/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		10: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"c72aeb44","1":"2df1e379","2":"bbcfc33d","3":"df811adb","4":"c3cd927a","5":"84fde7b2","6":"13c3c7f2","7":"b85edb06","8":"39ea1181","9":"b208500b"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 712);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(719);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(727)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){for(var o in a)e[o]=a[o]}(exports,function(e){var a={};function o(t){if(a[t])return a[t].exports;var s=a[t]={i:t,l:!1,exports:{}};return e[t].call(s.exports,s,s.exports,o),s.l=!0,s.exports}return o.m=e,o.c=a,o.d=function(e,a,t){o.o(e,a)||Object.defineProperty(e,a,{enumerable:!0,get:t})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,a){if(1&a&&(e=o(e)),8&a)return e;if(4&a&&"object"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:e}),2&a&&"string"!=typeof e)for(var s in e)o.d(t,s,function(a){return e[a]}.bind(null,s));return t},o.n=function(e){var a=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(a,"a",a),a},o.o=function(e,a){return Object.prototype.hasOwnProperty.call(e,a)},o.p="",o(o.s=12)}([function(e,a){e.exports=__webpack_require__(0)},function(e,a){e.exports=__webpack_require__(1)},function(e,a){e.exports=__webpack_require__(24)},function(e,a){e.exports=__webpack_require__(55)},function(e,a){e.exports=__webpack_require__(85)},function(e,a){e.exports=__webpack_require__(5)},function(e,a){e.exports=__webpack_require__(895)},function(e,a){e.exports=__webpack_require__(896)},function(e,a){e.exports=__webpack_require__(897)},function(e,a){e.exports=__webpack_require__(42)},function(e,a){e.exports=__webpack_require__(898)},function(e,a){e.exports=__webpack_require__(444)},function(e,a,o){"use strict";o.r(a);var t=o(0),s=o.n(t),r=o(1),n=o.n(r),i=o(5),c=function(e){return s.a.createElement("i",{className:"icon ".concat(e.iconName," ").concat(e.className),alt:e.iconName,title:e.title,value:e.value,action:e.action,onClick:e.onClick,"aria-hidden":"true"})};c.propTypes={iconName:n.a.string.isRequired,title:n.a.string,className:n.a.string,value:n.a.string,action:n.a.string,onClick:n.a.func};var l=c,d=function(e){return e.loading?s.a.createElement("button",{id:e.id,name:e.name,"aria-disabled":e.disabled,disabled:e.disabled,type:e.type,className:"".concat(e.disabled&&"btn-disabled"," ").concat(e.className?e.className.replace("btn-icon",""):""),value:"Carregando","aria-label":"Carregando"},s.a.createElement("div",{className:"btn-loading mr-auto ml-auto"},s.a.createElement("div",null),s.a.createElement("div",null),s.a.createElement("div",null),s.a.createElement("div",null))):e.iconName?e.text?s.a.createElement("button",{id:e.id,name:e.name,"aria-disabled":e.disabled,disabled:e.disabled,type:e.type,className:"".concat(e.disabled&&"btn-disabled"," btn-icon ").concat(e.className||""),onClick:!e.disabled&&e.onClick,value:e.value,"aria-label":e["aria-label"]},s.a.createElement(l,{iconName:e.iconName}),e.text):s.a.createElement("button",{id:e.id,name:e.name,"aria-disabled":e.disabled,disabled:e.disabled,type:e.type,className:"".concat(e.disabled&&"btn-disabled","  btn-icon btn-icon-only ").concat(e.className||""),onClick:!e.disabled&&e.onClick,value:e.value,"aria-label":e["aria-label"]},s.a.createElement(l,{iconName:e.iconName})):s.a.createElement("button",{id:e.id,name:e.name,"aria-disabled":e.disabled,disabled:e.disabled,type:e.type,className:"".concat(e.disabled&&"btn-disabled"," ").concat(e.className||""),onClick:!e.disabled&&e.onClick,value:e.value,"aria-label":e["aria-label"]},e.text)};d.propTypes={id:n.a.string.isRequired,name:n.a.string,disabled:n.a.string,loading:n.a.bool,type:n.a.oneOf(["button","reset","submit"]),className:n.a.string,text:n.a.string,iconName:n.a.string,onClick:n.a.func,ariaLabel:n.a.string,value:n.a.string};var m=d,p=o(2),u=o.n(p),b=function(e,a){return parseFloat(e).toFixed(a).replace(".",",").replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1.")},f=function(e){return e.toLocaleString("pt-br",{minimumFractionDigits:2,maximumFractionDigits:2})},v=function(e){var a=e.onlyCash,o=e.priceFor,t=e.sellingPrice,r=e.pointsName,n=e.decimalPlace,i=e.available,c=e.cashBack;return s.a.createElement(h,{available:i},a?g({sellingPrice:t}):y({priceFor:o,pointsName:r,decimalPlace:n,cashBack:c}))},y=function(e){var a=e.priceFor,o=e.pointsName,r=e.decimalPlace,n=e.cashBack;return s.a.createElement(t.Fragment,null,s.a.createElement("div",{className:"card-price-points col-12 txt-title txt-font-body txt-left color-ui-1 nowrap",title:a?b(a,r)+" "+o:""},a?b(a,r)+" "+o:""),n?a>0&&s.a.createElement("div",{className:"card-price-cashback col-auto mx-1 txt-body-sm txt-font-body txt-left txt-bold color-success border border-color-ui-4 radius"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-auto px-0 d-none d-lg-block"},s.a.createElement("i",{className:"icon_cashback icon-sm icon icon_gift color-success"})),s.a.createElement("div",{className:"col-auto txt-body-sm"},"Ganhe ".concat(Math.floor(.05*a)," ").concat(o)))):s.a.createElement("div",{className:"card-price-complete-with col-12 txt-body-sm txt-font-body txt-left txt-bold color-success"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-auto pt-half"},"Ou utilize pontos + dinheiro"))))},g=function(e){var a=e.sellingPrice;return s.a.createElement(t.Fragment,null,s.a.createElement("div",{className:"card-price-points col-12 txt-title txt-font-body-bold txt-left color-ui-1 nowrap",title:a?"R$ "+f(a):"Carregando Preço"},a?"R$ "+f(a):s.a.createElement(m,{loading:!0,text:"Carregando",className:"btn-flat"})),s.a.createElement("div",{className:"card-price-currency col-12 txt-body txt-font-body-bold txt-center color-ui-1"}))},h=function(e){var a=e.available,o=e.children;return null==a?s.a.createElement(m,{loading:!0,text:"Carregando",className:"btn-flat mx-auto py-half",role:"button",value:"Carregando","aria-label":"Carregando pontuação"}):!1===a?s.a.createElement("div",{className:"card-button col-12 m-0 mt-1 p-0"},s.a.createElement(m,{className:"btn-featured btn-sm btn-block col-12",text:"Produto indisponível",disabled:"disabled"})):o};v.propTypes={onlyCash:n.a.bool,priceFor:n.a.any,sellingPrice:n.a.any,pointsName:n.a.string,decimalPlace:n.a.number,available:n.a.bool,cashBack:n.a.bool},y.propTypes={priceFor:n.a.any,pointsName:n.a.string,decimalPlace:n.a.number,cashBack:n.a.bool},g.propTypes={sellingPrice:n.a.any};var E=v,x=(o(7),o(6));function N(e){return(N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function P(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function q(e,a){return!a||"object"!==N(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function O(e){return(O=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function w(e,a){return(w=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var S=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=q(this,O(a).call(this,e))).state={currentSku:"",visiblebutton:!0,added:!1,addedError:!1,visiblebuttonLoading:!1},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&w(e,a)}(a,t["Component"]),o=a,(r=[{key:"update",value:function(){var e=this;this.setState({currentSku:this.props.sku}),this.props.clearError(),setTimeout(function(){e.props.addCart(e.props.itemCart),e.setState({visiblebuttonLoading:!0,visiblebutton:!1}),e.props.cart.error?e.addedError():setTimeout(function(){e.props.cart.error?e.addedError():e.added(),e.setState({currentSku:""})},1e3)},500)}},{key:"added",value:function(){var e=this;this.setState({added:!0,visiblebutton:!1,addedError:!1,visiblebuttonLoading:!1}),setTimeout(function(){e.setState({added:!1,visiblebutton:!0,addedError:!1,visiblebuttonLoading:!1})},2e3)}},{key:"remdemptionNow",value:function(e){e.preventDefault(),this.props.addCart(this.props.itemCart,!0)}},{key:"addedError",value:function(){var e=this;this.setState({addedError:!0,visiblebutton:!1,added:!1,visiblebuttonLoading:!1}),setTimeout(function(){e.setState({addedError:!1,visiblebutton:!0,added:!1,visiblebuttonLoading:!1})},2e3)}},{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"item card ".concat(this.props.cardClass)},s.a.createElement("div",{className:"bordered radius border-color-ui-3 bg-white"},s.a.createElement("div",{className:"row mx-0 px-1"},s.a.createElement("div",{className:"col-12 discount-whishlist"},this.props.percentage?s.a.createElement("span",{className:"pos-absolute r-1 t-1 card-flag bg-success color-brand-5 radius txt-body-sm txt-font-body-bold mt-1"},this.props.percentage,"%"):"",s.a.createElement(l,{iconName:this.props.inWishlist?"icon_wishlist_color":"icon_wishlist",className:"card-wishlist txt-body-lg cursor pos-absolute r-0 t-1",onClick:this.props.inWishlist?function(){return e.props.removeWishlist(e.props.sku)}:function(){return e.props.addWishlist(e.props.sku)},alt:"Favoritar este item "})),s.a.createElement("div",{className:"card-img col-12 row txt-center py-3 t-1"},s.a.createElement("div",{className:"row col-12 ml-auto mr-auto t-0 pos-absolute"},s.a.createElement("div",{className:"col-12 m-0 p-0"},s.a.createElement(i.Link,{to:"/products/".concat(this.props.sku),"aria-label":this.props.description},s.a.createElement(x.LazyLoadImage,{alt:this.props.description,placeholderSrc:u.a,className:"card-image-fallback",src:this.props.image}))))),this.props.countDown?s.a.createElement("div",{className:"card-counter col-10 mt-2 mx-auto"},s.a.createElement("p",{className:" py-1 px-2  txt-body-sm color-ui-white txt-font-body-bold txt-center"},"Acaba em ",s.a.createElement("span",{className:"txt-body"},"00:00:00"))):"",s.a.createElement("div",{className:"card-internal col-12 pt-md-0 pt-5 mt-5 mt-md-0"},s.a.createElement("div",{className:"card-name col-12 mt-0 p-0"},s.a.createElement("h2",{className:"txt-body-sm color-ui-2 txt-font-body txt-left"},s.a.createElement(i.Link,{to:"/products/".concat(this.props.sku),"aria-label":this.props.description},this.props.description))),s.a.createElement("div",{className:"card-partner"},s.a.createElement("p",{className:"pt-half color-ui-1 txt-body-sm txt-font-body txt-left txt-bold"},s.a.createElement("strong",null,this.props.vendor?this.props.vendor.name:""))),s.a.createElement("div",{className:"card-price col-12 mt-1 mb-1 color-brand-1 p-0"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"card-price-item col-12"},s.a.createElement("div",{className:"row"},this.props.percentage?s.a.createElement("div",{className:"card-price-from col-12 txt-subtitle txt-font-body color-ui-2 txt-left"},"De ",s.a.createElement("s",null,this.props.priceFrom)," pts por"):"",s.a.createElement(E,{available:this.props.available,onlyCash:this.props.onlyCash,priceFor:this.props.priceFor,sellingPrice:this.props.sellingPrice,pointsName:this.props.pointsName,decimalPlace:this.props.decimalPlace,cashBack:this.props.cashBack})))))))))}}])&&P(o.prototype,r),n&&P(o,n),a}();S.propTypes={inWishlist:n.a.bool,image:n.a.string.isRequired,description:n.a.string.isRequired,priceFrom:n.a.string,priceFor:n.a.string.isRequired,cardClass:n.a.string,percentage:n.a.number,countDown:n.a.bool,sku:n.a.string,vendor:n.a.object,addCart:n.a.func,itemCart:n.a.object,cart:n.a.object,addWishlist:n.a.func,removeWishlist:n.a.func,onlyCash:n.a.bool,sellingPrice:n.a.string,available:n.a.bool,pointsName:n.a.string,decimalPlace:n.a.number,clearError:n.a.func,itemAdded:n.a.bool,cashBack:n.a.bool};var C=S,z=o(3),T=o.n(z);function k(e){return(k="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function A(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function j(e,a){return!a||"object"!==k(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function U(e){return(U=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _(e,a){return(_=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var I=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=j(this,U(a).call(this,e))).state={},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&_(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"item card active"},s.a.createElement("div",{className:"bordered radius border-color-ui-3 bg-white"},s.a.createElement("a",{className:"row mx-0 px-1",href:this.props.link,"aria-label":this.props.description,title:this.props.title,target:"_blank"},s.a.createElement("div",{className:"card-img col-12 row txt-center py-3 t-1"},s.a.createElement("div",{className:"row col-12 ml-auto mr-auto t-0 pos-absolute"},s.a.createElement("div",{className:"col-12 m-0 p-0"},s.a.createElement(T.a,{src:this.props.image,fallbackImage:u.a,initialImage:u.a,title:this.props.titleImg,alt:this.props.alt,className:"card-image-fallback w-100"})))),s.a.createElement("div",{className:"card-internal col-12 pt-md-0 pt-5 mt-5 mt-md-0"},s.a.createElement("div",{className:"col-12 mt-0 p-0"},s.a.createElement("p",{className:"txt-body w-100 color-ui-black txt-font-body mb-1 text-bfits-list"},this.props.name),s.a.createElement("p",{className:"text-style-benific"},this.props.children),s.a.createElement("strong",{className:"text-benific-pq"},this.props.profile))),s.a.createElement("span",{class:"hide-absolute"},"Site Externo"))))}}])&&A(o.prototype,r),n&&A(o,n),a}();I.propTypes={name:n.a.string,description:n.a.string,image:n.a.any,title:n.a.string,titleImg:n.a.string,alt:n.a.string,link:n.a.string,children:n.a.string,profile:n.a.string};var L=I;function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function M(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function G(e,a){return!a||"object"!==D(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function R(e){return(R=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function F(e,a){return(F=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var B=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=G(this,R(a).call(this,e))).state={},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&F(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"col-12 item card active mb-2"},s.a.createElement("div",{className:"bordered radius border-color-ui-3 bg-white benefits-internal-height d-flex align-items-center",onClick:this.props.onClick},s.a.createElement("div",{className:"row mx-0 px-1 pointer w-100 align-items-center",title:this.props.title,onClick:function(){window.open(e.props.link,"_self")}},s.a.createElement("div",{className:"card-img col-4 txt-center"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-12 ml-auto mr-auto pos-absolute"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-12 m-0 p-0"},s.a.createElement(T.a,{src:this.props.image,fallbackImage:u.a,initialImage:u.a,title:this.props.titleImg,alt:this.props.alt,className:"card-image-fallback"})))))),s.a.createElement("div",{className:"card-internal col mx-0 px-0 ml-2 py-2"},s.a.createElement("div",{className:"col-12"},s.a.createElement("p",{className:"mb-1 color-ui-black txt-font-body fontSize14"},this.props.name),s.a.createElement("p",{className:"txt-body-sm fontWeightBen txt-font-body"},this.props.children),s.a.createElement("strong",{className:"text-benific-pq colorMobBen"},this.props.profile))))))}}])&&M(o.prototype,r),n&&M(o,n),a}();B.propTypes={name:n.a.string,description:n.a.string,onClick:n.a.any,title:n.a.string,titleImg:n.a.string,alt:n.a.string,image:n.a.any,link:n.a.string,children:n.a.string,profile:n.a.string};var V=B;function K(e){return(K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function H(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function W(e,a){return!a||"object"!==K(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Z(e){return(Z=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Q(e,a){return(Q=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var X=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=W(this,Z(a).call(this,e))).state={currentSku:"",visiblebutton:!0,added:!1,addedError:!1,visiblebuttonLoading:!1},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Q(e,a)}(a,t["Component"]),o=a,(r=[{key:"update",value:function(){var e=this;this.setState({currentSku:this.props.sku}),this.props.clearError(),setTimeout(function(){e.props.addCart(e.props.itemCart),e.setState({visiblebuttonLoading:!0,visiblebutton:!1}),e.props.cart.error?e.addedError():setTimeout(function(){e.props.cart.error?e.addedError():e.added(),e.setState({currentSku:""})},1e3)},500)}},{key:"added",value:function(){var e=this;this.setState({added:!0,visiblebutton:!1,addedError:!1,visiblebuttonLoading:!1}),setTimeout(function(){e.setState({added:!1,visiblebutton:!0,addedError:!1,visiblebuttonLoading:!1})},2e3)}},{key:"remdemptionNow",value:function(e){e.preventDefault(),this.props.addCart(this.props.itemCart),this.props.redirect("/cart")}},{key:"addedError",value:function(){var e=this;this.setState({addedError:!0,visiblebutton:!1,added:!1,visiblebuttonLoading:!1}),setTimeout(function(){e.setState({addedError:!1,visiblebutton:!0,added:!1,visiblebuttonLoading:!1})},2e3)}},{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"item card ".concat(this.props.cardClass)},s.a.createElement("div",{className:"bordered radius border-color-ui-3 bg-white"},s.a.createElement("div",{className:"row mx-0 px-1"},s.a.createElement("div",{className:"col-12 discount-whishlist"},this.props.percentage?s.a.createElement("span",{className:"pos-absolute r-1 t-1 card-flag bg-success color-brand-5 radius txt-body-sm txt-font-body-bold mt-1"},this.props.percentage,"%"):"",s.a.createElement(l,{iconName:this.props.inWishlist?"icon_wishlist_color":"icon_wishlist",className:"card-wishlist txt-body-lg cursor pos-absolute r-0 t-1",onClick:this.props.inWishlist?function(){return e.props.removeWishlist(e.props.sku)}:function(){return e.props.addWishlist(e.props.sku)},alt:"Favoritar este item "})),s.a.createElement("div",{className:"card-img col-5 row txt-center py-3 my-2"},s.a.createElement("div",{className:"row col-12 ml-auto mr-auto t-0 pos-absolute p-0"},s.a.createElement("div",{className:"col-12 pl-0 pr-2"},s.a.createElement(i.Link,{to:"/products/".concat(this.props.sku),"aria-label":this.props.description},s.a.createElement(T.a,{src:this.props.image,fallbackImage:u.a,initialImage:u.a,alt:this.props.description,className:"card-image-fallback pos-absolute l-0"}))))),this.props.countDown?s.a.createElement("div",{className:"card-counter col-10 mt-2 mx-auto"},s.a.createElement("p",{className:" py-1 px-2  txt-body-sm color-ui-white txt-font-body-bold txt-center"},"Acaba em ",s.a.createElement("span",{className:"txt-body"},"00:00:00"))):"",s.a.createElement("div",{className:"card-internal col-7 my-1"},s.a.createElement("div",{className:"card-name col-12 mt-0 p-0"},s.a.createElement("h2",{className:"txt-body-sm color-ui-2 txt-font-body txt-left"},this.props.description)),s.a.createElement("div",{className:"card-price col-12 color-brand-1 p-0"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"card-price-item ".concat(this.props.available?"":"col-12"," ")},this.props.percentage?s.a.createElement("div",{className:"card-price-from col-12 txt-subtitle txt-font-body color-ui-2 txt-left px-0"},"De ",s.a.createElement("s",null,this.props.priceFrom)," ",this.props.pointsName," por"):"",s.a.createElement(E,{available:this.props.available,onlyCash:this.props.onlyCash,priceFor:this.props.priceFor,sellingPrice:this.props.sellingPrice,pointsName:this.props.pointsName,decimalPlace:this.props.decimalPlace,cashBack:this.props.cashBack})))))),s.a.createElement("div",{className:"row mx-0 pos-relative ".concat(this.props.available?"":"d-none")},s.a.createElement("div",{className:"card-hover col-12 border-color-ui-3 radius pos-absolute bg-white"},s.a.createElement("div",{className:"card-hover-item row m-0"},s.a.createElement("div",{className:"card-button col-12 m-0 mt-1"},s.a.createElement(i.Link,{id:"rescueNow",className:"btn btn-featured btn-sm txt-uppercase txt-center",disabled:this.props.cart&&this.props.cart.isLoading&&this.state.currentSku===this.props.sku?"disabled":"",loading:this.props.cart&&this.props.cart.isLoading&&this.state.currentSku===this.props.sku,to:"/cart",onClick:function(a){return e.remdemptionNow(a)}},"Resgatar Agora")),s.a.createElement("div",{className:"card-button col-12 m-0 mt-1"},s.a.createElement(m,{id:"addItemToCart",className:"btn-featured btn-sm btn-cart ".concat(this.state.visiblebutton?"d-block":"d-none"),text:"Por no Carrinho",onClick:function(){return e.update()},disabled:this.props.cart&&this.props.cart.isLoading&&this.state.currentSku===this.props.sku?"disabled":"",loading:this.props.cart&&this.props.cart.isLoading&&this.state.currentSku===this.props.sku}),s.a.createElement(m,{className:"btn-featured btn-sm btn-cart ".concat(this.state.visiblebuttonLoading?"d-block":"d-none"),loading:!0}),s.a.createElement(m,{id:"addedToCart",className:"btn-featured btn-sm btn-cart-success btn-icon ".concat(this.state.added?"d-block":"d-none"),iconName:"icon_check_circle color-success",text:"Adicionado"}),s.a.createElement(m,{id:"addedToCartError",className:"cart-done btn-featured btn-sm btn-cart-error btn-icon ".concat(this.state.addedError?"d-block":"d-none"),iconName:"icon_close_circle color-error",text:"Erro ao adicionar"})),s.a.createElement("div",{className:"card-brand col-12 txt-center py-1 d-none"},s.a.createElement(T.a,{src:this.props.vendor.imageUrl,fallbackImage:u.a,initialImage:u.a,alt:this.props.description,className:"card-image-fallback card-brand mx-auto"})))))))}}])&&H(o.prototype,r),n&&H(o,n),a}();X.propTypes={inWishlist:n.a.bool,image:n.a.string.isRequired,description:n.a.string.isRequired,priceFrom:n.a.string,priceFor:n.a.string.isRequired,cardClass:n.a.string,percentage:n.a.number,countDown:n.a.bool,cashBack:n.a.bool,sku:n.a.string,vendor:n.a.object,addCart:n.a.func,itemCart:n.a.object,cart:n.a.object,addWishlist:n.a.func,removeWishlist:n.a.func,onlyCash:n.a.bool,sellingPrice:n.a.string,available:n.a.bool,pointsName:n.a.string,decimalPlace:n.a.number,clearError:n.a.func,redirect:n.a.func};var Y=X;function $(e){return($="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function J(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function ee(e,a){return!a||"object"!==$(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function ae(e){return(ae=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function oe(e,a){return(oe=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var te=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=ee(this,ae(a).call(this,e))).state={},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&oe(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"col-6"},s.a.createElement("div",{className:"bg-white radius border border-color-ui-3 d-flex align-items-center justify-content-center mt-0 mt-md-2 py-2 pointer-beneficos",onClick:function(){return window.open(e.props.link,"_blank")},title:this.props.title,tabIndex:"0"},s.a.createElement("div",null,s.a.createElement("img",{className:"img-h-100 img-w-auto app-store",src:this.props.image,title:this.props.titleImg,alt:this.props.alt}),s.a.createElement("p",{className:"txt-body-lg color-ui-black mt-2"},this.props.name),s.a.createElement("p",{className:"color-brand-1 fontStrong"},this.props.description))))}}])&&J(o.prototype,r),n&&J(o,n),a}();te.propTypes={name:n.a.string,description:n.a.string,title:n.a.string,titleImg:n.a.string,alt:n.a.string,image:n.a.any,link:n.a.string};var se=te;function re(e){return(re="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ne(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function ie(e,a){return!a||"object"!==re(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function ce(e){return(ce=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function le(e,a){return(le=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var de=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=ie(this,ce(a).call(this,e))).state={},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&le(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"col-6"},s.a.createElement("div",{className:"bg-white radius border border-color-ui-3 d-flex align-items-center justify-content-center mt-0 mt-md-2 py-2 pointer-beneficos",onClick:function(){return window.open(e.props.link,"_self")},title:this.props.title,tabIndex:"0"},s.a.createElement("div",null,s.a.createElement("img",{className:"img-h-100 img-w-auto app-store",src:this.props.image,title:this.props.titleImg,alt:this.props.alt}),s.a.createElement("p",{className:"txt-body-lg color-ui-black mt-2"},this.props.name),s.a.createElement("p",{className:"color-brand-1 fontStrong"},this.props.description))))}}])&&ne(o.prototype,r),n&&ne(o,n),a}();de.propTypes={name:n.a.string,description:n.a.string,title:n.a.string,titleImg:n.a.string,alt:n.a.string,image:n.a.any,link:n.a.string};var me=de;function pe(e){return(pe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ue(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function be(e,a){return!a||"object"!==pe(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function fe(e){return(fe=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ve(e,a){return(ve=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var ye=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=be(this,fe(a).call(this,e))).state={},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&ve(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"col-6 mb-0 mb-md-2 pl-1 pl-md-0",role:"presentation"},s.a.createElement("div",{className:"row mx-0 bg-white radius border border-color-ui-3 brands-benefits-new d-flex align-items-center justify-content-center pt-1 pb-2 mt-2 mt-md-0 pointer",onClick:function(){return window.open(e.props.link,"_blank")},title:this.props.title},s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"row",tabIndex:"0"},s.a.createElement("div",{className:"col-12"},s.a.createElement(T.a,{src:this.props.image,fallbackImage:u.a,initialImage:u.a,title:this.props.titleImg,alt:this.props.alt})),s.a.createElement("div",{className:"col-12"},s.a.createElement("p",{className:"text-style-benific-box"},this.props.description))))))}}])&&ue(o.prototype,r),n&&ue(o,n),a}();ye.propTypes={title:n.a.string,alt:n.a.string,titleImg:n.a.string,image:n.a.any,description:n.a.string,link:n.a.string};var ge=ye;function he(e){return(he="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Ee(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function xe(e,a){return!a||"object"!==he(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Ne(e){return(Ne=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Pe(e,a){return(Pe=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var qe=function(e){function a(e){var o;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),(o=xe(this,Ne(a).call(this,e))).state={},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Pe(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"col-6 mb-0 mb-md-2 pl-1 pl-md-0",role:"presentation"},s.a.createElement("div",{className:"row mx-0 bg-white radius border border-color-ui-3 brands-benefits-new d-flex align-items-center justify-content-center pt-1 pb-2 mt-2 mt-md-0 pointer",onClick:function(){return window.open(e.props.link,"_self")},title:this.props.title,tabIndex:"0"},s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-12"},s.a.createElement(T.a,{src:this.props.image,fallbackImage:u.a,initialImage:u.a,title:this.props.titleImg,alt:this.props.alt})),s.a.createElement("div",{className:"col-12"},s.a.createElement("p",{className:"text-style-benific-box"},this.props.description))))))}}])&&Ee(o.prototype,r),n&&Ee(o,n),a}();qe.propTypes={title:n.a.string,alt:n.a.string,titleImg:n.a.string,description:n.a.string,image:n.a.any,link:n.a.string};var Oe=qe,we=function(e){var a=e.sku,o=e.image,t=e.description,r=e.priceFrom,n=e.priceFor,c=e.percentage,d=e.poinstPlusCash,m=e.cardClass;return s.a.createElement("div",{className:"item card cardTimer ".concat(m)},s.a.createElement("div",{className:"bordered radius border-color-ui-3 bg-white"},s.a.createElement("div",{className:"row mx-0 px-1"},s.a.createElement("div",{className:"card-img col-12 txt-center pt-2"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"col-12"},c?s.a.createElement("span",{className:"card-flag bg-success color-brand-5 radius txt-subtitle txt-font-body-bold"},c,"%"):"",s.a.createElement(l,{icoName:"icon_wishlist",className:"card-wishlist txt-body-lg color-error cursor pos-absolute r-1 t-0"}),s.a.createElement(i.Link,{to:"/products/".concat(a)},s.a.createElement(T.a,{src:o,fallbackImage:u.a,initialImage:u.a,alt:t,className:"card-image-fallback"}))))),s.a.createElement("div",{className:"row bg-ui-1"},s.a.createElement("div",{className:"card-counter col-10 mt-2 mx-auto"},s.a.createElement("p",{className:" py-1 px-2  txt-body-sm color-ui-white txt-font-body-bold txt-center"},"Acaba em ",s.a.createElement("span",{className:"txt-body"},"00:00:00"))),s.a.createElement("div",{className:"card-name col-12 mt-2 px-2"},s.a.createElement("h2",{className:"txt-body-sm txt-font-body txt-center color-ui-white"},t)),s.a.createElement("div",{className:"card-price col-12  mt-2 mb-1 color-brand-1 px-2"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"card-price-item mx-auto"},c?s.a.createElement("div",{className:"card-price-from col-12 txt-subtitle txt-font-body color-ui-2 txt-center color-ui-white"},"De ",s.a.createElement("s",null,r)," pontos por"):"",s.a.createElement("div",{className:"card-price-points col-12 txt-headline txt-circular-black txt-center color-ui-white"},n),s.a.createElement("div",{className:"card-price-currency col-12 txt-body txt-circular-black txt-center color-ui-white"},"pontos"))))))),s.a.createElement("div",{className:"row mx-0 pos-relative"},d?Se(d):""))},Se=function(e){return e&&e.installments&&e.installments.length>0?s.a.createElement("div",{className:"card-points-cash bg-ui-1 radius-bottom  border-color-ui-3 col-12 txt-center txt-font-body-bold txt-body-sm  color-ui-white py-1 px-1"},"Ou ",e.partialPoints," pontos +"," "+e.installments[e.installments.length-1].installment,"x de R$"," "+e.installments[e.installments.length-1].value):""};we.propTypes={image:n.a.string.isRequired,description:n.a.string.isRequired,priceFrom:n.a.string,priceFor:n.a.string.isRequired,cardClass:n.a.string,percentage:n.a.number,poinstPlusCash:n.a.object,sku:n.a.string};var Ce=we,ze=function(e){return s.a.createElement("div",{className:"item card"},s.a.createElement("div",{className:"bordered radius border-color-ui-4 bg-white"},s.a.createElement("div",{className:"row mx-0 px-1"},s.a.createElement("div",{className:"card-img col-12 txt-center pt-2"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"col-12"},s.a.createElement("img",{src:e.image,alt:e.image})))),s.a.createElement("div",{className:"card-name col-12 mt-2"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-10 ml-auto mr-auto mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}),s.a.createElement("div",{className:"col-8 ml-auto mr-auto  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}))),s.a.createElement("div",{className:"card-price col-12  mt-2 mb-1 color-brand-1"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"card-price-points col-12 txt-headline txt-circular-black txt-center"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-5 ml-auto mr-auto mb-1 py-2 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}))),s.a.createElement("div",{className:"card-price-currency col-12 txt-body txt-circular-black txt-center"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-3 ml-auto mr-auto mb-1 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}))))))))};ze.propTypes={image:n.a.string.isRequired};var Te=ze,ke=function(e){return s.a.createElement("div",{className:"item card"},s.a.createElement("div",{className:"bordered radius border-color-ui-4 bg-white"},s.a.createElement("div",{className:"row mx-0 px-1"},s.a.createElement("div",{className:"card-img col-12 txt-center pt-2"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"col-12"},s.a.createElement("img",{src:e.image,alt:e.image})))),s.a.createElement("div",{className:"card-name col-12 mt-2"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-10 ml-auto mr-auto mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}),s.a.createElement("div",{className:"col-8 ml-auto mr-auto  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}))),s.a.createElement("div",{className:"card-price col-12  mt-2 mb-1 color-brand-1"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"card-price-points col-12 txt-headline txt-circular-black txt-center"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-5 ml-auto mr-auto mb-1 py-2 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}))),s.a.createElement("div",{className:"card-price-currency col-12 txt-body txt-circular-black txt-center"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-3 ml-auto mr-auto mb-1 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius"}))))))))};ke.propTypes={image:n.a.string.isRequired};var Ae=ke;function je(e){return(je="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Ue(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function _e(e,a){return!a||"object"!==je(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Ie(e){return(Ie=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Le(e,a){return(Le=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var De=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),_e(this,Ie(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Le(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e={backgroundImage:"url("+this.props.informations.bannerImage+")"},a=this.props.informations.vendorImage;return s.a.createElement("div",{className:"card-store row bg-white radius px-1 border-color-ui-4 border",style:e,"data-vendor":this.props.informations.vendorId},s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"store-logo txt-center mt-5 mb-2"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"col-auto mr-auto ml-auto border-color-ui-4 border px-half py-2 radius bg-white"},s.a.createElement(x.LazyLoadImage,{alt:this.props.informations.description,placeholderSrc:u.a,className:"card-image-fallback img-fluid",src:a})))),s.a.createElement("h3",{className:"txt-font-body txt-center color-ui-2 h4"},this.props.informations.description),s.a.createElement("div",{className:"txt-center pt-1 pb-2"},s.a.createElement("a",{herf:"/vendor?vendor=".concat(this.props.informations.vendorId),className:"color-brand-1 txt-body-sm"},"Ver loja"))))}}])&&Ue(o.prototype,r),n&&Ue(o,n),a}();De.propTypes={informations:n.a.object};var Me=De;function Ge(e){return(Ge="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Re(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Fe(e,a){return!a||"object"!==Ge(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Be(e){return(Be=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Ve(e,a){return(Ve=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Ke=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Fe(this,Be(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Ve(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){var e=this.props.informations.vendorImage;return s.a.createElement("div",{className:"card-store row px-half py-half"},s.a.createElement("div",{className:"col-12 px-2 py-2 border-color-ui-4 border bg-white radius"},s.a.createElement(T.a,{src:e,fallbackImage:u.a,initialImage:u.a,alt:this.props.informations.description,className:"card-image-fallback w-100"})))}}])&&Re(o.prototype,r),n&&Re(o,n),a}();Ke.propTypes={informations:n.a.object};var He=Ke,We=o(4),Ze=o.n(We);function Qe(e){return(Qe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Xe(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Ye(e){return(Ye=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function $e(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Je(e,a){return(Je=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var ea=function(e){function a(e){var o,t,s;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),t=this,(o=!(s=Ye(a).call(this,e))||"object"!==Qe(s)&&"function"!=typeof s?$e(t):s).state={value:e.value||"",currentIndex:-1,open:!1,focus:!1},o.handleKeyDown=o.handleKeyDown.bind($e(o)),o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Je(e,a)}(a,t["Component"]),o=a,(r=[{key:"handleChange",value:function(e,a){this.setState({value:e,currentIndex:a}),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"handleKeyDown",value:function(e){if(39===e.keyCode||40===e.keyCode||34===e.keyCode)(o=this.state.currentIndex+1)<this.props.options.length&&this.handleChange(this.props.options[o],o),e.preventDefault();else if(37===e.keyCode||38===e.keyCode||33===e.keyCode){(a=this.state.currentIndex-1)>=0&&this.handleChange(this.props.options[a],a),e.preventDefault()}else if(36===e.keyCode){var a=0;this.handleChange(this.props.options[a],a),e.preventDefault()}else if(35===e.keyCode){var o=this.props.options.length-1;this.handleChange(this.props.options[o],o),e.preventDefault()}else 27===e.keyCode&&(this.setState({open:!1,focus:!1}),e.preventDefault())}},{key:"IsRequired",value:function(){if(this.props.required)return s.a.createElement("span",{className:"required"},"*")}},{key:"HasIcon",value:function(){if(this.props.iconName&&void 0===this.props.valid)return s.a.createElement("span",{className:"icon ".concat(this.props.iconName)})}},{key:"HasEmptyValue",value:function(){var e=this;if(this.props.hasEmpty&&!0===this.props.hasEmpty)return s.a.createElement("li",{value:"",onClick:function(){return e.handleChange("",-1)}},"Selecione")}},{key:"IsValid",value:function(){return!0===this.props.valid?s.a.createElement("span",{className:"message message-success"},this.props["data-success"]):!1===this.props.valid?s.a.createElement("span",{className:"message message-error"},this.props["data-error"]):void 0}},{key:"GetContainerClasses",value:function(){return Ze()({select:!0,"has-content":this.state.value||this.props.placeholder,open:this.state.open,success:!0===this.props.valid,error:!1===this.props.valid})}},{key:"GetOptionsStyle",value:function(){if(!0===this.state.open)return{display:"block"}}},{key:"render",value:function(){var e=this;return s.a.createElement(t.Fragment,null,s.a.createElement("div",{className:"form-field ".concat(this.props.className||"")},s.a.createElement("div",{className:" ".concat(this.GetContainerClasses()," ").concat(this.props.image?"select-with-image":"")},s.a.createElement("button",{className:"button-select select-styled",id:this.props.id,name:this.props.name,disabled:this.props.disabled,"aria-haspopup":"listbox","aria-expanded":this.state.open,onClick:function(){return e.props.disabled?null:e.setState({open:!e.state.open,focus:!0})},onKeyDown:this.handleKeyDown},this.state.value?"image"===this.props.showSelected?s.a.createElement("img",{src:this.state.value[this.props.image],alt:this.state.value[this.props.image]}):this.state.value[this.props.displayValue]:this.props.placeholder||""),s.a.createElement("ul",{className:"select-options",role:"listbox",tabIndex:"-1",style:this.GetOptionsStyle()},!this.props.required&&this.HasEmptyValue(),this.props.options.map(function(a,o){return s.a.createElement("li",{role:"option",key:o,value:a[e.props.selectedValue],onClick:function(){e.handleChange(a,o),!e.props.disabled&&e.setState({open:!1,focus:!1})},className:"txt-body-sm row pointer ".concat(e.props.image?"select-img":""," ").concat("image"===e.props.showSelected?"txt-right":"","\n                  ").concat(e.props.optionClass||"","\n                ")},a[e.props.displayValue],e.props.image?s.a.createElement("div",{className:"select-image col-4 bg-white txt-center"},s.a.createElement("img",{src:a[e.props.image],alt:a[e.props.image],className:"mw-100 d-flex mx-auto"})):"")}))),s.a.createElement("label",{htmlFor:this.props.id},this.props.label,this.IsRequired()),this.HasIcon(),this.IsValid()))}}])&&Xe(o.prototype,r),n&&Xe(o,n),a}();ea.propTypes={id:n.a.string.isRequired,name:n.a.string,disabled:n.a.string,className:n.a.string,value:n.a.any,label:n.a.string,required:n.a.bool,placeholder:n.a.string,"data-error":n.a.string,"data-success":n.a.string,valid:n.a.bool,onChange:n.a.func,selectedValue:n.a.string.isRequired,displayValue:n.a.string.isRequired,options:n.a.array.isRequired,iconName:n.a.string,hasEmpty:n.a.bool,image:n.a.string,imageAlign:n.a.string,optionClass:n.a.string,showSelected:n.a.string};var aa=ea,oa=o(8),ta=o.n(oa);function sa(e){return(sa="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ra(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function na(e){return(na=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ia(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ca(e,a){return(ca=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var la=function(e){function a(e){var o,t,s;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),t=this,(o=!(s=na(a).call(this,e))||"object"!==sa(s)&&"function"!=typeof s?ia(t):s).handleChange=o.handleChange.bind(ia(o)),o.state={showPassword:!1,labelShowPassword:"Mostrar",typeShowPassword:"password"},o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&ca(e,a)}(a,t["Component"]),o=a,(r=[{key:"toogleShowPassword",value:function(){var e=this.state.showPassword?"Mostrar":"Ocultar",a=this.state.showPassword?"password":"text";this.setState({showPassword:!this.state.showPassword,labelShowPassword:e,typeShowPassword:a}),this.setState({showPassword:!this.state.showPassword,typeShowPassword:a})}},{key:"handleChange",value:function(e){"function"==typeof this.props.onChange&&this.props.onChange(e);var a=e.target;""!==a.value||0===a.value?a.classList.add("has-content"):a.classList.remove("has-content")}},{key:"IsRequired",value:function(){if(this.props.required)return s.a.createElement("span",{className:"required"},"*")}},{key:"HasIcon",value:function(){if(this.props.iconName&&void 0===this.props.valid)return this.props.iconOnClick?s.a.createElement("span",{onClick:this.props.iconOnClick(),className:"icon ".concat(this.props.iconName)}):s.a.createElement("span",{className:"icon ".concat(this.props.iconName)})}},{key:"IsValid",value:function(){return!0===this.props.valid?s.a.createElement("p",{id:this.props["aria-describedby"]||"success-".concat(this.props.id),className:"message message-success",role:"alert","aria-live":"polite","aria-atomic":"true"},s.a.createElement("small",{className:"txt-subtitle txt-font-body color-success"},this.props["data-success"])):!1===this.props.valid?s.a.createElement("p",{id:this.props["aria-describedby"]||"error-".concat(this.props.id),className:"message message-error",role:"alert","aria-live":"polite","aria-atomic":"true"},s.a.createElement("small",{className:"txt-subtitle txt-font-body color-error"},this.props["data-error"])):void 0}},{key:"GetClasses",value:function(){return Ze()({"has-content":!!this.props.value||!0===this.props.valid||!1===this.props.valid,success:!0===this.props.valid,error:!1===this.props.valid})}},{key:"render",value:function(){var e=this;return s.a.createElement("div",{className:"form-field ".concat(this.props.className||"")},this.props.mask?s.a.createElement(ta.a,{id:this.props.id,name:this.props.name,type:"text",inputMode:this.props.inputMode||"text ",pattern:this.props.pattern||".*",disabled:this.props.disabled,"aria-disabled":this.props.disabled,className:" ".concat(this.props.disabled?"disabled":""," ").concat(this.props.childrenClassName?this.props.childrenClassName:""," ").concat(this.GetClasses(),"\n            ").concat(this.props.value?"has-content":""),value:this.props.value,placeholder:this.props.placeholder,minLength:this.props.minLength,maxLength:this.props.maxLength,required:this.props.required,onChange:this.handleChange,onBlur:this.props.onBlur,onFocus:this.props.onFocus,onKeyDown:this.props.onKeyDown,onKeyUp:this.props.onKeyUp,onKeyPress:this.props.onKeyPress,mask:this.props.mask,guide:this.props.guide,placeholderChar:this.props.placeholderChar,"aria-label":this.props["aria-label"]||this.props.placeholder||this.props.label,"aria-describedby":this.props["aria-describedby"]}):s.a.createElement("input",{id:this.props.id,name:this.props.name,type:this.props.type?"number"===this.props.type?"number":"password"===this.props.type?this.state.typeShowPassword:this.props.type:"text",inputMode:this.props.inputMode||"text",pattern:this.props.pattern||".*",disabled:this.props.disabled,"aria-disabled":this.props.disabled,className:" ".concat(this.props.disabled?"disabled":""," ").concat(this.props.childrenClassName?this.props.childrenClassName:""," ").concat(this.GetClasses()," ").concat(this.props.value||0===this.props.value?"has-content":""),placeholder:this.props.placeholder,minLength:this.props.minLength,maxLength:this.props.maxLength,required:this.props.required,value:this.props.value,onChange:this.handleChange,onBlur:this.props.onBlur,onFocus:this.props.onFocus,onKeyDown:this.props.onKeyDown,onKeyUp:this.props.onKeyUp,onKeyPress:this.props.onKeyPress,"aria-label":this.props["aria-label"]||this.props.placeholder||this.props.label,"aria-describedby":this.props["aria-describedby"]}),s.a.createElement("label",{htmlFor:this.props.id,"aria-hidden":"true"},this.props.label,this.IsRequired()),this.HasIcon(),this.IsValid(),"password"===this.props.type?s.a.createElement("button",{tabIndex:"0",role:"button",type:"button","aria-label":"Mostrar"===this.state.labelShowPassword?"Mostrar senha":"Ocultar senha",onClick:function(){return e.toogleShowPassword()},className:"cursor txt-subtitle txt-body-sm btn-show-password"},s.a.createElement("i",{className:"icon icon_".concat("Mostrar"===this.state.labelShowPassword?"view":"view_slash"," pointer")})):"")}}])&&ra(o.prototype,r),n&&ra(o,n),a}();la.propTypes={id:n.a.string.isRequired,guide:n.a.string,placeholderChar:n.a.string,name:n.a.string,type:n.a.string,inputMode:n.a.string,pattern:n.a.string,disabled:n.a.string,className:n.a.string,childrenClassName:n.a.string,value:n.a.string,label:n.a.string,minLength:n.a.string,maxLength:n.a.string,required:n.a.bool,placeholder:n.a.string,"data-error":n.a.string,"data-success":n.a.string,"aria-label":n.a.string,"aria-describedby":n.a.string,iconName:n.a.string,valid:n.a.bool,onChange:n.a.func,onBlur:n.a.func,onFocus:n.a.func,onKeyDown:n.a.func,onKeyUp:n.a.func,onKeyPress:n.a.func,iconOnClick:n.a.func,mask:n.a.oneOfType([n.a.array,n.a.func,n.a.bool,n.a.shape({mask:n.a.oneOfType([n.a.array,n.a.func]),pipe:n.a.func})])};var da=la;function ma(e){return(ma="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function pa(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function ua(e,a){return!a||"object"!==ma(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function ba(e){return(ba=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function fa(e,a){return(fa=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var va=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),ua(this,ba(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&fa(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return this.props.outerLabel?s.a.createElement("div",{className:"form-field ".concat(this.props.className||"")},s.a.createElement("label",{className:"effect radio inner ".concat(this.props.labelClass||""," ").concat(this.props.defaultChecked?"checked":"")},s.a.createElement("input",{id:this.props.id,name:this.props.name,type:"radio",disabled:this.props.disabled,value:this.props.value,defaultChecked:this.props.defaultChecked,onClick:this.props.onClick,role:this.props.role?this.props.role:"checkbox","aria-checked":this.props.defaultChecked,"aria-labelledby":this.props.ariaLabelledby}),s.a.createElement("span",null),s.a.createElement("span",null,this.props.label))):s.a.createElement("div",{className:"form-field ".concat(this.props.className||"")},s.a.createElement("input",{id:this.props.id,name:this.props.name,type:"radio",disabled:this.props.disabled,value:this.props.value,defaultChecked:this.props.defaultChecked,onClick:this.props.onClick,role:this.props.role?this.props.role:"checkbox","aria-checked":this.props.defaultChecked,"aria-labelledby":this.props.ariaLabelledby}),s.a.createElement("label",{className:"effect radio out  ".concat(this.props.labelClass||""," ").concat(this.props.defaultChecked?"checked":""),htmlFor:this.props.id},s.a.createElement("span",null),s.a.createElement("span",null,this.props.label)))}}])&&pa(o.prototype,r),n&&pa(o,n),a}();va.propTypes={id:n.a.string.isRequired,name:n.a.string,disabled:n.a.string,className:n.a.string,labelClass:n.a.string,defaultChecked:n.a.bool,outerLabel:n.a.bool,label:n.a.string,value:n.a.any,onClick:n.a.func,ariaLabelledby:n.a.string,role:n.a.string};var ya=va;function ga(e){return(ga="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ha(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Ea(e,a){return!a||"object"!==ga(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function xa(e){return(xa=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Na(e,a){return(Na=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Pa=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Ea(this,xa(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Na(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-auto filter-color ".concat(this.props.className||"")},s.a.createElement("input",{id:this.props.id,name:this.props.name,type:this.props.multiple?"checkbox":"radio",disabled:this.props.disabled,value:this.props.value,checked:this.props.checked,onClick:this.props.onClick,onChange:this.props.onChange}),s.a.createElement("label",{htmlFor:this.props.id,style:{backgroundColor:this.props.color},label:this.props.label}))}}])&&ha(o.prototype,r),n&&ha(o,n),a}();Pa.propTypes={id:n.a.string.isRequired,color:n.a.string.isRequired,name:n.a.string,label:n.a.string,disabled:n.a.string,className:n.a.string,checked:n.a.bool,multiple:n.a.bool,onChange:n.a.func,onClick:n.a.func,value:n.a.string};var qa=Pa;function Oa(e){return(Oa="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function wa(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Sa(e,a){return!a||"object"!==Oa(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Ca(e){return(Ca=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function za(e,a){return(za=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Ta=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Sa(this,Ca(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&za(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-auto filter-size ".concat(this.props.className||"")},s.a.createElement("input",{id:this.props.id,name:this.props.name,type:this.props.multiple?"checkbox":"radio",disabled:this.props.disabled,value:this.props.value,checked:this.props.checked,className:this.props.className,onClick:this.props.onClick,onChange:this.props.onChange,"aria-hidden":this.props["aria-label"]||!1}),s.a.createElement("label",{"aria-hidden":this.props["aria-label"]||!1,className:this.props.labelClass,htmlFor:this.props.id,"aria-label":this.props["aria-label"]||this.props.label},this.props.label))}}])&&wa(o.prototype,r),n&&wa(o,n),a}();Ta.propTypes={id:n.a.string.isRequired,value:n.a.string,name:n.a.string,label:n.a.string,disabled:n.a.string,className:n.a.string,labelClass:n.a.string,checked:n.a.bool,multiple:n.a.bool,onChange:n.a.func,onClick:n.a.func,"aria-label":n.a.string,"aria-hidden":n.a.bool};var ka=Ta;function Aa(e){return(Aa="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ja(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Ua(e){return(Ua=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _a(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ia(e,a){return(Ia=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var La=function(e){function a(e){var o,t,s;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),t=this,(o=!(s=Ua(a).call(this,e))||"object"!==Aa(s)&&"function"!=typeof s?_a(t):s).state={value:e.value||""},o.handleChange=o.handleChange.bind(_a(o)),o.clickUp=o.clickUp.bind(_a(o)),o.clickDown=o.clickDown.bind(_a(o)),o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Ia(e,a)}(a,t["Component"]),o=a,(r=[{key:"handleChange",value:function(e){""!==e.target.value&&(this.props.max&&e.target.value>+this.props.max&&(e.target.value=this.props.max),this.props.min&&+e.target.value<+this.props.min&&(e.target.value=this.props.min)),this.setState({value:e.target.value}),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"IsValid",value:function(){return!0===this.props.valid?s.a.createElement("span",{className:"message message-success"},this.props["data-success"]):!1===this.props.valid?s.a.createElement("span",{className:"message message-error"},this.props["data-error"]):void 0}},{key:"GetClasses",value:function(){return Ze()({"input-spinner-vertical":!0,"no-label":!0,error:!1===this.props.valid})}},{key:"clickUp",value:function(e){e.target.value=+this.state.value+(+this.props.step||1),this.handleChange(e)}},{key:"clickDown",value:function(e){e.target.value=+this.state.value-(+this.props.step||1),this.handleChange(e)}},{key:"isDownDisabled",value:function(){return this.state.value>"1"&&!this.props.isDownDisabled?s.a.createElement("div",{className:"quantity-button icon icon_remove quantity-down",onClick:this.clickDown}):s.a.createElement("div",{className:"quantity-button icon icon_remove quantity-down",disabled:!0})}},{key:"isUpDisabled",value:function(){return this.props.isUpDisabled?s.a.createElement("div",{className:"quantity-button icon icon_more quantity-up",disabled:!0}):s.a.createElement("div",{className:"quantity-button icon icon_more quantity-up",onClick:this.clickUp})}},{key:"render",value:function(){return s.a.createElement("div",{className:"form-field px-0 ".concat(this.props.className||"")},s.a.createElement("input",{id:this.props.id,name:this.props.name,type:"number",disabled:this.props.disabled,className:this.GetClasses(),value:this.state.value,placeholder:this.props.placeholder,"aria-label":this.props["aria-label"]||this.props.placeholder,min:this.props.min,max:this.props.max,readOnly:this.props.readonly,step:this.props.step,required:this.props.required,onChange:this.props.onChange,onBlur:this.props.onBlur,onFocus:this.props.onFocus,onKeyDown:this.props.onKeyDown,onKeyUp:this.props.onKeyUp,onKeyPress:this.props.onKeyPress}),this.isUpDisabled(),this.isDownDisabled(),this.IsValid())}}])&&ja(o.prototype,r),n&&ja(o,n),a}();La.propTypes={id:n.a.string.isRequired,name:n.a.string,disabled:n.a.string,className:n.a.string,value:n.a.string,step:n.a.string,min:n.a.string,max:n.a.string,required:n.a.bool,readonly:n.a.bool,isUpDisabled:n.a.isUpDisabled,isDownDisabled:n.a.isDownDisabled,placeholder:n.a.string,"data-error":n.a.string,"aria-label":n.a.string,valid:n.a.bool,onChange:n.a.func,onBlur:n.a.func,onFocus:n.a.func,onKeyDown:n.a.func,onKeyUp:n.a.func,onKeyPress:n.a.func};var Da=La;function Ma(e){return(Ma="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Ga(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Ra(e,a){return!a||"object"!==Ma(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Fa(e){return(Fa=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Ba(e,a){return(Ba=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Va=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Ra(this,Fa(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Ba(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return this.props.outerLabel?s.a.createElement("div",(e={title:this.props.accessibilityCheckBoxTitle||"",tabIndex:0,className:"form-field checkbox-field ".concat(this.props.className||"")},a="title",o=this.props.title,a in e?Object.defineProperty(e,a,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[a]=o,e),s.a.createElement("label",{className:"effect check inner ".concat(this.props.labelClass||""," ").concat(this.props.checked?"checked":""),"aria-label":this.props.title},s.a.createElement("input",{key:this.props.id,id:this.props.id,name:this.props.name,type:"checkbox",disabled:this.props.disabled,value:this.props.value,checked:this.props.checked,onChange:this.props.onChange,"aria-label":this.props.title}),s.a.createElement("span",{"aria-hidden":"true",className:!this.props.checked&&"bg-white"}),s.a.createElement("span",null,this.props.label))):s.a.createElement("div",{className:"form-field checkbox-field ".concat(this.props.className||"")},s.a.createElement("input",{key:this.props.id,id:this.props.id,name:this.props.name,type:"checkbox",disabled:this.props.disabled,value:this.props.value,checked:this.props.checked,onChange:this.props.onChange,"aria-label":this.props.title}),s.a.createElement("label",{className:"effect check out  ".concat(this.props.labelClass||""," ").concat(this.props.checked?"checked":""),htmlFor:this.props.id},s.a.createElement("span",{"aria-hidden":!0,className:!this.props.checked&&"bg-white"}),s.a.createElement("span",{"aria-hidden":!0},this.props.label)));var e,a,o}}])&&Ga(o.prototype,r),n&&Ga(o,n),a}();Va.propTypes={id:n.a.string.isRequired,name:n.a.string,disabled:n.a.string,className:n.a.string,labelClass:n.a.string,checked:n.a.bool,outerLabel:n.a.bool,label:n.a.string,value:n.a.any,onChange:n.a.func,title:n.a.string,accessibilityCheckBoxTitle:n.a.string};var Ka=Va;function Ha(e){return(Ha="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Wa(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Za(e){return(Za=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Qa(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Xa(e,a){return(Xa=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Ya=function(e){function a(e){var o,t,s;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),t=this,(o=!(s=Za(a).call(this,e))||"object"!==Ha(s)&&"function"!=typeof s?Qa(t):s).state={isHide:!1},o.hideBar=o.hideBar.bind(Qa(o)),o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Xa(e,a)}(a,t["Component"]),o=a,(r=[{key:"hideBar",value:function(){var e=this.state.isHide;window.scrollY>this.prev?!e&&this.setState({isHide:!0}):e&&this.setState({isHide:!1}),this.prev=window.scrollY}},{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.hideBar)}},{key:"componentWillUnmount",value:function(){window.removeEventListener("scroll",this.hideBar)}},{key:"render",value:function(){var e=this.state.isHide?"d-none":"";return s.a.createElement("div",{className:"sticky"+e},props.children)}}])&&Wa(o.prototype,r),n&&Wa(o,n),a}(),$a=o(9),Ja=o.n($a);function eo(e){return(eo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ao(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function oo(e){return(oo=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function to(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function so(e,a){return(so=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var ro=function(e){function a(e){var o,t,s;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),t=this,(o=!(s=oo(a).call(this,e))||"object"!==eo(s)&&"function"!=typeof s?to(t):s).state={value:e.value||""},o.handleChange=o.handleChange.bind(to(o)),o.handleKeyDown=o.handleKeyDown.bind(to(o)),o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&so(e,a)}(a,t["Component"]),o=a,(r=[{key:"handleChange",value:function(e){this.setState({value:e.target.value}),"function"==typeof this.props.onChange&&this.props.onChange(e);var a=e.target;""!==a.value?a.classList.add("has-content"):a.classList.remove("has-content")}},{key:"handleKeyDown",value:function(e){var a=e.target;setTimeout(function(){a.style.cssText="height:auto; padding:0",a.style.cssText="height:"+a.scrollHeight+"px"},0),"function"==typeof this.props.onKeyDown&&this.props.onKeyDown(e)}},{key:"IsRequired",value:function(){if(this.props.required)return s.a.createElement("span",{className:"required"},"*")}},{key:"IsValid",value:function(){return!0===this.props.valid?s.a.createElement("span",{className:"message message-success icon icon_check"},this.props["data-success"]):!1===this.props.valid?s.a.createElement("span",{className:"message message-error icon icon_check"},this.props["data-error"]):void 0}},{key:"GetClasses",value:function(){return Ze()({"has-content":this.state.value||this.props.placeholder,success:!0===this.props.valid,error:!1===this.props.valid})}},{key:"componentDidMount",value:function(){if(this.props.value&&this.props.value.length>0){var e=Ja.a.findDOMNode(this);e.childNodes[0].style.cssText="height:"+e.childNodes[0].scrollHeight+"px"}}},{key:"render",value:function(){return s.a.createElement("div",{className:"form-field ".concat(this.props.className||"")},s.a.createElement("textarea",{id:this.props.id,name:this.props.name,disabled:this.props.disabled,className:"".concat(this.GetClasses(),"\n          ").concat(this.props.value&&""!==this.props.value?"has-content":""),placeholder:this.props.placeholder,minLength:this.props.minLength,maxLength:this.props.maxLength,required:this.props.required,onChange:this.handleChange,onBlur:this.props.onBlur,onFocus:this.props.onFocus,onKeyDown:this.handleKeyDown,onKeyUp:this.props.onKeyUp,onKeyPress:this.props.onKeyPress,"aria-label":this.props.label},this.state.value),s.a.createElement("label",{"aria-hidden":"true",htmlFor:this.props.id},this.props.label,this.IsRequired()),this.IsValid())}}])&&ao(o.prototype,r),n&&ao(o,n),a}();ro.propTypes={id:n.a.string.isRequired,name:n.a.string,disabled:n.a.string,className:n.a.string,value:n.a.string,label:n.a.string,minLength:n.a.string,maxLength:n.a.string,required:n.a.bool,"data-error":n.a.string,"data-success":n.a.string,valid:n.a.bool,onChange:n.a.func,onBlur:n.a.func,onFocus:n.a.func,onKeyDown:n.a.func,onKeyUp:n.a.func,onKeyPress:n.a.func,placeholder:n.a.string};var no=ro;function io(e){return(io="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function co(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function lo(e,a){return!a||"object"!==io(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function mo(e){return(mo=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function po(e,a){return(po=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var uo=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),lo(this,mo(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&po(e,a)}(a,t["Component"]),o=a,(r=[{key:"componentDidMount",value:function(){var e=document.getElementById("alert-message-box");e.setAttribute("tabindex","0"),e.blur();var a=0,o=window.setInterval(function(){e.focus(),++a>=10&&window.clearInterval(o)},10)}},{key:"render",value:function(){var e=this,a=this.props.className||"",o=this.props.isError?"error":"success",t=this.props.isError?"close":"check";return s.a.createElement("div",{className:"col-12 px-0 mr-auto ml-auto confirmation-alert ".concat(a),role:"alert","aria-label":"Erro ao finalizar pagamento","aria-atomic":"true"},s.a.createElement("div",{id:"alert-message-box",className:"bg-white radius border-".concat(o," border-left-lg border-color-").concat(o," px-3 py-3"),tabIndex:0},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"col-auto","aria-hidden":"true"},s.a.createElement("i",{className:"icon icon_".concat(t,"_circle color-").concat(o),"aria-hidden":"true"})),s.a.createElement("div",{className:"col col-md-10 mr-auto"},s.a.createElement("h2",{className:"color-".concat(o," txt-circular-book txt-body-lg")},this.props.title),s.a.createElement("p",{className:"txt-body-sm"},s.a.createElement("p",{className:"txt-body-sm"},this.props.description))),s.a.createElement("div",{className:"col-auto"},s.a.createElement("a",{href:"javascript:void(0)",id:"close-alert-message",role:"button",onClick:function(a){return e.props.onClose()},onKeyPress:function(a){return e.props.onClose()},"aria-label":"Fechar",className:"d-block"},s.a.createElement("i",{className:"icon icon_close cursor","aria-hidden":"true"}))))))}}])&&co(o.prototype,r),n&&co(o,n),a}();uo.propTypes={isError:n.a.bool,className:n.a.string,title:n.a.string,description:n.a.string,onClose:n.a.func};var bo=uo;function fo(e){return(fo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function vo(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function yo(e,a){return!a||"object"!==fo(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function go(e){return(go=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ho(e,a){return(ho=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Eo=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),yo(this,go(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&ho(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"container-fluid bg-ui-4"},s.a.createElement("div",{className:"container py-5"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"row"},s.a.createElement(bo,{isError:!1,title:"Parabéns! Seu resgate foi concluído com sucesso.",description:"Veja abaixo o resumo do seu pedido."}))),s.a.createElement("div",{className:"col-12 mt-2"},s.a.createElement("div",{className:"row"},s.a.createElement(bo,{isError:!0,title:"Não foi possível!",description:"Veja abaixo o resumo do seu pedido."}))),s.a.createElement("div",{className:"col-12  mt-2"},s.a.createElement("h2",null,"Modal Full Page"),s.a.createElement("div",{className:"row mt-4"},s.a.createElement("div",{className:"col-11 border-bottom-lg border-color-featured bg-white py-4 mr-auto ml-auto"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col"},s.a.createElement("h2",null,"Terms and Services")),s.a.createElement("div",{className:"col-auto"},s.a.createElement(m,{name:"Close",className:"btn btn-double btn-flat btn-icon-only btn-icon",iconName:"icon_close icon-sm",text:""}))),s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col mx-0 mt-4 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3"},s.a.createElement("div",{className:"row mx-1"},s.a.createElement("div",{className:"col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm"},"asda"))))),s.a.createElement("div",{className:"col-12 pt-3"},s.a.createElement("div",{className:"row  align-items-center h-100  px-3"},s.a.createElement("div",{className:"modal-back col-3 px-0 txt-left mr-auto"},s.a.createElement(m,{id:"AddMoreProducts",name:"AddMoreProducts",className:"btn btn-sm btn-flat",iconName:"icon_left icon-sm",text:"Voltar"})),s.a.createElement("div",{className:"modal-back col-3 px-0 txt-right"},s.a.createElement(m,{id:"Agree",name:"Agree",className:"btn btn-double btn-featured btn-icon",iconName:"icon_check_circle",text:"LI E ACEITO O REGULAMENTO"}))))))),s.a.createElement("div",{className:"col-6 mt-5"},s.a.createElement("h2",null,"Modal Half Page"),s.a.createElement("div",{className:"row mt-4"},s.a.createElement("div",{className:"col-11 border-bottom-lg border-color-featured bg-white py-4 mr-auto ml-auto"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col"},s.a.createElement("h2",null,"Terms and Services")),s.a.createElement("div",{className:"col-auto"},s.a.createElement(m,{name:"Close",className:"btn btn-double btn-flat btn-icon-only btn-icon",iconName:"icon_close icon-sm",text:""}))),s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col mx-0 mt-4 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3"},s.a.createElement("div",{className:"row mx-1"},s.a.createElement("div",{className:"col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm"},"asda"))))),s.a.createElement("div",{className:"col-12 pt-3"},s.a.createElement("div",{className:"row align-items-center h-100 px-3"},s.a.createElement("div",{className:"modal-back col-6 px-0 txt-left mr-auto"},s.a.createElement(m,{id:"AddMoreProducts",name:"AddMoreProducts",className:"btn btn-sm btn-flat",iconName:"icon_left icon-sm",text:"Voltar"})),s.a.createElement("div",{className:"modal-back col-6 px-0 txt-right"},s.a.createElement(m,{id:"Agree",name:"Agree",className:"btn btn-double btn-featured btn-icon",iconName:"icon_check_circle",text:"LI E ACEITO O REGULAMENTO"}))))))),s.a.createElement("div",{className:"col-6 mt-5"},s.a.createElement("h2",null,"Modal Default"),s.a.createElement("div",{className:"row mt-4"},s.a.createElement("div",{className:"col-11 border-bottom-lg border-color-featured bg-white py-4 px-0 mr-auto ml-auto"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col"},s.a.createElement("h2",null,"Terms and Services")),s.a.createElement("div",{className:"col-auto"},s.a.createElement(m,{name:"Close",className:"btn btn-double btn-flat btn-icon-only btn-icon",iconName:"icon_close icon-sm",text:""}))),s.a.createElement("div",{className:"col-auto mx-0 mt-4 pl-3 pr-1 py-3 border-top border-color-ui-4"},s.a.createElement("div",{className:"row mx-1"},s.a.createElement("div",{className:"col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm"},"asda")))))),s.a.createElement("div",{className:"col-6 mt-5"},s.a.createElement("h2",null,"Action"),s.a.createElement("div",{className:"row mt-4"},s.a.createElement("div",{className:"col-11 border-bottom-lg border-color-featured bg-white py-4 px-0 mr-auto ml-auto"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col"},s.a.createElement("h2",null,"Terms and Services")),s.a.createElement("div",{className:"col-auto"},s.a.createElement(m,{name:"Close",className:"btn btn-double btn-flat btn-icon-only btn-icon",iconName:"icon_close icon-sm",text:""}))),s.a.createElement("div",{className:"col-auto mx-0 mt-4 pl-3 pr-1 py-3 border-top border-color-ui-4"},s.a.createElement("div",{className:"row mx-1"},s.a.createElement("div",{className:"col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm"},"asda"))),s.a.createElement("div",{className:"col-12 pt-3"},s.a.createElement("div",{className:"row align-items-center h-100 px-3"},s.a.createElement("div",{className:"modal-back col pr-1 px-0 txt-left mr-auto"},s.a.createElement(m,{id:"Cancel",name:"Cancel",className:"btn btn-sm",text:"Voltar"})),s.a.createElement("div",{className:"modal-back pl-1 col px-0 txt-right"},s.a.createElement(m,{id:"Agree",name:"Agree",className:"btn btn-sm btn-featured",text:"Aceitar"}))))))),s.a.createElement("div",{className:"col-8 mt-5"},s.a.createElement("h2",null,"Action"),s.a.createElement("div",{className:"row mt-4"},s.a.createElement("div",{className:"col-11 border-bottom-lg border-color-featured bg-white py-4 px-0 mr-auto ml-auto"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col"},s.a.createElement("h2",null,"Terms and Services")),s.a.createElement("div",{className:"col-auto"},s.a.createElement(m,{name:"Close",className:"btn btn-double btn-flat btn-icon-only btn-icon",iconName:"icon_close icon-sm",text:""}))),s.a.createElement("div",{className:"col-auto mx-0 mt-4 pl-3 pr-1 py-3 border-top border-color-ui-4"},s.a.createElement("div",{className:"row mx-1"},s.a.createElement("div",{className:"col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm"},"asda"))),s.a.createElement("div",{className:"col-12 pt-3"},s.a.createElement("div",{className:"row align-items-center h-100 px-3"},s.a.createElement("div",{className:"modal-back col pr-1 px-0 txt-left mr-auto"},s.a.createElement(m,{name:"Cancel",className:"btn btn-sm",text:"Voltar"})),s.a.createElement("div",{className:"modal-back pl-1 col px-0 txt-right"},s.a.createElement(m,{name:"Agree",className:"btn btn-sm btn-featured",text:"Aceitar"}))))))))))}}])&&vo(o.prototype,r),n&&vo(o,n),a}();function xo(e){return(xo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function No(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Po(e,a){return!a||"object"!==xo(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function qo(e){return(qo=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Oo(e,a){return(Oo=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var wo=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Po(this,qo(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Oo(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-6 border-bottom-lg border-color-featured bg-white py-4 mr-auto ml-auto ".concat(this.props.className)},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col"},s.a.createElement("h2",null,this.props.title)),s.a.createElement("div",{className:"col-auto"},s.a.createElement(m,{name:"Close",className:"btn btn-double btn-flat btn-icon-only btn-icon",iconName:"icon_close icon-sm",text:"",onClick:this.props.onClose()}))),s.a.createElement("div",{className:"col-12"},s.a.createElement("div",{className:"row px-3"},s.a.createElement("div",{className:"col mx-0 mt-4 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3"},s.a.createElement("div",{className:"row mx-1"},s.a.createElement("div",{className:"col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm"},this.props.description))))),s.a.createElement("div",{className:"col-12 pt-3"},s.a.createElement("div",{className:"row  align-items-center h-100  px-3"},s.a.createElement("div",{className:"modal-back col-3 px-0 txt-left mr-auto"},s.a.createElement(m,{id:"AddMoreProducts",name:"AddMoreProducts",className:"btn btn-sm btn-flat",iconName:"icon_left icon-sm",text:"Voltar",onClick:this.props.onCancel()})),s.a.createElement("div",{className:"modal-back col-3 px-0 txt-right"},s.a.createElement(m,{id:"Agree",name:"Agree",className:"btn btn-double btn-featured btn-icon",iconName:"icon_check_circle",text:"LI E ACEITO O REGULAMENTO",onConfirm:this.props.onConfirm()})))))}}])&&No(o.prototype,r),n&&No(o,n),a}();wo.propTypes={className:n.a.string,title:n.a.string,description:n.a.string,onClose:n.a.func,onCancel:n.a.func,onConfirm:n.a.func};var So=wo;o(11);function Co(e){return(Co="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function zo(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function To(e){return(To=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ko(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ao(e,a){return(Ao=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var jo=function(e){function a(e){var o,t,s;return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),t=this,(o=!(s=To(a).call(this,e))||"object"!==Co(s)&&"function"!=typeof s?ko(t):s).state={toggleActiveTooltip:!1},o.handleToggleTooltip=o.handleToggleTooltip.bind(ko(o)),o.handleUntoggleTooltip=o.handleUntoggleTooltip.bind(ko(o)),o}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Ao(e,a)}(a,t["Component"]),o=a,(r=[{key:"handleToggleTooltip",value:function(e){this.setState({toggleActiveTooltip:!0})}},{key:"handleUntoggleTooltip",value:function(e){this.setState({toggleActiveTooltip:!1})}},{key:"render",value:function(){var e=this,a=this.props,o=a.icon,t=a.tooltipIitle;return s.a.createElement("div",{className:"custom-tooltip custom-tooltip-".concat(this.props.position?this.props.position:"top"," ").concat(this.state.toggleActiveTooltip?"custom-tooltip-active":"")},o&&s.a.createElement("button",{"aria-label":this.state.toggleActiveTooltip?"Fechar":t,onClick:function(a){return e.state.toggleActiveTooltip?e.handleUntoggleTooltip(a):e.handleToggleTooltip()},"aria-haspopup":!0,"aria-expanded":this.state.toggleActiveTooltip,className:"btn-tooltip-discount"},s.a.createElement("i",{"aria-hidden":!0,className:"icon ".concat(this.state.toggleActiveTooltip?"icon_close":o)})),this.props.children)}}])&&zo(o.prototype,r),n&&zo(o,n),a}();jo.propTypes={children:n.a.element.isRequired,icon:n.a.string,tooltipIitle:n.a.string,position:n.a.string};var Uo=jo,_o=o(10),Io=o.n(_o),Lo=function(e,a,o){return Io.a.post(e,a,{async:!0,timeout:5e3,headers:o})},Do=function(e){var a=e.error,o=e.username,t=e.url,r=e.endpoint,n=e.headers,i=e.successPath,c=void 0===i?"/v1/participants/fingerPrint":i,l=e.errorPath,d=void 0===l?"/v1/fingerPrint/send-finger-print-error":l;return s.a.createElement(s.a.Fragment,null,a?function e(a,o,t,s,r){var n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,i=arguments.length>6&&void 0!==arguments[6]?arguments[6]:10;if(t&&""!==t){var c=document.querySelector("#nameinputhidden").value;if(c)Lo(a+r,{username:t,url:s,fingerPrint:c},o);else if(n<i)return setTimeout(function(){e(a,o,t,s,r,n+1,i)},1e3)}}(r,n,o,t,d):function e(a,o,t,s){var r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:10,i=document.querySelector("#nameinputhidden").value;if(s=document.querySelector("#hiddenclearsale").value,i)Lo(a+t,{fingerPrintToken:i,isConfirmation:!0,SessionId:s},o);else if(r<n)return setTimeout(function(){e(a,o,t,s,r+1,n)},1e3)}(r,n,c))};Do.propTypes={error:n.a.bool,username:n.a.string,url:n.a.string,headers:n.a.object,endpoint:n.a.string,successPath:n.a.string,errorPath:n.a.string};var Mo=Do;function Go(e){return(Go="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Ro(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Fo(e,a){return!a||"object"!==Go(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Bo(e){return(Bo=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Vo(e,a){return(Vo=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Ko=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Fo(this,Bo(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Vo(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white border-ui-3 radius-0 radius-md"},s.a.createElement("div",{className:"row border-bottom border-color-ui-3"},s.a.createElement("div",{className:"col-12 px-3 py-3"},s.a.createElement("h3",null,"Termos de uso"))),s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-3",role:"article"},s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"Termos de Uso")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O catálogo de prêmios, disponível para acesso em www.webpremios.com.br ou por meio de redirecionamento diretamente do hotsite de Programas de Relacionamento, Campanhas de Incentivo e Ações (“Web Prêmios” ou “Plataforma”), é uma plataforma online que permite a você (doravante “Usuário”), participante de determinada campanha de incentivo, desenvolvida por um gestor de campanhas, contratante do Grupo LTM (“Gestor”), trocar seus pontos adquiridos em tal campanha por produtos ou serviços disponibilizados por nossas empresas parceiras (“Parceiros”), indicadas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Dessa forma, os presentes Termos de Uso (“Termos”) estipulam as regras para utilização da Plataforma pelos Usuários, e estão disponíveis para acesso, a qualquer momento, por meio do link"," ",s.a.createElement("a",{href:"/terms",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/terms")),"."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Aplicam-se aos presentes Termos, ainda, o quanto disposto na Política de Privacidade, disponível para acesso em"," ",s.a.createElement("a",{href:"/privacy",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/privacy")),"."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Em caso de quaisquer dúvidas sobre o quanto disposto nestes Termos, o Usuário deverá entrar em contato com o Grupo LTM por meio da página “Fale Conosco”, disponível em"," ",s.a.createElement("a",{href:"/redirect/contact",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/redirect/contact")),"."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"1. ACEITAÇÃO DESTES TERMOS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"1.1. O aceite livre, expresso e informado aos presentes Termos se dará no momento do clique do Usuário no botão “Aceito”, quando de seu primeiro acesso à Plataforma, estando a utilização condicionada à integral aceitação do quanto disposto no presente documento, sendo certo que, caso o Usuário não concorde com o quanto aqui estipulado, deverá se abster de utilizar o site."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"1.2. Exceto em caso de expressa previsão legal em sentido contrário, os presentes Termos poderão ser atualizados ou modificados a qualquer momento, a exclusivo critério do Grupo LTM, independentemente de qualquer formalidade e comunicação, cabendo ao Usuário verificar novamente o conteúdo destes Termos a cada modificação, conforme data de atualização constante ao final deste documento."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"1.3. A continuidade de utilização da Plataforma pelo Usuário implicará a irrestrita aceitação das condições fixadas, incluindo as alterações que porventura venham a ser realizadas em referidas condições."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"2. ACESSO À PLATAFORMA")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.1. O acesso à Plataforma se dará mediante login e senha de acesso, após o cadastro do Usuário no sistema."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.2. Em algumas campanhas, o acesso poderá depender de validação positiva do cadastro do Usuário, por meio da conferência das informações fornecidas pelo Gestor, tais como CPF e data de nascimento, entre outras."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.3. É possível, ainda, que o acesso do Usuário à Plataforma se dê por meio de hotsite, desenvolvido pelo Gestor da campanha. Nesta hipótese, o Usuário deve se atentar também para eventuais Termos de Serviço adicionais constantes de referida página, mantida pelo Gestor."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.4. Poderão se registrar e utilizar a Plataforma Usuários plenamente capazes, nos termos da legislação brasileira. Dessa forma, menores de 18 (dezoito) anos de idade, exceto os emancipados, nos termos do parágrafo único do artigo 5º do Código Civil Brasileiro, não poderão utilizar a Plataforma, sendo vedado seu cadastro como Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.5. Em qualquer hipótese, o Usuário se compromete a fornecer todas as informações obrigatórias solicitadas quando de seu cadastro, de forma correta e verdadeira, responsabilizando-se por qualquer informação incorreta ou inverídica inserida na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.6. Uma vez que o acesso à Plataforma é destinado apenas a participantes das campanhas desenvolvidas pelos Gestores, o Grupo LTM se reserva o direito de negar o acesso de quaisquer Usuários não vinculados a nenhuma campanha ou, a qualquer momento, excluir o acesso de tais Usuários."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.7. Após o cadastro, o Usuário terá acesso a quantidade pontos que possui, bem como ao catálogo de produtos e serviços dos Parceiros do Grupo LTM (“Catálogo”)."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"3. UTILIZAÇÃO DA PLATAFORMA")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.1. Ao utilizar a Plataforma, o Usuário declara e reconhece que:"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.2. Está devidamente autorizado pelo Gestor da campanha a preencher seu cadastro, acessar a Plataforma e realizar a troca de pontos por produtos ou serviços dos Parceiros;"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.3. Deverá manter sempre seu cadastro devidamente atualizado, especialmente seu endereço e informações de contato;"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.4. Não poderá inserir ou produzir na Plataforma, por qualquer meio, conteúdo ilícito, que viole direitos de terceiros ou que seja de qualquer modo contrário à moral e aos bons costumes geralmente aceitos;"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.5. É vedada a inserção na Plataforma de conteúdo que incorpore vírus ou outros elementos físicos ou eletrônicos que possam causar danos ou impedir o normal funcionamento da rede, do sistema ou de equipamentos informáticos, do Grupo LTM, ou de terceiros; e"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.6. É vedada a inserção na Plataforma de conteúdo que provoque, por suas características (tais como forma, extensão etc.), dificuldades no normal funcionamento da Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.7. O Usuário se compromete a utilizar a Plataforma e o seu conteúdo, ou seja, os textos, imagens, fotografias, gráficos, ícones, tecnologia, links e demais conteúdos audiovisuais ou sonoros, incluindo o software da Plataforma, desenhos gráficos e códigos fonte (em conjunto, “Conteúdo(s)”), de acordo com todo o ordenamento jurídico, com a moral e os bons costumes geralmente aceitos, os presentes Termos e eventuais instruções adicionais existentes na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.8. O Usuário deverá se abster de obter, ou de tentar obter, os Conteúdos por quaisquer meios distintos daqueles que, em cada caso, tenham sido colocados à disposição para tais propósitos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.9. Em qualquer circunstância, o Usuário será o único responsável pelo uso que fizer da Plataforma, eximindo o Grupo LTM de qualquer responsabilidade por eventuais danos ou prejuízos decorrentes do uso indevido ou inadequado que o Usuário fizer da Plataforma."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"4. AQUISIÇÃO E TROCA DE PONTOS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.1. Os pontos serão atribuídos ao Usuário pelo Gestor da campanha, de acordo com os critérios estabelecidos pelo Gestor. O Grupo LTM apenas disponibilizará na conta do Usuário os respectivos e eventuais pontos indicados pelo Gestor, sem qualquer ingerência e responsabilidade do Grupo LTM na atribuição dos pontos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.2. Dessa forma, o Grupo LTM não será responsável, em hipótese alguma, por eventuais divergências entre as regras da campanha, estipuladas pelo Gestor, e a quantidade de pontos atribuída ao Usuário, sendo a responsabilidade por tal atribuição exclusiva do Gestor da campanha."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.3. Caso o Usuário não possua saldo de pontos suficiente para realizar o resgate do produto ou serviço desejado, incluindo o valor do frete, este poderá, em determinadas situações, adquirir pontos diretamente do Grupo LTM, apenas e tão somente para a finalidade de completar a quantidade de pontos necessária para o resgate de um determinado produto ou serviço. A aquisição dos pontos será realizada com cartão de crédito ou outro meio de pagamento disponibilizado na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.4. Para que reste autorizada a compra de pontos, o Usuário deverá possuir ao menos parte do valor do produto ou serviço que deseje adquirirem pontos. Não é possível a compra de pontos desvinculada da aquisição de um produto ou serviço, nem a compra de produtos diretamente dos Parceiros, sem a utilização de pontos. O Parceiro poderá exigir que o participante tenha um número mínimo de pontos para habilitar a função “compra de pontos”."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.5. A compra de pontos estará disponível apenas para alguns Parceiros do catálogo de prêmios, de acordo com as condições acordadas entre estes e o Grupo LTM. Caso seja possível a compra, o ícone “compra de pontos” aparecerá como disponível ao Usuário. Assim, o Usuário reconhece que, caso tal ícone não seja disponibilizado, não poderá haver a compra de pontos para a aquisição do produto ou serviço em questão."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.6. A venda de pontos é realizada exclusivamente pelo Grupo LTM, sem qualquer intervenção do Gestor da Campanha. O preço do ponto vendido no catálogo de prêmios será aquele divulgado ao Usuário no momento da compra."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.7. Não há correlação monetária entre os pontos adquiridos pelos Usuários e aqueles que são concedidos pelos Gestores das Campanhas. Assim, o Grupo LTM não se compromete a respeitar qualquer equivalência entre pontos e valores monetários eventualmente indicada pelo Gestor, sendo certo que os pontos fornecidos aos Usuários pelos Gestores das Campanhas não possuem valor monetário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.8. O Usuário poderá trocar os pontos a ele atribuídos por quaisquer produtos ou serviços oferecidos por Parceiros, disponibilizados no Catálogo, acessível por meio de sua conta de acesso."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.9. O Usuário entende e reconhece que a troca de pontos poderá ser restrita a produtos ou serviços de apenas alguns dos Parceiros indicados na Plataforma, a exclusivo critério do Gestor da Campanha. Assim, o Grupo LTM não se responsabiliza por produtos ou serviços de Parceiros que não estejam disponíveis no Catálogo apresentado ao Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.10. Os pontos disponibilizados ao Usuário poderão estar sujeitos a prazo de validade, determinado pelo Gestor da campanha à qual tais pontos estão vinculados. Ainda, todos os pontos relacionados a determinada campanha expirarão, em caso de término do contrato entre o Gestor e o Grupo LTM. É de responsabilidade exclusiva do Usuário utilizar seus pontos, antes da expiração do prazo, não se responsabilizando o Grupo LTM, em hipótese alguma, caso o Usuário não os utilize, dentro do prazo máximo estipulado."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.11. Em hipótese alguma os pontos obtidos pelos Usuários poderão ser convertidos em dinheiro ou trocados por quaisquer produtos ou serviços não constantes no Catálogo disponibilizado ao Usuário quando de seu acesso."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.12. A troca dos pontos pelos produtos ou serviços constantes no Catálogo disponibilizado ao Usuário está sujeita à disponibilidade. A operação de troca por alguns produtos ou serviços poderá não ser concluída, em razão de sua indisponibilidade. A troca somente será tida como completa, após o Usuário finalizar a transação pela Plataforma e receber e-mail com tal confirmação."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.13. A disponibilidade dos produtos ou serviços depende exclusivamente dos Parceiros que os fornecem, não se responsabilizando o Grupo LTM por quaisquer produtos constantes do Catálogo não disponibilizados pelos Parceiros."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.14. O Catálogo de prêmios é atualizado periódica e automaticamente pelos Parceiros e os produtos e pontos necessários para troca poderão sofrer alterações durante a navegação dos Usuários, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate/troca dos pontos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.15. Não há correlação direta entre os preços divulgados em pontos no catálogo de prêmios e os valores indicados pelos Parceiros em seus sites direcionados aos consumidores finais, na medida em que os pontos fornecidos pelo Gestor ao Usuário não possuem valor monetário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.16. Para utilização dos Pontos em determinados Parceiros, o Grupo LTM poderá debitar da conta de premiação dos Usuários uma taxa administrativa. A taxa administrativa padrão para resgate de vouchers é de 5,9% (cinco vírgula nove por cento) sobre o valor nominal do resgate, taxa administrativa da qual o Usuário declara desde logo ter plena ciência. A taxa administrativa para resgate nos demais Parceiros pode variar de acordo com os custos operacionais e administrativos decorrentes do resgate realizado. O preço final do produto em pontos será aquele informado ao Usuário no momento da finalização do resgate."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.17. A Plataforma poderá sugerir produtos e serviços para resgate pelos Usuários de acordo com o seu perfil de consumo, observando inclusive a suas preferências de navegação no catálogo de prêmios, como detalhado na Política de Privacidade relacionada a estes Termos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.18. Caso os pontos do Usuários estejam com prazo de expiração próximo, o Grupo LTM ou o Gestor poderão, em determinadas situações, realizar ações promocionais com resgate automático de pontos para determinados parceiros, visando que o Usuário não seja prejudicado com a expiração dos pontos. Nestas situações, o realizador da ação promocional enviará um SMS ao Usuário, indicando que realizará o resgate automático dos pontos a vencer, formalizando para qual dos Parceiros os pontos a expirar seriam transferidos e concedendo ao Usuário a possibilidade de optar pela sua não realização. O Usuário reconhece que não há obrigatoriedade na realização do resgate automático, seja pelo Grupo LTM ou pelo Gestor, sendo tal medida excepcional."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.19. O Usuário poderá realizar a busca inteligente de produtos e serviços por meio do filtro disponível por categoria, marcas ou saldo de pontos."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"5. ENTREGA DE PRODUTOS OU SERVIÇOS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.1. O Grupo LTM atua apenas como catálogo online, intermediador entre o Usuário e os Parceiros, que inserem diretamente seus produtos e/ou serviços na Plataforma, não comercializando, o Grupo LTM, quaisquer produtos ou serviços, nem mantendo produtos em estoque."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.2. Desta forma, a entrega dos produtos ou a prestação dos serviços selecionados pelo Usuário é de exclusiva responsabilidade do respectivo Parceiro, não se responsabilizando o Grupo LTM por quaisquer atrasos ou falhas na entrega dos produtos ou na prestação dos serviços."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.3. Eventualmente o Grupo LTM poderá adquirir vouchers de Parceiros e comercializá-los na Plataforma, realizando diretamente a entrega deles aos Usuários, hipótese em que o Usuário será informado de que tais vouchers são entregues pelo Grupo LTM."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.4. É de responsabilidade exclusiva do Usuário manter seus dados cadastrais atualizados, eximindo o Grupo LTM e seus Parceiros de qualquer responsabilidade em relação à entrega de produtos decorrentes de informações desatualizadas inseridas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.5. Caso o Usuário opte por resgatar mais de um produto do catálogo de prêmios, ainda que em Parceiros diferentes, o fechamento do resgate poderá ser finalizado no mesmo pedido, em um carrinho único. Os fretes e prazos de entrega, todavia, serão calculados por cada um dos Parceiros e serão incluídos individualmente no pedido. Assim, pedidos contendo mais de um produto poderão possuir datas de entrega diferentes, de acordo com o estipulado pelo Parceiro responsável."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.6. A função de finalização única de resgate não estará disponível para todos os pedidos, pois dependerá da disponibilidade técnica de cada um dos Parceiros."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.7. O cancelamento do pedido de um único produto incluído no carrinho não implicará cancelamento dos demais produtos ou serviços resgatados no mesmo pedido."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.8. Será disponibilizado ao Usuário, por meio do acesso ao ícone “Meus Pedidos”, o acompanhamento do status da entrega dos produtos resgatados, de acordo com as informações disponibilizadas por cada Parceiro, informações que também poderão ser enviadas aos Usuários por e-mail ou SMS."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.9. Caso a entrega do produto não possa ser realizada em razão de divergência no endereço de entrega informado pelo Usuário, o resgate poderá ser cancelado pelo Parceiro, sendo os pontos respectivos creditados novamente na conta do Usuário, respeitado o prazo de validade original dos pontos para que o Usuário possa realizar novo resgate."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.10. Nos cancelamentos de Pedidos em que o Usuário tenha adquirido pontos para realizar o resgate, estes pontos adquiridos serão creditados na sua conta de premiação para posterior utilização, em novo resgate."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.11. Caso o Usuário tenha solicitado cancelamento do pedido, em razão do atraso na entrega ou por outros motivos aplicáveis e o produto tenha sido efetivamente entregue no endereço por ele indicado, o Grupo LTM estará autorizado a debitar os pontos referentes ao produto recebido da conta de premiação do Usuário. Para que não haja o débito de pontos o Usuário deverá recusar o recebimento do pedido que pretendia ver cancelado."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.12. É de responsabilidade exclusiva do Usuário manter seus dados cadastrais atualizados, eximindo o Grupo LTM e seus Parceiros de qualquer responsabilidade relacionada à entrega equivocada de produtos decorrentes de informações desatualizadas inseridas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"6. DURAÇÃO E FINALIZAÇÃO DO ACESSO")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"6.1. O acesso à Plataforma é concedido ao Usuário por prazo indeterminado. No entanto, o Grupo LTM está facultado a dar por terminado, suspender ou interromper unilateralmente, a qualquer momento e sem necessidade de prévio aviso, o acesso do Usuário, sem que qualquer indenização seja devia em razão disso."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"7. ISENÇÃO DE RESPONSABILIDADE")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"7.1. Além das demais hipóteses de isenção de responsabilidade previstas neste documento, o Grupo LTM não se responsabilizará:"),s.a.createElement("p",{className:"txt-body-sm mb-2 pl-1"},"1. Por quaisquer danos decorrentes da interrupção do acesso à Plataforma, ou por falhas de funcionamento;",s.a.createElement("br",null),"2. Pela defraudação da utilidade que os Usuários possam ter atribuído à Plataforma, pela falibilidade da mesma, ou por qualquer dificuldade de acesso;",s.a.createElement("br",null),"3. Pela existência de quaisquer elementos nocivos que possam produzir alterações nos sistemas informáticos dos Usuários (software e/ou hardware) ou nos documentos eletrônicos armazenados no sistema informático;",s.a.createElement("br",null),"4. Por quaisquer hyperlinks disponibilizados na Plataforma, sendo certo que não há verificação prévia do conteúdo de qualquer hyperlink disponibilizado na Plataforma e que as páginas por meio deles acessadas estão sujeitas a outros Termos de Uso e Políticas de Privacidade;",s.a.createElement("br",null),"5. Pelos danos e prejuízos de toda natureza que possam decorrer do conhecimento que terceiros não autorizados possam ter de quaisquer das informações fornecidas pelo Usuário, em decorrência de falha exclusivamente atribuível ao Usuário; e",s.a.createElement("br",null),"6. Por falhas ou informações recebidas de modo incompleto pelo Grupo LTM ou seus Parceiros, que dificultem ou impeçam a troca de pontos por produtos ou serviços;",s.a.createElement("br",null),"7. Por produtos ou serviços disponibilizados na Plataforma pelos Parceiros, devendo qualquer eventual defeito em referidos produtos ou serviços ser comunicado diretamente ao Parceiro responsável, por meio das informações de contato por ele indicadas, para adoção das respectivas providências."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"7.2. O Grupo LTM poderá, a seu exclusivo critério e sem anuência ou concordância do Usuário, alterar os serviços prestados, adicionando ou excluindo Parceiros, produtos e serviços, bem como a pontuação necessária para a troca de determinados produtos ou serviços, sem que qualquer valor ou indenização seja devido ao Usuário, em razão de tais alterações."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"8. PROPRIEDADE INTELECTUAL")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"8.1 Todos os direitos de propriedade intelectual referentes a qualquer material disponibilizado na Plataforma, tais como textos, marcas, logos, fotografias, gráficos, imagens, links, conteúdos audiovisuais ou sonoros, software, desenhos gráficos e códigos fontes, entre outros, são de titularidade do Grupo LTM ou de terceiros que autorizaram seu uso, sendo vedada sua cópia, reprodução, ou qualquer outro tipo de utilização, ficando os infratores sujeitos às sanções civis e criminais correspondentes, nos termos das Leis 9.610/98, 9.609/98 e 9.279/96."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"8.2 Todas as marcas, os nomes comerciais ou logotipos de qualquer espécie disponibilizados na Plataforma são de propriedade do Grupo LTM ou de terceiros que autorizaram seu uso, sem que o acesso ao ou utilização da Plataforma possa ser entendida como autorização para que o Usuário possa citar tais marcas, nomes comerciais e logotipos."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"9. DISPOSIÇÕES GERAIS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"9.1 Se qualquer parte destes Termos for considerada inválida ou inexequível, essa parte deve ser interpretada de forma consistente com a lei aplicável, para refletir, na medida do possível, a intenção original das partes, e as demais disposições permanecerão em pleno vigor e efeito."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"9.2 A falha do Grupo LTM em exigir quaisquer direitos ou disposições dos presentes Termos não constituirá renúncia, podendo exercer regularmente o seu direito, dentro dos prazos legais."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"10. CONTATO")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"10.1 O Usuário poderá entrar em contato com o Grupo LTM por meio do formulário disponibilizado na página Fale Conosco, disponível para acesso em"," ",s.a.createElement("a",{href:"/redirect/contact",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/redirect/contact")),", bem como por meio do endereço de e-mail ou telefone divulgados na comunicação da campanha."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"10.2 O Grupo LTM poderá entrar em contato com o Usuário, e esta comunicação será considerada válida, por meio de qualquer informação de contato por ele disponibilizada quando do preenchimento de seu cadastro. Os comunicados emitidos por meio da Plataforma também serão considerados válidos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"10.3 O Grupo LTM poderá implementar mecanismos antifraude na Plataforma, inclusive realizando contato junto ao Usuário para confirmação do pedido, por meio de ligação, SMS, e-mail ou qualquer outro programa de mensagens pela internet."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"11. LEI APLICÁVEL E FORO")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"11.1 Estes Termos serão regidos, interpretados e executados de acordo com as leis da República Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados ou países, sendo competente o Foro da Comarca de São Paulo, Capital, no Brasil, para dirimir qualquer dúvida decorrente deste instrumento. O Usuário consente, expressamente, com a competência desse juízo, e renuncia, neste ato, à competência de qualquer outro foro, por mais privilegiado que seja ou venha a ser."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Última atualização: 04.05.2017")))}}])&&Ro(o.prototype,r),n&&Ro(o,n),a}();function Ho(e){return(Ho="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Wo(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function Zo(e,a){return!a||"object"!==Ho(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Qo(e){return(Qo=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Xo(e,a){return(Xo=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var Yo=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),Zo(this,Qo(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Xo(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white border-ui-3 radius-0 radius-md"},s.a.createElement("div",{className:"row border-bottom border-color-ui-3"},s.a.createElement("div",{className:"col-12 px-3 py-3"},s.a.createElement("h3",null,"Regulamento iupp"))),s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-3",role:"article"},s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"1. DISPOSIÇÕES GERAIS")),s.a.createElement("p",{className:"txt-body mb-2"},"1.1. Iupp é uma plataforma de fidelidade que visa conceder benefícios que reconheçam o valor de seus clientes. A Plataforma permite que seus Participantes acumulem pontos (“Pontos iupp”), troquem por recompensas e tenham acesso a benefícios e descontos."),s.a.createElement("p",{className:"txt-body mb-2"},"1.2. Este Regulamento tem por finalidade estabelecer as regras e condições as quais se sujeitam os Participantes desta plataforma de fidelidade do Itaú (“Plataforma”) administrada pelo Banco Itaucard S.A., inscrito no CNPJ/MF sob o nº 17.192.451/0001-70."),s.a.createElement("p",{className:"txt-body mb-2"},"1.3. Ao se cadastrar na Plataforma o Participante dá ciência e concorda com o inteiro teor deste Regulamento e com a Política de Privacidade da Plataforma, estando sujeito à todas as regras aqui previstas."),s.a.createElement("p",{className:"txt-body mb-2"},"1.4. Ao se cadastrar na Plataforma o Participante também terá acesso ao Shopping iupp, loja virtual na qual o Participante poderá adquirir produtos e serviços dos parceiros credenciados da Plataforma e acumular pontos iupp."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"2. ADESÃO DOS PARTICIPANTES")),s.a.createElement("p",{className:"txt-body mb-2"},"2.1. Toda pessoa física portadora de CPF, capaz, que se cadastrar através do site ",s.a.createElement("a",{href:"https://www.iupp.com.br",target:"_blank"},"www.iupp.com.br")," ou por quaisquer outros canais disponibilizados pela Plataforma poderá se tornar Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"2.2. Para se cadastrar, o Participante deverá inserir todas as informações solicitadas de forma correta. A veracidade dos dados é de responsabilidade do próprio Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"2.3. O cadastro será vinculado ao CPF do cliente e será necessária a definição de uma senha de acesso à Plataforma e outra para a Central de Relacionamento."),s.a.createElement("p",{className:"txt-body mb-2"},"2.4. As informações da conta iupp e senhas de acesso são de uso pessoal, intransferível e de responsabilidade do próprio Participante, não devendo ele compartilhá-las ou divulgá-las por qualquer meio."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"3. ACÚMULO")),s.a.createElement("p",{className:"txt-body mb-2"},"3.1. Os Participantes poderão acumular Pontos iupp pelos seguintes meios:"),s.a.createElement("p",{className:"txt-body mb-2"},"(i) Adesão, contratação, compra ou uso de determinados produtos ou serviços dos parceiros da Plataforma – conforme termos e condições descritos em regulamento específico, disponíveis no site ",s.a.createElement("a",{href:"https://www.iupp.com.br",target:"_blank"},"www.iupp.com.br"),"– tais como: utilização dos cartões de crédito vinculados à Plataforma, compras no Shopping iupp, entre outros;"),s.a.createElement("p",{className:"txt-body mb-2"},"(ii) Participação em atividades ou campanhas de incentivo, promoções da Plataforma e/ou de seus parceiros conforme termos e condições descritos em regulamentos específicos, disponíveis no site ",s.a.createElement("a",{href:"https://www.iupp.com.br",target:"_blank"},"www.iupp.com.br"),";"),s.a.createElement("p",{className:"txt-body mb-2"},"(iii) Compra de pontos diretamente na Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"3.2. A Plataforma se reserva no direito de disponibilizar outras formas de acúmulo que não as mencionadas no presente Regulamento, as quais terão suas regras próprias que serão disponibilizadas aos Participantes através de quaisquer canais de comunicação da Plataforma com o Participante e aplicativo iupp."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"4. SHOPPING iupp")),s.a.createElement("p",{className:"txt-body mb-2"},"4.1. O Participante poderá adquirir produtos e/ou serviços dos parceiros iupp através dos meios de pagamento disponíveis no momento da compra e o Participante poderá acumular pontos por compras realizadas no Shopping iupp, que terá suas regras próprias as quais serão disponibilizadas aos Participantes através de quaisquer canais de comunicação da Plataforma com o Participante e aplicativo iupp."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"5. C0MPRA DE PONTOS")),s.a.createElement("p",{className:"txt-body mb-2"},"5.1. Os Participantes poderão comprar Pontos iupp através dos canais disponíveis da Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"5.2. A Plataforma se reserva no direito de alterar a qualquer momento e sem prévia comunicação ao Participante o preço dos Pontos iupp e limites de quantidade de compra, devendo o Participante verificar as informações disponibilizadas no momento da compra."),s.a.createElement("p",{className:"txt-body mb-2"},"5.3. Os Pontos iupp adquiridos serão disponibilizados na conta iupp do Participante logo após a confirmação de pagamento."),s.a.createElement("p",{className:"txt-body mb-2"},"5.4. Os Participantes poderão solicitar o cancelamento da compra dos pontos através dos canais disponíveis em até 7 (sete) dias corridos contados do recebimento dos pontos, desde que nenhum dos pontos adquiridos tenham sido utilizados."),s.a.createElement("p",{className:"txt-body mb-2"},"5.5. Os Pontos iupp adquiridos através da compra de pontos não expiram."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"6. RESGATE DE PONTOS")),s.a.createElement("p",{className:"txt-body mb-2"},"6.1. Os Participantes poderão usar seus Pontos iupp para adquirir benefícios e recompensas que estiverem disponíveis na Plataforma iupp através dos seguintes canais: (i) Site ",s.a.createElement("a",{href:"https://www.iupp.com.br",target:"_blank"},"www.iupp.com.br"),";"),s.a.createElement("p",{className:"txt-body mb-2"},"(ii) Outros canais próprios que poderão ser consultados no Site."),s.a.createElement("p",{className:"txt-body mb-2"},"a) A disponibilidade, valor, formas de entrega, formas de pagamento, valor do frete e demais características das recompensas poderão ser consultadas no catálogo disponível nos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"b) O prazo para a entrega do produto/serviço resgatado pode variar de acordo com o fornecedor e natureza da recompensa e o Participante deve sempre consultar o prazo de entrega no momento do resgate."),s.a.createElement("p",{className:"txt-body mb-2"},"c) O Participante poderá realizar o resgate dos produtos/serviços na Plataforma utilizando seus pontos, podendo também complementar o pagamento utilizando os meios de pagamento disponíveis."),s.a.createElement("p",{className:"txt-body mb-2"},"d) Para utilizar seus pontos, o Participante deve acessar os canais iupp, inserir os dados de login e senha, escolher a recompensa desejada , informar corretamente os dados solicitados, e confirmar o resgate."),s.a.createElement("p",{className:"txt-body mb-2"},"6.2. A inclusão de itens no carrinho de compras não garante a sua disponibilidade, que pode estar sujeita à disponibilidade do estoque."),s.a.createElement("p",{className:"txt-body mb-2"},"6.3. O status de cada pedido poderá ser verificado através dos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"6.4. Ao realizar um resgate, o Participante autoriza que suas informações cadastrais (como CPF, nome, e-mail, telefone e endereço completos) sejam divulgados ao Parceiro do resgate, para que este providencie a reserva, cadastramento e/ou entrega da recompensa."),s.a.createElement("p",{className:"txt-body mb-2"},"6.5. O Participante autoriza que eventual Parceiro responsável pela entrega da recompensa resgatada na Plataforma entre em contato através dos seus dados fornecidos a fim de confirmar detalhes da entrega dos produtos, se necessário."),s.a.createElement("p",{className:"txt-body mb-2"},"6.6. O Participante é o responsável por: (i) garantir a veracidade de todas as informações fornecidas; e (ii) definir o beneficiário do resgate caso a natureza da recompensa permita que o beneficiário seja alguém que não o próprio Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"6.7. Caso não seja possível entregar o produto em razão de mudança de endereço não informada, endereço não localizado ou ausência de responsável maior do que 18 anos no momento da entrega, o resgate será cancelado e os Pontos iupp e valores pagos serão devolvidos ao Participante, excluídos os custos de logística da entrega, se houver."),s.a.createElement("p",{className:"txt-body mb-2"},"6.8. Caso o produto seja entregue em outro local que não o desejado por conta de erro no fornecimento de informações pelo Participante, este perderá o direito ao produto, os Pontos iupp e eventuais valores pagos não serão devolvidos."),s.a.createElement("p",{className:"txt-body mb-2"},"6.9. A responsabilidade pela qualidade, garantia, especificações técnicas e durabilidade dos produtos e serviços escolhidos no resgate é exclusiva dos Parceiros que os prestarem ou fornecerem."),s.a.createElement("p",{className:"txt-body mb-2"},"6.10. Havendo indisponibilidade em estoque ou extravio do produto resgatado, o resgate será cancelado e os Pontos iupp e eventuais valores serão devolvidos. Neste caso, a Plataforma iupp se responsabiliza por comunicar o Participante sobre o eventual cancelamento. O status do pedido também poderá ser consultado através dos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"6.11. No caso de resgate de Pontos iupp para doações, a Plataforma não confere nenhuma garantia de que este poderá ser utilizado para abatimento de Imposto de Renda e nem de quaisquer outros tributos devidos pelo Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"6.12. A Plataforma não se responsabiliza por transações não finalizadas em razão de falhas de comunicação de dados ou quaisquer outros problemas relacionados a provedores e servidores de Internet."),s.a.createElement("p",{className:"txt-body mb-2"},"6.13. Os pontos utilizados no momento do resgate serão sempre aqueles mais próximos da data de expiração."),s.a.createElement("p",{className:"txt-body mb-2"},"6.14. O resgate dos pontos na Plataforma é um direito pessoal e intransferível do Participante, que não deverá ceder ou transferir seus pontos à terceiros."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"7. CANCELAMENTO DE RESGATES COM PONTOS DO CATÁLOGO DE RECOMPENSAS iupp")),s.a.createElement("p",{className:"txt-body mb-2"},"7.1. O Participante poderá solicitar o cancelamento por arrependimento dos produtos físicos resgatados em até 7 (sete) dias corridos após o recebimento do produto, através da Central de Relacionamento iupp, devendo manter a embalagem e o produto em perfeito estado para sua devolução. Nesta situação, o resgate será cancelado e os Pontos iupp e eventuais valores pagos serão devolvidos."),s.a.createElement("p",{className:"txt-body mb-2"},"7.2. Uma vez constatado que o produto entregue contém qualquer vício ou defeito, ou que não se trata do produto solicitado, o Participante deverá formular reclamação à Plataforma através da Central de Relacionamento de acordo com os prazos previstos pelo Código de Defesa do Consumidor, devendo manter a embalagem e o produto em perfeito estado para sua devolução."),s.a.createElement("p",{className:"txt-body mb-2"},"7.3. Ao solicitar resgates dos Pontos iupp para milhas ou programas parceiros, ou por recompensas entregues de forma digital/por e-mail, o Participante poderá solicitar, por motivo de desistência, erro ou divergência, o cancelamento ou troca em até 7 (sete) dias corridos após a data de solicitação do resgate, através dos canais iupp, desde que não tenha utilizado a recompensa. Ao transferir seus Pontos iupp para programas parceiros, o Participante estará sujeito às regras do programa de destino."),s.a.createElement("p",{className:"txt-body mb-2"},"7.4. As regras descritas neste item não se aplicam ao resgate de passagens aéreas, hotéis e pacotes de viagens, cujas regras de alteração e cancelamento estão sujeitas às normas das próprias empresas parceiras e devem ser verificadas no momento do resgate ou nos canais das companhias."),s.a.createElement("p",{className:"txt-body mb-2"},"7.5. Toda solicitação de cancelamento de resgate passa por uma análise a fim de que seja verificado se o cancelamento solicitado se encontra dentro das regras descritas neste Regulamento e previstas no Código de Defesa do Consumidor."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"8. TRATAMENTO DAS INFORMAÇÕES DOS PARTICIPANTES")),s.a.createElement("p",{className:"txt-body mb-2"},"8.1. Ao se inscrever na Plataforma e aderir a este Regulamento, o Participante expressamente concorda com a Política de Privacidade da Plataforma iupp, que dispõe sobre a"),s.a.createElement("p",{className:"txt-body mb-2"},"coleta, tratamento e eventual compartilhamento dos dados dos Participantes com parceiros, a qual está disponível para consulta no site ",s.a.createElement("a",{href:"https://www.iupp.com.br",target:"_blank"},"www.iupp.com.br"),"."),s.a.createElement("p",{className:"txt-body mb-2"},"8.2. O Banco Itaucard S.A., gestor da Plataforma, e demais empresas do Conglomerado Itaú (“Itaú”) tratam dados pessoais de pessoas físicas (como clientes, representantes e sócios/acionistas de clientes pessoa jurídica) para diversas finalidades relacionadas ao desempenho de suas atividades."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3. Nesse item resumimos as principais informações sobre como coletamos e usamos dados pessoais. Para maiores informações, inclusive sobre os seus direitos em relação aos seus dados pessoais (como de correção, acesso aos dados e informações sobre o tratamento, eliminação, bloqueio, exclusão, oposição e portabilidade de dados pessoais), acesse a nossa Política de Privacidade nos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.1. Dados coletados: Os dados pessoais coletados e tratados pelo Itaú podem incluir dados cadastrais, financeiros, transacionais ou outros dados, que podem ser fornecidos diretamente por você ou obtidos em decorrência da prestação de serviços ou fornecimento de produtos pelo Itaú a você ou a você relacionados, bem como obtidos de outras fontes conforme permitido na legislação aplicável, tais como fontes públicas, empresas do Conglomerado Itaú, outras instituições dos sistema financeiro, parceiros ou fornecedores, bem como, empresas e órgãos com os quais o Conglomerado Itaú tenha alguma relação contratual e com os quais você possua vínculo."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.2. Finalidades de uso dos dados: Poderemos usar os dados pessoais para diversas finalidades relacionadas ao desempenho de nossas atividades, na forma prevista na Política de Privacidade, como por exemplo: (i) oferta, divulgação, prestação de serviços e fornecimento de produtos; (ii) execução de contrato e de etapas prévias ao contrato, incluindo a avaliação dos produtos e serviços mais adequados ao seu perfil, bem como atividades de crédito, financeiras, de investimento, cobrança e demais atividades do Conglomerado Itaú; (iii) cumprimento de obrigações legais e regulatórias; (iv) atendimento de requisições de autoridades administrativas e judiciais; (v) exercício regular de direitos, inclusive em processos administrativos, judiciais e arbitrais; (vi) análise, gerenciamento e tratamento de potenciais riscos, incluindo os de crédito, fraude e segurança; (vii) verificação da sua identidade e dados pessoais, inclusive dados biométricos, para fins de autenticação, segurança e/ou prevenção à fraude; (viii) verificação, análise e tratamento de dados pessoais para fins de avaliação, manutenção e aprimoramento dos nossos serviços; (ix) hipóteses de legítimo interesse, como desenvolvimento e ofertas de produtos e serviços do Conglomerado Itaú."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.3. Dados biométricos: Poderemos utilizar sua biometria facial e/ou digital em produtos e/ou serviços das empresas do Conglomerado Itaú para processos de identificação e/ou autenticação em sistemas eletrônicos próprios ou de terceiros para fins de segurança e prevenção a fraudes."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.4. Compartilhamento dos dados: Os seus dados pessoais poderão ser compartilhados para as finalidades previstas neste documento e na nossa Política de Privacidade, como, por exemplo, entre as empresas do Conglomerado Itaú, com prestadores de serviços e fornecedores localizados no Brasil ou no exterior, bureaus de crédito de acordo com as regras aplicáveis à atividade, órgãos reguladores e entidades públicas, inclusive administrativas e judiciais, e ainda, com parceiros estratégicos para possibilitar a oferta"),s.a.createElement("p",{className:"txt-body mb-2"},"de produtos e serviços. Apenas compartilhamos dados na medida necessária, com segurança e de acordo com a legislação aplicável."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"9. VALIDADE DOS PONTOS iupp")),s.a.createElement("p",{className:"txt-body mb-2"},"9.1. A validade dos Pontos iupp se dará conforme termos e condições descritos em regulamento específico de cada forma de acúmulo, disponível no site ",s.a.createElement("a",{href:"https://www.iupp.com.br",target:"_blank"},"www.iupp.com.br"),"."),s.a.createElement("p",{className:"txt-body mb-2"},"9.2. Pontos iupp acumulados através da compra de pontos não expiram, conforme definido na Cláusula 6.5 deste Regulamento."),s.a.createElement("p",{className:"txt-body mb-2"},"9.3. Pontos iupp acumulados através de compras no Shopping iupp tem a validade de 24 meses, a partir da data em que forem creditados na conta iupp do Participante, exceto quando acumulados em razão de campanhas promocionais com regras próprias."),s.a.createElement("p",{className:"txt-body mb-2"},"9.4. A Plataforma poderá realizar campanhas promocionais de concessão de Pontos iupp cuja validade será determinada pela regra própria da referida campanha e disponibilizada ao Participante em regulamento próprio."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"10. DISPOSIÇÕES FINAIS")),s.a.createElement("p",{className:"txt-body mb-2"},"10.1 A Plataforma se reserva o direito de, a seu critério e a qualquer tempo, (i) alterar os parceiros de resgate participantes da Plataforma, as próprias recompensas e a pontuação necessária para cada resgate, cabendo ao Participante consultar as recompensas e condições vigentes no momento do resgate; (ii) modificar as regras da Plataforma mediante o envio de comunicação com 15 dias de antecedência aos Participantes (iii) encerrar ou cancelar a Plataforma mediante comunicação com 30 dias de antecedência aos Participantes; (iv) encerrar o relacionamento com um Participante iupp, de forma unilateral, com comunicação prévia de 15 dias, para que o Participante utilize seus pontos, com exceção das situações descritas no item 10.3 abaixo."),s.a.createElement("p",{className:"txt-body mb-2"},"10.2 Caso a Plataforma seja encerrada, o Participante será comunicado com 30 dias de antecedência sobre o fim do acúmulo dos pontos. A partir da data da comunicação, o Participante terá 60 dias para realizar resgates dos pontos acumulados na Plataforma. Após este prazo, todos os pontos serão cancelados juntamente com a Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"10.3. Os Pontos iupp serão automaticamente cancelados na ocorrência das seguintes hipóteses: (i) falecimento do Participante; (ii) solicitação de saída da Plataforma pelo Participante; (iii) identificação de fraude e (iv) caso a Plataforma constate não ser verdadeira qualquer informação que o Participante tenha fornecido."),s.a.createElement("p",{className:"txt-body mb-2"},"10.4. O Participante é o responsável por respeitar todas as disposições deste Regulamento a eles aplicáveis, sob pena de perder o direito à recompensa ou aos Pontos iupp, ou ser excluído da Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"10.5. As seguintes situações não afetarão as condições previstas neste Regulamento, tampouco o direito da Plataforma de exigi-las, a qualquer tempo: (i) a omissão da Plataforma em requerer execução de qualquer obrigação do Regulamento; (ii) a tolerância para o descumprimento de qualquer obrigação do Regulamento."),s.a.createElement("p",{className:"txt-body mb-2"},"10.6. Na hipótese de qualquer disposição ou termo deste Regulamento ser considerado inexequível, inválido ou ilegal, em juízo ou por árbitro competente, os demais termos e condições permanecem exequíveis e válidos.")))}}])&&Wo(o.prototype,r),n&&Wo(o,n),a}();function $o(e){return($o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Jo(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function et(e,a){return!a||"object"!==$o(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function at(e){return(at=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ot(e,a){return(ot=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var tt=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),et(this,at(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&ot(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white border-ui-3 radius-0 radius-md"},s.a.createElement("div",{className:"row border-bottom border-color-ui-3"},s.a.createElement("div",{className:"col-12 px-3 py-3"},s.a.createElement("h3",null,"Política de Privacidade"))),s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-3",role:"article"},s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"Política de Privacidade")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O catálogo de prêmios disponível para acesso em www.webpremios.com.br ou por meio de redirecionamento diretamente do hotsite de Programas de Relacionamento, Campanhas de Incentivo e Ações (“Web Prêmios” ou “Plataforma”), é uma plataforma online que permite a você (doravante “Usuário”), participante de determinada campanha de incentivo, desenvolvida por um gestor de campanhas (“Gestor”) contratante do Grupo LTM, trocar seus pontos adquiridos em tal campanha por produtos ou serviços disponibilizados por nossas empresas parceiras (“Parceiros”), indicadas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"A presente Política de Privacidade (“Política”) foi desenvolvida para que o Usuário tenha ciência de quais informações são coletadas por meio de sua utilização da Plataforma, bem como sobre a forma como se dará o armazenamento, o tratamento e utilização de tais informações."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"A presente Política está disponível para acesso pelo Usuário, a qualquer momento, por meio do endereço ",s.a.createElement("strong",null,window.location.host,"/privacy"),". Além disso, são aplicáveis conjuntamente ao presente documento os Termos de Uso da Plataforma, disponível em ",s.a.createElement("strong",null,window.location.host,"/terms"),"."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Em caso de quaisquer dúvidas sobre o quanto disposto nesta Política, o Usuário deverá entrar em contato com o Grupo LTM por meio da página “Fale Conosco”, disponível em ",s.a.createElement("strong",null,window.location.host,"/redirect/contact"),"."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"A presente Política é aplicável à coleta de dados realizada pelo Grupo LTM por meio da Plataforma. Dados coletados em quaisquer outros portais, inclusive nos Portais dos Parceiros, serão de responsabilidade exclusiva do respectivo responsável e podem estar sujeitos a outras políticas ou regras, cabendo ao Usuário verificar a adequação delas."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"1. ACEITAÇÃO DESTA POLÍTICA")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O aceite livre, expresso e informado à presente Política se dará no momento do clique do Usuário no botão “Aceito”, quando de seu primeiro acesso à Plataforma, estando a sua utilização condicionada à integral aceitação do quanto disposto no presente documento, sendo certo que, caso o Usuário não concorde com o quanto aqui estipulado, deverá abster-se de utilizar a Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Exceto em caso de expressa previsão legal em sentido contrário, a presente Política poderá ser atualizada ou modificada a qualquer momento, a exclusivo critério do Grupo LTM, independentemente de qualquer formalidade e comunicação, cabendo ao Usuário verificar novamente o conteúdo desta Política a cada nova modificação, conforme data de atualização constante ao final deste documento."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"A continuidade de utilização da Plataforma pelo Usuário implicará a irrestrita aceitação das condições aqui fixadas, incluindo as alterações que porventura venham a ser realizadas."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"2. INFORMAÇÕES QUE O GRUPO LTM COLETA")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"São coletados, basicamente, dois tipos de informações por meio da Plataforma: (i) Dados fornecidos ativamente pelo Usuário e (ii) Dados gerados automaticamente quando da utilização da Plataforma pelo Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"(i) Informações fornecidas pelo Usuário: Correspondem às informações inseridas ativamente pelo Usuário na Plataforma, como as informações pessoais fornecidas quando do preenchimento de seu cadastro na Plataforma, consistentes em (i) nome completo, (ii) sexo, (iii) estado civil, (iv) CPF, (v) data de nascimento, (vi) documento de identidade, (vii) endereço residencial e comercial, (viii) telefone residencial e comercial, (ix) e-mail pessoal e comercial, entre outras informações que podem vir a ser requeridas para acesso à Plataforma. Incluem, em síntese, todos os dados inseridos pelo Usuário quando do preenchimento de formulários disponibilizados na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"(ii) Informações coletadas automaticamente: Além das informações mencionadas no item anterior, a cada acesso do Usuário à Plataforma, o Grupo LTM coletará algumas informações geradas automaticamente, especialmente IP (com data e hora) e origem do IP, podendo, no entanto, ser coletadas também características do dispositivo de acesso, do navegador, informações sobre cliques, páginas acessadas, as páginas seguintes acessadas após a saída da Plataforma, ou qualquer termo de procura digitado na Plataforma ou em referência a esta, dentre outros. Para a coleta de tais informações poderão ser utilizadas diversas tecnologias padrões, como cookies, pixel tags, beacons e local shared objects, sempre de forma a melhorar a experiência de navegação do Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Usuário pode configurar o seu navegador, de forma a evitar a coleta automática de alguns tipos de informações, como cookies. No entanto, caso tal configuração seja implementada, é possível que alguns recursos fornecidos na Plataforma deixem de funcionar corretamente."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Usuário desde já afirma estar ciente e concordar com a coleta de informações descrita nesta Política."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"3. COMO O GRUPO LTM UTILIZA AS INFORMAÇÕES COLETADAS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"As informações coletadas pelo Grupo LTM são tratadas como confidenciais e somente serão utilizadas da forma descrita na presente Política e pelo Usuário autorizada."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Os dados coletados pelo Grupo LTM são utilizados especialmente para a prestação dos serviços desenvolvidos na Plataforma, ou seja, para reconhecimento do Usuário, troca de pontos, entrega de produtos, bem como para o contato do Grupo LTM e Parceiros com os Usuários. Além disso, as informações coletadas poderão ser utilizadas também para a verificação de fraudes na Plataforma e para a identificação positiva do Usuário, bem como para fins estatísticos e publicitários, inclusive para a sugestão de produtos ou serviços para resgate pelo Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Dessa forma, o Usuário dá o consentimento livre, expresso e informado para que o Grupo LTM utilize as informações obtidas por meio da Plataforma para a verificação de fraudes e da identidade do Usuário, para a entrega de produtos, para fins publicitários e estatísticos, bem como para personalizar o acesso do Usuário à Plataforma, além da regular prestação de serviços pelo Grupo LTM. O Usuário manifesta, ainda, seu consentimento livre, expresso e informado para que o Grupo LTM repasse as informações coletadas por meio da Plataforma aos Gestores de campanhas e Parceiros, estando o Usuário desde já ciente de que o Grupo LTM não possui qualquer ingerência na utilização de tais informações pelos Gestores e Parceiros."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"4. COM QUEM O GRUPO LTM COMPARTILHA AS INFORMAÇÕES")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Grupo LTM trabalha em parceria com diversas empresas, de modo que poderá compartilhar as informações coletadas com terceiros, nas seguintes hipóteses:"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Para o desenvolvimento das atividades comerciais do Grupo LTM, sendo necessário o compartilhamento das informações dos Usuários com os Parceiros, para a entrega dos produtos e prestação dos serviços; Com os Gestores das campanhas realizadas por meio da Plataforma, para cumprimento das obrigações contratuais do Grupo LTM; Para proteção dos interesses do Grupo LTM em qualquer tipo de conflito, incluindo ações judiciais; No caso de transações e alterações societárias envolvendo o Grupo LTM, hipótese em que a transferência das informações será necessária para a continuidade dos serviços; ou Mediante ordem judicial ou pelo requerimento de autoridades administrativas que detenham competência legal para sua requisição."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"5. COMO O GRUPO LTM ARMAZENA AS INFORMAÇÕES")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Grupo LTM armazenará os dados coletados em servidores próprios ou por ele contratados para tal finalidade."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Grupo LTM adota todas as medidas razoáveis de mercado para garantir a segurança de seus sistemas e dos dados de Usuários coletados, respeitando, ainda, todas as exigências da legislação brasileira, em especial do Decreto 8.771/2016, quais sejam:"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Utilização de soluções para que os dados coletados sejam criptografados e anonimizados; Utilização de software de alta tecnologia para a proteção contra acessos não autorizados aos dados, armazenados em ambiente controlado e de segurança; Acesso aos locais de armazenamento das informações permitido somente a pessoas previamente autorizadas, comprometidas a manter as informações em sigilo, de forma que a quebra de tal obrigação acarretará em sua responsabilização civil, nos moldes da legislação brasileira; Emprego de mecanismos de autenticação de acesso aos registros, os quais serão capazes de individualizar o responsável pelo tratamento desses registros; Manutenção de inventário, que indicará o momento, a duração, a identidade do funcionário ou do responsável pelo acesso e o arquivo acessado, para controle do acesso aos registros."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Dessa forma, o Grupo LTM tem como objetivo sempre manter e preservar a privacidade dos dados dos Usuários, constituindo a presente Política esforço para resguardar a segurança destes dados. No entanto, o Grupo LTM não pode garantir integralmente que todas as informações que trafegam na Plataforma não sejam alvo de acessos não autorizados perpetrados por meio de métodos desenvolvidos para obter informações de forma indevida."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"6. EXCLUSÃO DAS INFORMAÇÕES COLETADAS PELO GRUPO LTM")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Grupo LTM não exclui automaticamente as informações coletadas, a não ser mediante solicitação do Gestor da campanha que motivou a coleta de tais informações, ou quando do término do contrato entre tal Gestor e o Grupo LTM, hipótese em que tais informações deixarão de ser úteis para os fins para os quais foram coletadas."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O Usuário poderá requerer a exclusão dos dados sobre ele coletados, entrando em contato com o Grupo LTM, pelo e-mail:atendimento@webpremios.com.br, informando seu pedido. O Grupo LTM empreenderá todos os esforços para atender a os pedidos, no menor espaço de tempo possível."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"A exclusão dos dados acarretará no encerramento da conta do Usuário e perda de todos os pontos acumulados, sem que qualquer indenização seja devida pelo Grupo LTM do Usuário, em razão de tal exclusão."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Importante notar que, mesmo em caso de requisição de exclusão, o Grupo LTM respeitará o prazo de armazenamento mínimo de informações determinado pela legislação brasileira e pelo Gestor."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"7. LEGISLAÇÃO E FORO APLICÁVEIS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Essa Política será regida, interpretada e executada de acordo com as leis da República Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados ou países, sendo competente o Foro da Comarca de São Paulo, Capital, no Brasil, para dirimir qualquer dúvida decorrente deste instrumento. O Usuário consente, expressamente, com a competência desse juízo, e renuncia, neste ato, à competência de qualquer outro foro, por mais privilegiado que seja ou venha a ser."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Última atualização: 04.05.2017.")))}}])&&Jo(o.prototype,r),n&&Jo(o,n),a}();function st(e){return(st="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function rt(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function nt(e,a){return!a||"object"!==st(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function it(e){return(it=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ct(e,a){return(ct=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var lt=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),nt(this,it(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&ct(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white border-ui-3 radius-0 radius-md"},s.a.createElement("div",{className:"row border-bottom border-color-ui-3"},s.a.createElement("div",{className:"col-12 px-3 py-3"},s.a.createElement("h3",null,"POLÍTICA DE PRIVACIDADE"))),s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-3",role:"article"},s.a.createElement("p",{className:"txt-body mb-2"},"A privacidade, a proteção de Dados Pessoais e o seu tratamento de forma transparente, ética, segura e responsável são valores essenciais para nós.  "),s.a.createElement("p",{className:"txt-body mb-2"},"Esta Política de Privacidade (ou apenas “Política”) explica como as empresas do Conglomerado Itaú Unibanco, na qualidade de Controladores de Dados Pessoais, coletam, usam, compartilham ou de outra forma tratam informações e Dados Pessoais de pessoas físicas, inclusive de clientes e de terceiros, para o desempenho de nossas atividades, incluindo pelos nossos Sites e Aplicativos. Aqui você também encontra informações sobre os seus direitos em relação aos seus Dados Pessoais, de acordo com a LGPD - Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/18), e demais legislações aplicáveis. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Política de Privacidade ")),s.a.createElement("p",{className:"txt-body mb-2 ml-2"},"1. Atualização da Política de Privacidade ",s.a.createElement("br",null),"2. Quais informações utilizamos e como coletamos ",s.a.createElement("br",null),"3. Para que usamos os seus dados? ",s.a.createElement("br",null),"4. As informações podem ser compartilhadas ",s.a.createElement("br",null),"5. Sobre os Cookies ",s.a.createElement("br",null),"6. Transferência internacional de dados ",s.a.createElement("br",null),"7. Por quanto tempo mantemos seus dados? ",s.a.createElement("br",null),"8. Segurança dos dados ",s.a.createElement("br",null),"9. Seus direitos ",s.a.createElement("br",null),"10.Encarregado de Proteção de Dados ",s.a.createElement("br",null),"11. Glossário"),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"1. ATUALIZAÇÃO DA POLÍTICA DE PRIVACIDADE ")),s.a.createElement("p",{className:"txt-body mb-2"},"Sempre que o Itaú Unibanco entender necessário, a Política de Privacidade poderá sofrer alterações que serão publicadas em nossos Sites e Aplicativos. Essas alterações serão válidas, eficazes e vinculantes após a nova versão ser divulgada nos nossos Sites e Aplicativos ou serem comunicadas de qualquer outra forma a você. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"2. QUAIS INFORMAÇÕES UTILIZAMOS E COMO COLETAMOS? ")),s.a.createElement("p",{className:"txt-body mb-2"},"Nós tratamos Dados Pessoais de quem é ou foi nosso cliente ou teve algum relacionamento conosco, foi ou é representante, procurador, empregado, sócio de algum cliente, empresa ou entidade com a qual nos relacionamos, realizou alguma transação conosco ou com nossos clientes, de pessoas com as quais pretendemos nos relacionar ou outros titulares de Dados Pessoais."),s.a.createElement("p",{className:"txt-body mb-2"},"Os Dados Pessoais que tratamos variam de acordo as finalidades de uso, inclusive as indicadas nessa Política, e com as atividades que realizamos. Esses Dados Pessoais incluem dados cadastrais, financeiros e transacionais, tais como: "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dados cadastrais:")," nome, data de nascimento, sexo, RG, CPF e/ou outros documentos de identificação, tais como carteira de habilitação, foto, data de nascimento, endereço residencial e comercial, telefones residencial, comercial e celular, e-mail, profissão, ocupação, estado civil, nacionalidade, naturalidade, PEP – pessoa politicamente exposta, entre outros.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dados Pessoais Sensíveis: ")," dados biométricos, inclusive facial e/ou digital ou outros dados pessoais sensíveis, de acordo com a legislação aplicável. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dados financeiros e transacionais:")," informações sobre operações e transações bancárias, financeiras e de pagamento, produtos e serviços contratados ou que se pretenda contratar e sua utilização (inclusive nossos produtos financeiros, bancários, de crédito, financiamento, câmbio, investimento, seguros, previdência, capitalização, consórcio, cartão de crédito e serviços de pagamento, entre outros).  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dados sobre terceiros: ")," filiação, representantes, representados, garantidor, contrapartes, procuradores, colaboradores, sócios ou beneficiários de produtos e serviços, como por exemplo de seguros, previdência, cartão de crédito e pagamento. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Informações sobre seus dispositivos:")," informações sobre o seu dispositivo (tais como Advertising ID e informações técnicas, como sistema operacional, tamanho de tela), conexão (tais como data, hora e Endereço IP, rede utilizada), identificação do dispositivo, uso do dispositivo. Também poderemos coletar, se você nos autorizar pelos nossos Aplicativos, sua geolocalização, para usarmos para prevenção à fraude e segurança, proteção do crédito, indicarmos dependências próximas e também fazermos ofertas de produtos e serviços para você. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Informações que acessamos para te entregar uma funcionalidade:")," caso você autorize e para possibilitar determinadas funcionalidades de nossos Sites e Aplicativos, como quando tratamos suas fotos e dados de contatos para a criação e envio de comprovantes de pagamento. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Informações sobre hábitos de navegação:"),"páginas e funcionalidades acessadas em nossos Sites e Aplicativos, quantidade de cliques, páginas e aplicativos que originaram o acesso aos nossos Sites e Aplicativos (por exemplo, se você acessar um site que possuir um link para os nossos Sites e Aplicativos, ou se você acessar páginas de terceiros a partir de links nos nossos Sites e Aplicativos). "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dados de mídias e plataformas sociais: "),"interações que você possa ter com nossas redes sociais, tais como Facebook, Twitter, Instagram, LinkedIn e YouTube.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dados relacionados a situação financeira: ")," podemos acessar os dados sobre sua situação financeira ou de crédito, tais como renda, patrimônio, negativação, dados do cadastro positivo, inclusive dados detalhados de cadastro positivo ou dados de Sistema de Informações de Crédito do Banco Central, de acordo com a legislação aplicável.  "),s.a.createElement("p",{className:"txt-body mb-2"},"Os dados podem ser fornecidos diretamente por você, serem coletados em decorrência da prestação de serviços ou fornecimento de produtos pelo Itaú Unibanco a você (ou a você relacionados), ou podem ser fornecidos por outras empresas do Conglomerado Itaú Unibanco ou por fontes externas legítimas, como parceiros estratégicos, corretoras, inclusive de valores e seguros, fornecedores, prestadores de serviços, outras instituições do sistema financeiro, bureaus de crédito, órgãos públicos, correspondentes e empresas ou órgãos com os quais o Itaú Unibanco ou você possua vínculo ou algum tipo de relação direta ou indireta. Também podemos obter Dados Pessoais e outras informações de fontes públicas e/ou acessíveis publicamente, como Internet, meios de comunicação, mídias sociais e registros públicos e de outras fontes, conforme permitido na legislação aplicável."),s.a.createElement("p",{className:"txt-body mb-2"},"A seguir indicamos alguns exemplos dessas situações. "),s.a.createElement("p",{className:"txt-body mb-2"},"Dados podem ser fornecidos por você, por exemplo, no preenchimento de cadastros, formulários, propostas, simulações, adesões, contratações, acessos, procura ou manifestação de interesse em produtos e serviços. "),s.a.createElement("p",{className:"txt-body mb-2"},"Dados recebidos de terceiros são aqueles fornecidos por terceiros sobre você, mesmo que você não seja cliente do Itaú Unibanco, inclusive por empresas ou órgãos com os quais o Itaú Unibanco ou você tenha alguma relação, bem como fornecedores e parceiros. Alguns exemplos de casos em que isso ocorre são: "),s.a.createElement("p",{className:"txt-body mb-2"},"alguém realiza uma transação financeira com você, como uma transferência bancária ou pagamento de boleto; "),s.a.createElement("p",{className:"txt-body mb-2"},"quando você é beneficiário ou Usuário de algum produto contratado por um terceiro, como cartão, seguro ou previdência; "),s.a.createElement("p",{className:"txt-body mb-2"},"a empresa ou órgão em que você trabalha nos fornece informações sobre você para o fornecimento de produtos e serviços a você, como para o pagamento do seu salário pelo Itaú Unibanco, para concessão ou consignação de crédito ou produtos de previdência; "),s.a.createElement("p",{className:"txt-body mb-2"},"realizamos o pagamento de benefícios originados de órgãos públicos; "),s.a.createElement("p",{className:"txt-body mb-2"},"um cliente, contraparte, parceiro ou prestador de serviços indica você como seu sócio, representante, empregado, procurador ou contato; "),s.a.createElement("p",{className:"txt-body mb-2"},"um parceiro ou prestador de serviços nos fornece informações sobre você para a oferta ou contratação de produtos e serviços; "),s.a.createElement("p",{className:"txt-body mb-2"},"buscamos informações sobre você ou confirmamos informações que você nos fornecer, para as nossas atividades, como realizar ou melhorar o seu cadastro e sua experiência, prevenir fraudes e cumprir outras obrigações legais. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"3. PARA QUE USAMOS OS SEUS DADOS? ")),s.a.createElement("p",{className:"txt-body mb-2"},"O Itaú Unibanco realiza o tratamento de dados pessoais de acordo com as bases legais previstas na Lei Geral de Proteção de Dados (LGPD), como por exemplo, para cumprimento de obrigações legais e regulatórias; execução de contrato; proteção do crédito; para atender os interesses legítimos do Itaú Unibanco, dos nossos clientes e de terceiros; proteção da vida ou da incolumidade física do Titular ou de terceiro; nas situações em que o consentimento do Titular dos Dados Pessoais for coletado e para o exercício regular de direitos. "),s.a.createElement("p",{className:"txt-body mb-2"},"Poderemos tratar Dados Pessoais e outras informações para diversas finalidades relacionadas ao desempenho das atividades do Conglomerado Itaú Unibanco, conforme exemplos descritos abaixo: "),s.a.createElement("p",{className:"txt-body mb-2"},"Realizar as nossas atividades, prestar os nossos serviços e fornecer os nossos produtos no nosso relacionamento com você: "),s.a.createElement("p",{className:"txt-body mb-2"},"realizar e manter o seu cadastro atualizado, verificar sua identidade e eventuais outras informações;",s.a.createElement("br",null),s.a.createElement("br",null),"dar cumprimento e realizar ações relacionadas ao contrato, inclusive etapas anteriores à contratação, durante e após a contratação. Atividades como avaliação de propostas de contratação, atendimento nos nossos canais e processos operacionais para garantir a melhor experiência e atendimento para os nossos clientes;",s.a.createElement("br",null),s.a.createElement("br",null),"atender os nossos clientes, potenciais clientes e terceiros, inclusive tratando dúvidas, reclamações, sinistros, solicitações e suporte pelos nossos canais de atendimento, possibilitando o seu contato conosco sempre que necessário, e o contrário também;",s.a.createElement("br",null),s.a.createElement("br",null),"envio de comunicações sobre produtos e serviços contratados por você, necessários para o cumprimento do contrato;",s.a.createElement("br",null),s.a.createElement("br",null),"avaliações e exercício regular de direitos necessários para execução de contratos, como por exemplo, informações sobre a sua saúde necessárias para a contratação de determinados produtos, como de seguros, ou ainda para a avaliação de sinistros relacionados;",s.a.createElement("br",null),s.a.createElement("br",null),"Entender os nossos clientes e oferecer produtos mais adequados às suas necessidades e perfil:",s.a.createElement("br",null),s.a.createElement("br",null),"avaliar o perfil, identificar oportunidades e realizar oferta e contratação de produtos, serviços, iniciativas e benefícios do Conglomerado Itaú Unibanco e/ou de parceiros estratégicos mais adequados ao perfil, interesses e necessidades, para clientes atuais, potenciais e terceiros, inclusive por meio de e-mail marketing ou outras comunicações. Você pode gerenciar os nossos canais pelos quais prefere receber as nossas ofertas ou optar por não mais recebê-las em nossos canais;",s.a.createElement("br",null),s.a.createElement("br",null),"avaliar os comportamentos de navegação e o perfil dos Usuários e clientes, inclusive para entender se o Usuário chegou até os Sites e Aplicativos por meio de acesso direto, links ou cookies próprios ou de terceiros, por exemplo;",s.a.createElement("br",null),s.a.createElement("br",null),"realizar campanhas de marketing e também utilizar tecnologias da informação e soluções de propaganda online;",s.a.createElement("br",null),s.a.createElement("br",null),"realizar pesquisas com o público para melhoria dos nossos produtos, serviços, atendimento e iniciativas."),s.a.createElement("p",{className:"txt-body mb-2"},"Segurança e risco: "),s.a.createElement("p",{className:"txt-body mb-2"},"identificar, prevenir e gerenciar eventuais riscos de segurança, física ou cibernética, sua, do Itaú Unibanco ou de terceiros;",s.a.createElement("br",null),s.a.createElement("br",null),"prevenir fraudes e garantir a segurança, inclusive com utilização de sua biometria (facial, digital ou outra), bem como sua geolocalização, em quaisquer produtos, serviços, Sites e Aplicativos do Itaú Unibanco, para processos de identificação e/ou autenticação em sistemas eletrônicos próprios ou de terceiros, que também podem ser Controladores de Dados Pessoais, inclusive pelo desenvolvimento e/ou uso de ferramentas antifraude;",s.a.createElement("br",null),s.a.createElement("br",null),"analisar perfil, identificar, gerenciar e tratar potenciais riscos na oferta e contratação de produtos e/ou serviços e nas demais atividades do Itaú Unibanco, como os riscos de crédito, riscos operacionais, riscos reputacionais, riscos de mercado, entre outros riscos. Monitorando esses riscos também estamos cuidando da segurança dos nossos clientes;",s.a.createElement("br",null),s.a.createElement("br",null),"atividades relacionadas à proteção do crédito, como avaliação e gerenciamento de risco de crédito, avaliação de situação financeira e patrimonial, cobrança, cessão de crédito, atividades relacionadas à informação e consulta a entidades de proteção ao crédito e cadastro positivo, entre outras."),s.a.createElement("p",{className:"txt-body mb-2"},"Cumprimento de obrigações legais e regulatórias "),s.a.createElement("p",{className:"txt-body mb-2"},"cumprir obrigações legais, regulatórias e de autorregulação, como por exemplo: atividades de auditoria interna e compliance, prevenção aos crimes de lavagem de dinheiro e financiamento ao terrorismo e outros ilícitos, atividades de know your client – KYC e outras atividades de gerenciamento de riscos, reportes à Receita Federal, medidas de prevenção à fraude, prestação de informações ao Banco Central e outros órgãos competentes, do Brasil e do exterior, para cumprimento de normas, comunicação de operações suspeitas ao Coaf, prova de vida de beneficiário do INSS, avaliação de representantes legais e sócios de empresas, entre outras atividades;",s.a.createElement("br",null),s.a.createElement("br",null),"cumprir ordens e decisões judiciais, administrativas e arbitrais."),s.a.createElement("p",{className:"txt-body mb-2"},"Proteger os seus direitos, do Itaú Unibanco e de terceiros: "),s.a.createElement("p",{className:"txt-body mb-2"},"para o exercício regular de direitos, inclusive em contratos e processos judiciais, extrajudiciais, administrativos ou arbitrais."),s.a.createElement("p",{className:"txt-body mb-2"},"Manter, criar e melhorar as nossas atividades: "),s.a.createElement("p",{className:"txt-body mb-2"},"analisar, criar e aperfeiçoar os nossos produtos, serviços, atividades, sejam internas ou externas, iniciativas, projetos, recursos e funcionalidades das nossas plataformas, Sites e Aplicativos, inclusive para melhorar o seu acesso e utilização e fornecer a melhor experiência para você;",s.a.createElement("br",null),s.a.createElement("br",null),"medir e entender a interação dos Usuários e clientes conosco, inclusive em redes sociais e em nossos canais, assim como a utilização dos nossos produtos, serviços, atividades, iniciativas, Sites e Aplicativos e a satisfação dos Usuários e clientes. Assim podemos criar, manter e melhorar os nossos produtos, serviços e nossos canais de atendimento;",s.a.createElement("br",null),s.a.createElement("br",null),"execução de processos de negócios, gerenciamento interno e gerencial. Tratamos seus dados para nossas atividades e para nos ajudar a tomar melhores decisões sobre nossas operações, negócios, serviços, produtos, atividades e iniciativas;",s.a.createElement("br",null),s.a.createElement("br",null),"atividades relacionadas à contratação e relacionamento com fornecedores, prestadores de serviços e outros terceiros."),s.a.createElement("p",{className:"txt-body mb-2"},"Outras situações de Tratamento baseadas em finalidades legítimas, como por exemplo o apoio e promoção de atividades do Itaú Unibanco ou para a prestação de serviços que beneficiem os nossos clientes. "),s.a.createElement("p",{className:"txt-body mb-2"},"Promover eventos, realizar patrocínios e outras atividades e iniciativas. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"4 . AS INFORMAÇÕES PODEM SER COMPARTILHADAS?")),s.a.createElement("p",{className:"txt-body mb-2"},"O Itaú Unibanco somente compartilha suas informações quando é necessário ou pertinente, para as finalidades previstas nos contratos com os nossos clientes e nessa Política de Privacidade, dentro de padrões rígidos de segurança, sempre visando a confidencialidade das suas informações e seguindo as normas de sigilo bancário e demais normas de proteção de dados e da privacidade. Exemplos de situações de compartilhamento são:"),s.a.createElement("p",{className:"txt-body mb-2"},"entre as empresas do Conglomerado Itaú Unibanco e com fundação ou entidade que tenha qualquer destas empresas como mantenedora ou que de qualquer forma seja gerida ou vinculada ao Conglomerado Itaú Unibanco, inclusive para o desenvolvimento de nossas atividades, oferta e prestação de serviços e fornecimento de produtos, gerenciamento de riscos, cumprimento de obrigações legais e demais finalidades previstas nessa Política;",s.a.createElement("br",null),s.a.createElement("br",null),"com parceiros estratégicos, inclusive para oferta, contratação e uso de produtos e serviços destes, ou ainda desenvolvidos em conjunto ou que possam ter um benefício para você;",s.a.createElement("br",null),s.a.createElement("br",null),"com prestadores de serviços, fornecedores, corretoras, inclusive de valores e seguros, e correspondentes contratados pelo Itaú Unibanco para o desenvolvimento de nossas atividades;",s.a.createElement("br",null),s.a.createElement("br",null),"com órgãos reguladores, outras entidades públicas, instituições do sistema financeiro e terceiros, inclusive para cumprimento e execução de obrigações legais, regulatórias e contratuais e para a proteção e o exercício regular de direitos;",s.a.createElement("br",null),s.a.createElement("br",null),"para cumprimento de requisições, solicitações e decisões de autoridades judiciais, administrativas ou arbitrais;",s.a.createElement("br",null),"para identificação, prevenção e investigação de possíveis infrações ou atos ilícitos (inclusive fraude, lavagem de dinheiro e financiamento ao terrorismo);",s.a.createElement("br",null),s.a.createElement("br",null),"para prevenir riscos, fraudes e garantir a segurança, inclusive com utilização de sua biometria (facial, digital ou outra) em processos de identificação e/ou autenticação em sistemas eletrônicos próprios ou de terceiros, que também são Controladores de Dados Pessoais;",s.a.createElement("br",null),s.a.createElement("br",null),"situações em que o compartilhamento seja relevante ou necessário para criação, oferta, manutenção, funcionamento e melhoria dos nossos Sites e Aplicativos, bem como das atividades, das iniciativas e dos produtos e serviços do Conglomerado Itaú Unibanco e de parceiros estratégicos;",s.a.createElement("br",null),s.a.createElement("br",null),"com bureaus de crédito, inclusive de acordo com o disposto na legislação aplicável, como para cumprimento da legislação do cadastro positivo, nos casos de negativação, entre outros;",s.a.createElement("br",null),s.a.createElement("br",null),"com outras instituições financeiras, inclusive quando necessário, para o processamento de alguma transação ou outras atividades para execução de contrato;",s.a.createElement("br",null),s.a.createElement("br",null),"compartilhamento de informações anonimizadas, agrupadas, de cookies ou de outras informações ou formas que não possibilitem a identificação pessoal dos Titulares de Dados;",s.a.createElement("br",null),s.a.createElement("br",null),"nos casos de aquisição, fusão ou outras reorganizações societárias;",s.a.createElement("br",null),s.a.createElement("br",null),"situações em que o seu consentimento pode ser necessário e, caso seja, solicitaremos o seu consentimento oportunamente."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"5. SOBRE OS COOKIES")),s.a.createElement("p",{className:"txt-body mb-2"},"Os cookies permitem a coleta de dados relacionadas à navegação dependendo do tipo de dispositivo usado, das autorizações concedidas por você através das configurações de seu dispositivo e das funcionalidades utilizadas em cada aplicação. Podemos utilizar cookies próprios ou de terceiros em nossos Sites e Aplicativos."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"O que são cookies? ")),s.a.createElement("p",{className:"txt-body mb-2"},"São pequenos arquivos de texto que podem ou não ser adicionados no navegador do dispositivo. Estes arquivos armazenam e reconhecem dados que garantem o correto funcionamento dos Sites e Aplicativos e nos ajudam a identificar suas preferências e melhoras suas experiências.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null)),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Tipos de cookies e suas finalidades")," "),s.a.createElement("p",{className:"txt-body mb-2"},"Os cookies podem coletar dados para diferentes finalidades relacionadas às funcionalidades de nossos Sites e Aplicativos. Confira a seguir os tipos que utilizamos: "),s.a.createElement("p",{className:"txt-body mb-2 ml-3"},"funcionamento: para garantir o correto acesso e funcionamento das aplicações;",s.a.createElement("br",null),s.a.createElement("br",null),"autenticação: para reconhecer o Usuário, possibilitando o seu acesso, inclusive, a áreas de acesso restrito e utilizados também para oferecer conteúdo, ofertas e/ou serviços de parceiros estratégicos;",s.a.createElement("br",null),s.a.createElement("br",null),"segurança: para auxiliar no monitoramento e detecção de atividades não autorizadas, na prevenção à fraude e na proteção das informações dos Usuários, suas, do Conglomerado Itaú Unibanco e de terceiros;",s.a.createElement("br",null),s.a.createElement("br",null),"pesquisa, Análise e Desempenho: para verificar, medir e analisar a audiência, o desempenho, a utilização das aplicações pelos usuários;",s.a.createElement("br",null),s.a.createElement("br",null),"propaganda: para apresentar publicidade relevante do Conglomerado Itaú Unibanco e de parceiros e de acordo com o perfil do Usuário e para saber se os Usuários a visualizaram, tanto em nossos ambientes quanto em sites e aplicativos de parceiros. Também podem ser utilizados para lembrar eventuais pesquisas realizadas pelos Usuários, e com base no resultado dessas pesquisas, mostrar anúncios ou ofertas de produtos, serviços e iniciativas de seu interesse."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Posso desativar os cookies e as outras formas de coleta de informações?  ")),s.a.createElement("p",{className:"txt-body mb-2"},"Você pode desativar ou excluir os cookies, bem como as tecnologias de coleta, nas configurações do seu navegador e nas configurações do sistema operacional do seu dispositivo, com exceção dos cookies de funcionamento que, se desativados, não permitirão o uso dos Sites e Aplicativos."),s.a.createElement("p",{className:"txt-body mb-2"},"Apenas lembramos que se determinados cookies forem desabilitados, os Sites ou Aplicativos ou alguns de seus recursos ou funcionalidades poderão não funcionar corretamente. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"6. TRANSFERÊNCIA INTERNACIONAL DE DADOS  ")),s.a.createElement("p",{className:"txt-body mb-2"},"Os seus Dados Pessoais poderão ser transferidos e Tratados em outros países, de acordo com as hipóteses previstas na LGPD e legislação aplicável, para as finalidades previstas nesta Política de Privacidade.  "),s.a.createElement("p",{className:"txt-body mb-2"},"Por exemplo, os dados podem ser transferidos para o exterior caso seja necessário para a execução de contrato (como transações de cartão de crédito realizadas no exterior ou transações de cartões estrangeiros realizadas no Brasil, câmbio e outras operações bancárias, financeiras, securitárias e de investimento com outras empresas do Conglomerado Itaú Unibanco no exterior ou outras instituições financeiras); para o cumprimento de obrigações legais e regulatórias do Itaú Unibanco; para o exercício regular de direitos em processos administrativos, judiciais ou arbitrais ou para a investigação de crimes e outros ilícitos. Ainda, a transferência internacional de dados pode ocorrer para o desenvolvimento das atividades do Itaú Unibanco, mediante a adoção de medidas de proteção dos Dados Pessoais.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"7. POR QUANTO TEMPO MANTEMOS SEUS DADOS? ")),s.a.createElement("p",{className:"txt-body mb-2"},"O prazo pelo qual o Itaú Unibanco mantém os Dados Pessoais coletados depende do propósito e da natureza do tratamento dos dados. Nós trataremos seus dados pelo período necessário para o cumprimento de obrigações legais, regulatórias e contratuais, para continuar a fornecer e aprimorar nossos produtos e serviços, para o gerenciamento de riscos, para o exercício regular de direito em processos administrativos, judiciais e arbitrais e para as demais finalidades previstas nesta Política de Privacidade.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"8. SEGURANÇA DOS DADOS ")),s.a.createElement("p",{className:"txt-body mb-2"},"A segurança e proteção de dados pessoais e das informações do Itaú Unibanco é uma prioridade para nós. O Itaú Unibanco estabelece processos e controles para prevenção, detecção e resposta a incidentes e proteção dos seus dados de acessos e usos não autorizados, garantindo a gestão do risco de segurança, inclusive cibernética, e a construção de um alicerce robusto de segurança. "),s.a.createElement("p",{className:"txt-body mb-2"},"Consideramos que a informação deve ser protegida independentemente de onde ela esteja, seja em um prestador de serviço ou em uma unidade internacional, ou em parceiro, em todo o seu ciclo de vida, desde o momento que ela é coletada, passando pelo processamento, transmissão, armazenamento, análise e seu descarte. "),s.a.createElement("p",{className:"txt-body mb-2"},"Cuidamos dos dados, seguindo padrões rígidos de segurança e confidencialidade, para fornecer aos nossos usuários e clientes um ambiente seguro e confiável. Usamos ferramentas e tecnologias para manter a integridade e confidencialidade das informações e protegê-las de acessos não autorizados. "),s.a.createElement("p",{className:"txt-body mb-2"},"Adicionalmente, restringimos o acesso aos dados na medida necessária, com rígidas obrigações de confidencialidade e sigilo e mediante a adoção de critérios de segurança.  "),s.a.createElement("p",{className:"txt-body mb-2"},"As diretrizes de proteção dos dados da organização, dos clientes e do público em geral estão formalizadas na ",s.a.createElement("a",{href:"https://www.itau.com.br/relacoes-com-investidores/Download.aspx?Arquivo=10W2o93X6iM4JjSSPq7GWg==&IdCanal=jjCFHS5IadmGCLdvw2zIdg==",target:"_blank"},"Política Corporativa de Segurança da Informação e Cyber Security.")," "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"9. SEUS DIREITOS ")),s.a.createElement("p",{className:"txt-body mb-2"},"A LGPD garante direitos aos Titulares dos Dados. Como Titular dos seus Dados Pessoais, você pode nos fazer os seguintes requerimentos:  "),s.a.createElement("p",{className:"txt-body mb-2"},"acesso e confirmação da existência de tratamento dos dados;",s.a.createElement("br",null),s.a.createElement("br",null),"atualização, correção de dados incompletos, inexatos ou desatualizados;",s.a.createElement("br",null),s.a.createElement("br",null),"anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na LGPD;",s.a.createElement("br",null),s.a.createElement("br",null),"portabilidade dos dados, observadas as normas aplicáveis e os segredos comercial e industrial;",s.a.createElement("br",null),s.a.createElement("br",null),"informação das entidades públicas e privadas com as quais o Controlador realizou uso compartilhado de dados;",s.a.createElement("br",null),s.a.createElement("br",null),"informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;",s.a.createElement("br",null),s.a.createElement("br",null),"revogação de consentimento que poderá ser realizada a qualquer momento e sem ônus, mediante manifestação expressa;",s.a.createElement("br",null),s.a.createElement("br",null),"solicitar a eliminação dos Dados Pessoais Tratados com o consentimento, exceto nas hipóteses em que a manutenção dos dados é necessária ou permitida pela legislação;",s.a.createElement("br",null),s.a.createElement("br",null),"oposição a Tratamento realizado com fundamento em outras bases legais, em caso de descumprimento da LGPD, ressaltando que pode haver situações em que poderemos continuar a realizar o Tratamento e recusar o seu pedido de oposição;",s.a.createElement("br",null),s.a.createElement("br",null),"solicitar a revisão de decisões tomadas unicamente com base em Tratamento automatizado de Dados Pessoais que o afetem, como decisões de crédito;",s.a.createElement("br",null),s.a.createElement("br",null),"solicitar o cancelamento do envio de ofertas direcionadas de produtos e serviços do Itaú Unibanco pelos nossos canais."),s.a.createElement("p",{className:"txt-body mb-2"},"Para exercer seus direitos sobre os seus Dados Pessoais, você pode acionar os nossos canais de atendimento. Consulte em ",s.a.createElement("a",{href:"https://www.itau.com.br/",target:"_blank"},"www.itau.com.br/seguranca/privacidade"),"  qual o mais apropriado de acordo com o seu relacionamento."),s.a.createElement("p",{className:"txt-body mb-2"},"Reforçamos que poderemos manter alguns dados e/ou continuar a realizar o Tratamento, mesmo no caso de solicitação de eliminação, oposição, bloqueio ou anonimização, em algumas circunstâncias, como para cumprimento de obrigações legais, contratuais e regulatórias, para resguardar e exercer direitos do Itaú Unibanco, dos Usuários e clientes, para prevenção de atos ilícitos e em processos judiciais, administrativos e arbitrais, inclusive por questionamento de terceiros sobre suas atividades e em outras hipóteses previstas em lei. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"10. ENCARREGADO DE PROTEÇÃO DE DADOS ")),s.a.createElement("p",{className:"txt-body mb-2"},"Para obter mais informações sobre a Política ou sobre como tratamos os seus dados pessoais, você pode entrar em contato no e-mail encarregado-dados@itau.com.br com o título “aos cuidados do Encarregado”. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"GLOSSÁRIO ")),s.a.createElement("p",{className:"txt-body mb-2"},"Os termos abaixo são usados nos nossos Termos de Uso e Política de Privacidade. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Conglomerado Itaú Unibanco")," ou apenas Itaú Unibanco: inclui o ",s.a.createElement("strong",null,"Itaú Unibanco: ")," Holding S.A., o Itaú Unibanco S.A., e as demais sociedades controladoras ou controladas, diretamente ou indiretamente, isolada ou conjuntamente com terceiros, por tais empresas e coligadas, no Brasil e no exterior, que incluem, por exemplo, o Banco Itaucard S.A., Banco Itaú BBA S.A., Banco Itaú Consignado S.A., Itaú Administradora de Consórcios Ltda., Itaú Seguros S.A., Itaú Corretora de Seguros S.A., Itaú Vida e Previdência S.A., Financeira Itaú CBD S.A. Crédito, Financiamento e Investimento, Luizacred S.A. Sociedade de Crédito, Financiamento e Investimento, Hipercard Banco Múltiplo S.A., Itaú Corretora de Valores S.A., Itaú Distribuidora de Títulos e Valores Mobiliários S.A., Microinvest S.A. Sociedade de Crédito a Microempreendedor, Redecard S.A. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Controlador: ")," pessoa natural ou jurídica, de direito público ou privado, a quem competem as decisões referentes ao Tratamento de Dados Pessoais. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dado Pessoal: ")," informação relacionada a pessoa natural identificada ou identificável. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Dado Pessoal Sensível:")," dado pessoal sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Endereço de Protocolo de Internet (Endereço IP): ")," código atribuído a um terminal de uma rede para permitir sua identificação, definido segundo parâmetros internacionais.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Sites e Aplicativos: ")," sites e aplicativos do Conglomerado Itaú Unibanco que podem ser acessados por Usuários.  "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Titular de Dados Pessoais: ")," pessoa natural a quem se referem os dados pessoais que são objeto de tratamento. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Tratamento:")," toda operação realizada com Dados Pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração. "),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Usuários:")," todas as pessoas que visitarem e acessarem os Sites e Aplicativos. Também podemos nos referir ao Usuário e ao Titular de Dados Pessoais como “você”. "),s.a.createElement("p",{className:"txt-body mb-2"},"Atualização: agosto de 2020. ")))}}])&&rt(o.prototype,r),n&&rt(o,n),a}();function dt(e){return(dt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function mt(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function pt(e,a){return!a||"object"!==dt(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function ut(e){return(ut=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function bt(e,a){return(bt=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var ft=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),pt(this,ut(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&bt(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white"},s.a.createElement("div",{className:"row"},s.a.createElement("div",{className:"col-12 px-3 py-3 cardUi4"},s.a.createElement("div",{className:"container px-md-3 pt-4"},s.a.createElement("p",{className:"d-flex txt-body-md mb-2 mt-2 px-1"},s.a.createElement("span",{className:"color-brand-2 d-flex align-items-center"},s.a.createElement("a",{href:"/",className:"d-flex txt-body-md"},s.a.createElement(l,{className:"icon icon-sm color-brand-2",iconName:"icon_home"}),s.a.createElement("p",{className:"ml-md-2 ml-1 mr-1 mr-md-0 txt-underline"},"Início"))),s.a.createElement("strong",{className:"ml-md-1 fontSize16"},"/ Estatuto de acessibilidade")),s.a.createElement("h1",{className:"container accessibility-h1"},"Estatuto de acessibilidade")))),s.a.createElement("div",{className:"container mb-4"},s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-4"},s.a.createElement("h2",{className:"accessibility-h2 mb-2"},"Aqui todo mundo é igual."),s.a.createElement("p",{className:"txt-body-md mb-2"},"Fazer parte do iupp é tornar a vida cada vez mais fácil, inclusive para quem tem necessidades especiais."),s.a.createElement("p",{className:"txt-body-md mb-2"},"Por isso, a gente se comprometeu a desenvolver uma plataforma seguindo práticas reconhecidas no mundo todo ",s.a.createElement("strong",null,"(WCAG 2.1, A e AA)"),", que tornam o nosso site acessível a qualquer tipo de usuário, inclusive você."),s.a.createElement("p",{className:"txt-body-md mb-2"},"Além destas regras, a gente também faz pesquisas regularmente com portadores de deficiência visual e auditiva para garantir que todo mundo se sinta bem. Afinal, ser iupp é muito mais que juntar pontos. Ser iupp é viver experiências e fazer com que elas sejam inesquecíveis, iguais às recompensas que você encontra por aqui."),s.a.createElement("p",{className:"txt-body-md mb-2 Xbold fontSize25 color-brand-4 mb-4"},"Então, se você acha que a gente pode melhorar algo ou encontrou alguma limitação de acessibilidade, fale com a gente. Vai ser muito bom te atender. ;)"),s.a.createElement("a",{role:"button",id:"btnContinue",className:"btn btn-sm btn-featured d-flex justify-content-center mb-4",type:"button",href:"https://atendimentoiupp.zendesk.com/hc/pt-br/requests/new?ticket_form_id=360000543012"},"enviar comentário"),s.a.createElement("div",{className:"hr mb-4"}),s.a.createElement("h2",{className:"accessibility-h2 mb-2"},"Se precisar de uma força, a gente tem algumas dicas."),s.a.createElement("h3",{className:"txt-body-md mb-2 mt-4"},s.a.createElement("strong",{className:"Xbold color-brand-4 fontSize25"},"Conte com a ajuda de leitores de tela")),s.a.createElement("p",{className:"txt-body-md mb-2"},"Dependendo do seu sistema operacional, existem ferramentas que te dão uma força a mais:"),s.a.createElement("p",{className:"txt-body-md"},"- se você usa Windows, é comum a combinação entre o ",s.a.createElement("strong",null,"Google Chrome")," e o ",s.a.createElement("strong",null,"NVDA"),"."),s.a.createElement("p",{className:"txt-body-md"},"- se o seu é o iOS, uma das soluções famosas é usar o ",s.a.createElement("strong",null,"Safari")," com o ",s.a.createElement("strong",null,"VoiceOver"),"."),s.a.createElement("p",{className:"txt-body-md"},"- se você prefere Android, o ",s.a.createElement("strong",null,"Google Chrome")," funciona muito bem com o ",s.a.createElement("strong",null,"Talkback"),"."),s.a.createElement("p",{className:"txt-body-md mb-2"},"- e, ainda, o ",s.a.createElement("strong",null,"ProDeaf")," é um tradutor para Libras."),s.a.createElement("h3",{className:"txt-body-md mb-2 mt-4"},s.a.createElement("strong",{className:"color-brand-4 fontSize25 Xbold"},"Faça como a gente e fique por dentro dos seus direitos.")),s.a.createElement("p",{className:"txt-body-md"},"Lei Brasileira de Inclusão, de 2015."),s.a.createElement("p",{className:"txt-body-md"},"Decreto n. 5.296, de 02 de dezembro de 2004."),s.a.createElement("p",{className:"txt-body-md"},"Decreto n. 6.949, de 25 de agosto de 2009 – Promulga a Convenção Internacional sobre os Direitos das Pessoas com Deficiência e seu Protocolo Facultativo, assinados em Nova York, em 30 de março de 2007."),s.a.createElement("p",{className:"txt-body-md"},"Decreto n. 7.724, de 16 de maio de 2012 – Regulamenta a Lei n. 12.527, que dispõe sobre o acesso a informações."),s.a.createElement("p",{className:"txt-body-md"},"Modelo de Acessibilidade de Governo Eletrônico."),s.a.createElement("p",{className:"txt-body-md mb-2"},"Portaria n. 03, de 07 de maio de 2007 – Institucionaliza o Modelo de Acessibilidade em Governo Eletrônico – e-MAG."))))}}])&&mt(o.prototype,r),n&&mt(o,n),a}();function vt(e){return(vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function yt(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function gt(e,a){return!a||"object"!==vt(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function ht(e){return(ht=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function Et(e,a){return(Et=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var xt=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),gt(this,ht(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&Et(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white border-ui-3 radius-0 radius-md"},s.a.createElement("div",{className:"row border-bottom border-color-ui-3"},s.a.createElement("div",{className:"col-12 px-3 py-3"},s.a.createElement("h3",null,"Termos de uso"))),s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-3",role:"article"},s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"Termos de Uso")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"O catálogo de prêmios, disponível para acesso em www.webpremios.com.br ou por meio de redirecionamento diretamente do hotsite de Programas de Relacionamento, Campanhas de Incentivo e Ações (“Web Prêmios” ou “Plataforma”), é uma plataforma online que permite a você (doravante “Usuário”), participante de determinada campanha de incentivo, desenvolvida por um gestor de campanhas, contratante do Grupo LTM (“Gestor”), trocar seus pontos adquiridos em tal campanha por produtos ou serviços disponibilizados por nossas empresas parceiras (“Parceiros”), indicadas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Dessa forma, os presentes Termos de Uso (“Termos”) estipulam as regras para utilização da Plataforma pelos Usuários, e estão disponíveis para acesso, a qualquer momento, por meio do link"," ",s.a.createElement("a",{href:"/terms",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/terms")),"."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Aplicam-se aos presentes Termos, ainda, o quanto disposto na Política de Privacidade, disponível para acesso em"," ",s.a.createElement("a",{href:"/privacy",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/privacy")),"."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Em caso de quaisquer dúvidas sobre o quanto disposto nestes Termos, o Usuário deverá entrar em contato com o Grupo LTM por meio da página “Fale Conosco”, disponível em"," ",s.a.createElement("a",{href:"/redirect/contact",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/redirect/contact")),"."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"1. ACEITAÇÃO DESTES TERMOS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"1.1. O aceite livre, expresso e informado aos presentes Termos se dará no momento do clique do Usuário no botão “Aceito”, quando de seu primeiro acesso à Plataforma, estando a utilização condicionada à integral aceitação do quanto disposto no presente documento, sendo certo que, caso o Usuário não concorde com o quanto aqui estipulado, deverá se abster de utilizar o site."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"1.2. Exceto em caso de expressa previsão legal em sentido contrário, os presentes Termos poderão ser atualizados ou modificados a qualquer momento, a exclusivo critério do Grupo LTM, independentemente de qualquer formalidade e comunicação, cabendo ao Usuário verificar novamente o conteúdo destes Termos a cada modificação, conforme data de atualização constante ao final deste documento."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"1.3. A continuidade de utilização da Plataforma pelo Usuário implicará a irrestrita aceitação das condições fixadas, incluindo as alterações que porventura venham a ser realizadas em referidas condições."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"2. ACESSO À PLATAFORMA")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.1. O acesso à Plataforma se dará mediante login e senha de acesso, após o cadastro do Usuário no sistema."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.2. Em algumas campanhas, o acesso poderá depender de validação positiva do cadastro do Usuário, por meio da conferência das informações fornecidas pelo Gestor, tais como CPF e data de nascimento, entre outras."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.3. É possível, ainda, que o acesso do Usuário à Plataforma se dê por meio de hotsite, desenvolvido pelo Gestor da campanha. Nesta hipótese, o Usuário deve se atentar também para eventuais Termos de Serviço adicionais constantes de referida página, mantida pelo Gestor."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.4. Poderão se registrar e utilizar a Plataforma Usuários plenamente capazes, nos termos da legislação brasileira. Dessa forma, menores de 18 (dezoito) anos de idade, exceto os emancipados, nos termos do parágrafo único do artigo 5º do Código Civil Brasileiro, não poderão utilizar a Plataforma, sendo vedado seu cadastro como Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.5. Em qualquer hipótese, o Usuário se compromete a fornecer todas as informações obrigatórias solicitadas quando de seu cadastro, de forma correta e verdadeira, responsabilizando-se por qualquer informação incorreta ou inverídica inserida na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.6. Uma vez que o acesso à Plataforma é destinado apenas a participantes das campanhas desenvolvidas pelos Gestores, o Grupo LTM se reserva o direito de negar o acesso de quaisquer Usuários não vinculados a nenhuma campanha ou, a qualquer momento, excluir o acesso de tais Usuários."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"2.7. Após o cadastro, o Usuário terá acesso a quantidade pontos que possui, bem como ao catálogo de produtos e serviços dos Parceiros do Grupo LTM (“Catálogo”)."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"3. UTILIZAÇÃO DA PLATAFORMA")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.1. Ao utilizar a Plataforma, o Usuário declara e reconhece que:"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.2. Está devidamente autorizado pelo Gestor da campanha a preencher seu cadastro, acessar a Plataforma e realizar a troca de pontos por produtos ou serviços dos Parceiros;"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.3. Deverá manter sempre seu cadastro devidamente atualizado, especialmente seu endereço e informações de contato;"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.4. Não poderá inserir ou produzir na Plataforma, por qualquer meio, conteúdo ilícito, que viole direitos de terceiros ou que seja de qualquer modo contrário à moral e aos bons costumes geralmente aceitos;"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.5. É vedada a inserção na Plataforma de conteúdo que incorpore vírus ou outros elementos físicos ou eletrônicos que possam causar danos ou impedir o normal funcionamento da rede, do sistema ou de equipamentos informáticos, do Grupo LTM, ou de terceiros; e"),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.6. É vedada a inserção na Plataforma de conteúdo que provoque, por suas características (tais como forma, extensão etc.), dificuldades no normal funcionamento da Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.7. O Usuário se compromete a utilizar a Plataforma e o seu conteúdo, ou seja, os textos, imagens, fotografias, gráficos, ícones, tecnologia, links e demais conteúdos audiovisuais ou sonoros, incluindo o software da Plataforma, desenhos gráficos e códigos fonte (em conjunto, “Conteúdo(s)”), de acordo com todo o ordenamento jurídico, com a moral e os bons costumes geralmente aceitos, os presentes Termos e eventuais instruções adicionais existentes na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.8. O Usuário deverá se abster de obter, ou de tentar obter, os Conteúdos por quaisquer meios distintos daqueles que, em cada caso, tenham sido colocados à disposição para tais propósitos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"3.9. Em qualquer circunstância, o Usuário será o único responsável pelo uso que fizer da Plataforma, eximindo o Grupo LTM de qualquer responsabilidade por eventuais danos ou prejuízos decorrentes do uso indevido ou inadequado que o Usuário fizer da Plataforma."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"4. AQUISIÇÃO E TROCA DE PONTOS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.1. Os pontos serão atribuídos ao Usuário pelo Gestor da campanha, de acordo com os critérios estabelecidos pelo Gestor. O Grupo LTM apenas disponibilizará na conta do Usuário os respectivos e eventuais pontos indicados pelo Gestor, sem qualquer ingerência e responsabilidade do Grupo LTM na atribuição dos pontos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.2. Dessa forma, o Grupo LTM não será responsável, em hipótese alguma, por eventuais divergências entre as regras da campanha, estipuladas pelo Gestor, e a quantidade de pontos atribuída ao Usuário, sendo a responsabilidade por tal atribuição exclusiva do Gestor da campanha."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.3. Caso o Usuário não possua saldo de pontos suficiente para realizar o resgate do produto ou serviço desejado, incluindo o valor do frete, este poderá, em determinadas situações, adquirir pontos diretamente do Grupo LTM, apenas e tão somente para a finalidade de completar a quantidade de pontos necessária para o resgate de um determinado produto ou serviço. A aquisição dos pontos será realizada com cartão de crédito ou outro meio de pagamento disponibilizado na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.4. Para que reste autorizada a compra de pontos, o Usuário deverá possuir ao menos parte do valor do produto ou serviço que deseje adquirirem pontos. Não é possível a compra de pontos desvinculada da aquisição de um produto ou serviço, nem a compra de produtos diretamente dos Parceiros, sem a utilização de pontos. O Parceiro poderá exigir que o participante tenha um número mínimo de pontos para habilitar a função “compra de pontos”."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.5. A compra de pontos estará disponível apenas para alguns Parceiros do catálogo de prêmios, de acordo com as condições acordadas entre estes e o Grupo LTM. Caso seja possível a compra, o ícone “compra de pontos” aparecerá como disponível ao Usuário. Assim, o Usuário reconhece que, caso tal ícone não seja disponibilizado, não poderá haver a compra de pontos para a aquisição do produto ou serviço em questão."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.6. A venda de pontos é realizada exclusivamente pelo Grupo LTM, sem qualquer intervenção do Gestor da Campanha. O preço do ponto vendido no catálogo de prêmios será aquele divulgado ao Usuário no momento da compra."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.7. Não há correlação monetária entre os pontos adquiridos pelos Usuários e aqueles que são concedidos pelos Gestores das Campanhas. Assim, o Grupo LTM não se compromete a respeitar qualquer equivalência entre pontos e valores monetários eventualmente indicada pelo Gestor, sendo certo que os pontos fornecidos aos Usuários pelos Gestores das Campanhas não possuem valor monetário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.8. O Usuário poderá trocar os pontos a ele atribuídos por quaisquer produtos ou serviços oferecidos por Parceiros, disponibilizados no Catálogo, acessível por meio de sua conta de acesso."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.9. O Usuário entende e reconhece que a troca de pontos poderá ser restrita a produtos ou serviços de apenas alguns dos Parceiros indicados na Plataforma, a exclusivo critério do Gestor da Campanha. Assim, o Grupo LTM não se responsabiliza por produtos ou serviços de Parceiros que não estejam disponíveis no Catálogo apresentado ao Usuário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.10. Os pontos disponibilizados ao Usuário poderão estar sujeitos a prazo de validade, determinado pelo Gestor da campanha à qual tais pontos estão vinculados. Ainda, todos os pontos relacionados a determinada campanha expirarão, em caso de término do contrato entre o Gestor e o Grupo LTM. É de responsabilidade exclusiva do Usuário utilizar seus pontos, antes da expiração do prazo, não se responsabilizando o Grupo LTM, em hipótese alguma, caso o Usuário não os utilize, dentro do prazo máximo estipulado."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.11. Em hipótese alguma os pontos obtidos pelos Usuários poderão ser convertidos em dinheiro ou trocados por quaisquer produtos ou serviços não constantes no Catálogo disponibilizado ao Usuário quando de seu acesso."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.12. A troca dos pontos pelos produtos ou serviços constantes no Catálogo disponibilizado ao Usuário está sujeita à disponibilidade. A operação de troca por alguns produtos ou serviços poderá não ser concluída, em razão de sua indisponibilidade. A troca somente será tida como completa, após o Usuário finalizar a transação pela Plataforma e receber e-mail com tal confirmação."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.13. A disponibilidade dos produtos ou serviços depende exclusivamente dos Parceiros que os fornecem, não se responsabilizando o Grupo LTM por quaisquer produtos constantes do Catálogo não disponibilizados pelos Parceiros."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.14. O Catálogo de prêmios é atualizado periódica e automaticamente pelos Parceiros e os produtos e pontos necessários para troca poderão sofrer alterações durante a navegação dos Usuários, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate/troca dos pontos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.15. Não há correlação direta entre os preços divulgados em pontos no catálogo de prêmios e os valores indicados pelos Parceiros em seus sites direcionados aos consumidores finais, na medida em que os pontos fornecidos pelo Gestor ao Usuário não possuem valor monetário."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.16. Para utilização dos Pontos em determinados Parceiros, o Grupo LTM poderá debitar da conta de premiação dos Usuários uma taxa administrativa. A taxa administrativa padrão para resgate de vouchers é de 5,9% (cinco vírgula nove por cento) sobre o valor nominal do resgate, taxa administrativa da qual o Usuário declara desde logo ter plena ciência. A taxa administrativa para resgate nos demais Parceiros pode variar de acordo com os custos operacionais e administrativos decorrentes do resgate realizado. O preço final do produto em pontos será aquele informado ao Usuário no momento da finalização do resgate."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.17. A Plataforma poderá sugerir produtos e serviços para resgate pelos Usuários de acordo com o seu perfil de consumo, observando inclusive a suas preferências de navegação no catálogo de prêmios, como detalhado na Política de Privacidade relacionada a estes Termos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.18. Caso os pontos do Usuários estejam com prazo de expiração próximo, o Grupo LTM ou o Gestor poderão, em determinadas situações, realizar ações promocionais com resgate automático de pontos para determinados parceiros, visando que o Usuário não seja prejudicado com a expiração dos pontos. Nestas situações, o realizador da ação promocional enviará um SMS ao Usuário, indicando que realizará o resgate automático dos pontos a vencer, formalizando para qual dos Parceiros os pontos a expirar seriam transferidos e concedendo ao Usuário a possibilidade de optar pela sua não realização. O Usuário reconhece que não há obrigatoriedade na realização do resgate automático, seja pelo Grupo LTM ou pelo Gestor, sendo tal medida excepcional."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"4.19. O Usuário poderá realizar a busca inteligente de produtos e serviços por meio do filtro disponível por categoria, marcas ou saldo de pontos."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"5. ENTREGA DE PRODUTOS OU SERVIÇOS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.1. O Grupo LTM atua apenas como catálogo online, intermediador entre o Usuário e os Parceiros, que inserem diretamente seus produtos e/ou serviços na Plataforma, não comercializando, o Grupo LTM, quaisquer produtos ou serviços, nem mantendo produtos em estoque."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.2. Desta forma, a entrega dos produtos ou a prestação dos serviços selecionados pelo Usuário é de exclusiva responsabilidade do respectivo Parceiro, não se responsabilizando o Grupo LTM por quaisquer atrasos ou falhas na entrega dos produtos ou na prestação dos serviços."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.3. Eventualmente o Grupo LTM poderá adquirir vouchers de Parceiros e comercializá-los na Plataforma, realizando diretamente a entrega deles aos Usuários, hipótese em que o Usuário será informado de que tais vouchers são entregues pelo Grupo LTM."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.4. É de responsabilidade exclusiva do Usuário manter seus dados cadastrais atualizados, eximindo o Grupo LTM e seus Parceiros de qualquer responsabilidade em relação à entrega de produtos decorrentes de informações desatualizadas inseridas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.5. Caso o Usuário opte por resgatar mais de um produto do catálogo de prêmios, ainda que em Parceiros diferentes, o fechamento do resgate poderá ser finalizado no mesmo pedido, em um carrinho único. Os fretes e prazos de entrega, todavia, serão calculados por cada um dos Parceiros e serão incluídos individualmente no pedido. Assim, pedidos contendo mais de um produto poderão possuir datas de entrega diferentes, de acordo com o estipulado pelo Parceiro responsável."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.6. A função de finalização única de resgate não estará disponível para todos os pedidos, pois dependerá da disponibilidade técnica de cada um dos Parceiros."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.7. O cancelamento do pedido de um único produto incluído no carrinho não implicará cancelamento dos demais produtos ou serviços resgatados no mesmo pedido."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.8. Será disponibilizado ao Usuário, por meio do acesso ao ícone “Meus Pedidos”, o acompanhamento do status da entrega dos produtos resgatados, de acordo com as informações disponibilizadas por cada Parceiro, informações que também poderão ser enviadas aos Usuários por e-mail ou SMS."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.9. Caso a entrega do produto não possa ser realizada em razão de divergência no endereço de entrega informado pelo Usuário, o resgate poderá ser cancelado pelo Parceiro, sendo os pontos respectivos creditados novamente na conta do Usuário, respeitado o prazo de validade original dos pontos para que o Usuário possa realizar novo resgate."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.10. Nos cancelamentos de Pedidos em que o Usuário tenha adquirido pontos para realizar o resgate, estes pontos adquiridos serão creditados na sua conta de premiação para posterior utilização, em novo resgate."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.11. Caso o Usuário tenha solicitado cancelamento do pedido, em razão do atraso na entrega ou por outros motivos aplicáveis e o produto tenha sido efetivamente entregue no endereço por ele indicado, o Grupo LTM estará autorizado a debitar os pontos referentes ao produto recebido da conta de premiação do Usuário. Para que não haja o débito de pontos o Usuário deverá recusar o recebimento do pedido que pretendia ver cancelado."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"5.12. É de responsabilidade exclusiva do Usuário manter seus dados cadastrais atualizados, eximindo o Grupo LTM e seus Parceiros de qualquer responsabilidade relacionada à entrega equivocada de produtos decorrentes de informações desatualizadas inseridas na Plataforma."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"6. DURAÇÃO E FINALIZAÇÃO DO ACESSO")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"6.1. O acesso à Plataforma é concedido ao Usuário por prazo indeterminado. No entanto, o Grupo LTM está facultado a dar por terminado, suspender ou interromper unilateralmente, a qualquer momento e sem necessidade de prévio aviso, o acesso do Usuário, sem que qualquer indenização seja devia em razão disso."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"7. ISENÇÃO DE RESPONSABILIDADE")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"7.1. Além das demais hipóteses de isenção de responsabilidade previstas neste documento, o Grupo LTM não se responsabilizará:"),s.a.createElement("p",{className:"txt-body-sm mb-2 pl-1"},"1. Por quaisquer danos decorrentes da interrupção do acesso à Plataforma, ou por falhas de funcionamento;",s.a.createElement("br",null),"2. Pela defraudação da utilidade que os Usuários possam ter atribuído à Plataforma, pela falibilidade da mesma, ou por qualquer dificuldade de acesso;",s.a.createElement("br",null),"3. Pela existência de quaisquer elementos nocivos que possam produzir alterações nos sistemas informáticos dos Usuários (software e/ou hardware) ou nos documentos eletrônicos armazenados no sistema informático;",s.a.createElement("br",null),"4. Por quaisquer hyperlinks disponibilizados na Plataforma, sendo certo que não há verificação prévia do conteúdo de qualquer hyperlink disponibilizado na Plataforma e que as páginas por meio deles acessadas estão sujeitas a outros Termos de Uso e Políticas de Privacidade;",s.a.createElement("br",null),"5. Pelos danos e prejuízos de toda natureza que possam decorrer do conhecimento que terceiros não autorizados possam ter de quaisquer das informações fornecidas pelo Usuário, em decorrência de falha exclusivamente atribuível ao Usuário; e",s.a.createElement("br",null),"6. Por falhas ou informações recebidas de modo incompleto pelo Grupo LTM ou seus Parceiros, que dificultem ou impeçam a troca de pontos por produtos ou serviços;",s.a.createElement("br",null),"7. Por produtos ou serviços disponibilizados na Plataforma pelos Parceiros, devendo qualquer eventual defeito em referidos produtos ou serviços ser comunicado diretamente ao Parceiro responsável, por meio das informações de contato por ele indicadas, para adoção das respectivas providências."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"7.2. O Grupo LTM poderá, a seu exclusivo critério e sem anuência ou concordância do Usuário, alterar os serviços prestados, adicionando ou excluindo Parceiros, produtos e serviços, bem como a pontuação necessária para a troca de determinados produtos ou serviços, sem que qualquer valor ou indenização seja devido ao Usuário, em razão de tais alterações."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"8. PROPRIEDADE INTELECTUAL")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"8.1 Todos os direitos de propriedade intelectual referentes a qualquer material disponibilizado na Plataforma, tais como textos, marcas, logos, fotografias, gráficos, imagens, links, conteúdos audiovisuais ou sonoros, software, desenhos gráficos e códigos fontes, entre outros, são de titularidade do Grupo LTM ou de terceiros que autorizaram seu uso, sendo vedada sua cópia, reprodução, ou qualquer outro tipo de utilização, ficando os infratores sujeitos às sanções civis e criminais correspondentes, nos termos das Leis 9.610/98, 9.609/98 e 9.279/96."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"8.2 Todas as marcas, os nomes comerciais ou logotipos de qualquer espécie disponibilizados na Plataforma são de propriedade do Grupo LTM ou de terceiros que autorizaram seu uso, sem que o acesso ao ou utilização da Plataforma possa ser entendida como autorização para que o Usuário possa citar tais marcas, nomes comerciais e logotipos."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"9. DISPOSIÇÕES GERAIS")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"9.1 Se qualquer parte destes Termos for considerada inválida ou inexequível, essa parte deve ser interpretada de forma consistente com a lei aplicável, para refletir, na medida do possível, a intenção original das partes, e as demais disposições permanecerão em pleno vigor e efeito."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"9.2 A falha do Grupo LTM em exigir quaisquer direitos ou disposições dos presentes Termos não constituirá renúncia, podendo exercer regularmente o seu direito, dentro dos prazos legais."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"10. CONTATO")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"10.1 O Usuário poderá entrar em contato com o Grupo LTM por meio do formulário disponibilizado na página Fale Conosco, disponível para acesso em"," ",s.a.createElement("a",{href:"/redirect/contact",target:"_blank",className:"txt-body-sm"},s.a.createElement("strong",null,window.location.host,"/redirect/contact")),", bem como por meio do endereço de e-mail ou telefone divulgados na comunicação da campanha."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"10.2 O Grupo LTM poderá entrar em contato com o Usuário, e esta comunicação será considerada válida, por meio de qualquer informação de contato por ele disponibilizada quando do preenchimento de seu cadastro. Os comunicados emitidos por meio da Plataforma também serão considerados válidos."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"10.3 O Grupo LTM poderá implementar mecanismos antifraude na Plataforma, inclusive realizando contato junto ao Usuário para confirmação do pedido, por meio de ligação, SMS, e-mail ou qualquer outro programa de mensagens pela internet."),s.a.createElement("p",{className:"txt-body-sm txt-uppercase mb-1"},s.a.createElement("strong",null,"11. LEI APLICÁVEL E FORO")),s.a.createElement("p",{className:"txt-body-sm mb-2"},"11.1 Estes Termos serão regidos, interpretados e executados de acordo com as leis da República Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados ou países, sendo competente o Foro da Comarca de São Paulo, Capital, no Brasil, para dirimir qualquer dúvida decorrente deste instrumento. O Usuário consente, expressamente, com a competência desse juízo, e renuncia, neste ato, à competência de qualquer outro foro, por mais privilegiado que seja ou venha a ser."),s.a.createElement("p",{className:"txt-body-sm mb-2"},"Última atualização: 04.05.2017")))}}])&&yt(o.prototype,r),n&&yt(o,n),a}();function Nt(e){return(Nt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Pt(e,a){for(var o=0;o<a.length;o++){var t=a[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}function qt(e,a){return!a||"object"!==Nt(a)&&"function"!=typeof a?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):a}function Ot(e){return(Ot=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function wt(e,a){return(wt=Object.setPrototypeOf||function(e,a){return e.__proto__=a,e})(e,a)}var St=function(e){function a(){return function(e,a){if(!(e instanceof a))throw new TypeError("Cannot call a class as a function")}(this,a),qt(this,Ot(a).apply(this,arguments))}var o,r,n;return function(e,a){if("function"!=typeof a&&null!==a)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(a&&a.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),a&&wt(e,a)}(a,t["Component"]),o=a,(r=[{key:"render",value:function(){return s.a.createElement("div",{className:"col-12 bg-white border-ui-3 radius-0 radius-md"},s.a.createElement("div",{className:"row border-bottom border-color-ui-3"},s.a.createElement("div",{className:"col-12 px-3 py-3"},s.a.createElement("h3",null,"TERMOS DE USO"))),s.a.createElement("div",{className:"col-12 px-2 px-md-3 py-3",role:"article"},s.a.createElement("p",{className:"txt-body mb-2"},"O Itaú Unibanco S.A. e suas Afiliadas (“Itaú Unibanco”) têm como propósito contribuir para que as pessoas e as empresas possam realizar sonhos e investir em grandes ideias. Tudo sempre feito de forma transparente, ética e responsável."),s.a.createElement("p",{className:"txt-body mb-2"},"Assim, apresentamos os nossos Termos de Uso em linguagem simples, clara e objetiva, para que os nossos Usuários compreendam facilmente as condições para uso dos nossos Sites e Aplicativos e a forma como coletamos e usamos suas informações."),s.a.createElement("p",{className:"txt-body mb-2"},"Se tiver dúvidas, entre em contato conosco pelos nossos canais de atendimento."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"Termos de Uso")),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"1. DISPOSIÇÕES GERAIS")),s.a.createElement("p",{className:"txt-body mb-2"},"1.1. Iupp é uma plataforma de fidelidade que visa conceder benefícios que reconheçam o valor de seus clientes. A Plataforma permite que seus Participantes acumulem pontos (“Pontos iupp”), troquem por recompensas e tenham acesso a benefícios e descontos."),s.a.createElement("p",{className:"txt-body mb-2"},"1.2. Este Regulamento tem por finalidade estabelecer as regras e condições as quais se sujeitam os Participantes desta plataforma de fidelidade do Itaú (“Plataforma”) administrada pelo Banco Itaucard S.A., inscrito no CNPJ/MF sob o nº 17.192.451/0001-70."),s.a.createElement("p",{className:"txt-body mb-2"},"1.3. Ao se cadastrar na Plataforma o Participante dá ciência e concorda com o inteiro teor deste Regulamento e com a Política de Privacidade da Plataforma, estando sujeito à todas as regras aqui previstas."),s.a.createElement("p",{className:"txt-body mb-2"},"1.4. Ao se cadastrar na Plataforma o Participante também terá acesso ao Shopping iupp, loja virtual na qual o Participante poderá adquirir produtos e serviços dos parceiros credenciados da Plataforma e acumular pontos iupp."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"2. ADESÃO DOS PARTICIPANTES")),s.a.createElement("p",{className:"txt-body mb-2"},"2.1. Toda pessoa física portadora de CPF, capaz, que se cadastrar através do site www.iupp.com.br ou por quaisquer outros canais disponibilizados pela Plataforma poderá se tornar Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"2.2. Para se cadastrar, o Participante deverá inserir todas as informações solicitadas de forma correta. A veracidade dos dados é de responsabilidade do próprio Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"2.3. O cadastro será vinculado ao CPF do cliente e será necessária a definição de uma senha de acesso à Plataforma e outra para a Central de Relacionamento."),s.a.createElement("p",{className:"txt-body mb-2"},"2.4. As informações da conta iupp e senhas de acesso são de uso pessoal, intransferível e de responsabilidade do próprio Participante, não devendo ele compartilhá-las ou divulgá-las por qualquer meio."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"3. ACÚMULO")),s.a.createElement("p",{className:"txt-body mb-2"},"3.1. Os Participantes poderão acumular Pontos iupp pelos seguintes meios:"),s.a.createElement("p",{className:"txt-body mb-2"},"(i) Adesão, contratação, compra ou uso de determinados produtos ou serviços dos parceiros da Plataforma – conforme termos e condições descritos em regulamento específico, disponíveis no site www.iupp.com.br– tais como: utilização dos cartões de crédito vinculados à Plataforma, compras no Shopping iupp, entre outros;"),s.a.createElement("p",{className:"txt-body mb-2"},"(ii) Participação em atividades ou campanhas de incentivo, promoções da Plataforma e/ou de seus parceiros conforme termos e condições descritos em regulamentos específicos, disponíveis no site www.iupp.com.br;"),s.a.createElement("p",{className:"txt-body mb-2"},"(iii) Compra de pontos diretamente na Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"3.2. A Plataforma se reserva no direito de disponibilizar outras formas de acúmulo que não as mencionadas no presente Regulamento, as quais terão suas regras próprias que serão disponibilizadas aos Participantes através de quaisquer canais de comunicação da Plataforma com o Participante e aplicativo iupp."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"4. SHOPPING iupp")),s.a.createElement("p",{className:"txt-body mb-2"},"4.1. O Participante poderá adquirir produtos e/ou serviços dos parceiros iupp através dos meios de pagamento disponíveis no momento da compra e o Participante poderá acumular pontos por compras realizadas no Shopping iupp, que terá suas regras próprias as quais serão disponibilizadas aos Participantes através de quaisquer canais de comunicação da Plataforma com o Participante e aplicativo iupp."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"5. C0MPRA DE PONTOS")),s.a.createElement("p",{className:"txt-body mb-2"},"5.1. Os Participantes poderão comprar Pontos iupp através dos canais disponíveis da Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"5.2. A Plataforma se reserva no direito de alterar a qualquer momento e sem prévia comunicação ao Participante o preço dos Pontos iupp e limites de quantidade de compra, devendo o Participante verificar as informações disponibilizadas no momento da compra."),s.a.createElement("p",{className:"txt-body mb-2"},"5.3. Os Pontos iupp adquiridos serão disponibilizados na conta iupp do Participante logo após a confirmação de pagamento."),s.a.createElement("p",{className:"txt-body mb-2"},"5.4. Os Participantes poderão solicitar o cancelamento da compra dos pontos através dos canais disponíveis em até 7 (sete) dias corridos contados do recebimento dos pontos, desde que nenhum dos pontos adquiridos tenham sido utilizados."),s.a.createElement("p",{className:"txt-body mb-2"},"5.5. Os Pontos iupp adquiridos através da compra de pontos não expiram."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"6. RESGATE DE PONTOS")),s.a.createElement("p",{className:"txt-body mb-2"},"6.1. Os Participantes poderão usar seus Pontos iupp para adquirir benefícios e recompensas que estiverem disponíveis na Plataforma iupp através dos seguintes canais: (i) Site www.iupp.com.br;"),s.a.createElement("p",{className:"txt-body mb-2"},"(ii) Outros canais próprios que poderão ser consultados no Site."),s.a.createElement("p",{className:"txt-body mb-2"},"a) A disponibilidade, valor, formas de entrega, formas de pagamento, valor do frete e demais características das recompensas poderão ser consultadas no catálogo disponível nos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"b) O prazo para a entrega do produto/serviço resgatado pode variar de acordo com o fornecedor e natureza da recompensa e o Participante deve sempre consultar o prazo de entrega no momento do resgate."),s.a.createElement("p",{className:"txt-body mb-2"},"c) O Participante poderá realizar o resgate dos produtos/serviços na Plataforma utilizando seus pontos, podendo também complementar o pagamento utilizando os meios de pagamento disponíveis."),s.a.createElement("p",{className:"txt-body mb-2"},"d) Para utilizar seus pontos, o Participante deve acessar os canais iupp, inserir os dados de login e senha, escolher a recompensa desejada, informar corretamente os dados solicitados, e confirmar o resgate."),s.a.createElement("p",{className:"txt-body mb-2"},"6.2. A inclusão de itens no carrinho de compras não garante a sua disponibilidade, que pode estar sujeita à disponibilidade do estoque."),s.a.createElement("p",{className:"txt-body mb-2"},"6.3. O status de cada pedido poderá ser verificado através dos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"6.4. Ao realizar um resgate, o Participante autoriza que suas informações cadastrais (como CPF, nome, e-mail, telefone e endereço completos) sejam divulgados ao Parceiro do resgate, para que este providencie a reserva, cadastramento e/ou entrega da recompensa."),s.a.createElement("p",{className:"txt-body mb-2"},"6.5. O Participante autoriza que eventual Parceiro responsável pela entrega da recompensa resgatada na Plataforma entre em contato através dos seus dados fornecidos a fim de confirmar detalhes da entrega dos produtos, se necessário."),s.a.createElement("p",{className:"txt-body mb-2"},"6.6. O Participante é o responsável por: (i) garantir a veracidade de todas as informações fornecidas; e (ii) definir o beneficiário do resgate caso a natureza da recompensa permita que o beneficiário seja alguém que não o próprio Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"6.7. Caso não seja possível entregar o produto em razão de mudança de endereço não informada, endereço não localizado ou ausência de responsável maior do que 18 anos no momento da entrega, o resgate será cancelado e os Pontos iupp e valores pagos serão devolvidos ao Participante, excluídos os custos de logística da entrega, se houver."),s.a.createElement("p",{className:"txt-body mb-2"},"6.8. Caso o produto seja entregue em outro local que não o desejado por conta de erro no fornecimento de informações pelo Participante, este perderá o direito ao produto, os Pontos iupp e eventuais valores pagos não serão devolvidos."),s.a.createElement("p",{className:"txt-body mb-2"},"6.9. A responsabilidade pela qualidade, garantia, especificações técnicas e durabilidade dos produtos e serviços escolhidos no resgate é exclusiva dos Parceiros que os prestarem ou fornecerem."),s.a.createElement("p",{className:"txt-body mb-2"},"6.10. Havendo indisponibilidade em estoque ou extravio do produto resgatado, o resgate será cancelado e os Pontos iupp e eventuais valores serão devolvidos. Neste caso, a Plataforma iupp se responsabiliza por comunicar o Participante sobre o eventual cancelamento. O status do pedido também poderá ser consultado através dos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"6.11. No caso de resgate de Pontos iupp para doações, a Plataforma não confere nenhuma garantia de que este poderá ser utilizado para abatimento de Imposto de Renda e nem de quaisquer outros tributos devidos pelo Participante."),s.a.createElement("p",{className:"txt-body mb-2"},"6.12. A Plataforma não se responsabiliza por transações não finalizadas em razão de falhas de comunicação de dados ou quaisquer outros problemas relacionados a provedores e servidores de Internet."),s.a.createElement("p",{className:"txt-body mb-2"},"6.13. Os pontos utilizados no momento do resgate serão sempre aqueles mais próximos da data de expiração."),s.a.createElement("p",{className:"txt-body mb-2"},"6.14. O resgate dos pontos na Plataforma é um direito pessoal e intransferível do Participante, que não deverá ceder ou transferir seus pontos à terceiros."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"7. CANCELAMENTO DE RESGATES COM PONTOS DO CATÁLOGO DE RECOMPENSAS iupp")),s.a.createElement("p",{className:"txt-body mb-2"},"7.1. O Participante poderá solicitar o cancelamento por arrependimento dos produtos físicos resgatados em até 7 (sete) dias corridos após o recebimento do produto, através da Central de Relacionamento iupp, devendo manter a embalagem e o produto em perfeito estado para sua devolução. Nesta situação, o resgate será cancelado e os Pontos iupp e eventuais valores pagos serão devolvidos."),s.a.createElement("p",{className:"txt-body mb-2"},"7.2. Uma vez constatado que o produto entregue contém qualquer vício ou defeito, ou que não se trata do produto solicitado, o Participante deverá formular reclamação à Plataforma através da Central de Relacionamento de acordo com os prazos previstos pelo Código de Defesa do Consumidor, devendo manter a embalagem e o produto em perfeito estado para sua devolução."),s.a.createElement("p",{className:"txt-body mb-2"},"7.3. Ao solicitar resgates dos Pontos iupp para milhas ou programas parceiros, ou por recompensas entregues de forma digital/por e-mail, o Participante poderá solicitar, por motivo de desistência, erro ou divergência, o cancelamento ou troca em até 7 (sete) dias corridos após a data de solicitação do resgate, através dos canais iupp, desde que não tenha utilizado a recompensa. Ao transferir seus Pontos iupp para programas parceiros, o Participante estará sujeito às regras do programa de destino."),s.a.createElement("p",{className:"txt-body mb-2"},"7.4. As regras descritas neste item não se aplicam ao resgate de passagens aéreas, hotéis e pacotes de viagens, cujas regras de alteração e cancelamento estão sujeitas às normas das próprias empresas parceiras e devem ser verificadas no momento do resgate ou nos canais das companhias."),s.a.createElement("p",{className:"txt-body mb-2"},"7.5. Toda solicitação de cancelamento de resgate passa por uma análise a fim de que seja verificado se o cancelamento solicitado se encontra dentro das regras descritas neste Regulamento e previstas no Código de Defesa do Consumidor."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"8. TRATAMENTO DAS INFORMAÇÕES DOS PARTICIPANTES")),s.a.createElement("p",{className:"txt-body mb-2"},"8.1. Ao se inscrever na Plataforma e aderir a este Regulamento, o Participante expressamente concorda com a Política de Privacidade da Plataforma iupp, que dispõe sobre a coleta, tratamento e eventual compartilhamento dos dados dos Participantes com parceiros, a qual está disponível para consulta no site www.iupp.com.br."),s.a.createElement("p",{className:"txt-body mb-2"},"8.2. O Banco Itaucard S.A., gestor da Plataforma, e demais empresas do Conglomerado Itaú (“Itaú”) tratam dados pessoais de pessoas físicas (como clientes, representantes e sócios/acionistas de clientes pessoa jurídica) para diversas finalidades relacionadas ao desempenho de suas atividades."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3. Nesse item resumimos as principais informações sobre como coletamos e usamos dados pessoais. Para maiores informações, inclusive sobre os seus direitos em relação aos seus dados pessoais (como de correção, acesso aos dados e informações sobre o tratamento, eliminação, bloqueio, exclusão, oposição e portabilidade de dados pessoais), acesse a nossa Política de Privacidade nos canais iupp."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.1. Dados coletados: Os dados pessoais coletados e tratados pelo Itaú podem incluir dados cadastrais, financeiros, transacionais ou outros dados, que podem ser fornecidos diretamente por você ou obtidos em decorrência da prestação de serviços ou fornecimento de produtos pelo Itaú a você ou a você relacionados, bem como obtidos de outras fontes conforme permitido na legislação aplicável, tais como fontes públicas, empresas do Conglomerado Itaú, outras instituições dos sistema financeiro, parceiros ou fornecedores, bem como, empresas e órgãos com os quais o Conglomerado Itaú tenha alguma relação contratual e com os quais você possua vínculo."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.2. Finalidades de uso dos dados: Poderemos usar os dados pessoais para diversas finalidades relacionadas ao desempenho de nossas atividades, na forma prevista na Política de Privacidade, como por exemplo: (i) oferta, divulgação, prestação de serviços e fornecimento de produtos; (ii) execução de contrato e de etapas prévias ao contrato, incluindo a avaliação dos produtos e serviços mais adequados ao seu perfil, bem como atividades de crédito, financeiras, de investimento, cobrança e demais atividades do Conglomerado Itaú; (iii) cumprimento de obrigações legais e regulatórias; (iv) atendimento de requisições de autoridades administrativas e judiciais; (v) exercício regular de direitos, inclusive em processos administrativos, judiciais e arbitrais; (vi) análise, gerenciamento e tratamento de potenciais riscos, incluindo os de crédito, fraude e segurança; (vii) verificação da sua identidade e dados pessoais, inclusive dados biométricos, para fins de autenticação, segurança e/ou prevenção à fraude; (viii) verificação, análise e tratamento de dados pessoais para fins de avaliação, manutenção e aprimoramento dos nossos serviços; (ix) hipóteses de legítimo interesse, como desenvolvimento e ofertas de produtos e serviços do Conglomerado Itaú."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.3. Dados biométricos: Poderemos utilizar sua biometria facial e/ou digital em produtos e/ou serviços das empresas do Conglomerado Itaú para processos de identificação e/ou autenticação em sistemas eletrônicos próprios ou de terceiros para fins de segurança e prevenção a fraudes."),s.a.createElement("p",{className:"txt-body mb-2"},"8.3.4. Compartilhamento dos dados: Os seus dados pessoais poderão ser compartilhados para as finalidades previstas neste documento e na nossa Política de Privacidade, como, por exemplo, entre as empresas do Conglomerado Itaú, com prestadores de serviços e fornecedores localizados no Brasil ou no exterior, bureaus de crédito de acordo com as regras aplicáveis à atividade, órgãos reguladores e entidades públicas, inclusive administrativas e judiciais, e ainda, com parceiros estratégicos para possibilitar a oferta"),s.a.createElement("p",{className:"txt-body mb-2"},"de produtos e serviços. Apenas compartilhamos dados na medida necessária, com segurança e de acordo com a legislação aplicável."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"9. VALIDADE DOS PONTOS iupp")),s.a.createElement("p",{className:"txt-body mb-2"},"9.1. A validade dos Pontos iupp se dará conforme termos e condições descritos em regulamento específico de cada forma de acúmulo ou canal de transferência, disponível no site www.iupp.com.br."),s.a.createElement("p",{className:"txt-body mb-2"},"9.2. Pontos iupp acumulados através da compra de pontos não expiram, conforme definido na Cláusula 6.5 deste Regulamento."),s.a.createElement("p",{className:"txt-body mb-2"},"9.3. Pontos iupp acumulados através de compras no Shopping iupp tem a validade de 24 meses, a partir da data em que forem creditados na conta iupp do Participante, exceto quando acumulados em razão de campanhas promocionais com regras próprias."),s.a.createElement("p",{className:"txt-body mb-2"},"9.4. A Plataforma poderá realizar campanhas promocionais de concessão de Pontos iupp cuja validade será determinada pela regra própria da referida campanha e disponibilizada ao Participante em regulamento próprio."),s.a.createElement("p",{className:"txt-body mb-2"},s.a.createElement("strong",null,"10. DISPOSIÇÕES FINAIS")),s.a.createElement("p",{className:"txt-body mb-2"},"10.1 A Plataforma se reserva o direito de, a seu critério e a qualquer tempo, (i) alterar os parceiros de resgate participantes da Plataforma, as próprias recompensas e a pontuação necessária para cada resgate, cabendo ao Participante consultar as recompensas e condições vigentes no momento do resgate; (ii) modificar as regras da Plataforma mediante o envio de comunicação com 15 dias de antecedência aos Participantes (iii) encerrar ou cancelar a Plataforma mediante comunicação com 30 dias de antecedência aos Participantes; (iv) encerrar o relacionamento com um Participante iupp, de forma unilateral, com comunicação prévia de 15 dias, para que o Participante utilize seus pontos, com exceção das situações descritas no item 10.3 abaixo."),s.a.createElement("p",{className:"txt-body mb-2"},"10.2 Caso a Plataforma seja encerrada, o Participante será comunicado com 30 dias de antecedência sobre o fim do acúmulo dos pontos. A partir da data da comunicação, o Participante terá 60 dias para realizar resgates dos pontos acumulados na Plataforma. Após este prazo, todos os pontos serão cancelados juntamente com a Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"10.3. Os Pontos iupp serão automaticamente cancelados na ocorrência das seguintes hipóteses: (i) falecimento do Participante; (ii) solicitação de saída da Plataforma pelo Participante; (iii) identificação de fraude e (iv) caso a Plataforma constate não ser verdadeira qualquer informação que o Participante tenha fornecido."),s.a.createElement("p",{className:"txt-body mb-2"},"10.4. O Participante é o responsável por respeitar todas as disposições deste Regulamento a eles aplicáveis, sob pena de perder o direito à recompensa ou aos Pontos iupp, ou ser excluído da Plataforma."),s.a.createElement("p",{className:"txt-body mb-2"},"10.5. As seguintes situações não afetarão as condições previstas neste Regulamento, tampouco o direito da Plataforma de exigi-las, a qualquer tempo: (i) a omissão da Plataforma em requerer execução de qualquer obrigação do Regulamento; (ii) a tolerância para o descumprimento de qualquer obrigação do Regulamento."),s.a.createElement("p",{className:"txt-body mb-2"},"10.6. Na hipótese de qualquer disposição ou termo deste Regulamento ser considerado inexequível, inválido ou ilegal, em juízo ou por árbitro competente, os demais termos e condições permanecem exequíveis e válidos."),s.a.createElement("p",{className:"txt-body mb-2"},"Atualização: Junho de 2020")))}}])&&Pt(o.prototype,r),n&&Pt(o,n),a}();function Ct(){return(Ct=Object.assign||function(e){for(var a=1;a<arguments.length;a++){var o=arguments[a];for(var t in o)Object.prototype.hasOwnProperty.call(o,t)&&(e[t]=o[t])}return e}).apply(this,arguments)}var zt=function(e){var a=e.name,o=e.isValid;return s.a.createElement("div",{className:"col-12 mt-1"},s.a.createElement("div",{className:"row align-items-center h-100"},s.a.createElement("div",{className:"col-auto px-0 dot radius-circle ".concat(o?"bg-success":"bg-ui-3")}),s.a.createElement("div",{className:"col"},s.a.createElement("p",{className:"txt-subtitle"},a))))};zt.propTypes={name:n.a.string.isRequired,isValid:n.a.bool.isRequired};var Tt=function(e){return e.rules.map(function(e,a){return s.a.createElement(zt,Ct({key:a},e))})};function kt(){return(kt=Object.assign||function(e){for(var a=1;a<arguments.length;a++){var o=arguments[a];for(var t in o)Object.prototype.hasOwnProperty.call(o,t)&&(e[t]=o[t])}return e}).apply(this,arguments)}var At=function(e,a){return e.isValid===a.isValid?0:e.isValid?-1:1},jt=function(e){var a=e.isValid;return s.a.createElement("div",{className:"col pt-half radius mr-1 mb-1 ".concat(a?"bg-success":"bg-ui-3")})};jt.propTypes={isValid:n.a.bool.isRequired};var Ut=function(e){return e.rules.sort(At).map(function(e,a){return s.a.createElement(jt,kt({key:a},e))})};function _t(e){return function(e){if(Array.isArray(e)){for(var a=0,o=new Array(e.length);a<e.length;a++)o[a]=e[a];return o}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var It=function(e){var a=e.rules,o=void 0===a?[{name:"contém letras minúsculas",regex:/[a-z]+/},{name:"contém letras maiúsculas",regex:/[A-Z]+/},{name:"contém números",regex:/\d/},{name:"contém 8 caracteres ou mais",regex:/^.{8,}$/}]:a,t=e.password;return o=function(e){return function(a){return Object.values(e).map(function(e){var o=e.name,t=e.regex;return{name:o,isValid:!!a.match(t)}})}}(o)(t),s.a.createElement("div",{className:"row mx-0"},s.a.createElement("div",{className:"col-12 mb-1 px-0 mt-2"},s.a.createElement("p",{className:"txt-body-sm"},s.a.createElement("strong",null,"veja o que sua senha precisa conter:"))),s.a.createElement(Ut,{rules:_t(o)}),s.a.createElement(Tt,{rules:_t(o)}))};It.propTypes={rules:n.a.array,password:n.a.string};var Lt=It;o.d(a,"Card",function(){return C}),o.d(a,"CardBenefits",function(){return L}),o.d(a,"CardBenefitsMobile",function(){return V}),o.d(a,"CardSearchMobile",function(){return Y}),o.d(a,"CardBenefitsSpecial",function(){return se}),o.d(a,"CardBenefitsSpecialMobile",function(){return me}),o.d(a,"CardBenefitsTop",function(){return ge}),o.d(a,"CardBenefitsTopMobile",function(){return Oe}),o.d(a,"CardTimer",function(){return Ce}),o.d(a,"CardPlaceholder",function(){return Te}),o.d(a,"CardSearchMobilePlaceholder",function(){return Ae}),o.d(a,"CardStore",function(){return Me}),o.d(a,"CardStoreMobile",function(){return He}),o.d(a,"Select",function(){return aa}),o.d(a,"Input",function(){return da}),o.d(a,"RadioButton",function(){return ya}),o.d(a,"Button",function(){return m}),o.d(a,"Icon",function(){return l}),o.d(a,"Color",function(){return qa}),o.d(a,"Size",function(){return ka}),o.d(a,"Spinner",function(){return Da}),o.d(a,"Checkbox",function(){return Ka}),o.d(a,"Sticky",function(){return Ya}),o.d(a,"TextArea",function(){return no}),o.d(a,"Modal",function(){return Eo}),o.d(a,"Alert",function(){return bo}),o.d(a,"ModalHalf",function(){return So}),o.d(a,"Tooltip",function(){return Uo}),o.d(a,"FingerPrint",function(){return Mo}),o.d(a,"RegulationDefaultComponent",function(){return Ko}),o.d(a,"RegulationIuppComponent",function(){return Yo}),o.d(a,"PrivacyDefaultComponent",function(){return tt}),o.d(a,"PrivacyIuppComponent",function(){return lt}),o.d(a,"AccessibilityIuppComponent",function(){return ft}),o.d(a,"TermsDefaultComponent",function(){return xt}),o.d(a,"TermsIuppComponent",function(){return St}),o.d(a,"PasswordStrength",function(){return Lt})}]));

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(63);
var hide = __webpack_require__(49);
var redefine = __webpack_require__(50);
var ctx = __webpack_require__(64);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory(__webpack_require__(0)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.react);
}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_6__) {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 5);
    }([ function(module, exports, __webpack_require__) {
        var ReactIs = __webpack_require__(1);
        module.exports = __webpack_require__(8)(ReactIs.isElement, !0);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = __webpack_require__(7);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function toHyphenLower(match) {
            return "-" + match.toLowerCase();
        }
        function hyphenateStyleName(name) {
            if (cache.hasOwnProperty(name)) return cache[name];
            var hName = name.replace(uppercasePattern, toHyphenLower);
            return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
        }
        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
        __webpack_exports__.a = hyphenateStyleName;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }))), ownKeys.forEach(function(key) {
                    _defineProperty(target, key, source[key]);
                });
            }
            return target;
        }
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([ __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number ]), matchers = {
            orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "portrait", "landscape" ]),
            scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "progressive", "interlace" ]),
            aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            height: stringOrNumber,
            deviceHeight: stringOrNumber,
            width: stringOrNumber,
            deviceWidth: stringOrNumber,
            color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            resolution: stringOrNumber
        }, features = _objectSpread({
            minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            minHeight: stringOrNumber,
            maxHeight: stringOrNumber,
            minDeviceHeight: stringOrNumber,
            maxDeviceHeight: stringOrNumber,
            minWidth: stringOrNumber,
            maxWidth: stringOrNumber,
            minDeviceWidth: stringOrNumber,
            maxDeviceWidth: stringOrNumber,
            minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minResolution: stringOrNumber,
            maxResolution: stringOrNumber
        }, matchers), types = {
            all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
        }, all = _objectSpread({}, types, features);
        matchers.type = Object.keys(types), __webpack_exports__.a = {
            all: all,
            types: types,
            matchers: matchers,
            features: features
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function _typeof(obj) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            })(obj);
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), 
            Constructor;
        }
        function _possibleConstructorReturn(self, call) {
            return !call || "object" !== _typeof(call) && "function" != typeof call ? _assertThisInitialized(self) : call;
        }
        function _getPrototypeOf(o) {
            return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            })(o);
        }
        function _assertThisInitialized(self) {
            if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self;
        }
        function _inherits(subClass, superClass) {
            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: !0,
                    configurable: !0
                }
            }), superClass && _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
            return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                return o.__proto__ = p, o;
            })(o, p);
        }
        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }))), ownKeys.forEach(function(key) {
                    _defineProperty(target, key, source[key]);
                });
            }
            return target;
        }
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: !0
        }), __webpack_require__.d(__webpack_exports__, "default", function() {
            return MediaQuery;
        });
        var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery__ = __webpack_require__(11), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_4__mediaQuery__ = __webpack_require__(4), __WEBPACK_IMPORTED_MODULE_5__toQuery__ = __webpack_require__(13);
        __webpack_require__.d(__webpack_exports__, "toQuery", function() {
            return __WEBPACK_IMPORTED_MODULE_5__toQuery__.a;
        });
        var defaultTypes = {
            component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
            query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__mediaQuery__.a.matchers),
            children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([ __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func ]),
            onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
        }, excludedQueryKeys = Object.keys(defaultTypes), omit = function(object, keys) {
            var newObject = _objectSpread({}, object);
            return keys.forEach(function(key) {
                return delete newObject[key];
            }), newObject;
        }, getValues = function(_ref) {
            var values = _ref.values;
            if (!values) return null;
            var keys = Object.keys(values);
            return 0 === keys.length ? null : keys.reduce(function(result, key) {
                return result[Object(__WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__.a)(key)] = values[key], 
                result;
            }, {});
        }, getQuery = function(props) {
            return props.query || Object(__WEBPACK_IMPORTED_MODULE_5__toQuery__.a)(omit(props, excludedQueryKeys));
        }, MediaQuery = function(_React$Component) {
            function MediaQuery() {
                var _getPrototypeOf2, _this;
                _classCallCheck(this, MediaQuery);
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                return _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MediaQuery)).call.apply(_getPrototypeOf2, [ this ].concat(args))), 
                _defineProperty(_assertThisInitialized(_this), "state", {
                    matches: !1,
                    mq: null,
                    query: "",
                    values: null
                }), _defineProperty(_assertThisInitialized(_this), "componentDidMount", function() {
                    _this.state.mq.addListener(_this.updateMatches), _this.updateMatches();
                }), _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function(prevProps, prevState) {
                    _this.state.mq !== prevState.mq && (_this.cleanupMediaQuery(prevState.mq), _this.state.mq.addListener(_this.updateMatches)), 
                    _this.props.onChange && prevState.matches !== _this.state.matches && _this.props.onChange(_this.state.matches);
                }), _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function() {
                    _this._unmounted = !0, _this.cleanupMediaQuery(_this.state.mq);
                }), _defineProperty(_assertThisInitialized(_this), "cleanupMediaQuery", function(mq) {
                    mq && (mq.removeListener(_this.updateMatches), mq.dispose());
                }), _defineProperty(_assertThisInitialized(_this), "updateMatches", function() {
                    _this._unmounted || _this.state.mq.matches !== _this.state.matches && _this.setState({
                        matches: _this.state.mq.matches
                    });
                }), _defineProperty(_assertThisInitialized(_this), "render", function() {
                    return "function" == typeof _this.props.children ? _this.props.children(_this.state.matches) : _this.state.matches ? _this.props.children : null;
                }), _this;
            }
            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, null, [ {
                key: "getDerivedStateFromProps",
                value: function(props, state) {
                    var query = getQuery(props);
                    if (!query) throw new Error("Invalid or missing MediaQuery!");
                    var values = getValues(props);
                    if (query === state.query && values === state.values) return null;
                    var mq = __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default()(query, values || {}, !!values);
                    return {
                        matches: mq.matches,
                        mq: mq,
                        query: query,
                        values: values
                    };
                }
            } ]), MediaQuery;
        }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
        _defineProperty(MediaQuery, "displayName", "MediaQuery"), _defineProperty(MediaQuery, "defaultProps", {
            values: null
        });
    }, function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        !function() {
            function isValidElementType(type) {
                return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
            }
            function typeOf(object) {
                if ("object" == typeof object && null !== object) {
                    var $$typeof = object.$$typeof;
                    switch ($$typeof) {
                      case REACT_ELEMENT_TYPE:
                        var type = object.type;
                        switch (type) {
                          case REACT_ASYNC_MODE_TYPE:
                          case REACT_CONCURRENT_MODE_TYPE:
                          case REACT_FRAGMENT_TYPE:
                          case REACT_PROFILER_TYPE:
                          case REACT_STRICT_MODE_TYPE:
                          case REACT_SUSPENSE_TYPE:
                            return type;

                          default:
                            var $$typeofType = type && type.$$typeof;
                            switch ($$typeofType) {
                              case REACT_CONTEXT_TYPE:
                              case REACT_FORWARD_REF_TYPE:
                              case REACT_PROVIDER_TYPE:
                                return $$typeofType;

                              default:
                                return $$typeof;
                            }
                        }

                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PORTAL_TYPE:
                        return $$typeof;
                    }
                }
            }
            function isAsyncMode(object) {
                return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, 
                lowPriorityWarning$1(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), 
                isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
                return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
            var hasSymbol = "function" == typeof Symbol && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, lowPriorityWarning = function() {}, printWarning = function(format) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
                var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
                    return args[argIndex++];
                });
                "undefined" != typeof console && console.warn(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            };
            lowPriorityWarning = function(condition, format) {
                if (void 0 === format) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
                if (!condition) {
                    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
                    printWarning.apply(void 0, [ format ].concat(args));
                }
            };
            var lowPriorityWarning$1 = lowPriorityWarning, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
            exports.typeOf = typeOf, exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, 
            exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, 
            exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, 
            exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, 
            exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isValidElementType = isValidElementType, 
            exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, 
            exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, 
            exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, 
            exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, 
            exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense;
        }();
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function emptyFunctionThatReturnsNull() {
            return null;
        }
        var ReactIs = __webpack_require__(1), assign = __webpack_require__(9), ReactPropTypesSecret = __webpack_require__(2), checkPropTypes = __webpack_require__(10), has = Function.call.bind(Object.prototype.hasOwnProperty), printWarning = function() {};
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, module.exports = function(isValidElement, throwOnDirectAccess) {
            function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if ("function" == typeof iteratorFn) return iteratorFn;
            }
            function is(x, y) {
                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
            }
            function PropTypeError(message) {
                this.message = message, this.stack = "";
            }
            function createChainableTypeChecker(validate) {
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
                    secret !== ReactPropTypesSecret) {
                        if (throwOnDirectAccess) {
                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            throw err.name = "Invariant Violation", err;
                        }
                        if ("undefined" != typeof console) {
                            var cacheKey = componentName + ":" + propName;
                            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), 
                            manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
                        }
                    }
                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
                }
                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
            }
            function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
                    }
                    for (var i = 0; i < propValue.length; i++) {
                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!(props[propName] instanceof expectedClass)) {
                        var expectedClassName = expectedClass.name || ANONYMOUS;
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createEnumTypeChecker(expectedValues) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
                    var valuesString = JSON.stringify(expectedValues, function(key, value) {
                        return "symbol" === getPreciseType(value) ? String(value) : value;
                    });
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
                }
                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), 
                emptyFunctionThatReturnsNull);
            }
            function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
                    for (var key in propValue) if (has(propValue, key)) {
                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createUnionTypeChecker(arrayOfTypeCheckers) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
                    }
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
                }
                if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), 
                emptyFunctionThatReturnsNull;
                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                    var checker = arrayOfTypeCheckers[i];
                    if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), 
                    emptyFunctionThatReturnsNull;
                }
                return createChainableTypeChecker(validate);
            }
            function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    for (var key in shapeTypes) {
                        var checker = shapeTypes[key];
                        if (checker) {
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    var allKeys = assign({}, props[propName], shapeTypes);
                    for (var key in allKeys) {
                        var checker = shapeTypes[key];
                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function isNode(propValue) {
                switch (typeof propValue) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;

                  case "boolean":
                    return !propValue;

                  case "object":
                    if (Array.isArray(propValue)) return propValue.every(isNode);
                    if (null === propValue || isValidElement(propValue)) return !0;
                    var iteratorFn = getIteratorFn(propValue);
                    if (!iteratorFn) return !1;
                    var step, iterator = iteratorFn.call(propValue);
                    if (iteratorFn !== propValue.entries) {
                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
                    } else for (;!(step = iterator.next()).done; ) {
                        var entry = step.value;
                        if (entry && !isNode(entry[1])) return !1;
                    }
                    return !0;

                  default:
                    return !1;
                }
            }
            function isSymbol(propType, propValue) {
                return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
            }
            function getPropType(propValue) {
                var propType = typeof propValue;
                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
            }
            function getPreciseType(propValue) {
                if (void 0 === propValue || null === propValue) return "" + propValue;
                var propType = getPropType(propValue);
                if ("object" === propType) {
                    if (propValue instanceof Date) return "date";
                    if (propValue instanceof RegExp) return "regexp";
                }
                return propType;
            }
            function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch (type) {
                  case "array":
                  case "object":
                    return "an " + type;

                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + type;

                  default:
                    return type;
                }
            }
            function getClassName(propValue) {
                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
            }
            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
                array: createPrimitiveTypeChecker("array"),
                bool: createPrimitiveTypeChecker("boolean"),
                func: createPrimitiveTypeChecker("function"),
                number: createPrimitiveTypeChecker("number"),
                object: createPrimitiveTypeChecker("object"),
                string: createPrimitiveTypeChecker("string"),
                symbol: createPrimitiveTypeChecker("symbol"),
                any: function() {
                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                }(),
                arrayOf: createArrayOfTypeChecker,
                element: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                elementType: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!ReactIs.isValidElementType(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                instanceOf: createInstanceTypeChecker,
                node: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
                    }
                    return createChainableTypeChecker(validate);
                }(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
            };
            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
            ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, 
            ReactPropTypes;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function toObject(val) {
            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/
        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module.exports = function() {
            try {
                if (!Object.assign) return !1;
                var test1 = new String("abc");
                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                }).join("")) return !1;
                var test3 = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
            } catch (err) {
                return !1;
            }
        }() ? Object.assign : function(target, source) {
            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
                from = Object(arguments[s]);
                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
                }
            }
            return to;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
            for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
                var error;
                try {
                    if ("function" != typeof typeSpecs[typeSpecName]) {
                        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                        throw err.name = "Invariant Violation", err;
                    }
                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                    error = ex;
                }
                if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), 
                error instanceof Error && !(error.message in loggedTypeFailures)) {
                    loggedTypeFailures[error.message] = !0;
                    var stack = getStack ? getStack() : "";
                    printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
                }
            }
        }
        var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(2), loggedTypeFailures = {}, has = Function.call.bind(Object.prototype.hasOwnProperty);
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, checkPropTypes.resetWarningCache = function() {
            loggedTypeFailures = {};
        }, module.exports = checkPropTypes;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function Mql(query, values, forceStatic) {
            function addListener(listener) {
                mql && mql.addListener(listener);
            }
            function removeListener(listener) {
                mql && mql.removeListener(listener);
            }
            function update(evt) {
                self.matches = evt.matches, self.media = evt.media;
            }
            function dispose() {
                mql && mql.removeListener(update);
            }
            var self = this;
            if (dynamicMatch && !forceStatic) {
                var mql = dynamicMatch.call(window, query);
                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
            } else this.matches = staticMatch(query, values), this.media = query;
            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
        }
        function matchMedia(query, values, forceStatic) {
            return new Mql(query, values, forceStatic);
        }
        var staticMatch = __webpack_require__(12).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
        module.exports = matchMedia;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function matchQuery(mediaQuery, values) {
            return parseQuery(mediaQuery).some(function(query) {
                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
                var expressionsMatch = query.expressions.every(function(expression) {
                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                    if (!value) return !1;
                    switch (feature) {
                      case "orientation":
                      case "scan":
                        return value.toLowerCase() === expValue.toLowerCase();

                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        expValue = toPx(expValue), value = toPx(value);
                        break;

                      case "resolution":
                        expValue = toDpi(expValue), value = toDpi(value);
                        break;

                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case "device-pixel-ratio":
                        expValue = toDecimal(expValue), value = toDecimal(value);
                        break;

                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
                    }
                    switch (modifier) {
                      case "min":
                        return value >= expValue;

                      case "max":
                        return value <= expValue;

                      default:
                        return value === expValue;
                    }
                });
                return expressionsMatch && !inverse || !expressionsMatch && inverse;
            });
        }
        function parseQuery(mediaQuery) {
            return mediaQuery.split(",").map(function(query) {
                query = query.trim();
                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                    return {
                        modifier: feature[1],
                        feature: feature[2],
                        value: captures[2]
                    };
                }), parsed;
            });
        }
        function toDecimal(ratio) {
            var numbers, decimal = Number(ratio);
            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
            decimal;
        }
        function toDpi(resolution) {
            var value = parseFloat(resolution);
            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
              case "dpcm":
                return value / 2.54;

              case "dppx":
                return 96 * value;

              default:
                return value;
            }
        }
        function toPx(length) {
            var value = parseFloat(length);
            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
              case "em":
              case "rem":
                return 16 * value;

              case "cm":
                return 96 * value / 2.54;

              case "mm":
                return 96 * value / 2.54 / 10;

              case "in":
                return 96 * value;

              case "pt":
                return 72 * value;

              case "pc":
                return 72 * value / 12;

              default:
                return value;
            }
        }
        exports.match = matchQuery, exports.parse = parseQuery;
        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function keyVal(k, v) {
            var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
            return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? k : !1 === v ? negate(k) : "(".concat(realKey, ": ").concat(v, ")");
        }
        function join(conds) {
            return conds.join(" and ");
        }
        var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(4), negate = function(cond) {
            return "not ".concat(cond);
        };
        __webpack_exports__.a = function(obj) {
            var rules = [];
            return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
                var v = obj[k];
                null != v && rules.push(keyVal(k, v));
            }), join(rules);
        };
    } ]);
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ReactPlaceholder_1 = __webpack_require__(928);
exports["default"] = ReactPlaceholder_1["default"];


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.27.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.27.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * The main AWS namespace
 */
var AWS = { util: __webpack_require__(31) };

/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */
var _hidden = {}; _hidden.toString(); // hack to parse macro

/**
 * @api private
 */
module.exports = AWS;

AWS.util.update(AWS, {

  /**
   * @constant
   */
  VERSION: '2.518.0',

  /**
   * @api private
   */
  Signers: {},

  /**
   * @api private
   */
  Protocol: {
    Json: __webpack_require__(278),
    Query: __webpack_require__(494),
    Rest: __webpack_require__(199),
    RestJson: __webpack_require__(496),
    RestXml: __webpack_require__(497)
  },

  /**
   * @api private
   */
  XML: {
    Builder: __webpack_require__(1113),
    Parser: null // conditionally set based on environment
  },

  /**
   * @api private
   */
  JSON: {
    Builder: __webpack_require__(279),
    Parser: __webpack_require__(280)
  },

  /**
   * @api private
   */
  Model: {
    Api: __webpack_require__(498),
    Operation: __webpack_require__(499),
    Shape: __webpack_require__(150),
    Paginator: __webpack_require__(500),
    ResourceWaiter: __webpack_require__(501)
  },

  /**
   * @api private
   */
  apiLoader: __webpack_require__(1118),

  /**
   * @api private
   */
  EndpointCache: __webpack_require__(1119).EndpointCache
});
__webpack_require__(502);
__webpack_require__(1121);
__webpack_require__(1124);
__webpack_require__(505);
__webpack_require__(1125);
__webpack_require__(1130);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1141);

/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */
AWS.events = new AWS.SequentialExecutor();

//create endpoint cache lazily
AWS.util.memoizedProperty(AWS, 'endpointCache', function() {
  return new AWS.EndpointCache(AWS.config.endpointCacheSize);
}, true);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var lenient = __webpack_require__(772);

var yn = function yn(input, options) {
	input = String(input).trim();

	options = Object.assign({
		lenient: false,
		default: null
	}, options);

	if (options.default !== null && typeof options.default !== 'boolean') {
		throw new TypeError('Expected the `default` option to be of type `boolean`, got `' + _typeof(options.default) + '`');
	}

	if (/^(?:y|yes|true|1)$/i.test(input)) {
		return true;
	}

	if (/^(?:n|no|false|0)$/i.test(input)) {
		return false;
	}

	if (options.lenient === true) {
		return lenient(input, options);
	}

	return options.default;
};

module.exports = yn;
// TODO: Remove this for the next major release
module.exports.default = yn;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(23)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(972);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(378);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(973);

var _HelmetConstants = __webpack_require__(456);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrencyLabel__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CurrencyLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CatalogCurrencyLabel__ = __webpack_require__(955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CatalogCurrencyLabel__["a"]; });


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.createMatchSelector = exports.getAction = exports.getLocation = exports.routerMiddleware = exports.connectRouter = exports.ConnectedRouter = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.LOCATION_CHANGE = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createAll = __webpack_require__(744);

var _createAll2 = _interopRequireDefault(_createAll);

var _plain = __webpack_require__(755);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _get__2 = _get__('createAll')(_get__('plainStructure'));

var LOCATION_CHANGE = _get__2.LOCATION_CHANGE,
    CALL_HISTORY_METHOD = _get__2.CALL_HISTORY_METHOD,
    push = _get__2.push,
    replace = _get__2.replace,
    go = _get__2.go,
    goBack = _get__2.goBack,
    goForward = _get__2.goForward,
    routerActions = _get__2.routerActions,
    ConnectedRouter = _get__2.ConnectedRouter,
    connectRouter = _get__2.connectRouter,
    routerMiddleware = _get__2.routerMiddleware,
    getLocation = _get__2.getLocation,
    getAction = _get__2.getAction,
    createMatchSelector = _get__2.createMatchSelector;
exports.LOCATION_CHANGE = LOCATION_CHANGE;
exports.CALL_HISTORY_METHOD = CALL_HISTORY_METHOD;
exports.push = push;
exports.replace = replace;
exports.go = go;
exports.goBack = goBack;
exports.goForward = goForward;
exports.routerActions = routerActions;
exports.ConnectedRouter = ConnectedRouter;
exports.connectRouter = connectRouter;
exports.routerMiddleware = routerMiddleware;
exports.getLocation = getLocation;
exports.getAction = getAction;
exports.createMatchSelector = createMatchSelector;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'createAll':
      return _createAll2.default;

    case 'plainStructure':
      return _plain2.default;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports.default = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(786)
var ieee754 = __webpack_require__(787)
var isArray = __webpack_require__(387)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var cloudloyaltyUrl="https://api.ltm.digital";var trackingUrl="https://ltmtrackingprdapi.azurewebsites.net/";var subscriptionKey="4c8e61c3270c44bb8d274d090a2a97c5";var urlReplaceV1=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_CLOUD_LOYALTY_URL_REPLACE_V1;var urlReplaceV2=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_CLOUD_LOYALTY_URL_REPLACE_V2;var refererApi="prod";var onboardingUrl=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PARTICIPANT_ONBOARDING_ENDPOINT;var composeURL=function composeURL(_ref){var url=_ref.url,_ref$remoteSuffix=_ref.remoteSuffix,remoteSuffix=_ref$remoteSuffix===undefined?'':_ref$remoteSuffix,_ref$localSuffix=_ref.localSuffix,localSuffix=_ref$localSuffix===undefined?'':_ref$localSuffix;return url&&url+'/'+(url.indexOf('localhost')>-1?localSuffix:remoteSuffix);};var replaceVersion=function replaceVersion(url,version,newVersion){if(!url)return url;var urlSplitted=url.split('/');if(urlSplitted[0]===version){urlSplitted[0]=newVersion;}else if(urlSplitted[1]===version){urlSplitted[1]=newVersion;}return urlSplitted.join('/');};var tracking={client:__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:composeURL({url:trackingUrl}),responseType:'json'}),options:{interceptors:{request:[function(_ref2,req){var getState=_ref2.getState;var _getState=getState(),accessToken=_getState.oidc.user.access_token;req.headers=Object.assign({},req.headers,{Authorization:'Bearer '+accessToken,'Ocp-Apim-Subscription-Key':subscriptionKey,'Referer-Api':refererApi});return req;}]}}};var mileageApi={client:__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:composeURL({url:cloudloyaltyUrl}),responseType:'json'}),options:{interceptors:{request:[function(_ref3,req){var getState=_ref3.getState;var _getState2=getState(),accessToken=_getState2.oidc.user.access_token;req.headers=Object.assign({},req.headers,{Authorization:'Bearer '+accessToken,'Ocp-Apim-Subscription-Key':subscriptionKey,'Referer-Api':refererApi});return req;}]}}};var cloudloyalty={client:__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:composeURL({url:cloudloyaltyUrl,remoteSuffix:'cloudloyalty'}),responseType:'json',headers:{'Ocp-Apim-Subscription-Key':subscriptionKey,'Referer-Api':refererApi}}),options:{interceptors:{request:[function(_ref4,req){var getState=_ref4.getState;// TODO: descobrir porque algumas requisições são feitas sem nenhum endpoint
if(!req.url){return false;}if(urlReplaceV1){req.url=replaceVersion(req.url,'v1',urlReplaceV1);}if(urlReplaceV2){req.url=replaceVersion(req.url,'v2',urlReplaceV2);}if(getState().oidc.user){var _getState3=getState(),accessToken=_getState3.oidc.user.access_token;req.headers=Object.assign({},req.headers,{Authorization:'Bearer '+accessToken});}return req;}],response:[function(_ref5,res){var getState=_ref5.getState;if(res.request.responseURL.indexOf('identifier=voucher')>-1){var products=res.data.products;var productsOrder=['9426b85b56bc4d9db8c5','6585e4d3c3884defbfb3','bb576f69dc414070a7e0','73159f17916d4c918141'];productsOrder.map(function(p){var found=products.find(function(x){return x.sku===p;});if(found&&found!==-1){products.unshift(found);}});var newProducts=[];products.map(function(item){var i=newProducts.findIndex(function(x){return x.sku===item.sku;});if(i===-1){newProducts.push(Object.assign({},item));}});res.data.products=newProducts;}return res;}]}}};var onboardingApi={client:__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:composeURL({url:onboardingUrl}),responseType:'json'}),options:{interceptors:{request:[function(_ref6,req){var getState=_ref6.getState;var _getState4=getState(),accessToken=_getState4.oidc.user.access_token;req.headers=Object.assign({},req.headers,{Authorization:'Bearer '+accessToken,ProjectId:Buffer.from("70885").toString('base64')});req.headers=Object.assign({},req.headers,{'Ocp-Apim-Subscription-Key':"4c8e61c3270c44bb8d274d090a2a97c5"});return req;}]}}};var solr={client:__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:'https://solr.dev.ltm.grupoltm.com.br:8984/solr/products',responseType:'json'})};/* harmony default export */ __webpack_exports__["a"] = ({tracking:tracking,mileageApi:mileageApi,cloudloyalty:cloudloyalty,onboardingApi:onboardingApi,solr:solr});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(23).Buffer))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(168)('wks');
var uid = __webpack_require__(106);
var Symbol = __webpack_require__(16).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(1439);
/* unused harmony namespace reexport */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(298);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "c", function () {
  return __WEBPACK_IMPORTED_MODULE_1__error__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(127);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "q", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["a"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "r", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["b"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "s", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["d"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "t", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["e"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "u", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["f"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "v", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["g"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "y", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["h"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "z", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["i"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "A", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["k"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "B", function () {
  return __WEBPACK_IMPORTED_MODULE_2__is__["m"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(299);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "C", function () {
  return __WEBPACK_IMPORTED_MODULE_3__logger__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(161);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "e", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["a"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "f", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["b"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "h", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["c"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "i", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["d"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "l", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["e"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "m", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["f"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "n", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["g"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "o", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["h"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "p", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["i"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "x", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["j"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "F", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["k"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "G", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["l"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "K", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["m"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "N", function () {
  return __WEBPACK_IMPORTED_MODULE_5__misc__["n"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(578);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "j", function () {
  return __WEBPACK_IMPORTED_MODULE_6__object__["a"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "k", function () {
  return __WEBPACK_IMPORTED_MODULE_6__object__["b"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "D", function () {
  return __WEBPACK_IMPORTED_MODULE_6__object__["c"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "E", function () {
  return __WEBPACK_IMPORTED_MODULE_6__object__["d"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "M", function () {
  return __WEBPACK_IMPORTED_MODULE_6__object__["e"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(1441);
/* unused harmony namespace reexport */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(1442);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(579);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "w", function () {
  return __WEBPACK_IMPORTED_MODULE_9__string__["a"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "H", function () {
  return __WEBPACK_IMPORTED_MODULE_9__string__["b"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "L", function () {
  return __WEBPACK_IMPORTED_MODULE_9__string__["c"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(581);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "I", function () {
  return __WEBPACK_IMPORTED_MODULE_10__supports__["a"];
});
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "J", function () {
  return __WEBPACK_IMPORTED_MODULE_10__supports__["d"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(580);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "d", function () {
  return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_12__instrument__ = __webpack_require__(1443);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "g", function () {
  return __WEBPACK_IMPORTED_MODULE_12__instrument__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_13__dsn__ = __webpack_require__(1444);
/* harmony namespace reexport (by used) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return __WEBPACK_IMPORTED_MODULE_13__dsn__["a"];
});

//# sourceMappingURL=index.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(66);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
var AWS;

/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */
var util = {
  environment: 'nodejs',
  engine: function engine() {
    if (util.isBrowser() && typeof navigator !== 'undefined') {
      return navigator.userAgent;
    } else {
      var engine = process.platform + '/' + process.version;
      if (Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).AWS_EXECUTION_ENV) {
        engine += ' exec-env/' + Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).AWS_EXECUTION_ENV;
      }
      return engine;
    }
  },

  userAgent: function userAgent() {
    var name = util.environment;
    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(13).VERSION;
    if (name === 'nodejs') agent += ' ' + util.engine();
    return agent;
  },

  uriEscape: function uriEscape(string) {
    var output = encodeURIComponent(string);
    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[*]/g, function(ch) {
      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
    });

    return output;
  },

  uriEscapePath: function uriEscapePath(string) {
    var parts = [];
    util.arrayEach(string.split('/'), function (part) {
      parts.push(util.uriEscape(part));
    });
    return parts.join('/');
  },

  urlParse: function urlParse(url) {
    return util.url.parse(url);
  },

  urlFormat: function urlFormat(url) {
    return util.url.format(url);
  },

  queryStringParse: function queryStringParse(qs) {
    return util.querystring.parse(qs);
  },

  queryParamsToString: function queryParamsToString(params) {
    var items = [];
    var escape = util.uriEscape;
    var sortedKeys = Object.keys(params).sort();

    util.arrayEach(sortedKeys, function(name) {
      var value = params[name];
      var ename = escape(name);
      var result = ename + '=';
      if (Array.isArray(value)) {
        var vals = [];
        util.arrayEach(value, function(item) { vals.push(escape(item)); });
        result = ename + '=' + vals.sort().join('&' + ename + '=');
      } else if (value !== undefined && value !== null) {
        result = ename + '=' + escape(value);
      }
      items.push(result);
    });

    return items.join('&');
  },

  readFileSync: function readFileSync(path) {
    if (util.isBrowser()) return null;
    return __webpack_require__(283).readFileSync(path, 'utf-8');
  },

  base64: {
    encode: function encode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 encode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      var buf = util.buffer.toBuffer(string);
      return buf.toString('base64');
    },

    decode: function decode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 decode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      return util.buffer.toBuffer(string, 'base64');
    }

  },

  buffer: {
    /**
     * Buffer constructor for Node buffer and buffer pollyfill
     */
    toBuffer: function(data, encoding) {
      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ?
        util.Buffer.from(data, encoding) : new util.Buffer(data, encoding);
    },

    alloc: function(size, fill, encoding) {
      if (typeof size !== 'number') {
        throw new Error('size passed to alloc must be a number.');
      }
      if (typeof util.Buffer.alloc === 'function') {
        return util.Buffer.alloc(size, fill, encoding);
      } else {
        var buf = new util.Buffer(size);
        if (fill !== undefined && typeof buf.fill === 'function') {
          buf.fill(fill, undefined, undefined, encoding);
        }
        return buf;
      }
    },

    toStream: function toStream(buffer) {
      if (!util.Buffer.isBuffer(buffer)) buffer =  util.buffer.toBuffer(buffer);

      var readable = new (util.stream.Readable)();
      var pos = 0;
      readable._read = function(size) {
        if (pos >= buffer.length) return readable.push(null);

        var end = pos + size;
        if (end > buffer.length) end = buffer.length;
        readable.push(buffer.slice(pos, end));
        pos = end;
      };

      return readable;
    },

    /**
     * Concatenates a list of Buffer objects.
     */
    concat: function(buffers) {
      var length = 0,
          offset = 0,
          buffer = null, i;

      for (i = 0; i < buffers.length; i++) {
        length += buffers[i].length;
      }

      buffer = util.buffer.alloc(length);

      for (i = 0; i < buffers.length; i++) {
        buffers[i].copy(buffer, offset);
        offset += buffers[i].length;
      }

      return buffer;
    }
  },

  string: {
    byteLength: function byteLength(string) {
      if (string === null || string === undefined) return 0;
      if (typeof string === 'string') string = util.buffer.toBuffer(string);

      if (typeof string.byteLength === 'number') {
        return string.byteLength;
      } else if (typeof string.length === 'number') {
        return string.length;
      } else if (typeof string.size === 'number') {
        return string.size;
      } else if (typeof string.path === 'string') {
        return __webpack_require__(283).lstatSync(string.path).size;
      } else {
        throw util.error(new Error('Cannot determine length of ' + string),
          { object: string });
      }
    },

    upperFirst: function upperFirst(string) {
      return string[0].toUpperCase() + string.substr(1);
    },

    lowerFirst: function lowerFirst(string) {
      return string[0].toLowerCase() + string.substr(1);
    }
  },

  ini: {
    parse: function string(ini) {
      var currentSection, map = {};
      util.arrayEach(ini.split(/\r?\n/), function(line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
      });

      return map;
    }
  },

  fn: {
    noop: function() {},
    callback: function (err) { if (err) throw err; },

    /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */
    makeAsync: function makeAsync(fn, expectedArgs) {
      if (expectedArgs && expectedArgs <= fn.length) {
        return fn;
      }

      return function() {
        var args = Array.prototype.slice.call(arguments, 0);
        var callback = args.pop();
        var result = fn.apply(null, args);
        callback(result);
      };
    }
  },

  /**
   * Date and time utility functions.
   */
  date: {

    /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */
    getDate: function getDate() {
      if (!AWS) AWS = __webpack_require__(13);
      if (AWS.config.systemClockOffset) { // use offset when non-zero
        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
      } else {
        return new Date();
      }
    },

    /**
     * @return [String] the date in ISO-8601 format
     */
    iso8601: function iso8601(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
    },

    /**
     * @return [String] the date in RFC 822 format
     */
    rfc822: function rfc822(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toUTCString();
    },

    /**
     * @return [Integer] the UNIX timestamp value for the current time
     */
    unixTimestamp: function unixTimestamp(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.getTime() / 1000;
    },

    /**
     * @param [String,number,Date] date
     * @return [Date]
     */
    from: function format(date) {
      if (typeof date === 'number') {
        return new Date(date * 1000); // unix timestamp
      } else {
        return new Date(date);
      }
    },

    /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */
    format: function format(date, formatter) {
      if (!formatter) formatter = 'iso8601';
      return util.date[formatter](util.date.from(date));
    },

    parseTimestamp: function parseTimestamp(value) {
      if (typeof value === 'number') { // unix timestamp (number)
        return new Date(value * 1000);
      } else if (value.match(/^\d+$/)) { // unix timestamp
        return new Date(value * 1000);
      } else if (value.match(/^\d{4}/)) { // iso8601
        return new Date(value);
      } else if (value.match(/^\w{3},/)) { // rfc822
        return new Date(value);
      } else {
        throw util.error(
          new Error('unhandled timestamp format: ' + value),
          {code: 'TimestampParserError'});
      }
    }

  },

  crypto: {
    crc32Table: [
     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
     0x2D02EF8D],

    crc32: function crc32(data) {
      var tbl = util.crypto.crc32Table;
      var crc = 0 ^ -1;

      if (typeof data === 'string') {
        data = util.buffer.toBuffer(data);
      }

      for (var i = 0; i < data.length; i++) {
        var code = data.readUInt8(i);
        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
      }
      return (crc ^ -1) >>> 0;
    },

    hmac: function hmac(key, string, digest, fn) {
      if (!digest) digest = 'binary';
      if (digest === 'buffer') { digest = undefined; }
      if (!fn) fn = 'sha256';
      if (typeof string === 'string') string = util.buffer.toBuffer(string);
      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
    },

    md5: function md5(data, digest, callback) {
      return util.crypto.hash('md5', data, digest, callback);
    },

    sha256: function sha256(data, digest, callback) {
      return util.crypto.hash('sha256', data, digest, callback);
    },

    hash: function(algorithm, data, digest, callback) {
      var hash = util.crypto.createHash(algorithm);
      if (!digest) { digest = 'binary'; }
      if (digest === 'buffer') { digest = undefined; }
      if (typeof data === 'string') data = util.buffer.toBuffer(data);
      var sliceFn = util.arraySliceFn(data);
      var isBuffer = util.Buffer.isBuffer(data);
      //Identifying objects with an ArrayBuffer as buffers
      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

      if (callback && typeof data === 'object' &&
          typeof data.on === 'function' && !isBuffer) {
        data.on('data', function(chunk) { hash.update(chunk); });
        data.on('error', function(err) { callback(err); });
        data.on('end', function() { callback(null, hash.digest(digest)); });
      } else if (callback && sliceFn && !isBuffer &&
                 typeof FileReader !== 'undefined') {
        // this might be a File/Blob
        var index = 0, size = 1024 * 512;
        var reader = new FileReader();
        reader.onerror = function() {
          callback(new Error('Failed to read data.'));
        };
        reader.onload = function() {
          var buf = new util.Buffer(new Uint8Array(reader.result));
          hash.update(buf);
          index += buf.length;
          reader._continueReading();
        };
        reader._continueReading = function() {
          if (index >= data.size) {
            callback(null, hash.digest(digest));
            return;
          }

          var back = index + size;
          if (back > data.size) back = data.size;
          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
        };

        reader._continueReading();
      } else {
        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
          data = new util.Buffer(new Uint8Array(data));
        }
        var out = hash.update(data).digest(digest);
        if (callback) callback(null, out);
        return out;
      }
    },

    toHex: function toHex(data) {
      var out = [];
      for (var i = 0; i < data.length; i++) {
        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
      }
      return out.join('');
    },

    createHash: function createHash(algorithm) {
      return util.crypto.lib.createHash(algorithm);
    }

  },

  /** @!ignore */

  /* Abort constant */
  abort: {},

  each: function each(object, iterFunction) {
    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        var ret = iterFunction.call(this, key, object[key]);
        if (ret === util.abort) break;
      }
    }
  },

  arrayEach: function arrayEach(array, iterFunction) {
    for (var idx in array) {
      if (Object.prototype.hasOwnProperty.call(array, idx)) {
        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
        if (ret === util.abort) break;
      }
    }
  },

  update: function update(obj1, obj2) {
    util.each(obj2, function iterator(key, item) {
      obj1[key] = item;
    });
    return obj1;
  },

  merge: function merge(obj1, obj2) {
    return util.update(util.copy(obj1), obj2);
  },

  copy: function copy(object) {
    if (object === null || object === undefined) return object;
    var dupe = {};
    // jshint forin:false
    for (var key in object) {
      dupe[key] = object[key];
    }
    return dupe;
  },

  isEmpty: function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  },

  arraySliceFn: function arraySliceFn(obj) {
    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
    return typeof fn === 'function' ? fn : null;
  },

  isType: function isType(obj, type) {
    // handle cross-"frame" objects
    if (typeof type === 'function') type = util.typeName(type);
    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
  },

  typeName: function typeName(type) {
    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
    var str = type.toString();
    var match = str.match(/^\s*function (.+)\(/);
    return match ? match[1] : str;
  },

  error: function error(err, options) {
    var originalError = null;
    if (typeof err.message === 'string' && err.message !== '') {
      if (typeof options === 'string' || (options && options.message)) {
        originalError = util.copy(err);
        originalError.message = err.message;
      }
    }
    err.message = err.message || null;

    if (typeof options === 'string') {
      err.message = options;
    } else if (typeof options === 'object' && options !== null) {
      util.update(err, options);
      if (options.message)
        err.message = options.message;
      if (options.code || options.name)
        err.code = options.code || options.name;
      if (options.stack)
        err.stack = options.stack;
    }

    if (typeof Object.defineProperty === 'function') {
      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
      Object.defineProperty(err, 'message', {enumerable: true});
    }

    err.name = options && options.name || err.name || err.code || 'Error';
    err.time = new Date();

    if (originalError) err.originalError = originalError;

    return err;
  },

  /**
   * @api private
   */
  inherit: function inherit(klass, features) {
    var newObject = null;
    if (features === undefined) {
      features = klass;
      klass = Object;
      newObject = {};
    } else {
      var ctor = function ConstructorWrapper() {};
      ctor.prototype = klass.prototype;
      newObject = new ctor();
    }

    // constructor not supplied, create pass-through ctor
    if (features.constructor === Object) {
      features.constructor = function() {
        if (klass !== Object) {
          return klass.apply(this, arguments);
        }
      };
    }

    features.constructor.prototype = newObject;
    util.update(features.constructor.prototype, features);
    features.constructor.__super__ = klass;
    return features.constructor;
  },

  /**
   * @api private
   */
  mixin: function mixin() {
    var klass = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      // jshint forin:false
      for (var prop in arguments[i].prototype) {
        var fn = arguments[i].prototype[prop];
        if (prop !== 'constructor') {
          klass.prototype[prop] = fn;
        }
      }
    }
    return klass;
  },

  /**
   * @api private
   */
  hideProperties: function hideProperties(obj, props) {
    if (typeof Object.defineProperty !== 'function') return;

    util.arrayEach(props, function (key) {
      Object.defineProperty(obj, key, {
        enumerable: false, writable: true, configurable: true });
    });
  },

  /**
   * @api private
   */
  property: function property(obj, name, value, enumerable, isValue) {
    var opts = {
      configurable: true,
      enumerable: enumerable !== undefined ? enumerable : true
    };
    if (typeof value === 'function' && !isValue) {
      opts.get = value;
    }
    else {
      opts.value = value; opts.writable = true;
    }

    Object.defineProperty(obj, name, opts);
  },

  /**
   * @api private
   */
  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
    var cachedValue = null;

    // build enumerable attribute for each value with lazy accessor.
    util.property(obj, name, function() {
      if (cachedValue === null) {
        cachedValue = get();
      }
      return cachedValue;
    }, enumerable);
  },

  /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */
  hoistPayloadMember: function hoistPayloadMember(resp) {
    var req = resp.request;
    var operationName = req.operation;
    var operation = req.service.api.operations[operationName];
    var output = operation.output;
    if (output.payload && !operation.hasEventOutput) {
      var payloadMember = output.members[output.payload];
      var responsePayload = resp.data[output.payload];
      if (payloadMember.type === 'structure') {
        util.each(responsePayload, function(key, value) {
          util.property(resp.data, key, value, false);
        });
      }
    }
  },

  /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */
  computeSha256: function computeSha256(body, done) {
    if (util.isNode()) {
      var Stream = util.stream.Stream;
      var fs = __webpack_require__(283);
      if (typeof Stream === 'function' && body instanceof Stream) {
        if (typeof body.path === 'string') { // assume file object
          var settings = {};
          if (typeof body.start === 'number') {
            settings.start = body.start;
          }
          if (typeof body.end === 'number') {
            settings.end = body.end;
          }
          body = fs.createReadStream(body.path, settings);
        } else { // TODO support other stream types
          return done(new Error('Non-file stream objects are ' +
                                'not supported with SigV4'));
        }
      }
    }

    util.crypto.sha256(body, 'hex', function(err, sha) {
      if (err) done(err);
      else done(null, sha);
    });
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(serverTime) {
    if (serverTime) {
      util.property(AWS.config, 'isClockSkewed',
        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
      return AWS.config.isClockSkewed;
    }
  },

  applyClockOffset: function applyClockOffset(serverTime) {
    if (serverTime)
      AWS.config.systemClockOffset = serverTime - new Date().getTime();
  },

  /**
   * @api private
   */
  extractRequestId: function extractRequestId(resp) {
    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
                     resp.httpResponse.headers['x-amzn-requestid'];

    if (!requestId && resp.data && resp.data.ResponseMetadata) {
      requestId = resp.data.ResponseMetadata.RequestId;
    }

    if (requestId) {
      resp.requestId = requestId;
    }

    if (resp.error) {
      resp.error.requestId = requestId;
    }
  },

  /**
   * @api private
   */
  addPromises: function addPromises(constructors, PromiseDependency) {
    var deletePromises = false;
    if (PromiseDependency === undefined && AWS && AWS.config) {
      PromiseDependency = AWS.config.getPromisesDependency();
    }
    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
      PromiseDependency = Promise;
    }
    if (typeof PromiseDependency !== 'function') deletePromises = true;
    if (!Array.isArray(constructors)) constructors = [constructors];

    for (var ind = 0; ind < constructors.length; ind++) {
      var constructor = constructors[ind];
      if (deletePromises) {
        if (constructor.deletePromisesFromClass) {
          constructor.deletePromisesFromClass();
        }
      } else if (constructor.addPromisesToClass) {
        constructor.addPromisesToClass(PromiseDependency);
      }
    }
  },

  /**
   * @api private
   */
  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
    return function promise() {
      var self = this;
      return new PromiseDependency(function(resolve, reject) {
        self[methodName](function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    };
  },

  /**
   * @api private
   */
  isDualstackAvailable: function isDualstackAvailable(service) {
    if (!service) return false;
    var metadata = __webpack_require__(1142);
    if (typeof service !== 'string') service = service.serviceIdentifier;
    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
    return !!metadata[service].dualstackAvailable;
  },

  /**
   * @api private
   */
  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
    if (!retryDelayOptions) retryDelayOptions = {};
    var customBackoff = retryDelayOptions.customBackoff || null;
    if (typeof customBackoff === 'function') {
      return customBackoff(retryCount);
    }
    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
    var delay = Math.random() * (Math.pow(2, retryCount) * base);
    return delay;
  },

  /**
   * @api private
   */
  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
    if (!options) options = {};
    var http = AWS.HttpClient.getInstance();
    var httpOptions = options.httpOptions || {};
    var retryCount = 0;

    var errCallback = function(err) {
      var maxRetries = options.maxRetries || 0;
      if (err && err.code === 'TimeoutError') err.retryable = true;
      if (err && err.retryable && retryCount < maxRetries) {
        retryCount++;
        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
        setTimeout(sendRequest, delay + (err.retryAfter || 0));
      } else {
        cb(err);
      }
    };

    var sendRequest = function() {
      var data = '';
      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
        httpResponse.on('end', function() {
          var statusCode = httpResponse.statusCode;
          if (statusCode < 300) {
            cb(null, data);
          } else {
            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
            var err = util.error(new Error(),
              { retryable: statusCode >= 500 || statusCode === 429 }
            );
            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
            errCallback(err);
          }
        });
      }, errCallback);
    };

    AWS.util.defer(sendRequest);
  },

  /**
   * @api private
   */
  uuid: {
    v4: function uuidV4() {
      return __webpack_require__(1143).v4();
    }
  },

  /**
   * @api private
   */
  convertPayloadToString: function convertPayloadToString(resp) {
    var req = resp.request;
    var operation = req.operation;
    var rules = req.service.api.operations[operation].output || {};
    if (rules.payload && resp.data[rules.payload]) {
      resp.data[rules.payload] = resp.data[rules.payload].toString();
    }
  },

  /**
   * @api private
   */
  defer: function defer(callback) {
    if (typeof process === 'object' && typeof process.nextTick === 'function') {
      process.nextTick(callback);
    } else if (typeof setImmediate === 'function') {
      setImmediate(callback);
    } else {
      setTimeout(callback, 0);
    }
  },

  /**
   * @api private
   */
  getRequestPayloadShape: function getRequestPayloadShape(req) {
    var operations = req.service.api.operations;
    if (!operations) return undefined;
    var operation = (operations || {})[req.operation];
    if (!operation || !operation.input || !operation.input.payload) return undefined;
    return operation.input.members[operation.input.payload];
  },

  getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
    var profiles = {};
    var profilesFromConfig = {};
    if (Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[util.configOptInEnv]) {
      var profilesFromConfig = iniLoader.loadFrom({
        isConfig: true,
        filename: Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[util.sharedConfigFileEnv]
      });
    }
    var profilesFromCreds = iniLoader.loadFrom({
      filename: filename ||
        (Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[util.configOptInEnv] && Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[util.sharedCredentialsFileEnv])
    });
    for (var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++) {
      profiles[profileNames[i]] = profilesFromConfig[profileNames[i]];
    }
    for (var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++) {
      profiles[profileNames[i]] = profilesFromCreds[profileNames[i]];
    }
    return profiles;
  },

  /**
   * @api private
   */
  defaultProfile: 'default',

  /**
   * @api private
   */
  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

  /**
   * @api private
   */
  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

  /**
   * @api private
   */
  sharedConfigFileEnv: 'AWS_CONFIG_FILE',

  /**
   * @api private
   */
  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
};

/**
 * @api private
 */
module.exports = util;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(247).setImmediate))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(674);
var toPrimitive = __webpack_require__(72);
var dP = Object.defineProperty;

exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(822).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["e"] = __values;
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* harmony export (immutable) */ __webpack_exports__["d"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(73);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _style = __webpack_require__(1032);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        var effect = props.effect || 'fadeInDown';
        _this.setSize(effect);
        _this.state = {
            visible: props.visible,
            style: _style2.default[effect]
        };
        return _this;
    }

    _createClass(Modal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var visible = _ref.visible,
                _ref$effect = _ref.effect,
                effect = _ref$effect === undefined ? 'fadeInDown' : _ref$effect;

            this.setState({
                visible: visible
            });
            this.setSize(effect);
            this.setStyles(effect);
        }
    }, {
        key: 'setStyles',
        value: function setStyles(effect) {
            if (this.props && this.props.styles) {
                _style2.default[effect].panel = _extends({}, _style2.default[effect].panel, this.props.styles);
            }
        }
    }, {
        key: 'setSize',
        value: function setSize(effect) {
            if (this.props && this.props.width) {
                if (this.props.width.charAt(this.props.width.length - 1) === '%') {
                    // Use Percentage
                    var width = this.props.width.slice(0, -1);
                    _style2.default[effect].panel.width = width + '%';
                } else if (this.props.width.charAt(this.props.width.length - 1) === 'x') {
                    // Use Pixels
                    var _width = this.props.width.slice(0, -2);
                    _style2.default[effect].panel.width = _width + 'px';
                } else {
                    // Defaults
                    _style2.default[effect].panel.width = this.props.width + 'px';
                }
            }
            if (this.props && this.props.height) {
                if (this.props.height.charAt(this.props.height.length - 1) === '%') {
                    // Use Percentage
                    var height = this.props.height.slice(0, -1);
                    _style2.default[effect].panel.height = height + 'vh';
                } else if (this.props.height.charAt(this.props.height.length - 1) === 'x') {
                    // Use Pixels
                    var _height = this.props.height.slice(0, -2);
                    _style2.default[effect].panel.height = _height + 'px';
                } else {
                    // Defaults
                    _style2.default[effect].panel.height = this.props.height + 'px';
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { style: this.state.visible ? this.state.style.container : this.state.style.containerHidden },
                    _react2.default.createElement(
                        'div',
                        { style: this.state.visible ? _extends({}, this.state.style.panel) : this.state.style.panelHidden },
                        this.props.children
                    ),
                    _react2.default.createElement('div', { style: this.state.visible ? this.state.style.mask : this.state.style.maskHidden, onClick: this.props.onClickAway ? this.props.onClickAway : null })
                )
            );
        }
    }]);

    return Modal;
}(_react.Component);

exports.default = Modal;

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cart__ = __webpack_require__(946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Cart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartContainer__ = __webpack_require__(974);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__CartContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(975);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__reducer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(774);


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_7__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(720);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var stripAccents = function (str) {
    var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    var fixes = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    var split = accents.split('').join('|');
    var reg = new RegExp("(" + split + ")", 'g');
    function replacement(a) {
        return fixes[accents.indexOf(a)] || '';
    }
    return str.replace(reg, replacement);
};
// *+~.()\'"!:@
// const blacklist = ['*', '+', '~', '.', '(', ')', '\\', "'", '"', '!', ':', '@'];
var harmonize = function (text, delimiter, ignoreInvalid) {
    if (ignoreInvalid === void 0) { ignoreInvalid = false; }
    var harmonized = stripAccents(text)
        .trim()
        .toLowerCase();
    if (ignoreInvalid) {
        return harmonized.replace(/\s+/g, delimiter);
    }
    return harmonized.replace(new RegExp("[^a-z0-9" + delimiter + "]+", 'g'), delimiter);
};
var slugify = function (node, options) {
    if (options === void 0) { options = { delimiter: '-', prefix: '' }; }
    if (!options.delimiter)
        options.delimiter = '-';
    if (!options.prefix)
        options.prefix = '';
    if (!node || typeof node === 'boolean') {
        return '';
    }
    var delimiter = options.delimiter, prefix = options.prefix;
    // string, number
    if (typeof node === 'string' || typeof node === 'number') {
        var harmonizedPrefix = harmonize(prefix, delimiter, true);
        var harmonizedNode = harmonize(String(node), delimiter);
        if (harmonizedPrefix) {
            return "" + harmonizedPrefix + delimiter + harmonizedNode;
        }
        return harmonizedNode;
    }
    // empty object
    if (typeof node === 'object' && Object.keys(node).length === 0) {
        return '';
    }
    // We did the check about empty object before
    // const castedNode = node as React.ReactElement<any> | React.ReactNodeArray | React.ReactPortal;
    // ReactPortal
    if ('children' in node) {
        return slugify(node.children);
    }
    // ReactNodeArray
    if (node instanceof Array) {
        return slugify(node.map(function (n) { return slugify(n, { delimiter: delimiter }); }).join(delimiter), options);
    }
    // ReactElement
    if ('type' in node)
        return slugify(node.props.children, options);
    // unhandled case
    return '';
};
exports["default"] = slugify;
//# sourceMappingURL=slugify.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return Constants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Facet__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Amplify__ = __webpack_require__(201);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWS", function() { return __WEBPACK_IMPORTED_MODULE_0__Facet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClientDevice__ = __webpack_require__(1177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClientDevice", function() { return __WEBPACK_IMPORTED_MODULE_3__ClientDevice__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleLogger", function() { return __WEBPACK_IMPORTED_MODULE_1__Logger__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return __WEBPACK_IMPORTED_MODULE_1__Logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Errors__ = __webpack_require__(1179);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "missingConfig", function() { return __WEBPACK_IMPORTED_MODULE_4__Errors__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invalidParameter", function() { return __WEBPACK_IMPORTED_MODULE_4__Errors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Hub__ = __webpack_require__(1180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return __WEBPACK_IMPORTED_MODULE_5__Hub__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__I18n__ = __webpack_require__(1181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18n", function() { return __WEBPACK_IMPORTED_MODULE_6__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JS__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "JS", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Signer__ = __webpack_require__(1183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Signer", function() { return __WEBPACK_IMPORTED_MODULE_8__Signer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Parser__ = __webpack_require__(1184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return __WEBPACK_IMPORTED_MODULE_9__Parser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OAuthHelper__ = __webpack_require__(511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FacebookOAuth", function() { return __WEBPACK_IMPORTED_MODULE_10__OAuthHelper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GoogleOAuth", function() { return __WEBPACK_IMPORTED_MODULE_10__OAuthHelper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RNComponents__ = __webpack_require__(1187);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Linking", function() { return __WEBPACK_IMPORTED_MODULE_11__RNComponents__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AppState", function() { return __WEBPACK_IMPORTED_MODULE_11__RNComponents__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AsyncStorage", function() { return __WEBPACK_IMPORTED_MODULE_11__RNComponents__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Credentials__ = __webpack_require__(1188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Credentials", function() { return __WEBPACK_IMPORTED_MODULE_12__Credentials__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ServiceWorker__ = __webpack_require__(1189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ServiceWorker", function() { return __WEBPACK_IMPORTED_MODULE_13__ServiceWorker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StorageHelper__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StorageHelper", function() { return __WEBPACK_IMPORTED_MODULE_14__StorageHelper__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryStorage", function() { return __WEBPACK_IMPORTED_MODULE_14__StorageHelper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Platform__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Platform", function() { return __WEBPACK_IMPORTED_MODULE_15__Platform__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



















var Constants = {
    userAgent: __WEBPACK_IMPORTED_MODULE_15__Platform__["a" /* default */].userAgent,
};
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2__Amplify__["a" /* default */]);
var logger = new __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* ConsoleLogger */]('Core');
if (__WEBPACK_IMPORTED_MODULE_0__Facet__["a" /* AWS */]['util']) {
    __WEBPACK_IMPORTED_MODULE_0__Facet__["a" /* AWS */]['util'].userAgent = function () {
        return Constants.userAgent;
    };
}
else if (__WEBPACK_IMPORTED_MODULE_0__Facet__["a" /* AWS */].config) {
    __WEBPACK_IMPORTED_MODULE_0__Facet__["a" /* AWS */].config.update({ customUserAgent: Constants.userAgent });
}
else {
    logger.warn('No AWS.config');
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(436);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConsoleLogger__ = __webpack_require__(1176);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConsoleLogger__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var createDesc = __webpack_require__(105);
module.exports = __webpack_require__(29) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var hide = __webpack_require__(49);
var has = __webpack_require__(56);
var SRC = __webpack_require__(106)('src');
var $toString = __webpack_require__(2082);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(63).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var fails = __webpack_require__(19);
var defined = __webpack_require__(73);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(33);
var minAssert = __webpack_require__(52);
var minUtils = __webpack_require__(411);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(428);
var isBuffer = __webpack_require__(869);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _filterInvalidDomProps = __webpack_require__(893);

var _filterInvalidDomProps2 = _interopRequireDefault(_filterInvalidDomProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactImageFallback = function (_Component) {
	_inherits(ReactImageFallback, _Component);

	function ReactImageFallback(props) {
		_classCallCheck(this, ReactImageFallback);

		var _this = _possibleConstructorReturn(this, (ReactImageFallback.__proto__ || Object.getPrototypeOf(ReactImageFallback)).call(this, props));

		_this.state = {
			imageSource: null
		};
		_this.setDisplayImage = _this.setDisplayImage.bind(_this);
		_this.handleInitialTimeout = _this.handleInitialTimeout.bind(_this);
		_this.isLoaded = false;
		return _this;
	}

	_createClass(ReactImageFallback, [{
		key: "handleInitialTimeout",
		value: function handleInitialTimeout() {
			var _this2 = this;

			if (this.props.initialTimeout && this.props.initialTimeout > 0) {
				setTimeout(function () {
					if (!_this2.isLoaded) {
						_this2.setState({
							imageSource: _this2.props.initialImage
						});
					}
				}, this.props.initialTimeout);
			} else {
				this.setState({
					imageSource: this.props.initialImage
				});
			}
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.handleInitialTimeout();
			this.displayImage = new window.Image();
			this.setDisplayImage({ image: this.props.src, fallbacks: this.props.fallbackImage });
		}
	}, {
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.src !== this.props.src) {
				this.isLoaded = false;
				if (nextProps.initialImage) {
					this.handleInitialTimeout();
				}
				this.setDisplayImage({ image: nextProps.src, fallbacks: nextProps.fallbackImage });
			}
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			if (this.displayImage) {
				this.displayImage.onerror = null;
				this.displayImage.onload = null;
				this.displayImage = null;
			}
		}
	}, {
		key: "setDisplayImage",
		value: function setDisplayImage(_ref) {
			var _this3 = this;

			var image = _ref.image,
			    fallbacks = _ref.fallbacks;

			var imagesArray = [image].concat(fallbacks).filter(function (fallback) {
				return !!fallback;
			});
			this.displayImage.onerror = function () {
				if (imagesArray.length > 2 && typeof imagesArray[1] === "string") {
					var updatedFallbacks = imagesArray.slice(2);
					_this3.setDisplayImage({ image: imagesArray[1], fallbacks: updatedFallbacks });
					return;
				}
				_this3.isLoaded = true;
				_this3.setState({
					imageSource: imagesArray[1] || null
				}, function () {
					if (_this3.props.onError) {
						_this3.props.onError(_this3.props.src);
					}
				});
			};
			this.displayImage.onload = function () {
				_this3.isLoaded = true;
				_this3.setState({
					imageSource: imagesArray[0]
				}, function () {
					if (_this3.props.onLoad) {
						_this3.props.onLoad(imagesArray[0]);
					}
				});
			};
			if (typeof imagesArray[0] === "string") {
				this.displayImage.src = imagesArray[0];
			} else {
				this.setState({
					imageSource: imagesArray[0]
				}, function () {
					if (_this3.props.onLoad) {
						_this3.props.onLoad(imagesArray[0]);
					}
				});
			}
		}
	}, {
		key: "render",
		value: function render() {
			return typeof this.state.imageSource === "string" ? _react2.default.createElement("img", _extends({}, (0, _filterInvalidDomProps2.default)(this.props), { src: this.state.imageSource })) : this.state.imageSource;
		}
	}]);

	return ReactImageFallback;
}(_react.Component);

exports.default = ReactImageFallback;

ReactImageFallback.displayName = "ReactImageFallback";

ReactImageFallback.propTypes = {
	src: _propTypes2.default.string,
	fallbackImage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]).isRequired,
	initialImage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	onLoad: _propTypes2.default.func,
	onError: _propTypes2.default.func,
	initialTimeout: _propTypes2.default.number
};

ReactImageFallback.defaultProps = {
	initialImage: null
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(169);
var defined = __webpack_require__(73);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(170);
var createDesc = __webpack_require__(105);
var toIObject = __webpack_require__(57);
var toPrimitive = __webpack_require__(72);
var has = __webpack_require__(56);
var IE8_DOM_DEFINE = __webpack_require__(674);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(29) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(56);
var toObject = __webpack_require__(35);
var IE_PROTO = __webpack_require__(332)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(1438);
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "f", function () {
  return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"];
});
/* unused harmony reexport captureEvent */
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "g", function () {
  return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"];
});
/* unused harmony reexport configureScope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "j", function () {
  return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(160);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "e", function () {
  return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"];
});
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "h", function () {
  return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"];
});
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(1446);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return __WEBPACK_IMPORTED_MODULE_2__api__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(1447);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
  return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(1449);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__sdk__ = __webpack_require__(1450);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "i", function () {
  return __WEBPACK_IMPORTED_MODULE_5__sdk__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__transports_noop__ = __webpack_require__(582);
/* unused harmony reexport NoopTransport */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(1451);
/* harmony reexport (module object) */__webpack_require__.d(__webpack_exports__, "d", function () {
  return __WEBPACK_IMPORTED_MODULE_7__integrations__;
});

//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(40);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(19);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(52);
var inherits = __webpack_require__(11);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccessSecurity__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChangePassword__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var LoggedSidebar=function LoggedSidebar(props){var selected=props.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userSidebar col-12 col-md-4 d-none d-lg-block pr-3 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 bg-brand-5 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{role:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/wishlist'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'wishlist-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/wishlist',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_wishlist'}),'Favoritos'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_EXTRACT,{default:true})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-extract px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/extract'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'extract-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/extract',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_listing'}),'Extrato'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_ORDERS,{default:true})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-order px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/my-orders'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'order-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/my-orders',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_package'}),'Pedidos'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_TRAVEL,{default:true})&&__WEBPACK_IMPORTED_MODULE_5_yn___default()("80938"==='40455'||"80938"==='40496'||"80938"==='40543')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-order px-1 py-0 py-1 border-bottom border-color-ui-3',role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'order-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',href:'https://viagens.webpremios.digital/meus-pedidos',target:'_self',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_airplane'}),'Minhas viagens'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()("false",{default:true})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-calendar px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/scheduling'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'calendar-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/scheduling',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_calendar'}),'Resgates recorrentes'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_PROFILE,{default:true})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-profile px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/profile'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'profile-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/profile',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_edit'}),'Informa\xE7\xF5es pessoais'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_ADDRESS,{default:true})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-address px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/my-address'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'profile-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/my-address',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_truck'}),'Endere\xE7o'))),__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_SECURITY,{default:true})&&(__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_SECURITY_ACCESS)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AccessSecurity__["a" /* default */],{selected:selected}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ChangePassword__["a" /* default */],{selected:selected}))))))));};LoggedSidebar.propTypes={selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (LoggedSidebar);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1074)


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(63);
var fails = __webpack_require__(19);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(169);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(28);
var asc = __webpack_require__(348);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

"use strict";

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_PARTICIPANT */
/* unused harmony export FETCH_PARTICIPANT_SUCCESS */
/* unused harmony export FETCH_PARTICIPANT_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchParticipant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return expireUpdatedParticipant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cleanError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOnlyNumbers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_clients__ = __webpack_require__(25);
var FETCH_PARTICIPANT='participant/FETCH';var FETCH_PARTICIPANT_SUCCESS=FETCH_PARTICIPANT+'_SUCCESS';var FETCH_PARTICIPANT_FAIL=FETCH_PARTICIPANT+'_FAIL';var fetchParticipant=function fetchParticipant(){return{type:FETCH_PARTICIPANT,payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me'}}};};var update=function update(data){return function(dispatch,_){dispatch({type:'UPDATE_PARTICIPANT'});var handleSuccess=function handleSuccess(response){dispatch(updateSuccess());dispatch(fetchParticipant());};var handleError=function handleError(err){return dispatch(updateItemFail(err));};__WEBPACK_IMPORTED_MODULE_1_redux_clients__["a" /* default */].cloudloyalty.client.put('/v1/participants/me',data).then(handleSuccess).catch(handleError);};};var updateSuccess=function updateSuccess(){return{type:'UPDATE_PARTICIPANT_SUCCESS',payload:null};};var updateItemFail=function updateItemFail(err){return{type:'UPDATE_PARTICIPANT_FAIL',error:{data:err}};};var expireUpdatedParticipant=function expireUpdatedParticipant(){return{type:'EXIPIRE_UPDATED_PARTICIPANT'};};var cleanError=function cleanError(){return{type:'CLEAN_ERROR_PARTICIPANT'};};var selectParticipantPhones=function selectParticipantPhones(phones,_ref){var readOnlyPhone=_ref.readOnlyPhone;var defaultPhones={home:{areaCode:'',number:'',type:'HOME'},mobile:{areaCode:'',number:'',type:'MOBILE'},work:{areaCode:'',number:'',type:'WORK'}};if(!phones||phones.length===0)return defaultPhones;var home='HOME';var mobile='MOBILE';var work='WORK';var matchPhone=function matchPhone(prev,_ref2){var areaCode=_ref2.areaCode,number=_ref2.number,type=_ref2.type;switch(type){case home:return Object.assign({},prev,{home:{areaCode:areaCode,number:number,disabled:readOnlyPhone,type:type}});case mobile:return Object.assign({},prev,{mobile:{areaCode:areaCode,number:number,disabled:readOnlyPhone,type:type}});case work:return Object.assign({},prev,{work:{areaCode:areaCode,number:number,disabled:readOnlyPhone,type:type}});default:return Object.assign({},prev);}};return phones.reduce(matchPhone,defaultPhones);};var buildPhone=function buildPhone(phone,type){if(!phone){return{areaCode:'',number:'',type:type};}var onlyNumbers=getOnlyNumbers(phone);return{areaCode:onlyNumbers.substr(0,2),number:onlyNumbers.substr(2),type:type};};var getOnlyNumbers=function getOnlyNumbers(value){var numberPattern=/\d+/g;return value.match(numberPattern).join([]);};var initialState={isLoading:true,isUpdating:false,hasError:false,updatedSuccessfully:false,name:{},cpf:{},cnpj:{},mails:{},email:{},address:{addressText:{},number:{},complement:{},district:{},city:{},state:{},zipCode:{},reference:{}},phones:{}};/* harmony default export */ __webpack_exports__["c"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case FETCH_PARTICIPANT:return Object.assign({},state,{isLoading:true});case FETCH_PARTICIPANT_SUCCESS:var participant=action.payload.data;var catalogParameters=participant.catalogParameters,address=participant.address,documentNumber=participant.documentNumber,emails=participant.emails,persontypeId=participant.persontypeId,genderTypeId=participant.genderTypeId,birthDate=participant.birthDate,maritalStatusId=participant.maritalStatusId,profileId=participant.profileId,statusId=participant.statusId,companyName=participant.companyName,name=participant.name,clientId=participant.clientId,catalogId=participant.catalogId;var phones=selectParticipantPhones(participant.phones,catalogParameters);return Object.assign({},state,{isLoading:false,personType:persontypeId,isCompany:persontypeId===2,profileId:profileId,statusId:statusId,genderType:{value:genderTypeId,disabled:catalogParameters.readOnlyGenderType},birthDate:{value:birthDate?__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(birthDate).format('DD/MM/YYYY'):'',disabled:catalogParameters.readOnlyBirthDate},maritalStatus:{value:maritalStatusId,disabled:catalogParameters.readOnlyMaritalStatus},name:{value:name,disabled:catalogParameters.readOnlyName},companyName:{value:companyName==null?name:companyName,disabled:catalogParameters.readOnlyCompanyName},cpf:{value:documentNumber,disabled:catalogParameters.readOnlyCpfCnpj},cnpj:{value:documentNumber,disabled:catalogParameters.readOnlyCpfCnpj},cpfCnpj:{value:documentNumber,disabled:catalogParameters.readOnlyCpfCnpj},mails:{value:emails,disabled:catalogParameters.readOnlyEmail},email:{value:emails.length>0?emails[0].email:'',disabled:catalogParameters.readOnlyEmail},address:address?{addressText:{value:address.street,disabled:catalogParameters.shippingAddess},number:{value:address.number,disabled:catalogParameters.shippingAddessNumber},complement:{value:address.complement,disabled:catalogParameters.shippingAddessComplement},district:{value:address.district,disabled:catalogParameters.shippingAddessDistrict},city:{value:address.city,disabled:catalogParameters.shippingAddessCity},state:{value:address.state,disabled:catalogParameters.shippingAddessState},zipCode:{value:address.zipCode,disabled:catalogParameters.shippingZipCode},reference:{value:address.reference,disabled:'false'}}:{addressText:{value:'',disabled:catalogParameters.shippingAddess},number:{value:'',disabled:catalogParameters.shippingAddessNumber},complement:{value:'',disabled:catalogParameters.shippingAddessComplement},district:{value:'',disabled:catalogParameters.shippingAddessDistrict},city:{value:'',disabled:catalogParameters.shippingAddessCity},state:{value:'',disabled:catalogParameters.shippingAddessState},zipCode:{value:'',disabled:catalogParameters.shippingZipCode},reference:{value:'',disabled:'false'}},phones:phones,clientId:clientId,catalogId:catalogId});case FETCH_PARTICIPANT_FAIL:return Object.assign({},state,{isLoading:false});case'UPDATE_PARTICIPANT':return Object.assign({},state,{isUpdating:true,updatedSuccessfully:false});case'UPDATE_PARTICIPANT_SUCCESS':return Object.assign({},state,{isUpdating:false,hasError:false,updatedSuccessfully:true});case'UPDATE_PARTICIPANT_FAIL':return Object.assign({},state,{isUpdating:false,updatedSuccessfully:false,hasError:true});case'EXIPIRE_UPDATED_PARTICIPANT':return Object.assign({},state,{updatedSuccessfully:false});case'CLEAN_ERROR_PARTICIPANT':return Object.assign({},state,{hasError:false});default:return state;}});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_SEARCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SearchFiltered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResultSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setFilterChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_slugify__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var FETCH_SEARCH='FETCH_RESULT_SEARCH';var FETCH_SEARCH_SUCCESS=FETCH_SEARCH+'_SUCCESS';var defaultSort='SCORE';var initialState={services:[],products:[],hasMoreItems:true,hasProducts:false,isLoading:true,filterChanged:'',filterSelected:{term:'',identifier:'',type:0,brand:[],category:[],subcategory:[],vendor:[],vendortype:[],feature:[],minprice:0,maxprice:0,sort:defaultSort},facetHistory:[],validShowcasePage:false,showcase:{}};/* harmony default export */ __webpack_exports__["d"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var setHistory=function setHistory(dataResult){var facetHistoryCheck=state.facetHistory.filter(function(x){return JSON.stringify(x.filterSelected)===JSON.stringify(state.filterSelected);});if(facetHistoryCheck.length<=0){state.facetHistory.push({filterSelected:{term:state.filterSelected.term,identifier:state.filterSelected.identifier,type:state.filterSelected.type,brand:[].concat(_toConsumableArray(state.filterSelected.brand)),category:[].concat(_toConsumableArray(state.filterSelected.category)),subcategory:[].concat(_toConsumableArray(state.filterSelected.subcategory)),vendor:[].concat(_toConsumableArray(state.filterSelected.vendor)),vendortype:[].concat(_toConsumableArray(state.filterSelected.vendortype)),feature:[].concat(_toConsumableArray(state.filterSelected.feature)),minprice:state.filterSelected.minprice,maxprice:state.filterSelected.maxprice},facets:{categories:dataResult.categories,subcategories:dataResult.subcategories,brands:dataResult.brands,vendors:dataResult.vendors,features:dataResult.features}});}};var getDataResultHistory=function getDataResultHistory(filterSingle,filterPlural,dataResult){var filterSelectedState=Object.assign({},state.filterSelected);filterSelectedState[filterSingle]=[];var facetHistoryCheck=state.facetHistory.filter(function(f){return JSON.stringify(f.filterSelected)===JSON.stringify(filterSelectedState);});var facetsHistory=facetHistoryCheck.length>0?facetHistoryCheck[0].facets[filterPlural]:dataResult[filterPlural];state.filterSelected[filterSingle]=facetsHistory.filter(function(f){return state.filterSelected[filterSingle].some(function(s){return s===String(f.id);});}).map(function(m){return String(m.id);});return facetsHistory;};switch(action.type){case'SET_FILTER_CHANGED':return Object.assign({},state,{filterChanged:action.payload.filterName,filterSelected:action.payload.filterSelected});case'FETCH_RESULT_SEARCH':return Object.assign({},state,{isLoading:true});case'FETCH_RESULT_SEARCH_SUCCESS':var dataResult=action.payload.data;setHistory(dataResult);return Object.assign({},state,{hasMoreItems:[].concat(_toConsumableArray(state.products),_toConsumableArray(dataResult.products)).length<dataResult.totalRowCount&&dataResult.products.length>0,services:[].concat(_toConsumableArray(state.services),_toConsumableArray(dataResult.services||[])),products:[].concat(_toConsumableArray(state.products),_toConsumableArray(dataResult.products||[])),quantityFoundProducts:dataResult.totalRowCount,categories:dataResult.categories,subcategories:dataResult.subcategories,brands:getDataResultHistory('brand','brands',dataResult),vendors:getDataResultHistory('vendor','vendors',dataResult),features:dataResult.features,facetHistory:state.facetHistory,filterSelected:state.filterSelected,isLoading:false,lowerPrice:dataResult.lowerPrice,higherPrice:dataResult.higherPrice,showcase:dataResult.showcase});case'FETCH_RESULT_SEARCH_FAIL':return Object.assign({},state,{error:action.error,isLoading:false});case'CLEAR_PRODUCTS':return Object.assign({},state,{services:[],products:[],isLoading:false});case'FETCH_SEARCH_CARD_AVAILABILITY':return Object.assign({},state);case'FETCH_SEARCH_CARD_AVAILABILITY_SUCCESS':var availability=action.payload.data[0];var products=state.products;var sku=action.meta.previousAction.sku;var index=products.findIndex(function(p){return p.sku===sku;});if(products[index]){products[index].availability=Object.assign({},availability);}return Object.assign({},state,{products:products});case'FETCH_SEARCH_CARD_AVAILABILITY_FAIL':return Object.assign({},state,{error_availability:action.error});case'SEARCH_PAGE_RESET_STATE':return Object.assign({},initialState);default:return Object.assign({},state);}});var restrictProducts=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_RESTRICT_PRODUCTS?Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_RESTRICT_PRODUCTS.split(','):[];var checker=function checker(value){for(var i=0;i<restrictProducts.length;i++){if(value.indexOf(restrictProducts[i])>-1){return false;}}return true;};var SearchFiltered=function SearchFiltered(searchResult,router){searchResult.products.map(function(prod){var vendor=searchResult.vendors.filter(function(v){return v.id===prod.vendor.id;});prod.vendor.imageUrl=vendor.length>0?vendor[0].imageUrl:'';});var removeCategories= true?"servicos,tabacaria,viagens,veiculos,educacao,vale-compras".split(','):[];var removeSubcategories= true?"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas".split(','):[];if(restrictProducts.length){searchResult.products=searchResult.products.filter(function(el){return checker(el.name.toLowerCase());});}var filteredCategories=[];var filteredSubcategories=[];if(searchResult.categories&&searchResult.categories.length){searchResult.categories.map(function(cat){if(!removeCategories.includes(__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()(cat.name,{delimiter:'-'}))){filteredCategories.push(cat);}});}if(searchResult.subcategories&&searchResult.subcategories.length){searchResult.subcategories.map(function(sub){if(!removeSubcategories.includes(__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()(sub.name,{delimiter:'-'}))){filteredSubcategories.push(sub);}});}var products=searchResult.products.filter(function(item,index,self){return index===self.findIndex(function(t){return t.sku===item.sku;});});return{services:searchResult.services,products:products,hasMoreItems:searchResult.hasMoreItems,hasNoProducts:searchResult.services.length<=0&&searchResult.products.length<=0,quantityFoundProducts:searchResult.quantityFoundProducts,categories:filteredCategories,subcategories:filteredSubcategories,brands:searchResult.brands,vendors:searchResult.vendors,features:searchResult.features,filtersName:router.location.search,isLoading:searchResult.isLoading,priceLimit:{min:searchResult.lowerPrice,max:searchResult.higherPrice},filterSelected:searchResult.filterSelected,facetHistory:searchResult.facetHistory,validShowcasePage:searchResult.filterSelected.identifier&&searchResult.filterSelected.type>0,showcase:searchResult.showcase};};var fetchResultSearch=function fetchResultSearch(typeSearch){return function(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex){return{type:'FETCH_RESULT_SEARCH',payload:{client:'cloudloyalty',request:{url:(typeSearch==='showcase'?'/v2/showcases/'+identifier+'/'+type+'/?cachedPrice=true':'/v2/products/?cachedPrice=true'+setFilter(term,'term'))+(''+setFilter(brands,'brands'))+(''+setFilter(categories,'categories'))+(''+setFilter(subcategories,'subcategories'))+(''+setFilter(vendors,'vendors'))+(''+setFilter(vendortype,'vendortypes'))+(''+setFilter(features,'features'))+(''+setFilter(minprice,'minprice'))+(''+setFilter(maxprice,'maxprice'))+(''+setFilter(sort,'sort','&sort='+defaultSort))+('&pageIndex='+pageIndex+'&pageSize=12')}}};};};var setFilter=function setFilter(filters,paramName){var defaultFilter=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var featureIndex=0;if(Array.isArray(filters)){var queryFilter='';filters.map(function(filter){queryFilter+=filter?defineFilterValue(filter,paramName,featureIndex++):defaultFilter;});return queryFilter;}return filters?defineFilterValue(filters,paramName,featureIndex++):defaultFilter;};var defineFilterValue=function defineFilterValue(filter,paramName,featureIndex){switch(paramName){case'features':var filterSplitted=filter.split('_');return'&Features['+featureIndex+'].Type='+filterSplitted[0]+'&Features['+featureIndex+'].Value='+filterSplitted[1];default:return'&'+paramName+'='+filter;}};var clearSearch=function clearSearch(){return{type:'CLEAR_PRODUCTS'};};var setFilterChanged=function setFilterChanged(filterName,filterSelected){return{type:'SET_FILTER_CHANGED',payload:{filterName:filterName,filterSelected:filterSelected}};};var resetState=function resetState(){return{type:'SEARCH_PAGE_RESET_STATE'};};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(29)) {
  var LIBRARY = __webpack_require__(89);
  var global = __webpack_require__(16);
  var fails = __webpack_require__(19);
  var $export = __webpack_require__(4);
  var $typed = __webpack_require__(229);
  var $buffer = __webpack_require__(356);
  var ctx = __webpack_require__(64);
  var anInstance = __webpack_require__(112);
  var propertyDesc = __webpack_require__(105);
  var hide = __webpack_require__(49);
  var redefineAll = __webpack_require__(114);
  var toInteger = __webpack_require__(66);
  var toLength = __webpack_require__(28);
  var toIndex = __webpack_require__(702);
  var toAbsoluteIndex = __webpack_require__(108);
  var toPrimitive = __webpack_require__(72);
  var has = __webpack_require__(56);
  var classof = __webpack_require__(134);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(35);
  var isArrayIter = __webpack_require__(345);
  var create = __webpack_require__(109);
  var getPrototypeOf = __webpack_require__(59);
  var gOPN = __webpack_require__(110).f;
  var getIterFn = __webpack_require__(347);
  var uid = __webpack_require__(106);
  var wks = __webpack_require__(26);
  var createArrayMethod = __webpack_require__(75);
  var createArrayIncludes = __webpack_require__(219);
  var speciesConstructor = __webpack_require__(172);
  var ArrayIterators = __webpack_require__(350);
  var Iterators = __webpack_require__(136);
  var $iterDetect = __webpack_require__(224);
  var setSpecies = __webpack_require__(111);
  var arrayFill = __webpack_require__(349);
  var arrayCopyWithin = __webpack_require__(691);
  var $DP = __webpack_require__(32);
  var $GOPD = __webpack_require__(58);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(697);
var $export = __webpack_require__(4);
var shared = __webpack_require__(168)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(700))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(783);
var objectAssign = __webpack_require__(118);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBrowserHistory", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHashHistory", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLocation", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locationsAreEqual", function() { return locationsAreEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePath", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPath", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(749);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer
var Transform = __webpack_require__(243).Transform
var StringDecoder = __webpack_require__(233).StringDecoder
var inherits = __webpack_require__(11)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var IsResponsiveEnabledContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(true);/* harmony default export */ __webpack_exports__["a"] = (IsResponsiveEnabledContext);

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(106)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(56);
var setDesc = __webpack_require__(32).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(26)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(49)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_on_demand_live_region__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_on_demand_live_region___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_on_demand_live_region__);
var Splash=function Splash(_ref){var text=_ref.text;setTimeout(function(){var liveRegionDelayed=new __WEBPACK_IMPORTED_MODULE_5_on_demand_live_region___default.a({delay:300,level:'assertive',parent:'#loadingscreen'});document.querySelectorAll('#loadingscreen').length>0&&liveRegionDelayed.say(''+(__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CUSTOM_SPLASH)?Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CUSTOM_SPLASH_TEXT:text));},1000);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{'data-campaign':"80938"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'loadingscreen',className:'row loading-screen screen-default'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col-12 bg-brand-4 progress-loader p-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'progress-bar'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col-12 bg-brand-2 txt-loading py-5 d-flex align-items-center justify-content-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'logo'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'mr-auto ml-auto txt-center logo-header'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/',tabIndex:0,title:text},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'hide-absolute'},"Tupperware | Premmiar"||'Premmiar')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'color-ui-white txt-normal mx-auto my-2'},text),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'btn-loading loader-screen mx-auto'})))));};Splash.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Splash);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(737);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(140);
util.inherits = __webpack_require__(11);
/*</replacement>*/

var Readable = __webpack_require__(389);
var Writable = __webpack_require__(246);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SecondFactorAuthentication__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SecondFactorAuthentication__["a"]; });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShowcaseContainer__ = __webpack_require__(1289);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Showcase__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Showcase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShowcaseBenefits__ = __webpack_require__(1324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ShowcaseBenefits__["a"]; });


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_SHOWCASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SHOWCASE_SUCCESS; });
/* unused harmony export FETCH_SHOWCASE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchShowcase; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var FETCH_SHOWCASE='showcase/FETCH';var FETCH_SHOWCASE_SUCCESS=FETCH_SHOWCASE+'_SUCCESS';var FETCH_SHOWCASE_FAIL=FETCH_SHOWCASE+'_FAIL';var SHOWCASE_DEFAULTS={5:{home:{title:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PRODUCTS_SHOWCASE_TITLE||Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_TITLE_SHOWCASE_DEFAULTS||'Troque seus pontos por produtos dos principais e-commerces.',titleOnlyCash:'Uma seleção de ofertas especiais para você.',mobileTitle:'Produtos'}},7:{home:{title:'Vale-compras para você presentear.',mobileTitle:'Produtos'}}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case FETCH_SHOWCASE:return Object.assign({},state,_defineProperty({},action.showcaseType,Object.assign({},state[action.showcaseType],_defineProperty({},action.identifier,Object.assign({},SHOWCASE_DEFAULTS[action.showcaseType]?SHOWCASE_DEFAULTS[action.showcaseType][action.identifier]:{},state[action.showcaseType]?state[action.showcaseType][action.identifier]:{},{isLoading:true})))));case FETCH_SHOWCASE_SUCCESS:return Object.assign({},state,_defineProperty({},action.meta.previousAction.showcaseType,Object.assign({},state[action.meta.previousAction.showcaseType],_defineProperty({},action.meta.previousAction.identifier,Object.assign({},state[action.meta.previousAction.showcaseType][action.meta.previousAction.identifier],{isLoading:false},action.payload.data.showcase,{products:action.payload.data.products.map(function(_ref){var sku=_ref.sku;return sku;}),vendors:action.payload.data.vendors})))));case FETCH_SHOWCASE_FAIL:return Object.assign({},state,_defineProperty({},action.meta.previousAction.showcaseType,Object.assign({},state[action.meta.previousAction.showcaseType],_defineProperty({},action.meta.previousAction.identifier,Object.assign({},state[action.meta.previousAction.showcaseType][action.meta.previousAction.identifier],{isLoading:false})))));default:return Object.assign({},state);}});var fetchShowcase=function fetchShowcase(showcaseType,identifier){return{type:FETCH_SHOWCASE,showcaseType:showcaseType,identifier:identifier,payload:{client:'cloudloyalty',request:{url:'/v2/showcases/'+showcaseType+'?identifier='+identifier+'&cachedPrice=true'}}};};

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WishlistResume_WishlistResume__ = __webpack_require__(1296);
/* unused harmony reexport WishlistResume */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WishlistPage__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__WishlistPage__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(1434);
/* unused harmony reexport LogLevel */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(1435);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return __WEBPACK_IMPORTED_MODULE_1__severity__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(1436);
/* unused harmony reexport SpanStatus */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__status__ = __webpack_require__(1437);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return __WEBPACK_IMPORTED_MODULE_3__status__["a"];
});

//# sourceMappingURL=index.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellphonerechargeContainer__ = __webpack_require__(1515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__CellphonerechargeContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1609);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalTerms__ = __webpack_require__(212);
/* unused harmony reexport ModalTerms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CellphonerechargePlaceholder__ = __webpack_require__(1610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__CellphonerechargePlaceholder__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_slugify__);
var getButton=function getButton(isLogged,eventCategory,eventAction,eventLabel){var dimension8=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'event','eventCategory':("tupperware-inc-cancun"||'webpremios')+':'+eventCategory+'-'+(isLogged?'logada':'aberta'),'eventAction':eventAction,'eventLabel':eventLabel,'dimension8':dimension8?__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()(dimension8,{delimiter:'-'}):__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()("tupperware-inc-cancun"||'webpremios',{delimiter:'-'})});};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.String = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var camelize = exports.camelize = function camelize(str) {
    return str.split('_').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
  };
});

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(676);
var enumBugKeys = __webpack_require__(333);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(66);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(677);
var enumBugKeys = __webpack_require__(333);
var IE_PROTO = __webpack_require__(332)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(330)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(334).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(676);
var hiddenKeys = __webpack_require__(333).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var dP = __webpack_require__(32);
var DESCRIPTORS = __webpack_require__(29);
var SPECIES = __webpack_require__(26)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(64);
var call = __webpack_require__(689);
var isArrayIter = __webpack_require__(345);
var anObject = __webpack_require__(10);
var toLength = __webpack_require__(28);
var getIterFn = __webpack_require__(347);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(50);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {(function (global, factory) {
   true ? factory(exports, __webpack_require__(0)) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (factory((global.reactAccessibleAccordion = {}),global.React));
}(this, (function (exports,React) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  // Arbitrary, but ought to be unique to avoid context namespace clashes.
  var CONTEXT_KEY = 'react-accessible-accordion@AccordionContainer';
  var Provider =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        items: _this.props.items || []
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addItem", function (newItem) {
        // Need to use callback style otherwise race-conditions are created by concurrent registrations.
        _this.setState(function (state) {
          var items;

          if (state.items.some(function (item) {
            return item.uuid === newItem.uuid;
          })) {
            // eslint-disable-next-line no-console
            console.error("AccordionItem error: One item already has the uuid \"".concat(newItem.uuid, "\". Uuid property must be unique. See: https://github.com/springload/react-accessible-accordion#accordionitem"));
          }

          if (_this.props.accordion && newItem.expanded) {
            // If this is a true accordion and the new item is expanded, then the others must be closed.
            items = _toConsumableArray(state.items.map(function (item) {
              return _objectSpread({}, item, {
                expanded: false
              });
            })).concat([newItem]);
          } else {
            items = _toConsumableArray(state.items).concat([newItem]);
          }

          return {
            items: items
          };
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeItem", function (key) {
        return _this.setState(function (state) {
          return {
            items: state.items.filter(function (item) {
              return item.uuid !== key;
            })
          };
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setExpanded", function (key, expanded) {
        return _this.setState(function (state) {
          return {
            items: state.items.map(function (item) {
              if (item.uuid === key) {
                return _objectSpread({}, item, {
                  expanded: expanded
                });
              }

              if (_this.props.accordion && expanded) {
                // If this is an accordion, we might need to collapse the other expanded item.
                return _objectSpread({}, item, {
                  expanded: false
                });
              }

              return item;
            })
          };
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(_this.props.accordion ? key : _this.state.items.filter(function (item) {
              return item.expanded;
            }).map(function (item) {
              return item.uuid;
            }));
          }
        });
      });

      return _this;
    }

    _createClass(Provider, [{
      key: "getChildContext",
      value: function getChildContext() {
        var context = {
          items: this.state.items,
          accordion: !!this.props.accordion,
          addItem: this.addItem,
          removeItem: this.removeItem,
          setExpanded: this.setExpanded
        };
        return _defineProperty({}, CONTEXT_KEY, context);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children || null;
      }
    }]);

    return Provider;
  }(React.Component); // eslint-disable-next-line react/no-multi-comp

  _defineProperty(Provider, "childContextTypes", _defineProperty({}, CONTEXT_KEY, function () {
    return null;
  }));

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      _classCallCheck(this, Consumer);

      return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
    }

    _createClass(Consumer, [{
      key: "render",
      value: function render() {
        return this.props.children(this.context[CONTEXT_KEY]);
      }
    }]);

    return Consumer;
  }(React.Component);

  _defineProperty(Consumer, "contextTypes", _defineProperty({}, CONTEXT_KEY, function () {
    return null;
  }));

  var accordionDefaultProps = {
    accordion: true
  };

  var Accordion = function Accordion(_ref) {
    var accordion = _ref.accordion,
        rest = _objectWithoutProperties(_ref, ["accordion"]);

    return React__default.createElement("div", _extends({
      role: accordion ? 'tablist' : null
    }, rest));
  };

  Accordion.defaultProps = accordionDefaultProps;

  var defaultProps = {
    accordion: true,
    onChange: function onChange() {},
    className: 'accordion',
    children: null
  };

  var AccordionWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionWrapper, _Component);

    function AccordionWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AccordionWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderAccordion", function (accordionStore) {
        var _this$props = _this.props,
            accordion = _this$props.accordion,
            onChange = _this$props.onChange,
            rest = _objectWithoutProperties(_this$props, ["accordion", "onChange"]);

        return React__default.createElement(Accordion, _extends({
          accordion: accordionStore.accordion
        }, rest));
      });

      return _this;
    }

    _createClass(AccordionWrapper, [{
      key: "render",
      value: function render() {
        return React__default.createElement(Provider, {
          accordion: this.props.accordion,
          onChange: this.props.onChange
        }, React__default.createElement(Consumer, null, this.renderAccordion));
      }
    }]);

    return AccordionWrapper;
  }(React.Component);

  _defineProperty(AccordionWrapper, "defaultProps", defaultProps);

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   * 
   */

  function _inheritsLoose$1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var lib = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
    var currentListeners = [];
    var nextListeners = currentListeners;

    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }

    function listen(listener) {
      if (typeof listener !== 'function') {
        throw new Error('Expected listener to be a function.');
      }

      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function () {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
      };
    }

    function emit() {
      currentListeners = nextListeners;
      var listeners = currentListeners;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i].apply(listeners, arguments);
      }
    }

    return {
      listen: listen,
      emit: emit
    };
  };
  });

  unwrapExports(lib);
  var lib_1 = lib.createChangeEmitter;

  function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;

    if (typeof Symbol === 'function') {
      if (Symbol.observable) {
        result = Symbol.observable;
      } else {
        result = Symbol('observable');
        Symbol.observable = result;
      }
    } else {
      result = '@@observable';
    }

    return result;
  }

  /* global window */
  var root;

  if (typeof self !== 'undefined') {
    root = self;
  } else if (typeof window !== 'undefined') {
    root = window;
  } else if (typeof global !== 'undefined') {
    root = global;
  } else if (true) {
    root = module;
  } else {
    root = Function('return this')();
  }

  var result = symbolObservablePonyfill(root);

  var Nothing =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$1(Nothing, _Component);

    function Nothing() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = Nothing.prototype;

    _proto.render = function render() {
      return null;
    };

    return Nothing;
  }(React.Component);

  var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
    if (renderPropName === void 0) {
      renderPropName = 'children';
    }

    return function (BaseComponent) {
      var baseFactory = React__default.createFactory(BaseComponent);
      var renderPropsFactory = React__default.createFactory(RenderPropsComponent);

      var FromRenderProps = function FromRenderProps(ownerProps) {
        var _renderPropsFactory;

        return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
          return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
        }, _renderPropsFactory));
      };

      return FromRenderProps;
    };
  };

  var compose = function compose() {
    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
      funcs[_key] = arguments[_key];
    }

    return funcs.reduce(function (a, b) {
      return function () {
        return a(b.apply(void 0, arguments));
      };
    }, function (arg) {
      return arg;
    });
  };

  /*!
   * consecutive
   * Get consecutive numbers
   * Copyright(c) 2017 ivanoff .$ curl -A cv ivanoff.org.ua
   * MIT Licensed
   */

  var consecutive = function (begin, base, inc) {
    var number = begin || 0;
    if (typeof base !== 'number') base = 10;
    if (typeof inc !== 'number') inc = 1;
    return function () {
      var res;

      if (typeof base === 'undefined' || base === 10) {
        res = number;
        number += inc;
      } else {
        res = number.toString();
        number = (parseInt(number, base) + inc).toString(base);
      }

      return res;
    };
  };

  // Arbitrary, but ought to be unique to avoid context namespace clashes.
  var CONTEXT_KEY$1 = 'react-accessible-accordion@ItemContainer';
  var Provider$1 =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      _classCallCheck(this, Provider);

      return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
    }

    _createClass(Provider, [{
      key: "getChildContext",
      value: function getChildContext() {
        var uuid = this.props.uuid;
        var context = {
          uuid: uuid
        };
        return _defineProperty({}, CONTEXT_KEY$1, context);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children || null;
      }
    }]);

    return Provider;
  }(React.Component);

  _defineProperty(Provider$1, "childContextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
    return null;
  }));

  // eslint-disable-next-line react/no-multi-comp
  var Consumer$1 =
  /*#__PURE__*/
  function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      _classCallCheck(this, Consumer);

      return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
    }

    _createClass(Consumer, [{
      key: "render",
      value: function render() {
        return this.props.children(this.context[CONTEXT_KEY$1]);
      }
    }]);

    return Consumer;
  }(React.Component);

  _defineProperty(Consumer$1, "contextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
    return null;
  }));

  var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          classes.push(classNames.apply(null, arg));
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      module.exports = classNames;
    } else if (false) {
      // register as 'classnames', consistent with npm package name
      undefined('classnames', [], function () {
        return classNames;
      });
    } else {
      window.classNames = classNames;
    }
  })();
  });

  var AccordionItem =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItem, _Component);

    function AccordionItem() {
      _classCallCheck(this, AccordionItem);

      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItem).apply(this, arguments));
    }

    _createClass(AccordionItem, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            uuid = _this$props.uuid,
            accordionStore = _this$props.accordionStore,
            disabled = _this$props.disabled;
        accordionStore.addItem({
          uuid: uuid,
          expanded: this.props.expanded || false,
          disabled: disabled
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.props.accordionStore.removeItem(this.props.uuid);
      } // This is here so that the user can dynamically set the 'expanded' state using the 'expanded' prop.

    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props2 = this.props,
            uuid = _this$props2.uuid,
            expanded = _this$props2.expanded,
            accordionStore = _this$props2.accordionStore;

        if (expanded !== prevProps.expanded) {
          accordionStore.setExpanded(uuid, expanded);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            uuid = _this$props3.uuid,
            className = _this$props3.className,
            hideBodyClassName = _this$props3.hideBodyClassName,
            accordionStore = _this$props3.accordionStore,
            disabled = _this$props3.disabled,
            expanded = _this$props3.expanded,
            rest = _objectWithoutProperties(_this$props3, ["uuid", "className", "hideBodyClassName", "accordionStore", "disabled", "expanded"]); // Deliberately not using 'find' because IE compat.


        var currentItem = accordionStore.items.filter(function (item) {
          return item.uuid === uuid;
        })[0];

        if (!currentItem) {
          return null;
        }

        return React__default.createElement("div", _extends({
          className: classnames(className, _defineProperty({}, hideBodyClassName, !currentItem.expanded && hideBodyClassName))
        }, rest));
      }
    }]);

    return AccordionItem;
  }(React.Component);

  var nextUuid = consecutive();
  function resetNextUuid() {
    nextUuid = consecutive();
  }

  var AccordionItemWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemWrapper, _Component);

    function AccordionItemWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AccordionItemWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "id", nextUuid());

      return _this;
    }

    _createClass(AccordionItemWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            accordionStore = _this$props.accordionStore,
            uuid = _this$props.uuid,
            rest = _objectWithoutProperties(_this$props, ["accordionStore", "uuid"]);

        var itemUuid = uuid !== undefined ? uuid : this.id;
        return React__default.createElement(Provider$1, {
          uuid: itemUuid
        }, React__default.createElement(AccordionItem, _extends({}, rest, {
          uuid: itemUuid,
          accordionStore: accordionStore
        })));
      }
    }]);

    return AccordionItemWrapper;
  }(React.Component);

  _defineProperty(AccordionItemWrapper, "defaultProps", {
    className: 'accordion__item',
    hideBodyClassName: '',
    disabled: false,
    expanded: false,
    uuid: undefined
  });

  var AccordionItem_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
    return {
      accordionStore: accordionStore
    };
  }))(AccordionItemWrapper);

  var AccordionItemTitle =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemTitle, _Component);

    function AccordionItemTitle() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AccordionItemTitle);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
        var _this$props = _this.props,
            uuid = _this$props.uuid,
            expanded = _this$props.expanded,
            setExpanded = _this$props.setExpanded;
        setExpanded(uuid, !expanded);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (evt) {
        if (evt.charCode === 13 || evt.charCode === 32) {
          evt.preventDefault();

          _this.handleClick();
        }
      });

      return _this;
    }

    _createClass(AccordionItemTitle, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            className = _this$props2.className,
            hideBodyClassName = _this$props2.hideBodyClassName,
            item = _this$props2.item,
            accordion = _this$props2.accordion,
            setExpanded = _this$props2.setExpanded,
            expanded = _this$props2.expanded,
            uuid = _this$props2.uuid,
            disabled = _this$props2.disabled,
            rest = _objectWithoutProperties(_this$props2, ["className", "hideBodyClassName", "item", "accordion", "setExpanded", "expanded", "uuid", "disabled"]);

        var id = "accordion__title-".concat(uuid);
        var ariaControls = "accordion__body-".concat(uuid);
        var role = accordion ? 'tab' : 'button';
        var titleClassName = classnames(className, _defineProperty({}, hideBodyClassName, hideBodyClassName && !expanded));

        if (role === 'tab') {
          return React__default.createElement("div", _extends({
            id: id,
            "aria-selected": expanded,
            "aria-controls": ariaControls,
            className: titleClassName,
            onClick: disabled ? undefined : this.handleClick,
            role: role,
            tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
            ,
            onKeyPress: this.handleKeyPress,
            disabled: disabled
          }, rest));
        }

        return React__default.createElement("div", _extends({
          id: id,
          "aria-expanded": expanded,
          "aria-controls": ariaControls,
          className: titleClassName,
          onClick: disabled ? undefined : this.handleClick,
          role: role,
          tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
          ,
          onKeyPress: this.handleKeyPress,
          disabled: disabled
        }, rest));
      }
    }]);

    return AccordionItemTitle;
  }(React.Component);

  _defineProperty(AccordionItemTitle, "accordionElementName", 'AccordionItemTitle');

  // eslint-disable-next-line react/prefer-stateless-function
  var AccordionItemTitleWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemTitleWrapper, _Component);

    function AccordionItemTitleWrapper() {
      _classCallCheck(this, AccordionItemTitleWrapper);

      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemTitleWrapper).apply(this, arguments));
    }

    _createClass(AccordionItemTitleWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            itemStore = _this$props.itemStore,
            accordionStore = _this$props.accordionStore,
            rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);

        var uuid = itemStore.uuid;
        var items = accordionStore.items,
            accordion = accordionStore.accordion;
        var item = items.filter(function (stateItem) {
          return stateItem.uuid === uuid;
        })[0];
        return React__default.createElement(AccordionItemTitle, _extends({}, rest, item, {
          setExpanded: accordionStore.setExpanded,
          accordion: accordion
        }));
      }
    }]);

    return AccordionItemTitleWrapper;
  }(React.Component);

  _defineProperty(AccordionItemTitleWrapper, "defaultProps", {
    className: 'accordion__title',
    hideBodyClassName: ''
  });

  var AccordionItemTitle_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
    return {
      accordionStore: accordionStore
    };
  }), fromRenderProps(Consumer$1, function (itemStore) {
    return {
      itemStore: itemStore
    };
  }))(AccordionItemTitleWrapper);

  var AccordionItemBody = function AccordionItemBody(props) {
    var className = props.className,
        hideBodyClassName = props.hideBodyClassName,
        uuid = props.uuid,
        expanded = props.expanded,
        disabled = props.disabled,
        accordion = props.accordion,
        rest = _objectWithoutProperties(props, ["className", "hideBodyClassName", "uuid", "expanded", "disabled", "accordion"]);

    return React__default.createElement("div", _extends({
      id: "accordion__body-".concat(uuid),
      className: classnames(className, _defineProperty({}, hideBodyClassName, !expanded)),
      "aria-hidden": !expanded,
      "aria-labelledby": "accordion__title-".concat(uuid),
      role: accordion ? 'tabpanel' : null
    }, rest));
  };

  // eslint-disable-next-line react/prefer-stateless-function
  var AccordionItemBodyWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemBodyWrapper, _Component);

    function AccordionItemBodyWrapper() {
      _classCallCheck(this, AccordionItemBodyWrapper);

      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemBodyWrapper).apply(this, arguments));
    }

    _createClass(AccordionItemBodyWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            itemStore = _this$props.itemStore,
            accordionStore = _this$props.accordionStore,
            rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);

        var uuid = itemStore.uuid;
        var items = accordionStore.items,
            accordion = accordionStore.accordion;
        var item = items.filter(function (stateItem) {
          return stateItem.uuid === uuid;
        })[0];
        return item ? React__default.createElement(AccordionItemBody, _extends({}, rest, item, {
          accordion: accordion
        })) : null;
      }
    }]);

    return AccordionItemBodyWrapper;
  }(React.Component);

  _defineProperty(AccordionItemBodyWrapper, "defaultProps", {
    className: 'accordion__body',
    hideBodyClassName: 'accordion__body--hidden'
  });

  var AccordionItemBody_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
    return {
      accordionStore: accordionStore
    };
  }), fromRenderProps(Consumer$1, function (itemStore) {
    return {
      itemStore: itemStore
    };
  }))(AccordionItemBodyWrapper);

  // eslint-disable-next-line

  exports.Accordion = AccordionWrapper;
  exports.AccordionItem = AccordionItem_wrapper;
  exports.AccordionItemTitle = AccordionItemTitle_wrapper;
  exports.AccordionItemBody = AccordionItemBody_wrapper;
  exports.resetNextUuid = resetNextUuid;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(76)(module)))

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(5), __webpack_require__(1), __webpack_require__(83));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-router-dom", "prop-types", "history"], factory);
	else if(typeof exports === 'object')
		exports["ReactRouterLastLocation"] = factory(require("react"), require("react-router-dom"), require("prop-types"), require("history"));
	else
		root["ReactRouterLastLocation"] = factory(root["react"], root["react-router-dom"], root["prop-types"], root["history"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__10__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(6);
var react_router_dom_1 = __webpack_require__(1);
var LastLocationContext_1 = __webpack_require__(3);
var prevent_1 = __webpack_require__(7);
var lastLocation = null;
var updateLastLocation = function (_a) {
    var location = _a.location, nextLocation = _a.nextLocation, watchOnlyPathname = _a.watchOnlyPathname;
    if (location === null) {
        return;
    }
    if (nextLocation === location) {
        return;
    }
    if (watchOnlyPathname && location.pathname === nextLocation.pathname) {
        return;
    }
    if (prevent_1.shouldPrevent(nextLocation) && !prevent_1.hasBeenPrevented(nextLocation)) {
        prevent_1.prevent(nextLocation);
        return;
    }
    lastLocation = __assign({}, location);
};
var LastLocationProvider = /** @class */ (function (_super) {
    __extends(LastLocationProvider, _super);
    function LastLocationProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentLocation: null,
        };
        return _this;
    }
    LastLocationProvider.getDerivedStateFromProps = function (props, state) {
        updateLastLocation({
            location: state.currentLocation,
            nextLocation: props.location,
            watchOnlyPathname: props.watchOnlyPathname,
        });
        return {
            currentLocation: props.location,
        };
    };
    LastLocationProvider.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(LastLocationContext_1.default.Provider, { value: lastLocation }, children));
    };
    LastLocationProvider.propTypes = {
        watchOnlyPathname: PropTypes.bool,
        children: PropTypes.node.isRequired,
    };
    LastLocationProvider.defaultProps = {
        watchOnlyPathname: false,
    };
    return LastLocationProvider;
}(React.Component));
exports.getLastLocation = function () { return lastLocation; };
exports.setLastLocation = function (nextLastLocation) {
    lastLocation = nextLastLocation;
};
exports.default = react_router_dom_1.withRouter(LastLocationProvider);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var LastLocationContext = react_1.createContext(null);
exports.default = LastLocationContext;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var withLastLocation_1 = __webpack_require__(5);
exports.withLastLocation = withLastLocation_1.default;
var LastLocationProvider_1 = __webpack_require__(2);
exports.LastLocationProvider = LastLocationProvider_1.default;
var useLastLocation_1 = __webpack_require__(8);
exports.useLastLocation = useLastLocation_1.default;
var RedirectWithoutLastLocation_1 = __webpack_require__(9);
exports.RedirectWithoutLastLocation = RedirectWithoutLastLocation_1.default;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(1);
var LastLocationProvider_1 = __webpack_require__(2);
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
var withLastLocation = function (WrappedComponent) {
    var WithLastLocation = function (props) { return (React.createElement(WrappedComponent, __assign({ lastLocation: LastLocationProvider_1.getLastLocation() }, props))); };
    WithLastLocation.displayName = "WithLastLocation(" + getDisplayName(WrappedComponent) + ")";
    return react_router_dom_1.withRouter(WithLastLocation);
};
exports.default = withLastLocation;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * I could only check `key` here but according to:
 * @see https://reacttraining.com/react-router/web/api/location
 * `key` property is not available when HashHistory is used.
 */
var props = ['key', 'pathname', 'search', 'hash'];
var isEqual = function (a, b) { return props.every(function (prop) { return a[prop] === b[prop]; }); };
var prevented = [];
exports.prevent = function (location) {
    var state = location.state, rest = __rest(location, ["state"]);
    prevented.push(rest);
};
exports.hasBeenPrevented = function (location) {
    return prevented.some(function (preventedLocation) { return isEqual(location, preventedLocation); });
};
exports.shouldPrevent = function (location) {
    return Boolean(location.state && location.state.preventLastLocation);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var LastLocationContext_1 = __webpack_require__(3);
function useLastLocation() {
    return react_1.useContext(LastLocationContext_1.default);
}
exports.default = useLastLocation;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(1);
var history_1 = __webpack_require__(10);
var RedirectWithoutLastLocation = function (_a) {
    var to = _a.to, rest = __rest(_a, ["to"]);
    var finalTo;
    if (typeof to === 'string') {
        finalTo = history_1.createLocation(to, { preventLastLocation: true });
    }
    else {
        finalTo = __assign({}, to, { state: __assign({ preventLastLocation: true }, to.state) });
    }
    return React.createElement(react_router_dom_1.Redirect, __assign({}, rest, { to: finalTo }));
};
exports.default = RedirectWithoutLastLocation;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ })
/******/ ]);
});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(15).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(36)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckoutContainer__ = __webpack_require__(1041);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CheckoutContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkout__ = __webpack_require__(1043);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Checkout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SecondFactorAuthenticaton__ = __webpack_require__(95);
/* unused harmony reexport SecondFactorAuthenticaton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["c"]; });


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Address__ = __webpack_require__(486);
/* unused harmony reexport Address */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Address__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Profile__ = __webpack_require__(488);
/* unused harmony reexport Profile */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Profile__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__genderTypes__ = __webpack_require__(1054);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__genderTypes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__maritalStatuses__ = __webpack_require__(1055);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__maritalStatuses__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profileStatuses__ = __webpack_require__(1056);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__profileStatuses__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Extract__ = __webpack_require__(194);
/* unused harmony reexport Extract */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Extract__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TwoStepVerification__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__TwoStepVerification__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__TwoStepVerification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChangePassword__ = __webpack_require__(1106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__ChangePassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SecurityAccess__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__SecurityAccess__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TokenChangeEmail__ = __webpack_require__(534);
/* unused harmony reexport TokenChangeEmailPage */


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var MIME_MAP = [
    { type: 'text/plain', ext: 'txt' },
    { type: 'text/html', ext: 'html' },
    { type: 'text/javascript', ext: 'js' },
    { type: 'text/css', ext: 'css' },
    { type: 'text/csv', ext: 'csv' },
    { type: 'text/yaml', ext: 'yml' },
    { type: 'text/yaml', ext: 'yaml' },
    { type: 'text/calendar', ext: 'ics' },
    { type: 'text/calendar', ext: 'ical' },
    { type: 'image/png', ext: 'png' },
    { type: 'image/gif', ext: 'gif' },
    { type: 'image/jpeg', ext: 'jpg' },
    { type: 'image/jpeg', ext: 'jpeg' },
    { type: 'image/bmp', ext: 'bmp' },
    { type: 'image/x-icon', ext: 'ico' },
    { type: 'image/tiff', ext: 'tif' },
    { type: 'image/tiff', ext: 'tiff' },
    { type: 'image/svg+xml', ext: 'svg' },
    { type: 'application/json', ext: 'json' },
    { type: 'application/xml', ext: 'xml' },
    { type: 'application/x-sh', ext: 'sh' },
    { type: 'application/zip', ext: 'zip' },
    { type: 'application/x-rar-compressed', ext: 'rar' },
    { type: 'application/x-tar', ext: 'tar' },
    { type: 'application/x-bzip', ext: 'bz' },
    { type: 'application/x-bzip2', ext: 'bz2' },
    { type: 'application/pdf', ext: 'pdf' },
    { type: 'application/java-archive', ext: 'jar' },
    { type: 'application/msword', ext: 'doc' },
    { type: 'application/vnd.ms-excel', ext: 'xls' },
    { type: 'application/vnd.ms-excel', ext: 'xlsx' },
    { type: 'message/rfc822', ext: 'eml' },
];
var JS = /** @class */ (function () {
    function JS() {
    }
    JS.isEmpty = function (obj) {
        return Object.keys(obj).length === 0;
    };
    JS.sortByField = function (list, field, dir) {
        if (!list || !list.sort) {
            return false;
        }
        var dirX = dir && dir === 'desc' ? -1 : 1;
        list.sort(function (a, b) {
            var a_val = a[field];
            var b_val = b[field];
            if (typeof b_val === 'undefined') {
                return typeof a_val === 'undefined' ? 0 : 1 * dirX;
            }
            if (typeof a_val === 'undefined') {
                return -1 * dirX;
            }
            if (a_val < b_val) {
                return -1 * dirX;
            }
            if (a_val > b_val) {
                return 1 * dirX;
            }
            return 0;
        });
        return true;
    };
    JS.objectLessAttributes = function (obj, less) {
        var ret = Object.assign({}, obj);
        if (less) {
            if (typeof less === 'string') {
                delete ret[less];
            }
            else {
                less.forEach(function (attr) {
                    delete ret[attr];
                });
            }
        }
        return ret;
    };
    JS.filenameToContentType = function (filename, defVal) {
        if (defVal === void 0) { defVal = 'application/octet-stream'; }
        var name = filename.toLowerCase();
        var filtered = MIME_MAP.filter(function (mime) { return name.endsWith('.' + mime.ext); });
        return filtered.length > 0 ? filtered[0].type : defVal;
    };
    JS.isTextFile = function (contentType) {
        var type = contentType.toLowerCase();
        if (type.startsWith('text/')) {
            return true;
        }
        return ('application/json' === type ||
            'application/xml' === type ||
            'application/sh' === type);
    };
    /**
     * generate random string
     */
    JS.generateRandomString = function () {
        var result = '';
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (var i = 32; i > 0; i -= 1) {
            result += chars[Math.floor(Math.random() * chars.length)];
        }
        return result;
    };
    JS.makeQuerablePromise = function (promise) {
        if (promise.isResolved)
            return promise;
        var isPending = true;
        var isRejected = false;
        var isFullfilled = false;
        var result = promise.then(function (data) {
            isFullfilled = true;
            isPending = false;
            return data;
        }, function (e) {
            isRejected = true;
            isPending = false;
            throw e;
        });
        result.isFullfilled = function () {
            return isFullfilled;
        };
        result.isPending = function () {
            return isPending;
        };
        result.isRejected = function () {
            return isRejected;
        };
        return result;
    };
    JS.browserOrNode = function () {
        var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
        var isNode = typeof process !== 'undefined' &&
            process.versions != null &&
            process.versions.node != null;
        return {
            isBrowser: isBrowser,
            isNode: isNode,
        };
    };
    /**
     * transfer the first letter of the keys to lowercase
     * @param {Object} obj - the object need to be transferred
     * @param {Array} whiteListForItself - whitelist itself from being transferred
     * @param {Array} whiteListForChildren - whitelist its children keys from being transferred
     */
    JS.transferKeyToLowerCase = function (obj, whiteListForItself, whiteListForChildren) {
        if (whiteListForItself === void 0) { whiteListForItself = []; }
        if (whiteListForChildren === void 0) { whiteListForChildren = []; }
        if (!JS.isStrictObject(obj))
            return obj;
        var ret = {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var transferedKey = whiteListForItself.includes(key)
                    ? key
                    : key[0].toLowerCase() + key.slice(1);
                ret[transferedKey] = whiteListForChildren.includes(key)
                    ? obj[key]
                    : JS.transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
            }
        }
        return ret;
    };
    /**
     * transfer the first letter of the keys to lowercase
     * @param {Object} obj - the object need to be transferred
     * @param {Array} whiteListForItself - whitelist itself from being transferred
     * @param {Array} whiteListForChildren - whitelist its children keys from being transferred
     */
    JS.transferKeyToUpperCase = function (obj, whiteListForItself, whiteListForChildren) {
        if (whiteListForItself === void 0) { whiteListForItself = []; }
        if (whiteListForChildren === void 0) { whiteListForChildren = []; }
        if (!JS.isStrictObject(obj))
            return obj;
        var ret = {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var transferedKey = whiteListForItself.includes(key)
                    ? key
                    : key[0].toUpperCase() + key.slice(1);
                ret[transferedKey] = whiteListForChildren.includes(key)
                    ? obj[key]
                    : JS.transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
            }
        }
        return ret;
    };
    /**
     * Return true if the object is a strict object
     * which means it's not Array, Function, Number, String, Boolean or Null
     * @param obj the Object
     */
    JS.isStrictObject = function (obj) {
        return (obj instanceof Object &&
            !(obj instanceof Array) &&
            !(obj instanceof Function) &&
            !(obj instanceof Number) &&
            !(obj instanceof String) &&
            !(obj instanceof Boolean));
    };
    return JS;
}());
/* harmony default export */ __webpack_exports__["a"] = (JS);
//# sourceMappingURL=JS.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SummaryOrder__ = __webpack_require__(1235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__SummaryOrder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmitButton__ = __webpack_require__(1236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SubmitButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(1237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingValue__ = __webpack_require__(1238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ShippingValue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TotalValue__ = __webpack_require__(1239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__TotalValue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TotalPointsCash__ = __webpack_require__(1240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__TotalPointsCash__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TotalCashOnly__ = __webpack_require__(1241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__TotalCashOnly__["a"]; });


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* harmony export (immutable) */__webpack_exports__["d"] = isError;
/* harmony export (immutable) */__webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */__webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */__webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */__webpack_exports__["k"] = isString;
/* harmony export (immutable) */__webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */__webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */__webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */__webpack_exports__["c"] = isElement;
/* harmony export (immutable) */__webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */__webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */__webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */__webpack_exports__["g"] = isInstanceOf;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat === "undefined" ? "undefined" : _typeof(wat)) !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === 'function');
    // tslint:enable:no-unsafe-any
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(1463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegulationContainer__ = __webpack_require__(1465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__RegulationContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegulationPage__ = __webpack_require__(589);
/* unused harmony reexport RegulationPage */


/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComunidadeIuup__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ComunidadeIuup__["a"]; });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _star["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _star = _interopRequireDefault(__webpack_require__(1865));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Rater =
/*#__PURE__*/
function (_Component) {
  _inherits(Rater, _Component);

  function Rater(props) {
    var _this;

    _classCallCheck(this, Rater);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rater).call(this, props));
    _this.state = {
      rating: props.rating,
      lastRating: props.rating,
      isRating: false
    };
    return _this;
  }

  _createClass(Rater, [{
    key: "willRate",
    value: function willRate(rating, e) {
      this.setState({
        rating: rating,
        isRating: true
      });
      var callback = this.props.onRating;
      callback && callback(_objectSpread({}, e, {
        rating: rating
      }));
    }
  }, {
    key: "onRate",
    value: function onRate(rating, e) {
      this.setState({
        rating: rating,
        lastRating: rating,
        isRating: false
      });
      var callback = this.props.onRate;
      callback && callback(_objectSpread({}, e, {
        rating: rating
      }));
    }
  }, {
    key: "onCancelRate",
    value: function onCancelRate() {
      var rating = this.state.lastRating;
      this.setState({
        rating: rating,
        isRating: false
      });
      var callback = this.props.onCancelRate;
      callback && callback({
        rating: rating
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps, props) {
      var rating = nextProps.rating;

      if (rating !== props.rating) {
        this.setState({
          rating: rating,
          lastRating: rating
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          total = _this$props.total,
          interactive = _this$props.interactive,
          children = _this$props.children,
          restProps = _objectWithoutProperties(_this$props, ["total", "interactive", "children"]);

      var _this$state = this.state,
          rating = _this$state.rating,
          isRating = _this$state.isRating;
      children = _react.Children.toArray(children);
      delete restProps.rating;
      delete restProps.onRate;
      delete restProps.onRating;
      delete restProps.onCancelRate;
      var nodes = Array.apply(null, Array(total)).map(function (_, i) {
        var starProps = {
          isActive: !isRating && rating - i >= 1,
          willBeActive: isRating && i < rating,
          isActiveHalf: !isRating && rating - i >= 0.5 && rating - i < 1,
          isDisabled: !interactive
        };
        return _react["default"].createElement("div", {
          key: "star-".concat(i),
          onClick: interactive ? _this2.onRate.bind(_this2, i + 1) : null,
          onMouseOver: interactive ? _this2.willRate.bind(_this2, i + 1) : null
        }, children.length ? _react["default"].cloneElement(children[i % children.length], starProps) : _react["default"].createElement(_star["default"], starProps));
      });

      if (interactive) {
        return _react["default"].createElement("div", _extends({
          className: "react-rater",
          onMouseOut: this.onCancelRate.bind(this)
        }, restProps), nodes);
      } else {
        return _react["default"].createElement("div", _extends({
          className: "react-rater"
        }, restProps), nodes);
      }
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Rater;
}(_react.Component);

exports["default"] = Rater;
Rater.propTypes = {
  total: _propTypes["default"].number,
  rating: _propTypes["default"].number,
  interactive: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  onRate: _propTypes["default"].func,
  onRating: _propTypes["default"].func,
  onCancelRate: _propTypes["default"].func
};
Rater.defaultProps = {
  total: 5,
  rating: 0,
  interactive: true
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Rater, "Rater", "/Users/simon/Individual/react-rater/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(32).f;
var has = __webpack_require__(56);
var TAG = __webpack_require__(26)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(65);
var TAG = __webpack_require__(26)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var defined = __webpack_require__(73);
var fails = __webpack_require__(19);
var spaces = __webpack_require__(336);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createUserManager__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRedirectUri__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oidc_client__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_oidc_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_device_detect__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
var isSilentRenewEnabled=function isSilentRenewEnabled(){var enabled=false;if(__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SILENT_RENEW)){enabled=__WEBPACK_IMPORTED_MODULE_3_react_device_detect__["isMobile"]&&Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SILENT_RENEW_PLATFORMS.includes('MOBILE')||__WEBPACK_IMPORTED_MODULE_3_react_device_detect__["isBrowser"]&&Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SILENT_RENEW_PLATFORMS.includes('BROWSER');}return enabled;};var getResponseType=function getResponseType(){if(isSilentRenewEnabled()){return'code';}else{return'token id_token';}};var getClientId=function getClientId(){if(__WEBPACK_IMPORTED_MODULE_3_react_device_detect__["isMobile"]){return Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_CLIENT_ID_MOBILE||"1tbhh14ofdn4d5oof5dm32nmen";}else{return "1tbhh14ofdn4d5oof5dm32nmen";}};var getUserStore=function getUserStore(){if(isSilentRenewEnabled()){return new __WEBPACK_IMPORTED_MODULE_2_oidc_client__["WebStorageStateStore"]({store:window.localStorage});}else{return new __WEBPACK_IMPORTED_MODULE_2_oidc_client__["WebStorageStateStore"]({store:window.sessionStorage});}};var config={authority:"https://auth.tupperwarepremios.premmiar.io"+'/.well-known/openid-configuration',scope:'profile email openid aws.cognito.signin.user.admin webpremios.campaigns/'+"70885",client_id:getClientId(),userStore:getUserStore(),response_type:getResponseType(),automaticSilentRenew:isSilentRenewEnabled(),//  accessTokenExpiringNotificationTime: 280,
redirect_uri:Object(__WEBPACK_IMPORTED_MODULE_1__createRedirectUri__["a" /* default */])()};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createUserManager__["a" /* default */])(config));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var MD5 = __webpack_require__(242)
var RIPEMD160 = __webpack_require__(248)
var sha = __webpack_require__(249)
var Base = __webpack_require__(84)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var assert = __webpack_require__(52);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(33);

asn1.define = __webpack_require__(847).define;
asn1.base = __webpack_require__(144);
asn1.constants = __webpack_require__(417);
asn1.decoders = __webpack_require__(852);
asn1.encoders = __webpack_require__(854);


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(849).Reporter;
base.DecoderBuffer = __webpack_require__(416).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(416).EncoderBuffer;
base.Node = __webpack_require__(850);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_App_Shell_ShellContainer__ = __webpack_require__(426);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_App_Shell_ShellRoute__ = __webpack_require__(937);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1_App_Shell_ShellRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Shell_Shell__ = __webpack_require__(938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2_App_Shell_Shell__["a"]; });


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainMenu__ = __webpack_require__(261);
/* unused harmony reexport MainMenu */
/* unused harmony reexport MainMenuPublic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainMenuContainer__ = __webpack_require__(923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__MainMenuContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainMenuPublicContainer__ = __webpack_require__(924);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__MainMenuPublicContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OnlyCash_reducer__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__OnlyCash_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TradeMenu_SubItems_ProductCategory_reducer__ = __webpack_require__(933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__TradeMenu_SubItems_ProductCategory_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeMenu_SubItems_EcommerceStore_reducer__ = __webpack_require__(934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__TradeMenu_SubItems_EcommerceStore_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradeMenu_SubItems_ProductCategory_actions__ = __webpack_require__(935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__TradeMenu_SubItems_ProductCategory_actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TradeMenu_SubItems_EcommerceStore_actions__ = __webpack_require__(936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__TradeMenu_SubItems_EcommerceStore_actions__["a"]; });


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductImage__ = __webpack_require__(996);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductImage__["a"]; });


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(0), __webpack_require__(42));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["react-owl-carousel2"] = factory(require("prop-types"), require("react"), require("react-dom"));
	else
		root["react-owl-carousel2"] = factory(root["PropTypes"], root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	eval("'use strict';\n\nObject.defineProperty(exports, \"__esModule\", {\n\tvalue: true\n});\n\nvar _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };\n\nvar _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();\n\nvar _react = __webpack_require__(4);\n\nvar _react2 = _interopRequireDefault(_react);\n\nvar _reactDom = __webpack_require__(5);\n\nvar _propTypes = __webpack_require__(3);\n\nvar _propTypes2 = _interopRequireDefault(_propTypes);\n\n__webpack_require__(2);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nfunction _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return call && (typeof call === \"object\" || typeof call === \"function\") ? call : self; }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function, not \" + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }\n\nvar owlCarouselOptions = {\n\tcore: ['items', 'loop', 'center', 'rewind', 'mouseDrag', 'touchDrag', 'pullDrag', 'freeDrag', 'margin', 'stagePadding', 'merge', 'mergeFit', 'autoWidth', 'startPosition', 'rtl', 'smartSpeed', 'fluidSpeed', 'dragEndSpeed', 'responsive', 'responsiveRefreshRate', 'responsiveBaseElement', 'fallbackEasing', 'info', 'nestedItemSelector', 'itemElement', 'stageElement', 'refreshClass', 'loadedClass', 'loadingClass', 'rtlClass', 'responsiveClass', 'dragClass', 'itemClass', 'stageClass', 'stageOuterClass', 'grabClass'],\n\tautorefresh: ['autoRefresh', 'autoRefreshInterval'],\n\tlazy: ['lazyLoad'],\n\tautoHeight: ['autoHeight', 'autoHeightClass'],\n\tvideo: ['video', 'videoHeight', 'videoWidth'],\n\tanimate: ['animateOut', 'animateIn'],\n\tautoplay: ['autoplay', 'autoplayTimeout', 'autoplayHoverPause', 'autoplaySpeed'],\n\tnavigation: ['nav', 'navText', 'navSpeed', 'navElement', 'navContainer', 'navContainerClass', 'navClass', 'slideBy', 'dotClass', 'dotsClass', 'dots', 'dotsEach', 'dotsData', 'dotsSpeed', 'dotsContainer'],\n\thash: ['URLhashListener']\n};\n\nvar owlCarouselEvents = {\n\tcore: ['onInitialize', 'onInitialized', 'onResize', 'onResized', 'onRefresh', 'onRefreshed', 'onDrag', 'onDragged', 'onTranslate', 'onTranslated', 'onChange', 'onChanged'],\n\tlazy: ['onLoadLazy', 'onLoadedLazy'],\n\tvideo: ['onStopVideo', 'onPlayVideo']\n};\n\nvar OwlCarousel = function (_React$Component) {\n\t_inherits(OwlCarousel, _React$Component);\n\n\tfunction OwlCarousel(props, context) {\n\t\t_classCallCheck(this, OwlCarousel);\n\n\t\tvar _this = _possibleConstructorReturn(this, (OwlCarousel.__proto__ || Object.getPrototypeOf(OwlCarousel)).call(this, props, context));\n\n\t\t_this.onTranslate = function (next) {\n\t\t\treturn function (event) {\n\t\t\t\t_this.currentPosition = event.item.index;\n\t\t\t\tif (next) next(event);\n\t\t\t};\n\t\t};\n\n\t\t_this.next = function () {\n\t\t\treturn _this.$car.next();\n\t\t};\n\t\t_this.prev = function () {\n\t\t\treturn _this.$car.prev();\n\t\t};\n\t\t_this.goTo = function (x) {\n\t\t\treturn _this.$car.to(x);\n\t\t};\n\n\t\t_this.currentPosition = 0;\n\t\t_this.onTranslate = _this.onTranslate.bind(_this);\n\t\treturn _this;\n\t}\n\n\t_createClass(OwlCarousel, [{\n\t\tkey: 'componentDidMount',\n\t\tvalue: function componentDidMount() {\n\t\t\t__webpack_require__(1);\n\t\t\tvar options = this.getOptions();\n\t\t\tthis.init(options);\n\t\t}\n\t}, {\n\t\tkey: 'componentWillReceiveProps',\n\t\tvalue: function componentWillReceiveProps(nextProps) {\n\t\t\tthis.destroy();\n\t\t}\n\t}, {\n\t\tkey: 'componentDidUpdate',\n\t\tvalue: function componentDidUpdate(prevProps, prevState) {\n\t\t\tvar options = this.getOptions();\n\t\t\toptions.startPosition = this.currentPosition;\n\t\t\tthis.init(options);\n\t\t}\n\t}, {\n\t\tkey: 'componentWillUnmount',\n\t\tvalue: function componentWillUnmount() {\n\t\t\tthis.destroy();\n\t\t}\n\t}, {\n\t\tkey: 'init',\n\t\tvalue: function init(options) {\n\t\t\tvar next = options.onTranslate;\n\t\t\toptions.onTranslate = this.onTranslate(next);\n\t\t\tthis.$node.owlCarousel(options);\n\t\t\tthis.$car = this.$node.data('owl.carousel');\n\t\t}\n\t}, {\n\t\tkey: 'destroy',\n\t\tvalue: function destroy() {\n\t\t\tthis.$car.destroy();\n\t\t}\n\t}, {\n\t\tkey: 'getOptions',\n\t\tvalue: function getOptions() {\n\t\t\tvar _this2 = this;\n\n\t\t\tvar options = {};\n\n\t\t\tvar carOptions = Object.values(owlCarouselOptions).reduce(function (a, v) {\n\t\t\t\treturn a.concat(v);\n\t\t\t}, []);\n\n\t\t\tcarOptions.forEach(function (val) {\n\t\t\t\tif (val in _this2.props.options) options[val] = _this2.props.options[val];\n\t\t\t});\n\n\t\t\tvar carEvents = Object.values(owlCarouselEvents).reduce(function (a, v) {\n\t\t\t\treturn a.concat(v);\n\t\t\t}, []);\n\n\t\t\tcarEvents.forEach(function (val) {\n\t\t\t\tif (val in _this2.props.events) options[val] = _this2.props.events[val];\n\t\t\t});\n\n\t\t\treturn options;\n\t\t}\n\t}, {\n\t\tkey: 'render',\n\t\tvalue: function render() {\n\t\t\tvar _this3 = this;\n\n\t\t\tvar _props = this.props,\n\t\t\t    options = _props.options,\n\t\t\t    events = _props.events,\n\t\t\t    children = _props.children,\n\t\t\t    props = _objectWithoutProperties(_props, ['options', 'events', 'children']);\n\n\t\t\treturn _react2.default.createElement(\n\t\t\t\t'div',\n\t\t\t\t_extends({ ref: function ref(item) {\n\t\t\t\t\t\treturn _this3.$node = $((0, _reactDom.findDOMNode)(item));\n\t\t\t\t\t}, className: 'owl-carousel owl-theme' }, props),\n\t\t\t\tchildren\n\t\t\t);\n\t\t}\n\t}]);\n\n\treturn OwlCarousel;\n}(_react2.default.Component);\n\nOwlCarousel.propTypes = {\n\tchildren: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element.isRequired)]).isRequired,\n\n\tstyle: _propTypes2.default.object,\n\tid: _propTypes2.default.string,\n\n\toptions: _propTypes2.default.shape({\n\t\t// core\n\t\titems: _propTypes2.default.number,\n\t\tloop: _propTypes2.default.bool,\n\t\tcenter: _propTypes2.default.bool,\n\t\trewind: _propTypes2.default.bool,\n\n\t\tmouseDrag: _propTypes2.default.bool,\n\t\ttouchDrag: _propTypes2.default.bool,\n\t\tpullDrag: _propTypes2.default.bool,\n\t\tfreeDrag: _propTypes2.default.bool,\n\n\t\tmargin: _propTypes2.default.number,\n\t\tstagePadding: _propTypes2.default.number,\n\n\t\tmerge: _propTypes2.default.bool,\n\t\tmergeFit: _propTypes2.default.bool,\n\t\tautoWidth: _propTypes2.default.bool,\n\n\t\tstartPosition: _propTypes2.default.number,\n\t\trtl: _propTypes2.default.bool,\n\n\t\tsmartSpeed: _propTypes2.default.number,\n\t\tfluidSpeed: _propTypes2.default.bool,\n\t\tdragEndSpeed: _propTypes2.default.bool,\n\n\t\tresponsive: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),\n\t\tresponsiveRefreshRate: _propTypes2.default.number,\n\t\tresponsiveBaseElement: _propTypes2.default.object,\n\n\t\tfallbackEasing: _propTypes2.default.string,\n\n\t\tinfo: _propTypes2.default.bool,\n\n\t\tnestedItemSelector: _propTypes2.default.bool,\n\t\titemElement: _propTypes2.default.string,\n\t\tstageElement: _propTypes2.default.string,\n\n\t\trefreshClass: _propTypes2.default.string,\n\t\tloadedClass: _propTypes2.default.string,\n\t\tloadingClass: _propTypes2.default.string,\n\t\trtlClass: _propTypes2.default.string,\n\t\tresponsiveClass: _propTypes2.default.string,\n\t\tdragClass: _propTypes2.default.string,\n\t\titemClass: _propTypes2.default.string,\n\t\tstageClass: _propTypes2.default.string,\n\t\tstageOuterClass: _propTypes2.default.string,\n\t\tgrabClass: _propTypes2.default.string,\n\n\t\t// autoRefresh\n\t\tautoRefresh: _propTypes2.default.bool,\n\t\tautoRefreshInterval: _propTypes2.default.number,\n\n\t\t// lazy\n\t\tlazyLoad: _propTypes2.default.bool,\n\n\t\t// autoHeight\n\t\tautoHeight: _propTypes2.default.bool,\n\t\tautoHeightClass: _propTypes2.default.string,\n\n\t\t// video\n\t\tvideo: _propTypes2.default.bool,\n\t\tvideoHeight: _propTypes2.default.bool,\n\t\tvideoWidth: _propTypes2.default.bool,\n\n\t\t// animate\n\t\tanimateOut: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),\n\t\tanimateIn: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),\n\n\t\t// autoplay\n\t\tautoplay: _propTypes2.default.bool,\n\t\tautoplayTimeout: _propTypes2.default.number,\n\t\tautoplayHoverPause: _propTypes2.default.bool,\n\t\tautoplaySpeed: _propTypes2.default.bool,\n\n\t\t// navigation\n\t\tnav: _propTypes2.default.bool,\n\t\tnavText: _propTypes2.default.array,\n\t\tnavSpeed: _propTypes2.default.bool,\n\t\tnavElement: _propTypes2.default.string,\n\t\tnavContainer: _propTypes2.default.bool,\n\t\tnavContainerClass: _propTypes2.default.string,\n\t\tnavClass: _propTypes2.default.array,\n\t\tslideBy: _propTypes2.default.number,\n\t\tdotClass: _propTypes2.default.string,\n\t\tdotsClass: _propTypes2.default.string,\n\t\tdots: _propTypes2.default.bool,\n\t\tdotsEach: _propTypes2.default.bool,\n\t\tdotsData: _propTypes2.default.bool,\n\t\tdotsSpeed: _propTypes2.default.bool,\n\t\tdotsContainer: _propTypes2.default.bool,\n\n\t\t// hash\n\t\tURLhashListener: _propTypes2.default.bool\n\t}),\n\n\tevents: _propTypes2.default.shape({\n\t\t// core\n\t\tonInitialize: _propTypes2.default.func,\n\t\tonInitialized: _propTypes2.default.func,\n\t\tonResize: _propTypes2.default.func,\n\t\tonResized: _propTypes2.default.func,\n\t\tonRefresh: _propTypes2.default.func,\n\t\tonRefreshed: _propTypes2.default.func,\n\t\tonDrag: _propTypes2.default.func,\n\t\tonDragged: _propTypes2.default.func,\n\t\tonTranslate: _propTypes2.default.func,\n\t\tonTranslated: _propTypes2.default.func,\n\t\tonChange: _propTypes2.default.func,\n\t\tonChanged: _propTypes2.default.func,\n\n\t\t// lazy\n\t\tonLoadLazy: _propTypes2.default.func,\n\t\tonLoadedLazy: _propTypes2.default.func,\n\n\t\t// video\n\t\tonStopVideo: _propTypes2.default.func,\n\t\tonPlayVideo: _propTypes2.default.func\n\t})\n};\n\nOwlCarousel.defaultProps = {\n\toptions: {},\n\tevents: {}\n};\n\nexports.default = OwlCarousel;\nmodule.exports = exports['default'];\n\n/*****************\n ** WEBPACK FOOTER\n ** ./components/OwlCarousel.jsx\n ** module id = 0\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///./components/OwlCarousel.jsx?");

/***/ },
/* 1 */
/***/ function(module, exports) {

	eval("'use strict';\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/**\n * Owl Carousel v2.2.1\n * Copyright 2013-2017 David Deutsch\n * Licensed under  ()\n */\n/**\n * Owl carousel\n * @version 2.1.6\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n * @todo Lazy Load Icon\n * @todo prevent animationend bubling\n * @todo itemsScaleUp\n * @todo Test Zepto\n * @todo stagePadding calculate wrong active classes\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates a carousel.\n  * @class The Owl Carousel.\n  * @public\n  * @param {HTMLElement|jQuery} element - The element to create the carousel for.\n  * @param {Object} [options] - The options\n  */\n\tfunction Owl(element, options) {\n\n\t\t/**\n   * Current settings for the carousel.\n   * @public\n   */\n\t\tthis.settings = null;\n\n\t\t/**\n   * Current options set by the caller including defaults.\n   * @public\n   */\n\t\tthis.options = $.extend({}, Owl.Defaults, options);\n\n\t\t/**\n   * Plugin element.\n   * @public\n   */\n\t\tthis.$element = $(element);\n\n\t\t/**\n   * Proxied event handlers.\n   * @protected\n   */\n\t\tthis._handlers = {};\n\n\t\t/**\n   * References to the running plugins of this carousel.\n   * @protected\n   */\n\t\tthis._plugins = {};\n\n\t\t/**\n   * Currently suppressed events to prevent them from beeing retriggered.\n   * @protected\n   */\n\t\tthis._supress = {};\n\n\t\t/**\n   * Absolute current position.\n   * @protected\n   */\n\t\tthis._current = null;\n\n\t\t/**\n   * Animation speed in milliseconds.\n   * @protected\n   */\n\t\tthis._speed = null;\n\n\t\t/**\n   * Coordinates of all items in pixel.\n   * @todo The name of this member is missleading.\n   * @protected\n   */\n\t\tthis._coordinates = [];\n\n\t\t/**\n   * Current breakpoint.\n   * @todo Real media queries would be nice.\n   * @protected\n   */\n\t\tthis._breakpoint = null;\n\n\t\t/**\n   * Current width of the plugin element.\n   */\n\t\tthis._width = null;\n\n\t\t/**\n   * All real items.\n   * @protected\n   */\n\t\tthis._items = [];\n\n\t\t/**\n   * All cloned items.\n   * @protected\n   */\n\t\tthis._clones = [];\n\n\t\t/**\n   * Merge values of all items.\n   * @todo Maybe this could be part of a plugin.\n   * @protected\n   */\n\t\tthis._mergers = [];\n\n\t\t/**\n   * Widths of all items.\n   */\n\t\tthis._widths = [];\n\n\t\t/**\n   * Invalidated parts within the update process.\n   * @protected\n   */\n\t\tthis._invalidated = {};\n\n\t\t/**\n   * Ordered list of workers for the update process.\n   * @protected\n   */\n\t\tthis._pipe = [];\n\n\t\t/**\n   * Current state information for the drag operation.\n   * @todo #261\n   * @protected\n   */\n\t\tthis._drag = {\n\t\t\ttime: null,\n\t\t\ttarget: null,\n\t\t\tpointer: null,\n\t\t\tstage: {\n\t\t\t\tstart: null,\n\t\t\t\tcurrent: null\n\t\t\t},\n\t\t\tdirection: null\n\t\t};\n\n\t\t/**\n   * Current state information and their tags.\n   * @type {Object}\n   * @protected\n   */\n\t\tthis._states = {\n\t\t\tcurrent: {},\n\t\t\ttags: {\n\t\t\t\t'initializing': ['busy'],\n\t\t\t\t'animating': ['busy'],\n\t\t\t\t'dragging': ['interacting']\n\t\t\t}\n\t\t};\n\n\t\t$.each(['onResize', 'onThrottledResize'], $.proxy(function (i, handler) {\n\t\t\tthis._handlers[handler] = $.proxy(this[handler], this);\n\t\t}, this));\n\n\t\t$.each(Owl.Plugins, $.proxy(function (key, plugin) {\n\t\t\tthis._plugins[key.charAt(0).toLowerCase() + key.slice(1)] = new plugin(this);\n\t\t}, this));\n\n\t\t$.each(Owl.Workers, $.proxy(function (priority, worker) {\n\t\t\tthis._pipe.push({\n\t\t\t\t'filter': worker.filter,\n\t\t\t\t'run': $.proxy(worker.run, this)\n\t\t\t});\n\t\t}, this));\n\n\t\tthis.setup();\n\t\tthis.initialize();\n\t}\n\n\t/**\n  * Default options for the carousel.\n  * @public\n  */\n\tOwl.Defaults = {\n\t\titems: 3,\n\t\tloop: false,\n\t\tcenter: false,\n\t\trewind: false,\n\n\t\tmouseDrag: true,\n\t\ttouchDrag: true,\n\t\tpullDrag: true,\n\t\tfreeDrag: false,\n\n\t\tmargin: 0,\n\t\tstagePadding: 0,\n\n\t\tmerge: false,\n\t\tmergeFit: true,\n\t\tautoWidth: false,\n\n\t\tstartPosition: 0,\n\t\trtl: false,\n\n\t\tsmartSpeed: 250,\n\t\tfluidSpeed: false,\n\t\tdragEndSpeed: false,\n\n\t\tresponsive: {},\n\t\tresponsiveRefreshRate: 200,\n\t\tresponsiveBaseElement: window,\n\n\t\tfallbackEasing: 'swing',\n\n\t\tinfo: false,\n\n\t\tnestedItemSelector: false,\n\t\titemElement: 'div',\n\t\tstageElement: 'div',\n\n\t\trefreshClass: 'owl-refresh',\n\t\tloadedClass: 'owl-loaded',\n\t\tloadingClass: 'owl-loading',\n\t\trtlClass: 'owl-rtl',\n\t\tresponsiveClass: 'owl-responsive',\n\t\tdragClass: 'owl-drag',\n\t\titemClass: 'owl-item',\n\t\tstageClass: 'owl-stage',\n\t\tstageOuterClass: 'owl-stage-outer',\n\t\tgrabClass: 'owl-grab'\n\t};\n\n\t/**\n  * Enumeration for width.\n  * @public\n  * @readonly\n  * @enum {String}\n  */\n\tOwl.Width = {\n\t\tDefault: 'default',\n\t\tInner: 'inner',\n\t\tOuter: 'outer'\n\t};\n\n\t/**\n  * Enumeration for types.\n  * @public\n  * @readonly\n  * @enum {String}\n  */\n\tOwl.Type = {\n\t\tEvent: 'event',\n\t\tState: 'state'\n\t};\n\n\t/**\n  * Contains all registered plugins.\n  * @public\n  */\n\tOwl.Plugins = {};\n\n\t/**\n  * List of workers involved in the update process.\n  */\n\tOwl.Workers = [{\n\t\tfilter: ['width', 'settings'],\n\t\trun: function run() {\n\t\t\tthis._width = this.$element.width();\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tcache.current = this._items && this._items[this.relative(this._current)];\n\t\t}\n\t}, {\n\t\tfilter: ['items', 'settings'],\n\t\trun: function run() {\n\t\t\tthis.$stage.children('.cloned').remove();\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tvar margin = this.settings.margin || '',\n\t\t\t    grid = !this.settings.autoWidth,\n\t\t\t    rtl = this.settings.rtl,\n\t\t\t    css = {\n\t\t\t\t'width': 'auto',\n\t\t\t\t'margin-left': rtl ? margin : '',\n\t\t\t\t'margin-right': rtl ? '' : margin\n\t\t\t};\n\n\t\t\t!grid && this.$stage.children().css(css);\n\n\t\t\tcache.css = css;\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tvar width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,\n\t\t\t    merge = null,\n\t\t\t    iterator = this._items.length,\n\t\t\t    grid = !this.settings.autoWidth,\n\t\t\t    widths = [];\n\n\t\t\tcache.items = {\n\t\t\t\tmerge: false,\n\t\t\t\twidth: width\n\t\t\t};\n\n\t\t\twhile (iterator--) {\n\t\t\t\tmerge = this._mergers[iterator];\n\t\t\t\tmerge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;\n\n\t\t\t\tcache.items.merge = merge > 1 || cache.items.merge;\n\n\t\t\t\twidths[iterator] = !grid ? this._items[iterator].width() : width * merge;\n\t\t\t}\n\n\t\t\tthis._widths = widths;\n\t\t}\n\t}, {\n\t\tfilter: ['items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar clones = [],\n\t\t\t    items = this._items,\n\t\t\t    settings = this.settings,\n\n\t\t\t// TODO: Should be computed from number of min width items in stage\n\t\t\tview = Math.max(settings.items * 2, 4),\n\t\t\t    size = Math.ceil(items.length / 2) * 2,\n\t\t\t    repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,\n\t\t\t    append = '',\n\t\t\t    prepend = '';\n\n\t\t\trepeat /= 2;\n\n\t\t\twhile (repeat--) {\n\t\t\t\t// Switch to only using appended clones\n\t\t\t\tclones.push(this.normalize(clones.length / 2, true));\n\t\t\t\tappend = append + items[clones[clones.length - 1]][0].outerHTML;\n\t\t\t\tclones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));\n\t\t\t\tprepend = items[clones[clones.length - 1]][0].outerHTML + prepend;\n\t\t\t}\n\n\t\t\tthis._clones = clones;\n\n\t\t\t$(append).addClass('cloned').appendTo(this.$stage);\n\t\t\t$(prepend).addClass('cloned').prependTo(this.$stage);\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar rtl = this.settings.rtl ? 1 : -1,\n\t\t\t    size = this._clones.length + this._items.length,\n\t\t\t    iterator = -1,\n\t\t\t    previous = 0,\n\t\t\t    current = 0,\n\t\t\t    coordinates = [];\n\n\t\t\twhile (++iterator < size) {\n\t\t\t\tprevious = coordinates[iterator - 1] || 0;\n\t\t\t\tcurrent = this._widths[this.relative(iterator)] + this.settings.margin;\n\t\t\t\tcoordinates.push(previous + current * rtl);\n\t\t\t}\n\n\t\t\tthis._coordinates = coordinates;\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar padding = this.settings.stagePadding,\n\t\t\t    coordinates = this._coordinates,\n\t\t\t    css = {\n\t\t\t\t'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,\n\t\t\t\t'padding-left': padding || '',\n\t\t\t\t'padding-right': padding || ''\n\t\t\t};\n\n\t\t\tthis.$stage.css(css);\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tvar iterator = this._coordinates.length,\n\t\t\t    grid = !this.settings.autoWidth,\n\t\t\t    items = this.$stage.children();\n\n\t\t\tif (grid && cache.items.merge) {\n\t\t\t\twhile (iterator--) {\n\t\t\t\t\tcache.css.width = this._widths[this.relative(iterator)];\n\t\t\t\t\titems.eq(iterator).css(cache.css);\n\t\t\t\t}\n\t\t\t} else if (grid) {\n\t\t\t\tcache.css.width = cache.items.width;\n\t\t\t\titems.css(cache.css);\n\t\t\t}\n\t\t}\n\t}, {\n\t\tfilter: ['items'],\n\t\trun: function run() {\n\t\t\tthis._coordinates.length < 1 && this.$stage.removeAttr('style');\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'items', 'settings'],\n\t\trun: function run(cache) {\n\t\t\tcache.current = cache.current ? this.$stage.children().index(cache.current) : 0;\n\t\t\tcache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));\n\t\t\tthis.reset(cache.current);\n\t\t}\n\t}, {\n\t\tfilter: ['position'],\n\t\trun: function run() {\n\t\t\tthis.animate(this.coordinates(this._current));\n\t\t}\n\t}, {\n\t\tfilter: ['width', 'position', 'items', 'settings'],\n\t\trun: function run() {\n\t\t\tvar rtl = this.settings.rtl ? 1 : -1,\n\t\t\t    padding = this.settings.stagePadding * 2,\n\t\t\t    begin = this.coordinates(this.current()) + padding,\n\t\t\t    end = begin + this.width() * rtl,\n\t\t\t    inner,\n\t\t\t    outer,\n\t\t\t    matches = [],\n\t\t\t    i,\n\t\t\t    n;\n\n\t\t\tfor (i = 0, n = this._coordinates.length; i < n; i++) {\n\t\t\t\tinner = this._coordinates[i - 1] || 0;\n\t\t\t\touter = Math.abs(this._coordinates[i]) + padding * rtl;\n\n\t\t\t\tif (this.op(inner, '<=', begin) && this.op(inner, '>', end) || this.op(outer, '<', begin) && this.op(outer, '>', end)) {\n\t\t\t\t\tmatches.push(i);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tthis.$stage.children('.active').removeClass('active');\n\t\t\tthis.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');\n\n\t\t\tif (this.settings.center) {\n\t\t\t\tthis.$stage.children('.center').removeClass('center');\n\t\t\t\tthis.$stage.children().eq(this.current()).addClass('center');\n\t\t\t}\n\t\t}\n\t}];\n\n\t/**\n  * Initializes the carousel.\n  * @protected\n  */\n\tOwl.prototype.initialize = function () {\n\t\tthis.enter('initializing');\n\t\tthis.trigger('initialize');\n\n\t\tthis.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);\n\n\t\tif (this.settings.autoWidth && !this.is('pre-loading')) {\n\t\t\tvar imgs, nestedSelector, width;\n\t\t\timgs = this.$element.find('img');\n\t\t\tnestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;\n\t\t\twidth = this.$element.children(nestedSelector).width();\n\n\t\t\tif (imgs.length && width <= 0) {\n\t\t\t\tthis.preloadAutoWidthImages(imgs);\n\t\t\t}\n\t\t}\n\n\t\tthis.$element.addClass(this.options.loadingClass);\n\n\t\t// HACK: DISABLE SCROLLBAR\n\t\tvar overflowVal = $('body').css('overflow');\n\t\t$('body').css({ 'overflow': 'hidden' });\n\n\t\t// create stage\n\t\tthis.$stage = $('<' + this.settings.stageElement + ' class=\"' + this.settings.stageClass + '\"/>').wrap('<div class=\"' + this.settings.stageOuterClass + '\"/>');\n\n\t\t// append stage\n\t\tthis.$element.append(this.$stage.parent());\n\n\t\t// append content\n\t\tthis.replace(this.$element.children().not(this.$stage.parent()));\n\n\t\t// check visibility\n\t\tif (this.$element.is(':visible')) {\n\t\t\t// update view\n\t\t\tthis.refresh();\n\t\t} else {\n\t\t\t// invalidate width\n\t\t\tthis.invalidate('width');\n\t\t}\n\n\t\t// HACK: RESTORE SCROLLBAR\n\t\t$('body').css({ 'overflow': overflowVal });\n\n\t\tthis.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);\n\n\t\t// register event handlers\n\t\tthis.registerEventHandlers();\n\n\t\tthis.leave('initializing');\n\t\tthis.trigger('initialized');\n\t};\n\n\t/**\n  * Setups the current settings.\n  * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?\n  * @todo Support for media queries by using `matchMedia` would be nice.\n  * @public\n  */\n\tOwl.prototype.setup = function () {\n\t\tvar viewport = this.viewport(),\n\t\t    overwrites = this.options.responsive,\n\t\t    match = -1,\n\t\t    settings = null;\n\n\t\tif (!overwrites) {\n\t\t\tsettings = $.extend({}, this.options);\n\t\t} else {\n\t\t\t$.each(overwrites, function (breakpoint) {\n\t\t\t\tif (breakpoint <= viewport && breakpoint > match) {\n\t\t\t\t\tmatch = Number(breakpoint);\n\t\t\t\t}\n\t\t\t});\n\n\t\t\tsettings = $.extend({}, this.options, overwrites[match]);\n\t\t\tif (typeof settings.stagePadding === 'function') {\n\t\t\t\tsettings.stagePadding = settings.stagePadding();\n\t\t\t}\n\t\t\tdelete settings.responsive;\n\n\t\t\t// responsive class\n\t\t\tif (settings.responsiveClass) {\n\t\t\t\tthis.$element.attr('class', this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\\\S+\\\\s', 'g'), '$1' + match));\n\t\t\t}\n\t\t}\n\n\t\tthis.trigger('change', { property: { name: 'settings', value: settings } });\n\t\tthis._breakpoint = match;\n\t\tthis.settings = settings;\n\t\tthis.invalidate('settings');\n\t\tthis.trigger('changed', { property: { name: 'settings', value: this.settings } });\n\t};\n\n\t/**\n  * Updates option logic if necessery.\n  * @protected\n  */\n\tOwl.prototype.optionsLogic = function () {\n\t\tif (this.settings.autoWidth) {\n\t\t\tthis.settings.stagePadding = false;\n\t\t\tthis.settings.merge = false;\n\t\t}\n\t};\n\n\t/**\n  * Prepares an item before add.\n  * @todo Rename event parameter `content` to `item`.\n  * @protected\n  * @returns {jQuery|HTMLElement} - The item container.\n  */\n\tOwl.prototype.prepare = function (item) {\n\t\tvar event = this.trigger('prepare', { content: item });\n\n\t\tif (!event.data) {\n\t\t\tevent.data = $('<' + this.settings.itemElement + '/>').addClass(this.options.itemClass).append(item);\n\t\t}\n\n\t\tthis.trigger('prepared', { content: event.data });\n\n\t\treturn event.data;\n\t};\n\n\t/**\n  * Updates the view.\n  * @public\n  */\n\tOwl.prototype.update = function () {\n\t\tvar i = 0,\n\t\t    n = this._pipe.length,\n\t\t    filter = $.proxy(function (p) {\n\t\t\treturn this[p];\n\t\t}, this._invalidated),\n\t\t    cache = {};\n\n\t\twhile (i < n) {\n\t\t\tif (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {\n\t\t\t\tthis._pipe[i].run(cache);\n\t\t\t}\n\t\t\ti++;\n\t\t}\n\n\t\tthis._invalidated = {};\n\n\t\t!this.is('valid') && this.enter('valid');\n\t};\n\n\t/**\n  * Gets the width of the view.\n  * @public\n  * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.\n  * @returns {Number} - The width of the view in pixel.\n  */\n\tOwl.prototype.width = function (dimension) {\n\t\tdimension = dimension || Owl.Width.Default;\n\t\tswitch (dimension) {\n\t\t\tcase Owl.Width.Inner:\n\t\t\tcase Owl.Width.Outer:\n\t\t\t\treturn this._width;\n\t\t\tdefault:\n\t\t\t\treturn this._width - this.settings.stagePadding * 2 + this.settings.margin;\n\t\t}\n\t};\n\n\t/**\n  * Refreshes the carousel primarily for adaptive purposes.\n  * @public\n  */\n\tOwl.prototype.refresh = function () {\n\t\tthis.enter('refreshing');\n\t\tthis.trigger('refresh');\n\n\t\tthis.setup();\n\n\t\tthis.optionsLogic();\n\n\t\tthis.$element.addClass(this.options.refreshClass);\n\n\t\tthis.update();\n\n\t\tthis.$element.removeClass(this.options.refreshClass);\n\n\t\tthis.leave('refreshing');\n\t\tthis.trigger('refreshed');\n\t};\n\n\t/**\n  * Checks window `resize` event.\n  * @protected\n  */\n\tOwl.prototype.onThrottledResize = function () {\n\t\twindow.clearTimeout(this.resizeTimer);\n\t\tthis.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);\n\t};\n\n\t/**\n  * Checks window `resize` event.\n  * @protected\n  */\n\tOwl.prototype.onResize = function () {\n\t\tif (!this._items.length) {\n\t\t\treturn false;\n\t\t}\n\n\t\tif (this._width === this.$element.width()) {\n\t\t\treturn false;\n\t\t}\n\n\t\tif (!this.$element.is(':visible')) {\n\t\t\treturn false;\n\t\t}\n\n\t\tthis.enter('resizing');\n\n\t\tif (this.trigger('resize').isDefaultPrevented()) {\n\t\t\tthis.leave('resizing');\n\t\t\treturn false;\n\t\t}\n\n\t\tthis.invalidate('width');\n\n\t\tthis.refresh();\n\n\t\tthis.leave('resizing');\n\t\tthis.trigger('resized');\n\t};\n\n\t/**\n  * Registers event handlers.\n  * @todo Check `msPointerEnabled`\n  * @todo #261\n  * @protected\n  */\n\tOwl.prototype.registerEventHandlers = function () {\n\t\tif ($.support.transition) {\n\t\t\tthis.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));\n\t\t}\n\n\t\tif (this.settings.responsive !== false) {\n\t\t\tthis.on(window, 'resize', this._handlers.onThrottledResize);\n\t\t}\n\n\t\tif (this.settings.mouseDrag) {\n\t\t\tthis.$element.addClass(this.options.dragClass);\n\t\t\tthis.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));\n\t\t\tthis.$stage.on('dragstart.owl.core selectstart.owl.core', function () {\n\t\t\t\treturn false;\n\t\t\t});\n\t\t}\n\n\t\tif (this.settings.touchDrag) {\n\t\t\tthis.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));\n\t\t\tthis.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));\n\t\t}\n\t};\n\n\t/**\n  * Handles `touchstart` and `mousedown` events.\n  * @todo Horizontal swipe threshold as option\n  * @todo #261\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onDragStart = function (event) {\n\t\tvar stage = null;\n\n\t\tif (event.which === 3) {\n\t\t\treturn;\n\t\t}\n\n\t\tif ($.support.transform) {\n\t\t\tstage = this.$stage.css('transform').replace(/.*\\(|\\)| /g, '').split(',');\n\t\t\tstage = {\n\t\t\t\tx: stage[stage.length === 16 ? 12 : 4],\n\t\t\t\ty: stage[stage.length === 16 ? 13 : 5]\n\t\t\t};\n\t\t} else {\n\t\t\tstage = this.$stage.position();\n\t\t\tstage = {\n\t\t\t\tx: this.settings.rtl ? stage.left + this.$stage.width() - this.width() + this.settings.margin : stage.left,\n\t\t\t\ty: stage.top\n\t\t\t};\n\t\t}\n\n\t\tif (this.is('animating')) {\n\t\t\t$.support.transform ? this.animate(stage.x) : this.$stage.stop();\n\t\t\tthis.invalidate('position');\n\t\t}\n\n\t\tthis.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');\n\n\t\tthis.speed(0);\n\n\t\tthis._drag.time = new Date().getTime();\n\t\tthis._drag.target = $(event.target);\n\t\tthis._drag.stage.start = stage;\n\t\tthis._drag.stage.current = stage;\n\t\tthis._drag.pointer = this.pointer(event);\n\n\t\t$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));\n\n\t\t$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function (event) {\n\t\t\tvar delta = this.difference(this._drag.pointer, this.pointer(event));\n\n\t\t\t$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));\n\n\t\t\tif (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tevent.preventDefault();\n\n\t\t\tthis.enter('dragging');\n\t\t\tthis.trigger('drag');\n\t\t}, this));\n\t};\n\n\t/**\n  * Handles the `touchmove` and `mousemove` events.\n  * @todo #261\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onDragMove = function (event) {\n\t\tvar minimum = null,\n\t\t    maximum = null,\n\t\t    pull = null,\n\t\t    delta = this.difference(this._drag.pointer, this.pointer(event)),\n\t\t    stage = this.difference(this._drag.stage.start, delta);\n\n\t\tif (!this.is('dragging')) {\n\t\t\treturn;\n\t\t}\n\n\t\tevent.preventDefault();\n\n\t\tif (this.settings.loop) {\n\t\t\tminimum = this.coordinates(this.minimum());\n\t\t\tmaximum = this.coordinates(this.maximum() + 1) - minimum;\n\t\t\tstage.x = ((stage.x - minimum) % maximum + maximum) % maximum + minimum;\n\t\t} else {\n\t\t\tminimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());\n\t\t\tmaximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());\n\t\t\tpull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;\n\t\t\tstage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);\n\t\t}\n\n\t\tthis._drag.stage.current = stage;\n\n\t\tthis.animate(stage.x);\n\t};\n\n\t/**\n  * Handles the `touchend` and `mouseup` events.\n  * @todo #261\n  * @todo Threshold for click event\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onDragEnd = function (event) {\n\t\tvar delta = this.difference(this._drag.pointer, this.pointer(event)),\n\t\t    stage = this._drag.stage.current,\n\t\t    direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';\n\n\t\t$(document).off('.owl.core');\n\n\t\tthis.$element.removeClass(this.options.grabClass);\n\n\t\tif (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {\n\t\t\tthis.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);\n\t\t\tthis.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));\n\t\t\tthis.invalidate('position');\n\t\t\tthis.update();\n\n\t\t\tthis._drag.direction = direction;\n\n\t\t\tif (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {\n\t\t\t\tthis._drag.target.one('click.owl.core', function () {\n\t\t\t\t\treturn false;\n\t\t\t\t});\n\t\t\t}\n\t\t}\n\n\t\tif (!this.is('dragging')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.leave('dragging');\n\t\tthis.trigger('dragged');\n\t};\n\n\t/**\n  * Gets absolute position of the closest item for a coordinate.\n  * @todo Setting `freeDrag` makes `closest` not reusable. See #165.\n  * @protected\n  * @param {Number} coordinate - The coordinate in pixel.\n  * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.\n  * @return {Number} - The absolute position of the closest item.\n  */\n\tOwl.prototype.closest = function (coordinate, direction) {\n\t\tvar position = -1,\n\t\t    pull = 30,\n\t\t    width = this.width(),\n\t\t    coordinates = this.coordinates();\n\n\t\tif (!this.settings.freeDrag) {\n\t\t\t// check closest item\n\t\t\t$.each(coordinates, $.proxy(function (index, value) {\n\t\t\t\t// on a left pull, check on current index\n\t\t\t\tif (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {\n\t\t\t\t\tposition = index;\n\t\t\t\t\t// on a right pull, check on previous index\n\t\t\t\t\t// to do so, subtract width from value and set position = index + 1\n\t\t\t\t} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {\n\t\t\t\t\tposition = index + 1;\n\t\t\t\t} else if (this.op(coordinate, '<', value) && this.op(coordinate, '>', coordinates[index + 1] || value - width)) {\n\t\t\t\t\tposition = direction === 'left' ? index + 1 : index;\n\t\t\t\t}\n\t\t\t\treturn position === -1;\n\t\t\t}, this));\n\t\t}\n\n\t\tif (!this.settings.loop) {\n\t\t\t// non loop boundries\n\t\t\tif (this.op(coordinate, '>', coordinates[this.minimum()])) {\n\t\t\t\tposition = coordinate = this.minimum();\n\t\t\t} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {\n\t\t\t\tposition = coordinate = this.maximum();\n\t\t\t}\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n  * Animates the stage.\n  * @todo #270\n  * @public\n  * @param {Number} coordinate - The coordinate in pixels.\n  */\n\tOwl.prototype.animate = function (coordinate) {\n\t\tvar animate = this.speed() > 0;\n\n\t\tthis.is('animating') && this.onTransitionEnd();\n\n\t\tif (animate) {\n\t\t\tthis.enter('animating');\n\t\t\tthis.trigger('translate');\n\t\t}\n\n\t\tif ($.support.transform3d && $.support.transition) {\n\t\t\tthis.$stage.css({\n\t\t\t\ttransform: 'translate3d(' + coordinate + 'px,0px,0px)',\n\t\t\t\ttransition: this.speed() / 1000 + 's'\n\t\t\t});\n\t\t} else if (animate) {\n\t\t\tthis.$stage.animate({\n\t\t\t\tleft: coordinate + 'px'\n\t\t\t}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));\n\t\t} else {\n\t\t\tthis.$stage.css({\n\t\t\t\tleft: coordinate + 'px'\n\t\t\t});\n\t\t}\n\t};\n\n\t/**\n  * Checks whether the carousel is in a specific state or not.\n  * @param {String} state - The state to check.\n  * @returns {Boolean} - The flag which indicates if the carousel is busy.\n  */\n\tOwl.prototype.is = function (state) {\n\t\treturn this._states.current[state] && this._states.current[state] > 0;\n\t};\n\n\t/**\n  * Sets the absolute position of the current item.\n  * @public\n  * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.\n  * @returns {Number} - The absolute position of the current item.\n  */\n\tOwl.prototype.current = function (position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._current;\n\t\t}\n\n\t\tif (this._items.length === 0) {\n\t\t\treturn undefined;\n\t\t}\n\n\t\tposition = this.normalize(position);\n\n\t\tif (this._current !== position) {\n\t\t\tvar event = this.trigger('change', { property: { name: 'position', value: position } });\n\n\t\t\tif (event.data !== undefined) {\n\t\t\t\tposition = this.normalize(event.data);\n\t\t\t}\n\n\t\t\tthis._current = position;\n\n\t\t\tthis.invalidate('position');\n\n\t\t\tthis.trigger('changed', { property: { name: 'position', value: this._current } });\n\t\t}\n\n\t\treturn this._current;\n\t};\n\n\t/**\n  * Invalidates the given part of the update routine.\n  * @param {String} [part] - The part to invalidate.\n  * @returns {Array.<String>} - The invalidated parts.\n  */\n\tOwl.prototype.invalidate = function (part) {\n\t\tif ($.type(part) === 'string') {\n\t\t\tthis._invalidated[part] = true;\n\t\t\tthis.is('valid') && this.leave('valid');\n\t\t}\n\t\treturn $.map(this._invalidated, function (v, i) {\n\t\t\treturn i;\n\t\t});\n\t};\n\n\t/**\n  * Resets the absolute position of the current item.\n  * @public\n  * @param {Number} position - The absolute position of the new item.\n  */\n\tOwl.prototype.reset = function (position) {\n\t\tposition = this.normalize(position);\n\n\t\tif (position === undefined) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._speed = 0;\n\t\tthis._current = position;\n\n\t\tthis.suppress(['translate', 'translated']);\n\n\t\tthis.animate(this.coordinates(position));\n\n\t\tthis.release(['translate', 'translated']);\n\t};\n\n\t/**\n  * Normalizes an absolute or a relative position of an item.\n  * @public\n  * @param {Number} position - The absolute or relative position to normalize.\n  * @param {Boolean} [relative=false] - Whether the given position is relative or not.\n  * @returns {Number} - The normalized position.\n  */\n\tOwl.prototype.normalize = function (position, relative) {\n\t\tvar n = this._items.length,\n\t\t    m = relative ? 0 : this._clones.length;\n\n\t\tif (!this.isNumeric(position) || n < 1) {\n\t\t\tposition = undefined;\n\t\t} else if (position < 0 || position >= n + m) {\n\t\t\tposition = ((position - m / 2) % n + n) % n + m / 2;\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n  * Converts an absolute position of an item into a relative one.\n  * @public\n  * @param {Number} position - The absolute position to convert.\n  * @returns {Number} - The converted position.\n  */\n\tOwl.prototype.relative = function (position) {\n\t\tposition -= this._clones.length / 2;\n\t\treturn this.normalize(position, true);\n\t};\n\n\t/**\n  * Gets the maximum position for the current item.\n  * @public\n  * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.\n  * @returns {Number}\n  */\n\tOwl.prototype.maximum = function (relative) {\n\t\tvar settings = this.settings,\n\t\t    maximum = this._coordinates.length,\n\t\t    iterator,\n\t\t    reciprocalItemsWidth,\n\t\t    elementWidth;\n\n\t\tif (settings.loop) {\n\t\t\tmaximum = this._clones.length / 2 + this._items.length - 1;\n\t\t} else if (settings.autoWidth || settings.merge) {\n\t\t\titerator = this._items.length;\n\t\t\treciprocalItemsWidth = this._items[--iterator].width();\n\t\t\telementWidth = this.$element.width();\n\t\t\twhile (iterator--) {\n\t\t\t\treciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;\n\t\t\t\tif (reciprocalItemsWidth > elementWidth) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t\tmaximum = iterator + 1;\n\t\t} else if (settings.center) {\n\t\t\tmaximum = this._items.length - 1;\n\t\t} else {\n\t\t\tmaximum = this._items.length - settings.items;\n\t\t}\n\n\t\tif (relative) {\n\t\t\tmaximum -= this._clones.length / 2;\n\t\t}\n\n\t\treturn Math.max(maximum, 0);\n\t};\n\n\t/**\n  * Gets the minimum position for the current item.\n  * @public\n  * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.\n  * @returns {Number}\n  */\n\tOwl.prototype.minimum = function (relative) {\n\t\treturn relative ? 0 : this._clones.length / 2;\n\t};\n\n\t/**\n  * Gets an item at the specified relative position.\n  * @public\n  * @param {Number} [position] - The relative position of the item.\n  * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.\n  */\n\tOwl.prototype.items = function (position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._items.slice();\n\t\t}\n\n\t\tposition = this.normalize(position, true);\n\t\treturn this._items[position];\n\t};\n\n\t/**\n  * Gets an item at the specified relative position.\n  * @public\n  * @param {Number} [position] - The relative position of the item.\n  * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.\n  */\n\tOwl.prototype.mergers = function (position) {\n\t\tif (position === undefined) {\n\t\t\treturn this._mergers.slice();\n\t\t}\n\n\t\tposition = this.normalize(position, true);\n\t\treturn this._mergers[position];\n\t};\n\n\t/**\n  * Gets the absolute positions of clones for an item.\n  * @public\n  * @param {Number} [position] - The relative position of the item.\n  * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.\n  */\n\tOwl.prototype.clones = function (position) {\n\t\tvar odd = this._clones.length / 2,\n\t\t    even = odd + this._items.length,\n\t\t    map = function map(index) {\n\t\t\treturn index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2;\n\t\t};\n\n\t\tif (position === undefined) {\n\t\t\treturn $.map(this._clones, function (v, i) {\n\t\t\t\treturn map(i);\n\t\t\t});\n\t\t}\n\n\t\treturn $.map(this._clones, function (v, i) {\n\t\t\treturn v === position ? map(i) : null;\n\t\t});\n\t};\n\n\t/**\n  * Sets the current animation speed.\n  * @public\n  * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.\n  * @returns {Number} - The current animation speed in milliseconds.\n  */\n\tOwl.prototype.speed = function (speed) {\n\t\tif (speed !== undefined) {\n\t\t\tthis._speed = speed;\n\t\t}\n\n\t\treturn this._speed;\n\t};\n\n\t/**\n  * Gets the coordinate of an item.\n  * @todo The name of this method is missleanding.\n  * @public\n  * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.\n  * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.\n  */\n\tOwl.prototype.coordinates = function (position) {\n\t\tvar multiplier = 1,\n\t\t    newPosition = position - 1,\n\t\t    coordinate;\n\n\t\tif (position === undefined) {\n\t\t\treturn $.map(this._coordinates, $.proxy(function (coordinate, index) {\n\t\t\t\treturn this.coordinates(index);\n\t\t\t}, this));\n\t\t}\n\n\t\tif (this.settings.center) {\n\t\t\tif (this.settings.rtl) {\n\t\t\t\tmultiplier = -1;\n\t\t\t\tnewPosition = position + 1;\n\t\t\t}\n\n\t\t\tcoordinate = this._coordinates[position];\n\t\t\tcoordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;\n\t\t} else {\n\t\t\tcoordinate = this._coordinates[newPosition] || 0;\n\t\t}\n\n\t\tcoordinate = Math.ceil(coordinate);\n\n\t\treturn coordinate;\n\t};\n\n\t/**\n  * Calculates the speed for a translation.\n  * @protected\n  * @param {Number} from - The absolute position of the start item.\n  * @param {Number} to - The absolute position of the target item.\n  * @param {Number} [factor=undefined] - The time factor in milliseconds.\n  * @returns {Number} - The time in milliseconds for the translation.\n  */\n\tOwl.prototype.duration = function (from, to, factor) {\n\t\tif (factor === 0) {\n\t\t\treturn 0;\n\t\t}\n\n\t\treturn Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs(factor || this.settings.smartSpeed);\n\t};\n\n\t/**\n  * Slides to the specified item.\n  * @public\n  * @param {Number} position - The position of the item.\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  */\n\tOwl.prototype.to = function (position, speed) {\n\t\tvar current = this.current(),\n\t\t    revert = null,\n\t\t    distance = position - this.relative(current),\n\t\t    direction = (distance > 0) - (distance < 0),\n\t\t    items = this._items.length,\n\t\t    minimum = this.minimum(),\n\t\t    maximum = this.maximum();\n\n\t\tif (this.settings.loop) {\n\t\t\tif (!this.settings.rewind && Math.abs(distance) > items / 2) {\n\t\t\t\tdistance += direction * -1 * items;\n\t\t\t}\n\n\t\t\tposition = current + distance;\n\t\t\trevert = ((position - minimum) % items + items) % items + minimum;\n\n\t\t\tif (revert !== position && revert - distance <= maximum && revert - distance > 0) {\n\t\t\t\tcurrent = revert - distance;\n\t\t\t\tposition = revert;\n\t\t\t\tthis.reset(current);\n\t\t\t}\n\t\t} else if (this.settings.rewind) {\n\t\t\tmaximum += 1;\n\t\t\tposition = (position % maximum + maximum) % maximum;\n\t\t} else {\n\t\t\tposition = Math.max(minimum, Math.min(maximum, position));\n\t\t}\n\n\t\tthis.speed(this.duration(current, position, speed));\n\t\tthis.current(position);\n\n\t\tif (this.$element.is(':visible')) {\n\t\t\tthis.update();\n\t\t}\n\t};\n\n\t/**\n  * Slides to the next item.\n  * @public\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  */\n\tOwl.prototype.next = function (speed) {\n\t\tspeed = speed || false;\n\t\tthis.to(this.relative(this.current()) + 1, speed);\n\t};\n\n\t/**\n  * Slides to the previous item.\n  * @public\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  */\n\tOwl.prototype.prev = function (speed) {\n\t\tspeed = speed || false;\n\t\tthis.to(this.relative(this.current()) - 1, speed);\n\t};\n\n\t/**\n  * Handles the end of an animation.\n  * @protected\n  * @param {Event} event - The event arguments.\n  */\n\tOwl.prototype.onTransitionEnd = function (event) {\n\n\t\t// if css2 animation then event object is undefined\n\t\tif (event !== undefined) {\n\t\t\tevent.stopPropagation();\n\n\t\t\t// Catch only owl-stage transitionEnd event\n\t\t\tif ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {\n\t\t\t\treturn false;\n\t\t\t}\n\t\t}\n\n\t\tthis.leave('animating');\n\t\tthis.trigger('translated');\n\t};\n\n\t/**\n  * Gets viewport width.\n  * @protected\n  * @return {Number} - The width in pixel.\n  */\n\tOwl.prototype.viewport = function () {\n\t\tvar width;\n\t\tif (this.options.responsiveBaseElement !== window) {\n\t\t\twidth = $(this.options.responsiveBaseElement).width();\n\t\t} else if (window.innerWidth) {\n\t\t\twidth = window.innerWidth;\n\t\t} else if (document.documentElement && document.documentElement.clientWidth) {\n\t\t\twidth = document.documentElement.clientWidth;\n\t\t} else {\n\t\t\tconsole.warn('Can not detect viewport width.');\n\t\t}\n\t\treturn width;\n\t};\n\n\t/**\n  * Replaces the current content.\n  * @public\n  * @param {HTMLElement|jQuery|String} content - The new content.\n  */\n\tOwl.prototype.replace = function (content) {\n\t\tthis.$stage.empty();\n\t\tthis._items = [];\n\n\t\tif (content) {\n\t\t\tcontent = content instanceof jQuery ? content : $(content);\n\t\t}\n\n\t\tif (this.settings.nestedItemSelector) {\n\t\t\tcontent = content.find('.' + this.settings.nestedItemSelector);\n\t\t}\n\n\t\tcontent.filter(function () {\n\t\t\treturn this.nodeType === 1;\n\t\t}).each($.proxy(function (index, item) {\n\t\t\titem = this.prepare(item);\n\t\t\tthis.$stage.append(item);\n\t\t\tthis._items.push(item);\n\t\t\tthis._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t}, this));\n\n\t\tthis.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);\n\n\t\tthis.invalidate('items');\n\t};\n\n\t/**\n  * Adds an item.\n  * @todo Use `item` instead of `content` for the event arguments.\n  * @public\n  * @param {HTMLElement|jQuery|String} content - The item content to add.\n  * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.\n  */\n\tOwl.prototype.add = function (content, position) {\n\t\tvar current = this.relative(this._current);\n\n\t\tposition = position === undefined ? this._items.length : this.normalize(position, true);\n\t\tcontent = content instanceof jQuery ? content : $(content);\n\n\t\tthis.trigger('add', { content: content, position: position });\n\n\t\tcontent = this.prepare(content);\n\n\t\tif (this._items.length === 0 || position === this._items.length) {\n\t\t\tthis._items.length === 0 && this.$stage.append(content);\n\t\t\tthis._items.length !== 0 && this._items[position - 1].after(content);\n\t\t\tthis._items.push(content);\n\t\t\tthis._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t} else {\n\t\t\tthis._items[position].before(content);\n\t\t\tthis._items.splice(position, 0, content);\n\t\t\tthis._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);\n\t\t}\n\n\t\tthis._items[current] && this.reset(this._items[current].index());\n\n\t\tthis.invalidate('items');\n\n\t\tthis.trigger('added', { content: content, position: position });\n\t};\n\n\t/**\n  * Removes an item by its position.\n  * @todo Use `item` instead of `content` for the event arguments.\n  * @public\n  * @param {Number} position - The relative position of the item to remove.\n  */\n\tOwl.prototype.remove = function (position) {\n\t\tposition = this.normalize(position, true);\n\n\t\tif (position === undefined) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.trigger('remove', { content: this._items[position], position: position });\n\n\t\tthis._items[position].remove();\n\t\tthis._items.splice(position, 1);\n\t\tthis._mergers.splice(position, 1);\n\n\t\tthis.invalidate('items');\n\n\t\tthis.trigger('removed', { content: null, position: position });\n\t};\n\n\t/**\n  * Preloads images with auto width.\n  * @todo Replace by a more generic approach\n  * @protected\n  */\n\tOwl.prototype.preloadAutoWidthImages = function (images) {\n\t\timages.each($.proxy(function (i, element) {\n\t\t\tthis.enter('pre-loading');\n\t\t\telement = $(element);\n\t\t\t$(new Image()).one('load', $.proxy(function (e) {\n\t\t\t\telement.attr('src', e.target.src);\n\t\t\t\telement.css('opacity', 1);\n\t\t\t\tthis.leave('pre-loading');\n\t\t\t\t!this.is('pre-loading') && !this.is('initializing') && this.refresh();\n\t\t\t}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));\n\t\t}, this));\n\t};\n\n\t/**\n  * Destroys the carousel.\n  * @public\n  */\n\tOwl.prototype.destroy = function () {\n\n\t\tthis.$element.off('.owl.core');\n\t\tthis.$stage.off('.owl.core');\n\t\t$(document).off('.owl.core');\n\n\t\tif (this.settings.responsive !== false) {\n\t\t\twindow.clearTimeout(this.resizeTimer);\n\t\t\tthis.off(window, 'resize', this._handlers.onThrottledResize);\n\t\t}\n\n\t\tfor (var i in this._plugins) {\n\t\t\tthis._plugins[i].destroy();\n\t\t}\n\n\t\tthis.$stage.children('.cloned').remove();\n\n\t\tthis.$stage.unwrap();\n\t\tthis.$stage.children().contents().unwrap();\n\t\tthis.$stage.children().unwrap();\n\n\t\tthis.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\\\S+\\\\s', 'g'), '')).removeData('owl.carousel');\n\t};\n\n\t/**\n  * Operators to calculate right-to-left and left-to-right.\n  * @protected\n  * @param {Number} [a] - The left side operand.\n  * @param {String} [o] - The operator.\n  * @param {Number} [b] - The right side operand.\n  */\n\tOwl.prototype.op = function (a, o, b) {\n\t\tvar rtl = this.settings.rtl;\n\t\tswitch (o) {\n\t\t\tcase '<':\n\t\t\t\treturn rtl ? a > b : a < b;\n\t\t\tcase '>':\n\t\t\t\treturn rtl ? a < b : a > b;\n\t\t\tcase '>=':\n\t\t\t\treturn rtl ? a <= b : a >= b;\n\t\t\tcase '<=':\n\t\t\t\treturn rtl ? a >= b : a <= b;\n\t\t\tdefault:\n\t\t\t\tbreak;\n\t\t}\n\t};\n\n\t/**\n  * Attaches to an internal event.\n  * @protected\n  * @param {HTMLElement} element - The event source.\n  * @param {String} event - The event name.\n  * @param {Function} listener - The event handler to attach.\n  * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.\n  */\n\tOwl.prototype.on = function (element, event, listener, capture) {\n\t\tif (element.addEventListener) {\n\t\t\telement.addEventListener(event, listener, capture);\n\t\t} else if (element.attachEvent) {\n\t\t\telement.attachEvent('on' + event, listener);\n\t\t}\n\t};\n\n\t/**\n  * Detaches from an internal event.\n  * @protected\n  * @param {HTMLElement} element - The event source.\n  * @param {String} event - The event name.\n  * @param {Function} listener - The attached event handler to detach.\n  * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.\n  */\n\tOwl.prototype.off = function (element, event, listener, capture) {\n\t\tif (element.removeEventListener) {\n\t\t\telement.removeEventListener(event, listener, capture);\n\t\t} else if (element.detachEvent) {\n\t\t\telement.detachEvent('on' + event, listener);\n\t\t}\n\t};\n\n\t/**\n  * Triggers a public event.\n  * @todo Remove `status`, `relatedTarget` should be used instead.\n  * @protected\n  * @param {String} name - The event name.\n  * @param {*} [data=null] - The event data.\n  * @param {String} [namespace=carousel] - The event namespace.\n  * @param {String} [state] - The state which is associated with the event.\n  * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.\n  * @returns {Event} - The event arguments.\n  */\n\tOwl.prototype.trigger = function (name, data, namespace, state, enter) {\n\t\tvar status = {\n\t\t\titem: { count: this._items.length, index: this.current() }\n\t\t},\n\t\t    handler = $.camelCase($.grep(['on', name, namespace], function (v) {\n\t\t\treturn v;\n\t\t}).join('-').toLowerCase()),\n\t\t    event = $.Event([name, 'owl', namespace || 'carousel'].join('.').toLowerCase(), $.extend({ relatedTarget: this }, status, data));\n\n\t\tif (!this._supress[name]) {\n\t\t\t$.each(this._plugins, function (name, plugin) {\n\t\t\t\tif (plugin.onTrigger) {\n\t\t\t\t\tplugin.onTrigger(event);\n\t\t\t\t}\n\t\t\t});\n\n\t\t\tthis.register({ type: Owl.Type.Event, name: name });\n\t\t\tthis.$element.trigger(event);\n\n\t\t\tif (this.settings && typeof this.settings[handler] === 'function') {\n\t\t\t\tthis.settings[handler].call(this, event);\n\t\t\t}\n\t\t}\n\n\t\treturn event;\n\t};\n\n\t/**\n  * Enters a state.\n  * @param name - The state name.\n  */\n\tOwl.prototype.enter = function (name) {\n\t\t$.each([name].concat(this._states.tags[name] || []), $.proxy(function (i, name) {\n\t\t\tif (this._states.current[name] === undefined) {\n\t\t\t\tthis._states.current[name] = 0;\n\t\t\t}\n\n\t\t\tthis._states.current[name]++;\n\t\t}, this));\n\t};\n\n\t/**\n  * Leaves a state.\n  * @param name - The state name.\n  */\n\tOwl.prototype.leave = function (name) {\n\t\t$.each([name].concat(this._states.tags[name] || []), $.proxy(function (i, name) {\n\t\t\tthis._states.current[name]--;\n\t\t}, this));\n\t};\n\n\t/**\n  * Registers an event or state.\n  * @public\n  * @param {Object} object - The event or state to register.\n  */\n\tOwl.prototype.register = function (object) {\n\t\tif (object.type === Owl.Type.Event) {\n\t\t\tif (!$.event.special[object.name]) {\n\t\t\t\t$.event.special[object.name] = {};\n\t\t\t}\n\n\t\t\tif (!$.event.special[object.name].owl) {\n\t\t\t\tvar _default = $.event.special[object.name]._default;\n\t\t\t\t$.event.special[object.name]._default = function (e) {\n\t\t\t\t\tif (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {\n\t\t\t\t\t\treturn _default.apply(this, arguments);\n\t\t\t\t\t}\n\t\t\t\t\treturn e.namespace && e.namespace.indexOf('owl') > -1;\n\t\t\t\t};\n\t\t\t\t$.event.special[object.name].owl = true;\n\t\t\t}\n\t\t} else if (object.type === Owl.Type.State) {\n\t\t\tif (!this._states.tags[object.name]) {\n\t\t\t\tthis._states.tags[object.name] = object.tags;\n\t\t\t} else {\n\t\t\t\tthis._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);\n\t\t\t}\n\n\t\t\tthis._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function (tag, i) {\n\t\t\t\treturn $.inArray(tag, this._states.tags[object.name]) === i;\n\t\t\t}, this));\n\t\t}\n\t};\n\n\t/**\n  * Suppresses events.\n  * @protected\n  * @param {Array.<String>} events - The events to suppress.\n  */\n\tOwl.prototype.suppress = function (events) {\n\t\t$.each(events, $.proxy(function (index, event) {\n\t\t\tthis._supress[event] = true;\n\t\t}, this));\n\t};\n\n\t/**\n  * Releases suppressed events.\n  * @protected\n  * @param {Array.<String>} events - The events to release.\n  */\n\tOwl.prototype.release = function (events) {\n\t\t$.each(events, $.proxy(function (index, event) {\n\t\t\tdelete this._supress[event];\n\t\t}, this));\n\t};\n\n\t/**\n  * Gets unified pointer coordinates from event.\n  * @todo #261\n  * @protected\n  * @param {Event} - The `mousedown` or `touchstart` event.\n  * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.\n  */\n\tOwl.prototype.pointer = function (event) {\n\t\tvar result = { x: null, y: null };\n\n\t\tevent = event.originalEvent || event || window.event;\n\n\t\tevent = event.touches && event.touches.length ? event.touches[0] : event.changedTouches && event.changedTouches.length ? event.changedTouches[0] : event;\n\n\t\tif (event.pageX) {\n\t\t\tresult.x = event.pageX;\n\t\t\tresult.y = event.pageY;\n\t\t} else {\n\t\t\tresult.x = event.clientX;\n\t\t\tresult.y = event.clientY;\n\t\t}\n\n\t\treturn result;\n\t};\n\n\t/**\n  * Determines if the input is a Number or something that can be coerced to a Number\n  * @protected\n  * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested\n  * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number\n  */\n\tOwl.prototype.isNumeric = function (number) {\n\t\treturn !isNaN(parseFloat(number));\n\t};\n\n\t/**\n  * Gets the difference of two vectors.\n  * @todo #261\n  * @protected\n  * @param {Object} - The first vector.\n  * @param {Object} - The second vector.\n  * @returns {Object} - The difference.\n  */\n\tOwl.prototype.difference = function (first, second) {\n\t\treturn {\n\t\t\tx: first.x - second.x,\n\t\t\ty: first.y - second.y\n\t\t};\n\t};\n\n\t/**\n  * The jQuery Plugin for the Owl Carousel\n  * @todo Navigation plugin `next` and `prev`\n  * @public\n  */\n\t$.fn.owlCarousel = function (option) {\n\t\tvar args = Array.prototype.slice.call(arguments, 1);\n\n\t\treturn this.each(function () {\n\t\t\tvar $this = $(this),\n\t\t\t    data = $this.data('owl.carousel');\n\n\t\t\tif (!data) {\n\t\t\t\tdata = new Owl(this, (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);\n\t\t\t\t$this.data('owl.carousel', data);\n\n\t\t\t\t$.each(['next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'], function (i, event) {\n\t\t\t\t\tdata.register({ type: Owl.Type.Event, name: event });\n\t\t\t\t\tdata.$element.on(event + '.owl.carousel.core', $.proxy(function (e) {\n\t\t\t\t\t\tif (e.namespace && e.relatedTarget !== this) {\n\t\t\t\t\t\t\tthis.suppress([event]);\n\t\t\t\t\t\t\tdata[event].apply(this, [].slice.call(arguments, 1));\n\t\t\t\t\t\t\tthis.release([event]);\n\t\t\t\t\t\t}\n\t\t\t\t\t}, data));\n\t\t\t\t});\n\t\t\t}\n\n\t\t\tif (typeof option == 'string' && option.charAt(0) !== '_') {\n\t\t\t\tdata[option].apply(data, args);\n\t\t\t}\n\t\t});\n\t};\n\n\t/**\n  * The constructor for the jQuery Plugin\n  * @public\n  */\n\t$.fn.owlCarousel.Constructor = Owl;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * AutoRefresh Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the auto refresh plugin.\n  * @class The Auto Refresh Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar AutoRefresh = function AutoRefresh(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Refresh interval.\n   * @protected\n   * @type {number}\n   */\n\t\tthis._interval = null;\n\n\t\t/**\n   * Whether the element is currently visible or not.\n   * @protected\n   * @type {Boolean}\n   */\n\t\tthis._visible = null;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoRefresh) {\n\t\t\t\t\tthis.watch();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAutoRefresh.Defaults = {\n\t\tautoRefresh: true,\n\t\tautoRefreshInterval: 500\n\t};\n\n\t/**\n  * Watches the element.\n  */\n\tAutoRefresh.prototype.watch = function () {\n\t\tif (this._interval) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._visible = this._core.$element.is(':visible');\n\t\tthis._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);\n\t};\n\n\t/**\n  * Refreshes the element.\n  */\n\tAutoRefresh.prototype.refresh = function () {\n\t\tif (this._core.$element.is(':visible') === this._visible) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._visible = !this._visible;\n\n\t\tthis._core.$element.toggleClass('owl-hidden', !this._visible);\n\n\t\tthis._visible && this._core.invalidate('width') && this._core.refresh();\n\t};\n\n\t/**\n  * Destroys the plugin.\n  */\n\tAutoRefresh.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\twindow.clearInterval(this._interval);\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Lazy Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the lazy plugin.\n  * @class The Lazy Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar Lazy = function Lazy(carousel) {\n\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Already loaded items.\n   * @protected\n   * @type {Array.<jQuery>}\n   */\n\t\tthis._loaded = [];\n\n\t\t/**\n   * Event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (!e.namespace) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tif (!this._core.settings || !this._core.settings.lazyLoad) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tif (e.property && e.property.name == 'position' || e.type == 'initialized') {\n\t\t\t\t\tvar settings = this._core.settings,\n\t\t\t\t\t    n = settings.center && Math.ceil(settings.items / 2) || settings.items,\n\t\t\t\t\t    i = settings.center && n * -1 || 0,\n\t\t\t\t\t    position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,\n\t\t\t\t\t    clones = this._core.clones().length,\n\t\t\t\t\t    load = $.proxy(function (i, v) {\n\t\t\t\t\t\tthis.load(v);\n\t\t\t\t\t}, this);\n\n\t\t\t\t\twhile (i++ < n) {\n\t\t\t\t\t\tthis.load(clones / 2 + this._core.relative(position));\n\t\t\t\t\t\tclones && $.each(this._core.clones(this._core.relative(position)), load);\n\t\t\t\t\t\tposition++;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set the default options\n\t\tthis._core.options = $.extend({}, Lazy.Defaults, this._core.options);\n\n\t\t// register event handler\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tLazy.Defaults = {\n\t\tlazyLoad: false\n\t};\n\n\t/**\n  * Loads all resources of an item at the specified position.\n  * @param {Number} position - The absolute position of the item.\n  * @protected\n  */\n\tLazy.prototype.load = function (position) {\n\t\tvar $item = this._core.$stage.children().eq(position),\n\t\t    $elements = $item && $item.find('.owl-lazy');\n\n\t\tif (!$elements || $.inArray($item.get(0), this._loaded) > -1) {\n\t\t\treturn;\n\t\t}\n\n\t\t$elements.each($.proxy(function (index, element) {\n\t\t\tvar $element = $(element),\n\t\t\t    image,\n\t\t\t    url = window.devicePixelRatio > 1 && $element.attr('data-src-retina') || $element.attr('data-src');\n\n\t\t\tthis._core.trigger('load', { element: $element, url: url }, 'lazy');\n\n\t\t\tif ($element.is('img')) {\n\t\t\t\t$element.one('load.owl.lazy', $.proxy(function () {\n\t\t\t\t\t$element.css('opacity', 1);\n\t\t\t\t\tthis._core.trigger('loaded', { element: $element, url: url }, 'lazy');\n\t\t\t\t}, this)).attr('src', url);\n\t\t\t} else {\n\t\t\t\timage = new Image();\n\t\t\t\timage.onload = $.proxy(function () {\n\t\t\t\t\t$element.css({\n\t\t\t\t\t\t'background-image': 'url(\"' + url + '\")',\n\t\t\t\t\t\t'opacity': '1'\n\t\t\t\t\t});\n\t\t\t\t\tthis._core.trigger('loaded', { element: $element, url: url }, 'lazy');\n\t\t\t\t}, this);\n\t\t\t\timage.src = url;\n\t\t\t}\n\t\t}, this));\n\n\t\tthis._loaded.push($item.get(0));\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @public\n  */\n\tLazy.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tfor (handler in this.handlers) {\n\t\t\tthis._core.$element.off(handler, this.handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * AutoHeight Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the auto height plugin.\n  * @class The Auto Height Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar AutoHeight = function AutoHeight(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight) {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight && e.property.name == 'position') {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'loaded.owl.lazy': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoHeight && e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {\n\t\t\t\t\tthis.update();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAutoHeight.Defaults = {\n\t\tautoHeight: false,\n\t\tautoHeightClass: 'owl-height'\n\t};\n\n\t/**\n  * Updates the view.\n  */\n\tAutoHeight.prototype.update = function () {\n\t\tvar start = this._core._current,\n\t\t    end = start + this._core.settings.items,\n\t\t    visible = this._core.$stage.children().toArray().slice(start, end),\n\t\t    heights = [],\n\t\t    maxheight = 0;\n\n\t\t$.each(visible, function (index, item) {\n\t\t\theights.push($(item).height());\n\t\t});\n\n\t\tmaxheight = Math.max.apply(null, heights);\n\n\t\tthis._core.$stage.parent().height(maxheight).addClass(this._core.settings.autoHeightClass);\n\t};\n\n\tAutoHeight.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Video Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the video plugin.\n  * @class The Video Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\tvar Video = function Video(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Cache all video URLs.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._videos = {};\n\n\t\t/**\n   * Current playing item.\n   * @protected\n   * @type {jQuery}\n   */\n\t\tthis._playing = null;\n\n\t\t/**\n   * All event handlers.\n   * @todo The cloned content removale is too late\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis._core.register({ type: 'state', name: 'playing', tags: ['interacting'] });\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'resize.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.video && this.isInFullScreen()) {\n\t\t\t\t\te.preventDefault();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'refreshed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.is('resizing')) {\n\t\t\t\t\tthis._core.$stage.find('.cloned .owl-video-frame').remove();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name === 'position' && this._playing) {\n\t\t\t\t\tthis.stop();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'prepared.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (!e.namespace) {\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\tvar $element = $(e.content).find('.owl-video');\n\n\t\t\t\tif ($element.length) {\n\t\t\t\t\t$element.css('display', 'none');\n\t\t\t\t\tthis.fetch($element, $(e.content));\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Video.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\n\t\tthis._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function (e) {\n\t\t\tthis.play(e);\n\t\t}, this));\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tVideo.Defaults = {\n\t\tvideo: false,\n\t\tvideoHeight: false,\n\t\tvideoWidth: false\n\t};\n\n\t/**\n  * Gets the video ID and the type (YouTube/Vimeo/vzaar only).\n  * @protected\n  * @param {jQuery} target - The target containing the video data.\n  * @param {jQuery} item - The item containing the video.\n  */\n\tVideo.prototype.fetch = function (target, item) {\n\t\tvar type = function () {\n\t\t\tif (target.attr('data-vimeo-id')) {\n\t\t\t\treturn 'vimeo';\n\t\t\t} else if (target.attr('data-vzaar-id')) {\n\t\t\t\treturn 'vzaar';\n\t\t\t} else {\n\t\t\t\treturn 'youtube';\n\t\t\t}\n\t\t}(),\n\t\t    id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),\n\t\t    width = target.attr('data-width') || this._core.settings.videoWidth,\n\t\t    height = target.attr('data-height') || this._core.settings.videoHeight,\n\t\t    url = target.attr('href');\n\n\t\tif (url) {\n\n\t\t\t/*\n   \t\tParses the id's out of the following urls (and probably more):\n   \t\thttps://www.youtube.com/watch?v=:id\n   \t\thttps://youtu.be/:id\n   \t\thttps://vimeo.com/:id\n   \t\thttps://vimeo.com/channels/:channel/:id\n   \t\thttps://vimeo.com/groups/:group/videos/:id\n   \t\thttps://app.vzaar.com/videos/:id\n   \t\t\tVisual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F\n   */\n\n\t\t\tid = url.match(/(http:|https:|)\\/\\/(player.|www.|app.)?(vimeo\\.com|youtu(be\\.com|\\.be|be\\.googleapis\\.com)|vzaar\\.com)\\/(video\\/|videos\\/|embed\\/|channels\\/.+\\/|groups\\/.+\\/|watch\\?v=|v\\/)?([A-Za-z0-9._%-]*)(\\&\\S+)?/);\n\n\t\t\tif (id[3].indexOf('youtu') > -1) {\n\t\t\t\ttype = 'youtube';\n\t\t\t} else if (id[3].indexOf('vimeo') > -1) {\n\t\t\t\ttype = 'vimeo';\n\t\t\t} else if (id[3].indexOf('vzaar') > -1) {\n\t\t\t\ttype = 'vzaar';\n\t\t\t} else {\n\t\t\t\tthrow new Error('Video URL not supported.');\n\t\t\t}\n\t\t\tid = id[6];\n\t\t} else {\n\t\t\tthrow new Error('Missing video URL.');\n\t\t}\n\n\t\tthis._videos[url] = {\n\t\t\ttype: type,\n\t\t\tid: id,\n\t\t\twidth: width,\n\t\t\theight: height\n\t\t};\n\n\t\titem.attr('data-video', url);\n\n\t\tthis.thumbnail(target, this._videos[url]);\n\t};\n\n\t/**\n  * Creates video thumbnail.\n  * @protected\n  * @param {jQuery} target - The target containing the video data.\n  * @param {Object} info - The video info object.\n  * @see `fetch`\n  */\n\tVideo.prototype.thumbnail = function (target, video) {\n\t\tvar tnLink,\n\t\t    icon,\n\t\t    path,\n\t\t    dimensions = video.width && video.height ? 'style=\"width:' + video.width + 'px;height:' + video.height + 'px;\"' : '',\n\t\t    customTn = target.find('img'),\n\t\t    srcType = 'src',\n\t\t    lazyClass = '',\n\t\t    settings = this._core.settings,\n\t\t    create = function create(path) {\n\t\t\ticon = '<div class=\"owl-video-play-icon\"></div>';\n\n\t\t\tif (settings.lazyLoad) {\n\t\t\t\ttnLink = '<div class=\"owl-video-tn ' + lazyClass + '\" ' + srcType + '=\"' + path + '\"></div>';\n\t\t\t} else {\n\t\t\t\ttnLink = '<div class=\"owl-video-tn\" style=\"opacity:1;background-image:url(' + path + ')\"></div>';\n\t\t\t}\n\t\t\ttarget.after(tnLink);\n\t\t\ttarget.after(icon);\n\t\t};\n\n\t\t// wrap video content into owl-video-wrapper div\n\t\ttarget.wrap('<div class=\"owl-video-wrapper\"' + dimensions + '></div>');\n\n\t\tif (this._core.settings.lazyLoad) {\n\t\t\tsrcType = 'data-src';\n\t\t\tlazyClass = 'owl-lazy';\n\t\t}\n\n\t\t// custom thumbnail\n\t\tif (customTn.length) {\n\t\t\tcreate(customTn.attr(srcType));\n\t\t\tcustomTn.remove();\n\t\t\treturn false;\n\t\t}\n\n\t\tif (video.type === 'youtube') {\n\t\t\tpath = \"//img.youtube.com/vi/\" + video.id + \"/hqdefault.jpg\";\n\t\t\tcreate(path);\n\t\t} else if (video.type === 'vimeo') {\n\t\t\t$.ajax({\n\t\t\t\ttype: 'GET',\n\t\t\t\turl: '//vimeo.com/api/v2/video/' + video.id + '.json',\n\t\t\t\tjsonp: 'callback',\n\t\t\t\tdataType: 'jsonp',\n\t\t\t\tsuccess: function success(data) {\n\t\t\t\t\tpath = data[0].thumbnail_large;\n\t\t\t\t\tcreate(path);\n\t\t\t\t}\n\t\t\t});\n\t\t} else if (video.type === 'vzaar') {\n\t\t\t$.ajax({\n\t\t\t\ttype: 'GET',\n\t\t\t\turl: '//vzaar.com/api/videos/' + video.id + '.json',\n\t\t\t\tjsonp: 'callback',\n\t\t\t\tdataType: 'jsonp',\n\t\t\t\tsuccess: function success(data) {\n\t\t\t\t\tpath = data.framegrab_url;\n\t\t\t\t\tcreate(path);\n\t\t\t\t}\n\t\t\t});\n\t\t}\n\t};\n\n\t/**\n  * Stops the current video.\n  * @public\n  */\n\tVideo.prototype.stop = function () {\n\t\tthis._core.trigger('stop', null, 'video');\n\t\tthis._playing.find('.owl-video-frame').remove();\n\t\tthis._playing.removeClass('owl-video-playing');\n\t\tthis._playing = null;\n\t\tthis._core.leave('playing');\n\t\tthis._core.trigger('stopped', null, 'video');\n\t};\n\n\t/**\n  * Starts the current video.\n  * @public\n  * @param {Event} event - The event arguments.\n  */\n\tVideo.prototype.play = function (event) {\n\t\tvar target = $(event.target),\n\t\t    item = target.closest('.' + this._core.settings.itemClass),\n\t\t    video = this._videos[item.attr('data-video')],\n\t\t    width = video.width || '100%',\n\t\t    height = video.height || this._core.$stage.height(),\n\t\t    html;\n\n\t\tif (this._playing) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._core.enter('playing');\n\t\tthis._core.trigger('play', null, 'video');\n\n\t\titem = this._core.items(this._core.relative(item.index()));\n\n\t\tthis._core.reset(item.index());\n\n\t\tif (video.type === 'youtube') {\n\t\t\thtml = '<iframe width=\"' + width + '\" height=\"' + height + '\" src=\"//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id + '\" frameborder=\"0\" allowfullscreen></iframe>';\n\t\t} else if (video.type === 'vimeo') {\n\t\t\thtml = '<iframe src=\"//player.vimeo.com/video/' + video.id + '?autoplay=1\" width=\"' + width + '\" height=\"' + height + '\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';\n\t\t} else if (video.type === 'vzaar') {\n\t\t\thtml = '<iframe frameborder=\"0\"' + 'height=\"' + height + '\"' + 'width=\"' + width + '\" allowfullscreen mozallowfullscreen webkitAllowFullScreen ' + 'src=\"//view.vzaar.com/' + video.id + '/player?autoplay=true\"></iframe>';\n\t\t}\n\n\t\t$('<div class=\"owl-video-frame\">' + html + '</div>').insertAfter(item.find('.owl-video'));\n\n\t\tthis._playing = item.addClass('owl-video-playing');\n\t};\n\n\t/**\n  * Checks whether an video is currently in full screen mode or not.\n  * @todo Bad style because looks like a readonly method but changes members.\n  * @protected\n  * @returns {Boolean}\n  */\n\tVideo.prototype.isInFullScreen = function () {\n\t\tvar element = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;\n\n\t\treturn element && $(element).parent().hasClass('owl-video-frame');\n\t};\n\n\t/**\n  * Destroys the plugin.\n  */\n\tVideo.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tthis._core.$element.off('click.owl.video');\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Video = Video;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Animate Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the animate plugin.\n  * @class The Navigation Plugin\n  * @param {Owl} scope - The Owl Carousel\n  */\n\tvar Animate = function Animate(scope) {\n\t\tthis.core = scope;\n\t\tthis.core.options = $.extend({}, Animate.Defaults, this.core.options);\n\t\tthis.swapping = true;\n\t\tthis.previous = undefined;\n\t\tthis.next = undefined;\n\n\t\tthis.handlers = {\n\t\t\t'change.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name == 'position') {\n\t\t\t\t\tthis.previous = this.core.current();\n\t\t\t\t\tthis.next = e.property.value;\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.swapping = e.type == 'translated';\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'translate.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {\n\t\t\t\t\tthis.swap();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\tthis.core.$element.on(this.handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAnimate.Defaults = {\n\t\tanimateOut: false,\n\t\tanimateIn: false\n\t};\n\n\t/**\n  * Toggles the animation classes whenever an translations starts.\n  * @protected\n  * @returns {Boolean|undefined}\n  */\n\tAnimate.prototype.swap = function () {\n\n\t\tif (this.core.settings.items !== 1) {\n\t\t\treturn;\n\t\t}\n\n\t\tif (!$.support.animation || !$.support.transition) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis.core.speed(0);\n\n\t\tvar left,\n\t\t    clear = $.proxy(this.clear, this),\n\t\t    previous = this.core.$stage.children().eq(this.previous),\n\t\t    next = this.core.$stage.children().eq(this.next),\n\t\t    incoming = this.core.settings.animateIn,\n\t\t    outgoing = this.core.settings.animateOut;\n\n\t\tif (this.core.current() === this.previous) {\n\t\t\treturn;\n\t\t}\n\n\t\tif (outgoing) {\n\t\t\tleft = this.core.coordinates(this.previous) - this.core.coordinates(this.next);\n\t\t\tprevious.one($.support.animation.end, clear).css({ 'left': left + 'px' }).addClass('animated owl-animated-out').addClass(outgoing);\n\t\t}\n\n\t\tif (incoming) {\n\t\t\tnext.one($.support.animation.end, clear).addClass('animated owl-animated-in').addClass(incoming);\n\t\t}\n\t};\n\n\tAnimate.prototype.clear = function (e) {\n\t\t$(e.target).css({ 'left': '' }).removeClass('animated owl-animated-out owl-animated-in').removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut);\n\t\tthis.core.onTransitionEnd();\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @public\n  */\n\tAnimate.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tfor (handler in this.handlers) {\n\t\t\tthis.core.$element.off(handler, this.handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Autoplay Plugin\n * @version 2.1.0\n * @author Bartosz Wojciechowski\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\t/**\n  * Creates the autoplay plugin.\n  * @class The Autoplay Plugin\n  * @param {Owl} scope - The Owl Carousel\n  */\n\tvar Autoplay = function Autoplay(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * The autoplay timeout.\n   * @type {Timeout}\n   */\n\t\tthis._timeout = null;\n\n\t\t/**\n   * Indicates whenever the autoplay is paused.\n   * @type {Boolean}\n   */\n\t\tthis._paused = false;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name === 'settings') {\n\t\t\t\t\tif (this._core.settings.autoplay) {\n\t\t\t\t\t\tthis.play();\n\t\t\t\t\t} else {\n\t\t\t\t\t\tthis.stop();\n\t\t\t\t\t}\n\t\t\t\t} else if (e.namespace && e.property.name === 'position') {\n\t\t\t\t\t//console.log('play?', e);\n\t\t\t\t\tif (this._core.settings.autoplay) {\n\t\t\t\t\t\tthis._setAutoPlayInterval();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.autoplay) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'play.owl.autoplay': $.proxy(function (e, t, s) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.play(t, s);\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'stop.owl.autoplay': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tthis.stop();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'mouseover.owl.autoplay': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.pause();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'mouseleave.owl.autoplay': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'touchstart.owl.core': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {\n\t\t\t\t\tthis.pause();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'touchend.owl.core': $.proxy(function () {\n\t\t\t\tif (this._core.settings.autoplayHoverPause) {\n\t\t\t\t\tthis.play();\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// register event handlers\n\t\tthis._core.$element.on(this._handlers);\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Autoplay.Defaults, this._core.options);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tAutoplay.Defaults = {\n\t\tautoplay: false,\n\t\tautoplayTimeout: 5000,\n\t\tautoplayHoverPause: false,\n\t\tautoplaySpeed: false\n\t};\n\n\t/**\n  * Starts the autoplay.\n  * @public\n  * @param {Number} [timeout] - The interval before the next animation starts.\n  * @param {Number} [speed] - The animation speed for the animations.\n  */\n\tAutoplay.prototype.play = function (timeout, speed) {\n\t\tthis._paused = false;\n\n\t\tif (this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._core.enter('rotating');\n\n\t\tthis._setAutoPlayInterval();\n\t};\n\n\t/**\n  * Gets a new timeout\n  * @private\n  * @param {Number} [timeout] - The interval before the next animation starts.\n  * @param {Number} [speed] - The animation speed for the animations.\n  * @return {Timeout}\n  */\n\tAutoplay.prototype._getNextTimeout = function (timeout, speed) {\n\t\tif (this._timeout) {\n\t\t\twindow.clearTimeout(this._timeout);\n\t\t}\n\t\treturn window.setTimeout($.proxy(function () {\n\t\t\tif (this._paused || this._core.is('busy') || this._core.is('interacting') || document.hidden) {\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tthis._core.next(speed || this._core.settings.autoplaySpeed);\n\t\t}, this), timeout || this._core.settings.autoplayTimeout);\n\t};\n\n\t/**\n  * Sets autoplay in motion.\n  * @private\n  */\n\tAutoplay.prototype._setAutoPlayInterval = function () {\n\t\tthis._timeout = this._getNextTimeout();\n\t};\n\n\t/**\n  * Stops the autoplay.\n  * @public\n  */\n\tAutoplay.prototype.stop = function () {\n\t\tif (!this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\twindow.clearTimeout(this._timeout);\n\t\tthis._core.leave('rotating');\n\t};\n\n\t/**\n  * Stops the autoplay.\n  * @public\n  */\n\tAutoplay.prototype.pause = function () {\n\t\tif (!this._core.is('rotating')) {\n\t\t\treturn;\n\t\t}\n\n\t\tthis._paused = true;\n\t};\n\n\t/**\n  * Destroys the plugin.\n  */\n\tAutoplay.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\tthis.stop();\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Navigation Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\t'use strict';\n\n\t/**\n  * Creates the navigation plugin.\n  * @class The Navigation Plugin\n  * @param {Owl} carousel - The Owl Carousel.\n  */\n\n\tvar Navigation = function Navigation(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Indicates whether the plugin is initialized or not.\n   * @protected\n   * @type {Boolean}\n   */\n\t\tthis._initialized = false;\n\n\t\t/**\n   * The current paging indexes.\n   * @protected\n   * @type {Array}\n   */\n\t\tthis._pages = [];\n\n\t\t/**\n   * All DOM elements of the user interface.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._controls = {};\n\n\t\t/**\n   * Markup for an indicator.\n   * @protected\n   * @type {Array.<String>}\n   */\n\t\tthis._templates = [];\n\n\t\t/**\n   * The carousel element.\n   * @type {jQuery}\n   */\n\t\tthis.$element = this._core.$element;\n\n\t\t/**\n   * Overridden methods of the carousel.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._overrides = {\n\t\t\tnext: this._core.next,\n\t\t\tprev: this._core.prev,\n\t\t\tto: this._core.to\n\t\t};\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'prepared.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.push('<div class=\"' + this._core.settings.dotClass + '\">' + $(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'added.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.splice(e.position, 0, this._templates.pop());\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'remove.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.dotsData) {\n\t\t\t\t\tthis._templates.splice(e.position, 1);\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name == 'position') {\n\t\t\t\t\tthis.draw();\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && !this._initialized) {\n\t\t\t\t\tthis._core.trigger('initialize', null, 'navigation');\n\t\t\t\t\tthis.initialize();\n\t\t\t\t\tthis.update();\n\t\t\t\t\tthis.draw();\n\t\t\t\t\tthis._initialized = true;\n\t\t\t\t\tthis._core.trigger('initialized', null, 'navigation');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'refreshed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._initialized) {\n\t\t\t\t\tthis._core.trigger('refresh', null, 'navigation');\n\t\t\t\t\tthis.update();\n\t\t\t\t\tthis.draw();\n\t\t\t\t\tthis._core.trigger('refreshed', null, 'navigation');\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Navigation.Defaults, this._core.options);\n\n\t\t// register event handlers\n\t\tthis.$element.on(this._handlers);\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  * @todo Rename `slideBy` to `navBy`\n  */\n\tNavigation.Defaults = {\n\t\tnav: false,\n\t\tnavText: ['prev', 'next'],\n\t\tnavSpeed: false,\n\t\tnavElement: 'div',\n\t\tnavContainer: false,\n\t\tnavContainerClass: 'owl-nav',\n\t\tnavClass: ['owl-prev', 'owl-next'],\n\t\tslideBy: 1,\n\t\tdotClass: 'owl-dot',\n\t\tdotsClass: 'owl-dots',\n\t\tdots: true,\n\t\tdotsEach: false,\n\t\tdotsData: false,\n\t\tdotsSpeed: false,\n\t\tdotsContainer: false\n\t};\n\n\t/**\n  * Initializes the layout of the plugin and extends the carousel.\n  * @protected\n  */\n\tNavigation.prototype.initialize = function () {\n\t\tvar override,\n\t\t    settings = this._core.settings;\n\n\t\t// create DOM structure for relative navigation\n\t\tthis._controls.$relative = (settings.navContainer ? $(settings.navContainer) : $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');\n\n\t\tthis._controls.$previous = $('<' + settings.navElement + '>').addClass(settings.navClass[0]).html(settings.navText[0]).prependTo(this._controls.$relative).on('click', $.proxy(function (e) {\n\t\t\tthis.prev(settings.navSpeed);\n\t\t}, this));\n\t\tthis._controls.$next = $('<' + settings.navElement + '>').addClass(settings.navClass[1]).html(settings.navText[1]).appendTo(this._controls.$relative).on('click', $.proxy(function (e) {\n\t\t\tthis.next(settings.navSpeed);\n\t\t}, this));\n\n\t\t// create DOM structure for absolute navigation\n\t\tif (!settings.dotsData) {\n\t\t\tthis._templates = [$('<div>').addClass(settings.dotClass).append($('<span>')).prop('outerHTML')];\n\t\t}\n\n\t\tthis._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer) : $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');\n\n\t\tthis._controls.$absolute.on('click', 'div', $.proxy(function (e) {\n\t\t\tvar index = $(e.target).parent().is(this._controls.$absolute) ? $(e.target).index() : $(e.target).parent().index();\n\n\t\t\te.preventDefault();\n\n\t\t\tthis.to(index, settings.dotsSpeed);\n\t\t}, this));\n\n\t\t// override public methods of the carousel\n\t\tfor (override in this._overrides) {\n\t\t\tthis._core[override] = $.proxy(this[override], this);\n\t\t}\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @protected\n  */\n\tNavigation.prototype.destroy = function () {\n\t\tvar handler, control, property, override;\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (control in this._controls) {\n\t\t\tthis._controls[control].remove();\n\t\t}\n\t\tfor (override in this.overides) {\n\t\t\tthis._core[override] = this._overrides[override];\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t/**\n  * Updates the internal state.\n  * @protected\n  */\n\tNavigation.prototype.update = function () {\n\t\tvar i,\n\t\t    j,\n\t\t    k,\n\t\t    lower = this._core.clones().length / 2,\n\t\t    upper = lower + this._core.items().length,\n\t\t    maximum = this._core.maximum(true),\n\t\t    settings = this._core.settings,\n\t\t    size = settings.center || settings.autoWidth || settings.dotsData ? 1 : settings.dotsEach || settings.items;\n\n\t\tif (settings.slideBy !== 'page') {\n\t\t\tsettings.slideBy = Math.min(settings.slideBy, settings.items);\n\t\t}\n\n\t\tif (settings.dots || settings.slideBy == 'page') {\n\t\t\tthis._pages = [];\n\n\t\t\tfor (i = lower, j = 0, k = 0; i < upper; i++) {\n\t\t\t\tif (j >= size || j === 0) {\n\t\t\t\t\tthis._pages.push({\n\t\t\t\t\t\tstart: Math.min(maximum, i - lower),\n\t\t\t\t\t\tend: i - lower + size - 1\n\t\t\t\t\t});\n\t\t\t\t\tif (Math.min(maximum, i - lower) === maximum) {\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t\tj = 0, ++k;\n\t\t\t\t}\n\t\t\t\tj += this._core.mergers(this._core.relative(i));\n\t\t\t}\n\t\t}\n\t};\n\n\t/**\n  * Draws the user interface.\n  * @todo The option `dotsData` wont work.\n  * @protected\n  */\n\tNavigation.prototype.draw = function () {\n\t\tvar difference,\n\t\t    settings = this._core.settings,\n\t\t    disabled = this._core.items().length <= settings.items,\n\t\t    index = this._core.relative(this._core.current()),\n\t\t    loop = settings.loop || settings.rewind;\n\n\t\tthis._controls.$relative.toggleClass('disabled', !settings.nav || disabled);\n\n\t\tif (settings.nav) {\n\t\t\tthis._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));\n\t\t\tthis._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));\n\t\t}\n\n\t\tthis._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);\n\n\t\tif (settings.dots) {\n\t\t\tdifference = this._pages.length - this._controls.$absolute.children().length;\n\n\t\t\tif (settings.dotsData && difference !== 0) {\n\t\t\t\tthis._controls.$absolute.html(this._templates.join(''));\n\t\t\t} else if (difference > 0) {\n\t\t\t\tthis._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));\n\t\t\t} else if (difference < 0) {\n\t\t\t\tthis._controls.$absolute.children().slice(difference).remove();\n\t\t\t}\n\n\t\t\tthis._controls.$absolute.find('.active').removeClass('active');\n\t\t\tthis._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');\n\t\t}\n\t};\n\n\t/**\n  * Extends event data.\n  * @protected\n  * @param {Event} event - The event object which gets thrown.\n  */\n\tNavigation.prototype.onTrigger = function (event) {\n\t\tvar settings = this._core.settings;\n\n\t\tevent.page = {\n\t\t\tindex: $.inArray(this.current(), this._pages),\n\t\t\tcount: this._pages.length,\n\t\t\tsize: settings && (settings.center || settings.autoWidth || settings.dotsData ? 1 : settings.dotsEach || settings.items)\n\t\t};\n\t};\n\n\t/**\n  * Gets the current page position of the carousel.\n  * @protected\n  * @returns {Number}\n  */\n\tNavigation.prototype.current = function () {\n\t\tvar current = this._core.relative(this._core.current());\n\t\treturn $.grep(this._pages, $.proxy(function (page, index) {\n\t\t\treturn page.start <= current && page.end >= current;\n\t\t}, this)).pop();\n\t};\n\n\t/**\n  * Gets the current succesor/predecessor position.\n  * @protected\n  * @returns {Number}\n  */\n\tNavigation.prototype.getPosition = function (successor) {\n\t\tvar position,\n\t\t    length,\n\t\t    settings = this._core.settings;\n\n\t\tif (settings.slideBy == 'page') {\n\t\t\tposition = $.inArray(this.current(), this._pages);\n\t\t\tlength = this._pages.length;\n\t\t\tsuccessor ? ++position : --position;\n\t\t\tposition = this._pages[(position % length + length) % length].start;\n\t\t} else {\n\t\t\tposition = this._core.relative(this._core.current());\n\t\t\tlength = this._core.items().length;\n\t\t\tsuccessor ? position += settings.slideBy : position -= settings.slideBy;\n\t\t}\n\n\t\treturn position;\n\t};\n\n\t/**\n  * Slides to the next item or page.\n  * @public\n  * @param {Number} [speed=false] - The time in milliseconds for the transition.\n  */\n\tNavigation.prototype.next = function (speed) {\n\t\t$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);\n\t};\n\n\t/**\n  * Slides to the previous item or page.\n  * @public\n  * @param {Number} [speed=false] - The time in milliseconds for the transition.\n  */\n\tNavigation.prototype.prev = function (speed) {\n\t\t$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);\n\t};\n\n\t/**\n  * Slides to the specified item or page.\n  * @public\n  * @param {Number} position - The position of the item or page.\n  * @param {Number} [speed] - The time in milliseconds for the transition.\n  * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.\n  */\n\tNavigation.prototype.to = function (position, speed, standard) {\n\t\tvar length;\n\n\t\tif (!standard && this._pages.length) {\n\t\t\tlength = this._pages.length;\n\t\t\t$.proxy(this._overrides.to, this._core)(this._pages[(position % length + length) % length].start, speed);\n\t\t} else {\n\t\t\t$.proxy(this._overrides.to, this._core)(position, speed);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Hash Plugin\n * @version 2.1.0\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\t'use strict';\n\n\t/**\n  * Creates the hash plugin.\n  * @class The Hash Plugin\n  * @param {Owl} carousel - The Owl Carousel\n  */\n\n\tvar Hash = function Hash(carousel) {\n\t\t/**\n   * Reference to the core.\n   * @protected\n   * @type {Owl}\n   */\n\t\tthis._core = carousel;\n\n\t\t/**\n   * Hash index for the items.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._hashes = {};\n\n\t\t/**\n   * The carousel element.\n   * @type {jQuery}\n   */\n\t\tthis.$element = this._core.$element;\n\n\t\t/**\n   * All event handlers.\n   * @protected\n   * @type {Object}\n   */\n\t\tthis._handlers = {\n\t\t\t'initialized.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && this._core.settings.startPosition === 'URLHash') {\n\t\t\t\t\t$(window).trigger('hashchange.owl.navigation');\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'prepared.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace) {\n\t\t\t\t\tvar hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');\n\n\t\t\t\t\tif (!hash) {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\tthis._hashes[hash] = e.content;\n\t\t\t\t}\n\t\t\t}, this),\n\t\t\t'changed.owl.carousel': $.proxy(function (e) {\n\t\t\t\tif (e.namespace && e.property.name === 'position') {\n\t\t\t\t\tvar current = this._core.items(this._core.relative(this._core.current())),\n\t\t\t\t\t    hash = $.map(this._hashes, function (item, hash) {\n\t\t\t\t\t\treturn item === current ? hash : null;\n\t\t\t\t\t}).join();\n\n\t\t\t\t\tif (!hash || window.location.hash.slice(1) === hash) {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\twindow.location.hash = hash;\n\t\t\t\t}\n\t\t\t}, this)\n\t\t};\n\n\t\t// set default options\n\t\tthis._core.options = $.extend({}, Hash.Defaults, this._core.options);\n\n\t\t// register the event handlers\n\t\tthis.$element.on(this._handlers);\n\n\t\t// register event listener for hash navigation\n\t\t$(window).on('hashchange.owl.navigation', $.proxy(function (e) {\n\t\t\tvar hash = window.location.hash.substring(1),\n\t\t\t    items = this._core.$stage.children(),\n\t\t\t    position = this._hashes[hash] && items.index(this._hashes[hash]);\n\n\t\t\tif (position === undefined || position === this._core.current()) {\n\t\t\t\treturn;\n\t\t\t}\n\n\t\t\tthis._core.to(this._core.relative(position), false, true);\n\t\t}, this));\n\t};\n\n\t/**\n  * Default options.\n  * @public\n  */\n\tHash.Defaults = {\n\t\tURLhashListener: false\n\t};\n\n\t/**\n  * Destroys the plugin.\n  * @public\n  */\n\tHash.prototype.destroy = function () {\n\t\tvar handler, property;\n\n\t\t$(window).off('hashchange.owl.navigation');\n\n\t\tfor (handler in this._handlers) {\n\t\t\tthis._core.$element.off(handler, this._handlers[handler]);\n\t\t}\n\t\tfor (property in Object.getOwnPropertyNames(this)) {\n\t\t\ttypeof this[property] != 'function' && (this[property] = null);\n\t\t}\n\t};\n\n\t$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;\n})(window.Zepto || window.jQuery, window, document);\n\n/**\n * Support Plugin\n *\n * @version 2.1.0\n * @author Vivid Planet Software GmbH\n * @author Artus Kolanowski\n * @author David Deutsch\n * @license The MIT License (MIT)\n */\n;(function ($, window, document, undefined) {\n\n\tvar style = $('<support>').get(0).style,\n\t    prefixes = 'Webkit Moz O ms'.split(' '),\n\t    events = {\n\t\ttransition: {\n\t\t\tend: {\n\t\t\t\tWebkitTransition: 'webkitTransitionEnd',\n\t\t\t\tMozTransition: 'transitionend',\n\t\t\t\tOTransition: 'oTransitionEnd',\n\t\t\t\ttransition: 'transitionend'\n\t\t\t}\n\t\t},\n\t\tanimation: {\n\t\t\tend: {\n\t\t\t\tWebkitAnimation: 'webkitAnimationEnd',\n\t\t\t\tMozAnimation: 'animationend',\n\t\t\t\tOAnimation: 'oAnimationEnd',\n\t\t\t\tanimation: 'animationend'\n\t\t\t}\n\t\t}\n\t},\n\t    tests = {\n\t\tcsstransforms: function csstransforms() {\n\t\t\treturn !!test('transform');\n\t\t},\n\t\tcsstransforms3d: function csstransforms3d() {\n\t\t\treturn !!test('perspective');\n\t\t},\n\t\tcsstransitions: function csstransitions() {\n\t\t\treturn !!test('transition');\n\t\t},\n\t\tcssanimations: function cssanimations() {\n\t\t\treturn !!test('animation');\n\t\t}\n\t};\n\n\tfunction test(property, prefixed) {\n\t\tvar result = false,\n\t\t    upper = property.charAt(0).toUpperCase() + property.slice(1);\n\n\t\t$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function (i, property) {\n\t\t\tif (style[property] !== undefined) {\n\t\t\t\tresult = prefixed ? property : true;\n\t\t\t\treturn false;\n\t\t\t}\n\t\t});\n\n\t\treturn result;\n\t}\n\n\tfunction prefixed(property) {\n\t\treturn test(property, true);\n\t}\n\n\tif (tests.csstransitions()) {\n\t\t/* jshint -W053 */\n\t\t$.support.transition = new String(prefixed('transition'));\n\t\t$.support.transition.end = events.transition.end[$.support.transition];\n\t}\n\n\tif (tests.cssanimations()) {\n\t\t/* jshint -W053 */\n\t\t$.support.animation = new String(prefixed('animation'));\n\t\t$.support.animation.end = events.animation.end[$.support.animation];\n\t}\n\n\tif (tests.csstransforms()) {\n\t\t/* jshint -W053 */\n\t\t$.support.transform = new String(prefixed('transform'));\n\t\t$.support.transform3d = tests.csstransforms3d();\n\t}\n})(window.Zepto || window.jQuery, window, document);\n\n/*****************\n ** WEBPACK FOOTER\n ** ./src/owl.carousel.js\n ** module id = 1\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///./src/owl.carousel.js?");

/***/ },
/* 2 */
/***/ function(module, exports) {

	eval("// removed by extract-text-webpack-plugin\n\n/*****************\n ** WEBPACK FOOTER\n ** ./src/owl.carousel.css\n ** module id = 2\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///./src/owl.carousel.css?");

/***/ },
/* 3 */
/***/ function(module, exports) {

	eval("module.exports = __WEBPACK_EXTERNAL_MODULE_3__;\n\n/*****************\n ** WEBPACK FOOTER\n ** external {\"root\":\"PropTypes\",\"commonjs2\":\"prop-types\",\"commonjs\":\"prop-types\",\"amd\":\"prop-types\"}\n ** module id = 3\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///external_%7B%22root%22:%22PropTypes%22,%22commonjs2%22:%22prop-types%22,%22commonjs%22:%22prop-types%22,%22amd%22:%22prop-types%22%7D?");

/***/ },
/* 4 */
/***/ function(module, exports) {

	eval("module.exports = __WEBPACK_EXTERNAL_MODULE_4__;\n\n/*****************\n ** WEBPACK FOOTER\n ** external {\"root\":\"React\",\"commonjs2\":\"react\",\"commonjs\":\"react\",\"amd\":\"react\"}\n ** module id = 4\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///external_%7B%22root%22:%22React%22,%22commonjs2%22:%22react%22,%22commonjs%22:%22react%22,%22amd%22:%22react%22%7D?");

/***/ },
/* 5 */
/***/ function(module, exports) {

	eval("module.exports = __WEBPACK_EXTERNAL_MODULE_5__;\n\n/*****************\n ** WEBPACK FOOTER\n ** external {\"root\":\"ReactDOM\",\"commonjs2\":\"react-dom\",\"commonjs\":\"react-dom\",\"amd\":\"react-dom\"}\n ** module id = 5\n ** module chunks = 0\n **/\n//# sourceURL=webpack:///external_%7B%22root%22:%22ReactDOM%22,%22commonjs2%22:%22react-dom%22,%22commonjs%22:%22react-dom%22,%22amd%22:%22react-dom%22%7D?");

/***/ }
/******/ ])
});
;

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(1067);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabList__ = __webpack_require__(1069);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_TabList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tab__ = __webpack_require__(1070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__ = __webpack_require__(1071);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__ = __webpack_require__(491);
/* unused harmony reexport resetIdCounter */






/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(495);

var util = __webpack_require__(31);

function property(obj, name, value) {
  if (value !== null && value !== undefined) {
    util.property.apply(this, arguments);
  }
}

function memoizedProperty(obj, name) {
  if (!obj.constructor.prototype[name]) {
    util.memoizedProperty.apply(this, arguments);
  }
}

function Shape(shape, options, memberName) {
  options = options || {};

  property(this, 'shape', shape.shape);
  property(this, 'api', options.api, false);
  property(this, 'type', shape.type);
  property(this, 'enum', shape.enum);
  property(this, 'min', shape.min);
  property(this, 'max', shape.max);
  property(this, 'pattern', shape.pattern);
  property(this, 'location', shape.location || this.location || 'body');
  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
    shape.locationName || memberName);
  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
  property(this, 'requiresLength', shape.requiresLength, false);
  property(this, 'isComposite', shape.isComposite || false);
  property(this, 'isShape', true, false);
  property(this, 'isQueryName', Boolean(shape.queryName), false);
  property(this, 'isLocationName', Boolean(shape.locationName), false);
  property(this, 'isIdempotent', shape.idempotencyToken === true);
  property(this, 'isJsonValue', shape.jsonvalue === true);
  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
  property(this, 'isEventStream', Boolean(shape.eventstream), false);
  property(this, 'isEvent', Boolean(shape.event), false);
  property(this, 'isEventPayload', Boolean(shape.eventpayload), false);
  property(this, 'isEventHeader', Boolean(shape.eventheader), false);
  property(this, 'isTimestampFormatSet', Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
  property(this, 'endpointDiscoveryId', Boolean(shape.endpointdiscoveryid), false);
  property(this, 'hostLabel', Boolean(shape.hostLabel), false);

  if (options.documentation) {
    property(this, 'documentation', shape.documentation);
    property(this, 'documentationUrl', shape.documentationUrl);
  }

  if (shape.xmlAttribute) {
    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
  }

  // type conversion and parsing
  property(this, 'defaultValue', null);
  this.toWireFormat = function(value) {
    if (value === null || value === undefined) return '';
    return value;
  };
  this.toType = function(value) { return value; };
}

/**
 * @api private
 */
Shape.normalizedTypes = {
  character: 'string',
  double: 'float',
  long: 'integer',
  short: 'integer',
  biginteger: 'integer',
  bigdecimal: 'float',
  blob: 'binary'
};

/**
 * @api private
 */
Shape.types = {
  'structure': StructureShape,
  'list': ListShape,
  'map': MapShape,
  'boolean': BooleanShape,
  'timestamp': TimestampShape,
  'float': FloatShape,
  'integer': IntegerShape,
  'string': StringShape,
  'base64': Base64Shape,
  'binary': BinaryShape
};

Shape.resolve = function resolve(shape, options) {
  if (shape.shape) {
    var refShape = options.api.shapes[shape.shape];
    if (!refShape) {
      throw new Error('Cannot find shape reference: ' + shape.shape);
    }

    return refShape;
  } else {
    return null;
  }
};

Shape.create = function create(shape, options, memberName) {
  if (shape.isShape) return shape;

  var refShape = Shape.resolve(shape, options);
  if (refShape) {
    var filteredKeys = Object.keys(shape);
    if (!options.documentation) {
      filteredKeys = filteredKeys.filter(function(name) {
        return !name.match(/documentation/);
      });
    }

    // create an inline shape with extra members
    var InlineShape = function() {
      refShape.constructor.call(this, shape, options, memberName);
    };
    InlineShape.prototype = refShape;
    return new InlineShape();
  } else {
    // set type if not set
    if (!shape.type) {
      if (shape.members) shape.type = 'structure';
      else if (shape.member) shape.type = 'list';
      else if (shape.key) shape.type = 'map';
      else shape.type = 'string';
    }

    // normalize types
    var origType = shape.type;
    if (Shape.normalizedTypes[shape.type]) {
      shape.type = Shape.normalizedTypes[shape.type];
    }

    if (Shape.types[shape.type]) {
      return new Shape.types[shape.type](shape, options, memberName);
    } else {
      throw new Error('Unrecognized shape type: ' + origType);
    }
  }
};

function CompositeShape(shape) {
  Shape.apply(this, arguments);
  property(this, 'isComposite', true);

  if (shape.flattened) {
    property(this, 'flattened', shape.flattened || false);
  }
}

function StructureShape(shape, options) {
  var self = this;
  var requiredMap = null, firstInit = !this.isShape;

  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'members', {});
    property(this, 'memberNames', []);
    property(this, 'required', []);
    property(this, 'isRequired', function() { return false; });
  }

  if (shape.members) {
    property(this, 'members', new Collection(shape.members, options, function(name, member) {
      return Shape.create(member, options, name);
    }));
    memoizedProperty(this, 'memberNames', function() {
      return shape.xmlOrder || Object.keys(shape.members);
    });

    if (shape.event) {
      memoizedProperty(this, 'eventPayloadMemberName', function() {
        var members = self.members;
        var memberNames = self.memberNames;
        // iterate over members to find ones that are event payloads
        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
          if (members[memberNames[i]].isEventPayload) {
            return memberNames[i];
          }
        }
      });

      memoizedProperty(this, 'eventHeaderMemberNames', function() {
        var members = self.members;
        var memberNames = self.memberNames;
        var eventHeaderMemberNames = [];
        // iterate over members to find ones that are event headers
        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
          if (members[memberNames[i]].isEventHeader) {
            eventHeaderMemberNames.push(memberNames[i]);
          }
        }
        return eventHeaderMemberNames;
      });
    }
  }

  if (shape.required) {
    property(this, 'required', shape.required);
    property(this, 'isRequired', function(name) {
      if (!requiredMap) {
        requiredMap = {};
        for (var i = 0; i < shape.required.length; i++) {
          requiredMap[shape.required[i]] = true;
        }
      }

      return requiredMap[name];
    }, false, true);
  }

  property(this, 'resultWrapper', shape.resultWrapper || null);

  if (shape.payload) {
    property(this, 'payload', shape.payload);
  }

  if (typeof shape.xmlNamespace === 'string') {
    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
  } else if (typeof shape.xmlNamespace === 'object') {
    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
  }
}

function ListShape(shape, options) {
  var self = this, firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return []; });
  }

  if (shape.member) {
    memoizedProperty(this, 'member', function() {
      return Shape.create(shape.member, options);
    });
  }

  if (this.flattened) {
    var oldName = this.name;
    memoizedProperty(this, 'name', function() {
      return self.member.name || oldName;
    });
  }
}

function MapShape(shape, options) {
  var firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'key', Shape.create({type: 'string'}, options));
    property(this, 'value', Shape.create({type: 'string'}, options));
  }

  if (shape.key) {
    memoizedProperty(this, 'key', function() {
      return Shape.create(shape.key, options);
    });
  }
  if (shape.value) {
    memoizedProperty(this, 'value', function() {
      return Shape.create(shape.value, options);
    });
  }
}

function TimestampShape(shape) {
  var self = this;
  Shape.apply(this, arguments);

  if (shape.timestampFormat) {
    property(this, 'timestampFormat', shape.timestampFormat);
  } else if (self.isTimestampFormatSet && this.timestampFormat) {
    property(this, 'timestampFormat', this.timestampFormat);
  } else if (this.location === 'header') {
    property(this, 'timestampFormat', 'rfc822');
  } else if (this.location === 'querystring') {
    property(this, 'timestampFormat', 'iso8601');
  } else if (this.api) {
    switch (this.api.protocol) {
      case 'json':
      case 'rest-json':
        property(this, 'timestampFormat', 'unixTimestamp');
        break;
      case 'rest-xml':
      case 'query':
      case 'ec2':
        property(this, 'timestampFormat', 'iso8601');
        break;
    }
  }

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    if (typeof value.toUTCString === 'function') return value;
    return typeof value === 'string' || typeof value === 'number' ?
           util.date.parseTimestamp(value) : null;
  };

  this.toWireFormat = function(value) {
    return util.date.format(value, self.timestampFormat);
  };
}

function StringShape() {
  Shape.apply(this, arguments);

  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
  this.toType = function(value) {
    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
      value || '' : value;
    if (this.isJsonValue) {
      return JSON.parse(value);
    }

    return value && typeof value.toString === 'function' ?
      value.toString() : value;
  };

  this.toWireFormat = function(value) {
    return this.isJsonValue ? JSON.stringify(value) : value;
  };
}

function FloatShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseFloat(value);
  };
  this.toWireFormat = this.toType;
}

function IntegerShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseInt(value, 10);
  };
  this.toWireFormat = this.toType;
}

function BinaryShape() {
  Shape.apply(this, arguments);
  this.toType = function(value) {
    var buf = util.base64.decode(value);
    if (this.isSensitive && util.isNode() && typeof util.Buffer.alloc === 'function') {
  /* Node.js can create a Buffer that is not isolated.
   * i.e. buf.byteLength !== buf.buffer.byteLength
   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
   */
      var secureBuf = util.Buffer.alloc(buf.length, buf);
      buf.fill(0);
      buf = secureBuf;
    }
    return buf;
  };
  this.toWireFormat = util.base64.encode;
}

function Base64Shape() {
  BinaryShape.apply(this, arguments);
}

function BooleanShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined) return null;
    return value === 'true';
  };
}

/**
 * @api private
 */
Shape.shapes = {
  StructureShape: StructureShape,
  ListShape: ListShape,
  MapShape: MapShape,
  StringShape: StringShape,
  BooleanShape: BooleanShape,
  Base64Shape: Base64Shape
};

/**
 * @api private
 */
module.exports = Shape;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(277);
var AWS = __webpack_require__(13);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sts'] = {};
AWS.STS = Service.defineService('sts', ['2011-06-15']);
__webpack_require__(1163);
Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
  get: function get() {
    var model = __webpack_require__(1164);
    model.paginators = __webpack_require__(1165).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.STS;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(276);
var core_1 = __webpack_require__(45);
var cache_1 = __webpack_require__(1206);
var logger = new core_1.ConsoleLogger('BaseProvider');
var BaseProvider = /** @class */ (function () {
    function BaseProvider(options) {
        this._config = {};
        if (options)
            this.configure(options);
        this._credentialsTokenSource = BaseProvider.ID_TOKEN;
    }
    BaseProvider.prototype.configure = function (options) {
        Object.assign(this._config, options);
        var _a = this._config, storage = _a.storage, _b = _a.refreshHandlers, refreshHandlers = _b === void 0 ? {} : _b;
        this._storage = storage;
        this._storageSync = this._storage && typeof this._storage['sync'] === 'function' ?
            this._storage['sync']() : Promise.resolve();
        this._refreshHandler =
            refreshHandlers[this.getProviderName()] ||
                refreshHandlers[this._credentialsDomain];
    };
    BaseProvider.prototype.getProviderName = function () {
        return 'Base';
    };
    BaseProvider.prototype.getCategory = function () {
        return 'Auth';
    };
    BaseProvider.prototype.setSession = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix, username, attributes, tokens, expires_at, provider, federatedWithIDP, errorHandler, otherProps, session, user, sessionKey, userKey, credentials, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _keyPrefix = this._config._keyPrefix;
                        username = params.username, attributes = params.attributes, tokens = params.tokens, expires_at = params.expires_at, provider = params.provider, federatedWithIDP = params.federatedWithIDP;
                        federatedWithIDP.domain = federatedWithIDP.domain || this._credentialsDomain;
                        federatedWithIDP.token = federatedWithIDP.token || this._credentialsTokenSource || BaseProvider.ID_TOKEN;
                        errorHandler = federatedWithIDP.errorHandler, otherProps = __rest(federatedWithIDP, ["errorHandler"]);
                        session = {
                            tokens: tokens,
                            expires_at: expires_at,
                            type: types_1.SessionType.FederatedProviderSession,
                            provider: this.getProviderName(),
                            federatedWithIDP: otherProps
                        };
                        user = {
                            name: username,
                            attributes: attributes
                        };
                        // cache information
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        // cache information
                        _a.sent();
                        sessionKey = _keyPrefix + "_session";
                        userKey = _keyPrefix + "_user";
                        this._storage.setItem(sessionKey, JSON.stringify(session));
                        this._storage.setItem(userKey, JSON.stringify(user));
                        credentials = undefined;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, core_1.Credentials.set(session, 'federation')];
                    case 3:
                        credentials = _a.sent();
                        user.id = credentials.identityId;
                        this._storage.setItem(userKey, JSON.stringify(user));
                        // backward compatibility
                        cache_1.default.setItem('federatedInfo', {
                            provider: provider,
                            token: federatedWithIDP.token === 'id_token' ? tokens.idToken : tokens.accessToken,
                            user: user,
                            expires_at: expires_at,
                            identity_id: federatedWithIDP.identityId
                        }, { priority: 1 });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        logger.debug('Failed to get the aws credentials with the tokens provided', e_1);
                        if (errorHandler) {
                            errorHandler(e_1);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, {
                            session: session,
                            user: user,
                            credentials: credentials
                        }];
                }
            });
        });
    };
    BaseProvider.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix, session;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _keyPrefix = this._config._keyPrefix;
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        _a.sent();
                        session = JSON.parse(this._storage.getItem(_keyPrefix + "_session"));
                        if (!session)
                            throw new Error('Session is not cached.');
                        if (session.expires_at > new Date().getTime()) {
                            logger.debug('token not expired');
                            return [2 /*return*/, session];
                        }
                        else {
                            // refresh
                            if (this._refreshHandler && typeof this._refreshHandler === 'function') {
                                logger.debug('getting refreshed jwt token from federation provider');
                                return [2 /*return*/, this._refreshHandler().then(function (data) {
                                        logger.debug('refresh federated token sucessfully', data);
                                        var newSession = null;
                                        var expires_at = session.expires_at, tokens = session.tokens, otherSessionInfo = __rest(session, ["expires_at", "tokens"]);
                                        if (_this._credentialsTokenSource === BaseProvider.ACCESS_TOKEN) {
                                            tokens.accessToken = data.token;
                                        }
                                        else {
                                            tokens.idToken = data.token;
                                        }
                                        newSession = __assign({ tokens: tokens, expires_at: data.expires_at }, otherSessionInfo);
                                        // restore the new session
                                        _this._storage.setItem(_keyPrefix + "_session", JSON.stringify(newSession));
                                        return newSession;
                                    }).catch(function (e) {
                                        logger.debug('refresh federated token failed', e);
                                        throw new Error('refreshing federation token failed: ' + e);
                                    })];
                            }
                            else {
                                logger.debug('no refresh handler for provider:', this.getProviderName());
                                throw new Error('no refresh handler for provider');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseProvider.prototype.clearSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix, sessionKey, userKey;
            return __generator(this, function (_a) {
                _keyPrefix = this._config._keyPrefix;
                sessionKey = _keyPrefix + "_session";
                userKey = _keyPrefix + "_user";
                this._storage.removeItem(sessionKey);
                this._storage.removeItem(userKey);
                cache_1.default.removeItem('federatedInfo');
                return [2 /*return*/];
            });
        });
    };
    BaseProvider.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _keyPrefix = this._config._keyPrefix;
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, JSON.parse(this._storage.getItem(_keyPrefix + "_user"))];
                }
            });
        });
    };
    BaseProvider.ACCESS_TOKEN = 'access_token';
    BaseProvider.ID_TOKEN = 'id_token';
    return BaseProvider;
}());
exports.default = BaseProvider;
//# sourceMappingURL=BaseProvider.js.map

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_AVAILABILITY */
/* unused harmony export FETCH_AVAILABILITY_SUCCESS */
/* unused harmony export FETCH_AVAILABILITY_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAvailabilityBySku; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectIsAvailableBySku; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_starter_kit__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Search_ducks__ = __webpack_require__(78);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var FETCH_AVAILABILITY='availability/FETCH';var FETCH_AVAILABILITY_SUCCESS='availability/FETCH_SUCCESS';var FETCH_AVAILABILITY_FAIL='availability/FETCH_FAIL';/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case FETCH_AVAILABILITY:return Object.assign({},state,_defineProperty({},action.sku,Object.assign({},state[action.sku],{isLoading:true})));case FETCH_AVAILABILITY_SUCCESS:var _action$payload$data$=action.payload.data[0],isAvailable=_action$payload$data$.available,price=_objectWithoutProperties(_action$payload$data$,['available']);return Object.assign({},state,_defineProperty({},action.meta.previousAction.sku,Object.assign({isLoading:false,isAvailable:isAvailable,isPriceUpdated:true},isAvailable&&{price:price})));case FETCH_AVAILABILITY_FAIL:return Object.assign({},state,_defineProperty({},action.meta.previousAction.sku,{isLoading:false,isAvailable:false,isPriceUpdated:true}));case __WEBPACK_IMPORTED_MODULE_1_Catalog_Showcase_ducks__["a" /* FETCH_SHOWCASE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_2_Catalog_Search_ducks__["a" /* FETCH_SEARCH_SUCCESS */]:var hotAvailabilities=action.payload.data.products.reduce(function(availabilities,currentProduct){var sku=currentProduct.sku,availability=currentProduct.availability,isPriceUpdated=currentProduct.hasPriceUpdated;var _ref=availability||{},isAvailable=_ref.available,pointsCash=_ref.pointCash,price=_objectWithoutProperties(_ref,['available','pointCash']);var curAvailability=_defineProperty({},sku,Object.assign({},state[sku],{isLoading:false,isAvailable:isAvailable!==undefined?isAvailable:state[sku]?state[sku].isAvailable:false,isPriceUpdated:isPriceUpdated,price:isAvailable?Object.assign({},price,{pointsCash:pointsCash}):state[sku]?state[sku].price:undefined}));return Object.assign({},availabilities,curAvailability);},{});return Object.assign({},state,hotAvailabilities);default:return Object.assign({},state);}});var fetchAvailability=function fetchAvailability(sku,originalId,vendorId){return{type:FETCH_AVAILABILITY,sku:sku,payload:{client:'cloudloyalty',request:{method:'GET',url:'/v1/products/skus/'+sku+'/availability',params:{vendorId:vendorId,originalId:originalId}}}};};var selectAvailabilityBySku=Object(__WEBPACK_IMPORTED_MODULE_0_redux_starter_kit__["a" /* createSelector */])([function(state){return state.availability;},function(_,props){return props.sku;}],function(availability,sku){return availability[sku]&&availability[sku];});var selectIsAvailableBySku=Object(__WEBPACK_IMPORTED_MODULE_0_redux_starter_kit__["a" /* createSelector */])([selectAvailabilityBySku],function(availability){return availability&&availability.isAvailable;});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchCard__ = __webpack_require__(1325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductCard__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ProductCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductRecomendationCard__ = __webpack_require__(1329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ProductRecomendationCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VoucherCard__ = __webpack_require__(1333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__VoucherCard__["a"]; });


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__ = __webpack_require__(153);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tagging=function(_Component){_inherits(Tagging,_Component);function Tagging(props){_classCallCheck(this,Tagging);var _this=_possibleConstructorReturn(this,(Tagging.__proto__||Object.getPrototypeOf(Tagging)).call(this,props));_this.state={sendGTM:false};return _this;}_createClass(Tagging,[{key:'addDataLayerTransition',value:function addDataLayerTransition(){setTimeout(function(){window.dataLayer=window.dataLayer||[];window.dataLayerTransition=window.dataLayerTransition||undefined;if(window.dataLayerTransition){/* eslint-disable */var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.entries(window.dataLayerTransition)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref=_step.value;var _ref2=_slicedToArray(_ref,2);var key=_ref2[0];var item=_ref2[1];window.dataLayer.push({'event':'productImpressions','eventCategory':'enhanced-ecommerce','eventAction':'productImpression','ecommerce':{'impressions':item}});}/* eslint-enable */}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}},5000);}},{key:'addDataLayer',value:function addDataLayer(productSku,productName,productPrice,productIdentifier,originalId,vendorId,productPosition,categoryName){this.setState({sendGTM:true});window.dataLayer=window.dataLayer||[];if(this.props.type==='view'){window.dataLayerTransition=window.dataLayerTransition||{};var dataLayerTransition=window.dataLayerTransition;var nameProps=__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productIdentifier,{delimiter:' '});var arrayTransition=[{'name':__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productName,{delimiter:' '}),'id':productSku,'price':productPrice?productPrice.price:undefined,'metric2  ':productPrice&&productPrice.cash?productPrice.cash.price.toFixed(2):undefined,'position':productPosition+1,'category':categoryName?__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(categoryName,{delimiter:' '}):undefined,'list':__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productIdentifier,{delimiter:' '})}];if(dataLayerTransition[nameProps]){var item=dataLayerTransition[nameProps].find(function(item){return item.id===productSku;});if(!item){window.dataLayerTransition=_defineProperty({},nameProps,dataLayerTransition[nameProps]?dataLayerTransition[nameProps].concat(arrayTransition):dataLayerTransition[nameProps]);}}else{window.dataLayerTransition=_defineProperty({},nameProps,arrayTransition);}}if(this.props.type==='click'){window.dataLayer.push({'event':'productClick','eventCategory':'enhanced-ecommerce','eventAction':'productClick','ecommerce':{'click':{'actionField':{'list':__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productIdentifier,{delimiter:' '})},'products':[{'metric2':productPrice&&productPrice.cash?productPrice.cash.price.toFixed(2):undefined,'name':__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productName,{delimiter:' '}),'id':productSku,'price':productPrice?productPrice.price:undefined,'category':categoryName?__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(categoryName,{delimiter:' '}):undefined,'position':productPosition+1}]}}});}if(this.props.type==='viewProduct'){window.dataLayer.push({'event':'productDetail','eventCategory':'enhanced-ecommerce','eventAction':'productDetail','ecommerce':{'detail':{'products':[{'metric2':productPrice&&productPrice.cash?productPrice.cash.price.toFixed(2):undefined,'name':__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productName,{delimiter:' '}),'id':productSku,'price':productPrice?productPrice.price:undefined,'category':categoryName?__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(categoryName,{delimiter:' '}):undefined}]}}});}if(this.props.type==='clickProduct'){window.dataLayer.push({'event':'addToCart','eventCategory':'enhanced-ecommerce','eventAction':'addToCart','ecommerce':{'add':{'products':[{'metric2':productPrice&&productPrice.cash?productPrice.cash.price.toFixed(2):undefined,'name':__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(productName,{delimiter:' '}),'id':productSku,'price':productPrice?productPrice.price:undefined,'category':categoryName?__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(categoryName,{delimiter:' '}):undefined,'quantity':'1'}]}}});}}},{key:'render',value:function render(){if(this.props.type==='send'){this.addDataLayerTransition();}else if(this.state.sendGTM===false&&this.props.price){var nameShowcase='';if(this.props.categoryName!==''){nameShowcase=this.props.identifier+' - '+this.props.categoryName+' - '+this.props.titleShowcase;}else{nameShowcase=this.props.identifier+' - '+this.props.titleShowcase;}var productIdentifier=__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(nameShowcase,{delimiter:' '});this.addDataLayer(this.props.sku,this.props.name,this.props.price,productIdentifier,this.props.originalId,this.props.vendorId,this.props.position,this.props.categoryName);}return'';}}]);return Tagging;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tagging.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,identifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleShowcase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,categoryName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,position:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Tagging.defaultProps={titleShowcase:'',categoryName:''};var mapStateToProps=function mapStateToProps(state,props){var Availability=Object(__WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__["c" /* selectAvailabilityBySku */])(state,props);return Availability||{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadAvailability:function loadAvailability(sku,originalId,vendorId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__["b" /* fetchAvailability */])(sku,originalId,vendorId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Tagging));

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_PRODUCT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_PRODUCT_SUCCESS; });
/* unused harmony export FETCH_PRODUCT_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchProduct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Catalog_Search_ducks__ = __webpack_require__(78);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var FETCH_PRODUCT='products/FETCH';var FETCH_PRODUCT_SUCCESS=FETCH_PRODUCT+'_SUCCESS';var FETCH_PRODUCT_FAIL=FETCH_PRODUCT+'_FAIL';var fetchProduct=function fetchProduct(sku){return{type:FETCH_PRODUCT,sku:sku,payload:{client:'cloudloyalty',request:{method:'GET',url:'/v2/products/skus/'+sku}}};};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var hotProducts={};switch(action.type){case FETCH_PRODUCT_SUCCESS:var _action$payload$data=action.payload.data,name=_action$payload$data.name,description=_action$payload$data.description,productFeatures=_action$payload$data.features,skus=_action$payload$data.skus,vendor=_action$payload$data.vendor,brand=_action$payload$data.brand;hotProducts=skus.reduce(function(products,currentProduct){var currentSku=currentProduct.sku,originalId=currentProduct.originalId,images=currentProduct.images,features=currentProduct.skuFeatures;return Object.assign({},products,_defineProperty({},currentSku,Object.assign({},state[currentSku],{name:name,originalId:originalId,vendorId:vendor&&String(vendor.id),vendorName:vendor&&vendor.name,brandId:brand&&String(brand.id),description:description,images:images,features:features,productFeatures:productFeatures,skus:skus.filter(function(_ref){var sku=_ref.sku;return sku!==currentSku;}).map(function(_ref2){var sku=_ref2.sku;return sku;})})));},{});return Object.assign({},state,hotProducts);case __WEBPACK_IMPORTED_MODULE_0_Catalog_Showcase_ducks__["a" /* FETCH_SHOWCASE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_1_Catalog_Search_ducks__["a" /* FETCH_SEARCH_SUCCESS */]:hotProducts=action.payload.data.products.reduce(function(products,currentProduct){var sku=currentProduct.sku,name=currentProduct.name,originalId=currentProduct.originalId,vendor=currentProduct.vendor,imageUrl=currentProduct.imageUrl,brand=currentProduct.brand;return Object.assign({},products,_defineProperty({},sku,Object.assign({},state[sku],{name:name,originalId:originalId,vendorId:vendor&&String(vendor.id),brandId:brand&&String(brand.id),imageUrl:imageUrl})));},{});return Object.assign({},state,hotProducts);default:return state;}});

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);

var FocusTrap = __webpack_require__(1423);

var displace = __webpack_require__(1427);

var noScroll = __webpack_require__(1428);

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getApplicationNode", function () {
      if (_this.props.getApplicationNode) return _this.props.getApplicationNode();
      return _this.props.applicationNode;
    });

    _defineProperty(_assertThisInitialized(_this), "checkUnderlayClick", function (event) {
      if (_this.dialogNode && _this.dialogNode.contains(event.target) || // If the click is on the scrollbar we don't want to close the modal.
      event.pageX > event.target.ownerDocument.documentElement.offsetWidth || event.pageY > event.target.ownerDocument.documentElement.offsetHeight) return;

      _this.exit(event);
    });

    _defineProperty(_assertThisInitialized(_this), "checkDocumentKeyDown", function (event) {
      if (_this.props.escapeExits && (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)) {
        _this.exit(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "exit", function (event) {
      if (_this.props.onExit) {
        _this.props.onExit(event);
      }
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.props.titleText && !this.props.titleId) {
        throw new Error('react-aria-modal instances should have a `titleText` or `titleId`');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      } // Timeout to ensure this happens *after* focus has moved


      var applicationNode = this.getApplicationNode();
      setTimeout(function () {
        if (applicationNode) {
          applicationNode.setAttribute('aria-hidden', 'true');
        }
      }, 0);

      if (this.props.escapeExits) {
        this.addKeyDownListener();
      }

      if (this.props.scrollDisabled) {
        noScroll.on();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.scrollDisabled && !this.props.scrollDisabled) {
        noScroll.off();
      } else if (!prevProps.scrollDisabled && this.props.scrollDisabled) {
        noScroll.on();
      }

      if (this.props.escapeExits && !prevProps.escapeExits) {
        this.addKeyDownListener();
      } else if (!this.props.escapeExits && prevProps.escapeExits) {
        this.removeKeyDownListener();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.scrollDisabled) {
        noScroll.off();
      }

      var applicationNode = this.getApplicationNode();

      if (applicationNode) {
        applicationNode.setAttribute('aria-hidden', 'false');
      }

      this.removeKeyDownListener();
    }
  }, {
    key: "addKeyDownListener",
    value: function addKeyDownListener() {
      var _this2 = this;

      setTimeout(function () {
        document.addEventListener('keydown', _this2.checkDocumentKeyDown);
      });
    }
  }, {
    key: "removeKeyDownListener",
    value: function removeKeyDownListener() {
      var _this3 = this;

      setTimeout(function () {
        document.removeEventListener('keydown', _this3.checkDocumentKeyDown);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var style = {};

      if (props.includeDefaultStyles) {
        style = {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1050,
          overflowX: 'hidden',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          textAlign: 'center'
        };

        if (props.underlayColor) {
          style.background = props.underlayColor;
        }

        if (props.underlayClickExits) {
          style.cursor = 'pointer';
        }
      }

      if (props.underlayStyle) {
        for (var key in props.underlayStyle) {
          if (!props.underlayStyle.hasOwnProperty(key)) continue;
          style[key] = props.underlayStyle[key];
        }
      }

      var underlayProps = {
        className: props.underlayClass,
        style: style
      };

      if (props.underlayClickExits) {
        underlayProps.onMouseDown = this.checkUnderlayClick;
      }

      for (var prop in this.props.underlayProps) {
        underlayProps[prop] = this.props.underlayProps[prop];
      }

      var verticalCenterStyle = {};

      if (props.includeDefaultStyles) {
        verticalCenterStyle = {
          display: 'inline-block',
          height: '100%',
          verticalAlign: 'middle'
        };
      }

      var verticalCenterHelperProps = {
        key: 'a',
        style: verticalCenterStyle
      };
      var dialogStyle = {};

      if (props.includeDefaultStyles) {
        dialogStyle = {
          display: 'inline-block',
          textAlign: 'left',
          top: 0,
          maxWidth: '100%',
          cursor: 'default',
          outline: props.focusDialog ? 0 : null
        };

        if (props.verticallyCenter) {
          dialogStyle.verticalAlign = 'middle';
          dialogStyle.top = 0;
        }
      }

      if (props.dialogStyle) {
        for (var _key2 in props.dialogStyle) {
          if (!props.dialogStyle.hasOwnProperty(_key2)) continue;
          dialogStyle[_key2] = props.dialogStyle[_key2];
        }
      }

      var dialogProps = {
        key: 'b',
        ref: function (el) {
          this.dialogNode = el;
        }.bind(this),
        role: props.alert ? 'alertdialog' : 'dialog',
        id: props.dialogId,
        className: props.dialogClass,
        style: dialogStyle
      };

      if (props.titleId) {
        dialogProps['aria-labelledby'] = props.titleId;
      } else if (props.titleText) {
        dialogProps['aria-label'] = props.titleText;
      }

      if (props.focusDialog) {
        dialogProps.tabIndex = '-1';
      } // Apply data- and aria- attributes passed as props


      for (var _key3 in props) {
        if (/^(data-|aria-)/.test(_key3)) {
          dialogProps[_key3] = props[_key3];
        }
      }

      var childrenArray = [React.createElement('div', dialogProps, props.children)];

      if (props.verticallyCenter) {
        childrenArray.unshift(React.createElement('div', verticalCenterHelperProps));
      }

      var focusTrapOptions = props.focusTrapOptions || {};

      if (props.focusDialog || props.initialFocus) {
        focusTrapOptions.initialFocus = props.focusDialog ? "#".concat(this.props.dialogId) : props.initialFocus;
      }

      focusTrapOptions.escapeDeactivates = props.escapeExits;
      return React.createElement(FocusTrap, {
        focusTrapOptions: focusTrapOptions,
        paused: props.focusTrapPaused
      }, React.createElement('div', underlayProps, childrenArray));
    }
  }]);

  return Modal;
}(React.Component);

_defineProperty(Modal, "defaultProps", {
  underlayProps: {},
  dialogId: 'react-aria-modal-dialog',
  underlayClickExits: true,
  escapeExits: true,
  underlayColor: 'rgba(0,0,0,0.5)',
  includeDefaultStyles: true,
  focusTrapPaused: false,
  scrollDisabled: true
});

var DisplacedModal = displace(Modal);

DisplacedModal.renderTo = function (input) {
  return displace(Modal, {
    renderTo: input
  });
};

module.exports = DisplacedModal;

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(576);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return __WEBPACK_IMPORTED_MODULE_0__scope__["b"];
});
/* unused harmony reexport Scope */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(1445);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return __WEBPACK_IMPORTED_MODULE_1__hub__["a"];
});
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getMainCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */

//# sourceMappingURL=index.js.map

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* WEBPACK VAR INJECTION */(function (process, global) {
    /* harmony export (immutable) */__webpack_exports__["d"] = dynamicRequire;
    /* harmony export (immutable) */__webpack_exports__["j"] = isNodeEnv;
    /* harmony export (immutable) */__webpack_exports__["g"] = getGlobalObject;
    /* harmony export (immutable) */__webpack_exports__["n"] = uuid4;
    /* harmony export (immutable) */__webpack_exports__["l"] = parseUrl;
    /* harmony export (immutable) */__webpack_exports__["e"] = getEventDescription;
    /* harmony export (immutable) */__webpack_exports__["c"] = consoleSandbox;
    /* harmony export (immutable) */__webpack_exports__["b"] = addExceptionTypeValue;
    /* harmony export (immutable) */__webpack_exports__["a"] = addExceptionMechanism;
    /* harmony export (immutable) */__webpack_exports__["h"] = getLocationHref;
    /* harmony export (immutable) */__webpack_exports__["i"] = htmlTreeAsString;
    /* harmony export (immutable) */__webpack_exports__["m"] = timestampWithMs;
    /* unused harmony export parseSemver */
    /* harmony export (immutable) */__webpack_exports__["k"] = parseRetryAfterHeader;
    /* harmony export (immutable) */__webpack_exports__["f"] = getFunctionName;
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(127);

    /**
     * Requires a module which is protected _against bundler minification.
     *
     * @param request The module path to resolve
     */
    function dynamicRequire(mod, request) {
        // tslint:disable-next-line: no-unsafe-any
        return mod.require(request);
    }
    /**
     * Checks whether we're in the Node.js or Browser environment
     *
     * @returns Answer to given question
     */
    function isNodeEnv() {
        // tslint:disable:strict-type-predicates
        return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
    }
    var fallbackGlobalObject = {};
    /**
     * Safely get global scope object
     *
     * @returns Global scope object
     */
    function getGlobalObject() {
        return isNodeEnv() ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : fallbackGlobalObject;
    }
    /**
     * UUID4 generator
     *
     * @returns string Generated UUID4.
     */
    function uuid4() {
        var global = getGlobalObject();
        var crypto = global.crypto || global.msCrypto;
        if (!(crypto === void 0) && crypto.getRandomValues) {
            // Use window.crypto API if available
            var arr = new Uint16Array(8);
            crypto.getRandomValues(arr);
            // set 4 in byte 7
            // tslint:disable-next-line:no-bitwise
            arr[3] = arr[3] & 0xfff | 0x4000;
            // set 2 most significant bits of byte 9 to '10'
            // tslint:disable-next-line:no-bitwise
            arr[4] = arr[4] & 0x3fff | 0x8000;
            var pad = function pad(num) {
                var v = num.toString(16);
                while (v.length < 4) {
                    v = "0" + v;
                }
                return v;
            };
            return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
        }
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            // tslint:disable-next-line:no-bitwise
            var r = Math.random() * 16 | 0;
            // tslint:disable-next-line:no-bitwise
            var v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    /**
     * Parses string form of URL into an object
     * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
     * // intentionally using regex and not <a/> href parsing trick because React Native and other
     * // environments where DOM might not be available
     * @returns parsed URL object
     */
    function parseUrl(url) {
        if (!url) {
            return {};
        }
        var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
        if (!match) {
            return {};
        }
        // coerce to undefined values to empty string so we don't get 'undefined'
        var query = match[6] || '';
        var fragment = match[8] || '';
        return {
            host: match[4],
            path: match[5],
            protocol: match[2],
            relative: match[5] + query + fragment
        };
    }
    /**
     * Extracts either message or type+value from an event that can be used for user-facing logs
     * @returns event's description
     */
    function getEventDescription(event) {
        if (event.message) {
            return event.message;
        }
        if (event.exception && event.exception.values && event.exception.values[0]) {
            var exception = event.exception.values[0];
            if (exception.type && exception.value) {
                return exception.type + ": " + exception.value;
            }
            return exception.type || exception.value || event.event_id || '<unknown>';
        }
        return event.event_id || '<unknown>';
    }
    /** JSDoc */
    function consoleSandbox(callback) {
        var global = getGlobalObject();
        var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
        if (!('console' in global)) {
            return callback();
        }
        var originalConsole = global.console;
        var wrappedLevels = {};
        // Restore all wrapped console methods
        levels.forEach(function (level) {
            if (level in global.console && originalConsole[level].__sentry__) {
                wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
                originalConsole[level] = originalConsole[level].__sentry_original__;
            }
        });
        // Perform callback manipulations
        var result = callback();
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function (level) {
            originalConsole[level] = wrappedLevels[level];
        });
        return result;
    }
    /**
     * Adds exception values, type and value to an synthetic Exception.
     * @param event The event to modify.
     * @param value Value of the exception.
     * @param type Type of the exception.
     * @hidden
     */
    function addExceptionTypeValue(event, value, type) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].value = event.exception.values[0].value || value || '';
        event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
    }
    /**
     * Adds exception mechanism to a given event.
     * @param event The event to modify.
     * @param mechanism Mechanism of the mechanism.
     * @hidden
     */
    function addExceptionMechanism(event, mechanism) {
        if (mechanism === void 0) {
            mechanism = {};
        }
        // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
        try {
            // @ts-ignore
            // tslint:disable:no-non-null-assertion
            event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
            Object.keys(mechanism).forEach(function (key) {
                // @ts-ignore
                event.exception.values[0].mechanism[key] = mechanism[key];
            });
        } catch (_oO) {
            // no-empty
        }
    }
    /**
     * A safe form of location.href
     */
    function getLocationHref() {
        try {
            return document.location.href;
        } catch (oO) {
            return '';
        }
    }
    /**
     * Given a child DOM element, returns a query-selector statement describing that
     * and its ancestors
     * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
     * @returns generated DOM path
     */
    function htmlTreeAsString(elem) {
        // try/catch both:
        // - accessing event.target (see getsentry/raven-js#838, #768)
        // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
        // - can throw an exception in some circumstances.
        try {
            var currentElem = elem;
            var MAX_TRAVERSE_HEIGHT = 5;
            var MAX_OUTPUT_LEN = 80;
            var out = [];
            var height = 0;
            var len = 0;
            var separator = ' > ';
            var sepLength = separator.length;
            var nextStr = void 0;
            while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
                nextStr = _htmlElementAsString(currentElem);
                // bail out if
                // - nextStr is the 'html' element
                // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
                //   (ignore this limit if we are on the first iteration)
                if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) {
                    break;
                }
                out.push(nextStr);
                len += nextStr.length;
                currentElem = currentElem.parentNode;
            }
            return out.reverse().join(separator);
        } catch (_oO) {
            return '<unknown>';
        }
    }
    /**
     * Returns a simple, query-selector representation of a DOM element
     * e.g. [HTMLElement] => input#foo.btn[name=baz]
     * @returns generated DOM path
     */
    function _htmlElementAsString(el) {
        var elem = el;
        var out = [];
        var className;
        var classes;
        var key;
        var attr;
        var i;
        if (!elem || !elem.tagName) {
            return '';
        }
        out.push(elem.tagName.toLowerCase());
        if (elem.id) {
            out.push("#" + elem.id);
        }
        className = elem.className;
        if (className && Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
        var attrWhitelist = ['type', 'name', 'title', 'alt'];
        for (i = 0; i < attrWhitelist.length; i++) {
            key = attrWhitelist[i];
            attr = elem.getAttribute(key);
            if (attr) {
                out.push("[" + key + "=\"" + attr + "\"]");
            }
        }
        return out.join('');
    }
    /**
     * Returns a timestamp in seconds with milliseconds precision.
     */
    function timestampWithMs() {
        return new Date().getTime() / 1000;
    }
    // https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
    var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
    /**
     * Parses input into a SemVer interface
     * @param input string representation of a semver version
     */
    function parseSemver(input) {
        var match = input.match(SEMVER_REGEXP) || [];
        var major = parseInt(match[1], 10);
        var minor = parseInt(match[2], 10);
        var patch = parseInt(match[3], 10);
        return {
            buildmetadata: match[5],
            major: isNaN(major) ? undefined : major,
            minor: isNaN(minor) ? undefined : minor,
            patch: isNaN(patch) ? undefined : patch,
            prerelease: match[4]
        };
    }
    var defaultRetryAfter = 60 * 1000; // 60 seconds
    /**
     * Extracts Retry-After value from the request header or returns default value
     * @param now current unix timestamp
     * @param header string representation of 'Retry-After' header
     */
    function parseRetryAfterHeader(now, header) {
        if (!header) {
            return defaultRetryAfter;
        }
        var headerDelay = parseInt("" + header, 10);
        if (!isNaN(headerDelay)) {
            return headerDelay * 1000;
        }
        var headerDate = Date.parse("" + header);
        if (!isNaN(headerDate)) {
            return headerDate - now;
        }
        return defaultRetryAfter;
    }
    var defaultFunctionName = '<anonymous>';
    /**
     * Safely extract function name from itself
     */
    function getFunctionName(fn) {
        try {
            if (!fn || typeof fn !== 'function') {
                return defaultFunctionName;
            }
            return fn.name || defaultFunctionName;
        } catch (e) {
            // Just accessing custom props in some Selenium environments
            // can cause a "Permission denied" exception (see raven-js#495).
            return defaultFunctionName;
        }
    }
    //# sourceMappingURL=misc.js.map
    /* WEBPACK VAR INJECTION */
}).call(__webpack_exports__, __webpack_require__(36), __webpack_require__(8));

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyOrdersContainer__ = __webpack_require__(1473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MyOrdersContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductOrderDetail__ = __webpack_require__(1492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ProductOrderDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(1505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__reducer__["a"]; });


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
var MILLISECONDS_IN_MINUTE = 60000;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mileage__ = __webpack_require__(1667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Mileage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].mileageApi.client,clientMkp=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client,clientMkp);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_METADATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setMetadata; });
var SET_METADATA='metadata/SET';var initialState={title: true?"Tupperware | Premmiar":'Catálogo de Prêmios | Premmiar',description:'O WebPrêmios é um marketplace com design integrado que oferece uma experiência interativa ao participante, possibilitando a personalização do catálogo sem necessidade de envolvimento de técnicos ou intermediários. Entre suas facilidades estão telas de comparativo de preços, carrinho único, tracking, navegação com menos cliques, atendimento por chat e cross-selling de produtos.'};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case SET_METADATA:return Object.assign({},state,action.metadata);default:return state;}});var setMetadata=function setMetadata(metadata){return{type:SET_METADATA,metadata:metadata};};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomeIupp__ = __webpack_require__(1841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__HomeIupp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card_CardStore__ = __webpack_require__(326);
/* unused harmony reexport CardStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_CardOferta__ = __webpack_require__(167);
/* unused harmony reexport CardOferta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Product_ProductContainer__ = __webpack_require__(1862);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Product_ProductContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Store_StoreContainer__ = __webpack_require__(1872);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__Store_StoreContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Search_Search__ = __webpack_require__(1880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Search_Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Search_SearchEcommerce__ = __webpack_require__(1881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__Search_SearchEcommerce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Search_SearchStore__ = __webpack_require__(1882);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__Search_SearchStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Search_Sidebar__ = __webpack_require__(1883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__Search_Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Search_NotFound__ = __webpack_require__(1889);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__Search_NotFound__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Store_EmptyOffers__ = __webpack_require__(1890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__Store_EmptyOffers__["a"]; });


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardOferta=function(_Component){_inherits(CardOferta,_Component);function CardOferta(){_classCallCheck(this,CardOferta);return _possibleConstructorReturn(this,(CardOferta.__proto__||Object.getPrototypeOf(CardOferta)).apply(this,arguments));}_createClass(CardOferta,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/comunidade-iupp/product/'+this.props.id+'/store/'+this.props.store.id+'/company/'+this.props.store.externalCode,tabIndex:0,className:'card card-bairro mt-2',title:'Vai para '+this.props.name},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bordered radius border-color-ui-3 bg-white d-flex-mob'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'figure-mBairo d-flex justify-content-center mt-2 mb-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default.a,{src:this.props.images.length>0?this.props.images[0].url:null,fallbackImage:__WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png___default.a,alt:this.props.isPhysicalStore?this.props.fantasyName+' '+this.props.store.name+' - '+this.props.name:this.props.fantasyName+' - '+this.props.name,className:'mx-auto'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'div-mob h-auto'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col-12 mt-0 px-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'txt-body w-100 color-ui-black txt-font-body mb-1 text-bfits-list'},this.props.fantasyName,' ',this.props.isPhysicalStore?'-'+this.props.store.name:''),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'text-style-benific lineH29'},this.props.offer?this.props.offer.benefitTitle:this.props.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',{className:'text-benific-pq colorBairro'},this.props.location?(this.props.store.place.location.distance/1000).toFixed(1)+' km - '+this.props.store.place.address.city:'',' ')))));}}]);return CardOferta;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);CardOferta.propTypes={offer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,images:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isPhysicalStore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fantasyName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,store:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,fantasyName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,externalCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,place:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({distance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({city:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})})}),location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (CardOferta);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(63);
var global = __webpack_require__(16);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(89) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(65);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(10);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(40);
var SPECIES = __webpack_require__(26)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){if(true)module.exports=r(__webpack_require__(1),__webpack_require__(0),function(){try{return __webpack_require__(365)}catch(e){}}(),__webpack_require__(176));else if("function"==typeof define&&define.amd)define(["prop-types","react","immutable","oidc-client"],r);else{var t="object"==typeof exports?r(require("prop-types"),require("react"),function(){try{return require("immutable")}catch(e){}}(),require("oidc-client")):r(e["prop-types"],e.react,e.immutable,e["oidc-client"]);for(var n in t)("object"==typeof exports?exports:e)[n]=t[n]}}(this,function(e,r,t,n){return function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}var t={};return r.m=e,r.c=t,r.i=function(e){return e},r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},r.p="",r(r.s=16)}([function(e,r,t){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.USER_EXPIRED="redux-oidc/USER_EXPIRED",r.SILENT_RENEW_ERROR="redux-oidc/SILENT_RENEW_ERROR",r.SESSION_TERMINATED="redux-oidc/SESSION_TERMINATED",r.USER_EXPIRING="redux-oidc/USER_EXPIRING",r.USER_FOUND="redux-oidc/USER_FOUND",r.LOADING_USER="redux-oidc/LOADING_USER",r.USER_SIGNED_OUT="redux-oidc/USER_SIGNED_OUT",r.LOAD_USER_ERROR="redux-oidc/LOAD_USER_ERROR"},function(e,r,t){"use strict";function n(){return{type:d.USER_EXPIRED}}function o(e){return{type:d.USER_FOUND,payload:e}}function u(e){return{type:d.SILENT_RENEW_ERROR,payload:e}}function i(){return{type:d.SESSION_TERMINATED}}function s(){return{type:d.USER_EXPIRING}}function a(){return{type:d.LOADING_USER}}function c(){return{type:d.USER_SIGNED_OUT}}function l(){return{type:d.LOAD_USER_ERROR}}Object.defineProperty(r,"__esModule",{value:!0}),r.userExpired=n,r.userFound=o,r.silentRenewError=u,r.sessionTerminated=i,r.userExpiring=s,r.loadingUser=a,r.userSignedOut=c,r.loadUserError=l;var d=t(0)},function(e,r){e.exports=__webpack_require__(1)},function(e,r){e.exports=__webpack_require__(0)},function(e,r,t){"use strict";function n(e){return new o.UserManager(e)}Object.defineProperty(r,"__esModule",{value:!0}),r.default=n;var o=t(15)},function(e,r,t){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.loadUserError=r.userSignedOut=r.loadingUser=r.userExpiring=r.sessionTerminated=r.silentRenewError=r.userFound=r.userExpired=r.LOAD_USER_ERROR=r.USER_SIGNED_OUT=r.LOADING_USER=r.USER_EXPIRING=r.SESSION_TERMINATED=r.SILENT_RENEW_ERROR=r.USER_FOUND=r.USER_EXPIRED=r.SignoutCallbackComponent=r.OidcProvider=r.reducer=r.immutableReducer=r.CallbackComponent=r.loadUser=r.processSilentRenew=r.createUserManager=void 0;var n=t(11),o=function(e){return e&&e.__esModule?e:{default:e}}(n);r.createUserManager=t(4).default,r.processSilentRenew=t(10).default,r.loadUser=t(9).default,r.CallbackComponent=t(6).default,r.immutableReducer=t(12).default,r.reducer=t(13).default,r.OidcProvider=t(7).default,r.SignoutCallbackComponent=t(8).default,r.USER_EXPIRED=t(0).USER_EXPIRED,r.USER_FOUND=t(0).USER_FOUND,r.SILENT_RENEW_ERROR=t(0).SILENT_RENEW_ERROR,r.SESSION_TERMINATED=t(0).SESSION_TERMINATED,r.USER_EXPIRING=t(0).USER_EXPIRING,r.LOADING_USER=t(0).LOADING_USER,r.USER_SIGNED_OUT=t(0).USER_SIGNED_OUT,r.LOAD_USER_ERROR=t(0).LOAD_USER_ERROR,r.userExpired=t(1).userExpired,r.userFound=t(1).userFound,r.silentRenewError=t(1).silentRenewError,r.sessionTerminated=t(1).sessionTerminated,r.userExpiring=t(1).userExpiring,r.loadingUser=t(1).loadingUser,r.userSignedOut=t(1).userSignedOut,r.loadUserError=t(1).loadUserError,r.default=o.default},function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}function u(e,r){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!r||"object"!=typeof r&&"function"!=typeof r?e:r}function i(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Super expression must either be null or a function, not "+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)}Object.defineProperty(r,"__esModule",{value:!0});var s=function(){function e(e,r){for(var t=0;t<r.length;t++){var n=r[t];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(r,t,n){return t&&e(r.prototype,t),n&&e(r,n),r}}(),a=t(2),c=n(a),l=t(3),d=n(l),f=function(e){function r(){var e,t,n,i;o(this,r);for(var s=arguments.length,a=Array(s),c=0;c<s;c++)a[c]=arguments[c];return t=n=u(this,(e=r.__proto__||Object.getPrototypeOf(r)).call.apply(e,[this].concat(a))),n.onRedirectSuccess=function(e){n.props.successCallback(e)},n.onRedirectError=function(e){if(!n.props.errorCallback)throw new Error("Error handling redirect callback: "+e.message);n.props.errorCallback(e)},i=t,u(n,i)}return i(r,e),s(r,[{key:"componentDidMount",value:function(){var e=this;this.props.userManager.signinRedirectCallback().then(function(r){return e.onRedirectSuccess(r)}).catch(function(r){return e.onRedirectError(r)})}},{key:"render",value:function(){return d.default.Children.only(this.props.children)}}]),r}(d.default.Component);f.propTypes={children:c.default.element.isRequired,userManager:c.default.object.isRequired,successCallback:c.default.func.isRequired,errorCallback:c.default.func},r.default=f},function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}function u(e,r){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!r||"object"!=typeof r&&"function"!=typeof r?e:r}function i(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Super expression must either be null or a function, not "+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)}Object.defineProperty(r,"__esModule",{value:!0});var s=function(){function e(e,r){for(var t=0;t<r.length;t++){var n=r[t];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(r,t,n){return t&&e(r.prototype,t),n&&e(r,n),r}}(),a=t(2),c=n(a),l=t(3),d=n(l),f=t(1),p=function(e){function r(e){o(this,r);var t=u(this,(r.__proto__||Object.getPrototypeOf(r)).call(this,e));return t.onUserLoaded=function(e){t.props.store.dispatch((0,f.userFound)(e))},t.onSilentRenewError=function(e){t.props.store.dispatch((0,f.silentRenewError)(e))},t.onAccessTokenExpired=function(){t.props.store.dispatch((0,f.userExpired)())},t.onUserUnloaded=function(){t.props.store.dispatch((0,f.sessionTerminated)())},t.onAccessTokenExpiring=function(){t.props.store.dispatch((0,f.userExpiring)())},t.onUserSignedOut=function(){t.props.store.dispatch((0,f.userSignedOut)())},t.userManager=e.userManager,t.userManager.events.addUserLoaded(t.onUserLoaded),t.userManager.events.addSilentRenewError(t.onSilentRenewError),t.userManager.events.addAccessTokenExpired(t.onAccessTokenExpired),t.userManager.events.addAccessTokenExpiring(t.onAccessTokenExpiring),t.userManager.events.addUserUnloaded(t.onUserUnloaded),t.userManager.events.addUserSignedOut(t.onUserSignedOut),t}return i(r,e),s(r,[{key:"componentWillUnmount",value:function(){this.userManager.events.removeUserLoaded(this.onUserLoaded),this.userManager.events.removeSilentRenewError(this.onSilentRenewError),this.userManager.events.removeAccessTokenExpired(this.onAccessTokenExpired),this.userManager.events.removeAccessTokenExpiring(this.onAccessTokenExpiring),this.userManager.events.removeUserUnloaded(this.onUserUnloaded),this.userManager.events.removeUserSignedOut(this.onUserSignedOut)}},{key:"render",value:function(){return d.default.Children.only(this.props.children)}}]),r}(d.default.Component);p.propTypes={userManager:c.default.object.isRequired,store:c.default.object.isRequired},r.default=p},function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}function u(e,r){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!r||"object"!=typeof r&&"function"!=typeof r?e:r}function i(e,r){if("function"!=typeof r&&null!==r)throw new TypeError("Super expression must either be null or a function, not "+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)}Object.defineProperty(r,"__esModule",{value:!0});var s=function(){function e(e,r){for(var t=0;t<r.length;t++){var n=r[t];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(r,t,n){return t&&e(r.prototype,t),n&&e(r,n),r}}(),a=t(2),c=n(a),l=t(3),d=n(l),f=function(e){function r(){var e,t,n,i;o(this,r);for(var s=arguments.length,a=Array(s),c=0;c<s;c++)a[c]=arguments[c];return t=n=u(this,(e=r.__proto__||Object.getPrototypeOf(r)).call.apply(e,[this].concat(a))),n.onRedirectSuccess=function(e){n.props.successCallback(e)},n.onRedirectError=function(e){if(!n.props.errorCallback)throw new Error("Error handling logout redirect callback: "+e.message);n.props.errorCallback(e)},i=t,u(n,i)}return i(r,e),s(r,[{key:"componentDidMount",value:function(){var e=this;this.props.userManager.signoutRedirectCallback().then(function(r){return e.onRedirectSuccess(r)}).catch(function(r){return e.onRedirectError(r)})}},{key:"render",value:function(){return d.default.Children.only(this.props.children)}}]),r}(d.default.Component);f.propTypes={children:c.default.element.isRequired,userManager:c.default.object.isRequired,successCallback:c.default.func.isRequired,errorCallback:c.default.func},r.default=f},function(e,r,t){"use strict";function n(e){c=e}function o(){return c}function u(e){return e&&!e.expired?c.dispatch((0,a.userFound)(e)):(!e||e&&e.expired)&&c.dispatch((0,a.userExpired)()),e}function i(e){console.error("redux-oidc: Error in loadUser() function: "+e.message),c.dispatch((0,a.loadUserError)())}function s(e,r){if(!e||!e.dispatch)throw new Error("redux-oidc: You need to pass the redux store into the loadUser helper!");if(!r||!r.getUser)throw new Error("redux-oidc: You need to pass the userManager into the loadUser helper!");return c=e,e.dispatch((0,a.loadingUser)()),r.getUser().then(u).catch(i)}Object.defineProperty(r,"__esModule",{value:!0}),r.setReduxStore=n,r.getReduxStore=o,r.getUserCallback=u,r.errorCallback=i,r.default=s;var a=t(1),c=void 0},function(e,r,t){"use strict";function n(){(0,u.default)().signinSilentCallback()}Object.defineProperty(r,"__esModule",{value:!0}),r.default=n;var o=t(4),u=function(e){return e&&e.__esModule?e:{default:e}}(o)},function(e,r,t){"use strict";function n(e){r.nextMiddleware=E=e}function o(){return E}function u(e){r.storedUser=p=e}function i(){r.storedUser=p=null}function s(e){!e||e.expired?E((0,d.userExpired)()):(r.storedUser=p=e,E((0,d.userFound)(e)))}function a(e){console.error("redux-oidc: Error loading user in oidcMiddleware: "+e.message),E((0,d.loadUserError)())}function c(e,t,n){return t.type===f.USER_EXPIRED||t.type===f.LOADING_USER||t.type===f.USER_FOUND?e(t):(r.nextMiddleware=E=e,p&&!p.expired||(e((0,d.loadingUser)()),n.getUser().then(s).catch(a)),e(t))}function l(e){if(!e||!e.getUser)throw new Error("You must provide a user manager!");return function(r){return function(r){return function(t){return c(r,t,e)}}}}Object.defineProperty(r,"__esModule",{value:!0}),r.nextMiddleware=r.storedUser=void 0,r.setNext=n,r.getNext=o,r.setStoredUser=u,r.removeStoredUser=i,r.getUserCallback=s,r.errorCallback=a,r.middlewareHandler=c,r.default=l;var d=t(1),f=t(0),p=r.storedUser=null,E=r.nextMiddleware=null},function(e,r,t){"use strict";Object.defineProperty(r,"__esModule",{value:!0});var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=t(0),u=void 0;try{var i=t(14),s=i.fromJS,a=i.Seq,c=function e(r){return"object"!==(void 0===r?"undefined":n(r))||null===r?r:Array.isArray(r)?a(r).map(e).toList():a(r).map(e).toMap()},l=s({user:null,isLoadingUser:!1});u=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,r=arguments[1];switch(r.type){case o.USER_EXPIRED:case o.SILENT_RENEW_ERROR:return s({user:null,isLoadingUser:!1});case o.SESSION_TERMINATED:case o.USER_SIGNED_OUT:return s({user:null,isLoadingUser:!1});case o.USER_FOUND:return c({user:r.payload,isLoadingUser:!1});case o.LOADING_USER:return e.set("isLoadingUser",!0);default:return e}}}catch(e){u=function(){console.error("You must install immutable-js for the immutable reducer to work!")}}r.default=u},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:i,r=arguments[1];switch(r.type){case u.USER_EXPIRED:case u.SILENT_RENEW_ERROR:return Object.assign({},o({},e),{user:null,isLoadingUser:!1});case u.SESSION_TERMINATED:case u.USER_SIGNED_OUT:return Object.assign({},o({},e),{user:null,isLoadingUser:!1});case u.USER_FOUND:return Object.assign({},o({},e),{user:r.payload,isLoadingUser:!1});case u.LOADING_USER:return Object.assign({},o({},e),{isLoadingUser:!0});default:return e}}Object.defineProperty(r,"__esModule",{value:!0});var o=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e};r.default=n;var u=t(0),i={user:null,isLoadingUser:!1}},function(e,r){e.exports=__webpack_require__(365)},function(e,r){e.exports=__webpack_require__(176)},function(e,r,t){e.exports=t(5)}])});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

!function t(e,r){if(true)module.exports=r();else if("function"==typeof define&&define.amd)define([],r);else{var n=r();for(var i in n)("object"==typeof exports?exports:e)[i]=n[i]}}(this,function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function e(){return t.default}:function e(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=22)}([function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}();var i={debug:function t(){},info:function t(){},warn:function t(){},error:function t(){}},o=void 0,s=void 0;(e.Log=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.reset=function t(){s=3,o=i},t.debug=function t(){if(s>=4){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.debug.apply(o,Array.from(r))}},t.info=function t(){if(s>=3){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.info.apply(o,Array.from(r))}},t.warn=function t(){if(s>=2){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.warn.apply(o,Array.from(r))}},t.error=function t(){if(s>=1){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.error.apply(o,Array.from(r))}},n(t,null,[{key:"NONE",get:function t(){return 0}},{key:"ERROR",get:function t(){return 1}},{key:"WARN",get:function t(){return 2}},{key:"INFO",get:function t(){return 3}},{key:"DEBUG",get:function t(){return 4}},{key:"level",get:function t(){return s},set:function t(e){if(!(0<=e&&e<=4))throw new Error("Invalid log level");s=e}},{key:"logger",get:function t(){return o},set:function t(e){if(!e.debug&&e.info&&(e.debug=e.info),!(e.debug&&e.info&&e.warn&&e.error))throw new Error("Invalid logger");o=e}}]),t}()).reset()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}();var i={setInterval:function(t){function e(e,r){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t,e){return setInterval(t,e)}),clearInterval:function(t){function e(e){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t){return clearInterval(t)})},o=!1,s=null;e.Global=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t._testing=function t(){o=!0},t.setXMLHttpRequest=function t(e){s=e},n(t,null,[{key:"location",get:function t(){if(!o)return location}},{key:"localStorage",get:function t(){if(!o&&"undefined"!=typeof window)return localStorage}},{key:"sessionStorage",get:function t(){if(!o&&"undefined"!=typeof window)return sessionStorage}},{key:"XMLHttpRequest",get:function t(){if(!o&&"undefined"!=typeof window)return s||XMLHttpRequest}},{key:"timer",get:function t(){if(!o)return i}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.MetadataService=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(7);e.MetadataService=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.JsonService;if(function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw i.Log.error("MetadataService: No settings passed to MetadataService"),new Error("settings");this._settings=e,this._jsonService=new r(["application/jwk-set+json"])}return t.prototype.getMetadata=function t(){var e=this;return this._settings.metadata?(i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"),Promise.resolve(this._settings.metadata)):this.metadataUrl?(i.Log.debug("MetadataService.getMetadata: getting metadata from",this.metadataUrl),this._jsonService.getJson(this.metadataUrl).then(function(t){return i.Log.debug("MetadataService.getMetadata: json received"),e._settings.metadata=t,t})):(i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"),Promise.reject(new Error("No authority or metadataUrl configured on settings")))},t.prototype.getIssuer=function t(){return this._getMetadataProperty("issuer")},t.prototype.getAuthorizationEndpoint=function t(){return this._getMetadataProperty("authorization_endpoint")},t.prototype.getUserInfoEndpoint=function t(){return this._getMetadataProperty("userinfo_endpoint")},t.prototype.getTokenEndpoint=function t(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return this._getMetadataProperty("token_endpoint",e)},t.prototype.getCheckSessionIframe=function t(){return this._getMetadataProperty("check_session_iframe",!0)},t.prototype.getEndSessionEndpoint=function t(){return this._getMetadataProperty("end_session_endpoint",!0)},t.prototype.getRevocationEndpoint=function t(){return this._getMetadataProperty("revocation_endpoint",!0)},t.prototype.getKeysEndpoint=function t(){return this._getMetadataProperty("jwks_uri",!0)},t.prototype._getMetadataProperty=function t(e){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return i.Log.debug("MetadataService.getMetadataProperty for: "+e),this.getMetadata().then(function(t){if(i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"),void 0===t[e]){if(!0===r)return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property "+e);throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property "+e),new Error("Metadata does not contain property "+e)}return t[e]})},t.prototype.getSigningKeys=function t(){var e=this;return this._settings.signingKeys?(i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"),Promise.resolve(this._settings.signingKeys)):this._getMetadataProperty("jwks_uri").then(function(t){return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received",t),e._jsonService.getJson(t).then(function(t){if(i.Log.debug("MetadataService.getSigningKeys: key set received",t),!t.keys)throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"),new Error("Missing keys on keyset");return e._settings.signingKeys=t.keys,e._settings.signingKeys})})},n(t,[{key:"metadataUrl",get:function t(){return this._metadataUrl||(this._settings.metadataUrl?this._metadataUrl=this._settings.metadataUrl:(this._metadataUrl=this._settings.authority,this._metadataUrl&&this._metadataUrl.indexOf(".well-known/openid-configuration")<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=".well-known/openid-configuration"))),this._metadataUrl}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UrlUtility=void 0;var n=r(0),i=r(1);e.UrlUtility=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.addQueryParam=function t(e,r,n){return e.indexOf("?")<0&&(e+="?"),"?"!==e[e.length-1]&&(e+="&"),e+=encodeURIComponent(r),e+="=",e+=encodeURIComponent(n)},t.parseUrlFragment=function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#",o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.Global;"string"!=typeof e&&(e=o.location.href);var s=e.lastIndexOf(r);s>=0&&(e=e.substr(s+1)),"?"===r&&(s=e.indexOf("#"))>=0&&(e=e.substr(0,s));for(var a,u={},c=/([^&=]+)=([^&]*)/g,h=0;a=c.exec(e);)if(u[decodeURIComponent(a[1])]=decodeURIComponent(a[2]),h++>50)return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters",e),{error:"Response exceeded expected number of parameters"};for(var l in u)return u;return{}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.JoseUtil=void 0;var n=r(25),i=function o(t){return t&&t.__esModule?t:{default:t}}(r(32));e.JoseUtil=(0,i.default)({jws:n.jws,KeyUtil:n.KeyUtil,X509:n.X509,crypto:n.crypto,hextob64u:n.hextob64u,b64tohex:n.b64tohex,AllowedSigningAlgs:n.AllowedSigningAlgs})},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.OidcClientSettings=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=r(0),s=r(6),a=r(23),u=r(2);var c="id_token",h="openid",l=900,f=300;e.OidcClientSettings=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.authority,i=e.metadataUrl,o=e.metadata,d=e.signingKeys,p=e.client_id,g=e.client_secret,v=e.response_type,y=void 0===v?c:v,m=e.scope,_=void 0===m?h:m,S=e.redirect_uri,F=e.post_logout_redirect_uri,b=e.prompt,w=e.display,E=e.max_age,x=e.ui_locales,k=e.acr_values,A=e.resource,P=e.response_mode,C=e.filterProtocolClaims,T=void 0===C||C,R=e.loadUserInfo,I=void 0===R||R,D=e.staleStateAge,L=void 0===D?l:D,U=e.clockSkew,B=void 0===U?f:U,N=e.userInfoJwtIssuer,O=void 0===N?"OP":N,j=e.stateStore,H=void 0===j?new s.WebStorageStateStore:j,M=e.ResponseValidatorCtor,K=void 0===M?a.ResponseValidator:M,V=e.MetadataServiceCtor,q=void 0===V?u.MetadataService:V,J=e.extraQueryParams,W=void 0===J?{}:J;!function z(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._authority=r,this._metadataUrl=i,this._metadata=o,this._signingKeys=d,this._client_id=p,this._client_secret=g,this._response_type=y,this._scope=_,this._redirect_uri=S,this._post_logout_redirect_uri=F,this._prompt=b,this._display=w,this._max_age=E,this._ui_locales=x,this._acr_values=k,this._resource=A,this._response_mode=P,this._filterProtocolClaims=!!T,this._loadUserInfo=!!I,this._staleStateAge=L,this._clockSkew=B,this._userInfoJwtIssuer=O,this._stateStore=H,this._validator=new K(this),this._metadataService=new q(this),this._extraQueryParams="object"===(void 0===W?"undefined":n(W))?W:{}}return i(t,[{key:"client_id",get:function t(){return this._client_id},set:function t(e){if(this._client_id)throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."),new Error("client_id has already been assigned.");this._client_id=e}},{key:"client_secret",get:function t(){return this._client_secret}},{key:"response_type",get:function t(){return this._response_type}},{key:"scope",get:function t(){return this._scope}},{key:"redirect_uri",get:function t(){return this._redirect_uri}},{key:"post_logout_redirect_uri",get:function t(){return this._post_logout_redirect_uri}},{key:"prompt",get:function t(){return this._prompt}},{key:"display",get:function t(){return this._display}},{key:"max_age",get:function t(){return this._max_age}},{key:"ui_locales",get:function t(){return this._ui_locales}},{key:"acr_values",get:function t(){return this._acr_values}},{key:"resource",get:function t(){return this._resource}},{key:"response_mode",get:function t(){return this._response_mode}},{key:"authority",get:function t(){return this._authority},set:function t(e){if(this._authority)throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."),new Error("authority has already been assigned.");this._authority=e}},{key:"metadataUrl",get:function t(){return this._metadataUrl||(this._metadataUrl=this.authority,this._metadataUrl&&this._metadataUrl.indexOf(".well-known/openid-configuration")<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=".well-known/openid-configuration")),this._metadataUrl}},{key:"metadata",get:function t(){return this._metadata},set:function t(e){this._metadata=e}},{key:"signingKeys",get:function t(){return this._signingKeys},set:function t(e){this._signingKeys=e}},{key:"filterProtocolClaims",get:function t(){return this._filterProtocolClaims}},{key:"loadUserInfo",get:function t(){return this._loadUserInfo}},{key:"staleStateAge",get:function t(){return this._staleStateAge}},{key:"clockSkew",get:function t(){return this._clockSkew}},{key:"userInfoJwtIssuer",get:function t(){return this._userInfoJwtIssuer}},{key:"stateStore",get:function t(){return this._stateStore}},{key:"validator",get:function t(){return this._validator}},{key:"metadataService",get:function t(){return this._metadataService}},{key:"extraQueryParams",get:function t(){return this._extraQueryParams},set:function t(e){"object"===(void 0===e?"undefined":n(e))?this._extraQueryParams=e:this._extraQueryParams={}}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.WebStorageStateStore=void 0;var n=r(0),i=r(1);e.WebStorageStateStore=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.prefix,n=void 0===r?"oidc.":r,o=e.store,s=void 0===o?i.Global.localStorage:o;!function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._store=s,this._prefix=n}return t.prototype.set=function t(e,r){return n.Log.debug("WebStorageStateStore.set",e),e=this._prefix+e,this._store.setItem(e,r),Promise.resolve()},t.prototype.get=function t(e){n.Log.debug("WebStorageStateStore.get",e),e=this._prefix+e;var r=this._store.getItem(e);return Promise.resolve(r)},t.prototype.remove=function t(e){n.Log.debug("WebStorageStateStore.remove",e),e=this._prefix+e;var r=this._store.getItem(e);return this._store.removeItem(e),Promise.resolve(r)},t.prototype.getAllKeys=function t(){n.Log.debug("WebStorageStateStore.getAllKeys");for(var e=[],r=0;r<this._store.length;r++){var i=this._store.key(r);0===i.indexOf(this._prefix)&&e.push(i.substr(this._prefix.length))}return Promise.resolve(e)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.JsonService=void 0;var n=r(0),i=r(1);e.JsonService=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.Global.XMLHttpRequest,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;!function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),e&&Array.isArray(e)?this._contentTypes=e.slice():this._contentTypes=[],this._contentTypes.push("application/json"),n&&this._contentTypes.push("application/jwt"),this._XMLHttpRequest=r,this._jwtHandler=n}return t.prototype.getJson=function t(e,r){var i=this;if(!e)throw n.Log.error("JsonService.getJson: No url passed"),new Error("url");return n.Log.debug("JsonService.getJson, url: ",e),new Promise(function(t,o){var s=new i._XMLHttpRequest;s.open("GET",e);var a=i._contentTypes,u=i._jwtHandler;s.onload=function(){if(n.Log.debug("JsonService.getJson: HTTP response received, status",s.status),200===s.status){var r=s.getResponseHeader("Content-Type");if(r){var i=a.find(function(t){if(r.startsWith(t))return!0});if("application/jwt"==i)return void u(s).then(t,o);if(i)try{return void t(JSON.parse(s.responseText))}catch(t){return n.Log.error("JsonService.getJson: Error parsing JSON response",t.message),void o(t)}}o(Error("Invalid response Content-Type: "+r+", from URL: "+e))}else o(Error(s.statusText+" ("+s.status+")"))},s.onerror=function(){n.Log.error("JsonService.getJson: network error"),o(Error("Network Error"))},r&&(n.Log.debug("JsonService.getJson: token passed, setting Authorization header"),s.setRequestHeader("Authorization","Bearer "+r)),s.send()})},t.prototype.postForm=function t(e,r){var i=this;if(!e)throw n.Log.error("JsonService.postForm: No url passed"),new Error("url");return n.Log.debug("JsonService.postForm, url: ",e),new Promise(function(t,o){var s=new i._XMLHttpRequest;s.open("POST",e);var a=i._contentTypes;s.onload=function(){if(n.Log.debug("JsonService.postForm: HTTP response received, status",s.status),200!==s.status){if(400===s.status)if(i=s.getResponseHeader("Content-Type"))if(a.find(function(t){if(i.startsWith(t))return!0}))try{var r=JSON.parse(s.responseText);if(r&&r.error)return n.Log.error("JsonService.postForm: Error from server: ",r.error),void o(new Error(r.error))}catch(t){return n.Log.error("JsonService.postForm: Error parsing JSON response",t.message),void o(t)}o(Error(s.statusText+" ("+s.status+")"))}else{var i;if((i=s.getResponseHeader("Content-Type"))&&a.find(function(t){if(i.startsWith(t))return!0}))try{return void t(JSON.parse(s.responseText))}catch(t){return n.Log.error("JsonService.postForm: Error parsing JSON response",t.message),void o(t)}o(Error("Invalid response Content-Type: "+i+", from URL: "+e))}},s.onerror=function(){n.Log.error("JsonService.postForm: network error"),o(Error("Network Error"))};var u="";for(var c in r){var h=r[c];h&&(u.length>0&&(u+="&"),u+=encodeURIComponent(c),u+="=",u+=encodeURIComponent(h))}s.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),s.send(u)})},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.State=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=function s(t){return t&&t.__esModule?t:{default:t}}(r(14));e.State=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.id,n=e.data,i=e.created,s=e.request_type;!function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._id=r||(0,o.default)(),this._data=n,this._created="number"==typeof i&&i>0?i:parseInt(Date.now()/1e3),this._request_type=s}return t.prototype.toStorageString=function t(){return i.Log.debug("State.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,request_type:this.request_type})},t.fromStorageString=function e(r){return i.Log.debug("State.fromStorageString"),new t(JSON.parse(r))},t.clearStaleState=function e(r,n){var o=Date.now()/1e3-n;return r.getAllKeys().then(function(e){i.Log.debug("State.clearStaleState: got keys",e);for(var n=[],s=function s(a){var c=e[a];u=r.get(c).then(function(e){var n=!1;if(e)try{var s=t.fromStorageString(e);i.Log.debug("State.clearStaleState: got item from key: ",c,s.created),s.created<=o&&(n=!0)}catch(t){i.Log.error("State.clearStaleState: Error parsing state for key",c,t.message),n=!0}else i.Log.debug("State.clearStaleState: no item in storage for key: ",c),n=!0;if(n)return i.Log.debug("State.clearStaleState: removed item for key: ",c),r.remove(c)}),n.push(u)},a=0;a<e.length;a++){var u;s(a)}return i.Log.debug("State.clearStaleState: waiting on promise count:",n.length),Promise.all(n)})},n(t,[{key:"id",get:function t(){return this._id}},{key:"data",get:function t(){return this._data}},{key:"created",get:function t(){return this._created}},{key:"request_type",get:function t(){return this._request_type}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.OidcClient=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(5),s=r(11),a=r(12),u=r(36),c=r(37),h=r(38),l=r(13),f=r(8);e.OidcClient=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),e instanceof o.OidcClientSettings?this._settings=e:this._settings=new o.OidcClientSettings(e)}return t.prototype.createSigninRequest=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.response_type,o=r.scope,s=r.redirect_uri,u=r.data,c=r.state,h=r.prompt,l=r.display,f=r.max_age,d=r.ui_locales,p=r.id_token_hint,g=r.login_hint,v=r.acr_values,y=r.resource,m=r.request,_=r.request_uri,S=r.response_mode,F=r.extraQueryParams,b=r.extraTokenParams,w=r.request_type,E=r.skipUserInfo,x=arguments[1];i.Log.debug("OidcClient.createSigninRequest");var k=this._settings.client_id;n=n||this._settings.response_type,o=o||this._settings.scope,s=s||this._settings.redirect_uri,h=h||this._settings.prompt,l=l||this._settings.display,f=f||this._settings.max_age,d=d||this._settings.ui_locales,v=v||this._settings.acr_values,y=y||this._settings.resource,S=S||this._settings.response_mode,F=F||this._settings.extraQueryParams;var A=this._settings.authority;return a.SigninRequest.isCode(n)&&"code"!==n?Promise.reject(new Error("OpenID Connect hybrid flow is not supported")):this._metadataService.getAuthorizationEndpoint().then(function(t){i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint",t);var r=new a.SigninRequest({url:t,client_id:k,redirect_uri:s,response_type:n,scope:o,data:u||c,authority:A,prompt:h,display:l,max_age:f,ui_locales:d,id_token_hint:p,login_hint:g,acr_values:v,resource:y,request:m,request_uri:_,extraQueryParams:F,extraTokenParams:b,request_type:w,response_mode:S,client_secret:e._settings.client_secret,skipUserInfo:E}),P=r.state;return(x=x||e._stateStore).set(P.id,P.toStorageString()).then(function(){return r})})},t.prototype.readSigninResponseState=function t(e,r){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];i.Log.debug("OidcClient.readSigninResponseState");var o="query"===this._settings.response_mode||!this._settings.response_mode&&a.SigninRequest.isCode(this._settings.response_type)?"?":"#",s=new u.SigninResponse(e,o);return s.state?(r=r||this._stateStore,(n?r.remove.bind(r):r.get.bind(r))(s.state).then(function(t){if(!t)throw i.Log.error("OidcClient.readSigninResponseState: No matching state found in storage"),new Error("No matching state found in storage");return{state:l.SigninState.fromStorageString(t),response:s}})):(i.Log.error("OidcClient.readSigninResponseState: No state in response"),Promise.reject(new Error("No state in response")))},t.prototype.processSigninResponse=function t(e,r){var n=this;return i.Log.debug("OidcClient.processSigninResponse"),this.readSigninResponseState(e,r,!0).then(function(t){var e=t.state,r=t.response;return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"),n._validator.validateSigninResponse(e,r)})},t.prototype.createSignoutRequest=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.id_token_hint,o=r.data,s=r.state,a=r.post_logout_redirect_uri,u=r.extraQueryParams,h=r.request_type,l=arguments[1];return i.Log.debug("OidcClient.createSignoutRequest"),a=a||this._settings.post_logout_redirect_uri,u=u||this._settings.extraQueryParams,this._metadataService.getEndSessionEndpoint().then(function(t){if(!t)throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"),new Error("no end session endpoint");i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint",t);var r=new c.SignoutRequest({url:t,id_token_hint:n,post_logout_redirect_uri:a,data:o||s,extraQueryParams:u,request_type:h}),f=r.state;return f&&(i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"),(l=l||e._stateStore).set(f.id,f.toStorageString())),r})},t.prototype.readSignoutResponseState=function t(e,r){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];i.Log.debug("OidcClient.readSignoutResponseState");var o=new h.SignoutResponse(e);if(!o.state)return i.Log.debug("OidcClient.readSignoutResponseState: No state in response"),o.error?(i.Log.warn("OidcClient.readSignoutResponseState: Response was error: ",o.error),Promise.reject(new s.ErrorResponse(o))):Promise.resolve({undefined:void 0,response:o});var a=o.state;return r=r||this._stateStore,(n?r.remove.bind(r):r.get.bind(r))(a).then(function(t){if(!t)throw i.Log.error("OidcClient.readSignoutResponseState: No matching state found in storage"),new Error("No matching state found in storage");return{state:f.State.fromStorageString(t),response:o}})},t.prototype.processSignoutResponse=function t(e,r){var n=this;return i.Log.debug("OidcClient.processSignoutResponse"),this.readSignoutResponseState(e,r,!0).then(function(t){var e=t.state,r=t.response;return e?(i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"),n._validator.validateSignoutResponse(e,r)):(i.Log.debug("OidcClient.processSignoutResponse: No state from storage; skipping validating response"),r)})},t.prototype.clearStaleState=function t(e){return i.Log.debug("OidcClient.clearStaleState"),e=e||this._stateStore,f.State.clearStaleState(e,this.settings.staleStateAge)},n(t,[{key:"_stateStore",get:function t(){return this.settings.stateStore}},{key:"_validator",get:function t(){return this.settings.validator}},{key:"_metadataService",get:function t(){return this.settings.metadataService}},{key:"settings",get:function t(){return this._settings}},{key:"metadataService",get:function t(){return this._metadataService}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.TokenClient=void 0;var n=r(7),i=r(2),o=r(0);e.TokenClient=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n.JsonService,s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService;if(function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw o.Log.error("TokenClient.ctor: No settings passed"),new Error("settings");this._settings=e,this._jsonService=new r,this._metadataService=new s(this._settings)}return t.prototype.exchangeCode=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return(r=Object.assign({},r)).grant_type=r.grant_type||"authorization_code",r.client_id=r.client_id||this._settings.client_id,r.redirect_uri=r.redirect_uri||this._settings.redirect_uri,r.code?r.redirect_uri?r.code_verifier?r.client_id?this._metadataService.getTokenEndpoint(!1).then(function(t){return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"),e._jsonService.postForm(t,r).then(function(t){return o.Log.debug("TokenClient.exchangeCode: response received"),t})}):(o.Log.error("TokenClient.exchangeCode: No client_id passed"),Promise.reject(new Error("A client_id is required"))):(o.Log.error("TokenClient.exchangeCode: No code_verifier passed"),Promise.reject(new Error("A code_verifier is required"))):(o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"),Promise.reject(new Error("A redirect_uri is required"))):(o.Log.error("TokenClient.exchangeCode: No code passed"),Promise.reject(new Error("A code is required")))},t.prototype.exchangeRefreshToken=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return(r=Object.assign({},r)).grant_type=r.grant_type||"refresh_token",r.client_id=r.client_id||this._settings.client_id,r.client_secret=r.client_secret||this._settings.client_secret,r.refresh_token?r.client_id?this._metadataService.getTokenEndpoint(!1).then(function(t){return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"),e._jsonService.postForm(t,r).then(function(t){return o.Log.debug("TokenClient.exchangeRefreshToken: response received"),t})}):(o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"),Promise.reject(new Error("A client_id is required"))):(o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"),Promise.reject(new Error("A refresh_token is required")))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.ErrorResponse=void 0;var n=r(0);e.ErrorResponse=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},i=r.error,o=r.error_description,s=r.error_uri,a=r.state;if(function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),!i)throw n.Log.error("No error passed to ErrorResponse"),new Error("error");var c=function h(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,o||i));return c.name="ErrorResponse",c.error=i,c.error_description=o,c.error_uri=s,c.state=a,c}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(Error)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SigninRequest=void 0;var n=r(0),i=r(3),o=r(13);e.SigninRequest=function(){function t(e){var r=e.url,s=e.client_id,a=e.redirect_uri,u=e.response_type,c=e.scope,h=e.authority,l=e.data,f=e.prompt,d=e.display,p=e.max_age,g=e.ui_locales,v=e.id_token_hint,y=e.login_hint,m=e.acr_values,_=e.resource,S=e.response_mode,F=e.request,b=e.request_uri,w=e.extraQueryParams,E=e.request_type,x=e.client_secret,k=e.extraTokenParams,A=e.skipUserInfo;if(function P(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!r)throw n.Log.error("SigninRequest.ctor: No url passed"),new Error("url");if(!s)throw n.Log.error("SigninRequest.ctor: No client_id passed"),new Error("client_id");if(!a)throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"),new Error("redirect_uri");if(!u)throw n.Log.error("SigninRequest.ctor: No response_type passed"),new Error("response_type");if(!c)throw n.Log.error("SigninRequest.ctor: No scope passed"),new Error("scope");if(!h)throw n.Log.error("SigninRequest.ctor: No authority passed"),new Error("authority");var C=t.isOidc(u),T=t.isCode(u);S||(S=t.isCode(u)?"query":null),this.state=new o.SigninState({nonce:C,data:l,client_id:s,authority:h,redirect_uri:a,code_verifier:T,request_type:E,response_mode:S,client_secret:x,scope:c,extraTokenParams:k,skipUserInfo:A}),r=i.UrlUtility.addQueryParam(r,"client_id",s),r=i.UrlUtility.addQueryParam(r,"redirect_uri",a),r=i.UrlUtility.addQueryParam(r,"response_type",u),r=i.UrlUtility.addQueryParam(r,"scope",c),r=i.UrlUtility.addQueryParam(r,"state",this.state.id),C&&(r=i.UrlUtility.addQueryParam(r,"nonce",this.state.nonce)),T&&(r=i.UrlUtility.addQueryParam(r,"code_challenge",this.state.code_challenge),r=i.UrlUtility.addQueryParam(r,"code_challenge_method","S256"));var R={prompt:f,display:d,max_age:p,ui_locales:g,id_token_hint:v,login_hint:y,acr_values:m,resource:_,request:F,request_uri:b,response_mode:S};for(var I in R)R[I]&&(r=i.UrlUtility.addQueryParam(r,I,R[I]));for(var D in w)r=i.UrlUtility.addQueryParam(r,D,w[D]);this.url=r}return t.isOidc=function t(e){return!!e.split(/\s+/g).filter(function(t){return"id_token"===t})[0]},t.isOAuth=function t(e){return!!e.split(/\s+/g).filter(function(t){return"token"===t})[0]},t.isCode=function t(e){return!!e.split(/\s+/g).filter(function(t){return"code"===t})[0]},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SigninState=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(8),s=r(4),a=function u(t){return t&&t.__esModule?t:{default:t}}(r(14));e.SigninState=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.nonce,i=r.authority,o=r.client_id,u=r.redirect_uri,c=r.code_verifier,h=r.response_mode,l=r.client_secret,f=r.scope,d=r.extraTokenParams,p=r.skipUserInfo;!function g(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var v=function y(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,arguments[0]));if(!0===n?v._nonce=(0,a.default)():n&&(v._nonce=n),!0===c?v._code_verifier=(0,a.default)()+(0,a.default)()+(0,a.default)():c&&(v._code_verifier=c),v.code_verifier){var m=s.JoseUtil.hashString(v.code_verifier,"SHA256");v._code_challenge=s.JoseUtil.hexToBase64Url(m)}return v._redirect_uri=u,v._authority=i,v._client_id=o,v._response_mode=h,v._client_secret=l,v._scope=f,v._extraTokenParams=d,v._skipUserInfo=p,v}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.toStorageString=function t(){return i.Log.debug("SigninState.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,request_type:this.request_type,nonce:this.nonce,code_verifier:this.code_verifier,redirect_uri:this.redirect_uri,authority:this.authority,client_id:this.client_id,response_mode:this.response_mode,client_secret:this.client_secret,scope:this.scope,extraTokenParams:this.extraTokenParams,skipUserInfo:this.skipUserInfo})},e.fromStorageString=function t(r){return i.Log.debug("SigninState.fromStorageString"),new e(JSON.parse(r))},n(e,[{key:"nonce",get:function t(){return this._nonce}},{key:"authority",get:function t(){return this._authority}},{key:"client_id",get:function t(){return this._client_id}},{key:"redirect_uri",get:function t(){return this._redirect_uri}},{key:"code_verifier",get:function t(){return this._code_verifier}},{key:"code_challenge",get:function t(){return this._code_challenge}},{key:"response_mode",get:function t(){return this._response_mode}},{key:"client_secret",get:function t(){return this._client_secret}},{key:"scope",get:function t(){return this._scope}},{key:"extraTokenParams",get:function t(){return this._extraTokenParams}},{key:"skipUserInfo",get:function t(){return this._skipUserInfo}}]),e}(o.State)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function n(){return(0,i.default)().replace(/-/g,"")};var i=function o(t){return t&&t.__esModule?t:{default:t}}(r(33));t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.User=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.User=function(){function t(e){var r=e.id_token,n=e.session_state,i=e.access_token,o=e.refresh_token,s=e.token_type,a=e.scope,u=e.profile,c=e.expires_at,h=e.state;!function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.id_token=r,this.session_state=n,this.access_token=i,this.refresh_token=o,this.token_type=s,this.scope=a,this.profile=u,this.expires_at=c,this.state=h}return t.prototype.toStorageString=function t(){return i.Log.debug("User.toStorageString"),JSON.stringify({id_token:this.id_token,session_state:this.session_state,access_token:this.access_token,refresh_token:this.refresh_token,token_type:this.token_type,scope:this.scope,profile:this.profile,expires_at:this.expires_at})},t.fromStorageString=function e(r){return i.Log.debug("User.fromStorageString"),new t(JSON.parse(r))},n(t,[{key:"expires_in",get:function t(){if(this.expires_at){var e=parseInt(Date.now()/1e3);return this.expires_at-e}},set:function t(e){var r=parseInt(e);if("number"==typeof r&&r>0){var n=parseInt(Date.now()/1e3);this.expires_at=n+r}}},{key:"expired",get:function t(){var e=this.expires_in;if(void 0!==e)return e<=0}},{key:"scopes",get:function t(){return(this.scope||"").split(" ")}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AccessTokenEvents=void 0;var n=r(0),i=r(48);var o=60;e.AccessTokenEvents=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.accessTokenExpiringNotificationTime,n=void 0===r?o:r,s=e.accessTokenExpiringTimer,a=void 0===s?new i.Timer("Access token expiring"):s,u=e.accessTokenExpiredTimer,c=void 0===u?new i.Timer("Access token expired"):u;!function h(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._accessTokenExpiringNotificationTime=n,this._accessTokenExpiring=a,this._accessTokenExpired=c}return t.prototype.load=function t(e){if(e.access_token&&void 0!==e.expires_in){var r=e.expires_in;if(n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:",r),r>0){var i=r-this._accessTokenExpiringNotificationTime;i<=0&&(i=1),n.Log.debug("AccessTokenEvents.load: registering expiring timer in:",i),this._accessTokenExpiring.init(i)}else n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."),this._accessTokenExpiring.cancel();var o=r+1;n.Log.debug("AccessTokenEvents.load: registering expired timer in:",o),this._accessTokenExpired.init(o)}else this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},t.prototype.unload=function t(){n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"),this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},t.prototype.addAccessTokenExpiring=function t(e){this._accessTokenExpiring.addHandler(e)},t.prototype.removeAccessTokenExpiring=function t(e){this._accessTokenExpiring.removeHandler(e)},t.prototype.addAccessTokenExpired=function t(e){this._accessTokenExpired.addHandler(e)},t.prototype.removeAccessTokenExpired=function t(e){this._accessTokenExpired.removeHandler(e)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Event=void 0;var n=r(0);e.Event=function(){function t(e){!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._name=e,this._callbacks=[]}return t.prototype.addHandler=function t(e){this._callbacks.push(e)},t.prototype.removeHandler=function t(e){var r=this._callbacks.findIndex(function(t){return t===e});r>=0&&this._callbacks.splice(r,1)},t.prototype.raise=function t(){n.Log.debug("Event: Raising event: "+this._name);for(var e=0;e<this._callbacks.length;e++){var r;(r=this._callbacks)[e].apply(r,arguments)}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SessionMonitor=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(19);e.SessionMonitor=function(){function t(e){var r=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.CheckSessionIFrame;if(function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"),new Error("userManager");this._userManager=e,this._CheckSessionIFrameCtor=n,this._userManager.events.addUserLoaded(this._start.bind(this)),this._userManager.events.addUserUnloaded(this._stop.bind(this)),this._userManager.getUser().then(function(t){t&&r._start(t)}).catch(function(t){i.Log.error("SessionMonitor ctor: error from getUser:",t.message)})}return t.prototype._start=function t(e){var r=this,n=e.session_state;n&&(this._sub=e.profile.sub,this._sid=e.profile.sid,i.Log.debug("SessionMonitor._start: session_state:",n,", sub:",this._sub),this._checkSessionIFrame?this._checkSessionIFrame.start(n):this._metadataService.getCheckSessionIframe().then(function(t){if(t){i.Log.debug("SessionMonitor._start: Initializing check session iframe");var e=r._client_id,o=r._checkSessionInterval,s=r._stopCheckSessionOnError;r._checkSessionIFrame=new r._CheckSessionIFrameCtor(r._callback.bind(r),e,t,o,s),r._checkSessionIFrame.load().then(function(){r._checkSessionIFrame.start(n)})}else i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata")}).catch(function(t){i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:",t.message)}))},t.prototype._stop=function t(){this._sub=null,this._sid=null,this._checkSessionIFrame&&(i.Log.debug("SessionMonitor._stop"),this._checkSessionIFrame.stop())},t.prototype._callback=function t(){var e=this;this._userManager.querySessionStatus().then(function(t){var r=!0;t?t.sub===e._sub?(r=!1,e._checkSessionIFrame.start(t.session_state),t.sid===e._sid?i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:",t.session_state):(i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:",t.session_state),e._userManager.events._raiseUserSessionChanged())):i.Log.debug("SessionMonitor._callback: Different subject signed into OP:",t.sub):i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"),r&&(i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"),e._userManager.events._raiseUserSignedOut())}).catch(function(t){i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event",t.message),e._userManager.events._raiseUserSignedOut()})},n(t,[{key:"_settings",get:function t(){return this._userManager.settings}},{key:"_metadataService",get:function t(){return this._userManager.metadataService}},{key:"_client_id",get:function t(){return this._settings.client_id}},{key:"_checkSessionInterval",get:function t(){return this._settings.checkSessionInterval}},{key:"_stopCheckSessionOnError",get:function t(){return this._settings.stopCheckSessionOnError}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CheckSessionIFrame=void 0;var n=r(0);var i=2e3;e.CheckSessionIFrame=function(){function t(e,r,n,o){var s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4];!function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._callback=e,this._client_id=r,this._url=n,this._interval=o||i,this._stopOnError=s;var u=n.indexOf("/",n.indexOf("//")+2);this._frame_origin=n.substr(0,u),this._frame=window.document.createElement("iframe"),this._frame.style.visibility="hidden",this._frame.style.position="absolute",this._frame.style.display="none",this._frame.style.width=0,this._frame.style.height=0,this._frame.src=n}return t.prototype.load=function t(){var e=this;return new Promise(function(t){e._frame.onload=function(){t()},window.document.body.appendChild(e._frame),e._boundMessageEvent=e._message.bind(e),window.addEventListener("message",e._boundMessageEvent,!1)})},t.prototype._message=function t(e){e.origin===this._frame_origin&&e.source===this._frame.contentWindow&&("error"===e.data?(n.Log.error("CheckSessionIFrame: error message from check session op iframe"),this._stopOnError&&this.stop()):"changed"===e.data?(n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"),this.stop(),this._callback()):n.Log.debug("CheckSessionIFrame: "+e.data+" message from check session op iframe"))},t.prototype.start=function t(e){var r=this;if(this._session_state!==e){n.Log.debug("CheckSessionIFrame.start"),this.stop(),this._session_state=e;var i=function t(){r._frame.contentWindow.postMessage(r._client_id+" "+r._session_state,r._frame_origin)};i(),this._timer=window.setInterval(i,this._interval)}},t.prototype.stop=function t(){this._session_state=null,this._timer&&(n.Log.debug("CheckSessionIFrame.stop"),window.clearInterval(this._timer),this._timer=null)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.TokenRevocationClient=void 0;var n=r(0),i=r(2),o=r(1);e.TokenRevocationClient=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.Global.XMLHttpRequest,s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService;if(function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw n.Log.error("TokenRevocationClient.ctor: No settings provided"),new Error("No settings provided.");this._settings=e,this._XMLHttpRequestCtor=r,this._metadataService=new s(this._settings)}return t.prototype.revoke=function t(e,r){var i=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"access_token";if(!e)throw n.Log.error("TokenRevocationClient.revoke: No token provided"),new Error("No token provided.");if("access_token"!==o&&"refresh_token"!=o)throw n.Log.error("TokenRevocationClient.revoke: Invalid token type"),new Error("Invalid token type.");return this._metadataService.getRevocationEndpoint().then(function(t){if(t){n.Log.debug("TokenRevocationClient.revoke: Revoking "+o);var s=i._settings.client_id,a=i._settings.client_secret;return i._revoke(t,s,a,e,o)}if(r)throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"),new Error("Revocation not supported")})},t.prototype._revoke=function t(e,r,i,o,s){var a=this;return new Promise(function(t,u){var c=new a._XMLHttpRequestCtor;c.open("POST",e),c.onload=function(){n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status",c.status),200===c.status?t():u(Error(c.statusText+" ("+c.status+")"))},c.onerror=function(){n.Log.debug("TokenRevocationClient.revoke: Network Error."),u("Network Error")};var h="client_id="+encodeURIComponent(r);i&&(h+="&client_secret="+encodeURIComponent(i)),h+="&token_type_hint="+encodeURIComponent(s),h+="&token="+encodeURIComponent(o),c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),c.send(h)})},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CordovaPopupWindow=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);var o="location=no,toolbar=no,zoom=no",s="_blank";e.CordovaPopupWindow=function(){function t(e){var r=this;!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._promise=new Promise(function(t,e){r._resolve=t,r._reject=e}),this.features=e.popupWindowFeatures||o,this.target=e.popupWindowTarget||s,this.redirect_uri=e.startUrl,i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: "+this.redirect_uri)}return t.prototype._isInAppBrowserInstalled=function t(e){return["cordova-plugin-inappbrowser","cordova-plugin-inappbrowser.inappbrowser","org.apache.cordova.inappbrowser"].some(function(t){return e.hasOwnProperty(t)})},t.prototype.navigate=function t(e){if(e&&e.url){if(!window.cordova)return this._error("cordova is undefined");var r=window.cordova.require("cordova/plugin_list").metadata;if(!1===this._isInAppBrowserInstalled(r))return this._error("InAppBrowser plugin not found");this._popup=cordova.InAppBrowser.open(e.url,this.target,this.features),this._popup?(i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"),this._exitCallbackEvent=this._exitCallback.bind(this),this._loadStartCallbackEvent=this._loadStartCallback.bind(this),this._popup.addEventListener("exit",this._exitCallbackEvent,!1),this._popup.addEventListener("loadstart",this._loadStartCallbackEvent,!1)):this._error("Error opening popup window")}else this._error("No url provided");return this.promise},t.prototype._loadStartCallback=function t(e){0===e.url.indexOf(this.redirect_uri)&&this._success({url:e.url})},t.prototype._exitCallback=function t(e){this._error(e)},t.prototype._success=function t(e){this._cleanup(),i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"),this._resolve(e)},t.prototype._error=function t(e){this._cleanup(),i.Log.error(e),this._reject(new Error(e))},t.prototype.close=function t(){this._cleanup()},t.prototype._cleanup=function t(){this._popup&&(i.Log.debug("CordovaPopupWindow: cleaning up popup"),this._popup.removeEventListener("exit",this._exitCallbackEvent,!1),this._popup.removeEventListener("loadstart",this._loadStartCallbackEvent,!1),this._popup.close()),this._popup=null},n(t,[{key:"promise",get:function t(){return this._promise}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(0),i=r(9),o=r(5),s=r(6),a=r(39),u=r(40),c=r(16),h=r(2),l=r(50),f=r(51),d=r(19),p=r(20),g=r(18),v=r(1),y=r(15),m=r(52);e.default={Version:m.Version,Log:n.Log,OidcClient:i.OidcClient,OidcClientSettings:o.OidcClientSettings,WebStorageStateStore:s.WebStorageStateStore,InMemoryWebStorage:a.InMemoryWebStorage,UserManager:u.UserManager,AccessTokenEvents:c.AccessTokenEvents,MetadataService:h.MetadataService,CordovaPopupNavigator:l.CordovaPopupNavigator,CordovaIFrameNavigator:f.CordovaIFrameNavigator,CheckSessionIFrame:d.CheckSessionIFrame,TokenRevocationClient:p.TokenRevocationClient,SessionMonitor:g.SessionMonitor,Global:v.Global,User:y.User},t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.ResponseValidator=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=r(0),o=r(2),s=r(24),a=r(10),u=r(11),c=r(4);var h=["nonce","at_hash","iat","nbf","exp","aud","iss","c_hash"];e.ResponseValidator=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.MetadataService,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.UserInfoService,u=arguments.length>3&&void 0!==arguments[3]?arguments[3]:c.JoseUtil,h=arguments.length>4&&void 0!==arguments[4]?arguments[4]:a.TokenClient;if(function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"),new Error("settings");this._settings=e,this._metadataService=new r(this._settings),this._userInfoService=new n(this._settings),this._joseUtil=u,this._tokenClient=new h(this._settings)}return t.prototype.validateSigninResponse=function t(e,r){var n=this;return i.Log.debug("ResponseValidator.validateSigninResponse"),this._processSigninParams(e,r).then(function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"),n._validateTokens(e,t).then(function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"),n._processClaims(e,t).then(function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"),t})})})},t.prototype.validateSignoutResponse=function t(e,r){return e.id!==r.state?(i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"),Promise.reject(new Error("State does not match"))):(i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"),r.state=e.data,r.error?(i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error",r.error),Promise.reject(new u.ErrorResponse(r))):Promise.resolve(r))},t.prototype._processSigninParams=function t(e,r){if(e.id!==r.state)return i.Log.error("ResponseValidator._processSigninParams: State does not match"),Promise.reject(new Error("State does not match"));if(!e.client_id)return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"),Promise.reject(new Error("No client_id on state"));if(!e.authority)return i.Log.error("ResponseValidator._processSigninParams: No authority on state"),Promise.reject(new Error("No authority on state"));if(this._settings.authority){if(this._settings.authority&&this._settings.authority!==e.authority)return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"),Promise.reject(new Error("authority mismatch on settings vs. signin state"))}else this._settings.authority=e.authority;if(this._settings.client_id){if(this._settings.client_id&&this._settings.client_id!==e.client_id)return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"),Promise.reject(new Error("client_id mismatch on settings vs. signin state"))}else this._settings.client_id=e.client_id;return i.Log.debug("ResponseValidator._processSigninParams: state validated"),r.state=e.data,r.error?(i.Log.warn("ResponseValidator._processSigninParams: Response was error",r.error),Promise.reject(new u.ErrorResponse(r))):e.nonce&&!r.id_token?(i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"),Promise.reject(new Error("No id_token in response"))):!e.nonce&&r.id_token?(i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"),Promise.reject(new Error("Unexpected id_token in response"))):e.code_verifier&&!r.code?(i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"),Promise.reject(new Error("No code in response"))):!e.code_verifier&&r.code?(i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"),Promise.reject(new Error("Unexpected code in response"))):(r.scope||(r.scope=e.scope),Promise.resolve(r))},t.prototype._processClaims=function t(e,r){var n=this;if(r.isOpenIdConnect){if(i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"),r.profile=this._filterProtocolClaims(r.profile),!0!==e.skipUserInfo&&this._settings.loadUserInfo&&r.access_token)return i.Log.debug("ResponseValidator._processClaims: loading user info"),this._userInfoService.getClaims(r.access_token).then(function(t){return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"),t.sub!==r.profile.sub?(i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in access_token"),Promise.reject(new Error("sub from user info endpoint does not match sub in access_token"))):(r.profile=n._mergeClaims(r.profile,t),i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:",r.profile),r)});i.Log.debug("ResponseValidator._processClaims: not loading user info")}else i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");return Promise.resolve(r)},t.prototype._mergeClaims=function t(e,r){var i=Object.assign({},e);for(var o in r){var s=r[o];Array.isArray(s)||(s=[s]);for(var a=0;a<s.length;a++){var u=s[a];i[o]?Array.isArray(i[o])?i[o].indexOf(u)<0&&i[o].push(u):i[o]!==u&&("object"===(void 0===u?"undefined":n(u))?i[o]=this._mergeClaims(i[o],u):i[o]=[i[o],u]):i[o]=u}}return i},t.prototype._filterProtocolClaims=function t(e){i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:",e);var r=Object.assign({},e);return this._settings._filterProtocolClaims?(h.forEach(function(t){delete r[t]}),i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered",r)):i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"),r},t.prototype._validateTokens=function t(e,r){return r.code?(i.Log.debug("ResponseValidator._validateTokens: Validating code"),this._processCode(e,r)):r.id_token?r.access_token?(i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"),this._validateIdTokenAndAccessToken(e,r)):(i.Log.debug("ResponseValidator._validateTokens: Validating id_token"),this._validateIdToken(e,r)):(i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"),Promise.resolve(r))},t.prototype._processCode=function t(e,r){var o=this,s={client_id:e.client_id,client_secret:e.client_secret,code:r.code,redirect_uri:e.redirect_uri,code_verifier:e.code_verifier};return e.extraTokenParams&&"object"===n(e.extraTokenParams)&&Object.assign(s,e.extraTokenParams),this._tokenClient.exchangeCode(s).then(function(t){for(var n in t)r[n]=t[n];return r.id_token?(i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"),o._validateIdTokenAttributes(e,r)):(i.Log.debug("ResponseValidator._processCode: token response successful, returning response"),r)})},t.prototype._validateIdTokenAttributes=function t(e,r){var n=this;return this._metadataService.getIssuer().then(function(t){var o=e.client_id,s=n._settings.clockSkew;return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ",s),n._joseUtil.validateJwtAttributes(r.id_token,t,o,s).then(function(t){return e.nonce&&e.nonce!==t.nonce?(i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"))):t.sub?(r.profile=t,r):(i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"),Promise.reject(new Error("No sub present in id_token")))})})},t.prototype._validateIdTokenAndAccessToken=function t(e,r){var n=this;return this._validateIdToken(e,r).then(function(t){return n._validateAccessToken(t)})},t.prototype._validateIdToken=function t(e,r){var n=this;if(!e.nonce)return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"),Promise.reject(new Error("No nonce on state"));var o=this._joseUtil.parseJwt(r.id_token);if(!o||!o.header||!o.payload)return i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token",o),Promise.reject(new Error("Failed to parse id_token"));if(e.nonce!==o.payload.nonce)return i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"));var s=o.header.kid;return this._metadataService.getIssuer().then(function(t){return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"),n._metadataService.getSigningKeys().then(function(a){if(!a)return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));i.Log.debug("ResponseValidator._validateIdToken: Received signing keys");var u=void 0;if(s)u=a.filter(function(t){return t.kid===s})[0];else{if((a=n._filterByAlg(a,o.header.alg)).length>1)return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"),Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));u=a[0]}if(!u)return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"),Promise.reject(new Error("No key matching kid or alg found in signing keys"));var c=e.client_id,h=n._settings.clockSkew;return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ",h),n._joseUtil.validateJwt(r.id_token,u,t,c,h).then(function(){return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"),o.payload.sub?(r.profile=o.payload,r):(i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"),Promise.reject(new Error("No sub present in id_token")))})})})},t.prototype._filterByAlg=function t(e,r){var n=null;if(r.startsWith("RS"))n="RSA";else if(r.startsWith("PS"))n="PS";else{if(!r.startsWith("ES"))return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ",r),[];n="EC"}return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ",n),e=e.filter(function(t){return t.kty===n}),i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ",n,e.length),e},t.prototype._validateAccessToken=function t(e){if(!e.profile)return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"),Promise.reject(new Error("No profile loaded from id_token"));if(!e.profile.at_hash)return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"),Promise.reject(new Error("No at_hash in id_token"));if(!e.id_token)return i.Log.error("ResponseValidator._validateAccessToken: No id_token"),Promise.reject(new Error("No id_token"));var r=this._joseUtil.parseJwt(e.id_token);if(!r||!r.header)return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token",r),Promise.reject(new Error("Failed to parse id_token"));var n=r.header.alg;if(!n||5!==n.length)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",n),Promise.reject(new Error("Unsupported alg: "+n));var o=n.substr(2,3);if(!o)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",n,o),Promise.reject(new Error("Unsupported alg: "+n));if(256!==(o=parseInt(o))&&384!==o&&512!==o)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",n,o),Promise.reject(new Error("Unsupported alg: "+n));var s="sha"+o,a=this._joseUtil.hashString(e.access_token,s);if(!a)return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:",s),Promise.reject(new Error("Failed to validate at_hash"));var u=a.substr(0,a.length/2),c=this._joseUtil.hexToBase64Url(u);return c!==e.profile.at_hash?(i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash",c,e.profile.at_hash),Promise.reject(new Error("Failed to validate at_hash"))):(i.Log.debug("ResponseValidator._validateAccessToken: success"),Promise.resolve(e))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserInfoService=void 0;var n=r(7),i=r(2),o=r(0),s=r(4);e.UserInfoService=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n.JsonService,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService,u=arguments.length>3&&void 0!==arguments[3]?arguments[3]:s.JoseUtil;if(function c(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!e)throw o.Log.error("UserInfoService.ctor: No settings passed"),new Error("settings");this._settings=e,this._jsonService=new r(void 0,void 0,this._getClaimsFromJwt.bind(this)),this._metadataService=new a(this._settings),this._joseUtil=u}return t.prototype.getClaims=function t(e){var r=this;return e?this._metadataService.getUserInfoEndpoint().then(function(t){return o.Log.debug("UserInfoService.getClaims: received userinfo url",t),r._jsonService.getJson(t,e).then(function(t){return o.Log.debug("UserInfoService.getClaims: claims received",t),t})}):(o.Log.error("UserInfoService.getClaims: No token passed"),Promise.reject(new Error("A token is required")))},t.prototype._getClaimsFromJwt=function t(e){var r=this;try{var n=this._joseUtil.parseJwt(e.responseText);if(!n||!n.header||!n.payload)return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT",n),Promise.reject(new Error("Failed to parse id_token"));var i=n.header.kid,s=void 0;switch(this._settings.userInfoJwtIssuer){case"OP":s=this._metadataService.getIssuer();break;case"ANY":s=Promise.resolve(n.payload.iss);break;default:s=Promise.resolve(this._settings.userInfoJwtIssuer)}return s.then(function(t){return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:"+t),r._metadataService.getSigningKeys().then(function(s){if(!s)return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys");var a=void 0;if(i)a=s.filter(function(t){return t.kid===i})[0];else{if((s=r._filterByAlg(s,n.header.alg)).length>1)return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"),Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));a=s[0]}if(!a)return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"),Promise.reject(new Error("No key matching kid or alg found in signing keys"));var u=r._settings.client_id,c=r._settings.clockSkew;return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ",c),r._joseUtil.validateJwt(e.responseText,a,t,u,c,void 0,!0).then(function(){return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"),n.payload})})})}catch(t){return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response",t.message),void reject(t)}},t.prototype._filterByAlg=function t(e,r){var n=null;if(r.startsWith("RS"))n="RSA";else if(r.startsWith("PS"))n="PS";else{if(!r.startsWith("ES"))return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ",r),[];n="EC"}return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ",n),e=e.filter(function(t){return t.kty===n}),o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ",n,e.length),e},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AllowedSigningAlgs=e.b64tohex=e.hextob64u=e.crypto=e.X509=e.KeyUtil=e.jws=void 0;var n=r(26);e.jws=n.jws,e.KeyUtil=n.KEYUTIL,e.X509=n.X509,e.crypto=n.crypto,e.hextob64u=n.hextob64u,e.b64tohex=n.b64tohex,e.AllowedSigningAlgs=["RS256","RS384","RS512","PS256","PS384","PS512","ES256","ES384","ES512"]},function(t,e,r){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n={userAgent:!1},i={};
/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
if(void 0===o)var o={};o.lang={extend:function t(e,r,i){if(!r||!e)throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");var o=function t(){};if(o.prototype=r.prototype,e.prototype=new o,e.prototype.constructor=e,e.superclass=r.prototype,r.prototype.constructor==Object.prototype.constructor&&(r.prototype.constructor=r),i){var s;for(s in i)e.prototype[s]=i[s];var a=function t(){},u=["toString","valueOf"];try{/MSIE/.test(n.userAgent)&&(a=function t(e,r){for(s=0;s<u.length;s+=1){var n=u[s],i=r[n];"function"==typeof i&&i!=Object.prototype[n]&&(e[n]=i)}})}catch(t){}a(e.prototype,i)}}};
/*! CryptoJS v3.1.2 core-fix.js
 * code.google.com/p/crypto-js
 * (c) 2009-2013 by Jeff Mott. All rights reserved.
 * code.google.com/p/crypto-js/wiki/License
 * THIS IS FIX of 'core.js' to fix Hmac issue.
 * https://code.google.com/p/crypto-js/issues/detail?id=84
 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
 */
var s,a,u,c,h,l,f,d,p,g,v,y=y||(s=Math,u=(a={}).lib={},c=u.Base=function(){function t(){}return{extend:function e(r){t.prototype=this;var n=new t;return r&&n.mixIn(r),n.hasOwnProperty("init")||(n.init=function(){n.$super.init.apply(this,arguments)}),n.init.prototype=n,n.$super=this,n},create:function t(){var e=this.extend();return e.init.apply(e,arguments),e},init:function t(){},mixIn:function t(e){for(var r in e)e.hasOwnProperty(r)&&(this[r]=e[r]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function t(){return this.init.prototype.extend(this)}}}(),h=u.WordArray=c.extend({init:function t(e,r){e=this.words=e||[],this.sigBytes=void 0!=r?r:4*e.length},toString:function t(e){return(e||f).stringify(this)},concat:function t(e){var r=this.words,n=e.words,i=this.sigBytes,o=e.sigBytes;if(this.clamp(),i%4)for(var s=0;s<o;s++){var a=n[s>>>2]>>>24-s%4*8&255;r[i+s>>>2]|=a<<24-(i+s)%4*8}else for(s=0;s<o;s+=4)r[i+s>>>2]=n[s>>>2];return this.sigBytes+=o,this},clamp:function t(){var e=this.words,r=this.sigBytes;e[r>>>2]&=4294967295<<32-r%4*8,e.length=s.ceil(r/4)},clone:function t(){var e=c.clone.call(this);return e.words=this.words.slice(0),e},random:function t(e){for(var r=[],n=0;n<e;n+=4)r.push(4294967296*s.random()|0);return new h.init(r,e)}}),l=a.enc={},f=l.Hex={stringify:function t(e){for(var r=e.words,n=e.sigBytes,i=[],o=0;o<n;o++){var s=r[o>>>2]>>>24-o%4*8&255;i.push((s>>>4).toString(16)),i.push((15&s).toString(16))}return i.join("")},parse:function t(e){for(var r=e.length,n=[],i=0;i<r;i+=2)n[i>>>3]|=parseInt(e.substr(i,2),16)<<24-i%8*4;return new h.init(n,r/2)}},d=l.Latin1={stringify:function t(e){for(var r=e.words,n=e.sigBytes,i=[],o=0;o<n;o++){var s=r[o>>>2]>>>24-o%4*8&255;i.push(String.fromCharCode(s))}return i.join("")},parse:function t(e){for(var r=e.length,n=[],i=0;i<r;i++)n[i>>>2]|=(255&e.charCodeAt(i))<<24-i%4*8;return new h.init(n,r)}},p=l.Utf8={stringify:function t(e){try{return decodeURIComponent(escape(d.stringify(e)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function t(e){return d.parse(unescape(encodeURIComponent(e)))}},g=u.BufferedBlockAlgorithm=c.extend({reset:function t(){this._data=new h.init,this._nDataBytes=0},_append:function t(e){"string"==typeof e&&(e=p.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function t(e){var r=this._data,n=r.words,i=r.sigBytes,o=this.blockSize,a=i/(4*o),u=(a=e?s.ceil(a):s.max((0|a)-this._minBufferSize,0))*o,c=s.min(4*u,i);if(u){for(var l=0;l<u;l+=o)this._doProcessBlock(n,l);var f=n.splice(0,u);r.sigBytes-=c}return new h.init(f,c)},clone:function t(){var e=c.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0}),u.Hasher=g.extend({cfg:c.extend(),init:function t(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function t(){g.reset.call(this),this._doReset()},update:function t(e){return this._append(e),this._process(),this},finalize:function t(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function t(e){return function(t,r){return new e.init(r).finalize(t)}},_createHmacHelper:function t(e){return function(t,r){return new v.HMAC.init(e,r).finalize(t)}}}),v=a.algo={},a);!function(t){var e,r=(e=y).lib,n=r.Base,i=r.WordArray;(e=e.x64={}).Word=n.extend({init:function t(e,r){this.high=e,this.low=r}}),e.WordArray=n.extend({init:function t(e,r){e=this.words=e||[],this.sigBytes=void 0!=r?r:8*e.length},toX32:function t(){for(var e=this.words,r=e.length,n=[],o=0;o<r;o++){var s=e[o];n.push(s.high),n.push(s.low)}return i.create(n,this.sigBytes)},clone:function t(){for(var e=n.clone.call(this),r=e.words=this.words.slice(0),i=r.length,o=0;o<i;o++)r[o]=r[o].clone();return e}})}(),function(){var t=y,e=t.lib.WordArray;t.enc.Base64={stringify:function t(e){var r=e.words,n=e.sigBytes,i=this._map;e.clamp(),e=[];for(var o=0;o<n;o+=3)for(var s=(r[o>>>2]>>>24-o%4*8&255)<<16|(r[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|r[o+2>>>2]>>>24-(o+2)%4*8&255,a=0;4>a&&o+.75*a<n;a++)e.push(i.charAt(s>>>6*(3-a)&63));if(r=i.charAt(64))for(;e.length%4;)e.push(r);return e.join("")},parse:function t(r){var n=r.length,i=this._map;(o=i.charAt(64))&&(-1!=(o=r.indexOf(o))&&(n=o));for(var o=[],s=0,a=0;a<n;a++)if(a%4){var u=i.indexOf(r.charAt(a-1))<<a%4*2,c=i.indexOf(r.charAt(a))>>>6-a%4*2;o[s>>>2]|=(u|c)<<24-s%4*8,s++}return e.create(o,s)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}}(),function(t){for(var e=y,r=(i=e.lib).WordArray,n=i.Hasher,i=e.algo,o=[],s=[],a=function t(e){return 4294967296*(e-(0|e))|0},u=2,c=0;64>c;){var h;t:{h=u;for(var l=t.sqrt(h),f=2;f<=l;f++)if(!(h%f)){h=!1;break t}h=!0}h&&(8>c&&(o[c]=a(t.pow(u,.5))),s[c]=a(t.pow(u,1/3)),c++),u++}var d=[];i=i.SHA256=n.extend({_doReset:function t(){this._hash=new r.init(o.slice(0))},_doProcessBlock:function t(e,r){for(var n=this._hash.words,i=n[0],o=n[1],a=n[2],u=n[3],c=n[4],h=n[5],l=n[6],f=n[7],p=0;64>p;p++){if(16>p)d[p]=0|e[r+p];else{var g=d[p-15],v=d[p-2];d[p]=((g<<25|g>>>7)^(g<<14|g>>>18)^g>>>3)+d[p-7]+((v<<15|v>>>17)^(v<<13|v>>>19)^v>>>10)+d[p-16]}g=f+((c<<26|c>>>6)^(c<<21|c>>>11)^(c<<7|c>>>25))+(c&h^~c&l)+s[p]+d[p],v=((i<<30|i>>>2)^(i<<19|i>>>13)^(i<<10|i>>>22))+(i&o^i&a^o&a),f=l,l=h,h=c,c=u+g|0,u=a,a=o,o=i,i=g+v|0}n[0]=n[0]+i|0,n[1]=n[1]+o|0,n[2]=n[2]+a|0,n[3]=n[3]+u|0,n[4]=n[4]+c|0,n[5]=n[5]+h|0,n[6]=n[6]+l|0,n[7]=n[7]+f|0},_doFinalize:function e(){var r=this._data,n=r.words,i=8*this._nDataBytes,o=8*r.sigBytes;return n[o>>>5]|=128<<24-o%32,n[14+(o+64>>>9<<4)]=t.floor(i/4294967296),n[15+(o+64>>>9<<4)]=i,r.sigBytes=4*n.length,this._process(),this._hash},clone:function t(){var e=n.clone.call(this);return e._hash=this._hash.clone(),e}});e.SHA256=n._createHelper(i),e.HmacSHA256=n._createHmacHelper(i)}(Math),function(){function t(){return n.create.apply(n,arguments)}for(var e=y,r=e.lib.Hasher,n=(o=e.x64).Word,i=o.WordArray,o=e.algo,s=[t(1116352408,3609767458),t(1899447441,602891725),t(3049323471,3964484399),t(3921009573,2173295548),t(961987163,4081628472),t(1508970993,3053834265),t(2453635748,2937671579),t(2870763221,3664609560),t(3624381080,2734883394),t(310598401,1164996542),t(607225278,1323610764),t(1426881987,3590304994),t(1925078388,4068182383),t(2162078206,991336113),t(2614888103,633803317),t(3248222580,3479774868),t(3835390401,2666613458),t(4022224774,944711139),t(264347078,2341262773),t(604807628,2007800933),t(770255983,1495990901),t(1249150122,1856431235),t(1555081692,3175218132),t(1996064986,2198950837),t(2554220882,3999719339),t(2821834349,766784016),t(2952996808,2566594879),t(3210313671,3203337956),t(3336571891,1034457026),t(3584528711,2466948901),t(113926993,3758326383),t(338241895,168717936),t(666307205,1188179964),t(773529912,1546045734),t(1294757372,1522805485),t(1396182291,2643833823),t(1695183700,2343527390),t(1986661051,1014477480),t(2177026350,1206759142),t(2456956037,344077627),t(2730485921,1290863460),t(2820302411,3158454273),t(3259730800,3505952657),t(3345764771,106217008),t(3516065817,3606008344),t(3600352804,1432725776),t(4094571909,1467031594),t(275423344,851169720),t(430227734,3100823752),t(506948616,1363258195),t(659060556,3750685593),t(883997877,3785050280),t(958139571,3318307427),t(1322822218,3812723403),t(1537002063,2003034995),t(1747873779,3602036899),t(1955562222,1575990012),t(2024104815,1125592928),t(2227730452,2716904306),t(2361852424,442776044),t(2428436474,593698344),t(2756734187,3733110249),t(3204031479,2999351573),t(3329325298,3815920427),t(3391569614,3928383900),t(3515267271,566280711),t(3940187606,3454069534),t(4118630271,4000239992),t(116418474,1914138554),t(174292421,2731055270),t(289380356,3203993006),t(460393269,320620315),t(685471733,587496836),t(852142971,1086792851),t(1017036298,365543100),t(1126000580,2618297676),t(1288033470,3409855158),t(1501505948,4234509866),t(1607167915,987167468),t(1816402316,1246189591)],a=[],u=0;80>u;u++)a[u]=t();o=o.SHA512=r.extend({_doReset:function t(){this._hash=new i.init([new n.init(1779033703,4089235720),new n.init(3144134277,2227873595),new n.init(1013904242,4271175723),new n.init(2773480762,1595750129),new n.init(1359893119,2917565137),new n.init(2600822924,725511199),new n.init(528734635,4215389547),new n.init(1541459225,327033209)])},_doProcessBlock:function t(e,r){for(var n=(f=this._hash.words)[0],i=f[1],o=f[2],u=f[3],c=f[4],h=f[5],l=f[6],f=f[7],d=n.high,p=n.low,g=i.high,v=i.low,y=o.high,m=o.low,_=u.high,S=u.low,F=c.high,b=c.low,w=h.high,E=h.low,x=l.high,k=l.low,A=f.high,P=f.low,C=d,T=p,R=g,I=v,D=y,L=m,U=_,B=S,N=F,O=b,j=w,H=E,M=x,K=k,V=A,q=P,J=0;80>J;J++){var W=a[J];if(16>J)var z=W.high=0|e[r+2*J],Y=W.low=0|e[r+2*J+1];else{z=((Y=(z=a[J-15]).high)>>>1|(G=z.low)<<31)^(Y>>>8|G<<24)^Y>>>7;var G=(G>>>1|Y<<31)^(G>>>8|Y<<24)^(G>>>7|Y<<25),X=((Y=(X=a[J-2]).high)>>>19|(Q=X.low)<<13)^(Y<<3|Q>>>29)^Y>>>6,Q=(Q>>>19|Y<<13)^(Q<<3|Y>>>29)^(Q>>>6|Y<<26),$=(Y=a[J-7]).high,Z=(tt=a[J-16]).high,tt=tt.low;z=(z=(z=z+$+((Y=G+Y.low)>>>0<G>>>0?1:0))+X+((Y=Y+Q)>>>0<Q>>>0?1:0))+Z+((Y=Y+tt)>>>0<tt>>>0?1:0);W.high=z,W.low=Y}$=N&j^~N&M,tt=O&H^~O&K,W=C&R^C&D^R&D;var et=T&I^T&L^I&L,rt=(G=(C>>>28|T<<4)^(C<<30|T>>>2)^(C<<25|T>>>7),X=(T>>>28|C<<4)^(T<<30|C>>>2)^(T<<25|C>>>7),(Q=s[J]).high),nt=Q.low;Z=(Z=(Z=(Z=V+((N>>>14|O<<18)^(N>>>18|O<<14)^(N<<23|O>>>9))+((Q=q+((O>>>14|N<<18)^(O>>>18|N<<14)^(O<<23|N>>>9)))>>>0<q>>>0?1:0))+$+((Q=Q+tt)>>>0<tt>>>0?1:0))+rt+((Q=Q+nt)>>>0<nt>>>0?1:0))+z+((Q=Q+Y)>>>0<Y>>>0?1:0),W=G+W+((Y=X+et)>>>0<X>>>0?1:0),V=M,q=K,M=j,K=H,j=N,H=O,N=U+Z+((O=B+Q|0)>>>0<B>>>0?1:0)|0,U=D,B=L,D=R,L=I,R=C,I=T,C=Z+W+((T=Q+Y|0)>>>0<Q>>>0?1:0)|0}p=n.low=p+T,n.high=d+C+(p>>>0<T>>>0?1:0),v=i.low=v+I,i.high=g+R+(v>>>0<I>>>0?1:0),m=o.low=m+L,o.high=y+D+(m>>>0<L>>>0?1:0),S=u.low=S+B,u.high=_+U+(S>>>0<B>>>0?1:0),b=c.low=b+O,c.high=F+N+(b>>>0<O>>>0?1:0),E=h.low=E+H,h.high=w+j+(E>>>0<H>>>0?1:0),k=l.low=k+K,l.high=x+M+(k>>>0<K>>>0?1:0),P=f.low=P+q,f.high=A+V+(P>>>0<q>>>0?1:0)},_doFinalize:function t(){var e=this._data,r=e.words,n=8*this._nDataBytes,i=8*e.sigBytes;return r[i>>>5]|=128<<24-i%32,r[30+(i+128>>>10<<5)]=Math.floor(n/4294967296),r[31+(i+128>>>10<<5)]=n,e.sigBytes=4*r.length,this._process(),this._hash.toX32()},clone:function t(){var e=r.clone.call(this);return e._hash=this._hash.clone(),e},blockSize:32}),e.SHA512=r._createHelper(o),e.HmacSHA512=r._createHmacHelper(o)}(),function(){var t=y,e=(i=t.x64).Word,r=i.WordArray,n=(i=t.algo).SHA512,i=i.SHA384=n.extend({_doReset:function t(){this._hash=new r.init([new e.init(3418070365,3238371032),new e.init(1654270250,914150663),new e.init(2438529370,812702999),new e.init(355462360,4144912697),new e.init(1731405415,4290775857),new e.init(2394180231,1750603025),new e.init(3675008525,1694076839),new e.init(1203062813,3204075428)])},_doFinalize:function t(){var e=n._doFinalize.call(this);return e.sigBytes-=16,e}});t.SHA384=n._createHelper(i),t.HmacSHA384=n._createHmacHelper(i)}();
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
var m,_="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",S="=";function F(t){var e,r,n="";for(e=0;e+3<=t.length;e+=3)r=parseInt(t.substring(e,e+3),16),n+=_.charAt(r>>6)+_.charAt(63&r);if(e+1==t.length?(r=parseInt(t.substring(e,e+1),16),n+=_.charAt(r<<2)):e+2==t.length&&(r=parseInt(t.substring(e,e+2),16),n+=_.charAt(r>>2)+_.charAt((3&r)<<4)),S)for(;(3&n.length)>0;)n+=S;return n}function b(t){var e,r,n,i="",o=0;for(e=0;e<t.length&&t.charAt(e)!=S;++e)(n=_.indexOf(t.charAt(e)))<0||(0==o?(i+=D(n>>2),r=3&n,o=1):1==o?(i+=D(r<<2|n>>4),r=15&n,o=2):2==o?(i+=D(r),i+=D(n>>2),r=3&n,o=3):(i+=D(r<<2|n>>4),i+=D(15&n),o=0));return 1==o&&(i+=D(r<<2)),i}function w(t){var e,r=b(t),n=new Array;for(e=0;2*e<r.length;++e)n[e]=parseInt(r.substring(2*e,2*e+2),16);return n}function E(t,e,r){null!=t&&("number"==typeof t?this.fromNumber(t,e,r):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}function x(){return new E(null)}"Microsoft Internet Explorer"==n.appName?(E.prototype.am=function k(t,e,r,n,i,o){for(var s=32767&e,a=e>>15;--o>=0;){var u=32767&this[t],c=this[t++]>>15,h=a*u+c*s;i=((u=s*u+((32767&h)<<15)+r[n]+(1073741823&i))>>>30)+(h>>>15)+a*c+(i>>>30),r[n++]=1073741823&u}return i},m=30):"Netscape"!=n.appName?(E.prototype.am=function A(t,e,r,n,i,o){for(;--o>=0;){var s=e*this[t++]+r[n]+i;i=Math.floor(s/67108864),r[n++]=67108863&s}return i},m=26):(E.prototype.am=function P(t,e,r,n,i,o){for(var s=16383&e,a=e>>14;--o>=0;){var u=16383&this[t],c=this[t++]>>14,h=a*u+c*s;i=((u=s*u+((16383&h)<<14)+r[n]+i)>>28)+(h>>14)+a*c,r[n++]=268435455&u}return i},m=28),E.prototype.DB=m,E.prototype.DM=(1<<m)-1,E.prototype.DV=1<<m;E.prototype.FV=Math.pow(2,52),E.prototype.F1=52-m,E.prototype.F2=2*m-52;var C,T,R="0123456789abcdefghijklmnopqrstuvwxyz",I=new Array;for(C="0".charCodeAt(0),T=0;T<=9;++T)I[C++]=T;for(C="a".charCodeAt(0),T=10;T<36;++T)I[C++]=T;for(C="A".charCodeAt(0),T=10;T<36;++T)I[C++]=T;function D(t){return R.charAt(t)}function L(t,e){var r=I[t.charCodeAt(e)];return null==r?-1:r}function U(t){var e=x();return e.fromInt(t),e}function B(t){var e,r=1;return 0!=(e=t>>>16)&&(t=e,r+=16),0!=(e=t>>8)&&(t=e,r+=8),0!=(e=t>>4)&&(t=e,r+=4),0!=(e=t>>2)&&(t=e,r+=2),0!=(e=t>>1)&&(t=e,r+=1),r}function N(t){this.m=t}function O(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function j(t,e){return t&e}function H(t,e){return t|e}function M(t,e){return t^e}function K(t,e){return t&~e}function V(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function q(t){for(var e=0;0!=t;)t&=t-1,++e;return e}function J(){}function W(t){return t}function z(t){this.r2=x(),this.q3=x(),E.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t),this.m=t}N.prototype.convert=function Y(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t},N.prototype.revert=function G(t){return t},N.prototype.reduce=function X(t){t.divRemTo(this.m,null,t)},N.prototype.mulTo=function Q(t,e,r){t.multiplyTo(e,r),this.reduce(r)},N.prototype.sqrTo=function $(t,e){t.squareTo(e),this.reduce(e)},O.prototype.convert=function Z(t){var e=x();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(E.ZERO)>0&&this.m.subTo(e,e),e},O.prototype.revert=function tt(t){var e=x();return t.copyTo(e),this.reduce(e),e},O.prototype.reduce=function et(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var r=32767&t[e],n=r*this.mpl+((r*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(t[r=e+this.m.t]+=this.m.am(0,n,t,e,0,this.m.t);t[r]>=t.DV;)t[r]-=t.DV,t[++r]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)},O.prototype.mulTo=function rt(t,e,r){t.multiplyTo(e,r),this.reduce(r)},O.prototype.sqrTo=function nt(t,e){t.squareTo(e),this.reduce(e)},E.prototype.copyTo=function it(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s},E.prototype.fromInt=function ot(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0},E.prototype.fromString=function st(t,e){var r;if(16==e)r=4;else if(8==e)r=3;else if(256==e)r=8;else if(2==e)r=1;else if(32==e)r=5;else{if(4!=e)return void this.fromRadix(t,e);r=2}this.t=0,this.s=0;for(var n=t.length,i=!1,o=0;--n>=0;){var s=8==r?255&t[n]:L(t,n);s<0?"-"==t.charAt(n)&&(i=!0):(i=!1,0==o?this[this.t++]=s:o+r>this.DB?(this[this.t-1]|=(s&(1<<this.DB-o)-1)<<o,this[this.t++]=s>>this.DB-o):this[this.t-1]|=s<<o,(o+=r)>=this.DB&&(o-=this.DB))}8==r&&0!=(128&t[0])&&(this.s=-1,o>0&&(this[this.t-1]|=(1<<this.DB-o)-1<<o)),this.clamp(),i&&E.ZERO.subTo(this,this)},E.prototype.clamp=function at(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t},E.prototype.dlShiftTo=function ut(t,e){var r;for(r=this.t-1;r>=0;--r)e[r+t]=this[r];for(r=t-1;r>=0;--r)e[r]=0;e.t=this.t+t,e.s=this.s},E.prototype.drShiftTo=function ct(t,e){for(var r=t;r<this.t;++r)e[r-t]=this[r];e.t=Math.max(this.t-t,0),e.s=this.s},E.prototype.lShiftTo=function ht(t,e){var r,n=t%this.DB,i=this.DB-n,o=(1<<i)-1,s=Math.floor(t/this.DB),a=this.s<<n&this.DM;for(r=this.t-1;r>=0;--r)e[r+s+1]=this[r]>>i|a,a=(this[r]&o)<<n;for(r=s-1;r>=0;--r)e[r]=0;e[s]=a,e.t=this.t+s+1,e.s=this.s,e.clamp()},E.prototype.rShiftTo=function lt(t,e){e.s=this.s;var r=Math.floor(t/this.DB);if(r>=this.t)e.t=0;else{var n=t%this.DB,i=this.DB-n,o=(1<<n)-1;e[0]=this[r]>>n;for(var s=r+1;s<this.t;++s)e[s-r-1]|=(this[s]&o)<<i,e[s-r]=this[s]>>n;n>0&&(e[this.t-r-1]|=(this.s&o)<<i),e.t=this.t-r,e.clamp()}},E.prototype.subTo=function ft(t,e){for(var r=0,n=0,i=Math.min(t.t,this.t);r<i;)n+=this[r]-t[r],e[r++]=n&this.DM,n>>=this.DB;if(t.t<this.t){for(n-=t.s;r<this.t;)n+=this[r],e[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<t.t;)n-=t[r],e[r++]=n&this.DM,n>>=this.DB;n-=t.s}e.s=n<0?-1:0,n<-1?e[r++]=this.DV+n:n>0&&(e[r++]=n),e.t=r,e.clamp()},E.prototype.multiplyTo=function dt(t,e){var r=this.abs(),n=t.abs(),i=r.t;for(e.t=i+n.t;--i>=0;)e[i]=0;for(i=0;i<n.t;++i)e[i+r.t]=r.am(0,n[i],e,i,0,r.t);e.s=0,e.clamp(),this.s!=t.s&&E.ZERO.subTo(e,e)},E.prototype.squareTo=function pt(t){for(var e=this.abs(),r=t.t=2*e.t;--r>=0;)t[r]=0;for(r=0;r<e.t-1;++r){var n=e.am(r,e[r],t,2*r,0,1);(t[r+e.t]+=e.am(r+1,2*e[r],t,2*r+1,n,e.t-r-1))>=e.DV&&(t[r+e.t]-=e.DV,t[r+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(r,e[r],t,2*r,0,1)),t.s=0,t.clamp()},E.prototype.divRemTo=function gt(t,e,r){var n=t.abs();if(!(n.t<=0)){var i=this.abs();if(i.t<n.t)return null!=e&&e.fromInt(0),void(null!=r&&this.copyTo(r));null==r&&(r=x());var o=x(),s=this.s,a=t.s,u=this.DB-B(n[n.t-1]);u>0?(n.lShiftTo(u,o),i.lShiftTo(u,r)):(n.copyTo(o),i.copyTo(r));var c=o.t,h=o[c-1];if(0!=h){var l=h*(1<<this.F1)+(c>1?o[c-2]>>this.F2:0),f=this.FV/l,d=(1<<this.F1)/l,p=1<<this.F2,g=r.t,v=g-c,y=null==e?x():e;for(o.dlShiftTo(v,y),r.compareTo(y)>=0&&(r[r.t++]=1,r.subTo(y,r)),E.ONE.dlShiftTo(c,y),y.subTo(o,o);o.t<c;)o[o.t++]=0;for(;--v>=0;){var m=r[--g]==h?this.DM:Math.floor(r[g]*f+(r[g-1]+p)*d);if((r[g]+=o.am(0,m,r,v,0,c))<m)for(o.dlShiftTo(v,y),r.subTo(y,r);r[g]<--m;)r.subTo(y,r)}null!=e&&(r.drShiftTo(c,e),s!=a&&E.ZERO.subTo(e,e)),r.t=c,r.clamp(),u>0&&r.rShiftTo(u,r),s<0&&E.ZERO.subTo(r,r)}}},E.prototype.invDigit=function vt(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return(e=(e=(e=(e=e*(2-(15&t)*e)&15)*(2-(255&t)*e)&255)*(2-((65535&t)*e&65535))&65535)*(2-t*e%this.DV)%this.DV)>0?this.DV-e:-e},E.prototype.isEven=function yt(){return 0==(this.t>0?1&this[0]:this.s)},E.prototype.exp=function mt(t,e){if(t>4294967295||t<1)return E.ONE;var r=x(),n=x(),i=e.convert(this),o=B(t)-1;for(i.copyTo(r);--o>=0;)if(e.sqrTo(r,n),(t&1<<o)>0)e.mulTo(n,i,r);else{var s=r;r=n,n=s}return e.revert(r)},E.prototype.toString=function _t(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var r,n=(1<<e)-1,i=!1,o="",s=this.t,a=this.DB-s*this.DB%e;if(s-- >0)for(a<this.DB&&(r=this[s]>>a)>0&&(i=!0,o=D(r));s>=0;)a<e?(r=(this[s]&(1<<a)-1)<<e-a,r|=this[--s]>>(a+=this.DB-e)):(r=this[s]>>(a-=e)&n,a<=0&&(a+=this.DB,--s)),r>0&&(i=!0),i&&(o+=D(r));return i?o:"0"},E.prototype.negate=function St(){var t=x();return E.ZERO.subTo(this,t),t},E.prototype.abs=function Ft(){return this.s<0?this.negate():this},E.prototype.compareTo=function bt(t){var e=this.s-t.s;if(0!=e)return e;var r=this.t;if(0!=(e=r-t.t))return this.s<0?-e:e;for(;--r>=0;)if(0!=(e=this[r]-t[r]))return e;return 0},E.prototype.bitLength=function wt(){return this.t<=0?0:this.DB*(this.t-1)+B(this[this.t-1]^this.s&this.DM)},E.prototype.mod=function Et(t){var e=x();return this.abs().divRemTo(t,null,e),this.s<0&&e.compareTo(E.ZERO)>0&&t.subTo(e,e),e},E.prototype.modPowInt=function xt(t,e){var r;return r=t<256||e.isEven()?new N(e):new O(e),this.exp(t,r)},E.ZERO=U(0),E.ONE=U(1),J.prototype.convert=W,J.prototype.revert=W,J.prototype.mulTo=function kt(t,e,r){t.multiplyTo(e,r)},J.prototype.sqrTo=function At(t,e){t.squareTo(e)},z.prototype.convert=function Pt(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=x();return t.copyTo(e),this.reduce(e),e},z.prototype.revert=function Ct(t){return t},z.prototype.reduce=function Tt(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)},z.prototype.mulTo=function Rt(t,e,r){t.multiplyTo(e,r),this.reduce(r)},z.prototype.sqrTo=function It(t,e){t.squareTo(e),this.reduce(e)};var Dt=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],Lt=(1<<26)/Dt[Dt.length-1];
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Ut(){this.i=0,this.j=0,this.S=new Array}E.prototype.chunkSize=function Bt(t){return Math.floor(Math.LN2*this.DB/Math.log(t))},E.prototype.toRadix=function Nt(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var e=this.chunkSize(t),r=Math.pow(t,e),n=U(r),i=x(),o=x(),s="";for(this.divRemTo(n,i,o);i.signum()>0;)s=(r+o.intValue()).toString(t).substr(1)+s,i.divRemTo(n,i,o);return o.intValue().toString(t)+s},E.prototype.fromRadix=function Ot(t,e){this.fromInt(0),null==e&&(e=10);for(var r=this.chunkSize(e),n=Math.pow(e,r),i=!1,o=0,s=0,a=0;a<t.length;++a){var u=L(t,a);u<0?"-"==t.charAt(a)&&0==this.signum()&&(i=!0):(s=e*s+u,++o>=r&&(this.dMultiply(n),this.dAddOffset(s,0),o=0,s=0))}o>0&&(this.dMultiply(Math.pow(e,o)),this.dAddOffset(s,0)),i&&E.ZERO.subTo(this,this)},E.prototype.fromNumber=function jt(t,e,r){if("number"==typeof e)if(t<2)this.fromInt(1);else for(this.fromNumber(t,r),this.testBit(t-1)||this.bitwiseTo(E.ONE.shiftLeft(t-1),H,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(e);)this.dAddOffset(2,0),this.bitLength()>t&&this.subTo(E.ONE.shiftLeft(t-1),this);else{var n=new Array,i=7&t;n.length=1+(t>>3),e.nextBytes(n),i>0?n[0]&=(1<<i)-1:n[0]=0,this.fromString(n,256)}},E.prototype.bitwiseTo=function Ht(t,e,r){var n,i,o=Math.min(t.t,this.t);for(n=0;n<o;++n)r[n]=e(this[n],t[n]);if(t.t<this.t){for(i=t.s&this.DM,n=o;n<this.t;++n)r[n]=e(this[n],i);r.t=this.t}else{for(i=this.s&this.DM,n=o;n<t.t;++n)r[n]=e(i,t[n]);r.t=t.t}r.s=e(this.s,t.s),r.clamp()},E.prototype.changeBit=function Mt(t,e){var r=E.ONE.shiftLeft(t);return this.bitwiseTo(r,e,r),r},E.prototype.addTo=function Kt(t,e){for(var r=0,n=0,i=Math.min(t.t,this.t);r<i;)n+=this[r]+t[r],e[r++]=n&this.DM,n>>=this.DB;if(t.t<this.t){for(n+=t.s;r<this.t;)n+=this[r],e[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<t.t;)n+=t[r],e[r++]=n&this.DM,n>>=this.DB;n+=t.s}e.s=n<0?-1:0,n>0?e[r++]=n:n<-1&&(e[r++]=this.DV+n),e.t=r,e.clamp()},E.prototype.dMultiply=function Vt(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()},E.prototype.dAddOffset=function qt(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}},E.prototype.multiplyLowerTo=function Jt(t,e,r){var n,i=Math.min(this.t+t.t,e);for(r.s=0,r.t=i;i>0;)r[--i]=0;for(n=r.t-this.t;i<n;++i)r[i+this.t]=this.am(0,t[i],r,i,0,this.t);for(n=Math.min(t.t,e);i<n;++i)this.am(0,t[i],r,i,0,e-i);r.clamp()},E.prototype.multiplyUpperTo=function Wt(t,e,r){--e;var n=r.t=this.t+t.t-e;for(r.s=0;--n>=0;)r[n]=0;for(n=Math.max(e-this.t,0);n<t.t;++n)r[this.t+n-e]=this.am(e-n,t[n],r,0,0,this.t+n-e);r.clamp(),r.drShiftTo(1,r)},E.prototype.modInt=function zt(t){if(t<=0)return 0;var e=this.DV%t,r=this.s<0?t-1:0;if(this.t>0)if(0==e)r=this[0]%t;else for(var n=this.t-1;n>=0;--n)r=(e*r+this[n])%t;return r},E.prototype.millerRabin=function Yt(t){var e=this.subtract(E.ONE),r=e.getLowestSetBit();if(r<=0)return!1;var n=e.shiftRight(r);(t=t+1>>1)>Dt.length&&(t=Dt.length);for(var i=x(),o=0;o<t;++o){i.fromInt(Dt[Math.floor(Math.random()*Dt.length)]);var s=i.modPow(n,this);if(0!=s.compareTo(E.ONE)&&0!=s.compareTo(e)){for(var a=1;a++<r&&0!=s.compareTo(e);)if(0==(s=s.modPowInt(2,this)).compareTo(E.ONE))return!1;if(0!=s.compareTo(e))return!1}}return!0},E.prototype.clone=
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Gt(){var t=x();return this.copyTo(t),t},E.prototype.intValue=function Xt(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},E.prototype.byteValue=function Qt(){return 0==this.t?this.s:this[0]<<24>>24},E.prototype.shortValue=function $t(){return 0==this.t?this.s:this[0]<<16>>16},E.prototype.signum=function Zt(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},E.prototype.toByteArray=function te(){var t=this.t,e=new Array;e[0]=this.s;var r,n=this.DB-t*this.DB%8,i=0;if(t-- >0)for(n<this.DB&&(r=this[t]>>n)!=(this.s&this.DM)>>n&&(e[i++]=r|this.s<<this.DB-n);t>=0;)n<8?(r=(this[t]&(1<<n)-1)<<8-n,r|=this[--t]>>(n+=this.DB-8)):(r=this[t]>>(n-=8)&255,n<=0&&(n+=this.DB,--t)),0!=(128&r)&&(r|=-256),0==i&&(128&this.s)!=(128&r)&&++i,(i>0||r!=this.s)&&(e[i++]=r);return e},E.prototype.equals=function ee(t){return 0==this.compareTo(t)},E.prototype.min=function re(t){return this.compareTo(t)<0?this:t},E.prototype.max=function ne(t){return this.compareTo(t)>0?this:t},E.prototype.and=function ie(t){var e=x();return this.bitwiseTo(t,j,e),e},E.prototype.or=function oe(t){var e=x();return this.bitwiseTo(t,H,e),e},E.prototype.xor=function se(t){var e=x();return this.bitwiseTo(t,M,e),e},E.prototype.andNot=function ae(t){var e=x();return this.bitwiseTo(t,K,e),e},E.prototype.not=function ue(){for(var t=x(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t},E.prototype.shiftLeft=function ce(t){var e=x();return t<0?this.rShiftTo(-t,e):this.lShiftTo(t,e),e},E.prototype.shiftRight=function he(t){var e=x();return t<0?this.lShiftTo(-t,e):this.rShiftTo(t,e),e},E.prototype.getLowestSetBit=function le(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+V(this[t]);return this.s<0?this.t*this.DB:-1},E.prototype.bitCount=function fe(){for(var t=0,e=this.s&this.DM,r=0;r<this.t;++r)t+=q(this[r]^e);return t},E.prototype.testBit=function de(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)},E.prototype.setBit=function pe(t){return this.changeBit(t,H)},E.prototype.clearBit=function ge(t){return this.changeBit(t,K)},E.prototype.flipBit=function ve(t){return this.changeBit(t,M)},E.prototype.add=function ye(t){var e=x();return this.addTo(t,e),e},E.prototype.subtract=function me(t){var e=x();return this.subTo(t,e),e},E.prototype.multiply=function _e(t){var e=x();return this.multiplyTo(t,e),e},E.prototype.divide=function Se(t){var e=x();return this.divRemTo(t,e,null),e},E.prototype.remainder=function Fe(t){var e=x();return this.divRemTo(t,null,e),e},E.prototype.divideAndRemainder=function be(t){var e=x(),r=x();return this.divRemTo(t,e,r),new Array(e,r)},E.prototype.modPow=function we(t,e){var r,n,i=t.bitLength(),o=U(1);if(i<=0)return o;r=i<18?1:i<48?3:i<144?4:i<768?5:6,n=i<8?new N(e):e.isEven()?new z(e):new O(e);var s=new Array,a=3,u=r-1,c=(1<<r)-1;if(s[1]=n.convert(this),r>1){var h=x();for(n.sqrTo(s[1],h);a<=c;)s[a]=x(),n.mulTo(h,s[a-2],s[a]),a+=2}var l,f,d=t.t-1,p=!0,g=x();for(i=B(t[d])-1;d>=0;){for(i>=u?l=t[d]>>i-u&c:(l=(t[d]&(1<<i+1)-1)<<u-i,d>0&&(l|=t[d-1]>>this.DB+i-u)),a=r;0==(1&l);)l>>=1,--a;if((i-=a)<0&&(i+=this.DB,--d),p)s[l].copyTo(o),p=!1;else{for(;a>1;)n.sqrTo(o,g),n.sqrTo(g,o),a-=2;a>0?n.sqrTo(o,g):(f=o,o=g,g=f),n.mulTo(g,s[l],o)}for(;d>=0&&0==(t[d]&1<<i);)n.sqrTo(o,g),f=o,o=g,g=f,--i<0&&(i=this.DB-1,--d)}return n.revert(o)},E.prototype.modInverse=function Ee(t){var e=t.isEven();if(this.isEven()&&e||0==t.signum())return E.ZERO;for(var r=t.clone(),n=this.clone(),i=U(1),o=U(0),s=U(0),a=U(1);0!=r.signum();){for(;r.isEven();)r.rShiftTo(1,r),e?(i.isEven()&&o.isEven()||(i.addTo(this,i),o.subTo(t,o)),i.rShiftTo(1,i)):o.isEven()||o.subTo(t,o),o.rShiftTo(1,o);for(;n.isEven();)n.rShiftTo(1,n),e?(s.isEven()&&a.isEven()||(s.addTo(this,s),a.subTo(t,a)),s.rShiftTo(1,s)):a.isEven()||a.subTo(t,a),a.rShiftTo(1,a);r.compareTo(n)>=0?(r.subTo(n,r),e&&i.subTo(s,i),o.subTo(a,o)):(n.subTo(r,n),e&&s.subTo(i,s),a.subTo(o,a))}return 0!=n.compareTo(E.ONE)?E.ZERO:a.compareTo(t)>=0?a.subtract(t):a.signum()<0?(a.addTo(t,a),a.signum()<0?a.add(t):a):a},E.prototype.pow=function xe(t){return this.exp(t,new J)},E.prototype.gcd=function ke(t){var e=this.s<0?this.negate():this.clone(),r=t.s<0?t.negate():t.clone();if(e.compareTo(r)<0){var n=e;e=r,r=n}var i=e.getLowestSetBit(),o=r.getLowestSetBit();if(o<0)return e;for(i<o&&(o=i),o>0&&(e.rShiftTo(o,e),r.rShiftTo(o,r));e.signum()>0;)(i=e.getLowestSetBit())>0&&e.rShiftTo(i,e),(i=r.getLowestSetBit())>0&&r.rShiftTo(i,r),e.compareTo(r)>=0?(e.subTo(r,e),e.rShiftTo(1,e)):(r.subTo(e,r),r.rShiftTo(1,r));return o>0&&r.lShiftTo(o,r),r},E.prototype.isProbablePrime=function Ae(t){var e,r=this.abs();if(1==r.t&&r[0]<=Dt[Dt.length-1]){for(e=0;e<Dt.length;++e)if(r[0]==Dt[e])return!0;return!1}if(r.isEven())return!1;for(e=1;e<Dt.length;){for(var n=Dt[e],i=e+1;i<Dt.length&&n<Lt;)n*=Dt[i++];for(n=r.modInt(n);e<i;)if(n%Dt[e++]==0)return!1}return r.millerRabin(t)},E.prototype.square=function Pe(){var t=x();return this.squareTo(t),t},Ut.prototype.init=function Ce(t){var e,r,n;for(e=0;e<256;++e)this.S[e]=e;for(r=0,e=0;e<256;++e)r=r+this.S[e]+t[e%t.length]&255,n=this.S[e],this.S[e]=this.S[r],this.S[r]=n;this.i=0,this.j=0},Ut.prototype.next=function Te(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]};var Re,Ie,De,Le=256;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */function Ue(){!function t(e){Ie[De++]^=255&e,Ie[De++]^=e>>8&255,Ie[De++]^=e>>16&255,Ie[De++]^=e>>24&255,De>=Le&&(De-=Le)}((new Date).getTime())}if(null==Ie){var Be;if(Ie=new Array,De=0,void 0!==i&&(void 0!==i.crypto||void 0!==i.msCrypto)){var Ne=i.crypto||i.msCrypto;if(Ne.getRandomValues){var Oe=new Uint8Array(32);for(Ne.getRandomValues(Oe),Be=0;Be<32;++Be)Ie[De++]=Oe[Be]}else if("Netscape"==n.appName&&n.appVersion<"5"){var je=i.crypto.random(32);for(Be=0;Be<je.length;++Be)Ie[De++]=255&je.charCodeAt(Be)}}for(;De<Le;)Be=Math.floor(65536*Math.random()),Ie[De++]=Be>>>8,Ie[De++]=255&Be;De=0,Ue()}function He(){if(null==Re){for(Ue(),(Re=function t(){return new Ut}()).init(Ie),De=0;De<Ie.length;++De)Ie[De]=0;De=0}return Re.next()}function Me(){}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Ke(t,e){return new E(t,e)}function Ve(t,e,r){for(var n="",i=0;n.length<e;)n+=r(String.fromCharCode.apply(String,t.concat([(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i]))),i+=1;return n}function qe(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Je(t,e){this.x=e,this.q=t}function We(t,e,r,n){this.curve=t,this.x=e,this.y=r,this.z=null==n?E.ONE:n,this.zinv=null}function ze(t,e,r){this.q=t,this.a=this.fromBigInteger(e),this.b=this.fromBigInteger(r),this.infinity=new We(this,null,null)}Me.prototype.nextBytes=function Ye(t){var e;for(e=0;e<t.length;++e)t[e]=He()},qe.prototype.doPublic=function Ge(t){return t.modPowInt(this.e,this.n)},qe.prototype.setPublic=function Xe(t,e){if(this.isPublic=!0,this.isPrivate=!1,"string"!=typeof t)this.n=t,this.e=e;else{if(!(null!=t&&null!=e&&t.length>0&&e.length>0))throw"Invalid RSA public key";this.n=Ke(t,16),this.e=parseInt(e,16)}},qe.prototype.encrypt=function Qe(t){var e=function r(t,e){if(e<t.length+11)throw"Message too long for RSA";for(var r=new Array,n=t.length-1;n>=0&&e>0;){var i=t.charCodeAt(n--);i<128?r[--e]=i:i>127&&i<2048?(r[--e]=63&i|128,r[--e]=i>>6|192):(r[--e]=63&i|128,r[--e]=i>>6&63|128,r[--e]=i>>12|224)}r[--e]=0;for(var o=new Me,s=new Array;e>2;){for(s[0]=0;0==s[0];)o.nextBytes(s);r[--e]=s[0]}return r[--e]=2,r[--e]=0,new E(r)}(t,this.n.bitLength()+7>>3);if(null==e)return null;var n=this.doPublic(e);if(null==n)return null;var i=n.toString(16);return 0==(1&i.length)?i:"0"+i},qe.prototype.encryptOAEP=function $e(t,e,r){var n=function i(t,e,r,n){var i=Er.crypto.MessageDigest,o=Er.crypto.Util,s=null;if(r||(r="sha1"),"string"==typeof r&&(s=i.getCanonicalAlgName(r),n=i.getHashLength(s),r=function t(e){return Or(o.hashHex(jr(e),s))}),t.length+2*n+2>e)throw"Message too long for RSA";var a,u="";for(a=0;a<e-t.length-2*n-2;a+=1)u+="\0";var c=r("")+u+""+t,h=new Array(n);(new Me).nextBytes(h);var l=Ve(h,c.length,r),f=[];for(a=0;a<c.length;a+=1)f[a]=c.charCodeAt(a)^l.charCodeAt(a);var d=Ve(f,h.length,r),p=[0];for(a=0;a<h.length;a+=1)p[a+1]=h[a]^d.charCodeAt(a);return new E(p.concat(f))}(t,this.n.bitLength()+7>>3,e,r);if(null==n)return null;var o=this.doPublic(n);if(null==o)return null;var s=o.toString(16);return 0==(1&s.length)?s:"0"+s},qe.prototype.type="RSA",Je.prototype.equals=function Ze(t){return t==this||this.q.equals(t.q)&&this.x.equals(t.x)},Je.prototype.toBigInteger=function tr(){return this.x},Je.prototype.negate=function er(){return new Je(this.q,this.x.negate().mod(this.q))},Je.prototype.add=function rr(t){return new Je(this.q,this.x.add(t.toBigInteger()).mod(this.q))},Je.prototype.subtract=function nr(t){return new Je(this.q,this.x.subtract(t.toBigInteger()).mod(this.q))},Je.prototype.multiply=function ir(t){return new Je(this.q,this.x.multiply(t.toBigInteger()).mod(this.q))},Je.prototype.square=function or(){return new Je(this.q,this.x.square().mod(this.q))},Je.prototype.divide=function sr(t){return new Je(this.q,this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q))},We.prototype.getX=function ar(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))},We.prototype.getY=function ur(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))},We.prototype.equals=function cr(t){return t==this||(this.isInfinity()?t.isInfinity():t.isInfinity()?this.isInfinity():!!t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(E.ZERO)&&t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(E.ZERO))},We.prototype.isInfinity=function hr(){return null==this.x&&null==this.y||this.z.equals(E.ZERO)&&!this.y.toBigInteger().equals(E.ZERO)},We.prototype.negate=function lr(){return new We(this.curve,this.x,this.y.negate(),this.z)},We.prototype.add=function fr(t){if(this.isInfinity())return t;if(t.isInfinity())return this;var e=t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),r=t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q);if(E.ZERO.equals(r))return E.ZERO.equals(e)?this.twice():this.curve.getInfinity();var n=new E("3"),i=this.x.toBigInteger(),o=this.y.toBigInteger(),s=(t.x.toBigInteger(),t.y.toBigInteger(),r.square()),a=s.multiply(r),u=i.multiply(s),c=e.square().multiply(this.z),h=c.subtract(u.shiftLeft(1)).multiply(t.z).subtract(a).multiply(r).mod(this.curve.q),l=u.multiply(n).multiply(e).subtract(o.multiply(a)).subtract(c.multiply(e)).multiply(t.z).add(e.multiply(a)).mod(this.curve.q),f=a.multiply(this.z).multiply(t.z).mod(this.curve.q);return new We(this.curve,this.curve.fromBigInteger(h),this.curve.fromBigInteger(l),f)},We.prototype.twice=function dr(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=new E("3"),e=this.x.toBigInteger(),r=this.y.toBigInteger(),n=r.multiply(this.z),i=n.multiply(r).mod(this.curve.q),o=this.curve.a.toBigInteger(),s=e.square().multiply(t);E.ZERO.equals(o)||(s=s.add(this.z.square().multiply(o)));var a=(s=s.mod(this.curve.q)).square().subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.q),u=s.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(s.square().multiply(s)).mod(this.curve.q),c=n.square().multiply(n).shiftLeft(3).mod(this.curve.q);return new We(this.curve,this.curve.fromBigInteger(a),this.curve.fromBigInteger(u),c)},We.prototype.multiply=function pr(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,r=t,n=r.multiply(new E("3")),i=this.negate(),o=this;for(e=n.bitLength()-2;e>0;--e){o=o.twice();var s=n.testBit(e);s!=r.testBit(e)&&(o=o.add(s?this:i))}return o},We.prototype.multiplyTwo=function gr(t,e,r){var n;n=t.bitLength()>r.bitLength()?t.bitLength()-1:r.bitLength()-1;for(var i=this.curve.getInfinity(),o=this.add(e);n>=0;)i=i.twice(),t.testBit(n)?i=r.testBit(n)?i.add(o):i.add(this):r.testBit(n)&&(i=i.add(e)),--n;return i},ze.prototype.getQ=function vr(){return this.q},ze.prototype.getA=function yr(){return this.a},ze.prototype.getB=function mr(){return this.b},ze.prototype.equals=function _r(t){return t==this||this.q.equals(t.q)&&this.a.equals(t.a)&&this.b.equals(t.b)},ze.prototype.getInfinity=function Sr(){return this.infinity},ze.prototype.fromBigInteger=function Fr(t){return new Je(this.q,t)},ze.prototype.decodePointHex=function br(t){switch(parseInt(t.substr(0,2),16)){case 0:return this.infinity;case 2:case 3:return null;case 4:case 6:case 7:var e=(t.length-2)/2,r=t.substr(2,e),n=t.substr(e+2,e);return new We(this,this.fromBigInteger(new E(r,16)),this.fromBigInteger(new E(n,16)));default:return null}},
/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
 */
Je.prototype.getByteLength=function(){return Math.floor((this.toBigInteger().bitLength()+7)/8)},We.prototype.getEncoded=function(t){var e=function t(e,r){var n=e.toByteArrayUnsigned();if(r<n.length)n=n.slice(n.length-r);else for(;r>n.length;)n.unshift(0);return n},r=this.getX().toBigInteger(),n=this.getY().toBigInteger(),i=e(r,32);return t?n.isEven()?i.unshift(2):i.unshift(3):(i.unshift(4),i=i.concat(e(n,32))),i},We.decodeFrom=function(t,e){e[0];var r=e.length-1,n=e.slice(1,1+r/2),i=e.slice(1+r/2,1+r);n.unshift(0),i.unshift(0);var o=new E(n),s=new E(i);return new We(t,t.fromBigInteger(o),t.fromBigInteger(s))},We.decodeFromHex=function(t,e){e.substr(0,2);var r=e.length-2,n=e.substr(2,r/2),i=e.substr(2+r/2,r/2),o=new E(n,16),s=new E(i,16);return new We(t,t.fromBigInteger(o),t.fromBigInteger(s))},We.prototype.add2D=function(t){if(this.isInfinity())return t;if(t.isInfinity())return this;if(this.x.equals(t.x))return this.y.equals(t.y)?this.twice():this.curve.getInfinity();var e=t.x.subtract(this.x),r=t.y.subtract(this.y).divide(e),n=r.square().subtract(this.x).subtract(t.x),i=r.multiply(this.x.subtract(n)).subtract(this.y);return new We(this.curve,n,i)},We.prototype.twice2D=function(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=this.curve.fromBigInteger(E.valueOf(2)),e=this.curve.fromBigInteger(E.valueOf(3)),r=this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)),n=r.square().subtract(this.x.multiply(t)),i=r.multiply(this.x.subtract(n)).subtract(this.y);return new We(this.curve,n,i)},We.prototype.multiply2D=function(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,r=t,n=r.multiply(new E("3")),i=this.negate(),o=this;for(e=n.bitLength()-2;e>0;--e){o=o.twice();var s=n.testBit(e);s!=r.testBit(e)&&(o=o.add2D(s?this:i))}return o},We.prototype.isOnCurve=function(){var t=this.getX().toBigInteger(),e=this.getY().toBigInteger(),r=this.curve.getA().toBigInteger(),n=this.curve.getB().toBigInteger(),i=this.curve.getQ(),o=e.multiply(e).mod(i),s=t.multiply(t).multiply(t).add(r.multiply(t)).add(n).mod(i);return o.equals(s)},We.prototype.toString=function(){return"("+this.getX().toBigInteger().toString()+","+this.getY().toBigInteger().toString()+")"},We.prototype.validate=function(){var t=this.curve.getQ();if(this.isInfinity())throw new Error("Point is at infinity.");var e=this.getX().toBigInteger(),r=this.getY().toBigInteger();if(e.compareTo(E.ONE)<0||e.compareTo(t.subtract(E.ONE))>0)throw new Error("x coordinate out of bounds");if(r.compareTo(E.ONE)<0||r.compareTo(t.subtract(E.ONE))>0)throw new Error("y coordinate out of bounds");if(!this.isOnCurve())throw new Error("Point is not on the curve.");if(this.multiply(t).isInfinity())throw new Error("Point is not a scalar multiple of G.");return!0};
/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
 */
var wr=function(){var t=new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))',"g"),e=new RegExp("\\\\(?:([^u])|u(.{4}))","g"),n={'"':'"',"/":"/","\\":"\\",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"};function i(t,e,r){return e?n[e]:String.fromCharCode(parseInt(r,16))}var o=new String(""),s=(Object,Array,Object.hasOwnProperty);return function(n,a){var u,c,h=n.match(t),l=h[0],f=!1;"{"===l?u={}:"["===l?u=[]:(u=[],f=!0);for(var d=[u],p=1-f,g=h.length;p<g;++p){var v;switch((l=h[p]).charCodeAt(0)){default:(v=d[0])[c||v.length]=+l,c=void 0;break;case 34:if(-1!==(l=l.substring(1,l.length-1)).indexOf("\\")&&(l=l.replace(e,i)),v=d[0],!c){if(!(v instanceof Array)){c=l||o;break}c=v.length}v[c]=l,c=void 0;break;case 91:v=d[0],d.unshift(v[c||v.length]=[]),c=void 0;break;case 93:d.shift();break;case 102:(v=d[0])[c||v.length]=!1,c=void 0;break;case 110:(v=d[0])[c||v.length]=null,c=void 0;break;case 116:(v=d[0])[c||v.length]=!0,c=void 0;break;case 123:v=d[0],d.unshift(v[c||v.length]={}),c=void 0;break;case 125:d.shift()}}if(f){if(1!==d.length)throw new Error;u=u[0]}else if(d.length)throw new Error;if(a){u=function t(e,n){var i=e[n];if(i&&"object"===(void 0===i?"undefined":r(i))){var o=null;for(var u in i)if(s.call(i,u)&&i!==e){var c=t(i,u);void 0!==c?i[u]=c:(o||(o=[]),o.push(u))}if(o)for(var h=o.length;--h>=0;)delete i[o[h]]}return a.call(e,n,i)}({"":u},"")}return u}}();void 0!==Er&&Er||(e.KJUR=Er={}),void 0!==Er.asn1&&Er.asn1||(Er.asn1={}),Er.asn1.ASN1Util=new function(){this.integerToByteHex=function(t){var e=t.toString(16);return e.length%2==1&&(e="0"+e),e},this.bigIntToMinTwosComplementsHex=function(t){var e=t.toString(16);if("-"!=e.substr(0,1))e.length%2==1?e="0"+e:e.match(/^[0-7]/)||(e="00"+e);else{var r=e.substr(1).length;r%2==1?r+=1:e.match(/^[0-7]/)||(r+=2);for(var n="",i=0;i<r;i++)n+="f";e=new E(n,16).xor(t).add(E.ONE).toString(16).replace(/^-/,"")}return e},this.getPEMStringFromHex=function(t,e){return Vr(t,e)},this.newObject=function(t){var e=Er.asn1,r=e.DERBoolean,n=e.DERInteger,i=e.DERBitString,o=e.DEROctetString,s=e.DERNull,a=e.DERObjectIdentifier,u=e.DEREnumerated,c=e.DERUTF8String,h=e.DERNumericString,l=e.DERPrintableString,f=e.DERTeletexString,d=e.DERIA5String,p=e.DERUTCTime,g=e.DERGeneralizedTime,v=e.DERSequence,y=e.DERSet,m=e.DERTaggedObject,_=e.ASN1Util.newObject,S=Object.keys(t);if(1!=S.length)throw"key of param shall be only one.";var F=S[0];if(-1==":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+F+":"))throw"undefined key: "+F;if("bool"==F)return new r(t[F]);if("int"==F)return new n(t[F]);if("bitstr"==F)return new i(t[F]);if("octstr"==F)return new o(t[F]);if("null"==F)return new s(t[F]);if("oid"==F)return new a(t[F]);if("enum"==F)return new u(t[F]);if("utf8str"==F)return new c(t[F]);if("numstr"==F)return new h(t[F]);if("prnstr"==F)return new l(t[F]);if("telstr"==F)return new f(t[F]);if("ia5str"==F)return new d(t[F]);if("utctime"==F)return new p(t[F]);if("gentime"==F)return new g(t[F]);if("seq"==F){for(var b=t[F],w=[],E=0;E<b.length;E++){var x=_(b[E]);w.push(x)}return new v({array:w})}if("set"==F){for(b=t[F],w=[],E=0;E<b.length;E++){x=_(b[E]);w.push(x)}return new y({array:w})}if("tag"==F){var k=t[F];if("[object Array]"===Object.prototype.toString.call(k)&&3==k.length){var A=_(k[2]);return new m({tag:k[0],explicit:k[1],obj:A})}var P={};if(void 0!==k.explicit&&(P.explicit=k.explicit),void 0!==k.tag&&(P.tag=k.tag),void 0===k.obj)throw"obj shall be specified for 'tag'.";return P.obj=_(k.obj),new m(P)}},this.jsonToASN1HEX=function(t){return this.newObject(t).getEncodedHex()}},Er.asn1.ASN1Util.oidHexToInt=function(t){for(var e="",r=parseInt(t.substr(0,2),16),n=(e=Math.floor(r/40)+"."+r%40,""),i=2;i<t.length;i+=2){var o=("00000000"+parseInt(t.substr(i,2),16).toString(2)).slice(-8);if(n+=o.substr(1,7),"0"==o.substr(0,1))e=e+"."+new E(n,2).toString(10),n=""}return e},Er.asn1.ASN1Util.oidIntToHex=function(t){var e=function t(e){var r=e.toString(16);return 1==r.length&&(r="0"+r),r},r=function t(r){var n="",i=new E(r,10).toString(2),o=7-i.length%7;7==o&&(o=0);for(var s="",a=0;a<o;a++)s+="0";i=s+i;for(a=0;a<i.length-1;a+=7){var u=i.substr(a,7);a!=i.length-7&&(u="1"+u),n+=e(parseInt(u,2))}return n};if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var n="",i=t.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=e(o),i.splice(0,2);for(var s=0;s<i.length;s++)n+=r(i[s]);return n},Er.asn1.ASN1Object=function(){this.getLengthHexFromValue=function(){if(void 0===this.hV||null==this.hV)throw"this.hV is null or undefined.";if(this.hV.length%2==1)throw"value hex must be even length: n="+"".length+",v="+this.hV;var t=this.hV.length/2,e=t.toString(16);if(e.length%2==1&&(e="0"+e),t<128)return e;var r=e.length/2;if(r>15)throw"ASN.1 length too long to represent by 8x: n = "+t.toString(16);return(128+r).toString(16)+e},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""}},Er.asn1.DERAbstractString=function(t){Er.asn1.DERAbstractString.superclass.constructor.call(this);this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=Br(this.s).toLowerCase()},this.setStringHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?this.setString(t):void 0!==t.str?this.setString(t.str):void 0!==t.hex&&this.setStringHex(t.hex))},o.lang.extend(Er.asn1.DERAbstractString,Er.asn1.ASN1Object),Er.asn1.DERAbstractTime=function(t){Er.asn1.DERAbstractTime.superclass.constructor.call(this);this.localDateToUTC=function(t){return utc=t.getTime()+6e4*t.getTimezoneOffset(),new Date(utc)},this.formatDate=function(t,e,r){var n=this.zeroPadding,i=this.localDateToUTC(t),o=String(i.getFullYear());"utc"==e&&(o=o.substr(2,2));var s=o+n(String(i.getMonth()+1),2)+n(String(i.getDate()),2)+n(String(i.getHours()),2)+n(String(i.getMinutes()),2)+n(String(i.getSeconds()),2);if(!0===r){var a=i.getMilliseconds();if(0!=a){var u=n(String(a),3);s=s+"."+(u=u.replace(/[0]+$/,""))}}return s+"Z"},this.zeroPadding=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=Rr(t)},this.setByDateValue=function(t,e,r,n,i,o){var s=new Date(Date.UTC(t,e-1,r,n,i,o,0));this.setByDate(s)},this.getFreshValueHex=function(){return this.hV}},o.lang.extend(Er.asn1.DERAbstractTime,Er.asn1.ASN1Object),Er.asn1.DERAbstractStructured=function(t){Er.asn1.DERAbstractString.superclass.constructor.call(this);this.setByASN1ObjectArray=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array=t},this.appendASN1Object=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array.push(t)},this.asn1Array=new Array,void 0!==t&&void 0!==t.array&&(this.asn1Array=t.array)},o.lang.extend(Er.asn1.DERAbstractStructured,Er.asn1.ASN1Object),Er.asn1.DERBoolean=function(){Er.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV="0101ff"},o.lang.extend(Er.asn1.DERBoolean,Er.asn1.ASN1Object),Er.asn1.DERInteger=function(t){Er.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=Er.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new E(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.bigint?this.setByBigInteger(t.bigint):void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},o.lang.extend(Er.asn1.DERInteger,Er.asn1.ASN1Object),Er.asn1.DERBitString=function(t){if(void 0!==t&&void 0!==t.obj){var e=Er.asn1.ASN1Util.newObject(t.obj);t.hex="00"+e.getEncodedHex()}Er.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(t){this.hTLV=null,this.isModified=!0,this.hV=t},this.setUnusedBitsAndHexValue=function(t,e){if(t<0||7<t)throw"unused bits shall be from 0 to 7: u = "+t;var r="0"+t;this.hTLV=null,this.isModified=!0,this.hV=r+e},this.setByBinaryString=function(t){var e=8-(t=t.replace(/0+$/,"")).length%8;8==e&&(e=0);for(var r=0;r<=e;r++)t+="0";var n="";for(r=0;r<t.length-1;r+=8){var i=t.substr(r,8),o=parseInt(i,2).toString(16);1==o.length&&(o="0"+o),n+=o}this.hTLV=null,this.isModified=!0,this.hV="0"+e+n},this.setByBooleanArray=function(t){for(var e="",r=0;r<t.length;r++)1==t[r]?e+="1":e+="0";this.setByBinaryString(e)},this.newFalseArray=function(t){for(var e=new Array(t),r=0;r<t;r++)e[r]=!1;return e},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t&&t.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(t):void 0!==t.hex?this.setHexValueIncludingUnusedBits(t.hex):void 0!==t.bin?this.setByBinaryString(t.bin):void 0!==t.array&&this.setByBooleanArray(t.array))},o.lang.extend(Er.asn1.DERBitString,Er.asn1.ASN1Object),Er.asn1.DEROctetString=function(t){if(void 0!==t&&void 0!==t.obj){var e=Er.asn1.ASN1Util.newObject(t.obj);t.hex=e.getEncodedHex()}Er.asn1.DEROctetString.superclass.constructor.call(this,t),this.hT="04"},o.lang.extend(Er.asn1.DEROctetString,Er.asn1.DERAbstractString),Er.asn1.DERNull=function(){Er.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},o.lang.extend(Er.asn1.DERNull,Er.asn1.ASN1Object),Er.asn1.DERObjectIdentifier=function(t){var e=function t(e){var r=e.toString(16);return 1==r.length&&(r="0"+r),r},r=function t(r){var n="",i=new E(r,10).toString(2),o=7-i.length%7;7==o&&(o=0);for(var s="",a=0;a<o;a++)s+="0";i=s+i;for(a=0;a<i.length-1;a+=7){var u=i.substr(a,7);a!=i.length-7&&(u="1"+u),n+=e(parseInt(u,2))}return n};Er.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.setValueOidString=function(t){if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var n="",i=t.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=e(o),i.splice(0,2);for(var s=0;s<i.length;s++)n+=r(i[s]);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=n},this.setValueName=function(t){var e=Er.asn1.x509.OID.name2oid(t);if(""===e)throw"DERObjectIdentifier oidName undefined: "+t;this.setValueOidString(e)},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?t.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(t):this.setValueName(t):void 0!==t.oid?this.setValueOidString(t.oid):void 0!==t.hex?this.setValueHex(t.hex):void 0!==t.name&&this.setValueName(t.name))},o.lang.extend(Er.asn1.DERObjectIdentifier,Er.asn1.ASN1Object),Er.asn1.DEREnumerated=function(t){Er.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=Er.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new E(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},o.lang.extend(Er.asn1.DEREnumerated,Er.asn1.ASN1Object),Er.asn1.DERUTF8String=function(t){Er.asn1.DERUTF8String.superclass.constructor.call(this,t),this.hT="0c"},o.lang.extend(Er.asn1.DERUTF8String,Er.asn1.DERAbstractString),Er.asn1.DERNumericString=function(t){Er.asn1.DERNumericString.superclass.constructor.call(this,t),this.hT="12"},o.lang.extend(Er.asn1.DERNumericString,Er.asn1.DERAbstractString),Er.asn1.DERPrintableString=function(t){Er.asn1.DERPrintableString.superclass.constructor.call(this,t),this.hT="13"},o.lang.extend(Er.asn1.DERPrintableString,Er.asn1.DERAbstractString),Er.asn1.DERTeletexString=function(t){Er.asn1.DERTeletexString.superclass.constructor.call(this,t),this.hT="14"},o.lang.extend(Er.asn1.DERTeletexString,Er.asn1.DERAbstractString),Er.asn1.DERIA5String=function(t){Er.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="16"},o.lang.extend(Er.asn1.DERIA5String,Er.asn1.DERAbstractString),Er.asn1.DERUTCTime=function(t){Er.asn1.DERUTCTime.superclass.constructor.call(this,t),this.hT="17",this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"utc"),this.hV=Rr(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=Rr(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{12}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date))},o.lang.extend(Er.asn1.DERUTCTime,Er.asn1.DERAbstractTime),Er.asn1.DERGeneralizedTime=function(t){Er.asn1.DERGeneralizedTime.superclass.constructor.call(this,t),this.hT="18",this.withMillis=!1,this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=Rr(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=Rr(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{14}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date),!0===t.millis&&(this.withMillis=!0))},o.lang.extend(Er.asn1.DERGeneralizedTime,Er.asn1.DERAbstractTime),Er.asn1.DERSequence=function(t){Er.asn1.DERSequence.superclass.constructor.call(this,t),this.hT="30",this.getFreshValueHex=function(){for(var t="",e=0;e<this.asn1Array.length;e++){t+=this.asn1Array[e].getEncodedHex()}return this.hV=t,this.hV}},o.lang.extend(Er.asn1.DERSequence,Er.asn1.DERAbstractStructured),Er.asn1.DERSet=function(t){Er.asn1.DERSet.superclass.constructor.call(this,t),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var t=new Array,e=0;e<this.asn1Array.length;e++){var r=this.asn1Array[e];t.push(r.getEncodedHex())}return 1==this.sortFlag&&t.sort(),this.hV=t.join(""),this.hV},void 0!==t&&void 0!==t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},o.lang.extend(Er.asn1.DERSet,Er.asn1.DERAbstractStructured),Er.asn1.DERTaggedObject=function(t){Er.asn1.DERTaggedObject.superclass.constructor.call(this),this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(t,e,r){this.hT=e,this.isExplicit=t,this.asn1Object=r,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=r.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,e),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.tag&&(this.hT=t.tag),void 0!==t.explicit&&(this.isExplicit=t.explicit),void 0!==t.obj&&(this.asn1Object=t.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},o.lang.extend(Er.asn1.DERTaggedObject,Er.asn1.ASN1Object);var Er,xr,kr,Ar=new function(){};function Pr(t){for(var e=new Array,r=0;r<t.length;r++)e[r]=t.charCodeAt(r);return e}function Cr(t){for(var e="",r=0;r<t.length;r++)e+=String.fromCharCode(t[r]);return e}function Tr(t){for(var e="",r=0;r<t.length;r++){var n=t[r].toString(16);1==n.length&&(n="0"+n),e+=n}return e}function Rr(t){return Tr(Pr(t))}function Ir(t){return t=(t=(t=t.replace(/\=/g,"")).replace(/\+/g,"-")).replace(/\//g,"_")}function Dr(t){return t.length%4==2?t+="==":t.length%4==3&&(t+="="),t=(t=t.replace(/-/g,"+")).replace(/_/g,"/")}function Lr(t){return t.length%2==1&&(t="0"+t),Ir(F(t))}function Ur(t){return b(Dr(t))}function Br(t){return zr($r(t))}function Nr(t){return decodeURIComponent(Yr(t))}function Or(t){for(var e="",r=0;r<t.length-1;r+=2)e+=String.fromCharCode(parseInt(t.substr(r,2),16));return e}function jr(t){for(var e="",r=0;r<t.length;r++)e+=("0"+t.charCodeAt(r).toString(16)).slice(-2);return e}function Hr(t){return F(t)}function Mr(t){var e=Hr(t).replace(/(.{64})/g,"$1\r\n");return e=e.replace(/\r\n$/,"")}function Kr(t){return b(t.replace(/[^0-9A-Za-z\/+=]*/g,""))}function Vr(t,e){return"-----BEGIN "+e+"-----\r\n"+Mr(t)+"\r\n-----END "+e+"-----\r\n"}function qr(t,e){if(-1==t.indexOf("-----BEGIN "))throw"can't find PEM header: "+e;return Kr(t=void 0!==e?(t=t.replace("-----BEGIN "+e+"-----","")).replace("-----END "+e+"-----",""):(t=t.replace(/-----BEGIN [^-]+-----/,"")).replace(/-----END [^-]+-----/,""))}function Jr(t){var e,r,n,i,o,s,a,u,c,h,l;if(l=t.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/))return u=l[1],e=parseInt(u),2===u.length&&(50<=e&&e<100?e=1900+e:0<=e&&e<50&&(e=2e3+e)),r=parseInt(l[2])-1,n=parseInt(l[3]),i=parseInt(l[4]),o=parseInt(l[5]),s=parseInt(l[6]),a=0,""!==(c=l[7])&&(h=(c.substr(1)+"00").substr(0,3),a=parseInt(h)),Date.UTC(e,r,n,i,o,s,a);throw"unsupported zulu format: "+t}function Wr(t){return~~(Jr(t)/1e3)}function zr(t){return t.replace(/%/g,"")}function Yr(t){return t.replace(/(..)/g,"%$1")}function Gr(t){var e="malformed IPv6 address";if(!t.match(/^[0-9A-Fa-f:]+$/))throw e;var r=(t=t.toLowerCase()).split(":").length-1;if(r<2)throw e;var n=":".repeat(7-r+2),i=(t=t.replace("::",n)).split(":");if(8!=i.length)throw e;for(var o=0;o<8;o++)i[o]=("0000"+i[o]).slice(-4);return i.join("")}function Xr(t){if(!t.match(/^[0-9A-Fa-f]{32}$/))throw"malformed IPv6 address octet";for(var e=(t=t.toLowerCase()).match(/.{1,4}/g),r=0;r<8;r++)e[r]=e[r].replace(/^0+/,""),""==e[r]&&(e[r]="0");var n=(t=":"+e.join(":")+":").match(/:(0:){2,}/g);if(null===n)return t.slice(1,-1);var i="";for(r=0;r<n.length;r++)n[r].length>i.length&&(i=n[r]);return(t=t.replace(i,"::")).slice(1,-1)}function Qr(t){var e="malformed hex value";if(!t.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))throw e;if(8!=t.length)return 32==t.length?Xr(t):t;try{return parseInt(t.substr(0,2),16)+"."+parseInt(t.substr(2,2),16)+"."+parseInt(t.substr(4,2),16)+"."+parseInt(t.substr(6,2),16)}catch(t){throw e}}function $r(t){for(var e=encodeURIComponent(t),r="",n=0;n<e.length;n++)"%"==e[n]?(r+=e.substr(n,3),n+=2):r=r+"%"+Rr(e[n]);return r}function Zr(t){return t.length%2==1?"0"+t:t.substr(0,1)>"7"?"00"+t:t}Ar.getLblen=function(t,e){if("8"!=t.substr(e+2,1))return 1;var r=parseInt(t.substr(e+3,1));return 0==r?-1:0<r&&r<10?r+1:-2},Ar.getL=function(t,e){var r=Ar.getLblen(t,e);return r<1?"":t.substr(e+2,2*r)},Ar.getVblen=function(t,e){var r;return""==(r=Ar.getL(t,e))?-1:("8"===r.substr(0,1)?new E(r.substr(2),16):new E(r,16)).intValue()},Ar.getVidx=function(t,e){var r=Ar.getLblen(t,e);return r<0?r:e+2*(r+1)},Ar.getV=function(t,e){var r=Ar.getVidx(t,e),n=Ar.getVblen(t,e);return t.substr(r,2*n)},Ar.getTLV=function(t,e){return t.substr(e,2)+Ar.getL(t,e)+Ar.getV(t,e)},Ar.getNextSiblingIdx=function(t,e){return Ar.getVidx(t,e)+2*Ar.getVblen(t,e)},Ar.getChildIdx=function(t,e){var r=Ar,n=new Array,i=r.getVidx(t,e);"03"==t.substr(e,2)?n.push(i+2):n.push(i);for(var o=r.getVblen(t,e),s=i,a=0;;){var u=r.getNextSiblingIdx(t,s);if(null==u||u-i>=2*o)break;if(a>=200)break;n.push(u),s=u,a++}return n},Ar.getNthChildIdx=function(t,e,r){return Ar.getChildIdx(t,e)[r]},Ar.getIdxbyList=function(t,e,r,n){var i,o,s=Ar;if(0==r.length){if(void 0!==n&&t.substr(e,2)!==n)throw"checking tag doesn't match: "+t.substr(e,2)+"!="+n;return e}return i=r.shift(),o=s.getChildIdx(t,e),s.getIdxbyList(t,o[i],r,n)},Ar.getTLVbyList=function(t,e,r,n){var i=Ar,o=i.getIdxbyList(t,e,r);if(void 0===o)throw"can't find nthList object";if(void 0!==n&&t.substr(o,2)!=n)throw"checking tag doesn't match: "+t.substr(o,2)+"!="+n;return i.getTLV(t,o)},Ar.getVbyList=function(t,e,r,n,i){var o,s,a=Ar;if(void 0===(o=a.getIdxbyList(t,e,r,n)))throw"can't find nthList object";return s=a.getV(t,o),!0===i&&(s=s.substr(2)),s},Ar.hextooidstr=function(t){var e=function t(e,r){return e.length>=r?e:new Array(r-e.length+1).join("0")+e},r=[],n=t.substr(0,2),i=parseInt(n,16);r[0]=new String(Math.floor(i/40)),r[1]=new String(i%40);for(var o=t.substr(2),s=[],a=0;a<o.length/2;a++)s.push(parseInt(o.substr(2*a,2),16));var u=[],c="";for(a=0;a<s.length;a++)128&s[a]?c+=e((127&s[a]).toString(2),7):(c+=e((127&s[a]).toString(2),7),u.push(new String(parseInt(c,2))),c="");var h=r.join(".");return u.length>0&&(h=h+"."+u.join(".")),h},Ar.dump=function(t,e,r,n){var i=Ar,o=i.getV,s=i.dump,a=i.getChildIdx,u=t;t instanceof Er.asn1.ASN1Object&&(u=t.getEncodedHex());var c=function t(e,r){return e.length<=2*r?e:e.substr(0,r)+"..(total "+e.length/2+"bytes).."+e.substr(e.length-r,r)};void 0===e&&(e={ommit_long_octet:32}),void 0===r&&(r=0),void 0===n&&(n="");var h=e.ommit_long_octet;if("01"==u.substr(r,2))return"00"==(l=o(u,r))?n+"BOOLEAN FALSE\n":n+"BOOLEAN TRUE\n";if("02"==u.substr(r,2))return n+"INTEGER "+c(l=o(u,r),h)+"\n";if("03"==u.substr(r,2))return n+"BITSTRING "+c(l=o(u,r),h)+"\n";if("04"==u.substr(r,2)){var l=o(u,r);if(i.isASN1HEX(l)){var f=n+"OCTETSTRING, encapsulates\n";return f+=s(l,e,0,n+"  ")}return n+"OCTETSTRING "+c(l,h)+"\n"}if("05"==u.substr(r,2))return n+"NULL\n";if("06"==u.substr(r,2)){var d=o(u,r),p=Er.asn1.ASN1Util.oidHexToInt(d),g=Er.asn1.x509.OID.oid2name(p),v=p.replace(/\./g," ");return""!=g?n+"ObjectIdentifier "+g+" ("+v+")\n":n+"ObjectIdentifier ("+v+")\n"}if("0c"==u.substr(r,2))return n+"UTF8String '"+Nr(o(u,r))+"'\n";if("13"==u.substr(r,2))return n+"PrintableString '"+Nr(o(u,r))+"'\n";if("14"==u.substr(r,2))return n+"TeletexString '"+Nr(o(u,r))+"'\n";if("16"==u.substr(r,2))return n+"IA5String '"+Nr(o(u,r))+"'\n";if("17"==u.substr(r,2))return n+"UTCTime "+Nr(o(u,r))+"\n";if("18"==u.substr(r,2))return n+"GeneralizedTime "+Nr(o(u,r))+"\n";if("30"==u.substr(r,2)){if("3000"==u.substr(r,4))return n+"SEQUENCE {}\n";f=n+"SEQUENCE\n";var y=e;if((2==(S=a(u,r)).length||3==S.length)&&"06"==u.substr(S[0],2)&&"04"==u.substr(S[S.length-1],2)){g=i.oidname(o(u,S[0]));var m=JSON.parse(JSON.stringify(e));m.x509ExtName=g,y=m}for(var _=0;_<S.length;_++)f+=s(u,y,S[_],n+"  ");return f}if("31"==u.substr(r,2)){f=n+"SET\n";var S=a(u,r);for(_=0;_<S.length;_++)f+=s(u,e,S[_],n+"  ");return f}var F=parseInt(u.substr(r,2),16);if(0!=(128&F)){var b=31&F;if(0!=(32&F)){var f=n+"["+b+"]\n";for(S=a(u,r),_=0;_<S.length;_++)f+=s(u,e,S[_],n+"  ");return f}return"68747470"==(l=o(u,r)).substr(0,8)&&(l=Nr(l)),"subjectAltName"===e.x509ExtName&&2==b&&(l=Nr(l)),f=n+"["+b+"] "+l+"\n"}return n+"UNKNOWN("+u.substr(r,2)+") "+o(u,r)+"\n"},Ar.isASN1HEX=function(t){var e=Ar;if(t.length%2==1)return!1;var r=e.getVblen(t,0),n=t.substr(0,2),i=e.getL(t,0);return t.length-n.length-i.length==2*r},Ar.oidname=function(t){var e=Er.asn1;Er.lang.String.isHex(t)&&(t=e.ASN1Util.oidHexToInt(t));var r=e.x509.OID.oid2name(t);return""===r&&(r=t),r},void 0!==Er&&Er||(e.KJUR=Er={}),void 0!==Er.lang&&Er.lang||(Er.lang={}),Er.lang.String=function(){},"function"==typeof t?(e.utf8tob64u=xr=function e(r){return Ir(new t(r,"utf8").toString("base64"))},e.b64utoutf8=kr=function e(r){return new t(Dr(r),"base64").toString("utf8")}):(e.utf8tob64u=xr=function t(e){return Lr(zr($r(e)))},e.b64utoutf8=kr=function t(e){return decodeURIComponent(Yr(Ur(e)))}),Er.lang.String.isInteger=function(t){return!!t.match(/^[0-9]+$/)||!!t.match(/^-[0-9]+$/)},Er.lang.String.isHex=function(t){return!(t.length%2!=0||!t.match(/^[0-9a-f]+$/)&&!t.match(/^[0-9A-F]+$/))},Er.lang.String.isBase64=function(t){return!(!(t=t.replace(/\s+/g,"")).match(/^[0-9A-Za-z+\/]+={0,3}$/)||t.length%4!=0)},Er.lang.String.isBase64URL=function(t){return!t.match(/[+/=]/)&&(t=Dr(t),Er.lang.String.isBase64(t))},Er.lang.String.isIntegerArray=function(t){return!!(t=t.replace(/\s+/g,"")).match(/^\[[0-9,]+\]$/)};void 0!==Er&&Er||(e.KJUR=Er={}),void 0!==Er.crypto&&Er.crypto||(Er.crypto={}),Er.crypto.Util=new function(){this.DIGESTINFOHEAD={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},this.DEFAULTPROVIDER={md5:"cryptojs",sha1:"cryptojs",sha224:"cryptojs",sha256:"cryptojs",sha384:"cryptojs",sha512:"cryptojs",ripemd160:"cryptojs",hmacmd5:"cryptojs",hmacsha1:"cryptojs",hmacsha224:"cryptojs",hmacsha256:"cryptojs",hmacsha384:"cryptojs",hmacsha512:"cryptojs",hmacripemd160:"cryptojs",MD5withRSA:"cryptojs/jsrsa",SHA1withRSA:"cryptojs/jsrsa",SHA224withRSA:"cryptojs/jsrsa",SHA256withRSA:"cryptojs/jsrsa",SHA384withRSA:"cryptojs/jsrsa",SHA512withRSA:"cryptojs/jsrsa",RIPEMD160withRSA:"cryptojs/jsrsa",MD5withECDSA:"cryptojs/jsrsa",SHA1withECDSA:"cryptojs/jsrsa",SHA224withECDSA:"cryptojs/jsrsa",SHA256withECDSA:"cryptojs/jsrsa",SHA384withECDSA:"cryptojs/jsrsa",SHA512withECDSA:"cryptojs/jsrsa",RIPEMD160withECDSA:"cryptojs/jsrsa",SHA1withDSA:"cryptojs/jsrsa",SHA224withDSA:"cryptojs/jsrsa",SHA256withDSA:"cryptojs/jsrsa",MD5withRSAandMGF1:"cryptojs/jsrsa",SHA1withRSAandMGF1:"cryptojs/jsrsa",SHA224withRSAandMGF1:"cryptojs/jsrsa",SHA256withRSAandMGF1:"cryptojs/jsrsa",SHA384withRSAandMGF1:"cryptojs/jsrsa",SHA512withRSAandMGF1:"cryptojs/jsrsa",RIPEMD160withRSAandMGF1:"cryptojs/jsrsa"},this.CRYPTOJSMESSAGEDIGESTNAME={md5:y.algo.MD5,sha1:y.algo.SHA1,sha224:y.algo.SHA224,sha256:y.algo.SHA256,sha384:y.algo.SHA384,sha512:y.algo.SHA512,ripemd160:y.algo.RIPEMD160},this.getDigestInfoHex=function(t,e){if(void 0===this.DIGESTINFOHEAD[e])throw"alg not supported in Util.DIGESTINFOHEAD: "+e;return this.DIGESTINFOHEAD[e]+t},this.getPaddedDigestInfoHex=function(t,e,r){var n=this.getDigestInfoHex(t,e),i=r/4;if(n.length+22>i)throw"key is too short for SigAlg: keylen="+r+","+e;for(var o="0001",s="00"+n,a="",u=i-o.length-s.length,c=0;c<u;c+=2)a+="ff";return o+a+s},this.hashString=function(t,e){return new Er.crypto.MessageDigest({alg:e}).digestString(t)},this.hashHex=function(t,e){return new Er.crypto.MessageDigest({alg:e}).digestHex(t)},this.sha1=function(t){return new Er.crypto.MessageDigest({alg:"sha1",prov:"cryptojs"}).digestString(t)},this.sha256=function(t){return new Er.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"}).digestString(t)},this.sha256Hex=function(t){return new Er.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"}).digestHex(t)},this.sha512=function(t){return new Er.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"}).digestString(t)},this.sha512Hex=function(t){return new Er.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"}).digestHex(t)}},Er.crypto.Util.md5=function(t){return new Er.crypto.MessageDigest({alg:"md5",prov:"cryptojs"}).digestString(t)},Er.crypto.Util.ripemd160=function(t){return new Er.crypto.MessageDigest({alg:"ripemd160",prov:"cryptojs"}).digestString(t)},Er.crypto.Util.SECURERANDOMGEN=new Me,Er.crypto.Util.getRandomHexOfNbytes=function(t){var e=new Array(t);return Er.crypto.Util.SECURERANDOMGEN.nextBytes(e),Tr(e)},Er.crypto.Util.getRandomBigIntegerOfNbytes=function(t){return new E(Er.crypto.Util.getRandomHexOfNbytes(t),16)},Er.crypto.Util.getRandomHexOfNbits=function(t){var e=t%8,r=new Array((t-e)/8+1);return Er.crypto.Util.SECURERANDOMGEN.nextBytes(r),r[0]=(255<<e&255^255)&r[0],Tr(r)},Er.crypto.Util.getRandomBigIntegerOfNbits=function(t){return new E(Er.crypto.Util.getRandomHexOfNbits(t),16)},Er.crypto.Util.getRandomBigIntegerZeroToMax=function(t){for(var e=t.bitLength();;){var r=Er.crypto.Util.getRandomBigIntegerOfNbits(e);if(-1!=t.compareTo(r))return r}},Er.crypto.Util.getRandomBigIntegerMinToMax=function(t,e){var r=t.compareTo(e);if(1==r)throw"biMin is greater than biMax";if(0==r)return t;var n=e.subtract(t);return Er.crypto.Util.getRandomBigIntegerZeroToMax(n).add(t)},Er.crypto.MessageDigest=function(t){this.setAlgAndProvider=function(t,e){if(null!==(t=Er.crypto.MessageDigest.getCanonicalAlgName(t))&&void 0===e&&(e=Er.crypto.Util.DEFAULTPROVIDER[t]),-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t)&&"cryptojs"==e){try{this.md=Er.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create()}catch(e){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+e}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=y.enc.Hex.parse(t);this.md.update(e)},this.digest=function(){return this.md.finalize().toString(y.enc.Hex)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}if(-1!=":sha256:".indexOf(t)&&"sjcl"==e){try{this.md=new sjcl.hash.sha256}catch(e){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+e}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=sjcl.codec.hex.toBits(t);this.md.update(e)},this.digest=function(){var t=this.md.finalize();return sjcl.codec.hex.fromBits(t)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digest=function(){throw"digest() not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},void 0!==t&&void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=Er.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName))},Er.crypto.MessageDigest.getCanonicalAlgName=function(t){return"string"==typeof t&&(t=(t=t.toLowerCase()).replace(/-/,"")),t},Er.crypto.MessageDigest.getHashLength=function(t){var e=Er.crypto.MessageDigest,r=e.getCanonicalAlgName(t);if(void 0===e.HASHLENGTH[r])throw"not supported algorithm: "+t;return e.HASHLENGTH[r]},Er.crypto.MessageDigest.HASHLENGTH={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,ripemd160:20},Er.crypto.Mac=function(t){this.setAlgAndProvider=function(t,e){if(null==(t=t.toLowerCase())&&(t="hmacsha1"),"hmac"!=(t=t.toLowerCase()).substr(0,4))throw"setAlgAndProvider unsupported HMAC alg: "+t;void 0===e&&(e=Er.crypto.Util.DEFAULTPROVIDER[t]),this.algProv=t+"/"+e;var r=t.substr(4);if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r)&&"cryptojs"==e){try{var n=Er.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r];this.mac=y.algo.HMAC.create(n,this.pass)}catch(t){throw"setAlgAndProvider hash alg set fail hashAlg="+r+"/"+t}this.updateString=function(t){this.mac.update(t)},this.updateHex=function(t){var e=y.enc.Hex.parse(t);this.mac.update(e)},this.doFinal=function(){return this.mac.finalize().toString(y.enc.Hex)},this.doFinalString=function(t){return this.updateString(t),this.doFinal()},this.doFinalHex=function(t){return this.updateHex(t),this.doFinal()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algProv},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algProv},this.doFinal=function(){throw"digest() not supported for this alg/prov: "+this.algProv},this.doFinalString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algProv},this.doFinalHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algProv},this.setPassword=function(t){if("string"==typeof t){var e=t;return t.length%2!=1&&t.match(/^[0-9A-Fa-f]+$/)||(e=jr(t)),void(this.pass=y.enc.Hex.parse(e))}if("object"!=(void 0===t?"undefined":r(t)))throw"KJUR.crypto.Mac unsupported password type: "+t;e=null;if(void 0!==t.hex){if(t.hex.length%2!=0||!t.hex.match(/^[0-9A-Fa-f]+$/))throw"Mac: wrong hex password: "+t.hex;e=t.hex}if(void 0!==t.utf8&&(e=Br(t.utf8)),void 0!==t.rstr&&(e=jr(t.rstr)),void 0!==t.b64&&(e=b(t.b64)),void 0!==t.b64u&&(e=Ur(t.b64u)),null==e)throw"KJUR.crypto.Mac unsupported password type: "+t;this.pass=y.enc.Hex.parse(e)},void 0!==t&&(void 0!==t.pass&&this.setPassword(t.pass),void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=Er.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName)))},Er.crypto.Signature=function(t){var e=null;if(this._setAlgNames=function(){var t=this.algName.match(/^(.+)with(.+)$/);t&&(this.mdAlgName=t[1].toLowerCase(),this.pubkeyAlgName=t[2].toLowerCase())},this._zeroPaddingOfSignature=function(t,e){for(var r="",n=e/4-t.length,i=0;i<n;i++)r+="0";return r+t},this.setAlgAndProvider=function(t,e){if(this._setAlgNames(),"cryptojs/jsrsa"!=e)throw"provider not supported: "+e;if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)){try{this.md=new Er.crypto.MessageDigest({alg:this.mdAlgName})}catch(t){throw"setAlgAndProvider hash alg set fail alg="+this.mdAlgName+"/"+t}this.init=function(t,e){var r=null;try{r=void 0===e?tn.getKey(t):tn.getKey(t,e)}catch(t){throw"init failed:"+t}if(!0===r.isPrivate)this.prvKey=r,this.state="SIGN";else{if(!0!==r.isPublic)throw"init failed.:"+r;this.pubKey=r,this.state="VERIFY"}},this.updateString=function(t){this.md.updateString(t)},this.updateHex=function(t){this.md.updateHex(t)},this.sign=function(){if(this.sHashHex=this.md.digest(),void 0!==this.ecprvhex&&void 0!==this.eccurvename){var t=new Er.crypto.ECDSA({curve:this.eccurvename});this.hSign=t.signHex(this.sHashHex,this.ecprvhex)}else if(this.prvKey instanceof qe&&"rsaandmgf1"===this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHashPSS(this.sHashHex,this.mdAlgName,this.pssSaltLen);else if(this.prvKey instanceof qe&&"rsa"===this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex,this.mdAlgName);else if(this.prvKey instanceof Er.crypto.ECDSA)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex);else{if(!(this.prvKey instanceof Er.crypto.DSA))throw"Signature: unsupported private key alg: "+this.pubkeyAlgName;this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}return this.hSign},this.signString=function(t){return this.updateString(t),this.sign()},this.signHex=function(t){return this.updateHex(t),this.sign()},this.verify=function(t){if(this.sHashHex=this.md.digest(),void 0!==this.ecpubhex&&void 0!==this.eccurvename)return new Er.crypto.ECDSA({curve:this.eccurvename}).verifyHex(this.sHashHex,t,this.ecpubhex);if(this.pubKey instanceof qe&&"rsaandmgf1"===this.pubkeyAlgName)return this.pubKey.verifyWithMessageHashPSS(this.sHashHex,t,this.mdAlgName,this.pssSaltLen);if(this.pubKey instanceof qe&&"rsa"===this.pubkeyAlgName)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(void 0!==Er.crypto.ECDSA&&this.pubKey instanceof Er.crypto.ECDSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(void 0!==Er.crypto.DSA&&this.pubKey instanceof Er.crypto.DSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}},this.init=function(t,e){throw"init(key, pass) not supported for this alg:prov="+this.algProvName},this.updateString=function(t){throw"updateString(str) not supported for this alg:prov="+this.algProvName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg:prov="+this.algProvName},this.sign=function(){throw"sign() not supported for this alg:prov="+this.algProvName},this.signString=function(t){throw"digestString(str) not supported for this alg:prov="+this.algProvName},this.signHex=function(t){throw"digestHex(hex) not supported for this alg:prov="+this.algProvName},this.verify=function(t){throw"verify(hSigVal) not supported for this alg:prov="+this.algProvName},this.initParams=t,void 0!==t&&(void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov?this.provName=Er.crypto.Util.DEFAULTPROVIDER[this.algName]:this.provName=t.prov,this.algProvName=this.algName+":"+this.provName,this.setAlgAndProvider(this.algName,this.provName),this._setAlgNames()),void 0!==t.psssaltlen&&(this.pssSaltLen=t.psssaltlen),void 0!==t.prvkeypem)){if(void 0!==t.prvkeypas)throw"both prvkeypem and prvkeypas parameters not supported";try{e=tn.getKey(t.prvkeypem);this.init(e)}catch(t){throw"fatal error to load pem private key: "+t}}},Er.crypto.Cipher=function(t){},Er.crypto.Cipher.encrypt=function(t,e,r){if(e instanceof qe&&e.isPublic){var n=Er.crypto.Cipher.getAlgByKeyAndName(e,r);if("RSA"===n)return e.encrypt(t);if("RSAOAEP"===n)return e.encryptOAEP(t,"sha1");var i=n.match(/^RSAOAEP(\d+)$/);if(null!==i)return e.encryptOAEP(t,"sha"+i[1]);throw"Cipher.encrypt: unsupported algorithm for RSAKey: "+r}throw"Cipher.encrypt: unsupported key or algorithm"},Er.crypto.Cipher.decrypt=function(t,e,r){if(e instanceof qe&&e.isPrivate){var n=Er.crypto.Cipher.getAlgByKeyAndName(e,r);if("RSA"===n)return e.decrypt(t);if("RSAOAEP"===n)return e.decryptOAEP(t,"sha1");var i=n.match(/^RSAOAEP(\d+)$/);if(null!==i)return e.decryptOAEP(t,"sha"+i[1]);throw"Cipher.decrypt: unsupported algorithm for RSAKey: "+r}throw"Cipher.decrypt: unsupported key or algorithm"},Er.crypto.Cipher.getAlgByKeyAndName=function(t,e){if(t instanceof qe){if(-1!=":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(e))return e;if(null===e||void 0===e)return"RSA";throw"getAlgByKeyAndName: not supported algorithm name for RSAKey: "+e}throw"getAlgByKeyAndName: not supported algorithm name: "+e},Er.crypto.OID=new function(){this.oidhex2name={"2a864886f70d010101":"rsaEncryption","2a8648ce3d0201":"ecPublicKey","2a8648ce380401":"dsa","2a8648ce3d030107":"secp256r1","2b8104001f":"secp192k1","2b81040021":"secp224r1","2b8104000a":"secp256k1","2b81040023":"secp521r1","2b81040022":"secp384r1","2a8648ce380403":"SHA1withDSA","608648016503040301":"SHA224withDSA","608648016503040302":"SHA256withDSA"}},void 0!==Er&&Er||(e.KJUR=Er={}),void 0!==Er.crypto&&Er.crypto||(Er.crypto={}),Er.crypto.ECDSA=function(t){var e=new Me;this.type="EC",this.isPrivate=!1,this.isPublic=!1,this.getBigRandom=function(t){return new E(t.bitLength(),e).mod(t.subtract(E.ONE)).add(E.ONE)},this.setNamedCurve=function(t){this.ecparams=Er.crypto.ECParameterDB.getByName(t),this.prvKeyHex=null,this.pubKeyHex=null,this.curveName=t},this.setPrivateKeyHex=function(t){this.isPrivate=!0,this.prvKeyHex=t},this.setPublicKeyHex=function(t){this.isPublic=!0,this.pubKeyHex=t},this.getPublicKeyXYHex=function(){var t=this.pubKeyHex;if("04"!==t.substr(0,2))throw"this method supports uncompressed format(04) only";var e=this.ecparams.keylen/4;if(t.length!==2+2*e)throw"malformed public key hex length";var r={};return r.x=t.substr(2,e),r.y=t.substr(2+e),r},this.getShortNISTPCurveName=function(){var t=this.curveName;return"secp256r1"===t||"NIST P-256"===t||"P-256"===t||"prime256v1"===t?"P-256":"secp384r1"===t||"NIST P-384"===t||"P-384"===t?"P-384":null},this.generateKeyPairHex=function(){var t=this.ecparams.n,e=this.getBigRandom(t),r=this.ecparams.G.multiply(e),n=r.getX().toBigInteger(),i=r.getY().toBigInteger(),o=this.ecparams.keylen/4,s=("0000000000"+e.toString(16)).slice(-o),a="04"+("0000000000"+n.toString(16)).slice(-o)+("0000000000"+i.toString(16)).slice(-o);return this.setPrivateKeyHex(s),this.setPublicKeyHex(a),{ecprvhex:s,ecpubhex:a}},this.signWithMessageHash=function(t){return this.signHex(t,this.prvKeyHex)},this.signHex=function(t,e){var r=new E(e,16),n=this.ecparams.n,i=new E(t,16);do{var o=this.getBigRandom(n),s=this.ecparams.G.multiply(o).getX().toBigInteger().mod(n)}while(s.compareTo(E.ZERO)<=0);var a=o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n);return Er.crypto.ECDSA.biRSSigToASN1Sig(s,a)},this.sign=function(t,e){var r=e,n=this.ecparams.n,i=E.fromByteArrayUnsigned(t);do{var o=this.getBigRandom(n),s=this.ecparams.G.multiply(o).getX().toBigInteger().mod(n)}while(s.compareTo(E.ZERO)<=0);var a=o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n);return this.serializeSig(s,a)},this.verifyWithMessageHash=function(t,e){return this.verifyHex(t,e,this.pubKeyHex)},this.verifyHex=function(t,e,r){var n,i,o,s=Er.crypto.ECDSA.parseSigHex(e);n=s.r,i=s.s,o=We.decodeFromHex(this.ecparams.curve,r);var a=new E(t,16);return this.verifyRaw(a,n,i,o)},this.verify=function(t,e,n){var i,o,s;if(Bitcoin.Util.isArray(e)){var a=this.parseSig(e);i=a.r,o=a.s}else{if("object"!==(void 0===e?"undefined":r(e))||!e.r||!e.s)throw"Invalid value for signature";i=e.r,o=e.s}if(n instanceof We)s=n;else{if(!Bitcoin.Util.isArray(n))throw"Invalid format for pubkey value, must be byte array or ECPointFp";s=We.decodeFrom(this.ecparams.curve,n)}var u=E.fromByteArrayUnsigned(t);return this.verifyRaw(u,i,o,s)},this.verifyRaw=function(t,e,r,n){var i=this.ecparams.n,o=this.ecparams.G;if(e.compareTo(E.ONE)<0||e.compareTo(i)>=0)return!1;if(r.compareTo(E.ONE)<0||r.compareTo(i)>=0)return!1;var s=r.modInverse(i),a=t.multiply(s).mod(i),u=e.multiply(s).mod(i);return o.multiply(a).add(n.multiply(u)).getX().toBigInteger().mod(i).equals(e)},this.serializeSig=function(t,e){var r=t.toByteArraySigned(),n=e.toByteArraySigned(),i=[];return i.push(2),i.push(r.length),(i=i.concat(r)).push(2),i.push(n.length),(i=i.concat(n)).unshift(i.length),i.unshift(48),i},this.parseSig=function(t){var e;if(48!=t[0])throw new Error("Signature not a valid DERSequence");if(2!=t[e=2])throw new Error("First element in signature must be a DERInteger");var r=t.slice(e+2,e+2+t[e+1]);if(2!=t[e+=2+t[e+1]])throw new Error("Second element in signature must be a DERInteger");var n=t.slice(e+2,e+2+t[e+1]);return e+=2+t[e+1],{r:E.fromByteArrayUnsigned(r),s:E.fromByteArrayUnsigned(n)}},this.parseSigCompact=function(t){if(65!==t.length)throw"Signature has the wrong length";var e=t[0]-27;if(e<0||e>7)throw"Invalid signature type";var r=this.ecparams.n;return{r:E.fromByteArrayUnsigned(t.slice(1,33)).mod(r),s:E.fromByteArrayUnsigned(t.slice(33,65)).mod(r),i:e}},this.readPKCS5PrvKeyHex=function(t){var e,r,n,i=Ar,o=Er.crypto.ECDSA.getName,s=i.getVbyList;if(!1===i.isASN1HEX(t))throw"not ASN.1 hex string";try{e=s(t,0,[2,0],"06"),r=s(t,0,[1],"04");try{n=s(t,0,[3,0],"03").substr(2)}catch(t){}}catch(t){throw"malformed PKCS#1/5 plain ECC private key"}if(this.curveName=o(e),void 0===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n),this.setPrivateKeyHex(r),this.isPublic=!1},this.readPKCS8PrvKeyHex=function(t){var e,r,n,i=Ar,o=Er.crypto.ECDSA.getName,s=i.getVbyList;if(!1===i.isASN1HEX(t))throw"not ASN.1 hex string";try{s(t,0,[1,0],"06"),e=s(t,0,[1,1],"06"),r=s(t,0,[2,0,1],"04");try{n=s(t,0,[2,0,2,0],"03").substr(2)}catch(t){}}catch(t){throw"malformed PKCS#8 plain ECC private key"}if(this.curveName=o(e),void 0===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n),this.setPrivateKeyHex(r),this.isPublic=!1},this.readPKCS8PubKeyHex=function(t){var e,r,n=Ar,i=Er.crypto.ECDSA.getName,o=n.getVbyList;if(!1===n.isASN1HEX(t))throw"not ASN.1 hex string";try{o(t,0,[0,0],"06"),e=o(t,0,[0,1],"06"),r=o(t,0,[1],"03").substr(2)}catch(t){throw"malformed PKCS#8 ECC public key"}if(this.curveName=i(e),null===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(r)},this.readCertPubKeyHex=function(t,e){5!==e&&(e=6);var r,n,i=Ar,o=Er.crypto.ECDSA.getName,s=i.getVbyList;if(!1===i.isASN1HEX(t))throw"not ASN.1 hex string";try{r=s(t,0,[0,e,0,1],"06"),n=s(t,0,[0,e,1],"03").substr(2)}catch(t){throw"malformed X.509 certificate ECC public key"}if(this.curveName=o(r),null===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n)},void 0!==t&&void 0!==t.curve&&(this.curveName=t.curve),void 0===this.curveName&&(this.curveName="secp256r1"),this.setNamedCurve(this.curveName),void 0!==t&&(void 0!==t.prv&&this.setPrivateKeyHex(t.prv),void 0!==t.pub&&this.setPublicKeyHex(t.pub))},Er.crypto.ECDSA.parseSigHex=function(t){var e=Er.crypto.ECDSA.parseSigHexInHexRS(t);return{r:new E(e.r,16),s:new E(e.s,16)}},Er.crypto.ECDSA.parseSigHexInHexRS=function(t){var e=Ar,r=e.getChildIdx,n=e.getV;if("30"!=t.substr(0,2))throw"signature is not a ASN.1 sequence";var i=r(t,0);if(2!=i.length)throw"number of signature ASN.1 sequence elements seem wrong";var o=i[0],s=i[1];if("02"!=t.substr(o,2))throw"1st item of sequene of signature is not ASN.1 integer";if("02"!=t.substr(s,2))throw"2nd item of sequene of signature is not ASN.1 integer";return{r:n(t,o),s:n(t,s)}},Er.crypto.ECDSA.asn1SigToConcatSig=function(t){var e=Er.crypto.ECDSA.parseSigHexInHexRS(t),r=e.r,n=e.s;if("00"==r.substr(0,2)&&r.length%32==2&&(r=r.substr(2)),"00"==n.substr(0,2)&&n.length%32==2&&(n=n.substr(2)),r.length%32==30&&(r="00"+r),n.length%32==30&&(n="00"+n),r.length%32!=0)throw"unknown ECDSA sig r length error";if(n.length%32!=0)throw"unknown ECDSA sig s length error";return r+n},Er.crypto.ECDSA.concatSigToASN1Sig=function(t){if(t.length/2*8%128!=0)throw"unknown ECDSA concatinated r-s sig  length error";var e=t.substr(0,t.length/2),r=t.substr(t.length/2);return Er.crypto.ECDSA.hexRSSigToASN1Sig(e,r)},Er.crypto.ECDSA.hexRSSigToASN1Sig=function(t,e){var r=new E(t,16),n=new E(e,16);return Er.crypto.ECDSA.biRSSigToASN1Sig(r,n)},Er.crypto.ECDSA.biRSSigToASN1Sig=function(t,e){var r=Er.asn1,n=new r.DERInteger({bigint:t}),i=new r.DERInteger({bigint:e});return new r.DERSequence({array:[n,i]}).getEncodedHex()},Er.crypto.ECDSA.getName=function(t){return"2a8648ce3d030107"===t?"secp256r1":"2b8104000a"===t?"secp256k1":"2b81040022"===t?"secp384r1":-1!=="|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(t)?"secp256r1":-1!=="|secp256k1|".indexOf(t)?"secp256k1":-1!=="|secp384r1|NIST P-384|P-384|".indexOf(t)?"secp384r1":null},void 0!==Er&&Er||(e.KJUR=Er={}),void 0!==Er.crypto&&Er.crypto||(Er.crypto={}),Er.crypto.ECParameterDB=new function(){var t={},e={};function r(t){return new E(t,16)}this.getByName=function(r){var n=r;if(void 0!==e[n]&&(n=e[r]),void 0!==t[n])return t[n];throw"unregistered EC curve name: "+n},this.regist=function(n,i,o,s,a,u,c,h,l,f,d,p){t[n]={};var g=r(o),v=r(s),y=r(a),m=r(u),_=r(c),S=new ze(g,v,y),F=S.decodePointHex("04"+h+l);t[n].name=n,t[n].keylen=i,t[n].curve=S,t[n].G=F,t[n].n=m,t[n].h=_,t[n].oid=d,t[n].info=p;for(var b=0;b<f.length;b++)e[f[b]]=n}},Er.crypto.ECParameterDB.regist("secp128r1",128,"FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC","E87579C11079F43DD824993C2CEE5ED3","FFFFFFFE0000000075A30D1B9038A115","1","161FF7528B899B2D0C28607CA52C5B86","CF5AC8395BAFEB13C02DA292DDED7A83",[],"","secp128r1 : SECG curve over a 128 bit prime field"),Er.crypto.ECParameterDB.regist("secp160k1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73","0","7","0100000000000000000001B8FA16DFAB9ACA16B6B3","1","3B4C382CE37AA192A4019E763036F4F5DD4D7EBB","938CF935318FDCED6BC28286531733C3F03C4FEE",[],"","secp160k1 : SECG curve over a 160 bit prime field"),Er.crypto.ECParameterDB.regist("secp160r1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC","1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45","0100000000000000000001F4C8F927AED3CA752257","1","4A96B5688EF573284664698968C38BB913CBFC82","23A628553168947D59DCC912042351377AC5FB32",[],"","secp160r1 : SECG curve over a 160 bit prime field"),Er.crypto.ECParameterDB.regist("secp192k1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37","0","3","FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D","1","DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D","9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D",[]),Er.crypto.ECParameterDB.regist("secp192r1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC","64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1","FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831","1","188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012","07192B95FFC8DA78631011ED6B24CDD573F977A11E794811",[]),Er.crypto.ECParameterDB.regist("secp224r1",224,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE","B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4","FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D","1","B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21","BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34",[]),Er.crypto.ECParameterDB.regist("secp256k1",256,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F","0","7","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141","1","79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798","483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8",[]),Er.crypto.ECParameterDB.regist("secp256r1",256,"FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC","5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B","FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551","1","6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296","4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5",["NIST P-256","P-256","prime256v1"]),Er.crypto.ECParameterDB.regist("secp384r1",384,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC","B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973","1","AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7","3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f",["NIST P-384","P-384"]),Er.crypto.ECParameterDB.regist("secp521r1",521,"1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC","051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409","1","C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650",["NIST P-521","P-521"]);var tn=function(){var t=function t(r,n,i){return e(y.AES,r,n,i)},e=function t(e,r,n,i){var o=y.enc.Hex.parse(r),s=y.enc.Hex.parse(n),a=y.enc.Hex.parse(i),u={};u.key=s,u.iv=a,u.ciphertext=o;var c=e.decrypt(u,s,{iv:a});return y.enc.Hex.stringify(c)},r=function t(e,r,i){return n(y.AES,e,r,i)},n=function t(e,r,n,i){var o=y.enc.Hex.parse(r),s=y.enc.Hex.parse(n),a=y.enc.Hex.parse(i),u=e.encrypt(o,s,{iv:a}),c=y.enc.Hex.parse(u.toString());return y.enc.Base64.stringify(c)},i={"AES-256-CBC":{proc:t,eproc:r,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:r,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:r,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:function t(r,n,i){return e(y.TripleDES,r,n,i)},eproc:function t(e,r,i){return n(y.TripleDES,e,r,i)},keylen:24,ivlen:8},"DES-CBC":{proc:function t(r,n,i){return e(y.DES,r,n,i)},eproc:function t(e,r,i){return n(y.DES,e,r,i)},keylen:8,ivlen:8}},o=function t(e){var r={},n=e.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"));n&&(r.cipher=n[1],r.ivsalt=n[2]);var i=e.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));i&&(r.type=i[1]);var o=-1,s=0;-1!=e.indexOf("\r\n\r\n")&&(o=e.indexOf("\r\n\r\n"),s=2),-1!=e.indexOf("\n\n")&&(o=e.indexOf("\n\n"),s=1);var a=e.indexOf("-----END");if(-1!=o&&-1!=a){var u=e.substring(o+2*s,a-s);u=u.replace(/\s+/g,""),r.data=u}return r},s=function t(e,r,n){for(var o=n.substring(0,16),s=y.enc.Hex.parse(o),a=y.enc.Utf8.parse(r),u=i[e].keylen+i[e].ivlen,c="",h=null;;){var l=y.algo.MD5.create();if(null!=h&&l.update(h),l.update(a),l.update(s),h=l.finalize(),(c+=y.enc.Hex.stringify(h)).length>=2*u)break}var f={};return f.keyhex=c.substr(0,2*i[e].keylen),f.ivhex=c.substr(2*i[e].keylen,2*i[e].ivlen),f},a=function t(e,r,n,o){var s=y.enc.Base64.parse(e),a=y.enc.Hex.stringify(s);return(0,i[r].proc)(a,n,o)};return{version:"1.0.0",parsePKCS5PEM:function t(e){return o(e)},getKeyAndUnusedIvByPasscodeAndIvsalt:function t(e,r,n){return s(e,r,n)},decryptKeyB64:function t(e,r,n,i){return a(e,r,n,i)},getDecryptedKeyHex:function t(e,r){var n=o(e),i=(n.type,n.cipher),u=n.ivsalt,c=n.data,h=s(i,r,u).keyhex;return a(c,i,h,u)},getEncryptedPKCS5PEMFromPrvKeyHex:function t(e,r,n,o,a){var u="";if(void 0!==o&&null!=o||(o="AES-256-CBC"),void 0===i[o])throw"KEYUTIL unsupported algorithm: "+o;void 0!==a&&null!=a||(a=function t(e){var r=y.lib.WordArray.random(e);return y.enc.Hex.stringify(r)}(i[o].ivlen).toUpperCase());var c=function t(e,r,n,o){return(0,i[r].eproc)(e,n,o)}(r,o,s(o,n,a).keyhex,a);u="-----BEGIN "+e+" PRIVATE KEY-----\r\n";return u+="Proc-Type: 4,ENCRYPTED\r\n",u+="DEK-Info: "+o+","+a+"\r\n",u+="\r\n",u+=c.replace(/(.{64})/g,"$1\r\n"),u+="\r\n-----END "+e+" PRIVATE KEY-----\r\n"},parseHexOfEncryptedPKCS8:function t(e){var r=Ar,n=r.getChildIdx,i=r.getV,o={},s=n(e,0);if(2!=s.length)throw"malformed format: SEQUENCE(0).items != 2: "+s.length;o.ciphertext=i(e,s[1]);var a=n(e,s[0]);if(2!=a.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+a.length;if("2a864886f70d01050d"!=i(e,a[0]))throw"this only supports pkcs5PBES2";var u=n(e,a[1]);if(2!=a.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+u.length;var c=n(e,u[1]);if(2!=c.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+c.length;if("2a864886f70d0307"!=i(e,c[0]))throw"this only supports TripleDES";o.encryptionSchemeAlg="TripleDES",o.encryptionSchemeIV=i(e,c[1]);var h=n(e,u[0]);if(2!=h.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+h.length;if("2a864886f70d01050c"!=i(e,h[0]))throw"this only supports pkcs5PBKDF2";var l=n(e,h[1]);if(l.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+l.length;o.pbkdf2Salt=i(e,l[0]);var f=i(e,l[1]);try{o.pbkdf2Iter=parseInt(f,16)}catch(t){throw"malformed format pbkdf2Iter: "+f}return o},getPBKDF2KeyHexFromParam:function t(e,r){var n=y.enc.Hex.parse(e.pbkdf2Salt),i=e.pbkdf2Iter,o=y.PBKDF2(r,n,{keySize:6,iterations:i});return y.enc.Hex.stringify(o)},_getPlainPKCS8HexFromEncryptedPKCS8PEM:function t(e,r){var n=qr(e,"ENCRYPTED PRIVATE KEY"),i=this.parseHexOfEncryptedPKCS8(n),o=tn.getPBKDF2KeyHexFromParam(i,r),s={};s.ciphertext=y.enc.Hex.parse(i.ciphertext);var a=y.enc.Hex.parse(o),u=y.enc.Hex.parse(i.encryptionSchemeIV),c=y.TripleDES.decrypt(s,a,{iv:u});return y.enc.Hex.stringify(c)},getKeyFromEncryptedPKCS8PEM:function t(e,r){var n=this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e,r);return this.getKeyFromPlainPrivatePKCS8Hex(n)},parsePlainPrivatePKCS8Hex:function t(e){var r=Ar,n=r.getChildIdx,i=r.getV,o={algparam:null};if("30"!=e.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var s=n(e,0);if(3!=s.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=e.substr(s[1],2))throw"malformed PKCS8 private key(code:003)";var a=n(e,s[1]);if(2!=a.length)throw"malformed PKCS8 private key(code:004)";if("06"!=e.substr(a[0],2))throw"malformed PKCS8 private key(code:005)";if(o.algoid=i(e,a[0]),"06"==e.substr(a[1],2)&&(o.algparam=i(e,a[1])),"04"!=e.substr(s[2],2))throw"malformed PKCS8 private key(code:006)";return o.keyidx=r.getVidx(e,s[2]),o},getKeyFromPlainPrivatePKCS8PEM:function t(e){var r=qr(e,"PRIVATE KEY");return this.getKeyFromPlainPrivatePKCS8Hex(r)},getKeyFromPlainPrivatePKCS8Hex:function t(e){var r,n=this.parsePlainPrivatePKCS8Hex(e);if("2a864886f70d010101"==n.algoid)r=new qe;else if("2a8648ce380401"==n.algoid)r=new Er.crypto.DSA;else{if("2a8648ce3d0201"!=n.algoid)throw"unsupported private key algorithm";r=new Er.crypto.ECDSA}return r.readPKCS8PrvKeyHex(e),r},_getKeyFromPublicPKCS8Hex:function t(e){var r,n=Ar.getVbyList(e,0,[0,0],"06");if("2a864886f70d010101"===n)r=new qe;else if("2a8648ce380401"===n)r=new Er.crypto.DSA;else{if("2a8648ce3d0201"!==n)throw"unsupported PKCS#8 public key hex";r=new Er.crypto.ECDSA}return r.readPKCS8PubKeyHex(e),r},parsePublicRawRSAKeyHex:function t(e){var r=Ar,n=r.getChildIdx,i=r.getV,o={};if("30"!=e.substr(0,2))throw"malformed RSA key(code:001)";var s=n(e,0);if(2!=s.length)throw"malformed RSA key(code:002)";if("02"!=e.substr(s[0],2))throw"malformed RSA key(code:003)";if(o.n=i(e,s[0]),"02"!=e.substr(s[1],2))throw"malformed RSA key(code:004)";return o.e=i(e,s[1]),o},parsePublicPKCS8Hex:function t(e){var r=Ar,n=r.getChildIdx,i=r.getV,o={algparam:null},s=n(e,0);if(2!=s.length)throw"outer DERSequence shall have 2 elements: "+s.length;var a=s[0];if("30"!=e.substr(a,2))throw"malformed PKCS8 public key(code:001)";var u=n(e,a);if(2!=u.length)throw"malformed PKCS8 public key(code:002)";if("06"!=e.substr(u[0],2))throw"malformed PKCS8 public key(code:003)";if(o.algoid=i(e,u[0]),"06"==e.substr(u[1],2)?o.algparam=i(e,u[1]):"30"==e.substr(u[1],2)&&(o.algparam={},o.algparam.p=r.getVbyList(e,u[1],[0],"02"),o.algparam.q=r.getVbyList(e,u[1],[1],"02"),o.algparam.g=r.getVbyList(e,u[1],[2],"02")),"03"!=e.substr(s[1],2))throw"malformed PKCS8 public key(code:004)";return o.key=i(e,s[1]).substr(2),o}}}();tn.getKey=function(t,e,r){var n=(v=Ar).getChildIdx,i=(v.getV,v.getVbyList),o=Er.crypto,s=o.ECDSA,a=o.DSA,u=qe,c=qr,h=tn;if(void 0!==u&&t instanceof u)return t;if(void 0!==s&&t instanceof s)return t;if(void 0!==a&&t instanceof a)return t;if(void 0!==t.curve&&void 0!==t.xy&&void 0===t.d)return new s({pub:t.xy,curve:t.curve});if(void 0!==t.curve&&void 0!==t.d)return new s({prv:t.d,curve:t.curve});if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d)return(P=new u).setPublic(t.n,t.e),P;if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.co&&void 0===t.qi)return(P=new u).setPrivateEx(t.n,t.e,t.d,t.p,t.q,t.dp,t.dq,t.co),P;if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0===t.p)return(P=new u).setPrivate(t.n,t.e,t.d),P;if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0===t.x)return(P=new a).setPublic(t.p,t.q,t.g,t.y),P;if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0!==t.x)return(P=new a).setPrivate(t.p,t.q,t.g,t.y,t.x),P;if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d)return(P=new u).setPublic(Ur(t.n),Ur(t.e)),P;if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.qi)return(P=new u).setPrivateEx(Ur(t.n),Ur(t.e),Ur(t.d),Ur(t.p),Ur(t.q),Ur(t.dp),Ur(t.dq),Ur(t.qi)),P;if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d)return(P=new u).setPrivate(Ur(t.n),Ur(t.e),Ur(t.d)),P;if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0===t.d){var l=(A=new s({curve:t.crv})).ecparams.keylen/4,f="04"+("0000000000"+Ur(t.x)).slice(-l)+("0000000000"+Ur(t.y)).slice(-l);return A.setPublicKeyHex(f),A}if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0!==t.d){l=(A=new s({curve:t.crv})).ecparams.keylen/4,f="04"+("0000000000"+Ur(t.x)).slice(-l)+("0000000000"+Ur(t.y)).slice(-l);var d=("0000000000"+Ur(t.d)).slice(-l);return A.setPublicKeyHex(f),A.setPrivateKeyHex(d),A}if("pkcs5prv"===r){var p,g=t,v=Ar;if(9===(p=n(g,0)).length)(P=new u).readPKCS5PrvKeyHex(g);else if(6===p.length)(P=new a).readPKCS5PrvKeyHex(g);else{if(!(p.length>2&&"04"===g.substr(p[1],2)))throw"unsupported PKCS#1/5 hexadecimal key";(P=new s).readPKCS5PrvKeyHex(g)}return P}if("pkcs8prv"===r)return P=h.getKeyFromPlainPrivatePKCS8Hex(t);if("pkcs8pub"===r)return h._getKeyFromPublicPKCS8Hex(t);if("x509pub"===r)return sn.getPublicKeyFromCertHex(t);if(-1!=t.indexOf("-END CERTIFICATE-",0)||-1!=t.indexOf("-END X509 CERTIFICATE-",0)||-1!=t.indexOf("-END TRUSTED CERTIFICATE-",0))return sn.getPublicKeyFromCertPEM(t);if(-1!=t.indexOf("-END PUBLIC KEY-")){var y=qr(t,"PUBLIC KEY");return h._getKeyFromPublicPKCS8Hex(y)}if(-1!=t.indexOf("-END RSA PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){var m=c(t,"RSA PRIVATE KEY");return h.getKey(m,null,"pkcs5prv")}if(-1!=t.indexOf("-END DSA PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){var _=i(R=c(t,"DSA PRIVATE KEY"),0,[1],"02"),S=i(R,0,[2],"02"),F=i(R,0,[3],"02"),b=i(R,0,[4],"02"),w=i(R,0,[5],"02");return(P=new a).setPrivate(new E(_,16),new E(S,16),new E(F,16),new E(b,16),new E(w,16)),P}if(-1!=t.indexOf("-END PRIVATE KEY-"))return h.getKeyFromPlainPrivatePKCS8PEM(t);if(-1!=t.indexOf("-END RSA PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var x=h.getDecryptedKeyHex(t,e),k=new qe;return k.readPKCS5PrvKeyHex(x),k}if(-1!=t.indexOf("-END EC PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var A,P=i(R=h.getDecryptedKeyHex(t,e),0,[1],"04"),C=i(R,0,[2,0],"06"),T=i(R,0,[3,0],"03").substr(2);if(void 0===Er.crypto.OID.oidhex2name[C])throw"undefined OID(hex) in KJUR.crypto.OID: "+C;return(A=new s({curve:Er.crypto.OID.oidhex2name[C]})).setPublicKeyHex(T),A.setPrivateKeyHex(P),A.isPublic=!1,A}if(-1!=t.indexOf("-END DSA PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var R;_=i(R=h.getDecryptedKeyHex(t,e),0,[1],"02"),S=i(R,0,[2],"02"),F=i(R,0,[3],"02"),b=i(R,0,[4],"02"),w=i(R,0,[5],"02");return(P=new a).setPrivate(new E(_,16),new E(S,16),new E(F,16),new E(b,16),new E(w,16)),P}if(-1!=t.indexOf("-END ENCRYPTED PRIVATE KEY-"))return h.getKeyFromEncryptedPKCS8PEM(t,e);throw"not supported argument"},tn.generateKeypair=function(t,e){if("RSA"==t){var r=e;(s=new qe).generate(r,"10001"),s.isPrivate=!0,s.isPublic=!0;var n=new qe,i=s.n.toString(16),o=s.e.toString(16);return n.setPublic(i,o),n.isPrivate=!1,n.isPublic=!0,(a={}).prvKeyObj=s,a.pubKeyObj=n,a}if("EC"==t){var s,a,u=e,c=new Er.crypto.ECDSA({curve:u}).generateKeyPairHex();return(s=new Er.crypto.ECDSA({curve:u})).setPublicKeyHex(c.ecpubhex),s.setPrivateKeyHex(c.ecprvhex),s.isPrivate=!0,s.isPublic=!1,(n=new Er.crypto.ECDSA({curve:u})).setPublicKeyHex(c.ecpubhex),n.isPrivate=!1,n.isPublic=!0,(a={}).prvKeyObj=s,a.pubKeyObj=n,a}throw"unknown algorithm: "+t},tn.getPEM=function(t,e,r,n,i,o){var s=Er,a=s.asn1,u=a.DERObjectIdentifier,c=a.DERInteger,h=a.ASN1Util.newObject,l=a.x509.SubjectPublicKeyInfo,f=s.crypto,d=f.DSA,p=f.ECDSA,g=qe;function v(t){return h({seq:[{int:0},{int:{bigint:t.n}},{int:t.e},{int:{bigint:t.d}},{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.dmp1}},{int:{bigint:t.dmq1}},{int:{bigint:t.coeff}}]})}function m(t){return h({seq:[{int:1},{octstr:{hex:t.prvKeyHex}},{tag:["a0",!0,{oid:{name:t.curveName}}]},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]})}function _(t){return h({seq:[{int:0},{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}},{int:{bigint:t.y}},{int:{bigint:t.x}}]})}if((void 0!==g&&t instanceof g||void 0!==d&&t instanceof d||void 0!==p&&t instanceof p)&&1==t.isPublic&&(void 0===e||"PKCS8PUB"==e))return Vr(w=new l(t).getEncodedHex(),"PUBLIC KEY");if("PKCS1PRV"==e&&void 0!==g&&t instanceof g&&(void 0===r||null==r)&&1==t.isPrivate)return Vr(w=v(t).getEncodedHex(),"RSA PRIVATE KEY");if("PKCS1PRV"==e&&void 0!==p&&t instanceof p&&(void 0===r||null==r)&&1==t.isPrivate){var S=new u({name:t.curveName}).getEncodedHex(),F=m(t).getEncodedHex(),b="";return b+=Vr(S,"EC PARAMETERS"),b+=Vr(F,"EC PRIVATE KEY")}if("PKCS1PRV"==e&&void 0!==d&&t instanceof d&&(void 0===r||null==r)&&1==t.isPrivate)return Vr(w=_(t).getEncodedHex(),"DSA PRIVATE KEY");if("PKCS5PRV"==e&&void 0!==g&&t instanceof g&&void 0!==r&&null!=r&&1==t.isPrivate){var w=v(t).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",w,r,n,o)}if("PKCS5PRV"==e&&void 0!==p&&t instanceof p&&void 0!==r&&null!=r&&1==t.isPrivate){w=m(t).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("EC",w,r,n,o)}if("PKCS5PRV"==e&&void 0!==d&&t instanceof d&&void 0!==r&&null!=r&&1==t.isPrivate){w=_(t).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA",w,r,n,o)}var E=function t(e,r){var n=x(e,r);return new h({seq:[{seq:[{oid:{name:"pkcs5PBES2"}},{seq:[{seq:[{oid:{name:"pkcs5PBKDF2"}},{seq:[{octstr:{hex:n.pbkdf2Salt}},{int:n.pbkdf2Iter}]}]},{seq:[{oid:{name:"des-EDE3-CBC"}},{octstr:{hex:n.encryptionSchemeIV}}]}]}]},{octstr:{hex:n.ciphertext}}]}).getEncodedHex()},x=function t(e,r){var n=y.lib.WordArray.random(8),i=y.lib.WordArray.random(8),o=y.PBKDF2(r,n,{keySize:6,iterations:100}),s=y.enc.Hex.parse(e),a=y.TripleDES.encrypt(s,o,{iv:i})+"",u={};return u.ciphertext=a,u.pbkdf2Salt=y.enc.Hex.stringify(n),u.pbkdf2Iter=100,u.encryptionSchemeAlg="DES-EDE3-CBC",u.encryptionSchemeIV=y.enc.Hex.stringify(i),u};if("PKCS8PRV"==e&&void 0!=g&&t instanceof g&&1==t.isPrivate){var k=v(t).getEncodedHex();w=h({seq:[{int:0},{seq:[{oid:{name:"rsaEncryption"}},{null:!0}]},{octstr:{hex:k}}]}).getEncodedHex();return void 0===r||null==r?Vr(w,"PRIVATE KEY"):Vr(F=E(w,r),"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&void 0!==p&&t instanceof p&&1==t.isPrivate){k=new h({seq:[{int:1},{octstr:{hex:t.prvKeyHex}},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]}).getEncodedHex(),w=h({seq:[{int:0},{seq:[{oid:{name:"ecPublicKey"}},{oid:{name:t.curveName}}]},{octstr:{hex:k}}]}).getEncodedHex();return void 0===r||null==r?Vr(w,"PRIVATE KEY"):Vr(F=E(w,r),"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&void 0!==d&&t instanceof d&&1==t.isPrivate){k=new c({bigint:t.x}).getEncodedHex(),w=h({seq:[{int:0},{seq:[{oid:{name:"dsa"}},{seq:[{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}}]}]},{octstr:{hex:k}}]}).getEncodedHex();return void 0===r||null==r?Vr(w,"PRIVATE KEY"):Vr(F=E(w,r),"ENCRYPTED PRIVATE KEY")}throw"unsupported object nor format"},tn.getKeyFromCSRPEM=function(t){var e=qr(t,"CERTIFICATE REQUEST");return tn.getKeyFromCSRHex(e)},tn.getKeyFromCSRHex=function(t){var e=tn.parseCSRHex(t);return tn.getKey(e.p8pubkeyhex,null,"pkcs8pub")},tn.parseCSRHex=function(t){var e=Ar,r=e.getChildIdx,n=e.getTLV,i={},o=t;if("30"!=o.substr(0,2))throw"malformed CSR(code:001)";var s=r(o,0);if(s.length<1)throw"malformed CSR(code:002)";if("30"!=o.substr(s[0],2))throw"malformed CSR(code:003)";var a=r(o,s[0]);if(a.length<3)throw"malformed CSR(code:004)";return i.p8pubkeyhex=n(o,a[2]),i},tn.getJWKFromKey=function(t){var e={};if(t instanceof qe&&t.isPrivate)return e.kty="RSA",e.n=Lr(t.n.toString(16)),e.e=Lr(t.e.toString(16)),e.d=Lr(t.d.toString(16)),e.p=Lr(t.p.toString(16)),e.q=Lr(t.q.toString(16)),e.dp=Lr(t.dmp1.toString(16)),e.dq=Lr(t.dmq1.toString(16)),e.qi=Lr(t.coeff.toString(16)),e;if(t instanceof qe&&t.isPublic)return e.kty="RSA",e.n=Lr(t.n.toString(16)),e.e=Lr(t.e.toString(16)),e;if(t instanceof Er.crypto.ECDSA&&t.isPrivate){if("P-256"!==(n=t.getShortNISTPCurveName())&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;var r=t.getPublicKeyXYHex();return e.kty="EC",e.crv=n,e.x=Lr(r.x),e.y=Lr(r.y),e.d=Lr(t.prvKeyHex),e}if(t instanceof Er.crypto.ECDSA&&t.isPublic){var n;if("P-256"!==(n=t.getShortNISTPCurveName())&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;r=t.getPublicKeyXYHex();return e.kty="EC",e.crv=n,e.x=Lr(r.x),e.y=Lr(r.y),e}throw"not supported key object"},qe.getPosArrayOfChildrenFromHex=function(t){return Ar.getChildIdx(t,0)},qe.getHexValueArrayOfChildrenFromHex=function(t){var e,r=Ar.getV,n=r(t,(e=qe.getPosArrayOfChildrenFromHex(t))[0]),i=r(t,e[1]),o=r(t,e[2]),s=r(t,e[3]),a=r(t,e[4]),u=r(t,e[5]),c=r(t,e[6]),h=r(t,e[7]),l=r(t,e[8]);return(e=new Array).push(n,i,o,s,a,u,c,h,l),e},qe.prototype.readPrivateKeyFromPEMString=function(t){var e=qr(t),r=qe.getHexValueArrayOfChildrenFromHex(e);this.setPrivateEx(r[1],r[2],r[3],r[4],r[5],r[6],r[7],r[8])},qe.prototype.readPKCS5PrvKeyHex=function(t){var e=qe.getHexValueArrayOfChildrenFromHex(t);this.setPrivateEx(e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8])},qe.prototype.readPKCS8PrvKeyHex=function(t){var e,r,n,i,o,s,a,u,c=Ar,h=c.getVbyList;if(!1===c.isASN1HEX(t))throw"not ASN.1 hex string";try{e=h(t,0,[2,0,1],"02"),r=h(t,0,[2,0,2],"02"),n=h(t,0,[2,0,3],"02"),i=h(t,0,[2,0,4],"02"),o=h(t,0,[2,0,5],"02"),s=h(t,0,[2,0,6],"02"),a=h(t,0,[2,0,7],"02"),u=h(t,0,[2,0,8],"02")}catch(t){throw"malformed PKCS#8 plain RSA private key"}this.setPrivateEx(e,r,n,i,o,s,a,u)},qe.prototype.readPKCS5PubKeyHex=function(t){var e=Ar,r=e.getV;if(!1===e.isASN1HEX(t))throw"keyHex is not ASN.1 hex string";var n=e.getChildIdx(t,0);if(2!==n.length||"02"!==t.substr(n[0],2)||"02"!==t.substr(n[1],2))throw"wrong hex for PKCS#5 public key";var i=r(t,n[0]),o=r(t,n[1]);this.setPublic(i,o)},qe.prototype.readPKCS8PubKeyHex=function(t){var e=Ar;if(!1===e.isASN1HEX(t))throw"not ASN.1 hex string";if("06092a864886f70d010101"!==e.getTLVbyList(t,0,[0,0]))throw"not PKCS8 RSA public key";var r=e.getTLVbyList(t,0,[1,0]);this.readPKCS5PubKeyHex(r)},qe.prototype.readCertPubKeyHex=function(t,e){var r,n;(r=new sn).readCertHex(t),n=r.getPublicKeyHex(),this.readPKCS8PubKeyHex(n)};var en=new RegExp("");function rn(t,e){for(var r="",n=e/4-t.length,i=0;i<n;i++)r+="0";return r+t}function nn(t,e,r){for(var n="",i=0;n.length<e;)n+=Or(r(jr(t+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])))),i+=1;return n}function on(t){for(var e in Er.crypto.Util.DIGESTINFOHEAD){var r=Er.crypto.Util.DIGESTINFOHEAD[e],n=r.length;if(t.substring(0,n)==r)return[e,t.substring(n)]}return[]}function sn(){var t=Ar,e=t.getChildIdx,r=t.getV,n=t.getTLV,i=t.getVbyList,o=t.getTLVbyList,s=t.getIdxbyList,a=t.getVidx,u=t.oidname,c=sn,h=qr;this.hex=null,this.version=0,this.foffset=0,this.aExtInfo=null,this.getVersion=function(){return null===this.hex||0!==this.version?this.version:"a003020102"!==o(this.hex,0,[0,0])?(this.version=1,this.foffset=-1,1):(this.version=3,3)},this.getSerialNumberHex=function(){return i(this.hex,0,[0,1+this.foffset],"02")},this.getSignatureAlgorithmField=function(){return u(i(this.hex,0,[0,2+this.foffset,0],"06"))},this.getIssuerHex=function(){return o(this.hex,0,[0,3+this.foffset],"30")},this.getIssuerString=function(){return c.hex2dn(this.getIssuerHex())},this.getSubjectHex=function(){return o(this.hex,0,[0,5+this.foffset],"30")},this.getSubjectString=function(){return c.hex2dn(this.getSubjectHex())},this.getNotBefore=function(){var t=i(this.hex,0,[0,4+this.foffset,0]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.getNotAfter=function(){var t=i(this.hex,0,[0,4+this.foffset,1]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.getPublicKeyHex=function(){return t.getTLVbyList(this.hex,0,[0,6+this.foffset],"30")},this.getPublicKeyIdx=function(){return s(this.hex,0,[0,6+this.foffset],"30")},this.getPublicKeyContentIdx=function(){var t=this.getPublicKeyIdx();return s(this.hex,t,[1,0],"30")},this.getPublicKey=function(){return tn.getKey(this.getPublicKeyHex(),null,"pkcs8pub")},this.getSignatureAlgorithmName=function(){return u(i(this.hex,0,[1,0],"06"))},this.getSignatureValueHex=function(){return i(this.hex,0,[2],"03",!0)},this.verifySignature=function(t){var e=this.getSignatureAlgorithmName(),r=this.getSignatureValueHex(),n=o(this.hex,0,[0],"30"),i=new Er.crypto.Signature({alg:e});return i.init(t),i.updateHex(n),i.verify(r)},this.parseExt=function(){if(3!==this.version)return-1;var r=s(this.hex,0,[0,7,0],"30"),n=e(this.hex,r);this.aExtInfo=new Array;for(var o=0;o<n.length;o++){var u={critical:!1},c=0;3===e(this.hex,n[o]).length&&(u.critical=!0,c=1),u.oid=t.hextooidstr(i(this.hex,n[o],[0],"06"));var h=s(this.hex,n[o],[1+c]);u.vidx=a(this.hex,h),this.aExtInfo.push(u)}},this.getExtInfo=function(t){var e=this.aExtInfo,r=t;if(t.match(/^[0-9.]+$/)||(r=Er.asn1.x509.OID.name2oid(t)),""!==r)for(var n=0;n<e.length;n++)if(e[n].oid===r)return e[n]},this.getExtBasicConstraints=function(){var t=this.getExtInfo("basicConstraints");if(void 0===t)return t;var e=r(this.hex,t.vidx);if(""===e)return{};if("0101ff"===e)return{cA:!0};if("0101ff02"===e.substr(0,8)){var n=r(e,6);return{cA:!0,pathLen:parseInt(n,16)}}throw"basicConstraints parse error"},this.getExtKeyUsageBin=function(){var t=this.getExtInfo("keyUsage");if(void 0===t)return"";var e=r(this.hex,t.vidx);if(e.length%2!=0||e.length<=2)throw"malformed key usage value";var n=parseInt(e.substr(0,2)),i=parseInt(e.substr(2),16).toString(2);return i.substr(0,i.length-n)},this.getExtKeyUsageString=function(){for(var t=this.getExtKeyUsageBin(),e=new Array,r=0;r<t.length;r++)"1"==t.substr(r,1)&&e.push(sn.KEYUSAGE_NAME[r]);return e.join(",")},this.getExtSubjectKeyIdentifier=function(){var t=this.getExtInfo("subjectKeyIdentifier");return void 0===t?t:r(this.hex,t.vidx)},this.getExtAuthorityKeyIdentifier=function(){var t=this.getExtInfo("authorityKeyIdentifier");if(void 0===t)return t;for(var i={},o=n(this.hex,t.vidx),s=e(o,0),a=0;a<s.length;a++)"80"===o.substr(s[a],2)&&(i.kid=r(o,s[a]));return i},this.getExtExtKeyUsageName=function(){var t=this.getExtInfo("extKeyUsage");if(void 0===t)return t;var i=new Array,o=n(this.hex,t.vidx);if(""===o)return i;for(var s=e(o,0),a=0;a<s.length;a++)i.push(u(r(o,s[a])));return i},this.getExtSubjectAltName=function(){for(var t=this.getExtSubjectAltName2(),e=new Array,r=0;r<t.length;r++)"DNS"===t[r][0]&&e.push(t[r][1]);return e},this.getExtSubjectAltName2=function(){var t,i,o,s=this.getExtInfo("subjectAltName");if(void 0===s)return s;for(var a=new Array,u=n(this.hex,s.vidx),c=e(u,0),h=0;h<c.length;h++)o=u.substr(c[h],2),t=r(u,c[h]),"81"===o&&(i=Nr(t),a.push(["MAIL",i])),"82"===o&&(i=Nr(t),a.push(["DNS",i])),"84"===o&&(i=sn.hex2dn(t,0),a.push(["DN",i])),"86"===o&&(i=Nr(t),a.push(["URI",i])),"87"===o&&(i=Qr(t),a.push(["IP",i]));return a},this.getExtCRLDistributionPointsURI=function(){var t=this.getExtInfo("cRLDistributionPoints");if(void 0===t)return t;for(var r=new Array,n=e(this.hex,t.vidx),o=0;o<n.length;o++)try{var s=Nr(i(this.hex,n[o],[0,0,0],"86"));r.push(s)}catch(t){}return r},this.getExtAIAInfo=function(){var t=this.getExtInfo("authorityInfoAccess");if(void 0===t)return t;for(var r={ocsp:[],caissuer:[]},n=e(this.hex,t.vidx),o=0;o<n.length;o++){var s=i(this.hex,n[o],[0],"06"),a=i(this.hex,n[o],[1],"86");"2b06010505073001"===s&&r.ocsp.push(Nr(a)),"2b06010505073002"===s&&r.caissuer.push(Nr(a))}return r},this.getExtCertificatePolicies=function(){var t=this.getExtInfo("certificatePolicies");if(void 0===t)return t;for(var o=n(this.hex,t.vidx),s=[],a=e(o,0),c=0;c<a.length;c++){var h={},l=e(o,a[c]);if(h.id=u(r(o,l[0])),2===l.length)for(var f=e(o,l[1]),d=0;d<f.length;d++){var p=i(o,f[d],[0],"06");"2b06010505070201"===p?h.cps=Nr(i(o,f[d],[1])):"2b06010505070202"===p&&(h.unotice=Nr(i(o,f[d],[1,0])))}s.push(h)}return s},this.readCertPEM=function(t){this.readCertHex(h(t))},this.readCertHex=function(t){this.hex=t,this.getVersion();try{s(this.hex,0,[0,7],"a3"),this.parseExt()}catch(t){}},this.getInfo=function(){var t,e,r;if(t="Basic Fields\n",t+="  serial number: "+this.getSerialNumberHex()+"\n",t+="  signature algorithm: "+this.getSignatureAlgorithmField()+"\n",t+="  issuer: "+this.getIssuerString()+"\n",t+="  notBefore: "+this.getNotBefore()+"\n",t+="  notAfter: "+this.getNotAfter()+"\n",t+="  subject: "+this.getSubjectString()+"\n",t+="  subject public key info: \n",t+="    key algorithm: "+(e=this.getPublicKey()).type+"\n","RSA"===e.type&&(t+="    n="+Zr(e.n.toString(16)).substr(0,16)+"...\n",t+="    e="+Zr(e.e.toString(16))+"\n"),void 0!==(r=this.aExtInfo)&&null!==r){t+="X509v3 Extensions:\n";for(var n=0;n<r.length;n++){var i=r[n],o=Er.asn1.x509.OID.oid2name(i.oid);""===o&&(o=i.oid);var s="";if(!0===i.critical&&(s="CRITICAL"),t+="  "+o+" "+s+":\n","basicConstraints"===o){var a=this.getExtBasicConstraints();void 0===a.cA?t+="    {}\n":(t+="    cA=true",void 0!==a.pathLen&&(t+=", pathLen="+a.pathLen),t+="\n")}else if("keyUsage"===o)t+="    "+this.getExtKeyUsageString()+"\n";else if("subjectKeyIdentifier"===o)t+="    "+this.getExtSubjectKeyIdentifier()+"\n";else if("authorityKeyIdentifier"===o){var u=this.getExtAuthorityKeyIdentifier();void 0!==u.kid&&(t+="    kid="+u.kid+"\n")}else{if("extKeyUsage"===o)t+="    "+this.getExtExtKeyUsageName().join(", ")+"\n";else if("subjectAltName"===o)t+="    "+this.getExtSubjectAltName2()+"\n";else if("cRLDistributionPoints"===o)t+="    "+this.getExtCRLDistributionPointsURI()+"\n";else if("authorityInfoAccess"===o){var c=this.getExtAIAInfo();void 0!==c.ocsp&&(t+="    ocsp: "+c.ocsp.join(",")+"\n"),void 0!==c.caissuer&&(t+="    caissuer: "+c.caissuer.join(",")+"\n")}else if("certificatePolicies"===o)for(var h=this.getExtCertificatePolicies(),l=0;l<h.length;l++)void 0!==h[l].id&&(t+="    policy oid: "+h[l].id+"\n"),void 0!==h[l].cps&&(t+="    cps: "+h[l].cps+"\n")}}}return t+="signature algorithm: "+this.getSignatureAlgorithmName()+"\n",t+="signature: "+this.getSignatureValueHex().substr(0,16)+"...\n"}}en.compile("[^0-9a-f]","gi"),qe.prototype.sign=function(t,e){var r=function t(r){return Er.crypto.Util.hashString(r,e)}(t);return this.signWithMessageHash(r,e)},qe.prototype.signWithMessageHash=function(t,e){var r=Ke(Er.crypto.Util.getPaddedDigestInfoHex(t,e,this.n.bitLength()),16);return rn(this.doPrivate(r).toString(16),this.n.bitLength())},qe.prototype.signPSS=function(t,e,r){var n=function t(r){return Er.crypto.Util.hashHex(r,e)}(jr(t));return void 0===r&&(r=-1),this.signWithMessageHashPSS(n,e,r)},qe.prototype.signWithMessageHashPSS=function(t,e,r){var n,i=Or(t),o=i.length,s=this.n.bitLength()-1,a=Math.ceil(s/8),u=function t(r){return Er.crypto.Util.hashHex(r,e)};if(-1===r||void 0===r)r=o;else if(-2===r)r=a-o-2;else if(r<-2)throw"invalid salt length";if(a<o+r+2)throw"data too long";var c="";r>0&&(c=new Array(r),(new Me).nextBytes(c),c=String.fromCharCode.apply(String,c));var h=Or(u(jr("\0\0\0\0\0\0\0\0"+i+c))),l=[];for(n=0;n<a-r-o-2;n+=1)l[n]=0;var f=String.fromCharCode.apply(String,l)+""+c,d=nn(h,f.length,u),p=[];for(n=0;n<f.length;n+=1)p[n]=f.charCodeAt(n)^d.charCodeAt(n);var g=65280>>8*a-s&255;for(p[0]&=~g,n=0;n<o;n++)p.push(h.charCodeAt(n));return p.push(188),rn(this.doPrivate(new E(p)).toString(16),this.n.bitLength())},qe.prototype.verify=function(t,e){var r=Ke(e=(e=e.replace(en,"")).replace(/[ \n]+/g,""),16);if(r.bitLength()>this.n.bitLength())return 0;var n=on(this.doPublic(r).toString(16).replace(/^1f+00/,""));if(0==n.length)return!1;var i=n[0];return n[1]==function t(e){return Er.crypto.Util.hashString(e,i)}(t)},qe.prototype.verifyWithMessageHash=function(t,e){var r=Ke(e=(e=e.replace(en,"")).replace(/[ \n]+/g,""),16);if(r.bitLength()>this.n.bitLength())return 0;var n=on(this.doPublic(r).toString(16).replace(/^1f+00/,""));if(0==n.length)return!1;n[0];return n[1]==t},qe.prototype.verifyPSS=function(t,e,r,n){var i=function t(e){return Er.crypto.Util.hashHex(e,r)}(jr(t));return void 0===n&&(n=-1),this.verifyWithMessageHashPSS(i,e,r,n)},qe.prototype.verifyWithMessageHashPSS=function(t,e,r,n){var i=new E(e,16);if(i.bitLength()>this.n.bitLength())return!1;var o,s=function t(e){return Er.crypto.Util.hashHex(e,r)},a=Or(t),u=a.length,c=this.n.bitLength()-1,h=Math.ceil(c/8);if(-1===n||void 0===n)n=u;else if(-2===n)n=h-u-2;else if(n<-2)throw"invalid salt length";if(h<u+n+2)throw"data too long";var l=this.doPublic(i).toByteArray();for(o=0;o<l.length;o+=1)l[o]&=255;for(;l.length<h;)l.unshift(0);if(188!==l[h-1])throw"encoded message does not end in 0xbc";var f=(l=String.fromCharCode.apply(String,l)).substr(0,h-u-1),d=l.substr(f.length,u),p=65280>>8*h-c&255;if(0!=(f.charCodeAt(0)&p))throw"bits beyond keysize not zero";var g=nn(d,f.length,s),v=[];for(o=0;o<f.length;o+=1)v[o]=f.charCodeAt(o)^g.charCodeAt(o);v[0]&=~p;var y=h-u-n-2;for(o=0;o<y;o+=1)if(0!==v[o])throw"leftmost octets not zero";if(1!==v[y])throw"0x01 marker not found";return d===Or(s(jr("\0\0\0\0\0\0\0\0"+a+String.fromCharCode.apply(String,v.slice(-n)))))},qe.SALT_LEN_HLEN=-1,qe.SALT_LEN_MAX=-2,qe.SALT_LEN_RECOVER=-2,sn.hex2dn=function(t,e){if(void 0===e&&(e=0),"30"!==t.substr(e,2))throw"malformed DN";for(var r=new Array,n=Ar.getChildIdx(t,e),i=0;i<n.length;i++)r.push(sn.hex2rdn(t,n[i]));return"/"+(r=r.map(function(t){return t.replace("/","\\/")})).join("/")},sn.hex2rdn=function(t,e){if(void 0===e&&(e=0),"31"!==t.substr(e,2))throw"malformed RDN";for(var r=new Array,n=Ar.getChildIdx(t,e),i=0;i<n.length;i++)r.push(sn.hex2attrTypeValue(t,n[i]));return(r=r.map(function(t){return t.replace("+","\\+")})).join("+")},sn.hex2attrTypeValue=function(t,e){var r=Ar,n=r.getV;if(void 0===e&&(e=0),"30"!==t.substr(e,2))throw"malformed attribute type and value";var i=r.getChildIdx(t,e);2!==i.length||t.substr(i[0],2);var o=n(t,i[0]),s=Er.asn1.ASN1Util.oidHexToInt(o);return Er.asn1.x509.OID.oid2atype(s)+"="+Or(n(t,i[1]))},sn.getPublicKeyFromCertHex=function(t){var e=new sn;return e.readCertHex(t),e.getPublicKey()},sn.getPublicKeyFromCertPEM=function(t){var e=new sn;return e.readCertPEM(t),e.getPublicKey()},sn.getPublicKeyInfoPropOfCertPEM=function(t){var e,r,n=Ar.getVbyList,i={};return i.algparam=null,(e=new sn).readCertPEM(t),r=e.getPublicKeyHex(),i.keyhex=n(r,0,[1],"03").substr(2),i.algoid=n(r,0,[0,0],"06"),"2a8648ce3d0201"===i.algoid&&(i.algparam=n(r,0,[0,1],"06")),i},sn.KEYUSAGE_NAME=["digitalSignature","nonRepudiation","keyEncipherment","dataEncipherment","keyAgreement","keyCertSign","cRLSign","encipherOnly","decipherOnly"],void 0!==Er&&Er||(e.KJUR=Er={}),void 0!==Er.jws&&Er.jws||(Er.jws={}),Er.jws.JWS=function(){var t=Er.jws.JWS.isSafeJSONString;this.parseJWS=function(e,r){if(void 0===this.parsedJWS||!r&&void 0===this.parsedJWS.sigvalH){var n=e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);if(null==n)throw"JWS signature is not a form of 'Head.Payload.SigValue'.";var i=n[1],o=n[2],s=n[3],a=i+"."+o;if(this.parsedJWS={},this.parsedJWS.headB64U=i,this.parsedJWS.payloadB64U=o,this.parsedJWS.sigvalB64U=s,this.parsedJWS.si=a,!r){var u=Ur(s),c=Ke(u,16);this.parsedJWS.sigvalH=u,this.parsedJWS.sigvalBI=c}var h=kr(i),l=kr(o);if(this.parsedJWS.headS=h,this.parsedJWS.payloadS=l,!t(h,this.parsedJWS,"headP"))throw"malformed JSON string for JWS Head: "+h}}},Er.jws.JWS.sign=function(t,e,n,i,o){var s,a,u,c=Er,h=c.jws.JWS,l=h.readSafeJSONString,f=h.isSafeJSONString,d=c.crypto,p=(d.ECDSA,d.Mac),g=d.Signature,v=JSON;if("string"!=typeof e&&"object"!=(void 0===e?"undefined":r(e)))throw"spHeader must be JSON string or object: "+e;if("object"==(void 0===e?"undefined":r(e))&&(a=e,s=v.stringify(a)),"string"==typeof e){if(!f(s=e))throw"JWS Head is not safe JSON string: "+s;a=l(s)}if(u=n,"object"==(void 0===n?"undefined":r(n))&&(u=v.stringify(n)),""!=t&&null!=t||void 0===a.alg||(t=a.alg),""!=t&&null!=t&&void 0===a.alg&&(a.alg=t,s=v.stringify(a)),t!==a.alg)throw"alg and sHeader.alg doesn't match: "+t+"!="+a.alg;var y=null;if(void 0===h.jwsalg2sigalg[t])throw"unsupported alg name: "+t;y=h.jwsalg2sigalg[t];var m=xr(s)+"."+xr(u),_="";if("Hmac"==y.substr(0,4)){if(void 0===i)throw"mac key shall be specified for HS* alg";var S=new p({alg:y,prov:"cryptojs",pass:i});S.updateString(m),_=S.doFinal()}else{var F;if(-1!=y.indexOf("withECDSA"))(F=new g({alg:y})).init(i,o),F.updateString(m),hASN1Sig=F.sign(),_=Er.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig);else if("none"!=y)(F=new g({alg:y})).init(i,o),F.updateString(m),_=F.sign()}return m+"."+Lr(_)},Er.jws.JWS.verify=function(t,e,n){var i,o=Er,s=o.jws.JWS,a=s.readSafeJSONString,u=o.crypto,c=u.ECDSA,h=u.Mac,l=u.Signature;void 0!==r(qe)&&(i=qe);var f=t.split(".");if(3!==f.length)return!1;var d=f[0]+"."+f[1],p=Ur(f[2]),g=a(kr(f[0])),v=null,y=null;if(void 0===g.alg)throw"algorithm not specified in header";if((y=(v=g.alg).substr(0,2),null!=n&&"[object Array]"===Object.prototype.toString.call(n)&&n.length>0)&&-1==(":"+n.join(":")+":").indexOf(":"+v+":"))throw"algorithm '"+v+"' not accepted in the list";if("none"!=v&&null===e)throw"key shall be specified to verify.";if("string"==typeof e&&-1!=e.indexOf("-----BEGIN ")&&(e=tn.getKey(e)),!("RS"!=y&&"PS"!=y||e instanceof i))throw"key shall be a RSAKey obj for RS* and PS* algs";if("ES"==y&&!(e instanceof c))throw"key shall be a ECDSA obj for ES* algs";var m=null;if(void 0===s.jwsalg2sigalg[g.alg])throw"unsupported alg name: "+v;if("none"==(m=s.jwsalg2sigalg[v]))throw"not supported";if("Hmac"==m.substr(0,4)){if(void 0===e)throw"hexadecimal key shall be specified for HMAC";var _=new h({alg:m,pass:e});return _.updateString(d),p==_.doFinal()}if(-1!=m.indexOf("withECDSA")){var S,F=null;try{F=c.concatSigToASN1Sig(p)}catch(t){return!1}return(S=new l({alg:m})).init(e),S.updateString(d),S.verify(F)}return(S=new l({alg:m})).init(e),S.updateString(d),S.verify(p)},Er.jws.JWS.parse=function(t){var e,r,n,i=t.split("."),o={};if(2!=i.length&&3!=i.length)throw"malformed sJWS: wrong number of '.' splitted elements";return e=i[0],r=i[1],3==i.length&&(n=i[2]),o.headerObj=Er.jws.JWS.readSafeJSONString(kr(e)),o.payloadObj=Er.jws.JWS.readSafeJSONString(kr(r)),o.headerPP=JSON.stringify(o.headerObj,null,"  "),null==o.payloadObj?o.payloadPP=kr(r):o.payloadPP=JSON.stringify(o.payloadObj,null,"  "),void 0!==n&&(o.sigHex=Ur(n)),o},Er.jws.JWS.verifyJWT=function(t,e,n){var i=Er.jws,o=i.JWS,s=o.readSafeJSONString,a=o.inArray,u=o.includedArray,c=t.split("."),h=c[0],l=c[1],f=(Ur(c[2]),s(kr(h))),d=s(kr(l));if(void 0===f.alg)return!1;if(void 0===n.alg)throw"acceptField.alg shall be specified";if(!a(f.alg,n.alg))return!1;if(void 0!==d.iss&&"object"===r(n.iss)&&!a(d.iss,n.iss))return!1;if(void 0!==d.sub&&"object"===r(n.sub)&&!a(d.sub,n.sub))return!1;if(void 0!==d.aud&&"object"===r(n.aud))if("string"==typeof d.aud){if(!a(d.aud,n.aud))return!1}else if("object"==r(d.aud)&&!u(d.aud,n.aud))return!1;var p=i.IntDate.getNow();return void 0!==n.verifyAt&&"number"==typeof n.verifyAt&&(p=n.verifyAt),void 0!==n.gracePeriod&&"number"==typeof n.gracePeriod||(n.gracePeriod=0),!(void 0!==d.exp&&"number"==typeof d.exp&&d.exp+n.gracePeriod<p)&&(!(void 0!==d.nbf&&"number"==typeof d.nbf&&p<d.nbf-n.gracePeriod)&&(!(void 0!==d.iat&&"number"==typeof d.iat&&p<d.iat-n.gracePeriod)&&((void 0===d.jti||void 0===n.jti||d.jti===n.jti)&&!!o.verify(t,e,n.alg))))},Er.jws.JWS.includedArray=function(t,e){var n=Er.jws.JWS.inArray;if(null===t)return!1;if("object"!==(void 0===t?"undefined":r(t)))return!1;if("number"!=typeof t.length)return!1;for(var i=0;i<t.length;i++)if(!n(t[i],e))return!1;return!0},Er.jws.JWS.inArray=function(t,e){if(null===e)return!1;if("object"!==(void 0===e?"undefined":r(e)))return!1;if("number"!=typeof e.length)return!1;for(var n=0;n<e.length;n++)if(e[n]==t)return!0;return!1},Er.jws.JWS.jwsalg2sigalg={HS256:"HmacSHA256",HS384:"HmacSHA384",HS512:"HmacSHA512",RS256:"SHA256withRSA",RS384:"SHA384withRSA",RS512:"SHA512withRSA",ES256:"SHA256withECDSA",ES384:"SHA384withECDSA",PS256:"SHA256withRSAandMGF1",PS384:"SHA384withRSAandMGF1",PS512:"SHA512withRSAandMGF1",none:"none"},Er.jws.JWS.isSafeJSONString=function(t,e,n){var i=null;try{return"object"!=(void 0===(i=wr(t))?"undefined":r(i))?0:i.constructor===Array?0:(e&&(e[n]=i),1)}catch(t){return 0}},Er.jws.JWS.readSafeJSONString=function(t){var e=null;try{return"object"!=(void 0===(e=wr(t))?"undefined":r(e))?null:e.constructor===Array?null:e}catch(t){return null}},Er.jws.JWS.getEncodedSignatureValueFromJWS=function(t){var e=t.match(/^[^.]+\.[^.]+\.([^.]+)$/);if(null==e)throw"JWS signature is not a form of 'Head.Payload.SigValue'.";return e[1]},Er.jws.JWS.getJWKthumbprint=function(t){if("RSA"!==t.kty&&"EC"!==t.kty&&"oct"!==t.kty)throw"unsupported algorithm for JWK Thumprint";var e="{";if("RSA"===t.kty){if("string"!=typeof t.n||"string"!=typeof t.e)throw"wrong n and e value for RSA key";e+='"e":"'+t.e+'",',e+='"kty":"'+t.kty+'",',e+='"n":"'+t.n+'"}'}else if("EC"===t.kty){if("string"!=typeof t.crv||"string"!=typeof t.x||"string"!=typeof t.y)throw"wrong crv, x and y value for EC key";e+='"crv":"'+t.crv+'",',e+='"kty":"'+t.kty+'",',e+='"x":"'+t.x+'",',e+='"y":"'+t.y+'"}'}else if("oct"===t.kty){if("string"!=typeof t.k)throw"wrong k value for oct(symmetric) key";e+='"kty":"'+t.kty+'",',e+='"k":"'+t.k+'"}'}var r=jr(e);return Lr(Er.crypto.Util.hashHex(r,"sha256"))},Er.jws.IntDate={},Er.jws.IntDate.get=function(t){var e=Er.jws.IntDate,r=e.getNow,n=e.getZulu;if("now"==t)return r();if("now + 1hour"==t)return r()+3600;if("now + 1day"==t)return r()+86400;if("now + 1month"==t)return r()+2592e3;if("now + 1year"==t)return r()+31536e3;if(t.match(/Z$/))return n(t);if(t.match(/^[0-9]+$/))return parseInt(t);throw"unsupported format: "+t},Er.jws.IntDate.getZulu=function(t){return Wr(t)},Er.jws.IntDate.getNow=function(){return~~(new Date/1e3)},Er.jws.IntDate.intDate2UTCString=function(t){return new Date(1e3*t).toUTCString()},Er.jws.IntDate.intDate2Zulu=function(t){var e=new Date(1e3*t);return("0000"+e.getUTCFullYear()).slice(-4)+("00"+(e.getUTCMonth()+1)).slice(-2)+("00"+e.getUTCDate()).slice(-2)+("00"+e.getUTCHours()).slice(-2)+("00"+e.getUTCMinutes()).slice(-2)+("00"+e.getUTCSeconds()).slice(-2)+"Z"},e.SecureRandom=Me,e.rng_seed_time=Ue,e.BigInteger=E,e.RSAKey=qe;var an=Er.crypto.EDSA;e.EDSA=an;var un=Er.crypto.DSA;e.DSA=un;var cn=Er.crypto.Signature;e.Signature=cn;var hn=Er.crypto.MessageDigest;e.MessageDigest=hn;var ln=Er.crypto.Mac;e.Mac=ln;var fn=Er.crypto.Cipher;e.Cipher=fn,e.KEYUTIL=tn,e.ASN1HEX=Ar,e.X509=sn,e.CryptoJS=y,e.b64tohex=b,e.b64toBA=w,e.stoBA=Pr,e.BAtos=Cr,e.BAtohex=Tr,e.stohex=Rr,e.stob64=function dn(t){return F(Rr(t))},e.stob64u=function pn(t){return Ir(F(Rr(t)))},e.b64utos=function gn(t){return Cr(w(Dr(t)))},e.b64tob64u=Ir,e.b64utob64=Dr,e.hex2b64=F,e.hextob64u=Lr,e.b64utohex=Ur,e.utf8tob64u=xr,e.b64utoutf8=kr,e.utf8tob64=function vn(t){return F(zr($r(t)))},e.b64toutf8=function yn(t){return decodeURIComponent(Yr(b(t)))},e.utf8tohex=Br,e.hextoutf8=Nr,e.hextorstr=Or,e.rstrtohex=jr,e.hextob64=Hr,e.hextob64nl=Mr,e.b64nltohex=Kr,e.hextopem=Vr,e.pemtohex=qr,e.hextoArrayBuffer=function mn(t){if(t.length%2!=0)throw"input is not even length";if(null==t.match(/^[0-9A-Fa-f]+$/))throw"input is not hexadecimal";for(var e=new ArrayBuffer(t.length/2),r=new DataView(e),n=0;n<t.length/2;n++)r.setUint8(n,parseInt(t.substr(2*n,2),16));return e},e.ArrayBuffertohex=function _n(t){for(var e="",r=new DataView(t),n=0;n<t.byteLength;n++)e+=("00"+r.getUint8(n).toString(16)).slice(-2);return e},e.zulutomsec=Jr,e.zulutosec=Wr,e.zulutodate=function Sn(t){return new Date(Jr(t))},e.datetozulu=function Fn(t,e,r){var n,i=t.getUTCFullYear();if(e){if(i<1950||2049<i)throw"not proper year for UTCTime: "+i;n=(""+i).slice(-2)}else n=("000"+i).slice(-4);if(n+=("0"+(t.getUTCMonth()+1)).slice(-2),n+=("0"+t.getUTCDate()).slice(-2),n+=("0"+t.getUTCHours()).slice(-2),n+=("0"+t.getUTCMinutes()).slice(-2),n+=("0"+t.getUTCSeconds()).slice(-2),r){var o=t.getUTCMilliseconds();0!==o&&(n+="."+(o=(o=("00"+o).slice(-3)).replace(/0+$/g,"")))}return n+="Z"},e.uricmptohex=zr,e.hextouricmp=Yr,e.ipv6tohex=Gr,e.hextoipv6=Xr,e.hextoip=Qr,e.iptohex=function bn(t){var e="malformed IP address";if(!(t=t.toLowerCase(t)).match(/^[0-9.]+$/)){if(t.match(/^[0-9a-f:]+$/)&&-1!==t.indexOf(":"))return Gr(t);throw e}var r=t.split(".");if(4!==r.length)throw e;var n="";try{for(var i=0;i<4;i++)n+=("0"+parseInt(r[i]).toString(16)).slice(-2);return n}catch(t){throw e}},e.encodeURIComponentAll=$r,e.newline_toUnix=function wn(t){return t=t.replace(/\r\n/gm,"\n")},e.newline_toDos=function En(t){return t=(t=t.replace(/\r\n/gm,"\n")).replace(/\n/gm,"\r\n")},e.hextoposhex=Zr,e.intarystrtohex=function xn(t){t=(t=(t=t.replace(/^\s*\[\s*/,"")).replace(/\s*\]\s*$/,"")).replace(/\s*/g,"");try{return t.split(/,/).map(function(t,e,r){var n=parseInt(t);if(n<0||255<n)throw"integer not in range 0-255";return("00"+n.toString(16)).slice(-2)}).join("")}catch(t){throw"malformed integer array string: "+t}},e.strdiffidx=function t(e,r){var n=e.length;e.length>r.length&&(n=r.length);for(var i=0;i<n;i++)if(e.charCodeAt(i)!=r.charCodeAt(i))return i;return e.length!=r.length?n:-1},e.KJUR=Er;var kn=Er.crypto;e.crypto=kn;var An=Er.asn1;e.asn1=An;var Pn=Er.jws;e.jws=Pn;var Cn=Er.lang;e.lang=Cn}).call(this,r(27).Buffer)},function(t,e,r){"use strict";(function(t){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var n=r(29),i=r(30),o=r(31);function s(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function a(t,e){if(s()<e)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=u.prototype:(null===t&&(t=new u(e)),t.length=e),t}function u(t,e,r){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(t,e,r);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return l(this,t)}return c(this,t,e,r)}function c(t,e,r,n){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function i(t,e,r,n){if(e.byteLength,r<0||e.byteLength<r)throw new RangeError("'offset' is out of bounds");if(e.byteLength<r+(n||0))throw new RangeError("'length' is out of bounds");e=void 0===r&&void 0===n?new Uint8Array(e):void 0===n?new Uint8Array(e,r):new Uint8Array(e,r,n);u.TYPED_ARRAY_SUPPORT?(t=e).__proto__=u.prototype:t=f(t,e);return t}(t,e,r,n):"string"==typeof e?function s(t,e,r){"string"==typeof r&&""!==r||(r="utf8");if(!u.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var n=0|p(e,r),i=(t=a(t,n)).write(e,r);i!==n&&(t=t.slice(0,i));return t}(t,e,r):function c(t,e){if(u.isBuffer(e)){var r=0|d(e.length);return 0===(t=a(t,r)).length?t:(e.copy(t,0,0,r),t)}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||function n(t){return t!=t}(e.length)?a(t,0):f(t,e);if("Buffer"===e.type&&o(e.data))return f(t,e.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function h(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function l(t,e){if(h(e),t=a(t,e<0?0:0|d(e)),!u.TYPED_ARRAY_SUPPORT)for(var r=0;r<e;++r)t[r]=0;return t}function f(t,e){var r=e.length<0?0:0|d(e.length);t=a(t,r);for(var n=0;n<r;n+=1)t[n]=255&e[n];return t}function d(t){if(t>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|t}function p(t,e){if(u.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return K(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return V(t).length;default:if(n)return K(t).length;e=(""+e).toLowerCase(),n=!0}}function g(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function v(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:t.length-1),r<0&&(r=t.length+r),r>=t.length){if(i)return-1;r=t.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof e&&(e=u.from(e,n)),u.isBuffer(e))return 0===e.length?-1:y(t,e,r,n,i);if("number"==typeof e)return e&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):y(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function y(t,e,r,n,i){var o,s=1,a=t.length,u=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;s=2,a/=2,u/=2,r/=2}function c(t,e){return 1===s?t[e]:t.readUInt16BE(e*s)}if(i){var h=-1;for(o=r;o<a;o++)if(c(t,o)===c(e,-1===h?0:o-h)){if(-1===h&&(h=o),o-h+1===u)return h*s}else-1!==h&&(o-=o-h),h=-1}else for(r+u>a&&(r=a-u),o=r;o>=0;o--){for(var l=!0,f=0;f<u;f++)if(c(t,o+f)!==c(e,f)){l=!1;break}if(l)return o}return-1}function m(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=e.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;s<n;++s){var a=parseInt(e.substr(2*s,2),16);if(isNaN(a))return s;t[r+s]=a}return s}function _(t,e,r,n){return q(K(e,t.length-r),t,r,n)}function S(t,e,r,n){return q(function i(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function F(t,e,r,n){return S(t,e,r,n)}function b(t,e,r,n){return q(V(e),t,r,n)}function w(t,e,r,n){return q(function i(t,e){for(var r,n,i,o=[],s=0;s<t.length&&!((e-=2)<0);++s)r=t.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}(e,t.length-r),t,r,n)}function E(t,e,r){return 0===e&&r===t.length?n.fromByteArray(t):n.fromByteArray(t.slice(e,r))}function x(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var o,s,a,u,c=t[i],h=null,l=c>239?4:c>223?3:c>191?2:1;if(i+l<=r)switch(l){case 1:c<128&&(h=c);break;case 2:128==(192&(o=t[i+1]))&&(u=(31&c)<<6|63&o)>127&&(h=u);break;case 3:o=t[i+1],s=t[i+2],128==(192&o)&&128==(192&s)&&(u=(15&c)<<12|(63&o)<<6|63&s)>2047&&(u<55296||u>57343)&&(h=u);break;case 4:o=t[i+1],s=t[i+2],a=t[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&(u=(15&c)<<18|(63&o)<<12|(63&s)<<6|63&a)>65535&&u<1114112&&(h=u)}null===h?(h=65533,l=1):h>65535&&(h-=65536,n.push(h>>>10&1023|55296),h=56320|1023&h),n.push(h),i+=l}return function f(t){var e=t.length;if(e<=P)return String.fromCharCode.apply(String,t);var r="",n=0;for(;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=P));return r}(n)}e.Buffer=u,e.SlowBuffer=function k(t){+t!=t&&(t=0);return u.alloc(+t)},e.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function A(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=s(),u.poolSize=8192,u._augment=function(t){return t.__proto__=u.prototype,t},u.from=function(t,e,r){return c(null,t,e,r)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(t,e,r){return function n(t,e,r,i){return h(e),e<=0?a(t,e):void 0!==r?"string"==typeof i?a(t,e).fill(r,i):a(t,e).fill(r):a(t,e)}(null,t,e,r)},u.allocUnsafe=function(t){return l(null,t)},u.allocUnsafeSlow=function(t){return l(null,t)},u.isBuffer=function t(e){return!(null==e||!e._isBuffer)},u.compare=function t(e,r){if(!u.isBuffer(e)||!u.isBuffer(r))throw new TypeError("Arguments must be Buffers");if(e===r)return 0;for(var n=e.length,i=r.length,o=0,s=Math.min(n,i);o<s;++o)if(e[o]!==r[o]){n=e[o],i=r[o];break}return n<i?-1:i<n?1:0},u.isEncoding=function t(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function t(e,r){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return u.alloc(0);var n;if(void 0===r)for(r=0,n=0;n<e.length;++n)r+=e[n].length;var i=u.allocUnsafe(r),s=0;for(n=0;n<e.length;++n){var a=e[n];if(!u.isBuffer(a))throw new TypeError('"list" argument must be an Array of Buffers');a.copy(i,s),s+=a.length}return i},u.byteLength=p,u.prototype._isBuffer=!0,u.prototype.swap16=function t(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var r=0;r<e;r+=2)g(this,r,r+1);return this},u.prototype.swap32=function t(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var r=0;r<e;r+=4)g(this,r,r+3),g(this,r+1,r+2);return this},u.prototype.swap64=function t(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var r=0;r<e;r+=8)g(this,r,r+7),g(this,r+1,r+6),g(this,r+2,r+5),g(this,r+3,r+4);return this},u.prototype.toString=function t(){var e=0|this.length;return 0===e?"":0===arguments.length?x(this,0,e):function r(t,e,n){var i=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return R(this,e,n);case"utf8":case"utf-8":return x(this,e,n);case"ascii":return C(this,e,n);case"latin1":case"binary":return T(this,e,n);case"base64":return E(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return I(this,e,n);default:if(i)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),i=!0}}.apply(this,arguments)},u.prototype.equals=function t(e){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===u.compare(this,e)},u.prototype.inspect=function t(){var r="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(r=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(r+=" ... ")),"<Buffer "+r+">"},u.prototype.compare=function t(e,r,n,i,o){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===r&&(r=0),void 0===n&&(n=e?e.length:0),void 0===i&&(i=0),void 0===o&&(o=this.length),r<0||n>e.length||i<0||o>this.length)throw new RangeError("out of range index");if(i>=o&&r>=n)return 0;if(i>=o)return-1;if(r>=n)return 1;if(r>>>=0,n>>>=0,i>>>=0,o>>>=0,this===e)return 0;for(var s=o-i,a=n-r,c=Math.min(s,a),h=this.slice(i,o),l=e.slice(r,n),f=0;f<c;++f)if(h[f]!==l[f]){s=h[f],a=l[f];break}return s<a?-1:a<s?1:0},u.prototype.includes=function t(e,r,n){return-1!==this.indexOf(e,r,n)},u.prototype.indexOf=function t(e,r,n){return v(this,e,r,n,!0)},u.prototype.lastIndexOf=function t(e,r,n){return v(this,e,r,n,!1)},u.prototype.write=function t(e,r,n,i){if(void 0===r)i="utf8",n=this.length,r=0;else if(void 0===n&&"string"==typeof r)i=r,n=this.length,r=0;else{if(!isFinite(r))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");r|=0,isFinite(n)?(n|=0,void 0===i&&(i="utf8")):(i=n,n=void 0)}var o=this.length-r;if((void 0===n||n>o)&&(n=o),e.length>0&&(n<0||r<0)||r>this.length)throw new RangeError("Attempt to write outside buffer bounds");i||(i="utf8");for(var s=!1;;)switch(i){case"hex":return m(this,e,r,n);case"utf8":case"utf-8":return _(this,e,r,n);case"ascii":return S(this,e,r,n);case"latin1":case"binary":return F(this,e,r,n);case"base64":return b(this,e,r,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return w(this,e,r,n);default:if(s)throw new TypeError("Unknown encoding: "+i);i=(""+i).toLowerCase(),s=!0}},u.prototype.toJSON=function t(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var P=4096;function C(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(127&t[i]);return n}function T(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(t[i]);return n}function R(t,e,r){var n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=e;o<r;++o)i+=M(t[o]);return i}function I(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function D(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function L(t,e,r,n,i,o){if(!u.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||e<o)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function U(t,e,r,n){e<0&&(e=65535+e+1);for(var i=0,o=Math.min(t.length-r,2);i<o;++i)t[r+i]=(e&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function B(t,e,r,n){e<0&&(e=4294967295+e+1);for(var i=0,o=Math.min(t.length-r,4);i<o;++i)t[r+i]=e>>>8*(n?i:3-i)&255}function N(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function O(t,e,r,n,o){return o||N(t,0,r,4),i.write(t,e,r,n,23,4),r+4}function j(t,e,r,n,o){return o||N(t,0,r,8),i.write(t,e,r,n,52,8),r+8}u.prototype.slice=function t(e,r){var n,i=this.length;if(e=~~e,r=void 0===r?i:~~r,e<0?(e+=i)<0&&(e=0):e>i&&(e=i),r<0?(r+=i)<0&&(r=0):r>i&&(r=i),r<e&&(r=e),u.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,r)).__proto__=u.prototype;else{var o=r-e;n=new u(o,void 0);for(var s=0;s<o;++s)n[s]=this[s+e]}return n},u.prototype.readUIntLE=function t(e,r,n){e|=0,r|=0,n||D(e,r,this.length);for(var i=this[e],o=1,s=0;++s<r&&(o*=256);)i+=this[e+s]*o;return i},u.prototype.readUIntBE=function t(e,r,n){e|=0,r|=0,n||D(e,r,this.length);for(var i=this[e+--r],o=1;r>0&&(o*=256);)i+=this[e+--r]*o;return i},u.prototype.readUInt8=function t(e,r){return r||D(e,1,this.length),this[e]},u.prototype.readUInt16LE=function t(e,r){return r||D(e,2,this.length),this[e]|this[e+1]<<8},u.prototype.readUInt16BE=function t(e,r){return r||D(e,2,this.length),this[e]<<8|this[e+1]},u.prototype.readUInt32LE=function t(e,r){return r||D(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},u.prototype.readUInt32BE=function t(e,r){return r||D(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},u.prototype.readIntLE=function t(e,r,n){e|=0,r|=0,n||D(e,r,this.length);for(var i=this[e],o=1,s=0;++s<r&&(o*=256);)i+=this[e+s]*o;return i>=(o*=128)&&(i-=Math.pow(2,8*r)),i},u.prototype.readIntBE=function t(e,r,n){e|=0,r|=0,n||D(e,r,this.length);for(var i=r,o=1,s=this[e+--i];i>0&&(o*=256);)s+=this[e+--i]*o;return s>=(o*=128)&&(s-=Math.pow(2,8*r)),s},u.prototype.readInt8=function t(e,r){return r||D(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},u.prototype.readInt16LE=function t(e,r){r||D(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt16BE=function t(e,r){r||D(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt32LE=function t(e,r){return r||D(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},u.prototype.readInt32BE=function t(e,r){return r||D(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},u.prototype.readFloatLE=function t(e,r){return r||D(e,4,this.length),i.read(this,e,!0,23,4)},u.prototype.readFloatBE=function t(e,r){return r||D(e,4,this.length),i.read(this,e,!1,23,4)},u.prototype.readDoubleLE=function t(e,r){return r||D(e,8,this.length),i.read(this,e,!0,52,8)},u.prototype.readDoubleBE=function t(e,r){return r||D(e,8,this.length),i.read(this,e,!1,52,8)},u.prototype.writeUIntLE=function t(e,r,n,i){(e=+e,r|=0,n|=0,i)||L(this,e,r,n,Math.pow(2,8*n)-1,0);var o=1,s=0;for(this[r]=255&e;++s<n&&(o*=256);)this[r+s]=e/o&255;return r+n},u.prototype.writeUIntBE=function t(e,r,n,i){(e=+e,r|=0,n|=0,i)||L(this,e,r,n,Math.pow(2,8*n)-1,0);var o=n-1,s=1;for(this[r+o]=255&e;--o>=0&&(s*=256);)this[r+o]=e/s&255;return r+n},u.prototype.writeUInt8=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,1,255,0),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[r]=255&e,r+1},u.prototype.writeUInt16LE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[r]=255&e,this[r+1]=e>>>8):U(this,e,r,!0),r+2},u.prototype.writeUInt16BE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>8,this[r+1]=255&e):U(this,e,r,!1),r+2},u.prototype.writeUInt32LE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[r+3]=e>>>24,this[r+2]=e>>>16,this[r+1]=e>>>8,this[r]=255&e):B(this,e,r,!0),r+4},u.prototype.writeUInt32BE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>24,this[r+1]=e>>>16,this[r+2]=e>>>8,this[r+3]=255&e):B(this,e,r,!1),r+4},u.prototype.writeIntLE=function t(e,r,n,i){if(e=+e,r|=0,!i){var o=Math.pow(2,8*n-1);L(this,e,r,n,o-1,-o)}var s=0,a=1,u=0;for(this[r]=255&e;++s<n&&(a*=256);)e<0&&0===u&&0!==this[r+s-1]&&(u=1),this[r+s]=(e/a>>0)-u&255;return r+n},u.prototype.writeIntBE=function t(e,r,n,i){if(e=+e,r|=0,!i){var o=Math.pow(2,8*n-1);L(this,e,r,n,o-1,-o)}var s=n-1,a=1,u=0;for(this[r+s]=255&e;--s>=0&&(a*=256);)e<0&&0===u&&0!==this[r+s+1]&&(u=1),this[r+s]=(e/a>>0)-u&255;return r+n},u.prototype.writeInt8=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,1,127,-128),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[r]=255&e,r+1},u.prototype.writeInt16LE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[r]=255&e,this[r+1]=e>>>8):U(this,e,r,!0),r+2},u.prototype.writeInt16BE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>8,this[r+1]=255&e):U(this,e,r,!1),r+2},u.prototype.writeInt32LE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[r]=255&e,this[r+1]=e>>>8,this[r+2]=e>>>16,this[r+3]=e>>>24):B(this,e,r,!0),r+4},u.prototype.writeInt32BE=function t(e,r,n){return e=+e,r|=0,n||L(this,e,r,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>24,this[r+1]=e>>>16,this[r+2]=e>>>8,this[r+3]=255&e):B(this,e,r,!1),r+4},u.prototype.writeFloatLE=function t(e,r,n){return O(this,e,r,!0,n)},u.prototype.writeFloatBE=function t(e,r,n){return O(this,e,r,!1,n)},u.prototype.writeDoubleLE=function t(e,r,n){return j(this,e,r,!0,n)},u.prototype.writeDoubleBE=function t(e,r,n){return j(this,e,r,!1,n)},u.prototype.copy=function t(e,r,n,i){if(n||(n=0),i||0===i||(i=this.length),r>=e.length&&(r=e.length),r||(r=0),i>0&&i<n&&(i=n),i===n)return 0;if(0===e.length||0===this.length)return 0;if(r<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(i<0)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),e.length-r<i-n&&(i=e.length-r+n);var o,s=i-n;if(this===e&&n<r&&r<i)for(o=s-1;o>=0;--o)e[o+r]=this[o+n];else if(s<1e3||!u.TYPED_ARRAY_SUPPORT)for(o=0;o<s;++o)e[o+r]=this[o+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+s),r);return s},u.prototype.fill=function t(e,r,n,i){if("string"==typeof e){if("string"==typeof r?(i=r,r=0,n=this.length):"string"==typeof n&&(i=n,n=this.length),1===e.length){var o=e.charCodeAt(0);o<256&&(e=o)}if(void 0!==i&&"string"!=typeof i)throw new TypeError("encoding must be a string");if("string"==typeof i&&!u.isEncoding(i))throw new TypeError("Unknown encoding: "+i)}else"number"==typeof e&&(e&=255);if(r<0||this.length<r||this.length<n)throw new RangeError("Out of range index");if(n<=r)return this;var s;if(r>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(s=r;s<n;++s)this[s]=e;else{var a=u.isBuffer(e)?e:K(new u(e,i).toString()),c=a.length;for(s=0;s<n-r;++s)this[s+r]=a[s%c]}return this};var H=/[^+\/0-9A-Za-z-_]/g;function M(t){return t<16?"0"+t.toString(16):t.toString(16)}function K(t,e){var r;e=e||1/0;for(var n=t.length,i=null,o=[],s=0;s<n;++s){if((r=t.charCodeAt(s))>55295&&r<57344){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((e-=1)<0)break;o.push(r)}else if(r<2048){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function V(t){return n.toByteArray(function e(t){if((t=function e(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}(t).replace(H,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function q(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}}).call(this,r(28))},function(t,e){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){"use strict";e.byteLength=function n(t){var e=f(t),r=e[0],n=e[1];return 3*(r+n)/4-n},e.toByteArray=function i(t){for(var e,r=f(t),n=r[0],i=r[1],o=new u(function s(t,e,r){return 3*(e+r)/4-r}(0,n,i)),c=0,h=i>0?n-4:n,l=0;l<h;l+=4)e=a[t.charCodeAt(l)]<<18|a[t.charCodeAt(l+1)]<<12|a[t.charCodeAt(l+2)]<<6|a[t.charCodeAt(l+3)],o[c++]=e>>16&255,o[c++]=e>>8&255,o[c++]=255&e;2===i&&(e=a[t.charCodeAt(l)]<<2|a[t.charCodeAt(l+1)]>>4,o[c++]=255&e);1===i&&(e=a[t.charCodeAt(l)]<<10|a[t.charCodeAt(l+1)]<<4|a[t.charCodeAt(l+2)]>>2,o[c++]=e>>8&255,o[c++]=255&e);return o},e.fromByteArray=function o(t){for(var e,r=t.length,n=r%3,i=[],o=0,a=r-n;o<a;o+=16383)i.push(d(t,o,o+16383>a?a:o+16383));1===n?(e=t[r-1],i.push(s[e>>2]+s[e<<4&63]+"==")):2===n&&(e=(t[r-2]<<8)+t[r-1],i.push(s[e>>10]+s[e>>4&63]+s[e<<2&63]+"="));return i.join("")};for(var s=[],a=[],u="undefined"!=typeof Uint8Array?Uint8Array:Array,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",h=0,l=c.length;h<l;++h)s[h]=c[h],a[c.charCodeAt(h)]=h;function f(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}function d(t,e,r){for(var n,i,o=[],a=e;a<r;a+=3)n=(t[a]<<16&16711680)+(t[a+1]<<8&65280)+(255&t[a+2]),o.push(s[(i=n)>>18&63]+s[i>>12&63]+s[i>>6&63]+s[63&i]);return o.join("")}a["-".charCodeAt(0)]=62,a["_".charCodeAt(0)]=63},function(t,e){e.read=function(t,e,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,h=-7,l=r?i-1:0,f=r?-1:1,d=t[e+l];for(l+=f,o=d&(1<<-h)-1,d>>=-h,h+=a;h>0;o=256*o+t[e+l],l+=f,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=n;h>0;s=256*s+t[e+l],l+=f,h-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:1/0*(d?-1:1);s+=Math.pow(2,n),o-=c}return(d?-1:1)*s*Math.pow(2,o-n)},e.write=function(t,e,r,n,i,o){var s,a,u,c=8*o-i-1,h=(1<<c)-1,l=h>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=n?0:o-1,p=n?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-s))<1&&(s--,u*=2),(e+=s+l>=1?f/u:f*Math.pow(2,1-l))*u>=2&&(s++,u/=2),s+l>=h?(a=0,s=h):s+l>=1?(a=(e*u-1)*Math.pow(2,i),s+=l):(a=e*Math.pow(2,l-1)*Math.pow(2,i),s=0));i>=8;t[r+d]=255&a,d+=p,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;t[r+d]=255&s,d+=p,s/=256,c-=8);t[r+d-p]|=128*g}},function(t,e){var r={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==r.call(t)}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function n(t){var e=t.jws,r=t.KeyUtil,n=t.X509,o=t.crypto,s=t.hextob64u,a=t.b64tohex,u=t.AllowedSigningAlgs;return function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.parseJwt=function t(r){i.Log.debug("JoseUtil.parseJwt");try{var n=e.JWS.parse(r);return{header:n.headerObj,payload:n.payloadObj}}catch(t){i.Log.error(t)}},t.validateJwt=function e(o,s,u,c,h,l,f){i.Log.debug("JoseUtil.validateJwt");try{if("RSA"===s.kty)if(s.e&&s.n)s=r.getKey(s);else{if(!s.x5c||!s.x5c.length)return i.Log.error("JoseUtil.validateJwt: RSA key missing key material",s),Promise.reject(new Error("RSA key missing key material"));var d=a(s.x5c[0]);s=n.getPublicKeyFromCertHex(d)}else{if("EC"!==s.kty)return i.Log.error("JoseUtil.validateJwt: Unsupported key type",s&&s.kty),Promise.reject(new Error(s.kty));if(!(s.crv&&s.x&&s.y))return i.Log.error("JoseUtil.validateJwt: EC key missing key material",s),Promise.reject(new Error("EC key missing key material"));s=r.getKey(s)}return t._validateJwt(o,s,u,c,h,l,f)}catch(t){return i.Log.error(t&&t.message||t),Promise.reject("JWT validation failed")}},t.validateJwtAttributes=function e(r,n,o,s,a,u){s||(s=0),a||(a=parseInt(Date.now()/1e3));var c=t.parseJwt(r).payload;if(!c.iss)return i.Log.error("JoseUtil._validateJwt: issuer was not provided"),Promise.reject(new Error("issuer was not provided"));if(c.iss!==n)return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token",c.iss),Promise.reject(new Error("Invalid issuer in token: "+c.iss));if(!c.aud)return i.Log.error("JoseUtil._validateJwt: aud was not provided"),Promise.reject(new Error("aud was not provided"));var h=c.aud===o||Array.isArray(c.aud)&&c.aud.indexOf(o)>=0;if(!h)return i.Log.error("JoseUtil._validateJwt: Invalid audience in token",c.aud),Promise.reject(new Error("Invalid audience in token: "+c.aud));if(c.azp&&c.azp!==o)return i.Log.error("JoseUtil._validateJwt: Invalid azp in token",c.azp),Promise.reject(new Error("Invalid azp in token: "+c.azp));if(!u){var l=a+s,f=a-s;if(!c.iat)return i.Log.error("JoseUtil._validateJwt: iat was not provided"),Promise.reject(new Error("iat was not provided"));if(l<c.iat)return i.Log.error("JoseUtil._validateJwt: iat is in the future",c.iat),Promise.reject(new Error("iat is in the future: "+c.iat));if(c.nbf&&l<c.nbf)return i.Log.error("JoseUtil._validateJwt: nbf is in the future",c.nbf),Promise.reject(new Error("nbf is in the future: "+c.nbf));if(!c.exp)return i.Log.error("JoseUtil._validateJwt: exp was not provided"),Promise.reject(new Error("exp was not provided"));if(c.exp<f)return i.Log.error("JoseUtil._validateJwt: exp is in the past",c.exp),Promise.reject(new Error("exp is in the past:"+c.exp))}return Promise.resolve(c)},t._validateJwt=function r(n,o,s,a,c,h,l){return t.validateJwtAttributes(n,s,a,c,h,l).then(function(t){try{return e.JWS.verify(n,o,u)?t:(i.Log.error("JoseUtil._validateJwt: signature validation failed"),Promise.reject(new Error("signature validation failed")))}catch(t){return i.Log.error(t&&t.message||t),Promise.reject(new Error("signature validation failed"))}})},t.hashString=function t(e,r){try{return o.Util.hashString(e,r)}catch(t){i.Log.error(t)}},t.hexToBase64Url=function t(e){try{return s(e)}catch(t){i.Log.error(t)}},t}()};var i=r(0);t.exports=e.default},function(t,e,r){var n=r(34),i=r(35);t.exports=function o(t,e,r){var o=e&&r||0;"string"==typeof t&&(e="binary"===t?new Array(16):null,t=null);var s=(t=t||{}).random||(t.rng||n)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,e)for(var a=0;a<16;++a)e[o+a]=s[a];return e||i(s)}},function(t,e){var r="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(r){var n=new Uint8Array(16);t.exports=function t(){return r(n),n}}else{var i=new Array(16);t.exports=function t(){for(var e,r=0;r<16;r++)0==(3&r)&&(e=4294967296*Math.random()),i[r]=e>>>((3&r)<<3)&255;return i}}},function(t,e){for(var r=[],n=0;n<256;++n)r[n]=(n+256).toString(16).substr(1);t.exports=function i(t,e){var n=e||0,i=r;return[i[t[n++]],i[t[n++]],i[t[n++]],i[t[n++]],"-",i[t[n++]],i[t[n++]],"-",i[t[n++]],i[t[n++]],"-",i[t[n++]],i[t[n++]],"-",i[t[n++]],i[t[n++]],i[t[n++]],i[t[n++]],i[t[n++]],i[t[n++]]].join("")}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SigninResponse=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(3);e.SigninResponse=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#";!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var o=i.UrlUtility.parseUrlFragment(e,r);this.error=o.error,this.error_description=o.error_description,this.error_uri=o.error_uri,this.code=o.code,this.state=o.state,this.id_token=o.id_token,this.session_state=o.session_state,this.access_token=o.access_token,this.token_type=o.token_type,this.scope=o.scope,this.profile=void 0,this.expires_in=o.expires_in}return n(t,[{key:"expires_in",get:function t(){if(this.expires_at){var e=parseInt(Date.now()/1e3);return this.expires_at-e}},set:function t(e){var r=parseInt(e);if("number"==typeof r&&r>0){var n=parseInt(Date.now()/1e3);this.expires_at=n+r}}},{key:"expired",get:function t(){var e=this.expires_in;if(void 0!==e)return e<=0}},{key:"scopes",get:function t(){return(this.scope||"").split(" ")}},{key:"isOpenIdConnect",get:function t(){return this.scopes.indexOf("openid")>=0||!!this.id_token}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SignoutRequest=void 0;var n=r(0),i=r(3),o=r(8);e.SignoutRequest=function t(e){var r=e.url,s=e.id_token_hint,a=e.post_logout_redirect_uri,u=e.data,c=e.extraQueryParams,h=e.request_type;if(function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!r)throw n.Log.error("SignoutRequest.ctor: No url passed"),new Error("url");for(var f in s&&(r=i.UrlUtility.addQueryParam(r,"id_token_hint",s)),a&&(r=i.UrlUtility.addQueryParam(r,"post_logout_redirect_uri",a),u&&(this.state=new o.State({data:u,request_type:h}),r=i.UrlUtility.addQueryParam(r,"state",this.state.id))),c)r=i.UrlUtility.addQueryParam(r,f,c[f]);this.url=r}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SignoutResponse=void 0;var n=r(3);e.SignoutResponse=function t(e){!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var i=n.UrlUtility.parseUrlFragment(e,"?");this.error=i.error,this.error_description=i.error_description,this.error_uri=i.error_uri,this.state=i.state}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.InMemoryWebStorage=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.InMemoryWebStorage=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t),this._data={}}return t.prototype.getItem=function t(e){return i.Log.debug("InMemoryWebStorage.getItem",e),this._data[e]},t.prototype.setItem=function t(e,r){i.Log.debug("InMemoryWebStorage.setItem",e),this._data[e]=r},t.prototype.removeItem=function t(e){i.Log.debug("InMemoryWebStorage.removeItem",e),delete this._data[e]},t.prototype.key=function t(e){return Object.getOwnPropertyNames(this._data)[e]},n(t,[{key:"length",get:function t(){return Object.getOwnPropertyNames(this._data).length}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserManager=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(9),s=r(41),a=r(15),u=r(47),c=r(49),h=r(18),l=r(20),f=r(10),d=r(4);e.UserManager=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.SilentRenewService,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:h.SessionMonitor,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:l.TokenRevocationClient,p=arguments.length>4&&void 0!==arguments[4]?arguments[4]:f.TokenClient,g=arguments.length>5&&void 0!==arguments[5]?arguments[5]:d.JoseUtil;!function v(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),r instanceof s.UserManagerSettings||(r=new s.UserManagerSettings(r));var y=function m(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,r));return y._events=new u.UserManagerEvents(r),y._silentRenewService=new n(y),y.settings.automaticSilentRenew&&(i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"),y.startSilentRenew()),y.settings.monitorSession&&(i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"),y._sessionMonitor=new o(y)),y._tokenRevocationClient=new a(y._settings),y._tokenClient=new p(y._settings),y._joseUtil=g,y}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.getUser=function t(){var e=this;return this._loadUser().then(function(t){return t?(i.Log.info("UserManager.getUser: user loaded"),e._events.load(t,!1),t):(i.Log.info("UserManager.getUser: user not found in storage"),null)})},e.prototype.removeUser=function t(){var e=this;return this.storeUser(null).then(function(){i.Log.info("UserManager.removeUser: user removed from storage"),e._events.unload()})},e.prototype.signinRedirect=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="si:r";var r={useReplaceToNavigate:e.useReplaceToNavigate};return this._signinStart(e,this._redirectNavigator,r).then(function(){i.Log.info("UserManager.signinRedirect: successful")})},e.prototype.signinRedirectCallback=function t(e){return this._signinEnd(e||this._redirectNavigator.url).then(function(t){return t.profile&&t.profile.sub?i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinRedirectCallback: no sub"),t})},e.prototype.signinPopup=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="si:p";var r=e.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return r?(e.redirect_uri=r,e.display="popup",this._signin(e,this._popupNavigator,{startUrl:r,popupWindowFeatures:e.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:e.popupWindowTarget||this.settings.popupWindowTarget}).then(function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinPopup: no sub")),t})):(i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},e.prototype.signinPopupCallback=function t(e){return this._signinCallback(e,this._popupNavigator).then(function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinPopupCallback: no sub")),t}).catch(function(t){i.Log.error(t.message)})},e.prototype.signinSilent=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return(r=Object.assign({},r)).request_type="si:s",this._loadUser().then(function(t){return t&&t.refresh_token?(r.refresh_token=t.refresh_token,e._useRefreshToken(r)):(r.id_token_hint=r.id_token_hint||e.settings.includeIdTokenInSilentRenew&&t&&t.id_token,t&&e._settings.validateSubOnSilentRenew&&(i.Log.debug("UserManager.signinSilent, subject prior to silent renew: ",t.profile.sub),r.current_sub=t.profile.sub),e._signinSilentIframe(r))})},e.prototype._useRefreshToken=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._tokenClient.exchangeRefreshToken(r).then(function(t){return t?t.access_token?e._loadUser().then(function(r){if(r){var n=Promise.resolve();return t.id_token&&(n=e._validateIdTokenFromTokenRefreshToken(r.profile,t.id_token)),n.then(function(){return i.Log.debug("UserManager._useRefreshToken: refresh token response success"),r.id_token=t.id_token,r.access_token=t.access_token,r.refresh_token=t.refresh_token||r.refresh_token,r.expires_in=t.expires_in,e.storeUser(r).then(function(){return e._events.load(r),r})})}return null}):(i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"),Promise.reject("No access token returned from token endpoint")):(i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"),Promise.reject("No response returned from token endpoint"))})},e.prototype._validateIdTokenFromTokenRefreshToken=function t(e,r){var n=this;return this._metadataService.getIssuer().then(function(t){return n._joseUtil.validateJwtAttributes(r,t,n._settings.client_id,n._settings.clockSkew).then(function(t){return t?t.sub!==e.sub?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"),Promise.reject(new Error("sub in id_token does not match current sub"))):t.auth_time&&t.auth_time!==e.auth_time?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"),Promise.reject(new Error("auth_time in id_token does not match original auth_time"))):t.azp&&t.azp!==e.azp?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"),Promise.reject(new Error("azp in id_token does not match original azp"))):!t.azp&&e.azp?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"),Promise.reject(new Error("azp not in id_token, but present in original id_token"))):void 0:(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"),Promise.reject(new Error("Failed to validate id_token")))})})},e.prototype._signinSilentIframe=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.redirect_uri||this.settings.silent_redirect_uri||this.settings.redirect_uri;return r?(e.redirect_uri=r,e.prompt=e.prompt||"none",this._signin(e,this._iframeNavigator,{startUrl:r,silentRequestTimeout:e.silentRequestTimeout||this.settings.silentRequestTimeout}).then(function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinSilent: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinSilent: no sub")),t})):(i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype.signinSilentCallback=function t(e){return this._signinCallback(e,this._iframeNavigator).then(function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinSilentCallback: no sub")),t})},e.prototype.signinCallback=function t(e){var r=this;return this.readSigninResponseState(e).then(function(t){var n=t.state;t.response;return"si:r"===n.request_type?r.signinRedirectCallback(e):"si:p"===n.request_type?r.signinPopupCallback(e):"si:s"===n.request_type?r.signinSilentCallback(e):Promise.reject(new Error("invalid response_type in state"))})},e.prototype.signoutCallback=function t(e,r){var n=this;return this.readSignoutResponseState(e).then(function(t){var i=t.state,o=t.response;return i?"so:r"===i.request_type?n.signoutRedirectCallback(e):"so:p"===i.request_type?n.signoutPopupCallback(e,r):Promise.reject(new Error("invalid response_type in state")):o})},e.prototype.querySessionStatus=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(r=Object.assign({},r)).request_type="si:s";var n=r.redirect_uri||this.settings.silent_redirect_uri||this.settings.redirect_uri;return n?(r.redirect_uri=n,r.prompt="none",r.response_type=r.response_type||this.settings.query_status_response_type,r.scope=r.scope||"openid",r.skipUserInfo=!0,this._signinStart(r,this._iframeNavigator,{startUrl:n,silentRequestTimeout:r.silentRequestTimeout||this.settings.silentRequestTimeout}).then(function(t){return e.processSigninResponse(t.url).then(function(t){if(i.Log.debug("UserManager.querySessionStatus: got signin response"),t.session_state&&t.profile.sub)return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ",t.profile.sub),{session_state:t.session_state,sub:t.profile.sub,sid:t.profile.sid};i.Log.info("querySessionStatus successful, user not authenticated")})})):(i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype._signin=function t(e,r){var n=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._signinStart(e,r,i).then(function(t){return n._signinEnd(t.url,e)})},e.prototype._signinStart=function t(e,r){var n=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return r.prepare(o).then(function(t){return i.Log.debug("UserManager._signinStart: got navigator window handle"),n.createSigninRequest(e).then(function(e){return i.Log.debug("UserManager._signinStart: got signin request"),o.url=e.url,o.id=e.state.id,t.navigate(o)}).catch(function(e){throw t.close&&(i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"),t.close()),e})})},e.prototype._signinEnd=function t(e){var r=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.processSigninResponse(e).then(function(t){i.Log.debug("UserManager._signinEnd: got signin response");var e=new a.User(t);if(n.current_sub){if(n.current_sub!==e.profile.sub)return i.Log.debug("UserManager._signinEnd: current user does not match user returned from signin. sub from signin: ",e.profile.sub),Promise.reject(new Error("login_required"));i.Log.debug("UserManager._signinEnd: current user matches user returned from signin")}return r.storeUser(e).then(function(){return i.Log.debug("UserManager._signinEnd: user stored"),r._events.load(e),e})})},e.prototype._signinCallback=function t(e,r){return i.Log.debug("UserManager._signinCallback"),r.callback(e)},e.prototype.signoutRedirect=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="so:r";var r=e.post_logout_redirect_uri||this.settings.post_logout_redirect_uri;r&&(e.post_logout_redirect_uri=r);var n={useReplaceToNavigate:e.useReplaceToNavigate};return this._signoutStart(e,this._redirectNavigator,n).then(function(){i.Log.info("UserManager.signoutRedirect: successful")})},e.prototype.signoutRedirectCallback=function t(e){return this._signoutEnd(e||this._redirectNavigator.url).then(function(t){return i.Log.info("UserManager.signoutRedirectCallback: successful"),t})},e.prototype.signoutPopup=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="so:p";var r=e.post_logout_redirect_uri||this.settings.popup_post_logout_redirect_uri||this.settings.post_logout_redirect_uri;return e.post_logout_redirect_uri=r,e.display="popup",e.post_logout_redirect_uri&&(e.state=e.state||{}),this._signout(e,this._popupNavigator,{startUrl:r,popupWindowFeatures:e.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:e.popupWindowTarget||this.settings.popupWindowTarget}).then(function(){i.Log.info("UserManager.signoutPopup: successful")})},e.prototype.signoutPopupCallback=function t(e,r){void 0===r&&"boolean"==typeof e&&(r=e,e=null);return this._popupNavigator.callback(e,r,"?").then(function(){i.Log.info("UserManager.signoutPopupCallback: successful")})},e.prototype._signout=function t(e,r){var n=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._signoutStart(e,r,i).then(function(t){return n._signoutEnd(t.url)})},e.prototype._signoutStart=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=this,n=arguments[1],o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return n.prepare(o).then(function(t){return i.Log.debug("UserManager._signoutStart: got navigator window handle"),r._loadUser().then(function(n){return i.Log.debug("UserManager._signoutStart: loaded current user from storage"),(r._settings.revokeAccessTokenOnSignout?r._revokeInternal(n):Promise.resolve()).then(function(){var s=e.id_token_hint||n&&n.id_token;return s&&(i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"),e.id_token_hint=s),r.removeUser().then(function(){return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"),r.createSignoutRequest(e).then(function(e){return i.Log.debug("UserManager._signoutStart: got signout request"),o.url=e.url,e.state&&(o.id=e.state.id),t.navigate(o)})})})}).catch(function(e){throw t.close&&(i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"),t.close()),e})})},e.prototype._signoutEnd=function t(e){return this.processSignoutResponse(e).then(function(t){return i.Log.debug("UserManager._signoutEnd: got signout response"),t})},e.prototype.revokeAccessToken=function t(){var e=this;return this._loadUser().then(function(t){return e._revokeInternal(t,!0).then(function(r){if(r)return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"),t.access_token=null,t.refresh_token=null,t.expires_at=null,t.token_type=null,e.storeUser(t).then(function(){i.Log.debug("UserManager.revokeAccessToken: user stored"),e._events.load(t)})})}).then(function(){i.Log.info("UserManager.revokeAccessToken: access token revoked successfully")})},e.prototype._revokeInternal=function t(e,r){var n=this;if(e){var o=e.access_token,s=e.refresh_token;return this._revokeAccessTokenInternal(o,r).then(function(t){return n._revokeRefreshTokenInternal(s,r).then(function(e){return t||e||i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"),t||e})})}return Promise.resolve(!1)},e.prototype._revokeAccessTokenInternal=function t(e,r){return!e||e.indexOf(".")>=0?Promise.resolve(!1):this._tokenRevocationClient.revoke(e,r).then(function(){return!0})},e.prototype._revokeRefreshTokenInternal=function t(e,r){return e?this._tokenRevocationClient.revoke(e,r,"refresh_token").then(function(){return!0}):Promise.resolve(!1)},e.prototype.startSilentRenew=function t(){this._silentRenewService.start()},e.prototype.stopSilentRenew=function t(){this._silentRenewService.stop()},e.prototype._loadUser=function t(){return this._userStore.get(this._userStoreKey).then(function(t){return t?(i.Log.debug("UserManager._loadUser: user storageString loaded"),a.User.fromStorageString(t)):(i.Log.debug("UserManager._loadUser: no user storageString"),null)})},e.prototype.storeUser=function t(e){if(e){i.Log.debug("UserManager.storeUser: storing user");var r=e.toStorageString();return this._userStore.set(this._userStoreKey,r)}return i.Log.debug("storeUser.storeUser: removing user"),this._userStore.remove(this._userStoreKey)},n(e,[{key:"_redirectNavigator",get:function t(){return this.settings.redirectNavigator}},{key:"_popupNavigator",get:function t(){return this.settings.popupNavigator}},{key:"_iframeNavigator",get:function t(){return this.settings.iframeNavigator}},{key:"_userStore",get:function t(){return this.settings.userStore}},{key:"events",get:function t(){return this._events}},{key:"_userStoreKey",get:function t(){return"user:"+this.settings.authority+":"+this.settings.client_id}}]),e}(o.OidcClient)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserManagerSettings=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=(r(0),r(5)),o=r(42),s=r(43),a=r(45),u=r(6),c=r(1),h=r(12);var l=60,f=2e3;e.UserManagerSettings=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.popup_redirect_uri,i=r.popup_post_logout_redirect_uri,d=r.popupWindowFeatures,p=r.popupWindowTarget,g=r.silent_redirect_uri,v=r.silentRequestTimeout,y=r.automaticSilentRenew,m=void 0!==y&&y,_=r.validateSubOnSilentRenew,S=void 0!==_&&_,F=r.includeIdTokenInSilentRenew,b=void 0===F||F,w=r.monitorSession,E=void 0===w||w,x=r.checkSessionInterval,k=void 0===x?f:x,A=r.stopCheckSessionOnError,P=void 0===A||A,C=r.query_status_response_type,T=r.revokeAccessTokenOnSignout,R=void 0!==T&&T,I=r.accessTokenExpiringNotificationTime,D=void 0===I?l:I,L=r.redirectNavigator,U=void 0===L?new o.RedirectNavigator:L,B=r.popupNavigator,N=void 0===B?new s.PopupNavigator:B,O=r.iframeNavigator,j=void 0===O?new a.IFrameNavigator:O,H=r.userStore,M=void 0===H?new u.WebStorageStateStore({store:c.Global.sessionStorage}):H;!function K(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var V=function q(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,arguments[0]));return V._popup_redirect_uri=n,V._popup_post_logout_redirect_uri=i,V._popupWindowFeatures=d,V._popupWindowTarget=p,V._silent_redirect_uri=g,V._silentRequestTimeout=v,V._automaticSilentRenew=m,V._validateSubOnSilentRenew=S,V._includeIdTokenInSilentRenew=b,V._accessTokenExpiringNotificationTime=D,V._monitorSession=E,V._checkSessionInterval=k,V._stopCheckSessionOnError=P,C?V._query_status_response_type=C:arguments[0]&&arguments[0].response_type?V._query_status_response_type=h.SigninRequest.isOidc(arguments[0].response_type)?"id_token":"code":V._query_status_response_type="id_token",V._revokeAccessTokenOnSignout=R,V._redirectNavigator=U,V._popupNavigator=N,V._iframeNavigator=j,V._userStore=M,V}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),n(e,[{key:"popup_redirect_uri",get:function t(){return this._popup_redirect_uri}},{key:"popup_post_logout_redirect_uri",get:function t(){return this._popup_post_logout_redirect_uri}},{key:"popupWindowFeatures",get:function t(){return this._popupWindowFeatures}},{key:"popupWindowTarget",get:function t(){return this._popupWindowTarget}},{key:"silent_redirect_uri",get:function t(){return this._silent_redirect_uri}},{key:"silentRequestTimeout",get:function t(){return this._silentRequestTimeout}},{key:"automaticSilentRenew",get:function t(){return this._automaticSilentRenew}},{key:"validateSubOnSilentRenew",get:function t(){return this._validateSubOnSilentRenew}},{key:"includeIdTokenInSilentRenew",get:function t(){return this._includeIdTokenInSilentRenew}},{key:"accessTokenExpiringNotificationTime",get:function t(){return this._accessTokenExpiringNotificationTime}},{key:"monitorSession",get:function t(){return this._monitorSession}},{key:"checkSessionInterval",get:function t(){return this._checkSessionInterval}},{key:"stopCheckSessionOnError",get:function t(){return this._stopCheckSessionOnError}},{key:"query_status_response_type",get:function t(){return this._query_status_response_type}},{key:"revokeAccessTokenOnSignout",get:function t(){return this._revokeAccessTokenOnSignout}},{key:"redirectNavigator",get:function t(){return this._redirectNavigator}},{key:"popupNavigator",get:function t(){return this._popupNavigator}},{key:"iframeNavigator",get:function t(){return this._iframeNavigator}},{key:"userStore",get:function t(){return this._userStore}}]),e}(i.OidcClientSettings)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.RedirectNavigator=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.RedirectNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(){return Promise.resolve(this)},t.prototype.navigate=function t(e){return e&&e.url?(e.useReplaceToNavigate?window.location.replace(e.url):window.location=e.url,Promise.resolve()):(i.Log.error("RedirectNavigator.navigate: No url provided"),Promise.reject(new Error("No url provided")))},n(t,[{key:"url",get:function t(){return window.location.href}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.PopupNavigator=void 0;var n=r(0),i=r(44);e.PopupNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){var r=new i.PopupWindow(e);return Promise.resolve(r)},t.prototype.callback=function t(e,r,o){n.Log.debug("PopupNavigator.callback");try{return i.PopupWindow.notifyOpener(e,r,o),Promise.resolve()}catch(t){return Promise.reject(t)}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.PopupWindow=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(3);var s=500,a="location=no,toolbar=no,width=500,height=500,left=100,top=100;",u="_blank";e.PopupWindow=function(){function t(e){var r=this;!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._promise=new Promise(function(t,e){r._resolve=t,r._reject=e});var o=e.popupWindowTarget||u,c=e.popupWindowFeatures||a;this._popup=window.open("",o,c),this._popup&&(i.Log.debug("PopupWindow.ctor: popup successfully created"),this._checkForPopupClosedTimer=window.setInterval(this._checkForPopupClosed.bind(this),s))}return t.prototype.navigate=function t(e){return this._popup?e&&e.url?(i.Log.debug("PopupWindow.navigate: Setting URL in popup"),this._id=e.id,this._id&&(window["popupCallback_"+e.id]=this._callback.bind(this)),this._popup.focus(),this._popup.window.location=e.url):(this._error("PopupWindow.navigate: no url provided"),this._error("No url provided")):this._error("PopupWindow.navigate: Error opening popup window"),this.promise},t.prototype._success=function t(e){i.Log.debug("PopupWindow.callback: Successful response from popup window"),this._cleanup(),this._resolve(e)},t.prototype._error=function t(e){i.Log.error("PopupWindow.error: ",e),this._cleanup(),this._reject(new Error(e))},t.prototype.close=function t(){this._cleanup(!1)},t.prototype._cleanup=function t(e){i.Log.debug("PopupWindow.cleanup"),window.clearInterval(this._checkForPopupClosedTimer),this._checkForPopupClosedTimer=null,delete window["popupCallback_"+this._id],this._popup&&!e&&this._popup.close(),this._popup=null},t.prototype._checkForPopupClosed=function t(){this._popup&&!this._popup.closed||this._error("Popup window closed")},t.prototype._callback=function t(e,r){this._cleanup(r),e?(i.Log.debug("PopupWindow.callback success"),this._success({url:e})):(i.Log.debug("PopupWindow.callback: Invalid response from popup"),this._error("Invalid response from popup"))},t.notifyOpener=function t(e,r,n){if(window.opener){if(e=e||window.location.href){var s=o.UrlUtility.parseUrlFragment(e,n);if(s.state){var a="popupCallback_"+s.state,u=window.opener[a];u?(i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"),u(e,r)):i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener")}else i.Log.warn("PopupWindow.notifyOpener: no state found in response url")}}else i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.")},n(t,[{key:"promise",get:function t(){return this._promise}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.IFrameNavigator=void 0;var n=r(0),i=r(46);e.IFrameNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){var r=new i.IFrameWindow(e);return Promise.resolve(r)},t.prototype.callback=function t(e){n.Log.debug("IFrameNavigator.callback");try{return i.IFrameWindow.notifyParent(e),Promise.resolve()}catch(t){return Promise.reject(t)}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.IFrameWindow=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.IFrameWindow=function(){function t(e){var r=this;!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._promise=new Promise(function(t,e){r._resolve=t,r._reject=e}),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1),this._frame=window.document.createElement("iframe"),this._frame.style.visibility="hidden",this._frame.style.position="absolute",this._frame.style.display="none",this._frame.style.width=0,this._frame.style.height=0,window.document.body.appendChild(this._frame)}return t.prototype.navigate=function t(e){if(e&&e.url){var r=e.silentRequestTimeout||1e4;i.Log.debug("IFrameWindow.navigate: Using timeout of:",r),this._timer=window.setTimeout(this._timeout.bind(this),r),this._frame.src=e.url}else this._error("No url provided");return this.promise},t.prototype._success=function t(e){this._cleanup(),i.Log.debug("IFrameWindow: Successful response from frame window"),this._resolve(e)},t.prototype._error=function t(e){this._cleanup(),i.Log.error(e),this._reject(new Error(e))},t.prototype.close=function t(){this._cleanup()},t.prototype._cleanup=function t(){this._frame&&(i.Log.debug("IFrameWindow: cleanup"),window.removeEventListener("message",this._boundMessageEvent,!1),window.clearTimeout(this._timer),window.document.body.removeChild(this._frame),this._timer=null,this._frame=null,this._boundMessageEvent=null)},t.prototype._timeout=function t(){i.Log.debug("IFrameWindow.timeout"),this._error("Frame window timed out")},t.prototype._message=function t(e){if(i.Log.debug("IFrameWindow.message"),this._timer&&e.origin===this._origin&&e.source===this._frame.contentWindow){var r=e.data;r?this._success({url:r}):this._error("Invalid response from frame")}},t.notifyParent=function t(e){i.Log.debug("IFrameWindow.notifyParent"),window.frameElement&&(e=e||window.location.href)&&(i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"),window.parent.postMessage(e,location.protocol+"//"+location.host))},n(t,[{key:"promise",get:function t(){return this._promise}},{key:"_origin",get:function t(){return location.protocol+"//"+location.host}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserManagerEvents=void 0;var n=r(0),i=r(16),o=r(17);e.UserManagerEvents=function(t){function e(r){!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var i=function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,r));return i._userLoaded=new o.Event("User loaded"),i._userUnloaded=new o.Event("User unloaded"),i._silentRenewError=new o.Event("Silent renew error"),i._userSignedOut=new o.Event("User signed out"),i._userSessionChanged=new o.Event("User session changed"),i}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.load=function e(r){var i=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];n.Log.debug("UserManagerEvents.load"),t.prototype.load.call(this,r),i&&this._userLoaded.raise(r)},e.prototype.unload=function e(){n.Log.debug("UserManagerEvents.unload"),t.prototype.unload.call(this),this._userUnloaded.raise()},e.prototype.addUserLoaded=function t(e){this._userLoaded.addHandler(e)},e.prototype.removeUserLoaded=function t(e){this._userLoaded.removeHandler(e)},e.prototype.addUserUnloaded=function t(e){this._userUnloaded.addHandler(e)},e.prototype.removeUserUnloaded=function t(e){this._userUnloaded.removeHandler(e)},e.prototype.addSilentRenewError=function t(e){this._silentRenewError.addHandler(e)},e.prototype.removeSilentRenewError=function t(e){this._silentRenewError.removeHandler(e)},e.prototype._raiseSilentRenewError=function t(e){n.Log.debug("UserManagerEvents._raiseSilentRenewError",e.message),this._silentRenewError.raise(e)},e.prototype.addUserSignedOut=function t(e){this._userSignedOut.addHandler(e)},e.prototype.removeUserSignedOut=function t(e){this._userSignedOut.removeHandler(e)},e.prototype._raiseUserSignedOut=function t(){n.Log.debug("UserManagerEvents._raiseUserSignedOut"),this._userSignedOut.raise()},e.prototype.addUserSessionChanged=function t(e){this._userSessionChanged.addHandler(e)},e.prototype.removeUserSessionChanged=function t(e){this._userSessionChanged.removeHandler(e)},e.prototype._raiseUserSessionChanged=function t(){n.Log.debug("UserManagerEvents._raiseUserSessionChanged"),this._userSessionChanged.raise()},e}(i.AccessTokenEvents)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Timer=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(1),s=r(17);e.Timer=function(t){function e(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.Global.timer,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;!function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var a=function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,r));return a._timer=n,a._nowFunc=i||function(){return Date.now()/1e3},a}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.init=function t(e){e<=0&&(e=1),e=parseInt(e);var r=this.now+e;if(this.expiration===r&&this._timerHandle)i.Log.debug("Timer.init timer "+this._name+" skipping initialization since already initialized for expiration:",this.expiration);else{this.cancel(),i.Log.debug("Timer.init timer "+this._name+" for duration:",e),this._expiration=r;var n=5;e<n&&(n=e),this._timerHandle=this._timer.setInterval(this._callback.bind(this),1e3*n)}},e.prototype.cancel=function t(){this._timerHandle&&(i.Log.debug("Timer.cancel: ",this._name),this._timer.clearInterval(this._timerHandle),this._timerHandle=null)},e.prototype._callback=function e(){var r=this._expiration-this.now;i.Log.debug("Timer.callback; "+this._name+" timer expires in:",r),this._expiration<=this.now&&(this.cancel(),t.prototype.raise.call(this))},n(e,[{key:"now",get:function t(){return parseInt(this._nowFunc())}},{key:"expiration",get:function t(){return this._expiration}}]),e}(s.Event)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SilentRenewService=void 0;var n=r(0);e.SilentRenewService=function(){function t(e){!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._userManager=e}return t.prototype.start=function t(){this._callback||(this._callback=this._tokenExpiring.bind(this),this._userManager.events.addAccessTokenExpiring(this._callback),this._userManager.getUser().then(function(t){}).catch(function(t){n.Log.error("SilentRenewService.start: Error from getUser:",t.message)}))},t.prototype.stop=function t(){this._callback&&(this._userManager.events.removeAccessTokenExpiring(this._callback),delete this._callback)},t.prototype._tokenExpiring=function t(){var e=this;this._userManager.signinSilent().then(function(t){n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful")},function(t){n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:",t.message),e._userManager.events._raiseSilentRenewError(t)})},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CordovaPopupNavigator=void 0;var n=r(21);e.CordovaPopupNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){var r=new n.CordovaPopupWindow(e);return Promise.resolve(r)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CordovaIFrameNavigator=void 0;var n=r(21);e.CordovaIFrameNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){e.popupWindowFeatures="hidden=yes";var r=new n.CordovaPopupWindow(e);return Promise.resolve(r)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.Version="1.9.1"}])});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var onLocationChanged = exports.onLocationChanged = function onLocationChanged(location, action) {
  return {
    type: _get__('LOCATION_CHANGE'),
    payload: {
      location: location,
      action: action
    }
  };
};

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

var updateLocation = function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: _get__('CALL_HISTORY_METHOD'),
      payload: {
        method: method,
        args: args
      }
    };
  };
};

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = _get__('updateLocation')('push');
var replace = exports.replace = _get__('updateLocation')('replace');
var go = exports.go = _get__('updateLocation')('go');
var goBack = exports.goBack = _get__('updateLocation')('goBack');
var goForward = exports.goForward = _get__('updateLocation')('goForward');

var routerActions = exports.routerActions = { push: _get__('push'), replace: _get__('replace'), go: _get__('go'), goBack: _get__('goBack'), goForward: _get__('goForward') };

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LOCATION_CHANGE':
      return LOCATION_CHANGE;

    case 'CALL_HISTORY_METHOD':
      return CALL_HISTORY_METHOD;

    case 'updateLocation':
      return updateLocation;

    case 'push':
      return push;

    case 'replace':
      return replace;

    case 'go':
      return go;

    case 'goBack':
      return goBack;

    case 'goForward':
      return goForward;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports.default = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
  CHARSET: 'charset',
  CSS_TEXT: 'cssText',
  HREF: 'href',
  HTTPEQUIV: 'http-equiv',
  INNER_HTML: 'innerHTML',
  ITEM_PROP: 'itemprop',
  NAME: 'name',
  PROPERTY: 'property',
  REL: 'rel',
  SRC: 'src'
};

var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
  BODY: 'bodyAttributes',
  HTML: 'htmlAttributes',
  TITLE: 'titleAttributes'
};

var TAG_NAMES = exports.TAG_NAMES = {
  BASE: 'base',
  BODY: 'body',
  HEAD: 'head',
  HTML: 'html',
  LINK: 'link',
  META: 'meta',
  NOSCRIPT: 'noscript',
  SCRIPT: 'script',
  STYLE: 'style',
  TITLE: 'title',
  FRAGMENT: 'Symbol(react.fragment)'
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
  return TAG_NAMES[name];
});

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
  accesskey: 'accessKey',
  charset: 'charSet',
  class: 'className',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  'http-equiv': 'httpEquiv',
  itemprop: 'itemProp',
  tabindex: 'tabIndex'
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
  obj[REACT_TAG_MAP[key]] = key;
  return obj;
}, {});

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = 'data-rh';

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthRouter__ = __webpack_require__(771);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userManager__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__userManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Login__ = __webpack_require__(380);
/* unused harmony reexport Login */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logout__ = __webpack_require__(383);
/* unused harmony reexport Logout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Session__ = __webpack_require__(384);
/* unused harmony reexport Session */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Callback__ = __webpack_require__(385);
/* unused harmony reexport Callback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivateRoute__ = __webpack_require__(778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__PrivateRoute__["a"]; });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(15).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer
var MD5 = __webpack_require__(242)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var utils = __webpack_require__(53);
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(846)
var aesid = __webpack_require__(857)
var fixProc = __webpack_require__(858)
var ciphers = __webpack_require__(251)
var compat = __webpack_require__(398)
var Buffer = __webpack_require__(15).Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["a"]; });


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardBrands__ = __webpack_require__(887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CardBrands__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(888);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(889);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeVisualizationContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVisualizationContext; });
var changeVisualizationContext=function changeVisualizationContext(cash){return{type:'ONLY_CASH',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/participants/VisualizationContext',data:{VisualizationContext:cash}}}};};var getVisualizationContext=function getVisualizationContext(){return{type:'PARTICIPANT_VISUALIZATION_CONTEXT',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/VisualizationContext'}}};};

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrackingItem__ = __webpack_require__(990);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__TrackingItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductShipping__ = __webpack_require__(994);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ProductShipping__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSide__ = __webpack_require__(995);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ProductSide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductSideEmpty__ = __webpack_require__(1001);
/* unused harmony reexport ProductSideEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Title__ = __webpack_require__(1002);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__availableVendors__ = __webpack_require__(1003);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__availableVendors__["a"]; });


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/placeholder.8249cee5.svg";

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var composeURL=function composeURL(_ref){var url=_ref.url,_ref$remoteSuffix=_ref.remoteSuffix,remoteSuffix=_ref$remoteSuffix===undefined?'':_ref$remoteSuffix,_ref$localSuffix=_ref.localSuffix,localSuffix=_ref$localSuffix===undefined?'':_ref$localSuffix;return url&&url+'/'+(url.indexOf('localhost')>-1?localSuffix:remoteSuffix);};var FingerPrintContainer=function FingerPrintContainer(_ref2){var accessToken=_ref2.accessToken;var endpoint=composeURL({url:"https://api.ltm.digital",remoteSuffix:'cloudloyalty'});var subscriptionKey="4c8e61c3270c44bb8d274d090a2a97c5";var headers={Authorization:'Bearer '+accessToken,'Ocp-Apim-Subscription-Key':subscriptionKey};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["FingerPrint"],{headers:headers,endpoint:endpoint}));};var mapStateToProps=function mapStateToProps(_ref3){var accessToken=_ref3.oidc.user.access_token;return{accessToken:accessToken};};FingerPrintContainer.propTypes={accessToken:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(FingerPrintContainer));

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExtractPage__ = __webpack_require__(1057);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ExtractPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Extract__ = __webpack_require__(1058);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Extract__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1080);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1081);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Totalizers__ = __webpack_require__(1059);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Totalizers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Balance__ = __webpack_require__(1061);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Balance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__History__ = __webpack_require__(1062);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__History__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(1063);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Item__["a"]; });


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Details__ = __webpack_require__(1066);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Details__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccountStatement__ = __webpack_require__(1073);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AccountStatement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Expirations__ = __webpack_require__(1075);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Expirations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(1076);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Filters__ = __webpack_require__(1077);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Filters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Empty__ = __webpack_require__(1078);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Empty__["a"]; });


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTabPanel;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTabList;
function isTab(el) {
  return el.type && el.type.tabsRole === 'Tab';
}
function isTabPanel(el) {
  return el.type && el.type.tabsRole === 'TabPanel';
}
function isTabList(el) {
  return el.type && el.type.tabsRole === 'TabList';
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_aws_sdk_global__; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// import * as S3 from 'aws-sdk/clients/s3';

// import * as Pinpoint from 'aws-sdk/clients/pinpoint';
// import * as Kinesis from 'aws-sdk/clients/kinesis';
// import * as MobileAnalytics from 'aws-sdk/clients/mobileanalytics';
// export {AWS, S3, Pinpoint, MobileAnalytics, Kinesis };

//# sourceMappingURL=Facet.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var populateHostPrefix = __webpack_require__(281).populateHostPrefix;

function populateMethod(req) {
  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}

function generateURI(endpointPath, operationPath, input, params) {
  var uri = [endpointPath, operationPath].join('/');
  uri = uri.replace(/\/+/g, '/');

  var queryString = {}, queryStringSet = false;
  util.each(input.members, function (name, member) {
    var paramValue = params[name];
    if (paramValue === null || paramValue === undefined) return;
    if (member.location === 'uri') {
      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
      uri = uri.replace(regex, function(_, plus) {
        var fn = plus ? util.uriEscapePath : util.uriEscape;
        return fn(String(paramValue));
      });
    } else if (member.location === 'querystring') {
      queryStringSet = true;

      if (member.type === 'list') {
        queryString[member.name] = paramValue.map(function(val) {
          return util.uriEscape(member.member.toWireFormat(val).toString());
        });
      } else if (member.type === 'map') {
        util.each(paramValue, function(key, value) {
          if (Array.isArray(value)) {
            queryString[key] = value.map(function(val) {
              return util.uriEscape(String(val));
            });
          } else {
            queryString[key] = util.uriEscape(String(value));
          }
        });
      } else {
        queryString[member.name] = util.uriEscape(member.toWireFormat(paramValue).toString());
      }
    }
  });

  if (queryStringSet) {
    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
    var parts = [];
    util.arrayEach(Object.keys(queryString).sort(), function(key) {
      if (!Array.isArray(queryString[key])) {
        queryString[key] = [queryString[key]];
      }
      for (var i = 0; i < queryString[key].length; i++) {
        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
      }
    });
    uri += parts.join('&');
  }

  return uri;
}

function populateURI(req) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
  req.httpRequest.path = uri;
}

function populateHeaders(req) {
  var operation = req.service.api.operations[req.operation];
  util.each(operation.input.members, function (name, member) {
    var value = req.params[name];
    if (value === null || value === undefined) return;

    if (member.location === 'headers' && member.type === 'map') {
      util.each(value, function(key, memberValue) {
        req.httpRequest.headers[member.name + key] = memberValue;
      });
    } else if (member.location === 'header') {
      value = member.toWireFormat(value).toString();
      if (member.isJsonValue) {
        value = util.base64.encode(value);
      }
      req.httpRequest.headers[member.name] = value;
    }
  });
}

function buildRequest(req) {
  populateMethod(req);
  populateURI(req);
  populateHeaders(req);
  populateHostPrefix(req);
}

function extractError() {
}

function extractData(resp) {
  var req = resp.request;
  var data = {};
  var r = resp.httpResponse;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  // normalize headers names to lower-cased keys for matching
  var headers = {};
  util.each(r.headers, function (k, v) {
    headers[k.toLowerCase()] = v;
  });

  util.each(output.members, function(name, member) {
    var header = (member.name || name).toLowerCase();
    if (member.location === 'headers' && member.type === 'map') {
      data[name] = {};
      var location = member.isLocationName ? member.name : '';
      var pattern = new RegExp('^' + location + '(.+)', 'i');
      util.each(r.headers, function (k, v) {
        var result = k.match(pattern);
        if (result !== null) {
          data[name][result[1]] = v;
        }
      });
    } else if (member.location === 'header') {
      if (headers[header] !== undefined) {
        var value = member.isJsonValue ?
          util.base64.decode(headers[header]) :
          headers[header];
        data[name] = member.toType(value);
      }
    } else if (member.location === 'statusCode') {
      data[name] = parseInt(r.statusCode, 10);
    }
  });

  resp.data = data;
}

/**
 * @api private
 */
module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData,
  generateURI: generateURI
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(23).Buffer;

/**
 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
 * e.g. missing in IE 10.
 *
 * @api private
 */
if (
    typeof ArrayBuffer !== 'undefined' &&
    typeof ArrayBuffer.isView === 'undefined'
) {
    ArrayBuffer.isView = function(arg) {
        return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
    };
}

/**
 * @api private
 */
var viewStrings = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]',
    '[object DataView]',
];

/**
 * @api private
 */
function isEmptyData(data) {
    if (typeof data === 'string') {
        return data.length === 0;
    }
    return data.byteLength === 0;
}

/**
 * @api private
 */
function convertToBuffer(data) {
    if (typeof data === 'string') {
        data = new Buffer(data, 'utf8');
    }

    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }

    return new Uint8Array(data);
}

/**
 * @api private
 */
module.exports = exports = {
    isEmptyData: isEmptyData,
    convertToBuffer: convertToBuffer,
};


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Amplify');
var Amplify = /** @class */ (function () {
    function Amplify() {
    }
    Amplify.register = function (comp) {
        logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            Amplify[comp.getModuleName()] = comp;
        }
        else {
            logger.debug('no getModuleName method for component', comp);
        }
    };
    Amplify.configure = function (config) {
        var _this = this;
        if (!config)
            return this._config;
        this._config = Object.assign(this._config, config);
        logger.debug('amplify config', this._config);
        this._components.map(function (comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    Amplify.addPluggable = function (pluggable) {
        if (pluggable &&
            pluggable['getCategory'] &&
            typeof pluggable['getCategory'] === 'function') {
            this._components.map(function (comp) {
                if (comp['addPluggable'] &&
                    typeof comp['addPluggable'] === 'function') {
                    comp.addPluggable(pluggable);
                }
            });
        }
    };
    Amplify._components = [];
    Amplify._config = {};
    // for backward compatibility to avoid breaking change
    // if someone is using like Amplify.Auth
    Amplify.Auth = null;
    Amplify.Analytics = null;
    Amplify.API = null;
    Amplify.Storage = null;
    Amplify.I18n = null;
    Amplify.Cache = null;
    Amplify.PubSub = null;
    Amplify.Interactions = null;
    Amplify.Pushnotification = null;
    Amplify.UI = null;
    Amplify.XR = null;
    Amplify.Predictions = null;
    Amplify.Logger = __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */];
    Amplify.ServiceWorker = null;
    return Amplify;
}());
/* harmony default export */ __webpack_exports__["a"] = (Amplify);
//# sourceMappingURL=Amplify.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PointsCash__ = __webpack_require__(1248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__PointsCash__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PointsCashCardBrands__ = __webpack_require__(1249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__PointsCashCardBrands__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PointsCashContent__ = __webpack_require__(1250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__PointsCashContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PointsCashContainer__ = __webpack_require__(1252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__PointsCashContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Range__ = __webpack_require__(1253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__Range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditCard__ = __webpack_require__(1272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__CreditCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditCardFront__ = __webpack_require__(1274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__CreditCardFront__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreditCardBack__ = __webpack_require__(1275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__CreditCardBack__["a"]; });


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _captialize = __webpack_require__(1257);

Object.defineProperty(exports, 'captialize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_captialize).default;
  }
});

var _clamp = __webpack_require__(1258);

Object.defineProperty(exports, 'clamp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_clamp).default;
  }
});

var _distanceTo = __webpack_require__(1259);

Object.defineProperty(exports, 'distanceTo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_distanceTo).default;
  }
});

var _isDefined = __webpack_require__(1260);

Object.defineProperty(exports, 'isDefined', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isDefined).default;
  }
});

var _isNumber = __webpack_require__(1261);

Object.defineProperty(exports, 'isNumber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isNumber).default;
  }
});

var _isObject = __webpack_require__(1262);

Object.defineProperty(exports, 'isObject', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_isObject).default;
  }
});

var _length = __webpack_require__(1263);

Object.defineProperty(exports, 'length', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_length).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchPointsCashConfig */
/* unused harmony export fetchInstallments */
/* unused harmony export createPurchase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authorizeWithToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authorizeWithTokenResend; });
/* unused harmony export authorizeWithTokenLastTry */
/* unused harmony export redirectConfirmation */
/* unused harmony export success */
/* unused harmony export fetchCashOnlyConfig */
/* unused harmony export clearRedux */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__);
var fetchPointsCashConfig=function fetchPointsCashConfig(){return{type:'FETCH_POINTS_CASH_CONFIG',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/Pointcash/1'}}};};var fetchInstallments=function fetchInstallments(data){return{type:'FETCH_INSTALLMENTS',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/purchases/CalculateInstallment',data:data}}};};var createPurchase=function createPurchase(creditCardPayment){return{type:'CREATE_PURCHASE',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/purchases',data:{channelType:'ONLINE',creditCardPayment:creditCardPayment}}}};};var authorizeWithToken=function authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){var lastTry=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;return{type:'AUTHORIZE_TOKEN',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/purchases/withToken',data:{OrderId:OrderId,PaymentMoneyRequest:PaymentMoneyRequest,Token:Token,TokenType:TokenType,Resend:Resend}}},lastTry:lastTry};};var authorizeWithTokenResend=function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return{type:'AUTHORIZE_RESEND',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/purchases/generateToken',data:{OrderId:OrderId,PaymentMoneyRequest:PaymentMoneyRequest,Token:Token,TokenType:TokenType,Resend:Resend}}}};};var authorizeWithTokenLastTry=function authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return{type:'AUTHORIZE_TOKEN_LAST_TRY',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/purchases/generateToken',data:{OrderId:OrderId,PaymentMoneyRequest:PaymentMoneyRequest,Token:Token,TokenType:TokenType,Resend:Resend}}}};};var redirectConfirmation=function redirectConfirmation(orderId){return Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/confirmation/'+orderId);};var success=function success(){return{type:'SUCCESS'};};var fetchCashOnlyConfig=function fetchCashOnlyConfig(){return{type:'FETCH_CASH_ONLY_CONFIG',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/onlycash/1'}}};};var clearRedux=function clearRedux(){return{type:'CLEAR_CONFIRMED_ORDER_DATA'};};/* harmony default export */ __webpack_exports__["c"] = ({fetchPointsCashConfig:fetchPointsCashConfig,fetchInstallments:fetchInstallments,createPurchase:createPurchase,redirectConfirmation:redirectConfirmation,fetchCashOnlyConfig:fetchCashOnlyConfig,authorizeWithToken:authorizeWithToken,authorizeWithTokenResend:authorizeWithTokenResend,authorizeWithTokenLastTry:authorizeWithTokenLastTry,clearRedux:clearRedux});

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductCardContainer__ = __webpack_require__(1343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductCardContainer__["a"]; });


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__About__ = __webpack_require__(1499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__About__["a"]; });


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VENDORID_CELLPHONE_RECHARGE */
/* unused harmony export SERVICETYPE_MOBILE_RECHARGE */
/* unused harmony export REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REGULATION_TYPE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGULATION_TYPE_CAMPAIGN_AND_VENDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REGULATION_TYPE_VENDOR; });
var VENDORID_CELLPHONE_RECHARGE=71;var SERVICETYPE_MOBILE_RECHARGE=1;var REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE=5;var REGULATION_TYPE_CAMPAIGN='Campaign';var REGULATION_TYPE_CAMPAIGN_AND_VENDOR='VendorAndRegulationType';var REGULATION_TYPE_VENDOR='Vendor';/* harmony default export */ __webpack_exports__["d"] = ({VENDORID_CELLPHONE_RECHARGE:VENDORID_CELLPHONE_RECHARGE,SERVICETYPE_MOBILE_RECHARGE:SERVICETYPE_MOBILE_RECHARGE,REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE:REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE,REGULATION_TYPE_CAMPAIGN:REGULATION_TYPE_CAMPAIGN,REGULATION_TYPE_CAMPAIGN_AND_VENDOR:REGULATION_TYPE_CAMPAIGN_AND_VENDOR,REGULATION_TYPE_VENDOR:REGULATION_TYPE_VENDOR});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalTerms__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalTerms__["a"]; });


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FuelCredit__ = __webpack_require__(1658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FuelCredit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].mileageApi.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Regulation__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_slugify__);
var REGULATION_TYPE_CAMPAIGN='Campaign';var REGULATION_TYPE_CAMPAIGN_AND_VENDOR='VendorAndRegulationType';var REGULATION_TYPE_VENDOR='Vendor';var ModalServices=function ModalServices(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default.a,{width:'1160',height:'500',effect:'fadeInUp',visible:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white py-3 mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title'},props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{name:'Close',className:'btn btn-double btn-flat btn-icon-only btn-icon mx-0',iconName:'icon_close icon-sm',text:'','aria-label':'Fechar',onClick:function onClick(e){return props.onClose();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mx-0 mt-2 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm',style:{height:'250px'}},CheckTypeHandler(props.terms)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  align-items-center h-100  px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-2 px-0 txt-left mr-auto d-none d-md-block'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-12 col-md-4 px-0 txt-right d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'Agree-desktop-'+__WEBPACK_IMPORTED_MODULE_5_react_slugify___default()(props.title,{delimiter:'-'}),name:'Agree',className:'btn btn-double btn-featured btn-icon mx-0',iconName:'icon_check_circle',text:'LI E ACEITO O REGULAMENTO',onClick:function onClick(e){return props.acceptTerms();},loading:props.isLoading})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-12 col-md-4 px-0 txt-right d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'Agree-mobile-'+__WEBPACK_IMPORTED_MODULE_5_react_slugify___default()(props.title,{delimiter:'-'}),name:'Agree',className:'cart-done btn-featured btn-icon nowrap',iconName:'icon_check_circle',text:'LI E ACEITO O REGULAMENTO',onClick:function onClick(e){return props.acceptTerms();},loading:props.isLoading})))))));};var CheckTypeHandler=function CheckTypeHandler(terms){switch(terms.type){case REGULATION_TYPE_CAMPAIGN:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],{campaignId:terms.campaignId});case REGULATION_TYPE_CAMPAIGN_AND_VENDOR:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],{vendorId:terms.vendorId,regulationType:terms.regulationType});case REGULATION_TYPE_VENDOR:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],{vendorId:terms.vendorId});}};ModalServices.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,terms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ModalServices);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StixContainer__ = __webpack_require__(1670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StixContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stix__ = __webpack_require__(627);
/* unused harmony reexport Stix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StixInfos__ = __webpack_require__(1672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__StixInfos__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StixHeader__ = __webpack_require__(1673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__StixHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StixWrapper__ = __webpack_require__(1674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__StixWrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SideBar__ = __webpack_require__(1675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__SideBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StixStars__ = __webpack_require__(1676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__StixStars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducer__ = __webpack_require__(1677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__reducer__["a"]; });


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Bling = __webpack_require__(1759);

Object.defineProperty(exports, "Bling", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bling).default;
  }
});

var _Events = __webpack_require__(323);

Object.defineProperty(exports, "Events", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Events).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search_SearchPage__ = __webpack_require__(1961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Search_SearchPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_SearchVendor__ = __webpack_require__(1969);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Search_SearchVendor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar__ = __webpack_require__(1970);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StoreInfo__ = __webpack_require__(1974);
/* unused harmony reexport StoreInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(1975);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__NotFound__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchTitle__ = __webpack_require__(1976);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__SearchTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchPlaceHolder__ = __webpack_require__(665);
/* unused harmony reexport SearchPlaceHolder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Search_ShowCase__ = __webpack_require__(1977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Search_ShowCase__["a"]; });


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(57);
var toLength = __webpack_require__(28);
var toAbsoluteIndex = __webpack_require__(108);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(65);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(66);
var defined = __webpack_require__(73);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(65);
var MATCH = __webpack_require__(26)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(26)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(134);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(693);
var redefine = __webpack_require__(50);
var hide = __webpack_require__(49);
var fails = __webpack_require__(19);
var defined = __webpack_require__(73);
var wks = __webpack_require__(26);
var regexpExec = __webpack_require__(351);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(50);
var redefineAll = __webpack_require__(114);
var meta = __webpack_require__(90);
var forOf = __webpack_require__(113);
var anInstance = __webpack_require__(112);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(19);
var $iterDetect = __webpack_require__(224);
var setToStringTag = __webpack_require__(133);
var inheritIfRequired = __webpack_require__(337);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var hide = __webpack_require__(49);
var uid = __webpack_require__(106);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(89) || !__webpack_require__(19)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(16)[K];
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(40);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(113);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(15).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(179);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(178);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducePropsToState = exports.flattenArray = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(180);

var HELMET_PROPS = {
  DEFAULT_TITLE: 'defaultTitle',
  DEFER: 'defer',
  ENCODE_SPECIAL_CHARACTERS: 'encodeSpecialCharacters',
  ON_CHANGE_CLIENT_STATE: 'onChangeClientState',
  TITLE_TEMPLATE: 'titleTemplate'
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
  for (var i = propsList.length - 1; i >= 0; i -= 1) {
    var props = propsList[i];

    if (Object.prototype.hasOwnProperty.call(props, property)) {
      return props[property];
    }
  }

  return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
  var innermostTitle = getInnermostProperty(propsList, _constants.TAG_NAMES.TITLE);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(innermostTitle)) {
    innermostTitle = innermostTitle.join('');
  }
  if (innermostTemplate && innermostTitle) {
    // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function () {
      return innermostTitle;
    });
  }

  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

  return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
  return propsList.filter(function (props) {
    return typeof props[tagType] !== 'undefined';
  }).map(function (props) {
    return props[tagType];
  }).reduce(function (tagAttrs, current) {
    return _extends({}, tagAttrs, current);
  }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
  return propsList.filter(function (props) {
    return typeof props[_constants.TAG_NAMES.BASE] !== 'undefined';
  }).map(function (props) {
    return props[_constants.TAG_NAMES.BASE];
  }).reverse().reduce(function (innermostBaseTag, tag) {
    if (!innermostBaseTag.length) {
      var keys = Object.keys(tag);

      for (var i = 0; i < keys.length; i += 1) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();

        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag);
        }
      }
    }

    return innermostBaseTag;
  }, []);
};

// eslint-disable-next-line no-console
var warn = function warn(msg) {
  return console && typeof console.warn === 'function' && console.warn(msg);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
  // Calculate list of tags, giving priority innermost component (end of the propslist)
  var approvedSeenTags = {};

  return propsList.filter(function (props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }
    if (typeof props[tagName] !== 'undefined') {
      warn('Helmet: ' + tagName + ' should be of type "Array". Instead found type "' + _typeof(props[tagName]) + '"');
    }
    return false;
  }).map(function (props) {
    return props[tagName];
  }).reverse().reduce(function (approvedTags, instanceTags) {
    var instanceSeenTags = {};

    instanceTags.filter(function (tag) {
      var primaryAttributeKey = void 0;
      var keys = Object.keys(tag);
      for (var i = 0; i < keys.length; i += 1) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();

        // Special rule with link tags, since rel and href are both primary tags, rel takes priority
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _constants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === 'canonical') && !(lowerCaseAttributeKey === _constants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === 'stylesheet')) {
          primaryAttributeKey = lowerCaseAttributeKey;
        }
        // Special case for innerHTML which doesn't work lowercased
        if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _constants.TAG_PROPERTIES.INNER_HTML || attributeKey === _constants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _constants.TAG_PROPERTIES.ITEM_PROP)) {
          primaryAttributeKey = attributeKey;
        }
      }

      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }

      var value = tag[primaryAttributeKey].toLowerCase();

      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }

      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }

      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }

      return false;
    }).reverse().forEach(function (tag) {
      return approvedTags.push(tag);
    });

    // Update seen tags with tags from this instance
    var keys = Object.keys(instanceSeenTags);
    for (var i = 0; i < keys.length; i += 1) {
      var attributeKey = keys[i];
      var tagUnion = _extends({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

      approvedSeenTags[attributeKey] = tagUnion;
    }

    return approvedTags;
  }, []).reverse();
};

var reducePropsToState = function reducePropsToState(propsList) {
  return {
    baseTag: getBaseTagFromPropsList([_constants.TAG_PROPERTIES.HREF], propsList),
    bodyAttributes: getAttributesFromPropsList(_constants.ATTRIBUTE_NAMES.BODY, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList(_constants.ATTRIBUTE_NAMES.HTML, propsList),
    linkTags: getTagsFromPropsList(_constants.TAG_NAMES.LINK, [_constants.TAG_PROPERTIES.REL, _constants.TAG_PROPERTIES.HREF], propsList),
    metaTags: getTagsFromPropsList(_constants.TAG_NAMES.META, [_constants.TAG_PROPERTIES.NAME, _constants.TAG_PROPERTIES.CHARSET, _constants.TAG_PROPERTIES.HTTPEQUIV, _constants.TAG_PROPERTIES.PROPERTY, _constants.TAG_PROPERTIES.ITEM_PROP], propsList),
    noscriptTags: getTagsFromPropsList(_constants.TAG_NAMES.NOSCRIPT, [_constants.TAG_PROPERTIES.INNER_HTML], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList(_constants.TAG_NAMES.SCRIPT, [_constants.TAG_PROPERTIES.SRC, _constants.TAG_PROPERTIES.INNER_HTML], propsList),
    styleTags: getTagsFromPropsList(_constants.TAG_NAMES.STYLE, [_constants.TAG_PROPERTIES.CSS_TEXT], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList(_constants.ATTRIBUTE_NAMES.TITLE, propsList)
  };
};

var flattenArray = exports.flattenArray = function flattenArray(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join('') : possibleArray;
};

exports.reducePropsToState = reducePropsToState;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var HashBase = __webpack_require__(388)
var Buffer = __webpack_require__(15).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(173).EventEmitter;
var inherits = __webpack_require__(11);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(244);
Stream.Writable = __webpack_require__(795);
Stream.Duplex = __webpack_require__(796);
Stream.Transform = __webpack_require__(797);
Stream.PassThrough = __webpack_require__(798);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(389);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(246);
exports.Duplex = __webpack_require__(94);
exports.Transform = __webpack_require__(392);
exports.PassThrough = __webpack_require__(794);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(23)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(140);
util.inherits = __webpack_require__(11);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(793)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(390);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(245).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(391);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(94);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(94);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(247).setImmediate, __webpack_require__(8)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(792);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(23).Buffer
var inherits = __webpack_require__(11)
var HashBase = __webpack_require__(388)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(799)
exports.sha1 = __webpack_require__(800)
exports.sha224 = __webpack_require__(801)
exports.sha256 = __webpack_require__(393)
exports.sha384 = __webpack_require__(802)
exports.sha512 = __webpack_require__(394)


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(52);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(811)
var deciphers = __webpack_require__(819)
var modes = __webpack_require__(406)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(812),
  CBC: __webpack_require__(813),
  CFB: __webpack_require__(814),
  CFB8: __webpack_require__(815),
  CFB1: __webpack_require__(816),
  OFB: __webpack_require__(817),
  CTR: __webpack_require__(404),
  GCM: __webpack_require__(404)
}

var modes = __webpack_require__(406)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(823);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(33);
var randomBytes = __webpack_require__(120);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(828).version;
elliptic.utils = __webpack_require__(53);
elliptic.rand = __webpack_require__(253);
elliptic.curve = __webpack_require__(412);
elliptic.curves = __webpack_require__(256);

// Protocols
elliptic.ec = __webpack_require__(839);
elliptic.eddsa = __webpack_require__(843);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(257);
var curve = __webpack_require__(412);
var utils = __webpack_require__(53);

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(838);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(69);
hash.common = __webpack_require__(142);
hash.sha = __webpack_require__(832);
hash.ripemd = __webpack_require__(836);
hash.hmac = __webpack_require__(837);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_WISHLIST */
/* unused harmony export FETCH_WISHLIST_SUCCESS */
/* unused harmony export FETCH_WISHLIST_FAIL */
/* unused harmony export ADD_TO_WISHLIST */
/* unused harmony export ADD_TO_WISHLIST_SUCCESS */
/* unused harmony export REMOVE_FROM_WISHLIST */
/* unused harmony export REMOVE_FROM_WISHLIST_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchWishlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToWishlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeFromWishlist; });
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var FETCH_WISHLIST='wishlist/FETCH';var FETCH_WISHLIST_SUCCESS=FETCH_WISHLIST+'_SUCCESS';var FETCH_WISHLIST_FAIL=FETCH_WISHLIST+'_FAIL';var ADD_TO_WISHLIST='wishlist/ADD';var ADD_TO_WISHLIST_SUCCESS=ADD_TO_WISHLIST+'_SUCCESS';var REMOVE_FROM_WISHLIST='wishlist/REMOVE';var REMOVE_FROM_WISHLIST_SUCCESS=REMOVE_FROM_WISHLIST+'_SUCCESS';var initialState={isLoading:false,products:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case FETCH_WISHLIST:return Object.assign({},state,{isLoading:true});case FETCH_WISHLIST_SUCCESS:return Object.assign({},state,{isLoading:false,products:action.payload.data.map(function(_ref){var skuId=_ref.skuId;return skuId;})});case FETCH_WISHLIST_FAIL:return Object.assign({},state,{isLoading:false});case ADD_TO_WISHLIST_SUCCESS:return Object.assign({},state,{products:[].concat(_toConsumableArray(state.products),[action.meta.previousAction.sku])});case REMOVE_FROM_WISHLIST_SUCCESS:return Object.assign({},state,{products:state.products.filter(function(sku){return sku!==action.meta.previousAction.sku;})});default:return state;}});var fetchWishlist=function fetchWishlist(){return{type:FETCH_WISHLIST,payload:{client:'cloudloyalty',request:{method:'GET',url:'/v1/participants/me/wishlist'}}};};var addToWishlist=function addToWishlist(sku){return{type:ADD_TO_WISHLIST,sku:sku,payload:{request:{method:'PUT',url:'/v1/participants/me/wishlist/'+sku+'/add'}}};};var removeFromWishlist=function removeFromWishlist(sku){return{type:REMOVE_FROM_WISHLIST,sku:sku,payload:{request:{method:'DELETE',url:'/v1/participants/me/wishlist/'+sku+'/remove'}}};};

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_CATALOG */
/* unused harmony export FETCH_CATALOG_SUCCESS */
/* unused harmony export FETCH_CATALOG_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCatalog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isRedeemPointsMoreOthers; });
var FETCH_CATALOG='catalog/FETCH';var FETCH_CATALOG_SUCCESS=FETCH_CATALOG+'_SUCCESS';var FETCH_CATALOG_FAIL=FETCH_CATALOG+'_FAIL';var initialState={isLoading:false,isLoaded:false,currencyConfiguration:{pointsName:'',decimalPlaces:0},redeemType:''};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case FETCH_CATALOG:return Object.assign({},state,{isLoading:true});case FETCH_CATALOG_SUCCESS:return Object.assign({},state,action.payload.data,{isLoading:false,isLoaded:true});case FETCH_CATALOG_FAIL:return Object.assign({isLoaded:false},state,{isLoading:false});default:return state;}});var fetchCatalog=function fetchCatalog(){return{type:FETCH_CATALOG,payload:{client:'cloudloyalty',request:{url:'/v1/configurations/catalogs/byToken'}}};};var isRedeemPointsMoreOthers=function isRedeemPointsMoreOthers(type){return type==='POINTSMOREOTHERS';};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(54);
var normalizeHeaderName = __webpack_require__(871);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(429);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(429);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CategoryMenu__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OnlyCash__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var defaultState={menu:false};var MainMenu=function MainMenu(_ref){var categoryMenu=_ref.categoryMenu,onlyCash=_ref.onlyCash,catalogJustCash=_ref.catalogJustCash,profile=_ref.profile;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultState),_useState2=_slicedToArray(_useState,2),ownState=_useState2[0],setOwnState=_useState2[1];var openTabletMenu=function openTabletMenu(){setOwnState(Object.assign({},ownState,{menu:!ownState.menu}));};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setTimeout(function(){var linkMenu=document.querySelectorAll('button.link-menu');Array.from(linkMenu).forEach(function(link,index){link.addEventListener('click',function(event){var containClass=link.classList.contains('link-menu-active');var allContainers=Array.from(linkMenu);allContainers.splice(index,1);allContainers.forEach(function(container){container.classList.remove('link-menu-active');container.setAttribute('aria-expanded',false);});if(containClass){link.classList.remove('link-menu-active');link.setAttribute('aria-expanded',false);}else{link.classList.add('link-menu-active');link.setAttribute('aria-expanded',true);}event.preventDefault();});});},500);},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-sm-block d-print-none','aria-label':'Menu Principal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container container-with-zoom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu menu-without-trade row row-eq-height flex-wrap flex-md-nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minWidth:421,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'pos-absolite h-100 d-flex align-items-center','aria-haspopup':'true','aria-expanded':ownState.menu,onClick:openTabletMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_'+(__WEBPACK_IMPORTED_MODULE_5_yn___default()(ownState.menu)?'menu_app_close':'menu')+' mr-2','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_5_yn___default()(ownState.menu)?'fechar menu':'menu')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-absolute tablet-menu bg-white w-100 l-0 mt-half border-ui-2 '+(!__WEBPACK_IMPORTED_MODULE_5_yn___default()(ownState.menu)&&'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CategoryMenu__["a" /* CategoryMenu */],{menus:categoryMenu,onlyCash:onlyCash}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CategoryMenu__["a" /* CategoryMenu */],{menus:categoryMenu,onlyCash:onlyCash})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minWidth:768},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},catalogJustCash?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnlyCash__["a" /* OnlyCash */],{profile:profile}):'')))))));};MainMenu.propTypes={categoryMenu:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,catalogJustCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (MainMenu);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_POINT_PURCHASE_CONFIG */
/* unused harmony export FETCH_POINT_PURCHASE_CONFIG_SUCCESS */
/* unused harmony export FETCH_POINT_PURCHASE_CONFIG_FAIL */
/* unused harmony export CHECKOUT_POINTS_PURCHASE */
/* unused harmony export CHECKOUT_POINTS_PURCHASE_SUCCESS */
/* unused harmony export CHECKOUT_POINTS_PURCHASE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearSecondFactorAuthentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchPointPurchaseConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkoutPointsPurchase; });
var FETCH_POINT_PURCHASE_CONFIG='checkout/points_purchase_config/FETCH';var FETCH_POINT_PURCHASE_CONFIG_SUCCESS=FETCH_POINT_PURCHASE_CONFIG+'_SUCCESS';var FETCH_POINT_PURCHASE_CONFIG_FAIL=FETCH_POINT_PURCHASE_CONFIG+'_FAIL';var CHECKOUT_POINTS_PURCHASE='checkout/points_purchase/FETCH';var CHECKOUT_POINTS_PURCHASE_SUCCESS=CHECKOUT_POINTS_PURCHASE+'_SUCCESS';var CHECKOUT_POINTS_PURCHASE_FAIL=CHECKOUT_POINTS_PURCHASE+'_FAIL';var type={REQUIRES_TOKEN_VALIDATION:'RequiresTokenValidation'};var initialState={isLoading:false,config:{}};/* harmony default export */ __webpack_exports__["c"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case FETCH_POINT_PURCHASE_CONFIG:return Object.assign({},state,{isLoading:true,hasSuccess:false,hasError:false,errors:[],id:undefined});case FETCH_POINT_PURCHASE_CONFIG_SUCCESS:return Object.assign({},state,{isLoading:false,config:action.payload.data});case FETCH_POINT_PURCHASE_CONFIG_FAIL:var errorsConfig=[];if(action.error.response.status===422){if(action.error.response.data.errors){errorsConfig=action.error.response.data.errors;}else{errorsConfig=action.error.response.data.map(function(error){return{message:error.Message};});}}else if(action.error){errorsConfig=[{message:'Erro inesperado, favor tentar mais tarde.'}];}return Object.assign({},state,{isLoading:false,hasError:true,errors:errorsConfig,config:{}});case CHECKOUT_POINTS_PURCHASE:return Object.assign({},state,{isLoading:true});case CHECKOUT_POINTS_PURCHASE_SUCCESS:return Object.assign({},state,ValidSecondFactorAuthentication(action));case CHECKOUT_POINTS_PURCHASE_FAIL:var errors=[];if(action.error.response.status===422){if(action.error.response.data.errors){errors=action.error.response.data.errors;}else{errors=action.error.response.data.map(function(error){return{message:error.Message};});}}return Object.assign({},state,{isLoading:false,hasError:true,errors:errors},ValidOnBoardingAuthentication(action));case'GET_ORDER_CONFIRMATION_SUCCESS':return Object.assign({},state,{isLoading:false,hasError:false,hasSuccess:false,id:undefined});case'CLEAR_SECOND_FACTOR_AUTHENTICATION':return Object.assign({},state,{SecondFactorAuthentication:false});case'AUTHORIZE_TOKEN_FAIL':return Object.assign({},state,{SecondFactorAuthentication:false});case'AUTHORIZE_TOKEN_SUCCESS':return Object.assign({},state,validationTokenSuccess(action));default:return state;}});var validationTokenSuccess=function validationTokenSuccess(action){if(action.payload.status===200){return{hasSuccess:true};}else{return{hasSuccess:false};}};var ValidOnBoardingAuthentication=function ValidOnBoardingAuthentication(action){var status=action.error.response.status;if(status===406){return{SecondFactorAuthentication:true,SecondFactorAuthenticationConfirmed:false};}};var ValidSecondFactorAuthentication=function ValidSecondFactorAuthentication(action){var status=action.payload.data.status;if(type.REQUIRES_TOKEN_VALIDATION===status){return{isLoading:false,hasSuccess:false,SecondFactorAuthentication:true,id:action.payload.data.id,confirmedOrderId:action.payload.data.id,SecondFactorAuthenticationConfirmed:true};}else{return{isLoading:false,hasSuccess:true,SecondFactorAuthentication:false,id:action.payload.data.id,confirmedOrderId:action.payload.data.id,SecondFactorAuthenticationConfirmed:true};}};var clearSecondFactorAuthentication=function clearSecondFactorAuthentication(){return{type:'CLEAR_SECOND_FACTOR_AUTHENTICATION'};};var fetchPointPurchaseConfiguration=function fetchPointPurchaseConfiguration(){var vendorId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"61677";return{type:FETCH_POINT_PURCHASE_CONFIG,payload:{client:'cloudloyalty',request:{url:'/v2/purchase/configuration',params:{vendorId:vendorId}}}};};var checkoutPointsPurchase=function checkoutPointsPurchase(purchase){return{type:CHECKOUT_POINTS_PURCHASE,payload:{client:'cloudloyalty',request:{url:'/v1/purchases/points',method:'post',data:Object.assign({vendorId:"61677"},purchase)}}};};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(940);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Logo__["a"]; });


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchContainer__ = __webpack_require__(941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AutoCompleteProducts__ = __webpack_require__(978);
/* unused harmony reexport AutoCompleteProducts */


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading__ = __webpack_require__(954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loading__["a"]; });


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numberToStrCurrency; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var numberToStrCurrency=function numberToStrCurrency(value,decimalPlaces){return value.toLocaleString('pt-br',{minimumFractionDigits:decimalPlaces,maximumFractionDigits:decimalPlaces});};var CurrencyLabel=function CurrencyLabel(_ref){var id=_ref.id,label=_ref.label,_ref$value=_ref.value,value=_ref$value===undefined?'0':_ref$value,decimalPlaces=_ref.decimalPlaces,className=_ref.className,_ref$showpointsName=_ref.showpointsName,showpointsName=_ref$showpointsName===undefined?true:_ref$showpointsName,_ref$prefixLabel=_ref.prefixLabel,prefixLabel=_ref$prefixLabel===undefined?'':_ref$prefixLabel;if(isNaN(value)){value=0;}var valueFormated=numberToStrCurrency(value,decimalPlaces);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:id,className:'price-value '+className,'aria-label':prefixLabel+' '+valueFormated+' '+(showpointsName?label:'')},prefixLabel+' '+valueFormated+' '+(showpointsName?label:''));};CurrencyLabel.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showpointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,prefixLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CurrencyLabel);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cart__ = __webpack_require__(979);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Cart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartContainer__ = __webpack_require__(980);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CartContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartItem_CartItem__ = __webpack_require__(981);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CartItem_CartItem__["a"]; });


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackingContainer__ = __webpack_require__(1004);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TrackingContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1010);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_molecules_header_css__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_molecules_header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_molecules_header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_menu_toggle_css__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_menu_toggle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_menu_toggle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_base_css__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_base_css__);
var HeaderWrapper=function HeaderWrapper(_ref){var children=_ref.children,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-header bg-brand-2 container-fluid pt-0 d-print-none d-md-flex align-items-center '+(className||''),role:'banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container container-with-zoom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'header',className:'header row row-eq-height'},children))));};HeaderWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (HeaderWrapper);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TitleAnnouncer=function TitleAnnouncer(_ref){var orientation=_ref.orientation;var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(''),_React$useState2=_slicedToArray(_React$useState,2),title=_React$useState2[0],setTitle=_React$useState2[1];var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState2=_slicedToArray(_useState,2),tabIndex=_useState2[0],setTabIndex=_useState2[1];var titleRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();var onHelmetChange=function onHelmetChange(_ref2){var title=_ref2.title;return setTitle(title);};setTimeout(function(){if(orientation==='mobile'){var btnBackPage=document.querySelector('.btn-back-page');if(btnBackPage){btnBackPage.focus();}}else{var accessibilityMenus=document.getElementById('accessibility-menu-anchors');if(accessibilityMenus!==null){accessibilityMenus.setAttribute('tabindex','0');accessibilityMenus.focus();accessibilityMenus.addEventListener('blur',function(){accessibilityMenus.removeAttribute('tabindex');});accessibilityMenus.blur();}}setTabIndex(-1);},500);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"],{onChangeClientState:onHelmetChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide-absolute'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{role:'status','aria-live':'assertive','aria-atomic':'true',ref:titleRef,className:'TitleAnnouncer',tabIndex:tabIndex},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"],{onChangeClientState:onHelmetChange}))));};TitleAnnouncer.propTypes={orientation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (TitleAnnouncer);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__history__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store__["persistor"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rootReducer__ = __webpack_require__(478);
/* unused harmony reexport rootReducer */


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form__ = __webpack_require__(1042);
/* unused harmony reexport Form */


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/*!
*   Gerador e Validador de CPF v3.1.3
*   http://tiagoporto.github.io/gerador-validador-cpf
*   Copyright (c) 2014-2018 Tiago Porto (http://tiagoporto.com)
*   Released under the MIT license
*/



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * CPF Class
 *
 * generate function
 * @param  {string} param      Formatting option
 * @return {string}            Valid and formatted CPF
 *
 * validate function
 * @param  {string} value      The value for validation
 * @return {boolean}           True = valid || False = invalid
 *
 * format function
 * @param  {string} value      The value for formatting
 * @param  {string} param      Formatting option
 *
 * @return {string}            Formatted CPF || error message
 */

(function () {
  var root = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || this;

  var CPF = function CPF() {};

  if (typeof exports !== 'undefined' && !exports.nodeType) {
    if (typeof module !== 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = CPF;
    }

    exports.CPF = CPF;
  } else {
    root.CPF = CPF;
  }

  var calcChecker1 = function calcChecker1(firstNineDigits) {
    var sum = null;

    for (var j = 0; j < 9; ++j) {
      sum += firstNineDigits.toString().charAt(j) * (10 - j);
    }

    var lastSumChecker1 = sum % 11;
    var checker1 = lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;

    return checker1;
  };

  var calcChecker2 = function calcChecker2(cpfWithChecker1) {
    var sum = null;

    for (var k = 0; k < 10; ++k) {
      sum += cpfWithChecker1.toString().charAt(k) * (11 - k);
    }

    var lastSumChecker2 = sum % 11;
    var checker2 = lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;

    return checker2;
  };

  var formatCPF = function formatCPF(value, formatter) {
    var digitsSeparator = '.';
    var checkersSeparator = '-';

    if (formatter === 'digits') {
      digitsSeparator = '';
      checkersSeparator = '';
    } else if (formatter === 'checker') {
      digitsSeparator = '';
      checkersSeparator = '-';
    }

    if (value.length > 11) {
      return 'The value contains error. Has more than 11 digits.';
    } else if (value.length < 11) {
      return 'The value contains error. Has fewer than 11 digits.';
    } else {
      return value.slice(0, 3) + digitsSeparator + value.slice(3, 6) + digitsSeparator + value.slice(6, 9) + checkersSeparator + value.slice(9, 11);
    }
  };

  CPF.generate = function (param) {
    var firstNineDigits = '';

    // Generating the first 9 digits of the CPF
    for (var i = 0; i < 9; ++i) {
      firstNineDigits += String(Math.floor(Math.random() * 9));
    }

    var checker1 = calcChecker1(firstNineDigits);
    var generatedCPF = firstNineDigits + checker1 + calcChecker2(firstNineDigits + checker1);

    return formatCPF(generatedCPF, param);
  };

  CPF.validate = function (value) {
    if (!value || value === true) {
      return;
    }

    if (typeof value === 'number') {
      value = String(value);
    }

    var cleanCPF = value.replace(/\.|-|\s/g, '');
    var firstNineDigits = cleanCPF.substring(0, 9);
    var checker = cleanCPF.substring(9, 11);

    if (cleanCPF.length !== 11) {
      return false;
    }

    // Checking if all digits are equal
    for (var i = 0; i < 10; i++) {
      if ('' + firstNineDigits + checker === Array(12).join(i)) {
        return false;
      }
    }

    var checker1 = calcChecker1(firstNineDigits);
    var checker2 = calcChecker2('' + firstNineDigits + checker1);

    if (checker.toString() === checker1.toString() + checker2.toString()) {
      return true;
    } else {
      return false;
    }
  };

  CPF.format = function (value, param) {
    if (!value) {
      return;
    }

    var getCPF = value.replace(/[^\d]/g, '');

    return formatCPF(getCPF, param);
  };

  return CPF;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(76)(module)))

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deepMap;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepForEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(197);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function isTabChild(child) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child);
}

function deepMap(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return null;

    if (isTabChild(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && typeof child.props.children === 'object') {
      // Clone the child that has children and map them too
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}
function deepForEach(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TwoStepVerificationPage__ = __webpack_require__(1082);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__TwoStepVerificationPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TwoStepVerification__ = __webpack_require__(1083);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__TwoStepVerification__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FaqTwoStep__ = __webpack_require__(1103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FaqTwoStep__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(1105);
/* unused harmony reexport reducer */


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1110));
//# sourceMappingURL=index.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);

// browser specific modules
util.crypto.lib = __webpack_require__(1146);
util.Buffer = __webpack_require__(23).Buffer;
util.url = __webpack_require__(509);
util.querystring = __webpack_require__(510);
util.realClock = __webpack_require__(1155);
util.environment = 'js';
util.createEventStream = __webpack_require__(1156).createEventStream;
util.isBrowser = function() { return true; };
util.isNode = function() { return false; };

var AWS = __webpack_require__(13);

/**
 * @api private
 */
module.exports = AWS;

__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(1162);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1173);

// Load the DOMParser XML parser
AWS.XML.Parser = __webpack_require__(1174);

// Load the XHR HttpClient
__webpack_require__(1175);

if (typeof process === 'undefined') {
  var process = {
    browser: true
  };
}


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var JsonBuilder = __webpack_require__(279);
var JsonParser = __webpack_require__(280);
var populateHostPrefix = __webpack_require__(281).populateHostPrefix;

function buildRequest(req) {
  var httpRequest = req.httpRequest;
  var api = req.service.api;
  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
  var version = api.jsonVersion || '1.0';
  var input = api.operations[req.operation].input;
  var builder = new JsonBuilder();

  if (version === 1) version = '1.0';
  httpRequest.body = builder.build(req.params || {}, input);
  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
  httpRequest.headers['X-Amz-Target'] = target;

  populateHostPrefix(req);
}

function extractError(resp) {
  var error = {};
  var httpResponse = resp.httpResponse;

  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
  if (typeof error.code === 'string') {
    error.code = error.code.split(':')[0];
  }

  if (httpResponse.body.length > 0) {
    try {
      var e = JSON.parse(httpResponse.body.toString());
      if (e.__type || e.code) {
        error.code = (e.__type || e.code).split('#').pop();
      }
      if (error.code === 'RequestEntityTooLarge') {
        error.message = 'Request body must be less than 1 MB';
      } else {
        error.message = (e.message || e.Message || null);
      }
    } catch (e) {
      error.statusCode = httpResponse.statusCode;
      error.message = httpResponse.statusMessage;
    }
  } else {
    error.statusCode = httpResponse.statusCode;
    error.message = httpResponse.statusCode.toString();
  }

  resp.error = util.error(new Error(), error);
}

function extractData(resp) {
  var body = resp.httpResponse.body.toString() || '{}';
  if (resp.request.service.config.convertResponseTypes === false) {
    resp.data = JSON.parse(body);
  } else {
    var operation = resp.request.service.api.operations[resp.request.operation];
    var shape = operation.output || {};
    var parser = new JsonParser();
    resp.data = parser.parse(body, shape);
  }
}

/**
 * @api private
 */
module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);

function JsonBuilder() { }

JsonBuilder.prototype.build = function(value, shape) {
  return JSON.stringify(translate(value, shape));
};

function translate(value, shape) {
  if (!shape || value === undefined || value === null) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      if (memberShape.location !== 'body') return;
      var locationName = memberShape.isLocationName ? memberShape.name : name;
      var result = translate(value, memberShape);
      if (result !== undefined) struct[locationName] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result !== undefined) out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result !== undefined) out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toWireFormat(value);
}

/**
 * @api private
 */
module.exports = JsonBuilder;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);

function JsonParser() { }

JsonParser.prototype.parse = function(value, shape) {
  return translate(JSON.parse(value), shape);
};

function translate(value, shape) {
  if (!shape || value === undefined) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  if (structure == null) return undefined;

  var struct = {};
  var shapeMembers = shape.members;
  util.each(shapeMembers, function(name, memberShape) {
    var locationName = memberShape.isLocationName ? memberShape.name : name;
    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
      var value = structure[locationName];
      var result = translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toType(value);
}

/**
 * @api private
 */
module.exports = JsonParser;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var util =  __webpack_require__(31);
var AWS = __webpack_require__(13);

/**
 * Prepend prefix defined by API model to endpoint that's already
 * constructed. This feature does not apply to operations using
 * endpoint discovery and can be disabled.
 * @api private
 */
function populateHostPrefix(request)  {
  var enabled = request.service.config.hostPrefixEnabled;
  if (!enabled) return request;
  var operationModel = request.service.api.operations[request.operation];
  //don't marshal host prefix when operation has endpoint discovery traits
  if (hasEndpointDiscover(request)) return request;
  if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
    var hostPrefixNotation = operationModel.endpoint.hostPrefix;
    var hostPrefix = expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
    prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
    validateHostname(request.httpRequest.endpoint.hostname);
  }
  return request;
}

/**
 * @api private
 */
function hasEndpointDiscover(request) {
  var api = request.service.api;
  var operationModel = api.operations[request.operation];
  var isEndpointOperation = api.endpointOperation && (api.endpointOperation === util.string.lowerFirst(operationModel.name));
  return (operationModel.endpointDiscoveryRequired !== 'NULL' || isEndpointOperation === true);
}

/**
 * @api private
 */
function expandHostPrefix(hostPrefixNotation, params, shape) {
  util.each(shape.members, function(name, member) {
    if (member.hostLabel === true) {
      if (typeof params[name] !== 'string' || params[name] === '') {
        throw util.error(new Error(), {
          message: 'Parameter ' + name + ' should be a non-empty string.',
          code: 'InvalidParameter'
        });
      }
      var regex = new RegExp('\\{' + name + '\\}', 'g');
      hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
    }
  });
  return hostPrefixNotation;
}

/**
 * @api private
 */
function prependEndpointPrefix(endpoint, prefix) {
  if (endpoint.host) {
    endpoint.host = prefix + endpoint.host;
  }
  if (endpoint.hostname) {
    endpoint.hostname = prefix + endpoint.hostname;
  }
}

/**
 * @api private
 */
function validateHostname(hostname) {
  var labels = hostname.split('.');
  //Reference: https://tools.ietf.org/html/rfc1123#section-2
  var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
  util.arrayEach(labels, function(label) {
    if (!label.length || label.length < 1 || label.length > 63) {
      throw util.error(new Error(), {
        code: 'ValidationError',
        message: 'Hostname label length should be between 1 to 63 characters, inclusive.'
      });
    }
    if (!hostPattern.test(label)) {
      throw AWS.util.error(new Error(),
        {code: 'ValidationError', message: label + ' is not hostname compatible.'});
    }
  });
}

module.exports = {
  populateHostPrefix: populateHostPrefix
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

(function(exports) {
  "use strict";

  function isArray(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    } else {
      return false;
    }
  }

  function isObject(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    } else {
      return false;
    }
  }

  function strictDeepEqual(first, second) {
    // Check the scalar case first.
    if (first === second) {
      return true;
    }

    // Check if they are the same type.
    var firstType = Object.prototype.toString.call(first);
    if (firstType !== Object.prototype.toString.call(second)) {
      return false;
    }
    // We know that first and second have the same type so we can just check the
    // first type from now on.
    if (isArray(first) === true) {
      // Short circuit if they're not the same length;
      if (first.length !== second.length) {
        return false;
      }
      for (var i = 0; i < first.length; i++) {
        if (strictDeepEqual(first[i], second[i]) === false) {
          return false;
        }
      }
      return true;
    }
    if (isObject(first) === true) {
      // An object is equal if it has the same key/value pairs.
      var keysSeen = {};
      for (var key in first) {
        if (hasOwnProperty.call(first, key)) {
          if (strictDeepEqual(first[key], second[key]) === false) {
            return false;
          }
          keysSeen[key] = true;
        }
      }
      // Now check that there aren't any keys in second that weren't
      // in first.
      for (var key2 in second) {
        if (hasOwnProperty.call(second, key2)) {
          if (keysSeen[key2] !== true) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  }

  function isFalse(obj) {
    // From the spec:
    // A false value corresponds to the following values:
    // Empty list
    // Empty object
    // Empty string
    // False boolean
    // null value

    // First check the scalar values.
    if (obj === "" || obj === false || obj === null) {
        return true;
    } else if (isArray(obj) && obj.length === 0) {
        // Check for an empty array.
        return true;
    } else if (isObject(obj)) {
        // Check for an empty object.
        for (var key in obj) {
            // If there are any keys, then
            // the object is not empty so the object
            // is not false.
            if (obj.hasOwnProperty(key)) {
              return false;
            }
        }
        return true;
    } else {
        return false;
    }
  }

  function objValues(obj) {
    var keys = Object.keys(obj);
    var values = [];
    for (var i = 0; i < keys.length; i++) {
      values.push(obj[keys[i]]);
    }
    return values;
  }

  function merge(a, b) {
      var merged = {};
      for (var key in a) {
          merged[key] = a[key];
      }
      for (var key2 in b) {
          merged[key2] = b[key2];
      }
      return merged;
  }

  var trimLeft;
  if (typeof String.prototype.trimLeft === "function") {
    trimLeft = function(str) {
      return str.trimLeft();
    };
  } else {
    trimLeft = function(str) {
      return str.match(/^\s*(.*)/)[1];
    };
  }

  // Type constants used to define functions.
  var TYPE_NUMBER = 0;
  var TYPE_ANY = 1;
  var TYPE_STRING = 2;
  var TYPE_ARRAY = 3;
  var TYPE_OBJECT = 4;
  var TYPE_BOOLEAN = 5;
  var TYPE_EXPREF = 6;
  var TYPE_NULL = 7;
  var TYPE_ARRAY_NUMBER = 8;
  var TYPE_ARRAY_STRING = 9;

  var TOK_EOF = "EOF";
  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
  var TOK_RBRACKET = "Rbracket";
  var TOK_RPAREN = "Rparen";
  var TOK_COMMA = "Comma";
  var TOK_COLON = "Colon";
  var TOK_RBRACE = "Rbrace";
  var TOK_NUMBER = "Number";
  var TOK_CURRENT = "Current";
  var TOK_EXPREF = "Expref";
  var TOK_PIPE = "Pipe";
  var TOK_OR = "Or";
  var TOK_AND = "And";
  var TOK_EQ = "EQ";
  var TOK_GT = "GT";
  var TOK_LT = "LT";
  var TOK_GTE = "GTE";
  var TOK_LTE = "LTE";
  var TOK_NE = "NE";
  var TOK_FLATTEN = "Flatten";
  var TOK_STAR = "Star";
  var TOK_FILTER = "Filter";
  var TOK_DOT = "Dot";
  var TOK_NOT = "Not";
  var TOK_LBRACE = "Lbrace";
  var TOK_LBRACKET = "Lbracket";
  var TOK_LPAREN= "Lparen";
  var TOK_LITERAL= "Literal";

  // The "&", "[", "<", ">" tokens
  // are not in basicToken because
  // there are two token variants
  // ("&&", "[?", "<=", ">=").  This is specially handled
  // below.

  var basicTokens = {
    ".": TOK_DOT,
    "*": TOK_STAR,
    ",": TOK_COMMA,
    ":": TOK_COLON,
    "{": TOK_LBRACE,
    "}": TOK_RBRACE,
    "]": TOK_RBRACKET,
    "(": TOK_LPAREN,
    ")": TOK_RPAREN,
    "@": TOK_CURRENT
  };

  var operatorStartToken = {
      "<": true,
      ">": true,
      "=": true,
      "!": true
  };

  var skipChars = {
      " ": true,
      "\t": true,
      "\n": true
  };


  function isAlpha(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             ch === "_";
  }

  function isNum(ch) {
      return (ch >= "0" && ch <= "9") ||
             ch === "-";
  }
  function isAlphaNum(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             (ch >= "0" && ch <= "9") ||
             ch === "_";
  }

  function Lexer() {
  }
  Lexer.prototype = {
      tokenize: function(stream) {
          var tokens = [];
          this._current = 0;
          var start;
          var identifier;
          var token;
          while (this._current < stream.length) {
              if (isAlpha(stream[this._current])) {
                  start = this._current;
                  identifier = this._consumeUnquotedIdentifier(stream);
                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (basicTokens[stream[this._current]] !== undefined) {
                  tokens.push({type: basicTokens[stream[this._current]],
                              value: stream[this._current],
                              start: this._current});
                  this._current++;
              } else if (isNum(stream[this._current])) {
                  token = this._consumeNumber(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "[") {
                  // No need to increment this._current.  This happens
                  // in _consumeLBracket
                  token = this._consumeLBracket(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "\"") {
                  start = this._current;
                  identifier = this._consumeQuotedIdentifier(stream);
                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "'") {
                  start = this._current;
                  identifier = this._consumeRawStringLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "`") {
                  start = this._current;
                  var literal = this._consumeLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: literal,
                               start: start});
              } else if (operatorStartToken[stream[this._current]] !== undefined) {
                  tokens.push(this._consumeOperator(stream));
              } else if (skipChars[stream[this._current]] !== undefined) {
                  // Ignore whitespace.
                  this._current++;
              } else if (stream[this._current] === "&") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "&") {
                      this._current++;
                      tokens.push({type: TOK_AND, value: "&&", start: start});
                  } else {
                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
                  }
              } else if (stream[this._current] === "|") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "|") {
                      this._current++;
                      tokens.push({type: TOK_OR, value: "||", start: start});
                  } else {
                      tokens.push({type: TOK_PIPE, value: "|", start: start});
                  }
              } else {
                  var error = new Error("Unknown character:" + stream[this._current]);
                  error.name = "LexerError";
                  throw error;
              }
          }
          return tokens;
      },

      _consumeUnquotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
              this._current++;
          }
          return stream.slice(start, this._current);
      },

      _consumeQuotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "\"" && this._current < maxLength) {
              // You can escape a double quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "\"")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          return JSON.parse(stream.slice(start, this._current));
      },

      _consumeRawStringLiteral: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "'" && this._current < maxLength) {
              // You can escape a single quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "'")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          var literal = stream.slice(start + 1, this._current - 1);
          return literal.replace("\\'", "'");
      },

      _consumeNumber: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (isNum(stream[this._current]) && this._current < maxLength) {
              this._current++;
          }
          var value = parseInt(stream.slice(start, this._current));
          return {type: TOK_NUMBER, value: value, start: start};
      },

      _consumeLBracket: function(stream) {
          var start = this._current;
          this._current++;
          if (stream[this._current] === "?") {
              this._current++;
              return {type: TOK_FILTER, value: "[?", start: start};
          } else if (stream[this._current] === "]") {
              this._current++;
              return {type: TOK_FLATTEN, value: "[]", start: start};
          } else {
              return {type: TOK_LBRACKET, value: "[", start: start};
          }
      },

      _consumeOperator: function(stream) {
          var start = this._current;
          var startingChar = stream[start];
          this._current++;
          if (startingChar === "!") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_NE, value: "!=", start: start};
              } else {
                return {type: TOK_NOT, value: "!", start: start};
              }
          } else if (startingChar === "<") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_LTE, value: "<=", start: start};
              } else {
                  return {type: TOK_LT, value: "<", start: start};
              }
          } else if (startingChar === ">") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_GTE, value: ">=", start: start};
              } else {
                  return {type: TOK_GT, value: ">", start: start};
              }
          } else if (startingChar === "=") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_EQ, value: "==", start: start};
              }
          }
      },

      _consumeLiteral: function(stream) {
          this._current++;
          var start = this._current;
          var maxLength = stream.length;
          var literal;
          while(stream[this._current] !== "`" && this._current < maxLength) {
              // You can escape a literal char or you can escape the escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "`")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          var literalString = trimLeft(stream.slice(start, this._current));
          literalString = literalString.replace("\\`", "`");
          if (this._looksLikeJSON(literalString)) {
              literal = JSON.parse(literalString);
          } else {
              // Try to JSON parse it as "<literal>"
              literal = JSON.parse("\"" + literalString + "\"");
          }
          // +1 gets us to the ending "`", +1 to move on to the next char.
          this._current++;
          return literal;
      },

      _looksLikeJSON: function(literalString) {
          var startingChars = "[{\"";
          var jsonLiterals = ["true", "false", "null"];
          var numberLooking = "-0123456789";

          if (literalString === "") {
              return false;
          } else if (startingChars.indexOf(literalString[0]) >= 0) {
              return true;
          } else if (jsonLiterals.indexOf(literalString) >= 0) {
              return true;
          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
              try {
                  JSON.parse(literalString);
                  return true;
              } catch (ex) {
                  return false;
              }
          } else {
              return false;
          }
      }
  };

      var bindingPower = {};
      bindingPower[TOK_EOF] = 0;
      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_RBRACKET] = 0;
      bindingPower[TOK_RPAREN] = 0;
      bindingPower[TOK_COMMA] = 0;
      bindingPower[TOK_RBRACE] = 0;
      bindingPower[TOK_NUMBER] = 0;
      bindingPower[TOK_CURRENT] = 0;
      bindingPower[TOK_EXPREF] = 0;
      bindingPower[TOK_PIPE] = 1;
      bindingPower[TOK_OR] = 2;
      bindingPower[TOK_AND] = 3;
      bindingPower[TOK_EQ] = 5;
      bindingPower[TOK_GT] = 5;
      bindingPower[TOK_LT] = 5;
      bindingPower[TOK_GTE] = 5;
      bindingPower[TOK_LTE] = 5;
      bindingPower[TOK_NE] = 5;
      bindingPower[TOK_FLATTEN] = 9;
      bindingPower[TOK_STAR] = 20;
      bindingPower[TOK_FILTER] = 21;
      bindingPower[TOK_DOT] = 40;
      bindingPower[TOK_NOT] = 45;
      bindingPower[TOK_LBRACE] = 50;
      bindingPower[TOK_LBRACKET] = 55;
      bindingPower[TOK_LPAREN] = 60;

  function Parser() {
  }

  Parser.prototype = {
      parse: function(expression) {
          this._loadTokens(expression);
          this.index = 0;
          var ast = this.expression(0);
          if (this._lookahead(0) !== TOK_EOF) {
              var t = this._lookaheadToken(0);
              var error = new Error(
                  "Unexpected token type: " + t.type + ", value: " + t.value);
              error.name = "ParserError";
              throw error;
          }
          return ast;
      },

      _loadTokens: function(expression) {
          var lexer = new Lexer();
          var tokens = lexer.tokenize(expression);
          tokens.push({type: TOK_EOF, value: "", start: expression.length});
          this.tokens = tokens;
      },

      expression: function(rbp) {
          var leftToken = this._lookaheadToken(0);
          this._advance();
          var left = this.nud(leftToken);
          var currentToken = this._lookahead(0);
          while (rbp < bindingPower[currentToken]) {
              this._advance();
              left = this.led(currentToken, left);
              currentToken = this._lookahead(0);
          }
          return left;
      },

      _lookahead: function(number) {
          return this.tokens[this.index + number].type;
      },

      _lookaheadToken: function(number) {
          return this.tokens[this.index + number];
      },

      _advance: function() {
          this.index++;
      },

      nud: function(token) {
        var left;
        var right;
        var expression;
        switch (token.type) {
          case TOK_LITERAL:
            return {type: "Literal", value: token.value};
          case TOK_UNQUOTEDIDENTIFIER:
            return {type: "Field", name: token.value};
          case TOK_QUOTEDIDENTIFIER:
            var node = {type: "Field", name: token.value};
            if (this._lookahead(0) === TOK_LPAREN) {
                throw new Error("Quoted identifier not allowed for function names.");
            } else {
                return node;
            }
            break;
          case TOK_NOT:
            right = this.expression(bindingPower.Not);
            return {type: "NotExpression", children: [right]};
          case TOK_STAR:
            left = {type: "Identity"};
            right = null;
            if (this._lookahead(0) === TOK_RBRACKET) {
                // This can happen in a multiselect,
                // [a, b, *]
                right = {type: "Identity"};
            } else {
                right = this._parseProjectionRHS(bindingPower.Star);
            }
            return {type: "ValueProjection", children: [left, right]};
          case TOK_FILTER:
            return this.led(token.type, {type: "Identity"});
          case TOK_LBRACE:
            return this._parseMultiselectHash();
          case TOK_FLATTEN:
            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
            right = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [left, right]};
          case TOK_LBRACKET:
            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice({type: "Identity"}, right);
            } else if (this._lookahead(0) === TOK_STAR &&
                       this._lookahead(1) === TOK_RBRACKET) {
                this._advance();
                this._advance();
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection",
                        children: [{type: "Identity"}, right]};
            } else {
                return this._parseMultiselectList();
            }
            break;
          case TOK_CURRENT:
            return {type: TOK_CURRENT};
          case TOK_EXPREF:
            expression = this.expression(bindingPower.Expref);
            return {type: "ExpressionReference", children: [expression]};
          case TOK_LPAREN:
            var args = [];
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            return args[0];
          default:
            this._errorToken(token);
        }
      },

      led: function(tokenName, left) {
        var right;
        switch(tokenName) {
          case TOK_DOT:
            var rbp = bindingPower.Dot;
            if (this._lookahead(0) !== TOK_STAR) {
                right = this._parseDotRHS(rbp);
                return {type: "Subexpression", children: [left, right]};
            } else {
                // Creating a projection.
                this._advance();
                right = this._parseProjectionRHS(rbp);
                return {type: "ValueProjection", children: [left, right]};
            }
            break;
          case TOK_PIPE:
            right = this.expression(bindingPower.Pipe);
            return {type: TOK_PIPE, children: [left, right]};
          case TOK_OR:
            right = this.expression(bindingPower.Or);
            return {type: "OrExpression", children: [left, right]};
          case TOK_AND:
            right = this.expression(bindingPower.And);
            return {type: "AndExpression", children: [left, right]};
          case TOK_LPAREN:
            var name = left.name;
            var args = [];
            var expression, node;
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              if (this._lookahead(0) === TOK_COMMA) {
                this._match(TOK_COMMA);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            node = {type: "Function", name: name, children: args};
            return node;
          case TOK_FILTER:
            var condition = this.expression(0);
            this._match(TOK_RBRACKET);
            if (this._lookahead(0) === TOK_FLATTEN) {
              right = {type: "Identity"};
            } else {
              right = this._parseProjectionRHS(bindingPower.Filter);
            }
            return {type: "FilterProjection", children: [left, right, condition]};
          case TOK_FLATTEN:
            var leftNode = {type: TOK_FLATTEN, children: [left]};
            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [leftNode, rightNode]};
          case TOK_EQ:
          case TOK_NE:
          case TOK_GT:
          case TOK_GTE:
          case TOK_LT:
          case TOK_LTE:
            return this._parseComparator(left, tokenName);
          case TOK_LBRACKET:
            var token = this._lookaheadToken(0);
            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice(left, right);
            } else {
                this._match(TOK_STAR);
                this._match(TOK_RBRACKET);
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection", children: [left, right]};
            }
            break;
          default:
            this._errorToken(this._lookaheadToken(0));
        }
      },

      _match: function(tokenType) {
          if (this._lookahead(0) === tokenType) {
              this._advance();
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Expected " + tokenType + ", got: " + t.type);
              error.name = "ParserError";
              throw error;
          }
      },

      _errorToken: function(token) {
          var error = new Error("Invalid token (" +
                                token.type + "): \"" +
                                token.value + "\"");
          error.name = "ParserError";
          throw error;
      },


      _parseIndexExpression: function() {
          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
              return this._parseSliceExpression();
          } else {
              var node = {
                  type: "Index",
                  value: this._lookaheadToken(0).value};
              this._advance();
              this._match(TOK_RBRACKET);
              return node;
          }
      },

      _projectIfSlice: function(left, right) {
          var indexExpr = {type: "IndexExpression", children: [left, right]};
          if (right.type === "Slice") {
              return {
                  type: "Projection",
                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
              };
          } else {
              return indexExpr;
          }
      },

      _parseSliceExpression: function() {
          // [start:end:step] where each part is optional, as well as the last
          // colon.
          var parts = [null, null, null];
          var index = 0;
          var currentToken = this._lookahead(0);
          while (currentToken !== TOK_RBRACKET && index < 3) {
              if (currentToken === TOK_COLON) {
                  index++;
                  this._advance();
              } else if (currentToken === TOK_NUMBER) {
                  parts[index] = this._lookaheadToken(0).value;
                  this._advance();
              } else {
                  var t = this._lookahead(0);
                  var error = new Error("Syntax error, unexpected token: " +
                                        t.value + "(" + t.type + ")");
                  error.name = "Parsererror";
                  throw error;
              }
              currentToken = this._lookahead(0);
          }
          this._match(TOK_RBRACKET);
          return {
              type: "Slice",
              children: parts
          };
      },

      _parseComparator: function(left, comparator) {
        var right = this.expression(bindingPower[comparator]);
        return {type: "Comparator", name: comparator, children: [left, right]};
      },

      _parseDotRHS: function(rbp) {
          var lookahead = this._lookahead(0);
          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
          if (exprTokens.indexOf(lookahead) >= 0) {
              return this.expression(rbp);
          } else if (lookahead === TOK_LBRACKET) {
              this._match(TOK_LBRACKET);
              return this._parseMultiselectList();
          } else if (lookahead === TOK_LBRACE) {
              this._match(TOK_LBRACE);
              return this._parseMultiselectHash();
          }
      },

      _parseProjectionRHS: function(rbp) {
          var right;
          if (bindingPower[this._lookahead(0)] < 10) {
              right = {type: "Identity"};
          } else if (this._lookahead(0) === TOK_LBRACKET) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_FILTER) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_DOT) {
              this._match(TOK_DOT);
              right = this._parseDotRHS(rbp);
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Sytanx error, unexpected token: " +
                                    t.value + "(" + t.type + ")");
              error.name = "ParserError";
              throw error;
          }
          return right;
      },

      _parseMultiselectList: function() {
          var expressions = [];
          while (this._lookahead(0) !== TOK_RBRACKET) {
              var expression = this.expression(0);
              expressions.push(expression);
              if (this._lookahead(0) === TOK_COMMA) {
                  this._match(TOK_COMMA);
                  if (this._lookahead(0) === TOK_RBRACKET) {
                    throw new Error("Unexpected token Rbracket");
                  }
              }
          }
          this._match(TOK_RBRACKET);
          return {type: "MultiSelectList", children: expressions};
      },

      _parseMultiselectHash: function() {
        var pairs = [];
        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
        var keyToken, keyName, value, node;
        for (;;) {
          keyToken = this._lookaheadToken(0);
          if (identifierTypes.indexOf(keyToken.type) < 0) {
            throw new Error("Expecting an identifier token, got: " +
                            keyToken.type);
          }
          keyName = keyToken.value;
          this._advance();
          this._match(TOK_COLON);
          value = this.expression(0);
          node = {type: "KeyValuePair", name: keyName, value: value};
          pairs.push(node);
          if (this._lookahead(0) === TOK_COMMA) {
            this._match(TOK_COMMA);
          } else if (this._lookahead(0) === TOK_RBRACE) {
            this._match(TOK_RBRACE);
            break;
          }
        }
        return {type: "MultiSelectHash", children: pairs};
      }
  };


  function TreeInterpreter(runtime) {
    this.runtime = runtime;
  }

  TreeInterpreter.prototype = {
      search: function(node, value) {
          return this.visit(node, value);
      },

      visit: function(node, value) {
          var matched, current, result, first, second, field, left, right, collected, i;
          switch (node.type) {
            case "Field":
              if (value === null ) {
                  return null;
              } else if (isObject(value)) {
                  field = value[node.name];
                  if (field === undefined) {
                      return null;
                  } else {
                      return field;
                  }
              } else {
                return null;
              }
              break;
            case "Subexpression":
              result = this.visit(node.children[0], value);
              for (i = 1; i < node.children.length; i++) {
                  result = this.visit(node.children[1], result);
                  if (result === null) {
                      return null;
                  }
              }
              return result;
            case "IndexExpression":
              left = this.visit(node.children[0], value);
              right = this.visit(node.children[1], left);
              return right;
            case "Index":
              if (!isArray(value)) {
                return null;
              }
              var index = node.value;
              if (index < 0) {
                index = value.length + index;
              }
              result = value[index];
              if (result === undefined) {
                result = null;
              }
              return result;
            case "Slice":
              if (!isArray(value)) {
                return null;
              }
              var sliceParams = node.children.slice(0);
              var computed = this.computeSliceParams(value.length, sliceParams);
              var start = computed[0];
              var stop = computed[1];
              var step = computed[2];
              result = [];
              if (step > 0) {
                  for (i = start; i < stop; i += step) {
                      result.push(value[i]);
                  }
              } else {
                  for (i = start; i > stop; i += step) {
                      result.push(value[i]);
                  }
              }
              return result;
            case "Projection":
              // Evaluate left child.
              var base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              collected = [];
              for (i = 0; i < base.length; i++) {
                current = this.visit(node.children[1], base[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "ValueProjection":
              // Evaluate left child.
              base = this.visit(node.children[0], value);
              if (!isObject(base)) {
                return null;
              }
              collected = [];
              var values = objValues(base);
              for (i = 0; i < values.length; i++) {
                current = this.visit(node.children[1], values[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "FilterProjection":
              base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              var filtered = [];
              var finalResults = [];
              for (i = 0; i < base.length; i++) {
                matched = this.visit(node.children[2], base[i]);
                if (!isFalse(matched)) {
                  filtered.push(base[i]);
                }
              }
              for (var j = 0; j < filtered.length; j++) {
                current = this.visit(node.children[1], filtered[j]);
                if (current !== null) {
                  finalResults.push(current);
                }
              }
              return finalResults;
            case "Comparator":
              first = this.visit(node.children[0], value);
              second = this.visit(node.children[1], value);
              switch(node.name) {
                case TOK_EQ:
                  result = strictDeepEqual(first, second);
                  break;
                case TOK_NE:
                  result = !strictDeepEqual(first, second);
                  break;
                case TOK_GT:
                  result = first > second;
                  break;
                case TOK_GTE:
                  result = first >= second;
                  break;
                case TOK_LT:
                  result = first < second;
                  break;
                case TOK_LTE:
                  result = first <= second;
                  break;
                default:
                  throw new Error("Unknown comparator: " + node.name);
              }
              return result;
            case TOK_FLATTEN:
              var original = this.visit(node.children[0], value);
              if (!isArray(original)) {
                return null;
              }
              var merged = [];
              for (i = 0; i < original.length; i++) {
                current = original[i];
                if (isArray(current)) {
                  merged.push.apply(merged, current);
                } else {
                  merged.push(current);
                }
              }
              return merged;
            case "Identity":
              return value;
            case "MultiSelectList":
              if (value === null) {
                return null;
              }
              collected = [];
              for (i = 0; i < node.children.length; i++) {
                  collected.push(this.visit(node.children[i], value));
              }
              return collected;
            case "MultiSelectHash":
              if (value === null) {
                return null;
              }
              collected = {};
              var child;
              for (i = 0; i < node.children.length; i++) {
                child = node.children[i];
                collected[child.name] = this.visit(child.value, value);
              }
              return collected;
            case "OrExpression":
              matched = this.visit(node.children[0], value);
              if (isFalse(matched)) {
                  matched = this.visit(node.children[1], value);
              }
              return matched;
            case "AndExpression":
              first = this.visit(node.children[0], value);

              if (isFalse(first) === true) {
                return first;
              }
              return this.visit(node.children[1], value);
            case "NotExpression":
              first = this.visit(node.children[0], value);
              return isFalse(first);
            case "Literal":
              return node.value;
            case TOK_PIPE:
              left = this.visit(node.children[0], value);
              return this.visit(node.children[1], left);
            case TOK_CURRENT:
              return value;
            case "Function":
              var resolvedArgs = [];
              for (i = 0; i < node.children.length; i++) {
                  resolvedArgs.push(this.visit(node.children[i], value));
              }
              return this.runtime.callFunction(node.name, resolvedArgs);
            case "ExpressionReference":
              var refNode = node.children[0];
              // Tag the node with a specific attribute so the type
              // checker verify the type.
              refNode.jmespathType = TOK_EXPREF;
              return refNode;
            default:
              throw new Error("Unknown node type: " + node.type);
          }
      },

      computeSliceParams: function(arrayLength, sliceParams) {
        var start = sliceParams[0];
        var stop = sliceParams[1];
        var step = sliceParams[2];
        var computed = [null, null, null];
        if (step === null) {
          step = 1;
        } else if (step === 0) {
          var error = new Error("Invalid slice, step cannot be 0");
          error.name = "RuntimeError";
          throw error;
        }
        var stepValueNegative = step < 0 ? true : false;

        if (start === null) {
            start = stepValueNegative ? arrayLength - 1 : 0;
        } else {
            start = this.capSliceRange(arrayLength, start, step);
        }

        if (stop === null) {
            stop = stepValueNegative ? -1 : arrayLength;
        } else {
            stop = this.capSliceRange(arrayLength, stop, step);
        }
        computed[0] = start;
        computed[1] = stop;
        computed[2] = step;
        return computed;
      },

      capSliceRange: function(arrayLength, actualValue, step) {
          if (actualValue < 0) {
              actualValue += arrayLength;
              if (actualValue < 0) {
                  actualValue = step < 0 ? -1 : 0;
              }
          } else if (actualValue >= arrayLength) {
              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
          }
          return actualValue;
      }

  };

  function Runtime(interpreter) {
    this._interpreter = interpreter;
    this.functionTable = {
        // name: [function, <signature>]
        // The <signature> can be:
        //
        // {
        //   args: [[type1, type2], [type1, type2]],
        //   variadic: true|false
        // }
        //
        // Each arg in the arg list is a list of valid types
        // (if the function is overloaded and supports multiple
        // types.  If the type is "any" then no type checking
        // occurs on the argument.  Variadic is optional
        // and if not provided is assumed to be false.
        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
        contains: {
            _func: this._functionContains,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
                        {types: [TYPE_ANY]}]},
        "ends_with": {
            _func: this._functionEndsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
        length: {
            _func: this._functionLength,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
        map: {
            _func: this._functionMap,
            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
        max: {
            _func: this._functionMax,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "merge": {
            _func: this._functionMerge,
            _signature: [{types: [TYPE_OBJECT], variadic: true}]
        },
        "max_by": {
          _func: this._functionMaxBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        "starts_with": {
            _func: this._functionStartsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        min: {
            _func: this._functionMin,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "min_by": {
          _func: this._functionMinBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
        "sort_by": {
          _func: this._functionSortBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        join: {
            _func: this._functionJoin,
            _signature: [
                {types: [TYPE_STRING]},
                {types: [TYPE_ARRAY_STRING]}
            ]
        },
        reverse: {
            _func: this._functionReverse,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
        "not_null": {
            _func: this._functionNotNull,
            _signature: [{types: [TYPE_ANY], variadic: true}]
        }
    };
  }

  Runtime.prototype = {
    callFunction: function(name, resolvedArgs) {
      var functionEntry = this.functionTable[name];
      if (functionEntry === undefined) {
          throw new Error("Unknown function: " + name + "()");
      }
      this._validateArgs(name, resolvedArgs, functionEntry._signature);
      return functionEntry._func.call(this, resolvedArgs);
    },

    _validateArgs: function(name, args, signature) {
        // Validating the args requires validating
        // the correct arity and the correct type of each arg.
        // If the last argument is declared as variadic, then we need
        // a minimum number of args to be required.  Otherwise it has to
        // be an exact amount.
        var pluralized;
        if (signature[signature.length - 1].variadic) {
            if (args.length < signature.length) {
                pluralized = signature.length === 1 ? " argument" : " arguments";
                throw new Error("ArgumentError: " + name + "() " +
                                "takes at least" + signature.length + pluralized +
                                " but received " + args.length);
            }
        } else if (args.length !== signature.length) {
            pluralized = signature.length === 1 ? " argument" : " arguments";
            throw new Error("ArgumentError: " + name + "() " +
                            "takes " + signature.length + pluralized +
                            " but received " + args.length);
        }
        var currentSpec;
        var actualType;
        var typeMatched;
        for (var i = 0; i < signature.length; i++) {
            typeMatched = false;
            currentSpec = signature[i].types;
            actualType = this._getTypeName(args[i]);
            for (var j = 0; j < currentSpec.length; j++) {
                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                    typeMatched = true;
                    break;
                }
            }
            if (!typeMatched) {
                throw new Error("TypeError: " + name + "() " +
                                "expected argument " + (i + 1) +
                                " to be type " + currentSpec +
                                " but received type " + actualType +
                                " instead.");
            }
        }
    },

    _typeMatches: function(actual, expected, argValue) {
        if (expected === TYPE_ANY) {
            return true;
        }
        if (expected === TYPE_ARRAY_STRING ||
            expected === TYPE_ARRAY_NUMBER ||
            expected === TYPE_ARRAY) {
            // The expected type can either just be array,
            // or it can require a specific subtype (array of numbers).
            //
            // The simplest case is if "array" with no subtype is specified.
            if (expected === TYPE_ARRAY) {
                return actual === TYPE_ARRAY;
            } else if (actual === TYPE_ARRAY) {
                // Otherwise we need to check subtypes.
                // I think this has potential to be improved.
                var subtype;
                if (expected === TYPE_ARRAY_NUMBER) {
                  subtype = TYPE_NUMBER;
                } else if (expected === TYPE_ARRAY_STRING) {
                  subtype = TYPE_STRING;
                }
                for (var i = 0; i < argValue.length; i++) {
                    if (!this._typeMatches(
                            this._getTypeName(argValue[i]), subtype,
                                             argValue[i])) {
                        return false;
                    }
                }
                return true;
            }
        } else {
            return actual === expected;
        }
    },
    _getTypeName: function(obj) {
        switch (Object.prototype.toString.call(obj)) {
            case "[object String]":
              return TYPE_STRING;
            case "[object Number]":
              return TYPE_NUMBER;
            case "[object Array]":
              return TYPE_ARRAY;
            case "[object Boolean]":
              return TYPE_BOOLEAN;
            case "[object Null]":
              return TYPE_NULL;
            case "[object Object]":
              // Check if it's an expref.  If it has, it's been
              // tagged with a jmespathType attr of 'Expref';
              if (obj.jmespathType === TOK_EXPREF) {
                return TYPE_EXPREF;
              } else {
                return TYPE_OBJECT;
              }
        }
    },

    _functionStartsWith: function(resolvedArgs) {
        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
    },

    _functionEndsWith: function(resolvedArgs) {
        var searchStr = resolvedArgs[0];
        var suffix = resolvedArgs[1];
        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
    },

    _functionReverse: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        if (typeName === TYPE_STRING) {
          var originalStr = resolvedArgs[0];
          var reversedStr = "";
          for (var i = originalStr.length - 1; i >= 0; i--) {
              reversedStr += originalStr[i];
          }
          return reversedStr;
        } else {
          var reversedArray = resolvedArgs[0].slice(0);
          reversedArray.reverse();
          return reversedArray;
        }
    },

    _functionAbs: function(resolvedArgs) {
      return Math.abs(resolvedArgs[0]);
    },

    _functionCeil: function(resolvedArgs) {
        return Math.ceil(resolvedArgs[0]);
    },

    _functionAvg: function(resolvedArgs) {
        var sum = 0;
        var inputArray = resolvedArgs[0];
        for (var i = 0; i < inputArray.length; i++) {
            sum += inputArray[i];
        }
        return sum / inputArray.length;
    },

    _functionContains: function(resolvedArgs) {
        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
    },

    _functionFloor: function(resolvedArgs) {
        return Math.floor(resolvedArgs[0]);
    },

    _functionLength: function(resolvedArgs) {
       if (!isObject(resolvedArgs[0])) {
         return resolvedArgs[0].length;
       } else {
         // As far as I can tell, there's no way to get the length
         // of an object without O(n) iteration through the object.
         return Object.keys(resolvedArgs[0]).length;
       }
    },

    _functionMap: function(resolvedArgs) {
      var mapped = [];
      var interpreter = this._interpreter;
      var exprefNode = resolvedArgs[0];
      var elements = resolvedArgs[1];
      for (var i = 0; i < elements.length; i++) {
          mapped.push(interpreter.visit(exprefNode, elements[i]));
      }
      return mapped;
    },

    _functionMerge: function(resolvedArgs) {
      var merged = {};
      for (var i = 0; i < resolvedArgs.length; i++) {
        var current = resolvedArgs[i];
        for (var key in current) {
          merged[key] = current[key];
        }
      }
      return merged;
    },

    _functionMax: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.max.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var maxElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (maxElement.localeCompare(elements[i]) < 0) {
                  maxElement = elements[i];
              }
          }
          return maxElement;
        }
      } else {
          return null;
      }
    },

    _functionMin: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.min.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var minElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (elements[i].localeCompare(minElement) < 0) {
                  minElement = elements[i];
              }
          }
          return minElement;
        }
      } else {
        return null;
      }
    },

    _functionSum: function(resolvedArgs) {
      var sum = 0;
      var listToSum = resolvedArgs[0];
      for (var i = 0; i < listToSum.length; i++) {
        sum += listToSum[i];
      }
      return sum;
    },

    _functionType: function(resolvedArgs) {
        switch (this._getTypeName(resolvedArgs[0])) {
          case TYPE_NUMBER:
            return "number";
          case TYPE_STRING:
            return "string";
          case TYPE_ARRAY:
            return "array";
          case TYPE_OBJECT:
            return "object";
          case TYPE_BOOLEAN:
            return "boolean";
          case TYPE_EXPREF:
            return "expref";
          case TYPE_NULL:
            return "null";
        }
    },

    _functionKeys: function(resolvedArgs) {
        return Object.keys(resolvedArgs[0]);
    },

    _functionValues: function(resolvedArgs) {
        var obj = resolvedArgs[0];
        var keys = Object.keys(obj);
        var values = [];
        for (var i = 0; i < keys.length; i++) {
            values.push(obj[keys[i]]);
        }
        return values;
    },

    _functionJoin: function(resolvedArgs) {
        var joinChar = resolvedArgs[0];
        var listJoin = resolvedArgs[1];
        return listJoin.join(joinChar);
    },

    _functionToArray: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
            return resolvedArgs[0];
        } else {
            return [resolvedArgs[0]];
        }
    },

    _functionToString: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
            return resolvedArgs[0];
        } else {
            return JSON.stringify(resolvedArgs[0]);
        }
    },

    _functionToNumber: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        var convertedValue;
        if (typeName === TYPE_NUMBER) {
            return resolvedArgs[0];
        } else if (typeName === TYPE_STRING) {
            convertedValue = +resolvedArgs[0];
            if (!isNaN(convertedValue)) {
                return convertedValue;
            }
        }
        return null;
    },

    _functionNotNull: function(resolvedArgs) {
        for (var i = 0; i < resolvedArgs.length; i++) {
            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
                return resolvedArgs[i];
            }
        }
        return null;
    },

    _functionSort: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        sortedArray.sort();
        return sortedArray;
    },

    _functionSortBy: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        if (sortedArray.length === 0) {
            return sortedArray;
        }
        var interpreter = this._interpreter;
        var exprefNode = resolvedArgs[1];
        var requiredType = this._getTypeName(
            interpreter.visit(exprefNode, sortedArray[0]));
        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
            throw new Error("TypeError");
        }
        var that = this;
        // In order to get a stable sort out of an unstable
        // sort algorithm, we decorate/sort/undecorate (DSU)
        // by creating a new list of [index, element] pairs.
        // In the cmp function, if the evaluated elements are
        // equal, then the index will be used as the tiebreaker.
        // After the decorated list has been sorted, it will be
        // undecorated to extract the original elements.
        var decorated = [];
        for (var i = 0; i < sortedArray.length; i++) {
          decorated.push([i, sortedArray[i]]);
        }
        decorated.sort(function(a, b) {
          var exprA = interpreter.visit(exprefNode, a[1]);
          var exprB = interpreter.visit(exprefNode, b[1]);
          if (that._getTypeName(exprA) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprA));
          } else if (that._getTypeName(exprB) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprB));
          }
          if (exprA > exprB) {
            return 1;
          } else if (exprA < exprB) {
            return -1;
          } else {
            // If they're equal compare the items by their
            // order to maintain relative order of equal keys
            // (i.e. to get a stable sort).
            return a[0] - b[0];
          }
        });
        // Undecorate: extract out the original list elements.
        for (var j = 0; j < decorated.length; j++) {
          sortedArray[j] = decorated[j][1];
        }
        return sortedArray;
    },

    _functionMaxBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var maxNumber = -Infinity;
      var maxRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current > maxNumber) {
          maxNumber = current;
          maxRecord = resolvedArray[i];
        }
      }
      return maxRecord;
    },

    _functionMinBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var minNumber = Infinity;
      var minRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current < minNumber) {
          minNumber = current;
          minRecord = resolvedArray[i];
        }
      }
      return minRecord;
    },

    createKeyFunction: function(exprefNode, allowedTypes) {
      var that = this;
      var interpreter = this._interpreter;
      var keyFunc = function(x) {
        var current = interpreter.visit(exprefNode, x);
        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
          var msg = "TypeError: expected one of " + allowedTypes +
                    ", received " + that._getTypeName(current);
          throw new Error(msg);
        }
        return current;
      };
      return keyFunc;
    }

  };

  function compile(stream) {
    var parser = new Parser();
    var ast = parser.parse(stream);
    return ast;
  }

  function tokenize(stream) {
      var lexer = new Lexer();
      return lexer.tokenize(stream);
  }

  function search(data, expression) {
      var parser = new Parser();
      // This needs to be improved.  Both the interpreter and runtime depend on
      // each other.  The runtime needs the interpreter to support exprefs.
      // There's likely a clean way to avoid the cyclic dependency.
      var runtime = new Runtime();
      var interpreter = new TreeInterpreter(runtime);
      runtime._interpreter = interpreter;
      var node = parser.parse(expression);
      return interpreter.search(node, data);
  }

  exports.tokenize = tokenize;
  exports.compile = compile;
  exports.search = search;
  exports.strictDeepEqual = strictDeepEqual;
})( false ? this.jmespath = {} : exports);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryStorage; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var dataMemory = {};
/** @class */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */
    MemoryStorage.setItem = function (key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */
    MemoryStorage.getItem = function (key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key)
            ? dataMemory[key]
            : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */
    MemoryStorage.removeItem = function (key) {
        return delete dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */
    MemoryStorage.clear = function () {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}());

var StorageHelper = /** @class */ (function () {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */
    function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        }
        catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */
    StorageHelper.prototype.getStorage = function () {
        return this.storageWindow;
    };
    return StorageHelper;
}());
/* harmony default export */ __webpack_exports__["b"] = (StorageHelper);
//# sourceMappingURL=index.js.map

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthenticationDetails__ = __webpack_require__(1192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationDetails", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthenticationDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthenticationHelper__ = __webpack_require__(513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationHelper", function() { return __WEBPACK_IMPORTED_MODULE_1__AuthenticationHelper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoAccessToken__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoAccessToken", function() { return __WEBPACK_IMPORTED_MODULE_2__CognitoAccessToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoIdToken__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoIdToken", function() { return __WEBPACK_IMPORTED_MODULE_3__CognitoIdToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CognitoRefreshToken__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoRefreshToken", function() { return __WEBPACK_IMPORTED_MODULE_4__CognitoRefreshToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CognitoUser__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoUser", function() { return __WEBPACK_IMPORTED_MODULE_5__CognitoUser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CognitoUserAttribute__ = __webpack_require__(525);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoUserAttribute", function() { return __WEBPACK_IMPORTED_MODULE_6__CognitoUserAttribute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CognitoUserPool__ = __webpack_require__(1195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoUserPool", function() { return __WEBPACK_IMPORTED_MODULE_7__CognitoUserPool__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CognitoUserSession__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoUserSession", function() { return __WEBPACK_IMPORTED_MODULE_8__CognitoUserSession__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CookieStorage__ = __webpack_require__(1198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CookieStorage", function() { return __WEBPACK_IMPORTED_MODULE_9__CookieStorage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateHelper__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return __WEBPACK_IMPORTED_MODULE_10__DateHelper__["a"]; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */













/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DecodingHelper__ = __webpack_require__(528);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */



/** @class */

var CognitoAccessToken = function () {
  /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */
  function CognitoAccessToken(AccessToken) {
    _classCallCheck(this, CognitoAccessToken);

    // Assign object
    this.jwtToken = AccessToken || '';
    this.payload = this.decodePayload();
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoAccessToken.prototype.getJwtToken = function getJwtToken() {
    return this.jwtToken;
  };

  /**
   * Sets new value for access token.
   * @param {string=} accessToken The JWT access token.
   * @returns {void}
   */


  CognitoAccessToken.prototype.setJwtToken = function setJwtToken(accessToken) {
    this.jwtToken = accessToken;
  };

  /**
   * @returns {int} the token's expiration (exp member).
   */


  CognitoAccessToken.prototype.getExpiration = function getExpiration() {
    if (this.jwtToken === null) {
      return undefined;
    }
    var jwtPayload = this.jwtToken.split('.')[1];
    return JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__DecodingHelper__["a" /* decode */])(jwtPayload)).exp;
  };

  /**
   * @returns {string} the username from payload.
   */


  CognitoAccessToken.prototype.getUsername = function getUsername() {
    if (this.jwtToken === null) {
      return undefined;
    }
    var jwtPayload = this.jwtToken.split('.')[1];
    return JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__DecodingHelper__["a" /* decode */])(jwtPayload)).username;
  };

  /**
   * @returns {object} the token's payload.
   */


  CognitoAccessToken.prototype.decodePayload = function decodePayload() {
    var jwtPayload = this.jwtToken.split('.')[1];
    try {
      return JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__DecodingHelper__["a" /* decode */])(jwtPayload));
    } catch (err) {
      return {};
    }
  };

  return CognitoAccessToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoAccessToken);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DecodingHelper__ = __webpack_require__(528);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */



/** @class */

var CognitoIdToken = function () {
  /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */
  function CognitoIdToken(IdToken) {
    _classCallCheck(this, CognitoIdToken);

    // Assign object
    this.jwtToken = IdToken || '';
    this.payload = this.decodePayload();
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoIdToken.prototype.getJwtToken = function getJwtToken() {
    return this.jwtToken;
  };

  /**
   * Sets new value for id token.
   * @param {string=} idToken The JWT Id token
   * @returns {void}
   */


  CognitoIdToken.prototype.setJwtToken = function setJwtToken(idToken) {
    this.jwtToken = idToken;
  };

  /**
   * @returns {int} the token's expiration (exp member).
   */


  CognitoIdToken.prototype.getExpiration = function getExpiration() {
    if (this.jwtToken === null) {
      return undefined;
    }
    var jwtPayload = this.jwtToken.split('.')[1];
    return JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__DecodingHelper__["a" /* decode */])(jwtPayload)).exp;
  };

  /**
   * @returns {object} the token's payload.
   */


  CognitoIdToken.prototype.decodePayload = function decodePayload() {
    var jwtPayload = this.jwtToken.split('.')[1];
    try {
      return JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__DecodingHelper__["a" /* decode */])(jwtPayload));
    } catch (err) {
      return {};
    }
  };

  return CognitoIdToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoIdToken);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */

/** @class */
var CognitoRefreshToken = function () {
  /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */
  function CognitoRefreshToken(RefreshToken) {
    _classCallCheck(this, CognitoRefreshToken);

    // Assign object
    this.refreshToken = RefreshToken || '';
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoRefreshToken.prototype.getToken = function getToken() {
    return this.refreshToken;
  };

  /**
   * Sets new value for refresh token.
   * @param {string=} refreshToken The JWT refresh token.
   * @returns {void}
   */


  CognitoRefreshToken.prototype.setToken = function setToken(refreshToken) {
    this.refreshToken = refreshToken;
  };

  return CognitoRefreshToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoRefreshToken);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */

/** @class */
var CognitoTokenScopes = function () {
  /**
   * Constructs a new CognitoTokenScopes object
   * @param {array=} TokenScopesArray The token scopes
   */
  function CognitoTokenScopes(TokenScopesArray) {
    _classCallCheck(this, CognitoTokenScopes);

    // Assign object
    this.tokenScopes = TokenScopesArray || [];
  }

  /**
   * @returns {Array} the token scopes.
   */


  CognitoTokenScopes.prototype.getScopes = function getScopes() {
    return this.tokenScopes;
  };

  /**
   * Sets new value for token scopes.
   * @param {array=} tokenScopes The token scopes
   * @returns {void}
   */


  CognitoTokenScopes.prototype.setTokenScopes = function setTokenScopes(tokenScopes) {
    this.tokenScopes = tokenScopes;
  };

  return CognitoTokenScopes;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoTokenScopes);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CacheUtils__ = __webpack_require__(1208);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CacheList__ = __webpack_require__(1209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CacheList__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


//# sourceMappingURL=index.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 *
 * The decorator may be used on classes or methods
 * ```
 * @autobind
 * class FullBound {}
 *
 * class PartBound {
 *   @autobind
 *   method () {}
 * }
 * ```
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = autobind;

function autobind() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return boundClass.apply(undefined, args);
  } else {
    return boundMethod.apply(undefined, args);
  }
}

/**
 * Use boundMethod to bind all methods on the target.prototype
 */
function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys = undefined;
  // Use Reflect if exists
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype);
    // use symbols if support is provided
    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

    // Only methods need binding
    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
  }

  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.
  var definingProperty = false;

  return {
    configurable: true,
    get: function get() {
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        value: boundFn,
        configurable: true,
        writable: true
      });
      definingProperty = false;
      return boundFn;
    }
  };
}
module.exports = exports['default'];


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserRecomendation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getItemToItemRecomendation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Products_selector__ = __webpack_require__(1340);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{itemToItem:{products:[],isLoading:false},user:{products:[],isLoading:false}};var action=arguments[1];switch(action.type){case'FETCH_USER_RECOMENDATION':return Object.assign({},state,{user:{products:[],isLoading:true}});case'FETCH_ITEM_TO_ITEM__RECOMENDATION':return Object.assign({},state,{itemToItem:{products:[],isLoading:true}});case'FETCH_USER_RECOMENDATION_SUCCESS':return Object.assign({},state,{user:{products:[].concat(_toConsumableArray(action.payload.data)),isLoading:false}});case'FETCH_ITEM_TO_ITEM__RECOMENDATION_SUCCESS':return Object.assign({},state,{itemToItem:{products:[].concat(_toConsumableArray(action.payload.data)),isLoading:false}});case'FETCH_USER_RECOMENDATION_FAIL':return Object.assign({},state,{error:action.error});case'FETCH_ITEM_TO_ITEM__RECOMENDATION_FAIL':return Object.assign({},state,{error:action.error});case'FETCH_RECOMENDATION_CARD_AVAILABILITY':return Object.assign({},state);case'FETCH_RECOMENDATION_CARD_AVAILABILITY_SUCCESS':var availability=action.payload.data[0];var products=state.products;var sku=action.meta.previousAction.sku;var index=products.findIndex(function(p){return p.sku===sku;});if(products[index]){products[index].availability=Object.assign({},availability);}return Object.assign({},state,{products:products});case'FETCH_RECOMENDATION_CARD_AVAILABILITY_FAIL':return Object.assign({},state,{error_availability:action.error});default:return Object.assign({},state);}});var getRandomInt=function getRandomInt(min,max){min=Math.ceil(min);max=Math.floor(max);return Math.floor(Math.random()*(max-min+1))+min;};var getUserRecomendation=function getUserRecomendation(listProducts,recomendation,availabilities){var products=recomendation.user.products;var productsRecomendation=products.length>0?Object(__WEBPACK_IMPORTED_MODULE_0__Products_selector__["a" /* getProductsBySkuListWithAvailability */])(listProducts,products,availabilities):products;productsRecomendation.forEach(function(item){if(item.availability){item.availability['onlyCash']={sellingPrice:getRandomInt(0,1000).toFixed(2)};}});var voucher={products:products.length>0?Object(__WEBPACK_IMPORTED_MODULE_0__Products_selector__["a" /* getProductsBySkuListWithAvailability */])(listProducts,products,availabilities):products,title:'Veja os produtos indicados para você',titleMobile:'Produtos'};return voucher;};var getItemToItemRecomendation=function getItemToItemRecomendation(listProducts,recomendation){var products=recomendation.itemToItem.products;var productsRecomendation=products.length>0?Object(__WEBPACK_IMPORTED_MODULE_0__Products_selector__["a" /* getProductsBySkuListWithAvailability */])(listProducts,products):products;productsRecomendation.forEach(function(item){if(item.availability){item.availability['onlyCash']={sellingPrice:getRandomInt(0,1200).toFixed(2)};}});var voucher={products:products.length>0?Object(__WEBPACK_IMPORTED_MODULE_0__Products_selector__["a" /* getProductsBySkuListWithAvailability */])(listProducts,products):products,title:'Veja os produtos indicados para você',titleMobile:'Produtos'};return voucher;};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingContainer__ = __webpack_require__(1370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ShippingContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingPlaceholder__ = __webpack_require__(561);
/* unused harmony reexport ShippingPlaceholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__reducer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var FeatureWrapper=function FeatureWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},children));};FeatureWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (FeatureWrapper);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(1405);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_Button_ActionButton__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddToCartButton=function(_Component){_inherits(AddToCartButton,_Component);function AddToCartButton(props){_classCallCheck(this,AddToCartButton);var _this=_possibleConstructorReturn(this,(AddToCartButton.__proto__||Object.getPrototypeOf(AddToCartButton)).call(this,props));_this.AddItemCart=function(){if(__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_VERIFY_CART_PARTNER)&&_this.props.onlyCash){if(_this.props.items.length===0||_this.props.items.length>0&&_this.props.vendorId===_this.props.items[0].vendor.id.toString()){_this.props.onClick();}else{_this.props.items.map(function(item,index){_this.props.vendorId!==_this.props.items[0].vendor.id.toString()&&_this.props.removeItem(item.sku);});_this.setState({clickToRemove:true});}}else{_this.props.onClick();}};_this.state={clickToRemove:false};_this.AddItemCart=_this.AddItemCart.bind(_this);return _this;}_createClass(AddToCartButton,[{key:'render',value:function render(){if(this.state.clickToRemove&&this.props.itemsToRemove.skus.length===0){this.props.onClick();this.setState({clickToRemove:false});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_Button_ActionButton__["a" /* default */],Object.assign({AddItemCart:this.AddItemCart},this.props));}}]);return AddToCartButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref){var cart=_ref.cart,oidc=_ref.oidc,itemsToRemove=_ref.itemsToRemove,onlyCash=_ref.onlyCash;return{items:cart.items,isLoading:cart.isLoadingRedirect,hasSuccess:cart.itemAdded,email:oidc&&oidc.user&&oidc.user.profile&&oidc.user.profile.email,itemsToRemove:itemsToRemove,onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var sku=_ref2.sku,vendorId=_ref2.vendorId,goToCheckout=_ref2.goToCheckout;return{onClick:function onClick(email){return function(){return dispatch(__WEBPACK_IMPORTED_MODULE_2_features_Cart__["c" /* actions */].addItem({sku:sku,vendorId:vendorId,email:email},goToCheckout));};},removeItem:function removeItem(sku){return dispatch(__WEBPACK_IMPORTED_MODULE_2_features_Cart__["c" /* actions */].removeItem(sku));},loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_2_features_Cart__["c" /* actions */].loadCart());}};};var mergeProps=function mergeProps(_ref3,_ref4,own){var onClick=_ref4.onClick,removeItem=_ref4.removeItem;var email=_ref3.email,stateProps=_objectWithoutProperties(_ref3,['email']);return Object.assign({},stateProps,{onClick:onClick(email),removeItem:removeItem},own);};AddToCartButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,removeItem:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,wasModified:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,items:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,vendorId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,itemsToRemove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};AddToCartButton.defaultProps={errorText:'Erro ao adicionar',successText:'Adicionado',text:'Adicionar ao Carrinho',iconName:'icon_cart'};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(AddToCartButton));

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return SentryError;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(1440);

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

//# sourceMappingURL=error.js.map

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return logger;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(161);

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["g" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}();
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
'use strict';

/* harmony export (immutable) */__webpack_exports__["a"] = computeStackTrace;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
// tslint:disable:object-literal-sort-keys

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[-a-z]+:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
/** JSDoc */
function computeStackTrace(ex) {
    // tslint:disable:no-unsafe-any
    var stack = null;
    var popSize = ex && ex.framesToPop;
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    } catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    } catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true
    };
}
/** JSDoc */
// tslint:disable-next-line:cyclomatic-complexity
function computeStackTraceFromStackProp(ex) {
    // tslint:disable:no-conditional-assignment
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if (parts = chrome.exec(lines[i])) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null
            };
        } else if (parts = winjs.exec(lines[i])) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null
            };
        } else if (parts = gecko.exec(lines[i])) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            } else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null
            };
        } else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** JSDoc */
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        // tslint:disable:no-conditional-assignment
        var element = null;
        if (parts = opera10Regex.exec(lines[line])) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null
            };
        } else if (parts = opera11Regex.exec(lines[line])) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2]
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, stacktrace, { stack: stacktrace.stack.slice(popSize) });
    } catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return BaseTransport;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);

/** Base Transport class implementation */
var BaseTransport = /** @class */function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* PromiseBuffer */](30);
        this.url = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* API */](this.options.dsn).getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}();

//# sourceMappingURL=base.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["a"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */__webpack_exports__["b"] = wrap;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);

var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) {
        options = {};
    }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            // tslint:disable-next-line:strict-type-predicates
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            var wrappedArguments = args.map(function (arg) {
                return wrap(arg, options);
            });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
            // tslint:enable:no-unsafe-any
        } catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, processedEvent.extra, { arguments: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* normalize */])(args, 3) });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    } catch (_oO) {} // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true
        },
        __sentry_original__: {
            enumerable: false,
            value: fn
        }
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function get() {
                    return fn.name;
                }
            });
        }
    } catch (_oO) {
        /*no-empty*/
    }
    return sentryWrapped;
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectMobileOperator__ = __webpack_require__(1506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SelectMobileOperator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(1524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a"]; });


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DatePicker__ = __webpack_require__(1527);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__DatePicker__["a" /* default */]);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate).getTime();
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(211);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(614);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var desiredMonth = date.getMonth() + amount;
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
  return date;
}

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_context__);





var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_4_create_react_context___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "referenceNode", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);



/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchedulingContainer__ = __webpack_require__(1638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__SchedulingContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPartners */
/* unused harmony export convertPointsToMiles */
/* unused harmony export clearCalculator */
/* unused harmony export disableRedemptionButton */
/* unused harmony export closeErrorMileage */
/* unused harmony export errorCpfMileage */
/* unused harmony export errorBalanceRedemption */
/* unused harmony export errorMinimunRedemption */
/* unused harmony export errorMinimunBalanceRedemption */
/* unused harmony export authorizeWithTokenMileage */
/* unused harmony export mileageRedemption */
/* unused harmony export getMileageConfigurations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterPartnerMileage; });
/* unused harmony export getPartnersWithConfigurations */
/* unused harmony export closeModalShowError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getPartners=function getPartners(){return{type:'FETCH_MILEAGE_PARTNERS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/stores/mileage'}}};};var convertPointsToMiles=function convertPointsToMiles(supplierId,points){return{type:'FETCH_POINTS_TO_MILES',payload:{client:'mileageApi',request:{method:'get',url:'/mileage-api/v1/calculators/pointsToMiles/'+supplierId+'/'+points}}};};var clearCalculator=function clearCalculator(){return{type:'CLEAR_CALCULATOR'};};var disableRedemptionButton=function disableRedemptionButton(value){return{type:'REDEMPTION_DISABLE_BUTTON',value:value};};var closeErrorMileage=function closeErrorMileage(){return{type:'REDEMPTION_MILEAGE_CLOSE_ERROR'};};var errorCpfMileage=function errorCpfMileage(){return{type:'REDEMPTION_MILEAGE_ERROR_CPF'};};var errorBalanceRedemption=function errorBalanceRedemption(){return{type:'REDEMPTION_MILEAGE_ERROR_BALANCE'};};var errorMinimunRedemption=function errorMinimunRedemption(MinimumRedemption){return{type:'REDEMPTION_MILEAGE_MINIMUN',MinimumRedemption:MinimumRedemption};};var errorMinimunBalanceRedemption=function errorMinimunBalanceRedemption(MinimunBalance){return{type:'REDEMPTION_MILEAGE_MINIMUN_BALANCE',MinimunBalance:MinimunBalance};};var authorizeWithTokenMileage=function authorizeWithTokenMileage(client){return function(OrderId,Token,OrderMileageId,VendorId,lastTry){return function(dispatch,getState){var _getState=getState(),user=_getState.oidc.user;if(!user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/auth/login'));}else{dispatch({type:'MILEAGE_WITH_TOKEN',lastTry:lastTry,orderId:OrderId});}var handleSuccess=function handleSuccess(response){dispatch({type:'REDEMPTION_MILEAGE_SUCCESS'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/services/confirmation/'+response.data.order.liveOrderId));};var handleError=function handleError(error){var response=error.response;if(response.status===401){if(response.data.description==='AuthenticationRequired'){dispatch({type:'TOKEN_INVALID_MILEAGE',orderId:response.data.orderId,orderMileageId:response.data.orderMileageId,lastTry:lastTry});}}else{dispatch({type:'REDEMPTION_MILEAGE_FAIL',error:error});}};client.post('/mileage-api/v1/orders/withToken?orderId='+OrderId+'&token='+Token+'&orderMileageId='+OrderMileageId,null,{headers:{'X-Mileage-VendorId':VendorId}}).then(handleSuccess).catch(handleError);};};};var mileageRedemption=function mileageRedemption(client){return function(order,supplierId){return function(dispatch,getState){var _getState2=getState(),user=_getState2.oidc.user;if(!user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/auth/login'));}else{dispatch({type:'REDEMPTION_MILEAGE'});}var handleSuccess=function handleSuccess(response){dispatch({type:'REDEMPTION_MILEAGE_SUCCESS'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/services/confirmation/'+response.data.order.liveOrderId));};var handleError=function handleError(error){var response=error.response;if(response.status===401||response.status===406){if(response.data.description==='AuthenticationRequired'){dispatch({type:'AUTHORIZATION_REQUIRED_MILEAGE',orderId:response.data.orderId,orderMileageId:response.data.orderMileageId});}if(response.data.status==='OnBoardingRequired'){dispatch({type:'ONBOARDING_REQUIRED_MILEAGE'});}}else{dispatch({type:'REDEMPTION_MILEAGE_FAIL',error:error});}};client.post('/mileage-api/v1/orders/redemption',order,{headers:{'X-Mileage-VendorId':supplierId}}).then(handleSuccess).catch(handleError);};};};var getMileageConfigurations=function getMileageConfigurations(catalogId,supplierId){return{type:'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN',payload:{client:'mileageApi',request:{method:'get',url:'/mileage-api/v1/configurations/CampaignConfig?catalogId='+catalogId+'&supplierId='+supplierId}},supplierId:supplierId};};var filterPartnerMileage=function filterPartnerMileage(partners,isMileagePartners){var TYPE={DISTINCT_PARTNERS:77};if(isMileagePartners){return partners&&partners.filter(function(x){return x.priority!==TYPE.DISTINCT_PARTNERS;});}else{return partners&&partners.filter(function(x){return x.priority===TYPE.DISTINCT_PARTNERS;});}};var getPartnersWithConfigurations=function getPartnersWithConfigurations(client){return function(catalogId){return function(dispatch,_){dispatch({type:'FETCH_MILEAGE_PARTNERS'});dispatch({type:'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/CLOSE'});var handleSuccess=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data){var count;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:count=data.length-1;dispatch({type:'FETCH_MILEAGE_PARTNERS_SUCCESS',data:data});data.forEach(function(item,index){dispatch(getMileageConfigurations(catalogId,item.vendorId));if(index===count){setTimeout(function(){dispatch({type:'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/OPEN'});},3000);}});case 3:case'end':return _context.stop();}}},_callee,_this);}));return function handleSuccess(_x){return _ref.apply(this,arguments);};}();var handleFail=function handleFail(error){dispatch({type:'FETCH_MILEAGE_PARTNERS_FAIL',message:error});};client.get('/v1/stores/mileage').then(function(rensponse){handleSuccess(rensponse.data);}).catch(handleFail);};};};var closeModalShowError=function closeModalShowError(error){return{type:'CLOSE_MODAL_SHOW_ERROR',error:error};};/* harmony default export */ __webpack_exports__["a"] = (function(client,clientMkp){return{getPartners:getPartners,convertPointsToMiles:convertPointsToMiles,clearCalculator:clearCalculator,mileageRedemption:mileageRedemption(client),authorizeWithTokenMileage:authorizeWithTokenMileage(client),getPartnersWithConfigurations:getPartnersWithConfigurations(clientMkp),closeErrorMileage:closeErrorMileage,errorBalanceRedemption:errorBalanceRedemption,errorMinimunRedemption:errorMinimunRedemption,errorMinimunBalanceRedemption:errorMinimunBalanceRedemption,errorCpfMileage:errorCpfMileage,getMileageConfigurations:getMileageConfigurations,closeModalShowError:closeModalShowError,disableRedemptionButton:disableRedemptionButton};});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPartnersStix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMileageConfigurations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return convertPointsToMiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleSupplierId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeRedemptionPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeMinimumRedemptionLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeMaximumRedemptionLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeErrorStix; });
var Types={TOGGLE_SUPPLIER_ID:'STIX/TOGGLE_SUPPLIER_ID',CHANGE_REDEMPTION_POINTS:'STIX/CHANGE_REDEMPTION_POINTS',CHANGE_MINIMUM_REDEMPTION_LIMIT:'STIX/CHANGE_MINIMUM_REDEMPTION_LIMIT',CHANGE_MAXIMUM_REDEMPTION_LIMIT:'STIX/CHANGE_MAXIMUM_REDEMPTION_LIMIT',CLOSE_ERROR_STIX:'STIX/CLOSE_ERROR'};var getPartnersStix=function getPartnersStix(){return{type:'FETCH_PARTNERS_STIX',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/stores/mileage'}}};};var getMileageConfigurations=function getMileageConfigurations(catalogId,supplierId){return{type:'CONFIGURATION_STIX_PARTNERS',payload:{client:'mileageApi',request:{method:'get',url:'/mileage-api/v1/configurations/CampaignConfig?catalogId='+catalogId+'&supplierId='+supplierId}},supplierId:supplierId};};var convertPointsToMiles=function convertPointsToMiles(supplierId,points){return{type:'FETCH_POINTS_TO_MILES',payload:{client:'mileageApi',request:{method:'get',url:'/mileage-api/v1/calculators/pointsToMiles/'+supplierId+'/'+points}}};};var toggleSupplierId=function toggleSupplierId(supplierId){return{type:Types.TOGGLE_SUPPLIER_ID,supplierId:supplierId};};var changeRedemptionPoints=function changeRedemptionPoints(redemptionPoints){return{type:Types.CHANGE_REDEMPTION_POINTS,redemptionPoints:redemptionPoints};};var changeMinimumRedemptionLimit=function changeMinimumRedemptionLimit(minimumRedemptionLimit){return{type:Types.CHANGE_MINIMUM_REDEMPTION_LIMIT,minimumRedemptionLimit:minimumRedemptionLimit};};var changeMaximumRedemptionLimit=function changeMaximumRedemptionLimit(maximumRedemptionLimit){return{type:Types.CHANGE_MAXIMUM_REDEMPTION_LIMIT,maximumRedemptionLimit:maximumRedemptionLimit};};var closeErrorStix=function closeErrorStix(){return{type:Types.CLOSE_ERROR_STIX};};/* unused harmony default export */ var _unused_webpack_default_export = ({toggleSupplierId:toggleSupplierId,changeRedemptionPoints:changeRedemptionPoints,changeMinimumRedemptionLimit:changeMinimumRedemptionLimit,changeMaximumRedemptionLimit:changeMaximumRedemptionLimit,getPartnersStix:getPartnersStix,closeErrorStix:closeErrorStix});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuMobileContainer__ = __webpack_require__(1705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuMobileContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuMobilePublicContainer__ = __webpack_require__(1713);
/* unused harmony reexport MenuMobilePublicContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuHomeContainer__ = __webpack_require__(1714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuHomeContainer__["a"]; });


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BEAUTIFY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_PRODUCTION; });
/* unused harmony export REACT_MINOR_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUPPORTS_BEFORE_UPDATE_SNAPSHOT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// external dependencies


/**
 * @constant {Object} BEAUTIFY_OPTIONS the options to pass to cssbeautify
 */
var BEAUTIFY_OPTIONS = {
  autosemicolon: true,
  indent: '  '
};

/**
 * @constant {boolean} IS_PRODUCTION is the runtime in the production environment
 */
var IS_PRODUCTION = !!(process && Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}) && "production" === 'production');

/**
 * @constant {number} REACT_MINOR_VERSION the numeric major.minor version of React
 */
var REACT_MINOR_VERSION = +__WEBPACK_IMPORTED_MODULE_0_react___default.a.version.split('.').slice(0, 2).join('.');

/**
 * @constant {boolean} SUPPORTS_BEFORE_UPDATE_SNAPSHOT is getSnapshotBeforeUpdate supported by the React version
 */
var SUPPORTS_BEFORE_UPDATE_SNAPSHOT = !isNaN(REACT_MINOR_VERSION) && REACT_MINOR_VERSION >= 16.3;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_404_png__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_404_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_404_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_404_css__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_404_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_404_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
var FourOFour=function FourOFour(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-404 container-fluid bg-white pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'P\xE1gina n\xE3o encontrada - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Ops! P\xE1gina n\xE3o encontrada.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022 Verifique se voc\xEA digitou corretamente o endere\xE7o desejado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022 O conte\xFAdo pode ter sido removido ou n\xE3o estar mais dispon\xEDvel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022 O servidor pode estar fora do ar no momento.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ilustra_404 col-12 col-md-6 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mw-100 numero404 pendulum',src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_404_png___default.a,alt:'404 - P\xE1gina n\xE3o foi encontrada'})))));};/* harmony default export */ __webpack_exports__["a"] = (FourOFour);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Products; });
/* unused harmony default export */ var _unused_webpack_default_export = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{products:[]};var action=arguments[1];switch(action.type){case'FETCH_PRODUCT_RECOMENDATION':return Object.assign({},state);case'FETCH_PRODUCT_RECOMENDATION_SUCCESS':return Object.assign({},state,action.payload.data);case'FETCH_PRODUCT_RECOMENDATION_FAIL':return Object.assign({},state,{error:action.error});case'FETCH_RECOMENDATION_CARD_AVAILABILITY':return Object.assign({},state);case'FETCH_RECOMENDATION_CARD_AVAILABILITY_SUCCESS':var availability=action.payload.data[0];var products=state.products;var sku=action.meta.previousAction.sku;var index=products.findIndex(function(p){return p.sku===sku;});if(products[index]){products[index].availability=Object.assign({},availability);}products.forEach(function(item){item.availability['onlyCash']['sellingPrice']=120;});return Object.assign({},state,{products:products});case'FETCH_RECOMENDATION_CARD_AVAILABILITY_FAIL':return Object.assign({},state,{error_availability:action.error});default:return Object.assign({},state);}});var getRandomInt=function getRandomInt(min,max){min=Math.ceil(min);max=Math.floor(max);return Math.floor(Math.random()*(max-min+1))+min;};var Products=function Products(productSuggestion){var products=productSuggestion.products;products.forEach(function(item){if(item.availability){item.availability['onlyCash']={sellingPrice:getRandomInt(0,1200).toFixed(2)};}});var voucher={products:products||[],title:'Produtos recomendados',titleMobile:'Produtos'};return voucher;};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(643);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Events = {
    READY: "ready",
    RENDER: "render",
    SLOT_RENDER_ENDED: "slotRenderEnded",
    IMPRESSION_VIEWABLE: "impressionViewable",
    SLOT_VISIBILITY_CHANGED: "slotVisibilityChanged",
    SLOT_LOADED: "slotOnload"
};

exports.default = Events;

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShowcaseContainer__ = __webpack_require__(1791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__ShowcaseContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Showcase__ = __webpack_require__(649);
/* unused harmony reexport Showcase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShowcaseBenefits__ = __webpack_require__(1794);
/* unused harmony reexport ShowcaseBenefits */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilteredShowcase__ = __webpack_require__(1795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FilteredShowcase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoriesShowcase__ = __webpack_require__(1799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__CategoriesShowcase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BenefitsShowcase__ = __webpack_require__(1803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__BenefitsShowcase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BannersShowcase__ = __webpack_require__(1807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__BannersShowcase__["a"]; });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.arePathsEqual = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two path arrays of LatLng objects.
   */

  var arePathsEqual = exports.arePathsEqual = function arePathsEqual(pathA, pathB) {
    if (pathA === pathB) {
      return true;
    }
    if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
      return false;
    }
    if (pathA.length !== pathB.length) {
      return false;
    }
    for (var i = 0; i < pathA.length; ++i) {
      if (pathA[i] === pathB[i]) {
        continue;
      }
      if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) {
        return false;
      }
      if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) {
        return false;
      }
    }
    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var isValidLatLng = function isValidLatLng(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('lat') && elem.hasOwnProperty('lng');
  };
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardStore=function(_Component){_inherits(CardStore,_Component);function CardStore(){_classCallCheck(this,CardStore);return _possibleConstructorReturn(this,(CardStore.__proto__||Object.getPrototypeOf(CardStore)).apply(this,arguments));}_createClass(CardStore,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/comunidade-iupp/company/'+this.props.chain.id+'/store/'+this.props.id,tabIndex:0,className:'card card-bairro mt-2',title:'Vai para '+this.props.chain.name},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'bordered radius border-color-ui-3 bg-white d-flex-mob'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'figure-mBairo d-flex justify-content-center mt-2 mb-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default.a,{src:this.props.urlThumbnail,fallbackImage:__WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_0__loyal_images_products_product_placeholder_png___default.a,alt:this.props.chain.name,className:'mx-auto'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'div-mob h-auto'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col-12 mt-0 px-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'txt-body w-100 color-ui-black txt-font-body mb-1 text-bfits-list'},this.props.chain.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'text-style-benific lineH29'},this.props.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',{className:'text-benific-pq'},this.props.quantityOffers>0?this.props.quantityOffers+' ofertas':'Nenhum oferta'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',{className:'text-benific-pq colorBairro'},this.props.location?(this.props.place.location.distance/1000).toFixed(1)+' km - '+this.props.place.address.city:'',' ')))));}}]);return CardStore;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);CardStore.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,chain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,quantityOffers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,urlThumbnail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,place:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({distance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({city:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,uf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})}),location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (CardStore);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Filters__ = __webpack_require__(1884);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Filters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectedFilters__ = __webpack_require__(1885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SelectedFilters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectedFiltersList__ = __webpack_require__(1886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__SelectedFiltersList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectedFiltersText__ = __webpack_require__(1887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__SelectedFiltersText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterItems__ = __webpack_require__(1888);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__FilterItems__["a"]; });


/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseSearch=function(_Component){_inherits(BaseSearch,_Component);function BaseSearch(props){_classCallCheck(this,BaseSearch);var _this=_possibleConstructorReturn(this,(BaseSearch.__proto__||Object.getPrototypeOf(BaseSearch)).call(this,props));_this.pageIndexInfinity=0;_this.metaApplied=false;_this.handleFilter=function(){_this.setState({condition:!_this.state.condition});};_this.loadItems=function(){if(!_this.props.isLoading){var _this$props$filterSel=_this.props.filterSelected,term=_this$props$filterSel.term,identifier=_this$props$filterSel.identifier,type=_this$props$filterSel.type,brand=_this$props$filterSel.brand,category=_this$props$filterSel.category,subcategory=_this$props$filterSel.subcategory,vendor=_this$props$filterSel.vendor,vendortype=_this$props$filterSel.vendortype,feature=_this$props$filterSel.feature,minprice=_this$props$filterSel.minprice,maxprice=_this$props$filterSel.maxprice,sort=_this$props$filterSel.sort;_this.props.fetchResultSearch(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,_this.pageIndexInfinity++);}};_this.handleSelectOrdinationFilterChanged=function(selectedOrdenation){var mustFetch=true;var filterType='sort';var _this$props$filterSel2=_this.props.filterSelected,term=_this$props$filterSel2.term,identifier=_this$props$filterSel2.identifier,type=_this$props$filterSel2.type,brand=_this$props$filterSel2.brand,category=_this$props$filterSel2.category,subcategory=_this$props$filterSel2.subcategory,vendor=_this$props$filterSel2.vendor,vendortype=_this$props$filterSel2.vendortype,feature=_this$props$filterSel2.feature,minprice=_this$props$filterSel2.minprice,maxprice=_this$props$filterSel2.maxprice,sort=_this$props$filterSel2.sort;sort=_this.setFilterValue(sort,selectedOrdenation,filterType);_this.handleOrdination(sort);var mustChangeUrl=true;_this.setFilter(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,mustChangeUrl,mustFetch,filterType);};_this.handleFilterRemove=function(filterType,filterValue){var filterAction='remove';if(filterType==='minprice'||filterType==='maxprice'){filterAction='update';}var mustFetch=true;var _this$props$filterSel3=_this.props.filterSelected,term=_this$props$filterSel3.term,identifier=_this$props$filterSel3.identifier,type=_this$props$filterSel3.type,brand=_this$props$filterSel3.brand,category=_this$props$filterSel3.category,subcategory=_this$props$filterSel3.subcategory,vendor=_this$props$filterSel3.vendor,vendortype=_this$props$filterSel3.vendortype,feature=_this$props$filterSel3.feature,minprice=_this$props$filterSel3.minprice,maxprice=_this$props$filterSel3.maxprice,sort=_this$props$filterSel3.sort;switch(filterType){case'category':{category=_this.setFilterValue(category,filterValue,filterAction);break;}case'subcategory':{subcategory=_this.setFilterValue(subcategory,filterValue,filterAction);break;}case'brand':{brand=_this.setFilterValue(brand,filterValue,filterAction);break;}case'vendor':{vendor=_this.setFilterValue(vendor,filterValue,filterAction);break;}case'vendorType':{vendortype=_this.setFilterValue(vendortype,filterValue,filterAction);break;}case'feature':{feature=_this.setFilterValue(feature,filterValue,filterAction);break;}case'minprice':{minprice=_this.setFilterValue(minprice,filterValue,filterAction);break;}case'maxprice':{maxprice=_this.setFilterValue(maxprice,filterValue,filterAction);break;}case'price':{minprice=_this.setFilterValue(minprice,filterValue.target.getAttribute('minprice'),filterAction);maxprice=_this.setFilterValue(maxprice,filterValue.target.getAttribute('maxprice'),filterAction);break;}case'sort':{sort=_this.setFilterValue(sort,filterValue,filterAction);_this.handleOrdination(sort);break;}case'term':{term=_this.setFilterValue(term,filterValue,filterAction);break;}case'identifier':{identifier=_this.setFilterValue(identifier,filterValue,filterAction);break;}case'type':{type=_this.setFilterValue(type,filterValue,filterAction);break;}}var mustChangeUrl=true;_this.setFilter(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,mustChangeUrl,mustFetch,filterType);};_this.handleFilterChanged=function(filterType){var mustFetch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(e){var filterValue=void 0;var filterAction='update';var tagType=e.target?String(e.target.type):'';switch(tagType){case'checkbox':{filterValue=e.target.value;filterAction=e.target.checked?'add':'remove';break;}case'text':{filterValue=e.target.value;break;}default:{if(e.target){filterAction=e.target.getAttribute('action');filterValue=e.target.getAttribute('value');}break;}}filterAction=filterAction||'update';filterValue=filterValue||e;var _this$props$filterSel4=_this.props.filterSelected,term=_this$props$filterSel4.term,identifier=_this$props$filterSel4.identifier,type=_this$props$filterSel4.type,brand=_this$props$filterSel4.brand,category=_this$props$filterSel4.category,subcategory=_this$props$filterSel4.subcategory,vendor=_this$props$filterSel4.vendor,vendortype=_this$props$filterSel4.vendortype,feature=_this$props$filterSel4.feature,minprice=_this$props$filterSel4.minprice,maxprice=_this$props$filterSel4.maxprice,sort=_this$props$filterSel4.sort;switch(filterType){case'category':{category=_this.setFilterValue(category,filterValue,filterAction);break;}case'subcategory':{subcategory=_this.setFilterValue(subcategory,filterValue,filterAction);break;}case'brand':{brand=_this.setFilterValue(brand,filterValue,filterAction);break;}case'vendor':{vendor=_this.setFilterValue(vendor,filterValue,filterAction);break;}case'vendorType':{vendortype=_this.setFilterValue(vendortype,filterValue,filterAction);break;}case'feature':{feature=_this.setFilterValue(feature,filterValue,filterAction);break;}case'minprice':{minprice=_this.setFilterValue(minprice,filterValue,filterAction);break;}case'maxprice':{maxprice=_this.setFilterValue(maxprice,filterValue,filterAction);break;}case'price':{minprice=_this.setFilterValue(minprice,filterValue.target.getAttribute('minprice'),filterAction);maxprice=_this.setFilterValue(maxprice,filterValue.target.getAttribute('maxprice'),filterAction);break;}case'sort':{sort=_this.setFilterValue(sort,filterValue,filterAction);_this.handleOrdination(sort);break;}case'term':{term=_this.setFilterValue(term,filterValue,filterAction);break;}case'identifier':{identifier=_this.setFilterValue(identifier,filterValue,filterAction);break;}case'type':{type=_this.setFilterValue(type,filterValue,filterAction);break;}}var mustChangeUrl=true;_this.setFilter(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,mustChangeUrl,mustFetch,filterType);};};_this.handleFilterClean=function(pageType){return function(e){var mustChangeUrl=true;var mustFetch=true;var filterType='subcategory';var _this$props$filterSel5=_this.props.filterSelected,term=_this$props$filterSel5.term,identifier=_this$props$filterSel5.identifier,type=_this$props$filterSel5.type,brand=_this$props$filterSel5.brand,category=_this$props$filterSel5.category,subcategory=_this$props$filterSel5.subcategory,vendor=_this$props$filterSel5.vendor,vendortype=_this$props$filterSel5.vendortype,feature=_this$props$filterSel5.feature,minprice=_this$props$filterSel5.minprice,maxprice=_this$props$filterSel5.maxprice,sort=_this$props$filterSel5.sort;if(pageType!=='vendor'){vendor=[];}brand=[];category=[];subcategory=[];vendortype=[];feature=[];minprice=0;maxprice=0;sort=undefined;_this.setFilter(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,mustChangeUrl,mustFetch,filterType);_this.setState({ordination:{RELEVANCE:false,NEWRELEASES:false,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:false,SCORE:false,checked:false}});};};_this.setFilter=function(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,mustChangeUrl,mustFetch,filterType){var filterSelected={term:term,identifier:identifier,type:type,brand:brand,category:category,subcategory:subcategory,vendor:vendor,vendortype:vendortype,feature:feature,minprice:minprice,maxprice:maxprice,sort:sort};_this.props.setFilterChanged(filterType,filterSelected);if(mustChangeUrl){_this.setQueryString(filterSelected);}if(mustFetch){_this.props.clearSearch();_this.pageIndexInfinity=0;_this.props.fetchResultSearch(term,identifier,type,brand,category,subcategory,vendor,vendortype,feature,minprice,maxprice,sort,_this.pageIndexInfinity++);}};_this.setQueryString=function(filterSelected){var filterQueryString='';Object.keys(filterSelected).map(function(key){var filterQS=filterSelected[key];if(filterQS!==undefined&&filterQS.toString()!==''){filterQueryString+=(filterQueryString?'&':'')+key+'='+filterQS.toString();}});var urlChanged=window.location.protocol+'//'+window.location.host+window.location.pathname+'?'+filterQueryString;window.history.pushState({path:urlChanged},'',urlChanged);};_this.setFilterByQueryString=function(){var _queryString$parse=__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(_this.props.filtersName),term=_queryString$parse.term,identifier=_queryString$parse.identifier,type=_queryString$parse.type,brand=_queryString$parse.brand,category=_queryString$parse.category,subcategory=_queryString$parse.subcategory,vendor=_queryString$parse.vendor,vendortypes=_queryString$parse.vendortypes,feature=_queryString$parse.feature,minprice=_queryString$parse.minprice,maxprice=_queryString$parse.maxprice,sort=_queryString$parse.sort;brand=_this.setFilterValue(null,brand,'add');category=_this.setFilterValue(null,category,'add');subcategory=_this.setFilterValue(null,subcategory,'add');vendor=_this.setFilterValue(null,vendor,'add');vendortypes=_this.setFilterValue(null,vendortypes,'add');feature=_this.setFilterValue(null,feature,'add');minprice=_this.setFilterValue(null,minprice||_this.props.filterSelected.minprice,'update');maxprice=_this.setFilterValue(null,maxprice||_this.props.filterSelected.maxprice,'update');var mustFetch=true;var mustChangeUrl=false;var filterType='querystring';_this.setFilter(term,identifier,type,brand,category,subcategory,vendor,vendortypes,feature,minprice,maxprice,sort,mustChangeUrl,mustFetch,filterType);};_this.setFilterValue=function(sideBarFilter,valueFilter,action){sideBarFilter=sideBarFilter||[];if(valueFilter===undefined){return sideBarFilter;}if(!Array.isArray(valueFilter)){valueFilter=isNaN(valueFilter)?valueFilter.split(','):[valueFilter];}valueFilter.map(function(valueItem){if(valueItem!==undefined&&valueItem!==null){switch(action){case'add':{sideBarFilter.push(String(valueItem));break;}case'remove':{sideBarFilter=sideBarFilter.filter(function(value){return value!==String(valueItem);});break;}default:{sideBarFilter=isNaN(valueItem)?valueItem.length>0?String(valueItem):null:valueItem;}}}});return sideBarFilter;};_this.state={ordination:{RELEVANCE:false,NEWRELEASES:false,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:false,SCORE:true,checked:false},condition:false};return _this;}_createClass(BaseSearch,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.filtersName!==this.props.filtersName){this.setFilterByQueryString();}if(this.props.showcase&&this.props.showcase.description&&!this.metaApplied){this.props.setMeta(this.props.showcase.description);this.metaApplied=true;}}},{key:'componentDidMount',value:function componentDidMount(){this.setFilterByQueryString();}},{key:'handleOrdination',value:function handleOrdination(type){switch(type){case'RELEVANCE':this.setState({ordination:{RELEVANCE:true,NEWRELEASES:false,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:false,SCORE:false,checked:true}});break;case'NEWRELEASES':this.setState({ordination:{RELEVANCE:false,NEWRELEASES:true,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:false,SCORE:false,checked:true}});break;case'PRICELOWERTOHIGHER':this.setState({ordination:{RELEVANCE:false,NEWRELEASES:false,PRICELOWERTOHIGHER:true,PRICEHIGHERTOLOWER:false,SCORE:false,checked:true}});break;case'PRICEHIGHERTOLOWER':this.setState({ordination:{RELEVANCE:false,NEWRELEASES:false,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:true,SCORE:false,checked:true}});break;case'SCORE':this.setState({ordination:{RELEVANCE:false,NEWRELEASES:false,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:false,SCORE:true,checked:true}});break;default:this.setState({ordination:{RELEVANCE:false,NEWRELEASES:false,PRICELOWERTOHIGHER:false,PRICEHIGHERTOLOWER:false,SCORE:false,checked:false}});break;}}}]);return BaseSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BaseSearch.propTypes={fetchResultSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filterSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,clearSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setFilterChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,filtersName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,setMeta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,showcase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (BaseSearch);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(16).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(63);
var LIBRARY = __webpack_require__(89);
var wksExt = __webpack_require__(675);
var defineProperty = __webpack_require__(32).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(168)('keys');
var uid = __webpack_require__(106);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(16).document;
module.exports = document && document.documentElement;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(10);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(64)(Function.call, __webpack_require__(58).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(335).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(66);
var defined = __webpack_require__(73);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 339 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 340 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(89);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(50);
var hide = __webpack_require__(49);
var Iterators = __webpack_require__(136);
var $iterCreate = __webpack_require__(342);
var setToStringTag = __webpack_require__(133);
var getPrototypeOf = __webpack_require__(59);
var ITERATOR = __webpack_require__(26)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(109);
var descriptor = __webpack_require__(105);
var setToStringTag = __webpack_require__(133);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(49)(IteratorPrototype, __webpack_require__(26)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(223);
var defined = __webpack_require__(73);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(26)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(136);
var ITERATOR = __webpack_require__(26)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(32);
var createDesc = __webpack_require__(105);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(134);
var ITERATOR = __webpack_require__(26)('iterator');
var Iterators = __webpack_require__(136);
module.exports = __webpack_require__(63).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(2171);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(108);
var toLength = __webpack_require__(28);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(91);
var step = __webpack_require__(692);
var Iterators = __webpack_require__(136);
var toIObject = __webpack_require__(57);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(341)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(171);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(222)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(64);
var invoke = __webpack_require__(682);
var html = __webpack_require__(334);
var cel = __webpack_require__(330);
var global = __webpack_require__(16);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(65)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var macrotask = __webpack_require__(353).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(65)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(40);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(29);
var LIBRARY = __webpack_require__(89);
var $typed = __webpack_require__(229);
var hide = __webpack_require__(49);
var redefineAll = __webpack_require__(114);
var fails = __webpack_require__(19);
var anInstance = __webpack_require__(112);
var toInteger = __webpack_require__(66);
var toLength = __webpack_require__(28);
var toIndex = __webpack_require__(702);
var gOPN = __webpack_require__(110).f;
var dP = __webpack_require__(32).f;
var arrayFill = __webpack_require__(349);
var setToStringTag = __webpack_require__(133);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(732);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(715);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(360);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

"use strict";

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(364);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(235);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(178);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createMemoryHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(237);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["locationsAreEqual"])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(750)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(178);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(179);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["createLocation"])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(238);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelmetProvider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Provider = __webpack_require__(376);

Object.defineProperty(exports, 'HelmetProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Provider).default;
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFastCompare = __webpack_require__(378);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _invariant = __webpack_require__(60);

var _invariant2 = _interopRequireDefault(_invariant);

var _Dispatcher = __webpack_require__(769);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _constants = __webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */

var Helmet = function (_Component) {
  _inherits(Helmet, _Component);

  function Helmet() {
    _classCallCheck(this, Helmet);

    return _possibleConstructorReturn(this, (Helmet.__proto__ || Object.getPrototypeOf(Helmet)).apply(this, arguments));
  }

  _createClass(Helmet, [{
    key: 'shouldComponentUpdate',

    /**
     * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
     * @param {Object} bodyAttributes: {"className": "root"}
     * @param {String} defaultTitle: "Default Title"
     * @param {Boolean} defer: true
     * @param {Boolean} encodeSpecialCharacters: true
     * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
     * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
     * @param {Array} meta: [{"name": "description", "content": "Test description"}]
     * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
     * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
     * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
     * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
     * @param {String} title: "Title"
     * @param {Object} titleAttributes: {"itemprop": "name"}
     * @param {String} titleTemplate: "MySite.com - %s"
     */
    /* eslint-disable react/prop-types, react/forbid-prop-types, react/require-default-props */
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _reactFastCompare2.default)(this.props, nextProps);
    }
    /* eslint-enable react/prop-types, react/forbid-prop-types, react/require-default-props */

  }, {
    key: 'mapNestedChildrenToProps',
    value: function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }

      switch (child.type) {
        case _constants.TAG_NAMES.SCRIPT:
        case _constants.TAG_NAMES.NOSCRIPT:
          return {
            innerHTML: nestedChildren
          };

        case _constants.TAG_NAMES.STYLE:
          return {
            cssText: nestedChildren
          };
        default:
          throw new Error('<' + child.type + ' /> elements are self-closing and can not contain children. Refer to our API for more information.');
      }
    }
  }, {
    key: 'flattenArrayTypeChildren',
    value: function flattenArrayTypeChildren(_ref) {
      var child = _ref.child,
          arrayTypeChildren = _ref.arrayTypeChildren,
          newChildProps = _ref.newChildProps,
          nestedChildren = _ref.nestedChildren;

      return _extends({}, arrayTypeChildren, _defineProperty({}, child.type, [].concat(_toConsumableArray(arrayTypeChildren[child.type] || []), [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))])));
    }
  }, {
    key: 'mapObjectTypeChildren',
    value: function mapObjectTypeChildren(_ref2) {
      var _extends3;

      var child = _ref2.child,
          newProps = _ref2.newProps,
          newChildProps = _ref2.newChildProps,
          nestedChildren = _ref2.nestedChildren;

      switch (child.type) {
        case _constants.TAG_NAMES.TITLE:
          return _extends({}, newProps, (_extends3 = {}, _defineProperty(_extends3, child.type, nestedChildren), _defineProperty(_extends3, 'titleAttributes', _extends({}, newChildProps)), _extends3));

        case _constants.TAG_NAMES.BODY:
          return _extends({}, newProps, {
            bodyAttributes: _extends({}, newChildProps)
          });

        case _constants.TAG_NAMES.HTML:
          return _extends({}, newProps, {
            htmlAttributes: _extends({}, newChildProps)
          });
        default:
          return _extends({}, newProps, _defineProperty({}, child.type, _extends({}, newChildProps)));
      }
    }
  }, {
    key: 'mapArrayTypeChildrenToProps',
    value: function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _extends({}, newProps);

      Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
        newFlattenedProps = _extends({}, newFlattenedProps, _defineProperty({}, arrayChildName, arrayTypeChildren[arrayChildName]));
      });

      return newFlattenedProps;
    }
  }, {
    key: 'warnOnInvalidChildren',
    value: function warnOnInvalidChildren(child, nestedChildren) {
      (0, _invariant2.default)(_constants.VALID_TAG_NAMES.some(function (name) {
        return child.type === name;
      }), typeof child.type === 'function' ? 'You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.' : 'Only elements types ' + _constants.VALID_TAG_NAMES.join(', ') + ' are allowed. Helmet does not support rendering <' + child.type + '> elements. Refer to our API for more information.');

      (0, _invariant2.default)(!nestedChildren || typeof nestedChildren === 'string' || Array.isArray(nestedChildren) && !nestedChildren.some(function (nestedChild) {
        return typeof nestedChild !== 'string';
      }), 'Helmet expects a string as a child of <' + child.type + '>. Did you forget to wrap your children in braces? ( <' + child.type + '>{``}</' + child.type + '> ) Refer to our API for more information.');

      return true;
    }
  }, {
    key: 'mapChildrenToProps',
    value: function mapChildrenToProps(children, newProps) {
      var _this2 = this;

      var arrayTypeChildren = {};

      _react2.default.Children.forEach(children, function (child) {
        if (!child || !child.props) {
          return;
        }

        var _child$props = child.props,
            nestedChildren = _child$props.children,
            childProps = _objectWithoutProperties(_child$props, ['children']);
        // convert React props to HTML attributes


        var newChildProps = Object.keys(childProps).reduce(function (obj, key) {
          obj[_constants.HTML_TAG_MAP[key] || key] = childProps[key];
          return obj;
        }, {});

        var type = child.type;

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol') {
          type = type.toString();
        } else {
          _this2.warnOnInvalidChildren(child, nestedChildren);
        }

        switch (type) {
          case _constants.TAG_NAMES.FRAGMENT:
            newProps = _this2.mapChildrenToProps(nestedChildren, newProps);
            break;

          case _constants.TAG_NAMES.LINK:
          case _constants.TAG_NAMES.META:
          case _constants.TAG_NAMES.NOSCRIPT:
          case _constants.TAG_NAMES.SCRIPT:
          case _constants.TAG_NAMES.STYLE:
            arrayTypeChildren = _this2.flattenArrayTypeChildren({
              child: child,
              arrayTypeChildren: arrayTypeChildren,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;

          default:
            newProps = _this2.mapObjectTypeChildren({
              child: child,
              newProps: newProps,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;
        }
      });

      return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      var newProps = _extends({}, props);

      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }

      return _react2.default.createElement(
        _Provider.Context.Consumer,
        null,
        function (context) {
          return _react2.default.createElement(_Dispatcher2.default, _extends({}, newProps, { context: context }));
        }
      );
    }
  }]);

  return Helmet;
}(_react.Component);

Helmet.propTypes = {
  base: _propTypes2.default.object,
  bodyAttributes: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  defaultTitle: _propTypes2.default.string,
  defer: _propTypes2.default.bool,
  encodeSpecialCharacters: _propTypes2.default.bool,
  htmlAttributes: _propTypes2.default.object,
  link: _propTypes2.default.arrayOf(_propTypes2.default.object),
  meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
  noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onChangeClientState: _propTypes2.default.func,
  script: _propTypes2.default.arrayOf(_propTypes2.default.object),
  style: _propTypes2.default.arrayOf(_propTypes2.default.object),
  title: _propTypes2.default.string,
  titleAttributes: _propTypes2.default.object,
  titleTemplate: _propTypes2.default.string
};
Helmet.defaultProps = {
  defer: true,
  encodeSpecialCharacters: true
};
exports.default = Helmet;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerShape = exports.Context = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _server = __webpack_require__(377);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var defaultValue = {};

var Context = exports.Context = _react2.default.createContext(defaultValue);

var providerShape = exports.providerShape = _propTypes2.default.shape({
  setHelmet: _propTypes2.default.func,
  helmetInstances: _propTypes2.default.shape({
    get: _propTypes2.default.func,
    add: _propTypes2.default.func,
    remove: _propTypes2.default.func
  })
});

var canUseDOM = typeof document !== 'undefined';

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props));

    _this.instances = [];
    _this.value = {
      setHelmet: function setHelmet(serverState) {
        _this.props.context.helmet = serverState;
      },
      helmetInstances: {
        get: function get() {
          return _this.instances;
        },
        add: function add(instance) {
          _this.instances.push(instance);
        },
        remove: function remove(instance) {
          var index = _this.instances.indexOf(instance);
          _this.instances.splice(index, 1);
        }
      }
    };


    if (!Provider.canUseDOM) {
      props.context.helmet = (0, _server2.default)({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: true,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: '',
        titleAttributes: {}
      });
    }
    return _this;
  }

  _createClass(Provider, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Context.Provider,
        { value: this.value },
        this.props.children
      );
    }
  }]);

  return Provider;
}(_react.Component);

Provider.canUseDOM = canUseDOM;
Provider.propTypes = {
  context: _propTypes2.default.shape({}),
  children: _propTypes2.default.node.isRequired
};
Provider.defaultProps = {
  context: {}
};
exports.default = Provider;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(180);

var _utils = __webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SELF_CLOSING_TAGS = [_constants.TAG_NAMES.NOSCRIPT, _constants.TAG_NAMES.SCRIPT, _constants.TAG_NAMES.STYLE];

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (encode === false) {
    return String(str);
  }

  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
  return Object.keys(attributes).reduce(function (str, key) {
    var attr = typeof attributes[key] !== 'undefined' ? key + '="' + attributes[key] + '"' : '' + key;
    return str ? str + ' ' + attr : attr;
  }, '');
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = (0, _utils.flattenArray)(title);
  return attributeString ? '<' + type + ' ' + _constants.HELMET_ATTRIBUTE + '="true" ' + attributeString + '>' + encodeSpecialCharacters(flattenedTitle, encode) + '</' + type + '>' : '<' + type + ' ' + _constants.HELMET_ATTRIBUTE + '="true">' + encodeSpecialCharacters(flattenedTitle, encode) + '</' + type + '>';
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
  return tags.reduce(function (str, tag) {
    var attributeHtml = Object.keys(tag).filter(function (attribute) {
      return !(attribute === _constants.TAG_PROPERTIES.INNER_HTML || attribute === _constants.TAG_PROPERTIES.CSS_TEXT);
    }).reduce(function (string, attribute) {
      var attr = typeof tag[attribute] === 'undefined' ? attribute : attribute + '="' + encodeSpecialCharacters(tag[attribute], encode) + '"';
      return string ? string + ' ' + attr : attr;
    }, '');

    var tagContent = tag.innerHTML || tag.cssText || '';

    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

    return str + '<' + type + ' ' + _constants.HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? '/>' : '>' + tagContent + '</' + type + '>');
  }, '');
};

var convertElementAttributesToReactProps = function convertElementAttributesToReactProps(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(attributes).reduce(function (obj, key) {
    obj[_constants.REACT_TAG_MAP[key] || key] = attributes[key];
    return obj;
  }, initProps);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
  // assigning into an array to define toString function on it
  var initProps = _defineProperty({
    key: title
  }, _constants.HELMET_ATTRIBUTE, true);
  var props = convertElementAttributesToReactProps(attributes, initProps);

  return [_react2.default.createElement(_constants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
  return tags.map(function (tag, i) {
    var mappedTag = _defineProperty({
      key: i
    }, _constants.HELMET_ATTRIBUTE, true);

    Object.keys(tag).forEach(function (attribute) {
      var mappedAttribute = _constants.REACT_TAG_MAP[attribute] || attribute;

      if (mappedAttribute === _constants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _constants.TAG_PROPERTIES.CSS_TEXT) {
        var content = tag.innerHTML || tag.cssText;
        mappedTag.dangerouslySetInnerHTML = { __html: content };
      } else {
        mappedTag[mappedAttribute] = tag[attribute];
      }
    });

    return _react2.default.createElement(type, mappedTag);
  });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
  switch (type) {
    case _constants.TAG_NAMES.TITLE:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
        },
        toString: function toString() {
          return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
        }
      };
    case _constants.ATTRIBUTE_NAMES.BODY:
    case _constants.ATTRIBUTE_NAMES.HTML:
      return {
        toComponent: function toComponent() {
          return convertElementAttributesToReactProps(tags);
        },
        toString: function toString() {
          return generateElementAttributesAsString(tags);
        }
      };
    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type, tags);
        },
        toString: function toString() {
          return generateTagsAsString(type, tags, encode);
        }
      };
  }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
  var baseTag = _ref.baseTag,
      bodyAttributes = _ref.bodyAttributes,
      encode = _ref.encode,
      htmlAttributes = _ref.htmlAttributes,
      linkTags = _ref.linkTags,
      metaTags = _ref.metaTags,
      noscriptTags = _ref.noscriptTags,
      scriptTags = _ref.scriptTags,
      styleTags = _ref.styleTags,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      titleAttributes = _ref.titleAttributes;
  return {
    base: getMethodsForTag(_constants.TAG_NAMES.BASE, baseTag, encode),
    bodyAttributes: getMethodsForTag(_constants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag(_constants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
    link: getMethodsForTag(_constants.TAG_NAMES.LINK, linkTags, encode),
    meta: getMethodsForTag(_constants.TAG_NAMES.META, metaTags, encode),
    noscript: getMethodsForTag(_constants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
    script: getMethodsForTag(_constants.TAG_NAMES.SCRIPT, scriptTags, encode),
    style: getMethodsForTag(_constants.TAG_NAMES.STYLE, styleTags, encode),
    title: getMethodsForTag(_constants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
  };
};

exports.default = mapStateOnServer;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Splash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userManager__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_last_location__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_last_location__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var routeLastLocation=function routeLastLocation(lastLocation){var _ref=lastLocation||{},_ref$pathname=_ref.pathname,pathname=_ref$pathname===undefined?Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_REDIRECT_ONLY_CASH?'/redirect/cash':'/':_ref$pathname,_ref$search=_ref.search,search=_ref$search===undefined?'':_ref$search;var table=_defineProperty({},pathname,pathname);return table[pathname].concat(search);};var Login=function(_Component){_inherits(Login,_Component);function Login(){_classCallCheck(this,Login);return _possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).apply(this,arguments));}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){var lastLocation=this.props.lastLocation;var lastLocationUri=routeLastLocation(lastLocation);var localStorage=typeof window!=='undefined'&&window?window.localStorage:null;if(localStorage){var localStoraLocation=localStorage.getItem('lastLocationUri');if(!localStoraLocation){localStorage.setItem('lastLocationUri',lastLocationUri);}}__WEBPACK_IMPORTED_MODULE_3__userManager__["a" /* default */].signinRedirect({state:lastLocationUri});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Splash__["a" /* default */],{text:'Redirecionando para o login'});}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Login.propTypes={lastLocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_last_location__["withLastLocation"])(Login));

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_oidc_client__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CognitoMetadataService=function(_MetadataService){_inherits(CognitoMetadataService,_MetadataService);function CognitoMetadataService(){_classCallCheck(this,CognitoMetadataService);return _possibleConstructorReturn(this,(CognitoMetadataService.__proto__||Object.getPrototypeOf(CognitoMetadataService)).apply(this,arguments));}_createClass(CognitoMetadataService,[{key:'getEndSessionEndpoint',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var endSessionEndpoint,logoutUri;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:endSessionEndpoint=new URL("https://auth.tupperwarepremios.premmiar.io");if(!Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_LOGOUT_URI){_context.next=7;break;}_context.t0=URL;_context.next=5;return this.getTokenEndpoint();case 5:_context.t1=_context.sent;endSessionEndpoint=new _context.t0(_context.t1);case 7:endSessionEndpoint.pathname='logout';endSessionEndpoint.searchParams.set('client_id',"1tbhh14ofdn4d5oof5dm32nmen");logoutUri=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_LOGOUT_URI||window.location.protocol+'//'+window.location.hostname+(window.location.port?':'+window.location.port:'');endSessionEndpoint.searchParams.set('logout_uri',logoutUri);return _context.abrupt('return',endSessionEndpoint.href);case 12:case'end':return _context.stop();}}},_callee,this);}));function getEndSessionEndpoint(){return _ref.apply(this,arguments);}return getEndSessionEndpoint;}()}]);return CognitoMetadataService;}(__WEBPACK_IMPORTED_MODULE_1_oidc_client__["MetadataService"]);var CognitoUserManager=function(_UserManager){_inherits(CognitoUserManager,_UserManager);function CognitoUserManager(){_classCallCheck(this,CognitoUserManager);return _possibleConstructorReturn(this,(CognitoUserManager.__proto__||Object.getPrototypeOf(CognitoUserManager)).apply(this,arguments));}_createClass(CognitoUserManager,[{key:'_signinStart',value:function _signinStart(args,navigator){var _this3=this;var navigatorParams=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};__WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug('_signinStart for Cognito');return navigator.prepare(navigatorParams).then(function(handle){__WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug('got navigator window handle');return _this3.createSigninRequest(args).then(function(signinRequest){__WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug('got signin request');navigatorParams.url=signinRequest.url.replace('%20id_token','');navigatorParams.id=signinRequest.state.id;return handle.navigate(navigatorParams);}).catch(function(err){if(handle.close){__WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug('Error after preparing navigator, closing navigator window');handle.close();}throw err;});});}},{key:'signinWithRefreshToken',value:function signinWithRefreshToken(refreshToken){var _this4=this;return this._tokenClient.exchangeRefreshToken({refresh_token:refreshToken}).then(function(user){var newUser=new __WEBPACK_IMPORTED_MODULE_1_oidc_client__["User"](_this4._manageClaims(user,refreshToken));return _this4.storeUser(newUser);});}},{key:'_manageClaims',value:function _manageClaims(user,refreshToken){var jwt=this._joseUtil.parseJwt(user.id_token).payload;user.scope=this.settings.scope;user.expires_at=jwt.exp;user.refresh_token=refreshToken;user.profile=jwt;user.profile.username=jwt['cognito:username'];delete user.profile.at_hash;delete user.profile.aud;delete user.profile.exp;delete user.profile.iat;delete user.profile.iss;return user;}}]);return CognitoUserManager;}(__WEBPACK_IMPORTED_MODULE_1_oidc_client__["UserManager"]);var createUserManager=function createUserManager(settings){var userManager=new CognitoUserManager(Object.assign({},settings,{clockSkew:4500,MetadataServiceCtor:CognitoMetadataService}));userManager.events.addSilentRenewError(function(e){__WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug('addSilentRenewError',e);setTimeout(function(){userManager.getUser();},2000);});userManager.events.addAccessTokenExpired(function(){__WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug('addAccessTokenExpired');if(userManager.settings.automaticSilentRenew){userManager.signinSilent().catch(function(error){return __WEBPACK_IMPORTED_MODULE_1_oidc_client__["Log"].debug(error);});}});return userManager;};/* harmony default export */ __webpack_exports__["a"] = (createUserManager);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createRedirectUri=function createRedirectUri(){var callbackPath=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'/auth/callback';return window.location.protocol+'//'+window.location.hostname+(window.location.port?':'+window.location.port:'')+callbackPath;};/* harmony default export */ __webpack_exports__["a"] = (createRedirectUri);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userManager__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Splash__ = __webpack_require__(92);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Logout=function(_Component){_inherits(Logout,_Component);function Logout(){_classCallCheck(this,Logout);return _possibleConstructorReturn(this,(Logout.__proto__||Object.getPrototypeOf(Logout)).apply(this,arguments));}_createClass(Logout,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1__userManager__["a" /* default */].signoutRedirect();__WEBPACK_IMPORTED_MODULE_1__userManager__["a" /* default */].removeUser();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Splash__["a" /* default */],{text:'Carregando...'});}}]);return Logout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Logout);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Splash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userManager__ = __webpack_require__(138);
var isEmpty=function isEmpty(val){return val===undefined||val==null||val.length<=0;};var goToError=function goToError(history){__WEBPACK_IMPORTED_MODULE_3__userManager__["a" /* default */].removeUser().then(function(){return history.push('/404');});};var Session=function Session(_ref){var history=_ref.history,hash=_ref.location.hash;var refreshToken=hash.replace('#/','');if(isEmpty(refreshToken)){goToError(history);}else{__WEBPACK_IMPORTED_MODULE_3__userManager__["a" /* default */].signinWithRefreshToken(refreshToken).then(function(user){return history.push('/');}).catch(function(){return goToError(history);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Splash__["a" /* default */],{text:'Realizando o login...'});};Session.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({hash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (Session);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_oidc__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_oidc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_oidc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userManager__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App_Splash__ = __webpack_require__(92);
var Callback=function Callback(_ref){var history=_ref.history,profile=_ref.profile,redirectToLastLocation=_ref.redirectToLastLocation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_oidc__["CallbackComponent"],{userManager:__WEBPACK_IMPORTED_MODULE_5__userManager__["a" /* default */],successCallback:redirectToLastLocation,errorCallback:function errorCallback(error){console.error(error);if(error.message==='No matching state found in storage'){history.goBack();}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_App_Splash__["a" /* default */],{text:'Estamos carregando a sua experi\xEAncia.'}));};Callback.propTypes={profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,redirectToLastLocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref2){var oidc=_ref2.oidc;return{profile:oidc.user&&oidc.user.profile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectToLastLocation:function redirectToLastLocation(user){var localStorage=typeof window!=='undefined'&&window?window.localStorage:null;var redirectUri=user.state;var lastLocationUri='';if(localStorage){lastLocationUri=localStorage.getItem('lastLocationUri');localStorage.removeItem('lastLocationUri');}return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(lastLocationUri||redirectUri));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Callback));

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Auth_createUserManager__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Auth_createRedirectUri__ = __webpack_require__(382);
var config={authority:"https://auth.tupperwarepremios.premmiar.io"+'/.well-known/openid-configuration',client_id:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_CLIENT_ID,scope:'profile email openid webpremios.campaigns/'+"70885",response_type:'token id_token',redirect_uri:Object(__WEBPACK_IMPORTED_MODULE_1_Auth_createRedirectUri__["a" /* default */])('/zendesk/callback')};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_Auth_createUserManager__["a" /* default */])(config));

/***/ }),
/* 387 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Buffer = __webpack_require__(15).Buffer;
var Transform = __webpack_require__(243).Transform;
var inherits = __webpack_require__(11);

function throwIfNotStringOrBuffer(val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer');
  }
}

function HashBase(blockSize) {
  Transform.call(this);

  this._block = Buffer.allocUnsafe(blockSize);
  this._blockSize = blockSize;
  this._blockOffset = 0;
  this._length = [0, 0, 0, 0];

  this._finalized = false;
}

inherits(HashBase, Transform);

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null;
  try {
    this.update(chunk, encoding);
  } catch (err) {
    error = err;
  }

  callback(error);
};

HashBase.prototype._flush = function (callback) {
  var error = null;
  try {
    this.push(this.digest());
  } catch (err) {
    error = err;
  }

  callback(error);
};

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data');
  if (this._finalized) throw new Error('Digest already called');
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);

  // consume data
  var block = this._block;
  var offset = 0;
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) {
      block[i++] = data[offset++];
    }this._update();
    this._blockOffset = 0;
  }
  while (offset < data.length) {
    block[this._blockOffset++] = data[offset++];
  } // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry;
    carry = this._length[j] / 0x0100000000 | 0;
    if (carry > 0) this._length[j] -= 0x0100000000 * carry;
  }

  return this;
};

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented');
};

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called');
  this._finalized = true;

  var digest = this._digest();
  if (encoding !== undefined) digest = digest.toString(encoding);

  // reset state
  this._block.fill(0);
  this._blockOffset = 0;
  for (var i = 0; i < 4; ++i) {
    this._length[i] = 0;
  }return digest;
};

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented');
};

module.exports = HashBase;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(387);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(173).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(390);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(245).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(140);
util.inherits = __webpack_require__(11);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(789);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(790);
var destroyImpl = __webpack_require__(391);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(94);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(233).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(94);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(233).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(36)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(173).EventEmitter;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(94);

/*<replacement>*/
var util = __webpack_require__(140);
util.inherits = __webpack_require__(11);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(121)
var Buffer = __webpack_require__(15).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(121)
var Buffer = __webpack_require__(15).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var Legacy = __webpack_require__(803)
var Base = __webpack_require__(84)
var Buffer = __webpack_require__(15).Buffer
var md5 = __webpack_require__(396)
var RIPEMD160 = __webpack_require__(248)

var sha = __webpack_require__(249)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(242)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(805)
exports.pbkdf2Sync = __webpack_require__(401)


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(396)
var RIPEMD160 = __webpack_require__(248)
var sha = __webpack_require__(249)

var checkParameters = __webpack_require__(399)
var defaultEncoding = __webpack_require__(400)
var Buffer = __webpack_require__(15).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(52);
var inherits = __webpack_require__(11);

var utils = __webpack_require__(402);
var Cipher = __webpack_require__(250);

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(141)
var Buffer = __webpack_require__(15).Buffer
var incr32 = __webpack_require__(405)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 405 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(183)
var Buffer = __webpack_require__(15).Buffer
var Transform = __webpack_require__(84)
var inherits = __webpack_require__(11)
var GHASH = __webpack_require__(818)
var xor = __webpack_require__(141)
var incr32 = __webpack_require__(405)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(183)
var Buffer = __webpack_require__(15).Buffer
var Transform = __webpack_require__(84)
var inherits = __webpack_require__(11)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(120);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(33);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(410);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(33);
var brorand = __webpack_require__(253);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(185);
curve.short = __webpack_require__(829);
curve.mont = __webpack_require__(830);
curve.edwards = __webpack_require__(831);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var common = __webpack_require__(142);
var shaCommon = __webpack_require__(413);
var assert = __webpack_require__(52);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var common = __webpack_require__(142);
var assert = __webpack_require__(52);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Reporter = __webpack_require__(144).Reporter;
var Buffer = __webpack_require__(23).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(851);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

var asn1 = __webpack_require__(143);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Buffer = __webpack_require__(23).Buffer;

var asn1 = __webpack_require__(143);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(139)
var Buffer = __webpack_require__(15).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(33)
var Buffer = __webpack_require__(15).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 424 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_Shell__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_Shell_AuthedShell__ = __webpack_require__(867);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var ShellContainer=function ShellContainer(_ref){var profile=_ref.profile,children=_ref.children,rest=_objectWithoutProperties(_ref,['profile','children']);return profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell_AuthedShell__["a" /* default */],{profile:profile},children):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_Shell__["a" /* Shell */],{profile:profile},children);};ShellContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref2){var oidc=_ref2.oidc,catalog=_ref2.catalog;var user=oidc.user;var _ref3=user||{},profile=_ref3.profile;return{profile:profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(ShellContainer));

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(868);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var settle = __webpack_require__(872);
var buildURL = __webpack_require__(874);
var parseHeaders = __webpack_require__(875);
var isURLSameOrigin = __webpack_require__(876);
var createError = __webpack_require__(430);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(877);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(873);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryMenu__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CategoryMenu__["a"]; });


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuItem__ = __webpack_require__(435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(916);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryMenu_CategorySubMenuItem__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var MenuItem=function MenuItem(_ref){var label=_ref.label,path=_ref.path,icon=_ref.icon,checked=_ref.checked,categoryId=_ref.categoryId,indexItem=_ref.indexItem,indexParent=_ref.indexParent,subCategoryId=_ref.subCategoryId,campaingId=_ref.campaingId,type=_ref.type,enabled=_ref.enabled,hide=_ref.hide,className=_ref.className,parentClassName=_ref.parentClassName,hasItems=_ref.hasItems,showSubmenu=_ref.showSubmenu,onBlurLink=_ref.onBlurLink,externalLink=_ref.externalLink;return hasItems?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName+' item-with-submenu '+(checked?'item-checked':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return showSubmenu(type+'_'+indexParent+'_'+indexItem);},onKeyPress:function onKeyPress(event){return event.key==='Enter'&&showSubmenu(type+'_'+indexParent+'_'+indexItem);},'data-href':path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,'aria-expanded':checked,'aria-controls':'submenu-'+type+'_'+indexParent+'_'+indexItem},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pr-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_right',className:'icon-sm'}))):label==='Verificação em Duas Etapas'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,role:'button'},label))):type==='category'||type==='sub-category'||type==='services'||type==='services-external'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CategoryMenu_CategorySubMenuItem__["a" /* default */],{type:type,path:path,label:label,categoryId:categoryId,subCategoryId:subCategoryId,enabled:enabled,className:''+className,parentClassName:parentClassName,hasItems:hasItems}):label==='Minhas viagens'?("80938"==='40542'||"80938"==='40541'||"80938"==='40540'||"80938"==='40539'||"80938"==='40538'||"80938"==='40543')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,role:'button'},label))):path==='/scheduling'?__WEBPACK_IMPORTED_MODULE_5_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,role:'button'},label))):type==='logout'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,role:'button',onBlur:function onBlur(){return onBlurLink();}},label))):externalLink?!hide&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,role:'button',onBlur:function onBlur(){return onBlurLink();},'aria-label':label},label))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:path==null?'/':path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className},label)),icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pr-1 my-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_right',className:'icon-sm'})):'');};MenuItem.propTypes={label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,path:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,checked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,categoryId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,indexItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,indexParent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,subCategoryId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,campaingId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,enabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,parentClassName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hasItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showSubmenu:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onBlurLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,hide:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,externalLink:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};MenuItem.defaultProps={className:''};/* harmony default export */ __webpack_exports__["a"] = (MenuItem);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(46);
var normalizeHeaderName = __webpack_require__(904);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(440);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(440);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);
var settle = __webpack_require__(905);
var buildURL = __webpack_require__(437);
var buildFullPath = __webpack_require__(907);
var parseHeaders = __webpack_require__(910);
var isURLSameOrigin = __webpack_require__(911);
var createError = __webpack_require__(441);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(912);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(906);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_slugify__);
var getMenu=function getMenu(isLogged,eventCategory,eventAction,eventLabel){var dimension8=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var dimension9=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'event','eventCategory':("tupperware-inc-cancun"||'webpremios')+':'+eventCategory+'-'+(isLogged?'logada':'aberta'),'eventAction':eventAction,'eventLabel':eventLabel,'dimension8':dimension8?__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()(dimension8,{delimiter:'-'}):__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()("tupperware-inc-cancun"||'webpremios',{delimiter:'-'}),'dimension9':dimension9?__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()(dimension9,{delimiter:'-'}):__WEBPACK_IMPORTED_MODULE_0_react_slugify___default()("tupperware-inc-cancun"||'webpremios',{delimiter:'-'})});};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case'ONLY_CASH_SUCCESS':case'PARTICIPANT_VISUALIZATION_CONTEXT_SUCCESS':return action.payload.data;default:return state;}});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var TextRow = /** @class */ (function (_super) {
    __extends(TextRow, _super);
    function TextRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextRow.prototype.render = function () {
        var _a = this.props, className = _a.className, maxHeight = _a.maxHeight, color = _a.color, lineSpacing = _a.lineSpacing, style = _a.style;
        var defaultStyles = {
            maxHeight: maxHeight,
            width: '100%',
            height: '1em',
            backgroundColor: color,
            marginTop: lineSpacing
        };
        var classes = ['text-row', className].filter(function (c) { return c; }).join(' ');
        return (React.createElement("div", { className: classes, style: __assign({}, defaultStyles, style) }));
    };
    TextRow.propTypes = {
        maxHeight: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        className: PropTypes.string,
        color: PropTypes.string.isRequired,
        lineSpacing: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        style: PropTypes.object
    };
    TextRow.defaultProps = {
        lineSpacing: '0.7em'
    };
    return TextRow;
}(React.Component));
exports["default"] = TextRow;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var RoundShape = /** @class */ (function (_super) {
    __extends(RoundShape, _super);
    function RoundShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RoundShape.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, color = _a.color;
        var defaultStyles = {
            backgroundColor: color,
            borderRadius: '500rem',
            width: '100%',
            height: '100%'
        };
        var classes = ['round-shape', className].filter(function (c) { return c; }).join(' ');
        return (React.createElement("div", { className: classes, style: __assign({}, defaultStyles, style) }));
    };
    RoundShape.propTypes = {
        color: PropTypes.string.isRequired,
        className: PropTypes.string,
        style: PropTypes.object
    };
    return RoundShape;
}(React.Component));
exports["default"] = RoundShape;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var TextRow_1 = __webpack_require__(448);
var TextBlock = /** @class */ (function (_super) {
    __extends(TextBlock, _super);
    function TextBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRowStyle = function (i) {
            var _a = _this.props, rows = _a.rows, widths = _a.widths;
            return {
                maxHeight: (100 / (rows * 2 - 1)) + "%",
                width: widths[(i + widths.length) % widths.length] + "%"
            };
        };
        _this.getRows = function () {
            var _a = _this.props, rows = _a.rows, lineSpacing = _a.lineSpacing, color = _a.color;
            var range = Array.apply(null, Array(rows));
            return range.map(function (_, i) { return (React.createElement(TextRow_1["default"], { color: color, style: _this.getRowStyle(i), lineSpacing: i !== 0 ? lineSpacing : 0, key: i })); });
        };
        return _this;
    }
    TextBlock.prototype.render = function () {
        var _a = this.props, style = _a.style, className = _a.className;
        var defaultStyles = {
            width: '100%'
        };
        var classes = ['text-block', className].filter(function (c) { return c; }).join(' ');
        return (React.createElement("div", { className: classes, style: __assign({}, defaultStyles, style) }, this.getRows()));
    };
    TextBlock.propTypes = {
        rows: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
        lineSpacing: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        widths: PropTypes.arrayOf(PropTypes.number),
        style: PropTypes.object,
        className: PropTypes.string
    };
    TextBlock.defaultProps = {
        widths: [97, 100, 94, 90, 98, 95, 98, 40]
    };
    return TextBlock;
}(React.Component));
exports["default"] = TextBlock;


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logo__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Search__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cart__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserProfile__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tracking__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HeaderWrapper__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MainMenu__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BackButton__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UserBasicInformation__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shell_TitleAnnouncer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @ts-nocheck
var DefaultHeader=function(_Component){_inherits(DefaultHeader,_Component);function DefaultHeader(props){_classCallCheck(this,DefaultHeader);var _this=_possibleConstructorReturn(this,(DefaultHeader.__proto__||Object.getPrototypeOf(DefaultHeader)).call(this,props));_this.state={sendGTM:false};return _this;}_createClass(DefaultHeader,[{key:'sendGTM',value:function sendGTM(){var _this2=this;setTimeout(function(){if(!_this2.state.sendGTM){window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'global','dimension1':_this2.props.participant_Id,'dimension6':_this2.props.campaing_Id,'dimension7':"80938",'dimension8':"tupperware-inc-cancun"});_this2.setState({sendGTM:true});}},500);}},{key:'componentDidMount',value:function componentDidMount(){if(!this.state.sendGTM){this.sendGTM(this.props);}document.querySelectorAll('#meu-negocio').length>0&&document.querySelector('#meu-negocio').focus();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__HeaderWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{maxDeviceWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shell_TitleAnnouncer__["a" /* default */],{orientation:'mobile'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__BackButton__["b" /* BackButtonMobile */],Object.assign({refererIsLogin:this.props.refererIsLogin},this.state))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Shell_TitleAnnouncer__["a" /* default */],{orientation:'desktop'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Logo__["a" /* Logo */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Search__["a" /* SearchContainer */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UserProfile__["a" /* UserProfileContainer */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Tracking__["a" /* TrackingContainer */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{minWidth:480},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Cart__["b" /* CartContainer */],{desktop:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{maxWidth:479},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UserBasicInformation__["a" /* UserBasicInformation */],this.state)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MainMenu__["a" /* MainMenuContainer */],this.state));}}]);return DefaultHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DefaultHeader.propTypes={refererIsLogin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,campaing_Id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,participant_Id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var oidc=_ref.oidc;return{campaing_Id:oidc.user.profile['custom:campaign_id'],participant_Id:oidc.user.profile['custom:participant_id']};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(mapStateToProps)(DefaultHeader));

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchAddress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAddress; });
var fetchAddress=function fetchAddress(zipCode){return{type:'FETCH_ADDRESS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/addresses/'+zipCode}}};};var setAddress=function setAddress(address){return{type:'SET_ADDRESS',address:address};};var cleanError=function cleanError(){return{type:'CLEAN_ERROR_ADDRESS'};};/* harmony default export */ __webpack_exports__["a"] = ({fetchAddress:fetchAddress,cleanError:cleanError,setAddress:setAddress});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary__ = __webpack_require__(947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Summary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SummaryPlaceholder__ = __webpack_require__(956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__SummaryPlaceholder__["a"]; });


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image__ = __webpack_require__(963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Image__["a"]; });


/***/ }),
/* 456 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserProfileSubmenu__ = __webpack_require__(983);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserProfile=function(_Component){_inherits(UserProfile,_Component);function UserProfile(props){_classCallCheck(this,UserProfile);var _this=_possibleConstructorReturn(this,(UserProfile.__proto__||Object.getPrototypeOf(UserProfile)).call(this));_this.onBlurLink=function(){setTimeout(function(){if(document.querySelectorAll('[data-profile-expanded="true"]').length>0&&document.querySelectorAll('.profile-menu .link-profile:focus').length===0){_this.toggleExpandMenu();}},300);};_this.formatName=function(name){return name.split(' ')[0];};_this.formatPoints=function(value){return parseFloat(value.toFixed(2)).toLocaleString('pt-br',{minimumFractionDigits:0,maximumFractionDigits:2});};_this.hideValue=function(){window.localStorage.setItem('hideValue',!_this.state.hideValue);_this.setState({hideValue:!_this.state.hideValue});};_this.toggleExpandMenu=function(){_this.setState({menuExpanded:!_this.state.menuExpanded});};_this.state={hideValue:false,menuExpanded:false};_this.onBlurLink=_this.onBlurLink.bind(_this);return _this;}_createClass(UserProfile,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-menu profile zindex-high col-sm-4 d-none d-sm-block px-2','data-profile-expanded':this.state.menuExpanded},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col color-brand-5 profile-infos txt-font-body txt-body-sm px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-left'},'Ol\xE1, ',this.formatName(this.props.userInfo.name),'!'),this.props.isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-points-information txt-left'},'Carregando pontua\xE7\xE3o'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'row txt-title color-points-information txt-left pt-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',role:'button',className:'d-inline-block','aria-label':window.localStorage.getItem('hideValue')==='true'||this.state.hideValue?'Exibir pontuação':'Esconder pontuação',onClick:function onClick(){return _this2.hideValue();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:window.localStorage.getItem('hideValue')==='true'||this.state.hideValue?'icon_no_view':'icon_view',className:'icon-md w-100 position-relative pos-relative l-0 t-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:(window.localStorage.getItem('hideValue')==='true'||this.state.hideValue?'d-none':'')+' fontSize20'},this.formatPoints(this.props.pointsValue)+' '+this.props.pointsName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-relative hidden-value bg-ui-3 radius '+(window.localStorage.getItem('hideValue')!=='true'&&!this.state.hideValue?'d-none':'')})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-none d-sm-block profile-dropdown  px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'profile-menu','aria-expanded':this.state.menuExpanded,'aria-controls':'profile-list',onClick:this.toggleExpandMenu,onBlur:function onBlur(){return _this2.onBlurLink();},'aria-label':'Abrir menu do usu\xE1rio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_down',className:'icon-sm color-brand-5'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UserProfileSubmenu__["a" /* UserProfileSubmenu */],{onBlurLink:this.onBlurLink}));}}]);return UserProfile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserProfile.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,userInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var oidc=_ref.oidc,balance=_ref.balance,catalog=_ref.catalog;return{isLoading:balance.isLoading,userInfo:oidc.user.profile,pointsValue:balance.pointsValue,pointsName:catalog.currencyConfiguration.pointsName};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(UserProfile));

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadMyOrdersTracking */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadProductsTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrderListDetails; });
/* unused harmony export getTrackingStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNetshoesLastEvent; });
/* unused harmony export insertLastEventTrackingStatus */
/* unused harmony export insertTrackingStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Participant_MyOrders_ProductOrderDetail_ProductSide__ = __webpack_require__(190);
var client=__WEBPACK_IMPORTED_MODULE_1_redux_clients__["a" /* default */].cloudloyalty.client;var clientCloudLoyalty=__WEBPACK_IMPORTED_MODULE_1_redux_clients__["a" /* default */].cloudloyalty.client;var defaultStatusTracking={statuses:[{status:'1',name:'Produto solicitado',when:null},{status:'2',name:'Produto confirmado no parceiro',when:null},{status:'3',name:'Produto enviado para a transportadora',when:null},{status:'4',name:'Produto em rota de entrega',when:null},{status:'5',name:'Produto entregue',when:null}]};var loadMyOrdersTracking=function loadMyOrdersTracking(){return function(dispatch,getState){dispatch({type:'FETCH_ORDER_TRACKING'});var handleSuccess=function handleSuccess(payload){dispatch({type:'FETCH_ORDER_TRACKING_SUCCESS',payload:payload});};var handleError=function handleError(err){dispatch({type:'FETCH_ORDER_TRACKING_FAIL',error:{data:err}});};var dateFrom=__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(11,'d').format('DD/MM/YYYY');var formattedInitialDate=dateFrom;var formattedEndDate=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().format('DD/MM/YYYY');client.get('/v1/purchases/me/orders?orderId=&startDate='+formattedInitialDate+'&endDate='+formattedEndDate+'&offset=0&limit=0').then(handleSuccess).catch(handleError);};};var loadProductsTracking=function loadProductsTracking(cache,pageIndex,pageSize){return function(dispatch,getState){dispatch({type:'FETCH_PRODUCTS_TRACKING'});var handleSuccess=function handleSuccess(payload){dispatch({type:'FETCH_PRODUCTS_TRACKING_SUCCESS',payload:payload,pageIndex:pageIndex});};var handleError=function handleError(err){dispatch({type:'FETCH_PRODUCTS_TRACKING_FAIL',error:{data:err}});};var formattedInitialDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(11,'d').format('DD/MM/YYYY');var formattedEndDate=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc().format('DD/MM/YYYY');var data={statusGroupFilters:[{descriptionStatusGroup:'Confirmado'},{descriptionStatusGroup:'Enviado'},{descriptionStatusGroup:'Pendente'},{descriptionStatusGroup:'Entregue',innitialDate:formattedInitialDate,endDate:formattedEndDate}],pageIndex:pageIndex,pageSize:pageSize};clientCloudLoyalty.post('/v1/purchases/me/search?cache='+cache,data).then(handleSuccess).catch(handleError);};};var getOrderListDetails=function getOrderListDetails(parentOrderId,orderId,productId,fromOrderDetail){return{type:'GET_ORDERLIST',parentOrderId:parentOrderId,productId:productId,orderId:orderId,fromOrderDetail:fromOrderDetail,payload:{client:'tracking',request:{method:'get',url:'/timelines/'+orderId}}};};var getTrackingStatus=function getTrackingStatus(order){var sku=order.productCode;if(sku){var splitSku=sku.split('-');if(splitSku.length>0)sku=splitSku[0];}if(!__WEBPACK_IMPORTED_MODULE_2__Participant_MyOrders_ProductOrderDetail_ProductSide__["e" /* availableVendors */].includes(order.vendorId)){if(order.vendorType==='e-Commerce'){var status=Object.assign({},defaultStatusTracking);status.statuses[0].when=order.insertDate;return insertTrackingStatus(order.orderId,status,order.id,sku);}else{return insertLastEventTrackingStatus(order.orderId,order.orderStatusId,order.id,sku);}}return{type:'GET_TRACKING_STATUS',orderId:order.orderId,sku:sku,id:order.id,payload:{client:'tracking',request:{method:'get',url:'/timelines/'+order.orderId+'/items/'+sku}}};};var insertNetshoesLastEvent=function insertNetshoesLastEvent(orderId,status){return{type:'INSERT_NETSHOES_LAST_EVENT',orderId:orderId,status:status};};var insertLastEventTrackingStatus=function insertLastEventTrackingStatus(orderId,status,orderItemId,sku){return{type:'INSERT_NETSHOES_EVENT_TRACKING_STATUS',orderId:orderId,status:status,orderItemId:orderItemId,sku:sku};};var insertTrackingStatus=function insertTrackingStatus(orderId,status,orderItemId,sku){return{type:'INSERT_TRACKING_STATUS',orderId:orderId,status:status,orderItemId:orderItemId,sku:sku};};/* harmony default export */ __webpack_exports__["a"] = (function(client){return{loadMyOrdersTracking:loadMyOrdersTracking(),getOrderListDetails:getOrderListDetails,loadProductsTracking:loadProductsTracking,getTrackingStatus:getTrackingStatus};});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Status__ = __webpack_require__(991);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Name__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Name__["a"]; });


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var getColorClassByStatus=function getColorClassByStatus(status){switch(status){case'1':case'2':case'3':case'4':case'5':return'color-success';case'6':case'7':case'8':case'9':case'10':return'color-error';default:return'';}};var Name=function Name(_ref){var status=_ref.status,name=_ref.name,className=_ref.className,when=_ref.when;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:className+' '+getColorClassByStatus(when&&status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},''+(getColorClassByStatus(when&&status)===''?'(pendente)':'')+(getColorClassByStatus(when&&status)==='color-success'?'(resolvido)':'')+(getColorClassByStatus(when&&status)==='color-error'?'(não resolvido)':'')+' '+name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},''+name)));};Name.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,when:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Name);

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBARXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAARqADAAQAAAABAAAARgAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgARgBGAwERAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/dAAQACf/aAAwDAQACEQMRAD8A/Mz9pX9pL4rftVfF3xh8X/iz4r1rxHrfibWtRvtPsdQ1G7udL8KaJPeXE2leFfDOnzTS2+j6DodpMtlYWFmqIFR7idp7ye5ubj/Szh3h7LOGcqwmVZXhaOHo4ajThUnTpwjUxNZQiquJxE0lKtXrSi5zqSbeqiuWEYRj/amT5PgcjwGHwGBoU6VOjThGc4wjGpXqKKU69aa1qVaslzSlJvsrRUYx8Cr3D1AoAKACgAoAKACgD9CP2Fv+CkP7QX7CGseKZfhx4gudX8IeK9FNlffD/wAQ3N1qfg+DW47/AE24tPFNjost1FbWOvW9laXelNfWnlPdWF+8F4LgQWZtfg+NfD7IuNqWGWYYeNLF4Wtzwx1CMKeLdFwqRlhp1lFynQlOUavJPm5ZwTg4801L5XiXhDKuJqdFYykqdehU5o4qjGMMQ6bjNSoSqL3pUnKSqcsm+WcLx5by5v/Q/FbC+g/Kv9SD+6AwvoPyoAML6D8qADC+g/KgAwvoPyoAML6D8qADC+g/KgAwvoPyoAhPU/U0Af/R/Fj5fU/lX+pB/dAfL6n8qAD5fU/lQAfL6n8v/wBX+fXpRZjs3tf7r/1/XYPl9T+VAg+X1P5UAHy+p/KgA49T+VAFc9T9TQB//9L8V6/1IP7oEJCgsxAABJJOAAOSSTgAAckk/lij+v6/r8wtf8hN6bPM3r5e3fvLAJt67t3I2gAkknHrnFFvn6a99mt7Wf3Psw7W67W1v5rvs3p28mfo3+xH+yn+y3+0T8Kv2mvGnx5/a10H9nvxZ8JPCkOs/DLwrqV14Ztm8bXEmj6rqD6rNb69LHqXinTI9VsrHw7/AMI54KH/AAkTXWoLcGVWuNMtrv8ANuOOLeJ+HM04dweScL1M7w2aVnDG4mNLE1Xhn7SlH2NOdD93Qq+ynKs62JSpOK0vGM+X4zibiDO8nzDKMLlmRzzTD42oo4uvGnVmqV6qh7FOmnGjNQl7T2lb3Hpa6UlL84YZfNQEgLLtQzRZBaF3XcY3HVWU5GCF6dOtfpTT169e+6vvr0d731Wqumj7S29raO2mqT7dO2l1drXS49XRyyo6syHa6qwJRjyAwBJU45wcHvjkUWdr2du/T7/n+K7oLPs9Pw1t+enrp2GpNE7MiSxu6ffVHVmX/eVSSvPrj6cU3GUfijKO26a30W9t20l6210YOLV7pqyu7prTo3fZElS1bR6NaNPoIgPU/U0Af//T/Fev9SD+6D379lf4qeBvgh+0Z8Gvi18Tfh3onxX+H3gTx3o2t+MPAniDT11Ww1fQkkaC9u4NNldbS+1nw+k//CSeHrPUI7nTbrXNJsLfULWezlmjb53i3KsdnnDWcZVlmOq5fj8bgqlPC4mjV9jNVoWnGjOotY0cTZ4erKLpzjGo5RqJq8fIz/AYvNMmzDA4LE1MJi8Rh6kMPiKU3TnGrbSnKSs1Srr91UlF88U/ctJn9dGof8Esf2etV/b20f8A4KS23iDwCP2Grj4ZS/tT61pzyWi+GJPilZ2Nvq1jrA0x4zbf8K41HSpv+Ft6gjxGJPE+mXejzWLWWorbp/JsPE3PqfAtXw8qUcbLihY+OR0q1pfWIZa6jjPDe0i+dYyFdfUIaylKhV5vaXjLm/AYca5rDherwi6WJ/t1Y1ZZCraXt1heezpufM5rEwqL6pDkf8F3bbc5S+T/ANhHTP2W/wBtCy/4LI/HeD9mL4NaP4Ui0y31f4K6HefDfwzcT+BNLi+F3xXS18S6JBf2N4nhPxX4uu9GsfGviT/hHhp0EHiK5It41+xQvX0/Gr4l4P8A+IU5NPiHNp4tK2ayjjsRGFaq80wklhJThKCxFDBwqvDU/aqq+Tmi5NStD3uJv7Z4dhwBlss3zCWIWmPcMXViqtSeOws3h5ShKPtqWGUlRpe1VSSje8tUjlfhv+yl8I/+CuP/AAS+/Z7tf2bfC/w5+Df7Un7KmveHvhr460vTra20bTr3T/EFxpkHjrXdenHnalqtv4x0V4vjDoOo6pPe3U3i3SPEvhaG4e5vNRuK68fxTnHhP4kcQyz7EY7Ocg4kpV8bhKlacqsqk4wnLAKipyjTpzwlV/2ZXhS5VGjKlNpqlSjHTF53mPAfGObvNauLzLKM5pVMVhpTlKT5leWEdPmlGClhqlsLUjBLlpSjN3tGJ7Z8U/2ef2FvjB/wUB/Yq/4JdeFPh14MufC/7LPw513xJ8bvHmn21tp3jj4h3vhjwcNZ0X4Ja34p0hrbUdSj1m6u/wDhY3xQD3U94s+pPp2lS6PdJrG7xsrzvjbKeCOMPEqvmOLhiOJMwo4HK8PKUpYbCLE4qSxGb0aFRSp0lRhB5dlzSXLZ1GqqhRmefgc24ly/hriDjKri68KudYuGGwFCcnOjRVarKNbHU6M/dg6UP9nwvu8m8/ecYSPWfDPhv9lD/goj4v8A22f2Ide/4J9+H/2ZdL/Ze0zXdM+HHx60fwjonhXVtF1XRNT1Dw3o+rve6T4Q8OSaBeahLYJ4z0vQf7c8S6R4p8FJePrDOoD3XkV8TxPwFhOD+MMLxzVz2rxJbEY3JpYuviVKnO06tGtSq168a9NxqPDzrSp0atHFr92uaKlHzqtXOeFKXDvENDiiWa1c2cKmJy54irXjySSqTozjUrVFVjFS9lOUoUpU69lCLteP8V20oWRpIpmjZ4zPASYJzGxTz4CeTBNt8yEnrGynua/tCEueFOfK4qcITUXe8eaKfK27tuN+Vtu91rdn9JxfNGErNc0Yys9ZR5lflk9LyV7SdtXrpcgPU/U1Qz//1PxYw3ofyr/Ug/ugMN6H8v8AP+elH9f1t+f3WD+v6/r8j7TT/goF+1En7Hj/ALC6+NLQfAN9Sa4Nn/Zko8XjQX1r/hI38Br4m+3fL4EfXs6g+hjThKUZtL+3DRW/s6viH4e8MS4wXG0sLUecJKXI5QeCWJVJUVj/AKu6d5YyNO6jOVT2fOoVnTdVc8vmHwjkz4hjxN7Kf9ox97lvH6tKuoez+typ2UvrKg3afNy8/LPkTTRY/ZV/b6+Ov7Hnw/8Ajx8NvhLY+Abvw7+0RodvoHjyTxl4e1PWdStLS20HxJ4cil8OXNhr+jw2NwNO8U6kzfbrbUYGuUtJDCUiljlringLJeL8wyXMszrY+lXyGfPg44StThTm/rFDEWrKpSq8yc6Cvy8srStfSxWecKZZxBi8sxmOqYqFXKp+0w8aE4RhOXtKFVqqpRldOVHVqzs7K3K+bmP2Of22P2gf2EvGfiLxx+z7ruj6dqHi3woPCHiTSPFeit4k8M6vp9vdR32k311o4vtOH9taDeJNLo2ppcK9rHf6naSRXFnqF1by9HGHBORccYTC4PPKddxwWKeKw2IwlVUcVS5o8lWgqns5wdCtBRVSDpq0oRqQtOMDXiHhnKuJsPQw+aUqjWHrOtSq4eoqVWDnpVpxk4VF7GrG3NBpe9GMk04o8k8J/HX4w+B/jTY/tFeF/Huv6b8bLDxrf/ESP4hNMl5rNz4u1a7u7vWtS1NbyOa01SDXG1DULbWdMvoJtN1LTb660y6tmspnhb1cVw/k+MyOXDeJwNKpks8HSwLwOsIRw9CMFQ9nKHJOnVoOnCpSqQ5ZRqRUnezU+7E5RluKyv8AsarhKTy76vHDfVldRVOmoqnyzXvwnT5IuNSLjJNX6s/UX4//APBd79ur9oH4Nar8F9Qk+GHw403xTos/h3x14v8Ahl4Z13SPGfi3Rr62+x6rp4vtY8T63ZeGbfWrQy2mqP4ds7O+ks5p7WzvbGCZ42/M8j8DOC8kzalm3tMzzKWGrqvg8HmFTDzwmHqwnz0pzjToU54l0mlyxrS9m3GEpwlZqXxWV+F3DeWY+GP58bjZUKsauGw+LnSeHpVI6wclThCVXklrHnluk3quY/GAJsUKq7VUBVULhVUcAADAAAwAAPbjFfsrd235v+tP6e5+jv8Aq+/q+7fV9Xr1ID1P1NID/9X8WPl9T+Vf6kH90B8vqfyoAPl9T+VAB8vqfyoAPl9T+VAB8vqfyoAPl9T+VABx6n8qAK56n6mgD//W/Fev9SD+6AoAKACgAoAKACgAoAgPU/U0Af/X+cf+Clf7A+v/ALBnx11XwbP4o8O+KPBHiq+1LxD8N59Mk1Ma7Z+Dr2/u30fT/FlneaRYWNtrlhaoLO7bSb/VLG6aBbuKWDz2s7f/AEI8O+OaHHGSUsXHDYjDY3Cwp0MwVRU3Qni4Qgq1TCzjVlUlRnJ88Pa06c483I1Llc5f13wfxRS4nyyniFQrUMTQjCljFNQ9lLERjH2kqEo1JSdOUnzR54Qkr8rvy80vzlr9APrQoAKACgAoAKACgD9/f+CS3/BHjTf2zvDniX40fGHxtp+l/CiOyn8PeG9A8LNd3PjaXxgb3S7xtR1ddT0eHQ7HRLTR0vbeJLPUNSvr29vo2dLGGyP2v8K8UvFmpwjiMPk+U4OpVzRzjXxFfE8sMGsJyVYezpOlVlXnWnVcJPnp04QhB2c3P3fyzjrj+fD1ajl2X4eU8c5qrWq11FYZYflqR5KfJVdSVWVTld5RhGMY/acrQ//Z"

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackButtonMobile__ = __webpack_require__(1013);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__BackButtonMobile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BackButtonDesktop__ = __webpack_require__(1014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BackButtonDesktop__["a"]; });


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BackButton__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logo__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HeaderWrapper__ = __webpack_require__(269);
var BasicHeader=function BasicHeader(){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){document.querySelectorAll('#meu-negocio').length>0&&document.querySelector('#meu-negocio').focus();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HeaderWrapper__["a" /* default */],{className:'container-header-basic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxWidth:479},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BackButton__["a" /* BackButtonDesktop */],{mobile:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Logo__["a" /* Logo */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minWidth:480},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BackButton__["a" /* BackButtonDesktop */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear pl-1 order-md-3 order-3 d-flex d-md-none col-2'}));};/* harmony default export */ __webpack_exports__["a"] = (BasicHeader);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Search__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GuestUserProfile__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GuestCart__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HeaderWrapper__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_App_MainMenu__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_yn__);
var GuestHeader=function GuestHeader(){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){document.querySelectorAll('#meu-negocio').length>0&&document.querySelector('#meu-negocio').focus();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HeaderWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NO_INDEX)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'robots',content:'noindex, nofollow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* Logo */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Search__["a" /* SearchContainer */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GuestUserProfile__["a" /* default */],null),window.innerWidth>767?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GuestCart__["a" /* default */],null):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_App_MainMenu__["b" /* MainMenuPublicContainer */],null));};/* harmony default export */ __webpack_exports__["a"] = (GuestHeader);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["anchor-link"] = factory(require("react"));
	else
		root["anchor-link"] = factory(root["react"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _anchorLink = __webpack_require__(1);

var _anchorLink2 = _interopRequireDefault(_anchorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _anchorLink2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnchorLink = function (_Component) {
  _inherits(AnchorLink, _Component);

  function AnchorLink(props) {
    _classCallCheck(this, AnchorLink);

    var _this = _possibleConstructorReturn(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).call(this, props));

    _this.smoothScroll = _this.smoothScroll.bind(_this);
    return _this;
  }

  _createClass(AnchorLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __webpack_require__(3).polyfill();
    }
  }, {
    key: 'smoothScroll',
    value: function smoothScroll(e) {
      var _this2 = this;

      e.preventDefault();
      var offset = function offset() {
        return 0;
      };
      if (typeof this.props.offset !== 'undefined') {
        if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
          offset = this.props.offset;
        } else {
          offset = function offset() {
            return parseInt(_this2.props.offset);
          };
        }
      }
      var id = e.currentTarget.getAttribute('href').slice(1);
      var $anchor = document.getElementById(id);
      var offsetTop = $anchor.getBoundingClientRect().top + window.pageYOffset;
      window.scroll({
        top: offsetTop - offset(),
        behavior: 'smooth'
      });
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          offset = _props.offset,
          rest = _objectWithoutProperties(_props, ['offset']);

      return _react2.default.createElement('a', _extends({}, rest, { onClick: this.smoothScroll }));
    }
  }]);

  return AnchorLink;
}(_react.Component);

exports.default = AnchorLink;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.0 - 2018 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ })
/******/ ]);
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(83);
var history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["createBrowserHistory"])();history.listen(function(location,action){window.scrollTo(0,0);});/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_oidc__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_oidc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_oidc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rootReducer__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initial_state__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_axios_middleware__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_axios_middleware___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_axios_middleware__);
var oidcMiddleware=__WEBPACK_IMPORTED_MODULE_1_redux_oidc___default()(__WEBPACK_IMPORTED_MODULE_8_Auth__["c" /* userManager */]);var createStoreWithMiddlewares=Object(__WEBPACK_IMPORTED_MODULE_5_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_5_redux__["applyMiddleware"])(Object(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__["routerMiddleware"])(__WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */],oidcMiddleware,Object(__WEBPACK_IMPORTED_MODULE_9_redux_axios_middleware__["multiClientMiddleware"])(__WEBPACK_IMPORTED_MODULE_7__clients__["a" /* default */],{defaultClientName:'cloudloyalty'})))(__WEBPACK_IMPORTED_MODULE_5_redux__["createStore"]);var reducerWithRouter=Object(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__["connectRouter"])(__WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__rootReducer__["a" /* default */]);var store=createStoreWithMiddlewares(reducerWithRouter,__WEBPACK_IMPORTED_MODULE_4__initial_state__["a" /* default */],window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__());/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__oidcReducer__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_features_Balance__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_Header_Search__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Checkout__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App_MainMenu__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__features_Suggestion_ProductSuggestion__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__features_Recomendation__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__features_Suggestion_VoucherSuggestion__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__features_Suggestion_StoreSuggestion__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductDetail_RedemptionSection_Shipping__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductDetail_RedemptionSection_Unvailable__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductDetail__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Catalog_Product_ProductDetail_RedemptionSection_Payment__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__features_Address__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Catalog_Search_ducks__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__features_CardBrands__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__features_Regulation__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_Participant_MyOrders__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_Participant_Wishlist__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_features_SelectMobileOperator__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_features_CellphoneRecharge_ValuesRecharge__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_features_CellphoneRecharge_PhoneNumber_SelectAreaCode__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_Participant_Extract__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_features_CellphoneRecharge__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_features_Confirmation__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_features_ConfirmationMobileRechargeSchedule__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_Participant_Scheduling__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_features_Services_FuelCredit__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_features_Services_ConfirmationCreditMileage__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_features_Services_Mileage__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_App_Header_Tracking__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_features_Stix__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__features_Products_reducer__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__features_Checkout__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_Participant_ducks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_Catalog_ducks__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_Catalog_Brand_ducks__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_Catalog_Vendor_ducks__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_Catalog_Availability_ducks__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_Catalog_Service_ducks__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_Catalog_Product_ducks__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_Wishlist_ducks__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_Shared_HeadMetadata_ducks__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_Checkout_PointsPurchase_ducks__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_Participant_TokenChangeEmail_ducks__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__features_MeuBairro_rootReducer__ = __webpack_require__(1682);
var google=function google(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{google:{}};var action=arguments[1];return Object.assign({},state);};var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({onlyCash:__WEBPACK_IMPORTED_MODULE_6_App_MainMenu__["f" /* onlyCashReducer */],oidc:__WEBPACK_IMPORTED_MODULE_1__oidcReducer__["a" /* default */],productSuggestion:__WEBPACK_IMPORTED_MODULE_7__features_Suggestion_ProductSuggestion__["a" /* productSuggestionReducer */],recomendation:__WEBPACK_IMPORTED_MODULE_8__features_Recomendation__["b" /* recomendationReducer */],voucherSuggestion:__WEBPACK_IMPORTED_MODULE_9__features_Suggestion_VoucherSuggestion__["a" /* voucherSuggestionReducer */],storeSuggestion:__WEBPACK_IMPORTED_MODULE_10__features_Suggestion_StoreSuggestion__["b" /* storeSuggestionReducer */],balance:__WEBPACK_IMPORTED_MODULE_2_features_Balance__["b" /* reducer */],cart:__WEBPACK_IMPORTED_MODULE_4_features_Cart__["d" /* reducer */],itemsToRemove:__WEBPACK_IMPORTED_MODULE_5_Checkout__["b" /* reducerItemToRemove */],mainMenu:__WEBPACK_IMPORTED_MODULE_6_App_MainMenu__["e" /* mainMenuReducer */],shipping:__WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductDetail_RedemptionSection_Shipping__["b" /* ShippingReducer */],unAvailable:__WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductDetail_RedemptionSection_Unvailable__["a" /* unAvailableReducer */],productsBySku:__WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductDetail__["a" /* reducer */],payment:__WEBPACK_IMPORTED_MODULE_14_Catalog_Product_ProductDetail_RedemptionSection_Payment__["b" /* paymentReducer */],address:__WEBPACK_IMPORTED_MODULE_15__features_Address__["b" /* reducer */],autoComplete:__WEBPACK_IMPORTED_MODULE_3_App_Header_Search__["b" /* reducer */],searchResult:__WEBPACK_IMPORTED_MODULE_16_Catalog_Search_ducks__["d" /* default */],google:google,productCategories:__WEBPACK_IMPORTED_MODULE_6_App_MainMenu__["g" /* productCategoriesReducer */],stores:__WEBPACK_IMPORTED_MODULE_6_App_MainMenu__["h" /* storesReducer */],cardBrands:__WEBPACK_IMPORTED_MODULE_17__features_CardBrands__["c" /* reducer */],regulations:__WEBPACK_IMPORTED_MODULE_18__features_Regulation__["c" /* reducer */],myOrders:__WEBPACK_IMPORTED_MODULE_19_Participant_MyOrders__["e" /* reducer */],mobileOperators:__WEBPACK_IMPORTED_MODULE_21_features_SelectMobileOperator__["b" /* reducer */],valuesRecharge:__WEBPACK_IMPORTED_MODULE_22_features_CellphoneRecharge_ValuesRecharge__["b" /* reducer */],areaCodes:__WEBPACK_IMPORTED_MODULE_23_features_CellphoneRecharge_PhoneNumber_SelectAreaCode__["b" /* reducer */],extract:__WEBPACK_IMPORTED_MODULE_24_Participant_Extract__["d" /* reducer */],checkout:__WEBPACK_IMPORTED_MODULE_35__features_Checkout__["d" /* reducer */],cellphoneRecharge:__WEBPACK_IMPORTED_MODULE_25_features_CellphoneRecharge__["d" /* reducer */],confirmation:__WEBPACK_IMPORTED_MODULE_26_features_Confirmation__["b" /* reducer */],confirmationMobileRechargeSchedule:__WEBPACK_IMPORTED_MODULE_27_features_ConfirmationMobileRechargeSchedule__["b" /* reducer */],scheduling:__WEBPACK_IMPORTED_MODULE_28_Participant_Scheduling__["c" /* reducer */],products:__WEBPACK_IMPORTED_MODULE_34__features_Products_reducer__["a" /* productReducer */],fuelCredit:__WEBPACK_IMPORTED_MODULE_29_features_Services_FuelCredit__["c" /* reducer */],confirmationCreditMileage:__WEBPACK_IMPORTED_MODULE_30_features_Services_ConfirmationCreditMileage__["b" /* reducer */],mileage:__WEBPACK_IMPORTED_MODULE_31_features_Services_Mileage__["c" /* reducer */],ordersTracking:__WEBPACK_IMPORTED_MODULE_32_App_Header_Tracking__["c" /* reducer */],wishlist:__WEBPACK_IMPORTED_MODULE_20_Participant_Wishlist__["c" /* reducer */],participant:__WEBPACK_IMPORTED_MODULE_36_Participant_ducks__["c" /* default */],catalog:__WEBPACK_IMPORTED_MODULE_37_Catalog_ducks__["a" /* default */],showcases:__WEBPACK_IMPORTED_MODULE_41_Catalog_Showcase_ducks__["b" /* default */],services:__WEBPACK_IMPORTED_MODULE_42_Catalog_Service_ducks__["a" /* default */],productsv2:__WEBPACK_IMPORTED_MODULE_43_Catalog_Product_ducks__["b" /* default */],availability:__WEBPACK_IMPORTED_MODULE_40_Catalog_Availability_ducks__["a" /* default */],wishlistv2:__WEBPACK_IMPORTED_MODULE_44_Wishlist_ducks__["b" /* default */],metadata:__WEBPACK_IMPORTED_MODULE_45_Shared_HeadMetadata_ducks__["a" /* default */],brands:__WEBPACK_IMPORTED_MODULE_38_Catalog_Brand_ducks__["a" /* default */],vendors:__WEBPACK_IMPORTED_MODULE_39_Catalog_Vendor_ducks__["a" /* default */],pointsPurchase:__WEBPACK_IMPORTED_MODULE_46_Checkout_PointsPurchase_ducks__["c" /* default */],tokenChangeEmail:__WEBPACK_IMPORTED_MODULE_47_Participant_TokenChangeEmail_ducks__["a" /* default */],stix:__WEBPACK_IMPORTED_MODULE_33_features_Stix__["g" /* reducer */],comunidade:__WEBPACK_IMPORTED_MODULE_48__features_MeuBairro_rootReducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Checkout_CheckoutRouter__ = __webpack_require__(1025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_Checkout_CheckoutRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cart_reducer__ = __webpack_require__(1286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Cart_reducer__["a"]; });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-card-flip", [], factory);
	else if(typeof exports === 'object')
		exports["react-card-flip"] = factory();
	else
		root["react-card-flip"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(2);
  var loggedTypeFailures = {};

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          )

        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactCardFlip = function (_React$Component) {
  _inherits(ReactCardFlip, _React$Component);

  function ReactCardFlip(props) {
    _classCallCheck(this, ReactCardFlip);

    var _this = _possibleConstructorReturn(this, (ReactCardFlip.__proto__ || Object.getPrototypeOf(ReactCardFlip)).call(this, props));

    _this.state = {
      isFlipped: _this.props.isFlipped,
      rotation: 0
    };
    return _this;
  }

  _createClass(ReactCardFlip, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isFlipped !== this.props.isFlipped) {
        this.setState({ isFlipped: nextProps.isFlipped });
        this.setState({ rotation: this.state.rotation + 180 });
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent(key) {
      return this.props.children.filter(function (component) {
        return component.key === key;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = {
        container: {
          perspective: '1000px',
          transformStyle: 'preserve-3d'
        },
        flipper: {
          position: 'relative',
          transformStyle: 'preserve-3d'
        },
        front: _extends({
          WebkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          left: '0',
          position: 'absolute',
          top: '0',
          transform: 'rotateY(' + (this.props.infinite ? this.state.rotation : this.state.isFlipped ? 180 : 0) + 'deg)',
          transformStyle: 'preserve-3d',
          width: '100%',
          zIndex: '2',
          transition: this.props.flipSpeedBackToFront + 's'
        }, this.props.cardStyles.front),
        back: _extends({
          WebkitBackfaceVisibility: 'hidden',
          backfaceVisibility: 'hidden',
          left: '0',
          position: 'absolute',
          transform: 'rotateY(' + (this.props.infinite ? this.state.rotation + 180 : this.state.isFlipped ? 0 : -180) + 'deg)',
          transformStyle: 'preserve-3d',
          top: '0',
          width: '100%',
          transition: this.props.flipSpeedFrontToBack + 's'
        }, this.props.cardStyles.back)
      };

      return _react2.default.createElement(
        'div',
        { className: 'react-card-flip', style: styles.container },
        _react2.default.createElement(
          'div',
          {
            className: 'react-card-flipper',
            style: styles.flipper
          },
          _react2.default.createElement(
            'div',
            { className: 'react-card-front', style: styles.front },
            this.getComponent('front')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-card-back', style: styles.back },
            this.getComponent('back')
          )
        )
      );
    }
  }]);

  return ReactCardFlip;
}(_react2.default.Component);

ReactCardFlip.propTypes = {
  cardStyles: _propTypes2.default.shape({
    front: _propTypes2.default.object,
    back: _propTypes2.default.object
  }),
  children: function children(props, propName, componentName) {
    if (_react2.default.Children.count(props[propName]) !== 2) {
      return new Error(componentName + ' requires two children.');
    }
    return null;
  },
  flipSpeedBackToFront: _propTypes2.default.number,
  flipSpeedFrontToBack: _propTypes2.default.number,
  infinite: _propTypes2.default.bool,
  isFlipped: _propTypes2.default.bool
};

ReactCardFlip.defaultProps = {
  cardStyles: {
    front: {},
    back: {}
  },
  flipSpeedBackToFront: 0.6,
  flipSpeedFrontToBack: 0.6,
  infinite: false,
  isFlipped: false
};

exports.default = ReactCardFlip;
module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(6);
} else {
  module.exports = __webpack_require__(7);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(1),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,unstable_ConcurrentMode:x,Suspense:z,unstable_Profiler:u,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),
g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},
isValidElement:O,version:"16.6.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.6.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

var _assign = __webpack_require__(1);
var checkPropTypes = __webpack_require__(3);

// TODO: this is special because it gets imported during build.

var ReactVersion = '16.6.0';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';

function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }
  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }
  return null;
}

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function () {};

{
  validateFormat = function (format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error = void 0;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

// Relying on the `invariant()` implementation lets us
// preserve the format and params in the www builds.

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warningWithoutStack = function () {};

{
  warningWithoutStack = function (condition, format) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    if (format === undefined) {
      throw new Error('`warningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (args.length > 8) {
      // Check before the condition to catch violations early.
      throw new Error('warningWithoutStack() currently supports at most 8 arguments.');
    }
    if (condition) {
      return;
    }
    if (typeof console !== 'undefined') {
      var _args$map = args.map(function (item) {
        return '' + item;
      }),
          a = _args$map[0],
          b = _args$map[1],
          c = _args$map[2],
          d = _args$map[3],
          e = _args$map[4],
          f = _args$map[5],
          g = _args$map[6],
          h = _args$map[7];

      var message = 'Warning: ' + format;

      // We intentionally don't use spread (or .apply) because it breaks IE9:
      // https://github.com/facebook/react/issues/13610
      switch (args.length) {
        case 0:
          console.error(message);
          break;
        case 1:
          console.error(message, a);
          break;
        case 2:
          console.error(message, a, b);
          break;
        case 3:
          console.error(message, a, b, c);
          break;
        case 4:
          console.error(message, a, b, c, d);
          break;
        case 5:
          console.error(message, a, b, c, d, e);
          break;
        case 6:
          console.error(message, a, b, c, d, e, f);
          break;
        case 7:
          console.error(message, a, b, c, d, e, f, g);
          break;
        case 8:
          console.error(message, a, b, c, d, e, f, g, h);
          break;
        default:
          throw new Error('warningWithoutStack() currently supports at most 8 arguments.');
      }
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      var argIndex = 0;
      var _message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      throw new Error(_message);
    } catch (x) {}
  };
}

var warningWithoutStack$1 = warningWithoutStack;

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + '.' + callerName;
    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }
    warningWithoutStack$1(false, "Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};
{
  Object.freeze(emptyObject);
}

/**
 * Base class helpers for the updating state of a component.
 */
function Component(props, context, updater) {
  this.props = props;
  this.context = context;
  // If a component has string refs, we will assign a different object later.
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
Component.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : void 0;
  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        lowPriorityWarning$1(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
        return undefined;
      }
    });
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;

/**
 * Convenience component with default shallow equality check for sCU.
 */
function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  // If a component has string refs, we will assign a different object later.
  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
// Avoid an extra prototype jump for these methods.
_assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };
  {
    Object.seal(refObject);
  }
  return refObject;
}

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null,
  currentDispatcher: null
};

var BEFORE_SLASH_RE = /^(.*)[\\\/]/;

var describeComponentFrame = function (name, source, ownerName) {
  var sourceInfo = '';
  if (source) {
    var path = source.fileName;
    var fileName = path.replace(BEFORE_SLASH_RE, '');
    {
      // In DEV, include code for a common special case:
      // prefer "folder/index.js" instead of just "index.js".
      if (/^index\./.test(fileName)) {
        var match = path.match(BEFORE_SLASH_RE);
        if (match) {
          var pathBeforeSlash = match[1];
          if (pathBeforeSlash) {
            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
            fileName = folderName + '/' + fileName;
          }
        }
      }
    }
    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
  } else if (ownerName) {
    sourceInfo = ' (created by ' + ownerName + ')';
  }
  return '\n    in ' + (name || 'Unknown') + sourceInfo;
};

var Resolved = 1;


function refineResolvedLazyComponent(lazyComponent) {
  return lazyComponent._status === Resolved ? lazyComponent._result : null;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + '(' + functionName + ')' : wrapperName);
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }
  {
    if (typeof type.tag === 'number') {
      warningWithoutStack$1(false, 'Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }
  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }
  if (typeof type === 'string') {
    return type;
  }
  switch (type) {
    case REACT_CONCURRENT_MODE_TYPE:
      return 'ConcurrentMode';
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';
    case REACT_PORTAL_TYPE:
      return 'Portal';
    case REACT_PROFILER_TYPE:
      return 'Profiler';
    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';
    case REACT_SUSPENSE_TYPE:
      return 'Suspense';
  }
  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        return 'Context.Consumer';
      case REACT_PROVIDER_TYPE:
        return 'Context.Provider';
      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');
      case REACT_MEMO_TYPE:
        return getComponentName(type.type);
      case REACT_LAZY_TYPE:
        {
          var thenable = type;
          var resolvedThenable = refineResolvedLazyComponent(thenable);
          if (resolvedThenable) {
            return getComponentName(resolvedThenable);
          }
        }
    }
  }
  return null;
}

var ReactDebugCurrentFrame = {};

var currentlyValidatingElement = null;

function setCurrentlyValidatingElement(element) {
  {
    currentlyValidatingElement = element;
  }
}

{
  // Stack implementation injected by the current renderer.
  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = '';

    // Add an extra top frame while an element is being validated
    if (currentlyValidatingElement) {
      var name = getComponentName(currentlyValidatingElement.type);
      var owner = currentlyValidatingElement._owner;
      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
    }

    // Delegate to the injected renderer-specific implementation
    var impl = ReactDebugCurrentFrame.getCurrentStack;
    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

var ReactSharedInternals = {
  ReactCurrentOwner: ReactCurrentOwner,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  _assign(ReactSharedInternals, {
    // These should not be included in production.
    ReactDebugCurrentFrame: ReactDebugCurrentFrame,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
}

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = warningWithoutStack$1;

{
  warning = function (condition, format) {
    if (condition) {
      return;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();
    // eslint-disable-next-line react-internal/warning-and-invariant-args

    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    warningWithoutStack$1.apply(undefined, [false, format + '%s'].concat(args, [stack]));
  };
}

var warning$1 = warning;

var hasOwnProperty = Object.prototype.hasOwnProperty;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown = void 0;
var specialPropRefWarningShown = void 0;

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
      warningWithoutStack$1(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
      warningWithoutStack$1(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    });
    // self and source are DEV only properties.
    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    });
    // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.
    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */
function createElement(type, config, children) {
  var propName = void 0;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }
      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}

/**
 * Return a function that produces ReactElements of a given type.
 * See https://reactjs.org/docs/react-api.html#createfactory
 */


function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
}

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */
function cloneElement(element, config, children) {
  !!(element === null || element === undefined) ? invariant(false, 'React.cloneElement(...): The argument must be a React element, but you passed %s.', element) : void 0;

  var propName = void 0;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps = void 0;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}

/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */
function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */
function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

var POOL_SIZE = 10;
var traverseContextPool = [];
function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
  if (traverseContextPool.length) {
    var traverseContext = traverseContextPool.pop();
    traverseContext.result = mapResult;
    traverseContext.keyPrefix = keyPrefix;
    traverseContext.func = mapFunction;
    traverseContext.context = mapContext;
    traverseContext.count = 0;
    return traverseContext;
  } else {
    return {
      result: mapResult,
      keyPrefix: keyPrefix,
      func: mapFunction,
      context: mapContext,
      count: 0
    };
  }
}

function releaseTraverseContext(traverseContext) {
  traverseContext.result = null;
  traverseContext.keyPrefix = null;
  traverseContext.func = null;
  traverseContext.context = null;
  traverseContext.count = 0;
  if (traverseContextPool.length < POOL_SIZE) {
    traverseContextPool.push(traverseContext);
  }
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;
      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }
    }
  }

  if (invokeCallback) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child = void 0;
  var nextName = void 0;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (typeof iteratorFn === 'function') {
      {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          !didWarnAboutMaps ? warning$1(false, 'Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.') : void 0;
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step = void 0;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';
      {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
      }
      var childrenString = '' + children;
      invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum);
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof component === 'object' && component !== null && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  releaseTraverseContext(traverseContext);
}

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function (c) {
      return c;
    });
  } else if (mappedChild != null) {
    if (isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  releaseTraverseContext(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children) {
  return traverseAllChildren(children, function () {
    return null;
  }, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, function (child) {
    return child;
  });
  return result;
}

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !isValidElement(children) ? invariant(false, 'React.Children.only expected to receive a single React element child.') : void 0;
  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      !(calculateChangedBits === null || typeof calculateChangedBits === 'function') ? warningWithoutStack$1(false, 'createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits) : void 0;
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // These are circular
    Provider: null,
    Consumer: null
  };

  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };

  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    };
    // $FlowFixMe: Flow complains about not setting a value, which is intentional here
    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;
            warning$1(false, 'Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }
          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;
            warning$1(false, 'Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }
          return context.Consumer;
        }
      }
    });
    // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

function lazy(ctor) {
  return {
    $$typeof: REACT_LAZY_TYPE,
    _ctor: ctor,
    // React uses these fields to store the result.
    _status: -1,
    _result: null
  };
}

function forwardRef(render) {
  {
    if (typeof render !== 'function') {
      warningWithoutStack$1(false, 'forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      !(
      // Do not warn for 0 arguments because it could be due to usage of the 'arguments' object
      render.length === 0 || render.length === 2) ? warningWithoutStack$1(false, 'forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.') : void 0;
    }

    if (render != null) {
      !(render.defaultProps == null && render.propTypes == null) ? warningWithoutStack$1(false, 'forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?') : void 0;
    }
  }

  return {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };
}

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      warningWithoutStack$1(false, 'memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }
  return {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };
}

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */

var propTypesMisspellWarningShown = void 0;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);
    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }
  return '';
}

function getSourceInfoErrorAddendum(elementProps) {
  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
    var source = elementProps.__source;
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      info = '\n\nCheck the top-level render call using <' + parentName + '>.';
    }
  }
  return info;
}

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }
  ownerHasKeyUseWarning[currentComponentErrorInfo] = true;

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  var childOwner = '';
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = ' It was passed a child from ' + getComponentName(element._owner.type) + '.';
  }

  setCurrentlyValidatingElement(element);
  {
    warning$1(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
  }
  setCurrentlyValidatingElement(null);
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step = void 0;
        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var type = element.type;
  var name = void 0,
      propTypes = void 0;
  if (typeof type === 'function') {
    // Class or function component
    name = type.displayName || type.name;
    propTypes = type.propTypes;
  } else if (typeof type === 'object' && type !== null && type.$$typeof === REACT_FORWARD_REF_TYPE) {
    // ForwardRef
    var functionName = type.render.displayName || type.render.name || '';
    name = type.displayName || (functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef');
    propTypes = type.propTypes;
  } else {
    return;
  }
  if (propTypes) {
    setCurrentlyValidatingElement(element);
    checkPropTypes(propTypes, element.props, 'prop', name, ReactDebugCurrentFrame.getStackAddendum);
    setCurrentlyValidatingElement(null);
  } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
    propTypesMisspellWarningShown = true;
    warningWithoutStack$1(false, 'Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
  }
  if (typeof type.getDefaultProps === 'function') {
    !type.getDefaultProps.isReactClassApproved ? warningWithoutStack$1(false, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
  }
}

/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */
function validateFragmentProps(fragment) {
  setCurrentlyValidatingElement(fragment);

  var keys = Object.keys(fragment.props);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key !== 'children' && key !== 'key') {
      warning$1(false, 'Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
      break;
    }
  }

  if (fragment.ref !== null) {
    warning$1(false, 'Invalid attribute `ref` supplied to `React.Fragment`.');
  }

  setCurrentlyValidatingElement(null);
}

function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type);

  // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.
  if (!validType) {
    var info = '';
    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendum(props);
    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString = void 0;
    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = '<' + (getComponentName(type.type) || 'Unknown') + ' />';
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    warning$1(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
  }

  var element = createElement.apply(this, arguments);

  // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.
  if (element == null) {
    return element;
  }

  // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)
  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === REACT_FRAGMENT_TYPE) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}

function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;
  // Legacy hook: remove it
  {
    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        lowPriorityWarning$1(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}

function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);
  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }
  validatePropTypes(newElement);
  return newElement;
}

var React = {
  Children: {
    map: mapChildren,
    forEach: forEachChildren,
    count: countChildren,
    toArray: toArray,
    only: onlyChild
  },

  createRef: createRef,
  Component: Component,
  PureComponent: PureComponent,

  createContext: createContext,
  forwardRef: forwardRef,
  lazy: lazy,
  memo: memo,

  Fragment: REACT_FRAGMENT_TYPE,
  StrictMode: REACT_STRICT_MODE_TYPE,
  unstable_ConcurrentMode: REACT_CONCURRENT_MODE_TYPE,
  Suspense: REACT_SUSPENSE_TYPE,
  unstable_Profiler: REACT_PROFILER_TYPE,

  createElement: createElementWithValidation,
  cloneElement: cloneElementWithValidation,
  createFactory: createFactoryWithValidation,
  isValidElement: isValidElement,

  version: ReactVersion,

  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: ReactSharedInternals
};



var React$2 = Object.freeze({
	default: React
});

var React$3 = ( React$2 && React ) || React$2;

// TODO: decide on the top-level export form.
// This is hacky but makes it work with both Rollup and Jest.
var react = React$3.default || React$3;

module.exports = react;
  })();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(9)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(10)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var assign = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(2);
var checkPropTypes = __webpack_require__(3);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ })
/******/ ]);
});
//# sourceMappingURL=react-card-flip.js.map

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAAClCAYAAACgA2N7AAAAAXNSR0IArs4c6QAAB6xJREFUeAHt28GL3eUZBeDvu5PgMm6ECBaDiKtuUroQKXVVqLQY8R9oNehKi1WkNSKkLTppMSauRCRDcCFuCtFVBEGK0HbXQDeltkVLpa7U2E1rJ/fz9xu4YYyDM+9O5zyzcO6dOQM5z2sO9w7a2y4fxx978uZxZdzd+/j+aO2WNvrh3tv1u/yYbxMg8BUTGKN93Pr4oLf2jzH6xb7WXz93+un3vuyPOWV3/njg0SduW47+m+m7x3ZO+CoBAl97gTEuLBbtZy89t/7Xnbp8YSDue/iJGxZr7Ret9wemHziw0w/5GgEC+0pgc3p18eJ//7d86pUXTn20vdnnBuLHjz9+eLF54NXe+p3bQx4TILD/BUYbv+vtunvPnTn54artYvXg5MmTi8X/D24Yh5WIzwSyBOa/+2N8+vK8BavmVx/88/Knz0y/fLxr9Q2fCRDIE5g24AfzFqyab73FOP6TE98ci3Gp9762+obPBAhkCowxriz78uj5M7/+89YriLFozxqHzH8ZtCZwrcC8BWtt7Vfz1/uDj5y4cbON96cvfu4Xltf+kOcECOQITK8iRtu8ctOBzd6PTctgHHJurymBXQXmFwzj4MG7F22Me3ZNCxAgkCcwxg/n30EcyWuuMQECuwr0cdNieiFxeNegAAECcQLT7x2OTK8g+qG45goTILAHgX7o6n8otYe0CAECYQIGIuzg6hKoCBiIipYsgTABAxF2cHUJVAQMREVLlkCYgIEIO7i6BCoCBqKiJUsgTMBAhB1cXQIVAQNR0ZIlECZgIMIOri6BioCBqGjJEggTMBBhB1eXQEXAQFS0ZAmECRiIsIOrS6AiYCAqWrIEwgQMRNjB1SVQETAQFS1ZAmECBiLs4OoSqAgYiIqWLIEwAQMRdnB1CVQEDERFS5ZAmICBCDu4ugQqAgaioiVLIEzAQIQdXF0CFQEDUdGSJRAmYCDCDq4ugYqAgahoyRIIEzAQYQdXl0BFwEBUtGQJhAkYiLCDq0ugImAgKlqyBMIEDETYwdUlUBEwEBUtWQJhAgYi7ODqEqgIGIiKliyBMAEDEXZwdQlUBAxERUuWQJiAgQg7uLoEKgIGoqIlSyBMwECEHVxdAhUBA1HRkiUQJmAgwg6uLoGKgIGoaMkSCBMwEGEHV5dARcBAVLRkCYQJGIiwg6tLoCJgICpasgTCBAxE2MHVJVARMBAVLVkCYQIGIuzg6hKoCBiIipYsgTABAxF2cHUJVAQMREVLlkCYgIEIO7i6BCoCBqKiJUsgTMBAhB1cXQIVAQNR0ZIlECZgIMIOri6BioCBqGjJEggTMBBhB1eXQEXAQFS0ZAmECRiIsIOrS6AiYCAqWrIEwgQMRNjB1SVQETAQFS1ZAmECBiLs4OoSqAgYiIqWLIEwAQMRdnB1CVQEDERFS5ZAmICBCDu4ugQqAgaioiVLIEzAQIQdXF0CFQEDUdGSJRAmYCDCDq4ugYqAgahoyRIIEzAQYQdXl0BFwEBUtGQJhAkYiLCDq0ugImAgKlqyBMIEDETYwdUlUBEwEBUtWQJhAgYi7ODqEqgIGIiKliyBMAEDEXZwdQlUBAxERUuWQJiAgQg7uLoEKgIGoqIlSyBMwECEHVxdAhUBA1HRkiUQJmAgwg6uLoGKgIGoaMkSCBMwEGEHV5dARcBAVLRkCYQJGIiwg6tLoCJgICpasgTCBAxE2MHVJVARMBAVLVkCYQIGIuzg6hKoCBiIipYsgTABAxF2cHUJVAQMREVLlkCYgIEIO7i6BCoCBqKiJUsgTMBAhB1cXQIVAQNR0ZIlECZgIMIOri6BioCBqGjJEggTMBBhB1eXQEXAQFS0ZAmECRiIsIOrS6AiYCAqWrIEwgQMRNjB1SVQETAQFS1ZAmECBiLs4OoSqAgYiIqWLIEwAQMRdnB1CVQEDERFS5ZAmICBCDu4ugQqAgaioiVLIEzAQIQdXF0CFQEDUdGSJRAmYCDCDq4ugYqAgahoyRIIEzAQYQdXl0BFwEBUtGQJhAkYiLCDq0ugImAgKlqyBMIEDETYwdUlUBEwEBUtWQJhAgYi7ODqEqgIGIiKliyBMAEDEXZwdQlUBAxERUuWQJiAgQg7uLoEKgIGoqIlSyBMwECEHVxdAhUBA1HRkiUQJmAgwg6uLoGKwDQQ43LlB2QJEEgRGJcXY/QPUurqSYDA3gXmbZjfYry79x+RJEAgSODd+S3GxaDCqhIgsFeB3i8slmvNQOwVTI5AkMByXLm4OH96/S9T59eCeqtKgMDuAq+dP3tqfovR2rL3h0cb/9n9ZyQIENjvAvMWzJsw91yb/3HpD29/cvT27/6793bP/NwHAQK5Aovl+NHG2fXfzwJbAzE/+NMf3770rdu/c2Pr/dvzcx8ECEQKPH/u7PrpVfOttxirJ3+//rqHppcXL62e+0yAQJDAaBuf/Oudx7Y37tufrB7f/8iJX05vN55aPfeZAIH9LTC9MHhy48z6M9e2vPoWY/s3prcbbx29444LvfUjrfVbt3/PYwIE9o/AGOPNvuzHNp5f/+1OrXZ8BbE9ePynP7+1jX7vaO1701h8o/dxePp8aHvGYwIEvg4C4/LW/1rRx3tttDemv8uvnztz6m9f9if/DIkPyPL46waDAAAAAElFTkSuQmCC"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_countdown_now__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OnBoardingRedirect__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Timeout__ = __webpack_require__(1040);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecondFactoAuthentication=function(_Component){_inherits(SecondFactoAuthentication,_Component);function SecondFactoAuthentication(props){_classCallCheck(this,SecondFactoAuthentication);var _this=_possibleConstructorReturn(this,(SecondFactoAuthentication.__proto__||Object.getPrototypeOf(SecondFactoAuthentication)).call(this,props));_this.getConfirmedOrderId=function(){return _this.props.sendTwoFactorAuthorization&&_this.props.sendTwoFactorAuthorization.enable?_this.props.sendTwoFactorAuthorization.orderId:_this.props.confirmedOrderId;};_this.enableSendButton=function(event){_this.setState({couldSendToken:event.target.value.length>0,token:event.target.value});};_this.sendSMS=function(){if(_this.props.sendTwoFactorAuthorization&&_this.props.sendTwoFactorAuthorization.enable){_this.props.authorizeWithTokenMileage(_this.props.sendTwoFactorAuthorization.orderId,_this.state.token,_this.props.sendTwoFactorAuthorization.orderMileageId,_this.props.vendorId,_this.state.tryCounter>=3);}else{_this.props.authorizeWithToken(_this.getConfirmedOrderId(),_this.props.paymentSelected==='POINTS_ONLY'?null:_this.PaymentMoneyRequest(),// dadosdecartao
_this.state.token,1,false,_this.state.tryCounter>3);}_this.setState({tryCounter:Math.min(_this.state.tryCounter+1,3),token:''});};_this.resendSMS=function(){_this.setState({couldSendToken:false});_this.props.authorizeWithTokenResend(_this.getConfirmedOrderId(),_this.props.paymentSelected==='POINTS_ONLY'?null:_this.PaymentMoneyRequest(),_this.state.token,1,true);_this.setState({resend:true,timeUp:false,timerCompleted:false,key:_this.state.key+1,initialDate:Date.now(),couldSendToken:true,token:'',restartCountdown:true,countdownDate:null});};_this.closeModal=function(){_this.props.closeModal();};_this.sendCall=function(){_this.props.authorizeWithTokenResend(_this.getConfirmedOrderId(),_this.props.paymentSelected==='POINTS_ONLY'?null:_this.PaymentMoneyRequest(),_this.state.token,2,true);_this.setState({resend:true,timeUp:false,timerCompleted:false,key:_this.state.key+1,initialDate:Date.now(),couldSendToken:false,restartCountdown:true,countdownDate:null});};_this.PurchasePointsRequest=function(){return{CardBrandId:_this.props.cardBrand(),CardExpirationMonthDate:_this.props.creditCard.cardExpirationDateMonth,CardExpirationYearDate:_this.props.creditCard.cardExpirationDateYear,CardNumber:_this.props.creditCard.cardNumber,CardHolderCpfCnpj:_this.props.creditCard.cardHolderCpf,CatalogId:_this.props.catalog.id,NameOfCardHolder:_this.props.creditCard.cardHolderName,Parcels:_this.props.creditCard.installments,PointsCash:_this.props.paymentPoints,SecurityCode:_this.props.creditCard.cardCvv};};_this.PurchaseMoneyRequest=function(){var brand=_this.props.cardBrand();var validityDateParts=_this.props.creditCard.validityDate.split('/');var totalOrder=_this.props.payment.pointsCashConfig.totalOrder;var installment=_this.props.creditCard.installment||_this.props.payment.installments.items[2];var pointsCash=_this.props.onlyCash?installment.parcel*installment.parcelValue:totalOrder-_this.props.paymentPoints;return{CardBrandId:brand.id,CardExpirationMonthDate:validityDateParts[0],CardExpirationYearDate:validityDateParts[1],CardNumber:_this.props.creditCard.number.replace(/\s/g,''),CardHolderCpfCnpj:_this.props.participant.cpf.value,CatalogId:_this.props.catalog.id,NameOfCardHolder:_this.props.creditCard.personName,Parcels:installment.parcel,PointsCash:pointsCash,SecurityCode:_this.props.creditCard.cvv};};_this.PaymentMoneyRequest=function(){switch(_this.props.paymentSelected){case'PURCHASE_POINTS_ONLY':return _this.PurchasePointsRequest();default:return _this.PurchaseMoneyRequest();}};_this.completionist=function(){setTimeout(function(){_this.setState({timeUp:true,timerCompleted:true,secondFactorAuthConfirmated:null});},1000);if(_this.state.tryCounter>3){_this.props.closeModal();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'O c\xF3digo gerado expira em 00:00');};_this.renderer=function(_ref){var minutes=_ref.minutes,seconds=_ref.seconds,completed=_ref.completed;if(completed&&!_this.props.loadingResendToken&&_this.state.countdownDate!==null){return _this.completionist();}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'O c\xF3digo gerado expira em ',Object(__WEBPACK_IMPORTED_MODULE_4_react_countdown_now__["b" /* zeroPad */])(minutes,2),':',Object(__WEBPACK_IMPORTED_MODULE_4_react_countdown_now__["b" /* zeroPad */])(seconds,2));}};_this.state={couldSendToken:true,secondFactorAuthConfirmated:false,timeUp:false,token:'',initialDate:Date.now(),key:1,resend:true,timerCompleted:false,tryCounter:1,countdownDate:Date.now()+120000,restartCountdown:false};return _this;}_createClass(SecondFactoAuthentication,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// if (
//   (this.props.secondFactorAuthConfirmated !== prevProps.secondFactorAuthConfirmated ||
//   this.props.loadingResendToken !== prevProps.loadingResendToken) &&
//   (this.state.countdownDate === null &&
//     this.props.secondFactorAuthConfirmated &&
//     !this.props.loadingResendToken &&
//     this.state.restartCountdown)
// ) {
//   // eslint-disable-next-line react/no-did-update-set-state
//   this.setState({ countdownDate: Date.now() + 120000, restartCountdown: false })
// }
}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'580',height:'0',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto pos-absolute '+(this.props.secondFactorAuthConfirmated?'':'d-none'),style:{top:'-243px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 border-color-ui-3 border-bottom pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{id:'modalTitle'},'Valide seu Token - Tentativa ',this.state.tryCounter,' de 3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 text-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1 '+(this.state.timeUp&&this.state.resend||this.props.errorResend?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0'},'Enviamos um c\xF3digo de 6 d\xEDgitos via SMS',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Por favor, digite o c\xF3digo no campo abaixo.'),this.props.errorToken&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0 color-error'},'Token inv\xE1lido, por favor tente novamente.'),this.props.errorResend&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0 color-ui-2 color-error'},'N\xE3o foi poss\xEDvel renviar, por favor tente novamente.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-sms-confirmation',label:'C\xF3digo de verifica\xE7\xE3o',className:'form-field col-12 col-md-6 px-0',mask:[/\d/,/\d/,/\d/,/\d/,/\d/,/\d/],value:this.state.token,onChange:this.enableSendButton,disabled:this.props.isCreatingPurchase||this.props.loadingResendToken}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-send-sms-verification',name:'btn-send-sms-verification',className:'btn btn-double btn-featured btn-rating-modal2 col-12 ml-0 ml-md-3',text:'Enviar',loading:this.props.isCreatingPurchase||this.props.loadingResendToken,disabled:!this.state.couldSendToken,onClick:function onClick(){return _this2.sendSMS();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 confirmation-alert py-2 pl-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius border-brand-1 border-left-lg border-color-brand-1 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_clock color-brand-1'})),this.props.isCreatingPurchase?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'countDownText',className:'color-brand-1 txt-circular-book txt-body-lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Estamos validando a sua tentativa !'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'countDownText',className:'color-brand-1 txt-circular-book txt-body-lg'},this.state.countdownDate===null||this.state.countdownDate<Date.now()||this.props.loadingResendToken?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'O c\xF3digo gerado expira em 02:00'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_countdown_now__["a" /* default */],{autoStart:true,key:this.state.key,date:this.state.countdownDate,renderer:this.renderer}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-none'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1 '+(this.state.timeUp||this.props.errorResend?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row color-ui-2 txt-font-body txt-body-sm product-rating mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-1 px-0'},'Enviamos um c\xF3digo de 6 d\xEDgitos via SMS',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Mas o tempo limite para valida\xE7\xE3o do c\xF3digo expirou.'),this.props.errorResend&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0 color-error'},'N\xE3o foi poss\xEDvel renviar, por favor tente novamente.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-featured btn-sm btn-cart btn-icon col-12 col-md-6',text:'Reenviar SMS',iconName:'icon_message',onClick:function onClick(){return _this2.resendSMS();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-featured btn-sm btn-cart btn-icon col-12 col-md-6 l-1',text:'Receber Liga\xE7\xE3o',iconName:'icon_call',onClick:function onClick(){return _this2.sendCall();}}))),!this.props.errorResend&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Timeout__["a" /* default */],null)))))),!this.props.secondFactorAuthConfirmated&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OnBoardingRedirect__["a" /* default */],{oidc:this.props.oidc,showOnboarding:this.props.show})));}}]);return SecondFactoAuthentication;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SecondFactoAuthentication.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isCreatingPurchase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,confirmedOrderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,authorizeWithTokenMileage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,authorizeWithToken:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,secondFactorAuthConfirmated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,closeModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,errorToken:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,errorResend:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,sendTwoFactorAuthorization:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,creditCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,catalog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,paymentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,cardBrand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,payment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,paymentPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,loadingResendToken:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,oidc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (SecondFactoAuthentication);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAddress; });
var inicialState={isLoading:false,hasError:false,cepError:false,streetType:'',street:'',district:'',city:'',state:'',zipCode:''};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:inicialState;var action=arguments[1];switch(action.type){case'FETCH_ADDRESS':return Object.assign({},state,{isLoading:true,hasError:false,cepError:false});case'FETCH_ADDRESS_SUCCESS':var _action$payload=action.payload,request=_action$payload.request,data=_action$payload.data;var zipCode=request.responseURL.split('/').pop();return Object.assign({},state,{isLoading:false},data,{zipCode:zipCode});case'FETCH_ADDRESS_FAIL':var cepError=!!action.error.response;var hasError=!cepError;return Object.assign({},inicialState,{isLoading:false,hasError:hasError,cepError:cepError});case'CLEAN_ERROR_ADDRESS':return Object.assign({},state,{cepError:false,hasError:false});case'RESET_CART_SHIPPING':return inicialState;case'SET_ADDRESS':return Object.assign({},state,{isLoading:false},action.address);default:return Object.assign({},state);}});var getAddress=function getAddress(_ref){var participant=_ref.participant,address=_ref.address;return{participant:participant,hasError:address.hasError,cepError:address.cepError,isLoading:address.isLoading,zipCode:participant.address&&participant.address.zipCode,number:participant.address&&participant.address.number,complement:participant.address&&participant.address.complement,reference:participant.address&&participant.address.reference,receiver:participant.name,street:{value:address.street,valueParticipant:participant.address.addressText.value,disabled:participant.address&&participant.address.addressText.disabled},streetType:{value:address.streetType,disabled:participant.address&&participant.address.addressText.disabled},district:{value:address.district,valueParticipant:participant.address.district.value,disabled:participant.address&&participant.address.district.disabled},city:{value:address.city,disabled:participant.address&&participant.address.city.disabled},state:{value:address.state,disabled:participant.address&&participant.address.state.disabled}};};

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileInfos__ = __webpack_require__(1044);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ProfileInfos__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Individual__ = __webpack_require__(1045);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Individual__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company__ = __webpack_require__(1220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Company__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(1221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Header__["a"]; });


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Address__ = __webpack_require__(487);
/* unused harmony reexport Address */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddressPage__ = __webpack_require__(1049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AddressPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form__ = __webpack_require__(1050);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Form__["a"]; });


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormPlaceholder__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Address=function(_Component){_inherits(Address,_Component);function Address(props){_classCallCheck(this,Address);var _this=_possibleConstructorReturn(this,(Address.__proto__||Object.getPrototypeOf(Address)).call(this,props));_this.error=function(){if(_this.props.participant.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:'Ops! N\xE3o foi poss\xEDvel salvar as suas informa\xE7\xF5es.',description:'Tente novamente mais tarde.',className:'pb-2',onClose:_this.props.closeAlert});}if(_this.props.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:'Ops! N\xE3o foi poss\xEDvel buscar seu CEP.',description:'Tente novamente mais tarde.',className:'pb-2',onClose:_this.props.closeAlert});}return'';};_this.state={formReady:false};return _this;}_createClass(Address,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.zipCode&&this.props.fetchShipping(this.props.zipCode.value);this.props.participant&&!this.props.participant.isLoading&&!this.props.isLoading&&setTimeout(function(){!_this2.state.formReady&&_this2.setState({formReady:true});},3000);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Meu endere\xE7o - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pl-2 pr-2 pt-0 pb-4 py-md-2 pt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell_LoggedSidebar__["a" /* default */],{selected:this.props.location.pathname,count:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-lg-8 mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.error(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step row px-1 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-title txt-font-body txt-initial color-title mr-auto'},'Endere\xE7o'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 pt-half border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_placeholder___default.a,{ready:this.state.formReady,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FormPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["b" /* Form */],this.props))))))))));}}]);return Address;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string});Address.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,hasError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,street:valueType,streetType:valueType,district:valueType,city:valueType,state:valueType,zipCode:valueType,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,updateAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,closeAlert:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Address);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Profile__ = __webpack_require__(489);
/* unused harmony reexport Profile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfilePage__ = __webpack_require__(1051);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ProfilePage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Individual__ = __webpack_require__(1052);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Individual__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Company__ = __webpack_require__(1053);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Company__["a"]; });


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Profile=function(_Component){_inherits(Profile,_Component);function Profile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Profile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Profile.__proto__||Object.getPrototypeOf(Profile)).call.apply(_ref,[this].concat(args))),_this),_this.error=function(){return _this.props.participant.hasError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:'Ops! N\xE3o foi poss\xEDvel salvar as suas informa\xE7\xF5es.',description:'Tente novamente mais tarde.',className:'pb-2'}):'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Profile,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Meus dados - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pl-2 pr-2 pt-0 pb-4 pb-md-2 pt-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell_LoggedSidebar__["a" /* default */],{selected:this.props.location.pathname,count:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-lg-8 mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.error(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step row px-1 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-title txt-font-body txt-initial color-title mr-auto'},this.props.participant.isCompany?'Meus Dados':'Informações Pessoais'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 pt-half border-bottom border-color-ui-3'},this.props.participant.isCompany?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* Company */],this.props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["b" /* Individual */],this.props)))))))));}}]);return Profile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Profile.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}).isRequired,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({isCompany:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,hasError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export childrenPropType */
/* unused harmony export onSelectPropType */
/* unused harmony export selectedIndexPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(197);


function childrenPropType(props, propName, componentName) {
  var error;
  var tabsCount = 0;
  var panelsCount = 0;
  var tabListFound = false;
  var listTabs = [];
  var children = props[propName];
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) {
      if (child.props && child.props.children && typeof child.props.children === 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(child.props.children, function (listChild) {
          return listTabs.push(listChild);
        });
      }

      if (tabListFound) {
        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
      }

      tabListFound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) {
      if (!tabListFound || listTabs.indexOf(child) === -1) {
        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
      }

      tabsCount++;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      panelsCount++;
    }
  });

  if (!error && tabsCount !== panelsCount) {
    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
  }

  return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop && typeof prop !== 'function') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
  } else if (props.selectedIndex != null && prop == null) {
    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
  }

  return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop != null && typeof prop !== 'number') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
  } else if (props.defaultIndex != null && prop != null) {
    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
  }

  return error;
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
/* unused harmony export reset */
// Get a universally unique identifier
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function reset() {
  count = 0;
}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTabsCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPanelsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(197);


function getTabsCount(children) {
  var tabCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) panelCount++;
  });
  return panelCount;
}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var AccountStatementPlaceholder=function AccountStatementPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pl-0 my-2 zindex-low'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_loading txt-body-lg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block col-auto mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'px-2 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pl-0 my-2 zindex-low'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_loading txt-body-lg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block col-auto mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'px-2 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pl-0 my-2 zindex-low'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_loading txt-body-lg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block col-auto mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'px-2 mr-1 py-half radius bg-ui-3 mb-0'}))));};/* harmony default export */ __webpack_exports__["a"] = (AccountStatementPlaceholder);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var util = __webpack_require__(31);
var QueryParamSerializer = __webpack_require__(1112);
var Shape = __webpack_require__(150);
var populateHostPrefix = __webpack_require__(281).populateHostPrefix;

function buildRequest(req) {
  var operation = req.service.api.operations[req.operation];
  var httpRequest = req.httpRequest;
  httpRequest.headers['Content-Type'] =
    'application/x-www-form-urlencoded; charset=utf-8';
  httpRequest.params = {
    Version: req.service.api.apiVersion,
    Action: operation.name
  };

  // convert the request parameters into a list of query params,
  // e.g. Deeply.NestedParam.0.Name=value
  var builder = new QueryParamSerializer();
  builder.serialize(req.params, operation.input, function(name, value) {
    httpRequest.params[name] = value;
  });
  httpRequest.body = util.queryParamsToString(httpRequest.params);

  populateHostPrefix(req);
}

function extractError(resp) {
  var data, body = resp.httpResponse.body.toString();
  if (body.match('<UnknownOperationException')) {
    data = {
      Code: 'UnknownOperation',
      Message: 'Unknown operation ' + resp.request.operation
    };
  } else {
    try {
      data = new AWS.XML.Parser().parse(body);
    } catch (e) {
      data = {
        Code: resp.httpResponse.statusCode,
        Message: resp.httpResponse.statusMessage
      };
    }
  }

  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  var req = resp.request;
  var operation = req.service.api.operations[req.operation];
  var shape = operation.output || {};
  var origRules = shape;

  if (origRules.resultWrapper) {
    var tmp = Shape.create({type: 'structure'});
    tmp.members[origRules.resultWrapper] = shape;
    tmp.memberNames = [origRules.resultWrapper];
    util.property(shape, 'name', shape.resultWrapper);
    shape = tmp;
  }

  var parser = new AWS.XML.Parser();

  // TODO: Refactor XML Parser to parse RequestId from response.
  if (shape && shape.members && !shape.members._XAMZRequestId) {
    var requestIdShape = Shape.create(
      { type: 'string' },
      { api: { protocol: 'query' } },
      'requestId'
    );
    shape.members._XAMZRequestId = requestIdShape;
  }

  var data = parser.parse(resp.httpResponse.body.toString(), shape);
  resp.requestId = data._XAMZRequestId || data.requestId;

  if (data._XAMZRequestId) delete data._XAMZRequestId;

  if (origRules.resultWrapper) {
    if (data[origRules.resultWrapper]) {
      util.update(data, data[origRules.resultWrapper]);
      delete data[origRules.resultWrapper];
    }
  }

  resp.data = data;
}

/**
 * @api private
 */
module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var memoizedProperty = __webpack_require__(31).memoizedProperty;

function memoize(name, value, factory, nameTr) {
  memoizedProperty(this, nameTr(name), function() {
    return factory(name, value);
  });
}

function Collection(iterable, options, factory, nameTr, callback) {
  nameTr = nameTr || String;
  var self = this;

  for (var id in iterable) {
    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
      memoize.call(self, id, iterable[id], factory, nameTr);
      if (callback) callback(id, iterable[id]);
    }
  }
}

/**
 * @api private
 */
module.exports = Collection;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var Rest = __webpack_require__(199);
var Json = __webpack_require__(278);
var JsonBuilder = __webpack_require__(279);
var JsonParser = __webpack_require__(280);

function populateBody(req) {
  var builder = new JsonBuilder();
  var input = req.service.api.operations[req.operation].input;

  if (input.payload) {
    var params = {};
    var payloadShape = input.members[input.payload];
    params = req.params[input.payload];
    if (params === undefined) return;

    if (payloadShape.type === 'structure') {
      req.httpRequest.body = builder.build(params, payloadShape);
      applyContentTypeHeader(req);
    } else { // non-JSON payload
      req.httpRequest.body = params;
      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
        applyContentTypeHeader(req, true);
      }
    }
  } else {
    var body = builder.build(req.params, input);
    if (body !== '{}' || req.httpRequest.method !== 'GET') { //don't send empty body for GET method
      req.httpRequest.body = body;
    }
    applyContentTypeHeader(req);
  }
}

function applyContentTypeHeader(req, isBinary) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  if (!req.httpRequest.headers['Content-Type']) {
    var type = isBinary ? 'binary/octet-stream' : 'application/json';
    req.httpRequest.headers['Content-Type'] = type;
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on HEAD/DELETE
  if (['HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Json.extractError(resp);
}

function extractData(resp) {
  Rest.extractData(resp);

  var req = resp.request;
  var operation = req.service.api.operations[req.operation];
  var rules = req.service.api.operations[req.operation].output || {};
  var parser;
  var hasEventOutput = operation.hasEventOutput;

  if (rules.payload) {
    var payloadMember = rules.members[rules.payload];
    var body = resp.httpResponse.body;
    if (payloadMember.isEventStream) {
      parser = new JsonParser();
      resp.data[payload] = util.createEventStream(
        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body,
        parser,
        payloadMember
      );
    } else if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
      var parser = new JsonParser();
      resp.data[rules.payload] = parser.parse(body, payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[rules.payload] = body;
    } else {
      resp.data[rules.payload] = payloadMember.toType(body);
    }
  } else {
    var data = resp.data;
    Json.extractData(resp);
    resp.data = util.merge(data, resp.data);
  }
}

/**
 * @api private
 */
module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var util = __webpack_require__(31);
var Rest = __webpack_require__(199);

function populateBody(req) {
  var input = req.service.api.operations[req.operation].input;
  var builder = new AWS.XML.Builder();
  var params = req.params;

  var payload = input.payload;
  if (payload) {
    var payloadMember = input.members[payload];
    params = params[payload];
    if (params === undefined) return;

    if (payloadMember.type === 'structure') {
      var rootElement = payloadMember.name;
      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
    } else { // non-xml payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.toXML(params, input, input.name ||
      input.shape || util.string.upperFirst(req.operation) + 'Request');
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD
  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Rest.extractError(resp);

  var data;
  try {
    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
  } catch (e) {
    data = {
      Code: resp.httpResponse.statusCode,
      Message: resp.httpResponse.statusMessage
    };
  }

  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  Rest.extractData(resp);

  var parser;
  var req = resp.request;
  var body = resp.httpResponse.body;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  var hasEventOutput = operation.hasEventOutput;

  var payload = output.payload;
  if (payload) {
    var payloadMember = output.members[payload];
    if (payloadMember.isEventStream) {
      parser = new AWS.XML.Parser();
      resp.data[payload] = util.createEventStream(
        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body,
        parser,
        payloadMember
      );
    } else if (payloadMember.type === 'structure') {
      parser = new AWS.XML.Parser();
      resp.data[payload] = parser.parse(body.toString(), payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[payload] = body;
    } else {
      resp.data[payload] = payloadMember.toType(body);
    }
  } else if (body.length > 0) {
    parser = new AWS.XML.Parser();
    var data = parser.parse(body.toString(), output);
    util.update(resp.data, data);
  }
}

/**
 * @api private
 */
module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(495);
var Operation = __webpack_require__(499);
var Shape = __webpack_require__(150);
var Paginator = __webpack_require__(500);
var ResourceWaiter = __webpack_require__(501);

var util = __webpack_require__(31);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Api(api, options) {
  var self = this;
  api = api || {};
  options = options || {};
  options.api = this;

  api.metadata = api.metadata || {};

  property(this, 'isApi', true, false);
  property(this, 'apiVersion', api.metadata.apiVersion);
  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
  property(this, 'signingName', api.metadata.signingName);
  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
  property(this, 'signatureVersion', api.metadata.signatureVersion);
  property(this, 'jsonVersion', api.metadata.jsonVersion);
  property(this, 'targetPrefix', api.metadata.targetPrefix);
  property(this, 'protocol', api.metadata.protocol);
  property(this, 'timestampFormat', api.metadata.timestampFormat);
  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
  property(this, 'fullName', api.metadata.serviceFullName);
  property(this, 'serviceId', api.metadata.serviceId);

  memoizedProperty(this, 'className', function() {
    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
    if (!name) return null;

    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
    if (name === 'ElasticLoadBalancing') name = 'ELB';
    return name;
  });

  function addEndpointOperation(name, operation) {
    if (operation.endpointoperation === true) {
      property(self, 'endpointOperation', util.string.lowerFirst(name));
    }
  }

  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
    return new Operation(name, operation, options);
  }, util.string.lowerFirst, addEndpointOperation));

  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
    return Shape.create(shape, options);
  }));

  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
    return new Paginator(name, paginator, options);
  }));

  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
    return new ResourceWaiter(name, waiter, options);
  }, util.string.lowerFirst));

  if (options.documentation) {
    property(this, 'documentation', api.documentation);
    property(this, 'documentationUrl', api.documentationUrl);
  }
}

/**
 * @api private
 */
module.exports = Api;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(150);

var util = __webpack_require__(31);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Operation(name, operation, options) {
  var self = this;
  options = options || {};

  property(this, 'name', operation.name || name);
  property(this, 'api', options.api, false);

  operation.http = operation.http || {};
  property(this, 'endpoint', operation.endpoint);
  property(this, 'httpMethod', operation.http.method || 'POST');
  property(this, 'httpPath', operation.http.requestUri || '/');
  property(this, 'authtype', operation.authtype || '');
  property(
    this,
    'endpointDiscoveryRequired',
    operation.endpointdiscovery ?
      (operation.endpointdiscovery.required ? 'REQUIRED' : 'OPTIONAL') :
    'NULL'
  );

  memoizedProperty(this, 'input', function() {
    if (!operation.input) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.input, options);
  });

  memoizedProperty(this, 'output', function() {
    if (!operation.output) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.output, options);
  });

  memoizedProperty(this, 'errors', function() {
    var list = [];
    if (!operation.errors) return null;

    for (var i = 0; i < operation.errors.length; i++) {
      list.push(Shape.create(operation.errors[i], options));
    }

    return list;
  });

  memoizedProperty(this, 'paginator', function() {
    return options.api.paginators[name];
  });

  if (options.documentation) {
    property(this, 'documentation', operation.documentation);
    property(this, 'documentationUrl', operation.documentationUrl);
  }

  // idempotentMembers only tracks top-level input shapes
  memoizedProperty(this, 'idempotentMembers', function() {
    var idempotentMembers = [];
    var input = self.input;
    var members = input.members;
    if (!input.members) {
      return idempotentMembers;
    }
    for (var name in members) {
      if (!members.hasOwnProperty(name)) {
        continue;
      }
      if (members[name].isIdempotent === true) {
        idempotentMembers.push(name);
      }
    }
    return idempotentMembers;
  });

  memoizedProperty(this, 'hasEventOutput', function() {
    var output = self.output;
    return hasEventStream(output);
  });
}

function hasEventStream(topLevelShape) {
  var members = topLevelShape.members;
  var payload = topLevelShape.payload;

  if (!topLevelShape.members) {
    return false;
  }

  if (payload) {
    var payloadMember = members[payload];
    return payloadMember.isEventStream;
  }

  // check if any member is an event stream
  for (var name in members) {
    if (!members.hasOwnProperty(name)) {
      if (members[name].isEventStream === true) {
        return true;
      }
    }
  }
  return false;
}

/**
 * @api private
 */
module.exports = Operation;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var property = __webpack_require__(31).property;

function Paginator(name, paginator) {
  property(this, 'inputToken', paginator.input_token);
  property(this, 'limitKey', paginator.limit_key);
  property(this, 'moreResults', paginator.more_results);
  property(this, 'outputToken', paginator.output_token);
  property(this, 'resultKey', paginator.result_key);
}

/**
 * @api private
 */
module.exports = Paginator;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var property = util.property;

function ResourceWaiter(name, waiter, options) {
  options = options || {};
  property(this, 'name', name);
  property(this, 'api', options.api, false);

  if (waiter.operation) {
    property(this, 'operation', util.string.lowerFirst(waiter.operation));
  }

  var self = this;
  var keys = [
    'type',
    'description',
    'delay',
    'maxAttempts',
    'acceptors'
  ];

  keys.forEach(function(key) {
    var value = waiter[key];
    if (value) {
      property(self, key, value);
    }
  });
}

/**
 * @api private
 */
module.exports = ResourceWaiter;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
 *     Default to be false.
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */
AWS.SequentialExecutor = AWS.util.inherit({

  constructor: function SequentialExecutor() {
    this._events = {};
  },

  /**
   * @api private
   */
  listeners: function listeners(eventName) {
    return this._events[eventName] ? this._events[eventName].slice(0) : [];
  },

  on: function on(eventName, listener, toHead) {
    if (this._events[eventName]) {
      toHead ?
        this._events[eventName].unshift(listener) :
        this._events[eventName].push(listener);
    } else {
      this._events[eventName] = [listener];
    }
    return this;
  },

  onAsync: function onAsync(eventName, listener, toHead) {
    listener._isAsync = true;
    return this.on(eventName, listener, toHead);
  },

  removeListener: function removeListener(eventName, listener) {
    var listeners = this._events[eventName];
    if (listeners) {
      var length = listeners.length;
      var position = -1;
      for (var i = 0; i < length; ++i) {
        if (listeners[i] === listener) {
          position = i;
        }
      }
      if (position > -1) {
        listeners.splice(position, 1);
      }
    }
    return this;
  },

  removeAllListeners: function removeAllListeners(eventName) {
    if (eventName) {
      delete this._events[eventName];
    } else {
      this._events = {};
    }
    return this;
  },

  /**
   * @api private
   */
  emit: function emit(eventName, eventArgs, doneCallback) {
    if (!doneCallback) doneCallback = function() { };
    var listeners = this.listeners(eventName);
    var count = listeners.length;
    this.callListeners(listeners, eventArgs, doneCallback);
    return count > 0;
  },

  /**
   * @api private
   */
  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
    var self = this;
    var error = prevError || null;

    function callNextListener(err) {
      if (err) {
        error = AWS.util.error(error || new Error(), err);
        if (self._haltHandlersOnError) {
          return doneCallback.call(self, error);
        }
      }
      self.callListeners(listeners, args, doneCallback, error);
    }

    while (listeners.length > 0) {
      var listener = listeners.shift();
      if (listener._isAsync) { // asynchronous listener
        listener.apply(self, args.concat([callNextListener]));
        return; // stop here, callNextListener will continue
      } else { // synchronous listener
        try {
          listener.apply(self, args);
        } catch (err) {
          error = AWS.util.error(error || new Error(), err);
        }
        if (error && self._haltHandlersOnError) {
          doneCallback.call(self, error);
          return;
        }
      }
    }
    doneCallback.call(self, error);
  },

  /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */
  addListeners: function addListeners(listeners) {
    var self = this;

    // extract listeners if parameter is an SequentialExecutor object
    if (listeners._events) listeners = listeners._events;

    AWS.util.each(listeners, function(event, callbacks) {
      if (typeof callbacks === 'function') callbacks = [callbacks];
      AWS.util.arrayEach(callbacks, function(callback) {
        self.on(event, callback);
      });
    });

    return self;
  },

  /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */
  addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
    this[name] = callback;
    this.addListener(eventName, callback, toHead);
    return this;
  },

  /**
   * @api private
   */
  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
    callback._isAsync = true;
    return this.addNamedListener(name, eventName, callback, toHead);
  },

  /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */
  addNamedListeners: function addNamedListeners(callback) {
    var self = this;
    callback(
      function() {
        self.addNamedListener.apply(self, arguments);
      },
      function() {
        self.addNamedAsyncListener.apply(self, arguments);
      }
    );
    return this;
  }
});

/**
 * {on} is the prefered method.
 * @api private
 */
AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;

/**
 * @api private
 */
module.exports = AWS.SequentialExecutor;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */
AWS.Credentials = AWS.util.inherit({
  /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */
  constructor: function Credentials() {
    // hide secretAccessKey from being displayed with util.inspect
    AWS.util.hideProperties(this, ['secretAccessKey']);

    this.expired = false;
    this.expireTime = null;
    this.refreshCallbacks = [];
    if (arguments.length === 1 && typeof arguments[0] === 'object') {
      var creds = arguments[0].credentials || arguments[0];
      this.accessKeyId = creds.accessKeyId;
      this.secretAccessKey = creds.secretAccessKey;
      this.sessionToken = creds.sessionToken;
    } else {
      this.accessKeyId = arguments[0];
      this.secretAccessKey = arguments[1];
      this.sessionToken = arguments[2];
    }
  },

  /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */
  expiryWindow: 15,

  /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */
  needsRefresh: function needsRefresh() {
    var currentTime = AWS.util.date.getDate().getTime();
    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

    if (this.expireTime && adjustedTime > this.expireTime) {
      return true;
    } else {
      return this.expired || !this.accessKeyId || !this.secretAccessKey;
    }
  },

  /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */
  get: function get(callback) {
    var self = this;
    if (this.needsRefresh()) {
      this.refresh(function(err) {
        if (!err) self.expired = false; // reset expired flag
        if (callback) callback(err);
      });
    } else if (callback) {
      callback();
    }
  },

  /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */
  refresh: function refresh(callback) {
    this.expired = false;
    callback();
  },

  /**
   * @api private
   * @param callback
   */
  coalesceRefresh: function coalesceRefresh(callback, sync) {
    var self = this;
    if (self.refreshCallbacks.push(callback) === 1) {
      self.load(function onLoad(err) {
        AWS.util.arrayEach(self.refreshCallbacks, function(callback) {
          if (sync) {
            callback(err);
          } else {
            // callback could throw, so defer to ensure all callbacks are notified
            AWS.util.defer(function () {
              callback(err);
            });
          }
        });
        self.refreshCallbacks.length = 0;
      });
    }
  },

  /**
   * @api private
   * @param callback
   */
  load: function load(callback) {
    callback();
  }
});

/**
 * @api private
 */
AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
};

/**
 * @api private
 */
AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.getPromise;
  delete this.prototype.refreshPromise;
};

AWS.util.addPromises(AWS.Credentials);


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */
AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

  /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */
  constructor: function CredentialProviderChain(providers) {
    if (providers) {
      this.providers = providers;
    } else {
      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
    }
    this.resolveCallbacks = [];
  },

  /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */

  /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */
  resolve: function resolve(callback) {
    var self = this;
    if (self.providers.length === 0) {
      callback(new Error('No providers'));
      return self;
    }

    if (self.resolveCallbacks.push(callback) === 1) {
      var index = 0;
      var providers = self.providers.slice(0);

      function resolveNext(err, creds) {
        if ((!err && creds) || index === providers.length) {
          AWS.util.arrayEach(self.resolveCallbacks, function (callback) {
            callback(err, creds);
          });
          self.resolveCallbacks.length = 0;
          return;
        }

        var provider = providers[index++];
        if (typeof provider === 'function') {
          creds = provider.call();
        } else {
          creds = provider;
        }

        if (creds.get) {
          creds.get(function (getErr) {
            resolveNext(getErr, getErr ? null : creds);
          });
        } else {
          resolveNext(null, creds);
        }
      }

      resolveNext();
    }

    return self;
  }
});

/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () { return new AWS.ECSCredentials(); },
 *   function () { return new AWS.ProcessCredentials(); },
 *   function () { return new AWS.EC2MetadataCredentials() }
 * ]
 * ```
 */
AWS.CredentialProviderChain.defaultProviders = [];

/**
 * @api private
 */
AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
};

/**
 * @api private
 */
AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.resolvePromise;
};

AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;

/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */
AWS.Endpoint = inherit({

  /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */
  constructor: function Endpoint(endpoint, config) {
    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

    if (typeof endpoint === 'undefined' || endpoint === null) {
      throw new Error('Invalid endpoint: ' + endpoint);
    } else if (typeof endpoint !== 'string') {
      return AWS.util.copy(endpoint);
    }

    if (!endpoint.match(/^http/)) {
      var useSSL = config && config.sslEnabled !== undefined ?
        config.sslEnabled : AWS.config.sslEnabled;
      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
    }

    AWS.util.update(this, AWS.util.urlParse(endpoint));

    // Ensure the port property is set as an integer
    if (this.port) {
      this.port = parseInt(this.port, 10);
    } else {
      this.port = this.protocol === 'https:' ? 443 : 80;
    }
  }

});

/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */
AWS.HttpRequest = inherit({

  /**
   * @api private
   */
  constructor: function HttpRequest(endpoint, region) {
    endpoint = new AWS.Endpoint(endpoint);
    this.method = 'POST';
    this.path = endpoint.path || '/';
    this.headers = {};
    this.body = '';
    this.endpoint = endpoint;
    this.region = region;
    this._userAgent = '';
    this.setUserAgent();
  },

  /**
   * @api private
   */
  setUserAgent: function setUserAgent() {
    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
  },

  getUserAgentHeaderName: function getUserAgentHeaderName() {
    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
    return prefix + 'User-Agent';
  },

  /**
   * @api private
   */
  appendToUserAgent: function appendToUserAgent(agentPartial) {
    if (typeof agentPartial === 'string' && agentPartial) {
      this._userAgent += ' ' + agentPartial;
    }
    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
  },

  /**
   * @api private
   */
  getUserAgent: function getUserAgent() {
    return this._userAgent;
  },

  /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */
  pathname: function pathname() {
    return this.path.split('?', 1)[0];
  },

  /**
   * @return [String] the query string portion of the {path}
   */
  search: function search() {
    var query = this.path.split('?', 2)[1];
    if (query) {
      query = AWS.util.queryStringParse(query);
      return AWS.util.queryParamsToString(query);
    }
    return '';
  },

  /**
   * @api private
   * update httpRequest endpoint with endpoint string
   */
  updateEndpoint: function updateEndpoint(endpointStr) {
    var newEndpoint = new AWS.Endpoint(endpointStr);
    this.endpoint = newEndpoint;
    this.path = newEndpoint.path || '/';
  }
});

/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */
AWS.HttpResponse = inherit({

  /**
   * @api private
   */
  constructor: function HttpResponse() {
    this.statusCode = undefined;
    this.headers = {};
    this.body = undefined;
    this.streaming = false;
    this.stream = null;
  },

  /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */
  createUnbufferedStream: function createUnbufferedStream() {
    this.streaming = true;
    return this.stream;
  }
});


AWS.HttpClient = inherit({});

/**
 * @api private
 */
AWS.HttpClient.getInstance = function getInstance() {
  if (this.singleton === undefined) {
    this.singleton = new this();
  }
  return this.singleton;
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    var datetime = AWS.util.date.rfc822(date);

    this.request.headers['X-Amz-Date'] = datetime;

    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    this.request.headers['X-Amzn-Authorization'] =
      this.authorization(credentials, datetime);

  },

  authorization: function authorization(credentials) {
    return 'AWS3 ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'SignedHeaders=' + this.signedHeaders() + ',' +
      'Signature=' + this.signature(credentials);
  },

  signedHeaders: function signedHeaders() {
    var headers = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      headers.push(h.toLowerCase());
    });
    return headers.sort().join(';');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = this.request.headers;
    var parts = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
    });
    return parts.sort().join('\n') + '\n';
  },

  headersToSign: function headersToSign() {
    var headers = [];
    AWS.util.each(this.request.headers, function iterator(k) {
      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
        headers.push(k);
      }
    });
    return headers;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push('/');
    parts.push('');
    parts.push(this.canonicalHeaders());
    parts.push(this.request.body);
    return AWS.util.crypto.sha256(parts.join('\n'));
  }

});

/**
 * @api private
 */
module.exports = AWS.Signers.V3;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 508 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1151);
var util = __webpack_require__(1152);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(510);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1153);
exports.encode = exports.stringify = __webpack_require__(1154);


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GoogleOAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookOAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleOAuth__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FacebookOAuth__ = __webpack_require__(1186);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var GoogleOAuth = new __WEBPACK_IMPORTED_MODULE_0__GoogleOAuth__["a" /* default */]();
var FacebookOAuth = new __WEBPACK_IMPORTED_MODULE_1__FacebookOAuth__["a" /* default */]();

//# sourceMappingURL=index.js.map

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var packageInfo = __webpack_require__(1191);
var Platform = {
    userAgent: "aws-amplify/" + packageInfo.version + " js",
    product: '',
    navigator: null,
    isReactNative: false,
};
if (typeof navigator !== 'undefined' && navigator.product) {
    Platform.product = navigator.product || '';
    Platform.navigator = navigator || null;
    switch (navigator.product) {
        case 'ReactNative':
            Platform.userAgent = "aws-amplify/" + packageInfo.version + " react-native";
            Platform.isReactNative = true;
            break;
        default:
            Platform.userAgent = "aws-amplify/" + packageInfo.version + " js";
            Platform.isReactNative = false;
            break;
    }
}
/* harmony default export */ __webpack_exports__["a"] = (Platform);
//# sourceMappingURL=index.js.map

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BigInteger__ = __webpack_require__(517);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



 // necessary for crypto js



var randomBytes = function randomBytes(nBytes) {
	return __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(__WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.random(nBytes).toString(), 'hex');
};



var initN = 'FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1' + '29024E088A67CC74020BBEA63B139B22514A08798E3404DD' + 'EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245' + 'E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED' + 'EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D' + 'C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F' + '83655D23DCA3AD961C62F356208552BB9ED529077096966D' + '670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B' + 'E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9' + 'DE2BCBF6955817183995497CEA956AE515D2261898FA0510' + '15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64' + 'ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7' + 'ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B' + 'F12FFA06D98A0864D87602733EC86A64521F2B18177B200C' + 'BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31' + '43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF';

var newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';

/** @class */

var AuthenticationHelper = function () {
	/**
  * Constructs a new AuthenticationHelper object
  * @param {string} PoolName Cognito user pool name.
  */
	function AuthenticationHelper(PoolName) {
		_classCallCheck(this, AuthenticationHelper);

		this.N = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](initN, 16);
		this.g = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */]('2', 16);
		this.k = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](this.hexHash('00' + this.N.toString(16) + '0' + this.g.toString(16)), 16);

		this.smallAValue = this.generateRandomSmallA();
		this.getLargeAValue(function () {});

		this.infoBits = __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from('Caldera Derived Key', 'utf8');

		this.poolName = PoolName;
	}

	/**
  * @returns {BigInteger} small A, a random number
  */


	AuthenticationHelper.prototype.getSmallAValue = function getSmallAValue() {
		return this.smallAValue;
	};

	/**
  * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
  * @returns {void}
  */


	AuthenticationHelper.prototype.getLargeAValue = function getLargeAValue(callback) {
		var _this = this;

		if (this.largeAValue) {
			callback(null, this.largeAValue);
		} else {
			this.calculateA(this.smallAValue, function (err, largeAValue) {
				if (err) {
					callback(err, null);
				}

				_this.largeAValue = largeAValue;
				callback(null, _this.largeAValue);
			});
		}
	};

	/**
  * helper function to generate a random big integer
  * @returns {BigInteger} a random value.
  * @private
  */


	AuthenticationHelper.prototype.generateRandomSmallA = function generateRandomSmallA() {
		var hexRandom = randomBytes(128).toString('hex');

		var randomBigInt = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](hexRandom, 16);
		var smallABigInt = randomBigInt.mod(this.N);

		return smallABigInt;
	};

	/**
  * helper function to generate a random string
  * @returns {string} a random value.
  * @private
  */


	AuthenticationHelper.prototype.generateRandomString = function generateRandomString() {
		return randomBytes(40).toString('base64');
	};

	/**
  * @returns {string} Generated random value included in password hash.
  */


	AuthenticationHelper.prototype.getRandomPassword = function getRandomPassword() {
		return this.randomPassword;
	};

	/**
  * @returns {string} Generated random value included in devices hash.
  */


	AuthenticationHelper.prototype.getSaltDevices = function getSaltDevices() {
		return this.SaltToHashDevices;
	};

	/**
  * @returns {string} Value used to verify devices.
  */


	AuthenticationHelper.prototype.getVerifierDevices = function getVerifierDevices() {
		return this.verifierDevices;
	};

	/**
  * Generate salts and compute verifier.
  * @param {string} deviceGroupKey Devices to generate verifier for.
  * @param {string} username User to generate verifier for.
  * @param {nodeCallback<null>} callback Called with (err, null)
  * @returns {void}
  */


	AuthenticationHelper.prototype.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
		var _this2 = this;

		this.randomPassword = this.generateRandomString();
		var combinedString = '' + deviceGroupKey + username + ':' + this.randomPassword;
		var hashedString = this.hash(combinedString);

		var hexRandom = randomBytes(16).toString('hex');
		this.SaltToHashDevices = this.padHex(new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](hexRandom, 16));

		this.g.modPow(new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function (err, verifierDevicesNotPadded) {
			if (err) {
				callback(err, null);
			}

			_this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
			callback(null, null);
		});
	};

	/**
  * Calculate the client's public value A = g^a%N
  * with the generated random number a
  * @param {BigInteger} a Randomly generated small A.
  * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
  * @returns {void}
  * @private
  */


	AuthenticationHelper.prototype.calculateA = function calculateA(a, callback) {
		var _this3 = this;

		this.g.modPow(a, this.N, function (err, A) {
			if (err) {
				callback(err, null);
			}

			if (A.mod(_this3.N).equals(__WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */].ZERO)) {
				callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
			}

			callback(null, A);
		});
	};

	/**
  * Calculate the client's value U which is the hash of A and B
  * @param {BigInteger} A Large A value.
  * @param {BigInteger} B Server B value.
  * @returns {BigInteger} Computed U value.
  * @private
  */


	AuthenticationHelper.prototype.calculateU = function calculateU(A, B) {
		this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
		var finalU = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](this.UHexHash, 16);

		return finalU;
	};

	/**
  * Calculate a hash from a bitArray
  * @param {Buffer} buf Value to hash.
  * @returns {String} Hex-encoded hash.
  * @private
  */


	AuthenticationHelper.prototype.hash = function hash(buf) {
		var str = buf instanceof __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"] ? __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(buf) : buf;
		var hashHex = __WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256___default()(str).toString();

		return new Array(64 - hashHex.length).join('0') + hashHex;
	};

	/**
  * Calculate a hash from a hex string
  * @param {String} hexStr Value to hash.
  * @returns {String} Hex-encoded hash.
  * @private
  */


	AuthenticationHelper.prototype.hexHash = function hexHash(hexStr) {
		return this.hash(__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(hexStr, 'hex'));
	};

	/**
  * Standard hkdf algorithm
  * @param {Buffer} ikm Input key material.
  * @param {Buffer} salt Salt value.
  * @returns {Buffer} Strong key material.
  * @private
  */


	AuthenticationHelper.prototype.computehkdf = function computehkdf(ikm, salt) {
		var infoBitsWordArray = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].concat([this.infoBits, __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(String.fromCharCode(1), 'utf8')]));
		var ikmWordArray = ikm instanceof __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"] ? __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(ikm) : ikm;
		var saltWordArray = salt instanceof __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"] ? __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(salt) : salt;

		var prk = __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(ikmWordArray, saltWordArray);
		var hmac = __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(infoBitsWordArray, prk);
		return __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(hmac.toString(), 'hex').slice(0, 16);
	};

	/**
  * Calculates the final hkdf based on computed S value, and computed U value and the key
  * @param {String} username Username.
  * @param {String} password Password.
  * @param {BigInteger} serverBValue Server B value.
  * @param {BigInteger} salt Generated salt.
  * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
  * @returns {void}
  */


	AuthenticationHelper.prototype.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
		var _this4 = this;

		if (serverBValue.mod(this.N).equals(__WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */].ZERO)) {
			throw new Error('B cannot be zero.');
		}

		this.UValue = this.calculateU(this.largeAValue, serverBValue);

		if (this.UValue.equals(__WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */].ZERO)) {
			throw new Error('U cannot be zero.');
		}

		var usernamePassword = '' + this.poolName + username + ':' + password;
		var usernamePasswordHash = this.hash(usernamePassword);

		var xValue = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
		this.calculateS(xValue, serverBValue, function (err, sValue) {
			if (err) {
				callback(err, null);
			}

			var hkdf = _this4.computehkdf(__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(_this4.padHex(sValue), 'hex'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(_this4.padHex(_this4.UValue.toString(16)), 'hex'));

			callback(null, hkdf);
		});
	};

	/**
  * Calculates the S value used in getPasswordAuthenticationKey
  * @param {BigInteger} xValue Salted password hash value.
  * @param {BigInteger} serverBValue Server B value.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	AuthenticationHelper.prototype.calculateS = function calculateS(xValue, serverBValue, callback) {
		var _this5 = this;

		this.g.modPow(xValue, this.N, function (err, gModPowXN) {
			if (err) {
				callback(err, null);
			}

			var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
			intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function (err2, result) {
				if (err2) {
					callback(err2, null);
				}

				callback(null, result.mod(_this5.N));
			});
		});
	};

	/**
  * Return constant newPasswordRequiredChallengeUserAttributePrefix
  * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
  */


	AuthenticationHelper.prototype.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
		return newPasswordRequiredChallengeUserAttributePrefix;
	};

	/**
  * Converts a BigInteger (or hex string) to hex format padded with zeroes for hashing
  * @param {BigInteger|String} bigInt Number or string to pad.
  * @returns {String} Padded hex string.
  */


	AuthenticationHelper.prototype.padHex = function padHex(bigInt) {
		var hashStr = bigInt.toString(16);
		if (hashStr.length % 2 === 1) {
			hashStr = '0' + hashStr;
		} else if ('89ABCDEFabcdef'.indexOf(hashStr[0]) !== -1) {
			hashStr = '00' + hashStr;
		}
		return hashStr;
	};

	return AuthenticationHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthenticationHelper);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(96));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(96));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(96), __webpack_require__(515), __webpack_require__(1193));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow

/* harmony default export */ __webpack_exports__["a"] = (BigInteger);

/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */

// (public) Constructor
function BigInteger(a, b) {
	if (a != null) this.fromString(a, b);
}

// return new, unset BigInteger
function nbi() {
	return new BigInteger(null);
}

// Bits per digit
var dbits;

// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
	while (--n >= 0) {
		var v = x * this[i++] + w[j] + c;
		c = Math.floor(v / 0x4000000);
		w[j++] = v & 0x3ffffff;
	}
	return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
	var xl = x & 0x7fff,
	    xh = x >> 15;
	while (--n >= 0) {
		var l = this[i] & 0x7fff;
		var h = this[i++] >> 15;
		var m = xh * l + h * xl;
		l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
		c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
		w[j++] = l & 0x3fffffff;
	}
	return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
	var xl = x & 0x3fff,
	    xh = x >> 14;
	while (--n >= 0) {
		var l = this[i] & 0x3fff;
		var h = this[i++] >> 14;
		var m = xh * l + h * xl;
		l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
		c = (l >> 28) + (m >> 14) + xh * h;
		w[j++] = l & 0xfffffff;
	}
	return c;
}
var inBrowser = typeof navigator !== 'undefined';
if (inBrowser && j_lm && navigator.appName == 'Microsoft Internet Explorer') {
	BigInteger.prototype.am = am2;
	dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != 'Netscape') {
	BigInteger.prototype.am = am1;
	dbits = 26;
} else {
	// Mozilla/Netscape seems to prefer am3
	BigInteger.prototype.am = am3;
	dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;

var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;

// Digit conversions
var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var BI_RC = new Array();
var rr, vv;
rr = '0'.charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
	BI_RC[rr++] = vv;
}rr = 'a'.charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
	BI_RC[rr++] = vv;
}rr = 'A'.charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
	BI_RC[rr++] = vv;
}function int2char(n) {
	return BI_RM.charAt(n);
}
function intAt(s, i) {
	var c = BI_RC[s.charCodeAt(i)];
	return c == null ? -1 : c;
}

// (protected) copy this to r
function bnpCopyTo(r) {
	for (var i = this.t - 1; i >= 0; --i) {
		r[i] = this[i];
	}r.t = this.t;
	r.s = this.s;
}

// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
	this.t = 1;
	this.s = x < 0 ? -1 : 0;
	if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;
}

// return bigint initialized to value
function nbv(i) {
	var r = nbi();

	r.fromInt(i);

	return r;
}

// (protected) set from string and radix
function bnpFromString(s, b) {
	var k;
	if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
	this.t = 0;
	this.s = 0;
	var i = s.length,
	    mi = false,
	    sh = 0;
	while (--i >= 0) {
		var x = intAt(s, i);
		if (x < 0) {
			if (s.charAt(i) == '-') mi = true;
			continue;
		}
		mi = false;
		if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
			this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
			this[this.t++] = x >> this.DB - sh;
		} else this[this.t - 1] |= x << sh;
		sh += k;
		if (sh >= this.DB) sh -= this.DB;
	}
	this.clamp();
	if (mi) BigInteger.ZERO.subTo(this, this);
}

// (protected) clamp off excess high words
function bnpClamp() {
	var c = this.s & this.DM;
	while (this.t > 0 && this[this.t - 1] == c) {
		--this.t;
	}
}

// (public) return string representation in given radix
function bnToString(b) {
	if (this.s < 0) return '-' + this.negate().toString();
	var k;
	if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
	var km = (1 << k) - 1,
	    d,
	    m = false,
	    r = '',
	    i = this.t;
	var p = this.DB - i * this.DB % k;
	if (i-- > 0) {
		if (p < this.DB && (d = this[i] >> p) > 0) {
			m = true;
			r = int2char(d);
		}
		while (i >= 0) {
			if (p < k) {
				d = (this[i] & (1 << p) - 1) << k - p;
				d |= this[--i] >> (p += this.DB - k);
			} else {
				d = this[i] >> (p -= k) & km;
				if (p <= 0) {
					p += this.DB;
					--i;
				}
			}
			if (d > 0) m = true;
			if (m) r += int2char(d);
		}
	}
	return m ? r : '0';
}

// (public) -this
function bnNegate() {
	var r = nbi();

	BigInteger.ZERO.subTo(this, r);

	return r;
}

// (public) |this|
function bnAbs() {
	return this.s < 0 ? this.negate() : this;
}

// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
	var r = this.s - a.s;
	if (r != 0) return r;
	var i = this.t;
	r = i - a.t;
	if (r != 0) return this.s < 0 ? -r : r;
	while (--i >= 0) {
		if ((r = this[i] - a[i]) != 0) return r;
	}return 0;
}

// returns bit length of the integer x
function nbits(x) {
	var r = 1,
	    t;
	if ((t = x >>> 16) != 0) {
		x = t;
		r += 16;
	}
	if ((t = x >> 8) != 0) {
		x = t;
		r += 8;
	}
	if ((t = x >> 4) != 0) {
		x = t;
		r += 4;
	}
	if ((t = x >> 2) != 0) {
		x = t;
		r += 2;
	}
	if ((t = x >> 1) != 0) {
		x = t;
		r += 1;
	}
	return r;
}

// (public) return the number of bits in "this"
function bnBitLength() {
	if (this.t <= 0) return 0;
	return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}

// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
	var i;
	for (i = this.t - 1; i >= 0; --i) {
		r[i + n] = this[i];
	}for (i = n - 1; i >= 0; --i) {
		r[i] = 0;
	}r.t = this.t + n;
	r.s = this.s;
}

// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
	for (var i = n; i < this.t; ++i) {
		r[i - n] = this[i];
	}r.t = Math.max(this.t - n, 0);
	r.s = this.s;
}

// (protected) r = this << n
function bnpLShiftTo(n, r) {
	var bs = n % this.DB;
	var cbs = this.DB - bs;
	var bm = (1 << cbs) - 1;
	var ds = Math.floor(n / this.DB),
	    c = this.s << bs & this.DM,
	    i;
	for (i = this.t - 1; i >= 0; --i) {
		r[i + ds + 1] = this[i] >> cbs | c;
		c = (this[i] & bm) << bs;
	}
	for (i = ds - 1; i >= 0; --i) {
		r[i] = 0;
	}r[ds] = c;
	r.t = this.t + ds + 1;
	r.s = this.s;
	r.clamp();
}

// (protected) r = this >> n
function bnpRShiftTo(n, r) {
	r.s = this.s;
	var ds = Math.floor(n / this.DB);
	if (ds >= this.t) {
		r.t = 0;
		return;
	}
	var bs = n % this.DB;
	var cbs = this.DB - bs;
	var bm = (1 << bs) - 1;
	r[0] = this[ds] >> bs;
	for (var i = ds + 1; i < this.t; ++i) {
		r[i - ds - 1] |= (this[i] & bm) << cbs;
		r[i - ds] = this[i] >> bs;
	}
	if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
	r.t = this.t - ds;
	r.clamp();
}

// (protected) r = this - a
function bnpSubTo(a, r) {
	var i = 0,
	    c = 0,
	    m = Math.min(a.t, this.t);
	while (i < m) {
		c += this[i] - a[i];
		r[i++] = c & this.DM;
		c >>= this.DB;
	}
	if (a.t < this.t) {
		c -= a.s;
		while (i < this.t) {
			c += this[i];
			r[i++] = c & this.DM;
			c >>= this.DB;
		}
		c += this.s;
	} else {
		c += this.s;
		while (i < a.t) {
			c -= a[i];
			r[i++] = c & this.DM;
			c >>= this.DB;
		}
		c -= a.s;
	}
	r.s = c < 0 ? -1 : 0;
	if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
	r.t = i;
	r.clamp();
}

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
	var x = this.abs(),
	    y = a.abs();
	var i = x.t;
	r.t = i + y.t;
	while (--i >= 0) {
		r[i] = 0;
	}for (i = 0; i < y.t; ++i) {
		r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
	}r.s = 0;
	r.clamp();
	if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}

// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
	var x = this.abs();
	var i = r.t = 2 * x.t;
	while (--i >= 0) {
		r[i] = 0;
	}for (i = 0; i < x.t - 1; ++i) {
		var c = x.am(i, x[i], r, 2 * i, 0, 1);
		if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
			r[i + x.t] -= x.DV;
			r[i + x.t + 1] = 1;
		}
	}
	if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
	r.s = 0;
	r.clamp();
}

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
	var pm = m.abs();
	if (pm.t <= 0) return;
	var pt = this.abs();
	if (pt.t < pm.t) {
		if (q != null) q.fromInt(0);
		if (r != null) this.copyTo(r);
		return;
	}
	if (r == null) r = nbi();
	var y = nbi(),
	    ts = this.s,
	    ms = m.s;
	var nsh = this.DB - nbits(pm[pm.t - 1]);
	// normalize modulus
	if (nsh > 0) {
		pm.lShiftTo(nsh, y);
		pt.lShiftTo(nsh, r);
	} else {
		pm.copyTo(y);
		pt.copyTo(r);
	}
	var ys = y.t;
	var y0 = y[ys - 1];
	if (y0 == 0) return;
	var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
	var d1 = this.FV / yt,
	    d2 = (1 << this.F1) / yt,
	    e = 1 << this.F2;
	var i = r.t,
	    j = i - ys,
	    t = q == null ? nbi() : q;
	y.dlShiftTo(j, t);
	if (r.compareTo(t) >= 0) {
		r[r.t++] = 1;
		r.subTo(t, r);
	}
	BigInteger.ONE.dlShiftTo(ys, t);
	t.subTo(y, y);
	// "negative" y so we can replace sub with am later
	while (y.t < ys) {
		y[y.t++] = 0;
	}while (--j >= 0) {
		// Estimate quotient digit
		var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
		if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
			// Try it out
			y.dlShiftTo(j, t);
			r.subTo(t, r);
			while (r[i] < --qd) {
				r.subTo(t, r);
			}
		}
	}
	if (q != null) {
		r.drShiftTo(ys, q);
		if (ts != ms) BigInteger.ZERO.subTo(q, q);
	}
	r.t = ys;
	r.clamp();
	if (nsh > 0) r.rShiftTo(nsh, r);
	// Denormalize remainder
	if (ts < 0) BigInteger.ZERO.subTo(r, r);
}

// (public) this mod a
function bnMod(a) {
	var r = nbi();
	this.abs().divRemTo(a, null, r);
	if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
	return r;
}

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
	if (this.t < 1) return 0;
	var x = this[0];
	if ((x & 1) == 0) return 0;
	var y = x & 3;
	// y == 1/x mod 2^2
	y = y * (2 - (x & 0xf) * y) & 0xf;
	// y == 1/x mod 2^4
	y = y * (2 - (x & 0xff) * y) & 0xff;
	// y == 1/x mod 2^8
	y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
	// y == 1/x mod 2^16
	// last step - calculate inverse mod DV directly;
	// assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
	y = y * (2 - x * y % this.DV) % this.DV;
	// y == 1/x mod 2^dbits
	// we really want the negative inverse, and -DV < y < DV
	return y > 0 ? this.DV - y : -y;
}

function bnEquals(a) {
	return this.compareTo(a) == 0;
}

// (protected) r = this + a
function bnpAddTo(a, r) {
	var i = 0,
	    c = 0,
	    m = Math.min(a.t, this.t);
	while (i < m) {
		c += this[i] + a[i];
		r[i++] = c & this.DM;
		c >>= this.DB;
	}
	if (a.t < this.t) {
		c += a.s;
		while (i < this.t) {
			c += this[i];
			r[i++] = c & this.DM;
			c >>= this.DB;
		}
		c += this.s;
	} else {
		c += this.s;
		while (i < a.t) {
			c += a[i];
			r[i++] = c & this.DM;
			c >>= this.DB;
		}
		c += a.s;
	}
	r.s = c < 0 ? -1 : 0;
	if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
	r.t = i;
	r.clamp();
}

// (public) this + a
function bnAdd(a) {
	var r = nbi();

	this.addTo(a, r);

	return r;
}

// (public) this - a
function bnSubtract(a) {
	var r = nbi();

	this.subTo(a, r);

	return r;
}

// (public) this * a
function bnMultiply(a) {
	var r = nbi();

	this.multiplyTo(a, r);

	return r;
}

// (public) this / a
function bnDivide(a) {
	var r = nbi();

	this.divRemTo(a, r, null);

	return r;
}

// Montgomery reduction
function Montgomery(m) {
	this.m = m;
	this.mp = m.invDigit();
	this.mpl = this.mp & 0x7fff;
	this.mph = this.mp >> 15;
	this.um = (1 << m.DB - 15) - 1;
	this.mt2 = 2 * m.t;
}

// xR mod m
function montConvert(x) {
	var r = nbi();
	x.abs().dlShiftTo(this.m.t, r);
	r.divRemTo(this.m, null, r);
	if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
	return r;
}

// x/R mod m
function montRevert(x) {
	var r = nbi();
	x.copyTo(r);
	this.reduce(r);
	return r;
}

// x = x/R mod m (HAC 14.32)
function montReduce(x) {
	while (x.t <= this.mt2) {
		// pad x so am has enough room later
		x[x.t++] = 0;
	}for (var i = 0; i < this.m.t; ++i) {
		// faster way of calculating u0 = x[i]*mp mod DV
		var j = x[i] & 0x7fff;
		var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
		// use am to combine the multiply-shift-add into one call
		j = i + this.m.t;
		x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
		// propagate carry
		while (x[j] >= x.DV) {
			x[j] -= x.DV;
			x[++j]++;
		}
	}
	x.clamp();
	x.drShiftTo(this.m.t, x);
	if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}

// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
	x.squareTo(r);

	this.reduce(r);
}

// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
	x.multiplyTo(y, r);

	this.reduce(r);
}

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;

// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
	var i = e.bitLength(),
	    k,
	    r = nbv(1),
	    z = new Montgomery(m);
	if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;

	// precomputation
	var g = new Array(),
	    n = 3,
	    k1 = k - 1,
	    km = (1 << k) - 1;
	g[1] = z.convert(this);
	if (k > 1) {
		var g2 = nbi();
		z.sqrTo(g[1], g2);
		while (n <= km) {
			g[n] = nbi();
			z.mulTo(g2, g[n - 2], g[n]);
			n += 2;
		}
	}

	var j = e.t - 1,
	    w,
	    is1 = true,
	    r2 = nbi(),
	    t;
	i = nbits(e[j]) - 1;
	while (j >= 0) {
		if (i >= k1) w = e[j] >> i - k1 & km;else {
			w = (e[j] & (1 << i + 1) - 1) << k1 - i;
			if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
		}

		n = k;
		while ((w & 1) == 0) {
			w >>= 1;
			--n;
		}
		if ((i -= n) < 0) {
			i += this.DB;
			--j;
		}
		if (is1) {
			// ret == 1, don't bother squaring or multiplying it
			g[w].copyTo(r);
			is1 = false;
		} else {
			while (n > 1) {
				z.sqrTo(r, r2);
				z.sqrTo(r2, r);
				n -= 2;
			}
			if (n > 0) z.sqrTo(r, r2);else {
				t = r;
				r = r2;
				r2 = t;
			}
			z.mulTo(r2, g[w], r);
		}

		while (j >= 0 && (e[j] & 1 << i) == 0) {
			z.sqrTo(r, r2);
			t = r;
			r = r2;
			r2 = t;
			if (--i < 0) {
				i = this.DB - 1;
				--j;
			}
		}
	}
	var result = z.revert(r);
	callback(null, result);
	return result;
}

// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;

// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;

// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__ = __webpack_require__(519);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoAccessToken = function (_CognitoJwtToken) {
  _inherits(CognitoAccessToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */
  function CognitoAccessToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        AccessToken = _ref.AccessToken;

    _classCallCheck(this, CognitoAccessToken);

    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, AccessToken || ''));
  }

  return CognitoAccessToken;
}(__WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CognitoAccessToken);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer___);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoJwtToken = function () {
	/**
  * Constructs a new CognitoJwtToken object
  * @param {string=} token The JWT token.
  */
	function CognitoJwtToken(token) {
		_classCallCheck(this, CognitoJwtToken);

		// Assign object
		this.jwtToken = token || '';
		this.payload = this.decodePayload();
	}

	/**
  * @returns {string} the record's token.
  */


	CognitoJwtToken.prototype.getJwtToken = function getJwtToken() {
		return this.jwtToken;
	};

	/**
  * @returns {int} the token's expiration (exp member).
  */


	CognitoJwtToken.prototype.getExpiration = function getExpiration() {
		return this.payload.exp;
	};

	/**
  * @returns {int} the token's "issued at" (iat member).
  */


	CognitoJwtToken.prototype.getIssuedAt = function getIssuedAt() {
		return this.payload.iat;
	};

	/**
  * @returns {object} the token's payload.
  */


	CognitoJwtToken.prototype.decodePayload = function decodePayload() {
		var payload = this.jwtToken.split('.')[1];
		try {
			return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(payload, 'base64').toString('utf8'));
		} catch (err) {
			return {};
		}
	};

	return CognitoJwtToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoJwtToken);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__ = __webpack_require__(519);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoIdToken = function (_CognitoJwtToken) {
  _inherits(CognitoIdToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */
  function CognitoIdToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        IdToken = _ref.IdToken;

    _classCallCheck(this, CognitoIdToken);

    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, IdToken || ''));
  }

  return CognitoIdToken;
}(__WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CognitoIdToken);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoRefreshToken = function () {
  /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */
  function CognitoRefreshToken() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        RefreshToken = _ref.RefreshToken;

    _classCallCheck(this, CognitoRefreshToken);

    // Assign object
    this.token = RefreshToken || '';
  }

  /**
   * @returns {string} the record's token.
   */


  CognitoRefreshToken.prototype.getToken = function getToken() {
    return this.token;
  };

  return CognitoRefreshToken;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoRefreshToken);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BigInteger__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CognitoAccessToken__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CognitoIdToken__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CognitoRefreshToken__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CognitoUserSession__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DateHelper__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CognitoUserAttribute__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StorageHelper__ = __webpack_require__(526);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



 // necessary for crypto js













/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */

/**
 * @callback onFailure
 * @param {*} err Failure reason.
 */

/**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */

/**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */

/**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */

/**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */

/**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */

/** @class */

var CognitoUser = function () {
	/**
  * Constructs a new CognitoUser object
  * @param {object} data Creation options
  * @param {string} data.Username The user's username.
  * @param {CognitoUserPool} data.Pool Pool containing the user.
  * @param {object} data.Storage Optional storage object.
  */
	function CognitoUser(data) {
		_classCallCheck(this, CognitoUser);

		if (data == null || data.Username == null || data.Pool == null) {
			throw new Error('Username and pool information are required.');
		}

		this.username = data.Username || '';
		this.pool = data.Pool;
		this.Session = null;

		this.client = data.Pool.client;

		this.signInUserSession = null;
		this.authenticationFlowType = 'USER_SRP_AUTH';

		this.storage = data.Storage || new __WEBPACK_IMPORTED_MODULE_13__StorageHelper__["a" /* default */]().getStorage();

		this.keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
		this.userDataKey = this.keyPrefix + '.' + this.username + '.userData';
	}

	/**
  * Sets the session for this user
  * @param {CognitoUserSession} signInUserSession the session
  * @returns {void}
  */


	CognitoUser.prototype.setSignInUserSession = function setSignInUserSession(signInUserSession) {
		this.clearCachedUserData();
		this.signInUserSession = signInUserSession;
		this.cacheTokens();
	};

	/**
  * @returns {CognitoUserSession} the current session for this user
  */


	CognitoUser.prototype.getSignInUserSession = function getSignInUserSession() {
		return this.signInUserSession;
	};

	/**
  * @returns {string} the user's username
  */


	CognitoUser.prototype.getUsername = function getUsername() {
		return this.username;
	};

	/**
  * @returns {String} the authentication flow type
  */


	CognitoUser.prototype.getAuthenticationFlowType = function getAuthenticationFlowType() {
		return this.authenticationFlowType;
	};

	/**
  * sets authentication flow type
  * @param {string} authenticationFlowType New value.
  * @returns {void}
  */


	CognitoUser.prototype.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
		this.authenticationFlowType = authenticationFlowType;
	};

	/**
  * This is used for authenticating the user through the custom authentication flow.
  * @param {AuthenticationDetails} authDetails Contains the authentication data
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *        response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */


	CognitoUser.prototype.initiateAuth = function initiateAuth(authDetails, callback) {
		var _this = this;

		var authParameters = authDetails.getAuthParameters();
		authParameters.USERNAME = this.username;

		var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();

		var jsonReq = {
			AuthFlow: 'CUSTOM_AUTH',
			ClientId: this.pool.getClientId(),
			AuthParameters: authParameters,
			ClientMetadata: clientMetaData
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}

		this.client.request('InitiateAuth', jsonReq, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}
			var challengeName = data.ChallengeName;
			var challengeParameters = data.ChallengeParameters;

			if (challengeName === 'CUSTOM_CHALLENGE') {
				_this.Session = data.Session;
				return callback.customChallenge(challengeParameters);
			}
			_this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
			_this.cacheTokens();
			return callback.onSuccess(_this.signInUserSession);
		});
	};

	/**
  * This is used for authenticating the user.
  * stuff
  * @param {AuthenticationDetails} authDetails Contains the authentication data
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {newPasswordRequired} callback.newPasswordRequired new
  *        password and any required attributes are required to continue
  * @param {mfaRequired} callback.mfaRequired MFA code
  *        required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *        response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */


	CognitoUser.prototype.authenticateUser = function authenticateUser(authDetails, callback) {
		if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') {
			return this.authenticateUserPlainUsernamePassword(authDetails, callback);
		} else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') {
			return this.authenticateUserDefaultAuth(authDetails, callback);
		}
		return callback.onFailure(new Error('Authentication flow type is invalid.'));
	};

	/**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * It calls the AuthenticationHelper for SRP related
  * stuff
  * @param {AuthenticationDetails} authDetails Contains the authentication data
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {newPasswordRequired} callback.newPasswordRequired new
  *        password and any required attributes are required to continue
  * @param {mfaRequired} callback.mfaRequired MFA code
  *        required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *        response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */


	CognitoUser.prototype.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
		var _this2 = this;

		var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
		var dateHelper = new __WEBPACK_IMPORTED_MODULE_11__DateHelper__["a" /* default */]();

		var serverBValue = void 0;
		var salt = void 0;
		var authParameters = {};

		if (this.deviceKey != null) {
			authParameters.DEVICE_KEY = this.deviceKey;
		}

		authParameters.USERNAME = this.username;
		authenticationHelper.getLargeAValue(function (errOnAValue, aValue) {
			// getLargeAValue callback start
			if (errOnAValue) {
				callback.onFailure(errOnAValue);
			}

			authParameters.SRP_A = aValue.toString(16);

			if (_this2.authenticationFlowType === 'CUSTOM_AUTH') {
				authParameters.CHALLENGE_NAME = 'SRP_A';
			}

			var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();

			var jsonReq = {
				AuthFlow: _this2.authenticationFlowType,
				ClientId: _this2.pool.getClientId(),
				AuthParameters: authParameters,
				ClientMetadata: clientMetaData
			};
			if (_this2.getUserContextData(_this2.username)) {
				jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
			}

			_this2.client.request('InitiateAuth', jsonReq, function (err, data) {
				if (err) {
					return callback.onFailure(err);
				}

				var challengeParameters = data.ChallengeParameters;

				_this2.username = challengeParameters.USER_ID_FOR_SRP;
				serverBValue = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SRP_B, 16);
				salt = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SALT, 16);
				_this2.getCachedDeviceKeyAndPassword();

				authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function (errOnHkdf, hkdf) {
					// getPasswordAuthenticationKey callback start
					if (errOnHkdf) {
						callback.onFailure(errOnHkdf);
					}

					var dateNow = dateHelper.getNowString();

					var message = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].concat([__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(_this2.username, 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(challengeParameters.SECRET_BLOCK, 'base64'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(dateNow, 'utf8')]));
					var key = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(hkdf);
					var signatureString = __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64___default.a.stringify(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(message, key));

					var challengeResponses = {};

					challengeResponses.USERNAME = _this2.username;
					challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
					challengeResponses.TIMESTAMP = dateNow;
					challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;

					if (_this2.deviceKey != null) {
						challengeResponses.DEVICE_KEY = _this2.deviceKey;
					}

					var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
						return _this2.client.request('RespondToAuthChallenge', challenge, function (errChallenge, dataChallenge) {
							if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
								challengeResponses.DEVICE_KEY = null;
								_this2.deviceKey = null;
								_this2.randomPassword = null;
								_this2.deviceGroupKey = null;
								_this2.clearCachedDeviceKeyAndPassword();
								return respondToAuthChallenge(challenge, challengeCallback);
							}
							return challengeCallback(errChallenge, dataChallenge);
						});
					};

					var jsonReqResp = {
						ChallengeName: 'PASSWORD_VERIFIER',
						ClientId: _this2.pool.getClientId(),
						ChallengeResponses: challengeResponses,
						Session: data.Session,
						ClientMetadata: clientMetaData
					};
					if (_this2.getUserContextData()) {
						jsonReqResp.UserContextData = _this2.getUserContextData();
					}
					respondToAuthChallenge(jsonReqResp, function (errAuthenticate, dataAuthenticate) {
						if (errAuthenticate) {
							return callback.onFailure(errAuthenticate);
						}

						return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
					});
					return undefined;
					// getPasswordAuthenticationKey callback end
				});
				return undefined;
			});
			// getLargeAValue callback end
		});
	};

	/**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * @param {AuthenticationDetails} authDetails Contains the authentication data.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {mfaRequired} callback.mfaRequired MFA code
  *        required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */


	CognitoUser.prototype.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
		var _this3 = this;

		var authParameters = {};
		authParameters.USERNAME = this.username;
		authParameters.PASSWORD = authDetails.getPassword();
		if (!authParameters.PASSWORD) {
			callback.onFailure(new Error('PASSWORD parameter is required'));
			return;
		}
		var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
		this.getCachedDeviceKeyAndPassword();
		if (this.deviceKey != null) {
			authParameters.DEVICE_KEY = this.deviceKey;
		}

		var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();

		var jsonReq = {
			AuthFlow: 'USER_PASSWORD_AUTH',
			ClientId: this.pool.getClientId(),
			AuthParameters: authParameters,
			ClientMetadata: clientMetaData
		};
		if (this.getUserContextData(this.username)) {
			jsonReq.UserContextData = this.getUserContextData(this.username);
		}
		// USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
		// Cognito UserPools verifies password and returns tokens.
		this.client.request('InitiateAuth', jsonReq, function (err, authResult) {
			if (err) {
				return callback.onFailure(err);
			}
			return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
		});
	};

	/**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * @param {object} dataAuthenticate authentication data
  * @param {object} authenticationHelper helper created
  * @param {callback} callback passed on from caller
  * @returns {void}
  */


	CognitoUser.prototype.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
		var _this4 = this;

		var challengeName = dataAuthenticate.ChallengeName;
		var challengeParameters = dataAuthenticate.ChallengeParameters;

		if (challengeName === 'SMS_MFA') {
			this.Session = dataAuthenticate.Session;
			return callback.mfaRequired(challengeName, challengeParameters);
		}

		if (challengeName === 'SELECT_MFA_TYPE') {
			this.Session = dataAuthenticate.Session;
			return callback.selectMFAType(challengeName, challengeParameters);
		}

		if (challengeName === 'MFA_SETUP') {
			this.Session = dataAuthenticate.Session;
			return callback.mfaSetup(challengeName, challengeParameters);
		}

		if (challengeName === 'SOFTWARE_TOKEN_MFA') {
			this.Session = dataAuthenticate.Session;
			return callback.totpRequired(challengeName, challengeParameters);
		}

		if (challengeName === 'CUSTOM_CHALLENGE') {
			this.Session = dataAuthenticate.Session;
			return callback.customChallenge(challengeParameters);
		}

		if (challengeName === 'NEW_PASSWORD_REQUIRED') {
			this.Session = dataAuthenticate.Session;

			var userAttributes = null;
			var rawRequiredAttributes = null;
			var requiredAttributes = [];
			var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

			if (challengeParameters) {
				userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
				rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
			}

			if (rawRequiredAttributes) {
				for (var i = 0; i < rawRequiredAttributes.length; i++) {
					requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
				}
			}
			return callback.newPasswordRequired(userAttributes, requiredAttributes);
		}

		if (challengeName === 'DEVICE_SRP_AUTH') {
			this.getDeviceResponse(callback);
			return undefined;
		}

		this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
		this.challengeName = challengeName;
		this.cacheTokens();

		var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
		if (newDeviceMetadata == null) {
			return callback.onSuccess(this.signInUserSession);
		}

		authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
			if (errGenHash) {
				return callback.onFailure(errGenHash);
			}

			var deviceSecretVerifierConfig = {
				Salt: __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
				PasswordVerifier: __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
			};

			_this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
			_this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
			_this4.randomPassword = authenticationHelper.getRandomPassword();

			_this4.client.request('ConfirmDevice', {
				DeviceKey: newDeviceMetadata.DeviceKey,
				AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
				DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
				DeviceName: navigator.userAgent
			}, function (errConfirm, dataConfirm) {
				if (errConfirm) {
					return callback.onFailure(errConfirm);
				}

				_this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
				_this4.cacheDeviceKeyAndPassword();
				if (dataConfirm.UserConfirmationNecessary === true) {
					return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
				}
				return callback.onSuccess(_this4.signInUserSession);
			});
			return undefined;
		});
		return undefined;
	};

	/**
  * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
  * Pass the new password with any new user attributes to be updated.
  * User attribute keys must be of format userAttributes.<attribute_name>.
  * @param {string} newPassword new password for this user
  * @param {object} requiredAttributeData map with values for all required attributes
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *         response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
		var _this5 = this;

		if (!newPassword) {
			return callback.onFailure(new Error('New password is required.'));
		}
		var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
		var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

		var finalUserAttributes = {};
		if (requiredAttributeData) {
			Object.keys(requiredAttributeData).forEach(function (key) {
				finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
			});
		}

		finalUserAttributes.NEW_PASSWORD = newPassword;
		finalUserAttributes.USERNAME = this.username;
		var jsonReq = {
			ChallengeName: 'NEW_PASSWORD_REQUIRED',
			ClientId: this.pool.getClientId(),
			ChallengeResponses: finalUserAttributes,
			Session: this.Session,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}

		this.client.request('RespondToAuthChallenge', jsonReq, function (errAuthenticate, dataAuthenticate) {
			if (errAuthenticate) {
				return callback.onFailure(errAuthenticate);
			}
			return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
		});
		return undefined;
	};

	/**
  * This is used to get a session using device authentication. It is called at the end of user
  * authentication
  *
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  * @private
  */


	CognitoUser.prototype.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
		var _this6 = this;

		var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.deviceGroupKey);
		var dateHelper = new __WEBPACK_IMPORTED_MODULE_11__DateHelper__["a" /* default */]();

		var authParameters = {};

		authParameters.USERNAME = this.username;
		authParameters.DEVICE_KEY = this.deviceKey;
		authenticationHelper.getLargeAValue(function (errAValue, aValue) {
			// getLargeAValue callback start
			if (errAValue) {
				callback.onFailure(errAValue);
			}

			authParameters.SRP_A = aValue.toString(16);

			var jsonReq = {
				ChallengeName: 'DEVICE_SRP_AUTH',
				ClientId: _this6.pool.getClientId(),
				ChallengeResponses: authParameters,
				ClientMetadata: clientMetadata
			};
			if (_this6.getUserContextData()) {
				jsonReq.UserContextData = _this6.getUserContextData();
			}
			_this6.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
				if (err) {
					return callback.onFailure(err);
				}

				var challengeParameters = data.ChallengeParameters;

				var serverBValue = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SRP_B, 16);
				var salt = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SALT, 16);

				authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function (errHkdf, hkdf) {
					// getPasswordAuthenticationKey callback start
					if (errHkdf) {
						return callback.onFailure(errHkdf);
					}

					var dateNow = dateHelper.getNowString();

					var message = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].concat([__WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(_this6.deviceGroupKey, 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(_this6.deviceKey, 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(challengeParameters.SECRET_BLOCK, 'base64'), __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(dateNow, 'utf8')]));
					var key = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(hkdf);
					var signatureString = __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64___default.a.stringify(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(message, key));

					var challengeResponses = {};

					challengeResponses.USERNAME = _this6.username;
					challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
					challengeResponses.TIMESTAMP = dateNow;
					challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
					challengeResponses.DEVICE_KEY = _this6.deviceKey;

					var jsonReqResp = {
						ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
						ClientId: _this6.pool.getClientId(),
						ChallengeResponses: challengeResponses,
						Session: data.Session
					};
					if (_this6.getUserContextData()) {
						jsonReqResp.UserContextData = _this6.getUserContextData();
					}

					_this6.client.request('RespondToAuthChallenge', jsonReqResp, function (errAuthenticate, dataAuthenticate) {
						if (errAuthenticate) {
							return callback.onFailure(errAuthenticate);
						}

						_this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
						_this6.cacheTokens();

						return callback.onSuccess(_this6.signInUserSession);
					});
					return undefined;
					// getPasswordAuthenticationKey callback end
				});
				return undefined;
			});
			// getLargeAValue callback end
		});
	};

	/**
  * This is used for a certain user to confirm the registration by using a confirmation code
  * @param {string} confirmationCode Code entered by user.
  * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
		var jsonReq = {
			ClientId: this.pool.getClientId(),
			ConfirmationCode: confirmationCode,
			Username: this.username,
			ForceAliasCreation: forceAliasCreation,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}
		this.client.request('ConfirmSignUp', jsonReq, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
	};

	/**
  * This is used by the user once he has the responses to a custom challenge
  * @param {string} answerChallenge The custom challenge answer.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {customChallenge} callback.customChallenge
  *    Custom challenge response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
		var _this7 = this;

		var challengeResponses = {};
		challengeResponses.USERNAME = this.username;
		challengeResponses.ANSWER = answerChallenge;

		var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
		this.getCachedDeviceKeyAndPassword();
		if (this.deviceKey != null) {
			challengeResponses.DEVICE_KEY = this.deviceKey;
		}

		var jsonReq = {
			ChallengeName: 'CUSTOM_CHALLENGE',
			ChallengeResponses: challengeResponses,
			ClientId: this.pool.getClientId(),
			Session: this.Session,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}
		this.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}

			return _this7.authenticateUserInternal(data, authenticationHelper, callback);
		});
	};

	/**
  * This is used by the user once he has an MFA code
  * @param {string} confirmationCode The MFA code entered by the user.
  * @param {object} callback Result callback map.
  * @param {string} mfaType The mfa we are replying to.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
		var _this8 = this;

		var challengeResponses = {};
		challengeResponses.USERNAME = this.username;
		challengeResponses.SMS_MFA_CODE = confirmationCode;
		var mfaTypeSelection = mfaType || 'SMS_MFA';
		if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') {
			challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
		}

		if (this.deviceKey != null) {
			challengeResponses.DEVICE_KEY = this.deviceKey;
		}

		var jsonReq = {
			ChallengeName: mfaTypeSelection,
			ChallengeResponses: challengeResponses,
			ClientId: this.pool.getClientId(),
			Session: this.Session,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}

		this.client.request('RespondToAuthChallenge', jsonReq, function (err, dataAuthenticate) {
			if (err) {
				return callback.onFailure(err);
			}

			var challengeName = dataAuthenticate.ChallengeName;

			if (challengeName === 'DEVICE_SRP_AUTH') {
				_this8.getDeviceResponse(callback);
				return undefined;
			}

			_this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
			_this8.cacheTokens();

			if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
				return callback.onSuccess(_this8.signInUserSession);
			}

			var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](_this8.pool.getUserPoolId().split('_')[1]);
			authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
				if (errGenHash) {
					return callback.onFailure(errGenHash);
				}

				var deviceSecretVerifierConfig = {
					Salt: __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
					PasswordVerifier: __WEBPACK_IMPORTED_MODULE_0_buffer___["Buffer"].from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
				};

				_this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
				_this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
				_this8.randomPassword = authenticationHelper.getRandomPassword();

				_this8.client.request('ConfirmDevice', {
					DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
					AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
					DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
					DeviceName: navigator.userAgent
				}, function (errConfirm, dataConfirm) {
					if (errConfirm) {
						return callback.onFailure(errConfirm);
					}

					_this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
					_this8.cacheDeviceKeyAndPassword();
					if (dataConfirm.UserConfirmationNecessary === true) {
						return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
					}
					return callback.onSuccess(_this8.signInUserSession);
				});
				return undefined;
			});
			return undefined;
		});
	};

	/**
  * This is used by an authenticated user to change the current password
  * @param {string} oldUserPassword The current password.
  * @param {string} newUserPassword The requested new password.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('ChangePassword', {
			PreviousPassword: oldUserPassword,
			ProposedPassword: newUserPassword,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			ClientMetadata: clientMetadata
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used by an authenticated user to enable MFA for itself
  * @deprecated
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.enableMFA = function enableMFA(callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback(new Error('User is not authenticated'), null);
		}

		var mfaOptions = [];
		var mfaEnabled = {
			DeliveryMedium: 'SMS',
			AttributeName: 'phone_number'
		};
		mfaOptions.push(mfaEnabled);

		this.client.request('SetUserSettings', {
			MFAOptions: mfaOptions,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used by an authenticated user to enable MFA for itself
  * @param {IMfaSettings} smsMfaSettings the sms mfa settings
  * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('SetUserMFAPreference', {
			SMSMfaSettings: smsMfaSettings,
			SoftwareTokenMfaSettings: softwareTokenMfaSettings,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used by an authenticated user to disable MFA for itself
  * @deprecated
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.disableMFA = function disableMFA(callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback(new Error('User is not authenticated'), null);
		}

		var mfaOptions = [];

		this.client.request('SetUserSettings', {
			MFAOptions: mfaOptions,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used by an authenticated user to delete itself
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.deleteUser = function deleteUser(callback, clientMetadata) {
		var _this9 = this;

		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('DeleteUser', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			ClientMetadata: clientMetadata
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			_this9.clearCachedUser();
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
  */
	/**
  * This is used by an authenticated user to change a list of attributes
  * @param {AttributeArg[]} attributes A list of the new user attributes.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('UpdateUserAttributes', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			UserAttributes: attributes,
			ClientMetadata: clientMetadata
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used by an authenticated user to get a list of attributes
  * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.getUserAttributes = function getUserAttributes(callback) {
		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('GetUser', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err, userData) {
			if (err) {
				return callback(err, null);
			}

			var attributeList = [];

			for (var i = 0; i < userData.UserAttributes.length; i++) {
				var attribute = {
					Name: userData.UserAttributes[i].Name,
					Value: userData.UserAttributes[i].Value
				};
				var userAttribute = new __WEBPACK_IMPORTED_MODULE_12__CognitoUserAttribute__["a" /* default */](attribute);
				attributeList.push(userAttribute);
			}

			return callback(null, attributeList);
		});
		return undefined;
	};

	/**
  * This is used by an authenticated user to get the MFAOptions
  * @param {nodeCallback<MFAOptions>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.getMFAOptions = function getMFAOptions(callback) {
		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('GetUser', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err, userData) {
			if (err) {
				return callback(err, null);
			}

			return callback(null, userData.MFAOptions);
		});
		return undefined;
	};

	/**
  * This is used by an authenticated users to get the userData
  * @param {nodeCallback<UserData>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.getUserData = function getUserData(callback, params) {
		var _this10 = this;

		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			this.clearCachedUserData();
			return callback(new Error('User is not authenticated'), null);
		}

		var bypassCache = params ? params.bypassCache : false;

		var userData = this.storage.getItem(this.userDataKey);
		// get the cached user data

		if (!userData || bypassCache) {
			this.client.request('GetUser', {
				AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
			}, function (err, latestUserData) {
				if (err) {
					return callback(err, null);
				}
				_this10.cacheUserData(latestUserData);
				var refresh = _this10.signInUserSession.getRefreshToken();
				if (refresh && refresh.getToken()) {
					_this10.refreshSession(refresh, function (refreshError, data) {
						if (refreshError) {
							return callback(refreshError, null);
						}
						return callback(null, latestUserData);
					});
				} else {
					return callback(null, latestUserData);
				}
			});
		} else {
			try {
				return callback(null, JSON.parse(userData));
			} catch (err) {
				this.clearCachedUserData();
				return callback(err, null);
			}
		}
		return undefined;
	};

	/**
  * This is used by an authenticated user to delete a list of attributes
  * @param {string[]} attributeList Names of the attributes to delete.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.deleteAttributes = function deleteAttributes(attributeList, callback) {
		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			return callback(new Error('User is not authenticated'), null);
		}

		this.client.request('DeleteUserAttributes', {
			UserAttributeNames: attributeList,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, 'SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used by a user to resend a confirmation code
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
		var jsonReq = {
			ClientId: this.pool.getClientId(),
			Username: this.username,
			ClientMetadata: clientMetadata
		};

		this.client.request('ResendConfirmationCode', jsonReq, function (err, result) {
			if (err) {
				return callback(err, null);
			}
			return callback(null, result);
		});
	};

	/**
  * This is used to get a session, either from the session object
  * or from  the local storage, or by using a refresh token
  *
  * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.getSession = function getSession(callback) {
		if (this.username == null) {
			return callback(new Error('Username is null. Cannot retrieve a new session'), null);
		}

		if (this.signInUserSession != null && this.signInUserSession.isValid()) {
			return callback(null, this.signInUserSession);
		}

		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
		var idTokenKey = keyPrefix + '.idToken';
		var accessTokenKey = keyPrefix + '.accessToken';
		var refreshTokenKey = keyPrefix + '.refreshToken';
		var clockDriftKey = keyPrefix + '.clockDrift';

		if (this.storage.getItem(idTokenKey)) {
			var idToken = new __WEBPACK_IMPORTED_MODULE_8__CognitoIdToken__["a" /* default */]({
				IdToken: this.storage.getItem(idTokenKey)
			});
			var accessToken = new __WEBPACK_IMPORTED_MODULE_7__CognitoAccessToken__["a" /* default */]({
				AccessToken: this.storage.getItem(accessTokenKey)
			});
			var refreshToken = new __WEBPACK_IMPORTED_MODULE_9__CognitoRefreshToken__["a" /* default */]({
				RefreshToken: this.storage.getItem(refreshTokenKey)
			});
			var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;

			var sessionData = {
				IdToken: idToken,
				AccessToken: accessToken,
				RefreshToken: refreshToken,
				ClockDrift: clockDrift
			};
			var cachedSession = new __WEBPACK_IMPORTED_MODULE_10__CognitoUserSession__["a" /* default */](sessionData);
			if (cachedSession.isValid()) {
				this.signInUserSession = cachedSession;
				return callback(null, this.signInUserSession);
			}

			if (!refreshToken.getToken()) {
				return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
			}

			this.refreshSession(refreshToken, callback);
		} else {
			callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
		}

		return undefined;
	};

	/**
  * This uses the refreshToken to retrieve a new session
  * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
  * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
		var _this11 = this;

		var authParameters = {};
		authParameters.REFRESH_TOKEN = refreshToken.getToken();
		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
		var lastUserKey = keyPrefix + '.LastAuthUser';

		if (this.storage.getItem(lastUserKey)) {
			this.username = this.storage.getItem(lastUserKey);
			var deviceKeyKey = keyPrefix + '.' + this.username + '.deviceKey';
			this.deviceKey = this.storage.getItem(deviceKeyKey);
			authParameters.DEVICE_KEY = this.deviceKey;
		}

		var jsonReq = {
			ClientId: this.pool.getClientId(),
			AuthFlow: 'REFRESH_TOKEN_AUTH',
			AuthParameters: authParameters,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}
		this.client.request('InitiateAuth', jsonReq, function (err, authResult) {
			if (err) {
				if (err.code === 'NotAuthorizedException') {
					_this11.clearCachedUser();
				}
				return callback(err, null);
			}
			if (authResult) {
				var authenticationResult = authResult.AuthenticationResult;
				if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) {
					authenticationResult.RefreshToken = refreshToken.getToken();
				}
				_this11.signInUserSession = _this11.getCognitoUserSession(authenticationResult);
				_this11.cacheTokens();
				return callback(null, _this11.signInUserSession);
			}
			return undefined;
		});
	};

	/**
  * This is used to save the session tokens to local storage
  * @returns {void}
  */


	CognitoUser.prototype.cacheTokens = function cacheTokens() {
		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
		var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
		var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
		var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
		var clockDriftKey = keyPrefix + '.' + this.username + '.clockDrift';
		var lastUserKey = keyPrefix + '.LastAuthUser';

		this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
		this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
		this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
		this.storage.setItem(clockDriftKey, '' + this.signInUserSession.getClockDrift());
		this.storage.setItem(lastUserKey, this.username);
	};

	/**
  * This is to cache user data
  */


	CognitoUser.prototype.cacheUserData = function cacheUserData(userData) {
		this.storage.setItem(this.userDataKey, JSON.stringify(userData));
	};

	/**
  * This is to remove cached user data
  */


	CognitoUser.prototype.clearCachedUserData = function clearCachedUserData() {
		this.storage.removeItem(this.userDataKey);
	};

	CognitoUser.prototype.clearCachedUser = function clearCachedUser() {
		this.clearCachedTokens();
		this.clearCachedUserData();
	};

	/**
  * This is used to cache the device key and device group and device password
  * @returns {void}
  */


	CognitoUser.prototype.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
		var deviceKeyKey = keyPrefix + '.deviceKey';
		var randomPasswordKey = keyPrefix + '.randomPasswordKey';
		var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

		this.storage.setItem(deviceKeyKey, this.deviceKey);
		this.storage.setItem(randomPasswordKey, this.randomPassword);
		this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
	};

	/**
  * This is used to get current device key and device group and device password
  * @returns {void}
  */


	CognitoUser.prototype.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
		var deviceKeyKey = keyPrefix + '.deviceKey';
		var randomPasswordKey = keyPrefix + '.randomPasswordKey';
		var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

		if (this.storage.getItem(deviceKeyKey)) {
			this.deviceKey = this.storage.getItem(deviceKeyKey);
			this.randomPassword = this.storage.getItem(randomPasswordKey);
			this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
		}
	};

	/**
  * This is used to clear the device key info from local storage
  * @returns {void}
  */


	CognitoUser.prototype.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
		var deviceKeyKey = keyPrefix + '.deviceKey';
		var randomPasswordKey = keyPrefix + '.randomPasswordKey';
		var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';

		this.storage.removeItem(deviceKeyKey);
		this.storage.removeItem(randomPasswordKey);
		this.storage.removeItem(deviceGroupKeyKey);
	};

	/**
  * This is used to clear the session tokens from local storage
  * @returns {void}
  */


	CognitoUser.prototype.clearCachedTokens = function clearCachedTokens() {
		var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
		var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
		var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
		var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
		var lastUserKey = keyPrefix + '.LastAuthUser';
		var clockDriftKey = keyPrefix + '.' + this.username + '.clockDrift';

		this.storage.removeItem(idTokenKey);
		this.storage.removeItem(accessTokenKey);
		this.storage.removeItem(refreshTokenKey);
		this.storage.removeItem(lastUserKey);
		this.storage.removeItem(clockDriftKey);
	};

	/**
  * This is used to build a user session from tokens retrieved in the authentication result
  * @param {object} authResult Successful auth response from server.
  * @returns {CognitoUserSession} The new user session.
  * @private
  */


	CognitoUser.prototype.getCognitoUserSession = function getCognitoUserSession(authResult) {
		var idToken = new __WEBPACK_IMPORTED_MODULE_8__CognitoIdToken__["a" /* default */](authResult);
		var accessToken = new __WEBPACK_IMPORTED_MODULE_7__CognitoAccessToken__["a" /* default */](authResult);
		var refreshToken = new __WEBPACK_IMPORTED_MODULE_9__CognitoRefreshToken__["a" /* default */](authResult);

		var sessionData = {
			IdToken: idToken,
			AccessToken: accessToken,
			RefreshToken: refreshToken
		};

		return new __WEBPACK_IMPORTED_MODULE_10__CognitoUserSession__["a" /* default */](sessionData);
	};

	/**
  * This is used to initiate a forgot password request
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {inputVerificationCode?} callback.inputVerificationCode
  *    Optional callback raised instead of onSuccess with response data.
  * @param {onSuccess} callback.onSuccess Called on success.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.forgotPassword = function forgotPassword(callback, clientMetadata) {
		var jsonReq = {
			ClientId: this.pool.getClientId(),
			Username: this.username,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}
		this.client.request('ForgotPassword', jsonReq, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}
			if (typeof callback.inputVerificationCode === 'function') {
				return callback.inputVerificationCode(data);
			}
			return callback.onSuccess(data);
		});
	};

	/**
  * This is used to confirm a new password using a confirmationCode
  * @param {string} confirmationCode Code entered by user.
  * @param {string} newPassword Confirm new password.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<void>} callback.onSuccess Called on success.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
		var jsonReq = {
			ClientId: this.pool.getClientId(),
			Username: this.username,
			ConfirmationCode: confirmationCode,
			Password: newPassword,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}
		this.client.request('ConfirmForgotPassword', jsonReq, function (err) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess();
		});
	};

	/**
  * This is used to initiate an attribute confirmation request
  * @param {string} attributeName User attribute that needs confirmation.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */


	CognitoUser.prototype.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('GetUserAttributeVerificationCode', {
			AttributeName: attributeName,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			ClientMetadata: clientMetadata
		}, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}
			if (typeof callback.inputVerificationCode === 'function') {
				return callback.inputVerificationCode(data);
			}
			return callback.onSuccess();
		});
		return undefined;
	};

	/**
  * This is used to confirm an attribute using a confirmation code
  * @param {string} attributeName Attribute being confirmed.
  * @param {string} confirmationCode Code entered by user.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */


	CognitoUser.prototype.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('VerifyUserAttribute', {
			AttributeName: attributeName,
			Code: confirmationCode,
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess('SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used to get the device information using the current device key
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
  * @returns {void}
  */


	CognitoUser.prototype.getDevice = function getDevice(callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('GetDevice', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			DeviceKey: this.deviceKey
		}, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess(data);
		});
		return undefined;
	};

	/**
  * This is used to forget a specific device
  * @param {string} deviceKey Device key.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */


	CognitoUser.prototype.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('ForgetDevice', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			DeviceKey: deviceKey
		}, function (err) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess('SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used to forget the current device
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */


	CognitoUser.prototype.forgetDevice = function forgetDevice(callback) {
		var _this12 = this;

		this.forgetSpecificDevice(this.deviceKey, {
			onFailure: callback.onFailure,
			onSuccess: function onSuccess(result) {
				_this12.deviceKey = null;
				_this12.deviceGroupKey = null;
				_this12.randomPassword = null;
				_this12.clearCachedDeviceKeyAndPassword();
				return callback.onSuccess(result);
			}
		});
	};

	/**
  * This is used to set the device status as remembered
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */


	CognitoUser.prototype.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('UpdateDeviceStatus', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			DeviceKey: this.deviceKey,
			DeviceRememberedStatus: 'remembered'
		}, function (err) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess('SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used to set the device status as not remembered
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */


	CognitoUser.prototype.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('UpdateDeviceStatus', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			DeviceKey: this.deviceKey,
			DeviceRememberedStatus: 'not_remembered'
		}, function (err) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess('SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used to list all devices for a user
  *
  * @param {int} limit the number of devices returned in a call
  * @param {string} paginationToken the pagination token in case any was returned before
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
  * @returns {void}
  */


	CognitoUser.prototype.listDevices = function listDevices(limit, paginationToken, callback) {
		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('ListDevices', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
			Limit: limit,
			PaginationToken: paginationToken
		}, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}
			return callback.onSuccess(data);
		});
		return undefined;
	};

	/**
  * This is used to globally revoke all tokens issued to a user
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */


	CognitoUser.prototype.globalSignOut = function globalSignOut(callback) {
		var _this13 = this;

		if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
			return callback.onFailure(new Error('User is not authenticated'));
		}

		this.client.request('GlobalSignOut', {
			AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
		}, function (err) {
			if (err) {
				return callback.onFailure(err);
			}
			_this13.clearCachedUser();
			return callback.onSuccess('SUCCESS');
		});
		return undefined;
	};

	/**
  * This is used for the user to signOut of the application and clear the cached tokens.
  * @returns {void}
  */


	CognitoUser.prototype.signOut = function signOut() {
		this.signInUserSession = null;
		this.clearCachedUser();
	};

	/**
  * This is used by a user trying to select a given MFA
  * @param {string} answerChallenge the mfa the user wants
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
		var _this14 = this;

		var challengeResponses = {};
		challengeResponses.USERNAME = this.username;
		challengeResponses.ANSWER = answerChallenge;

		var jsonReq = {
			ChallengeName: 'SELECT_MFA_TYPE',
			ChallengeResponses: challengeResponses,
			ClientId: this.pool.getClientId(),
			Session: this.Session
		};
		if (this.getUserContextData()) {
			jsonReq.UserContextData = this.getUserContextData();
		}
		this.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
			if (err) {
				return callback.onFailure(err);
			}
			_this14.Session = data.Session;
			if (answerChallenge === 'SMS_MFA') {
				return callback.mfaRequired(data.challengeName, data.challengeParameters);
			}
			if (answerChallenge === 'SOFTWARE_TOKEN_MFA') {
				return callback.totpRequired(data.challengeName, data.challengeParameters);
			}
			return undefined;
		});
	};

	/**
  * This returns the user context data for advanced security feature.
  * @returns {void}
  */


	CognitoUser.prototype.getUserContextData = function getUserContextData() {
		var pool = this.pool;
		return pool.getUserContextData(this.username);
	};

	/**
  * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.associateSoftwareToken = function associateSoftwareToken(callback) {
		var _this15 = this;

		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			this.client.request('AssociateSoftwareToken', {
				Session: this.Session
			}, function (err, data) {
				if (err) {
					return callback.onFailure(err);
				}
				_this15.Session = data.Session;
				return callback.associateSecretCode(data.SecretCode);
			});
		} else {
			this.client.request('AssociateSoftwareToken', {
				AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
			}, function (err, data) {
				if (err) {
					return callback.onFailure(err);
				}
				return callback.associateSecretCode(data.SecretCode);
			});
		}
	};

	/**
  * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
  * @param {string} totpCode The MFA code entered by the user.
  * @param {string} friendlyDeviceName The device name we are assigning to the device.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */


	CognitoUser.prototype.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
		var _this16 = this;

		if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
			this.client.request('VerifySoftwareToken', {
				Session: this.Session,
				UserCode: totpCode,
				FriendlyDeviceName: friendlyDeviceName
			}, function (err, data) {
				if (err) {
					return callback.onFailure(err);
				}
				_this16.Session = data.Session;
				var challengeResponses = {};
				challengeResponses.USERNAME = _this16.username;
				var jsonReq = {
					ChallengeName: 'MFA_SETUP',
					ClientId: _this16.pool.getClientId(),
					ChallengeResponses: challengeResponses,
					Session: _this16.Session
				};
				if (_this16.getUserContextData()) {
					jsonReq.UserContextData = _this16.getUserContextData();
				}
				_this16.client.request('RespondToAuthChallenge', jsonReq, function (errRespond, dataRespond) {
					if (errRespond) {
						return callback.onFailure(errRespond);
					}
					_this16.signInUserSession = _this16.getCognitoUserSession(dataRespond.AuthenticationResult);
					_this16.cacheTokens();
					return callback.onSuccess(_this16.signInUserSession);
				});
				return undefined;
			});
		} else {
			this.client.request('VerifySoftwareToken', {
				AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
				UserCode: totpCode,
				FriendlyDeviceName: friendlyDeviceName
			}, function (err, data) {
				if (err) {
					return callback.onFailure(err);
				}
				return callback.onSuccess(data);
			});
		}
	};

	return CognitoUser;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUser);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserSession = function () {
	/**
  * Constructs a new CognitoUserSession object
  * @param {CognitoIdToken} IdToken The session's Id token.
  * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
  * @param {CognitoAccessToken} AccessToken The session's access token.
  * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
  */
	function CognitoUserSession() {
		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    IdToken = _ref.IdToken,
		    RefreshToken = _ref.RefreshToken,
		    AccessToken = _ref.AccessToken,
		    ClockDrift = _ref.ClockDrift;

		_classCallCheck(this, CognitoUserSession);

		if (AccessToken == null || IdToken == null) {
			throw new Error('Id token and Access Token must be present.');
		}

		this.idToken = IdToken;
		this.refreshToken = RefreshToken;
		this.accessToken = AccessToken;
		this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
	}

	/**
  * @returns {CognitoIdToken} the session's Id token
  */


	CognitoUserSession.prototype.getIdToken = function getIdToken() {
		return this.idToken;
	};

	/**
  * @returns {CognitoRefreshToken} the session's refresh token
  */


	CognitoUserSession.prototype.getRefreshToken = function getRefreshToken() {
		return this.refreshToken;
	};

	/**
  * @returns {CognitoAccessToken} the session's access token
  */


	CognitoUserSession.prototype.getAccessToken = function getAccessToken() {
		return this.accessToken;
	};

	/**
  * @returns {int} the session's clock drift
  */


	CognitoUserSession.prototype.getClockDrift = function getClockDrift() {
		return this.clockDrift;
	};

	/**
  * @returns {int} the computer's clock drift
  */


	CognitoUserSession.prototype.calculateClockDrift = function calculateClockDrift() {
		var now = Math.floor(new Date() / 1000);
		var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());

		return now - iat;
	};

	/**
  * Checks to see if the session is still valid based on session expiry information found
  * in tokens and the current time (adjusted with clock drift)
  * @returns {boolean} if the session is still valid
  */


	CognitoUserSession.prototype.isValid = function isValid() {
		var now = Math.floor(new Date() / 1000);
		var adjusted = now - this.clockDrift;

		return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
	};

	return CognitoUserSession;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUserSession);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** @class */

var DateHelper = function () {
	function DateHelper() {
		_classCallCheck(this, DateHelper);
	}

	/**
  * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
  */
	DateHelper.prototype.getNowString = function getNowString() {
		var now = new Date();

		var weekDay = weekNames[now.getUTCDay()];
		var month = monthNames[now.getUTCMonth()];
		var day = now.getUTCDate();

		var hours = now.getUTCHours();
		if (hours < 10) {
			hours = '0' + hours;
		}

		var minutes = now.getUTCMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes;
		}

		var seconds = now.getUTCSeconds();
		if (seconds < 10) {
			seconds = '0' + seconds;
		}

		var year = now.getUTCFullYear();

		// ddd MMM D HH:mm:ss UTC YYYY
		var dateNow = weekDay + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC ' + year;

		return dateNow;
	};

	return DateHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (DateHelper);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserAttribute = function () {
	/**
  * Constructs a new CognitoUserAttribute object
  * @param {string=} Name The record's name
  * @param {string=} Value The record's value
  */
	function CognitoUserAttribute() {
		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    Name = _ref.Name,
		    Value = _ref.Value;

		_classCallCheck(this, CognitoUserAttribute);

		this.Name = Name || '';
		this.Value = Value || '';
	}

	/**
  * @returns {string} the record's value.
  */


	CognitoUserAttribute.prototype.getValue = function getValue() {
		return this.Value;
	};

	/**
  * Sets the record's value.
  * @param {string} value The new value.
  * @returns {CognitoUserAttribute} The record for method chaining.
  */


	CognitoUserAttribute.prototype.setValue = function setValue(value) {
		this.Value = value;
		return this;
	};

	/**
  * @returns {string} the record's name.
  */


	CognitoUserAttribute.prototype.getName = function getName() {
		return this.Name;
	};

	/**
  * Sets the record's name
  * @param {string} name The new name.
  * @returns {CognitoUserAttribute} The record for method chaining.
  */


	CognitoUserAttribute.prototype.setName = function setName(name) {
		this.Name = name;
		return this;
	};

	/**
  * @returns {string} a string representation of the record.
  */


	CognitoUserAttribute.prototype.toString = function toString() {
		return JSON.stringify(this);
	};

	/**
  * @returns {object} a flat object representing the record.
  */


	CognitoUserAttribute.prototype.toJSON = function toJSON() {
		return {
			Name: this.Name,
			Value: this.Value
		};
	};

	return CognitoUserAttribute;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUserAttribute);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

var dataMemory = {};

/** @class */

var MemoryStorage = function () {
	function MemoryStorage() {
		_classCallCheck(this, MemoryStorage);
	}

	/**
  * This is used to set a specific item in storage
  * @param {string} key - the key for the item
  * @param {object} value - the value
  * @returns {string} value that was set
  */
	MemoryStorage.setItem = function setItem(key, value) {
		dataMemory[key] = value;
		return dataMemory[key];
	};

	/**
  * This is used to get a specific key from storage
  * @param {string} key - the key for the item
  * This is used to clear the storage
  * @returns {string} the data item
  */


	MemoryStorage.getItem = function getItem(key) {
		return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
	};

	/**
  * This is used to remove an item from storage
  * @param {string} key - the key being set
  * @returns {string} value - value that was deleted
  */


	MemoryStorage.removeItem = function removeItem(key) {
		return delete dataMemory[key];
	};

	/**
  * This is used to clear the storage
  * @returns {string} nothing
  */


	MemoryStorage.clear = function clear() {
		dataMemory = {};
		return dataMemory;
	};

	return MemoryStorage;
}();

/** @class */


var StorageHelper = function () {
	/**
  * This is used to get a storage object
  * @returns {object} the storage
  */
	function StorageHelper() {
		_classCallCheck(this, StorageHelper);

		try {
			this.storageWindow = window.localStorage;
			this.storageWindow.setItem('aws.cognito.test-ls', 1);
			this.storageWindow.removeItem('aws.cognito.test-ls');
		} catch (exception) {
			this.storageWindow = MemoryStorage;
		}
	}

	/**
  * This is used to return the storage
  * @returns {object} the storage
  */


	StorageHelper.prototype.getStorage = function getStorage() {
		return this.storageWindow;
	};

	return StorageHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (StorageHelper);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decode; });
var decode = function (str) {
  return global.atob(str);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoTokenScopes__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__ = __webpack_require__(288);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */






/** @class */

var CognitoAuthSession = function () {
  /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {array}  TokenScopes  The session's token scopes.
    * @param {string} State The session's state. 
   */
  function CognitoAuthSession() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        IdToken = _ref.IdToken,
        RefreshToken = _ref.RefreshToken,
        AccessToken = _ref.AccessToken,
        TokenScopes = _ref.TokenScopes,
        State = _ref.State;

    _classCallCheck(this, CognitoAuthSession);

    if (IdToken) {
      this.idToken = IdToken;
    } else {
      this.idToken = new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */]();
    }
    if (RefreshToken) {
      this.refreshToken = RefreshToken;
    } else {
      this.refreshToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__["a" /* default */]();
    }
    if (AccessToken) {
      this.accessToken = AccessToken;
    } else {
      this.accessToken = new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */]();
    }
    if (TokenScopes) {
      this.tokenScopes = TokenScopes;
    } else {
      this.tokenScopes = new __WEBPACK_IMPORTED_MODULE_0__CognitoTokenScopes__["a" /* default */]();
    }
    if (State) {
      this.state = State;
    } else {
      this.state = null;
    }
  }

  /**
   * @returns {CognitoIdToken} the session's Id token
   */


  CognitoAuthSession.prototype.getIdToken = function getIdToken() {
    return this.idToken;
  };

  /**
   * Set a new Id token
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @returns {void}
   */


  CognitoAuthSession.prototype.setIdToken = function setIdToken(IdToken) {
    this.idToken = IdToken;
  };

  /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */


  CognitoAuthSession.prototype.getRefreshToken = function getRefreshToken() {
    return this.refreshToken;
  };

  /**
   * Set a new Refresh token
   * @param {CognitoRefreshToken} RefreshToken The session's refresh token.
   * @returns {void}
   */


  CognitoAuthSession.prototype.setRefreshToken = function setRefreshToken(RefreshToken) {
    this.refreshToken = RefreshToken;
  };

  /**
   * @returns {CognitoAccessToken} the session's access token
   */


  CognitoAuthSession.prototype.getAccessToken = function getAccessToken() {
    return this.accessToken;
  };

  /**
   * Set a new Access token
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @returns {void}
   */


  CognitoAuthSession.prototype.setAccessToken = function setAccessToken(AccessToken) {
    this.accessToken = AccessToken;
  };

  /**
   * @returns {CognitoTokenScopes} the session's token scopes
   */


  CognitoAuthSession.prototype.getTokenScopes = function getTokenScopes() {
    return this.tokenScopes;
  };

  /**
   * Set new token scopes
   * @param {array}  tokenScopes  The session's token scopes.
   * @returns {void}
   */


  CognitoAuthSession.prototype.setTokenScopes = function setTokenScopes(tokenScopes) {
    this.tokenScopes = tokenScopes;
  };

  /**
   * @returns {string} the session's state
   */


  CognitoAuthSession.prototype.getState = function getState() {
    return this.state;
  };

  /**
   * Set new state
   * @param {string}  state  The session's state.
   * @returns {void}
   */


  CognitoAuthSession.prototype.setState = function setState(State) {
    this.state = State;
  };

  /**
   * Checks to see if the session is still valid based on session expiry information found
   * in Access and Id Tokens and the current time
   * @returns {boolean} if the session is still valid
   */


  CognitoAuthSession.prototype.isValid = function isValid() {
    var now = Math.floor(new Date() / 1000);
    try {
      if (this.accessToken != null) {
        return now < this.accessToken.getExpiration();
      }
      if (this.idToken != null) {
        return now < this.idToken.getExpiration();
      }
      return false;
    } catch (e) {
      return false;
    }
  };

  return CognitoAuthSession;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoAuthSession);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */
var dataMemory = {};

/** @class */

var MemoryStorage = function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);
  }

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  MemoryStorage.setItem = function setItem(key, value) {
    dataMemory[key] = value;
    return dataMemory[key];
  };

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */


  MemoryStorage.getItem = function getItem(key) {
    return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
  };

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */


  MemoryStorage.removeItem = function removeItem(key) {
    return delete dataMemory[key];
  };

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */


  MemoryStorage.clear = function clear() {
    dataMemory = {};
    return dataMemory;
  };

  return MemoryStorage;
}();

/** @class */


var StorageHelper = function () {

  /**
   * This is used to get a storage object
   * @returns {object} the storage
   */
  function StorageHelper() {
    _classCallCheck(this, StorageHelper);

    try {
      this.storageWindow = window.localStorage;
      this.storageWindow.setItem('aws.cognito.test-ls', 1);
      this.storageWindow.removeItem('aws.cognito.test-ls');
    } catch (exception) {
      this.storageWindow = MemoryStorage;
    }
  }

  /**
   * This is used to return the storage
   * @returns {object} the storage
   */


  StorageHelper.prototype.getStorage = function getStorage() {
    return this.storageWindow;
  };

  return StorageHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (StorageHelper);

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AWSCognitoProvider_1 = __webpack_require__(1204);
exports.AWSCognitoProvider = AWSCognitoProvider_1.default;
var GoogleProvider_1 = __webpack_require__(1205);
exports.GoogleProvider = GoogleProvider_1.default;
var FacebookProvider_1 = __webpack_require__(1211);
exports.FacebookProvider = FacebookProvider_1.default;
var AmazonProvider_1 = __webpack_require__(1212);
exports.AmazonProvider = AmazonProvider_1.default;
var DeveloperProvider_1 = __webpack_require__(1213);
exports.DeveloperProvider = DeveloperProvider_1.default;
var GenericProvider_1 = __webpack_require__(1214);
exports.GenericProvider = GenericProvider_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(45);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var logger = new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["ConsoleLogger"]('StorageCache');
/**
 * Initialization of the cache
 *
 */
var StorageCache = /** @class */ (function () {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */
    function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function () {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function () {
        // check configuration
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* isInteger */])(this.config.capacityInBytes)) {
            logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].capacityInBytes;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* isInteger */])(this.config.itemMaxSize)) {
            logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].itemMaxSize;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* isInteger */])(this.config.defaultTTL)) {
            logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].defaultTTL;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* isInteger */])(this.config.defaultPriority)) {
            logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 ||
            Number(this.config.warningThreshold) < 0) {
            logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5 * 1024 * 1024;
        if (this.config.capacityInBytes > cacheLimit) {
            logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */
    StorageCache.prototype.fillCacheItem = function (key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])(),
            visitedTime: Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0,
        };
        ret.byteSize = Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* getByteLength */])(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* getByteLength */])(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */
    StorageCache.prototype.configure = function (config) {
        if (!config) {
            return this.config;
        }
        if (config.keyPrefix) {
            logger.warn("Don't try to configure keyPrefix!");
        }
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}());
/* harmony default export */ __webpack_exports__["a"] = (StorageCache);
//# sourceMappingURL=StorageCache.js.map

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SecurityAccessPage__ = __webpack_require__(1216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SecurityAccessPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SecurityAccess__ = __webpack_require__(1217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SecurityAccess__["a"]; });


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TokenChangeEmailPage__ = __webpack_require__(1218);
/* unused harmony reexport TokenChangeEmailPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TokenChangeEmail__ = __webpack_require__(1219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__TokenChangeEmail__["a"]; });


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEND_TOKEN_PHONE */
/* unused harmony export SEND_TOKEN_PHONE_SUCCESS */
/* unused harmony export SEND_TOKEN_PHONE_FAIL */
/* unused harmony export TOKEN_CHAGE_EMAIL */
/* unused harmony export TOKEN_CHAGE_EMAIL_SUCCESS */
/* unused harmony export TOKEN_CHAGE_EMAIL_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSendTokenPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchTokenChangeEmail; });
var SEND_TOKEN_PHONE='SEND_TOKEN_PHONE';var SEND_TOKEN_PHONE_SUCCESS=SEND_TOKEN_PHONE+'_SUCCESS';var SEND_TOKEN_PHONE_FAIL=SEND_TOKEN_PHONE+'_FAIL';var TOKEN_CHAGE_EMAIL='TOKEN_CHAGE_EMAIL';var TOKEN_CHAGE_EMAIL_SUCCESS=TOKEN_CHAGE_EMAIL+'_SUCCESS';var TOKEN_CHAGE_EMAIL_FAIL=TOKEN_CHAGE_EMAIL+'_FAIL';var fetchSendTokenPhone=function fetchSendTokenPhone(data){return{type:SEND_TOKEN_PHONE,payload:{client:'onboardingApi',request:{method:'post',url:'/v2/sonar/token/phone',data:data}}};};var fetchTokenChangeEmail=function fetchTokenChangeEmail(data){return{type:TOKEN_CHAGE_EMAIL,payload:{client:'onboardingApi',request:{method:'put',url:'/v1/api/participant/changeemail',data:data}}};};var INITIAL_STATE={isLoading:false,dataResponse:null,errors:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:INITIAL_STATE;var action=arguments[1];switch(action.type){case SEND_TOKEN_PHONE:return Object.assign({},state,{isLoading:true,errors:null,dataResponse:null});case SEND_TOKEN_PHONE_SUCCESS:return Object.assign({},state,{isLoading:false,dataResponse:action.payload.data});case SEND_TOKEN_PHONE_FAIL:return Object.assign({},state,{isLoading:false,errors:action.error.response.data});case TOKEN_CHAGE_EMAIL:return Object.assign({},state,{isLoading:true,errors:null,dataResponse:null});case TOKEN_CHAGE_EMAIL_SUCCESS:return Object.assign({},state,{isLoading:false,dataResponse:action.payload.data});case TOKEN_CHAGE_EMAIL_FAIL:return Object.assign({},state,{isLoading:false,errors:action.error.response.data});default:return Object.assign({},state);}});

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @param {Object} props
 * @param {InputRangeClassNames} props.classNames
 * @param {Function} props.formatLabel
 * @param {string} props.type
 */
function Label(props) {
  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;

  return _react2.default.createElement(
    'span',
    { className: props.classNames[props.type + 'Label'] },
    _react2.default.createElement(
      'span',
      { className: props.classNames.labelContainer },
      labelValue
    )
  );
}

/**
 * @type {Object}
 * @property {Function} children
 * @property {Function} classNames
 * @property {Function} formatLabel
 * @property {Function} type
 */
Label.propTypes = {
  children: _propTypes2.default.node.isRequired,
  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  formatLabel: _propTypes2.default.func,
  type: _propTypes2.default.string.isRequired
};
module.exports = exports['default'];
//# sourceMappingURL=label.js.map

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSuggestionContainer__ = __webpack_require__(1287);
/* unused harmony reexport ProductSuggestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSuggestionPlaceholder__ = __webpack_require__(547);
/* unused harmony reexport ProductSuggestionPlaceholder */


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductCardContainer__ = __webpack_require__(1290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductCardContainer__["a"]; });


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0____["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WishlistPageContainer__ = __webpack_require__(1298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__WishlistPageContainer__["a"]; });


/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export Immer */
/* unused harmony export applyPatches */
/* unused harmony export createDraft */
/* unused harmony export finishDraft */
/* unused harmony export immerable */
/* unused harmony export isDraft */
/* unused harmony export isDraftable */
/* unused harmony export nothing */
/* unused harmony export original */
/* unused harmony export produce */
/* unused harmony export produceWithPatches */
/* unused harmony export setAutoFreeze */
/* unused harmony export setUseProxies */
var obj;
var NOTHING = typeof Symbol !== "undefined" ? Symbol("immer-nothing") : ( obj = {}, obj["immer-nothing"] = true, obj );
var DRAFTABLE = typeof Symbol !== "undefined" && Symbol.for ? Symbol.for("immer-draftable") : "__$immer_draftable";
var DRAFT_STATE = typeof Symbol !== "undefined" && Symbol.for ? Symbol.for("immer-state") : "__$immer_state";
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value) { return false; }
  return isPlainObject(value) || !!value[DRAFTABLE] || !!value.constructor[DRAFTABLE];
}
function isPlainObject(value) {
  if (!value || typeof value !== "object") { return false; }
  if (Array.isArray(value)) { return true; }
  var proto = Object.getPrototypeOf(value);
  return !proto || proto === Object.prototype;
}
function original(value) {
  if (value && value[DRAFT_STATE]) {
    return value[DRAFT_STATE].base;
  } // otherwise return undefined

}
var assign = Object.assign || function assign(target, value) {
  for (var key in value) {
    if (has(value, key)) {
      target[key] = value[key];
    }
  }

  return target;
};
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : typeof Object.getOwnPropertySymbols !== "undefined" ? function (obj) { return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj)); } : Object.getOwnPropertyNames;
function shallowCopy(base, invokeGetters) {
  if ( invokeGetters === void 0 ) invokeGetters = false;

  if (Array.isArray(base)) { return base.slice(); }
  var clone = Object.create(Object.getPrototypeOf(base));
  ownKeys(base).forEach(function (key) {
    if (key === DRAFT_STATE) {
      return; // Never copy over draft state.
    }

    var desc = Object.getOwnPropertyDescriptor(base, key);
    var value = desc.value;

    if (desc.get) {
      if (!invokeGetters) {
        throw new Error("Immer drafts cannot have computed properties");
      }

      value = desc.get.call(base);
    }

    if (desc.enumerable) {
      clone[key] = value;
    } else {
      Object.defineProperty(clone, key, {
        value: value,
        writable: true,
        configurable: true
      });
    }
  });
  return clone;
}
function each(value, cb) {
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) { cb(i, value[i], value); }
  } else {
    ownKeys(value).forEach(function (key) { return cb(key, value[key], value); });
  }
}
function isEnumerable(base, prop) {
  var desc = Object.getOwnPropertyDescriptor(base, prop);
  return !!desc && desc.enumerable;
}
function has(thing, prop) {
  return Object.prototype.hasOwnProperty.call(thing, prop);
}
function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function clone(obj) {
  if (!isDraftable(obj)) { return obj; }
  if (Array.isArray(obj)) { return obj.map(clone); }
  var cloned = Object.create(Object.getPrototypeOf(obj));

  for (var key in obj) { cloned[key] = clone(obj[key]); }

  return cloned;
}
function deepFreeze(obj) {
  if (!isDraftable(obj) || isDraft(obj) || Object.isFrozen(obj)) { return; }
  Object.freeze(obj);
  if (Array.isArray(obj)) { obj.forEach(deepFreeze); }else { for (var key in obj) { deepFreeze(obj[key]); } }
}

/** Each scope represents a `produce` call. */

var ImmerScope = function ImmerScope(parent) {
  this.drafts = [];
  this.parent = parent; // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.

  this.canAutoFreeze = true; // To avoid prototype lookups:

  this.patches = null;
};

ImmerScope.prototype.usePatches = function usePatches (patchListener) {
  if (patchListener) {
    this.patches = [];
    this.inversePatches = [];
    this.patchListener = patchListener;
  }
};

ImmerScope.prototype.revoke = function revoke$1 () {
  this.leave();
  this.drafts.forEach(revoke);
  this.drafts = null; // Make draft-related methods throw.
};

ImmerScope.prototype.leave = function leave () {
  if (this === ImmerScope.current) {
    ImmerScope.current = this.parent;
  }
};
ImmerScope.current = null;

ImmerScope.enter = function () {
  return this.current = new ImmerScope(this.current);
};

function revoke(draft) {
  draft[DRAFT_STATE].revoke();
}

// but share them all instead

var descriptors = {};
function willFinalize(scope, result, isReplaced) {
  scope.drafts.forEach(function (draft) {
    draft[DRAFT_STATE].finalizing = true;
  });

  if (!isReplaced) {
    if (scope.patches) {
      markChangesRecursively(scope.drafts[0]);
    } // This is faster when we don't care about which attributes changed.


    markChangesSweep(scope.drafts);
  } // When a child draft is returned, look for changes.
  else if (isDraft(result) && result[DRAFT_STATE].scope === scope) {
      markChangesSweep(scope.drafts);
    }
}
function createProxy(base, parent) {
  var isArray = Array.isArray(base);
  var draft = clonePotentialDraft(base);
  each(draft, function (prop) {
    proxyProperty(draft, prop, isArray || isEnumerable(base, prop));
  }); // See "proxy.js" for property documentation.

  var scope = parent ? parent.scope : ImmerScope.current;
  var state = {
    scope: scope,
    modified: false,
    finalizing: false,
    // es5 only
    finalized: false,
    assigned: {},
    parent: parent,
    base: base,
    draft: draft,
    copy: null,
    revoke: revoke$1,
    revoked: false // es5 only

  };
  createHiddenProperty(draft, DRAFT_STATE, state);
  scope.drafts.push(draft);
  return draft;
}

function revoke$1() {
  this.revoked = true;
}

function source(state) {
  return state.copy || state.base;
} // Access a property without creating an Immer draft.


function peek(draft, prop) {
  var state = draft[DRAFT_STATE];

  if (state && !state.finalizing) {
    state.finalizing = true;
    var value = draft[prop];
    state.finalizing = false;
    return value;
  }

  return draft[prop];
}

function get(state, prop) {
  assertUnrevoked(state);
  var value = peek(source(state), prop);
  if (state.finalizing) { return value; } // Create a draft if the value is unmodified.

  if (value === peek(state.base, prop) && isDraftable(value)) {
    prepareCopy(state);
    return state.copy[prop] = createProxy(value, state);
  }

  return value;
}

function set(state, prop, value) {
  assertUnrevoked(state);
  state.assigned[prop] = true;

  if (!state.modified) {
    if (is(value, peek(source(state), prop))) { return; }
    markChanged(state);
    prepareCopy(state);
  }

  state.copy[prop] = value;
}

function markChanged(state) {
  if (!state.modified) {
    state.modified = true;
    if (state.parent) { markChanged(state.parent); }
  }
}

function prepareCopy(state) {
  if (!state.copy) { state.copy = clonePotentialDraft(state.base); }
}

function clonePotentialDraft(base) {
  var state = base && base[DRAFT_STATE];

  if (state) {
    state.finalizing = true;
    var draft = shallowCopy(state.draft, true);
    state.finalizing = false;
    return draft;
  }

  return shallowCopy(base);
}

function proxyProperty(draft, prop, enumerable) {
  var desc = descriptors[prop];

  if (desc) {
    desc.enumerable = enumerable;
  } else {
    descriptors[prop] = desc = {
      configurable: true,
      enumerable: enumerable,

      get: function get$1() {
        return get(this[DRAFT_STATE], prop);
      },

      set: function set$1(value) {
        set(this[DRAFT_STATE], prop, value);
      }

    };
  }

  Object.defineProperty(draft, prop, desc);
}

function assertUnrevoked(state) {
  if (state.revoked === true) { throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(source(state))); }
} // This looks expensive, but only proxies are visited, and only objects without known changes are scanned.


function markChangesSweep(drafts) {
  // The natural order of drafts in the `scope` array is based on when they
  // were accessed. By processing drafts in reverse natural order, we have a
  // better chance of processing leaf nodes first. When a leaf node is known to
  // have changed, we can avoid any traversal of its ancestor nodes.
  for (var i = drafts.length - 1; i >= 0; i--) {
    var state = drafts[i][DRAFT_STATE];

    if (!state.modified) {
      if (Array.isArray(state.base)) {
        if (hasArrayChanges(state)) { markChanged(state); }
      } else if (hasObjectChanges(state)) { markChanged(state); }
    }
  }
}

function markChangesRecursively(object) {
  if (!object || typeof object !== "object") { return; }
  var state = object[DRAFT_STATE];
  if (!state) { return; }
  var base = state.base;
  var draft = state.draft;
  var assigned = state.assigned;

  if (!Array.isArray(object)) {
    // Look for added keys.
    Object.keys(draft).forEach(function (key) {
      // The `undefined` check is a fast path for pre-existing keys.
      if (base[key] === undefined && !has(base, key)) {
        assigned[key] = true;
        markChanged(state);
      } else if (!assigned[key]) {
        // Only untouched properties trigger recursion.
        markChangesRecursively(draft[key]);
      }
    }); // Look for removed keys.

    Object.keys(base).forEach(function (key) {
      // The `undefined` check is a fast path for pre-existing keys.
      if (draft[key] === undefined && !has(draft, key)) {
        assigned[key] = false;
        markChanged(state);
      }
    });
  } else if (hasArrayChanges(state)) {
    markChanged(state);
    assigned.length = true;

    if (draft.length < base.length) {
      for (var i = draft.length; i < base.length; i++) { assigned[i] = false; }
    } else {
      for (var i$1 = base.length; i$1 < draft.length; i$1++) { assigned[i$1] = true; }
    }

    for (var i$2 = 0; i$2 < draft.length; i$2++) {
      // Only untouched indices trigger recursion.
      if (assigned[i$2] === undefined) { markChangesRecursively(draft[i$2]); }
    }
  }
}

function hasObjectChanges(state) {
  var base = state.base;
  var draft = state.draft; // Search for added keys and changed keys. Start at the back, because
  // non-numeric keys are ordered by time of definition on the object.

  var keys = Object.keys(draft);

  for (var i = keys.length - 1; i >= 0; i--) {
    var key = keys[i];
    var baseValue = base[key]; // The `undefined` check is a fast path for pre-existing keys.

    if (baseValue === undefined && !has(base, key)) {
      return true;
    } // Once a base key is deleted, future changes go undetected, because its
    // descriptor is erased. This branch detects any missed changes.
    else {
        var value = draft[key];
        var state$1 = value && value[DRAFT_STATE];

        if (state$1 ? state$1.base !== baseValue : !is(value, baseValue)) {
          return true;
        }
      }
  } // At this point, no keys were added or changed.
  // Compare key count to determine if keys were deleted.


  return keys.length !== Object.keys(base).length;
}

function hasArrayChanges(state) {
  var draft = state.draft;
  if (draft.length !== state.base.length) { return true; } // See #116
  // If we first shorten the length, our array interceptors will be removed.
  // If after that new items are added, result in the same original length,
  // those last items will have no intercepting property.
  // So if there is no own descriptor on the last position, we know that items were removed and added
  // N.B.: splice, unshift, etc only shift values around, but not prop descriptors, so we only have to check
  // the last one

  var descriptor = Object.getOwnPropertyDescriptor(draft, draft.length - 1); // descriptor can be null, but only for newly created sparse arrays, eg. new Array(10)

  if (descriptor && !descriptor.get) { return true; } // For all other cases, we don't have to compare, as they would have been picked up by the index setters

  return false;
}

function createHiddenProperty(target, prop, value) {
  Object.defineProperty(target, prop, {
    value: value,
    enumerable: false,
    writable: true
  });
}

var legacyProxy = /*#__PURE__*/Object.freeze({
	willFinalize: willFinalize,
	createProxy: createProxy
});

function willFinalize$1() {}
function createProxy$1(base, parent) {
  var scope = parent ? parent.scope : ImmerScope.current;
  var state = {
    // Track which produce call this is associated with.
    scope: scope,
    // True for both shallow and deep changes.
    modified: false,
    // Used during finalization.
    finalized: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned: {},
    // The parent draft state.
    parent: parent,
    // The base state.
    base: base,
    // The base proxy.
    draft: null,
    // Any property proxies.
    drafts: {},
    // The base copy with any updated values.
    copy: null,
    // Called by the `produce` function.
    revoke: null
  };
  var ref = Array.isArray(base) ? // [state] is used for arrays, to make sure the proxy is array-ish and not violate invariants,
  // although state itself is an object
  Proxy.revocable([state], arrayTraps) : Proxy.revocable(state, objectTraps);
  var revoke = ref.revoke;
  var proxy = ref.proxy;
  state.draft = proxy;
  state.revoke = revoke;
  scope.drafts.push(proxy);
  return proxy;
}
var objectTraps = {
  get: get$1,

  has: function has(target, prop) {
    return prop in source$1(target);
  },

  ownKeys: function ownKeys(target) {
    return Reflect.ownKeys(source$1(target));
  },

  set: set$1,
  deleteProperty: deleteProperty,
  getOwnPropertyDescriptor: getOwnPropertyDescriptor,

  defineProperty: function defineProperty() {
    throw new Error("Object.defineProperty() cannot be used on an Immer draft"); // prettier-ignore
  },

  getPrototypeOf: function getPrototypeOf(target) {
    return Object.getPrototypeOf(target.base);
  },

  setPrototypeOf: function setPrototypeOf() {
    throw new Error("Object.setPrototypeOf() cannot be used on an Immer draft"); // prettier-ignore
  }

};
var arrayTraps = {};
each(objectTraps, function (key, fn) {
  arrayTraps[key] = function () {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});

arrayTraps.deleteProperty = function (state, prop) {
  if (isNaN(parseInt(prop))) {
    throw new Error("Immer only supports deleting array indices"); // prettier-ignore
  }

  return objectTraps.deleteProperty.call(this, state[0], prop);
};

arrayTraps.set = function (state, prop, value) {
  if (prop !== "length" && isNaN(parseInt(prop))) {
    throw new Error("Immer only supports setting array indices and the 'length' property"); // prettier-ignore
  }

  return objectTraps.set.call(this, state[0], prop, value);
}; // returns the object we should be reading the current value from, which is base, until some change has been made


function source$1(state) {
  return state.copy || state.base;
} // Access a property without creating an Immer draft.


function peek$1(draft, prop) {
  var state = draft[DRAFT_STATE];
  var desc = Reflect.getOwnPropertyDescriptor(state ? source$1(state) : draft, prop);
  return desc && desc.value;
}

function get$1(state, prop) {
  if (prop === DRAFT_STATE) { return state; }
  var drafts = state.drafts; // Check for existing draft in unmodified state.

  if (!state.modified && has(drafts, prop)) {
    return drafts[prop];
  }

  var value = source$1(state)[prop];

  if (state.finalized || !isDraftable(value)) {
    return value;
  } // Check for existing draft in modified state.


  if (state.modified) {
    // Assigned values are never drafted. This catches any drafts we created, too.
    if (value !== peek$1(state.base, prop)) { return value; } // Store drafts on the copy (when one exists).

    drafts = state.copy;
  }

  return drafts[prop] = createProxy$1(value, state);
}

function set$1(state, prop, value) {
  if (!state.modified) {
    var baseValue = peek$1(state.base, prop); // Optimize based on value's truthiness. Truthy values are guaranteed to
    // never be undefined, so we can avoid the `in` operator. Lastly, truthy
    // values may be drafts, but falsy values are never drafts.

    var isUnchanged = value ? is(baseValue, value) || value === state.drafts[prop] : is(baseValue, value) && prop in state.base;
    if (isUnchanged) { return true; }
    markChanged$1(state);
  }

  state.assigned[prop] = true;
  state.copy[prop] = value;
  return true;
}

function deleteProperty(state, prop) {
  // The `undefined` check is a fast path for pre-existing keys.
  if (peek$1(state.base, prop) !== undefined || prop in state.base) {
    state.assigned[prop] = false;
    markChanged$1(state);
  } else if (state.assigned[prop]) {
    // if an originally not assigned property was deleted
    delete state.assigned[prop];
  }

  if (state.copy) { delete state.copy[prop]; }
  return true;
} // Note: We never coerce `desc.value` into an Immer draft, because we can't make
// the same guarantee in ES5 mode.


function getOwnPropertyDescriptor(state, prop) {
  var owner = source$1(state);
  var desc = Reflect.getOwnPropertyDescriptor(owner, prop);

  if (desc) {
    desc.writable = true;
    desc.configurable = !Array.isArray(owner) || prop !== "length";
  }

  return desc;
}

function markChanged$1(state) {
  if (!state.modified) {
    state.modified = true;
    state.copy = assign(shallowCopy(state.base), state.drafts);
    state.drafts = null;
    if (state.parent) { markChanged$1(state.parent); }
  }
}

var modernProxy = /*#__PURE__*/Object.freeze({
	willFinalize: willFinalize$1,
	createProxy: createProxy$1
});

function generatePatches(state, basePath, patches, inversePatches) {
  Array.isArray(state.base) ? generateArrayPatches(state, basePath, patches, inversePatches) : generateObjectPatches(state, basePath, patches, inversePatches);
}

function generateArrayPatches(state, basePath, patches, inversePatches) {
  var assign, assign$1;

  var base = state.base;
  var copy = state.copy;
  var assigned = state.assigned; // Reduce complexity by ensuring `base` is never longer.

  if (copy.length < base.length) {
    (assign = [copy, base], base = assign[0], copy = assign[1]);
    (assign$1 = [inversePatches, patches], patches = assign$1[0], inversePatches = assign$1[1]);
  }

  var delta = copy.length - base.length; // Find the first replaced index.

  var start = 0;

  while (base[start] === copy[start] && start < base.length) {
    ++start;
  } // Find the last replaced index. Search from the end to optimize splice patches.


  var end = base.length;

  while (end > start && base[end - 1] === copy[end + delta - 1]) {
    --end;
  } // Process replaced indices.


  for (var i = start; i < end; ++i) {
    if (assigned[i] && copy[i] !== base[i]) {
      var path = basePath.concat([i]);
      patches.push({
        op: "replace",
        path: path,
        value: copy[i]
      });
      inversePatches.push({
        op: "replace",
        path: path,
        value: base[i]
      });
    }
  }

  var replaceCount = patches.length; // Process added indices.

  for (var i$1 = end + delta - 1; i$1 >= end; --i$1) {
    var path$1 = basePath.concat([i$1]);
    patches[replaceCount + i$1 - end] = {
      op: "add",
      path: path$1,
      value: copy[i$1]
    };
    inversePatches.push({
      op: "remove",
      path: path$1
    });
  }
}

function generateObjectPatches(state, basePath, patches, inversePatches) {
  var base = state.base;
  var copy = state.copy;
  each(state.assigned, function (key, assignedValue) {
    var origValue = base[key];
    var value = copy[key];
    var op = !assignedValue ? "remove" : key in base ? "replace" : "add";
    if (origValue === value && op === "replace") { return; }
    var path = basePath.concat(key);
    patches.push(op === "remove" ? {
      op: op,
      path: path
    } : {
      op: op,
      path: path,
      value: value
    });
    inversePatches.push(op === "add" ? {
      op: "remove",
      path: path
    } : op === "remove" ? {
      op: "add",
      path: path,
      value: origValue
    } : {
      op: "replace",
      path: path,
      value: origValue
    });
  });
}

var applyPatches = function (draft, patches) {
  for (var i$1 = 0, list = patches; i$1 < list.length; i$1 += 1) {
    var patch = list[i$1];

    var path = patch.path;
    var op = patch.op;
    var value = clone(patch.value); // used to clone patch to ensure original patch is not modified, see #411

    if (!path.length) { throw new Error("Illegal state"); }
    var base = draft;

    for (var i = 0; i < path.length - 1; i++) {
      base = base[path[i]];
      if (!base || typeof base !== "object") { throw new Error("Cannot apply patch, path doesn't resolve: " + path.join("/")); } // prettier-ignore
    }

    var key = path[path.length - 1];

    switch (op) {
      case "replace":
        // if value is an object, then it's assigned by reference
        // in the following add or remove ops, the value field inside the patch will also be modifyed
        // so we use value from the cloned patch
        base[key] = value;
        break;

      case "add":
        if (Array.isArray(base)) {
          // TODO: support "foo/-" paths for appending to an array
          base.splice(key, 0, value);
        } else {
          base[key] = value;
        }

        break;

      case "remove":
        if (Array.isArray(base)) {
          base.splice(key, 1);
        } else {
          delete base[key];
        }

        break;

      default:
        throw new Error("Unsupported patch operation: " + op);
    }
  }

  return draft;
};

function verifyMinified() {}

var configDefaults = {
  useProxies: typeof Proxy !== "undefined" && typeof Proxy.revocable !== "undefined" && typeof Reflect !== "undefined",
  autoFreeze: typeof process !== "undefined" ? "production" !== "production" : verifyMinified.name === "verifyMinified",
  onAssign: null,
  onDelete: null,
  onCopy: null
};
var Immer = function Immer(config) {
  assign(this, configDefaults, config);
  this.setUseProxies(this.useProxies);
  this.produce = this.produce.bind(this);
};

Immer.prototype.produce = function produce (base, recipe, patchListener) {
    var this$1 = this;

  // curried invocation
  if (typeof base === "function" && typeof recipe !== "function") {
    var defaultBase = recipe;
    recipe = base;
    var self = this;
    return function curriedProduce(base) {
        var this$1 = this;
        if ( base === void 0 ) base = defaultBase;
        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

      return self.produce(base, function (draft) { return recipe.call.apply(recipe, [ this$1, draft ].concat( args )); }); // prettier-ignore
    };
  } // prettier-ignore


  {
    if (typeof recipe !== "function") {
      throw new Error("The first or second argument to `produce` must be a function");
    }

    if (patchListener !== undefined && typeof patchListener !== "function") {
      throw new Error("The third argument to `produce` must be a function or undefined");
    }
  }
  var result; // Only plain objects, arrays, and "immerable classes" are drafted.

  if (isDraftable(base)) {
    var scope = ImmerScope.enter();
    var proxy = this.createProxy(base);
    var hasError = true;

    try {
      result = recipe(proxy);
      hasError = false;
    } finally {
      // finally instead of catch + rethrow better preserves original stack
      if (hasError) { scope.revoke(); }else { scope.leave(); }
    }

    if (result instanceof Promise) {
      return result.then(function (result) {
        scope.usePatches(patchListener);
        return this$1.processResult(result, scope);
      }, function (error) {
        scope.revoke();
        throw error;
      });
    }

    scope.usePatches(patchListener);
    return this.processResult(result, scope);
  } else {
    result = recipe(base);
    if (result === NOTHING) { return undefined; }
    if (result === undefined) { result = base; }
    this.maybeFreeze(result, true);
    return result;
  }
};

Immer.prototype.produceWithPatches = function produceWithPatches (arg1, arg2, arg3) {
    var this$1 = this;

  if (typeof arg1 === "function") {
    return function (state) {
        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

        return this$1.produceWithPatches(state, function (draft) { return arg1.apply(void 0, [ draft ].concat( args )); });
      };
  } // non-curried form


  if (arg3) { throw new Error("A patch listener cannot be passed to produceWithPatches"); }
  var patches, inversePatches;
  var nextState = this.produce(arg1, arg2, function (p, ip) {
    patches = p;
    inversePatches = ip;
  });
  return [nextState, patches, inversePatches];
};

Immer.prototype.createDraft = function createDraft (base) {
  if (!isDraftable(base)) {
    throw new Error("First argument to `createDraft` must be a plain object, an array, or an immerable object"); // prettier-ignore
  }

  var scope = ImmerScope.enter();
  var proxy = this.createProxy(base);
  proxy[DRAFT_STATE].isManual = true;
  scope.leave();
  return proxy;
};

Immer.prototype.finishDraft = function finishDraft (draft, patchListener) {
  var state = draft && draft[DRAFT_STATE];

  if (!state || !state.isManual) {
    throw new Error("First argument to `finishDraft` must be a draft returned by `createDraft`"); // prettier-ignore
  }

  if (state.finalized) {
    throw new Error("The given draft is already finalized"); // prettier-ignore
  }

  var scope = state.scope;
  scope.usePatches(patchListener);
  return this.processResult(undefined, scope);
};

Immer.prototype.setAutoFreeze = function setAutoFreeze (value) {
  this.autoFreeze = value;
};

Immer.prototype.setUseProxies = function setUseProxies (value) {
  this.useProxies = value;
  assign(this, value ? modernProxy : legacyProxy);
};

Immer.prototype.applyPatches = function applyPatches$1 (base, patches) {
  // If a patch replaces the entire state, take that replacement as base
  // before applying patches
  var i;

  for (i = patches.length - 1; i >= 0; i--) {
    var patch = patches[i];

    if (patch.path.length === 0 && patch.op === "replace") {
      base = patch.value;
      break;
    }
  }

  if (isDraft(base)) {
    // N.B: never hits if some patch a replacement, patches are never drafts
    return applyPatches(base, patches);
  } // Otherwise, produce a copy of the base state.


  return this.produce(base, function (draft) { return applyPatches(draft, patches.slice(i + 1)); });
};
/** @internal */


Immer.prototype.processResult = function processResult (result, scope) {
  var baseDraft = scope.drafts[0];
  var isReplaced = result !== undefined && result !== baseDraft;
  this.willFinalize(scope, result, isReplaced);

  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified) {
      scope.revoke();
      throw new Error("An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft."); // prettier-ignore
    }

    if (isDraftable(result)) {
      // Finalize the result in case it contains (or is) a subset of the draft.
      result = this.finalize(result, null, scope);
      this.maybeFreeze(result);
    }

    if (scope.patches) {
      scope.patches.push({
        op: "replace",
        path: [],
        value: result
      });
      scope.inversePatches.push({
        op: "replace",
        path: [],
        value: baseDraft[DRAFT_STATE].base
      });
    }
  } else {
    // Finalize the base draft.
    result = this.finalize(baseDraft, [], scope);
  }

  scope.revoke();

  if (scope.patches) {
    scope.patchListener(scope.patches, scope.inversePatches);
  }

  return result !== NOTHING ? result : undefined;
};
/**
 * @internal
 * Finalize a draft, returning either the unmodified base state or a modified
 * copy of the base state.
 */


Immer.prototype.finalize = function finalize (draft, path, scope) {
    var this$1 = this;

  var state = draft[DRAFT_STATE];

  if (!state) {
    if (Object.isFrozen(draft)) { return draft; }
    return this.finalizeTree(draft, null, scope);
  } // Never finalize drafts owned by another scope.


  if (state.scope !== scope) {
    return draft;
  }

  if (!state.modified) {
    this.maybeFreeze(state.base, true);
    return state.base;
  }

  if (!state.finalized) {
    state.finalized = true;
    this.finalizeTree(state.draft, path, scope);

    if (this.onDelete) {
      // The `assigned` object is unreliable with ES5 drafts.
      if (this.useProxies) {
        var assigned = state.assigned;

        for (var prop in assigned) {
          if (!assigned[prop]) { this.onDelete(state, prop); }
        }
      } else {
        var base = state.base;
          var copy = state.copy;
        each(base, function (prop) {
          if (!has(copy, prop)) { this$1.onDelete(state, prop); }
        });
      }
    }

    if (this.onCopy) {
      this.onCopy(state);
    } // At this point, all descendants of `state.copy` have been finalized,
    // so we can be sure that `scope.canAutoFreeze` is accurate.


    if (this.autoFreeze && scope.canAutoFreeze) {
      Object.freeze(state.copy);
    }

    if (path && scope.patches) {
      generatePatches(state, path, scope.patches, scope.inversePatches);
    }
  }

  return state.copy;
};
/**
 * @internal
 * Finalize all drafts in the given state tree.
 */


Immer.prototype.finalizeTree = function finalizeTree (root, rootPath, scope) {
    var this$1 = this;

  var state = root[DRAFT_STATE];

  if (state) {
    if (!this.useProxies) {
      // Create the final copy, with added keys and without deleted keys.
      state.copy = shallowCopy(state.draft, true);
    }

    root = state.copy;
  }

  var needPatches = !!rootPath && !!scope.patches;

  var finalizeProperty = function (prop, value, parent) {
    if (value === parent) {
      throw Error("Immer forbids circular references");
    } // In the `finalizeTree` method, only the `root` object may be a draft.


    var isDraftProp = !!state && parent === root;

    if (isDraft(value)) {
      var path = isDraftProp && needPatches && !state.assigned[prop] ? rootPath.concat(prop) : null; // Drafts owned by `scope` are finalized here.

      value = this$1.finalize(value, path, scope); // Drafts from another scope must prevent auto-freezing.

      if (isDraft(value)) {
        scope.canAutoFreeze = false;
      } // Preserve non-enumerable properties.


      if (Array.isArray(parent) || isEnumerable(parent, prop)) {
        parent[prop] = value;
      } else {
        Object.defineProperty(parent, prop, {
          value: value
        });
      } // Unchanged drafts are never passed to the `onAssign` hook.


      if (isDraftProp && value === state.base[prop]) { return; }
    } // Unchanged draft properties are ignored.
    else if (isDraftProp && is(value, state.base[prop])) {
        return;
      } // Search new objects for unfinalized drafts. Frozen objects should never contain drafts.
      else if (isDraftable(value) && !Object.isFrozen(value)) {
          each(value, finalizeProperty);
          this$1.maybeFreeze(value);
        }

    if (isDraftProp && this$1.onAssign) {
      this$1.onAssign(state, prop, value);
    }
  };

  each(root, finalizeProperty);
  return root;
};

Immer.prototype.maybeFreeze = function maybeFreeze (value, deep) {
    if ( deep === void 0 ) deep = false;

  if (this.autoFreeze && !isDraft(value)) {
    if (deep) { deepFreeze(value); }else { Object.freeze(value); }
  }
};

var immer = new Immer();
/**
 * The `produce` function takes a value and a "recipe function" (whose
 * return value often depends on the base state). The recipe function is
 * free to mutate its first argument however it wants. All mutations are
 * only ever applied to a __copy__ of the base state.
 *
 * Pass only a function to create a "curried producer" which relieves you
 * from passing the recipe function every time.
 *
 * Only plain objects and arrays are made mutable. All other objects are
 * considered uncopyable.
 *
 * Note: This function is __bound__ to its `Immer` instance.
 *
 * @param {any} base - the initial state
 * @param {Function} producer - function that receives a proxy of the base state as first argument and which can be freely modified
 * @param {Function} patchListener - optional function that will be called with all the patches produced here
 * @returns {any} a new state, or the initial state if nothing was modified
 */

var produce = immer.produce;
/**
 * Like `produce`, but `produceWithPatches` always returns a tuple
 * [nextState, patches, inversePatches] (instead of just the next state)
 */

var produceWithPatches = immer.produceWithPatches.bind(immer);
/**
 * Pass true to automatically freeze all copies created by Immer.
 *
 * By default, auto-freezing is disabled in production.
 */

var setAutoFreeze = immer.setAutoFreeze.bind(immer);
/**
 * Pass true to use the ES2015 `Proxy` class when creating drafts, which is
 * always faster than using ES5 proxies.
 *
 * By default, feature detection is used, so calling this is rarely necessary.
 */

var setUseProxies = immer.setUseProxies.bind(immer);
/**
 * Apply an array of Immer patches to the first argument.
 *
 * This function is a producer, which means copy-on-write is in effect.
 */

var applyPatches$1 = immer.applyPatches.bind(immer);
/**
 * Create an Immer draft from the given base state, which may be a draft itself.
 * The draft can be modified until you finalize it with the `finishDraft` function.
 */

var createDraft = immer.createDraft.bind(immer);
/**
 * Finalize an Immer draft from a `createDraft` call, returning the base state
 * (if no changes were made) or a modified copy. The draft must *not* be
 * mutated afterwards.
 *
 * Pass a function as the 2nd argument to generate Immer patches based on the
 * changes that were made.
 */

var finishDraft = immer.finishDraft.bind(immer);

/* harmony default export */ __webpack_exports__["a"] = (produce);

//# sourceMappingURL=immer.module.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMemoize */
/* unused harmony export createSelectorCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSelector; });
/* unused harmony export createStructuredSelector */
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShowcasePlaceholder__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShowcaseHeader__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShowcaseProductListWrapper__ = __webpack_require__(1323);
var Showcase=function Showcase(_ref){var children=_ref.children,isLoading=_ref.isLoading,products=_ref.products,title=_ref.title,mobileTitle=_ref.mobileTitle,viewAllPath=_ref.viewAllPath;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ShowcasePlaceholder__["a" /* default */],{isLoading:isLoading&&products.length===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'showcard-products container-card container py-1 py-md-3 px-0 px-md-0 mx-1 mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShowcaseHeader__["a" /* default */],{title:title,mobileTitle:mobileTitle,viewAllPath:viewAllPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShowcaseProductListWrapper__["a" /* default */],null,children)));};Showcase.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mobileTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,viewAllPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Showcase);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Products; });
/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{products:[],showcase:{}};var action=arguments[1];switch(action.type){case'FETCH_PRODUCT_SUGGESTIONS':return Object.assign({},state);case'FETCH_PRODUCT_SUGGESTIONS_SUCCESS':return Object.assign({},state,action.payload.data);case'FETCH_PRODUCT_SUGGESTIONS_FAIL':return Object.assign({},state,{error:action.error});case'FETCH_PRODUCT_CARD_AVAILABILITY':return Object.assign({},state);case'FETCH_PRODUCT_CARD_AVAILABILITY_SUCCESS':var availability=action.payload.data[0];var products=state.products;var sku=action.meta.previousAction.sku;var index=products.findIndex(function(p){return p.sku===sku;});if(products[index]){products[index].availability=Object.assign({},availability);}return Object.assign({},state,{products:products});case'FETCH_PRODUCT_CARD_AVAILABILITY_FAIL':return Object.assign({},state,{error_availability:action.error});default:return Object.assign({},state);}});var Products=function Products(productSuggestion){var products=productSuggestion.products,showcase=productSuggestion.showcase;var suggestion={products:products||[],title:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PRODUCTS_SHOWCASE_TITLE||Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_TITLE_SHOWCASE_DEFAULTS||'Troque seus pontos por produtos dos principais e-commerces.',titleOnlyCash:'Compre produtos dos principais e-commerces.',titleMobile:'Produtos',showcase:showcase};return suggestion;};

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__);
var ProductSuggestionPlaceholder=function ProductSuggestionPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card container pt-3 pb-1 py-md-3 px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx--1 mx-md-0 px-2 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1 d-none  d-md-flex '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 d-none d-md-flex px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))))));};/* harmony default export */ __webpack_exports__["a"] = (ProductSuggestionPlaceholder);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Personalized__ = __webpack_require__(549);
/* unused harmony reexport PersonalizedContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ItemToItem__ = __webpack_require__(551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ItemToItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PersonalizedContainer__ = __webpack_require__(1338);
/* unused harmony reexport PersonalizedContainer */
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Products_action__ = __webpack_require__(1337);
var fetchUserRecomendation=function fetchUserRecomendation(client){return function(){return function(dispatch,_){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["a" /* addProducts */])());client.get('/v2/products/recommendations/participant?take=10').then(function(response){var productsList=transformResponseData(response.data);dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["c" /* addProductsSuccess */])(productsList));dispatch({type:'FETCH_USER_RECOMENDATION_SUCCESS',payload:{data:Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["d" /* createListByProp */])(productsList,'sku')}});}).catch(function(err){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["b" /* addProductsFail */])(err));});};};};var fetchItemToItemRecomendation=function fetchItemToItemRecomendation(client){return function(productId){return function(dispatch,_){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["a" /* addProducts */])());client.get('/v2/products/recommendations/product/'+productId+'?take=10').then(function(response){var productsList=transformResponseData(response.data);dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["c" /* addProductsSuccess */])(productsList));dispatch({type:'FETCH_ITEM_TO_ITEM__RECOMENDATION_SUCCESS',payload:{data:Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["d" /* createListByProp */])(productsList,'sku')}});}).catch(function(err){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Products_action__["b" /* addProductsFail */])(err));});};};};var transformResponseData=function transformResponseData(response){return response.map(function(item){return{sku:item.productSkuId,originalId:item.originalProductSkuId,imageUrl:item.imageUrl,name:item.name,productId:item.productId,vendorId:item.vendorId};});};/* harmony default export */ __webpack_exports__["a"] = (function(client){return{fetchUserRecomendation:fetchUserRecomendation(client),fetchItemToItemRecomendation:fetchItemToItemRecomendation(client)};});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemToItemContainer__ = __webpack_require__(1341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ItemToItemContainer__["a"]; });
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var actions=Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */])(client);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Wishlist_WishlistHeart_WishlistHeart__ = __webpack_require__(553);
/* unused harmony reexport WishlistHeart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Wishlist_WishlistHeart_WishlistHeartContainer__ = __webpack_require__(1347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1_Wishlist_WishlistHeart_WishlistHeartContainer__["a"]; });


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WishlistHeart=function(_Component){_inherits(WishlistHeart,_Component);function WishlistHeart(props){_classCallCheck(this,WishlistHeart);var _this=_possibleConstructorReturn(this,(WishlistHeart.__proto__||Object.getPrototypeOf(WishlistHeart)).call(this,props));_this.toggleWishlist=function(){_this.handleLoading();_this.props.toggleWishlist();};_this.handleLoading=function(){_this.setState({isLoading:!_this.state.isLoading});};_this.state={isLoading:false};return _this;}_createClass(WishlistHeart,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.state.isLoading&&prevProps.isInWishlist!==this.props.isInWishlist){this.handleLoading();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'box-card-link-wishlist',role:'button',onClick:this.toggleWishlist,'aria-label':this.state.isLoading?'Carregando...':this.props.isInWishlist?'Remover dos favoritos':'Adicionar aos favoritos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:this.state.isLoading?'icon_loading':this.props.isInWishlist?'icon_wishlist_color':'icon_wishlist',className:'txt-body-lg pointer r-0 t-0 '+this.props.className}));}}]);return WishlistHeart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WishlistHeart.propTypes={isInWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,toggleWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};WishlistHeart.defaultProps={isInWishlist:false,className:''};/* harmony default export */ __webpack_exports__["a"] = (WishlistHeart);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Catalog_Availability_ProductAvailabilityContainer__ = __webpack_require__(1351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_Catalog_Availability_ProductAvailabilityContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Catalog_Availability_IfAvailable__ = __webpack_require__(1362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1_Catalog_Availability_IfAvailable__["a"]; });


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
var Unavailable=function Unavailable(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12 mt-half mb-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-12 m-0 mt-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{id:Math.random().toString(),className:'btn-sm btn-block col-12 py-2 product-unavailable',text:'Produto indispon\xEDvel',disabled:'disabled'}))))));};/* harmony default export */ __webpack_exports__["a"] = (Unavailable);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VoucherSuggestionContainer__ = __webpack_require__(1364);
/* unused harmony reexport VoucherSuggestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["b"]; });


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Vouchers; });
/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{products:[]};var action=arguments[1];switch(action.type){case'FETCH_VOUCHER_SUGGESTIONS':return Object.assign({},state);case'FETCH_VOUCHER_SUGGESTIONS_SUCCESS':return Object.assign({},state,action.payload.data);case'FETCH_VOUCHER_SUGGESTIONS_FAIL':return Object.assign({},state,{error:action.error});case'FETCH_VOUCHER_CARD_AVAILABILITY':return Object.assign({},state);case'FETCH_VOUCHER_CARD_AVAILABILITY_SUCCESS':var availability=action.payload.data[0];var products=state.products;var sku=action.meta.previousAction.sku;var index=products.findIndex(function(p){return p.sku===sku;});if(products[index]){products[index].availability=Object.assign({},availability);}return Object.assign({},state,{products:products});case'FETCH_VOUCHER_CARD_AVAILABILITY_FAIL':return Object.assign({},state,{error_availability:action.error});default:return Object.assign({},state);}});var Vouchers=function Vouchers(voucherSuggestion){var products=voucherSuggestion.products;var voucher={products:products||[],title:'Vale-compras para você presentear.',titleMobile:'Produtos'};return voucher;};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StoreSuggestion__ = __webpack_require__(1366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StoreSuggestion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["b"]; });


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Stores; });
/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{stores:[]};var action=arguments[1];switch(action.type){case'FETCH_STORE_SUGGESTIONS':return Object.assign({},state);case'FETCH_STORE_SUGGESTIONS_SUCCESS':return Object.assign({},state,{stores:action.payload.data});case'FETCH_STORE_SUGGESTIONS_FAIL':return Object.assign({},state,{error:action.error});default:return Object.assign({},state);}});var Stores=function Stores(storeSuggestion){var partnerShowcase=storeSuggestion.stores.partnerBrandShowcase;var stores=null;if(partnerShowcase){stores=partnerShowcase.map(function(item){return{name:item.description,imageUrl:item.banner,background:item.backgroundBanner,id:item.parameterValueId,link:item.linkText};});}var store={stores:stores||[],title:'Encontre as suas lojas favoritas.',titleMobile:'Lojas'};return store;};

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShipping; });
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{value:null,isloading:false,filled:false};var action=arguments[1];switch(action.type){case'FETCH_SHIPPING':return Object.assign({},state,{isloading:true,filled:false});case'FETCH_SHIPPING_SUCCESS':return Object.assign({},state,{isloading:false,value:Object.assign({},action.payload.data),filled:true});case'FETCH_SHIPPING_FAIL':return Object.assign({},state,{isloading:false,value:{},error:action.error.data,filled:false});case'FETCH_BACK_SHIPPING':return Object.assign({},state,{isloading:false,value:{},filled:false});case'ERROR_FILLED_SHIPPING':return Object.assign({},state,{isloading:false,value:{},error:{data:'CEP invalido'},filled:false});default:return Object.assign({},state);}});var getShipping=function getShipping(_ref){var shipping=_ref.shipping;return{isloading:shipping.isloading,value:shipping.value,filled:shipping.filled,error:shipping.error,visible:true};};

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShippingPlaceholder=function(_Component){_inherits(ShippingPlaceholder,_Component);function ShippingPlaceholder(){_classCallCheck(this,ShippingPlaceholder);return _possibleConstructorReturn(this,(ShippingPlaceholder.__proto__||Object.getPrototypeOf(ShippingPlaceholder)).apply(this,arguments));}_createClass(ShippingPlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-form row row-eq-height pt-2 mx-2 pb-2',tabIndex:0,'aria-label':'carregando...'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-5 pr-half pt-5 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-button col-6 col-md-4 form-field pl-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm txt-white','aria-hidden':'true','aria-disabled':'true',disabled:'true','aria-label':'carregando...'},'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-input col-12 col-md-3 form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-auto py-half radius bg-ui-2'}))));}}]);return ShippingPlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ShippingPlaceholder);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ducks__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Catalog_Product_ProductDetail_reducer__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Catalog_Availability__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Catalog_Product_ProductDetail_DetailSection_ProductImage__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Catalog_Product_ProductDetail_RedemptionSection_Payment__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Catalog_Product_ProductDetail_RedemptionSection_Voucher__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Catalog_Product_ProductDetail_DetailSection_ProductTabs__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductDetail_RedemptionSection_Feature__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductDetail_RedemptionSection_AddCartVerify__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductCard_Tagging__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Catalog_Product_ProductDetail_RedemptionSection_Shipping__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Catalog_Product_ProductDetail_RedemptionSection_Shipping_ShippingPlaceholder__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_features_Recomendation__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_App_FingerPrint_FingerPrintContainer__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__loyal_template_products_css__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__loyal_template_products_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__loyal_template_products_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sentry_browser__ = __webpack_require__(575);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductBrandDisplay=function ProductBrandDisplay(_ref){var name=_ref.name;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'h3 txt-brand-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1','aria-label':'Marca: '+name},name);};ProductBrandDisplay.propTypes={name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var ProductBrandDisplayContainer=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function(_ref2,_ref3){var brands=_ref2.brands;var brandId=_ref3.brandId;return brands[brandId];})(ProductBrandDisplay);var ProductNameDisplay=function ProductNameDisplay(_ref4){var name=_ref4.name;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'txt-title-product txt-font-body color-ui-2'},name);};ProductNameDisplay.propTypes={name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var showProductContext=function showProductContext(actualContext,vendorContext){return actualContext===vendorContext;};showProductContext.propTypes={actualContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,vendorContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var VendorDisplay=function VendorDisplay(_ref5){var name=_ref5.name,imageUrl=_ref5.imageUrl;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row border-color-ui-3 border-bottom mx-0 py-2 px-3 card-price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row product-brand w-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-7'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1 h3'},'SOBRE A LOJA'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'aria-hidden':'true'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'hide-absolute'},'Fornecido e entregue por: ',name))),imageUrl&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-brand col-5 txt-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'img-w-auto img-w-90 img-h-90',src:imageUrl,alt:name,'aria-hidden':'true'}))));};VendorDisplay.propTypes={name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var VendorDisplayContainer=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function(_ref6,_ref7){var vendors=_ref6.vendors;var vendorId=_ref7.vendorId;return vendors[vendorId];})(VendorDisplay);var ProductDetail=function ProductDetail(_ref8){var sku=_ref8.sku,originalId=_ref8.originalId,vendorId=_ref8.vendorId,brandId=_ref8.brandId,name=_ref8.name,description=_ref8.description,images=_ref8.images,imageUrl=_ref8.imageUrl,productFeatures=_ref8.productFeatures,detail=_ref8.detail,isOnlyCash=_ref8.isOnlyCash,sendCart=_ref8.sendCart,clickSendCart=_ref8.clickSendCart;Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){window._etmc.push(['setOrgId','6422293']);window._etmc.push(['trackPageView',{'item':originalId}]);},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-product container pt-0 pt-md-5 pb-0 pb-lg-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_App_FingerPrint_FingerPrintContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('title',null,' '+name+' - '+("Tupperware | Premmiar"||''))),sendCart&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductCard_Tagging__["a" /* default */],{type:'clickProduct',identifier:'productPage',position:'0',sku:sku,name:name,vendorId:vendorId,originalId:originalId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductCard_Tagging__["a" /* default */],{type:'viewProduct',identifier:'productPage',position:'0',sku:sku,name:name,vendorId:vendorId,originalId:originalId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product-side col-12 col-lg-7 pr-0 pl-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'border-ui-3 radius pb-3 pb-lg-0  bg-white pt-1 pos-relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Catalog_Product_ProductDetail_DetailSection_ProductImage__["a" /* ProductImage */],{sku:sku,images:images,imageUrl:imageUrl}),description&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Catalog_Product_ProductDetail_DetailSection_ProductTabs__["a" /* ProductTabs */],{isVoucher:detail&&detail.isVoucher,isPhysicalVoucher:detail&&detail.isPhysicalVoucher,description:description,properties:productFeatures.filter(function(feat){return feat.type==='CARACTERÍSTICAS';}),specs:productFeatures.filter(function(feat){return feat.type==='ESPECIFICAÇÕES TÉCNICAS';})})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product-side col-12 col-lg-5  mt-4 mt-lg-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'product-infos col-12 pt-3 px-3 mx-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ProductBrandDisplayContainer,{brandId:brandId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ProductNameDisplay,{name:name})),detail&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductDetail_RedemptionSection_Feature__["a" /* Feature */],{isVoucher:detail.isVoucher,isPhysicalVoucher:detail.isPhysicalVoucher,features:detail.skuFeaturesByType||{},SkuByType:detail.SkuByType}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row border-color-ui-3 border-bottom mx-0 py-2 px-3 card-price'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row product-brand w-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},vendorId&&originalId&&sku&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_Shared_IsResponsiveEnabledContext__["a" /* default */].Provider,{value:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Availability__["b" /* default */],{sku:sku,originalId:originalId,vendorId:vendorId,changeContext:detail&&detail.onlyCash!==undefined?showProductContext(isOnlyCash,detail.onlyCash):true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 button-area',onClick:function onClick(){return clickSendCart();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Availability__["a" /* IfAvailable */],{sku:sku},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductDetail_RedemptionSection_AddCartVerify__["a" /* default */],{sku:sku,vendorId:vendorId,hasVoltage:detail&&typeof detail.skuFeaturesByType!=='undefined'?typeof detail.skuFeaturesByType.VOLTAGEM!=='undefined':false,changeContext:detail&&detail.onlyCash!==undefined?!showProductContext(isOnlyCash,detail.onlyCash):false}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(VendorDisplayContainer,{vendorId:vendorId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Catalog_Product_ProductDetail_RedemptionSection_Voucher__["a" /* Voucher */],{visible:detail&&detail.isVoucher}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Availability__["a" /* IfAvailable */],{sku:sku,component:__WEBPACK_IMPORTED_MODULE_8_Catalog_Product_ProductDetail_RedemptionSection_Payment__["a" /* Payment */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_placeholder___default.a,{ready:!!detail,customPlaceholder:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_Catalog_Product_ProductDetail_RedemptionSection_Shipping_ShippingPlaceholder__["a" /* default */],null)},detail&&showProductContext(isOnlyCash,detail.onlyCash)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_Catalog_Product_ProductDetail_RedemptionSection_Shipping__["a" /* ShippingContainer */],{productSkuId:sku,isVoucher:detail&&detail.isVoucher,isPhysicalVoucher:detail&&detail.isPhysicalVoucher,pointsName:detail&&detail.pointsName})),description&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_responsive___default.a,{maxDeviceWidth:1024},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Catalog_Product_ProductDetail_DetailSection_ProductTabs__["a" /* ProductTabs */],{isVoucher:detail&&detail.isVoucher,isPhysicalVoucher:detail&&detail.isPhysicalVoucher,description:description,properties:productFeatures.filter(function(feat){return feat.type==='CARACTERÍSTICAS';}),specs:productFeatures.filter(function(feat){return feat.type==='ESPECIFICAÇÕES TÉCNICAS';})}))))),Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_RECOMMENDATION_SHOWCASE&&(detail&&!isOnlyCash?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_features_Recomendation__["a" /* ItemToItemContainer */],{productId:detail.productId}):''));};ProductDetail.propTypes={clickSendCart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,sendCart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,sku:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,originalId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,brandId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,images:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productFeatures:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,detail:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({isVoucher:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isPhysicalVoucher:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,skuFeaturesByType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,SkuByType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,payment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool}),isOnlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var ProductDetailContainer=function(_Component){_inherits(ProductDetailContainer,_Component);function ProductDetailContainer(props){_classCallCheck(this,ProductDetailContainer);var _this=_possibleConstructorReturn(this,(ProductDetailContainer.__proto__||Object.getPrototypeOf(ProductDetailContainer)).call(this,props));_this.state={clickSendCart:false};_this.clickSendCart=_this.clickSendCart.bind(_this);return _this;}_createClass(ProductDetailContainer,[{key:'handleDetailUpdate',value:function handleDetailUpdate(){var _props=this.props,loadProductDetail=_props.loadProductDetail,detail=_props.detail;!detail&&loadProductDetail();}},{key:'componentDidMount',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.handleDetailUpdate();case 1:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref9.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function componentDidUpdate(){this.handleDetailUpdate();}},{key:'render',value:function render(){var _props2=this.props,_=_props2.loadProductDetail,props=_objectWithoutProperties(_props2,['loadProductDetail']);__WEBPACK_IMPORTED_MODULE_23__sentry_browser__["a" /* captureMessage */]('Product Detail Test for Pentest');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ProductDetail,Object.assign({sendCart:this.state.clickSendCart,clickSendCart:this.clickSendCart},props));}},{key:'clickSendCart',value:function clickSendCart(){this.setState({clickSendCart:true});}}]);return ProductDetailContainer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ProductDetailContainer.propTypes={loadProductDetail:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,detail:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,isOnlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref10,ownProps){var isOnlyCash=_ref10.onlyCash,products=_ref10.productsv2,state=_objectWithoutProperties(_ref10,['onlyCash','productsv2']);var sku=ownProps.match.params.sku;return Object.assign({isOnlyCash:isOnlyCash,sku:sku},products[sku],{detail:Object(__WEBPACK_IMPORTED_MODULE_5_Catalog_Product_ProductDetail_reducer__["b" /* getProductBySku */])(state,sku)});};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){var sku=ownProps.match.params.sku;return{loadProductDetail:function loadProductDetail(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ducks__["c" /* fetchProduct */])(sku));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductDetailContainer));

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPayment */
/* unused harmony export getSkuImages */
/* unused harmony export getSkuProperties */
/* unused harmony export getSkuSpecs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductBySku; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Catalog_Product_ducks__ = __webpack_require__(156);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case'LOAD_PRODUCT_DETAIL':return Object.assign({},state,_defineProperty({},action.productSkuId,{isLoading:true,availability:null,hasPriceUpdated:false}));case'LOAD_PRODUCT_DETAIL_SUCCESS':case __WEBPACK_IMPORTED_MODULE_0_Catalog_Product_ducks__["a" /* FETCH_PRODUCT_SUCCESS */]:return Object.assign({},state,_defineProperty({},action.meta.previousAction.sku,Object.assign({isLoading:false,availability:null,hasPriceUpdated:false},action.payload.data)));case'LOAD_PRODUCT_DETAIL_ERROR':return Object.assign({},state,_defineProperty({},action.meta.previousAction.productSkuId,Object.assign({isLoading:false,availability:null,hasPriceUpdated:false},action.payload.error)));case'FETCH_PRODUCT_NEW_AVAILABILITY':return Object.assign({},state,_defineProperty({},action.productSkuId,{isLoading:true,availability:null,hasPriceUpdated:false}));case'FETCH_PRODUCT_NEW_AVAILABILITY_SUCCESS':var availability=action.payload.data[0];var sku=action.meta.previousAction.sku;state[sku].availability=Object.assign({},availability);state[sku].hasPriceUpdated=true;return Object.assign({},state);case'FETCH_PRODUCT_NEW_AVAILABILITY_FAIL':var productSkuId=action.meta.previousAction.sku;state[productSkuId].error=action.error;state[productSkuId].hasPriceUpdated=true;state[productSkuId].isLoading=false;state[productSkuId].availability=null;state[productSkuId].hasPriceUpdated=false;return Object.assign({},state);default:return Object.assign({},state);}});var getPayment=function getPayment(state,productSkuId){var _ref=state.availability[productSkuId]||{},isPriceUpdated=_ref.isPriceUpdated,_ref$price=_ref.price;_ref$price=_ref$price===undefined?{}:_ref$price;var newPointCash=_ref$price.pointsCash;if(!isPriceUpdated)return{isVisible:false};var pointsName=state.catalog.currencyConfiguration.pointsName,_state$payment=state.payment,isLoading=_state$payment.isLoading,brands=_state$payment.brands;var isVisible=!!(newPointCash&&newPointCash['installments'].length>0);var description=isVisible&&newPointCash['installments'][0].description;var pointsCash={currencyName:pointsName,points:newPointCash?newPointCash.partialPoints:0,description:description};var Cardbrands={isLoading:isLoading,brands:brands};return{isVisible:isVisible,pointsCash:pointsCash,Cardbrands:Cardbrands};};var getSkuImages=function getSkuImages(productSku){return productSku.images.map(function(image){return{original:image.largeImage||image.mediumImage,thumbnail:image.smallImage};});};var getSkuProperties=function getSkuProperties(productBySku){return productBySku.features.filter(function(feat){return feat.type==='CARACTERÍSTICAS';});};var getSkuSpecs=function getSkuSpecs(productBySku){return productBySku.features.filter(function(feat){return feat.type==='ESPECIFICAÇÕES TÉCNICAS';});};var getProductBySku=function getProductBySku(state,productSkuId){var productBySku=state.productsBySku[productSkuId];if(!productBySku||productBySku.isLoading)return null;var productSku=productBySku.skus.filter(function(_ref2){var sku=_ref2.sku;return sku===productSkuId;})[0];var isVoucher=productBySku.vendor.type==='EXTERNALVOUCHERVIRTUAL';var isPhysicalVoucher=productBySku.vendor.type==='PHYSICALVOUCHER';var skuFeatures=productBySku.skus.map(function(_ref3){var sku=_ref3.sku,skuFeatures=_ref3.skuFeatures;return skuFeatures.map(function(feature){return Object.assign({sku:sku},feature);});}).reduce(function(acc,curr){return[].concat(_toConsumableArray(acc),_toConsumableArray(curr));},[]);// let originalId
// productBySku.skus.map(product => {
//   if (product.sku === productSkuId) {
//     originalId = product.originalId
//   }
// })
var skuType=[];skuFeatures.forEach(function(element){var index=skuType.findIndex(function(x){return x.sku===element.sku;});if(index===-1){skuType.push({sku:element.sku,currentSku:element.sku===productSkuId});}});skuFeatures.forEach(function(element){var index=skuType.findIndex(function(x){return x.sku===element.sku;});if(index!==-1){skuType[index][element.type]=element.value;}});var composeSkuFeaturesByType=skuFeatures.reduce(function(acc,curr,idx){return Object.assign({},acc,_defineProperty({},curr.type,[].concat(_toConsumableArray(acc[curr.type]||{}),[{sku:curr.sku,value:curr.value}])));},{});var skuFeaturesByType=Object.keys(composeSkuFeaturesByType).reduce(function(acc,curr){return Object.assign({},acc,_defineProperty({},curr,composeSkuFeaturesByType[curr].reduce(function(acc,curr){return Object.assign({},acc,_defineProperty({},curr.value,[].concat(_toConsumableArray(acc[curr.value]||{}),[{sku:curr.sku,currentSku:curr.sku===productSkuId}])));},{})));},{});// const availability = productBySku.hasPriceUpdated
//   ? productBySku.availability
//   : {
//     sku: productSku.sku,
//     originalId: originalId,
//     vendorId: productBySku.vendor.id
//   }
// const payment = getPayment(state, productSkuId)
var itemCart=isVoucher?{sku:productSku.sku,vendorId:productBySku.vendor.id,email:state&&state.oidc&&state.oidc.user&&state.oidc.user.profile&&state.oidc.user.profile.email}:{sku:productSku.sku,vendorId:productBySku.vendor.id};return{productId:productBySku.id,brandName:productBySku.brand?productBySku.brand.name:'',productName:productBySku.name,isLoading:false,images:getSkuImages(productSku),isVoucher:isVoucher,isPhysicalVoucher:isPhysicalVoucher,description:productBySku.description,properties:!isVoucher?getSkuProperties(productBySku):null,specs:getSkuSpecs(productBySku),skuFeatures:skuFeatures,skuFeaturesByType:skuFeaturesByType,SkuByType:skuType,partner:{name:productBySku.vendor.name,logo:productBySku.vendor.logoUrl},vendorId:productBySku.vendor.id,hasPriceUpdated:productBySku.hasPriceUpdated,availability:state.availability[productSkuId],itemCart:itemCart,onlyCash:productBySku.onlyCash!==null?productBySku.onlyCash:false};};

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductImage__ = __webpack_require__(1377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductImagePlaceholder__ = __webpack_require__(1382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ProductImagePlaceholder__["a"]; });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSwipeable = __webpack_require__(1378);

var _lodash = __webpack_require__(1379);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1380);

var _lodash4 = _interopRequireDefault(_lodash3);

var _resizeObserverPolyfill = __webpack_require__(1381);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var screenChangeEvents = ['fullscreenchange', 'MSFullscreenChange', 'mozfullscreenchange', 'webkitfullscreenchange'];

var ImageGallery = function (_React$Component) {
  _inherits(ImageGallery, _React$Component);

  function ImageGallery(props) {
    _classCallCheck(this, ImageGallery);

    var _this = _possibleConstructorReturn(this, (ImageGallery.__proto__ || Object.getPrototypeOf(ImageGallery)).call(this, props));

    _this.slideToIndex = function (index, event) {
      var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          isTransitioning = _this$state.isTransitioning;


      if (!isTransitioning) {
        if (event) {
          if (_this._intervalId) {
            // user triggered event while ImageGallery is playing, reset interval
            _this.pause(false);
            _this.play(false);
          }
        }

        var slideCount = _this.props.items.length - 1;
        var nextIndex = index;

        if (index < 0) {
          nextIndex = slideCount;
        } else if (index > slideCount) {
          nextIndex = 0;
        }

        _this.setState({
          previousIndex: currentIndex,
          currentIndex: nextIndex,
          isTransitioning: nextIndex !== currentIndex,
          offsetPercentage: 0,
          style: {
            transition: 'all ' + _this.props.slideDuration + 'ms ease-out'
          }
        }, _this._onSliding);
      }
    };

    _this._onSliding = function () {
      var isTransitioning = _this.state.isTransitioning;

      _this._transitionTimer = window.setTimeout(function () {
        if (isTransitioning) {
          _this.setState({ isTransitioning: !isTransitioning });
          if (_this.props.onSlide) {
            _this.props.onSlide(_this.state.currentIndex);
          }
        }
      }, _this.props.slideDuration + 50);
    };

    _this._handleScreenChange = function () {
      /*
        handles screen change events that the browser triggers e.g. esc key
      */
      var fullScreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

      if (_this.props.onScreenChange) {
        _this.props.onScreenChange(fullScreenElement);
      }

      _this.setState({ isFullscreen: !!fullScreenElement });
    };

    _this._toggleFullScreen = function () {
      if (_this.state.isFullscreen) {
        _this.exitFullScreen();
      } else {
        _this.fullScreen();
      }
    };

    _this._togglePlay = function () {
      if (_this._intervalId) {
        _this.pause();
      } else {
        _this.play();
      }
    };

    _this._initGalleryResizing = function (element) {
      /*
        When image-gallery-slide-wrapper unmounts and mounts when thumbnail bar position is changed
        ref is called twice, once with null and another with the element.
        Make sure element is available before calling observe.
      */
      if (element) {
        _this._imageGallerySlideWrapper = element;
        _this.resizeObserver = new _resizeObserverPolyfill2.default(_this._createResizeObserver);
        _this.resizeObserver.observe(element);
      }
    };

    _this._createResizeObserver = (0, _lodash4.default)(function (entries) {
      if (!entries) return;
      entries.forEach(function () {
        _this._handleResize();
      });
    }, 300);

    _this._handleResize = function () {
      var currentIndex = _this.state.currentIndex;

      if (_this._imageGallery) {
        _this.setState({
          galleryWidth: _this._imageGallery.offsetWidth
        });
      }

      if (_this._imageGallerySlideWrapper) {
        _this.setState({
          gallerySlideWrapperHeight: _this._imageGallerySlideWrapper.offsetHeight
        });
      }

      if (_this._thumbnailsWrapper) {
        if (_this._isThumbnailVertical()) {
          _this.setState({ thumbnailsWrapperHeight: _this._thumbnailsWrapper.offsetHeight });
        } else {
          _this.setState({ thumbnailsWrapperWidth: _this._thumbnailsWrapper.offsetWidth });
        }
      }

      // Adjust thumbnail container when thumbnail width or height is adjusted
      _this._setThumbsTranslate(-_this._getThumbsTranslate(currentIndex));
    };

    _this._handleKeyDown = function (event) {
      if (_this.props.disableArrowKeys) {
        return;
      }
      var LEFT_ARROW = 37;
      var RIGHT_ARROW = 39;
      var ESC_KEY = 27;
      var key = parseInt(event.keyCode || event.which || 0);

      switch (key) {
        case LEFT_ARROW:
          if (_this._canSlideLeft() && !_this._intervalId) {
            _this._slideLeft();
          }
          break;
        case RIGHT_ARROW:
          if (_this._canSlideRight() && !_this._intervalId) {
            _this._slideRight();
          }
          break;
        case ESC_KEY:
          if (_this.state.isFullscreen && !_this.props.useBrowserFullscreen) {
            _this.exitFullScreen();
          }
      }
    };

    _this._handleImageError = function (event) {
      if (_this.props.defaultImage && event.target.src.indexOf(_this.props.defaultImage) === -1) {
        event.target.src = _this.props.defaultImage;
      }
    };

    _this._handleOnSwiped = function (_ref) {
      var event = _ref.event,
          dir = _ref.dir,
          velocity = _ref.velocity;

      if (_this.props.disableSwipe) return;
      var _this$state2 = _this.state,
          scrollingUpDown = _this$state2.scrollingUpDown,
          scrollingLeftRight = _this$state2.scrollingLeftRight;
      var isRTL = _this.props.isRTL;

      if (_this.props.stopPropagation) event.stopPropagation();
      if (scrollingUpDown) {
        // user stopped scrollingUpDown
        _this.setState({ scrollingUpDown: false });
      }

      if (scrollingLeftRight) {
        // user stopped scrollingLeftRight
        _this.setState({ scrollingLeftRight: false });
      }

      if (!scrollingUpDown) {
        // don't swipe if user is scrolling
        var side = (dir === _reactSwipeable.LEFT ? 1 : -1) * (isRTL ? -1 : 1); // if it is RTL the direction is reversed
        var isFlick = velocity > _this.props.flickThreshold;
        _this._handleOnSwipedTo(side, isFlick);
      }
    };

    _this._handleSwiping = function (_ref2) {
      var event = _ref2.event,
          absX = _ref2.absX,
          dir = _ref2.dir;

      if (_this.props.disableSwipe) return;
      var _this$state3 = _this.state,
          galleryWidth = _this$state3.galleryWidth,
          isTransitioning = _this$state3.isTransitioning,
          scrollingUpDown = _this$state3.scrollingUpDown,
          scrollingLeftRight = _this$state3.scrollingLeftRight;
      var swipingTransitionDuration = _this.props.swipingTransitionDuration;

      _this._setScrollDirection(dir);
      if (_this.props.stopPropagation) event.stopPropagation();
      if ((_this.props.preventDefaultTouchmoveEvent || scrollingLeftRight) && event.cancelable) event.preventDefault();
      if (!isTransitioning && !scrollingUpDown) {
        var side = dir === _reactSwipeable.RIGHT ? 1 : -1;

        var offsetPercentage = absX / galleryWidth * 100;
        if (Math.abs(offsetPercentage) >= 100) {
          offsetPercentage = 100;
        }

        var swipingTransition = {
          transition: 'transform ' + swipingTransitionDuration + 'ms ease-out'
        };

        _this.setState({
          offsetPercentage: side * offsetPercentage,
          style: swipingTransition
        });
      } else {
        // don't move the slide
        _this.setState({ offsetPercentage: 0 });
      }
    };

    _this._slideLeft = function () {
      _this.props.isRTL ? _this._slideNext() : _this._slidePrevious();
    };

    _this._slideRight = function () {
      _this.props.isRTL ? _this._slidePrevious() : _this._slideNext();
    };

    _this._slidePrevious = function (event) {
      _this.slideToIndex(_this.state.currentIndex - 1, event);
    };

    _this._slideNext = function (event) {
      _this.slideToIndex(_this.state.currentIndex + 1, event);
    };

    _this._renderItem = function (item) {
      var onImageError = _this.props.onImageError || _this._handleImageError;

      return _react2.default.createElement(
        'div',
        { className: 'image-gallery-image' },
        item.imageSet ? _react2.default.createElement(
          'picture',
          {
            onLoad: _this.props.onImageLoad,
            onError: onImageError
          },
          item.imageSet.map(function (source, index) {
            return _react2.default.createElement('source', {
              key: index,
              media: source.media,
              srcSet: source.srcSet,
              type: source.type
            });
          }),
          _react2.default.createElement('img', {
            alt: item.originalAlt,
            src: item.original
          })
        ) : _react2.default.createElement('img', {
          src: item.original,
          alt: item.originalAlt,
          srcSet: item.srcSet,
          sizes: item.sizes,
          title: item.originalTitle,
          onLoad: _this.props.onImageLoad,
          onError: onImageError
        }),
        item.description && _react2.default.createElement(
          'span',
          { className: 'image-gallery-description' },
          item.description
        )
      );
    };

    _this._renderThumbInner = function (item) {
      var onThumbnailError = _this.props.onThumbnailError || _this._handleImageError;

      return _react2.default.createElement(
        'div',
        { className: 'image-gallery-thumbnail-inner' },
        _react2.default.createElement('img', {
          src: item.thumbnail,
          alt: item.thumbnailAlt,
          title: item.thumbnailTitle,
          onError: onThumbnailError
        }),
        item.thumbnailLabel && _react2.default.createElement(
          'div',
          { className: 'image-gallery-thumbnail-label' },
          item.thumbnailLabel
        )
      );
    };

    _this._onThumbnailClick = function (event, index) {
      _this.slideToIndex(index, event);
      if (_this.props.onThumbnailClick) {
        _this.props.onThumbnailClick(event, index);
      }
    };

    _this._onThumbnailMouseOver = function (event, index) {
      if (_this._thumbnailMouseOverTimer) {
        window.clearTimeout(_this._thumbnailMouseOverTimer);
        _this._thumbnailMouseOverTimer = null;
      }
      _this._thumbnailMouseOverTimer = window.setTimeout(function () {
        _this.slideToIndex(index);
        _this.pause();
      }, 300);
    };

    _this._onThumbnailMouseLeave = function () {
      if (_this._thumbnailMouseOverTimer) {
        window.clearTimeout(_this._thumbnailMouseOverTimer);
        _this._thumbnailMouseOverTimer = null;
        if (_this.props.autoPlay) {
          _this.play();
        }
      }
    };

    _this.state = {
      currentIndex: props.startIndex,
      thumbsTranslate: 0,
      offsetPercentage: 0,
      galleryWidth: 0,
      thumbnailsWrapperWidth: 0,
      thumbnailsWrapperHeight: 0,
      isFullscreen: false,
      isPlaying: false
    };

    // Used to update the throttle if slideDuration changes
    _this._unthrottledSlideToIndex = _this.slideToIndex;
    _this.slideToIndex = (0, _lodash2.default)(_this._unthrottledSlideToIndex, props.slideDuration, { trailing: false });

    if (props.lazyLoad) {
      _this._lazyLoaded = [];
    }
    return _this;
  }

  _createClass(ImageGallery, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var itemsSizeChanged = prevProps.items.length !== this.props.items.length;
      var itemsChanged = prevProps.items !== this.props.items;
      var startIndexUpdated = prevProps.startIndex !== this.props.startIndex;
      if (itemsSizeChanged) {
        this._handleResize();
      }
      if (prevState.currentIndex !== this.state.currentIndex) {
        this._slideThumbnailBar(prevState.currentIndex);
      }
      // if slideDuration changes, update slideToIndex throttle
      if (prevProps.slideDuration !== this.props.slideDuration) {
        this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, { trailing: false });
      }
      if (this.props.lazyLoad && (!prevProps.lazyLoad || itemsChanged)) {
        this._lazyLoaded = [];
      }

      if (startIndexUpdated || itemsChanged) {
        this.setState({ currentIndex: this.props.startIndex });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoPlay) {
        this.play();
      }
      window.addEventListener('keydown', this._handleKeyDown);
      this._onScreenChangeEvent();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this._handleKeyDown);

      this._offScreenChangeEvent();

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
      }

      if (this.resizeObserver && this._imageGallerySlideWrapper) {
        this.resizeObserver.unobserve(this._imageGallerySlideWrapper);
      }

      if (this._transitionTimer) {
        window.clearTimeout(this._transitionTimer);
      }

      if (this._createResizeObserver) {
        this._createResizeObserver();
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this2 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this._intervalId) {
        var _props = this.props,
            slideInterval = _props.slideInterval,
            slideDuration = _props.slideDuration;

        this.setState({ isPlaying: true });
        this._intervalId = window.setInterval(function () {
          if (!_this2.props.infinite && !_this2._canSlideRight()) {
            _this2.pause();
          } else {
            _this2.slideToIndex(_this2.state.currentIndex + 1);
          }
        }, Math.max(slideInterval, slideDuration));

        if (this.props.onPlay && callback) {
          this.props.onPlay(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
        this.setState({ isPlaying: false });

        if (this.props.onPause && callback) {
          this.props.onPause(this.state.currentIndex);
        }
      }
    }
  }, {
    key: 'setModalFullscreen',
    value: function setModalFullscreen(state) {
      this.setState({ modalFullscreen: state });
      // manually call because browser does not support screenchange events
      if (this.props.onScreenChange) {
        this.props.onScreenChange(state);
      }
    }
  }, {
    key: 'fullScreen',
    value: function fullScreen() {
      var gallery = this._imageGallery;

      if (this.props.useBrowserFullscreen) {
        if (gallery.requestFullscreen) {
          gallery.requestFullscreen();
        } else if (gallery.msRequestFullscreen) {
          gallery.msRequestFullscreen();
        } else if (gallery.mozRequestFullScreen) {
          gallery.mozRequestFullScreen();
        } else if (gallery.webkitRequestFullscreen) {
          gallery.webkitRequestFullscreen();
        } else {
          // fallback to fullscreen modal for unsupported browsers
          this.setModalFullscreen(true);
        }
      } else {
        this.setModalFullscreen(true);
      }

      this.setState({ isFullscreen: true });
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      if (this.state.isFullscreen) {
        if (this.props.useBrowserFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else {
            // fallback to fullscreen modal for unsupported browsers
            this.setModalFullscreen(false);
          }
        } else {
          this.setModalFullscreen(false);
        }

        this.setState({ isFullscreen: false });
      }
    }
  }, {
    key: 'getCurrentIndex',
    value: function getCurrentIndex() {
      return this.state.currentIndex;
    }
  }, {
    key: '_onScreenChangeEvent',
    value: function _onScreenChangeEvent() {
      var _this3 = this;

      screenChangeEvents.map(function (eventName) {
        document.addEventListener(eventName, _this3._handleScreenChange);
      });
    }
  }, {
    key: '_offScreenChangeEvent',
    value: function _offScreenChangeEvent() {
      var _this4 = this;

      screenChangeEvents.map(function (eventName) {
        document.removeEventListener(eventName, _this4._handleScreenChange);
      });
    }
  }, {
    key: '_isThumbnailVertical',
    value: function _isThumbnailVertical() {
      var thumbnailPosition = this.props.thumbnailPosition;

      return thumbnailPosition === 'left' || thumbnailPosition === 'right';
    }
  }, {
    key: '_setScrollDirection',
    value: function _setScrollDirection(dir) {
      var _state = this.state,
          scrollingUpDown = _state.scrollingUpDown,
          scrollingLeftRight = _state.scrollingLeftRight;


      if (!scrollingUpDown && !scrollingLeftRight) {
        if (dir === _reactSwipeable.LEFT || dir === _reactSwipeable.RIGHT) {
          this.setState({ scrollingLeftRight: true });
        } else {
          this.setState({ scrollingUpDown: true });
        }
      }
    }
  }, {
    key: '_handleOnSwipedTo',
    value: function _handleOnSwipedTo(side, isFlick) {
      var _state2 = this.state,
          currentIndex = _state2.currentIndex,
          isTransitioning = _state2.isTransitioning;

      var slideTo = currentIndex;

      if ((this._sufficientSwipeOffset() || isFlick) && !isTransitioning) {
        slideTo += side;
      }

      if (side < 0) {
        if (!this._canSlideLeft()) {
          slideTo = currentIndex;
        }
      } else {
        if (!this._canSlideRight()) {
          slideTo = currentIndex;
        }
      }

      this._unthrottledSlideToIndex(slideTo);
    }
  }, {
    key: '_sufficientSwipeOffset',
    value: function _sufficientSwipeOffset() {
      return Math.abs(this.state.offsetPercentage) > this.props.swipeThreshold;
    }
  }, {
    key: '_canNavigate',
    value: function _canNavigate() {
      return this.props.items.length >= 2;
    }
  }, {
    key: '_canSlideLeft',
    value: function _canSlideLeft() {
      return this.props.infinite || (this.props.isRTL ? this._canSlideNext() : this._canSlidePrevious());
    }
  }, {
    key: '_canSlideRight',
    value: function _canSlideRight() {
      return this.props.infinite || (this.props.isRTL ? this._canSlidePrevious() : this._canSlideNext());
    }
  }, {
    key: '_canSlidePrevious',
    value: function _canSlidePrevious() {
      return this.state.currentIndex > 0;
    }
  }, {
    key: '_canSlideNext',
    value: function _canSlideNext() {
      return this.state.currentIndex < this.props.items.length - 1;
    }
  }, {
    key: '_slideThumbnailBar',
    value: function _slideThumbnailBar(previousIndex) {
      var _state3 = this.state,
          thumbsTranslate = _state3.thumbsTranslate,
          currentIndex = _state3.currentIndex;

      if (this.state.currentIndex === 0) {
        this._setThumbsTranslate(0);
      } else {
        var indexDifference = Math.abs(previousIndex - currentIndex);
        var scroll = this._getThumbsTranslate(indexDifference);
        if (scroll > 0) {
          if (previousIndex < currentIndex) {
            this._setThumbsTranslate(thumbsTranslate - scroll);
          } else if (previousIndex > currentIndex) {
            this._setThumbsTranslate(thumbsTranslate + scroll);
          }
        }
      }
    }
  }, {
    key: '_setThumbsTranslate',
    value: function _setThumbsTranslate(thumbsTranslate) {
      this.setState({ thumbsTranslate: thumbsTranslate });
    }
  }, {
    key: '_getThumbsTranslate',
    value: function _getThumbsTranslate(indexDifference) {
      if (this.props.disableThumbnailScroll) {
        return 0;
      }

      var _state4 = this.state,
          thumbnailsWrapperWidth = _state4.thumbnailsWrapperWidth,
          thumbnailsWrapperHeight = _state4.thumbnailsWrapperHeight;

      var totalScroll = void 0;

      if (this._thumbnails) {
        // total scroll required to see the last thumbnail
        if (this._isThumbnailVertical()) {
          if (this._thumbnails.scrollHeight <= thumbnailsWrapperHeight) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollHeight - thumbnailsWrapperHeight;
        } else {
          if (this._thumbnails.scrollWidth <= thumbnailsWrapperWidth || thumbnailsWrapperWidth <= 0) {
            return 0;
          }
          totalScroll = this._thumbnails.scrollWidth - thumbnailsWrapperWidth;
        }

        var totalThumbnails = this._thumbnails.children.length;
        // scroll-x required per index change
        var perIndexScroll = totalScroll / (totalThumbnails - 1);

        return indexDifference * perIndexScroll;
      }
    }
  }, {
    key: '_getAlignmentClassName',
    value: function _getAlignmentClassName(index) {
      /*
        Necessary for lazing loading
      */
      var currentIndex = this.state.currentIndex;

      var alignment = '';
      var leftClassName = 'left';
      var centerClassName = 'center';
      var rightClassName = 'right';

      switch (index) {
        case currentIndex - 1:
          alignment = ' ' + leftClassName;
          break;
        case currentIndex:
          alignment = ' ' + centerClassName;
          break;
        case currentIndex + 1:
          alignment = ' ' + rightClassName;
          break;
      }

      if (this.props.items.length >= 3 && this.props.infinite) {
        if (index === 0 && currentIndex === this.props.items.length - 1) {
          // set first slide as right slide if were sliding right from last slide
          alignment = ' ' + rightClassName;
        } else if (index === this.props.items.length - 1 && currentIndex === 0) {
          // set last slide as left slide if were sliding left from first slide
          alignment = ' ' + leftClassName;
        }
      }

      return alignment;
    }
  }, {
    key: '_isGoingFromFirstToLast',
    value: function _isGoingFromFirstToLast() {
      var _state5 = this.state,
          currentIndex = _state5.currentIndex,
          previousIndex = _state5.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === 0 && currentIndex === totalSlides;
    }
  }, {
    key: '_isGoingFromLastToFirst',
    value: function _isGoingFromLastToFirst() {
      var _state6 = this.state,
          currentIndex = _state6.currentIndex,
          previousIndex = _state6.previousIndex;

      var totalSlides = this.props.items.length - 1;
      return previousIndex === totalSlides && currentIndex === 0;
    }
  }, {
    key: '_getTranslateXForTwoSlide',
    value: function _getTranslateXForTwoSlide(index) {
      // For taking care of infinite swipe when there are only two slides
      var _state7 = this.state,
          currentIndex = _state7.currentIndex,
          offsetPercentage = _state7.offsetPercentage,
          previousIndex = _state7.previousIndex;

      var baseTranslateX = -100 * currentIndex;
      var translateX = baseTranslateX + index * 100 + offsetPercentage;

      // keep track of user swiping direction
      if (offsetPercentage > 0) {
        this.direction = 'left';
      } else if (offsetPercentage < 0) {
        this.direction = 'right';
      }

      // when swiping make sure the slides are on the correct side
      if (currentIndex === 0 && index === 1 && offsetPercentage > 0) {
        translateX = -100 + offsetPercentage;
      } else if (currentIndex === 1 && index === 0 && offsetPercentage < 0) {
        translateX = 100 + offsetPercentage;
      }

      if (currentIndex !== previousIndex) {
        // when swiped move the slide to the correct side
        if (previousIndex === 0 && index === 0 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = 100;
        } else if (previousIndex === 1 && index === 1 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = -100;
        }
      } else {
        // keep the slide on the correct slide even when not a swipe
        if (currentIndex === 0 && index === 1 && offsetPercentage === 0 && this.direction === 'left') {
          translateX = -100;
        } else if (currentIndex === 1 && index === 0 && offsetPercentage === 0 && this.direction === 'right') {
          translateX = 100;
        }
      }

      return translateX;
    }
  }, {
    key: '_getThumbnailBarHeight',
    value: function _getThumbnailBarHeight() {
      if (this._isThumbnailVertical()) {
        return {
          height: this.state.gallerySlideWrapperHeight
        };
      }
      return {};
    }
  }, {
    key: '_shouldPushSlideOnInfiniteMode',
    value: function _shouldPushSlideOnInfiniteMode(index) {
      /*
        Push(show) slide if slide is the current slide, and the next slide
        OR
        The slide is going more than 1 slide left, or right, but not going from
        first to last and not going from last to first
         There is an edge case where if you go to the first or last slide, when they're
        not left, or right of each other they will try to catch up in the background
        so unless were going from first to last or vice versa we don't want the first
        or last slide to show up during our transition
      */
      return !this._slideIsTransitioning(index) || this._ignoreIsTransitioning() && !this._isFirstOrLastSlide(index);
    }
  }, {
    key: '_slideIsTransitioning',
    value: function _slideIsTransitioning(index) {
      /*
      returns true if the gallery is transitioning and the index is not the
      previous or currentIndex
      */
      var _state8 = this.state,
          isTransitioning = _state8.isTransitioning,
          previousIndex = _state8.previousIndex,
          currentIndex = _state8.currentIndex;

      var indexIsNotPreviousOrNextSlide = !(index === previousIndex || index === currentIndex);
      return isTransitioning && indexIsNotPreviousOrNextSlide;
    }
  }, {
    key: '_isFirstOrLastSlide',
    value: function _isFirstOrLastSlide(index) {
      var totalSlides = this.props.items.length - 1;
      var isLastSlide = index === totalSlides;
      var isFirstSlide = index === 0;
      return isLastSlide || isFirstSlide;
    }
  }, {
    key: '_ignoreIsTransitioning',
    value: function _ignoreIsTransitioning() {
      /*
        Ignore isTransitioning because were not going to sibling slides
        e.g. center to left or center to right
      */
      var _state9 = this.state,
          previousIndex = _state9.previousIndex,
          currentIndex = _state9.currentIndex;

      var totalSlides = this.props.items.length - 1;
      // we want to show the in between slides transition
      var slidingMoreThanOneSlideLeftOrRight = Math.abs(previousIndex - currentIndex) > 1;
      var notGoingFromFirstToLast = !(previousIndex === 0 && currentIndex === totalSlides);
      var notGoingFromLastToFirst = !(previousIndex === totalSlides && currentIndex === 0);

      return slidingMoreThanOneSlideLeftOrRight && notGoingFromFirstToLast && notGoingFromLastToFirst;
    }
  }, {
    key: '_getSlideStyle',
    value: function _getSlideStyle(index) {
      var _state10 = this.state,
          currentIndex = _state10.currentIndex,
          offsetPercentage = _state10.offsetPercentage;
      var _props2 = this.props,
          infinite = _props2.infinite,
          items = _props2.items,
          useTranslate3D = _props2.useTranslate3D,
          isRTL = _props2.isRTL;

      var baseTranslateX = -100 * currentIndex;
      var totalSlides = items.length - 1;

      // calculates where the other slides belong based on currentIndex
      // if it is RTL the base line should be reversed
      var translateX = (baseTranslateX + index * 100) * (isRTL ? -1 : 1) + offsetPercentage;

      if (infinite && items.length > 2) {
        if (currentIndex === 0 && index === totalSlides) {
          // make the last slide the slide before the first
          // if it is RTL the base line should be reversed
          translateX = -100 * (isRTL ? -1 : 1) + offsetPercentage;
        } else if (currentIndex === totalSlides && index === 0) {
          // make the first slide the slide after the last
          // if it is RTL the base line should be reversed
          translateX = 100 * (isRTL ? -1 : 1) + offsetPercentage;
        }
      }

      // Special case when there are only 2 items with infinite on
      if (infinite && items.length === 2) {
        translateX = this._getTranslateXForTwoSlide(index);
      }

      var translate = 'translate(' + translateX + '%, 0)';

      if (useTranslate3D) {
        translate = 'translate3d(' + translateX + '%, 0, 0)';
      }

      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: '_getThumbnailStyle',
    value: function _getThumbnailStyle() {
      var translate = void 0;
      var _props3 = this.props,
          useTranslate3D = _props3.useTranslate3D,
          isRTL = _props3.isRTL;
      var thumbsTranslate = this.state.thumbsTranslate;

      var verticalTranslateValue = isRTL ? thumbsTranslate * -1 : thumbsTranslate;

      if (this._isThumbnailVertical()) {
        translate = 'translate(0, ' + thumbsTranslate + 'px)';
        if (useTranslate3D) {
          translate = 'translate3d(0, ' + thumbsTranslate + 'px, 0)';
        }
      } else {
        translate = 'translate(' + verticalTranslateValue + 'px, 0)';
        if (useTranslate3D) {
          translate = 'translate3d(' + verticalTranslateValue + 'px, 0, 0)';
        }
      }
      return {
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        transform: translate
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state11 = this.state,
          currentIndex = _state11.currentIndex,
          isFullscreen = _state11.isFullscreen,
          modalFullscreen = _state11.modalFullscreen,
          isPlaying = _state11.isPlaying;
      var _props4 = this.props,
          infinite = _props4.infinite,
          slideOnThumbnailOver = _props4.slideOnThumbnailOver,
          isRTL = _props4.isRTL,
          lazyLoad = _props4.lazyLoad;


      var thumbnailStyle = this._getThumbnailStyle();
      var thumbnailPosition = this.props.thumbnailPosition;

      var slideLeft = this._slideLeft;
      var slideRight = this._slideRight;

      var slides = [];
      var thumbnails = [];
      var bullets = [];

      this.props.items.forEach(function (item, index) {
        var alignment = _this5._getAlignmentClassName(index);
        var originalClass = item.originalClass ? ' ' + item.originalClass : '';
        var thumbnailClass = item.thumbnailClass ? ' ' + item.thumbnailClass : '';

        var renderItem = item.renderItem || _this5.props.renderItem || _this5._renderItem;

        var renderThumbInner = item.renderThumbInner || _this5.props.renderThumbInner || _this5._renderThumbInner;

        var showItem = !lazyLoad || alignment || _this5._lazyLoaded[index];
        if (showItem && lazyLoad && !_this5._lazyLoaded[index]) {
          _this5._lazyLoaded[index] = true;
        }

        var slideStyle = _this5._getSlideStyle(index);

        var slide = _react2.default.createElement(
          'div',
          {
            key: index,
            className: 'image-gallery-slide' + alignment + originalClass,
            style: _extends(slideStyle, _this5.state.style),
            onClick: _this5.props.onClick,
            onTouchMove: _this5.props.onTouchMove,
            onTouchEnd: _this5.props.onTouchEnd,
            onTouchStart: _this5.props.onTouchStart,
            onMouseOver: _this5.props.onMouseOver,
            onMouseLeave: _this5.props.onMouseLeave,
            role: _this5.props.onClick && 'button'
          },
          showItem ? renderItem(item) : _react2.default.createElement('div', { style: { height: '100%' } })
        );

        if (infinite) {
          // don't add some slides while transitioning to avoid background transitions
          if (_this5._shouldPushSlideOnInfiniteMode(index)) {
            slides.push(slide);
          }
        } else {
          slides.push(slide);
        }

        if (_this5.props.showThumbnails) {
          thumbnails.push(_react2.default.createElement(
            'a',
            {
              key: index,
              role: 'button',
              'aria-pressed': currentIndex === index ? 'true' : 'false',
              'aria-label': 'Go to Slide ' + (index + 1),
              className: 'image-gallery-thumbnail' + (currentIndex === index ? ' active' : '') + thumbnailClass,
              onMouseLeave: slideOnThumbnailOver ? _this5._onThumbnailMouseLeave : undefined,
              onMouseOver: function onMouseOver(event) {
                return slideOnThumbnailOver ? _this5._onThumbnailMouseOver(event, index) : undefined;
              },
              onClick: function onClick(event) {
                return _this5._onThumbnailClick(event, index);
              }
            },
            renderThumbInner(item)
          ));
        }

        if (_this5.props.showBullets) {
          var bulletOnClick = function bulletOnClick(event) {
            if (item.bulletOnClick) {
              item.bulletOnClick({ item: item, itemIndex: index, currentIndex: currentIndex });
            }
            return _this5.slideToIndex.call(_this5, index, event);
          };
          bullets.push(_react2.default.createElement('button', {
            key: index,
            type: 'button',
            className: ['image-gallery-bullet', currentIndex === index ? 'active' : '', item.bulletClass || ''].join(' '),
            onClick: bulletOnClick,
            'aria-pressed': currentIndex === index ? 'true' : 'false',
            'aria-label': 'Go to Slide ' + (index + 1)
          }));
        }
      });

      var slideWrapper = _react2.default.createElement(
        'div',
        {
          ref: this._initGalleryResizing,
          className: 'image-gallery-slide-wrapper ' + thumbnailPosition + ' ' + (isRTL ? 'image-gallery-rtl' : '')
        },
        this.props.renderCustomControls && this.props.renderCustomControls(),
        this.props.showFullscreenButton && this.props.renderFullscreenButton(this._toggleFullScreen, isFullscreen),
        this.props.showPlayButton && this.props.renderPlayPauseButton(this._togglePlay, isPlaying),
        this._canNavigate() ? [this.props.showNav && _react2.default.createElement(
          'span',
          { key: 'navigation' },
          this.props.renderLeftNav(slideLeft, !this._canSlideLeft()),
          this.props.renderRightNav(slideRight, !this._canSlideRight())
        ), _react2.default.createElement(
          _reactSwipeable.Swipeable,
          {
            className: 'image-gallery-swipe',
            key: 'swipeable',
            delta: 0,
            onSwiping: this._handleSwiping,
            onSwiped: this._handleOnSwiped
          },
          _react2.default.createElement(
            'div',
            { className: 'image-gallery-slides' },
            slides
          )
        )] : _react2.default.createElement(
          'div',
          { className: 'image-gallery-slides' },
          slides
        ),
        this.props.showBullets && _react2.default.createElement(
          'div',
          { className: 'image-gallery-bullets' },
          _react2.default.createElement(
            'div',
            {
              className: 'image-gallery-bullets-container',
              role: 'navigation',
              'aria-label': 'Bullet Navigation'
            },
            bullets
          )
        ),
        this.props.showIndex && _react2.default.createElement(
          'div',
          { className: 'image-gallery-index' },
          _react2.default.createElement(
            'span',
            { className: 'image-gallery-index-current' },
            this.state.currentIndex + 1
          ),
          _react2.default.createElement(
            'span',
            { className: 'image-gallery-index-separator' },
            this.props.indexSeparator
          ),
          _react2.default.createElement(
            'span',
            { className: 'image-gallery-index-total' },
            this.props.items.length
          )
        )
      );

      var classNames = ['image-gallery', this.props.additionalClass, modalFullscreen ? 'fullscreen-modal' : ''].filter(function (name) {
        return typeof name === 'string';
      }).join(' ');

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(i) {
            return _this5._imageGallery = i;
          },
          className: classNames,
          'aria-live': 'polite'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'image-gallery-content' + (isFullscreen ? ' fullscreen' : '')
          },
          (thumbnailPosition === 'bottom' || thumbnailPosition === 'right') && slideWrapper,
          this.props.showThumbnails && _react2.default.createElement(
            'div',
            {
              className: 'image-gallery-thumbnails-wrapper ' + thumbnailPosition + ' ' + (!this._isThumbnailVertical() && isRTL ? 'thumbnails-wrapper-rtl' : ''),
              style: this._getThumbnailBarHeight()
            },
            _react2.default.createElement(
              'div',
              {
                className: 'image-gallery-thumbnails',
                ref: function ref(i) {
                  return _this5._thumbnailsWrapper = i;
                }
              },
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(t) {
                    return _this5._thumbnails = t;
                  },
                  className: 'image-gallery-thumbnails-container',
                  style: thumbnailStyle,
                  'aria-label': 'Thumbnail Navigation'
                },
                thumbnails
              )
            )
          ),
          (thumbnailPosition === 'top' || thumbnailPosition === 'left') && slideWrapper
        )
      );
    }
  }]);

  return ImageGallery;
}(_react2.default.Component);

ImageGallery.propTypes = {
  flickThreshold: _propTypes2.default.number,
  items: _propTypes2.default.array.isRequired,
  showNav: _propTypes2.default.bool,
  autoPlay: _propTypes2.default.bool,
  lazyLoad: _propTypes2.default.bool,
  infinite: _propTypes2.default.bool,
  showIndex: _propTypes2.default.bool,
  showBullets: _propTypes2.default.bool,
  showThumbnails: _propTypes2.default.bool,
  showPlayButton: _propTypes2.default.bool,
  showFullscreenButton: _propTypes2.default.bool,
  disableThumbnailScroll: _propTypes2.default.bool,
  disableArrowKeys: _propTypes2.default.bool,
  disableSwipe: _propTypes2.default.bool,
  useBrowserFullscreen: _propTypes2.default.bool,
  preventDefaultTouchmoveEvent: _propTypes2.default.bool,
  defaultImage: _propTypes2.default.string,
  indexSeparator: _propTypes2.default.string,
  thumbnailPosition: _propTypes2.default.string,
  startIndex: _propTypes2.default.number,
  slideDuration: _propTypes2.default.number,
  slideInterval: _propTypes2.default.number,
  slideOnThumbnailOver: _propTypes2.default.bool,
  swipeThreshold: _propTypes2.default.number,
  swipingTransitionDuration: _propTypes2.default.number,
  onSlide: _propTypes2.default.func,
  onScreenChange: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onImageLoad: _propTypes2.default.func,
  onImageError: _propTypes2.default.func,
  onTouchMove: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onThumbnailError: _propTypes2.default.func,
  onThumbnailClick: _propTypes2.default.func,
  renderCustomControls: _propTypes2.default.func,
  renderLeftNav: _propTypes2.default.func,
  renderRightNav: _propTypes2.default.func,
  renderPlayPauseButton: _propTypes2.default.func,
  renderFullscreenButton: _propTypes2.default.func,
  renderItem: _propTypes2.default.func,
  stopPropagation: _propTypes2.default.bool,
  additionalClass: _propTypes2.default.string,
  useTranslate3D: _propTypes2.default.bool,
  isRTL: _propTypes2.default.bool
};
ImageGallery.defaultProps = {
  items: [],
  showNav: true,
  autoPlay: false,
  lazyLoad: false,
  infinite: true,
  showIndex: false,
  showBullets: false,
  showThumbnails: true,
  showPlayButton: true,
  showFullscreenButton: true,
  disableThumbnailScroll: false,
  disableArrowKeys: false,
  disableSwipe: false,
  useTranslate3D: true,
  isRTL: false,
  useBrowserFullscreen: true,
  preventDefaultTouchmoveEvent: false,
  flickThreshold: 0.4,
  stopPropagation: false,
  indexSeparator: ' / ',
  thumbnailPosition: 'bottom',
  startIndex: 0,
  slideDuration: 450,
  swipingTransitionDuration: 0,
  slideInterval: 3000,
  swipeThreshold: 30,
  renderLeftNav: function renderLeftNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-left-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Previous Slide'
    });
  },
  renderRightNav: function renderRightNav(onClick, disabled) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-right-nav',
      disabled: disabled,
      onClick: onClick,
      'aria-label': 'Next Slide'
    });
  },
  renderPlayPauseButton: function renderPlayPauseButton(onClick, isPlaying) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-play-button' + (isPlaying ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Play or Pause Slideshow'
    });
  },
  renderFullscreenButton: function renderFullscreenButton(onClick, isFullscreen) {
    return _react2.default.createElement('button', {
      type: 'button',
      className: 'image-gallery-fullscreen-button' + (isFullscreen ? ' active' : ''),
      onClick: onClick,
      'aria-label': 'Open Fullscreen'
    });
  }
};
exports.default = ImageGallery;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Payment__ = __webpack_require__(1383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Payment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentPlaceholder__ = __webpack_require__(568);
/* unused harmony reexport PaymentPlaceholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(1389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_placeholder_lib_reactPlaceholder_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentPlaceholder=function(_Component){_inherits(PaymentPlaceholder,_Component);function PaymentPlaceholder(){_classCallCheck(this,PaymentPlaceholder);return _possibleConstructorReturn(this,(PaymentPlaceholder.__proto__||Object.getPrototypeOf(PaymentPlaceholder)).apply(this,arguments));}_createClass(PaymentPlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-payment col-12 border-color-ui-3 py-3 px-3 mx-0 d-none '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-auto py-half radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 mr-auto py-half radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-1 py-1 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-1 py-1 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-1 py-1 radius bg-ui-3'})));}}]);return PaymentPlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PaymentPlaceholder);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tabs__ = __webpack_require__(149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductTabsPlaceholder=function(_Component){_inherits(ProductTabsPlaceholder,_Component);function ProductTabsPlaceholder(){_classCallCheck(this,ProductTabsPlaceholder);return _possibleConstructorReturn(this,(ProductTabsPlaceholder.__proto__||Object.getPrototypeOf(ProductTabsPlaceholder)).apply(this,arguments));}_createClass(ProductTabsPlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["d" /* Tabs */],{className:'product-tabs border-color-ui-3 mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["b" /* TabList */],{className:'tabs-item  row py-3 border-color-ui-3 border-bottom px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["a" /* Tab */],{className:'item-button item-button-inactive col-3 px-2 txt-circular-black txt-uppercase txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-5 radius bg-ui-3'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["a" /* Tab */],{className:'item-button item-button-inactive placeholder col-3 px-2 txt-circular-black txt-uppercase txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-5 radius bg-ui-3'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["a" /* Tab */],{className:'item-button item-button-inactive col-3 px-2 txt-circular-black txt-uppercase txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-5 radius bg-ui-3'})),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["c" /* TabPanel */],{className:'row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 pr-half pt-1 radius bg-ui-3'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["c" /* TabPanel */],{className:'row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 pr-half pt-1 radius bg-ui-3'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["c" /* TabPanel */],{className:'row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-half pt-1 radius bg-ui-3 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 pr-half pt-1 radius bg-ui-3'})))));}}]);return ProductTabsPlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProductTabsPlaceholder);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var FeatureTitle=function FeatureTitle(_ref){var children=_ref.children,ariaLabelledby=_ref.ariaLabelledby;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'txt-body-sm',id:ariaLabelledby},children));};FeatureTitle.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,ariaLabelledby:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (FeatureTitle);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var FeatureItems=function FeatureItems(_ref){var children=_ref.children,ariaLabelledby=_ref.ariaLabelledby,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 mb-1 px-0 '+(className||''),'aria-labelledby':ariaLabelledby},children);};FeatureItems.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,ariaLabelledby:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (FeatureItems);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Option = exports.Select = undefined;

var _Select = __webpack_require__(1399);

var _Select2 = _interopRequireDefault(_Select);

var _Option = __webpack_require__(573);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Select = _Select2.default;
exports.Option = _Option2.default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Option = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// World's most unintersting component. :) The real work happens in OptionWrapper.
var Option = exports.Option = function Option(props) {
  return _react2.default.createElement(
    'div',
    null,
    props.children
  );
};

Option.propTypes =  false ? {
  label: _propTypes2.default.string
} : {};

exports.default = Option;

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export Integrations */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(100);
/* unused harmony reexport Severity */
/* unused harmony reexport Status */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(62);
/* unused harmony reexport addGlobalEventProcessor */
/* unused harmony reexport addBreadcrumb */
/* unused harmony reexport captureException */
/* unused harmony reexport captureEvent */
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["g"];
});
/* unused harmony reexport configureScope */
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getCurrentHub */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* unused harmony reexport withScope */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__(583);
/* unused harmony reexport BrowserClient */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__sdk__ = __webpack_require__(1457);
/* unused harmony reexport defaultIntegrations */
/* unused harmony reexport forceLoad */
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_4__sdk__["a"];
});
/* unused harmony reexport lastEventId */
/* unused harmony reexport onLoad */
/* unused harmony reexport showReportDialog */
/* unused harmony reexport flush */
/* unused harmony reexport close */
/* unused harmony reexport wrap */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(587);
/* unused harmony reexport SDK_NAME */
/* unused harmony reexport SDK_VERSION */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(588);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__transports__ = __webpack_require__(586);
/* unused harmony reexport Transports */

var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var _window = Object(__WEBPACK_IMPORTED_MODULE_6__sentry_utils__["n" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
// tslint:enable: no-unsafe-any
var INTEGRATIONS = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, windowIntegrations, __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d" /* Integrations */], __WEBPACK_IMPORTED_MODULE_7__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return Scope;
});
/* harmony export (immutable) */__webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._context = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) {
            index = 0;
        }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            } else {
                var result = processor(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* isThenable */])(result)) {
                    result.then(function (final) {
                        return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                    }).then(null, reject);
                } else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
                }
            }
        });
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(user);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(tags));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(value), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extra) {
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(extra));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(extra), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(fingerprint);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(level);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransaction = function (transaction) {
        this._transaction = transaction;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (name, context) {
        this._context[name] = context ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(context) : undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Internal getter for Span, used in Hub.
     * @hidden
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](scope._breadcrumbs);
            newScope._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._tags);
            newScope._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._extra);
            newScope._context = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._context);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transaction = scope._transaction;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._context = {};
        this._level = undefined;
        this._transaction = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* timestampWithMs */])();
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        this._breadcrumbs = maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0 ? __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(mergedBreadcrumb)]).slice(-maxBreadcrumbs) : __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(mergedBreadcrumb)]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._user, event.user);
        }
        if (this._context && Object.keys(this._context).length) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._context, event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transaction) {
            event.transaction = this._transaction;
        }
        if (this._span) {
            event.contexts = event.contexts || {};
            event.contexts.trace = this._span.getTraceContext();
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}();

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return Memo;
});
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */function () {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        } else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}();

//# sourceMappingURL=memo.js.map

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* WEBPACK VAR INJECTION */(function (global) {
    /* harmony export (immutable) */__webpack_exports__["b"] = fill;
    /* harmony export (immutable) */__webpack_exports__["e"] = urlEncode;
    /* harmony export (immutable) */__webpack_exports__["d"] = normalizeToSize;
    /* unused harmony export walk */
    /* harmony export (immutable) */__webpack_exports__["c"] = normalize;
    /* harmony export (immutable) */__webpack_exports__["a"] = extractExceptionKeysForMessage;
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(127);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__memo__ = __webpack_require__(577);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__misc__ = __webpack_require__(161);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__string__ = __webpack_require__(579);

    /**
     * Wrap a given object method with a higher-order function
     *
     * @param source An object that contains a method to be wrapped.
     * @param name A name of method to be wrapped.
     * @param replacement A function that should be used to wrap a given method.
     * @returns void
     */
    function fill(source, name, replacement) {
        if (!(name in source)) {
            return;
        }
        var original = source[name];
        var wrapped = replacement(original);
        // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
        // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
        // tslint:disable-next-line:strict-type-predicates
        if (typeof wrapped === 'function') {
            try {
                wrapped.prototype = wrapped.prototype || {};
                Object.defineProperties(wrapped, {
                    __sentry_original__: {
                        enumerable: false,
                        value: original
                    }
                });
            } catch (_Oo) {
                // This can throw if multiple fill happens on a global object like XMLHttpRequest
                // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
            }
        }
        source[name] = wrapped;
    }
    /**
     * Encodes given object into url-friendly format
     *
     * @param object An object that contains serializable values
     * @returns string Encoded
     */
    function urlEncode(object) {
        return Object.keys(object).map(
        // tslint:disable-next-line:no-unsafe-any
        function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
        }).join('&');
    }
    /**
     * Transforms any object into an object literal with all it's attributes
     * attached to it.
     *
     * @param value Initial source that we have to transform in order to be usable by the serializer
     */
    function getWalkSource(value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["d" /* isError */])(value)) {
            var error = value;
            var err = {
                message: error.message,
                name: error.name,
                stack: error.stack
            };
            for (var i in error) {
                if (Object.prototype.hasOwnProperty.call(error, i)) {
                    err[i] = error[i];
                }
            }
            return err;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isEvent */])(value)) {
            var event_1 = value;
            var source = {};
            source.type = event_1.type;
            // Accessing event.target can throw (see getsentry/raven-js#838, #768)
            try {
                source.target = Object(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isElement */])(event_1.target) ? Object(__WEBPACK_IMPORTED_MODULE_2__misc__["i" /* htmlTreeAsString */])(event_1.target) : Object.prototype.toString.call(event_1.target);
            } catch (_oO) {
                source.target = '<unknown>';
            }
            try {
                source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isElement */])(event_1.currentTarget) ? Object(__WEBPACK_IMPORTED_MODULE_2__misc__["i" /* htmlTreeAsString */])(event_1.currentTarget) : Object.prototype.toString.call(event_1.currentTarget);
            } catch (_oO) {
                source.currentTarget = '<unknown>';
            }
            // tslint:disable-next-line:strict-type-predicates
            if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_0__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
                source.detail = event_1.detail;
            }
            for (var i in event_1) {
                if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                    source[i] = event_1;
                }
            }
            return source;
        }
        return value;
    }
    /** Calculates bytes size of input string */
    function utf8Length(value) {
        // tslint:disable-next-line:no-bitwise
        return ~-encodeURI(value).split(/%..|./).length;
    }
    /** Calculates bytes size of input object */
    function jsonSize(value) {
        return utf8Length(JSON.stringify(value));
    }
    /** JSDoc */
    function normalizeToSize(object,
    // Default Node.js REPL depth
    depth,
    // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize) {
        if (depth === void 0) {
            depth = 3;
        }
        if (maxSize === void 0) {
            maxSize = 100 * 1024;
        }
        var serialized = normalize(object, depth);
        if (jsonSize(serialized) > maxSize) {
            return normalizeToSize(object, depth - 1, maxSize);
        }
        return serialized;
    }
    /** Transforms any input value into a string form, either primitive value or a type of the input */
    function serializeValue(value) {
        var type = Object.prototype.toString.call(value);
        // Node.js REPL notation
        if (typeof value === 'string') {
            return value;
        }
        if (type === '[object Object]') {
            return '[Object]';
        }
        if (type === '[object Array]') {
            return '[Array]';
        }
        var normalized = normalizeValue(value);
        return Object(__WEBPACK_IMPORTED_MODULE_0__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
    }
    /**
     * normalizeValue()
     *
     * Takes unserializable input and make it serializable friendly
     *
     * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
     * - serializes Error objects
     * - filter global objects
     */
    // tslint:disable-next-line:cyclomatic-complexity
    function normalizeValue(value, key) {
        if (key === 'domain' && value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && value._events) {
            return '[Domain]';
        }
        if (key === 'domainEmitter') {
            return '[DomainEmitter]';
        }
        if (typeof global !== 'undefined' && value === global) {
            return '[Global]';
        }
        if (typeof window !== 'undefined' && value === window) {
            return '[Window]';
        }
        if (typeof document !== 'undefined' && value === document) {
            return '[Document]';
        }
        // React's SyntheticEvent thingy
        if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["l" /* isSyntheticEvent */])(value)) {
            return '[SyntheticEvent]';
        }
        // tslint:disable-next-line:no-tautology-expression
        if (typeof value === 'number' && value !== value) {
            return '[NaN]';
        }
        if (value === void 0) {
            return '[undefined]';
        }
        if (typeof value === 'function') {
            return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_2__misc__["f" /* getFunctionName */])(value) + "]";
        }
        return value;
    }
    /**
     * Walks an object to perform a normalization on it
     *
     * @param key of object that's walked in current iteration
     * @param value object to be walked
     * @param depth Optional number indicating how deep should walking be performed
     * @param memo Optional Memo class handling decycling
     */
    function walk(key, value, depth, memo) {
        if (depth === void 0) {
            depth = +Infinity;
        }
        if (memo === void 0) {
            memo = new __WEBPACK_IMPORTED_MODULE_1__memo__["a" /* Memo */]();
        }
        // If we reach the maximum depth, serialize whatever has left
        if (depth === 0) {
            return serializeValue(value);
        }
        // If value implements `toJSON` method, call it and return early
        // tslint:disable:no-unsafe-any
        if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
            return value.toJSON();
        }
        // tslint:enable:no-unsafe-any
        // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
        var normalized = normalizeValue(value, key);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["i" /* isPrimitive */])(normalized)) {
            return normalized;
        }
        // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
        var source = getWalkSource(value);
        // Create an accumulator that will act as a parent for all future itterations of that branch
        var acc = Array.isArray(value) ? [] : {};
        // If we already walked that branch, bail out, as it's circular reference
        if (memo.memoize(value)) {
            return '[Circular ~]';
        }
        // Walk all keys of the source
        for (var innerKey in source) {
            // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
            if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
                continue;
            }
            // Recursively walk through all the child nodes
            acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
        }
        // Once walked through all the branches, remove the parent from memo storage
        memo.unmemoize(value);
        // Return accumulated values
        return acc;
    }
    /**
     * normalize()
     *
     * - Creates a copy to prevent original input mutation
     * - Skip non-enumerablers
     * - Calls `toJSON` if implemented
     * - Removes circular references
     * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
     * - Translates known global objects/Classes to a string representations
     * - Takes care of Error objects serialization
     * - Optionally limit depth of final output
     */
    function normalize(input, depth) {
        try {
            // tslint:disable-next-line:no-unsafe-any
            return JSON.parse(JSON.stringify(input, function (key, value) {
                return walk(key, value, depth);
            }));
        } catch (_oO) {
            return '**non-serializable**';
        }
    }
    /**
     * Given any captured exception, extract its keys and create a sorted
     * and truncated list that will be used inside the event message.
     * eg. `Non-error exception captured with keys: foo, bar, baz`
     */
    function extractExceptionKeysForMessage(exception, maxLength) {
        if (maxLength === void 0) {
            maxLength = 40;
        }
        // tslint:disable:strict-type-predicates
        var keys = Object.keys(getWalkSource(exception));
        keys.sort();
        if (!keys.length) {
            return '[object has no keys]';
        }
        if (keys[0].length >= maxLength) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__string__["c" /* truncate */])(keys[0], maxLength);
        }
        for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
            var serialized = keys.slice(0, includedKeys).join(', ');
            if (serialized.length > maxLength) {
                continue;
            }
            if (includedKeys === keys.length) {
                return serialized;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_3__string__["c" /* truncate */])(serialized, maxLength);
        }
        return '';
    }
    //# sourceMappingURL=object.js.map
    /* WEBPACK VAR INJECTION */
}).call(__webpack_exports__, __webpack_require__(8));

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["c"] = truncate;
/* unused harmony export snipLine */
/* harmony export (immutable) */__webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */__webpack_exports__["a"] = isMatchingPattern;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(127);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) {
        max = 0;
    }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return SyncPromise;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(127);

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["m" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            if (_this._state === States.REJECTED) {
                _this._handlers.forEach(function (handler) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                });
            } else {
                _this._handlers.forEach(function (handler) {
                    if (handler.onfulfilled) {
                        // tslint:disable-next-line:no-unsafe-any
                        handler.onfulfilled(_this._value);
                    }
                });
            }
            _this._handlers = [];
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item).then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                }).then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (_onfulfilled, _onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                onfulfilled: function onfulfilled(result) {
                    if (!_onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(_onfulfilled(result));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function onrejected(reason) {
                    if (!_onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(_onrejected(reason));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                }
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                // tslint:disable-next-line:no-unsafe-any
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */__webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */__webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */__webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */__webpack_exports__["b"] = supportsHistory;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(299);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(161);

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // tslint:disable-next-line:no-unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    if (doc) {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        try {
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // tslint:disable-next-line:no-unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        } catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return NoopTransport;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(100);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);

/** Noop transport */
var NoopTransport = /** @class */function () {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}();

//# sourceMappingURL=noop.js.map

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return BrowserClient;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(1454);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(587);

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) {
            options = {};
        }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event.sdk, { name: __WEBPACK_IMPORTED_MODULE_4__version__["a" /* SDK_NAME */], packages: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](event.sdk && event.sdk.packages || [], [{
                name: 'npm:@sentry/browser',
                version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */]
            }]), version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) {
            options = {};
        }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error('Trying to call showReportDialog with Sentry Client is disabled');
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error('Missing `eventId` option in showReportDialog call');
            return;
        }
        if (!dsn) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error('Missing `Dsn` option in showReportDialog call');
            return;
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getReportDialogEndpoint(options);
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]);

//# sourceMappingURL=client.js.map

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["b"] = eventFromUnknownInput;
/* harmony export (immutable) */__webpack_exports__["a"] = eventFromString;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__parsers__ = __webpack_require__(585);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__tracekit__ = __webpack_require__(300);

/** JSDoc */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) {
        options = {};
    }
    var event;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["r" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* addExceptionTypeValue */])(event, message);
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["y" /* isPlainObject */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["u" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["a" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        synthetic: true
    });
    return event;
}
// this._options.attachStacktrace
/** JSDoc */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) {
        options = {};
    }
    var event = {
        message: input
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */__webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */__webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */__webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(300);

var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [{
                type: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["u" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["j" /* extractExceptionKeysForMessage */])(exception)
            }]
        },
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* normalizeToSize */])(exception)
        }
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception]
        }
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack.map(function (frame) {
        return {
            colno: frame.column === null ? undefined : frame.column,
            filename: frame.url || localStack[0].url,
            function: frame.func || '?',
            in_app: true,
            lineno: frame.line === null ? undefined : frame.line
        };
    }).slice(0, STACKTRACE_LIMIT).reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(301);
/* unused harmony reexport BaseTransport */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(1455);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(1456);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"];
});

//# sourceMappingURL=index.js.map

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
  return SDK_NAME;
});
/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
  return SDK_VERSION;
});
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.10.1';
//# sourceMappingURL=version.js.map

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(1458);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "GlobalHandlers", function () {
  return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(1459);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "TryCatch", function () {
  return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(1460);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Breadcrumbs", function () {
  return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(1461);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "LinkedErrors", function () {
  return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(1462);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "UserAgent", function () {
  return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"];
});

//# sourceMappingURL=index.js.map

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegulationDefault__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegulationIupp__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegulationAvonComponent__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegulationMHMO__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RegulationPetronas__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_yn__);
var RegulationPage=function RegulationPage(){switch(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_REGULATION_CUSTOM_ID){case'avon':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RegulationAvonComponent__["a" /* default */],null);case'mhmo':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RegulationMHMO__["a" /* default */],null);case'petronas':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RegulationPetronas__["a" /* default */],null);default:break;}return __WEBPACK_IMPORTED_MODULE_6_yn___default()("false")?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RegulationIupp__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RegulationDefault__["a" /* default */],null);};/* harmony default export */ __webpack_exports__["default"] = (RegulationPage);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TrackingStatus__ = __webpack_require__(1483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TrackingStatus__["a"]; });


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AboutOrder__ = __webpack_require__(1495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AboutOrder__["a"]; });


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMobileOperators */
var getMobileOperators=function getMobileOperators(){return{type:'FETCH_MOBILEOPERATORS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/mobileRecharges/mobileoperator'}}};};/* harmony default export */ __webpack_exports__["a"] = ({getMobileOperators:getMobileOperators});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState=[];/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_MOBILEOPERATORS':return initialState;case'FETCH_MOBILEOPERATORS_SUCCESS':return[].concat(_toConsumableArray(action.payload.data));case'FETCH_MOBILEOPERATORS_FAIL':return initialState;default:return state||initialState;}});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValuesRechargeContainer__ = __webpack_require__(1507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ValuesRechargeContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValuesRecharge */
/* unused harmony export clearAreaCodes */
var getValuesRecharge=function getValuesRecharge(operatorKey,areaCode){return{type:'FETCH_CREDITVALUE',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/mobileRecharges/mobileoperator/'+operatorKey+'/areacode/'+areaCode+'/rechargeValue'}}};};var clearAreaCodes=function clearAreaCodes(){return{type:'CLEAR_CREDITVALUE'};};/* harmony default export */ __webpack_exports__["a"] = ({getValuesRecharge:getValuesRecharge,clearAreaCodes:clearAreaCodes});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectAreaCodeContainer__ = __webpack_require__(1510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SelectAreaCodeContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePicker__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PeriodScheduleRecharge=function(_Component){_inherits(PeriodScheduleRecharge,_Component);function PeriodScheduleRecharge(props){_classCallCheck(this,PeriodScheduleRecharge);var _this=_possibleConstructorReturn(this,(PeriodScheduleRecharge.__proto__||Object.getPrototypeOf(PeriodScheduleRecharge)).call(this,props));_this.state={innitialDate:null,possibleEndDates:[]};return _this;}_createClass(PeriodScheduleRecharge,[{key:'generatePossibleEndDates',value:function generatePossibleEndDates(innitialDate,quantityMonths){var possibleEndDates=[];if(!innitialDate)return possibleEndDates;for(var i=0;i<quantityMonths;i++){possibleEndDates.push(__WEBPACK_IMPORTED_MODULE_3_moment___default()(innitialDate).add(i,'month').toDate());}this.setState({innitialDate:innitialDate,possibleEndDates:possibleEndDates});}},{key:'render',value:function render(){if(this.state.innitialDate!==this.props.innitialDate){this.generatePossibleEndDates(this.props.innitialDate,this.props.maxQuantityMonths);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-dotted-top color-ui-3 mt-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-lg-12 txt-title-3 txt-body-sm txt-font-body txt-left mt-2 color-ui-2 px-0 mb-1'},'Aqui voc\xEA escolhe a data inicial de resgate e este dia ser\xE1 repetido todo m\xEAs at\xE9 a data termino.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DatePicker__["a" /* default */],{name:'datainicio',onChange:this.props.onChangeInnitialDate,selected:this.props.innitialDate,minDate:__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).add(1,'days').toDate(),labelDescription:'Data de in\xEDcio'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DatePicker__["a" /* default */],{name:'datatermino',labelDescription:'Data de t\xE9rmino',onChange:this.props.onChangeEndDate,selected:this.props.endDate,disabled:!this.props.innitialDate,includeDates:this.state.possibleEndDates,highlightDates:this.state.possibleEndDates,locale:'pt'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 color-ui-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'}))));}}]);return PeriodScheduleRecharge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PeriodScheduleRecharge.propTypes={onChangeInnitialDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,innitialDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),onChangeEndDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,endDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),maxQuantityMonths:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (PeriodScheduleRecharge);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  return !isNaN(date);
}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(1535);





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchFn;
function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(306);


/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(1539);



var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a" /* default */])(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(210);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(1540);



var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a" /* default */])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a" /* default */])(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["a"] = (longFormatters);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isProtectedDayOfYearToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = isProtectedWeekYearToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token) {
  if (token === 'YYYY') {
    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'YY') {
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'D') {
    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  } else if (token === 'DD') {
    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
  }
}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(306);


var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(306);


var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(308);


/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var days = amount * 7;
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["default"])(dirtyDate, days);
}

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDaysInMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(309);


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["default"])(dirtyDate, amount * 12);
}

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(614);



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var month = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(18);


/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/* unused harmony export shallowEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRef; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Regulation__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_awesome_modal__);
var ModalTerms=function ModalTerms(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_awesome_modal___default.a,{width:'1180',height:'502',effect:'fadeInUp',visible:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white py-3 mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title'},'Termos do regulamento')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{name:'Close',className:'btn btn-double btn-flat btn-icon-only btn-icon mx-0',iconName:'icon_close icon-sm',text:'','aria-label':'Fechar',onClick:function onClick(e){return props.onClose();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mx-0 mt-2 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-3 modal-scroll color-ui-2 txt-font-body txt-body-sm'},CheckTypeHandler(props.terms)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-2 px-0 txt-left mr-auto'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-4 px-0 txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'Agree-recharge',name:'Agree',className:'btn btn-double btn-featured btn-icon mx-0',iconName:'icon_check_circle',text:'LI E ACEITO O REGULAMENTO',onClick:function onClick(e){return props.acceptTerms();},loading:!!props.btnAgreeIsLoading})))))));};var CheckTypeHandler=function CheckTypeHandler(terms){switch(terms.type){case __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* REGULATION_TYPE_CAMPAIGN */]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],null);case __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* REGULATION_TYPE_CAMPAIGN_AND_VENDOR */]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],{vendorId:terms.vendorId,regulationType:terms.regulationType});case __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* REGULATION_TYPE_VENDOR */]:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],{vendorId:terms.vendorId});}};ModalTerms.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,terms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,btnAgreeIsLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ModalTerms);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmationContainer__ = __webpack_require__(1611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConfirmationContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_typeform_embed__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_typeform_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_typeform_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_aria_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_aria_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_aria_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nps=function(_Component){_inherits(Nps,_Component);function Nps(props){_classCallCheck(this,Nps);var _this=_possibleConstructorReturn(this,(Nps.__proto__||Object.getPrototypeOf(Nps)).call(this,props));_this.getApplicationNode=function(){return document.querySelector('#root');};_this.state={showModal:false};setTimeout(function(){_this.setState({showModal:_this.props.closeDonation});},1000);return _this;}_createClass(Nps,[{key:'closeNPS',value:function closeNPS(){this.setState({showModal:false});}},{key:'render',value:function render(){var _this2=this;return Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS?this.state.showModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_aria_modal___default.a,{titleText:'Como foi sua experi\xEAncia?',onExit:function onExit(){return _this2.closeNPS();},focusDialog:'true',getApplicationNode:this.getApplicationNode,underlayStyle:{paddingTop:'100px',zIndex:9999}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-campaign':"80938"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-absolute zindex-high r-3 t-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'button',href:'javascript:void(0)','aria-label':'Fechar',onClick:function onClick(){return _this2.closeNPS();},className:'txt-subtitle txt-font-body color-ui-2 d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_typeform_embed__["ReactTypeformEmbed"],{url:this.props.urlNps||Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS}))):'';}}]);return Nps;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Nps.propTypes={closeDonation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,urlNps:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Nps);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmationMobileRechargeScheduleContainer__ = __webpack_require__(1628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConfirmationMobileRechargeScheduleContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmationCreditMileageContainer__ = __webpack_require__(1660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConfirmationCreditMileageContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Checkout_actions__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputRange__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Services_Mileage__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Services_Mileage_actions__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkout_SecondFactorAuthenticaton__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @ts-nocheck
var Stix=function(_Component){_inherits(Stix,_Component);function Stix(props){_classCallCheck(this,Stix);var _this=_possibleConstructorReturn(this,(Stix.__proto__||Object.getPrototypeOf(Stix)).call(this,props));_this.getOrderRequest=function(){return{totalMiles:_this.state.totalPoints,totalPoints:_this.state.totalPoints,catalogId:_this.props.catalog.id,transferKey:'cpf',loyaltyNumber:_this.props.participant.cpf.value,cpf:_this.props.participant.cpf.value,participantName:_this.props.participant.name.value,offline:false,orderItems:[{quantity:1,points:_this.state.totalPoints,miles:_this.state.totalPoints,totalPoints:_this.state.totalPoints,packageName:_this.createStringValueResult()}],orderTypeId:1};};_this.createStringValueResult=function(){var res=parseInt(_this.props.calculator.miles);res+=res===1?' ponto ':' pontos ';res+='stix';return res;};_this.closeModal=function(){if(_this.state.isModalConfirmationOpened){_this.setState({isModalConfirmationOpened:false});}};_this.handlePaymentConfirmation=function(){_this.setState({isModalConfirmationOpened:true});};_this.formatTitle=function(title){return title.split(' ')[0];};_this.handlerFinalizePayment=function(){_this.props.mileageRedemption(_this.getOrderRequest(),_this.props.stix.supplierId);};_this.getConfigurationByKey=function(key){return _this.props.configuration[_this.props.stix.supplierId].filter(function(x){return x.key===key;});};_this.state={step:_this.props.stix.supplierId?2:1,loadingPayment:false,totalPoints:1,error:false,partnerName:'',paymentSelected:'POINTS_ONLY',multipliceRule:0,configurationRule:false,Partners:_this.props.partners,isModalConfirmationOpened:false};_this.HandlerValueSelected=_this.HandlerValueSelected.bind(_this);_this.disabledVerify=_this.disabledVerify.bind(_this);return _this;}_createClass(Stix,[{key:'showError',value:function showError(){var _this2=this;return this.props.errorRedemption&&this.props.errorRedemption!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.closeModal(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Alert"],{isError:true,title:'Não foi possível concluir a sua transferência.',description:'Erro ao tentar efetuar o resgate',className:'pb-2',onClose:function onClose(){return _this2.props.closeErrorMileage();}})):'';}},{key:'showStixError',value:function showStixError(){var _this3=this;return this.props.stix&&this.props.stix.error&&this.props.stix.error.response?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.closeModal(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Alert"],{isError:true,title:this.props.stix.error.response.data,description:'',className:'pb-2',onClose:function onClose(){return _this3.props.closeErrorStix();}})):'';}},{key:'MessageBalanceLimit',value:function MessageBalanceLimit(){return this.ValidationBalanceLimit()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.closeModal(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Alert"],{isError:true,title:'Não podemos prosseguir com a operação!',description:'Seu saldo \xE9 insulficiente para a transfer\xEAncia.',className:'pb-2'})):'';}},{key:'ValidationBalanceLimit',value:function ValidationBalanceLimit(){return parseInt(this.state.totalPoints)>parseInt(this.props.pointsValue);}},{key:'selectPartner',value:function selectPartner(){var partner=this.props.partners[0];this.props.pointsToMiles(partner.vendorId,'');this.props.toggleSupplierId(partner.vendorId);this.setState({partnerName:partner.name,totalPoints:''});}},{key:'nextStep',value:function nextStep(step){this.setState({step:step});}},{key:'HandlerValueSelected',value:function HandlerValueSelected(value){this.setState({totalPoints:value});this.props.pointsToMiles(this.props.stix.supplierId,value);}},{key:'disableConfigurationRule',value:function disableConfigurationRule(value){this.setState({configurationRule:value});}},{key:'updateMaximumRedemptionLimit',value:function updateMaximumRedemptionLimit(){if(this.props.stix.minimumRedemptionLimit===0||this.props.pointsValue===0){return;}this.props.changeMaximumRedemptionLimit(~~(this.props.pointsValue/this.props.stix.minimumRedemptionLimit)*this.props.stix.minimumRedemptionLimit);}// #region [Life clycle]
},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.enableConfiguration!==this.props.enableConfiguration){this.disableConfigurationRule(this.props.enableConfiguration);}if(prevProps.configuration!==this.props.configuration){var minimumRedemptionLimit=this.getConfigurationByKey('MinimumRedemptionLimit');var multiplicityRule=this.getConfigurationByKey('MultiplicityRule');if(multiplicityRule===undefined){return;}if(minimumRedemptionLimit===undefined){return;}var minimumLimit=parseInt(minimumRedemptionLimit[0].value);this.props.changeMinimumRedemptionLimit(minimumLimit);if(this.props.stix.redemptionPoints<minimumLimit){this.props.changeRedemptionPoints(minimumRedemptionLimit);}}if(prevProps.pointsValue!==this.props.pointsValue||prevProps.stix.minimumRedemptionLimit!==this.props.stix.minimumRedemptionLimit){this.updateMaximumRedemptionLimit();}if(prevProps.partners&&this.props.partners&&prevProps.partners.length===0&&this.props.partners.length>0&&prevProps.partners!==this.props.partners){this.selectPartner();}if(this.props.sendTwoFactorAuthorization&&this.props.sendTwoFactorAuthorization.enable&&prevProps.sendTwoFactorAuthorization.enable!==this.props.sendTwoFactorAuthorization.enable){this.closeModal();}this.MessageBalanceLimit();}// #endregion
},{key:'disabledVerify',value:function disabledVerify(){return this.props.stix.error||this.props.calculator.miles===0||this.ValidationBalanceLimit();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["f" /* StixWrapper */],null,this.showError,this.showStixError,this.MessageBalanceLimit,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Checkout_SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],{show:this.props.sendTwoFactorAuthorization&&this.props.sendTwoFactorAuthorization.enable,secondFactorAuthConfirmated:this.props.sendTwoFactorAuthorization&&this.props.sendTwoFactorAuthorization.secondFactorAuthConfirmated,sendTwoFactorAuthorization:this.props.sendTwoFactorAuthorization&&this.props.sendTwoFactorAuthorization,authorizeWithTokenMileage:this.props.authorizeWithTokenMileage,authorizeWithTokenResend:this.props.authorizeWithTokenResend,authorizeWithTokenLastTry:this.props.authorizeWithTokenLastTry,vendorId:Number(this.props.stix.supplierId),errorToken:this.props.sendTwoFactorAuthorization&&this.props.sendTwoFactorAuthorization.errorToken,paymentSelected:this.state.paymentSelected,isCreatingPurchase:this.props.mileageIsLoading,oidc:this.props.oidc})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["c" /* StixHeader */],null,'envie pontos para parceiros'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stix-content row radius-bottom bg-white px-1 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'step-2',className:'Step2 step-2 col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body pb-half'},'Quantos pontos deseja transferir?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-quantity col-12 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InputRange__["a" /* default */],{minimunValue:this.props.stix.minimumRedemptionLimit,maximunValue:this.props.stix.maximumRedemptionLimit,multipliceRule:this.state.multipliceRule,step:this.props.stix.minimumRedemptionLimit,handlerValueSelected:this.HandlerValueSelected,isDivisible:true,pointsName:this.props.catalog.currencyConfiguration.pointsName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto txt-center my-2 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-equal'},'='),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'equal-line d-md-none d-block'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md my-2 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Voc\xEA vai receber na Stix:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-featured txt-title-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["e" /* StixStars */],{totalStars:this.props.calculator.miles}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body pb-half'},'Onde voc\xEA pode usar seus pontos stix:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md border border-ui-3 px-3 py-2 box-benefits-stix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-logo-stix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-logo pao-de-acucar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-logo drogaraia'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-logo extra'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-logo drogasil'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-logo mais-parceiros'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'step-3',className:'Step3 step-3 col-12 bg-white pt-0 pt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["d" /* StixInfos */],null)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* SideBar */],{loadingPayment:this.props.mileageIsLoading,disabledButton:this.disabledVerify,partnerName:this.state.partnerName,creditValue:this.state.totalPoints,starValue:this.props.calculator.miles,handlerFinalizePayment:this.handlerFinalizePayment,handlePaymentConfirmation:this.handlePaymentConfirmation,closeModal:this.closeModal,isModalConfirmationOpened:this.state.isModalConfirmationOpened,pointsName:this.props.catalog.currencyConfiguration.pointsName,formatTitle:this.formatTitle,isLoading:this.props.stix.isLoading}))));}}]);return Stix;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref){var mileage=_ref.mileage,stix=_ref.stix,balance=_ref.balance,catalog=_ref.catalog,participant=_ref.participant,oidc=_ref.oidc;return{mileageIsLoading:mileage.isLoading,errorRedemption:mileage.errorRedemption,configuration:stix.configuration,stix:stix,balanceIsLoading:balance.isLoading,pointsValue:balance.pointsValue,catalog:catalog,participant:participant,sendTwoFactorAuthorization:mileage.sendTwoFactorAuthorization,enableConfiguration:stix.enableConfiguration,partners:Object(__WEBPACK_IMPORTED_MODULE_8__Services_Mileage_actions__["b" /* filterPartnerMileage */])(stix.partners,false),oidc:oidc,calculator:stix.calculator};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleSupplierId:function toggleSupplierId(supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["i" /* toggleSupplierId */](supplierId));},pointsToMiles:function pointsToMiles(supplierId,points){return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["f" /* convertPointsToMiles */](supplierId,points));},changeRedemptionPoints:function changeRedemptionPoints(pointsAmout){return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* changeRedemptionPoints */](pointsAmout));},changeMinimumRedemptionLimit:function changeMinimumRedemptionLimit(minimumRedemptionLimit){return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["c" /* changeMinimumRedemptionLimit */](minimumRedemptionLimit));},changeMaximumRedemptionLimit:function changeMaximumRedemptionLimit(maximumRedemptionLimit){return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["b" /* changeMaximumRedemptionLimit */](maximumRedemptionLimit));},mileageRedemption:function mileageRedemption(order,supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Services_Mileage__["b" /* actions */].mileageRedemption(order,supplierId));},closeErrorMileage:function closeErrorMileage(){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Services_Mileage__["b" /* actions */].closeErrorMileage());},closeErrorStix:function closeErrorStix(){return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["e" /* closeErrorStix */]());},authorizeWithTokenMileage:function authorizeWithTokenMileage(orderId,Token,orderIdMileage,vendorId){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Services_Mileage__["b" /* actions */].authorizeWithTokenMileage(orderId,Token,orderIdMileage,vendorId));},authorizeWithTokenResend:function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Checkout_actions__["c" /* default */].authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},authorizeWithTokenLastTry:function authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Checkout_actions__["c" /* default */].authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));}};};// Objeto que retorna da ação: convertPointsToMiles.
var calculatorMessage=__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({points:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,miles:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string});// Propriedades do componente Mileage.
Stix.propTypes={stix:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,mileageIsLoading:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,calculator:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(calculatorMessage),pointsValue:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,supplierId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,configuration:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,participant:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,catalog:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,partners:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,toggleSupplierId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,changeRedemptionPoints:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,changeMinimumRedemptionLimit:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,changeMaximumRedemptionLimit:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,mileageRedemption:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,errorRedemption:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,sendTwoFactorAuthorization:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,authorizeWithTokenMileage:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,authorizeWithTokenLastTry:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,closeErrorMileage:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,closeErrorStix:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,enableConfiguration:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,oidc:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,pointsToMiles:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Stix));

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ZIPCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_USE_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REQUEST_GET_SHOWCASE_STORES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REQUEST_GET_SHOWCASE_STORES_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_GET_SHOWCASE_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REQUEST_GET_SHOWCASE_OFFERS_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_GET_LOCATION_FROM_ZIP_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED; });
/* harmony export (immutable) */ __webpack_exports__["m"] = setLocation;
/* harmony export (immutable) */ __webpack_exports__["o"] = setZipCode;
/* harmony export (immutable) */ __webpack_exports__["n"] = setUseLocation;
/* harmony export (immutable) */ __webpack_exports__["l"] = getStoreShowcase;
/* harmony export (immutable) */ __webpack_exports__["k"] = getOfferShowCase;
/* harmony export (immutable) */ __webpack_exports__["j"] = getLocationFromZipCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__effects__ = __webpack_require__(1687);
var createThunkEffect=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,actionType,effect){for(var _len=arguments.length,args=Array(_len>3?_len-3:0),_key=3;_key<_len;_key++){args[_key-3]=arguments[_key];}var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(createAction(actionType));_context4.next=3;return effect.apply(undefined,_toConsumableArray(args));case 3:model=_context4.sent;dispatch(createAction(actionType+'_FINISHED',model,false));return _context4.abrupt('return',model);case 6:case'end':return _context4.stop();}}},_callee4,this);}));return function createThunkEffect(_x7,_x8,_x9){return _ref4.apply(this,arguments);};}();var createThunkEffectWitMeta=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,actionType,effect,meta){for(var _len2=arguments.length,args=Array(_len2>4?_len2-4:0),_key2=4;_key2<_len2;_key2++){args[_key2-4]=arguments[_key2];}var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(createAction(actionType));_context5.next=3;return effect.apply(undefined,_toConsumableArray(args));case 3:model=_context5.sent;dispatch(createAction(actionType+'_FINISHED',model,false,meta));return _context5.abrupt('return',model);case 6:case'end':return _context5.stop();}}},_callee5,this);}));return function createThunkEffectWitMeta(_x10,_x11,_x12,_x13){return _ref5.apply(this,arguments);};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var SET_LOCATION='Comunidade.SET_LOCATION';var SET_ZIPCODE='Comunidade.SET_ZIPCODE';var SET_USE_LOCATION='Comunidade.SET_USE_LOCATION';var REQUEST_GET_SHOWCASE_STORES='Comunidade.REQUEST_GET_SHOWCASE_STORES';var REQUEST_GET_SHOWCASE_STORES_FINISHED='Comunidade.REQUEST_GET_SHOWCASE_STORES_FINISHED';var REQUEST_GET_SHOWCASE_OFFERS='Comunidade.REQUEST_GET_SHOWCASE_OFFERS';var REQUEST_GET_SHOWCASE_OFFERS_FINISHED='Comunidade.REQUEST_GET_SHOWCASE_OFFERS_FINISHED';var REQUEST_GET_LOCATION_FROM_ZIP_CODE='Comunidade.REQUEST_GET_LOCATION_FROM_ZIP_CODE';var REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED='Comunidade.REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED';function setLocation(location){return createAction(SET_LOCATION,location);}function setZipCode(zipCode){return createAction(SET_ZIPCODE,zipCode);}function setUseLocation(value){return createAction(SET_USE_LOCATION,value);}function getStoreShowcase(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var stores;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:stores=getState().comunidade.showcase.filters.stores;_context.next=3;return createThunkEffect(dispatch,REQUEST_GET_SHOWCASE_STORES,__WEBPACK_IMPORTED_MODULE_1__effects__["c" /* getStores */],stores);case 3:case'end':return _context.stop();}}},_callee,_this);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();}function getOfferShowCase(type){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var filter;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:filter=getState().comunidade.showcase.filters[type];_context2.next=3;return createThunkEffectWitMeta(dispatch,REQUEST_GET_SHOWCASE_OFFERS,__WEBPACK_IMPORTED_MODULE_1__effects__["b" /* getOffers */],type,filter);case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}();}function getLocationFromZipCode(){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var zipCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:zipCode=getState().comunidade.showcase.zipCode;_context3.next=3;return createThunkEffect(dispatch,REQUEST_GET_LOCATION_FROM_ZIP_CODE,__WEBPACK_IMPORTED_MODULE_1__effects__["a" /* getLocationFromZipCode */],zipCode);case 3:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}();}function createAction(type){var payload=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;var error=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var meta=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return{type:type,payload:payload,error:error,meta:meta};}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComunidadeIuppService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios__ = __webpack_require__(1688);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var EndPoints={Token:'/v1/auth/application_token',Offers:'/v1/Search/FilterOffers',Unitys:'/v1/Search/Filter',Verify:'v1/auth/Token_Verify',Unity:'v1/Unity',Categories:'/v1/Category/All',Location:'/v1/Address/Search/',Evaluate:'/v1/ToEvaluate',Complain:'v2/Complain',ReportComplain:'v2/ReportComplain'};var COMUNIDADE_IUPP_PORTAL_API={URL:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_API};var ComunidadeIuppService={getAccessToken:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(''+EndPoints.Token));case 1:case'end':return _context.stop();}}},_callee,this);}));function getAccessToken(){return _ref.apply(this,arguments);}return getAccessToken;}(),getOffers:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).post(''+EndPoints.Offers,payload));case 1:case'end':return _context2.stop();}}},_callee2,this);}));function getOffers(_x){return _ref2.apply(this,arguments);}return getOffers;}(),getUnitys:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).post(''+EndPoints.Unitys,payload));case 1:case'end':return _context3.stop();}}},_callee3,this);}));function getUnitys(_x2){return _ref3.apply(this,arguments);}return getUnitys;}(),getLocation:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(cep){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(''+EndPoints.Location+cep));case 1:case'end':return _context4.stop();}}},_callee4,this);}));function getLocation(_x3){return _ref4.apply(this,arguments);}return getLocation;}(),getCategories:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(''+EndPoints.Categories));case 1:case'end':return _context5.stop();}}},_callee5,this);}));function getCategories(){return _ref5.apply(this,arguments);}return getCategories;}(),tokenVerify:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(''+EndPoints.Token).then(function(response){if(window.localStorage.getItem('comunidadeIuppToken')){window.localStorage.removeItem('comunidadeIuppToken');}if(response.data.objectReturn.token){window.localStorage.setItem('comunidadeIuppToken',response.data.objectReturn.token);}}).catch(function(){});case 2:case'end':return _context6.stop();}}},_callee6,this);}));function tokenVerify(){return _ref6.apply(this,arguments);}return tokenVerify;}(),getUnity:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(rede,unidade){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:return _context7.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(EndPoints.Unity+'/'+unidade+'/'+rede));case 1:case'end':return _context7.stop();}}},_callee7,this);}));function getUnity(_x4,_x5){return _ref7.apply(this,arguments);}return getUnity;}(),getEvaluate:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(companyId){var items=arguments.length>1&&arguments[1]!==undefined?arguments[1]:5;var page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:return _context8.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(EndPoints.Evaluate+'/All/'+companyId+'/'+items+'/'+page));case 1:case'end':return _context8.stop();}}},_callee8,this);}));function getEvaluate(_x8){return _ref8.apply(this,arguments);}return getEvaluate;}(),createEvaluate:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:return _context9.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).post(EndPoints.Evaluate+'/Create',payload));case 1:case'end':return _context9.stop();}}},_callee9,this);}));function createEvaluate(_x9){return _ref9.apply(this,arguments);}return createEvaluate;}(),getComplain:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:return _context10.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).get(EndPoints.Complain+'/all'));case 1:case'end':return _context10.stop();}}},_callee10,this);}));function getComplain(){return _ref10.apply(this,arguments);}return getComplain;}(),createReportComplain:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:return _context11.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_1__axios__["a" /* default */])(COMUNIDADE_IUPP_PORTAL_API.URL).post(EndPoints.ReportComplain+'/Create',payload));case 1:case'end':return _context11.stop();}}},_callee11,this);}));function createReportComplain(_x10){return _ref11.apply(this,arguments);}return createReportComplain;}(),refreshToken:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var resultToken;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return this.getApplicationToken();case 2:resultToken=_context12.sent;if(window.localStorage.getItem('comunidadeIuppToken')){window.localStorage.removeItem('comunidadeIuppToken');}if(resultToken.data.objectReturn.token){window.localStorage.setItem('comunidadeIuppToken',resultToken.data.objectReturn.token);}case 5:case'end':return _context12.stop();}}},_callee12,this);}));function refreshToken(){return _ref12.apply(this,arguments);}return refreshToken;}()};

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_footer_css__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_molecules_footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_features_Nps__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FooterPlaceholder__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FooterContent__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileMenu__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MobileMenuLogged__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Shared_GTM_getButton__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(props){_classCallCheck(this,Footer);var _this=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this.openNPS=function(){_this.setState({openNPS:!_this.state.openNPS});};_this.state={profileMenu:false,userMenu:false,categoryMenu:true,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false,openNPS:false,showIuppMobileMenu:false};return _this;}_createClass(Footer,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FooterPlaceholder__["a" /* default */],null)},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS_BUTTON&&this.state.openNPS&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_features_Nps__["a" /* default */],{urlNps:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS_BUTTON,closeDonation:true}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('footer',{id:'footer',title:'rodap\xE9',className:'box-footer d-print-none'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS_BUTTON&&this.props.profile&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:'btnFeedBack',onClick:function onClick(){_this2.openNPS();Object(__WEBPACK_IMPORTED_MODULE_11_Shared_GTM_getButton__["a" /* getButton */])(_this2.props.profile,'home','clique:menu','deixe-sua-opiniao');}},'Deixe sua opini\xE3o'),this.props.profile?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{maxWidth:479},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__MobileMenuLogged__["a" /* default */],null))):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{maxWidth:479},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MobileMenu__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minWidth:480},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FooterContent__["a" /* default */],{profile:this.props.profile}))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);Footer.propTypes={profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var FooterPlaceholder=function FooterPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer bg-brand-4 container-fluid py-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address col-12 col-md-6 align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-2 bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 align-self-center mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-3 radius opacity'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 txt-right downloadit-app txt-circular-book color-ui-white txt-center txt-md-right mt-3 mt-md-0 align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-2 bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-2 bg-ui-3 radius opacity'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer bg-ui-1 container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'links col-12 px-0 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius opacity'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'legal col-12 px-0 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-3 radius opacity'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-3 radius opacity'}))))));};/* harmony default export */ __webpack_exports__["a"] = (FooterPlaceholder);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-store.52d6ed33.svg";

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google-play.8837f5e2.svg";

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MyAccountGuest__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MyAccountLogged__ = __webpack_require__(1702);
var IuppContactList=function IuppContactList(props){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){window.addEventListener('load',function(){var hideCSDPWidget=document.querySelector('[id^="csdp_"]');hideCSDPWidget&&hideCSDPWidget.setAttribute('tabindex','-1');});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 contact-list row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 col-lg-3 py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address col-12 logo-footer px-0',role:'img','aria-label':"Tupperware | Premmiar"||''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-0 color-ui-white txt-subtitle'},'Banco Itaucard S.A.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-0 color-ui-white txt-subtitle'},'CNPJ/MF sob o n\xBA 17.192.451/0001-70'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-0 color-ui-white txt-subtitle'},'Pra\xE7a Alfredo Egydio de Souza Aranha,'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-0 color-ui-white txt-subtitle'},'100, Torre Olavo Setubal, 7\xBA andar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'m-0 color-ui-white txt-subtitle'},'Parque Jabaquara - S\xE3o Paulo - SP')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 social-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/Iupp-107690693947953/',target:'_blank',className:'facebook-icon d-block','aria-label':'Acessar a nossa p\xE1gina no Facebook em uma p\xE1gina externa'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 social-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.instagram.com/iupp/',target:'_blank',className:'instagram-icon d-block','aria-label':'Acessar a nossa p\xE1gina no Instagram em uma p\xE1gina externa'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 social-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.youtube.com/channel/UCCwUfTgGBcf9aqx_hV38-KA',target:'_blank',className:'youtube-icon d-block','aria-label':'Acessar o nosso canal no YouTube em uma p\xE1gina externa'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 social-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://twitter.com/iupp',target:'_blank',className:'twitter-icon d-block','aria-label':'Acessar o nosso perfil no Twitter em uma p\xE1gina externa'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 col-lg-3 py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3'},'Sobre o iupp'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/accessibility-status'},'Estatuto de acessibilidade')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/regulation'},'Regulamentos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/privacy'},'Pol\xEDticas de privacidade')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/terms'},'Termos de uso')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 col-lg-3 py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3'},'T\xE1 com d\xFAvida?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_URL+'hc/pt-br/requests/new',target:'_blank'},'Fale com a gente')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_URL+'hc/pt-br',target:'_blank'},'D\xFAvidas frequ\xEAntes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_URL+'hc/pt-br/articles/360037500412-como-entro-em-contato-com-o-atendimento-do-iupp-',target:'_blank'},'Telefones \xFAteis')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 col-lg-3 py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3'},'Minha conta'),props.profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MyAccountLogged__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MyAccountGuest__["a" /* default */],null)));};IuppContactList.propTypes={profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (IuppContactList);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Profile_Profile__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Faq_Faq__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Items_Items__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubItems_SubItems__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Header_GuestHeader_GuestUserProfileMobile__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MenuMobile=function(_Component){_inherits(MenuMobile,_Component);function MenuMobile(props){_classCallCheck(this,MenuMobile);var _this=_possibleConstructorReturn(this,(MenuMobile.__proto__||Object.getPrototypeOf(MenuMobile)).call(this,props));_this.menuBenefits=function(){_this.setState({menuBenefitsOpened:!_this.state.menuBenefitsOpened});};_this.closeMenu=function(){var checkMenu=document.getElementById('menuToggle');if(checkMenu&&checkMenu.checked===true){checkMenu.checked=false;}_this.props.callReset();};_this.checkMenuContext=function(onlyCash){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var currentContext=onlyCash?'cash':'points';return context.indexOf(currentContext)>-1;};_this.mountDisplay=function(items){items&&items.map(function(__,index){return _this.state.displayMenu.push({index:index,display:false});});};_this.clickHandler=function(index){return function(){_this.state.displayMenu.map(function(it,x){it.display=x===index;});_this.setState({displayMenu:_this.state.displayMenu});setTimeout(function(){document.querySelectorAll('#btn-close-submenu').length>0&&document.getElementById('btn-close-submenu').focus();},300);};};_this.callUserMenu=function(){_this.setState({userMenu:true});};_this.closeUserMenu=function(){_this.setState({userMenu:false});_this.props.profileMenuState();};_this.formatSubItems=function(item){if(item.dynamicAction==='loadCategories'){item.items=_this.props.productCategories.items.map(function(cat){return{label:cat.name,path:'/search?category='+cat.id};});}if(item.dynamicAction==='loadEcommerceStores'){item.items=_this.props.stores.ecommerce.map(function(st){return{label:st.name,path:'/vendor?vendor='+st.supplierId};});}if(item.dynamicAction==='loadVouchersStores'){item.items=_this.props.stores.vouchers.map(function(st){return{label:st.name,path:'/vendor?vendor='+st.supplierId};});}};_this.clickHandler=_this.clickHandler.bind(_this);_this.closeMenu=_this.closeMenu.bind(_this);var externalExtractUrl=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_EXTRACT_URL;_this.items=props.categoryMenuItens;_this.state={displayMenu:[],userMenu:false,items:[{path:externalExtractUrl||'/extract',label:'Extrato',icon:'icon_listing',hide:!__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_EXTRACT,{default:true}),order:0,type:'external'},{path:'/my-orders',label:'Pedidos',icon:'icon_package',hide:!__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_ORDERS,{default:true}),order:1},{path:'/profile',label:'Informações Pessoais',icon:'icon_edit',order:5,hide:__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HIDE_PERSONAL_INFO,{default:true})},{path:'/my-address',label:'Endereço',icon:'icon_truck',hide:!__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_ADDRESS,{default:true}),order:6},{path:props.profile?"https://onboarding.webpremios.com.br/Login/RedirectCognito?id="+props.profile['custom:campaign_id']:'',label:'Verificação em Duas Etapas',icon:'icon_link',hide:!__WEBPACK_IMPORTED_MODULE_9_yn___default()("false",{default:true}),type:'external',order:7},{path:__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_SECURITY_ACCESS)?'/security-access':'/my-account/change-password',label:__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_SECURITY_ACCESS)?'Acessos e segurança':'Alterar Senha',icon:'icon_lock',order:8,hide:__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HIDE_CHANGE_PASSWORD)}],menuBenefitsOpened:false};_this.itemsOrdered=_this.state.items.sort(function(a,b){return a.order-b.order;});return _this;}_createClass(MenuMobile,[{key:'componentWillMount',value:function componentWillMount(){this.mountDisplay(this.props.categoryMenuItens);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menuToggle col-auto order-1 pos-absolute'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 justify-content-start justify-content-md-center pl-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'menuToggle',checked:this.props.categoryMenu||this.props.userMenu,onChange:function onChange(){return _this2.props.callReset(_this2.props.stateMenu);},tabIndex:-1,'aria-hidden':true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menuToggleContainer bg-white '+(this.props.categoryMenu||this.props.userMenu?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'txt-left radius px-0 py-0 '+(this.props.profileMenu||this.state.userMenu?'d-none':'')+' '+(this.state.displayMenu&&this.state.displayMenu.find(function(obj){return obj.display===true;})?'d-none':'')+' ',role:'navigation',tabIndex:-1},this.props.profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Profile_Profile__["a" /* default */],this.props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Header_GuestHeader_GuestUserProfileMobile__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 py-0 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mx-2 px-half pt-2 pb-1 border-bottom border-color-ui-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Destaques'))),this.items&&this.items.map(function(item,index){return _this2.checkMenuContext(_this2.props.onlyCash,item.context||['points','cash'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Items_Items__["a" /* default */],Object.assign({key:index},item,{click:_this2.clickHandler,closeMenu:_this2.closeMenu,index:index}));})),this.items&&this.items.map(function(item,index){var labelParent=item.label;_this2.formatSubItems(item);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SubItems_SubItems__["a" /* default */],Object.assign({key:index,displayMenu:_this2.state.displayMenu,close:_this2.clickHandler,index:index,labelParent:labelParent,callReset:function callReset(){return _this2.props.callReset();}},item));}),(this.props.profileMenu||this.state.userMenu)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subMenuToggle  '+(this.props.profileMenu?'active':'')+' '+(this.state.userMenu?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'txt-left radius px-0 py-0'},this.props.profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Profile_Profile__["a" /* default */],this.props):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile  border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["Link"],{role:'link',to:'/wishlist',className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile','aria-label':'Favoritos '+(this.props.wishlist.length===0||this.props.wishlist.length===undefined?0:this.props.wishlist.length)+' '+(this.props.wishlist.length>1?'itens':'item')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative border-bottom border-color-ui-1 mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-0 mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Icon"],{iconName:'icon icon_wishlist pos-relative icon-menu-mobile'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-2 px-0 pl-half ml-1','aria-hidden':'true'},'Favoritos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm border radius-circle border-color-ui-4 bg-ui-2 color-brand-1 wishlist-counter d-flex justify-content-center align-items-center'},this.props.wishlist.length===0||this.props.wishlist.length===undefined?0:this.props.wishlist.length))))))),this.itemsOrdered.map(function(item,indexItem){return item.hide===false?item.type==='external'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:indexItem,className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.path,className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile','aria-label':item.label+' (p\xE1gina externa)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 pl-0','aria-hidden':true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Icon"],{iconName:'icon '+item.icon+' pos-relative icon-menu-mobile'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-0 px-0 pl-half ml-1','aria-hidden':true},item.label)))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:indexItem,className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["Link"],{role:'link',to:item.path,className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile','aria-label':item.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 pl-0','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Icon"],{iconName:'icon '+item.icon+' pos-relative icon-menu-mobile'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-0 px-0 pl-half ml-1','aria-hidden':'true'},item.label)))))):'';}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Faq_Faq__["a" /* default */],{activePage:function activePage(){return _this2.props.activePage();},callReset:function callReset(){return _this2.props.callReset();}}),__WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_LOGOUT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 h-100 item-menu-mobile border-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["Link"],{role:'link',to:'/auth/logout',className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile','aria-label':'realizar logoff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 pl-0','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Icon"],{iconName:'icon icon_logout pos-relative icon-menu-mobile'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-0 px-0 pl-half ml-1','aria-hidden':'true'},'Sair'))))))))))));}}]);return MenuMobile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MenuMobile.propTypes={productCategories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,pointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,balance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,publicUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,wishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,profileMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,profileMenuState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,activePage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,callReset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,stateMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,userMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,categoryMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,categoryMenuItens:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,catalog_id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,login:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var onlyCash=_ref.onlyCash,oidc=_ref.oidc;return{onlyCash:onlyCash,catalog_id:oidc.user.profile['custom:catalog_id'],login:oidc.user.profile.preferred_username};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps)(MenuMobile));

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GLOBAL_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCoalescedOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setGlobalOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(319);
// constants


/**
 * @constant {Object} GLOBAL_OPTIONS the global options to apply as fallback to local props
 */
var GLOBAL_OPTIONS = {
  hasSourceMap: !__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* IS_PRODUCTION */],
  isCompressed: true,
  isMinified: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* IS_PRODUCTION */],
  isPrefixed: true
};

/**
 * @function getCoalescedOption
 *
 * @description
 * get the option either from props if it exists, or globally
 *
 * @param {Object} props the props to the specific instance
 * @param {string} option the option to coalesce
 * @returns {boolean} the coalesced option
 */
var getCoalescedOption = function getCoalescedOption(props, option) {
  return typeof props[option] === 'boolean' ? props[option] : GLOBAL_OPTIONS[option];
};

/**
 * @function setGlobalOptions
 *
 * @description
 * set the options passed to be global
 *
 * @param {Object} options the objects to apply globally
 * @returns {void}
 */
var setGlobalOptions = function setGlobalOptions(options) {
  return Object.keys(options).forEach(function (option) {
    return GLOBAL_OPTIONS.hasOwnProperty(option) && typeof options[option] === 'boolean' && (GLOBAL_OPTIONS[option] = options[option]);
  });
};

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Features__ = __webpack_require__(1729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Features__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToggleFeature__ = __webpack_require__(1730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ToggleFeature__["a"]; });


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchRecomendationParticipant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRecomendationSku; });
/* unused harmony export fetchAvailability */
var productSuggestion=5;var fetchRecomendationParticipant=function fetchRecomendationParticipant(participantId,identifier){return{type:'FETCH_PRODUCT_RECOMENDATION',participantId:participantId,payload:{client:'cloudloyalty',request:{url:'/v2/showcases/'+productSuggestion+'?identifier='+identifier+'&cachedPrice=true'}}};};var fetchRecomendationSku=function fetchRecomendationSku(productId,identifier){return{type:'FETCH_PRODUCT_RECOMENDATION',productId:productId,payload:{client:'cloudloyalty',request:{url:'/v2/showcases/'+productSuggestion+'?identifier='+identifier+'&cachedPrice=true'}}};};var fetchAvailability=function fetchAvailability(sku,vendorId,originalId){return{type:'FETCH_RECOMENDATION_AVAILABILITY',payload:{client:'cloudloyalty',request:{url:'/v1/products/skus/'+sku+'/availability?vendorId='+vendorId+'&originalId='+originalId}}};};

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdSlider__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AdSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdBanner__ = __webpack_require__(1779);
/* unused harmony reexport AdBanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wrapperSlider__ = __webpack_require__(1780);
/* unused harmony reexport WrapperSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__doubleSlider__ = __webpack_require__(1784);
/* unused harmony reexport DoubleSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SliderContainer__ = __webpack_require__(1787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__SliderContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConexxeBanner__ = __webpack_require__(1788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__ConexxeBanner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConexxeBannerDFP__ = __webpack_require__(1789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__ConexxeBannerDFP__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConexxeBannerVivo__ = __webpack_require__(1790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__ConexxeBannerVivo__["a"]; });


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gpt__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_gpt__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_2_react_gpt__["Bling"].configure({renderWhenViewable:false,collapseEmptyDiv:true,outOfPage:true});var AdSlider=function(_Component){_inherits(AdSlider,_Component);function AdSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AdSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AdSlider.__proto__||Object.getPrototypeOf(AdSlider)).call.apply(_ref,[this].concat(args))),_this),_this.nextSlide=function(){jQuery('.csslider input[type="radio"]').each(function(b,e){jQuery(e).is(":checked")&&(b+1==jQuery('.csslider input[type="radio"]').length?setTimeout(function(){jQuery('.csslider input[type="radio"]:eq(0)').trigger("click");},5000):setTimeout(function(){jQuery(e).next().trigger("click");},5000));});},_this.removeEmpty=function(event){if(event.isEmpty){jQuery('.'+_this.state.sliderPosition).remove();}else{setTimeout(function(){_this.props.sendSliderLoaded(_this.state.sliderPosition);},1000);if(jQuery('.csslider .navigation.d-none').length>0){setTimeout(function(){jQuery('.csslider .navigation').removeClass('d-none').addClass('d-block');},3000);}}if(jQuery('.cssslider-container li.scrollable').length==0){jQuery('.container-slider').remove();}if(jQuery('.cssslider-container li.scrollable').length<=2){jQuery('.container-slider .arrows').remove();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AdSlider,[{key:'componentWillMount',value:function componentWillMount(){this.urlSlider='/'+this.props.accountDfp+'/'+this.props.sliderName;this.setState({sliderPosition:this.props.sliderPosition});}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;/* eslint-disable */setInterval(function(){_this2.nextSlide();},7000);/* eslint-enable */}/* eslint-disable */},{key:'render',/* eslint-enable */value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_gpt__["Bling"],{adUnitPath:this.urlSlider,targeting:this.props.targeting,sizeMapping:this.props.sizeMapping,onSlotRenderEnded:this.removeEmpty});}}]);return AdSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AdSlider.propTypes={accountDfp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,sliderName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,targeting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,sizeMapping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,sliderPosition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,sendSliderLoaded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AdSlider);

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(644);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1761);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toObject = Object;
var TypeErr = TypeError;

module.exports = function flags() {
	if (this != null && this !== toObject(this)) {
		throw new TypeErr('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(645);

var supportsDescriptors = __webpack_require__(322).supportsDescriptors;
var gOPD = Object.getOwnPropertyDescriptor;
var TypeErr = TypeError;

module.exports = function getPolyfill() {
	if (!supportsDescriptors) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	if (/a/mig.flags === 'gim') {
		var descriptor = gOPD(RegExp.prototype, 'flags');
		if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
			return descriptor.get;
		}
	}
	return implementation;
};


/***/ }),
/* 647 */
/***/ (function(module, exports) {

'use strict';

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function (delay, noTrailing, callback, debounceMode) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if (typeof noTrailing !== 'boolean') {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper() {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec() {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear() {
			timeoutID = undefined;
		}

		if (debounceMode && !timeoutID) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if (timeoutID) {
			clearTimeout(timeoutID);
		}

		if (debounceMode === undefined && elapsed > delay) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();
		} else if (noTrailing !== true) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}
	}

	// Return the wrapper function.
	return wrapper;
};

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdSlider__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WrapperSliderPlaceholder__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_slider_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_molecules_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_modules_carousel_css_owl_theme_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_showcases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_template_cssslider_css__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_template_cssslider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_template_cssslider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Shared_GTM_getBanner__ = __webpack_require__(1783);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WrapperSlider=function(_Component){_inherits(WrapperSlider,_Component);function WrapperSlider(props){_classCallCheck(this,WrapperSlider);var _this=_possibleConstructorReturn(this,(WrapperSlider.__proto__||Object.getPrototypeOf(WrapperSlider)).call(this,props));_this.stateCarousel=false;_this.state={checked:0,ready:false,sliderLoaded:[]};_this.handleChange=function(idx){_this.setState({checked:idx});};_this.sendSliderLoaded=_this.sendSliderLoaded.bind(_this);return _this;}_createClass(WrapperSlider,[{key:'sendSliderLoaded',value:function sendSliderLoaded(name){var sliders=this.state.sliderLoaded;sliders.push(name);this.setState({sliderLoaded:sliders});if(document.querySelectorAll('.csslider .cssslider-container li').length===sliders.length){var items=[];sliders.forEach(function(entry){items.push({'id':entry,'name':entry});});Object(__WEBPACK_IMPORTED_MODULE_11_Shared_GTM_getBanner__["a" /* getBanner */])(this.props.profile,'enhanced-ecommerce','promotionImpression',items);}}},{key:'componentWillMount',value:function componentWillMount(){this.setState({dotsSlider:'d-none',slideReady:false});this.state.ready&&this.setState({ready:false});}},{key:'promotionClick',value:function promotionClick(_promotionClick){window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'promotionClick','eventCategory':'enhanced-ecommerce','eventAction':'promotionClick','ecommerce':{'promoClick':{'promotions':[{'id':_promotionClick,'name':_promotionClick}]}}});}},{key:'render',value:function render(){var _this2=this;setTimeout(function(){!_this2.state.ready&&_this2.setState({ready:true});},3000);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:this.state.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__WrapperSliderPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-slider container-fluid  py-2','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' container pos-relative radius px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'csslider infinity'},this.props.sliders.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{tabIndex:'-1','aria-hidden':'true',type:'radio',name:'dfpslides',key:index,id:'dpfslides_'+index,className:'slider-position slider-position-'+index,onChange:function onChange(e){return _this2.handleChange(index);},checked:index===_this2.state.checked});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'cssslider-container'},this.props.sliders.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'aria-hidden':'true',key:index,'slider-position':index,className:'scrollable slider-position slider-position-'+index,onClick:function onClick(){return _this2.promotionClick('slider-position-'+index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AdSlider__["a" /* default */],{accountDfp:itemSlider.accountDfp,sliderName:itemSlider.sliderName,sizeMapping:itemSlider.sizeMapping,targeting:itemSlider.targeting,collapseEmptyDivs:true,sliderPosition:'slider-position-'+index,sendSliderLoaded:_this2.sendSliderLoaded}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrows'},this.props.sliders.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'aria-hidden':'true',htmlFor:'dpfslides_'+index,key:index,index:index,className:'slider-position-'+index+' slider-position'});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navigation '+this.state.dotsSlider},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.sliders.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'aria-hidden':'true',key:index,htmlFor:'dpfslides_'+index,className:'slider-position slider-position-'+index});})))))));}}]);return WrapperSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WrapperSlider.propTypes={sliders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (WrapperSlider);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_template_showcases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Catalog_Showcase_ShowcasePlaceholder__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Catalog_Showcase_ShowcaseHeader__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Catalog_Showcase_ShowcaseProductListWrapper__ = __webpack_require__(1793);
var Showcase=function Showcase(_ref){var children=_ref.children,isLoading=_ref.isLoading,products=_ref.products,title=_ref.title,titleOnlyCash=_ref.titleOnlyCash,mobileTitle=_ref.mobileTitle,id=_ref.id,showcaseType=_ref.showcaseType,identifier=_ref.identifier,catalogId=_ref.catalogId,viewAllPath=_ref.viewAllPath;return isLoading||id?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Catalog_Showcase_ShowcasePlaceholder__["a" /* default */],{isLoading:isLoading&&products.length===0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'showcard-products container-card container py-1 py-md-3 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Showcase_ShowcaseHeader__["a" /* default */],{title:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_TITLE_SHOWCASE_DEFAULTS||title,titleOnlyCash:titleOnlyCash,mobileTitle:mobileTitle,viewAllPath:viewAllPath||getUrlViewAllShowcaseHome(catalogId)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Catalog_Showcase_ShowcaseProductListWrapper__["a" /* default */],{viewAllPath:viewAllPath||'/search'},children))):null;};Showcase.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,titleOnlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,mobileTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,showcaseType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,identifier:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,catalogId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,viewAllPath:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};function getUrlViewAllShowcaseHome(catalogId){var result='/search';if(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SHOWCASE_HOME_VIEWALL_URL){var catalogViewAllUrls=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SHOWCASE_HOME_VIEWALL_URL.split('|');var i=0;var value=catalogId;for(i=0;i<catalogViewAllUrls.length;i++){if(catalogViewAllUrls[i].split(',')[0]===value){result=catalogViewAllUrls[i].split(',')[1];}}if(catalogViewAllUrls.length<=0){if(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SHOWCASE_HOME_VIEWALL_URL.split(',')[0]===value){result=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SHOWCASE_HOME_VIEWALL_URL.split(',')[1];}}}return result;}var mapStateToProps=function mapStateToProps(_ref2){var profile=_ref2.oidc.user.profile;return{catalogId:profile['custom:catalog_id']};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(path));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Showcase));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive__);
var ShowcaseHeader=function ShowcaseHeader(_ref){var title=_ref.title,titleOnlyCash=_ref.titleOnlyCash,mobileTitle=_ref.mobileTitle,viewAllPath=_ref.viewAllPath,onlyCash=_ref.onlyCash;var showTitleDesktop=onlyCash?titleOnlyCash!=='':title!=='';var showTitleMobile=mobileTitle!=='';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx-0 px-0'},showTitleDesktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'},onlyCash?titleOnlyCash:title),showTitleMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-block d-md-none px-md-0 pt-1 px-0'},mobileTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:viewAllPath,className:'card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert','aria-label':'Ver todos os produtos'},'Ver todos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{'aria-hidden':'true',iconName:'icon-sm icon_right'})))));};ShowcaseHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,titleOnlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,mobileTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,viewAllPath:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ShowcaseHeader.defaultProps={viewAllPath:'/search'};var mapStateToProps=function mapStateToProps(_ref2){var onlyCash=_ref2.onlyCash;return{onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ShowcaseHeader));

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css__);
// @ts-nocheck
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card container pt-3 pb-1 py-md-3 px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx--1 mx-md-0 px-2 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1 d-none  d-md-flex '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 d-none d-md-flex px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))))));};var ShowCasePlaceHolder=function ShowCasePlaceHolder(_ref){var isLoading=_ref.isLoading,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:!isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder,null)},children));};ShowCasePlaceHolder.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};ShowCasePlaceHolder.defaultProps={isLoading:true};/* harmony default export */ __webpack_exports__["a"] = (ShowCasePlaceHolder);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_slugify__);
var StoreGroup=function StoreGroup(_ref){var title=_ref.title,items=_ref.items,hasContent=_ref.hasContent;return hasContent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryGroup col-12 pb-3 '+__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(title,{delimiter:'-'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'CategoryParent mb-1'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryChilds row'},items.map(function(item,ix){return  false?item.supplierTypeId!=='4'&&React.createElement('div',{key:ix,className:'col-12 col-md-4 pt-half pl-3 pl-md-1  '+slugify(item.name,{delimiter:'-'})},React.createElement('p',null,React.createElement(Link,{to:item.customUrlPage!==undefined&&item.customUrlPage!==null?item.customUrlPage:'/vendor?vendor='+item.supplierId,className:'txt-body-sm '+(item.name==='CONEXXE TRAVEL'?'d-none':'')},item.name))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:ix,className:'col-12 col-md-4 pt-half pl-3 pl-md-1  '+__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(item.name,{delimiter:'-'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'data-supplierId':item.supplierTypeId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:item.customUrlPage!==undefined&&item.customUrlPage!==null?item.customUrlPage:'/vendor?vendor='+item.supplierId,className:'txt-body-sm'},item.name)));}))):'';};StoreGroup.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,hasContent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StoreGroup);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var StorePage=function StorePage(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 px-3'},children)))))));};StorePage.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StorePage);

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = function (string, preserve) {
  if (!preserve) {
    string = string.toLowerCase();
  }
  return string.charAt(0).toUpperCase() + string.substring(1);
}

module.exports.words = function (string, preserve) {
  if (!preserve) {
    string = string.toLowerCase();
  }
  return string.replace(/(?!^[0-9])(^|[^a-zA-Z\u00C0-\u017F\u0400-\u04FF'])([a-zA-Z\u00C0-\u017F\u0400-\u04FF])/g, function (m) {
    return m.toUpperCase()
  })
}


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Orders__ = __webpack_require__(1897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Orders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Order__ = __webpack_require__(1899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Order__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderSide__ = __webpack_require__(1901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__OrderSide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderProductItem__ = __webpack_require__(656);
/* unused harmony reexport OrderProductItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TrackingItem__ = __webpack_require__(657);
/* unused harmony reexport TrackingItem */


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_iphone_jpg__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_iphone_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_iphone_jpg__);
var OrderProductItem=function OrderProductItem(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_iphone_jpg___default.a,alt:'Imagem do produto'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},'Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1\u201D, android 6.0, 4G c\xE2mera 12MP'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item  mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Quantidade: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor unit\xE1rio: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2.000 pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Previs\xE3o de entrega: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10/11/2018'))))));};/* harmony default export */ __webpack_exports__["a"] = (OrderProductItem);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_tracking_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_tracking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_tracking_css__);
var TrackingItem=function TrackingItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tracking-steps col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_check_circle',className:'color-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-success txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Entregue')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle pt-half'},'em 10/10/2018 \xE0s 19:00')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_check_circle',className:'color-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-success txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Em rota de entrega')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle pt-half'},'em 10/10/2018 \xE0s 19:00')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_check_circle',className:'color-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-success txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Seu produto foi solicitado')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle pt-half'},'em 10/10/2018 \xE0s 19:00')))));};/* harmony default export */ __webpack_exports__["a"] = (TrackingItem);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillPaymentContainer__ = __webpack_require__(1920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BillPaymentContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(1922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormBillPayment__ = __webpack_require__(1926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__FormBillPayment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BillPaymentPlaceholder__ = __webpack_require__(1927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__BillPaymentPlaceholder__["a"]; });


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MileageContainer__ = __webpack_require__(1928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__MileageContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(1930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormMileage__ = __webpack_require__(1935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FormMileage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MileagePlaceholder__ = __webpack_require__(1936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__MileagePlaceholder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalCofirm__ = __webpack_require__(1937);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__ModalCofirm__["a"]; });


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FuelCreditContainer__ = __webpack_require__(1939);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__FuelCreditContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(1941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFuelCredit__ = __webpack_require__(1945);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FormFuelCredit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FuelCreditPlaceholder__ = __webpack_require__(1946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__FuelCreditPlaceholder__["a"]; });


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DonationContainer__ = __webpack_require__(1947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DonationContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(1951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormDonation__ = __webpack_require__(1955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__FormDonation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DonationPlaceholder__ = __webpack_require__(1957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__DonationPlaceholder__["a"]; });


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var titleName=function titleName(vendors,filterSelected){var filterNumber=parseInt(filterSelected);var filter='';vendors.some(function(el,i){if(el.id===filterNumber)filter=el.name;});return filter;};/* harmony default export */ __webpack_exports__["a"] = (titleName);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Filters__ = __webpack_require__(1971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Filters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectedFilters__ = __webpack_require__(1972);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__SelectedFilters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterItems__ = __webpack_require__(1973);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FilterItems__["a"]; });


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var SidebarPlaceholder=function SidebarPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-sidebar col-12 col-md-4 col-lg-3 pb-5 px-1 px-md-2 mb-5 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-filter row radius border-color-ui-3 radius mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 bg-white py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pb-half pl-1 pr-half bg-ui-4 radius mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half bg-ui-4 radius'}))));};/* harmony default export */ __webpack_exports__["a"] = (SidebarPlaceholder);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__);
var Item=function Item(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card col-6 col-md-4 mb-1 mb-md-2 mb-md-2 px-half px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,alt:'Ainda está carregando'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 ml-auto mr-auto mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 ml-auto mr-auto mb-1 py-2 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 ml-auto mr-auto mb-1 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))))))));};var SearchPlaceHolder=function SearchPlaceHolder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null)));};/* harmony default export */ __webpack_exports__["a"] = (SearchPlaceHolder);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_brand_cards_benefits_imagem_cinema_png__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_brand_cards_benefits_imagem_cinema_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_images_brand_cards_benefits_imagem_cinema_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_cards_benefits_imagem_teatro_png__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_cards_benefits_imagem_teatro_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_cards_benefits_imagem_teatro_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_saude_new_png__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_saude_new_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_saude_new_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_cards_new_meu_bairro_png__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_cards_new_meu_bairro_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_cards_new_meu_bairro_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_evino_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_evino_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_evino_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_emporio_nestle_png__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_emporio_nestle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_emporio_nestle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_benefits_css__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_benefits_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_benefits_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DiscountSuggestion__ = __webpack_require__(1983);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ItauCardLanding=function(_Component){_inherits(ItauCardLanding,_Component);function ItauCardLanding(props){_classCallCheck(this,ItauCardLanding);var _this=_possibleConstructorReturn(this,(ItauCardLanding.__proto__||Object.getPrototypeOf(ItauCardLanding)).call(this,props));_this.state={};return _this;}_createClass(ItauCardLanding,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["Link"],{className:'container-fluid pt-1 pt-md-0 bg-ui-3 benefits-banner-new',to:'/benefits/listing',title:'vai para lista de benef\xEDcios'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'container-fluid px-0 bg-white d-flex justify-content-center discount-accordion'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'container row px-0 pt-3'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col-12 col-md-6 row mx-0 px-0 px-md-1 d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["Link"],{to:'/benefits/listing',className:'bg-benefits-new mx-0 py-5 pl-3 pl-md-5 radius',title:'vai para lista de benef\xEDcios'})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col-12 col-md-6 mx-0 px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'row mx-0 pointer-beneficos'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTopMobile"],{link:'https://www.evino.com.br/',title:'Vai Evino',alt:'Evino',titleImg:'Evino',image:__WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_evino_png___default.a,description:'1\xAA compra: 10% off + frete com cupom IUPP10'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTopMobile"],{link:'https://emporionestle.parceriasonline.com.br/iupp',title:'Vai para Nestle',alt:'Nestle',titleImg:'Logo Nestle',image:__WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_emporio_nestle_png___default.a,description:'10% em todos os produtos da loja'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTopMobile"],{link:'/comunidade-iupp',title:'Vai para Comunidade iupp',alt:'Comunidade iupp',titleImg:'Logo Comunidade iupp',image:__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_cards_new_meu_bairro_png___default.a,description:'Confira os descontos perto de voc\xEA'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTopMobile"],{link:'https://atendimentoiupp.zendesk.com/hc/pt-br/sections/360010149252',title:'Vai para Farm\xE1rcias',alt:'Farm\xE1rcias',titleImg:'Logo Farm\xE1rcias',image:__WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_saude_new_png___default.a,description:'Confira os descontos nas principais farm\xE1cias'})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTop"],{link:'https://www.evino.com.br/',title:'Vai Evino',alt:'Evino',titleImg:'Evino',image:__WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_evino_png___default.a,description:'1\xAA compra: 10% off + frete com cupom IUPP10'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTop"],{link:'https://emporionestle.parceriasonline.com.br/iupp',title:'Vai para Nestle',alt:'Nestle',titleImg:'Logo Nestle',image:__WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_emporio_nestle_png___default.a,description:'10% em todos os produtos da loja'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTop"],{link:'/comunidade-iupp',title:'Vai para Comunidade iupp',alt:'Comunidade iupp',titleImg:'Logo Comunidade iupp',image:__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_cards_new_meu_bairro_png___default.a,description:'Confira os descontos perto de voc\xEA'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsTop"],{link:'https://atendimentoiupp.zendesk.com/hc/pt-br/sections/360010149252',title:'Vai para Farm\xE1rcias',alt:'Farm\xE1rcias',titleImg:'Logo Farm\xE1rcias',image:__WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_saude_new_png___default.a,description:'Confira os descontos nas principais farm\xE1cias'}))))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'container-fluid bg-white px-0 d-flex justify-content-center discount-options'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'container row px-0 pb-3'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'col-12 discount-options-title'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h2',{className:'txt-font-title color-title px-1 px-md-0 py-2 py-md-0 d-block d-md-none',tabIndex:0},'Veja uma sele\xE7\xE3o de benef\xEDcios especiais para voc\xEA.'),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h2',{className:'txt-font-title color-title px-1 px-md-0 d-none d-md-block',tabIndex:0},'Veja uma sele\xE7\xE3o de benef\xEDcios especiais para voc\xEA.')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsSpecialMobile"],{link:'https://www.itau.com.br/cartoes/beneficios/cinema/',title:'Vai para Cinema',image:__WEBPACK_IMPORTED_MODULE_0__loyal_images_brand_cards_benefits_imagem_cinema_png___default.a,titleImg:'Logo Cinema',name:'Cinema',description:'50% de desconto'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsSpecialMobile"],{link:'https://www.itau.com.br/cartoes/beneficios/teatro/',title:'Vai para teatro',image:__WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_cards_benefits_imagem_teatro_png___default.a,titleImg:'Logo Teatro',name:'Teatro',description:'At\xE9 50% de desconto'})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsSpecial"],{link:'https://www.itau.com.br/cartoes/beneficios/cinema/',title:'Vai para Cinema',image:__WEBPACK_IMPORTED_MODULE_0__loyal_images_brand_cards_benefits_imagem_cinema_png___default.a,titleImg:'Logo Cinema',name:'Cinema',description:'50% de desconto'}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["CardBenefitsSpecial"],{link:'https://www.itau.com.br/cartoes/beneficios/teatro/',title:'Vai para teatro',image:__WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_cards_benefits_imagem_teatro_png___default.a,titleImg:'Logo Teatro',name:'Teatro',description:'At\xE9 50% de desconto'})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:'container-fluid px-0 d-flex justify-content-center exclusive-discounts'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Showcase__["b" /* ShowcaseBenefits */],{title:'Confira nossas promo\xE7\xF5es e descontos exclusivos.',titleMobile:'Descontos exclusivos',searchPage:'/benefits/listing'},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DiscountSuggestion__["a" /* DiscountSuggestion */],null))));}}]);return ItauCardLanding;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);/* harmony default export */ __webpack_exports__["default"] = (ItauCardLanding);

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAAXNSR0IArs4c6QAAGaNJREFUeAHtnQeQHcdxhucAHMIBh5xzPEQikAQRiEREAqBIMIBBpCkapGVSskoWy3aVbFe5ylKpLNmWSnZJFCUKokwxR4AECRCBiETOOR+Rcz7k4P7msI+z+/Yd7sC73fcO3eThvd03u7P777893T0zPVnXRIyKIhATAhViqlerVQQsAkpAJUKsCCgBY4VfK1cCKgdiRUAJGCv8WrkSUDkQKwJKwFjh18qVgMqBWBFQAsYKv1auBFQOxIqAEjBW+LVyJaByIFYElICxwq+VKwGVA7EioASMFX6tXAmoHIgVASVgrPBr5UpA5UCsCCgBY4VfK1cCKgdiRUAJGCv8WrkSUDkQKwJKwFjh18qVgMqBWBFQAsYKv1auBFQOxIqAEjBW+LVyJaByIFYElICxwq+VKwGVA7EioASMFX6tXAmoHIgVASVgrPBr5UpA5UCsCCgBY4VfK1cCKgdiRUAJGCv8WrkSUDkQKwJKwFjh18qVgMqBWBFQAsYKv1auBFQOxIqAEjBW+LVyJaByIFYElICxwq+VKwGVA7EioASMFX6tXAmoHIgVASVgrPBr5ZUUgtJD4NLFi+at3/+vuXL5khn7+NOmQeOmpXfycnom1YCl9GAvC+nWLltk9n210/TsO8DUa9i4lM5cvk+TdU2kfN9iNHd38cJ5s2PzRnPt6lWT162HqVhJG5fiIK8oBVA6sGeXOXb4oDlbcMacKygwlbKzTZPmrUzrvE6Bkl9vfrVti5n+0dui/fIN73Or9nmm37B7Tcfben5dyPnmvfNZWVnO3lvz6y1HQB7+1StXUmqoJXNmmHXLlxjsuUuXLpoKFSqa3Fq1zLin/8a069TFbrtUOXPqlPnwz783h/bvNRUqVjSQasu61ebooQNCxJ+ZqtVy3OL2+5GD+828aZ+Y7OzKpmmrNqZJi1amfqMmpnKVKklly/uOW4qARw8dNBtXLTN1GzQynXveYckSfMAVKlYyp0+eMJUqZUu5hubU8eOiEQ+ZOZ9OEqeiialdt77vkK+2bTYH9+0xOdVrmF79B5lqOTlm/uefmiMHD1h7sG2nrr7ybBzat1euY7k5c+qk/a1W3Xqmz5ARpt89I0zVnOpJ5cvzjlvGCUHzffzmq2bK26+ZBdM/NSeOHgl9rg2bNLP7GzVrYV786S/Nk99/0WqxHZvWm4N79yQdc/zIIbuvcfOWZsyjT5nBYx4wDZs2t/sgbpjs/WqHKTh9ytSoWdN06t5LSH7MzPjoHTNj8vthxcv1vnJHQGy3hbOmWbLxYD3BSTh/tsBu7tv9lfGI4/3ufaKNaEYhCFIjt6apJtoNAnOOoFw4X7gvu3JlaZ4FTlw6KYtcFYckTI4c2G/P165TN/Pgd74r2vhOWxb7M5WsXDhPTIPFpuDM6VRFMnJ/uSMgttfU9940X86YauZO/dicu066s/LgLl64YB8SRNwr4ZIwqVa9urUPedAnjh0x2zeuk6byhKko9l2YPXdZ7EQku3Kh/Qbprl69YvfhwITJ4QP77G4cm5q160jIppHdvnzpUlhxS9bpH71r3nnlN2bnpg2hZTJ1Z7kjYAMx5us1KozBLZjxmZDxDau5Tp04bi6cP5d4TjgKV8QZCUrVqtVMFfm7dPGC+fk//p1tsnFIeg8aapq1bhssbp0VdqIBkStXLifOW6VqVbvP/efCuXPWBkTL7tuVb1+SRV98brVni7bt3aKJ7zs3b7AaO6dGrmnSsnVif3n4kpFOCNqskniQYV5jFfE6G4v9tl8eLrJu2WLrOGCjQSQe4IHrTfAZcTZocl1Bk3HeAmnpaterL3ZaLdOwSXMzZMw4cTCSHQRP29nmV0505bIQUP4QiByUPfk7Ehpy2bwvbJiH62rZtoPpJQHsoPAibF67yu7mvmrVrRssktHbGUdAPNlZH79vOkiwt2efu5PAR7O0kIeJzcR3muC5EvLAw6SJa9Wug4F4J8U+PCYORBgBveZ0+P2PmDyJ5UFCzhUm2VUKtdyxI4et94wJcOa6/Vhd7Meg7Nq+xe6CnJUkWE1TjzMy7IFHbEgmWP64OEtoa6Rd527WOw+WyeTtjCEgsTPsuqXzZlki4ZES6A3TSq07dLQhFMIcGPpb168xsyWMgkCKDl27mxVfzjVooDZ5nX3Pr2q1aoZmGIEkubVq+34PbnTtdaeZLwSnmfzZi88nfq4vZgCetCs0+dvEpkS4dsI2f/71z01OjZqmacs2btHE981rVhqcE86VKrCNllw8e4YlKs5Sl169pTvw7lBsEidOky9pT0AAxWGY9Nor5sDe3dbL7NzjDnPnwHukqUy2scC1Vp26pmW7PLNq0XxTp34D2ze7bP4XFnIIm9M613qUW9atsraep/EoQBeaZ7sVnCn0hO2BKf5p1qqtufeRb1uNC+G5XkI5/YaNKvSKnePoWfFifw2aNLU9Jjgqp8U+PX3imNWETnFrs26X8A8C+WrXa+D+bL9Dal4u7F3sS4Rmfm/+dgmeP5f2GjPtCQigdI0BKnJ7/8Hmvieetm83thOCh+oKYRO6wyAgx0IQyIbHCTGvyX+5terY3go0afM27RKH09S2Eg2aLXZg2ANPFLz+BcIOGDnWdJR43hHxbonAcD5egqCgqWh2qYORMrwM9SQoTi/KUbnOoIOxa8c2q/04T163nqE27+7tW83sKZOk3qsGUtesXdfkb9loNTwvaesOnYKXkVbbaU9AHlb33v3M0rmzzLYNaw0B4fNnz5rVi7+0tuDdI8aYwaPv94HKMWjJSX+ZaD3N42Kf/fi/X0qUIVSCx1lXtGNY6GOY2H4lEepD63lB7FTHoo1/8G//Yc6fO2u74ShH4Hr5gjlCtN2m2x19fIeumD/bnDx21GrxttINGBRile/88TfWqUFDPvzXz4uJkWsm/vJnEj5ab9avWGJfBnp10lXSnoAecAOEaDggBJDfeOlX4kAclsECZ2xIwyvjfuaKtsOLpSttp2iETj1uT/yMxzpi3KNWc1IuanHjibxcbTr67VCuhxeD5pdrzevaI8kJQvvPnPye4HHYxif7Dh1l7VW2CTkhaHn6stNZMiYO2KFbd+kxKCQRzTEPgCZmxIPjQ/HlwRHawMbybCO3IP28eMBe+MT9LcrvNOH0Lwf7mNGShINqiBOUd1uPpEvCMVm1aIHdT792u+t9zvQC0dOCWcJLF/f9JV14YEdGjQekOXrlv35iO/rbde5qnv7BP9mHlL91k1m1cL4Z89hTPsekMF6Y7dsXuP+03sSh4R4YoBC0c18V7xkPuanENb/3Lz81WRWyrFlCbwlO1cBRY62WT+sblIvLmCYYIGkuB937LfPRaxOtU7Jh5VLbkb9YhlAxuADnoVe/gQnM6TnIZMG2DIslck+HZAQO0lLimmhRRuXQ9Yjwct41eLj9nu7/ZBQBaU7uGDDELJkz0xLwk7f+z2oINAVeZ6qwTLo/hJu5Pjx07L2dMgobb5/AO80yGPQTezDMC7+Zesr6mIxqgj0wdu/cZt595beGTn0cjWH3P2x63NU/MSDAK1eePwnMv/7bXyXCNNwrDsdDz3xXQlWDkpyWdMUiIwlI/+v8aVPM7p3bbQyOZojm6lYStD592gu/mG727863wXO85f7DR1vHK1OwyEgCAm7h2LwsaXJuvWHsLrkgYsHp06L9s0MHP7hl0/F7xhIwHcHUayo5AhkTByz5rekRmYCAEjATnlI5vkYlYDl+uJlwa0rATHhK5fgalYDl+OFmwq0pATPhKZXja4ylK45JO8SvPCGlRbqP2vCutbx8gj8z+JiqSkzVTlmVffUl+0OUQ7giJSADQcm9Qt/ltatfE5DRx7f17mvuGjSsWD0apEJbNGu62bRmue886UwOBkn0kElU3vRNxuxNe//NRIaGBjKgdeCo+xJzhIP3MuvjD+y4RvLaZNEnfvdgO9XgRj1AEI1xk3Td2YlYkq3hOH9HD9uBvRdllHaCgDJSfPT4p2xXXrD+stqOlIB0HU0V0MPG5zEB/KSMaBn50OM3vNcls2eazz98287nuGHhNCnAw2eoPtNDEUZ4MzHKkx0yqQkiPPrc971diU/6vKdL6g5XDsr8GOYpe6OwmRS1cfUKOzOvQOamFAjpmGvCrMCwUd/uudzvzMCjLzkqiZSAvG2XLhTO4wi7waUyS40J4HXqNwz7ObGP5EHMr8gkobkjd6AnXsYGb5tPxv6FSVhZmkwXg8UyQmj14sIBqmHnKO4+5pZEKWnlhDBjjORBNLFFSdQgFXUtxf3NTkaSpjMhjg3s7XPtYm9fUZ/uKby8N0WVL85vlSoVZngoTtnSKBOpBizOBW9Zt8aOcWPubkmFCUo86HQU5h+TA7CshFEw5BksKYnd62Fga++BQ91dZf497Z4WzQpOCkOswlJbFIXIPfc9KFMdc4oqEttvZe1Z8sK279LtG95fVuTRiLQjIAhuWLlM5vV2lGHlw0oEaEVp4sr6QZfogiIsjDeclZXeM+DC4EhLAjIjbM5nk8ztdw8qtZn9NE3MFmPuBPlbzksWAcawkhaDzKdM4A7miQkDzNuHE7BHRmbvF88eDxfNnZVVwc7LrS+TzptJ6t2ybHK96yjqkymsDNolBHP6xAkpes1O4SRDLC0MoZ+4469pQUCmTgZDBcx32LxmlU2l+01AIujNAyB1xW7JNED8yw0DoTnIpECOPkjIVE+Ik6pOjP21knFr4+rllnw4Tu61cz7S9TKBiumSXW/vbW0zNDMknfPZZGvj8hIEZY+Q5Q+/+PfEbiayDxn7YGK7OF940QjbbJIUwKuWfGknbREHdJNlVpH8N7Xq1LMvyZ0DhkgC9s4p77c4dX6TMmlBQIK0xMS8tGbcEEDO+uQDSXfb7KYXfOEcC2d9brWpl5MlCBZlCH/wB0GxPx946llLnGBZwj/vTXzJJjviuDBhPxmv+GOSEAmQSN3BbL7TJ0+aZfMLsx2EHUt2V+KBCdlcmBHLy3eY2F/EFzT8+3/6nZ26mqoYL+Chc3vszLr1K5aa/pLRn3k1qRJqpjpPaex34gKlcbqbOwfranToclvSwSz6wgNM9bCTDgjsIDUHAetU5AsUt5uQjKz3JI10hYnwnItAbUmuh/ORJJM5vK4Wcs9dGt85N3WQloME6cUVgt9zp062L7urAIp7/DctlxYakKmE93zrIbvQC4C4QlNHU1aSJDsQhAQ9KxfO9QVrOS9pMUgMlFOjMO8zk90Pi23oJZqkDNqLjFOkOSOhEUKajK3X8/TZHdf/IWhOOjhyCNJNRvO3VzI3cA5PuB5MgNGSJKlFm/a2uUPbuaYAZZlQTq5AT3Kq56bsmvPKeJ/Yo9M+eEvu1x/op+uPmYN1Ce6LeUAvyaH9+2yvi3cs5CU/Dbi486q938vyMy0IyA2SRqNHn/62i8q9YRwHyPDMD4uf5Yns9NM+eLuwg905Gd1W4/7qWenCamf7ZLHXSPBDM/TZu6/bpEFecYi5cOY0M1ReDB4i2sXLueKVgTATXvxnsRkLUwKzn4e5SV6aya//yTonXlmSBZ2V9Gzjn33BTiKaKUk2l0tz7EpryehF0nJPSBOHfco01KKEl2fe51OsTeqWg8wjxj0mL9Kd9gXhN17w/K2bzVsv/08ifzb7SeiOhqe/OpX9S7nSlrRogr2bGjz6AasFvG0+0R5bJEWtl57N/S3V901rVlhv1/0dkjz0zN9KIqAudiYd5EPIPEC4Z+RDjyUtXrN8wezEvFvIF2x6yS/jko/z8fA6SWau+5+cYBrJcg1oFf6slpQFb9D2OBdeEkyO8YRBGfzm/ZHZwbtOr0zYJ+uO7AgkL+e4J1940XZtop09oX5Mnuf+4V+Tkm+SXYJJ/1FKWhGQB9pXUukG30AePDaZ26ylAgltQAq3oPBmExpJJR1v6yXpe/N8P2M7sqYHkh2S8R5PdvHs6dbLdps+rp+EQt9+4e/Nk9/7kf17ZMLzpn4ZLWBI2jo8XVcY9NCyfer50o3kd0yboJDuxPXqg7+X9nbaNMHcGG8tQ5I2yagObClX8E7bShozElQWJcyRDR5LeYZ/cd5UclU64WnuXIH4eMZ97xlpk0fSVLv91DwoHB3S+NaVMA72HcPKSLdLTj5vwRr3nGXxfc2ShUnaGe25YcWyIqvDxgwKDgwvHnZjFJJWBOSGeZiMiMEmc5s8PDTGALKoS1GCJjh7xq8NKE9I52aEZgmtyhCl7aJptsqfK1wjzTN/+Vs22TXguAc0EOnRyGwabKbd47/pd65t3+78pNMwvI2/kgpxTkbf3LIEBDAeHGupkVjSFXJEF6XFKItWcrWUe/zNfL8sxKd5hVSDJBPrSSGal5kq1fkIvfBHTI60cd3v6mf6Dh1Zar06br0MbyvN8Ak5p8PWT3HrLM3vaWUDejdGT8SQseO8zcQnPQlTJCMWKXqjEjxg1iRBWCZhwo9+bPpI6jM3y2mqa6G7Dg/203f+YrPYl+aL4dVJvuvSFEYTRTmiKO2aYMDEFmR0B6GZXTu2+vDFEVlVxMBLQiOV5S8YYyPQXU1ifyWRajk17HIHXnJIrov+YrLPDx833jZxaLld27fJQoa7U2pemunpH75jY3Fhhn9JrilYlhFD3DMvpyskLGd4VkmkoqwUSi5qvPaoJC0JyM3zsGm2jh05KEaxf7kEd8mtIFCs9Ub2eZpAV1iTg0VnSiJ4vjzcMCG0gWeNTXpKllggf/VB6Xrjhdmbv1NigEd9NizXzHolpU1AcIJo3gI43rU2btbShoK87eJ8ci6w4zMqSVsCAkB3yfm3Uwz7pXOLH5sirodHytIHrvCAughZ6IgPE2xHFpFxHySawDuGoDEBbpo8HlB7aY69mCImA39kqkfbsa4JpgKpg11hXWF+T/WAbzb80V08b/e6qZO6GRtZ1PA0ujrXS9iFa0LQ9AzqLY55YQ8ohX/SmoAA0nfIcLsKESNaiiM83C4S36LnwgOW45YvmGuHH5E9NEgAys2fPkXW7H3XZ4DTvDFKplHTFub9V1/2nY9BBfSCEGx2hXM3kgEUTVq0TCKgOyckTLMytAu7saQp5/C0c2tN9ml9WoAvPvlIBkKMCR3YS8/Mmy//2vYEuddP+AaMopK0dELcmyeWxmriJRE0EwvSuIKNNG/qJ7Lc12fmsPSFEuuiacejnS/dWHS7Bb0/7CjGC1bMrpTUS8KMs4/feNVqHuxNSMwfYxkZRrZ1vT9cw7XQr+yRn96OoHBNU9973fa+ENZxg9vBsu425yI/dlC+nDnV2p5oRwhJtyOmAjHVSa//MWkSFC+8u2hP8HxlsZ3WGpAbZohQnyHD7IiNoF2XCpB60uMw8sFHzR/+8ye+Iqz/S15ptEVVaZ4YQHpWluMK2pjeQX2F+PTO0LPRVkjtLRrI75CNONtEWRKL+qpfD2KfESfpqARzg4MqOKa9M+KnqfTK0NRBWE845yLJeLp22SL5rbppLtMuRz3yhPdzyk8wYh0VxhO6K8EzxAwSMtuQVTa5X2xRXp6wkTntxfEjmB6lpL0GBAyaK3pI6McsjqBl2nbqapufsOYMIqMF0X5h5LNdadJf2qv/wES34L0PPxGqHdB+2FIEqPljmdgw8jHKhD5iTxo3b2HzWnvb3ick5JowOVbLgFImkRdH0PjjJ7yQ1NxyPq7Hu18GWYSRD7zue/w7xamqVMtESkCIIf8niZctIOkHZwceZ5u81CNi7LlFU7kyePQ40QxjbRDZ3V/Ud64Fsox9/GmfAd9YPE0mzaOVvGa0qPN4v9Elh1ZhwCfLaHnC/qGyL2wcpFcG8uAeCGrersRnEEu2WYH9gacmWI2cKHiDLzgpmCyjZDBGWfbYpLqMSJtghoETR8Ob9AS7iBUnbySUGy7La+2XUAdDh4JC8xbUkAxH4iHTP/vexN/ZZN5hbz/n4gEyXGv0+Cet9gy+FPwOWZoKEWnSFktTSZNelDBWkAVjWI4rbL0P7unx538o9udUsUM/9TXHnLe6OARcB3M4gtMWcmVkTW7N2r7qIVPPvgPsusNcHwM4IHEqweFgyTKWdo3S83WvJ/Ic0TR/m9eutF1m5DhhoCkPngdcHMGGYQXxwv7eQnB5kO27dC/Se4R4e8Re2yrzjonbuQJRWNyFFyE4Esct536nWWONDobQu3YcZSAbWo9genGHudP/SlPOnJXLl1hx/ZrtT2byEMSiaWeCEX2/4EaQ/kaBZkwMsMLxcCfz491zXl7auIjnYRk5Ab2K9VMRAAG/0aSYKAIRI6AEjBhwrc6PgBLQj4duRYyAEjBiwLU6PwJKQD8euhUxAkrAiAHX6vwIKAH9eOhWxAgoASMGXKvzI6AE9OOhWxEjoASMGHCtzo+AEtCPh25FjIASMGLAtTo/AkpAPx66FTECSsCIAdfq/AgoAf146FbECCgBIwZcq/MjoAT046FbESOgBIwYcK3Oj4AS0I+HbkWMgBIwYsC1Oj8CSkA/HroVMQJKwIgB1+r8CCgB/XjoVsQIKAEjBlyr8yOgBPTjoVsRI6AEjBhwrc6PgBLQj4duRYyAEjBiwLU6PwJKQD8euhUxAkrAiAHX6vwIKAH9eOhWxAgoASMGXKvzI6AE9OOhWxEjoASMGHCtzo+AEtCPh25FjIASMGLAtTo/AkpAPx66FTECSsCIAdfq/AgoAf146FbECCgBIwZcq/MjoAT046FbESOgBIwYcK3Oj4AS0I+HbkWMgBIwYsC1Oj8CSkA/HroVMQJKwIgB1+r8CCgB/XjoVsQIKAEjBlyr8yPw//wEK431qUjUAAAAAElFTkSuQmCC"

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_mistral.b59f0fbe.png";

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseListing__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_benefits_css__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_benefits_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_benefits_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filter__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_brand_cards_benefits_img_ubook_png__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_brand_cards_benefits_img_ubook_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_brand_cards_benefits_img_ubook_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_brand_cards_benefits_img_drogaria_sp_png__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_brand_cards_benefits_img_drogaria_sp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_brand_cards_benefits_img_drogaria_sp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_brand_cards_benefits_img_drogaria_pacheco_png__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_brand_cards_benefits_img_drogaria_pacheco_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_images_brand_cards_benefits_img_drogaria_pacheco_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_brand_cards_benefits_img_dasa_png__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_brand_cards_benefits_img_dasa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_images_brand_cards_benefits_img_dasa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_brand_cards_benefits_img_farma_delivery_png__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_brand_cards_benefits_img_farma_delivery_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_images_brand_cards_benefits_img_farma_delivery_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_brand_cards_benefits_img_chinainbox_png__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_brand_cards_benefits_img_chinainbox_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__loyal_images_brand_cards_benefits_img_chinainbox_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_images_brand_cards_benefits_img_mistral_png__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_images_brand_cards_benefits_img_mistral_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__loyal_images_brand_cards_benefits_img_mistral_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyal_images_brand_cards_benefits_img_picme_png__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyal_images_brand_cards_benefits_img_picme_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__loyal_images_brand_cards_benefits_img_picme_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loyal_images_brand_cards_benefits_img_havanna_png__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loyal_images_brand_cards_benefits_img_havanna_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__loyal_images_brand_cards_benefits_img_havanna_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loyal_images_brand_cards_benefits_img_evino_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loyal_images_brand_cards_benefits_img_evino_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__loyal_images_brand_cards_benefits_img_evino_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loyal_images_brand_cards_benefits_img_centauro_png__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loyal_images_brand_cards_benefits_img_centauro_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__loyal_images_brand_cards_benefits_img_centauro_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loyal_images_brand_cards_benefits_img_netshoes_png__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loyal_images_brand_cards_benefits_img_netshoes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__loyal_images_brand_cards_benefits_img_netshoes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__loyal_images_brand_cards_benefits_img_marisa_png__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__loyal_images_brand_cards_benefits_img_marisa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__loyal_images_brand_cards_benefits_img_marisa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__loyal_images_brand_cards_benefits_img_renner_png__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__loyal_images_brand_cards_benefits_img_renner_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__loyal_images_brand_cards_benefits_img_renner_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__loyal_images_brand_cards_benefits_img_shoestock_png__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__loyal_images_brand_cards_benefits_img_shoestock_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__loyal_images_brand_cards_benefits_img_shoestock_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__loyal_images_brand_cards_benefits_img_studio_geek_png__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__loyal_images_brand_cards_benefits_img_studio_geek_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__loyal_images_brand_cards_benefits_img_studio_geek_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__loyal_images_brand_cards_benefits_img_zattini_png__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__loyal_images_brand_cards_benefits_img_zattini_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__loyal_images_brand_cards_benefits_img_zattini_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__loyal_images_brand_cards_benefits_img_pets_png__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__loyal_images_brand_cards_benefits_img_pets_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__loyal_images_brand_cards_benefits_img_pets_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__loyal_images_brand_cards_benefits_img_giuliana_flores_png__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__loyal_images_brand_cards_benefits_img_giuliana_flores_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__loyal_images_brand_cards_benefits_img_giuliana_flores_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__loyal_images_brand_cards_benefits_img_cestas_michelli_png__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__loyal_images_brand_cards_benefits_img_cestas_michelli_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__loyal_images_brand_cards_benefits_img_cestas_michelli_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__loyal_images_brand_cards_benefits_img_nova_flor_png__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__loyal_images_brand_cards_benefits_img_nova_flor_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__loyal_images_brand_cards_benefits_img_nova_flor_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__loyal_images_brand_cards_benefits_img_sony_png__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__loyal_images_brand_cards_benefits_img_sony_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__loyal_images_brand_cards_benefits_img_sony_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__loyal_images_brand_cards_benefits_img_nespresso_png__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__loyal_images_brand_cards_benefits_img_nespresso_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__loyal_images_brand_cards_benefits_img_nespresso_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__loyal_images_brand_cards_benefits_img_decolar_png__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__loyal_images_brand_cards_benefits_img_decolar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__loyal_images_brand_cards_benefits_img_decolar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__loyal_images_brand_cards_benefits_img_conectcar_png__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__loyal_images_brand_cards_benefits_img_conectcar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__loyal_images_brand_cards_benefits_img_conectcar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__loyal_images_brand_cards_benefits_img_hoteis_png__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__loyal_images_brand_cards_benefits_img_hoteis_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__loyal_images_brand_cards_benefits_img_hoteis_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__loyal_images_brand_cards_benefits_img_localiza_png__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__loyal_images_brand_cards_benefits_img_localiza_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__loyal_images_brand_cards_benefits_img_localiza_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__loyal_images_brand_cards_benefits_img_movida_png__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__loyal_images_brand_cards_benefits_img_movida_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__loyal_images_brand_cards_benefits_img_movida_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__loyal_images_brand_cards_benefits_img_natura_png__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__loyal_images_brand_cards_benefits_img_natura_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__loyal_images_brand_cards_benefits_img_natura_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__loyal_images_brand_cards_benefits_img_unidas_png__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__loyal_images_brand_cards_benefits_img_unidas_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__loyal_images_brand_cards_benefits_img_unidas_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__loyal_images_brand_cards_benefits_img_hertz_png__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__loyal_images_brand_cards_benefits_img_hertz_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__loyal_images_brand_cards_benefits_img_hertz_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__loyal_images_brand_cards_benefits_img_menu_personnalite_png__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__loyal_images_brand_cards_benefits_img_menu_personnalite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__loyal_images_brand_cards_benefits_img_menu_personnalite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__loyal_images_brand_cards_benefits_img_sociedade_mesa_png__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__loyal_images_brand_cards_benefits_img_sociedade_mesa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__loyal_images_brand_cards_benefits_img_sociedade_mesa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__loyal_images_brand_cards_benefits_img_cafeorfeu_png__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__loyal_images_brand_cards_benefits_img_cafeorfeu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__loyal_images_brand_cards_benefits_img_cafeorfeu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__loyal_images_brand_cards_benefits_img_wine_png__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__loyal_images_brand_cards_benefits_img_wine_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__loyal_images_brand_cards_benefits_img_wine_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__loyal_images_brand_cards_benefits_img_amaro_png__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__loyal_images_brand_cards_benefits_img_amaro_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__loyal_images_brand_cards_benefits_img_amaro_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__loyal_images_brand_cards_benefits_img_lounge_personnalite_png__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__loyal_images_brand_cards_benefits_img_lounge_personnalite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__loyal_images_brand_cards_benefits_img_lounge_personnalite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__loyal_images_brand_cards_benefits_img_livup_png__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__loyal_images_brand_cards_benefits_img_livup_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__loyal_images_brand_cards_benefits_img_livup_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__loyal_images_brand_cards_benefits_img_emporio_nestle_png__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__loyal_images_brand_cards_benefits_img_emporio_nestle_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__loyal_images_brand_cards_benefits_img_emporio_nestle_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__loyal_images_brand_cards_benefits_img_aramis_png__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__loyal_images_brand_cards_benefits_img_aramis_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__loyal_images_brand_cards_benefits_img_aramis_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__loyal_images_brand_cards_benefits_img_extra_png__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__loyal_images_brand_cards_benefits_img_extra_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__loyal_images_brand_cards_benefits_img_extra_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__loyal_images_brand_cards_benefits_img_pontofrio_png__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__loyal_images_brand_cards_benefits_img_pontofrio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__loyal_images_brand_cards_benefits_img_pontofrio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__loyal_images_brand_cards_benefits_img_casasbahia_png__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__loyal_images_brand_cards_benefits_img_casasbahia_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__loyal_images_brand_cards_benefits_img_casasbahia_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__loyal_images_brand_cards_benefits_img_shopclub_png__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__loyal_images_brand_cards_benefits_img_shopclub_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__loyal_images_brand_cards_benefits_img_shopclub_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__loyal_images_brand_cards_benefits_img_loccitane_png__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__loyal_images_brand_cards_benefits_img_loccitane_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__loyal_images_brand_cards_benefits_img_loccitane_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__loyal_images_brand_cards_benefits_img_magalu_png__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__loyal_images_brand_cards_benefits_img_magalu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__loyal_images_brand_cards_benefits_img_magalu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__loyal_images_brand_cards_benefits_img_reserva_png__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__loyal_images_brand_cards_benefits_img_reserva_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__loyal_images_brand_cards_benefits_img_reserva_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__loyal_images_brand_cards_benefits_cards_new_cobasi_jpg__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__loyal_images_brand_cards_benefits_cards_new_cobasi_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__loyal_images_brand_cards_benefits_cards_new_cobasi_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__loyal_images_brand_cards_benefits_cards_new_5asesc_png__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__loyal_images_brand_cards_benefits_cards_new_5asesc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__loyal_images_brand_cards_benefits_cards_new_5asesc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__loyal_images_brand_cards_benefits_cards_new_fast_shop_png__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__loyal_images_brand_cards_benefits_cards_new_fast_shop_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__loyal_images_brand_cards_benefits_cards_new_fast_shop_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__loyal_images_brand_cards_benefits_cards_new_lepostiche_png__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__loyal_images_brand_cards_benefits_cards_new_lepostiche_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__loyal_images_brand_cards_benefits_cards_new_lepostiche_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__loyal_images_brand_cards_benefits_cards_new_logo_original_experience_png__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__loyal_images_brand_cards_benefits_cards_new_logo_original_experience_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__loyal_images_brand_cards_benefits_cards_new_logo_original_experience_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__loyal_images_brand_cards_benefits_cards_new_looccitane_png__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__loyal_images_brand_cards_benefits_cards_new_looccitane_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__loyal_images_brand_cards_benefits_cards_new_looccitane_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__loyal_images_brand_cards_benefits_cards_new_oldflix_png__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__loyal_images_brand_cards_benefits_cards_new_oldflix_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__loyal_images_brand_cards_benefits_cards_new_oldflix_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__loyal_images_brand_cards_benefits_cards_new_sephora_png__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__loyal_images_brand_cards_benefits_cards_new_sephora_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__loyal_images_brand_cards_benefits_cards_new_sephora_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__loyal_images_brand_cards_benefits_cards_new_tokbeauty_png__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__loyal_images_brand_cards_benefits_cards_new_tokbeauty_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__loyal_images_brand_cards_benefits_cards_new_tokbeauty_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__loyal_images_brand_cards_benefits_cards_new_funstock_jpg__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__loyal_images_brand_cards_benefits_cards_new_funstock_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__loyal_images_brand_cards_benefits_cards_new_funstock_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__loyal_images_brand_cards_benefits_cards_new_comschool_png__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__loyal_images_brand_cards_benefits_cards_new_comschool_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__loyal_images_brand_cards_benefits_cards_new_comschool_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__loyal_images_brand_cards_benefits_cards_new_under_jpg__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__loyal_images_brand_cards_benefits_cards_new_under_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__loyal_images_brand_cards_benefits_cards_new_under_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__loyal_images_brand_cards_benefits_cards_new_camicado_png__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__loyal_images_brand_cards_benefits_cards_new_camicado_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__loyal_images_brand_cards_benefits_cards_new_camicado_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__loyal_images_brand_cards_benefits_cards_new_vinu_png__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__loyal_images_brand_cards_benefits_cards_new_vinu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__loyal_images_brand_cards_benefits_cards_new_vinu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__loyal_images_brand_cards_benefits_cards_new_olympikus_png__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__loyal_images_brand_cards_benefits_cards_new_olympikus_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__loyal_images_brand_cards_benefits_cards_new_olympikus_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__loyal_images_brand_cards_benefits_cards_new_atlantica_png__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__loyal_images_brand_cards_benefits_cards_new_atlantica_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__loyal_images_brand_cards_benefits_cards_new_atlantica_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__loyal_images_brand_cards_benefits_cards_new_berenice_png__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__loyal_images_brand_cards_benefits_cards_new_berenice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__loyal_images_brand_cards_benefits_cards_new_berenice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__loyal_images_brand_cards_benefits_cards_new_espaco_laser_png__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__loyal_images_brand_cards_benefits_cards_new_espaco_laser_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__loyal_images_brand_cards_benefits_cards_new_espaco_laser_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__loyal_images_brand_cards_benefits_cards_new_eudora_png__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__loyal_images_brand_cards_benefits_cards_new_eudora_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__loyal_images_brand_cards_benefits_cards_new_eudora_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__loyal_images_brand_cards_benefits_cards_new_hertz_internacional_png__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__loyal_images_brand_cards_benefits_cards_new_hertz_internacional_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__loyal_images_brand_cards_benefits_cards_new_hertz_internacional_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__loyal_images_brand_cards_benefits_cards_new_invisalign_png__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__loyal_images_brand_cards_benefits_cards_new_invisalign_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__loyal_images_brand_cards_benefits_cards_new_invisalign_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__loyal_images_brand_cards_benefits_cards_new_azaleia_png__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__loyal_images_brand_cards_benefits_cards_new_azaleia_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__loyal_images_brand_cards_benefits_cards_new_azaleia_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__loyal_images_brand_cards_benefits_cards_new_mobly_jpg__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__loyal_images_brand_cards_benefits_cards_new_mobly_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__loyal_images_brand_cards_benefits_cards_new_mobly_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__loyal_images_brand_cards_benefits_cards_new_prontolight_png__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__loyal_images_brand_cards_benefits_cards_new_prontolight_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__loyal_images_brand_cards_benefits_cards_new_prontolight_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__loyal_images_brand_cards_benefits_cards_new_protec_bag_png__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__loyal_images_brand_cards_benefits_cards_new_protec_bag_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__loyal_images_brand_cards_benefits_cards_new_protec_bag_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__loyal_images_brand_cards_benefits_cards_new_reserva_new_png__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__loyal_images_brand_cards_benefits_cards_new_reserva_new_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__loyal_images_brand_cards_benefits_cards_new_reserva_new_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__loyal_images_brand_cards_benefits_cards_new_turbi_png__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__loyal_images_brand_cards_benefits_cards_new_turbi_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__loyal_images_brand_cards_benefits_cards_new_turbi_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__loyal_images_brand_cards_benefits_cards_new_adcos_png__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__loyal_images_brand_cards_benefits_cards_new_adcos_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__loyal_images_brand_cards_benefits_cards_new_adcos_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__loyal_images_brand_cards_benefits_cards_new_digital_house_png__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__loyal_images_brand_cards_benefits_cards_new_digital_house_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__loyal_images_brand_cards_benefits_cards_new_digital_house_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__loyal_images_brand_cards_benefits_cards_new_visa_png__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__loyal_images_brand_cards_benefits_cards_new_visa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__loyal_images_brand_cards_benefits_cards_new_visa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__loyal_images_brand_cards_benefits_cards_new_master_card_png__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__loyal_images_brand_cards_benefits_cards_new_master_card_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__loyal_images_brand_cards_benefits_cards_new_master_card_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__loyal_images_brand_cards_benefits_cards_new_zenklub_png__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__loyal_images_brand_cards_benefits_cards_new_zenklub_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__loyal_images_brand_cards_benefits_cards_new_zenklub_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__loyal_images_brand_cards_benefits_cards_new_studio_png__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__loyal_images_brand_cards_benefits_cards_new_studio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__loyal_images_brand_cards_benefits_cards_new_studio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__loyal_images_brand_cards_benefits_cards_new_vivara_png__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__loyal_images_brand_cards_benefits_cards_new_vivara_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__loyal_images_brand_cards_benefits_cards_new_vivara_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__loyal_images_brand_cards_benefits_cards_new_microsoft_png__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__loyal_images_brand_cards_benefits_cards_new_microsoft_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__loyal_images_brand_cards_benefits_cards_new_microsoft_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__loyal_images_brand_cards_benefits_cards_new_carnegie_png__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__loyal_images_brand_cards_benefits_cards_new_carnegie_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__loyal_images_brand_cards_benefits_cards_new_carnegie_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// #region IMPORT IMG
// #endregion
var ItauCardListing=function(_BaseListing){_inherits(ItauCardListing,_BaseListing);function ItauCardListing(){_classCallCheck(this,ItauCardListing);return _possibleConstructorReturn(this,(ItauCardListing.__proto__||Object.getPrototypeOf(ItauCardListing)).apply(this,arguments));}_createClass(ItauCardListing,[{key:'componentDidMount',value:function componentDidMount(){this.benefits=[// #region ITAUCARD
{link:'https://www.giulianaflores.com.br/?partner=top_itaucard15perene&utm_source=itau&utm_medium=parcerias&utm_campaign=perene',name:'Giuliana Flores',discount:15,image:__WEBPACK_IMPORTED_MODULE_24__loyal_images_brand_cards_benefits_img_giuliana_flores_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off'),profile:'quem tem Itaucard',category:'Para você',partner:'Giuliana Flores',alt:'Logo Giuliana Flores'},{link:'https://www.novaflor.com.br/?partner=top_iupp25lancamento&utm_source=iupp&utm_medium=parcerias&utm_campaign=lancamento-iupp',name:'Nova Flor',discount:15,image:__WEBPACK_IMPORTED_MODULE_26__loyal_images_brand_cards_benefits_img_nova_flor_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'25% off'),profile:'pra todo mundo',category:'Para você',partner:'Nova Flor',alt:'Logo Nova Flor'},{link:'http://try.ubook.com/itaucard',name:'Ubook',discount:0,image:__WEBPACK_IMPORTED_MODULE_6__loyal_images_brand_cards_benefits_img_ubook_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3 meses por R$14,90'),profile:'quem tem Itaucard',category:'Entretenimento',partner:'Ubook',alt:'Logo Ubook'},{link:'https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf',name:'Drogaria São Paulo',discount:35,image:__WEBPACK_IMPORTED_MODULE_7__loyal_images_brand_cards_benefits_img_drogaria_sp_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 35% off'),profile:'quem tem Itaucard',category:'Bem estar e saúde',partner:'Drogaria São Paulo',alt:'Logo Drogaria São Paulo'},{link:'https://www.itau.com.br/content/dam/itau/cartoes/beneficios/PDF_Beneficio_Farmacia.pdf',name:'Drogaria Pacheco',discount:35,image:__WEBPACK_IMPORTED_MODULE_8__loyal_images_brand_cards_benefits_img_drogaria_pacheco_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 35% off'),profile:'quem tem Itaucard',category:'Bem estar e saúde',partner:'Drogaria Pacheco',title:'Vai para Drogaria Pacheco',alt:'Logo Drogaria Pacheco'},{link:'https://dasa.com.br/parcerias/itau',name:'Dasa',discount:25,image:__WEBPACK_IMPORTED_MODULE_9__loyal_images_brand_cards_benefits_img_dasa_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 25% de descontos em exames'),profile:'quem tem Itaucard',category:'Bem estar e saúde',partner:'Dasa',alt:'Logo Dasa'},{link:'https://itaucard.farmadelivery.com.br',name:'Farmadelivery',discount:12,image:__WEBPACK_IMPORTED_MODULE_10__loyal_images_brand_cards_benefits_img_farma_delivery_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 12% de desconto'),profile:'quem tem Itaucard',category:'Bem estar e saúde',partner:'Farmadelivery',alt:'Logo Farmadelivery'},{link:'https://www.chinainbox.com.br',name:'China In Box',discount:15,image:__WEBPACK_IMPORTED_MODULE_11__loyal_images_brand_cards_benefits_img_chinainbox_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com cupom 15ITAUCHINA. Min R$30'),profile:'quem tem Itaucard',category:'Alimentos',partner:'China In Box',alt:'Logo China In Box'},{link:'https://www.clubepicme.com.br/itaucard',name:'Pic-Me',discount:20,image:__WEBPACK_IMPORTED_MODULE_13__loyal_images_brand_cards_benefits_img_picme_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% de desconto nas assinaturas'),profile:'quem tem Itaucard',category:'Alimentos',partner:'Pic-Me',title:'Vai para Pic-Me',alt:'Logo Pic-Me'},{link:'http://www.havanna.com.br',name:'Havanna',discount:20,image:__WEBPACK_IMPORTED_MODULE_14__loyal_images_brand_cards_benefits_img_havanna_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com o cupom ITAUCARD2020'),profile:'quem tem Itaucard',category:'Alimentos',partner:'Havanna',alt:'Logo Havanna'},{link:'http://www.mistral.com.br/itaucard',name:'Mistral',discount:20,image:__WEBPACK_IMPORTED_MODULE_12__loyal_images_brand_cards_benefits_img_mistral_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 20% de desconto em at\xE9 7x sem juros'),profile:'quem tem Itaucard',category:'Bebidas',partner:'Mistral',alt:'Logo Mistral'},{link:'https://www.evino.com.br/',name:'Evino',discount:25,image:__WEBPACK_IMPORTED_MODULE_15__loyal_images_brand_cards_benefits_img_evino_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1\xAA compra: 10% off + frete com cupom IUPP10'),profile:'pra todo mundo',category:'Bebidas',partner:'Evino',alt:'Logo Evino'},{link:'https://www.nespressobenefits.com.br/',name:'Nespresso',discount:20,image:__WEBPACK_IMPORTED_MODULE_28__loyal_images_brand_cards_benefits_img_nespresso_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com o cupom it0615'),profile:'quem tem Itaucard',category:'Bebidas',partner:'Nespresso',alt:'Logo Nespresso'},{link:'https://itau.centauro.com.br/',name:'Centauro',discount:15,image:__WEBPACK_IMPORTED_MODULE_16__loyal_images_brand_cards_benefits_img_centauro_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom iupp15'),profile:'pra todo mundo',category:'Esporte',partner:'Centauro',alt:'Logo Centauro'},{link:'https://clube.netshoes.com.br/iupp',name:'Netshoes',discount:15,image:__WEBPACK_IMPORTED_MODULE_17__loyal_images_brand_cards_benefits_img_netshoes_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off pelo hotsite com o cupom iupp'),profile:'pra todo mundo',category:'Esporte',partner:'Netshoes',alt:'Logo Netshoes'},{link:'https://www.marisa.com.br/parcerias/c/itaucard',name:'Marisa',discount:15,image:__WEBPACK_IMPORTED_MODULE_18__loyal_images_brand_cards_benefits_img_marisa_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com o cupom ITAUMARISA20'),profile:'quem tem Itaucard',category:'Moda',partner:'Marisa',alt:'Logo Marisa'},{link:'https://www.lojasrenner.com.br/b2b/itaucard',name:'Renner',discount:15,image:__WEBPACK_IMPORTED_MODULE_19__loyal_images_brand_cards_benefits_img_renner_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off pelo hotsite'),profile:'quem tem Itaucard',category:'Moda',partner:'Renner',alt:'Logo Renner'},{link:'https://www.shoestock.com.br/especial/itaucard?campaign=netpro_itaucard&utm_source=b2b_itaucard&utm_medium=redirect-itaucard&utm_campaign=b2b_itaucard',name:'Shoestock',discount:15,image:__WEBPACK_IMPORTED_MODULE_20__loyal_images_brand_cards_benefits_img_shoestock_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% de desconto'),profile:'quem tem Itaucard',category:'Moda',partner:'Shoestock',alt:'Logo Shoestock'},{link:'https://www.studiogeek.com.br/',name:'Studio Geek',discount:20,image:__WEBPACK_IMPORTED_MODULE_21__loyal_images_brand_cards_benefits_img_studio_geek_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'25% off com o cupom STUDIO25'),profile:'quem tem Itaucard',category:'Moda',partner:'Studio Geek',alt:'Logo Studio Geek'},{link:'https://www.zattini.com.br/iupp',name:'Zattini',discount:15,image:__WEBPACK_IMPORTED_MODULE_22__loyal_images_brand_cards_benefits_img_zattini_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off pelo hotsite com o cupom iupp'),profile:'pra todo mundo',category:'Moda',partner:'Zattini',alt:'Logo Zattini'},{link:'https://oldflix.parceriasonline.com.br/itaucard',name:'Oldflix',discount:15,image:__WEBPACK_IMPORTED_MODULE_59__loyal_images_brand_cards_benefits_cards_new_oldflix_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% de desconto na assinatura'),profile:'quem tem Itaucard',category:'Entretenimento',partner:'Oldflix',alt:'Logo Oldflix'},{link:'https://sephora.parceriasonline.com.br/itaucard',name:'Sephora',discount:5,image:__WEBPACK_IMPORTED_MODULE_60__loyal_images_brand_cards_benefits_cards_new_sephora_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5% off em compras acima de R$ 299'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'Sephora',alt:'Logo Sephora'},{link:'http://onelink.to/tokbeauty',name:'TokBeauty',discount:40,image:__WEBPACK_IMPORTED_MODULE_61__loyal_images_brand_cards_benefits_cards_new_tokbeauty_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'40% off na 1\xAA compra com o cupom ITAUCARD40'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'TokBeauty',alt:'Logo TokBeauty'},{link:'https://loja.5asec.com.br/home',name:'5àSec Lavanderia',discount:10,image:__WEBPACK_IMPORTED_MODULE_54__loyal_images_brand_cards_benefits_cards_new_5asesc_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% de desconto com o cupom ITAUCARD10 '),profile:'quem tem Itaucard',category:'Para você',partner:'5àSec Lavanderia',alt:'Logo 5àSec Lavanderia'},{link:'https://www.lepostiche.com.br/?utm_source=itaucard&utm_medium=parceria&utm_campaign=lepostiche&utm_content=cupom',name:'Le Postiche',discount:10,image:__WEBPACK_IMPORTED_MODULE_56__loyal_images_brand_cards_benefits_cards_new_lepostiche_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 10% de desconto com o cupom ITAUCARD10 '),profile:'quem tem Itaucard',category:'Moda',partner:'Le Postiche',alt:'Logo Le Postiche'},{link:'https://loccitaneenprovence.parceriasonline.com.br/itaucard',name:'L\'Occitane en Provence',discount:10,image:__WEBPACK_IMPORTED_MODULE_58__loyal_images_brand_cards_benefits_cards_new_looccitane_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off com o cupom ITAUCARD'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'L\'Occitane en Provence',alt:'Logo L\'Occitane en Provence'},{link:'https://vinu.club/',name:'VINU',discount:20,image:__WEBPACK_IMPORTED_MODULE_66__loyal_images_brand_cards_benefits_cards_new_vinu_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% de desconto com o cupom VINUITAU '),profile:'quem tem Itaucard',category:'Bebidas',partner:'VINU',alt:'Logo VINU'},{link:'https://www.fastshop.com.br/itaucard/',name:'Fast',discount:30,image:__WEBPACK_IMPORTED_MODULE_55__loyal_images_brand_cards_benefits_cards_new_fast_shop_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 30% de desconto '),profile:'quem tem Itaucard',category:'Eletroeletrônicos',partner:'Fast',alt:'Logo Fast'},{link:'https://clube.camicado.com.br/b2b/itaucard',name:'Camicado',discount:11,image:__WEBPACK_IMPORTED_MODULE_65__loyal_images_brand_cards_benefits_cards_new_camicado_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11% de desconto + frete gr\xE1tis '),profile:'quem tem Itaucard',category:'Casa e Decoração',partner:'Camicado',alt:'Logo Camicado'},{link:'https://comschool.co/itaucard',name:'ComSchool',discount:30,image:__WEBPACK_IMPORTED_MODULE_63__loyal_images_brand_cards_benefits_cards_new_comschool_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'30% off com o cupom ITAUCARD-30'),profile:'quem tem Itaucard',category:'Educação',partner:'ComSchool',alt:'Logo ComSchool'},{link:'https://blog.funstock.com.br/itaucard-e-funstock/',name:'Funstock',discount:15,image:__WEBPACK_IMPORTED_MODULE_62__loyal_images_brand_cards_benefits_cards_new_funstock_jpg___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off '),profile:'quem tem Itaucard',category:'Para você',partner:'Funstock',alt:'Logo Funstock'},{link:'https://www.originalexperience.com.br/',name:'Original Experience',discount:10,image:__WEBPACK_IMPORTED_MODULE_57__loyal_images_brand_cards_benefits_cards_new_logo_original_experience_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% de desconto com o cupom iupp15'),profile:'pra todo mundo',category:'Entretenimento',partner:'Original Experience',alt:'Logo Original Experience'},{link:'https://petz.parceriasonline.com.br/iupp',name:'Petz',discount:10,image:__WEBPACK_IMPORTED_MODULE_23__loyal_images_brand_cards_benefits_img_pets_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off acima R$120 com cupom PARCEIROS10PETZ'),profile:'pra todo mundo',category:'Pets',partner:'Petz',alt:'Logo Petz'},{link:'https://corporativostore.sony.com.br/itau',name:'Sony',discount:15,image:__WEBPACK_IMPORTED_MODULE_27__loyal_images_brand_cards_benefits_img_sony_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 15% de desconto'),profile:'quem tem Itaucard',category:'Eletroeletrônicos',partner:'Sony',alt:'Logo Sony'},{link:'https://clube2.magazineluiza.com.br/itau',name:'Magalu',discount:10,image:__WEBPACK_IMPORTED_MODULE_51__loyal_images_brand_cards_benefits_img_magalu_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 10% de desconto'),profile:'quem tem Itaucard',category:'Eletroeletrônicos',partner:'Magalu',alt:'Logo Magalu'},{link:'https://itaucard.decolar.com/login?redirect_to=%2Fwhitelabel%2Fsocial%2Flogin%3Fredirect_to%3Dhttps%253A%252F%252Fitaucard.decolar.com%252Fhome',name:'Decolar',discount:10,image:__WEBPACK_IMPORTED_MODULE_29__loyal_images_brand_cards_benefits_img_decolar_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 10% de desconto'),profile:'quem tem Itaucard',category:'Hotelaria',partner:'Decolar',alt:'Decolar'},{link:'https://parceiros.conectcar.com/ofertas-itaucard/',name:'Conectcar',image:__WEBPACK_IMPORTED_MODULE_30__loyal_images_brand_cards_benefits_img_conectcar_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'12 meses gr\xE1tis no Plano Completo'),profile:'quem tem Itaucard',category:'Hotelaria',partner:'Conectcar',alt:'Logo Conectcar'},{link:'https://www.hoteis.com/ofertas-de-hoteis/descontos-itaucard?locale=pt_BR&pos=HCOM_BR&rffrid=mdp.hcom.br.404.000.00.00',name:'Hoteis.com',discount:10,image:__WEBPACK_IMPORTED_MODULE_31__loyal_images_brand_cards_benefits_img_hoteis_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% de desconto.'),profile:'quem tem Itaucard',category:'Hotelaria',partner:'Hoteis.com',alt:'Logo Hoteis.com'},{link:'https://www.localizahertz.com/brasil/pt-br/ofertas/itaucard',name:'Localiza',discount:15,image:__WEBPACK_IMPORTED_MODULE_32__loyal_images_brand_cards_benefits_img_localiza_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off + parcelamento em 10x s/ juros'),profile:'quem tem Itaucard',category:'Transporte',partner:'Localiza',alt:'Logo Localiza'},{link:'https://parcerias.movida.com.br/itaucard',name:'Movida',discount:10,image:__WEBPACK_IMPORTED_MODULE_33__loyal_images_brand_cards_benefits_img_movida_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off'),profile:'quem tem Itaucard',category:'Transporte',partner:'Movida',alt:'Logo Movida'},{link:'https://www.natura.com.br/parceiros/itaucard?utm_source=itaucard&utm_medium=permuta&utm_campaign=emailmkt&utm_term=020920_051020_itau9&utm_content=geral',name:'Natura',discount:15,image:__WEBPACK_IMPORTED_MODULE_34__loyal_images_brand_cards_benefits_img_natura_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off em produtos selecionados'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'Natura',alt:'Logo Natura'},// #endregion
// #region PERSONNALITE
{link:'https://www.itau.com.br/personnalite/experiencia/viagem/movida/',name:'Movida',discount:15,image:__WEBPACK_IMPORTED_MODULE_33__loyal_images_brand_cards_benefits_img_movida_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 15% off sobre a di\xE1ria dos carros'),profile:'pra quem é Personnalité',category:'Viagem',partner:'Movida',alt:'Logo Movida'},{link:'https://www.itau.com.br/personnalite/experiencia/viagem/decolar/',name:'Decolar',discount:12,image:__WEBPACK_IMPORTED_MODULE_29__loyal_images_brand_cards_benefits_img_decolar_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 12% de desconto'),profile:'pra quem é Personnalité',category:'Viagem',partner:'Decolar',alt:'Logo Decolar'},{link:'https://www.itau.com.br/personnalite/experiencia/viagem/unidas/',name:'Unidas',discount:25,image:__WEBPACK_IMPORTED_MODULE_35__loyal_images_brand_cards_benefits_img_unidas_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Descontos de At\xE9 25%'),profile:'pra quem é Personnalité',category:'Viagem',partner:'Unidas',alt:'Logo Unidas'},{link:'https://www.itau.com.br/personnalite/experiencia/viagem/hertz/',name:'Hertz',discount:20,image:__WEBPACK_IMPORTED_MODULE_36__loyal_images_brand_cards_benefits_img_hertz_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% de desconto na loca\xE7\xE3o de ve\xEDculos'),profile:'pra quem é Personnalité',category:'Viagem',partner:'Hertz',alt:'Logo Hertz'},{link:'https://www.itau.com.br/personnalite/experiencia/viagem/localiza/',name:'Localiza Hertz',discount:22,image:__WEBPACK_IMPORTED_MODULE_32__loyal_images_brand_cards_benefits_img_localiza_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 22% off (sobre o valor das di\xE1rias)'),profile:'pra quem é Personnalité',category:'Viagem',partner:'Localiza Hertz',alt:'Logo Localiza Hertz'},{link:'https://www.ibeneficios.com.br/menupersonnalite',name:'Menu Personnalité',discount:0,image:__WEBPACK_IMPORTED_MODULE_37__loyal_images_brand_cards_benefits_img_menu_personnalite_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Um menu desgusta\xE7\xE3o exclusivo'),profile:'pra quem é Personnalité',category:'Gastronomia',partner:'Menu Personnalité',alt:'Logo Menu Personnalité'},{link:'https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/',name:'Sociedade da mesa',discount:0,image:__WEBPACK_IMPORTED_MODULE_38__loyal_images_brand_cards_benefits_img_sociedade_mesa_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fa\xE7a parte do Clube de vinhos'),profile:'pra quem é Personnalité',category:'Gastronomia',partner:'Sociedade da mesa',alt:'Logo Sociedade da mesa'},{link:'https://www.itau.com.br/personnalite/experiencia/gastronomia/nespresso',name:'Nespresso',discount:25,image:__WEBPACK_IMPORTED_MODULE_28__loyal_images_brand_cards_benefits_img_nespresso_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 25% off em m\xE1quinas selecionadas'),profile:'pra quem é Personnalité',category:'Gastronomia',partner:'Nespresso',alt:'Logo Nespresso'},{link:'https://www.mistral.com.br/parceria/personnalite',name:'Mistral',discount:25,image:__WEBPACK_IMPORTED_MODULE_12__loyal_images_brand_cards_benefits_img_mistral_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 25% de desconto em at\xE9 7x sem juros '),profile:'pra quem é Personnalité',category:'Gastronomia',partner:'Mistral',alt:'Logo Mistral'},{link:'https://www.itau.com.br/personnalite/experiencia/gastronomia/cafe-orfeu/',name:'Orfeu',discount:20,image:__WEBPACK_IMPORTED_MODULE_39__loyal_images_brand_cards_benefits_img_cafeorfeu_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% de desconto em todos os caf\xE9s do site'),profile:'pra quem é Personnalité',category:'Gastronomia',partner:'Orfeu',alt:'Logo Orfeu'},{link:'https://www.itau.com.br/personnalite/experiencia/gastronomia/wine/',name:'Wine',discount:15,image:__WEBPACK_IMPORTED_MODULE_40__loyal_images_brand_cards_benefits_img_wine_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% de desconto em todas as mensalidades'),profile:'pra quem é Personnalité',category:'Gastronomia',partner:'Wine',alt:'Logo Wine'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/amaro/',name:'AMARO',discount:15,image:__WEBPACK_IMPORTED_MODULE_41__loyal_images_brand_cards_benefits_img_amaro_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% + frete gr\xE1tis compras maior de R$199,00'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'AMARO',alt:'Logo AMARO'},{link:'https://www.itau.com.br/personnalite/experiencia/cultura/lounge',name:'Lounge Personnalité',discount:0,image:__WEBPACK_IMPORTED_MODULE_42__loyal_images_brand_cards_benefits_img_lounge_personnalite_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Louge Personnalit\xE9: Programa\xE7\xE3o Especial'),profile:'pra quem é Personnalité',category:'Cultura',partner:'Lounge Personnalité',alt:'Logo Lounge Personnalité'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/under-armour/',name:'Under Armour',discount:15,image:__WEBPACK_IMPORTED_MODULE_64__loyal_images_brand_cards_benefits_cards_new_under_jpg___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 15% off  em produtos selecionados'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Under Armour',alt:'Logo Under Armour'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/sephora/',name:'Sephora',discount:10,image:__WEBPACK_IMPORTED_MODULE_60__loyal_images_brand_cards_benefits_cards_new_sephora_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'at\xE9 50% off em produtos selecionados'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Sephora',alt:'Logo Sephora'},{link:'https://www.itau.com.br/personnalite/experiencia/viagem/conectcar/',name:'Conectcar',discount:30,image:__WEBPACK_IMPORTED_MODULE_30__loyal_images_brand_cards_benefits_img_conectcar_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Confira as condi\xE7\xF5es exclusivas'),profile:'pra quem é Personnalité',category:'Viagem',partner:'Conectcar',alt:'Logo ConectCar'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/5-a-sec/',name:'5àSec Lavanderia',discount:20,image:__WEBPACK_IMPORTED_MODULE_54__loyal_images_brand_cards_benefits_cards_new_5asesc_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com o cupom PERSONNALITE20'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'5àSec Lavanderia',alt:'Logo 5àSec Lavanderia'},// #endregion
// #region IUPP
{link:'http://www.livup.com.br/',name:'Liv up',discount:10,image:__WEBPACK_IMPORTED_MODULE_43__loyal_images_brand_cards_benefits_img_livup_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off com o cupom iupp10'),profile:'pra todo mundo',category:'Alimentos',partner:'Liv up',alt:'Logo Liv up'},{link:'http://emporionestle.parceriasonline.com.br/iupp',name:'Empório Nestlé',discount:10,image:__WEBPACK_IMPORTED_MODULE_44__loyal_images_brand_cards_benefits_img_emporio_nestle_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% em todos os produtos da loja'),profile:'pra todo mundo',category:'Alimentos',partner:'Empório Nestlé',alt:'Logo Empório Nestlé'},{link:'https://www.aramis.com.br/',name:'Aramis',discount:15,image:__WEBPACK_IMPORTED_MODULE_45__loyal_images_brand_cards_benefits_img_aramis_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom iupp15'),profile:'pra todo mundo',category:'Moda',partner:'Aramis',alt:'Logo Aramis'},{link:'https://www.extra.com.br/loja/Itaucard.aspx?utm_source=b2b_itaucard&utm_medium=itaucard&utm_campaign=itaucard_parceiro',name:'Extra',discount:25,image:__WEBPACK_IMPORTED_MODULE_46__loyal_images_brand_cards_benefits_img_extra_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 25% em produtos selecionados'),profile:'quem tem Itaucard',category:'Eletroeletrônicos',partner:'Extra',alt:'Logo Extra'},{link:'https://www.pontofrio.com.br/b2b/Itaucard.aspx?utm_source=b2b_itaucard&utm_medium=itaucard&utm_campaign=itaucard_parceiro',name:'Ponto Frio',discount:25,image:__WEBPACK_IMPORTED_MODULE_47__loyal_images_brand_cards_benefits_img_pontofrio_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 25% em produtos selecionados'),profile:'quem tem Itaucard',category:'Eletroeletrônicos',partner:'Ponto Frio',alt:'Logo Ponto Frio'},{link:'https://www.casasbahia.com.br/loja/Itaucard.aspx?utm_source=b2b_itaucard&utm_medium=itaucard&utm_campaign=itaucard_parceiro',name:'Casas Bahia',discount:25,image:__WEBPACK_IMPORTED_MODULE_48__loyal_images_brand_cards_benefits_img_casasbahia_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 25% em produtos selecionados'),profile:'quem tem Itaucard',category:'Eletroeletrônicos',partner:'Casas Bahia',alt:'Logo Casas Bahia'},{link:'https://www.shopclub.com.br/iupp',name:'ShopClub',discount:45,image:__WEBPACK_IMPORTED_MODULE_49__loyal_images_brand_cards_benefits_img_shopclub_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 40% off com o cupom iupp'),profile:'pra todo mundo',category:'Eletroeletrônicos',partner:'ShopClub',alt:'Logo ShopClub'},{link:'https://loccitane.parceriasonline.com.br/iupp',name:'L\'occitane',discount:15,image:__WEBPACK_IMPORTED_MODULE_50__loyal_images_brand_cards_benefits_img_loccitane_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom IUPP2020'),profile:'pra todo mundo',category:'Perfumaria',partner:'L\'occitane',alt:'Logo loccitane'},{link:'https://www.reserva.ink/iupp',name:'Reserva',discount:0,image:__WEBPACK_IMPORTED_MODULE_52__loyal_images_brand_cards_benefits_img_reserva_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Camisetas personalizadas iupp por R$59,00'),profile:'pra todo mundo',category:'Moda',partner:'Reserva',alt:'Logo reserva'},{link:'https://www.cestasmichelli.com.br/?partner=top_iupp25lancamento&utm_source=iupp&utm_medium=parcerias&utm_campaign=lancamento-iupp',name:'Cestas Michelli',discount:25,image:__WEBPACK_IMPORTED_MODULE_25__loyal_images_brand_cards_benefits_img_cestas_michelli_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'25% de desconto em todo o site'),profile:'pra todo mundo',category:'Para você',partner:'Cestas Michelli',alt:'Logo Cestas Michelli'},{link:'https://www.cobasi.com.br',name:'Cobasi',discount:10,image:__WEBPACK_IMPORTED_MODULE_53__loyal_images_brand_cards_benefits_cards_new_cobasi_jpg___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% de desconto com o cupom IUPP '),profile:'pra todo mundo',category:'Pets',partner:'Cobasi',alt:'Logo Cobasi'},{name:'Protec Bag',discount:20,image:__WEBPACK_IMPORTED_MODULE_77__loyal_images_brand_cards_benefits_cards_new_protec_bag_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com cupom ITAUCARD20 em lojas f\xEDsicas'),profile:'quem tem Itaucard',category:'Hotelaria',partner:'Protec Bag',alt:'Logo Protec Bag'},{link:'https://app.adjust.com/sm2tu1i?engagement_type=fallback_click&fallback=https%3A%2F%2Fturbi.com.br%2F',name:'Turbi',discount:60,image:__WEBPACK_IMPORTED_MODULE_79__loyal_images_brand_cards_benefits_cards_new_turbi_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% de desconto em viagens com Itaucard.'),profile:'quem tem Itaucard',category:'Transporte',partner:'Turbi',alt:'Logo Turbi'},{link:'https://www.atlanticahotels.com.br/acoes-promocionais/promocao-itaucard/',name:'Atlantica',discount:30,image:__WEBPACK_IMPORTED_MODULE_68__loyal_images_brand_cards_benefits_cards_new_atlantica_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 30% de desconto'),profile:'quem tem Itaucard',category:'Hotelaria',partner:'Atlantica',alt:'Logo Atlantica'},{link:'https://olympikus.parceriasonline.com.br/iupp',name:'Olympikus',discount:15,image:__WEBPACK_IMPORTED_MODULE_67__loyal_images_brand_cards_benefits_cards_new_olympikus_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off na sele\xE7\xE3o de produtos'),profile:'pra todo mundo',category:'Esporte',partner:'Olympikus',alt:'Logo Olympikus'},{link:'https://underarmour.parceriasonline.com.br/iupp',name:'Under Armour',discount:10,image:__WEBPACK_IMPORTED_MODULE_64__loyal_images_brand_cards_benefits_cards_new_under_jpg___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off  com cupom iupp2020'),profile:'pra todo mundo',category:'Esporte',partner:'Under Armour',alt:'Logo Under Armour'},{link:'https://www.quemdisseberenice.com.br/parceria-itaucard',name:'Quem disse, Berenice?',discount:10,image:__WEBPACK_IMPORTED_MODULE_69__loyal_images_brand_cards_benefits_cards_new_berenice_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off com o cupom ITAU10'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'Quem disse Berenice',alt:'Logo Quem disse Berenice'},{name:'EspaçoLaser',discount:55,image:__WEBPACK_IMPORTED_MODULE_70__loyal_images_brand_cards_benefits_cards_new_espaco_laser_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'60% off e veja o cupom no app Espa\xE7olaser'),profile:'Pra quem é funcionário',category:'Bem estar e saúde',partner:'Espaço Laser',alt:'Logo Espaço Laser'},{link:'https://parceria.sgrentals.com.br/itaucard',name:'Hertz Internacional',discount:15,image:__WEBPACK_IMPORTED_MODULE_72__loyal_images_brand_cards_benefits_cards_new_hertz_internacional_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off sobre o valor da di\xE1ria'),profile:'quem tem Itaucard',category:'Transporte',partner:'Hertz Internacional',alt:'Logo Hertz Internacional'},{link:'https://www.eudora.com.br/',name:'Eudora',discount:20,image:__WEBPACK_IMPORTED_MODULE_71__loyal_images_brand_cards_benefits_cards_new_eudora_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off cupom o EUDORAITAUCARD10'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'Eudora',alt:'Logo Eudora'},{link:'https://www.invisalign.com.br/use-invisalign',name:'Invisalign',image:__WEBPACK_IMPORTED_MODULE_73__loyal_images_brand_cards_benefits_cards_new_invisalign_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Transformar o seu sorriso ficou mais f\xE1cil'),profile:'quem tem Itaucard',category:'Bem estar e saúde',partner:'Invisalign',alt:'Logo Invisalign'},{link:'https://www.invisalign.com.br/use-invisalign',name:'Invisalign',image:__WEBPACK_IMPORTED_MODULE_73__loyal_images_brand_cards_benefits_cards_new_invisalign_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Transformar o seu sorriso ficou mais f\xE1cil'),profile:'Pra quem é funcionário',category:'Bem estar e saúde',partner:'Invisalign',alt:'Logo Invisalign'},{link:'https://www.natura.com.br/parceiros/itau-colaboradores',name:'Natura',discount:35,image:__WEBPACK_IMPORTED_MODULE_34__loyal_images_brand_cards_benefits_img_natura_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 35% off em produtos selecionados'),profile:'Pra quem é funcionário',category:'Perfumaria',partner:'Natura',alt:'Logo Natura'},{link:'https://azaleia.parceriasonline.com.br/iupp',name:'Azaleia',discount:10,image:__WEBPACK_IMPORTED_MODULE_74__loyal_images_brand_cards_benefits_cards_new_azaleia_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off com o cupom AZALEIA10'),profile:'pra todo mundo',category:'Moda',partner:'Azaleia',alt:'Logo Azaleia'},{link:'https://www.mobly.com.br/itaucard/',name:'Mobly',discount:8,image:__WEBPACK_IMPORTED_MODULE_75__loyal_images_brand_cards_benefits_cards_new_mobly_jpg___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8% de desconto com o cupom ITAUCARD8'),profile:'quem tem Itaucard',category:'Casa e Decoração',partner:'Mobly',alt:'Logo Mobly'},{name:'Evino',link:'https://www.evino.com.br/',discount:25,image:__WEBPACK_IMPORTED_MODULE_15__loyal_images_brand_cards_benefits_img_evino_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Demais compras: 10% off com o cupom IUPP10'),profile:'pra todo mundo',category:'Bebidas',partner:'Evino',alt:'Logo Evino'},{link:'https://prontolight.com/',name:'Pronto Light',discount:20,image:__WEBPACK_IMPORTED_MODULE_76__loyal_images_brand_cards_benefits_cards_new_prontolight_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom IUPP15'),profile:'pra todo mundo',category:'Alimentos',partner:'Pronto Light',alt:'Logo Pronto Light'},{link:'http://www.usereserva.com/',name:'Reserva',discount:15,image:__WEBPACK_IMPORTED_MODULE_78__loyal_images_brand_cards_benefits_cards_new_reserva_new_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom ITAU15'),profile:'quem tem Itaucard',category:'Moda',partner:'Reserva',alt:'Logo Reserva'},{link:'https://www.digitalhouse.com/br/acoes/itaucard',name:'Digital House',image:__WEBPACK_IMPORTED_MODULE_81__loyal_images_brand_cards_benefits_cards_new_digital_house_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'50% off em cursos'),profile:'quem tem Itaucard',category:'Educação',partner:'Digital House',alt:'Logo Digital House'},{link:'https://visabenefitslac.axa-assistance.us/',name:'Visa',image:__WEBPACK_IMPORTED_MODULE_82__loyal_images_brand_cards_benefits_cards_new_visa_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Conhe\xE7a os benef\xEDcios que a Visa tem para voc\xEA'),profile:'quem tem Itaucard',category:'Para você',partner:'Visa',alt:'Logo Visa'},{link:'https://www.mastercard.com.br/pt-br/consumidores/encontre-seu-cartao/cartoes-credito.html',name:'Mastercard®',image:__WEBPACK_IMPORTED_MODULE_83__loyal_images_brand_cards_benefits_cards_new_master_card_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Conhe\xE7a os benef\xEDcios do seu cart\xE3o Mastercard\xAE'),profile:'quem tem Itaucard',category:'Para você',partner:'Mastercard',alt:'Logo Mastercard'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/adcos/',name:'ADCOS',image:__WEBPACK_IMPORTED_MODULE_80__loyal_images_brand_cards_benefits_cards_new_adcos_png___default.a,discount:10,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% + 4 amostras nas compras na loja online'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'ADCOS',alt:'Logo ADCOS'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/le-postiche/',name:'Le postiche',image:__WEBPACK_IMPORTED_MODULE_56__loyal_images_brand_cards_benefits_cards_new_lepostiche_png___default.a,discount:10,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom ITAUPERSONNALITE15'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Le postiche',alt:'Logo Le postiche'},{link:'https://zenklub.com.br/auth/signup/?referralCode=itauzen&h1=O%20seu%20benef%C3%ADcio%20Ita%C3%BA%20chegou!&h2=Aproveite%20o%20seu%20desconto%20sobre%20qualquer%20consulta',name:'Zenklub',image:__WEBPACK_IMPORTED_MODULE_84__loyal_images_brand_cards_benefits_cards_new_zenklub_png___default.a,discount:20,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off em consultas'),profile:'quem tem Itaucard',category:'Bem estar e saúde',partner:'Zenklub',alt:'Logo Zenklub'},{link:'https://zenklub.com.br/auth/signup/?referralCode=itauzen&h1=O%20seu%20benef%C3%ADcio%20Ita%C3%BA%20chegou!&h2=Aproveite%20o%20seu%20desconto%20sobre%20qualquer%20consulta',name:'Zenklub',image:__WEBPACK_IMPORTED_MODULE_84__loyal_images_brand_cards_benefits_cards_new_zenklub_png___default.a,discount:20,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2 meses gr\xE1tis no App + 20% off em consultas'),profile:'Pra quem é funcionário',category:'Bem estar e saúde',partner:'Zenklub',alt:'Logo Zenklub'},{link:'https://www.stz.com.br/iuppdesconto',name:'StudioZ',image:__WEBPACK_IMPORTED_MODULE_85__loyal_images_brand_cards_benefits_cards_new_studio_png___default.a,discount:10,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off com o cupom IUPPDESCONTO'),profile:'pra todo mundo',category:'Moda',partner:'StudioZ',alt:'Logo StudioZ'},{link:'http://www.onelink.to/tokbeauty',name:'TokBeauty',image:__WEBPACK_IMPORTED_MODULE_61__loyal_images_brand_cards_benefits_cards_new_tokbeauty_png___default.a,discount:15,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off nos demais com cupom ITAUCARD15'),profile:'quem tem Itaucard',category:'Perfumaria',partner:'TokBeauty',alt:'TokBeauty'},{link:'https://atendimentoiupp.zendesk.com/hc/pt-br/sections/360010476431',name:'Marisa',image:__WEBPACK_IMPORTED_MODULE_18__loyal_images_brand_cards_benefits_img_marisa_png___default.a,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Confira as condi\xE7\xF5es exclusivas '),profile:'pra todo mundo',category:'Moda',partner:'Marisa',alt:'Marisa'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/reserva/',name:'Reserva',image:__WEBPACK_IMPORTED_MODULE_78__loyal_images_brand_cards_benefits_cards_new_reserva_new_png___default.a,discount:15,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off pagando com os cart\xF5es Personnalit\xE9'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Reserva',alt:'Reserva'},{link:'http://www.vivara.com.br/',name:'Vivara',image:__WEBPACK_IMPORTED_MODULE_86__loyal_images_brand_cards_benefits_cards_new_vivara_png___default.a,discount:15,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off com o cupom iupp15'),profile:'pra todo mundo',category:'Para você',partner:'Vivara',alt:'Vivara'},{link:'https://carnegiebrasil.com.br/iupp',name:'Carnegie',image:__WEBPACK_IMPORTED_MODULE_88__loyal_images_brand_cards_benefits_cards_new_carnegie_png___default.a,discount:50,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'30% off nos cursos com o cupom itaucard30'),profile:'quem tem Itaucard',category:'Educação',partner:'Carnegie',alt:'Carnegie'},{link:'https://www.microsoft.com/pt-br/home-use-program',name:'Microsoft',image:__WEBPACK_IMPORTED_MODULE_87__loyal_images_brand_cards_benefits_cards_new_microsoft_png___default.a,discount:30,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'30% em assinaturas do Microsoft 365'),profile:'Pra quem é funcionário',category:'Para você',partner:'Microsoft',alt:'Microsoft'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/cobasi/',name:'Cobasi',image:__WEBPACK_IMPORTED_MODULE_53__loyal_images_brand_cards_benefits_cards_new_cobasi_jpg___default.a,discount:10,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10% off no site utilizando o cupom PERSONNALITE'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Cobasi',alt:'Cobasi'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/cestas-michelli/',name:'Cestas Michelli',image:__WEBPACK_IMPORTED_MODULE_25__loyal_images_brand_cards_benefits_img_cestas_michelli_png___default.a,discount:20,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off pelo hotsite'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Cestas Michelli',alt:'Cestas Michelli'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/giuliana-flores/',name:'Giuliana Flores',image:__WEBPACK_IMPORTED_MODULE_24__loyal_images_brand_cards_benefits_img_giuliana_flores_png___default.a,discount:20,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off pelo hotsite'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Giuliana Flores',alt:'Giuliana Flores'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/loccitane-en-provance/',name:'L\'Occitane en Provence',image:__WEBPACK_IMPORTED_MODULE_58__loyal_images_brand_cards_benefits_cards_new_looccitane_png___default.a,discount:15,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off no site com o cupom PERSONNALITE'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'L\'Occitane en Provence',alt:'L\'Occitane en Provence'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/original-experience/',name:'Original Experience',image:__WEBPACK_IMPORTED_MODULE_57__loyal_images_brand_cards_benefits_cards_new_logo_original_experience_png___default.a,discount:20,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'12% off com o cupom PERSONNALITE12 '),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'Original Experience',alt:'Original Experience'},{link:'https://www.itau.com.br/personnalite/experiencia/estilo-de-vida/loccitane-au-bresil/',name:'L\'Occitane Au Br\xE9sil',image:__WEBPACK_IMPORTED_MODULE_50__loyal_images_brand_cards_benefits_img_loccitane_png___default.a,discount:15,descriptionHtml:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'15% off no site com o cupom PERSONNALITE15'),profile:'pra quem é Personnalité',category:'Estilo de Vida',partner:'L\'Occitane Au Br\xE9sil',alt:'L\'Occitane Au Br\xE9sil'}];// #endregion
this.buildFilters(this.benefits);this.filterBenefits();this.onOrderChange({type:'ASCENDING'});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container row px-0 pt-2 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2 d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm '+(this.state.openFilter?'d-none':''),onClick:function onClick(){return _this2.setState({openFilter:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{text:'Voltar',iconName:'icon_left icon-sm pt-3',className:'col-12 btn-sm btn-flat pt-5 '+(this.state.openFilter?'':'d-none'),onClick:function onClick(){return _this2.setState({openFilter:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 '+(this.state.openFilter?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{className:'btn btn-sm btn-featured',text:'Aplicar',onClick:function onClick(){return _this2.setState({openFilter:false});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '+(this.state.openFilter?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Filter__["a" /* Filter */],{onOrderChange:this.onOrderChange,onFilterChange:this.onFilterChange,filters:this.state.filter,profiles:this.state.profiles,categories:this.state.categories,places:this.state.places,partners:this.state.partners,tags:this.state.tags,removeTags:this.removeTags,removeAllTags:this.removeAllTags}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 mt-2 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Filter__["a" /* Filter */],{onOrderChange:this.onOrderChange,onFilterChange:this.onFilterChange,filters:this.state.filter,profiles:this.state.profiles,categories:this.state.categories,places:this.state.places,partners:this.state.partners,tags:this.state.tags,removeTags:this.removeTags,removeAllTags:this.removeAllTags})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-9 mt-2 row parters-benefits-area mx-0 px-0 '+(this.state.openFilter?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:this.loadItems,hasMore:this.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'}),className:'container row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 mx-0 px-0'},this.state.filteredBenefits&&this.state.filteredBenefits.map(this.getCardsBenefits)))))));}}]);return ItauCardListing;}(__WEBPACK_IMPORTED_MODULE_1__BaseListing__["a" /* default */]);/* harmony default export */ __webpack_exports__["default"] = (ItauCardListing);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(29) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(330)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(26);


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(56);
var toIObject = __webpack_require__(57);
var arrayIndexOf = __webpack_require__(219)(false);
var IE_PROTO = __webpack_require__(332)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(107);

module.exports = __webpack_require__(29) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(57);
var gOPN = __webpack_require__(110).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(29);
var getKeys = __webpack_require__(107);
var gOPS = __webpack_require__(220);
var pIE = __webpack_require__(170);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(169);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(19)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(40);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(682);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 682 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(16).parseInt;
var $trim = __webpack_require__(135).trim;
var ws = __webpack_require__(336);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(16).parseFloat;
var $trim = __webpack_require__(135).trim;

module.exports = 1 / $parseFloat(__webpack_require__(336) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(65);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 687 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(339);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(40);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(169);
var toLength = __webpack_require__(28);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(108);
var toLength = __webpack_require__(28);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(351);
__webpack_require__(4)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(29) && /./g.flags != 'g') __webpack_require__(32).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(171)
});


/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(355);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(698);
var validate = __webpack_require__(115);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(228)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(32).f;
var create = __webpack_require__(109);
var redefineAll = __webpack_require__(114);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(112);
var forOf = __webpack_require__(113);
var $iterDefine = __webpack_require__(341);
var step = __webpack_require__(692);
var setSpecies = __webpack_require__(111);
var DESCRIPTORS = __webpack_require__(29);
var fastKey = __webpack_require__(90).fastKey;
var validate = __webpack_require__(115);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(698);
var validate = __webpack_require__(115);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(228)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var each = __webpack_require__(75)(0);
var redefine = __webpack_require__(50);
var meta = __webpack_require__(90);
var assign = __webpack_require__(679);
var weak = __webpack_require__(701);
var isObject = __webpack_require__(20);
var validate = __webpack_require__(115);
var NATIVE_WEAK_MAP = __webpack_require__(115);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(228)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(114);
var getWeak = __webpack_require__(90).getWeak;
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(112);
var forOf = __webpack_require__(113);
var createArrayMethod = __webpack_require__(75);
var $has = __webpack_require__(56);
var validate = __webpack_require__(115);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(66);
var toLength = __webpack_require__(28);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(110);
var gOPS = __webpack_require__(220);
var anObject = __webpack_require__(10);
var Reflect = __webpack_require__(16).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(221);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(28);
var ctx = __webpack_require__(64);
var IS_CONCAT_SPREADABLE = __webpack_require__(26)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(28);
var repeat = __webpack_require__(338);
var defined = __webpack_require__(73);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(29);
var getKeys = __webpack_require__(107);
var toIObject = __webpack_require__(57);
var isEnum = __webpack_require__(170).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(134);
var from = __webpack_require__(708);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(113);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 709 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(785);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(865);
var v4 = __webpack_require__(866);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(713);
module.exports = __webpack_require__(718);


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(714).enable()
  window.Promise = __webpack_require__(716)
}

// fetch() polyfill for making API calls.
__webpack_require__(717)

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(118)

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global)
}


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(358);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(358);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 717 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_browser__ = __webpack_require__(575);
var match=/(_token=)([A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*)|(code=)([A-Za-z0-9-]+)/g;window._etmc=window._etmc||[];__WEBPACK_IMPORTED_MODULE_6__sentry_browser__["b" /* init */]({beforeSend:function beforeSend(event){if(event.request&&event.request.url){event.request.url=event.request.url.replace(match,'$1[filtered]');}return event;},beforeBreadcrumb:function beforeBreadcrumb(breadcrumb,hint){if(breadcrumb.category==='navigation'){if(breadcrumb.data.to){breadcrumb.data.to=breadcrumb.data.to.replace(match,'$1[filtered]');}if(breadcrumb.data.from){breadcrumb.data.from=breadcrumb.data.from.replace(match,'$1[filtered]');}}return breadcrumb;},environment:'tenants.'+"prod"+'.'+"70885",dsn:'https://0ca83c8de7ed4175968d793999cbf782@sentry.io/1849338'});Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App__["a" /* default */],{store:__WEBPACK_IMPORTED_MODULE_5__redux__["c" /* store */],history:__WEBPACK_IMPORTED_MODULE_5__redux__["a" /* history */],persistor:__WEBPACK_IMPORTED_MODULE_5__redux__["b" /* persistor */]}),document.getElementById('root'));__WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__["a" /* unregister */]();

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(118),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(118),q=__webpack_require__(721);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(722);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_main_css__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_oidc__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_oidc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_oidc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_last_location__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_last_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet_async__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_App_AppRouter__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Shared_HeadMetadata__ = __webpack_require__(2074);
var App=function App(_ref){var store=_ref.store,history=_ref.history;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_oidc__["OidcProvider"],{store:store,userManager:__WEBPACK_IMPORTED_MODULE_8_Auth__["c" /* userManager */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["ConnectedRouter"],{history:history},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_last_location__["LastLocationProvider"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet_async__["HelmetProvider"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Shared_HeadMetadata__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_App_AppRouter__["a" /* default */],null))))));};App.propTypes={store:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

"use strict";

/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(728);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(235);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(357);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(742);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(363);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(738);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8), __webpack_require__(362)(module)))

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(363);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(364);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(743);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(235);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = __webpack_require__(177);

var actions = _interopRequireWildcard(_actions);

var _ConnectedRouter = __webpack_require__(745);

var _ConnectedRouter2 = _interopRequireDefault(_ConnectedRouter);

var _reducer = __webpack_require__(752);

var _reducer2 = _interopRequireDefault(_reducer);

var _middleware = __webpack_require__(753);

var _middleware2 = _interopRequireDefault(_middleware);

var _selectors = __webpack_require__(754);

var _selectors2 = _interopRequireDefault(_selectors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var createAll = function createAll(structure) {
  return _extends({}, _get__('actions'), _get__('createSelectors')(structure), {
    ConnectedRouter: _get__('createConnectedRouter')(structure),
    connectRouter: _get__('createConnectRouter')(structure),
    routerMiddleware: _get__('routerMiddleware')
  });
};

exports.default = _get__('createAll');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'actions':
      return _filterWildcardImport__(actions);

    case 'createSelectors':
      return _selectors2.default;

    case 'createConnectedRouter':
      return _ConnectedRouter2.default;

    case 'createConnectRouter':
      return _reducer2.default;

    case 'routerMiddleware':
      return _middleware2.default;

    case 'createAll':
      return createAll;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createAll === 'undefined' ? 'undefined' : _typeof(createAll);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createAll, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createAll)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

function _filterWildcardImport__() {
  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
  });
  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
    return filteredWildcardImport;
  }, {});
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _reactRouter = __webpack_require__(41);

var _actions = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createConnectedRouter = function createConnectedRouter(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;
  /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */

  var ConnectedRouter = function (_get__2) {
    _inherits(ConnectedRouter, _get__2);

    function ConnectedRouter(props, context) {
      _classCallCheck(this, ConnectedRouter);

      var _this = _possibleConstructorReturn(this, (ConnectedRouter.__proto__ || Object.getPrototypeOf(ConnectedRouter)).call(this, props));

      _this.inTimeTravelling = false;

      // Subscribe to store changes
      _this.unsubscribe = context.store.subscribe(function () {
        // Extract store's location
        var _toJS = toJS(getIn(context.store.getState(), ['router', 'location'])),
            pathnameInStore = _toJS.pathname,
            searchInStore = _toJS.search,
            hashInStore = _toJS.hash;
        // Extract history's location


        var _props$history$locati = props.history.location,
            pathnameInHistory = _props$history$locati.pathname,
            searchInHistory = _props$history$locati.search,
            hashInHistory = _props$history$locati.hash;

        // If we do time travelling, the location in store is changed but location in history is not changed

        if (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore) {
          _this.inTimeTravelling = true;
          // Update history's location to match store's location
          props.history.push({
            pathname: pathnameInStore,
            search: searchInStore,
            hash: hashInStore
          });
        }
      });

      var handleLocationChange = function handleLocationChange(location, action) {
        // Dispatch onLocationChanged except when we're in time travelling
        if (!_this.inTimeTravelling) {
          props.onLocationChanged(location, action);
        } else {
          _this.inTimeTravelling = false;
        }
      };

      // Listen to history changes
      _this.unlisten = props.history.listen(handleLocationChange);
      // Dispatch a location change action for the initial location
      handleLocationChange(props.history.location, props.history.action);
      return _this;
    }

    _createClass(ConnectedRouter, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unlisten();
        this.unsubscribe();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            history = _props.history,
            children = _props.children;


        return _get__('React').createElement(
          _get__('Router'),
          { history: history },
          children
        );
      }
    }]);

    return ConnectedRouter;
  }(_get__('Component'));

  ConnectedRouter.contextTypes = {
    store: _get__('PropTypes').shape({
      getState: _get__('PropTypes').func.isRequired,
      subscribe: _get__('PropTypes').func.isRequired
    }).isRequired
  };

  ConnectedRouter.propTypes = {
    history: _get__('PropTypes').shape({
      action: _get__('PropTypes').string.isRequired,
      listen: _get__('PropTypes').func.isRequired,
      location: _get__('PropTypes').object.isRequired,
      push: _get__('PropTypes').func.isRequired
    }).isRequired,
    location: _get__('PropTypes').oneOfType([_get__('PropTypes').object, _get__('PropTypes').string]).isRequired,
    action: _get__('PropTypes').string.isRequired,
    basename: _get__('PropTypes').string,
    children: _get__('PropTypes').oneOfType([_get__('PropTypes').func, _get__('PropTypes').node]),
    onLocationChanged: _get__('PropTypes').func.isRequired
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      action: getIn(state, ['router', 'action']),
      location: getIn(state, ['router', 'location'])
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onLocationChanged: function onLocationChanged(location, action) {
        return dispatch(_get__('onLocationChanged')(location, action));
      }
    };
  };

  return _get__('connect')(mapStateToProps, mapDispatchToProps)(ConnectedRouter);
};

exports.default = _get__('createConnectedRouter');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'PropTypes':
      return _propTypes2.default;

    case 'onLocationChanged':
      return _actions.onLocationChanged;

    case 'connect':
      return _reactRedux.connect;

    case 'createConnectedRouter':
      return createConnectedRouter;

    case 'React':
      return _react2.default;

    case 'Router':
      return _reactRouter.Router;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createConnectedRouter === 'undefined' ? 'undefined' : _typeof(createConnectedRouter);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createConnectedRouter, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createConnectedRouter)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _actions = __webpack_require__(177);

var createConnectRouter = function createConnectRouter(structure) {
  var filterNotRouter = structure.filterNotRouter,
      fromJS = structure.fromJS,
      getIn = structure.getIn,
      merge = structure.merge,
      setIn = structure.setIn;
  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to.
   */

  var routerReducer = function routerReducer(state) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        type = _ref.type,
        payload = _ref.payload;

    if (type === _get__('LOCATION_CHANGE')) {
      return merge(state, payload);
    }

    return state;
  };

  var connectRouter = function connectRouter(history) {
    var initialRouterState = fromJS({
      location: history.location,
      action: history.action
    });
    // Wrap a root reducer and return a new root reducer with router state
    return function (rootReducer) {
      return function (state, action) {
        var routerState = initialRouterState;

        // Extract router state
        if (state) {
          routerState = getIn(state, ['router']) || routerState;
          state = filterNotRouter(state);
        }
        var reducerResults = rootReducer(state, action);

        return setIn(reducerResults, ['router'], routerReducer(routerState, action));
      };
    };
  };

  return connectRouter;
};

exports.default = _get__('createConnectRouter');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LOCATION_CHANGE':
      return _actions.LOCATION_CHANGE;

    case 'createConnectRouter':
      return createConnectRouter;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createConnectRouter === 'undefined' ? 'undefined' : _typeof(createConnectRouter);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createConnectRouter, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createConnectRouter)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _actions = __webpack_require__(177);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
var routerMiddleware = function routerMiddleware(history) {
  return function (store) {
    return function (next) {
      return function (action) {
        // eslint-disable-line no-unused-vars
        if (action.type !== _get__('CALL_HISTORY_METHOD')) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
};

exports.default = _get__('routerMiddleware');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'CALL_HISTORY_METHOD':
      return _actions.CALL_HISTORY_METHOD;

    case 'routerMiddleware':
      return routerMiddleware;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof routerMiddleware === 'undefined' ? 'undefined' : _typeof(routerMiddleware);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(routerMiddleware, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(routerMiddleware)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reactRouter = __webpack_require__(41);

var createSelectors = function createSelectors(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;

  var getLocation = function getLocation(state) {
    return toJS(getIn(state, ['router', 'location']));
  };
  var getAction = function getAction(state) {
    return toJS(getIn(state, ['router', 'action']));
  };

  // It only makes sense to recalculate the `matchPath` whenever the pathname
  // of the location changes. That's why `createMatchSelector` memoizes
  // the latest result based on the location's pathname.
  var createMatchSelector = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;

    return function (state) {
      var _ref = getLocation(state) || {},
          pathname = _ref.pathname;

      if (pathname === lastPathname) {
        return lastMatch;
      }
      lastPathname = pathname;
      var match = _get__('matchPath')(pathname, path);
      if (!match || !lastMatch || match.url !== lastMatch.url) {
        lastMatch = match;
      }

      return lastMatch;
    };
  };

  return { getLocation: getLocation, getAction: getAction, createMatchSelector: createMatchSelector };
};

exports.default = _get__('createSelectors');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'matchPath':
      return _reactRouter.matchPath;

    case 'createSelectors':
      return createSelectors;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createSelectors === 'undefined' ? 'undefined' : _typeof(createSelectors);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createSelectors, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createSelectors)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getIn = __webpack_require__(756);

var _getIn2 = _interopRequireDefault(_getIn);

var _setIn = __webpack_require__(757);

var _setIn2 = _interopRequireDefault(_setIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var structure = {
  filterNotRouter: function filterNotRouter(state) {
    var router = state.router,
        rest = _objectWithoutProperties(state, ['router']); // eslint-disable-line no-unused-vars


    return rest;
  },
  fromJS: function fromJS(value) {
    return value;
  },
  getIn: _get__('getIn'),
  merge: function merge(state, payload) {
    return _extends({}, state, payload);
  },
  setIn: _get__('setIn'),
  toJS: function toJS(value) {
    return value;
  }
};

exports.default = _get__('structure');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'getIn':
      return _getIn2.default;

    case 'setIn':
      return _setIn2.default;

    case 'structure':
      return structure;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof structure === 'undefined' ? 'undefined' : _typeof(structure);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(structure, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(structure)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* Code from github.com/erikras/redux-form by Erik Rasmussen */

var getIn = function getIn(state, path) {
  if (!state) {
    return state;
  }

  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && !!result; ++i) {
    result = result[path[i]];
  }

  return result;
};

exports.default = _get__("getIn");

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "getIn":
      return getIn;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof getIn === "undefined" ? "undefined" : _typeof(getIn);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(getIn, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(getIn)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Code from github.com/erikras/redux-form by Erik Rasmussen */

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var next = _get__("setInWithPath")(state && state[first], value, path, pathIndex + 1);

  if (!state) {
    var initialized = isNaN(first) ? {} : [];
    initialized[first] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[first] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return _get__("setInWithPath")(state, value, field, 0);
};

exports.default = _get__("setIn");

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "setInWithPath":
      return setInWithPath;

    case "setIn":
      return setIn;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof setIn === "undefined" ? "undefined" : _typeof(setIn);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(setIn, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(setIn)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(239);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createBrowserHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(239);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createHashHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(366);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(373);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(367);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(368);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(370);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(371);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(237);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(179);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(372);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _shallowequal = __webpack_require__(379);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _client = __webpack_require__(770);

var _client2 = _interopRequireDefault(_client);

var _server = __webpack_require__(377);

var _server2 = _interopRequireDefault(_server);

var _utils = __webpack_require__(240);

var _Provider = __webpack_require__(376);

var _Provider2 = _interopRequireDefault(_Provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dispatcher = function (_Component) {
  _inherits(Dispatcher, _Component);

  function Dispatcher() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dispatcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dispatcher.__proto__ || Object.getPrototypeOf(Dispatcher)).call.apply(_ref, [this].concat(args))), _this), _this.rendered = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dispatcher, [{
    key: 'init',


    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    value: function init() {
      if (this.rendered) {
        return;
      }

      this.rendered = true;

      var helmetInstances = this.props.context.helmetInstances;

      helmetInstances.add(this);
      this.emitChange();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowequal2.default)(nextProps, this.props);
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      var _props$context = this.props.context,
          helmetInstances = _props$context.helmetInstances,
          setHelmet = _props$context.setHelmet;

      var serverState = null;
      var state = (0, _utils.reducePropsToState)(helmetInstances.get().map(function (instance) {
        var props = _extends({}, instance.props);
        delete props.context;
        return props;
      }));
      if (_Provider2.default.canUseDOM) {
        (0, _client2.default)(state);
      } else if (_server2.default) {
        serverState = (0, _server2.default)(state);
      }
      setHelmet(serverState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var helmetInstances = this.props.context.helmetInstances;

      helmetInstances.remove(this);
      this.emitChange();
    }
  }, {
    key: 'render',
    value: function render() {
      this.init();

      return null;
    }
  }]);

  return Dispatcher;
}(_react.Component);

Dispatcher.propTypes = {
  context: _Provider.providerShape.isRequired
};
exports.default = Dispatcher;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAnimationFrame = undefined;

var _constants = __webpack_require__(180);

var _utils = __webpack_require__(240);

var rafPolyfill = function () {
  var clock = Date.now();

  return function (callback) {
    var currentTime = Date.now();

    if (currentTime - clock > 16) {
      clock = currentTime;
      callback(currentTime);
    } else {
      setTimeout(function () {
        rafPolyfill(callback);
      }, 0);
    }
  };
}();

var updateTags = function updateTags(type, tags) {
  var headElement = document.head || document.querySelector(_constants.TAG_NAMES.HEAD);
  var tagNodes = headElement.querySelectorAll(type + '[' + _constants.HELMET_ATTRIBUTE + ']');
  var oldTags = [].slice.call(tagNodes);
  var newTags = [];
  var indexToDelete = void 0;

  if (tags && tags.length) {
    tags.forEach(function (tag) {
      var newElement = document.createElement(type);

      // eslint-disable-next-line
      for (var attribute in tag) {
        if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
          if (attribute === _constants.TAG_PROPERTIES.INNER_HTML) {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === _constants.TAG_PROPERTIES.CSS_TEXT) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            var value = typeof tag[attribute] === 'undefined' ? '' : tag[attribute];
            newElement.setAttribute(attribute, value);
          }
        }
      }

      newElement.setAttribute(_constants.HELMET_ATTRIBUTE, 'true');

      // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
      if (oldTags.some(function (existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }

  oldTags.forEach(function (tag) {
    return tag.parentNode.removeChild(tag);
  });
  newTags.forEach(function (tag) {
    return headElement.appendChild(tag);
  });

  return {
    oldTags: oldTags,
    newTags: newTags
  };
};

var updateAttributes = function updateAttributes(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];

  if (!elementTag) {
    return;
  }

  var helmetAttributeString = elementTag.getAttribute(_constants.HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(',') : [];
  var attributesToRemove = [].concat(helmetAttributes);
  var attributeKeys = Object.keys(attributes);

  for (var i = 0; i < attributeKeys.length; i += 1) {
    var attribute = attributeKeys[i];
    var value = attributes[attribute] || '';

    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }

    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }

    var indexToSave = attributesToRemove.indexOf(attribute);
    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }

  for (var _i = attributesToRemove.length - 1; _i >= 0; _i -= 1) {
    elementTag.removeAttribute(attributesToRemove[_i]);
  }

  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(_constants.HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(_constants.HELMET_ATTRIBUTE) !== attributeKeys.join(',')) {
    elementTag.setAttribute(_constants.HELMET_ATTRIBUTE, attributeKeys.join(','));
  }
};

var updateTitle = function updateTitle(title, attributes) {
  if (typeof title !== 'undefined' && document.title !== title) {
    document.title = (0, _utils.flattenArray)(title);
  }

  updateAttributes(_constants.TAG_NAMES.TITLE, attributes);
};

var commitTagChanges = function commitTagChanges(newState, cb) {
  var baseTag = newState.baseTag,
      bodyAttributes = newState.bodyAttributes,
      htmlAttributes = newState.htmlAttributes,
      linkTags = newState.linkTags,
      metaTags = newState.metaTags,
      noscriptTags = newState.noscriptTags,
      onChangeClientState = newState.onChangeClientState,
      scriptTags = newState.scriptTags,
      styleTags = newState.styleTags,
      title = newState.title,
      titleAttributes = newState.titleAttributes;

  updateAttributes(_constants.TAG_NAMES.BODY, bodyAttributes);
  updateAttributes(_constants.TAG_NAMES.HTML, htmlAttributes);

  updateTitle(title, titleAttributes);

  var tagUpdates = {
    baseTag: updateTags(_constants.TAG_NAMES.BASE, baseTag),
    linkTags: updateTags(_constants.TAG_NAMES.LINK, linkTags),
    metaTags: updateTags(_constants.TAG_NAMES.META, metaTags),
    noscriptTags: updateTags(_constants.TAG_NAMES.NOSCRIPT, noscriptTags),
    scriptTags: updateTags(_constants.TAG_NAMES.SCRIPT, scriptTags),
    styleTags: updateTags(_constants.TAG_NAMES.STYLE, styleTags)
  };

  var addedTags = {};
  var removedTags = {};

  Object.keys(tagUpdates).forEach(function (tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType],
        newTags = _tagUpdates$tagType.newTags,
        oldTags = _tagUpdates$tagType.oldTags;


    if (newTags.length) {
      addedTags[tagType] = newTags;
    }
    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });

  if (cb) {
    cb();
  }

  onChangeClientState(newState, addedTags, removedTags);
};

var cafPolyfill = function cafPolyfill(id) {
  return clearTimeout(id);
};

var requestAnimationFrame = exports.requestAnimationFrame = typeof window !== 'undefined' ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== 'undefined' ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

// eslint-disable-next-line
var _helmetCallback = null;

var handleStateChangeOnClient = function handleStateChangeOnClient(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }

  if (newState.defer) {
    _helmetCallback = requestAnimationFrame(function () {
      commitTagChanges(newState, function () {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};

exports.default = handleStateChangeOnClient;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Auth_Login__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Auth_Logout__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Auth_Session__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Auth_Callback__ = __webpack_require__(385);
var AuthRouter=function AuthRouter(_ref){var url=_ref.match.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/login',component:__WEBPACK_IMPORTED_MODULE_3_Auth_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/logout',component:__WEBPACK_IMPORTED_MODULE_4_Auth_Logout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/session',component:__WEBPACK_IMPORTED_MODULE_5_Auth_Session__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/callback',component:__WEBPACK_IMPORTED_MODULE_6_Auth_Callback__["a" /* default */]}));};AuthRouter.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(AuthRouter));

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var YES_MATCH_SCORE_THRESHOLD = 2;
var NO_MATCH_SCORE_THRESHOLD = 1.25;

var yMatch = new Map([[5, 0.25], [6, 0.25], [7, 0.25], ['t', 0.75], ['y', 1], ['u', 0.75], ['g', 0.25], ['h', 0.25], ['j', 0.25]]);

var eMatch = new Map([[2, 0.25], [3, 0.25], [4, 0.25], ['w', 0.75], ['e', 1], ['r', 0.75], ['s', 0.25], ['d', 0.25], ['f', 0.25]]);

var sMatch = new Map([['q', 0.25], ['w', 0.25], ['e', 0.25], ['a', 0.75], ['s', 1], ['d', 0.75], ['z', 0.25], ['x', 0.25], ['c', 0.25]]);

var nMatch = new Map([['h', 0.25], ['j', 0.25], ['k', 0.25], ['b', 0.75], ['n', 1], ['m', 0.75]]);

var oMatch = new Map([[9, 0.25], [0, 0.25], ['i', 0.75], ['o', 1], ['p', 0.75], ['k', 0.25], ['l', 0.25]]);

function getYesMatchScore(value) {
	var _value = _slicedToArray(value, 3),
	    y = _value[0],
	    e = _value[1],
	    s = _value[2];

	var score = 0;

	if (yMatch.has(y)) {
		score += yMatch.get(y);
	}

	if (eMatch.has(e)) {
		score += eMatch.get(e);
	}

	if (sMatch.has(s)) {
		score += sMatch.get(s);
	}

	return score;
}

function getNoMatchScore(value) {
	var _value2 = _slicedToArray(value, 2),
	    n = _value2[0],
	    o = _value2[1];

	var score = 0;

	if (nMatch.has(n)) {
		score += nMatch.get(n);
	}

	if (oMatch.has(o)) {
		score += oMatch.get(o);
	}

	return score;
}

module.exports = function (input, options) {
	if (getYesMatchScore(input) >= YES_MATCH_SCORE_THRESHOLD) {
		return true;
	}

	if (getNoMatchScore(input) >= NO_MATCH_SCORE_THRESHOLD) {
		return false;
	}

	return options.default;
};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define */

(function (global) {
  'use strict'

  // Constructor
  function OnDemandLiveRegion (options) {
    options = options || {}

    // The default settings for the module.
    this.settings = {
      level: 'polite',
      parent: 'body',
      idPrefix: 'live-region-',
      delay: 0
    }

    // Overwrite defaults where they are provided in options
    for (var setting in options) {
      if (options.hasOwnProperty(setting)) {
        this.settings[setting] = options[setting]
      }
    }

    // Cast parent as DOM node
    this.settings.parent = document.querySelector(this.settings.parent)
  }

  // 'Say' method
  OnDemandLiveRegion.prototype.say = function (thingToSay, delay) {
    // Get rid of old live region if it exists
    var oldRegion = this.settings.parent.querySelector('[id^="' + this.settings.idPrefix + '"]') || false
    if (oldRegion) {
      this.settings.parent.removeChild(oldRegion)
    }

    // Did an override level get set?
    delay = delay || this.settings.delay

    // Create fresh live region
    this.currentRegion = document.createElement('span')
    this.currentRegion.id = this.settings.idPrefix + Math.floor(Math.random() * 10000)

    // Determine redundant role
    var role = this.settings.level !== 'assertive' ? 'status' : 'alert'

    // Add role and aria-live attribution
    this.currentRegion.setAttribute('aria-live', this.settings.level)
    this.currentRegion.setAttribute('role', role)

    // Hide live region element, but not from assistive technologies
    this.currentRegion.setAttribute('style', 'clip: rect(1px, 1px, 1px, 1px); height: 1px; overflow: hidden; position: absolute; white-space: nowrap; width: 1px')

    // Add live region to its designated parent
    this.settings.parent.appendChild(this.currentRegion)

    // Populate live region to trigger it
    window.setTimeout(function () {
      this.currentRegion.textContent = thingToSay
    }.bind(this), delay)

    return this
  }

  // Export OnDemandLiveRegion
  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = OnDemandLiveRegion
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return OnDemandLiveRegion
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof global === 'object') {
    // attach to window
    global.OnDemandLiveRegion = OnDemandLiveRegion
  }
}(this))


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(775);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 775 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(777);

var UA = new UAParser();
var browser = UA.getBrowser();
var cpu = UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};
var BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari",
  EDGE_CHROMIUM: "Edge Chromium",
  MIUI: "MIUI Browser"
};
var OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone",
  WINDOWS: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return {
        isMobile: true
      };

    case DEVICE_TYPES.TABLET:
      return {
        isTablet: true
      };

    case DEVICE_TYPES.SMART_TV:
      return {
        isSmartTV: true
      };

    case DEVICE_TYPES.CONSOLE:
      return {
        isConsole: true
      };

    case DEVICE_TYPES.WEARABLE:
      return {
        isWearable: true
      };

    case DEVICE_TYPES.BROWSER:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DEVICE_TYPES.MOBILE;
};

var isTabletType = function isTabletType() {
  return device.type === DEVICE_TYPES.TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DEVICE_TYPES.MOBILE:
    case DEVICE_TYPES.TABLET:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DEVICE_TYPES.SMART_TV;
};

var isBrowserType = function isBrowserType() {
  return device.type === DEVICE_TYPES.BROWSER;
};

var isWearableType = function isWearableType() {
  return device.type === DEVICE_TYPES.WEARABLE;
};

var isConsoleType = function isConsoleType() {
  return device.type === DEVICE_TYPES.CONSOLE;
};

var isAndroidType = function isAndroidType() {
  return os.name === OS_TYPES.ANDROID;
};

var isWindowsType = function isWindowsType() {
  return os.name === OS_TYPES.WINDOWS;
};

var isMacOsType = function isMacOsType() {
  return os.name === OS_TYPES.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OS_TYPES.WINDOWS_PHONE;
};

var isIOSType = function isIOSType() {
  return os.name === OS_TYPES.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BROWSER_TYPES.CHROME;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BROWSER_TYPES.FIREFOX;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BROWSER_TYPES.CHROMIUM;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BROWSER_TYPES.EDGE;
};

var isYandexType = function isYandexType() {
  return browser.name === BROWSER_TYPES.YANDEX;
};

var isSafariType = function isSafariType() {
  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
};

var isOperaType = function isOperaType() {
  return browser.name === BROWSER_TYPES.OPERA;
};

var isIEType = function isIEType() {
  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BROWSER_TYPES.MIUI;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;
  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;
  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;
  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;
  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;
  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;
  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;
  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;
  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;
  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;
  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;
  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;
  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
    className: viewClassName,
    style: style
  }, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

exports.AndroidView = AndroidView;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.22
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.22",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,/(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(Avast)\/([\w\.]+)/i],[[NAME,"Avast Secure Browser"],VERSION],[/(AVG)\/([\w\.]+)/i],[[NAME,"AVG Secure Browser"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(baiduboxapp)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/(qihu|qhbrowser|qihoobrowser|360browser)/i],[[NAME,"360 Browser"]],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"],[TYPE,SMARTTV]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p|vog-l29|ane-lx1|eml-l29|ele-l29)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/android.+(bah2?-a?[lw]\d{2})/i],[MODEL,[VENDOR,"Huawei"],[TYPE,TABLET]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"],[TYPE,SMARTTV]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]?[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]?[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})[\s)]/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen|kaios)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(41);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PrivateRoute=function PrivateRoute(_ref){var _render=_ref.render,Component=_ref.component,user=_ref.user,redirectTo=_ref.redirectTo,rest=_objectWithoutProperties(_ref,['render','component','user','redirectTo']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"],Object.assign({},rest,{render:function render(props){return!user||user.expired?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Redirect"],{to:redirectTo||'/auth/login'}):_render?_render(props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props);}}));};PrivateRoute.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,render:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,redirectTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(state){return{user:state.oidc.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{dispatch:dispatch};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PrivateRoute));

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Auth_Zendesk__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_Shell__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_App_FourOFour__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Checkout__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_HomePage_HomeRouter__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Catalog_Product_ProductDetail_ProductDetailPageContainer__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_features_ProductCategory__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_features_Store__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_features_Services_ConfirmationCreditMileage__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Participant_MyOrders__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_features_Confirmation__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Participant__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_Participant_Scheduling__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_features_User_Orders__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_Participant_Wishlist__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_features_ConfirmationDonation__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_features_CellphoneRecharge__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HomePageItauMeuBairro__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_features_BillPayment__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_features_MileageRescue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_features_Stix__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_features_FuelCredit__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_features_Donation__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_features_PointsAndCash__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_features_ConfirmationMobileRechargeSchedule__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_Catalog_Search__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_features_Benefits__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_features_RedirectCustom_RedirectCustom__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_features_Accessibility_AccessibilityIupp__ = __webpack_require__(2073);
var Terms=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2291));});var RegulationPage=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 589));});var Privacy=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2292));});var Security=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2293));});var AppRouter=function AppRouter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/zendesk',component:__WEBPACK_IMPORTED_MODULE_3_Auth_Zendesk__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/auth',component:__WEBPACK_IMPORTED_MODULE_2_Auth__["b" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/',exact:true,component:__WEBPACK_IMPORTED_MODULE_7_HomePage_HomeRouter__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/comunidade-iupp/search/',component:__WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__["e" /* Search */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/comunidade-iupp/searchEcomm/',component:__WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__["f" /* SearchEcommerce */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/comunidade-iupp/searchStores/',component:__WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__["g" /* SearchStore */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/comunidade-iupp/product/:product/store/:store/company/:company',component:__WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__["d" /* ProductContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/comunidade-iupp/company/:company/store/:store',component:__WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__["i" /* StoreContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/comunidade-iupp',component:__WEBPACK_IMPORTED_MODULE_8_features_MeuBairro__["b" /* HomeIupp */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{isGuest:true,path:'/meu-negocio',component:__WEBPACK_IMPORTED_MODULE_22__HomePageItauMeuBairro__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/checkout',component:__WEBPACK_IMPORTED_MODULE_6_Checkout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/products/:sku',component:__WEBPACK_IMPORTED_MODULE_9_Catalog_Product_ProductDetail_ProductDetailPageContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/categories',component:__WEBPACK_IMPORTED_MODULE_10_features_ProductCategory__["a" /* ProductCategory */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/services/confirmation/:orderId',component:__WEBPACK_IMPORTED_MODULE_13_features_Services_ConfirmationCreditMileage__["a" /* ConfirmationCreditMileage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/stores/vouchers',component:__WEBPACK_IMPORTED_MODULE_11_features_Store__["b" /* StoreVoucher */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/stores',component:__WEBPACK_IMPORTED_MODULE_11_features_Store__["a" /* Store */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/my-orders',component:__WEBPACK_IMPORTED_MODULE_14_Participant_MyOrders__["a" /* MyOrders */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/order/:parentOrderId/:orderId/product/:productId',component:__WEBPACK_IMPORTED_MODULE_14_Participant_MyOrders__["b" /* ProductOrderDetail */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/confirmation/:orderId',component:__WEBPACK_IMPORTED_MODULE_15_features_Confirmation__["a" /* Confirmation */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/two-step-verification',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["g" /* TwoStepVerificationPage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/faq-two-step',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["d" /* FaqTwoStep */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/modal',component:__WEBPACK_IMPORTED_MODULE_12_loyal_react__["Modal"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/scheduling',component:__WEBPACK_IMPORTED_MODULE_17_Participant_Scheduling__["a" /* Scheduling */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/orders',component:__WEBPACK_IMPORTED_MODULE_18_features_User_Orders__["c" /* Orders */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/order',component:__WEBPACK_IMPORTED_MODULE_18_features_User_Orders__["a" /* Order */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/my-account/change-password',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["b" /* ChangePassword */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/security-access',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["f" /* SecurityAccessPage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/wishlist',component:__WEBPACK_IMPORTED_MODULE_19_Participant_Wishlist__["a" /* WishlistPage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/my-address',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["a" /* AddressPage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/extract',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["c" /* ExtractPage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/profile',component:__WEBPACK_IMPORTED_MODULE_16_Participant__["e" /* ProfilePage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/mobile-recharge',component:__WEBPACK_IMPORTED_MODULE_21_features_CellphoneRecharge__["a" /* Cellphonerecharge */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/confirmation-donation',component:__WEBPACK_IMPORTED_MODULE_20_features_ConfirmationDonation__["a" /* ConfirmationDonation */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/pointsandcash',component:__WEBPACK_IMPORTED_MODULE_28_features_PointsAndCash__["a" /* PointsAndCash */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/billpayment',component:__WEBPACK_IMPORTED_MODULE_23_features_BillPayment__["a" /* BillPaymentContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/fuelcredit',component:__WEBPACK_IMPORTED_MODULE_26_features_FuelCredit__["b" /* FuelCreditContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/donation',component:__WEBPACK_IMPORTED_MODULE_27_features_Donation__["a" /* DonationContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/stix',component:__WEBPACK_IMPORTED_MODULE_25_features_Stix__["b" /* StixContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/mileage',component:__WEBPACK_IMPORTED_MODULE_24_features_MileageRescue__["b" /* MileageContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/showcase',component:__WEBPACK_IMPORTED_MODULE_31_Catalog_Search__["e" /* ShowCase */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/search',component:__WEBPACK_IMPORTED_MODULE_31_Catalog_Search__["b" /* SearchPage */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/vendor',component:__WEBPACK_IMPORTED_MODULE_31_Catalog_Search__["d" /* SearchVendor */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/mobile-recharge/confirmation/:scheduleId',component:__WEBPACK_IMPORTED_MODULE_30_features_ConfirmationMobileRechargeSchedule__["a" /* ConfirmationMobileRechargeSchedule */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/cart',component:__WEBPACK_IMPORTED_MODULE_29_features_Cart__["b" /* CartContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/terms',component:Terms,isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/regulation',component:RegulationPage,isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/privacy',component:Privacy,isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/security',component:Security,isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/accessibility-status',component:__WEBPACK_IMPORTED_MODULE_34_features_Accessibility_AccessibilityIupp__["a" /* default */],isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{path:'/benefits',component:__WEBPACK_IMPORTED_MODULE_32_features_Benefits__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/redirect',component:__WEBPACK_IMPORTED_MODULE_33_features_RedirectCustom_RedirectCustom__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/purchase-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"],{to:'/checkout/points-purchase'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{path:'/guest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"],{to:'/'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell__["b" /* ShellRoute */],{component:__WEBPACK_IMPORTED_MODULE_5_App_FourOFour__["a" /* default */],isGuest:true})));};/* harmony default export */ __webpack_exports__["a"] = (AppRouter);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Auth_Zendesk_AuthRouter__ = __webpack_require__(781);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_Auth_Zendesk_AuthRouter__["a"]; });


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Auth_Zendesk_Login__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Auth_Zendesk_Callback__ = __webpack_require__(784);
var AuthRouter=function AuthRouter(_ref){var url=_ref.match.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/login',component:__WEBPACK_IMPORTED_MODULE_3_Auth_Zendesk_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/callback',component:__WEBPACK_IMPORTED_MODULE_4_Auth_Zendesk_Callback__["a" /* default */]}));};AuthRouter.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(AuthRouter));

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_App_Splash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_last_location__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_last_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Auth_Zendesk_userManager__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Login=function(_Component){_inherits(Login,_Component);function Login(parentContext){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this));_this.props=parentContext;_this.state={redirect:''};return _this;}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){var queryString=__webpack_require__(82);// eslint-disable-next-line camelcase
var _queryString$parse=queryString.parse(this.props.location.search),return_to=_queryString$parse.return_to;__WEBPACK_IMPORTED_MODULE_3_Auth_Zendesk_userManager__["a" /* default */].signinRedirect({state:return_to});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_App_Splash__["a" /* default */],{text:'Redirecionando para o login'});}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Login.propTypes={location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_last_location__["withLastLocation"])(Login));

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Auth_Zendesk_userManager__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_Splash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_simple__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_simple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jwt_simple__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Callback=function(_Component){_inherits(Callback,_Component);function Callback(){_classCallCheck(this,Callback);return _possibleConstructorReturn(this,(Callback.__proto__||Object.getPrototypeOf(Callback)).apply(this,arguments));}_createClass(Callback,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var user,subDomain,payload,redirectUrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_2_Auth_Zendesk_userManager__["a" /* default */].signinCallback();case 2:user=_context.sent;subDomain=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_URL;payload=generatePayload(user);redirectUrl=subDomain+'access/jwt?jwt='+payload+'&return_to='+user.state;window.location.href=redirectUrl;case 7:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_Splash__["a" /* default */],{text:'Estamos carregando a sua experi\xEAncia.'});}}]);return Callback;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var generatePayload=function generatePayload(user){var generateUUID=__webpack_require__(711);var payload={email:user?user.profile.email:'',name:user.profile&&user.profile.name?user.profile.name:user.profile.username,external_id:user?user.profile.username:'',jti:generateUUID.v4(),iat:Math.round(new Date().getTime()/1000)};var secret=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_SECRET;var token=__WEBPACK_IMPORTED_MODULE_6_jwt_simple___default.a.encode(payload,secret);return token;};var mapStateToProps=function mapStateToProps(_ref2){var oidc=_ref2.oidc;return{profile:oidc.user&&oidc.user.profile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectToLastLocation:function redirectToLastLocation(user){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["push"])(user.state));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Callback));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * jwt-simple
 *
 * JSON Web Token encode and decode module for node.js
 *
 * Copyright(c) 2011 Kazuhito Hokamura
 * MIT Licensed
 */

/**
 * module dependencies
 */
var crypto = __webpack_require__(788);


/**
 * support algorithm mapping
 */
var algorithmMap = {
  HS256: 'sha256',
  HS384: 'sha384',
  HS512: 'sha512',
  RS256: 'RSA-SHA256'
};

/**
 * Map algorithm to hmac or sign type, to determine which crypto function to use
 */
var typeMap = {
  HS256: 'hmac',
  HS384: 'hmac',
  HS512: 'hmac',
  RS256: 'sign'
};


/**
 * expose object
 */
var jwt = module.exports;


/**
 * version
 */
jwt.version = '0.5.6';

/**
 * Decode jwt
 *
 * @param {Object} token
 * @param {String} key
 * @param {Boolean} [noVerify]
 * @param {String} [algorithm]
 * @return {Object} payload
 * @api public
 */
jwt.decode = function jwt_decode(token, key, noVerify, algorithm) {
  // check token
  if (!token) {
    throw new Error('No token supplied');
  }
  // check segments
  var segments = token.split('.');
  if (segments.length !== 3) {
    throw new Error('Not enough or too many segments');
  }

  // All segment should be base64
  var headerSeg = segments[0];
  var payloadSeg = segments[1];
  var signatureSeg = segments[2];

  // base64 decode and parse JSON
  var header = JSON.parse(base64urlDecode(headerSeg));
  var payload = JSON.parse(base64urlDecode(payloadSeg));

  if (!noVerify) {
    if (!algorithm && /BEGIN( RSA)? PUBLIC KEY/.test(key.toString())) {
      algorithm = 'RS256';
    }

    var signingMethod = algorithmMap[algorithm || header.alg];
    var signingType = typeMap[algorithm || header.alg];
    if (!signingMethod || !signingType) {
      throw new Error('Algorithm not supported');
    }

    // verify signature. `sign` will return base64 string.
    var signingInput = [headerSeg, payloadSeg].join('.');
    if (!verify(signingInput, key, signingMethod, signingType, signatureSeg)) {
      throw new Error('Signature verification failed');
    }

    // Support for nbf and exp claims.
    // According to the RFC, they should be in seconds.
    if (payload.nbf && Date.now() < payload.nbf*1000) {
      throw new Error('Token not yet active');
    }

    if (payload.exp && Date.now() > payload.exp*1000) {
      throw new Error('Token expired');
    }
  }

  return payload;
};


/**
 * Encode jwt
 *
 * @param {Object} payload
 * @param {String} key
 * @param {String} algorithm
 * @param {Object} options
 * @return {String} token
 * @api public
 */
jwt.encode = function jwt_encode(payload, key, algorithm, options) {
  // Check key
  if (!key) {
    throw new Error('Require key');
  }

  // Check algorithm, default is HS256
  if (!algorithm) {
    algorithm = 'HS256';
  }

  var signingMethod = algorithmMap[algorithm];
  var signingType = typeMap[algorithm];
  if (!signingMethod || !signingType) {
    throw new Error('Algorithm not supported');
  }

  // header, typ is fixed value.
  var header = { typ: 'JWT', alg: algorithm };
  if (options && options.header) {
    assignProperties(header, options.header);
  }

  // create segments, all segments should be base64 string
  var segments = [];
  segments.push(base64urlEncode(JSON.stringify(header)));
  segments.push(base64urlEncode(JSON.stringify(payload)));
  segments.push(sign(segments.join('.'), key, signingMethod, signingType));

  return segments.join('.');
};

/**
 * private util functions
 */

function assignProperties(dest, source) {
  for (var attr in source) {
    if (source.hasOwnProperty(attr)) {
      dest[attr] = source[attr];
    }
  }
}

function verify(input, key, method, type, signature) {
  if(type === "hmac") {
    return (signature === sign(input, key, method, type));
  }
  else if(type == "sign") {
    return crypto.createVerify(method)
                 .update(input)
                 .verify(key, base64urlUnescape(signature), 'base64');
  }
  else {
    throw new Error('Algorithm type not recognized');
  }
}

function sign(input, key, method, type) {
  var base64str;
  if(type === "hmac") {
    base64str = crypto.createHmac(method, key).update(input).digest('base64');
  }
  else if(type == "sign") {
    base64str = crypto.createSign(method).update(input).sign(key, 'base64');
  }
  else {
    throw new Error('Algorithm type not recognized');
  }

  return base64urlEscape(base64str);
}

function base64urlDecode(str) {
  return Buffer.from(base64urlUnescape(str), 'base64').toString();
}

function base64urlUnescape(str) {
  str += new Array(5 - str.length % 4).join('=');
  return str.replace(/\-/g, '+').replace(/_/g, '/');
}

function base64urlEncode(str) {
  return base64urlEscape(Buffer.from(str).toString('base64'));
}

function base64urlEscape(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 787 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(120)
exports.createHash = exports.Hash = __webpack_require__(139)
exports.createHmac = exports.Hmac = __webpack_require__(395)

var algos = __webpack_require__(804)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(398)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(806)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(821)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(826)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(860)

var publicEncrypt = __webpack_require__(861)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(864)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 789 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(245).Buffer;
var util = __webpack_require__(791);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(36)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(392);

/*<replacement>*/
var util = __webpack_require__(140);
util.inherits = __webpack_require__(11);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(246);


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(94);


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(244).Transform


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(244).PassThrough


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(121)
var Buffer = __webpack_require__(15).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(121)
var Buffer = __webpack_require__(15).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(11)
var Sha256 = __webpack_require__(393)
var Hash = __webpack_require__(121)
var Buffer = __webpack_require__(15).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11)
var SHA512 = __webpack_require__(394)
var Hash = __webpack_require__(121)
var Buffer = __webpack_require__(15).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var Buffer = __webpack_require__(15).Buffer

var Base = __webpack_require__(84)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(397)


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(399)
var defaultEncoding = __webpack_require__(400)
var sync = __webpack_require__(401)
var Buffer = __webpack_require__(15).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(36)))

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(807)
var aes = __webpack_require__(251)
var aesModes = __webpack_require__(252)
var desModes = __webpack_require__(820)
var ebtk = __webpack_require__(184)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(84)
var des = __webpack_require__(808)
var inherits = __webpack_require__(11)
var Buffer = __webpack_require__(15).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(402);
exports.Cipher = __webpack_require__(250);
exports.DES = __webpack_require__(403);
exports.CBC = __webpack_require__(809);
exports.EDE = __webpack_require__(810);


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(52);
var inherits = __webpack_require__(11);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(52);
var inherits = __webpack_require__(11);

var Cipher = __webpack_require__(250);
var DES = __webpack_require__(403);

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(252)
var AuthCipher = __webpack_require__(407)
var Buffer = __webpack_require__(15).Buffer
var StreamCipher = __webpack_require__(408)
var Transform = __webpack_require__(84)
var aes = __webpack_require__(183)
var ebtk = __webpack_require__(184)
var inherits = __webpack_require__(11)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 812 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(141)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer
var xor = __webpack_require__(141)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(141)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(15).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(407)
var Buffer = __webpack_require__(15).Buffer
var MODES = __webpack_require__(252)
var StreamCipher = __webpack_require__(408)
var Transform = __webpack_require__(84)
var aes = __webpack_require__(183)
var ebtk = __webpack_require__(184)
var inherits = __webpack_require__(11)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 820 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(409)
var primes = __webpack_require__(824)

var DH = __webpack_require__(825)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 822 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 823 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(33);
var MillerRabin = __webpack_require__(410);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(409);
var randomBytes = __webpack_require__(120);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(139)
var stream = __webpack_require__(243)
var inherits = __webpack_require__(11)
var sign = __webpack_require__(827)
var verify = __webpack_require__(859)

var algorithms = __webpack_require__(397)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(395)
var crt = __webpack_require__(254)
var EC = __webpack_require__(255).ec
var BN = __webpack_require__(33)
var parseKeys = __webpack_require__(186)
var curves = __webpack_require__(420)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.4","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.6.0","mocha":"^6.1.4"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(53);
var BN = __webpack_require__(33);
var inherits = __webpack_require__(11);
var Base = __webpack_require__(185);

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var inherits = __webpack_require__(11);
var Base = __webpack_require__(185);

var utils = __webpack_require__(53);

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(53);
var BN = __webpack_require__(33);
var inherits = __webpack_require__(11);
var Base = __webpack_require__(185);

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(833);
exports.sha224 = __webpack_require__(834);
exports.sha256 = __webpack_require__(414);
exports.sha384 = __webpack_require__(835);
exports.sha512 = __webpack_require__(415);


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var common = __webpack_require__(142);
var shaCommon = __webpack_require__(413);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var SHA256 = __webpack_require__(414);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);

var SHA512 = __webpack_require__(415);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var common = __webpack_require__(142);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(69);
var assert = __webpack_require__(52);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var HmacDRBG = __webpack_require__(840);
var utils = __webpack_require__(53);
var curves = __webpack_require__(256);
var rand = __webpack_require__(253);
var assert = utils.assert;

var KeyPair = __webpack_require__(841);
var Signature = __webpack_require__(842);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(257);
var utils = __webpack_require__(411);
var assert = __webpack_require__(52);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var utils = __webpack_require__(53);
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);

var utils = __webpack_require__(53);
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(257);
var curves = __webpack_require__(256);
var utils = __webpack_require__(53);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(844);
var Signature = __webpack_require__(845);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(53);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(33);
var utils = __webpack_require__(53);
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(143)

exports.certificate = __webpack_require__(856)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(143);
var inherits = __webpack_require__(11);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(848).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 848 */
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(144).Reporter;
var EncoderBuffer = __webpack_require__(144).EncoderBuffer;
var DecoderBuffer = __webpack_require__(144).DecoderBuffer;
var assert = __webpack_require__(52);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(417);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(418);
decoders.pem = __webpack_require__(853);


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Buffer = __webpack_require__(23).Buffer;

var DERDecoder = __webpack_require__(418);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(419);
encoders.pem = __webpack_require__(855);


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

var DEREncoder = __webpack_require__(419);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(143)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(184)
var ciphers = __webpack_require__(251)
var Buffer = __webpack_require__(15).Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(33)
var EC = __webpack_require__(255).ec
var parseKeys = __webpack_require__(186)
var curves = __webpack_require__(420)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(255)
var BN = __webpack_require__(33)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).Buffer))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(862)
exports.privateDecrypt = __webpack_require__(863)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(186)
var randomBytes = __webpack_require__(120)
var createHash = __webpack_require__(139)
var mgf = __webpack_require__(421)
var xor = __webpack_require__(422)
var BN = __webpack_require__(33)
var withPublic = __webpack_require__(423)
var crt = __webpack_require__(254)
var Buffer = __webpack_require__(15).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(186)
var mgf = __webpack_require__(421)
var xor = __webpack_require__(422)
var BN = __webpack_require__(33)
var crt = __webpack_require__(254)
var createHash = __webpack_require__(139)
var withPublic = __webpack_require__(423)
var Buffer = __webpack_require__(15).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(15)
var randombytes = __webpack_require__(120)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(36)))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(424);
var bytesToUuid = __webpack_require__(425);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(424);
var bytesToUuid = __webpack_require__(425);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_Shell__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_Splash__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Wishlist_ducks__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Catalog_ducks__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Participant_ducks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_features_Balance__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_features_CardBrands__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_App_MainMenu__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Checkout_PointsPurchase_ducks__ = __webpack_require__(262);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AuthedShell=function(_Component){_inherits(AuthedShell,_Component);function AuthedShell(){_classCallCheck(this,AuthedShell);return _possibleConstructorReturn(this,(AuthedShell.__proto__||Object.getPrototypeOf(AuthedShell)).apply(this,arguments));}_createClass(AuthedShell,[{key:'loadAuthedShell',value:function loadAuthedShell(){var _props=this.props,profile=_props.profile,loadWishlist=_props.loadWishlist,loadCatalog=_props.loadCatalog,loadParticipant=_props.loadParticipant,loadCategories=_props.loadCategories,loadCardBrands=_props.loadCardBrands,loadBalance=_props.loadBalance,loadStores=_props.loadStores,loadPurchasePointsConfiguration=_props.loadPurchasePointsConfiguration;loadCatalog();loadParticipant();loadBalance();loadWishlist();loadStores(profile['custom:catalog_id']);loadCategories();loadCardBrands();loadPurchasePointsConfiguration();}},{key:'componentDidMount',value:function componentDidMount(){this.loadAuthedShell();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props2=this.props,isLoadedCatalog=_props2.isLoadedCatalog,isLoadingCatalog=_props2.isLoadingCatalog;if(!isLoadedCatalog&&!isLoadingCatalog){this.loadAuthedShell();}}},{key:'render',value:function render(){var _props3=this.props,children=_props3.children,profile=_props3.profile,isLoadingCatalog=_props3.isLoadingCatalog;return isLoadingCatalog?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Splash__["a" /* default */],{text:'Estamos carregando sua experi\xEAncia'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_Shell__["a" /* Shell */],{profile:profile},children);}}]);return AuthedShell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AuthedShell.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loadWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadCatalog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isLoadingCatalog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoadedCatalog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadCategories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadCardBrands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadBalance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadStores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadPurchasePointsConfiguration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref){var catalog=_ref.catalog;var isLoadingCatalog=catalog.isLoading,isLoadedCatalog=catalog.isLoaded;return{isLoadingCatalog:isLoadingCatalog,isLoadedCatalog:isLoadedCatalog};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadWishlist:function loadWishlist(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Wishlist_ducks__["c" /* fetchWishlist */])());},loadCatalog:function loadCatalog(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Catalog_ducks__["b" /* fetchCatalog */])());},loadParticipant:function loadParticipant(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Participant_ducks__["e" /* fetchParticipant */])());},loadCardBrands:function loadCardBrands(){return dispatch(__WEBPACK_IMPORTED_MODULE_9_features_CardBrands__["b" /* actions */].fetchCardBrands());},loadStores:function loadStores(catalogId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_App_MainMenu__["d" /* StoresAction */])(catalogId));},loadCategories:function loadCategories(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_App_MainMenu__["c" /* ProductCategoryAction */])());},loadBalance:function loadBalance(){return dispatch(__WEBPACK_IMPORTED_MODULE_8_features_Balance__["a" /* actions */].loadBalance());},loadPurchasePointsConfiguration:function loadPurchasePointsConfiguration(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_Checkout_PointsPurchase_ducks__["d" /* fetchPointPurchaseConfiguration */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(AuthedShell));

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var bind = __webpack_require__(428);
var Axios = __webpack_require__(870);
var defaults = __webpack_require__(260);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(432);
axios.CancelToken = __webpack_require__(883);
axios.isCancel = __webpack_require__(431);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(884);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

'use strict';

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(260);
var utils = __webpack_require__(54);
var InterceptorManager = __webpack_require__(878);
var dispatchRequest = __webpack_require__(879);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(430);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);
var transformData = __webpack_require__(880);
var isCancel = __webpack_require__(431);
var defaults = __webpack_require__(260);
var isAbsoluteURL = __webpack_require__(881);
var combineURLs = __webpack_require__(882);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(54);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(432);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,pointsValue:0};var action=arguments[1];switch(action.type){case'LOAD_BALANCE':return Object.assign({},state,{isLoading:true});case'LOAD_BALANCE_SUCCESS':return Object.assign({},state,{isLoading:false},action.payload.data);case'LOAD_BALANCE_FAIL':return Object.assign({},state,{isLoading:false,error:action.error.data});case'LOAD_BALANCE_CACHED_SUCCESS':return Object.assign({},state,{isLoading:false,pointsValue:action.payload.data});case'LOAD_BALANCE_CACHED_FAIL':return Object.assign({},state,{isLoading:false,error:action.error.data});default:return Object.assign({},state);}});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadBalance */
var loadBalance=function loadBalance(){return{type:'LOAD_BALANCE',payload:{client:'cloudloyalty',request:{url:'/v1/participants/me/simpleBalance'}}};};/* harmony default export */ __webpack_exports__["a"] = ({loadBalance:loadBalance});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Cardbrands=function Cardbrands(_ref){var brands=_ref.brands;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-brands-icons row pt-half pt-md-1 px-half justify-content-end'},brands.map(function(_ref2){var id=_ref2.id,imageUrl=_ref2.imageUrl,name=_ref2.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 px-half',key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'w-100',src:imageUrl,alt:name}));}));};var brandType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});Cardbrands.propTypes={brands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(brandType).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Cardbrands);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchCardBrands */
var fetchCardBrands=function fetchCardBrands(){return{type:'FETCH_CARD_BRANDS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/configurations/cardBrands'}}};};/* harmony default export */ __webpack_exports__["a"] = ({fetchCardBrands:fetchCardBrands});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,brands:[]};var action=arguments[1];switch(action.type){case'FETCH_CARD_BRANDS':return Object.assign({},state,{isLoading:true});case'FETCH_CARD_BRANDS_SUCCESS':return Object.assign({},state,{isLoading:false,brands:action.payload.data});case'FETCH_CARD_BRANDS_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});default:return Object.assign({},state);}});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategoryMenuItems__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CategoryMenuType__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_responsive__);
var checkMenuContext=function checkMenuContext(onlyCash){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var currentContext=onlyCash?'cash':'points';return context.indexOf(currentContext)>-1;};var CategoryMenuWrapper=function CategoryMenuWrapper(_ref){var onlyCash=_ref.onlyCash,context=_ref.context,children=_ref.children;return checkMenuContext(onlyCash,context)?children:null;};var formatSubItems=function formatSubItems(dynamicAction,productCategories,stores,items){var itemsMenu=[];if(dynamicAction==='loadCategories'){productCategories.items.slice(0,10).map(function(st){return itemsMenu.push({label:st.name,className:'',path:'/search?category='+st.id});});itemsMenu.length>=10&&itemsMenu.push({label:'Ver todos',parentClassName:'hover-ver-todos py-1 border-top border-color-ui-3',className:'ver-todos txt-font-body-bold color-brand-1',path:'/categories'});}if(dynamicAction==='loadEcommerceStores'){stores.ecommerce.slice(0,10).map(function(st){return itemsMenu.push({label:st.name,className:'',path:'/vendor?vendor='+st.supplierId});});itemsMenu.length>=10&&itemsMenu.push({label:'Ver todos',parentClassName:'hover-ver-todos py-1 border-top border-color-ui-3',className:'ver-todos txt-font-body-bold color-brand-1',path:'/stores'});}if(dynamicAction==='loadVouchersStores'){stores.vouchers.slice(0,10).map(function(st){return itemsMenu.push({label:st.name,className:'',path:'/vendor?vendor='+st.supplierId});});itemsMenu.length>=10&&itemsMenu.push({label:'Ver todos',parentClassName:'hover-ver-todos py-1 border-top border-color-ui-3',className:'txt-font-body-bold',path:'/stores/vouchers'});}if(dynamicAction===null){var labelSeeAll=['Ver todos','Ver todas as categorias','Ver todos os itens'];items.length>0&&items.map(function(st){return labelSeeAll.indexOf(st.label)===-1?itemsMenu.push(Object.assign({},st)):itemsMenu.push(Object.assign({},st,{parentClassName:'hover-ver-todos py-1 border-top border-color-ui-3',className:'txt-font-body-bold py-1'}));});}return itemsMenu;};var CategoryMenu=function CategoryMenu(_ref2){var menus=_ref2.menus,onlyCash=_ref2.onlyCash,productCategories=_ref2.productCategories,stores=_ref2.stores;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minWidth:600,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'primary-menu mx-0'},menus&&menus.map(function(_ref3,index){var label=_ref3.label,enabled=_ref3.enabled,type=_ref3.type,path=_ref3.path,sku=_ref3.sku,items=_ref3.items,context=_ref3.context,dynamicAction=_ref3.dynamicAction;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CategoryMenuWrapper,{onlyCash:onlyCash,context:context},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 cat-'+__WEBPACK_IMPORTED_MODULE_5_react_slugify___default()(label,{delimiter:'-'}),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CategoryMenuType__["a" /* default */],{type:type,sku:sku,path:path,label:label,enabled:enabled,className:'txt-uppercase txt-font-body '+type}),typeof dynamicAction!=='undefined'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CategoryMenuItems__["a" /* CategoryMenuItems */],{type:type,items:formatSubItems(dynamicAction,productCategories,stores,items),dynamicAction:dynamicAction,indexParent:index}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CategoryMenuItems__["a" /* CategoryMenuItems */],{type:type,items:formatSubItems(null,productCategories,stores,items),dynamicAction:dynamicAction,indexParent:index})));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'primary-menu row mx-0'},menus&&menus.map(function(_ref4,index){var label=_ref4.label,enabled=_ref4.enabled,type=_ref4.type,path=_ref4.path,sku=_ref4.sku,items=_ref4.items,context=_ref4.context,dynamicAction=_ref4.dynamicAction;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CategoryMenuWrapper,{onlyCash:onlyCash,context:context},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-auto px-1 cat-'+__WEBPACK_IMPORTED_MODULE_5_react_slugify___default()(label,{delimiter:'-'}),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CategoryMenuType__["a" /* default */],{type:type,sku:sku,path:path,label:label,enabled:enabled,className:'txt-uppercase txt-font-body '+type}),typeof dynamicAction!=='undefined'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CategoryMenuItems__["a" /* CategoryMenuItems */],{type:type,items:formatSubItems(dynamicAction,productCategories,stores,items),dynamicAction:dynamicAction,indexParent:index}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CategoryMenuItems__["a" /* CategoryMenuItems */],{type:type,items:formatSubItems(null,productCategories,stores,items),dynamicAction:dynamicAction,indexParent:index})));}))));};CategoryMenu.propTypes={menus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_2__CategoryMenuItems__["a" /* CategoryMenuItems */].propTypes)).isRequired,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,productCategories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref5){var productCategories=_ref5.productCategories,stores=_ref5.stores;return{productCategories:productCategories,stores:stores};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,null)(CategoryMenu));

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryMenuItems__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CategoryMenuItems__["a"]; });


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(434);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryMenuItems=function(_Component){_inherits(CategoryMenuItems,_Component);function CategoryMenuItems(props){_classCallCheck(this,CategoryMenuItems);var _this=_possibleConstructorReturn(this,(CategoryMenuItems.__proto__||Object.getPrototypeOf(CategoryMenuItems)).call(this,props));_this.state={showSubmenu:''};_this.hideSubmenu=_this.hideSubmenu.bind(_this);_this.showSubmenu=_this.showSubmenu.bind(_this);return _this;}_createClass(CategoryMenuItems,[{key:'hideSubmenu',value:function hideSubmenu(){this.setState({showSubmenu:''});}},{key:'showSubmenu',value:function showSubmenu(currentId){this.setState({showSubmenu:currentId});var linkSubmenu=document.querySelectorAll('.item-checked ~ .submenuCategories .link-profile');Array.from(linkSubmenu).forEach(function(link){link.addEventListener('blur',function(event){setTimeout(function(){if(document.querySelectorAll('.item-checked ~ .submenuCategories .link-profile:focus').length===0){if(document.querySelectorAll('.item-checked').length>0){var itemsChecked=document.querySelector('.item-with-submenu.item-checked');document.querySelector('.item-checked ~ input[type="radio"]:checked').checked=false;itemsChecked.classList.remove('item-checked');}}},300);});});}},{key:'checkAllowedTypes',value:function checkAllowedTypes(type){switch(type.toLowerCase()){case'category':case'sub-category':case'dynamic':case'services':case'services-external':return true;default:return false;}}},{key:'render',value:function render(){var _this2=this;return this.props.items.length>0&&this.checkAllowedTypes(this.props.type)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submenu zindex-high txt-left radius pt-1 pb-0 '+this.props.className,onMouseEnter:function onMouseEnter(){return _this2.hideSubmenu();}},this.props.items.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-left p-0 m-0 pos-initial'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MenuItem__["a" /* MenuItem */],Object.assign({key:index,indexParent:_this2.props.indexParent,indexItem:index,type:ele.type||_this2.props.type},ele,{hasItems:ele.items&&ele.items.length>0,showSubmenu:_this2.showSubmenu,checked:_this2.state.showSubmenu===(ele.type||_this2.props.type)+'_'+_this2.props.indexParent+'_'+index})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{checked:_this2.state.showSubmenu===(ele.type||_this2.props.type)+'_'+_this2.props.indexParent+'_'+index,className:'d-none submenuCategories-radio',type:'radio',id:(ele.type||_this2.props.type)+'_'+_this2.props.indexParent+'_'+index,name:'submenuCategories-radio'}),ele.items&&ele.items.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'aria-hidden':_this2.state.showSubmenu!==(ele.type||_this2.props.type)+'_'+_this2.props.indexParent+'_'+index,'aria-label':ele.label,id:'submenu-'+(ele.type||_this2.props.type)+'_'+_this2.props.indexParent+'_'+index,className:'submenuCategories bg-white',onClick:function onClick(){return _this2.hideSubmenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MenuItem__["b" /* SubMenu */],{parentLabel:ele.label,indexParent:_this2.props.indexParent,indexItem:index,type:ele.type||_this2.props.type,items:ele.items,hideSubmenu:_this2.hideSubmenu,path:ele.path})):'');})):null;}}]);return CategoryMenuItems;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CategoryMenuItems.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_2__MenuItem__["a" /* MenuItem */].propTypes)).isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,indexParent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (CategoryMenuItems);

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = filterInvalidDOMProps;

var _htmlAttributes = __webpack_require__(894);

var _htmlAttributes2 = _interopRequireDefault(_htmlAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventProps = {
	onCopy: true,
	onCut: true,
	onPaste: true,
	onLoad: true,
	onError: true,
	onWheel: true,
	onScroll: true,
	onCompositionEnd: true,
	onCompositionStart: true,
	onCompositionUpdate: true,
	onKeyDown: true,
	onKeyPress: true,
	onKeyUp: true,
	onFocus: true,
	onBlur: true,
	onChange: true,
	onInput: true,
	onSubmit: true,
	onClick: true,
	onContextMenu: true,
	onDoubleClick: true,
	onDrag: true,
	onDragEnd: true,
	onDragEnter: true,
	onDragExit: true,
	onDragLeave: true,
	onDragOver: true,
	onDragStart: true,
	onDrop: true,
	onMouseDown: true,
	onMouseEnter: true,
	onMouseLeave: true,
	onMouseMove: true,
	onMouseOut: true,
	onMouseOver: true,
	onMouseUp: true,
	onSelect: true,
	onTouchCancel: true,
	onTouchEnd: true,
	onTouchMove: true,
	onTouchStart: true,
	onAnimationStart: true,
	onAnimationEnd: true,
	onAnimationIteration: true,
	onTransitionEnd: true
};

function isValidDOMProp(prop) {
	return eventProps[prop] || _htmlAttributes2.default[prop];
}

function filterInvalidDOMProps(props) {
	var domProps = {};
	for (var prop in props) {
		if (props.hasOwnProperty(prop) && isValidDOMProp(prop)) {
			domProps[prop] = props[prop];
		}
	}
	return domProps;
}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

/*!
 * html-attributes
 * https://github.com/alexmingoia/html-attributes
 */

/**
 * @module html-attributes
 */

module.exports = {
  "abbr": "abbr",
  "accept": "accept",
  "acceptCharset": "accept-charset",
  "accessKey": "accesskey",
  "action": "action",
  "allowFullScreen": "allowfullscreen",
  "allowTransparency": "allowtransparency",
  "alt": "alt",
  "async": "async",
  "autoComplete": "autocomplete",
  "autoFocus": "autofocus",
  "autoPlay": "autoplay",
  "cellPadding": "cellpadding",
  "cellSpacing": "cellspacing",
  "challenge": "challenge",
  "charset": "charset",
  "checked": "checked",
  "cite": "cite",
  "class": "class",
  "className": "class",
  "cols": "cols",
  "colSpan": "colspan",
  "command": "command",
  "content": "content",
  "contentEditable": "contenteditable",
  "contextMenu": "contextmenu",
  "controls": "controls",
  "coords": "coords",
  "crossOrigin": "crossorigin",
  "data": "data",
  "dateTime": "datetime",
  "default": "default",
  "defer": "defer",
  "dir": "dir",
  "disabled": "disabled",
  "download": "download",
  "draggable": "draggable",
  "dropzone": "dropzone",
  "encType": "enctype",
  "for": "for",
  "form": "form",
  "formAction": "formaction",
  "formEncType": "formenctype",
  "formMethod": "formmethod",
  "formNoValidate": "formnovalidate",
  "formTarget": "formtarget",
  "frameBorder": "frameBorder",
  "headers": "headers",
  "height": "height",
  "hidden": "hidden",
  "high": "high",
  "href": "href",
  "hrefLang": "hreflang",
  "htmlFor": "for",
  "httpEquiv": "http-equiv",
  "icon": "icon",
  "id": "id",
  "inputMode": "inputmode",
  "isMap": "ismap",
  "itemId": "itemid",
  "itemProp": "itemprop",
  "itemRef": "itemref",
  "itemScope": "itemscope",
  "itemType": "itemtype",
  "kind": "kind",
  "label": "label",
  "lang": "lang",
  "list": "list",
  "loop": "loop",
  "manifest": "manifest",
  "max": "max",
  "maxLength": "maxlength",
  "media": "media",
  "mediaGroup": "mediagroup",
  "method": "method",
  "min": "min",
  "minLength": "minlength",
  "multiple": "multiple",
  "muted": "muted",
  "name": "name",
  "noValidate": "novalidate",
  "open": "open",
  "optimum": "optimum",
  "pattern": "pattern",
  "ping": "ping",
  "placeholder": "placeholder",
  "poster": "poster",
  "preload": "preload",
  "radioGroup": "radiogroup",
  "readOnly": "readonly",
  "rel": "rel",
  "required": "required",
  "role": "role",
  "rows": "rows",
  "rowSpan": "rowspan",
  "sandbox": "sandbox",
  "scope": "scope",
  "scoped": "scoped",
  "scrolling": "scrolling",
  "seamless": "seamless",
  "selected": "selected",
  "shape": "shape",
  "size": "size",
  "sizes": "sizes",
  "sortable": "sortable",
  "span": "span",
  "spellCheck": "spellcheck",
  "src": "src",
  "srcDoc": "srcdoc",
  "srcSet": "srcset",
  "start": "start",
  "step": "step",
  "style": "style",
  "tabIndex": "tabindex",
  "target": "target",
  "title": "title",
  "translate": "translate",
  "type": "type",
  "typeMustMatch": "typemustmatch",
  "useMap": "usemap",
  "value": "value",
  "width": "width",
  "wmode": "wmode",
  "wrap": "wrap"
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=8)}([function(e,t){e.exports=__webpack_require__(0)},function(e,t,r){e.exports=r(10)()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){return"undefined"!=typeof window&&"IntersectionObserver"in window&&"isIntersecting"in window.IntersectionObserverEntry.prototype}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),o=s(r(0)),i=r(1),a=s(r(4)),l=s(r(12)),u=s(r(2));function s(e){return e&&e.__esModule?e:{default:e}}var c=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var r=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),n=e.afterLoad,o=e.beforeLoad,i=e.scrollPosition,a=e.visibleByDefault;return r.state={visible:a},a&&(o(),n()),r.onVisible=r.onVisible.bind(r),r.isScrollTracked=i&&Number.isFinite(i.x)&&i.x>=0&&Number.isFinite(i.y)&&i.y>=0,r}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,o.default.Component),n(t,[{key:"componentDidUpdate",value:function(e,t){t.visible!==this.state.visible&&this.props.afterLoad()}},{key:"onVisible",value:function(){this.props.beforeLoad(),this.setState({visible:!0})}},{key:"render",value:function(){if(this.state.visible)return this.props.children;var e=this.props,t=e.className,r=e.height,n=e.placeholder,i=e.scrollPosition,s=e.style,c=e.threshold,f=e.width;return this.isScrollTracked||(0,u.default)()?o.default.createElement(a.default,{className:t,height:r,onVisible:this.onVisible,placeholder:n,scrollPosition:i,style:s,threshold:c,width:f}):o.default.createElement(l.default,{className:t,height:r,onVisible:this.onVisible,placeholder:n,style:s,threshold:c,width:f})}}]),t}();c.propTypes={afterLoad:i.PropTypes.func,beforeLoad:i.PropTypes.func,visibleByDefault:i.PropTypes.bool},c.defaultProps={afterLoad:function(){return{}},beforeLoad:function(){return{}},visibleByDefault:!1},t.default=c},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},o=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),i=s(r(0)),a=s(r(5)),l=r(1),u=s(r(2));function s(e){return e&&e.__esModule?e:{default:e}}var c=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var r=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),n=(0,u.default)();if(r.LAZY_LOAD_OBSERVER={supportsObserver:n},n){var o=e.threshold;r.LAZY_LOAD_OBSERVER.observer=new IntersectionObserver(r.checkIntersections,{rootMargin:o+"px"})}return r}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,i.default.Component),o(t,[{key:"checkIntersections",value:function(e){e.forEach(function(e){e.isIntersecting&&e.target.onVisible()})}},{key:"componentDidMount",value:function(){this.placeholder&&this.LAZY_LOAD_OBSERVER&&this.LAZY_LOAD_OBSERVER.observer&&(this.placeholder.onVisible=this.props.onVisible,this.LAZY_LOAD_OBSERVER.observer.observe(this.placeholder)),this.LAZY_LOAD_OBSERVER&&!this.LAZY_LOAD_OBSERVER.supportsObserver&&this.updateVisibility()}},{key:"componentWillUnMount",value:function(){this.LAZY_LOAD_OBSERVER&&this.LAZY_LOAD_OBSERVER.observer.unobserve(this.placeholder)}},{key:"componentDidUpdate",value:function(){this.LAZY_LOAD_OBSERVER&&!this.LAZY_LOAD_OBSERVER.supportsObserver&&this.updateVisibility()}},{key:"getPlaceholderBoundingBox",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.scrollPosition,t=this.placeholder.getBoundingClientRect(),r=a.default.findDOMNode(this.placeholder).style,n=parseInt(r.getPropertyValue("margin-left"),10)||0,o=parseInt(r.getPropertyValue("margin-top"),10)||0;return{bottom:e.y+t.bottom+o,left:e.x+t.left+n,right:e.x+t.right+n,top:e.y+t.top+o}}},{key:"isPlaceholderInViewport",value:function(){if("undefined"==typeof window||!this.placeholder)return!1;var e=this.props,t=e.scrollPosition,r=e.threshold,n=this.getPlaceholderBoundingBox(t),o=t.y+window.innerHeight,i=t.x,a=t.x+window.innerWidth,l=t.y;return Boolean(l-r<=n.bottom&&o+r>=n.top&&i-r<=n.right&&a+r>=n.left)}},{key:"updateVisibility",value:function(){this.isPlaceholderInViewport()&&this.props.onVisible()}},{key:"render",value:function(){var e=this,t=this.props,r=t.className,o=t.height,a=t.placeholder,l=t.style,u=t.width;return a&&"function"!=typeof a.type?i.default.cloneElement(a,{ref:function(t){return e.placeholder=t}}):i.default.createElement("span",{className:r,ref:function(t){return e.placeholder=t},style:n({display:"inline-block",height:o,width:u},l)},a)}}]),t}();c.propTypes={onVisible:l.PropTypes.func.isRequired,className:l.PropTypes.string,height:l.PropTypes.number,placeholder:l.PropTypes.element,threshold:l.PropTypes.number,scrollPosition:l.PropTypes.shape({x:l.PropTypes.number.isRequired,y:l.PropTypes.number.isRequired}),width:l.PropTypes.number},c.defaultProps={className:"",height:0,placeholder:null,threshold:100,width:0},t.default=c},function(e,t){e.exports=__webpack_require__(42)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},o=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),i=p(r(0)),a=p(r(5)),l=r(1),u=p(r(13)),s=p(r(14)),c=p(r(2)),f=p(r(15));function p(e){return e&&e.__esModule?e:{default:e}}function d(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var y=function(){return"undefined"==typeof window?0:window.scrollX||window.pageXOffset},h=function(){return"undefined"==typeof window?0:window.scrollY||window.pageYOffset};t.default=function(e){var t=function(t){function r(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,r);var t=d(this,(r.__proto__||Object.getPrototypeOf(r)).call(this,e));if((0,c.default)())return d(t);var n=t.onChangeScroll.bind(t);return"debounce"===e.delayMethod?t.delayedScroll=(0,u.default)(n,e.delayTime):"throttle"===e.delayMethod&&(t.delayedScroll=(0,s.default)(n,e.delayTime)),t.state={scrollPosition:{x:y(),y:h()}},t.baseComponentRef=i.default.createRef(),t}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(r,i.default.Component),o(r,[{key:"componentDidMount",value:function(){this.addListeners()}},{key:"componentWillUnmount",value:function(){this.removeListeners()}},{key:"componentDidUpdate",value:function(){"undefined"==typeof window||(0,c.default)()||(0,f.default)(a.default.findDOMNode(this.baseComponentRef.current))!==this.scrollElement&&(this.removeListeners(),this.addListeners())}},{key:"addListeners",value:function(){"undefined"==typeof window||(0,c.default)()||(this.scrollElement=(0,f.default)(a.default.findDOMNode(this.baseComponentRef.current)),this.scrollElement.addEventListener("scroll",this.delayedScroll),window.addEventListener("resize",this.delayedScroll),this.scrollElement!==window&&window.addEventListener("scroll",this.delayedScroll))}},{key:"removeListeners",value:function(){"undefined"==typeof window||(0,c.default)()||(this.scrollElement.removeEventListener("scroll",this.delayedScroll),window.removeEventListener("resize",this.delayedScroll),this.scrollElement!==window&&window.removeEventListener("scroll",this.delayedScroll))}},{key:"onChangeScroll",value:function(){(0,c.default)()||this.setState({scrollPosition:{x:y(),y:h()}})}},{key:"render",value:function(){var t=this.props,r=(t.delayMethod,t.delayTime,function(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}(t,["delayMethod","delayTime"])),o=(0,c.default)()?null:this.state.scrollPosition;return i.default.createElement(e,n({ref:this.baseComponentRef,scrollPosition:o},r))}}]),r}();return t.propTypes={delayMethod:l.PropTypes.oneOf(["debounce","throttle"]),delayTime:l.PropTypes.number},t.defaultProps={delayMethod:"throttle",delayTime:300},t}},function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(e){"object"==typeof window&&(r=window)}e.exports=r},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.trackWindowScroll=t.LazyLoadComponent=t.LazyLoadImage=void 0;var n=a(r(9)),o=a(r(3)),i=a(r(6));function a(e){return e&&e.__esModule?e:{default:e}}t.LazyLoadImage=n.default,t.LazyLoadComponent=o.default,t.trackWindowScroll=i.default},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},o=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),i=u(r(0)),a=r(1),l=u(r(3));function u(e){return e&&e.__esModule?e:{default:e}}var s=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var r=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={loaded:!1},r}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,i.default.Component),o(t,[{key:"onImageLoad",value:function(){var e=this;return this.state.loaded?null:function(){e.props.afterLoad(),e.setState({loaded:!0})}}},{key:"getImg",value:function(){var e=this.props,t=(e.afterLoad,e.beforeLoad,e.delayMethod,e.delayTime,e.effect,e.placeholder,e.placeholderSrc,e.scrollPosition,e.threshold,e.visibleByDefault,e.wrapperClassName,function(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}(e,["afterLoad","beforeLoad","delayMethod","delayTime","effect","placeholder","placeholderSrc","scrollPosition","threshold","visibleByDefault","wrapperClassName"]));return i.default.createElement("img",n({onLoad:this.onImageLoad()},t))}},{key:"getLazyLoadImage",value:function(e){var t=this.props,r=t.beforeLoad,n=t.className,o=t.delayMethod,a=t.delayTime,u=t.height,s=t.placeholder,c=t.scrollPosition,f=t.style,p=t.threshold,d=t.visibleByDefault,y=t.width;return i.default.createElement(l.default,{beforeLoad:r,className:n,delayMethod:o,delayTime:a,height:u,placeholder:s,scrollPosition:c,style:f,threshold:p,visibleByDefault:d,width:y},e)}},{key:"getWrappedLazyLoadImage",value:function(e){var t=this.props,r=t.effect,n=t.height,o=t.placeholderSrc,a=t.width,l=t.wrapperClassName,u=this.state.loaded,s=u?" lazy-load-image-loaded":"";return i.default.createElement("span",{className:l+" lazy-load-image-background "+r+s,style:{backgroundImage:u?"":"url( "+o+")",backgroundSize:u?"":"100% 100%",color:"transparent",display:"inline-block",height:n,width:a}},e)}},{key:"render",value:function(){var e=this.props,t=e.effect,r=e.placeholderSrc,n=e.visibleByDefault,o=this.state.loaded,i=this.getImg(),a=o?i:this.getLazyLoadImage(i);return!t&&!r||n?a:this.getWrappedLazyLoadImage(a)}}]),t}();s.propTypes={afterLoad:a.PropTypes.func,beforeLoad:a.PropTypes.func,delayMethod:a.PropTypes.string,delayTime:a.PropTypes.number,effect:a.PropTypes.string,placeholderSrc:a.PropTypes.string,threshold:a.PropTypes.number,visibleByDefault:a.PropTypes.bool,wrapperClassName:a.PropTypes.string},s.defaultProps={afterLoad:function(){return{}},beforeLoad:function(){return{}},delayMethod:"throttle",delayTime:300,effect:"",placeholderSrc:"",threshold:100,visibleByDefault:!1,wrapperClassName:""},t.default=s},function(e,t,r){"use strict";var n=r(11);function o(){}e.exports=function(){function e(e,t,r,o,i,a){if(a!==n){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=o,r.PropTypes=r,r}},function(e,t,r){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),o=l(r(0)),i=l(r(4)),a=l(r(6));function l(e){return e&&e.__esModule?e:{default:e}}var u=function(e){function t(e){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e))}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,o.default.Component),n(t,[{key:"render",value:function(){return o.default.createElement(i.default,this.props)}}]),t}();t.default=(0,a.default)(u)},function(e,t,r){(function(t){var r="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,l=/^0b[01]+$/i,u=/^0o[0-7]+$/i,s=parseInt,c="object"==typeof t&&t&&t.Object===Object&&t,f="object"==typeof self&&self&&self.Object===Object&&self,p=c||f||Function("return this")(),d=Object.prototype.toString,y=Math.max,h=Math.min,b=function(){return p.Date.now()};function v(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function m(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&d.call(e)==o}(e))return n;if(v(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=v(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var r=l.test(e);return r||u.test(e)?s(e.slice(2),r?2:8):a.test(e)?n:+e}e.exports=function(e,t,n){var o,i,a,l,u,s,c=0,f=!1,p=!1,d=!0;if("function"!=typeof e)throw new TypeError(r);function w(t){var r=o,n=i;return o=i=void 0,c=t,l=e.apply(n,r)}function O(e){var r=e-s;return void 0===s||r>=t||r<0||p&&e-c>=a}function g(){var e=b();if(O(e))return _(e);u=setTimeout(g,function(e){var r=t-(e-s);return p?h(r,a-(e-c)):r}(e))}function _(e){return u=void 0,d&&o?w(e):(o=i=void 0,l)}function P(){var e=b(),r=O(e);if(o=arguments,i=this,s=e,r){if(void 0===u)return function(e){return c=e,u=setTimeout(g,t),f?w(e):l}(s);if(p)return u=setTimeout(g,t),w(s)}return void 0===u&&(u=setTimeout(g,t)),l}return t=m(t)||0,v(n)&&(f=!!n.leading,a=(p="maxWait"in n)?y(m(n.maxWait)||0,t):a,d="trailing"in n?!!n.trailing:d),P.cancel=function(){void 0!==u&&clearTimeout(u),c=0,o=s=i=u=void 0},P.flush=function(){return void 0===u?l:_(b())},P}}).call(this,r(7))},function(e,t,r){(function(t){var r="Expected a function",n=NaN,o="[object Symbol]",i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,l=/^0b[01]+$/i,u=/^0o[0-7]+$/i,s=parseInt,c="object"==typeof t&&t&&t.Object===Object&&t,f="object"==typeof self&&self&&self.Object===Object&&self,p=c||f||Function("return this")(),d=Object.prototype.toString,y=Math.max,h=Math.min,b=function(){return p.Date.now()};function v(e,t,n){var o,i,a,l,u,s,c=0,f=!1,p=!1,d=!0;if("function"!=typeof e)throw new TypeError(r);function v(t){var r=o,n=i;return o=i=void 0,c=t,l=e.apply(n,r)}function O(e){var r=e-s;return void 0===s||r>=t||r<0||p&&e-c>=a}function g(){var e=b();if(O(e))return _(e);u=setTimeout(g,function(e){var r=t-(e-s);return p?h(r,a-(e-c)):r}(e))}function _(e){return u=void 0,d&&o?v(e):(o=i=void 0,l)}function P(){var e=b(),r=O(e);if(o=arguments,i=this,s=e,r){if(void 0===u)return function(e){return c=e,u=setTimeout(g,t),f?v(e):l}(s);if(p)return u=setTimeout(g,t),v(s)}return void 0===u&&(u=setTimeout(g,t)),l}return t=w(t)||0,m(n)&&(f=!!n.leading,a=(p="maxWait"in n)?y(w(n.maxWait)||0,t):a,d="trailing"in n?!!n.trailing:d),P.cancel=function(){void 0!==u&&clearTimeout(u),c=0,o=s=i=u=void 0},P.flush=function(){return void 0===u?l:_(b())},P}function m(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function w(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&d.call(e)==o}(e))return n;if(m(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=m(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var r=l.test(e);return r||u.test(e)?s(e.slice(2),r?2:8):a.test(e)?n:+e}e.exports=function(e,t,n){var o=!0,i=!0;if("function"!=typeof e)throw new TypeError(r);return m(n)&&(o="leading"in n?!!n.leading:o,i="trailing"in n?!!n.trailing:i),v(e,t,{leading:o,maxWait:t,trailing:i})}}).call(this,r(7))},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t){return"undefined"==typeof getComputedStyle?e.style[t]:getComputedStyle(e,null).getPropertyValue(t)},o=function(e){return n(e,"overflow")+n(e,"overflow-y")+n(e,"overflow-x")};t.default=function(e){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t!==document.body&&t!==document.documentElement&&t.parentNode;){if(/(scroll|auto)/.test(o(t)))return t;t=t.parentNode}return window}}]);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2017 Kris Kowal under the terms of the MIT
 * license found at https://github.com/kriskowal/q/blob/v1/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    "use strict";

    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.

    // Montage Require
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);

    // CommonJS
    } else if (true) {
        module.exports = definition();

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
        define(definition);

    // SES (Secure EcmaScript)
    } else if (typeof ses !== "undefined") {
        if (!ses.ok()) {
            return;
        } else {
            ses.makeQ = definition;
        }

    // <script>
    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
        // Prefer window over self for add-on scripts. Use self for
        // non-windowed contexts.
        var global = typeof window !== "undefined" ? window : self;

        // Get the `window` object, save the previous Q global
        // and initialize Q as a global.
        var previousQ = global.Q;
        global.Q = definition();

        // Add a noConflict function so Q can be removed from the
        // global namespace.
        global.Q.noConflict = function () {
            global.Q = previousQ;
            return this;
        };

    } else {
        throw new Error("This environment was not anticipated by Q. Please file a bug.");
    }

})(function () {
"use strict";

var hasStacks = false;
try {
    throw new Error();
} catch (e) {
    hasStacks = !!e.stack;
}

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// Use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick =(function () {
    // linked list of tasks (single, with head node)
    var head = {task: void 0, next: null};
    var tail = head;
    var flushing = false;
    var requestTick = void 0;
    var isNodeJS = false;
    // queue for late tasks, used by unhandled rejection tracking
    var laterQueue = [];

    function flush() {
        /* jshint loopfunc: true */
        var task, domain;

        while (head.next) {
            head = head.next;
            task = head.task;
            head.task = void 0;
            domain = head.domain;

            if (domain) {
                head.domain = void 0;
                domain.enter();
            }
            runSingle(task, domain);

        }
        while (laterQueue.length) {
            task = laterQueue.pop();
            runSingle(task);
        }
        flushing = false;
    }
    // runs a single function in the async queue
    function runSingle(task, domain) {
        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function () {
                    throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    nextTick = function (task) {
        tail = tail.next = {
            task: task,
            domain: isNodeJS && process.domain,
            next: null
        };

        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };

    if (typeof process === "object" &&
        process.toString() === "[object process]" && process.nextTick) {
        // Ensure Q is in a real Node environment, with a `process.nextTick`.
        // To see through fake Node environments:
        // * Mocha test runner - exposes a `process` global without a `nextTick`
        // * Browserify - exposes a `process.nexTick` function that uses
        //   `setTimeout`. In this case `setImmediate` is preferred because
        //    it is faster. Browserify's `process.toString()` yields
        //   "[object Object]", while in a real Node environment
        //   `process.toString()` yields "[object process]".
        isNodeJS = true;

        requestTick = function () {
            process.nextTick(flush);
        };

    } else if (typeof setImmediate === "function") {
        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
        if (typeof window !== "undefined") {
            requestTick = setImmediate.bind(window, flush);
        } else {
            requestTick = function () {
                setImmediate(flush);
            };
        }

    } else if (typeof MessageChannel !== "undefined") {
        // modern browsers
        // http://www.nonblocking.io/2011/06/windownexttick.html
        var channel = new MessageChannel();
        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
        // working message ports the first time a page loads.
        channel.port1.onmessage = function () {
            requestTick = requestPortTick;
            channel.port1.onmessage = flush;
            flush();
        };
        var requestPortTick = function () {
            // Opera requires us to provide a message payload, regardless of
            // whether we use it.
            channel.port2.postMessage(0);
        };
        requestTick = function () {
            setTimeout(flush, 0);
            requestPortTick();
        };

    } else {
        // old browsers
        requestTick = function () {
            setTimeout(flush, 0);
        };
    }
    // runs a task after all other tasks have been run
    // this is useful for unhandled rejection tracking that needs to happen
    // after all `then`d tasks have been run.
    nextTick.runAfter = function (task) {
        laterQueue.push(task);
        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };
    return nextTick;
})();

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this **might** have the nice side-effect of reducing the size of
// the minified code by reducing x.call() to merely x()
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
var call = Function.call;
function uncurryThis(f) {
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_defineProperty = Object.defineProperty || function (obj, prop, descriptor) {
    obj[prop] = descriptor.value;
    return obj;
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

function isObject(value) {
    return value === Object(value);
}

// generator related shims

// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

// FIXME: Remove this helper and Q.return once ES6 generators are in
// SpiderMonkey.
var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible, transform the error stack trace by removing Node and Q
    // cruft, then concatenating with the stack trace of `promise`. See #57.
    if (hasStacks &&
        promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack
    ) {
        var stacks = [];
        for (var p = promise; !!p; p = p.source) {
            if (p.stack && (!error.__minimumStackCounter__ || error.__minimumStackCounter__ > p.stackCounter)) {
                object_defineProperty(error, "__minimumStackCounter__", {value: p.stackCounter, configurable: true});
                stacks.unshift(p.stack);
            }
        }
        stacks.unshift(error.stack);

        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
        var stack = filterStackString(concatedStacks);
        object_defineProperty(error, "stack", {value: stack, configurable: true});
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function getFileNameAndLineNumber(stackLine) {
    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
    // In IE10 function name can have spaces ("Anonymous function") O_o
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) {
        return [attempt1[1], Number(attempt1[2])];
    }

    // Anonymous functions: "at filename:lineNumber:columnNumber"
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) {
        return [attempt2[1], Number(attempt2[2])];
    }

    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) {
        return [attempt3[1], Number(attempt3[2])];
    }
}

function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

    if (!fileNameAndLineNumber) {
        return false;
    }

    var fileName = fileNameAndLineNumber[0];
    var lineNumber = fileNameAndLineNumber[1];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (!hasStacks) {
        return;
    }

    try {
        throw new Error();
    } catch (e) {
        var lines = e.stack.split("\n");
        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
        if (!fileNameAndLineNumber) {
            return;
        }

        qFileName = fileNameAndLineNumber[0];
        return fileNameAndLineNumber[1];
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" &&
            typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative +
                         " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
function Q(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (value instanceof Promise) {
        return value;
    }

    // assimilate thenables
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}
Q.resolve = Q;

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Controls whether or not long stack traces will be on
 */
Q.longStackSupport = false;

/**
 * The counter is used to determine the stopping point for building
 * long stack traces. In makeStackTraceLong we walk backwards through
 * the linked list of promises, only stacks which were created before
 * the rejection are concatenated.
 */
var longStackCounter = 1;

// enable long stacks if Q_DEBUG is set
if (typeof process === "object" && process && Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}) && Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).Q_DEBUG) {
    Q.longStackSupport = true;
}

/**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */
Q.defer = defer;
function defer() {
    // if "messages" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the messages array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the `resolve` function because it handles both fully
    // non-thenable values and other thenables gracefully.
    var messages = [], progressListeners = [], resolvedPromise;

    var deferred = object_create(defer.prototype);
    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (messages) {
            messages.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            Q.nextTick(function () {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        }
    };

    // XXX deprecated
    promise.valueOf = function () {
        if (messages) {
            return promise;
        }
        var nearerValue = nearer(resolvedPromise);
        if (isPromise(nearerValue)) {
            resolvedPromise = nearerValue; // shorten chain
        }
        return nearerValue;
    };

    promise.inspect = function () {
        if (!resolvedPromise) {
            return { state: "pending" };
        }
        return resolvedPromise.inspect();
    };

    if (Q.longStackSupport && hasStacks) {
        try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
            promise.stackCounter = longStackCounter++;
        }
    }

    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
    // consolidating them into `become`, since otherwise we'd create new
    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

    function become(newPromise) {
        resolvedPromise = newPromise;

        if (Q.longStackSupport && hasStacks) {
            // Only hold a reference to the new promise if long stacks
            // are enabled to reduce memory usage
            promise.source = newPromise;
        }

        array_reduce(messages, function (undefined, message) {
            Q.nextTick(function () {
                newPromise.promiseDispatch.apply(newPromise, message);
            });
        }, void 0);

        messages = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(Q(value));
    };

    deferred.fulfill = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(fulfill(value));
    };
    deferred.reject = function (reason) {
        if (resolvedPromise) {
            return;
        }

        become(reject(reason));
    };
    deferred.notify = function (progress) {
        if (resolvedPromise) {
            return;
        }

        array_reduce(progressListeners, function (undefined, progressListener) {
            Q.nextTick(function () {
                progressListener(progress);
            });
        }, void 0);
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */
Q.Promise = promise; // ES6
Q.promise = promise;
function promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("resolver must be a function.");
    }
    var deferred = defer();
    try {
        resolver(deferred.resolve, deferred.reject, deferred.notify);
    } catch (reason) {
        deferred.reject(reason);
    }
    return deferred.promise;
}

promise.race = race; // ES6
promise.all = all; // ES6
promise.reject = reject; // ES6
promise.resolve = Q; // ES6

// XXX experimental.  This method is a way to denote that a local value is
// serializable and should be immediately dispatched to a remote upon request,
// instead of passing a reference.
Q.passByCopy = function (object) {
    //freeze(object);
    //passByCopies.set(object, true);
    return object;
};

Promise.prototype.passByCopy = function () {
    //freeze(object);
    //passByCopies.set(object, true);
    return this;
};

/**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */
Q.join = function (x, y) {
    return Q(x).join(y);
};

Promise.prototype.join = function (that) {
    return Q([this, that]).spread(function (x, y) {
        if (x === y) {
            // TODO: "===" should be Object.is or equiv
            return x;
        } else {
            throw new Error("Q can't join: not the same: " + x + " " + y);
        }
    });
};

/**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */
Q.race = race;
function race(answerPs) {
    return promise(function (resolve, reject) {
        // Switch to this once we can assume at least ES5
        // answerPs.forEach(function (answerP) {
        //     Q(answerP).then(resolve, reject);
        // });
        // Use this in the meantime
        for (var i = 0, len = answerPs.length; i < len; i++) {
            Q(answerPs[i]).then(resolve, reject);
        }
    });
}

Promise.prototype.race = function () {
    return this.then(Q.race);
};

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = Promise;
function Promise(descriptor, fallback, inspect) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error(
                "Promise does not support operation: " + op
            ));
        };
    }
    if (inspect === void 0) {
        inspect = function () {
            return {state: "unknown"};
        };
    }

    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    promise.inspect = inspect;

    // XXX deprecated `valueOf` and `exception` support
    if (inspect) {
        var inspected = inspect();
        if (inspected.state === "rejected") {
            promise.exception = inspected.reason;
        }

        promise.valueOf = function () {
            var inspected = inspect();
            if (inspected.state === "pending" ||
                inspected.state === "rejected") {
                return promise;
            }
            return inspected.value;
        };
    }

    return promise;
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.then = function (fulfilled, rejected, progressed) {
    var self = this;
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, self);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    Q.nextTick(function () {
        self.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    self.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
};

Q.tap = function (promise, callback) {
    return Q(promise).tap(callback);
};

/**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */
Promise.prototype.tap = function (callback) {
    callback = Q(callback);

    return this.then(function (value) {
        return callback.fcall(value).thenResolve(value);
    });
};

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    return Q(value).then(fulfilled, rejected, progressed);
}

Promise.prototype.thenResolve = function (value) {
    return this.then(function () { return value; });
};

Q.thenResolve = function (promise, value) {
    return Q(promise).thenResolve(value);
};

Promise.prototype.thenReject = function (reason) {
    return this.then(function () { throw reason; });
};

Q.thenReject = function (promise, reason) {
    return Q(promise).thenReject(reason);
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */

// XXX should we re-do this?
Q.nearer = nearer;
function nearer(value) {
    if (isPromise(value)) {
        var inspected = value.inspect();
        if (inspected.state === "fulfilled") {
            return inspected.value;
        }
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object instanceof Promise;
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return isObject(object) && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return isPromise(object) && object.inspect().state === "pending";
}

Promise.prototype.isPending = function () {
    return this.inspect().state === "pending";
};

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromise(object) || object.inspect().state === "fulfilled";
}

Promise.prototype.isFulfilled = function () {
    return this.inspect().state === "fulfilled";
};

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    return isPromise(object) && object.inspect().state === "rejected";
}

Promise.prototype.isRejected = function () {
    return this.inspect().state === "rejected";
};

//// BEGIN UNHANDLED REJECTION TRACKING

// This promise library consumes exceptions thrown in handlers so they can be
// handled by a subsequent promise.  The exceptions get added to this array when
// they are created, and removed when they are handled.  Note that in ES6 or
// shimmed environments, this would naturally be a `Set`.
var unhandledReasons = [];
var unhandledRejections = [];
var reportedUnhandledRejections = [];
var trackUnhandledRejections = true;

function resetUnhandledRejections() {
    unhandledReasons.length = 0;
    unhandledRejections.length = 0;

    if (!trackUnhandledRejections) {
        trackUnhandledRejections = true;
    }
}

function trackRejection(promise, reason) {
    if (!trackUnhandledRejections) {
        return;
    }
    if (typeof process === "object" && typeof process.emit === "function") {
        Q.nextTick.runAfter(function () {
            if (array_indexOf(unhandledRejections, promise) !== -1) {
                process.emit("unhandledRejection", reason, promise);
                reportedUnhandledRejections.push(promise);
            }
        });
    }

    unhandledRejections.push(promise);
    if (reason && typeof reason.stack !== "undefined") {
        unhandledReasons.push(reason.stack);
    } else {
        unhandledReasons.push("(no stack) " + reason);
    }
}

function untrackRejection(promise) {
    if (!trackUnhandledRejections) {
        return;
    }

    var at = array_indexOf(unhandledRejections, promise);
    if (at !== -1) {
        if (typeof process === "object" && typeof process.emit === "function") {
            Q.nextTick.runAfter(function () {
                var atReport = array_indexOf(reportedUnhandledRejections, promise);
                if (atReport !== -1) {
                    process.emit("rejectionHandled", unhandledReasons[at], promise);
                    reportedUnhandledRejections.splice(atReport, 1);
                }
            });
        }
        unhandledRejections.splice(at, 1);
        unhandledReasons.splice(at, 1);
    }
}

Q.resetUnhandledRejections = resetUnhandledRejections;

Q.getUnhandledReasons = function () {
    // Make a copy so that consumers can't interfere with our internal state.
    return unhandledReasons.slice();
};

Q.stopUnhandledRejectionTracking = function () {
    resetUnhandledRejections();
    trackUnhandledRejections = false;
};

resetUnhandledRejections();

//// END UNHANDLED REJECTION TRACKING

/**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */
Q.reject = reject;
function reject(reason) {
    var rejection = Promise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                untrackRejection(this);
            }
            return rejected ? rejected(reason) : this;
        }
    }, function fallback() {
        return this;
    }, function inspect() {
        return { state: "rejected", reason: reason };
    });

    // Note that the reason has not been handled.
    trackRejection(rejection, reason);

    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(value) {
    return Promise({
        "when": function () {
            return value;
        },
        "get": function (name) {
            return value[name];
        },
        "set": function (name, rhs) {
            value[name] = rhs;
        },
        "delete": function (name) {
            delete value[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name === null || name === void 0) {
                return value.apply(void 0, args);
            } else {
                return value[name].apply(value, args);
            }
        },
        "apply": function (thisp, args) {
            return value.apply(thisp, args);
        },
        "keys": function () {
            return object_keys(value);
        }
    }, void 0, function inspect() {
        return { state: "fulfilled", value: value };
    });
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    Q.nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return Promise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return Q(object).inspect();
    });
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(value, fulfilled, rejected) {
    return Q(value).spread(fulfilled, rejected);
}

Promise.prototype.spread = function (fulfilled, rejected) {
    return this.all().then(function (array) {
        return fulfilled.apply(void 0, array);
    }, rejected);
};

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;

            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
            // engine that has a deployed base of browsers that support generators.
            // However, SM's generators use the Python-inspired semantics of
            // outdated ES6 drafts.  We would like to support ES6, but we'd also
            // like to make it possible to use generators in deployed browsers, so
            // we also support Python-style generators.  At some point we can remove
            // this block.

            if (typeof StopIteration === "undefined") {
                // ES6 Generators
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    return reject(exception);
                }
                if (result.done) {
                    return Q(result.value);
                } else {
                    return when(result.value, callback, errback);
                }
            } else {
                // SpiderMonkey Generators
                // FIXME: Remove this case when SM does ES6 generators.
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    if (isStopIteration(exception)) {
                        return Q(exception.value);
                    } else {
                        return reject(exception);
                    }
                }
                return when(result, callback, errback);
            }
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "next");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */
Q.spawn = spawn;
function spawn(makeGenerator) {
    Q.done(Q.async(makeGenerator)());
}

// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q["return"] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    return Q(object).dispatch(op, args);
}

Promise.prototype.dispatch = function (op, args) {
    var self = this;
    var deferred = defer();
    Q.nextTick(function () {
        self.promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
};

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = function (object, key) {
    return Q(object).dispatch("get", [key]);
};

Promise.prototype.get = function (key) {
    return this.dispatch("get", [key]);
};

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = function (object, key, value) {
    return Q(object).dispatch("set", [key, value]);
};

Promise.prototype.set = function (key, value) {
    return this.dispatch("set", [key, value]);
};

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q.del = // XXX legacy
Q["delete"] = function (object, key) {
    return Q(object).dispatch("delete", [key]);
};

Promise.prototype.del = // XXX legacy
Promise.prototype["delete"] = function (key) {
    return this.dispatch("delete", [key]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
Q.mapply = // XXX As proposed by "Redsandro"
Q.post = function (object, name, args) {
    return Q(object).dispatch("post", [name, args]);
};

Promise.prototype.mapply = // XXX As proposed by "Redsandro"
Promise.prototype.post = function (name, args) {
    return this.dispatch("post", [name, args]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = // XXX Mark Miller's proposed parlance
Q.mcall = // XXX As proposed by "Redsandro"
Q.invoke = function (object, name /*...args*/) {
    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
};

Promise.prototype.send = // XXX Mark Miller's proposed parlance
Promise.prototype.mcall = // XXX As proposed by "Redsandro"
Promise.prototype.invoke = function (name /*...args*/) {
    return this.dispatch("post", [name, array_slice(arguments, 1)]);
};

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = function (object, args) {
    return Q(object).dispatch("apply", [void 0, args]);
};

Promise.prototype.fapply = function (args) {
    return this.dispatch("apply", [void 0, args]);
};

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] =
Q.fcall = function (object /* ...args*/) {
    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
};

Promise.prototype.fcall = function (/*...args*/) {
    return this.dispatch("apply", [void 0, array_slice(arguments)]);
};

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = function (object /*...args*/) {
    var promise = Q(object);
    var args = array_slice(arguments, 1);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};
Promise.prototype.fbind = function (/*...args*/) {
    var promise = this;
    var args = array_slice(arguments);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */
Q.keys = function (object) {
    return Q(object).dispatch("keys", []);
};

Promise.prototype.keys = function () {
    return this.dispatch("keys", []);
};

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var pendingCount = 0;
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            var snapshot;
            if (
                isPromise(promise) &&
                (snapshot = promise.inspect()).state === "fulfilled"
            ) {
                promises[index] = snapshot.value;
            } else {
                ++pendingCount;
                when(
                    promise,
                    function (value) {
                        promises[index] = value;
                        if (--pendingCount === 0) {
                            deferred.resolve(promises);
                        }
                    },
                    deferred.reject,
                    function (progress) {
                        deferred.notify({ index: index, value: progress });
                    }
                );
            }
        }, void 0);
        if (pendingCount === 0) {
            deferred.resolve(promises);
        }
        return deferred.promise;
    });
}

Promise.prototype.all = function () {
    return all(this);
};

/**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */
Q.any = any;

function any(promises) {
    if (promises.length === 0) {
        return Q.resolve();
    }

    var deferred = Q.defer();
    var pendingCount = 0;
    array_reduce(promises, function (prev, current, index) {
        var promise = promises[index];

        pendingCount++;

        when(promise, onFulfilled, onRejected, onProgress);
        function onFulfilled(result) {
            deferred.resolve(result);
        }
        function onRejected(err) {
            pendingCount--;
            if (pendingCount === 0) {
                var rejection = err || new Error("" + err);

                rejection.message = ("Q can't get fulfillment value from any promise, all " +
                    "promises were rejected. Last error message: " + rejection.message);

                deferred.reject(rejection);
            }
        }
        function onProgress(progress) {
            deferred.notify({
                index: index,
                value: progress
            });
        }
    }, undefined);

    return deferred.promise;
}

Promise.prototype.any = function () {
    return any(this);
};

/**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, Q);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

Promise.prototype.allResolved = function () {
    return allResolved(this);
};

/**
 * @see Promise#allSettled
 */
Q.allSettled = allSettled;
function allSettled(promises) {
    return Q(promises).allSettled();
}

/**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */
Promise.prototype.allSettled = function () {
    return this.then(function (promises) {
        return all(array_map(promises, function (promise) {
            promise = Q(promise);
            function regardless() {
                return promise.inspect();
            }
            return promise.then(regardless, regardless);
        }));
    });
};

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q.fail = // XXX legacy
Q["catch"] = function (object, rejected) {
    return Q(object).then(void 0, rejected);
};

Promise.prototype.fail = // XXX legacy
Promise.prototype["catch"] = function (rejected) {
    return this.then(void 0, rejected);
};

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(object, progressed) {
    return Q(object).then(void 0, void 0, progressed);
}

Promise.prototype.progress = function (progressed) {
    return this.then(void 0, void 0, progressed);
};

/**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q.fin = // XXX legacy
Q["finally"] = function (object, callback) {
    return Q(object)["finally"](callback);
};

Promise.prototype.fin = // XXX legacy
Promise.prototype["finally"] = function (callback) {
    if (!callback || typeof callback.apply !== "function") {
        throw new Error("Q can't apply finally callback");
    }
    callback = Q(callback);
    return this.then(function (value) {
        return callback.fcall().then(function () {
            return value;
        });
    }, function (reason) {
        // TODO attempt to recycle the rejection with "this".
        return callback.fcall().then(function () {
            throw reason;
        });
    });
};

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = function (object, fulfilled, rejected, progress) {
    return Q(object).done(fulfilled, rejected, progress);
};

Promise.prototype.done = function (fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        Q.nextTick(function () {
            makeStackTraceLong(error, promise);
            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promise = fulfilled || rejected || progress ?
        this.then(fulfilled, rejected, progress) :
        this;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }

    promise.then(void 0, onUnhandledError);
};

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = function (object, ms, error) {
    return Q(object).timeout(ms, error);
};

Promise.prototype.timeout = function (ms, error) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        if (!error || "string" === typeof error) {
            error = new Error(error || "Timed out after " + ms + " ms");
            error.code = "ETIMEDOUT";
        }
        deferred.reject(error);
    }, ms);

    this.then(function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    }, deferred.notify);

    return deferred.promise;
};

/**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */
Q.delay = function (object, timeout) {
    if (timeout === void 0) {
        timeout = object;
        object = void 0;
    }
    return Q(object).delay(timeout);
};

Promise.prototype.delay = function (timeout) {
    return this.then(function (value) {
        var deferred = defer();
        setTimeout(function () {
            deferred.resolve(value);
        }, timeout);
        return deferred.promise;
    });
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = function (callback, args) {
    return Q(callback).nfapply(args);
};

Promise.prototype.nfapply = function (args) {
    var deferred = defer();
    var nodeArgs = array_slice(args);
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */
Q.nfcall = function (callback /*...args*/) {
    var args = array_slice(arguments, 1);
    return Q(callback).nfapply(args);
};

Promise.prototype.nfcall = function (/*...args*/) {
    var nodeArgs = array_slice(arguments);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */
Q.nfbind =
Q.denodeify = function (callback /*...args*/) {
    if (callback === undefined) {
        throw new Error("Q can't wrap an undefined function");
    }
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(callback).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nfbind =
Promise.prototype.denodeify = function (/*...args*/) {
    var args = array_slice(arguments);
    args.unshift(this);
    return Q.denodeify.apply(void 0, args);
};

Q.nbind = function (callback, thisp /*...args*/) {
    var baseArgs = array_slice(arguments, 2);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        function bound() {
            return callback.apply(thisp, arguments);
        }
        Q(bound).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nbind = function (/*thisp, ...args*/) {
    var args = array_slice(arguments, 0);
    args.unshift(this);
    return Q.nbind.apply(void 0, args);
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nmapply = // XXX As proposed by "Redsandro"
Q.npost = function (object, name, args) {
    return Q(object).npost(name, args);
};

Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
Promise.prototype.npost = function (name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = // XXX Based on Mark Miller's proposed "send"
Q.nmcall = // XXX Based on "Redsandro's" proposal
Q.ninvoke = function (object, name /*...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
Promise.prototype.ninvoke = function (name /*...args*/) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */
Q.nodeify = nodeify;
function nodeify(object, nodeback) {
    return Q(object).nodeify(nodeback);
}

Promise.prototype.nodeify = function (nodeback) {
    if (nodeback) {
        this.then(function (value) {
            Q.nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            Q.nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return this;
    }
};

Q.noConflict = function() {
    throw new Error("Q.noConflict only works when Q is used as a global");
};

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(247).setImmediate))

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(899);

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);
var bind = __webpack_require__(436);
var Axios = __webpack_require__(900);
var mergeConfig = __webpack_require__(442);
var defaults = __webpack_require__(439);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(443);
axios.CancelToken = __webpack_require__(913);
axios.isCancel = __webpack_require__(438);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(914);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);
var buildURL = __webpack_require__(437);
var InterceptorManager = __webpack_require__(901);
var dispatchRequest = __webpack_require__(902);
var mergeConfig = __webpack_require__(442);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);
var transformData = __webpack_require__(903);
var isCancel = __webpack_require__(438);
var defaults = __webpack_require__(439);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(441);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(908);
var combineURLs = __webpack_require__(909);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(46);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(443);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var CategorySubMenuItem=function CategorySubMenuItem(props){return ComposeSubMenuItem(props.type,props.path,props.label,props.categoryId,props.subCategoryId,props.enabled,props.className,props.parentClassName,props.hasItems);};var ComposeSubMenuItem=function ComposeSubMenuItem(type,path,label,categoryId,subCategoryId,enabled,className,parentClassName,hastItems){switch(enabled){case true:switch(type){case'category':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?category='+categoryId,className:'link-profile txt-font-body txt-body-sm  d-block px-1 py-1 '+className},label)));case'sub-category':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?subcategory='+subCategoryId,className:'link-profile txt-font-body txt-body-sm  d-block px-1 py-1 '+className},label)));case'services':return label==='Passagens'||label==='Hotéis'||label==='Carros'||label==='Passeios'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+path,className:'link-profile txt-font-body txt-body-sm  d-block px-1 py-1 '+className},label))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:''+path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className},label)));case'services-external':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+parentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+path,className:'link-profile txt-font-body txt-body-sm d-block px-1 py-1 '+className,target:'_blank'},label)));}}};CategorySubMenuItem.propTypes={type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,path:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,categoryId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,subCategoryId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,enabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,parentClassName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hasItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (CategorySubMenuItem);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuItem__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var SubMenu=function SubMenu(_ref){var items=_ref.items,type=_ref.type,parentLabel=_ref.parentLabel,indexParent=_ref.indexParent,indexItem=_ref.indexItem,hideSubmenu=_ref.hideSubmenu,path=_ref.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'row px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subitems-title ver-todos row mx-0 pb-2 pt-1 mb-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_left',className:'icon-ssm ver-todos'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-profile txt-body d-block txt-font-body-bold',onClick:function onClick(){return hideSubmenu();},'aria-label':'Voc\xEA abriu o sub-menu '+parentLabel+'. Para fechar, \xE9 s\xF3 clicar aqui.'},parentLabel))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subitems-box w-100 mx--1',tabIndex:-1},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MenuItem__["a" /* default */],Object.assign({key:index,indexParent:indexParent,indexItem:indexItem,type:item.type||type},item));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subitems-seeall  row mx-0 px-2 pt-2 pb-1 mt-2 border-top border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:path==null?'/':path,className:'link-profile txt-body d-block txt-font-body-bold','aria-label':'Para ver todos os itens da sub-categoria '+parentLabel+' \xE9 s\xF3 clicar aqui.'},'Ver todos os itens',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Para ver todos os itens da sub-categoria ',parentLabel,' \xE9 s\xF3 clicar aqui.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_right',className:'ver-todos icon-sm color-brand-1'})))));};SubMenu.propTypes={items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_1__MenuItem__["a" /* default */].propTypes)).isRequired,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,parentLabel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,path:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,indexParent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,indexItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,hideSubmenu:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SubMenu);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
var CategoryMenuType=function CategoryMenuType(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,ComposeMenuType(props.type,props.sku,props.path,props.label,props.enabled));};var ComposeMenuType=function ComposeMenuType(type,sku,path,label,enabled){switch(enabled){case true:switch(type){case'product':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/products/'+sku,className:'link-menu',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto type-product'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))));case'external-link':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:''+path,className:'link-menu type-external-link',target:'_blank',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label)));case'internal-link':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);},to:''+path,className:'link-menu txt-font-body-bold d-flex type-internal-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label)));case'dynamic':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:768,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-dynamic px-0',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);},'aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-dynamic',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);},'aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))));case'services':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:768,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);},className:'link-menu type-services px-0','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);},className:'link-menu type-services','aria-expanded':'false'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))));case'services-external':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:768,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-services-external px-0','aria-expanded':'false',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-services-external','aria-expanded':'false',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))));case'category':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:768,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-category px-0','aria-expanded':'false',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-category','aria-expanded':'false',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))));case'sub-category':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:768,maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-sub-category px-0','aria-expanded':'false',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'link-menu type-sub-category','aria-expanded':'false',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_3_Shared_GTM_getMenu__["a" /* getMenu */])(true,'home','clique:menu',label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-text col-auto'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-icon col-auto d-none d-md-flex pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_down icon-ssm'}))))));}}};CategoryMenuType.propTypes={type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,sku:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,path:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,enabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CategoryMenuType);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OnlyCash__ = __webpack_require__(919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OnlyCash__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(446);
/* unused harmony reexport reducer */


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedirectPoints__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RedirectCash__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Shared_GTM_getMenu__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_expandmenu_css__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_expandmenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_expandmenu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnlyCash=function(_Component){_inherits(OnlyCash,_Component);function OnlyCash(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OnlyCash);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OnlyCash.__proto__||Object.getPrototypeOf(OnlyCash)).call.apply(_ref,[this].concat(args))),_this),_this.state={cash:false},_this.state={loaderCash:false},_this.state={loaderPoints:false},_this.state={onlyCash:_this.props.onlyCash},_this.setCash=function(value){return _this.setState({cash:_this.props.onlyCash});},_this.openChangeContext=function(){return _this.setState({changeContext:!_this.state.changeContext});},_this.handleChangeField=function(type){if(type==='cash'){_this.setState({cash:true});_this.props.SetOnlyCash(true);}else{_this.props.SetOnlyCash(false);}setTimeout(function(){window.location.href='/';},1500);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OnlyCash,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.catalogJustCash){this.props.getVisualizationContext();this.props.onlyCash&&this.setState({cash:this.props.onlyCash});}else{this.setState({cash:false});}this.setState({changeContext:false});}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.state.cash!==this.props.onlyCash){this.setCash(this.props.onlyCash);}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minDeviceWidth:768},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-value-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'visualization-context',id:'context-cash',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'visualization-context',id:'context-points',className:'d-none'}),this.state.cash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'toogle-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-icon col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_cash icon-md'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-text col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button','aria-controls':'list-context',onClick:function onClick(){return _this2.openChangeContext();},'aria-expanded':this.state.changeContext},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Compre com cart\xE3o'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon-ssm '+(!this.state.changeContext?'icon_down color-brand-1':'icon_close')})))),!this.state.cash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'toogle-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-icon col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_gift icon-md'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-text col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button','aria-controls':'list-context',onClick:function onClick(){return _this2.openChangeContext();},'aria-expanded':this.state.changeContext},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Resgate com pontos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon-ssm '+(!this.state.changeContext?'icon_down color-brand-1':'icon_close')})))),this.state.changeContext&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'list-context\'',className:'toogle-dropdown'},!this.state.cash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'toogle-menu',onClick:function onClick(){return _this2.handleChangeField('cash');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-icon col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_cash icon-md'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-text col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_7_Shared_GTM_getMenu__["a" /* getMenu */])(_this2.props.profile,'home','clique:resgate','compre-com-cartao');_this2.handleChangeField('cash');}},'Compre com Cart\xE3o')))),this.state.cash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'toogle-menu',onClick:function onClick(){return _this2.handleChangeField('points');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-icon col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_gift icon-md'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toogle-text col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_7_Shared_GTM_getMenu__["a" /* getMenu */])(_this2.props.profile,'home','clique:resgate','compre-com-pontos');_this2.handleChangeField('points');}},'Resgate com pontos'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{maxDeviceWidth:767},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'points-cash d-print-none '+(this.props.isMobile?'zindex-default':'zindex-high')+' '+(this.props.isGuest&&this.state.cash?'d-block':!this.props.catalogJustCash?'d-none':'d-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-points-cash '+(this.state.loaderCash?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RedirectCash__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-points-cash '+(this.state.loaderPoints?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RedirectPoints__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 main-menu d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'col-12 radius-left overflow px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 py-half '+(this.state.cash?'bg-featured border-featured':'bg-white border-ui-4')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{onClick:function onClick(){return _this2.handleChangeField('cash');},className:'d-block txt-center txt-subtitle '+(this.state.cash?'color-ui-1 txt-circular-black':'color-ui-2 txt-circular-black cursor')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nav-text'},'PAGUE COM CART\xC3O'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_cash'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-12 py-half '+(!this.state.cash?'bg-featured border-featured':'bg-white border-ui-4')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{onClick:function onClick(){return _this2.handleChangeField('points');},className:'d-block txt-center txt-subtitle '+(!this.state.cash?'color-ui-1 txt-circular-black':'color-ui-2 txt-circular-black cursor')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nav-text'},'TROQUE POR PONTOS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_gift'}))))))));}}]);return OnlyCash;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OnlyCash.propTypes={SetOnlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,catalogJustCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isGuest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,getVisualizationContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref2){var catalog=_ref2.catalog,onlyCash=_ref2.onlyCash;return{catalogJustCash:catalog.onlyCash,onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{SetOnlyCash:function SetOnlyCash(cash){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* changeVisualizationContext */])(cash));},getVisualizationContext:function getVisualizationContext(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* getVisualizationContext */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(OnlyCash));

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var textLoading1=function textLoading1(){return'Você quer trocar seus pontos?';};var textLoading2=function textLoading2(){return'Se precisar pode completar com '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro')+'.';};var enjoy=function enjoy(){return'Aproveite ;)';};var RedirectPoints=function(_Component){_inherits(RedirectPoints,_Component);function RedirectPoints(){_classCallCheck(this,RedirectPoints);return _possibleConstructorReturn(this,(RedirectPoints.__proto__||Object.getPrototypeOf(RedirectPoints)).apply(this,arguments));}_createClass(RedirectPoints,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row loading-screen screen-default'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 bg-brand-4 progress-loader p-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'progress-bar'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 bg-brand-2 txt-loading py-5 d-flex align-items-center justify-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'logo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mr-auto ml-auto txt-center logo-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/',tabIndex:0,title:textLoading1()+' '+textLoading2()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'d-none'},"Tupperware | Premmiar"||'Premmiar')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'cash color-ui-white txt-normal mx-auto mt-2'},textLoading1()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'cash color-ui-white txt-normal mx-auto'},textLoading2()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'color-brand-6 txt-normal mx-auto mb-2'},enjoy()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-loading loader-screen mx-auto'}))));}}]);return RedirectPoints;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RedirectPoints);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_template_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var textLoading=function textLoading(){return'Voc\xEA acabou de escolher pagar com '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro')+'.';};var enjoy=function enjoy(){return'Aproveite ;)';};var RedirectCash=function(_Component){_inherits(RedirectCash,_Component);function RedirectCash(){_classCallCheck(this,RedirectCash);return _possibleConstructorReturn(this,(RedirectCash.__proto__||Object.getPrototypeOf(RedirectCash)).apply(this,arguments));}_createClass(RedirectCash,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row loading-screen screen-default'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 bg-brand-4 progress-loader p-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'progress-bar'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 bg-brand-2 txt-loading py-5 d-flex align-items-center justify-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'logo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mr-auto ml-auto txt-center logo-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/',tabIndex:0,title:textLoading()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'d-none'},"Tupperware | Premmiar"||'Premmiar')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'points color-ui-white txt-normal mx-auto mt-2'},textLoading()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'color-brand-6 txt-normal mx-auto mb-2'},enjoy()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-loading loader-screen mx-auto'}))));}}]);return RedirectCash;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RedirectCash);

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainMenu__ = __webpack_require__(261);
var mapStateToProps=function mapStateToProps(_ref){var mainMenu=_ref.mainMenu,onlyCash=_ref.onlyCash,catalog=_ref.catalog,profile=_ref.oidc.user.profile;return{tradeMenu:(profile?mainMenu[profile['custom:catalog_id']]?mainMenu[profile['custom:catalog_id']]:mainMenu['default']:mainMenu['default']).tradeMenu,categoryMenu:(profile?mainMenu[profile['custom:catalog_id']]?mainMenu[profile['custom:catalog_id']]:mainMenu['default']:mainMenu['default']).categoryMenu,onlyCash:onlyCash,catalogJustCash:catalog.onlyCash,profile:profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MainMenu__["a" /* default */]));

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainMenuPublic__ = __webpack_require__(925);
var mapStateToProps=function mapStateToProps(_ref){var _ref$mainMenu$default=_ref.mainMenu.default,tradeMenu=_ref$mainMenu$default.tradeMenu,categoryMenu=_ref$mainMenu$default.categoryMenu;return{tradeMenu:tradeMenu,categoryMenu:categoryMenu};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MainMenuPublic__["a" /* default */]));

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_menu_css__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_molecules_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_molecules_menu_toggle_css__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_molecules_menu_toggle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_molecules_menu_toggle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainMenuPlaceholder__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CategoryMenu__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_molecules_slider_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_molecules_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_molecules_slider_css__);
var MainMenuPublic=function MainMenuPublic(_ref){var categoryMenu=_ref.categoryMenu;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MainMenuPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('nav',{className:'container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-md-block d-print-none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'menu menu-without-trade row row-eq-height flex-wrap flex-md-nowrap'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CategoryMenu__["a" /* CategoryMenu */],{menus:categoryMenu})))))));};MainMenuPublic.propTypes={categoryMenu:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (MainMenuPublic);

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var MainMenuPlaceholder=function MainMenuPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu row row-eq-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-md-1 order-2 col-md-2 col px-1 pr-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-5 radius opacity'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-sm-block d-auto col-md col-12 order-md-2 order-4 px-1 px-md-4 py-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center py-1 h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-5 radius  opacity'}))))));};/* harmony default export */ __webpack_exports__["a"] = (MainMenuPlaceholder);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var placeholders = __webpack_require__(929);
var ReactPlaceholder = /** @class */ (function (_super) {
    __extends(ReactPlaceholder, _super);
    function ReactPlaceholder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            ready: _this.props.ready
        };
        _this.getFiller = function () {
            var _a = _this.props, firstLaunchOnly = _a.firstLaunchOnly, children = _a.children, ready = _a.ready, className = _a.className, // eslint-disable-line no-unused-vars
            type = _a.type, customPlaceholder = _a.customPlaceholder, showLoadingAnimation = _a.showLoadingAnimation, rest = __rest(_a, ["firstLaunchOnly", "children", "ready", "className", "type", "customPlaceholder", "showLoadingAnimation"]);
            var classes = showLoadingAnimation ?
                ['show-loading-animation', className].filter(function (c) { return c; }).join(' ') :
                className;
            if (customPlaceholder && React.isValidElement(customPlaceholder)) {
                var mergedCustomClasses = [
                    customPlaceholder.props.className,
                    classes
                ].filter(function (c) { return c; }).join(' ');
                return React.cloneElement(customPlaceholder, { className: mergedCustomClasses });
            }
            else if (customPlaceholder) {
                return customPlaceholder;
            }
            var Placeholder = placeholders[type];
            return React.createElement(Placeholder, __assign({}, rest, { className: classes }));
        };
        _this.setNotReady = function () {
            var delay = _this.props.delay;
            if (delay && delay > 0) {
                _this.timeout = window.setTimeout(function () {
                    _this.setState({ ready: false });
                }, delay);
            }
            else {
                _this.setState({ ready: false });
            }
        };
        _this.setReady = function () {
            if (_this.timeout) {
                window.clearTimeout(_this.timeout);
            }
            if (!_this.state.ready) {
                _this.setState({ ready: true });
            }
        };
        return _this;
    }
    ReactPlaceholder.prototype.render = function () {
        return this.state.ready ? this.props.children : this.getFiller();
    };
    ReactPlaceholder.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.firstLaunchOnly && this.state.ready && !nextProps.ready) {
            this.setNotReady();
        }
        else if (nextProps.ready) {
            this.setReady();
        }
    };
    ReactPlaceholder.propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.element
        ]).isRequired,
        delay: PropTypes.number,
        ready: PropTypes.bool.isRequired,
        firstLaunchOnly: PropTypes.bool,
        type: PropTypes.oneOf(['text', 'media', 'textRow', 'rect', 'round']),
        rows: PropTypes.number,
        color: PropTypes.string,
        showLoadingAnimation: PropTypes.bool,
        customPlaceholder: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.element
        ]),
        className: PropTypes.string,
        style: PropTypes.object
    };
    ReactPlaceholder.defaultProps = {
        delay: 0,
        type: 'text',
        color: '#CDCDCD'
    };
    return ReactPlaceholder;
}(React.Component));
exports["default"] = ReactPlaceholder;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TextRow_1 = __webpack_require__(448);
exports.TextRow = TextRow_1["default"];
var RoundShape_1 = __webpack_require__(449);
exports.RoundShape = RoundShape_1["default"];
var RectShape_1 = __webpack_require__(930);
exports.RectShape = RectShape_1["default"];
var TextBlock_1 = __webpack_require__(450);
exports.TextBlock = TextBlock_1["default"];
var MediaBlock_1 = __webpack_require__(931);
exports.MediaBlock = MediaBlock_1["default"];
exports.textRow = TextRow_1["default"];
exports.round = RoundShape_1["default"];
exports.rect = RectShape_1["default"];
exports.text = TextBlock_1["default"];
exports.media = MediaBlock_1["default"];


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var RectShape = /** @class */ (function (_super) {
    __extends(RectShape, _super);
    function RectShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RectShape.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, color = _a.color;
        var defaultStyle = {
            backgroundColor: color,
            width: '100%',
            height: '100%',
            marginRight: 10
        };
        var classes = ['rect-shape', className].filter(function (c) { return c; }).join(' ');
        return (React.createElement("div", { className: classes, style: __assign({}, defaultStyle, style) }));
    };
    RectShape.propTypes = {
        color: PropTypes.string,
        className: PropTypes.string,
        style: PropTypes.object
    };
    return RectShape;
}(React.Component));
exports["default"] = RectShape;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var TextBlock_1 = __webpack_require__(450);
var RoundShape_1 = __webpack_require__(449);
var MediaBlock = /** @class */ (function (_super) {
    __extends(MediaBlock, _super);
    function MediaBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaBlock.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, color = _a.color, rows = _a.rows;
        var defaultStyles = {
            display: 'flex'
        };
        var classes = ['media-block', className].filter(function (c) { return c; }).join(' ');
        return (React.createElement("div", { className: classes, style: __assign({}, defaultStyles, style) },
            React.createElement(RoundShape_1["default"], { color: color, style: { minHeight: 55, width: 55, minWidth: 55, marginRight: 10 } }),
            React.createElement(TextBlock_1["default"], { color: color, rows: rows })));
    };
    MediaBlock.propTypes = {
        rows: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
        style: PropTypes.object,
        className: PropTypes.string
    };
    return MediaBlock;
}(React.Component));
exports["default"] = MediaBlock;


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{default:{tradeMenu:{label:'',items:[],bottom:[]},categoryMenu:{menus:[]}}};var action=arguments[1];return Object.assign({},state);});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:true,items:[]};var action=arguments[1];switch(action.type){case'FETCH_PRODUCT_CATEGORIES':return Object.assign({},state,{isLoading:true});case'FETCH_PRODUCT_CATEGORIES_SUCCESS':var data=action.payload.data;return Object.assign({},state,{items:data,isLoading:false});case'FETCH_PRODUCT_CATEGORIES_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});default:return Object.assign({},state);}});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,ecommerce:[],vouchers:[],services:[],vendorTypes:vendorTypes};var action=arguments[1];switch(action.type){case'FETCH_STORES':return Object.assign({},state,{isLoading:true});case'FETCH_STORES_SUCCESS':var data=action.payload.data;return Object.assign({},state,formatStores(vendorTypes,data),{isLoading:false});case'FETCH_STORES_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});default:return Object.assign({},state);}});var vendorTypes={Ecommerce:'1',VoucherFisico:'2',VoucherVirtual:'3',Milhas:'4',Outros:'5',RecargaDeCelular:'6',VoucherVirtualExterno:'7',Doacao:'8',PagueContas:'14',CreditoShellVPower:'15'};var formatStores=function formatStores(vendorTypes,stores){return{ecommerce:stores.filter(function(it){return!isVendorInactive(it.statusId)&&(!it.supplierTypeId||it.supplierTypeId===vendorTypes.Ecommerce);}),vouchers:stores.filter(function(it){return!isVendorInactive(it.statusId)&&(it.supplierTypeId===vendorTypes.VoucherFisico||it.supplierTypeId===vendorTypes.VoucherVirtual||it.supplierTypeId===vendorTypes.VoucherVirtualExterno);}),services:stores.filter(function(it){return!isVendorInactive(it.statusId)&&(it.supplierTypeId===vendorTypes.RecargaDeCelular||it.supplierTypeId===vendorTypes.Milhas||it.supplierTypeId===vendorTypes.Doacao||it.supplierTypeId===vendorTypes.Outros||it.supplierTypeId===vendorTypes.PagueContas||it.supplierTypeId===vendorTypes.CreditoShellVPower);})};};var statusVendorEnum={ativo:1,inativo:2,suspenso:3};var isVendorInactive=function isVendorInactive(statusId){return!!(statusId===statusVendorEnum.inativo||statusId===statusVendorEnum.suspenso);};

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadCategories; });
var loadCategories=function loadCategories(){return{type:'FETCH_PRODUCT_CATEGORIES',payload:{client:'cloudloyalty',request:{method:'get',url:'/v2/products/categories'}}};};

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadStores; });
var loadStores=function loadStores(catalogId){return{type:'FETCH_STORES',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/stores/getStoresAllStatus?catalogId='+catalogId}}};};

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Auth__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_Shell_ShellContainer__ = __webpack_require__(426);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var ShellRoute=function ShellRoute(_ref){var Component=_ref.component,_ref$isGuest=_ref.isGuest,isGuest=_ref$isGuest===undefined?false:_ref$isGuest,rest=_objectWithoutProperties(_ref,['component','isGuest']);var RouteComponent=isGuest?__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"]:__WEBPACK_IMPORTED_MODULE_3_Auth__["a" /* PrivateRoute */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Shell_ShellContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RouteComponent,Object.assign({},rest,{render:function render(matchProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,matchProps);}}))));};ShellRoute.propTypes={component:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.elementType,isGuest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ShellRoute.defaultProps={isGuest:false};/* harmony default export */ __webpack_exports__["a"] = (ShellRoute);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Header__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_HomePageItauMeuBairro_Header__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_Footer__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_HomePageItauMeuBairro_Footer__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App_FingerPrint_FingerPrintContainer__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Widgets__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_last_location__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_router_last_location__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// import AnchorLink from 'react-anchor-link-smooth-scroll'
// import MediaQuery from 'react-responsive'
var Shell=function Shell(_ref){var children=_ref.children,profile=_ref.profile;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),headBairro=_useState2[0],useHeadBairro=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(children.props.children.props.path==='/meu-negocio'){useHeadBairro(true);}// Removendo outline no clique do mouse
var htmlElement=document.querySelector('html');htmlElement.classList.add('clicking');document.addEventListener('click',function(){htmlElement.classList.add('clicking');});document.addEventListener('keyup',function(e){if(e.keyCode===9){htmlElement.classList.remove('clicking');}});// Menu de acessibilidade
var accessibilityMenus=document.getElementById('accessibility-menu-anchors');if(accessibilityMenus!==null){accessibilityMenus.setAttribute('tabindex','0');accessibilityMenus.focus();accessibilityMenus.addEventListener('blur',function(){accessibilityMenus.removeAttribute('tabindex');});accessibilityMenus.blur();}else{var btnBackPage=document.querySelector('.btn-back-page');btnBackPage&&btnBackPage.focus();}});var refererIsLogin=function refererIsLogin(){return typeof Object(__WEBPACK_IMPORTED_MODULE_8_react_router_last_location__["useLastLocation"])()!=='undefined'&&Object(__WEBPACK_IMPORTED_MODULE_8_react_router_last_location__["useLastLocation"])()&&Object(__WEBPACK_IMPORTED_MODULE_8_react_router_last_location__["useLastLocation"])().pathname.toString().indexOf('auth')>-1;};// const handleFocus = (target) => {
//   document.activeElement.blur()
//   setTimeout(() => {
//     let targetElement = document.querySelector(`${target}`)
//     if (target === '#mainContainer') {
//       targetElement = document.querySelector('h1')
//     }
//     if (targetElement) {
//       targetElement.setAttribute('tabindex', '0')
//       targetElement.focus()
//       targetElement.addEventListener('blur', function () {
//         targetElement.removeAttribute('tabindex')
//       })
//     }
//   }, 300)
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4','data-campaign':"80938"},refererIsLogin()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_App_FingerPrint_FingerPrintContainer__["a" /* default */],null),headBairro?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_HomePageItauMeuBairro_Header__["a" /* default */],{profile:profile}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Header__["a" /* default */],{refererIsLogin:refererIsLogin()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mainContainer',className:'container-fluid px-0 py-0',role:'main'},children),headBairro?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_HomePageItauMeuBairro_Footer__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_Footer__["a" /* FooterContainer */],null),profile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Widgets__["a" /* default */],null));};Shell.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Shell);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultHeader__ = __webpack_require__(451);
/* unused harmony reexport DefaultHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicHeader__ = __webpack_require__(473);
/* unused harmony reexport BasicHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuestHeader__ = __webpack_require__(1018);
/* unused harmony reexport GuestHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderRouter__ = __webpack_require__(1021);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__HeaderRouter__["a"]; });


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var Logo=function Logo(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo zindex col-3 col-sm-2  mx-auto mx-sm-0 pr-sm-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},window.location.pathname!=='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/',className:'d-block pos-absolute w-100 logo-header-link logo-header logo-header-img my-1','aria-label':'Logo '+("Tupperware | Premmiar"||'Premmiar')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},'Logo ',"Tupperware | Premmiar"||'Web Prêmios')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'d-block pos-absolute w-100 logo-header-link logo-header logo-header-img my-1'},'Logo ',"Tupperware | Premmiar"||'Premmiar'))));};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mostSearched__ = __webpack_require__(976);
var mapStateToProps=function mapStateToProps(_ref){var autoComplete=_ref.autoComplete,router=_ref.router;return Object.assign({},autoComplete,{mostSearched:__WEBPACK_IMPORTED_MODULE_5__mostSearched__["a" /* default */],router:router});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchSearch:function fetchSearch(term){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* fetchSearch */])(term));},emptySearch:function emptySearch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* emptySearch */])());},addItemCart:function addItemCart(body){return dispatch(__WEBPACK_IMPORTED_MODULE_3_features_Cart__["c" /* actions */].addItem(body));},redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(path));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Search__["a" /* default */]));

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_left_pad__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_left_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_left_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_autocomplete_css__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Search=function(_Component){_inherits(Search,_Component);function Search(props){_classCallCheck(this,Search);var _this=_possibleConstructorReturn(this,(Search.__proto__||Object.getPrototypeOf(Search)).call(this,props));_this.state={term:'',timer:0,autoCompleteFilled:true,hideSearchField:true,verifyTrigger:true,clickedSearch:false,msgMostSearched:''};_this.setTerm=_this.setTerm.bind(_this);return _this;}_createClass(Search,[{key:'handleKeyUp',value:function handleKeyUp(e){clearTimeout(this.state.timer);if(e.key==='Enter'){this.emptyTerm();this.hideSearchField();this.props.redirect('/search?term='+e.target.value);this.setState({verifyTrigger:false});}else if(e.key==='Escape'){this.hideSearchField();}else{if(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_AUTOCOMPLETE){this.searchTerm();}}}},{key:'searchTrigger',value:function searchTrigger(e){if(e.key!=='Tab'){this.emptyTerm();this.props.redirect('/search?term='+this.state.term);this.setState({verifyTrigger:false});}}},{key:'emptySearch',value:function emptySearch(){this.props.emptySearch();this.setAutoComplete(true);}},{key:'emptyTerm',value:function emptyTerm(){this.setState({autoCompleteFilled:true,term:''});}},{key:'setTerm',value:function setTerm(value){this.setState({term:value});}},{key:'searchTerm',value:function searchTerm(){var _this2=this;if(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_AUTOCOMPLETE){if(this.state.term){this.setState({timer:setTimeout(function(){_this2.props.fetchSearch(_this2.state.term);},1000),autoCompleteFilled:true,verifyTrigger:true});}else{this.setState({autoCompleteFilled:false,verifyTrigger:false});}}}},{key:'setAutoComplete',value:function setAutoComplete(isFilled){this.setState({autoCompleteFilled:isFilled});}},{key:'showSearchField',value:function showSearchField(){this.setState({hideSearchField:false});setTimeout(function(){var logo=document.querySelector('.logo-header-link');logo&&logo.setAttribute('aria-hidden','true');document.getElementById('box-search-field-mobile-close')&&document.getElementById('box-search-field-mobile-close').focus();},100);}},{key:'hideSearchField',value:function hideSearchField(){this.setState({hideSearchField:true,clickedSearch:false,autoCompleteFilled:true,term:''});this.hideMostSearchedItems();setTimeout(function(){var logo=document.querySelector('.logo-header-link');logo&&logo.setAttribute('aria-hidden','false');document.getElementById('box-search-field-mobile-open')&&document.getElementById('box-search-field-mobile-open').focus();},500);}},{key:'showMostSearchedItems',value:function showMostSearchedItems(){var noSrollBody=document.getElementsByTagName('body');noSrollBody[0].classList.add('noSrollBody');!this.state.term?this.setState({autoCompleteFilled:false}):this.setState({autoCompleteFilled:true});}},{key:'hideMostSearchedItems',value:function hideMostSearchedItems(){var _this3=this;setTimeout(function(){var noSrollBody=document.getElementsByTagName('body');noSrollBody[0].classList.remove('noSrollBody');_this3.emptySearch();},300);}},{key:'render',value:function render(){var _this4=this;var searchLabel='O que você está buscando hoje?';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search zindex'+(!this.state.hideSearchField?'-high':'')+' d-sm-block d-auto col-xs-12 col-sm px-xs-1 px-sm-4 ml-auto',role:'search'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 form-field search-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'hide-absolute color-ui-white',role:'status','aria-live':'assertive','aria-atomic':'true'},this.state.term!==''&&(this.props.isLoading?'Auto-completar: Carregando resultados':'Resultado completo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'hide-absolute color-ui-white',role:'status','aria-live':'assertive','aria-atomic':'true'},!this.state.autoCompleteFilled?'Exibindo os termos mais buscados':this.state.msgMostSearched),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-search-field-desktop d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'buscar-desktop',className:'hide-absolute'},searchLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'no-label no-border radius color-ui-2',id:'buscar-desktop',type:'text',placeholder:searchLabel,name:'buscar',onChange:function onChange(e){return _this4.setTerm(e.target.value);},value:this.state.term,onKeyUp:function onKeyUp(e){return _this4.handleKeyUp(e);},onFocus:function onFocus(){return _this4.searchTerm();},onBlur:function onBlur(){return setTimeout(function(){_this4.emptySearch();},300);},autoComplete:'off'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'h-100 btn-sm btn btn-flat btn-icon btn-icon-only','aria-label':this.props.isLoading?'Auto-completar: Carregando resultados...':'Buscar por produtos',id:'btn-search-loupe',onClick:function onClick(e){return!_this4.props.isLoading&&_this4.searchTrigger(e);},onBlur:function onBlur(){return setTimeout(function(){_this4.emptySearch();},300);},readOnly:this.props.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:!this.props.isLoading?'icon_search':'icon_loading',className:!this.props.isLoading?'color-brand-2':'color-ui-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'box-search-field-mobile',className:'box-search-field-mobile d-block d-sm-none'},this.state.hideSearchField===false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'box-search-field-mobile-close',className:'h-100 btn-sm btn btn-flat btn-icon btn-icon-only restore-search',onClick:function onClick(){return _this4.hideSearchField();},'aria-label':'Fechar campo de busca','aria-haspopup':'true','aria-expanded':!this.state.hideSearchField},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_left_app',className:'color-brand-5'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'no-label no-border radius color-ui-2',id:'buscar-mobile',type:'text',tabIndex:0,placeholder:searchLabel,name:'buscar',onChange:function onChange(e){return _this4.setTerm(e.target.value);},value:this.state.term,onKeyUp:function onKeyUp(e){return _this4.handleKeyUp(e);},onFocus:function onFocus(){return _this4.showMostSearchedItems();},onBlur:function onBlur(){return _this4.hideMostSearchedItems();},autoComplete:'off'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'h-100 btn-sm btn btn-flat btn-icon btn-icon-only','aria-label':this.props.isLoading?'Auto-completar: Carregando resultados...':'Buscar por produtos',id:'btn-search-loupe-mobile',onClick:function onClick(e){return!_this4.props.isLoading&&_this4.searchTrigger(e);},onBlur:function onBlur(){return _this4.props.emptySearch();},readOnly:this.props.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:!this.props.isLoading?'icon_search':'icon_loading',className:!this.props.isLoading?'color-brand-2':'color-ui-1'}))),this.state.hideSearchField&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'box-search-field-mobile-open',className:'h-100 btn-sm btn btn-flat btn-icon btn-icon-only','aria-label':'Exibir campo de busca',onClick:function onClick(){return _this4.showSearchField();},'aria-haspopup':'true','aria-expanded':!this.state.hideSearchField},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:!this.props.isLoading?'icon_search':'icon_loading',className:!this.props.isLoading?'color-ui-1':'color-brand-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-autocomplete col-12 px-1 border border-color-ui-4 bg-white radius-bottom '+(this.props.mostSearched&&!this.state.autoCompleteFilled?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-uppercase px-half txt-body-sm py-half mt-1'},'Termos mais buscados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pb-1'},this.props.mostSearched&&!this.state.autoCompleteFilled&&this.props.mostSearched.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{key:index,to:'/search?term='+element.name,onClick:function onClick(){_this4.emptySearch();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 py-1 px-half  bg-ui-4-hv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-subtitle txt-font-body bg-brand-1 d-inline-block radius-circle color-ui-white px-half py-half',style:{width:'22px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_3_left_pad___default()(index+1,2,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col text-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body color-ui-3'},element.name)))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-autocomplete col-12 px-1 border border-color-ui-4 bg-white radius-bottom '+(this.state.term!==''&&this.state.verifyTrigger&&(this.props.categories&&this.props.categories.length>0||this.props.services&&this.props.services.length>0||this.props.products&&this.props.products.length>0)?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row '+(this.state.verifyTrigger?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:''+(this.state.verifyTrigger?'d-block':'d-none')},this.props.categories&&this.state.autoCompleteFilled&&this.props.categories.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{key:index,to:'/search?term='+_this4.state.term+'&category='+element.id,onChange:function onChange(){return _this4.setTerm('');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 align-items-center h-100 py-1 bg-ui-4-hv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_search',className:'d-inline icon-sm color-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-auto color-ui-2 txt-body-sm'},_this4.state.term,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color-ui-3 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,element.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm'},element.count),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body-sm'},element.count===1?'resultado':'resultados')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 border-top border-color-ui-4 bg-white radius-bottom  '},this.props.services&&this.state.autoCompleteFilled&&this.props.services.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:element.path,onClick:function onClick(){_this4.emptySearch();},role:'link','aria-label':'Ver p\xE1gina do produto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img px-0 py-2 col-auto txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_image_fallback___default.a,{src:element.image,fallbackImage:__WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png___default.a,alt:element.name,className:'card-image-fallback search-img'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-subtitle txt-font-body color-ui-2 '},element.name.substring(0,70)+' '))))))));}),this.props.products&&this.state.autoCompleteFilled&&this.props.products.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/products/'+element.sku,onClick:function onClick(){_this4.emptySearch();},role:'link','aria-label':'Ver p\xE1gina do produto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img px-0 py-2 col-auto txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_image_fallback___default.a,{src:element.imageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_7__loyal_images_products_product_placeholder_png___default.a,alt:element.name,className:'card-image-fallback search-img'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-subtitle txt-font-body color-ui-2 '},element.name.substring(0,70)+' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/cart',className:'btn-featured btn-sm btn-icon pl-2 pr-3 radius',onClick:function onClick(e){var product={vendorId:element.vendor&&element.vendor.id,sku:element.sku};_this4.emptySearch();_this4.props.addItemCart(product);},role:'button','aria-label':'Adicionar produto ao carrinho'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_cart'})))))));})))))));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Search.propTypes={fetchSearch:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,emptySearch:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,addItemCart:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,redirect:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,categories:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,services:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,products:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,mostSearched:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,isLoading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* This program is free software. It comes without any warranty, to
     * the extent permitted by applicable law. You can redistribute it
     * and/or modify it under the terms of the Do What The Fuck You Want
     * To Public License, Version 2, as published by Sam Hocevar. See
     * http://www.wtfpl.net/ for more details. */

module.exports = leftPad;

var cache = [
  '',
  ' ',
  '  ',
  '   ',
  '    ',
  '     ',
  '      ',
  '       ',
  '        ',
  '         '
];

function leftPad (str, len, ch) {
  // convert `str` to a `string`
  str = str + '';
  // `len` is the `pad`'s length now
  len = len - str.length;
  // doesn't need to pad
  if (len <= 0) return str;
  // `ch` defaults to `' '`
  if (!ch && ch !== 0) ch = ' ';
  // convert `ch` to a `string` cuz it could be a number
  ch = ch + '';
  // cache common use cases
  if (ch === ' ' && len < 10) return cache[len] + str;
  // `pad` starts with an empty string
  var pad = '';
  // loop
  while (true) {
    // add `ch` to `pad` if `len` is odd
    if (len & 1) pad += ch;
    // divide `len` by 2, ditch the remainder
    len >>= 1;
    // "double" the `ch` so this operation count grows logarithmically on `len`
    // each time `ch` is "doubled", the `len` would need to be "doubled" too
    // similar to finding a value in binary search tree, hence O(log(n))
    if (len) ch += ch;
    // `len` is 0, exit the loop
    else break;
  }
  // pad `str`!
  return pad + str;
}


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emptySearch; });
var fetchSearch=function fetchSearch(term){return{type:'FETCH_SEARCH',payload:{client:'cloudloyalty',request:{method:'get',url:'/v2/products/autocomplete?term='+term}}};};var emptySearch=function emptySearch(){return{type:'EMPTY_SEARCH'};};

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadCart */
/* unused harmony export addItemToCartSuccess */
/* unused harmony export addItemToCartRedirectSuccess */
/* unused harmony export addItem */
/* unused harmony export dispatchShipping */
/* unused harmony export fetchShipping */
/* unused harmony export resetShipping */
/* unused harmony export clearCartError */
/* unused harmony export removeItem */
/* unused harmony export removeItemSuccess */
/* unused harmony export removeItemFail */
/* unused harmony export updateItem */
/* unused harmony export updateItemSuccess */
/* unused harmony export updateItemFail */
/* unused harmony export updateShippingAddress */
/* unused harmony export ChangeEmail */
/* unused harmony export updateCoupon */
/* unused harmony export removeCoupon */
/* unused harmony export clearCouponError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Address_actions_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
var loadCart=function loadCart(client,redirect){return function(){return function(dispatch,getState){if(redirect){dispatch({type:'FETCH_CART_REDIRECT'});}else{dispatch({type:'FETCH_CART'});}var handleSuccess=function handleSuccess(payload){dispatch({type:'FETCH_CART_SUCCESS',payload:payload});var _getState=getState(),address=_getState.address,addressParticipant=_getState.participant.address;if(address&&address.zipCode){dispatch(fetchShipping(address.zipCode));}else if(payload.data.shippingAddress){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Address_actions_js__["b" /* setAddress */])(payload.data.shippingAddress));}else if(addressParticipant&&addressParticipant.zipCode){var addressData={cepError:false,city:addressParticipant.city&&addressParticipant.city.value,district:addressParticipant.district&&addressParticipant.district.value,hasError:false,isLoading:false,state:addressParticipant.state&&addressParticipant.state.value,street:addressParticipant.addressText&&addressParticipant.addressText.value,zipCode:addressParticipant.zipCode&&addressParticipant.zipCode.value,number:addressParticipant.number&&addressParticipant.number.value,complement:addressParticipant.complement&&addressParticipant.complement.value,reference:addressParticipant.reference&&addressParticipant.reference.value};dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Address_actions_js__["b" /* setAddress */])(addressData));}if(redirect)dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/cart'));};var handleError=function handleError(err){dispatch({type:'FETCH_CART_FAIL',error:{data:err}});};client.get('/v1/carts/me').then(handleSuccess).catch(handleError);};};};var addItemToCartSuccess=function addItemToCartSuccess(_ref){var data=_ref.data;return{type:'ADD_ITEM_TO_CART_SUCCESS',payload:{data:data}};};var addItemToCartRedirectSuccess=function addItemToCartRedirectSuccess(_ref2){var data=_ref2.data;return{type:'ADD_ITEM_TO_CART_REDIRECT_SUCCESS',payload:{data:data}};};var addItem=function addItem(client){return function(body,redirect){return function(dispatch,getState){var _getState2=getState(),user=_getState2.oidc.user;if(!user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/auth/login'));}else{if(redirect){dispatch({type:'ADD_ITEM_TO_CART_REDIRECT'});}else{dispatch({type:'ADD_ITEM_TO_CART'});}var handleSuccess=function handleSuccess(response){if(redirect){dispatch(addItemToCartRedirectSuccess(response));}else{dispatch(addItemToCartSuccess(response));}dispatch(loadCart(client,redirect)());};var handleError=function handleError(err){dispatch({type:'ADD_ITEM_TO_CART_FAIL',error:{data:err}});dispatch(loadCart(client,false)());};client.post('/v1/carts/me/items',body).then(handleSuccess).catch(handleError);}};};};var dispatchShipping=function dispatchShipping(zipCode){return{type:'FETCH_CART_SHIPPING',payload:{client:'cloudloyalty',request:{url:'/v1/carts/me/shipping/rates/'+zipCode}}};};var fetchShipping=function fetchShipping(client){return function(zipCode){return function(dispatch){dispatch(dispatchShipping(zipCode));client.get('v1/addresses/'+zipCode).then(function(responseAddress){getModelAddress(responseAddress,zipCode);}).catch();client.get('v1/addresses/'+zipCode).then(function(responseAddress){getModelAddress(responseAddress,zipCode);}).catch();var getModelAddress=function getModelAddress(address,zipCode){var _address$data=address.data,streetType=_address$data.streetType,street=_address$data.street,district=_address$data.district,city=_address$data.city,state=_address$data.state;var model={street:(streetType+' '+street).trim(),district:''+district,city:''+city,state:''+state,zipCode:''+zipCode};dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__Address_actions_js__["b" /* setAddress */])(model));};};};};var resetShipping=function resetShipping(){return{type:'RESET_CART_SHIPPING'};};var clearCartError=function clearCartError(){return{type:'CLEAR_ERROR_CART'};};var removeItem=function removeItem(client){return function(sku){return function(dispatch,getState){dispatch({type:'REMOVE_ITEM_FROM_CART',sku:sku});var _getState3=getState(),address=_getState3.address,participantAddress=_getState3.participant.address;if(address&&address.zipCode){dispatch(fetchShipping(client)(address.zipCode));}else if(participantAddress&&participantAddress.zipCode){dispatch(fetchShipping(client)(participantAddress.zipCode));}var handleSuccess=function handleSuccess(response){dispatch(removeItemSuccess(response,sku));dispatch(loadCart(client)());};var handleError=function handleError(err){return dispatch(removeItemFail(err,sku));};client.delete('/v1/carts/me/items/'+sku).then(handleSuccess).catch(handleError);};};};var removeItemSuccess=function removeItemSuccess(response,sku){return{type:'REMOVE_ITEM_FROM_CART_SUCCESS',payload:null,sku:sku};};var removeItemFail=function removeItemFail(err,sku){return{type:'REMOVE_ITEM_FROM_CART_FAIL',error:{data:err},sku:sku};};var updateItem=function updateItem(client){return function(item){return function(dispatch,getState){var _getState4=getState(),address=_getState4.address,participantAddress=_getState4.participant.address;dispatch({type:'UPDATE_ITEM_FROM_CART'});dispatch({type:'FETCH_CART_SHIPPING'});var handleSuccess=function handleSuccess(response){dispatch(updateItemSuccess(response));dispatch(loadCart(client)());if(address&&address.zipCode){dispatch(fetchShipping(client)(address.zipCode));}else if(participantAddress&&participantAddress.zipCode){dispatch(fetchShipping(client)(participantAddress.zipCode));}};var handleError=function handleError(err){return dispatch(updateItemFail(err));};var sku=item.sku,vendorId=item.vendorId,quantity=item.quantity,email=item.email;client.put('/v1/carts/me/items/'+sku,{vendorId:vendorId,quantity:quantity,email:email}).then(handleSuccess).catch(handleError);};};};var updateItemSuccess=function updateItemSuccess(){return{type:'UPDATE_ITEM_FROM_CART_SUCCESS',payload:null};};var updateItemFail=function updateItemFail(err){return{type:'UPDATE_ITEM_FROM_CART_FAIL',error:{data:err}};};var updateShippingAddress=function updateShippingAddress(client){return function(body){return function(dispatch,_){dispatch({type:'UPDATE_SHIPPING_ADDRESS_TO_CART'});var handleSuccess=function handleSuccess(_){dispatch({type:'UPDATE_SHIPPING_ADDRESS_TO_CART_SUCCESS',shipping:body});dispatch(loadCart(client)());};var handleError=function handleError(err){return dispatch({type:'UPDATE_SHIPPING_ADDRESS_TO_CART_FAIL',error:{data:err}});};client.put('/v1/carts/me/shipping',body).then(handleSuccess).catch(handleError);};};};var ChangeEmail=function ChangeEmail(email){return{type:'CHANGE_EMAIL',email:email,payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/carts/1/me/emailAddress?email='+email}}};};var updateCoupon=function updateCoupon(code){return{type:'CART_UPDATE_COUPON',payload:{client:'cloudloyalty',request:{method:'patch',url:'/v1/carts/me/coupon',data:{code:code}}}};};var removeCoupon=function removeCoupon(){return{type:'CART_REMOVE_COUPON',payload:{client:'cloudloyalty',request:{method:'delete',url:'/v1/carts/me/coupon'}}};};var clearCouponError=function clearCouponError(){return{type:'CART_COUPON_CLEAR_ERROR'};};/* harmony default export */ __webpack_exports__["a"] = (function(client,redirect){return{loadCart:loadCart(client),ChangeEmail:ChangeEmail,addItemToCartSuccess:addItemToCartSuccess,addItem:addItem(client,redirect),fetchShipping:fetchShipping(client),removeItem:removeItem(client),updateItem:updateItem(client),resetShipping:resetShipping,updateShippingAddress:updateShippingAddress(client),clearCartError:clearCartError,updateCoupon:updateCoupon,removeCoupon:removeCoupon,clearCouponError:clearCouponError,redirect:Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/cart'),dispatchShipping:dispatchShipping};});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Summary__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_last_location__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_last_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_cart_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cart=function(_Component){_inherits(Cart,_Component);function Cart(props){_classCallCheck(this,Cart);var _this=_possibleConstructorReturn(this,(Cart.__proto__||Object.getPrototypeOf(Cart)).call(this,props));_this.state={sendGTM:false};_this.sendGTM=_this.sendGTM.bind(_this);return _this;}_createClass(Cart,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchCart();this.props.resetShipping();this.props.clearConfirmedOrderData();this.sendETMC();}},{key:'sendGTM',value:function sendGTM(){var props=this.props;if(Object.entries(props.items).length>0){this.setState({sendGTM:true});var productsList=[];props.items.map(function(item,index){var categoryName=void 0;if(item.category){categoryName=item.category.name!==''?__WEBPACK_IMPORTED_MODULE_4_react_slugify___default()(item.category.name,{delimiter:' '}):undefined;}return productsList.push({'name':__WEBPACK_IMPORTED_MODULE_4_react_slugify___default()(item.name,{delimiter:' '}),'id':item.sku,'price':item.price,'brand':undefined,'category':categoryName,'variant':undefined,'quantity':item.quantity,'coupon':undefined,'dimension5':item.vendor?'vendor-'+item.vendor.id:undefined,'metric2':item.cash?item.cash.sellingPrice.toFixed(2):undefined});});window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'checkout','eventCategory':'enhanced-ecommerce','eventAction':'checkout','ecommerce':{'checkout':{'actionField':{'step':'1'},'products':productsList}}});}}},{key:'sendETMC',value:function sendETMC(){var props=this.props;if(Object.entries(props.items).length>0){var productsList=[];props.items.map(function(item,index){return productsList.push({'item':item.sku,'quantity':999999,'price':item.price,'unique_id':item.sku});});window._etmc.push(['setOrgId','6422293']);window._etmc.push(['trackConversion',{'cart':productsList}]);}}},{key:'render',value:function render(){var ready=!this.props.isLoading||this.props.wasModified;if(this.state.sendGTM===false){this.sendGTM();}this.sendETMC();if(this.props.items.length<1&&ready){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Seu carrinho est\xE1 vazio - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container py-0 py-md-5 container-fluid '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-0 py-md-0 mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-0 py-md-0 mt-0 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__List__["b" /* ListEmpty */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Summary__["a" /* Summary */],Object.assign({},this.props,{ready:ready})))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Seu carrinho - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container py-0 py-md-5 container-fluid '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-1 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-0 py-md-0 mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_placeholder___default.a,{ready:ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__List__["c" /* ListPlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__List__["a" /* List */],Object.assign({},this.props,{sendGTM:this.sendGTM}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Summary__["a" /* Summary */],Object.assign({},this.props,{ready:ready}))))));}}]);return Cart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Cart.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,wasModified:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isUpdating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetchCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,resetShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,lastLocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,search:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),clearConfirmedOrderData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_last_location__["withLastLocation"])(Cart));

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardBrands__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VirtualVoucher__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loading__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Summary=function(_Component){_inherits(Summary,_Component);function Summary(){_classCallCheck(this,Summary);return _possibleConstructorReturn(this,(Summary.__proto__||Object.getPrototypeOf(Summary)).apply(this,arguments));}_createClass(Summary,[{key:'cardBrandIsloading',value:function cardBrandIsloading(qty,onlyCash){return this.props.isRedeemPointsMoreOthers&&!this.props.cardBrands.isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-brands row px-2 pb-3 '+(qty===0?'border-dotted-top border-color-ui-3 pt-2':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},onlyCash?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Pague com cart\xE3o de cr\xE9dito.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Confira as bandeiras aceitas.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Sem '+this.props.pointsName+' suficientes? N\xE3o se preocupe.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA pode completar seu resgate com dinheiro.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CardBrands__["a" /* CardBrands */],{brands:this.props.cardBrands.brands}))):'';}},{key:'convertCurrency',value:function convertCurrency(value,fixed){var number=parseFloat(value);return number.toFixed(fixed).replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$price=_props.price,price=_props$price===undefined?0:_props$price,_props$priceCash=_props.priceCash,priceCash=_props$priceCash===undefined?0:_props$priceCash,_props$count=_props.count,count=_props$count===undefined?0:_props$count,shipping=_props.shipping,ready=_props.ready;var total=price+(shipping.total||0);var totalCash=priceCash+(shipping.totalCash||0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7____["b" /* SummaryPlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Resumo do pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb--1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-quantity',className:'col-7 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},'Subtotal ('+count+' '+(count<=1?'item':'itens')+'):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-price',className:'col-5 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* Loading */],{ready:!this.props.isUpdating&&!this.props.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'cart-subtotal-price-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:price,cash:priceCash},checkCashOnly:true}))))),this.props.hasItemsDifferentVirtualVoucher?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'Frete:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-brand-4 txt-right justify-content-center align-selfe-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* Loading */],{ready:!shipping.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'cart-subtotal-shipping-value'},shipping.total?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:shipping.total,cash:shipping.totalCash},checkCashOnly:true}):'-')))):'',this.props.hasItemsVirtualVoucher?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VirtualVoucher__["a" /* VirtualVoucher */],this.props)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-shipping row py-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-total-value col-7 txt-body txt-font-body txt-left justify-content-center align-self-center'},'Valor Total:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-total-value col-5 txt-body color-brand-1 txt-font-body txt-right justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* Loading */],{ready:!this.props.isUpdating&&!this.props.isLoading&&!shipping.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'cart-subtotal-total-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:total,cash:totalCash},checkCashOnly:true}))))),count>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2 pt-1 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn '+(this.props.zipCodeHasValid?'btn-disabled':'')+' btn-featured btn-icon txt-button txt-font-body',onClick:function onClick(){return _this2.props.history.push('/checkout');},role:'button',disabled:this.props.zipCodeHasValid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_gift','aria-hidden':'true'}),this.props.onlyCash?'COMPRAR AGORA':'RESGATAR AGORA'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 pb-1 pt-0 row mx-0 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-0 px-0 row cart-shipping'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-7 px-0 txt-body txt-font-body txt-left justify-content-center align-self-center'},'Valor Total:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-5 px-0 txt-body txt-font-body txt-right justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* Loading */],{ready:!this.props.isUpdating&&!this.props.isLoading&&!shipping.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{id:'cart-subtotal-total-value-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:total,cash:totalCash},checkCashOnly:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn '+(this.props.zipCodeHasValid?'btn-disabled':'')+' btn-ssm btn-featured nowrap txt-center py-1',onClick:function onClick(){return _this2.props.history.push('/checkout');},role:'button',disabled:this.props.zipCodeHasValid},this.props.onlyCash?'COMPRAR AGORA':'RESGATAR AGORA')))):'',this.cardBrandIsloading(count,this.props.onlyCash)))));}}]);return Summary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Summary.propTypes={price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,priceCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,count:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,pointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isRedeemPointsMoreOthers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cardBrands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,hasItemsVoucherVirtual:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,everyItemsVirtualVoucher:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasItemsDifferentVirtualVoucher:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasItemsVirtualVoucher:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isUpdating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,shippingAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,zipCodeHasValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref){var onlyCash=_ref.onlyCash;return{onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,null)(Summary));

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VirtualVoucher__ = __webpack_require__(949);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VirtualVoucher__["a"]; });


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Viewer__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_clients__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var client=__WEBPACK_IMPORTED_MODULE_4_redux_clients__["a" /* default */].cloudloyalty.client;var VirtualVoucher=function(_Component){_inherits(VirtualVoucher,_Component);function VirtualVoucher(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VirtualVoucher);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VirtualVoucher.__proto__||Object.getPrototypeOf(VirtualVoucher)).call.apply(_ref,[this].concat(args))),_this),_this.state={email:_this.props.configuration&&_this.props.configuration.email||_this.props.customer.email,isFormOpen:false,dirty:false,isLoading:false},_this.handleEmail=function(event){return _this.setState({email:event.target.value,dirty:true});},_this.saveEmail=function(){_this.setState({isLoading:true});client.post('v1/carts/1/me/emailAddress?email='+_this.state.email).then(function(_){_this.setState({isLoading:false,isFormOpen:false,dirty:false});_this.props.fetchCart();});},_this.handleFormEdit=function(){return _this.setState({isFormOpen:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VirtualVoucher,[{key:'render',value:function render(){var email=this.props.participant.email;var emailCustomer=this.props.customer.email;var emailToEdit=this.state.dirty?this.state.email:emailCustomer;if(this.state.isFormOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Viewer__["a" /* Viewer */],{email:emailCustomer,isEditVisible:false,handleEdit:this.handleFormEdit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Form__["a" /* Form */],{email:emailToEdit,handleEmail:this.handleEmail,saveEmail:this.saveEmail,isLoading:this.state.isLoading}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Viewer__["a" /* Viewer */],{email:emailCustomer,isEditVisible:email.disabled==='false',handleEdit:this.handleFormEdit});}}]);return VirtualVoucher;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VirtualVoucher.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired}),configuration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),fetchCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (VirtualVoucher);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var Form=function Form(_ref){var email=_ref.email,handleEmail=_ref.handleEmail,saveEmail=_ref.saveEmail,isLoading=_ref.isLoading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'virtualVoucher-email',className:'col-12 pl-0',labelClass:'l-1 pl-half',label:'E-mail',value:email,onChange:handleEmail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'virtualVoucher-btn-saveEmail',className:'btn-icon btn-featured btn-icon-only',iconName:'icon_check',onClick:saveEmail,loading:isLoading}))));};Form.propTypes={email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,handleEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,saveEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Viewer__ = __webpack_require__(953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Viewer__["a"]; });


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var handleEditShow=function handleEditShow(isEditVisible,handleEdit){if(isEditVisible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'virtualVoucher-btn-editEmail',href:'javascript:void(0)',className:'txt-body-sm txt-font-body color-brand-1',onClick:handleEdit,role:'button'},'Alterar'));}return'';};var Viewer=function Viewer(_ref){var email=_ref.email,isEditVisible=_ref.isEditVisible,handleEdit=_ref.handleEdit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'E-mail:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right justify-content-center align-selfe-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'virtualVoucher-viewer-email',className:'txt-body-sm txt-font-body color-ui-2'},email),handleEditShow(isEditVisible,handleEdit)));};Viewer.propTypes={email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isEditVisible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,handleEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Viewer);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var printChildren=function printChildren(children){return children;};var Loading=function Loading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.ready&&printChildren(props.children),!props.ready&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none'},printChildren(props.children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-auto ml-auto loading-spinner '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)))));};Loading.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(21);
var CatalogCurrencyLabel=function CatalogCurrencyLabel(props){if(props.checkCashOnly&&props.onlyCash){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["b" /* CurrencyLabel */],{id:props.id,value:props.price.cash,prefixLabel:'R$ ',decimalPlaces:2,className:'txt-uppercase '+props.className,showpointsName:false});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["b" /* CurrencyLabel */],{id:props.id,label:props.label,value:props.value||props.price&&props.price.points||0,decimalPlaces:props.decimalPlaces,className:props.className,showpointsName:props.showpointsName});};CatalogCurrencyLabel.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,decimalPlaces:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,showpointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,checkCashOnly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref){var currencyConfiguration=_ref.catalog.currencyConfiguration,onlyCash=_ref.onlyCash;return{label:currencyConfiguration.pointsName,decimalPlaces:currencyConfiguration.decimalPlaces,onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(CatalogCurrencyLabel));

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SummaryPlaceholder=function(_Component){_inherits(SummaryPlaceholder,_Component);function SummaryPlaceholder(){_classCallCheck(this,SummaryPlaceholder);return _possibleConstructorReturn(this,(SummaryPlaceholder.__proto__||Object.getPrototypeOf(SummaryPlaceholder)).apply(this,arguments));}_createClass(SummaryPlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-4 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-quantity',className:'col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-price',className:'col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml-auto col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-quantity',className:'col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-price',className:'col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml-auto col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-quantity',className:'col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-price',className:'col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml-auto col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-2 px-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-quantity',className:'col-6 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cart-subtotal-price',className:'col-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml-auto col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml-auto col-12 pt-3 pb-2 bg-ui-3 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 py-half bg-ui-4 radius mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 pt-1 pb-2 bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 pt-1 pb-2 bg-ui-4 radius ml-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 pt-1 pb-2 bg-ui-4 radius ml-1'}))))))));}}]);return SummaryPlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SummaryPlaceholder);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListEmpty__ = __webpack_require__(970);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ListEmpty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListPlaceholder__ = __webpack_require__(971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ListPlaceholder__["a"]; });


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingCalculator__ = __webpack_require__(964);
var List=function List(props){var items=props.items,removeItem=props.removeItem,updateItem=props.updateItem,stores=props.stores,isUpdating=props.isUpdating,isLoading=props.isLoading,onlyCash=props.onlyCash,decimalPlaces=props.decimalPlaces,pointsName=props.pointsName,shippingAddress=props.shippingAddress;var ready=!isLoading&&!isUpdating;var list=items.map(function(item,key){var hasShipping=props.shipping.vendors&&props.shipping.vendors.length>0;var getVendor=function getVendor(){var vendor=props.shipping.vendors.filter(function(_ref){var id=_ref.id;return id===item.vendor.id;})[0];return vendor&&vendor.length>0?vendor[0]:null;};var shippingVendor=hasShipping?getVendor():null;var deliveryDate='';if(shippingVendor){deliveryDate=__WEBPACK_IMPORTED_MODULE_2_moment___default()(shippingVendor.deliveryDate).format('DD/MM/YYYY');}var vendor=stores.filter(function(store){return store.supplierId===item.vendor.id;})[0];var data=Object.assign({},item,{items:items,key:key,removeItem:removeItem,updateItem:updateItem,deliveryDate:deliveryDate,vendorName:vendor?vendor.name:'',ready:ready,onlyCash:onlyCash});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Item__["b" /* Item */],Object.assign({},data,{decimalPlaces:decimalPlaces,pointsName:pointsName,sendGTM:props.sendGTM}));});var zipCode=shippingAddress?shippingAddress.zipCode:'';var zipCodeParticipant=props.participant&&props.participant.address&&props.participant.address.zipCode?props.participant.address.zipCode.value:'';zipCode=zipCode||zipCodeParticipant;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 px-0 pr-md-2 mb-2 mb-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'color-title txt-font-body'},'Carrinho de compras')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},list,props.hasItemsDifferentVirtualVoucher?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShippingCalculator__["a" /* ShippingCalculator */],Object.assign({},props,{zipCodeValue:zipCode,decimalPlaces:props.decimalPlaces})):'')));};List.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,removeItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,updateItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,hasItemsDifferentVirtualVoucher:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isUpdating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,shippingAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,sendGTM:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriceDiscount__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard_TaggingPrice__ = __webpack_require__(962);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=function(_Component){_inherits(Item,_Component);function Item(props){_classCallCheck(this,Item);var _this=_possibleConstructorReturn(this,(Item.__proto__||Object.getPrototypeOf(Item)).call(this,props));_this.removeCartItem=function(){_this.setState({removeCartItem:true});setTimeout(function(){_this.remove();},300);};_this.remove=function(){var _this$props=_this.props,sku=_this$props.sku,removeItem=_this$props.removeItem;removeItem(sku);};_this.OnChangeInputHandle=function(e){_this.setState({quantity:parseInt(e.target.value),msgBlurField:'Saia do campo para salvar'});};_this.OnBlurInputHandle=function(){if(_this.state.quantity!==_this.props.quantity){_this.setState({msgBlurField:''});if(isNaN(_this.state.quantity)||parseInt(_this.state.quantity)<1){_this.setState({quantity:1});}_this.update(_this.state.quantity.toString());}};_this.update=_this.update.bind(_this);_this.delayedUpdate=null;_this.state={removeCartItem:false,quantity:_this.props.quantity||1,msgBlurField:''};return _this;}_createClass(Item,[{key:'Addition',value:function Addition(){var _this2=this;var quantity=parseInt(this.state.quantity)+1;this.setState({quantity:quantity});setTimeout(function(){_this2.update(_this2.state.quantity.toString());},300);}},{key:'Subtraction',value:function Subtraction(){var _this3=this;var quantity=parseInt(this.state.quantity)-1;this.setState({quantity:quantity});setTimeout(function(){_this3.update(_this3.state.quantity.toString());},300);}},{key:'update',value:function update(quantity){var _this4=this;var data={sku:this.props.sku,vendorId:this.props.vendor.id,quantity:quantity<1?1:quantity,email:this.props.email};this.props.updateItem(data);setTimeout(function(){_this4.props.sendGTM();},5000);}},{key:'convertCurrency',value:function convertCurrency(value,fixed){var number=parseFloat(value);return number.toFixed(fixed).replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row px-2 border-color-ui-3 border-bottom py-2'},this.state.removeCartItem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard_TaggingPrice__["a" /* default */],{type:'removeCart',identifier:'removeCart',position:'0',sku:this.props.sku,name:this.props.name,quantity:this.props.quantity.toString(),price:{points:this.props.price,cash:this.props.cash&&this.props.cash.sellingPrice||0}}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* Image */],{src:''+this.props.imageUrl,alt:'',className:'img-w-auto','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'txt-font-body txt-body-sm color-ui-2',to:'/products/'+this.props.sku},this.props.name,!this.props.ready&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_loading icon-ssm','aria-hidden':'true'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PriceDiscount__["a" /* PriceDiscount */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title-3 txt-circular-book txt-left color-ui-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:this.props.price,cash:this.props.cash&&this.props.cash.sellingPrice||0},checkCashOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},this.props.vendorName&&this.props.vendorName!=='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.vendorName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Fornecido e entregue por: ',this.props.vendorName)):'',this.props.deliveryDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},'Previs\xE3o de entrega: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.deliveryDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Previs\xE3o de entrega: ',this.props.deliveryDate)):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-action pos-relative col-12 col-md-auto txt-center mt-1 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-action-row row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto col-md-12',sku:this.props.sku},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-quantity form-field px-0 stix-quantity form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{role:'status',className:'hide-absolute'},this.state.msgBlurField),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-spinner pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'quantity-button icon icon_remove quantity-down',onClick:function onClick(){return _this5.props.ready&&_this5.Subtraction();},role:'button','aria-label':this.props.ready?'Subtrair um a quantidade':'Carregando','aria-disabled':!this.props.ready}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'input-spinner-vertical no-label qtd-points','aria-label':this.props.ready?'Quantidade':'Carregando',placeholder:'Quantidade',min:1,value:this.state.quantity,step:1,required:true,onChange:function onChange(e){return _this5.props.ready&&_this5.OnChangeInputHandle(e);},onBlur:function onBlur(e){return _this5.props.ready&&_this5.OnBlurInputHandle(e);},readOnly:!this.props.ready,'aria-disabled':!this.props.ready}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'quantity-button icon icon_more quantity-up',onClick:function onClick(){return _this5.props.ready&&_this5.Addition();},role:'button','aria-label':this.props.ready?'Adicionar um a quantidade':'Carregando','aria-disabled':!this.props.ready}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-remove txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'txt-body-sm color-ui-2 btn btn-sm btn-flat txt-initial txt-font-body py-1',onClick:this.removeCartItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true',className:'color-links border-color-links'},'Remover'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Remover produto')))))))));}}]);return Item;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Item.propTypes={sku:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,removeItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,vendor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,email:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,updateItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,deliveryDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,quantity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,vendorName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,ready:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,cash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,decimalPlaces:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,sendGTM:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PriceDiscount__ = __webpack_require__(961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PriceDiscount__["a"]; });


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var PriceDiscount=function PriceDiscount(_ref){var points=_ref.points,cash=_ref.cash,onlyCash=_ref.onlyCash;if(!onlyCash){if(points.regularPrice===0||points.regularPrice<=points.price){return'';}}return!onlyCash?points.regularPrice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-from col-12 txt-title-3 txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'de ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('s',{className:'pr-half'},points.regularPrice),'pts por'):'':cash.regularPrice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-from col-12 txt-title-3 txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'de R$ ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('s',{className:'pr-half'},cash.regularPrice),'por'):'';};PriceDiscount.propTypes={points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,cash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (PriceDiscount);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_slugify__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaggingPrice=function(_Component){_inherits(TaggingPrice,_Component);function TaggingPrice(props){_classCallCheck(this,TaggingPrice);var _this=_possibleConstructorReturn(this,(TaggingPrice.__proto__||Object.getPrototypeOf(TaggingPrice)).call(this,props));_this.state={sendGTM:false};return _this;}_createClass(TaggingPrice,[{key:'addDataLayer',value:function addDataLayer(productSku,productName,productPrice,productIdentifier,quantity,productPosition){window.dataLayer=window.dataLayer||[];if(this.props.type==='removeCart'){window.dataLayer.push({'event':'removeFromCart','eventCategory':'enhanced-ecommerce','eventAction':'removeFromCart','eventLabel':productSku+':removeFromCart','ecommerce':{'remove':{'products':[{'metric2':productPrice?productPrice.cash:undefined,'name':__WEBPACK_IMPORTED_MODULE_2_react_slugify___default()(productName,{delimiter:' '}),'id':productSku,'price':productPrice?productPrice.points:undefined,'category':undefined,'quantity':quantity}]}}});}this.setState({sendGTM:true});}},{key:'render',value:function render(){if(this.state.sendGTM===false&&this.props.price){this.addDataLayer(this.props.sku,this.props.name,this.props.price,this.props.identifier,this.props.quantity,this.props.position);}return'';}}]);return TaggingPrice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaggingPrice.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,quantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,identifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,position:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (TaggingPrice);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Image=function(_Component){_inherits(Image,_Component);function Image(){_classCallCheck(this,Image);var _this=_possibleConstructorReturn(this,(Image.__proto__||Object.getPrototypeOf(Image)).call(this));_this.state={};_this.fallback=function(){_this.setState({failed:true});};return _this;}_createClass(Image,[{key:'render',value:function render(){if(this.state.failed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default.a,alt:this.props.alt,className:this.props.className||'','aria-hidden':'true'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.src,onLoad:__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default.a,onError:this.fallback,alt:this.props.alt,className:this.props.className||'','aria-hidden':'true'});}}}]);return Image;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Image.propTypes={src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingCalculator__ = __webpack_require__(965);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingCalculator__["a"]; });


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingCalculed__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShippingCalculator=function(_Component){_inherits(ShippingCalculator,_Component);function ShippingCalculator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShippingCalculator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShippingCalculator.__proto__||Object.getPrototypeOf(ShippingCalculator)).call.apply(_ref,[this].concat(args))),_this),_this.state={zipCode:'',wasCalculed:false},_this.handleZipCodeChange=function(event){_this.setState({zipCode:event.target.value});},_this.calculate=function(zipCodeMemory){var zipCodeWithoutFormat=zipCodeMemory?_this.props.zipCodeValue:_this.state.zipCode;_this.props.fetchShipping(zipCodeWithoutFormat.replace('-',''));_this.setState({wasCalculed:true});},_this.handleUpdateAddress=function(shippingAddress){_this.props.updateShippingAddress(_this.createRequest({shippingAddress:shippingAddress}));},_this.isZipCodeValid=function(value){return!!value&&value.length===8;},_this.validateZipCode=function(){var _this$state$zipCode=_this.state.zipCode,number=_this$state$zipCode.number,value=_this$state$zipCode.value;var isValid=_this.isZipCodeValid(number);var zipCode={value:value,number:number,isValid:isValid};_this.setState({zipCode:zipCode,dirty:true});},_this.createRequest=function(shipping){return{customer:{name:_this.props.participant.name.value,documentNumber:_this.props.participant.cpf.value,email:_this.props.participant.email.value,birthDate:_this.props.participant.birthDate.value,genderType:_this.props.participant.genderType.value===1?'MALE':'FEMALE',personType:_this.props.participant.personType,phones:_this.props.participant.phones},shippingAddress:{street:_this.props.address.street,number:'',complement:'',district:_this.props.address.district,city:_this.props.address.city,state:_this.props.address.state,zipCode:_this.props.address.zipCode,reference:''}};},_this.edit=function(){_this.props.resetShipping();_this.setState({wasCalculed:false});},_this.editCEP=function(isLoading){_this.edit();!isLoading&&setTimeout(function(){document.querySelector('#zipCode').focus();},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShippingCalculator,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.zipCodeValue){this.calculate(true);}}},{key:'render',value:function render(){var _this2=this;var isLoading=this.props.shipping.isLoading||this.props.address.isLoading;var zipCode=this.props.participant.address.zipCode.disabled?!this.props.shipping.fetchShipping&&this.props.participant.address.zipCode.value!==''?this.props.participant.address.zipCode.value:'':this.props.shipping.fetchShipping&&this.props.address.zipCode===''?this.props.participant.address.zipCode.value:this.props.address.zipCode;if(!this.props.address.isLoading&&zipCode!==''&&this.props.shipping.fetchShipping){if(!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FIX_CART_ERROR)){this.handleUpdateAddress(zipCode);}}var props=Object.assign({},this.props,{zipCode:this.state.zipCode,handleZipCodeChange:this.handleZipCodeChange,calculate:this.calculate,edit:this.edit,isLoading:isLoading});var showShippingCalculed=this.state.wasCalculed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 px-md-3 bg-ui-5 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-shipping h-auto col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_truck',className:'color-brand-4 icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-uppercase txt-circular-black txt-body txt-left','aria-label':'cep para entrega'},'Cep para entrega')),showShippingCalculed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShippingCalculed__["a" /* ShippingCalculed */],Object.assign({},props,{decimalPlaces:props.decimalPlaces})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* Form */],props),!this.props.participant.address.zipCode.disabled?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 col-md-3 pl-2 ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:showShippingCalculed?'btnChangeShipping':'btnFetchShipping',className:'btn-sm',onClick:function onClick(){return showShippingCalculed?_this2.editCEP(props.isLoading):!showShippingCalculed&&!props.zipCode?false:_this2.calculate(false);},isLoading:props.isLoading,text:showShippingCalculed?'Alterar':'Calcular'})))));}}]);return ShippingCalculator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShippingCalculator.propTypes={address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,resetShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleUpdateAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,shippingAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isUpdatingShippingAddressToCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,updateShippingAddress:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,createRequest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,zipCodeValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ShippingCalculator);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var _this=this;var Form=function Form(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shippingNotCalculated col-7 col-md-4 mt-1 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'zipCode',label:'CEP',className:'col-12 pr-half',value:props.zipCode,onChange:props.handleZipCodeChange,valid:props.zipCode,onBlur:_this.validateZipCode,mask:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/],'data-error':'Digite um CEP v\xE1lido'})));};Form.propTypes={zipCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,handleZipCodeChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingCalculed__ = __webpack_require__(969);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingCalculed__["a"]; });


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var ShippingCalculed=function ShippingCalculed(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shippingCalculated col-12 col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md my-1 my-md-0'},!props.isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},props.address.zipCode),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle '+(props.shipping.error_get_shipping||props.shipping.error?'txt-uppercase txt-circular-black color-error':'')},!props.shipping.error_get_shipping&&!props.shipping.error?(props.address.streetType&&props.address.streetType+' '||'')+(props.address.street&&props.address.street+' - '||'')+(props.address.district&&props.address.district+' - '||'')+(props.address.city&&props.address.city+' - '||'')+props.address.state||'':'Não é possível entregar no CEP digitado.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{role:'status','aria-live':'assertive','aria-atomic':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_loading',className:'color-brand-4 icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Carregando...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 pl-half'},!props.isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-uppercase txt-circular-black txt-body txt-left color-brand-1'},props.shipping.error_get_shipping||props.shipping.error?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:props.shipping.total,cash:props.shipping.totalCash},checkCashOnly:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_loading',className:'color-brand-4 icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Carregando...')))));};ShippingCalculed.propTypes={address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({zipCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,cepError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,streetType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,street:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,district:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,city:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,state:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,totalCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,error_get_shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}),isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ShippingCalculed);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var ListEmpty=function ListEmpty(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 px-0 pr-md-2 mb-2 mb-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'color-title txt-font-body'},'Carrinho de compras')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 py-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-auto ml-auto bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_cart txt-headline color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-auto ml-auto col-7 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-center txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Seu carrinho est\xE1 vazio.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-center txt-body-sm'},'Voc\xEA ainda n\xE3o adicionou nenhum produto no carrinho.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-center txt-body-sm'},'Aproveite agora nossas ofertas!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-auto ml-auto txt-center col-8 col-md-4 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search',className:'btn btn-sm btn-featured txt-button txt-font-body',role:'button'},'Ver Produtos'))))));};/* harmony default export */ __webpack_exports__["a"] = (ListEmpty);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__);
var ListPlaceholder=function ListPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 px-0 pr-md-2 mb-2 mb-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-4 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 pb-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,alt:'Produto est\xE1 carregando...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-action pos-relative col-12 col-md-2 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-action-row row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 col-md-12 py-2 bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-remove'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 col-md-7 mr-auto ml-0 ml-md-auto py-half bg-ui-4 radius'}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 px-md-3 bg-ui-5  border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-shipping h-auto col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block pt-2 pb-half pl-2 pr-half bg-ui-3 radius-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-2 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-white radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 mr-auto py-half bg-white radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shippingNotCalculated mt-2 mt-md-0 px-2 px-md-0 col-12 col-md-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 pt-3 pb-2 mr-1  bg-white radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 pt-3 pb-2  bg-ui-3 radius'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pb-2 pt-3 px-3 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})))));};/* harmony default export */ __webpack_exports__["a"] = (ListPlaceholder);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(379));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(118);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(456);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_ducks__ = __webpack_require__(259);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(_ref){var onlyCash=_ref.onlyCash,address=_ref.address,cart=_ref.cart,_ref$catalog=_ref.catalog,_ref$catalog$currency=_ref$catalog.currencyConfiguration,pointsName=_ref$catalog$currency.pointsName,decimalPlaces=_ref$catalog$currency.decimalPlaces,redeemType=_ref$catalog.redeemType,cardBrands=_ref.cardBrands,participant=_ref.participant,_ref$stores=_ref.stores,ecommerce=_ref$stores.ecommerce,vouchers=_ref$stores.vouchers,services=_ref$stores.services;return Object.assign({},cart,{address:address,pointsName:pointsName,decimalPlaces:decimalPlaces,isRedeemPointsMoreOthers:Object(__WEBPACK_IMPORTED_MODULE_3_Catalog_ducks__["c" /* isRedeemPointsMoreOthers */])(redeemType),cardBrands:cardBrands,participant:participant,stores:[].concat(_toConsumableArray(ecommerce),_toConsumableArray(vouchers),_toConsumableArray(services)),onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCart:function fetchCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].loadCart());},fetchShipping:function fetchShipping(zipCode){dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].fetchShipping(zipCode));},clearConfirmedOrderData:function clearConfirmedOrderData(){dispatch({type:'CLEAR_CONFIRMED_ORDER_DATA'});},resetShipping:function resetShipping(){dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].resetShipping());},updateShippingAddress:function updateShippingAddress(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].updateShippingAddress(data));},removeItem:function removeItem(sku){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].removeItem(sku));},updateItem:function updateItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].updateItem(data));},clearCartError:function clearCartError(){dispatch({type:'CLEAR_ERROR_CART'});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Cart */],props);}));

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var typeVirtualVoucher='EXTERNALVOUCHERVIRTUAL';var equalsVirtualVoucher=function equalsVirtualVoucher(item){return item.vendor.type===typeVirtualVoucher;};var diffVirtualVoucher=function diffVirtualVoucher(item){return item.vendor.type!==typeVirtualVoucher;};var calculatorCount=function calculatorCount(current,item){return current+item.quantity;};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,wasModified:false,isUpdating:false,items:[],shipping:{isLoading:false,error_get_shipping:true},isUpdatingShippingAddressToCart:false,coupon:{isLoading:false}};var action=arguments[1];if(state.prop){delete state.prop;}switch(action.type){case'FETCH_CART':return Object.assign({},state,{isLoading:true});case'FETCH_CART_SUCCESS':var data=action.payload.data;var count=data.items.reduce(calculatorCount,0);var hasItemsVirtualVoucher=data.items.some(equalsVirtualVoucher);var hasItemsDifferentVirtualVoucher=data.items.some(diffVirtualVoucher);return Object.assign({},state,data,{isLoading:false,count:count,hasItemsVirtualVoucher:hasItemsVirtualVoucher,hasItemsDifferentVirtualVoucher:hasItemsDifferentVirtualVoucher,itemAdded:false,isError:false});case'CLEAR_ERROR_CART':return Object.assign({},state,{isLoading:false,error:null,hasError:false,errorData:[]});case'FETCH_CART_FAIL':var reponseFetchCartFail=action.error.data.response;return Object.assign({},state,{isLoading:false,error:action.error.data,itemAdded:false,isError:false,hasError:true,errorData:reponseFetchCartFail&&reponseFetchCartFail.data?reponseFetchCartFail.data:[],statusCode:action.status});case'FETCH_CART_REDIRECT':return Object.assign({},state);case'ADD_ITEM_TO_CART':return Object.assign({},state,{isLoading:true});case'ADD_ITEM_TO_CART_SUCCESS':return Object.assign({},state,{itemAdded:true});case'ADD_ITEM_TO_CART_FAIL':return Object.assign({},state,{isLoading:false,error:action.error.data,isError:true});case'ADD_ITEM_TO_CART_REDIRECT':return Object.assign({},state,{isLoadingRedirect:true});case'ADD_ITEM_TO_CART_REDIRECT_SUCCESS':return Object.assign({},state,{isLoadingRedirect:false});case'UPDATE_ITEM_FROM_CART':return Object.assign({},state,{isLoading:true,wasModified:true,isUpdating:true});case'UPDATE_ITEM_FROM_CART_SUCCESS':return Object.assign({},state,{isLoading:false,isUpdating:false});case'UPDATE_ITEM_FROM_CART_FAIL':var responseUpdateItemFail=action.error.data.response;return Object.assign({},state,{isLoading:false,isUpdating:false,error:action.error.data,shipping:{isLoading:false,error:action.error.data,fetchShipping:false,error_get_shipping:true},hasError:true,errorData:responseUpdateItemFail.data,statusCode:action.status});case'FETCH_CART_SHIPPING':return Object.assign({},state,{shipping:{isLoading:true,fetchShipping:false}});case'FETCH_CART_SHIPPING_SUCCESS':var deliveriesDate=action.payload.data.vendors.map(function(_ref){var deliveryDate=_ref.deliveryDate;return __WEBPACK_IMPORTED_MODULE_0_moment___default()(deliveryDate);});var maxDeliveryDate=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.max(deliveriesDate).format('DD/MM/YYYY');return Object.assign({},state,{shipping:Object.assign({isLoading:false},action.payload.data,{maxDeliveryDate:maxDeliveryDate,fetchShipping:true})});case'FETCH_CART_SHIPPING_FAIL':var response=action.error.response;return Object.assign({},state,{shipping:{isLoading:false,error:action.error.data,fetchShipping:false,error_get_shipping:true},hasError:true,errorData:response&&response.data?response.data:[],statusCode:action.status});case'RESET_CART_SHIPPING':return Object.assign({},state,{shipping:{isLoading:false,fetchShipping:false}});case'UPDATE_SHIPPING_ADDRESS_TO_CART':return Object.assign({},state,{updateShippingAddress:'loading'});case'UPDATE_SHIPPING_ADDRESS_TO_CART_SUCCESS':return Object.assign({},state,{updateShippingAddress:'success'});case'UPDATE_SHIPPING_ADDRESS_TO_CART_FAIL':return Object.assign({},state,{updateShippingAddress:'failed',shipping:{fetchShipping:false}});case'CHANGE_EMAIL':return Object.assign({},state);case'CHANGE_EMAIL_SUCCESS':return Object.assign({},state,{customer:Object.assign({},state.customer,{email:action.meta.previousAction.email})});case'CART_UPDATE_COUPON':return Object.assign({},state,{coupon:{isLoading:true}});case'CART_UPDATE_COUPON_SUCCESS':return Object.assign({},state,{coupon:Object.assign({isLoading:false,hasError:false},action.payload.data)});case'CART_UPDATE_COUPON_FAIL':return Object.assign({},state,{coupon:{isLoading:false,hasError:true}});case'CART_REMOVE_COUPON':return Object.assign({},state,{coupon:Object.assign({},state.coupon,{isLoading:true})});case'CART_REMOVE_COUPON_SUCCESS':return Object.assign({},state,{coupon:{isLoading:false}});case'CART_REMOVE_COUPON_FAIL':return Object.assign({},state,{coupon:Object.assign({},state.coupon,{isLoading:false})});case'CART_COUPON_CLEAR_ERROR':return Object.assign({},state,{coupon:Object.assign({},state.coupon,{hasError:false})});default:return Object.assign({},state);}});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mostSearched=[{name:'Celular'},{name:'Iphone'},{name:'Notebook'},{name:'Microondas'},{name:'Chapinha'},{name:'Secador'},{name:'Brinquedo'},{name:'TV'},{name:'Perfume'},{name:'Samsung'}];/* harmony default export */ __webpack_exports__["a"] = (mostSearched);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,services:[],products:[],subcategories:[],categories:[]};var action=arguments[1];var restrictProducts=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_RESTRICT_PRODUCTS?Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_RESTRICT_PRODUCTS.split(','):[];var checker=function checker(value){for(var i=0;i<restrictProducts.length;i++){if(value.indexOf(restrictProducts[i])>-1){return false;}}return true;};switch(action.type){case'FETCH_SEARCH':return Object.assign({},state,{isLoading:true});case'FETCH_SEARCH_SUCCESS':var subcategories=action.payload.data.subcategories;var products=action.payload.data.products;if(restrictProducts.length){products=products.filter(function(el){return checker(el.name.toLowerCase());});}return Object.assign({},state,{isLoading:false,services:action.payload.data.services,products:products,subcategories:action.payload.data.subcategories.slice(0,subcategories.length>5?5:subcategories.length),categories:action.payload.data.categories});case'FETCH_SEARCH_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});case'EMPTY_SEARCH':return Object.assign({},state,{isLoading:false,services:[],products:[],subcategories:[],categories:[]});default:return Object.assign({},state);}});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_autocomplete_css__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_template_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoCompleteProducts=function(_Component){_inherits(AutoCompleteProducts,_Component);function AutoCompleteProducts(){_classCallCheck(this,AutoCompleteProducts);return _possibleConstructorReturn(this,(AutoCompleteProducts.__proto__||Object.getPrototypeOf(AutoCompleteProducts)).apply(this,arguments));}_createClass(AutoCompleteProducts,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-autocomplete-products box-autocomplete col-12 px-1 border border-color-ui-4 bg-white radius-bottom '+(this.props.show?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row '+(this.props.verifyTrigger?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'mostSearchedCategories-title',className:'hide-absolute'},'Termo buscado nas categorias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:''+(this.props.verifyTrigger?'d-block':'d-none'),'aria-labelledby':'mostSearchedCategories-title'},this.props.categories&&this.props.autoCompleteFilled&&this.props.categories.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 align-items-center h-100 py-1 bg-ui-4-hv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_search',className:'d-inline icon-sm color-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-auto color-ui-2 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{key:index,to:'/search?term='+_this2.props.term+'&category='+element.id,onChange:function onChange(){return _this2.props.setTerm('');},onBlur:function onBlur(){return _this2.props.emptySearch();},className:'box-autocomplete-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},_this2.props.term,' na categoria ',element.name,_this2.props.products&&_this2.props.products.length===0&&_this2.props.services&&_this2.props.services.length===0&&_this2.props.categories.length-1===index&&' (Último item, continue para fechar)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},_this2.props.term),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color-ui-3 txt-body-sm','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',element.name)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},element.count===1?'Encontrado ':'Encontrados ',element.count,' ',element.count===1?'resultado':'resultados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm','aria-hidden':'true'},element.count,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body-sm','aria-hidden':'true'},element.count===1?'resultado':'resultados'))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 border-top border-color-ui-4 bg-white radius-bottom  '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'mostSearchedProducts-title',className:'hide-absolute'},'Sugest\xE3o de produtos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'aria-labelledby':'mostSearchedProducts-title'},this.props.services&&this.props.autoCompleteFilled&&this.props.services.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img px-0 py-2 col-auto txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_image_fallback___default.a,{src:element.image,fallbackImage:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default.a,alt:'',className:'card-image-fallback search-img','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:element.path,onClick:function onClick(){_this2.props.emptySearch();},onBlur:function onBlur(){return _this2.props.emptySearch();},className:'box-autocomplete-item txt-subtitle txt-font-body color-ui-2',role:'link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},element.name.substring(0,70)+' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},element.name+' ',' ',_this2.props.products&&_this2.props.products.length===0&&_this2.props.services.length-1===index&&'(Último item, continue para fechar)')))))))));}),this.props.products&&this.props.autoCompleteFilled&&this.props.products.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'cart-item row mx-0 bg-ui-4-hv px-2 border-bottom border-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img px-0 py-2 col-auto txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_image_fallback___default.a,{src:element.imageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default.a,alt:'Imagem do produto '+element.name,className:'card-image-fallback search-img'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/products/'+element.sku,onClick:function onClick(){_this2.props.emptySearch();},onBlur:function onBlur(){return _this2.props.emptySearch();},className:'box-autocomplete-item txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},element.name.substring(0,70)+' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},element.name+' '),_this2.props.products.length-1===index&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'(\xDAltimo item, continue para fechar)')))))))));})))));}}]);return AutoCompleteProducts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AutoCompleteProducts.propTypes={emptySearch:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,setTerm:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,term:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,categories:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,services:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,products:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,autoCompleteFilled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,verifyTrigger:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,show:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* unused harmony default export */ var _unused_webpack_default_export = (AutoCompleteProducts);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_accordion_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_molecules_accordion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(267);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cart=function(_Component){_inherits(Cart,_Component);function Cart(props){_classCallCheck(this,Cart);var _this=_possibleConstructorReturn(this,(Cart.__proto__||Object.getPrototypeOf(Cart)).call(this,props));_this.state={showResume:false};return _this;}_createClass(Cart,[{key:'componentDidMount',value:function componentDidMount(){this.props.loadCart();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.onlyCash!==this.props.onlyCash){this.props.loadCart();}}},{key:'handleResume',value:function handleResume(){this.setState({showResume:!this.state.showResume});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,price=_props.price,priceCash=_props.priceCash;var count=items.length;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cart zindex-high col-auto '+(this.props.desktop&&'d-none d-sm-block ')},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row align-items-center h-100 justify-content-end justify-content-sm-center px-3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a',{href:'javascript:void(0)',role:'button','aria-label':count>0?!this.state.showResume?'Abrir resumo do carrinho':'Fechar resumo carrinho':'Carrinho vazio',className:'d-block pt-1',onClick:function onClick(){return _this2.handleResume();},'aria-haspopup':count>0,'aria-expanded':count>0&&this.state.showResume},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-auto pos-relative'},count>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('strong',{role:'status','aria-live':'assertive','aria-atomic':'true',className:'cart-count color-brand-6 d-block txt-center w-100 txt-font-body pos-absolute'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:this.state.showResume&&'hide-absolute','aria-label':count+' produto'+(count>0&&'s')+' no carrinho'},count)):'',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:count>0?this.state.showResume?'icon_menu_app_close':'icon_cart':'icon_cart',className:'icon_only color-brand-5 cursor'})))),count>0?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-cart border-ui-3 bg-white radius py-2 '+(this.state.showResume&&'d-block')},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-header row mx-0 border-bottom border-color-ui-3 mx-0 px-2 pb-2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col mr-auto px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'txt-font-title txt-title color-title',to:'/cart'},'Ver carrinho')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-auto px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_right',className:'icon-sm'}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'panel-accordion active border-color-ui-3  pl-2 pr-1 py-1 bg-white'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'panel-scroll'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 px-0 '},count>0?items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7____["c" /* CartItem */],Object.assign({key:index},item));}):__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cart-item row mx-0 pr-1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA n\xE3o possui produtos no carrinho')))))))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-footer row mx-0 border-top border-color-ui-3 mx-0 px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col mx-0 mr-auto'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'txt-font-body txt-body-sm color-title'},'Subtotal :')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'txt-font-body txt-body-sm color-title'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:price,cash:priceCash},checkCashOnly:true}))),count>0&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 px-0 mt-1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'btn btn-sm d-block btn-featured txt-button txt-center txt-font-body',to:'/checkout',role:'button'},this.props.onlyCash?'Comprar Agora':'Resgatar Agora')))):'');}}]);return Cart;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);Cart.propTypes={items:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,onlyCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,price:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,priceCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,loadCart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,desktop:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Cart);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(267);
var mapStateToProps=function mapStateToProps(_ref){var cart=_ref.cart,onlyCash=_ref.onlyCash;return Object.assign({},cart,{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_2_features_Cart__["c" /* actions */].loadCart());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["a" /* Cart */],props);}));

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__);
var CartItem=function CartItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/products/'+props.sku,className:'cart-item row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img px-0 col-auto txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default.a,{src:props.imageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,className:'img-w-auto',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},props.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item pt-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-body txt-circular-black txt-left color-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:{points:props.price,cash:props.cash&&props.cash.sellingPrice||0},checkCashOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-quantity pt-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},'Quantidade: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.quantity))))));};CartItem.propTypes={imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,quantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CartItem);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile__ = __webpack_require__(457);
/* unused harmony reexport UserProfile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfileContainer__ = __webpack_require__(988);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__UserProfileContainer__["a"]; });


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfileSubmenu__ = __webpack_require__(984);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UserProfileSubmenu__["a"]; });


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_MainMenu_MenuItem__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WishlistMenuItem__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserProfileSubmenu=function(_Component){_inherits(UserProfileSubmenu,_Component);function UserProfileSubmenu(props){_classCallCheck(this,UserProfileSubmenu);var _this=_possibleConstructorReturn(this,(UserProfileSubmenu.__proto__||Object.getPrototypeOf(UserProfileSubmenu)).call(this,props));var externalExtractUrl=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_EXTRACT_URL;_this.state={items:[{path:externalExtractUrl||'/extract',label:'Extrato',order:1,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_EXTRACT,{default:true}),externalLink:!!Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_EXTRACT_URL},{path:'/my-orders',label:'Pedidos',order:2,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_ORDERS,{default:true})},{path:'https://viagens.webpremios.digital/meus-pedidos',label:'Minhas viagens',order:3,campaingId:"80938",hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_TRAVEL,{default:true})},{path:'/checkout/points-purchase',label:'Comprar pontos',order:4,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()("false",{default:true})},{path:'/scheduling',label:'Resgates recorrentes',order:4,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()("false",{default:true})},{path:'/profile',label:'Informações Pessoais',order:5,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_PROFILE,{default:true})},{path:'/my-address',label:'Endereço',order:6,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_ADDRESS,{default:true})},{path:"https://onboarding.webpremios.com.br/Login/RedirectCognito?id="+props.campaing_Id,label:'Verificação em Duas Etapas',order:7,target:'_blank',campaingId:props.campaing_Id,hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()("false",{default:true})},{path:__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_SECURITY_ACCESS)?'/security-access':'/my-account/change-password',label:__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_SECURITY_ACCESS)?'Acessos e segurança':'Alterar Senha',order:8,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_SECURITY,{default:true})},{path:'/auth/logout',label:'Sair',type:'logout',order:9,target:'_self',hide:!__WEBPACK_IMPORTED_MODULE_5_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_LOGOUT,{default:true})}]};_this.itemsOrdered=_this.state.items.sort(function(a,b){return a.order-b.order;});return _this;}_createClass(UserProfileSubmenu,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'profile-list',className:'bg-brand-5 profile-submenu radius border border-color-ui-4 pb-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 mx-0 radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{role:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WishlistMenuItem__["a" /* default */],null),this.itemsOrdered.map(function(item,indexItem){return!item.hide&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-0 py-0',role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_MainMenu_MenuItem__["a" /* MenuItem */],Object.assign({key:indexItem},item,{onBlurLink:_this2.props.onBlurLink})));})))));}}]);return UserProfileSubmenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserProfileSubmenu.propTypes={campaing_Id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onBlurLink:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,login:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,catalog_id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};var mapStateToProps=function mapStateToProps(_ref){var oidc=_ref.oidc;return{campaing_Id:oidc.user.profile['custom:campaign_id'],catalog_id:oidc.user.profile['custom:catalog_id'],login:oidc.user.profile.preferred_username};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(UserProfileSubmenu));

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WishlistMenuItemContainer__ = __webpack_require__(986);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WishlistMenuItemContainer__["a"]; });


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WishlistMenuItem__ = __webpack_require__(987);
var mapStateToProps=function mapStateToProps(_ref){var products=_ref.wishlistv2.products;return{count:products&&products.length};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__WishlistMenuItem__["a" /* default */]));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var WishlistMenuItem=function WishlistMenuItem(_ref){var count=_ref.count;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{role:'menuitem',className:'txt-left p-0 m-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-half '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 py-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_wishlist color-brand-1','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col my-auto ml-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/wishlist',className:'link-wishlist link-profile txt-font-body txt-body color-no-hv d-block px-1 py-1 color-brand-1 txt-bold','aria-label':'Lista de favoritos, '+count+' '+(count===1?'item':'itens')+' na lista'},'Favoritos')),count>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'aria-hidden':true,className:'col-auto ml-auto my-auto mr-2 wishlist-count txt-body-sm border radius-circle py-half px-1 border-color-ui-4 bg-ui-4 color-brand-1'},count)));};WishlistMenuItem.propTypes={count:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};WishlistMenuItem.defaultProps={itemCount:0};/* harmony default export */ __webpack_exports__["a"] = (WishlistMenuItem);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(989);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},state.oidc.user.profile,{catalog:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* getCatalogData */])(state),balance:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* getBalanceData */])(state)});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__UserProfile__["a" /* default */]));

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBalanceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCatalogData; });
/* unused harmony export getWishlist */
var getBalanceData=function getBalanceData(_ref){var balance=_ref.balance;return balance;};var getCatalogData=function getCatalogData(_ref2){var pointsName=_ref2.catalog.currencyConfiguration.pointsName;return{pointsName:pointsName};};var getWishlist=function getWishlist(_ref3){var wishlist=_ref3.wishlist;return wishlist;};

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_tracking_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_tracking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_tracking_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_Header_Tracking_Item_Status__ = __webpack_require__(459);
var TrackingItem=function TrackingItem(props){return props.tracking&&props.tracking.statuses?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-tracking col-12 px-0 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-ui-2 txt-uppercase txt-body txt-circular-black'},'DETALHE DO RASTREAMENTO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tracking-steps col-12 px-0'},props.tracking.statuses.map(function(track,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App_Header_Tracking_Item_Status__["b" /* Status */],{status:track,index:index});})))):'';};TrackingItem.propTypes={tracking:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (TrackingItem);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Name__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__When__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var Status=function Status(_ref){var status=_ref.status,name=_ref.name,className=_ref.className,index=_ref.index;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Name__["a" /* default */],status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__When__["a" /* default */],status))));};Status.propTypes={status:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,index:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Status);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var getIconNameByStatus=function getIconNameByStatus(status){switch(status){case'1':case'2':case'6':case'9':case'10':case'5':return'icon_check_circle';case'3':case'4':case'8':case'7':return'icon_truck';default:return'';}};var getIconClassNameByStatus=function getIconClassNameByStatus(status){switch(status){case'1':case'2':case'3':case'4':case'5':return'color-success icon-md';case'6':case'7':case'8':case'9':case'10':return'color-error icon-md';default:return'icon-md';}};var Icon=function Icon(_ref){var status=_ref.status,when=_ref.when;return getIconNameByStatus(status)?getIconClassNameByStatus(when&&status)==='color-success icon-md'||getIconClassNameByStatus(when&&status)==='color-error icon-md'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:getIconNameByStatus(status),className:getIconClassNameByStatus(when&&status)}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-half py-half mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto py-half px-half bg-ui-2 radius-circle','aria-hidden':'true'})):'';};Icon.propTypes={status:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,when:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var When=function When(_ref){var when=_ref.when;var whenStatus=when&&__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(when).format('DD/MM/YYYY [às] HH[h]mm');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle pt-half'},whenStatus!==null&&'em '+whenStatus);};When.propTypes={when:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (When);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var ProductShipping=function ProductShipping(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-shipping col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_truck',className:'color-brand-1 icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Transportadora:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.trackingVtexData.courier)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'C\xF3digo de rastreamento:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.trackingVtexData.trackingNumber)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 pl-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){window.open(props.trackingVtexData.trackingUrl);}},'Rastrear Pedido'))));};ProductShipping.prototype={trackingVtexData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};ProductShipping.propTypes={trackingVtexData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (ProductShipping);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_features_ProductImage__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TrackingItemPlaceholder__ = __webpack_require__(1000);
var voucherName='DSHOP';var getVoucherLink=function getVoucherLink(props){var model={OrderId:props.orderDetail.orderId,CatalogId:props.orderDetail.catalogId,VendorId:props.orderDetail.vendorId,ClientId:props.orderDetail.clientId};props.handleVoucherLink(model);};var veryfyCustomMessage=function veryfyCustomMessage(props){var vendorName=props.parentOrderDetail.vendorOrderModel[0].vendorName;var vendorType=props.orderDetail.vendorType;switch(vendorType){case'Milhas':return'Transfer\xEAncia de pontos para '+vendorName;default:return props.productDetail.name;}};var ProductSide=function ProductSide(props){var decimalValue=props&&props.parentOrderDetail&&props.parentOrderDetail.orderPaymentDetailMoneyAndPoints&&props.parentOrderDetail.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal;var pointsUsedDecimal=props.parentOrderDetail.orderPaymentDetailMoneyAndPoints&&props.parentOrderDetail.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal;var storeDescription=props.storeConfiguration&&props.storeConfiguration.description&&props.storeConfiguration.description.toUpperCase();var storeName=props.parentOrderDetail.vendorOrderModel[0].vendorName.toUpperCase();var unitValue=null;var donationValue=props&&props.productDetail&&props.productDetail.currencySellingPrice;if(props.parentOrderDetail.vendorOrderModel[0].vendorName==='Compra de Pontos'){unitValue=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ ',addZeroes(decimalValue)));}else if(props.parentOrderDetail.paymentType===5){unitValue=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2'},'Valor unit\xE1rio: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ ',addZeroes(decimalValue)));}else if(props.orderDetail.vendorType==='Doação'){unitValue=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2'},'Valor em pontos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:pointsUsedDecimal!==props.productDetail.sellingPrice&&pointsUsedDecimal!==0?pointsUsedDecimal:props.productDetail.sellingPrice}),props&&props.productDetail&&props.productDetail.currencySellingPrice?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Valor: R$ ',addZeroes(donationValue)):'');}else{unitValue=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2'},'Valor',props.orderDetail.vendorType!=='Milhas'&&' unitário',':',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:pointsUsedDecimal!==props.productDetail.sellingPrice&&pointsUsedDecimal!==0?pointsUsedDecimal:props.productDetail.sellingPrice}),props.parentOrderDetail.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal!==0&&props.parentOrderDetail.paymentType===2?' + R$ '+addZeroes(props.parentOrderDetail.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal):'');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 px-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["c" /* Title */],{orderId:props.parentOrderDetail.parentOrderId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_features_ProductImage__["a" /* ProductImage */],{name:props.productDetail.name,alt:props.productDetail.name,imageUrl:props.productDetail.imageUrl,vendorId:props.orderDetail.vendorId,vendorType:props.orderDetail.vendorType,ready:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},veryfyCustomMessage(props)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item  mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},props.orderDetail.vendorType==='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block'},'Quantidade:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.productDetail.quantity*props.packageSize})):props.orderDetail.vendorType!=='Milhas'&&props.orderDetail.vendorType!=='Doação'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Quantidade:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.productDetail.quantity))),unitValue,props.productDetail.deliveryForecastParticipant?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Previs\xE3o de entrega:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(props.productDetail.deliveryForecastParticipant).format('DD/MM/YYYY'))):'')))),props.orderDetail.trackingVtexData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-3 border-color-ui-3 border-bottom py-2 d-print-none '+(!props.productDetail.tracking?'d-none':'')+' '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* ProductShipping */],{trackingVtexData:props.orderDetail.trackingVtexData})):__WEBPACK_IMPORTED_MODULE_5____["e" /* availableVendors */].includes(props.orderDetail.vendorId)&&props.tracking?// eslint-disable-next-line react/jsx-indent
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-3 border-color-ui-3 border-bottom py-2 '+(!props.productDetail.tracking?'d-none':'')+' '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_placeholder___default.a,{ready:!!props.tracking,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TrackingItemPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["d" /* TrackingItem */],{tracking:props.tracking})))):props.orderDetail.vendorType==='e-Commerce'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-3 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_placeholder___default.a,{ready:props.showPlaceholder,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TrackingItemPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["d" /* TrackingItem */],{tracking:props.orderDetail.vendorType==='e-Commerce'&&props.orderDetail.items.length>0&&props.trackingAlternative})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-0 border-color-ui-3 border-bottom'},storeName.includes(voucherName)||storeDescription&&storeDescription.includes(voucherName)?// eslint-disable-next-line react/jsx-indent
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 mx-0 px-3 bg-ui-5 border-color-ui-3 border-top border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 col-12 col-md-9 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Consulte para saber mais sobre o envio do seu cupom.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 col-12 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{className:'btn btn-featured btn-cart',text:'Consultar',onClick:function onClick(){return getVoucherLink(props);}}))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block row col-12 py-1 px-2 d-print-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-back px-0 txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:props.previousRoute||'/my-orders/',className:'btn btn-sm btn-flat btn-icon txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_left',className:'icon icon-smr'}),'Ver todos os pedidos'))))));};function addZeroes(value){var newValue=value*1;newValue=newValue+'';var pos=newValue.indexOf('.');if(pos===-1)newValue=newValue+'.00';else{var integer=newValue.substring(0,pos);var decimals=newValue.substring(pos+1);while(decimals.length<2){decimals=decimals+'0';}newValue=integer+','+decimals;}return newValue.toString().replace('.',',');}ProductSide.propTypes={productDetail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,parentOrderDetail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,orderDetail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,previousRoute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tracking:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,showPlaceholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,storeConfiguration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,trackingAlternative:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductSide);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Placeholder__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__);
var ProductImage=function ProductImage(props){var img;var src;var alt='';if(props.vendorType==='Compra de Pontos'){src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.PURCHASEPOINTS.IMAGEURL;alt=props.alt;}else if(props.vendorType==='Doação'){src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.DONATION.IMAGEURL;alt=props.alt;}else if(props.vendorType==='Recarga Celular'){src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.CELLPHONERECHARGE.IMAGEURL;alt=props.alt;}else{switch(props.vendorId){case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SMILES.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SMILES.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SHELL.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SHELL.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.PAYBILLS.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.PAYBILLS.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.PURCHASEPOINTS.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.PURCHASEPOINTS.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.DONATION.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.DONATION.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.CELLPHONERECHARGE.ID:var srcRecharge;var altRecharge;for(var property in __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OPERATORS){var operator=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OPERATORS[property];if(props.alt.toUpperCase().indexOf(operator.description.toUpperCase())>-1){srcRecharge=operator.IMAGEURL;altRecharge=operator.description;break;}}src=srcRecharge||__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.CELLPHONERECHARGE.IMAGEURL;alt=altRecharge||props.alt;break;}}img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.imageUrl||src||__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,alt:props.alt||alt,'aria-hidden':props.ariaHidden||false});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:props.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Placeholder__["a" /* default */],null)},img);};ProductImage.propTypes={imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vendorType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,ariaHidden:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ProductImage);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VENDOR */
/* unused harmony export OPERATORS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_orders_mobile_png__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_orders_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__loyal_images_orders_mobile_png__);
var VENDOR={SHELL:{ID:117,IMAGEURL:__WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg___default.a},SMILES:{ID:21185,IMAGEURL:__WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg___default.a},PURCHASEPOINTS:{ID:61594,IMAGEURL:__WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg___default.a},PAYBILLS:{ID:21188,IMAGEURL:__WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg___default.a},DONATION:{ID:54,IMAGEURL:__WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg___default.a},CELLPHONERECHARGE:{ID:71,IMAGEURL:__WEBPACK_IMPORTED_MODULE_11__loyal_images_orders_mobile_png___default.a}};var OPERATORS={BRT:{description:'Brasil Telecom',IMAGEURL:__WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg___default.a},CLARO:{description:'Claro',IMAGEURL:__WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg___default.a},NEXTEL:{description:'Nextel',IMAGEURL:__WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg___default.a},OI:{description:'Oi',IMAGEURL:__WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg___default.a},TIM:{description:'Tim',IMAGEURL:__WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg___default.a},VIVO:{description:'Vivo',IMAGEURL:__WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg___default.a}};/* harmony default export */ __webpack_exports__["a"] = ({VENDOR:VENDOR,OPERATORS:OPERATORS});

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAABHNCSVQICAgIfAhkiAAAAttJREFUeF7tmdtLVFEUh39zy0wqK4sYzSavk1pKpfQgRQQGmoxMERL9Y7700FVpLNRBpoheeohIBq+VOnmZHIoiHaULOZcT+wQh5ZGzbI7R4bee9z7s8+1vrX3OXg5N0zQw/iDgIJj1rSAYg2whGIKRFVIaQ2NojIwAjZHxYo2hMTRGRoDGyHixxtAYGiMjQGNkvFhjaAyNkRH4l8Zks1lMz8zj/uAjzC8kkE5nRIt3uVzwHSpGe8s51FRVwOl0iuZvZvCW1Ji5twnc7u3HbHxhM2v8Nae02IvOjjZUlfv+6jlmJlsOJpvVEB2bQNeNbqiGhNp9j9ttetfVnFQ6pVvmdDpw7XIAzU0nTc83A2G9MZaDyWQyeB4dxfW7IXg8HlSXH4G/sgwF+dtNrfnb91VMxmbwcuoNUqkUrgbbceZ0I9xul6n5mx20pWAqfKW4dPECKstkqaBSsftBGLG5uD3BnKqvQ7CtBQeK9ok28tPiEu4NRDA0Mm5PMI0NxxBsbcH+or0iMItLSR3Mi+ExgllLjmAMPCIYgmGNwdrvGBbfNSmRCzDquA6FH/JU+r3U8DvGoPgSDMHITiUaQ2NoTE6+Y5hKTCWmUu5SKRzB0LBNL6qO11TrF1Ul3oOii6r3Hz6ip28QY6+m7HlRtadwt36R3VDrR17eNlNwVldTGJ+cxpOnz7CYXLYnGIfDgcJdO6EAqTaKmVA/ocnlFSwtr+jtF1t2CTYCUV/r12FFRyc25GUbMFlNQ3RkHF03e/QdN4orgVa9V3Snd8BwzM+GWweam078/w039ZaqNXsr1K/3rY2iYEc+VKp9/vLVcIwq2p2BNr1hZ3VY3nBTL5BOp/E6Nou+yGPEE+/0I1wSqol/uMSL1vNnUXe0Sm/xWh1bAsbql7Di+QRjQJVgCEaWcDSGxtAYGQEaI+PFGkNjaIyMAI2R8WKNoTE0RkaAxsh4scbQGBojI0BjZLx+APgXIVzbd61fAAAAAElFTkSuQmCC"

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg__);
var Placeholder=function Placeholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg___default.a,alt:'Ainda est\xE1 carregando...'});};/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TrackingItemPlaceholder=function TrackingItemPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-tracking col-12 px-0 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-ui-2 txt-uppercase txt-body txt-circular-black'},'DETALHE DO RASTREAMENTO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tracking-steps col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto py-2 px-2 bg-ui-3 radius-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 mt-1 py-half bg-ui-4 radius'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (TrackingItemPlaceholder);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ProductSideEmpty=function ProductSideEmpty(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-8 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},'Produto n\xE3o encontrado')));};/* unused harmony default export */ var _unused_webpack_default_export = (ProductSideEmpty);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Title=function Title(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'color-title txt-font-body'},'Pedido: #',props.orderId));};Title.propTypes={orderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([46,58,59,60,62,20987,106,21004,21145,21146,21147,21148,21150,21151,21153,21154,21155,21156,21157,21158,21159,21160,21161,21162,21163,21167,21168,21169,21172,21176,21178,21181,21184,21209,21210,21217,21219,21221,21236,21239,21247,21249,21250,21252,21255,21256,21260,21264,21266,21271,21272,21273,21274,21275,41415,41417,41419,41421,41439,51451,51452,51453,51454,51455,61638,61642,61688,61644,61645,61654,61647,61648,61651,61652,61715,61716,61717,61718,61719,61720,61721,61725]);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tracking__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(458);
var mapStateToProps=function mapStateToProps(_ref){var _ref$ordersTracking=_ref.ordersTracking,orderItems=_ref$ordersTracking.orderItems,loading=_ref$ordersTracking.loading,totalRows=_ref$ordersTracking.totalRows,tracking=_ref$ordersTracking.tracking,hasMoreItems=_ref$ordersTracking.hasMoreItems;return{orderItems:orderItems,totalRows:totalRows,loading:loading,tracking:tracking,hasMoreItems:hasMoreItems};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{getOrderDetails:function getOrderDetails(parentOrderId,orderId,productId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* getOrderListDetails */])(null,orderId,null));},loadProductsTracking:function loadProductsTracking(pageIndex,pageSize){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* loadProductsTracking */])(false,pageIndex,pageSize));},insertNetshoesLastEvent:function insertNetshoesLastEvent(orderId,status){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* insertNetshoesLastEvent */])(orderId,status));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__Tracking__["a" /* default */]));

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_owl_carousel2__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_owl_carousel2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_owl_carousel2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(1006);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tracking=function(_Component){_inherits(Tracking,_Component);function Tracking(props){_classCallCheck(this,Tracking);var _this=_possibleConstructorReturn(this,(Tracking.__proto__||Object.getPrototypeOf(Tracking)).call(this,props));_this.state={options:{margin:10,autoplay:false,dots:false,nav:false,rewind:false,loop:false,callbacks:true,responsive:{0:{items:1,stagePadding:10,loop:false,rewind:false}},navClass:['pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon','pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'],navText:['<i class=\'icon icon_left icon-sm color-ui-white\'></i>','<i class=\'icon icon_right icon-sm color-ui-white\'></i>']},pageIndex:1,pageSize:1};_this.loadProductsTracking=_this.loadProductsTracking.bind(_this);_this.next=_this.next.bind(_this);_this.prev=_this.prev.bind(_this);_this.loadNextCard=_this.loadNextCard.bind(_this);return _this;}_createClass(Tracking,[{key:'componentDidMount',value:function componentDidMount(){this.loadProductsTracking();}},{key:'next',value:function next(){this.refs.orders.next();setTimeout(this.loadNextCard,300);}},{key:'prev',value:function prev(){this.refs.orders.prev();}},{key:'loadNextCard',value:function loadNextCard(){var nextPosition=this.refs.orders.currentPosition;var lastPosition=this.state.pageIndex*this.state.pageSize;if(!this.props.loading&&nextPosition===lastPosition&&this.props.hasMoreItems){this.loadNextPageProductsTracking();}}},{key:'loadProductsTracking',value:function loadProductsTracking(){this.props.loadProductsTracking(this.state.pageIndex,this.state.pageSize);}},{key:'loadNextPageProductsTracking',value:function loadNextPageProductsTracking(){this.setState({pageIndex:this.state.pageIndex+1},this.loadProductsTracking);}},{key:'render',value:function render(){var _this2=this;var items=null;if(this.props.orderItems&&this.props.orderItems.length>0){items=this.props.orderItems.map(function(orderItem,index){var visible=_this2.props.tracking&&_this2.props.tracking[orderItem.id]&&!_this2.props.tracking[orderItem.id].loading;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* Item */],Object.assign({},_this2.props,{loading:false,order:orderItem,index:index,style:{visibility:visible?'visible':'hidden'}}));});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'tracking zindex-high col-md-1 col-auto order-md-4 order-3 d-none d-lg-block','aria-haspopup':this.props.totalRows&&this.props.totalRows>0},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row align-items-center h-100 justify-content-end justify-content-lg-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["Link"],{className:'d-block',to:'/my-orders',tabIndex:0,'aria-label':'Meus pedidos'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-auto pos-relative'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('strong',{className:'tracking-count color-success txt-center txt-font-body pos-absolute'},this.props.totalRows>0?this.props.totalRows:''),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'traking-status border-ui-3 radius-circle p-1 '+(this.props.totalRows>0?'':'percent-0')},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_truck',className:'icon_only color-brand-5 cursor'}))))),items&&items.length>0&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-tracking bg-ui-5 radius pb-0 border-ui-3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-header bg-white row  align-items-center h-100 mx-0 border-bottom border-color-ui-3 mx-0 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col mr-auto px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'h3 txt-font-title txt-title color-title'},'Pedidos')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'icon icon_left icon-sm color-ui-3 cursor',onClick:this.prev})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'icon icon_right icon-sm color-ui-3 cursor',onClick:this.next}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'resume-body row mx-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'panel-accordion active border-color-ui-3  px-1 py-1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'tracking-empty d-none  orders-item row mx-0 pt-1  pb-3 px-1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'mr-auto ml-auto bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i',{className:'icon icon_truck txt-headline color-brand-1','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 mr-auto ml-auto  clearfix'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 px-0 mr-auto ml-auto  mt-2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',{className:'txt-center txt-body'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('strong',null,'Voc\xEA n\xE3o possui pedidos em andamento')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'txt-center txt-body-sm'},'Aproveite nossas ofertas agora mesmo.')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-8 mr-auto ml-auto  mt-2'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('button',{className:'btn btn-sm btn-featured'},'Ver ofertas'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'tracking-list orders-item row mx-0 pt-1 px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_owl_carousel2___default.a,{ref:'orders',className:'bx-slider w-100 mx-0 owl-carousel owl-theme',options:this.state.options},items,this.props.hasMoreItems&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* Item */],{loading:true})))))));}}]);return Tracking;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);Tracking.propTypes={orders:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,orderstracking:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,getOrderDetails:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,loadProductsTracking:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,insertNetshoesLastEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,orderItems:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,totalRows:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,loading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,hasMoreItems:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,tracking:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Tracking);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ItemContainer__ = __webpack_require__(1007);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ItemContainer__["a"]; });


/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Placeholder__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(268);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ItemContainer=function(_Component){_inherits(ItemContainer,_Component);function ItemContainer(){_classCallCheck(this,ItemContainer);return _possibleConstructorReturn(this,(ItemContainer.__proto__||Object.getPrototypeOf(ItemContainer)).apply(this,arguments));}_createClass(ItemContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.getTrackingStatuses();}},{key:'render',value:function render(){var placeHolder=!!this.props.loading||!this.props.tracking||!!this.props.tracking.loading;var render=placeHolder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Placeholder__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Item__["a" /* default */],this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-scroll border-ui-3 px-1 py-2 mb-1 bg-white radius'},render);}}]);return ItemContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ItemContainer.propTypes={order:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,tracking:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,insertNetshoesLastEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,getTrackingStatuses:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref,ownProps){var tracking=_ref.ordersTracking.tracking;if(!ownProps.order||!tracking)return{};var orderItemTracking=tracking[ownProps.order.id]||{};return{tracking:orderItemTracking};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{getTrackingStatuses:function getTrackingStatuses(){if(!ownProps.order||!ownProps.order.orderId||!ownProps.order.productCode||!ownProps.order.vendorId||!ownProps.order.orderStatusId){return;}dispatch(__WEBPACK_IMPORTED_MODULE_5____["b" /* actions */].getTrackingStatus(ownProps.order));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ItemContainer));

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Status__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Participant_MyOrders_ProductOrderDetail_ProductSide__ = __webpack_require__(190);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=function(_Component){_inherits(Item,_Component);function Item(){_classCallCheck(this,Item);return _possibleConstructorReturn(this,(Item.__proto__||Object.getPrototypeOf(Item)).apply(this,arguments));}_createClass(Item,[{key:'render',value:function render(){var _props=this.props,order=_props.order,tracking=_props.tracking;var statuses=null;if(tracking&&tracking.statuses)statuses=tracking.statuses;else{statuses=[{status:'1',name:'Produto solicitado',when:order.insertDate}];}var lastTrackingStatus=statuses.slice(-1);lastTrackingStatus=lastTrackingStatus&&lastTrackingStatus[0];var statusTracking=null;if(order.trackingVtexId){statusTracking=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Participant_MyOrders_ProductOrderDetail_ProductSide__["a" /* ProductShipping */],{trackingVtexData:{courier:this.props.order.trackingVtexCourier,trackingNumber:this.props.order.trackingVtexNumber}});}else if(statuses){statusTracking=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tracking-steps col-12 px-0'},statuses.map(function(status,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Status__["b" /* Status */],{status:status,index:index});}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'mx-0 row px-0 py-2',to:'/order/'+order.parentOrderId+'/'+order.orderId+'/product/'+order.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-3 txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default.a,{src:order.productImageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default.a,alt:order.productName,className:'img-w-auto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},lastTrackingStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Status__["a" /* Name */],Object.assign({className:'txt-font-body ptxt-subtitle color-ui-2 mt-1'},lastTrackingStatus))||'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-subtitle color-ui-2 mt-1'},order.productName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-subtitle pt-half d-none'},'J\xE1 recebi o produto'))))))))),statusTracking);}}]);return Item;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Item.propTypes={order:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,tracking:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,insertNetshoesLastEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png__);
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-3 txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_product_placeholder_png___default.a,className:'img-w-auto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-6 py-half bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'col-10 py-half bg-ui-2 radius mt-1'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tracking-steps col-12 px-0 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto py-2 px-2 bg-ui-3 radius-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 py-half bg-ui-4 radius'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto py-2 px-2 bg-ui-3 radius-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 mt-1 py-half bg-ui-4 radius'})))))));};/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(state,action){switch(action.type){case'FETCH_ORDER_TRACKING':{return Object.assign({},state,{loading:true});}case'FETCH_ORDER_TRACKING_SUCCESS':{var result=Object.assign({},state,{orders:action.payload.data.orders,loading:false});return result;}case'FETCH_ORDER_TRACKING_FAIL':{return Object.assign({},state,{hasMoreItems:false,error:action.request&&action.request.status!==404?'Error':undefined,ready:true,loading:false});}case'GET_ORDERLIST':{return Object.assign({},state,{loading:true});}case'GET_ORDERLIST_SUCCESS':{var orderstracking=(state&&state.orderstracking&&!action.fromOrderDetail?[].concat(_toConsumableArray(state.orderstracking),_toConsumableArray(action.payload.data)):!action.fromOrderDetail&&[].concat(_toConsumableArray(action.payload.data))).reduce(function(unique,item){return unique.includes(item)?unique:[].concat(_toConsumableArray(unique),[item]);},[]);return Object.assign({},state,{orderstracking:orderstracking,loading:false});}case'INSERT_NETSHOES_LAST_EVENT':{return Object.assign({},state,{orderstracking:(state&&state.orderstracking?[].concat(_toConsumableArray(state.orderstracking),[{orderId:action.orderId,statuses:[{status:action.status,name:mapOrderStatus(action.status)}]}]):[{orderId:action.orderId,statuses:[{status:action.status,name:mapOrderStatus(action.status)}]}]).reduce(function(unique,item){return unique.includes(item)?unique:[].concat(_toConsumableArray(unique),[item]);},[]),loading:false});}case'INSERT_NETSHOES_EVENT_TRACKING_STATUS':{state.tracking=state.tracking||{};var id=action.id,sku=action.sku,orderId=action.orderId;state.tracking[id]={orderId:orderId,sku:sku,statuses:[{status:action.status,name:mapOrderStatus(action.status)}]};return Object.assign({},state,{loading:false});}case'FETCH_PRODUCTS_TRACKING':{return Object.assign({},state,{loading:true,hasMoreItems:true});}case'FETCH_PRODUCTS_TRACKING_SUCCESS':{var orderItems=state&&action.pageIndex!==1&&state.orderItems||[];orderItems=[].concat(_toConsumableArray(orderItems),_toConsumableArray(action.payload.data.orderItems));return Object.assign({},state,{orderItems:orderItems,totalRows:action.payload.data.totalRows,loading:false,hasMoreItems:orderItems.length<action.payload.data.totalRows});}case'FETCH_PRODUCTS_TRACKING_FAIL':{return Object.assign({},state,{hasMoreItems:false,error:action.request&&action.request.status!==404?'Error':undefined,ready:true,loading:false});}case'GET_TRACKING_STATUS':{var _id=action.id;state.tracking=state.tracking||{};if(!state.tracking[_id])state.tracking[_id]={loading:true};return Object.assign({},state);}case'GET_TRACKING_STATUS_SUCCESS':{if(!state.tracking)return Object.assign({},state);var data=action.payload.data||{};data.trackingVtexCourier='teste';data.trackingVtexId=1;data.trackingVtexNumber='1231231';data.trackingVtexUrl='http://';state.tracking[action.meta.previousAction.id]=data;return Object.assign({},state);}case'GET_TRACKING_STATUS_FAIL':{if(!state.tracking)return Object.assign({},state);state.tracking[action.meta.previousAction.id]={erro:true};return Object.assign({},state);}case'INSERT_TRACKING_STATUS':{state.tracking=state.tracking||{};var _id2=action.id,_sku=action.sku,_orderId=action.orderId,status=action.status;state.tracking[_id2]={orderId:_orderId,sku:_sku,statuses:status};return Object.assign({},state,{loading:false});}default:return Object.assign({},state);}});var mapOrderStatus=function mapOrderStatus(orderStatus){var status;switch(orderStatus){case 1:status='Confirmado';break;case 2:status='Pendente';break;case 3:status='Estornado';break;case 4:status='Pendente';break;case 5:status='Confirmado';break;case 6:status='Cancelado';break;case 7:status='Estornado';break;case 8:status='Cancelado';break;case 9:status='Pendente';break;case 10:status='Cancelado';break;case 11:status='Cancelado';break;case 12:status='Confirmado';break;case 13:status='Cancelado';break;case 14:status='Cancelado';break;case 15:status='Cancelado';break;case 16:status='Cancelado';break;case 17:status='Pendente';break;case 18:status='Estornado';break;case 19:status='Estornado';break;}return status;};

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
var redirectGoBack=function redirectGoBack(history,referer){if(referer||window.location.pathname.indexOf('products')>0){history.push('/');}else{history.goBack();}};var BackButtonMobile=function BackButtonMobile(_ref){var history=_ref.history,refererIsLogin=_ref.refererIsLogin;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block d-md-none'},(window.location.pathname.indexOf('confirmation')===0||window.location.pathname.substring(window.location.pathname.lastIndexOf('/'))!=='/')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'h-100 btn-back-page-mobile btn-back-page btn-sm btn btn-flat btn-icon btn-icon-only back-page','aria-label':'Voltar',onClick:function onClick(){return redirectGoBack(history,refererIsLogin);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{className:'icon color-brand-5',iconName:'icon_left_app'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-none'},'Voltar ')));};BackButtonMobile.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,refererIsLogin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(BackButtonMobile));

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var BackButton=function BackButton(_ref){var history=_ref.history,mobile=_ref.mobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'backButton col-md-auto col-2 pr-0 ml-0 ml-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{className:'btn-back-page '+(mobile?'btn-back-page-mobile':'btn-back-page-desktop')+' p-1 px-2 btn-sm btn-flat color-ui-white border-none btn-icon txt-button txt-font-body',to:'/cart','aria-label':'Voltar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{className:'icon icon-sm color-ui-white',iconName:'icon_left_app'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-none d-md-inline-block color-ui-white border-bottom pl-2','aria-hidden':true},'Voltar')))));};BackButton.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,mobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(BackButton));

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserBasicInformation__ = __webpack_require__(1016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UserBasicInformation__["a"]; });


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainMenu_OnlyCash_actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PointsInformation__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserBasicInformation=function(_Component){_inherits(UserBasicInformation,_Component);function UserBasicInformation(props){_classCallCheck(this,UserBasicInformation);var _this=_possibleConstructorReturn(this,(UserBasicInformation.__proto__||Object.getPrototypeOf(UserBasicInformation)).call(this,props));_this.setCash=function(value){return _this.setState({cash:_this.props.onlyCash});};_this.formatName=function(name){return name.split(' ')[0];};_this.formatPoints=function(value){return parseFloat(value.toFixed(0)).toLocaleString('pt-br',{minimumFractionDigits:0,maximumFractionDigits:2});};_this.hideValue=function(){window.localStorage.setItem('hideValue',!_this.state.hideValue);_this.setState({hideValue:!_this.state.hideValue});};_this.returnPoints=function(){return _this.formatPoints(_this.props.pointsValue)+' '+_this.props.pointsName;};_this.maskedValue=function(){var hiddenPoints=_this.returnPoints();return hiddenPoints.replace(/./g,'*');};_this.openFlagArea=function(){_this.setState({isFlagChoiceOpened:!_this.state.isFlagChoiceOpened});};_this.pointsCash=function(type){if(type==='cash'){_this.setState({cash:true});_this.props.SetOnlyCash(true);}else{_this.props.SetOnlyCash(false);}setTimeout(function(){window.location.href='/';},1500);};_this.state={hideValue:false,isFlagChoiceOpened:false,cash:false,smallHeader:false};return _this;}_createClass(UserBasicInformation,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.catalogJustCash){this.props.getVisualizationContext();this.props.onlyCash&&this.setState({cash:this.props.onlyCash});}else{this.setState({cash:false});}this.setState({changeContext:false});window.onscroll=function(){scrollHeader();};var scrollHeader=function scrollHeader(){if(document.body.scrollTop>50||document.documentElement.scrollTop>50){_this2.setState({smallHeader:true});}else{_this2.setState({smallHeader:false});}};}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.state.cash!==this.props.onlyCash){this.setCash(this.props.onlyCash);}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-points-toogle col-12 pos-relative py-1 t-5 mt-1 container-fluid border-top border-top-color-brand-3 container-header d-print-none user-basic-information '+(!this.state.smallHeader?'py-2':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 txt-left pointer color-brand-5 '+(!this.state.smallHeader?'props-small-header':'')+' small-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-font-body txt-body-sm'},'Ol\xE1, '+this.formatName(this.props.userInfo.name)+'! Voc\xEA tem ',this.props.isLoading?'Carregando pontuação':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PointsInformation__["a" /* default */],{hideValue:this.state.hideValue,maskedValue:this.maskedValue(),formatPoints:this.returnPoints()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){return _this3.hideValue();},href:'javascript:void(0)',role:'button','aria-label':window.localStorage.getItem('hideValue')==='true'||this.state.hideValue?'Exibir pontuação':'Esconder pontuação',className:'d-inline-block ml-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:window.localStorage.getItem('hideValue')==='true'||this.state.hideValue?'icon_no_view':'icon_view',className:'color-brand-5 txt-body-sm position-relative pos-relative l-0 t-0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},this.state.isFlagChoiceOpened?'Fechar seleção do formato':'Selecionar formato de resgate'))))),this.props.catalogJustCash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 px-2 txt-left pointer color-brand-5 pointer '+(!this.state.smallHeader?'not-props-small-header':'')+' small-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'open-flag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:this.state.cash?'icon_cash':'icon_points',className:'color-brand-5 txt-body-sm'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.openFlagArea,href:'javascript:void(0)',role:'button','aria-expanded':this.state.isFlagChoiceOpened,'aria-label':this.state.isFlagChoiceOpened?'Fechar seleção do formato':'Selecionar formato de resgate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:this.state.isFlagChoiceOpened?'icon_up':'icon_down',className:'color-brand-5 txt-body-sm'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},this.state.isFlagChoiceOpened?'Fechar seleção do formato':'Selecionar formato de resgate')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '+(this.state.isFlagChoiceOpened?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-6 pl-2 pt-1 pb-2 show-tablet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-sm btn btn-icon border border-color-'+(!this.state.cash?'featured':'brand-3')+' border-radius pl-5 pr-0 py-1 txt-left',onClick:function onClick(){return _this3.pointsCash('points');},role:'button','aria-label':'Troque seus pontos'+(!this.state.cash?' (Selecionado)':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:'icon_points',className:'color-'+(!this.state.cash?'featured':'brand-5')}),'Troque',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'seus pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-6 pl-2 pt-1 pb-2 show-tablet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-sm btn btn-icon border border-color-'+(this.state.cash?'featured':'brand-3')+' border-radius pl-5 pr-0 py-1 txt-left',onClick:function onClick(){return _this3.pointsCash('cash');},role:'button','aria-label':'Compre com cart\xE3o'+(this.state.cash?' (Selecionado)':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:'icon_cash',className:'color-'+(this.state.cash?'featured':'brand-5')}),'Compre',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'com cart\xE3o')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(this.state.isFlagChoiceOpened?'col-6 pr-2 pt-1 pb-2 show-tablet':'d-none')+' '})))));}}]);return UserBasicInformation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UserBasicInformation.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,userInfo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,SetOnlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,catalogJustCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,getVisualizationContext:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref){var oidc=_ref.oidc,balance=_ref.balance,catalog=_ref.catalog,onlyCash=_ref.onlyCash;return{userInfo:oidc.user.profile,isLoading:balance.isLoading,pointsValue:balance.pointsValue,pointsName:catalog.currencyConfiguration.pointsName,catalogJustCash:catalog.onlyCash,onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{SetOnlyCash:function SetOnlyCash(cash){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__MainMenu_OnlyCash_actions__["a" /* changeVisualizationContext */])(cash));},getVisualizationContext:function getVisualizationContext(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__MainMenu_OnlyCash_actions__["b" /* getVisualizationContext */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(UserBasicInformation));

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PointsInformation=function(_Component){_inherits(PointsInformation,_Component);function PointsInformation(){_classCallCheck(this,PointsInformation);return _possibleConstructorReturn(this,(PointsInformation.__proto__||Object.getPrototypeOf(PointsInformation)).apply(this,arguments));}_createClass(PointsInformation,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''+(window.localStorage.getItem('hideValue')==='true'||this.props.hideValue?'hide-points':''),'aria-hidden':window.localStorage.getItem('hideValue')==='true'||this.props.hideValue},window.localStorage.getItem('hideValue')==='true'||this.props.hideValue?this.props.maskedValue:this.props.formatPoints);}}]);return PointsInformation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PointsInformation.propTypes={hideValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,maskedValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,formatPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (PointsInformation);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GuestHeader__ = __webpack_require__(474);
/* unused harmony reexport GuestHeader */


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var GuestUserProfile=function GuestUserProfile(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{title:'Ol\xE1, fa\xE7a o seu login ou cadastre-se',to:'/auth/login',className:'profile-menu profile zindex-high col d-none d-md-block order-md-3 px-2',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-between align-items-center h-100 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_profile',className:'color-brand-5'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 px-0 color-brand-5 profile-infos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'nowrap txt-body-sm'},'Ol\xE1, fa\xE7a o seu login'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'nowrap txt-body-sm'},'ou cadastre-se')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 d-none d-lg-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_right',className:'icon-ssm color-brand-5'}))));};/* harmony default export */ __webpack_exports__["a"] = (GuestUserProfile);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_cart_css__);
var GuestCart=function GuestCart(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart col-md-1 col-auto order-md-4 order-3 d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 justify-content-end justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pos-relative opacity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_cart',className:'icon_only color-brand-5'}))));};/* harmony default export */ __webpack_exports__["a"] = (GuestCart);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HeaderRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GuestHeader_GuestHeader__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HeaderRoutes__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IuppHeaderDisconnected__ = __webpack_require__(1023);
var HeaderRouter=function HeaderRouter(_ref){var profile=_ref.profile,refererIsLogin=_ref.refererIsLogin;return profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HeaderRoutes__["a" /* default */],{refererIsLogin:refererIsLogin}):__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HEADERIUPP)&&!profile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IuppHeaderDisconnected__["a" /* default */],{profile:profile}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GuestHeader_GuestHeader__["a" /* default */],null);};HeaderRouter.propTypes={profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,refererIsLogin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state){var user=state.oidc.user;var _ref2=user||{},profile=_ref2.profile;return{profile:profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(HeaderRouter)));

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefaultHeader__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasicHeader__ = __webpack_require__(473);
var HeaderRoutes=function HeaderRoutes(_ref){var refererIsLogin=_ref.refererIsLogin;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/checkout/points-purchase',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DefaultHeader__["a" /* default */],null);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/checkout',component:__WEBPACK_IMPORTED_MODULE_4__BasicHeader__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/confirmation/:orderId',component:__WEBPACK_IMPORTED_MODULE_3__DefaultHeader__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/two-step-verification',component:__WEBPACK_IMPORTED_MODULE_4__BasicHeader__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/faq-two-step',component:__WEBPACK_IMPORTED_MODULE_4__BasicHeader__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DefaultHeader__["a" /* default */],{refererIsLogin:refererIsLogin});}}));};HeaderRoutes.propTypes={refererIsLogin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};HeaderRoutes.defaultProps={routes:[]};/* harmony default export */ __webpack_exports__["a"] = (HeaderRoutes);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavTabHeader__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavTabHeaderMobile__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__ = __webpack_require__(102);
var IuppHeaderDisconnected=function IuppHeaderDisconnected(_ref){var profile=_ref.profile;var redirectLoginPage=function redirectLoginPage(){window.location.href='/auth/login';};var returnHome=function returnHome(){__WEBPACK_IMPORTED_MODULE_2__redux__["a" /* history */].push('/');};var _focusOutOnClick=function _focusOutOnClick(section){document.activeElement.blur();setTimeout(function(){document.querySelector(section+' h2').setAttribute('tabindex','0');document.querySelector(section+' h2').focus();document.querySelector(section+' h2').addEventListener('blur',function(){document.querySelector(section+' h2').removeAttribute('tabindex');});},800);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){document.querySelector('.logo-header').focus();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'placeholder-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'iupp-header header-disconnected'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minWidth:800,maxWidth:960},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavTabHeader__["a" /* default */],{profile:profile,focusOutOnClick:function focusOutOnClick(){return _focusOutOnClick();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavTabHeader__["a" /* default */],{profile:profile,focusOutOnClick:function focusOutOnClick(){return _focusOutOnClick();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{id:'header','aria-label':'principal',className:'menu menu-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2__redux__["a" /* history */].location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block d-lg-flex mx-auto mx-lg-0 logo-header logo-header-img logo-header-link'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:returnHome,className:'d-block d-lg-flex mx-auto mx-lg-0 logo-header logo-header-img logo-header-link','aria-label':'Logo iupp ita\xFA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minWidth:490,maxWidth:960},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menu'},__WEBPACK_IMPORTED_MODULE_2__redux__["a" /* history */].location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#experiences','data-target':'#experiences',className:'flex-item mn-item mn-experiences',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');_focusOutOnClick('#experiences');}},'experi\xEAncias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#accumulatePoints','data-target':'#accumulatePoints',className:'flex-item mn-item mn-accumulate-points',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');_focusOutOnClick('#accumulatePoints');}},'junte pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#usePoint','data-target':'#usePoint',className:'flex-item mn-item mn-use-points',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');_focusOutOnClick('#usePoint');}},'use pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#benefits','data-target':'#benefits',className:'flex-item mn-item mn-benefits',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');_focusOutOnClick('#benefits');}},'descontos')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#experiences',className:'flex-item mn-item mn-experiences',onClick:function onClick(){returnHome();_focusOutOnClick('#experiences');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');}},'experi\xEAncias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#accumulatePoints',className:'flex-item mn-item mn-accumulate-points',onClick:function onClick(){returnHome();_focusOutOnClick('#accumulatePoints');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');}},'junte pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#usePoint',className:'flex-item mn-item mn-use-points',onClick:function onClick(){returnHome();_focusOutOnClick('#usePoint');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');}},'use pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#benefits',className:'flex-item mn-item mn-benefits',onClick:function onClick(){returnHome();_focusOutOnClick('#benefits');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');}},'descontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){redirectLoginPage();Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','entrar');},text:'entrar',className:'flex-item mn-item mn-login'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){redirectLoginPage();Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','cadastre-se');},text:'cadastre-se',className:'flex-item mn-item mn-register'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minWidth:961,maxWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menu'},__WEBPACK_IMPORTED_MODULE_2__redux__["a" /* history */].location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#experiences','data-target':'#experiences',className:'flex-item mn-item mn-experiences',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');_focusOutOnClick('#experiences');}},'experi\xEAncias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#accumulatePoints','data-target':'#accumulatePoints',className:'flex-item mn-item mn-accumulate-points',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');_focusOutOnClick('#accumulatePoints');}},'junte pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#usePoint','data-target':'#usePoint',className:'flex-item mn-item mn-use-points',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');_focusOutOnClick('#usePoint');}},'use pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#benefits','data-target':'#benefits',className:'flex-item mn-item mn-benefits',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');_focusOutOnClick('#benefits');}},'descontos')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#experiences',className:'flex-item mn-item mn-experiences',onClick:function onClick(){returnHome();_focusOutOnClick('#experiences');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');}},'experi\xEAncias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#accumulatePoints',className:'flex-item mn-item mn-accumulate-points',onClick:function onClick(){returnHome();_focusOutOnClick('#accumulatePoints');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');}},'junte pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#usePoint',className:'flex-item mn-item mn-use-points',onClick:function onClick(){returnHome();_focusOutOnClick('#usePoint');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');}},'use pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#benefits',className:'flex-item mn-item mn-benefits',onClick:function onClick(){returnHome();_focusOutOnClick('#benefits');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');}},'descontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','entrar');redirectLoginPage();},text:'entrar',className:'flex-item mn-item mn-login'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','cadastre-se');redirectLoginPage();},text:'cadastre-se',className:'flex-item mn-item mn-register'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minWidth:1026},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menu'},__WEBPACK_IMPORTED_MODULE_2__redux__["a" /* history */].location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#experiences','data-target':'#experiences',className:'flex-item mn-item mn-experiences',onClick:function onClick(){_focusOutOnClick('#experiences');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');}},'experi\xEAncias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#accumulatePoints','data-target':'#accumulatePoints',className:'flex-item mn-item mn-accumulate-points',onClick:function onClick(){_focusOutOnClick('#accumulatePoints');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');}},'junte pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#usePoint','data-target':'#usePoint',className:'flex-item mn-item mn-use-points',onClick:function onClick(){_focusOutOnClick('#usePoint');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');}},'use pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{role:'menuitem',href:'#benefits','data-target':'#benefits',className:'flex-item mn-item mn-benefits',onClick:function onClick(){_focusOutOnClick('#benefits');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');}},'descontos')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#experiences',className:'flex-item mn-item mn-experiences',onClick:function onClick(){returnHome();_focusOutOnClick('#experiences');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');}},'experi\xEAncias'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#accumulatePoints',className:'flex-item mn-item mn-accumulate-points',onClick:function onClick(){returnHome();_focusOutOnClick('#accumulatePoints');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');}},'junte pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#usePoint',className:'flex-item mn-item mn-use-points',onClick:function onClick(){returnHome();_focusOutOnClick('#usePoint');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');}},'use pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#benefits',className:'flex-item mn-item mn-benefits',onClick:function onClick(){returnHome();_focusOutOnClick('#benefits');Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');}},'descontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){redirectLoginPage();Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','entrar');},text:'entrar',className:'flex-item mn-item mn-login'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){redirectLoginPage();Object(__WEBPACK_IMPORTED_MODULE_8_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','cadastre-se');},text:'cadastre-se',className:'flex-item mn-item mn-register'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NavTabHeaderMobile__["a" /* default */],{focusOutOnClick:function focusOutOnClick(){return _focusOutOnClick();}}))));};IuppHeaderDisconnected.propTypes={profile:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (IuppHeaderDisconnected);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_oidc__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_oidc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_oidc__);
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_redux_oidc__["USER_EXPIRED"]:return Object.assign({},Object.assign({},state),{user:{},isLoadingUser:false});case __WEBPACK_IMPORTED_MODULE_0_redux_oidc__["SESSION_TERMINATED"]:case __WEBPACK_IMPORTED_MODULE_0_redux_oidc__["USER_SIGNED_OUT"]:return Object.assign({},Object.assign({},state),{user:{},isLoadingUser:false});case __WEBPACK_IMPORTED_MODULE_0_redux_oidc__["USER_FOUND"]:return Object.assign({},Object.assign({},state),{user:action.payload,isLoadingUser:false});case __WEBPACK_IMPORTED_MODULE_0_redux_oidc__["LOADING_USER"]:return Object.assign({},Object.assign({},state),{isLoadingUser:true});case __WEBPACK_IMPORTED_MODULE_0_redux_oidc__["SILENT_RENEW_ERROR"]:default:return state||{};}});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Checkout_PointsPurchase__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_Checkout__ = __webpack_require__(122);
var AuthRouter=function AuthRouter(_ref){var url=_ref.match.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/points-purchase',component:__WEBPACK_IMPORTED_MODULE_3_Checkout_PointsPurchase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url,exact:true,component:__WEBPACK_IMPORTED_MODULE_4_features_Checkout__["b" /* CheckoutContainer */]}));};AuthRouter.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(AuthRouter));

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Checkout_PointsPurchase_PointsPurchaseContainer__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_Checkout_PointsPurchase_PointsPurchaseContainer__["a"]; });


/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Checkout_PointsPurchase_ducks__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Checkout_PointsPurchase_ResumeCart_ResumeCart__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Checkout_PointsPurchase_CardFlip__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Checkout_createInstallment__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Checkout_PointsPurchase_PointsPurchaseFormWrapper__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__features_Checkout_SecondFactorAuthenticaton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__features_Checkout___ = __webpack_require__(122);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PointsPurchaseContainer=function(_Component){_inherits(PointsPurchaseContainer,_Component);function PointsPurchaseContainer(props){_classCallCheck(this,PointsPurchaseContainer);var _this=_possibleConstructorReturn(this,(PointsPurchaseContainer.__proto__||Object.getPrototypeOf(PointsPurchaseContainer)).call(this,props));_initialiseProps.call(_this);_this.state={quantity:'',totalPrice:0,selectedInstallment:{text:'Selecione uma parcela',value:0},installmentOptions:[{text:'Selecione uma parcela',value:0}],cardNumber:null,cardExpirationDate:null,cardHolderName:null,cardCvv:null,isFormValid:false};_this.props.clearRedux();return _this;}_createClass(PointsPurchaseContainer,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.secondFactorAuthSuccess!==this.props.secondFactorAuthSuccess){if(this.props.secondFactorAuthSuccess&&this.props.hasSuccess){this.props.closeModal();this.props.redirectConfirmation(this.props.confirmedOrderId);}}}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,loadConfiguration=_props.loadConfiguration,isLoading=_props.isLoading;!isLoading&&loadConfiguration();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,quantity=_state.quantity,totalPrice=_state.totalPrice,installmentOptions=_state.installmentOptions,selectedInstallment=_state.selectedInstallment,cardBrand=_state.cardBrand,cardNumber=_state.cardNumber,cardHolderName=_state.cardHolderName,isCardHolderNameValid=_state.isCardHolderNameValid,cardExpirationDate=_state.cardExpirationDate,isCardExpirationDateValid=_state.isCardExpirationDateValid,cardCvv=_state.cardCvv,isCardCvvValid=_state.isCardCvvValid,isCardCvvEditing=_state.isCardCvvEditing;var _props2=this.props,isLoading=_props2.isLoading,hasError=_props2.hasError,hasSuccess=_props2.hasSuccess,id=_props2.id,errors=_props2.errors;if(hasSuccess&&!isLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Redirect"],{to:'/confirmation/'+id});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-cart container-purchase-points-lazy container py-md-5 py-0 px-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},hasError&&errors.map(function(error){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:'Não foi possível concluir a sua transferência.',description:error.message,className:'pb-2'});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Checkout_PointsPurchase_PointsPurchaseFormWrapper__["a" /* default */],{packageSize:this.props.config.packageSize},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 col-md-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{type:'number',className:'col-6 mt-0',childrenClassName:'no-label radius',value:quantity,'aria-label':'Quantidade',name:'quantity',placeholder:'0',disabled:isLoading||hasError,onChange:this.handleQuantityChange,onBlur:this.handleQuantityRounding}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{className:'col-6 mt-0',childrenClassName:'no-label radius',value:'R$ '+totalPrice,'aria-label':'Valor Total',disabled:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Select"],{id:'payment-installment',label:'Parcelar em',className:'col-12 mt-2',displayValue:'text',options:installmentOptions,value:selectedInstallment,onChange:this.handleChangeInstallments,required:true,disabled:isLoading||hasError||installmentOptions.length<=1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-number',label:'N\xFAmero do cart\xE3o','aria-label':'N\xFAmero do cart\xE3o',className:'col-12 mt-2',required:true,'data-error':'Número de cartão inválido!',guide:false,valid:this.state.isCardNumberValid,mask:[/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/],name:'cardNumber',onChange:this.handleCreditCardChange,onBlur:this.handleCardNumberChange,disabled:totalPrice<=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-person-name',label:'Nome impresso no cart\xE3o','aria-label':'Nome impresso no cart\xE3o',className:'col-12 mt-2',required:true,name:'cardHolderName','data-error':'Nome inválido!',valid:isCardHolderNameValid,value:cardHolderName,onChange:this.handleCreditCardChange,onBlur:this.handleCardHolderNameValidation,disabled:totalPrice<=0,style:{marginTop:'10px'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-validity-date',label:'Validade m\xEAs/ano','aria-label':'Validade m\xEAs/ano',className:'col-6 mt-2',mask:[/\d/,/\d/,'/',/\d/,/\d/],required:true,name:'cardExpirationDate','data-error':'Data inv\xE1lida!',valid:isCardExpirationDateValid,onChange:this.handleCreditCardChange,onBlur:this.handleExpirationDateValidation,value:cardExpirationDate,disabled:totalPrice<=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-cvv',label:'CVV','aria-label':'CVV',className:'col-6 mt-2',guide:false,mask:cardBrand&&cardBrand.name==='AmericanExpress'?[/\d/,/\d/,/\d/,/\d/]:[/\d/,/\d/,/\d/],required:true,'data-error':'CVV inv\xE1lido!',valid:isCardCvvValid,value:cardCvv,name:'cardCvv',onChange:this.handleCreditCardChange,onBlur:function onBlur(e){_this2.toggleCvvEditing(e);_this2.handleCardCvvValidation();},onFocus:this.toggleCvvEditing,disabled:!cardBrand}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Checkout_PointsPurchase_CardFlip__["a" /* default */],{isCardCvvEditing:isCardCvvEditing,cardNumber:cardNumber,cardBrand:cardBrand,cardExpirationDate:cardExpirationDate,cardHolderName:cardHolderName,cardCvv:cardCvv}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Checkout_PointsPurchase_ResumeCart_ResumeCart__["a" /* default */],{showTermsEvent:this.showTermsEvent,points:quantity,cash:totalPrice,canCheckout:this.canCheckout,purchasePointsFinaly:this.handleCheckout,isLoading:isLoading})),this.props.SecondFactorAuthentication&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__features_Checkout_SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],Object.assign({show:this.props.SecondFactorAuthentication,secondFactorAuthConfirmated:this.props.SecondFactorAuthenticationConfirmed,oidc:this.props.oidc},this.props,{paymentSelected:'PURCHASE_POINTS_ONLY',closeModal:this.props.closeModal,creditCard:this.state.credCard,paymentPoints:this.state.totalPrice,cardBrand:function cardBrand(){return _this2.state.cardBrand&&_this2.state.cardBrand.id;}}))));}}]);return PointsPurchaseContainer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.handleChangeInstallments=function(selectedInstallment){_this3.setState({selectedInstallment:selectedInstallment});};this.handleQuantityChange=function(e){var value=e.target.value;_this3.setState(function(state,props){return{quantity:value,totalPrice:Math.round(_this3.calculateTotalPrice(props,value))};});};this.calculateTotalPrice=function(props,value){var total=value/props.config.packageSize*props.config.price;return total;};this.calculateQuantity=function(state,props,value){var quantity=Math.round(value/props.config.packageSize)*props.config.packageSize;var calcTotalPrice=quantity/props.config.packageSize*props.config.price;_this3.handleInstallmentOptions(calcTotalPrice);_this3.setState(function(state,props){return{totalPrice:calcTotalPrice};});return quantity;};this.handleQuantityRounding=function(e){var value=e.target.value;_this3.setState(function(state,props){return{quantity:_this3.calculateQuantity(state,props,value)};});};this.handleCreditCardChange=function(e){var _e$target=e.target,name=_e$target.name,value=_e$target.value;if(name==='cardCvv'){_this3.handleCardCvvValidation(value);}_this3.setState(function(){return _defineProperty({},name,value);});};this.handleCardNumberChange=function(e){var cardNumber=e.target.value.replace(/\s/g,'');var cardBrands=_this3.props.cardBrands;var cardBrand=cardBrands.find(function(brand){return RegExp(brand.regexValidation).test(cardNumber);});_this3.setState({isCardNumberValid:!!cardBrand,cardBrand:cardBrand});};this.toggleCvvEditing=function(e){_this3.setState({isCardCvvEditing:e.type==='focus'});};this.handleInstallmentOptions=function(totalPriceValue){if(!totalPriceValue)return false;if(totalPriceValue===0){return _this3.setState(function(state){return{installmentOptions:[state.installmentOptions[0]]};});}var quantityInstallment=1;var minimumValueInstallment=_this3.props.catalog.minimumInstallmentPurchasePointsCurrency;if(totalPriceValue/3>=minimumValueInstallment){quantityInstallment=3;}else if(totalPriceValue/2>=minimumValueInstallment){quantityInstallment=2;}var installmentOptions=Array(quantityInstallment).fill().map(function(_,idx){idx++;if(idx===1){return Object(__WEBPACK_IMPORTED_MODULE_11_Checkout_createInstallment__["a" /* default */])(idx,totalPriceValue);}var installmentValue=(totalPriceValue/idx).toLocaleString('pt-br',{minimumFractionDigits:2,maximumFractionDigits:2});return Object(__WEBPACK_IMPORTED_MODULE_11_Checkout_createInstallment__["a" /* default */])(idx,installmentValue);});_this3.setState(function(state){return{installmentOptions:[state.installmentOptions[0]].concat(_toConsumableArray(installmentOptions))};});};this.handleExpirationDateValidation=function(){var cardExpirationDate=_this3.state.cardExpirationDate;var _ref3=cardExpirationDate?cardExpirationDate.split('/'):[],_ref4=_slicedToArray(_ref3,2),_ref4$=_ref4[0],month=_ref4$===undefined?'00':_ref4$,_ref4$2=_ref4[1],year=_ref4$2===undefined?'00':_ref4$2;var currentYear=parseInt(__WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YY'));var currentMonth=__WEBPACK_IMPORTED_MODULE_9_moment___default()().month()+1;var isMonthInvalid=parseInt(month)<=0||parseInt(month)>12;var isYearPast=parseInt(year)<currentYear;var isExpired=parseInt(year)===currentYear&&parseInt(month)<currentMonth;_this3.setState({isCardExpirationDateValid:!isMonthInvalid&&!isYearPast&&!isExpired,cardExpirationDateMonth:month,cardExpirationDateYear:year});};this.handleCardHolderNameValidation=function(){var cardHolderName=_this3.state.cardHolderName;_this3.setState({isCardHolderNameValid:cardHolderName?cardHolderName.length>3:false});};this.handleCardCvvValidation=function(value){var cardCvv=value||_this3.state.cardCvv;_this3.setState({isCardCvvValid:cardCvv?cardCvv.length>=3&&cardCvv.length<=4:false});};this.handleCheckout=function(){var _state2=_this3.state,quantity=_state2.quantity,cardNumber=_state2.cardNumber,cardCvv=_state2.cardCvv,cardExpirationDateMonth=_state2.cardExpirationDateMonth,cardExpirationDateYear=_state2.cardExpirationDateYear,cardHolderName=_state2.cardHolderName,selectedInstallment=_state2.selectedInstallment,cardBrand=_state2.cardBrand;_this3.props.clearRedux();var _props3=_this3.props,cardHolderCpf=_props3.cardHolderCpf,checkout=_props3.checkout;var purchase={quantity:quantity/_this3.props.config.packageSize,cardNumber:cardNumber.replace(/\s/g,''),cardCvv:cardCvv,cardExpirationDateMonth:cardExpirationDateMonth,cardExpirationDateYear:cardExpirationDateYear,cardHolderName:cardHolderName,cardHolderCpf:cardHolderCpf,installments:selectedInstallment.value,cardBrandId:cardBrand.id};checkout(purchase);_this3.setState({credCard:purchase});};this.canCheckout=function(){var _state3=_this3.state,isCardNumberValid=_state3.isCardNumberValid,isCardHolderNameValid=_state3.isCardHolderNameValid,isCardExpirationDateValid=_state3.isCardExpirationDateValid,isCardCvvValid=_state3.isCardCvvValid,selectedInstallment=_state3.selectedInstallment;return isCardNumberValid&&isCardHolderNameValid&&isCardExpirationDateValid&&isCardCvvValid&&selectedInstallment.value>0;};};PointsPurchaseContainer.propTypes={loadConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,config:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,cardHolderCpf:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hasError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hasSuccess:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,errors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,cardBrands:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,checkout:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,ClearSecondFactorAuthentication:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,closeModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,redirectConfirmation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,packageSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,catalog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,SecondFactorAuthentication:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,oidc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,errorToken:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,secondFactorAuthSuccess:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,SecondFactorAuthenticationConfirmed:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,confirmedOrderId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,clearRedux:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref){var pointsPurchase=_ref.pointsPurchase,cardBrands=_ref.cardBrands,participant=_ref.participant,catalog=_ref.catalog,oidc=_ref.oidc,checkout=_ref.checkout;pointsPurchase.hasError=pointsPurchase.hasError||checkout.errorToken;if(!pointsPurchase.errors){pointsPurchase.errors=[];}if(checkout.errorToken&&checkout.messageError_){pointsPurchase.errors.push({message:checkout.messageError_});}return Object.assign({},pointsPurchase,{cardBrands:cardBrands.brands,cardHolderCpf:participant.cpf&&participant.cpf.value,catalog:catalog,oidc:oidc,SecondFactorAuthentication:pointsPurchase.SecondFactorAuthentication&&!checkout.secondFactorAuthSuccess,SecondFactorAuthenticationConfirmed:pointsPurchase.SecondFactorAuthenticationConfirmed,isCreatingPurchase:checkout.isCreatingPurchase,errorToken:checkout.errorToken,secondFactorAuthSuccess:checkout.secondFactorAuthSuccess});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadConfiguration:function loadConfiguration(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Checkout_PointsPurchase_ducks__["d" /* fetchPointPurchaseConfiguration */])());},checkout:function checkout(purchase){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Checkout_PointsPurchase_ducks__["a" /* checkoutPointsPurchase */])(purchase));},closeModal:function closeModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Checkout_PointsPurchase_ducks__["b" /* clearSecondFactorAuthentication */])());},redirectConfirmation:function redirectConfirmation(orderId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/confirmation/'+orderId));},authorizeWithToken:function authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){var lastTry=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;return dispatch(__WEBPACK_IMPORTED_MODULE_14__features_Checkout___["c" /* actions */].authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend,lastTry));},authorizeWithTokenResend:function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_14__features_Checkout___["c" /* actions */].authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},authorizeWithTokenLastTry:function authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_14__features_Checkout___["c" /* actions */].authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},clearRedux:function clearRedux(){return dispatch(__WEBPACK_IMPORTED_MODULE_14__features_Checkout___["c" /* actions */].clearRedux());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PointsPurchaseContainer));

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResumeCart=function(_Component){_inherits(ResumeCart,_Component);function ResumeCart(props){_classCallCheck(this,ResumeCart);var _this=_possibleConstructorReturn(this,(ResumeCart.__proto__||Object.getPrototypeOf(ResumeCart)).call(this,props));_this.acceptTermsEvent=function(){if(!_this.state.acceptTerms){_this.setState({acceptTerms:true});}else{_this.setState({acceptTerms:false});}};_this.state={termAccepted:false};return _this;}_createClass(ResumeCart,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side border-ui-3 radius bg-white px-0 py-0 mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-title txt-font-body'},'Resumo da compra')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-2 pb-2  px-2  border-dotted-bottom border-color-ui-3 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2 txt-left'},'Transa\xE7\xE3o: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Compra de pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half txt-body-sm txt-font-body color-ui-2 txt-left'},'Valor em pontos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.points.toLocaleString('pt-br',{minimumFractionDigits:0,maximumFractionDigits:0}),' ','pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half txt-body-sm txt-font-body color-ui-2 txt-left'},'Valor em reais:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$',' ',this.props.cash.toLocaleString('pt-br',{minimumFractionDigits:2,maximumFractionDigits:2}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pb-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn-featured btn-icon nowrap',text:'Finalizar pagamento',disabled:!this.props.canCheckout(),iconName:'icon_gift',onClick:this.props.purchasePointsFinaly,loading:this.props.isLoading}))))));}}]);return ResumeCart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResumeCart.propTypes={points:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,cash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,canCheckout:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,purchasePointsFinaly:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ResumeCart);

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_card_flip__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_card_flip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_card_flip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_payment_credit_card_front_png__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_payment_credit_card_front_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_payment_credit_card_front_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_payment_credit_card_back_png__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_payment_credit_card_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_payment_credit_card_back_png__);
var CardFlip=function CardFlip(_ref){var isCardCvvEditing=_ref.isCardCvvEditing,cardNumber=_ref.cardNumber,cardBrand=_ref.cardBrand,cardHolderName=_ref.cardHolderName,cardExpirationDate=_ref.cardExpirationDate,cardCvv=_ref.cardCvv;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pos-relative inserted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-credit-card front_credit-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_card_flip___default.a,{isFlipped:isCardCvvEditing},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front',key:'front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_payment_credit_card_front_png___default.a,alt:''+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'Cartão'),className:'creditcard w-100'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back',key:'back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__loyal_images_payment_credit_card_back_png___default.a,alt:''+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'Cartão'),className:'creditcard w-100'})))),!isCardCvvEditing?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card brand_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'},cardBrand&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:cardBrand.imageUrl,alt:cardBrand.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card brand_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card number_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'},cardNumber||'**** **** **** ****'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card name_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'},cardHolderName||'Nome e Sobrenome'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card date_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'},cardExpirationDate||'00/00')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'back_credit-card cvv_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-1 txt-uppercase'},isCardCvvEditing&&cardBrand&&cardBrand.name==='AmericanExpress'?cardCvv||'****':cardCvv||'***'))));};CardFlip.propTypes={isCardCvvEditing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cardCvv:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cardNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cardBrand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cardHolderName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cardExpirationDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CardFlip);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(installment,price){return{text:installment+'x de R$ '+price.toLocaleString('pt-br',{minimumFractionDigits:2}),value:installment};});

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
var PointsPurchaseFormHeader=function PointsPurchaseFormHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-comprarpontos bg-paguecontas radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title-2 txt-circular-book'},'Comprar pontos')));};var PointsPurchaseFormWrapper=function PointsPurchaseFormWrapper(_ref){var children=_ref.children,packageSize=_ref.packageSize;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Comprar pontos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PointsPurchaseFormHeader,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Selecione o valor em pontos que deseja comprar e pague o valor em R$ com seu cart\xE3o de cr\xE9dito.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-item border-color-ui-3 row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method-creditcard col-12 mt-2 border-dashed-top border-color-ui-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-step h-auto row'},children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-dashed-top border-color-ui-3 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-bold pb-1'},'Fique atento \xE0s condi\xE7\xF5es da compra de pontos:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'- Limites de compra: m\xEDnimo de ',packageSize,' pontos por compra e m\xE1ximo de 1.000.000 de pontos por ano civil;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'- Os pontos comprados n\xE3o possuem expira\xE7\xE3o;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'- As condi\xE7\xF5es da compra de pontos poder\xE3o ser alteradas, suspensas ou cancelados sem aviso pr\xE9vio;')))))))))));};PointsPurchaseFormWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (PointsPurchaseFormWrapper);

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fadeInDown = __webpack_require__(1033);

var _fadeInDown2 = _interopRequireDefault(_fadeInDown);

var _fadeInUp = __webpack_require__(1034);

var _fadeInUp2 = _interopRequireDefault(_fadeInUp);

var _fadeInLeft = __webpack_require__(1035);

var _fadeInLeft2 = _interopRequireDefault(_fadeInLeft);

var _fadeInRight = __webpack_require__(1036);

var _fadeInRight2 = _interopRequireDefault(_fadeInRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    fadeInDown: _fadeInDown2.default,
    fadeInUp: _fadeInUp2.default,
    fadeInLeft: _fadeInLeft2.default,
    fadeInRight: _fadeInRight2.default
};

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'mask': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'backgroundColor': 'rgba(0, 0, 0, 0.7)',
        'zIndex': 10001
    },
    'maskHidden': {
        'display': 'none'
    },
    'container': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': 10000
    },
    'containerHidden': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': -1
    },
    'panel': {
        'backgroundColor': '#fff',
        'borderRadius': '5px',
        'boxSizing': 'border-box',
        'boxShadow': '0 2px 4px rgba(0, 0, 0, 0.3)',
        'transform': 'translate3d(0, 0, 0)',
        'transition': 'transform 500ms cubic-bezier(0, 0, 0.25, 1), opacity 500ms cubic-bezier(0, 0, 0.25, 1)',
        'zIndex': 10002
    },
    'panelHidden': {
        'transform': 'translate3d(0, -100px, 0)',
        'opacity': 0,
        'zIndex': -1,
        'height': 0,
        'width': 0,
        'overflow': 'hidden'
    }
};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'mask': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'backgroundColor': 'rgba(0, 0, 0, 0.7)',
        'zIndex': 10001
    },
    'maskHidden': {
        'display': 'none'
    },
    'container': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': 10000
    },
    'containerHidden': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': -1
    },
    'panel': {
        'backgroundColor': '#fff',
        'borderRadius': '5px',
        'boxSizing': 'border-box',
        'boxShadow': '0 2px 4px rgba(0, 0, 0, 0.3)',
        'transform': 'translate3d(0, 0, 0)',
        'transition': 'transform 500ms cubic-bezier(0, 0, 0.25, 1), opacity 500ms cubic-bezier(0, 0, 0.25, 1)',
        'zIndex': 10002
    },
    'panelHidden': {
        'transform': 'translate3d(0, 100px, 0)',
        'opacity': 0,
        'zIndex': -1,
        'height': 0,
        'width': 0,
        'overflow': 'hidden'
    }
};

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'mask': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'backgroundColor': 'rgba(0, 0, 0, 0.7)',
        'zIndex': 10001
    },
    'maskHidden': {
        'display': 'none'
    },
    'container': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': 10000
    },
    'containerHidden': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': -1
    },
    'panel': {
        'backgroundColor': '#fff',
        'borderRadius': '5px',
        'boxSizing': 'border-box',
        'boxShadow': '0 2px 4px rgba(0, 0, 0, 0.3)',
        'transform': 'translate3d(0, 0, 0)',
        'transition': 'transform 500ms cubic-bezier(0, 0, 0.25, 1), opacity 500ms cubic-bezier(0, 0, 0.25, 1)',
        'zIndex': 10002
    },
    'panelHidden': {
        'transform': 'translate3d(-100px, 0, 0)',
        'opacity': 0,
        'zIndex': -1,
        'height': 0,
        'width': 0,
        'overflow': 'hidden'
    }
};

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'mask': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'backgroundColor': 'rgba(0, 0, 0, 0.7)',
        'zIndex': 10001
    },
    'maskHidden': {
        'display': 'none'
    },
    'container': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': 10000
    },
    'containerHidden': {
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'width': '100%',
        'height': '100%',
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'zIndex': -1
    },
    'panel': {
        'backgroundColor': '#fff',
        'borderRadius': '5px',
        'boxSizing': 'border-box',
        'boxShadow': '0 2px 4px rgba(0, 0, 0, 0.3)',
        'transform': 'translate3d(0, 0, 0)',
        'transition': 'transform 500ms cubic-bezier(0, 0, 0.25, 1), opacity 500ms cubic-bezier(0, 0, 0.25, 1)',
        'zIndex': 10002
    },
    'panelHidden': {
        'transform': 'translate3d(100px, 0, 0)',
        'opacity': 0,
        'zIndex': -1,
        'height': 0,
        'width': 0,
        'overflow': 'hidden'
    }
};

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calcTimeDelta */
/* unused harmony export formatTimeDelta */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return zeroPad; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0) return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : '';
  var suffix = match ? match[3] : '';
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
    return '0';
  }).join('') + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$now = _ref.now,
      now = _ref$now === void 0 ? Date.now : _ref$now,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 0 : _ref$precision,
      _ref$controlled = _ref.controlled,
      controlled = _ref$controlled === void 0 ? false : _ref$controlled,
      _ref$offsetTime = _ref.offsetTime,
      offsetTime = _ref$offsetTime === void 0 ? 0 : _ref$offsetTime;

  var startTimestamp;

  if (typeof date === 'string') {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }

  if (!controlled) {
    startTimestamp += offsetTime;
  }

  var total = Math.round(parseFloat((Math.max(0, controlled ? startTimestamp : startTimestamp - now()) / 1000).toFixed(Math.max(0, Math.min(20, precision)))) * 1000);
  var seconds = total / 1000;
  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(delta, options) {
  var days = delta.days,
      hours = delta.hours,
      minutes = delta.minutes,
      seconds = delta.seconds;

  var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options),
      daysInHours = _Object$assign.daysInHours,
      zeroPadTime = _Object$assign.zeroPadTime,
      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;

  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, Math.min(2, zeroPadTime));
  return {
    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, Math.min(2, zeroPadTime)),
    seconds: zeroPad(seconds, Math.min(2, zeroPadTime))
  };
}

var isEqual = __webpack_require__(1038);

var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  function Countdown(props) {
    var _this;

    _classCallCheck(this, Countdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Countdown).call(this, props));
    _this.mounted = false;

    _this.tick = function () {
      var onTick = _this.props.onTick;

      var timeDelta = _this.calcTimeDelta();

      _this.setTimeDeltaState(Object.assign({}, timeDelta));

      if (onTick && timeDelta.total > 0) {
        onTick(timeDelta);
      }
    };

    _this.start = function () {
      _this.setState(function (_ref) {
        var offsetStart = _ref.offsetStart,
            offsetTime = _ref.offsetTime;
        return {
          offsetStart: 0,
          offsetTime: offsetTime + (offsetStart ? Date.now() - offsetStart : 0)
        };
      }, function () {
        var timeDelta = _this.calcTimeDelta();

        _this.setTimeDeltaState(timeDelta);

        _this.props.onStart && _this.props.onStart(timeDelta);

        if (!_this.props.controlled) {
          _this.clearInterval();

          _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
        }
      });
    };

    _this.pause = function () {
      _this.clearInterval();

      _this.setState({
        offsetStart: _this.calcOffsetStart()
      }, function () {
        var timeDelta = _this.calcTimeDelta();

        _this.setTimeDeltaState(timeDelta);

        _this.props.onPause && _this.props.onPause(timeDelta);
      });
    };

    _this.isPaused = function () {
      return _this.state.offsetStart > 0;
    };

    _this.isCompleted = function () {
      return _this.state.timeDelta.completed;
    };

    _this.state = {
      timeDelta: _this.calcTimeDelta(),
      offsetStart: props.autoStart ? 0 : _this.calcOffsetStart(),
      offsetTime: 0
    };
    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.props.autoStart && this.start();
      this.props.onMount && this.props.onMount(this.calcTimeDelta());
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual(this.props, prevProps)) {
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.clearInterval();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props,
          date = _this$props.date,
          now = _this$props.now,
          precision = _this$props.precision,
          controlled = _this$props.controlled;
      return calcTimeDelta(date, {
        now: now,
        precision: precision,
        controlled: controlled,
        offsetTime: this.state ? this.state.offsetTime : 0
      });
    }
  }, {
    key: "calcOffsetStart",
    value: function calcOffsetStart() {
      return Date.now();
    }
  }, {
    key: "clearInterval",
    value: function clearInterval() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta) {
      var _this2 = this;

      var callback;

      if (!this.state.timeDelta.completed && timeDelta.completed) {
        this.clearInterval();

        callback = function callback() {
          return _this2.props.onComplete && _this2.props.onComplete(timeDelta);
        };
      }

      if (this.mounted) {
        return this.setState({
          timeDelta: timeDelta
        }, callback);
      }
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        isPaused: this.isPaused,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props,
          daysInHours = _this$props2.daysInHours,
          zeroPadTime = _this$props2.zeroPadTime,
          zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign(Object.assign({}, timeDelta), {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours: daysInHours,
          zeroPadTime: zeroPadTime,
          zeroPadDays: zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          renderer = _this$props3.renderer;
      var renderProps = this.getRenderProps();

      if (renderer) {
        return renderer(renderProps);
      }

      if (children && this.state.timeDelta.completed) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
          countdown: renderProps
        });
      }

      var _renderProps$formatte = renderProps.formatted,
          days = _renderProps$formatte.days,
          hours = _renderProps$formatte.hours,
          minutes = _renderProps$formatte.minutes,
          seconds = _renderProps$formatte.seconds;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, days, days ? ':' : '', hours, ":", minutes, ":", seconds);
    }
  }]);

  return Countdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
Countdown.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  autoStart: true
});
Countdown.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  daysInHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  zeroPadTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  zeroPadDays: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  controlled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  intervalDelay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  precision: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  autoStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  renderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  now: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onTick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Countdown);



/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(76)(module)))

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yn__);
var OnBoardingRedirect=function OnBoardingRedirect(_ref){var oidc=_ref.oidc,showOnboarding=_ref.showOnboarding;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto pos-absolute '+(!__WEBPACK_IMPORTED_MODULE_3_yn___default()(showOnboarding)&&'d-none'),style:{top:'-243px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 border-color-ui-3 border-bottom pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{id:'modalTitle'},'Verifica\xE7\xE3o em 2 etapas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{name:'Close',className:'btn btn-double btn-flat btn-icon-only btn-icon d-none',iconName:'icon_close icon-sm',text:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-3 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm txt-bold pb-1 px-0  title-color'},'Voc\xEA ainda n\xE3o possui nenhum celular verificado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0'},'Realizar essa verifica\xE7\xE3o \xE9 muito importante para que seus resgates no',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Cat\xE1logo de Pr\xEAmios ocorram de forma segura. Assim saberemos que apenas',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'voc\xEA estar\xE1 utilizando seus pontos e n\xE3o um poss\xEDvel fraudador.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-double btn-featured btn-rating-modal2 col-12',text:'VERIFIQUE AGORA',onClick:function onClick(){return window.open("https://onboarding.webpremios.com.br/Login/RedirectCognito?id="+oidc.user.profile['custom:campaign_id'],'_self');}}))))))));};OnBoardingRedirect.propTypes={oidc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,showOnboarding:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (OnBoardingRedirect);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Timeout=function Timeout(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 confirmation-alert py-2 pl-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius border-brand-1 border-left-lg border-color-brand-1 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_clock color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'countDownText',className:'color-brand-1 txt-circular-book txt-body-lg'},'Tempo esgotado.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-none'}))));};/* harmony default export */ __webpack_exports__["a"] = (Timeout);

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Address__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_App_FingerPrint_FingerPrintContainer__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App_MainMenu_OnlyCash_actions__ = __webpack_require__(189);
var mapStateToProps=function mapStateToProps(_ref){var checkout=_ref.checkout,participant=_ref.participant,cart=_ref.cart,address=_ref.address,balance=_ref.balance,cardBrands=_ref.cardBrands,catalog=_ref.catalog,onlyCash=_ref.onlyCash,oidc=_ref.oidc,shipping=_ref.shipping,brandsByVendor=_ref.brandsByVendor,getVisualizationContext=_ref.getVisualizationContext;return Object.assign({},checkout,{participant:participant,cart:cart,address:address,balance:balance,brands:cardBrands.brands,catalog:catalog,onlyCash:onlyCash,oidc:oidc,shipping:shipping,brandsByVendor:brandsByVendor,getVisualizationContext:getVisualizationContext,catalogJustCash:catalog.onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getVisualizationContext:function getVisualizationContext(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_App_MainMenu_OnlyCash_actions__["b" /* getVisualizationContext */])());},fetchShipping:function fetchShipping(zipCode){dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].fetchShipping(zipCode));dispatch(__WEBPACK_IMPORTED_MODULE_4__Address__["a" /* actions */].fetchAddress(zipCode));},resetShipping:function resetShipping(){dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].resetShipping());},fetchPointsCashConfig:function fetchPointsCashConfig(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchPointsCashConfig());},fetchInstallments:function fetchInstallments(data){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchInstallments(data));},updateShippingAddress:function updateShippingAddress(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].updateShippingAddress(data));},createPurchase:function createPurchase(creditCardPayment){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].createPurchase(creditCardPayment));},redirectConfirmation:function redirectConfirmation(orderId){dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].redirectConfirmation(orderId));},closeModal:function closeModal(){return dispatch({type:'CLOSE_MODAL'});},clearConfirmedOrderData:function clearConfirmedOrderData(){return dispatch({type:'CLEAR_CONFIRMED_ORDER_DATA'});},changePropToSuccess:function changePropToSuccess(){return dispatch({type:'SUCCESS'});},clearError:function clearError(){return dispatch({type:'CLEAR_PURCHASE_ERROR'});},loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].loadCart());},updateShippingEmail:function updateShippingEmail(email){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].updateShippingEmail(email));},removeCoupon:function removeCoupon(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].removeCoupon());},fetchCashOnlyConfig:function fetchCashOnlyConfig(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchCashOnlyConfig());},authorizeWithToken:function authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){var lastTry=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend,lastTry));},authorizeWithTokenResend:function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},authorizeWithTokenLastTry:function authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_App_FingerPrint_FingerPrintContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* Checkout */],props));}));

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var numberPattern=/^[0-9]*$/;var Form=function(_Component){_inherits(Form,_Component);function Form(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Form);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Form.__proto__||Object.getPrototypeOf(Form)).call.apply(_ref,[this].concat(args))),_this),_this.state={zipCode:_this.props.zipCode.value,receiver:_this.props.receiver.value,number:_this.props.number.value,complement:_this.props.complement.value},_this.handleZipCodeChange=function(event){var zipCode=event.target.value;_this.setState({zipCode:zipCode});var zipCodeNumber=zipCode.replace('-','');if(zipCodeNumber.length===8&&numberPattern.test(zipCodeNumber)){_this.props.fetchShipping(zipCodeNumber);}},_this.handleOnClick=function(_){return _this.props.btn.onClick({zipCode:_this.state.zipCode.value,receiver:_this.state.receiver.value,number:_this.state.number.value,complement:_this.state.complement.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Form,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-form col-12 mt-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-zipCode',label:'CEP',className:'col-12 col-md-6 mt-2',value:this.state.zipCode,onChange:this.handleZipCodeChange,mask:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/],required:true,disabled:this.props.zipCode.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-receiver',label:'Destinat\xE1rio',className:'col-12 col-md-6  mt-2',value:this.state.receiver,onChange:function onChange(e){return _this2.setState({receiver:e.target.value});},required:true,disabled:this.props.receiver.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-street',label:'Logradouro',className:'col-12 col-md-6 mt-2',value:this.props.street.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-number',label:'N\xFAmero',className:'col-12 col-md-6 mt-2',value:this.state.number,onChange:function onChange(e){return _this2.setState({number:e.target.value});},required:true,disabled:this.props.number.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-complement',label:'Complemento',className:'col-12 col-md-6 mt-2',value:this.state.complement,onChange:function onChange(e){return _this2.setState({complement:e.target.value});},disabled:this.props.complement.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-district',label:'Bairro',className:'col-12 col-md-6 mt-2',value:this.props.district.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-city',label:'Cidade',className:'col-12 col-md-6 mt-2',value:this.props.city.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'address-state',label:'Estado',className:'col-12 col-md-6 mt-2',value:this.props.state.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 offset-md-6 col-md-6 mt-1 mb-2 pb-1 px-1 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-address-submit',className:'btn-featured form-field btn-sm txt-center',text:this.props.btn.text,onClick:this.handleOnClick}))));}}]);return Form;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});var btnType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired});Form.propTypes={street:valueType.isRequired,district:valueType.isRequired,city:valueType.isRequired,state:valueType.isRequired,zipCode:valueType.isRequired,receiver:valueType,number:valueType,complement:valueType,btn:btnType.isRequired,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProfileInfos__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingAddress__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Summary__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Payment__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormVirtualVoucher__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckoutPlaceholder__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Payment_PaymentBrands_PaymentClient__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__App_Shell_TitleAnnouncer__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SecondFactorAuthenticaton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__loyal_template_checkout_css__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__loyal_template_checkout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__loyal_template_checkout_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var paymentDefault='POINTS_ONLY';var cardType='direct';var creditCardDefault=function creditCardDefault(){return{number:'',personName:'',validityDate:'',cvv:''};};var brand={};var Checkout=function(_Component){_inherits(Checkout,_Component);function Checkout(props){var _this2=this;_classCallCheck(this,Checkout);var _this=_possibleConstructorReturn(this,(Checkout.__proto__||Object.getPrototypeOf(Checkout)).call(this,props));_this.state={step:0,customer:{},paymentSelected:paymentDefault,paymentPoints:0,creditCard:creditCardDefault(),showModal:true,hideModal:true,sendGTM:false,showPayment:false,shippingCalculated:false};_this.forceFocus=function(element){var elementFocus='.logo-header-link';var closeModalAcessibility=document.querySelector('.close-accessibility-message');var backButtonMobile=document.querySelector('.btn-back-page-mobile');if(closeModalAcessibility!==null){elementFocus='.close-accessibility-message';}else if(backButtonMobile!==null){elementFocus='.btn-back-page-mobile';}var alertBox=document.querySelector(element||elementFocus);var focusInterval=10;// ms, time between function calls
var focusTotalRepetitions=10;// number of repetitions
alertBox.setAttribute('tabindex','0');alertBox.blur();var focusRepetitions=0;var interval=window.setInterval(function(){alertBox.focus();focusRepetitions++;if(focusRepetitions>=focusTotalRepetitions){window.clearInterval(interval);}},focusInterval);};_this.confirm=function(id){_this.props.redirectConfirmation(id);_this.props.changePropToSuccess();};_this.setCustomer=function(customer){_this.setState({customer:customer,step:1,paymentSelected:paymentDefault});_this.sendGTM();};_this.selectPointsCash=function(){_this.setState({paymentSelected:'POINTS_CASH',creditCard:creditCardDefault()});_this.removeCouponOnChangePayment();};_this.selectPointsOnly=function(){_this.setState({paymentSelected:'POINTS_ONLY',creditCard:creditCardDefault()});_this.removeCouponOnChangePayment();};_this.removeCouponOnChangePayment=function(){var _this$props=_this.props,cart=_this$props.cart,removeCoupon=_this$props.removeCoupon;if(cart.coupon&&cart.coupon.code)removeCoupon();};_this.handleCreditCardChange=function(_ref){var target=_ref.target;var name=target.name,value=target.value;var creditCard=Object.assign({},_this.state.creditCard,_defineProperty({},name,value));_this.setState({creditCard:creditCard});};_this.fetchInstallments=function(points){var creditCard=Object.assign({},_this.state.creditCard,{installment:null});_this.setState({creditCard:creditCard,paymentPoints:points});var _this$props$payment$p=_this.props.payment.pointsCashConfig,maxPointForCash=_this$props$payment$p.maxPointForCash,totalOrder=_this$props$payment$p.totalOrder;var pointsDiff=maxPointForCash-points<0?totalOrder-maxPointForCash:totalOrder-points;_this.props.fetchInstallments({PointsCash:pointsDiff});};_this.handleStepChange=function(step){_this.setState({step:step,paymentSelected:paymentDefault});_this.sendGTM();};_this.handleConfirmAddress=function(shippingAddress){_this.props.updateShippingAddress({customer:_this.state.customer,shippingAddress:shippingAddress});};_this.installmentSelected=function(){return _this.state.creditCard.installment||_this.props.payment.installments.items[2];};_this.cardBrand=function(){var number=_this.cardNumber();var brands=_this.props.payment.pointsCashConfig.cardBrandModel;if(!number)return;if(_this.props.onlyCash&&_this.state.vendorBrands&&_this.state.vendorBrands.type!=='classic'){var paymentTypes=_this.state.vendorBrands.data;var cardbrand=paymentTypes&&paymentTypes.find(function(item){return RegExp(item.regex).test(number);});brand=cardbrand&&{id:cardbrand.idFormaPagamento,name:cardbrand.nome,imageUrl:cardbrand.urlImage,regexValidation:cardbrand.regex};}else{if(!brands)return;brand=brands.find(function(item){return RegExp(item.regexValidation).test(number);});}return brand;};_this.getPaymentsByVendor=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(item){var price,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:price=_this.convertNumber(_this.props.cart.priceCash+_this.props.cart.shipping.totalCash);_context.t0=_this.props.cart.shippingAddress.zipCode;_context.t1=price;_context.next=5;return _this.createProductsToSend(_this.props.cart);case 5:_context.t2=_context.sent;data={zip_code:_context.t0,shipment_id:0,cart_total_value:_context.t1,products:_context.t2};return _context.abrupt('return',__WEBPACK_IMPORTED_MODULE_13__Payment_PaymentBrands_PaymentClient__["a" /* default */].handleCardbrands(item.vendor.id,data));case 8:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();_this.getInstallments=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(item,cardBrand){var price,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:price=_this.convertNumber(_this.props.cart.priceCash+_this.props.cart.shipping.totalCash);_context2.t0=_this.props.cart.shippingAddress.zipCode;_context2.t1=price;_context2.t2=[cardBrand];_context2.next=6;return _this.createProductsToSend(_this.props.cart);case 6:_context2.t3=_context2.sent;data={zip_code:_context2.t0,shipment_id:0,cart_total_value:_context2.t1,payment_options:_context2.t2,products:_context2.t3};return _context2.abrupt('return',__WEBPACK_IMPORTED_MODULE_13__Payment_PaymentBrands_PaymentClient__["a" /* default */].handleInstallments(item.vendor.id,data));case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}();_this.createProductsToSend=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(cart){var products,index,product;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:products=[];index=0;case 2:if(!(index<cart.items.length)){_context3.next=12;break;}_context3.t0=cart.items[index].quantity;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_13__Payment_PaymentBrands_PaymentClient__["a" /* default */].getOriginalId(cart.items[index].sku);case 6:_context3.t1=_context3.sent;product={quantity:_context3.t0,product_id:_context3.t1};products.push(product);case 9:index++;_context3.next=2;break;case 12:return _context3.abrupt('return',products);case 13:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x4){return _ref4.apply(this,arguments);};}();_this.convertNumber=function(num){var convertido=num.toFixed(2);return Number(convertido);};_this.updateInstallments=function(installments){if(_this.props.onlyCash&&_this.state&&_this.state.vendorBrands&&_this.state.vendorBrands.type===cardType&&_this.state.vendorInstallments){installments=_this.state.vendorInstallments?_this.state.vendorInstallments.data:installments;}return installments;};_this.checkError=function(error){var formatedError=error.split(' - ');return error.includes('exception')?'Tente novamente em instantes':formatedError[1]||_this.defaultMessageError();};_this.cardNumber=function(){var onlyNumbers=_this.state.creditCard.number.match(/\d+/g);if(onlyNumbers)return onlyNumbers.join([]);return'';};_this.getCvv=function(){var onlyNumbers=_this.state.creditCard.cvv.match(/\d+/g);if(onlyNumbers)return onlyNumbers.join([]);return'';};_this.createPurchasePointsCash=function(){var _this$state=_this.state,creditCard=_this$state.creditCard,paymentPoints=_this$state.paymentPoints;var totalOrder=_this.props.payment.pointsCashConfig.totalOrder;var validityDateParts=creditCard.validityDate.split('/');var installmentSelected=_this.installmentSelected();var installments=installmentSelected.parcel;var pointsValue=_this.props.onlyCash?installments*installmentSelected.parcelValue:totalOrder-paymentPoints;var cardBrand=_this.cardBrand();var cardNumber=_this.cardNumber();_this.props.createPurchase({cardBrandId:cardBrand.id,cardHolderName:creditCard.personName,cardHolderCPF:creditCard.personCPF.replace(/[^0-9 ]/g,''),cardNumber:cardNumber,expirationMonth:validityDateParts[0],expirationYear:validityDateParts[1],securityCode:_this.getCvv(),installments:installments,pointsValue:pointsValue});};_this.createPurchase=function(){var paymentSelected=_this.state.paymentSelected;if(paymentSelected==='POINTS_ONLY'){_this.props.createPurchase();}else{_this.createPurchasePointsCash();}};_this.defaultMessageError=function(){var messageError='Vamos fazer uma nova tentativa?';return _this.state.paymentSelected==='POINTS_ONLY'?messageError:messageError+' Verifique os dados do cart\xE3o ou tente outro cart\xE3o.';};_this.toogleModal=function(){_this.setState({showModal:!_this.state.showModal});};_this.forceFocus=_this.forceFocus.bind(_this);_this.cardBrand=_this.cardBrand.bind(_this);_this.setVendorBrands=_this.setVendorBrands.bind(_this);_this.updateInstallments=_this.updateInstallments.bind(_this);return _this;}_createClass(Checkout,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;this.props.loadCart();this.props.resetShipping();this.props.clearError();this.props.clearConfirmedOrderData();if(this.props.catalogJustCash){this.props.getVisualizationContext();}setTimeout(function(){_this3.setState({showPayment:true});},600);}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.state.shippingCalculated&&this.props.shipping&&this.props.shipping.value===null&&this.props.address&&this.props.address.zipCode!==''&&this.props.address.zipCode){this.props.fetchShipping(this.props.address.zipCode);this.shippingCalculated();}if(this.props.secondFactorAuthSuccess){if(this.props.authorized&&(this.props.statusCode!==500||this.props.statusCode!==400)){this.confirm(this.props.confirmedOrderId);}else if(this.props.authorized===false){this.props.closeModal();}}if(this.props.cart&&this.props.cart.items&&this.props.cart.items.length>0&&!this.state.vendorBrands&&!this.props.payment.pointsCashConfig.isLoading&&this.props.onlyCash){this.setVendorBrands();}if(this.props.cart&&this.props.cart.items&&this.props.cart.items.length>0&&this.props.onlyCash&&this.state.vendorBrands&&!this.state.vendorInstallments&&!this.state.vendorInstallmentsIsLoading){this.setVendorInstallments();}}},{key:'shippingCalculated',value:function shippingCalculated(){this.setState({shippingCalculated:true});}},{key:'setVendorBrands',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var vendorBrands;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.getPaymentsByVendor(this.props.cart.items.find(function(e){return true;}));case 2:vendorBrands=_context4.sent;this.setState({vendorBrands:vendorBrands});case 4:case'end':return _context4.stop();}}},_callee4,this);}));function setVendorBrands(){return _ref5.apply(this,arguments);}return setVendorBrands;}()},{key:'setVendorInstallments',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var parcelas;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(this.state.vendorBrands.type===cardType&&brand&&brand.id)){_context5.next=6;break;}this.setState({vendorInstallmentsIsLoading:true});_context5.next=4;return this.getInstallments(this.props.cart.items.find(function(e){return true;}),brand.id);case 4:parcelas=_context5.sent;this.setState({vendorInstallments:parcelas,vendorInstallmentsIsLoading:false});case 6:case'end':return _context5.stop();}}},_callee5,this);}));function setVendorInstallments(){return _ref6.apply(this,arguments);}return setVendorInstallments;}()},{key:'sendGTM',value:function sendGTM(){var _this4=this;setTimeout(function(){var props=_this4.props.cart;var step=_this4.state.step+2;if(Object.entries(props.items).length>0){var productsList=[];props.items.map(function(item,index){var categoryName=void 0;if(item.category){categoryName=item.category.name?__WEBPACK_IMPORTED_MODULE_16_react_slugify___default()(item.category.name,{delimiter:' '}):undefined;}return productsList.push({'name':__WEBPACK_IMPORTED_MODULE_16_react_slugify___default()(item.name,{delimiter:' '}),'id':item.sku,'price':item.price,'brand':undefined,'category':categoryName,'variant':undefined,'quantity':item.quantity,'coupon':undefined,'dimension5':item.vendor?'vendor-'+item.vendor.id:undefined,'metric2':item.cash?item.cash.sellingPrice.toFixed(2):undefined});});window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'checkout','eventCategory':'enhanced-ecommerce','eventAction':'checkout','ecommerce':{'checkout':{'actionField':{'step':step.toString()},'products':productsList}}});}},500);this.setState({sendGTM:true});}},{key:'render',value:function render(){var _this5=this;if(this.props.confirmedOrderId!==undefined){if(this.props.status!=='RequiresTokenValidation'&&this.props.status!=='Onboarding'&&this.props.status!=='ResendTokenError'&&this.props.secondFactorAuthSuccess!==true&&this.props.authorized){this.props.redirectConfirmation(this.props.confirmedOrderId);}}if(this.props.onlyCash&&this.state.paymentSelected!=='CASH_ONLY'){this.setState({paymentSelected:'CASH_ONLY'});}var _props$cart=this.props.cart,price=_props$cart.price,priceCash=_props$cart.priceCash,shipping=_props$cart.shipping,coupon=_props$cart.coupon;var totalPoints=Math.max(price+(shipping.total||0)-(coupon&&coupon.totalOfBenefits||0),0);var totalCash=priceCash+(shipping.totalCash||0);var totalPrice={points:totalPoints,cash:totalCash};var props=Object.assign({},this.props,this.state,{totalPrice:totalPrice,handleStepChange:this.handleStepChange,setCustomer:this.setCustomer,handleConfirmAddress:this.handleConfirmAddress,selectPointsCash:this.selectPointsCash,selectPointsOnly:this.selectPointsOnly,handleCreditCardChange:this.handleCreditCardChange,fetchInstallments:this.fetchInstallments,installmentSelected:this.installmentSelected,cardBrand:this.cardBrand,createPurchase:this.createPurchase,updateInstallments:this.updateInstallments});if(this.state.sendGTM===false){this.sendGTM();}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('title',null,'Pagamento - '+("Tupperware | Premmiar"||'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_responsive___default.a,{maxDeviceWidth:'1024'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__App_Shell_TitleAnnouncer__["a" /* default */],{orientation:'mobile'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_responsive___default.a,{minDeviceWidth:'1025'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__App_Shell_TitleAnnouncer__["a" /* default */],{orientation:'desktop'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_placeholder___default.a,{ready:!this.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CheckoutPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-cart container py-md-5 py-0 px-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row mx-0'},props.hasError&&props.statusCode!==406&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Alert"],{isError:true,title:props.titleError?props.titleError:'Não foi possível concluir o seu pagamento.',description:'Descri\xE7\xE3o do erro: '+this.checkError(props.messageError),className:'pb-2',onClose:this.props.clearError}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'checkout-side col-12 col-lg-8 pl-0 pr-lg-2 pr-0 mt-5 pt-2 mt-sm-0 pt-sm-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row mx-0'},props.cart.hasItemsDifferentVirtualVoucher?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProfileInfos__["d" /* ProfileInfos */],Object.assign({forceFocus:this.forceFocus},props)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShippingAddress__["a" /* ShippingAddress */],Object.assign({forceFocus:this.forceFocus},props,{orientation:'desktop'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_responsive___default.a,{maxDeviceWidth:1024},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShippingAddress__["a" /* ShippingAddress */],Object.assign({forceFocus:this.forceFocus},props,{orientation:'mobile'})))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FormVirtualVoucher__["a" /* FormVirtualVoucher */],props),this.state.showPayment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Payment__["a" /* Payment */],Object.assign({},props,{orientation:'desktop'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_responsive___default.a,{maxDeviceWidth:1024},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Payment__["a" /* Payment */],Object.assign({},props,{orientation:'mobile'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Summary__["a" /* Summary */],props)),this.props.confirmedOrderId!==undefined&&this.props.status==='RequiresTokenValidation'&&// eslint-disable-next-line react/jsx-indent
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],Object.assign({show:this.state.showModal&&!this.props.secondFactorAuthSuccess,onClose:function onClose(){return _this5.toogleModal();},secondFactorAuthConfirmated:true},this.props,{creditCard:props.creditCard,cardBrand:props.cardBrand,paymentSelected:props.paymentSelected,payment:this.props.payment,paymentPoints:props.paymentPoints,oidc:this.props.oidc}))),this.props.statusCode===406&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],Object.assign({show:this.state.showModal&&!this.props.secondFactorAuthSuccess,onClose:function onClose(){return _this5.toogleModal();},secondFactorAuthConfirmated:false},this.props,{creditCard:props.creditCard,cardBrand:props.cardBrand,paymentSelected:props.paymentSelected,payment:this.props.payment,paymentPoints:props.paymentPoints,oidc:this.props.oidc}))))));}}]);return Checkout;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Checkout.propTypes={address:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,participant:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,payment:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,cart:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,currency:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,hasError:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,messageError:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,updateShippingAddress:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchInstallments:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,createPurchase:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,redirectConfirmation:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,confirmedOrderId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,status:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,statusCode:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,errorToken:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,clearError:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchShipping:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,resetShipping:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,shipping:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,loadCart:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,removeCoupon:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,catalog:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,brandsByVendor:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,authorizeWithToken:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,secondFactorAuthSuccess:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,authorized:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,changePropToSuccess:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,clearConfirmedOrderData:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,closeModal:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,oidc:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,updateInstallments:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,getVisualizationContext:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,catalogJustCash:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Checkout);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(485);
var buildPhone=function buildPhone(phone,type){if(!phone){return{areaCode:'',number:'',type:type};}var numberPattern=/\d+/g;var onlyNumbers=phone.match(numberPattern).join([]);return{areaCode:onlyNumbers.substr(0,2),number:onlyNumbers.substr(2),type:type};};var ProfileInfos=function ProfileInfos(props){if(props.step===0){var Component=props.participant.isCompany?__WEBPACK_IMPORTED_MODULE_2____["a" /* Company */]:__WEBPACK_IMPORTED_MODULE_2____["c" /* Individual */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* Header */],{step:props.step,handleStepChange:props.handleStepChange,description:'Documento: '+props.customer.documentNumber,active:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},props,{buildPhone:buildPhone})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* Header */],{step:props.step,handleStepChange:props.handleStepChange,description:'Documento: '+props.customer.documentNumber}));};ProfileInfos.propTypes={step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,handleStepChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,forceFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProfileInfos);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Participant__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gerador_validador_cpf__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gerador_validador_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gerador_validador_cpf__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProfileInfos=function(_Component){_inherits(ProfileInfos,_Component);function ProfileInfos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProfileInfos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProfileInfos.__proto__||Object.getPrototypeOf(ProfileInfos)).call.apply(_ref,[this].concat(args))),_this),_this.state={isValid:true,name:_this.props.participant.name,cpf:_this.props.participant.cpf,email:_this.props.participant.email,birthDate:_this.props.participant.birthDate,phone:{value:_this.props.participant.phones.home&&_this.props.participant.phones.home.number?''+_this.props.participant.phones.home.areaCode+_this.props.participant.phones.home.number:'',disabled:_this.props.participant.phones.home.disabled},mobilePhone:{value:''+_this.props.participant.phones.mobile.areaCode+_this.props.participant.phones.mobile.number,disabled:_this.props.participant.phones.mobile.disabled},buttonNext:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef()},_this.isValid=function(){var isValid=true;var mailValidator=/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim;var _this$state=_this.state,name=_this$state.name,cpf=_this$state.cpf,email=_this$state.email,birthDate=_this$state.birthDate,mobilePhone=_this$state.mobilePhone;if(!name.value){_this.setState({name:{value:name.value,disabled:name.disabled,error:'Digite seu nome'}});isValid=false;}if(!Object(__WEBPACK_IMPORTED_MODULE_5_gerador_validador_cpf__["validate"])(cpf.value)){_this.setState({cpf:{value:cpf.value,disabled:cpf.disabled,error:'Digite um CPF válido'}});isValid=false;}if(!mailValidator.test(email.value)){_this.setState({email:{value:email.value,disabled:email.disabled,error:'Digite um e-mail válido'}});isValid=false;}var birthDateVerify=__WEBPACK_IMPORTED_MODULE_4_moment___default()(birthDate.value,'DD/MM/YYYY',true);if(!birthDateVerify.isValid()){_this.setState({birthDate:{value:birthDate.value,disabled:birthDate.disabled,error:'Digite uma data de nascimento válida'}});isValid=false;}if(!mobilePhone.value){_this.setState({mobilePhone:{value:mobilePhone.value,disabled:mobilePhone.disabled,error:'Digite um celular válido'}});isValid=false;}_this.setState({isValid:isValid});return isValid;},_this.handleConfirm=function(){if(!_this.isValid())return;var _this$props=_this.props,buildPhone=_this$props.buildPhone,setCustomer=_this$props.setCustomer,participant=_this$props.participant;var _this$state2=_this.state,name=_this$state2.name,cpf=_this$state2.cpf,email=_this$state2.email,phone=_this$state2.phone,birthDate=_this$state2.birthDate,mobilePhone=_this$state2.mobilePhone;var phones=[buildPhone(mobilePhone.value,'MOBILE')];if(phone.value){phones.push(buildPhone(phone.value,'HOME'));}var customer={name:name.value,documentNumber:cpf.value,email:email.value,genderType:__WEBPACK_IMPORTED_MODULE_3_Participant__["h" /* genderTypes */][participant.genderType.value],personType:'INDIVIDUAL',birthDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()(birthDate.value,'DD/MM/YYYY').format('YYYY/MM/DD'),phones:phones};setCustomer(customer);},_this.handleInputChange=function(event){_this.setState(_defineProperty({},event.target.name,{value:event.target.value}));},_this.handleKeyPress=function(e,element){var inputIndex=element;var inputOrder=['input-name-profile-data','input-cpf-profile-data','input-email-profile-data','input-birthDate-profile-data','input-mobilePhone-profile-data','input-phone-profile-data','next-button'];var isDisabled=true;while(isDisabled){if(inputOrder[inputIndex]==='next-button'){isDisabled=false;}else{var input=document.querySelector('#'+inputOrder[inputIndex]);if(input.getAttribute('disabled')===null||input.getAttribute('disabled')===undefined){isDisabled=false;}else{inputIndex++;}}}// eslint-disable-next-line no-unused-expressions
if(e.key==='Enter'){if(inputIndex){e.target.blur();document.querySelector('#'+inputOrder[inputIndex])&&document.querySelector('#'+inputOrder[inputIndex]).focus();}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProfileInfos,[{key:'componentDidMount',value:function componentDidMount(){this.isValid();}},{key:'handleInputValid',value:function handleInputValid(input){if(input.error)return false;return null;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-infos col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-name-profile-data',label:'Nome',ref:this.state.inputNameRef,className:'col-12 col-md-6 mt-2',minLength:'1',maxLength:'50',name:'name',required:true,'data-error':this.state.name.error,valid:this.handleInputValid(this.state.name),onChange:this.handleInputChange,value:this.state.name.value,disabled:this.state.name.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,1);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-cpf-profile-data',label:'CPF',ref:this.state.inputCPFRef,className:'col-12 col-md-6 mt-2',required:true,mask:[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/],name:'cpf','data-error':this.state.cpf.error,valid:this.handleInputValid(this.state.cpf),onChange:this.handleInputChange,value:this.state.cpf.value,disabled:this.state.cpf.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,2);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-email-profile-data',label:'E-mail',ref:this.state.inputEmailRef,className:'col-12 col-md-6 mt-2',required:true,name:'email','data-error':this.state.email.error,valid:this.handleInputValid(this.state.email),onChange:this.handleInputChange,value:this.state.email.value,disabled:this.state.email.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,3);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-birthDate-profile-data',label:'Data de nascimento',ref:this.state.inputDateRef,className:'col-12 col-md-6 mt-2',required:true,name:'birthDate',mask:[/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[1-2]/,/[0-9]/,/[0-9]/,/[0-9]/],'data-error':this.state.birthDate.error,valid:this.handleInputValid(this.state.birthDate),onChange:this.handleInputChange,value:this.state.birthDate.value,disabled:this.state.birthDate.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,4);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-mobilePhone-profile-data',label:'Celular',ref:this.state.inputCelRef,className:'col-12 col-md-6 mt-2',required:true,mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],'data-error':this.state.mobilePhone.error,valid:this.handleInputValid(this.state.mobilePhone),onChange:this.handleInputChange,name:'mobilePhone',value:this.state.mobilePhone.value,disabled:this.state.mobilePhone.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,5);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-phone-profile-data',label:'Telefone',ref:this.state.inputTelRef,className:'col-12 col-md-6 mt-2',mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],name:'phone',onChange:this.handleInputChange,value:this.state.phone.value,disabled:this.state.phone.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,6);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 offset-md-6 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured',disabled:!this.state.isValid,onClick:function onClick(){_this2.handleConfirm();_this2.props.forceFocus();},text:'Pr\xF3ximo',id:'next-button',ref:this.state.buttonNext})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured',disabled:!this.state.isValid,onClick:function onClick(){_this2.handleConfirm();_this2.props.forceFocus();},text:'Pr\xF3ximo'}))))));}}]);return ProfileInfos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});ProfileInfos.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:valueType,cpf:valueType,email:valueType,birthDate:valueType,phones:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,genderType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}).isRequired,setCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,buildPhone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,forceFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProfileInfos);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var AccessSecurity=function AccessSecurity(_ref){var selected=_ref.selected;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'user-item item-calendar px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/security-access'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'profile-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase',to:'/security-access',tabIndex:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_lock'}),'Acessos e seguran\xE7a')));};AccessSecurity.propTypes={selected:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (AccessSecurity);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var ChangePassword=function ChangePassword(_ref){var selected=_ref.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-password px-1 py-0 py-1 border-bottom border-color-ui-3 '+(selected==='/my-account/change-password'?'active':''),role:'menuitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{className:'profile-button col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-body-sm txt-uppercase',to:'/my-account/change-password',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_lock'}),'Alterar senha')));};ChangePassword.propTypes={selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ChangePassword);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var FormPlaceholder=function FormPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-form col-12 mt-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md mr-0 mr-md-1 mt-2 pt-5 bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md ml-0 ml-md-1 mt-2 pt-5 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md mr-0 mr-md-1  mt-2 pt-5 bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md ml-0 ml-md-1 mt-2 pt-5 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md mr-0 mr-md-1 mt-2 pt-5 bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md ml-0 ml-md-1 mt-2 pt-5 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md mr-0 mr-md-1 mt-2 pt-5 bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md ml-0 ml-md-1 mt-2 pt-5 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 mt-2 pt-5 bg-ui-3 radius'})));};/* harmony default export */ __webpack_exports__["a"] = (FormPlaceholder);

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Participant_ducks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Participant_Address_Address__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_Address__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_features_Address_reducer__ = __webpack_require__(484);
var mapStateToProps=function mapStateToProps(state){return Object(__WEBPACK_IMPORTED_MODULE_5_features_Address_reducer__["b" /* getAddress */])(state);};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchShipping:function fetchShipping(zipCode){dispatch(__WEBPACK_IMPORTED_MODULE_4_features_Address__["a" /* actions */].fetchAddress(zipCode));},updateParticipant:function updateParticipant(participant){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Participant_ducks__["g" /* update */])(participant));},expireUpdatedParticipant:function expireUpdatedParticipant(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Participant_ducks__["d" /* expireUpdatedParticipant */])());},closeAlert:function closeAlert(){dispatch(__WEBPACK_IMPORTED_MODULE_4_features_Address__["a" /* actions */].cleanError());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Participant_ducks__["b" /* cleanError */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Participant_Address_Address__["a" /* default */],props);}));

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Participant_ducks__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getZipCode=function getZipCode(value){var number=value?Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["f" /* getOnlyNumbers */])(value):'';return{value:value,number:number};};var Form=function(_Component){_inherits(Form,_Component);function Form(props){_classCallCheck(this,Form);var _this=_possibleConstructorReturn(this,(Form.__proto__||Object.getPrototypeOf(Form)).call(this,props));_this.changeAddress=function(){if(!_this.props.isLoading){if(_this.props.street.value!==_this.state.street.value&&_this.state.street.value===''){_this.setState({street:{value:_this.props.streetType.value+' '+_this.props.street.value}});}if(_this.props.district.value!==_this.state.district.value&&_this.state.district.value===''){_this.setState({district:{value:_this.props.district.value}});}}};_this.buttonProps=function(){return _this.props.participant.updatedSuccessfully?{text:'Salvo',className:'btn btn-sm btn-featured bg-success'}:{text:'Salvar',className:'btn btn-sm btn-featured'};};_this.handleZipCodeChange=function(_ref){var value=_ref.target.value;var zipCode=getZipCode(value);_this.setState({zipCode:zipCode,dirty:true});if(zipCode.number.length===8){_this.setState({district:{value:''},street:{value:''}});_this.props.fetchShipping(zipCode.number);}};_this.isZipCodeValid=function(value){return!!value&&value.length===8;};_this.validateZipCode=function(){var _this$state$zipCode=_this.state.zipCode,number=_this$state$zipCode.number,value=_this$state$zipCode.value;var isValid=_this.isZipCodeValid(number);var zipCode={value:value,number:number,isValid:isValid};_this.setState({zipCode:zipCode,dirty:true});};_this.isNumberValid=function(value){return!!value;};_this.validateNumber=function(){var value=_this.state.number.value;var isValid=_this.isNumberValid(value);_this.setState({number:{value:value,isValid:isValid},dirty:true});};_this.isDistrictValid=function(value){return!!value&&value.length>2;};_this.isStreetValid=function(value){return!!value&&value.length>2;};_this.buttonDisabled=function(){var _this$state=_this.state,zipCode=_this$state.zipCode,number=_this$state.number,dirty=_this$state.dirty,district=_this$state.district,street=_this$state.street;var enabled=dirty&&_this.isZipCodeValid(zipCode.number)&&_this.isNumberValid(number.value)&&_this.isDistrictValid(district.value)&&_this.isStreetValid(street.value);return!enabled;};_this.isValid=function(){var isValid=true;var _this$state2=_this.state,complement=_this$state2.complement,reference=_this$state2.reference;var nameValidator=/^[\wÀ-Ÿ\-&\s()]+(?![http:https:www.])$/;if(!complement.value){_this.setState({complement:{value:complement.value,disabled:complement.disabled,error:'O complemento é obrigatório'}});isValid=false;}if(!nameValidator.test(complement.value)){_this.setState({complement:{value:complement.value,disabled:complement.disabled,error:'Digite um complemento válido'}});isValid=false;}if(reference.value){if(!nameValidator.test(reference.value)){_this.setState({reference:{value:reference.value,disabled:reference.disabled,error:'Digite uma referência válida'}});isValid=false;}}_this.setState({isValid:isValid});};_this.handleOnClick=function(){if(!_this.state.isValid)return;var _this$state3=_this.state,zipCode=_this$state3.zipCode,number=_this$state3.number,complement=_this$state3.complement,reference=_this$state3.reference,district=_this$state3.district,street=_this$state3.street;var address={zipCode:zipCode.number,number:number.value,complement:complement.value,reference:reference.value,district:district.value,street:street.value,city:_this.props.city.value,state:_this.props.state.value};var _this$props$participa=_this.props.participant,maritalStatus=_this$props$participa.maritalStatus,genderType=_this$props$participa.genderType,birthDate=_this$props$participa.birthDate,name=_this$props$participa.name,cpfCnpj=_this$props$participa.cpfCnpj,phones=_this$props$participa.phones,email=_this$props$participa.email;var currPhones=[];if(phones.home.number)currPhones.push(phones.home);if(phones.mobile.number)currPhones.push(phones.mobile);if(phones.work.number)currPhones.push(phones.work);_this.props.updateParticipant({name:name.value,documentNumber:cpfCnpj.value,maritalStatus:maritalStatus.value,genderType:genderType.value,birthDate:birthDate.value?__WEBPACK_IMPORTED_MODULE_2_moment___default()(birthDate.value,'DD/MM/YYYY').format():undefined,emails:[{email:email.value,type:'PERSONAL'}],status:__WEBPACK_IMPORTED_MODULE_4____["j" /* profileStatuses */][_this.props.participant.statusId],profileId:_this.props.participant.profileId,phones:currPhones,address:address});};_this.state={zipCode:_this.props.zipCode&&getZipCode(_this.props.zipCode.value),number:{value:_this.props.number&&_this.props.number.value},complement:_this.props.complement,reference:_this.props.reference,city:_this.props.city&&_this.props.city.value,state:_this.props.state&&_this.props.state.value,street:{value:_this.props.street&&_this.props.street.valueParticipant,disabled:_this.props.street.disabled},district:{value:_this.props.district&&_this.props.district.valueParticipant,disabled:_this.props.district.disabled},dirty:false,loaded:false,isLoading:_this.props.isLoading,isValid:true};return _this;}_createClass(Form,[{key:'updateInitialState',value:function updateInitialState(){var addressDone=this.props.zipCode&&this.props.zipCode.value!==''&&this.props.number&&this.props.number.value!==''&&this.props.street&&this.props.street.valueParticipant!==''&&this.props.district&&this.props.district.valueParticipant!==''&&this.props.city.value&&this.props.city.value!==''&&this.props.state.value&&this.props.state.value!=='';addressDone&&this.setState({zipCode:this.props.zipCode&&getZipCode(this.props.zipCode.value),number:{value:this.props.number&&this.props.number.value},complement:this.props.complement,reference:this.props.reference,city:this.props.city&&this.props.city.value,state:this.props.state&&this.props.state.value,street:{value:this.props.street&&this.props.street.valueParticipant,disabled:this.props.street.disabled},district:{value:this.props.district&&this.props.district.valueParticipant,disabled:this.props.district.disabled},dirty:false,loaded:true,isLoading:this.props.isLoading});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;this.changeAddress();!this.state.loaded&&!this.props.isLoading&&this.updateInitialState();if(!this.props.participant.updatedSuccessfully)return;setTimeout(function(){_this2.setState({dirty:false});_this2.props.expireUpdatedParticipant();},3000);}},{key:'handleInputValid',value:function handleInputValid(input){if(input&&input.error)return false;return true;}},{key:'render',value:function render(){var _this3=this;var cepValid=this.state.zipCode&&this.state.zipCode.isValid;var streetDisabled=true;var districtDisabled=true;if(this.props.cepError)cepValid=false;if(!this.props.isLoading&&this.props.city.value!==''){if(this.props.street.value==='')streetDisabled=false;if(this.props.district.value==='')districtDisabled=false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-form col-12 mt-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-zipCode',label:'CEP',className:'col-12 col-md-6 mt-2',value:this.state.zipCode&&this.state.zipCode.value,onChange:this.handleZipCodeChange,mask:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/],required:true,disabled:this.props.zipCode.value!==''&&this.props.zipCode.disabled==='true','data-error':'Digite um CEP v\xE1lido',valid:cepValid,onBlur:this.validateZipCode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-street',label:'Logradouro',className:'col-12 col-md-6 mt-2',value:this.state.street.value,onChange:function onChange(e){return _this3.setState({street:{value:e.target.value,isValid:null},dirty:true});},maxLength:'100',required:true,disabled:streetDisabled,'data-error':'Digite um Logradouro',valid:this.isStreetValid(this.state.street.value)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-number',label:'N\xFAmero',className:'col-12 col-md-6 mt-2',value:this.state.number.value,onChange:function onChange(e){return _this3.setState({number:{value:e.target.value,isValid:null},dirty:true});},required:true,disabled:this.props.number&&this.props.number.disabled==='true','data-error':'Digite um n\xFAmero',valid:this.state.number.isValid,onBlur:this.validateNumber}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-complement',label:'Complemento',name:'complement',required:true,className:'col-12 col-md-6 mt-2',value:this.state.complement.value,onChange:function onChange(e){return _this3.setState({complement:{value:e.target.value},dirty:true});},disabled:this.props.complement&&this.props.complement.disabled==='true','data-error':this.state.complement&&this.state.complement.error,valid:this.handleInputValid(this.state.complement),onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{name:'reference',id:'address-reference',label:'Ponto de Refer\xEAncia',className:'col-12 col-md-6 mt-2',value:this.state.reference.value,onChange:function onChange(e){return _this3.setState({reference:{value:e.target.value}});},disabled:this.props.reference&&this.props.reference.disabled==='true','data-error':this.state.reference&&this.state.reference.error,valid:this.handleInputValid(this.state.reference),onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-district',label:'Bairro',className:'col-12 col-md-6 mt-2',value:this.state.district.value,onChange:function onChange(e){return _this3.setState({district:{value:e.target.value,isValid:null},dirty:true});},maxLength:'100',required:true,disabled:districtDisabled,'data-error':'Digite um Bairro',valid:this.isDistrictValid(this.state.district.value)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-city',label:'Cidade',className:'col-12 col-md-6 mt-2',value:this.props.city.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'address-state',label:'Estado',className:'col-12 col-md-6 mt-2',value:this.props.state.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],Object.assign({id:'btn-address-submit',className:'btn-featured form-field btn-sm txt-center',text:'Salvar',onClick:this.handleOnClick,disabled:this.buttonDisabled()},this.buttonProps(),{loading:this.props.participant.isUpdating})))));}}]);return Form;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string});Form.propTypes={street:valueType,streetType:valueType,district:valueType,city:valueType,state:valueType,zipCode:valueType,number:valueType,complement:valueType,reference:valueType,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,updateParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,cepError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,expireUpdatedParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Participant_Profile_Profile__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Participant_ducks__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(_ref){var participant=_ref.participant;return{participant:participant};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateParticipant:function updateParticipant(participant){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Participant_ducks__["g" /* update */])(participant));},expireUpdatedParticipant:function expireUpdatedParticipant(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Participant_ducks__["d" /* expireUpdatedParticipant */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Participant_Profile_Profile__["a" /* default */],props);}));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Participant_ducks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gerador_validador_cpf__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gerador_validador_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gerador_validador_cpf__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Individual=function(_Component){_inherits(Individual,_Component);function Individual(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Individual);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Individual.__proto__||Object.getPrototypeOf(Individual)).call.apply(_ref,[this].concat(args))),_this),_this.state={dirty:false,isValid:true,name:_this.props.participant.name,cpf:_this.props.participant.cpf,email:_this.props.participant.email,homePhone:{value:''+(_this.props.participant.phones.home&&_this.props.participant.phones.home.areaCode)+(_this.props.participant.phones.home&&_this.props.participant.phones.home.number),disabled:_this.props.participant.phones.home&&_this.props.participant.phones.home.disabled},mobilePhone:{value:''+(_this.props.participant.phones.mobile&&_this.props.participant.phones.mobile.areaCode)+(_this.props.participant.phones.mobile&&_this.props.participant.phones.mobile.number),disabled:_this.props.participant.phones.mobile&&_this.props.participant.phones.mobile.disabled},genderType:{value:_this.props.participant.genderType&&__WEBPACK_IMPORTED_MODULE_4____["h" /* genderTypes */][_this.props.participant.genderType.value]},birthDate:_this.props.participant.birthDate,maritalStatusSelected:{value:_this.props.participant.maritalStatus&&__WEBPACK_IMPORTED_MODULE_4____["i" /* maritalStatuses */].getById(_this.props.participant.maritalStatus.value).value,text:_this.props.participant.maritalStatus&&__WEBPACK_IMPORTED_MODULE_4____["i" /* maritalStatuses */].getById(_this.props.participant.maritalStatus.value).text,disabled:_this.props.participant.maritalStatus&&_this.props.participant.maritalStatus.disabled}},_this.isValid=function(){var isValid=true;var mailValidator=/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim;var _this$state=_this.state,name=_this$state.name,cpf=_this$state.cpf,email=_this$state.email,mobilePhone=_this$state.mobilePhone,birthDate=_this$state.birthDate;var nameValidator=/^[\wÀ-Ÿ\-&\s()]+(?![http:https:])$/;if(!nameValidator.test(name.value)){_this.setState({name:{value:name.value,disabled:name.disabled,error:'Digite um nome válido'}});isValid=false;}if(!name.value){_this.setState({name:{value:name.value,disabled:name.disabled,error:'Digite seu nome'}});isValid=false;}if(!Object(__WEBPACK_IMPORTED_MODULE_6_gerador_validador_cpf__["validate"])(cpf.value)){_this.setState({cpf:{value:cpf.value,disabled:cpf.disabled,error:'Digite um CPF válido'}});isValid=false;}if(!mailValidator.test(email.value)){_this.setState({email:{value:email.value,disabled:email.disabled,error:'Digite um e-mail válido'}});isValid=false;}if(!mobilePhone.value){_this.setState({mobilePhone:{value:mobilePhone.value,disabled:mobilePhone.disabled,error:'Digite um celular válido'}});isValid=false;}if(!birthDate.value){_this.setState({birthDate:Object.assign({},birthDate,{value:birthDate.value,error:'Digite sua data de nascimento'})});isValid=false;}_this.setState({isValid:isValid});},_this.buttonProps=function(){return _this.props.participant.updatedSuccessfully?{text:'Salvo',className:'btn btn-sm btn-featured bg-success'}:{text:'Salvar',className:'btn btn-sm btn-featured'};},_this.handleOnSubmit=function(){if(!_this.state.isValid)return;var _this$state2=_this.state,name=_this$state2.name,cpf=_this$state2.cpf,email=_this$state2.email,homePhone=_this$state2.homePhone,mobilePhone=_this$state2.mobilePhone,birthDate=_this$state2.birthDate,maritalStatusSelected=_this$state2.maritalStatusSelected,genderType=_this$state2.genderType;var address=_this.props.participant.address;var phones=[];if(homePhone.value)phones.push(Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["a" /* buildPhone */])(homePhone.value,'HOME'));if(mobilePhone.value)phones.push(Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["a" /* buildPhone */])(mobilePhone.value,'MOBILE'));_this.props.updateParticipant({name:name.value,documentNumber:Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["f" /* getOnlyNumbers */])(cpf.value),maritalStatus:maritalStatusSelected.value,genderType:genderType.value,birthDate:birthDate.value&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(birthDate.value,'DD/MM/YYYY').format(),emails:[{email:email.value,type:'PERSONAL'}],status:__WEBPACK_IMPORTED_MODULE_4____["j" /* profileStatuses */][_this.props.participant.statusId],profileId:_this.props.participant.profileId,phones:phones,address:address?{street:address.addressText.value,number:address.number.value,complement:address.complement.value,district:address.district.value,city:address.city.value,state:address.state.value?address.state.value:'SP',zipCode:address.zipCode.value?address.zipCode.value:'00000000'}:{street:'',number:'',complement:'',district:'',city:'',state:'SP',zipCode:'00000000'}});},_this.handleInputChange=function(event){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,event.target.name,{value:event.target.value}),_defineProperty(_this$setState,'dirty',true),_this$setState));},_this.handleSelectInputChange=function(value){_this.setState({maritalStatusSelected:{value:value.id},dirty:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Individual,[{key:'handleInputValid',value:function handleInputValid(input){if(input&&input.error)return false;return null;}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;if(!this.props.participant.updatedSuccessfully)return;setTimeout(function(){_this2.setState({dirty:false});_this2.props.expireUpdatedParticipant();},3000);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["RadioButton"],{id:'genderType-male',name:'genderType',label:'Masculino',className:'col-4 col-md-3 pb-1',tabIndex:0,labelClass:'l-1',outerLabel:false,role:'radio',value:'MALE',onClick:this.handleInputChange,defaultChecked:this.state.genderType.value==='MALE'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["RadioButton"],{id:'genderType-female',name:'genderType',label:'Feminino',className:'col-4 col-md-3 pb-1',tabIndex:0,labelClass:'l-1',outerLabel:false,role:'radio',value:'FEMALE',onClick:this.handleInputChange,defaultChecked:this.state.genderType.value==='FEMALE'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["RadioButton"],{id:'genderType-uninformed',name:'genderType',label:'Outros',className:'col-4 col-md-3 pb-1',tabIndex:0,labelClass:'l-1',outerLabel:false,role:'radio',value:'UNINFORMED',onClick:this.handleInputChange,defaultChecked:this.state.genderType.value==='UNINFORMED'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-name-profile-data',label:'Nome',className:'col-12 col-md-6',tabIndex:0,minLength:'1',maxLength:'50',name:'name',required:true,'data-error':this.state.name.error,valid:this.handleInputValid(this.state.name),onChange:this.handleInputChange,value:this.state.name.value,disabled:this.state.name.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-cpf-profile-data',label:'CPF',className:'col-12 col-md-6 mt-md-0 mt-2',tabIndex:0,required:true,mask:[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/],name:'cpf','data-error':this.state.cpf.error,valid:this.handleInputValid(this.state.cpf),onChange:this.handleInputChange,value:this.state.cpf.value,disabled:this.state.cpf.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'birthDate',label:'Data de nascimento',className:'col-12 col-md-6 mt-2',tabIndex:0,name:'birthDate',required:true,mask:[/\d/,/\d/,'/',/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/],onChange:this.handleInputChange,value:this.state.birthDate&&this.state.birthDate.value,disabled:this.state.birthDate&&this.state.birthDate.disabled==='true',onBlur:this.isValid,'data-error':this.state.birthDate&&this.state.birthDate.error,valid:this.handleInputValid(this.state.birthDate)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-email-profile-data',label:'E-mail',className:'col-12 col-md-6 mt-2',tabIndex:0,required:true,name:'email','data-error':this.state.email.error,valid:this.handleInputValid(this.state.email),onChange:this.handleInputChange,value:this.state.email.value,disabled:this.state.email.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Select"],{id:'maritalStatus',label:'Estado civil',className:'col-12 col-md-6 mt-2',tabIndex:0,displayValue:'text',selectedValue:'value',name:'maritalStatusSelected',value:this.state.maritalStatusSelected,disabled:this.state.maritalStatusSelected&&this.state.maritalStatusSelected.disabled==='true',options:__WEBPACK_IMPORTED_MODULE_4____["i" /* maritalStatuses */].options,onChange:this.handleSelectInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-mobilePhone-profile-data',label:'Celular',className:'col-12 col-md-6 mt-2',tabIndex:0,required:true,mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],'data-error':this.state.mobilePhone.error,valid:this.handleInputValid(this.state.mobilePhone),onChange:this.handleInputChange,name:'mobilePhone',value:this.state.mobilePhone.value,disabled:this.state.mobilePhone.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-phone-profile-data',label:'Telefone Residencial',className:'col-12 col-md-6 mt-2',tabIndex:0,guide:false,mask:this.state.homePhone.value.replace(/\D/g,'').length<11?['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/,/\d/]:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],name:'homePhone',onChange:this.handleInputChange,value:this.state.homePhone.value,disabled:this.state.homePhone.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-md-6 col-12 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],Object.assign({id:'btn-save-participant',tabIndex:0,onClick:this.handleOnSubmit,disabled:!this.state.dirty||!this.state.isValid},this.buttonProps(),{loading:this.props.participant.isUpdating})))));}}]);return Individual;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});var valueTypeNumber=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});Individual.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:valueType,cpf:valueType,email:valueType,phones:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,genderType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,birthDate:valueType,maritalStatus:valueTypeNumber,profileId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,statusId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isUpdating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,updatedSuccessfully:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}).isRequired,updateParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,expireUpdatedParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Individual);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Participant_ducks__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Company=function(_Component){_inherits(Company,_Component);function Company(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Company);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Company.__proto__||Object.getPrototypeOf(Company)).call.apply(_ref,[this].concat(args))),_this),_this.state={dirty:false,isValid:true,companyName:_this.props.participant.companyName,cnpj:_this.props.participant.cnpj,email:_this.props.participant.email,mobile:{value:''+_this.props.participant.phones.mobile.areaCode+_this.props.participant.phones.mobile.number,disabled:_this.props.participant.phones.mobile&&_this.props.participant.phones.mobile.disabled},workPhone:{value:''+_this.props.participant.phones.work.areaCode+_this.props.participant.phones.work.number,disabled:_this.props.participant.phones.work&&_this.props.participant.phones.work.disabled}},_this.isValid=function(){var isValid=true;var mailValidator=/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim;var _this$state=_this.state,companyName=_this$state.companyName,cnpj=_this$state.cnpj,email=_this$state.email;var nameValidator=/^[\wÀ-Ÿ\-&\s()]+(?![http:https:])$/gim;if(!nameValidator.test(companyName.value)){_this.setState({name:{value:companyName.value,disabled:companyName.disabled,error:'Digite uma Razão Social válida'}});isValid=false;}if(!companyName.value){_this.setState({name:{value:companyName.value,disabled:companyName.disabled,error:'Digite sua Razão Social'}});isValid=false;}if(!cnpj.value){_this.setState({cnpj:{value:cnpj.value,disabled:cnpj.disabled,error:'Digite um CNPJ válido'}});isValid=false;}if(!mailValidator.test(email.value)){_this.setState({email:{value:email.value,disabled:email.disabled,error:'Digite um E-mail válido'}});isValid=false;}_this.setState({isValid:isValid});},_this.buttonProps=function(){return _this.props.participant.updatedSuccessfully?{text:'Salvo',className:'btn btn-sm btn-featured bg-success'}:{text:'Salvar',className:'btn btn-sm btn-featured'};},_this.handleOnSubmit=function(){if(!_this.state.isValid)return;var _this$state2=_this.state,companyName=_this$state2.companyName,cnpj=_this$state2.cnpj,email=_this$state2.email,mobile=_this$state2.mobile,workPhone=_this$state2.workPhone;var _this$props$participa=_this.props.participant,address=_this$props$participa.address,maritalStatus=_this$props$participa.maritalStatus,genderType=_this$props$participa.genderType,birthDate=_this$props$participa.birthDate;var phones=[];if(mobile.value)phones.push(Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["a" /* buildPhone */])(mobile.value,'MOBILE'));if(workPhone.value)phones.push(Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["a" /* buildPhone */])(workPhone.value,'WORK'));_this.props.updateParticipant({name:companyName.value,documentNumber:Object(__WEBPACK_IMPORTED_MODULE_5_Participant_ducks__["f" /* getOnlyNumbers */])(cnpj.value),maritalStatus:maritalStatus.value,genderType:genderType.value,birthDate:birthDate.value&&__WEBPACK_IMPORTED_MODULE_2_moment___default()(birthDate.value,'DD/MM/YYYY').format(),emails:[{email:email.value,type:'PERSONAL'}],status:__WEBPACK_IMPORTED_MODULE_4____["j" /* profileStatuses */][_this.props.participant.statusId],profileId:_this.props.participant.profileId,phones:phones,address:{street:address.addressText.value,number:address.number.value,complement:address.complement.value,district:address.district.value,city:address.city.value,state:address.state.value,zipCode:address.zipCode.value}});},_this.handleInputChange=function(event){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,event.target.name,{value:event.target.value}),_defineProperty(_this$setState,'dirty',true),_this$setState));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Company,[{key:'handleInputValid',value:function handleInputValid(input){if(input.error)return false;return null;}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;if(!this.props.participant.updatedSuccessfully)return;setTimeout(function(){_this2.setState({dirty:false});_this2.props.expireUpdatedParticipant();},3000);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-name-profile-data',label:'Raz\xE3o social',className:'col-12',minLength:'1',maxLength:'100',name:'companyName',required:true,'data-error':this.state.companyName.error,valid:this.handleInputValid(this.state.companyName),onChange:this.handleInputChange,value:this.state.companyName.value,disabled:this.state.companyName.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-cnpj-profile-data',label:'CNPJ',className:'col-12 col-md-6 mt-2',required:true,mask:[/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/],name:'cnpj','data-error':this.state.cnpj.error,valid:this.handleInputValid(this.state.cnpj),onChange:this.handleInputChange,value:this.state.cnpj.value,disabled:this.state.cnpj.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-email-profile-data',label:'E-mail',className:'col-12 col-md-6 mt-2',required:true,name:'email','data-error':this.state.email.error,valid:this.handleInputValid(this.state.email),onChange:this.handleInputChange,value:this.state.email.value,disabled:this.state.email.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-phone-profile-data',label:'Celular',className:'col-12 col-md-6 mt-2',required:true,mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],'data-error':this.state.mobile.error,valid:this.handleInputValid(this.state.mobile),onChange:this.handleInputChange,name:'mobile',value:this.state.mobile.value,disabled:this.state.mobile.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'input-workPhone-profile-data',label:'Telefone comercial',className:'col-12 col-md-6 mt-2',mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],name:'workPhone',onChange:this.handleInputChange,value:this.state.workPhone.value,disabled:this.state.workPhone.disabled==='true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-md-6 col-12 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],Object.assign({id:'btn-save-participant',onClick:this.handleOnSubmit,disabled:!this.state.dirty||!this.state.isValid},this.buttonProps(),{loading:this.props.participant.isUpdating})))));}}]);return Company;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});var valueTypeNumber=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});Company.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({name:valueType,cnpj:valueType,companyName:valueType,email:valueType,phones:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,genderType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,birthDate:valueType,maritalStatus:valueTypeNumber,profileId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,statusId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isUpdating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,updatedSuccessfully:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}).isRequired,expireUpdatedParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,updateParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Company);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({1:'MALE',2:'FEMALE',3:'UNINFORMED'});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export options */
/* unused harmony export getById */
var married={id:1,value:'MARRIED',text:'Casado'};var divorced={id:2,value:'DIVORCED',text:'Divorciado'};var single={id:3,value:'SINGLE',text:'Solteiro'};var widowed={id:4,value:'WIDOWED',text:'Viuvo'};var separated={id:5,value:'SEPARATED',text:'Separado'};var uninformed={id:6,value:'UNINFORMED',text:'Não Informado'};var options=[married,divorced,single,widowed,separated,uninformed];var getById=function getById(idToFind){return options.find(function(_ref){var id=_ref.id;return id===idToFind;})||uninformed;};/* harmony default export */ __webpack_exports__["a"] = ({options:options,getById:getById});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({1:'ACTIVE',2:'SIGNPENDANT',3:'INACTIVE',4:'WAIT',5:'PENDINGVALIDATION',6:'PENDINGREGISTRATION',7:'PENDINGPAYMENT',8:'CANCELLEDCARD',9:'STANDBYWITHOUTPRIZE',10:'PASSWORDSIGNPENDANT',52:'BLOCKEDUSER'});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__features_Balance__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
var mapStateToProps=function mapStateToProps(_ref){var extract=_ref.extract,balance=_ref.balance,catalog=_ref.catalog;return Object.assign({},extract,{balance:balance,currency:{label:catalog.currencyConfiguration.pointsName,decimalPlaces:catalog.currencyConfiguration.decimalPlaces,isLoading:catalog.isLoading}});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchExtractTotalizer:function fetchExtractTotalizer(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchExtractTotalizer());},loadBalance:function loadBalance(cached){return dispatch(__WEBPACK_IMPORTED_MODULE_2__features_Balance__["a" /* actions */].loadBalance(cached));},fetchExtract:function fetchExtract(params){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchExtract(params));},fetchCreditToExpire:function fetchCreditToExpire(periodId){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchCreditToExpire(periodId));},fetchCampaignName:function fetchCampaignName(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].fetchCampaignName());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* Extract */],props);}));

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Totalizers__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Infos__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Details__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExtractPlaceholder__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Extract=function(_Component){_inherits(Extract,_Component);function Extract(){_classCallCheck(this,Extract);return _possibleConstructorReturn(this,(Extract.__proto__||Object.getPrototypeOf(Extract)).apply(this,arguments));}_createClass(Extract,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchCampaignName();this.props.loadBalance(false);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Seu extrato - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_placeholder___default.a,{ready:!this.props.totalizers.isLoading||!this.props.balance.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ExtractPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-ui-4 mt-sm-0 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pl-2 pr-2 px-0 px-md-1 py-0 py-sm-2 pt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell_LoggedSidebar__["a" /* default */],{selected:'/extract'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-lg-8 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-totalizers col-12 mb-2 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-title txt-font-body txt-initial color-title mr-auto'},'Extrato'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Totalizers__["d" /* Totalizers */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Infos__["a" /* Infos */],this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Details__["b" /* Details */],this.props)))))))))));}}]);return Extract;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Extract.propTypes={fetchCampaignName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,totalizers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired}).isRequired,balance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired}).isRequired,loadBalance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Extract);

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TotalizersPlaceholder__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var className='extract-resume row bg-ui-5 border-bottom border-color-ui-3';var Totalizers=function(_Component){_inherits(Totalizers,_Component);function Totalizers(){_classCallCheck(this,Totalizers);return _possibleConstructorReturn(this,(Totalizers.__proto__||Object.getPrototypeOf(Totalizers)).apply(this,arguments));}_createClass(Totalizers,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchExtractTotalizer();}},{key:'render',value:function render(){if(this.props.totalizers.isLoading||this.props.balance.isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TotalizersPlaceholder__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Balance */],this.props),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_HISTORY_EXTRACT)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* History */],this.props));}}]);return Totalizers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Totalizers.propTypes={fetchExtractTotalizer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,totalizers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired}).isRequired,balance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Totalizers);

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TotalizersPlaceholder=function TotalizersPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-resume row bg-ui-5 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (TotalizersPlaceholder);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var Balance=function Balance(_ref){var onHold=_ref.totalizers.onHold,pointsValue=_ref.balance.pointsValue,currency=_ref.currency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md py-2 px-3 '+(window.innerWidth<420?'border-bottom border-color-ui-3':'border-right border-color-ui-3')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-body color-brand-1 txt-uppercase'},'Saldo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Item */],{description:'Dispon\xEDvel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:pointsValue},currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Item */],{description:'Resgate em Processamento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:onHold},currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Item */],{description:'Total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:pointsValue+onHold},currency)))))));};Balance.propTypes={currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,balance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pointsValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}).isRequired,totalizers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({onHold:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Balance);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var History=function History(_ref){var _ref$totalizers=_ref.totalizers,expired=_ref$totalizers.expired,redeemed=_ref$totalizers.redeemed,credited=_ref$totalizers.credited,currency=_ref.currency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-body color-brand-1 txt-uppercase'},'Hist\xF3rico')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Item */],{description:currency.label+' expirados'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:expired},currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Item */],{description:currency.label+' regatados'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:redeemed},currency))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* Item */],{description:currency.label+' creditados'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:credited},currency)))))));};History.propTypes={currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,totalizers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({expired:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,redeemed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,credited:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (History);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Item=function Item(_ref){var description=_ref.description,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},children))));};Item.propTypes={description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Infos__ = __webpack_require__(1065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Infos__["a"]; });


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var Infos=function Infos(_ref){var createdAt=_ref.createdAt,name=_ref.campaign.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half  txt-subtitle'},'Informa\xE7\xF5es capturadas em ',__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('DD/MM/YYYY'),', \xE0s',' ',__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('HH:mm'),' e sujeitas a altera\xE7\xF5es at\xE9 o fim do dia.'))));};Infos.propTypes={createdAt:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,campaign:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Infos);

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tabs_style_react_tabs_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_tracking_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_tracking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_tracking_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Details=function(_Component){_inherits(Details,_Component);function Details(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Details);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Details.__proto__||Object.getPrototypeOf(Details)).call.apply(_ref,[this].concat(args))),_this),_this.state={filterSelected:__WEBPACK_IMPORTED_MODULE_3__tabs__["a" /* default */][0].options[2].value,currentTab:__WEBPACK_IMPORTED_MODULE_3__tabs__["a" /* default */][0]},_this.fetchRecords=function(tab,value){if(tab.name==='AccountStatement'){_this.props.fetchExtract(value);}else{_this.props.fetchCreditToExpire(value);}},_this.handleOnFilterSelect=function(value){_this.setState({filterSelected:value});var currentTab=_this.state.currentTab;_this.fetchRecords(currentTab,value);},_this.handleOnTabSelect=function(index){var currentTab=__WEBPACK_IMPORTED_MODULE_3__tabs__["a" /* default */][index];var options=currentTab.options.slice(2,7);var filterSelected=options[0].value;_this.setState({currentTab:currentTab,filterSelected:filterSelected});_this.fetchRecords(currentTab,filterSelected);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Details,[{key:'componentDidMount',value:function componentDidMount(){this.handleOnFilterSelect(this.state.filterSelected);this.handleOnFilterSelect({startDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1,'month').format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1,'day').format('YYYY-MM-DD')});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-summary radius bg-ui-5 row px-0 pb-2 border-bottom border-left border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["d" /* Tabs */],{onSelect:this.handleOnTabSelect,className:'col-12 product-tabs border-none radius-top border-color-ui-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable px-2 px-md-0 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["b" /* TabList */],{className:'tabs-item pt-3 px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},'Detalhe de ',this.props.currency.label),!__WEBPACK_IMPORTED_MODULE_6_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_EXPIRATION_POINTS_LABEL_DISABLED)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body  color-ui-3'},this.props.currency.label,' a expirar')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["e" /* Filters */],{options:this.state.currentTab.options.slice(2,7),onFilterSelect:this.handleOnFilterSelect,filterSelected:this.state.filterSelected,currentTab:this.state.currentTab}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */],{className:'row px-3 mx-0 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* AccountStatement */],this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */],{className:'row px-3 mx-0 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* Expirations */],this.props))));}}]);return Details;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Details.propTypes={fetchExtract:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,fetchCreditToExpire:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,currency:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Details);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_propTypes__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_count__ = __webpack_require__(492);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelected = function (index, last, event) {
      var onSelect = _this.props.onSelect; // Call change event handler

      if (typeof onSelect === 'function') {
        // Check if the change event handler cancels the tab change
        if (onSelect(index, last, event) === false) return;
      }

      var state = {
        // Set focus if the change was triggered from the keyboard
        focus: event.type === 'keydown'
      };

      if (Tabs.inUncontrolledMode(_this.props)) {
        // Update selected index
        state.selectedIndex = index;
      }

      _this.setState(state);
    };

    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    if (false) {
      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.");
    } // Use a transactional update to prevent race conditions
    // when reading the state in copyPropsToState
    // See https://github.com/reactjs/react-tabs/issues/51


    this.setState(function (state) {
      return Tabs.copyPropsToState(newProps, state);
    });
  };

  Tabs.inUncontrolledMode = function inUncontrolledMode(props) {
    return props.selectedIndex === null;
  };

  // preserve the existing selectedIndex from state.
  // If the state has not selectedIndex, default to the defaultIndex or 0
  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }

    var newState = {
      focus: focus
    };

    if (Tabs.inUncontrolledMode(props)) {
      var maxTabIndex = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_count__["b" /* getTabsCount */])(props.children) - 1;
      var selectedIndex = null;

      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }

      newState.selectedIndex = selectedIndex;
    }

    return newState;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        defaultIndex = _this$props.defaultIndex,
        defaultFocus = _this$props.defaultFocus,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "defaultIndex", "defaultFocus"]);

    var _this$state = this.state,
        focus = _this$state.focus,
        selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;

    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__["a" /* default */], props, children);
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tabs.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null
};

Tabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: onSelectPropType,
  selectedIndex: selectedIndexPropType,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};
Tabs.tabsRole = 'Tabs';

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_uuid__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_propTypes__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_count__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__ = __webpack_require__(197);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










function isNode(node) {
  return node && 'getAttribute' in node;
} // Determine if a node from event.target is a Tab element


function isTabNode(node) {
  return isNode(node) && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  return isNode(node) && node.getAttribute('aria-disabled') === 'true';
}

var canUseActiveElement;

try {
  canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
} catch (e) {
  // Work around for IE bug when accessing document.activeElement in an iframe
  // Refer to the following resources:
  // http://stackoverflow.com/a/10982960/369687
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
  canUseActiveElement = false;
}

var UncontrolledTabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTabs, _Component);

  function UncontrolledTabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];

    _this.handleKeyDown = function (e) {
      if (_this.isTabFromContainer(e.target)) {
        var index = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;

        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;

          _this.handleClick(e);
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
          // Select next tab to the left
          index = _this.getPrevTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || e.keyCode === 40) {
          // Select next tab to the right
          index = _this.getNextTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          // Select last tab (End key)
          index = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          // Select first tab (Home key)
          index = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        } // This prevents scrollbars from moving around


        if (preventDefault) {
          e.preventDefault();
        } // Only use the selected index in the state if we're not using the tabbed index


        if (useSelectedIndex) {
          _this.setSelected(index, e);
        }
      }
    };

    _this.handleClick = function (e) {
      var node = e.target; // eslint-disable-next-line no-cond-assign

      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }

          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);

          _this.setSelected(index, e);

          return;
        }
      } while ((node = node.parentNode) != null);
    };

    return _this;
  }

  var _proto = UncontrolledTabs.prototype;

  _proto.setSelected = function setSelected(index, event) {
    // Check index boundary
    if (index < 0 || index >= this.getTabsCount()) return;
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        selectedIndex = _this$props.selectedIndex; // Call change event handler

    onSelect(index, selectedIndex, event);
  };

  _proto.getNextTab = function getNextTab(index) {
    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right

    for (var i = index + 1; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from first on left to index


    for (var _i = 0; _i < index; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getPrevTab = function getPrevTab(index) {
    var i = index; // Look for non-disabled tab from index to first tab on the left

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from last tab on right to index


    i = this.getTabsCount();

    while (i-- > index) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getFirstTab = function getFirstTab() {
    var count = this.getTabsCount(); // Look for non disabled tab from the first tab

    for (var i = 0; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount(); // Look for non disabled tab from the last tab

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getTabsCount = function getTabsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["b" /* getTabsCount */])(children);
  };

  _proto.getPanelsCount = function getPanelsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["a" /* getPanelsCount */])(children);
  };

  _proto.getTab = function getTab(index) {
    return this.tabNodes["tabs-" + index];
  };

  _proto.getChildren = function getChildren() {
    var _this2 = this;

    var index = 0;
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabledTabClassName = _this$props2.disabledTabClassName,
        focus = _this$props2.focus,
        forceRenderTabPanel = _this$props2.forceRenderTabPanel,
        selectedIndex = _this$props2.selectedIndex,
        selectedTabClassName = _this$props2.selectedTabClassName,
        selectedTabPanelClassName = _this$props2.selectedTabPanelClassName;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
    // Don't bother removing ids, just keep them in case they are added again
    // This is more efficient, and keeps the uuid counter under control

    while (diff++ < 0) {
      this.tabIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
      this.panelIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
    } // Map children to dynamically setup refs


    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(children, function (child) {
      var result = child; // Clone TabList and Tab components to have refs

      if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["b" /* isTabList */])(child)) {
        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
        // If it is we should keep the focus on the next selected tab

        var wasTabFocused = false;

        if (canUseActiveElement) {
          wasTabFocused = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(child.props.children).filter(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["a" /* isTab */]).some(function (tab, i) {
            return document.activeElement === _this2.getTab(i);
          });
        }

        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
          children: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(child.props.children, function (tab) {
            var key = "tabs-" + listIndex;
            var selected = selectedIndex === listIndex;
            var props = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected,
              focus: selected && (focus || wasTabFocused)
            };
            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
            listIndex++;
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tab, props);
          })
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["c" /* isTabPanel */])(child)) {
        var props = {
          id: _this2.panelIds[index],
          tabId: _this2.tabIds[index],
          selected: selectedIndex === index
        };
        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
        index++;
        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, props);
      }

      return result;
    });
  };

  /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    // return immediately if the clicked element is not a Tab.
    if (!isTabNode(node)) {
      return false;
    } // Check if the first occurrence of a Tabs container is `this` one.


    var nodeAncestor = node.parentElement;

    do {
      if (nodeAncestor === this.node) return true;
      if (nodeAncestor.getAttribute('data-tabs')) break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);

    return false;
  };

  _proto.render = function render() {
    var _this3 = this;

    // Delete all known props, so they don't get added to DOM
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabledTabClassName = _this$props3.disabledTabClassName,
        domRef = _this$props3.domRef,
        focus = _this$props3.focus,
        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
        onSelect = _this$props3.onSelect,
        selectedIndex = _this$props3.selectedIndex,
        selectedTabClassName = _this$props3.selectedTabClassName,
        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
        attributes = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef) domRef(node);
      },
      "data-tabs": true
    }), this.getChildren());
  };

  return UncontrolledTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UncontrolledTabs.defaultProps = {
  className: 'react-tabs',
  focus: false
};

UncontrolledTabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  focus: PropTypes.bool,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var TabList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      role: "tablist"
    }), children);
  };

  return TabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabList.defaultProps = {
  className: 'react-tabs__tab-list'
};

TabList.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};
TabList.tabsRole = 'TabList';

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab';

var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };

  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props,
        selected = _this$props.selected,
        focus = _this$props.focus;

    if (selected && focus) {
      this.node.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        disabledClassName = _this$props2.disabledClassName,
        focus = _this$props2.focus,
        id = _this$props2.id,
        panelId = _this$props2.panelId,
        selected = _this$props2.selected,
        selectedClassName = _this$props2.selectedClassName,
        tabIndex = _this$props2.tabIndex,
        tabRef = _this$props2.tabRef,
        attributes = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef) tabRef(node);
      },
      role: "tab",
      id: id,
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected ? '0' : null)
    }), children);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tab.defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: DEFAULT_CLASS + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

Tab.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  disabledClassName: PropTypes.string,
  focus: PropTypes.bool,
  // private
  id: PropTypes.string,
  // private
  panelId: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabRef: PropTypes.func // private

} : {};
Tab.tabsRole = 'Tab';

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab-panel';

var TabPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanel.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        forceRender = _this$props.forceRender,
        id = _this$props.id,
        selected = _this$props.selected,
        selectedClassName = _this$props.selectedClassName,
        tabId = _this$props.tabId,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
      role: "tabpanel",
      id: id,
      "aria-labelledby": tabId
    }), forceRender || selected ? children : null);
  };

  return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

TabPanel.propTypes =  false ? {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  forceRender: PropTypes.bool,
  id: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabId: PropTypes.string // private

} : {};
TabPanel.tabsRole = 'TabPanel';

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var getFormattedDate=function getFormattedDate(duration,unitOfTime){return{startDate:__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(duration,unitOfTime).format('YYYY-MM-DD'),endDate:__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1,'days').format('YYYY-MM-DD')};};/* harmony default export */ __webpack_exports__["a"] = ({0:{name:'AccountStatement',options:[{text:'7 dias',value:getFormattedDate(7,'days')},{text:'15 dias',value:getFormattedDate(15,'days')},{text:'1 mês',value:getFormattedDate(1,'months')},{text:'3 meses',value:getFormattedDate(3,'months')},{text:'6 meses',value:getFormattedDate(6,'months')},{text:'1 ano',value:getFormattedDate(1,'years')},{text:'+ de 1 ano',value:getFormattedDate(20,'years')}]},1:{name:'Expirations',options:[{text:'7 dias',value:'0'},{text:'15 dias',value:'1'},{text:'1 mês',value:'2'},{text:'3 meses',value:'4'},{text:'6 meses',value:'5'},{text:'1 ano',value:'6'}]}});

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccountStatementPlaceholder__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccountStatement=function(_Component){_inherits(AccountStatement,_Component);function AccountStatement(props){_classCallCheck(this,AccountStatement);var _this=_possibleConstructorReturn(this,(AccountStatement.__proto__||Object.getPrototypeOf(AccountStatement)).call(this,props));_initialiseProps.call(_this);_this.state={arrayItems:'',hasMoreItems:true,pageItem:0,currentItems:''};return _this;}_createClass(AccountStatement,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.items.length!==this.state.currentItems.length){this.setState({arrayItems:'',hasMoreItems:true});}}},{key:'loadExtract',value:function loadExtract(){var items=this.listItems();if(items.length===this.state.currentItems.length){this.printItems();}else{this.setState({currentItems:items,pageItem:0});this.printItems();}}},{key:'printItems',value:function printItems(){var _this2=this;setTimeout(function(){if(_this2.state.currentItems.length>0){_this2.setState({arrayItems:_this2.state.currentItems.slice(0,_this2.state.pageItem*10+10)});if(_this2.state.arrayItems.length<_this2.state.currentItems.length){_this2.setState({pageItem:_this2.state.pageItem+1});}else{_this2.setState({hasMoreItems:false});}}else{_this2.setState({arrayItems:[],hasMoreItems:false});}},1000);}},{key:'render',value:function render(){var _this3=this;if(this.props.isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AccountStatementPlaceholder__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_infinite_scroller___default.a,{pageStart:0,loadMore:function loadMore(){return _this3.loadExtract();},hasMore:this.state.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'}),key:10,initialLoad:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'},this.state.arrayItems.length>0?this.state.arrayItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["f" /* Item */],Object.assign({key:index,value:item.valuePoints,currency:_this3.props.currency},_this3.buildItemProps(item)));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["c" /* Empty */],null)));}}]);return AccountStatement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.buildItemProps=function(_ref){var date=_ref.date,type=_ref.type,purchaseId=_ref.purchaseId,description=_ref.description,parentOrderId=_ref.parentOrderId,vendorName=_ref.vendorName;var dateFormat=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(date).format('DD/MM/YYYY - HH:mm');var descriptionFormat=purchaseId?'#'+purchaseId+' - '+description:description;var props=type==='DEBIT'?{cssColor:'color-error',subtitle:'Debitado em '+dateFormat,icon:'remove_circle',description:descriptionFormat,parentOrderId:parentOrderId,vendorName:vendorName}:{cssColor:'color-success',subtitle:'Creditado em '+dateFormat,icon:'cash',description:descriptionFormat,parentOrderId:parentOrderId,vendorName:vendorName};return props;};this.listItems=function(){var items=_this4.props.items;return items;};};AccountStatement.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetchExtract:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccountStatement);

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isReverse && this.loadMore) {
        var parentElement = this.getParentElement(this.scrollComponent);
        parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
        this.loadMore = false;
      }
      this.attachScrollListener();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: 'isPassiveSupported',
    value: function isPassiveSupported() {
      var passive = false;

      var testOptions = {
        get passive() {
          passive = true;
        }
      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {
        // ignore
      }
      return passive;
    }
  }, {
    key: 'eventListenerOptions',
    value: function eventListenerOptions() {
      var options = this.props.useCapture;

      if (this.isPassiveSupported()) {
        options = {
          useCapture: this.props.useCapture,
          passive: true
        };
      }
      return options;
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachMousewheelListener',
    value: function detachMousewheelListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: 'getParentElement',
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
      if (scrollParent != null) {
        return scrollParent;
      }
      return el && el.parentNode;
    }
  }, {
    key: 'filterProps',
    value: function filterProps(props) {
      return props;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!this.props.hasMore || !parentElement) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = parentElement;
      }

      scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'mousewheelListener',
    value: function mousewheelListener(e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !this.isPassiveSupported()) {
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var parentNode = this.getParentElement(el);

      var offset = void 0;
      if (this.props.useWindow) {
        var doc = document.documentElement || document.body.parentNode || document.body;
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateOffset(el, scrollTop);
        }
      } else if (this.props.isReverse) {
        offset = parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
      }

      // Here we make sure the element is visible as well as checking the offset
      if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
        this.detachScrollListener();
        this.beforeScrollHeight = parentNode.scrollHeight;
        this.beforeScrollTop = parentNode.scrollTop;
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
          this.loadMore = true;
        }
      }
    }
  }, {
    key: 'calculateOffset',
    value: function calculateOffset(el, scrollTop) {
      if (!el) {
        return 0;
      }

      return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderProps = this.filterProps(this.props);

      var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      if (hasMore) {
        if (loader) {
          isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
        } else if (this.defaultLoader) {
          isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
        }
      }
      return _react2.default.createElement(element, props, childrenArray);
    }
  }]);

  return InfiniteScroll;
}(_react.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccountStatementPlaceholder__ = __webpack_require__(493);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Expirations=function(_Component){_inherits(Expirations,_Component);function Expirations(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Expirations);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Expirations.__proto__||Object.getPrototypeOf(Expirations)).call.apply(_ref,[this].concat(args))),_this),_this.buildItem=function(_ref2,index){var expirationDate=_ref2.expirationDate,value=_ref2.value;var date=__WEBPACK_IMPORTED_MODULE_2_moment___default()(expirationDate).format('DD/MM/YYYY - HH:mm');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["f" /* Item */],{key:index,description:_this.props.campaign.name,subtitle:'Expira em '+date,value:value,currency:_this.props.currency,cssColor:'color-brand-1',icon:'warning'});},_this.list=function(){var items=_this.props.creditToExpire.items;if(!items||items.length<1)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["c" /* Empty */],null);return items.map(_this.buildItem);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Expirations,[{key:'render',value:function render(){var isLoading=this.props.creditToExpire.isLoading;if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AccountStatementPlaceholder__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'},this.list());}}]);return Expirations;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Expirations.propTypes={creditToExpire:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,campaign:{name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}};/* harmony default export */ __webpack_exports__["a"] = (Expirations);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__ = __webpack_require__(21);
var Item=function Item(_ref){var description=_ref.description,subtitle=_ref.subtitle,value=_ref.value,currency=_ref.currency,cssColor=_ref.cssColor,icon=_ref.icon,parentOrderId=_ref.parentOrderId,vendorName=_ref.vendorName;var vendor=vendorName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),vendorName):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 col-sm-1 pl-0 my-2 zindex-low'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_'+icon+' txt-body-lg',style:icon==='cash'?{position:'relative',left:'5px'}:{}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},subtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,parentOrderId?'#'+parentOrderId+' - ':'',description,vendor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'d-block d-md-none mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:value},currency,{className:'txt-body-sm '+cssColor})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block col-auto mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__["b" /* CurrencyLabel */],Object.assign({value:value},currency,{className:'txt-body-sm '+cssColor})))));};Item.propTypes={description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,subtitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,cssColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,parentOrderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vendorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Option=function Option(_ref){var text=_ref.text,value=_ref.value,selected=_ref.selected,handleOnClick=_ref.handleOnClick,index=_ref.index,total=_ref.total;var id='option_'+value+'_days';var classActive=selected?'bg-ui-4 border-color-brand-1 color-brand-1 bg-ui-4':' border-color-ui-2';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item  px-half '+(total-1===index||total-2===index?'d-inline-block d-md-none d-lg-inline-block':'d-inline-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'filter-'+index,name:id,href:'javascript:void(0)',role:'button',className:'d-block radius  pointer border  py-1 px-1 txt-body-sm txt-left '+classActive,onClick:function onClick(){return handleOnClick(value);},title:'Filtrar extrato'},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,text):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text)));};Option.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleOnClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.integer,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.integer};var Filters=function Filters(_ref2){var options=_ref2.options,onFilterSelect=_ref2.onFilterSelect,filterSelected=_ref2.filterSelected,currentTab=_ref2.currentTab;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0 px0 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 px-md-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 pt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 px-sm-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Selecione um per\xEDodo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable px-3 px-md-0 pt-1 pb-2'},options.map(function(_ref3,index){var text=_ref3.text,value=_ref3.value;return currentTab.name==='Expirations'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option,{text:text,value:value,selected:value===filterSelected&&value===filterSelected,handleOnClick:onFilterSelect,index:index,total:options.length}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option,{text:text,value:value,selected:value.startDate===filterSelected.startDate&&value.endDate===filterSelected.endDate,handleOnClick:onFilterSelect,index:index,total:options.length});}))));};Filters.propTypes={onFilterSelect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,filterSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,currentTab:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Empty=function Empty(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-3 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-center'},'Nenhum registro encontrado no per\xEDodo'));};/* harmony default export */ __webpack_exports__["a"] = (Empty);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ExtractPlaceholder=function ExtractPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-ui-4 pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0 px-md-1 py-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userSidebar col-12 col-md-4 d-none d-md-block pr-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 bg-brand-5 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-3 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-initial color-brand-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-resume row bg-ui-5 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mr-1 py-half radius bg-ui-3'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-summary radius bg-ui-5 row px-0 pb-2 border-bottom border-left border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 product-tabs border-none radius-top border-color-ui-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable col-12 row mx-0 px-2 px-md-0 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item col-12 row mx-0 d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-item pt-3 pl-1 pl-md-3 pr-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-button col-6 col-md-2 row pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-button col-6 col-md-2 row pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0 px0 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-10 px-0 px-md-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable row mx-0 px-2 px-md-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 mb-2 mx-0 radius-bottom overflow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'})))))))))))))))));};/* harmony default export */ __webpack_exports__["a"] = (ExtractPlaceholder);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchExtractTotalizer */
/* unused harmony export fetchExtract */
/* unused harmony export fetchCreditToExpire */
/* unused harmony export fetchCampaignName */
var fetchExtractTotalizer=function fetchExtractTotalizer(){return{type:'FETCH_EXTRACT_TOTALIZERS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/extract'}}};};var fetchExtract=function fetchExtract(params){return{type:'FETCH_EXTRACT',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/extractOrderDescription',params:params}}};};var fetchCreditToExpire=function fetchCreditToExpire(periodId){return{type:'FETCH_CREDIT_TO_EXPIRE',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/toExpire/'+periodId}}};};var fetchCampaignName=function fetchCampaignName(){return{type:'FETCH_CAMPAIGN_NAME',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/fullBalance'}}};};/* harmony default export */ __webpack_exports__["a"] = ({fetchExtract:fetchExtract,fetchExtractTotalizer:fetchExtractTotalizer,fetchCreditToExpire:fetchCreditToExpire,fetchCampaignName:fetchCampaignName});

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{items:[],totalizers:{isLoading:true,createdAt:''},creditToExpire:{isLoading:true},campaign:{name:'',isLoading:true}};var action=arguments[1];switch(action.type){case'FETCH_EXTRACT_TOTALIZERS':return Object.assign({},state,{totalizers:{isLoading:true}});case'FETCH_EXTRACT_TOTALIZERS_SUCCESS':var data=action.payload.data;var createdAt=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(data.insertDate).format('DD/MM/YYYY');var totalizers={isLoading:false,onHold:data.lockedBalance,expired:data.expiredBalance,redeemed:data.redeemBalance,credited:data.creditBalance};return Object.assign({},state,{totalizers:totalizers,createdAt:createdAt});case'FETCH_EXTRACT_TOTALIZERS_FAIL':return Object.assign({},state,{totalizers:{isLoading:false,error:action.error.data}});case'FETCH_CREDIT_TO_EXPIRE':return Object.assign({},state,{creditToExpire:{isLoading:true}});case'FETCH_CREDIT_TO_EXPIRE_SUCCESS':return Object.assign({},state,{creditToExpire:{items:action.payload.data,isLoading:false}});case'FETCH_CREDIT_TO_EXPIRE_FAIL':return Object.assign({},state,{creditToExpire:{isLoading:false,error:action.error.data}});case'FETCH_EXTRACT':return Object.assign({},state,{isLoading:true});case'FETCH_EXTRACT_SUCCESS':return Object.assign({},state,{items:action.payload.data,isLoading:false});case'FETCH_EXTRACT_FAIL':return Object.assign({},state,{isLoading:false,error:action.error.data});case'FETCH_CAMPAIGN_NAME':return Object.assign({},state,{isLoading:true});case'FETCH_CAMPAIGN_NAME_SUCCESS':return Object.assign({},state,{campaign:{name:action.payload.data.loyaltyBalanceCampaign[0].campaignName,isLoading:false}});case'FETCH_CAMPAIGN_NAME_FAIL':return Object.assign({},state,{campaign:{isLoading:false}});default:return Object.assign({},state);}});

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
var mapStateToProps=function mapStateToProps(_ref){var extract=_ref.extract,balance=_ref.balance,catalog=_ref.catalog;return Object.assign({},extract,{balance:balance,currency:{label:catalog.currencyConfiguration.pointsName,decimalPlaces:catalog.currencyConfiguration.decimalPlaces,isLoading:catalog.isLoading}});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchExtractTotalizer:function fetchExtractTotalizer(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["d" /* actions */].fetchExtractTotalizer());},fetchExtract:function fetchExtract(params){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["d" /* actions */].fetchExtract(params));},fetchCreditToExpire:function fetchCreditToExpire(periodId){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["d" /* actions */].fetchCreditToExpire(periodId));},fetchCampaignName:function fetchCampaignName(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["d" /* actions */].fetchCampaignName());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* TwoStepVerification */],props);}));

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TwoStepVerificationPlaceholder__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PhoneEmpty_index__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HasPhone_index__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SendDocuments_index__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DocumentAnalysis_index__ = __webpack_require__(1101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TwoStepVerification=function(_Component){_inherits(TwoStepVerification,_Component);function TwoStepVerification(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TwoStepVerification);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TwoStepVerification.__proto__||Object.getPrototypeOf(TwoStepVerification)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasPhone:false,sendDocuments:false,documentAnalysis:false,showAlertBox:false,isError:false,isCountdown:false,title:'',description:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TwoStepVerification,[{key:'countdown',value:function countdown(element,minutes,seconds){var time=minutes*60+seconds;var interval=setInterval(function(){var el=document.getElementById(element);if(time<=0){var text='O código gerado expira em 00:00';el.innerHTML=text;clearInterval(interval);return;}var minutes=Math.floor(time/60);if(minutes<10)minutes='0'+minutes;var seconds=time%60;if(seconds<10)seconds='0'+seconds;text='O código gerado expira em '+minutes+':'+seconds;el.innerHTML=text;time--;},1000);}},{key:'faqTwoStep',value:function faqTwoStep(){window.location.href='/faq-two-step';}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:!this.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TwoStepVerificationPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 px-0 px-md-1 pt-1 pt-md-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:this.state.isError,title:this.state.title,description:this.state.description,className:'pt-3 pt-md-0 pb-2 px-2 px-md-0 '+(this.state.showAlertBox&&!this.state.isCountdown?'':'d-none'),onClose:function onClose(){}}),this.state.showAlertBox&&this.state.isCountdown?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 mr-auto ml-auto confirmation-alert pt-3 pt-md-0 pb-2 px-2 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius border-brand-1 border-left-lg border-color-brand-1 py-3 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_clock color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-md-10 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'countDownText',className:'color-brand-1 txt-circular-book txt-body-lg'},this.state.isCountdown?this.countdown('countDownText',0,120):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-none'})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+(this.state.sendDocuments?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 py-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-title txt-circular-book txt-initial color-ui-black mr-auto'},'Verifica\xE7\xE3o em 2 etapas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-auto color-brand-1 txt-font-body txt-body-sm d-flex align-items-center pointer',onClick:function onClick(){return _this2.faqTwoStep();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_question txt-body-sm color-brand-1 mr-md-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-none d-md-block'},'D\xFAvidas frequentes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-2 py-2 border-bottom border-color-ui-3 '+(!this.state.hasPhone||this.state.documentAnalysis?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HasPhone_index__["a" /* HasPhone */],this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-2 py-2 border-bottom border-color-ui-3 '+(this.state.hasPhone||this.state.documentAnalysis?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PhoneEmpty_index__["a" /* PhoneEmpty */],this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-2 py-2 border-bottom border-color-ui-3 '+(this.state.documentAnalysis?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DocumentAnalysis_index__["a" /* DocumentAnalysis */],this.props)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 '+(this.state.sendDocuments?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 py-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-title txt-circular-book txt-initial color-ui-black mr-auto'},'Envio de documentos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-auto color-brand-1 txt-font-body txt-body-sm d-flex align-items-center pointer',onClick:function onClick(){return _this2.faqTwoStep();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_question txt-body-sm color-brand-1 mr-md-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-none d-md-block'},'D\xFAvidas frequentes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SendDocuments_index__["a" /* SendDocuments */],null)))));}}]);return TwoStepVerification;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TwoStepVerification.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hasPhone:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,sendDocuments:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showAlertBox:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isCountdown:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (TwoStepVerification);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TwoStepVerificationPlaceholder=function TwoStepVerificationPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-ui-4 pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0 px-md-1 py-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0  pt-5 pt-md-0  mt-5 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userSidebar col-12 col-md-4 d-none d-md-block pr-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 bg-brand-5 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-3 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-initial color-brand-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-resume row bg-ui-5 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mr-1 py-half radius bg-ui-3'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-summary radius bg-ui-5 row px-0 pb-2 border-bottom border-left border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 product-tabs border-none radius-top border-color-ui-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable col-12 row mx-0 px-2 px-md-0 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item col-12 row mx-0 d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-item pt-3 pl-3 pr-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-button col-2 row pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-button col-2 row pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0 px0 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-10 px-0 px-md-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable row mx-0 px-2 px-md-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 mx-0 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'})))))))))))))))));};/* harmony default export */ __webpack_exports__["a"] = (TwoStepVerificationPlaceholder);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneEmpty__ = __webpack_require__(1086);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PhoneEmpty__["a"]; });


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PhoneEmpty=function(_Component){_inherits(PhoneEmpty,_Component);function PhoneEmpty(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PhoneEmpty);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PhoneEmpty.__proto__||Object.getPrototypeOf(PhoneEmpty)).call.apply(_ref,[this].concat(args))),_this),_this.state={firstStep:true,secondStep:false,thirdStep:false,isValid:undefined,dataError:'',disableButton:true},_this.verifyNow=function(){_this.setState({firstStep:false,secondStep:true,thirdStep:false});},_this.verifyPhone=function(){_this.setState({firstStep:false,secondStep:false,thirdStep:true,isValid:true,dataError:''});},_this.typeCode=function(){var codeVerification=document.getElementById('codeVerification').value;if(codeVerification.length>0){_this.setState({disableButton:false});}else{_this.setState({disableButton:true});}},_this.codeVerification=function(){window.alert('ok');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PhoneEmpty,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pb-2 '+(this.state.firstStep?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-bold  title-color'},'Voc\xEA ainda n\xE3o possui nenhum celular verificado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-1'},'Realizar essa verifica\xE7\xE3o \xE9 muito importante para que seus resgates no Cat\xE1logo de Pr\xEAmios ocorram de forma segura.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Assim saberemos que apenas voc\xEA estar\xE1 utilizando seus pontos e n\xE3o um poss\xEDvel fraudador.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 px-0 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured txt-button txt-center txt-font-body-bold',text:'VERIFIQUE AGORA',onClick:function onClick(){return _this2.verifyNow();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pb-2 row mx-0 '+(this.state.secondStep?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm txt-bold color-brand-1'},'Precisaremos do seu n\xFAmero de celular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm mt-1'},'Tenha um celular em m\xE3os para que possamos enviar um c\xF3digo para a valida\xE7\xE3o do n\xFAmero.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'phoneNumber',className:'col-12 col-md-3 mt-2 pl-md-0 pr-md-1 px-0',labelClass:'l-1 pl-half',label:'Celular',mask:['+',/\d/,/\d/,'(',/\d/,/\d/,')',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],valid:this.state.isValid,'data-error':this.state.dataError}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'col-12 col-md-3 mt-2 btn btn-sm btn-featured btn-cart btn-icon txt-button txt-center txt-font-body-bold',text:'receber sms',iconName:'icon_message',onClick:function onClick(){return _this2.verifyPhone();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'col-12 col-md-3 mt-2 ml-0 ml-md-1 btn btn-sm btn-featured btn-cart btn-icon txt-button txt-center txt-font-body-bold',text:'receber liga\xE7\xE3o',iconName:'icon_call',onClick:function onClick(){return _this2.verifyPhone();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pb-2 row mx-0 '+(this.state.thirdStep?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm mt-1'},'Aguarde alguns segundos para receber o c\xF3digo no n\xFAmero: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'(1*) 96***-4068')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'codeVerification',className:'col-12 col-md-3 mt-2 pl-md-0 pr-md-1 px-0',labelClass:'l-1 pl-half',label:'C\xF3digo de verifica\xE7\xE3o',onChange:function onChange(){return _this2.typeCode();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'col-12 col-md-3 mt-2 btn btn-sm btn-featured txt-button txt-center txt-font-body-bold',text:'VERIFICAR',disabled:this.state.disableButton,onClick:function onClick(){return _this2.codeVerification();}})));}}]);return PhoneEmpty;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PhoneEmpty);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HasPhone__ = __webpack_require__(1088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HasPhone__["a"]; });


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HasPhonePlaceholder__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalDeleteItem_index__ = __webpack_require__(1090);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HasPhone=function(_Component){_inherits(HasPhone,_Component);function HasPhone(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HasPhone);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HasPhone.__proto__||Object.getPrototypeOf(HasPhone)).call.apply(_ref,[this].concat(args))),_this),_this.state={showDeleteConfirmation:false},_this.deleteConfirmation=function(){_this.setState({showDeleteConfirmation:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HasPhone,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:!this.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HasPhonePlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom border-color-ui-3 px-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'O seu celular validado ser\xE1 utilizado para confirmar os resgates no cat\xE1logo de pr\xEAmios\u200B.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 border-bottom border-color-ui-3 mx-0 px-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{className:'icon icon_phone'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Adicionado em 24/07/2019 - 12:20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold'},'Celular: (**) *****932')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{className:'icon icon_trash pointer txt-body',onClick:function onClick(){return _this2.deleteConfirmation();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 border-bottom border-color-ui-3 mx-0 px-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{className:'icon icon_newsletter'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Adicionado em 24/07/2019 - 12:20'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold'},'E-mail: nome*****@**ail.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{className:'icon icon_trash pointer txt-body',onClick:function onClick(){return _this2.deleteConfirmation();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 px-0 justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 px-0 pt-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{className:'btn btn-sm btn-featured txt-button txt-center txt-font-body-bold',text:'Alterar celular',onClick:function onClick(){}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ModalDeleteItem_index__["a" /* ModalDeleteItem */],{show:this.state.showDeleteConfirmation,onCloseButton:function onCloseButton(e){return _this2.setState({showDeleteConfirmation:false});},onClose:function onClose(e){return _this2.setState({showDeleteConfirmation:false});}})));}}]);return HasPhone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HasPhone.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (HasPhone);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TwoStepVerificationPlaceholder=function TwoStepVerificationPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-ui-4 pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0 px-md-1 py-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0  pt-5 pt-md-0  mt-5 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userSidebar col-12 col-md-4 d-none d-md-block pr-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 bg-brand-5 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-3 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-initial color-brand-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-resume row bg-ui-5 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 border-right border-left border-color-ui-3 py-2 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row mr-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row ml-auto mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'}))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-half txt-subtitle mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mr-1 py-half radius bg-ui-3'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-summary radius bg-ui-5 row px-0 pb-2 border-bottom border-left border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 product-tabs border-none radius-top border-color-ui-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable col-12 row mx-0 px-2 px-md-0 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item col-12 row mx-0 d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-item pt-3 pl-3 pr-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-button col-2 row pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-button col-2 row pos-relative d-inline-block px-0 mr-2 txt-circular-black txt-uppercase txt-body color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-white radius-top border-color-ui-3 border-bottom mx-0 px0 px-md-2 pt-2 pb-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-10 px-0 px-md-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable row mx-0 px-2 px-md-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-sm mr-1 py-2 pl-4 pr-3 radius bg-ui-3'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 mx-0 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'})))))))))))))))));};/* harmony default export */ __webpack_exports__["a"] = (TwoStepVerificationPlaceholder);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalDeleteItem__ = __webpack_require__(1091);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalDeleteItem__["a"]; });


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDeleteItem=function(_Component){_inherits(ModalDeleteItem,_Component);function ModalDeleteItem(){_classCallCheck(this,ModalDeleteItem);return _possibleConstructorReturn(this,(ModalDeleteItem.__proto__||Object.getPrototypeOf(ModalDeleteItem)).apply(this,arguments));}_createClass(ModalDeleteItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'580',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 border-color-ui-3 border-bottom pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{id:'modalTitle'},'Excluir celular'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0'},'Deseja excluir o celular cadastrado?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 row my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-close-sms-verification',name:'btn-close-sms-verification',className:'btn btn-double btn-featured btn-rating-modal col-12',text:'Cancelar',onClick:this.props.onClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 row my-2 ml-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-send-sms-verification',name:'btn-send-sms-verification',className:'btn btn-double btn-featured btn-rating-modal2 col-12',text:'Confirmar',onClick:this.props.onCloseButton}))))))))));}}]);return ModalDeleteItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalDeleteItem.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onCloseButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ModalDeleteItem);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SendDocuments__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SendDocuments__["a"]; });


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_images_upload__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_images_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_images_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_imageuploader_css__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_imageuploader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_imageuploader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalSendDocuments_index__ = __webpack_require__(1099);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var documentType=[{text:'RG',value:0},{text:'CNH',value:1}];var SendDocuments=function(_Component){_inherits(SendDocuments,_Component);function SendDocuments(props){_classCallCheck(this,SendDocuments);var _this=_possibleConstructorReturn(this,(SendDocuments.__proto__||Object.getPrototypeOf(SendDocuments)).call(this,props));_this.changeDocumentType=function(e){if(e.value===0){_this.setState({isRG:true,isCNH:false});}else if(e.value===1){_this.setState({isRG:false,isCNH:true});}};_this.sendRG=function(){_this.setState({showSendDocumentsConfirmation:true});};_this.sendCNH=function(){_this.setState({showSendDocumentsConfirmation:true});};_this.state={showDeleteConfirmation:false,isRG:false,isCNH:false,picturesRG:[],picturesCNH:[],showSendDocumentsConfirmation:false};_this.onDropRG=_this.onDropRG.bind(_this);_this.onDropCNH=_this.onDropCNH.bind(_this);return _this;}_createClass(SendDocuments,[{key:'onDropRG',value:function onDropRG(pictureFiles,pictureDataURLs){this.setState({picturesRG:this.state.picturesRG.concat(pictureFiles)});}},{key:'onDropCNH',value:function onDropCNH(pictureFiles,pictureDataURLs){this.setState({picturesCNH:this.state.picturesCNH.concat(pictureFiles)});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body'},'Escolha um tipo de documento para enviar.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'DocumentType',label:'Tipo de documento',className:'col-12 col-md-3 pr-md-0',displayValue:'text',options:documentType,onChange:this.changeDocumentType})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1 px-0 py-2 border-dashed-top border-color-ui-3 '+(this.state.isRG?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body mb-1'},'Tire uma foto digital do seu RG frente e verso. Caso o CPF n\xE3o esteja identificado no RG enviar uma foto digital do cart\xE3o CPF a parte.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_images_upload___default.a,{withIcon:false,withLabel:false,withPreview:true,className:'rg col-12 col-md-3 px-0 pr-md-1',buttonText:'RG (frente)',onChange:this.onDropRG,imgExtension:['.jpg','.png','.gif'],fileSizeError:'O tamanho deste arquivo excede o limite de 5mb.',fileTypeError:'Este arquivo possui um formato não suportado.',maxFileSize:5242880}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_images_upload___default.a,{withIcon:false,withLabel:false,withPreview:true,className:'rg col-12 col-md-3 px-0 pr-md-1',buttonText:'RG (verso)',onChange:this.onDropRG,imgExtension:['.jpg','.png','.gif'],fileSizeError:'O tamanho deste arquivo excede o limite de 5mb.',fileTypeError:'Este arquivo possui um formato não suportado.',maxFileSize:5242880}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_images_upload___default.a,{withIcon:false,withLabel:false,withPreview:true,className:'rg col-12 col-md-3 px-0 pr-md-1',buttonText:'Cart\xE3o CPF',onChange:this.onDropRG,imgExtension:['.jpg','.png','.gif'],fileSizeError:'O tamanho deste arquivo excede o limite de 5mb.',fileTypeError:'Este arquivo possui um formato não suportado.',maxFileSize:5242880}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 mt-1 px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured txt-button txt-center txt-font-body-bold',text:'Enviar',disabled:this.state.picturesRG.length!==2,onClick:function onClick(){return _this2.sendRG();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1 px-0 py-2 border-dashed-top border-color-ui-3 '+(this.state.isCNH?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body mb-1'},'Tire uma foto digital da sua CNH.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_images_upload___default.a,{withIcon:false,withLabel:false,withPreview:true,className:'cnh col-12 col-md-3 px-0 pr-md-1',buttonText:'CNH (frente)',onChange:this.onDropCNH,imgExtension:['.jpg','.png','.gif'],fileSizeError:'O tamanho deste arquivo excede o limite de 5mb.',fileTypeError:'Este arquivo possui um formato não suportado.',maxFileSize:5242880}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 mt-1 px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured txt-button txt-center txt-font-body-bold',text:'Enviar',disabled:this.state.picturesCNH.length!==1,onClick:function onClick(){return _this2.sendCNH();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModalSendDocuments_index__["a" /* ModalSendDocuments */],{show:this.state.showSendDocumentsConfirmation,onCloseButton:function onCloseButton(e){return _this2.setState({showSendDocumentsConfirmation:false});},onClose:function onClose(e){return _this2.setState({showSendDocumentsConfirmation:false});}}));}}]);return SendDocuments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SendDocuments);

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(1095);

var _reactFlipMove = __webpack_require__(1096);

var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);

var _UploadIcon = __webpack_require__(1097);

var _UploadIcon2 = _interopRequireDefault(_UploadIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  width: "100%"
};

var ReactImageUploadComponent = function (_React$Component) {
  _inherits(ReactImageUploadComponent, _React$Component);

  function ReactImageUploadComponent(props) {
    _classCallCheck(this, ReactImageUploadComponent);

    var _this = _possibleConstructorReturn(this, (ReactImageUploadComponent.__proto__ || Object.getPrototypeOf(ReactImageUploadComponent)).call(this, props));

    _this.state = {
      pictures: [].concat(_toConsumableArray(props.defaultImages)),
      files: [],
      notAcceptedFileType: [],
      notAcceptedFileSize: []
    };
    _this.inputElement = '';
    _this.onDropFile = _this.onDropFile.bind(_this);
    _this.onUploadClick = _this.onUploadClick.bind(_this);
    _this.triggerFileUpload = _this.triggerFileUpload.bind(_this);
    return _this;
  }

  _createClass(ReactImageUploadComponent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevState.files !== this.state.files) {
        this.props.onChange(this.state.files, this.state.pictures);
      }
    }

    /*
     Load image at the beggining if defaultImage prop exists
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultImages !== this.props.defaultImages) {
        this.setState({ pictures: nextProps.defaultImages });
      }
    }

    /*
    Check file extension (onDropFile)
    */

  }, {
    key: 'hasExtension',
    value: function hasExtension(fileName) {
      var pattern = '(' + this.props.imgExtension.join('|').replace(/\./g, '\\.') + ')$';
      return new RegExp(pattern, 'i').test(fileName);
    }

    /*
     Handle file validation
     */

  }, {
    key: 'onDropFile',
    value: function onDropFile(e) {
      var _this2 = this;

      var files = e.target.files;
      var allFilePromises = [];

      // Iterate over all uploaded files
      for (var i = 0; i < files.length; i++) {
        var f = files[i];
        // Check for file extension
        if (!this.hasExtension(f.name)) {
          var newArray = this.state.notAcceptedFileType.slice();
          newArray.push(f.name);
          this.setState({ notAcceptedFileType: newArray });
          continue;
        }
        // Check for file size
        if (f.size > this.props.maxFileSize) {
          var _newArray = this.state.notAcceptedFileSize.slice();
          _newArray.push(f.name);
          this.setState({ notAcceptedFileSize: _newArray });
          continue;
        }

        allFilePromises.push(this.readFile(f));
      }

      Promise.all(allFilePromises).then(function (newFilesData) {
        var dataURLs = _this2.state.pictures.slice();
        var files = _this2.state.files.slice();

        newFilesData.forEach(function (newFileData) {
          dataURLs.push(newFileData.dataURL);
          files.push(newFileData.file);
        });

        _this2.setState({ pictures: dataURLs, files: files });
      });
    }
  }, {
    key: 'onUploadClick',
    value: function onUploadClick(e) {
      // Fixes https://github.com/JakeHartnell/react-images-upload/issues/55
      e.target.value = null;
    }

    /*
       Read a file and return a promise that when resolved gives the file itself and the data URL
     */

  }, {
    key: 'readFile',
    value: function readFile(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        // Read the image via FileReader API and save image result in state.
        reader.onload = function (e) {
          // Add the file name to the data URL
          var dataURL = e.target.result;
          dataURL = dataURL.replace(";base64", ';name=' + file.name + ';base64');
          resolve({ file: file, dataURL: dataURL });
        };

        reader.readAsDataURL(file);
      });
    }

    /*
     Remove the image from state
     */

  }, {
    key: 'removeImage',
    value: function removeImage(picture) {
      var _this3 = this;

      var removeIndex = this.state.pictures.findIndex(function (e) {
        return e === picture;
      });
      var filteredPictures = this.state.pictures.filter(function (e, index) {
        return index !== removeIndex;
      });
      var filteredFiles = this.state.files.filter(function (e, index) {
        return index !== removeIndex;
      });

      this.setState({ pictures: filteredPictures, files: filteredFiles }, function () {
        _this3.props.onChange(_this3.state.files, _this3.state.pictures);
      });
    }

    /*
     Check if any errors && render
     */

  }, {
    key: 'renderErrors',
    value: function renderErrors() {
      var _this4 = this;

      var notAccepted = '';
      if (this.state.notAcceptedFileType.length > 0) {
        notAccepted = this.state.notAcceptedFileType.map(function (error, index) {
          return _react2.default.createElement(
            'div',
            { className: 'errorMessage ' + _this4.props.errorClass, key: index, style: _this4.props.errorStyle },
            '* ',
            error,
            ' ',
            _this4.props.fileTypeError
          );
        });
      }
      if (this.state.notAcceptedFileSize.length > 0) {
        notAccepted = this.state.notAcceptedFileSize.map(function (error, index) {
          return _react2.default.createElement(
            'div',
            { className: 'errorMessage ' + _this4.props.errorClass, key: index, style: _this4.props.errorStyle },
            '* ',
            error,
            ' ',
            _this4.props.fileSizeError
          );
        });
      }
      return notAccepted;
    }

    /*
     Render the upload icon
     */

  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      if (this.props.withIcon) {
        return _react2.default.createElement('img', { src: _UploadIcon2.default, className: 'uploadIcon', alt: 'Upload Icon' });
      }
    }

    /*
     Render label
     */

  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      if (this.props.withLabel) {
        return _react2.default.createElement(
          'p',
          { className: this.props.labelClass, style: this.props.labelStyles },
          this.props.label
        );
      }
    }

    /*
     Render preview images
     */

  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      return _react2.default.createElement(
        'div',
        { className: 'uploadPicturesWrapper' },
        _react2.default.createElement(
          _reactFlipMove2.default,
          { enterAnimation: 'fade', leaveAnimation: 'fade', style: styles },
          this.renderPreviewPictures()
        )
      );
    }
  }, {
    key: 'renderPreviewPictures',
    value: function renderPreviewPictures() {
      var _this5 = this;

      return this.state.pictures.map(function (picture, index) {
        return _react2.default.createElement(
          'div',
          { key: index, className: 'uploadPictureContainer' },
          _react2.default.createElement(
            'div',
            { className: 'deleteImage', onClick: function onClick() {
                return _this5.removeImage(picture);
              } },
            'X'
          ),
          _react2.default.createElement('img', { src: picture, className: 'uploadPicture', alt: 'preview' })
        );
      });
    }

    /*
     On button click, trigger input file to open
     */

  }, {
    key: 'triggerFileUpload',
    value: function triggerFileUpload() {
      this.inputElement.click();
    }
  }, {
    key: 'clearPictures',
    value: function clearPictures() {
      this.setState({ pictures: [] });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        'div',
        { className: "fileUploader " + this.props.className, style: this.props.style },
        _react2.default.createElement(
          'div',
          { className: 'fileContainer', style: this.props.fileContainerStyle },
          this.renderIcon(),
          this.renderLabel(),
          _react2.default.createElement(
            'div',
            { className: 'errorsContainer' },
            this.renderErrors()
          ),
          _react2.default.createElement(
            'button',
            {
              type: this.props.buttonType,
              className: "chooseFileButton " + this.props.buttonClassName,
              style: this.props.buttonStyles,
              onClick: this.triggerFileUpload
            },
            this.props.buttonText
          ),
          _react2.default.createElement('input', {
            type: 'file',
            ref: function ref(input) {
              return _this6.inputElement = input;
            },
            name: this.props.name,
            multiple: !this.props.singleImage,
            onChange: this.onDropFile,
            onClick: this.onUploadClick,
            accept: this.props.accept
          }),
          this.props.withPreview ? this.renderPreview() : null
        )
      );
    }
  }]);

  return ReactImageUploadComponent;
}(_react2.default.Component);

ReactImageUploadComponent.defaultProps = {
  className: '',
  fileContainerStyle: {},
  buttonClassName: "",
  buttonStyles: {},
  withPreview: false,
  accept: "image/*",
  name: "",
  withIcon: true,
  buttonText: "Choose images",
  buttonType: "button",
  withLabel: true,
  label: "Max file size: 5mb, accepted: jpg|gif|png",
  labelStyles: {},
  labelClass: "",
  imgExtension: ['.jpg', '.jpeg', '.gif', '.png'],
  maxFileSize: 5242880,
  fileSizeError: " file size is too big",
  fileTypeError: " is not a supported file extension",
  errorClass: "",
  style: {},
  errorStyle: {},
  singleImage: false,
  onChange: function onChange() {},
  defaultImages: []
};

ReactImageUploadComponent.propTypes = {
  style: _propTypes2.default.object,
  fileContainerStyle: _propTypes2.default.object,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  buttonClassName: _propTypes2.default.string,
  buttonStyles: _propTypes2.default.object,
  buttonType: _propTypes2.default.string,
  withPreview: _propTypes2.default.bool,
  accept: _propTypes2.default.string,
  name: _propTypes2.default.string,
  withIcon: _propTypes2.default.bool,
  buttonText: _propTypes2.default.string,
  withLabel: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  labelStyles: _propTypes2.default.object,
  labelClass: _propTypes2.default.string,
  imgExtension: _propTypes2.default.array,
  maxFileSize: _propTypes2.default.number,
  fileSizeError: _propTypes2.default.string,
  fileTypeError: _propTypes2.default.string,
  errorClass: _propTypes2.default.string,
  errorStyle: _propTypes2.default.object,
  singleImage: _propTypes2.default.bool,
  defaultImages: _propTypes2.default.array
};

exports.default = ReactImageUploadComponent;


/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function warnOnce(msg) {
  var hasWarned = false;
  return function () {
    if (!hasWarned) {
      console.warn(msg);
      hasWarned = true;
    }
  };
}


var statelessFunctionalComponentSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a stateless functional component as a child to <FlipMove>. Unfortunately, SFCs aren\'t supported, because Flip Move needs access to the backing instances via refs, and SFCs don\'t have a public instance that holds that info.\n\nPlease wrap your components in a native element (eg. <div>), or a non-functional component.\n');

var primitiveNodeSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a primitive (text or number) node as a child to <FlipMove>. Flip Move needs containers with unique keys to move children around.\n\nPlease wrap your value in a native element (eg. <span>), or a component.\n');

var invalidTypeForTimingProp = function invalidTypeForTimingProp(args
// prettier-ignore
) {
  return console.error('\n>> Error, via react-flip-move <<\n\nThe prop you provided for \'' + args.prop + '\' is invalid. It needs to be a positive integer, or a string that can be resolved to a number. The value you provided is \'' + args.value + '\'.\n\nAs a result,  the default value for this parameter will be used, which is \'' + args.defaultValue + '\'.\n');
};

var invalidEnterLeavePreset = function invalidEnterLeavePreset(args
// prettier-ignore
) {
  return console.error('\n>> Error, via react-flip-move <<\n\nThe enter/leave preset you provided is invalid. We don\'t currently have a \'' + args.value + ' preset.\'\n\nAcceptable values are ' + args.acceptableValues + '. The default value of \'' + args.defaultValue + '\' will be used.\n');
};

var parentNodePositionStatic = warnOnce('\n>> Warning, via react-flip-move <<\n\nWhen using "wrapperless" mode (by supplying \'typeName\' of \'null\'), strange things happen when the direct parent has the default "static" position.\n\nFlipMove has added \'position: relative\' to this node, to ensure Flip Move animates correctly.\n\nTo avoid seeing this warning, simply apply a non-static position to that parent node.\n');

var childIsDisabled = warnOnce('\n>> Warning, via react-flip-move <<\n\nOne or more of Flip Move\'s child elements have the html attribute \'disabled\' set to true.\n\nPlease note that this will cause animations to break in Internet Explorer 11 and below. Either remove the disabled attribute or set \'animation\' to false.\n');

var enterPresets = {
  elevator: {
    from: { transform: 'scale(0)', opacity: '0' },
    to: { transform: '', opacity: '' }
  },
  fade: {
    from: { opacity: '0' },
    to: { opacity: '' }
  },
  accordionVertical: {
    from: { transform: 'scaleY(0)', transformOrigin: 'center top' },
    to: { transform: '', transformOrigin: 'center top' }
  },
  accordionHorizontal: {
    from: { transform: 'scaleX(0)', transformOrigin: 'left center' },
    to: { transform: '', transformOrigin: 'left center' }
  },
  none: null
};
/**
 * React Flip Move | enterLeavePresets
 * (c) 2016-present Joshua Comeau
 *
 * This contains the master list of presets available for enter/leave animations,
 * along with the mapping between preset and styles.
 */


var leavePresets = {
  elevator: {
    from: { transform: 'scale(1)', opacity: '1' },
    to: { transform: 'scale(0)', opacity: '0' }
  },
  fade: {
    from: { opacity: '1' },
    to: { opacity: '0' }
  },
  accordionVertical: {
    from: { transform: 'scaleY(1)', transformOrigin: 'center top' },
    to: { transform: 'scaleY(0)', transformOrigin: 'center top' }
  },
  accordionHorizontal: {
    from: { transform: 'scaleX(1)', transformOrigin: 'left center' },
    to: { transform: 'scaleX(0)', transformOrigin: 'left center' }
  },
  none: null
};

// For now, appearPresets will be identical to enterPresets.
// Assigning a custom export in case we ever want to add appear-specific ones.
var appearPresets = enterPresets;

var defaultPreset = 'elevator';
var disablePreset = 'none';

var find = function find(predicate, arr) {
  for (var i = 0; i < arr.length; i++) {
    if (predicate(arr[i], i, arr)) {
      return arr[i];
    }
  }

  return undefined;
};


var every = function every(predicate, arr) {
  for (var i = 0; i < arr.length; i++) {
    if (!predicate(arr[i], i, arr)) {
      return false;
    }
  }
  return true;
};

// eslint-disable-next-line import/no-mutable-exports
var _isArray = function isArray(arr) {
  _isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
  return _isArray(arr);
};

var isElementAnSFC = function isElementAnSFC(element) {
  var isNativeDOMElement = typeof element.type === 'string';

  if (isNativeDOMElement) {
    return false;
  }

  return typeof element.type === 'function' && !element.type.prototype.isReactComponent;
};

function omit(obj) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (attrs.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

function arraysEqual(a, b) {
  var sameObject = a === b;
  if (sameObject) {
    return true;
  }

  var notBothArrays = !_isArray(a) || !_isArray(b);
  var differentLengths = a.length !== b.length;

  if (notBothArrays || differentLengths) {
    return false;
  }

  return every(function (element, index) {
    return element === b[index];
  }, a);
}

function memoizeString(fn) {
  var cache = {};

  return function (str) {
    if (!cache[str]) {
      cache[str] = fn(str);
    }
    return cache[str];
  };
}

var hyphenate = memoizeString(function (str) {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * React Flip Move | propConverter
 * (c) 2016-present Joshua Comeau
 *
 * Abstracted away a bunch of the messy business with props.
 *   - props flow types and defaultProps
 *   - Type conversion (We accept 'string' and 'number' values for duration,
 *     delay, and other fields, but we actually need them to be ints.)
 *   - Children conversion (we need the children to be an array. May not always
 *     be, if a single child is passed in.)
 *   - Resolving animation presets into their base CSS styles
 */
/* eslint-disable block-scoped-var */

// eslint-disable-next-line no-duplicate-imports


function propConverter(ComposedComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(FlipMovePropConverter, _Component);

    function FlipMovePropConverter() {
      classCallCheck(this, FlipMovePropConverter);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    // eslint-disable-next-line class-methods-use-this
    FlipMovePropConverter.prototype.checkChildren = function checkChildren(children) {
      // Skip all console warnings in production.
      // Bail early, to avoid unnecessary work.
      if (true) {
        return;
      }

      // same as React.Node, but without fragments, see https://github.com/facebook/flow/issues/4781


      // FlipMove does not support stateless functional components.
      // Check to see if any supplied components won't work.
      // If the child doesn't have a key, it means we aren't animating it.
      // It's allowed to be an SFC, since we ignore it.
      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
        // null, undefined, and booleans will be filtered out by Children.toArray
        if (child == null || typeof child === 'boolean') {
          return;
        }

        if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) !== 'object') {
          primitiveNodeSupplied();
          return;
        }

        if (isElementAnSFC(child) && child.key != null) {
          statelessFunctionalComponentSupplied();
        }
      });
    };

    FlipMovePropConverter.prototype.convertProps = function convertProps(props) {
      var workingProps = {
        // explicitly bypass the props that don't need conversion
        children: props.children,
        easing: props.easing,
        onStart: props.onStart,
        onFinish: props.onFinish,
        onStartAll: props.onStartAll,
        onFinishAll: props.onFinishAll,
        typeName: props.typeName,
        disableAllAnimations: props.disableAllAnimations,
        getPosition: props.getPosition,
        maintainContainerHeight: props.maintainContainerHeight,
        verticalAlignment: props.verticalAlignment,

        // Do string-to-int conversion for all timing-related props
        duration: this.convertTimingProp('duration'),
        delay: this.convertTimingProp('delay'),
        staggerDurationBy: this.convertTimingProp('staggerDurationBy'),
        staggerDelayBy: this.convertTimingProp('staggerDelayBy'),

        // Our enter/leave animations can be specified as boolean (default or
        // disabled), string (preset name), or object (actual animation values).
        // Let's standardize this so that they're always objects
        appearAnimation: this.convertAnimationProp(props.appearAnimation, appearPresets),
        enterAnimation: this.convertAnimationProp(props.enterAnimation, enterPresets),
        leaveAnimation: this.convertAnimationProp(props.leaveAnimation, leavePresets),

        delegated: {}
      };

      this.checkChildren(workingProps.children);

      // Gather any additional props;
      // they will be delegated to the ReactElement created.
      var primaryPropKeys = Object.keys(workingProps);
      var delegatedProps = omit(this.props, primaryPropKeys);

      // The FlipMove container element needs to have a non-static position.
      // We use `relative` by default, but it can be overridden by the user.
      // Now that we're delegating props, we need to merge this in.
      delegatedProps.style = _extends({
        position: 'relative'
      }, delegatedProps.style);

      workingProps.delegated = delegatedProps;

      return workingProps;
    };

    FlipMovePropConverter.prototype.convertTimingProp = function convertTimingProp(prop) {
      var rawValue = this.props[prop];

      var value = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);

      if (isNaN(value)) {
        var defaultValue = FlipMovePropConverter.defaultProps[prop];

        if (false) {
          invalidTypeForTimingProp({
            prop: prop,
            value: rawValue,
            defaultValue: defaultValue
          });
        }

        return defaultValue;
      }

      return value;
    };

    // eslint-disable-next-line class-methods-use-this


    FlipMovePropConverter.prototype.convertAnimationProp = function convertAnimationProp(animation, presets) {
      switch (typeof animation === 'undefined' ? 'undefined' : _typeof(animation)) {
        case 'boolean':
          {
            // If it's true, we want to use the default preset.
            // If it's false, we want to use the 'none' preset.
            return presets[animation ? defaultPreset : disablePreset];
          }

        case 'string':
          {
            var presetKeys = Object.keys(presets);

            if (presetKeys.indexOf(animation) === -1) {
              if (false) {
                invalidEnterLeavePreset({
                  value: animation,
                  acceptableValues: presetKeys.join(', '),
                  defaultValue: defaultPreset
                });
              }

              return presets[defaultPreset];
            }

            return presets[animation];
          }

        default:
          {
            return animation;
          }
      }
    };

    FlipMovePropConverter.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent, this.convertProps(this.props));
    };

    return FlipMovePropConverter;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.defaultProps = {
    easing: 'ease-in-out',
    duration: 350,
    delay: 0,
    staggerDurationBy: 0,
    staggerDelayBy: 0,
    typeName: 'div',
    enterAnimation: defaultPreset,
    leaveAnimation: defaultPreset,
    disableAllAnimations: false,
    getPosition: function getPosition(node) {
      return node.getBoundingClientRect();
    },
    maintainContainerHeight: false,
    verticalAlignment: 'top'
  }, _temp;
}

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 *
 * These methods read from and write to the DOM.
 * They almost always have side effects, and will hopefully become the
 * only spot in the codebase with impure functions.
 */
function applyStylesToDOMNode(_ref) {
  var domNode = _ref.domNode,
      styles = _ref.styles;

  // Can't just do an object merge because domNode.styles is no regular object.
  // Need to do it this way for the engine to fire its `set` listeners.
  Object.keys(styles).forEach(function (key) {
    domNode.style.setProperty(hyphenate(key), styles[key]);
  });
}

// Modified from Modernizr
function whichTransitionEvent() {
  var transitions = {
    transition: 'transitionend',
    '-o-transition': 'oTransitionEnd',
    '-moz-transition': 'transitionend',
    '-webkit-transition': 'webkitTransitionEnd'
  };

  // If we're running in a browserless environment (eg. SSR), it doesn't apply.
  // Return a placeholder string, for consistent type return.
  if (typeof document === 'undefined') return '';

  var el = document.createElement('fakeelement');

  var match = find(function (t) {
    return el.style.getPropertyValue(t) !== undefined;
  }, Object.keys(transitions));

  // If no `transition` is found, we must be running in a browser so ancient,
  // React itself won't run. Return an empty string, for consistent type return
  return match ? transitions[match] : '';
}

var getRelativeBoundingBox = function getRelativeBoundingBox(_ref2) {
  var childDomNode = _ref2.childDomNode,
      parentDomNode = _ref2.parentDomNode,
      getPosition = _ref2.getPosition;

  var parentBox = getPosition(parentDomNode);

  var _getPosition = getPosition(childDomNode),
      top = _getPosition.top,
      left = _getPosition.left,
      right = _getPosition.right,
      bottom = _getPosition.bottom,
      width = _getPosition.width,
      height = _getPosition.height;

  return {
    top: top - parentBox.top,
    left: left - parentBox.left,
    right: parentBox.right - right,
    bottom: parentBox.bottom - bottom,
    width: width,
    height: height
  };
};

/** getPositionDelta
 * This method returns the delta between two bounding boxes, to figure out
 * how many pixels on each axis the element has moved.
 *
 */
var getPositionDelta = function getPositionDelta(_ref3) {
  var childDomNode = _ref3.childDomNode,
      childBoundingBox = _ref3.childBoundingBox,
      parentBoundingBox = _ref3.parentBoundingBox,
      getPosition = _ref3.getPosition;

  // TEMP: A mystery bug is sometimes causing unnecessary boundingBoxes to
  var defaultBox = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: 0,
    width: 0
  };

  // Our old box is its last calculated position, derived on mount or at the
  // start of the previous animation.
  var oldRelativeBox = childBoundingBox || defaultBox;
  var parentBox = parentBoundingBox || defaultBox;

  // Our new box is the new final resting place: Where we expect it to wind up
  // after the animation. First we get the box in absolute terms (AKA relative
  // to the viewport), and then we calculate its relative box (relative to the
  // parent container)
  var newAbsoluteBox = getPosition(childDomNode);
  var newRelativeBox = {
    top: newAbsoluteBox.top - parentBox.top,
    left: newAbsoluteBox.left - parentBox.left
  };

  return [oldRelativeBox.left - newRelativeBox.left, oldRelativeBox.top - newRelativeBox.top];
};

/** removeNodeFromDOMFlow
 * This method does something very sneaky: it removes a DOM node from the
 * document flow, but without actually changing its on-screen position.
 *
 * It works by calculating where the node is, and then applying styles
 * so that it winds up being positioned absolutely, but in exactly the
 * same place.
 *
 * This is a vital part of the FLIP technique.
 */
var removeNodeFromDOMFlow = function removeNodeFromDOMFlow(childData, verticalAlignment) {
  var domNode = childData.domNode,
      boundingBox = childData.boundingBox;


  if (!domNode || !boundingBox) {
    return;
  }

  // For this to work, we have to offset any given `margin`.
  var computed = window.getComputedStyle(domNode);

  // We need to clean up margins, by converting and removing suffix:
  // eg. '21px' -> 21
  var marginAttrs = ['margin-top', 'margin-left', 'margin-right'];
  var margins = marginAttrs.reduce(function (acc, margin) {
    var _babelHelpers$extends;

    var propertyVal = computed.getPropertyValue(margin);

    return _extends({}, acc, (_babelHelpers$extends = {}, _babelHelpers$extends[margin] = Number(propertyVal.replace('px', '')), _babelHelpers$extends));
  }, {});

  // If we're bottom-aligned, we need to add the height of the child to its
  // top offset. This is because, when the container is bottom-aligned, its
  // height shrinks from the top, not the bottom. We're removing this node
  // from the flow, so the top is going to drop by its height.
  var topOffset = verticalAlignment === 'bottom' ? boundingBox.top - boundingBox.height : boundingBox.top;

  var styles = {
    position: 'absolute',
    top: topOffset - margins['margin-top'] + 'px',
    left: boundingBox.left - margins['margin-left'] + 'px',
    right: boundingBox.right - margins['margin-right'] + 'px'
  };

  applyStylesToDOMNode({ domNode: domNode, styles: styles });
};

/** updateHeightPlaceholder
 * An optional property to FlipMove is a `maintainContainerHeight` boolean.
 * This property creates a node that fills space, so that the parent
 * container doesn't collapse when its children are removed from the
 * document flow.
 */
var updateHeightPlaceholder = function updateHeightPlaceholder(_ref4) {
  var domNode = _ref4.domNode,
      parentData = _ref4.parentData,
      getPosition = _ref4.getPosition;

  var parentDomNode = parentData.domNode;
  var parentBoundingBox = parentData.boundingBox;

  if (!parentDomNode || !parentBoundingBox) {
    return;
  }

  // We need to find the height of the container *without* the placeholder.
  // Since it's possible that the placeholder might already be present,
  // we first set its height to 0.
  // This allows the container to collapse down to the size of just its
  // content (plus container padding or borders if any).
  applyStylesToDOMNode({ domNode: domNode, styles: { height: '0' } });

  // Find the distance by which the container would be collapsed by elements
  // leaving. We compare the freshly-available parent height with the original,
  // cached container height.
  var originalParentHeight = parentBoundingBox.height;
  var collapsedParentHeight = getPosition(parentDomNode).height;
  var reductionInHeight = originalParentHeight - collapsedParentHeight;

  // If the container has become shorter, update the padding element's
  // height to take up the difference. Otherwise set its height to zero,
  // so that it has no effect.
  var styles = {
    height: reductionInHeight > 0 ? reductionInHeight + 'px' : '0'
  };

  applyStylesToDOMNode({ domNode: domNode, styles: styles });
};

var getNativeNode = function getNativeNode(element) {
  // When running in a windowless environment, abort!
  if (typeof HTMLElement === 'undefined') {
    return null;
  }

  // `element` may already be a native node.
  if (element instanceof HTMLElement) {
    return element;
  }

  // While ReactDOM's `findDOMNode` is discouraged, it's the only
  // publicly-exposed way to find the underlying DOM node for
  // composite components.
  var foundNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(element);

  if (foundNode && foundNode.nodeType === Node.TEXT_NODE) {
    // Text nodes are not supported
    return null;
  }
  // eslint-disable-next-line flowtype/no-weak-types
  return foundNode;
};

var createTransitionString = function createTransitionString(index, props) {
  var delay = props.delay,
      duration = props.duration;
  var staggerDurationBy = props.staggerDurationBy,
      staggerDelayBy = props.staggerDelayBy,
      easing = props.easing;


  delay += index * staggerDelayBy;
  duration += index * staggerDurationBy;

  var cssProperties = ['transform', 'opacity'];

  return cssProperties.map(function (prop) {
    return prop + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
  }).join(', ');
};

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 *
 * For information on how this code is laid out, check out CODE_TOUR.md
 */

/* eslint-disable react/prop-types */

// eslint-disable-next-line no-duplicate-imports


var transitionEnd = whichTransitionEvent();
var noBrowserSupport = !transitionEnd;

function getKey(childData) {
  return childData.key || '';
}

function getElementChildren(children) {
  // Fix incomplete typing of Children.toArray
  // eslint-disable-next-line flowtype/no-weak-types
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children);
}

var FlipMove$1 = function (_Component) {
  inherits(FlipMove, _Component);

  function FlipMove() {
    var _temp, _this, _ret;

    classCallCheck(this, FlipMove);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      children: getElementChildren(
      // `this.props` ought to always be defined at this point, but a report
      // was made about it not being defined in IE10.
      // TODO: Test in IE10, to see if there's an underlying cause that can
      // be addressed.
      _this.props ? _this.props.children : []).map(function (element) {
        return _extends({}, element, {
          element: element,
          appearing: true
        });
      })
    }, _this.childrenData = {}, _this.parentData = {
      domNode: null,
      boundingBox: null
    }, _this.heightPlaceholderData = {
      domNode: null
    }, _this.remainingAnimations = 0, _this.childrenToAnimate = [], _this.findDOMContainer = function () {
      // eslint-disable-next-line react/no-find-dom-node
      var domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);
      var parentNode = domNode && domNode.parentNode;

      // This ought to be impossible, but handling it for Flow's sake.
      if (!parentNode || !(parentNode instanceof HTMLElement)) {
        return;
      }

      // If the parent node has static positioning, leave animations might look
      // really funky. Let's automatically apply `position: relative` in this
      // case, to prevent any quirkiness.
      if (window.getComputedStyle(parentNode).position === 'static') {
        parentNode.style.position = 'relative';
        parentNodePositionStatic();
      }

      _this.parentData.domNode = parentNode;
    }, _this.runAnimation = function () {
      var dynamicChildren = _this.state.children.filter(_this.doesChildNeedToBeAnimated);

      // Splitting DOM reads and writes to be peformed in batches
      var childrenInitialStyles = dynamicChildren.map(function (child) {
        return _this.computeInitialStyles(child);
      });
      dynamicChildren.forEach(function (child, index) {
        _this.remainingAnimations += 1;
        _this.childrenToAnimate.push(getKey(child));
        _this.animateChild(child, index, childrenInitialStyles[index]);
      });

      if (typeof _this.props.onStartAll === 'function') {
        _this.callChildrenHook(_this.props.onStartAll);
      }
    }, _this.doesChildNeedToBeAnimated = function (child) {
      // If the child doesn't have a key, it's an immovable child (one that we
      // do not want to do FLIP stuff to.)
      if (!getKey(child)) {
        return false;
      }

      var childData = _this.getChildData(getKey(child));
      var childDomNode = childData.domNode;
      var childBoundingBox = childData.boundingBox;
      var parentBoundingBox = _this.parentData.boundingBox;

      if (!childDomNode) {
        return false;
      }

      var _this$props = _this.props,
          appearAnimation = _this$props.appearAnimation,
          enterAnimation = _this$props.enterAnimation,
          leaveAnimation = _this$props.leaveAnimation,
          getPosition = _this$props.getPosition;


      var isAppearingWithAnimation = child.appearing && appearAnimation;
      var isEnteringWithAnimation = child.entering && enterAnimation;
      var isLeavingWithAnimation = child.leaving && leaveAnimation;

      if (isAppearingWithAnimation || isEnteringWithAnimation || isLeavingWithAnimation) {
        return true;
      }

      // If it isn't entering/leaving, we want to animate it if it's
      // on-screen position has changed.

      var _getPositionDelta = getPositionDelta({
        childDomNode: childDomNode,
        childBoundingBox: childBoundingBox,
        parentBoundingBox: parentBoundingBox,
        getPosition: getPosition
      }),
          dX = _getPositionDelta[0],
          dY = _getPositionDelta[1];

      return dX !== 0 || dY !== 0;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  // Copy props.children into state.
  // To understand why this is important (and not an anti-pattern), consider
  // how "leave" animations work. An item has "left" when the component
  // receives a new set of props that do NOT contain the item.
  // If we just render the props as-is, the item would instantly disappear.
  // We want to keep the item rendered for a little while, until its animation
  // can complete. Because we cannot mutate props, we make `state` the source
  // of truth.


  // FlipMove needs to know quite a bit about its children in order to do
  // its job. We store these as a property on the instance. We're not using
  // state, because we don't want changes to trigger re-renders, we just
  // need a place to keep the data for reference, when changes happen.
  // This field should not be accessed directly. Instead, use getChildData,
  // putChildData, etc...


  // Similarly, track the dom node and box of our parent element.


  // If `maintainContainerHeight` prop is set to true, we'll create a
  // placeholder element which occupies space so that the parent height
  // doesn't change when items are removed from the document flow (which
  // happens during leave animations)


  // Keep track of remaining animations so we know when to fire the
  // all-finished callback, and clean up after ourselves.
  // NOTE: we can't simply use childrenToAnimate.length to track remaining
  // animations, because we need to maintain the list of animating children,
  // to pass to the `onFinishAll` handler.


  FlipMove.prototype.componentDidMount = function componentDidMount() {
    // Because React 16 no longer requires wrapping elements, Flip Move can opt
    // to not wrap the children in an element. In that case, find the parent
    // element using `findDOMNode`.
    if (this.props.typeName === null) {
      this.findDOMContainer();
    }

    // Run our `appearAnimation` if it was requested, right after the
    // component mounts.
    var shouldTriggerFLIP = this.props.appearAnimation && !this.isAnimationDisabled(this.props);

    if (shouldTriggerFLIP) {
      this.prepForAnimation();
      this.runAnimation();
    }
  };

  FlipMove.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (this.props.typeName === null) {
      this.findDOMContainer();
    }
    // If the children have been re-arranged, moved, or added/removed,
    // trigger the main FLIP animation.
    //
    // IMPORTANT: We need to make sure that the children have actually changed.
    // At the end of the transition, we clean up nodes that need to be removed.
    // We DON'T want this cleanup to trigger another update.

    var oldChildrenKeys = getElementChildren(this.props.children).map(function (d) {
      return d.key;
    });
    var nextChildrenKeys = getElementChildren(previousProps.children).map(function (d) {
      return d.key;
    });

    var shouldTriggerFLIP = !arraysEqual(oldChildrenKeys, nextChildrenKeys) && !this.isAnimationDisabled(this.props);

    if (shouldTriggerFLIP) {
      this.prepForAnimation();
      this.runAnimation();
    }
  };

  FlipMove.prototype.calculateNextSetOfChildren = function calculateNextSetOfChildren(nextChildren) {
    var _this2 = this;

    // We want to:
    //   - Mark all new children as `entering`
    //   - Pull in previous children that aren't in nextChildren, and mark them
    //     as `leaving`
    //   - Preserve the nextChildren list order, with leaving children in their
    //     appropriate places.
    //

    var updatedChildren = nextChildren.map(function (nextChild) {
      var child = _this2.findChildByKey(nextChild.key);

      // If the current child did exist, but it was in the midst of leaving,
      // we want to treat it as though it's entering
      var isEntering = !child || child.leaving;

      return _extends({}, nextChild, { element: nextChild, entering: isEntering });
    });

    // This is tricky. We want to keep the nextChildren's ordering, but with
    // any just-removed items maintaining their original position.
    // eg.
    //   this.state.children  = [ 1, 2, 3, 4 ]
    //   nextChildren         = [ 3, 1 ]
    //
    // In this example, we've removed the '2' & '4'
    // We want to end up with:  [ 2, 3, 1, 4 ]
    //
    // To accomplish that, we'll iterate through this.state.children. whenever
    // we find a match, we'll append our `leaving` flag to it, and insert it
    // into the nextChildren in its ORIGINAL position. Note that, as we keep
    // inserting old items into the new list, the "original" position will
    // keep incrementing.
    var numOfChildrenLeaving = 0;
    this.state.children.forEach(function (child, index) {
      var isLeaving = !find(function (_ref) {
        var key = _ref.key;
        return key === getKey(child);
      }, nextChildren);

      // If the child isn't leaving (or, if there is no leave animation),
      // we don't need to add it into the state children.
      if (!isLeaving || !_this2.props.leaveAnimation) return;

      var nextChild = _extends({}, child, { leaving: true });
      var nextChildIndex = index + numOfChildrenLeaving;

      updatedChildren.splice(nextChildIndex, 0, nextChild);
      numOfChildrenLeaving += 1;
    });

    return updatedChildren;
  };

  FlipMove.prototype.prepForAnimation = function prepForAnimation() {
    var _this3 = this;

    // Our animation prep consists of:
    // - remove children that are leaving from the DOM flow, so that the new
    //   layout can be accurately calculated,
    // - update the placeholder container height, if needed, to ensure that
    //   the parent's height doesn't collapse.

    var _props = this.props,
        leaveAnimation = _props.leaveAnimation,
        maintainContainerHeight = _props.maintainContainerHeight,
        getPosition = _props.getPosition;

    // we need to make all leaving nodes "invisible" to the layout calculations
    // that will take place in the next step (this.runAnimation).

    if (leaveAnimation) {
      var leavingChildren = this.state.children.filter(function (child) {
        return child.leaving;
      });

      leavingChildren.forEach(function (leavingChild) {
        var childData = _this3.getChildData(getKey(leavingChild));

        // Warn if child is disabled
        if (!_this3.isAnimationDisabled(_this3.props) && childData.domNode && childData.domNode.disabled) {
          childIsDisabled();
        }

        // We need to take the items out of the "flow" of the document, so that
        // its siblings can move to take its place.
        if (childData.boundingBox) {
          removeNodeFromDOMFlow(childData, _this3.props.verticalAlignment);
        }
      });

      if (maintainContainerHeight && this.heightPlaceholderData.domNode) {
        updateHeightPlaceholder({
          domNode: this.heightPlaceholderData.domNode,
          parentData: this.parentData,
          getPosition: getPosition
        });
      }
    }

    // For all children not in the middle of entering or leaving,
    // we need to reset the transition, so that the NEW shuffle starts from
    // the right place.
    this.state.children.forEach(function (child) {
      var _getChildData = _this3.getChildData(getKey(child)),
          domNode = _getChildData.domNode;

      // Ignore children that don't render DOM nodes (eg. by returning null)


      if (!domNode) {
        return;
      }

      if (!child.entering && !child.leaving) {
        applyStylesToDOMNode({
          domNode: domNode,
          styles: {
            transition: ''
          }
        });
      }
    });
  };

  // eslint-disable-next-line camelcase


  FlipMove.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    // When the component is handed new props, we need to figure out the
    // "resting" position of all currently-rendered DOM nodes.
    // We store that data in this.parent and this.children,
    // so it can be used later to work out the animation.
    this.updateBoundingBoxCaches();

    // Convert opaque children object to array.
    var nextChildren = getElementChildren(nextProps.children);

    // Next, we need to update our state, so that it contains our new set of
    // children. If animation is disabled or unsupported, this is easy;
    // we just copy our props into state.
    // Assuming that we can animate, though, we have to do some work.
    // Essentially, we want to keep just-deleted nodes in the DOM for a bit
    // longer, so that we can animate them away.
    this.setState({
      children: this.isAnimationDisabled(nextProps) ? nextChildren.map(function (element) {
        return _extends({}, element, { element: element });
      }) : this.calculateNextSetOfChildren(nextChildren)
    });
  };

  FlipMove.prototype.animateChild = function animateChild(child, index, childInitialStyles) {
    var _this4 = this;

    var _getChildData2 = this.getChildData(getKey(child)),
        domNode = _getChildData2.domNode;

    if (!domNode) {
      return;
    }

    // Apply the relevant style for this DOM node
    // This is the offset from its actual DOM position.
    // eg. if an item has been re-rendered 20px lower, we want to apply a
    // style of 'transform: translate(-20px)', so that it appears to be where
    // it started.
    // In FLIP terminology, this is the 'Invert' stage.
    applyStylesToDOMNode({
      domNode: domNode,
      styles: childInitialStyles
    });

    // Start by invoking the onStart callback for this child.
    if (this.props.onStart) this.props.onStart(child, domNode);

    // Next, animate the item from it's artificially-offset position to its
    // new, natural position.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        // NOTE, RE: the double-requestAnimationFrame:
        // Sadly, this is the most browser-compatible way to do this I've found.
        // Essentially we need to set the initial styles outside of any request
        // callbacks to avoid batching them. Then, a frame needs to pass with
        // the styles above rendered. Then, on the second frame, we can apply
        // our final styles to perform the animation.

        // Our first order of business is to "undo" the styles applied in the
        // previous frames, while also adding a `transition` property.
        // This way, the item will smoothly transition from its old position
        // to its new position.

        // eslint-disable-next-line flowtype/require-variable-type
        var styles = {
          transition: createTransitionString(index, _this4.props),
          transform: '',
          opacity: ''
        };

        if (child.appearing && _this4.props.appearAnimation) {
          styles = _extends({}, styles, _this4.props.appearAnimation.to);
        } else if (child.entering && _this4.props.enterAnimation) {
          styles = _extends({}, styles, _this4.props.enterAnimation.to);
        } else if (child.leaving && _this4.props.leaveAnimation) {
          styles = _extends({}, styles, _this4.props.leaveAnimation.to);
        }

        // In FLIP terminology, this is the 'Play' stage.
        applyStylesToDOMNode({ domNode: domNode, styles: styles });
      });
    });

    this.bindTransitionEndHandler(child);
  };

  FlipMove.prototype.bindTransitionEndHandler = function bindTransitionEndHandler(child) {
    var _this5 = this;

    var _getChildData3 = this.getChildData(getKey(child)),
        domNode = _getChildData3.domNode;

    if (!domNode) {
      return;
    }

    // The onFinish callback needs to be bound to the transitionEnd event.
    // We also need to unbind it when the transition completes, so this ugly
    // inline function is required (we need it here so it closes over
    // dependent variables `child` and `domNode`)
    var transitionEndHandler = function transitionEndHandler(ev) {
      // It's possible that this handler is fired not on our primary transition,
      // but on a nested transition (eg. a hover effect). Ignore these cases.
      if (ev.target !== domNode) return;

      // Remove the 'transition' inline style we added. This is cleanup.
      domNode.style.transition = '';

      // Trigger any applicable onFinish/onFinishAll hooks
      _this5.triggerFinishHooks(child, domNode);

      domNode.removeEventListener(transitionEnd, transitionEndHandler);

      if (child.leaving) {
        _this5.removeChildData(getKey(child));
      }
    };

    domNode.addEventListener(transitionEnd, transitionEndHandler);
  };

  FlipMove.prototype.triggerFinishHooks = function triggerFinishHooks(child, domNode) {
    var _this6 = this;

    if (this.props.onFinish) this.props.onFinish(child, domNode);

    // Reduce the number of children we need to animate by 1,
    // so that we can tell when all children have finished.
    this.remainingAnimations -= 1;

    if (this.remainingAnimations === 0) {
      // Remove any items from the DOM that have left, and reset `entering`.
      var nextChildren = this.state.children.filter(function (_ref2) {
        var leaving = _ref2.leaving;
        return !leaving;
      }).map(function (item) {
        return _extends({}, item, {
          // fix for Flow
          element: item.element,
          appearing: false,
          entering: false
        });
      });

      this.setState({ children: nextChildren }, function () {
        if (typeof _this6.props.onFinishAll === 'function') {
          _this6.callChildrenHook(_this6.props.onFinishAll);
        }

        // Reset our variables for the next iteration
        _this6.childrenToAnimate = [];
      });

      // If the placeholder was holding the container open while elements were
      // leaving, we we can now set its height to zero.
      if (this.heightPlaceholderData.domNode) {
        this.heightPlaceholderData.domNode.style.height = '0';
      }
    }
  };

  FlipMove.prototype.callChildrenHook = function callChildrenHook(hook) {
    var _this7 = this;

    var elements = [];
    var domNodes = [];

    this.childrenToAnimate.forEach(function (childKey) {
      // If this was an exit animation, the child may no longer exist.
      // If so, skip it.
      var child = _this7.findChildByKey(childKey);

      if (!child) {
        return;
      }

      elements.push(child);

      if (_this7.hasChildData(childKey)) {
        domNodes.push(_this7.getChildData(childKey).domNode);
      }
    });

    hook(elements, domNodes);
  };

  FlipMove.prototype.updateBoundingBoxCaches = function updateBoundingBoxCaches() {
    var _this8 = this;

    // This is the ONLY place that parentData and childrenData's
    // bounding boxes are updated. They will be calculated at other times
    // to be compared to this value, but it's important that the cache is
    // updated once per update.
    var parentDomNode = this.parentData.domNode;

    if (!parentDomNode) {
      return;
    }

    this.parentData.boundingBox = this.props.getPosition(parentDomNode);

    // Splitting DOM reads and writes to be peformed in batches
    var childrenBoundingBoxes = [];

    this.state.children.forEach(function (child) {
      var childKey = getKey(child);

      // It is possible that a child does not have a `key` property;
      // Ignore these children, they don't need to be moved.
      if (!childKey) {
        childrenBoundingBoxes.push(null);
        return;
      }

      // In very rare circumstances, for reasons unknown, the ref is never
      // populated for certain children. In this case, avoid doing this update.
      // see: https://github.com/joshwcomeau/react-flip-move/pull/91
      if (!_this8.hasChildData(childKey)) {
        childrenBoundingBoxes.push(null);
        return;
      }

      var childData = _this8.getChildData(childKey);

      // If the child element returns null, we need to avoid trying to
      // account for it
      if (!childData.domNode || !child) {
        childrenBoundingBoxes.push(null);
        return;
      }

      childrenBoundingBoxes.push(getRelativeBoundingBox({
        childDomNode: childData.domNode,
        parentDomNode: parentDomNode,
        getPosition: _this8.props.getPosition
      }));
    });

    this.state.children.forEach(function (child, index) {
      var childKey = getKey(child);

      var childBoundingBox = childrenBoundingBoxes[index];

      if (!childKey) {
        return;
      }

      _this8.setChildData(childKey, {
        boundingBox: childBoundingBox
      });
    });
  };

  FlipMove.prototype.computeInitialStyles = function computeInitialStyles(child) {
    if (child.appearing) {
      return this.props.appearAnimation ? this.props.appearAnimation.from : {};
    } else if (child.entering) {
      if (!this.props.enterAnimation) {
        return {};
      }
      // If this child was in the middle of leaving, it still has its
      // absolute positioning styles applied. We need to undo those.
      return _extends({
        position: '',
        top: '',
        left: '',
        right: '',
        bottom: ''
      }, this.props.enterAnimation.from);
    } else if (child.leaving) {
      return this.props.leaveAnimation ? this.props.leaveAnimation.from : {};
    }

    var childData = this.getChildData(getKey(child));
    var childDomNode = childData.domNode;
    var childBoundingBox = childData.boundingBox;
    var parentBoundingBox = this.parentData.boundingBox;

    if (!childDomNode) {
      return {};
    }

    var _getPositionDelta2 = getPositionDelta({
      childDomNode: childDomNode,
      childBoundingBox: childBoundingBox,
      parentBoundingBox: parentBoundingBox,
      getPosition: this.props.getPosition
    }),
        dX = _getPositionDelta2[0],
        dY = _getPositionDelta2[1];

    return {
      transform: 'translate(' + dX + 'px, ' + dY + 'px)'
    };
  };

  // eslint-disable-next-line class-methods-use-this


  FlipMove.prototype.isAnimationDisabled = function isAnimationDisabled(props) {
    // If the component is explicitly passed a `disableAllAnimations` flag,
    // we can skip this whole process. Similarly, if all of the numbers have
    // been set to 0, there is no point in trying to animate; doing so would
    // only cause a flicker (and the intent is probably to disable animations)
    // We can also skip this rigamarole if there's no browser support for it.
    return noBrowserSupport || props.disableAllAnimations || props.duration === 0 && props.delay === 0 && props.staggerDurationBy === 0 && props.staggerDelayBy === 0;
  };

  FlipMove.prototype.findChildByKey = function findChildByKey(key) {
    return find(function (child) {
      return getKey(child) === key;
    }, this.state.children);
  };

  FlipMove.prototype.hasChildData = function hasChildData(key) {
    // Object has some built-in properties on its prototype, such as toString.  hasOwnProperty makes
    // sure that key is present on childrenData itself, not on its prototype.
    return Object.prototype.hasOwnProperty.call(this.childrenData, key);
  };

  FlipMove.prototype.getChildData = function getChildData(key) {
    return this.hasChildData(key) ? this.childrenData[key] : {};
  };

  FlipMove.prototype.setChildData = function setChildData(key, data) {
    this.childrenData[key] = _extends({}, this.getChildData(key), data);
  };

  FlipMove.prototype.removeChildData = function removeChildData(key) {
    delete this.childrenData[key];
    this.setState(function (prevState) {
      return _extends({}, prevState, {
        children: prevState.children.filter(function (child) {
          return child.element.key !== key;
        })
      });
    });
  };

  FlipMove.prototype.createHeightPlaceholder = function createHeightPlaceholder() {
    var _this9 = this;

    var typeName = this.props.typeName;

    // If requested, create an invisible element at the end of the list.
    // Its height will be modified to prevent the container from collapsing
    // prematurely.

    var isContainerAList = typeName === 'ul' || typeName === 'ol';
    var placeholderType = isContainerAList ? 'li' : 'div';

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(placeholderType, {
      key: 'height-placeholder',
      ref: function ref(domNode) {
        _this9.heightPlaceholderData.domNode = domNode;
      },
      style: { visibility: 'hidden', height: 0 }
    });
  };

  FlipMove.prototype.childrenWithRefs = function childrenWithRefs() {
    var _this10 = this;

    // We need to clone the provided children, capturing a reference to the
    // underlying DOM node. Flip Move needs to use the React escape hatches to
    // be able to do its calculations.
    return this.state.children.map(function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child.element, {
        ref: function ref(element) {
          // Stateless Functional Components are not supported by FlipMove,
          // because they don't have instances.
          if (!element) {
            return;
          }

          var domNode = getNativeNode(element);
          _this10.setChildData(getKey(child), { domNode: domNode });
        }
      });
    });
  };

  FlipMove.prototype.render = function render() {
    var _this11 = this;

    var _props2 = this.props,
        typeName = _props2.typeName,
        delegated = _props2.delegated,
        leaveAnimation = _props2.leaveAnimation,
        maintainContainerHeight = _props2.maintainContainerHeight;


    var children = this.childrenWithRefs();
    if (leaveAnimation && maintainContainerHeight) {
      children.push(this.createHeightPlaceholder());
    }

    if (!typeName) return children;

    var props = _extends({}, delegated, {
      children: children,
      ref: function ref(node) {
        _this11.parentData.domNode = node;
      }
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(typeName, props);
  };

  return FlipMove;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var enhancedFlipMove = /* #__PURE__ */propConverter(FlipMove$1);

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 */

/* harmony default export */ __webpack_exports__["default"] = (enhancedFlipMove);


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/UploadIcon.1cedb6e9.svg";

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalSendDocuments__ = __webpack_require__(1100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalSendDocuments__["a"]; });


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalSendDocuments=function(_Component){_inherits(ModalSendDocuments,_Component);function ModalSendDocuments(){_classCallCheck(this,ModalSendDocuments);return _possibleConstructorReturn(this,(ModalSendDocuments.__proto__||Object.getPrototypeOf(ModalSendDocuments)).apply(this,arguments));}_createClass(ModalSendDocuments,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'580',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 border-color-ui-3 border-bottom pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{id:'modalTitle'},'Solicita\xE7\xE3o em an\xE1lise'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2 px-0'},'Sua solicita\xE7\xE3o foi enviada com sucesso. Voc\xEA ser\xE1 notificado por email em at\xE9 72 horas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 row my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-close-sms-verification',name:'btn-close-sms-verification',className:'btn btn-double btn-featured btn-rating-modal col-12',text:'Cancelar',onClick:this.props.onClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 row my-2 ml-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-send-sms-verification',name:'btn-send-sms-verification',className:'btn btn-double btn-featured btn-rating-modal2 col-12',text:'Confirmar',onClick:this.props.onCloseButton}))))))))));}}]);return ModalSendDocuments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalSendDocuments.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onCloseButton:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ModalSendDocuments);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DocumentAnalysis__ = __webpack_require__(1102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DocumentAnalysis__["a"]; });


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentAnalysis=function(_Component){_inherits(DocumentAnalysis,_Component);function DocumentAnalysis(){_classCallCheck(this,DocumentAnalysis);return _possibleConstructorReturn(this,(DocumentAnalysis.__proto__||Object.getPrototypeOf(DocumentAnalysis)).apply(this,arguments));}_createClass(DocumentAnalysis,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-bold color-brand-1'},'Voc\xEA possui uma solicita\xE7\xE3o de cadastro em aberto.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-1'},'Realizada em ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'19/06/2019'),' \xE0s ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10:37'),' com n\xFAmero de protocolo ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'00262816'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sua solicita\xE7\xE3o ser\xE1 respondida por e-mail em at\xE9 72 horas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 px-0 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured txt-button txt-center txt-font-body-bold',text:'VERIFIQUE AGORA',onClick:function onClick(){}}))));}}]);return DocumentAnalysis;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DocumentAnalysis);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqTwoStep=function(_Component){_inherits(FaqTwoStep,_Component);function FaqTwoStep(){_classCallCheck(this,FaqTwoStep);return _possibleConstructorReturn(this,(FaqTwoStep.__proto__||Object.getPrototypeOf(FaqTwoStep)).apply(this,arguments));}_createClass(FaqTwoStep,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 px-0 px-md-1 pt-1 pt-md-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 ${this.state.sendDocuments'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 py-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-title txt-circular-book txt-initial color-ui-black mr-auto'},'D\xFAvidas frequentes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-2 py-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["Accordion"],{className:'row col-12 mx-0 px-0 mx-md radius-0 radius-md bg-white border-left border-top border-right border-color-ui-3',accordion:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Por qual motivo devo cadastrar meu celular?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'Para que seus resgates no Cat\xE1logo de Pr\xEAmios ocorram de forma segura. Assim saberemos que apenas voc\xEA estar\xE1 utilizando seus pontos e n\xE3o um poss\xEDvel fraudador.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Como funcionam os resgates ap\xF3s o cadastro do meu celular?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'Sempre que voc\xEA efetuar resgate em uma das lojas parceiras constantes no Cat\xE1logo de Pr\xEAmios ser\xE1 enviado o token para o seu celular, que dever\xE1 ser informado para que haja a conclus\xE3o do seu resgate.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'O que \xE9 token?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'Token \xE9 um dispositivo eletr\xF4nico que gera senhas num\xE9ricas aleat\xF3rias. Foi criado para proporcionar ainda mais seguran\xE7a aos usu\xE1rios da internet em transa\xE7\xF5es virtuais (compras, acesso a contas banc\xE1rias, atualiza\xE7\xE3o de dados cadastrais, etc.) e assim dificultar a a\xE7\xE3o de hackers e fraudadores.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Qual a necessidade de enviar meus documentos para validar meu celular?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'O envio de documentos \xE9 apenas um m\xE9todo alternativo para validar seu celular. Ele ser\xE1 solicitado somente se voc\xEA n\xE3o receber o e-mail para ativa\xE7\xE3o do dispositivo, que ser\xE1 utilizado para confirmar os resgates no Cat\xE1logo de Pr\xEAmios.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Quais s\xE3o os documentos necess\xE1rios para a valida\xE7\xE3o do meu celular?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'RG e CPF ou CNH. Os documentos devem ser digitalizados totalmente abertos, sem cortes ou efeitos que impossibilite a leitura de todos os dados.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Qual o prazo para valida\xE7\xE3o do meu celular ap\xF3s o envio de documentos?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'Ap\xF3s o envio dos documentos sua solicita\xE7\xE3o de valida\xE7\xE3o do celular entrar\xE1 em an\xE1lise e em at\xE9 72 horas voc\xEA ser\xE1 notificado por e-mail sobre o resultado.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Enviei os documentos e n\xE3o tive o celular validado. O que devo fazer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'Entre em contato com a Central de Atendimento da sua Campanha de Premia\xE7\xE3o para verificar o que pode ter ocorrido.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0',expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 px-1 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-title-3 txt-font-body color-ui-1'},'Se eu tiver mais d\xFAvidas sobre a valida\xE7\xE3o do celular, o que devo fazer?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{className:'icon icon_down icon-sm'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body'},'Nosso time est\xE1 preparado para responder as suas d\xFAvidas e auxiliar no que for necess\xE1rio. Basta entrar em contato por meio da Central de Atendimento da sua Campanha de Premia\xE7\xE3o.'))))))))));}}]);return FaqTwoStep;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FaqTwoStep);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchExtractTotalizer */
/* unused harmony export fetchExtract */
/* unused harmony export fetchCreditToExpire */
/* unused harmony export fetchCampaignName */
var fetchExtractTotalizer=function fetchExtractTotalizer(){return{type:'FETCH_EXTRACT_TOTALIZERS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/extract'}}};};var fetchExtract=function fetchExtract(params){return{type:'FETCH_EXTRACT',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/extract',params:params}}};};var fetchCreditToExpire=function fetchCreditToExpire(periodId){return{type:'FETCH_CREDIT_TO_EXPIRE',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/toExpire/'+periodId}}};};var fetchCampaignName=function fetchCampaignName(){return{type:'FETCH_CAMPAIGN_NAME',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/fullBalance'}}};};/* harmony default export */ __webpack_exports__["a"] = ({fetchExtract:fetchExtract,fetchExtractTotalizer:fetchExtractTotalizer,fetchCreditToExpire:fetchCreditToExpire,fetchCampaignName:fetchCampaignName});

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* unused harmony default export */ var _unused_webpack_default_export = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{items:[],totalizers:{isLoading:true,createdAt:''},creditToExpire:{isLoading:true},campaign:{name:'',isLoading:true}};var action=arguments[1];switch(action.type){case'FETCH_EXTRACT_TOTALIZERS':return Object.assign({},state,{totalizers:{isLoading:true}});case'FETCH_EXTRACT_TOTALIZERS_SUCCESS':var data=action.payload.data;var createdAt=__WEBPACK_IMPORTED_MODULE_0_moment___default()(data.insertDate).format('DD/MM/YYYY');var totalizers={isLoading:false,onHold:data.lockedBalance,expired:data.expiredBalance,redeemed:data.redeemBalance,credited:data.creditBalance};return Object.assign({},state,{totalizers:totalizers,createdAt:createdAt});case'FETCH_EXTRACT_TOTALIZERS_FAIL':return Object.assign({},state,{totalizers:{isLoading:false,error:action.error.data}});case'FETCH_CREDIT_TO_EXPIRE':return Object.assign({},state,{creditToExpire:{isLoading:true}});case'FETCH_CREDIT_TO_EXPIRE_SUCCESS':return Object.assign({},state,{creditToExpire:{items:action.payload.data,isLoading:false}});case'FETCH_CREDIT_TO_EXPIRE_FAIL':return Object.assign({},state,{creditToExpire:{isLoading:false,error:action.error.data}});case'FETCH_EXTRACT':return Object.assign({},state,{isLoading:true});case'FETCH_EXTRACT_SUCCESS':return Object.assign({},state,{items:action.payload.data,isLoading:false});case'FETCH_EXTRACT_FAIL':return Object.assign({},state,{isLoading:false,error:action.error.data});case'FETCH_CAMPAIGN_NAME':return Object.assign({},state,{isLoading:true});case'FETCH_CAMPAIGN_NAME_SUCCESS':return Object.assign({},state,{campaign:{name:action.payload.data.loyaltyBalanceCampaign[0].campaignName,isLoading:false}});case'FETCH_CAMPAIGN_NAME_FAIL':return Object.assign({},state,{campaign:{isLoading:false}});default:return Object.assign({},state);}});

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangePassword__ = __webpack_require__(1107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ChangePassword__["a"]; });


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FieldPassword_FieldPassword__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_password_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_password_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_password_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangePassword=function(_Component){_inherits(ChangePassword,_Component);function ChangePassword(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChangePassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangePassword.__proto__||Object.getPrototypeOf(ChangePassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={oldPassword:'',newPassword:'',confirmPassword:'',oldPasswordIsValid:null,newPasswordIsValid:null,confirmPasswordIsValid:null,isChanged:false,error:null,rules:[{name:'Conter caracteres especiais',regex:/[!@#$%^&*(),.?":{}|<>]/},{name:'Conter números',regex:/\d/},{name:'Conter letras maiúsculas',regex:/[A-Z]+/},{name:'Conter letras minúsculas',regex:/[a-z]+/},{name:'Conter no mínimo 6 caracteres',regex:/^.{6,}$/}]},_this.handleSuccess=function(){_this.setState({isChanged:true,error:null,oldPassword:'',newPassword:'',confirmPassword:'',confirmPasswordIsValid:null,newPasswordIsValid:null});},_this.handleError=function(error){_this.setState({error:error,isChanged:false});},_this.validateNewPassword=function(){var regras=_this.testRules(_this.state.rules,_this.state.newPassword);var rules=regras.filter(function(ele){return ele.isValid===false;});if(rules&&rules.length>0){if(_this.state.newPasswordIsValid!==false){_this.setState({newPasswordIsValid:false});}}else{if(_this.state.newPasswordIsValid!==true){_this.setState({newPasswordIsValid:true});}}},_this.validateConfirmPassword=function(){var confirmPasswordIsValid=!!_this.state.confirmPassword&&_this.state.newPassword===_this.state.confirmPassword;_this.setState({confirmPasswordIsValid:confirmPasswordIsValid});return confirmPasswordIsValid;},_this.handleSubmit=function(event){event.preventDefault();var _this$props=_this.props,idToken=_this$props.id_token,accessToken=_this$props.access_token,profile=_this$props.profile;var _this$state=_this.state,oldPassword=_this$state.oldPassword,newPassword=_this$state.newPassword;__WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth___default.a.setSession({username:profile.username,provider:__WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth__["AWSCognitoProvider"].NAME,tokens:{idToken:idToken,accessToken:accessToken}}).then(function(_ref2){var user=_ref2.user;return __WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth___default.a.changePassword(user,oldPassword,newPassword);}).then(_this.handleSuccess).catch(_this.handleError);},_this.handleInputValue=function(_ref3){var _ref3$target=_ref3.target,name=_ref3$target.name,value=_ref3$target.value;return _this.setState(_defineProperty({isChanged:false},name,value));},_this.isFormValid=function(){var _this$state2=_this.state,oldPasswordIsValid=_this$state2.oldPasswordIsValid,newPasswordIsValid=_this$state2.newPasswordIsValid,confirmPasswordIsValid=_this$state2.confirmPasswordIsValid;return oldPasswordIsValid===null&&newPasswordIsValid&&confirmPasswordIsValid;},_this.closeAlert=function(){return _this.setState({error:null,isChanged:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangePassword,[{key:'componentDidMount',value:function componentDidMount(){var userPoolId="us-east-1_XR3aIEQ8B";var region=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_REGION;var userPoolWebClientId="1tbhh14ofdn4d5oof5dm32nmen";__WEBPACK_IMPORTED_MODULE_3__aws_amplify_auth___default.a.configure({userPoolId:userPoolId,userPoolWebClientId:userPoolWebClientId,region:region});}},{key:'testRules',value:function testRules(rules,password){return Object.values(rules).map(function(_ref4){var name=_ref4.name,regex=_ref4.regex;return{name:name,// eslint-disable-next-line no-unneeded-ternary
isValid:password.match(regex)?true:false};});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Minha senha - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pl-2 pr-2 pt-0 pb-4 py-md-2 pt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_App_Shell_LoggedSidebar__["a" /* default */],{selected:'/security-access',count:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-lg-8 mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.state.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Alert"],{isError:true,title:'Ops! N\xE3o foi poss\xEDvel alterar sua senha.',className:'pb-2',onClose:this.closeAlert}),this.state.isChanged&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Alert"],{title:'Senha alterada com sucesso.',className:'pb-2',onClose:this.closeAlert}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step row px-1 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-title txt-font-body txt-initial color-title mr-auto'},'Alterar Senha'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 pt-half border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FieldPassword_FieldPassword__["a" /* default */],Object.assign({},this.state,{handleInputValue:this.handleInputValue,handleSubmit:this.handleSubmit,validateConfirmPassword:this.validateConfirmPassword,validateNewPassword:this.validateNewPassword,validateOldPassword:this.validateOldPassword,isFormValid:this.isFormValid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-6 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 px-3 px-sm-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["PasswordStrength"],{password:this.state.newPassword}))))))))));}}]);return ChangePassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangePassword.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,id_token:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,access_token:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};var mapStateToProps=function mapStateToProps(_ref5){var user=_ref5.oidc.user;return Object.assign({},user);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChangePassword,props);}));

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var Auth_1 = __webpack_require__(1109);
exports.AuthClass = Auth_1.default;
var amazon_cognito_identity_js_1 = __webpack_require__(285);
exports.CognitoUser = amazon_cognito_identity_js_1.CognitoUser;
exports.CookieStorage = amazon_cognito_identity_js_1.CookieStorage;
var core_1 = __webpack_require__(45);
var logger = new core_1.ConsoleLogger('Auth');
var _instance = null;
if (!_instance) {
    logger.debug('Create Auth Instance');
    _instance = new Auth_1.default(null);
}
var Auth = _instance;
core_1.default.register(Auth);
exports.default = Auth;
__export(__webpack_require__(531));
__export(__webpack_require__(276));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(276);
var core_1 = __webpack_require__(45);
var amazon_cognito_identity_js_1 = __webpack_require__(285);
var amazon_cognito_auth_js_1 = __webpack_require__(1199);
var providers_1 = __webpack_require__(531);
var logger = new core_1.ConsoleLogger('AuthClass');
var dispatchAuthEvent = function (event, data) {
    core_1.Hub.dispatch('auth', { event: event, data: data }, 'Auth');
};
/**
* Provide authentication steps
*/
var AuthClass = /** @class */ (function () {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */
    function AuthClass(config) {
        this.userPool = null;
        this._cognitoAuthClient = null;
        this.user = null;
        this._gettingCredPromise = null;
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        this._pluggables = [];
        // add default pluggables
        this.addPluggable(new providers_1.AWSCognitoProvider());
        this.addPluggable(new providers_1.GoogleProvider());
        this.addPluggable(new providers_1.FacebookProvider());
        this.addPluggable(new providers_1.AmazonProvider());
        this.addPluggable(new providers_1.DeveloperProvider());
        this.addPluggable(new providers_1.GenericProvider());
        if (core_1.AWS.config) {
            core_1.AWS.config.update({ customUserAgent: core_1.Constants.userAgent });
        }
        else {
            logger.warn('No AWS.config');
        }
        this.configure(config);
    }
    AuthClass.prototype.getModuleName = function () {
        return 'Auth';
    };
    AuthClass.prototype.configure = function (config) {
        var _this = this;
        if (!config)
            return this._config || {};
        logger.debug('configure Auth', config);
        var conf = Object.assign({}, this._config, core_1.Parser.parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, storage = _a.storage, identityPoolRegion = _a.identityPoolRegion;
        this._keyPrefix = "AmplifyAuth_" + userPoolId + "_" + identityPoolId;
        if (!this._config.storage) {
            // backward compatbility
            if (cookieStorage)
                this._storage = new amazon_cognito_identity_js_1.CookieStorage(cookieStorage);
            else {
                this._storage = new core_1.StorageHelper().getStorage();
            }
        }
        else {
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') {
            this._storageSync = this._storage['sync']();
        }
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
            };
            userPoolData.Storage = this._storage;
            this.userPool = new amazon_cognito_identity_js_1.CognitoUserPool(userPoolData);
        }
        core_1.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            _keyPrefix: this._keyPrefix
        });
        // initiailize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (oauth['domain'] ? oauth : oauth.awsCognito) : undefined;
        if (cognitoHostedUIConfig) {
            var that_1 = this;
            var cognitoAuthParams = Object.assign({
                ClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                AppWebDomain: cognitoHostedUIConfig['domain'],
                TokenScopesArray: cognitoHostedUIConfig['scope'],
                RedirectUriSignIn: cognitoHostedUIConfig['redirectSignIn'],
                RedirectUriSignOut: cognitoHostedUIConfig['redirectSignOut'],
                ResponseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage
            }, cognitoHostedUIConfig['options']);
            logger.debug('cognito auth params', cognitoAuthParams);
            this._cognitoAuthClient = new amazon_cognito_auth_js_1.CognitoAuth(cognitoAuthParams);
            this._cognitoAuthClient.userhandler = {
                // user signed in
                onSuccess: function (result) {
                    that_1.user = that_1.userPool.getCurrentUser();
                    logger.debug("Cognito Hosted authentication result", result);
                    _this._addSessionSource(providers_1.AWSCognitoProvider.NAME);
                    that_1.currentSession().then(function (session) { return __awaiter(_this, void 0, void 0, function () {
                        var cred, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, 4, 5]);
                                    return [4 /*yield*/, core_1.Credentials.clear()];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, core_1.Credentials.set(session, 'session')];
                                case 2:
                                    cred = _a.sent();
                                    logger.debug('sign in succefully with', cred);
                                    return [3 /*break*/, 5];
                                case 3:
                                    e_1 = _a.sent();
                                    logger.debug('sign in without aws credentials', e_1);
                                    return [3 /*break*/, 5];
                                case 4:
                                    dispatchAuthEvent('signIn', that_1.user);
                                    dispatchAuthEvent('cognitoHostedUI', that_1.user);
                                    return [7 /*endfinally*/];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); });
                },
                onFailure: function (err) {
                    logger.debug("Error in cognito hosted auth response", err);
                    dispatchAuthEvent('signIn_failure', err);
                    dispatchAuthEvent('cognitoHostedUI_failure', err);
                }
            };
            // if not logged in, try to parse the url.
            this.currentAuthenticatedUser().then(function () {
                logger.debug('user already logged in');
            }).catch(function (e) {
                logger.debug('not logged in, try to parse the url');
                if (!core_1.JS.browserOrNode().isBrowser || !window.location) {
                    logger.debug('not in the browser');
                    return;
                }
                var curUrl = window.location.href;
                try {
                    _this._cognitoAuthClient.parseCognitoWebResponse(curUrl);
                }
                catch (err) {
                    logger.debug('something wrong when parsing the url', err);
                    dispatchAuthEvent('parsingUrl_failure', null);
                }
            });
        }
        this._pluggables.forEach(function (pluggable) {
            pluggable.configure(__assign({}, _this._config, { storage: _this._storage, _keyPrefix: _this._keyPrefix }));
        });
        dispatchAuthEvent('configured', null);
        return this._config;
    };
    /**
     * Add a plugin into Auth module
     * The plugin is aimed to provide provider-specified methods
     * like setSession, getSession, getUser
     * @param {AuthProvider} pluggable - the specified provider for Auth
     */
    AuthClass.prototype.addPluggable = function (pluggable) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (pluggable && pluggable.getCategory() === 'Auth') {
                    this._pluggables.push(pluggable);
                }
                return [2 /*return*/];
            });
        });
    };
    //#region Registration Related Methods 
    /**
     * Sign up with username, password and other attrbutes like phone, email
     * @param {String | object} params - The user attirbutes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */
    AuthClass.prototype.signUp = function (params) {
        var _this = this;
        var restOfAttrs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            restOfAttrs[_i - 1] = arguments[_i];
        }
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email)
                attributes.push({ Name: 'email', Value: email });
            if (phone_number)
                attributes.push({ Name: 'phone_number', Value: phone_number });
        }
        else if (params && typeof params === 'object') {
            username = params['username'];
            password = params['password'];
            var attrs_1 = params['attributes'];
            if (attrs_1) {
                Object.keys(attrs_1).map(function (key) {
                    var ele = { Name: key, Value: attrs_1[key] };
                    attributes.push(ele);
                });
            }
            validationData = params['validationData'] || null;
        }
        else {
            return Promise.reject('The first parameter should either be non-null string or object');
        }
        if (!username) {
            return Promise.reject('Username cannot be empty');
        }
        if (!password) {
            return Promise.reject('Password cannot be empty');
        }
        logger.debug('signUp attrs:', attributes);
        logger.debug('signUp validation data:', validationData);
        return new Promise(function (resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function (err, data) {
                if (err) {
                    dispatchAuthEvent('signUp_failure', err);
                    reject(err);
                }
                else {
                    dispatchAuthEvent('signUp', data);
                    resolve(data);
                }
            });
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */
    AuthClass.prototype.confirmSignUp = function (username, code, options) {
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        if (!username) {
            return Promise.reject('Username cannot be empty');
        }
        if (!code) {
            return Promise.reject('Code cannot be empty');
        }
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean'
            ? options.forceAliasCreation : true;
        return new Promise(function (resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function (err, data) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(data);
                }
            });
        });
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @return - A promise resolves data if success
     */
    AuthClass.prototype.resendSignUp = function (username) {
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        if (!username) {
            return Promise.reject('Username cannot be empty');
        }
        var user = this.createCognitoUser(username);
        return new Promise(function (resolve, reject) {
            user.resendConfirmationCode(function (err, data) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(data);
                }
            });
        });
    };
    //#endregion
    //#region Sign In Related Methods
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} password - The password of the username
     * @return - A promise resolves the CognitoUser
     */
    AuthClass.prototype.signIn = function (usernameOrSignInOpts, pw) {
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        }
        else if (types_1.isUsernamePasswordOpts(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') {
                logger.warn('The password should be defined under the first parameter object!');
            }
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        }
        else {
            return Promise.reject(new Error('The username should either be a string or one of the sign in types'));
        }
        if (!username) {
            return Promise.reject('Username cannot be empty');
        }
        var authDetails = new amazon_cognito_identity_js_1.AuthenticationDetails({
            Username: username,
            Password: password,
            ValidationData: validationData
        });
        if (password) {
            return this.signInWithPassword(authDetails);
        }
        else {
            return this.signInWithoutPassword(authDetails);
        }
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */
    AuthClass.prototype.authCallbacks = function (user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function (session) { return __awaiter(_this, void 0, void 0, function () {
                var cred, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this._addSessionSource(providers_1.AWSCognitoProvider.NAME);
                            logger.debug(session);
                            delete (user['challengeName']);
                            delete (user['challengeParam']);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, 5, 6]);
                            return [4 /*yield*/, core_1.Credentials.clear()];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, core_1.Credentials.set(session, 'session')];
                        case 3:
                            cred = _a.sent();
                            logger.debug('succeed to get cognito credentials', cred);
                            return [3 /*break*/, 6];
                        case 4:
                            e_2 = _a.sent();
                            logger.debug('cannot get cognito credentials', e_2);
                            return [3 /*break*/, 6];
                        case 5:
                            that.user = user;
                            dispatchAuthEvent('signIn', user);
                            resolve(user);
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            }); },
            onFailure: function (err) {
                logger.debug('signIn failure', err);
                dispatchAuthEvent('signIn_failure', err);
                reject(err);
            },
            customChallenge: function (challengeParam) {
                logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function (challengeName, challengeParam) {
                logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function (challengeName, challengeParam) {
                logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function (challengeName, challengeParam) {
                logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function (challengeName, challengeParam) {
                logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */
    AuthClass.prototype.signInWithPassword = function (authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        return new Promise(function (resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */
    AuthClass.prototype.signInWithoutPassword = function (authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function (resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */
    AuthClass.prototype.confirmSignIn = function (user, code, mfaType) {
        var _this = this;
        if (!code) {
            return Promise.reject('Code cannot be empty');
        }
        var that = this;
        return new Promise(function (resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function (session) { return __awaiter(_this, void 0, void 0, function () {
                    var cred, e_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                logger.debug('sendMFACode Success', session);
                                this._addSessionSource(providers_1.AWSCognitoProvider.NAME);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, 5, 6]);
                                return [4 /*yield*/, core_1.Credentials.clear()];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, core_1.Credentials.set(session, 'session')];
                            case 3:
                                cred = _a.sent();
                                logger.debug('succeed to get cognito credentials', cred);
                                return [3 /*break*/, 6];
                            case 4:
                                e_3 = _a.sent();
                                logger.debug('cannot get cognito credentials', e_3);
                                return [3 /*break*/, 6];
                            case 5:
                                that.user = user;
                                dispatchAuthEvent('signIn', user);
                                resolve(user);
                                return [7 /*endfinally*/];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); },
                onFailure: function (err) {
                    logger.debug('confirm signIn failure', err);
                    reject(err);
                }
            }, mfaType);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */
    AuthClass.prototype.sendCustomChallengeAnswer = function (user, challengeResponses) {
        var _this = this;
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        if (!challengeResponses) {
            return Promise.reject('Challenge response cannot be empty');
        }
        var that = this;
        return new Promise(function (resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject));
        });
    };
    //#endregion
    //#region MFA Related Methods
    /**
     * get user current preferred mfa option
     * this method doesn't work with totp, we need to deprecate it.
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */
    AuthClass.prototype.getMFAOptions = function (user) {
        return new Promise(function (res, rej) {
            user.getMFAOptions(function (err, mfaOptions) {
                if (err) {
                    logger.debug('get MFA Options failed', err);
                    return rej(err);
                }
                logger.debug('get MFA options success', mfaOptions);
                return res(mfaOptions);
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     */
    AuthClass.prototype.getPreferredMFA = function (user) {
        var that = this;
        return new Promise(function (res, rej) {
            user.getUserData(function (err, data) {
                if (err) {
                    logger.debug('getting preferred mfa failed', err);
                    return rej(err);
                }
                var mfaType = that._getMfaTypeFromUserData(data);
                if (!mfaType) {
                    return rej('invalid MFA Type');
                }
                else {
                    return res(mfaType);
                }
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function (data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) {
            ret = preferredMFA;
        }
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(), 
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) {
                    ret = 'SMS_MFA';
                }
                else {
                    ret = 'NOMFA';
                }
            }
            else if (mfaList.length === 0) {
                ret = 'NOMFA';
            }
            else {
                logger.debug('invalid case for getPreferredMFA', data);
            }
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function (user) {
        return new Promise(function (res, rej) {
            user.getUserData(function (err, data) {
                if (err) {
                    logger.debug('getting user data failed', err);
                    return rej(err);
                }
                else {
                    return res(data);
                }
            });
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */
    AuthClass.prototype.setPreferredMFA = function (user, mfaMethod) {
        return __awaiter(this, void 0, void 0, function () {
            var userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._getUserData(user)];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch (_a) {
                            case 'TOTP' || 'SOFTWARE_TOKEN_MFA': return [3 /*break*/, 2];
                            case 'SMS' || 'SMS_MFA': return [3 /*break*/, 3];
                            case 'NOMFA': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [3 /*break*/, 7];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [3 /*break*/, 7];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [4 /*yield*/, this._getMfaTypeFromUserData(userData)];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') {
                            return [2 /*return*/, Promise.resolve('No change for mfa type')];
                        }
                        else if (currentMFAType === 'SMS_MFA') {
                            smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        }
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') {
                            totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        }
                        else {
                            return [2 /*return*/, Promise.reject('invalid MFA type')];
                        }
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) {
                            // to disable SMS or TOTP if exists in that list
                            mfaList.forEach(function (mfaType) {
                                if (mfaType === 'SMS_MFA') {
                                    smsMfaSettings = {
                                        PreferredMfa: false,
                                        Enabled: false
                                    };
                                }
                                else if (mfaType === 'SOFTWARE_TOKEN_MFA') {
                                    totpMfaSettings = {
                                        PreferredMfa: false,
                                        Enabled: false
                                    };
                                }
                            });
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        logger.debug('no validmfa method provided');
                        return [2 /*return*/, Promise.reject('no validmfa method provided')];
                    case 7:
                        that = this;
                        return [2 /*return*/, new Promise(function (res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function (err, result) {
                                    if (err) {
                                        logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    logger.debug('Set user mfa success', result);
                                    return res(result);
                                });
                            })];
                }
            });
        });
    };
    /**
     * diable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */
    AuthClass.prototype.disableSMS = function (user) {
        return new Promise(function (res, rej) {
            user.disableMFA(function (err, data) {
                if (err) {
                    logger.debug('disable mfa failed', err);
                    return rej(err);
                }
                logger.debug('disable mfa succeed', data);
                return res(data);
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */
    AuthClass.prototype.enableSMS = function (user) {
        return new Promise(function (res, rej) {
            user.enableMFA(function (err, data) {
                if (err) {
                    logger.debug('enable mfa failed', err);
                    return rej(err);
                }
                logger.debug('enable mfa succeed', data);
                return res(data);
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */
    AuthClass.prototype.setupTOTP = function (user) {
        return new Promise(function (res, rej) {
            user.associateSoftwareToken({
                onFailure: function (err) {
                    logger.debug('associateSoftwareToken failed', err);
                    return rej(err);
                },
                associateSecretCode: function (secretCode) {
                    logger.debug('associateSoftwareToken sucess', secretCode);
                    return res(secretCode);
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */
    AuthClass.prototype.verifyTotpToken = function (user, challengeAnswer) {
        logger.debug('verfication totp token', user, challengeAnswer);
        return new Promise(function (res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function (err) {
                    logger.debug('verifyTotpToken failed', err);
                    return rej(err);
                },
                onSuccess: function (data) {
                    logger.debug('verifyTotpToken success', data);
                    return res(data);
                }
            });
        });
    };
    //#endregion
    //#region ResetPassword Related Methods
    AuthClass.prototype.completeNewPassword = function (user, password, requiredAttributes) {
        var _this = this;
        if (!password) {
            return Promise.reject('Password cannot be empty');
        }
        var that = this;
        return new Promise(function (resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function (session) { return __awaiter(_this, void 0, void 0, function () {
                    var cred, e_4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this._addSessionSource(providers_1.AWSCognitoProvider.NAME);
                                logger.debug(session);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, 5, 6]);
                                return [4 /*yield*/, core_1.Credentials.clear()];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, core_1.Credentials.set(session, 'session')];
                            case 3:
                                cred = _a.sent();
                                logger.debug('succeed to get cognito credentials', cred);
                                return [3 /*break*/, 6];
                            case 4:
                                e_4 = _a.sent();
                                logger.debug('cannot get cognito credentials', e_4);
                                return [3 /*break*/, 6];
                            case 5:
                                that.user = user;
                                dispatchAuthEvent('signIn', user);
                                resolve(user);
                                return [7 /*endfinally*/];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); },
                onFailure: function (err) {
                    logger.debug('completeNewPassword failure', err);
                    dispatchAuthEvent('completeNewPassword_failure', err);
                    reject(err);
                },
                mfaRequired: function (challengeName, challengeParam) {
                    logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function (challengeName, challengeParam) {
                    logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */
    AuthClass.prototype.changePassword = function (user, oldPassword, newPassword) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.userSession(user).then(function (session) {
                user.changePassword(oldPassword, newPassword, function (err, data) {
                    if (err) {
                        logger.debug('change password failure', err);
                        return reject(err);
                    }
                    else {
                        return resolve(data);
                    }
                });
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */
    AuthClass.prototype.forgotPassword = function (username) {
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        if (!username) {
            return Promise.reject('Username cannot be empty');
        }
        var user = this.createCognitoUser(username);
        return new Promise(function (resolve, reject) {
            user.forgotPassword({
                onSuccess: function () {
                    logger.debug('Forgot password succeeds');
                    return resolve();
                },
                onFailure: function (err) {
                    logger.debug('Forgot password failure', err);
                    return reject(err);
                },
                inputVerificationCode: function (data) {
                    return resolve(data);
                }
            });
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */
    AuthClass.prototype.forgotPasswordSubmit = function (username, code, password) {
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        if (!username) {
            return Promise.reject('Username cannot be empty');
        }
        if (!code) {
            return Promise.reject('Code cannot be empty');
        }
        if (!password) {
            return Promise.reject('Password cannot be empty');
        }
        var user = this.createCognitoUser(username);
        return new Promise(function (resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function () {
                    return resolve();
                },
                onFailure: function (err) {
                    return reject(err);
                }
            });
        });
    };
    //#endregion
    //#region Attributes Related Methods
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/
    AuthClass.prototype.updateUserAttributes = function (user, attributes) {
        var attributeList = [];
        var that = this;
        return new Promise(function (resolve, reject) {
            that.userSession(user).then(function (session) {
                for (var key in attributes) {
                    if (key !== 'sub' &&
                        key.indexOf('_verified') < 0) {
                        var attr = {
                            'Name': key,
                            'Value': attributes[key]
                        };
                        attributeList.push(attr);
                    }
                }
                user.updateAttributes(attributeList, function (err, result) {
                    if (err) {
                        return reject(err);
                    }
                    else {
                        return resolve(result);
                    }
                });
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */
    AuthClass.prototype.userAttributes = function (user) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.userSession(user).then(function (session) {
                user.getUserAttributes(function (err, attributes) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(attributes);
                    }
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function (user) {
        var that = this;
        return this.userAttributes(user)
            .then(function (attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) {
                    verified['email'] = attrs['email'];
                }
                else {
                    unverified['email'] = attrs['email'];
                }
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) {
                    verified['phone_number'] = attrs['phone_number'];
                }
                else {
                    unverified['phone_number'] = attrs['phone_number'];
                }
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */
    AuthClass.prototype.verifyUserAttribute = function (user, attr) {
        return new Promise(function (resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function () { return resolve(); },
                onFailure: function (err) { return reject(err); }
            });
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */
    AuthClass.prototype.verifyUserAttributeSubmit = function (user, attr, code) {
        if (!code) {
            return Promise.reject('Code cannot be empty');
        }
        return new Promise(function (resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function (data) {
                    logger.debug('Verify user attributes succeeds');
                    return resolve(data);
                },
                onFailure: function (err) {
                    logger.debug('Failed to verify user attributes', err);
                    return reject(err);
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function (attr) {
        var that = this;
        return that.currentUserPoolUser()
            .then(function (user) { return that.verifyUserAttribute(user, attr); });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */
    AuthClass.prototype.verifyCurrentUserAttributeSubmit = function (attr, code) {
        var that = this;
        return that.currentUserPoolUser()
            .then(function (user) { return that.verifyUserAttributeSubmit(user, attr, code); });
    };
    //#endregion
    //#region Current User/Session/Credentials Related Methods
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */
    AuthClass.prototype.currentUserPoolUser = function (params) {
        var _this = this;
        if (!this.userPool) {
            return Promise.reject('No userPool');
        }
        var that = this;
        return new Promise(function (res, rej) {
            _this._storageSync.then(function () {
                var user = that.userPool.getCurrentUser();
                if (!user) {
                    logger.debug('Failed to get user from user pool');
                    return rej('No current user');
                }
                // refresh the session if the session expired.
                user.getSession(function (err, session) {
                    if (err) {
                        logger.debug('Failed to get the user session', err);
                        return rej(err);
                    }
                    // get user data from Cognito
                    var bypassCache = params ? params.bypassCache : false;
                    user.getUserData(function (err, data) {
                        if (err) {
                            logger.debug('getting user data failed', err);
                            // Make sure the user is still valid
                            if (err.message === 'User is disabled' || err.message === 'User does not exist.') {
                                return rej(err);
                            }
                            else {
                                // the error may also be thrown when lack of permissions to get user info etc
                                // in that case we just bypass the error
                                return res(user);
                            }
                        }
                        var preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                        var attributeList = [];
                        for (var i = 0; i < data.UserAttributes.length; i++) {
                            var attribute = {
                                Name: data.UserAttributes[i].Name,
                                Value: data.UserAttributes[i].Value,
                            };
                            var userAttribute = new amazon_cognito_identity_js_1.CognitoUserAttribute(attribute);
                            attributeList.push(userAttribute);
                        }
                        var attributes = that.attributesToObject(attributeList);
                        Object.assign(user, { attributes: attributes, preferredMFA: preferredMFA });
                        return res(user);
                    }, { bypassCache: bypassCache });
                });
            }).catch(function (e) {
                logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */
    AuthClass.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionSource, user, e_5, providerClass, _a, e_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger.debug('getting current authenticted user');
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        _b.sent();
                        sessionSource = this._getSessionSource();
                        if (!(!sessionSource || sessionSource === providers_1.AWSCognitoProvider.NAME)) return [3 /*break*/, 6];
                        logger.debug('get current authenticated userpool user');
                        user = null;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.currentUserPoolUser(params)];
                    case 3:
                        user = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_5 = _b.sent();
                        if (e_5 === 'No userPool') {
                            logger.error('Cannot get the current user because the user pool is missing. ' +
                                'Please make sure the Auth module is configured with a valid Cognito User Pool ID');
                        }
                        logger.debug('The user is not authenticated by the error', e_5);
                        throw ('not authenticated');
                    case 5:
                        this.user = user;
                        return [2 /*return*/, this.user];
                    case 6:
                        providerClass = this._getProvider(sessionSource);
                        _b.label = 7;
                    case 7:
                        _b.trys.push([7, 9, , 10]);
                        _a = this;
                        return [4 /*yield*/, providerClass.getUser()];
                    case 8:
                        _a.user = _b.sent();
                        return [2 /*return*/, this.user];
                    case 9:
                        e_6 = _b.sent();
                        logger.debug('The user is not authenticated by the error', e_6);
                        throw ('not authenticated');
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */
    AuthClass.prototype.currentSession = function () {
        var _this = this;
        logger.debug('Getting current session');
        return new Promise(function (res, rej) {
            _this._storageSync.then(function () {
                var sessionSource = _this._getSessionSource();
                if (!sessionSource || sessionSource === providers_1.AWSCognitoProvider.NAME) {
                    if (!_this.userPool) {
                        return rej('No userPool');
                    }
                    _this.currentUserPoolUser().then(function (user) {
                        _this.userSession(user).then(function (session) {
                            return res(session);
                        }).catch(function (e) {
                            logger.debug('Failed to get the current session', e);
                            return rej(e);
                        });
                    }).catch(function (e) {
                        logger.debug('Failed to get the current user', e);
                        return rej(e);
                    });
                }
                else {
                    var providerClass = _this._getProvider(sessionSource);
                    providerClass.getSession().then(function (session) {
                        return res(session);
                    }).catch(function (e) {
                        logger.debug('Failed to get the current session', e);
                        return rej(e);
                    });
                }
            });
        });
    };
    /**
     * Get the Cognito User session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */
    AuthClass.prototype.userSession = function (user) {
        if (!user) {
            logger.debug('the user is null');
            return Promise.reject('Failed to get the session because the user is empty');
        }
        return new Promise(function (resolve, reject) {
            logger.debug('Getting the session from this user:', user);
            user.getSession(function (err, session) {
                if (err) {
                    logger.debug('Failed to get the session from user', user);
                    return reject(err);
                }
                else {
                    logger.debug('Succeed to get the user session', session);
                    return resolve(session);
                }
            });
        });
    };
    /**
     * Get  authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */
    AuthClass.prototype.currentUserCredentials = function () {
        logger.debug('Getting current user credentials');
        var sessionSource = this._getSessionSource();
        if (!sessionSource || sessionSource === providers_1.AWSCognitoProvider.NAME) {
            return this.currentSession()
                .then(function (session) {
                logger.debug('getting session success', session);
                return core_1.Credentials.set(session, 'session');
            }).catch(function (error) {
                logger.debug('getting session failed', error);
                return core_1.Credentials.set(null, 'guest');
            });
        }
        else {
            var providerClass = this._getProvider(sessionSource);
            return providerClass.getSession()
                .then(function (session) {
                logger.debug('getting session success', session);
                return core_1.Credentials.set(session, 'federation');
            }).catch(function (error) {
                logger.debug('getting session failed', error);
                return core_1.Credentials.set(null, 'guest');
            });
        }
    };
    /**
     * Get the current credentials
     * @return {Promise<ICredentials>} - a promise which resolves to be credentials
     */
    AuthClass.prototype.currentCredentials = function () {
        logger.debug('getting current credntials');
        return core_1.Credentials.get();
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */
    AuthClass.prototype.currentUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sessionSource, user, e_7, attributes, userAttrs, credentials, e_8, info, err_1, providerClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionSource = this._getSessionSource();
                        if (!(!sessionSource || sessionSource === providers_1.AWSCognitoProvider.NAME)) return [3 /*break*/, 13];
                        user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.currentUserPoolUser()];
                    case 2:
                        user = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_7 = _a.sent();
                        logger.debug('Failed to get the current user pool user', e_7);
                        return [3 /*break*/, 4];
                    case 4:
                        if (!user) {
                            return [2 /*return*/, null];
                        }
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 11, , 12]);
                        return [4 /*yield*/, this.userAttributes(user)];
                    case 6:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, this.currentCredentials()];
                    case 8:
                        credentials = _a.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        e_8 = _a.sent();
                        logger.debug('Failed to retrieve credentials while getting current user info', e_8);
                        return [3 /*break*/, 10];
                    case 10:
                        info = {
                            'id': credentials ? credentials.identityId : undefined,
                            'username': user.getUsername(),
                            'attributes': userAttrs
                        };
                        return [2 /*return*/, info];
                    case 11:
                        err_1 = _a.sent();
                        logger.debug('currentUserInfo error', err_1);
                        return [2 /*return*/, {}];
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        providerClass = this._getProvider(sessionSource);
                        return [2 /*return*/, providerClass.getUser()];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    //#endregion
    //#region SignOut Related Methods
    AuthClass.prototype.cognitoIdentitySignOut = function (opts, user) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (res, rej) {
                        if (opts && opts.global) {
                            logger.debug('user global sign out', user);
                            // in order to use global signout
                            // we must validate the user as an authenticated user by using getSession
                            user.getSession(function (err, result) {
                                if (err) {
                                    logger.debug('failed to get the user session', err);
                                    return rej(err);
                                }
                                user.globalSignOut({
                                    onSuccess: function (data) {
                                        logger.debug('global sign out success');
                                        if (_this._cognitoAuthClient) {
                                            _this._cognitoAuthClient.signOut();
                                        }
                                        return res();
                                    },
                                    onFailure: function (err) {
                                        logger.debug('global sign out failed', err);
                                        return rej(err);
                                    }
                                });
                            });
                        }
                        else {
                            logger.debug('user sign out', user);
                            user.signOut();
                            if (_this._cognitoAuthClient) {
                                _this._cognitoAuthClient.signOut();
                            }
                            return res();
                        }
                    })];
            });
        });
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */
    AuthClass.prototype.signOut = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var e_9, sessionSource, user, providerClass;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cleanCachedItems()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_9 = _a.sent();
                        logger.debug('failed to clear cached items');
                        return [3 /*break*/, 3];
                    case 3: return [4 /*yield*/, this._storageSync];
                    case 4:
                        _a.sent();
                        sessionSource = this._getSessionSource();
                        this._removeSessionSource();
                        if (!(!sessionSource || sessionSource === providers_1.AWSCognitoProvider.NAME)) return [3 /*break*/, 8];
                        if (!this.userPool) {
                            logger.error('No Congito User pool configured in the Auth module');
                            throw new Error('No userPool');
                        }
                        user = this.userPool.getCurrentUser();
                        if (!user) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.cognitoIdentitySignOut(opts, user)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        logger.debug('no current Cognito user');
                        _a.label = 7;
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        providerClass = this._getProvider(sessionSource);
                        return [4 /*yield*/, providerClass.clearSession()];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10:
                        dispatchAuthEvent('signOut', this.user);
                        this.user = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // clear cognito cached item
                    return [4 /*yield*/, core_1.Credentials.clear()];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated
     * For federated login
     * @param {String} provider - federation login provider
     * @param {FederatedResponse} response - response should have the access token
     * the identity id (optional)
     * and the expiration time (the universal time)
     * @param {String} user - user info
     */
    AuthClass.prototype.federatedSignIn = function (provider, response, user) {
        return __awaiter(this, void 0, void 0, function () {
            var token, identity_id, expires_at, authProvider, domain, idToken, accessToken, credentials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        authProvider = null;
                        domain = null;
                        // for backward compatiblity
                        switch (provider) {
                            case 'google' || providers_1.GoogleProvider.NAME:
                                authProvider = providers_1.GoogleProvider.NAME;
                                domain = providers_1.GoogleProvider.DEFAULT_DOMAIN;
                                break;
                            case 'facebook' || providers_1.FacebookProvider.NAME:
                                authProvider = providers_1.FacebookProvider.NAME;
                                domain = providers_1.FacebookProvider.DEFAULT_DOMAIN;
                                break;
                            case 'amazon' || providers_1.AmazonProvider.NAME:
                                authProvider = providers_1.AmazonProvider.NAME;
                                domain = providers_1.AmazonProvider.DEFAULT_DOMAIN;
                                break;
                            case 'developer' || providers_1.DeveloperProvider.NAME:
                                authProvider = providers_1.DeveloperProvider.NAME;
                                domain = providers_1.DeveloperProvider.DEFAULT_DOMAIN;
                                break;
                            default:
                                authProvider = providers_1.GenericProvider.NAME;
                                domain = provider;
                                break;
                        }
                        idToken = authProvider === providers_1.FacebookProvider.NAME ||
                            authProvider === providers_1.AmazonProvider.NAME ?
                            undefined : token;
                        accessToken = authProvider === providers_1.FacebookProvider.NAME ||
                            authProvider === providers_1.AmazonProvider.NAME ?
                            token : undefined;
                        return [4 /*yield*/, this.setSession({
                                username: user.name,
                                attributes: user.attributes,
                                tokens: {
                                    idToken: idToken,
                                    accessToken: accessToken
                                },
                                expires_at: expires_at,
                                provider: authProvider,
                                federatedWithIDP: {
                                    token: idToken ? 'id_token' : 'access_token',
                                    domain: domain,
                                    identityId: identity_id,
                                    errorHandler: function (e) {
                                        throw e;
                                    }
                                }
                            })];
                    case 1:
                        credentials = (_a.sent()).credentials;
                        dispatchAuthEvent('signIn', this.user);
                        logger.debug('federated sign in credentials', credentials);
                        return [2 /*return*/, credentials];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */
    AuthClass.prototype.essentialCredentials = function (credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function (attributes) {
        var obj = {};
        if (attributes) {
            attributes.map(function (attribute) {
                if (attribute.Value === 'true') {
                    obj[attribute.Name] = true;
                }
                else if (attribute.Value === 'false') {
                    obj[attribute.Name] = false;
                }
                else {
                    obj[attribute.Name] = attribute.Value;
                }
            });
        }
        return obj;
    };
    AuthClass.prototype.createCognitoUser = function (username) {
        var userData = {
            Username: username,
            Pool: this.userPool,
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new amazon_cognito_identity_js_1.CognitoUser(userData);
        if (authenticationFlowType) {
            user.setAuthenticationFlowType(authenticationFlowType);
        }
        return user;
    };
    AuthClass.prototype._getProvider = function (providerName) {
        var providerClass = this._pluggables.filter(function (pluggable) { return pluggable.getProviderName() === providerName; })[0];
        if (!providerClass) {
            throw new Error("no provider class for " + providerName);
        }
        return providerClass;
    };
    AuthClass.prototype._getSessionSource = function () {
        return this._storage.getItem(this._keyPrefix + "_sessionSource");
    };
    AuthClass.prototype._removeSessionSource = function () {
        this._storage.removeItem(this._keyPrefix + "_sessionSource");
    };
    AuthClass.prototype._addSessionSource = function (source) {
        this._storage.setItem(this._keyPrefix + "_sessionSource", source);
    };
    /**
     * Manually set the session into Auth module
     * @param {ExternalSession} params - the external session
     * @return {Promise<SetSessionResult>} - returns the user, session and credentials
     */
    AuthClass.prototype.setSession = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var loggedInUser, e_10, provider, providerClass, result, e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.currentAuthenticatedUser()];
                    case 1:
                        loggedInUser = _a.sent();
                        logger.warn("There is already a signed in user: " + loggedInUser + " in your app. \n                You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        return [3 /*break*/, 3];
                    case 2:
                        e_10 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3:
                        provider = params.provider;
                        if (!provider) {
                            throw new Error('The provider property must be specified');
                        }
                        providerClass = this._getProvider(provider);
                        if (!providerClass) {
                            throw new Error("No AuthProvider class for the provider, " + provider);
                        }
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        logger.debug('Setting session with the following params', params);
                        return [4 /*yield*/, providerClass.setSession(params)];
                    case 5:
                        result = _a.sent();
                        this._addSessionSource(provider);
                        return [2 /*return*/, result];
                    case 6:
                        e_11 = _a.sent();
                        logger.debug('Failed to set the session', e_11);
                        throw e_11;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return AuthClass;
}());
exports.default = AuthClass;
//#endregion
//# sourceMappingURL=Auth.js.map

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SessionType;
(function (SessionType) {
    SessionType["FederatedProviderSession"] = "FederatedProviderSession";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var MFAType;
(function (MFAType) {
    MFAType["SMS_MFA"] = "SMS_MFA";
    MFAType["SOFTWARE_TOKEN_MFA"] = "SOFTWARE_TOKEN_MFA";
})(MFAType = exports.MFAType || (exports.MFAType = {}));
var FederatedProvider;
(function (FederatedProvider) {
    FederatedProvider["Google"] = "Google";
    FederatedProvider["Facebook"] = "Facebook";
    FederatedProvider["Amazon"] = "Amazon";
    FederatedProvider["Developer"] = "Developer";
})(FederatedProvider = exports.FederatedProvider || (exports.FederatedProvider = {}));
function isUsernamePasswordOpts(obj) {
    return !!obj.username;
}
exports.isUsernamePasswordOpts = isUsernamePasswordOpts;
//# sourceMappingURL=Auth.js.map

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(277);

var AWS = __webpack_require__(13);
if (typeof window !== 'undefined') window.AWS = AWS;
if (true) module.exports = AWS;
if (typeof self !== 'undefined') self.AWS = AWS;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);

function QueryParamSerializer() {
}

QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
  serializeStructure('', params, shape, fn);
};

function ucfirst(shape) {
  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
    return shape.name;
  } else {
    return shape.name[0].toUpperCase() + shape.name.substr(1);
  }
}

function serializeStructure(prefix, struct, rules, fn) {
  util.each(rules.members, function(name, member) {
    var value = struct[name];
    if (value === null || value === undefined) return;

    var memberName = ucfirst(member);
    memberName = prefix ? prefix + '.' + memberName : memberName;
    serializeMember(memberName, value, member, fn);
  });
}

function serializeMap(name, map, rules, fn) {
  var i = 1;
  util.each(map, function (key, value) {
    var prefix = rules.flattened ? '.' : '.entry.';
    var position = prefix + (i++) + '.';
    var keyName = position + (rules.key.name || 'key');
    var valueName = position + (rules.value.name || 'value');
    serializeMember(name + keyName, key, rules.key, fn);
    serializeMember(name + valueName, value, rules.value, fn);
  });
}

function serializeList(name, list, rules, fn) {
  var memberRules = rules.member || {};

  if (list.length === 0) {
    fn.call(this, name, null);
    return;
  }

  util.arrayEach(list, function (v, n) {
    var suffix = '.' + (n + 1);
    if (rules.api.protocol === 'ec2') {
      // Do nothing for EC2
      suffix = suffix + ''; // make linter happy
    } else if (rules.flattened) {
      if (memberRules.name) {
        var parts = name.split('.');
        parts.pop();
        parts.push(ucfirst(memberRules));
        name = parts.join('.');
      }
    } else {
      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
    }
    serializeMember(name + suffix, v, memberRules, fn);
  });
}

function serializeMember(name, value, rules, fn) {
  if (value === null || value === undefined) return;
  if (rules.type === 'structure') {
    serializeStructure(name, value, rules, fn);
  } else if (rules.type === 'list') {
    serializeList(name, value, rules, fn);
  } else if (rules.type === 'map') {
    serializeMap(name, value, rules, fn);
  } else {
    fn(name, rules.toWireFormat(value).toString());
  }
}

/**
 * @api private
 */
module.exports = QueryParamSerializer;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var XmlNode = __webpack_require__(1114).XmlNode;
var XmlText = __webpack_require__(1116).XmlText;

function XmlBuilder() { }

XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
  var xml = new XmlNode(rootElement);
  applyNamespaces(xml, shape, true);
  serialize(xml, params, shape);
  return xml.children.length > 0 || noEmpty ? xml.toString() : '';
};

function serialize(xml, value, shape) {
  switch (shape.type) {
    case 'structure': return serializeStructure(xml, value, shape);
    case 'map': return serializeMap(xml, value, shape);
    case 'list': return serializeList(xml, value, shape);
    default: return serializeScalar(xml, value, shape);
  }
}

function serializeStructure(xml, params, shape) {
  util.arrayEach(shape.memberNames, function(memberName) {
    var memberShape = shape.members[memberName];
    if (memberShape.location !== 'body') return;

    var value = params[memberName];
    var name = memberShape.name;
    if (value !== undefined && value !== null) {
      if (memberShape.isXmlAttribute) {
        xml.addAttribute(name, value);
      } else if (memberShape.flattened) {
        serialize(xml, value, memberShape);
      } else {
        var element = new XmlNode(name);
        xml.addChildNode(element);
        applyNamespaces(element, memberShape);
        serialize(element, value, memberShape);
      }
    }
  });
}

function serializeMap(xml, map, shape) {
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';

  util.each(map, function(key, value) {
    var entry = new XmlNode(shape.flattened ? shape.name : 'entry');
    xml.addChildNode(entry);

    var entryKey = new XmlNode(xmlKey);
    var entryValue = new XmlNode(xmlValue);
    entry.addChildNode(entryKey);
    entry.addChildNode(entryValue);

    serialize(entryKey, key, shape.key);
    serialize(entryValue, value, shape.value);
  });
}

function serializeList(xml, list, shape) {
  if (shape.flattened) {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || shape.name;
      var element = new XmlNode(name);
      xml.addChildNode(element);
      serialize(element, value, shape.member);
    });
  } else {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || 'member';
      var element = new XmlNode(name);
      xml.addChildNode(element);
      serialize(element, value, shape.member);
    });
  }
}

function serializeScalar(xml, value, shape) {
  xml.addChildNode(
    new XmlText(shape.toWireFormat(value))
  );
}

function applyNamespaces(xml, shape, isRoot) {
  var uri, prefix = 'xmlns';
  if (shape.xmlNamespaceUri) {
    uri = shape.xmlNamespaceUri;
    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
  } else if (isRoot && shape.api.xmlNamespaceUri) {
    uri = shape.api.xmlNamespaceUri;
  }

  if (uri) xml.addAttribute(prefix, uri);
}

/**
 * @api private
 */
module.exports = XmlBuilder;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var escapeAttribute = __webpack_require__(1115).escapeAttribute;

/**
 * Represents an XML node.
 * @api private
 */
function XmlNode(name, children) {
    if (children === void 0) { children = []; }
    this.name = name;
    this.children = children;
    this.attributes = {};
}
XmlNode.prototype.addAttribute = function (name, value) {
    this.attributes[name] = value;
    return this;
};
XmlNode.prototype.addChildNode = function (child) {
    this.children.push(child);
    return this;
};
XmlNode.prototype.removeAttribute = function (name) {
    delete this.attributes[name];
    return this;
};
XmlNode.prototype.toString = function () {
    var hasChildren = Boolean(this.children.length);
    var xmlText = '<' + this.name;
    // add attributes
    var attributes = this.attributes;
    for (var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++) {
        var attributeName = attributeNames[i];
        var attribute = attributes[attributeName];
        if (typeof attribute !== 'undefined' && attribute !== null) {
            xmlText += ' ' + attributeName + '=\"' + escapeAttribute('' + attribute) + '\"';
        }
    }
    return xmlText += !hasChildren ? '/>' : '>' + this.children.map(function (c) { return c.toString(); }).join('') + '</' + this.name + '>';
};

/**
 * @api private
 */
module.exports = {
    XmlNode: XmlNode
};


/***/ }),
/* 1115 */
/***/ (function(module, exports) {

/**
 * Escapes characters that can not be in an XML attribute.
 */
function escapeAttribute(value) {
    return value.replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * @api private
 */
module.exports = {
    escapeAttribute: escapeAttribute
};


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var escapeElement = __webpack_require__(1117).escapeElement;

/**
 * Represents an XML text value.
 * @api private
 */
function XmlText(value) {
    this.value = value;
}

XmlText.prototype.toString = function () {
    return escapeElement('' + this.value);
};

/**
 * @api private
 */
module.exports = {
    XmlText: XmlText
};


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

/**
 * Escapes characters that can not be in an XML element.
 */
function escapeElement(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/**
 * @api private
 */
module.exports = {
    escapeElement: escapeElement
};


/***/ }),
/* 1118 */
/***/ (function(module, exports) {

function apiLoader(svc, version) {
  if (!apiLoader.services.hasOwnProperty(svc)) {
    throw new Error('InvalidService: Failed to load api for ' + svc);
  }
  return apiLoader.services[svc][version];
}

/**
 * @api private
 *
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */
apiLoader.services = {};

/**
 * @api private
 */
module.exports = apiLoader;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LRU_1 = __webpack_require__(1120);
var CACHE_SIZE = 1000;
/**
 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
 */
var EndpointCache = /** @class */ (function () {
    function EndpointCache(maxSize) {
        if (maxSize === void 0) { maxSize = CACHE_SIZE; }
        this.maxSize = maxSize;
        this.cache = new LRU_1.LRUCache(maxSize);
    }
    ;
    Object.defineProperty(EndpointCache.prototype, "size", {
        get: function () {
            return this.cache.length;
        },
        enumerable: true,
        configurable: true
    });
    EndpointCache.prototype.put = function (key, value) {
      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
        var endpointRecord = this.populateValue(value);
        this.cache.put(keyString, endpointRecord);
    };
    EndpointCache.prototype.get = function (key) {
      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
        var now = Date.now();
        var records = this.cache.get(keyString);
        if (records) {
            for (var i = 0; i < records.length; i++) {
                var record = records[i];
                if (record.Expire < now) {
                    this.cache.remove(keyString);
                    return undefined;
                }
            }
        }
        return records;
    };
    EndpointCache.getKeyString = function (key) {
        var identifiers = [];
        var identifierNames = Object.keys(key).sort();
        for (var i = 0; i < identifierNames.length; i++) {
            var identifierName = identifierNames[i];
            if (key[identifierName] === undefined)
                continue;
            identifiers.push(key[identifierName]);
        }
        return identifiers.join(' ');
    };
    EndpointCache.prototype.populateValue = function (endpoints) {
        var now = Date.now();
        return endpoints.map(function (endpoint) { return ({
            Address: endpoint.Address || '',
            Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60 * 1000
        }); });
    };
    EndpointCache.prototype.empty = function () {
        this.cache.empty();
    };
    EndpointCache.prototype.remove = function (key) {
      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
        this.cache.remove(keyString);
    };
    return EndpointCache;
}());
exports.EndpointCache = EndpointCache;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedListNode = /** @class */ (function () {
    function LinkedListNode(key, value) {
        this.key = key;
        this.value = value;
    }
    return LinkedListNode;
}());
var LRUCache = /** @class */ (function () {
    function LRUCache(size) {
        this.nodeMap = {};
        this.size = 0;
        if (typeof size !== 'number' || size < 1) {
            throw new Error('Cache size can only be positive number');
        }
        this.sizeLimit = size;
    }
    Object.defineProperty(LRUCache.prototype, "length", {
        get: function () {
            return this.size;
        },
        enumerable: true,
        configurable: true
    });
    LRUCache.prototype.prependToList = function (node) {
        if (!this.headerNode) {
            this.tailNode = node;
        }
        else {
            this.headerNode.prev = node;
            node.next = this.headerNode;
        }
        this.headerNode = node;
        this.size++;
    };
    LRUCache.prototype.removeFromTail = function () {
        if (!this.tailNode) {
            return undefined;
        }
        var node = this.tailNode;
        var prevNode = node.prev;
        if (prevNode) {
            prevNode.next = undefined;
        }
        node.prev = undefined;
        this.tailNode = prevNode;
        this.size--;
        return node;
    };
    LRUCache.prototype.detachFromList = function (node) {
        if (this.headerNode === node) {
            this.headerNode = node.next;
        }
        if (this.tailNode === node) {
            this.tailNode = node.prev;
        }
        if (node.prev) {
            node.prev.next = node.next;
        }
        if (node.next) {
            node.next.prev = node.prev;
        }
        node.next = undefined;
        node.prev = undefined;
        this.size--;
    };
    LRUCache.prototype.get = function (key) {
        if (this.nodeMap[key]) {
            var node = this.nodeMap[key];
            this.detachFromList(node);
            this.prependToList(node);
            return node.value;
        }
    };
    LRUCache.prototype.remove = function (key) {
        if (this.nodeMap[key]) {
            var node = this.nodeMap[key];
            this.detachFromList(node);
            delete this.nodeMap[key];
        }
    };
    LRUCache.prototype.put = function (key, value) {
        if (this.nodeMap[key]) {
            this.remove(key);
        }
        else if (this.size === this.sizeLimit) {
            var tailNode = this.removeFromTail();
            var key_1 = tailNode.key;
            delete this.nodeMap[key_1];
        }
        var newNode = new LinkedListNode(key, value);
        this.nodeMap[key] = newNode;
        this.prependToList(newNode);
    };
    LRUCache.prototype.empty = function () {
        var keys = Object.keys(this.nodeMap);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var node = this.nodeMap[key];
            this.detachFromList(node);
            delete this.nodeMap[key];
        }
    };
    return LRUCache;
}());
exports.LRUCache = LRUCache;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(13);
var Api = __webpack_require__(498);
var regionConfig = __webpack_require__(1122);

var inherit = AWS.util.inherit;
var clientCount = 0;

/**
 * The service class representing an AWS service.
 *
 * @class_abstract This class is an abstract class.
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */
AWS.Service = inherit({
  /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */
  constructor: function Service(config) {
    if (!this.loadServiceClass) {
      throw AWS.util.error(new Error(),
        'Service must be constructed with `new\' operator');
    }
    var ServiceClass = this.loadServiceClass(config || {});
    if (ServiceClass) {
      var originalConfig = AWS.util.copy(config);
      var svc = new ServiceClass(config);
      Object.defineProperty(svc, '_originalConfig', {
        get: function() { return originalConfig; },
        enumerable: false,
        configurable: true
      });
      svc._clientId = ++clientCount;
      return svc;
    }
    this.initialize(config);
  },

  /**
   * @api private
   */
  initialize: function initialize(config) {
    var svcConfig = AWS.config[this.serviceIdentifier];
    this.config = new AWS.Config(AWS.config);
    if (svcConfig) this.config.update(svcConfig, true);
    if (config) this.config.update(config, true);

    this.validateService();
    if (!this.config.endpoint) regionConfig(this);

    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
    this.setEndpoint(this.config.endpoint);
    //enable attaching listeners to service client
    AWS.SequentialExecutor.call(this);
    AWS.Service.addDefaultMonitoringListeners(this);
    if ((this.config.clientSideMonitoring || AWS.Service._clientSideMonitoring) && this.publisher) {
      var publisher = this.publisher;
      this.addNamedListener('PUBLISH_API_CALL', 'apiCall', function PUBLISH_API_CALL(event) {
        process.nextTick(function() {publisher.eventHandler(event);});
      });
      this.addNamedListener('PUBLISH_API_ATTEMPT', 'apiCallAttempt', function PUBLISH_API_ATTEMPT(event) {
        process.nextTick(function() {publisher.eventHandler(event);});
      });
    }
  },

  /**
   * @api private
   */
  validateService: function validateService() {
  },

  /**
   * @api private
   */
  loadServiceClass: function loadServiceClass(serviceConfig) {
    var config = serviceConfig;
    if (!AWS.util.isEmpty(this.api)) {
      return null;
    } else if (config.apiConfig) {
      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
    } else if (!this.constructor.services) {
      return null;
    } else {
      config = new AWS.Config(AWS.config);
      config.update(serviceConfig, true);
      var version = config.apiVersions[this.constructor.serviceIdentifier];
      version = version || config.apiVersion;
      return this.getLatestServiceClass(version);
    }
  },

  /**
   * @api private
   */
  getLatestServiceClass: function getLatestServiceClass(version) {
    version = this.getLatestServiceVersion(version);
    if (this.constructor.services[version] === null) {
      AWS.Service.defineServiceApi(this.constructor, version);
    }

    return this.constructor.services[version];
  },

  /**
   * @api private
   */
  getLatestServiceVersion: function getLatestServiceVersion(version) {
    if (!this.constructor.services || this.constructor.services.length === 0) {
      throw new Error('No services defined on ' +
                      this.constructor.serviceIdentifier);
    }

    if (!version) {
      version = 'latest';
    } else if (AWS.util.isType(version, Date)) {
      version = AWS.util.date.iso8601(version).split('T')[0];
    }

    if (Object.hasOwnProperty(this.constructor.services, version)) {
      return version;
    }

    var keys = Object.keys(this.constructor.services).sort();
    var selectedVersion = null;
    for (var i = keys.length - 1; i >= 0; i--) {
      // versions that end in "*" are not available on disk and can be
      // skipped, so do not choose these as selectedVersions
      if (keys[i][keys[i].length - 1] !== '*') {
        selectedVersion = keys[i];
      }
      if (keys[i].substr(0, 10) <= version) {
        return selectedVersion;
      }
    }

    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
                    ' API to satisfy version constraint `' + version + '\'');
  },

  /**
   * @api private
   */
  api: {},

  /**
   * @api private
   */
  defaultRetryCount: 3,

  /**
   * @api private
   */
  customizeRequests: function customizeRequests(callback) {
    if (!callback) {
      this.customRequestHandler = null;
    } else if (typeof callback === 'function') {
      this.customRequestHandler = callback;
    } else {
      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
    }
  },

  /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeRequest: function makeRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = null;
    }

    params = params || {};
    if (this.config.params) { // copy only toplevel bound params
      var rules = this.api.operations[operation];
      if (rules) {
        params = AWS.util.copy(params);
        AWS.util.each(this.config.params, function(key, value) {
          if (rules.input.members[key]) {
            if (params[key] === undefined || params[key] === null) {
              params[key] = value;
            }
          }
        });
      }
    }

    var request = new AWS.Request(this, operation, params);
    this.addAllRequestListeners(request);
    this.attachMonitoringEmitter(request);
    if (callback) request.send(callback);
    return request;
  },

  /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = {};
    }

    var request = this.makeRequest(operation, params).toUnauthenticated();
    return callback ? request.send(callback) : request;
  },

  /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  waitFor: function waitFor(state, params, callback) {
    var waiter = new AWS.ResourceWaiter(this, state);
    return waiter.wait(params, callback);
  },

  /**
   * @api private
   */
  addAllRequestListeners: function addAllRequestListeners(request) {
    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
                AWS.EventListeners.CorePost];
    for (var i = 0; i < list.length; i++) {
      if (list[i]) request.addListeners(list[i]);
    }

    // disable parameter validation
    if (!this.config.paramValidation) {
      request.removeListener('validate',
        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    }

    if (this.config.logger) { // add logging events
      request.addListeners(AWS.EventListeners.Logger);
    }

    this.setupRequestListeners(request);
    // call prototype's customRequestHandler
    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
      this.constructor.prototype.customRequestHandler(request);
    }
    // call instance's customRequestHandler
    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
      this.customRequestHandler(request);
    }
  },

  /**
   * Event recording metrics for a whole API call.
   * @returns {object} a subset of api call metrics
   * @api private
   */
  apiCallEvent: function apiCallEvent(request) {
    var api = request.service.api.operations[request.operation];
    var monitoringEvent = {
      Type: 'ApiCall',
      Api: api ? api.name : request.operation,
      Version: 1,
      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
      Region: request.httpRequest.region,
      MaxRetriesExceeded: 0,
      UserAgent: request.httpRequest.getUserAgent(),
    };
    var response = request.response;
    if (response.httpResponse.statusCode) {
      monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
    }
    if (response.error) {
      var error = response.error;
      var statusCode = response.httpResponse.statusCode;
      if (statusCode > 299) {
        if (error.code) monitoringEvent.FinalAwsException = error.code;
        if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
      } else {
        if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
        if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
      }
    }
    return monitoringEvent;
  },

  /**
   * Event recording metrics for an API call attempt.
   * @returns {object} a subset of api call attempt metrics
   * @api private
   */
  apiAttemptEvent: function apiAttemptEvent(request) {
    var api = request.service.api.operations[request.operation];
    var monitoringEvent = {
      Type: 'ApiCallAttempt',
      Api: api ? api.name : request.operation,
      Version: 1,
      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
      Fqdn: request.httpRequest.endpoint.hostname,
      UserAgent: request.httpRequest.getUserAgent(),
    };
    var response = request.response;
    if (response.httpResponse.statusCode) {
      monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
    }
    if (
      !request._unAuthenticated &&
      request.service.config.credentials &&
      request.service.config.credentials.accessKeyId
    ) {
      monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
    }
    if (!response.httpResponse.headers) return monitoringEvent;
    if (request.httpRequest.headers['x-amz-security-token']) {
      monitoringEvent.SessionToken = request.httpRequest.headers['x-amz-security-token'];
    }
    if (response.httpResponse.headers['x-amzn-requestid']) {
      monitoringEvent.XAmznRequestId = response.httpResponse.headers['x-amzn-requestid'];
    }
    if (response.httpResponse.headers['x-amz-request-id']) {
      monitoringEvent.XAmzRequestId = response.httpResponse.headers['x-amz-request-id'];
    }
    if (response.httpResponse.headers['x-amz-id-2']) {
      monitoringEvent.XAmzId2 = response.httpResponse.headers['x-amz-id-2'];
    }
    return monitoringEvent;
  },

  /**
   * Add metrics of failed request.
   * @api private
   */
  attemptFailEvent: function attemptFailEvent(request) {
    var monitoringEvent = this.apiAttemptEvent(request);
    var response = request.response;
    var error = response.error;
    if (response.httpResponse.statusCode > 299 ) {
      if (error.code) monitoringEvent.AwsException = error.code;
      if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
    } else {
      if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
      if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
    }
    return monitoringEvent;
  },

  /**
   * Attach listeners to request object to fetch metrics of each request
   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
   * @api private
   */
  attachMonitoringEmitter: function attachMonitoringEmitter(request) {
    var attemptTimestamp; //timestamp marking the beginning of a request attempt
    var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
    var attemptLatency; //latency from request sent out to http response reaching SDK
    var callStartRealTime; //Start time of API call. Used to calculating API call latency
    var attemptCount = 0; //request.retryCount is not reliable here
    var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
    var callTimestamp; //timestamp when the request is created
    var self = this;
    var addToHead = true;

    request.on('validate', function () {
      callStartRealTime = AWS.util.realClock.now();
      callTimestamp = Date.now();
    }, addToHead);
    request.on('sign', function () {
      attemptStartRealTime = AWS.util.realClock.now();
      attemptTimestamp = Date.now();
      region = request.httpRequest.region;
      attemptCount++;
    }, addToHead);
    request.on('validateResponse', function() {
      attemptLatency = Math.round(AWS.util.realClock.now() - attemptStartRealTime);
    });
    request.addNamedListener('API_CALL_ATTEMPT', 'success', function API_CALL_ATTEMPT() {
      var apiAttemptEvent = self.apiAttemptEvent(request);
      apiAttemptEvent.Timestamp = attemptTimestamp;
      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
      apiAttemptEvent.Region = region;
      self.emit('apiCallAttempt', [apiAttemptEvent]);
    });
    request.addNamedListener('API_CALL_ATTEMPT_RETRY', 'retry', function API_CALL_ATTEMPT_RETRY() {
      var apiAttemptEvent = self.attemptFailEvent(request);
      apiAttemptEvent.Timestamp = attemptTimestamp;
      //attemptLatency may not be available if fail before response
      attemptLatency = attemptLatency ||
        Math.round(AWS.util.realClock.now() - attemptStartRealTime);
      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
      apiAttemptEvent.Region = region;
      self.emit('apiCallAttempt', [apiAttemptEvent]);
    });
    request.addNamedListener('API_CALL', 'complete', function API_CALL() {
      var apiCallEvent = self.apiCallEvent(request);
      apiCallEvent.AttemptCount = attemptCount;
      if (apiCallEvent.AttemptCount <= 0) return;
      apiCallEvent.Timestamp = callTimestamp;
      var latency = Math.round(AWS.util.realClock.now() - callStartRealTime);
      apiCallEvent.Latency = latency >= 0 ? latency : 0;
      var response = request.response;
      if (
        typeof response.retryCount === 'number' &&
        typeof response.maxRetries === 'number' &&
        (response.retryCount >= response.maxRetries)
      ) {
        apiCallEvent.MaxRetriesExceeded = 1;
      }
      self.emit('apiCall', [apiCallEvent]);
    });
  },

  /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @method_abstract This is an abstract method.
   */
  setupRequestListeners: function setupRequestListeners(request) {
  },

  /**
   * Gets the signer class for a given request
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var version;
    // get operation authtype if present
    var operation = null;
    var authtype = '';
    if (request) {
      var operations = request.service.api.operations || {};
      operation = operations[request.operation] || null;
      authtype = operation ? operation.authtype : '';
    }
    if (this.config.signatureVersion) {
      version = this.config.signatureVersion;
    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
      version = 'v4';
    } else {
      version = this.api.signatureVersion;
    }
    return AWS.Signers.RequestSigner.getVersion(version);
  },

  /**
   * @api private
   */
  serviceInterface: function serviceInterface() {
    switch (this.api.protocol) {
      case 'ec2': return AWS.EventListeners.Query;
      case 'query': return AWS.EventListeners.Query;
      case 'json': return AWS.EventListeners.Json;
      case 'rest-json': return AWS.EventListeners.RestJson;
      case 'rest-xml': return AWS.EventListeners.RestXml;
    }
    if (this.api.protocol) {
      throw new Error('Invalid service `protocol\' ' +
        this.api.protocol + ' in API config');
    }
  },

  /**
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    return resp.httpResponse.statusCode < 300;
  },

  /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */
  numRetries: function numRetries() {
    if (this.config.maxRetries !== undefined) {
      return this.config.maxRetries;
    } else {
      return this.defaultRetryCount;
    }
  },

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
  },

  /**
   * @api private
   */
  retryableError: function retryableError(error) {
    if (this.timeoutError(error)) return true;
    if (this.networkingError(error)) return true;
    if (this.expiredCredentialsError(error)) return true;
    if (this.throttledError(error)) return true;
    if (error.statusCode >= 500) return true;
    return false;
  },

  /**
   * @api private
   */
  networkingError: function networkingError(error) {
    return error.code === 'NetworkingError';
  },

  /**
   * @api private
   */
  timeoutError: function timeoutError(error) {
    return error.code === 'TimeoutError';
  },

  /**
   * @api private
   */
  expiredCredentialsError: function expiredCredentialsError(error) {
    // TODO : this only handles *one* of the expired credential codes
    return (error.code === 'ExpiredTokenException');
  },

  /**
   * @api private
   */
  clockSkewError: function clockSkewError(error) {
    switch (error.code) {
      case 'RequestTimeTooSkewed':
      case 'RequestExpired':
      case 'InvalidSignatureException':
      case 'SignatureDoesNotMatch':
      case 'AuthFailure':
      case 'RequestInTheFuture':
        return true;
      default: return false;
    }
  },

  /**
   * @api private
   */
  getSkewCorrectedDate: function getSkewCorrectedDate() {
    return new Date(Date.now() + this.config.systemClockOffset);
  },

  /**
   * @api private
   */
  applyClockOffset: function applyClockOffset(newServerTime) {
    if (newServerTime) {
      this.config.systemClockOffset = newServerTime - Date.now();
    }
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(newServerTime) {
    if (newServerTime) {
      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
    }
  },

  /**
   * @api private
   */
  throttledError: function throttledError(error) {
    // this logic varies between services
    switch (error.code) {
      case 'ProvisionedThroughputExceededException':
      case 'Throttling':
      case 'ThrottlingException':
      case 'RequestLimitExceeded':
      case 'RequestThrottled':
      case 'RequestThrottledException':
      case 'TooManyRequestsException':
      case 'TransactionInProgressException': //dynamodb
        return true;
      default:
        return false;
    }
  },

  /**
   * @api private
   */
  endpointFromTemplate: function endpointFromTemplate(endpoint) {
    if (typeof endpoint !== 'string') return endpoint;

    var e = endpoint;
    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
    e = e.replace(/\{region\}/g, this.config.region);
    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
    return e;
  },

  /**
   * @api private
   */
  setEndpoint: function setEndpoint(endpoint) {
    this.endpoint = new AWS.Endpoint(endpoint, this.config);
  },

  /**
   * @api private
   */
  paginationConfig: function paginationConfig(operation, throwException) {
    var paginator = this.api.operations[operation].paginator;
    if (!paginator) {
      if (throwException) {
        var e = new Error();
        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
      }
      return null;
    }

    return paginator;
  }
});

AWS.util.update(AWS.Service, {

  /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */
  defineMethods: function defineMethods(svc) {
    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
      if (svc.prototype[method]) return;
      var operation = svc.prototype.api.operations[method];
      if (operation.authtype === 'none') {
        svc.prototype[method] = function (params, callback) {
          return this.makeUnauthenticatedRequest(method, params, callback);
        };
      } else {
        svc.prototype[method] = function (params, callback) {
          return this.makeRequest(method, params, callback);
        };
      }
    });
  },

  /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */
  defineService: function defineService(serviceIdentifier, versions, features) {
    AWS.Service._serviceMap[serviceIdentifier] = true;
    if (!Array.isArray(versions)) {
      features = versions;
      versions = [];
    }

    var svc = inherit(AWS.Service, features || {});

    if (typeof serviceIdentifier === 'string') {
      AWS.Service.addVersions(svc, versions);

      var identifier = svc.serviceIdentifier || serviceIdentifier;
      svc.serviceIdentifier = identifier;
    } else { // defineService called with an API
      svc.prototype.api = serviceIdentifier;
      AWS.Service.defineMethods(svc);
    }
    AWS.SequentialExecutor.call(this.prototype);
    //util.clientSideMonitoring is only available in node
    if (!this.prototype.publisher && AWS.util.clientSideMonitoring) {
      var Publisher = AWS.util.clientSideMonitoring.Publisher;
      var configProvider = AWS.util.clientSideMonitoring.configProvider;
      var publisherConfig = configProvider();
      this.prototype.publisher = new Publisher(publisherConfig);
      if (publisherConfig.enabled) {
        //if csm is enabled in environment, SDK should send all metrics
        AWS.Service._clientSideMonitoring = true;
      }
    }
    AWS.SequentialExecutor.call(svc.prototype);
    AWS.Service.addDefaultMonitoringListeners(svc.prototype);
    return svc;
  },

  /**
   * @api private
   */
  addVersions: function addVersions(svc, versions) {
    if (!Array.isArray(versions)) versions = [versions];

    svc.services = svc.services || {};
    for (var i = 0; i < versions.length; i++) {
      if (svc.services[versions[i]] === undefined) {
        svc.services[versions[i]] = null;
      }
    }

    svc.apiVersions = Object.keys(svc.services).sort();
  },

  /**
   * @api private
   */
  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
    var svc = inherit(superclass, {
      serviceIdentifier: superclass.serviceIdentifier
    });

    function setApi(api) {
      if (api.isApi) {
        svc.prototype.api = api;
      } else {
        svc.prototype.api = new Api(api);
      }
    }

    if (typeof version === 'string') {
      if (apiConfig) {
        setApi(apiConfig);
      } else {
        try {
          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
        } catch (err) {
          throw AWS.util.error(err, {
            message: 'Could not find API configuration ' +
              superclass.serviceIdentifier + '-' + version
          });
        }
      }
      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
      }
      superclass.services[version] = svc;
    } else {
      setApi(version);
    }

    AWS.Service.defineMethods(svc);
    return svc;
  },

  /**
   * @api private
   */
  hasService: function(identifier) {
    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
  },

  /**
   * @param attachOn attach default monitoring listeners to object
   *
   * Each monitoring event should be emitted from service client to service constructor prototype and then
   * to global service prototype like bubbling up. These default monitoring events listener will transfer
   * the monitoring events to the upper layer.
   * @api private
   */
  addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
    attachOn.addNamedListener('MONITOR_EVENTS_BUBBLE', 'apiCallAttempt', function EVENTS_BUBBLE(event) {
      var baseClass = Object.getPrototypeOf(attachOn);
      if (baseClass._events) baseClass.emit('apiCallAttempt', [event]);
    });
    attachOn.addNamedListener('CALL_EVENTS_BUBBLE', 'apiCall', function CALL_EVENTS_BUBBLE(event) {
      var baseClass = Object.getPrototypeOf(attachOn);
      if (baseClass._events) baseClass.emit('apiCall', [event]);
    });
  },

  /**
   * @api private
   */
  _serviceMap: {}
});

AWS.util.mixin(AWS.Service, AWS.SequentialExecutor);

/**
 * @api private
 */
module.exports = AWS.Service;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var regionConfig = __webpack_require__(1123);

function generateRegionPrefix(region) {
  if (!region) return null;

  var parts = region.split('-');
  if (parts.length < 3) return null;
  return parts.slice(0, parts.length - 2).join('-') + '-*';
}

function derivedKeys(service) {
  var region = service.config.region;
  var regionPrefix = generateRegionPrefix(region);
  var endpointPrefix = service.api.endpointPrefix;

  return [
    [region, endpointPrefix],
    [regionPrefix, endpointPrefix],
    [region, '*'],
    [regionPrefix, '*'],
    ['*', endpointPrefix],
    ['*', '*']
  ].map(function(item) {
    return item[0] && item[1] ? item.join('/') : null;
  });
}

function applyConfig(service, config) {
  util.each(config, function(key, value) {
    if (key === 'globalEndpoint') return;
    if (service.config[key] === undefined || service.config[key] === null) {
      service.config[key] = value;
    }
  });
}

function configureEndpoint(service) {
  var keys = derivedKeys(service);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!key) continue;

    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
      var config = regionConfig.rules[key];
      if (typeof config === 'string') {
        config = regionConfig.patterns[config];
      }

      // set dualstack endpoint
      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
        config = util.copy(config);
        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
      }

      // set global endpoint
      service.isGlobalEndpoint = !!config.globalEndpoint;

      // signature version
      if (!config.signatureVersion) config.signatureVersion = 'v4';

      // merge config
      applyConfig(service, config);
      return;
    }
  }
}

/**
 * @api private
 */
module.exports = configureEndpoint;


/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
__webpack_require__(503);
__webpack_require__(504);
var PromisesDependency;

/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
 *       and returns the amount of time to delay in milliseconds. The `base` option will be
 *       ignored if this option is supplied.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
 *       failing to establish a connection with the server after
 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
 *       connection has been established.
 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
 *       milliseconds of inactivity on the socket. Defaults to two minutes
 *       (120000)
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 *
 * @!attribute endpointDiscoveryEnabled
 *   @return [Boolean] whether to enable endpoint discovery for operations that
 *     allow optionally using an endpoint returned by the service.
 *     Defaults to 'false'
 *
 * @!attribute endpointCacheSize
 *   @return [Number] the size of the global cache storing endpoints from endpoint
 *     discovery operations. Once endpoint cache is created, updating this setting
 *     cannot change existing cache size.
 *     Defaults to 1000
 *
 * @!attribute hostPrefixEnabled
 *   @return [Boolean] whether to marshal request parameters to the prefix of
 *     hostname. Defaults to `true`.
 */
AWS.Config = AWS.util.inherit({
  /**
   * @!endgroup
   */

  /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
   *     and returns the amount of time to delay in milliseconds. The `base` option will be
   *     ignored if this option is supplied.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   * @option options useAccelerateEndpoint [Boolean] Whether to use the
   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
   * @option options clientSideMonitoring [Boolean] whether to collect and
   *   publish this client's performance metrics of all its API requests.
   * @option options endpointDiscoveryEnabled [Boolean] whether to enable endpoint
   *   discovery for operations that allow optionally using an endpoint returned by
   *   the service.
   *   Defaults to 'false'
   * @option options endpointCacheSize [Number] the size of the global cache storing
   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
   *   updating this setting cannot change existing cache size.
   *   Defaults to 1000
   * @option options hostPrefixEnabled [Boolean] whether to marshal request
   *   parameters to the prefix of hostname.
   *   Defaults to `true`.
   */
  constructor: function Config(options) {
    if (options === undefined) options = {};
    options = this.extractCredentials(options);

    AWS.util.each.call(this, this.keys, function (key, value) {
      this.set(key, options[key], value);
    });
  },

  /**
   * @!group Managing Credentials
   */

  /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */
  getCredentials: function getCredentials(callback) {
    var self = this;

    function finish(err) {
      callback(err, err ? null : self.credentials);
    }

    function credError(msg, err) {
      return new AWS.util.error(err || new Error(), {
        code: 'CredentialsError',
        message: msg,
        name: 'CredentialsError'
      });
    }

    function getAsyncCredentials() {
      self.credentials.get(function(err) {
        if (err) {
          var msg = 'Could not load credentials from ' +
            self.credentials.constructor.name;
          err = credError(msg, err);
        }
        finish(err);
      });
    }

    function getStaticCredentials() {
      var err = null;
      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
        err = credError('Missing credentials');
      }
      finish(err);
    }

    if (self.credentials) {
      if (typeof self.credentials.get === 'function') {
        getAsyncCredentials();
      } else { // static credentials
        getStaticCredentials();
      }
    } else if (self.credentialProvider) {
      self.credentialProvider.resolve(function(err, creds) {
        if (err) {
          err = credError('Could not load credentials from any providers', err);
        }
        self.credentials = creds;
        finish(err);
      });
    } else {
      finish(credError('No credentials to load'));
    }
  },

  /**
   * @!group Loading and Setting Configuration Options
   */

  /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */
  update: function update(options, allowUnknownKeys) {
    allowUnknownKeys = allowUnknownKeys || false;
    options = this.extractCredentials(options);
    AWS.util.each.call(this, options, function (key, value) {
      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
          AWS.Service.hasService(key)) {
        this.set(key, value);
      }
    });
  },

  /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */
  loadFromPath: function loadFromPath(path) {
    this.clear();

    var options = JSON.parse(AWS.util.readFileSync(path));
    var fileSystemCreds = new AWS.FileSystemCredentials(path);
    var chain = new AWS.CredentialProviderChain();
    chain.providers.unshift(fileSystemCreds);
    chain.resolve(function (err, creds) {
      if (err) throw err;
      else options.credentials = creds;
    });

    this.constructor(options);

    return this;
  },

  /**
   * Clears configuration data on this object
   *
   * @api private
   */
  clear: function clear() {
    /*jshint forin:false */
    AWS.util.each.call(this, this.keys, function (key) {
      delete this[key];
    });

    // reset credential provider
    this.set('credentials', undefined);
    this.set('credentialProvider', undefined);
  },

  /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */
  set: function set(property, value, defaultValue) {
    if (value === undefined) {
      if (defaultValue === undefined) {
        defaultValue = this.keys[property];
      }
      if (typeof defaultValue === 'function') {
        this[property] = defaultValue.call(this);
      } else {
        this[property] = defaultValue;
      }
    } else if (property === 'httpOptions' && this[property]) {
      // deep merge httpOptions
      this[property] = AWS.util.merge(this[property], value);
    } else {
      this[property] = value;
    }
  },

  /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */
  keys: {
    credentials: null,
    credentialProvider: null,
    region: null,
    logger: null,
    apiVersions: {},
    apiVersion: null,
    endpoint: undefined,
    httpOptions: {
      timeout: 120000
    },
    maxRetries: undefined,
    maxRedirects: 10,
    paramValidation: true,
    sslEnabled: true,
    s3ForcePathStyle: false,
    s3BucketEndpoint: false,
    s3DisableBodySigning: true,
    computeChecksums: true,
    convertResponseTypes: true,
    correctClockSkew: false,
    customUserAgent: null,
    dynamoDbCrc32: true,
    systemClockOffset: 0,
    signatureVersion: null,
    signatureCache: true,
    retryDelayOptions: {},
    useAccelerateEndpoint: false,
    clientSideMonitoring: false,
    endpointDiscoveryEnabled: false,
    endpointCacheSize: 1000,
    hostPrefixEnabled: true
  },

  /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */
  extractCredentials: function extractCredentials(options) {
    if (options.accessKeyId && options.secretAccessKey) {
      options = AWS.util.copy(options);
      options.credentials = new AWS.Credentials(options);
    }
    return options;
  },

  /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */
  setPromisesDependency: function setPromisesDependency(dep) {
    PromisesDependency = dep;
    // if null was passed in, we should try to use native promises
    if (dep === null && typeof Promise === 'function') {
      PromisesDependency = Promise;
    }
    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
    AWS.util.addPromises(constructors, PromisesDependency);
  },

  /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */
  getPromisesDependency: function getPromisesDependency() {
    return PromisesDependency;
  }
});

/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */
AWS.config = new AWS.Config();


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var SequentialExecutor = __webpack_require__(502);
var DISCOVER_ENDPOINT = __webpack_require__(1126).discoverEndpoint;
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */
AWS.EventListeners = {
  /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */
  Core: {} /* doc hack */
};

/**
 * @api private
 */
function getOperationAuthtype(req) {
  if (!req.service.api.operations) {
    return '';
  }
  var operation = req.service.api.operations[req.operation];
  return operation ? operation.authtype : '';
}

AWS.EventListeners = {
  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
    addAsync('VALIDATE_CREDENTIALS', 'validate',
        function VALIDATE_CREDENTIALS(req, done) {
      if (!req.service.api.signatureVersion) return done(); // none
      req.service.config.getCredentials(function(err) {
        if (err) {
          req.response.error = AWS.util.error(err,
            {code: 'CredentialsError', message: 'Missing credentials in config'});
        }
        done();
      });
    });

    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
        req.response.error = AWS.util.error(new Error(),
          {code: 'ConfigError', message: 'Missing region in config'});
      }
    });

    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      if (!operation) {
        return;
      }
      var idempotentMembers = operation.idempotentMembers;
      if (!idempotentMembers.length) {
        return;
      }
      // creates a copy of params so user's param object isn't mutated
      var params = AWS.util.copy(req.params);
      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
        if (!params[idempotentMembers[i]]) {
          // add the member
          params[idempotentMembers[i]] = AWS.util.uuid.v4();
        }
      }
      req.params = params;
    });

    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var rules = req.service.api.operations[req.operation].input;
      var validation = req.service.config.paramValidation;
      new AWS.ParamValidator(validation).validate(rules, req.params);
    });

    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
      req.haltHandlersOnError();
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!req.service.api.signatureVersion && !authtype) return done(); // none
      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
        var body = req.httpRequest.body || '';
        if (authtype.indexOf('unsigned-body') >= 0) {
          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
          return done();
        }
        AWS.util.computeSha256(body, function(err, sha) {
          if (err) {
            done(err);
          }
          else {
            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
            done();
          }
        });
      } else {
        done();
      }
    });

    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
      var authtype = getOperationAuthtype(req);
      var payloadMember = AWS.util.getRequestPayloadShape(req);
      if (req.httpRequest.headers['Content-Length'] === undefined) {
        try {
          var length = AWS.util.string.byteLength(req.httpRequest.body);
          req.httpRequest.headers['Content-Length'] = length;
        } catch (err) {
          if (payloadMember && payloadMember.isStreaming) {
            if (payloadMember.requiresLength) {
              //streaming payload requires length(s3, glacier)
              throw err;
            } else if (authtype.indexOf('unsigned-body') >= 0) {
              //unbounded streaming payload(lex, mediastore)
              req.httpRequest.headers['Transfer-Encoding'] = 'chunked';
              return;
            } else {
              throw err;
            }
          }
          throw err;
        }
      }
    });

    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
    });

    add('RESTART', 'restart', function RESTART() {
      var err = this.response.error;
      if (!err || !err.retryable) return;

      this.httpRequest = new AWS.HttpRequest(
        this.service.endpoint,
        this.service.region
      );

      if (this.response.retryCount < this.service.config.maxRetries) {
        this.response.retryCount++;
      } else {
        this.response.error = null;
      }
    });

    var addToHead = true;
    addAsync('DISCOVER_ENDPOINT', 'sign', DISCOVER_ENDPOINT, addToHead);

    addAsync('SIGN', 'sign', function SIGN(req, done) {
      var service = req.service;
      var operations = req.service.api.operations || {};
      var operation = operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!service.api.signatureVersion && !authtype) return done(); // none

      service.config.getCredentials(function (err, credentials) {
        if (err) {
          req.response.error = err;
          return done();
        }

        try {
          var date = service.getSkewCorrectedDate();
          var SignerClass = service.getSignerClass(req);
          var signer = new SignerClass(req.httpRequest,
            service.api.signingName || service.api.endpointPrefix,
            {
              signatureCache: service.config.signatureCache,
              operation: operation,
              signatureVersion: service.api.signatureVersion
            });
          signer.setServiceClientId(service._clientId);

          // clear old authorization headers
          delete req.httpRequest.headers['Authorization'];
          delete req.httpRequest.headers['Date'];
          delete req.httpRequest.headers['X-Amz-Date'];

          // add new authorization
          signer.addAuthorization(credentials, date);
          req.signedAt = date;
        } catch (e) {
          req.response.error = e;
        }
        done();
      });
    });

    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
      if (this.service.successfulResponse(resp, this)) {
        resp.data = {};
        resp.error = null;
      } else {
        resp.data = null;
        resp.error = AWS.util.error(new Error(),
          {code: 'UnknownError', message: 'An unknown error occurred.'});
      }
    });

    addAsync('SEND', 'send', function SEND(resp, done) {
      resp.httpResponse._abortCallback = done;
      resp.error = null;
      resp.data = null;

      function callback(httpResp) {
        resp.httpResponse.stream = httpResp;
        var stream = resp.request.httpRequest.stream;
        var service = resp.request.service;
        var api = service.api;
        var operationName = resp.request.operation;
        var operation = api.operations[operationName] || {};

        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
          resp.request.emit(
            'httpHeaders',
            [statusCode, headers, resp, statusMessage]
          );

          if (!resp.httpResponse.streaming) {
            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
              // if we detect event streams, we're going to have to
              // return the stream immediately
              if (operation.hasEventOutput && service.successfulResponse(resp)) {
                // skip reading the IncomingStream
                resp.request.emit('httpDone');
                done();
                return;
              }

              httpResp.on('readable', function onReadable() {
                var data = httpResp.read();
                if (data !== null) {
                  resp.request.emit('httpData', [data, resp]);
                }
              });
            } else { // legacy streams API
              httpResp.on('data', function onData(data) {
                resp.request.emit('httpData', [data, resp]);
              });
            }
          }
        });

        httpResp.on('end', function onEnd() {
          if (!stream || !stream.didCallback) {
            if (AWS.HttpClient.streamsApiVersion === 2 && (operation.hasEventOutput && service.successfulResponse(resp))) {
              // don't concatenate response chunks when streaming event stream data when response is successful
              return;
            }
            resp.request.emit('httpDone');
            done();
          }
        });
      }

      function progress(httpResp) {
        httpResp.on('sendProgress', function onSendProgress(value) {
          resp.request.emit('httpUploadProgress', [value, resp]);
        });

        httpResp.on('receiveProgress', function onReceiveProgress(value) {
          resp.request.emit('httpDownloadProgress', [value, resp]);
        });
      }

      function error(err) {
        if (err.code !== 'RequestAbortedError') {
          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
          err = AWS.util.error(err, {
            code: errCode,
            region: resp.request.httpRequest.region,
            hostname: resp.request.httpRequest.endpoint.hostname,
            retryable: true
          });
        }
        resp.error = err;
        resp.request.emit('httpError', [resp.error, resp], function() {
          done();
        });
      }

      function executeSend() {
        var http = AWS.HttpClient.getInstance();
        var httpOptions = resp.request.service.config.httpOptions || {};
        try {
          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
                                          callback, error);
          progress(stream);
        } catch (err) {
          error(err);
        }
      }
      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
        this.emit('sign', [this], function(err) {
          if (err) done(err);
          else executeSend();
        });
      } else {
        executeSend();
      }
    });

    add('HTTP_HEADERS', 'httpHeaders',
        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
      resp.httpResponse.statusCode = statusCode;
      resp.httpResponse.statusMessage = statusMessage;
      resp.httpResponse.headers = headers;
      resp.httpResponse.body = AWS.util.buffer.toBuffer('');
      resp.httpResponse.buffers = [];
      resp.httpResponse.numBytes = 0;
      var dateHeader = headers.date || headers.Date;
      var service = resp.request.service;
      if (dateHeader) {
        var serverTime = Date.parse(dateHeader);
        if (service.config.correctClockSkew
            && service.isClockSkewed(serverTime)) {
          service.applyClockOffset(serverTime);
        }
      }
    });

    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
      if (chunk) {
        if (AWS.util.isNode()) {
          resp.httpResponse.numBytes += chunk.length;

          var total = resp.httpResponse.headers['content-length'];
          var progress = { loaded: resp.httpResponse.numBytes, total: total };
          resp.request.emit('httpDownloadProgress', [progress, resp]);
        }

        resp.httpResponse.buffers.push(AWS.util.buffer.toBuffer(chunk));
      }
    });

    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
      // convert buffers array into single buffer
      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
        resp.httpResponse.body = body;
      }
      delete resp.httpResponse.numBytes;
      delete resp.httpResponse.buffers;
    });

    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
      if (resp.httpResponse.statusCode) {
        resp.error.statusCode = resp.httpResponse.statusCode;
        if (resp.error.retryable === undefined) {
          resp.error.retryable = this.service.retryableError(resp.error, this);
        }
      }
    });

    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
      if (!resp.error) return;
      switch (resp.error.code) {
        case 'RequestExpired': // EC2 only
        case 'ExpiredTokenException':
        case 'ExpiredToken':
          resp.error.retryable = true;
          resp.request.service.config.credentials.expired = true;
      }
    });

    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
      var err = resp.error;
      if (!err) return;
      if (typeof err.code === 'string' && typeof err.message === 'string') {
        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
          resp.error.retryable = true;
        }
      }
    });

    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
      if (!resp.error) return;
      if (this.service.clockSkewError(resp.error)
          && this.service.config.correctClockSkew) {
        resp.error.retryable = true;
      }
    });

    add('REDIRECT', 'retry', function REDIRECT(resp) {
      if (resp.error && resp.error.statusCode >= 300 &&
          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
        this.httpRequest.endpoint =
          new AWS.Endpoint(resp.httpResponse.headers['location']);
        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
        resp.error.redirect = true;
        resp.error.retryable = true;
      }
    });

    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
      if (resp.error) {
        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.error.retryDelay = 0;
        } else if (resp.retryCount < resp.maxRetries) {
          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
        }
      }
    });

    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
      var delay, willRetry = false;

      if (resp.error) {
        delay = resp.error.retryDelay || 0;
        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
          resp.retryCount++;
          willRetry = true;
        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.redirectCount++;
          willRetry = true;
        }
      }

      if (willRetry) {
        resp.error = null;
        setTimeout(done, delay);
      } else {
        done();
      }
    });
  }),

  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);

    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
        var message = 'Inaccessible host: `' + err.hostname +
          '\'. This service may not be available in the `' + err.region +
          '\' region.';
        this.response.error = AWS.util.error(new Error(message), {
          code: 'UnknownEndpoint',
          region: err.region,
          hostname: err.hostname,
          retryable: true,
          originalError: err
        });
      }
    });
  }),

  Logger: new SequentialExecutor().addNamedListeners(function(add) {
    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
      var req = resp.request;
      var logger = req.service.config.logger;
      if (!logger) return;
      function filterSensitiveLog(inputShape, shape) {
        if (!shape) {
          return shape;
        }
        switch (inputShape.type) {
          case 'structure':
            var struct = {};
            AWS.util.each(shape, function(subShapeName, subShape) {
              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
              } else {
                struct[subShapeName] = subShape;
              }
            });
            return struct;
          case 'list':
            var list = [];
            AWS.util.arrayEach(shape, function(subShape, index) {
              list.push(filterSensitiveLog(inputShape.member, subShape));
            });
            return list;
          case 'map':
            var map = {};
            AWS.util.each(shape, function(key, value) {
              map[key] = filterSensitiveLog(inputShape.value, value);
            });
            return map;
          default:
            if (inputShape.isSensitive) {
              return '***SensitiveInformation***';
            } else {
              return shape;
            }
        }
      }

      function buildMessage() {
        var time = resp.request.service.getSkewCorrectedDate().getTime();
        var delta = (time - req.startTime.getTime()) / 1000;
        var ansi = logger.isTTY ? true : false;
        var status = resp.httpResponse.statusCode;
        var censoredParams = req.params;
        if (
          req.service.api.operations &&
              req.service.api.operations[req.operation] &&
              req.service.api.operations[req.operation].input
        ) {
          var inputShape = req.service.api.operations[req.operation].input;
          censoredParams = filterSensitiveLog(inputShape, req.params);
        }
        var params = __webpack_require__(1127).inspect(censoredParams, true, null);
        var message = '';
        if (ansi) message += '\x1B[33m';
        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
        if (ansi) message += '\x1B[0;1m';
        message += ' ' + AWS.util.string.lowerFirst(req.operation);
        message += '(' + params + ')';
        if (ansi) message += '\x1B[0m';
        return message;
      }

      var line = buildMessage();
      if (typeof logger.log === 'function') {
        logger.log(line);
      } else if (typeof logger.write === 'function') {
        logger.write(line + '\n');
      }
    });
  }),

  Json: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(278);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Rest: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(199);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(496);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(497);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Query: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(494);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  })
};


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var util = __webpack_require__(31);
var endpointDiscoveryEnabledEnvs = ['AWS_ENABLE_ENDPOINT_DISCOVERY', 'AWS_ENDPOINT_DISCOVERY_ENABLED'];

/**
 * Generate key (except resources and operation part) to index the endpoints in the cache
 * If input shape has endpointdiscoveryid trait then use
 *   accessKey + operation + resources + region + service as cache key
 * If input shape doesn't have endpointdiscoveryid trait then use
 *   accessKey + region + service as cache key
 * @return [map<String,String>] object with keys to index endpoints.
 * @api private
 */
function getCacheKey(request) {
  var service = request.service;
  var api = service.api || {};
  var operations = api.operations;
  var identifiers = {};
  if (service.config.region) {
    identifiers.region = service.config.region;
  }
  if (api.serviceId) {
    identifiers.serviceId = api.serviceId;
  }
  if (service.config.credentials.accessKeyId) {
    identifiers.accessKeyId = service.config.credentials.accessKeyId;
  }
  return identifiers;
}

/**
 * Recursive helper for marshallCustomIdentifiers().
 * Looks for required string input members that have 'endpointdiscoveryid' trait.
 * @api private
 */
function marshallCustomIdentifiersHelper(result, params, shape) {
  if (!shape || params === undefined || params === null) return;
  if (shape.type === 'structure' && shape.required && shape.required.length > 0) {
    util.arrayEach(shape.required, function(name) {
      var memberShape = shape.members[name];
      if (memberShape.endpointDiscoveryId === true) {
        var locationName = memberShape.isLocationName ? memberShape.name : name;
        result[locationName] = String(params[name]);
      } else {
        marshallCustomIdentifiersHelper(result, params[name], memberShape);
      }
    });
  }
}

/**
 * Get custom identifiers for cache key.
 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
 * @param [object] request object
 * @param [object] input shape of the given operation's api
 * @api private
 */
function marshallCustomIdentifiers(request, shape) {
  var identifiers = {};
  marshallCustomIdentifiersHelper(identifiers, request.params, shape);
  return identifiers;
}

/**
 * Call endpoint discovery operation when it's optional.
 * When endpoint is available in cache then use the cached endpoints. If endpoints
 * are unavailable then use regional endpoints and call endpoint discovery operation
 * asynchronously. This is turned off by default.
 * @param [object] request object
 * @api private
 */
function optionalDiscoverEndpoint(request) {
  var service = request.service;
  var api = service.api;
  var operationModel = api.operations ? api.operations[request.operation] : undefined;
  var inputShape = operationModel ? operationModel.input : undefined;

  var identifiers = marshallCustomIdentifiers(request, inputShape);
  var cacheKey = getCacheKey(request);
  if (Object.keys(identifiers).length > 0) {
    cacheKey = util.update(cacheKey, identifiers);
    if (operationModel) cacheKey.operation = operationModel.name;
  }
  var endpoints = AWS.endpointCache.get(cacheKey);
  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
    //endpoint operation is being made but response not yet received
    //or endpoint operation just failed in 1 minute
    return;
  } else if (endpoints && endpoints.length > 0) {
    //found endpoint record from cache
    request.httpRequest.updateEndpoint(endpoints[0].Address);
  } else {
    //endpoint record not in cache or outdated. make discovery operation
    var endpointRequest = service.makeRequest(api.endpointOperation, {
      Operation: operationModel.name,
      Identifiers: identifiers,
    });
    addApiVersionHeader(endpointRequest);
    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    endpointRequest.removeListener('retry', AWS.EventListeners.Core.RETRY_CHECK);
    //put in a placeholder for endpoints already requested, prevent
    //too much in-flight calls
    AWS.endpointCache.put(cacheKey, [{
      Address: '',
      CachePeriodInMinutes: 1
    }]);
    endpointRequest.send(function(err, data) {
      if (data && data.Endpoints) {
        AWS.endpointCache.put(cacheKey, data.Endpoints);
      } else if (err) {
        AWS.endpointCache.put(cacheKey, [{
          Address: '',
          CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
        }]);
      }
    });
  }
}

var requestQueue = {};

/**
 * Call endpoint discovery operation when it's required.
 * When endpoint is available in cache then use cached ones. If endpoints are
 * unavailable then SDK should call endpoint operation then use returned new
 * endpoint for the api call. SDK will automatically attempt to do endpoint
 * discovery. This is turned off by default
 * @param [object] request object
 * @api private
 */
function requiredDiscoverEndpoint(request, done) {
  var service = request.service;
  var api = service.api;
  var operationModel = api.operations ? api.operations[request.operation] : undefined;
  var inputShape = operationModel ? operationModel.input : undefined;

  var identifiers = marshallCustomIdentifiers(request, inputShape);
  var cacheKey = getCacheKey(request);
  if (Object.keys(identifiers).length > 0) {
    cacheKey = util.update(cacheKey, identifiers);
    if (operationModel) cacheKey.operation = operationModel.name;
  }
  var cacheKeyStr = AWS.EndpointCache.getKeyString(cacheKey);
  var endpoints = AWS.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
    //endpoint operation is being made but response not yet received
    //push request object to a pending queue
    if (!requestQueue[cacheKeyStr]) requestQueue[cacheKeyStr] = [];
    requestQueue[cacheKeyStr].push({request: request, callback: done});
    return;
  } else if (endpoints && endpoints.length > 0) {
    request.httpRequest.updateEndpoint(endpoints[0].Address);
    done();
  } else {
    var endpointRequest = service.makeRequest(api.endpointOperation, {
      Operation: operationModel.name,
      Identifiers: identifiers,
    });
    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    addApiVersionHeader(endpointRequest);

    //put in a placeholder for endpoints already requested, prevent
    //too much in-flight calls
    AWS.endpointCache.put(cacheKeyStr, [{
      Address: '',
      CachePeriodInMinutes: 60 //long-live cache
    }]);
    endpointRequest.send(function(err, data) {
      if (err) {
        var errorParams = {
          code: 'EndpointDiscoveryException',
          message: 'Request cannot be fulfilled without specifying an endpoint',
          retryable: false
        };
        request.response.error = util.error(err, errorParams);
        AWS.endpointCache.remove(cacheKey);

        //fail all the pending requests in batch
        if (requestQueue[cacheKeyStr]) {
          var pendingRequests = requestQueue[cacheKeyStr];
          util.arrayEach(pendingRequests, function(requestContext) {
            requestContext.request.response.error = util.error(err, errorParams);
            requestContext.callback();
          });
          delete requestQueue[cacheKeyStr];
        }
      } else if (data) {
        AWS.endpointCache.put(cacheKeyStr, data.Endpoints);
        request.httpRequest.updateEndpoint(data.Endpoints[0].Address);

        //update the endpoint for all the pending requests in batch
        if (requestQueue[cacheKeyStr]) {
          var pendingRequests = requestQueue[cacheKeyStr];
          util.arrayEach(pendingRequests, function(requestContext) {
            requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
            requestContext.callback();
          });
          delete requestQueue[cacheKeyStr];
        }
      }
      done();
    });
  }
}

/**
 * add api version header to endpoint operation
 * @api private
 */
function addApiVersionHeader(endpointRequest) {
  var api = endpointRequest.service.api;
  var apiVersion = api.apiVersion;
  if (apiVersion && !endpointRequest.httpRequest.headers['x-amz-api-version']) {
    endpointRequest.httpRequest.headers['x-amz-api-version'] = apiVersion;
  }
}

/**
 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
 * endpoint from cache.
 * @api private
 */
function invalidateCachedEndpoints(response) {
  var error = response.error;
  var httpResponse = response.httpResponse;
  if (error &&
    (error.code === 'InvalidEndpointException' || httpResponse.statusCode === 421)
  ) {
    var request = response.request;
    var operations = request.service.api.operations || {};
    var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
    var identifiers = marshallCustomIdentifiers(request, inputShape);
    var cacheKey = getCacheKey(request);
    if (Object.keys(identifiers).length > 0) {
      cacheKey = util.update(cacheKey, identifiers);
      if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
    }
    AWS.endpointCache.remove(cacheKey);
  }
}

/**
 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
 * @param [object] client Service client object.
 * @api private
 */
function hasCustomEndpoint(client) {
  //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
  if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) {
    throw util.error(new Error(), {
      code: 'ConfigurationException',
      message: 'Custom endpoint is supplied; endpointDiscoveryEnabled must not be true.'
    });
  };
  var svcConfig = AWS.config[client.serviceIdentifier] || {};
  return Boolean(AWS.config.endpoint || svcConfig.endpoint || (client._originalConfig && client._originalConfig.endpoint));
}

/**
 * @api private
 */
function isFalsy(value) {
  return ['false', '0'].indexOf(value) >= 0;
}

/**
 * If endpoint discovery should perform for this request when endpoint discovery is optional.
 * SDK performs config resolution in order like below:
 * 1. If turned on client configuration(default to off) then turn on endpoint discovery.
 * 2. If turned on in env AWS_ENABLE_ENDPOINT_DISCOVERY then turn on endpoint discovery.
 * 3. If turned on in shared ini config file with key 'endpoint_discovery_enabled', then
 *   turn on endpoint discovery.
 * @param [object] request request object.
 * @api private
 */
function isEndpointDiscoveryApplicable(request) {
  var service = request.service || {};
  if (service.config.endpointDiscoveryEnabled === true) return true;

  //shared ini file is only available in Node
  //not to check env in browser
  if (util.isBrowser()) return false;

  for (var i = 0; i < endpointDiscoveryEnabledEnvs.length; i++) {
    var env = endpointDiscoveryEnabledEnvs[i];
    if (Object.prototype.hasOwnProperty.call(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}), env)) {
      if (Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[env] === '' || Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[env] === undefined) {
        throw util.error(new Error(), {
          code: 'ConfigurationException',
          message: 'environmental variable ' + env + ' cannot be set to nothing'
        });
      }
      if (!isFalsy(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[env])) return true;
    }
  }

  var configFile = {};
  try {
    configFile = AWS.util.iniLoader ? AWS.util.iniLoader.loadFrom({
      isConfig: true,
      filename: Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}})[AWS.util.sharedConfigFileEnv]
    }) : {};
  } catch (e) {}
  var sharedFileConfig = configFile[
    Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).AWS_PROFILE || AWS.util.defaultProfile
  ] || {};
  if (Object.prototype.hasOwnProperty.call(sharedFileConfig, 'endpoint_discovery_enabled')) {
    if (sharedFileConfig.endpoint_discovery_enabled === undefined) {
      throw util.error(new Error(), {
        code: 'ConfigurationException',
        message: 'config file entry \'endpoint_discovery_enabled\' cannot be set to nothing'
      });
    }
    if (!isFalsy(sharedFileConfig.endpoint_discovery_enabled)) return true;
  }
  return false;
}

/**
 * attach endpoint discovery logic to request object
 * @param [object] request
 * @api private
 */
function discoverEndpoint(request, done) {
  var service = request.service || {};
  if (hasCustomEndpoint(service) || request.isPresigned()) return done();

  if (!isEndpointDiscoveryApplicable(request)) return done();

  request.httpRequest.appendToUserAgent('endpoint-discovery');

  var operations = service.api.operations || {};
  var operationModel = operations[request.operation];
  var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : 'NULL';
  switch (isEndpointDiscoveryRequired) {
    case 'OPTIONAL':
      optionalDiscoverEndpoint(request);
      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
      done();
      break;
    case 'REQUIRED':
      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
      requiredDiscoverEndpoint(request, done);
      break;
    case 'NULL':
    default:
      done();
      break;
  }
}

module.exports = {
  discoverEndpoint: discoverEndpoint,
  requiredDiscoverEndpoint: requiredDiscoverEndpoint,
  optionalDiscoverEndpoint: optionalDiscoverEndpoint,
  marshallCustomIdentifiers: marshallCustomIdentifiers,
  getCacheKey: getCacheKey,
  invalidateCachedEndpoint: invalidateCachedEndpoints,
};


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1128);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1129);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(13);
var AcceptorStateMachine = __webpack_require__(1131);
var inherit = AWS.util.inherit;
var domain = AWS.util.domain;
var jmespath = __webpack_require__(282);

/**
 * @api private
 */
var hardErrorStates = {success: 1, error: 1, complete: 1};

function isTerminalState(machine) {
  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
}

var fsm = new AcceptorStateMachine();
fsm.setupStates = function() {
  var transition = function(_, done) {
    var self = this;
    self._haltHandlersOnError = false;

    self.emit(self._asm.currentState, function(err) {
      if (err) {
        if (isTerminalState(self)) {
          if (domain && self.domain instanceof domain.Domain) {
            err.domainEmitter = self;
            err.domain = self.domain;
            err.domainThrown = false;
            self.domain.emit('error', err);
          } else {
            throw err;
          }
        } else {
          self.response.error = err;
          done(err);
        }
      } else {
        done(self.response.error);
      }
    });

  };

  this.addState('validate', 'build', 'error', transition);
  this.addState('build', 'afterBuild', 'restart', transition);
  this.addState('afterBuild', 'sign', 'restart', transition);
  this.addState('sign', 'send', 'retry', transition);
  this.addState('retry', 'afterRetry', 'afterRetry', transition);
  this.addState('afterRetry', 'sign', 'error', transition);
  this.addState('send', 'validateResponse', 'retry', transition);
  this.addState('validateResponse', 'extractData', 'extractError', transition);
  this.addState('extractError', 'extractData', 'retry', transition);
  this.addState('extractData', 'success', 'retry', transition);
  this.addState('restart', 'build', 'error', transition);
  this.addState('success', 'complete', 'complete', transition);
  this.addState('error', 'complete', 'complete', transition);
  this.addState('complete', null, null, transition);
};
fsm.setupStates();

/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(error, response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */
AWS.Request = inherit({

  /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */
  constructor: function Request(service, operation, params) {
    var endpoint = service.endpoint;
    var region = service.config.region;
    var customUserAgent = service.config.customUserAgent;

    // global endpoints sign as us-east-1
    if (service.isGlobalEndpoint) region = 'us-east-1';

    this.domain = domain && domain.active;
    this.service = service;
    this.operation = operation;
    this.params = params || {};
    this.httpRequest = new AWS.HttpRequest(endpoint, region);
    this.httpRequest.appendToUserAgent(customUserAgent);
    this.startTime = service.getSkewCorrectedDate();

    this.response = new AWS.Response(this);
    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
    this._haltHandlersOnError = false;

    AWS.SequentialExecutor.call(this);
    this.emit = this.emitEvent;
  },

  /**
   * @!group Sending a Request
   */

  /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */
  send: function send(callback) {
    if (callback) {
      // append to user agent
      this.httpRequest.appendToUserAgent('callback');
      this.on('complete', function (resp) {
        callback.call(resp, resp.error, resp.data);
      });
    }
    this.runTo();

    return this.response;
  },

  /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */

  /**
   * @api private
   */
  build: function build(callback) {
    return this.runTo('send', callback);
  },

  /**
   * @api private
   */
  runTo: function runTo(state, done) {
    this._asm.runTo(state, done, this);
    return this;
  },

  /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */
  abort: function abort() {
    this.removeAllListeners('validateResponse');
    this.removeAllListeners('extractError');
    this.on('validateResponse', function addAbortedError(resp) {
      resp.error = AWS.util.error(new Error('Request aborted by user'), {
         code: 'RequestAbortedError', retryable: false
      });
    });

    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
      this.httpRequest.stream.abort();
      if (this.httpRequest._abortCallback) {
         this.httpRequest._abortCallback();
      } else {
        this.removeAllListeners('send'); // haven't sent yet, so let's not
      }
    }

    return this;
  },

  /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */
  eachPage: function eachPage(callback) {
    // Make all callbacks async-ish
    callback = AWS.util.fn.makeAsync(callback, 3);

    function wrappedCallback(response) {
      callback.call(response, response.error, response.data, function (result) {
        if (result === false) return;

        if (response.hasNextPage()) {
          response.nextPage().on('complete', wrappedCallback).send();
        } else {
          callback.call(response, null, null, AWS.util.fn.noop);
        }
      });
    }

    this.on('complete', wrappedCallback).send();
  },

  /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */
  eachItem: function eachItem(callback) {
    var self = this;
    function wrappedCallback(err, data) {
      if (err) return callback(err, null);
      if (data === null) return callback(null, null);

      var config = self.service.paginationConfig(self.operation);
      var resultKey = config.resultKey;
      if (Array.isArray(resultKey)) resultKey = resultKey[0];
      var items = jmespath.search(data, resultKey);
      var continueIteration = true;
      AWS.util.arrayEach(items, function(item) {
        continueIteration = callback(null, item);
        if (continueIteration === false) {
          return AWS.util.abort;
        }
      });
      return continueIteration;
    }

    this.eachPage(wrappedCallback);
  },

  /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */
  isPageable: function isPageable() {
    return this.service.paginationConfig(this.operation) ? true : false;
  },

  /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */
  createReadStream: function createReadStream() {
    var streams = AWS.util.stream;
    var req = this;
    var stream = null;

    if (AWS.HttpClient.streamsApiVersion === 2) {
      stream = new streams.PassThrough();
      process.nextTick(function() { req.send(); });
    } else {
      stream = new streams.Stream();
      stream.readable = true;

      stream.sent = false;
      stream.on('newListener', function(event) {
        if (!stream.sent && event === 'data') {
          stream.sent = true;
          process.nextTick(function() { req.send(); });
        }
      });
    }

    this.on('error', function(err) {
      stream.emit('error', err);
    });

    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
      if (statusCode < 300) {
        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
        req.on('httpError', function streamHttpError(error) {
          resp.error = error;
          resp.error.retryable = false;
        });

        var shouldCheckContentLength = false;
        var expectedLen;
        if (req.httpRequest.method !== 'HEAD') {
          expectedLen = parseInt(headers['content-length'], 10);
        }
        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
          shouldCheckContentLength = true;
          var receivedLen = 0;
        }

        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
          if (shouldCheckContentLength && receivedLen !== expectedLen) {
            stream.emit('error', AWS.util.error(
              new Error('Stream content length mismatch. Received ' +
                receivedLen + ' of ' + expectedLen + ' bytes.'),
              { code: 'StreamContentLengthMismatch' }
            ));
          } else if (AWS.HttpClient.streamsApiVersion === 2) {
            stream.end();
          } else {
            stream.emit('end');
          }
        };

        var httpStream = resp.httpResponse.createUnbufferedStream();

        if (AWS.HttpClient.streamsApiVersion === 2) {
          if (shouldCheckContentLength) {
            var lengthAccumulator = new streams.PassThrough();
            lengthAccumulator._write = function(chunk) {
              if (chunk && chunk.length) {
                receivedLen += chunk.length;
              }
              return streams.PassThrough.prototype._write.apply(this, arguments);
            };

            lengthAccumulator.on('end', checkContentLengthAndEmit);
            stream.on('error', function(err) {
              shouldCheckContentLength = false;
              httpStream.unpipe(lengthAccumulator);
              lengthAccumulator.emit('end');
              lengthAccumulator.end();
            });
            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
          } else {
            httpStream.pipe(stream);
          }
        } else {

          if (shouldCheckContentLength) {
            httpStream.on('data', function(arg) {
              if (arg && arg.length) {
                receivedLen += arg.length;
              }
            });
          }

          httpStream.on('data', function(arg) {
            stream.emit('data', arg);
          });
          httpStream.on('end', checkContentLengthAndEmit);
        }

        httpStream.on('error', function(err) {
          shouldCheckContentLength = false;
          stream.emit('error', err);
        });
      }
    });

    return stream;
  },

  /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */
  emitEvent: function emit(eventName, args, done) {
    if (typeof args === 'function') { done = args; args = null; }
    if (!done) done = function() { };
    if (!args) args = this.eventParameters(eventName, this.response);

    var origEmit = AWS.SequentialExecutor.prototype.emit;
    origEmit.call(this, eventName, args, function (err) {
      if (err) this.response.error = err;
      done.call(this, err);
    });
  },

  /**
   * @api private
   */
  eventParameters: function eventParameters(eventName) {
    switch (eventName) {
      case 'restart':
      case 'validate':
      case 'sign':
      case 'build':
      case 'afterValidate':
      case 'afterBuild':
        return [this];
      case 'error':
        return [this.response.error, this.response];
      default:
        return [this.response];
    }
  },

  /**
   * @api private
   */
  presign: function presign(expires, callback) {
    if (!callback && typeof expires === 'function') {
      callback = expires;
      expires = null;
    }
    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
  },

  /**
   * @api private
   */
  isPresigned: function isPresigned() {
    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
  },

  /**
   * @api private
   */
  toUnauthenticated: function toUnauthenticated() {
    this._unAuthenticated = true;
    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
    return this;
  },

  /**
   * @api private
   */
  toGet: function toGet() {
    if (this.service.api.protocol === 'query' ||
        this.service.api.protocol === 'ec2') {
      this.removeListener('build', this.buildAsGet);
      this.addListener('build', this.buildAsGet);
    }
    return this;
  },

  /**
   * @api private
   */
  buildAsGet: function buildAsGet(request) {
    request.httpRequest.method = 'GET';
    request.httpRequest.path = request.service.endpoint.path +
                               '?' + request.httpRequest.body;
    request.httpRequest.body = '';

    // don't need these headers on a GET request
    delete request.httpRequest.headers['Content-Length'];
    delete request.httpRequest.headers['Content-Type'];
  },

  /**
   * @api private
   */
  haltHandlersOnError: function haltHandlersOnError() {
    this._haltHandlersOnError = true;
  }
});

/**
 * @api private
 */
AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = function promise() {
    var self = this;
    // append to user agent
    this.httpRequest.appendToUserAgent('promise');
    return new PromiseDependency(function(resolve, reject) {
      self.on('complete', function(resp) {
        if (resp.error) {
          reject(resp.error);
        } else {
          // define $response property so that it is not enumberable
          // this prevents circular reference errors when stringifying the JSON object
          resolve(Object.defineProperty(
            resp.data || {},
            '$response',
            {value: resp}
          ));
        }
      });
      self.runTo();
    });
  };
};

/**
 * @api private
 */
AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.Request);

AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

function AcceptorStateMachine(states, state) {
  this.currentState = state || null;
  this.states = states || {};
}

AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
  if (typeof finalState === 'function') {
    inputError = bindObject; bindObject = done;
    done = finalState; finalState = null;
  }

  var self = this;
  var state = self.states[self.currentState];
  state.fn.call(bindObject || self, inputError, function(err) {
    if (err) {
      if (state.fail) self.currentState = state.fail;
      else return done ? done.call(bindObject, err) : null;
    } else {
      if (state.accept) self.currentState = state.accept;
      else return done ? done.call(bindObject) : null;
    }
    if (self.currentState === finalState) {
      return done ? done.call(bindObject, err) : null;
    }

    self.runTo(finalState, done, bindObject, err);
  });
};

AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
  if (typeof acceptState === 'function') {
    fn = acceptState; acceptState = null; failState = null;
  } else if (typeof failState === 'function') {
    fn = failState; failState = null;
  }

  if (!this.currentState) this.currentState = name;
  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
  return this;
};

/**
 * @api private
 */
module.exports = AcceptorStateMachine;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(282);

/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */
AWS.Response = inherit({

  /**
   * @api private
   */
  constructor: function Response(request) {
    this.request = request;
    this.data = null;
    this.error = null;
    this.retryCount = 0;
    this.redirectCount = 0;
    this.httpResponse = new AWS.HttpResponse();
    if (request) {
      this.maxRetries = request.service.numRetries();
      this.maxRedirects = request.service.config.maxRedirects;
    }
  },

  /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */
  nextPage: function nextPage(callback) {
    var config;
    var service = this.request.service;
    var operation = this.request.operation;
    try {
      config = service.paginationConfig(operation, true);
    } catch (e) { this.error = e; }

    if (!this.hasNextPage()) {
      if (callback) callback(this.error, null);
      else if (this.error) throw this.error;
      return null;
    }

    var params = AWS.util.copy(this.request.params);
    if (!this.nextPageTokens) {
      return callback ? callback(null, null) : null;
    } else {
      var inputTokens = config.inputToken;
      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
      for (var i = 0; i < inputTokens.length; i++) {
        params[inputTokens[i]] = this.nextPageTokens[i];
      }
      return service.makeRequest(this.request.operation, params, callback);
    }
  },

  /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */
  hasNextPage: function hasNextPage() {
    this.cacheNextPageTokens();
    if (this.nextPageTokens) return true;
    if (this.nextPageTokens === undefined) return undefined;
    else return false;
  },

  /**
   * @api private
   */
  cacheNextPageTokens: function cacheNextPageTokens() {
    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
    this.nextPageTokens = undefined;

    var config = this.request.service.paginationConfig(this.request.operation);
    if (!config) return this.nextPageTokens;

    this.nextPageTokens = null;
    if (config.moreResults) {
      if (!jmespath.search(this.data, config.moreResults)) {
        return this.nextPageTokens;
      }
    }

    var exprs = config.outputToken;
    if (typeof exprs === 'string') exprs = [exprs];
    AWS.util.arrayEach.call(this, exprs, function (expr) {
      var output = jmespath.search(this.data, expr);
      if (output) {
        this.nextPageTokens = this.nextPageTokens || [];
        this.nextPageTokens.push(output);
      }
    });

    return this.nextPageTokens;
  }

});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(282);

/**
 * @api private
 */
function CHECK_ACCEPTORS(resp) {
  var waiter = resp.request._waiter;
  var acceptors = waiter.config.acceptors;
  var acceptorMatched = false;
  var state = 'retry';

  acceptors.forEach(function(acceptor) {
    if (!acceptorMatched) {
      var matcher = waiter.matchers[acceptor.matcher];
      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
        acceptorMatched = true;
        state = acceptor.state;
      }
    }
  });

  if (!acceptorMatched && resp.error) state = 'failure';

  if (state === 'success') {
    waiter.setSuccess(resp);
  } else {
    waiter.setError(resp, state === 'retry');
  }
}

/**
 * @api private
 */
AWS.ResourceWaiter = inherit({
  /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */
  constructor: function constructor(service, state) {
    this.service = service;
    this.state = state;
    this.loadWaiterConfig(this.state);
  },

  service: null,

  state: null,

  config: null,

  matchers: {
    path: function(resp, expected, argument) {
      try {
        var result = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      return jmespath.strictDeepEqual(result,expected);
    },

    pathAll: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      if (!numResults) return false;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (!jmespath.strictDeepEqual(results[ind], expected)) {
          return false;
        }
      }
      return true;
    },

    pathAny: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (jmespath.strictDeepEqual(results[ind], expected)) {
          return true;
        }
      }
      return false;
    },

    status: function(resp, expected) {
      var statusCode = resp.httpResponse.statusCode;
      return (typeof statusCode === 'number') && (statusCode === expected);
    },

    error: function(resp, expected) {
      if (typeof expected === 'string' && resp.error) {
        return expected === resp.error.code;
      }
      // if expected is not string, can be boolean indicating presence of error
      return expected === !!resp.error;
    }
  },

  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
    add('RETRY_CHECK', 'retry', function(resp) {
      var waiter = resp.request._waiter;
      if (resp.error && resp.error.code === 'ResourceNotReady') {
        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
      }
    });

    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);

    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
  }),

  /**
   * @return [AWS.Request]
   */
  wait: function wait(params, callback) {
    if (typeof params === 'function') {
      callback = params; params = undefined;
    }

    if (params && params.$waiter) {
      params = AWS.util.copy(params);
      if (typeof params.$waiter.delay === 'number') {
        this.config.delay = params.$waiter.delay;
      }
      if (typeof params.$waiter.maxAttempts === 'number') {
        this.config.maxAttempts = params.$waiter.maxAttempts;
      }
      delete params.$waiter;
    }

    var request = this.service.makeRequest(this.config.operation, params);
    request._waiter = this;
    request.response.maxRetries = this.config.maxAttempts;
    request.addListeners(this.listeners);

    if (callback) request.send(callback);
    return request;
  },

  setSuccess: function setSuccess(resp) {
    resp.error = null;
    resp.data = resp.data || {};
    resp.request.removeAllListeners('extractData');
  },

  setError: function setError(resp, retryable) {
    resp.data = null;
    resp.error = AWS.util.error(resp.error || new Error(), {
      code: 'ResourceNotReady',
      message: 'Resource is not in the state ' + this.state,
      retryable: retryable
    });
  },

  /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */
  loadWaiterConfig: function loadWaiterConfig(state) {
    if (!this.service.api.waiters[state]) {
      throw new AWS.util.error(new Error(), {
        code: 'StateNotFoundError',
        message: 'State ' + state + ' not found.'
      });
    }

    this.config = AWS.util.copy(this.service.api.waiters[state]);
  }
});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.RequestSigner = inherit({
  constructor: function RequestSigner(request) {
    this.request = request;
  },

  setServiceClientId: function setServiceClientId(id) {
    this.serviceClientId = id;
  },

  getServiceClientId: function getServiceClientId() {
    return this.serviceClientId;
  }
});

AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
  switch (version) {
    case 'v2': return AWS.Signers.V2;
    case 'v3': return AWS.Signers.V3;
    case 's3v4': return AWS.Signers.V4;
    case 'v4': return AWS.Signers.V4;
    case 's3': return AWS.Signers.S3;
    case 'v3https': return AWS.Signers.V3Https;
  }
  throw new Error('Unknown signing version ' + version);
};

__webpack_require__(1135);
__webpack_require__(506);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1139);
__webpack_require__(1140);


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    if (!date) date = AWS.util.date.getDate();

    var r = this.request;

    r.params.Timestamp = AWS.util.date.iso8601(date);
    r.params.SignatureVersion = '2';
    r.params.SignatureMethod = 'HmacSHA256';
    r.params.AWSAccessKeyId = credentials.accessKeyId;

    if (credentials.sessionToken) {
      r.params.SecurityToken = credentials.sessionToken;
    }

    delete r.params.Signature; // delete old Signature for re-signing
    r.params.Signature = this.signature(credentials);

    r.body = AWS.util.queryParamsToString(r.params);
    r.headers['Content-Length'] = r.body.length;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push(this.request.endpoint.host.toLowerCase());
    parts.push(this.request.pathname());
    parts.push(AWS.util.queryParamsToString(this.request.params));
    return parts.join('\n');
  }

});

/**
 * @api private
 */
module.exports = AWS.Signers.V2;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;

__webpack_require__(506);

/**
 * @api private
 */
AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
  authorization: function authorization(credentials) {
    return 'AWS3-HTTPS ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'Signature=' + this.signature(credentials);
  },

  stringToSign: function stringToSign() {
    return this.request.headers['X-Amz-Date'];
  }
});

/**
 * @api private
 */
module.exports = AWS.Signers.V3Https;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var v4Credentials = __webpack_require__(1138);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
  constructor: function V4(request, serviceName, options) {
    AWS.Signers.RequestSigner.call(this, request);
    this.serviceName = serviceName;
    options = options || {};
    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
    this.operation = options.operation;
    this.signatureVersion = options.signatureVersion;
  },

  algorithm: 'AWS4-HMAC-SHA256',

  addAuthorization: function addAuthorization(credentials, date) {
    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');

    if (this.isPresigned()) {
      this.updateForPresigned(credentials, datetime);
    } else {
      this.addHeaders(credentials, datetime);
    }

    this.request.headers['Authorization'] =
      this.authorization(credentials, datetime);
  },

  addHeaders: function addHeaders(credentials, datetime) {
    this.request.headers['X-Amz-Date'] = datetime;
    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }
  },

  updateForPresigned: function updateForPresigned(credentials, datetime) {
    var credString = this.credentialString(datetime);
    var qs = {
      'X-Amz-Date': datetime,
      'X-Amz-Algorithm': this.algorithm,
      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
      'X-Amz-Expires': this.request.headers[expiresHeader],
      'X-Amz-SignedHeaders': this.signedHeaders()
    };

    if (credentials.sessionToken) {
      qs['X-Amz-Security-Token'] = credentials.sessionToken;
    }

    if (this.request.headers['Content-Type']) {
      qs['Content-Type'] = this.request.headers['Content-Type'];
    }
    if (this.request.headers['Content-MD5']) {
      qs['Content-MD5'] = this.request.headers['Content-MD5'];
    }
    if (this.request.headers['Cache-Control']) {
      qs['Cache-Control'] = this.request.headers['Cache-Control'];
    }

    // need to pull in any other X-Amz-* headers
    AWS.util.each.call(this, this.request.headers, function(key, value) {
      if (key === expiresHeader) return;
      if (this.isSignableHeader(key)) {
        var lowerKey = key.toLowerCase();
        // Metadata should be normalized
        if (lowerKey.indexOf('x-amz-meta-') === 0) {
          qs[lowerKey] = value;
        } else if (lowerKey.indexOf('x-amz-') === 0) {
          qs[key] = value;
        }
      }
    });

    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
    this.request.path += sep + AWS.util.queryParamsToString(qs);
  },

  authorization: function authorization(credentials, datetime) {
    var parts = [];
    var credString = this.credentialString(datetime);
    parts.push(this.algorithm + ' Credential=' +
      credentials.accessKeyId + '/' + credString);
    parts.push('SignedHeaders=' + this.signedHeaders());
    parts.push('Signature=' + this.signature(credentials, datetime));
    return parts.join(', ');
  },

  signature: function signature(credentials, datetime) {
    var signingKey = v4Credentials.getSigningKey(
      credentials,
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName,
      this.signatureCache
    );
    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
  },

  stringToSign: function stringToSign(datetime) {
    var parts = [];
    parts.push('AWS4-HMAC-SHA256');
    parts.push(datetime);
    parts.push(this.credentialString(datetime));
    parts.push(this.hexEncodedHash(this.canonicalString()));
    return parts.join('\n');
  },

  canonicalString: function canonicalString() {
    var parts = [], pathname = this.request.pathname();
    if (this.serviceName !== 's3' && this.signatureVersion !== 's3v4') pathname = AWS.util.uriEscapePath(pathname);

    parts.push(this.request.method);
    parts.push(pathname);
    parts.push(this.request.search());
    parts.push(this.canonicalHeaders() + '\n');
    parts.push(this.signedHeaders());
    parts.push(this.hexEncodedBodyHash());
    return parts.join('\n');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = [];
    AWS.util.each.call(this, this.request.headers, function (key, item) {
      headers.push([key, item]);
    });
    headers.sort(function (a, b) {
      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
    });
    var parts = [];
    AWS.util.arrayEach.call(this, headers, function (item) {
      var key = item[0].toLowerCase();
      if (this.isSignableHeader(key)) {
        var value = item[1];
        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
            code: 'InvalidHeader'
          });
        }
        parts.push(key + ':' +
          this.canonicalHeaderValues(value.toString()));
      }
    });
    return parts.join('\n');
  },

  canonicalHeaderValues: function canonicalHeaderValues(values) {
    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  },

  signedHeaders: function signedHeaders() {
    var keys = [];
    AWS.util.each.call(this, this.request.headers, function (key) {
      key = key.toLowerCase();
      if (this.isSignableHeader(key)) keys.push(key);
    });
    return keys.sort().join(';');
  },

  credentialString: function credentialString(datetime) {
    return v4Credentials.createScope(
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName
    );
  },

  hexEncodedHash: function hash(string) {
    return AWS.util.crypto.sha256(string, 'hex');
  },

  hexEncodedBodyHash: function hexEncodedBodyHash() {
    var request = this.request;
    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
      return 'UNSIGNED-PAYLOAD';
    } else if (request.headers['X-Amz-Content-Sha256']) {
      return request.headers['X-Amz-Content-Sha256'];
    } else {
      return this.hexEncodedHash(this.request.body || '');
    }
  },

  unsignableHeaders: [
    'authorization',
    'content-type',
    'content-length',
    'user-agent',
    expiresHeader,
    'expect',
    'x-amzn-trace-id'
  ],

  isSignableHeader: function isSignableHeader(key) {
    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
    return this.unsignableHeaders.indexOf(key) < 0;
  },

  isPresigned: function isPresigned() {
    return this.request.headers[expiresHeader] ? true : false;
  }

});

/**
 * @api private
 */
module.exports = AWS.Signers.V4;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

/**
 * @api private
 */
var cachedSecret = {};

/**
 * @api private
 */
var cacheQueue = [];

/**
 * @api private
 */
var maxCacheEntries = 50;

/**
 * @api private
 */
var v4Identifier = 'aws4_request';

/**
 * @api private
 */
module.exports = {
  /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */
  createScope: function createScope(date, region, serviceName) {
    return [
      date.substr(0, 8),
      region,
      serviceName,
      v4Identifier
    ].join('/');
  },

  /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */
  getSigningKey: function getSigningKey(
    credentials,
    date,
    region,
    service,
    shouldCache
  ) {
    var credsIdentifier = AWS.util.crypto
      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
    var cacheKey = [credsIdentifier, date, region, service].join('_');
    shouldCache = shouldCache !== false;
    if (shouldCache && (cacheKey in cachedSecret)) {
      return cachedSecret[cacheKey];
    }

    var kDate = AWS.util.crypto.hmac(
      'AWS4' + credentials.secretAccessKey,
      date,
      'buffer'
    );
    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
    if (shouldCache) {
      cachedSecret[cacheKey] = signingKey;
      cacheQueue.push(cacheKey);
      if (cacheQueue.length > maxCacheEntries) {
        // remove the oldest entry (not the least recently used)
        delete cachedSecret[cacheQueue.shift()];
      }
    }

    return signingKey;
  },

  /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */
  emptyCache: function emptyCache() {
    cachedSecret = {};
    cacheQueue = [];
  }
};


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
  /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */
  subResources: {
    'acl': 1,
    'accelerate': 1,
    'analytics': 1,
    'cors': 1,
    'lifecycle': 1,
    'delete': 1,
    'inventory': 1,
    'location': 1,
    'logging': 1,
    'metrics': 1,
    'notification': 1,
    'partNumber': 1,
    'policy': 1,
    'requestPayment': 1,
    'replication': 1,
    'restore': 1,
    'tagging': 1,
    'torrent': 1,
    'uploadId': 1,
    'uploads': 1,
    'versionId': 1,
    'versioning': 1,
    'versions': 1,
    'website': 1
  },

  // when building the stringToSign, these querystring params should be
  // part of the canonical resource string with their NON-encoded values
  responseHeaders: {
    'response-content-type': 1,
    'response-content-language': 1,
    'response-expires': 1,
    'response-cache-control': 1,
    'response-content-disposition': 1,
    'response-content-encoding': 1
  },

  addAuthorization: function addAuthorization(credentials, date) {
    if (!this.request.headers['presigned-expires']) {
      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
    }

    if (credentials.sessionToken) {
      // presigned URLs require this header to be lowercased
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;

    this.request.headers['Authorization'] = auth;
  },

  stringToSign: function stringToSign() {
    var r = this.request;

    var parts = [];
    parts.push(r.method);
    parts.push(r.headers['Content-MD5'] || '');
    parts.push(r.headers['Content-Type'] || '');

    // This is the "Date" header, but we use X-Amz-Date.
    // The S3 signing mechanism requires us to pass an empty
    // string for this Date header regardless.
    parts.push(r.headers['presigned-expires'] || '');

    var headers = this.canonicalizedAmzHeaders();
    if (headers) parts.push(headers);
    parts.push(this.canonicalizedResource());

    return parts.join('\n');

  },

  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {

    var amzHeaders = [];

    AWS.util.each(this.request.headers, function (name) {
      if (name.match(/^x-amz-/i))
        amzHeaders.push(name);
    });

    amzHeaders.sort(function (a, b) {
      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    });

    var parts = [];
    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
    });

    return parts.join('\n');

  },

  canonicalizedResource: function canonicalizedResource() {

    var r = this.request;

    var parts = r.path.split('?');
    var path = parts[0];
    var querystring = parts[1];

    var resource = '';

    if (r.virtualHostedBucket)
      resource += '/' + r.virtualHostedBucket;

    resource += path;

    if (querystring) {

      // collect a list of sub resources and query params that need to be signed
      var resources = [];

      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
        var name = param.split('=')[0];
        var value = param.split('=')[1];
        if (this.subResources[name] || this.responseHeaders[name]) {
          var subresource = { name: name };
          if (value !== undefined) {
            if (this.subResources[name]) {
              subresource.value = value;
            } else {
              subresource.value = decodeURIComponent(value);
            }
          }
          resources.push(subresource);
        }
      });

      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });

      if (resources.length) {

        querystring = [];
        AWS.util.arrayEach(resources, function (res) {
          if (res.value === undefined) {
            querystring.push(res.name);
          } else {
            querystring.push(res.name + '=' + res.value);
          }
        });

        resource += '?' + querystring.join('&');
      }

    }

    return resource;

  },

  sign: function sign(secret, string) {
    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
  }
});

/**
 * @api private
 */
module.exports = AWS.Signers.S3;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
function signedUrlBuilder(request) {
  var expires = request.httpRequest.headers[expiresHeader];
  var signerClass = request.service.getSignerClass(request);

  delete request.httpRequest.headers['User-Agent'];
  delete request.httpRequest.headers['X-Amz-User-Agent'];

  if (signerClass === AWS.Signers.V4) {
    if (expires > 604800) { // one week expiry is invalid
      var message = 'Presigning does not support expiry time greater ' +
                    'than a week with SigV4 signing.';
      throw AWS.util.error(new Error(), {
        code: 'InvalidExpiryTime', message: message, retryable: false
      });
    }
    request.httpRequest.headers[expiresHeader] = expires;
  } else if (signerClass === AWS.Signers.S3) {
    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
    request.httpRequest.headers[expiresHeader] = parseInt(
      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
  } else {
    throw AWS.util.error(new Error(), {
      message: 'Presigning only supports S3 or SigV4 signing.',
      code: 'UnsupportedSigner', retryable: false
    });
  }
}

/**
 * @api private
 */
function signedUrlSigner(request) {
  var endpoint = request.httpRequest.endpoint;
  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
  var queryParams = {};

  if (parsedUrl.search) {
    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
  }

  var auth = request.httpRequest.headers['Authorization'].split(' ');
  if (auth[0] === 'AWS') {
    auth = auth[1].split(':');
    queryParams['AWSAccessKeyId'] = auth[0];
    queryParams['Signature'] = auth[1];

    AWS.util.each(request.httpRequest.headers, function (key, value) {
      if (key === expiresHeader) key = 'Expires';
      if (key.indexOf('x-amz-meta-') === 0) {
        // Delete existing, potentially not normalized key
        delete queryParams[key];
        key = key.toLowerCase();
      }
      queryParams[key] = value;
    });
    delete request.httpRequest.headers[expiresHeader];
    delete queryParams['Authorization'];
    delete queryParams['Host'];
  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
    auth.shift();
    var rest = auth.join(' ');
    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
    queryParams['X-Amz-Signature'] = signature;
    delete queryParams['Expires'];
  }

  // build URL
  endpoint.pathname = parsedUrl.pathname;
  endpoint.search = AWS.util.queryParamsToString(queryParams);
}

/**
 * @api private
 */
AWS.Signers.Presign = inherit({
  /**
   * @api private
   */
  sign: function sign(request, expireTime, callback) {
    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
    request.on('build', signedUrlBuilder);
    request.on('sign', signedUrlSigner);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.COMPUTE_SHA256);

    request.emit('beforePresign', [request]);

    if (callback) {
      request.build(function() {
        if (this.response.error) callback(this.response.error);
        else {
          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
        }
      });
    } else {
      request.build();
      if (request.response.error) throw request.response.error;
      return AWS.util.urlFormat(request.httpRequest.endpoint);
    }
  }
});

/**
 * @api private
 */
module.exports = AWS.Signers.Presign;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

/**
 * @api private
 */
AWS.ParamValidator = AWS.util.inherit({
  /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */
  constructor: function ParamValidator(validation) {
    if (validation === true || validation === undefined) {
      validation = {'min': true};
    }
    this.validation = validation;
  },

  validate: function validate(shape, params, context) {
    this.errors = [];
    this.validateMember(shape, params || {}, context || 'params');

    if (this.errors.length > 1) {
      var msg = this.errors.join('\n* ');
      msg = 'There were ' + this.errors.length +
        ' validation errors:\n* ' + msg;
      throw AWS.util.error(new Error(msg),
        {code: 'MultipleValidationErrors', errors: this.errors});
    } else if (this.errors.length === 1) {
      throw this.errors[0];
    } else {
      return true;
    }
  },

  fail: function fail(code, message) {
    this.errors.push(AWS.util.error(new Error(message), {code: code}));
  },

  validateStructure: function validateStructure(shape, params, context) {
    this.validateType(params, context, ['object'], 'structure');

    var paramName;
    for (var i = 0; shape.required && i < shape.required.length; i++) {
      paramName = shape.required[i];
      var value = params[paramName];
      if (value === undefined || value === null) {
        this.fail('MissingRequiredParameter',
          'Missing required key \'' + paramName + '\' in ' + context);
      }
    }

    // validate hash members
    for (paramName in params) {
      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;

      var paramValue = params[paramName],
          memberShape = shape.members[paramName];

      if (memberShape !== undefined) {
        var memberContext = [context, paramName].join('.');
        this.validateMember(memberShape, paramValue, memberContext);
      } else {
        this.fail('UnexpectedParameter',
          'Unexpected key \'' + paramName + '\' found in ' + context);
      }
    }

    return true;
  },

  validateMember: function validateMember(shape, param, context) {
    switch (shape.type) {
      case 'structure':
        return this.validateStructure(shape, param, context);
      case 'list':
        return this.validateList(shape, param, context);
      case 'map':
        return this.validateMap(shape, param, context);
      default:
        return this.validateScalar(shape, param, context);
    }
  },

  validateList: function validateList(shape, params, context) {
    if (this.validateType(params, context, [Array])) {
      this.validateRange(shape, params.length, context, 'list member count');
      // validate array members
      for (var i = 0; i < params.length; i++) {
        this.validateMember(shape.member, params[i], context + '[' + i + ']');
      }
    }
  },

  validateMap: function validateMap(shape, params, context) {
    if (this.validateType(params, context, ['object'], 'map')) {
      // Build up a count of map members to validate range traits.
      var mapCount = 0;
      for (var param in params) {
        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
        // Validate any map key trait constraints
        this.validateMember(shape.key, param,
                            context + '[key=\'' + param + '\']');
        this.validateMember(shape.value, params[param],
                            context + '[\'' + param + '\']');
        mapCount++;
      }
      this.validateRange(shape, mapCount, context, 'map member count');
    }
  },

  validateScalar: function validateScalar(shape, value, context) {
    switch (shape.type) {
      case null:
      case undefined:
      case 'string':
        return this.validateString(shape, value, context);
      case 'base64':
      case 'binary':
        return this.validatePayload(value, context);
      case 'integer':
      case 'float':
        return this.validateNumber(shape, value, context);
      case 'boolean':
        return this.validateType(value, context, ['boolean']);
      case 'timestamp':
        return this.validateType(value, context, [Date,
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
          'Date object, ISO-8601 string, or a UNIX timestamp');
      default:
        return this.fail('UnkownType', 'Unhandled type ' +
                         shape.type + ' for ' + context);
    }
  },

  validateString: function validateString(shape, value, context) {
    var validTypes = ['string'];
    if (shape.isJsonValue) {
      validTypes = validTypes.concat(['number', 'object', 'boolean']);
    }
    if (value !== null && this.validateType(value, context, validTypes)) {
      this.validateEnum(shape, value, context);
      this.validateRange(shape, value.length, context, 'string length');
      this.validatePattern(shape, value, context);
      this.validateUri(shape, value, context);
    }
  },

  validateUri: function validateUri(shape, value, context) {
    if (shape['location'] === 'uri') {
      if (value.length === 0) {
        this.fail('UriParameterError', 'Expected uri parameter to have length >= 1,'
          + ' but found "' + value +'" for ' + context);
      }
    }
  },

  validatePattern: function validatePattern(shape, value, context) {
    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
      if (!(new RegExp(shape['pattern'])).test(value)) {
        this.fail('PatternMatchError', 'Provided value "' + value + '" '
          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
          + context);
      }
    }
  },

  validateRange: function validateRange(shape, value, context, descriptor) {
    if (this.validation['min']) {
      if (shape['min'] !== undefined && value < shape['min']) {
        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
          + shape['min'] + ', but found ' + value + ' for ' + context);
      }
    }
    if (this.validation['max']) {
      if (shape['max'] !== undefined && value > shape['max']) {
        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
          + shape['max'] + ', but found ' + value + ' for ' + context);
      }
    }
  },

  validateEnum: function validateRange(shape, value, context) {
    if (this.validation['enum'] && shape['enum'] !== undefined) {
      // Fail if the string value is not present in the enum list
      if (shape['enum'].indexOf(value) === -1) {
        this.fail('EnumError', 'Found string value of ' + value + ', but '
          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
      }
    }
  },

  validateType: function validateType(value, context, acceptedTypes, type) {
    // We will not log an error for null or undefined, but we will return
    // false so that callers know that the expected type was not strictly met.
    if (value === null || value === undefined) return false;

    var foundInvalidType = false;
    for (var i = 0; i < acceptedTypes.length; i++) {
      if (typeof acceptedTypes[i] === 'string') {
        if (typeof value === acceptedTypes[i]) return true;
      } else if (acceptedTypes[i] instanceof RegExp) {
        if ((value || '').toString().match(acceptedTypes[i])) return true;
      } else {
        if (value instanceof acceptedTypes[i]) return true;
        if (AWS.util.isType(value, acceptedTypes[i])) return true;
        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
      }
      foundInvalidType = true;
    }

    var acceptedType = type;
    if (!acceptedType) {
      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
    }

    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
              vowel + ' ' + acceptedType);
    return false;
  },

  validateNumber: function validateNumber(shape, value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') {
      var castedValue = parseFloat(value);
      if (castedValue.toString() === value) value = castedValue;
    }
    if (this.validateType(value, context, ['number'])) {
      this.validateRange(shape, value, context, 'numeric value');
    }
  },

  validatePayload: function validatePayload(value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') return;
    if (value && typeof value.byteLength === 'number') return; // typed arrays
    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
      var Stream = AWS.util.stream.Stream;
      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
    } else {
      if (typeof Blob !== void 0 && value instanceof Blob) return;
    }

    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
    if (value) {
      for (var i = 0; i < types.length; i++) {
        if (AWS.util.isType(value, types[i])) return;
        if (AWS.util.typeName(value.constructor) === types[i]) return;
      }
    }

    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
      'string, Buffer, Stream, Blob, or typed array object');
  }
});


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect"},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics"},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService"},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService"}}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1144);
var v4 = __webpack_require__(1145);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(507);
var bytesToUuid = __webpack_require__(508);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(507);
var bytesToUuid = __webpack_require__(508);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var Hmac = __webpack_require__(1147);
var Md5 = __webpack_require__(1148);
var Sha1 = __webpack_require__(1149);
var Sha256 = __webpack_require__(1150);

/**
 * @api private
 */
module.exports = exports = {
    createHash: function createHash(alg) {
      alg = alg.toLowerCase();
      if (alg === 'md5') {
        return new Md5();
      } else if (alg === 'sha256') {
        return new Sha256();
      } else if (alg === 'sha1') {
        return new Sha1();
      }

      throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
    },
    createHmac: function createHmac(alg, key) {
      alg = alg.toLowerCase();
      if (alg === 'md5') {
        return new Hmac(Md5, key);
      } else if (alg === 'sha256') {
        return new Hmac(Sha256, key);
      } else if (alg === 'sha1') {
        return new Hmac(Sha1, key);
      }

      throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
    },
    createSign: function() {
      throw new Error('createSign is not implemented in the browser');
    }
  };


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var hashUtils = __webpack_require__(200);

/**
 * @api private
 */
function Hmac(hashCtor, secret) {
    this.hash = new hashCtor();
    this.outer = new hashCtor();

    var inner = bufferFromSecret(hashCtor, secret);
    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
    outer.set(inner);

    for (var i = 0; i < hashCtor.BLOCK_SIZE; i++) {
        inner[i] ^= 0x36;
        outer[i] ^= 0x5c;
    }

    this.hash.update(inner);
    this.outer.update(outer);

    // Zero out the copied key buffer.
    for (var i = 0; i < inner.byteLength; i++) {
        inner[i] = 0;
    }
}

/**
 * @api private
 */
module.exports = exports = Hmac;

Hmac.prototype.update = function (toHash) {
    if (hashUtils.isEmptyData(toHash) || this.error) {
        return this;
    }

    try {
        this.hash.update(hashUtils.convertToBuffer(toHash));
    } catch (e) {
        this.error = e;
    }

    return this;
};

Hmac.prototype.digest = function (encoding) {
    if (!this.outer.finished) {
        this.outer.update(this.hash.digest());
    }

    return this.outer.digest(encoding);
};

function bufferFromSecret(hashCtor, secret) {
    var input = hashUtils.convertToBuffer(secret);
    if (input.byteLength > hashCtor.BLOCK_SIZE) {
        var bufferHash = new hashCtor;
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var hashUtils = __webpack_require__(200);
var Buffer = __webpack_require__(23).Buffer;

var BLOCK_SIZE = 64;

var DIGEST_LENGTH = 16;

var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
];

/**
 * @api private
 */
function Md5() {
    this.state = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
    ];
    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
    this.bufferLength = 0;
    this.bytesHashed = 0;
    this.finished = false;
}

/**
 * @api private
 */
module.exports = exports = Md5;

Md5.BLOCK_SIZE = BLOCK_SIZE;

Md5.prototype.update = function (sourceData) {
    if (hashUtils.isEmptyData(sourceData)) {
        return this;
    } else if (this.finished) {
        throw new Error('Attempted to update an already finished hash.');
    }

    var data = hashUtils.convertToBuffer(sourceData);
    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    while (byteLength > 0) {
        this.buffer.setUint8(this.bufferLength++, data[position++]);
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }

    return this;
};

Md5.prototype.digest = function (encoding) {
    if (!this.finished) {
        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
        var bitsHashed = bytesHashed * 8;
        buffer.setUint8(this.bufferLength++, 128);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
                buffer.setUint8(i, 0);
            }
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
            buffer.setUint8(i, 0);
        }
        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
        this.hashBuffer();
        this.finished = true;
    }
    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
    for (var i = 0; i < 4; i++) {
        out.setUint32(i * 4, this.state[i], true);
    }
    var buff = new Buffer(out.buffer, out.byteOffset, out.byteLength);
    return encoding ? buff.toString(encoding) : buff;
};

Md5.prototype.hashBuffer = function () {
    var _a = this, buffer = _a.buffer, state = _a.state;
    var a = state[0], b = state[1], c = state[2], d = state[3];
    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
    state[0] = (a + state[0]) & 0xFFFFFFFF;
    state[1] = (b + state[1]) & 0xFFFFFFFF;
    state[2] = (c + state[2]) & 0xFFFFFFFF;
    state[3] = (d + state[3]) & 0xFFFFFFFF;
};

function cmn(q, a, b, x, s, t) {
    a = (((a + q) & 0xFFFFFFFF) + ((x + t) & 0xFFFFFFFF)) & 0xFFFFFFFF;
    return (((a << s) | (a >>> (32 - s))) + b) & 0xFFFFFFFF;
}

function ff(a, b, c, d, x, s, t) {
    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | (~d)), a, b, x, s, t);
}


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(23).Buffer;
var hashUtils = __webpack_require__(200);

var BLOCK_SIZE = 64;

var DIGEST_LENGTH = 20;

var KEY = new Uint32Array([
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc | 0,
    0xca62c1d6 | 0
]);

var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19,
];

var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

/**
 * @api private
 */
function Sha1() {
    this.h0 = 0x67452301;
    this.h1 = 0xEFCDAB89;
    this.h2 = 0x98BADCFE;
    this.h3 = 0x10325476;
    this.h4 = 0xC3D2E1F0;
    // The first 64 bytes (16 words) is the data chunk
    this.block = new Uint32Array(80);
    this.offset = 0;
    this.shift = 24;
    this.totalLength = 0;
}

/**
 * @api private
 */
module.exports = exports = Sha1;

Sha1.BLOCK_SIZE = BLOCK_SIZE;

Sha1.prototype.update = function (data) {
    if (this.finished) {
        throw new Error('Attempted to update an already finished hash.');
    }

    if (hashUtils.isEmptyData(data)) {
        return this;
    }

    data = hashUtils.convertToBuffer(data);

    var length = data.length;
    this.totalLength += length * 8;
    for (var i = 0; i < length; i++) {
        this.write(data[i]);
    }

    return this;
};

Sha1.prototype.write = function write(byte) {
    this.block[this.offset] |= (byte & 0xff) << this.shift;
    if (this.shift) {
        this.shift -= 8;
    } else {
        this.offset++;
        this.shift = 24;
    }

    if (this.offset === 16) this.processBlock();
};

Sha1.prototype.digest = function (encoding) {
    // Pad
    this.write(0x80);
    if (this.offset > 14 || (this.offset === 14 && this.shift < 24)) {
      this.processBlock();
    }
    this.offset = 14;
    this.shift = 24;

    // 64-bit length big-endian
    this.write(0x00); // numbers this big aren't accurate in javascript anyway
    this.write(0x00); // ..So just hard-code to zero.
    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
    for (var s = 24; s >= 0; s -= 8) {
        this.write(this.totalLength >> s);
    }
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new Buffer(DIGEST_LENGTH);
    var outView = new DataView(out.buffer);
    outView.setUint32(0, this.h0, false);
    outView.setUint32(4, this.h1, false);
    outView.setUint32(8, this.h2, false);
    outView.setUint32(12, this.h3, false);
    outView.setUint32(16, this.h4, false);

    return encoding ? out.toString(encoding) : out;
};

Sha1.prototype.processBlock = function processBlock() {
    // Extend the sixteen 32-bit words into eighty 32-bit words:
    for (var i = 16; i < 80; i++) {
      var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
      this.block[i] = (w << 1) | (w >>> 31);
    }

    // Initialize hash value for this chunk:
    var a = this.h0;
    var b = this.h1;
    var c = this.h2;
    var d = this.h3;
    var e = this.h4;
    var f, k;

    // Main loop:
    for (i = 0; i < 80; i++) {
      if (i < 20) {
        f = d ^ (b & (c ^ d));
        k = 0x5A827999;
      }
      else if (i < 40) {
        f = b ^ c ^ d;
        k = 0x6ED9EBA1;
      }
      else if (i < 60) {
        f = (b & c) | (d & (b | c));
        k = 0x8F1BBCDC;
      }
      else {
        f = b ^ c ^ d;
        k = 0xCA62C1D6;
      }
      var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i]|0);
      e = d;
      d = c;
      c = (b << 30 | b >>> 2);
      b = a;
      a = temp;
    }

    // Add this chunk's hash to result so far:
    this.h0 = (this.h0 + a) | 0;
    this.h1 = (this.h1 + b) | 0;
    this.h2 = (this.h2 + c) | 0;
    this.h3 = (this.h3 + d) | 0;
    this.h4 = (this.h4 + e) | 0;

    // The block is now reusable.
    this.offset = 0;
    for (i = 0; i < 16; i++) {
        this.block[i] = 0;
    }
};


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(23).Buffer;
var hashUtils = __webpack_require__(200);

var BLOCK_SIZE = 64;

var DIGEST_LENGTH = 32;

var KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);

var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19,
];

var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

/**
 * @private
 */
function Sha256() {
    this.state = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19,
    ];
    this.temp = new Int32Array(64);
    this.buffer = new Uint8Array(64);
    this.bufferLength = 0;
    this.bytesHashed = 0;
    /**
     * @private
     */
    this.finished = false;
}

/**
 * @api private
 */
module.exports = exports = Sha256;

Sha256.BLOCK_SIZE = BLOCK_SIZE;

Sha256.prototype.update = function (data) {
    if (this.finished) {
        throw new Error('Attempted to update an already finished hash.');
    }

    if (hashUtils.isEmptyData(data)) {
        return this;
    }

    data = hashUtils.convertToBuffer(data);

    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
        throw new Error('Cannot hash more than 2^53 - 1 bits');
    }

    while (byteLength > 0) {
        this.buffer[this.bufferLength++] = data[position++];
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }

    return this;
};

Sha256.prototype.digest = function (encoding) {
    if (!this.finished) {
        var bitsHashed = this.bytesHashed * 8;
        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        var undecoratedLength = this.bufferLength;
        bufferView.setUint8(this.bufferLength++, 0x80);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
                bufferView.setUint8(i, 0);
            }
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
            bufferView.setUint8(i, 0);
        }
        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
        this.hashBuffer();
        this.finished = true;
    }
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new Buffer(DIGEST_LENGTH);
    for (var i = 0; i < 8; i++) {
        out[i * 4] = (this.state[i] >>> 24) & 0xff;
        out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
        out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
        out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
    }
    return encoding ? out.toString(encoding) : out;
};

Sha256.prototype.hashBuffer = function () {
    var _a = this,
        buffer = _a.buffer,
        state = _a.state;
    var state0 = state[0],
        state1 = state[1],
        state2 = state[2],
        state3 = state[3],
        state4 = state[4],
        state5 = state[5],
        state6 = state[6],
        state7 = state[7];
    for (var i = 0; i < BLOCK_SIZE; i++) {
        if (i < 16) {
            this.temp[i] = (((buffer[i * 4] & 0xff) << 24) |
                ((buffer[(i * 4) + 1] & 0xff) << 16) |
                ((buffer[(i * 4) + 2] & 0xff) << 8) |
                (buffer[(i * 4) + 3] & 0xff));
        }
        else {
            var u = this.temp[i - 2];
            var t1_1 = (u >>> 17 | u << 15) ^
                (u >>> 19 | u << 13) ^
                (u >>> 10);
            u = this.temp[i - 15];
            var t2_1 = (u >>> 7 | u << 25) ^
                (u >>> 18 | u << 14) ^
                (u >>> 3);
            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) +
                (t2_1 + this.temp[i - 16] | 0);
        }
        var t1 = (((((state4 >>> 6 | state4 << 26) ^
            (state4 >>> 11 | state4 << 21) ^
            (state4 >>> 25 | state4 << 7))
            + ((state4 & state5) ^ (~state4 & state6))) | 0)
            + ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) | 0;
        var t2 = (((state0 >>> 2 | state0 << 30) ^
            (state0 >>> 13 | state0 << 19) ^
            (state0 >>> 22 | state0 << 10)) + ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) | 0;
        state7 = state6;
        state6 = state5;
        state5 = state4;
        state4 = (state3 + t1) | 0;
        state3 = state2;
        state2 = state1;
        state1 = state0;
        state0 = (t1 + t2) | 0;
    }
    state[0] += state0;
    state[1] += state1;
    state[2] += state2;
    state[3] += state3;
    state[4] += state4;
    state[5] += state5;
    state[6] += state6;
    state[7] += state7;
};


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module), __webpack_require__(8)))

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = {
  //provide realtime clock for performance measurement
  now: function now() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      return performance.now();
    }
    return Date.now();
  }
};


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var eventMessageChunker = __webpack_require__(1157).eventMessageChunker;
var parseEvent = __webpack_require__(1158).parseEvent;

function createEventStream(body, parser, model) {
    var eventMessages = eventMessageChunker(body);

    var events = [];

    for (var i = 0; i < eventMessages.length; i++) {
        events.push(parseEvent(parser, eventMessages[i], model));
    }

    return events;
}

/**
 * @api private
 */
module.exports = {
    createEventStream: createEventStream
};


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

/**
 * Takes in a buffer of event messages and splits them into individual messages.
 * @param {Buffer} buffer
 * @api private
 */
function eventMessageChunker(buffer) {
    /** @type Buffer[] */
    var messages = [];
    var offset = 0;

    while (offset < buffer.length) {
        var totalLength = buffer.readInt32BE(offset);

        // create new buffer for individual message (shares memory with original)
        var message = buffer.slice(offset, totalLength + offset);
        // increment offset to it starts at the next message
        offset += totalLength;

        messages.push(message);
    }

    return messages;
}

/**
 * @api private
 */
module.exports = {
    eventMessageChunker: eventMessageChunker
};


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var parseMessage = __webpack_require__(1159).parseMessage;

/**
 *
 * @param {*} parser
 * @param {Buffer} message
 * @param {*} shape
 * @api private
 */
function parseEvent(parser, message, shape) {
    var parsedMessage = parseMessage(message);

    // check if message is an event or error
    var messageType = parsedMessage.headers[':message-type'];
    if (messageType) {
        if (messageType.value === 'error') {
            throw parseError(parsedMessage);
        } else if (messageType.value !== 'event') {
            // not sure how to parse non-events/non-errors, ignore for now
            return;
        }
    }

    // determine event type
    var eventType = parsedMessage.headers[':event-type'];
    // check that the event type is modeled
    var eventModel = shape.members[eventType.value];
    if (!eventModel) {
        return;
    }

    var result = {};
    // check if an event payload exists
    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
    if (eventPayloadMemberName) {
        var payloadShape = eventModel.members[eventPayloadMemberName];
        // if the shape is binary, return the byte array
        if (payloadShape.type === 'binary') {
            result[eventPayloadMemberName] = parsedMessage.body;
        } else {
            result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
        }
    }

    // read event headers
    var eventHeaderNames = eventModel.eventHeaderMemberNames;
    for (var i = 0; i < eventHeaderNames.length; i++) {
        var name = eventHeaderNames[i];
        if (parsedMessage.headers[name]) {
            // parse the header!
            result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
        }
    }

    var output = {};
    output[eventType.value] = result;
    return output;
}

function parseError(message) {
    var errorCode = message.headers[':error-code'];
    var errorMessage = message.headers[':error-message'];
    var error = new Error(errorMessage.value || errorMessage);
    error.code = error.name = errorCode.value || errorCode;
    return error;
}

/**
 * @api private
 */
module.exports = {
    parseEvent: parseEvent
};


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var Int64 = __webpack_require__(1160).Int64;

var splitMessage = __webpack_require__(1161).splitMessage;

var BOOLEAN_TAG = 'boolean';
var BYTE_TAG = 'byte';
var SHORT_TAG = 'short';
var INT_TAG = 'integer';
var LONG_TAG = 'long';
var BINARY_TAG = 'binary';
var STRING_TAG = 'string';
var TIMESTAMP_TAG = 'timestamp';
var UUID_TAG = 'uuid';

/**
 * @api private
 *
 * @param {Buffer} headers
 */
function parseHeaders(headers) {
    var out = {};
    var position = 0;
    while (position < headers.length) {
        var nameLength = headers.readUInt8(position++);
        var name = headers.slice(position, position + nameLength).toString();
        position += nameLength;
        switch (headers.readUInt8(position++)) {
            case 0 /* boolTrue */:
                out[name] = {
                    type: BOOLEAN_TAG,
                    value: true
                };
                break;
            case 1 /* boolFalse */:
                out[name] = {
                    type: BOOLEAN_TAG,
                    value: false
                };
                break;
            case 2 /* byte */:
                out[name] = {
                    type: BYTE_TAG,
                    value: headers.readInt8(position++)
                };
                break;
            case 3 /* short */:
                out[name] = {
                    type: SHORT_TAG,
                    value: headers.readInt16BE(position)
                };
                position += 2;
                break;
            case 4 /* integer */:
                out[name] = {
                    type: INT_TAG,
                    value: headers.readInt32BE(position)
                };
                position += 4;
                break;
            case 5 /* long */:
                out[name] = {
                    type: LONG_TAG,
                    value: new Int64(headers.slice(position, position + 8))
                };
                position += 8;
                break;
            case 6 /* byteArray */:
                var binaryLength = headers.readUInt16BE(position);
                position += 2;
                out[name] = {
                    type: BINARY_TAG,
                    value: headers.slice(position, position + binaryLength)
                };
                position += binaryLength;
                break;
            case 7 /* string */:
                var stringLength = headers.readUInt16BE(position);
                position += 2;
                out[name] = {
                    type: STRING_TAG,
                    value: headers.slice(
                        position,
                        position + stringLength
                    ).toString()
                };
                position += stringLength;
                break;
            case 8 /* timestamp */:
                out[name] = {
                    type: TIMESTAMP_TAG,
                    value: new Date(
                        new Int64(headers.slice(position, position + 8))
                            .valueOf()
                    )
                };
                position += 8;
                break;
            case 9 /* uuid */:
                var uuidChars = headers.slice(position, position + 16)
                    .toString('hex');
                position += 16;
                out[name] = {
                    type: UUID_TAG,
                    value: uuidChars.substr(0, 8) + '-' +
                        uuidChars.substr(8, 4) + '-' +
                        uuidChars.substr(12, 4) + '-' +
                        uuidChars.substr(16, 4) + '-' +
                        uuidChars.substr(20)
                };
                break;
            default:
                throw new Error('Unrecognized header type tag');
        }
    }
    return out;
}

function parseMessage(message) {
    var parsed = splitMessage(message);
    return { headers: parseHeaders(parsed.headers), body: parsed.body };
}

/**
 * @api private
 */
module.exports = {
    parseMessage: parseMessage
};


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(13).util;
var toBuffer = util.buffer.toBuffer;

/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 * @param {Buffer} bytes
 *
 * @api private
 */
function Int64(bytes) {
    if (bytes.length !== 8) {
        throw new Error('Int64 buffers must be exactly 8 bytes');
    }
    if (!util.Buffer.isBuffer(bytes)) bytes = toBuffer(bytes);

    this.bytes = bytes;
}

/**
 * @param {number} number
 * @returns {Int64}
 *
 * @api private
 */
Int64.fromNumber = function(number) {
    if (number > 9223372036854775807 || number < -9223372036854775808) {
        throw new Error(
            number + ' is too large (or, if negative, too small) to represent as an Int64'
        );
    }

    var bytes = new Uint8Array(8);
    for (
        var i = 7, remaining = Math.abs(Math.round(number));
        i > -1 && remaining > 0;
        i--, remaining /= 256
    ) {
        bytes[i] = remaining;
    }

    if (number < 0) {
        negate(bytes);
    }

    return new Int64(bytes);
};

/**
 * @returns {number}
 *
 * @api private
 */
Int64.prototype.valueOf = function() {
    var bytes = this.bytes.slice(0);
    var negative = bytes[0] & 128;
    if (negative) {
        negate(bytes);
    }

    return parseInt(bytes.toString('hex'), 16) * (negative ? -1 : 1);
};

Int64.prototype.toString = function() {
    return String(this.valueOf());
};

/**
 * @param {Buffer} bytes
 *
 * @api private
 */
function negate(bytes) {
    for (var i = 0; i < 8; i++) {
        bytes[i] ^= 0xFF;
    }
    for (var i = 7; i > -1; i--) {
        bytes[i]++;
        if (bytes[i] !== 0) {
            break;
        }
    }
}

/**
 * @api private
 */
module.exports = {
    Int64: Int64
};


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(13).util;
var toBuffer = util.buffer.toBuffer;

// All prelude components are unsigned, 32-bit integers
var PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;

/**
 * @api private
 *
 * @param {Buffer} message
 */
function splitMessage(message) {
    if (!util.Buffer.isBuffer(message)) message = toBuffer(message);

    if (message.length < MINIMUM_MESSAGE_LENGTH) {
        throw new Error('Provided message too short to accommodate event stream message overhead');
    }

    if (message.length !== message.readUInt32BE(0)) {
        throw new Error('Reported message length does not match received message length');
    }

    var expectedPreludeChecksum = message.readUInt32BE(PRELUDE_LENGTH);

    if (
        expectedPreludeChecksum !== util.crypto.crc32(
            message.slice(0, PRELUDE_LENGTH)
        )
    ) {
        throw new Error(
            'The prelude checksum specified in the message (' +
            expectedPreludeChecksum +
            ') does not match the calculated CRC32 checksum.'
        );
    }

    var expectedMessageChecksum = message.readUInt32BE(message.length - CHECKSUM_LENGTH);

    if (
        expectedMessageChecksum !== util.crypto.crc32(
            message.slice(0, message.length - CHECKSUM_LENGTH)
        )
    ) {
        throw new Error(
            'The message checksum did not match the expected value of ' +
                expectedMessageChecksum
        );
    }

    var headersStart = PRELUDE_LENGTH + CHECKSUM_LENGTH;
    var headersEnd = headersStart + message.readUInt32BE(PRELUDE_MEMBER_LENGTH);

    return {
        headers: message.slice(headersStart, headersEnd),
        body: message.slice(headersEnd, message.length - CHECKSUM_LENGTH),
    };
}

/**
 * @api private
 */
module.exports = {
    splitMessage: splitMessage
};


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var STS = __webpack_require__(151);

/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * @note AWS.TemporaryCredentials is deprecated, but remains available for
 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
 *   preferred class for temporary credentials.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */
AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */
  constructor: function TemporaryCredentials(params, masterCredentials) {
    AWS.Credentials.call(this);
    this.loadMasterCredentials(masterCredentials);
    this.expired = true;

    this.params = params || {};
    if (this.params.RoleArn) {
      this.params.RoleSessionName =
        this.params.RoleSessionName || 'temporary-credentials';
    }
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh (callback) {
    this.coalesceRefresh(callback || AWS.util.fn.callback);
  },

  /**
   * @api private
   */
  load: function load (callback) {
    var self = this;
    self.createClients();
    self.masterCredentials.get(function () {
      self.service.config.credentials = self.masterCredentials;
      var operation = self.params.RoleArn ?
        self.service.assumeRole : self.service.getSessionToken;
      operation.call(self.service, function (err, data) {
        if (!err) {
          self.service.credentialsFrom(data, self);
        }
        callback(err);
      });
    });
  },

  /**
   * @api private
   */
  loadMasterCredentials: function loadMasterCredentials (masterCredentials) {
    this.masterCredentials = masterCredentials || AWS.config.credentials;
    while (this.masterCredentials.masterCredentials) {
      this.masterCredentials = this.masterCredentials.masterCredentials;
    }

    if (typeof this.masterCredentials.get !== 'function') {
      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
    }
  },

  /**
   * @api private
   */
  createClients: function () {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

AWS.util.update(AWS.STS.prototype, {
  /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */
  credentialsFrom: function credentialsFrom(data, credentials) {
    if (!data) return null;
    if (!credentials) credentials = new AWS.TemporaryCredentials();
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
    return credentials;
  },

  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
  },

  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
  }
});


/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"Sc":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sh":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var STS = __webpack_require__(151);

/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
 * the way masterCredentials and refreshes are handled.
 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
 * masterCredentials passed by the user to support chaining of STS credentials.
 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
 * during instantiation, precluding the ability to refresh credentials which
 * require intermediate, temporary credentials.
 *
 * For example, if the application should use RoleA, which must be assumed from
 * RoleB, and the environment provides credentials which can assume RoleB, then
 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
 * temporary credentials for RoleA:
 *
 * ```javascript
 * var roleACreds = new AWS.ChainableTemporaryCredentials({
 *   params: {RoleArn: 'RoleA'},
 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
 *     params: {RoleArn: 'RoleB'},
 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
 *   })
 * });
 * ```
 *
 * If AWS.TemporaryCredentials had been used in the previous example,
 * `roleACreds` would fail to refresh because `roleACreds` would
 * use the environment credentials for the AssumeRole request.
 *
 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
 * service instance during instantiation while AWS.TemporaryCredentials creates
 * the STS service instance during the first refresh. Creating the service
 * instance during instantiation effectively captures the master credentials
 * from the global config, so that subsequent changes to the global config do
 * not affect the master credentials used to refresh the temporary credentials.
 *
 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
 * to AWS.config.credentials:
 *
 * ```javascript
 * var envCreds = new AWS.EnvironmentCredentials('AWS');
 * AWS.config.credentials = envCreds;
 * // masterCredentials will be envCreds
 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
 *   params: {RoleArn: '...'}
 * });
 * ```
 *
 * Similarly, to use the CredentialProviderChain's default providers as the
 * master credentials, simply create a new instance of
 * AWS.ChainableTemporaryCredentials:
 *
 * ```javascript
 * AWS.config.credentials = new ChainableTemporaryCredentials({
 *   params: {RoleArn: '...'}
 * });
 * ```
 *
 * @!attribute service
 *   @return [AWS.STS] the STS service instance used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */
AWS.ChainableTemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new temporary credentials object.
   *
   * @param options [map] a set of options
   * @option options params [map] ({}) a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
   *   also be passed in or an error will be thrown.
   * @option options masterCredentials [AWS.Credentials] the master credentials
   *   used to get and refresh temporary credentials from AWS STS. By default,
   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
   * @option options tokenCodeFn [Function] (null) Function to provide
   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
   *   is called with value of `SerialNumber` and `callback`, and should provide
   *   the `TokenCode` or an error to the callback in the format
   *   `callback(err, token)`.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
   *     params: {
   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
   *     }
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */
  constructor: function ChainableTemporaryCredentials(options) {
    AWS.Credentials.call(this);
    options = options || {};
    this.errorCode = 'ChainableTemporaryCredentialsProviderFailure';
    this.expired = true;
    this.tokenCodeFn = null;

    var params = AWS.util.copy(options.params) || {};
    if (params.RoleArn) {
      params.RoleSessionName = params.RoleSessionName || 'temporary-credentials';
    }
    if (params.SerialNumber) {
      if (!options.tokenCodeFn || (typeof options.tokenCodeFn !== 'function')) {
        throw new AWS.util.error(
          new Error('tokenCodeFn must be a function when params.SerialNumber is given'),
          {code: this.errorCode}
        );
      } else {
        this.tokenCodeFn = options.tokenCodeFn;
      }
    }
    config = AWS.util.merge(
      {
        params: params,
        credentials: options.masterCredentials || AWS.config.credentials
      },
      options.stsConfig || {}
    );
    this.service = new STS(config);
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */
  refresh: function refresh(callback) {
    this.coalesceRefresh(callback || AWS.util.fn.callback);
  },

  /**
   * @api private
   * @param callback
   */
  load: function load(callback) {
    var self = this;
    var operation = self.service.config.params.RoleArn ? 'assumeRole' : 'getSessionToken';
    this.getTokenCode(function (err, tokenCode) {
      var params = {};
      if (err) {
        callback(err);
        return;
      }
      if (tokenCode) {
        params.TokenCode = tokenCode;
      }
      self.service[operation](params, function (err, data) {
        if (!err) {
          self.service.credentialsFrom(data, self);
        }
        callback(err);
      });
    });
  },

  /**
   * @api private
   */
  getTokenCode: function getTokenCode(callback) {
    var self = this;
    if (this.tokenCodeFn) {
      this.tokenCodeFn(this.service.config.params.SerialNumber, function (err, token) {
        if (err) {
          var message = err;
          if (err instanceof Error) {
            message = err.message;
          }
          callback(
            AWS.util.error(
              new Error('Error fetching MFA token: ' + message),
              { code: self.errorCode}
            )
          );
          return;
        }
        callback(null, token);
      });
    } else {
      callback(null);
    }
  }
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var STS = __webpack_require__(151);

/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */
AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */
  constructor: function WebIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
    this.data = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    this.coalesceRefresh(callback || AWS.util.fn.callback);
  },

  /**
   * @api private
   */
  load: function load(callback) {
    var self = this;
    self.createClients();
    self.service.assumeRoleWithWebIdentity(function (err, data) {
      self.data = null;
      if (!err) {
        self.data = data;
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    if (!this.service) {
      var stsConfig = AWS.util.merge({}, this._clientConfig);
      stsConfig.params = this.params;
      this.service = new STS(stsConfig);
    }
  }

});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var CognitoIdentity = __webpack_require__(1169);
var STS = __webpack_require__(151);

/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */
AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * @api private
   */
  localStorageKey: {
    id: 'aws.cognito.identity-id.',
    providers: 'aws.cognito.identity-providers.'
  },

  /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */
  constructor: function CognitoIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.data = null;
    this._identityId = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
    this.loadCachedId();
    var self = this;
    Object.defineProperty(this, 'identityId', {
      get: function() {
        self.loadCachedId();
        return self._identityId || self.params.IdentityId;
      },
      set: function(identityId) {
        self._identityId = identityId;
      }
    });
  },

  /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */
  refresh: function refresh(callback) {
    this.coalesceRefresh(callback || AWS.util.fn.callback);
  },

  /**
   * @api private
   * @param callback
   */
  load: function load(callback) {
    var self = this;
    self.createClients();
    self.data = null;
    self._identityId = null;
    self.getId(function(err) {
      if (!err) {
        if (!self.params.RoleArn) {
          self.getCredentialsForIdentity(callback);
        } else {
          self.getCredentialsFromSTS(callback);
        }
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */
  clearCachedId: function clearCache() {
    this._identityId = null;
    delete this.params.IdentityId;

    var poolId = this.params.IdentityPoolId;
    var loginId = this.params.LoginId || '';
    delete this.storage[this.localStorageKey.id + poolId + loginId];
    delete this.storage[this.localStorageKey.providers + poolId + loginId];
  },

  /**
   * @api private
   */
  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
    var self = this;
    if (err.code == 'NotAuthorizedException') {
      self.clearCachedId();
    }
  },

  /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */
  getId: function getId(callback) {
    var self = this;
    if (typeof self.params.IdentityId === 'string') {
      return callback(null, self.params.IdentityId);
    }

    self.cognito.getId(function(err, data) {
      if (!err && data.IdentityId) {
        self.params.IdentityId = data.IdentityId;
        callback(null, data.IdentityId);
      } else {
        callback(err);
      }
    });
  },


  /**
   * @api private
   */
  loadCredentials: function loadCredentials(data, credentials) {
    if (!data || !credentials) return;
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
  },

  /**
   * @api private
   */
  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
    var self = this;
    self.cognito.getCredentialsForIdentity(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.data = data;
        self.loadCredentials(self.data, self);
      } else {
        self.clearIdOnNotAuthorized(err);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
    var self = this;
    self.cognito.getOpenIdToken(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.params.WebIdentityToken = data.Token;
        self.webIdentityCredentials.refresh(function(webErr) {
          if (!webErr) {
            self.data = self.webIdentityCredentials.data;
            self.sts.credentialsFrom(self.data, self);
          }
          callback(webErr);
        });
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * @api private
   */
  loadCachedId: function loadCachedId() {
    var self = this;

    // in the browser we source default IdentityId from localStorage
    if (AWS.util.isBrowser() && !self.params.IdentityId) {
      var id = self.getStorage('id');
      if (id && self.params.Logins) {
        var actualProviders = Object.keys(self.params.Logins);
        var cachedProviders =
          (self.getStorage('providers') || '').split(',');

        // only load ID if at least one provider used this ID before
        var intersect = cachedProviders.filter(function(n) {
          return actualProviders.indexOf(n) !== -1;
        });
        if (intersect.length !== 0) {
          self.params.IdentityId = id;
        }
      } else if (id) {
        self.params.IdentityId = id;
      }
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    var clientConfig = this._clientConfig;
    this.webIdentityCredentials = this.webIdentityCredentials ||
      new AWS.WebIdentityCredentials(this.params, clientConfig);
    if (!this.cognito) {
      var cognitoConfig = AWS.util.merge({}, clientConfig);
      cognitoConfig.params = this.params;
      this.cognito = new CognitoIdentity(cognitoConfig);
    }
    this.sts = this.sts || new STS(clientConfig);
  },

  /**
   * @api private
   */
  cacheId: function cacheId(data) {
    this._identityId = data.IdentityId;
    this.params.IdentityId = this._identityId;

    // cache this IdentityId in browser localStorage if possible
    if (AWS.util.isBrowser()) {
      this.setStorage('id', data.IdentityId);

      if (this.params.Logins) {
        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
      }
    }
  },

  /**
   * @api private
   */
  getStorage: function getStorage(key) {
    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
  },

  /**
   * @api private
   */
  setStorage: function setStorage(key, val) {
    try {
      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
    } catch (_) {}
  },

  /**
   * @api private
   */
  storage: (function() {
    try {
      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
          window.localStorage : {};

      // Test set/remove which would throw an error in Safari's private browsing
      storage['aws.test-storage'] = 'foobar';
      delete storage['aws.test-storage'];

      return storage;
    } catch (_) {
      return {};
    }
  })()
});


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(277);
var AWS = __webpack_require__(13);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentity'] = {};
AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
__webpack_require__(1170);
Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(1171);
    model.paginators = __webpack_require__(1172).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentity;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);

AWS.util.update(AWS.CognitoIdentity.prototype, {
  getOpenIdToken: function getOpenIdToken(params, callback) {
    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
  },

  getId: function getId(params, callback) {
    return this.makeUnauthenticatedRequest('getId', params, callback);
  },

  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
  }
});


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"output":{"shape":"Sj"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Su"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sj"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sz"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Su"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sg"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"LoginsToRemove":{"shape":"Sv"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sj"},"output":{"shape":"Sj"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"Su":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sv"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"map","key":{},"value":{}},"S1b":{"type":"map","key":{},"value":{}},"S1d":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var STS = __webpack_require__(151);

/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */
AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */
  constructor: function SAMLCredentials(params) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    this.coalesceRefresh(callback || AWS.util.fn.callback);
  },

  /**
   * @api private
   */
  load: function load(callback) {
    var self = this;
    self.createClients();
    self.service.assumeRoleWithSAML(function (err, data) {
      if (!err) {
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(31);
var Shape = __webpack_require__(150);

function DomXmlParser() { }

DomXmlParser.prototype.parse = function(xml, shape) {
  if (xml.replace(/^\s+/, '') === '') return {};

  var result, error;
  try {
    if (window.DOMParser) {
      try {
        var parser = new DOMParser();
        result = parser.parseFromString(xml, 'text/xml');
      } catch (syntaxError) {
        throw util.error(new Error('Parse error in document'),
          {
            originalError: syntaxError,
            code: 'XMLParserError',
            retryable: true
          });
      }

      if (result.documentElement === null) {
        throw util.error(new Error('Cannot parse empty document.'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }

      var isError = result.getElementsByTagName('parsererror')[0];
      if (isError && (isError.parentNode === result ||
          isError.parentNode.nodeName === 'body' ||
          isError.parentNode.parentNode === result ||
          isError.parentNode.parentNode.nodeName === 'body')) {
        var errorElement = isError.getElementsByTagName('div')[0] || isError;
        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else if (window.ActiveXObject) {
      result = new window.ActiveXObject('Microsoft.XMLDOM');
      result.async = false;

      if (!result.loadXML(xml)) {
        throw util.error(new Error('Parse error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else {
      throw new Error('Cannot load XML parser');
    }
  } catch (e) {
    error = e;
  }

  if (result && result.documentElement && !error) {
    var data = parseXml(result.documentElement, shape);
    var metadata = getElementByTagName(result.documentElement, 'ResponseMetadata');
    if (metadata) {
      data.ResponseMetadata = parseXml(metadata, {});
    }
    return data;
  } else if (error) {
    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
  } else { // empty xml document
    return {};
  }
};

function getElementByTagName(xml, tag) {
  var elements = xml.getElementsByTagName(tag);
  for (var i = 0, iLen = elements.length; i < iLen; i++) {
    if (elements[i].parentNode === xml) {
      return elements[i];
    }
  }
}

function parseXml(xml, shape) {
  if (!shape) shape = {};
  switch (shape.type) {
    case 'structure': return parseStructure(xml, shape);
    case 'map': return parseMap(xml, shape);
    case 'list': return parseList(xml, shape);
    case undefined: case null: return parseUnknown(xml);
    default: return parseScalar(xml, shape);
  }
}

function parseStructure(xml, shape) {
  var data = {};
  if (xml === null) return data;

  util.each(shape.members, function(memberName, memberShape) {
    if (memberShape.isXmlAttribute) {
      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
        var value = xml.attributes[memberShape.name].value;
        data[memberName] = parseXml({textContent: value}, memberShape);
      }
    } else {
      var xmlChild = memberShape.flattened ? xml :
        getElementByTagName(xml, memberShape.name);
      if (xmlChild) {
        data[memberName] = parseXml(xmlChild, memberShape);
      } else if (!memberShape.flattened && memberShape.type === 'list') {
        data[memberName] = memberShape.defaultValue;
      }
    }
  });

  return data;
}

function parseMap(xml, shape) {
  var data = {};
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';
  var tagName = shape.flattened ? shape.name : 'entry';

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      var key = getElementByTagName(child, xmlKey).textContent;
      var value = getElementByTagName(child, xmlValue);
      data[key] = parseXml(value, shape.value);
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseList(xml, shape) {
  var data = [];
  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      data.push(parseXml(child, shape.member));
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseScalar(xml, shape) {
  if (xml.getAttribute) {
    var encoding = xml.getAttribute('encoding');
    if (encoding === 'base64') {
      shape = new Shape.create({type: encoding});
    }
  }

  var text = xml.textContent;
  if (text === '') text = null;
  if (typeof shape.toType === 'function') {
    return shape.toType(text);
  } else {
    return text;
  }
}

function parseUnknown(xml) {
  if (xml === undefined || xml === null) return '';

  // empty object
  if (!xml.firstElementChild) {
    if (xml.parentNode.parentNode === null) return {};
    if (xml.childNodes.length === 0) return '';
    else return xml.textContent;
  }

  // object, parse as structure
  var shape = {type: 'structure', members: {}};
  var child = xml.firstElementChild;
  while (child) {
    var tag = child.nodeName;
    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
      // multiple tags of the same name makes it a list
      shape.members[tag].type = 'list';
    } else {
      shape.members[tag] = {name: tag};
    }
    child = child.nextElementSibling;
  }
  return parseStructure(xml, shape);
}

/**
 * @api private
 */
module.exports = DomXmlParser;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(13);
var EventEmitter = __webpack_require__(173).EventEmitter;
__webpack_require__(505);

/**
 * @api private
 */
AWS.XHRClient = AWS.util.inherit({
  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
    var self = this;
    var endpoint = httpRequest.endpoint;
    var emitter = new EventEmitter();
    var href = endpoint.protocol + '//' + endpoint.hostname;
    if (endpoint.port !== 80 && endpoint.port !== 443) {
      href += ':' + endpoint.port;
    }
    href += httpRequest.path;

    var xhr = new XMLHttpRequest(), headersEmitted = false;
    httpRequest.stream = xhr;

    xhr.addEventListener('readystatechange', function() {
      try {
        if (xhr.status === 0) return; // 0 code is invalid
      } catch (e) { return; }

      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
        emitter.statusCode = xhr.status;
        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
        emitter.emit(
          'headers',
          emitter.statusCode,
          emitter.headers,
          xhr.statusText
        );
        headersEmitted = true;
      }
      if (this.readyState === this.DONE) {
        self.finishRequest(xhr, emitter);
      }
    }, false);
    xhr.upload.addEventListener('progress', function (evt) {
      emitter.emit('sendProgress', evt);
    });
    xhr.addEventListener('progress', function (evt) {
      emitter.emit('receiveProgress', evt);
    }, false);
    xhr.addEventListener('timeout', function () {
      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
    }, false);
    xhr.addEventListener('error', function () {
      errCallback(AWS.util.error(new Error('Network Failure'), {
        code: 'NetworkingError'
      }));
    }, false);
    xhr.addEventListener('abort', function () {
      errCallback(AWS.util.error(new Error('Request aborted'), {
        code: 'RequestAbortedError'
      }));
    }, false);

    callback(emitter);
    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
    AWS.util.each(httpRequest.headers, function (key, value) {
      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
        xhr.setRequestHeader(key, value);
      }
    });

    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
      xhr.timeout = httpOptions.timeout;
    }

    if (httpOptions.xhrWithCredentials) {
      xhr.withCredentials = true;
    }
    try { xhr.responseType = 'arraybuffer'; } catch (e) {}

    try {
      if (httpRequest.body) {
        xhr.send(httpRequest.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
      } else {
        throw err;
      }
    }

    return emitter;
  },

  parseHeaders: function parseHeaders(rawHeaders) {
    var headers = {};
    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
      var key = line.split(':', 1)[0];
      var value = line.substring(key.length + 2);
      if (key.length > 0) headers[key.toLowerCase()] = value;
    });
    return headers;
  },

  finishRequest: function finishRequest(xhr, emitter) {
    var buffer;
    if (xhr.responseType === 'arraybuffer' && xhr.response) {
      var ab = xhr.response;
      buffer = new AWS.util.Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
      }
    }

    try {
      if (!buffer && typeof xhr.responseText === 'string') {
        buffer = new AWS.util.Buffer(xhr.responseText);
      }
    } catch (e) {}

    if (buffer) emitter.emit('data', buffer);
    emitter.emit('end');
  }
});

/**
 * @api private
 */
AWS.HttpClient.prototype = AWS.XHRClient.prototype;

/**
 * @api private
 */
AWS.HttpClient.streamsApiVersion = 1;


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsoleLogger; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
};
/**
 * Write logs
 * @class Logger
 */
var ConsoleLogger = /** @class */ (function () {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */
    function ConsoleLogger(name, level) {
        if (level === void 0) { level = 'WARN'; }
        this.name = name;
        this.level = level;
    }
    ConsoleLogger.prototype._padding = function (n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function () {
        var dt = new Date();
        return ([this._padding(dt.getMinutes()), this._padding(dt.getSeconds())].join(':') +
            '.' +
            dt.getMilliseconds());
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype._log = function (type) {
        var msg = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            msg[_i - 1] = arguments[_i];
        }
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) {
            logger_level_name = ConsoleLogger.LOG_LEVEL;
        }
        if (typeof window !== 'undefined' && window.LOG_LEVEL) {
            logger_level_name = window.LOG_LEVEL;
        }
        var logger_level = LOG_LEVELS[logger_level_name];
        var type_level = LOG_LEVELS[type];
        if (!(type_level >= logger_level)) {
            // Do nothing if type is not greater than or equal to logger level (handle undefined)
            return;
        }
        var log = console.log.bind(console);
        if (type === 'ERROR' && console.error) {
            log = console.error.bind(console);
        }
        if (type === 'WARN' && console.warn) {
            log = console.warn.bind(console);
        }
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        if (msg.length === 1 && typeof msg[0] === 'string') {
            log(prefix + " - " + msg[0]);
        }
        else if (msg.length === 1) {
            log(prefix, msg[0]);
        }
        else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) {
                obj = obj[0];
            }
            log(prefix + " - " + msg[0], obj);
        }
        else {
            log(prefix, msg);
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.log = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spreadArrays(['INFO'], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.info = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spreadArrays(['INFO'], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.warn = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spreadArrays(['WARN'], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.error = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spreadArrays(['ERROR'], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.debug = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spreadArrays(['DEBUG'], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.verbose = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spreadArrays(['VERBOSE'], msg));
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}());

//# sourceMappingURL=ConsoleLogger.js.map

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser__ = __webpack_require__(1178);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var ClientDevice = /** @class */ (function () {
    function ClientDevice() {
    }
    ClientDevice.clientInfo = function () {
        return __WEBPACK_IMPORTED_MODULE_0__browser__["a" /* clientInfo */]();
    };
    ClientDevice.dimension = function () {
        return __WEBPACK_IMPORTED_MODULE_0__browser__["b" /* dimension */]();
    };
    return ClientDevice;
}());
/* harmony default export */ __webpack_exports__["a"] = (ClientDevice);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = dimension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('ClientDevice_Browser');
function clientInfo() {
    if (typeof window === 'undefined') {
        return {};
    }
    return browserClientInfo();
}
function browserClientInfo() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = browserType(userAgent);
    var timezone = browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [type.type, type.version].join('/'),
        language: language,
        timezone: timezone,
    };
}
function dimension() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return { width: 320, height: 320 };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
function browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) {
        return { type: operaMatch[1], version: operaMatch[2] };
    }
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) {
        return { type: ieMatch[1], version: ieMatch[2] };
    }
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) {
        return { type: cfMatch[1], version: cfMatch[2] };
    }
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) {
        return { type: sMatch[1], version: sMatch[2] };
    }
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) {
        return { type: awkMatch[1], version: awkMatch[2] };
    }
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) {
        return { type: anyMatch[1], version: anyMatch[2] };
    }
    return { type: '', version: '' };
}
//# sourceMappingURL=browser.js.map

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = missingConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = invalidParameter;
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
function missingConfig(name) {
    return new Error('Missing config value of ' + name);
}
function invalidParameter(name) {
    return new Error('Invalid parameter value of ' + name);
}
//# sourceMappingURL=Errors.js.map

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HubClass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Hub');
var AMPLIFY_SYMBOL = (typeof Symbol !== 'undefined' &&
    typeof Symbol.for === 'function'
    ? Symbol.for('amplify_default')
    : '@@amplify_default');
function isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var HubClass = /** @class */ (function () {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'xr',
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function (channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function (_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = __spreadArrays(this.patterns.filter(function (x) { return x !== pattern_1; }));
        }
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = __spreadArrays(holder.filter(function (_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function (channel, payload, source, ampSymbol) {
        if (source === void 0) { source = ''; }
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === AMPLIFY_SYMBOL;
            if (!hasAccess) {
                logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
            }
        }
        var capsule = {
            channel: channel,
            payload: __assign({}, payload),
            source: source,
            patternInfo: [],
        };
        try {
            this._toListeners(capsule);
        }
        catch (e) {
            logger.error(e);
        }
    };
    HubClass.prototype.listen = function (channel, callback, listenerName) {
        if (listenerName === void 0) { listenerName = 'noname'; }
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if (isLegacyCallback(callback)) {
            logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        }
        else if (typeof callback !== 'function') {
            throw new Error('No callback supplied to Hub');
        }
        else {
            cb = callback;
        }
        if (channel instanceof RegExp) {
            this.patterns.push({
                pattern: channel,
                callback: cb,
            });
        }
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb,
            });
        }
    };
    HubClass.prototype._toListeners = function (capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) {
            holder.forEach(function (listener) {
                logger.debug("Dispatching to " + channel + " with ", payload);
                try {
                    listener.callback(capsule);
                }
                catch (e) {
                    logger.error(e);
                }
            });
        }
        if (this.patterns.length > 0) {
            if (!payload.message) {
                logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function (pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var groups = match.slice(1);
                    var dispatchingCapsule = __assign(__assign({}, capsule), { patternInfo: groups });
                    try {
                        pattern.callback(dispatchingCapsule);
                    }
                    catch (e) {
                        logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}());

/*We export a __default__ instance of HubClass to use it as a
psuedo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events.*/
var Hub = new HubClass('__default__');
/* harmony default export */ __webpack_exports__["a"] = (Hub);
//# sourceMappingURL=Hub.js.map

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__I18n__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Amplify__ = __webpack_require__(201);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



var logger = new __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* ConsoleLogger */]('I18n');
var _config = null;
var _i18n = null;
/**
 * Export I18n APIs
 */
var I18n = /** @class */ (function () {
    function I18n() {
    }
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */
    I18n.configure = function (config) {
        logger.debug('configure I18n');
        if (!config) {
            return _config;
        }
        _config = Object.assign({}, _config, config.I18n || config);
        I18n.createInstance();
        return _config;
    };
    I18n.getModuleName = function () {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */
    I18n.createInstance = function () {
        logger.debug('create I18n instance');
        if (_i18n) {
            return;
        }
        _i18n = new __WEBPACK_IMPORTED_MODULE_0__I18n__["a" /* I18n */](_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */
    I18n.setLanguage = function (lang) {
        I18n.checkConfig();
        return _i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */
    I18n.get = function (key, defVal) {
        if (!I18n.checkConfig()) {
            return typeof defVal === 'undefined' ? key : defVal;
        }
        return _i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */
    I18n.putVocabulariesForLanguage = function (language, vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */
    I18n.putVocabularies = function (vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function () {
        if (!_i18n) {
            _i18n = new __WEBPACK_IMPORTED_MODULE_0__I18n__["a" /* I18n */](_config);
        }
        return true;
    };
    return I18n;
}());
__WEBPACK_IMPORTED_MODULE_2__Amplify__["a" /* default */].register(I18n);
/* harmony default export */ __webpack_exports__["a"] = (I18n);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('I18n');
/**
 * Language transition class
 */
var I18n = /** @class */ (function () {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */
    function I18n(options) {
        /**
         * @private
         */
        this._options = null;
        /**
         * @private
         */
        this._lang = null;
        /**
         * @private
         */
        this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang &&
            typeof window !== 'undefined' &&
            window &&
            window.navigator) {
            this._lang = window.navigator.language;
        }
        logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */
    I18n.prototype.setLanguage = function (lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */
    I18n.prototype.get = function (key, defVal) {
        if (defVal === void 0) { defVal = undefined; }
        if (!this._lang) {
            return typeof defVal !== 'undefined' ? defVal : key;
        }
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) {
            return val;
        }
        if (lang.indexOf('-') > 0) {
            val = this.getByLanguage(key, lang.split('-')[0]);
        }
        if (val) {
            return val;
        }
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */
    I18n.prototype.getByLanguage = function (key, language, defVal) {
        if (defVal === void 0) { defVal = null; }
        if (!language) {
            return defVal;
        }
        var lang_dict = this._dict[language];
        if (!lang_dict) {
            return defVal;
        }
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */
    I18n.prototype.putVocabulariesForLanguage = function (language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) {
            lang_dict = this._dict[language] = {};
        }
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */
    I18n.prototype.putVocabularies = function (vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function (key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}());

//# sourceMappingURL=I18n.js.map

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Facet__ = __webpack_require__(198);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Signer'), url = __webpack_require__(509), crypto = __WEBPACK_IMPORTED_MODULE_1__Facet__["a" /* AWS */]['util'].crypto;
var DEFAULT_ALGORITHM = 'AWS4-HMAC-SHA256';
var IOT_SERVICE_NAME = 'iotdevicegateway';
var encrypt = function (key, src, encoding) {
    return crypto.lib
        .createHmac('sha256', key)
        .update(src, 'utf8')
        .digest(encoding);
};
var hash = function (src) {
    var arg = src || '';
    return crypto
        .createHash('sha256')
        .update(arg, 'utf8')
        .digest('hex');
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */
var escape_RFC3986 = function (component) {
    return component.replace(/[!'()*]/g, function (c) {
        return ('%' +
            c
                .charCodeAt(0)
                .toString(16)
                .toUpperCase());
    });
};
/**
 * @private
 * Create canonical query string
 *
 */
var canonical_query = function (query) {
    if (!query || query.length === 0) {
        return '';
    }
    return query
        .split('&')
        .map(function (e) {
        var key_val = e.split('=');
        if (key_val.length === 1) {
            return e;
        }
        else {
            var reencoded_val = escape_RFC3986(key_val[1]);
            return key_val[0] + '=' + reencoded_val;
        }
    })
        .sort(function (a, b) {
        var key_a = a.split('=')[0];
        var key_b = b.split('=')[0];
        if (key_a === key_b) {
            return a < b ? -1 : 1;
        }
        else {
            return key_a < key_b ? -1 : 1;
        }
    })
        .join('&');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/
var canonical_headers = function (headers) {
    if (!headers || Object.keys(headers).length === 0) {
        return '';
    }
    return (Object.keys(headers)
        .map(function (key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : '',
        };
    })
        .sort(function (a, b) {
        return a.key < b.key ? -1 : 1;
    })
        .map(function (item) {
        return item.key + ':' + item.value;
    })
        .join('\n') + '\n');
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */
var signed_headers = function (headers) {
    return Object.keys(headers)
        .map(function (key) {
        return key.toLowerCase();
    })
        .sort()
        .join(';');
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/
var canonical_request = function (request) {
    var url_info = url.parse(request.url);
    return [
        request.method || '/',
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'),
        canonical_query(url_info.query),
        canonical_headers(request.headers),
        signed_headers(request.headers),
        hash(request.data),
    ].join('\n');
};
var parse_service_info = function (request) {
    var url_info = url.parse(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') {
        // Elastic Search
        parsed = parsed.reverse();
    }
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1],
    };
};
var credential_scope = function (d_str, region, service) {
    return [d_str, region, service, 'aws4_request'].join('/');
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/
var string_to_sign = function (algorithm, canonical_request, dt_str, scope) {
    return [algorithm, dt_str, scope, hash(canonical_request)].join('\n');
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/
var get_signing_key = function (secret_key, d_str, service_info) {
    logger.debug(service_info);
    var k = 'AWS4' + secret_key, k_date = encrypt(k, d_str), k_region = encrypt(k_date, service_info.region), k_service = encrypt(k_region, service_info.service), k_signing = encrypt(k_service, 'aws4_request');
    return k_signing;
};
var get_signature = function (signing_key, str_to_sign) {
    return encrypt(signing_key, str_to_sign, 'hex');
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */
var get_authorization_header = function (algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature,
    ].join(', ');
};
/**
 * AWS request signer.
 * Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
 *
 * @class Signer
 */
var Signer = /** @class */ (function () {
    function Signer() {
    }
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */
    Signer.sign = function (request, access_info, service_info) {
        if (service_info === void 0) { service_info = null; }
        request.headers = request.headers || {};
        // datetime string and date string
        var dt = new Date(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8);
        var url_info = url.parse(request.url);
        request.headers['host'] = url_info.host;
        request.headers['x-amz-date'] = dt_str;
        if (access_info.session_token) {
            request.headers['X-Amz-Security-Token'] = access_info.session_token;
        }
        // Task 1: Create a Canonical Request
        var request_str = canonical_request(request);
        logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || parse_service_info(request), scope = credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = string_to_sign(DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = get_authorization_header(DEFAULT_ALGORITHM, access_info.access_key, scope, signed_headers(request.headers), signature);
        request.headers['Authorization'] = authorization_header;
        return request;
    };
    Signer.signUrl = function (urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        var body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        var now = new Date().toISOString().replace(/[:\-]|\.\d{3}/g, '');
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = url.parse(urlToSign, true, true), search = _a.search, parsedUrl = __rest(_a, ["search"]);
        var host = parsedUrl.host;
        var signedHeaders = { host: host };
        var _b = serviceInfo || parse_service_info({ url: url.format(parsedUrl) }), region = _b.region, service = _b.service;
        var credentialScope = credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== IOT_SERVICE_NAME;
        var queryParams = __assign(__assign(__assign({ 'X-Amz-Algorithm': DEFAULT_ALGORITHM, 'X-Amz-Credential': [accessInfo.access_key, credentialScope].join('/'), 'X-Amz-Date': now.substr(0, 16) }, (sessionTokenRequired
            ? { 'X-Amz-Security-Token': "" + accessInfo.session_token }
            : {})), (expiration ? { 'X-Amz-Expires': "" + expiration } : {})), { 'X-Amz-SignedHeaders': Object.keys(signedHeaders).join(',') });
        var canonicalRequest = canonical_request({
            method: method,
            url: url.format(__assign(__assign({}, parsedUrl), { query: __assign(__assign({}, parsedUrl.query), queryParams) })),
            headers: signedHeaders,
            data: body,
        });
        var stringToSign = string_to_sign(DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service,
        });
        var signature = get_signature(signing_key, stringToSign);
        var additionalQueryParams = __assign({ 'X-Amz-Signature': signature }, (accessInfo.session_token && {
            'X-Amz-Security-Token': accessInfo.session_token,
        }));
        var result = url.format({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: __assign(__assign(__assign({}, parsedUrl.query), queryParams), additionalQueryParams),
        });
        return result;
    };
    return Signer;
}());
/* harmony default export */ __webpack_exports__["a"] = (Signer);
//# sourceMappingURL=Signer.js.map

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Parser');
var Parser = /** @class */ (function () {
    function Parser() {
    }
    Parser.parseMobilehubConfig = function (config) {
        var amplifyConfig = {};
        // Analytics
        if (config['aws_mobile_analytics_app_id']) {
            var Analytics = {
                AWSPinpoint: {
                    appId: config['aws_mobile_analytics_app_id'],
                    region: config['aws_mobile_analytics_app_region'],
                },
            };
            amplifyConfig.Analytics = Analytics;
        }
        // Auth
        if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) {
            var Auth = {
                userPoolId: config['aws_user_pools_id'],
                userPoolWebClientId: config['aws_user_pools_web_client_id'],
                region: config['aws_cognito_region'],
                identityPoolId: config['aws_cognito_identity_pool_id'],
                mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable' ? true : false,
            };
            amplifyConfig.Auth = Auth;
        }
        // Storage
        var storageConfig;
        if (config['aws_user_files_s3_bucket']) {
            storageConfig = {
                AWSS3: {
                    bucket: config['aws_user_files_s3_bucket'],
                    region: config['aws_user_files_s3_bucket_region'],
                    dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing'],
                },
            };
        }
        else {
            storageConfig = config ? config.Storage || config : {};
        }
        amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
        amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
        amplifyConfig.Storage = Object.assign({}, storageConfig);
        logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
        return amplifyConfig;
    };
    return Parser;
}());
/* harmony default export */ __webpack_exports__["a"] = (Parser);
//# sourceMappingURL=Parser.js.map

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(125);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('CognitoCredentials');
var waitForInit = new Promise(function (res, rej) {
    if (!__WEBPACK_IMPORTED_MODULE_1__JS__["a" /* default */].browserOrNode().isBrowser) {
        logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        logger.debug('google api already loaded');
        return res();
    }
    else {
        setTimeout(function () {
            return res();
        }, 2000);
    }
});
var GoogleOAuth = /** @class */ (function () {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.initialized) return [3 /*break*/, 2];
                        logger.debug('need to wait for the Google SDK loaded');
                        return [4 /*yield*/, waitForInit];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug('finish waiting');
                        _a.label = 2;
                    case 2: return [2 /*return*/, this._refreshGoogleTokenImpl()];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function () {
        var ga = null;
        if (__WEBPACK_IMPORTED_MODULE_1__JS__["a" /* default */].browserOrNode().isBrowser)
            ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function (res, rej) {
            ga.getAuthInstance()
                .then(function (googleAuth) {
                if (!googleAuth) {
                    console.log('google Auth undefiend');
                    rej('google Auth undefiend');
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    logger.debug('refreshing the google access token');
                    googleUser.reloadAuthResponse().then(function (authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        var profile = googleUser.getBasicProfile();
                        var user = {
                            email: profile.getEmail(),
                            name: profile.getName(),
                        };
                        res({ token: id_token, expires_at: expires_at });
                    });
                }
                else {
                    rej('User is not signed in with Google');
                }
            })
                .catch(function (err) {
                logger.debug('Failed to refresh google token', err);
                rej('Failed to refresh google token');
            });
        });
    };
    return GoogleOAuth;
}());
/* harmony default export */ __webpack_exports__["a"] = (GoogleOAuth);
//# sourceMappingURL=GoogleOAuth.js.map

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(125);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('CognitoCredentials');
var waitForInit = new Promise(function (res, rej) {
    if (!__WEBPACK_IMPORTED_MODULE_1__JS__["a" /* default */].browserOrNode().isBrowser) {
        logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        logger.debug('FB SDK already loaded');
        return res();
    }
    else {
        setTimeout(function () {
            return res();
        }, 2000);
    }
});
var FacebookOAuth = /** @class */ (function () {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.initialized) return [3 /*break*/, 2];
                        logger.debug('need to wait for the Facebook SDK loaded');
                        return [4 /*yield*/, waitForInit];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug('finish waiting');
                        _a.label = 2;
                    case 2: return [2 /*return*/, this._refreshFacebookTokenImpl()];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function () {
        var fb = null;
        if (__WEBPACK_IMPORTED_MODULE_1__JS__["a" /* default */].browserOrNode().isBrowser)
            fb = window['FB'];
        if (!fb) {
            logger.debug('no fb sdk available');
            return Promise.reject('no fb sdk available');
        }
        return new Promise(function (res, rej) {
            fb.getLoginStatus(function (fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    logger.debug('no response from facebook when refreshing the jwt token');
                    rej('no response from facebook when refreshing the jwt token');
                }
                var response = fbResponse.authResponse;
                var accessToken = response.accessToken, expiresIn = response.expiresIn;
                var date = new Date();
                var expires_at = expiresIn * 1000 + date.getTime();
                if (!accessToken) {
                    logger.debug('the jwtToken is undefined');
                    rej('the jwtToken is undefined');
                }
                res({ token: accessToken, expires_at: expires_at });
            }, { scope: 'public_profile,email' });
        });
    };
    return FacebookOAuth;
}());
/* harmony default export */ __webpack_exports__["a"] = (FacebookOAuth);
//# sourceMappingURL=FacebookOAuth.js.map

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Linking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AsyncStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JS__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageHelper__ = __webpack_require__(284);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var Linking = {};
var AppState = {
    addEventListener: function (action, handler) {
        return;
    },
};
// if not in react native, just use local storage
var AsyncStorage = __WEBPACK_IMPORTED_MODULE_0__JS__["a" /* default */].browserOrNode().isBrowser
    ? new __WEBPACK_IMPORTED_MODULE_1__StorageHelper__["b" /* default */]().getStorage()
    : undefined;

//# sourceMappingURL=index.js.map

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Credentials */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageHelper__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Facet__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JS__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OAuthHelper__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Amplify__ = __webpack_require__(201);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};






var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Credentials');
var Credentials = /** @class */ (function () {
    function Credentials(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        this.configure(config);
        this._refreshHandlers['google'] = __WEBPACK_IMPORTED_MODULE_4__OAuthHelper__["b" /* GoogleOAuth */].refreshGoogleToken;
        this._refreshHandlers['facebook'] = __WEBPACK_IMPORTED_MODULE_4__OAuthHelper__["a" /* FacebookOAuth */].refreshFacebookToken;
    }
    Credentials.prototype.getCredSource = function () {
        return this._credentials_source;
    };
    Credentials.prototype.configure = function (config) {
        if (!config)
            return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) {
            this._refreshHandlers = __assign(__assign({}, this._refreshHandlers), refreshHandlers);
        }
        this._storage = this._config.storage;
        if (!this._storage) {
            this._storage = new __WEBPACK_IMPORTED_MODULE_1__StorageHelper__["b" /* default */]().getStorage();
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') {
            this._storageSync = this._storage['sync']();
        }
        return this._config;
    };
    Credentials.prototype.get = function () {
        logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    Credentials.prototype._pickupCredentials = function () {
        logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            logger.debug('getting new cred promise');
            if (__WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].config &&
                __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].config.credentials &&
                __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].config.credentials instanceof __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].Credentials) {
                this._gettingCredPromise = __WEBPACK_IMPORTED_MODULE_3__JS__["a" /* default */].makeQuerablePromise(this._setCredentialsFromAWS());
            }
            else {
                this._gettingCredPromise = __WEBPACK_IMPORTED_MODULE_3__JS__["a" /* default */].makeQuerablePromise(this._keepAlive());
            }
        }
        else {
            logger.debug('getting old cred promise');
        }
        return this._gettingCredPromise;
    };
    Credentials.prototype._keepAlive = function () {
        logger.debug('checking if credentials exists and not expired');
        var cred = this._credentials;
        if (cred && !this._isExpired(cred)) {
            logger.debug('credentials not changed and not expired, directly return');
            return Promise.resolve(cred);
        }
        logger.debug('need to get a new credential or refresh the existing one');
        if (__WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Auth &&
            typeof __WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Auth.currentUserCredentials === 'function') {
            return __WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Auth.currentUserCredentials();
        }
        else {
            return Promise.reject('No Auth module registered in Amplify');
        }
    };
    Credentials.prototype.refreshFederatedToken = function (federatedInfo) {
        var _this = this;
        logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user;
        var token = federatedInfo.token;
        var expires_at = federatedInfo.expires_at;
        var identity_id = federatedInfo.identity_id;
        var that = this;
        logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at,
            });
        }
        else {
            // if refresh handler exists
            if (that._refreshHandlers[provider] &&
                typeof that._refreshHandlers[provider] === 'function') {
                logger.debug('getting refreshed jwt token from federation provider');
                return that._refreshHandlers[provider]()
                    .then(function (data) {
                    logger.debug('refresh federated token sucessfully', data);
                    token = data.token;
                    identity_id = data.identity_id;
                    expires_at = data.expires_at;
                    return that._setCredentialsFromFederation({
                        provider: provider,
                        token: token,
                        user: user,
                        identity_id: identity_id,
                        expires_at: expires_at,
                    });
                })
                    .catch(function (e) {
                    logger.debug('refresh federated token failed', e);
                    _this.clear();
                    return Promise.reject('refreshing federation token failed: ' + e);
                });
            }
            else {
                logger.debug('no refresh handler for provider:', provider);
                this.clear();
                return Promise.reject('no refresh handler for provider');
            }
        }
    };
    Credentials.prototype._isExpired = function (credentials) {
        if (!credentials) {
            logger.debug('no credentials for expiration check');
            return true;
        }
        logger.debug('is this credentials expired?', credentials);
        var ts = new Date().getTime();
        var delta = 10 * 60 * 1000; // 10 minutes
        var expired = credentials.expired, expireTime = credentials.expireTime;
        if (!expired && expireTime > ts + delta) {
            return false;
        }
        return true;
    };
    Credentials.prototype._setCredentialsForGuest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var attempted, _a, identityPoolId, region, mandatorySignIn, identityId, e_1, credentials, that;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        attempted = false;
                        logger.debug('setting credentials for guest');
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) {
                            return [2 /*return*/, Promise.reject('cannot get guest credentials when mandatory signin enabled')];
                        }
                        if (!identityPoolId) {
                            logger.debug('No Cognito Federated Identity pool provided');
                            return [2 /*return*/, Promise.reject('No Cognito Federated Identity pool provided')];
                        }
                        identityId = undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._storageSync];
                    case 2:
                        _b.sent();
                        identityId = this._storage.getItem('CognitoIdentityId-' + identityPoolId);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        logger.debug('Failed to get the cached identityId', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        credentials = new __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].CognitoIdentityCredentials({
                            IdentityPoolId: identityPoolId,
                            IdentityId: identityId ? identityId : undefined,
                        }, {
                            region: region,
                        });
                        that = this;
                        return [2 /*return*/, this._loadCredentials(credentials, 'guest', false, null)
                                .then(function (res) {
                                return res;
                            })
                                .catch(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var newCredentials;
                                return __generator(this, function (_a) {
                                    // If identity id is deleted in the console, we make one attempt to recreate it
                                    // and remove existing id from cache.
                                    if (e.code === 'ResourceNotFoundException' &&
                                        e.message === "Identity '" + identityId + "' not found." &&
                                        !attempted) {
                                        attempted = true;
                                        logger.debug('Failed to load guest credentials');
                                        this._storage.removeItem('CognitoIdentityId-' + identityPoolId);
                                        credentials.clearCachedId();
                                        newCredentials = new __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].CognitoIdentityCredentials({
                                            IdentityPoolId: identityPoolId,
                                            IdentityId: undefined,
                                        }, {
                                            region: region,
                                        });
                                        return [2 /*return*/, this._loadCredentials(newCredentials, 'guest', false, null)];
                                    }
                                    else {
                                        return [2 /*return*/, e];
                                    }
                                    return [2 /*return*/];
                                });
                            }); })];
                }
            });
        });
    };
    Credentials.prototype._setCredentialsFromAWS = function () {
        var credentials = __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].config.credentials;
        logger.debug('setting credentials from aws');
        var that = this;
        if (credentials instanceof __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].Credentials) {
            return Promise.resolve(credentials);
        }
        else {
            logger.debug('AWS.config.credentials is not an instance of AWS Credentials');
            return Promise.reject('AWS.config.credentials is not an instance of AWS Credentials');
        }
    };
    Credentials.prototype._setCredentialsFromFederation = function (params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id, user = params.user, expires_at = params.expires_at;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com',
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) {
            return Promise.reject('You must specify a federated provider');
        }
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        var credentials = new __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
            IdentityId: identity_id,
            Logins: logins,
        }, {
            region: region,
        });
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    Credentials.prototype._setCredentialsFromSession = function (session) {
        logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var credentials = new __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
            Logins: logins,
        }, {
            region: region,
        });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    Credentials.prototype._loadCredentials = function (credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        var identityPoolId = this._config.identityPoolId;
        return new Promise(function (res, rej) {
            credentials.get(function (err) { return __awaiter(_this, void 0, void 0, function () {
                var user, provider, token, expires_at, identity_id, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (err) {
                                logger.debug('Failed to load credentials', credentials);
                                rej(err);
                                return [2 /*return*/];
                            }
                            logger.debug('Load credentials successfully', credentials);
                            that._credentials = credentials;
                            that._credentials.authenticated = authenticated;
                            that._credentials_source = source;
                            if (!(source === 'federated')) return [3 /*break*/, 3];
                            user = Object.assign({ id: this._credentials.identityId }, info.user);
                            provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                            try {
                                this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                    provider: provider,
                                    token: token,
                                    user: user,
                                    expires_at: expires_at,
                                    identity_id: identity_id,
                                }));
                            }
                            catch (e) {
                                logger.debug('Failed to put federated info into auth storage', e);
                            }
                            if (!(__WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Cache && typeof __WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Cache.setItem === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Cache.setItem('federatedInfo', {
                                    provider: provider,
                                    token: token,
                                    user: user,
                                    expires_at: expires_at,
                                    identity_id: identity_id,
                                }, { priority: 1 })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            logger.debug('No Cache module registered in Amplify');
                            _a.label = 3;
                        case 3:
                            if (!(source === 'guest')) return [3 /*break*/, 7];
                            _a.label = 4;
                        case 4:
                            _a.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, this._storageSync];
                        case 5:
                            _a.sent();
                            this._storage.setItem('CognitoIdentityId-' + identityPoolId, credentials.identityId);
                            return [3 /*break*/, 7];
                        case 6:
                            e_2 = _a.sent();
                            logger.debug('Failed to cache identityId', e_2);
                            return [3 /*break*/, 7];
                        case 7:
                            res(that._credentials);
                            return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    Credentials.prototype.set = function (params, source) {
        if (source === 'session') {
            return this._setCredentialsFromSession(params);
        }
        else if (source === 'federation') {
            return this._setCredentialsFromFederation(params);
        }
        else if (source === 'guest') {
            return this._setCredentialsForGuest();
        }
        else {
            logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    Credentials.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, identityPoolId, region, credentials;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
                        if (identityPoolId) {
                            credentials = new __WEBPACK_IMPORTED_MODULE_2__Facet__["a" /* AWS */].CognitoIdentityCredentials({
                                IdentityPoolId: identityPoolId,
                            }, {
                                region: region,
                            });
                            credentials.clearCachedId();
                        }
                        this._credentials = null;
                        this._credentials_source = null;
                        this._storage.removeItem('aws-amplify-federatedInfo');
                        if (!(__WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Cache && typeof __WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Cache.setItem === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__Amplify__["a" /* default */].Cache.removeItem('federatedInfo')];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        logger.debug('No Cache module registered in Amplify');
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */
    Credentials.prototype.shear = function (credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated,
        };
    };
    return Credentials;
}());

var instance = new Credentials(null);
/* harmony default export */ __webpack_exports__["a"] = (instance);
//# sourceMappingURL=Credentials.js.map

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceWorker__ = __webpack_require__(1190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ServiceWorker__["a"]; });
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Amplify__ = __webpack_require__(201);
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */
var ServiceWorkerClass = /** @class */ (function () {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */
        get: function () {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/
    ServiceWorkerClass.prototype.register = function (filePath, scope) {
        var _this = this;
        if (filePath === void 0) { filePath = '/service-worker.js'; }
        if (scope === void 0) { scope = '/'; }
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function (resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) {
                navigator.serviceWorker
                    .register(filePath, {
                    scope: scope,
                })
                    .then(function (registration) {
                    if (registration.installing) {
                        _this._serviceWorker = registration.installing;
                    }
                    else if (registration.waiting) {
                        _this._serviceWorker = registration.waiting;
                    }
                    else if (registration.active) {
                        _this._serviceWorker = registration.active;
                    }
                    _this._registration = registration;
                    _this._setupListeners();
                    _this._logger.debug("Service Worker Registration Success: " + registration);
                    return resolve(registration);
                })
                    .catch(function (error) {
                    _this._logger.debug("Service Worker Registration Failed " + error);
                    return reject(error);
                });
            }
            else {
                return reject(new Error('Service Worker not available'));
            }
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */
    ServiceWorkerClass.prototype.enablePush = function (publicKey) {
        var _this = this;
        if (!this._registration)
            throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function (resolve, reject) {
            if (__WEBPACK_IMPORTED_MODULE_1__JS__["a" /* default */].browserOrNode().isBrowser) {
                _this._registration.pushManager.getSubscription().then(function (subscription) {
                    if (subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }
                    else {
                        _this._logger.debug("User is NOT subscribed to push");
                        return _this._registration.pushManager
                            .subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: _this._urlB64ToUint8Array(publicKey),
                        })
                            .then(function (subscription) {
                            _this._subscription = subscription;
                            _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                            resolve(subscription);
                        })
                            .catch(function (error) {
                            _this._logger.error(error);
                        });
                    }
                });
            }
            else {
                return reject(new Error('Service Worker not available'));
            }
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */
    ServiceWorkerClass.prototype._urlB64ToUint8Array = function (base64String) {
        var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        var base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/
    ServiceWorkerClass.prototype.send = function (message) {
        if (this._serviceWorker) {
            this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
        }
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/
    ServiceWorkerClass.prototype._setupListeners = function () {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function (event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if (__WEBPACK_IMPORTED_MODULE_2__Amplify__["a" /* default */].Analytics && typeof __WEBPACK_IMPORTED_MODULE_2__Amplify__["a" /* default */].Analytics.record === 'function') {
                __WEBPACK_IMPORTED_MODULE_2__Amplify__["a" /* default */].Analytics.record({
                    name: 'ServiceWorker',
                    attributes: {
                        state: currentState,
                    },
                });
            }
        });
        this._serviceWorker.addEventListener('message', function (event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}());
/* harmony default export */ __webpack_exports__["a"] = (ServiceWorkerClass);
//# sourceMappingURL=ServiceWorker.js.map

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports = {"name":"@aws-amplify/core","version":"1.2.4","description":"Core category of aws-amplify","main":"./index.js","module":"./lib-esm/index.js","typings":"./lib-esm/index.d.ts","publishConfig":{"access":"public"},"scripts":{"test":"tslint 'src/**/*.ts' && jest -w 1 --coverage","build-with-test":"npm test && npm run build","build:cjs":"node ./build es5 && webpack && webpack --config ./webpack.config.dev.js","build:esm":"node ./build es6","build":"npm run clean && npm run build:esm && npm run build:cjs","clean":"rimraf lib-esm lib dist","format":"echo \"Not implemented\"","lint":"tslint 'src/**/*.ts'"},"react-native":{"./lib/ClientDevice":"./lib/ClientDevice/reactnative.js","./lib/RNComponents":"./lib/RNComponents/reactnative.js","./lib/StorageHelper":"./lib/StorageHelper/reactnative.js"},"repository":{"type":"git","url":"https://github.com/aws-amplify/amplify-js.git"},"author":"Amazon Web Services","license":"Apache-2.0","bugs":{"url":"https://github.com/aws/aws-amplify/issues"},"homepage":"https://aws-amplify.github.io/","devDependencies":{"find":"^0.2.7","prepend-file":"^1.3.1","prettier":"^1.7.4","typescript":"^3.2.2"},"dependencies":{"aws-sdk":"2.518.0","url":"^0.11.0"},"jest":{"globals":{"ts-jest":{"diagnostics":false,"tsConfig":{"lib":["es5","es2015","dom","esnext.asynciterable","es2017.object"],"allowJs":true}}},"transform":{"^.+\\.(js|jsx|ts|tsx)$":"ts-jest"},"testRegex":"(/__tests__/.*|\\.(test|spec))\\.(tsx?|jsx?)$","moduleFileExtensions":["ts","tsx","js","json","jsx"],"testEnvironment":"jsdom","coverageThreshold":{"global":{"branches":0,"functions":0,"lines":0,"statements":0}},"testURL":"http://localhost/","coveragePathIgnorePatterns":["/node_modules/"]},"gitHead":"c4fdc5ce1d754c7d690a92336f81f108db0f0b51"}

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var AuthenticationDetails = function () {
	/**
  * Constructs a new AuthenticationDetails object
  * @param {object=} data Creation options.
  * @param {string} data.Username User being authenticated.
  * @param {string} data.Password Plain-text password to authenticate with.
  * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
  * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
  */
	function AuthenticationDetails(data) {
		_classCallCheck(this, AuthenticationDetails);

		var _ref = data || {},
		    ValidationData = _ref.ValidationData,
		    Username = _ref.Username,
		    Password = _ref.Password,
		    AuthParameters = _ref.AuthParameters,
		    ClientMetadata = _ref.ClientMetadata;

		this.validationData = ValidationData || {};
		this.authParameters = AuthParameters || {};
		this.clientMetadata = ClientMetadata || {};
		this.username = Username;
		this.password = Password;
	}

	/**
  * @returns {string} the record's username
  */


	AuthenticationDetails.prototype.getUsername = function getUsername() {
		return this.username;
	};

	/**
  * @returns {string} the record's password
  */


	AuthenticationDetails.prototype.getPassword = function getPassword() {
		return this.password;
	};

	/**
  * @returns {Array} the record's validationData
  */


	AuthenticationDetails.prototype.getValidationData = function getValidationData() {
		return this.validationData;
	};

	/**
  * @returns {Array} the record's authParameters
  */


	AuthenticationDetails.prototype.getAuthParameters = function getAuthParameters() {
		return this.authParameters;
	};

	/**
  * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
  */


	AuthenticationDetails.prototype.getClientMetadata = function getClientMetadata() {
		return this.clientMetadata;
	};

	return AuthenticationDetails;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthenticationDetails);

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(96));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(96));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Client__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoUser__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StorageHelper__ = __webpack_require__(526);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */





/** @class */

var CognitoUserPool = function () {
	/**
  * Constructs a new CognitoUserPool object
  * @param {object} data Creation options.
  * @param {string} data.UserPoolId Cognito user pool id.
  * @param {string} data.ClientId User pool application client id.
  * @param {object} data.Storage Optional storage object.
  * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
  *        boolean flag indicating if the data collection is enabled
  *        to support cognito advanced security features. By default, this
  *        flag is set to true.
  */
	function CognitoUserPool(data) {
		_classCallCheck(this, CognitoUserPool);

		var _ref = data || {},
		    UserPoolId = _ref.UserPoolId,
		    ClientId = _ref.ClientId,
		    endpoint = _ref.endpoint,
		    AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;

		if (!UserPoolId || !ClientId) {
			throw new Error('Both UserPoolId and ClientId are required.');
		}
		if (!/^[\w-]+_.+$/.test(UserPoolId)) {
			throw new Error('Invalid UserPoolId format.');
		}
		var region = UserPoolId.split('_')[0];

		this.userPoolId = UserPoolId;
		this.clientId = ClientId;

		this.client = new __WEBPACK_IMPORTED_MODULE_0__Client__["a" /* default */](region, endpoint);

		/**
   * By default, AdvancedSecurityDataCollectionFlag is set to true,
   * if no input value is provided.
   */
		this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;

		this.storage = data.Storage || new __WEBPACK_IMPORTED_MODULE_2__StorageHelper__["a" /* default */]().getStorage();
	}

	/**
  * @returns {string} the user pool id
  */


	CognitoUserPool.prototype.getUserPoolId = function getUserPoolId() {
		return this.userPoolId;
	};

	/**
  * @returns {string} the client id
  */


	CognitoUserPool.prototype.getClientId = function getClientId() {
		return this.clientId;
	};

	/**
  * @typedef {object} SignUpResult
  * @property {CognitoUser} user New user.
  * @property {bool} userConfirmed If the user is already confirmed.
  */
	/**
  * method for signing up a user
  * @param {string} username User's username.
  * @param {string} password Plain-text initial password entered by user.
  * @param {(AttributeArg[])=} userAttributes New user attributes.
  * @param {(AttributeArg[])=} validationData Application metadata.
  * @param {(AttributeArg[])=} clientMetadata Client metadata.
  * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
  * @returns {void}
  */


	CognitoUserPool.prototype.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
		var _this = this;

		var jsonReq = {
			ClientId: this.clientId,
			Username: username,
			Password: password,
			UserAttributes: userAttributes,
			ValidationData: validationData,
			ClientMetadata: clientMetadata
		};
		if (this.getUserContextData(username)) {
			jsonReq.UserContextData = this.getUserContextData(username);
		}
		this.client.request('SignUp', jsonReq, function (err, data) {
			if (err) {
				return callback(err, null);
			}

			var cognitoUser = {
				Username: username,
				Pool: _this,
				Storage: _this.storage
			};

			var returnData = {
				user: new __WEBPACK_IMPORTED_MODULE_1__CognitoUser__["a" /* default */](cognitoUser),
				userConfirmed: data.UserConfirmed,
				userSub: data.UserSub,
				codeDeliveryDetails: data.CodeDeliveryDetails
			};

			return callback(null, returnData);
		});
	};

	/**
  * method for getting the current user of the application from the local storage
  *
  * @returns {CognitoUser} the user retrieved from storage
  */


	CognitoUserPool.prototype.getCurrentUser = function getCurrentUser() {
		var lastUserKey = 'CognitoIdentityServiceProvider.' + this.clientId + '.LastAuthUser';

		var lastAuthUser = this.storage.getItem(lastUserKey);
		if (lastAuthUser) {
			var cognitoUser = {
				Username: lastAuthUser,
				Pool: this,
				Storage: this.storage
			};

			return new __WEBPACK_IMPORTED_MODULE_1__CognitoUser__["a" /* default */](cognitoUser);
		}

		return null;
	};

	/**
  * This method returns the encoded data string used for cognito advanced security feature.
  * This would be generated only when developer has included the JS used for collecting the
  * data on their client. Please refer to documentation to know more about using AdvancedSecurity
  * features
  * @param {string} username the username for the context data
  * @returns {string} the user context data
  **/


	CognitoUserPool.prototype.getUserContextData = function getUserContextData(username) {
		if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
			return undefined;
		}
		/* eslint-disable */
		var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
		/* eslint-enable */

		if (this.advancedSecurityDataCollectionFlag) {
			var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
			if (advancedSecurityData) {
				var userContextData = {
					EncodedData: advancedSecurityData
				};
				return userContextData;
			}
		}
		return {};
	};

	return CognitoUserPool;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoUserPool);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserAgent__ = __webpack_require__(1197);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/** @class */

var Client = function () {
	/**
  * Constructs a new AWS Cognito Identity Provider client object
  * @param {string} region AWS region
  * @param {string} endpoint endpoint
  */
	function Client(region, endpoint) {
		_classCallCheck(this, Client);

		this.endpoint = endpoint || 'https://cognito-idp.' + region + '.amazonaws.com/';
		this.userAgent = __WEBPACK_IMPORTED_MODULE_0__UserAgent__["a" /* default */].prototype.userAgent || 'aws-amplify/0.1.x js';
	}

	/**
  * Makes an unauthenticated request on AWS Cognito Identity Provider API
  * using fetch
  * @param {string} operation API operation
  * @param {object} params Input parameters
  * @param {function} callback Callback called when a response is returned
  * @returns {void}
  */


	Client.prototype.request = function request(operation, params, callback) {
		var headers = {
			'Content-Type': 'application/x-amz-json-1.1',
			'X-Amz-Target': 'AWSCognitoIdentityProviderService.' + operation,
			'X-Amz-User-Agent': this.userAgent
		};

		var options = {
			headers: headers,
			method: 'POST',
			mode: 'cors',
			cache: 'no-cache',
			body: JSON.stringify(params)
		};

		var response = void 0;
		var responseJsonData = void 0;

		fetch(this.endpoint, options).then(function (resp) {
			response = resp;
			return resp;
		}, function (err) {
			// If error happens here, the request failed
			// if it is TypeError throw network error
			if (err instanceof TypeError) {
				throw new Error('Network error');
			}
			throw err;
		}).then(function (resp) {
			return resp.json().catch(function () {
				return {};
			});
		}).then(function (data) {
			// return parsed body stream
			if (response.ok) return callback(null, data);
			responseJsonData = data;

			// Taken from aws-sdk-js/lib/protocol/json.js
			// eslint-disable-next-line no-underscore-dangle
			var code = (data.__type || data.code).split('#').pop();
			var error = {
				code: code,
				name: code,
				message: data.message || data.Message || null
			};
			return callback(error);
		}).catch(function (err) {
			// first check if we have a service error
			if (response && response.headers && response.headers.get('x-amzn-errortype')) {
				try {
					var code = response.headers.get('x-amzn-errortype').split(':')[0];
					var error = {
						code: code,
						name: code,
						statusCode: response.status,
						message: response.status ? response.status.toString() : null
					};
					return callback(error);
				} catch (ex) {
					return callback(err);
				}
				// otherwise check if error is Network error
			} else if (err instanceof Error && err.message === 'Network error') {
				var _error = {
					code: 'NetworkError',
					name: err.name,
					message: err.message
				};
				return callback(_error);
			} else {
				return callback(err);
			}
		});
	};

	return Client;
}();

/* harmony default export */ __webpack_exports__["a"] = (Client);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// class for defining the amzn user-agent
/* harmony default export */ __webpack_exports__["a"] = (UserAgent);
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** @class */

var CookieStorage = function () {
	/**
  * Constructs a new CookieStorage object
  * @param {object} data Creation options.
  * @param {string} data.domain Cookies domain (mandatory).
  * @param {string} data.path Cookies path (default: '/')
  * @param {integer} data.expires Cookie expiration (in days, default: 365)
  * @param {boolean} data.secure Cookie secure flag (default: true)
  */
	function CookieStorage(data) {
		_classCallCheck(this, CookieStorage);

		if (data.domain) {
			this.domain = data.domain;
		} else {
			throw new Error('The domain of cookieStorage can not be undefined.');
		}
		if (data.path) {
			this.path = data.path;
		} else {
			this.path = '/';
		}
		if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
			this.expires = data.expires;
		} else {
			this.expires = 365;
		}
		if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
			this.secure = data.secure;
		} else {
			this.secure = true;
		}
	}

	/**
  * This is used to set a specific item in storage
  * @param {string} key - the key for the item
  * @param {object} value - the value
  * @returns {string} value that was set
  */


	CookieStorage.prototype.setItem = function setItem(key, value) {
		__WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"](key, value, {
			path: this.path,
			expires: this.expires,
			domain: this.domain,
			secure: this.secure
		});
		return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
	};

	/**
  * This is used to get a specific key from storage
  * @param {string} key - the key for the item
  * This is used to clear the storage
  * @returns {string} the data item
  */


	CookieStorage.prototype.getItem = function getItem(key) {
		return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
	};

	/**
  * This is used to remove an item from storage
  * @param {string} key - the key being set
  * @returns {string} value - value that was deleted
  */


	CookieStorage.prototype.removeItem = function removeItem(key) {
		return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](key, {
			path: this.path,
			domain: this.domain,
			secure: this.secure
		});
	};

	/**
  * This is used to clear the storage
  * @returns {string} nothing
  */


	CookieStorage.prototype.clear = function clear() {
		var cookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]();
		var index = void 0;
		for (index = 0; index < cookies.length; ++index) {
			__WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](cookies[index]);
		}
		return {};
	};

	return CookieStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (CookieStorage);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoAccessToken__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoAccessToken", function() { return __WEBPACK_IMPORTED_MODULE_0__CognitoAccessToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoIdToken__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoIdToken", function() { return __WEBPACK_IMPORTED_MODULE_1__CognitoIdToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoRefreshToken__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoRefreshToken", function() { return __WEBPACK_IMPORTED_MODULE_2__CognitoRefreshToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoTokenScopes__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoTokenScopes", function() { return __WEBPACK_IMPORTED_MODULE_3__CognitoTokenScopes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CognitoAuth__ = __webpack_require__(1200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoAuth", function() { return __WEBPACK_IMPORTED_MODULE_4__CognitoAuth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CognitoAuthSession__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoAuthSession", function() { return __WEBPACK_IMPORTED_MODULE_5__CognitoAuthSession__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateHelper__ = __webpack_require__(1202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateHelper", function() { return __WEBPACK_IMPORTED_MODULE_6__DateHelper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StorageHelper__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StorageHelper", function() { return __WEBPACK_IMPORTED_MODULE_7__StorageHelper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CookieStorage__ = __webpack_require__(1203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CookieStorage", function() { return __WEBPACK_IMPORTED_MODULE_8__CookieStorage__["a"]; });
/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */











/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoTokenScopes__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CognitoAuthSession__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StorageHelper__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UriHelper__ = __webpack_require__(1201);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
  * Amazon Cognito Auth SDK for JavaScript
  * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
  *
  * Licensed under the Apache License, Version 2.0 (the "License").
  * You may not use this file except in compliance with the License.
  * A copy of the License is located at
  *
  *         http://aws.amazon.com/apache2.0/
  *
  * or in the "license" file accompanying this file.
  * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
  * OR CONDITIONS OF ANY KIND, either express or implied. See the
  * License for the specific language governing permissions
  * and limitations under the License.
  */









/** @class */

var CognitoAuth = function () {
  /**
   * Constructs a new CognitoAuth object
   * @param {object} data Creation options
   * @param {string} data.ClientId Required: User pool application client id.
   * @param {string} data.AppWebDomain Required: The application/user-pools Cognito web hostname,
   *                     this is set at the Cognito console.
   * @param {array} data.TokenScopesArray Optional: The token scopes
   * @param {string} data.RedirectUriSignIn Required: The redirect Uri,
   * which will be launched after authentication as signed in.
   * @param {string} data.RedirectUriSignOut Required:
   * The redirect Uri, which will be launched when signed out.
   * @param {string} data.IdentityProvider Optional: Pre-selected identity provider (this allows to
   * automatically trigger social provider authentication flow).
   * @param {string} data.UserPoolId Optional: UserPoolId for the configured cognito userPool.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional: boolean flag indicating if the
   *        data collection is enabled to support cognito advanced security features. By default, this
   *        flag is set to true.
   * @param {object} data.Storage Optional: e.g. new CookieStorage(), to use the specified storage provided
   * @param {function} data.LaunchUri Optional: Function to open a url, by default uses window.open in browser, Linking.openUrl in React Native
   * @param {nodeCallback<CognitoAuthSession>} Optional: userhandler Called on success or error.
   */
  function CognitoAuth(data) {
    _classCallCheck(this, CognitoAuth);

    var _ref = data || {},
        ClientId = _ref.ClientId,
        AppWebDomain = _ref.AppWebDomain,
        TokenScopesArray = _ref.TokenScopesArray,
        RedirectUriSignIn = _ref.RedirectUriSignIn,
        RedirectUriSignOut = _ref.RedirectUriSignOut,
        IdentityProvider = _ref.IdentityProvider,
        UserPoolId = _ref.UserPoolId,
        AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag,
        Storage = _ref.Storage,
        LaunchUri = _ref.LaunchUri;

    if (data == null || !ClientId || !AppWebDomain || !RedirectUriSignIn || !RedirectUriSignOut) {
      throw new Error(this.getCognitoConstants().PARAMETERERROR);
    }

    this.clientId = ClientId;
    this.appWebDomain = AppWebDomain;
    this.TokenScopesArray = TokenScopesArray || [];
    if (!Array.isArray(TokenScopesArray)) {
      throw new Error(this.getCognitoConstants().SCOPETYPEERROR);
    }
    var tokenScopes = new __WEBPACK_IMPORTED_MODULE_0__CognitoTokenScopes__["a" /* default */](this.TokenScopesArray);
    this.RedirectUriSignIn = RedirectUriSignIn;
    this.RedirectUriSignOut = RedirectUriSignOut;
    this.IdentityProvider = IdentityProvider;
    this.responseType = this.getCognitoConstants().TOKEN;
    this.storage = Storage || new __WEBPACK_IMPORTED_MODULE_5__StorageHelper__["a" /* default */]().getStorage();
    this.username = this.getLastUser();
    this.userPoolId = UserPoolId;
    this.signInUserSession = this.getCachedSession();
    this.signInUserSession.setTokenScopes(tokenScopes);
    this.launchUri = typeof LaunchUri === 'function' ? LaunchUri : __WEBPACK_IMPORTED_MODULE_6__UriHelper__["a" /* launchUri */];

    /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true, if no input value is provided.
     */
    this.advancedSecurityDataCollectionFlag = true;
    if (AdvancedSecurityDataCollectionFlag) {
      this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag;
    }
  }

  /**
   * @returns {JSON} the constants
   */


  CognitoAuth.prototype.getCognitoConstants = function getCognitoConstants() {
    var CognitoConstants = {
      DOMAIN_SCHEME: 'https',
      DOMAIN_PATH_SIGNIN: 'oauth2/authorize',
      DOMAIN_PATH_TOKEN: 'oauth2/token',
      DOMAIN_PATH_SIGNOUT: 'logout',
      DOMAIN_QUERY_PARAM_REDIRECT_URI: 'redirect_uri',
      DOMAIN_QUERY_PARAM_SIGNOUT_URI: 'logout_uri',
      DOMAIN_QUERY_PARAM_RESPONSE_TYPE: 'response_type',
      DOMAIN_QUERY_PARAM_IDENTITY_PROVIDER: 'identity_provider',
      DOMAIN_QUERY_PARAM_USERCONTEXTDATA: 'userContextData',
      CLIENT_ID: 'client_id',
      STATE: 'state',
      SCOPE: 'scope',
      TOKEN: 'token',
      CODE: 'code',
      POST: 'POST',
      PARAMETERERROR: 'The parameters: App client Id, App web domain' + ', the redirect URL when you are signed in and the ' + 'redirect URL when you are signed out are required.',
      SCOPETYPEERROR: 'Scopes have to be array type. ',
      QUESTIONMARK: '?',
      POUNDSIGN: '#',
      COLONDOUBLESLASH: '://',
      SLASH: '/',
      AMPERSAND: '&',
      EQUALSIGN: '=',
      SPACE: ' ',
      CONTENTTYPE: 'Content-Type',
      CONTENTTYPEVALUE: 'application/x-www-form-urlencoded',
      AUTHORIZATIONCODE: 'authorization_code',
      IDTOKEN: 'id_token',
      ACCESSTOKEN: 'access_token',
      REFRESHTOKEN: 'refresh_token',
      ERROR: 'error',
      ERROR_DESCRIPTION: 'error_description',
      STRINGTYPE: 'string',
      STATELENGTH: 32,
      STATEORIGINSTRING: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
      WITHCREDENTIALS: 'withCredentials',
      UNDEFINED: 'undefined',
      HOSTNAMEREGEX: /:\/\/([0-9]?\.)?(.[^/:]+)/i,
      QUERYPARAMETERREGEX1: /#(.+)/,
      QUERYPARAMETERREGEX2: /=(.+)/,
      HEADER: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };
    return CognitoConstants;
  };

  /**
   * @returns {string} the client id
   */


  CognitoAuth.prototype.getClientId = function getClientId() {
    return this.clientId;
  };

  /**
   * @returns {string} the app web domain
   */


  CognitoAuth.prototype.getAppWebDomain = function getAppWebDomain() {
    return this.appWebDomain;
  };

  /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoAuth} the user retrieved from storage
   */


  CognitoAuth.prototype.getCurrentUser = function getCurrentUser() {
    var lastUserKey = 'CognitoIdentityServiceProvider.' + this.clientId + '.LastAuthUser';

    var lastAuthUser = this.storage.getItem(lastUserKey);
    return lastAuthUser;
  };

  /**
   * @param {string} Username the user's name
   * method for setting the current user's name
   * @returns {void}
   */


  CognitoAuth.prototype.setUser = function setUser(Username) {
    this.username = Username;
  };

  /**
   * sets response type to 'code'
   * @returns {void}
   */


  CognitoAuth.prototype.useCodeGrantFlow = function useCodeGrantFlow() {
    this.responseType = this.getCognitoConstants().CODE;
  };

  /**
   * sets response type to 'token'
   * @returns {void}
   */


  CognitoAuth.prototype.useImplicitFlow = function useImplicitFlow() {
    this.responseType = this.getCognitoConstants().TOKEN;
  };

  /**
   * @returns {CognitoAuthSession} the current session for this user
   */


  CognitoAuth.prototype.getSignInUserSession = function getSignInUserSession() {
    return this.signInUserSession;
  };

  /**
   * @returns {string} the user's username
   */


  CognitoAuth.prototype.getUsername = function getUsername() {
    return this.username;
  };

  /**
   * @param {string} Username the user's username
   * @returns {void}
   */


  CognitoAuth.prototype.setUsername = function setUsername(Username) {
    this.username = Username;
  };

  /**
   * @returns {string} the user's state
   */


  CognitoAuth.prototype.getState = function getState() {
    return this.state;
  };

  /**
   * @param {string} State the user's state
   * @returns {void}
   */


  CognitoAuth.prototype.setState = function setState(State) {
    this.state = State;
  };

  /**
   * This is used to get a session, either from the session object
   * or from the local storage, or by using a refresh token
   * @param {string} RedirectUriSignIn Required: The redirect Uri,
   * which will be launched after authentication.
   * @param {array} TokenScopesArray Required: The token scopes, it is an
   * array of strings specifying all scopes for the tokens.
   * @returns {void}
   */


  CognitoAuth.prototype.getSession = function getSession() {
    var tokenScopesInputSet = new Set(this.TokenScopesArray);
    var cachedScopesSet = new Set(this.signInUserSession.tokenScopes.getScopes());
    var URL = this.getFQDNSignIn();
    if (this.signInUserSession != null && this.signInUserSession.isValid()) {
      return this.userhandler.onSuccess(this.signInUserSession);
    }
    this.signInUserSession = this.getCachedSession();
    // compare scopes
    if (!this.compareSets(tokenScopesInputSet, cachedScopesSet)) {
      var tokenScopes = new __WEBPACK_IMPORTED_MODULE_0__CognitoTokenScopes__["a" /* default */](this.TokenScopesArray);
      var idToken = new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */]();
      var accessToken = new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */]();
      var refreshToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__["a" /* default */]();
      this.signInUserSession.setTokenScopes(tokenScopes);
      this.signInUserSession.setIdToken(idToken);
      this.signInUserSession.setAccessToken(accessToken);
      this.signInUserSession.setRefreshToken(refreshToken);
      this.launchUri(URL);
    } else if (this.signInUserSession.isValid()) {
      return this.userhandler.onSuccess(this.signInUserSession);
    } else if (!this.signInUserSession.getRefreshToken() || !this.signInUserSession.getRefreshToken().getToken()) {
      this.launchUri(URL);
    } else {
      this.refreshSession(this.signInUserSession.getRefreshToken().getToken());
    }
    return undefined;
  };

  /**
   * @param {string} httpRequestResponse the http request response
   * @returns {void}
   * Parse the http request response and proceed according to different response types.
   */


  CognitoAuth.prototype.parseCognitoWebResponse = function parseCognitoWebResponse(httpRequestResponse) {
    var map = void 0;
    if (httpRequestResponse.indexOf(this.getCognitoConstants().QUESTIONMARK) > -1) {
      // for code type
      // this is to avoid a bug exists when sign in with Google or facebook
      // Sometimes the code will contain a poundsign in the end which breaks the parsing
      var response = httpRequestResponse.split(this.getCognitoConstants().POUNDSIGN)[0];
      map = this.getQueryParameters(response, this.getCognitoConstants().QUESTIONMARK);
      if (map.has(this.getCognitoConstants().ERROR)) {
        return this.userhandler.onFailure(map.get(this.getCognitoConstants().ERROR_DESCRIPTION));
      }
      this.getCodeQueryParameter(map);
    } else if (httpRequestResponse.indexOf(this.getCognitoConstants().POUNDSIGN) > -1) {
      // for token type
      map = this.getQueryParameters(httpRequestResponse, this.getCognitoConstants().QUERYPARAMETERREGEX1);
      if (map.has(this.getCognitoConstants().ERROR)) {
        return this.userhandler.onFailure(map.get(this.getCognitoConstants().ERROR_DESCRIPTION));
      }
      // To use the map to get tokens
      this.getTokenQueryParameter(map);
    }
  };

  /**
   * @param {map} Query parameter map 
   * @returns {void}
   * Get the query parameter map and proceed according to code response type.
   */


  CognitoAuth.prototype.getCodeQueryParameter = function getCodeQueryParameter(map) {
    var state = null;
    if (map.has(this.getCognitoConstants().STATE)) {
      this.signInUserSession.setState(map.get(this.getCognitoConstants().STATE));
    } else {
      this.signInUserSession.setState(state);
    }

    if (map.has(this.getCognitoConstants().CODE)) {
      // if the response contains code
      // To parse the response and get the code value.
      var codeParameter = map.get(this.getCognitoConstants().CODE);
      var url = this.getCognitoConstants().DOMAIN_SCHEME.concat(this.getCognitoConstants().COLONDOUBLESLASH, this.getAppWebDomain(), this.getCognitoConstants().SLASH, this.getCognitoConstants().DOMAIN_PATH_TOKEN);
      var header = this.getCognitoConstants().HEADER;
      var body = { grant_type: this.getCognitoConstants().AUTHORIZATIONCODE,
        client_id: this.getClientId(),
        redirect_uri: this.RedirectUriSignIn,
        code: codeParameter };
      var boundOnSuccess = this.onSuccessExchangeForToken.bind(this);
      var boundOnFailure = this.onFailure.bind(this);
      this.makePOSTRequest(header, body, url, boundOnSuccess, boundOnFailure);
    }
  };

  /**
   * Get the query parameter map and proceed according to token response type.
   * @param {map} Query parameter map 
   * @returns {void}
   */


  CognitoAuth.prototype.getTokenQueryParameter = function getTokenQueryParameter(map) {
    var idToken = new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */]();
    var accessToken = new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */]();
    var refreshToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__["a" /* default */]();
    var state = null;
    if (map.has(this.getCognitoConstants().IDTOKEN)) {
      idToken.setJwtToken(map.get(this.getCognitoConstants().IDTOKEN));
      this.signInUserSession.setIdToken(idToken);
    } else {
      this.signInUserSession.setIdToken(idToken);
    }
    if (map.has(this.getCognitoConstants().ACCESSTOKEN)) {
      accessToken.setJwtToken(map.get(this.getCognitoConstants().ACCESSTOKEN));
      this.signInUserSession.setAccessToken(accessToken);
    } else {
      this.signInUserSession.setAccessToken(accessToken);
    }
    if (map.has(this.getCognitoConstants().STATE)) {
      this.signInUserSession.setState(map.get(this.getCognitoConstants().STATE));
    } else {
      this.signInUserSession.setState(state);
    }
    this.cacheTokensScopes();
    this.userhandler.onSuccess(this.signInUserSession);
  };

  /**
   * Get cached tokens and scopes and return a new session using all the cached data.
   * @returns {CognitoAuthSession} the auth session
   */


  CognitoAuth.prototype.getCachedSession = function getCachedSession() {
    if (!this.username) {
      return new __WEBPACK_IMPORTED_MODULE_4__CognitoAuthSession__["a" /* default */]();
    }
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.getClientId() + '.' + this.username;
    var idTokenKey = keyPrefix + '.idToken';
    var accessTokenKey = keyPrefix + '.accessToken';
    var refreshTokenKey = keyPrefix + '.refreshToken';
    var scopeKey = keyPrefix + '.tokenScopesString';

    var scopesString = this.storage.getItem(scopeKey);
    var scopesArray = [];
    if (scopesString) {
      scopesArray = scopesString.split(' ');
    }
    var tokenScopes = new __WEBPACK_IMPORTED_MODULE_0__CognitoTokenScopes__["a" /* default */](scopesArray);
    var idToken = new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */](this.storage.getItem(idTokenKey));
    var accessToken = new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */](this.storage.getItem(accessTokenKey));
    var refreshToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__["a" /* default */](this.storage.getItem(refreshTokenKey));

    var sessionData = {
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken,
      TokenScopes: tokenScopes
    };
    var cachedSession = new __WEBPACK_IMPORTED_MODULE_4__CognitoAuthSession__["a" /* default */](sessionData);
    return cachedSession;
  };

  /**
   * This is used to get last signed in user from local storage
   * @returns {string} the last user name
   */


  CognitoAuth.prototype.getLastUser = function getLastUser() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.getClientId();
    var lastUserKey = keyPrefix + '.LastAuthUser';
    var lastUserName = this.storage.getItem(lastUserKey);
    if (lastUserName) {
      return lastUserName;
    }
    return undefined;
  };

  /**
   * This is used to save the session tokens and scopes to local storage
   * Input parameter is a set of strings.
   * @returns {void}
   */


  CognitoAuth.prototype.cacheTokensScopes = function cacheTokensScopes() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.getClientId();
    var tokenUserName = this.signInUserSession.getAccessToken().getUsername();
    this.username = tokenUserName;
    var idTokenKey = keyPrefix + '.' + tokenUserName + '.idToken';
    var accessTokenKey = keyPrefix + '.' + tokenUserName + '.accessToken';
    var refreshTokenKey = keyPrefix + '.' + tokenUserName + '.refreshToken';
    var lastUserKey = keyPrefix + '.LastAuthUser';
    var scopeKey = keyPrefix + '.' + tokenUserName + '.tokenScopesString';
    var scopesArray = this.signInUserSession.getTokenScopes().getScopes();
    var scopesString = scopesArray.join(' ');
    this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
    this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
    this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
    this.storage.setItem(lastUserKey, tokenUserName);
    this.storage.setItem(scopeKey, scopesString);
  };

  /**
   * Compare two sets if they are identical.
   * @param {set} set1 one set
   * @param {set} set2 the other set
   * @returns {boolean} boolean value is true if two sets are identical
   */


  CognitoAuth.prototype.compareSets = function compareSets(set1, set2) {
    if (set1.size !== set2.size) {
      return false;
    }
    for (var _iterator = set1, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var item = _ref2;

      if (!set2.has(item)) {
        return false;
      }
    }
    return true;
  };

  /**
   * @param {string} url the url string
   * Get the hostname from url.
   * @returns {string} hostname string
   */


  CognitoAuth.prototype.getHostName = function getHostName(url) {
    var match = url.match(this.getCognitoConstants().HOSTNAMEREGEX);
    if (match != null && match.length > 2 && _typeof(match[2]) === this.getCognitoConstants().STRINGTYPE && match[2].length > 0) {
      return match[2];
    }
    return undefined;
  };

  /**
   * Get http query parameters and return them as a map.
   * @param {string} url the url string
   * @param {string} splitMark query parameters split mark (prefix)
   * @returns {map} map
   */


  CognitoAuth.prototype.getQueryParameters = function getQueryParameters(url, splitMark) {
    var str = String(url).split(splitMark);
    var url2 = str[1];
    var str1 = String(url2).split(this.getCognitoConstants().AMPERSAND);
    var num = str1.length;
    var map = new Map();
    var i = void 0;
    for (i = 0; i < num; i++) {
      str1[i] = String(str1[i]).split(this.getCognitoConstants().QUERYPARAMETERREGEX2);
      map.set(str1[i][0], str1[i][1]);
    }
    return map;
  };

  /**
   * helper function to generate a random string
   * @param {int} length the length of string
   * @param {string} chars a original string
   * @returns {string} a random value.
   */


  CognitoAuth.prototype.generateRandomString = function generateRandomString(length, chars) {
    var result = '';
    var i = length;
    for (; i > 0; --i) {
      result += chars[Math.round(Math.random() * (chars.length - 1))];
    }return result;
  };

  /**
   * This is used to clear the session tokens and scopes from local storage
   * @returns {void}
   */


  CognitoAuth.prototype.clearCachedTokensScopes = function clearCachedTokensScopes() {
    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.getClientId();
    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
    var lastUserKey = keyPrefix + '.LastAuthUser';
    var scopeKey = keyPrefix + '.' + this.username + '.tokenScopesString';

    this.storage.removeItem(idTokenKey);
    this.storage.removeItem(accessTokenKey);
    this.storage.removeItem(refreshTokenKey);
    this.storage.removeItem(lastUserKey);
    this.storage.removeItem(scopeKey);
  };

  /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} refreshToken authResult Successful auth response from server.
   * @returns {void}
   */


  CognitoAuth.prototype.refreshSession = function refreshSession(refreshToken) {
    // https POST call for refreshing token
    var url = this.getCognitoConstants().DOMAIN_SCHEME.concat(this.getCognitoConstants().COLONDOUBLESLASH, this.getAppWebDomain(), this.getCognitoConstants().SLASH, this.getCognitoConstants().DOMAIN_PATH_TOKEN);
    var header = this.getCognitoConstants().HEADER;
    var body = { grant_type: this.getCognitoConstants().REFRESHTOKEN,
      client_id: this.getClientId(),
      redirect_uri: this.RedirectUriSignIn,
      refresh_token: refreshToken };
    var boundOnSuccess = this.onSuccessRefreshToken.bind(this);
    var boundOnFailure = this.onFailure.bind(this);
    this.makePOSTRequest(header, body, url, boundOnSuccess, boundOnFailure);
  };

  /**
   * Make the http POST request.
   * @param {JSON} header header JSON object
   * @param {JSON} body body JSON object
   * @param {string} url string
   * @param {function} onSuccess callback
   * @param {function} onFailure callback
   * @returns {void}
   */


  CognitoAuth.prototype.makePOSTRequest = function makePOSTRequest(header, body, url, onSuccess, onFailure) {
    // This is a sample server that supports CORS.
    var xhr = this.createCORSRequest(this.getCognitoConstants().POST, url);
    var bodyString = '';
    if (!xhr) {
      return;
    }
    // set header
    for (var key in header) {
      xhr.setRequestHeader(key, header[key]);
    }
    for (var _key in body) {
      bodyString = bodyString.concat(_key, this.getCognitoConstants().EQUALSIGN, body[_key], this.getCognitoConstants().AMPERSAND);
    }
    bodyString = bodyString.substring(0, bodyString.length - 1);
    xhr.send(bodyString);
    xhr.onreadystatechange = function addressState() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          onSuccess(xhr.responseText);
        } else {
          onFailure(xhr.responseText);
        }
      }
    };
  };

  /**
   * Create the XHR object
   * @param {string} method which method to call
   * @param {string} url the url string
   * @returns {object} xhr
   */


  CognitoAuth.prototype.createCORSRequest = function createCORSRequest(method, url) {
    var xhr = new XMLHttpRequest();
    if (this.getCognitoConstants().WITHCREDENTIALS in xhr) {
      // XHR for Chrome/Firefox/Opera/Safari.
      xhr.open(method, url, true);
    } else if ((typeof XDomainRequest === 'undefined' ? 'undefined' : _typeof(XDomainRequest)) !== this.getCognitoConstants().UNDEFINED) {
      // XDomainRequest for IE.
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else {
      // CORS not supported.
      xhr = null;
    }
    return xhr;
  };

  /**
   * The http POST request onFailure callback.
   * @param {object} err the error object
   * @returns {function} onFailure
   */


  CognitoAuth.prototype.onFailure = function onFailure(err) {
    this.userhandler.onFailure(err);
  };

  /**
   * The http POST request onSuccess callback when refreshing tokens.
   * @param {JSON} jsonData tokens
   */


  CognitoAuth.prototype.onSuccessRefreshToken = function onSuccessRefreshToken(jsonData) {
    var jsonDataObject = JSON.parse(jsonData);
    if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().ERROR)) {
      var URL = this.getFQDNSignIn();
      this.launchUri(URL);
    } else {
      if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().IDTOKEN)) {
        this.signInUserSession.setIdToken(new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */](jsonDataObject.id_token));
      }
      if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().ACCESSTOKEN)) {
        this.signInUserSession.setAccessToken(new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */](jsonDataObject.access_token));
      }
      this.cacheTokensScopes();
      this.userhandler.onSuccess(this.signInUserSession);
    }
  };

  /**
   * The http POST request onSuccess callback when exchanging code for tokens.
   * @param {JSON} jsonData tokens
   */


  CognitoAuth.prototype.onSuccessExchangeForToken = function onSuccessExchangeForToken(jsonData) {
    var jsonDataObject = JSON.parse(jsonData);
    var refreshToken = new __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__["a" /* default */]();
    var accessToken = new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */]();
    var idToken = new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */]();
    var state = null;
    if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().ERROR)) {
      return this.userhandler.onFailure(jsonData);
    }
    if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().IDTOKEN)) {
      this.signInUserSession.setIdToken(new __WEBPACK_IMPORTED_MODULE_2__CognitoIdToken__["a" /* default */](jsonDataObject.id_token));
    } else {
      this.signInUserSession.setIdToken(idToken);
    }
    if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().ACCESSTOKEN)) {
      this.signInUserSession.setAccessToken(new __WEBPACK_IMPORTED_MODULE_1__CognitoAccessToken__["a" /* default */](jsonDataObject.access_token));
    } else {
      this.signInUserSession.setAccessToken(accessToken);
    }
    if (Object.prototype.hasOwnProperty.call(jsonDataObject, this.getCognitoConstants().REFRESHTOKEN)) {
      this.signInUserSession.setRefreshToken(new __WEBPACK_IMPORTED_MODULE_3__CognitoRefreshToken__["a" /* default */](jsonDataObject.refresh_token));
    } else {
      this.signInUserSession.setRefreshToken(refreshToken);
    }
    this.cacheTokensScopes();
    this.userhandler.onSuccess(this.signInUserSession);
  };

  /**
   * Launch Cognito Auth UI page.
   * @param {string} URL the url to launch
   * @returns {void}
   */


  CognitoAuth.prototype.launchUri = function launchUri() {};

  // overwritten in constructor

  /**
   * @returns {string} scopes string
   */
  CognitoAuth.prototype.getSpaceSeperatedScopeString = function getSpaceSeperatedScopeString() {
    var tokenScopesString = this.signInUserSession.getTokenScopes().getScopes();
    tokenScopesString = tokenScopesString.join(this.getCognitoConstants().SPACE);
    return encodeURIComponent(tokenScopesString);
  };

  /**
   * Create the FQDN(fully qualified domain name) for authorization endpoint.
   * @returns {string} url
   */


  CognitoAuth.prototype.getFQDNSignIn = function getFQDNSignIn() {
    if (this.state == null) {
      this.state = this.generateRandomString(this.getCognitoConstants().STATELENGTH, this.getCognitoConstants().STATEORIGINSTRING);
    }

    var identityProviderParam = this.IdentityProvider ? this.getCognitoConstants().AMPERSAND.concat(this.getCognitoConstants().DOMAIN_QUERY_PARAM_IDENTITY_PROVIDER, this.getCognitoConstants().EQUALSIGN, this.IdentityProvider) : '';
    var tokenScopesString = this.getSpaceSeperatedScopeString();

    var userContextDataParam = '';
    var userContextData = this.getUserContextData();
    if (userContextData) {
      userContextDataParam = this.getCognitoConstants().AMPERSAND + this.getCognitoConstants().DOMAIN_QUERY_PARAM_USERCONTEXTDATA + this.getCognitoConstants().EQUALSIGN + this.getUserContextData();
    }

    // Build the complete web domain to launch the login screen
    var uri = this.getCognitoConstants().DOMAIN_SCHEME.concat(this.getCognitoConstants().COLONDOUBLESLASH, this.getAppWebDomain(), this.getCognitoConstants().SLASH, this.getCognitoConstants().DOMAIN_PATH_SIGNIN, this.getCognitoConstants().QUESTIONMARK, this.getCognitoConstants().DOMAIN_QUERY_PARAM_REDIRECT_URI, this.getCognitoConstants().EQUALSIGN, encodeURIComponent(this.RedirectUriSignIn), this.getCognitoConstants().AMPERSAND, this.getCognitoConstants().DOMAIN_QUERY_PARAM_RESPONSE_TYPE, this.getCognitoConstants().EQUALSIGN, this.responseType, this.getCognitoConstants().AMPERSAND, this.getCognitoConstants().CLIENT_ID, this.getCognitoConstants().EQUALSIGN, this.getClientId(), this.getCognitoConstants().AMPERSAND, this.getCognitoConstants().STATE, this.getCognitoConstants().EQUALSIGN, this.state, this.getCognitoConstants().AMPERSAND, this.getCognitoConstants().SCOPE, this.getCognitoConstants().EQUALSIGN, tokenScopesString, identityProviderParam, userContextDataParam);

    return uri;
  };

  /**
   * Sign out the user.
   * @returns {void}
   */


  CognitoAuth.prototype.signOut = function signOut() {
    var URL = this.getFQDNSignOut();
    this.signInUserSession = null;
    this.clearCachedTokensScopes();
    this.launchUri(URL);
  };

  /**
   * Create the FQDN(fully qualified domain name) for signout endpoint.
   * @returns {string} url
   */


  CognitoAuth.prototype.getFQDNSignOut = function getFQDNSignOut() {
    var uri = this.getCognitoConstants().DOMAIN_SCHEME.concat(this.getCognitoConstants().COLONDOUBLESLASH, this.getAppWebDomain(), this.getCognitoConstants().SLASH, this.getCognitoConstants().DOMAIN_PATH_SIGNOUT, this.getCognitoConstants().QUESTIONMARK, this.getCognitoConstants().DOMAIN_QUERY_PARAM_SIGNOUT_URI, this.getCognitoConstants().EQUALSIGN, encodeURIComponent(this.RedirectUriSignOut), this.getCognitoConstants().AMPERSAND, this.getCognitoConstants().CLIENT_ID, this.getCognitoConstants().EQUALSIGN, this.getClientId());
    return uri;
  };

  /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   **/


  CognitoAuth.prototype.getUserContextData = function getUserContextData() {
    if (typeof AmazonCognitoAdvancedSecurityData === "undefined") {
      return;
    }

    var _username = "";
    if (this.username) {
      _username = this.username;
    }

    var _userpoolId = "";
    if (this.userpoolId) {
      _userpoolId = this.userpoolId;
    }

    if (this.advancedSecurityDataCollectionFlag) {
      return AmazonCognitoAdvancedSecurityData.getData(_username, _userpoolId, this.clientId);
    }
  };

  /**
   * Helper method to let the user know if he has either a valid cached session 
   * or a valid authenticated session from the app integration callback.
   * @returns {boolean} userSignedIn 
   */


  CognitoAuth.prototype.isUserSignedIn = function isUserSignedIn() {
    return this.signInUserSession != null && this.signInUserSession.isValid() || this.getCachedSession() != null && this.getCachedSession().isValid();
  };

  return CognitoAuth;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoAuth);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return launchUri; });
var SELF = '_self';

var launchUri = function (url) {
  return window.open(url, SELF);
};

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Amazon Cognito Auth SDK for JavaScript
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *         http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file.
 * This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions
 * and limitations under the License.
 */
var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** @class */

var DateHelper = function () {
  function DateHelper() {
    _classCallCheck(this, DateHelper);
  }

  /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */
  DateHelper.prototype.getNowString = function getNowString() {
    var now = new Date();

    var weekDay = weekNames[now.getUTCDay()];
    var month = monthNames[now.getUTCMonth()];
    var day = now.getUTCDate();

    var hours = now.getUTCHours();
    if (hours < 10) {
      hours = '0' + hours;
    }

    var minutes = now.getUTCMinutes();
    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    var seconds = now.getUTCSeconds();
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    var year = now.getUTCFullYear();

    // ddd MMM D HH:mm:ss UTC YYYY
    var dateNow = weekDay + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC ' + year;

    return dateNow;
  };

  return DateHelper;
}();

/* harmony default export */ __webpack_exports__["a"] = (DateHelper);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/** @class */

var CookieStorage = function () {

  /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   */
  function CookieStorage(data) {
    _classCallCheck(this, CookieStorage);

    this.domain = data.domain;
    if (data.path) {
      this.path = data.path;
    } else {
      this.path = '/';
    }
    if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
      this.expires = data.expires;
    } else {
      this.expires = 365;
    }
    if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
      this.secure = data.secure;
    } else {
      this.secure = true;
    }
  }

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */


  CookieStorage.prototype.setItem = function setItem(key, value) {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"](key, value, {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    });
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
  };

  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */


  CookieStorage.prototype.getItem = function getItem(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
  };

  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */


  CookieStorage.prototype.removeItem = function removeItem(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](key, {
      path: this.path,
      domain: this.domain,
      secure: this.secure
    });
  };

  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */


  CookieStorage.prototype.clear = function clear() {
    var cookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]();
    var index = void 0;
    for (index = 0; index < cookies.length; ++index) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](cookies[index]);
    }
    return {};
  };

  return CookieStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (CookieStorage);

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_cognito_identity_js_1 = __webpack_require__(285);
var core_1 = __webpack_require__(45);
var logger = new core_1.ConsoleLogger('AWSCognitoProvider');
var AWSCognitoProvider = /** @class */ (function () {
    function AWSCognitoProvider(options) {
        this._config = {};
        this.configure(options);
    }
    AWSCognitoProvider.prototype.configure = function (options) {
        Object.assign(this._config, options);
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, storage = _a.storage;
        this._storage = storage;
        this._storageSync = this._storage && typeof this._storage['sync'] === 'function' ?
            this._storage['sync']() : Promise.resolve();
        if (userPoolId) {
            this._userPool = new amazon_cognito_identity_js_1.CognitoUserPool({
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId
            });
        }
    };
    AWSCognitoProvider.prototype.getProviderName = function () {
        return AWSCognitoProvider.NAME;
    };
    AWSCognitoProvider.prototype.getCategory = function () {
        return 'Auth';
    };
    AWSCognitoProvider.prototype.setSession = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, authenticationFlowType, _keyPrefix, username, tokens, provider, _b, federatedWithIDP, user, userSession, credentials, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this._config, authenticationFlowType = _a.authenticationFlowType, _keyPrefix = _a._keyPrefix;
                        username = params.username, tokens = params.tokens, provider = params.provider, _b = params.federatedWithIDP, federatedWithIDP = _b === void 0 ? {} : _b;
                        user = new amazon_cognito_identity_js_1.CognitoUser({
                            Username: username,
                            Pool: this._userPool,
                            Storage: this._storage
                        });
                        userSession = new amazon_cognito_identity_js_1.CognitoUserSession({
                            IdToken: new amazon_cognito_identity_js_1.CognitoIdToken({ IdToken: tokens.idToken }),
                            AccessToken: new amazon_cognito_identity_js_1.CognitoAccessToken({ AccessToken: tokens.accessToken }),
                            RefreshToken: new amazon_cognito_identity_js_1.CognitoRefreshToken({ RefreshToken: tokens.refreshToken })
                        });
                        // cache information
                        user.setSignInUserSession(userSession);
                        credentials = undefined;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, core_1.Credentials.set(userSession, 'session')];
                    case 2:
                        credentials = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        logger.debug('Failed to get the aws credentials with the tokens provided', e_1);
                        if (federatedWithIDP.errorHandler) {
                            federatedWithIDP.errorHandler(e_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, {
                            session: userSession,
                            user: user,
                            credentials: credentials
                        }];
                }
            });
        });
    };
    AWSCognitoProvider.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.debug('tobe implemented');
                return [2 /*return*/, null];
            });
        });
    };
    AWSCognitoProvider.prototype.clearSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.debug('tobe implemented');
                return [2 /*return*/];
            });
        });
    };
    AWSCognitoProvider.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.debug('tobe implemented');
                return [2 /*return*/];
            });
        });
    };
    AWSCognitoProvider.NAME = 'AWSCognito';
    return AWSCognitoProvider;
}());
exports.default = AWSCognitoProvider;
//# sourceMappingURL=AWSCognitoProvider.js.map

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(45);
var BaseProvider_1 = __webpack_require__(152);
var logger = new core_1.ConsoleLogger('GoogleProvider');
var GoogleProvider = /** @class */ (function (_super) {
    __extends(GoogleProvider, _super);
    function GoogleProvider(options) {
        var _this = _super.call(this, options) || this;
        _this._credentialsDomain = GoogleProvider.DEFAULT_DOMAIN;
        return _this;
    }
    GoogleProvider.prototype.configure = function (options) {
        _super.prototype.configure.call(this, options);
        var _a = this._config.refreshHandlers, refreshHandlers = _a === void 0 ? {} : _a;
        this._refreshHandler =
            this._refreshHandler ||
                refreshHandlers['google'] ||
                core_1.GoogleOAuth.refreshGoogleToken;
    };
    GoogleProvider.prototype.getProviderName = function () {
        return GoogleProvider.NAME;
    };
    GoogleProvider.NAME = 'Google';
    GoogleProvider.DEFAULT_DOMAIN = 'accounts.google.com';
    return GoogleProvider;
}(BaseProvider_1.default));
exports.default = GoogleProvider;
//# sourceMappingURL=GoogleProvider.js.map

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InMemoryCache__ = __webpack_require__(1210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserStorageCache", function() { return __WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InMemoryCache", function() { return __WEBPACK_IMPORTED_MODULE_2__InMemoryCache__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["default"].register(__WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserStorageCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageCache__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__ = __webpack_require__(45);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var logger = new __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__["ConsoleLogger"]('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */
var BrowserStorageCache = /** @class */ (function (_super) {
    __extends(BrowserStorageCache, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */
    function BrowserStorageCache(config) {
        var _this = this;
        var cacheConfig = config
            ? Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */], config)
            : __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */];
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */
    BrowserStorageCache.prototype._decreaseCurSizeInBytes = function (amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */
    BrowserStorageCache.prototype._increaseCurSizeInBytes = function (amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */
    BrowserStorageCache.prototype._refreshItem = function (item, prefixedKey) {
        item.visitedTime = Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */
    BrowserStorageCache.prototype._isExpired = function (key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])() >= item.expires) {
            return true;
        }
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */
    BrowserStorageCache.prototype._removeItem = function (prefixedKey, size) {
        var itemSize = size
            ? size
            : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */
    BrowserStorageCache.prototype._setItem = function (prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        }
        catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */
    BrowserStorageCache.prototype._sizeToPop = function (itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace
            ? spaceItemNeed
            : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */
    BrowserStorageCache.prototype._isCacheFull = function (itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */
    BrowserStorageCache.prototype._findValidKeys = function () {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for (var i = 0; i < this.config.storage.length; i += 1) {
            keyInCache.push(this.config.storage.key(i));
        }
        // find those items which belong to our cache and also clean those expired items
        for (var i = 0; i < keyInCache.length; i += 1) {
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 &&
                key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) {
                    this._removeItem(key);
                }
                else {
                    keys.push(key);
                }
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */
    BrowserStorageCache.prototype._popOutItems = function (keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for (var i = 0; i < keys.length; i += 1) {
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function (a, b) {
            if (a.priority > b.priority) {
                return -1;
            }
            else if (a.priority < b.priority) {
                return 1;
            }
            else {
                if (a.visitedTime < b.visitedTime) {
                    return -1;
                }
                else
                    return 1;
            }
        });
        for (var i = 0; i < items.length; i += 1) {
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) {
                return;
            }
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */
    BrowserStorageCache.prototype.setItem = function (key, value, options) {
        logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined
                ? options.priority
                : this.config.defaultPriority,
            expires: options && options.expires !== undefined
                ? options.expires
                : this.config.defaultTTL + Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])(),
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) {
                this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            }
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        }
        catch (e) {
            logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */
    BrowserStorageCache.prototype.getItem = function (key, options) {
        logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                }
                else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) {
                    this.setItem(key, val, options);
                }
                return val;
            }
            return null;
        }
        catch (e) {
            logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */
    BrowserStorageCache.prototype.removeItem = function (key) {
        logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            return;
        }
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) {
                this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            }
        }
        catch (e) {
            logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */
    BrowserStorageCache.prototype.clear = function () {
        logger.log("Clear Cache");
        var keysToRemove = [];
        for (var i = 0; i < this.config.storage.length; i += 1) {
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) {
                keysToRemove.push(key);
            }
        }
        try {
            for (var i = 0; i < keysToRemove.length; i += 1) {
                this.config.storage.removeItem(keysToRemove[i]);
            }
        }
        catch (e) {
            logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */
    BrowserStorageCache.prototype.getAllKeys = function () {
        var keys = [];
        for (var i = 0; i < this.config.storage.length; i += 1) {
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 &&
                key !== this.cacheCurSizeKey) {
                keys.push(key.substring(this.config.keyPrefix.length));
            }
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */
    BrowserStorageCache.prototype.getCacheCurSize = function () {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */
    BrowserStorageCache.prototype.createInstance = function (config) {
        if (!config.keyPrefix || config.keyPrefix === __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */].keyPrefix) {
            logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = __WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */].toString();
        }
        return new BrowserStorageCache(config);
    };
    return BrowserStorageCache;
}(__WEBPACK_IMPORTED_MODULE_1__StorageCache__["a" /* default */]));

var instance = new BrowserStorageCache();
/* harmony default export */ __webpack_exports__["a"] = (instance);
//# sourceMappingURL=BrowserStorageCache.js.map

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultConfig; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getByteLength;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCurrTime;
/* harmony export (immutable) */ __webpack_exports__["e"] = isInteger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(45);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

/**
 * Default cache config
 */
var defaultConfig = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["StorageHelper"]().getStorage(),
};
/**
 * return the byte size of the string
 * @param str
 */
function getByteLength(str) {
    var ret = 0;
    ret = str.length;
    for (var i = str.length; i >= 0; i -= 1) {
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) {
            ret += 1;
        }
        else if (charCode > 0x7ff && charCode <= 0xffff) {
            ret += 2;
        }
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) {
            i -= 1;
        }
    }
    return ret;
}
/**
 * get current time
 */
function getCurrTime() {
    var currTime = new Date();
    return currTime.getTime();
}
/**
 * check if passed value is an integer
 */
function isInteger(value) {
    if (Number.isInteger) {
        return Number.isInteger(value);
    }
    return _isInteger(value);
}
function _isInteger(value) {
    return (typeof value === 'number' && isFinite(value) && Math.floor(value) === value);
}
/**
 * provide an object as the in-memory cache
 */
var store = {};
var CacheObject = /** @class */ (function () {
    function CacheObject() {
    }
    CacheObject.clear = function () {
        store = {};
    };
    CacheObject.getItem = function (key) {
        return store[key] || null;
    };
    CacheObject.setItem = function (key, value) {
        store[key] = value;
    };
    CacheObject.removeItem = function (key) {
        delete store[key];
    };
    return CacheObject;
}());

//# sourceMappingURL=CacheUtils.js.map

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var DoubleLinkedNode = /** @class */ (function () {
    function DoubleLinkedNode(keyVal) {
        this.key = keyVal ? keyVal : '';
        this.prevNode = null;
        this.nextNode = null;
    }
    return DoubleLinkedNode;
}());
/**
 * double linked list plus a hash table inside
 * each key in the cache stored as a node in the list
 * recently visited node will be rotated to the head
 * so the Last Recently Visited node will be at the tail
 *
 * @member head - dummy head of the linked list
 * @member tail - dummy tail of the linked list
 * @member hashtable - the hashtable which maps cache key to list node
 * @member length - length of the list
 */
var CacheList = /** @class */ (function () {
    /**
     * initialization
     */
    function CacheList() {
        this.head = new DoubleLinkedNode();
        this.tail = new DoubleLinkedNode();
        this.hashtable = {};
        this.length = 0;
        this.head.nextNode = this.tail;
        this.tail.prevNode = this.head;
    }
    /**
     * insert node to the head of the list
     *
     * @param node
     */
    CacheList.prototype.insertNodeToHead = function (node) {
        var tmp = this.head.nextNode;
        this.head.nextNode = node;
        node.nextNode = tmp;
        node.prevNode = this.head;
        tmp.prevNode = node;
        this.length = this.length + 1;
    };
    /**
     * remove node
     *
     * @param node
     */
    CacheList.prototype.removeNode = function (node) {
        node.prevNode.nextNode = node.nextNode;
        node.nextNode.prevNode = node.prevNode;
        node.prevNode = null;
        node.nextNode = null;
        this.length = this.length - 1;
    };
    /**
     * @return true if list is empty
     */
    CacheList.prototype.isEmpty = function () {
        return this.length === 0;
    };
    /**
     * refresh node so it is rotated to the head
     *
     * @param key - key of the node
     */
    CacheList.prototype.refresh = function (key) {
        var node = this.hashtable[key];
        this.removeNode(node);
        this.insertNodeToHead(node);
    };
    /**
     * insert new node to the head and add it in the hashtable
     *
     * @param key - the key of the node
     */
    CacheList.prototype.insertItem = function (key) {
        var node = new DoubleLinkedNode(key);
        this.hashtable[key] = node;
        this.insertNodeToHead(node);
    };
    /**
     * @return the LAST Recently Visited key
     */
    CacheList.prototype.getLastItem = function () {
        return this.tail.prevNode.key;
    };
    /**
     * remove the cache key from the list and hashtable
     * @param key - the key of the node
     */
    CacheList.prototype.removeItem = function (key) {
        var removedItem = this.hashtable[key];
        this.removeNode(removedItem);
        delete this.hashtable[key];
    };
    /**
     * @return length of the list
     */
    CacheList.prototype.getSize = function () {
        return this.length;
    };
    /**
     * @return true if the key is in the hashtable
     * @param key
     */
    CacheList.prototype.containsKey = function (key) {
        return key in this.hashtable;
    };
    /**
     * clean up the list and hashtable
     */
    CacheList.prototype.clearList = function () {
        for (var _i = 0, _a = Object.keys(this.hashtable); _i < _a.length; _i++) {
            var key = _a[_i];
            if (this.hashtable.hasOwnProperty(key)) {
                delete this.hashtable[key];
            }
        }
        this.head.nextNode = this.tail;
        this.tail.prevNode = this.head;
        this.length = 0;
    };
    /**
     * @return all keys in the hashtable
     */
    CacheList.prototype.getKeys = function () {
        return Object.keys(this.hashtable);
    };
    /**
     * mainly for test
     *
     * @param key
     * @return true if key is the head node
     */
    CacheList.prototype.isHeadNode = function (key) {
        var node = this.hashtable[key];
        return node.prevNode === this.head;
    };
    /**
     * mainly for test
     *
     * @param key
     * @return true if key is the tail node
     */
    CacheList.prototype.isTailNode = function (key) {
        var node = this.hashtable[key];
        return node.nextNode === this.tail;
    };
    return CacheList;
}());
/* harmony default export */ __webpack_exports__["a"] = (CacheList);
//# sourceMappingURL=CacheList.js.map

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InMemoryCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageCache__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__ = __webpack_require__(45);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var logger = new __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__["ConsoleLogger"]('InMemoryCache');
/**
 * Customized in-memory cache with LRU implemented
 * @member cacheObj - object which store items
 * @member cacheList - list of keys in the cache with LRU
 * @member curSizeInBytes - current size of the cache
 * @member maxPriority - max of the priority
 * @member cacheSizeLimit - the limit of cache size
 */
var InMemoryCache = /** @class */ (function (_super) {
    __extends(InMemoryCache, _super);
    /**
     * initialize the cache
     *
     * @param config - the configuration of the cache
     */
    function InMemoryCache(config) {
        var _this = this;
        var cacheConfig = config
            ? Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */], config)
            : __WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* defaultConfig */];
        _this = _super.call(this, cacheConfig) || this;
        logger.debug('now we start!');
        _this.cacheList = [];
        _this.curSizeInBytes = 0;
        _this.maxPriority = 5;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        // initialize list for every priority
        for (var i = 0; i < _this.maxPriority; i += 1) {
            _this.cacheList[i] = new __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* CacheList */]();
        }
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @param amount - the amount of the cache size which needs to be decreased
     */
    InMemoryCache.prototype._decreaseCurSizeInBytes = function (amount) {
        this.curSizeInBytes -= amount;
    };
    /**
     * increase current size of the cache
     *
     * @param amount - the amount of the cache szie which need to be increased
     */
    InMemoryCache.prototype._increaseCurSizeInBytes = function (amount) {
        this.curSizeInBytes += amount;
    };
    /**
     * check whether item is expired
     *
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */
    InMemoryCache.prototype._isExpired = function (key) {
        var text = __WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* CacheObject */].getItem(key);
        var item = JSON.parse(text);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])() >= item.expires) {
            return true;
        }
        return false;
    };
    /**
     * delete item from cache
     *
     * @param prefixedKey - the key of the item
     * @param listIdx - indicates which cache list the key belongs to
     */
    InMemoryCache.prototype._removeItem = function (prefixedKey, listIdx) {
        // delete the key from the list
        this.cacheList[listIdx].removeItem(prefixedKey);
        // decrease the current size of the cache
        this._decreaseCurSizeInBytes(JSON.parse(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* CacheObject */].getItem(prefixedKey)).byteSize);
        // finally remove the item from memory
        __WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* CacheObject */].removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     * @param listIdx - indicates which cache list the key belongs to
     */
    InMemoryCache.prototype._setItem = function (prefixedKey, item, listIdx) {
        // insert the key into the list
        this.cacheList[listIdx].insertItem(prefixedKey);
        // increase the current size of the cache
        this._increaseCurSizeInBytes(item.byteSize);
        // finally add the item into memory
        __WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* CacheObject */].setItem(prefixedKey, JSON.stringify(item));
    };
    /**
     * see whether cache is full
     *
     * @param itemSize
     *
     * @return true if cache is full
     */
    InMemoryCache.prototype._isCacheFull = function (itemSize) {
        return this.curSizeInBytes + itemSize > this.config.capacityInBytes;
    };
    /**
     * check whether the cache contains the key
     *
     * @param key
     */
    InMemoryCache.prototype.containsKey = function (key) {
        var prefixedKey = this.config.keyPrefix + key;
        for (var i = 0; i < this.maxPriority; i += 1) {
            if (this.cacheList[i].containsKey(prefixedKey)) {
                return i + 1;
            }
        }
        return -1;
    };
    /**
     * * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @throws if the item is too big which exceeds the limit of single item size
     * @throws if the key is invalid
     */
    InMemoryCache.prototype.setItem = function (key, value, options) {
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined
                ? options.priority
                : this.config.defaultPriority,
            expires: options && options.expires !== undefined
                ? options.expires
                : this.config.defaultTTL + Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* getCurrTime */])(),
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        // if key already in the cache, then delete it.
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            this._removeItem(prefixedKey, presentKeyPrio - 1);
        }
        // pop out items in the cache when cache is full based on LRU
        // first start from lowest priority cache list
        var cacheListIdx = this.maxPriority - 1;
        while (this._isCacheFull(item.byteSize) && cacheListIdx >= 0) {
            if (!this.cacheList[cacheListIdx].isEmpty()) {
                var popedItemKey = this.cacheList[cacheListIdx].getLastItem();
                this._removeItem(popedItemKey, cacheListIdx);
            }
            else {
                cacheListIdx -= 1;
            }
        }
        this._setItem(prefixedKey, item, Number(item.priority) - 1);
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     *
     * @param key - the key of the item
     * @param options - the options of callback function
     */
    InMemoryCache.prototype.getItem = function (key, options) {
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        // check whether it's in the cachelist
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            if (this._isExpired(prefixedKey)) {
                // if expired, remove that item and return null
                this._removeItem(prefixedKey, presentKeyPrio - 1);
            }
            else {
                // if not expired, great, return the value and refresh it
                ret = __WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* CacheObject */].getItem(prefixedKey);
                var item = JSON.parse(ret);
                this.cacheList[item.priority - 1].refresh(prefixedKey);
                return item.data;
            }
        }
        if (options && options.callback !== undefined) {
            var val = options.callback();
            if (val !== null) {
                this.setItem(key, val, options);
            }
            return val;
        }
        return null;
    };
    /**
     * remove item from the cache
     *
     * @param key - the key of the item
     */
    InMemoryCache.prototype.removeItem = function (key) {
        var prefixedKey = this.config.keyPrefix + key;
        // check if the key is in the cache
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            this._removeItem(prefixedKey, presentKeyPrio - 1);
        }
    };
    /**
     * clear the entire cache
     */
    InMemoryCache.prototype.clear = function () {
        for (var i = 0; i < this.maxPriority; i += 1) {
            for (var _i = 0, _a = this.cacheList[i].getKeys(); _i < _a.length; _i++) {
                var key = _a[_i];
                this._removeItem(key, i);
            }
        }
    };
    /**
     * Return all the keys in the cache.
     */
    InMemoryCache.prototype.getAllKeys = function () {
        var keys = [];
        for (var i = 0; i < this.maxPriority; i += 1) {
            for (var _i = 0, _a = this.cacheList[i].getKeys(); _i < _a.length; _i++) {
                var key = _a[_i];
                keys.push(key.substring(this.config.keyPrefix.length));
            }
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return the current size of the cache
     */
    InMemoryCache.prototype.getCacheCurSize = function () {
        return this.curSizeInBytes;
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     */
    InMemoryCache.prototype.createInstance = function (config) {
        return new InMemoryCache(config);
    };
    return InMemoryCache;
}(__WEBPACK_IMPORTED_MODULE_1__StorageCache__["a" /* default */]));

var instance = new InMemoryCache();
/* harmony default export */ __webpack_exports__["a"] = (instance);
//# sourceMappingURL=InMemoryCache.js.map

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(45);
var BaseProvider_1 = __webpack_require__(152);
var logger = new core_1.ConsoleLogger('FacebookProvider');
var FacebookProvider = /** @class */ (function (_super) {
    __extends(FacebookProvider, _super);
    function FacebookProvider(options) {
        var _this = _super.call(this, options) || this;
        _this._credentialsDomain = FacebookProvider.DEFAULT_DOMAIN;
        _this._credentialsTokenSource = BaseProvider_1.default.ACCESS_TOKEN;
        return _this;
    }
    FacebookProvider.prototype.configure = function (options) {
        _super.prototype.configure.call(this, options);
        var _a = this._config.refreshHandlers, refreshHandlers = _a === void 0 ? {} : _a;
        this._refreshHandler =
            this._refreshHandler ||
                refreshHandlers['facebook'] ||
                core_1.FacebookOAuth.refreshFacebookToken;
    };
    FacebookProvider.prototype.getProviderName = function () {
        return FacebookProvider.NAME;
    };
    FacebookProvider.NAME = 'Facebook';
    FacebookProvider.DEFAULT_DOMAIN = 'graph.facebook.com';
    return FacebookProvider;
}(BaseProvider_1.default));
exports.default = FacebookProvider;
//# sourceMappingURL=FacebookProvider.js.map

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(45);
var BaseProvider_1 = __webpack_require__(152);
var logger = new core_1.ConsoleLogger('AmazonProvider');
var AmazonProvider = /** @class */ (function (_super) {
    __extends(AmazonProvider, _super);
    function AmazonProvider(options) {
        var _this = _super.call(this, options) || this;
        _this._credentialsDomain = AmazonProvider.DEFAULT_DOMAIN;
        _this._credentialsTokenSource = BaseProvider_1.default.ACCESS_TOKEN;
        return _this;
    }
    AmazonProvider.prototype.configure = function (options) {
        _super.prototype.configure.call(this, options);
        var _a = this._config.refreshHandlers, refreshHandlers = _a === void 0 ? {} : _a;
        this._refreshHandler =
            this._refreshHandler ||
                refreshHandlers['amazon'];
    };
    AmazonProvider.prototype.getProviderName = function () {
        return AmazonProvider.NAME;
    };
    AmazonProvider.NAME = 'Amazon';
    AmazonProvider.DEFAULT_DOMAIN = 'www.amazon.com';
    return AmazonProvider;
}(BaseProvider_1.default));
exports.default = AmazonProvider;
//# sourceMappingURL=AmazonProvider.js.map

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(45);
var BaseProvider_1 = __webpack_require__(152);
var logger = new core_1.ConsoleLogger('DeveloperProvider');
var DeveloperProvider = /** @class */ (function (_super) {
    __extends(DeveloperProvider, _super);
    function DeveloperProvider(options) {
        var _this = _super.call(this, options) || this;
        _this._credentialsDomain = DeveloperProvider.DEFAULT_DOMAIN;
        return _this;
    }
    DeveloperProvider.prototype.configure = function (options) {
        _super.prototype.configure.call(this, options);
        var _a = this._config.refreshHandlers, refreshHandlers = _a === void 0 ? {} : _a;
        this._refreshHandler =
            this._refreshHandler ||
                refreshHandlers['developer'];
    };
    DeveloperProvider.prototype.getProviderName = function () {
        return DeveloperProvider.NAME;
    };
    DeveloperProvider.NAME = 'Developer';
    DeveloperProvider.DEFAULT_DOMAIN = 'cognito-identity.amazonaws.com';
    return DeveloperProvider;
}(BaseProvider_1.default));
exports.default = DeveloperProvider;
//# sourceMappingURL=DeveloperProvider.js.map

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(45);
var BaseProvider_1 = __webpack_require__(152);
var logger = new core_1.ConsoleLogger('GenericProvider');
var GenericProvider = /** @class */ (function (_super) {
    __extends(GenericProvider, _super);
    function GenericProvider(options) {
        return _super.call(this, options) || this;
    }
    GenericProvider.prototype.getProviderName = function () {
        return GenericProvider.NAME;
    };
    GenericProvider.NAME = 'Generic';
    return GenericProvider;
}(BaseProvider_1.default));
exports.default = GenericProvider;
//# sourceMappingURL=GenericProvider.js.map

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_password_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_password_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_template_password_css__);
var FieldPassword=function FieldPassword(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-form col-12 col-sm-6 mt-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'oldPassword',name:'oldPassword',label:'Senha atual',className:'col-12 col-md-12 mb-2',disable:'true',type:'password',onChange:props.handleInputValue,value:props.oldPassword,required:true,'data-error':'Digite sua senha atual',valid:props.oldPasswordIsValid,onBlur:props.validateOldPassword}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'newPassword',name:'newPassword',label:'Nova Senha',className:'col-12 col-md-12 form-field mb-2',disable:'true',type:'password',onChange:props.handleInputValue,value:props.newPassword,required:true,'data-error':'Digite sua nova senha',valid:props.newPasswordIsValid,onBlur:function onBlur(){return props.validateNewPassword();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'confirmPassword',name:'confirmPassword',label:'Confirma senha',className:'col-12 col-md-12 form-field mb-2',disable:'true',type:'password',onChange:props.handleInputValue,value:props.confirmPassword,required:true,'data-error':'As senhas digitadas n\xE3o conferem',valid:props.confirmPasswordIsValid,onBlur:props.validateConfirmPassword}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-12 col-xs-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'Salvar',name:'Salvar',text:'Salvar',className:'btn-featured btn radius btn-sm',onClick:props.handleSubmit,disabled:!props.isFormValid()||props.isFormValid()&&props.isChanged})));};FieldPassword.propTypes={oldPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,newPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,confirmPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,oldPasswordIsValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,newPasswordIsValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,confirmPasswordIsValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,handleSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,handleInputValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validateConfirmPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validateOldPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,validateNewPassword:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isFormValid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (FieldPassword);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Participant_ducks__ = __webpack_require__(77);
var mapStateToProps=function mapStateToProps(_ref){var securityAccess=_ref.securityAccess,participant=_ref.participant;return Object.assign({email:participant.email},securityAccess);};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchParticipant:function fetchParticipant(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Participant_ducks__["e" /* fetchParticipant */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* SecurityAccess */],props);}));

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_password_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_password_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_template_password_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SecurityAccess=function(_Component){_inherits(SecurityAccess,_Component);function SecurityAccess(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SecurityAccess);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SecurityAccess.__proto__||Object.getPrototypeOf(SecurityAccess)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SecurityAccess,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('title',null,'Minha senha - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'container-fluid px-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'container pl-2 pr-2 pt-0 pb-4 pb-md-2 pt-md-5'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_App_Shell_LoggedSidebar__["a" /* default */],{selected:this.props.location.pathname}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col-12 col-lg-8 mt-0'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'checkout-step row px-1 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h1',{className:'txt-title txt-font-body txt-initial color-title mr-auto',tabIndex:0},'Acesso e seguran\xE7a'))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 d-none'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex mt-2 align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('i',{className:'icon icon_message mr-2 color-brand-1',tabIndex:0}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'flex-column'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'txt-left txt-font-body txt-body-sm color-ui-2',tabIndex:0},'E-mail'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',{className:'txt-font-body txt-initial color-title txt-email-flow',tabIndex:0},this.props.email.value)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col btn-flat btn-sm txt-right d-block txt-font-body'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{to:'/token-change-email',className:'color-brand-1-acce-bold',tabIndex:0,title:'Vai para tela de alterar Email'},'Alterar')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row px-0 pb-2 pt-half border-bottom border-color-ui-3 d-none'}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col-12 border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'d-flex mt-2 align-items-center'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('i',{className:'icon icon_password mr-2 color-brand-1',tabIndex:0}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'flex-column'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span',{className:'txt-left txt-font-body txt-body-sm color-ui-2',tabIndex:0},'Senha'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('strong',{className:'txt-font-body txt-initial color-title',tabIndex:0},'******')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col btn-flat btn-sm txt-right d-block txt-font-body'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{to:'/my-account/change-password',className:'color-brand-1-acce-bold',title:'Vai para tela de alterar senha',tabIndex:0},'Alterar')))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'row px-0 pb-2 pt-half border-color-ui-3'}))))))));}}]);return SecurityAccess;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);SecurityAccess.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,email:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (SecurityAccess);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ducks__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Participant_ducks__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(5);
var mapStateToProps=function mapStateToProps(_ref){var tokenChangeEmail=_ref.tokenChangeEmail,oidc=_ref.oidc;return Object.assign({userInfo:oidc.user.profile},tokenChangeEmail);};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchSendTokenPhone:function fetchSendTokenPhone(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__ducks__["b" /* fetchSendTokenPhone */])(data));},fetchTokenChangeEmail:function fetchTokenChangeEmail(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__ducks__["c" /* fetchTokenChangeEmail */])(data));},fetchParticipant:function fetchParticipant(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Participant_ducks__["e" /* fetchParticipant */])());}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* TokenChangeEmail */],props);})));

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_password_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_template_password_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_template_password_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var errors={InternalErrorException:'Erro ao validar o token. Tente novamente!',ErrorToken:'Erro ao enviar o token. Tente novamente!'};var successMsg={SuccessToken:'Token enviado com sucesso.',SuccessConfirm:'E-mail alterado com sucesso.'};var timerDefault=180;var TokenChangeEmail=function(_Component){_inherits(TokenChangeEmail,_Component);function TokenChangeEmail(props){_classCallCheck(this,TokenChangeEmail);var _this=_possibleConstructorReturn(this,(TokenChangeEmail.__proto__||Object.getPrototypeOf(TokenChangeEmail)).call(this,props));_this.go=function(){_this.sendToken();_this.startTimer();};_this.startTimer=function(){_this.setState({timer:setInterval(function(){_this.countDown();},1000)});};_this.toSeconds=function(seconds){return[parseInt(seconds/60%60),parseInt(seconds%60)].join(':').replace(/\b(\d)\b/g,'0$1');};_this.sendToken=function(){_this.setState({isLoadingToken:true});var handleSuccess=function handleSuccess(response){setTimeout(function(){if(response.type==='SEND_TOKEN_PHONE_SUCCESS'){var transactionId=_this.props.dataResponse;_this.setState({transactionId:transactionId,isLoadingToken:false,timeLeft:timerDefault,expiredTime:false,disableVerifyInput:false});}else{_this.setState({success:false,isLoadingToken:false,expiredTime:true,error:{msg:errors.ErrorToken}});}},500);};var _this$state=_this.state,phone=_this$state.phone,name=_this$state.name,documentNumber=_this$state.documentNumber;var data={contact:phone,name:name,documentNumber:documentNumber};_this.props.fetchSendTokenPhone(data).then(handleSuccess);};_this.sendTokenAgain=function(){_this.closeAlert();_this.setState({isLoadingToken:true});var handleSuccess=function handleSuccess(response){setTimeout(function(){if(response.type==='SEND_TOKEN_PHONE_SUCCESS'){var transactionId=_this.props.dataResponse;_this.setState({transactionId:transactionId,isLoadingToken:false,timeLeft:timerDefault,expiredTime:false,disableVerifyInput:false,success:{msg:successMsg.SuccessToken}});_this.startTimer();}else{_this.setState({success:false,isLoadingToken:false,expiredTime:true,error:{msg:errors.ErrorToken}});}},500);};var _this$state2=_this.state,phone=_this$state2.phone,name=_this$state2.name,documentNumber=_this$state2.documentNumber;var data={contact:phone,name:name,documentNumber:documentNumber};_this.props.fetchSendTokenPhone(data).then(handleSuccess);};_this.confirmToken=function(){_this.closeAlert();_this.setState({isLoading:true});var _this$state3=_this.state,phone=_this$state3.phone,documentNumber=_this$state3.documentNumber,transactionId=_this$state3.transactionId,token=_this$state3.token,email=_this$state3.email;var handleSuccess=function handleSuccess(response){setTimeout(function(){if(response.type==='TOKEN_CHAGE_EMAIL_SUCCESS'){_this.setState({isLoading:false,isValidToken:false,isValidEmail:false,disableVerifyInput:true,error:null,success:{msg:successMsg.SuccessConfirm}});_this.props.fetchParticipant();_this.clearAllInput();setTimeout(function(){_this.redirect();},3000);}else{_this.setState({success:false,isLoading:false,isValidToken:false,isValidEmail:false,error:{msg:errors.InternalErrorException}});_this.clearAllInput();}},500);};var data={documentNumber:documentNumber,email:email.value,phone:phone,token:token.value,transactionId:transactionId.data};_this.props.fetchTokenChangeEmail(data).then(handleSuccess);};_this.handleKeyPress=function(e){if(e.key==='Enter'){_this.confirmToken();}};_this.onChangeToken=function(e){_this.setState({token:{value:e.target.value}},function(){return _this.isValidToken();});};_this.onChangeEmail=function(e){_this.setState({email:{value:e.target.value}},function(){return _this.isValidEmail();});};_this.maskPhone=function(phone){var tel=phone.replace('+55','');var maskedTel='';var idx=0;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=tel[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var d=_step.value;if(idx===0){maskedTel+='(';}if(idx===2){maskedTel+=') ';}if(idx===7){maskedTel+='-';}if(idx>=2&&idx<=6){maskedTel+='*';}else{maskedTel+=d;}idx++;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return maskedTel;};_this.isValidToken=function(){var isValidToken=false;var tokenValidator=/^[0-9]{6}$/;var token=_this.state.token;if(!tokenValidator.test(token.value)){_this.setState({token:{value:token.value,error:'Digite um token válido'}});isValidToken=false;_this.setState({disableVerifyButton:true});}else{_this.setState({token:{value:token.value,error:''}});isValidToken=true;}_this.setState({isValidToken:isValidToken});};_this.isValidEmail=function(){var isValidEmail=false;var emailValidator=/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/;var email=_this.state.email;if(!emailValidator.test(email.value)){_this.setState({email:{value:email.value,error:'Digite um e-mail válido'}});isValidEmail=false;_this.setState({disableVerifyButton:true});}else{_this.setState({email:{value:email.value,error:''}});isValidEmail=true;}_this.setState({isValidEmail:isValidEmail});};_this.isInputEmpty=function(){if(!_this.state.isValidEmail||!_this.state.isValidToken){return true;}};_this.closeAlert=function(){return _this.setState({error:null,success:null});};_this.state={expiredTime:false,token:{value:''},isValidToken:false,isLoadingToken:true,email:{value:''},isValidEmail:false,isLoading:false,transactionId:null,error:null,success:null,disableVerifyInput:true,phone:_this.props.userInfo.phone_number.replace('+55',''),name:_this.props.userInfo.name,documentNumber:_this.props.userInfo.username,timeLeft:timerDefault,test:null};_this.confirmToken=_this.confirmToken.bind(_this);_this.sendTokenAgain=_this.sendTokenAgain.bind(_this);return _this;}_createClass(TokenChangeEmail,[{key:'countDown',value:function countDown(){this.setState({timeLeft:this.state.timeLeft-1});if(this.state.timeLeft===0){clearInterval(this.state.timer);this.setState({expiredTime:true});}}},{key:'componentDidMount',value:function componentDidMount(){this.go();}},{key:'clearAllInput',value:function clearAllInput(){this.setState({token:{value:''}});this.setState({email:{value:''}});}},{key:'redirect',value:function redirect(){this.props.history.push('/security-access');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('title',null,'Minha senha - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'container-fluid px-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'container pt-0 pb-4 py-md-4'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_App_Shell_LoggedSidebar__["a" /* default */],{selected:'/security-access',count:0}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 col-md-8 mt-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row'},this.state.error&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Alert"],{isError:true,title:this.state.error.msg,className:'pb-2',onClose:this.closeAlert}),this.state.success&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Alert"],{title:this.state.success.msg,className:'pb-2',onClose:this.closeAlert}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'checkout-step row px-1 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('section',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h1',{className:'txt-title txt-font-body txt-initial color-title mr-auto',tabIndex:0},'Altere seu e-mail aqui'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 mt-2 ml-0 mb-0 px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p',{className:'ml-1'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{tabIndex:0},'enviamos um c\xF3digo via SMS para o seu telefone: ',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('strong',{className:'color-brand-1-acce'},' ',this.maskPhone(this.props.userInfo.phone_number),' ')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{tabIndex:0,className:'d-block mb-2'},'por favor, digite o c\xF3digo no campo abaixo.')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 d-flex mb-0 px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-6 px-0',tabIndex:0},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-token-confirm',name:'code',label:'c\xF3digo de verifica\xE7\xE3o',className:'col-12 col-md-12',required:true,value:this.state.token.value,onChange:this.onChangeToken,valid:this.state.isValidToken,'data-error':this.state.token.error,disabled:this.state.disableVerifyInput,mask:[/[0-9]/,/\d/,/\d/,/\d/,/\d/,/\d/]})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn-heigth-pros btn-especific btn-reenviar mr-1 height50',type:'button',text:this.state.expiredTime?'Reenviar':'Reenviar em '+this.toSeconds(this.state.timeLeft),onClick:this.sendTokenAgain,loading:this.state.isLoadingToken,disabled:!this.state.expiredTime,tabIndex:0})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 d-flex mb-1 justify-content-center'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row col-12 px-0 pb-2 pt-half border-bottom border-color-ui-3'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 pl-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'txt-font-body txt-initial color-ui-2 d-block mb-2 ml-1 mt-3',tabIndex:0},'e agora, digite seu novo e-mail.')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 d-flex mb-2 px-0'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-6 px-0',tabIndex:0},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-email',name:'email',label:'Novo e-mail',className:'col-12 col-md-12',required:true,value:this.state.email.value,onChange:this.onChangeEmail,valid:this.state.isValidEmail,'data-error':this.state.email.error,disabled:this.state.disableVerifyInput,onKeyPress:this.handleKeyPress,maxLength:'100'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-6',tabIndex:0},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-send-sms-verification',name:'btn-send-sms-verification',className:'btn-sm btn-featured btn-continuar-sg border btn-heigth-pros border-color-ui-3 mr-1 height50',type:'button',text:'continuar',disabled:this.isInputEmpty(),onClick:this.confirmToken,loading:this.state.isLoading}))))))))));}}]);return TokenChangeEmail;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);TokenChangeEmail.propTypes={userInfo:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,fetchSendTokenPhone:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,fetchTokenChangeEmail:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,fetchParticipant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,dataResponse:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (TokenChangeEmail);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Participant__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProfileInfos=function(_Component){_inherits(ProfileInfos,_Component);function ProfileInfos(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProfileInfos);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProfileInfos.__proto__||Object.getPrototypeOf(ProfileInfos)).call.apply(_ref,[this].concat(args))),_this),_this.state={isValid:true,companyName:_this.props.participant.companyName,cnpj:_this.props.participant.cnpj,email:_this.props.participant.email,workPhone:{value:''+_this.props.participant.phones.work.areaCode+_this.props.participant.phones.work.number,disabled:_this.props.participant.phones.work.disabled},mobilePhone:{value:''+_this.props.participant.phones.mobile.areaCode+_this.props.participant.phones.mobile.number,disabled:_this.props.participant.phones.mobile.disabled}},_this.isValid=function(){var isValid=true;var mailValidator=/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim;var _this$state=_this.state,companyName=_this$state.companyName,cnpj=_this$state.cnpj,email=_this$state.email,mobilePhone=_this$state.mobilePhone;if(!companyName.value){_this.setState({name:{value:companyName.value,disabled:companyName.disabled,error:'Digite sua Razão Social'}});isValid=false;}if(!cnpj.value){_this.setState({cnpj:{value:cnpj.value,disabled:cnpj.disabled,error:'Digite um CNPJ válido'}});isValid=false;}if(!mailValidator.test(email.value)){_this.setState({email:{value:email.value,disabled:email.disabled,error:'Digite um e-mail válido'}});isValid=false;}if(!mobilePhone.value){_this.setState({mobilePhone:{value:mobilePhone.value,disabled:mobilePhone.disabled,error:'Digite um celular válido'}});isValid=false;}_this.setState({isValid:isValid});return isValid;},_this.handleConfirm=function(){if(!_this.isValid())return;var _this$state2=_this.state,companyName=_this$state2.companyName,cnpj=_this$state2.cnpj,email=_this$state2.email,workPhone=_this$state2.workPhone,mobilePhone=_this$state2.mobilePhone;var customer={name:companyName.value,documentNumber:cnpj.value,email:email.value,genderType:__WEBPACK_IMPORTED_MODULE_3_Participant__["h" /* genderTypes */][_this.props.participant.genderType.value],personType:'COMPANY',phones:[_this.props.buildPhone(workPhone.value,'WORK'),_this.props.buildPhone(mobilePhone.value,'MOBILE')]};_this.props.setCustomer(customer);},_this.handleInputChange=function(event){_this.setState(_defineProperty({},event.target.name,{value:event.target.value}));},_this.handleKeyPress=function(e,element){var inputIndex=element;var inputOrder=['input-name-profile-data','input-cnpj-profile-data','input-email-profile-data','input-mobilePhone-profile-data','input-workPhone-profile-data','company-next'];var isDisabled=true;while(isDisabled){if(inputOrder[inputIndex]==='company-next'){isDisabled=false;}else{var input=document.querySelector('#'+inputOrder[inputIndex]);if(input.getAttribute('disabled')===null||input.getAttribute('disabled')===undefined){isDisabled=false;}else{inputIndex++;}}}// eslint-disable-next-line no-unused-expressions
if(e.key==='Enter'){if(inputIndex){e.target.blur();document.querySelector('#'+inputOrder[inputIndex])&&document.querySelector('#'+inputOrder[inputIndex]).focus();}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProfileInfos,[{key:'componentDidMount',value:function componentDidMount(){this.isValid();}},{key:'handleInputValid',value:function handleInputValid(input){if(input.error)return false;return null;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-infos col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-name-profile-data',label:'Raz\xE3o social',className:'col-12 col-md-6 mt-2',minLength:'1',maxLength:'100',name:'companyName',required:true,'data-error':this.state.companyName.error,valid:this.handleInputValid(this.state.companyName),onChange:this.handleInputChange,value:this.state.companyName.value,disabled:this.state.companyName.disabled==='true',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,1);},onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-cnpj-profile-data',label:'CNPJ',className:'col-12 col-md-6 mt-2',required:true,mask:[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/],name:'cnpj','data-error':this.state.cnpj.error,valid:this.handleInputValid(this.state.cnpj),onChange:this.handleInputChange,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,2);},value:this.state.cnpj.value,disabled:this.state.cnpj.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-email-profile-data',label:'E-mail',className:'col-12 col-md-6 mt-2',required:true,name:'email','data-error':this.state.email.error,valid:this.handleInputValid(this.state.email),onChange:this.handleInputChange,value:this.state.email.value,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,3);},disabled:this.state.email.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-mobilePhone-profile-data',label:'Celular',className:'col-12 col-md-6 mt-2',required:true,mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],'data-error':this.state.mobilePhone.error,valid:this.handleInputValid(this.state.mobilePhone),onChange:this.handleInputChange,name:'mobilePhone',value:this.state.mobilePhone.value,disabled:this.state.mobilePhone.disabled==='true',onBlur:this.isValid,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,4);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-workPhone-profile-data',label:'Telefone comercial',className:'col-12 col-md-6 mt-2',mask:['(',/[1-9]/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/],name:'workPhone',onChange:this.handleInputChange,value:this.state.workPhone.value,disabled:''+this.state.workPhone.disabled==='true',onBlur:this.isValid,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,5);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'company-next',className:'btn btn-sm btn-featured',disabled:!this.state.isValid,onClick:function onClick(){_this2.handleConfirm();_this2.props.forceFocus();},text:'Pr\xF3ximo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-sm btn-featured',disabled:!this.state.isValid,onClick:function onClick(){_this2.handleConfirm();_this2.props.forceFocus();},text:'Pr\xF3ximo'}))))));}}]);return ProfileInfos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});ProfileInfos.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({companyName:valueType,cnpj:valueType,email:valueType,phones:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,genderType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object}).isRequired,setCustomer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,buildPhone:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,forceFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProfileInfos);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var Header=function Header(_ref){var step=_ref.step,handleStepChange=_ref.handleStepChange,description=_ref.description,active=_ref.active;var classDisplay=step>0?'d-block':'d-none';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step-profile checkout-step row px-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{className:'color-brand-1',iconName:'icon_profile'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},active?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'txt-body txt-uppercase color-brand-1'},'Dados Pessoais')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body txt-uppercase color-brand-1 h2'},'Dados Pessoais'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm '+classDisplay},description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'txt-body-sm txt-right border-bottom border-color-ui-1 color-links border-color-links '+classDisplay,onClick:function onClick(){handleStepChange(0);},href:'javascript:void(0)'},'Alterar')))));};Header.propTypes={step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,handleStepChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingAddress__ = __webpack_require__(1223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingAddress__["a"]; });


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Body__ = __webpack_require__(1226);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getBodyProps=function getBodyProps(_ref){var step=_ref.step,participant=_ref.participant,address=_ref.address,handleStepChange=_ref.handleStepChange,handleConfirmAddress=_ref.handleConfirmAddress,updateShippingAddress=_ref.cart.updateShippingAddress,fetchShipping=_ref.fetchShipping,forceFocus=_ref.forceFocus;var shippingAddressData=address||{};var participantAddress=participant&&participant.address||{};var disabledZipcode=participantAddress.zipCode&&participantAddress.zipCode.disabled;var disabledNumber=participantAddress.number&&participantAddress.number.disabled;var disabledComplement=participantAddress.complement&&participantAddress.complement.disabled;var disabledStreet=participantAddress.street&&participantAddress.street.disabled;var disabledDistrict=participantAddress.district&&participantAddress.district.disabled;var disabledCity=participantAddress.city&&participantAddress.city.disabled;var disabledState=participantAddress.state&&participantAddress.state.disabled;var disabledReference=participantAddress.reference&&participantAddress.reference.disabled;return{step:step,handleStepChange:handleStepChange,handleConfirmAddress:handleConfirmAddress,isLoading:address.isLoading,zipCode:address&&address.zipCode?{value:address.zipCode,disabled:disabledZipcode}:{value:'',disabled:disabledZipcode},receiver:participant.name,updateShippingAddress:updateShippingAddress,fetchShipping:fetchShipping,cepError:address.cepError,number:shippingAddressData.number?{value:shippingAddressData.number,disabled:disabledNumber}:{value:'',disabled:disabledNumber},complement:shippingAddressData.complement?{value:shippingAddressData.complement,disabled:disabledComplement}:{value:'',disabled:disabledComplement},street:address.street?{value:address.streetType+' '+address.street,valueParticipant:address.streetType+' '+address.street,disabled:disabledStreet}:{value:'',valueParticipant:'',disabled:disabledStreet},district:address.district?{value:address.district,valueParticipant:address.district,disabled:disabledDistrict}:{value:'',valueParticipant:'',disabled:disabledDistrict},city:address.city?{value:address.city,disabled:disabledCity}:{value:'',disabled:disabledCity},state:address.state?{value:address.state,disabled:disabledState}:{value:'',disabled:disabledState},reference:shippingAddressData.reference?{value:shippingAddressData.reference,disabled:disabledReference}:{value:'',disabled:disabledReference},forceFocus:forceFocus};};var ShippingAddress=function(_Component){_inherits(ShippingAddress,_Component);function ShippingAddress(){_classCallCheck(this,ShippingAddress);return _possibleConstructorReturn(this,(ShippingAddress.__proto__||Object.getPrototypeOf(ShippingAddress)).apply(this,arguments));}_createClass(ShippingAddress,[{key:'render',value:function render(){var _props=this.props,step=_props.step,cart=_props.cart,orientation=_props.orientation;var props=getBodyProps(this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Header__["a" /* Header */],{step:step,handleStepChange:this.props.handleStepChange,deliveryDate:cart.shipping.maxDeliveryDate,description:props.street.value+', '+props.number.value+' - '+props.complement.value}),step===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Body__["a" /* Body */],Object.assign({},props,{orientation:orientation})):'');}}]);return ShippingAddress;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShippingAddress.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleStepChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,fetchShipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,orientation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,forceFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ShippingAddress);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(1225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Header=function Header(_ref){var step=_ref.step,deliveryDate=_ref.deliveryDate,handleStepChange=_ref.handleStepChange,description=_ref.description;var classDisplay=step>1?'d-block':'d-none';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step-address checkout-step row px-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_truck  '+(step>=1?' color-brand-1':'color-ui-3'),'aria-hidden':'true'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},step===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'txt-body txt-uppercase color-brand-1'},'Endere\xE7o de Entrega')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body txt-uppercase color-ui-3 color-brand-1 h2'},'Endere\xE7o de Entrega'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm '+classDisplay},description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},deliveryDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm  '+(step===1?'d-block':'d-none')},'Entrega prevista para: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,deliveryDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'txt-body-sm txt-right border-bottom border-color-ui-1 color-links border-color-links '+(step>1?'d-block':'d-none'),href:'javascript:void(0)',onClick:function onClick(){handleStepChange(1);}},'Alterar')))));};Header.propTypes={step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,deliveryDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,handleStepChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Body__ = __webpack_require__(1227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Body__["a"]; });


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddressForm__ = __webpack_require__(1228);
var Body=function Body(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AddressForm__["a" /* AddressForm */],props))));};/* harmony default export */ __webpack_exports__["a"] = (Body);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddressForm__ = __webpack_require__(1229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AddressForm__["a"]; });


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var numberPattern=/^[0-9]*$/;var DisabledField=function DisabledField(model){return model.value===''||!model.value.replace(/\s/g,'').length;};var AddressForm=function(_Component){_inherits(AddressForm,_Component);function AddressForm(props){_classCallCheck(this,AddressForm);var _this=_possibleConstructorReturn(this,(AddressForm.__proto__||Object.getPrototypeOf(AddressForm)).call(this,props));_this.changeAddress=function(){if(!_this.props.isLoading){if(_this.props.street.value!==_this.state.street.value&&_this.state.street.value===''){_this.setState({street:{value:_this.props.street.value}});}if(_this.props.district.value!==_this.state.district.value&&_this.state.district.value===''){_this.setState({district:{value:_this.props.district.value}});}}};_this.handleZipCodeChange=function(_ref){var zipCode=_ref.target.value;var zipCodeNumber=zipCode.replace('-','');_this.setState({zipCode:zipCodeNumber});if(zipCodeNumber.length===8&&numberPattern.test(zipCodeNumber)){_this.setState({district:{value:''},street:{value:''}});_this.props.fetchShipping(zipCodeNumber);}};_this.isZipCodeValid=function(value){return!!value&&value.length===8;};_this.isDistrictValid=function(value){return!!value&&value.length>2;};_this.isStreetValid=function(value){return!!value&&value.length>2;};_this.isFormInvalid=function(){var zipCodeNumber=_this.state.zipCode.replace('_','');if(_this.isZipCodeValid(zipCodeNumber)===false)return true;if(_this.isDistrictValid(_this.state.district.value)===false)return true;if(_this.isStreetValid(_this.state.street.value)===false)return true;if(!_this.state.number)return true;if(!_this.state.complement)return true;if(!_this.state.reference)return true;if(!_this.props.city.value)return true;if(!_this.state.receiver)return true;return false;};_this.handleKeyPress=function(e,element){var inputIndex=element;var inputOrder=['address-zipCode','address-receiver','address-street','address-number','address-complement','address-reference','address-district','address-city','address-state','next-payment'];var isDisabled=true;while(isDisabled){if(inputOrder[inputIndex]==='next-payment'){isDisabled=false;}else{var input=document.querySelector('#'+inputOrder[inputIndex]);if(input.getAttribute('disabled')===null||input.getAttribute('disabled')===undefined){isDisabled=false;}else{inputIndex++;}}}// eslint-disable-next-line no-unused-expressions
if(e.key==='Enter'){if(inputIndex){e.target.blur();document.querySelector('#'+inputOrder[inputIndex])&&document.querySelector('#'+inputOrder[inputIndex]).focus();}}};_this.state={zipCode:props.zipCode.value,receiver:props.receiver.value,number:props.number.value,complement:props.complement.value,reference:props.reference.value,addressConfirmed:false,street:{value:props.street&&props.street.value,disabled:props.street.disabled},district:{value:props.district&&props.district.value,disabled:props.district.disabled}};return _this;}_createClass(AddressForm,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){document.querySelector('.checkout-step-profile').scrollIntoView();},500);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.changeAddress();}},{key:'render',value:function render(){var _this2=this;var streetDisabled=true;var districtDisabled=true;if(!this.props.isLoading&&this.props.city.value!==''){streetDisabled=!DisabledField(this.props.street);districtDisabled=!DisabledField(this.props.district);}if(this.state.addressConfirmed&&this.props.updateShippingAddress==='success'){this.props.handleStepChange(2);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-form col-12 pt-2 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-zipCode',label:'CEP',className:'col-12 col-md-6',value:this.state.zipCode,onChange:this.handleZipCodeChange,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,1);},mask:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/],required:true,disabled:this.props.zipCode.disabled==='true','data-error':'Cep inv\xE1lido',valid:this.props.cepError&&this.state.zipCode?false:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-receiver',label:'Destinat\xE1rio',className:'col-12 col-md-6',value:this.state.receiver,onChange:function onChange(e){return _this2.setState({receiver:e.target.value});},onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,2);},required:true,disabled:this.props.receiver.disabled==='true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-street',label:'Rua',className:'col-12 col-md-6 mt-2',value:this.state.street.value,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,3);},onChange:function onChange(e){return _this2.setState({street:{value:e.target.value,isValid:null},dirty:true});},maxLength:'100',required:true,disabled:streetDisabled,'data-error':'Digite uma Rua',valid:this.isStreetValid(this.state.street.value)?null:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-number',label:'N\xFAmero',maxLength:5,className:'col-12 col-md-6 mt-2',value:this.state.number,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,4);},onChange:function onChange(e){return _this2.setState({number:e.target.value});},required:true,disabled:this.props.number.disabled==='true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-complement',label:'Complemento',maxLength:20,className:'col-12 col-md-6 mt-2',value:this.state.complement,required:true,onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,5);},onChange:function onChange(e){return _this2.setState({complement:e.target.value});},disabled:this.props.complement.disabled==='true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-reference',label:'Ponto de Refer\xEAncia',maxLength:60,className:'col-12 col-md-6 mt-2',value:this.state.reference,required:true,onChange:function onChange(e){return _this2.setState({reference:e.target.value});},onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,6);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-district',label:'Bairro',className:'col-12 col-md-6 mt-2',value:this.state.district.value,onChange:function onChange(e){return _this2.setState({district:{value:e.target.value,isValid:null},dirty:true});},onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,7);},maxLength:'100',required:true,disabled:districtDisabled,'data-error':'Digite um Bairro',valid:this.isDistrictValid(this.state.district.value)?null:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-city',label:'Cidade',className:'col-12 col-md-6 mt-2',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,8);},value:this.props.city.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'address-state',label:'Estado',className:'col-12 col-md-6 mt-2',onKeyPress:function onKeyPress(e){return _this2.handleKeyPress(e,9);},value:this.props.state.value,required:true,disabled:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured',id:'next-payment',onClick:function onClick(){_this2.setState({addressConfirmed:true});_this2.props.forceFocus();_this2.props.handleConfirmAddress({zipCode:_this2.state.zipCode,receiver:_this2.state.receiver,number:_this2.state.number,complement:_this2.state.complement,reference:_this2.state.reference,street:_this2.state.street.value,district:_this2.state.district.value,city:_this2.props.city.value,state:_this2.props.state.value});},loading:this.props.isLoading||this.props.updateShippingAddress==='loading',text:'Pr\xF3ximo',disabled:this.isFormInvalid()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured',onClick:function onClick(){_this2.setState({addressConfirmed:true});_this2.props.forceFocus();_this2.props.handleConfirmAddress({zipCode:_this2.state.zipCode,receiver:_this2.state.receiver,number:_this2.state.number,complement:_this2.state.complement,reference:_this2.state.reference,street:_this2.state.street.value,district:_this2.state.district.value,city:_this2.props.city.value,state:_this2.props.state.value});},loading:this.props.isLoading||this.props.updateShippingAddress==='loading',text:'Pr\xF3ximo',disabled:this.isFormInvalid()})))));}}]);return AddressForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var valueType=__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}).isRequired;AddressForm.propTypes={receiver:valueType,street:valueType,number:valueType,complement:valueType,district:valueType,city:valueType,state:valueType,zipCode:valueType,reference:valueType,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,handleConfirmAddress:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchShipping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,updateShippingAddress:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,handleStepChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,cepError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,forceFocus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AddressForm);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary__ = __webpack_require__(1231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Summary__["a"]; });


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Coupon__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SummaryPlaceholder__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SummaryOrder__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SecondFactorAuthenticaton_SecondFactorAuthentication__ = __webpack_require__(483);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Summary=function(_Component){_inherits(Summary,_Component);function Summary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Summary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Summary.__proto__||Object.getPrototypeOf(Summary)).call.apply(_ref,[this].concat(args))),_this),_this.state={showModal:false,hideModal:true,placeholder:true},_this.toogleModal=function(){_this.setState({showModal:!_this.state.showModal});},_this.isButtonDisabled=function(){var _this$props=_this.props,paymentSelected=_this$props.paymentSelected,creditCard=_this$props.creditCard,shipping=_this$props.shipping;if(paymentSelected==='POINTS_CASH'||paymentSelected==='CASH_ONLY'){var number=creditCard.number,personName=creditCard.personName,validityDate=creditCard.validityDate,cvv=creditCard.cvv;var installmentSelected=_this.props.installmentSelected();var parcel=installmentSelected&&installmentSelected.parcel;var brand=_this.props.cardBrand();return!parcel||!number||!personName||!validityDate||!cvv||!brand;}else if(paymentSelected==='POINTS_ONLY'){if(shipping.error_get_shipping){return true;}else{return false;}}return true;},_this.getDifValue=function(){var valueInstallment=_this.props.installmentSelected();var shipping=_this.props.cart.shipping;var totalDifValue=0;if(_this.props.paymentSelected==='CASH_ONLY'&&_this.props.cart&&_this.props.cart.priceCash&&valueInstallment&&valueInstallment.parcel&&valueInstallment.parcelValue){var shippingPrice=shipping.totalCash||0;var price=_this.props.cart.priceCash;var valueInstallmentCalculated=valueInstallment.parcel*valueInstallment.parcelValue;var valueOrderCalculated=price+shippingPrice;totalDifValue=valueOrderCalculated-valueInstallmentCalculated;if(Math.abs(totalDifValue)>0.1){if(totalDifValue>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm color-ui-2 col-6 txt-title-3 txt-font-body txt-left justify-content-center align-self-center'},'Desconto \xE0 vista:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm color-ui-2 col-6 txt-title-3 txt-subtitle txt-font-body txt-right justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["b" /* CurrencyLabel */],{id:'valor-desconto-diferenca',value:Math.abs(totalDifValue),prefixLabel:'R$ ',decimalPlaces:2,className:'txt-uppercase',showpointsName:false})));}else if(totalDifValue<0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm color-ui-2 col-6 txt-title-3 txt-font-body txt-left justify-content-center align-self-center'},'Juros do parcelamento:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm color-ui-2 col-6 txt-title-3 txt-subtitle txt-font-body txt-right justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["b" /* CurrencyLabel */],{id:'valor-juros-diferenca',value:Math.abs(totalDifValue),prefixLabel:'R$ ',decimalPlaces:2,className:'txt-uppercase',showpointsName:false})));}}return'';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Summary,[{key:'render',value:function render(){var _this2=this;var paymentStep=2;var payment=this.props.payment;var isLoading=payment.pointsCashConfig.isLoading;if(isLoading&&this.props.step===paymentStep)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryPlaceholder__["a" /* default */],null);if(this.props.step!==paymentStep){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["d" /* SummaryOrder */],{cart:this.props.cart},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["g" /* TotalValue */],{totalPrice:this.props.totalPrice}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["d" /* SummaryOrder */],{cart:this.props.cart},this.props.onlyCash?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Coupon__["a" /* Coupon */],null),this.props.paymentSelected==='POINTS_CASH'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["f" /* TotalPointsCash */],{paymentPoints:this.props.paymentPoints,installmentSelected:this.props.installmentSelected}):this.props.paymentSelected==='CASH_ONLY'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block'},this.getDifValue(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["e" /* TotalCashOnly */],{installmentSelected:this.props.installmentSelected})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["g" /* TotalValue */],{totalPrice:this.props.totalPrice}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["c" /* SubmitButton */],{text:this.props.onlyCash?'FINALIZAR AGORA':'FINALIZAR RESGATE',onClick:function onClick(e){_this2.props.createPurchase();window._etmc.push(['setOrgId','6422293']);window._etmc.push(['trackConversion',{'cart':_this2.props.cart.items}]);e.target.blur();setTimeout(function(){if(document.querySelector('#alert-message-box')){document.querySelector('#alert-message-box').focus();}},300);},loading:this.props.isCreatingPurchase,disabled:this.isButtonDisabled()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-0 px-0 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 px-0 txt-body-sm color-ui-2 txt-font-body txt-left justify-content-center align-self-center'},this.props.cart.count>1?'Itens ':'Item ','(',this.props.cart.count,') + frete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-0 px-0 mb-1 mb-md-0 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 px-0 txt-body-sm color-brand-1 txt-font-body txt-left justify-content-center align-self-center'},this.props.paymentSelected==='POINTS_CASH'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["f" /* TotalPointsCash */],{paymentPoints:this.props.paymentPoints,installmentSelected:this.props.installmentSelected,isMobile:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SummaryOrder__["g" /* TotalValue */],{totalPrice:this.props.totalPrice,isMobile:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{className:'btn btn-sm btn-featured nowrap txt-center',text:this.props.onlyCash?'FINALIZAR AGORA':'FINALIZAR RESGATE',onClick:function onClick(e){_this2.props.createPurchase();window._etmc.push(['setOrgId','6422293']);window._etmc.push(['trackConversion',{'cart':_this2.props.cart.items}]);e.target.blur();setTimeout(function(){if(document.querySelector('#alert-message-box')){document.querySelector('#alert-message-box').focus();}},300);_this2.props.createPurchase();},loading:this.props.isCreatingPurchase,disabled:this.isButtonDisabled()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SecondFactorAuthenticaton_SecondFactorAuthentication__["a" /* default */],Object.assign({show:this.state.showModal,onClose:function onClose(){return _this2.toogleModal();},onCloseButton:this.props.createPurchase},this.props))));}}]);return Summary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Summary.propTypes={step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,totalPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,createPurchase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,paymentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,paymentPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,isCreatingPurchase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,installmentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,creditCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,cardBrand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,catalog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,shipping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,hasError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isAbilityInCampaing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,payment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Summary);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Coupon__ = __webpack_require__(1233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Coupon__["a"]; });


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_tooltip_css__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_molecules_tooltip_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CouponContent=function CouponContent(_ref){var children=_ref.children;var closeTooltip=function closeTooltip(){var close=document.querySelector('.btn-tooltip-discount');var tooltip=document.querySelector('.custom-tooltip-bottom');if(close!==null||close!==undefined){tooltip.classList.remove('custom-tooltip-active');close.click();close.focus();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'Cupom de desconto:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Tooltip"],{position:'bottom',icon:'icon_question',tooltipIitle:'Abrir para mais informa\xE7\xF5es do cupom de desconto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'custom-tooltiptext txt-left px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Cupom de Desconto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-2'},'\xC9 o c\xF3digo promocional que d\xE1 direito a um desconto em sua compra.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-2'},'Insira o c\xF3digo no campo abaixo e o valor ser\xE1 subtra\xEDdo do total de sua compra. Caso tenha optado por parcelar o valor, verifique novamente o total de parcelas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'mt-3',onClick:closeTooltip},'Fechar'))))),children);};CouponContent.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};var Coupon=function(_React$Component){_inherits(Coupon,_React$Component);function Coupon(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Coupon);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Coupon.__proto__||Object.getPrototypeOf(Coupon)).call.apply(_ref2,[this].concat(args))),_this),_this.state={isFormOpen:false,code:_this.props.code||''},_this.handleOpenForm=function(){return _this.setState({isFormOpen:!_this.state.isFormOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Coupon,[{key:'componentWillMount',value:function componentWillMount(){this.props.clearCouponError();}},{key:'render',value:function render(){var _this2=this;if(this.props.code){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CouponContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 color-ui-2 txt-body-sm txt-font-body txt-right justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.code)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.props.removeCoupon,className:'col-12 cursor txt-title-3 txt-body-sm txt-subtitle txt-font-body color-brand-1 txt-right justify-content-center align-selfe-center'},'Alterar')));}if(this.state.isFormOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CouponContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col form-field pl-0 pr-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Input"],{id:'coupon',name:'coupon',label:'Inserir cupom de desconto',className:'col-12 pl-half',value:this.state.code,onChange:function onChange(e){return _this2.setState({code:e.target.value});},'data-error':'N\xE3o foi poss\xEDvel aplicar o cupom de desconto.',valid:this.props.hasError?false:null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pl-half txt-right justify-content-center align-selfe-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Button"],{id:'adding-Coupon',className:'btn-icon btn-featured btn-icon-only',iconName:'icon_check','aria-label':'Aplicar cupom',loading:this.props.isLoading,disabled:!this.state.code,onClick:function onClick(){return _this2.props.updateCoupon(_this2.state.code);}})))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CouponContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 cursor  txt-title-3 txt-body-sm txt-subtitle txt-font-body txt-right justify-content-center align-selfe-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:this.handleOpenForm,className:'color-brand-2 txt-underline'},'Aplicar')));}}]);return Coupon;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Coupon.propTypes={code:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hasError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,updateCoupon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,removeCoupon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,clearCouponError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref3){var cart=_ref3.cart;return Object.assign({},cart.coupon);};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateCoupon:function updateCoupon(code){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].updateCoupon(code));},removeCoupon:function removeCoupon(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].removeCoupon());},clearCouponError:function clearCouponError(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Cart__["c" /* actions */].clearCouponError());},fetchPointsCashConfig:function fetchPointsCashConfig(){return dispatch(__WEBPACK_IMPORTED_MODULE_4____["c" /* actions */].fetchPointsCashConfig());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Coupon));

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SummaryPlaceholder=function(_Component){_inherits(SummaryPlaceholder,_Component);function SummaryPlaceholder(){_classCallCheck(this,SummaryPlaceholder);return _possibleConstructorReturn(this,(SummaryPlaceholder.__proto__||Object.getPrototypeOf(SummaryPlaceholder)).apply(this,arguments));}_createClass(SummaryPlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-side col-12 col-lg-4 mb-3 mb-sm-0 mt-2 mt-lg-0 px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-title txt-font-body'},'Resumo do pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 pb-2 pt-2 bg-ui-5 d-flex justify-content-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 px-2 radius bg-ui-3 pt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 pb-2 pt-2 bg-ui-5 d-flex justify-content-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 radius bg-ui-3 pt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 pb-2 pt-2 bg-ui-5 d-flex justify-content-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 px-2 radius bg-ui-3 pt-1'})))));}}]);return SummaryPlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SummaryPlaceholder);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var SummaryOrder=function SummaryOrder(_ref){var cart=_ref.cart,children=_ref.children;var count=cart.count,shipping=cart.shipping;var price={cash:cart.priceCash,points:cart.price};var shippingPrice={cash:shipping.totalCash,points:shipping.total};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-side col-12 col-lg-4 mb-3 mb-sm-0 mt-2 mt-lg-0 px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-ui-3 radius bg-white px-0 py-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-title txt-font-body'},'Resumo do pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Item */],{description:'Subtotal ('+count+' itens):',className:'row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3',classFont:'txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:price,checkCashOnly:true})),cart.hasItemsDifferentVirtualVoucher&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* ShippingItem */],{price:shippingPrice,label:'pontos'}),children)));};SummaryOrder.propTypes={cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SummaryOrder);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_responsive__);
var SubmitButton=function SubmitButton(_ref){var text=_ref.text,onClick=_ref.onClick,disabled=_ref.disabled,loading=_ref.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary-order-submit row px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minDeviceWidth:769},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn-featured btn-icon',onClick:onClick,disabled:disabled,text:text,loading:loading,iconName:'icon icon_gift'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{maxDeviceWidth:768},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn-featured',onClick:onClick,disabled:disabled,text:text,loading:loading}))));};SubmitButton.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SubmitButton);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Item=function Item(_ref){var description=_ref.description,children=_ref.children,className=_ref.className,classFont=_ref.classFont;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classFont+' col-6 txt-title-3 txt-font-body txt-left justify-content-center align-self-center'},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classFont+' col-6 txt-title-3 txt-subtitle txt-font-body txt-right justify-content-center align-self-center'},children));};Item.propTypes={description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,classFont:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var ShippingValue=function ShippingValue(_ref){var price=_ref.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Item */],{description:'Frete:',className:'row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3',classFont:'txt-body-sm color-ui-2'},price.points||price.cash?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{price:price,checkCashOnly:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'...'));};ShippingValue.propTypes={price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ShippingValue);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var TotalValue=function TotalValue(_ref){var totalPrice=_ref.totalPrice,isMobile=_ref.isMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Item */],{description:'Valor Total:',className:'row pt-2 '+(isMobile?'px-0':'px-2'),classFont:'total-points txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{className:'txt-bold',price:totalPrice,checkCashOnly:true}));};TotalValue.propTypes={totalPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TotalValue);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var TotalPointsCash=function TotalPointsCash(_ref){var paymentPoints=_ref.paymentPoints,installmentSelected=_ref.installmentSelected,isMobile=_ref.isMobile;var installment=installmentSelected();if(!installment)return'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Item */],{description:'Valor em Pontos:',className:'row pt-2 '+(isMobile?'px-0':'px-2'),classFont:'total-points txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{className:'txt-bold color-brand-1',value:paymentPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Item */],{description:'Valor em '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro')+':',className:'row pt-1 '+(isMobile?'px-0':'px-2'),classFont:'total-points txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-bold color-brand-1'},'+ ',installment.description)));};TotalPointsCash.propTypes={paymentPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,installmentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TotalPointsCash);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var TotalCashOnly=function TotalCashOnly(_ref){var installmentSelected=_ref.installmentSelected;var installment=installmentSelected();if(!installment)return'';var price={cash:installment.parcel*installment.parcelValue};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Item */],{description:'Valor em Total:',className:'row pt-2 px-2',classFont:'txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{className:'txt-bold color-brand-1',price:price,checkCashOnly:true}));};TotalCashOnly.propTypes={installmentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TotalCashOnly);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Payment__ = __webpack_require__(1243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Payment__["a"]; });


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Body__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var Payment=function Payment(props){if(props.step!==2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* Header */],{cssColor:'color-ui-3'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Header__["a" /* Header */],{active:true,cssColor:'color-brand-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Body__["a" /* Body */],props));};Payment.propTypes={step:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Payment);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(1245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var Header=function Header(_ref){var cssColor=_ref.cssColor,active=_ref.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step-payment checkout-step row px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{className:''+cssColor,iconName:'icon_pay'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},active?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'txt-body txt-uppercase '+cssColor},'Pagamento')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body txt-uppercase h2 '+cssColor},'Pagamento')))));};Header.propTypes={cssColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Body__ = __webpack_require__(1247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Body__["a"]; });


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PointsCash__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PointsOnly__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BodyPlaceholder__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Body=function(_Component){_inherits(Body,_Component);function Body(){_classCallCheck(this,Body);return _possibleConstructorReturn(this,(Body.__proto__||Object.getPrototypeOf(Body)).apply(this,arguments));}_createClass(Body,[{key:'componentDidMount',value:function componentDidMount(){setTimeout(function(){document.querySelector('.checkout-step-profile').scrollIntoView();},500);if(this.props.onlyCash){this.props.fetchCashOnlyConfig();}else{this.props.fetchPointsCashConfig();}}},{key:'render',value:function render(){var _props=this.props,payment=_props.payment,balance=_props.balance,totalPrice=_props.totalPrice,onlyCash=_props.onlyCash;var _payment$pointsCashCo=payment.pointsCashConfig,isLoading=_payment$pointsCashCo.isLoading,pointsCashAvailable=_payment$pointsCashCo.isAbilityInCampaing;if(isLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BodyPlaceholder__["a" /* default */],null);if(onlyCash){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PointsCash__["a" /* CreditCard */],this.props))));}if(pointsCashAvailable){if(payment.isDepreciated){this.props.fetchPointsCashConfig();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-1 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Selecione um meio de pagamento, voc\xEA tamb\xE9m pode utilizar seu cart\xE3o de cr\xE9dito.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PointsOnly__["a" /* PointsOnly */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PointsCash__["d" /* PointsCash */],this.props))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Este resgate ir\xE1 utilizar',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:totalPrice.points})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA possui',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:balance.pointsValue}))))))));}}]);return Body;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Body.propTypes={payment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,balance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,totalPrice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,isLoading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isAbilityInCampaing:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,fetchPointsCashConfig:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handleStepChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,orientation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,fetchCashOnlyConfig:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Body);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(203);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PointsCash=function(_Component){_inherits(PointsCash,_Component);function PointsCash(){_classCallCheck(this,PointsCash);return _possibleConstructorReturn(this,(PointsCash.__proto__||Object.getPrototypeOf(PointsCash)).apply(this,arguments));}_createClass(PointsCash,[{key:'render',value:function render(){if(this.props.paymentSelected==='POINTS_CASH'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["f" /* PointsCashContainer */],{radioSelected:true,selectPointsCash:this.props.selectPointsCash},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["g" /* PointsCashContent */],Object.assign({},this.props,{sliderAriaLabelledby:'cashPointsTxt'})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["f" /* PointsCashContainer */],Object.assign({},this.props,{radioSelected:false,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["e" /* PointsCashCardBrands */],{brands:this.props.brands})}));}}]);return PointsCash;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PointsCash.propTypes={brands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,paymentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,selectPointsCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PointsCash);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardBrands__ = __webpack_require__(188);
var PointsCashCardBrands=function PointsCashCardBrands(_ref){var brands=_ref.brands;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-payment border-none mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CardBrands__["a" /* CardBrands */],{brands:brands})));};PointsCashCardBrands.propTypes=__WEBPACK_IMPORTED_MODULE_1__CardBrands__["a" /* CardBrands */].propTypes;/* harmony default export */ __webpack_exports__["a"] = (PointsCashCardBrands);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PointsCashPlaceholder__ = __webpack_require__(1251);
var PointsCashContent=function PointsCashContent(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:!props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PointsCashPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method-creditcard col-12 mt-1 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["h" /* Range */],props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* CreditCard */],props)));};PointsCashContent.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,sliderAriaLabelledby:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PointsCashContent);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PointsCashPlaceholder=function PointsCashPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'method-creditcard col-12 mt-1 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range-step row border-color-ui-3 border-bottom pb-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-3 order-2 order-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 px-2 radius bg-ui-3 py-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 order-1 order-md-2 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 mb-2 mb-md-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 radius bg-ui-3 pt-1 mb-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-3 order-3 order-md-3 form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 px-2 radius bg-ui-3 py-2'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-step h-auto row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 radius bg-ui-3 py-2 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 radius bg-ui-3 py-2 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 radius bg-ui-3 py-2 mb-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-2 radius bg-ui-3 py-2 mb-1 mr-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-2 radius bg-ui-3 py-2 mb-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pos-relative inserted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-credit-card front_credit-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://via.placeholder.com/265x165/D2DCDE?text=\xA0',className:'creditcard w-100 my-1 pt-1 pb-0'}))))))));};/* harmony default export */ __webpack_exports__["a"] = (PointsCashPlaceholder);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var PointsCashContainer=function PointsCashContainer(_ref){var title=_ref.title,children=_ref.children,selectPointsCash=_ref.selectPointsCash,hasError=_ref.hasError,radioSelected=_ref.radioSelected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-item border-color-ui-3 col-12 mx-0 my-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-item item h-auto col-12 border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["RadioButton"],{id:'PointCash',name:'PaymentMethod',label:'',ariaLabelledby:'cashPointsTxt',role:'radio',value:'PointCash',className:'col-auto pl-0',onClick:selectPointsCash,disabled:hasError,defaultChecked:radioSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm',id:'cashPointsTxt','aria-hidden':'true'},'Utilizar pontos e cart\xE3o de cr\xE9dito ')),title)),children));};PointsCashContainer.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,selectPointsCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,hasError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,radioSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (PointsCashContainer);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_input_range__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_input_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_input_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RangePlaceholder__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_range_lib_css_index_css__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_range_lib_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_range_lib_css_index_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var numberToStrCurrency=function numberToStrCurrency(value,decimalPlaces){return value.toLocaleString('pt-br',{minimumFractionDigits:decimalPlaces,maximumFractionDigits:decimalPlaces});};var strCurrencyToNumber=function strCurrencyToNumber(value){return value.split('.').join('').replace(',','.');};var Range=function(_React$Component){_inherits(Range,_React$Component);function Range(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Range);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Range.__proto__||Object.getPrototypeOf(Range)).call.apply(_ref,[this].concat(args))),_this),_this.state={points:_this.props.payment.pointsCashConfig.maxPointForCash,minimulParcelCash:5,maxPointForCash:_this.props.payment.pointsCashConfig.maxPointForCash},_this.handleRangeChangeComplete=function(value){_this.props.fetchInstallments(value);},_this.handleRangeLimiteValue=function(){},_this.handleCash=function(points){var pointsCashConfig=_this.props.payment.pointsCashConfig;var markup=pointsCashConfig.markup,conversionRate=pointsCashConfig.conversionRate,maxPointForCash=pointsCashConfig.maxPointForCash,totalOrder=pointsCashConfig.totalOrder,totalFundsParticipant=pointsCashConfig.totalFundsParticipant;if(points>totalOrder)points=totalOrder;if(points>totalFundsParticipant)points=totalFundsParticipant;var pointsCash=parseFloat(points);if(maxPointForCash-points<0)pointsCash=maxPointForCash;var pointsDiference=totalOrder-pointsCash;var valueCurrency=pointsDiference/conversionRate;var markupCurrency=valueCurrency*markup/100;var cash=valueCurrency+markupCurrency;_this.setState({cash:cash});return cash;},_this.handleRangeChange=function(points){var _this$props$payment$p=_this.props.payment.pointsCashConfig,totalFundsParticipant=_this$props$payment$p.totalFundsParticipant,totalOrder=_this$props$payment$p.totalOrder;if(points>totalFundsParticipant)points=totalFundsParticipant;if(points>totalOrder)points=totalOrder;_this.setState(function(){return{points:points,cash:_this.handleCash(points)};});},_this.handleValueBlur=function(_){return _this.props.fetchInstallments(numberToStrCurrency(_this.state.cash||0,2));},_this.handleValueChange=function(_ref2){var value=_ref2.target.value;var points=strCurrencyToNumber(value);_this.setState({points:points});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Range,[{key:'componentDidMount',value:function componentDidMount(){var points=this.state.points;var _props$payment$points=this.props.payment.pointsCashConfig,decimalPlaces=_props$payment$points.decimalPlaces,totalFundsParticipant=_props$payment$points.totalFundsParticipant,totalOrder=_props$payment$points.totalOrder;if(points>totalFundsParticipant)points=totalFundsParticipant;if(points>totalOrder)points=totalOrder;this.handleRangeChange(points);this.handleRangeLimiteValue();this.props.fetchInstallments(points);var step=decimalPlaces>0?parseFloat('0.'+'1'.padStart(decimalPlaces,'0')):1;this.setState({step:step});}},{key:'render',value:function render(){var _props$payment=this.props.payment,items=_props$payment.installments.items,pointsCashConfig=_props$payment.pointsCashConfig;if(!this.props.showCashWithTotalPoints){if(!items||items.length<1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RangePlaceholder__["a" /* default */],null);}}var minPointForCash=pointsCashConfig.minPointForCash,decimalPlaces=pointsCashConfig.decimalPlaces;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range-step row border-color-ui-3 border-bottom pb-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-3 order-2 order-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'pontos',label:'Valor em '+this.props.pointsName,className:'form-field col-12 mt-0',value:numberToStrCurrency(this.state.points,decimalPlaces),onChange:this.handleValueChange,onBlur:this.handleValueBlur,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 order-1 order-md-2 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 mb-2 mb-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_input_range___default.a,{minValue:minPointForCash,maxValue:this.state.maxPointForCash,value:this.state.points,onChange:this.handleRangeChange,onChangeComplete:this.handleRangeChangeComplete,step:this.state.step,ariaLabelledby:this.props.sliderAriaLabelledby})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-3 order-3 order-md-3  form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'cash',label:'Valor em R$',className:'form-field col-12 mt-0',value:numberToStrCurrency(this.state.cash||0,2),disabled:true}))));}}]);return Range;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Range.propTypes={payment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,fetchInstallments:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,pointsName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,sliderAriaLabelledby:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,showCashWithTotalPoints:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired};var mapStateToProps=function mapStateToProps(_ref3){var _ref3$catalog=_ref3.catalog,currencyConfiguration=_ref3$catalog.currencyConfiguration,showCashWithTotalPoints=_ref3$catalog.showCashWithTotalPoints;return{pointsName:currencyConfiguration.pointsName,showCashWithTotalPoints:showCashWithTotalPoints};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(Range));

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputRange = __webpack_require__(1255);

var _inputRange2 = _interopRequireDefault(_inputRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 * @typedef {Object} ClientRect
 * @property {number} height
 * @property {number} left
 * @property {number} top
 * @property {number} width
 */

/**
 * @typedef {Object} InputRangeClassNames
 * @property {string} activeTrack
 * @property {string} disabledInputRange
 * @property {string} inputRange
 * @property {string} labelContainer
 * @property {string} maxLabel
 * @property {string} minLabel
 * @property {string} slider
 * @property {string} sliderContainer
 * @property {string} track
 * @property {string} valueLabel
 */

/**
 * @typedef {Function} LabelFormatter
 * @param {number} value
 * @param {string} type
 * @return {string}
 */

/**
 * @ignore
 * @typedef {Object} Point
 * @property {number} x
 * @property {number} y
 */

/**
 * @typedef {Object} Range
 * @property {number} min - Min value
 * @property {number} max - Max value
 */

exports.default = _inputRange2.default;
module.exports = exports['default'];
//# sourceMappingURL=index.js.map

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(291);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _valueTransformer = __webpack_require__(1256);

var valueTransformer = _interopRequireWildcard(_valueTransformer);

var _defaultClassNames = __webpack_require__(1264);

var _defaultClassNames2 = _interopRequireDefault(_defaultClassNames);

var _label = __webpack_require__(536);

var _label2 = _interopRequireDefault(_label);

var _rangePropType = __webpack_require__(1265);

var _rangePropType2 = _interopRequireDefault(_rangePropType);

var _valuePropType = __webpack_require__(1266);

var _valuePropType2 = _interopRequireDefault(_valuePropType);

var _slider = __webpack_require__(1267);

var _slider2 = _interopRequireDefault(_slider);

var _track = __webpack_require__(1268);

var _track2 = _interopRequireDefault(_track);

var _utils = __webpack_require__(204);

var _keyCodes = __webpack_require__(1269);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * A React component that allows users to input numeric values within a range
 * by dragging its sliders.
 */
var InputRange = (_class = function (_React$Component) {
  _inherits(InputRange, _React$Component);

  _createClass(InputRange, null, [{
    key: 'propTypes',

    /**
     * @ignore
     * @override
     * @return {Object}
     */
    get: function get() {
      return {
        allowSameValues: _propTypes2.default.bool,
        ariaLabelledby: _propTypes2.default.string,
        ariaControls: _propTypes2.default.string,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
        disabled: _propTypes2.default.bool,
        draggableTrack: _propTypes2.default.bool,
        formatLabel: _propTypes2.default.func,
        maxValue: _rangePropType2.default,
        minValue: _rangePropType2.default,
        name: _propTypes2.default.string,
        onChangeStart: _propTypes2.default.func,
        onChange: _propTypes2.default.func.isRequired,
        onChangeComplete: _propTypes2.default.func,
        step: _propTypes2.default.number,
        value: _valuePropType2.default
      };
    }

    /**
     * @ignore
     * @override
     * @return {Object}
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        allowSameValues: false,
        classNames: _defaultClassNames2.default,
        disabled: false,
        maxValue: 10,
        minValue: 0,
        step: 1
      };
    }

    /**
     * @param {Object} props
     * @param {boolean} [props.allowSameValues]
     * @param {string} [props.ariaLabelledby]
     * @param {string} [props.ariaControls]
     * @param {InputRangeClassNames} [props.classNames]
     * @param {boolean} [props.disabled = false]
     * @param {Function} [props.formatLabel]
     * @param {number|Range} [props.maxValue = 10]
     * @param {number|Range} [props.minValue = 0]
     * @param {string} [props.name]
     * @param {string} props.onChange
     * @param {Function} [props.onChangeComplete]
     * @param {Function} [props.onChangeStart]
     * @param {number} [props.step = 1]
     * @param {number|Range} props.value
     */

  }]);

  function InputRange(props) {
    _classCallCheck(this, InputRange);

    /**
     * @private
     * @type {?number}
     */
    var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));

    _this.startValue = null;

    /**
     * @private
     * @type {?Component}
     */
    _this.node = null;

    /**
     * @private
     * @type {?Component}
     */
    _this.trackNode = null;

    /**
     * @private
     * @type {bool}
     */
    _this.isSliderDragging = false;

    /**
     * @private
     * @type {?string}
     */
    _this.lastKeyMoved = null;
    return _this;
  }

  /**
   * @ignore
   * @override
   * @return {void}
   */


  _createClass(InputRange, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentMouseUpListener();
      this.removeDocumentTouchEndListener();
    }

    /**
     * Return the CSS class name of the component
     * @private
     * @return {string}
     */

  }, {
    key: 'getComponentClassName',
    value: function getComponentClassName() {
      if (!this.props.disabled) {
        return this.props.classNames.inputRange;
      }

      return this.props.classNames.disabledInputRange;
    }

    /**
     * Return the bounding rect of the track
     * @private
     * @return {ClientRect}
     */

  }, {
    key: 'getTrackClientRect',
    value: function getTrackClientRect() {
      return this.trackNode.getClientRect();
    }

    /**
     * Return the slider key closest to a point
     * @private
     * @param {Point} position
     * @return {string}
     */

  }, {
    key: 'getKeyByPosition',
    value: function getKeyByPosition(position) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

      if (this.isMultiValue()) {
        var distanceToMin = (0, _utils.distanceTo)(position, positions.min);
        var distanceToMax = (0, _utils.distanceTo)(position, positions.max);

        if (distanceToMin < distanceToMax) {
          return 'min';
        }
      }

      return 'max';
    }

    /**
     * Return all the slider keys
     * @private
     * @return {string[]}
     */

  }, {
    key: 'getKeys',
    value: function getKeys() {
      if (this.isMultiValue()) {
        return ['min', 'max'];
      }

      return ['max'];
    }

    /**
     * Return true if the difference between the new and the current value is
     * greater or equal to the step amount of the component
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'hasStepDifference',
    value: function hasStepDifference(values) {
      var currentValues = valueTransformer.getValueFromProps(this.props, this.isMultiValue());

      return (0, _utils.length)(values.min, currentValues.min) >= this.props.step || (0, _utils.length)(values.max, currentValues.max) >= this.props.step;
    }

    /**
     * Return true if the component accepts a min and max value
     * @private
     * @return {boolean}
     */

  }, {
    key: 'isMultiValue',
    value: function isMultiValue() {
      return (0, _utils.isObject)(this.props.value);
    }

    /**
     * Return true if the range is within the max and min value of the component
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'isWithinRange',
    value: function isWithinRange(values) {
      if (this.isMultiValue()) {
        return values.min >= this.props.minValue && values.max <= this.props.maxValue && this.props.allowSameValues ? values.min <= values.max : values.min < values.max;
      }

      return values.max >= this.props.minValue && values.max <= this.props.maxValue;
    }

    /**
     * Return true if the new value should trigger a render
     * @private
     * @param {Range} values
     * @return {boolean}
     */

  }, {
    key: 'shouldUpdate',
    value: function shouldUpdate(values) {
      return this.isWithinRange(values) && this.hasStepDifference(values);
    }

    /**
     * Update the position of a slider
     * @private
     * @param {string} key
     * @param {Point} position
     * @return {void}
     */

  }, {
    key: 'updatePosition',
    value: function updatePosition(key, position) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var positions = valueTransformer.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

      positions[key] = position;
      this.lastKeyMoved = key;

      this.updatePositions(positions);
    }

    /**
     * Update the positions of multiple sliders
     * @private
     * @param {Object} positions
     * @param {Point} positions.min
     * @param {Point} positions.max
     * @return {void}
     */

  }, {
    key: 'updatePositions',
    value: function updatePositions(positions) {
      var values = {
        min: valueTransformer.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
        max: valueTransformer.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
      };

      var transformedValues = {
        min: valueTransformer.getStepValueFromValue(values.min, this.props.step),
        max: valueTransformer.getStepValueFromValue(values.max, this.props.step)
      };

      this.updateValues(transformedValues);
    }

    /**
     * Update the value of a slider
     * @private
     * @param {string} key
     * @param {number} value
     * @return {void}
     */

  }, {
    key: 'updateValue',
    value: function updateValue(key, value) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());

      values[key] = value;

      this.updateValues(values);
    }

    /**
     * Update the values of multiple sliders
     * @private
     * @param {Range|number} values
     * @return {void}
     */

  }, {
    key: 'updateValues',
    value: function updateValues(values) {
      if (!this.shouldUpdate(values)) {
        return;
      }

      this.props.onChange(this.isMultiValue() ? values : values.max);
    }

    /**
     * Increment the value of a slider by key name
     * @private
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'incrementValue',
    value: function incrementValue(key) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var value = values[key] + this.props.step;

      this.updateValue(key, value);
    }

    /**
     * Decrement the value of a slider by key name
     * @private
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'decrementValue',
    value: function decrementValue(key) {
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var value = values[key] - this.props.step;

      this.updateValue(key, value);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Listen to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchEndListener',
    value: function addDocumentTouchEndListener() {
      this.removeDocumentTouchEndListener();
      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * Stop listening to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Stop listening to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchEndListener',
    value: function removeDocumentTouchEndListener() {
      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * Handle any "mousemove" event received by the slider
     * @private
     * @param {SyntheticEvent} event
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'handleSliderDrag',
    value: function handleSliderDrag(event, key) {
      var _this2 = this;

      if (this.props.disabled) {
        return;
      }

      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
      this.isSliderDragging = true;
      requestAnimationFrame(function () {
        return _this2.updatePosition(key, position);
      });
    }

    /**
     * Handle any "mousemove" event received by the track
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTrackDrag',
    value: function handleTrackDrag(event, prevEvent) {
      if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) {
        return;
      }

      var _props = this.props,
          maxValue = _props.maxValue,
          minValue = _props.minValue,
          _props$value = _props.value,
          max = _props$value.max,
          min = _props$value.min;


      var position = valueTransformer.getPositionFromEvent(event, this.getTrackClientRect());
      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);

      var prevPosition = valueTransformer.getPositionFromEvent(prevEvent, this.getTrackClientRect());
      var prevValue = valueTransformer.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
      var prevStepValue = valueTransformer.getStepValueFromValue(prevValue, this.props.step);

      var offset = prevStepValue - stepValue;

      var transformedValues = {
        min: min - offset,
        max: max - offset
      };

      this.updateValues(transformedValues);
    }

    /**
     * Handle any "keydown" event received by the slider
     * @private
     * @param {SyntheticEvent} event
     * @param {string} key
     * @return {void}
     */

  }, {
    key: 'handleSliderKeyDown',
    value: function handleSliderKeyDown(event, key) {
      if (this.props.disabled) {
        return;
      }

      switch (event.keyCode) {
        case _keyCodes.LEFT_ARROW:
        case _keyCodes.DOWN_ARROW:
          event.preventDefault();
          this.decrementValue(key);
          break;

        case _keyCodes.RIGHT_ARROW:
        case _keyCodes.UP_ARROW:
          event.preventDefault();
          this.incrementValue(key);
          break;

        default:
          break;
      }
    }

    /**
     * Handle any "mousedown" event received by the track
     * @private
     * @param {SyntheticEvent} event
     * @param {Point} position
     * @return {void}
     */

  }, {
    key: 'handleTrackMouseDown',
    value: function handleTrackMouseDown(event, position) {
      if (this.props.disabled) {
        return;
      }

      var _props2 = this.props,
          maxValue = _props2.maxValue,
          minValue = _props2.minValue,
          _props2$value = _props2.value,
          max = _props2$value.max,
          min = _props2$value.min;


      event.preventDefault();

      var value = valueTransformer.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
      var stepValue = valueTransformer.getStepValueFromValue(value, this.props.step);

      if (!this.props.draggableTrack || stepValue > max || stepValue < min) {
        this.updatePosition(this.getKeyByPosition(position), position);
      }
    }

    /**
     * Handle the start of any mouse/touch event
     * @private
     * @return {void}
     */

  }, {
    key: 'handleInteractionStart',
    value: function handleInteractionStart() {
      if (this.props.onChangeStart) {
        this.props.onChangeStart(this.props.value);
      }

      if (this.props.onChangeComplete && !(0, _utils.isDefined)(this.startValue)) {
        this.startValue = this.props.value;
      }
    }

    /**
     * Handle the end of any mouse/touch event
     * @private
     * @return {void}
     */

  }, {
    key: 'handleInteractionEnd',
    value: function handleInteractionEnd() {
      if (this.isSliderDragging) {
        this.isSliderDragging = false;
      }

      if (!this.props.onChangeComplete || !(0, _utils.isDefined)(this.startValue)) {
        return;
      }

      if (this.startValue !== this.props.value) {
        this.props.onChangeComplete(this.props.value);
      }

      this.startValue = null;
    }

    /**
     * Handle any "keydown" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      this.handleInteractionStart(event);
    }

    /**
     * Handle any "keyup" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      this.handleInteractionEnd(event);
    }

    /**
     * Handle any "mousedown" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      this.handleInteractionStart(event);
      this.addDocumentMouseUpListener();
    }

    /**
     * Handle any "mouseup" event received by the component
     * @private
     * @param {SyntheticEvent} event
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp(event) {
      this.handleInteractionEnd(event);
      this.removeDocumentMouseUpListener();
    }

    /**
     * Handle any "touchstart" event received by the component
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.handleInteractionStart(event);
      this.addDocumentTouchEndListener();
    }

    /**
     * Handle any "touchend" event received by the component
     * @private
     * @param {SyntheticEvent} event
     */

  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      this.handleInteractionEnd(event);
      this.removeDocumentTouchEndListener();
    }

    /**
     * Return JSX of sliders
     * @private
     * @return {JSX.Element}
     */

  }, {
    key: 'renderSliders',
    value: function renderSliders() {
      var _this3 = this;

      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
      var keys = this.props.allowSameValues && this.lastKeyMoved === 'min' ? this.getKeys().reverse() : this.getKeys();

      return keys.map(function (key) {
        var value = values[key];
        var percentage = percentages[key];

        var _props3 = _this3.props,
            maxValue = _props3.maxValue,
            minValue = _props3.minValue;


        if (key === 'min') {
          maxValue = values.max;
        } else {
          minValue = values.min;
        }

        var slider = _react2.default.createElement(_slider2.default, {
          ariaLabelledby: _this3.props.ariaLabelledby,
          ariaControls: _this3.props.ariaControls,
          classNames: _this3.props.classNames,
          formatLabel: _this3.props.formatLabel,
          key: key,
          maxValue: maxValue,
          minValue: minValue,
          onSliderDrag: _this3.handleSliderDrag,
          onSliderKeyDown: _this3.handleSliderKeyDown,
          percentage: percentage,
          type: key,
          value: value });

        return slider;
      });
    }

    /**
     * Return JSX of hidden inputs
     * @private
     * @return {JSX.Element}
     */

  }, {
    key: 'renderHiddenInputs',
    value: function renderHiddenInputs() {
      var _this4 = this;

      if (!this.props.name) {
        return [];
      }

      var isMultiValue = this.isMultiValue();
      var values = valueTransformer.getValueFromProps(this.props, isMultiValue);

      return this.getKeys().map(function (key) {
        var value = values[key];
        var name = isMultiValue ? '' + _this4.props.name + (0, _utils.captialize)(key) : _this4.props.name;

        return _react2.default.createElement('input', { key: key, type: 'hidden', name: name, value: value });
      });
    }

    /**
     * @ignore
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var componentClassName = this.getComponentClassName();
      var values = valueTransformer.getValueFromProps(this.props, this.isMultiValue());
      var percentages = valueTransformer.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);

      return _react2.default.createElement(
        'div',
        {
          'aria-disabled': this.props.disabled,
          ref: function ref(node) {
            _this5.node = node;
          },
          className: componentClassName,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart },
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'min' },
          this.props.minValue
        ),
        _react2.default.createElement(
          _track2.default,
          {
            classNames: this.props.classNames,
            draggableTrack: this.props.draggableTrack,
            ref: function ref(trackNode) {
              _this5.trackNode = trackNode;
            },
            percentages: percentages,
            onTrackDrag: this.handleTrackDrag,
            onTrackMouseDown: this.handleTrackMouseDown },
          this.renderSliders()
        ),
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'max' },
          this.props.maxValue
        ),
        this.renderHiddenInputs()
      );
    }
  }]);

  return InputRange;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
exports.default = InputRange;
module.exports = exports['default'];
//# sourceMappingURL=input-range.js.map

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getPercentageFromPosition = getPercentageFromPosition;
exports.getValueFromPosition = getValueFromPosition;
exports.getValueFromProps = getValueFromProps;
exports.getPercentageFromValue = getPercentageFromValue;
exports.getPercentagesFromValues = getPercentagesFromValues;
exports.getPositionFromValue = getPositionFromValue;
exports.getPositionsFromValues = getPositionsFromValues;
exports.getPositionFromEvent = getPositionFromEvent;
exports.getStepValueFromValue = getStepValueFromValue;

var _utils = __webpack_require__(204);

/**
 * Convert a point into a percentage value
 * @ignore
 * @param {Point} position
 * @param {ClientRect} clientRect
 * @return {number} Percentage value
 */
function getPercentageFromPosition(position, clientRect) {
  var length = clientRect.width;
  var sizePerc = position.x / length;

  return sizePerc || 0;
}

/**
 * Convert a point into a model value
 * @ignore
 * @param {Point} position
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {number}
 */
function getValueFromPosition(position, minValue, maxValue, clientRect) {
  var sizePerc = getPercentageFromPosition(position, clientRect);
  var valueDiff = maxValue - minValue;

  return minValue + valueDiff * sizePerc;
}

/**
 * Convert props into a range value
 * @ignore
 * @param {Object} props
 * @param {boolean} isMultiValue
 * @return {Range}
 */
function getValueFromProps(props, isMultiValue) {
  if (isMultiValue) {
    return _extends({}, props.value);
  }

  return {
    min: props.minValue,
    max: props.value
  };
}

/**
 * Convert a model value into a percentage value
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @return {number}
 */
function getPercentageFromValue(value, minValue, maxValue) {
  var validValue = (0, _utils.clamp)(value, minValue, maxValue);
  var valueDiff = maxValue - minValue;
  var valuePerc = (validValue - minValue) / valueDiff;

  return valuePerc || 0;
}

/**
 * Convert model values into percentage values
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @return {Range}
 */
function getPercentagesFromValues(values, minValue, maxValue) {
  return {
    min: getPercentageFromValue(values.min, minValue, maxValue),
    max: getPercentageFromValue(values.max, minValue, maxValue)
  };
}

/**
 * Convert a value into a point
 * @ignore
 * @param {number} value
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Point} Position
 */
function getPositionFromValue(value, minValue, maxValue, clientRect) {
  var length = clientRect.width;
  var valuePerc = getPercentageFromValue(value, minValue, maxValue);
  var positionValue = valuePerc * length;

  return {
    x: positionValue,
    y: 0
  };
}

/**
 * Convert a range of values into points
 * @ignore
 * @param {Range} values
 * @param {number} minValue
 * @param {number} maxValue
 * @param {ClientRect} clientRect
 * @return {Range}
 */
function getPositionsFromValues(values, minValue, maxValue, clientRect) {
  return {
    min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
    max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
  };
}

/**
 * Convert an event into a point
 * @ignore
 * @param {Event} event
 * @param {ClientRect} clientRect
 * @return {Point}
 */
function getPositionFromEvent(event, clientRect) {
  var length = clientRect.width;

  var _ref = event.touches ? event.touches[0] : event,
      clientX = _ref.clientX;

  return {
    x: (0, _utils.clamp)(clientX - clientRect.left, 0, length),
    y: 0
  };
}

/**
 * Convert a value into a step value
 * @ignore
 * @param {number} value
 * @param {number} valuePerStep
 * @return {number}
 */
function getStepValueFromValue(value, valuePerStep) {
  return Math.round(value / valuePerStep) * valuePerStep;
}
//# sourceMappingURL=value-transformer.js.map

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = captialize;
/**
 * Captialize a string
 * @ignore
 * @param {string} string
 * @return {string}
 */
function captialize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
module.exports = exports["default"];
//# sourceMappingURL=captialize.js.map

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clamp;
/**
 * Clamp a value between a min and max value
 * @ignore
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
module.exports = exports["default"];
//# sourceMappingURL=clamp.js.map

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = distanceTo;
/**
 * Calculate the distance between pointA and pointB
 * @ignore
 * @param {Point} pointA
 * @param {Point} pointB
 * @return {number} Distance
 */
function distanceTo(pointA, pointB) {
  var xDiff = Math.pow(pointB.x - pointA.x, 2);
  var yDiff = Math.pow(pointB.y - pointA.y, 2);

  return Math.sqrt(xDiff + yDiff);
}
module.exports = exports["default"];
//# sourceMappingURL=distance-to.js.map

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDefined;
/**
 * Check if a value is defined
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isDefined(value) {
  return value !== undefined && value !== null;
}
module.exports = exports["default"];
//# sourceMappingURL=is-defined.js.map

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}
module.exports = exports['default'];
//# sourceMappingURL=is-number.js.map

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isObject;
/**
 * Check if a value is an object
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
function isObject(value) {
  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}
module.exports = exports['default'];
//# sourceMappingURL=is-object.js.map

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = length;
/**
 * Calculate the absolute difference between two numbers
 * @ignore
 * @param {number} numA
 * @param {number} numB
 * @return {number}
 */
function length(numA, numB) {
  return Math.abs(numA - numB);
}
module.exports = exports["default"];
//# sourceMappingURL=length.js.map

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Default CSS class names
 * @ignore
 * @type {InputRangeClassNames}
 */
var DEFAULT_CLASS_NAMES = {
  activeTrack: 'input-range__track input-range__track--active',
  disabledInputRange: 'input-range input-range--disabled',
  inputRange: 'input-range',
  labelContainer: 'input-range__label-container',
  maxLabel: 'input-range__label input-range__label--max',
  minLabel: 'input-range__label input-range__label--min',
  slider: 'input-range__slider',
  sliderContainer: 'input-range__slider-container',
  track: 'input-range__track input-range__track--background',
  valueLabel: 'input-range__label input-range__label--value'
};

exports.default = DEFAULT_CLASS_NAMES;
module.exports = exports['default'];
//# sourceMappingURL=default-class-names.js.map

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rangePropType;

var _utils = __webpack_require__(204);

/**
 * @ignore
 * @param {Object} props - React component props
 * @return {?Error} Return Error if validation fails
 */
function rangePropType(props) {
  var maxValue = props.maxValue,
      minValue = props.minValue;


  if (!(0, _utils.isNumber)(minValue) || !(0, _utils.isNumber)(maxValue)) {
    return new Error('"minValue" and "maxValue" must be a number');
  }

  if (minValue >= maxValue) {
    return new Error('"minValue" must be smaller than "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=range-prop-type.js.map

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valuePropType;

var _utils = __webpack_require__(204);

/**
 * @ignore
 * @param {Object} props
 * @return {?Error} Return Error if validation fails
 */
function valuePropType(props, propName) {
  var maxValue = props.maxValue,
      minValue = props.minValue;

  var value = props[propName];

  if (!(0, _utils.isNumber)(value) && (!(0, _utils.isObject)(value) || !(0, _utils.isNumber)(value.min) || !(0, _utils.isNumber)(value.max))) {
    return new Error('"' + propName + '" must be a number or a range object');
  }

  if ((0, _utils.isNumber)(value) && (value < minValue || value > maxValue)) {
    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
  }

  if ((0, _utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
    return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
  }
}
module.exports = exports['default'];
//# sourceMappingURL=value-prop-type.js.map

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(291);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _label = __webpack_require__(536);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @ignore
 */
var Slider = (_class = function (_React$Component) {
  _inherits(Slider, _React$Component);

  _createClass(Slider, null, [{
    key: 'propTypes',

    /**
     * Accepted propTypes of Slider
     * @override
     * @return {Object}
     * @property {Function} ariaLabelledby
     * @property {Function} ariaControls
     * @property {Function} className
     * @property {Function} formatLabel
     * @property {Function} maxValue
     * @property {Function} minValue
     * @property {Function} onSliderDrag
     * @property {Function} onSliderKeyDown
     * @property {Function} percentage
     * @property {Function} type
     * @property {Function} value
     */
    get: function get() {
      return {
        ariaLabelledby: _propTypes2.default.string,
        ariaControls: _propTypes2.default.string,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        formatLabel: _propTypes2.default.func,
        maxValue: _propTypes2.default.number,
        minValue: _propTypes2.default.number,
        onSliderDrag: _propTypes2.default.func.isRequired,
        onSliderKeyDown: _propTypes2.default.func.isRequired,
        percentage: _propTypes2.default.number.isRequired,
        type: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.number.isRequired
      };
    }

    /**
     * @param {Object} props
     * @param {string} [props.ariaLabelledby]
     * @param {string} [props.ariaControls]
     * @param {InputRangeClassNames} props.classNames
     * @param {Function} [props.formatLabel]
     * @param {number} [props.maxValue]
     * @param {number} [props.minValue]
     * @param {Function} props.onSliderKeyDown
     * @param {Function} props.onSliderDrag
     * @param {number} props.percentage
     * @param {number} props.type
     * @param {number} props.value
     */

  }]);

  function Slider(props) {
    _classCallCheck(this, Slider);

    /**
     * @private
     * @type {?Component}
     */
    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.node = null;
    return _this;
  }

  /**
   * @ignore
   * @override
   * @return {void}
   */


  _createClass(Slider, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
      this.removeDocumentTouchEndListener();
      this.removeDocumentTouchMoveListener();
    }

    /**
     * @private
     * @return {Object}
     */

  }, {
    key: 'getStyle',
    value: function getStyle() {
      var perc = (this.props.percentage || 0) * 100;
      var style = {
        position: 'absolute',
        left: perc + '%'
      };

      return style;
    }

    /**
     * Listen to mousemove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseMoveListener',
    value: function addDocumentMouseMoveListener() {
      this.removeDocumentMouseMoveListener();
      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * Listen to touchmove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchMoveListener',
    value: function addDocumentTouchMoveListener() {
      this.removeDocumentTouchMoveListener();
      this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
    }

    /**
     * Listen to touchend event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentTouchEndListener',
    value: function addDocumentTouchEndListener() {
      this.removeDocumentTouchEndListener();
      this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseMoveListener',
    value: function removeDocumentMouseMoveListener() {
      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchMoveListener',
    value: function removeDocumentTouchMoveListener() {
      this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentTouchEndListener',
    value: function removeDocumentTouchEndListener() {
      this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown() {
      this.addDocumentMouseMoveListener();
      this.addDocumentMouseUpListener();
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      this.props.onSliderDrag(event, this.props.type);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart() {
      this.addDocumentTouchEndListener();
      this.addDocumentTouchMoveListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      this.props.onSliderDrag(event, this.props.type);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd() {
      this.removeDocumentTouchMoveListener();
      this.removeDocumentTouchEndListener();
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      this.props.onSliderKeyDown(event, this.props.type);
    }

    /**
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = this.getStyle();

      return _react2.default.createElement(
        'span',
        {
          className: this.props.classNames.sliderContainer,
          ref: function ref(node) {
            _this2.node = node;
          },
          style: style },
        _react2.default.createElement(
          _label2.default,
          {
            classNames: this.props.classNames,
            formatLabel: this.props.formatLabel,
            type: 'value' },
          this.props.value
        ),
        _react2.default.createElement('div', {
          'aria-labelledby': this.props.ariaLabelledby,
          'aria-controls': this.props.ariaControls,
          'aria-valuemax': this.props.maxValue,
          'aria-valuemin': this.props.minValue,
          'aria-valuenow': this.props.value,
          className: this.props.classNames.slider,
          draggable: 'false',
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          role: 'slider',
          tabIndex: '0' })
      );
    }
  }]);

  return Slider;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
exports.default = Slider;
module.exports = exports['default'];
//# sourceMappingURL=slider.js.map

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = __webpack_require__(291);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * @ignore
 */
var Track = (_class = function (_React$Component) {
  _inherits(Track, _React$Component);

  _createClass(Track, null, [{
    key: 'propTypes',

    /**
     * @override
     * @return {Object}
     * @property {Function} children
     * @property {Function} classNames
     * @property {Boolean} draggableTrack
     * @property {Function} onTrackDrag
     * @property {Function} onTrackMouseDown
     * @property {Function} percentages
     */
    get: function get() {
      return {
        children: _propTypes2.default.node.isRequired,
        classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        draggableTrack: _propTypes2.default.bool,
        onTrackDrag: _propTypes2.default.func,
        onTrackMouseDown: _propTypes2.default.func.isRequired,
        percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
      };
    }

    /**
     * @param {Object} props
     * @param {InputRangeClassNames} props.classNames
     * @param {Boolean} props.draggableTrack
     * @param {Function} props.onTrackDrag
     * @param {Function} props.onTrackMouseDown
     * @param {number} props.percentages
     */

  }]);

  function Track(props) {
    _classCallCheck(this, Track);

    /**
     * @private
     * @type {?Component}
     */
    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));

    _this.node = null;
    _this.trackDragEvent = null;
    return _this;
  }

  /**
   * @private
   * @return {ClientRect}
   */


  _createClass(Track, [{
    key: 'getClientRect',
    value: function getClientRect() {
      return this.node.getBoundingClientRect();
    }

    /**
     * @private
     * @return {Object} CSS styles
     */

  }, {
    key: 'getActiveTrackStyle',
    value: function getActiveTrackStyle() {
      var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
      var left = this.props.percentages.min * 100 + '%';

      return { left: left, width: width };
    }

    /**
     * Listen to mousemove event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseMoveListener',
    value: function addDocumentMouseMoveListener() {
      this.removeDocumentMouseMoveListener();
      this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * Listen to mouseup event
     * @private
     * @return {void}
     */

  }, {
    key: 'addDocumentMouseUpListener',
    value: function addDocumentMouseUpListener() {
      this.removeDocumentMouseUpListener();
      this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseMoveListener',
    value: function removeDocumentMouseMoveListener() {
      this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'removeDocumentMouseUpListener',
    value: function removeDocumentMouseUpListener() {
      this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
    }

    /**
     * @private
     * @param {SyntheticEvent} event
     * @return {void}
     */

  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (!this.props.draggableTrack) {
        return;
      }

      if (this.trackDragEvent !== null) {
        this.props.onTrackDrag(event, this.trackDragEvent);
      }

      this.trackDragEvent = event;
    }

    /**
     * @private
     * @return {void}
     */

  }, {
    key: 'handleMouseUp',
    value: function handleMouseUp() {
      if (!this.props.draggableTrack) {
        return;
      }

      this.removeDocumentMouseMoveListener();
      this.removeDocumentMouseUpListener();
      this.trackDragEvent = null;
    }

    /**
     * @private
     * @param {SyntheticEvent} event - User event
     */

  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var trackClientRect = this.getClientRect();
      var position = {
        x: clientX - trackClientRect.left,
        y: 0
      };

      this.props.onTrackMouseDown(event, position);

      if (this.props.draggableTrack) {
        this.addDocumentMouseMoveListener();
        this.addDocumentMouseUpListener();
      }
    }

    /**
     * @private
     * @param {SyntheticEvent} event - User event
     */

  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      event.preventDefault();

      this.handleMouseDown(event);
    }

    /**
     * @override
     * @return {JSX.Element}
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var activeTrackStyle = this.getActiveTrackStyle();

      return _react2.default.createElement(
        'div',
        {
          className: this.props.classNames.track,
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleTouchStart,
          ref: function ref(node) {
            _this2.node = node;
          } },
        _react2.default.createElement('div', {
          style: activeTrackStyle,
          className: this.props.classNames.activeTrack }),
        this.props.children
      );
    }
  }]);

  return Track;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
exports.default = Track;
module.exports = exports['default'];
//# sourceMappingURL=track.js.map

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @ignore */
var DOWN_ARROW = exports.DOWN_ARROW = 40;

/** @ignore */
var LEFT_ARROW = exports.LEFT_ARROW = 37;

/** @ignore */
var RIGHT_ARROW = exports.RIGHT_ARROW = 39;

/** @ignore */
var UP_ARROW = exports.UP_ARROW = 38;
//# sourceMappingURL=key-codes.js.map

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var RangePlaceholder=function RangePlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'range-step row border-color-ui-3 border-bottom pb-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-3 order-2 order-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 px-2 radius bg-ui-3 py-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 order-1 order-md-2 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 mb-2 mb-md-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 radius bg-ui-3 pt-1 mb-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-3 order-3 order-md-3 form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 px-2 radius bg-ui-3 py-2'}))));};/* harmony default export */ __webpack_exports__["a"] = (RangePlaceholder);

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_card_flip__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_card_flip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_card_flip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Select__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_payment_credit_card_front_png__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_payment_credit_card_front_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_payment_credit_card_front_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_payment_credit_card_back_png__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_payment_credit_card_back_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_payment_credit_card_back_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var messageErrorCredidNumber='O número do cartão de crédito parece inválido.';var CreditCard=function(_Component){_inherits(CreditCard,_Component);function CreditCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreditCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreditCard.__proto__||Object.getPrototypeOf(CreditCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={isFlipped:false,isBackCardVisible:false,errors:{}},_this.handleFlipChange=function(e){e.preventDefault();_this.setState(function(prevState){return{isFlipped:!prevState.isFlipped};});setTimeout(function(){_this.setState({isBackCardVisible:_this.state.isFlipped});},300);},_this.validateCardNumber=function(_ref2){var value=_ref2.target.value;if(value){var brand=_this.props.cardBrand();var errors=brand?Object.assign({},_this.state.errors,{number:''}):Object.assign({},_this.state.errors,{number:messageErrorCredidNumber});_this.setState({errors:errors});}},_this.fetchInstallments=function(items,installmentsCash,brand){var installments=items.length>0?items:installmentsCash;if(brand){var parcelas=_this.props.updateInstallments(installments);if(installments!==parcelas&&parcelas){var convert=[];for(var i=0;i<parcelas.length;i++){convert.push({description:_this.createInstallmentDescription(parcelas[i]),parcel:parcelas[i].quantidadeParcelas,parcelValue:parcelas[i].valorParcela,percentInterest:parcelas[i].taxaJurosAoMes});}installments=convert;}}return installments;},_this.createInstallmentDescription=function(parcela){return parcela.quantidadeParcelas+' X de R$ '+parcela.valorParcela;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreditCard,[{key:'render',value:function render(){var _props=this.props,_props$payment=_props.payment,items=_props$payment.installments.items,pointsCashConfig=_props$payment.pointsCashConfig,creditCard=_props.creditCard,cardBrand=_props.cardBrand;var brand=cardBrand();var installmentsCash=pointsCashConfig&&pointsCashConfig.parcelCashConfigurationModel||[];var installments=this.fetchInstallments(items,installmentsCash,brand);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-step h-auto row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-6 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-number',label:'N\xFAmero do cart\xE3o',className:'col-12 mt-2',required:true,guide:false,mask:[/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,/\d/],name:'number',onChange:this.props.handleCreditCardChange,value:creditCard.number,onBlur:this.validateCardNumber,'data-error':this.state.errors.number,valid:this.state.errors.number&&creditCard.number?false:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-person-name',label:'Nome impresso no cart\xE3o',className:'col-12 mt-2',required:true,onChange:this.props.handleCreditCardChange,value:creditCard.personName,name:'personName'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-person-cpf',label:'CPF do portador do cart\xE3o',className:'col-12 mt-2',required:true,mask:[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/],onChange:this.props.handleCreditCardChange,value:creditCard.personCPF,name:'personCPF'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-validity-date',label:'Validade m\xEAs/ano',className:'col-6 mt-2',mask:[/\d/,/\d/,'/',/\d/,/\d/],required:true,onChange:this.props.handleCreditCardChange,value:creditCard.validityDate,name:'validityDate'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'payment-card-cvv',label:'CVV',className:'col-6 mt-2',mask:typeof brand!=='undefined'&&brand.name==='AmericanExpress'?[/\d/,/\d/,/\d/,/\d/]:[/\d/,/\d/,/\d/],required:true,onFocus:this.handleFlipChange,onBlur:this.handleFlipChange,onChange:this.props.handleCreditCardChange,value:creditCard.cvv,name:'cvv'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Select__["a" /* default */],{id:'payment-installment',label:'Parcelar em',className:'col-12 mt-2',displayValue:'description',selectedValue:'parcel',options:installments,value:this.props.installmentSelected(),onChange:this.props.handleCreditCardChange,name:'installment',required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-6 d-none d-lg-block mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pos-relative inserted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-credit-card front_credit-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_card_flip___default.a,{isFlipped:this.state.isFlipped},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front',key:'front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__loyal_images_payment_credit_card_front_png___default.a,alt:'Cart\xE3o',className:'creditcard w-100'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back',key:'back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__loyal_images_payment_credit_card_back_png___default.a,alt:'Cart\xE3o',className:'creditcard w-100'})))),this.state.isBackCardVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["b" /* CreditCardBack */],Object.assign({},creditCard,{cvv:typeof brand!=='undefined'&&brand.name==='AmericanExpress'?'****':'***'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["c" /* CreditCardFront */],Object.assign({},creditCard,{cardBrand:cardBrand}))))));}}]);return CreditCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CreditCard.propTypes={payment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,creditCard:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,handleCreditCardChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,installmentSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,cardBrand:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,updateInstallments:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CreditCard);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Select=function(_Component){_inherits(Select,_Component);function Select(props){_classCallCheck(this,Select);var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));_this.handleChange=function(value,index){var _this$props=_this.props,onChange=_this$props.onChange,name=_this$props.name;_this.setState({value:value,currentIndex:index});if(typeof onChange==='function'){_this.props.onChange({target:{name:name,value:value}});}};_this.getOptionTextSelected=function(){var value=_this.props.value;var _this$props2=_this.props,options=_this$props2.options,placeholder=_this$props2.placeholder,displayValue=_this$props2.displayValue,selectedValue=_this$props2.selectedValue;if(!value)return placeholder||'';var option=options.find(function(item){return item[selectedValue]===value[selectedValue];});if(option)return option[displayValue];return'';};_this.buildOptions=function(){var _this$props3=_this.props,options=_this$props3.options,displayValue=_this$props3.displayValue,selectedValue=_this$props3.selectedValue,image=_this$props3.image;return options.map(function(item,index){var text=item[displayValue];var value=item[selectedValue];var img=image?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:item[image],alt:item[image]}):'';var classImg=image?'select-img':'';return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{key:index,value:value,onClick:function onClick(){return _this.handleChange(item,index);},className:'txt-body-sm '+classImg},text,img);});};_this.state={currentIndex:-1,open:false,focus:false};_this.handleKeyDown=_this.handleKeyDown.bind(_this);return _this;}_createClass(Select,[{key:'handleKeyDown',value:function handleKeyDown(e){if(e.keyCode===39||e.keyCode===40){var nextIndex=this.state.currentIndex+1;if(nextIndex<this.props.options.length){this.handleChange(this.props.options[nextIndex],nextIndex);}}else if(e.keyCode===37||e.keyCode===38){var previousIndex=this.state.currentIndex-1;if(previousIndex>=0){this.handleChange(this.props.options[previousIndex],previousIndex);}}e.preventDefault();}},{key:'IsRequired',value:function IsRequired(){if(this.props.required)return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'required'},'*');}},{key:'HasEmptyValue',value:function HasEmptyValue(){var _this2=this;if(this.props.hasEmpty&&this.props.hasEmpty===true){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{value:'',onClick:function onClick(){return _this2.handleChange('',-1);}},'Selecione');}}},{key:'IsValid',value:function IsValid(){if(this.props.valid===true){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'message message-success icon icon_check'},this.props['data-success']);}else if(this.props.valid===false){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'message message-error icon icon_check'},this.props['data-error']);}}},{key:'GetContainerClasses',value:function GetContainerClasses(){return __WEBPACK_IMPORTED_MODULE_0_classnames___default()({select:true,'has-content':this.props.value||this.props.placeholder,open:this.state.open,success:this.props.valid===true,error:this.props.valid===false});}},{key:'GetOptionsStyle',value:function GetOptionsStyle(){if(this.state.open===true){return{display:'block'};}}},{key:'HasIcon',value:function HasIcon(){if(this.props.iconName&&this.props.valid===undefined){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'icon '+this.props.iconName});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'form-field '+(this.props.className||'')},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:this.GetContainerClasses(),id:this.props.id,name:this.props.name,disabled:this.props.disabled,onClick:function onClick(){return!_this3.props.disabled?_this3.setState({open:!_this3.state.open,focus:true}):null;},onBlur:function onBlur(){return!_this3.props.disabled?_this3.setState({open:false,focus:false}):null;},tabIndex:0,onKeyDown:this.handleKeyDown},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'select-styled'},this.getOptionTextSelected()),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'select-options',style:this.GetOptionsStyle()},this.HasEmptyValue(),this.buildOptions())),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{htmlFor:this.props.id},this.props.label,this.IsRequired()),this.HasIcon(),this.IsValid());}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);Select.propTypes={id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,'data-error':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,'data-success':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,valid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selectedValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,displayValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,iconName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hasEmpty:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var CreditCardFront=function CreditCardFront(_ref){var cardBrand=_ref.cardBrand,number=_ref.number,personName=_ref.personName,validityDate=_ref.validityDate;var brand=cardBrand();var personNameFormat=personName.substr(0,20);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card brand_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'},brand&&brand.name?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:brand.imageUrl,alt:brand.name}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card number_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'},number||'**** **** **** ****'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card name_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'},personNameFormat||'Nome e Sobrenome'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'front_credit-card date_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-white txt-uppercase'},validityDate||'00/00'));};CreditCardFront.propTypes={number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,personName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,validityDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,cardBrand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CreditCardFront);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var CreditCardBack=function CreditCardBack(_ref){var cvv=_ref.cvv,cvvMask=_ref.cvvMask;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'back_credit-card cvv_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-1 txt-uppercase'},cvv||cvvMask);};CreditCardBack.propTypes={cvv:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,cvvMask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CreditCardBack);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PointsOnly__ = __webpack_require__(1277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PointsOnly__["a"]; });


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var PointsOnly=function PointsOnly(_ref){var balance=_ref.balance,selectPointsOnly=_ref.selectPointsOnly,catalog=_ref.catalog,paymentSelected=_ref.paymentSelected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-item item h-auto col-12 border-color-ui-3 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["RadioButton"],{id:'PointsOnly',name:'PaymentMethod',label:'',value:'PointsOnly',ariaLabelledby:'myPointsTxt',className:'col-auto pl-0',role:'radio',defaultChecked:paymentSelected==='POINTS_ONLY',onClick:selectPointsOnly}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm',id:'myPointsTxt','aria-hidden':'true'},'Utilizar apenas os meus '+(catalog&&catalog.currencyConfiguration&&catalog.currencyConfiguration.pointsName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA possui ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{className:'d-md-inline-block d-block txt-body-sm',value:balance.pointsValue})))));};PointsOnly.propTypes={balance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,selectPointsOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,catalog:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,paymentSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PointsOnly);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__);
var CheckoutPlaceholder=function CheckoutPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 px-2 radius bg-ui-3 pt-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-item item h-auto col-12 border-color-ui-3  pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1 radius-circle bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 px-1 radius bg-ui-3 pt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-6 col-6 px-1 radius bg-ui-3 pt-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1 radius-circle bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 radius bg-ui-3 pt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-1 radius-circle bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col row mx-0 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'0 -6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'0 -6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'0 -6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'0 -6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 bg-ui-3 pt-2 pb-1 mr-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'0 -6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 bg-ui-3 pt-2 pb-1',style:{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundRepeat:'no-repeat',backgroundSize:'cover',backgroundPosition:'0 -6px'}})))))));};/* harmony default export */ __webpack_exports__["a"] = (CheckoutPlaceholder);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormVirtualVoucher__ = __webpack_require__(1280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormVirtualVoucher__["a"]; });


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_modal_css__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Header__ = __webpack_require__(1281);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var client=__WEBPACK_IMPORTED_MODULE_3_redux_clients__["a" /* default */].cloudloyalty.client;var FormVirtualVoucher=function(_React$Component){_inherits(FormVirtualVoucher,_React$Component);function FormVirtualVoucher(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FormVirtualVoucher);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FormVirtualVoucher.__proto__||Object.getPrototypeOf(FormVirtualVoucher)).call.apply(_ref,[this].concat(args))),_this),_this.state={email:{value:_this.props.cart.customer&&_this.props.cart.customer.email||_this.props.participant.email.value,disabled:_this.props.participant.email.disabled},isValid:true,isConfirmLoading:false,confirmVoucher:false},_this.handleInputValid=function(input){if(input.error)return false;return null;},_this.isValid=function(){var mailValidator=/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim;var email=_this.state.email;if(!mailValidator.test(email.value)){_this.setState({email:{value:email.value,disabled:email.disabled,error:'Digite um e-mail válido'}});return false;}return true;},_this.handleConfirm=function(email){_this.setState({isConfirmLoading:true,confirmVoucher:false});client.post('v1/carts/1/me/emailAddress?email='+email.value).then(function(_){_this.setState({isConfirmLoading:false});_this.props.handleStepChange(2);});},_this.handleToggleModalConfirmation=function(){_this.setState({confirmVoucher:!_this.state.confirmVoucher});},_this.handleEmailChange=function(_ref2){var value=_ref2.target.value;return _this.setState({email:Object.assign({},_this.state.email,{value:value})});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FormVirtualVoucher,[{key:'componentDidMount',value:function componentDidMount(){this.isValid();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,step=_props.step,handleStepChange=_props.handleStepChange;var _state=this.state,email=_state.email,isValid=_state.isValid,isConfirmLoading=_state.isConfirmLoading,confirmVoucher=_state.confirmVoucher;if(step!==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Header__["a" /* default */],{step:step,handleStepChange:handleStepChange}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12','data-index':'1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Header__["a" /* default */],{step:step,handleStepChange:handleStepChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-virtual-voucher col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'input-email-profile-data',label:'E-mail',className:'col-6 col-md-6 mt-2',required:true,name:'email','data-error':email.error,valid:this.handleInputValid(email),onChange:this.handleEmailChange,value:email.value,disabled:email.disabled==='true',onBlur:this.isValid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-6 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured',disabled:!email.value&&!isValid,onClick:this.handleToggleModalConfirmation,text:'Pr\xF3ximo',loading:isConfirmLoading})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default.a,{width:'600',height:'90%',effect:'fadeInUp',visible:confirmVoucher},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-wrapper col-11 mx-auto bg-white radius px-2 py-3 border-bottom border-color-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'O voucher ser\xE1 encaminhado para o e-mail: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,email.value),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-1'},'Ap\xF3s o fechamento do pedido, n\xE3o ser\xE1 poss\xEDvel alterar o e-mail para envio ou reenvio do voucher.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6  mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm py-2',disabled:!isValid,onClick:this.handleToggleModalConfirmation,text:'Cancelar',loading:isConfirmLoading})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6  mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured  py-2',disabled:!isValid,onClick:function onClick(){return _this2.handleConfirm(email);},text:'Confirmar',loading:isConfirmLoading})))))));}}]);return FormVirtualVoucher;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FormVirtualVoucher.propTypes={participant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,handleStepChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FormVirtualVoucher);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Header=function Header(_ref){var step=_ref.step,handleStepChange=_ref.handleStepChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step-shipping checkout-step row px-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_message color-brand-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-brand-1 txt-body txt-uppercase mr-auto'},'Dados de Envio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'txt-body-sm txt-right border-bottom border-color-ui-1 color-links border-color-links '+(step>0?'d-block':'d-none'),href:'javascript:void(0)',onClick:function onClick(){handleStepChange(0);}},'Alterar'))));};Header.propTypes={step:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,handleStepChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CheckoutPlaceholder=function CheckoutPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container py-md-5 py-0 px-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-side col-12 col-md-8 pl-0 pr-md-2 pr-0 mt-5 pt-2 mt-md-0 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 checkout-step row px-2 border-bottom border-color-ui-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-2 radius bg-ui-3 py-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-5 radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-infos col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 radius bg-ui-3 py-1 mt-1 mr-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 radius bg-ui-3 py-1 mt-1 mr-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1 mr-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1 mr-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1 mr-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm py-2 mt-1 mr-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm radius bg-ui-3 py-2 mt-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 checkout-step row px-2 border-bottom border-color-ui-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-2 radius bg-ui-3 py-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-5 radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 checkout-step row px-2 border-bottom border-color-ui-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-2 radius bg-ui-3 py-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 px-5 radius bg-ui-3 py-1'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-side col-12 col-md-4 mb-3 mb-md-0 mt-2 mt-md-0 px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-ui-3 radius bg-white px-0 py-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 px-5 radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row pb-2 px-2 mx-0 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-5 radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mt-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-5 radius bg-ui-3 py-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row pb-2 px-2 mx-0 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-5 radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mt-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-5 radius bg-ui-3 py-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row pb-0 px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-5 radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mt-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-5 radius bg-ui-3 py-1'})))))));};/* harmony default export */ __webpack_exports__["a"] = (CheckoutPlaceholder);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export handleCardbrands */
/* unused harmony export handleInstallments */
/* unused harmony export getOriginalId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_clients__ = __webpack_require__(25);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var handleCardbrands=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(vendorId,requestdata){var retorno;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_1_redux_clients__["a" /* default */].cloudloyalty.client.post('/v1/configurations/payment/type/'+vendorId,requestdata);case 2:retorno=_context.sent;return _context.abrupt('return',retorno.status===200?retorno.data:{type:'classic'});case 4:case'end':return _context.stop();}}},_callee,_this);}));return function handleCardbrands(_x,_x2){return _ref.apply(this,arguments);};}();var handleInstallments=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(vendorId,requestdata){var retorno;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_1_redux_clients__["a" /* default */].cloudloyalty.client.post('/v1/configurations/payment/installments/'+vendorId,requestdata);case 2:retorno=_context2.sent;return _context2.abrupt('return',retorno.status===200?retorno.data:{type:'classic'});case 4:case'end':return _context2.stop();}}},_callee2,_this);}));return function handleInstallments(_x3,_x4){return _ref2.apply(this,arguments);};}();var getOriginalId=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(sku){var retorno;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_1_redux_clients__["a" /* default */].cloudloyalty.client.get('/v1/products/skus/'+sku);case 2:retorno=_context3.sent;return _context3.abrupt('return',retorno.status===200?retorno.data.skus.find(function(x){return x.sku===sku;}).originalId:0);case 4:case'end':return _context3.stop();}}},_callee3,_this);}));return function getOriginalId(_x5){return _ref3.apply(this,arguments);};}();/* harmony default export */ __webpack_exports__["a"] = ({handleCardbrands:handleCardbrands,handleInstallments:handleInstallments,getOriginalId:getOriginalId});

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var defaultPointsCashConfig={isLoading:true};var defaultInstallments={items:[],isLoading:true};var paymentDefault={pointsCashConfig:defaultPointsCashConfig,installments:defaultInstallments,isDepreciated:false};var defaultState={isLoading:false,hasError:false,messageError:'',payment:paymentDefault,confirmedOrderId:undefined,authorized:false,loadingResendToken:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case'FETCH_POINTS_CASH_CONFIG':case'FETCH_CASH_ONLY_CONFIG':return Object.assign({},state,{payment:paymentDefault});case'FETCH_POINTS_CASH_CONFIG_SUCCESS':case'FETCH_CASH_ONLY_CONFIG_SUCCESS':var data=action.payload.data;var isLoading=false;var hasError=data.error&&data.error.length>0;var error=hasError?data.error[0]:data.error;if(!hasError&&state.hasError){hasError=true;error=state.messageError;}var payment=Object.assign({},state.payment,{pointsCashConfig:Object.assign({},data,{isLoading:isLoading})});return Object.assign({},state,{payment:payment,hasError:hasError,messageError:error});case'FETCH_POINTS_CASH_CONFIG_FAIL':case'FETCH_CASH_ONLY_CONFIG_FAIL':return Object.assign({},state,{payment:Object.assign({},state.payment,{pointsCashConfig:{error:action.error,isLoading:false}})});case'FETCH_INSTALLMENTS':return Object.assign({},state,{payment:Object.assign({},state.payment,{installments:defaultInstallments})});case'FETCH_INSTALLMENTS_SUCCESS':return Object.assign({},state,{payment:Object.assign({},state.payment,{installments:{items:[].concat(_toConsumableArray(action.payload.data)),isLoading:false}})});case'FETCH_INSTALLMENTS_FAIL':return Object.assign({},state,{payment:Object.assign({},state.payment,{installments:{error:action.error,isLoading:false}})});case'CREATE_PURCHASE':delete state.errorResend;return Object.assign({},state,{isCreatingPurchase:true,status:''});case'CREATE_PURCHASE_SUCCESS':var _action$payload=action.payload,_action$payload$data=_action$payload.data,id=_action$payload$data.id,status=_action$payload$data.status,statusCode=_action$payload.status;return Object.assign({},state,{isCreatingPurchase:false,confirmedOrderId:id,status:status,statusCode:statusCode,secondFactorAuthSuccess:false,authorized:!status});case'CREATE_PURCHASE_FAIL':var response=action.error.response;var messageError=response&&response.data&&response.data.errors&&response.data.errors.length>0&&response.data.errors[0].message||response.data.messages[0].description||'';return Object.assign({},state,{isCreatingPurchase:false,secondFactorAuthSuccess:false,statusCode:response.status,hasError:true,messageError:messageError,authorized:false});case'CLEAR_PURCHASE_ERROR':return Object.assign({},state,{hasError:false,messageError:undefined});case'CART_UPDATE_COUPON_SUCCESS':{return Object.assign({},state,{payment:Object.assign({},state.payment,{isDepreciated:true})});}case'CART_REMOVE_COUPON_SUCCESS':return Object.assign({},state,{payment:Object.assign({},state.payment,{isDepreciated:true}),hasError:false,titleError:'',messageError:''});case'CART_REMOVE_COUPON_FAIL':return Object.assign({},state,{hasError:true,titleError:'Não foi possível remover o cupom de desconto.',messageError:'Tente novamente.'});case'AUTHORIZE_TOKEN':return Object.assign({},state,{isCreatingPurchase:true,authorized:false});case'AUTHORIZE_TOKEN_SUCCESS':delete state.errorToken;var lastTry=action.meta.previousAction&&action.meta.previousAction.lastTry;var _action$payload2=action.payload,_action$payload2$data=_action$payload2.data,_status=_action$payload2$data===undefined?status.status:_action$payload2$data,_action$payload2$stat=_action$payload2.status,_statusCode=_action$payload2$stat===undefined?statusCode:_action$payload2$stat;return Object.assign({},state,{secondFactorAuthSuccess:!(_statusCode===202&&_status.status==='RequiresTokenValidation')||lastTry,authorized:!_status.status,isCreatingPurchase:false,status:_status.status,statusCode:_statusCode,errorToken:_statusCode===202&&_status.status==='RequiresTokenValidation'});case'AUTHORIZE_TOKEN_FAIL':delete state.confirmedOrderId;var lastTryFail=action.meta.previousAction&&action.meta.previousAction.lastTry;var response_=action.error.response;var _response_$data=response_.data,_statusFail=_response_$data===undefined?status.status:_response_$data;var messageError_=response_&&response_.data&&response_.data.errors&&response_.data.errors.length>0&&response_.data.errors[0].message||_statusFail.status==='TokenFinished'&&'Tentativas de verificação de token excedidas!'||'';var titleError=_statusFail.status==='TokenFinished'&&'Não foi possível concluir o seu pagamento'||'';return Object.assign({},state,{titleError:titleError,status:_statusFail&&_statusFail.status,hasError:true,authorized:false,secondFactorAuthSuccess:!(response_&&response_.status===202&&_statusFail.status==='RequiresTokenValidation')||response_&&response_.status===403&&_statusFail.status==='TokenFinished'||lastTryFail,isCreatingPurchase:false,messageError_:messageError_,messageError:messageError_});case'AUTHORIZE_RESEND':delete state.errorResend;return Object.assign({},state,{loadingResendToken:true});case'AUTHORIZE_RESEND_SUCCESS':return Object.assign({},state,{isCreatingPurchase:false,loadingResendToken:false});case'AUTHORIZE_RESEND_FAIL':var responseR_=action.error.response;var messageErrorR_=responseR_&&responseR_.data&&(responseR_.data.errors&&responseR_.data.errors.length>0&&responseR_.data.errors[0].message||responseR_.data.message)||'';var dataStatus=responseR_&&responseR_.data&&responseR_.data.status;var responseRStatus=responseR_&&responseR_.status;return Object.assign({},state,{secondFactorAuthSuccess:true,status:dataStatus,statusCode:responseRStatus,isCreatingPurchase:false,errorResend:(responseRStatus===400||responseRStatus===500)&&dataStatus==='ResendTokenError',messageError:messageErrorR_,messageErrorR_:messageErrorR_,hasError:true,loadingResendToken:false});case'AUTHORIZE_TOKEN_LAST_TRY':return Object.assign({},state,{loadingResendToken:true});case'AUTHORIZE_TOKEN_LAST_TRY_SUCCESS':return Object.assign({},state,{loadingResendToken:false});case'AUTHORIZE_TOKEN_LAST_TRY_FAIL':delete state.confirmedOrderId;var responseL_=action.error.responseL_;var messageErrorL_=response_&&responseL_.data&&responseL_.data.errors&&responseL_.data.errors.length>0&&responseL_.data.errors[0].message||'';return Object.assign({},state,{hasError:true,messageErrorL_:messageErrorL_,loadingResendToken:false});case'CLOSE_MODAL':delete state.confirmedOrderId;delete state.authorized;return Object.assign({},state,{hasError:true});case'SUCCESS':delete state.confirmedOrderId;return Object.assign({},state,{secondFactorAuthSuccess:false});case'CLEAR_CONFIRMED_ORDER_DATA':return defaultState;default:{return Object.assign({},state);}}});

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{skus:[]};var action=arguments[1];switch(action.type){case'REMOVE_ITEM_FROM_CART':return{skus:[].concat(_toConsumableArray(state.skus),[action.sku])};case'REMOVE_ITEM_FROM_CART_SUCCESS':case'REMOVE_ITEM_FROM_CART_FAIL':state.skus=state.skus.filter(function(item){return item!==action.sku;});return state;default:return Object.assign({},state);}});

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Availability__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductSuggestionPlaceholder__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductSuggestionContainer=function(_Component){_inherits(ProductSuggestionContainer,_Component);function ProductSuggestionContainer(){_classCallCheck(this,ProductSuggestionContainer);return _possibleConstructorReturn(this,(ProductSuggestionContainer.__proto__||Object.getPrototypeOf(ProductSuggestionContainer)).apply(this,arguments));}_createClass(ProductSuggestionContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchSuggestions();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(JSON.stringify(prevProps)!==JSON.stringify(this.props)){this.props.fetchSuggestions();}}},{key:'render',value:function render(){var urlSearchPage='/showcase/?identifier='+this.props.showcase.url+'&type='+this.props.showcase.type;var _props=this.props,products=_props.products,onlyCash=_props.onlyCash,title=_props.title,titleOnlyCash=_props.titleOnlyCash,titleMobile=_props.titleMobile,showcase=_props.showcase;var isLoaded=products&&products.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative '+showcase.id+' '+showcase.url+'_'+showcase.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_placeholder___default.a,{ready:isLoaded,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductSuggestionPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Showcase__["a" /* Showcase */],{title:onlyCash?titleOnlyCash:title,titleMobile:titleMobile,searchPage:urlSearchPage,isLoading:!isLoaded},products.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Availability__["a" /* ProductCardContainer */],Object.assign({},p,{key:p.sku,cardClass:'col-12'})));}))));}}]);return ProductSuggestionContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductSuggestionContainer.propTypes={fetchSuggestions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleOnlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showcase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref){var productSuggestion=_ref.productSuggestion,onlyCash=_ref.onlyCash;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* Products */])(productSuggestion),{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchSuggestions:function fetchSuggestions(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchSuggestions */])('home'));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductSuggestionContainer));

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSuggestions; });
/* unused harmony export fetchAvailability */
var productSuggestion=5;var fetchSuggestions=function fetchSuggestions(identifier){return{type:'FETCH_PRODUCT_SUGGESTIONS',payload:{client:'cloudloyalty',request:{url:'/v2/showcases/'+productSuggestion+'?identifier='+identifier+'&cachedPrice=true'}}};};var fetchAvailability=function fetchAvailability(sku,vendorId,originalId){return{type:'FETCH_PRODUCT_AVAILABILITY',payload:{client:'cloudloyalty',request:{url:'/v1/products/skus/'+sku+'/availability?vendorId='+vendorId+'&originalId='+originalId}}};};

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Availability_ProductCard__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Showcase__ = __webpack_require__(545);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowcaseContainer=function(_Component){_inherits(ShowcaseContainer,_Component);function ShowcaseContainer(){_classCallCheck(this,ShowcaseContainer);return _possibleConstructorReturn(this,(ShowcaseContainer.__proto__||Object.getPrototypeOf(ShowcaseContainer)).apply(this,arguments));}_createClass(ShowcaseContainer,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,loadShowcase=_props.loadShowcase,showcaseType=_props.showcaseType,identifier=_props.identifier;loadShowcase(showcaseType,identifier);}},{key:'render',value:function render(){var _props2=this.props,_=_props2.loadShowcase,props=_objectWithoutProperties(_props2,['loadShowcase']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Showcase__["a" /* default */],props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minDeviceWidth:426},props.products.map(function(sku){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Availability_ProductCard__["a" /* ProductCardContainer */],{key:sku,sku:sku});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{maxDeviceWidth:425},'Limited 4 Product List'));}}]);return ShowcaseContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShowcaseContainer.propTypes={loadShowcase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,showcaseType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,identifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};ShowcaseContainer.defaultProps={isLoading:true,products:[]};var mapStateToProps=function mapStateToProps(_ref,_ref2){var showcases=_ref.showcases;var showcaseType=_ref2.showcaseType,identifier=_ref2.identifier;var showcase=showcases[showcaseType]?showcases[showcaseType][identifier]:{};return showcase;};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadShowcase:function loadShowcase(showcaseType,identifier){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Catalog_Showcase_ducks__["c" /* fetchShowcase */])(showcaseType,identifier));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ShowcaseContainer));

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductCard__ = __webpack_require__(1291);
var mapStateToProps=function mapStateToProps(_ref,_ref2){var products=_ref.productsv2;var sku=_ref2.sku;return products[sku];};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ProductCard__["a" /* default */]));

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WishlistLabel__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardImage__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardTitle__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductAvailability__ = __webpack_require__(1308);
var ProductCard=function ProductCard(_ref){var sku=_ref.sku,imageUrl=_ref.imageUrl,name=_ref.name,originalId=_ref.originalId,vendorId=_ref.vendorId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-3 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 discount-whishlist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WishlistLabel__["a" /* default */],{sku:sku})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CardImage__["a" /* default */],{linkTo:'/products/'+sku,imageUrl:imageUrl,altText:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-internal col-12 pt-md-0 pt-5 mt-5 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CardTitle__["a" /* default */],{linkTo:'/products/'+sku,title:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductAvailability__["a" /* ProductAvailabilityContainer */],{sku:sku,originalId:originalId,vendorId:vendorId})))));};ProductCard.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProductCard);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WishlistLabelContainer__ = __webpack_require__(1293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WishlistLabelContainer__["a"]; });


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WishlistLabel__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Participant_Wishlist__ = __webpack_require__(99);
var mapStateToProps=function mapStateToProps(_ref){var groupedWishlistBySkuId=_ref.wishlist.groupedWishlistBySkuId;return{groupedWishlistBySkuId:groupedWishlistBySkuId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleWishlist:function toggleWishlist(isInWishlist,sku){return function(){return isInWishlist?dispatch(__WEBPACK_IMPORTED_MODULE_2_Participant_Wishlist__["b" /* actions */].addWishlist(sku)):dispatch(__WEBPACK_IMPORTED_MODULE_2_Participant_Wishlist__["b" /* actions */].removeWishlist(sku));};}};};var mergeProps=function mergeProps(_ref2,dispatchProps,_ref3){var groupedWishlistBySkuId=_ref2.groupedWishlistBySkuId;var sku=_ref3.sku;var isInWishlist=groupedWishlistBySkuId&&!!groupedWishlistBySkuId[sku];var toggleWishlist=dispatchProps.toggleWishlist(isInWishlist,sku);return{isInWishlist:isInWishlist,toggleWishlist:toggleWishlist};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_1__WishlistLabel__["a" /* default */]));

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var WishlistLabel=function WishlistLabel(_ref){var isInWishlist=_ref.isInWishlist,toggleWishlist=_ref.toggleWishlist;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:isInWishlist?'icon_wishlist_color':'icon_wishlist',className:'card-wishlist txt-body-lg cursor pos-absolute r-0 t-1',onClick:toggleWishlist,alt:'Favoritar este item '});};WishlistLabel.propTypes={isInWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,toggleWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};WishlistLabel.defaultProps={isInWishlist:false};/* harmony default export */ __webpack_exports__["a"] = (WishlistLabel);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addWishlist */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var clientMiddleware=void 0;var loadWishList=function loadWishList(){return{type:'FETCH_WISHLIST',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/participants/me/wishlist'}}};};var succesAddCart=function succesAddCart(skuId){return{type:'ADD_CART_SUCCESS',skuId:skuId};};var errorAddCart=function errorAddCart(skuId){return{type:'ADD_CART_FAIL',skuId:skuId};};var loadingAddCart=function loadingAddCart(list){return{type:'LOAD_ADD_CART_WISHLIST',skus:list};};var addListToCart=function addListToCart(list){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,_){var handleSuccess,handleError,index,item;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(loadingAddCart(list.map(function(item){return item.skuId;})));handleSuccess=function handleSuccess(skuId){return function(response){if(response)dispatch(succesAddCart(skuId));};};handleError=function handleError(skuId){return function(){dispatch(errorAddCart(skuId));};};index=0;case 4:if(!(index<list.length)){_context.next=18;break;}item=list[index];_context.prev=6;_context.next=9;return clientMiddleware.post('/v1/carts/me/items',item);case 9:handleSuccess(item.skuId);_context.next=15;break;case 12:_context.prev=12;_context.t0=_context['catch'](6);handleError(item.skuId);case 15:index++;_context.next=4;break;case 18:dispatch(succesAddCart(0));case 19:case'end':return _context.stop();}}},_callee,_this,[[6,12]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();};var removeWishlist=function removeWishlist(skuId){return{type:'REMOVE_WISHLIST',payload:{client:'cloudloyalty',request:{method:'delete',url:'/v1/participants/me/wishlist/'+skuId+'/remove',data:null}},skuId:skuId};};var removeWishlistCard=function removeWishlistCard(skuId){return{type:'REMOVE_WISHLIST_CARD',payload:{client:'cloudloyalty',request:{method:'delete',url:'/v1/participants/me/wishlist/'+skuId+'/remove',data:null}},skuId:skuId};};var addCart=function addCart(skuId,vendorId){return{type:'ADD_WISHLIST_CART',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/carts/me/items',data:{ProductSkuId:skuId,Quantity:1,vendorId:vendorId}}}};};var inWishlist=function inWishlist(skuId,vendorId){// Lista de Favoritos
};var selectWishlist=function selectWishlist(skuId,selected){return{type:'SELECT_WISHLIST',skuId:skuId,selected:selected};};var selectAllWishlist=function selectAllWishlist(selected){return{type:'SELECT_ALL_WISHLIST',selected:selected};};var addWishlist=function addWishlist(skuId){return{type:'ADD_WISHLIST',payload:{client:'cloudloyalty',request:{method:'put',url:'/v1/participants/me/wishlist/'+skuId+'/add',data:null}},skuId:skuId};};/* harmony default export */ __webpack_exports__["a"] = (function(client){clientMiddleware=client;return{removeWishlist:removeWishlist,removeWishlistCard:removeWishlistCard,loadWishList:loadWishList,addCart:addCart,addListToCart:addListToCart,selectWishlist:selectWishlist,selectAllWishlist:selectAllWishlist,addWishlist:addWishlist,inWishlist:inWishlist};});

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WishlistResume=function(_Component){_inherits(WishlistResume,_Component);function WishlistResume(){_classCallCheck(this,WishlistResume);return _possibleConstructorReturn(this,(WishlistResume.__proto__||Object.getPrototypeOf(WishlistResume)).apply(this,arguments));}_createClass(WishlistResume,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-0 py-0 mb-1 profile-wishlist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'wishlist-button col mr-auto btn btn-flat btn-sm btn-icon color-brand-1 txt-font-body txt-initial txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_wishlist color-brand-1'}),'Favoritos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-count col-auto mx-2 my-1 txt-center bg-ui-4 color-brand-1 radius-circle'},this.props.count)));}}]);return WishlistResume;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WishlistResume.propTypes={count:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* unused harmony default export */ var _unused_webpack_default_export = (WishlistResume);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={groupedWishlistBySkuId:{},allSelected:false,redirectCart:false,loadingAddListCart:false,length:0,leastOneSelected:false,loading:false};var getRedirectCart=function getRedirectCart(state){for(var i in state.groupedWishlistBySkuId){if(state.groupedWishlistBySkuId[i].loadingAddCart)return false;}return true;};var getVerifySelected=function getVerifySelected(state){state.leastOneSelected=false;state.allSelected=true;for(var i in state.groupedWishlistBySkuId){if(state.groupedWishlistBySkuId[i].selected)state.leastOneSelected=true;else state.allSelected=false;}return true;};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_WISHLIST':{return Object.assign({},state,{loading:true});}case'FETCH_WISHLIST_SUCCESS':{var wishlist=state&&state.wishlist?[].concat(_toConsumableArray(state.wishlist),_toConsumableArray(action.payload.data)):[].concat(_toConsumableArray(action.payload.data));var groupWishlist={};if(wishlist){var length=0;wishlist.map(function(item,index){length++;item.loading=false;item.removed=false;item.selected=false;groupWishlist[item.skuId]=item;});}return{groupedWishlistBySkuId:groupWishlist,length:length,loading:false};}case'FETCH_WISHLIST_FAIL':{return{groupedWishlistBySkuId:null,error:action.request&&action.request.status!==404?'Error':undefined,loading:false};}case'ADD_WISHLIST':{var itemAdd=state.groupedWishlistBySkuId[action.skuId];if(!itemAdd){itemAdd={skuId:action.skuId};state.groupedWishlistBySkuId[action.skuId]=itemAdd;}itemAdd.loading=true;itemAdd.removed=false;itemAdd.selected=false;state.loadingAddListCart=true;return Object.assign({},state);}case'ADD_WISHLIST_SUCCESS':{var skuIdAddSuccess=action.meta&&action.meta.previousAction&&action.meta.previousAction.skuId;if(action.payload.data===true){var itemAdded=state.groupedWishlistBySkuId[skuIdAddSuccess];if(itemAdded!==undefined)itemAdded.loading=false;state.length=state.length&&state.length+1||1;}else{if(itemAdded!==undefined){delete state.groupedWishlistBySkuId[skuIdAddSuccess];}}state.loadingAddListCart=false;return Object.assign({},state);}case'ADD_WISHLIST_FAIL':{state.loadingAddListCart=false;return Object.assign({},state);}case'REMOVE_WISHLIST':{state.groupedWishlistBySkuId[action.skuId]&&(state.groupedWishlistBySkuId[action.skuId].loading=true);return Object.assign({},state);}case'REMOVE_WISHLIST_CARD':{state.groupedWishlistBySkuId[action.skuId]&&delete state.groupedWishlistBySkuId[action.skuId];return Object.assign({},state);}case'REMOVE_WISHLIST_SUCCESS':{if(action.payload.data===true){var skuIdRemoveSuccess=action.meta&&action.meta.previousAction&&action.meta.previousAction.skuId;state.groupedWishlistBySkuId[skuIdRemoveSuccess]&&(state.groupedWishlistBySkuId[skuIdRemoveSuccess].removed=true)&&(state.groupedWishlistBySkuId[skuIdRemoveSuccess].loading=false);}return Object.assign({},state);}case'REMOVE_WISHLIST_FAIL':{var skuIdRemoveFail=action.meta&&action.meta.previousAction&&action.meta.previousAction.skuId;state.groupedWishlistBySkuId[skuIdRemoveFail]&&(state.groupedWishlistBySkuId[skuIdRemoveFail].loading=false)&&(state.groupedWishlistBySkuId[skuIdRemoveFail].removed=false);return Object.assign({},state);}case'SELECT_WISHLIST':{var wishlistSelect=state.groupedWishlistBySkuId[action.skuId];if(wishlistSelect)wishlistSelect.selected=action.selected;getVerifySelected(state);return Object.assign({},state);}case'SELECT_ALL_WISHLIST':{for(var i in state.groupedWishlistBySkuId){!state.groupedWishlistBySkuId[i].removed&&(state.groupedWishlistBySkuId[i].selected=action.selected);}state.allSelected=action.selected;state.leastOneSelected=state.allSelected;return Object.assign({},state);}case'LOAD_ADD_CART_WISHLIST':{state.loadingAddListCart=true;return Object.assign({},state);}case'ADD_CART_SUCCESS':{if(state.groupedWishlistBySkuId[action.skuId]){state.groupedWishlistBySkuId[action.skuId].loadingAddCart=false;state.groupedWishlistBySkuId[action.skuId].addedCart=true;}state.redirectCart=getRedirectCart(state);state.loadingAddListCart=!state.redirectCart;return state;}case'ADD_CART_FAIL':{if(state.groupedWishlistBySkuId[action.skuId]){state.groupedWishlistBySkuId[action.skuId].loadingAddCart=false;state.groupedWishlistBySkuId[action.skuId].errorAddCart=true;}state.redirectCart=getRedirectCart(state);state.loadingAddListCart=!state.redirectCart;return state;}case'ADD_WISHLIST_CART_FAIL':{return Object.assign({},state,{hasMoreItems:false,error:action.request&&action.request.status!==404?'Error':undefined});}default:return Object.assign({},state);}});

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WishlistPage__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_features_Cart_index__ = __webpack_require__(38);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var wishlist=_ref.wishlist,cart=_ref.cart,participant=_ref.participant;if(wishlist){return{wishlist:wishlist,email:cart.customer?cart.customer.email:participant.email.value};}else return{wishlist:{}};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadWishList:function loadWishList(){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].loadWishList());},selectWishlist:function selectWishlist(skuId,selected){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].selectWishlist(skuId,selected));},selectAllWishlist:function selectAllWishlist(selected){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].selectAllWishlist(selected));},addListToCart:function addListToCart(list){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].addListToCart(list));},redirectCart:function redirectCart(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])('/cart'));},addItemToCart:function addItemToCart(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5_features_Cart_index__["c" /* actions */].addItem(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__WishlistPage__["a" /* default */]));

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Items__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_wishlist_css__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_wishlist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_wishlist_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WishlistPage=function(_Component){_inherits(WishlistPage,_Component);function WishlistPage(props){_classCallCheck(this,WishlistPage);var _this=_possibleConstructorReturn(this,(WishlistPage.__proto__||Object.getPrototypeOf(WishlistPage)).call(this,props));_this.props.loadWishList();_this.state={selectedItems:[],teste:true};_this.selectWishlist=_this.selectWishlist.bind(_this);return _this;}_createClass(WishlistPage,[{key:'selectWishlist',value:function selectWishlist(product,checked){this.props.selectWishlist(product.skuId,checked);}},{key:'selectAllWishlist',value:function selectAllWishlist(checked){this.props.selectAllWishlist(checked);}},{key:'getListToCart',value:function getListToCart(){var list=[];for(var i in this.props.wishlist.groupedWishlistBySkuId){if(this.props.wishlist.groupedWishlistBySkuId[i].selected){list.push({sku:this.props.wishlist.groupedWishlistBySkuId[i].skuId,vendorId:this.props.wishlist.groupedWishlistBySkuId[i].vendorId,email:this.props.email});}}return list;}},{key:'render',value:function render(){var _this2=this;if(this.props.wishlist.redirectCart===true){this.props.redirectCart();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Lista de desejos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-wishlist container-fluid px-0 px-md-1 pt-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pl-2 pr-2 pt-0 pb-2 pb-md-2 pt-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-0 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_App_Shell_LoggedSidebar__["a" /* default */],{selected:this.props.location.pathname}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-content col-12 col-lg-8 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step row px-1 py-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-title txt-font-body txt-initial color-title mr-auto'},'Favoritos',' ',this.props.wishlist.length>0?'('+this.props.wishlist.length+')':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-2 '+(!this.props.wishlist||this.props.wishlist.length===0?'d-none':'d-none d-md-inline-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Button"],{className:'btn btn-sm btn-featured',text:this.props.onlyCash?'Comprar agora':'Resgatar agora',onClick:function onClick(){return _this2.props.addListToCart(_this2.getListToCart());},loading:this.props.wishlist.loadingAddListCart,disabled:!this.props.wishlist.leastOneSelected||this.props.wishlist.loadingAddListCart})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{maxDeviceWidth:420},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 '+(!this.props.wishlist||this.props.wishlist.length===0?'d-none':'d-md-inline-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Button"],{className:'btn btn-sm btn-featured',text:this.props.onlyCash?'Comprar agora':'Resgatar agora',onClick:function onClick(){return _this2.props.addListToCart(_this2.getListToCart());},loading:this.props.wishlist.loadingAddListCart,disabled:!this.props.wishlist.leastOneSelected||this.props.wishlist.loadingAddListCart})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-relative col-auto txt-center '+(!this.props.wishlist||this.props.wishlist.length===0?'d-none':'d-md-inline-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Checkbox"],{id:'checkbox_all',className:'col-12 pos-relative',labelClass:'l-0',defaultChecked:this.props.wishlist.allSelected,onChange:function onChange(e){return _this2.selectAllWishlist(e.target.checked);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Items__["a" /* default */],{productsWishList:this.props.wishlist.groupedWishlistBySkuId,selectItem:this.selectWishlist,selectedItems:this.state.selectedItems,loading:this.props.wishlist.loading}))))));}}]);return WishlistPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WishlistPage.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,wishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loadWishList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,addListToCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selectWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selectAllWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,redirectCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,allSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,leastOneSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref){var onlyCash=_ref.onlyCash;return{onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,null)(WishlistPage));

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__);
var Items=function Items(props){var rows=[];if(!props.loading){if(!props.productsWishList||Object.keys(props.productsWishList).length===0){rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Empty__["a" /* default */],null));}else{for(var key in props.productsWishList){var item=props.productsWishList[key];rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Item__["a" /* default */],{product:item,key:key,selectItem:props.selectItem,checked:props.selectedItems&&props.selectedItems.filter(function(s){return s.skuId===item.skuId;})})));}}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-item row px-1 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-img col-auto col-md-auto txt-center px-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default.a,{src:__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,fallbackImage:__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,className:'card-image-fallback'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-product-info col col-md-7 mr-0 mr-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1 py-half radius bg-ui-4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half radius bg-ui-4'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-price-points col-12 txt-title-3 txt-font-body txt-left color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 pt-3 radius bg-ui-3'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto icon-area row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1 py-1 radius bg-ui-3 mr-1'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-1 py-1 radius bg-ui-4'})))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-5 pb-md-0 mb-0 mb-md-5'},rows);};Items.propTypes={productsWishList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,selectItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,selectedItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Items);

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_wishlist_css__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_wishlist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_wishlist_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_WishlistHeart__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Item=function(_Component){_inherits(Item,_Component);function Item(props){_classCallCheck(this,Item);var _this=_possibleConstructorReturn(this,(Item.__proto__||Object.getPrototypeOf(Item)).call(this,props));_this.state={checked:true};return _this;}_createClass(Item,[{key:'render',value:function render(){var _this2=this;var statusCart='';if(this.props.product.loadingAddCart)statusCart='Loading no Cart';else if(this.props.product.loadingAddCart===false){if(this.props.product.addedCart){statusCart='added no Cart';}else if(this.props.product.errorAddCart){statusCart='error no Cart';}}var styleStatusCart={fontWeigth:'bold'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-item row px-1 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/products/'+this.props.product.skuId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-img col-auto col-md-auto txt-center px-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_image_fallback___default.a,{src:this.props.product.mediumImage,fallbackImage:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_product_placeholder_png___default.a,alt:this.props.product.productName,className:'card-image-fallback'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-product-info col col-md-7 mr-0 mr-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/products/'+this.props.product.skuId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-body-sm color-ui-2'},this.props.product.productName,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:styleStatusCart},' ',statusCart!==''?' - '+statusCart:''))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-price-points col-12 txt-title-3 txt-font-body txt-left title-color'},this.props.product.sellingPrice>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:this.props.product.sellingPrice}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'price-value txt-initial color-error'},'Produto indispon\xEDvel')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto icon-area row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-action pos-relative col-12 col-md-auto txt-center px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_features_WishlistHeart__["a" /* WishlistHeart */],{skuId:this.props.product.skuId})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-action pos-relative col-12 col-md-auto txt-center px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Checkbox"],{id:'checkbox_'+this.props.product.skuId,className:'col-12',labelClass:'l-0',defaultChecked:this.props.product.selected,checked:this.props.product.selected,disabled:this.props.product.removed,onChange:function onChange(e){_this2.props.selectItem(_this2.props.product,e.target.checked);}}))))));}}]);return Item;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Item.propTypes={product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,selectItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WishlistHeartContainer__ = __webpack_require__(1303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WishlistHeartContainer__["a"]; });


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Participant_Wishlist__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WishlistHeart__ = __webpack_require__(1304);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref,ownProps){var wishlist=_ref.wishlist;var wishlistItem=wishlist&&wishlist.groupedWishlistBySkuId&&wishlist.groupedWishlistBySkuId[ownProps.skuId];return wishlistItem?{loading:wishlistItem.loading,removed:wishlistItem.removed,error:wishlistItem.error}:{notAdded:true};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{removeWishlist:function removeWishlist(skuId){return dispatch(__WEBPACK_IMPORTED_MODULE_2_Participant_Wishlist__["b" /* actions */].removeWishlist(skuId));},addWishlist:function addWishlist(skuId){return dispatch(__WEBPACK_IMPORTED_MODULE_2_Participant_Wishlist__["b" /* actions */].addWishlist(skuId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__WishlistHeart__["a" /* default */]));

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var Wishlist=function Wishlist(props){var icon='';if(props.loading){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_options',className:'txt-body-lg pointer','aria-label':'Adicionar a adicionar na lista de desejo'});}else if(props.removed||props.notAdded){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:props.inWishlist?'icon_wishlist_color':'icon_wishlist',className:'txt-body-lg pointer',onClick:props.inWishlist?function(){return props.removeWishlist(props.skuId);}:function(){return props.addWishlist(props.skuId);},role:'button','aria-label':'Adicionar na lista de desejos'});}else if(props.error){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_close_circle',className:'color-error h4  d-inline-block pointer','aria-label':'Erro ao adicionar na lista de desejo'});}else{icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_wishlist_color',className:'txt-body-lg color-error pointer',onClick:function onClick(){props.removeWishlist(props.skuId);},role:'button','aria-label':'Remover da lista de desejos'});}return icon;};Wishlist.propTypes={skuId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,removed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,addWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,removeWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,inWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Wishlist);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var Empty=function Empty(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 justify-content-center py-4 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_wishlist txt-headline color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-2 mx-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-center txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Voc\xEA ainda n\xE3o favoritou nenhum produto.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-center txt-body-sm'},'Escolha os produtos que voc\xEA mais gosta e clique no',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_wishlist d-inline-block txt-body'}),' que ele aparecer\xE1 aqui para voc\xEA.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 col-md-3 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-featured'},'Ver Produtos'))));};/* harmony default export */ __webpack_exports__["a"] = (Empty);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_images_products_product_placeholder_png__);
var CardImage=function CardImage(_ref){var linkTo=_ref.linkTo,altText=_ref.altText,imageUrl=_ref.imageUrl,visibleByDefault=_ref.visibleByDefault;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img col-12 row txt-center py-3 t-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 ml-auto mr-auto t-0 pos-absolute'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 m-0 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:linkTo,'aria-label':altText},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:altText,placeholderSrc:__WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_images_products_product_placeholder_png___default.a,className:'card-image-fallback',src:imageUrl})))));};CardImage.propTypes={linkTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,altText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,visibleByDefault:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(CardImage));

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var CardTitle=function CardTitle(_ref){var linkTo=_ref.linkTo,title=_ref.title,altText=_ref.altText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-0 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm color-ui-2 txt-font-body txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:linkTo,'aria-label':altText||title},title)));};CardTitle.propTypes={linkTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,altText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CardTitle);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductAvailabilityContainer__ = __webpack_require__(1309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductAvailabilityContainer__["a"]; });


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductAvailability__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAvailabilityContainer=function(_Component){_inherits(ProductAvailabilityContainer,_Component);function ProductAvailabilityContainer(){_classCallCheck(this,ProductAvailabilityContainer);return _possibleConstructorReturn(this,(ProductAvailabilityContainer.__proto__||Object.getPrototypeOf(ProductAvailabilityContainer)).apply(this,arguments));}_createClass(ProductAvailabilityContainer,[{key:'handleAvailabilityUpdate',value:function handleAvailabilityUpdate(){var _props=this.props,sku=_props.sku,originalId=_props.originalId,vendorId=_props.vendorId,loadAvailability=_props.loadAvailability,isPriceUpdated=_props.isPriceUpdated;!isPriceUpdated&&loadAvailability(sku,originalId,vendorId);}},{key:'componentDidMount',value:function componentDidMount(){this.handleAvailabilityUpdate();}},{key:'render',value:function render(){var _props2=this.props,isLoading=_props2.isLoading,isAvailable=_props2.isAvailable,price=_props2.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductAvailability__["a" /* default */],{isLoading:isLoading,isAvailable:isAvailable,price:price});}}]);return ProductAvailabilityContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductAvailabilityContainer.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isAvailable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isPriceUpdated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ProductAvailabilityContainer.defaultProps={isPriceUpdated:false};var getProductAvailability=function getProductAvailability(){var availability=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var sku=arguments[1];return availability[sku]||{sku:sku,isLoading:true};};var mapStateToProps=function mapStateToProps(_ref,_ref2){var availability=_ref.availability;var sku=_ref2.sku;return getProductAvailability(availability,sku);};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadAvailability:function loadAvailability(sku,originalId,vendorId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__["b" /* fetchAvailability */])(sku,originalId,vendorId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductAvailabilityContainer));

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Unavailable__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AvailabilityLoading__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PriceLabel__ = __webpack_require__(1313);
var ProductAvailability=function ProductAvailability(_ref){var isLoading=_ref.isLoading,isAvailable=_ref.isAvailable,price=_ref.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AvailabilityLoading__["a" /* default */],{isLoading:isLoading&&!isAvailable},isAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PriceLabel__["a" /* PriceLabelContainer */],price):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Unavailable__["a" /* default */],null));};ProductAvailability.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isAvailable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ProductAvailability);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
var Unavailable=function Unavailable(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-12 m-0 mt-1 p-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn-featured btn-sm btn-block col-12',text:'Produto indispon\xEDvel',disabled:'disabled'}));};/* harmony default export */ __webpack_exports__["a"] = (Unavailable);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AvailabilityLoading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var AvailabilityLoading=function AvailabilityLoading(_ref){var isLoading=_ref.isLoading,children=_ref.children;return isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-12 m-0 mt-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat mx-auto py-half',role:'button',value:'Carregando','aria-label':'Carregando pontua\xE7\xE3o'})):children;};AvailabilityLoading.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};AvailabilityLoading.defaultProps={isLoading:true};/* harmony default export */ __webpack_exports__["a"] = (AvailabilityLoading);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PriceLabelContainer__ = __webpack_require__(1314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PriceLabelContainer__["a"]; });


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriceLabel__ = __webpack_require__(1315);
var mapStateToProps=function mapStateToProps(_ref){var isOnlyCash=_ref.onlyCash;return{isOnlyCash:isOnlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PriceLabel__["a" /* default */]));

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayCash__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisplayPoints__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
var PriceLabel=function PriceLabel(_ref){var isOnlyCash=_ref.isOnlyCash,hasDiscount=_ref.hasDiscount,regularPrice=_ref.regularPrice,price=_ref.price,cash=_ref.cash,currency=_ref.currency;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12 mt-1 mb-1 color-brand-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},isOnlyCash?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DisplayCash__["a" /* default */],cash):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DisplayPoints__["a" /* default */],{hasDiscount:__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_DISCOUNT)||hasDiscount,regularPrice:regularPrice,price:price,currency:currency})))));};PriceLabel.propTypes={hasDiscount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,regularPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,cash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,isOnlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};PriceLabel.defaultProps={hasDiscount:false,currency:{decimalPlaces:2,name:'pontos'}};/* harmony default export */ __webpack_exports__["a"] = (PriceLabel);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var convertMoney=function convertMoney(value){return value.toLocaleString('pt-br',{minimumFractionDigits:2,maximumFractionDigits:2});};var DisplayCash=function DisplayCash(_ref){var price=_ref.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title txt-font-body-bold txt-left color-ui-1 nowrap',title:'R$ '+convertMoney(price)},'R$ '+convertMoney(price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-font-body-bold txt-center color-ui-1'}));};DisplayCash.propTypes={price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (DisplayCash);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Currency__ = __webpack_require__(1318);
var DisplayPoints=function DisplayPoints(_ref){var hasDiscount=_ref.hasDiscount,hasCashback=_ref.hasCashback,regularPrice=_ref.regularPrice,price=_ref.price,currency=_ref.currency,pointCash=_ref.pointCash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,hasDiscount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-from col-12 txt-subtitle txt-font-body color-ui-2 txt-left'},'De ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('s',null,regularPrice),' pts por'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title txt-font-body txt-left color-ui-1 nowrap',title:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Currency__["a" /* default */],Object.assign({value:price},currency))),pointCash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-complete-with col-12 txt-body-sm txt-font-body txt-left txt-bold color-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-half'},'Ou utilize pontos + ',Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro'))),hasCashback&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-cashback col-auto mx-1 txt-body-sm txt-font-body txt-left txt-bold color-success border border-color-ui-4 radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 d-none d-lg-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon_cashback icon-sm icon icon_gift color-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto txt-body-sm'},'Ganhe ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Currency__["a" /* default */],Object.assign({value:Math.floor(0.05*price)},currency))))));};DisplayPoints.propTypes={hasDiscount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,regularPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,pointCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,hasCashback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (DisplayPoints);

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var convertPoints=function convertPoints(value,fixed){var number=parseFloat(value);return number.toFixed(fixed).replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');};var Currency=function Currency(_ref){var value=_ref.value,decimalPlaces=_ref.decimalPlaces,name=_ref.name;return convertPoints(value,decimalPlaces)+' '+name;};/* harmony default export */ __webpack_exports__["a"] = (Currency);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export configureStore */
/* unused harmony export createAction */
/* unused harmony export createReducer */
/* unused harmony export createSerializableStateInvariantMiddleware */
/* unused harmony export createSlice */
/* unused harmony export findNonSerializableValue */
/* unused harmony export getDefaultMiddleware */
/* unused harmony export getType */
/* unused harmony export isPlain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immer__ = __webpack_require__(542);
/* unused harmony reexport createNextState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2_reselect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(544);








function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/**
 * Returns true if the passed value is "plain" object, i.e. an object whose
 * protoype is the root `Object.prototype`. This includes objects created
 * using object literals, but not for instance for class instances.
 *
 * @param {any} value The value to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
}

/**
 * Returns true if the passed value is "plain", i.e. a value that is either
 * directly JSON-serializable (boolean, number, string, array, plain object)
 * or `undefined`.
 *
 * @param val The value to check.
 */

function isPlain(val) {
  return typeof val === 'undefined' || val === null || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val) || isPlainObject(val);
}
var NON_SERIALIZABLE_STATE_MESSAGE =
/*#__PURE__*/
['A non-serializable value was detected in the state, in the path: `%s`. Value: %o', 'Take a look at the reducer(s) handling this action type: %s.', '(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)'].join('\n');
var NON_SERIALIZABLE_ACTION_MESSAGE =
/*#__PURE__*/
['A non-serializable value was detected in an action, in the path: `%s`. Value: %o', 'Take a look at the logic that dispatched this action:  %o.', '(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)'].join('\n');
function findNonSerializableValue(value, path, isSerializable, getEntries) {
  if (path === void 0) {
    path = [];
  }

  if (isSerializable === void 0) {
    isSerializable = isPlain;
  }

  var foundNestedSerializable;

  if (!isSerializable(value)) {
    return {
      keyPath: path.join('.') || '<root>',
      value: value
    };
  }

  if (typeof value !== 'object' || value === null) {
    return false;
  }

  var entries = getEntries != null ? getEntries(value) : Object.entries(value);

  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var _ref2 = _ref,
        property = _ref2[0],
        nestedValue = _ref2[1];
    var nestedPath = path.concat(property);

    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath.join('.'),
        value: nestedValue
      };
    }

    if (typeof nestedValue === 'object') {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries);

      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }

  return false;
}
/**
 * Creates a middleware that, after every state change, checks if the new
 * state is serializable. If a non-serializable value is found within the
 * state, an error is printed to the console.
 *
 * @param options Middleware options.
 */

function createSerializableStateInvariantMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$isSerializab = _options.isSerializable,
      isSerializable = _options$isSerializab === void 0 ? isPlain : _options$isSerializab,
      getEntries = _options.getEntries,
      _options$ignoredActio = _options.ignoredActions,
      ignoredActions = _options$ignoredActio === void 0 ? [] : _options$ignoredActio;
  return function (storeAPI) {
    return function (next) {
      return function (action) {
        if (ignoredActions.length && ignoredActions.indexOf(action.type) !== -1) {
          return next(action);
        }

        var foundActionNonSerializableValue = findNonSerializableValue(action, [], isSerializable, getEntries);

        if (foundActionNonSerializableValue) {
          var keyPath = foundActionNonSerializableValue.keyPath,
              value = foundActionNonSerializableValue.value;
          console.error(NON_SERIALIZABLE_ACTION_MESSAGE, keyPath, value, action);
        }

        var result = next(action);
        var state = storeAPI.getState();
        var foundStateNonSerializableValue = findNonSerializableValue(state, [], isSerializable, getEntries);

        if (foundStateNonSerializableValue) {
          var _keyPath = foundStateNonSerializableValue.keyPath,
              _value = foundStateNonSerializableValue.value;
          console.error(NON_SERIALIZABLE_STATE_MESSAGE, _keyPath, _value, action.type);
        }

        return result;
      };
    };
  };
}

function isBoolean(x) {
  return typeof x === 'boolean';
}
/**
 * Returns any array containing the default middleware installed by
 * `configureStore()`. Useful if you want to configure your store with a custom
 * `middleware` array but still keep the default set.
 *
 * @return The default middleware used by `configureStore()`.
 */


function getDefaultMiddleware(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$thunk = _options.thunk,
      thunk = _options$thunk === void 0 ? true : _options$thunk,
      _options$immutableChe = _options.immutableCheck,
      immutableCheck = _options$immutableChe === void 0 ? true : _options$immutableChe,
      _options$serializable = _options.serializableCheck,
      serializableCheck = _options$serializable === void 0 ? true : _options$serializable;
  var middlewareArray = [];

  if (thunk) {
    if (isBoolean(thunk)) {
      middlewareArray.push(__WEBPACK_IMPORTED_MODULE_4_redux_thunk__["a" /* default */]);
    } else {
      middlewareArray.push(__WEBPACK_IMPORTED_MODULE_4_redux_thunk__["a" /* default */].withExtraArgument(thunk.extraArgument));
    }
  }

  if (false) {
    /* START_REMOVE_UMD */
    if (immutableCheck) {
      var createImmutableStateInvariantMiddleware = require('redux-immutable-state-invariant')["default"];

      var immutableOptions = {};

      if (!isBoolean(immutableCheck)) {
        immutableOptions = immutableCheck;
      }

      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
    }
    /* STOP_REMOVE_UMD */


    if (serializableCheck) {
      var serializableOptions = {};

      if (!isBoolean(serializableCheck)) {
        serializableOptions = serializableCheck;
      }

      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
  }

  return middlewareArray;
}

var IS_PRODUCTION = "production" === 'production';
/**
 * A friendly abstraction over the standard Redux `createStore()` function.
 *
 * @param config The store configuration.
 * @returns A configured Redux store.
 */

function configureStore(options) {
  var _ref = options || {},
      _ref$reducer = _ref.reducer,
      reducer = _ref$reducer === void 0 ? undefined : _ref$reducer,
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === void 0 ? getDefaultMiddleware() : _ref$middleware,
      _ref$devTools = _ref.devTools,
      devTools = _ref$devTools === void 0 ? true : _ref$devTools,
      _ref$preloadedState = _ref.preloadedState,
      preloadedState = _ref$preloadedState === void 0 ? undefined : _ref$preloadedState,
      _ref$enhancers = _ref.enhancers,
      enhancers = _ref$enhancers === void 0 ? undefined : _ref$enhancers;

  var rootReducer;

  if (typeof reducer === 'function') {
    rootReducer = reducer;
  } else if (isPlainObject(reducer)) {
    rootReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(reducer);
  } else {
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  }

  var middlewareEnhancer = __WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(void 0, middleware);
  var finalCompose = __WEBPACK_IMPORTED_MODULE_0_redux__["compose"];

  if (devTools) {
    finalCompose = Object(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__["composeWithDevTools"])(_extends({
      // Enable capture of stack traces for dispatched Redux actions
      trace: !IS_PRODUCTION
    }, typeof devTools === 'object' && devTools));
  }

  var storeEnhancers = [middlewareEnhancer];

  if (Array.isArray(enhancers)) {
    storeEnhancers = [middlewareEnhancer].concat(enhancers);
  } else if (typeof enhancers === 'function') {
    storeEnhancers = enhancers(storeEnhancers);
  }

  var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(rootReducer, preloadedState, composedEnhancer);
}



function createAction(type, prepareAction) {
  function actionCreator() {
    if (prepareAction) {
      var prepared = prepareAction.apply(void 0, arguments);

      if (!prepared) {
        throw new Error('prepareAction did not return an object');
      }

      return _extends({
        type: type,
        payload: prepared.payload
      }, 'meta' in prepared && {
        meta: prepared.meta
      }, {}, 'error' in prepared && {
        error: prepared.error
      });
    }

    return {
      type: type,
      payload: arguments.length <= 0 ? undefined : arguments[0]
    };
  }

  actionCreator.toString = function () {
    return "" + type;
  };

  actionCreator.type = type;

  actionCreator.match = function (action) {
    return action.type === type;
  };

  return actionCreator;
}
/**
 * Returns the action type of the actions created by the passed
 * `createAction()`-generated action creator (arbitrary action creators
 * are not supported).
 *
 * @param action The action creator whose action type to get.
 * @returns The action type used by the action creator.
 */

function getType(actionCreator) {
  return "" + actionCreator;
}

/**
 * A utility function that allows defining a reducer as a mapping from action
 * type to *case reducer* functions that handle these action types. The
 * reducer's initial state is passed as the first argument.
 *
 * The body of every case reducer is implicitly wrapped with a call to
 * `produce()` from the [immer](https://github.com/mweststrate/immer) library.
 * This means that rather than returning a new state object, you can also
 * mutate the passed-in state object directly; these mutations will then be
 * automatically and efficiently translated into copies, giving you both
 * convenience and immutability.
 *
 * @param initialState The initial state to be returned by the reducer.
 * @param actionsMap A mapping from action types to action-type-specific
 *   case redeucers.
 */

function createReducer(initialState, actionsMap) {
  return function (state, action) {
    if (state === void 0) {
      state = initialState;
    }

    // @ts-ignore createNextState() produces an Immutable<Draft<S>> rather
    // than an Immutable<S>, and TypeScript cannot find out how to reconcile
    // these two types.
    return Object(__WEBPACK_IMPORTED_MODULE_1_immer__["a" /* default */])(state, function (draft) {
      var caseReducer = actionsMap[action.type];
      return caseReducer ? caseReducer(draft, action) : undefined;
    });
  };
}

function getType$1(slice, actionKey) {
  return slice + "/" + actionKey;
} // internal definition is a little less restrictive


function createSlice(options) {
  var name = options.name,
      initialState = options.initialState;

  if (!name) {
    throw new Error('`name` is a required option for createSlice');
  }

  var reducers = options.reducers || {};
  var extraReducers = options.extraReducers || {};
  var reducerNames = Object.keys(reducers);
  var sliceCaseReducersByName = {};
  var sliceCaseReducersByType = {};
  var actionCreators = {};
  reducerNames.forEach(function (reducerName) {
    var maybeReducerWithPrepare = reducers[reducerName];
    var type = getType$1(name, reducerName);
    var caseReducer;
    var prepareCallback;

    if (typeof maybeReducerWithPrepare === 'function') {
      caseReducer = maybeReducerWithPrepare;
    } else {
      caseReducer = maybeReducerWithPrepare.reducer;
      prepareCallback = maybeReducerWithPrepare.prepare;
    }

    sliceCaseReducersByName[reducerName] = caseReducer;
    sliceCaseReducersByType[type] = caseReducer;
    actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
  });

  var finalCaseReducers = _extends({}, extraReducers, {}, sliceCaseReducersByType);

  var reducer = createReducer(initialState, finalCaseReducers);
  return {
    name: name,
    reducer: reducer,
    actions: actionCreators,
    caseReducers: sliceCaseReducersByName
  };
}


//# sourceMappingURL=redux-starter-kit.esm.js.map


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(93).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css__);
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card container pt-3 pb-1 py-md-3 px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx--1 mx-md-0 px-2 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1 d-none  d-md-flex '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 d-none d-md-flex px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))))));};var ShowcasePlaceholder=function ShowcasePlaceholder(_ref){var isLoading=_ref.isLoading,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:!isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder,null)},children));};ShowcasePlaceholder.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};ShowcasePlaceholder.defaultProps={isLoading:true};/* harmony default export */ __webpack_exports__["a"] = (ShowcasePlaceholder);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
var ShowcaseHeader=function ShowcaseHeader(_ref){var title=_ref.title,mobileTitle=_ref.mobileTitle,viewAllPath=_ref.viewAllPath;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx-0 px-0'},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'},title),mobileTitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-block d-md-none px-md-0 pt-1 px-0'},mobileTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:viewAllPath,className:'card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert'},'Ver todos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon-sm icon_right'})))));};ShowcaseHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mobileTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,viewAllPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};ShowcaseHeader.defaultProps={viewAllPath:'/search'};/* harmony default export */ __webpack_exports__["a"] = (ShowcaseHeader);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_card_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_molecules_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_showcases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_modules_carousel_css_owl_theme_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2__);
var ShowcaseProductListWrapper=function ShowcaseProductListWrapper(_ref){var children=_ref.children,viewAllPath=_ref.viewAllPath;var options={margin:10,autoplay:false,dots:false,rewind:true,loop:false,responsive:{0:{items:1,margin:0,rewind:true,loop:false},400:{items:2,margin:0,rewind:true,loop:false},600:{items:4,nav:true,rewind:true,loop:false},1000:{margin:20,nav:true,rewind:true,loop:false,items:4}},navClass:['pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon','pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'],navText:['<i class="icon icon_left icon-sm color-ui-white" aria-hidden="true"></i>','<i class="icon icon_right icon-sm color-ui-white" aria-hidden="true"></i>']};return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2___default.a,{className:'showcase-carousel bx-slider w-100 mx-0 owl-carousel owl-theme px-1',options:options},children)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{maxDeviceWidth:425},children,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["Link"],{to:viewAllPath,className:'btn btn-sm  txt-center txt-button btn-invert'},'Ver todos')))));};ShowcaseProductListWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,viewAllPath:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string};ShowcaseProductListWrapper.defaultProps={viewAllPath:'/search'};/* harmony default export */ __webpack_exports__["a"] = (ShowcaseProductListWrapper);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_molecules_card_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_molecules_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_molecules_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_template_showcases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_owl_carousel2__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_owl_carousel2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_owl_carousel2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(5);
var Showcase=function Showcase(_ref){var _ref$title=_ref.title,title=_ref$title===undefined?'':_ref$title,_ref$titleMobile=_ref.titleMobile,titleMobile=_ref$titleMobile===undefined?'':_ref$titleMobile,children=_ref.children,searchPage=_ref.searchPage;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'showcard-products ml-mob-2 container-card-new container py-1 py-md-3 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx-0 px-0'},title&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2',{className:'txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0',tabIndex:0},title),titleMobile&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2',{className:'txt-font-title color-title d-block d-md-none px-md-0 pt-1 px-0',tabIndex:0},titleMobile)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:searchPage||'/search',className:'card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert',title:'vai para lista de benef\xEDcios'},'Ver todos ',__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon-sm icon_right'}))))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_owl_carousel2___default.a,{className:'showcase-carousel bx-slider w-100 mx-0 owl-carousel owl-theme px-1',options:options},children)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_responsive___default.a,{maxDeviceWidth:425},children,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:'col-12 mb-5 pb-2'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{to:searchPage||'/search',className:'btn btn-sm  txt-center txt-button btn-invert',title:'vai para lista de benef\xEDcios'},'Ver todos'))))));};var options={margin:10,autoplay:false,dots:false,rewind:true,loop:false,responsive:{0:{items:2,margin:0,rewind:true,loop:false},420:{items:2,nav:true,rewind:true,loop:false},600:{items:4,nav:true,rewind:true,loop:false},1000:{margin:20,nav:true,rewind:true,loop:false,items:4}},navClass:['pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon','pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'],navText:['<i class="icon icon_left icon-sm color-ui-white" aria-hidden="true"></i>','<i class="icon icon_right icon-sm color-ui-white" aria-hidden="true"></i>']};Showcase.propTypes={title:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,titleMobile:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired,searchPage:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Showcase);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchCardContainer__ = __webpack_require__(1326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchCardContainer__["a"]; });


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selector__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Participant_Wishlist__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchCardContainer=function(_Component){_inherits(SearchCardContainer,_Component);function SearchCardContainer(){_classCallCheck(this,SearchCardContainer);return _possibleConstructorReturn(this,(SearchCardContainer.__proto__||Object.getPrototypeOf(SearchCardContainer)).apply(this,arguments));}_createClass(SearchCardContainer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.hasPriceUpdated){var _props=this.props,sku=_props.sku,vendorId=_props.vendor.id,originalId=_props.originalId;this.props.getAvailability({sku:sku,vendorId:vendorId,originalId:originalId});this.inWishlist(sku,vendorId);}}},{key:'inWishlist',value:function inWishlist(props){for(var i in this.props.wishlist.groupedWishlistBySkuId){if(this.props.wishlist.groupedWishlistBySkuId[i].skuId===props.sku){return true;}}return false;}},{key:'verifyOnlyCash',value:function verifyOnlyCash(props){if(props.onlyCash&&props.availability&&props.availability.cash){return props.availability?props.availability.cash.price:false;}}},{key:'bottomOnlyCash',value:function bottomOnlyCash(props){if(props.onlyCash){return props.availability?props.availability.cash:null;}else{return props.availability?props.availability.pointCash?props.availability.pointCash:props.availability.pointsCash:null;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Card"],Object.assign({inWishlist:this.inWishlist(this.props),onlyCash:this.props.onlyCash,sellingPrice:this.verifyOnlyCash(this.props),cashBack:this.props.cashBack,key:this.props.key,cardClass:'col-6 col-lg-4 mb-2 px-1 d-none d-md-block',sku:this.props.sku,image:this.props.imageUrl,description:this.props.name,priceFrom:this.props.availability?this.props.availability.regularPrice.toString():'',priceFor:this.props.availability?this.props.availability.price.toString():'',poinstPlusCash:this.bottomOnlyCash(this.props),countDown:this.props.countDown?this.props.countDown:false},this.props,{vendor:this.props.vendor,addCart:this.props.addItemToCart,itemCart:{sku:this.props.sku,vendorId:this.props.vendor.id,email:this.props.email},cart:this.props.cart,addWishList:this.props.addWishlist,removeWishList:this.props.removeWishlistCard,available:this.props.availability&&this.props.availability.available,decimalPlace:this.props.currencyConfiguration.decimalPlaces,pointsName:this.props.currencyConfiguration.pointsName,clearError:this.props.clearErrorCart,redirect:this.props.redirect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["CardSearchMobile"],Object.assign({inWishlist:this.inWishlist(this.props),onlyCash:this.props.onlyCash,cashBack:this.props.cashBack,sellingPrice:this.verifyOnlyCash(this.props),key:this.props.key,cardClass:'col-12 mb-1 px-half d-block d-md-none card-mobile',sku:this.props.sku,image:this.props.imageUrl,description:this.props.name,priceFrom:this.props.availability?this.props.availability.regularPrice.toString():'',priceFor:this.props.availability?this.props.availability.price.toString():'',poinstPlusCash:this.bottomOnlyCash(this.props),countDown:this.props.countDown?this.props.countDown:false},this.props,{vendor:this.props.vendor,addCart:this.props.addItemToCart,itemCart:{sku:this.props.sku,vendorId:this.props.vendor.id,email:this.props.email},cart:this.props.cart,addWishList:this.props.addWishlist,removeWishList:this.props.removeWishlistCard,available:this.props.availability&&this.props.availability.available,decimalPlace:this.props.currencyConfiguration.decimalPlaces,pointsName:this.props.currencyConfiguration.pointsName,clearError:this.props.clearErrorCart,redirect:this.props.redirect})));}}]);return SearchCardContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchCardContainer.propTypes={hasPriceUpdated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,addItemToCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,availability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,getAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,countDown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,addWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,removeWishlistCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cashBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,wishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,clearErrorCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,key:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,redirect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref,ownProps){var searchResult=_ref.searchResult,oidc=_ref.oidc,cart=_ref.cart,onlyCash=_ref.onlyCash,wishlist=_ref.wishlist,catalog=_ref.catalog;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__selector__["a" /* getProduct */])(searchResult,ownProps.sku),{email:oidc&&oidc.user&&oidc.user.profile&&oidc.user.profile.email,cart:cart,itemAdded:cart.itemAdded,onlyCash:onlyCash,wishlist:wishlist,currencyConfiguration:catalog.currencyConfiguration});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAvailability:function getAvailability(sku,vendorId,originalProductId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* getAvailability */])(sku,vendorId,originalProductId));},addItemToCart:function addItemToCart(data,redirect){return dispatch(__WEBPACK_IMPORTED_MODULE_5_features_Cart__["c" /* actions */].addItem(data,redirect));},removeWishlist:function removeWishlist(skuId){return dispatch(__WEBPACK_IMPORTED_MODULE_8_Participant_Wishlist__["b" /* actions */].removeWishlistCard(skuId));},addWishlist:function addWishlist(skuId){return dispatch(__WEBPACK_IMPORTED_MODULE_8_Participant_Wishlist__["b" /* actions */].addWishlist(skuId));},clearErrorCart:function clearErrorCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_5_features_Cart__["c" /* actions */].clearCartError());},redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(path));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SearchCardContainer));

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailability; });
var getAvailability=function getAvailability(_ref){var sku=_ref.sku,vendorId=_ref.vendorId,originalId=_ref.originalId;return{type:'FETCH_SEARCH_CARD_AVAILABILITY',sku:sku,payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/products/skus/'+sku+'/availability',params:{vendorId:vendorId,originalId:originalId}}}};};

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProduct; });
var getProduct=function getProduct(_ref,sku){var products=_ref.products;return products.filter(function(p){return p.sku===sku;})[0]||{};};

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductRecomendationContainer__ = __webpack_require__(1330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductRecomendationContainer__["a"]; });


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selector__ = __webpack_require__(1332);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductRecomendationCardContainer=function(_Component){_inherits(ProductRecomendationCardContainer,_Component);function ProductRecomendationCardContainer(){_classCallCheck(this,ProductRecomendationCardContainer);return _possibleConstructorReturn(this,(ProductRecomendationCardContainer.__proto__||Object.getPrototypeOf(ProductRecomendationCardContainer)).apply(this,arguments));}_createClass(ProductRecomendationCardContainer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.hasPriceUpdated){var _props=this.props,sku=_props.sku,vendorId=_props.vendor.id,originalId=_props.originalId;this.props.getAvailability({sku:sku,vendorId:vendorId,originalId:originalId});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Card"],Object.assign({onlyCash:this.props.onlyCash,sellingPrice:this.props.availability?this.props.availability.onlyCash.sellingPrice:100,key:this.props.sku,sku:this.props.sku,image:this.props.imageUrl,description:this.props.name,priceFrom:this.props.availability?this.props.availability.regularPrice.toString():'',priceFor:this.props.availability?this.props.availability.price.toString():'',poinstPlusCash:this.props.availability?this.props.availability.cash:null,countDown:this.props.countDown?this.props.countDown:false,addCart:this.props.addItemToCart,itemCart:{sku:this.props.sku,vendorId:this.props.vendor.id,email:this.props.email},cart:this.props.cart,available:this.props.availability&&this.props.availability.available,decimalPlace:this.props.currencyConfiguration.decimalPlaces,pointsName:this.props.currencyConfiguration.pointsName,clearError:this.props.clearErrorCart,redirect:this.props.redirect},this.props)));}}]);return ProductRecomendationCardContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductRecomendationCardContainer.propTypes={hasPriceUpdated:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,sku:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,vendor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,originalId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,availability:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,getAvailability:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,email:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,addItemToCart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,countDown:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,cart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,clearErrorCart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,redirect:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref,ownProps){var productRecomendation=_ref.productRecomendation,oidc=_ref.oidc,cart=_ref.cart,onlyCash=_ref.onlyCash,catalog=_ref.catalog;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__selector__["a" /* getProduct */])(productRecomendation,ownProps.sku),{email:oidc&&oidc.user&&oidc.user.profile&&oidc.user.profile.email,cart:cart,itemAdded:cart.itemAdded,onlyCash:onlyCash,currencyConfiguration:catalog.currencyConfiguration});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAvailability:function getAvailability(sku,vendorId,originalProductId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* getAvailability */])(sku,vendorId,originalProductId));},addItemToCart:function addItemToCart(data,redirect){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Cart__["c" /* actions */].addItem(data,redirect));},clearErrorCart:function clearErrorCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Cart__["c" /* actions */].clearCartError());},redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])(path));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductRecomendationCardContainer));

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailability; });
var getAvailability=function getAvailability(_ref){var sku=_ref.sku,vendorId=_ref.vendorId,originalId=_ref.originalId;return{type:'FETCH_RECOMENDATION_CARD_AVAILABILITY',sku:sku,payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/products/skus/'+sku+'/availability',params:{vendorId:vendorId,originalId:originalId}}}};};

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProduct; });
var getProduct=function getProduct(_ref,sku){var products=_ref.products;return products.filter(function(p){return p.sku===sku;})[0]||{};};

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VoucherCardContainer__ = __webpack_require__(1334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VoucherCardContainer__["a"]; });


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selector__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Participant_Wishlist__ = __webpack_require__(99);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VoucherCardContainer=function(_Component){_inherits(VoucherCardContainer,_Component);function VoucherCardContainer(){_classCallCheck(this,VoucherCardContainer);return _possibleConstructorReturn(this,(VoucherCardContainer.__proto__||Object.getPrototypeOf(VoucherCardContainer)).apply(this,arguments));}_createClass(VoucherCardContainer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.hasPriceUpdated){var _props=this.props,sku=_props.sku,vendorId=_props.vendor.id,originalId=_props.originalId;this.props.getAvailability({sku:sku,vendorId:vendorId,originalId:originalId});this.inWishlist(sku,vendorId);}}},{key:'inWishlist',value:function inWishlist(props){for(var i in this.props.wishlist.groupedWishlistBySkuId){if(this.props.wishlist.groupedWishlistBySkuId[i].skuId===props.sku){return true;}}return false;}},{key:'verifyOnlyCash',value:function verifyOnlyCash(props){if(props.onlyCash){return props.availability?props.availability.cash.price:false;}}},{key:'bottomOnyCash',value:function bottomOnyCash(props){if(props.onlyCash){return props.availability?props.availability.cash:null;}else{return props.availability?props.availability.pointCash?props.availability.pointCash:props.availability.pointsCash:null;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Card"],Object.assign({inWishlist:this.inWishlist(this.props),onlyCash:this.props.onlyCash,sellingPrice:this.verifyOnlyCash(this.props),key:this.props.sku,sku:this.props.sku,image:this.props.imageUrl,description:this.props.name,priceFrom:this.props.availability?this.props.availability.regularPrice.toString():'',priceFor:this.props.availability?this.props.availability.price.toString():'',poinstPlusCash:this.bottomOnyCash(this.props),countDown:this.props.countDown?this.props.countDown:false},this.props,{addCart:this.props.addItemToCart,itemCart:{sku:this.props.sku,vendorId:this.props.vendor.id,email:this.props.email},cart:this.props.cart,addWishList:this.props.addWishlist,removeWishList:this.props.removeWishlistCard,available:this.props.availability&&this.props.availability.available,decimalPlace:this.props.currencyConfiguration.decimalPlaces,pointsName:this.props.currencyConfiguration.pointsName,clearError:this.props.clearErrorCart,redirect:this.props.redirect})));}}]);return VoucherCardContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VoucherCardContainer.propTypes={hasPriceUpdated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,addItemToCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,availability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,getAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,countDown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,addWishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,removeWishlistCard:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,wishlist:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,clearErrorCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,redirect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref,ownProps){var voucherSuggestion=_ref.voucherSuggestion,oidc=_ref.oidc,cart=_ref.cart,onlyCash=_ref.onlyCash,wishlist=_ref.wishlist,catalog=_ref.catalog;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__selector__["a" /* getVoucher */])(voucherSuggestion,ownProps.sku),{email:oidc&&oidc.user&&oidc.user.profile&&oidc.user.profile.email,cart:cart,itemAdded:cart.itemAdded,onlyCash:onlyCash,wishlist:wishlist,currencyConfiguration:catalog.currencyConfiguration});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAvailability:function getAvailability(sku,vendorId,originalProductId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* getAvailability */])(sku,vendorId,originalProductId));},addItemToCart:function addItemToCart(data,redirect){return dispatch(__WEBPACK_IMPORTED_MODULE_6_features_Cart__["c" /* actions */].addItem(data,redirect));},removeWishlist:function removeWishlist(skuId){return dispatch(__WEBPACK_IMPORTED_MODULE_8_Participant_Wishlist__["b" /* actions */].removeWishlistCard(skuId));},addWishlist:function addWishlist(skuId){return dispatch(__WEBPACK_IMPORTED_MODULE_8_Participant_Wishlist__["b" /* actions */].addWishlist(skuId));},clearErrorCart:function clearErrorCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_6_features_Cart__["c" /* actions */].clearCartError());},redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(path));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(VoucherCardContainer));

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailability; });
var getAvailability=function getAvailability(_ref){var sku=_ref.sku,vendorId=_ref.vendorId,originalId=_ref.originalId;return{type:'FETCH_VOUCHER_CARD_AVAILABILITY',sku:sku,payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/products/skus/'+sku+'/availability',params:{vendorId:vendorId,originalId:originalId}}}};};

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVoucher; });
var getVoucher=function getVoucher(_ref,sku){var products=_ref.products;return products.filter(function(p){return p.sku===sku;})[0]||{};};

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addProductsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addProductsFail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createListByProp; });
var addProducts=function addProducts(){return{type:'ADD_PRODUCTS'};};var addProductsSuccess=function addProductsSuccess(products){return function(dispatch,_){dispatch({type:'ADD_PRODUCTS_SUCCESS',products:products});products.forEach(function(item){var sku=item.sku,vendorId=item.vendorId,originalId=item.originalId;dispatch(getAvailability({sku:sku,vendorId:vendorId,originalId:originalId}));});};};var addProductsFail=function addProductsFail(err){return{type:'ADD_PRODUCTS_FAIL',error:{data:err}};};var getAvailability=function getAvailability(_ref){var sku=_ref.sku,vendorId=_ref.vendorId,originalId=_ref.originalId;return{type:'FETCH_AVAILABILITY',sku:sku,payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/products/skus/'+sku+'/availability',params:{vendorId:vendorId,originalId:originalId}}}};};var createListByProp=function createListByProp(ProducList,propName){return ProducList.map(function(item){return item[''+propName];});};

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Personalized__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(292);
var mapStateToProps=function mapStateToProps(_ref){var products=_ref.products,recomendation=_ref.recomendation,availabilities=_ref.availabilities;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["c" /* getUserRecomendation */])(products,recomendation,availabilities));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchUserRecomendation:function fetchUserRecomendation(){return dispatch(__WEBPACK_IMPORTED_MODULE_3____["a" /* actions */].fetchUserRecomendation());}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Personalized__["a" /* default */],props);}));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cart__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Personalized=function(_Component){_inherits(Personalized,_Component);function Personalized(props){_classCallCheck(this,Personalized);return _possibleConstructorReturn(this,(Personalized.__proto__||Object.getPrototypeOf(Personalized)).call(this));}_createClass(Personalized,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchUserRecomendation();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},this.props.products.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Showcase__["a" /* Showcase */],{title:this.props.title,titleMobile:this.props.titleMobile,searchPage:'/search'},this.props.products.map(function(p,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:!_this2.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["CardPlaceholder"],null),key:idx},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Card"],{onlyCash:_this2.props.onlyCash,sellingPrice:p.availability.availability?p.availability.onlyCash.sellingPrice:99,sku:p.sku,image:p.imageUrl,description:p.name,priceFrom:p.availability.available?p.availability.regularPrice.toString():'',priceFor:p.availability.available?p.availability.price.toString():'',poinstPlusCash:p.availability.available?p.availability.cash:null,countDown:p.countDown?p.countDown:false,vendor:'',percentage:false,addCart:_this2.props.addItemToCart,itemCart:{sku:p.sku,vendorId:p.vendorId,email:_this2.props.email},cart:_this2.props.cart,available:p.availability&&p.availability.available,decimalPlace:_this2.props.currencyConfiguration.decimalPlaces,pointsName:_this2.props.currencyConfiguration.pointsName}));})));}}]);return Personalized;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Personalized.propTypes={fetchUserRecomendation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,addItemToCart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,cart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,email:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,products:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,isLoading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref){var oidc=_ref.oidc,cart=_ref.cart,onlyCash=_ref.onlyCash;return{email:oidc&&oidc.user&&oidc.user.profile&&oidc.user.profile.email,cart:cart,onlyCash:onlyCash};};var mapDispathToProps=function mapDispathToProps(){return function(dispatch){return{addItemToCart:function addItemToCart(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Cart__["c" /* actions */].addItem(data));}};};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispathToProps)(Personalized));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getProductsBySkuList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProductsBySkuListWithAvailability; });
/* unused harmony export getProductsBySku */
/* unused harmony export getAvailabilityBySku */
var getProductsBySkuList=function getProductsBySkuList(products,productListFilter){var resultProductsFilter=[];productListFilter.forEach(function(item){var filter=products[item];if(filter)resultProductsFilter.push(filter);});return resultProductsFilter;};var getProductsBySkuListWithAvailability=function getProductsBySkuListWithAvailability(products,productListFilter){var resultProductsFilter=[];productListFilter.forEach(function(item){var filter=products[item];if(filter){resultProductsFilter.push(filter);}});return resultProductsFilter;};var getProductsBySku=function getProductsBySku(products,sku){return products[sku];};var getAvailabilityBySku=function getAvailabilityBySku(availabilities,sku){return availabilities[sku];};

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ItemToItem__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(292);
var mapStateToProps=function mapStateToProps(_ref){var products=_ref.products,recomendation=_ref.recomendation;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* getItemToItemRecomendation */])(products,recomendation));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchItemToItemRecomendation:function fetchItemToItemRecomendation(productId){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].fetchItemToItemRecomendation(productId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__ItemToItem__["a" /* default */]));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_features_Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ProductCard__ = __webpack_require__(207);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ItemToItem=function(_Component){_inherits(ItemToItem,_Component);function ItemToItem(){_classCallCheck(this,ItemToItem);return _possibleConstructorReturn(this,(ItemToItem.__proto__||Object.getPrototypeOf(ItemToItem)).apply(this,arguments));}_createClass(ItemToItem,[{key:'componentDidMount',value:function componentDidMount(){var productId=this.props.productId;this.props.fetchItemToItemRecomendation(productId);}},{key:'render',value:function render(){return this.props.products.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_features_Showcase__["a" /* Showcase */],{title:this.props.title,mobileTitle:this.props.titleMobile,isLoading:!(this.props.products.length>0),viewAllPath:'/search'},this.props.products.map(function(p,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],Object.assign({},p,{key:p.sku,className:'col-12 px-auto px-md-0 mb-2 mb-md-0',sku:p.sku}));}));}}]);return ItemToItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ItemToItem.propTypes={fetchItemToItemRecomendation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,addItemToCart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,email:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,cart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref){var oidc=_ref.oidc,cart=_ref.cart,onlyCash=_ref.onlyCash,catalog=_ref.catalog;return{email:oidc&&oidc.user&&oidc.user.profile&&oidc.user.profile.email,cart:cart,onlyCash:onlyCash,currencyConfiguration:catalog.currencyConfiguration};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ItemToItem));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductCard__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tagging__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCardContainer=function(_Component){_inherits(ProductCardContainer,_Component);function ProductCardContainer(){_classCallCheck(this,ProductCardContainer);return _possibleConstructorReturn(this,(ProductCardContainer.__proto__||Object.getPrototypeOf(ProductCardContainer)).apply(this,arguments));}_createClass(ProductCardContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tagging__["a" /* default */],Object.assign({type:'view'},this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductCard__["a" /* default */],this.props));}}]);return ProductCardContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref,_ref2){var products=_ref.productsv2;var sku=_ref2.sku;return products[sku]||{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(ProductCardContainer));

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DiscountLabel__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Wishlist_WishlistHeart__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ProductCard_CardImage__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Catalog_Product_ProductCard_CardTitle__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard_CardPartner__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Catalog_Availability__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Catalog_Product_ProductCard_CardInternal__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tagging__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCard=function(_Component){_inherits(ProductCard,_Component);function ProductCard(props){_classCallCheck(this,ProductCard);var _this=_possibleConstructorReturn(this,(ProductCard.__proto__||Object.getPrototypeOf(ProductCard)).call(this,props));_this.state={sendGTM:false};_this.TaggingClick=_this.TaggingClick.bind(_this);return _this;}_createClass(ProductCard,[{key:'TaggingClick',value:function TaggingClick(){this.setState({sendGTM:true});}},{key:'render',value:function render(){var _props=this.props,sku=_props.sku,imageUrl=_props.imageUrl,name=_props.name,originalId=_props.originalId,vendorId=_props.vendorId,isResponsiveEnabled=_props.isResponsiveEnabled,discount=_props.discount;var className=this.props.className?this.props.className:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Shared_IsResponsiveEnabledContext__["a" /* default */].Provider,{value:isResponsiveEnabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card '+className},this.state.sendGTM&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Tagging__["a" /* default */],Object.assign({type:'click'},this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-2 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_responsive___default.a,{minDeviceWidth:769},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Wishlist_WishlistHeart__["a" /* default */],{className:'card-wishlist pos-absolute',sku:sku})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1 px-0'},discount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 discount-whishlist'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DiscountLabel__["a" /* default */],{discount:discount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ProductCard_CardImage__["a" /* default */],{imageUrl:imageUrl,href:'/products/'+sku,TaggingClick:this.TaggingClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_Catalog_Product_ProductCard_CardInternal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard_CardPartner__["a" /* default */],{vendorId:vendorId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Catalog_Product_ProductCard_CardTitle__["a" /* default */],{title:name,href:'/products/'+sku,TaggingClick:this.TaggingClick}),vendorId&&originalId&&sku&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Catalog_Availability__["b" /* default */],{sku:sku,originalId:originalId,vendorId:vendorId}))))));}}]);return ProductCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductCard.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isResponsiveEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,discount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_router__["withRouter"])(ProductCard));

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiscountLabel__ = __webpack_require__(1346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DiscountLabel__["a"]; });


/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var DiscountLabel=function DiscountLabel(_ref){var discount=_ref.discount;return discount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pos-absolute r-1 t-1 card-flag bg-success color-brand-5 radius txt-body-sm txt-font-body-bold mt-1'},'-',discount,'%'):null;};DiscountLabel.propTypes={discount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};DiscountLabel.defaultProps={discount:0};/* harmony default export */ __webpack_exports__["a"] = (DiscountLabel);

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WishlistHeart__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Wishlist_ducks__ = __webpack_require__(258);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(_ref){var wishlist=_ref.wishlistv2;return wishlist;};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleWishlistFor:function toggleWishlistFor(isInWishlist,sku){return function(){return isInWishlist?dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Wishlist_ducks__["d" /* removeFromWishlist */])(sku)):dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Wishlist_ducks__["a" /* addToWishlist */])(sku));};}};};var mergeProps=function mergeProps(_ref3,_ref4,_ref2){var products=_ref3.products;var toggleWishlistFor=_ref4.toggleWishlistFor;var sku=_ref2.sku,ownProps=_objectWithoutProperties(_ref2,['sku']);var isInWishlist=products&&products.includes(sku);var toggleWishlist=toggleWishlistFor(isInWishlist,sku);return Object.assign({isInWishlist:isInWishlist,toggleWishlist:toggleWishlist},ownProps);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_1__WishlistHeart__["a" /* default */]));

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
var DefaultCardImage=function DefaultCardImage(_ref){var altText=_ref.altText,imageUrl=_ref.imageUrl,href=_ref.href,TaggingClick=_ref.TaggingClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img col-12 row txt-center py-3 t-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 ml-auto mr-auto t-0 pos-absolute'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 m-0 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:href,tabIndex:-1,'aria-hidden':true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{tabIndex:-1,'aria-hidden':true,alt:'',className:'card-image-fallback',src:imageUrl})))));};DefaultCardImage.propTypes={altText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,TaggingClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,href:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var ResponsiveCardImage=function ResponsiveCardImage(_ref2){var altText=_ref2.altText,imageUrl=_ref2.imageUrl,visibleByDefault=_ref2.visibleByDefault,href=_ref2.href,TaggingClick=_ref2.TaggingClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img col-5 row txt-center py-3 my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 ml-auto mr-auto t-0 pos-absolute p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:href,'aria-hidden':true,tabIndex:-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'aria-hidden':true,alt:'',className:'card-image-fallback pos-absolute l-0',src:imageUrl})))));};ResponsiveCardImage.propTypes=DefaultCardImage.propTypes;var CardImage=function CardImage(props){var isResponsiveEnabled=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4_Shared_IsResponsiveEnabledContext__["a" /* default */]);return isResponsiveEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minWidth:480},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardImage,props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxWidth:479},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveCardImage,props))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardImage,props);};CardImage.propTypes={imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,TaggingClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,href:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CardImage);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
var CardTitle=function CardTitle(_ref){var title=_ref.title,href=_ref.href,TaggingClick=_ref.TaggingClick;var titleProductDesktop=title&&title.trim().length>60?title.trim().substr(0,60)+'...':title.trim();var titleProductMobile=title&&title.trim().length>60?title.trim().substr(0,40)+'...':title.trim();return title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-0 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{'aria-label':titleProductDesktop,className:'h3 box-card-link d-block txt-body-sm color-ui-2 txt-font-body txt-left',to:href||'/search',onClick:function onClick(){return TaggingClick();}},titleProductDesktop)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{'aria-label':titleProductMobile,className:'h3 box-card-link d-block txt-body-sm color-ui-2 txt-font-body txt-left',to:href||'/search',onClick:function onClick(){return TaggingClick();}},titleProductMobile)));};CardTitle.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,TaggingClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,href:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CardTitle);

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
var CardPartner=function CardPartner(_ref){var name=_ref.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-partner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pt-half color-ui-1 mb-1 txt-body-sm txt-font-body txt-left txt-bold'},name?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'\xA0')));};CardPartner.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function(_ref2,_ref3){var vendors=_ref2.vendors;var vendorId=_ref3.vendorId;return vendors[vendorId];})(CardPartner));

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductAvailability__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductAvailabilityContainer=function(_Component){_inherits(ProductAvailabilityContainer,_Component);function ProductAvailabilityContainer(){_classCallCheck(this,ProductAvailabilityContainer);return _possibleConstructorReturn(this,(ProductAvailabilityContainer.__proto__||Object.getPrototypeOf(ProductAvailabilityContainer)).apply(this,arguments));}_createClass(ProductAvailabilityContainer,[{key:'handleAvailabilityUpdate',value:function handleAvailabilityUpdate(){var _props=this.props,sku=_props.sku,originalId=_props.originalId,vendorId=_props.vendorId,loadAvailability=_props.loadAvailability,isPriceUpdated=_props.isPriceUpdated,isLoading=_props.isLoading;!isPriceUpdated&&!isLoading&&loadAvailability(sku,originalId,vendorId);}},{key:'componentDidMount',value:function componentDidMount(){this.handleAvailabilityUpdate();this.setState({changeContext:this.props.changeContext});}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.handleAvailabilityUpdate();}},{key:'render',value:function render(){var _props2=this.props,isLoading=_props2.isLoading,isAvailable=_props2.isAvailable,price=_props2.price,changeContext=_props2.changeContext;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductAvailability__["a" /* default */],{isLoading:isLoading,isAvailable:isAvailable,price:price,changeContext:changeContext});}}]);return ProductAvailabilityContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductAvailabilityContainer.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,originalId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadAvailability:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isAvailable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,isPriceUpdated:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,changeContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ProductAvailabilityContainer.defaultProps={isPriceUpdated:false};var mapStateToProps=function mapStateToProps(state,props){return Object(__WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__["c" /* selectAvailabilityBySku */])(state,props)||{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadAvailability:function loadAvailability(sku,originalId,vendorId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_ducks__["b" /* fetchAvailability */])(sku,originalId,vendorId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductAvailabilityContainer));

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Availability_Unavailable__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Availability_AvailabilityLoading__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_PriceLabel__ = __webpack_require__(1354);
var ProductAvailability=function ProductAvailability(_ref){var isLoading=_ref.isLoading,isAvailable=_ref.isAvailable,price=_ref.price,changeContext=_ref.changeContext;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Catalog_Availability_AvailabilityLoading__["a" /* default */],{isLoading:isLoading&&!isAvailable},isAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Catalog_Availability_PriceLabel__["a" /* PriceLabelContainer */],Object.assign({hasDiscount:price&&price.regularPrice>price.price},price,{changeContext:changeContext})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Catalog_Availability_Unavailable__["a" /* default */],null));};ProductAvailability.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isAvailable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ProductAvailability.defaultProps={isLoading:true};/* harmony default export */ __webpack_exports__["a"] = (ProductAvailability);

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AvailabilityLoading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var AvailabilityLoading=function AvailabilityLoading(_ref){var isLoading=_ref.isLoading,children=_ref.children;return isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12 mt-1 mb-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-12 m-0 mt-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:Math.random().toString(),loading:true,className:'btn-flat mx-auto py-half',role:'button','aria-label':'Carregando pontua\xE7\xE3o'},'Carregando')))))):children;};AvailabilityLoading.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};AvailabilityLoading.defaultProps={isLoading:true};/* harmony default export */ __webpack_exports__["a"] = (AvailabilityLoading);

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PriceLabelContainer__ = __webpack_require__(1355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PriceLabelContainer__["a"]; });


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriceLabel__ = __webpack_require__(1356);
var mapStateToProps=function mapStateToProps(_ref){var isOnlyCash=_ref.onlyCash,catalog=_ref.catalog;var _catalog$currencyConf=catalog.currencyConfiguration,name=_catalog$currencyConf.pointsName,decimalPlaces=_catalog$currencyConf.decimalPlaces;return{isOnlyCash:isOnlyCash,currency:{name:name,decimalPlaces:decimalPlaces}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__PriceLabel__["a" /* default */]));

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisplayCash__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DisplayPoints__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DisplayContext__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Catalog_Availability_PriceLabel_CardPriceWrapper__ = __webpack_require__(1361);
var PriceLabel=function PriceLabel(_ref){var isOnlyCash=_ref.isOnlyCash,hasDiscount=_ref.hasDiscount,regularPrice=_ref.regularPrice,price=_ref.price,cash=_ref.cash,currency=_ref.currency,_ref$changeContext=_ref.changeContext,changeContext=_ref$changeContext===undefined?true:_ref$changeContext;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Catalog_Availability_PriceLabel_CardPriceWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},changeContext?isOnlyCash?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DisplayCash__["a" /* default */],Object.assign({},cash,{currency:currency,hasCashBack:"false",ruleCashBack:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_RULE_CASHBACK||'1'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DisplayPoints__["a" /* default */],{hasDiscount:hasDiscount,regularPrice:regularPrice,price:price,hasPointCash:"true"&&!Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HIDE_POINTS_CASH_CARDPRODUCTS,cash:cash&&cash.price,currency:currency}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DisplayContext__["a" /* default */],{isOnlyCash:isOnlyCash})))));};PriceLabel.propTypes={hasDiscount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,regularPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,cash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,isOnlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,changeContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};PriceLabel.defaultProps={hasDiscount:false,currency:{decimalPlaces:0,name:'pts'}};/* harmony default export */ __webpack_exports__["a"] = (PriceLabel);

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Currency__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Availability_Unavailable__ = __webpack_require__(555);
var convertMoney=function convertMoney(value){return value.toLocaleString('pt-br',{minimumFractionDigits:2,maximumFractionDigits:2});};var DisplayCash=function DisplayCash(_ref){var price=_ref.price,hasCashBack=_ref.hasCashBack,currency=_ref.currency,ruleCashBack=_ref.ruleCashBack;return price?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title txt-font-body-bold txt-left color-ui-1 nowrap',title:'R$ '+convertMoney(price)},'R$ '+convertMoney(price)),hasCashBack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-cashback col-auto mx-1 txt-body-sm txt-font-body txt-left txt-bold color-success border border-color-ui-4 radius py-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 d-none d-lg-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon_cashback icon-sm icon icon_gift color-success'})),ruleCashBack==='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto txt-body-sm'},'Ganhe ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Currency__["a" /* default */],Object.assign({value:Math.floor(0.05*price)},currency))),ruleCashBack==='2'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto txt-body-sm'},'Ganhe ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Currency__["a" /* default */],Object.assign({value:Math.round(price)},currency)))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Catalog_Availability_Unavailable__["a" /* default */],null);};DisplayCash.propTypes={price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,hasCashBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,ruleCashBack:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired};/* harmony default export */ __webpack_exports__["a"] = (DisplayCash);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var convertPoints=function convertPoints(value,fixed){var number=parseFloat(value);return number.toFixed(fixed).replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');};var Currency=function Currency(_ref){var value=_ref.value,decimalPlaces=_ref.decimalPlaces,name=_ref.name;return convertPoints(value,decimalPlaces)+' '+name;};/* harmony default export */ __webpack_exports__["a"] = (Currency);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var convertPoints=function convertPoints(value,fixed){var number=parseFloat(value);return number.toFixed(fixed).replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');};var DisplayPoints=function DisplayPoints(_ref){var hasDiscount=_ref.hasDiscount,regularPrice=_ref.regularPrice,price=_ref.price,currency=_ref.currency,hasPointCash=_ref.hasPointCash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,hasDiscount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-from col-12 txt-subtitle txt-font-body txt-lowecase color-ui-2 txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('s',{'aria-hidden':'true'},regularPrice+' '+(currency&&currency.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title txt-font-body txt-left color-ui-1 nowrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' '+convertPoints(price,currency.decimalPlaces)+' '+currency.name))),hasPointCash&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-complete-with col-12 txt-body-sm txt-font-body txt-left txt-bold color-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'color-success col-12 pt-half'},'Ou utilize pontos + dinheiro'))));};DisplayPoints.propTypes={hasDiscount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,regularPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,currency:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,hasPointCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (DisplayPoints);

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var DisplayContext=function DisplayContext(_ref){var isOnlyCash=_ref.isOnlyCash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title txt-font-body-bold txt-left color-ui-1'},isOnlyCash?'Produto disponível apenas para resgate de pontos':'Produto disponível apenas para compras com cartão de crédito'));};DisplayContext.propTypes={isOnlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (DisplayContext);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
var CardPriceWrapper=function CardPriceWrapper(_ref){var children=_ref.children;var isResponsiveEnabled=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3_Shared_IsResponsiveEnabledContext__["a" /* default */]);var DefaultPriceWrapper=function DefaultPriceWrapper(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12 mt-1 mb-1 color-brand-1 p-0'},children);};return isResponsiveEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultPriceWrapper,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price mt-2 col-12 color-brand-1 p-0'},children))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultPriceWrapper,null);};CardPriceWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.elementType};/* harmony default export */ __webpack_exports__["a"] = (CardPriceWrapper);

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IfAvailable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Catalog_Availability_ducks__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var IfAvailable=function IfAvailable(_ref){var isAvailable=_ref.isAvailable,children=_ref.children,Component=_ref.component,props=_objectWithoutProperties(_ref,['isAvailable','children','component']);return isAvailable?children||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):null;};var mapStateToProps=function mapStateToProps(state,props){return{isAvailable:Object(__WEBPACK_IMPORTED_MODULE_1_Catalog_Availability_ducks__["d" /* selectIsAvailableBySku */])(state,props)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(IfAvailable));

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
var CardInternal=function CardInternal(_ref){var children=_ref.children;var isResponsiveEnabled=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3_Shared_IsResponsiveEnabledContext__["a" /* default */]);var DefaultCardInternal=function DefaultCardInternal(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-internal col-12 pt-md-0 pt-3'},children);};return isResponsiveEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardInternal,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-internal col-7 my-1'},children))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardInternal,null);};CardInternal.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.elementType};/* harmony default export */ __webpack_exports__["a"] = (CardInternal);

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Availability__ = __webpack_require__(154);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VoucherSuggestionContainer=function(_Component){_inherits(VoucherSuggestionContainer,_Component);function VoucherSuggestionContainer(){_classCallCheck(this,VoucherSuggestionContainer);return _possibleConstructorReturn(this,(VoucherSuggestionContainer.__proto__||Object.getPrototypeOf(VoucherSuggestionContainer)).apply(this,arguments));}_createClass(VoucherSuggestionContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchVoucherSuggestions();}},{key:'render',value:function render(){if(this.props.onlyCash){return'';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},this.props.products.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Showcase__["a" /* Showcase */],{title:this.props.title,titleMobile:this.props.titleMobile,searchPage:'/search?vendortypes=7'},this.props.products.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Availability__["d" /* VoucherCardContainer */],Object.assign({},p,{key:p.sku}));})));}}]);return VoucherSuggestionContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VoucherSuggestionContainer.propTypes={fetchVoucherSuggestions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref){var voucherSuggestion=_ref.voucherSuggestion,onlyCash=_ref.onlyCash;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* Vouchers */])(voucherSuggestion),{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchVoucherSuggestions:function fetchVoucherSuggestions(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchVoucherSuggestions */])('home'));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(VoucherSuggestionContainer));

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchVoucherSuggestions; });
var voucherSuggestion=7;var fetchVoucherSuggestions=function fetchVoucherSuggestions(identifier){return{type:'FETCH_VOUCHER_SUGGESTIONS',payload:{client:'cloudloyalty',request:{url:'/v2/showcases/'+voucherSuggestion+'?identifier='+identifier+'&cachedPrice=true'}}};};

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_stores_css__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_stores_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_stores_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_modules_carousel_css_owl_theme_default_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreSuggestion=function(_Component){_inherits(StoreSuggestion,_Component);function StoreSuggestion(){_classCallCheck(this,StoreSuggestion);return _possibleConstructorReturn(this,(StoreSuggestion.__proto__||Object.getPrototypeOf(StoreSuggestion)).apply(this,arguments));}_createClass(StoreSuggestion,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchStoreSuggestion();}},{key:'render',value:function render(){if(this.props.onlyCash){return'';}return this.props.stores.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase container-fluid bg-ui-5 mx-0 mx-md-auto px-0 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-stores container mx-2 mx-auto px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-auto mb-2 mb-md-4 mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'},'Encontre as suas lojas favoritas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-block d-md-none px-md-0 px-2'},'Marcas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:this.props.viewAllPath,className:'card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert'},'Ver todos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loyal_react__["Icon"],{className:'px-0',iconName:'icon-sm icon_right'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},renderCardStores(this.props.stores,'col-6 col-md-3 my-half mx-half'))));}}]);return StoreSuggestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var renderCardStores=function renderCardStores(stores){var className=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return stores.map(function(ItemStore,index){var link=ItemStore.link;if(!link){link='/vendor?vendor='+ItemStore.id;}var vendor={description:ItemStore.name,vendorId:ItemStore.id,vendorImage:ItemStore.imageUrl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'item card px-0 vendor_'+ItemStore.id+' '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loyal_react__["CardStoreMobile"],{informations:vendor})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_loyal_react__["CardStore"],{informations:vendor})))))));});};StoreSuggestion.propTypes={fetchStoreSuggestion:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,viewAllPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var storeSuggestion=_ref.storeSuggestion,onlyCash=_ref.onlyCash;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* Stores */])(storeSuggestion),{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchStoreSuggestion:function fetchStoreSuggestion(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* fetchStoreSuggestion */])('home'));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(StoreSuggestion));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchStoreSuggestion; });
var storeSuggestion='vendorbrand';var fetchStoreSuggestion=function fetchStoreSuggestion(identifier){return{type:'FETCH_STORE_SUGGESTIONS',payload:{client:'cloudloyalty',request:{url:'/v2/showcases/'+storeSuggestion+'?identifier='+identifier}}};};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getShippingSuccess=function getShippingSuccess(data){return{type:'FETCH_SHIPPING_SUCCESS',payload:{data:data}};};var fetchShipping=function fetchShipping(client){return function(zipCode,productSku){return function(dispatch,_){dispatch({type:'FETCH_SHIPPING'});var handleSuccess=function handleSuccess(response,zipCode){client.get('v1/addresses/'+zipCode).then(function(responseAddress){return manipulateModel(response,responseAddress,zipCode);}).catch(function(_error){dispatch({type:'FETCH_SHIPPING_FAIL',error:{data:_error}});});};var manipulateModel=function manipulateModel(_ref,address,zipCode){var data=_ref.data;var _address$data=address.data,streetType=_address$data.streetType,street=_address$data.street,district=_address$data.district,city=_address$data.city,state=_address$data.state;var DataEntrega=data.deliveryDate.split('T')[0];DataEntrega=DataEntrega.split('-');var model={code:zipCode,adress:streetType+' '+street,district:''+district,city:city+' - '+state,shippingValue:data.total,shippingValueCash:data.totalCash,deliveryForeCastDate:DataEntrega[2]+'/'+DataEntrega[1]+'/'+DataEntrega[0]};dispatch(getShippingSuccess(model));};client.get('/v2/products/sku/'+productSku+'/shipping/'+zipCode).then(function(rensponse){return handleSuccess(rensponse,zipCode);}).catch(function(_err){dispatch({type:'FETCH_SHIPPING_FAIL',error:{data:_err}});});};};};var backStateShipping=function backStateShipping(){return{type:'FETCH_BACK_SHIPPING'};};var errorFilledShipping=function errorFilledShipping(){return{type:'ERROR_FILLED_SHIPPING'};};/* harmony default export */ __webpack_exports__["a"] = (function(client){return{fetchShipping:fetchShipping(client),backStateShipping:backStateShipping,errorFilledShipping:errorFilledShipping};});

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shipping__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(560);
var mapStateToProps=function mapStateToProps(state){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* getShipping */])(state),{onlyCash:state.onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchShipping:function fetchShipping(code,productSkuId){return dispatch(__WEBPACK_IMPORTED_MODULE_3____["c" /* actions */].fetchShipping(code,productSkuId));},backStateShipping:function backStateShipping(){return dispatch(__WEBPACK_IMPORTED_MODULE_3____["c" /* actions */].backStateShipping());},errorFilledShipping:function errorFilledShipping(){return dispatch(__WEBPACK_IMPORTED_MODULE_3____["c" /* actions */].errorFilledShipping());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Shipping__["a" /* default */],props);}));

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Shipping=function(_Component){_inherits(Shipping,_Component);function Shipping(props){_classCallCheck(this,Shipping);var _this=_possibleConstructorReturn(this,(Shipping.__proto__||Object.getPrototypeOf(Shipping)).call(this,props));_this.state={codeShipping:'',msgShipping:''};return _this;}_createClass(Shipping,[{key:'SendShipping',value:function SendShipping(){if(this.ValidateShipping()){this.props.fetchShipping(this.state.codeShipping,this.props.productSkuId);}else{this.props.errorFilledShipping();}}},{key:'ValidateShipping',value:function ValidateShipping(){if(this.state.codeShipping){return true;}return false;}},{key:'SetInputMessage',value:function SetInputMessage(){if(this.props.error!==undefined)return false;else return null;}},{key:'showMessage',value:function showMessage(){var _this2=this;setTimeout(function(){_this2.setState({msgShipping:'Frete Calculado'});},300);}},{key:'backStateShipping',value:function backStateShipping(){this.props.backStateShipping();setTimeout(function(){document.querySelector('#cep').focus();},300);}},{key:'renderAddress',value:function renderAddress(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-form row row-eq-height pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hide-absolute',role:'status','aria-live':'assertive','aria-atomic':'true'},this.state.msgShipping),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-input col-12 form-field pr-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.value.adress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.value.district),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.value.city),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.state.codeShipping)))));}},{key:'convertPoints',value:function convertPoints(value,fixed){var number=parseFloat(value);return number.toFixed(fixed).replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');}},{key:'renderUpdateShipping',value:function renderUpdateShipping(){this.showMessage();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-form row row-eq-height pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-12 border-top border-color-ui-4 mt-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},!__WEBPACK_IMPORTED_MODULE_3_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_REMOVE_FREIGHT_LABEL)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Frete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body-sm '+(this.props.value.shippingValueCash>0||this.props.value.shippingValue>0?'':'d-none')},this.props.onlyCash?'R$ ':'',this.props.onlyCash?this.convertPoints(this.props.value.shippingValueCash,2):this.convertPoints(this.props.value.shippingValue,2),' pontos',!this.props.onlyCash?this.props.pointsName:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body-sm '+(this.props.value.shippingValueCash>0&&this.props.value.shippingValue>0?'d-none':'')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Prazo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-body-sm'},this.props.value.deliveryForeCastDate))))));}},{key:'renderFetchShipping',value:function renderFetchShipping(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-form row row-eq-height pt-2'},!this.props.filled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'cep',label:'CEP',className:'shipping-input col-6 col-md-5 pr-half',onChange:function onChange(e){_this3.setState({codeShipping:e.target.value.replace('-','').replace('.','')});},'data-error':'Não é possível entregar no CEP digitado.',mask:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/],valid:this.SetInputMessage(),value:this.state.codeShipping}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},this.renderAddress()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-button col-6 col-md-4 form-field pl-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{id:'SendShipping',name:'SendShipping',className:'btn btn-sm',text:!this.props.filled?'Calcular':'Alterar',onClick:function onClick(){return!_this3.props.filled?_this3.SendShipping():_this3.backStateShipping();},loading:this.props.isloading})),!this.props.filled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shipping-input col-12 col-md-3 form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 p-0 mt-1 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm',target:'_blank',className:' color-brand-2 txt-underline txt-body-sm txt-font-body txt-left mx-1',title:'Ir para o site do Correios'},'Procurar CEP'))));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-shipping col-12 py-2 px-3 mx-0 '+(this.props.isVoucher===false?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SHIPPING_DELIVERY_TITLE||'Frete e prazo de entrega'),!this.props.filled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_SHIPPING_DELIVERY_TEXT||'Calcule o valor do seu frete e saiba o prazo de entrega.'),this.renderFetchShipping(),this.props.filled&&this.renderUpdateShipping());}}]);return Shipping;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Shipping.propTypes={productSkuId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,filled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fetchShipping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,backStateShipping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,errorFilledShipping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,error:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,isloading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isVoucher:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Shipping);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Unavailable__ = __webpack_require__(1373);
/* unused harmony reexport Unavailable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(1374);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Unavailable=function(_Component){_inherits(Unavailable,_Component);function Unavailable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Unavailable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Unavailable.__proto__||Object.getPrototypeOf(Unavailable)).call.apply(_ref,[this].concat(args))),_this),_this.name='',_this.mail='',_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Unavailable,[{key:'MessageInputName',value:function MessageInputName(){if(this.props.filled.Name.error!==undefined)return false;else return null;}},{key:'MessageInputMail',value:function MessageInputMail(){if(this.props.filled.Email.error!==undefined)return false;else return null;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-buttons row px-2 border-color-ui-3 pb-3 mx-0 py-3 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-6 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'Name',label:'Nome',className:'col-12',required:true,onChange:function onChange(e){_this2.Nome=e.target.value;},'data-error':'Nome Invalido',valid:this.MessageInputName(),value:this.Nome})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-6 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'mail',label:'mail',className:'col-12',required:true,onChange:function onChange(e){_this2.mail=e.target.value;},'data-error':'mail Invalido',valid:this.MessageInputMail(),value:this.mail}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row my-2 border-color-ui-4 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-2 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-uppercase color-error txt-body txt-font-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Produto indisponivel'))))));}}]);return Unavailable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Unavailable.propTypes={filled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(_ref2){var unAvailable=_ref2.unAvailable;return{filled:unAvailable.filled};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{SendMail:function SendMail(mail){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* SendMail */])(mail));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Unavailable));

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SendMail; });
/* unused harmony export ValidationNameSuccess */
/* unused harmony export ValidationNameFail */
/* unused harmony export ValidationMailSuccess */
/* unused harmony export ValidationMailFail */
var SendMail=function SendMail(code){return{type:'SEND_MAIL',payload:{client:'sandbox',request:{method:'get',url:'/shipping/'+code}}};};var ValidationNameSuccess=function ValidationNameSuccess(){return{type:'VALIDATION_NAME_SUCCESS'};};var ValidationNameFail=function ValidationNameFail(){return{type:'VALIDATION_NAME_FAIL'};};var ValidationMailSuccess=function ValidationMailSuccess(){return{type:'VALIDATION_MAIL_SUCCESS'};};var ValidationMailFail=function ValidationMailFail(){return{type:'VALIDATION_MAIL_FAIL'};};

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{filled:{Name:{filled:false,error:false},Email:{filled:false,error:false}}};var action=arguments[1];switch(action.type){case'VALIDATION_NAME_SUCCESS':return Object.assign({},state,{filled:{Name:{filled:true,error:null}}});case'VALIDATION_NAME_FAIL':return Object.assign({},state,{filled:{Name:{filled:false,error:true}}});case'VALIDATION_MAIL_SUCCESS':return Object.assign({},state,{filled:{Mail:{filled:true,error:false}}});case'VALIDATION_MAIL_FAIL':return Object.assign({},state,{filled:{Mail:{filled:false,error:true}}});case'SEND_MAIL':return Object.assign({},state,{isloading:true,filled:false});case'SEND_MAIL_SUCCESS':return Object.assign({},state,{success:Object.assign({},action.payload.data)});case'SEND_MAIL_FAIL':return Object.assign({},state,{success:{},error:action.error});default:return Object.assign({},state);}});

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetailPageContainer__ = __webpack_require__(562);
/* unused harmony reexport ProductDetailPageContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_gallery__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Wishlist_WishlistHeart__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_image_gallery_styles_css_image_gallery_css__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_image_gallery_styles_css_image_gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_image_gallery_styles_css_image_gallery_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductImage=function(_Component){_inherits(ProductImage,_Component);function ProductImage(props){_classCallCheck(this,ProductImage);var _this=_possibleConstructorReturn(this,(ProductImage.__proto__||Object.getPrototypeOf(ProductImage)).call(this,props));_this.handleLabelThumb=_this.handleLabelThumb.bind(_this);return _this;}_createClass(ProductImage,[{key:'handleLabelThumb',value:function handleLabelThumb(){var imgGalleryThumbnails=document.querySelectorAll('.image-gallery-thumbnail, .image-gallery-bullet');if(imgGalleryThumbnails&&imgGalleryThumbnails.length>0){Array.from(imgGalleryThumbnails).forEach(function(imgGalleryThumbnail){imgGalleryThumbnail.setAttribute('aria-hidden','true');imgGalleryThumbnail.setAttribute('aria-label',imgGalleryThumbnail.getAttribute('aria-label').replace('Go to','Ir para'));});}var imgGalleryThumbnailsContainer=document.querySelectorAll('.image-gallery-thumbnails-container');if(imgGalleryThumbnailsContainer&&imgGalleryThumbnailsContainer.length>0){Array.from(imgGalleryThumbnailsContainer).forEach(function(imgGalleryThumbnailContainer){imgGalleryThumbnailContainer.removeAttribute('aria-label');});}var imgGalleryThumbnailsContainerMobile=document.querySelectorAll('.image-gallery-bullets-container');if(imgGalleryThumbnailsContainerMobile&&imgGalleryThumbnailsContainerMobile.length>0){Array.from(imgGalleryThumbnailsContainerMobile).forEach(function(bulletContainer){bulletContainer.removeAttribute('aria-label');});}var imgGalleries=document.querySelectorAll('.image-gallery');if(imgGalleries&&imgGalleries.length>0){Array.from(imgGalleries).forEach(function(imgGallery){imgGallery.removeAttribute('aria-live');});}}},{key:'hideThumbs',value:function hideThumbs(e,handleLabelThumb){handleLabelThumb();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-gallery-image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:e.original,alt:'','aria-hidden':'true'}));}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.handleLabelThumb();},3000);}},{key:'render',value:function render(){var _this3=this;var isLoading=this.props.isLoading;var isVoucher=this.props.isVoucher;var images=this.props.images;var imageUrl=this.props.imageUrl;var sku=this.props.sku;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:!isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* ProductImagePlaceholder */],{voucher:isVoucher})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-image overflow '+(!images?'voucher':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Wishlist_WishlistHeart__["a" /* default */],{sku:sku,className:'card-wishlist pos-absolute'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'imageGallery-box','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{maxDeviceWidth:767},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_gallery___default.a,{showPlayButton:false,showFullscreenButton:false,useBrowserFullscreen:false,showNav:false,showBullets:true,showThumbnails:false,disableKeyDown:true,disableArrowKeys:true,disableSwipe:true,items:images?images.map(function(img){return{original:img.largeImage||img.mediumImage,thumbnail:img.smallImage,thumbnailClass:'radius mt-2',originalAlt:'',thumbnailAlt:'',renderItem:function renderItem(e){return _this3.hideThumbs(e,_this3.handleLabelThumb);}};}):[{original:imageUrl,thumbnail:imageUrl}]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minDeviceWidth:768},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_gallery___default.a,{showPlayButton:false,showFullscreenButton:false,useBrowserFullscreen:false,showNav:false,disableKeyDown:true,disableArrowKeys:true,disableSwipe:true,showThumbnails:!!(images&&images.length>1),items:images?images.map(function(img){return{original:img.largeImage||img.mediumImage,thumbnail:img.smallImage,thumbnailClass:'radius mt-2',originalAlt:'',thumbnailAlt:'',renderItem:function renderItem(e){return _this3.hideThumbs(e,_this3.handleLabelThumb);}};}):[{original:imageUrl,thumbnail:imageUrl}]})))));}}]);return ProductImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductImage.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isVoucher:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,images:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,sku:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProductImage);

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWN", function() { return DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEFT", function() { return LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RIGHT", function() { return RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swipeable", function() { return Swipeable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UP", function() { return UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSwipeable", function() { return useSwipeable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var defaultProps = {
  preventDefaultTouchmoveEvent: false,
  delta: 10,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState = {
  xy: [0, 0],
  swiping: false,
  eventData: undefined,
  start: undefined
};
var LEFT = 'Left';
var RIGHT = 'Right';
var UP = 'Up';
var DOWN = 'Down';
var touchStart = 'touchstart';
var touchMove = 'touchmove';
var touchEnd = 'touchend';
var mouseMove = 'mousemove';
var mouseUp = 'mouseup';

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return LEFT;
    }

    return RIGHT;
  } else if (deltaY > 0) {
    return UP;
  }

  return DOWN;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event.touches && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends({}, state, initialState, {
        eventData: {
          initial: [].concat(xy)
        },
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
        return state;
      }

      var _ref2 = event.touches ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = state.xy[0] - x;
      var deltaY = state.xy[1] - y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);

      var eventData = _extends({}, state.eventData, {
        event: event,
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        velocity: velocity,
        dir: dir
      });

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
      return _extends({}, state, {
        eventData: eventData,
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping) {
        eventData = _extends({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
      }

      return _extends({}, state, initialState, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };

  var attachTouch = function attachTouch(el) {
    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h);
      }); // return properly scoped cleanup method for removing listeners

      return function () {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = null;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef // if track mouse attach mouse down listener

  };

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = null;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el);
    }
  }

  return _extends({}, state, addState);
}

function useSwipeable(props) {
  var trackMouse = props.trackMouse;
  var transientState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(_extends({}, initialState, {
    type: 'hook'
  }));
  var transientProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();
  transientProps.current = _extends({}, defaultProps, props);

  var _React$useMemo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    return getHandlers(function (cb) {
      return transientState.current = cb(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      handlers = _React$useMemo[0],
      attachTouch = _React$useMemo[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
  return handlers;
}
var Swipeable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Swipeable, _React$PureComponent);

  function Swipeable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _this._set = function (cb) {
      _this.transientState = cb(_this.transientState, _this.props);
    };

    _this.transientState = _extends({}, initialState, {
      type: 'class'
    });
    return _this;
  }

  var _proto = Swipeable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        _this$props$nodeName = _this$props.nodeName,
        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
        innerRef = _this$props.innerRef,
        children = _this$props.children,
        trackMouse = _this$props.trackMouse;

    var _getHandlers = getHandlers(this._set, {
      trackMouse: trackMouse
    }),
        handlers = _getHandlers[0],
        attachTouch = _getHandlers[1];

    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
    var ref = innerRef ? function (el) {
      return innerRef(el), handlers.ref(el);
    } : handlers.ref;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(nodeName, _extends({}, handlers, {
      className: className,
      style: style,
      ref: ref
    }), children);
  };

  return Swipeable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);
Swipeable.propTypes = {
  onSwiped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwiping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  preventDefaultTouchmoveEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nodeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  trackMouse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  trackTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  rotationAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Swipeable.defaultProps = defaultProps;




/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_image_gallery__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_image_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_image_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_gallery_styles_css_image_gallery_css__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_gallery_styles_css_image_gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_gallery_styles_css_image_gallery_css__);
// import PropTypes from 'prop-types'
var ProductImagePlaceholder=function ProductImagePlaceholder(isVoucher){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-image '+(isVoucher?'voucher':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_image_gallery___default.a,{showPlayButton:false,showFullscreenButton:false,useBrowserFullscreen:false,showNav:false,showThumbnails:!isVoucher,items:[{original:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,originalClass:'',thumbnail:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,thumbnailClass:'radius mt-2'},{original:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,originalClass:'',thumbnail:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,thumbnailClass:'radius mt-2'},{original:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,originalClass:'',thumbnail:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,thumbnailClass:'radius mt-2'},{original:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,originalClass:'',thumbnail:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,thumbnailClass:'radius mt-2'},{original:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,originalClass:'',thumbnail:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,thumbnailClass:'radius mt-2'},{original:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,originalClass:'',thumbnail:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a,thumbnailClass:'radius mt-2'}]}));};// ProductImagePlaceholder.propTypes = {
//   isVoucher: PropTypes.bool.isRequired
// }
/* harmony default export */ __webpack_exports__["a"] = (ProductImagePlaceholder);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentPlaceholder__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardBrands__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PointsCash__ = __webpack_require__(1387);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { getPayment } from 'Catalog/Product/ProductDetail/reducer'
var Payment=function(_Component){_inherits(Payment,_Component);function Payment(){_classCallCheck(this,Payment);return _possibleConstructorReturn(this,(Payment.__proto__||Object.getPrototypeOf(Payment)).apply(this,arguments));}_createClass(Payment,[{key:'renderPointsCash',value:function renderPointsCash(_ref){var pointsCash=_ref.pointsCash,Cardbrands=_ref.Cardbrands,onlyCash=_ref.onlyCash;var points=pointsCash.points;if(points){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,onlyCash?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PointsCash__["a" /* PointsCash */],pointsCash),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CardBrands__["a" /* CardBrands */],Cardbrands));}return null;}},{key:'renderPayment',value:function renderPayment(isVisible){return isVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-payment col-12 border-color-ui-3 py-3 px-3 mx-0 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1'},'Pagamento'),this.renderPointsCash(this.props)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:this.props.isVisible,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PaymentPlaceholder__["a" /* default */],null)},this.renderPayment(this.props.isVisible)));}}]);return Payment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Payment.propTypes={pointsMoreCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,getCardBrands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isVisible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref2,_ref3){var onlyCash=_ref2.onlyCash,availability=_ref2.availability,catalog=_ref2.catalog,payment=_ref2.payment;var sku=_ref3.sku;var _ref4=availability[sku]||{},isPriceUpdated=_ref4.isPriceUpdated,_ref4$price=_ref4.price;_ref4$price=_ref4$price===undefined?{}:_ref4$price;var newPointCash=_ref4$price.pointsCash;if(!isPriceUpdated)return{isVisible:false};var pointsName=catalog.currencyConfiguration.pointsName;var isLoading=payment.isLoading,brands=payment.brands;var isVisible=!!(newPointCash&&newPointCash['installments'].length>0);var description=isVisible&&newPointCash['installments'][0].description;var pointsCash={currencyName:pointsName,points:newPointCash?newPointCash.partialPoints:0,description:description};var Cardbrands={isLoading:isLoading,brands:brands};return{onlyCash:onlyCash,isVisible:isVisible,pointsCash:pointsCash,Cardbrands:Cardbrands};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(Payment));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardBrands__ = __webpack_require__(1385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CardBrands__["a"]; });


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardBrands_css__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardBrands_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cardBrands_css__);
var Cardbrand=function Cardbrand(_ref){var isLoading=_ref.isLoading,brands=_ref.brands;return isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lds-roller'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-icons row pt-2 px-half'},brands.map(function(brand,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-half',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:brand.imageUrl,alt:brand.name}));}));};Cardbrand.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,brands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Cardbrand);

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PointsCash__ = __webpack_require__(1388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PointsCash__["a"]; });


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
var PointsCash=function PointsCash(_ref){var points=_ref.points,description=_ref.description,currencyName=_ref.currencyName,onlyCash=_ref.onlyCash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},' ',onlyCash?'Veja quais bandeiras são aceitas.':'Complemente seu resgate com '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro')+'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Resgate por '+points+' '+currencyName+' + '+description)));};PointsCash.propTypes={points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,currencyName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref2){var onlyCash=_ref2.onlyCash;return{onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,null)(PointsCash));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:true,brands:[]};var action=arguments[1];switch(action.type){case'FETCH_CARD_BRANDS':return Object.assign({},state,{isLoading:true});case'FETCH_CARD_BRANDS_SUCCESS':return Object.assign({},state,{isLoading:false,brands:action.payload.data});case'FETCH_CARD_BRANDS_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});default:return Object.assign({},state);}});

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VoucherContainer__ = __webpack_require__(1391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VoucherContainer__["a"]; });


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Voucher__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_features_Cart__ = __webpack_require__(38);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref,ownProps){var participant=_ref.participant,cart=_ref.cart;return{email:participant.email,customer:cart.customer};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCart:function fetchCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_3_features_Cart__["c" /* actions */].loadCart());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__Voucher__["a" /* default */]));

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_clients__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var client=__WEBPACK_IMPORTED_MODULE_3_redux_clients__["a" /* default */].cloudloyalty.client;var Voucher=function(_Component){_inherits(Voucher,_Component);function Voucher(props){_classCallCheck(this,Voucher);var _this=_possibleConstructorReturn(this,(Voucher.__proto__||Object.getPrototypeOf(Voucher)).call(this,props));_this.handleShowField=function(){_this.setState({showField:!_this.state.showField});};_this.handleKeyChange=function(event){_this.setState({email:event.target.value});};_this.handleChange=function(event){client.post('v1/carts/1/me/emailAddress?email='+_this.state.email).then(function(_){_this.props.fetchCart();});_this.setState({showField:!_this.state.showField});};_this.state={showField:false,email:_this.props.customer?_this.props.customer.email:_this.props.email.value};return _this;}_createClass(Voucher,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-color-ui-3 border-bottom mx-0 py-3 px-3 '+(this.props.visible===true?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1'},'E-mail de envio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'O seu vale presente ser\xE1 enviado em at\xE9 7 dias \xFAteis para o e-mail abaixo.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 '+(this.state.showField?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-lowercase txt-body-sm pb-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.handleShowField,className:'cursor txt-left px-0 pt-1 txt-font-body color-brand-2 txt-underline txt-body-sm',role:'button'},'Alterar e-mail'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 px-0 '+(this.state.showField?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{defaultValue:'contato@contato.com.br',id:'emailInvalidInput',className:'col-12 pl-0',childrenClassName:'no-label',onChange:this.handleKeyChange,value:this.state.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 px-0 '+(this.state.showField?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'button',name:'button',className:'btn btn-sm',text:'Alterar',onClick:this.handleChange})));}}]);return Voucher;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Voucher.propTypes={visible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,customer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fetchCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Voucher);

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductTabs__ = __webpack_require__(1394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductTabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductTabsPlaceholder__ = __webpack_require__(569);
/* unused harmony reexport ProductTabsPlaceholder */


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductTabsPlaceholder__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tabs__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_rater_lib_react_rater_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_rater_lib_react_rater_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_rater_lib_react_rater_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_tabs_style_react_tabs_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_rating_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_rating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_rating_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_storerating_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_storerating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_storerating_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductTabs=function(_Component){_inherits(ProductTabs,_Component);function ProductTabs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProductTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProductTabs.__proto__||Object.getPrototypeOf(ProductTabs)).call.apply(_ref,[this].concat(args))),_this),_this.state={showModal:false},_this.state={hideModal:true},_this.toogleModal=function(){_this.setState({showModal:!_this.state.showModal});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProductTabs,[{key:'render',value:function render(){var _props=this.props,description=_props.description,properties=_props.properties,specs=_props.specs;var hasProperties=!!properties.length;var hasSpecs=!!specs.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:!this.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductTabsPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["d" /* Tabs */],{className:'product-tabs border-color-ui-3 mt-0 mt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-area draggable border-color-ui-3 border-bottom px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["b" /* TabList */],{className:'tabs-item py-3 px-0 mx-0'},description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'},'Informa\xE7\xF5es'),hasProperties&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'},'Caracter\xEDsticas'),hasSpecs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-uppercase txt-body color-ui-3'},'Especifica\xE7\xF5es')))),description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm',dangerouslySetInnerHTML:{__html:description}}))),hasProperties&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.properties.map(function(property,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm'},property.name,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm',dangerouslySetInnerHTML:{__html:property.value}}));})))),hasSpecs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.specs?this.props.specs.map(function(property,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm'},property.name,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-body-sm',dangerouslySetInnerHTML:{__html:property.value}}));}):'')))));}}]);return ProductTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductTabs.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,properties:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,specs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (ProductTabs);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Feature__ = __webpack_require__(1396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Feature__["a"]; });


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureContainer__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturePlaceholder__ = __webpack_require__(1419);
var Feature=function Feature(_ref){var isLoading=_ref.isLoading,isVoucher=_ref.isVoucher,features=_ref.features,featuresSkusByCurrentSku=_ref.featuresSkusByCurrentSku,changeSku=_ref.changeSku,SkuByType=_ref.SkuByType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:!isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FeaturePlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-options row border-color-ui-3 pt-2 pb-1 px-3 mx-0 '+(!isVoucher===true?'d-block':'d-none')},Object.keys(features).sort().map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeatureContainer__["a" /* default */],{key:key,type:key,items:features[key],relationSkus:featuresSkusByCurrentSku,changeSku:changeSku,SkuByType:SkuByType});})));};Feature.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isVoucher:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,features:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,featuresSkusByCurrentSku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,SkuByType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,changeSku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Feature);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorFeature__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SizeFeature__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VoltageFeature__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefaultFeature__ = __webpack_require__(1418);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var features={COR:__WEBPACK_IMPORTED_MODULE_0__ColorFeature__["a" /* default */],TAMANHO:__WEBPACK_IMPORTED_MODULE_1__SizeFeature__["a" /* default */],VOLTAGEM:__WEBPACK_IMPORTED_MODULE_2__VoltageFeature__["a" /* default */],DEFAULT:__WEBPACK_IMPORTED_MODULE_3__DefaultFeature__["a" /* default */]};var FeatureContainer=function FeatureContainer(_ref){var type=_ref.type,props=_objectWithoutProperties(_ref,['type']);return features[type]?features[type](Object.assign({},props)):features['DEFAULT'](Object.assign({},props));};/* harmony default export */ __webpack_exports__["a"] = (FeatureContainer);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureWrapper__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FeatureTitle__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeatureItems__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_a11y_select__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_a11y_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_a11y_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_a11y_select_src_styles_css__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_a11y_select_src_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_a11y_select_src_styles_css__);
var getTypeColor=function getTypeColor(SkuByType){var colors=[];SkuByType.map(function(item){if(item.COR){var verify=colors.filter(function(x){return x.COR===item.COR;}).length>0;if(!verify){var current=SkuByType.filter(function(x){return x.currentSku===true&&x.COR===item.COR;}).length>0;colors.push({sku:item.sku,COR:item.COR,currentSku:current});}}});return colors;};var getCorSelected=function getCorSelected(SkuByType){return SkuByType.filter(function(x){return x.currentSku===true;})[0].COR;};var getSKUSelected=function getSKUSelected(SkuByType){return SkuByType.filter(function(x){return x.currentSku===true;})[0].sku;};var ColorFeature=function ColorFeature(_ref){var push=_ref.history.push,SkuByType=_ref.SkuByType;var selectedSKU=getSKUSelected(SkuByType);var selectedColor=getCorSelected(SkuByType);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeatureWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FeatureTitle__["a" /* default */],{ariaLabelledby:'opcao-cor'},'Cor selecionada: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,selectedColor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FeatureItems__["a" /* default */],{className:'px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_a11y_select__["Select"],{labelledBy:'opcao-cor',label:'Selecione a cor',placeholderText:'Seleciona a cor',initialValue:selectedSKU,onChange:function onChange(e){return push('/products/'+e);}},getTypeColor(SkuByType).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_a11y_select__["Option"],{value:item.sku,label:item.COR},item.COR);}))));};ColorFeature.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}),SkuByType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(ColorFeature));

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Option = __webpack_require__(573);

var _Option2 = _interopRequireDefault(_Option);

var _OptionWrapper = __webpack_require__(1400);

var _OptionWrapper2 = _interopRequireDefault(_OptionWrapper);

var _SelectButton = __webpack_require__(1401);

var _SelectButton2 = _interopRequireDefault(_SelectButton);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uniqueId = __webpack_require__(1402);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _keycodes = __webpack_require__(1414);

var keycode = _interopRequireWildcard(_keycodes);

var _optionCollection = __webpack_require__(1415);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO This class is way too large. Need to break it down into
// smaller subcomponents somehow. :-/
var Select = (_temp = _class = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.handleClick = function (e) {
      var open = _this.state.open;

      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        open: !open
      });
    };

    _this.handleClickOutside = function (e) {
      if (_this.wrapperDiv && !_this.wrapperDiv.contains(e.target)) {
        var open = _this.state.open;

        if (open) {
          _this.updateExpandedState(false);
        }
      }
    };

    _this.handleKeyDown = function (e) {
      var _this$state = _this.state,
          open = _this$state.open,
          selectedKey = _this$state.selectedKey,
          highlightedKey = _this$state.highlightedKey;

      if (e.keyCode !== keycode.TAB) {
        e.preventDefault();
        e.stopPropagation();
      }

      switch (e.keyCode) {
        case keycode.DOWN:
          {
            if (!open) {
              _this.updateExpandedState(true);
            }
            _this.highlightOption(_this.options.getNextEnabledKey(highlightedKey));
            break;
          }
        case keycode.UP:
          {
            _this.highlightOption(_this.options.getPreviousEnabledKey(highlightedKey));
            break;
          }
        case keycode.ESC:
          {
            if (open) {
              _this.updateExpandedState(false);
            }
            break;
          }
        case keycode.SPACE:
        case keycode.ENTER:
          {
            if (open) {
              _this.handleOptionSelect(e, highlightedKey);
            } else {
              _this.updateExpandedState(true);
              _this.setState({
                highlightedKey: selectedKey
              });
            }
            break;
          }
        case keycode.TAB:
          {
            if (open) {
              _this.updateExpandedState(false);
            }
            break;
          }
        default:
      }
      return false;
    };

    _this.state = {
      open: false,
      selectedKey: null,
      highlightedKey: null
    };
    _this.options = [];
    return _this;
  }

  Select.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        children = _props.children,
        initialValue = _props.initialValue;

    var optionComponents = _react2.default.Children.toArray(children).filter(function (child) {
      return child.type === _Option2.default;
    });
    this.options = new _optionCollection.OptionCollection(optionComponents);

    if (initialValue) {
      var initialOption = this.options.findOptionByValue(initialValue);
      if (initialOption) {
        this.setState({
          selectedKey: initialOption.key
        });
      }
    }
  };

  Select.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  };

  Select.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  Select.prototype.handleOptionHover = function handleOptionHover(e, hoverOverKey) {
    this.highlightOption(hoverOverKey);
  };

  Select.prototype.handleOptionSelect = function handleOptionSelect(_e, clickedKey) {
    this.selectOption(clickedKey);
  };

  Select.prototype.handleOptionWrapperRef = function handleOptionWrapperRef(el) {
    if (el) {
      if (el.getAttribute('tabindex') === '0') {
        el.focus();
      }
    }
  };

  Select.prototype.highlightOption = function highlightOption(highlightedKey) {
    var candidate = this.options.findOptionByKey(highlightedKey);
    if (candidate.props.disabled) {
      return;
    }
    this.setState({
      highlightedKey: highlightedKey
    });
  };

  Select.prototype.selectOption = function selectOption(key) {
    var onChange = this.props.onChange;

    this.updateExpandedState(false);
    this.setState({
      selectedKey: key,
      highlightedKey: null
    });

    var selectedOption = this.options.findOptionByKey(key);
    var selectedValue = selectedOption.props.value;
    if (onChange) {
      onChange(selectedValue);
    }
  };

  Select.prototype.updateExpandedState = function updateExpandedState(open) {
    this.setState({
      open: open
    });
    if (!open) {
      var buttonId = this.props.buttonId;

      var button = document.getElementById(buttonId);
      if (button) {
        button.focus();
      }
    }
  };

  Select.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var _state = this.state,
        highlightedKey = _state.highlightedKey,
        selectedKey = _state.selectedKey;

    return this.options.allOptions().map(function (option) {
      return _react2.default.createElement(
        _OptionWrapper2.default,
        {
          key: 'optionwrapper-' + option.key,
          optionKey: option.key,
          selectedKey: selectedKey,
          highlightedKey: highlightedKey,
          label: option.props.label,
          value: option.props.value,
          disabled: option.props.disabled,
          onOptionWrapperRef: _this2.handleOptionWrapperRef,
          onMouseOver: function onMouseOver(e) {
            return _this2.handleOptionHover(e, option.key);
          },
          onClick: function onClick(e) {
            return _this2.handleOptionSelect(e, option.key);
          },
          onKeyDown: function onKeyDown(e) {
            return _this2.handleKeyDown(e);
          }
        },
        option
      );
    });
  };

  Select.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        open = _state2.open,
        highlightedKey = _state2.highlightedKey,
        selectedKey = _state2.selectedKey;
    var _props2 = this.props,
        listId = _props2.listId,
        buttonId = _props2.buttonId,
        placeholderText = _props2.placeholderText;

    var highlightedId = highlightedKey ? 'react-a11y-option-' + highlightedKey : undefined;

    return _react2.default.createElement(
      'div',
      {
        className: 'ReactA11ySelect',
        ref: function ref(wrapperDiv) {
          _this3.wrapperDiv = wrapperDiv;
        }
      },
      _react2.default.createElement(
        _SelectButton2.default,
        {
          buttonId: buttonId,
          listId: listId,
          highlightedId: highlightedId,
          open: open,
          onKeyDown: this.handleKeyDown,
          onClick: this.handleClick
        },
        !selectedKey && placeholderText,
        !!selectedKey && this.options.findOptionByKey(selectedKey).props.children
      ),
      _react2.default.createElement(
        'ul',
        {
          id: listId,
          role: 'menu',
          className: 'ReactA11ySelect__ul',
          'aria-hidden': open ? undefined : true,
          'aria-activedescendant': highlightedId
        },
        this.renderChildren()
      )
    );
  };

  return Select;
}(_react.Component), _class.defaultProps = {
  placeholderText: 'Please choose...',
  buttonId: (0, _uniqueId2.default)('react-a11y-button-'),
  listId: (0, _uniqueId2.default)('react-a11y-list-'),
  onChange: function onChange(_value) {}
}, _temp);
exports.default = Select;
Select.propTypes =  false ? {
  label: function label(props, propName, componentName) {
    if (!props.label && !props.labelledBy) {
      var msg = 'One of props \'label\' or \'labelledBy\' was not specified in ' + componentName;
      return new Error(msg);
    }
    return null;
  },
  labelledBy: function labelledBy(props, propName, componentName) {
    var msg = 'One of props \'label\' or \'labelledBy\' was not specified in ' + componentName;
    if (!props.label && !props.labelledBy) {
      return new Error(msg);
    }
    return null;
  },
  placeholderText: _propTypes2.default.string,
  initialValue: _propTypes2.default.string,
  buttonId: _propTypes2.default.string,
  listId: _propTypes2.default.string,
  onChange: _propTypes2.default.func
} : {};
module.exports = exports['default'];

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.OptionWrapper = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// This is a private, not intended for use except by the Select
// component for wrapping Options
// TODO refactor me I'm hideous!
var OptionWrapper = function OptionWrapper(props) {
  var onMouseOver = props.onMouseOver,
      onClick = props.onClick,
      onOptionWrapperRef = props.onOptionWrapperRef,
      selectedKey = props.selectedKey,
      highlightedKey = props.highlightedKey,
      children = props.children,
      optionKey = props.optionKey,
      label = props.label,
      value = props.value,
      disabled = props.disabled,
      highlightedRef = props.highlightedRef,
      others = _objectWithoutProperties(props, ["onMouseOver", "onClick", "onOptionWrapperRef", "selectedKey", "highlightedKey", "children", "optionKey", "label", "value", "disabled", "highlightedRef"]);

  var highlighted = optionKey === highlightedKey;
  var selected = optionKey === selectedKey;
  var ariaLabel = label || value;
  return _react2.default.createElement(
    "li",
    _extends({
      id: "react-a11y-option-" + optionKey,
      className: "ReactA11ySelect__ul__li",
      tabIndex: highlighted ? "0" : "-1",
      role: "menuitemradio",
      "aria-checked": selected ? true : undefined,
      "aria-disabled": disabled ? true : undefined,
      "aria-label": ariaLabel,
      ref: function ref(e) {
        return onOptionWrapperRef(e);
      },
      disabled: disabled ? true : undefined,
      onMouseOver: disabled ? undefined : onMouseOver,
      onClick: disabled ? undefined : onClick
    }, others),
    selected && _react2.default.createElement("span", { className: "ReactA11ySelect__ul__li__selected-indicator", "aria-hidden": "true" }),
    children
  );
};
exports.OptionWrapper = OptionWrapper;
exports.default = OptionWrapper;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SelectButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectButton = exports.SelectButton = function SelectButton(props) {
  var open = props.open,
      listId = props.listId,
      buttonId = props.buttonId,
      highlightedId = props.highlightedId,
      onKeyDown = props.onKeyDown,
      onClick = props.onClick,
      inner = props.inner,
      children = props.children;

  return _react2.default.createElement(
    'button',
    {
      className: 'ReactA11ySelect__button',
      id: buttonId,
      role: 'button',
      tabIndex: open ? "-1" : "0",
      'aria-haspopup': 'true',
      'aria-expanded': open ? true : undefined // ARIA recommends not including over false
      , 'aria-controls': listId,
      onKeyDown: onKeyDown,
      onClick: onClick
    },
    _react2.default.createElement(
      'span',
      null,
      children
    ),
    _react2.default.createElement('span', { className: 'ReactA11ySelect__button__arrow-indicator', 'aria-hidden': 'true' })
  );
};

SelectButton.propTypes =  false ? {
  open: _propTypes2.default.bool,
  buttonId: _propTypes2.default.string,
  listId: _propTypes2.default.string,
  highlightedId: _propTypes2.default.string,
  onKeyDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
} : {};

exports.default = SelectButton;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(1403);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1404);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(296),
    arrayMap = __webpack_require__(1407),
    isArray = __webpack_require__(1408),
    isSymbol = __webpack_require__(1409);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1406);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1410),
    isObjectLike = __webpack_require__(1413);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(296),
    getRawTag = __webpack_require__(1411),
    objectToString = __webpack_require__(1412);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(296);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1412 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1413 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// keycodes for keyboard events.
var TAB = exports.TAB = 9;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var UP = exports.UP = 38;
var DOWN = exports.DOWN = 40;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OptionCollection = exports.OptionCollection = function () {
  function OptionCollection(options) {
    _classCallCheck(this, OptionCollection);

    this.options = options;
  }

  OptionCollection.prototype.allOptions = function allOptions() {
    return this.options;
  };

  OptionCollection.prototype.findOptionByValue = function findOptionByValue(value) {
    return this.options.find(function (option) {
      return option.props.value === value;
    });
  };

  OptionCollection.prototype.findOptionByKey = function findOptionByKey(key) {
    return this.options.find(function (option) {
      return option.key === key;
    });
  };

  OptionCollection.prototype.getNextEnabledKey = function getNextEnabledKey(key) {
    var currentIndex = this.options.findIndex(function (option) {
      return option.key === key;
    });
    var lastIndex = this.options.length - 1;
    var next = void 0;
    if (currentIndex === -1) {
      next = this.options[0];
    } else if (currentIndex === lastIndex) {
      next = this.options[currentIndex];
    } else {
      next = this.options[currentIndex + 1];
    }

    if (next.props.disabled && currentIndex !== lastIndex) {
      return this.getNextEnabledKey(next.key);
    }
    return next.key;
  };

  OptionCollection.prototype.getPreviousEnabledKey = function getPreviousEnabledKey(key) {
    var currentIndex = this.options.findIndex(function (option) {
      return option.key === key;
    });
    var previous = void 0;
    if (currentIndex === 0) {
      previous = this.options[0];
    } else {
      previous = this.options[currentIndex - 1];
    }

    if (currentIndex !== 0 && previous.props.disabled) {
      return this.getPreviousEnabledKey(previous.key);
    }
    return previous.key;
  };

  return OptionCollection;
}();

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureWrapper__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FeatureTitle__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeatureItems__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_a11y_select__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_a11y_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_a11y_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_a11y_select_src_styles_css__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_a11y_select_src_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_a11y_select_src_styles_css__);
var getSizes=function getSizes(SkuByType){var _COR=SkuByType.filter(function(x){return x.currentSku===true;})[0].COR;var listMap=SkuByType.filter(function(x){return x.COR===_COR;});return listMap.sort(function(a,b){var nameA=a.TAMANHO&&a.TAMANHO.toLowerCase();var nameB=b.TAMANHO&&b.TAMANHO.toLowerCase();if(nameA<nameB)return-1;if(nameA>nameB)return 1;return 0;});};var getSKUSelected=function getSKUSelected(SkuByType){return SkuByType.filter(function(x){return x.currentSku===true;})[0].sku;};var getTAMANHOSelected=function getTAMANHOSelected(SkuByType){return SkuByType.filter(function(x){return x.currentSku===true;})[0].TAMANHO;};var SizeFeature=function SizeFeature(_ref){var push=_ref.history.push,SkuByType=_ref.SkuByType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeatureWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FeatureTitle__["a" /* default */],{ariaLabelledby:'opcao-tamanho'},'Selecione o tamanho: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,getTAMANHOSelected(SkuByType))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FeatureItems__["a" /* default */],{className:'px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_a11y_select__["Select"],{ariaLabelledby:'opcao-voltagem',label:'Selecione o tamanho',placeholderText:'Seleciona o tamanho',initialValue:getSKUSelected(SkuByType),onChange:function onChange(e){return push('/products/'+e);}},getSizes(SkuByType).map(function(size){return size.TAMANHO&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_a11y_select__["Option"],{value:size.sku,label:size.TAMANHO},size.TAMANHO);}))));};SizeFeature.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func}),SkuByType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(SizeFeature));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureWrapper__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var getVoltage=function getVoltage(SkuByType){var current=SkuByType.filter(function(x){return x.currentSku===true;}).length>0;var _COR=SkuByType.filter(function(x){return x.currentSku===true;})[0].COR;var listMap=current?SkuByType.filter(function(x){return x.COR===_COR;}):SkuByType.filter(function(x){return x.VOLTAGEM!==undefined;});return listMap.sort(function(a,b){var nameA=a.VOLTAGEM&&a.VOLTAGEM.toLowerCase();var nameB=b.VOLTAGEM&&b.VOLTAGEM.toLowerCase();if(nameA<nameB)return-1;if(nameA>nameB)return 1;return 0;});};var VoltageFeature=function VoltageFeature(_ref){var SkuByType=_ref.SkuByType;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState2=_slicedToArray(_useState,2),currentVoltage=_useState2[0],setCurrentVoltage=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var voltage=getVoltage(SkuByType).filter(function(item){return item.currentSku===true;});setCurrentVoltage(voltage[0].VOLTAGEM);},[window.location]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-font-body e'},'Voltagem: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'Xbold'},currentVoltage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FeatureWrapper__["a" /* default */],null,getVoltage(SkuByType).map(function(size){return size.VOLTAGEM&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/products/'+size.sku,className:'voltage-link '+(size.currentSku?'current-voltage':''),key:size.sku,'aria-label':''+(size.currentSku?'(Selecionado) ':'')+size.VOLTAGEM.split('Volts').join('V')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:''+(size.currentSku?'current-voltage-volts':'voltage-volts')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},''+size.VOLTAGEM.split('Volts').join('V'))));})));};VoltageFeature.propTypes={SkuByType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (VoltageFeature);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,'');});

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeaturePlaceholder=function(_Component){_inherits(FeaturePlaceholder,_Component);function FeaturePlaceholder(){_classCallCheck(this,FeaturePlaceholder);return _possibleConstructorReturn(this,(FeaturePlaceholder.__proto__||Object.getPrototypeOf(FeaturePlaceholder)).apply(this,arguments));}_createClass(FeaturePlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-options row border-color-ui-3  pt-2 pb-1  mx-0'});}}]);return FeaturePlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FeaturePlaceholder);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Checkout_Cart_AddToCartButton__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Product_ProductDetail_RedemptionSection_ModalVoltage__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ProductDetail_RedemptionSection_VerifyItemsCart__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChangeContext__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddCartVerify=function(_Component){_inherits(AddCartVerify,_Component);function AddCartVerify(props){_classCallCheck(this,AddCartVerify);var _this=_possibleConstructorReturn(this,(AddCartVerify.__proto__||Object.getPrototypeOf(AddCartVerify)).call(this));_this.verifyItemsCart=function(){_this.setState({showModalItemsCart:!_this.state.showModalItemsCart});};_this.showModalCartPartner=function(){var _this$props=_this.props,vendorId=_this$props.vendorId,items=_this$props.items,onlyCash=_this$props.onlyCash;return __WEBPACK_IMPORTED_MODULE_9_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_VERIFY_CART_PARTNER)&&onlyCash&&items.length!==0&&items.length>0&&vendorId!==items[0].vendor.id.toString();};_this.state={showModalItemsCart:false};_this.verifyItemsCart=_this.verifyItemsCart.bind(_this);return _this;}_createClass(AddCartVerify,[{key:'render',value:function render(){var _props=this.props,sku=_props.sku,vendorId=_props.vendorId,hasVoltage=_props.hasVoltage,changeContext=_props.changeContext,isLoading=_props.isLoading,wasModified=_props.wasModified;// Exibir mensagem que existem produtos no carrinho
if(this.state.showModalItemsCart){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Catalog_Product_ProductDetail_RedemptionSection_VerifyItemsCart__["a" /* default */],{verifyItemsCart:this.verifyItemsCart,showModalItemsCart:true,sku:sku,vendorId:vendorId,goToCheckout:true,className:'btn-featured'});}// Exibir mensagem caso produto não pertença ao contexto
if(changeContext){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ChangeContext__["a" /* ChangeContext */],null);}var ready=!isLoading||wasModified;if(ready){if(hasVoltage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Catalog_Product_ProductDetail_RedemptionSection_ModalVoltage__["a" /* default */],{sku:sku,vendorId:vendorId,verifyItemsCart:this.showModalCartPartner()?this.verifyItemsCart:null});}else{if(this.showModalCartPartner()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loyal_react__["Button"],{className:'btn btn-sm txt-uppercase txt-center btn-featured',onClick:this.verifyItemsCart,text:'Adicionar ao carrinho'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Checkout_Cart_AddToCartButton__["a" /* default */],{sku:sku,vendorId:vendorId,goToCheckout:true,className:'btn-featured'});}}}else{return'';}}}]);return AddCartVerify;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AddCartVerify.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hasVoltage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,changeContext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,wasModified:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref){var cart=_ref.cart,onlyCash=_ref.onlyCash;return Object.assign({},cart,{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_6_features_Cart__["c" /* actions */].loadCart());},removeItem:function removeItem(sku){return dispatch(__WEBPACK_IMPORTED_MODULE_6_features_Cart__["c" /* actions */].removeItem(sku));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(AddCartVerify));

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var ActionButton=function ActionButton(_ref){var isLoading=_ref.isLoading,hasSuccess=_ref.hasSuccess,hasError=_ref.hasError,errorText=_ref.errorText,successText=_ref.successText,text=_ref.text,AddItemCart=_ref.AddItemCart,className=_ref.className,iconName=_ref.iconName,noIcon=_ref.noIcon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm txt-uppercase txt-center '+className+' '+(hasSuccess?'btn-cart-success btn-icon':hasError?'cart-done btn-featured btn-sm btn-cart-error btn-icon':''),disabled:isLoading,loading:isLoading,onClick:AddItemCart,iconName:!noIcon&&(hasSuccess?'icon_check_circle color-success':hasError?'icon_close_circle color-error':iconName),text:''+(isLoading?null:hasSuccess?successText:hasError?errorText:text)});};ActionButton.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,errorText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,successText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hasError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasSuccess:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,iconName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,noIcon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,AddItemCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ActionButton);

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Checkout_Cart_AddToCartButton__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_aria_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_aria_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_aria_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalVoltage=function(_Component){_inherits(ModalVoltage,_Component);function ModalVoltage(props){_classCallCheck(this,ModalVoltage);var _this=_possibleConstructorReturn(this,(ModalVoltage.__proto__||Object.getPrototypeOf(ModalVoltage)).call(this,props));_this.getApplicationNode=function(){return document.querySelector('#root');};_this.state={showConfirmVoltage:_this.props.showConfirmVoltage};return _this;}_createClass(ModalVoltage,[{key:'confirmVoltage',value:function confirmVoltage(){this.setState({showConfirmVoltage:!this.state.showConfirmVoltage});}},{key:'removeTabIndex',value:function removeTabIndex(){setTimeout(function(){var contentModalVoltage=document.querySelector('#modal-voltage');contentModalVoltage&&contentModalVoltage.removeAttribute('tabindex');},300);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'voltagem',text:'Adicionar ao Carrinho',iconName:'icon_cart',className:'btn-icon btn btn-sm txt-uppercase txt-center btn-featured',onClick:function onClick(){return _this2.confirmVoltage();}}),this.state.showConfirmVoltage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_aria_modal___default.a,{titleText:'Confirme o produto',onExit:function onExit(){return _this2.confirmVoltage();},initialFocus:'#modal-voltage',getApplicationNode:this.getApplicationNode,underlayStyle:{paddingTop:'100px',zIndex:9999},focusDialog:true,alert:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-none','data-campaign':"80938"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'modal-voltage',onBlur:this.removeTabIndex,tabIndex:0,className:'modal-voltage col-12 bg-white py-3 mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{id:'modal-question-voltage',className:'h3 txt-font-title'},'Tem certeza que deseja o produto com a voltagem escolhida?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-12 col-md-6 txt-right mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'back-voltage',name:'back-voltage',className:'btn btn-sm mx-0',text:'Voltar',onClick:function onClick(){return _this2.confirmVoltage();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-12 col-md-6 txt-right mt-3'},typeof this.props.verifyItemsCart==='function'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'confirm-voltage',name:'confirm-voltage',className:'btn btn-sm txt-uppercase txt-center btn-featured',text:'Adicionar ao carrinho',onClick:this.props.verifyItemsCart}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Checkout_Cart_AddToCartButton__["a" /* default */],{sku:this.props.sku,vendorId:this.props.vendorId,goToCheckout:true,className:'btn-featured',noIcon:true}))))))));}}]);return ModalVoltage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalVoltage.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,showConfirmVoltage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,verifyItemsCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ModalVoltage.defaultProps={showConfirmVoltage:false};/* harmony default export */ __webpack_exports__["a"] = (ModalVoltage);

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(42);
var createFocusTrap = __webpack_require__(1424);

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setFocusTrapElement = function (element) {
      _this.focusTrapElement = element;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      var focusTrapElementDOMNode = ReactDOM.findDOMNode(this.focusTrapElement);

      this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNode, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

        var returnFocus = returnFocusOnDeactivate || false;
        var config = { returnFocus: returnFocus };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var child = React.Children.only(this.props.children);

      var composedRefCallback = function composedRefCallback(element) {
        _this2.setFocusTrapElement(element);
        if (typeof child.ref === 'function') {
          child.ref(element);
        }
      };

      var childWithRef = React.cloneElement(child, { ref: composedRefCallback });

      return childWithRef;
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__(1425);
var xtend = __webpack_require__(1426);

var activeFocusTraps = (function() {
  var trapQueue = [];
  return {
    activateTrap: function(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];
        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },

    deactivateTrap: function(trap) {
      var trapIndex = trapQueue.indexOf(trap);
      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
})();

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    activeFocusTraps.deactivateTrap(trap);

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trap);

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (
    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (
    node.disabled
    || isHiddenInput(node)
    || untouchabilityChecker.isUntouchable(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function(item) {
      return item === node;
    });
    if (cached) return cached[1];

    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }

    this.cache.push([node, result]);

    return result;
}

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(42);

// React 16+ supports Portals.
var canUsePortals = !!ReactDOM.createPortal;

function displace(WrappedComponent, options) {
  if (!global.document) {
    return function (_React$Component) {
      _inherits(EmptyDisplace, _React$Component);

      function EmptyDisplace() {
        _classCallCheck(this, EmptyDisplace);

        return _possibleConstructorReturn(this, (EmptyDisplace.__proto__ || Object.getPrototypeOf(EmptyDisplace)).apply(this, arguments));
      }

      _createClass(EmptyDisplace, [{
        key: 'render',
        value: function render() {
          return false;
        }
      }]);

      return EmptyDisplace;
    }(React.Component);
  }

  options = options || {};

  var Displaced = function (_React$Component2) {
    _inherits(Displaced, _React$Component2);

    function Displaced() {
      var _ref;

      var _temp, _this2, _ret;

      _classCallCheck(this, Displaced);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Displaced.__proto__ || Object.getPrototypeOf(Displaced)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderDisplaced = function () {
        ReactDOM.unstable_renderSubtreeIntoContainer(_this2, React.createElement(WrappedComponent, _this2.props, _this2.props.children), _this2.container);
      }, _this2.removeDisplaced = function () {
        ReactDOM.unmountComponentAtNode(_this2.container);
      }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(Displaced, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.container = function () {
          if (!options.renderTo) {
            var result = document.createElement('div');
            document.body.appendChild(result);
            return result;
          } else if (typeof options.renderTo === 'string') {
            return document.querySelector(options.renderTo);
          } else {
            return options.renderTo;
          }
        }();
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (canUsePortals) return;
        if (this.props.mounted) {
          this.renderDisplaced();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (canUsePortals) return;
        if (prevProps.mounted && !this.props.mounted) {
          ReactDOM.unmountComponentAtNode(this.container);
        } else if (this.props.mounted) {
          this.renderDisplaced();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!canUsePortals) {
          ReactDOM.unmountComponentAtNode(this.container);
        }
        if (!options.renderTo) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (!canUsePortals || this.props.mounted === false) {
          return null;
        }
        return ReactDOM.createPortal(React.createElement(WrappedComponent, this.props, this.props.children), this.container);
      }
    }]);

    return Displaced;
  }(React.Component);

  Displaced.defaultProps = {
    mounted: true
  };
  Displaced.WrappedComponent = WrappedComponent;


  return Displaced;
}

module.exports = displace;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Checkout_Cart_AddToCartButton__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_aria_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_aria_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_aria_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VerifyItemsCart=function(_Component){_inherits(VerifyItemsCart,_Component);function VerifyItemsCart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VerifyItemsCart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VerifyItemsCart.__proto__||Object.getPrototypeOf(VerifyItemsCart)).call.apply(_ref,[this].concat(args))),_this),_this.getApplicationNode=function(){return document.querySelector('#root');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VerifyItemsCart,[{key:'removeTabIndex',value:function removeTabIndex(){setTimeout(function(){var contentModalVoltage=document.querySelector('#modal-items-cart');contentModalVoltage&&contentModalVoltage.removeAttribute('tabindex');},300);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.showModalItemsCart&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_aria_modal___default.a,{titleText:'Voc\xEA tem produto(s) de outro parceiro no carrinho',onExit:this.props.verifyItemsCart,initialFocus:'#modal-items-cart',getApplicationNode:this.getApplicationNode,underlayStyle:{paddingTop:'100px',zIndex:9999},focusDialog:true,alert:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-none','data-campaign':"80938"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'modal-items-cart',onBlur:this.removeTabIndex,tabIndex:0,className:'modal-voltage col-10 col-sm-7 bg-white py-3 mx-auto border-bottom-lg border-color-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{id:'modal-question-voltage',className:'h3 txt-font-title'},'Voc\xEA tem produto(s) de outro parceiro no carrinho'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Existem produtos de outro parceiro no seu carrinho. Finalize sua compra com os itens que j\xE1 est\xE3o no carrinho ou os remova para adicionar este produto.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-12 col-md-6 txt-right mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'back-product',name:'back-product',className:'btn btn-sm mx-0',text:'Voltar',onClick:this.props.verifyItemsCart})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-12 col-md-6 txt-right mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Checkout_Cart_AddToCartButton__["a" /* default */],{text:'Seguir com este produto',removeItems:true,sku:this.props.sku,vendorId:this.props.vendorId,goToCheckout:this.props.goToCheckout,className:this.props.className||'',noIcon:true}))))))));}}]);return VerifyItemsCart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VerifyItemsCart.propTypes={sku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,goToCheckout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showModalItemsCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,verifyItemsCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (VerifyItemsCart);

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChangeContext__ = __webpack_require__(1431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ChangeContext__["a"]; });


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddCart_ButtonsPlaceholder__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_App_MainMenu_OnlyCash_actions__ = __webpack_require__(189);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeContext=function(_Component){_inherits(ChangeContext,_Component);function ChangeContext(props){_classCallCheck(this,ChangeContext);var _this=_possibleConstructorReturn(this,(ChangeContext.__proto__||Object.getPrototypeOf(ChangeContext)).call(this));_this.changeContext=function(){_this.props.changeContextRequest(!_this.props.onlyCash);_this.setState({onlyCash:!_this.props.onlyCash});setTimeout(function(){window.location.reload();},500);};_this.state={onlyCash:props.onlyCash};return _this;}_createClass(ChangeContext,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:!this.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AddCart_ButtonsPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-buttons row px-2 border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-12 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minDeviceWidth:767},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Button"],{id:'changeContext',name:'changeContext',className:'d-md-block d-none btn btn-featured btn-icon py-2',text:this.props.onlyCash?'Comprar com Pontos':'Comprar com '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'Cartão'),onClick:function onClick(){return _this2.changeContext();},iconName:'icon_cart',disabled:this.props.cart&&this.props.cart.isLoading?'disabled':'',loading:this.props.cart&&this.props.cart.isLoading})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{maxDeviceWidth:768},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Button"],{id:'changeContext',name:'changeContext',className:'d-md-none d-block btn btn-featured btn-icon py-2',text:this.props.onlyCash?'Comprar com Pontos':'Comprar com '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'Cartão'),onClick:function onClick(){return _this2.changeContext();},iconName:'icon_cart',disabled:this.props.cart&&this.props.cart.isLoading?'disabled':'',loading:this.props.cart&&this.props.cart.isLoading})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{maxDeviceWidth:420},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-1 py-2 row mx-0 d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Button"],{id:'changeContext',name:'changeContext',className:'btn btn-sm btn-featured nowrap',text:this.props.onlyCash?'Comprar com Pontos':'Comprar com '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'Cartão'),onClick:function onClick(){return _this2.changeContext();},disabled:this.props.cart&&this.props.cart.isLoading?'disabled':'',loading:this.props.cart&&this.props.cart.isLoading}))))));}}]);return ChangeContext;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChangeContext.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,cart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,changeContextRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref){var onlyCash=_ref.onlyCash;return{onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{changeContextRequest:function changeContextRequest(cash){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_App_MainMenu_OnlyCash_actions__["a" /* changeVisualizationContext */])(cash));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ChangeContext));

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_placeholder_lib_reactPlaceholder_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ButtonsPlaceholder=function(_Component){_inherits(ButtonsPlaceholder,_Component);function ButtonsPlaceholder(){_classCallCheck(this,ButtonsPlaceholder);return _possibleConstructorReturn(this,(ButtonsPlaceholder.__proto__||Object.getPrototypeOf(ButtonsPlaceholder)).apply(this,arguments));}_createClass(ButtonsPlaceholder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-buttons row px-2 border-color-ui-3 pb-3 mx-0 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-button col-6 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-4 pb-2 radius bg-ui-3 mb-1'})));}}]);return ButtonsPlaceholder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ButtonsPlaceholder);

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return Severity;
});
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export SpanStatus */
/** The status of an Span. */
var SpanStatus;
(function (SpanStatus) {
    /** The operation completed successfully. */
    SpanStatus["Ok"] = "ok";
    /** Deadline expired before operation could complete. */
    SpanStatus["DealineExceeded"] = "deadline_exceeded";
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
    SpanStatus["Unauthenticated"] = "unauthenticated";
    /** 403 Forbidden */
    SpanStatus["PermissionDenied"] = "permission_denied";
    /** 404 Not Found. Some requested entity (file or directory) was not found. */
    SpanStatus["NotFound"] = "not_found";
    /** 429 Too Many Requests */
    SpanStatus["ResourceExhausted"] = "resource_exhausted";
    /** Client specified an invalid argument. 4xx. */
    SpanStatus["InvalidArgument"] = "invalid_argument";
    /** 501 Not Implemented */
    SpanStatus["Unimplemented"] = "unimplemented";
    /** 503 Service Unavailable */
    SpanStatus["Unavailable"] = "unavailable";
    /** Other/generic 5xx. */
    SpanStatus["InternalError"] = "internal_error";
    /** Unknown. Any non-standard HTTP status code. */
    SpanStatus["UnknownError"] = "unknown_error";
    /** The operation was cancelled (typically by the user). */
    SpanStatus["Cancelled"] = "cancelled";
    /** Already exists (409) */
    SpanStatus["AlreadyExists"] = "already_exists";
    /** Operation was rejected because the system is not in a state required for the operation's */
    SpanStatus["FailedPrecondition"] = "failed_precondition";
    /** The operation was aborted, typically due to a concurrency issue. */
    SpanStatus["Aborted"] = "aborted";
    /** Operation was attempted past the valid range. */
    SpanStatus["OutOfRange"] = "out_of_range";
    /** Unrecoverable data loss or corruption */
    SpanStatus["DataLoss"] = "data_loss";
})(SpanStatus || (SpanStatus = {}));
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (SpanStatus) {
    /**
     * Converts a HTTP status code into a {@link SpanStatus}.
     *
     * @param httpStatus The HTTP response status code.
     * @returns The span status or {@link SpanStatus.UnknownError}.
     */
    // tslint:disable-next-line:completed-docs
    function fromHttpCode(httpStatus) {
        if (httpStatus < 400) {
            return SpanStatus.Ok;
        }
        if (httpStatus >= 400 && httpStatus < 500) {
            switch (httpStatus) {
                case 401:
                    return SpanStatus.Unauthenticated;
                case 403:
                    return SpanStatus.PermissionDenied;
                case 404:
                    return SpanStatus.NotFound;
                case 409:
                    return SpanStatus.AlreadyExists;
                case 413:
                    return SpanStatus.FailedPrecondition;
                case 429:
                    return SpanStatus.ResourceExhausted;
                default:
                    return SpanStatus.InvalidArgument;
            }
        }
        if (httpStatus >= 500 && httpStatus < 600) {
            switch (httpStatus) {
                case 501:
                    return SpanStatus.Unimplemented;
                case 503:
                    return SpanStatus.Unavailable;
                case 504:
                    return SpanStatus.DealineExceeded;
                default:
                    return SpanStatus.InternalError;
            }
        }
        return SpanStatus.UnknownError;
    }
    SpanStatus.fromHttpCode = fromHttpCode;
})(SpanStatus || (SpanStatus = {}));
//# sourceMappingURL=span.js.map

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return Status;
});
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["a"] = captureException;
/* harmony export (immutable) */__webpack_exports__["b"] = captureMessage;
/* unused harmony export captureEvent */
/* unused harmony export configureScope */
/* unused harmony export addBreadcrumb */
/* unused harmony export setContext */
/* unused harmony export setExtras */
/* unused harmony export setTags */
/* unused harmony export setExtra */
/* unused harmony export setTag */
/* unused harmony export setUser */
/* harmony export (immutable) */__webpack_exports__["c"] = withScope;
/* unused harmony export _callOnClient */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(160);

/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    } catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        originalException: exception,
        syntheticException: syntheticException
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, level) {
    var syntheticException;
    try {
        throw new Error(message);
    } catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureMessage', message, level, {
        originalException: message,
        syntheticException: syntheticException
    });
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normailzed.
 */
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normailzed.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](['_invokeClient', method], args));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return setPrototypeOf;
});
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */
function setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
'use strict';

/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        } else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return PromiseBuffer;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(298);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(580);

/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task.then(function () {
            return _this.remove(task);
        }).then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer).then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            }).then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}();

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["a"] = addInstrumentationHandler;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(127);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(299);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(161);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__object__ = __webpack_require__(578);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__supports__ = __webpack_require__(581);
/* tslint:disable:only-arrow-functions no-unsafe-any */

var global = Object(__WEBPACK_IMPORTED_MODULE_3__misc__["g" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    // tslint:disable-next-line:strict-type-predicates
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __values */](handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(__WEBPACK_IMPORTED_MODULE_3__misc__["f" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["c" /* supportsNativeFetch */])()) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var commonHandlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData));
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now(), error: error }));
                throw error;
            });
        };
    });
}
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) {
        fetchArgs = [];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) {
        fetchArgs = [];
    }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args[1];
            this.__sentry_xhr__ = {
                method: Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(url) && this.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                this.__sentry_own_request__ = true;
            }
            return originalOpen.apply(this, args);
        };
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this; // tslint:disable-line:no-this-assignment
            var commonHandlerData = {
                args: args,
                startTimestamp: Date.now(),
                xhr: xhr
            };
            triggerHandlers('xhr', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData));
            /**
             * @hidden
             */
            function onreadystatechangeHandler() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    } catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now() }));
                }
            }
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            } else {
                // if onreadystatechange wasn't actually set by the page on this xhr, we
                // are free to set our own and capture the breadcrumb
                xhr.onreadystatechange = onreadystatechangeHandler;
            }
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["b" /* supportsHistory */])()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'pushState', historyReplacementFunction);
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    ['EventTarget', 'Node'].forEach(function (target) {
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === 'click') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                    if (eventName === 'keypress') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                } else {
                    if (eventName === 'click') {
                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
                    }
                    if (eventName === 'keypress') {
                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
                    }
                }
                return original.call(this, eventName, fn, options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                } catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) {
        debounce = false;
    }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(function () {
                handler({ event: event, name: name });
            });
        } else {
            handler({ event: event, name: name });
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        } catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            domEventHandler('input', handler)(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
'use strict';

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return Dsn;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(298);

/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        } else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private _representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) {
            withPassword = false;
        }
        // tslint:disable-next-line:no-this-assignment
        var _a = this,
            host = _a.host,
            path = _a.path,
            pass = _a.pass,
            port = _a.port,
            projectId = _a.projectId,
            protocol = _a.protocol,
            user = _a.user;
        return protocol + "://" + user + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */](match.slice(1), 6),
            protocol = _a[0],
            user = _a[1],
            _b = _a[2],
            pass = _b === void 0 ? '' : _b,
            host = _a[3],
            _c = _a[4],
            port = _c === void 0 ? '' : _c,
            lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
            }
        });
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
    };
    return Dsn;
}();

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* WEBPACK VAR INJECTION */(function (module) {
    /* unused harmony export API_VERSION */
    /* unused harmony export Hub */
    /* unused harmony export getMainCarrier */
    /* unused harmony export makeMain */
    /* harmony export (immutable) */__webpack_exports__["a"] = getCurrentHub;
    /* unused harmony export getHubFromCarrier */
    /* unused harmony export setHubOnCarrier */
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);
    /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(576);

    /**
     * API compatibility version of this hub.
     *
     * WARNING: This number should only be incresed when the global interface
     * changes a and new methods are introduced.
     *
     * @hidden
     */
    var API_VERSION = 3;
    /**
     * Default maximum number of breadcrumbs added to an event. Can be overwritten
     * with {@link Options.maxBreadcrumbs}.
     */
    var DEFAULT_BREADCRUMBS = 30;
    /**
     * Absolute maximum number of breadcrumbs added to an event. The
     * `maxBreadcrumbs` option cannot be higher than this value.
     */
    var MAX_BREADCRUMBS = 100;
    /**
     * @inheritDoc
     */
    var Hub = /** @class */function () {
        /**
         * Creates a new instance of the hub, will push one {@link Layer} into the
         * internal stack on creation.
         *
         * @param client bound to the hub.
         * @param scope bound to the hub.
         * @param version number, higher number means higher priority.
         */
        function Hub(client, scope, _version) {
            if (scope === void 0) {
                scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */]();
            }
            if (_version === void 0) {
                _version = API_VERSION;
            }
            this._version = _version;
            /** Is a {@link Layer}[] containing the client and scope */
            this._stack = [];
            this._stack.push({ client: client, scope: scope });
        }
        /**
         * Internal helper function to call a method on the top client if it exists.
         *
         * @param method The method to call on the client.
         * @param args Arguments to pass to the client function.
         */
        Hub.prototype._invokeClient = function (method) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var top = this.getStackTop();
            if (top && top.client && top.client[method]) {
                (_a = top.client)[method].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args, [top.scope]));
            }
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.isOlderThan = function (version) {
            return this._version < version;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.bindClient = function (client) {
            var top = this.getStackTop();
            top.client = client;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.pushScope = function () {
            // We want to clone the content of prev scope
            var stack = this.getStack();
            var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
            var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(parentScope);
            this.getStack().push({
                client: this.getClient(),
                scope: scope
            });
            return scope;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.popScope = function () {
            return this.getStack().pop() !== undefined;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.withScope = function (callback) {
            var scope = this.pushScope();
            try {
                callback(scope);
            } finally {
                this.popScope();
            }
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.getClient = function () {
            return this.getStackTop().client;
        };
        /** Returns the scope of the top stack. */
        Hub.prototype.getScope = function () {
            return this.getStackTop().scope;
        };
        /** Returns the scope stack for domains or the process. */
        Hub.prototype.getStack = function () {
            return this._stack;
        };
        /** Returns the topmost scope layer in the order domain > local > process. */
        Hub.prototype.getStackTop = function () {
            return this._stack[this._stack.length - 1];
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.captureException = function (exception, hint) {
            var eventId = this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])();
            var finalHint = hint;
            // If there's no explicit hint provided, mimick the same thing that would happen
            // in the minimal itself to create a consistent behavior.
            // We don't do this in the client, as it's the lowest level API, and doing this,
            // would prevent user from having full control over direct calls.
            if (!hint) {
                var syntheticException = void 0;
                try {
                    throw new Error('Sentry syntheticException');
                } catch (exception) {
                    syntheticException = exception;
                }
                finalHint = {
                    originalException: exception,
                    syntheticException: syntheticException
                };
            }
            this._invokeClient('captureException', exception, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
            return eventId;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.captureMessage = function (message, level, hint) {
            var eventId = this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])();
            var finalHint = hint;
            // If there's no explicit hint provided, mimick the same thing that would happen
            // in the minimal itself to create a consistent behavior.
            // We don't do this in the client, as it's the lowest level API, and doing this,
            // would prevent user from having full control over direct calls.
            if (!hint) {
                var syntheticException = void 0;
                try {
                    throw new Error(message);
                } catch (exception) {
                    syntheticException = exception;
                }
                finalHint = {
                    originalException: message,
                    syntheticException: syntheticException
                };
            }
            this._invokeClient('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
            return eventId;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.captureEvent = function (event, hint) {
            var eventId = this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])();
            this._invokeClient('captureEvent', event, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, hint, { event_id: eventId }));
            return eventId;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.lastEventId = function () {
            return this._lastEventId;
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
            var top = this.getStackTop();
            if (!top.scope || !top.client) {
                return;
            }
            var _a = top.client.getOptions && top.client.getOptions() || {},
                _b = _a.beforeBreadcrumb,
                beforeBreadcrumb = _b === void 0 ? null : _b,
                _c = _a.maxBreadcrumbs,
                maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
            if (maxBreadcrumbs <= 0) {
                return;
            }
            var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* timestampWithMs */])();
            var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
            var finalBreadcrumb = beforeBreadcrumb ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["h" /* consoleSandbox */])(function () {
                return beforeBreadcrumb(mergedBreadcrumb, hint);
            }) : mergedBreadcrumb;
            if (finalBreadcrumb === null) {
                return;
            }
            top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.setUser = function (user) {
            var top = this.getStackTop();
            if (!top.scope) {
                return;
            }
            top.scope.setUser(user);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.setTags = function (tags) {
            var top = this.getStackTop();
            if (!top.scope) {
                return;
            }
            top.scope.setTags(tags);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.setExtras = function (extras) {
            var top = this.getStackTop();
            if (!top.scope) {
                return;
            }
            top.scope.setExtras(extras);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.setTag = function (key, value) {
            var top = this.getStackTop();
            if (!top.scope) {
                return;
            }
            top.scope.setTag(key, value);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.setExtra = function (key, extra) {
            var top = this.getStackTop();
            if (!top.scope) {
                return;
            }
            top.scope.setExtra(key, extra);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.setContext = function (name, context) {
            var top = this.getStackTop();
            if (!top.scope) {
                return;
            }
            top.scope.setContext(name, context);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.configureScope = function (callback) {
            var top = this.getStackTop();
            if (top.scope && top.client) {
                callback(top.scope);
            }
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.run = function (callback) {
            var oldHub = makeMain(this);
            try {
                callback(this);
            } finally {
                makeMain(oldHub);
            }
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.getIntegration = function (integration) {
            var client = this.getClient();
            if (!client) {
                return null;
            }
            try {
                return client.getIntegration(integration);
            } catch (_oO) {
                __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
                return null;
            }
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.startSpan = function (spanOrSpanContext, forceNoChild) {
            if (forceNoChild === void 0) {
                forceNoChild = false;
            }
            return this._callExtensionMethod('startSpan', spanOrSpanContext, forceNoChild);
        };
        /**
         * @inheritDoc
         */
        Hub.prototype.traceHeaders = function () {
            return this._callExtensionMethod('traceHeaders');
        };
        /**
         * Calls global extension method and binding current instance to the function call
         */
        // @ts-ignore
        Hub.prototype._callExtensionMethod = function (method) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var carrier = getMainCarrier();
            var sentry = carrier.__SENTRY__;
            // tslint:disable-next-line: strict-type-predicates
            if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
                return sentry.extensions[method].apply(this, args);
            }
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].warn("Extension method " + method + " couldn't be found, doing nothing.");
        };
        return Hub;
    }();

    /** Returns the global shim registry. */
    function getMainCarrier() {
        var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getGlobalObject */])();
        carrier.__SENTRY__ = carrier.__SENTRY__ || {
            extensions: {},
            hub: undefined
        };
        return carrier;
    }
    /**
     * Replaces the current main hub with the passed one on the global object
     *
     * @returns The old replaced hub
     */
    function makeMain(hub) {
        var registry = getMainCarrier();
        var oldHub = getHubFromCarrier(registry);
        setHubOnCarrier(registry, hub);
        return oldHub;
    }
    /**
     * Returns the default hub instance.
     *
     * If a hub is already registered in the global carrier but this module
     * contains a more recent version, it replaces the registered version.
     * Otherwise, the currently registered hub will be returned.
     */
    function getCurrentHub() {
        // Get main carrier (global for every environment)
        var registry = getMainCarrier();
        // If there's no hub, or its an old API, assign a new one
        if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
            setHubOnCarrier(registry, new Hub());
        }
        // Prefer domains over global if they are there (applicable only to Node environment)
        if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["x" /* isNodeEnv */])()) {
            return getHubFromActiveDomain(registry);
        }
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
    /**
     * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
     * @returns discovered hub
     */
    function getHubFromActiveDomain(registry) {
        try {
            // We need to use `dynamicRequire` because `require` on it's own will be optimized by webpack.
            // We do not want this to happen, we need to try to `require` the domain node module and fail if we are in browser
            // for example so we do not have to shim it and use `getCurrentHub` universally.
            var domain = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* dynamicRequire */])(module, 'domain');
            var activeDomain = domain.active;
            // If there no active domain, just return global hub
            if (!activeDomain) {
                return getHubFromCarrier(registry);
            }
            // If there's no hub on current domain, or its an old API, assign a new one
            if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
                var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
                setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
            }
            // Return hub that lives on a domain
            return getHubFromCarrier(activeDomain);
        } catch (_Oo) {
            // Return hub that lives on a global object
            return getHubFromCarrier(registry);
        }
    }
    /**
     * This will tell whether a carrier has a hub on it or not
     * @param carrier object
     */
    function hasHubOnCarrier(carrier) {
        if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
            return true;
        }
        return false;
    }
    /**
     * This will create a new {@link Hub} and add to the passed object on
     * __SENTRY__.hub.
     * @param carrier object
     * @hidden
     */
    function getHubFromCarrier(carrier) {
        if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
            return carrier.__SENTRY__.hub;
        }
        carrier.__SENTRY__ = carrier.__SENTRY__ || {};
        carrier.__SENTRY__.hub = new Hub();
        return carrier.__SENTRY__.hub;
    }
    /**
     * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
     * @param carrier object
     * @param hub Hub
     */
    function setHubOnCarrier(carrier, hub) {
        if (!carrier) {
            return false;
        }
        carrier.__SENTRY__ = carrier.__SENTRY__ || {};
        carrier.__SENTRY__.hub = hub;
        return true;
    }
    //# sourceMappingURL=hub.js.map
    /* WEBPACK VAR INJECTION */
}).call(__webpack_exports__, __webpack_require__(362)(module));

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return API;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(27);

var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns a string with auth headers in the url to the store endpoint. */
    API.prototype.getStoreEndpoint = function () {
        return "" + this._getBaseUrl() + this.getStoreEndpointPath();
    };
    /** Returns the store endpoint with auth added in url encoded. */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION
        };
        // Auth is intentionally sent as part of query string (NOT as custom HTTP header)
        // to avoid preflight CORS requests
        return this.getStoreEndpoint() + "?" + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["M" /* urlEncode */])(auth);
    };
    /** Returns the base path of the url including the port. */
    API.prototype._getBaseUrl = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port;
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /** Returns an object that can be used in request headers. */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_timestamp=" + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* timestampWithMs */])()); // TODO: This can be removed
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', ')
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) {
            dialogOptions = {};
        }
        var dsn = this._dsnObject;
        var endpoint = "" + this._getBaseUrl() + (dsn.path ? "/" + dsn.path : '') + "/api/embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            } else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}();

//# sourceMappingURL=api.js.map

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return BaseClient;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__integration__ = __webpack_require__(1448);

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* Dsn */](options.dsn);
        }
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_2__integration__["a" /* setupIntegrations */])(this._options);
        }
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend().eventFromException(exception, hint).then(function (event) {
            return _this._processEvent(event, hint, scope);
        }).then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        }).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["z" /* isPrimitive */])(message) ? this._getBackend().eventFromMessage("" + message, level, hint) : this._getBackend().eventFromException(message, hint);
        promisedEvent.then(function (event) {
            return _this._processEvent(event, hint, scope);
        }).then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        }).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope).then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        }).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend().getTransport().close(timeout).then(function (transportFlushed) {
                return status.ready && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegrations = function () {
        return this._integrations || {};
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true
                    });
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _a = this.getOptions(),
            environment = _a.environment,
            release = _a.release,
            dist = _a.dist,
            _b = _a.maxValueLength,
            maxValueLength = _b === void 0 ? 250 : _b;
        var prepared = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
        if (prepared.environment === undefined && environment !== undefined) {
            prepared.environment = environment;
        }
        if (prepared.release === undefined && release !== undefined) {
            prepared.release = release;
        }
        if (prepared.dist === undefined && dist !== undefined) {
            prepared.dist = dist;
        }
        if (prepared.message) {
            prepared.message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* truncate */])(prepared.message, maxValueLength);
        }
        var exception = prepared.exception && prepared.exception.values && prepared.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* truncate */])(exception.value, maxValueLength);
        }
        var request = prepared.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* truncate */])(request.url, maxValueLength);
        }
        if (prepared.event_id === undefined) {
            prepared.event_id = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])();
        }
        this._addIntegrations(prepared.sdk);
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (scope) {
            // In case we have a hub we reassign it.
            result = scope.applyToEvent(prepared, hint);
        }
        return result;
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._addIntegrations = function (sdkInfo) {
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(),
            beforeSend = _a.beforeSend,
            sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        if (typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint).then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                try {
                    var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                    if (isInternalException || !beforeSend) {
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                        return;
                    }
                    var beforeSendResult = beforeSend(prepared, hint);
                    // tslint:disable-next-line:strict-type-predicates
                    if (typeof beforeSendResult === 'undefined') {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* isThenable */])(beforeSendResult)) {
                        _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                    } else {
                        finalEvent = beforeSendResult;
                        if (finalEvent === null) {
                            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                            resolve(null);
                            return;
                        }
                        // From here on we are really async
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                    }
                } catch (exception) {
                    _this.captureException(exception, {
                        data: {
                            __sentry__: true
                        },
                        originalException: exception
                    });
                    reject('`beforeSend` threw an error, will not send event.');
                }
            }).then(null, function () {
                reject('`beforeSend` threw an error, will not send event.');
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend.then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._getBackend().sendEvent(processedEvent);
            resolve(processedEvent);
        }).then(null, function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}();

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */__webpack_exports__["a"] = setupIntegrations;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(160);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);

var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = options.defaultIntegrations && __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) {
            return i.name;
        });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 && pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    } else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    } else {
        integrations = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return BaseBackend;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(582);

/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["C" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["C" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    return BaseBackend;
}();

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (immutable) */__webpack_exports__["a"] = initAndBind;
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(160);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].enable();
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["b" /* getCurrentHub */])().bindClient(new clientClass(options));
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(1452);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "FunctionToString", function () {
  return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"];
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(1453);
/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "InboundFilters", function () {
  return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"];
});

//# sourceMappingURL=index.js.map

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return FunctionToString;
});
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry__ ? this.__sentry_original__ : this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return InboundFilters;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(160);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */function () {
    function InboundFilters(_options) {
        if (_options === void 0) {
            _options = {};
        }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
            return true;
        }
        if (this._isBlacklistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isWhitelistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (options === void 0) {
            options = {};
        }
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return event && event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].type === 'SentryError' || false;
        } catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (options === void 0) {
            options = {};
        }
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isMatchingPattern */])(message, pattern);
            });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isBlacklistedUrl = function (event, options) {
        if (options === void 0) {
            options = {};
        }
        // TODO: Use Glob instead?
        if (!options.blacklistUrls || !options.blacklistUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.blacklistUrls.some(function (pattern) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isMatchingPattern */])(url, pattern);
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isWhitelistedUrl = function (event, options) {
        if (options === void 0) {
            options = {};
        }
        // TODO: Use Glob instead?
        if (!options.whitelistUrls || !options.whitelistUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.whitelistUrls.some(function (pattern) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isMatchingPattern */])(url, pattern);
        });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) {
            clientOptions = {};
        }
        return {
            blacklistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._options.blacklistUrls || [], clientOptions.blacklistUrls || []),
            ignoreErrors: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._options.ignoreErrors || [], clientOptions.ignoreErrors || [], DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
            whitelistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._options.whitelistUrls || [], clientOptions.whitelistUrls || [])
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = event.exception.values && event.exception.values[0] || {},
                    _b = _a.type,
                    type = _b === void 0 ? '' : _b,
                    _c = _a.value,
                    value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            } catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return frames_1 && frames_1[frames_1.length - 1].filename || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return frames_2 && frames_2[frames_2.length - 1].filename || null;
            }
            return null;
        } catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return BrowserBackend;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(100);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(584);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(586);

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._options.transportOptions, { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["a" /* FetchTransport */](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["b" /* XHRTransport */](transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(exception, syntheticException, {
            attachStacktrace: this._options.attachStacktrace
        });
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            handled: true,
            type: 'generic'
        });
        event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(event);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) {
            level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info;
        }
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromString */])(message, syntheticException, {
            attachStacktrace: this._options.attachStacktrace
        });
        event.level = level;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(event);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]);

//# sourceMappingURL=backend.js.map

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return FetchTransport;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(100);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(301);

var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](FetchTransport, _super);
    function FetchTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429
            });
        }
        var defaultOptions = {
            body: JSON.stringify(event),
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* supportsReferrerPolicy */])() ? 'origin' : ''
        };
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            global.fetch(_this.url, defaultOptions).then(function (response) {
                var status = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(response.status);
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["F" /* parseRetryAfterHeader */])(now, response.headers.get('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(response);
            }).catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]);

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return XHRTransport;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(100);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(301);

/** `XHR` based transport */
var XHRTransport = /** @class */function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                var status = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(request.status);
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["F" /* parseRetryAfterHeader */])(now, request.getResponseHeader('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(request);
            };
            request.open('POST', _this.url);
            request.send(JSON.stringify(event));
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]);

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* unused harmony export defaultIntegrations */
/* harmony export (immutable) */__webpack_exports__["a"] = init;
/* unused harmony export showReportDialog */
/* unused harmony export lastEventId */
/* unused harmony export forceLoad */
/* unused harmony export onLoad */
/* unused harmony export flush */
/* unused harmony export close */
/* unused harmony export wrap */
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(583);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(302);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(588);

var defaultIntegrations = [new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].InboundFilters(), new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].FunctionToString(), new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](), new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](), new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](), new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](), new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"]()];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) {
        options = {};
    }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) {
        options = {};
    }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {}
// Noop

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function wrap(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* wrap */])(fn)(); // tslint:disable-line:no-unsafe-any
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return GlobalHandlers;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(100);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(584);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(302);

/** Global handlers */
var GlobalHandlers = /** @class */function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getGlobalObject */])();
        /** JSDoc */
        this._oldOnErrorHandler = null;
        /** JSDoc */
        this._oldOnUnhandledRejectionHandler = null;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        if (this._onErrorHandlerInstalled) {
            return;
        }
        var self = this; // tslint:disable-line:no-this-assignment
        this._oldOnErrorHandler = this._global.onerror;
        this._global.onerror = function (msg, url, line, column, error) {
            var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])();
            var hasIntegration = currentHub.getIntegration(GlobalHandlers);
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                if (self._oldOnErrorHandler) {
                    return self._oldOnErrorHandler.apply(this, arguments);
                }
                return true;
            }
            var client = currentHub.getClient();
            var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isPrimitive */])(error) ? self._eventFromIncompleteOnError(msg, url, line, column) : self._enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(error, undefined, {
                attachStacktrace: client && client.getOptions().attachStacktrace,
                rejection: false
            }), url, line, column);
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                handled: false,
                type: 'onerror'
            });
            currentHub.captureEvent(event, {
                originalException: error
            });
            if (self._oldOnErrorHandler) {
                return self._oldOnErrorHandler.apply(this, arguments);
            }
            return true;
        };
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        var self = this; // tslint:disable-line:no-this-assignment
        this._oldOnUnhandledRejectionHandler = this._global.onunhandledrejection;
        this._global.onunhandledrejection = function (e) {
            var error = e;
            try {
                error = e && 'reason' in e ? e.reason : e;
            } catch (_oO) {
                // no-empty
            }
            var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])();
            var hasIntegration = currentHub.getIntegration(GlobalHandlers);
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                if (self._oldOnUnhandledRejectionHandler) {
                    return self._oldOnUnhandledRejectionHandler.apply(this, arguments);
                }
                return true;
            }
            var client = currentHub.getClient();
            var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isPrimitive */])(error) ? self._eventFromIncompleteRejection(error) : Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(error, undefined, {
                attachStacktrace: client && client.getOptions().attachStacktrace,
                rejection: true
            });
            event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                handled: false,
                type: 'onunhandledrejection'
            });
            currentHub.captureEvent(event, {
                originalException: error
            });
            if (self._oldOnUnhandledRejectionHandler) {
                return self._oldOnUnhandledRejectionHandler.apply(this, arguments);
            }
            return true;
        };
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["t" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [{
                    type: name || 'Error',
                    value: message
                }]
            }
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (error) {
        return {
            exception: {
                values: [{
                    type: 'UnhandledRejection',
                    value: "Non-Error promise rejection captured with value: " + error
                }]
            }
        };
    };
    /** JSDoc */
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isString */])(url) && url.length > 0 ? url : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return TryCatch;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(302);

/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */function () {
    function TryCatch() {
        /** JSDoc */
        this._ignoreOnError = 0;
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
    }
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument'
                }
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapRAF = function (original) {
        return function (callback) {
            return original(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["n" /* getGlobalObject */])();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(fn),
                                    target: target
                                },
                                handled: true,
                                type: 'instrument'
                            }
                        });
                    }
                } catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                } catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this; // tslint:disable-line:no-this-assignment
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in _this && typeof _this[prop] === 'function') {
                    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(_this, prop, function (original) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(original, {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original)
                                },
                                handled: true,
                                type: 'instrument'
                            }
                        });
                    });
                }
            });
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: 'onreadystatechange',
                                handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original)
                            },
                            handled: true,
                            type: 'instrument'
                        }
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    if (original.__sentry_original__) {
                        wrapOptions.mechanism.data.handler = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original.__sentry_original__);
                    }
                    // Otherwise wrap directly
                    return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(original, wrapOptions);
                });
            }
            return originalSend.apply(this, args);
        };
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        this._ignoreOnError = this._ignoreOnError;
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["n" /* getGlobalObject */])();
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        if ('XMLHttpRequest' in global) {
            Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'].forEach(this._wrapEventTarget.bind(this));
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}();

//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return Breadcrumbs;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(100);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(27);

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Creates breadcrumbs from console API calls
     */
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                extra: {
                    arguments: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* normalize */])(handlerData.args, 3)
                },
                logger: 'console'
            },
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(handlerData.level),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* safeJoin */])(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.extra.arguments = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* normalize */])(handlerData.args.slice(1), 3);
            } else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* htmlTreeAsString */])(handlerData.event.target) : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* htmlTreeAsString */])(handlerData.event);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: event,
            name: handlerData.name
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: 'xhr',
                data: handlerData.xhr.__sentry_xhr__,
                type: 'http'
            }, {
                xhr: handlerData.xhr
            });
            return;
        }
        // We only capture issued sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            addSentryBreadcrumb(handlerData.args[0]);
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getClient();
        var dsn = client && client.getDsn();
        if (dsn) {
            var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getStoreEndpoint();
            // if Sentry key appears in URL, don't capture it as a request
            // but rather as our own 'sentry' type breadcrumb
            if (filterUrl && handlerData.fetchData.url.indexOf(filterUrl) !== -1 && handlerData.fetchData.method === 'POST' && handlerData.args[1] && handlerData.args[1].body) {
                addSentryBreadcrumb(handlerData.args[1].body);
                return;
            }
        }
        if (handlerData.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, handlerData.fetchData, { status_code: handlerData.response.status }),
                level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                type: 'http'
            }, {
                data: handlerData.error,
                input: handlerData.args
            });
        } else {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, handlerData.fetchData, { status_code: handlerData.response.status }),
                type: 'http'
            }, {
                input: handlerData.args,
                response: handlerData.response
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseUrl */])(global.location.href);
        var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseUrl */])(from);
        var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseUrl */])(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            // tslint:disable-next-line:no-parameter-reassignment
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            // tslint:disable-next-line:no-parameter-reassignment
            from = parsedFrom.relative;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function callback() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'console'
            });
        }
        if (this._options.dom) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function callback() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'dom'
            });
        }
        if (this._options.xhr) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function callback() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'xhr'
            });
        }
        if (this._options.fetch) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function callback() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'fetch'
            });
        }
        if (this._options.history) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function callback() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'history'
            });
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();

/**
 * Create a breadcrumb of `sentry` from the events themselves
 */
function addSentryBreadcrumb(serializedData) {
    // There's always something that can go wrong with deserialization...
    try {
        var event_1 = JSON.parse(serializedData);
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
            category: 'sentry',
            event_id: event_1.event_id,
            level: event_1.level || __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString('error'),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["l" /* getEventDescription */])(event_1)
        }, {
            event: event_1
        });
    } catch (_oO) {
        __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* logger */].error('Error while adding sentry type breadcrumb');
    }
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return LinkedErrors;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(585);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(300);

var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) {
            options = {};
        }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) {
            stack = [];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */]([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
"use strict";

/* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return UserAgent;
});
/* harmony import */var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(34);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(62);
/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(27);

var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                // Request Interface: https://docs.sentry.io/development/sdk-dev/event-payloads/request/
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}();

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'LIST_REGULATION_SUCCESS':{var index=''+(action.meta.previousAction.campaignId?action.meta.previousAction.campaignId:'-')+(action.meta.previousAction.catalogId?action.meta.previousAction.catalogId:'-')+(action.meta.previousAction.vendorId?action.meta.previousAction.vendorId:'-')+(action.meta.previousAction.regulationType?action.meta.previousAction.regulationType:'-');state[index]={result:action.payload.data};return state;}case'LIST_REGULATION_FAIL':{var _index=''+(action.meta.previousAction.campaignId?action.meta.previousAction.campaignId:'-')+(action.meta.previousAction.catalogId?action.meta.previousAction.catalogId:'-')+(action.meta.previousAction.vendorId?action.meta.previousAction.vendorId:'-')+(action.meta.previousAction.regulationType?action.meta.previousAction.regulationType:'-');state[_index]={result:null};return state;}default:return state||initialState;}});

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listRegulationsCampaign */
/* unused harmony export listRegulationsVendor */
/* unused harmony export listRegulationsVendorAndRegulationType */
var listRegulationsCampaign=function listRegulationsCampaign(campaignId,catalogId){return{type:'LIST_REGULATION',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/campaigns/regulations?campaignId='+campaignId+'&catalogId='+catalogId}},campaignId:campaignId,catalogId:catalogId};};var listRegulationsVendor=function listRegulationsVendor(campaignId,catalogId,vendorId){return{type:'LIST_REGULATION',payload:{client:'cloudloyalty',request:{method:'get',url:'/v2/campaigns/regulations/store?catalogId='+catalogId+'&vendorId='+vendorId}},catalogId:catalogId,vendorId:vendorId,campaignId:campaignId};};var listRegulationsVendorAndRegulationType=function listRegulationsVendorAndRegulationType(campaignId,catalogId,vendorId,regulationType){return{type:'LIST_REGULATION',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/configurations/regulations/vendor/'+vendorId+'/'+regulationType}},campaignId:campaignId,catalogId:catalogId,vendorId:vendorId,regulationType:regulationType};};/* harmony default export */ __webpack_exports__["a"] = ({listRegulationsCampaign:listRegulationsCampaign,listRegulationsVendor:listRegulationsVendor,listRegulationsVendorAndRegulationType:listRegulationsVendorAndRegulationType});

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Regulation__ = __webpack_require__(1466);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref,ownProps){var regulations=_ref.regulations,profile=_ref.oidc.user.profile;var catalogId=profile&&profile['custom:catalog_id'];var campaignId=profile&&profile['custom:campaign_id'];var index=''+(campaignId||'-')+(catalogId||'-')+(ownProps.vendorId?ownProps.vendorId:'-')+(ownProps.regulationType?ownProps.regulationType:'-');var regulationItem=regulations&&regulations[index];return{regulations:regulationItem&&regulationItem.result?regulationItem.result.map(function(regulation){return regulation.html;}):[],// loaded: regulationItem.loaded,
catalogId:catalogId,campaignId:campaignId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{listRegulationsCampaign:function listRegulationsCampaign(campaignId,catalogId){return catalogId&&campaignId&&dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].listRegulationsCampaign(campaignId,catalogId));},listRegulationsVendor:function listRegulationsVendor(campaignId,catalogId,vendorId){return vendorId&&catalogId&&campaignId&&dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].listRegulationsVendor(campaignId,catalogId,vendorId));},listRegulationsVendorAndRegulationType:function listRegulationsVendorAndRegulationType(campaignId,catalogId,vendorId,regulationType){return vendorId&&catalogId&&campaignId&&regulationType&&dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].listRegulationsVendorAndRegulationType(campaignId,catalogId,vendorId,regulationType));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Regulation__["a" /* default */]));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__print_css__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__print_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__print_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// eslint-disable-next-line no-unused-vars
var Regulation=function(_Component){_inherits(Regulation,_Component);function Regulation(props){_classCallCheck(this,Regulation);var _this=_possibleConstructorReturn(this,(Regulation.__proto__||Object.getPrototypeOf(Regulation)).call(this,props));_this.listRegulations=_this.listRegulations.bind(_this);if(!_this.props.regulations||_this.props.regulations.length<=0){_this.listRegulations();}return _this;}_createClass(Regulation,[{key:'listRegulations',value:function listRegulations(){if(this.props.vendorId!==undefined){if(this.props.regulationType!==undefined){this.props.listRegulationsVendorAndRegulationType(this.props.campaignId,this.props.catalogId,this.props.vendorId,this.props.regulationType);}else{this.props.listRegulationsVendor(this.props.campaignId,this.props.catalogId,this.props.vendorId);}}else{this.props.listRegulationsCampaign(this.props.campaignId,this.props.catalogId);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if((this.props.campaignId!==prevProps.campaignId||this.props.catalogId!==prevProps.catalogId||this.props.vendorId!==prevProps.vendorId||this.props.regulationType!==prevProps.regulationType)&&(!this.props.regulations||this.props.regulations.length<=0)){this.listRegulations();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.vendorId?'':'divPrint',role:'article'},this.props.regulations&&this.props.regulations.map(function(regulation){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:regulation}});}));}}]);return Regulation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Regulation.propTypes={regulations:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,campaignId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,catalogId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,listRegulationsVendor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,listRegulationsCampaign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,listRegulationsVendorAndRegulationType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,regulationType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Regulation);

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
var RegulationDefault=function RegulationDefault(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Regulamentos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 bg-white border-ui-3 radius-0 radius-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Regulamentos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 px-md-3 py-3',role:'article'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Regulamentos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'O cat\xE1logo de pr\xEAmios, dispon\xEDvel para acesso em',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',window.location.host),' ou por meio de redirecionamento diretamente do hotsite de Programas de Relacionamento, Campanhas de Incentivo e A\xE7\xF5es (\u201CPremmiar\u201D ou \u201CPlataforma\u201D), \xE9 uma plataforma online que permite a voc\xEA (doravante \u201CUsu\xE1rio\u201D), participante de determinada campanha de incentivo, desenvolvida por um gestor de campanhas, contratante da Premmiar (\u201CGestor\u201D), trocar seus pontos adquiridos em tal campanha por produtos ou servi\xE7os disponibilizados por nossas empresas parceiras (\u201CParceiros\u201D), indicadas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Dessa forma, os presentes Termos de Uso (\u201CTermos\u201D) estipulam as regras para utiliza\xE7\xE3o da Plataforma pelos Usu\xE1rios, e est\xE3o dispon\xEDveis para acesso, a qualquer momento, por meio do link',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/terms',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/terms')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Aplicam-se aos presentes Termos, ainda, o quanto disposto na Pol\xEDtica de Privacidade, dispon\xEDvel para acesso em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/privacy',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/privacy')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Em caso de quaisquer d\xFAvidas sobre o quanto disposto nestes Termos, o Usu\xE1rio dever\xE1 entrar em contato com a Premmiar por meio da p\xE1gina \u201CFale Conosco\u201D, dispon\xEDvel em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/redirect/contact',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/redirect/contact')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1. ACEITA\xC7\xC3O DESTES TERMOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.1. O aceite livre, expresso e informado aos presentes Termos se dar\xE1 no momento do clique do Usu\xE1rio no bot\xE3o \u201CAceito\u201D, quando de seu primeiro acesso \xE0 Plataforma, estando a utiliza\xE7\xE3o condicionada \xE0 integral aceita\xE7\xE3o do quanto disposto no presente documento, sendo certo que, caso o Usu\xE1rio n\xE3o concorde com o quanto aqui estipulado, dever\xE1 se abster de utilizar o site.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.2. Exceto em caso de expressa previs\xE3o legal em sentido contr\xE1rio, os presentes Termos poder\xE3o ser atualizados ou modificados a qualquer momento, a exclusivo crit\xE9rio da Premmiar, independentemente de qualquer formalidade e comunica\xE7\xE3o, cabendo ao Usu\xE1rio verificar novamente o conte\xFAdo destes Termos a cada modifica\xE7\xE3o, conforme data de atualiza\xE7\xE3o constante ao final deste documento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.3. A continuidade de utiliza\xE7\xE3o da Plataforma pelo Usu\xE1rio implicar\xE1 a irrestrita aceita\xE7\xE3o das condi\xE7\xF5es fixadas, incluindo as altera\xE7\xF5es que porventura venham a ser realizadas em referidas condi\xE7\xF5es.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2. ACESSO \xC0 PLATAFORMA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.1. O acesso \xE0 Plataforma se dar\xE1 mediante login e senha de acesso, ap\xF3s o cadastro do Usu\xE1rio no sistema.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.2. Em algumas campanhas, o acesso poder\xE1 depender de valida\xE7\xE3o positiva do cadastro do Usu\xE1rio, por meio da confer\xEAncia das informa\xE7\xF5es fornecidas pelo Gestor, tais como CPF e data de nascimento, entre outras.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.3. \xC9 poss\xEDvel, ainda, que o acesso do Usu\xE1rio \xE0 Plataforma se d\xEA por meio de hotsite, desenvolvido pelo Gestor da campanha. Nesta hip\xF3tese, o Usu\xE1rio deve se atentar tamb\xE9m para eventuais Termos de Servi\xE7o adicionais constantes de referida p\xE1gina, mantida pelo Gestor.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4. Poder\xE3o se registrar e utilizar a Plataforma Usu\xE1rios plenamente capazes, nos termos da legisla\xE7\xE3o brasileira. Dessa forma, menores de 18 (dezoito) anos de idade, exceto os emancipados, nos termos do par\xE1grafo \xFAnico do artigo 5\xBA do C\xF3digo Civil Brasileiro, n\xE3o poder\xE3o utilizar a Plataforma, sendo vedado seu cadastro como Usu\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.5. Em qualquer hip\xF3tese, o Usu\xE1rio se compromete a fornecer todas as informa\xE7\xF5es obrigat\xF3rias solicitadas quando de seu cadastro, de forma correta e verdadeira, responsabilizando-se por qualquer informa\xE7\xE3o incorreta ou inver\xEDdica inserida na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.6. Uma vez que o acesso \xE0 Plataforma \xE9 destinado apenas a participantes das campanhas desenvolvidas pelos Gestores, a Premmiar se reserva o direito de negar o acesso de quaisquer Usu\xE1rios n\xE3o vinculados a nenhuma campanha ou, a qualquer momento, excluir o acesso de tais Usu\xE1rios.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.7. Ap\xF3s o cadastro, o Usu\xE1rio ter\xE1 acesso a quantidade pontos que possui, bem como ao cat\xE1logo de produtos e servi\xE7os dos Parceiros da Premmiar (\u201CCat\xE1logo\u201D).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3. UTILIZA\xC7\xC3O DA PLATAFORMA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.1. Ao utilizar a Plataforma, o Usu\xE1rio declara e reconhece que:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2. Est\xE1 devidamente autorizado pelo Gestor da campanha a preencher seu cadastro, acessar a Plataforma e realizar a troca de pontos por produtos ou servi\xE7os dos Parceiros;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.3. Dever\xE1 manter sempre seu cadastro devidamente atualizado, especialmente seu endere\xE7o e informa\xE7\xF5es de contato;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.4. N\xE3o poder\xE1 inserir ou produzir na Plataforma, por qualquer meio, conte\xFAdo il\xEDcito, que viole direitos de terceiros ou que seja de qualquer modo contr\xE1rio \xE0 moral e aos bons costumes geralmente aceitos;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.5. \xC9 vedada a inser\xE7\xE3o na Plataforma de conte\xFAdo que incorpore v\xEDrus ou outros elementos f\xEDsicos ou eletr\xF4nicos que possam causar danos ou impedir o normal funcionamento da rede, do sistema ou de equipamentos inform\xE1ticos, da Premmiar, ou de terceiros; e'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.6. \xC9 vedada a inser\xE7\xE3o na Plataforma de conte\xFAdo que provoque, por suas caracter\xEDsticas (tais como forma, extens\xE3o etc.), dificuldades no normal funcionamento da Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.7. O Usu\xE1rio se compromete a utilizar a Plataforma e o seu conte\xFAdo, ou seja, os textos, imagens, fotografias, gr\xE1ficos, \xEDcones, tecnologia, links e demais conte\xFAdos audiovisuais ou sonoros, incluindo o software da Plataforma, desenhos gr\xE1ficos e c\xF3digos fonte (em conjunto, \u201CConte\xFAdo(s)\u201D), de acordo com todo o ordenamento jur\xEDdico, com a moral e os bons costumes geralmente aceitos, os presentes Termos e eventuais instru\xE7\xF5es adicionais existentes na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.8. O Usu\xE1rio dever\xE1 se abster de obter, ou de tentar obter, os Conte\xFAdos por quaisquer meios distintos daqueles que, em cada caso, tenham sido colocados \xE0 disposi\xE7\xE3o para tais prop\xF3sitos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.9. Em qualquer circunst\xE2ncia, o Usu\xE1rio ser\xE1 o \xFAnico respons\xE1vel pelo uso que fizer da Plataforma, eximindo a Premmiar e qualquer responsabilidade por eventuais danos ou preju\xEDzos decorrentes do uso indevido ou inadequado que o Usu\xE1rio fizer da Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4. AQUISI\xC7\xC3O E TROCA DE PONTOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.1. Os pontos ser\xE3o atribu\xEDdos ao Usu\xE1rio pelo Gestor da campanha, de acordo com os crit\xE9rios estabelecidos pelo Gestor. A Premmiar apenas disponibilizar\xE1 na conta do Usu\xE1rio os respectivos e eventuais pontos indicados pelo Gestor, sem qualquer inger\xEAncia e responsabilidade da Premmiar na atribui\xE7\xE3o dos pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.2. Dessa forma, a Premmiar n\xE3o ser\xE1 respons\xE1vel, em hip\xF3tese alguma, por eventuais diverg\xEAncias entre as regras da campanha, estipuladas pelo Gestor, e a quantidade de pontos atribu\xEDda ao Usu\xE1rio, sendo a responsabilidade por tal atribui\xE7\xE3o exclusiva do Gestor da campanha.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.3. Caso o Usu\xE1rio n\xE3o possua saldo de pontos suficiente para realizar o resgate do produto ou servi\xE7o desejado, incluindo o valor do frete, este poder\xE1, em determinadas situa\xE7\xF5es, adquirir pontos diretamente da Premmiar, apenas e t\xE3o somente para a finalidade de completar a quantidade de pontos necess\xE1ria para o resgate de um determinado produto ou servi\xE7o. A aquisi\xE7\xE3o dos pontos ser\xE1 realizada com cart\xE3o de cr\xE9dito ou outro meio de pagamento disponibilizado na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.4. Para que reste autorizada a compra de pontos, o Usu\xE1rio dever\xE1 possuir ao menos parte do valor do produto ou servi\xE7o que deseje adquirirem pontos. N\xE3o \xE9 poss\xEDvel a compra de pontos desvinculada da aquisi\xE7\xE3o de um produto ou servi\xE7o, nem a compra de produtos diretamente dos Parceiros, sem a utiliza\xE7\xE3o de pontos. O Parceiro poder\xE1 exigir que o participante tenha um n\xFAmero m\xEDnimo de pontos para habilitar a fun\xE7\xE3o \u201Ccompra de pontos\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.5. A compra de pontos estar\xE1 dispon\xEDvel apenas para alguns Parceiros do cat\xE1logo de pr\xEAmios, de acordo com as condi\xE7\xF5es acordadas entre estes e a Premmiar. Caso seja poss\xEDvel a compra, o \xEDcone \u201Ccompra de pontos\u201D aparecer\xE1 como dispon\xEDvel ao Usu\xE1rio. Assim, o Usu\xE1rio reconhece que, caso tal \xEDcone n\xE3o seja disponibilizado, n\xE3o poder\xE1 haver a compra de pontos para a aquisi\xE7\xE3o do produto ou servi\xE7o em quest\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6. A venda de pontos \xE9 realizada exclusivamente pela Premmiar, sem qualquer interven\xE7\xE3o do Gestor da Campanha. O pre\xE7o do ponto vendido no cat\xE1logo de pr\xEAmios ser\xE1 aquele divulgado ao Usu\xE1rio no momento da compra.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.7. N\xE3o h\xE1 correla\xE7\xE3o monet\xE1ria entre os pontos adquiridos pelos Usu\xE1rios e aqueles que s\xE3o concedidos pelos Gestores das Campanhas. Assim, a Premmiar n\xE3o se compromete a respeitar qualquer equival\xEAncia entre pontos e valores monet\xE1rios eventualmente indicada pelo Gestor, sendo certo que os pontos fornecidos aos Usu\xE1rios pelos Gestores das Campanhas n\xE3o possuem valor monet\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.8. O Usu\xE1rio poder\xE1 trocar os pontos a ele atribu\xEDdos por quaisquer produtos ou servi\xE7os oferecidos por Parceiros, disponibilizados no Cat\xE1logo, acess\xEDvel por meio de sua conta de acesso.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.9. O Usu\xE1rio entende e reconhece que a troca de pontos poder\xE1 ser restrita a produtos ou servi\xE7os de apenas alguns dos Parceiros indicados na Plataforma, a exclusivo crit\xE9rio do Gestor da Campanha. Assim, a Premmiar n\xE3o se responsabiliza por produtos ou servi\xE7os de Parceiros que n\xE3o estejam dispon\xEDveis no Cat\xE1logo apresentado ao Usu\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.10. Os pontos disponibilizados ao Usu\xE1rio poder\xE3o estar sujeitos a prazo de validade, determinado pelo Gestor da campanha \xE0 qual tais pontos est\xE3o vinculados. Ainda, todos os pontos relacionados a determinada campanha expirar\xE3o, em caso de t\xE9rmino do contrato entre o Gestor e a Premmiar. \xC9 de responsabilidade exclusiva do Usu\xE1rio utilizar seus pontos, antes da expira\xE7\xE3o do prazo, n\xE3o se responsabilizando a Premmiar, em hip\xF3tese alguma, caso o Usu\xE1rio n\xE3o os utilize, dentro do prazo m\xE1ximo estipulado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.11. Em hip\xF3tese alguma os pontos obtidos pelos Usu\xE1rios poder\xE3o ser convertidos em ',Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro',' ou trocados por quaisquer produtos ou servi\xE7os n\xE3o constantes no Cat\xE1logo disponibilizado ao Usu\xE1rio quando de seu acesso.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.12. A troca dos pontos pelos produtos ou servi\xE7os constantes no Cat\xE1logo disponibilizado ao Usu\xE1rio est\xE1 sujeita \xE0 disponibilidade. A opera\xE7\xE3o de troca por alguns produtos ou servi\xE7os poder\xE1 n\xE3o ser conclu\xEDda, em raz\xE3o de sua indisponibilidade. A troca somente ser\xE1 tida como completa, ap\xF3s o Usu\xE1rio finalizar a transa\xE7\xE3o pela Plataforma e receber e-mail com tal confirma\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.13. A disponibilidade dos produtos ou servi\xE7os depende exclusivamente dos Parceiros que os fornecem, n\xE3o se responsabilizando a Premmiar por quaisquer produtos constantes do Cat\xE1logo n\xE3o disponibilizados pelos Parceiros.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.14. O Cat\xE1logo de pr\xEAmios \xE9 atualizado peri\xF3dica e automaticamente pelos Parceiros e os produtos e pontos necess\xE1rios para troca poder\xE3o sofrer altera\xE7\xF5es durante a navega\xE7\xE3o dos Usu\xE1rios, sem aviso pr\xE9vio, devendo ser consultados pelo interessado no momento da conclus\xE3o efetiva do resgate/troca dos pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.15. N\xE3o h\xE1 correla\xE7\xE3o direta entre os pre\xE7os divulgados em pontos no cat\xE1logo de pr\xEAmios e os valores indicados pelos Parceiros em seus sites direcionados aos consumidores finais, na medida em que os pontos fornecidos pelo Gestor ao Usu\xE1rio n\xE3o possuem valor monet\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.16. Para utiliza\xE7\xE3o dos Pontos em determinados Parceiros, a Premmiar poder\xE1 debitar da conta de premia\xE7\xE3o dos Usu\xE1rios uma taxa administrativa. A taxa administrativa padr\xE3o para resgate de vouchers \xE9 de 5,9% (cinco v\xEDrgula nove por cento) sobre o valor nominal do resgate, taxa administrativa da qual o Usu\xE1rio declara desde logo ter plena ci\xEAncia. A taxa administrativa para resgate nos demais Parceiros pode variar de acordo com os custos operacionais e administrativos decorrentes do resgate realizado. O pre\xE7o final do produto em pontos ser\xE1 aquele informado ao Usu\xE1rio no momento da finaliza\xE7\xE3o do resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.17. A Plataforma poder\xE1 sugerir produtos e servi\xE7os para resgate pelos Usu\xE1rios de acordo com o seu perfil de consumo, observando inclusive a suas prefer\xEAncias de navega\xE7\xE3o no cat\xE1logo de pr\xEAmios, como detalhado na Pol\xEDtica de Privacidade relacionada a estes Termos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.18. Caso os pontos do Usu\xE1rios estejam com prazo de expira\xE7\xE3o pr\xF3ximo, a Premmiar ou o Gestor poder\xE3o, em determinadas situa\xE7\xF5es, realizar a\xE7\xF5es promocionais com resgate autom\xE1tico de pontos para determinados parceiros, visando que o Usu\xE1rio n\xE3o seja prejudicado com a expira\xE7\xE3o dos pontos. Nestas situa\xE7\xF5es, o realizador da a\xE7\xE3o promocional enviar\xE1 um SMS ao Usu\xE1rio, indicando que realizar\xE1 o resgate autom\xE1tico dos pontos a vencer, formalizando para qual dos Parceiros os pontos a expirar seriam transferidos e concedendo ao Usu\xE1rio a possibilidade de optar pela sua n\xE3o realiza\xE7\xE3o. O Usu\xE1rio reconhece que n\xE3o h\xE1 obrigatoriedade na realiza\xE7\xE3o do resgate autom\xE1tico, seja pela Premmiar ou pelo Gestor, sendo tal medida excepcional.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.19. O Usu\xE1rio poder\xE1 realizar a busca inteligente de produtos e servi\xE7os por meio do filtro dispon\xEDvel por categoria, marcas ou saldo de pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5. ENTREGA DE PRODUTOS OU SERVI\xC7OS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1. A Premmiar atua apenas como cat\xE1logo online, intermediador entre o Usu\xE1rio e os Parceiros, que inserem diretamente seus produtos e/ou servi\xE7os na Plataforma, n\xE3o comercializando, a Premmiar, quaisquer produtos ou servi\xE7os, nem mantendo produtos em estoque.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.2. Desta forma, a entrega dos produtos ou a presta\xE7\xE3o dos servi\xE7os selecionados pelo Usu\xE1rio \xE9 de exclusiva responsabilidade do respectivo Parceiro, n\xE3o se responsabilizando a Premmiar por quaisquer atrasos ou falhas na entrega dos produtos ou na presta\xE7\xE3o dos servi\xE7os.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.3. Eventualmente a Premmiar poder\xE1 adquirir vouchers de Parceiros e comercializ\xE1-los na Plataforma, realizando diretamente a entrega deles aos Usu\xE1rios, hip\xF3tese em que o Usu\xE1rio ser\xE1 informado de que tais vouchers s\xE3o entregues pela Premmiar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.4. \xC9 de responsabilidade exclusiva do Usu\xE1rio manter seus dados cadastrais atualizados, eximindo a Premmiar e seus Parceiros de qualquer responsabilidade em rela\xE7\xE3o \xE0 entrega de produtos decorrentes de informa\xE7\xF5es desatualizadas inseridas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.5. Caso o Usu\xE1rio opte por resgatar mais de um produto do cat\xE1logo de pr\xEAmios, ainda que em Parceiros diferentes, o fechamento do resgate poder\xE1 ser finalizado no mesmo pedido, em um carrinho \xFAnico. Os fretes e prazos de entrega, todavia, ser\xE3o calculados por cada um dos Parceiros e ser\xE3o inclu\xEDdos individualmente no pedido. Assim, pedidos contendo mais de um produto poder\xE3o possuir datas de entrega diferentes, de acordo com o estipulado pelo Parceiro respons\xE1vel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.6. A fun\xE7\xE3o de finaliza\xE7\xE3o \xFAnica de resgate n\xE3o estar\xE1 dispon\xEDvel para todos os pedidos, pois depender\xE1 da disponibilidade t\xE9cnica de cada um dos Parceiros.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.7. O cancelamento do pedido de um \xFAnico produto inclu\xEDdo no carrinho n\xE3o implicar\xE1 cancelamento dos demais produtos ou servi\xE7os resgatados no mesmo pedido.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.8. Ser\xE1 disponibilizado ao Usu\xE1rio, por meio do acesso ao \xEDcone \u201CMeus Pedidos\u201D, o acompanhamento do status da entrega dos produtos resgatados, de acordo com as informa\xE7\xF5es disponibilizadas por cada Parceiro, informa\xE7\xF5es que tamb\xE9m poder\xE3o ser enviadas aos Usu\xE1rios por e-mail ou SMS.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.9. Caso a entrega do produto n\xE3o possa ser realizada em raz\xE3o de diverg\xEAncia no endere\xE7o de entrega informado pelo Usu\xE1rio, o resgate poder\xE1 ser cancelado pelo Parceiro, sendo os pontos respectivos creditados novamente na conta do Usu\xE1rio, respeitado o prazo de validade original dos pontos para que o Usu\xE1rio possa realizar novo resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.10. Nos cancelamentos de Pedidos em que o Usu\xE1rio tenha adquirido pontos para realizar o resgate, estes pontos adquiridos ser\xE3o creditados na sua conta de premia\xE7\xE3o para posterior utiliza\xE7\xE3o, em novo resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.11. Caso o Usu\xE1rio tenha solicitado cancelamento do pedido, em raz\xE3o do atraso na entrega ou por outros motivos aplic\xE1veis e o produto tenha sido efetivamente entregue no endere\xE7o por ele indicado, a Premmiar estar\xE1 autorizado a debitar os pontos referentes ao produto recebido da conta de premia\xE7\xE3o do Usu\xE1rio. Para que n\xE3o haja o d\xE9bito de pontos o Usu\xE1rio dever\xE1 recusar o recebimento do pedido que pretendia ver cancelado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.12. \xC9 de responsabilidade exclusiva do Usu\xE1rio manter seus dados cadastrais atualizados, eximindo a Premmiar e seus Parceiros de qualquer responsabilidade relacionada \xE0 entrega equivocada de produtos decorrentes de informa\xE7\xF5es desatualizadas inseridas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'6. DURA\xC7\xC3O E FINALIZA\xC7\xC3O DO ACESSO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'6.1. O acesso \xE0 Plataforma \xE9 concedido ao Usu\xE1rio por prazo indeterminado. No entanto, a Premmiar est\xE1 facultado a dar por terminado, suspender ou interromper unilateralmente, a qualquer momento e sem necessidade de pr\xE9vio aviso, o acesso do Usu\xE1rio, sem que qualquer indeniza\xE7\xE3o seja devia em raz\xE3o disso.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'7. ISEN\xC7\xC3O DE RESPONSABILIDADE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'7.1. Al\xE9m das demais hip\xF3teses de isen\xE7\xE3o de responsabilidade previstas neste documento, a Premmiar n\xE3o se responsabilizar\xE1:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2 pl-1'},'1. Por quaisquer danos decorrentes da interrup\xE7\xE3o do acesso \xE0 Plataforma, ou por falhas de funcionamento;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2. Pela defrauda\xE7\xE3o da utilidade que os Usu\xE1rios possam ter atribu\xEDdo \xE0 Plataforma, pela falibilidade da mesma, ou por qualquer dificuldade de acesso;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3. Pela exist\xEAncia de quaisquer elementos nocivos que possam produzir altera\xE7\xF5es nos sistemas inform\xE1ticos dos Usu\xE1rios (software e/ou hardware) ou nos documentos eletr\xF4nicos armazenados no sistema inform\xE1tico;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4. Por quaisquer hyperlinks disponibilizados na Plataforma, sendo certo que n\xE3o h\xE1 verifica\xE7\xE3o pr\xE9via do conte\xFAdo de qualquer hyperlink disponibilizado na Plataforma e que as p\xE1ginas por meio deles acessadas est\xE3o sujeitas a outros Termos de Uso e Pol\xEDticas de Privacidade;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5. Pelos danos e preju\xEDzos de toda natureza que possam decorrer do conhecimento que terceiros n\xE3o autorizados possam ter de quaisquer das informa\xE7\xF5es fornecidas pelo Usu\xE1rio, em decorr\xEAncia de falha exclusivamente atribu\xEDvel ao Usu\xE1rio; e',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'6. Por falhas ou informa\xE7\xF5es recebidas de modo incompleto pela Premmiar ou seus Parceiros, que dificultem ou impe\xE7am a troca de pontos por produtos ou servi\xE7os;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'7. Por produtos ou servi\xE7os disponibilizados na Plataforma pelos Parceiros, devendo qualquer eventual defeito em referidos produtos ou servi\xE7os ser comunicado diretamente ao Parceiro respons\xE1vel, por meio das informa\xE7\xF5es de contato por ele indicadas, para ado\xE7\xE3o das respectivas provid\xEAncias.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'7.2. A Premmiar poder\xE1, a seu exclusivo crit\xE9rio e sem anu\xEAncia ou concord\xE2ncia do Usu\xE1rio, alterar os servi\xE7os prestados, adicionando ou excluindo Parceiros, produtos e servi\xE7os, bem como a pontua\xE7\xE3o necess\xE1ria para a troca de determinados produtos ou servi\xE7os, sem que qualquer valor ou indeniza\xE7\xE3o seja devido ao Usu\xE1rio, em raz\xE3o de tais altera\xE7\xF5es.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'8. PROPRIEDADE INTELECTUAL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.1 Todos os direitos de propriedade intelectual referentes a qualquer material disponibilizado na Plataforma, tais como textos, marcas, logos, fotografias, gr\xE1ficos, imagens, links, conte\xFAdos audiovisuais ou sonoros, software, desenhos gr\xE1ficos e c\xF3digos fontes, entre outros, s\xE3o de titularidade da Premmiar ou de terceiros que autorizaram seu uso, sendo vedada sua c\xF3pia, reprodu\xE7\xE3o, ou qualquer outro tipo de utiliza\xE7\xE3o, ficando os infratores sujeitos \xE0s san\xE7\xF5es civis e criminais correspondentes, nos termos das Leis 9.610/98, 9.609/98 e 9.279/96.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.2 Todas as marcas, os nomes comerciais ou logotipos de qualquer esp\xE9cie disponibilizados na Plataforma s\xE3o de propriedade da Premmiar ou de terceiros que autorizaram seu uso, sem que o acesso ao ou utiliza\xE7\xE3o da Plataforma possa ser entendida como autoriza\xE7\xE3o para que o Usu\xE1rio possa citar tais marcas, nomes comerciais e logotipos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'9. DISPOSI\xC7\xD5ES GERAIS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'9.1 Se qualquer parte destes Termos for considerada inv\xE1lida ou inexequ\xEDvel, essa parte deve ser interpretada de forma consistente com a lei aplic\xE1vel, para refletir, na medida do poss\xEDvel, a inten\xE7\xE3o original das partes, e as demais disposi\xE7\xF5es permanecer\xE3o em pleno vigor e efeito.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'9.2 A falha da Premmiar em exigir quaisquer direitos ou disposi\xE7\xF5es dos presentes Termos n\xE3o constituir\xE1 ren\xFAncia, podendo exercer regularmente o seu direito, dentro dos prazos legais.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10. CONTATO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'10.1 O Usu\xE1rio poder\xE1 entrar em contato com a Premmiar por meio do formul\xE1rio disponibilizado na p\xE1gina Fale Conosco, dispon\xEDvel para acesso em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/redirect/contact',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/redirect/contact')),', bem como por meio do endere\xE7o de e-mail ou telefone divulgados na comunica\xE7\xE3o da campanha.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'10.2 A Premmiar poder\xE1 entrar em contato com o Usu\xE1rio, e esta comunica\xE7\xE3o ser\xE1 considerada v\xE1lida, por meio de qualquer informa\xE7\xE3o de contato por ele disponibilizada quando do preenchimento de seu cadastro. Os comunicados emitidos por meio da Plataforma tamb\xE9m ser\xE3o considerados v\xE1lidos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'10.3 A Premmiar poder\xE1 implementar mecanismos antifraude na Plataforma, inclusive realizando contato junto ao Usu\xE1rio para confirma\xE7\xE3o do pedido, por meio de liga\xE7\xE3o, SMS, e-mail ou qualquer outro programa de mensagens pela internet.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'11. LEI APLIC\xC1VEL E FORO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'11.1 Estes Termos ser\xE3o regidos, interpretados e executados de acordo com as leis da Rep\xFAblica Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados ou pa\xEDses, sendo competente o Foro da Comarca de S\xE3o Paulo, Capital, no Brasil, para dirimir qualquer d\xFAvida decorrente deste instrumento. O Usu\xE1rio consente, expressamente, com a compet\xEAncia desse ju\xEDzo, e renuncia, neste ato, \xE0 compet\xEAncia de qualquer outro foro, por mais privilegiado que seja ou venha a ser.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'\xDAltima atualiza\xE7\xE3o: 04.05.2017')))))))));};/* harmony default export */ __webpack_exports__["a"] = (RegulationDefault);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
var RegulationIupp=function RegulationIupp(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Regulamentos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 py-3 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["RegulationIuppComponent"],null)))))));};/* harmony default export */ __webpack_exports__["a"] = (RegulationIupp);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegulationAvonComponent=function(_Component){_inherits(RegulationAvonComponent,_Component);function RegulationAvonComponent(){_classCallCheck(this,RegulationAvonComponent);return _possibleConstructorReturn(this,(RegulationAvonComponent.__proto__||Object.getPrototypeOf(RegulationAvonComponent)).apply(this,arguments));}_createClass(RegulationAvonComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Regulamentos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 py-3 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 bg-white border-ui-3 radius-0 radius-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'REGULAMENTO MEU MUNDO AVON'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 px-md-3 py-3',role:'article'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1. DISPOSI\xC7\xD5ES GERAIS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.1 As presentes disposi\xE7\xF5es regulam o programa de incentivo na modalidade de pontos, denominado \u201CMeu Mundo Avon\u201D (\u201CPrograma\u201D), por meio do qual s\xE3o atribu\xEDdos pontos (\u201CPontos\u201D) \xE0s Revendedoras Avon e Revendedoras participantes do Programa Executiva de Vendas Avon (\u201CRevendedoras\u201D), a partir de sua ades\xE3o ao Programa, podendo referidos Pontos serem convertidos nos pr\xEAmios e servi\xE7os dispon\xEDveis no cat\xE1logo Meu Mundo Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.2 O Programa \xE9 administrado pela AVON COSM\xC9TICOS LTDA., pessoa jur\xEDdica de direito privado, com sede na Avenida Interlagos, n\xB0 4300, Pr\xE9dio Administrativo, 1\xBA e 2\xBA andares, no munic\xEDpio de S\xE3o Paulo, SP, inscrita no CNPJ/MF sob n\xBA 56.991.441/0001-57 (\u201CAvon\u201D), em parceria com fornecedores de bens de consumo (\u201CParceiros\u201D).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.3 A ades\xE3o ao Programa \xE9 autom\xE1tica e compreende todas as Revendedoras cadastradas na Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2. PONTOS NO PROGRAMA MEU MUNDO AVON')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.1. Os Pontos s\xE3o as unidades de medida utilizadas pela Avon neste Programa. O ac\xFAmulo de Pontos se dar\xE1 exclusivamente mediante o atendimento, pelas Revendedoras, das condi\xE7\xF5es e objetivos definidos em cada um dos Programas de Incentivos Participantes (\u201CProgramas Participantes\u201D), conforme definido pela Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.2.Ao acumular Pontos, as Revendedoras poder\xE3o realizar o resgate de pr\xEAmios e servi\xE7os no cat\xE1logo Meu Mundo Avon (\u201CResgate\u201D), observados os valores necess\xE1rios para cada produto, de acordo com o previsto no cat\xE1logo Meu Mundo Avon em vigor.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.3. Os Pontos v\xE1lidos para este Programa estar\xE3o dispon\xEDveis para Resgate t\xE3o logo sejam validados conforme as regras dos Programas Participantes. Os prazos e condi\xE7\xF5es para a valida\xE7\xE3o, contabiliza\xE7\xE3o, ac\xFAmulo e validade dos Pontos estar\xE3o previstos em cada um dos Programas Participantes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4. A Revendedora ter\xE1 um prazo de at\xE9 6 (seis) campanhas, contadas a partir da campanha de valida\xE7\xE3o do Ponto para realizar qualquer questionamento sobre eventuais discrep\xE2ncias na pontua\xE7\xE3o contabilizada.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.5. Os Pontos n\xE3o s\xE3o negoci\xE1veis ou transfer\xEDveis (compra, venda, cess\xF5es, doa\xE7\xF5es ou permuta de Pontos). A comprova\xE7\xE3o de que a Revendedora tenha incorrido em tais pr\xE1ticas, assim como outras pr\xE1ticas correlatas e/ou que gerem o mesmo efeito, acarretar\xE1 o cancelamento autom\xE1tico dos Pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.6. Os Pontos ter\xE3o a validade ques lhes for atribu\xEDda pelos Programas Participantes e, uma vez decorrido este prazo, expirar\xE3o automaticamente.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.7. Em nenhuma hip\xF3tese, os Pontos ser\xE3o convertidos total ou parcialmente em dinheiro, seja em cr\xE9dito em conta e/ou em pec\xFAnia.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3. COMPANHAMENTO DOS PONTOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.1. Ao utilizar a Plataforma, o Usu\xE1rio declara e reconhece que: A Revendedora poder\xE1 obter informa\xE7\xF5es sobre os objetivos e condi\xE7\xF5es espec\xEDficas para ac\xFAmulo de Pontos:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'i. Na Revista Avon Comigo da Campanha em que o Programa Participante for divulgado;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'ii. No site www.avon.com.br, clicando em Acesse sua \xC1rea Exclusiva > Clique no menu \u201CMeus Incentivos\u201D e consulte os regulamentos dos Programas Participantes;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'iii. No Servi\xE7o de Atendimento \xE0 Revendedora (SAR) - 0800 708 2866;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.1.1 Os Pontos poder\xE3o ser consultados atrav\xE9s do site www.avon.com.br, na Plataforma de Resgates, item \u201CMeus Pontos\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3.2. COMPANHAMENTO DOS PONTOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3.2.1 Est\xE1gio 1: Pontos Pendentes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.1 Ao atingir as condi\xE7\xF5es e objetivos definidos nos Programas Participantes, a Revendedora acumular\xE1 Pontos que ser\xE3o considerados como pendentes at\xE9 que sejam validados de acordo com as regras do Programa Participante.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Est\xE1gio 2: Valida\xE7\xE3o e Disponibiliza\xE7\xE3o dos Pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.2.1 Os Pontos estar\xE3o dispon\xEDveis ap\xF3s cumpridas as regras de valida\xE7\xE3o mencionadas nos Programas Participantes, dispon\xEDvel no site Avon Comigo \u2013',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'www.avon.com.br'},'www.avon.com.br'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.2.2 Eventuais questionamentos sobre a valida\xE7\xE3o e disponibiliza\xE7\xE3o dos Pontos dever\xE1 ser feita nos termos descritos neste regulamento, observando-se o prazo estabelecido na cl\xE1usula 2.4, assim como a apli\xE7\xE3o das regras previstas em cada um dos Programas Participantes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3.2.3. Est\xE1gio 3: Pontos Cancelados')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.3.1 Os Pontos n\xE3o validados de acordo com as regras acima descritas, ser\xE3o cancelados de acordo com o regulamento do Programa.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.4. Pontos adquiridos por fraudes ou condutas inadequadas ou n\xE3o condizentes com a pol\xEDtica e cultura da Avon, acarretam no cancelamento dos pontos.Estagio 4: Pontos Expirados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.4.1. Conforme estabelecido na cl\xE1usula 2.6, os Pontos acumulados expirar\xE3o automaticamente assim que a data final de validade descrita no respectivo Programa de Incentivo for atingida.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4. RESGATE DE PONTOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.1. As Revendedoras poder\xE3o efetuar Resgates utilizando o saldo do Pontos existente em sua conta desde o momento que o Ponto for validado, at\xE9 a data de sua expira\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.2. No ato do Resgate, os Pontos acumulados ser\xE3o abatidos automaticamente dos Pontos dispon\xEDveis e desbloqueados para uso, na ordem decrescente de validade.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.3. O Resgate de Pontos poder\xE1 n\xE3o consumir a totalidade dos Pontos dispon\xEDveis no extrato da Revendedora. Neste caso, o saldo de Pontos remanescentes poder\xE1 ser utilizado pela Revendedora para um novo Resgate, observando-se a data de expira\xE7\xE3o dos Pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.4. As op\xE7\xF5es dos pr\xEAmios dispon\xEDveis para Resgate estar\xE3o no site (www.avon.com.br clicando em Acesse sua \xC1rea Exclusiva > Clique no menu \u201CIncentivos\u201D > Clique em \u201CResgate Meu Mundo Avon\u201D). Sem preju\xEDzo a Avon enviar\xE1 uma pr\xE9via contida em cat\xE1logos impressos do Meu Mundo Avon, que ser\xE3o enviados na caixa de pedidos da Revendedora. Para refer\xEAncia sobre os cat\xE1logos, consulte a cl\xE1usula 6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.5. A Revendedora poder\xE1 resgatar seus Pontos:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'i. Atrav\xE9s do site www.avon.com.br clicando em Acesse sua \xC1rea Exclusiva > Clique no menu \u201CMeus Incentivos\u201D > Clique em \u201CResgate Meu Mundo Avon\u201D;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'ii. no Servi\xE7o de Atendimento \xE0 Revendedora (SAR) 0800 708 2866.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6. Se o resgate de pontos se der por ve\xEDculos automotores (carros e/ou motos), vouchers ou Viagens, dever\xE3o ser respeitadas as seguintes regras abaixo:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4.6.1 Ve\xEDculos automotores (carros e/ou motos)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.1. O prazo para entrega do ve\xEDculo \xE9 de 120 (cento e vinte) dias a contarda data do resgate na plataforma de pr\xEAmios. Esse prazo pode ser maior dependendo da disponibilidade da concession\xE1ria, dos tr\xE2mites legais aplic\xE1veis e da disponibiliza\xE7\xE3o dos documentos necess\xE1rios pela Revendedora participante. Se o prazo para entrega for superior ao estabelecido inicialmente nesta cl\xE1usula, ser\xE1 feita a comunica\xE7\xE3o via e-mail dos ganhadores.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.2. A entrega do ve\xEDculo dever\xE1 ocorrer obrigatoriamente no endere\xE7o da Revendedora participante, ficando vedada a emiss\xE3o dos documentos do ve\xEDculo em um endere\xE7o e a entrega do pr\xEAmio em outro.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.3. A Revendedora participante que resgatar um ve\xEDculo, ter\xE1 30 (trinta) dias, a partir da data de divulga\xE7\xE3o dos ganhadores, para enviar os documentos abaixo para a Avon:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'- C\xF3pia do RG;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'- C\xF3pia do CPF;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'- C\xF3pia do Comprovante de Resid\xEAncia.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.4 A Revendedora participante dever\xE1 realizar a transfer\xEAncia da documenta\xE7\xE3o do ve\xEDculo em at\xE9 30 (trinta) dias ap\xF3s a data de recebimento da documenta\xE7\xE3o. A transfer\xEAncia poder\xE1 ser feita somente em nome da Revendedora participante que realizou o resgate do ve\xEDculo Na hip\xF3tese de atraso ou n\xE3o cumprimento da legisla\xE7\xE3o aplic\xE1vel, a Revendedora participante arcar\xE1 exclusivamente com todas as penalidades, pontua\xE7\xF5es, custos e despesas decorrentes destes atos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.5. Os custos da transfer\xEAncia ser\xE3o arcados pela Avon em at\xE9 30 (trinta) dias a contar da data de emiss\xE3o da Nota Fiscal. Ap\xF3s este prazo, a Revendedora participante passa a ser respons\xE1vel por pontua\xE7\xF5es na Carteira Nacional de Habilita\xE7\xE3o e todos os custos adicionais.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.6. Os processos de vistoria e emplacamento do ve\xEDculo s\xE3o de total responsabilidade da Revendedora participante, sendo que a n\xE3o efetua\xE7\xE3o desse procedimento implica em n\xE3o conclus\xE3o da transfer\xEAncia e a perda do direito ao pr\xEAmio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.1.7. Caso o ve\xEDculo tenha sa\xEDdo de linha ou n\xE3o haja disponibilidade no mercado, a Avon oferecer\xE1 \xE0 Revendedora participante o modelo pelo qual o ve\xEDculo tenha sido substitu\xEDdo no mercado ou similar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4.6.2 Vouchers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.2.1. Ap\xF3s o recebimento do voucher a Revendedora dever\xE1 seguir as orienta\xE7\xF5es contidas no Regulamento de Incentivo espec\xEDfico ou, n\xE3o havendo, seguir as orienta\xE7\xF5es do fornecedor do Voucher para cadastro, desbloqueio e utiliza\xE7\xE3o do pr\xEAmio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.2.2. Uma vez desbloqueado, o voucher poder\xE1 ser utilizado, dentro do prazo de validade, no limite de seu cr\xE9dito, como meio de pagamentos na aquisi\xE7\xE3o de bens e/ou servi\xE7os nos estabelecimentos credenciados \xE0 bandeira indicada no respectivo cart\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.2.3. Nas opera\xE7\xF5es realizadas via internet, telefone ou outros canais eletr\xF4nicos, a confirma\xE7\xE3o poder\xE1 ser solicitada conforme procedimentos espec\xEDficos para tais canais, sendo que a utiliza\xE7\xE3o de senha e/ou aposi\xE7\xE3o de assinatura poder\xE1 ser substitu\xEDda pela indica\xE7\xE3o do n\xFAmero do cart\xE3o e a data de validade, desde que o estabelecimento credenciado esteja autorizado a efetuar transa\xE7\xF5es por este meio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.2.4. A inclus\xE3o da senha ou a confirma\xE7\xE3o da opera\xE7\xE3o caracterizam a sua concord\xE2ncia com a opera\xE7\xE3o. A Emissora n\xE3o se responsabiliza por eventual restri\xE7\xE3o imposta pelos Estabelecimentos Credenciados ao uso do voucher, nem pelo pre\xE7o, qualidade ou quantidade declarados dos bens adquiridos ou servi\xE7os prestados.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.18. A utiliza\xE7\xE3o do voucher ser\xE1 interrompida nas seguintes situa\xE7\xF5es: a. Solicita\xE7\xE3o de cancelamento ou bloqueio; b. Comunica\xE7\xE3o de perda, roubo, furto ou extravio \xE0 emissora do cart\xE3o; c. Cancelamento/bloqueio do voucher por exig\xEAncia judicial, do Banco Central do Brasil ou qualquer outro \xF3rg\xE3o governamental competente, por utiliza\xE7\xE3o il\xEDcita ou em desacordo com as normas vigentes; d. Suspeita de fraude. e. Caso o bloqueio do cart\xE3o ocorra por algum problema t\xE9cnico que n\xE3o tenha sido causado pelo ganhador, ser\xE1 emitido um novo cart\xE3o para a Revendedora Participante'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.2.6. A utiliza\xE7\xE3o do voucher estar\xE1 sujeita \xE0 disponibilidade da rede de cart\xF5es da Bandeira destacada no cart\xE3o da emissora.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.2.6. O voucher n\xE3o poder\xE1 ser utilizado para saques em dinheiro.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4.6.3. Viagens')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.1. Na hipotese de viagem internacional, a obten\xE7\xE3o de passaporte devidamente v\xE1lido, juntamente com o respectivo visto que viabilize a entrada em territ\xF3rio estrangeiro ser\xE1 de inteira responsabilidade da Revendedora e eventual acompanhante, devendo ela arcar com todo e qualquer custo relacionado \xE0 obten\xE7\xE3o de tais documentos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.2. Tamb\xE9m ficar\xE3o sob a responsabilidade da Revendedora e seu acompanhante as provid\xEAncias relativas a documentos e outras provid\xEAncias de car\xE1ter pessoal.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.3. No caso de perda do voo (ida ou volta), por culpa exclusiva da Revendedora e/ou seu acompanhante, estes n\xE3o ter\xE3o direito a receber outro bilhete a\xE9reo, sendo que o custo de eventual substitui\xE7\xE3o do bilhete e demais despesas, dever\xE3o ser arcadas inteiramente pela Revendedora.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.4. Caso a entrada no pa\xEDs de destino seja, por qualquer motivo, negada ao ganhador e/ou seu acompanhante, pelas autoridades locais aeroportu\xE1rias internacionais, a Avon ficar\xE1 isenta de qualquer responsabilidade.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.5. A Avon n\xE3o tem qualquer responsabilidade sobre os objetos pessoais levados pelos ganhadores e seus acompanhantes na viagem.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.6. A Avon n\xE3o se responsabilizar\xE1 por qualquer ato pessoal que os ganhadores e/ou seus acompanhantes venham a cometer em afronta aos bons costumes, a moral, a ordem e as leis durante a viagem e venham a causar danos materiais ou f\xEDsicos a outrem durante a viagem.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.7. Ao adquirir um vale-viagem, a Revendedora est\xE1 ciente que este tem validade de 1 ano e que dever\xE1 ser trocado por sua viagem ou experi\xEAncia dentro da plataforma MMA Viagens no pr\xF3prio Cat\xE1lodo do Meu Mundo Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8. Ao utilizar o vale-viagem na plataforma MMA Viagens, a Revendedora est\xE1 ciente que:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.1. A solicita\xE7\xE3o de troca de pontos por servi\xE7os tur\xEDsticos, em nenhuma hip\xF3tese, poder\xE1 ser cancelada. N\xC3O SER\xC1 ADMITIDA QUALQUER ALTERA\xC7\xC3O OU CANCELAMENTO DO PEDIDO DE RESGATE AP\xD3S A EFETIVA\xC7\xC3O DA TROCA DOS PONTOS POR SERVI\xC7OS TUR\xCDSTICOS E OS PONTOS RESGATADOS N\xC3O SER\xC3O RESTITU\xCDDOS.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.2. Caso o premiado n\xE3o utilize os servi\xE7os, inclusive o bilhete emitido na data e hor\xE1rios escolhidos, este perder\xE1 sua validade e a pontua\xE7\xE3o N\xC3O ser\xE1 estornada.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.3. O cancelamento do resgate somente poder\xE1 ocorrer nos casos de falecimento ou doen\xE7as de natureza infectocontagiosas do premiado. Neste caso, tais situa\xE7\xF5es dever\xE3o ser comprovadas por meio de um laudo m\xE9dico e/ou mediante apresenta\xE7\xE3o de outros documentos pertinentes a serem solicitados pela WEB PR\xCAMIOS TURISMO, cabendo a esta avaliar, a seu exclusivo crit\xE9rio, o cancelamento ou n\xE3o do resgate realizado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.4. O participante somente poder\xE1 efetuar a aquisi\xE7\xE3o dos servi\xE7os tur\xEDsticos e passagens a\xE9reas que estiverem dispon\xEDveis no momento do resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.5. Ap\xF3s o resgate, o envio das informa\xE7\xF5es relativas ao servi\xE7o e a emiss\xE3o do bilhete/confirma\xE7\xE3o de resgate se dar\xE1 por meio do e-mail informado pelo participante no momento do resgate, sendo de sua exclusiva responsabilidade a veracidade das informa\xE7\xF5es fornecidas. A WEB PR\xCAMIOS TURISMO n\xE3o se responsabiliza pelo n\xE3o recebimento do e-mail pelo participante. Caso o participante n\xE3o venha a receber o e-mail com a informa\xE7\xE3o de seu resgate no prazo de at\xE9 6 (seis) horas contadas do resgate, dever\xE1 entrar em contato com a Central de Atendimento da sua Campanha.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.6. As taxas de embarque poder\xE3o ser pagas com a utiliza\xE7\xE3o dos pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.7. Eventual complemento com cart\xE3o de cr\xE9dito, bem como as taxas de embarque n\xE3o s\xE3o reembols\xE1veis ap\xF3s a conclus\xE3o do resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.8. Ap\xF3s a conclus\xE3o do resgate n\xE3o ser\xE1 permitida altera\xE7\xE3o dos servi\xE7os contratados e do bilhete, inclusive no que tange a data de embarque, hor\xE1rio, companhia a\xE9rea, passageiro, ou qualquer outro item.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.9. \xC9 de exclusiva responsabilidade dos hot\xE9is, das companhias a\xE9reas e terceiros, a qualidade e a garantia dos produtos e/ou servi\xE7os oferecidos. A WEB PR\xCAMIOS TURISMO n\xE3o poder\xE1 ser responsabilizada pela indisponibilidade dos servi\xE7os das companhias a\xE9reas ou hot\xE9is ou qualquer cancelamento ou altera\xE7\xE3o de data e hor\xE1rio, ficando sob responsabilidade da Companhia A\xE9rea/terceiro a restitui\xE7\xE3o ao participante.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.10. A Avon n\xE3o se responsabiliza por acidentes, atrasos ou outros imprevistos ocorridos durante a realiza\xE7\xE3o de viagens, estadas ou outros eventos escolhidos pelo premiado, ficando sob sua conta, responsabilidade e despesas a realiza\xE7\xE3o dos seguros correspondentes, se assim desejar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.11. Na hip\xF3tese de cis\xE3o, cess\xE3o, fus\xE3o, incorpora\xE7\xE3o, recupera\xE7\xE3o judicial ou fal\xEAncia decretada pelas empresas fornecedoras, as mesmas ser\xE3o as \xFAnicas e exclusivas respons\xE1veis pelas perdas e danos eventualmente causados aos clientes, decorrentes de sua troca de pontos por passagens a\xE9reas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.12. Ao realizar o resgate o participante desde logo autoriza que suas informa\xE7\xF5es cadastrais sejam divulgadas aos respons\xE1veis pela emiss\xE3o do bilhete e demais documentos necess\xE1rios \xE0 contrata\xE7\xE3o dos servi\xE7os. Caso a emiss\xE3o do bilhete ou contrata\xE7\xE3o dos servi\xE7os n\xE3o seja poss\xEDvel devido a informa\xE7\xF5es incorretas prestadas pelo premiado, o premiado ter\xE1 o prazo de 3 (tr\xEAs) dias para entrar em contato com a Central de Atendimento e solucionar o problema. Ap\xF3s esse prazo, o participante perder\xE1 o direito ao pr\xEAmio resgatado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6.3.8.13. As demais condi\xE7\xF5es espec\xEDficas para resgates de passagens a\xE9reas e servi\xE7os tur\xEDsticos estar\xE3o descritas no momento do aceite do resgate e dever\xE3o ser consideradas como complemento deste Regulamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.7. A Revendedora ser\xE1 respons\xE1vel por todas as informa\xE7\xF5es fornecidas \xE0 Avon, no momento do resgate, assim como por observar as disposi\xE7\xF5es deste regulamento, a ela aplic\xE1vel, sob pena da Revendedora perder o direito \xE0 recompensa ou aos Pontos, e at\xE9 mesmo ser exclu\xEDda do Programa, caso esta n\xE3o observe o disposto neste regulamento ou alegue desconhecer seu teor.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.8. A escolha do pr\xEAmio \xE9 de responsabilidade exclusiva da Revendedora, sendo que, ap\xF3s a escolha, n\xE3o ser\xE1 aceita a troca por outro pr\xEAmio ou qualquer altera\xE7\xE3o de sua caracter\xEDstica, qualidade e origem, nem haver\xE1 a possibilidade de convers\xE3o em dinheiro, em hip\xF3tese alguma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.9. A Revendedora dever\xE1 manter sempre o seu n\xFAmero de telefone, e-mail e endere\xE7o atualizados no momento do Resgate, respondendo integralmente por qualquer extravio e/ou impossibilidade de entrega decorrente da n\xE3o atualiza\xE7\xE3o de seus dados. Havendo impossibilidade de entrega, a Revendedora dever\xE1 observar as regras previstas na cl\xE1usula 5.2 deste regulamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.10. \xC9 de responsabilidade da Revendedora a escolha da voltagem de eventuais produtos el\xE9tricos escolhidos no momento do Resgate, isentando a Avon da responsabilidade por substituir o produto no caso do Resgate incorreto.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5. ENTREGA DE PR\xCAMIOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1. A entrega dos pr\xEAmios resgatados pelas Revendedoras poder\xE1 ocorrer em duas formas distintas, a depender da caracter\xEDstica do pr\xEAmio por esta escolhido e da disponibilidade de meios de entrega no momento do Resgate:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1.1. Caixa de Mercadorias Avon: Para a entrega do pr\xEAmio na caixa de Mercadorias Avon, a Avon ter\xE1 o prazo m\xE1ximo de at\xE9 4 campanhas, observando o prazo m\xE1ximo de 60 (sessenta) dias, contados da data de concretiza\xE7\xE3o do Resgate, desde que a Revendedora coloque um pedido em uma das Campanhas de Vendas Avon relacionadas ao referido per\xEDodo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1.2. Se por alguma raz\xE3o de disponibilidade de estoque o produto n\xE3o estiver dispon\xEDvel para resgate, a Avon se reserva o direito de estornar os pontos para que o Revendedor resgate outro item dispon\xEDvel do cat\xE1logo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1.3. Caso identifique que enviou seu pedido Avon e n\xE3o recebeu o pr\xEAmio na sua caixa de mercadorias, a Revendedora ter\xE1 30 (trinta) dias a partir do prazo final de 60 (sessenta) dias ap\xF3s a realiza\xE7\xE3o do Resgate para entrar em contato com o Servi\xE7o de Atendimento \xE0 Revendedora, a fim de solicitar nova entrega. Ap\xF3s este prazo de 30 dias, a Revendedora perder\xE1 o direito ao pr\xEAmio e os Pontos n\xE3o ser\xE3o devolvidos. Tenha sempre em m\xE3os o protocolo de solicita\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1.4. Entrega por Lojas Parceiras: Para entrega de pr\xEAmios de lojas parceiras, o prazo ser\xE1 informado no momento do Resgate. A Avon realizar\xE1 o monitoramento da entrega dos pr\xEAmios resgatados no Programa Meu Mundo Avon, auxiliando a Revendedora at\xE9 o efetivo recebimento do pr\xEAmio escolhido. Todavia, \xE9 de exclusiva responsabilidade dos Parceiros e da Loja Parceira:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'i. a gest\xE3o de estoque e disponibilidade dos pr\xEAmios;',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'ii. a entrega do pr\xEAmio indicada no tempo e local designado; ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'iii. as condi\xE7\xF5es f\xEDsicas do pr\xEAmio entregue. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'O parceiro ser\xE1 respons\xE1vel pelo envio do pr\xEAmio, dada as seguintes condi\xE7\xF5es:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'i. O endere\xE7o de entrega do produto est\xE1 restrito ao territ\xF3rio nacional, atendido pelos correios ou pelos servi\xE7os de entrega dos Parceiros de Resgate e/ou Loja Parceira;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'ii. O endere\xE7o de entrega do produto poder\xE1 estar restrito exclusivamente ao endere\xE7o de cadastro do Participante, cabendo exclusivamente \xE0 Livelo autorizar envio de produtos a outros endere\xE7os em nome do Participante;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'iii. Determinadas localidades podem n\xE3o ser atendidas pelo(s) Parceiro(s) de Resgate desejado(s) pelo Participante, sendo a impossibilidade informada no carrinho, no momento do Resgate.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.2. Caso n\xE3o seja poss\xEDvel entregar o pr\xEAmio em raz\xE3o do fornecimento incorreto de informa\xE7\xF5es pela Revendedora, mudan\xE7a de endere\xE7o n\xE3o informada ou aus\xEAncia no momento da entrega, os pontos ser\xE3o estornados para que a Revendedora resgate outro item.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.3. A Revendedora ter\xE1 30 (trinta) dias a partir do prazo de entrega estipulado pelo parceiro ap\xF3s a realiza\xE7\xE3o do Resgate para entrar em contato com o Servi\xE7o de Atendimento \xE0 Revendedora, a fim de solicitar nova entrega e/ou retificar seus dados. Ap\xF3s este prazo de 30 dias, a Revendedora perder\xE1 o direito ao pr\xEAmio e os Pontos n\xE3o ser\xE3o devolvidos. Tenha sempre em m\xE3os o protocolo de solicita\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.4. Uma vez constatado que o pr\xEAmio entregue cont\xE9m qualquer defeito, avaria, ou que n\xE3o se trata do produto solicitado, a Revendedora dever\xE1 formular reclama\xE7\xE3o \xE0 Avon no Call Center (0800 708 2866), nos prazos abaixo estabelecidos, para an\xE1lise e eventual substitui\xE7\xE3o por outro produto similar em perfeitas condi\xE7\xF5es. Ressalta-se que esses prazos ser\xE3o contados da data de recebimento dos produtos. Ap\xF3s este prazo, a Revendedora dever\xE1 efetuar sua reclama\xE7\xE3o diretamente ao fabricante. i. Defeito \u2013 07 (sete) dias corridos; ii. Recebimento de item avariado \u2013 Caso o produto recebido seja avariado durante o transporte, recuse o recebimento imediatamente e entre em contato com o Servi\xE7o de Atendimento \xE0 Revendedora; iii. Recebimento de item divergente \u2013 03 (tr\xEAs) dias corridos; iv. Recebimento de item sem acess\xF3rio \u2013 07 (sete) dias corridos; v. Troca por voltagem \u2013 07 (sete) dias corridos (apenas no caso de envio incorreto pelo Parceiro).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.5. A responsabilidade pela qualidade, garantia, especifica\xE7\xF5es t\xE9cnicas e durabilidade dos pr\xEAmios fornecidos \xE9 exclusiva dos Parceiros que os fabricam e/ou os fornecerem, sendo a Revendedora respons\xE1vel, entretanto, por observar as especifica\xE7\xF5es contidas nos manuais de utiliza\xE7\xE3o dos pr\xEAmios, al\xE9m de guardar os respectivos certificados de garantia e nota fiscal dos pr\xEAmios para troca em caso de defeitos, ou para eventual assist\xEAncia t\xE9cnica, no prazo fixado pelos fabricantes, caso n\xE3o possa mais ser reclamado perante \xE0 Avon, nos termos da cl\xE1usula 5.3 acima.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.6. Os produtos devem ser devolvidos preferencialmente na embalagem original. \xC9 indispens\xE1vel que o lacre original do fabricante esteja intacto e que as mercadorias tenham nota fiscal, manual e todos os acess\xF3rios. Poder\xE3o ser aplic\xE1veis outros requisitos a depender das caracter\xEDsticas dos pr\xEAmios e do Parceiro respons\xE1vel pelo fornecimento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.7. Ainda dentro da embalagem, a Revendedora deve colocar a \xFAltima via da nota fiscal recebida no ato da entrega e descrever, no verso da nota o motivo da sua devolu\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.8. A Revendedora deve solicitar o comprovante no momento da retirada da mercadoria para an\xE1lise. Caso o transportador n\xE3o possua tal protocolo, a revendedora n\xE3o deve entregar a mercadoria e deve comunicar \xE0 Avon o ocorrido por meio do Servi\xE7o de Atendimento \xE0 Revendedora (SAR) no telefone 0800 708 2866.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.9. Caso a reclama\xE7\xE3o ultrapasse o prazo m\xE1ximo, os pr\xEAmios n\xE3o ser\xE3o trocados e nem analisados. Nesse caso, a Revendedora poder\xE1 dirigir-se a uma das assist\xEAncias t\xE9cnicas credenciadas pelo pr\xF3prio fabricante, indicadas no manual. A garantia contratual \xE9 de inteira responsabilidade do fabricante e seu prazo e forma de utiliza\xE7\xE3o constam do termo de garantia que acompanha o produto.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.10. Danos causados por uso indevido dos pr\xEAmios s\xE3o de inteira responsabilidade da Revendedora, n\xE3o sendo realizadas substitui\xE7\xF5es ou repara\xE7\xF5es gratuitas por este motivo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.11. Para a premia\xE7\xE3o resgatada ser entregue, a Revendedora tem que se encontrar ativa no ato do recebimento, atendendo \xE0 todas as condi\xE7\xF5es do regulamento do Programa, bem como do regulamenmto dos Programas Participantes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.12. Estorno de pontos: todo ponto estornado ter\xE1 validade de 30 dias a contar da data do estorno e \xE9 de responsabilidade da Revendedora resgatar novamente antes da expira\xE7\xE3o. Pontos expirados n\xE3o ser\xE3o devolvidos por nenhum motivo. A Revendedora deve acompanhar seus pontos estornados no cat\xE1logo de pr\xEAmios.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'6. CAT\xC1LOGO DE PR\xCAMIOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'6.1. As fotos dos pr\xEAmios divulgados no cat\xE1logo t\xEAm car\xE1ter meramente ilustrativo. Caso algum item tenha sa\xEDdo de linha ou n\xE3o haja disponibilidade no mercado no momento da compra, a Avon reserva-se ao direito de substitu\xED-lo, a seu exclusivo crit\xE9rio, por pr\xEAmios equivalentes em pot\xEAncia, capacidade e qualidade, da mesma marca ou similar ou, na impossibilidade de substitui\xE7\xE3o, \xE0 elimin\xE1-lo em definitivo do cat\xE1logo. Os elementos de produ\xE7\xE3o das fotos n\xE3o acompanham os pr\xEAmios.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'6.2. A Avon poder\xE1, a qualquer momento, limitar os pr\xEAmios, a quantidade e a oferta a cada Participante. Para acesso a mais detalhes, tais como descritivo dos pr\xEAmios e Parceiros de Resgate, o Participante poder\xE1 acessar o Site do Meu Mundo Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'7. VALIDADE DO PROGRAMA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'7.1. A Avon reserva-se o direito de encerrar o programa a qualquer tempo, com a respectiva comunica\xE7\xE3o da data de encerramento \xE0s Revendedores participantes com anteced\xEAncia m\xEDnima de 30 (trinta) dias.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'7.2. Ap\xF3s o encerramento, todos os Pontos adquiridos e n\xE3o utilizados no Programa Meu Mundo Avon perder\xE3o a validade.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'6.1. As fotos dos pr\xEAmios divulgados no cat\xE1logo t\xEAm car\xE1ter meramente ilustrativo. Caso algum item tenha sa\xEDdo de linha ou n\xE3o haja disponibilidade no mercado no momento da compra, a Avon reserva-se ao direito de substitu\xED-lo, a seu exclusivo crit\xE9rio, por pr\xEAmios equivalentes em pot\xEAncia, capacidade e qualidade, da mesma marca ou similar ou, na impossibilidade de substitui\xE7\xE3o, \xE0 elimin\xE1-lo em definitivo do cat\xE1logo. Os elementos de produ\xE7\xE3o das fotos n\xE3o acompanham os pr\xEAmios.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'8. CONSIDERA\xC7\xD5ES GERAIS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.1. Para ter direito aos pr\xEAmios previstos no Programa Meu Mundo Avon, a Revendedora dever\xE1 atender \xE0 todas as condi\xE7\xF5es previstas neste regulamento e nos respectivos regulamentos que originaram o ac\xFAmulo de Pontos, sendo tais documentos considerados, para efeitos deste programa, como complementares e indissoci\xE1veis. Sem preju\xEDzo, para manter-se eleg\xEDvel e fazer jus aos pr\xEAmios, dever\xE1 cumprir integralmente as regras previstas nos documentos que estabele\xE7am as regras de atua\xE7\xE3o como Revendedora Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.2. Este Regulamento poder\xE1 ser alterado, a qualquer tempo e a exclusivo crit\xE9rio da Avon, mediante pr\xE9via comunica\xE7\xE3o \xE0s Revendedoras participantes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.3. O presente regulamento revoga todos os regulamentos anteriores sobre o mesmo programa de incentivo, permanecendo v\xE1lido por per\xEDodo indeterminado at\xE9 que modificado ou substitu\xEDdo, a crit\xE9rio da Avon, por um novo regulamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.4. As Revendedoras participantes concordam com a utiliza\xE7\xE3o de seu nome, voz e imagem para a divulga\xE7\xE3o deste Programa, por prazo indeterminado, sem qualquer \xF4nus para a Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.5. O pr\xEAmio a ser distribu\xEDdo destina-se \xE0 Revendedora que efetuar o Resgate, e ser\xE1 entregue em nome desta, sendo vedada sua transfer\xEAncia.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.6. Em caso de falecimento da Revendedora, a Avon poder\xE1, mediante solicita\xE7\xE3o pr\xE9via e desde os pontos n\xE3o tenham expirado, conceder ao sucessor leg\xEDtimo, a possibilidade de resgatar o eventual pr\xEAmio a que teria direito a Revendedora falecida.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.7. Os Pontos em nome da Revendedora ser\xE3o automaticamente cancelados na ocorr\xEAncia de qualquer das seguintes hip\xF3teses: i. Solicita\xE7\xE3o, pela Revendedora, de exclus\xE3o do Programa; ii. A Revendedora deixar de cumprir qualquer de suas obriga\xE7\xF5es advindas deste regulamento e/ou dos regulamentos dos Programas Participantes, incluindo o contrato de presta\xE7\xE3o de servi\xE7os de Executiva de Vendas e seus documentos integrantes; iii. Se Avon constatar n\xE3o ser verdadeira qualquer informa\xE7\xE3o que a Revendedora lhe tenha fornecido, especialmente no que se refere a eventual fraude; iv. Caso a Revendedora entre em Cobran\xE7a por n\xE3o pagamento do seu boleto de qualquer Campanha.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.8. A Avon poder\xE1 realizar ajustes na Pontua\xE7\xE3o da Revendedora, a seu exclusivo crit\xE9rio, mediante solicita\xE7\xE3o dos parceiros ou, em car\xE1ter excepcional, mediante solicita\xE7\xE3o da Revendedora. Tal solicita\xE7\xE3o, nesses casos, estar\xE1 sujeita \xE0 avalia\xE7\xE3o e apura\xE7\xE3o por parte da Avon. Os motivos que poder\xE3o ensejar ajustes na Pontua\xE7\xE3o incluem, mas n\xE3o se limitam, a erro sist\xEAmico e/ou falha humana.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.9. Na hip\xF3tese de fundada suspeita ou efetiva constata\xE7\xE3o de qualquer irregularidade ou distor\xE7\xE3o que macule ou seja capaz de macular, a crit\xE9rio exclusivo da Avon, o resultado em qualquer um dos crit\xE9rios de pontua\xE7\xE3o (Pedidos, Vendas, Devolu\xE7\xE3o, Remessa) utilizados neste Programa, a Avon se reserva ao direito de desclassificar a Revededora a qualquer tempo, sem preju\xEDzo da ado\xE7\xE3o das medidas legais cab\xEDveis para o ressarcimento de eventuais preju\xEDzos suportados pela Avon.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2 '},'8.10. No caso de falta do pr\xEAmio por indisponibilidade de estoque do cat\xE1logo impresso, a Avon reserva-se o direito de retir\xE1-lo do site de resgate, a qualquer tempo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2 '},'8.11. A Avon n\xE3o se responsabiliza por riscos, acidentes e danos ocorridos durante a utiliza\xE7\xE3o dos produtos resgatados pela Revendedora, por meio do Programa, devendo a Revendedora observar e cumprir todas as especifica\xE7\xF5es t\xE9cnicas feitas pelo fabricante.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2 '},'8.12. Os casos n\xE3o contemplados neste Regulamento ser\xE3o analisados individualmente e poder\xE3o ser acrescentados a este documento a qualquer tempo.')))))))));}}]);return RegulationAvonComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RegulationAvonComponent);

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
var RegulationMHMO=function RegulationMHMO(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Regulamentos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 bg-white border-ui-3 radius-0 radius-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Regulamentos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 px-md-3 py-3',role:'article'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Regulamentos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'O cat\xE1logo de benef\xEDcios, dispon\xEDvel para acesso em ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'mhmo.com.br'),', \xE9 uma plataforma online que permite a voc\xEA (doravante \u201CUsu\xE1rio\u201D), funcion\xE1rio trocar seus pontos por produtos ou servi\xE7os disponibilizados por nossas empresas parceiras (\u201CParceiros\u201D), indicadas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Dessa forma, os presentes Termos de Uso (\u201CTermos\u201D) estipulam as regras para utiliza\xE7\xE3o da Plataforma pelos Usu\xE1rios, e est\xE3o dispon\xEDveis para acesso, a qualquer momento, por meio do link',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/terms',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'mhmo.com.br/terms')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Aplicam-se aos presentes Termos, ainda, o quanto disposto na Pol\xEDtica de Privacidade, dispon\xEDvel para acesso em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/privacy',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'mhmo.com.br/privacy')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Em caso de quaisquer d\xFAvidas sobre o quanto disposto nestes Termos, o Usu\xE1rio dever\xE1 entrar em contato com a Premmiar por meio da p\xE1gina \u201CFale Conosco\u201D, dispon\xEDvel em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/redirect/contact',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'mhmo.com.br/redirect/contact')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1. ACEITA\xC7\xC3O DESTES TERMOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.1. O aceite livre, expresso e informado aos presentes Termos se dar\xE1 no momento do clique do Usu\xE1rio no bot\xE3o \u201CAceito\u201D, quando de seu primeiro acesso \xE0 Plataforma, estando a utiliza\xE7\xE3o condicionada \xE0 integral aceita\xE7\xE3o do quanto disposto no presente documento, sendo certo que, caso o Usu\xE1rio n\xE3o concorde com o quanto aqui estipulado, dever\xE1 se abster de utilizar o site.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.2. Exceto em caso de expressa previs\xE3o legal em sentido contr\xE1rio, os presentes Termos poder\xE3o ser atualizados ou modificados a qualquer momento, a exclusivo crit\xE9rio da Premmiar, independentemente de qualquer formalidade e comunica\xE7\xE3o, cabendo ao Usu\xE1rio verificar novamente o conte\xFAdo destes Termos a cada modifica\xE7\xE3o, conforme data de atualiza\xE7\xE3o constante ao final deste documento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.3. A continuidade de utiliza\xE7\xE3o da Plataforma pelo Usu\xE1rio implicar\xE1 a irrestrita aceita\xE7\xE3o das condi\xE7\xF5es fixadas, incluindo as altera\xE7\xF5es que porventura venham a ser realizadas em referidas condi\xE7\xF5es.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2. ACESSO \xC0 PLATAFORMA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.1. O acesso \xE0 Plataforma se dar\xE1 mediante login e senha de acesso, ap\xF3s o cadastro do Usu\xE1rio no sistema.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.2. Em alguns casos, o acesso poder\xE1 depender de valida\xE7\xE3o positiva do cadastro do Usu\xE1rio, por meio da confer\xEAncia das informa\xE7\xF5es fornecidas pelo Gestor, tais como CPF e data de nascimento, entre outras.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.3. Poder\xE3o se registrar e utilizar a Plataforma Usu\xE1rios plenamente capazes, nos termos da legisla\xE7\xE3o brasileira. Dessa forma, menores de 18 (dezoito) anos de idade, exceto os emancipados, nos termos do par\xE1grafo \xFAnico do artigo 5\xBA do C\xF3digo Civil Brasileiro, n\xE3o poder\xE3o utilizar a Plataforma, sendo vedado seu cadastro como Usu\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4. Em qualquer hip\xF3tese, o Usu\xE1rio se compromete a fornecer todas as informa\xE7\xF5es obrigat\xF3rias solicitadas quando de seu cadastro, de forma correta e verdadeira, responsabilizando-se por qualquer informa\xE7\xE3o incorreta ou inver\xEDdica inserida na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.5. Uma vez que o acesso \xE0 Plataforma \xE9 destinado apenas a funcion\xE1rios de empresas clientes, a Premmiar se reserva o direito de negar o acesso de quaisquer Usu\xE1rios n\xE3o vinculados a nenhuma empresa cliente ou, a qualquer momento, excluir o acesso de tais Usu\xE1rios.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.6. Ap\xF3s o cadastro, o Usu\xE1rio ter\xE1 acesso a quantidade pontos que possui, bem como ao cat\xE1logo de produtos e servi\xE7os dos Parceiros da Premmiar (\u201CCat\xE1logo\u201D).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3. UTILIZA\xC7\xC3O DA PLATAFORMA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.1. Ao utilizar a Plataforma, o Usu\xE1rio declara e reconhece que:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2. Est\xE1 devidamente autorizado pelo Gestor da empresa cliente a preencher seu cadastro, acessar a Plataforma e realizar a troca de pontos por produtos ou servi\xE7os dos Parceiros;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.3. Dever\xE1 manter sempre seu cadastro devidamente atualizado, especialmente seu endere\xE7o e informa\xE7\xF5es de contato;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.4. N\xE3o poder\xE1 inserir ou produzir na Plataforma, por qualquer meio, conte\xFAdo il\xEDcito, que viole direitos de terceiros ou que seja de qualquer modo contr\xE1rio \xE0 moral e aos bons costumes geralmente aceitos;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.5. \xC9 vedada a inser\xE7\xE3o na Plataforma de conte\xFAdo que incorpore v\xEDrus ou outros elementos f\xEDsicos ou eletr\xF4nicos que possam causar danos ou impedir o normal funcionamento da rede, do sistema ou de equipamentos inform\xE1ticos, da Premmiar, ou de terceiros; e'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.6. \xC9 vedada a inser\xE7\xE3o na Plataforma de conte\xFAdo que provoque, por suas caracter\xEDsticas (tais como forma, extens\xE3o etc.), dificuldades no normal funcionamento da Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.7. O Usu\xE1rio se compromete a utilizar a Plataforma e o seu conte\xFAdo, ou seja, os textos, imagens, fotografias, gr\xE1ficos, \xEDcones, tecnologia, links e demais conte\xFAdos audiovisuais ou sonoros, incluindo o software da Plataforma, desenhos gr\xE1ficos e c\xF3digos fonte (em conjunto, \u201CConte\xFAdo(s)\u201D), de acordo com todo o ordenamento jur\xEDdico, com a moral e os bons costumes geralmente aceitos, os presentes Termos e eventuais instru\xE7\xF5es adicionais existentes na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.8. O Usu\xE1rio dever\xE1 se abster de obter, ou de tentar obter, os Conte\xFAdos por quaisquer meios distintos daqueles que, em cada caso, tenham sido colocados \xE0 disposi\xE7\xE3o para tais prop\xF3sitos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.9. Em qualquer circunst\xE2ncia, o Usu\xE1rio ser\xE1 o \xFAnico respons\xE1vel pelo uso que fizer da Plataforma, eximindo a Premmiar e qualquer responsabilidade por eventuais danos ou preju\xEDzos decorrentes do uso indevido ou inadequado que o Usu\xE1rio fizer da Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4. AQUISI\xC7\xC3O E TROCA DE PONTOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.1. Os pontos ser\xE3o atribu\xEDdos ao Usu\xE1rio pelo Gestor da empresa cliente, de acordo com os crit\xE9rios estabelecidos pelo Gestor. A Premmiar apenas disponibilizar\xE1 na conta do Usu\xE1rio os respectivos e eventuais pontos indicados pelo Gestor, sem qualquer inger\xEAncia e responsabilidade da Premmiar na atribui\xE7\xE3o dos pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.2. Dessa forma, a Premmiar n\xE3o ser\xE1 respons\xE1vel, em hip\xF3tese alguma, por eventuais diverg\xEAncias entre as regras do benef\xEDcio, estipuladas pelo Gestor, e a quantidade de pontos atribu\xEDda ao Usu\xE1rio, sendo a responsabilidade por tal atribui\xE7\xE3o exclusiva do Gestor da empresa cliente.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.3. Caso o Usu\xE1rio n\xE3o possua saldo de pontos suficiente para realizar o resgate do produto ou servi\xE7o desejado, incluindo o valor do frete, este poder\xE1, em determinadas situa\xE7\xF5es, adquirir pontos diretamente da Premmiar, apenas e t\xE3o somente para a finalidade de completar a quantidade de pontos necess\xE1ria para o resgate de um determinado produto ou servi\xE7o. A aquisi\xE7\xE3o dos pontos ser\xE1 realizada com cart\xE3o de cr\xE9dito ou outro meio de pagamento disponibilizado na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.4. Para que reste autorizada a compra de pontos, o Usu\xE1rio dever\xE1 possuir ao menos parte do valor do produto ou servi\xE7o que deseje adquirirem pontos. N\xE3o \xE9 poss\xEDvel a compra de pontos desvinculada da aquisi\xE7\xE3o de um produto ou servi\xE7o, nem a compra de produtos diretamente dos Parceiros, sem a utiliza\xE7\xE3o de pontos. O Parceiro poder\xE1 exigir que o participante tenha um n\xFAmero m\xEDnimo de pontos para habilitar a fun\xE7\xE3o \u201Ccompra de pontos\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.5. A compra de pontos estar\xE1 dispon\xEDvel apenas para alguns Parceiros do cat\xE1logo de pr\xEAmios, de acordo com as condi\xE7\xF5es acordadas entre estes e a Premmiar. Caso seja poss\xEDvel a compra, o \xEDcone \u201Ccompra de pontos\u201D aparecer\xE1 como dispon\xEDvel ao Usu\xE1rio. Assim, o Usu\xE1rio reconhece que, caso tal \xEDcone n\xE3o seja disponibilizado, n\xE3o poder\xE1 haver a compra de pontos para a aquisi\xE7\xE3o do produto ou servi\xE7o em quest\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.6. A venda de pontos \xE9 realizada exclusivamente pela Premmiar, sem qualquer interven\xE7\xE3o do Gestor da empresa cliente. O pre\xE7o do ponto vendido no cat\xE1logo de pr\xEAmios ser\xE1 aquele divulgado ao Usu\xE1rio no momento da compra.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.7. N\xE3o h\xE1 correla\xE7\xE3o monet\xE1ria entre os pontos adquiridos pelos Usu\xE1rios e aqueles que s\xE3o concedidos pelos Gestores da empresa cliente. Assim, a Premmiar n\xE3o se compromete a respeitar qualquer equival\xEAncia entre pontos e valores monet\xE1rios eventualmente indicada pelo Gestor, sendo certo que os pontos fornecidos aos Usu\xE1rios pelos Gestores da empresa cliente n\xE3o possuem valor monet\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.8. O Usu\xE1rio poder\xE1 trocar os pontos a ele atribu\xEDdos por quaisquer produtos ou servi\xE7os oferecidos por Parceiros, disponibilizados no Cat\xE1logo, acess\xEDvel por meio de sua conta de acesso.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.9. O Usu\xE1rio entende e reconhece que a troca de pontos poder\xE1 ser restrita a produtos ou servi\xE7os de apenas alguns dos Parceiros indicados na Plataforma, a exclusivo crit\xE9rio do Gestor da Campanha. Assim, a Premmiar n\xE3o se responsabiliza por produtos ou servi\xE7os de Parceiros que n\xE3o estejam dispon\xEDveis no Cat\xE1logo apresentado ao Usu\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.10. Os pontos disponibilizados ao Usu\xE1rio poder\xE3o estar sujeitos a prazo de validade, determinado pelo Gestor da campanha \xE0 qual tais pontos est\xE3o vinculados. Ainda, todos os pontos relacionados a determinada campanha expirar\xE3o, em caso de t\xE9rmino do contrato entre o Gestor e a Premmiar. \xC9 de responsabilidade exclusiva do Usu\xE1rio utilizar seus pontos, antes da expira\xE7\xE3o do prazo, n\xE3o se responsabilizando a Premmiar, em hip\xF3tese alguma, caso o Usu\xE1rio n\xE3o os utilize, dentro do prazo m\xE1ximo estipulado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.11. Em hip\xF3tese alguma os pontos obtidos pelos Usu\xE1rios poder\xE3o ser convertidos em dinheiro ou trocados por quaisquer produtos ou servi\xE7os n\xE3o constantes no Cat\xE1logo disponibilizado ao Usu\xE1rio quando de seu acesso.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.12. A troca dos pontos pelos produtos ou servi\xE7os constantes no Cat\xE1logo disponibilizado ao Usu\xE1rio est\xE1 sujeita \xE0 disponibilidade. A opera\xE7\xE3o de troca por alguns produtos ou servi\xE7os poder\xE1 n\xE3o ser conclu\xEDda, em raz\xE3o de sua indisponibilidade. A troca somente ser\xE1 tida como completa, ap\xF3s o Usu\xE1rio finalizar a transa\xE7\xE3o pela Plataforma e receber e-mail com tal confirma\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.13. A disponibilidade dos produtos ou servi\xE7os depende exclusivamente dos Parceiros que os fornecem, n\xE3o se responsabilizando a Premmiar por quaisquer produtos constantes do Cat\xE1logo n\xE3o disponibilizados pelos Parceiros.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.14. O Cat\xE1logo de pr\xEAmios \xE9 atualizado peri\xF3dica e automaticamente pelos Parceiros e os produtos e pontos necess\xE1rios para troca poder\xE3o sofrer altera\xE7\xF5es durante a navega\xE7\xE3o dos Usu\xE1rios, sem aviso pr\xE9vio, devendo ser consultados pelo interessado no momento da conclus\xE3o efetiva do resgate/troca dos pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.15. N\xE3o h\xE1 correla\xE7\xE3o direta entre os pre\xE7os divulgados em pontos no cat\xE1logo de pr\xEAmios e os valores indicados pelos Parceiros em seus sites direcionados aos consumidores finais, na medida em que os pontos fornecidos pelo Gestor ao Usu\xE1rio n\xE3o possuem valor monet\xE1rio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.16. Para utiliza\xE7\xE3o dos Pontos em determinados Parceiros, a Premmiar poder\xE1 debitar da conta de premia\xE7\xE3o dos Usu\xE1rios uma taxa administrativa. A taxa administrativa padr\xE3o para resgate de vouchers \xE9 de 4% (quatro por cento) sobre o valor nominal do resgate, taxa administrativa da qual o Usu\xE1rio declara desde logo ter plena ci\xEAncia. A taxa administrativa para resgate nos demais Parceiros pode variar de acordo com os custos operacionais e administrativos decorrentes do resgate realizado. O pre\xE7o final do produto em pontos ser\xE1 aquele informado ao Usu\xE1rio no momento da finaliza\xE7\xE3o do resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.17. A Plataforma poder\xE1 sugerir produtos e servi\xE7os para resgate pelos Usu\xE1rios de acordo com o seu perfil de consumo, observando inclusive a suas prefer\xEAncias de navega\xE7\xE3o no cat\xE1logo de pr\xEAmios, como detalhado na Pol\xEDtica de Privacidade relacionada a estes Termos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.18. Caso os pontos do Usu\xE1rios estejam com prazo de expira\xE7\xE3o pr\xF3ximo, a Premmiar ou o Gestor poder\xE3o, em determinadas situa\xE7\xF5es, realizar a\xE7\xF5es promocionais com resgate autom\xE1tico de pontos para determinados parceiros, visando que o Usu\xE1rio n\xE3o seja prejudicado com a expira\xE7\xE3o dos pontos. Nestas situa\xE7\xF5es, o realizador da a\xE7\xE3o promocional enviar\xE1 um SMS ao Usu\xE1rio, indicando que realizar\xE1 o resgate autom\xE1tico dos pontos a vencer, formalizando para qual dos Parceiros os pontos a expirar seriam transferidos e concedendo ao Usu\xE1rio a possibilidade de optar pela sua n\xE3o realiza\xE7\xE3o. O Usu\xE1rio reconhece que n\xE3o h\xE1 obrigatoriedade na realiza\xE7\xE3o do resgate autom\xE1tico, seja pela Premmiar ou pelo Gestor, sendo tal medida excepcional.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.19. O Usu\xE1rio poder\xE1 realizar a busca inteligente de produtos e servi\xE7os por meio do filtro dispon\xEDvel por categoria, marcas ou saldo de pontos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5. ENTREGA DE PRODUTOS OU SERVI\xC7OS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1. A Premmiar atua apenas como cat\xE1logo online, intermediador entre o Usu\xE1rio e os Parceiros, que inserem diretamente seus produtos e/ou servi\xE7os na Plataforma, n\xE3o comercializando, a Premmiar, quaisquer produtos ou servi\xE7os, nem mantendo produtos em estoque.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.2. Desta forma, a entrega dos produtos ou a presta\xE7\xE3o dos servi\xE7os selecionados pelo Usu\xE1rio \xE9 de exclusiva responsabilidade do respectivo Parceiro, n\xE3o se responsabilizando a Premmiar por quaisquer atrasos ou falhas na entrega dos produtos ou na presta\xE7\xE3o dos servi\xE7os.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.3. Eventualmente a Premmiar poder\xE1 adquirir vouchers de Parceiros e comercializ\xE1-los na Plataforma, realizando diretamente a entrega deles aos Usu\xE1rios, hip\xF3tese em que o Usu\xE1rio ser\xE1 informado de que tais vouchers s\xE3o entregues pela Premmiar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.4. \xC9 de responsabilidade exclusiva do Usu\xE1rio manter seus dados cadastrais atualizados, eximindo a Premmiar e seus Parceiros de qualquer responsabilidade em rela\xE7\xE3o \xE0 entrega de produtos decorrentes de informa\xE7\xF5es desatualizadas inseridas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.5. Caso o Usu\xE1rio opte por resgatar mais de um produto do cat\xE1logo de benef\xEDcios, ainda que em Parceiros diferentes, o fechamento do resgate poder\xE1 ser finalizado no mesmo pedido, em um carrinho \xFAnico. Os fretes e prazos de entrega, todavia, ser\xE3o calculados por cada um dos Parceiros e ser\xE3o inclu\xEDdos individualmente no pedido. Assim, pedidos contendo mais de um produto poder\xE3o possuir datas de entrega diferentes, de acordo com o estipulado pelo Parceiro respons\xE1vel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.6. A fun\xE7\xE3o de finaliza\xE7\xE3o \xFAnica de resgate n\xE3o estar\xE1 dispon\xEDvel para todos os pedidos, pois depender\xE1 da disponibilidade t\xE9cnica de cada um dos Parceiros.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.7. O cancelamento do pedido de um \xFAnico produto inclu\xEDdo no carrinho n\xE3o implicar\xE1 cancelamento dos demais produtos ou servi\xE7os resgatados no mesmo pedido.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.8. Ser\xE1 disponibilizado ao Usu\xE1rio, por meio do acesso ao \xEDcone \u201CMeus Pedidos\u201D, o acompanhamento do status da entrega dos produtos resgatados, de acordo com as informa\xE7\xF5es disponibilizadas por cada Parceiro, informa\xE7\xF5es que tamb\xE9m poder\xE3o ser enviadas aos Usu\xE1rios por e-mail ou SMS.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.9. Caso a entrega do produto n\xE3o possa ser realizada em raz\xE3o de diverg\xEAncia no endere\xE7o de entrega informado pelo Usu\xE1rio, o resgate poder\xE1 ser cancelado pelo Parceiro, sendo os pontos respectivos creditados novamente na conta do Usu\xE1rio, respeitado o prazo de validade original dos pontos para que o Usu\xE1rio possa realizar novo resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.10. Nos cancelamentos de Pedidos em que o Usu\xE1rio tenha adquirido pontos para realizar o resgate, estes pontos adquiridos ser\xE3o creditados na sua conta de premia\xE7\xE3o para posterior utiliza\xE7\xE3o, em novo resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.11. Caso o Usu\xE1rio tenha solicitado cancelamento do pedido, em raz\xE3o do atraso na entrega ou por outros motivos aplic\xE1veis e o produto tenha sido efetivamente entregue no endere\xE7o por ele indicado, a Premmiar estar\xE1 autorizado a debitar os pontos referentes ao produto recebido da conta de premia\xE7\xE3o do Usu\xE1rio. Para que n\xE3o haja o d\xE9bito de pontos o Usu\xE1rio dever\xE1 recusar o recebimento do pedido que pretendia ver cancelado.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.12. \xC9 de responsabilidade exclusiva do Usu\xE1rio manter seus dados cadastrais atualizados, eximindo a Premmiar e seus Parceiros de qualquer responsabilidade relacionada \xE0 entrega equivocada de produtos decorrentes de informa\xE7\xF5es desatualizadas inseridas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'6. DURA\xC7\xC3O E FINALIZA\xC7\xC3O DO ACESSO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'6.1. O acesso \xE0 Plataforma \xE9 concedido ao Usu\xE1rio por prazo indeterminado. No entanto, a Premmiar est\xE1 facultada a dar por terminado, suspender ou interromper unilateralmente, a qualquer momento e sem necessidade de pr\xE9vio aviso, o acesso do Usu\xE1rio, sem que qualquer indeniza\xE7\xE3o seja devia em raz\xE3o disso.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'7. ISEN\xC7\xC3O DE RESPONSABILIDADE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'7.1. Al\xE9m das demais hip\xF3teses de isen\xE7\xE3o de responsabilidade previstas neste documento, a Premmiar n\xE3o se responsabilizar\xE1:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2 pl-1'},'1. Por quaisquer danos decorrentes da interrup\xE7\xE3o do acesso \xE0 Plataforma, ou por falhas de funcionamento;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2. Pela defrauda\xE7\xE3o da utilidade que os Usu\xE1rios possam ter atribu\xEDdo \xE0 Plataforma, pela falibilidade da mesma, ou por qualquer dificuldade de acesso;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3. Pela exist\xEAncia de quaisquer elementos nocivos que possam produzir altera\xE7\xF5es nos sistemas inform\xE1ticos dos Usu\xE1rios (software e/ou hardware) ou nos documentos eletr\xF4nicos armazenados no sistema inform\xE1tico;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4. Por quaisquer hyperlinks disponibilizados na Plataforma, sendo certo que n\xE3o h\xE1 verifica\xE7\xE3o pr\xE9via do conte\xFAdo de qualquer hyperlink disponibilizado na Plataforma e que as p\xE1ginas por meio deles acessadas est\xE3o sujeitas a outros Termos de Uso e Pol\xEDticas de Privacidade;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5. Pelos danos e preju\xEDzos de toda natureza que possam decorrer do conhecimento que terceiros n\xE3o autorizados possam ter de quaisquer das informa\xE7\xF5es fornecidas pelo Usu\xE1rio, em decorr\xEAncia de falha exclusivamente atribu\xEDvel ao Usu\xE1rio; e',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'6. Por falhas ou informa\xE7\xF5es recebidas de modo incompleto pela Premmiar ou seus Parceiros, que dificultem ou impe\xE7am a troca de pontos por produtos ou servi\xE7os;',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'7. Por produtos ou servi\xE7os disponibilizados na Plataforma pelos Parceiros, devendo qualquer eventual defeito em referidos produtos ou servi\xE7os ser comunicado diretamente ao Parceiro respons\xE1vel, por meio das informa\xE7\xF5es de contato por ele indicadas, para ado\xE7\xE3o das respectivas provid\xEAncias.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'7.2. A Premmiar poder\xE1, a seu exclusivo crit\xE9rio e sem anu\xEAncia ou concord\xE2ncia do Usu\xE1rio, alterar os servi\xE7os prestados, adicionando ou excluindo Parceiros, produtos e servi\xE7os, bem como a pontua\xE7\xE3o necess\xE1ria para a troca de determinados produtos ou servi\xE7os, sem que qualquer valor ou indeniza\xE7\xE3o seja devido ao Usu\xE1rio, em raz\xE3o de tais altera\xE7\xF5es.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'8. PROPRIEDADE INTELECTUAL')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.1 Todos os direitos de propriedade intelectual referentes a qualquer material disponibilizado na Plataforma, tais como textos, marcas, logos, fotografias, gr\xE1ficos, imagens, links, conte\xFAdos audiovisuais ou sonoros, software, desenhos gr\xE1ficos e c\xF3digos fontes, entre outros, s\xE3o de titularidade da Premmiar ou de terceiros que autorizaram seu uso, sendo vedada sua c\xF3pia, reprodu\xE7\xE3o, ou qualquer outro tipo de utiliza\xE7\xE3o, ficando os infratores sujeitos \xE0s san\xE7\xF5es civis e criminais correspondentes, nos termos das Leis 9.610/98, 9.609/98 e 9.279/96.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'8.2 Todas as marcas, os nomes comerciais ou logotipos de qualquer esp\xE9cie disponibilizados na Plataforma s\xE3o de propriedade da Premmiar ou de terceiros que autorizaram seu uso, sem que o acesso ao ou utiliza\xE7\xE3o da Plataforma possa ser entendida como autoriza\xE7\xE3o para que o Usu\xE1rio possa citar tais marcas, nomes comerciais e logotipos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'9. DISPOSI\xC7\xD5ES GERAIS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'9.1 Se qualquer parte destes Termos for considerada inv\xE1lida ou inexequ\xEDvel, essa parte deve ser interpretada de forma consistente com a lei aplic\xE1vel, para refletir, na medida do poss\xEDvel, a inten\xE7\xE3o original das partes, e as demais disposi\xE7\xF5es permanecer\xE3o em pleno vigor e efeito.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'9.2 A falha da Premmiar em exigir quaisquer direitos ou disposi\xE7\xF5es dos presentes Termos n\xE3o constituir\xE1 ren\xFAncia, podendo exercer regularmente o seu direito, dentro dos prazos legais.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10. CONTATO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'10.1 O Usu\xE1rio poder\xE1 entrar em contato com a Premmiar por meio do formul\xE1rio disponibilizado na p\xE1gina Fale Conosco, dispon\xEDvel para acesso em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/redirect/contact',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'mhmo.com.br/redirect/contact')),', bem como por meio do endere\xE7o de e-mail ou telefone divulgados na comunica\xE7\xE3o do benef\xEDcio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'10.2 A Premmiar poder\xE1 entrar em contato com o Usu\xE1rio, e esta comunica\xE7\xE3o ser\xE1 considerada v\xE1lida, por meio de qualquer informa\xE7\xE3o de contato por ele disponibilizada quando do preenchimento de seu cadastro. Os comunicados emitidos por meio da Plataforma tamb\xE9m ser\xE3o considerados v\xE1lidos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'10.3 A Premmiar poder\xE1 implementar mecanismos antifraude na Plataforma, inclusive realizando contato junto ao Usu\xE1rio para confirma\xE7\xE3o do pedido, por meio de liga\xE7\xE3o, SMS, e-mail ou qualquer outro programa de mensagens pela internet.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'11. LEI APLIC\xC1VEL E FORO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'11.1 Estes Termos ser\xE3o regidos, interpretados e executados de acordo com as leis da Rep\xFAblica Federativa do Brasil, independentemente dos conflitos dessas leis com leis de outros estados ou pa\xEDses, sendo competente o Foro da Comarca de S\xE3o Paulo, Capital, no Brasil, para dirimir qualquer d\xFAvida decorrente deste instrumento. O Usu\xE1rio consente, expressamente, com a compet\xEAncia desse ju\xEDzo, e renuncia, neste ato, \xE0 compet\xEAncia de qualquer outro foro, por mais privilegiado que seja ou venha a ser.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'\xDAltima atualiza\xE7\xE3o: 05/10/2020')))))))));};/* harmony default export */ __webpack_exports__["a"] = (RegulationMHMO);

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
var RegulationDefault=function RegulationDefault(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Regulamentos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'regulation col-12 bg-white border-ui-3 radius-0 radius-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 py-3 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-bold txt-uppercase py-1'},'Regulamento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pt-1'},'"Vale Mais PETRONAS"'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'company-name txt-body-sm py-1'},'PETRONAS LUBRIFICANTES BRASIL S.A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body color-ui-black'},'Avenida Trajano de Araujo Viana n\xBA 2500')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body color-ui-black'},'Contagem - MG - CEP 32010-090')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body color-ui-black'},'CNPJ/MF: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'03.613.421/0001-86'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 px-md-3 py-3',role:'article'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Regulamentos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'O cat\xE1logo de pr\xEAmios, dispon\xEDvel para acesso em',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host),' ou por meio de redirecionamento diretamente do hotsite de Programas de Relacionamento, Campanhas de Incentivo e A\xE7\xF5es (\u201CPremmiar\u201D ou \u201CPlataforma\u201D), \xE9 uma plataforma online que permite a voc\xEA (doravante \u201CUsu\xE1rio\u201D), participante de determinada campanha de incentivo, desenvolvida por um gestor de campanhas, contratante da Premmiar (\u201CGestor\u201D), trocar seus pontos adquiridos em tal campanha por produtos ou servi\xE7os disponibilizados por nossas empresas parceiras (\u201CParceiros\u201D), indicadas na Plataforma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Dessa forma, os presentes Termos de Uso (\u201CTermos\u201D) estipulam as regras para utiliza\xE7\xE3o da Plataforma pelos Usu\xE1rios, e est\xE3o dispon\xEDveis para acesso, a qualquer momento, por meio do link',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/terms',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/terms')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Aplicam-se aos presentes Termos, ainda, o quanto disposto na Pol\xEDtica de Privacidade, dispon\xEDvel para acesso em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/privacy',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/privacy')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Em caso de quaisquer d\xFAvidas sobre o quanto disposto nestes Termos, o Usu\xE1rio dever\xE1 entrar em contato com a Premmiar por meio da p\xE1gina \u201CFale Conosco\u201D, dispon\xEDvel em',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/redirect/contact',target:'_blank',className:'txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,window.location.host,'/redirect/contact')),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'1. ACEITA\xC7\xC3O DESTES TERMOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.1. A presente Campanha constituindo-se em um Ato Unilateral com promessa de recompensa, conforme o disposto nos artigos 854 e seguintes do C\xF3digo Civil, sendo realizada em todo o territ\xF3rio nacional, durante o per\xEDodo de 01 de julho de 2020 a 30 de setembro de 2020.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.2. Esta Campanha ser\xE1 direcionada aos pontos de venda participantes do programa de relacionamento "Vale Mais PETRONAS", pertencentes as categorias Gold, Platinum e Titanium e que comercializam produtos PETRONAS Syntium, PETRONAS Sprinta e PETRONAS Urania, nas vers\xF5es Mineral, Semissint\xE9tico e Sint\xE9tico.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'1.3. A finalidade desta Campanha \xE9 incentivar, motivar, relacionar, fidelizar, monitorar e incrementar as vendas dos produtos PETRONAS exclusivamente por meio dos pontos de venda participantes, recompensando-as desde que sejam cumpridas todas as condi\xE7\xF5es aqui definidas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2. DA PARTICIPA\xC7\xC3O')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.1. Poder\xE3o participar desta campanha os pontos de venda dos canais relacionados abaixo, que comercializam produtos PETRONAS, participantes do programa de relacionamento "Vale Mais PETRONAS", desde que pertencentes as categorias e canais abaixo mencionados e observadas as demais regras de participa\xE7\xE3o adiante estabelecidas:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1'},'Categorias: Titanium, Platinum e Gold'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,' Canais:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-body-sm mt-1'},'1. Autope\xE7a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-body-sm'},'2. Centro Automotivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-body-sm'},'3. Concessionaria '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-body-sm'},'4. Loja de Pneu'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-body-sm'},'5. Oficina Mec\xE2nica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'txt-body-sm'},'6. Troca de \xF3leo'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'Para participar desta campanha, os pontos de venda eleg\xEDveis dever\xE3o, durante o per\xEDodo de participa\xE7\xE3o, realizar compras de produtos PETRONAS eleg\xEDveis junto ao seu respectivo Distribuidor Autorizado PETRONAS.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.3. Fica desde j\xE1 estabelecido que a venda de 01 (um) litro de um produto PETRONAS gerar\xE1 uma quantidade de pontos previamente determinada, conforme abaixo:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-lg-8 txt-center py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row txt-bold align-items-center pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'TIPO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'Sint\xE9tico')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'PETRONAS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'SYNTIUM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'1 ponto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'3 pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'5 pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'PETRONAS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'URANIA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'1 ponto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'3 pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'5 pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'PETRONAS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'URANIA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'1 ponto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'3 pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},'5 pontos'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'*Lista com detalhe de produtos participantes no ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#anexo1'},'anexo 1.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4. Para efetiva\xE7\xE3o da participa\xE7\xE3o e atribui\xE7\xE3o dos pontos gerados, o representante do ponto de venda dever\xE1 acessar o site ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.valemaispetronas.com.br/'},'www.valemaispetronas.com.br'),', fazer o login na \xE1rea reservada para esta campanha e cadastrar as informa\xE7\xF5es de acordo com os dados ali solicitados.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4.1. Caso seja o primeiro acesso ao site da campanha e o ponto de venda n\xE3o seja participante do \u201CVale Mais PETRONAS\u201D dever\xE1 efetuar o seu cadastro informando os dados solicitados, aceitar os termos do regulamento, al\xE9m de criar um login e senha para futuros acessos visando consultas, novos cadastros e/ou resgates. Ap\xF3s essa etapa o cadastro ser\xE1 validado pela PETRONAS caso o ponto de venda atenda os crit\xE9rios de participa\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4.2. Mesmo sendo membro do \u201CVale Mais PETRONAS\u201D no primeiro acesso para a efetiva\xE7\xE3o de sua participa\xE7\xE3o nesta campanha, ser\xE1 necess\xE1rio indicar o aceite aos termos deste regulamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'2.4.3. O ponto de venda somente ser\xE1 considerado participante do programa de relacionamento \u201CVale Mais PETRONAS\u201D ap\xF3s realizar o cadastro acima, sendo que os pontos somente ser\xE3o contabilizados para compras realizadas ap\xF3s a efetiva\xE7\xE3o do mesmo cadastro.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3. DO RESGATE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.1. Os pontos de venda participantes, desde que observadas as regras deste Regulamento, poder\xE3o realizar o resgate da pontua\xE7\xE3o atrav\xE9s do site ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.valemaispetronas.com.br/'},'www.valemaispetronas.com.br'),', at\xE9 dia 31 de outubro de 2020. Ap\xF3s esse prazo todos os pontos acumulados ser\xE3o automaticamente expirados.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.1.1. Os pontos ser\xE3o creditados em at\xE9 15 (quinze) dias \xFAteis do m\xEAs subsequente de compra do ponto de vendas junto ao Distribuidor Autorizado PETRONAS. Os pontos provenientes de produtos de pedidos devolvidos ou cancelados pelo ponto de venda ao Distribuidor Autorizado PETRONAS nesse per\xEDodo, em nenhuma hip\xF3tese, ser\xE3o computados, para fins desta campanha.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2 As Revendas participantes que possu\xEDrem o cadastro, ou seja, que tamb\xE9m participam do \u201CVale Mais PETRONAS\u201D, al\xE9m de acumularem a pontua\xE7\xE3o obtida, poder\xE3o optar pelo resgate m\xEDnimo de 400 pontos em produtos PETRONAS ou ainda, a pontua\xE7\xE3o necess\xE1ria para cada para item dispon\xEDvel no Cat\xE1logo de produtos dentro do site ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.valemaispetronas.com.br/'},'www.valemaispetronas.com.br'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.1. Para ter acesso as condi\xE7\xF5es de resgate de produtos dispon\xEDveis no Cat\xE1logo do \u201CVale Mais PETRONAS\u201D basta acessar o site ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.valemaispetronas.com.br/'},'www.valemaispetronas.com.br'),', onde tamb\xE9m est\xE1 dispon\xEDvel o regulamento completo da referida Campanha.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.2.2. A validade e condi\xE7\xF5es de regaste dos pontos para os participantes do \u201CVale Mais PETRONAS\u201D seguir\xE3o as regras do regulamento do referido programa de relacionamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.3. Ap\xF3s cumprir as condi\xE7\xF5es, na forma acima descrita, o ponto de venda participante, atrav\xE9s de seu representante, poder\xE1 realizar o resgate acessando o site da Campanha \u201CVale Mais PETRONAS\u201D e seguir as orienta\xE7\xF5es de resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.3.1. No pr\xF3prio site, ao escolher o produto que deseja e estando dispon\xEDvel, dever\xE1 confirmar o endere\xE7o para a sua entrega.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.4. O produto escolhido no momento do resgate ser\xE1 entregue sem custo adicional no endere\xE7o indicado em at\xE9 45 dias da confirma\xE7\xE3o da transa\xE7\xE3o de resgate realizada na forma deste regulamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.4.1. O produto ser\xE1 entregue em embalagem lacrada, em perfeito estado de uso, devendo o representante do ponto de venda verificar a sua integridade no momento de seu recebimento. Em caso de defeito, entrar em contato imediatamente ap\xF3s o seu recebimento com a Realizadora atrav\xE9s de contato com a central de atendimento no telefone (11) 3514-7678.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'3.5. N\xE3o ser\xE1 permitida a comercializa\xE7\xE3o e/ou troca de produto exclusivo PETRONAS escolhido no momento do resgate por qualquer outro, tampouco sua convers\xE3o em dinheiro.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'4. DIVULGA\xC7\xC3O DA CAMPANHA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.1. A Campanha ser\xE1 divulgada atrav\xE9s dos Distribuidores Autorizados PETRONAS junto aos pontos de venda que comercializam produtos PETRONAS e outros meios a crit\xE9rio exclusivo da empresa realizadora.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'4.2. Este regulamento estar\xE1 dispon\xEDvel na \xEDntegra no site ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.valemaispetronas.com.br/'},'www.valemaispetronas.com.br')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5. CONSIDERA\xC7\xD5ES GERAIS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.1. A participa\xE7\xE3o nesta Campanha implica na aceita\xE7\xE3o total de todos os itens deste Regulamento, que poder\xE1 ser alterado pela Realizadora tantas vezes quanto necess\xE1rio, a seu exclusivo crit\xE9rio, com posterior divulga\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.2. A Campanha, por exclusivo crit\xE9rio da Realizadora, poder\xE1 ser interrompida ou encerrada a qualquer tempo. Nesses casos, todas as informa\xE7\xF5es pertinentes ser\xE3o amplamente divulgadas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.3. Ser\xE3o automaticamente desclassificados os participantes que descumprirem os itens do presente regulamento, agirem de m\xE1-f\xE9 ou que, de alguma forma, burlarem as regras e condi\xE7\xF5es deste Regulamento ou utilizarem mecanismos fraudulentos ou il\xEDcitos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.4. Os pontos de venda participantes, por meio de seus representantes legais, e os demais participantes, concordam em autorizar o uso de suas imagens, nomes e dados pessoais, em relat\xF3rios, filmes, v\xEDdeos, m\xEDdias sociais, fotos e cartazes, an\xFAncios em jornais e revistas, pelo prazo 5 (cinco) ano ap\xF3s o encerramento desta Campanha, para divulga\xE7\xE3o de sua participa\xE7\xE3o, bem como do resgate de produtos conforme condi\xE7\xF5es aqui estabelecidas, sem nenhum \xF4nus para a Realizadora.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.4.1. As autoriza\xE7\xF5es descritas acima n\xE3o implicam em qualquer obriga\xE7\xE3o de divulga\xE7\xE3o ou de pagamento de qualquer quantia por parte da Realizadora.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.5. A participa\xE7\xE3o nesta Campanha \xE9 volunt\xE1ria, facultativa e gratuita, n\xE3o havendo qualquer san\xE7\xE3o \xE0quelas Revendas que optarem por n\xE3o participar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.6. As d\xFAvidas n\xE3o esclarecidas pelo presente Regulamento ser\xE3o dirimidas por um Comit\xEA Interno da Realizadora, de forma soberana e irrecorr\xEDvel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.7. A Realizadora n\xE3o ser\xE1 responsabilizada por qualquer evento decorrente de caso fortuito ou for\xE7a maior, nos termos da lei.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'5.8. Fica eleito o foro da Comarca de Belo Horizonte/MG como competente para solucionar quaisquer quest\xF5es oriundas do presente Regulamento.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'anexo1',className:'txt-body-sm txt-uppercase mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'ANEXO 1 - [LISTA DE PONTOS POR PRODUTO]'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-center my-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold pb-1'},'C\xD3DIGO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2054B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2B54B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2057B087J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'20541100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2057B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2B57B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2053B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2046B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2B46B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2048B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2B51B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2051B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C21B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C20B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C211100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C201100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C22B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1817B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C19B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1833B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1816B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18161100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18171100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C191100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C17B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C171100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1815B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18871100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1807B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1887B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18071100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18151100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1886B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1B07B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18541100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18121100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1854B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18861100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1812B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'18361100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1855B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1813B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21811910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21841910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21841100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2184B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21861910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21871100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21851100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C231100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21871910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2181B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21791100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21711100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21851910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21371100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21861100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2B301910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21711910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21811100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'13531100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21791910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2179B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21371910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'13531910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2137B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1C231910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'2186B091J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21781100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21781910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21031910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21031100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'13391100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'13391910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'13471100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21821100J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'13471910J'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'21831910J')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold pb-1'},'LINHA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Mineral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Semissint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Sint\xE9tico')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold pb-1'},'MARCA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SPRINTA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'SYNTIUM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold pb-1'},'DESCRI\xC7\xC3O PRODUTO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F300 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F300 ULT. 20W50 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA T300 (24X0,5L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F300 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA T300 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA T300 ULT. (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F500 10W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F500 15W50 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F500 15W50 ULT. (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F700 E 10W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F900 ULT. 10W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SPRINTA F900 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 300 20W50 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 500 15W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 300 20W50 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 500 15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 300 25W60 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 500 20W50 API SN (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 500 20W50 APISN(1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 15W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 SE SN+ 15W40(24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 HM 15W50 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 1000 10W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 1000 10W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 SE SN+15W40(1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 SE SN+10W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 800 SE SN+10W30(1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 5W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 XS 5W30 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 FR 5W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 XS 5W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 FR 5W30 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 7000 HYBRID SN+ (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 5W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 5000 DX 5W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 FR MZD 5W30(24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 BV 5W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 7000 0W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 BV 5W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 5000 DX 5W30 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 7000 HYBRID SN+ (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 7000 0W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 7000 0W20 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 7000 E 0W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 5000 AV 5W30 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 5000 FR 5W20 (24x1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 E 5W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS SYNTIUM 3000 E 5W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 1000 15W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000 SE 15W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000 SE 15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000 SE 15W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 800 25W60 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 800 25W50 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 1000 HM 20W50 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000E CI-4+15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 800 25W50 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 1000 15W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000 15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA CF 40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 1000 HM 20W50 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 500 40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 800 25W60 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA 3000 LS 15W-40 CK-4 (1x20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA CF 40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'URANIA 3000 LS 15W-40 CK-4 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 1000 15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA LD 7 15W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000 15W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000 15W40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 500 40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA LD 7 15W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 500 40 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 3000E CI-4+15W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 800 25W60 (24X1L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 5000 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 5000 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA K 10W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA K 10W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 100 K 10W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 100 K 10W40 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA F.E. 5W30 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 5000 SE 10W40 (1X200L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA F.E. 5W30 (1X20L)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'PETRONAS URANIA 5000 F 5W30 (1X20L)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body txt-bold pb-1'},'EMBALAGEM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 Litro '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tambor 200 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Bombona 20 L'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mb-2'},'\xDAltima atualiza\xE7\xE3o: 07/02/2020')))))))));};/* harmony default export */ __webpack_exports__["a"] = (RegulationDefault);

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MyOrders__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var myOrders=_ref.myOrders,router=_ref.router,packageSize=_ref.pointsPurchase.config.packageSize;var products=[];if(myOrders&&myOrders.orders&&myOrders.orders.length>0){myOrders.orders.map(function(order,index){return order.vendorOrderModel.map(function(vendor,index){return vendor.items.map(function(product,index){var trackingStatusDescription=mapOrderStatus(order.orderStatus);products.push({imageUrl:product.imageUrl,name:product.name,quantity:product.quantity,sellingPrice:product.sellingPrice,deliveryForecast:vendor.deliveryForecast,trackingStatusDescription:trackingStatusDescription,orderPaymentDetailMoneyAndPoints:order.orderPaymentDetailMoneyAndPoints,paymentType:order.paymentType,vendorName:vendor.vendorName,parentOrderId:order.parentOrderId,orderId:vendor.orderId,id:product.id,costPrice:product.costPrice,vendorId:vendor.vendorId,vendorType:vendor.vendorType});});});});products=products.filter(function(item,index,self){return index===self.findIndex(function(t){return t.orderId===item.orderId&&t.id===item.id;});});}var queryStringValues=__WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(router.location.search);var result={productOrders:products,hasMoreItems:myOrders.hasMoreItems,page:myOrders.page,ready:myOrders.ready,loading:myOrders.loading,daysFilter:queryStringValues&&queryStringValues.days&&!isNaN(parseInt(queryStringValues.days))?parseInt(queryStringValues.days):__WEBPACK_IMPORTED_MODULE_3____["d" /* constants */].DEFAULTDAYSFILTER,currentRoute:router.location.pathname+router.location.search,packageSize:packageSize};return result;};var mapOrderStatus=function mapOrderStatus(orderStatus){var status;switch(orderStatus){case 1:status='Confirmado';break;case 2:status='Pendente';break;case 3:status='Estornado';break;case 4:status='Pendente';break;case 5:status='Confirmado';break;case 6:status='Cancelado';break;case 7:status='Estornado';break;case 8:status='Cancelado';break;case 9:status='Pendente';break;case 10:status='Cancelado';break;case 11:status='Cancelado';break;case 12:status='Confirmado';break;case 13:status='Cancelado';break;case 14:status='Cancelado';break;case 15:status='Cancelado';break;case 16:status='Cancelado';break;case 17:status='Pendente';break;case 18:status='Estornado';break;case 19:status='Estornado';break;}return status;};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadMyOrders:function loadMyOrders(pageIndex,pageSize,initialDate,endDate){dispatch(__WEBPACK_IMPORTED_MODULE_3____["c" /* actions */].loadMyOrders(pageIndex,pageSize,initialDate,endDate));},resetMyOrders:function resetMyOrders(){return dispatch(__WEBPACK_IMPORTED_MODULE_3____["c" /* actions */].resetMyOrders());},setFilterQueryString:function setFilterQueryString(days){return dispatch(__WEBPACK_IMPORTED_MODULE_3____["c" /* actions */].setFilterQueryString(days));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__MyOrders__["a" /* default */]));

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_order_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_order_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8____ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductOrderList__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Title__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MyOrdersPlaceholderItem__ = __webpack_require__(1491);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyOrders=function(_Component){_inherits(MyOrders,_Component);function MyOrders(props){_classCallCheck(this,MyOrders);var _this=_possibleConstructorReturn(this,(MyOrders.__proto__||Object.getPrototypeOf(MyOrders)).call(this,props));_this.loadMyOrders=function(page,days){if(_this.props.hasMoreItems){var initialDate=days!==undefined?__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.endDate).subtract(days,'days').toDate():undefined;initialDate&&_this.setState({initialDate:initialDate});if(!_this.props.loading||_this.props.page===0){_this.props.loadMyOrders(page!==undefined?page:_this.props.page+1,_this.state.pageSize,'','');}}};_this.selectOnChange=function(e){_this.props.setFilterQueryString(e.value);};_this.state={endDate:new Date(),initialDate:__WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).subtract(_this.props.daysFilter,'days').toDate(),pageSize:10};_this.selectOnChange=_this.selectOnChange.bind(_this);return _this;}_createClass(MyOrders,[{key:'componentDidMount',value:function componentDidMount(){this.loadMyOrders(0,this.props.daysFilter);this.selectOnChange({text:'no último 1 ano',value:365});}},{key:'render',value:function render(){var _this2=this;var products=[];if(this.props.ready)products=this.props.productOrders;else products=__WEBPACK_IMPORTED_MODULE_8____["d" /* constants */].PRODUCTSPLACEHOLDER;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Seus pedidos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-orders container-fluid px-0 px-md-1 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pl-2 pr-2 pb-2 pt-0 pt-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_App_Shell_LoggedSidebar__["a" /* default */],{selected:this.props.location.pathname,ready:this.props.ready}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-content col-12 col-lg-8 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Title__["a" /* Title */],{ready:this.props.ready})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_infinite_scroller___default.a,{pageStart:0,loadMore:function loadMore(){return _this2.loadMyOrders();},hasMore:this.props.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MyOrdersPlaceholderItem__["a" /* default */],{page:this.props.page}),key:10,initialLoad:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ProductOrderList__["a" /* ProductOrderList */],{productOrders:products,ready:this.props.ready,loading:this.props.loading,previousRoute:this.props.currentRoute,packageSize:this.props.packageSize})))))));}}]);return MyOrders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MyOrders.propTypes={location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,productOrders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,hasMoreItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loadMyOrders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,daysFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,setFilterQueryString:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,currentRoute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (MyOrders);

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductOrderList__ = __webpack_require__(1476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductOrderList__["a"]; });


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_order_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_order_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductOrderItem__ = __webpack_require__(1478);
var ProductOrderList=function ProductOrderList(props){var productOrderList=[];if(props.productOrders&&props.productOrders.length>0){props.productOrders.map(function(product,index){return productOrderList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductOrderItem__["a" /* ProductOrderItem */],{product:product,key:index,ready:props.ready,previousRoute:props.previousRoute,packageSize:props.packageSize}));});}else if(!props.loading){productOrderList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Empty__["a" /* default */],{key:1}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orders-item row'},productOrderList);};ProductOrderList.propTypes={productOrders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,previousRoute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProductOrderList);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_order_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_order_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var ProductOrderItemEmpty=function ProductOrderItemEmpty(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orders-item row py-3 col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-auto ml-auto bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_package txt-headline color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-auto ml-auto  clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 col-md-4 mr-auto ml-auto mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-center txt-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Voc\xEA ainda n\xE3o fez nenhum pedido.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-center txt-body-sm mt-1'},'Aproveite nossas ofertas e comece a resgatar agora mesmo!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 col-md-4 mr-auto ml-auto  mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/search',className:'btn btn-sm btn-featured txt-center txt-uppercase',role:'link'},'Ver produtos')));};/* harmony default export */ __webpack_exports__["a"] = (ProductOrderItemEmpty);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductOrderItem__ = __webpack_require__(1479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductOrderItem__["a"]; });


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_order_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_order_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_ProductImage__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductDetails__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewProdutOrderDetail__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(5);
var ProductOrderItem=function ProductOrderItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 order-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2',to:'/order/'+props.product.parentOrderId+'/'+props.product.orderId+'/product/'+props.product.id+'?previousRoute='+props.previousRoute,title:'Ver as informa\xE7\xF5es do pedido '+props.product.orderId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-number col-auto txt-center px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-body-sm color-ui-2 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.product.parentOrderId?'#'+props.product.parentOrderId:'')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-3 col-sm-2 txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_features_ProductImage__["a" /* ProductImage */],{name:props.product.name,alt:'',imageUrl:props.product.imageUrl,vendorId:props.product.vendorId,vendorType:props.product.vendorType,ready:props.ready})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-subtitle color-ui-2 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.product.parentOrderId?'#'+props.product.parentOrderId:'')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductDetails__["a" /* ProductDetails */],{trackingStatus:props.product.trackingStatusDescription,name:props.product.name,sellingPrice:props.product.sellingPrice,quantity:props.product.quantity,deliveryDate:props.product.deliveryDate,vendorName:props.product.vendorName,vendorType:props.product.vendorType,ready:props.ready,orderPaymentDetailMoneyAndPoints:props.product.orderPaymentDetailMoneyAndPoints,paymentType:props.product.paymentType,costPrice:props.product.costPrice,packageSize:props.packageSize}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-action pos-relative col-3 txt-center d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ViewProdutOrderDetail__["a" /* ViewProdutOrderDetail */],{parentOrderId:props.product.parentOrderId,orderId:props.product.orderId,productId:props.product.id,ready:props.ready,previousRoute:props.previousRoute})))));};ProductOrderItem.propTypes={product:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,previousRoute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductOrderItem);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductDetails__ = __webpack_require__(1481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductDetails__["a"]; });


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Placeholder__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TrackingStatus__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__ = __webpack_require__(21);
var ProductDetails=function ProductDetails(props){var pointsUsedDecimal=props.orderPaymentDetailMoneyAndPoints&&props.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal;var purchaseValueDecimal=props.orderPaymentDetailMoneyAndPoints&&props.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal;var veryfyCustomMessage=function veryfyCustomMessage(props){var vendorName=props.vendorName;var vendorType=props.vendorType;switch(vendorType){case'Milhas':return'Transfer\xEAncia de pontos para '+vendorName;default:return props.name;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:props.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Placeholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TrackingStatus__["a" /* TrackingStatus */],{trackingStatus:props.trackingStatus,ready:props.ready}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-body-sm color-ui-2 mt-1'},veryfyCustomMessage(props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Valor: ',props.paymentType!==5&&props.vendorType!=='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:pointsUsedDecimal!==props.sellingPrice&&pointsUsedDecimal!==0?pointsUsedDecimal:props.sellingPrice}):' R$ '+addZeroes(purchaseValueDecimal),props.paymentType!==5&&props.vendorType!=='Compra de Pontos'&&purchaseValueDecimal!==0&&props.paymentType===2?' + R$ '+addZeroes(purchaseValueDecimal):'',props.vendorType==='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block'},'Quantidade: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.quantity*props.packageSize})):props.vendorType!=='Milhas'&&props.vendorType!=='Doação'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' x ',props.quantity,' unidades')),props.deliveryDate&&props.name!=='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Previs\xE3o de entrega:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.type!=='EXTERNALVOUCHERVIRTUAL'?props.deliveryDate:'')):'',props.vendorName&&props.vendorType!=='Compra de Pontos'&&props.vendorType!=='Milhas'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.vendorName)):''))));};function addZeroes(value){var newValue=value*1;newValue=newValue+'';var pos=newValue.indexOf('.');if(pos===-1)newValue=newValue+'.00';else{var integer=newValue.substring(0,pos);var decimals=newValue.substring(pos+1);while(decimals.length<2){decimals=decimals+'0';}newValue=integer+','+decimals;}return newValue.toString().replace('.',',');}ProductDetails.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,sellingPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,quantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,deliveryDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,vendorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,trackingStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,paymentType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,orderPaymentDetailMoneyAndPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductDetails);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrackingStatus__ = __webpack_require__(590);
var ProductDetails=function ProductDetails(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TrackingStatus__["a" /* TrackingStatus */],{ready:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius mt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})));};/* harmony default export */ __webpack_exports__["a"] = (ProductDetails);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Placeholder__ = __webpack_require__(1484);
var TrackingStatus=function TrackingStatus(props){var iconClassName='';var classColorText='';switch(props.trackingStatus){case'Cancelado':classColorText='color-error h4';// Cancelado
iconClassName='icon icon_close_circle color-error h4  d-inline-block';// Cancelado
break;case'Entregue':classColorText='color-success';// Pedido Realizado
iconClassName='icon icon_check_circle color-success h4  d-inline-block';// Pedido Realizado
break;case'Confirmado':classColorText='color-success';// Confirmado
iconClassName='icon icon_check_circle color-success h4  d-inline-block';// Confirmado
break;case'Seu produto foi solicitado':classColorText='color-success';iconClassName='icon icon_check_circle color-success h4  d-inline-block';break;case'Confirmado pelo parceiro':classColorText='color-success';iconClassName='icon icon_check_circle color-success h4  d-inline-block';break;case'Enviado para a transportadora':classColorText='color-success';// Enviado para a transportadora
iconClassName='icon icon_truck color-success h4  d-inline-block';// Enviado para a transportadora
break;case'Em rota de entrega':classColorText='color-success';// Enviado para a transportadora
iconClassName='icon icon_truck color-success h4  d-inline-block';// Enviado para a transportadora
break;case'Produto com dificuldade na entrega':classColorText='color-warning';// Produto com dificuldade na entrega
iconClassName='icon icon_truck color-warning h4  d-inline-block';// Produto com dificuldade na entrega
break;case'Estamos indo recolher o produto para troca':classColorText='color-success';iconClassName='icon icon_truck color-success h4  d-inline-block';break;case'Produto foi recolhido':classColorText='color-success';iconClassName='icon icon_check_circle color-success h4  d-inline-block';break;case'Produto não pôde ser recolhido':classColorText='color-error';iconClassName='icon icon_truck color-error h4  d-inline-block';break;case'Estornado':classColorText='color-error';iconClassName='icon icon_truck color-error h4  d-inline-block';break;default:classColorText='';iconClassName='icon icon_check_circle h4  d-inline-block';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:props.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Placeholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:iconClassName,'aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body py-half '+classColorText+' txt-body'},props.trackingStatus))));};TrackingStatus.propTypes={trackingStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (TrackingStatus);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block radius-circle bg-ui-3 px-1 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 py-half bg-ui-3 radius'}))))));};/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ViewProdutOrderDetail__ = __webpack_require__(1486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ViewProdutOrderDetail__["a"]; });


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Placeholder__ = __webpack_require__(1487);
var ViewProdutOrderDetail=function ViewProdutOrderDetail(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:props.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Placeholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'mx-auto',to:'/order/'+props.parentOrderId+'/'+props.orderId+'/product/'+props.productId+'?previousRoute='+props.previousRoute,title:'Ver as informa\xE7\xF5es do pedido '+props.orderId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'btnDetalhe-'+props.parentOrderId+'-'+props.orderId,className:'btn btn-sm',text:'Ver detalhes'})));};ViewProdutOrderDetail.propTypes={parentOrderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,orderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,productId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,previousRoute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ViewProdutOrderDetail);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 txt-body-sm bg-ui-4 radius'});};/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Title__ = __webpack_require__(1489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Title__["a"]; });


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Placeholder__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var Title=function Title(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_placeholder___default.a,{ready:props.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Placeholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-title txt-font-body txt-initial color-title mr-auto'},'Pedidos')));};Title.propTypes={ready:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 py-half txt-body-sm bg-ui-3 radius'})));};/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_placeholder_svg__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_placeholder_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_placeholder_svg__);
var MyOrdersPlaceholderItem=function MyOrdersPlaceholderItem(props){return props.page===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-3 txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_placeholder_svg___default.a,alt:'Ainda est\xE1 carregando...'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius mt-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'}))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'});};MyOrdersPlaceholderItem.propTypes={page:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (MyOrdersPlaceholderItem);

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductOrderDetailContainer__ = __webpack_require__(1493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductOrderDetailContainer__["a"]; });


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductOrderDetail__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(_ref,ownProps){var _ref$myOrders=_ref.myOrders,parentOrderDetail=_ref$myOrders.parentOrderDetail,orderDetail=_ref$myOrders.orderDetail,tracking=_ref$myOrders.tracking,productDetail=_ref$myOrders.productDetail,orderDetailNotFoundRedux=_ref$myOrders.orderDetailNotFoundRedux,orderDetailNotFound=_ref$myOrders.orderDetailNotFound,router=_ref.router,vouchers=_ref.stores.vouchers,packageSize=_ref.pointsPurchase.config.packageSize;var queryStringValues=__WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(router.location.search);var trackingAlternative=productDetail&&{statuses:[{status:'1',name:'Produto solicitado',when:productDetail.insertDate},{status:'2',name:'Produto confirmado no parceiro',when:null},{status:'3',name:'Produto enviado para a transportadora',when:null},{status:'4',name:'Produto em rota de entrega',when:null},{status:'5',name:'Produto entregue',when:null}]};return{parentOrderDetail:parentOrderDetail,orderDetail:orderDetail,tracking:tracking,productDetail:productDetail,previousRoute:queryStringValues.previousRoute,orderDetailNotFoundRedux:orderDetailNotFoundRedux,orderDetailNotFound:orderDetailNotFound,stores:[].concat(_toConsumableArray(vouchers)),trackingAlternative:trackingAlternative,packageSize:packageSize};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{getVoucherLink:function getVoucherLink(data){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].getVoucherLink(data));},getOrderListDetails:function getOrderListDetails(fromOrderDetail){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].getOrderListDetails(ownProps.match.params.parentOrderId,ownProps.match.params.orderId,ownProps.match.params.productId,fromOrderDetail));},redirect:function redirect(path){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["push"])(path));},getOrderDetailsApi:function getOrderDetailsApi(){return dispatch(__WEBPACK_IMPORTED_MODULE_1____["c" /* actions */].getOrderDetailsApi(ownProps.match.params.parentOrderId,ownProps.match.params.orderId,ownProps.match.params.productId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__ProductOrderDetail__["a" /* default */]));

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_features_AboutOrder__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductSide__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_features_Regulation__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductOrderDetail=function(_Component){_inherits(ProductOrderDetail,_Component);function ProductOrderDetail(props){_classCallCheck(this,ProductOrderDetail);var _this=_possibleConstructorReturn(this,(ProductOrderDetail.__proto__||Object.getPrototypeOf(ProductOrderDetail)).call(this,props));_this.state={voucherLinkResponse:null,hasErrors:false,showPlaceholder:false};_this.handleVoucherLink=_this.handleVoucherLink.bind(_this);_this.openVoucherLink=_this.openVoucherLink.bind(_this);return _this;}_createClass(ProductOrderDetail,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.getOrderListDetails(true);var trackingClient=__WEBPACK_IMPORTED_MODULE_7_redux_clients__["a" /* default */].tracking.client,client=__WEBPACK_IMPORTED_MODULE_7_redux_clients__["a" /* default */].cloudloyalty.client;this.client=client;this.tracking=trackingClient;this.trackingHandler();setTimeout(function(){_this2.setState({showPlaceholder:true});},4000);}},{key:'handleVoucherLink',value:function handleVoucherLink(model){var _this3=this;this.client.post('/v1/purchases/voucherLink',model).then(function(response){response.data&&response.data.voucherLink?_this3.openVoucherLink(response.data.voucherLink)&&_this3.setState({voucherLinkResponse:response.data}):_this3.setState({voucherLinkResponse:response.data});}).catch(function(ex){return _this3.setState({hasErrors:true});});}},{key:'trackingHandler',value:function trackingHandler(){var _this4=this;if(!this.props.orderDetail)return;var sku=this.props.productDetail&&this.props.productDetail.productCode;if(sku){var splitSku=sku.split('-');if(splitSku.length>0)sku=splitSku[0];}this.props.orderDetail.orderId&&this.tracking.get('/timelines/'+this.props.orderDetail.orderId+'/items/'+sku).then(function(result){_this4.setState({trackingObject:result.data});});}},{key:'openVoucherLink',value:function openVoucherLink(link){var url='http://'+link;window.open(url,'_blank');}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.orderDetailNotFoundRedux){this.props.getOrderDetailsApi();}if(this.props.orderDetail!==prevProps.orderDetail){this.trackingHandler();}if(JSON.stringify(this.props.match.params)!==JSON.stringify(prevProps.match.params)){this.props.getOrderListDetails();}}},{key:'render',value:function render(){var _this5=this;return this.props.parentOrderDetail&&this.props.orderDetail&&this.props.productDetail?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid pt-1 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-0 pt-md-5 pb-0 py-md-4 px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-5 pt-md-0'},this.state.hasErrors?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loyal_react__["Alert"],{isError:true,title:'Erro ao consultar o Voucher.'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_features_Regulation__["a" /* Regulation */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductSide__["b" /* ProductSide */],Object.assign({},this.state,{trackingAlternative:this.props.trackingAlternative,productDetail:this.props.productDetail,parentOrderDetail:this.props.parentOrderDetail,orderDetail:this.props.orderDetail,tracking:this.state.trackingObject,previousRoute:this.props.previousRoute,getVoucherLink:this.props.getVoucherLink,handleVoucherLink:this.handleVoucherLink,storeConfiguration:this.props.stores.find(function(store){return store.supplierId===_this5.props.orderDetail.vendorId;}),packageSize:this.props.packageSize})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_features_AboutOrder__["a" /* AboutOrder */],{parentOrder:this.props.parentOrderDetail})))):'';}}]);return ProductOrderDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductOrderDetail.propTypes={trackingAlternative:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,parentOrderDetail:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,orderDetail:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,tracking:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,productDetail:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,getOrderListDetails:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,previousRoute:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,orderDetailNotFoundRedux:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,getOrderDetailsApi:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,getVoucherLink:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,match:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,stores:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,packageSize:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductOrderDetail);

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderPointsAndCash__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderInfo__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddressInfo__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__About__ = __webpack_require__(208);
var AboutOrder=function AboutOrder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__About__["a" /* About */],{campaignHasDonation:props.campaignHasDonation,title:' Sobre o pedido'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OrderPointsAndCash__["a" /* default */],{paymentDetailMoneyAndPoints:props.parentOrder.orderPaymentDetailMoneyAndPoints}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OrderInfo__["a" /* default */],{parentOrder:props.parentOrder}),props.parentOrder&&props.parentOrder.vendorOrderModel&&props.parentOrder.vendorOrderModel[0].vendorType!=='Milhas'&&props.parentOrder.vendorOrderModel[0].vendorType!=='Doação'&&props.parentOrder.vendorOrderModel[0].vendorType!=='Compra de Pontos'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AddressInfo__["a" /* default */],{address:props.parentOrder.address,receiver:props.parentOrder.receiver}));};AboutOrder.propTypes={parentOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,campaignHasDonation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (AboutOrder);

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var OrderPointsAndCash=function OrderPointsAndCash(props){return props.paymentDetailMoneyAndPoints&&props.paymentDetailMoneyAndPoints.isDisplay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'w-100',src:props.paymentDetailMoneyAndPoints.imageUrlCardBrand,alt:'Bandeiras da operadora do cart\xE3o de cr\xE9dito'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Cart\xE3o:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'XXXX-XXXX-XXXX-',props.paymentDetailMoneyAndPoints.lastCreditCardDigits)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.paymentDetailMoneyAndPoints.numberParcels,'x R$',props.paymentDetailMoneyAndPoints.valueParcel)))):'';};OrderPointsAndCash.propTypes={paymentDetailMoneyAndPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (OrderPointsAndCash);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Shared_CurrencyLabel__ = __webpack_require__(21);
/* eslint-disable react/jsx-indent *//* eslint-disable indent */var OrderInfo=function OrderInfo(props){var getCashbackValue=function getCashbackValue(cashbackRule,price){switch(cashbackRule){case'1':return Math.floor(0.05*price);case'2':return Math.round(price);case'3':return Math.round(2*price);default:return 0;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'line-date-order txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Resgate realizado em: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(props.parentOrder.orderDate).format('DD/MM/YYYY [às] HH[h]mm'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'line-value-total txt-body-sm txt-subtitle txt-font-body color-ui-2'},props.parentOrder&&props.parentOrder.vendorOrderModel&&props.parentOrder.vendorOrderModel[0].vendorName==='Compra de Pontos'||props.parentOrder.paymentType===5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor Total em dinheiro: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ '+props.parentOrder.orderPaymentDetailMoneyAndPoints.valuePurchase)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor total em '+props.pointsName+':',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.parentOrder.totalItems}))),props.parentOrder&&props.parentOrder.vendorOrderModel&&props.parentOrder.vendorOrderModel[0].vendorName!=='Compra de Pontos'&&props.parentOrder.orderPaymentDetailMoneyAndPoints&&props.parentOrder.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'line-complement-value txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Complemento em dinheiro: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ '+props.parentOrder.orderPaymentDetailMoneyAndPoints.valuePurchase)):'',props.parentOrder.orderPromoCodeValue?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'line-discount-coupon txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Desconto em '+props.pointsName+': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.parentOrder.orderPromoCodeValue})):'',props.parentOrder.vendorOrderModel?props.parentOrder.vendorOrderModel.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line-shipping-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},element.totalShippingValue===0||element.vendorName==='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},props.parentOrder.paymentType===5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor do frete '+element.vendorName+':',' ','R$ '+addZeroes(element.totalShippingCurrencyValue)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor do frete '+element.vendorName+':',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:element.totalShippingValue})))),props.parentOrder&&props.parentOrder.vendorOrderModel&&props.parentOrder.vendorOrderModel[0].vendorName!=='Compra de Pontos'&&props.parentOrder.paymentType===5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Cashback gerado: '+getCashbackValue(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_RULE_CASHBACK||'1',props.parentOrder.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal-element.totalShippingCurrencyValue)+' '+props.pointsName+' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Seus '+props.pointsName+' do Cashback estar\xE3o dispon\xEDveis em at\xE9 30 dias'))):'');}):''));};function addZeroes(value){// set everything to at least two decimals; removs 3+ zero decimasl, keep non-zero decimals
var newValue=value*1;// removes trailing zeros
newValue=newValue+'';// casts it to string
var pos=newValue.indexOf('.');if(pos===-1)newValue=newValue+'.00';else{var integer=newValue.substring(0,pos);var decimals=newValue.substring(pos+1);while(decimals.length<2){decimals=decimals+'0';}newValue=integer+','+decimals;}return newValue.toString().replace('.',',');}OrderInfo.propTypes={parentOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var onlyCash=_ref.onlyCash,currencyConfiguration=_ref.catalog.currencyConfiguration;return{pointsName:currencyConfiguration.pointsName,onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,null)(OrderInfo));

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var AddressInfo=function AddressInfo(props){return props.address?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-2  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.receiver)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.address.addressText+', '+props.address.number+' - '+props.address.complement)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.address.district+' - '+props.address.city+' - '+props.address.state+' - '+props.address.zipCode)))):'';};AddressInfo.propTypes={address:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,receiver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (AddressInfo);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrintButton__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var About=function About(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 mt-2 mb-2 mb-md-0 mt-md-0 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PrintButton__["a" /* default */],{campaignHasDonation:props.campaignHasDonation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block d-md-none row mx-0 px-0 py-1 border-color-ui-3 border-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 cart-back mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:props.previousRoute||'/my-orders/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{className:'btn btn-sm btn-flat btn-icon txt-left',iconName:'icon icon-sm icon_left',text:'Ver todos os pedidos'})))));};About.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,campaignHasDonation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,previousRoute:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive__);
var confirmationPage=window.location.pathname.substring(0,window.location.pathname.indexOf('/',2));var donationPage=function donationPage(){window.location.href='/donation';};/* eslint-disable */var PdfPrint=function PdfPrint(){__WEBPACK_IMPORTED_MODULE_3_html2canvas___default()(document.body).then(function(canvas){var imgData=canvas.toDataURL('image/png');var imgWidth=210;var pageHeight=295;var imgHeight=canvas.height*imgWidth/canvas.width;var heightLeft=imgHeight;var pdf=new __WEBPACK_IMPORTED_MODULE_4_jspdf___default.a('p','mm','a4',true);var position=0;pdf.addImage(imgData,'PNG',0,position,imgWidth,imgHeight,'','FAST');heightLeft-=pageHeight;while(heightLeft>=0){position=heightLeft-imgHeight;pdf.addPage();pdf.addImage(imgData,'PNG',0,position,imgWidth,imgHeight,'','FAST');heightLeft-=pageHeight;}pdf.save('print-order.pdf');});};/* eslint-enable */var PrintButton=function PrintButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2 pt-2 d-print-none'},confirmationPage==='/confirmation'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0'},props.campaignHasDonation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm  btn-icon',text:'Fazer uma doa\xE7\xE3o',iconName:'icon_donation',onClick:function onClick(){return donationPage();}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minDeviceWidth:476},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm  btn-cart btn-icon',text:'Imprimir Pedido',iconName:'icon_press',onClick:function onClick(){return window.print();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{maxDeviceWidth:475},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm  btn-cart btn-icon',text:'Imprimir Pedido',iconName:'icon_press',onClick:function onClick(){return window.print();}})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minDeviceWidth:476},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm  btn-cart btn-icon',text:'Imprimir Pedido',iconName:'icon_press',onClick:function onClick(){return window.print();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{maxDeviceWidth:475},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm  btn-cart btn-icon',text:'Imprimir Pedido',iconName:'icon_press',onClick:function onClick(){return window.print();}}))));};PrintButton.propTypes={campaignHasDonation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (PrintButton);

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.0.0-rc.5 <https://html2canvas.hertzen.com>
 * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.html2canvas = factory());
}(this, function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var Bounds = /** @class */ (function () {
        function Bounds(x, y, w, h) {
            this.left = x;
            this.top = y;
            this.width = w;
            this.height = h;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (clientRect) {
            return new Bounds(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
        };
        return Bounds;
    }());
    var parseBounds = function (node) {
        return Bounds.fromClientRect(node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 1.1.1 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup[base64.charCodeAt(i)];
            encoded2 = lookup[base64.charCodeAt(i + 1)];
            encoded3 = lookup[base64.charCodeAt(i + 2)];
            encoded4 = lookup[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    var base64 = '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';

    /* @flow */
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR = 2; //  Cause a line break (after), except between CR and LF
    var LF = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var UnicodeTrie = createTrieFromBase64(base64);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR, LF, NL];
    var SPACE = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indicies = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indicies.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indicies.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indicies.push(indicies[index - 1]);
                    return types.push(prev);
                }
                indicies.push(index);
                return types.push(AL);
            }
            indicies.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indicies, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED;
        }
        // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
        if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED;
        }
        // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
        if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI && next === RI) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED) { }
                if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var TokenType;
    (function (TokenType) {
        TokenType[TokenType["STRING_TOKEN"] = 0] = "STRING_TOKEN";
        TokenType[TokenType["BAD_STRING_TOKEN"] = 1] = "BAD_STRING_TOKEN";
        TokenType[TokenType["LEFT_PARENTHESIS_TOKEN"] = 2] = "LEFT_PARENTHESIS_TOKEN";
        TokenType[TokenType["RIGHT_PARENTHESIS_TOKEN"] = 3] = "RIGHT_PARENTHESIS_TOKEN";
        TokenType[TokenType["COMMA_TOKEN"] = 4] = "COMMA_TOKEN";
        TokenType[TokenType["HASH_TOKEN"] = 5] = "HASH_TOKEN";
        TokenType[TokenType["DELIM_TOKEN"] = 6] = "DELIM_TOKEN";
        TokenType[TokenType["AT_KEYWORD_TOKEN"] = 7] = "AT_KEYWORD_TOKEN";
        TokenType[TokenType["PREFIX_MATCH_TOKEN"] = 8] = "PREFIX_MATCH_TOKEN";
        TokenType[TokenType["DASH_MATCH_TOKEN"] = 9] = "DASH_MATCH_TOKEN";
        TokenType[TokenType["INCLUDE_MATCH_TOKEN"] = 10] = "INCLUDE_MATCH_TOKEN";
        TokenType[TokenType["LEFT_CURLY_BRACKET_TOKEN"] = 11] = "LEFT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_CURLY_BRACKET_TOKEN"] = 12] = "RIGHT_CURLY_BRACKET_TOKEN";
        TokenType[TokenType["SUFFIX_MATCH_TOKEN"] = 13] = "SUFFIX_MATCH_TOKEN";
        TokenType[TokenType["SUBSTRING_MATCH_TOKEN"] = 14] = "SUBSTRING_MATCH_TOKEN";
        TokenType[TokenType["DIMENSION_TOKEN"] = 15] = "DIMENSION_TOKEN";
        TokenType[TokenType["PERCENTAGE_TOKEN"] = 16] = "PERCENTAGE_TOKEN";
        TokenType[TokenType["NUMBER_TOKEN"] = 17] = "NUMBER_TOKEN";
        TokenType[TokenType["FUNCTION"] = 18] = "FUNCTION";
        TokenType[TokenType["FUNCTION_TOKEN"] = 19] = "FUNCTION_TOKEN";
        TokenType[TokenType["IDENT_TOKEN"] = 20] = "IDENT_TOKEN";
        TokenType[TokenType["COLUMN_TOKEN"] = 21] = "COLUMN_TOKEN";
        TokenType[TokenType["URL_TOKEN"] = 22] = "URL_TOKEN";
        TokenType[TokenType["BAD_URL_TOKEN"] = 23] = "BAD_URL_TOKEN";
        TokenType[TokenType["CDC_TOKEN"] = 24] = "CDC_TOKEN";
        TokenType[TokenType["CDO_TOKEN"] = 25] = "CDO_TOKEN";
        TokenType[TokenType["COLON_TOKEN"] = 26] = "COLON_TOKEN";
        TokenType[TokenType["SEMICOLON_TOKEN"] = 27] = "SEMICOLON_TOKEN";
        TokenType[TokenType["LEFT_SQUARE_BRACKET_TOKEN"] = 28] = "LEFT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["RIGHT_SQUARE_BRACKET_TOKEN"] = 29] = "RIGHT_SQUARE_BRACKET_TOKEN";
        TokenType[TokenType["UNICODE_RANGE_TOKEN"] = 30] = "UNICODE_RANGE_TOKEN";
        TokenType[TokenType["WHITESPACE_TOKEN"] = 31] = "WHITESPACE_TOKEN";
        TokenType[TokenType["EOF_TOKEN"] = 32] = "EOF_TOKEN";
    })(TokenType || (TokenType = {}));
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE$1 = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE$1;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: TokenType.LEFT_PARENTHESIS_TOKEN
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: TokenType.RIGHT_PARENTHESIS_TOKEN
    };
    var COMMA_TOKEN = { type: TokenType.COMMA_TOKEN };
    var SUFFIX_MATCH_TOKEN = { type: TokenType.SUFFIX_MATCH_TOKEN };
    var PREFIX_MATCH_TOKEN = { type: TokenType.PREFIX_MATCH_TOKEN };
    var COLUMN_TOKEN = { type: TokenType.COLUMN_TOKEN };
    var DASH_MATCH_TOKEN = { type: TokenType.DASH_MATCH_TOKEN };
    var INCLUDE_MATCH_TOKEN = { type: TokenType.INCLUDE_MATCH_TOKEN };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: TokenType.LEFT_CURLY_BRACKET_TOKEN
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: TokenType.RIGHT_CURLY_BRACKET_TOKEN
    };
    var SUBSTRING_MATCH_TOKEN = { type: TokenType.SUBSTRING_MATCH_TOKEN };
    var BAD_URL_TOKEN = { type: TokenType.BAD_URL_TOKEN };
    var BAD_STRING_TOKEN = { type: TokenType.BAD_STRING_TOKEN };
    var CDO_TOKEN = { type: TokenType.CDO_TOKEN };
    var CDC_TOKEN = { type: TokenType.CDC_TOKEN };
    var COLON_TOKEN = { type: TokenType.COLON_TOKEN };
    var SEMICOLON_TOKEN = { type: TokenType.SEMICOLON_TOKEN };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.LEFT_SQUARE_BRACKET_TOKEN
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: TokenType.RIGHT_SQUARE_BRACKET_TOKEN
    };
    var WHITESPACE_TOKEN = { type: TokenType.WHITESPACE_TOKEN };
    var EOF_TOKEN = { type: TokenType.EOF_TOKEN };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: TokenType.HASH_TOKEN, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: TokenType.AT_KEYWORD_TOKEN, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: TokenType.DELIM_TOKEN, value: fromCodePoint(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint.apply(void 0, endDigits), 16);
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: end };
            }
            else {
                return { type: TokenType.UNICODE_RANGE_TOKEN, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: TokenType.FUNCTION_TOKEN, value: value };
            }
            return { type: TokenType.IDENT_TOKEN, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: TokenType.URL_TOKEN, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === TokenType.STRING_TOKEN) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: TokenType.URL_TOKEN, value: fromCodePoint.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 60000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: TokenType.STRING_TOKEN, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: TokenType.DIMENSION_TOKEN, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: TokenType.PERCENTAGE_TOKEN, number: number, flags: flags };
            }
            return { type: TokenType.NUMBER_TOKEN, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === TokenType.WHITESPACE_TOKEN) {
                token = this.consumeToken();
            }
            if (token.type === TokenType.EOF_TOKEN) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === TokenType.WHITESPACE_TOKEN);
            if (token.type === TokenType.EOF_TOKEN) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === TokenType.EOF_TOKEN) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case TokenType.LEFT_CURLY_BRACKET_TOKEN:
                case TokenType.LEFT_SQUARE_BRACKET_TOKEN:
                case TokenType.LEFT_PARENTHESIS_TOKEN:
                    return this.consumeSimpleBlock(token.type);
                case TokenType.FUNCTION_TOKEN:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === TokenType.EOF_TOKEN || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: TokenType.FUNCTION
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === TokenType.EOF_TOKEN || token.type === TokenType.RIGHT_PARENTHESIS_TOKEN) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === TokenType.DIMENSION_TOKEN; };
    var isNumberToken = function (token) { return token.type === TokenType.NUMBER_TOKEN; };
    var isIdentToken = function (token) { return token.type === TokenType.IDENT_TOKEN; };
    var isStringToken = function (token) { return token.type === TokenType.STRING_TOKEN; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== TokenType.WHITESPACE_TOKEN; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== TokenType.WHITESPACE_TOKEN && token.type !== TokenType.COMMA_TOKEN;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === TokenType.COMMA_TOKEN) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== TokenType.WHITESPACE_TOKEN) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === TokenType.LEFT_CURLY_BRACKET_TOKEN && token.type === TokenType.RIGHT_CURLY_BRACKET_TOKEN) {
            return true;
        }
        if (type === TokenType.LEFT_SQUARE_BRACKET_TOKEN && token.type === TokenType.RIGHT_SQUARE_BRACKET_TOKEN) {
            return true;
        }
        return type === TokenType.LEFT_PARENTHESIS_TOKEN && token.type === TokenType.RIGHT_PARENTHESIS_TOKEN;
    };

    var isLength = function (token) {
        return token.type === TokenType.NUMBER_TOKEN || token.type === TokenType.DIMENSION_TOKEN;
    };

    var isLengthPercentage = function (token) {
        return token.type === TokenType.PERCENTAGE_TOKEN || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: TokenType.NUMBER_TOKEN,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (value) {
            if (value.type === TokenType.DIMENSION_TOKEN) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === TokenType.DIMENSION_TOKEN) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color = {
        name: 'color',
        parse: function (value) {
            if (value.type === TokenType.FUNCTION) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(value.values);
            }
            if (value.type === TokenType.HASH_TOKEN) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === TokenType.IDENT_TOKEN) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === TokenType.NUMBER_TOKEN) {
            return token.number;
        }
        if (token.type === TokenType.PERCENTAGE_TOKEN) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === TokenType.NUMBER_TOKEN ? deg(hue.number) : angle.parse(hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var PropertyDescriptorParsingType;
    (function (PropertyDescriptorParsingType) {
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["VALUE"] = 0] = "VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["LIST"] = 1] = "LIST";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["IDENT_VALUE"] = 2] = "IDENT_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TYPE_VALUE"] = 3] = "TYPE_VALUE";
        PropertyDescriptorParsingType[PropertyDescriptorParsingType["TOKEN_VALUE"] = 4] = "TOKEN_VALUE";
    })(PropertyDescriptorParsingType || (PropertyDescriptorParsingType = {}));

    var BACKGROUND_CLIP;
    (function (BACKGROUND_CLIP) {
        BACKGROUND_CLIP[BACKGROUND_CLIP["BORDER_BOX"] = 0] = "BORDER_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["PADDING_BOX"] = 1] = "PADDING_BOX";
        BACKGROUND_CLIP[BACKGROUND_CLIP["CONTENT_BOX"] = 2] = "CONTENT_BOX";
    })(BACKGROUND_CLIP || (BACKGROUND_CLIP = {}));
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return BACKGROUND_CLIP.PADDING_BOX;
                        case 'content-box':
                            return BACKGROUND_CLIP.CONTENT_BOX;
                    }
                }
                return BACKGROUND_CLIP.BORDER_BOX;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var parseColorStop = function (args) {
        var color$1 = color.parse(args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color$1, stop: stop } : { color: color$1, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [[0, 0], [0, height], [width, 0], [width, height]];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case CSSRadialExtent.CLOSEST_SIDE:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.CLOSEST_CORNER:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case CSSRadialExtent.FARTHEST_SIDE:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case CSSRadialExtent.FARTHEST_CORNER:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === CSSRadialShape.CIRCLE) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === CSSRadialShape.ELLIPSE) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: CSSImageType.LINEAR_GRADIENT };
    };

    var prefixLinearGradient = function (tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === TokenType.IDENT_TOKEN &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: CSSImageType.LINEAR_GRADIENT
        };
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        }
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        Logger.create = function (options) {
            Logger.instances[options.id] = new Logger(options);
        };
        Logger.destroy = function (id) {
            delete Logger.instances[id];
        };
        Logger.getInstance = function (id) {
            var instance = Logger.instances[id];
            if (typeof instance === 'undefined') {
                throw new Error("No logger instance found with id " + id);
            }
            return instance;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, [this.id, this.getTime() + "ms"].concat(args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.create = function (name, options) {
            return (CacheStorage._caches[name] = new Cache(name, options));
        };
        CacheStorage.destroy = function (name) {
            delete CacheStorage._caches[name];
        };
        CacheStorage.open = function (name) {
            var cache = CacheStorage._caches[name];
            if (typeof cache !== 'undefined') {
                return cache;
            }
            throw new Error("Cache with key \"" + name + "\" not found");
        };
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage.getInstance = function () {
            var current = CacheStorage._current;
            if (current === null) {
                throw new Error("No cache instance attached");
            }
            return current;
        };
        CacheStorage.attachInstance = function (cache) {
            CacheStorage._current = cache;
        };
        CacheStorage.detachInstance = function () {
            CacheStorage._current = null;
        };
        CacheStorage._caches = {};
        CacheStorage._origin = 'about:blank';
        CacheStorage._current = null;
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(id, options) {
            this.id = id;
            this._options = options;
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                this._cache[src] = this.loadImage(src);
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !useProxy && !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            Logger.getInstance(this.id).debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                xhr.open('GET', proxy + "?url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var webkitGradient = function (tokens) {
        var angle = deg(180);
        var stops = [];
        var type = CSSImageType.LINEAR_GRADIENT;
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = CSSImageType.LINEAR_GRADIENT;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = CSSImageType.RADIAL_GRADIENT;
                    return;
                }
            }
            if (firstToken.type === TokenType.FUNCTION) {
                if (firstToken.name === 'from') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color$1 });
                }
                else if (firstToken.name === 'to') {
                    var color$1 = color.parse(firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color$1 });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color$1 = color.parse(values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: TokenType.PERCENTAGE_TOKEN, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color$1
                            });
                        }
                    }
                }
            }
        });
        return type === CSSImageType.LINEAR_GRADIENT
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var prefixRadialGradient = function (tokens) {
        var shape = CSSRadialShape.CIRCLE;
        var size = CSSRadialExtent.FARTHEST_CORNER;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = CSSRadialShape.CIRCLE;
                                return false;
                            case ELLIPSE:
                                shape = CSSRadialShape.ELLIPSE;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = CSSRadialExtent.CLOSEST_SIDE;
                                return false;
                            case FARTHEST_SIDE:
                                size = CSSRadialExtent.FARTHEST_SIDE;
                                return false;
                            case CLOSEST_CORNER:
                                size = CSSRadialExtent.CLOSEST_CORNER;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = CSSRadialExtent.FARTHEST_CORNER;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: CSSImageType.RADIAL_GRADIENT };
    };

    var CSSImageType;
    (function (CSSImageType) {
        CSSImageType[CSSImageType["URL"] = 0] = "URL";
        CSSImageType[CSSImageType["LINEAR_GRADIENT"] = 1] = "LINEAR_GRADIENT";
        CSSImageType[CSSImageType["RADIAL_GRADIENT"] = 2] = "RADIAL_GRADIENT";
    })(CSSImageType || (CSSImageType = {}));
    var isLinearGradient = function (background) {
        return background.type === CSSImageType.LINEAR_GRADIENT;
    };
    var isRadialGradient = function (background) {
        return background.type === CSSImageType.RADIAL_GRADIENT;
    };
    var CSSRadialShape;
    (function (CSSRadialShape) {
        CSSRadialShape[CSSRadialShape["CIRCLE"] = 0] = "CIRCLE";
        CSSRadialShape[CSSRadialShape["ELLIPSE"] = 1] = "ELLIPSE";
    })(CSSRadialShape || (CSSRadialShape = {}));
    var CSSRadialExtent;
    (function (CSSRadialExtent) {
        CSSRadialExtent[CSSRadialExtent["CLOSEST_SIDE"] = 0] = "CLOSEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_SIDE"] = 1] = "FARTHEST_SIDE";
        CSSRadialExtent[CSSRadialExtent["CLOSEST_CORNER"] = 2] = "CLOSEST_CORNER";
        CSSRadialExtent[CSSRadialExtent["FARTHEST_CORNER"] = 3] = "FARTHEST_CORNER";
    })(CSSRadialExtent || (CSSRadialExtent = {}));
    var image = {
        name: 'image',
        parse: function (value) {
            if (value.type === TokenType.URL_TOKEN) {
                var image_1 = { url: value.value, type: CSSImageType.URL };
                CacheStorage.getInstance().addImage(value.value);
                return image_1;
            }
            if (value.type === TokenType.FUNCTION) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(value.values);
            }
            throw new Error("Unsupported image type");
        }
    };
    function isSupportedImage(value) {
        return value.type !== TokenType.FUNCTION || SUPPORTED_IMAGE_FUNCTIONS[value.name];
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens.filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); }).map(image.parse);
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var BACKGROUND_REPEAT;
    (function (BACKGROUND_REPEAT) {
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT"] = 0] = "REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["NO_REPEAT"] = 1] = "NO_REPEAT";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_X"] = 2] = "REPEAT_X";
        BACKGROUND_REPEAT[BACKGROUND_REPEAT["REPEAT_Y"] = 3] = "REPEAT_Y";
    })(BACKGROUND_REPEAT || (BACKGROUND_REPEAT = {}));
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return BACKGROUND_REPEAT.NO_REPEAT;
            case 'repeat-x':
            case 'repeat no-repeat':
                return BACKGROUND_REPEAT.REPEAT_X;
            case 'repeat-y':
            case 'no-repeat repeat':
                return BACKGROUND_REPEAT.REPEAT_Y;
            case 'repeat':
            default:
                return BACKGROUND_REPEAT.REPEAT;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) { return parseLengthPercentageTuple(tokens.filter(isLengthPercentage)); }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var BORDER_STYLE;
    (function (BORDER_STYLE) {
        BORDER_STYLE[BORDER_STYLE["NONE"] = 0] = "NONE";
        BORDER_STYLE[BORDER_STYLE["SOLID"] = 1] = "SOLID";
    })(BORDER_STYLE || (BORDER_STYLE = {}));
    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (style) {
            switch (style) {
                case 'none':
                    return BORDER_STYLE.NONE;
            }
            return BORDER_STYLE.SOLID;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color$1 = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var FLOAT;
    (function (FLOAT) {
        FLOAT[FLOAT["NONE"] = 0] = "NONE";
        FLOAT[FLOAT["LEFT"] = 1] = "LEFT";
        FLOAT[FLOAT["RIGHT"] = 2] = "RIGHT";
        FLOAT[FLOAT["INLINE_START"] = 3] = "INLINE_START";
        FLOAT[FLOAT["INLINE_END"] = 4] = "INLINE_END";
    })(FLOAT || (FLOAT = {}));
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (float) {
            switch (float) {
                case 'left':
                    return FLOAT.LEFT;
                case 'right':
                    return FLOAT.RIGHT;
                case 'inline-start':
                    return FLOAT.INLINE_START;
                case 'inline-end':
                    return FLOAT.INLINE_END;
            }
            return FLOAT.NONE;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'normal') {
                return 0;
            }
            if (token.type === TokenType.NUMBER_TOKEN) {
                return token.number;
            }
            if (token.type === TokenType.DIMENSION_TOKEN) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === TokenType.NUMBER_TOKEN) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            return image.parse(token);
        }
    };

    var LIST_STYLE_POSITION;
    (function (LIST_STYLE_POSITION) {
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["INSIDE"] = 0] = "INSIDE";
        LIST_STYLE_POSITION[LIST_STYLE_POSITION["OUTSIDE"] = 1] = "OUTSIDE";
    })(LIST_STYLE_POSITION || (LIST_STYLE_POSITION = {}));
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'inside':
                    return LIST_STYLE_POSITION.INSIDE;
                case 'outside':
                default:
                    return LIST_STYLE_POSITION.OUTSIDE;
            }
        }
    };

    var LIST_STYLE_TYPE;
    (function (LIST_STYLE_TYPE) {
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["NONE"] = -1] = "NONE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISC"] = 0] = "DISC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CIRCLE"] = 1] = "CIRCLE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SQUARE"] = 2] = "SQUARE";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL"] = 3] = "DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_DECIMAL"] = 4] = "CJK_DECIMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DECIMAL_LEADING_ZERO"] = 5] = "DECIMAL_LEADING_ZERO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ROMAN"] = 6] = "LOWER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ROMAN"] = 7] = "UPPER_ROMAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_GREEK"] = 8] = "LOWER_GREEK";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ALPHA"] = 9] = "LOWER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ALPHA"] = 10] = "UPPER_ALPHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARABIC_INDIC"] = 11] = "ARABIC_INDIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ARMENIAN"] = 12] = "ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["BENGALI"] = 13] = "BENGALI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CAMBODIAN"] = 14] = "CAMBODIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_EARTHLY_BRANCH"] = 15] = "CJK_EARTHLY_BRANCH";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_HEAVENLY_STEM"] = 16] = "CJK_HEAVENLY_STEM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["CJK_IDEOGRAPHIC"] = 17] = "CJK_IDEOGRAPHIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DEVANAGARI"] = 18] = "DEVANAGARI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ETHIOPIC_NUMERIC"] = 19] = "ETHIOPIC_NUMERIC";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GEORGIAN"] = 20] = "GEORGIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GUJARATI"] = 21] = "GUJARATI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["GURMUKHI"] = 22] = "GURMUKHI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HEBREW"] = 22] = "HEBREW";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA"] = 23] = "HIRAGANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["HIRAGANA_IROHA"] = 24] = "HIRAGANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_FORMAL"] = 25] = "JAPANESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["JAPANESE_INFORMAL"] = 26] = "JAPANESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KANNADA"] = 27] = "KANNADA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA"] = 28] = "KATAKANA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KATAKANA_IROHA"] = 29] = "KATAKANA_IROHA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KHMER"] = 30] = "KHMER";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANGUL_FORMAL"] = 31] = "KOREAN_HANGUL_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_FORMAL"] = 32] = "KOREAN_HANJA_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["KOREAN_HANJA_INFORMAL"] = 33] = "KOREAN_HANJA_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LAO"] = 34] = "LAO";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["LOWER_ARMENIAN"] = 35] = "LOWER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MALAYALAM"] = 36] = "MALAYALAM";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MONGOLIAN"] = 37] = "MONGOLIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["MYANMAR"] = 38] = "MYANMAR";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["ORIYA"] = 39] = "ORIYA";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["PERSIAN"] = 40] = "PERSIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_FORMAL"] = 41] = "SIMP_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["SIMP_CHINESE_INFORMAL"] = 42] = "SIMP_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TAMIL"] = 43] = "TAMIL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TELUGU"] = 44] = "TELUGU";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["THAI"] = 45] = "THAI";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TIBETAN"] = 46] = "TIBETAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_FORMAL"] = 47] = "TRAD_CHINESE_FORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["TRAD_CHINESE_INFORMAL"] = 48] = "TRAD_CHINESE_INFORMAL";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["UPPER_ARMENIAN"] = 49] = "UPPER_ARMENIAN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_OPEN"] = 50] = "DISCLOSURE_OPEN";
        LIST_STYLE_TYPE[LIST_STYLE_TYPE["DISCLOSURE_CLOSED"] = 51] = "DISCLOSURE_CLOSED";
    })(LIST_STYLE_TYPE || (LIST_STYLE_TYPE = {}));
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (type) {
            switch (type) {
                case 'disc':
                    return LIST_STYLE_TYPE.DISC;
                case 'circle':
                    return LIST_STYLE_TYPE.CIRCLE;
                case 'square':
                    return LIST_STYLE_TYPE.SQUARE;
                case 'decimal':
                    return LIST_STYLE_TYPE.DECIMAL;
                case 'cjk-decimal':
                    return LIST_STYLE_TYPE.CJK_DECIMAL;
                case 'decimal-leading-zero':
                    return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
                case 'lower-roman':
                    return LIST_STYLE_TYPE.LOWER_ROMAN;
                case 'upper-roman':
                    return LIST_STYLE_TYPE.UPPER_ROMAN;
                case 'lower-greek':
                    return LIST_STYLE_TYPE.LOWER_GREEK;
                case 'lower-alpha':
                    return LIST_STYLE_TYPE.LOWER_ALPHA;
                case 'upper-alpha':
                    return LIST_STYLE_TYPE.UPPER_ALPHA;
                case 'arabic-indic':
                    return LIST_STYLE_TYPE.ARABIC_INDIC;
                case 'armenian':
                    return LIST_STYLE_TYPE.ARMENIAN;
                case 'bengali':
                    return LIST_STYLE_TYPE.BENGALI;
                case 'cambodian':
                    return LIST_STYLE_TYPE.CAMBODIAN;
                case 'cjk-earthly-branch':
                    return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
                case 'cjk-heavenly-stem':
                    return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
                case 'cjk-ideographic':
                    return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
                case 'devanagari':
                    return LIST_STYLE_TYPE.DEVANAGARI;
                case 'ethiopic-numeric':
                    return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
                case 'georgian':
                    return LIST_STYLE_TYPE.GEORGIAN;
                case 'gujarati':
                    return LIST_STYLE_TYPE.GUJARATI;
                case 'gurmukhi':
                    return LIST_STYLE_TYPE.GURMUKHI;
                case 'hebrew':
                    return LIST_STYLE_TYPE.HEBREW;
                case 'hiragana':
                    return LIST_STYLE_TYPE.HIRAGANA;
                case 'hiragana-iroha':
                    return LIST_STYLE_TYPE.HIRAGANA_IROHA;
                case 'japanese-formal':
                    return LIST_STYLE_TYPE.JAPANESE_FORMAL;
                case 'japanese-informal':
                    return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
                case 'kannada':
                    return LIST_STYLE_TYPE.KANNADA;
                case 'katakana':
                    return LIST_STYLE_TYPE.KATAKANA;
                case 'katakana-iroha':
                    return LIST_STYLE_TYPE.KATAKANA_IROHA;
                case 'khmer':
                    return LIST_STYLE_TYPE.KHMER;
                case 'korean-hangul-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
                case 'korean-hanja-formal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
                case 'korean-hanja-informal':
                    return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
                case 'lao':
                    return LIST_STYLE_TYPE.LAO;
                case 'lower-armenian':
                    return LIST_STYLE_TYPE.LOWER_ARMENIAN;
                case 'malayalam':
                    return LIST_STYLE_TYPE.MALAYALAM;
                case 'mongolian':
                    return LIST_STYLE_TYPE.MONGOLIAN;
                case 'myanmar':
                    return LIST_STYLE_TYPE.MYANMAR;
                case 'oriya':
                    return LIST_STYLE_TYPE.ORIYA;
                case 'persian':
                    return LIST_STYLE_TYPE.PERSIAN;
                case 'simp-chinese-formal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
                case 'simp-chinese-informal':
                    return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
                case 'tamil':
                    return LIST_STYLE_TYPE.TAMIL;
                case 'telugu':
                    return LIST_STYLE_TYPE.TELUGU;
                case 'thai':
                    return LIST_STYLE_TYPE.THAI;
                case 'tibetan':
                    return LIST_STYLE_TYPE.TIBETAN;
                case 'trad-chinese-formal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
                case 'trad-chinese-informal':
                    return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
                case 'upper-armenian':
                    return LIST_STYLE_TYPE.UPPER_ARMENIAN;
                case 'disclosure-open':
                    return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
                case 'disclosure-closed':
                    return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
                case 'none':
                default:
                    return LIST_STYLE_TYPE.NONE;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TOKEN_VALUE
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var OVERFLOW;
    (function (OVERFLOW) {
        OVERFLOW[OVERFLOW["VISIBLE"] = 0] = "VISIBLE";
        OVERFLOW[OVERFLOW["HIDDEN"] = 1] = "HIDDEN";
        OVERFLOW[OVERFLOW["SCROLL"] = 2] = "SCROLL";
        OVERFLOW[OVERFLOW["AUTO"] = 3] = "AUTO";
    })(OVERFLOW || (OVERFLOW = {}));
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return OVERFLOW.HIDDEN;
                    case 'scroll':
                        return OVERFLOW.SCROLL;
                    case 'auto':
                        return OVERFLOW.AUTO;
                    case 'visible':
                    default:
                        return OVERFLOW.VISIBLE;
                }
            });
        }
    };

    var OVERFLOW_WRAP;
    (function (OVERFLOW_WRAP) {
        OVERFLOW_WRAP["NORMAL"] = "normal";
        OVERFLOW_WRAP["BREAK_WORD"] = "break-word";
    })(OVERFLOW_WRAP || (OVERFLOW_WRAP = {}));
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'break-word':
                    return OVERFLOW_WRAP.BREAK_WORD;
                case 'normal':
                default:
                    return OVERFLOW_WRAP.NORMAL;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var TEXT_ALIGN;
    (function (TEXT_ALIGN) {
        TEXT_ALIGN[TEXT_ALIGN["LEFT"] = 0] = "LEFT";
        TEXT_ALIGN[TEXT_ALIGN["CENTER"] = 1] = "CENTER";
        TEXT_ALIGN[TEXT_ALIGN["RIGHT"] = 2] = "RIGHT";
    })(TEXT_ALIGN || (TEXT_ALIGN = {}));
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textAlign) {
            switch (textAlign) {
                case 'right':
                    return TEXT_ALIGN.RIGHT;
                case 'center':
                case 'justify':
                    return TEXT_ALIGN.CENTER;
                case 'left':
                default:
                    return TEXT_ALIGN.LEFT;
            }
        }
    };

    var POSITION;
    (function (POSITION) {
        POSITION[POSITION["STATIC"] = 0] = "STATIC";
        POSITION[POSITION["RELATIVE"] = 1] = "RELATIVE";
        POSITION[POSITION["ABSOLUTE"] = 2] = "ABSOLUTE";
        POSITION[POSITION["FIXED"] = 3] = "FIXED";
        POSITION[POSITION["STICKY"] = 4] = "STICKY";
    })(POSITION || (POSITION = {}));
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (position) {
            switch (position) {
                case 'relative':
                    return POSITION.RELATIVE;
                case 'absolute':
                    return POSITION.ABSOLUTE;
                case 'fixed':
                    return POSITION.FIXED;
                case 'sticky':
                    return POSITION.STICKY;
            }
            return POSITION.STATIC;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var TEXT_TRANSFORM;
    (function (TEXT_TRANSFORM) {
        TEXT_TRANSFORM[TEXT_TRANSFORM["NONE"] = 0] = "NONE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["LOWERCASE"] = 1] = "LOWERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["UPPERCASE"] = 2] = "UPPERCASE";
        TEXT_TRANSFORM[TEXT_TRANSFORM["CAPITALIZE"] = 3] = "CAPITALIZE";
    })(TEXT_TRANSFORM || (TEXT_TRANSFORM = {}));
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return TEXT_TRANSFORM.UPPERCASE;
                case 'lowercase':
                    return TEXT_TRANSFORM.LOWERCASE;
                case 'capitalize':
                    return TEXT_TRANSFORM.CAPITALIZE;
            }
            return TEXT_TRANSFORM.NONE;
        }
    };

    var transform = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN && token.value === 'none') {
                return null;
            }
            if (token.type === TokenType.FUNCTION) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === TokenType.NUMBER_TOKEN; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1], _a = values[2], _b = values[3], a2 = values[4], b2 = values[5], _c = values[6], _d = values[7], _e = values[8], _f = values[9], _g = values[10], _h = values[11], a4 = values[12], b4 = values[13], _j = values[14], _k = values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: TokenType.PERCENTAGE_TOKEN,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var VISIBILITY;
    (function (VISIBILITY) {
        VISIBILITY[VISIBILITY["VISIBLE"] = 0] = "VISIBLE";
        VISIBILITY[VISIBILITY["HIDDEN"] = 1] = "HIDDEN";
        VISIBILITY[VISIBILITY["COLLAPSE"] = 2] = "COLLAPSE";
    })(VISIBILITY || (VISIBILITY = {}));
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (visibility) {
            switch (visibility) {
                case 'hidden':
                    return VISIBILITY.HIDDEN;
                case 'collapse':
                    return VISIBILITY.COLLAPSE;
                case 'visible':
                default:
                    return VISIBILITY.VISIBLE;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: PropertyDescriptorParsingType.VALUE,
        parse: function (token) {
            if (token.type === TokenType.IDENT_TOKEN) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            return tokens.filter(isStringToken$1).map(function (token) { return token.value; });
        }
    };
    var isStringToken$1 = function (token) {
        return token.type === TokenType.STRING_TOKEN || token.type === TokenType.IDENT_TOKEN;
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: PropertyDescriptorParsingType.TYPE_VALUE,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: PropertyDescriptorParsingType.VALUE,
        prefix: false,
        parse: function (token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var FONT_STYLE;
    (function (FONT_STYLE) {
        FONT_STYLE["NORMAL"] = "normal";
        FONT_STYLE["ITALIC"] = "italic";
        FONT_STYLE["OBLIQUE"] = "oblique";
    })(FONT_STYLE || (FONT_STYLE = {}));
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: PropertyDescriptorParsingType.IDENT_VALUE,
        parse: function (overflow) {
            switch (overflow) {
                case 'oblique':
                    return FONT_STYLE.OBLIQUE;
                case 'italic':
                    return FONT_STYLE.ITALIC;
                case 'normal':
                default:
                    return FONT_STYLE.NORMAL;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === TokenType.IDENT_TOKEN) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: PropertyDescriptorParsingType.LIST,
        parse: function (tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === TokenType.IDENT_TOKEN && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: PropertyDescriptorParsingType.LIST,
        prefix: false,
        parse: function (tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color.parse(token);
                    }
                }
                return shadow;
            });
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(declaration) {
            this.backgroundClip = parse(backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(boxShadow, declaration.boxShadow);
            this.color = parse(color$1, declaration.color);
            this.display = parse(display, declaration.display);
            this.float = parse(float, declaration.cssFloat);
            this.fontFamily = parse(fontFamily, declaration.fontFamily);
            this.fontSize = parse(fontSize, declaration.fontSize);
            this.fontStyle = parse(fontStyle, declaration.fontStyle);
            this.fontVariant = parse(fontVariant, declaration.fontVariant);
            this.fontWeight = parse(fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(lineBreak, declaration.lineBreak);
            this.lineHeight = parse(lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(listStyleType, declaration.listStyleType);
            this.marginTop = parse(marginTop, declaration.marginTop);
            this.marginRight = parse(marginRight, declaration.marginRight);
            this.marginBottom = parse(marginBottom, declaration.marginBottom);
            this.marginLeft = parse(marginLeft, declaration.marginLeft);
            this.opacity = parse(opacity, declaration.opacity);
            var overflowTuple = parse(overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(paddingTop, declaration.paddingTop);
            this.paddingRight = parse(paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(paddingLeft, declaration.paddingLeft);
            this.position = parse(position, declaration.position);
            this.textAlign = parse(textAlign, declaration.textAlign);
            this.textDecorationColor = parse(textDecorationColor, declaration.textDecorationColor || declaration.color);
            this.textDecorationLine = parse(textDecorationLine, declaration.textDecorationLine);
            this.textShadow = parse(textShadow, declaration.textShadow);
            this.textTransform = parse(textTransform, declaration.textTransform);
            this.transform = parse(transform, declaration.transform);
            this.transformOrigin = parse(transformOrigin, declaration.transformOrigin);
            this.visibility = parse(visibility, declaration.visibility);
            this.wordBreak = parse(wordBreak, declaration.wordBreak);
            this.zIndex = parse(zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === VISIBILITY.VISIBLE;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== POSITION.STATIC;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== FLOAT.NONE;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(declaration) {
            this.content = parse(content, declaration.content);
            this.quotes = parse(quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(declaration) {
            this.counterIncrement = parse(counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case PropertyDescriptorParsingType.IDENT_VALUE:
                var token = parser.parseComponentValue();
                return descriptor.parse(isIdentToken(token) ? token.value : descriptor.initialValue);
            case PropertyDescriptorParsingType.VALUE:
                return descriptor.parse(parser.parseComponentValue());
            case PropertyDescriptorParsingType.LIST:
                return descriptor.parse(parser.parseComponentValues());
            case PropertyDescriptorParsingType.TOKEN_VALUE:
                return parser.parseComponentValue();
            case PropertyDescriptorParsingType.TYPE_VALUE:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(parser.parseComponentValue());
                    case 'color':
                        return color.parse(parser.parseComponentValue());
                    case 'image':
                        return image.parse(parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                }
        }
        throw new Error("Attempting to parse unsupported css format type " + descriptor.format);
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(element) {
            this.styles = new CSSParsedDeclaration(window.getComputedStyle(element, null));
            this.textNodes = [];
            this.elements = [];
            if (this.styles.transform !== null && isHTMLElementNode(element)) {
                // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(element);
            this.flags = 0;
        }
        return ElementContainer;
    }());

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length)));
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return new Bounds(0, 0, 0, 0);
    };
    var getRangeBounds = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return Bounds.fromClientRect(range.getBoundingClientRect());
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? toCodePoints(value).map(function (i) { return fromCodePoint(i); }) : breakWords(value, styles);
    };
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                words.push(bk.value.slice());
            }
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(node, styles) {
            this.text = transform$1(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform$1 = function (text, transform) {
        switch (transform) {
            case TEXT_TRANSFORM.LOWERCASE:
                return text.toLowerCase();
            case TEXT_TRANSFORM.CAPITALIZE:
                return text.replace(CAPITALIZE, capitalize);
            case TEXT_TRANSFORM.UPPERCASE:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(img) {
            var _this = _super.call(this, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            CacheStorage.getInstance().addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(canvas) {
            var _this = _super.call(this, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(img) {
            var _this = _super.call(this, img) || this;
            var s = new XMLSerializer();
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            CacheStorage.getInstance().addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: TokenType.DIMENSION_TOKEN,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: TokenType.PERCENTAGE_TOKEN,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(input) {
            var _this = _super.call(this, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle =
                    BORDER_STYLE.SOLID;
                _this.styles.backgroundClip = [BACKGROUND_CLIP.BORDER_BOX];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(element) {
            var _this = _super.call(this, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(element) {
            var _this = _super.call(this, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var parseColor = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(iframe) {
            var _this = _super.call(this, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.documentElement)
                            .backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                var container = createContainer(childNode);
                if (container.styles.isVisible()) {
                    if (createsRealStackingContext(childNode, container, root)) {
                        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                    }
                    else if (createsStackingContext(container.styles)) {
                        container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                    }
                    if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                        container.flags |= 8 /* IS_LIST_OWNER */;
                    }
                    parent.elements.push(container);
                    if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
                        parseNodeTree(childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function (element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(element);
        }
        return new ElementContainer(element);
    };
    var parseTree = function (element) {
        var container = createContainer(element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return typeof node.style !== 'undefined';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case LIST_STYLE_TYPE.DISC:
                return '•' + spaceSuffix;
            case LIST_STYLE_TYPE.CIRCLE:
                return '◦' + spaceSuffix;
            case LIST_STYLE_TYPE.SQUARE:
                return '◾' + spaceSuffix;
            case LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case LIST_STYLE_TYPE.CJK_DECIMAL:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case LIST_STYLE_TYPE.LOWER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.UPPER_ROMAN:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_GREEK:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ALPHA:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case LIST_STYLE_TYPE.UPPER_ALPHA:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case LIST_STYLE_TYPE.ARABIC_INDIC:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case LIST_STYLE_TYPE.ARMENIAN:
            case LIST_STYLE_TYPE.UPPER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.LOWER_ARMENIAN:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
            case LIST_STYLE_TYPE.BENGALI:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case LIST_STYLE_TYPE.CAMBODIAN:
            case LIST_STYLE_TYPE.KHMER:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
            case LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case LIST_STYLE_TYPE.JAPANESE_FORMAL:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case LIST_STYLE_TYPE.DEVANAGARI:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case LIST_STYLE_TYPE.GEORGIAN:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.GUJARATI:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case LIST_STYLE_TYPE.GURMUKHI:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.HEBREW:
                return createAdditiveCounter(value, 1, 10999, HEBREW, LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
            case LIST_STYLE_TYPE.HIRAGANA:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case LIST_STYLE_TYPE.HIRAGANA_IROHA:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case LIST_STYLE_TYPE.KANNADA:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case LIST_STYLE_TYPE.KATAKANA:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case LIST_STYLE_TYPE.KATAKANA_IROHA:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case LIST_STYLE_TYPE.LAO:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case LIST_STYLE_TYPE.MONGOLIAN:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case LIST_STYLE_TYPE.MYANMAR:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case LIST_STYLE_TYPE.ORIYA:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.PERSIAN:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case LIST_STYLE_TYPE.TAMIL:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case LIST_STYLE_TYPE.TELUGU:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case LIST_STYLE_TYPE.THAI:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case LIST_STYLE_TYPE.TIBETAN:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case LIST_STYLE_TYPE.DECIMAL:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(element, options) {
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    documentClone.documentElement.style.top = -windowSize.top + 'px';
                                    documentClone.documentElement.style.left = -windowSize.left + 'px';
                                    documentClone.documentElement.style.position = 'absolute';
                                }
                            }
                            onclone = this.options.onclone;
                            if (typeof this.clonedReferenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            /*
            if (isIFrameElement(node)) {
                return this.createIFrameClone(node);
            }
    */
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                Logger.getInstance(this.options.id).error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    Logger.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted");
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) { }
            return clonedCanvas;
        };
        /*
        createIFrameClone(iframe: HTMLIFrameElement) {
            const tempIframe = <HTMLIFrameElement>iframe.cloneNode(false);
            const iframeKey = generateIframeKey();
            tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

            const {width, height} = parseBounds(iframe);

            this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(iframe, this.options)
                .then(documentElement => {
                    return this.renderer(
                        documentElement,
                        {
                            allowTaint: this.options.allowTaint,
                            backgroundColor: '#ffffff',
                            canvas: null,
                            imageTimeout: this.options.imageTimeout,
                            logging: this.options.logging,
                            proxy: this.options.proxy,
                            removeContainer: this.options.removeContainer,
                            scale: this.options.scale,
                            foreignObjectRendering: this.options.foreignObjectRendering,
                            useCORS: this.options.useCORS,
                            target: new CanvasRenderer(),
                            width,
                            height,
                            x: 0,
                            y: 0,
                            windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                            windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                            scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                            scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                        },
                    );
                })
                .then(
                    (canvas: HTMLCanvasElement) =>
                        new Promise((resolve, reject) => {
                            const iframeCanvas = document.createElement('img');
                            iframeCanvas.onload = () => resolve(canvas);
                            iframeCanvas.onerror = (event) => {
                                // Empty iframes may result in empty "data:," URLs, which are invalid from the <img>'s point of view
                                // and instead of `onload` cause `onerror` and unhandled rejection warnings
                                // https://github.com/niklasvh/html2canvas/issues/1502
                                iframeCanvas.src == 'data:,' ? resolve(canvas) : reject(event);
                            };
                            iframeCanvas.src = canvas.toDataURL();
                            if (tempIframe.parentNode && iframe.ownerDocument && iframe.ownerDocument.defaultView) {
                                tempIframe.parentNode.replaceChild(
                                    copyCSSStyles(
                                        iframe.ownerDocument.defaultView.getComputedStyle(iframe),
                                        iframeCanvas
                                    ),
                                    tempIframe
                                );
                            }
                        })
                );
            return tempIframe;
        }
    */
        DocumentCloner.prototype.cloneNode = function (node) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (isHTMLElementNode(node) && window) {
                var clone = this.createElementClone(node);
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                for (var child = node.firstChild; child; child = child.nextSibling) {
                    if (!isElementNode(child) ||
                        (!isScriptElement(child) &&
                            !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                            (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                            clone.appendChild(this.cloneNode(child));
                        }
                    }
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if (style && this.options.copyStyles && !isIFrameElement(node)) {
                    copyCSSStyles(style, clone);
                }
                //this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(style));
            var declaration = new CSSParsedPseudoDeclaration(style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === TokenType.STRING_TOKEN) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === TokenType.URL_TOKEN) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === TokenType.FUNCTION) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(counterStyle.value)
                                : LIST_STYLE_TYPE.DECIMAL;
                            var separator = delim && delim.type === TokenType.STRING_TOKEN ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                }
                else if (token.type === TokenType.IDENT_TOKEN) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            clone.className +=
                pseudoElt === PseudoElementType.BEFORE
                    ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                    : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = function () {
                cloneWindow.onload = iframe.onload = documentClone.onreadystatechange = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            // Safari shows pseudoelements if content is set
            if (property !== 'content') {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var PathType;
    (function (PathType) {
        PathType[PathType["VECTOR"] = 0] = "VECTOR";
        PathType[PathType["BEZIER_CURVE"] = 1] = "BEZIER_CURVE";
    })(PathType || (PathType = {}));
    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = PathType.VECTOR;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = PathType.BEZIER_CURVE;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === PathType.BEZIER_CURVE; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderLeftWidth ? 0 : trh - borderLeftWidth, trv - borderTopWidth, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth), Math.max(0, brh - borderRightWidth), brv - borderBottomWidth, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + leftHeight, Math.max(0, blh - borderLeftWidth), blv - borderBottomWidth, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.type = 0 /* TRANSFORM */;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.type = 1 /* CLIP */;
            this.target = target;
            this.path = path;
        }
        return ClipEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(element, parentStack) {
            this.container = element;
            this.effects = parentStack.slice(0);
            this.curves = new BoundCurves(element);
            if (element.styles.transform !== null) {
                var offsetX = element.bounds.left + element.styles.transformOrigin[0].number;
                var offsetY = element.bounds.top + element.styles.transformOrigin[1].number;
                var matrix = element.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (element.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getParentEffects = function () {
            var effects = this.effects.slice(0);
            if (this.container.styles.overflowX !== OVERFLOW.VISIBLE) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (!equalPath(borderBox, paddingBox)) {
                    effects.push(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
            }
            return effects;
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent.getParentEffects());
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, []);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === BACKGROUND_CLIP.BORDER_BOX) {
            return element.bounds;
        }
        if (backgroundClip === BACKGROUND_CLIP.CONTENT_BOX) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case BACKGROUND_REPEAT.REPEAT_X:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case BACKGROUND_REPEAT.REPEAT_Y:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case BACKGROUND_REPEAT.NO_REPEAT:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function () {
        function CanvasRenderer(options) {
            this._activeEffects = [];
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            if (!options.canvas) {
                this.canvas.width = Math.floor(options.width * options.scale);
                this.canvas.height = Math.floor(options.height * options.scale);
                this.canvas.style.width = options.width + "px";
                this.canvas.style.height = options.height + "px";
            }
            this.fontMetrics = new FontMetrics(document);
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            this.ctx.textBaseline = 'bottom';
            this._activeEffects = [];
            Logger.getInstance(options.id).debug("Canvas renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        CanvasRenderer.prototype.applyEffects = function (effects, target) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.filter(function (effect) { return contains(effect.target, target); }).forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            this.ctx.globalAlpha = styles.opacity;
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
            }
            else {
                var letters = toCodePoints(text.text).map(function (i) { return fromCodePoint(i); });
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + text.bounds.height);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = styles.fontFamily.join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize;
                var _this = this;
                return __generator(this, function (_b) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    text.textBounds.forEach(function (text) {
                        _this.ctx.fillStyle = asString(styles.color);
                        _this.renderTextWithLetterSpacing(text, styles.letterSpacing);
                        var textShadows = styles.textShadow;
                        if (textShadows.length && text.text.trim().length) {
                            textShadows
                                .slice(0)
                                .reverse()
                                .forEach(function (textShadow) {
                                _this.ctx.shadowColor = asString(textShadow.color);
                                _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                _this.ctx.shadowBlur = textShadow.blur.number;
                                _this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                            });
                            _this.ctx.shadowColor = '';
                            _this.ctx.shadowOffsetX = 0;
                            _this.ctx.shadowOffsetY = 0;
                            _this.ctx.shadowBlur = 0;
                        }
                        if (styles.textDecorationLine.length) {
                            _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                            styles.textDecorationLine.forEach(function (textDecorationLine) {
                                switch (textDecorationLine) {
                                    case 1 /* UNDERLINE */:
                                        // Draws a line at the baseline of the font
                                        // TODO As some browsers display the line as more than 1px if the font-size is big,
                                        // need to take that into account both in position and size
                                        var baseline = _this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                        break;
                                    case 2 /* OVERLINE */:
                                        _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                        break;
                                    case 3 /* LINE_THROUGH */:
                                        // TODO try and find exact position for line-through
                                        var middle = _this.fontMetrics.getMetrics(fontFamily, fontSize).middle;
                                        _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                        break;
                                }
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, e_1, image, e_2, iframeRenderer, canvas, size, bounds, x, textBounds, img, image, url, e_3, bounds;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.applyEffects(paint.effects, 4 /* CONTENT */);
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _b.label = 5;
                        case 5:
                            _b.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.options.cache.match(container.src)];
                        case 6:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            e_1 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _b.label = 9;
                        case 9:
                            _b.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.options.cache.match(container.svg)];
                        case 10:
                            image = _b.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            e_2 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer({
                                id: this.options.id,
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                scrollX: 0,
                                scrollY: 0,
                                width: container.width,
                                height: container.height,
                                cache: this.options.cache,
                                windowWidth: container.width,
                                windowHeight: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _b.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _b.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case TEXT_ALIGN.CENTER:
                                        x += bounds.width / 2;
                                        break;
                                    case TEXT_ALIGN.RIGHT:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === CSSImageType.URL)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _b.label = 15;
                        case 15:
                            _b.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.options.cache.match(url)];
                        case 16:
                            image = _b.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            e_3 = _b.sent();
                            Logger.getInstance(this.options.id).error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== LIST_STYLE_TYPE.NONE) {
                                this.ctx.font = this.createFontStyle(styles)[0];
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _b.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0: 
                        // https://www.w3.org/TR/css-position-3/#painting-order
                        // 1. the background and borders of the element forming the stacking context.
                        return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            if (image.width === width && image.height === height) {
                return image;
            }
            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, e_4, _a, path, x, y, width, height, pattern, _b, path, x, y, width, height, _c, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _d, path, left, top_1, width, height, position, x, y, _e, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            if (!(backgroundImage.type === CSSImageType.URL)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _f.label = 1;
                                        case 1:
                                            _f.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.options.cache.match(url)];
                                        case 2:
                                            image = _f.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_4 = _f.sent();
                                            Logger.getInstance(this_1.options.id).error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _a = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _a[0], x = _a[1], y = _a[2], width = _a[3], height = _a[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _b = calculateBackgroundRendering(container, index, [null, null, null]), path = _b[0], x = _b[1], y = _b[2], width = _b[3], height = _b[4];
                                                _c = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _c[0], x0 = _c[1], x1 = _c[2], y0 = _c[3], y1 = _c[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], left = _d[1], top_1 = _d[2], width = _d[3], height = _d[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _e = calculateRadius(backgroundImage, x, y, width, height), rx = _e[0], ry = _e[1];
                                                if (rx > 0 && rx > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _f.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.effects, 2 /* BACKGROUND_BORDERS */);
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor },
                                { style: styles.borderRightStyle, color: styles.borderRightColor },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 7];
                            border = borders_1[_i];
                            if (!(border.style !== BORDER_STYLE.NONE && !isTransparent(border.color))) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderBorder(border.color, side, paint.curves)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            side++;
                            _a.label = 6;
                        case 6:
                            _i++;
                            return [3 /*break*/, 3];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x - this.options.scrollX, this.options.y - this.options.scrollY, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([], 2 /* BACKGROUND_BORDERS */);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }());
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case BACKGROUND_CLIP.BORDER_BOX:
                return calculateBorderBoxPath(curves);
            case BACKGROUND_CLIP.CONTENT_BOX:
                return calculateContentBoxPath(curves);
            case BACKGROUND_CLIP.PADDING_BOX:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case TEXT_ALIGN.CENTER:
                return 'center';
            case TEXT_ALIGN.RIGHT:
                return 'right';
            case TEXT_ALIGN.LEFT:
            default:
                return 'left';
        }
    };

    var ForeignObjectRenderer = /** @class */ (function () {
        function ForeignObjectRenderer(options) {
            this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + "px";
            this.canvas.style.height = options.height + "px";
            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x + options.scrollX, -options.y + options.scrollY);
            Logger.getInstance(options.id).debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(Math.max(this.options.windowWidth, this.options.width) * this.options.scale, Math.max(this.options.windowHeight, this.options.height) * this.options.scale, this.options.scrollX * this.options.scale, this.options.scrollY * this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG$1(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }());
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var _this = undefined;
    var parseColor$1 = function (value) { return color.parse(Parser.create(value).parseComponentValue()); };
    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    CacheStorage.setContext(window);
    var renderElement = function (element, opts) { return __awaiter(_this, void 0, void 0, function () {
        var ownerDocument, defaultView, instanceName, _a, width, height, left, top, defaultResourceOptions, resourceOptions, defaultOptions, options, windowBounds, documentCloner, clonedElement, container, documentBackgroundColor, bodyBackgroundColor, bgColor, defaultBackgroundColor, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    instanceName = (Math.round(Math.random() * 1000) + Date.now()).toString(16);
                    _a = isBodyElement(element) || isHTMLElement(element) ? parseDocumentSize(ownerDocument) : parseBounds(element), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    defaultResourceOptions = {
                        allowTaint: false,
                        imageTimeout: 15000,
                        proxy: undefined,
                        useCORS: false
                    };
                    resourceOptions = __assign({}, defaultResourceOptions, opts);
                    defaultOptions = {
                        backgroundColor: '#ffffff',
                        cache: opts.cache ? opts.cache : CacheStorage.create(instanceName, resourceOptions),
                        logging: true,
                        removeContainer: true,
                        foreignObjectRendering: false,
                        scale: defaultView.devicePixelRatio || 1,
                        windowWidth: defaultView.innerWidth,
                        windowHeight: defaultView.innerHeight,
                        scrollX: defaultView.pageXOffset,
                        scrollY: defaultView.pageYOffset,
                        x: left,
                        y: top,
                        width: Math.ceil(width),
                        height: Math.ceil(height),
                        id: instanceName
                    };
                    options = __assign({}, defaultOptions, resourceOptions, opts);
                    windowBounds = new Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);
                    Logger.create({ id: instanceName, enabled: options.logging });
                    Logger.getInstance(instanceName).debug("Starting document clone");
                    documentCloner = new DocumentCloner(element, {
                        id: instanceName,
                        onclone: options.onclone,
                        ignoreElements: options.ignoreElements,
                        inlineImages: options.foreignObjectRendering,
                        copyStyles: options.foreignObjectRendering
                    });
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _b.sent();
                    documentBackgroundColor = ownerDocument.documentElement
                        ? parseColor$1(getComputedStyle(ownerDocument.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bodyBackgroundColor = ownerDocument.body
                        ? parseColor$1(getComputedStyle(ownerDocument.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    bgColor = opts.backgroundColor;
                    defaultBackgroundColor = typeof bgColor === 'string' ? parseColor$1(bgColor) : bgColor === null ? COLORS.TRANSPARENT : 0xffffffff;
                    backgroundColor = element === ownerDocument.documentElement
                        ? isTransparent(documentBackgroundColor)
                            ? isTransparent(bodyBackgroundColor)
                                ? defaultBackgroundColor
                                : bodyBackgroundColor
                            : documentBackgroundColor
                        : defaultBackgroundColor;
                    renderOptions = {
                        id: instanceName,
                        cache: options.cache,
                        canvas: options.canvas,
                        backgroundColor: backgroundColor,
                        scale: options.scale,
                        x: options.x,
                        y: options.y,
                        scrollX: options.scrollX,
                        scrollY: options.scrollY,
                        width: options.width,
                        height: options.height,
                        windowWidth: options.windowWidth,
                        windowHeight: options.windowHeight
                    };
                    if (!options.foreignObjectRendering) return [3 /*break*/, 3];
                    Logger.getInstance(instanceName).debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    Logger.getInstance(instanceName).debug("Document cloned, using computed rendering");
                    CacheStorage.attachInstance(options.cache);
                    Logger.getInstance(instanceName).debug("Starting DOM parsing");
                    root = parseTree(clonedElement);
                    CacheStorage.detachInstance();
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    Logger.getInstance(instanceName).debug("Starting renderer");
                    renderer = new CanvasRenderer(renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _b.sent();
                    _b.label = 5;
                case 5:
                    if (options.removeContainer === true) {
                        if (!DocumentCloner.destroy(container)) {
                            Logger.getInstance(instanceName).error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    Logger.getInstance(instanceName).debug("Finished rendering");
                    Logger.destroy(instanceName);
                    CacheStorage.destroy(instanceName);
                    return [2 /*return*/, canvas];
            }
        });
    }); };

    return html2canvas;

}));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;!function(t){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t()}(function(){"use strict";
/** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ae}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
/** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */
et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectOptions */
/* unused harmony export PRODUCTSPLACEHOLDER */
/* unused harmony export VENDOR */
/* unused harmony export OPERATORS */
/* unused harmony export DEFAULTDAYSFILTER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg__);
var selectOptions=[{text:'nos últimos 7 dias',value:7},{text:'nos últimos 15 dias',value:15},{text:'nos últimos 30 dias',value:30},{text:'nos últimos 60 dias',value:60},{text:'nos últimos 90 dias',value:90},{text:'nos últimos 6 meses',value:180},{text:'no último 1 ano',value:365}];var PRODUCTSPLACEHOLDER=[{},{},{},{}];var VENDOR={SHELL:{ID:117,IMAGEURL:__WEBPACK_IMPORTED_MODULE_7__loyal_images_orders_pedido_shell_jpg___default.a},SMILES:{ID:21185,IMAGEURL:__WEBPACK_IMPORTED_MODULE_9__loyal_images_orders_pedido_viagem_jpg___default.a},PAYBILLS:{ID:21188,IMAGEURL:__WEBPACK_IMPORTED_MODULE_6__loyal_images_orders_pedido_pague_conta_jpg___default.a},DONATION:{ID:54,IMAGEURL:__WEBPACK_IMPORTED_MODULE_3__loyal_images_orders_pedido_doacao_jpg___default.a},CELLPHONERECHARGE:{ID:71,IMAGEURL:__WEBPACK_IMPORTED_MODULE_2__loyal_images_orders_pedido_compra_pontos_jpg___default.a}};var OPERATORS={BRT:{description:'Brasil Telecom',IMAGEURL:__WEBPACK_IMPORTED_MODULE_0__loyal_images_orders_pedido_brasil_telecom_jpg___default.a},CLARO:{description:'Claro',IMAGEURL:__WEBPACK_IMPORTED_MODULE_1__loyal_images_orders_pedido_claro_jpg___default.a},NEXTEL:{description:'Nextel',IMAGEURL:__WEBPACK_IMPORTED_MODULE_4__loyal_images_orders_pedido_nextel_jpg___default.a},OI:{description:'Oi',IMAGEURL:__WEBPACK_IMPORTED_MODULE_5__loyal_images_orders_pedido_oi_jpg___default.a},TIM:{description:'Tim',IMAGEURL:__WEBPACK_IMPORTED_MODULE_8__loyal_images_orders_pedido_tim_jpg___default.a},VIVO:{description:'Vivo',IMAGEURL:__WEBPACK_IMPORTED_MODULE_10__loyal_images_orders_pedido_vivo_jpg___default.a}};var DEFAULTDAYSFILTER=7;/* harmony default export */ __webpack_exports__["a"] = ({selectOptions:selectOptions,VENDOR:VENDOR,PRODUCTSPLACEHOLDER:PRODUCTSPLACEHOLDER,DEFAULTDAYSFILTER:DEFAULTDAYSFILTER,OPERATORS:OPERATORS});

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadMyOrders */
/* unused harmony export setFilterQueryString */
/* unused harmony export getVoucherLink */
/* unused harmony export getOrderListDetails */
/* unused harmony export getOrderDetailsApi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
var loadMyOrders=function loadMyOrders(pageIndex,pageSize,initialDate,endDate,orderId){var offset=pageIndex&&pageSize?pageIndex*pageSize:0;var formattedInitialDate=initialDate?__WEBPACK_IMPORTED_MODULE_0_moment___default()(initialDate).format('DD/MM/YYYY'):'';var formattedEndDate=endDate?__WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).format('DD/MM/YYYY'):'';orderId=orderId||'';return{type:'FETCH_ORDER',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/me/orders?orderId='+orderId+'&startDate='+formattedInitialDate+'&endDate='+formattedEndDate+'&offset='+offset+'&limit='+(pageSize||'10')}},page:pageIndex};};var setFilterQueryString=function setFilterQueryString(days){return Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["push"])('/my-orders?days='+days);};var getVoucherLink=function getVoucherLink(data){return{type:'GET_VOUCHER_LINK',payload:{client:'cloudloyalty',request:{method:'post',url:'/v1/purchases/voucherLink',data:data}}};};var getOrderListDetails=function getOrderListDetails(parentOrderId,orderId,productId){return{type:'GET_ORDERLIST',parentOrderId:parentOrderId,productId:productId,orderId:orderId,payload:{client:'tracking',request:{method:'get',url:'/timelines/'+orderId}}};};var getOrderDetailsApi=function getOrderDetailsApi(parentOrderId,orderId,productId){return{type:'FETCH_ORDER_DETAIL_API',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/me/orders?orderId='+parentOrderId+'&startDate=&endDate=&offset=0&limit=1'}},parentOrderId:parentOrderId,productId:productId,orderId:orderId};};/* harmony default export */ __webpack_exports__["a"] = ({loadMyOrders:loadMyOrders,getOrderListDetails:getOrderListDetails,setFilterQueryString:setFilterQueryString,getOrderDetailsApi:getOrderDetailsApi,getVoucherLink:getVoucherLink});

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={order:[],listtracking:[],hasMoreItems:true,page:-1,ready:false,loading:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_ORDER':{var orders=action.page===0?[]:state.orders;return Object.assign({},state,{loading:true,page:action.page,orders:[].concat(_toConsumableArray(orders))});}case'FETCH_ORDER_SUCCESS':{var result={orders:state&&state.orders?action.payload.data&&action.payload.data.orders?[].concat(_toConsumableArray(state.orders),_toConsumableArray(action.payload.data.orders)):[]:action.payload.data&&action.payload.data.orders?[].concat(_toConsumableArray(action.payload.data.orders)):[],totalRecords:action.payload.data&&action.payload.data.orders?action.payload.data.total:0,hasMoreItems:action.payload.data&&action.payload.data.orders&&action.payload.data.orders.length===10,ready:true,loading:false,page:state.page};return result;}case'FETCH_ORDER_FAIL':{return Object.assign({},state,{hasMoreItems:false,error:action.request&&action.request.status!==404?'Error':undefined,ready:true,loading:false});}case'GET_ORDER':{var _parentOrderDetail=null;var _orderDetail=null;var _productDetail=null;if(state.orders){_parentOrderDetail=state.orders.find(function(element,index,array){return element.parentOrderId===action.parentOrderId;});if(_parentOrderDetail){_orderDetail=_parentOrderDetail.vendorOrderModel.find(function(element){return element.orderId.toString()===action.orderId;});if(_orderDetail){_productDetail=_orderDetail.items.find(function(element,index){return element.id.toString()===action.productId;});}}}return Object.assign({},state,{parentOrderDetail:_parentOrderDetail,orderDetail:_orderDetail,productDetail:_productDetail,orderDetailNotFound:undefined,orderDetailNotFoundRedux:undefined,tracking:undefined});}case'GET_ORDER_SUCCESS':return Object.assign({},state,{orderDetailNotFound:undefined,orderDetailNotFoundRedux:undefined,tracking:action.payload.data});case'GET_ORDERLIST':{var _parentOrderDetail2=null;var _orderDetail2=null;var _productDetail2=null;if(state.orders){_parentOrderDetail2=state.orders.find(function(element,index,array){return element.parentOrderId===action.parentOrderId;});if(_parentOrderDetail2){_orderDetail2=_parentOrderDetail2.vendorOrderModel.find(function(element,index,array){return element.orderId.toString()===action.orderId;});if(_orderDetail2){_productDetail2=_orderDetail2.items.find(function(element,index,array){return element.id.toString()===action.productId;});}}}if(_parentOrderDetail2&&_orderDetail2&&_productDetail2){return Object.assign({},state,{parentOrderDetail:_parentOrderDetail2,orderDetail:_orderDetail2,productDetail:_productDetail2,orderDetailNotFound:undefined,orderDetailNotFoundRedux:undefined,tracking:undefined});}else{return Object.assign({},state,{parentOrderDetail:undefined,orderDetail:undefined,productDetail:undefined,orderDetailNotFoundRedux:true,orderDetailNotFound:undefined,tracking:undefined});}}case'GET_ORDERLIST_SUCCESS':return Object.assign({},state,{orderDetailNotFound:undefined,orderDetailNotFoundRedux:undefined,tracking:action.payload.data});case'GET_ORDER_TRACKING':return Object.assign({},state,{orderDetailNotFound:undefined,orderDetailNotFoundRedux:undefined});case'FETCH_ORDER_DETAIL_API':return Object.assign({},state,{orderDetailNotFound:undefined,orderDetailNotFoundRedux:undefined});case'FETCH_ORDER_DETAIL_API_FAIL':return Object.assign({},state,{orderDetailNotFound:true});case'FETCH_ORDER_DETAIL_API_SUCCESS':var parentOrderDetail=action.payload.data&&action.payload.data.orders&&action.payload.data.orders.length>0&&action.payload.data.orders[0];var orderDetail=parentOrderDetail&&parentOrderDetail.vendorOrderModel.find(function(element){return element.orderId.toString()===action.meta.previousAction.orderId;});var productDetail=orderDetail&&orderDetail.items.find(function(element){return element.id.toString()===action.meta.previousAction.productId;});return Object.assign({},state,{parentOrderDetail:parentOrderDetail,orderDetail:orderDetail,productDetail:productDetail});default:return state||initialState;}});

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectMobileOperator=function(_Component){_inherits(SelectMobileOperator,_Component);function SelectMobileOperator(props){_classCallCheck(this,SelectMobileOperator);var _this=_possibleConstructorReturn(this,(SelectMobileOperator.__proto__||Object.getPrototypeOf(SelectMobileOperator)).call(this,props));if(!_this.props.operators||_this.props.operators.length<=0){_this.props.getMobileOperators();}return _this;}_createClass(SelectMobileOperator,[{key:'render',value:function render(){var _this2=this;var source=this.props.operators||[];var value=source.find(function(item){return item.description===_this2.props.description;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Select"],{id:this.props.id,label:this.props.label,className:this.props.className,displayValue:'description',selectedValue:'mobileOperator',options:source,value:value,onChange:this.props.onChange,disabled:this.props.disabled});}}]);return SelectMobileOperator;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SelectMobileOperator.propTypes={description:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,operators:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,onChange:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,getMobileOperators:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,disabled:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var mobileOperators=_ref.mobileOperators;return{operators:mobileOperators};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getMobileOperators:function getMobileOperators(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].getMobileOperators());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SelectMobileOperator));

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValuesRecharge__ = __webpack_require__(1508);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var valuesRecharge=_ref.valuesRecharge;return{valuesRecharge:valuesRecharge};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getValuesRecharge:function getValuesRecharge(operatorKey,areaCode){return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].getValuesRecharge(operatorKey,areaCode));},clearAreaCodes:function clearAreaCodes(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].clearAreaCodes());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ValuesRecharge__["a" /* default */]));

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_recharge_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_recharge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_template_recharge_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValuesRecharge=function(_Component){_inherits(ValuesRecharge,_Component);function ValuesRecharge(props){_classCallCheck(this,ValuesRecharge);var _this=_possibleConstructorReturn(this,(ValuesRecharge.__proto__||Object.getPrototypeOf(ValuesRecharge)).call(this,props));_this.onChangeValue=_this.onChangeValue.bind(_this);return _this;}_createClass(ValuesRecharge,[{key:'componentDidMount',value:function componentDidMount(){this.props.getValuesRecharge(this.props.operatorKey,this.props.areaCode);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.operatorKey!==prevProps.operatorKey&&this.props.operatorKey!==''||this.props.areaCode!==prevProps.areaCode&&this.props.areaCode!==''){this.props.getValuesRecharge(this.props.operatorKey,this.props.areaCode);}}},{key:'onChangeValue',value:function onChangeValue(serviceId,pointsValue,rechargeValue){this.props.onChangeValue({value:serviceId,pointsValue:pointsValue,rechargeValue:rechargeValue});}},{key:'render',value:function render(){var _this2=this;var valuesRecharge=[];this.props.valuesRecharge.map(function(item){valuesRecharge.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 col-md-2 col-lg-2 mt-6 mb-1 radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'inputRecarga'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["RadioButton"],{name:'inputRecarga',id:'radio'+item.serviceId,className:'d-none',hidden:'true',value:item.serviceId,defaultChecked:item.serviceId===_this2.props.valueSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'btn'+item.serviceId,name:'botaoRecarga',className:'d-block radius  pointer border px-1 py-2 txt-body-sm txt-center '+(item.serviceId===_this2.props.valueSelected?'border-color-brand-1 color-brand-1 bg-ui-4':'border-color-ui-2'),onClick:function onClick(e){return _this2.onChangeValue(item.serviceId,item.pointsValue,item.rechargeValue);}},item.serviceId===_this2.props.valueSelected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ ',item.rechargeValue):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'R$ ',item.rechargeValue)))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-lg-12 txt-title-3 txt-body-sm txt-font-body txt-left mt-2 color-ui-2 px-0 mb-1'},'Escolha o valor em cr\xE9ditos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-lg-12 mt-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},valuesRecharge)));}}]);return ValuesRecharge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValuesRecharge.propTypes={valuesRecharge:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,areaCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,operatorKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,getValuesRecharge:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onChangeValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,valueSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ValuesRecharge);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState=[];/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_CREDITVALUE_SUCCESS':return[].concat(_toConsumableArray(action.payload.data));case'FETCH_CREDITVALUE_FAIL':return state||initialState;case'CLEAR_CREDITVALUE':return initialState;default:return state||initialState;}});

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectAreaCode__ = __webpack_require__(1512);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var areaCodes=_ref.areaCodes;return{areaCodes:areaCodes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAreaCodes:function getAreaCodes(operatorKey){return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].getAreaCodes(operatorKey));},clearAreaCodes:function clearAreaCodes(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].clearAreaCodes());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SelectAreaCode__["a" /* default */]));

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAreaCodes */
/* unused harmony export clearAreaCodes */
var getAreaCodes=function getAreaCodes(operatorKey){return{type:'FETCH_AREACODES',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/mobileRecharges/mobileoperator/'+operatorKey+'/areacode'}}};};var clearAreaCodes=function clearAreaCodes(){return{type:'CLEAR_AREACODES'};};/* harmony default export */ __webpack_exports__["a"] = ({getAreaCodes:getAreaCodes,clearAreaCodes:clearAreaCodes});

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectAreaCode=function(_Component){_inherits(SelectAreaCode,_Component);function SelectAreaCode(props){_classCallCheck(this,SelectAreaCode);var _this=_possibleConstructorReturn(this,(SelectAreaCode.__proto__||Object.getPrototypeOf(SelectAreaCode)).call(this,props));_this.props.getAreaCodes(_this.props.operatorKey);return _this;}_createClass(SelectAreaCode,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if((this.props.areaCodes||this.props.areaCodes.length>0)&&!this.props.operatorKey){this.props.clearAreaCodes();}if(this.props.operatorKey!==prevProps.operatorKey){this.props.getAreaCodes(this.props.operatorKey);}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'dataDDD',label:'DDD',className:'col-4',displayValue:'description',selectedValue:'areaCode',options:this.props.areaCodes,onChange:function onChange(e){return _this2.props.onChangeAreaCode(e);},value:this.props.areaCodes.find(function(item){return item.areaCode===_this2.props.areaCode;}),disabled:this.props.disabled,required:this.props.required,key:this.props.areaCode});}}]);return SelectAreaCode;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectAreaCode.propTypes={areaCodes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,onChangeAreaCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,getAreaCodes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,operatorKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,areaCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,clearAreaCodes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,required:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SelectAreaCode);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState=[];/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_AREACODES':return initialState;case'FETCH_AREACODES_SUCCESS':return[].concat(_toConsumableArray(action.payload.data));case'FETCH_AREACODES_FAIL':return initialState;case'CLEAR_AREACODES':return initialState;default:return state||initialState;}});

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export insertMobileRecharge */
/* unused harmony export scheduleMobileRecharges */
/* unused harmony export getOrderService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var handleErrorMessage=function handleErrorMessage(data){var message='';if(data){if(typeof data==='string'){message=data;}else if(data&&data.errors&&data.errors.constructor===Array){data.errors.map(function(item){return message+=item.message;});}else if(data.messages&&data.messages.constructor===Array){data.messages.map(function(item){return message+=item.description;});}}message=message||'Erro inesperado, favor tentar mais tarde';return message;};var secondFactorAuthentication=function secondFactorAuthentication(orderId,secondFactorAuthConfirmated){return{type:'SECOND_FACTOR_AUTHENTICATION',orderId:orderId,secondFactorAuthConfirmated:secondFactorAuthConfirmated};};var validateFundsPurchase=function validateFundsPurchase(client){return function(serviceId,validatedCallback,invalidatedCallback){client.post('/v1/purchases/ValidateFundsPurchase',{TypeValidate:3,Service:{Type:1,ServiceId:serviceId},ChannelType:1}).then(function(response){if(response.status===200){if(validatedCallback)validatedCallback();}}).catch(function(error){var message=error&&error.response&&error.response.data&&handleErrorMessage(error.response.data);if(invalidatedCallback)invalidatedCallback(message);});};};var insertService=function insertService(client,dispatch){return function(serviceId,operatorKey,areaCode,phone,successCallback,errorCallback){if(phone)phone=phone.replace('-','').replace('_','');client.post('/v1/purchases/service',{serviceId:serviceId.toString(),type:__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* default */].SERVICETYPE_MOBILE_RECHARGE,configuration:[{key:'OPERADORA',value:operatorKey},{key:'DDD',value:areaCode.toString()},{key:'PHONE',value:phone}]}).then(function(response){if(response.data){if(response.data.status&&response.data.status==='RequiresTokenValidation'){dispatch(secondFactorAuthentication(response.data.id,true));return;}if(successCallback){successCallback(response.data);}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/confirmation/'+response.data.id));dispatch({type:'MOBILE_RECHARGE_FINALIZE_ORDER_SUCCESS'});}}else{errorCallback('Erro inesperado, favor tentar mais tarde');}dispatch({type:'MOBILE_RECHARGE_FINALIZE_ORDER_END'});}).catch(function(error){var message=handleErrorMessage(error.response.data);if(error.response.status===406){dispatch(secondFactorAuthentication(null,false));}else if(errorCallback){errorCallback(message);}else{dispatch(showErrorMessage(message));dispatch({type:'MOBILE_RECHARGE_FINALIZE_ORDER_END'});}});};};var showErrorMessage=function showErrorMessage(message){return{type:'SHOW_ERRORMESSAGE_RECHARGE',message:message};};var insertMobileRecharge=function insertMobileRecharge(client){return function(serviceId,operatorKey,areaCode,phone,successCallback,errorCallback){return function(dispatch,_){dispatch({type:'MOBILE_RECHARGE_FINALIZE_ORDER'});validateFundsPurchase(client,dispatch)(serviceId,function(){return insertService(client,dispatch)(serviceId,operatorKey,areaCode,phone,successCallback,errorCallback);},function(message){if(errorCallback){errorCallback(message);}else{dispatch({type:'MOBILE_RECHARGE_FINALIZE_ORDER_END'});dispatch(showErrorMessage(message));}});};};};var scheduleMobileRecharges=function scheduleMobileRecharges(client){return function(serviceId,operatorKey,areaCode,phone,initialScheduleDate,endScheduleDate,creditValue,pointValue){return function(dispatch,_){dispatch({type:'MOBILE_RECHARGE_SCHEDULE_ORDER'});var innitial=__WEBPACK_IMPORTED_MODULE_2_moment___default()(initialScheduleDate);var end=__WEBPACK_IMPORTED_MODULE_2_moment___default()(endScheduleDate);var qtdScheduleMonths=end.diff(innitial,'months');client.post('/v3/myschedules',{vendorId:__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* default */].VENDORID_CELLPHONE_RECHARGE,initialScheduleDate:innitial.format('YYYY/MM/DD HH:mm:ss'),endScheduleDate:end.format('YYYY/MM/DD HH:mm:ss'),qtdScheduleMonths:qtdScheduleMonths,creditValue:creditValue,pointValue:pointValue,serviceType:__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* default */].SERVICETYPE_MOBILE_RECHARGE,operator:operatorKey,ddd:areaCode,phone:phone,serviceId:serviceId}).then(function(response){if(response.status===200&&response.data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/mobile-recharge/confirmation/'+response.data.id));}dispatch({type:'MOBILE_RECHARGE_SCHEDULE_ORDER_END'});}).catch(function(error){var message=handleErrorMessage(error.response.data);dispatch({type:'MOBILE_RECHARGE_SCHEDULE_ORDER_END'});dispatch(showErrorMessage(message));});};};};var getOrderService=function getOrderService(orderId){return{type:'GET_ORDER_SERVICE',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/'+orderId+'/order'}}};};/* harmony default export */ __webpack_exports__["a"] = (function(client){return{insertMobileRecharge:insertMobileRecharge(client),getOrderService:getOrderService,scheduleMobileRecharges:scheduleMobileRecharges(client)};});

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cellphonerecharge__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Checkout_actions__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var _ref$cellphoneRecharg=_ref.cellphoneRecharge,loadingFinalizeOrder=_ref$cellphoneRecharg.loadingFinalizeOrder,loadingScheduleOrder=_ref$cellphoneRecharg.loadingScheduleOrder,errorMessage=_ref$cellphoneRecharg.errorMessage,secondFactorAuthentication=_ref$cellphoneRecharg.secondFactorAuthentication,secondFactorAuthenticationOrderId=_ref$cellphoneRecharg.secondFactorAuthenticationOrderId,secondFactorAuthConfirmated=_ref$cellphoneRecharg.secondFactorAuthConfirmated,oidc=_ref.oidc,_ref$checkout=_ref.checkout,secondFactorAuthSuccess=_ref$checkout.secondFactorAuthSuccess,authorized=_ref$checkout.authorized,status=_ref$checkout.status,messageError_=_ref$checkout.messageError_,hasError=_ref$checkout.hasError,loadingResendToken=_ref$checkout.loadingResendToken,isCreatingPurchase=_ref$checkout.isCreatingPurchase,errorToken=_ref$checkout.errorToken,titleError=_ref$checkout.titleError;return{errorMessage:errorMessage,loadingFinalizeOrder:loadingFinalizeOrder,loadingScheduleOrder:loadingScheduleOrder,oidc:oidc,secondFactorAuthentication:secondFactorAuthentication||secondFactorAuthenticationOrderId&&!secondFactorAuthSuccess,secondFactorAuthenticationOrderId:secondFactorAuthenticationOrderId,secondFactorAuthConfirmated:secondFactorAuthConfirmated,authorizeWithTokenData:secondFactorAuthenticationOrderId&&{secondFactorAuthSuccess:secondFactorAuthSuccess,authorized:authorized,status:status,hasError:hasError,messageError:messageError_,loadingResendToken:loadingResendToken,isCreatingPurchase:isCreatingPurchase,errorToken:errorToken,titleError:titleError}};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{insertMobileRecharge:function insertMobileRecharge(serviceId,operatorKey,areaCode,phone){dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].insertMobileRecharge(serviceId,operatorKey,areaCode,phone));},scheduleMobileRecharges:function scheduleMobileRecharges(serviceId,operatorKey,areaCode,phone,initialScheduleDate,endScheduleDate,creditValue,pointValue){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["c" /* actions */].scheduleMobileRecharges(serviceId,operatorKey,areaCode,phone,initialScheduleDate,endScheduleDate,creditValue,pointValue));},clearErrorMessage:function clearErrorMessage(){return dispatch({type:'CLEAR_ERROR_MESSAGE'});},closeSecondFactorModal:function closeSecondFactorModal(){return dispatch({type:'CLOSE_SECOND_FACTOR'});},authorizeWithTokenResend:function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Checkout_actions__["b" /* authorizeWithTokenResend */](OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},authorizeWithToken:function authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){var lastTry=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;return dispatch(__WEBPACK_IMPORTED_MODULE_4__Checkout_actions__["a" /* authorizeWithToken */](OrderId,PaymentMoneyRequest,Token,TokenType,Resend,lastTry));},redirectConfirmation:function redirectConfirmation(orderId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["push"])('/confirmation/'+orderId));},clearRedux:function clearRedux(){dispatch({type:'RESET_DATA'});dispatch({type:'CLEAR_CONFIRMED_ORDER_DATA'});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Cellphonerecharge__["a" /* default */]));

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_recharge_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_recharge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_recharge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResumeRecharge__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectOperator__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ValuesRecharge__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PhoneNumber__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ScheduleRecharge__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AlertErrorMessage__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalTerms__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14____ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalConfirmRecharge_index__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Checkout_SecondFactorAuthenticaton__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cellphonerecharge=function(_Component){_inherits(Cellphonerecharge,_Component);function Cellphonerecharge(props){_classCallCheck(this,Cellphonerecharge);var _this=_possibleConstructorReturn(this,(Cellphonerecharge.__proto__||Object.getPrototypeOf(Cellphonerecharge)).call(this,props));_this.onSelectOperatorChange=_this.onSelectOperatorChange.bind(_this);_this.onChangeAreaCode=_this.onChangeAreaCode.bind(_this);_this.finalizeOrder=_this.finalizeOrder.bind(_this);_this.onChangeCreditValue=_this.onChangeCreditValue.bind(_this);_this.onChangePhoneNumber=_this.onChangePhoneNumber.bind(_this);_this.showTerms=_this.showTerms.bind(_this);_this.acceptTerms=_this.acceptTerms.bind(_this);_this.onChangeEndDate=_this.onChangeEndDate.bind(_this);_this.onChangeInnitialDate=_this.onChangeInnitialDate.bind(_this);_this.onChangeScheduleOrder=_this.onChangeScheduleOrder.bind(_this);_this.clearErrorMessage=_this.clearErrorMessage.bind(_this);_this.scheduleOrder=_this.scheduleOrder.bind(_this);_this.onRechargeConfirm=_this.onRechargeConfirm.bind(_this);props.clearRedux();if(props.location.state&&props.location.state.mobileRecharge){_this.state=props.location.state.mobileRecharge;props.history.replace({state:null});}else{_this.state={operatorKey:'',areaCode:'',creditValue:'',pointsValue:'',rechargeValue:'',schedule:false,phoneNumber:'',showTerms:false,acceptTerms:false,innitialDate:null,endDate:null,rechargeConfirmation:false};}return _this;}_createClass(Cellphonerecharge,[{key:'onRechargeConfirm',value:function onRechargeConfirm(){this.props.clearRedux();this.setState(Object.assign({},this.state,{rechargeConfirmation:true}));}},{key:'onSelectOperatorChange',value:function onSelectOperatorChange(e){this.setState({operatorKey:e.target.value,areaCode:'',creditValue:'',pointsValue:'',rechargeValue:'',acceptTerms:false});}},{key:'onChangeAreaCode',value:function onChangeAreaCode(e){this.setState({areaCode:e.areaCode,creditValue:'',pointsValue:'',rechargeValue:'',acceptTerms:false});}},{key:'onChangeCreditValue',value:function onChangeCreditValue(e){this.setState({creditValue:e.value,pointsValue:e.pointsValue,rechargeValue:e.rechargeValue,acceptTerms:false});}},{key:'onChangePhoneNumber',value:function onChangePhoneNumber(e){this.setState({phoneNumber:e.phoneNumber});}},{key:'showTerms',value:function showTerms(e){this.setState({showTerms:true});}},{key:'acceptTerms',value:function acceptTerms(accept){this.setState({acceptTerms:accept});}},{key:'onChangeScheduleOrder',value:function onChangeScheduleOrder(e){this.setState({schedule:e.target.checked,acceptTerms:false});}},{key:'finalizeOrder',value:function finalizeOrder(){this.props.insertMobileRecharge(this.state.creditValue,this.state.operatorKey,this.state.areaCode,this.state.phoneNumber);}},{key:'scheduleOrder',value:function scheduleOrder(){this.props.scheduleMobileRecharges(this.state.creditValue,this.state.operatorKey,this.state.areaCode,this.state.phoneNumber,this.state.innitialDate,this.state.endDate,this.state.rechargeValue,this.state.pointsValue);}},{key:'clearErrorMessage',value:function clearErrorMessage(){this.props.clearErrorMessage();}},{key:'onChangeEndDate',value:function onChangeEndDate(date){this.setState({endDate:date});}},{key:'onChangeInnitialDate',value:function onChangeInnitialDate(date){this.setState({innitialDate:date});}},{key:'toogleModal',value:function toogleModal(){this.props.closeSecondFactorModal();}},{key:'render',value:function render(){var _this2=this;var body=[];var errorMessage=this.props.errorMessage;var titleError=this.props.authorizeWithTokenData&&this.props.authorizeWithTokenData.titleError||'';if(this.props.authorizeWithTokenData){if(this.props.authorizeWithTokenData.authorized){this.props.closeSecondFactorModal();this.props.redirectConfirmation(this.props.secondFactorAuthenticationOrderId);}else if(this.props.authorizeWithTokenData.secondFactorAuthSuccess&&this.props.authorizeWithTokenData.hasError||this.props.authorizeWithTokenData.status==='TokenFinished'){this.props.closeSecondFactorModal();errorMessage=this.props.authorizeWithTokenData.messageError||'Não foi possível concluir o seu pagamento. Tentativas de verificação de token excedidas.';if(this.state.rechargeConfirmation){this.setState({rechargeConfirmation:false});}}}if(this.state.operatorKey!==''){body.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-auto col-lg-12 border-dotted-top color-ui-3 px-0 col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left mt-2'},'Digite seu telefone')));body.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PhoneNumber__["a" /* PhoneNumber */],{operatorKey:this.state&&this.state.operatorKey,onChangeAreaCode:this.onChangeAreaCode,onChangePhoneNumber:this.onChangePhoneNumber,areaCode:this.state.areaCode,phoneNumber:this.state.phoneNumber,divContentClassName:'col-md-12 col-lg-6 form-field mt-1 px-0',required:true}));if(this.state.areaCode!==''){body.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-dotted-top color-ui-3 mt-2'}));body.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ValuesRecharge__["a" /* ValuesRecharge */],{onChangeValue:this.onChangeCreditValue,valueSelected:this.state&&this.state.creditValue,areaCode:this.state&&this.state.areaCode,operatorKey:this.state&&this.state.operatorKey}));if(__WEBPACK_IMPORTED_MODULE_17_yn___default()("false")&&this.state.creditValue){body.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ScheduleRecharge__["a" /* ScheduleRecharge */],{innitialDate:this.state.innitialDate,endDate:this.state.endDate,onChangeEndDate:this.onChangeEndDate,onChangeInnitialDate:this.onChangeInnitialDate,maxQuantityMonths:24,onChangeScheduleOrder:this.onChangeScheduleOrder,scheduleOrder:this.state.schedule}));}}}var modalRechargeConfirm=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ModalConfirmRecharge_index__["a" /* ModalConfirmRecharge */],{onClose:function onClose(e){return _this2.setState({rechargeConfirmation:false});},show:this.state.rechargeConfirmation,areaCode:this.state.areaCode,phoneNumber:this.state.phoneNumber,creditValue:this.state.rechargeValue,finalizeOrder:this.finalizeOrder,loadingFinalizeOrder:this.props.loadingFinalizeOrder}));var modalTerms=this.state.schedule?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalTerms__["a" /* ModalTerms */],{show:this.state.showTerms,onClose:function onClose(e){return _this2.setState({showTerms:false});},acceptTerms:function acceptTerms(e){_this2.setState({showTerms:false});_this2.acceptTerms(true);},terms:{vendorId:__WEBPACK_IMPORTED_MODULE_15__constants__["d" /* default */].VENDORID_CELLPHONE_RECHARGE,type:__WEBPACK_IMPORTED_MODULE_15__constants__["d" /* default */].REGULATION_TYPE_CAMPAIGN_AND_VENDOR,regulationType:__WEBPACK_IMPORTED_MODULE_15__constants__["d" /* default */].REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalTerms__["a" /* ModalTerms */],{show:this.state.showTerms,onClose:function onClose(e){return _this2.setState({showTerms:false});},acceptTerms:function acceptTerms(e){_this2.setState({showTerms:false});_this2.acceptTerms(true);},terms:{vendorId:__WEBPACK_IMPORTED_MODULE_15__constants__["d" /* default */].VENDORID_CELLPHONE_RECHARGE,type:__WEBPACK_IMPORTED_MODULE_15__constants__["d" /* default */].REGULATION_TYPE_VENDOR}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Recarga de celular - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14____["b" /* CellphonerechargePlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-0 py-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AlertErrorMessage__["a" /* default */],{errorMessage:errorMessage,filledState:this.clearErrorMessage,title:titleError}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8 col-lg-8 pl-0 pr-0 pr-md-2 pr-lg-2 py-0 h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white md-mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 pb-1 border-color-ui-3 border-bottom bg-recharge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3 color-brand-5 col-12 my-3'},'Recarga de celular')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' px-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-1 border-color-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SelectOperator__["a" /* SelectOperator */],{checkedValue:this.state.operatorKey,onChangeValue:this.onSelectOperatorChange})),body))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ResumeRecharge__["a" /* ResumeRecharge */],{operator:this.state.operatorKey,areaCode:this.state.areaCode,phoneNumber:this.state.phoneNumber,creditValue:this.state.rechargeValue,pointsValue:this.state.pointsValue,scheduleOrder:this.scheduleOrder,onRechargeConfirm:this.onRechargeConfirm,scheduled:this.state.schedule,showTerms:this.showTerms,acceptedTerm:(!__WEBPACK_IMPORTED_MODULE_17_yn___default()("true")||this.state.acceptTerms)&&this.state.operatorKey&&this.state.phoneNumber&&this.state.phoneNumber.indexOf('_')===-1&&this.state.phoneNumber.trim().length===10&&this.state.pointsValue&&(!this.schedule||this.state.innitialDate&&this.state.endDate),onChangeAcceptTerms:this.acceptTerms,loadingScheduleOrder:this.props.loadingScheduleOrder})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,modalTerms),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,modalRechargeConfirm))),this.props.secondFactorAuthentication&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Checkout_SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],{show:true,onClose:function onClose(){return _this2.toogleModal();},paymentSelected:'POINTS_ONLY',paymentPoints:null,oidc:this.props.oidc,confirmedOrderId:this.props.secondFactorAuthenticationOrderId,closeModal:this.props.closeSecondFactorModal,authorizeWithTokenResend:this.props.authorizeWithTokenResend,authorizeWithToken:this.props.authorizeWithToken,loadingResendToken:this.props.authorizeWithTokenData&&this.props.authorizeWithTokenData.loadingResendToken,isCreatingPurchase:this.props.authorizeWithTokenData&&this.props.authorizeWithTokenData.isCreatingPurchase,errorToken:this.props.authorizeWithTokenData&&this.props.authorizeWithTokenData.errorToken,secondFactorAuthConfirmated:this.props.secondFactorAuthConfirmated})));}}]);return Cellphonerecharge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Cellphonerecharge.propTypes={insertMobileRecharge:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,clearErrorMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,errorMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,loadingScheduleOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loadingFinalizeOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,scheduleMobileRecharges:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,oidc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,secondFactorAuthentication:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,secondFactorAuthenticationOrderId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,closeSecondFactorModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,authorizeWithToken:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,authorizeWithTokenData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,redirectConfirmation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,clearRedux:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,secondFactorAuthConfirmated:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Cellphonerecharge);

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResumeRecharge__ = __webpack_require__(1518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ResumeRecharge__["a"]; });


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOption__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_recharge_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_recharge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_recharge_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResumeRecharge=function(_Component){_inherits(ResumeRecharge,_Component);function ResumeRecharge(){_classCallCheck(this,ResumeRecharge);return _possibleConstructorReturn(this,(ResumeRecharge.__proto__||Object.getPrototypeOf(ResumeRecharge)).apply(this,arguments));}_createClass(ResumeRecharge,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 col-lg-4 border-ui-3 radius bg-white py-0 mt-2 mt-md-0 mb-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3'},'Resumo de recarga'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-3 mx-0 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand py-1 border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'Operadora: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.operator)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'Telefone: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.phoneNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'Valor em cr\xE9ditos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.creditValue?'R$ '+this.props.creditValue.toLocaleString('pt-br',{minimumFractionDigits:2}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'},'Valor em pontos:',' ',this.props.pointsValue?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:this.props.pointsValue}):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-2 mb-1 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 txt-subtitle txt-font-body color-ui-2 txt-justify justify-content-center align-self-center'},'O valor pode ser creditado em at\xE9 96 horas. Caso o valor n\xE3o seja creditado nesse per\xEDodo, entre em contato com sua operadora de telefonia. A validade do cr\xE9dito pode mudar para cada operadora.')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TermsOption__["a" /* default */],{acceptedTerm:this.props.acceptedTerm,onChangeAcceptTerms:this.props.onChangeAcceptTerms,showTerms:this.props.showTerms}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-1 pt-2'},this.props.scheduled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn-featured btn-icon',text:'Agendar recarga',disabled:!this.props.acceptedTerm,onClick:this.props.scheduleOrder,loading:this.props.loadingScheduleOrder})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn-featured btn-gift',text:'Finalizar Recarga',disabled:!this.props.acceptedTerm,onClick:this.props.onRechargeConfirm}))))));}}]);return ResumeRecharge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResumeRecharge.propTypes={operator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,scheduled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,acceptedTerm:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,scheduleOrder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onRechargeConfirm:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,showTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onChangeAcceptTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,loadingScheduleOrder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ResumeRecharge);

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var TermsOption=function TermsOption(_ref){var acceptedTerm=_ref.acceptedTerm,onChangeAcceptTerms=_ref.onChangeAcceptTerms,showTerms=_ref.showTerms;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-title-3 txt-subtitle txt-font-body color-ui-2 txt-justify justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Checkbox"],{id:'aceito_termos',checked:acceptedTerm,className:'col-auto',labelClass:'l-0',outerLabel:true,onChange:function onChange(e){return onChangeAcceptTerms(e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:function onClick(e){return showTerms();},className:'txt-body-sm color-brand-2 txt-underline',role:'button'},'termos do regulamento'))))));};TermsOption.propTypes={acceptedTerm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChangeAcceptTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TermsOption);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectOperatorContainer__ = __webpack_require__(1521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SelectOperatorContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectMobileOperator_reducer__ = __webpack_require__(593);
/* unused harmony reexport reducer */


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectMobileOperator_actions__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectOperator__ = __webpack_require__(1522);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var mobileOperators=_ref.mobileOperators;return{operators:mobileOperators};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getMobileOperators:function getMobileOperators(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__SelectMobileOperator_actions__["a" /* default */].getMobileOperators());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__SelectOperator__["a" /* default */]));

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_recharge_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_recharge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_recharge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OperatorImg__ = __webpack_require__(1523);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectOperator=function(_Component){_inherits(SelectOperator,_Component);function SelectOperator(){_classCallCheck(this,SelectOperator);return _possibleConstructorReturn(this,(SelectOperator.__proto__||Object.getPrototypeOf(SelectOperator)).apply(this,arguments));}_createClass(SelectOperator,[{key:'componentDidMount',value:function componentDidMount(){this.props.getMobileOperators();}},{key:'getClassNameByOperator',value:function getClassNameByOperator(operatorKey){switch(operatorKey){case'Claro':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'img-operadora op-claro radius'});case'Nextel':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'img-operadora op-nextel radius'});case'Oi':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'img-operadora op-oi radius'});case'Tim':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'img-operadora op-tim radius'});case'Vivo':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'img-operadora op-vivo radius'});case'Brasil Telecom':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'img-operadora op-brasil radius'});default:return'';}}},{key:'render',value:function render(){var _this2=this;var operatorsOptions=[];this.props.operators.map(function(item){operatorsOptions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'col-6 col-md-2 col-lg-2 mt-2 mt-md-1 mb-0 pr-1 pr-md-2 radius boder-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'op-'+item.mobileOperator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'operadora',id:'op-'+item.mobileOperator,className:'txt-center pb-1 pt-1',type:'radio',hidden:'true',value:item.mobileOperator,onChange:function onChange(e){return _this2.props.onChangeValue(e);},checked:item.mobileOperator===_this2.props.checkedValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OperatorImg__["a" /* default */],{operatorKey:item.mobileOperator}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-lg-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left mt-1 px-0'},'Selecione a operadora que deseja fazer sua recarga.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'operadoras row'},operatorsOptions)));}}]);return SelectOperator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectOperator.propTypes={operators:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,getMobileOperators:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,checkedValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onChangeValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SelectOperator);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var OperatorImg=function OperatorImg(props){switch(props.operatorKey){case'Claro':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mx-auto img-operadora op-claro radius cursor'});case'Nextel':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mx-auto img-operadora op-nextel radius cursor'});case'Oi':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mx-auto img-operadora op-oi radius cursor'});case'Tim':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mx-auto img-operadora op-tim radius cursor'});case'Vivo':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mx-auto img-operadora op-vivo radius cursor'});case'Brasil Telecom':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mx-auto img-operadora op-brasil radius cursor'});default:return'';}};OperatorImg.propTypes={operatorKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (OperatorImg);

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectAreaCode__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_recharge_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_recharge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_recharge_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PhoneNumber=function(_Component){_inherits(PhoneNumber,_Component);function PhoneNumber(props){_classCallCheck(this,PhoneNumber);var _this=_possibleConstructorReturn(this,(PhoneNumber.__proto__||Object.getPrototypeOf(PhoneNumber)).call(this,props));_this.onChangePhoneNumber=_this.onChangePhoneNumber.bind(_this);_this.onChangeAreaCode=_this.onChangeAreaCode.bind(_this);return _this;}_createClass(PhoneNumber,[{key:'onChangePhoneNumber',value:function onChangePhoneNumber(e){this.props.onChangePhoneNumber({areaCode:this.props.areaCode,phoneNumber:e.target&&e.target.value||e.phoneNumber});}},{key:'onChangeAreaCode',value:function onChangeAreaCode(e){this.props.onChangeAreaCode(e);this.props.onChangePhoneNumber({areaCode:e.value||e.areaCode,phoneNumber:this.props.phoneNumber});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.divContentClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SelectAreaCode__["a" /* SelectAreaCode */],{onChangeAreaCode:this.onChangeAreaCode,operatorKey:this.props.operatorKey,areaCode:this.props.areaCode,disabled:this.props.disabled,required:this.props.required}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'telefone',className:'col-8',label:'N\xFAmero de telefone',type:'text',mask:[/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/],value:this.props.phoneNumber,onChange:function onChange(e){return _this2.onChangePhoneNumber(e);},disabled:this.props.disabled,required:this.props.required}))));}}]);return PhoneNumber;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PhoneNumber.propTypes={divContentClassName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,operatorKey:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,onChangeAreaCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onChangePhoneNumber:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,areaCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,phoneNumber:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,required:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (PhoneNumber);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleRecharge__ = __webpack_require__(1526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScheduleRecharge__["a"]; });


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_recharge_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_recharge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_recharge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PeriodScheduleRecharge__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScheduleRecharge=function(_Component){_inherits(ScheduleRecharge,_Component);function ScheduleRecharge(props){_classCallCheck(this,ScheduleRecharge);var _this=_possibleConstructorReturn(this,(ScheduleRecharge.__proto__||Object.getPrototypeOf(ScheduleRecharge)).call(this,props));_this.onChangeScheduleOrder=_this.onChangeScheduleOrder.bind(_this);return _this;}_createClass(ScheduleRecharge,[{key:'onChangeScheduleOrder',value:function onChangeScheduleOrder(e){this.props.onChangeScheduleOrder(e);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 color-ui-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Checkbox"],{id:'agendar_recarga',label:'Agendar recarga para outro dia',className:'d-none d-md-flex col-md-12 color-ui-3',onChange:this.onChangeScheduleOrder,defaultChecked:this.props.scheduleOrder})))),this.props.scheduleOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PeriodScheduleRecharge__["a" /* default */],{onChangeInnitialDate:this.props.onChangeInnitialDate,innitialDate:this.props.innitialDate,onChangeEndDate:this.props.onChangeEndDate,endDate:this.props.endDate,maxQuantityMonths:this.props.maxQuantityMonths}):'');}}]);return ScheduleRecharge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ScheduleRecharge.propTypes={innitialDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.date,endDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.date,onChangeEndDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onChangeInnitialDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,maxQuantityMonths:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,onChangeScheduleOrder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,scheduleOrder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ScheduleRecharge);

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datepicker__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultTemplate__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datepicker_css__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_locale_pt__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
Object(__WEBPACK_IMPORTED_MODULE_1_react_datepicker__["registerLocale"])('pt',__WEBPACK_IMPORTED_MODULE_5_date_fns_locale_pt__["a" /* default */]);var DatePicker=function DatePicker(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-flex col-12 mt-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datepicker___default.a,Object.assign({},props,{locale:'pt',dateFormat:'dd/MM/yyyy',customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DefaultTemplate__["a" /* default */],{name:props.name,labelDescription:props.labelDescription,value:props.value}),showMonthDropdown:true})));};DatePicker.propTypes={name:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,labelDescription:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(0),__webpack_require__(1),__webpack_require__(85),__webpack_require__(1529),__webpack_require__(598),__webpack_require__(1530),__webpack_require__(611),__webpack_require__(612),__webpack_require__(308),__webpack_require__(613),__webpack_require__(309),__webpack_require__(615),__webpack_require__(1541),__webpack_require__(1542),__webpack_require__(1543),__webpack_require__(1544),__webpack_require__(1545),__webpack_require__(1546),__webpack_require__(1547),__webpack_require__(1548),__webpack_require__(1549),__webpack_require__(1550),__webpack_require__(1551),__webpack_require__(1552),__webpack_require__(1553),__webpack_require__(1554),__webpack_require__(1555),__webpack_require__(1556),__webpack_require__(1557),__webpack_require__(1558),__webpack_require__(616),__webpack_require__(1559),__webpack_require__(1560),__webpack_require__(1561),__webpack_require__(1562),__webpack_require__(1563),__webpack_require__(1564),__webpack_require__(1565),__webpack_require__(1566),__webpack_require__(310),__webpack_require__(617),__webpack_require__(1567),__webpack_require__(618),__webpack_require__(1568),__webpack_require__(1569),__webpack_require__(1570),__webpack_require__(1571),__webpack_require__(1572),__webpack_require__(1573),__webpack_require__(1574),__webpack_require__(1575),__webpack_require__(1576),__webpack_require__(1577),__webpack_require__(1578),__webpack_require__(1579),__webpack_require__(7),__webpack_require__(1580),__webpack_require__(1587),__webpack_require__(1588),__webpack_require__(1589)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper)}(this,function(e,t,r,n,a,o,s,p,i,c,d,l,u,h,f,m,y,w,v,D,g,k,C,_,b,S,M,O,P,E,N,Y,T,x,I,q,L,W,F,B,R,j,H,Q,A,V,K,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se){"use strict";function pe(e){return(pe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ie(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ce(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function de(e,t,r){return t&&ce(e.prototype,t),r&&ce(e,r),e}function le(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ue(){return(ue=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function he(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,n)}return r}function fe(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ye(e,t)}function me(e){return(me=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ye(e,t){return(ye=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function we(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ve(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?we(e):t}t=t&&t.hasOwnProperty("default")?t.default:t,r=r&&r.hasOwnProperty("default")?r.default:r,n=n&&n.hasOwnProperty("default")?n.default:n,a=a&&a.hasOwnProperty("default")?a.default:a,o=o&&o.hasOwnProperty("default")?o.default:o,s=s&&s.hasOwnProperty("default")?s.default:s,p=p&&p.hasOwnProperty("default")?p.default:p,i=i&&i.hasOwnProperty("default")?i.default:i,c=c&&c.hasOwnProperty("default")?c.default:c,d=d&&d.hasOwnProperty("default")?d.default:d,l=l&&l.hasOwnProperty("default")?l.default:l,u=u&&u.hasOwnProperty("default")?u.default:u,h=h&&h.hasOwnProperty("default")?h.default:h,f=f&&f.hasOwnProperty("default")?f.default:f,m=m&&m.hasOwnProperty("default")?m.default:m,y=y&&y.hasOwnProperty("default")?y.default:y,w=w&&w.hasOwnProperty("default")?w.default:w,v=v&&v.hasOwnProperty("default")?v.default:v,D=D&&D.hasOwnProperty("default")?D.default:D,g=g&&g.hasOwnProperty("default")?g.default:g,k=k&&k.hasOwnProperty("default")?k.default:k,C=C&&C.hasOwnProperty("default")?C.default:C,_=_&&_.hasOwnProperty("default")?_.default:_,b=b&&b.hasOwnProperty("default")?b.default:b,S=S&&S.hasOwnProperty("default")?S.default:S,M=M&&M.hasOwnProperty("default")?M.default:M,O=O&&O.hasOwnProperty("default")?O.default:O,P=P&&P.hasOwnProperty("default")?P.default:P,E=E&&E.hasOwnProperty("default")?E.default:E,N=N&&N.hasOwnProperty("default")?N.default:N,Y=Y&&Y.hasOwnProperty("default")?Y.default:Y,T=T&&T.hasOwnProperty("default")?T.default:T,x=x&&x.hasOwnProperty("default")?x.default:x,I=I&&I.hasOwnProperty("default")?I.default:I,q=q&&q.hasOwnProperty("default")?q.default:q,L=L&&L.hasOwnProperty("default")?L.default:L,W=W&&W.hasOwnProperty("default")?W.default:W,F=F&&F.hasOwnProperty("default")?F.default:F,B=B&&B.hasOwnProperty("default")?B.default:B,R=R&&R.hasOwnProperty("default")?R.default:R,j=j&&j.hasOwnProperty("default")?j.default:j,H=H&&H.hasOwnProperty("default")?H.default:H,Q=Q&&Q.hasOwnProperty("default")?Q.default:Q,A=A&&A.hasOwnProperty("default")?A.default:A,V=V&&V.hasOwnProperty("default")?V.default:V,K=K&&K.hasOwnProperty("default")?K.default:K,U=U&&U.hasOwnProperty("default")?U.default:U,$=$&&$.hasOwnProperty("default")?$.default:$,z=z&&z.hasOwnProperty("default")?z.default:z,G=G&&G.hasOwnProperty("default")?G.default:G,J=J&&J.hasOwnProperty("default")?J.default:J,X=X&&X.hasOwnProperty("default")?X.default:X,Z=Z&&Z.hasOwnProperty("default")?Z.default:Z,ee=ee&&ee.hasOwnProperty("default")?ee.default:ee,te=te&&te.hasOwnProperty("default")?te.default:te,re=re&&re.hasOwnProperty("default")?re.default:re,ne=ne&&ne.hasOwnProperty("default")?ne.default:ne,ae=ae&&ae.hasOwnProperty("default")?ae.default:ae,oe=oe&&oe.hasOwnProperty("default")?oe.default:oe;var De,ge=function(e,t){return e(t={exports:{}},t.exports),t.exports}(function(e,t){function r(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function n(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a={p:n,P:function(e,t){var a,o=e.match(/(P+)(p+)?/),s=o[1],p=o[2];if(!p)return r(e,t);switch(s){case"P":a=t.dateTime({width:"short"});break;case"PP":a=t.dateTime({width:"medium"});break;case"PPP":a=t.dateTime({width:"long"});break;case"PPPP":default:a=t.dateTime({width:"full"})}return a.replace("{{date}}",r(s,t)).replace("{{time}}",n(p,t))}};t.default=a,e.exports=t.default}),ke=(De=ge)&&De.__esModule&&Object.prototype.hasOwnProperty.call(De,"default")?De.default:De,Ce=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function _e(e){var t=e?"string"==typeof e||e instanceof String?ae(e):re(e):new Date;return Se(t)?t:null}function be(e,t,r,n){var a=null,o=We(r)||Le(),p=!0;return Array.isArray(t)?(t.forEach(function(t){var r=ne(e,t,new Date,{locale:o});n&&(p=Se(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),Se(r)&&p&&(a=r)}),a):(a=ne(e,t,new Date,{locale:o}),n?p=Se(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):Se(a)||(t=t.match(Ce).map(function(e){var t=e[0];if("p"===t||"P"===t){var r=ke[t];return o?r(e,o.formatLong):t}return e}).join(""),e.length>0&&(a=ne(e,t.slice(0,e.length),new Date)),Se(a)||(a=new Date(e))),Se(a)&&p?a:null)}function Se(e){return o(e)&&Z(e,new Date("1/1/1000"))}function Me(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=We(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&Le()&&We(Le())&&(n=We(Le())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Oe(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return N(E(P(e,void 0===s?0:s),o),n)}function Pe(e,t){var r=We(t||Le());return j(e,{locale:r})}function Ee(e){return H(e)}function Ne(e,t){return e&&t?J(e,t):!e&&!t}function Ye(e,t){return e&&t?G(e,t):!e&&!t}function Te(e,t){return e&&t?X(e,t):!e&&!t}function xe(e,t){return e&&t?z(e,t):!e&&!t}function Ie(e,t){return e&&t?$(e,t):!e&&!t}function qe(e,t,r){var n,a=R(t),o=V(r);try{n=te(e,{start:a,end:o})}catch(e){n=!1}return n}function Le(){return("undefined"!=typeof window?window:global).__localeId__}function We(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Fe(e,t){return Me(Y(_e(),e),"LLL",t)}function Be(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ae(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return xe(e,t)})||o&&!o.some(function(t){return xe(e,t)})||s&&!s(_e(e))||!1}function Re(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ae(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Ye(e,t)})||o&&!o.some(function(t){return Ye(e,t)})||s&&!s(_e(e))||!1}function je(e,t,r,n){var a=M(e),o=b(e),s=M(t),p=b(t),i=M(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function He(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ae(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Te(e,t)})||o&&!o.some(function(t){return Te(e,t)})||s&&!s(_e(e))||!1}function Qe(e,t,r,n){var a=M(e),o=S(e),s=M(t),p=S(t),i=M(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function Ae(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&L(e,r)<0||n&&L(e,n)>0}function Ve(e,t){for(var r=t.length,n=0;n<r;n++)if(k(t[n])===k(e)&&g(t[n])===g(e))return!0;return!1}function Ke(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=_e(),s=N(E(o,g(e)),k(e)),p=N(E(o,g(r)),k(r)),i=N(E(o,g(n)),k(n));try{a=!te(s,{start:p,end:i})}catch(e){a=!1}return a}function Ue(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=w(e,1);return r&&W(r,a)>0||n&&n.every(function(e){return W(e,a)>0})||!1}function $e(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=l(e,1);return r&&W(a,r)>0||n&&n.every(function(e){return W(a,e)>0})||!1}function ze(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter(function(e){return L(e,t)>=0});return I(n)}return r?I(r):t}function Ge(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter(function(e){return L(e,t)<=0});return q(n)}return r?q(r):t}function Je(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var p=Me(s,"MM.dd.yyyy"),i=r.get(p)||[];i.includes(t)||(i.push(t),r.set(p,i))}else if("object"===pe(s)){var c=Object.keys(s),d=c[0],l=s[c[0]];if("string"==typeof d&&l.constructor===Array)for(var u=0,h=l.length;u<h;u++){var f=Me(l[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(d)||(m.push(d),r.set(f,m))}}}return r}function Xe(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var d=p(i(e,k(a[c])),g(a[c])),l=p(e,(r+1)*n);Z(d,t)&&ee(d,l)&&s.push(a[c])}return s}function Ze(e){return e<10?"0".concat(e):"".concat(e)}function et(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,p=!0;r&&(p=M(r)<=s),n&&p&&(p=M(n)>=s),p&&a.push(s)}return a}var tt=oe(function(e){function r(e){var n;ie(this,r),le(we(n=ve(this,me(r).call(this,e))),"renderOptions",function(){var e=n.props.year,r=n.state.yearsList.map(function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,ref:r,onClick:n.onChange.bind(we(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)}),a=n.props.minDate?M(n.props.minDate):null,o=n.props.maxDate?M(n.props.maxDate):null;return o&&n.state.yearsList.find(function(e){return e===o})||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find(function(e){return e===a})||r.push(t.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r}),le(we(n),"onChange",function(e){n.props.onChange(e)}),le(we(n),"handleClickOutside",function(){n.props.onCancel()}),le(we(n),"shiftYears",function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})}),le(we(n),"incrementYears",function(){return n.shiftYears(1)}),le(we(n),"decrementYears",function(){return n.shiftYears(-1)});var a=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=a||(o?10:5);return n.state={yearsList:et(n.props.year,s,n.props.minDate,n.props.maxDate)},n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}()),rt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),le(we(n),"renderSelectOptions",function(){for(var e=n.props.minDate?M(n.props.minDate):1900,r=n.props.maxDate?M(n.props.maxDate):2100,a=[],o=e;o<=r;o++)a.push(t.createElement("option",{key:o,value:o},o));return a}),le(we(n),"onSelectChange",function(e){n.onChange(e.target.value)}),le(we(n),"renderSelectMode",function(){return t.createElement("select",{value:n.props.year,className:"react-datepicker__year-select",onChange:n.onSelectChange},n.renderSelectOptions())}),le(we(n),"renderReadView",function(e){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},n.props.year))}),le(we(n),"renderDropdown",function(){return t.createElement(tt,{key:"dropdown",ref:"options",year:n.props.year,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})}),le(we(n),"renderScrollMode",function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t}),le(we(n),"onChange",function(e){n.toggleDropdown(),e!==n.props.year&&n.props.onChange(e)}),le(we(n),"toggleDropdown",function(e){n.setState({dropdownVisible:!n.state.dropdownVisible},function(){n.props.adjustDateOnChange&&n.handleYearChange(n.props.date,e)})}),le(we(n),"handleYearChange",function(e,t){n.onSelect(e,t),n.setOpen()}),le(we(n),"onSelect",function(e,t){n.props.onSelect&&n.props.onSelect(e,t)}),le(we(n),"setOpen",function(){n.props.setOpen&&n.props.setOpen(!0)}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(),nt=oe(function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"renderOptions",function(){return n.props.monthNames.map(function(e,r){return t.createElement("div",{className:n.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:e,ref:e,onClick:n.onChange.bind(we(n),r)},n.props.month===r?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})}),le(we(n),"onChange",function(e){return n.props.onChange(e)}),le(we(n),"handleClickOutside",function(){return n.props.onCancel()}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}()),at=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),le(we(n),"renderSelectOptions",function(e){return e.map(function(e,r){return t.createElement("option",{key:r,value:r},e)})}),le(we(n),"renderSelectMode",function(e){return t.createElement("select",{value:n.props.month,className:"react-datepicker__month-select",onChange:function(e){return n.onChange(e.target.value)}},n.renderSelectOptions(e))}),le(we(n),"renderReadView",function(e,r){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:n.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[n.props.month]))}),le(we(n),"renderDropdown",function(e){return t.createElement(nt,{key:"dropdown",ref:"options",month:n.props.month,monthNames:e,onChange:n.onChange,onCancel:n.toggleDropdown})}),le(we(n),"renderScrollMode",function(e){var t=n.state.dropdownVisible,r=[n.renderReadView(!t,e)];return t&&r.unshift(n.renderDropdown(e)),r}),le(we(n),"onChange",function(e){n.toggleDropdown(),e!==n.props.month&&n.props.onChange(e)}),le(we(n),"toggleDropdown",function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Fe(e,r.props.locale)}:function(e){return t=e,n=r.props.locale,Me(Y(_e(),t),"LLLL",n);var t,n});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}();function ot(e,t){for(var r=[],n=Ee(e),a=Ee(t);!Z(n,a);)r.push(_e(n)),n=l(n,1);return r}var st=oe(function(e){function r(e){var n;return ie(this,r),le(we(n=ve(this,me(r).call(this,e))),"renderOptions",function(){return n.state.monthYearsList.map(function(e){var r=O(e),a=Ne(n.props.date,e)&&Ye(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,ref:r,onClick:n.onChange.bind(we(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Me(e,n.props.dateFormat))})}),le(we(n),"onChange",function(e){return n.props.onChange(e)}),le(we(n),"handleClickOutside",function(){n.props.onCancel()}),n.state={monthYearsList:ot(n.props.minDate,n.props.maxDate)},n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}()),pt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),le(we(n),"renderSelectOptions",function(){for(var e=Ee(n.props.minDate),r=Ee(n.props.maxDate),a=[];!Z(e,r);){var o=O(e);a.push(t.createElement("option",{key:o,value:o},Me(e,n.props.dateFormat,n.props.locale))),e=l(e,1)}return a}),le(we(n),"onSelectChange",function(e){n.onChange(e.target.value)}),le(we(n),"renderSelectMode",function(){return t.createElement("select",{value:O(Ee(n.props.date)),className:"react-datepicker__month-year-select",onChange:n.onSelectChange},n.renderSelectOptions())}),le(we(n),"renderReadView",function(e){var r=Me(n.props.date,n.props.dateFormat,n.props.locale);return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))}),le(we(n),"renderDropdown",function(){return t.createElement(st,{key:"dropdown",ref:"options",date:n.props.date,dateFormat:n.props.dateFormat,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})}),le(we(n),"renderScrollMode",function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t}),le(we(n),"onChange",function(e){n.toggleDropdown();var t=_e(parseInt(e));Ne(n.props.date,t)&&Ye(n.props.date,t)||n.props.onChange(t)}),le(we(n),"toggleDropdown",function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(),it=function(e){function r(){var e,t;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(t=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"handleClick",function(e){!t.isDisabled()&&t.props.onClick&&t.props.onClick(e)}),le(we(t),"handleMouseEnter",function(e){!t.isDisabled()&&t.props.onMouseEnter&&t.props.onMouseEnter(e)}),le(we(t),"isSameDay",function(e){return xe(t.props.day,e)}),le(we(t),"isKeyboardSelected",function(){return!t.props.disabledKeyboardNavigation&&!t.props.inline&&!t.isSameDay(t.props.selected)&&t.isSameDay(t.props.preSelection)}),le(we(t),"isDisabled",function(){return Be(t.props.day,t.props)}),le(we(t),"isExcluded",function(){return function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).excludeDates;return t&&t.some(function(t){return xe(e,t)})||!1}(t.props.day,t.props)}),le(we(t),"getHighLightedClass",function(e){var r=t.props,n=r.day,a=r.highlightDates;if(!a)return!1;var o=Me(n,"MM.dd.yyyy");return a.get(o)}),le(we(t),"isInRange",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&qe(r,n,a)}),le(we(t),"isInSelectingRange",function(){var e=t.props,r=e.day,n=e.selectsStart,a=e.selectsEnd,o=e.selectingDate,s=e.startDate,p=e.endDate;return!(!n&&!a||!o||t.isDisabled())&&(n&&p&&(ee(o,p)||Ie(o,p))?qe(r,o,p):!(!a||!s||!Z(o,s)&&!Ie(o,s))&&qe(r,s,o))}),le(we(t),"isSelectingRangeStart",function(){if(!t.isInSelectingRange())return!1;var e=t.props,r=e.day,n=e.selectingDate,a=e.startDate;return xe(r,e.selectsStart?n:a)}),le(we(t),"isSelectingRangeEnd",function(){if(!t.isInSelectingRange())return!1;var e=t.props,r=e.day,n=e.selectingDate,a=e.endDate;return xe(r,e.selectsEnd?n:a)}),le(we(t),"isRangeStart",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&xe(n,r)}),le(we(t),"isRangeEnd",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&xe(a,r)}),le(we(t),"isWeekend",function(){var e=C(t.props.day);return 0===e||6===e}),le(we(t),"isOutsideMonth",function(){return void 0!==t.props.month&&t.props.month!==b(t.props.day)}),le(we(t),"getClassNames",function(e){var r,a=t.props.dayClassName?t.props.dayClassName(e):void 0;return n("react-datepicker__day",a,"react-datepicker__day--"+Me(t.props.day,"ddd",r),{"react-datepicker__day--disabled":t.isDisabled(),"react-datepicker__day--excluded":t.isExcluded(),"react-datepicker__day--selected":t.isSameDay(t.props.selected),"react-datepicker__day--keyboard-selected":t.isKeyboardSelected(),"react-datepicker__day--range-start":t.isRangeStart(),"react-datepicker__day--range-end":t.isRangeEnd(),"react-datepicker__day--in-range":t.isInRange(),"react-datepicker__day--in-selecting-range":t.isInSelectingRange(),"react-datepicker__day--selecting-range-start":t.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":t.isSelectingRangeEnd(),"react-datepicker__day--today":t.isSameDay(_e()),"react-datepicker__day--weekend":t.isWeekend(),"react-datepicker__day--outside-month":t.isOutsideMonth()},t.getHighLightedClass("react-datepicker__day--highlighted"))}),t}return fe(r,t.Component),de(r,[{key:"render",value:function(){return t.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-".concat(_(this.props.day)),role:"option","aria-disabled":this.isDisabled()},this.props.renderDayContents?this.props.renderDayContents(_(this.props.day),this.props.day):_(this.props.day))}}]),r}(),ct=function(e){function r(){var e,t;ie(this,r);for(var n=arguments.length,a=new Array(n),o=0;o<n;o++)a[o]=arguments[o];return le(we(t=ve(this,(e=me(r)).call.apply(e,[this].concat(a)))),"handleClick",function(e){t.props.onClick&&t.props.onClick(e)}),t}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return t.createElement("div",{className:n(e),"aria-label":"week-".concat(this.props.weekNumber),onClick:this.handleClick},this.props.weekNumber)}}]),r}(),dt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"handleDayClick",function(e,t){n.props.onDayClick&&n.props.onDayClick(e,t)}),le(we(n),"handleDayMouseEnter",function(e){n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)}),le(we(n),"handleWeekClick",function(e,t,r){"function"==typeof n.props.onWeekSelect&&n.props.onWeekSelect(e,t,r),n.props.shouldCloseOnSelect&&n.props.setOpen(!1)}),le(we(n),"formatWeekNumber",function(e){return n.props.formatWeekNumber?n.props.formatWeekNumber(e):function(e){return Ne(K(e),e)?F(e,A(e))+1:1}(e)}),le(we(n),"renderDays",function(){var e=Pe(n.props.day,n.props.locale),r=[],a=n.formatWeekNumber(e);if(n.props.showWeekNumber){var o=n.props.onWeekSelect?n.handleWeekClick.bind(we(n),e,a):void 0;r.push(t.createElement(ct,{key:"W",weekNumber:a,onClick:o}))}return r.concat([0,1,2,3,4,5,6].map(function(r){var a=c(e,r);return t.createElement(it,{key:r,day:a,month:n.props.month,onClick:n.handleDayClick.bind(we(n),a),onMouseEnter:n.handleDayMouseEnter.bind(we(n),a),minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,includeDates:n.props.includeDates,inline:n.props.inline,highlightDates:n.props.highlightDates,selectingDate:n.props.selectingDate,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,dayClassName:n.props.dayClassName,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation})}))}),n}return fe(r,t.Component),de(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(),lt=6,ut=function(e){function r(){var e,a;ie(this,r);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return le(we(a=ve(this,(e=me(r)).call.apply(e,[this].concat(s)))),"handleDayClick",function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t,a.props.orderInDisplay)}),le(we(a),"handleDayMouseEnter",function(e){a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)}),le(we(a),"handleMouseLeave",function(){a.props.onMouseLeave&&a.props.onMouseLeave()}),le(we(a),"isRangeStartMonth",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ye(Y(r,e),n)}),le(we(a),"isRangeStartQuarter",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Te(T(r,e),n)}),le(we(a),"isRangeEndMonth",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ye(Y(r,e),o)}),le(we(a),"isRangeEndQuarter",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Te(T(r,e),o)}),le(we(a),"isWeekInMonth",function(e){var t=a.props.day,r=c(e,6);return Ye(e,t)||Ye(r,t)}),le(we(a),"renderWeeks",function(){for(var e=[],r=a.props.fixedHeight,n=Pe(Ee(a.props.day),a.props.locale),o=0,s=!1;e.push(t.createElement(dt,{key:o,day:n,month:b(a.props.day),onDayClick:a.handleDayClick,onDayMouseEnter:a.handleDayMouseEnter,onWeekSelect:a.props.onWeekSelect,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,includeDates:a.props.includeDates,inline:a.props.inline,highlightDates:a.props.highlightDates,selectingDate:a.props.selectingDate,filterDate:a.props.filterDate,preSelection:a.props.preSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,showWeekNumber:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,dayClassName:a.props.dayClassName,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderDayContents:a.props.renderDayContents})),!s;){o++,n=d(n,1);var p=r&&o>=lt,i=!r&&!a.isWeekInMonth(n);if(p||i){if(!a.props.peekNextMonth)break;s=!0}}return e}),le(we(a),"onMonthClick",function(e,t){a.handleDayClick(Ee(Y(a.props.day,t)),e)}),le(we(a),"onQuarterClick",function(e,t){var r;a.handleDayClick((r=T(a.props.day,t),Q(r)),e)}),le(we(a),"getMonthClassNames",function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,p=t.selected,i=t.minDate,c=t.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(e),{"react-datepicker__month--disabled":(i||c)&&Re(Y(r,e),a.props),"react-datepicker__month--selected":b(r)===e&&M(r)===M(p),"react-datepicker__month--in-range":je(o,s,e,r),"react-datepicker__month--range-start":a.isRangeStartMonth(e),"react-datepicker__month--range-end":a.isRangeEndMonth(e)})}),le(we(a),"getQuarterClassNames",function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,p=t.selected,i=t.minDate,c=t.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter--disabled":(i||c)&&He(T(r,e),a.props),"react-datepicker__quarter--selected":S(r)===e&&M(r)===M(p),"react-datepicker__quarter--in-range":Qe(o,s,e,r),"react-datepicker__quarter--range-start":a.isRangeStartQuarter(e),"react-datepicker__quarter--range-end":a.isRangeEndQuarter(e)})}),le(we(a),"renderMonths",function(){return[[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map(function(e,r){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:r},e.map(function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onMonthClick(t,e)},className:a.getMonthClassNames(e)},Fe(e,a.props.locale))}))})}),le(we(a),"renderQuarters",function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map(function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onQuarterClick(t,e)},className:a.getQuarterClassNames(e)},(n=e,o=a.props.locale,Me(T(_e(),n),"QQQ",o)));var n,o}))}),le(we(a),"getClassNames",function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,o=e.selectsEnd,s=e.showMonthYearPicker,p=e.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(r||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":p})}),a}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox","aria-label":"month-"+Me(this.props.day,"yyyy-MM")},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),r}(),ht=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return le(we(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{height:null}),le(we(n),"handleClick",function(e){(n.props.minTime||n.props.maxTime)&&Ke(e,n.props)||n.props.excludeTimes&&Ve(e,n.props.excludeTimes)||n.props.includeTimes&&!Ve(e,n.props.includeTimes)||n.props.onChange(e)}),le(we(n),"liClasses",function(e,t,r){var a=["react-datepicker__time-list-item"];return n.props.selected&&t===k(e)&&r===g(e)&&a.push("react-datepicker__time-list-item--selected"),((n.props.minTime||n.props.maxTime)&&Ke(e,n.props)||n.props.excludeTimes&&Ve(e,n.props.excludeTimes)||n.props.includeTimes&&!Ve(e,n.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),n.props.injectTimes&&(60*k(e)+g(e))%n.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")}),le(we(n),"renderTimes",function(){for(var e,r=[],a=n.props.format?n.props.format:"p",o=n.props.intervals,s=n.props.selected||n.props.openToDate||_e(),i=k(s),c=g(s),d=(e=_e(),R(e)),l=1440/o,u=n.props.injectTimes&&n.props.injectTimes.sort(function(e,t){return e-t}),h=0;h<l;h++){var f=p(d,h*o);if(r.push(f),u){var m=Xe(d,f,h,o,u);r=r.concat(m)}}return r.map(function(e,r){return t.createElement("li",{key:r,onClick:n.handleClick.bind(we(n),e),className:n.liClasses(e,i,c),ref:function(t){i===k(e)&&c>=g(e)&&(n.centerLi=t)}},Me(e,a,n.props.locale))})}),n}return fe(r,t.Component),de(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}();le(ht,"calcCenterPosition",function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)});var ft=function(e){function r(e){var t;return ie(this,r),le(we(t=ve(this,me(r).call(this,e))),"onTimeChange",function(e){t.setState({time:e});var r=new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),t.props.onChange(r)}),t.state={time:t.props.timeString},t}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e=this,r=this.state.time,n=this.props.timeString;return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:r,onChange:function(t){e.onTimeChange(t.target.value||n)}}))))}}]),r}();function mt(e){var r=e.className,n=e.children,a=e.showPopperArrow,o=e.arrowProps,s=void 0===o?{}:o;return t.createElement("div",{className:r},a&&t.createElement("div",ue({className:"react-datepicker__triangle"},s)),n)}var yt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],wt=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return yt.some(function(e){return t.indexOf(e)>=0})},vt=function(e){function r(e){var n;return ie(this,r),le(we(n=ve(this,me(r).call(this,e))),"handleClickOutside",function(e){n.props.onClickOutside(e)}),le(we(n),"setClickOutsideRef",function(){return n.containerRef.current}),le(we(n),"handleDropdownFocus",function(e){wt(e.target)&&n.props.onDropdownFocus()}),le(we(n),"getDateInView",function(){var e=n.props,t=e.preSelection,r=e.selected,a=e.openToDate,o=ze(n.props),s=Ge(n.props),p=_e(),i=a||r||t;return i||(o&&ee(p,o)?o:s&&Z(p,s)?s:p)}),le(we(n),"increaseMonth",function(){n.setState(function(e){var t=e.date;return{date:l(t,1)}},function(){return n.handleMonthChange(n.state.date)})}),le(we(n),"decreaseMonth",function(){n.setState(function(e){var t=e.date;return{date:w(t,1)}},function(){return n.handleMonthChange(n.state.date)})}),le(we(n),"handleDayClick",function(e,t,r){return n.props.onSelect(e,t,r)}),le(we(n),"handleDayMouseEnter",function(e){n.setState({selectingDate:e}),n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)}),le(we(n),"handleMonthMouseLeave",function(){n.setState({selectingDate:null}),n.props.onMonthMouseLeave&&n.props.onMonthMouseLeave()}),le(we(n),"handleYearChange",function(e){n.props.onYearChange&&n.props.onYearChange(e)}),le(we(n),"handleMonthChange",function(e){n.props.onMonthChange&&n.props.onMonthChange(e),n.props.adjustDateOnChange&&(n.props.onSelect&&n.props.onSelect(e),n.props.setOpen&&n.props.setOpen(!0))}),le(we(n),"handleMonthYearChange",function(e){n.handleYearChange(e),n.handleMonthChange(e)}),le(we(n),"changeYear",function(e){n.setState(function(t){var r=t.date;return{date:x(r,e)}},function(){return n.handleYearChange(n.state.date)})}),le(we(n),"changeMonth",function(e){n.setState(function(t){var r=t.date;return{date:Y(r,e)}},function(){return n.handleMonthChange(n.state.date)})}),le(we(n),"changeMonthYear",function(e){n.setState(function(t){var r=t.date;return{date:x(Y(r,b(e)),M(e))}},function(){return n.handleMonthYearChange(n.state.date)})}),le(we(n),"header",function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=Pe(e,n.props.locale),a=[];return n.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map(function(e){var a=c(r,e),o=n.formatWeekday(a,n.props.locale);return t.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))}),le(we(n),"formatWeekday",function(e,t){return n.props.formatWeekDay?function(e,t,r){return t(Me(e,"EEEE",r))}(e,n.props.formatWeekDay,t):n.props.useWeekdaysShort?function(e,t){return Me(e,"EEE",t)}(e,t):function(e,t){return Me(e,"EEEEEE",t)}(e,t)}),le(we(n),"decreaseYear",function(){n.setState(function(e){var t=e.date;return{date:v(t,1)}},function(){return n.handleYearChange(n.state.date)})}),le(we(n),"renderPreviousButton",function(){if(!n.props.renderCustomHeader){var e=n.props.showMonthYearPicker?function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&B(r,a)>0||n&&n.every(function(e){return B(e,a)>0})||!1}(n.state.date,n.props):Ue(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],a=n.decreaseMonth;return(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.decreaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),a=null),t.createElement("button",{type:"button",className:r.join(" "),onClick:a},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.props.previousYearButtonLabel:n.props.previousMonthButtonLabel)}}}),le(we(n),"increaseYear",function(){n.setState(function(e){var t=e.date;return{date:u(t,1)}},function(){return n.handleYearChange(n.state.date)})}),le(we(n),"renderNextButton",function(){if(!n.props.renderCustomHeader){var e=n.props.showMonthYearPicker?function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=u(e,1);return r&&B(a,r)>0||n&&n.every(function(e){return B(a,e)>0})||!1}(n.state.date,n.props):$e(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];n.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var a=n.increaseMonth;return(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.increaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),a=null),t.createElement("button",{type:"button",className:r.join(" "),onClick:a},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.props.nextYearButtonLabel:n.props.nextMonthButtonLabel)}}}),le(we(n),"renderCurrentMonth",function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=["react-datepicker__current-month"];return n.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),n.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Me(e,n.props.dateFormat,n.props.locale))}),le(we(n),"renderYearDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return t.createElement(rt,{adjustDateOnChange:n.props.adjustDateOnChange,date:n.state.date,onSelect:n.props.onSelect,setOpen:n.props.setOpen,dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:M(n.state.date),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})}),le(we(n),"renderMonthDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown&&!e)return t.createElement(at,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,onChange:n.changeMonth,month:b(n.state.date),useShortMonthInDropdown:n.props.useShortMonthInDropdown})}),le(we(n),"renderMonthYearDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthYearDropdown&&!e)return t.createElement(pt,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonthYear,minDate:n.props.minDate,maxDate:n.props.maxDate,date:n.state.date,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})}),le(we(n),"renderTodayButton",function(){if(n.props.todayButton&&!n.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(R(_e()),e)}},n.props.todayButton)}),le(we(n),"renderDefaultHeader",function(e){var r=e.monthDate,a=e.i;return t.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode),onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==a),n.renderMonthYearDropdown(0!==a),n.renderYearDropdown(0!==a)),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))}),le(we(n),"renderCustomHeader",function(e){var r=e.monthDate;if(0!==e.i)return null;var a=Ue(n.state.date,n.props),o=$e(n.state.date,n.props);return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:n.props.onDropdownFocus},n.props.renderCustomHeader(function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?he(r,!0).forEach(function(t){le(e,t,r[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):he(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))})}return e}({},n.state,{changeMonth:n.changeMonth,changeYear:n.changeYear,decreaseMonth:n.decreaseMonth,increaseMonth:n.increaseMonth,prevMonthButtonDisabled:a,nextMonthButtonDisabled:o})),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))}),le(we(n),"renderYearHeader",function(){return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},M(n.state.date))}),le(we(n),"renderMonths",function(){if(!n.props.showTimeSelectOnly){for(var e=[],r=n.props.showPreviousMonths?n.props.monthsShown-1:0,a=w(n.state.date,r),o=0;o<n.props.monthsShown;++o){var s=o-n.props.monthSelectedIn,p=l(a,s),i="month-".concat(o);e.push(t.createElement("div",{key:i,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.renderYearHeader({monthDate:p,i:o}):n.props.renderCustomHeader?n.renderCustomHeader({monthDate:p,i:o}):n.renderDefaultHeader({monthDate:p,i:o}),t.createElement(ut,{onChange:n.changeMonthYear,day:p,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,orderInDisplay:o,formatWeekNumber:n.props.formatWeekNumber,locale:n.props.locale,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,setOpen:n.props.setOpen,shouldCloseOnSelect:n.props.shouldCloseOnSelect,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,showMonthYearPicker:n.props.showMonthYearPicker,showQuarterYearPicker:n.props.showQuarterYearPicker})))}return e}}),le(we(n),"renderTimeSection",function(){if(n.props.showTimeSelect&&(n.state.monthContainer||n.props.showTimeSelectOnly))return t.createElement(ht,{selected:n.props.selected,openToDate:n.props.openToDate,onChange:n.props.onTimeChange,format:n.props.timeFormat,includeTimes:n.props.includeTimes,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,timeCaption:n.props.timeCaption,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showMonthYearDropdown:n.props.showMonthYearDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer,injectTimes:n.props.injectTimes,locale:n.props.locale})}),le(we(n),"renderInputTimeSection",function(){var e=new Date(n.props.selected),r="".concat(Ze(e.getHours()),":").concat(Ze(e.getMinutes()));if(n.props.showTimeInput)return t.createElement(ft,{timeString:r,timeInputLabel:n.props.timeInputLabel,onChange:n.props.onTimeChange})}),n.containerRef=t.createRef(),n.state={date:n.getDateInView(),selectingDate:null,monthContainer:null},n}return fe(r,t.Component),de(r,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month"}}}]),de(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!xe(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!xe(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||mt;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),r}(),Dt=function(e){function r(){return ie(this,r),ve(this,me(r).apply(this,arguments))}return fe(r,t.Component),de(r,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,p=r.popperComponent,i=r.popperModifiers,c=r.popperPlacement,d=r.popperProps,l=r.targetComponent;if(!s){var u=n("react-datepicker-popper",a);e=t.createElement(se.Popper,ue({modifiers:i,placement:c},d),function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement("div",ue({ref:r,style:n},{className:u,"data-placement":a}),t.cloneElement(p,{arrowProps:o}))})}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e));var h=n("react-datepicker-wrapper",o);return t.createElement(se.Manager,{className:"react-datepicker-manager"},t.createElement(se.Reference,null,function(e){var r=e.ref;return t.createElement("div",{ref:r,className:h},l)}),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(),gt="react-datepicker-ignore-onclickoutside",kt=oe(vt);var Ct="Date input not valid.",_t=function(e){function r(e){var o;return ie(this,r),le(we(o=ve(this,me(r).call(this,e))),"getPreSelection",function(){return o.props.openToDate?o.props.openToDate:o.props.selectsEnd&&o.props.startDate?o.props.startDate:o.props.selectsStart&&o.props.endDate?o.props.endDate:_e()}),le(we(o),"calcInitialState",function(){var e=o.getPreSelection(),t=ze(o.props),r=Ge(o.props),n=t&&ee(e,t)?t:r&&Z(e,r)?r:e;return{open:o.props.startOpen||!1,preventFocus:!1,preSelection:o.props.selected?o.props.selected:n,highlightDates:Je(o.props.highlightDates),focused:!1}}),le(we(o),"clearPreventFocusTimeout",function(){o.preventFocusTimeout&&clearTimeout(o.preventFocusTimeout)}),le(we(o),"setFocus",function(){o.input&&o.input.focus&&o.input.focus()}),le(we(o),"setBlur",function(){o.input&&o.input.blur&&o.input.blur(),o.cancelFocusInput()}),le(we(o),"setOpen",function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];o.setState({open:e,preSelection:e&&o.state.open?o.state.preSelection:o.calcInitialState().preSelection,lastPreSelectChange:St},function(){e||o.setState(function(e){return{focused:!!t&&e.focused}},function(){!t&&o.setBlur(),o.setState({inputValue:null})})})}),le(we(o),"inputOk",function(){return a(o.state.preSelection)}),le(we(o),"isCalendarOpen",function(){return void 0===o.props.open?o.state.open&&!o.props.disabled&&!o.props.readOnly:o.props.open}),le(we(o),"handleFocus",function(e){o.state.preventFocus||(o.props.onFocus(e),o.props.preventOpenOnFocus||o.props.readOnly||o.setOpen(!0)),o.setState({focused:!0})}),le(we(o),"cancelFocusInput",function(){clearTimeout(o.inputFocusTimeout),o.inputFocusTimeout=null}),le(we(o),"deferFocusInput",function(){o.cancelFocusInput(),o.inputFocusTimeout=setTimeout(function(){return o.setFocus()},1)}),le(we(o),"handleDropdownFocus",function(){o.cancelFocusInput()}),le(we(o),"handleBlur",function(e){!o.state.open||o.props.withPortal||o.props.showTimeInput?o.props.onBlur(e):o.deferFocusInput(),o.setState({focused:!1})}),le(we(o),"handleCalendarClickOutside",function(e){o.props.inline||o.setOpen(!1),o.props.onClickOutside(e),o.props.withPortal&&e.preventDefault()}),le(we(o),"handleChange",function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!o.props.onChangeRaw||(o.props.onChangeRaw.apply(we(o),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){o.setState({inputValue:n.target.value,lastPreSelectChange:bt});var a=be(n.target.value,o.props.dateFormat,o.props.locale,o.props.strictParsing);!a&&n.target.value||o.setSelected(a,n,!0)}}),le(we(o),"handleSelect",function(e,t,r){o.setState({preventFocus:!0},function(){return o.preventFocusTimeout=setTimeout(function(){return o.setState({preventFocus:!1})},50),o.preventFocusTimeout}),o.setSelected(e,t,void 0,r),!o.props.shouldCloseOnSelect||o.props.showTimeSelect?o.setPreSelection(e):o.props.inline||o.setOpen(!1)}),le(we(o),"setSelected",function(e,t,r,n){var a=e;if(null===a||!Be(a,o.props)){if(!Ie(o.props.selected,a)||o.props.allowSameDay){if(null!==a){if(o.props.selected){var s=o.props.selected;r&&(s=_e(a)),a=Oe(a,{hour:k(s),minute:g(s),second:D(s)})}o.props.inline||o.setState({preSelection:a}),o.props.inline&&o.props.monthsShown>1&&!o.props.inlineFocusSelectedMonth&&o.setState({monthSelectedIn:n})}o.props.onChange(a,t)}o.props.onSelect(a,t),r||o.setState({inputValue:null})}}),le(we(o),"setPreSelection",function(e){var t=void 0!==o.props.minDate,r=void 0!==o.props.maxDate,n=!0;e&&(t&&r?n=qe(e,o.props.minDate,o.props.maxDate):t?n=Z(e,o.props.minDate):r&&(n=ee(e,o.props.maxDate))),n&&o.setState({preSelection:e})}),le(we(o),"handleTimeChange",function(e){var t=Oe(o.props.selected?o.props.selected:o.getPreSelection(),{hour:k(e),minute:g(e)});o.setState({preSelection:t}),o.props.onChange(t),o.props.shouldCloseOnSelect&&o.setOpen(!1),o.props.showTimeInput&&o.setOpen(!0),o.setState({inputValue:null})}),le(we(o),"onInputClick",function(){o.props.disabled||o.props.readOnly||o.setOpen(!0),o.props.onInputClick()}),le(we(o),"onInputKeyDown",function(e){o.props.onKeyDown(e);var t=e.key;if(o.state.open||o.props.inline||o.props.preventOpenOnFocus){var r=_e(o.state.preSelection);if("Enter"===t)e.preventDefault(),o.inputOk()&&o.state.lastPreSelectChange===St?(o.handleSelect(r,e),!o.props.shouldCloseOnSelect&&o.setPreSelection(r)):o.setOpen(!1);else if("Escape"===t)e.preventDefault(),o.setOpen(!1),o.inputOk()||o.props.onInputError({code:1,msg:Ct});else if("Tab"===t)o.setOpen(!1,!0);else if(!o.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=d(r,1);break;case"PageUp":n=w(r,1);break;case"PageDown":n=l(r,1);break;case"Home":n=v(r,1);break;case"End":n=u(r,1)}if(!n)return void(o.props.onInputError&&o.props.onInputError({code:1,msg:Ct}));e.preventDefault(),o.setState({lastPreSelectChange:St}),o.props.adjustDateOnChange&&o.setSelected(n),o.setPreSelection(n)}}else"ArrowDown"!==t&&"ArrowUp"!==t||o.onInputClick()}),le(we(o),"onClearClick",function(e){e&&e.preventDefault&&e.preventDefault(),o.props.onChange(null,e),o.setState({inputValue:null})}),le(we(o),"clear",function(){o.onClearClick()}),le(we(o),"renderCalendar",function(){return o.props.inline||o.isCalendarOpen()?t.createElement(kt,{ref:function(e){o.calendar=e},locale:o.props.locale,adjustDateOnChange:o.props.adjustDateOnChange,setOpen:o.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,dateFormat:o.props.dateFormatCalendar,useWeekdaysShort:o.props.useWeekdaysShort,formatWeekDay:o.props.formatWeekDay,dropdownMode:o.props.dropdownMode,selected:o.props.selected,preSelection:o.state.preSelection,onSelect:o.handleSelect,onWeekSelect:o.props.onWeekSelect,openToDate:o.props.openToDate,minDate:o.props.minDate,maxDate:o.props.maxDate,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,startDate:o.props.startDate,endDate:o.props.endDate,excludeDates:o.props.excludeDates,filterDate:o.props.filterDate,onClickOutside:o.handleCalendarClickOutside,formatWeekNumber:o.props.formatWeekNumber,highlightDates:o.state.highlightDates,includeDates:o.props.includeDates,includeTimes:o.props.includeTimes,injectTimes:o.props.injectTimes,inline:o.props.inline,peekNextMonth:o.props.peekNextMonth,showMonthDropdown:o.props.showMonthDropdown,showPreviousMonths:o.props.showPreviousMonths,useShortMonthInDropdown:o.props.useShortMonthInDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showWeekNumbers:o.props.showWeekNumbers,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,forceShowMonthNavigation:o.props.forceShowMonthNavigation,showDisabledMonthNavigation:o.props.showDisabledMonthNavigation,scrollableYearDropdown:o.props.scrollableYearDropdown,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown,todayButton:o.props.todayButton,weekLabel:o.props.weekLabel,outsideClickIgnoreClass:gt,fixedHeight:o.props.fixedHeight,monthsShown:o.props.monthsShown,monthSelectedIn:o.state.monthSelectedIn,onDropdownFocus:o.handleDropdownFocus,onMonthChange:o.props.onMonthChange,onYearChange:o.props.onYearChange,dayClassName:o.props.dayClassName,showTimeSelect:o.props.showTimeSelect,showTimeSelectOnly:o.props.showTimeSelectOnly,onTimeChange:o.handleTimeChange,timeFormat:o.props.timeFormat,timeIntervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,className:o.props.calendarClassName,container:o.props.calendarContainer,yearDropdownItemNumber:o.props.yearDropdownItemNumber,previousMonthButtonLabel:o.props.previousMonthButtonLabel,nextMonthButtonLabel:o.props.nextMonthButtonLabel,previousYearButtonLabel:o.props.previousYearButtonLabel,nextYearButtonLabel:o.props.nextYearButtonLabel,timeInputLabel:o.props.timeInputLabel,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,renderCustomHeader:o.props.renderCustomHeader,popperProps:o.props.popperProps,renderDayContents:o.props.renderDayContents,onDayMouseEnter:o.props.onDayMouseEnter,onMonthMouseLeave:o.props.onMonthMouseLeave,showTimeInput:o.props.showTimeInput,showMonthYearPicker:o.props.showMonthYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker,showPopperArrow:o.props.showPopperArrow},o.props.children):null}),le(we(o),"renderDateInput",function(){var e,r,a,s,p,i=n(o.props.className,le({},gt,o.state.open)),c=o.props.customInput||t.createElement("input",{type:"text"}),d=o.props.customInputRef||"ref",l="string"==typeof o.props.value?o.props.value:"string"==typeof o.state.inputValue?o.state.inputValue:(r=o.props.selected,a=o.props,s=a.dateFormat,p=a.locale,r&&Me(r,Array.isArray(s)?s[0]:s,p)||"");return t.cloneElement(c,(le(e={},d,function(e){o.input=e}),le(e,"value",l),le(e,"onBlur",o.handleBlur),le(e,"onChange",o.handleChange),le(e,"onClick",o.onInputClick),le(e,"onFocus",o.handleFocus),le(e,"onKeyDown",o.onInputKeyDown),le(e,"id",o.props.id),le(e,"name",o.props.name),le(e,"autoFocus",o.props.autoFocus),le(e,"placeholder",o.props.placeholderText),le(e,"disabled",o.props.disabled),le(e,"autoComplete",o.props.autoComplete),le(e,"className",n(c.props.className,i)),le(e,"title",o.props.title),le(e,"readOnly",o.props.readOnly),le(e,"required",o.props.required),le(e,"tabIndex",o.props.tabIndex),le(e,"aria-labelledby",o.props.ariaLabelledBy),e))}),le(we(o),"renderClearButton",function(){return o.props.isClearable&&null!=o.props.selected?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":"Close",onClick:o.onClearClick,title:o.props.clearButtonTitle,tabIndex:-1}):null}),o.state=o.calcInitialState(),o}return fe(r,t.Component),de(r,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1,showPopperArrow:!0}}}]),de(r,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?b(r)!==b(n)||M(r)!==M(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Je(this.props.highlightDates)}),t.focused||Ie(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(Dt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps})}}]),r}(),bt="input",St="navigate";e.CalendarContainer=mt,e.default=_t,e.getDefaultLocale=Le,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isDate;
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * var result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * var result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * var result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * var result = isDate({})
 * //=> false
 */
function isDate(value) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__ = __webpack_require__(18);








 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__["a" /* default */];
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["default"])(dirtyDate);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(originalDate);
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__["a" /* default */])(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__["a" /* default */][firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring);
      }

      if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(600);

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (formatLong);

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelative;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(601);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (localize);

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(603);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a" /* default */])({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__ = __webpack_require__(605);







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = Object(__WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date); // Padding

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = Object(__WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__["a" /* default */])(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__["a" /* default */])(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__["a" /* default */])(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(Math.floor(absOffset / 60), 2);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(605);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, token.length);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(210);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(211);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeek, dirtyOptions);
  return date;
}

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__ = __webpack_require__(611);


/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__ = __webpack_require__(612);


/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addHours_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(308);


/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(613);


/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(309);


/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__ = __webpack_require__(615);


/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addYears_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getFullYear();
  return year;
}

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var seconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(616);



/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var quarter = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return Object(__WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date)) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name min
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `min` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var minDate = min(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var minDate = min(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `max` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var maxDate = max(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var maxDate = max(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__(310);


var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var startOfDayLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["default"])(dirtyDateLeft);
  var startOfDayRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(163);


var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var startOfWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var cleanDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(18);


/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyLeftDate);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(310);

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeftStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(618);

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeftStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isAfter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isWithinInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 */

function isWithinInterval(dirtyDate, dirtyInterval) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var interval = dirtyInterval || {};
  var time = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate).getTime();
  var startTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(interval.start).getTime();
  var endTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__ = __webpack_require__(1582);









var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `backupDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `backupDate` which works as a context of parsing.
 *
 * `backupDate` must be passed for correct work of the function.
 * If you're not sure which `backupDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `backupDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `backupDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   toDate('2016-01-01')
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} backupDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyBackupDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a" /* default */];

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["default"])(dirtyBackupDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(token)) {
      Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token);
    }

    if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(token)) {
      Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token);
    }

    var firstCharacter = token[0];
    var parser = __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__["a" /* default */][firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).reverse();
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["default"])(dirtyBackupDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__["a" /* default */])(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__ = __webpack_require__(211);







var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a" /* default */])(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__["a" /* default */])(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__["a" /* default */])(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (parsers);

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var day = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var day = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__ = __webpack_require__(606);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyISOWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__["a" /* default */])(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__ = __webpack_require__(608);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var week = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__["a" /* default */])(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parseISO;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(163);


var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var fullTime = timestamp + time;
    var fullTimeDate = new Date(fullTime);
    offset = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(fullTimeDate); // Adjust time when it's coming from DST

    var fullTimeDateDiffDay = new Date(fullTime);

    if (offset > 0) {
      fullTimeDateDiffDay.setDate(fullTimeDate.getDate() + 1);
    } else {
      fullTimeDateDiffDay.setDate(fullTimeDate.getDate() - 1);
    }

    var offsetDiff = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(fullTimeDateDiffDay) - offset;

    if (offsetDiff > 0) {
      offset += offsetDiff;
    }
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_popper_js__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Manager__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(620);









var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* setRef */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_6_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || this.props.modifiers !== prevProps.modifiers) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* setRef */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_6_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Manager__["a" /* ManagerReferenceNodeContext */].Consumer, null, function (referenceNode) {
    return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1594);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1595);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(68);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(620);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* setRef */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["b" /* ManagerReferenceNodeSetterContext */].Consumer, null, function (setReferenceNode) {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var DefaultTemplate=function DefaultTemplate(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:props.name,name:props.name,label:props.labelDescription,className:'col-12',iconName:'icon_calendar cursor',iconOnClick:function iconOnClick(){return props.onClick;},value:props.value}));};DefaultTemplate.propTypes={name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,labelDescription:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (DefaultTemplate);

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(1605);





/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */

var locale = {
  code: 'pt',
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'aproximadamente 1 hora',
    other: 'aproximadamente {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXMonths: {
    one: 'aproximadamente 1 mês',
    other: 'aproximadamente {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'aproximadamente 1 ano',
    other: 'aproximadamente {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'daqui a ' + result;
    } else {
      return 'há ' + result;
    }
  }

  return result;
}

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(600);

var dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: 'dd/MM/y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (formatLong);

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelative;
var formatRelativeLocale = {
  lastWeek: "'na última' eeee 'às' p",
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(601);


function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'º';
}

var eraValues = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a.C.', 'd.C.'],
  wide: ['antes de Cristo', 'depois de Cristo']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var dayValues = {
  narrow: ['d', 's', 't', 'q', 'q', 's', 's'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  }
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (localize);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(603);


var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^may/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var match = {
  ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a" /* default */])({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AlertErrorMessage=function(_Component){_inherits(AlertErrorMessage,_Component);function AlertErrorMessage(props){_classCallCheck(this,AlertErrorMessage);var _this=_possibleConstructorReturn(this,(AlertErrorMessage.__proto__||Object.getPrototypeOf(AlertErrorMessage)).call(this,props));_this.state={errorMessage:null};_this.close=_this.close.bind(_this);return _this;}_createClass(AlertErrorMessage,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.errorMessage&&this.props.errorMessage!==''||this.props.title&&this.props.title!==''){this.state.errorMessage=this.props.errorMessage;this.state.title=this.props.title;this.props.filledState();}}},{key:'close',value:function close(){this.setState({errorMessage:null});if(this.props.onClose)this.props.onClose();}},{key:'render',value:function render(){return this.state.errorMessage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row mb-4'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Alert"],{isError:true,title:this.state.title?this.state.title:'Erro',description:this.state.errorMessage,onClose:this.close})):'';}}]);return AlertErrorMessage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AlertErrorMessage.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,errorMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,filledState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (AlertErrorMessage);

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalConfirmRecharge__ = __webpack_require__(1608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalConfirmRecharge__["a"]; });


/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
var ModalConfirmRecharge=function ModalConfirmRecharge(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'600',height:'90%',effect:'fadeInUp',visible:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-wrapper col-11 mx-auto bg-white radius px-2 py-3 border-bottom-lg border-color-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA est\xE1 realizando uma recarga no valor de ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',props.creditValue?'R$ '+props.creditValue.toLocaleString('pt-br',{minimumFractionDigits:2}):''),' para o n\xFAmero ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'(',props.areaCode||'xx',') ',props.phoneNumber||'xxxxx-xxxx'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-1'},'As recargas de celular s\xE3o v\xE1lidas apenas para celulares de planos pr\xE9-pago ou controle.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-1'},'Confira o n\xFAmero digitado e operadora escolhida antes de finalizar.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6  mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm py-2',onClick:function onClick(e){return props.onClose();},text:'Cancelar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6  mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'Confirm-recharge',name:'Confirm',className:'btn btn-featured py-2',text:'Confirmar Recarga',onClick:function onClick(e){return props.finalizeOrder();},loading:props.loadingFinalizeOrder}))))));};ModalConfirmRecharge.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,finalizeOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadingFinalizeOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,areaCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ModalConfirmRecharge);

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var innitialState={};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:innitialState;var action=arguments[1];switch(action.type){case'INSERT_MOBILE_RECHARGE':return innitialState;case'SHOW_ERRORMESSAGE_RECHARGE':return Object.assign({},state,{errorMessage:action.message});case'CLEAR_ERROR_MESSAGE':return Object.assign({},state,{errorMessage:undefined});case'MOBILE_RECHARGE_FINALIZE_ORDER':return Object.assign({},state,{loadingFinalizeOrder:true});case'MOBILE_RECHARGE_FINALIZE_ORDER_END':return Object.assign({},state,{loadingFinalizeOrder:undefined});case'MOBILE_RECHARGE_FINALIZE_ORDER_SUCCESS':return Object.assign({},state,{mobileRechargeInserted:true});case'MOBILE_RECHARGE_SCHEDULE_ORDER':return Object.assign({},state,{loadingScheduleOrder:true});case'MOBILE_RECHARGE_SCHEDULE_ORDER_END':return Object.assign({},state,{loadingScheduleOrder:undefined});case'SECOND_FACTOR_AUTHENTICATION':return Object.assign({},state,{secondFactorAuthentication:true,secondFactorAuthenticationOrderId:action.orderId,secondFactorAuthConfirmated:action.secondFactorAuthConfirmated});case'CLOSE_SECOND_FACTOR':return Object.assign({},state,{secondFactorAuthentication:undefined,secondFactorAuthenticationOrderId:undefined});case'RESET_DATA':return innitialState;default:return state||innitialState;}});

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var CellphonerechargePlaceholder=function CellphonerechargePlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 pr-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 py-5 radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-1 col py-3 bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-1 col py-3 bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-1 col py-3 bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-1 col py-3 bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-1 col py-3 bg-ui-3 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-1 col py-3 bg-ui-3 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-4 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-4 bg-ui-3 radius'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (CellphonerechargePlaceholder);

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Confirmation__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Balance__ = __webpack_require__(187);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref,ownProps){var confirmation=_ref.confirmation,packageSize=_ref.pointsPurchase.config.packageSize;return{order:confirmation,orderId:ownProps.match.params.orderId,packageSize:packageSize};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectNotFoundPage:function redirectNotFoundPage(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].REDIRECT_ROUTE_PAGE_404));},getOrder:function getOrder(orderId){return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].getOrder(orderId));},redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(path));},loadBalance:function loadBalance(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Balance__["a" /* actions */].loadBalance());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Confirmation__["a" /* default */]));

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOrder */
var getOrder=function getOrder(orderId){return{type:'GET_ORDER_CONFIRMATION',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/'+orderId+'/order'}}};};/* harmony default export */ __webpack_exports__["a"] = ({getOrder:getOrder});

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductOrderItem__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutOrder__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalEvaluationDonation__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Nps__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_features_Nps_GoogleForms__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_last_location__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_last_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_router_last_location__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VENDORTYPEDONATION='Doação';var Confirmation=function(_Component){_inherits(Confirmation,_Component);function Confirmation(props){_classCallCheck(this,Confirmation);var _this=_possibleConstructorReturn(this,(Confirmation.__proto__||Object.getPrototypeOf(Confirmation)).call(this,props));_this.state={showModal:false,hideModal:true,showAlert:true,vendorType:'',isDonationCampaign:false};_this.toogleModal=function(){_this.setState({showModal:!_this.state.showModal});};_this.onCloseAlert=function(){_this.setState({showAlert:!_this.state.showAlert});};_this.state={showModal:false,hideModal:true,showAlert:true};if(_this.props.lastLocation.pathname==='/checkout'){_this.state={sendGTM:false};}var client=__WEBPACK_IMPORTED_MODULE_8_redux_clients__["a" /* default */].cloudloyalty.client;_this.client=client;return _this;}_createClass(Confirmation,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.orderId){this.props.getOrder(this.props.orderId);}if(!__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_DISABLE_DONATION_MODAL)){this.getDonationStatus();}this.props.loadBalance();}},{key:'getDonationStatus',value:function getDonationStatus(){var _this2=this;this.client.get('/v1/donation/status').then(function(result){return _this2.setState({isDonationCampaign:result.data});});}},{key:'sendGTM',value:function sendGTM(){var _this3=this;var props=this.props;if(Object.entries(props.order).length>0){this.setState({sendGTM:true});var order=props.order;var purchaseType=order&&order.vendorOrderModel&&order.vendorOrderModel[0].vendorType==='Compra de Pontos'||order.paymentType===5?'resgate:points+cash':'resgate:points';var moneyValue=order&&order.vendorOrderModel&&order.vendorOrderModel[0].vendorType==='Compra de Pontos'||order.paymentType===5?parseFloat(order.orderPaymentDetailMoneyAndPoints.valuePurchase.replace('.','').replace(',','.')):undefined;var orderTotalValue=order&&order.vendorOrderModel&&order.vendorOrderModel[0].vendorType==='Compra de Pontos'||order.paymentType===5?undefined:order.orderTotalValue.toFixed(2);var productsList=[];order.vendorOrderModel.map(function(vendorItem){vendorItem.items.map(function(item,index){return productsList.push({'name':__WEBPACK_IMPORTED_MODULE_9_react_slugify___default()(item.name,{delimiter:' '}),'id':item.productSkuId,'price':_this3.props.order.paymentType===5?undefined:item.sellingPrice.toFixed(2),'brand':undefined,'category':item.categoryName?__WEBPACK_IMPORTED_MODULE_9_react_slugify___default()(item.categoryName,{delimiter:' '}):undefined,'variant':undefined,'quantity':item.quantity,'coupon':undefined,'dimension5':vendorItem.vendorId?'vendor-'+vendorItem.vendorId:undefined,'metric2':item.currencySellingPrice?item.currencySellingPrice.toFixed(2):undefined});});});window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'purchase','eventCategory':'enhanced-ecommerce','eventAction':'purchase','dimension4':purchaseType,'metric1':moneyValue,'ecommerce':{'purchase':{'actionField':{'id':order.parentOrderId,'revenue':orderTotalValue,'shipping':order&&order.orderTotalShippingValue?order.orderTotalShippingValue.toFixed(2):undefined,'tax':'0.00','coupon':undefined},'products':productsList}}});}}},{key:'render',value:function render(){var _this4=this;if(this.state.sendGTM===false){this.sendGTM();}var donationOrder=false;if(this.props.order.notFound){this.props.redirectNotFoundPage();}else if(this.props.order.vendorOrderModel){donationOrder=this.props.order.vendorOrderModel.findIndex(function(item){return item.vendorType===VENDORTYPEDONATION;})!==-1;}var successMsg=this.props.lastLocation&&this.props.lastLocation.pathname.toString().indexOf('points-purchase')>-1?'Parabéns! Sua compra foi concluída com sucesso':'Parabéns! Seu resgate foi concluído com sucesso.';var cash=this.props.order.orderPaymentDetailMoneyAndPoints&&this.props.order.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal;var pointsUsedDecimal=this.props.order.orderPaymentDetailMoneyAndPoints&&this.props.order.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal;var msgCash=cash>0?', e lembre-se que seus pontos de cashback serão creditados em até 30 dias.':'.';msgCash=this.props.lastLocation&&this.props.lastLocation.pathname.toString().indexOf('points-purchase')>-1?', seus pontos serão creditados em instantes.':msgCash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container px-0 pt-0 pt-sm-2 pb-5',onLoad:function onLoad(e){return!__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_DISABLE_DONATION_MODAL)&&_this4.toogleModal();}},!this.state.showModal&&Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Nps__["a" /* default */],{closeDonation:!this.state.showModal}),!this.state.showModal&&Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NPS_GFORMS&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Nps_GoogleForms__["a" /* default */],{closeDonation:!this.state.showModal}),this.props.isDonationCampaign&&donationOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:false,title:'Obrigado! Sua doa\xE7\xE3o foi conclu\xEDda com sucesso.',description:'Veja abaixo o resumo do seu pedido.',className:'mt-0 mt-sm-0 mb-2 '+(!this.state.showAlert&&'d-none'),onClose:function onClose(e){return _this4.onCloseAlert();}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:false,title:successMsg,className:'mt-0 mt-sm-0 mb-2 '+(!this.state.showAlert&&'d-none'),description:'Veja abaixo o resumo do seu pedido'+msgCash,onClose:function onClose(e){return _this4.onCloseAlert();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'confirmation-content',className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 pl-0 pr-0 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},this.props.isDonationCampaign&&donationOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'color-title txt-font-body h3'},'Resumo da doa\xE7\xE3o'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'color-title txt-font-body h3'},'Resumo do pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},this.props.order.vendorOrderModel?this.props.order.vendorOrderModel.map(function(vendorItem){return vendorItem.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductOrderItem__["a" /* default */],{key:index,productName:item.name,orderParentId:_this4.props.order.parentOrderId,sellingPrice:_this4.props.order.paymentType===5?cash:pointsUsedDecimal!==item.sellingPrice&&pointsUsedDecimal!==0?pointsUsedDecimal:item.sellingPrice,quanttity:item.quantity,vendorName:vendorItem.vendorName,deliveryDate:item.deliveryForecastParticipant,orderId:vendorItem.orderId,parentOrderId:_this4.props.order.parentOrderId,productId:item.id,imageUrl:item.imageUrl,vendorId:vendorItem.vendorId,vendorType:vendorItem.vendorType,redirect:_this4.props.redirect,paymentType:_this4.props.order.paymentType,cash:cash,packageSize:_this4.props.packageSize});});}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AboutOrder__["a" /* AboutOrder */],{campaignHasDonation:this.state.isDonationCampaign&&!donationOrder,parentOrder:this.props.order}),this.state.isDonationCampaign&&!donationOrder?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalEvaluationDonation__["a" /* ModalEvaluationDonation */],{show:this.state.showModal,onClose:function onClose(e){return _this4.toogleModal();}}):''));}}]);return Confirmation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Confirmation.propTypes={order:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,orderId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,getOrder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,redirectNotFoundPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,isDonationCampaign:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,lastLocation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,search:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,hash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string}),redirect:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,loadBalance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,packageSize:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number};Confirmation.defaultProps={lastLocation:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_router_last_location__["withLastLocation"])(Confirmation));

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductImage__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_confirmation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(5);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var ProductOrderItem=function ProductOrderItem(props){var sellingPrice=props.paymentType!==5&&props.vendorType!=='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.sellingPrice}):' R$ '+addZeroes(props.cash);var vendorName=props.vendorName&&props.vendorName!=='Compra de Pontos'&&props.vendorType!=='Milhas'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.vendorName))||'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductImage__["a" /* ProductImage */],{imageUrl:props.imageUrl,vendorId:props.vendorId,vendorType:props.vendorType,ready:true,ariaHidden:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-number col-12 mx-0 mb-1 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-body'},'Pedido: #',props.orderParentId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},props.productName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-none d-md-block col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor: ',sellingPrice,props.paymentType!==5&&props.vendorType!=='Compra de Pontos'&&props.cash!==0&&props.paymentType===2?' + R$ '+addZeroes(props.cash):'',props.vendorType==='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block'},'Quantidade:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.quanttity*(props.packageSize||1000)})):props.vendorType!=='Milhas'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block'},'Quantidade: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.quanttity+' unidades')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block d-md-none col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},props.vendorType==='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block'},'Quantidade:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.quanttity*(props.packageSize||1000)})):props.vendorType!=='Milhas'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'d-block'},'Quantidade: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.quanttity+' unidades'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block d-md-none col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor: ',sellingPrice,props.paymentType!==5&&props.vendorType!=='Compra de Pontos'&&props.cash!==0&&props.paymentType===2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' + R$ '+addZeroes(props.cash)):'')),props.deliveryDate&&props.vendorName!=='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Previs\xE3o de entrega:  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.deliveryDate?__WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(props.deliveryDate).format('DD/MM/YYYY'):'-')):'',vendorName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["Link"],{className:'btn btn-sm btn-featured btn-cart txt-center',to:'/order/'+props.parentOrderId+'/'+props.orderId+'/product/'+props.productId+'?previousRoute=/my-orders?days=365'},'Ver detalhes')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 d-block d-md-none mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured btn-cart',text:'Ver detalhes',onClick:function onClick(){props.redirect('/order/'+props.parentOrderId+'/'+props.orderId+'/product/'+props.productId);}})));};function addZeroes(value){// set everything to at least two decimals; removs 3+ zero decimasl, keep non-zero decimals
var newValue=value*1;// removes trailing zeros
newValue=newValue+'';// casts it to string
var pos=newValue.indexOf('.');if(pos===-1)newValue=newValue+'.00';else{var integer=newValue.substring(0,pos);var decimals=newValue.substring(pos+1);while(decimals.length<2){decimals=decimals+'0';}newValue=integer+','+decimals;}return newValue.toString().replace('.',',');}ProductOrderItem.propTypes={productName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,orderParentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,sellingPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,quanttity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,deliveryDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),vendorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,orderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,parentOrderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,productId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.vendorType,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,redirect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,paymentType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,cash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,packageSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductOrderItem);

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalEvaluationDonation__ = __webpack_require__(1616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalEvaluationDonation__["a"]; });


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_modal_donation_png__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_modal_donation_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_modal_donation_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_modal_donation_mobile_png__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_modal_donation_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_modal_donation_mobile_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var modalDonationBackground=function modalDonationBackground(){return window.innerWidth<=420?__WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_modal_donation_mobile_png___default.a:__WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_modal_donation_png___default.a;};var bgModalDonation={backgroundImage:'url('+modalDonationBackground()+')',backgroundColor:'transparent !important',borderColor:'transparent !important',backgroundRepeat:'no-repeat'};var donationScreen=function donationScreen(){window.location.href='/donation';};var ModalEvaluationDonation=function(_Component){_inherits(ModalEvaluationDonation,_Component);function ModalEvaluationDonation(){_classCallCheck(this,ModalEvaluationDonation);var _this=_possibleConstructorReturn(this,(ModalEvaluationDonation.__proto__||Object.getPrototypeOf(ModalEvaluationDonation)).call(this));_this.state={modalTitle:'Ainda restaram alguns pontos na sua conta'};return _this;}_createClass(ModalEvaluationDonation,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:window.innerWidth<=420?'336':'640',height:'360',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-1 pb-1 mr-auto ml-auto',style:bgModalDonation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pl-0 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{name:'Close',className:'btn btn-double btn-flat btn-icon-only btn-icon '+(window.innerWidth<=420?'pos-relative r-2':''),iconName:'icon_close icon-sm color-ui-white',text:'',onClick:this.props.onClose}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepOne',className:'col-12 col-md-7 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{id:'modalTitle',className:'color-ui-white'},this.state.modalTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body color-ui-white pt-2 px-0'},'Voc\xEA pode aproveitar para mudar a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body color-ui-white pt-0 px-0'},'realidade de diversas pessoas e fazer uma ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Doa\xE7\xE3o para o Movimento Solid\xE1rio'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body color-ui-white pb-2 px-0'},'Sua contribui\xE7\xE3o faz toda a diferen\xE7a!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-next-rating',name:'btn-next-rating',className:'btn btn-double btn-featured btn-rating-modal2 col-12',text:'QUERO FAZER A DIFEREN\xC7A',onClick:function onClick(){return donationScreen();}}))))))))));}}]);return ModalEvaluationDonation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalEvaluationDonation.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ModalEvaluationDonation);

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modal-donation.93fa2d83.png";

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modal-donation-mobile.08e71462.png";

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReactTypeformEmbed = __webpack_require__(1620);

Object.defineProperty(exports, 'ReactTypeformEmbed', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReactTypeformEmbed).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _embed = __webpack_require__(1621);

var typeformEmbed = _interopRequireWildcard(_embed);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styleDefault = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden'
};

var ReactTypeformEmbed = function (_Component) {
  _inherits(ReactTypeformEmbed, _Component);

  function ReactTypeformEmbed() {
    _classCallCheck(this, ReactTypeformEmbed);

    return _possibleConstructorReturn(this, (ReactTypeformEmbed.__proto__ || Object.getPrototypeOf(ReactTypeformEmbed)).apply(this, arguments));
  }

  _createClass(ReactTypeformEmbed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          hideHeaders = _props.hideHeaders,
          hideFooter = _props.hideFooter,
          opacity = _props.opacity,
          buttonText = _props.buttonText,
          popup = _props.popup,
          mode = _props.mode,
          autoOpen = _props.autoOpen,
          autoClose = _props.autoClose,
          onSubmit = _props.onSubmit;

      var options = {
        hideHeaders: hideHeaders,
        hideFooter: hideFooter,
        opacity: opacity,
        buttonText: buttonText,
        mode: mode,
        autoOpen: autoOpen,
        autoClose: autoClose,
        onSubmit: onSubmit
      };

      // Popup Mode
      if (popup) {
        // Load Typeform embed popup
        this.typeform = typeformEmbed.makePopup(url, options);

        // Widget Mode (default)
      } else {
        var elm = this.typeformElm;

        // Load Typeform embed widget
        typeformEmbed.makeWidget(elm, url, options);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = Object.assign({}, styleDefault, this.props.style);

      return _react2.default.createElement('div', {
        className: 'ReactTypeformEmbed',
        ref: function ref(tf) {
          _this2.typeformElm = tf;
        },
        style: style
      });
    }
  }]);

  return ReactTypeformEmbed;
}(_react.Component);

ReactTypeformEmbed.propTypes = {
  style: _propTypes2.default.object,
  url: _propTypes2.default.string.isRequired,
  popup: _propTypes2.default.bool,
  hideHeaders: _propTypes2.default.bool,
  hideFooter: _propTypes2.default.bool,

  // Widget options
  opacity: _propTypes2.default.number,
  buttonText: _propTypes2.default.string,

  // Popup options
  mode: _propTypes2.default.string,
  autoOpen: _propTypes2.default.bool,
  autoClose: _propTypes2.default.number,
  onSubmit: _propTypes2.default.func
};

// Default values taken from official Typeform docs
// https://developer.typeform.com/embed/modes/
ReactTypeformEmbed.defaultProps = {
  style: {},
  popup: false,
  hideHeaders: false,
  hideFooter: false,
  onSubmit: function onSubmit() {},

  // Widget options
  opacity: 100,
  buttonText: 'Start',

  // Popup options
  mode: 'popup', // options: "popup", "drawer_left", "drawer_right"
  autoOpen: false,
  autoClose: 5
};

exports.default = ReactTypeformEmbed;

/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = typeof window == 'object' && window && window.Math == Math ? window
  : typeof self == 'object' && self && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(20)('wks');
var uid = __webpack_require__(56);
var Symbol = __webpack_require__(0).Symbol;
var NATIVE_SYMBOL = __webpack_require__(113);

module.exports = function (name) {
  return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
    || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(79);




var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = (typeof Symbol!=='undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

var COMPONENT_WRAPPER_KEY = (typeof Symbol!=='undefined' && Symbol.for) ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};


var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;


var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = process.env.NODE_ENV!=='production';
}
catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() { return null; }



// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function() { return this.nodeName; },
	set: function(v) { this.nodeName = v; },
	configurable:true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function() { return this.attributes; },
	set: function(v) { this.attributes = v; },
	configurable:true
});



var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event = function (e) {
	if (oldEventHook) { e = oldEventHook(e); }
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};


var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
			attrs = vnode.attributes = vnode.attributes==null ? {} : extend({}, vnode.attributes);

		if (typeof tag==='function') {
			if (tag[COMPONENT_WRAPPER_KEY]===true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
				if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		}
		else {
			if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
			if (vnode.children) { attrs.children = vnode.children; }

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value!==0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) { oldVnodeHook(vnode); }
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
		a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
	if (a) { extend(vnode.attributes, a); }
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[ CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i ] = a[i];
				}
			}
		}
	}
}



// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode!==parent) { prev = null; }

	// default to first Element child
	if (!prev && parent) { prev = parent.firstElementChild; }

	// remove unaffected siblings
	for (var i=parent.childNodes.length; i--; ) {
		if (parent.childNodes[i]!==prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(vnode, parent, prev);
	if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
	if (typeof callback==='function') { callback(); }
	return out && out._component || out;
}


var ContextProvider = function () {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) { callback.call(component, renderContainer); }
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(Portal, { vnode: vnode, container: container });
}


function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode===container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}



var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		return children.map(fn);
	},
	forEach: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		children.forEach(fn);
	},
	count: function(children) {
		return children && children.length || 0;
	},
	only: function(children) {
		children = Children.toArray(children);
		if (children.length!==1) { throw new Error('Children.only() expects only one child.'); }
		return children[0];
	},
	toArray: function(children) {
		if (children == null) { return []; }
		return ARR.concat(children);
	}
};


/** Track current render() component for ref assignment */
var currentComponent;


function createFactory(type) {
	return createElement.bind(null, type);
}


var DOM = {};
for (var i=ELEMENTS.length; i--; ) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i=offset || 0; i<arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		}
		else if (obj && typeof obj==='object' && !isValidElement(obj) && ((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c==='function' && !(c.prototype && c.prototype.render);
}


// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function() {
			return WrappedComponent(this.props, this.context);
		}
	});
}


function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) { return Wrapped===true ? Ctor : Wrapped; }

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable:true, value:true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable:true, value:Wrapped });

	return Wrapped;
}


function createElement() {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */].apply(void 0, args));
}


function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
		type = ref && typeof ref;
	if (currentComponent && (type==='string' || type==='number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}


function cloneElement$1(element, props) {
	var children = [], len = arguments.length - 2;
	while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

	if (!isValidElement(element)) { return element; }
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* h */])(
		element.nodeName || element.type,
		extend({}, elementProps),
		element.children || elementProps && elementProps.children
	);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	}
	else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* cloneElement */].apply(void 0, cloneArgs));
}


function isValidElement(element) {
	return element && ((element instanceof VNode) || element.$$typeof===REACT_ELEMENT_TYPE);
}


function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved===null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}


function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName!=='string') { return; }
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName==='textarea' || (nodeName.toLowerCase()==='input' && !/^fil|che|rad/i.test(attributes.type)))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}


function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) { a.class = a.className; }
	Object.defineProperty(a, 'className', classNameDescriptor);
}


var classNameDescriptor = {
	configurable: true,
	get: function() { return this.class; },
	set: function(v) { this.class = v; }
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i=1, obj = (void 0); i<arguments.length; i++) {
		if ((obj = arguments$1[i])) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}


function shallowDiffers(a, b) {
	for (var i in a) { if (!(i in b)) { return true; } }
	for (var i$1 in b) { if (a[i$1]!==b[i$1]) { return true; } }
	return false;
}


function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}


function F(){}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}


// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i=0; i<mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key]==='function') {
				(keyed[key] || (keyed[key]=[])).push(mixin[key]);
			}
		}
	}
	return keyed;
}


// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) { if (mixins.hasOwnProperty(key)) {
		proto[key] = multihook(
			mixins[key].concat(proto[key] || ARR),
			key==='getDefaultProps' || key==='getInitialState' || key==='getChildContext'
		);
	} }
}


function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v==='function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}


function callMethod(ctx, m, args) {
	if (typeof m==='string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m==='function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function() {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i=0; i<hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r!=null) {
				if (!ret) { ret = {}; }
				for (var key in r) { if (r.hasOwnProperty(key)) {
					ret[key] = r[key];
				} }
			}
			else if (typeof r!=='undefined') { ret = r; }
		}
		return ret;
	};
}


function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}


function propsHook(props, context) {
	if (!props) { return; }

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length===1 && (typeof c[0]==='string' || typeof c[0]==='function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children==='object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this==='function' ? this : this.constructor,
			propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}


function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent===this) {
		currentComponent = null;
	}
}



function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts!==BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["a" /* Component */](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function() {
		return this.base;
	},

	isMounted: function() {
		return !!this.base;
	}
});



function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function(props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(42);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(75)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(78)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var definePropertyModule = __webpack_require__(14);
var createPropertyDescriptor = __webpack_require__(35);

module.exports = __webpack_require__(13) ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectAfterSubmit = exports.omit = exports.noop = exports.applyIOSIframeResizeHack = exports.applyIOSFooterHack = exports.debounce = exports.fixSafariScroll = exports.isElementInViewport = exports.onMessage = exports.ensureMetaViewport = exports.replaceExistingKeys = exports.appendParamsToUrl = exports.updateQueryStringParameter = exports.randomString = exports.DOMAIN = undefined;

var _customEvent = __webpack_require__(80);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isUrl = __webpack_require__(81);

var _isUrl2 = _interopRequireDefault(_isUrl);

var _urlParse = __webpack_require__(43);

var _urlParse2 = _interopRequireDefault(_urlParse);

var _isobject = __webpack_require__(84);

var _isobject2 = _interopRequireDefault(_isobject);

var _mobileDetection = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DOMAIN_REGEXP = /(\.typeform)\.(com|io)$/;
var DOMAIN = exports.DOMAIN = 'admin.typeform.com';

var randomString = exports.randomString = function randomString() {
  return Math.random().toString(36).substr(2, 5);
};

var updateQueryStringParameter = exports.updateQueryStringParameter = function updateQueryStringParameter(key, value, uri) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  }

  return uri + separator + key + '=' + value;
};

var appendParamsToUrl = exports.appendParamsToUrl = function appendParamsToUrl(url, params) {
  var queryParameters = [];

  var _UrlParse = (0, _urlParse2.default)(url, true),
      query = _UrlParse.query,
      origin = _UrlParse.origin,
      pathname = _UrlParse.pathname;

  var path = pathname.replace(/\/$/, ''); // remove trailing slash
  var parameters = Object.assign({}, query, params);

  Object.keys(parameters).forEach(function (key) {
    queryParameters.push(encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]));
  });

  return '' + origin + path + '?' + queryParameters.join('&');
};

var replaceExistingKeys = exports.replaceExistingKeys = function replaceExistingKeys(obj, replacer) {
  return Object.keys(replacer).reduce(function (acc, oldKey) {
    var newKey = replacer[oldKey];
    if (newKey != null && obj[oldKey] != null && obj[oldKey] !== false) {
      acc[newKey] = obj[oldKey];
    }

    return acc;
  }, {});
};

var ensureMetaViewport = exports.ensureMetaViewport = function ensureMetaViewport() {
  if (!document.querySelector) {
    return;
  }

  var viewport = document.querySelector('meta[name=viewport]');
  var viewportContent = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0';

  if (viewport) {
    viewport.setAttribute('content', viewportContent);
  } else {
    var metaTag = document.createElement('meta');
    metaTag.content = viewportContent;
    metaTag.name = 'viewport';
    document.head.appendChild(metaTag);
  }
};

var acceptMessageOrigin = function acceptMessageOrigin(e) {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  // deal with polymorphistic legacy: some events come from jQuery, other Vanilla JS
  var re = new RegExp('^(?:f|ht)tp(?:s)?://([^/]+)', 'im');
  var matches = e.origin.match(re);
  if (matches && matches.length > 1) {
    var domain = matches[1].toString();

    // to test this in local you will need to whitelist your local domain
    if (!DOMAIN_REGEXP.test(domain)) {
      return false;
    }
  } else {
    return false;
  }

  return true;
};

var onMessage = exports.onMessage = function onMessage(e) {
  e = e.originalEvent || e;
  if (!acceptMessageOrigin(e)) {
    return false;
  }

  if ((0, _isUrl2.default)(e.data)) {
    window.location.href = e.data;
    return;
  }

  if ((0, _isobject2.default)(e.data) && e.data.hasOwnProperty('type')) {
    window.dispatchEvent(new _customEvent2.default(e.data.type, {
      detail: e.data
    }));
    return;
  }

  window.dispatchEvent(new _customEvent2.default(e.data));
};

var isElementInViewport = exports.isElementInViewport = function isElementInViewport(el) {
  // If it's a nested iframe, don't try to calculate if is insideViewport
  if (window.top !== window) {
    return false;
  }

  var rect = el.getBoundingClientRect();

  var margin = rect.height * 0.2; // 20% of margin
  var docWidth = window.innerWidth || document.documentElement.clientWidth;
  var docHeight = window.innerHeight || document.documentElement.clientHeight;

  return rect.top >= -margin && rect.left >= -margin && rect.bottom <= docHeight + margin && rect.right <= docWidth + margin;
};

// RD-712
var fixSafariScroll = exports.fixSafariScroll = function fixSafariScroll(iframe) {
  if ((0, _mobileDetection.isMobile)(navigator.userAgent) || !(0, _mobileDetection.isSafari)(navigator.userAgent)) {
    return;
  }

  iframe.addEventListener('load', function () {
    return setTimeout(function () {
      var originalHeight = window.getComputedStyle(iframe).height;
      iframe.setAttribute('height', iframe.offsetHeight + 1 + 'px');
      return setTimeout(function () {
        iframe.setAttribute('height', originalHeight);
      }, 1);
    }, 1000);
  });
};

var debounce = exports.debounce = function debounce(func, wait, context) {
  var timeout = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var debounced = function debounced() {
      timeout = null;
      func.call.apply(func, [context].concat(args));
    };

    clearTimeout(timeout);
    timeout = setTimeout(debounced, wait);
  };
};

// Fix RD-731, footer not fully visible on iOS devices
var applyIOSFooterHack = exports.applyIOSFooterHack = function applyIOSFooterHack(element) {
  if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
    return;
  }

  element.setAttribute('scrolling', 'no');
  element.style.height = '1px';
  element.style.minHeight = '100%';
};

var applyIOSIframeResizeHack = exports.applyIOSIframeResizeHack = function applyIOSIframeResizeHack(element) {
  if (!(0, _mobileDetection.isIOSDevice)(navigator.userAgent)) {
    return;
  }

  element.style.maxHeight = '100%';
  element.style.maxWidth = '100%';
  element.style.minHeight = '100%';
  element.style.minWidth = '100%';
  element.style.width = 0;
};

var noop = exports.noop = function noop() {
  return null;
};

var omit = function omit(key, object) {
  var deletedKey = object[key],
      otherKeys = _objectWithoutProperties(object, [key]);

  return otherKeys;
};

exports.omit = omit;
var redirectAfterSubmit = exports.redirectAfterSubmit = function redirectAfterSubmit(event) {
  var url = event.detail.url;


  try {
    var anchor = document.createElement('a');

    anchor.href = url;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } catch (e) {}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getOwnPropertyDescriptor = __webpack_require__(34).f;
var hide = __webpack_require__(8);
var redefine = __webpack_require__(19);
var setGlobal = __webpack_require__(37);
var copyConstructorProperties = __webpack_require__(106);
var isForced = __webpack_require__(57);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      hide(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(54);
var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(53);
var nativeDefineProperty = Object.defineProperty;

exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isScreenBig = exports.isScreenBig = function isScreenBig() {
  return window.screen.width >= 1024 && window.screen.height >= 768;
};

var isMobile = exports.isMobile = function isMobile(ua) {
  return (/mobile|tablet|android/i.test(ua.toLowerCase())
  );
};

var isSafari = exports.isSafari = function isSafari(ua) {
  return (/^((?!chrome|android).)*safari/i.test(ua.toLowerCase())
  );
};

var isIOSDevice = exports.isIOSDevice = function isIOSDevice(ua) {
  return (/ip(hone|od|ad)/i.test(ua.toLowerCase())
  );
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = exports.injectGlobal = exports.css = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _createEmotion = __webpack_require__(86);

var _createEmotion2 = _interopRequireDefault(_createEmotion);

var _createEmotionStyled = __webpack_require__(91);

var _createEmotionStyled2 = _interopRequireDefault(_createEmotionStyled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = typeof global !== 'undefined' ? global : {};

var emotion = (0, _createEmotion2.default)(context);

var css = exports.css = emotion.css;
var injectGlobal = exports.injectGlobal = emotion.injectGlobal;
var keyframes = exports.keyframes = emotion.keyframes;
exports.default = (0, _createEmotionStyled2.default)(emotion, _react2.default);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(27);
var requireObjectCoercible = __webpack_require__(28);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var hide = __webpack_require__(8);
var has = __webpack_require__(7);
var setGlobal = __webpack_require__(37);
var nativeFunctionToString = __webpack_require__(55);
var InternalStateModule = __webpack_require__(22);
var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(nativeFunctionToString).split('toString');

__webpack_require__(20)('inspectSource', function (it) {
  return nativeFunctionToString.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else hide(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var setGlobal = __webpack_require__(37);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.0.1',
  mode: __webpack_require__(21) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(105);
var isObject = __webpack_require__(5);
var hide = __webpack_require__(8);
var objectHas = __webpack_require__(7);
var sharedKey = __webpack_require__(38);
var hiddenKeys = __webpack_require__(31);
var WeakMap = __webpack_require__(0).WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    hide(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Iframe = function (_Component) {
  _inherits(Iframe, _Component);

  function Iframe(props) {
    _classCallCheck(this, Iframe);

    var _this = _possibleConstructorReturn(this, (Iframe.__proto__ || Object.getPrototypeOf(Iframe)).call(this, props));

    _this.iframeRef = null;
    _this.loadHandler = _this.loadHandler.bind(_this);
    return _this;
  }

  // Fixes scroll not responding in renderer v1


  _createClass(Iframe, [{
    key: 'loadHandler',
    value: function loadHandler() {
      var _this2 = this;

      this.iframeRef.style.height = this.iframeRef.offsetHeight + 1 + 'px';
      setTimeout(function () {
        _this2.iframeRef.style.height = '';
        (0, _utils.applyIOSFooterHack)(_this2.iframeRef);
        (0, _utils.applyIOSIframeResizeHack)(_this2.iframeRef);

        _this2.props.onLoad && _this2.props.onLoad(_this2.iframeRef);
      }, 1);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.src !== this.props.src;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          style = _props.style,
          rest = _objectWithoutProperties(_props, ['style']);

      return _react2.default.createElement('iframe', _extends({}, rest, {
        'data-qa': 'iframe',
        frameBorder: '0',
        height: '100%',
        onLoad: this.loadHandler,
        ref: function ref(node) {
          _this3.iframeRef = node;
        },
        src: this.props.src,
        style: _extends({ border: 0 }, style),
        width: '100%'
      }));
    }
  }]);

  return Iframe;
}(_react.Component);

Iframe.propTypes = {
  src: _propTypes2.default.string.isRequired,
  onLoad: _propTypes2.default.func,
  style: _propTypes2.default.object
};

exports.default = Iframe;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var fails = __webpack_require__(10);
var classof = __webpack_require__(11);
var split = ''.split;

module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(28);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var propertyIsEnumerableModule = __webpack_require__(52);
var createPropertyDescriptor = __webpack_require__(35);
var toIndexedObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(53);
var has = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(54);
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var exist = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return exist ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var hide = __webpack_require__(8);

module.exports = function (key, value) {
  try {
    hide(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(20)('keys');
var uid = __webpack_require__(56);

module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(23);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(14).f;
var has = __webpack_require__(7);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(73);
} else {
  module.exports = __webpack_require__(74);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__(82)
  , qs = __webpack_require__(83)
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address) {          // Sanitize what is left of the address
    return address.replace('\\', '/');
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof global !== 'undefined') globalVar = global;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.qs = qs;

module.exports = Url;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPUP_MODES = exports.DRAWER_RIGHT = exports.DRAWER = exports.POPUP = exports.DEFAULT_AUTOCLOSE_TIMEOUT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _POPUP_MODES;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollbarWidth = __webpack_require__(85);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _styles = __webpack_require__(17);

var _styles2 = _interopRequireDefault(_styles);

var _iframe = __webpack_require__(26);

var _iframe2 = _interopRequireDefault(_iframe);

var _spinner = __webpack_require__(93);

var _spinner2 = _interopRequireDefault(_spinner);

var _utils = __webpack_require__(9);

var _close = __webpack_require__(95);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ESC_KEY_CODE = 27;
var CLOSE_BUTTON_WIDTH = 30;

var DEFAULT_AUTOCLOSE_TIMEOUT = exports.DEFAULT_AUTOCLOSE_TIMEOUT = 5;
var POPUP = exports.POPUP = 'popup';
var DRAWER = exports.DRAWER = 'drawer_left';
var DRAWER_RIGHT = exports.DRAWER_RIGHT = 'drawer_right';
var POPUP_MODES = exports.POPUP_MODES = (_POPUP_MODES = {}, _defineProperty(_POPUP_MODES, POPUP, 'popup-blank'), _defineProperty(_POPUP_MODES, DRAWER, 'popup-classic'), _defineProperty(_POPUP_MODES, DRAWER_RIGHT, 'popup-drawer'), _POPUP_MODES);

var BaseWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e1o3ysfi0'
})('visibility:', function (p) {
  return p.open ? 'visible' : 'hidden';
}, ';opacity:', function (p) {
  return p.open ? 1 : 0;
}, ';position:', function (p) {
  return p.isContained ? 'absolute' : 'fixed';
}, ';max-width:100%;z-index:10001;');

var Overlay = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e1o3ysfi1'
})('visibility:', function (p) {
  return p.appearing ? 'hidden' : 'visible';
}, ';opacity:', function (p) {
  return p.appearing ? 0 : 1;
}, ';transition:opacity 200ms ease,visibility 0s linear ', function (p) {
  return p.appearing ? '200ms' : '0s';
}, ';background:rgba(0,0,0,0.85);position:', function (p) {
  return p.isContained ? 'absolute' : 'fixed';
}, ';overflow:', function (p) {
  return p.isContained ? 'hidden' : 'auto';
}, ';left:0;top:0;right:0;bottom:0;z-index:10000;min-height:100%;');

var popupWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
  target: 'e1o3ysfi2'
})('width:', function (p) {
  return p.isContained ? 'calc(100% - 80px)' : 'calc(100vw - 80px)';
}, ';height:', function (p) {
  return p.isContained ? 'calc(100% - 80px)' : 'calc(100vh - 80px)';
}, ';top:40px;left:40px;transition:all 300ms ease-out;');

var drawerWrapper = /*#__PURE__*/(0, _styles2.default)(BaseWrapper, {
  target: 'e1o3ysfi3'
})('transition:all 400ms ease-out;width:', function (p) {
  return p.width;
}, 'px;height:100%;top:0;');

var drawerLeftWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
  target: 'e1o3ysfi4'
})('left:', function (p) {
  return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
}, 'px;');

var drawerRightWrapper = /*#__PURE__*/(0, _styles2.default)(drawerWrapper, {
  target: 'e1o3ysfi5'
})('right:', function (p) {
  return !p.open ? -(p.width - CLOSE_BUTTON_WIDTH) : 0;
}, 'px;');

var BaseCloseImage = /*#__PURE__*/(0, _styles2.default)('img', {
  target: 'e1o3ysfi6'
})('position:absolute;padding:8px;cursor:pointer;width:initial;max-width:initial;');

var closeImagePopup = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
  target: 'e1o3ysfi7'
})('top:-34px;right:-34px;');

var closeImageLeft = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
  target: 'e1o3ysfi8'
})('top:12px;right:-38px;');

var closeImageRight = /*#__PURE__*/(0, _styles2.default)(BaseCloseImage, {
  target: 'e1o3ysfi9'
})('top:12px;left:-38px;right:auto;');

var Popup = function (_Component) {
  _inherits(Popup, _Component);

  function Popup(props) {
    _classCallCheck(this, Popup);

    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

    _this.state = {
      frameAnimate: false,
      iframeLoaded: false,
      popupAnimate: true,
      transitionEnded: false
    };

    _this.handleIframeLoad = _this.handleIframeLoad.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onAutoClose = _this.onAutoClose.bind(_this);
    _this.animateBeforeClose = _this.animateBeforeClose.bind(_this);
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    _this.getWrapperRef = _this.getWrapperRef.bind(_this);
    return _this;
  }

  _createClass(Popup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('message', _utils.onMessage);
      window.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('form-close', this.animateBeforeClose);
      window.addEventListener('ESC', this.animateBeforeClose);
      window.addEventListener('embed-auto-close-popup', this.onAutoClose);
      window.addEventListener('form-submit', this.onFormSubmit);
      window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);

      setTimeout(function () {
        _this2.setState({
          popupAnimate: false
        });
      }, 100);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', _utils.onMessage);
      window.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('form-close', this.animateBeforeClose);
      window.removeEventListener('ESC', this.animateBeforeClose);
      window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
      window.removeEventListener('form-submit', this.onFormSubmit);
      window.removeEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
    }
  }, {
    key: 'getWrapperComponent',
    value: function getWrapperComponent(mode) {
      if (mode === DRAWER_RIGHT) return drawerRightWrapper;
      if (mode === DRAWER) return drawerLeftWrapper;
      return popupWrapper;
    }
  }, {
    key: 'getCloseImage',
    value: function getCloseImage(mode) {
      if (mode === DRAWER_RIGHT) return closeImageRight;
      if (mode === DRAWER) return closeImageLeft;
      return closeImagePopup;
    }
  }, {
    key: 'getWrapperRef',
    value: function getWrapperRef(node) {
      this.wrapper = node;
    }
  }, {
    key: 'handleIframeLoad',
    value: function handleIframeLoad(iframeRef) {
      var _this3 = this;

      this.setState({ iframeLoaded: true }, function () {
        setTimeout(function () {
          _this3.setState({ frameAnimate: true });
          if (iframeRef && iframeRef.contentWindow) {
            iframeRef.contentWindow.focus();
          }
        }, 500);
      });
    }
  }, {
    key: 'animateBeforeClose',
    value: function animateBeforeClose() {
      var _this4 = this;

      this.setState({ frameAnimate: false, popupAnimate: false }, function () {
        setTimeout(function () {
          _this4.setState({ popupAnimate: true }, function () {
            setTimeout(_this4.props.onClose, 400);
          });
        }, 400);
      });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var key = document.all ? e.keyCode : e.which;
      if (key === ESC_KEY_CODE) {
        this.animateBeforeClose();
      }
    }
  }, {
    key: 'onAutoClose',
    value: function onAutoClose(e) {
      var _this5 = this;

      var _e$detail$canSetAutoc = e.detail.canSetAutocloseDelay,
          canSetAutocloseDelay = _e$detail$canSetAutoc === undefined ? true : _e$detail$canSetAutoc;
      var _props$options = this.props.options,
          isAutoCloseEnabled = _props$options.isAutoCloseEnabled,
          _props$options$autoCl = _props$options.autoClose,
          autoClose = _props$options$autoCl === undefined ? DEFAULT_AUTOCLOSE_TIMEOUT : _props$options$autoCl;


      var timeout = (canSetAutocloseDelay ? autoClose : DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;

      if (isAutoCloseEnabled) {
        setTimeout(function () {
          _this5.animateBeforeClose();
        }, timeout);
      }
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd(event) {
      if (event.target === this.wrapper) {
        this.setState({
          transitionEnded: this.state.frameAnimate
        });
      }
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit() {
      var onSubmit = this.props.options.onSubmit;

      onSubmit();
    }
  }, {
    key: 'render',
    value: function render() {
      var iframeStyles = null;
      var options = this.props.options;
      var drawerWidth = options.drawerWidth,
          hideScrollbars = options.hideScrollbars,
          isContained = options.isContained,
          mode = options.mode;


      if (hideScrollbars) {
        iframeStyles = {
          width: 'calc(100% + ' + (0, _scrollbarWidth2.default)() + 'px)'
        };
      }

      if (mode === POPUP) {
        iframeStyles = _extends({}, iframeStyles, {
          WebkitMaskImage: '-webkit-radial-gradient(circle, white, black)',
          WebkitTransform: 'translateZ(0)'
        });
      }

      var Wrapper = this.getWrapperComponent(mode);
      var CloseImage = this.getCloseImage(mode);

      return _react2.default.createElement(
        Overlay,
        { appearing: this.state.popupAnimate, isContained: isContained },
        _react2.default.createElement(_spinner2.default, { stopped: this.state.iframeLoaded }),
        _react2.default.createElement(
          Wrapper,
          {
            'data-qa': 'popup-mode-' + mode,
            innerRef: this.getWrapperRef,
            isContained: isContained,
            mode: mode,
            onTransitionEnd: this.handleTransitionEnd,
            open: this.state.frameAnimate,
            width: drawerWidth
          },
          this.state.iframeLoaded && _react2.default.createElement(CloseImage, {
            alt: 'close-typeform',
            'data-qa': 'popup-close-button',
            mode: mode,
            onClick: this.animateBeforeClose,
            src: _close2.default
          }),
          _react2.default.createElement(_iframe2.default, {
            onLoad: this.handleIframeLoad,
            src: this.props.url,
            style: iframeStyles
          })
        )
      );
    }
  }]);

  return Popup;
}(_react.Component);

Popup.propTypes = {
  url: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number
};

exports.default = Popup;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(17);

var _styles2 = _interopRequireDefault(_styles);

var _closeIcon = __webpack_require__(96);

var _closeIcon2 = _interopRequireDefault(_closeIcon);

var _iframe = __webpack_require__(26);

var _iframe2 = _interopRequireDefault(_iframe);

var _dataService = __webpack_require__(47);

var _dataService2 = _interopRequireDefault(_dataService);

var _store = __webpack_require__(48);

var _store2 = _interopRequireDefault(_store);

var _utils = __webpack_require__(9);

var _popup = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DOMAIN = 'admin.typeform.com';
var TYPE = 'popup';

var Wrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e4550h40'
})('visibility:', function (p) {
  return p.open ? 'visible' : 'hidden';
}, ';opacity:', function (p) {
  return p.open ? 1 : 0;
}, ';background-color:', function (p) {
  return p.backgroundColor;
}, ';position:fixed !important;z-index:1000;left:0 !important;right:0 !important;top:0 !important;bottom:0 !important;overflow:hidden !important;height:100%;transition:all 400ms ease ', function (props) {
  return props.openDelay;
}, 's;');

(0, _styles.injectGlobal)('.__typeform-embed-mobile-modal-open{overflow:hidden !important;position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;}');

var MobileModal = function (_Component) {
  _inherits(MobileModal, _Component);

  function MobileModal(props) {
    _classCallCheck(this, MobileModal);

    var _this = _possibleConstructorReturn(this, (MobileModal.__proto__ || Object.getPrototypeOf(MobileModal)).call(this, props));

    _this.state = {
      backgroundColor: 'transparent',
      buttonColor: '#FFF'
    };

    _this.onAutoClose = _this.onAutoClose.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    _this.close = _this.close.bind(_this);
    return _this;
  }

  _createClass(MobileModal, [{
    key: 'onAutoClose',
    value: function onAutoClose(e) {
      var _this2 = this;

      var _e$detail$canSetAutoc = e.detail.canSetAutocloseDelay,
          canSetAutocloseDelay = _e$detail$canSetAutoc === undefined ? true : _e$detail$canSetAutoc;
      var _props = this.props,
          isAutoCloseEnabled = _props.isAutoCloseEnabled,
          autoClose = _props.autoClose;

      var timeout = (canSetAutocloseDelay ? autoClose : _popup.DEFAULT_AUTOCLOSE_TIMEOUT) * 1000;

      if (isAutoCloseEnabled) {
        setTimeout(function () {
          _this2.close();
        }, timeout);
      }
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit() {
      var onSubmit = this.props.onSubmit;

      onSubmit && onSubmit();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var uid = _dataService2.default.getUidFromURL(this.props.url);

      _dataService2.default.getFormData(uid, DOMAIN).then(function (data) {
        return (0, _store2.default)(uid, TYPE, _this3.props.url, _this3.props.buttonText, data);
      }).then(function (_ref) {
        var form = _ref.form;

        _this3.setState({
          backgroundColor: '#' + form['background-color'],
          buttonColor: '#' + form['button-color']
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', _utils.onMessage);
      window.addEventListener('embed-auto-close-popup', this.onAutoClose);
      window.addEventListener('form-submit', this.onFormSubmit);

      if (this.props.open) {
        this.open();
      }
    }
  }, {
    key: 'open',
    value: function open() {
      var _this4 = this;

      setTimeout(function () {
        _this4.originalBodyScrollTop = window.document.body.scrollTop;
        document.body.classList.add('__typeform-embed-mobile-modal-open');
      }, this.props.openDelay * 1000 + 500);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.open();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', _utils.onMessage);
      window.removeEventListener('embed-auto-close-popup', this.onAutoClose);
      window.removeEventListener('form-submit', this.onFormSubmit);

      document.body.classList.remove('__typeform-embed-mobile-modal-open');
    }
  }, {
    key: 'close',
    value: function close() {
      var _this5 = this;

      document.body.classList.remove('__typeform-embed-mobile-modal-open');
      setTimeout(function () {
        window.document.body.scrollTop = _this5.originalBodyScrollTop;
      }, 40);

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          url = _props2.url,
          open = _props2.open;
      var _state = this.state,
          backgroundColor = _state.backgroundColor,
          buttonColor = _state.buttonColor;


      return _react2.default.createElement(
        Wrapper,
        {
          backgroundColor: backgroundColor,
          'data-qa': 'mobile-modal',
          open: open,
          openDelay: this.props.openDelay
        },
        open && _react2.default.createElement(_iframe2.default, { src: url }),
        _react2.default.createElement(_closeIcon2.default, {
          color: buttonColor,
          dataQa: 'close-button-mobile',
          onClick: this.close
        })
      );
    }
  }]);

  return MobileModal;
}(_react.Component);

MobileModal.propTypes = {
  url: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  isAutoCloseEnabled: _propTypes2.default.bool,
  buttonText: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  autoClose: _propTypes2.default.number,
  openDelay: _propTypes2.default.number
};

MobileModal.defaultProps = {
  open: false,
  openDelay: 0,
  autoClose: null
};

exports.default = MobileModal;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fetchJsonp = __webpack_require__(97);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _urlParse = __webpack_require__(43);

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataService = {
  generateURL: function generateURL(uid, domain) {
    return 'https://' + domain + '/app/embed/' + uid + '?jsoncallback=?';
  },
  getFormData: function getFormData(uid, domain) {
    var url = this.generateURL(uid, domain);
    return (0, _fetchJsonp2.default)(url, { jsonpCallback: 'jsoncallback' }).then(function (res) {
      return res.json();
    });
  },
  getAccountFromURL: function getAccountFromURL(url) {
    return url.split('/')[2].split('.')[0];
  },
  getUidFromURL: function getUidFromURL(url) {
    var _UrlParse = (0, _urlParse2.default)(url, true),
        pathname = _UrlParse.pathname,
        query = _UrlParse.query;

    var path = pathname.replace(/\/$/, ''); // remove trailing slash
    var uid = path.replace(/\/to\/(.+)$/, '$1');

    if (uid === '/renderer') {
      return query.uid;
    }

    return uid;
  },
  getDomainFromUrl: function getDomainFromUrl(url) {
    return url.split('/')[2];
  },
  getDOMElementData: function getDOMElementData($element) {
    return {
      url: $element.data('url'),
      text: $element.data('text')
    };
  }
};

exports.default = DataService;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobileDetection = __webpack_require__(16);

var defaultData = {
  'account-name': 'admin',
  name: 'Typeform',
  'welcome-image': '',
  'font-google': '',
  'primary-color': '#222',
  'background-image': '',
  'background-color': '#DDD',
  'background-repeat': '',
  'background-brightness': '',
  'button-color': '#AAA'
};

var store = function store(uid, type, url, buttonText) {
  var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultData;

  return {
    isMobile: (0, _mobileDetection.isMobile)(navigator.userAgent),
    'account-name': data['account-name'] || 'admin',
    type: type,
    form: {
      uid: uid,
      url: url,
      ready: false, // not implemented
      buttonText: buttonText,
      name: data['name'] || '',
      'welcome-image': data['welcome-image'],
      'font-google': data['font-google'],
      'primary-color': data['primary-color'],
      'background-image': data['background-image'],
      'background-color': data['background-color'],
      'background-repeat': data['background-repeat'],
      'background-brightness': data['background-brightness'],
      'button-color': data['button-color']
    }
  };
};

exports.default = store;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var internalObjectKeys = __webpack_require__(50);
var enumBugKeys = __webpack_require__(32);

module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(7);
var toIndexedObject = __webpack_require__(18);
var arrayIndexOf = __webpack_require__(103)(false);
var hiddenKeys = __webpack_require__(31);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = nativeGetOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(5);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(13) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(36)('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20)('native-function-to-string', Function.toString);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(10);
var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var UNSCOPABLES = __webpack_require__(1)('unscopables');
var create = __webpack_require__(59);
var hide = __webpack_require__(8);
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  hide(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var defineProperties = __webpack_require__(114);
var enumBugKeys = __webpack_require__(32);
var html = __webpack_require__(60);
var documentCreateElement = __webpack_require__(36);
var IE_PROTO = __webpack_require__(38)('IE_PROTO');
var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

__webpack_require__(31)[IE_PROTO] = true;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;

module.exports = document && document.documentElement;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__(11);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var createIteratorConstructor = __webpack_require__(122);
var getPrototypeOf = __webpack_require__(64);
var setPrototypeOf = __webpack_require__(124);
var setToStringTag = __webpack_require__(40);
var hide = __webpack_require__(8);
var redefine = __webpack_require__(19);
var IS_PURE = __webpack_require__(21);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(15);
var IteratorsCore = __webpack_require__(63);
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          hide(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    hide(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(64);
var hide = __webpack_require__(8);
var has = __webpack_require__(7);
var IS_PURE = __webpack_require__(21);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(7);
var toObject = __webpack_require__(33);
var IE_PROTO = __webpack_require__(38)('IE_PROTO');
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(123);
var ObjectPrototype = Object.prototype;

module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(23);
var SPECIES = __webpack_require__(1)('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var classof = __webpack_require__(11);
var bind = __webpack_require__(39);
var html = __webpack_require__(60);
var createElement = __webpack_require__(36);
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var listener = function (event) {
  run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(bind(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(bind(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(bind(run, id, 1), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isObject = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(69);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(23);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(41);
var global = __webpack_require__(0);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFullScreen = exports.makeWidget = exports.makePopup = undefined;

var _makePopup = __webpack_require__(72);

var _makePopup2 = _interopRequireDefault(_makePopup);

var _makeWidget = __webpack_require__(98);

var _makeWidget2 = _interopRequireDefault(_makeWidget);

var _makeFullScreen = __webpack_require__(100);

var _makeFullScreen2 = _interopRequireDefault(_makeFullScreen);

__webpack_require__(101);

__webpack_require__(109);

__webpack_require__(115);

__webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.makePopup = _makePopup2.default;
exports.makeWidget = _makeWidget2.default;
exports.makeFullScreen = _makeFullScreen2.default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makePopup;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(2);

var _utils = __webpack_require__(9);

var _mobileDetection = __webpack_require__(16);

var _popup = __webpack_require__(44);

var _popup2 = _interopRequireDefault(_popup);

var _mobileModal = __webpack_require__(46);

var _mobileModal2 = _interopRequireDefault(_mobileModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_DRAWER_WIDTH = 800;

var defaultOptions = {
  mode: _popup.POPUP,
  autoOpen: false,
  isModalOpen: false,
  autoClose: _popup.DEFAULT_AUTOCLOSE_TIMEOUT,
  hideFooter: false,
  hideHeaders: false,
  hideScrollbars: false,
  disableTracking: false,
  drawerWidth: DEFAULT_DRAWER_WIDTH,
  onSubmit: _utils.noop
};

var queryStringKeys = {
  embedType: 'typeform-embed',
  hideFooter: 'embed-hide-footer',
  hideHeaders: 'embed-hide-headers',
  disableTracking: 'disable-tracking'
};

var renderComponent = function renderComponent(url, domNode, options, onClose) {
  var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));
  if (!(0, _mobileDetection.isMobile)(navigator.userAgent) && (0, _mobileDetection.isScreenBig)()) {
    (0, _reactDom.render)(_react2.default.createElement(_popup2.default, { onClose: onClose, options: options, url: urlWithQueryString }), domNode);
  } else {
    (0, _utils.ensureMetaViewport)();
    (0, _reactDom.render)(_react2.default.createElement(_mobileModal2.default, {
      autoClose: options.autoClose,
      buttonText: options.buttonText,
      isAutoCloseEnabled: options.isAutoCloseEnabled,
      onClose: onClose,
      onSubmit: options.onSubmit,
      open: true,
      url: urlWithQueryString
    }), domNode);
  }
};

function makePopup(url, options) {
  options = _extends({}, defaultOptions, options, {
    isAutoCloseEnabled: options.autoClose !== undefined,
    embedType: _popup.POPUP_MODES[options.mode]
  });

  if (!Number.isSafeInteger(options.drawerWidth)) {
    throw new Error('Whoops! You provided an invalid \'drawerWidth\' option: "' + options.drawerWidth + '". It must be a number.');
  }

  var domNode = document.createElement('div');
  options.isContained = options.container !== undefined;
  options.container = options.container || document.body;
  options.container.appendChild(domNode);

  var popup = {
    open: function open() {
      renderComponent(url, domNode, options, this.close);
    },
    close: function close() {
      window.postMessage('form-close', '*');
      (0, _reactDom.unmountComponentAtNode)(domNode);
    }
  };

  if (options.autoOpen) {
    popup.open();
  }

  return popup;
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.8.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(42);
var assign = __webpack_require__(76);

var ReactPropTypesSecret = __webpack_require__(24);
var checkPropTypes = __webpack_require__(77);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        if (getPropType(value) === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(24);
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(24);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return h; });
/* unused harmony export createElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cloneElement; });
/* unused harmony export createRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return render; });
/* unused harmony export rerender */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref != null) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* unused harmony default export */ var _unused_webpack_default_export = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 81 */
/***/ (function(module, exports) {


/**
 * Expose `isUrl`.
 */

module.exports = isUrl;

/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */

var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;

var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;

/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */

function isUrl(string){
  if (typeof string !== 'string') {
    return false;
  }

  var match = string.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }

  var everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }

  if (localhostDomainRE.test(everythingAfterProtocol) ||
      nonLocalhostDomainRE.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    if (key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(value));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.9.1
(function() {
  'use strict';
  var getScrollbarWidth, scrollbarWidth;

  scrollbarWidth = null;

  getScrollbarWidth = function(recalculate) {
    var div1, div2;
    if (recalculate == null) {
      recalculate = false;
    }
    if ((scrollbarWidth != null) && !recalculate) {
      return scrollbarWidth;
    }
    if (document.readyState === 'loading') {
      return null;
    }
    div1 = document.createElement('div');
    div2 = document.createElement('div');
    div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
    div1.style.overflow = 'scroll';
    div2.style.overflow = 'hidden';
    document.body.appendChild(div1);
    document.body.appendChild(div2);
    scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
    document.body.removeChild(div1);
    document.body.removeChild(div2);
    return scrollbarWidth;
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return getScrollbarWidth;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    module.exports = getScrollbarWidth;
  } else {
    this.getScrollbarWidth = getScrollbarWidth;
  }

}).call(this);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (process.env.NODE_ENV !== 'production') {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (process.env.NODE_ENV !== 'production') {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && process.env.NODE_ENV !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (process.env.NODE_ENV !== 'production') {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (process.env.NODE_ENV !== 'production') {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["default"] = (createEmotion);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__ = __webpack_require__(92);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var channel = '__EMOTION_THEMING__';

// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js

var _contextTypes;
var contextTypes = (_contextTypes = {}, _contextTypes[channel] = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object, _contextTypes);

function setTheme(theme) {
  this.setState({
    theme: theme
  });
}
var testPickPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_1__emotion_is_prop_valid__["a" /* default */];
var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};
var testAlwaysTrue = function testAlwaysTrue() {
  return true;
};
var pickAssign = function pickAssign(testFn, target) {
  var i = 2;
  var length = arguments.length;

  for (; i < length; i++) {
    var source = arguments[i];

    var _key = void 0;

    for (_key in source) {
      if (testFn(_key)) {
        target[_key] = source[_key];
      }
    }
  }

  return target;
};

var warnedAboutExtractStatic = false;

function createEmotionStyled(emotion, view) {
  var _createStyled = function createStyled(tag, options) {
    if (process.env.NODE_ENV !== 'production') {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var staticClassName;
    var identifierName;
    var stableClassName;
    var shouldForwardProp;

    if (options !== undefined) {
      staticClassName = options.e;
      identifierName = options.label;
      stableClassName = options.target;
      shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && // $FlowFixMe
        options.shouldForwardProp(propName);
      } : options.shouldForwardProp;
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;

    if (typeof shouldForwardProp !== 'function') {
      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
    }

    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (staticClassName === undefined) {
        if (args[0] == null || args[0].raw === undefined) {
          styles.push.apply(styles, args);
        } else {
          styles.push(args[0][0]);
          var len = args.length;
          var i = 1;

          for (; i < len; i++) {
            styles.push(args[i], args[0][i]);
          }
        }
      } else if (process.env.NODE_ENV !== 'production' && !warnedAboutExtractStatic) {
        console.warn('extractStatic is deprecated and will be removed in emotion@10. We recommend disabling extractStatic or using other libraries like linaria or css-literal-loader');
        warnedAboutExtractStatic = true;
      }

      var Styled =
      /*#__PURE__*/
      function (_view$Component) {
        _inheritsLoose(Styled, _view$Component);

        function Styled() {
          return _view$Component.apply(this, arguments) || this;
        }

        var _proto = Styled.prototype;

        _proto.componentWillMount = function componentWillMount() {
          if (this.context[channel] !== undefined) {
            this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
          }
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          if (this.unsubscribe !== undefined) {
            this.context[channel].unsubscribe(this.unsubscribe);
          }
        };

        _proto.render = function render() {
          var props = this.props,
              state = this.state;
          this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
            theme: state !== null && state.theme || props.theme || {}
          });
          var className = '';
          var classInterpolations = [];

          if (props.className) {
            if (staticClassName === undefined) {
              className += emotion.getRegisteredStyles(classInterpolations, props.className);
            } else {
              className += props.className + " ";
            }
          }

          if (staticClassName === undefined) {
            className += emotion.css.apply(this, styles.concat(classInterpolations));
          } else {
            className += staticClassName;
          }

          if (stableClassName !== undefined) {
            className += " " + stableClassName;
          }

          return view.createElement(baseTag, // $FlowFixMe
          pickAssign(shouldForwardProp, {}, props, {
            className: className,
            ref: props.innerRef
          }));
        };

        return Styled;
      }(view.Component);

      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";

      if (tag.defaultProps !== undefined) {
        // $FlowFixMe
        Styled.defaultProps = tag.defaultProps;
      }

      Styled.contextTypes = contextTypes;
      Styled.__emotion_styles = styles;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_real = Styled;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {
          if (process.env.NODE_ENV !== 'production' && stableClassName === undefined) {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe


          return "." + stableClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
      };

      return Styled;
    };
  };

  if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
    _createStyled = new Proxy(_createStyled, {
      get: function get(target, property) {
        switch (property) {
          // react-hot-loader tries to access this stuff
          case '__proto__':
          case 'name':
          case 'prototype':
          case 'displayName':
            {
              return target[property];
            }

          default:
            {
              throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
            }
        }
      }
    });
  }

  return _createStyled;
}

/* harmony default export */ __webpack_exports__["default"] = (createEmotionStyled);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(45);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spin = __webpack_require__(94);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultConfig = {
  lines: 16,
  length: 3,
  width: 3,
  radius: 14,
  color: '#FFFFFF',
  speed: 2.1,
  trail: 60,
  shadow: false,
  hwaccel: false,
  top: '50%',
  left: '50%',
  position: 'absolute',
  zIndex: 999
};

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.instantiateSpinner(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.config.color !== this.props.config.color) {
        this.spinner.stop();
        // the Spinner API doesn't provide a method to change its options after instantiation,
        // so the only way to do so is to reinstantiate the spinner ¯\_(ツ)_/¯
        this.instantiateSpinner(newProps);
      } else {
        if (newProps.stopped === true && !this.props.stopped) {
          this.spinner.stop();
        } else if (!newProps.stopped && this.props.stopped === true) {
          this.spinner.spin(this.container);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.spinner.stop();
    }
  }, {
    key: 'instantiateSpinner',
    value: function instantiateSpinner(props) {
      this.spinner = new _spin2.default(_extends({}, defaultConfig, props.config));
      if (!props.stopped) {
        this.spinner.spin(this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', { ref: function ref(node) {
          _this2.container = node;
        } });
    }
  }]);

  return Spinner;
}(_react.Component);

Spinner.propTypes = {
  config: _propTypes2.default.object,
  stopped: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

Spinner.defaultProps = {
  config: defaultConfig,
  className: '',
  style: {}
};

exports.default = Spinner;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright (c) 2011-2014 Felix Gnass
 * Licensed under the MIT license
 * http://spin.js.org/
 *
 * Example:
    var opts = {
      lines: 12             // The number of lines to draw
    , length: 7             // The length of each line
    , width: 5              // The line thickness
    , radius: 10            // The radius of the inner circle
    , scale: 1.0            // Scales overall size of the spinner
    , corners: 1            // Roundness (0..1)
    , color: '#000'         // #rgb or #rrggbb
    , opacity: 1/4          // Opacity of the lines
    , rotate: 0             // Rotation offset
    , direction: 1          // 1: clockwise, -1: counterclockwise
    , speed: 1              // Rounds per second
    , trail: 100            // Afterglow percentage
    , fps: 20               // Frames per second when using setTimeout()
    , zIndex: 2e9           // Use a high z-index by default
    , className: 'spinner'  // CSS class to assign to the element
    , top: '50%'            // center vertically
    , left: '50%'           // center horizontally
    , shadow: false         // Whether to render a shadow
    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
    , position: 'absolute'  // Element positioning
    }
    var target = document.getElementById('foo')
    var spinner = new Spinner(opts).spin(target)
 */
;(function (root, factory) {

  /* CommonJS */
  if (typeof module == 'object' && module.exports) module.exports = factory()

  /* AMD module */
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

  /* Browser global */
  else root.Spinner = factory()
}(this, function () {
  "use strict"

  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
    , animations = {} /* Animation rules keyed by their name */
    , useCssAnimations /* Whether to use CSS animations or setTimeout */
    , sheet /* A stylesheet to hold the @keyframe or VML rules. */

  /**
   * Utility function to create elements. If no tag name is given,
   * a DIV is created. Optionally properties can be passed.
   */
  function createEl (tag, prop) {
    var el = document.createElement(tag || 'div')
      , n

    for (n in prop) el[n] = prop[n]
    return el
  }

  /**
   * Appends children and returns the parent.
   */
  function ins (parent /* child1, child2, ...*/) {
    for (var i = 1, n = arguments.length; i < n; i++) {
      parent.appendChild(arguments[i])
    }

    return parent
  }

  /**
   * Creates an opacity keyframe animation rule and returns its name.
   * Since most mobile Webkits have timing issues with animation-delay,
   * we create separate rules for each line/segment.
   */
  function addAnimation (alpha, trail, i, lines) {
    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
      , start = 0.01 + i/lines * 100
      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
      , pre = prefix && '-' + prefix + '-' || ''

    if (!animations[name]) {
      sheet.insertRule(
        '@' + pre + 'keyframes ' + name + '{' +
        '0%{opacity:' + z + '}' +
        start + '%{opacity:' + alpha + '}' +
        (start+0.01) + '%{opacity:1}' +
        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
        '100%{opacity:' + z + '}' +
        '}', sheet.cssRules.length)

      animations[name] = 1
    }

    return name
  }

  /**
   * Tries various vendor prefixes and returns the first supported property.
   */
  function vendor (el, prop) {
    var s = el.style
      , pp
      , i

    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
    if (s[prop] !== undefined) return prop
    for (i = 0; i < prefixes.length; i++) {
      pp = prefixes[i]+prop
      if (s[pp] !== undefined) return pp
    }
  }

  /**
   * Sets multiple style properties at once.
   */
  function css (el, prop) {
    for (var n in prop) {
      el.style[vendor(el, n) || n] = prop[n]
    }

    return el
  }

  /**
   * Fills in default values.
   */
  function merge (obj) {
    for (var i = 1; i < arguments.length; i++) {
      var def = arguments[i]
      for (var n in def) {
        if (obj[n] === undefined) obj[n] = def[n]
      }
    }
    return obj
  }

  /**
   * Returns the line color from the given string or array.
   */
  function getColor (color, idx) {
    return typeof color == 'string' ? color : color[idx % color.length]
  }

  // Built-in defaults

  var defaults = {
    lines: 12             // The number of lines to draw
  , length: 7             // The length of each line
  , width: 5              // The line thickness
  , radius: 10            // The radius of the inner circle
  , scale: 1.0            // Scales overall size of the spinner
  , corners: 1            // Roundness (0..1)
  , color: '#000'         // #rgb or #rrggbb
  , opacity: 1/4          // Opacity of the lines
  , rotate: 0             // Rotation offset
  , direction: 1          // 1: clockwise, -1: counterclockwise
  , speed: 1              // Rounds per second
  , trail: 100            // Afterglow percentage
  , fps: 20               // Frames per second when using setTimeout()
  , zIndex: 2e9           // Use a high z-index by default
  , className: 'spinner'  // CSS class to assign to the element
  , top: '50%'            // center vertically
  , left: '50%'           // center horizontally
  , shadow: false         // Whether to render a shadow
  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
  , position: 'absolute'  // Element positioning
  }

  /** The constructor */
  function Spinner (o) {
    this.opts = merge(o || {}, Spinner.defaults, defaults)
  }

  // Global defaults that override the built-ins:
  Spinner.defaults = {}

  merge(Spinner.prototype, {
    /**
     * Adds the spinner to the given target element. If this instance is already
     * spinning, it is automatically removed from its previous target b calling
     * stop() internally.
     */
    spin: function (target) {
      this.stop()

      var self = this
        , o = self.opts
        , el = self.el = createEl(null, {className: o.className})

      css(el, {
        position: o.position
      , width: 0
      , zIndex: o.zIndex
      , left: o.left
      , top: o.top
      })

      if (target) {
        target.insertBefore(el, target.firstChild || null)
      }

      el.setAttribute('role', 'progressbar')
      self.lines(el, self.opts)

      if (!useCssAnimations) {
        // No CSS animation support, use setTimeout() instead
        var i = 0
          , start = (o.lines - 1) * (1 - o.direction) / 2
          , alpha
          , fps = o.fps
          , f = fps / o.speed
          , ostep = (1 - o.opacity) / (f * o.trail / 100)
          , astep = f / o.lines

        ;(function anim () {
          i++
          for (var j = 0; j < o.lines; j++) {
            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)

            self.opacity(el, j * o.direction + start, alpha, o)
          }
          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
        })()
      }
      return self
    }

    /**
     * Stops and removes the Spinner.
     */
  , stop: function () {
      var el = this.el
      if (el) {
        clearTimeout(this.timeout)
        if (el.parentNode) el.parentNode.removeChild(el)
        this.el = undefined
      }
      return this
    }

    /**
     * Internal method that draws the individual lines. Will be overwritten
     * in VML fallback mode below.
     */
  , lines: function (el, o) {
      var i = 0
        , start = (o.lines - 1) * (1 - o.direction) / 2
        , seg

      function fill (color, shadow) {
        return css(createEl(), {
          position: 'absolute'
        , width: o.scale * (o.length + o.width) + 'px'
        , height: o.scale * o.width + 'px'
        , background: color
        , boxShadow: shadow
        , transformOrigin: 'left'
        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
        })
      }

      for (; i < o.lines; i++) {
        seg = css(createEl(), {
          position: 'absolute'
        , top: 1 + ~(o.scale * o.width / 2) + 'px'
        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
        , opacity: o.opacity
        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
        })

        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
      }
      return el
    }

    /**
     * Internal method that adjusts the opacity of a single line.
     * Will be overwritten in VML fallback mode below.
     */
  , opacity: function (el, i, val) {
      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
    }

  })


  function initVML () {

    /* Utility function to create a VML tag */
    function vml (tag, attr) {
      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
    }

    // No CSS transforms but VML support, add a CSS rule for VML elements:
    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')

    Spinner.prototype.lines = function (el, o) {
      var r = o.scale * (o.length + o.width)
        , s = o.scale * 2 * r

      function grp () {
        return css(
          vml('group', {
            coordsize: s + ' ' + s
          , coordorigin: -r + ' ' + -r
          })
        , { width: s, height: s }
        )
      }

      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
        , i

      function seg (i, dx, filter) {
        ins(
          g
        , ins(
            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
          , ins(
              css(
                vml('roundrect', {arcsize: o.corners})
              , { width: r
                , height: o.scale * o.width
                , left: o.scale * o.radius
                , top: -o.scale * o.width >> 1
                , filter: filter
                }
              )
            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
            )
          )
        )
      }

      if (o.shadow)
        for (i = 1; i <= o.lines; i++) {
          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
        }

      for (i = 1; i <= o.lines; i++) seg(i)
      return ins(el, g)
    }

    Spinner.prototype.opacity = function (el, i, val, o) {
      var c = el.firstChild
      o = o.shadow && o.lines || 0
      if (c && i + o < c.childNodes.length) {
        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
        if (c) c.opacity = val
      }
    }
  }

  if (typeof document !== 'undefined') {
    sheet = (function () {
      var el = createEl('style', {type : 'text/css'})
      ins(document.getElementsByTagName('head')[0], el)
      return el.sheet || el.styleSheet
    }())

    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})

    if (!vendor(probe, 'transform') && probe.adj) initVML()
    else useCssAnimations = vendor(probe, 'animation')
  }

  return Spinner

}));


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEQARAIAAAODn7P///yH5BAEHAAEALAAAAAARABEAAAIqBIKpab3v3EMyVHWtWZluf0za0XFNKDJfCq5i5JpomdUxqKLQVmInqyoAADs="

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(17);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Root = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e1m9xwad0'
})('position:absolute;z-index:1001;top:0;right:0;font-size:20px;font-family:sans-serif;width:50px;height:50px;');

var closeArrow = /*#__PURE__*/(0, _styles.css)('border-radius:0;display:block;height:2px;width:25px;position:absolute;right:6px;top:6px;');

var ArrowLeft = /*#__PURE__*/(0, _styles2.default)('span', {
  target: 'e1m9xwad1'
})(closeArrow, ' background-color:', function (p) {
  return p.backgroundColor;
}, ';transform:translate(0,13px) rotate3d(0,0,1,-135deg);');

var ArrowRight = /*#__PURE__*/(0, _styles2.default)('span', {
  target: 'e1m9xwad2'
})(closeArrow, ' background-color:', function (p) {
  return p.backgroundColor;
}, ';transform:translate(0,13px) rotate3d(0,0,1,-45deg);');

var CloseIcon = function CloseIcon(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      dataQa = _ref.dataQa;
  return _react2.default.createElement(
    Root,
    { 'data-qa': dataQa, onClick: onClick },
    _react2.default.createElement(ArrowLeft, { backgroundColor: color }),
    _react2.default.createElement(ArrowRight, { backgroundColor: color })
  );
};

CloseIcon.propTypes = {
  color: _propTypes2.default.string,
  dataQa: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = CloseIcon;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeWidget;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(2);

var _utils = __webpack_require__(9);

var _mobileDetection = __webpack_require__(16);

var _widget = __webpack_require__(99);

var _widget2 = _interopRequireDefault(_widget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  mode: 'embed-widget',
  hideFooter: false,
  hideHeaders: false,
  hideScrollbars: false,
  disableTracking: false,
  onSubmit: _utils.noop
};

var queryStringKeys = {
  mode: 'typeform-embed',
  hideFooter: 'embed-hide-footer',
  hideHeaders: 'embed-hide-headers',
  opacity: 'embed-opacity',
  disableTracking: 'disable-tracking'
};

function makeWidget(element, url, options) {
  options = _extends({}, defaultOptions, options);

  var enabledFullscreen = (0, _mobileDetection.isMobile)(navigator.userAgent);

  var queryStrings = (0, _utils.replaceExistingKeys)(options, queryStringKeys);

  if (enabledFullscreen) {
    queryStrings = _extends({}, (0, _utils.omit)('embed-opacity', queryStrings), {
      'add-placeholder-ws': true
    });
  }

  var urlWithQueryString = (0, _utils.appendParamsToUrl)(url, queryStrings);

  var embedId = (0, _utils.randomString)();

  (0, _reactDom.render)(_react2.default.createElement(_widget2.default, {
    embedId: embedId,
    enabledFullscreen: enabledFullscreen,
    options: options,
    url: urlWithQueryString
  }), element);
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(17);

var _styles2 = _interopRequireDefault(_styles);

var _mobileModal = __webpack_require__(46);

var _mobileModal2 = _interopRequireDefault(_mobileModal);

var _utils = __webpack_require__(9);

var _iframe = __webpack_require__(26);

var _iframe2 = _interopRequireDefault(_iframe);

var _dataService = __webpack_require__(47);

var _dataService2 = _interopRequireDefault(_dataService);

var _store = __webpack_require__(48);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEBOUNCE_WAIT = 200;

var WidgetWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e12baen60'
})('height:100%;position:relative;');

var checkEmbedHash = function checkEmbedHash(embedId, event) {
  return event.detail && event.detail.embedId === embedId;
};

var PlaceholderAnimationAppear = /*#__PURE__*/(0, _styles.keyframes)('10%{opacity:1;}25%{top:0;left:0;width:100%;height:100%;opacity:1;}70%{top:0;left:0;width:100%;height:100%;opacity:1;}100%{top:0;left:0;width:100%;height:100%;opacity:0;}');

var PlaceholderAnimationDisappear = /*#__PURE__*/(0, _styles.keyframes)('100%{opacity:0;}75%{opacity:1;}25%{opacity:1;}0%{opacity:0;}');

var Placeholder = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e12baen61'
})('position:fixed;top:', function (props) {
  return props.top;
}, 'px;left:', function (props) {
  return props.left;
}, 'px;height:', function (props) {
  return props.height ? props.height + 'px' : '100%';
}, ';width:', function (props) {
  return props.width ? props.width + 'px' : '100%';
}, ';animation:', function (props) {
  return props.open ? PlaceholderAnimationAppear : PlaceholderAnimationDisappear;
}, ' 1.5s ease;visibility:', function (props) {
  return props.visible ? 'visible' : 'hidden';
}, ';background:', function (props) {
  return props.backgroundColor;
}, ';opacity:0;pointer-events:none;');

var IframeWrapper = /*#__PURE__*/(0, _styles2.default)('div', {
  target: 'e12baen62'
})('height:100%;width:100%;overflow:hidden;background:', function (props) {
  return props.backgroundColor;
}, ';');

var Widget = function (_Component) {
  _inherits(Widget, _Component);

  function Widget(props) {
    _classCallCheck(this, Widget);

    var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this, props));

    _this.state = {
      isFormReady: false,
      isIframeFocused: false,
      isFullscreen: false,
      closeIconColor: 'black',
      backgroundColor: 'transparent'
    };

    _this.onFormReady = _this.onFormReady.bind(_this);
    _this.focusIframe = _this.focusIframe.bind(_this);
    _this.onFormSubmit = _this.onFormSubmit.bind(_this);
    _this.goFullScreen = _this.goFullScreen.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.reloadIframe = _this.reloadIframe.bind(_this);
    _this.debouncedScroll = (0, _utils.debounce)(_this.focusIframe, DEBOUNCE_WAIT, _this);
    return _this;
  }

  _createClass(Widget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('message', _utils.onMessage);
      window.addEventListener('form-ready', this.onFormReady);
      window.addEventListener('scroll', this.debouncedScroll);
      window.addEventListener('form-submit', this.onFormSubmit);
      window.addEventListener('welcome-screen-hidden', this.goFullScreen);
      window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);

      var uid = _dataService2.default.getUidFromURL(this.props.url);

      _dataService2.default.getFormData(uid, _utils.DOMAIN).then(function (resp) {
        return (0, _store2.default)(uid, '', _this2.props.url, '', resp);
      }).then(function (data) {
        _this2.setState({
          closeIconColor: '#' + data.form['button-color'],
          backgroundColor: '#' + data.form['background-color']
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', _utils.onMessage);
      window.removeEventListener('form-ready', this.onFormReady);
      window.removeEventListener('scroll', this.debouncedScroll);
      window.removeEventListener('form-submit', this.onFormSubmit);
      window.removeEventListener('welcome-screen-hidden', this.goFullScreen);
      window.addEventListener('redirect-after-submit', _utils.redirectAfterSubmit);
    }
  }, {
    key: 'goFullScreen',
    value: function goFullScreen(event) {
      if (!checkEmbedHash(this.props.embedId, event)) {
        return;
      }

      if (this.props.enabledFullscreen) {
        this.setState({ isFullscreen: true });

        setTimeout(this.reloadIframe, 3000);
      }
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ isFullscreen: false });
    }
  }, {
    key: 'onFormReady',
    value: function onFormReady() {
      var _this3 = this;

      this.setState({
        isFormReady: true
      }, function () {
        _this3.focusIframe();
      });
    }
  }, {
    key: 'reloadIframe',
    value: function reloadIframe() {
      // Re-assign the source of the iframe, makes it reload cross-browser
      this.iframe.iframeRef.src = this.iframe.iframeRef.src;
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit() {
      var options = this.props.options;

      options.onSubmit && options.onSubmit();
    }
  }, {
    key: 'focusIframe',
    value: function focusIframe() {
      if (this.props.enabledFullscreen) return;

      var iframeRef = this.iframe.iframeRef;


      if (!iframeRef || !iframeRef.contentWindow) {
        return;
      }

      var isIframeInViewport = (0, _utils.isElementInViewport)(iframeRef);
      var canPostMessage = this.state.isFormReady && !this.state.isIframeFocused && isIframeInViewport && iframeRef.contentWindow != null;

      if (canPostMessage) {
        iframeRef.contentWindow.postMessage('embed-focus', '*');
        this.setState({
          isIframeFocused: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          isFullscreen = _state.isFullscreen,
          closeIconColor = _state.closeIconColor,
          backgroundColor = _state.backgroundColor,
          isFormReady = _state.isFormReady;
      var enabledFullscreen = this.props.enabledFullscreen;


      var iframePosition = this.iframe && this.iframe.iframeRef.getBoundingClientRect();

      var inlineIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-embed-id', this.props.embedId, this.props.url);

      if (enabledFullscreen) {
        inlineIframeUrl = (0, _utils.updateQueryStringParameter)('disable-tracking', 'true', inlineIframeUrl);
      }

      var fullscreenIframeUrl = (0, _utils.updateQueryStringParameter)('typeform-welcome', '0', this.props.url);

      return _react2.default.createElement(
        WidgetWrapper,
        null,
        _react2.default.createElement(
          IframeWrapper,
          {
            backgroundColor: enabledFullscreen ? backgroundColor : 'transparent'
          },
          _react2.default.createElement(_iframe2.default, {
            frameBorder: '0',
            height: '100%',
            ref: function ref(node) {
              _this4.iframe = node;
            },
            src: inlineIframeUrl,
            width: '100%'
          })
        ),
        enabledFullscreen && _react2.default.createElement(Placeholder, {
          backgroundColor: backgroundColor,
          bottom: iframePosition && iframePosition.bottom,
          height: iframePosition && iframePosition.height,
          left: iframePosition && iframePosition.left,
          open: isFullscreen,
          right: iframePosition && iframePosition.right,
          top: iframePosition && iframePosition.top,
          visible: isFormReady,
          width: iframePosition && iframePosition.width
        }),
        enabledFullscreen && _react2.default.createElement(_mobileModal2.default, {
          backgroundColor: backgroundColor,
          buttonColor: closeIconColor,
          onClose: this.handleClose,
          open: isFullscreen,
          openDelay: 0.3,
          url: fullscreenIframeUrl
        })
      );
    }
  }]);

  return Widget;
}(_react.Component);

Widget.propTypes = {
  url: _propTypes2.default.string,
  options: _propTypes2.default.object.isRequired,
  enabledFullscreen: _propTypes2.default.bool,
  embedId: _propTypes2.default.string
};

Widget.defaultProps = {
  options: {},
  enabledFullscreen: false
};

exports.default = Widget;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = makeFullScreen;

var _utils = __webpack_require__(9);

var defaultOptions = {
  mode: 'embed-fullpage',
  disableTracking: false,
  onSubmit: _utils.noop
};

var queryStringKeys = {
  mode: 'typeform-embed',
  disableTracking: 'disable-tracking'
};

function makeFullScreen(iframe, url, options) {
  options = _extends({}, defaultOptions, options);

  iframe.src = (0, _utils.appendParamsToUrl)(url, (0, _utils.replaceExistingKeys)(options, queryStringKeys));

  var onFormSubmit = function onFormSubmit() {
    options.onSubmit();
  };

  (0, _utils.ensureMetaViewport)();

  // Fix scroll inside the iframe (renderer v1)
  iframe.onload = function () {
    setTimeout(function () {
      iframe.style.height = '';
      (0, _utils.applyIOSFooterHack)(iframe);
      (0, _utils.applyIOSIframeResizeHack)(iframe);
    }, 1);

    iframe.contentWindow.focus();
  };

  window.addEventListener('message', _utils.onMessage);
  window.addEventListener('form-submit', onFormSubmit);
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var assign = __webpack_require__(102);

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
__webpack_require__(12)({ target: 'Object', stat: true, forced: Object.assign !== assign }, { assign: assign });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var objectKeys = __webpack_require__(49);
var getOwnPropertySymbolsModule = __webpack_require__(51);
var propertyIsEnumerableModule = __webpack_require__(52);
var toObject = __webpack_require__(33);
var IndexedObject = __webpack_require__(27);
var nativeAssign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !nativeAssign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (propertyIsEnumerable.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : nativeAssign;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(18);
var toLength = __webpack_require__(29);
var toAbsoluteIndex = __webpack_require__(104);

// `Array.prototype.{ indexOf, includes }` methods implementation
// false -> Array#indexOf
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
// true  -> Array#includes
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var nativeFunctionToString = __webpack_require__(55);
var WeakMap = __webpack_require__(0).WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(7);
var ownKeys = __webpack_require__(107);
var getOwnPropertyDescriptorModule = __webpack_require__(34);
var definePropertyModule = __webpack_require__(14);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var getOwnPropertyNamesModule = __webpack_require__(108);
var getOwnPropertySymbolsModule = __webpack_require__(51);
var anObject = __webpack_require__(6);
var Reflect = __webpack_require__(0).Reflect;

// all object keys, includes non-enumerable and symbols
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var internalObjectKeys = __webpack_require__(50);
var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalFind = __webpack_require__(110)(5);
var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
__webpack_require__(12)({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return internalFind(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
__webpack_require__(58)(FIND);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(39);
var IndexedObject = __webpack_require__(27);
var toObject = __webpack_require__(33);
var toLength = __webpack_require__(29);
var arraySpeciesCreate = __webpack_require__(111);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
// 0 -> Array#forEach
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
// 1 -> Array#map
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// 2 -> Array#filter
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// 3 -> Array#some
// https://tc39.github.io/ecma262/#sec-array.prototype.some
// 4 -> Array#every
// https://tc39.github.io/ecma262/#sec-array.prototype.every
// 5 -> Array#find
// https://tc39.github.io/ecma262/#sec-array.prototype.find
// 6 -> Array#findIndex
// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
module.exports = function (TYPE, specificCreate) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = specificCreate || arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: target.push(value);       // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var isArray = __webpack_require__(112);
var SPECIES = __webpack_require__(1)('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(11);

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// Chrome 38 Symbol has incorrect toString conversion
module.exports = !__webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var definePropertyModule = __webpack_require__(14);
var anObject = __webpack_require__(6);
var objectKeys = __webpack_require__(49);

module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) definePropertyModule.f(O, key = keys[i++], Properties[key]);
  return O;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var isInteger = __webpack_require__(116);
var abs = Math.abs;

// `Number.isSafeInteger` method
// https://tc39.github.io/ecma262/#sec-number.issafeinteger
__webpack_require__(12)({ target: 'Number', stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
  }
});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.github.io/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
__webpack_require__(120);
__webpack_require__(126);
__webpack_require__(129);
__webpack_require__(141);

module.exports = __webpack_require__(41).Promise;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(119);
var ObjectPrototype = Object.prototype;

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (toString !== ObjectPrototype.toString) {
  __webpack_require__(19)(ObjectPrototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(61);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = String(test) !== '[object z]' ? function toString() {
  return '[object ' + classof(this) + ']';
} : test.toString;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var codePointAt = __webpack_require__(121);
var InternalStateModule = __webpack_require__(22);
var defineIterator = __webpack_require__(62);
var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = codePointAt(string, index, true);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(30);
var requireObjectCoercible = __webpack_require__(28);
// CONVERT_TO_STRING: true  -> String#at
// CONVERT_TO_STRING: false -> String#codePointAt
module.exports = function (that, pos, CONVERT_TO_STRING) {
  var S = String(requireObjectCoercible(that));
  var position = toInteger(pos);
  var size = S.length;
  var first, second;
  if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
  first = S.charCodeAt(position);
  return first < 0xD800 || first > 0xDBFF || position + 1 === size
    || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
      ? CONVERT_TO_STRING ? S.charAt(position) : first
      : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(63).IteratorPrototype;
var create = __webpack_require__(59);
var createPropertyDescriptor = __webpack_require__(35);
var setToStringTag = __webpack_require__(40);
var Iterators = __webpack_require__(15);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(10)(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var validateSetPrototypeOfArguments = __webpack_require__(125);

module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var correctSetter = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    correctSetter = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    validateSetPrototypeOfArguments(O, proto);
    if (correctSetter) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var anObject = __webpack_require__(6);

module.exports = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) {
    throw TypeError("Can't set " + String(proto) + ' as a prototype');
  }
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var DOMIterables = __webpack_require__(127);
var ArrayIteratorMethods = __webpack_require__(128);
var global = __webpack_require__(0);
var hide = __webpack_require__(8);
var wellKnownSymbol = __webpack_require__(1);
var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      hide(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        hide(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(18);
var addToUnscopables = __webpack_require__(58);
var Iterators = __webpack_require__(15);
var InternalStateModule = __webpack_require__(22);
var defineIterator = __webpack_require__(62);
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PROMISE = 'Promise';
var IS_PURE = __webpack_require__(21);
var global = __webpack_require__(0);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(5);
var aFunction = __webpack_require__(23);
var anInstance = __webpack_require__(130);
var classof = __webpack_require__(11);
var iterate = __webpack_require__(131);
var checkCorrectnessOfIteration = __webpack_require__(135);
var speciesConstructor = __webpack_require__(65);
var task = __webpack_require__(66).set;
var microtask = __webpack_require__(136);
var promiseResolve = __webpack_require__(68);
var hostReportErrors = __webpack_require__(137);
var newPromiseCapabilityModule = __webpack_require__(69);
var perform = __webpack_require__(138);
var userAgent = __webpack_require__(67);
var SPECIES = __webpack_require__(1)('species');
var InternalStateModule = __webpack_require__(22);
var isForced = __webpack_require__(57);
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = global[PROMISE];
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = global.fetch;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper;

var FORCED = isForced(PROMISE, function () {
  // correct subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var empty = function () { /* empty */ };
  var FakePromise = (promise.constructor = {})[SPECIES] = function (exec) {
    exec(empty, empty);
  };
  // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !((IS_NODE || typeof PromiseRejectionEvent == 'function')
    && (!IS_PURE || promise['finally'])
    && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0
    && userAgent.indexOf('Chrome/66') === -1);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = __webpack_require__(139)(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  // wrap fetch result
  if (!IS_PURE && typeof $fetch == 'function') $export({ global: true, enumerable: true, forced: true }, {
    // eslint-disable-next-line no-unused-vars
    fetch: function fetch(input) {
      return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
    }
  });
}

$export({ global: true, wrap: true, forced: FORCED }, { Promise: PromiseConstructor });

__webpack_require__(40)(PromiseConstructor, PROMISE, false, true);
__webpack_require__(140)(PROMISE);

PromiseWrapper = __webpack_require__(41)[PROMISE];

// statics
$export({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$export({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$export({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      iterate(iterable, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isArrayIteratorMethod = __webpack_require__(132);
var toLength = __webpack_require__(29);
var bind = __webpack_require__(39);
var getIteratorMethod = __webpack_require__(133);
var callWithSafeIterationClosing = __webpack_require__(134);
var BREAK = {};

var exports = module.exports = function (iterable, fn, that, ENTRIES, ITERATOR) {
  var boundFunction = bind(fn, that, ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, step;

  if (ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
        if (result === BREAK) return BREAK;
      } return;
    }
    iterator = iterFn.call(iterable);
  }

  while (!(step = iterator.next()).done) {
    if (callWithSafeIterationClosing(iterator, boundFunction, step.value, ENTRIES) === BREAK) return BREAK;
  }
};

exports.BREAK = BREAK;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(15);
var ITERATOR = __webpack_require__(1)('iterator');
var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(61);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(15);

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(1)('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getOwnPropertyDescriptor = __webpack_require__(34).f;
var classof = __webpack_require__(11);
var macrotask = __webpack_require__(66).set;
var userAgent = __webpack_require__(67);
var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !/(iPhone|iPod|iPad).*AppleWebKit/i.test(userAgent)) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(19);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(70);
var definePropertyModule = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(13);
var SPECIES = __webpack_require__(1)('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var C = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;
  if (DESCRIPTORS && C && !C[SPECIES]) defineProperty(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(70);
var speciesConstructor = __webpack_require__(65);
var promiseResolve = __webpack_require__(68);

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
__webpack_require__(12)({ target: 'Promise', proto: true, real: true }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});


/***/ })
/******/ ]);

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_aria_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_aria_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_aria_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_rating_stars_component__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_rating_stars_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_rating_stars_component__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleForms=function(_Component){_inherits(GoogleForms,_Component);function GoogleForms(props){_classCallCheck(this,GoogleForms);var _this=_possibleConstructorReturn(this,(GoogleForms.__proto__||Object.getPrototypeOf(GoogleForms)).call(this,props));_this.getApplicationNode=function(){setTimeout(function(){var reactStars=document.querySelectorAll('[class^="react-stars-wrapper"] .react-stars');if(reactStars&&reactStars.length>0){Array.from(reactStars).forEach(function(reactStar){reactStar.setAttribute('aria-label','Adicione classificação digitando um número inteiro de 0 a 5 ou pressionando as teclas de seta');});}},300);return document.querySelector('#root');};_this.handleChangeRating=function(e){_this.setState({rating:e});};_this.handleChangeReason=function(e){_this.setState({reason:e.target.value});};_this.handleChangeOther=function(e){_this.setState({others:e.target.value});};_this.handleChangeComment=function(e){_this.setState({comments:e.target.value});};_this.onSubmitGoogleForms=function(){_this.setState({send:true});};_this.handlerCloseSuccess=function(){_this.setState({send:false});};_this.closeNPS=function(){_this.setState({showModal:false});};_this.state={rating:0,reason:'',others:'',comments:'',send:false,showModal:true};setTimeout(function(){_this.setState({showModal:_this.props.closeDonation});},1000);return _this;}_createClass(GoogleForms,[{key:'render',value:function render(){var _this2=this;return this.state.showModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_aria_modal___default.a,{titleText:'Como foi sua experi\xEAncia?',focusDialog:'true',getApplicationNode:this.getApplicationNode,underlayStyle:{zIndex:9999},dialogStyle:{maxWidth:'650px'},onExit:function onExit(){return _this2.closeNPS();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid container-nps py-0','data-campaign':"80938"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-absolute zindex-high r-1 r-md-3 t-1 t-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'button',href:'javascript:void(0)','aria-label':'Fechar',onClick:this.closeNPS,className:'txt-subtitle txt-font-body d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-1 cursor icon-md'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-3 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 mx-auto py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Queremos sua opini\xE3o.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-rating nps col-12'},this.state.send&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Alert"],{isSuccess:true,title:'Avaliação enviada com sucesso!',description:'Sua experiência é muito importante para nós.',className:'pb-2',onClose:this.handlerCloseSuccess}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body mb-1'},'Avalie sua experi\xEAncia de resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 store-rating modal-rating-stars mx-0 px-1 '+(this.state.rating&&'rating-empty')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_rating_stars_component___default.a,{count:5,onChange:this.handleChangeRating,size:36,activeColor:'#ffd700',emptyIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_star'}),filledIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_rating color-brand-1'})}))))),this.state.rating>0&&this.state.rating<5&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body mb-1'},'Queremos entender um pouco mais, conta pra gente se algum desses motivos s\xE3o a raz\xE3o desta nota:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["RadioButton"],{id:'atraso',name:'motivo',value:'Atraso na entrega do resgate',label:'Atraso na entrega do resgate',className:'col-12',labelClass:'l-1',outerLabel:false,role:'radio',onClick:function onClick(e){return _this2.handleChangeReason(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["RadioButton"],{id:'quantidade',name:'motivo',value:'Quantidade de produtos dispon\xEDveis para resgate',label:'Quantidade de produtos dispon\xEDveis para resgate',className:'col-12',labelClass:'l-1',outerLabel:false,role:'radio',onClick:function onClick(e){return _this2.handleChangeReason(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["RadioButton"],{id:'lentidao',name:'motivo',label:'Lentid\xE3o no site',value:'Lentid\xE3o no site',className:'col-12',labelClass:'l-1',outerLabel:false,role:'radio',onClick:function onClick(e){return _this2.handleChangeReason(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["RadioButton"],{id:'outros',name:'motivo',value:'Outros',label:'Outros',className:'col-12',labelClass:'l-1',outerLabel:false,role:'radio',onClick:function onClick(e){return _this2.handleChangeReason(e);}})))))),this.state.reason==='Outros'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body mb-1'},'Qual o motivo?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'nps-outros',name:'outro',label:'Outros',className:'col-12',onChange:function onChange(e){return _this2.handleChangeOther(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body mb-1'},'Deixe um coment\xE1rio sobre sua experi\xEAncia de resgate.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'nps-comentario',name:'comentario',label:'Coment\xE1rio',className:'col-12',onChange:function onChange(e){return _this2.handleChangeComment(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{name:'hidden_iframe',id:'hidden_iframe',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'https://docs.google.com/forms/d/e/1FAIpQLSfGon9c5NOr6SeDEJyu73dFkePZM5-KxKtkyKpvcFmqshMDkg/formResponse',method:'post',target:'hidden_iframe'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.343519078',type:'hidden',value:this.state.rating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.452954092',type:'hidden',value:this.state.reason}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.1470350034',type:'hidden',value:this.state.comments}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.185601226',type:'hidden',value:this.state.others}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.252273565',type:'hidden',value:this.props.profile&&this.props.profile['custom:campaign_id']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.1164317006',type:'hidden',value:this.props.profile&&this.props.profile['custom:catalog_id']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'entry.419888676',type:'hidden',value:this.props.profile&&this.props.profile['custom:client_id']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'Enviar',className:'btn btn-nps-send btn-featured mx-auto',onClick:this.onSubmitGoogleForms}))))))):'';}}]);return GoogleForms;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GoogleForms.propTypes={profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({'custom:campaign_id':__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,'custom:catalog_id':__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,'custom:client_id':__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}),closeDonation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref){var user=_ref.oidc.user;return{profile:user&&user.profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(GoogleForms));

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useConfig3 = __webpack_require__(1624);

var _useConfig4 = _interopRequireDefault(_useConfig3);

var _star = __webpack_require__(1625);

var _star2 = _interopRequireDefault(_star);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parentStyles = {
    overflow: "hidden",
    position: "relative"
};

function getHalfStarStyles(color, uniqueness) {
    return '\n    .react-stars-' + uniqueness + ':before {\n      position: absolute;\n      overflow: hidden;\n      display: block;\n      z-index: 1;\n      top: 0; left: 0;\n      width: 50%;\n      content: attr(data-forhalf);\n      color: ' + color + ';\n  }';
}

function getHalfStarStyleForIcons(color) {
    return '\n          span.react-stars-half > * {\n          color: ' + color + ';\n      }';
};

function ReactStars(props) {
    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        uniqueness = _useState2[0],
        setUniqueness = _useState2[1];

    var _useState3 = (0, _react.useState)(0),
        _useState4 = _slicedToArray(_useState3, 2),
        currentValue = _useState4[0],
        setCurrentValue = _useState4[1];

    var _useState5 = (0, _react.useState)([]),
        _useState6 = _slicedToArray(_useState5, 2),
        stars = _useState6[0],
        setStars = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isUsingIcons = _useState8[0],
        setIsUsingIcons = _useState8[1];

    var _useConfig = (0, _useConfig4.default)(props),
        _useConfig2 = _slicedToArray(_useConfig, 2),
        config = _useConfig2[0],
        setConfig = _useConfig2[1];

    var _useState9 = (0, _react.useState)(0),
        _useState10 = _slicedToArray(_useState9, 2),
        halfStarAt = _useState10[0],
        setHalfStarAt = _useState10[1];

    var _useState11 = (0, _react.useState)(false),
        _useState12 = _slicedToArray(_useState11, 2),
        halfStarHidden = _useState12[0],
        setHalfStarHidden = _useState12[1];

    var _useState13 = (0, _react.useState)(''),
        _useState14 = _slicedToArray(_useState13, 2),
        classNames = _useState14[0],
        setClassNames = _useState14[1];

    function iconsUsed(config) {
        return !config.isHalf && config.emptyIcon && config.filledIcon || config.isHalf && config.emptyIcon && config.halfIcon && config.filledIcon;
    }

    function createUniqueness() {
        setUniqueness((Math.random() + "").replace(".", ""));
    }

    (0, _react.useEffect)(function () {
        addClassNames();
        validateInitialValue(props.value, props.count);
        setStars(getStars(props.value));
        setConfig(props);
        createUniqueness();
        setIsUsingIcons(iconsUsed(props));
        setHalfStarAt(Math.floor(props.value));
        setHalfStarHidden(props.isHalf && props.value % 1 < 0.5);
    }, []);

    function validateInitialValue(value, count) {
        if (value < 0 || value > count) {
            setCurrentValue(0);
        } else {
            setCurrentValue(value);
        }
    }

    function addClassNames() {
        var reactStarsClass = 'react-stars';
        setClassNames(props.classNames + (' ' + reactStarsClass));
    }

    function isDecimal(value) {
        return value % 1 === 0;
    }

    function getRate() {
        return config.isHalf ? Math.floor(currentValue) : Math.round(currentValue);
    }

    function getStars(activeCount) {
        if (typeof activeCount === 'undefined') {
            activeCount = getRate();
        }

        var stars = [];
        for (var i = 0; i < config.count; i++) {
            stars.push({
                active: i <= activeCount - 1
            });
        }
        return stars;
    }

    function mouseOver(event) {
        if (!config.edit) return;

        var index = Number(event.currentTarget.getAttribute('data-index'));

        if (config.isHalf) {
            var isAtHalf = moreThanHalf(event);
            setHalfStarHidden(isAtHalf);
            if (isAtHalf) index += 1;
            setHalfStarAt(index);
        } else {
            index += 1;
        }

        updateStars(index);
    }

    function updateStars(index) {
        var currentActive = stars.filter(function (x) {
            return x.active;
        });
        if (index !== currentActive.length) {
            setStars(getStars(index));
        }
    }

    function moreThanHalf(event) {
        var target = event.target;

        var boundingClientRect = target.getBoundingClientRect();
        var mouseAt = event.clientX - boundingClientRect.left;
        mouseAt = Math.round(Math.abs(mouseAt));

        return mouseAt > boundingClientRect.width / 2;
    }

    function mouseLeave() {
        if (!config.edit) return;

        updateHalfStarValues(currentValue);
        setStars(getStars());
    }

    function updateHalfStarValues(value) {
        if (config.isHalf) {
            setHalfStarHidden(isDecimal(value));
            setHalfStarAt(Math.floor(value));
        }
    }

    function onClick(event) {
        if (!config.edit) return;

        var index = Number(event.currentTarget.getAttribute('data-index'));
        var value = void 0;
        if (config.isHalf) {
            var isAtHalf = moreThanHalf(event);
            setHalfStarHidden(isAtHalf);
            if (isAtHalf) index += 1;
            value = isAtHalf ? index : index + 0.5;
            setHalfStarAt(index);
        } else {
            value = index = index + 1;
        }

        currentValueUpdated(value);
    }

    function renderHalfStarStyleElement() {
        return _react2.default.createElement('style', { dangerouslySetInnerHTML: {
                __html: isUsingIcons ? getHalfStarStyleForIcons(config.activeColor) : getHalfStarStyles(config.activeColor, uniqueness)
            } });
    }

    function currentValueUpdated(value) {
        if (value !== currentValue) {
            setStars(getStars(value));
            setCurrentValue(value);
            props.onChange(value);
        }
    }

    function handleKeyDown(event) {
        if (!config.a11y && !config.edit) return;

        var key = event.key;

        var value = currentValue;

        var keyNumber = Number(key); // e.g. "1" => 1, "ArrowUp" => NaN
        if (keyNumber) {
            if (Number.isInteger(keyNumber) && keyNumber > 0 && keyNumber <= config.count) {
                value = keyNumber;
            }
        } else {
            if ((key === "ArrowUp" || key === "ArrowRight") && value < config.count) {
                event.preventDefault();

                value += config.isHalf ? 0.5 : 1;
            } else if ((key === "ArrowDown" || key === "ArrowLeft") && value > 0.5) {
                event.preventDefault();
                value -= config.isHalf ? 0.5 : 1;
            }
        }

        updateHalfStarValues(value);

        currentValueUpdated(value);
    }

    function renderStars() {
        return stars.map(function (star, i) {
            return _react2.default.createElement(_star2.default, {
                key: i,
                index: i,
                active: star.active,
                config: config,
                onMouseOver: mouseOver,
                onMouseLeave: mouseLeave,
                onClick: onClick,
                halfStarHidden: halfStarHidden,
                halfStarAt: halfStarAt,
                isUsingIcons: isUsingIcons,
                uniqueness: uniqueness
            });
        });
    }

    return _react2.default.createElement(
        'div',
        { className: 'react-stars-wrapper-' + uniqueness,
            style: { display: 'flex' } },
        _react2.default.createElement(
            'div',
            { tabIndex: config.a11y && config.edit ? 0 : null,
                'aria-label': 'add rating by typing an integer from 0 to 5 or pressing arrow keys',
                onKeyDown: handleKeyDown,
                className: classNames,
                style: parentStyles },
            config.isHalf && renderHalfStarStyleElement(),
            renderStars(),
            _react2.default.createElement(
                'p',
                { style: { position: 'absolute', left: '-200rem' }, role: 'status' },
                currentValue
            )
        )
    );
}

ReactStars.propTypes = {
    classNames: _propTypes2.default.string,
    edit: _propTypes2.default.bool,
    half: _propTypes2.default.bool,
    value: _propTypes2.default.number,
    count: _propTypes2.default.number,
    char: _propTypes2.default.string,
    size: _propTypes2.default.number,
    color: _propTypes2.default.string,
    activeColor: _propTypes2.default.string,
    emptyIcon: _propTypes2.default.element,
    halfIcon: _propTypes2.default.element,
    filledIcon: _propTypes2.default.element,
    a11y: _propTypes2.default.bool
};

ReactStars.defaultProps = {
    edit: true,
    half: false,
    value: 0,
    count: 5,
    char: '★',
    size: 15,
    color: 'gray',
    activeColor: '#ffd700',
    a11y: true,

    onChange: function onChange() {}
};

exports.default = ReactStars;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = useConfig;

var _react = __webpack_require__(0);

function useConfig(config) {
    var _useState = (0, _react.useState)(config.count),
        _useState2 = _slicedToArray(_useState, 2),
        count = _useState2[0],
        setCount = _useState2[1];

    var _useState3 = (0, _react.useState)(config.size),
        _useState4 = _slicedToArray(_useState3, 2),
        size = _useState4[0],
        setSize = _useState4[1];

    var _useState5 = (0, _react.useState)(config.char),
        _useState6 = _slicedToArray(_useState5, 2),
        char = _useState6[0],
        setChar = _useState6[1];

    var _useState7 = (0, _react.useState)(config.color),
        _useState8 = _slicedToArray(_useState7, 2),
        color = _useState8[0],
        setColor = _useState8[1];

    var _useState9 = (0, _react.useState)(config.activeColor),
        _useState10 = _slicedToArray(_useState9, 2),
        activeColor = _useState10[0],
        setActiveColor = _useState10[1];

    var _useState11 = (0, _react.useState)(config.isHalf),
        _useState12 = _slicedToArray(_useState11, 2),
        isHalf = _useState12[0],
        setIsHalf = _useState12[1];

    var _useState13 = (0, _react.useState)(config.edit),
        _useState14 = _slicedToArray(_useState13, 2),
        edit = _useState14[0],
        setEdit = _useState14[1];

    var _useState15 = (0, _react.useState)(config.emptyIcon),
        _useState16 = _slicedToArray(_useState15, 2),
        emptyIcon = _useState16[0],
        setEmptyIcon = _useState16[1];

    var _useState17 = (0, _react.useState)(config.halfIcon),
        _useState18 = _slicedToArray(_useState17, 2),
        halfIcon = _useState18[0],
        setHalfIcon = _useState18[1];

    var _useState19 = (0, _react.useState)(config.filledIcon),
        _useState20 = _slicedToArray(_useState19, 2),
        filledIcon = _useState20[0],
        setFilledIcon = _useState20[1];

    var _useState21 = (0, _react.useState)(config.a11y),
        _useState22 = _slicedToArray(_useState21, 2),
        a11y = _useState22[0],
        setA11y = _useState22[1];

    var configObj = {
        count: count,
        size: size,
        char: char,
        color: color,
        activeColor: activeColor,
        isHalf: isHalf,
        edit: edit,
        emptyIcon: emptyIcon,
        halfIcon: halfIcon,
        filledIcon: filledIcon,
        a11y: a11y
    };

    function setConfig(config) {
        setCount(config.count);
        setSize(config.size);
        setChar(config.char);
        setColor(config.color);
        setActiveColor(config.activeColor);
        setIsHalf(config.isHalf);
        setEdit(config.edit);
        setEmptyIcon(config.emptyIcon);
        setHalfIcon(config.halfIcon);
        setFilledIcon(config.filledIcon);
        setA11y(config.a11y);
    }

    return [configObj, setConfig];
}

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Star;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = {
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    display: "block",
    float: "left"
};

function Star(props) {
    var index = props.index,
        active = props.active,
        config = props.config,
        onMouseOver = props.onMouseOver,
        onMouseLeave = props.onMouseLeave,
        onClick = props.onClick,
        halfStarHidden = props.halfStarHidden,
        halfStarAt = props.halfStarAt,
        isUsingIcons = props.isUsingIcons,
        uniqueness = props.uniqueness;
    var color = config.color,
        activeColor = config.activeColor,
        size = config.size,
        char = config.char,
        isHalf = config.isHalf,
        edit = config.edit,
        halfIcon = config.halfIcon,
        emptyIcon = config.emptyIcon,
        filledIcon = config.filledIcon;


    var starClass = '';
    var half = false;

    if (isHalf && !halfStarHidden && halfStarAt === index) {
        if (!isUsingIcons) starClass = "react-stars-" + uniqueness;else starClass = 'react-stars-half';
        half = true;
    }

    var style = _extends({}, defaultStyles, {
        color: active ? activeColor : color,
        cursor: edit ? 'pointer' : 'default',
        fontSize: size + "px"
    });

    function renderIcon() {
        if (!isUsingIcons) {
            return char;
        } else {
            if (active) {
                return filledIcon;
            } else if (!active && half) {
                return halfIcon;
            } else {
                return emptyIcon;
            }
        }
    }

    return _react2.default.createElement(
        "span",
        {
            className: starClass,
            style: style,
            key: index,
            "data-index": index,
            "data-forhalf": filledIcon ? index : char,
            onMouseOver: onMouseOver,
            onMouseMove: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick },
        renderIcon()
    );
}

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REDIRECT_ROUTE_PAGE_404 */
var REDIRECT_ROUTE_PAGE_404='/404';/* harmony default export */ __webpack_exports__["a"] = ({REDIRECT_ROUTE_PAGE_404:REDIRECT_ROUTE_PAGE_404});

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var innitialState={};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:innitialState;var action=arguments[1];switch(action.type){case'GET_ORDER_CONFIRMATION':return innitialState;case'GET_ORDER_CONFIRMATION_SUCCESS':return Object.assign({},action.payload.data);case'GET_ORDER_CONFIRMATION_FAIL':var errorMessage='';return Object.assign({},innitialState,{notFound:action.error.request.status===404,errorMessage:action.data&&action.data.errors&&action.data.errors.length>0&&(action.data.errors.map(function(item,index){return errorMessage+=item.message;})||errorMessage)});default:return state||innitialState;}});

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmationMobileRechargeSchedule__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1635);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref,ownProps){var confirmationMobileRechargeSchedule=_ref.confirmationMobileRechargeSchedule;return{scheduleRecharge:confirmationMobileRechargeSchedule,scheduleId:ownProps.match.params.scheduleId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectNotFoundPage:function redirectNotFoundPage(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].REDIRECT_ROUTE_PAGE_404));},getScheduleRecharge:function getScheduleRecharge(scheduleId){dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].getScheduleRecharge(scheduleId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ConfirmationMobileRechargeSchedule__["a" /* default */]));

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getScheduleRecharge */
var getScheduleRecharge=function getScheduleRecharge(scheduleId){return{type:'GET_SCHEDULE_RECHARGE',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/myschedules/'+scheduleId}}};};/* harmony default export */ __webpack_exports__["a"] = ({getScheduleRecharge:getScheduleRecharge});

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MobileRechargeScheduleItem__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AboutMobileRechargeSchedule__ = __webpack_require__(1632);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmationMobileRechargeSchedule=function(_Component){_inherits(ConfirmationMobileRechargeSchedule,_Component);function ConfirmationMobileRechargeSchedule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmationMobileRechargeSchedule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmationMobileRechargeSchedule.__proto__||Object.getPrototypeOf(ConfirmationMobileRechargeSchedule)).call.apply(_ref,[this].concat(args))),_this),_this.state={supplierName:''},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmationMobileRechargeSchedule,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.scheduleRecharge.vendorId){var name=this.props.stores.filter(function(ele){return ele.supplierId===_this2.props.scheduleRecharge.vendorId;}).length>0?this.props.stores.filter(function(ele){return ele.supplierId===_this2.props.scheduleRecharge.vendorId;})[0].name:'';this.setState({supplierName:name});}if(this.props.scheduleId){this.props.getScheduleRecharge(this.props.scheduleId);}}},{key:'render',value:function render(){if(!this.props.scheduleRecharge||this.props.scheduleRecharge.notFount){this.props.redirectNotFoundPage();}var firstServiceItem=this.props.scheduleRecharge.serviceItem&&this.props.scheduleRecharge.serviceItem.length>0&&this.props.scheduleRecharge.serviceItem[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container py-5 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:false,title:'Parab\xE9ns! Seu resgate foi conclu\xEDdo com sucesso.',description:'Veja abaixo o resumo do seu pedido.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-8 pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body txt-uppercase txt-body'},'Resumo do pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MobileRechargeScheduleItem__["a" /* default */],{name:'Recarga Pr\xE9-pago '+this.props.scheduleRecharge.operator+' '+this.props.scheduleRecharge.ddd+' - R$'+(firstServiceItem&&firstServiceItem.value),vendorName:this.state.supplierName,areaCode:this.props.scheduleRecharge.ddd,phoneNumber:this.props.scheduleRecharge.phone,vendorId:this.props.scheduleRecharge.vendorId,initialScheduleDate:this.props.scheduleRecharge.firstSchedule,finalScheduleDate:this.props.scheduleRecharge.lastSchedule})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AboutMobileRechargeSchedule__["a" /* AboutMobileRechargeSchedule */],{dateCreatedScheduling:this.props.scheduleRecharge.dateCreatedScheduling,operator:this.props.scheduleRecharge.operator,phoneNumber:this.props.scheduleRecharge.phone,creditValue:firstServiceItem&&firstServiceItem.value,pointValue:firstServiceItem&&firstServiceItem.pointValue})));}}]);return ConfirmationMobileRechargeSchedule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref2){var stores=_ref2.stores;return{stores:stores.services};};ConfirmationMobileRechargeSchedule.propTypes={scheduleRecharge:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,redirectNotFoundPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,scheduleId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,getScheduleRecharge:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,stores:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(ConfirmationMobileRechargeSchedule));

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductImage__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var MobileRechargeScheduleItem=function MobileRechargeScheduleItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductImage__["a" /* ProductImage */],{imageUrl:'',alt:props.name,vendorId:props.vendorId,ready:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-number col-12 mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-body'},'Resgate recorrente agendado')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},props.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item  mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Ser\xE1 creditado em:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.areaCode,' ',props.phoneNumber,' agendado de',' ',__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.initialScheduleDate).utc().format('DD/MM/YYYY'),' ','at\xE9',' ',__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.finalScheduleDate).utc().format('DD/MM/YYYY'),' ')),props.vendorName&&props.vendorName!=='Compra de Pontos'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.vendorName)):'')))));};MobileRechargeScheduleItem.propTypes={name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,areaCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,initialScheduleDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),finalScheduleDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date))};/* harmony default export */ __webpack_exports__["a"] = (MobileRechargeScheduleItem);

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AboutMobileRechargeSchedule__ = __webpack_require__(1633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AboutMobileRechargeSchedule__["a"]; });


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__About__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileRechargeScheduleInfo__ = __webpack_require__(1634);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var AboutMobileRechargeSchedule=function AboutMobileRechargeSchedule(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__About__["a" /* About */],{title:'Sobre o pedido'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MobileRechargeScheduleInfo__["a" /* default */],{dateCreatedScheduling:props.dateCreatedScheduling,operator:props.operator,phoneNumber:props.phoneNumber,creditValue:props.creditValue,pointValue:props.pointValue}));};AboutMobileRechargeSchedule.propTypes={dateCreatedScheduling:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),operator:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.phoneNumber,pointValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.phoneNumber};/* harmony default export */ __webpack_exports__["a"] = (AboutMobileRechargeSchedule);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var MobileRechargeScheduleInfo=function MobileRechargeScheduleInfo(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Resgate agendado em:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.dateCreatedScheduling).format('DD/MM/YYYY [às] HH[h]MM'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'operadora: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.operator)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Telefone: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.phoneNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor de cr\xE9ditos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$',props.creditValue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor em pontos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.pointValue})))));};MobileRechargeScheduleInfo.propTypes={dateCreatedScheduling:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),operator:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,phoneNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.phoneNumber,pointValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.phoneNumber};/* harmony default export */ __webpack_exports__["a"] = (MobileRechargeScheduleInfo);

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REDIRECT_ROUTE_PAGE_404 */
var REDIRECT_ROUTE_PAGE_404='';/* harmony default export */ __webpack_exports__["a"] = ({REDIRECT_ROUTE_PAGE_404:REDIRECT_ROUTE_PAGE_404});

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var innitialState={};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:innitialState;var action=arguments[1];switch(action.type){case'GET_SCHEDULE_RECHARGE':return innitialState;case'GET_SCHEDULE_RECHARGE_SUCCESS':return Object.assign({},action.payload.data);case'GET_SCHEDULE_RECHARGE_FAIL':var errorMessage='';return Object.assign({},innitialState,{notFount:action.error.request.status===401,errorMessage:action.data&&action.data.errors&&action.data.errors.length>0&&(action.data.errors.map(function(item,index){return errorMessage+=item.message;})||errorMessage)});default:return state||innitialState;}});

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getScheduledOrders */
/* unused harmony export editServiceItem */
/* unused harmony export newServiceItem */
/* unused harmony export updateScheduleOrder */
/* unused harmony export cancelServiceItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_features_CellphoneRecharge__ = __webpack_require__(101);
var LIMIT_SCHEDULED_ORDERS=30;var getScheduledOrders=function getScheduledOrders(date){return{type:'GET_SCHEDULED_ORDERS',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/myschedules/limit/'+LIMIT_SCHEDULED_ORDERS}},date:date};};var editServiceItem=function editServiceItem(item){return{type:'EDIT_SERVICE_ITEM',item:item};};var newServiceItem=function newServiceItem(){return{type:'NEW_SERVICE_ITEM'};};var updateScheduleOrder=function updateScheduleOrder(client){return function(scheduleOrder){return function(dispatch,_){dispatch({type:'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER'});client.put('/v3/myschedules',scheduleOrder).then(function(response){if(response.status===200){dispatch({type:'CLEAR_SERVICE_ITEM'});dispatch({type:'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER_END'});dispatch({type:'GET_SCHEDULED_ORDERS_ORDERS'});}}).catch(function(error){dispatch({type:'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER_END'});var message=__WEBPACK_IMPORTED_MODULE_0_features_CellphoneRecharge__["c" /* actions */].handleErrorMessage(error.response.data);dispatch(__WEBPACK_IMPORTED_MODULE_0_features_CellphoneRecharge__["c" /* actions */].showErrorMessage(message));});};};};var cancelServiceItem=function cancelServiceItem(serviceItem){return{type:'CANCEL_SERVICE_ITEM',payload:{client:'cloudloyalty',request:{method:'PUT',url:'/v1/myschedules/cancel-schedules',data:serviceItem}}};};/* harmony default export */ __webpack_exports__["a"] = (function(client){return{getScheduledOrders:getScheduledOrders,editServiceItem:editServiceItem,newServiceItem:newServiceItem,updateScheduleOrder:updateScheduleOrder(client),cancelServiceItem:cancelServiceItem};});

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Scheduling__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_CellphoneRecharge__ = __webpack_require__(101);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref){var _ref$scheduling=_ref.scheduling,scheduledOrders=_ref$scheduling.scheduledOrders,scheduledOrder=_ref$scheduling.scheduledOrder,nextOrders=_ref$scheduling.nextOrders,participantSchedulesModel=_ref$scheduling.participantSchedulesModel,indexServiceItem=_ref$scheduling.indexServiceItem,isLoadingUpdate=_ref$scheduling.isLoadingUpdate,isLoadingInsert=_ref$scheduling.isLoadingInsert,loadingScheduleOrder=_ref.cellphoneRecharge.loadingScheduleOrder;return{scheduledOrders:scheduledOrders,scheduledOrder:scheduledOrder,nextOrders:nextOrders,participantSchedulesModel:participantSchedulesModel,indexServiceItem:indexServiceItem,isLoadingUpdate:isLoadingUpdate,isLoadingInsert:loadingScheduleOrder};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getScheduledOrders:function getScheduledOrders(date){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].getScheduledOrders(date));},editServiceItem:function editServiceItem(item){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].editServiceItem(item));},deleteServiceItem:function deleteServiceItem(index){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].deleteServiceItem(index));},newServiceItem:function newServiceItem(){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].newServiceItem());},updateScheduleOrder:function updateScheduleOrder(scheduleOrder){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].updateScheduleOrder(scheduleOrder));},cancelServiceItem:function cancelServiceItem(scheduleOrder){return dispatch(__WEBPACK_IMPORTED_MODULE_2____["b" /* actions */].cancelServiceItem(scheduleOrder));},insertScheduleOrder:function insertScheduleOrder(serviceId,operatorKey,areaCode,phone,initialScheduleDate,endScheduleDate,creditValue,pointValue){return dispatch(__WEBPACK_IMPORTED_MODULE_4_features_CellphoneRecharge__["c" /* actions */].scheduleMobileRecharges(serviceId,operatorKey,areaCode,phone,initialScheduleDate,endScheduleDate,creditValue,pointValue));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__Scheduling__["a" /* default */]));

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_calendar_component__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_calendar_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_calendar_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SchedulingOrderForm__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_pt_br__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_scheduling_css__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_scheduling_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_scheduling_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_tracking_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_tracking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_tracking_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScheduledOrderList__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SchedulingPlaceholder__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Scheduling=function(_Component){_inherits(Scheduling,_Component);function Scheduling(props){_classCallCheck(this,Scheduling);var _this=_possibleConstructorReturn(this,(Scheduling.__proto__||Object.getPrototypeOf(Scheduling)).call(this,props));_initialiseProps.call(_this);_this.today=__WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('MM-DD-YYYY'),'MM-DD-YYYY');var date=__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.today);var dateSelected=__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.today).format();var dayStartWeek=parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.today).format('YYYYMMDD'));var dayEndWeek=parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.today).format('YYYYMMDD'));_this.state={date:date,dateSelected:dateSelected,dayStartWeek:dayStartWeek,dayEndWeek:dayEndWeek,weekDays:['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'],view:'next-orders'};_this.renderHeader=_this.renderHeader.bind(_this);_this.renderDay=_this.renderDay.bind(_this);_this.handleChangeMonth=_this.handleChangeMonth.bind(_this);_this.handleChangeDay=_this.handleChangeDay.bind(_this);_this.handleChangeDate=_this.handleChangeDate.bind(_this);_this.getScheduleOrdersByDate=_this.getScheduleOrdersByDate.bind(_this);_this.onEditServiceItem=_this.onEditServiceItem.bind(_this);_this.onDeleteServiceItem=_this.onDeleteServiceItem.bind(_this);_this.saveSchedulingOrder=_this.saveSchedulingOrder.bind(_this);_this.cancelSchedule=_this.cancelSchedule.bind(_this);return _this;}_createClass(Scheduling,[{key:'componentDidMount',value:function componentDidMount(){var date=__WEBPACK_IMPORTED_MODULE_6_moment___default()(__WEBPACK_IMPORTED_MODULE_6_moment___default()().toString());var dayStartWeek=parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.state.date).weekday(0).format('YYYYMMDD'));var dayEndWeek=parseInt(__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.state.date).weekday(6).format('YYYYMMDD'));this.setState({date:date,dayStartWeek:dayStartWeek,dayEndWeek:dayEndWeek});this.props.getScheduledOrders(this.today);}},{key:'saveSchedulingOrder',value:function saveSchedulingOrder(schedulingOrder){var _this2=this;if(schedulingOrder.id){var participantScehdulePOSTData=JSON.parse(JSON.stringify(this.props.participantSchedulesModel));participantScehdulePOSTData.serviceItem[this.props.indexServiceItem]=schedulingOrder;this.props.updateScheduleOrder(participantScehdulePOSTData);}else{this.props.insertScheduleOrder(schedulingOrder.serviceId,schedulingOrder.operatorKey,schedulingOrder.areaCode,schedulingOrder.phone,schedulingOrder.initialDate,schedulingOrder.endDate,schedulingOrder.creditValue,schedulingOrder.pointValue);}setTimeout(function(){_this2.props.getScheduledOrders(_this2.today);_this2.setState({view:'next-orders'});},1000);}},{key:'renderHeader',value:function renderHeader(_ref){var date=_ref.date,onPrevMonth=_ref.onPrevMonth,onNextMonth=_ref.onNextMonth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Resgates recorrentes - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Calendar-header col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:onPrevMonth},'\xAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Calendar-header-currentDate txt-uppercase'},__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.state.dateSelected).format('DD MMMM YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:onNextMonth},'\xBB')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Calendar-grid Calendar-week-day-names col-12 px-0 mt-1'},this.state.weekDays.map(function(weekDay,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'Calendar-grid-item '+(weekDay===__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('ddd')&&__WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('YYYYMMDD')===__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYYMMDD')?'Calendar-grid-item--current':'')},weekDay);})))));}},{key:'renderDay',value:function renderDay(_ref2){var day=_ref2.day,onPickDate=_ref2.onPickDate;var dayInt=parseInt(day.format('YYYYMMDD'));var dayScheduledOrders=this.getScheduleOrdersByDate(day);var classNameDayHasScheduledOrder=dayScheduledOrders&&dayScheduledOrders.length>0?'calendar-scheduling':'';var classNameSelectedDay=__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.state.dateSelected).format('YYYYDDD')===day.format('YYYYDDD')?' color-brand-1 txt-font-body ':'';var classNameCalendarItem=dayInt>=this.state.dayStartWeek&&dayInt<=this.state.dayEndWeek?'Calendar-Item-show':'Calendar-Item-hidden';var classNameToday=dayInt===parseInt(this.today.format('YYYYMMDD'))?'txt-font-body':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:day.format('YYYYMMDD'),className:'Calendar-grid-item cursor '+classNameCalendarItem+' '+classNameDayHasScheduledOrder+' '+classNameSelectedDay+' '+classNameToday,onClick:function onClick(e){return onPickDate(day);}},day.format('D'));}},{key:'getScheduleOrdersByDate',value:function getScheduleOrdersByDate(date){var year=date.year();var month=date.month();var day=date.date();var yearlySchedules=this.props.scheduledOrders[year];if(!yearlySchedules)return[];var monthlySchedules=yearlySchedules[month];if(!monthlySchedules)return[];var dayleSchedules=monthlySchedules[day];if(!dayleSchedules)return[];return dayleSchedules;}},{key:'onEditServiceItem',value:function onEditServiceItem(item){this.props.editServiceItem(item);}},{key:'onDeleteServiceItem',value:function onDeleteServiceItem(item){var _this3=this;var scheduledOrder=item;var participantSchedule=JSON.parse(JSON.stringify(scheduledOrder.itemParticipantSchedule));var serviceItem=participantSchedule.serviceItem[scheduledOrder.indexServiceItem];serviceItem.status.statusId=3;serviceItem.status.statusName='Cancelado';serviceItem.change=true;this.props.cancelServiceItem(participantSchedule);setTimeout(function(){_this3.props.getScheduledOrders(_this3.today);_this3.setState({view:'next-orders'});},1000);}},{key:'render',value:function render(){var _this4=this;var schedulingOrderList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ScheduledOrderList__["a" /* ScheduledOrderList */],{onDelete:this.onDeleteServiceItem,onEdit:this.onEditServiceItem,scheduledOrders:this.state.view==='next-orders'?this.props.nextOrders:this.getScheduleOrdersByDate(this.state.date)});var schedulingForm=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SchedulingOrderForm__["a" /* SchedulingOrderForm */],{scheduledOrder:this.props.scheduledOrder,onSaveScheduledOrder:this.saveSchedulingOrder,onCancelSchedule:this.cancelSchedule,loading:this.props.isLoadingUpdate||this.props.isLoadingInsert});var body=this.props.scheduledOrder?schedulingForm:schedulingOrderList;var title=this.state.view==='next-orders'?'PRÓXIMOS RESGATES':this.state.date.format('YYYYMMDD')<this.today.format('YYYYMMDD')?'RESGATES REALIZADOS':'RESGATES DO DIA';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_placeholder___default.a,{ready:!this.props.isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SchedulingPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-scheduling container-fluid px-0 px-md-1 pt-2 pt-sm-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pb-2 pt-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_Shell_LoggedSidebar__["a" /* default */],{selected:this.props.location.pathname}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 px-0 px-md-1 border-color-ui-3 bg-white border radius pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-step row mx-0 px-3 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto px-md-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-initial color-brand-1 mr-auto'},'Resgates agendados'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'checkboxToggle',className:'checkboxToggle',type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_calendar_component__["Calendar"],{onChangeMonth:this.handleChangeMonth,date:this.state.date,onPickDate:this.handleChangeDay,renderHeader:this.renderHeader,renderDay:this.renderDay,containerClassName:'row mx-0 mx-sm--1 px-3 bg-ui-4 pt-2 pb-3 border-bottom border-color-ui-3 position-relative',contentClassName:'col-12 px-0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'calendarToggle txt-center pos-absolute bottom-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'checkboxToggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon_down',className:'icon-sm closed'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon_up',className:'icon-sm opened'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto px-md-3 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center py-half px-3 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-1 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-initial color-ui-2 mr-auto'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{className:'btn btn-sm btn-featured ',text:'AGENDAR NOVO RESGATE',onClick:function onClick(e){return _this4.props.newServiceItem();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-1 d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-initial color-ui-2 mr-auto'},title))))),body)))));}}]);return Scheduling;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this5=this;this.handleChangeDay=function(date){_this5.handleChangeDate(date,'day');};this.handleChangeMonth=function(date){_this5.handleChangeDate(date);};this.cancelSchedule=function(){setTimeout(function(){_this5.props.getScheduledOrders(_this5.today);_this5.setState({view:'next-orders'});},1000);};this.handleChangeDate=function(date,view){var dateSelected=date.format();var momentDateBeginWeek=__WEBPACK_IMPORTED_MODULE_6_moment___default()(dateSelected).weekday(0);var momentDateEndWeek=__WEBPACK_IMPORTED_MODULE_6_moment___default()(dateSelected).weekday(6);var dayStartWeek=parseInt(momentDateBeginWeek.format('YYYYMMDD'));var dayEndWeek=parseInt(momentDateEndWeek.format('YYYYMMDD'));_this5.setState({date:date,dayStartWeek:dayStartWeek,dayEndWeek:dayEndWeek,dateSelected:dateSelected});if(view)_this5.setState({view:view});};};Scheduling.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}).isRequired,scheduledOrders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,nextOrders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,getScheduledOrders:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,scheduledOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,editServiceItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,newServiceItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,updateScheduleOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,indexServiceItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,participantSchedulesModel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,insertScheduleOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoadingUpdate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingInsert:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,cancelServiceItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Scheduling);

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Calendar = __webpack_require__(1641);

Object.defineProperty(exports, 'Calendar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Calendar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(625);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(85);

var _classnames2 = _interopRequireDefault(_classnames);

var _createDateObjects = __webpack_require__(1642);

var _createDateObjects2 = _interopRequireDefault(_createDateObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextMonth = function () {
      if (_this.props.onNextMonth) {
        return _this.props.onNextMonth();
      }

      _this.props.onChangeMonth(_this.props.date.clone().add(1, 'months'));
    }, _this.handlePrevMonth = function () {
      if (_this.props.onPrevMonth) {
        return _this.props.onPrevMonth();
      }

      _this.props.onChangeMonth(_this.props.date.clone().subtract(1, 'months'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Calendar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          weekOffset = _props.weekOffset,
          renderDay = _props.renderDay,
          renderHeader = _props.renderHeader,
          onPickDate = _props.onPickDate,
          contentClassName = _props.contentClassName,
          containerClassName = _props.containerClassName;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Calendar', containerClassName) },
        renderHeader({
          date: date,
          onPrevMonth: this.handlePrevMonth,
          onNextMonth: this.handleNextMonth
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('Calendar-grid', contentClassName) },
          (0, _createDateObjects2.default)(date, weekOffset).map(function (day, i) {
            return renderDay(_extends({}, day, { onPickDate: onPickDate }));
          })
        )
      );
    }
  }]);

  return Calendar;
}(_react.Component);

Calendar.propTypes = {
  /** Week offset*/
  weekOffset: _propTypes2.default.number.isRequired,
  /** The current date as a moment objecct */
  date: _propTypes2.default.object.isRequired,
  /** Function to render a day cell */
  renderDay: _propTypes2.default.func,
  /** Function to render the header */
  renderHeader: _propTypes2.default.func,
  /** Called on next month click */
  onNextMonth: _propTypes2.default.func,
  /** Called on prev month click */
  onPrevMonth: _propTypes2.default.func,
  /** Called when some of the navigation controls are clicked */
  onChangeMonth: _propTypes2.default.func,
  /** Called when a date is clicked */
  onPickDate: _propTypes2.default.func,
  /** classname for div wrapping the whole calendar */
  containerClassName: _propTypes2.default.string,
  /** classname for the div wrapping the grid */
  contentClassName: _propTypes2.default.string
};
Calendar.defaultProps = {
  weekOffset: 0,
  renderDay: function renderDay(_ref2) {
    var day = _ref2.day,
        classNames = _ref2.classNames,
        onPickDate = _ref2.onPickDate;
    return _react2.default.createElement(
      'div',
      {
        key: day.format(),
        className: (0, _classnames2.default)('Calendar-grid-item', day.isSame((0, _moment2.default)(), 'day') && 'Calendar-grid-item--current', classNames),
        onClick: function onClick(e) {
          return onPickDate(day);
        }
      },
      day.format('D')
    );
  },
  renderHeader: function renderHeader(_ref3) {
    var date = _ref3.date,
        onPrevMonth = _ref3.onPrevMonth,
        onNextMonth = _ref3.onNextMonth;
    return _react2.default.createElement(
      'div',
      { className: 'Calendar-header' },
      _react2.default.createElement(
        'button',
        { onClick: onPrevMonth },
        '\xAB'
      ),
      _react2.default.createElement(
        'div',
        { className: 'Calendar-header-currentDate' },
        date.format('MMMM YYYY')
      ),
      _react2.default.createElement(
        'button',
        { onClick: onNextMonth },
        '\xBB'
      )
    );
  }
};
exports.default = Calendar;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDateObjects;

var _moment = __webpack_require__(625);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createDateObjects(date) {
  var weekOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var startOfMonth = date.startOf('month');

  var diff = startOfMonth.weekday() - weekOffset;
  if (diff < 0) diff += 7;

  var prevMonthDays = [];
  for (var _i = 0; _i < diff; _i++) {
    prevMonthDays.push({
      day: startOfMonth.clone().subtract(diff - _i, 'days'),
      classNames: 'prevMonth'
    });
  }

  var currentMonthDays = [];
  for (var _i2 = 1; _i2 < date.daysInMonth() + 1; _i2++) {
    currentMonthDays.push({
      day: (0, _moment2.default)([date.year(), date.month(), _i2])
    });
  }

  var daysAdded = prevMonthDays.length + currentMonthDays.length - 1;

  var nextMonthDays = [];
  var i = 1;
  while ((daysAdded + i) % 7 !== 0) {
    nextMonthDays.push({
      day: currentMonthDays[currentMonthDays.length - 1].day.clone().add(i, 'days'),
      classNames: 'nextMonth'
    });

    i = i + 1;
  }

  return [].concat(prevMonthDays, currentMonthDays, nextMonthDays);
}

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SchedulingOrderForm__ = __webpack_require__(1644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SchedulingOrderForm__["a"]; });


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_features_SelectMobileOperator__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_features_SelectValuesRecharge__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_features_DatePicker__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_features_CellphoneRecharge_ScheduleRecharge_PeriodScheduleRecharge__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_features_CellphoneRecharge_PhoneNumber__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var selectOptions=[{text:'Recarga de celular',value:1}];var SchedulingOrderForm=function(_Component){_inherits(SchedulingOrderForm,_Component);function SchedulingOrderForm(props){_classCallCheck(this,SchedulingOrderForm);var _this=_possibleConstructorReturn(this,(SchedulingOrderForm.__proto__||Object.getPrototypeOf(SchedulingOrderForm)).call(this,props));_this.state={scheduledOrder:props.scheduledOrder};_this.saveScheduledOrder=_this.saveScheduledOrder.bind(_this);_this.onChangeSchedulingDate=_this.onChangeSchedulingDate.bind(_this);_this.onChangeService=_this.onChangeService.bind(_this);_this.saveSchedulingOrder=_this.saveSchedulingOrder.bind(_this);_this.onChangeEndDate=_this.onChangeEndDate.bind(_this);_this.onChangeInitialDate=_this.onChangeInitialDate.bind(_this);_this.onChangeOperator=_this.onChangeOperator.bind(_this);_this.onChangePhoneNumber=_this.onChangePhoneNumber.bind(_this);_this.cancelSchedule=_this.cancelSchedule.bind(_this);return _this;}_createClass(SchedulingOrderForm,[{key:'saveScheduledOrder',value:function saveScheduledOrder(){this.props.onSaveScheduledOrder(this.state.scheduledOrder);}},{key:'onChangeSchedulingDate',value:function onChangeSchedulingDate(date){var scheduledOrder=this.state.scheduledOrder||{};this.setState({scheduledOrder:Object.assign({},scheduledOrder,{schedulingDate:date})});}},{key:'onChangeService',value:function onChangeService(item){var scheduledOrder=this.state.scheduledOrder||{};this.setState({scheduledOrder:Object.assign({},scheduledOrder,{serviceId:item.serviceId,serviceIdScheduling:item.serviceId,creditValue:item.costPrice,pointValue:item.sellingPrice})});}},{key:'onChangePhoneNumber',value:function onChangePhoneNumber(e){var scheduledOrder=this.state.scheduledOrder||{};this.setState({scheduledOrder:Object.assign({},scheduledOrder,{areaCode:e.areaCode,phone:e.phoneNumber})});}},{key:'saveSchedulingOrder',value:function saveSchedulingOrder(){this.props.onSaveScheduledOrder(this.state.scheduledOrder);}},{key:'cancelSchedule',value:function cancelSchedule(){this.props.onCancelSchedule();}},{key:'onChangeEndDate',value:function onChangeEndDate(date){var scheduledOrder=this.state.scheduledOrder||{};this.setState({scheduledOrder:Object.assign({},scheduledOrder,{endDate:date})});}},{key:'onChangeInitialDate',value:function onChangeInitialDate(date){var scheduledOrder=this.state.scheduledOrder||{};this.setState({scheduledOrder:Object.assign({},scheduledOrder,{initialDate:date})});}},{key:'onChangeOperator',value:function onChangeOperator(e){var scheduledOrder=this.state.scheduledOrder||{};this.setState({scheduledOrder:Object.assign({},scheduledOrder,{operator:e.value,operatorKey:e.value})});}},{key:'render',value:function render(){var date=this.state.scheduledOrder.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_features_DatePicker__["a" /* default */],{id:'schedulingDate',labelDescription:'Data do resgate',className:'col-12 col-md-6 mt-2',required:true,value:__WEBPACK_IMPORTED_MODULE_8_moment___default()(this.state.scheduledOrder.schedulingDate).utc().format('DD/MM/YYYY'),minDate:__WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).add(1,'days').toDate(),onChange:this.onChangeSchedulingDate}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_features_CellphoneRecharge_ScheduleRecharge_PeriodScheduleRecharge__["a" /* default */],{onChangeInnitialDate:this.onChangeInitialDate,innitialDate:this.state.scheduledOrder.initialDate,onChangeEndDate:this.onChangeEndDate,endDate:this.state.scheduledOrder.endDate,maxQuantityMonths:24});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 pb-3 pt-1 border-top border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-infos col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'escolha-servico',label:'Escolha o servi\xE7o',className:'col-12 col-md-6 mt-2',displayValue:'text',selectedValue:'value',options:selectOptions,value:selectOptions[0],disabled:true,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_features_SelectMobileOperator__["a" /* SelectMobileOperator */],{id:'escolha-parceiro',label:'Escolha uma operadora',className:'col-12 col-md-6 mt-2',value:this.state.scheduledOrder.operator,disabled:this.state.scheduledOrder.id,onChange:this.onChangeOperator}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_features_CellphoneRecharge_PhoneNumber__["a" /* PhoneNumber */],{operatorKey:this.state.scheduledOrder.operator,areaCode:this.state.scheduledOrder.areaCode,phoneNumber:this.state.scheduledOrder.phone,divContentClassName:'col-12 col-md-6 mt-2',disabled:this.state.scheduledOrder.id,onChangePhoneNumber:this.onChangePhoneNumber,onChangeAreaCode:this.onChangePhoneNumber,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_features_SelectValuesRecharge__["a" /* SelectValuesRecharge */],{id:'escolha-parceiro',label:'Escolha valor de cr\xE9dito',className:'col-12 col-md-6 mt-2',operatorKey:this.state.scheduledOrder.operator,areaCode:this.state.scheduledOrder.areaCode,value:this.state.scheduledOrder.serviceIdScheduling,onChangeValue:this.onChangeService}),date,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-2 pl-3 pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-double btn-featured btn-rating-modal col-12',text:'Cancelar',onClick:this.cancelSchedule})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mt-2 pl-3 pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured',text:this.state.scheduledOrder.id?'CONCLUIR EDIÇÃO':'AGENDAR AGORA',onClick:this.saveSchedulingOrder,loading:this.props.loading})))));}}]);return SchedulingOrderForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SchedulingOrderForm.propTypes={scheduledOrder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,onSaveScheduledOrder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,onCancelSchedule:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,loading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SchedulingOrderForm);

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectValuesRecharge__ = __webpack_require__(1646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SelectValuesRecharge__["a"]; });


/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellphoneRecharge_ValuesRecharge_actions__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectValuesRecharge=function(_Component){_inherits(SelectValuesRecharge,_Component);function SelectValuesRecharge(props){_classCallCheck(this,SelectValuesRecharge);var _this=_possibleConstructorReturn(this,(SelectValuesRecharge.__proto__||Object.getPrototypeOf(SelectValuesRecharge)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(SelectValuesRecharge,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.operatorKey&&this.props.areaCode){this.props.getValuesRecharge(this.props.operatorKey,this.props.areaCode);}else{this.props.clearValuesRecharge();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.operatorKey&&this.props.areaCode&&(this.props.operatorKey!==prevProps.operatorKey||this.props.areaCode!==prevProps.areaCode)){this.props.getValuesRecharge(this.props.operatorKey,this.props.areaCode);}}},{key:'onChange',value:function onChange(item){var selectedItem=this.props.valuesRecharge.find(function(valueRecharge){return valueRecharge.serviceId===item.value;});this.props.onChangeValue(selectedItem);}},{key:'render',value:function render(){var _this2=this;var source=this.props.selectSource||[];var value=source.find(function(item){return item.value===_this2.props.value;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Select"],{id:this.props.id,label:this.props.label,className:this.props.className,displayValue:'description',selectedValue:'value',options:source,value:value,required:this.props.required,onChange:this.onChange});}}]);return SelectValuesRecharge;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SelectValuesRecharge.propTypes={valuesRecharge:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,areaCode:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,operatorKey:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,selectSource:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,getValuesRecharge:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onChangeValue:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,clearValuesRecharge:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,required:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};var handleFormatValue=function handleFormatValue(value,decimalCurrency,decimalPlaces,pointsName){if(!isNaN(value)){return parseFloat(value).toLocaleString('pt-br',{minimumFractionDigits:decimalCurrency||decimalPlaces,maximumFractionDigits:decimalCurrency||decimalPlaces})+'  '+(decimalCurrency?'':pointsName)+' ';}return'';};var mapStateToProps=function mapStateToProps(_ref){var valuesRecharge=_ref.valuesRecharge,_ref$catalog$currency=_ref.catalog.currencyConfiguration,pointsName=_ref$catalog$currency.pointsName,decimalPlaces=_ref$catalog$currency.decimalPlaces;var source=valuesRecharge.map(function(item){return{description:'R$ '+handleFormatValue(item.rechargeValue,2,null,pointsName)+' por '+handleFormatValue(item.pointsValue,null,decimalPlaces,pointsName),value:item.serviceId};});return{valuesRecharge:valuesRecharge||[],selectSource:source||[],pointsName:pointsName,decimalPlaces:decimalPlaces};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getValuesRecharge:function getValuesRecharge(operatorKey,areaCode){return dispatch(__WEBPACK_IMPORTED_MODULE_3__CellphoneRecharge_ValuesRecharge_actions__["a" /* default */].getValuesRecharge(operatorKey,areaCode));},clearValuesRecharge:function clearValuesRecharge(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__CellphoneRecharge_ValuesRecharge_actions__["a" /* default */].clearAreaCodes());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SelectValuesRecharge));

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
    });

    return ptBr;

})));


/***/ }),
/* 1648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduledOrderList__ = __webpack_require__(1650);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScheduledOrderList__["a"]; });


/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScheduleOrderItem__ = __webpack_require__(1651);
var ScheduledOrderList=function ScheduledOrderList(props){var onEdit=function onEdit(index){props.onEdit(props.scheduledOrders[index]);};var onDelete=function onDelete(index){props.onDelete(props.scheduledOrders[index]);};return props.scheduledOrders&&props.scheduledOrders.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 border-top border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'tracking-steps col-12 px-2'},props.scheduledOrders&&props.scheduledOrders.map&&props.scheduledOrders.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ScheduleOrderItem__["a" /* ScheduleOrderItem */],{key:index,serviceItemId:item.serviceItemId,scheduleDate:item.scheduleDate,description:item.description,pointValue:item.pointValue,vendorId:item.vendorId,onEdit:onEdit,onDelete:onDelete,editable:item.editable,hasCancel:item.itemParticipantSchedule.serviceItem.findIndex(function(item){return item.status.statusName==='Cancelado';})!==-1,index:index});}))))||'';};ScheduledOrderList.propTypes={scheduledOrders:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ScheduledOrderList);

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleOrderItem__ = __webpack_require__(1652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScheduleOrderItem__["a"]; });


/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconItem__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__ = __webpack_require__(21);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var ScheduledOrderItem=function ScheduledOrderItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IconItem__["a" /* default */],{vendorId:props.vendorId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col order-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col order-1 order-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},!props.hasCancel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Agendado em',' ',__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.scheduleDate).utc().format('DD/MM/YYYY [-] HH[:]mm')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cancelado')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.description))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto order-4 order-md-2 mt-1 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm mt-half color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.pointValue})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto order-2 order-md-3 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},props.editable&&!props.hasCancel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_edit',className:'icon-sm',onClick:function onClick(e){return props.onEdit(props.index);}}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto order-3 order-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},props.editable&&!props.hasCancel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_trash',className:'icon-sm',onClick:function onClick(e){return props.onDelete(props.index);}}):'')))))));};ScheduledOrderItem.propTypes={scheduleDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof Date==='undefined'?'undefined':_typeof(Date)),description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pointValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,editable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onDelete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,hasCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ScheduledOrderItem);

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var IconItem=function IconItem(props){var classNameIcon='';switch(props.vendorId){case 71:classNameIcon='icon_phone';break;default:classNameIcon='';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tracking-item-icon pos-relative col-auto order-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:''+classNameIcon}));};IconItem.propTypes={vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (IconItem);

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SchedulingPlaceholder=function SchedulingPlaceholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-ui-4 pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0 px-md-1 py-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx mx-md-0  pt-5 pt-md-0  mt-5 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-md-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userSidebar col-12 col-md-4 d-none d-md-block pr-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 bg-brand-5 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wishlist-button row col btn btn-flat bg-ui-3 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-2 py-half radius bg-ui-3 py-1'})))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-3 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-initial color-brand-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 bg-ui-4 pt-2 pb-3 border-bottom border-color-ui-3 position-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Calendar-header col-12 row mx-0 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 px-5 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Calendar-grid Calendar-week-day-names col-12 row mx-0 mt-1 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Calendar-grid Calendar-week-day-names col-12 row mx-0 mt-1 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 mr-2 py-half radius bg-ui-3 py-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'calendarToggle txt-center pos-absolute bottom-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'checkboxToggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-2 py-half radius bg-ui-3 py-1'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 px-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-1 py-half radius bg-ui-3 py-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 px-3 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half radius bg-ui-3 py-2'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom pl-4 pr-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'extract-item pos-relative row mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto row mx-0 pl-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 radius bg-ui-3 py-1 px-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mr-1 py-half radius bg-ui-3 mb-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-half row mx-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 mr-1 py-half radius bg-ui-3 mb-0'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm col-12 row mx-0 px-0 color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-1 py-half radius bg-ui-3 mb-0'}))))))))))))))));};/* harmony default export */ __webpack_exports__["a"] = (SchedulingPlaceholder);

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1656);
var initialState={scheduledOrders:[],scheduledOrder:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'GET_SCHEDULED_ORDERS_ORDERS':{return state||initialState;}case'GET_SCHEDULED_ORDERS_SUCCESS':{var today=action.meta.previousAction.date;var tomorrow=__WEBPACK_IMPORTED_MODULE_0_moment___default()(today).add(1,'day');var nextOrders=[];var result={};action.payload.data&&action.payload.data.participantSchedulesModel&&action.payload.data.participantSchedulesModel.map(function(itemParticipantSchedule,indexItemParticipantSchedule){var firstScheduleMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default()(itemParticipantSchedule.firstSchedule).utc().format('DD/MM/YYYY');var lastScheduleMoment=__WEBPACK_IMPORTED_MODULE_0_moment___default()(itemParticipantSchedule.lastSchedule).utc().format('DD/MM/YYYY');var nextScheduledOrder=null;itemParticipantSchedule.serviceItem.map(function(itemSchedule,indexSchedule){if(itemSchedule.status.statusId===__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* default */].STATUS_MOBILE_RECHARGE_STATUS_CANCELED){return;}var dayKey=__WEBPACK_IMPORTED_MODULE_0_moment___default()(itemSchedule.schedulingDate).utc().date();var yearKey=__WEBPACK_IMPORTED_MODULE_0_moment___default()(itemSchedule.schedulingDate).utc().year();var monthKey=__WEBPACK_IMPORTED_MODULE_0_moment___default()(itemSchedule.schedulingDate).utc().month();var schedulingDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()(itemSchedule.schedulingDate);if(!result[yearKey])result[yearKey]={};if(!result[yearKey][monthKey])result[yearKey][monthKey]={};if(!result[yearKey][monthKey][dayKey]){result[yearKey][monthKey][dayKey]=[];}var scheduledOrder={scheduleDate:itemParticipantSchedule.dateCreatedScheduling,description:itemParticipantSchedule.ddd+' '+itemParticipantSchedule.phone+' agendado de '+firstScheduleMoment+' at\xE9 '+lastScheduleMoment,pointValue:itemSchedule.pointValue,vendorId:itemParticipantSchedule.vendorId,serviceItemId:itemSchedule.id,editable:tomorrow.format('YYYYMMDD')<=schedulingDate.format('YYYYMMDD'),indexServiceItem:indexSchedule,itemParticipantSchedule:itemParticipantSchedule};result[yearKey][monthKey][dayKey].push(scheduledOrder);if(!nextScheduledOrder&&tomorrow.format('YYYYMMDD')<=schedulingDate.format('YYYYMMDD')){nextScheduledOrder=scheduledOrder;}});if(nextScheduledOrder)nextOrders.push(nextScheduledOrder);nextScheduledOrder=null;});return{scheduledOrders:result,nextOrders:nextOrders,sourcescheduledOrders:action.payload.data.participantSchedulesModel};}case'GET_NEXT_SCHEDULED_ORDERS_FAIL':{return state||initialState;}case'EDIT_SERVICE_ITEM':{if(!action.item)return state;var scheduledOrder=action.item.itemParticipantSchedule.serviceItem[action.item.indexServiceItem];scheduledOrder.operator=action.item.itemParticipantSchedule.operator;scheduledOrder.phone=action.item.itemParticipantSchedule.phone;scheduledOrder.areaCode=action.item.itemParticipantSchedule.ddd;return Object.assign({},state,{scheduledOrder:scheduledOrder,participantSchedulesModel:action.item.itemParticipantSchedule,indexServiceItem:action.item.indexServiceItem});}case'NEW_SERVICE_ITEM':{delete state.indexServiceItem;return Object.assign({},state,{scheduledOrder:{},participantSchedulesModel:{}});}case'CLEAR_SERVICE_ITEM':delete state.scheduledOrder;delete state.participantSchedulesModel;delete state.indexServiceItem;delete state.isLoadingUpdate;return state;case'SHOW_ERRORMESSAGE_RECHARGE':state.message=action.message;return state;case'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER':return Object.assign({},state,{isLoadingUpdate:true});case'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER_END':delete state.isLoadingUpdate;return state;case'MOBILE_RECHARGE_FINALIZE_ORDER':return Object.assign({},state,{isLoadingInsert:true});case'MOBILE_RECHARGE_FINALIZE_ORDER_END':delete state.isLoadingInsert;return state;case'CLEAR_ERROR_MESSAGE':delete state.errorMessage;return state;default:return state||initialState;}});

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VENDORID_CELLPHONE_RECHARGE */
/* unused harmony export SERVICETYPE_MOBILE_RECHARGE */
/* unused harmony export REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE */
/* unused harmony export REGULATION_TYPE_CAMPAIGN */
/* unused harmony export REGULATION_TYPE_CAMPAIGN_AND_VENDOR */
/* unused harmony export REGULATION_TYPE_VENDOR */
var VENDORID_CELLPHONE_RECHARGE=71;var SERVICETYPE_MOBILE_RECHARGE=1;var REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE=5;var REGULATION_TYPE_CAMPAIGN='Campaign';var REGULATION_TYPE_CAMPAIGN_AND_VENDOR='VendorAndRegulationType';var REGULATION_TYPE_VENDOR='Vendor';/* harmony default export */ __webpack_exports__["a"] = ({VENDORID_CELLPHONE_RECHARGE:VENDORID_CELLPHONE_RECHARGE,SERVICETYPE_MOBILE_RECHARGE:SERVICETYPE_MOBILE_RECHARGE,REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE:REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE});

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadPackagesBySupplierId */
/* unused harmony export redemptionFuelCredit */
/* unused harmony export closeError */
/* unused harmony export changeStepFuelCredit */
/* unused harmony export redirectFuelCreditError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__);
var loadPackagesBySupplierId=function loadPackagesBySupplierId(supplierId,clientId){return{type:'FETCH_PACKAGES_BY_SUPPLIERID',payload:{client:'mileageApi',request:{method:'get',url:'/mileage-api/v1/packages/'+supplierId+'/'+clientId}}};};var redemptionFuelCredit=function redemptionFuelCredit(client){return function(order,state){return function(dispatch,getState){var _getState=getState(),user=_getState.oidc.user;if(!user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/auth/login'));}else{dispatch({type:'REDEMPTION_FUEL_CREDIT'});}var handleSuccess=function handleSuccess(response){dispatch({type:'REDEMPTION_FUEL_CREDIT_SUCCESS'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('services/confirmation/'+response.data.order.liveOrderId));};var handleError=function handleError(response){dispatch({type:'REDEMPTION_FUEL_CREDIT_FAIL',packageSelected:state.packageSelected});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/fuelcredit'));};client.post('/mileage-api/v1/orders/redemption',order,{headers:{'X-Mileage-VendorId':state.shellSupplierId}}).then(handleSuccess).catch(handleError);};};};var closeError=function closeError(){return{type:'REDEMPTION_FUEL_CREDIT_CLOSE_ERROR'};};var changeStepFuelCredit=function changeStepFuelCredit(step){return function(dispatch){dispatch({type:'CHANGE_STEP_FUEL_CREDIT',step:step});};};var redirectFuelCreditError=function redirectFuelCreditError(descriptionErrorFuelCredit,state){return function(dispatch){dispatch({type:'REDIRECT_ERROR_FUEL_CREDIT',descriptionErrorFuelCredit:descriptionErrorFuelCredit,packageSelected:state.packageSelected});dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_connected_react_router__["push"])('/fuelcredit'));};};/* harmony default export */ __webpack_exports__["a"] = (function(client){return{loadPackagesBySupplierId:loadPackagesBySupplierId,redemptionFuelCredit:redemptionFuelCredit(client),closeError:closeError,changeStepFuelCredit:changeStepFuelCredit,redirectFuelCreditError:redirectFuelCreditError};});

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shellSupplierId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loading__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalServices_ModalServices__ = __webpack_require__(214);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var shellSupplierId=117;var REGULATION_TYPE_VENDOR='Vendor';var first='first';var second='second';var error='error';var success='success';var errorBalance='Seu saldo é insuficiente.';var FuelCredit=function(_Component){_inherits(FuelCredit,_Component);function FuelCredit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FuelCredit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FuelCredit.__proto__||Object.getPrototypeOf(FuelCredit)).call.apply(_ref,[this].concat(args))),_this),_this.state={packageSelected:{},isValid:null,showModal:false,acceptTerms:false,firstStep:true,secondStep:false,stepError:false,stepFinal:false,shellSupplierId:shellSupplierId},_this.showTerms=function(){if(!_this.state.packageSelected.id){_this.setState({isValid:false});}else{_this.setState({showModal:true});}},_this.acceptTermsEvent=function(checked){_this.setState({showModal:false,acceptTerms:checked});},_this.handlerFinalizePayment=function(){if(_this.props.participantBalance<_this.state.packageSelected.pointsQuantity){_this.props.redirectFuelCreditError(errorBalance,_this.state);}else{_this.props.redemptionFuelCredit(_this.orderFuelCredit(),_this.state);}},_this.handlerChangePackage=function(packageSelected){_this.setState({packageSelected:packageSelected,isValid:null});},_this.handleChangeStepFuelCredit=function(stepValue){_this.props.changeStepFuelCredit(stepValue);},_this.handlerDisableButton=function(creditValue,pointsValue,acceptTerms){var result=!!(creditValue&&pointsValue&&acceptTerms);return!result?'disabled':'';},_this.handleFormatValue=function(value,decimalPlaces){return value.toLocaleString('pt-br',{minimumFractionDigits:decimalPlaces,maximumFractionDigits:decimalPlaces});},_this.orderFuelCredit=function(){return{totalMiles:_this.state.packageSelected.milesQuantity,totalPoints:_this.state.packageSelected.pointsQuantity,transferKey:'cpf',loyaltyNumber:_this.props.participant.cpf.value,cpf:_this.props.participant.cpf.value,participantName:_this.props.participant.name.value,offline:false,orderItems:[{quantity:1,points:_this.state.packageSelected.pointsQuantity,miles:_this.state.packageSelected.milesQuantity,totalPoints:_this.state.packageSelected.pointsQuantity,packageName:_this.state.packageSelected.title,clientProductCode:_this.state.packageSelected.clientProductCode,pointsAdjustment:_this.state.packageSelected.pointsAdjustment,partnerCampaignPackageId:_this.state.packageSelected.partnerCampaignPackageId}],orderTypeId:1};},_this.renderByStep=function(){switch(_this.props.step){case first:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-abasteca bg-white radius row px-2 mx-0 pt-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-3 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-uppercase color-brand-6 txt-body-sm mb-1'},'Cr\xE9dito de combust\xEDvel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title txt-circular-book'},'Abaste\xE7a com ',_this.props.pointsValue,' Shell Box.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Select"],{id:'selectFuelCredit',label:'Cr\xE9ditos em Combust\xEDvel?',className:'form-field col-12 mt-3 mt-md-5',hasEmpty:true,displayValue:'description',selectedValue:'id',options:_this.props.packages,required:true,'data-error':'Nenhum crédito selecionado',valid:_this.state.isValid,onChange:_this.handlerChangePackage,value:_this.state.packageSelected.id?_this.state.packageSelected:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btnNextStepFuelCredit',name:'NextStepFuelCredit',className:'btn-featured btn btn-sm mt-2 mx-1',text:'Continuar',onClick:function onClick(){return _this.handleChangeStepFuelCredit(second);},disabled:!_this.state.packageSelected.id}));case second:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1'},'Abaste\xE7a com ','Shell Box')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:function onClick(){return _this.handleChangeStepFuelCredit(first);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Loading__["a" /* Loading */],{ready:!_this.props.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Select"],{id:'selectPointsForTrade',label:'Quantos R$ em cr\xE9ditos quer receber?',className:'col-12 form-field mt-1',hasEmpty:true,displayValue:'description',selectedValue:'id',options:_this.props.packages,required:true,'data-error':'Nenhum crédito selecionado',valid:_this.state.isValid,onChange:_this.handlerChangePackage,value:_this.state.packageSelected.id?_this.state.packageSelected:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'totalFuelPoints',className:'col-12 form-field mt-2',label:'Voc\xEA vai resgatar',value:_this.handleFormatValue(_this.state.packageSelected.pointsQuantity||0,_this.props.currencyConfiguration.decimalPlaces)+' '+_this.props.currencyConfiguration.pointsName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Checkbox"],{id:'aceito_termos_fuel_credit',className:'col-auto',labelClass:'l-0',checked:_this.state.acceptTerms,onChange:function onChange(e){return _this.acceptTermsEvent(e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},' ','Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'txt-body-sm color-brand-2 txt-underline',role:'button',onClick:function onClick(e){return _this.setState({showModal:true});}},'termos do regulamento')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-1 mb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'DoneRecharge',name:'DoneRecharge',className:'btn-featured btn btn-sm',text:'Resgatar agora',onClick:_this.handlerFinalizePayment,loading:_this.props.sendRedemption,disabled:_this.handlerDisableButton(_this.state.packageSelected.milesQuantity,_this.state.packageSelected.pointsQuantity,_this.state.acceptTerms)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ModalServices_ModalServices__["a" /* default */],{title:'Termos do Regulamento de Shell Box',show:_this.state.showModal,onClose:function onClose(e){return _this.setState({showModal:false});},acceptTerms:function acceptTerms(e){return _this.acceptTermsEvent(true);},terms:{vendorId:shellSupplierId,type:REGULATION_TYPE_VENDOR},isLoading:_this.props.sendRedemption})));default:return'';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FuelCredit,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.packages||this.props.packages.length<1){this.props.loadPackagesBySupplierId(shellSupplierId,this.props.clientId);}}},{key:'btnTryAgain',value:function btnTryAgain(){this.setState({firstStep:false,secondStep:true,stepError:false,stepFinal:false});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-service col-12 col-md-8 col-lg-4 px-1 mb-lg-0 mb-3'},this.renderByStep(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-error',style:this.props.step===error?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close_circle color-error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:function onClick(){return _this2.handleChangeStepFuelCredit(first);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1 color-error'},'N\xE3o foi poss\xEDvel concluir o sua transa\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1'},'Seu saldo é insuficiente.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 mb-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btnTryAgainFuelCredit',name:'TryAgainFuelCredit',className:'btn-featured btn btn-sm btn-cart mb-5',text:'TENTAR NOVAMENTE',onClick:function onClick(){return _this2.btnTryAgain();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-success',style:this.props.step===success?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_check_circle color-success'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:function onClick(){return _this2.handleChangeStepFuelCredit(first);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1 color-success'},'Parab\xE9ns! Seu resgate foi conclu\xEDdo com sucesso.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Transfer\xEAncia: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Shell Box')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Valor em pontos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'100 pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Valor em cr\xE9ditos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ 100,00'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 mb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btnTryAgainRecharge',name:'TryAgainRecharge',className:'btn-featured btn btn-sm btn-cart mb-5',text:'Ver detalhes',onClick:function onClick(){return _this2.btnTryAgain();}})))));}}]);return FuelCredit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var packageType=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({description:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,partnerId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired});FuelCredit.propTypes={packages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(packageType).isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,loadPackagesBySupplierId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,participant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,redemptionFuelCredit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,sendRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,participantBalance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,step:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,changeStepFuelCredit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,redirectFuelCreditError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,clientId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref2){var fuelCredit=_ref2.fuelCredit,currencyConfiguration=_ref2.catalog.currencyConfiguration,participant=_ref2.participant,participantBalance=_ref2.balance.pointsValue,oidc=_ref2.oidc;var user=oidc.user;var _ref3=user||{},profile=_ref3.profile;return Object.assign({},fuelCredit,{currencyConfiguration:currencyConfiguration,participant:participant,participantBalance:participantBalance,pointsValue:currencyConfiguration.pointsName,clientId:profile&&profile['custom:client_id']});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadPackagesBySupplierId:function loadPackagesBySupplierId(shellSupplierId,participantClientId){return dispatch(__WEBPACK_IMPORTED_MODULE_4____["b" /* actions */].loadPackagesBySupplierId(shellSupplierId,participantClientId));},redemptionFuelCredit:function redemptionFuelCredit(order,state){return dispatch(__WEBPACK_IMPORTED_MODULE_4____["b" /* actions */].redemptionFuelCredit(order,state));},changeStepFuelCredit:function changeStepFuelCredit(stepValue){return dispatch(__WEBPACK_IMPORTED_MODULE_4____["b" /* actions */].changeStepFuelCredit(stepValue));},redirectFuelCreditError:function redirectFuelCreditError(descriptionErrorFuelCredit,state){return dispatch(__WEBPACK_IMPORTED_MODULE_4____["b" /* actions */].redirectFuelCreditError(descriptionErrorFuelCredit,state));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(FuelCredit));

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,packages:[],wasSend:false,step:'first'};var action=arguments[1];switch(action.type){case'FETCH_PACKAGES_BY_SUPPLIERID':return Object.assign({},state,{isLoading:true,packages:[]});case'FETCH_PACKAGES_BY_SUPPLIERID_SUCCESS':return Object.assign({},state,{isLoading:false,packages:action.payload.data});case'FETCH_PACKAGES_BY_SUPPLIERID_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});case'REDEMPTION_FUEL_CREDIT':return Object.assign({},state,{sendRedemption:true});case'REDEMPTION_FUEL_CREDIT_SUCCESS':return Object.assign({},state,{sendRedemption:false,step:'first'});case'REDEMPTION_FUEL_CREDIT_FAIL':return Object.assign({},state,{sendRedemption:false,sendRedemptionError:true,packageSelected:action.packageSelected,step:'first'});case'REDEMPTION_FUEL_CREDIT_CLOSE_ERROR':return Object.assign({},state,{sendRedemptionError:false});case'CHANGE_STEP_FUEL_CREDIT':return Object.assign({},state,{step:action.step});case'REDIRECT_ERROR_FUEL_CREDIT':return{descriptionErrorFuelCredit:action.descriptionErrorFuelCredit,sendRedemptionError:true,step:'first',packageSelected:action.packageSelected};default:return Object.assign({},state);}});

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmationCreditMileage__ = __webpack_require__(1663);
var mapStateToProps=function mapStateToProps(_ref,ownProps){var confirmationCreditMileage=_ref.confirmationCreditMileage;return{order:confirmationCreditMileage,orderId:ownProps.match.params.orderId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectNotFoundPage:function redirectNotFoundPage(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].REDIRECT_ROUTE_PAGE_404));},getOrder:function getOrder(orderId){return dispatch(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */].getOrder(orderId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__ConfirmationCreditMileage__["a" /* default */]));

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOrder */
var getOrder=function getOrder(orderId){return{type:'GET_ORDER_CONFIRMATION',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/'+orderId+'/order'}}};};/* harmony default export */ __webpack_exports__["a"] = ({getOrder:getOrder});

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REDIRECT_ROUTE_PAGE_404 */
var REDIRECT_ROUTE_PAGE_404='/404';/* harmony default export */ __webpack_exports__["a"] = ({REDIRECT_ROUTE_PAGE_404:REDIRECT_ROUTE_PAGE_404});

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmationCreditMileage_AboutCreditMileage_DetailCreditMileage__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmationCreditMileage_AboutCreditMileage_InfoCreditMileage__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_confirmation_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmationCreditMileage=function(_Component){_inherits(ConfirmationCreditMileage,_Component);function ConfirmationCreditMileage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmationCreditMileage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmationCreditMileage.__proto__||Object.getPrototypeOf(ConfirmationCreditMileage)).call.apply(_ref,[this].concat(args))),_this),_this.state={modalIsOpen:true,message:''},_this.handlerCloseSuccess=function(){_this.setState({modalIsOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmationCreditMileage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.orderId){this.props.getOrder(this.props.orderId).then(function(){if(!(_this2.props.order&&_this2.props.order.vendorOrderModel&&_this2.props.order.vendorOrderModel.length>0&&_this2.props.order.vendorOrderModel[0])){return;}var vendorId=_this2.props.order.vendorOrderModel[0].vendorId;if(!vendorId){return;}var quickRedemptionEnv="80,81,21039,21185,61659";var quickRedemption=quickRedemptionEnv&&quickRedemptionEnv.split(',').find(function(id){return JSON.parse(id||0)===JSON.parse(vendorId||0);});var redemptionMessage=quickRedemption?'Concluído! Seu pedido está sendo processado e você receberá seus créditos em alguns instantes.':'Parabéns! Seu pedido será processado em até 48 horas.';_this2.setState({message:redemptionMessage});});}}},{key:'render',value:function render(){var _this3=this;if(this.props.order.notFound){this.props.redirectNotFoundPage();}var order=this.props.order;var props=order.vendorOrderModel&&order.vendorOrderModel[0].items?Object.assign({},order,order.vendorOrderModel[0].items[0],{vendorName:order.vendorOrderModel[0].vendorName,itemId:order.vendorOrderModel[0].items[0].id,orderId:order.vendorOrderModel[0].orderId}):{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container py-5 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.state.modalIsOpen&&this.state.message?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:false,title:this.state.message,description:'Veja abaixo o resumo do seu pedido.',className:'mb-4',onClose:function onClose(){return _this3.handlerCloseSuccess();}}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body txt-uppercase txt-body'},'Resumo do pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ConfirmationCreditMileage_AboutCreditMileage_DetailCreditMileage__["a" /* default */],props)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ConfirmationCreditMileage_AboutCreditMileage_InfoCreditMileage__["a" /* default */],props)));}}]);return ConfirmationCreditMileage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConfirmationCreditMileage.propTypes={order:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,orderId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,getOrder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,redirectNotFoundPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerCloseSuccess:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ConfirmationCreditMileage);

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductImage__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_confirmation_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var DetailCreditMileage=function DetailCreditMileage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProductImage__["a" /* ProductImage */],{imageUrl:props.imageUrl,alt:'',vendorId:props.vendorId,ready:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-number col-12 mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-body'},'Pedido: #',props.parentOrderId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},'Transfer\xEAncia de pontos para ',props.vendorName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item  mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.sellingPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Realizado em:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.orderDate?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(props.orderDate).format('DD/MM/YYYY [às] HH[h]mm'):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{id:'order-detail',className:'btn btn-sm btn-featured btn-cart txt-center',to:'/order/'+props.parentOrderId+'/'+props.orderId+'/product/'+props.itemId},'Ver detalhes')))));};DetailCreditMileage.propTypes={vendorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,orderDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(typeof date==='undefined'?'undefined':_typeof(date)),sellingPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,parentOrderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,orderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,itemId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (DetailCreditMileage);

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__About__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__ = __webpack_require__(21);
var InfoCreditMileage=function InfoCreditMileage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__About__["a" /* About */],{title:' Sobre o pedido'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Transfer\xEAncia: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',props.vendorName,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor em pontos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:props.sellingPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor em Cr\xE9ditos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',props.name,' ')))));};InfoCreditMileage.propTypes={vendorName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,sellingPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (InfoCreditMileage);

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case'GET_ORDER_CONFIRMATION':return Object.assign({},state);case'GET_ORDER_CONFIRMATION_SUCCESS':return Object.assign({},action.payload.data);case'GET_ORDER_CONFIRMATION_FAIL':var errorMessage='';return Object.assign({},state,{notFound:action.error.request.status===404,errorMessage:action.data&&action.data.errors&&action.data.errors.length>0&&(action.data.errors.map(function(item,index){return errorMessage+=item.message;})||errorMessage)});default:return Object.assign({},state);}});

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_mileage_css__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_mileage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_mileage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loading__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalServices_ModalServices__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REGULATION_TYPE_VENDOR='Vendor';var Mileage=function(_Component){_inherits(Mileage,_Component);function Mileage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Mileage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Mileage.__proto__||Object.getPrototypeOf(Mileage)).call.apply(_ref,[this].concat(args))),_this),_this.state={supplierId:0,showModal:false,imageBanner:null,formValid:true,formMessage:'',points:'',loyaltyNumber: false?typeof _this.props.participant!=='undefined'?_this.props.participant.cpf.value:'':'',convertAllPoints:false,acceptTerms:false,partnerName:'',disabledField:true,fidelityLabel:''},_this.selectPartnersOnChange=function(item){// Verificando o supplier selecionado.
if(item===null||item===undefined||item===''){_this.setState({points:'',supplierId:0});_this.props.clearCalculator();return;}_this.setState({supplierId:item.vendorId,formValid:true,partnerName:item.name,points:'',loyaltyNumber:_this.state.loyaltyNumber,disabledField:false,acceptTerms:false,convertAllPoints:false,imageBanner:item.logoUrl,fidelityLabel:item.fidelityLabel});_this.props.clearCalculator();},_this.inputPointsOnblur=function(event){// Verificando se o supplierId foi selecionado.
if(_this.state.supplierId===0||_this.state.supplierId===undefined){_this.setState({formValid:false,formMessage:'Selecione um parceiro de milhas.'});return;}_this.setState({formValid:true,formMessage:'',convertAllPoints:false,points:event.target.value});_this.props.pointsToMiles(_this.state.supplierId,_this.state.points);},_this.checkboxAllPointsChange=function(event){// Verificando se o supplierId foi selecionado.
if(_this.state.supplierId===0||_this.state.supplierId===undefined){_this.setState({formValid:false,formMessage:'Selecione um parceiro de milhas.'});return;}var balance=Math.floor(_this.props.partBalance,0);_this.setState({convertAllPoints:!_this.state.convertAllPoints});if(event.target.checked){_this.setState({points:balance});_this.props.pointsToMiles(_this.state.supplierId,balance);}},_this.handleFormatValue=function(value){if(!isNaN(value)){return parseFloat(value).toLocaleString('pt-br',{minimumFractionDigits:_this.props.currencyConfiguration.decimalPlaces,maximumFractionDigits:_this.props.currencyConfiguration.decimalPlaces})+' '+_this.state.partnerName;}return'';},_this.checkboxRegulationChange=function(event){_this.setState({acceptTerms:event.target.checked});},_this.showTerms=function(){// Verificando se o supplierId foi selecionado.
if(_this.state.supplierId===0||_this.state.supplierId===undefined){_this.setState({formValid:false,formMessage:'Selecione um parceiro de milhas.'});return;}_this.setState({showModal:true});},_this.acceptTerms=function(accept){_this.setState({acceptTerms:accept});},_this.closeAlert=function(){_this.setState({formValid:true,formMessage:''});_this.props.closeError();},_this.inputPointsOnChange=function(_ref2){var value=_ref2.target.value;if(value.length>=7)return;var onlyNumbers=value.match(/\d+/g);if(onlyNumbers)return _this.setState({points:onlyNumbers.join([])});_this.setState({points:''});},_this.inputOnlyNumbers=function(_ref3){var value=_ref3.target.value;var onlyNumbers=value.match(/\d+/g);if(onlyNumbers){return _this.setState({loyaltyNumber:onlyNumbers.join([])});}_this.setState({loyaltyNumber:''});},_this.redeem=function(){// Verificando se o supplierId foi selecionado.
if(_this.state.supplierId===0||_this.state.supplierId===undefined){_this.setState({formValid:false,formMessage:'Selecione um parceiro de milhas.'});return;}if(_this.state.points===0||_this.state.points===undefined||_this.state.points===''){_this.setState({formMessage:'Insira a quantidade de '+_this.props.currencyConfiguration.pointsName,formValid:false});return;}_this.props.mileageRedemption(_this.getOrderRequest(),_this.state.supplierId);},_this.getOrderRequest=function(){return{totalMiles:_this.state.points,totalPoints:_this.props.calculator.miles,loyaltyNumber:_this.state.loyaltyNumber,cpf:_this.props.participant.cpf.value,participantName:_this.props.participant.name.value,catalogId:_this.props.participant.catalogId,offline:false,orderItems:[{quantity:1,points:_this.props.calculator.miles,miles:_this.state.points,totalPoints:_this.props.calculator.miles,packageName:_this.handleFormatValue(_this.props.calculator.miles)}],orderTypeId:1};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Mileage,[{key:'componentDidMount',value:function componentDidMount(){// Obtendo os parceiros de milhas ao carregar a página.
this.props.getPartners();this.props.clearCalculator();}},{key:'render',value:function render(){var _this2=this;var formValid=this.state.formValid&&!this.props.errorRedemption;var errorMessage=this.state.formMessage||this.props.errorRedemption;var readyForRedemption=formValid&&this.state.points>0&&this.state.acceptTerms&&this.state.loyaltyNumber;if(__WEBPACK_IMPORTED_MODULE_8_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_DISABLE_MILIAGE_AREA_HOME)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-mileage container-fluid bg-ui-5 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pb-2'},formValid===true?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:true,title:'N\xE3o foi poss\xEDvel concluir a sua transfer\xEAncia.',description:errorMessage,onClose:this.closeAlert})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mileage bg-ui-4 row mx-0 border border-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mileage-header col-12 radius-top pb-3 px-2','data-selected':this.state.supplierId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mileage-header-infos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-md-0 mt-2 align-items-start align-items-md-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-uppercase txt-font-body txt-body-sm'},'Milhas A\xE9reas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'mt-1 txt-circular-book txt-title-2 d-none d-md-block'},'Converta seus',' ',this.props.currencyConfiguration.pointsName,' em viagens completas.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.imageBanner})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'mt-1 txt-circular-book txt-title'},'Converta seus',' ',this.props.currencyConfiguration.pointsName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'em viagens completas.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mileage-body col-12 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1 py-2 px-1 radius-top bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'SelectPartners',label:'Transferir para',className:'col-12 col-md-3 mb-1 form-field mileage-form-tablets',hasEmpty:true,displayValue:'name',selectedValue:'vendorId',image:'logoUrl',classImage:'r-0',options:this.props.partners||[],imageAlign:'image-right',required:true,onChange:this.selectPartnersOnChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-5 form-field form-field-lg mileage-form-tablets mb-1 mb-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'FidelityNumber',name:'FidelityNumber',className:'col-12 col-md-6 form-field mb-1 mb-md-0',label:this.state.fidelityLabel||'CPF ou Loyalty Number',value:this.state.loyaltyNumber,onChange:this.inputOnlyNumbers,maxLength:'11',disabled:this.state.disabledField}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'InputPoints',name:'InputPoints',className:'col-12 col-md-6 form-field mb-1 mb-md-0',label:'Transferir quantos '+this.props.currencyConfiguration.pointsName+'?',required:true,value:this.state.points,onBlur:this.inputPointsOnblur,onChange:this.inputPointsOnChange,maxLength:'7',disabled:this.state.disabledField}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Checkbox"],{style:{position:'relative',marginLeft:'20px'},id:'CheckboxAllPoints',checked:this.state.convertAllPoints,className:'form-field checkbox-field col-5 ml-auto my-0 nowrap r-3 d-none d-md-block',labelClass:'l-0',label:'Transferir todos os meus '+this.props.currencyConfiguration.pointsName,onChange:this.checkboxAllPointsChange,disabled:this.state.disabledField}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Loading__["a" /* Loading */],{ready:!this.props.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto mb-md-0 mileage-form-tablets hidden-icon form-field mt-1 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_return',className:'color-brand-1 icon-sm d-none d-md-block py-2'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'MileageWillGet',name:'MileageWillGet',className:'col-12 col-md mb-md-0 mileage-form-tablets hidden-icon form-field',label:'Voc\xEA vai receber no programa parceiro',required:true,value:this.handleFormatValue(this.props.calculator.miles||0),disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{id:'DoneMileage',name:'DoneMileage',className:'btn-featured btn-icon btn-icon-only',iconName:'icon_send txt-body-lg',onClick:this.redeem,disabled:!readyForRedemption})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox-field col-12 col-md-3 mb-md-0 mb-1 mt-0 accept-terms r-5 mr-md-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Checkbox"],{id:'CheckboxAllPointsMobile',checked:this.state.convertAllPoints,className:'checkbox-field col-12 nowrap d-block d-md-none px-0',labelClass:'l-0',label:'Transferir todos os meus '+this.props.currencyConfiguration.pointsName,onChange:this.checkboxAllPointsChange,disabled:this.state.disabledField}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Checkbox"],{id:'aceito_termos',className:'col-1 px-0',labelClass:'l-0',onChange:this.checkboxRegulationChange,checked:this.state.acceptTerms,disabled:this.state.disabledField}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 align-self-center d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'txt-body-sm color-brand-2 txt-underline',role:'button',onClick:this.showTerms},'termos do regulamento'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 align-self-center d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'txt-body-sm color-brand-2 txt-underline',role:'button',onClick:function onClick(e){return _this2.setState({showModal:true});}},'termos do regulamento'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{id:'DoneMileageSmall',name:'DoneMileageSmall',className:'btn-featured btn btn-sm',text:'Transferir Agora',onClick:this.redeem})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ModalServices_ModalServices__["a" /* default */],{title:'Termos do Regulamento de Milhas',show:this.state.showModal,onClose:function onClose(e){return _this2.setState({showModal:false});},acceptTerms:function acceptTerms(e){_this2.setState({showModal:false});_this2.acceptTerms(true);},terms:{vendorId:this.state.supplierId,type:REGULATION_TYPE_VENDOR}})));}}]);return Mileage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Objeto que retorna da ação: loadMileagePartners.
var partnerMessage=__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,supplierId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired});// Objeto que retorna da ação: convertPointsToMiles.
var calculatorMessage=__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({points:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,miles:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string});// Propriedades do componente Mileage.
Mileage.propTypes={partners:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(partnerMessage).isRequired,calculator:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(calculatorMessage),isLoading:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,getPartners:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,pointsToMiles:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,clearCalculator:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,partBalance:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,mileageRedemption:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,participant:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,errorRedemption:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,closeError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref4){var mileage=_ref4.mileage,balance=_ref4.balance,participant=_ref4.participant,catalog=_ref4.catalog;return{partners:mileage.partners,firstPartner:mileage.firstPartner,calculator:mileage.calculator,isLoading:mileage.isLoading,getPartners:mileage.getPartners,pointsToMiles:mileage.pointsToMiles,partBalance:balance.pointsValue,participant:participant,errorRedemption:mileage.errorRedemption,currencyConfiguration:catalog.currencyConfiguration};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{clearCalculator:function clearCalculator(){return dispatch(__WEBPACK_IMPORTED_MODULE_5____["b" /* actions */].clearCalculator());},getPartners:function getPartners(){return dispatch(__WEBPACK_IMPORTED_MODULE_5____["b" /* actions */].getPartners());},pointsToMiles:function pointsToMiles(supplierId,points){return dispatch(__WEBPACK_IMPORTED_MODULE_5____["b" /* actions */].convertPointsToMiles(supplierId,points));},mileageRedemption:function mileageRedemption(order,supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_5____["b" /* actions */].mileageRedemption(order,supplierId));},closeError:function closeError(){return dispatch(__WEBPACK_IMPORTED_MODULE_5____["b" /* actions */].closeErrorMileage());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Mileage));

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false,partners:[],calculator:{supplierId:null,points:null,miles:null},configuration:{},sendTwoFactorAuthorization:{enable:false,errorToken:false,secondFactorAuthConfirmated:false}};var action=arguments[1];switch(action.type){case'FETCH_MILEAGE_PARTNERS':return Object.assign({},state,{isLoading:true,partners:[]});case'FETCH_MILEAGE_PARTNERS_SUCCESS':return Object.assign({},state,{isLoading:false,partners:action.payload&&action.payload.data});case'FETCH_MILEAGE_PARTNERS_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});case'REDEMPTION_DISABLE_BUTTON':return Object.assign({},state,{disableRedemption:action.value});case'FETCH_POINTS_TO_MILES':return Object.assign({},state,{disableRedemption:true,isLoading:true,calculator:{points:'',miles:''}});case'FETCH_POINTS_TO_MILES_SUCCESS':return Object.assign({},state,{isLoading:false,disableRedemption:false,calculator:action.payload.data});case'FETCH_POINTS_TO_MILES_FAIL':return Object.assign({},state,{isLoading:false,error:action.error});case'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN':return Object.assign({},state,{isLoading:false,enableConfiguration:false});case'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN_SUCCESS':var configuration=state.configuration,partners=state.partners;var supplierId=action.meta.previousAction.supplierId;configuration[supplierId]=[].concat(_toConsumableArray(action.payload.data));var fidelityLabelConfig=function fidelityLabelConfig(vendorId){var model=configuration[vendorId];if(model){var filter=model.filter(function(x){return x.key==='LoyaltyNumberLabel';});if(filter.length>0){return filter[0].value;}}else{return'';}};return Object.assign({},state,{isLoading:false,enableConfiguration:true,configuration:Object.assign({},configuration),partners:partners&&partners.map(function(p){return Object.assign({},p,{fidelityLabel:fidelityLabelConfig(p.vendorId)});})||[]});case'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN_FAIL':return Object.assign({},state,{isLoading:false,enableConfiguration:false,error:action.error});case'CLEAR_CALCULATOR':return Object.assign({},state,{calculator:{supplierId:null,points:'',miles:''},errorRedemption:''});case'REDEMPTION_MILEAGE_CLOSE_ERROR':return Object.assign({},state,{errorRedemption:''});case'REDEMPTION_MILEAGE_ERROR_BALANCE':return Object.assign({},state,{errorRedemption:'Seu saldo é insuficiente.',isLoading:false});case'REDEMPTION_MILEAGE_MINIMUN_BALANCE':return Object.assign({},state,{errorRedemption:'Verifique se o seu saldo \xE9 maior que '+action.MinimunBalance+' pontos ou tente novamente em alguns minutos',isLoading:false});case'REDEMPTION_MILEAGE_MINIMUN':return Object.assign({},state,{errorRedemption:'O Valor minimo de resgate \xE9 '+action.MinimumRedemption+' pontos',isLoading:false});case'REDEMPTION_MILEAGE_ERROR_CPF':return Object.assign({},state,{errorRedemption:'Digite um CPF válido.',isLoading:false});case'REDEMPTION_MILEAGE':return Object.assign({},state,{isLoading:true,sendRedemptionMileage:true});case'REDEMPTION_MILEAGE_SUCCESS':return Object.assign({},state,{isLoading:false,sendRedemptionMileage:false,loadingResendToken:false,sendTwoFactorAuthorization:undefined});case'REDEMPTION_MILEAGE_FAIL':return Object.assign({},state,{isLoading:false,errorRedemption:'Tente novamente em alguns minutos.',sendRedemptionMileage:false,loadingResendToken:false,sendTwoFactorAuthorization:undefined});case'AUTHORIZE_RESEND_FAIL':return Object.assign({},state,{sendTwoFactorAuthorization:Object.assign({},state.sendTwoFactorAuthorization,{enable:false,errorToken:false})});case'MILEAGE_WITH_TOKEN':return Object.assign({},state,{isLoading:true,isCreatingPurchase:true,loadingResendToken:true,sendTwoFactorAuthorization:{enable:!action.lastTry,orderId:action.orderId,orderMileageId:action.orderMileageId,errorToken:false,secondFactorAuthConfirmated:true}});case'TOKEN_INVALID_MILEAGE':return Object.assign({},state,{isLoading:false,isCreatingPurchase:false,loadingResendToken:false,errorRedemption:action.lastTry?'Tentativas de verificação de token excedidas!':'',sendTwoFactorAuthorization:{enable:!action.lastTry,orderId:action.orderId,orderMileageId:action.orderMileageId,errorToken:true,secondFactorAuthConfirmated:true}});case'AUTHORIZATION_REQUIRED_MILEAGE':return Object.assign({},state,{isLoading:false,sendTwoFactorAuthorization:{enable:true,orderId:action.orderId,orderMileageId:action.orderMileageId,errorToken:false,secondFactorAuthConfirmated:true}});case'ONBOARDING_REQUIRED_MILEAGE':return Object.assign({},state,{isLoading:false,sendTwoFactorAuthorization:{enable:true,secondFactorAuthConfirmated:false}});case'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/OPEN':return Object.assign({},state,{isLoading:false,disabledSelectPartners:false});case'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/CLOSE':return Object.assign({},state,{isLoading:true,disabledSelectPartners:true});case'CLOSE_MODAL_SHOW_ERROR':return Object.assign({},state,{sendTwoFactorAuthorization:{enable:false},errorRedemption:action.error});default:return Object.assign({},state);}});

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stix__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(317);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StixContainer=function(_Component){_inherits(StixContainer,_Component);function StixContainer(props){_classCallCheck(this,StixContainer);var _this=_possibleConstructorReturn(this,(StixContainer.__proto__||Object.getPrototypeOf(StixContainer)).call(this,props));_this.state={};return _this;}// #region [life cycle]
_createClass(StixContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.getPartners();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.supplierId!==this.props.supplierId){this.props.getMileageConfigurations(this.props.catalogId,this.props.supplierId);}}// #endregion
},{key:'render',value:function render(){// @ts-ignore
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Stix__["a" /* default */],null);}}]);return StixContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref){var stix=_ref.stix,catalog=_ref.catalog,mileage=_ref.mileage;return{catalogId:catalog.id,supplierId:stix.supplierId,redemptionPoints:stix.redemptionPoints,mileageIsLoading:mileage.isLoading,configuration:stix.configuration};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getMileageConfigurations:function getMileageConfigurations(catalogId,supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* getMileageConfigurations */](catalogId,supplierId));},getPartners:function getPartners(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* getPartnersStix */]());}};};StixContainer.propTypes={supplierId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,catalogId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,getMileageConfigurations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,getPartners:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(StixContainer));

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @ts-nocheck
var InputRange=function(_Component){_inherits(InputRange,_Component);function InputRange(props){_classCallCheck(this,InputRange);var _this=_possibleConstructorReturn(this,(InputRange.__proto__||Object.getPrototypeOf(InputRange)).call(this,props));_this.OnChangeInputHandle=function(e){return _this.setState({value:parseInt(e.target.value)});};_this.OnBlurInputHandle=function(){return _this.CallbackPointsToComponent(_this.state.value);};_this.state={step:_this.props.stepJump||2000,value:''};_this.OnChangeInputHandle=_this.OnChangeInputHandle.bind(_this);_this.OnBlurInputHandle=_this.OnBlurInputHandle.bind(_this);return _this;}// #region ["Event Listiners"]
_createClass(InputRange,[{key:'CallbackPointsToComponent',value:function CallbackPointsToComponent(value){this.props.handlerValueSelected(value);}// #endregion
},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-field px-0 stix-quantity form-field'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'no-label qtd-points',placeholder:'Qtd.','aria-label':'Quantidade',disabled:this.props.disabled,min:this.props.minimunValue,max:this.props.maximunValue,value:this.state.value,step:this.state.step,onChange:this.OnChangeInputHandle,onBlur:this.OnBlurInputHandle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-absolute t-0 r-0 h-100 d-flex align-items-center border border-ui-3 px-1 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-bold txt-lowercase'},this.props.pointsName)));}}]);return InputRange;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InputRange.propTypes={minimunValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,maximunValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,stepJump:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,handlerValueSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,pointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (InputRange);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StixInfos=function(_Component){_inherits(StixInfos,_Component);function StixInfos(){_classCallCheck(this,StixInfos);return _possibleConstructorReturn(this,(StixInfos.__proto__||Object.getPrototypeOf(StixInfos)).apply(this,arguments));}_createClass(StixInfos,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body'},'Veja o que voc\xEA precisa saber:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-custom icon_dot_down color-featured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'1 ponto iupp = 1 ponto stix.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'A transfer\xEAncia \xE9 gratuita.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-custom icon_user color-featured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Os pontos stix ser\xE3o',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'creditados automaticamente',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'no mesmo CPF da sua',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'conta iupp')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-custom icon_phone color-featured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA poder\xE1 trocar seus stix por',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'recompensas incr\xEDveis no app da',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Stix.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-custom icon_promo color-featured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'D\xE1 para trocar seus pontos stix por',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'vale-compras, produtos e servi\xE7os',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'do P\xE3o de A\xE7\xFAcar, Droga Raia, Extra,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Drogasil e muitos outros parceiros.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-custom icon_bag color-featured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Ap\xF3s escolher sua recompensa,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'siga as instru\xE7\xF5es para retir\xE1-la',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'na loja f\xEDsica ou online,',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dependendo do parceiro.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center  border border-color-ui-3 radius mx-0 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-custom icon_info color-featured'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Para mais informa\xE7\xF5es',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_URL+'hc/pt-br/sections/360006573912-transfer%C3%AAncia-de-pontos',className:'color-brand-2 txt-underline txt-body-sm'},'clique aqui'),'.')))))));}}]);return StixInfos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (StixInfos);

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var StixHeader=function StixHeader(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' stix-header row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-stix radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title-2 txt-circular-book'},children)))));};StixHeader.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StixHeader);

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var StixWrapper=function StixWrapper(_ref){var children=_ref.children;var scrollablePage=function scrollablePage(){var main=document.querySelector('[role="main"]');main.classList.add('stix-scrollable-area');};var returnOriginalState=function returnOriginalState(){var main=document.querySelector('[role="main"]');main.classList.remove('stix-scrollable-area');};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){scrollablePage();return function(){returnOriginalState();};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-stix container-fluid px-0 px-md-1 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-0 pb-3 py-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-0'},children)));};StixWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["a"] = (StixWrapper);

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__);
var SideBar=function SideBar(_ref){var loadingPayment=_ref.loadingPayment,disabledButton=_ref.disabledButton,_ref$partnerName=_ref.partnerName,partnerName=_ref$partnerName===undefined?'Stix':_ref$partnerName,_ref$creditValue=_ref.creditValue,creditValue=_ref$creditValue===undefined?0:_ref$creditValue,_ref$starValue=_ref.starValue,starValue=_ref$starValue===undefined?0:_ref$starValue,pointsName=_ref.pointsName,isModalConfirmationOpened=_ref.isModalConfirmationOpened,handlePaymentConfirmation=_ref.handlePaymentConfirmation,closeModal=_ref.closeModal,formatTitle=_ref.formatTitle,isLoading=_ref.isLoading,_ref$handlerFinalizeP=_ref.handlerFinalizePayment,handlerFinalizePayment=_ref$handlerFinalizeP===undefined?function(){}:_ref$handlerFinalizeP;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Resumo do resgate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Transfer\xEAncia: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,partnerName||'Stix')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm  txt-font-body color-ui-2'},'Valor em pontos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-lowercase'},' ',creditValue===''?0:creditValue,' ',pointsName,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Valor em pontos stix:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["e" /* StixStars */],{totalStars:starValue}),' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2','data-partnername':partnerName},'Ao clicar em finalizar transfer\xEAncia, seus pontos ser\xE3o transferidos para a Stix.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{loading:isLoading,className:'btn-featured btn-icon',disabled:disabledButton(),text:'transferir pontos',iconName:'icon_gift icon-sm',onClick:handlePaymentConfirmation}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default.a,{width:'580',height:'0',effect:'fadeInUp',visible:isModalConfirmationOpened},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto pos-absolute',style:{top:'-243px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 border-color-ui-3 border-bottom pb-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-font-title'},'Confirma\xE7\xE3o de transfer\xEAncia'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Voc\xEA est\xE1 transferindo ',creditValue===''?0:creditValue,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-lowercase'},pointsName),' ',formatTitle("Tupperware | Premmiar"),' para a Stix.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Deseja confirmar a transfer\xEAncia?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-6 txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm mx-0',text:'Cancelar',onClick:closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-6 txt-right'},loadingPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-featured btn-icon','aria-label':'Carregando...',disabled:disabledButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{className:'btn btn-sm btn-featured mx-0',text:'Confirmar transfer\xEAncia',onClick:handlerFinalizePayment})))))));};SideBar.propTypes={loadingPayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabledButton:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,partnerName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,starValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isModalConfirmationOpened:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handlePaymentConfirmation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,closeModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,formatTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SideBar);

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var StixStars=function StixStars(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.totalStars+' '+(props.totalStars===1?'ponto':'pontos'),' stix');};StixStars.propTypes={totalStars:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (StixStars);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(317);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var innitialState={isLoading:false,isReady:false,supplierId:null,redemptionPoints:0,minimumRedemptionLimit:0,maximumRedemptionLimit:0,partners:[],configuration:[],calculator:{points:'',miles:''},error:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:innitialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* Types */].TOGGLE_SUPPLIER_ID:return Object.assign({},state,{isReady:false,supplierId:action.supplierId});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* Types */].CHANGE_REDEMPTION_POINTS:return Object.assign({},state,{redemptionPoints:action.redemptionPoints});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* Types */].CHANGE_MINIMUM_REDEMPTION_LIMIT:return Object.assign({},state,{isReady:state.supplierId!==null&&action.minimumRedemptionLimit>0&&state.maximumRedemptionLimit>0,minimumRedemptionLimit:action.minimumRedemptionLimit});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* Types */].CHANGE_MAXIMUM_REDEMPTION_LIMIT:return Object.assign({},state,{isReady:state.supplierId!==null&&state.minimumRedemptionLimit>0&&action.maximumRedemptionLimit>0,maximumRedemptionLimit:action.maximumRedemptionLimit});case'FETCH_PARTNERS_STIX':return Object.assign({},state,{partners:[]});case'FETCH_PARTNERS_STIX_SUCCESS':return Object.assign({},state,{partners:action.payload.data});case'FETCH_PARTNERS_STIX_FAIL':return Object.assign({},state,{error:action.error});case'FETCH_POINTS_TO_MILES':return Object.assign({},state,{isLoading:true});case'FETCH_POINTS_TO_MILES_SUCCESS':return Object.assign({},state,{isLoading:false,error:null,calculator:action.payload.data});case'FETCH_POINTS_TO_MILES_FAIL':return Object.assign({},state,{isLoading:false,calculator:Object.assign({},state.calculator,{miles:''}),error:action.error});case'CONFIGURATION_STIX_PARTNERS':return Object.assign({},state,{isLoading:false,enableConfiguration:false});case'CONFIGURATION_STIX_PARTNERS_SUCCESS':var configuration=state.configuration,partners=state.partners;var supplierId=action.meta.previousAction.supplierId;configuration[supplierId]=[].concat(_toConsumableArray(action.payload.data));var fidelityLabelConfig=function fidelityLabelConfig(vendorId){var model=configuration[vendorId];if(model){var filter=model.filter(function(x){return x.key==='LoyaltyNumberLabel';});if(filter.length>0){return filter[0].value;}}else{return'';}};return Object.assign({},state,{isLoading:false,enableConfiguration:true,configuration:Object.assign({},configuration),partners:partners.map(function(p){return Object.assign({},p,{fidelityLabel:fidelityLabelConfig(p.vendorId)});})||[]});case'CONFIGURATION_STIX_PARTNERS_FAIL':return Object.assign({},state,{isLoading:false,enableConfiguration:false,error:action.error});case __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* Types */].CLOSE_ERROR_STIX:return Object.assign({},state,{error:null});default:return state||innitialState;}});

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productReducer; });
/* unused harmony export availabilityReducer */
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var productReducer=function productReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false};var action=arguments[1];switch(action.type){case'ADD_PRODUCTS':return Object.assign({},state,{isLoading:true});case'ADD_PRODUCTS_SUCCESS':return Object.assign({},state,{isLoading:false},action.products.reduce(function(acc,cur){return Object.assign({},acc,_defineProperty({},cur.sku,Object.assign({},cur)));},{}));case'ADD_PRODUCTS_FAIL':return Object.assign({},state,{isLoading:false,error:{message:'erro ao tentar incluir os produtos na collection'}});default:return Object.assign({},state);}};var availabilityReducer=function availabilityReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:false};var action=arguments[1];switch(action.type){case'FETCH_AVAILABILITY':return Object.assign({},state,{isLoading:true});case'FETCH_AVAILABILITY_SUCCESS':var availabilityList={};var availability=action.payload.data[0];var sku=action.meta.previousAction.sku;availabilityList[sku]=availability;return Object.assign({},state,{isLoading:false},availabilityList);case'FETCH_AVAILABILITY_FAIL':return Object.assign({},state,{isLoading:false});default:return Object.assign({},state);}};

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Catalog_Product_ducks__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Search_ducks__ = __webpack_require__(78);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_Catalog_Product_ducks__["a" /* FETCH_PRODUCT_SUCCESS */]:var _action$payload$data$=action.payload.data.brand,id=_action$payload$data$.id,rest=_objectWithoutProperties(_action$payload$data$,['id']);return Object.assign({},state,_defineProperty({},id,rest));case __WEBPACK_IMPORTED_MODULE_1_Catalog_Showcase_ducks__["a" /* FETCH_SHOWCASE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_2_Catalog_Search_ducks__["a" /* FETCH_SEARCH_SUCCESS */]:var hotBrands=action.payload.data.brands.reduce(function(brands,currentBrand){var brandId=currentBrand.id,_=currentBrand.quantity,rest=_objectWithoutProperties(currentBrand,['id','quantity']);return Object.assign({},brands,_defineProperty({},brandId,rest));},{});return Object.assign({},state,hotBrands);default:return state;}});

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Catalog_Product_ducks__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Search_ducks__ = __webpack_require__(78);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_Catalog_Product_ducks__["a" /* FETCH_PRODUCT_SUCCESS */]:var _action$payload$data$=action.payload.data.vendor,vendorId=_action$payload$data$.id,imageUrl=_action$payload$data$.logoUrl,rest=_objectWithoutProperties(_action$payload$data$,['id','logoUrl']);return Object.assign({},state,_defineProperty({},vendorId,Object.assign({imageUrl:imageUrl},rest)));case __WEBPACK_IMPORTED_MODULE_1_Catalog_Showcase_ducks__["a" /* FETCH_SHOWCASE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_2_Catalog_Search_ducks__["a" /* FETCH_SEARCH_SUCCESS */]:var hotVendors=action.payload.data.vendors.reduce(function(vendors,currentVendor){var vendorId=currentVendor.id,_=currentVendor.quantity,rest=_objectWithoutProperties(currentVendor,['id','quantity']);return Object.assign({},vendors,_defineProperty({},vendorId,rest));},{});return Object.assign({},state,hotVendors);default:return state;}});

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Catalog_Search_ducks__ = __webpack_require__(78);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var hotServices={};switch(action.type){case __WEBPACK_IMPORTED_MODULE_0_Catalog_Search_ducks__["a" /* FETCH_SEARCH_SUCCESS */]:var services=action.payload.data.services||[];hotServices=services.reduce(function(services,currentProduct){var image=currentProduct.image,name=currentProduct.name,partner=currentProduct.partner,partnerId=currentProduct.partnerId,path=currentProduct.path;return Object.assign({},services,_defineProperty({},name,Object.assign({},state[name],{image:image,name:name,partner:partner,partnerId:partnerId,path:path})));},{});return Object.assign({},state,hotServices);default:return state;}});

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestingReducer__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__showCaseReducer__ = __webpack_require__(1684);
var comunidadeReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({requesting:__WEBPACK_IMPORTED_MODULE_1__requestingReducer__["a" /* default */],showcase:__WEBPACK_IMPORTED_MODULE_2__showCaseReducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (comunidadeReducer);

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = requestingReducer;
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={};function requestingReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var isRequestType=action.type.indexOf('REQUEST_')>-1;if(isRequestType===false){return state;}var requestName=action.type.replace('_FINISHED','');var isFinishedRequestType=action.type.indexOf('_FINISHED')>-1;return Object.assign({},state,_defineProperty({},requestName,isFinishedRequestType===false));}

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immer__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseReducer__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(628);
var _baseReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var geoNear={maxDistance:500000,location:null};var pagination={pageSize:100,pageNumber:1};var initialState={filters:{stores:{pagination:pagination,filter:{chain:{ids:[]},geoNear:geoNear}},physicalOffers:{pagination:pagination,filter:{chain:{ids:[]},advertisementType:[0],geoNear:geoNear}},ecommerceOffers:{pagination:pagination,filter:{chain:{ids:[]},advertisementType:[1],geoNear:geoNear}}},stores:[],offers:{physicalOffers:[],ecommerceOffers:[]},useLocation:false,zipCode:null,location:{latitude:null,longitude:null}};var showCaseReducer=Object(__WEBPACK_IMPORTED_MODULE_1__baseReducer__["a" /* default */])(initialState,(_baseReducer={},_defineProperty(_baseReducer,__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* SET_LOCATION */],function(state,_ref){var payload=_ref.payload;return Object(__WEBPACK_IMPORTED_MODULE_0_immer__["a" /* produce */])(state,function(draft){draft.filters.stores.filter.geoNear.location=payload;draft.filters.physicalOffers.filter.geoNear.location=payload;draft.filters.ecommerceOffers.filter.geoNear.location=payload;draft.location=payload;});}),_defineProperty(_baseReducer,__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* SET_ZIPCODE */],function(state,_ref2){var payload=_ref2.payload;return Object(__WEBPACK_IMPORTED_MODULE_0_immer__["a" /* produce */])(state,function(draft){draft.zipCode=payload;});}),_defineProperty(_baseReducer,__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* SET_USE_LOCATION */],function(state,_ref3){var payload=_ref3.payload;return Object(__WEBPACK_IMPORTED_MODULE_0_immer__["a" /* produce */])(state,function(draft){draft.useLocation=payload;});}),_defineProperty(_baseReducer,__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* REQUEST_GET_SHOWCASE_STORES_FINISHED */],function(state,_ref4){var payload=_ref4.payload;return Object(__WEBPACK_IMPORTED_MODULE_0_immer__["a" /* produce */])(state,function(draft){draft.stores=payload;});}),_defineProperty(_baseReducer,__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* REQUEST_GET_SHOWCASE_OFFERS_FINISHED */],function(state,_ref5){var payload=_ref5.payload,meta=_ref5.meta;return Object(__WEBPACK_IMPORTED_MODULE_0_immer__["a" /* produce */])(state,function(draft){draft.offers[meta]=payload;});}),_defineProperty(_baseReducer,__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED */],function(state,_ref6){var payload=_ref6.payload;return Object(__WEBPACK_IMPORTED_MODULE_0_immer__["a" /* produce */])(state,function(draft){draft.filters.stores.filter.geoNear.location=payload;draft.filters.physicalOffers.filter.geoNear.location=payload;draft.filters.ecommerceOffers.filter.geoNear.location=payload;draft.location=payload;});}),_baseReducer));/* harmony default export */ __webpack_exports__["a"] = (showCaseReducer);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Immer */
/* unused harmony export applyPatches */
/* unused harmony export castDraft */
/* unused harmony export castImmutable */
/* unused harmony export createDraft */
/* unused harmony export current */
/* unused harmony export enableAllPlugins */
/* unused harmony export enableES5 */
/* unused harmony export enableMapSet */
/* unused harmony export enablePatches */
/* unused harmony export finishDraft */
/* unused harmony export immerable */
/* unused harmony export isDraft */
/* unused harmony export isDraftable */
/* unused harmony export nothing */
/* unused harmony export original */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return an; });
/* unused harmony export produceWithPatches */
/* unused harmony export setAutoFreeze */
/* unused harmony export setUseProxies */
function n(n){for(var t=arguments.length,r=Array(t>1?t-1:0),e=1;e<t;e++)r[e-1]=arguments[e];if(false){var i=Y[n],o=i?"function"==typeof i?i.apply(null,r):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(r.length?" "+r.join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function t(n){return!!n&&!!n[Q]}function r(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var t=Object.getPrototypeOf(n);return!t||t===Object.prototype}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function e(r){return t(r)||n(23,r),r[Q].t}function i(n,t,r){void 0===r&&(r=!1),0===o(n)?(r?Object.keys:Z)(n).forEach((function(e){r&&"symbol"==typeof e||t(e,n[e],n)})):n.forEach((function(r,e){return t(e,r,n)}))}function o(n){var t=n[Q];return t?t.i>3?t.i-4:t.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,t){return 2===o(n)?n.has(t):Object.prototype.hasOwnProperty.call(n,t)}function a(n,t){return 2===o(n)?n.get(t):n[t]}function f(n,t,r){var e=o(n);2===e?n.set(t,r):3===e?(n.delete(t),n.add(r)):n[t]=r}function c(n,t){return n===t?0!==n||1/n==1/t:n!=n&&t!=t}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return n.slice();var t=nn(n);delete t[Q];for(var r=Z(t),e=0;e<r.length;e++){var i=r[e],o=t[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(t[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),t)}function d(n,e){b(n)||t(n)||!r(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,t){return d(t,!0)}),!0))}function h(){n(2)}function b(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function y(t){var r=tn[t];return r||n( false?18:19,t),r}function m(n,t){tn[n]=t}function _(){return"production"==="production"||U||n(0),U}function j(n,t){t&&(y("Patches"),n.u=[],n.s=[],n.v=t)}function g(n){O(n),n.p.forEach(S),n.p=null}function O(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var t=n[Q];0===t.i||1===t.i?t.j():t.g=!0}function P(t,e){e._=e.p.length;var i=e.p[0],o=void 0!==t&&t!==i;return e.h.O||y("ES5").S(e,t,o),o?(i[Q].P&&(g(e),n(4)),r(t)&&(t=M(e,t),e.l||x(e,t)),e.u&&y("Patches").M(i[Q],t,e.u,e.s)):t=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),t!==H?t:void 0}function M(n,t,r){if(b(t))return t;var e=t[Q];if(!e)return i(t,(function(i,o){return A(n,e,t,i,o,r)}),!0),t;if(e.A!==n)return t;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(t,i){return A(n,e,o,t,i,r)})),x(n,o,!1),r&&n.u&&y("Patches").R(e,r,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if("production"!=="production"&&c===o&&n(5),t(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!t(v))return;e.m=!1}if(r(c)&&!b(c)){if(!e.h.N&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,t,r){void 0===r&&(r=!1),n.h.N&&n.m&&d(t,r)}function z(n,t){var r=n[Q];return(r?p(r):n)[t]}function I(n,t){if(t in n)for(var r=Object.getPrototypeOf(n);r;){var e=Object.getOwnPropertyDescriptor(r,t);if(e)return e;r=Object.getPrototypeOf(r)}}function E(n){n.P||(n.P=!0,n.l&&E(n.l))}function k(n){n.o||(n.o=l(n.t))}function R(n,t,r){var e=s(t)?y("MapSet").T(t,r):v(t)?y("MapSet").F(t,r):n.O?function(n,t){var r=Array.isArray(n),e={i:r?1:0,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:null,o:null,j:null,C:!1},i=e,o=rn;r&&(i=[e],o=en);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(t,r):y("ES5").J(t,r);return(r?r.A:_()).p.push(e),e}function D(e){return t(e)||n(22,e),function n(t){if(!r(t))return t;var e,u=t[Q],c=o(t);if(u){if(!u.P&&(u.i<4||!y("ES5").K(u)))return u.t;u.I=!0,e=N(t,c),u.I=!1}else e=N(t,c);return i(e,(function(t,r){u&&a(u.t,t)===r||f(e,t,n(r))})),3===c?new Set(e):e}(e)}function N(n,t){switch(t){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function T(){function r(n,t){var r=s[n];return r?r.enumerable=t:s[n]=r={configurable:!0,enumerable:t,get:function(){var t=this[Q];return"production"!=="production"&&f(t),rn.get(t,n)},set:function(t){var r=this[Q];"production"!=="production"&&f(r),rn.set(r,n,t)}},r}function e(n){for(var t=n.length-1;t>=0;t--){var r=n[t][Q];if(!r.P)switch(r.i){case 5:a(r)&&E(r);break;case 4:o(r)&&E(r)}}}function o(n){for(var t=n.t,r=n.k,e=Z(r),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=t[o];if(void 0===a&&!u(t,o))return!0;var f=r[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!t[Q];return e.length!==Z(t).length+(v?0:1)}function a(n){var t=n.k;if(t.length!==n.t.length)return!0;var r=Object.getOwnPropertyDescriptor(t,t.length-1);return!(!r||r.get)}function f(t){t.g&&n(3,JSON.stringify(p(t)))}var s={};m("ES5",{J:function(n,t){var e=Array.isArray(n),i=function(n,t){if(n){for(var e=Array(t.length),i=0;i<t.length;i++)Object.defineProperty(e,""+i,r(i,!0));return e}var o=nn(t);delete o[Q];for(var u=Z(o),a=0;a<u.length;a++){var f=u[a];o[f]=r(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(t),o)}(e,n),o={i:e?5:4,A:t?t.A:_(),P:!1,I:!1,D:{},l:t,t:n,k:i,o:null,g:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,r,o){o?t(r)&&r[Q].A===n&&e(n.p):(n.u&&function n(t){if(t&&"object"==typeof t){var r=t[Q];if(r){var e=r.t,o=r.k,f=r.D,c=r.i;if(4===c)i(o,(function(t){t!==Q&&(void 0!==e[t]||u(e,t)?f[t]||n(o[t]):(f[t]=!0,E(r)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,E(r))}));else if(5===c){if(a(r)&&(E(r),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function F(){function r(n){if(!n||"object"!=typeof n)return n;if(Array.isArray(n))return n.map(r);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],r(n[1])]})));if(v(n))return new Set(Array.from(n).map(r));var t=Object.create(Object.getPrototypeOf(n));for(var e in n)t[e]=r(n[e]);return t}function e(n){return t(n)?r(n):n}var f="add";m("Patches",{$:function(t,e){return e.forEach((function(e){for(var i=e.path,u=e.op,c=t,s=0;s<i.length-1;s++)"object"!=typeof(c=a(c,i[s]))&&n(15,i.join("/"));var v=o(c),p=r(e.value),l=i[i.length-1];switch(u){case"replace":switch(v){case 2:return c.set(l,p);case 3:n(16);default:return c[l]=p}case f:switch(v){case 1:return c.splice(l,0,p);case 2:return c.set(l,p);case 3:return c.add(p);default:return c[l]=p}case"remove":switch(v){case 1:return c.splice(l,1);case 2:return c.delete(l);case 3:return c.delete(e.value);default:return delete c[l]}default:n(17,u)}})),t},R:function(n,t,r,o){switch(n.i){case 0:case 4:case 2:return function(n,t,r,o){var c=n.t,s=n.o;i(n.D,(function(n,i){var v=a(c,n),p=a(s,n),l=i?u(c,n)?"replace":f:"remove";if(v!==p||"replace"!==l){var d=t.concat(n);r.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),o.push(l===f?{op:"remove",path:d}:"remove"===l?{op:f,path:d,value:e(v)}:{op:"replace",path:d,value:e(v)})}}))}(n,t,r,o);case 5:case 1:return function(n,t,r,i){var o=n.t,u=n.D,a=n.o;if(a.length<o.length){var c=[a,o];o=c[0],a=c[1];var s=[i,r];r=s[0],i=s[1]}for(var v=0;v<o.length;v++)if(u[v]&&a[v]!==o[v]){var p=t.concat([v]);r.push({op:"replace",path:p,value:e(a[v])}),i.push({op:"replace",path:p,value:e(o[v])})}for(var l=o.length;l<a.length;l++){var d=t.concat([l]);r.push({op:f,path:d,value:e(a[l])})}o.length<a.length&&i.push({op:"replace",path:t.concat(["length"]),value:o.length})}(n,t,r,o);case 3:return function(n,t,r,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=t.concat([u]);r.push({op:"remove",path:i,value:n}),e.unshift({op:f,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=t.concat([u]);r.push({op:f,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,t,r,o)}},M:function(n,t,r,e){r.push({op:"replace",path:[],value:t}),e.push({op:"replace",path:[],value:n.t})}})}function C(){function t(n,t){function r(){this.constructor=n}u(n,t),n.prototype=(r.prototype=t.prototype,new r)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function i(n){n.o||(n.o=new Set,n.t.forEach((function(t){if(r(t)){var e=R(n.A.h,t,n);n.p.set(t,e),n.o.add(e)}else n.o.add(t)})))}function o(t){t.g&&n(3,JSON.stringify(p(t)))}var u=function(n,t){return(u=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,t){n.__proto__=t}||function(n,t){for(var r in t)t.hasOwnProperty(r)&&(n[r]=t[r])})(n,t)},a=function(){function n(n,t){return this[Q]={i:2,l:t,A:t?t.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,g:!1},this}t(n,Map);var i=n.prototype;return Object.defineProperty(i,"size",{get:function(){return p(this[Q]).size}}),i.has=function(n){return p(this[Q]).has(n)},i.set=function(n,t){var r=this[Q];return o(r),p(r).has(n)&&p(r).get(n)===t||(e(r),E(r),r.D.set(n,!0),r.o.set(n,t),r.D.set(n,!0)),this},i.delete=function(n){if(!this.has(n))return!1;var t=this[Q];return o(t),e(t),E(t),t.D.set(n,!1),t.o.delete(n),!0},i.clear=function(){var n=this[Q];return o(n),e(n),E(n),n.D=new Map,n.o.clear()},i.forEach=function(n,t){var r=this;p(this[Q]).forEach((function(e,i){n.call(t,r.get(i),i,r)}))},i.get=function(n){var t=this[Q];o(t);var i=p(t).get(n);if(t.I||!r(i))return i;if(i!==t.t.get(n))return i;var u=R(t.A.h,i,t);return e(t),t.o.set(n,u),u},i.keys=function(){return p(this[Q]).keys()},i.values=function(){var n,t=this,r=this.keys();return(n={})[V]=function(){return t.values()},n.next=function(){var n=r.next();return n.done?n:{done:!1,value:t.get(n.value)}},n},i.entries=function(){var n,t=this,r=this.keys();return(n={})[V]=function(){return t.entries()},n.next=function(){var n=r.next();if(n.done)return n;var e=t.get(n.value);return{done:!1,value:[n.value,e]}},n},i[V]=function(){return this.entries()},n}(),f=function(){function n(n,t){return this[Q]={i:3,l:t,A:t?t.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,g:!1,C:!1},this}t(n,Set);var r=n.prototype;return Object.defineProperty(r,"size",{get:function(){return p(this[Q]).size}}),r.has=function(n){var t=this[Q];return o(t),t.o?!!t.o.has(n)||!(!t.p.has(n)||!t.o.has(t.p.get(n))):t.t.has(n)},r.add=function(n){var t=this[Q];return o(t),this.has(n)||(i(t),E(t),t.o.add(n)),this},r.delete=function(n){if(!this.has(n))return!1;var t=this[Q];return o(t),i(t),E(t),t.o.delete(n)||!!t.p.has(n)&&t.o.delete(t.p.get(n))},r.clear=function(){var n=this[Q];return o(n),i(n),E(n),n.o.clear()},r.values=function(){var n=this[Q];return o(n),i(n),n.o.values()},r.entries=function(){var n=this[Q];return o(n),i(n),n.o.entries()},r.keys=function(){return this.values()},r[V]=function(){return this.values()},r.forEach=function(n,t){for(var r=this.values(),e=r.next();!e.done;)n.call(t,e.value,e.value,this),e=r.next()},n}();m("MapSet",{T:function(n,t){return new a(n,t)},F:function(n,t){return new f(n,t)}})}function J(){T(),C(),F()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},19:"plugin not loaded",20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n}},Z="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,nn=Object.getOwnPropertyDescriptors||function(n){var t={};return Z(n).forEach((function(r){t[r]=Object.getOwnPropertyDescriptor(n,r)})),t},tn={},rn={get:function(n,t){if(t===Q)return n;var e=p(n);if(!u(e,t))return function(n,t,r){var e,i=I(t,r);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,t);var i=e[t];return n.I||!r(i)?i:i===z(n.t,t)?(k(n),n.o[t]=R(n.A.h,i,n)):i},has:function(n,t){return t in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,t,r){var e=I(p(n),t);if(null==e?void 0:e.set)return e.set.call(n.k,r),!0;if(n.D[t]=!0,!n.P){if(c(r,z(p(n),t))&&(void 0!==r||u(n.t,t)))return!0;k(n),E(n)}return n.o[t]=r,!0},deleteProperty:function(n,t){return void 0!==z(n.t,t)||t in n.t?(n.D[t]=!1,k(n),E(n)):delete n.D[t],n.o&&delete n.o[t],!0},getOwnPropertyDescriptor:function(n,t){var r=p(n),e=Reflect.getOwnPropertyDescriptor(r,t);return e?{writable:!0,configurable:1!==n.i||"length"!==t,enumerable:e.enumerable,value:r[t]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},en={};i(rn,(function(n,t){en[n]=function(){return arguments[0]=arguments[0][0],t.apply(this,arguments)}})),en.deleteProperty=function(t,r){return"production"!=="production"&&isNaN(parseInt(r))&&n(13),rn.deleteProperty.call(this,t[0],r)},en.set=function(t,r,e){return"production"!=="production"&&"length"!==r&&isNaN(parseInt(r))&&n(14),rn.set.call(this,t[0],r,e,t[0])};var on=function(){function e(n){this.O=B,this.N="production"!=="production","boolean"==typeof(null==n?void 0:n.useProxies)&&this.setUseProxies(n.useProxies),"boolean"==typeof(null==n?void 0:n.autoFreeze)&&this.setAutoFreeze(n.autoFreeze),this.produce=this.produce.bind(this),this.produceWithPatches=this.produceWithPatches.bind(this)}var i=e.prototype;return i.produce=function(t,e,i){if("function"==typeof t&&"function"!=typeof e){var o=e;e=t;var u=this;return function(n){var t=this;void 0===n&&(n=o);for(var r=arguments.length,i=Array(r>1?r-1:0),a=1;a<r;a++)i[a-1]=arguments[a];return u.produce(n,(function(n){var r;return(r=e).call.apply(r,[t,n].concat(i))}))}}var a;if("function"!=typeof e&&n(6),void 0!==i&&"function"!=typeof i&&n(7),r(t)){var f=w(this),c=R(this,t,void 0),s=!0;try{a=e(c),s=!1}finally{s?g(f):O(f)}return"undefined"!=typeof Promise&&a instanceof Promise?a.then((function(n){return j(f,i),P(n,f)}),(function(n){throw g(f),n})):(j(f,i),P(a,f))}if(!t||"object"!=typeof t){if((a=e(t))===H)return;return void 0===a&&(a=t),this.N&&d(a,!0),a}n(21,t)},i.produceWithPatches=function(n,t){var r,e,i=this;return"function"==typeof n?function(t){for(var r=arguments.length,e=Array(r>1?r-1:0),o=1;o<r;o++)e[o-1]=arguments[o];return i.produceWithPatches(t,(function(t){return n.apply(void 0,[t].concat(e))}))}:[this.produce(n,t,(function(n,t){r=n,e=t})),r,e]},i.createDraft=function(e){r(e)||n(8),t(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(t,r){var e=t&&t[Q];"production"!=="production"&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,r),P(void 0,i)},i.setAutoFreeze=function(n){this.N=n},i.setUseProxies=function(t){t&&!B&&n(20),this.O=t},i.applyPatches=function(n,r){var e;for(e=r.length-1;e>=0;e--){var i=r[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}var o=y("Patches").$;return t(n)?o(n,r):this.produce(n,(function(n){return o(n,r.slice(e+1))}))},e}(),un=new on,an=un.produce,fn=un.produceWithPatches.bind(un),cn=un.setAutoFreeze.bind(un),sn=un.setUseProxies.bind(un),vn=un.applyPatches.bind(un),pn=un.createDraft.bind(un),ln=un.finishDraft.bind(un);/* unused harmony default export */ var _unused_webpack_default_export = (an);
//# sourceMappingURL=immer.esm.js.map


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseReducer;
function baseReducer(initialState,methods){return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var method=methods[action.type];if(!method||action.error){return state;}return method(state,action);};}

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocationFromZipCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Services_ComunidadeIupp_ComunidadeIuup__ = __webpack_require__(629);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getStores=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filter){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_1__Services_ComunidadeIupp_ComunidadeIuup__["a" /* ComunidadeIuppService */].getUnitys(filter);case 2:response=_context.sent;return _context.abrupt('return',response.data.objectReturn.data);case 4:case'end':return _context.stop();}}},_callee,this);}));return function getStores(_x){return _ref.apply(this,arguments);};}();var getOffers=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(filter){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_1__Services_ComunidadeIupp_ComunidadeIuup__["a" /* ComunidadeIuppService */].getOffers(filter);case 2:response=_context2.sent;return _context2.abrupt('return',response.data.objectReturn.data);case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function getOffers(_x2){return _ref2.apply(this,arguments);};}();var getLocationFromZipCode=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(zipCode){var _ref4,data,_data$objectReturn$lo,lat,lng;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_1__Services_ComunidadeIupp_ComunidadeIuup__["a" /* ComunidadeIuppService */].getLocation(zipCode);case 2:_ref4=_context3.sent;data=_ref4.data;_data$objectReturn$lo=data.objectReturn.location,lat=_data$objectReturn$lo.lat,lng=_data$objectReturn$lo.lng;return _context3.abrupt('return',{latitude:lat,longitude:lng});case 6:case'end':return _context3.stop();}}},_callee3,this);}));return function getLocationFromZipCode(_x3){return _ref3.apply(this,arguments);};}();

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var getToken=function getToken(){return window.localStorage.getItem('comunidadeIuppToken');};var axios=function axios(baseURL){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({headers:{'X-API-KEY':Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_KEY,Authorization:'bearer '+getToken()},baseURL:baseURL});};/* harmony default export */ __webpack_exports__["a"] = (axios);

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__google__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categoryMenu__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tradeMenu__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meta__ = __webpack_require__(1693);
/* harmony default export */ __webpack_exports__["a"] = ({mainMenu:{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}||{default:{tradeMenu:__WEBPACK_IMPORTED_MODULE_2__tradeMenu__["a" /* default */],categoryMenu:__WEBPACK_IMPORTED_MODULE_1__categoryMenu__["a" /* default */]}},google:__WEBPACK_IMPORTED_MODULE_0__google__["a" /* default */],metadata:__WEBPACK_IMPORTED_MODULE_3__meta__["a" /* default */]});

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({accountDfp:'1040536'});

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var menus=[{'context':['points','cash'],'items':[{'items':[],'label':'Automotivo','path':'/search?category=2','enabled':true},{'items':[],'label':'Bebês','path':'/search?category=3','enabled':true},{'items':[],'label':'Bem estar','path':'/search?category=4','enabled':true},{'items':[],'label':'Casa e cozinha','path':'/search?category=5','enabled':true},{'items':[],'label':'Eletrônicos','path':'/search?category=6','enabled':true},{'items':[],'label':'Gastronomia','path':'/search?category=13','enabled':true},{'items':[],'label':'Indústria e Comércio','path':'/search?category=1','enabled':true},{'items':[],'label':'Lazer e Cultura','path':'/search?category=7','enabled':true},{'items':[],'label':'Moda','path':'/search?category=8','enabled':true},{'items':[],'label':'Todos','path':'/categories','enabled':true}],'label':'Categorias','enabled':true,'type':'services'},{'context':['points','cash'],'items':[{'items':[],'label':'C&C - Virtual','path':'/vendor?vendor=21248','enabled':true},{'items':[],'label':'Carrefour - Físico','path':'/vendor?vendor=21210','enabled':true},{'items':[],'label':'Carrefour - Virtual','path':'/vendor?vendor=21109','enabled':true},{'items':[],'label':'Cartão Presente Havan - Físico','path':'/vendor?vendor=61792','enabled':true},{'items':[],'label':'Casas Bahia - Virtual','path':'/vendor?vendor=21112','enabled':true},{'items':[],'label':'Cestas Michelli - Virtual','path':'/vendor?vendor=21110','enabled':true},{'items':[],'label':'Deezer - Físico','path':'/vendor?vendor=51483','enabled':true},{'items':[],'label':'Todos','path':'/stores/vouchers','enabled':true}],'label':'Vale Compras','enabled':true,'type':'services'},{'context':['points','cash'],'items':[{'items':[],'label':'Americanas','path':'/vendor?vendor=61982','enabled':true},{'items':[],'label':'Casas Bahia','path':'/vendor?vendor=60','enabled':true},{'items':[],'label':'Extra.Com','path':'/vendor?vendor=59','enabled':true},{'items':[],'label':'Fast Shop','path':'/vendor?vendor=106','enabled':true},{'items':[],'label':'Magazine Luiza','path':'/vendor?vendor=62','enabled':true},{'items':[],'label':'Ponto Frio','path':'/vendor?vendor=58','enabled':true},{'items':[],'label':'Todos','path':'/stores','enabled':true}],'label':'Lojas','enabled':true,'type':'services'},{'context':['points','cash'],'items':[{'items':[],'label':'Crédito em combustível','path':'/fuelcredit','enabled':true},{'items':[],'label':'Pague suas contas','path':'/billpayment','enabled':true},{'items':[],'label':'Recarga de celular','path':'/mobile-recharge','enabled':true}],'label':'Serviços','enabled':true,'type':'services'}];/* harmony default export */ __webpack_exports__["a"] = (menus);

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tradeMenu={label:'Trocar Pontos',items:[{items:[],label:'Extrato',title:'null',icon:'icon_listing',bannerInventory:'null',type:'static',dynamicAction:'null',path:'/extract'},{items:[],label:'Pedidos',title:'null',icon:'icon_package',bannerInventory:'null',type:'static',dynamicAction:'null',path:'/my-orders'},{items:[],label:'Recarga de celular',title:'null',icon:'icon_card',bannerInventory:'null',type:'static',dynamicAction:'null',path:'/mobile-recharge'},{context:['cash'],items:[],label:'Compre e ganhe pontos',title:'null',icon:'icon_cash',bannerInventory:'null',type:'static',dynamicAction:'null',path:'/search'},{context:['points'],items:[],label:'Troque seus pontos',title:'null',icon:'icon_gift',bannerInventory:'null',type:'static',dynamicAction:'null',path:'/search'}]};/* harmony default export */ __webpack_exports__["a"] = (tradeMenu);

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({title: true?"Tupperware | Premmiar":'Catálogo de Prêmios | Premmiar',description:'O WebPrêmios é um marketplace com design integrado que oferece uma experiência interativa ao participante, possibilitando a personalização do catálogo sem necessidade de envolvimento de técnicos ou intermediários. Entre suas facilidades estão telas de comparativo de preços, carrinho único, tracking, navegação com menos cliques, atendimento por chat e cross-selling de produtos.',keywords:''});

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ReduxAxiosMiddleware"] = factory();
	else
		root["ReduxAxiosMiddleware"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUCCESS_SUFFIX = exports.SUCCESS_SUFFIX = '_SUCCESS';
var ERROR_SUFFIX = exports.ERROR_SUFFIX = '_FAIL';

var getActionTypes = exports.getActionTypes = function getActionTypes(action) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$errorSuffix = _ref.errorSuffix,
      errorSuffix = _ref$errorSuffix === undefined ? ERROR_SUFFIX : _ref$errorSuffix,
      _ref$successSuffix = _ref.successSuffix,
      successSuffix = _ref$successSuffix === undefined ? SUCCESS_SUFFIX : _ref$successSuffix;

  var types = void 0;
  if (typeof action.type !== 'undefined') {
    var type = action.type;

    types = [type, '' + type + successSuffix, '' + type + errorSuffix];
  } else if (typeof action.types !== 'undefined') {
    types = action.types;
  } else {
    throw new Error('Action which matched axios middleware needs to have "type" or "types" key which is not null');
  }
  return types;
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiClientMiddleware = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaults = __webpack_require__(2);

var defaultOptions = _interopRequireWildcard(_defaults);

var _getActionTypes3 = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function addInterceptor(target, candidate, injectedParameters) {
  if (!candidate) return;
  var successInterceptor = typeof candidate === 'function' ? candidate : candidate.success;
  var errorInterceptor = candidate && candidate.error;
  target.use(successInterceptor && successInterceptor.bind(null, injectedParameters), errorInterceptor && errorInterceptor.bind(null, injectedParameters));
}

function bindInterceptors(client, injectedParameters) {
  var middlewareInterceptors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var clientInterceptors = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  [].concat(_toConsumableArray(middlewareInterceptors.request || []), _toConsumableArray(clientInterceptors.request || [])).forEach(function (interceptor) {
    addInterceptor(client.interceptors.request, interceptor, injectedParameters);
  });
  [].concat(_toConsumableArray(middlewareInterceptors.response || []), _toConsumableArray(clientInterceptors.response || [])).forEach(function (interceptor) {
    addInterceptor(client.interceptors.response, interceptor, injectedParameters);
  });
}

function getSourceAction(config) {
  return config.reduxSourceAction;
}

var multiClientMiddleware = exports.multiClientMiddleware = function multiClientMiddleware(clients, customMiddlewareOptions) {
  var middlewareOptions = _extends({}, defaultOptions, customMiddlewareOptions);
  var setupedClients = {};

  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (!middlewareOptions.isAxiosRequest(action)) {
          return next(action);
        }

        var clientName = middlewareOptions.getClientName(action) || middlewareOptions.defaultClientName;

        if (!clients[clientName]) {
          throw new Error('Client with name "' + clientName + '" has not been defined in middleware');
        }

        if (!setupedClients[clientName]) {
          var clientOptions = _extends({}, middlewareOptions, clients[clientName].options);

          if (clientOptions.interceptors) {
            var middlewareInterceptors = middlewareOptions.interceptors;
            var clientInterceptors = clients[clientName].options && clients[clientName].options.interceptors;
            var injectToInterceptor = { getState: getState, dispatch: dispatch, getSourceAction: getSourceAction };
            bindInterceptors(clients[clientName].client, injectToInterceptor, middlewareInterceptors, clientInterceptors);
          }

          setupedClients[clientName] = {
            client: clients[clientName].client,
            options: clientOptions
          };
        }

        var setupedClient = setupedClients[clientName];
        var actionOptions = _extends({}, setupedClient.options, setupedClient.options.getRequestOptions(action));

        var _getActionTypes = (0, _getActionTypes3.getActionTypes)(action, actionOptions),
            _getActionTypes2 = _slicedToArray(_getActionTypes, 1),
            REQUEST = _getActionTypes2[0];

        next(_extends({}, action, { type: REQUEST }));

        var requestConfig = _extends({}, actionOptions.getRequestConfig(action), {
          reduxSourceAction: action
        });
        return setupedClient.client.request(requestConfig).then(function (response) {
          var newAction = actionOptions.onSuccess({ action: action, next: next, response: response, getState: getState, dispatch: dispatch }, actionOptions);
          actionOptions.onComplete({ action: newAction, next: next, getState: getState, dispatch: dispatch }, actionOptions);
          return newAction;
        }, function (error) {
          var newAction = actionOptions.onError({ action: action, next: next, error: error, getState: getState, dispatch: dispatch }, actionOptions);
          actionOptions.onComplete({ action: newAction, next: next, getState: getState, dispatch: dispatch }, actionOptions);
          return actionOptions.returnRejectedPromiseOnError ? Promise.reject(newAction) : newAction;
        });
      };
    };
  };
};

exports.default = function (client, customMiddlewareOptions, customClientOptions) {
  var middlewareOptions = _extends({}, defaultOptions, customMiddlewareOptions);
  var options = customClientOptions || {};
  return multiClientMiddleware(_defineProperty({}, middlewareOptions.defaultClientName, { client: client, options: options }), middlewareOptions);
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onComplete = exports.onError = exports.onSuccess = exports.getRequestOptions = exports.getClientName = exports.getRequestConfig = exports.isAxiosRequest = exports.defaultClientName = exports.returnRejectedPromiseOnError = undefined;

var _getActionTypes = __webpack_require__(0);

var returnRejectedPromiseOnError = exports.returnRejectedPromiseOnError = false;

var defaultClientName = exports.defaultClientName = 'default';

var isAxiosRequest = exports.isAxiosRequest = function isAxiosRequest(action) {
  return action.payload && action.payload.request;
};

var getRequestConfig = exports.getRequestConfig = function getRequestConfig(action) {
  return action.payload.request;
};

var getClientName = exports.getClientName = function getClientName(action) {
  return action.payload.client;
};

var getRequestOptions = exports.getRequestOptions = function getRequestOptions(action) {
  return action.payload.options;
};

var onSuccess = exports.onSuccess = function onSuccess(_ref, options) {
  var action = _ref.action,
      next = _ref.next,
      response = _ref.response;

  var nextAction = {
    type: (0, _getActionTypes.getActionTypes)(action, options)[1],
    payload: response,
    meta: {
      previousAction: action
    }
  };
  next(nextAction);
  return nextAction;
};

var onError = exports.onError = function onError(_ref2, options) {
  var action = _ref2.action,
      next = _ref2.next,
      error = _ref2.error;

  var errorObject = void 0;
  if (!error.response) {
    errorObject = {
      data: error.message,
      status: 0
    };
    if (process.env.NODE_ENV !== 'production') {
      console.log('HTTP Failure in Axios', error);
    }
  } else {
    errorObject = error;
  }
  var nextAction = {
    type: (0, _getActionTypes.getActionTypes)(action, options)[2],
    error: errorObject,
    meta: {
      previousAction: action
    }
  };

  next(nextAction);
  return nextAction;
};

var onComplete = exports.onComplete = function onComplete() {};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = __webpack_require__(1);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_middleware).default;
  }
});
Object.defineProperty(exports, 'multiClientMiddleware', {
  enumerable: true,
  get: function get() {
    return _middleware.multiClientMiddleware;
  }
});

var _getActionTypes = __webpack_require__(0);

Object.defineProperty(exports, 'getActionTypes', {
  enumerable: true,
  get: function get() {
    return _getActionTypes.getActionTypes;
  }
});
Object.defineProperty(exports, 'ERROR_SUFFIX', {
  enumerable: true,
  get: function get() {
    return _getActionTypes.ERROR_SUFFIX;
  }
});
Object.defineProperty(exports, 'SUCCESS_SUFFIX', {
  enumerable: true,
  get: function get() {
    return _getActionTypes.SUCCESS_SUFFIX;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ]);
});

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Shared_GTM_getButton__ = __webpack_require__(102);
var NavTabHeader=function NavTabHeader(_ref){var focusOutOnClick=_ref.focusOutOnClick,profile=_ref.profile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'arial-label':'Segmento',className:'menu menu-segmentation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menubar','aria-label':'selecionar o seguimento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'meu-negocio',href:'/meu-negocio',className:'flex-item mn-item mn-business',role:'menuitem',onClick:function onClick(){focusOutOnClick();Object(__WEBPACK_IMPORTED_MODULE_2_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','para-seu-negocio');}},'para o seu neg\xF3cio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'para-voce',href:'/','aria-label':'para voc\xEA, p\xE1gina atual',className:'flex-item mn-item mn-personal current-home-page',role:'menuitem',onClick:function onClick(){focusOutOnClick();Object(__WEBPACK_IMPORTED_MODULE_2_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','para-voce');}},'para voc\xEA'))));};NavTabHeader.propTypes={focusOutOnClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (NavTabHeader);

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var NavTabHeaderMobile=function NavTabHeaderMobile(_ref){var focusOutOnClick=_ref.focusOutOnClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'arial-label':'Segmento',className:'menu menu-segmentation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menubar','aria-label':'selecionar o seguimento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/','aria-label':'para voc\xEA, p\xE1gina atual',className:'flex-item mn-item mn-personal current-home-page',role:'menuitem',onClick:function onClick(){return focusOutOnClick();}},'para voc\xEA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/meu-negocio',className:'flex-item mn-item mn-business',role:'menuitem',onClick:function onClick(){return focusOutOnClick();}},'para o seu neg\xF3cio'))));};NavTabHeaderMobile.propTypes={focusOutOnClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (NavTabHeaderMobile);

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__ = __webpack_require__(102);
var IuppHeaderDisconnected=function IuppHeaderDisconnected(_ref){var profile=_ref.profile;var redirectLoginPage=function redirectLoginPage(){window.location.href=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'placeholder-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'iupp-header header-disconnected'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'arial-label':'Segmento',className:'menu menu-segmentation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menubar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','para-seu-negocio','meu-negocio');},href:'#',className:'flex-item mn-item mn-personal',title:'Ver as vantages exclusivas para o seu neg\xF3cios',role:'menuitem'},'para o seu neg\xF3cio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',className:'flex-item mn-item',title:'Ver as vantagens exclusivas para voc\xEA',role:'menuitem',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','para-voce','meu-negocio');}},'para voc\xEA'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'arial-label':'Menu',className:'meu-bairro-head menu menu-navigation '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-meu-bairro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/meu-negocio',title:'Ir para a p\xE1gina inicial',className:'logo-header-community'},'comunidade ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'iupp')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-itens'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"],{to:'/meu-negocio/#benefits','data-target':'#benefits',className:'flex-item mn-item mn-benefits',title:'benef\xEDcios que v\xE3o te ajudar a vender mais.',role:'menuitem',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','beneficios','meu-negocio');}},'benef\xEDcios')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-itens'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["NavLink"],{to:'/meu-negocio/#help','data-target':'#help',className:'flex-item mn-item mn-help',title:'est\xE1 com d\xFAvidas? veja nossas perguntas frequentes.',role:'menuitem',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','ajuda','meu-negocio');}},'ajuda')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN,className:'flex-item mn-item mn-login',title:'Ir para \xE1rea de login',role:'menuitem',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','entrar','meu-negocio');}},'entrar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{onClick:function onClick(){redirectLoginPage();Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','cadastre-se','meu-negocio');},text:'cadastre-se',title:'Fazer cadastro',className:'flex-item mn-item mn-register',tabIndex:0})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{maxDeviceWidth:1024},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'arial-label':'Segmento',className:'menu menu-segmentation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flexible-items-container',role:'menubar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',className:'flex-item mn-item',title:'Ver as vantagens exclusivas para voc\xEA',role:'menuitem',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','para-voce','meu-negocio');}},'para voc\xEA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'flex-item mn-item mn-personal',title:'Ver as vantages exclusivas para o seu neg\xF3cios',role:'menuitem',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','para-seu-negocio','meu-negocio');}},'para o seu neg\xF3cio')))))));};IuppHeaderDisconnected.propTypes={profile:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (IuppHeaderDisconnected);

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FooterContainer__ = __webpack_require__(1699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FooterContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer__ = __webpack_require__(630);
/* unused harmony reexport Footer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResetFooter__ = __webpack_require__(1716);
/* unused harmony reexport ResetFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IuppFooter__ = __webpack_require__(1726);
/* unused harmony reexport IuppFooter */


/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Footer__ = __webpack_require__(630);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterContainer=function(_Component){_inherits(FooterContainer,_Component);function FooterContainer(){_classCallCheck(this,FooterContainer);return _possibleConstructorReturn(this,(FooterContainer.__proto__||Object.getPrototypeOf(FooterContainer)).apply(this,arguments));}_createClass(FooterContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Footer__["a" /* default */],this.props);}}]);return FooterContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var user=state.oidc.user;var _ref=user||{},profile=_ref.profile;return{profile:profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(FooterContainer));

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_app_store_svg__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_app_store_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_app_store_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_logo_bg_light_png__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_logo_bg_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_logo_bg_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_google_play_svg__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_google_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_google_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IuppContactList__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_yn__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterContent=function(_Component){_inherits(FooterContent,_Component);function FooterContent(props){_classCallCheck(this,FooterContent);var _this=_possibleConstructorReturn(this,(FooterContent.__proto__||Object.getPrototypeOf(FooterContent)).call(this,props));_this.state={profileMenu:false,userMenu:false,categoryMenu:true,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false,openNPS:false,showIuppMobileMenu:false};return _this;}_createClass(FooterContent,[{key:'render',value:function render(){var isIupp="tupperware-inc-cancun"==='iupp';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-footer-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer footer-part-1 bg-brand-4 container-fluid py-4 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address col-12 col-md-6 align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 pl-0 pr-2 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_logo_bg_light_png___default.a,className:'address-logo',alt:"Tupperware | Premmiar"||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 align-self-center mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm  color-ui-white txt-center txt-md-left'},'Alameda Rio Negro, 585 - 13\xBA andar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm  color-ui-white txt-center txt-md-left'},'Alphaville - Barueri - SP - CEP 06454-000')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app col-12 col-md-6 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 txt-right downloadit-app txt-circular-book txt-center txt-md-right mt-3 mt-md-0 align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txt-customsize-20x28 d-block'},'Baixe agora o app.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-h-100 img-w-auto google-play',src:__WEBPACK_IMPORTED_MODULE_4__loyal_images_google_play_svg___default.a,alt:'Baixe o aplicativo no Google play'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-h-100 img-w-auto app-store',src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_app_store_svg___default.a,alt:'Baixe o aplicativo na App Store'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer container-fluid footer-part-2 bg-ui-1 d-xs-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_7_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__IuppContactList__["a" /* default */],{profile:this.props.profile}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'aria-label':'Rodap\xE9',className:'links col-12 px-0 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row'},__WEBPACK_IMPORTED_MODULE_7_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-points-and-cash col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/pointsandcash'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/pointsandcash',tabIndex:0,target:'_blank'},'Pontos + dinheiro')),__WEBPACK_IMPORTED_MODULE_7_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-security col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/security'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/security',tabIndex:0,target:'_blank'},'Seguran\xE7a')),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-regulation col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/regulation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/regulation',tabIndex:0,target:'_blank'},'Regulamentos')),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-privacy col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/privacy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/privacy',tabIndex:0,target:'_blank'},'Pol\xEDtica de Privacidade')),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-terms col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/terms'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/terms',tabIndex:0,target:'_blank'},'Termos de uso')),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-faq col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/redirect/faq'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/redirect/faq',tabIndex:0,target:'_blank'},'Ajuda')),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'link-contact col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0','data-href':'/redirect/contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/redirect/contact',tabIndex:0,target:'_blank'},'Fale Conosco'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'legal col-12 col-xl-10 px-0 py-3'},isIupp?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-ui-white txt-subtitle txt-center txt-md-left'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MESSAGE_FOOTER_LEGAL||'PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-ui-white txt-subtitle txt-center txt-md-left'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MESSAGE_FOOTER_LEGAL_TEXT||'O cat\xE1logo de pr\xEAmios \xE9 atualizado peri\xF3dica e automaticamente pelos parceiros e os produtos \n                    e pre\xE7os poder\xE3o sofrer altera\xE7\xF5es durante a navega\xE7\xE3o, \n                    sem aviso pr\xE9vio, devendo ser consultados pelo interessado no momento da conclus\xE3o efetiva do resgate.')),!__WEBPACK_IMPORTED_MODULE_7_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address col-2 align-self-center txt-center logo-footer',role:'img','aria-label':"Tupperware | Premmiar"||''})))));}}]);return FooterContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FooterContent.propTypes={profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (FooterContent);

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var MyAccountGuest=function MyAccountGuest(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/auth/login'},'Entrar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/auth/login'},'Criar uma conta')));};/* harmony default export */ __webpack_exports__["a"] = (MyAccountGuest);

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
var MyAccountLogged=function MyAccountLogged(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/extract'},'Extrato')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/my-orders'},'Pedidos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://viagens.webpremios.digital/meus-pedidos'},'Minhas viagens')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/profile'},'Informa\xE7\xF5es pessoais')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/my-address'},'Endere\xE7o')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/security-access'},'Acesso e seguran\xE7a')));};/* harmony default export */ __webpack_exports__["a"] = (MyAccountLogged);

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__ = __webpack_require__(102);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var defaultState={isHomeOrGuest:false,isHelpPage:false,isWishlistPage:false,isCartPage:false,profileMenu:false,userMenu:false,stateMenu:true,categoryMenu:false,showIuppMobileMenu:false};var MobileMenu=function MobileMenu(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(defaultState),_useState2=_slicedToArray(_useState,2),ownState=_useState2[0],setOwnState=_useState2[1];var callReset=function callReset(e){setOwnState(Object.assign({},ownState,{stateMenu:!ownState.stateMenu}));if(!ownState.stateMenu||ownState.categoryMenu||ownState.userMenu){setTimeout(function(){setOwnState(Object.assign({},ownState,{profileMenu:false,userMenu:false,categoryMenu:false}));},300);}};var closeMenu=function closeMenu(){var checkMenu=document.getElementById('menuToggle');if(checkMenu&&checkMenu.checked===true){checkMenu.checked=false;}callReset();if(ownState.showIuppMobileMenu===true){setTimeout(function(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:false}));},300);}};var activePage=function activePage(){closeMenu();setTimeout(function(){var activeRoute=window.location.pathname.substring(window.location.pathname.lastIndexOf('/'));if(activeRoute==='/'){setOwnState(Object.assign({},ownState,{isHomeOrGuest:true,isHelpPage:false,isProfile:false,isCartPage:false,showIuppMobileMenu:false}));}else if(activeRoute==='/faq'){setOwnState(Object.assign({},ownState,{isHomeOrGuest:false,isHelpPage:true,isProfile:false,isCartPage:false,showIuppMobileMenu:false}));}else if(activeRoute==='/profile'||activeRoute==='/wishlist'||activeRoute==='/extract'||activeRoute==='/my-orders'||activeRoute==='/my-address'||activeRoute==='/scheduling'){setOwnState(Object.assign({},ownState,{isHomeOrGuest:false,isHelpPage:false,isProfile:true,isCartPage:false,showIuppMobileMenu:false}));}else if(activeRoute==='/cart'){setOwnState(Object.assign({},ownState,{isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:true,showIuppMobileMenu:false}));}else{setOwnState(Object.assign({},ownState,{isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false,showIuppMobileMenu:false}));}},1);};var toggleMenuMobileIupp=function toggleMenuMobileIupp(section){if(!ownState.showIuppMobileMenu){var allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button,  .iupp-header nav');if(allButtonsAndLinks&&allButtonsAndLinks.length>0){Array.from(allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.setAttribute('aria-hidden','true');});}}else{var _allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button,  .iupp-header nav');if(_allButtonsAndLinks&&_allButtonsAndLinks.length>0){Array.from(_allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.removeAttribute('aria-hidden');});}}setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));if(section==='#experiences'||section==='#accumulatePoints'||section==='#usePoint'||section==='#benefits'){setTimeout(function(){document.querySelector('.logo-header-link').blur();document.querySelector(section+' h2').setAttribute('tabindex','0');document.querySelector(section+' h2').focus();document.querySelector(section+' h2').addEventListener('blur',function(){document.querySelector(section+' h2').removeAttribute('tabindex');});},1000);}};var keyPressMenu=function keyPressMenu(e){if(e.which===13){toggleMenuMobileIupp();}};var returnHome=function returnHome(){__WEBPACK_IMPORTED_MODULE_5__redux__["a" /* history */].push('/');};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){activePage();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-footer d-print-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-footer-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer footer-part-mobile bg-brand-2 container-fluid row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(ownState.isHomeOrGuest?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){activePage();Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','ir-para-home');},onFocus:callReset,role:'button',tabIndex:0,'aria-label':'In\xEDcio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-ui-white icon icon_home','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'In\xEDcio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(ownState.showIuppMobileMenu?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){toggleMenuMobileIupp();Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','menu');},onKeyPress:keyPressMenu,onFocus:_this.callReset,tabIndex:0,'aria-label':ownState.showIuppMobileMenu?'Fechar':'Menu','aria-controls':'collapseMenuMobile',role:'button','aria-expanded':ownState.showIuppMobileMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-'+(ownState.showIuppMobileMenu?'brand-6 txt-body':'brand-5')+' icon icon_'+(ownState.showIuppMobileMenu?'menu_app_close':'menu_app'),'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},ownState.showIuppMobileMenu?'Fechar':'Menu')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:ownState.showIuppMobileMenu?'open-menu-iupp menu-mobile-iupp':'close-menu-iupp menu-mobile-iupp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-mobile menu'},ownState.showIuppMobileMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{'aria-label':'Menu',id:'collapseMenuMobile',className:'row h-100','arial-label':'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_5__redux__["a" /* history */].location.pathname==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{onClick:function onClick(){toggleMenuMobileIupp('#experiences');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');},href:'#experiences','data-target':'#experiences',className:'link-font-mobile mn-item mn-experiences',tabIndex:0},'experi\xEAncias')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{onClick:function onClick(){toggleMenuMobileIupp('#accumulatePoints');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');},href:'#accumulatePoints','data-target':'#accumulatePoints',className:'link-font-mobile mn-item mn-accumulate-points',tabIndex:0},'junte pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{onClick:function onClick(){toggleMenuMobileIupp('#usePoint');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');},href:'#usePoint','data-target':'#usePoint',className:'link-font-mobile mn-item mn-use-points',tabIndex:0},'use pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'border-bottom border-color-ui-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_anchor_link_smooth_scroll___default.a,{onClick:function onClick(){toggleMenuMobileIupp('#benefits');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','beneficios');},href:'#benefits','data-target':'#benefits',className:'link-font-mobile mn-item mn-benefits',tabIndex:0},'descontos'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){returnHome();toggleMenuMobileIupp('#experiences');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','experiencias');},href:'#experiences',className:'link-font-mobile mn-item mn-experiences',tabIndex:0,target:'_blank'},'experi\xEAncias')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){returnHome();toggleMenuMobileIupp('#accumulatePoints');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','junte-pontos');},href:'#accumulatePoints',className:'link-font-mobile mn-item mn-accumulate-points',tabIndex:0,target:'_blank'},'junte pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){returnHome();toggleMenuMobileIupp('#usePoint');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','use-pontos');},href:'#usePoint',className:'link-font-mobile mn-item mn-use-points',tabIndex:0,target:'_blank'},'use pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'border-bottom border-color-ui-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){returnHome();toggleMenuMobileIupp('#benefits');Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','descontos');},href:'#benefits',className:'link-font-mobile mn-item mn-benefits',tabIndex:0,target:'_blank'},'descontos'))),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/pointsandcash'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','pontos-mais-dinheiro');},to:'/pointsandcash',tabIndex:0,target:'_blank'},'pontos + dinheiro')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/security'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','seguranca');},to:'/security',tabIndex:0,target:'_blank'},'seguran\xE7a')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/regulation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','regulamentos');},to:'/regulation',tabIndex:0,target:'_blank'},'regulamentos')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/privacy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','politica-de-privacidade');},to:'/privacy',tabIndex:0,target:'_blank'},'pol\xEDtica de privacidade')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/terms'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','termos-de-uso');},to:'/terms',tabIndex:0,target:'_blank'},'termos de uso')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/faq'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','ajuda');},to:'/redirect/faq',tabIndex:0,target:'_blank'},'ajuda')),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-href':'/contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{className:'link-font-mobile mn-item',onClick:function onClick(){setOwnState(Object.assign({},ownState,{showIuppMobileMenu:!ownState.showIuppMobileMenu,isHomeOrGuest:!ownState.isHomeOrGuest}));Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','fale-conosco');},to:'/redirect/contact',tabIndex:0,target:'_blank'},'fale conosco')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','entrar');window.location.href='/auth/login';},text:'entrar',className:'link-font-mobile mn-item mn-login',tabIndex:0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','cadastre-se');window.location.href='/auth/login';},text:'cadastre-se',className:'link-font-mobile mn-item mn-register',tabIndex:0})))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/auth/login',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','menu');},className:'color-ui-white txt-body-sm d-flex justify-content-center',tabIndex:0,'aria-label':'Menu',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-'+(ownState.categoryMenu?'brand-6 txt-body':'brand-5')+' icon icon_'+(ownState.categoryMenu?'menu_app_close':'menu_app'),'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Menu'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center inactive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/auth/login',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this.activePage();Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','cadastre-se');},onFocus:_this.callReset,tabIndex:0,'aria-label':'Cadastre-se',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-brand-5 icon icon_login','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Cadastre-se'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center inactive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/auth/login',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','entrar');},className:'color-ui-white txt-body-sm d-flex justify-content-center',tabIndex:0,'aria-label':'Entrar',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-ui-white icon icon_profile','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Entrar'))),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(ownState.isHelpPage?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{to:'/redirect/faq',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this.activePage();Object(__WEBPACK_IMPORTED_MODULE_6_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','ajuda');},onFocus:_this.callReset,tabIndex:0,'aria-label':'Ajuda',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-ui-white icon icon_headphone','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Ajuda'))))));};/* harmony default export */ __webpack_exports__["a"] = (MobileMenu);

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_MainMenu_MenuMobile__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileMenuLogged=function(_Component){_inherits(MobileMenuLogged,_Component);function MobileMenuLogged(props){_classCallCheck(this,MobileMenuLogged);var _this=_possibleConstructorReturn(this,(MobileMenuLogged.__proto__||Object.getPrototypeOf(MobileMenuLogged)).call(this,props));_this.openProfileMenu=function(){setTimeout(function(){if(_this.state.userMenu===true){_this.setState({profileMenu:false,userMenu:false});var allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button');if(allButtonsAndLinks.length>0){Array.from(allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.removeAttribute('aria-hidden');});}}else{var _allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button');if(_allButtonsAndLinks.length>0){Array.from(_allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.setAttribute('aria-hidden','true');});}_this.setState({profileMenu:true,userMenu:true,categoryMenu:false,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false});}},300);};_this.openCategoryMenu=function(){setTimeout(function(){if(_this.state.categoryMenu===true){_this.setState({categoryMenu:false});var allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button');if(allButtonsAndLinks.length>0){Array.from(allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.removeAttribute('aria-hidden');});}}else{var _allButtonsAndLinks2=document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button');if(_allButtonsAndLinks2.length>0){Array.from(_allButtonsAndLinks2).forEach(function(buttonOrLink){buttonOrLink.setAttribute('aria-hidden','true');});}_this.setState({profileMenu:false,userMenu:false,categoryMenu:true,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false});}},300);};_this.callReset=function(e){_this.setState({stateMenu:!_this.state.stateMenu});if(!_this.state.stateMenu||_this.state.categoryMenu||_this.state.userMenu){setTimeout(function(){if(_this.state.categoryMenu===true){var allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button');if(allButtonsAndLinks.length>0){Array.from(allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.setAttribute('aria-hidden','false');});}}_this.setState({profileMenu:false,userMenu:false,categoryMenu:false});},300);}};_this.closeMenu=function(){var checkMenu=document.getElementById('menuToggle');if(checkMenu&&checkMenu.checked===true){checkMenu.checked=false;}_this.callReset();};_this.activePage=function(){_this.closeMenu();setTimeout(function(){var activeRoute=window.location.pathname.substring(window.location.pathname.lastIndexOf('/'));if(activeRoute==='/'){if(_this.state.userMenu===true){var allButtonsAndLinks=document.querySelectorAll('[role="main"], [role="main"] a, [role="main"] button, .container-header, .container-header a, .container-header button, .container-points-toogle, .container-points-toogle a, .container-points-toogle button, .container-menu, .container-menu a, .container-menu button');if(allButtonsAndLinks.length>0){Array.from(allButtonsAndLinks).forEach(function(buttonOrLink){buttonOrLink.removeAttribute('aria-hidden');});}}_this.setState({isHomeOrGuest:true,isHelpPage:false,isProfile:false,isCartPage:false,showIuppMobileMenu:false});}else if(activeRoute==='/faq'){_this.setState({isHomeOrGuest:false,isHelpPage:true,isProfile:false,isCartPage:false,showIuppMobileMenu:false});}else if(activeRoute==='/profile'||activeRoute==='/wishlist'||activeRoute==='/extract'||activeRoute==='/my-orders'||activeRoute==='/my-address'||activeRoute==='/scheduling'){_this.setState({isHomeOrGuest:false,isHelpPage:false,isProfile:true,isCartPage:false,showIuppMobileMenu:false});}else if(activeRoute==='/cart'){_this.setState({isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:true,showIuppMobileMenu:false});}else{_this.setState({isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false,showIuppMobileMenu:false});}},1);};_this.profileMenuState=function(){_this.setState({profileMenu:!_this.state.profileMenu});};_this.toggleMenuMobileIupp=function(section){_this.setState({showIuppMobileMenu:!_this.state.showIuppMobileMenu,isHomeOrGuest:!_this.state.isHomeOrGuest});if(section==='#experiences'||section==='#accumulatePoints'||section==='#usePoint'||section==='#benefits'){setTimeout(function(){document.querySelector(section+' h2').focus();},300);}};_this.keyPressMenu=function(e){if(e.which===13){_this.toggleMenuMobileIupp();}};_this.profileMenuState=_this.profileMenuState.bind(_this);_this.callReset=_this.callReset.bind(_this);_this.activePage=_this.activePage.bind(_this);_this.state={isHomeOrGuest:false,isHelpPage:false,isWishlistPage:false,isCartPage:false,profileMenu:false,userMenu:false,stateMenu:true,categoryMenu:false,showIuppMobileMenu:false};return _this;}// Apenas para o modo responsivo
_createClass(MobileMenuLogged,[{key:'componentDidMount',value:function componentDidMount(){this.activePage();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{maxWidth:1025},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-footer d-print-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-footer-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-footer footer-part-mobile bg-brand-2 container-fluid row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isHomeOrGuest?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.activePage();Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(true,'home','clique:menu','ir-para-home');},role:'button',tabIndex:0,'aria-label':'In\xEDcio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-ui-white icon icon_home','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'In\xEDcio'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.showIuppMobileMenu?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.openCategoryMenu();Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(true,'home','clique:menu','menu');},'aria-expanded':this.state.categoryMenu,role:'button',href:'javascript:void(0)',tabIndex:0,'aria-label':'Menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-'+(this.state.categoryMenu?'brand-6 txt-body':'brand-5')+' mt-0 icon icon_'+(this.state.categoryMenu?'menu_app_close':'menu_app'),'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_2_yn___default()(this.state.categoryMenu)?'Fechar':'Menu')),this.state.categoryMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_MainMenu_MenuMobile__["b" /* MenuMobileContainer */],{stateMenu:this.state.stateMenu,callReset:this.callReset,profileMenu:this.state.profileMenu,profileMenuState:this.profileMenuState,categoryMenu:this.state.categoryMenu,userMenu:this.state.userMenu,activePage:this.activePage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isCartPage?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/cart',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.activePage();Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(true,'home','clique:menu','carrinho');},tabIndex:0,'aria-label':'Carrinho',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-'+(this.state.isCartPage?'brand-6':'brand-5')+' icon icon_cart','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Carrinho'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isProfile?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center','aria-expanded':this.state.userMenu,onClick:function onClick(){_this2.openProfileMenu();Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(true,'home','clique:menu','perfil');},role:'button',href:'javascript:void(0)',tabIndex:0,'aria-label':'Perfil'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-'+(this.state.userMenu?'brand-6':'brand-5')+' mt-0 icon icon_'+(this.state.profileMenu?'menu_app_close':'profile')+' '+(this.state.userMenu?'brand-6 txt-body':'brand-5'),'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Perfil')),this.state.userMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_MainMenu_MenuMobile__["b" /* MenuMobileContainer */],{stateMenu:this.state.stateMenu,callReset:this.callReset,profileMenu:this.state.profileMenu,profileMenuState:this.profileMenuState,categoryMenu:this.state.categoryMenu,userMenu:this.state.userMenu,activePage:this.activePage}))),__WEBPACK_IMPORTED_MODULE_2_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isHelpPage?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/redirect/faq',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.activePage();Object(__WEBPACK_IMPORTED_MODULE_5_Shared_GTM_getButton__["a" /* getButton */])(true,'home','clique:menu','ajuda');},tabIndex:0,'aria-label':'Ajuda',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'color-ui-white icon icon_headphone','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile','aria-hidden':'true'},'Ajuda'))))))));}}]);return MobileMenuLogged;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MobileMenuLogged);

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuMobile__ = __webpack_require__(637);
var mapStateToProps=function mapStateToProps(_ref){var mainMenu=_ref.mainMenu,productCategories=_ref.productCategories,stores=_ref.stores,pointsName=_ref.catalog.currencyConfiguration.pointsName,balance=_ref.balance,user=_ref.oidc.user,wishlist=_ref.wishlist;return{tradeMenu:(user.profile?typeof mainMenu[user.profile['custom:catalog_id']]!=='undefined'?mainMenu[user.profile['custom:catalog_id']]:mainMenu['default']:mainMenu['default']).tradeMenu,categoryMenuItens:(user.profile?typeof mainMenu[user.profile['custom:catalog_id']]!=='undefined'?mainMenu[user.profile['custom:catalog_id']]:mainMenu['default']:mainMenu['default']).categoryMenu,productCategories:productCategories,stores:stores,pointsName:pointsName,balance:balance,profile:user&&user.profile,wishlist:wishlist};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MenuMobile__["a" /* default */]));

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var Profile=function Profile(_ref){var name=_ref.profile.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 h-auto border-color-ui-3 border-bottom bg-brand-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-double btn-flat btn-icon txt-font-body txt-initial txt-body txt-left py-1 default',role:'button',tabIndex:'-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_profile color-ui-white'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm color-ui-white py-1 pl-3'},'Ol\xE1, ',formatName(name),'!'))));};var formatName=function formatName(name){return name.split(' ')[0];};Profile.propTypes={profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FaqItem__ = __webpack_require__(1708);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(props){_classCallCheck(this,Faq);var _this=_possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).call(this));_this.state={};return _this;}_createClass(Faq,[{key:'render',value:function render(){var _this2=this;var items=[{path:'/regulation',label:'Regulamentos',icon:'icon_file',order:0},{path:'/terms',label:'Termos de uso',icon:'icon_file',order:1},{path:'/privacy',label:'Políticas de privacidade',icon:'icon_file',order:2}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'mx-1 p-0 h-100 item-menu-mobile border-top border-color-ui-1'},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FaqItem__["a" /* default */],{key:index,callReset:_this2.props.callReset,activePage:_this2.props.activePage,text:item.label,icon:item.icon,path:item.path});}));}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Faq.propTypes={callReset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,activePage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Faq);

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqItem=function(_Component){_inherits(FaqItem,_Component);function FaqItem(props){_classCallCheck(this,FaqItem);var _this=_possibleConstructorReturn(this,(FaqItem.__proto__||Object.getPrototypeOf(FaqItem)).call(this));_this.closeMenu=function(){var checkMenu=document.getElementById('menuToggle');if(checkMenu&&checkMenu.checked===true){checkMenu.checked=false;}_this.props.callReset();};_this.state={};return _this;}_createClass(FaqItem,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{role:'link','aria-label':this.props.text,to:this.props.path,className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative',onClick:function onClick(){return _this2.props.activePage();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 pl-0','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon '+this.props.icon+' pos-relative icon-menu-mobile'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-0 px-0 pl-half ml-1','aria-hidden':'true'},this.props.text)))));}}]);return FaqItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FaqItem.propTypes={callReset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,activePage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (FaqItem);

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(5);
var Items=function Items(_ref){var label=_ref.label,click=_ref.click,index=_ref.index,icon=_ref.icon,items=_ref.items,path=_ref.path,closeMenu=_ref.closeMenu,type=_ref.type;return items.length===0&&path?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return closeMenu();}},type==='external'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'link',href:path,'aria-label':label,className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-2 pt-half'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto','aria-hiden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon-sm',className:'icon_right invisible_icon','aria-hidden':'true'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hide-absolute'},'Este \xE9 um link externo. Ao clicar nele, voc\xEA ser\xE1 direcionado para outo site em uma nova aba no seu navegador.'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"],{role:'link',to:path,'aria-label':label,className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative','aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-2 pt-half'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto','aria-hiden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon-sm',className:'icon_right invisible_icon'}))))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'button',href:'javascript:void(0)','aria-label':label+', este item possui submenus',onClick:click(index),className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative','aria-hidden':true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-2 pt-half'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon-sm',className:'icon_right'})))))))));};Items.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,click:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,closeMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Items.defaultProps={icon:'icon_menu_app'};/* harmony default export */ __webpack_exports__["a"] = (Items);

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ItemsSubitems__ = __webpack_require__(1711);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubItems=function(_Component){_inherits(SubItems,_Component);function SubItems(props){_classCallCheck(this,SubItems);var _this=_possibleConstructorReturn(this,(SubItems.__proto__||Object.getPrototypeOf(SubItems)).call(this,props));_this.MaxLength=function(value){return value.length>30?value.substring(0,29):value;};_this.closeMenu=function(){var checkMenu=document.getElementById('menuToggle');_this.props.displayMenu[_this.props.index].display=false;if(checkMenu&&checkMenu.checked===true){checkMenu.checked=false;}_this.props.callReset();};_this.handleSubmenu=function(item){_this.setState({subItemsSelected:true,selectedItem:item});};_this.handleBackButtonItemsSubitems=function(){_this.setState({subItemsSelected:false,selectedItem:[]});};_this.state={subItemsSelected:false,selectedItem:[]};return _this;}_createClass(SubItems,[{key:'render',value:function render(){var _this2=this;var _state=this.state,subItemsSelected=_state.subItemsSelected,selectedItem=_state.selectedItem;return subItemsSelected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ItemsSubitems__["a" /* default */],{selectedItem:selectedItem,closeMenu:this.closeMenu,handleBackButtonItemsSubitems:this.handleBackButtonItemsSubitems}):this.props.displayMenu[this.props.index].display&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subMenuToggle '+(this.props.displayMenu[this.props.index].display?'active':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'txt-left radius px-0 py-0',tabIndex:-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-ui-3 border-bottom bg-brand-2 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'btn-close-submenu',onClick:this.props.close(-1),className:'btn btn-flat btn-sm btn-icon txt-font-body txt-body txt-font-body py-2 mx-1','aria-label':'Voltar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_left_app',className:'icon-sm'})))),this.props.items.map(function(item){return item.items.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){_this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:item.path,'aria-label':_this2.MaxLength(item.label),className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-2 pt-half py-half py-half','aria-hidden':true},_this2.MaxLength(item.label))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.handleSubmenu(item);},'aria-label':_this2.MaxLength(item.label)+' este item possui subitems',className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-2 pt-half txt-capitalize','aria-hidden':true},_this2.MaxLength(item.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-0 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_right',className:'icon-sm'})))))))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-path':this.props.path,className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile '+((!this.props.path||this.props.path)==='#'?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center pos-relative my-1 py-1 border-top border-color-ui-3',onClick:function onClick(){return _this2.closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'btn btn-flat btn-icon txt-font-body txt-initial txt-body',to:this.props.path,'aria-label':'Ver todas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{'aria-hidden':true},'Ver todas'))))));}}]);return SubItems;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubItems.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,displayMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,close:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,callReset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};SubItems.defaultProps={path:'#'};/* harmony default export */ __webpack_exports__["a"] = (SubItems);

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
var ItemsSubitems=function ItemsSubitems(_ref){var selectedItem=_ref.selectedItem,closeMenu=_ref.closeMenu,handleBackButtonItemsSubitems=_ref.handleBackButtonItemsSubitems;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){document.getElementById('voltar_subitem').focus();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subMenuToggle active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'txt-left radius px-0 py-0',tabIndex:-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-ui-3 border-bottom bg-brand-2 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return handleBackButtonItemsSubitems();},className:'btn btn-flat btn-sm btn-icon txt-font-body txt-body txt-font-body py-2 mx-1','aria-label':'Voltar',id:'voltar_subitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_left_app',className:'icon-sm'})))),selectedItem.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 py-0 border-color-brand-5 h-100 item-menu-mobile',key:'item_subitem_'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0',onClick:function onClick(){return closeMenu();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{className:'btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile',to:item.path,'aria-label':item.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col ml-2 py-half','aria-hidden':true},item.label))))));})));};ItemsSubitems.propTypes={selectedItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,closeMenu:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleBackButtonItemsSubitems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ItemsSubitems);

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
var redirectLogin=function redirectLogin(){window.location.href='/auth/login';};var GuestUserProfile=function GuestUserProfile(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'px-1 h-auto border-color-ui-3 border-bottom bg-brand-2 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return redirectLogin();},className:'btn btn-sm btn-double btn-flat btn-icon txt-font-body txt-initial txt-body txt-left py-1',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_profile color-ui-white'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm color-ui-white'},'Ol\xE1, fa\xE7a o seu login'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-body-sm color-brand-6'},'ou cadastre-se'))));};/* harmony default export */ __webpack_exports__["a"] = (GuestUserProfile);

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuMobile__ = __webpack_require__(637);
var mapStateToProps=function mapStateToProps(_ref){var tradeMenu=_ref.mainMenu.tradeMenu,productCategories=_ref.productCategories,stores=_ref.stores,pointsName=_ref.catalog.currencyConfiguration.pointsName,balance=_ref.balance,publicUser=_ref.publicUser;return{tradeMenu:tradeMenu,productCategories:productCategories,stores:stores,pointsName:pointsName,balance:balance,publicUser:publicUser};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MenuMobile__["a" /* default */]));

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuHome__ = __webpack_require__(1715);
var mapStateToProps=function mapStateToProps(_ref){var mainMenu=_ref.mainMenu,profile=_ref.oidc.user.profile;return{tradeMenu:(profile?mainMenu[profile['custom:catalog_id']]?mainMenu[profile['custom:catalog_id']]:mainMenu['default']:mainMenu['default']).tradeMenu};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__MenuHome__["a" /* default */]));

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var checkMenuContext=function checkMenuContext(onlyCash){var context=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var currentContext=onlyCash?'cash':'points';return context.indexOf(currentContext)>-1;};var MenuHomeMobile=function MenuHomeMobile(_ref){var onlyCash=_ref.onlyCash,items=_ref.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-carousel menu-carousel-mobile container draggable d-block d-sm-none  '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 flex-nowrap flex-md-wrap'},items.map(function(item,index){return checkMenuContext(onlyCash,item.context||['points','cash'])&&item.path&&item.path!=='#'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItemMobile,{key:index,item:item});})));};MenuHomeMobile.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var MenuHomeDesktop=function MenuHomeDesktop(_ref2){var onlyCash=_ref2.onlyCash,items=_ref2.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-carousel menu-carousel-desktop container px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height mx-0 px-0'},items.map(function(item,index){return checkMenuContext(onlyCash,item.context||['points','cash'])&&item.path&&item.path!=='#'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItemDesktop,{key:index,item:item});})));};MenuHomeDesktop.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var MenuItemMobile=function MenuItemMobile(_ref3){var item=_ref3.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col menu-categories-home-item px-1 border border-color-ui-3 radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:item.path,className:'d-block',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:item.icon,className:'icon-mmd color-brand-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-1 txt-body txt-bold color-title'},item.label))));};MenuItemMobile.propTypes={item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var MenuItemDesktop=function MenuItemDesktop(_ref4){var item=_ref4.item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col menu-categories-home-item px-1 border border-color-ui-3 radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:item.path,className:'row align-items-center h-100 mx-0',role:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{iconName:item.icon,className:'icon-mmd color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt-1 txt-body txt-bold color-title'},item.label))));};MenuItemDesktop.propTypes={item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var MenuHome=function(_Component){_inherits(MenuHome,_Component);function MenuHome(props){_classCallCheck(this,MenuHome);var _this=_possibleConstructorReturn(this,(MenuHome.__proto__||Object.getPrototypeOf(MenuHome)).call(this));_this.mountDisplay=function(items){items.map(function(__,index){return _this.state.displayMenu.push({index:index,display:false});});};_this.state={displayMenu:[]};_this.items=props.tradeMenu.items;return _this;}_createClass(MenuHome,[{key:'componentWillMount',value:function componentWillMount(){this.mountDisplay(this.props.tradeMenu.items);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-categories-home container-fluid bg-white px-0 pt-1 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuHomeMobile,{onlyCash:this.props.onlyCash,items:this.items})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuHomeDesktop,{onlyCash:this.props.onlyCash,items:this.items})));}}]);return MenuHome;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MenuHome.propTypes={tradeMenu:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref5){var onlyCash=_ref5.onlyCash;return{onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(MenuHome));

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_style_tag__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var ResetFooter=function ResetFooter(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_style_tag__["a" /* Style */],null,'\n          footer.box-footer {\n            margin-top: '+(props.top?props.top:'-175px')+';\n          }\n        ');};ResetFooter.propTypes={top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* unused harmony default export */ var _unused_webpack_default_export = (ResetFooter);

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Style__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hash__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(638);
/* unused harmony reexport hashKeys */
/* unused harmony reexport setGlobalOptions */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Style__["a"]; });
// components


// hash


// options




/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export componentDidMount */
/* unused harmony export getSnapshotBeforeUpdate */
/* unused harmony export componentDidUpdate */
/* unused harmony export componentWillUnmount */
/* unused harmony export getStyleForState */
/* unused harmony export relocateNode */
/* unused harmony export returnNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_parm__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blob__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__options__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(1722);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// external dependencies




// blob


// constants


// options


// styles


/**
 * @function componentDidMount
 *
 * @description
 * on mount, relocate the node
 *
 * @param {ReactComponent} instance the component instance
 * @param {HTMLElement} instance.node the node to render the styles into
 * @param {function} instance.relocateNote the method to relocate the node to the head
 * @returns {void}
 */
var componentDidMount = function componentDidMount(_ref) {
  var node = _ref.node,
      relocateNode = _ref.relocateNode;
  return relocateNode(node);
};

/**
 * @function getSnapshotBeforeUpdate
 *
 * @description
 * before the update occurs, if the sourceMap requirements have changed, return the node to its original position
 *
 * @param {ReactComponent} instance the component instance
 * @param {HTMLElement} instance.node the node to render the styles into
 * @param {function} instance.returnNode the method to return the node to its original parent
 * @returns {null}
 */
var getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(_ref2) {
  var node = _ref2.node,
      returnNode = _ref2.returnNode;

  returnNode(node);

  return null;
};

/**
 * @function componentDidUpdate
 *
 * @description
 * on update, if the sourceMap requirements have changed then relocate the new node to the head,
 * and if the styles have changed then set them in staet
 *
 * @param {ReactComponent} instance the component instance
 * @param {function} instance.getStyleForState the method to get the new rendered style
 * @param {HTMLElement} instance.node the node to render the styles into
 * @param {function} instance.relocateNote the method to relocate the node to the head
 * @param {Object} instance.props the new props of the component
 * @param {function} instance.setState the method to set the state of the component
 * @param {Array<any>} args the arguments passed to the function
 * @param {Object} previousProps the previous props of the component
 */
var componentDidUpdate = function componentDidUpdate(_ref3, _ref4) {
  var getStyleForState = _ref3.getStyleForState,
      node = _ref3.node,
      relocateNode = _ref3.relocateNode,
      props = _ref3.props,
      setState = _ref3.setState;
  var previousProps = _ref4[0];

  relocateNode(node);

  if (props.children !== previousProps.children) {
    setState(getStyleForState);
  }
};

/**
 * @function componentWillUnmount
 *
 * @description
 * prior to unmount, return the node to its original parent
 *
 * @param {ReactComponent} instance the component instance
 * @param {HTMLElement} instance.node the node to render the styles into
 * @param {function} instance.returnNode the method to return the node to its original parent
 * @returns {void}
 */
var componentWillUnmount = function componentWillUnmount(_ref5) {
  var node = _ref5.node,
      returnNode = _ref5.returnNode;
  return returnNode(node);
};

/**
 * @function getStyleForState
 *
 * @description
 * get the styles to be used for the rendered tag
 *
 * @param {ReactComponent} instance the component instance
 * @param {Object} instance.props the new props of the component
 * @returns {{style: string}} the style strng to use in the rendered tag
 */
var getStyleForState = function getStyleForState(_ref6) {
  var props = _ref6.props;
  return {
    style: Object(__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* getRenderedStyles */])(props.children, {
      isCompressed: Object(__WEBPACK_IMPORTED_MODULE_5__options__["a" /* getCoalescedOption */])(props, 'isCompressed'),
      isMinified: Object(__WEBPACK_IMPORTED_MODULE_5__options__["a" /* getCoalescedOption */])(props, 'isMinified'),
      isPrefixed: Object(__WEBPACK_IMPORTED_MODULE_5__options__["a" /* getCoalescedOption */])(props, 'isPrefixed')
    })
  };
};

/**
 * @function relocateNode
 *
 * @description
 * relocate the node to the bottom of the head
 *
 * @param {ReactComponent} instance the component instance
 * @param {Array<any>} args the arguments passed to the function
 * @param {HTMLElement} node the node to render the styles into
 */
var relocateNode = function relocateNode(instance, _ref7) {
  var node = _ref7[0];

  if (typeof document !== 'undefined' && node) {
    instance.originalParent = node.parentNode;

    instance.originalParent.removeChild(node);
    document.head.appendChild(node);
  }
};

/**
 * @function returnNode
 *
 * @description
 * return the node to the original parent
 *
 * @param {ReactComponent} instance the component instance
 * @param {Array<any>} args the arguments passed to the function
 * @param {HTMLElement} node the node to render the styles into
 */
var returnNode = function returnNode(instance, _ref8) {
  var node = _ref8[0];

  if (typeof document !== 'undefined' && node) {
    try {
      document.head.removeChild(node);
      instance.originalParent.appendChild(node);
    } catch (error) {
      // ignore the error
    } finally {
      instance.node = null;
      instance.originalParent = null;
    }
  }
};

var Style = function (_PureComponent) {
  _inherits(Style, _PureComponent);

  function Style(props) {
    _classCallCheck(this, Style);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.componentDidMount = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, componentDidMount);
    _this.componentDidUpdate = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, componentDidUpdate);
    _this[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* SUPPORTS_BEFORE_UPDATE_SNAPSHOT */] ? 'getSnapshotBeforeUpdate' : 'componentWillUpdate'] = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, getSnapshotBeforeUpdate);
    _this.componentWillUnmount = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, componentWillUnmount);
    _this.linkHref = null;
    _this.node = null;
    _this.originalParent = null;
    _this.getCachedLinkHref = Object(__WEBPACK_IMPORTED_MODULE_3__blob__["a" /* createGetCachedLinkHref */])();
    _this.getStyleForState = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, getStyleForState);
    _this.relocateNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, relocateNode);
    _this.returnNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["b" /* createMethod */])(_this, returnNode);


    _this.state = getStyleForState({ props: props });
    return _this;
  }

  // lifecycle methods

  /* eslint-disable react/sort-comp */

  /* eslint-enable */


  // instance values


  // static methods


  // instance methods


  Style.prototype.render = function render() {
    var _props = this.props,
        childrenIgnored = _props.children,
        hasSourceMapIgnored = _props.hasSourceMap,
        isMinifiedIgnored = _props.isCompressed,
        isPrefixedIgnored = _props.isPrefixed,
        props = _objectWithoutProperties(_props, ['children', 'hasSourceMap', 'isCompressed', 'isPrefixed']);

    var style = this.state.style;


    if (Object(__WEBPACK_IMPORTED_MODULE_5__options__["a" /* getCoalescedOption */])(this.props, 'hasSourceMap')) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__blob__["b" /* hasBlobSupport */])()) {
        return (
          /* eslint-disable prettier */
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('link', _extends({}, props, {
            href: this.getCachedLinkHref(style),
            ref: Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["a" /* createElementRef */])(this, 'node'),
            rel: 'stylesheet'
          }))
          /* eslint-enable */

        );
      }

      /* eslint-disable no-console */
      console.error('To support sourcemaps for react-style-tag you need Blob support, and the browser you are using does not currently support it. You should include a polyfill prior to the rendering of this component.');
      /* eslint-enable */
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'style',
      _extends({
        ref: Object(__WEBPACK_IMPORTED_MODULE_2_react_parm__["a" /* createElementRef */])(this, 'node')
      }, props),
      style
    );
  };

  return Style;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Style.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  hasSourceMap: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isCompressed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isMinified: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isPrefixed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
Style.setGlobalOptions = __WEBPACK_IMPORTED_MODULE_5__options__["b" /* setGlobalOptions */];


/* harmony default export */ __webpack_exports__["a"] = (Style);

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createCombinedRef */
/* unused harmony export createComponentRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createElementRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createMethod; });
/* unused harmony export createComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1720);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// external dependencies



// utils


/**
 * @function createCombinedRef
 *
 * @description
 * create a ref that assigns both the raw component and the underlying HTML element to the instance on a namespace
 *
 * @param {ReactComponent} instance the instance to assign to
 * @param {string} ref the instance value name
 * @returns {{component: ReactComponent, element: HTMLElement}} the combined ref
 */
var createCombinedRef = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* createRefCreator */])(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* getNamespacedRef */]);

/**
 * @function createComponentRef
 *
 * @description
 * create a ref that assigns the component itself to the instance
 *
 * @param {ReactComponent} instance the instance to assign to
 * @param {string} ref the instance value name
 * @returns {ReactComponent} the component ref
 */
var createComponentRef = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* createRefCreator */])(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* identity */]);

/**
 * @function createElementRef
 *
 * @description
 * create a ref that assigns the component's underlying HTML element to the instance
 *
 * @param {ReactComponent} instance the instance to assign to
 * @param {string} ref the instance value name
 * @returns {HTMLElement} the element ref
 */
var createElementRef = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* createRefCreator */])(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"]);

/**
 * @function createMethod
 *
 * @description
 * create a method that is a pure version of the lifecycle / instance method passed to it
 *
 * the conditional function return is to ensure the method is called with as performant a way as possible
 *
 * @param {ReactComponent} instance the instance the method is assigned to
 * @param {function} method the instance method
 * @param {Array<any>} extraArgs additional args to pass to the method
 * @returns {function(...Array<any>): any} the method with the instance passed as value
 */
var createMethod = function createMethod(instance, method) {
  for (var _len = arguments.length, extraArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    extraArgs[_key - 2] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isClassComponent */])(instance) ? Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* bindSetState */])(instance) && function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return method.call(instance, instance, args, extraArgs);
  } : Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* logInvalidInstanceError */])('method');
}; // eslint-disable-line no-console

/**
 * @function createComponent
 *
 * @description
 * create a component from the render method and any options passed
 *
 * @param {function} render the function to render the component
 * @param {Object} [options={}] the options to render the component with
 * @param {function} [getInitialState] the method to get the initial state with
 * @param {boolean} [isPure] is PureComponent used
 * @param {Object} [state] the initial state
 * @returns {ReactComponent} the component class
 */
var createComponent = function createComponent(render) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var getInitialState = _ref.getInitialState,
      isPure = _ref.isPure,
      state = _ref.state,
      options = _objectWithoutProperties(_ref, ['getInitialState', 'isPure', 'state']);

  var Constructor = isPure ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent : __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

  function ParmComponent(initialProps) {
    var _this = this;

    Constructor.call(this, initialProps);

    this.state = typeof getInitialState === 'function' ? createMethod(this, getInitialState)() : state || null;

    Object.keys(options).forEach(function (key) {
      _this[key] = typeof options[key] === 'function' ? createMethod(_this, options[key]) : options[key];
    });

    this.render = createMethod(this, render);

    return this;
  }

  ParmComponent.prototype = Object.create(Constructor.prototype);

  ParmComponent.displayName = render.displayName || render.name || 'ParmComponent';
  ParmComponent.propTypes = render.propTypes;
  ParmComponent.contextTypes = render.contextTypes;
  ParmComponent.childContextTypes = render.childContextTypes;
  ParmComponent.defaultProps = render.defaultProps;

  return ParmComponent;
};


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindSetState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return logInvalidInstanceError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRefCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNamespacedRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return identity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// external dependencies



/**
 * @function bindSetState
 *
 * @description
 * bind the setState method to the component instance to ensure it can be used in a functional way
 *
 * @param {ReactComponent} instance the instance to bind setState to
 * @returns {void}
 */
var bindSetState = function bindSetState(instance) {
  return instance.setState = instance.setState.bind(instance);
};

/**
 * @function isClassComponent
 *
 * @description
 * is the value passed a valid react component class instance
 *
 * @param {any} value the value to test
 * @returns {boolean} is the value a react component instance
 */
var isClassComponent = function isClassComponent(value) {
  return !!value && value instanceof __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;
};

/**
 * @function logInvalidInstanceError
 *
 * @description
 * notify the user that the instance passed is invalid
 *
 * @param {string} type the type of creator being called
 * @returns {void}
 */
var logInvalidInstanceError = function logInvalidInstanceError(type) {
  return console.error('The instance provided for use with the ' + type + ' is not a valid React component instance.');
}; // eslint-disable-line no-console

/**
 * @function createRefCreator
 *
 * @description
 * create a method that will assign a ref value to the instance passed
 *
 * @param {function} getter the function that gets the component value for the ref
 * @returns {function(ReactComponent, string): function((HTMLElement|Component)): void} the ref create
 */
var createRefCreator = function createRefCreator(getter) {
  return function (instance, ref) {
    return isClassComponent(instance) ? function (component) {
      return instance[ref] = getter(component);
    } : logInvalidInstanceError('ref');
  };
};

/**
 * @function getNamespacedRef
 *
 * @description
 * get the ref that is a combination of the raw component and the component's underlying HTML element
 *
 * @param {ReactComponent} component the component to assin
 * @returns {{component: ReactComponent, element: HTMLElement}} the namespaced ref
 */
var getNamespacedRef = function getNamespacedRef(component) {
  return { component: component, element: Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(component) };
};

/**
 * @function identity
 *
 * @description
 * return the first parameter passed
 *
 * @param {any} value the value to pass through
 * @returns {any} the first parameter passed
 */
var identity = function identity(value) {
  return value;
};

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUrl */
/* unused harmony export getHasBlobSupport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasBlobSupport; });
/* unused harmony export getLinkHref */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createGetCachedLinkHref; });
/**
 * @function getUrl
 *
 * @description
 * get the URL used to generate blobs
 *
 * @returns {Object} the URL object to generate blobs with
 */
var getUrl = function () {
  var defaultObject = {};

  var URL = defaultObject;

  var getUrl = function getUrl() {
    return URL !== defaultObject ? URL : URL = typeof window !== 'undefined' ? window.URL || window.webkitURL : defaultObject;
  };

  getUrl.reset = function () {
    return URL = defaultObject;
  };

  return getUrl;
}();

/**
 * @function getHasBlobSupport
 *
 * @description
 * get whether Blobs are supported in the runtime
 *
 * @returns {boolean} are Blobs supported
 */
var getHasBlobSupport = function getHasBlobSupport() {
  return typeof window !== 'undefined' && typeof window.Blob === 'function' && typeof getUrl().createObjectURL === 'function' && function () {
    try {
      new window.Blob();

      return true;
    } catch (error) {
      return false;
    }
  }();
};

/**
 * @function hasBlobSupport
 *
 * @description
 * a cached reference to determine Blob support in the runtime
 *
 * @returns {boolean} are Blobs supported
 */
var hasBlobSupport = function () {
  var support = false;

  var hasBlobSupport = function hasBlobSupport() {
    return support || (support = getHasBlobSupport());
  };

  hasBlobSupport.reset = function () {
    return support = false;
  };

  return hasBlobSupport;
}();

/**
 * @function getLinkHref
 *
 * @description
 * get the href of the link based on the style string Blob
 *
 * @param {string} style the style to create the Blob from
 * @returns {string} the data URI built from the Blob
 */
var getLinkHref = function getLinkHref(style) {
  return hasBlobSupport() ? getUrl().createObjectURL(new window.Blob([style], { type: 'text/css' })) : null;
};

/**
 * @function createGetCachedLinkHref
 *
 * @description
 * create a cached version of the getLinkHref
 *
 * @returns {function(string): string} the cached version of getLinkHref
 */
var createGetCachedLinkHref = function createGetCachedLinkHref() {
  return function () {
    var href = null,
        currentStyle = null;

    return function (style) {
      return style === currentStyle ? href : (currentStyle = style) ? href = getLinkHref(style) : href = null;
    };
  }();
};

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getProcessedStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRenderedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cssbeautify__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cssbeautify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cssbeautify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(319);
// external dependencies



// constants


/**
 * @function getProcessedStyles
 *
 * @description
 * get the styles processed by stylis
 *
 * @param {string} rawStyle the style to process
 * @param {Object} props the props passed to the component
 * @param {boolean} props.isCompressed is compressed CSS output requested
 * @param {boolean} props.isPrefixed is vendor-prefixed CSS requested
 * @returns {string} the processed styles
 */
var getProcessedStyles = function getProcessedStyles(rawStyle, _ref) {
  var isCompressed = _ref.isCompressed,
      isPrefixed = _ref.isPrefixed;
  return new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
    compress: isCompressed,
    global: false,
    keyframe: false,
    prefix: isPrefixed
  })('', rawStyle);
};

/**
 * @function getRenderedStyles
 *
 * @description
 * get the styles rendered in the HTML tag
 *
 * @param {string} rawStyle the style to process
 * @param {Object} props the props passed to the component
 * @param {boolean} props.isMinified is minified CSS output requested
 * @returns {string} the styles to use in the rendered tag
 */
var getRenderedStyles = function getRenderedStyles(rawStyle, props) {
  return props.isMinified ? getProcessedStyles(rawStyle, props) : __WEBPACK_IMPORTED_MODULE_0_cssbeautify___default()(getProcessedStyles(rawStyle, props), __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* BEAUTIFY_OPTIONS */]);
};

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

/*
 Copyright (C) 2013 Sencha Inc.
 Copyright (C) 2012 Sencha Inc.
 Copyright (C) 2011 Sencha Inc.

 Author: Ariya Hidayat.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
*/

/*jslint continue: true, indent: 4 */
/*global exports:true, module:true, window:true */

(function () {

    'use strict';

    function cssbeautify(style, opt) {

        var options, index = 0, length = style.length, blocks, formatted = '',
            ch, ch2, str, state, State, depth, quote, comment,
            openbracesuffix = true,
            autosemicolon = false,
            trimRight;

        options = arguments.length > 1 ? opt : {};
        if (typeof options.indent === 'undefined') {
            options.indent = '    ';
        }
        if (typeof options.openbrace === 'string') {
            openbracesuffix = (options.openbrace === 'end-of-line');
        }
        if (typeof options.autosemicolon === 'boolean') {
            autosemicolon = options.autosemicolon;
        }

        function isWhitespace(c) {
            return (c === ' ') || (c === '\n') || (c === '\t') || (c === '\r') || (c === '\f');
        }

        function isQuote(c) {
            return (c === '\'') || (c === '"');
        }

        // FIXME: handle Unicode characters
        function isName(c) {
            return (ch >= 'a' && ch <= 'z') ||
                (ch >= 'A' && ch <= 'Z') ||
                (ch >= '0' && ch <= '9') ||
                '-_*.:#[]'.indexOf(c) >= 0;
        }

        function appendIndent() {
            var i;
            for (i = depth; i > 0; i -= 1) {
                formatted += options.indent;
            }
        }

        function openBlock() {
            formatted = trimRight(formatted);
            if (openbracesuffix) {
                formatted += ' {';
            } else {
                formatted += '\n';
                appendIndent();
                formatted += '{';
            }
            if (ch2 !== '\n') {
                formatted += '\n';
            }
            depth += 1;
        }

        function closeBlock() {
            var last;
            depth -= 1;
            formatted = trimRight(formatted);

            if (formatted.length > 0 && autosemicolon) {
                last = formatted.charAt(formatted.length - 1);
                if (last !== ';' && last !== '{') {
                    formatted += ';';
                }
            }

            formatted += '\n';
            appendIndent();
            formatted += '}';
            blocks.push(formatted);
            formatted = '';
        }

        if (String.prototype.trimRight) {
            trimRight = function (s) {
                return s.trimRight();
            };
        } else {
            // old Internet Explorer
            trimRight = function (s) {
                return s.replace(/\s+$/, '');
            };
        }

        State = {
            Start: 0,
            AtRule: 1,
            Block: 2,
            Selector: 3,
            Ruleset: 4,
            Property: 5,
            Separator: 6,
            Expression: 7,
            URL: 8
        };

        depth = 0;
        state = State.Start;
        comment = false;
        blocks = [];

        // We want to deal with LF (\n) only
        style = style.replace(/\r\n/g, '\n');

        while (index < length) {
            ch = style.charAt(index);
            ch2 = style.charAt(index + 1);
            index += 1;

            // Inside a string literal?
            if (isQuote(quote)) {
                formatted += ch;
                if (ch === quote) {
                    quote = null;
                }
                if (ch === '\\' && ch2 === quote) {
                    // Don't treat escaped character as the closing quote
                    formatted += ch2;
                    index += 1;
                }
                continue;
            }

            // Starting a string literal?
            if (isQuote(ch)) {
                formatted += ch;
                quote = ch;
                continue;
            }

            // Comment
            if (comment) {
                formatted += ch;
                if (ch === '*' && ch2 === '/') {
                    comment = false;
                    formatted += ch2;
                    index += 1;
                }
                continue;
            }
            if (ch === '/' && ch2 === '*') {
                comment = true;
                formatted += ch;
                formatted += ch2;
                index += 1;
                continue;
            }

            if (state === State.Start) {

                if (blocks.length === 0) {
                    if (isWhitespace(ch) && formatted.length === 0) {
                        continue;
                    }
                }

                // Copy white spaces and control characters
                if (ch <= ' ' || ch.charCodeAt(0) >= 128) {
                    state = State.Start;
                    formatted += ch;
                    continue;
                }

                // Selector or at-rule
                if (isName(ch) || (ch === '@')) {

                    // Clear trailing whitespaces and linefeeds.
                    str = trimRight(formatted);

                    if (str.length === 0) {
                        // If we have empty string after removing all the trailing
                        // spaces, that means we are right after a block.
                        // Ensure a blank line as the separator.
                        if (blocks.length > 0) {
                            formatted = '\n\n';
                        }
                    } else {
                        // After finishing a ruleset or directive statement,
                        // there should be one blank line.
                        if (str.charAt(str.length - 1) === '}' ||
                                str.charAt(str.length - 1) === ';') {

                            formatted = str + '\n\n';
                        } else {
                            // After block comment, keep all the linefeeds but
                            // start from the first column (remove whitespaces prefix).
                            while (true) {
                                ch2 = formatted.charAt(formatted.length - 1);
                                if (ch2 !== ' ' && ch2.charCodeAt(0) !== 9) {
                                    break;
                                }
                                formatted = formatted.substr(0, formatted.length - 1);
                            }
                        }
                    }
                    formatted += ch;
                    state = (ch === '@') ? State.AtRule : State.Selector;
                    continue;
                }
            }

            if (state === State.AtRule) {

                // ';' terminates a statement.
                if (ch === ';') {
                    formatted += ch;
                    state = State.Start;
                    continue;
                }

                // '{' starts a block
                if (ch === '{') {
                    str = trimRight(formatted);
                    openBlock();
                    state = (str === '@font-face') ? State.Ruleset : State.Block;
                    continue;
                }

                formatted += ch;
                continue;
            }

            if (state === State.Block) {

                // Selector
                if (isName(ch)) {

                    // Clear trailing whitespaces and linefeeds.
                    str = trimRight(formatted);

                    if (str.length === 0) {
                        // If we have empty string after removing all the trailing
                        // spaces, that means we are right after a block.
                        // Ensure a blank line as the separator.
                        if (blocks.length > 0) {
                            formatted = '\n\n';
                        }
                    } else {
                        // Insert blank line if necessary.
                        if (str.charAt(str.length - 1) === '}') {
                            formatted = str + '\n\n';
                        } else {
                            // After block comment, keep all the linefeeds but
                            // start from the first column (remove whitespaces prefix).
                            while (true) {
                                ch2 = formatted.charAt(formatted.length - 1);
                                if (ch2 !== ' ' && ch2.charCodeAt(0) !== 9) {
                                    break;
                                }
                                formatted = formatted.substr(0, formatted.length - 1);
                            }
                        }
                    }

                    appendIndent();
                    formatted += ch;
                    state = State.Selector;
                    continue;
                }

                // '}' resets the state.
                if (ch === '}') {
                    closeBlock();
                    state = State.Start;
                    continue;
                }

                formatted += ch;
                continue;
            }

            if (state === State.Selector) {

                // '{' starts the ruleset.
                if (ch === '{') {
                    openBlock();
                    state = State.Ruleset;
                    continue;
                }

                // '}' resets the state.
                if (ch === '}') {
                    closeBlock();
                    state = State.Start;
                    continue;
                }

                formatted += ch;
                continue;
            }

            if (state === State.Ruleset) {

                // '}' finishes the ruleset.
                if (ch === '}') {
                    closeBlock();
                    state = State.Start;
                    if (depth > 0) {
                        state = State.Block;
                    }
                    continue;
                }

                // Make sure there is no blank line or trailing spaces inbetween
                if (ch === '\n') {
                    formatted = trimRight(formatted);
                    formatted += '\n';
                    continue;
                }

                // property name
                if (!isWhitespace(ch)) {
                    formatted = trimRight(formatted);
                    formatted += '\n';
                    appendIndent();
                    formatted += ch;
                    state = State.Property;
                    continue;
                }
                formatted += ch;
                continue;
            }

            if (state === State.Property) {

                // ':' concludes the property.
                if (ch === ':') {
                    formatted = trimRight(formatted);
                    formatted += ': ';
                    state = State.Expression;
                    if (isWhitespace(ch2)) {
                        state = State.Separator;
                    }
                    continue;
                }

                // '}' finishes the ruleset.
                if (ch === '}') {
                    closeBlock();
                    state = State.Start;
                    if (depth > 0) {
                        state = State.Block;
                    }
                    continue;
                }

                formatted += ch;
                continue;
            }

            if (state === State.Separator) {

                // Non-whitespace starts the expression.
                if (!isWhitespace(ch)) {
                    formatted += ch;
                    state = State.Expression;
                    continue;
                }

                // Anticipate string literal.
                if (isQuote(ch2)) {
                    state = State.Expression;
                }

                continue;
            }

            if (state === State.Expression) {

                // '}' finishes the ruleset.
                if (ch === '}') {
                    closeBlock();
                    state = State.Start;
                    if (depth > 0) {
                        state = State.Block;
                    }
                    continue;
                }

                // ';' completes the declaration.
                if (ch === ';') {
                    formatted = trimRight(formatted);
                    formatted += ';\n';
                    state = State.Ruleset;
                    continue;
                }

                formatted += ch;

                if (ch === '(') {
                    if (formatted.charAt(formatted.length - 2) === 'l' &&
                            formatted.charAt(formatted.length - 3) === 'r' &&
                            formatted.charAt(formatted.length - 4) === 'u') {

                        // URL starts with '(' and closes with ')'.
                        state = State.URL;
                        continue;
                    }
                }

                continue;
            }

            if (state === State.URL) {


                // ')' finishes the URL (only if it is not escaped).
                if (ch === ')' && formatted.charAt(formatted.length - 1 !== '\\')) {
                    formatted += ch;
                    state = State.Expression;
                    continue;
                }
            }

            // The default action is to copy the character (to prevent
            // infinite loop).
            formatted += ch;
        }

        formatted = blocks.join('') + formatted;

        return formatted;
    }

    if (true) {
        // Node.js module.
        module.exports = exports = cssbeautify;
    } else if (typeof window === 'object') {
        // Browser loading.
        window.cssbeautify = cssbeautify;
    }

}());


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hash */
/* unused harmony export hashKeys */
var counter = 0;

/**
 * @function hash
 *
 * @description
 * simple bitwise hash of string value
 *
 * @param {string} key ASCII only
 * @return {number} 32-bit positive integer hash
 */
var hash = function hash(key) {
  var stringToHash = key + "-" + counter;

  var hashValue = 5381,
      index = stringToHash.length;

  while (index) {
    hashValue = hashValue * 33 ^ stringToHash.charCodeAt(--index);
  }

  return "scoped__" + key + "__" + (hashValue >>> 0);
};

/**
 * @function hashKeys
 *
 * @description
 * create a hash map based on the keys passed
 *
 * @param {Array<string>} keys the keys to hash
 * @returns {Object} the hashmap of key => has pairs
 */
var hashKeys = function hashKeys(keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = hash(key);

    return hashMap;
  }, {});
};

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var IuppFooter=function IuppFooter(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,'\'teste\'');};/* unused harmony default export */ var _unused_webpack_default_export = (IuppFooter);

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_app_store_svg__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_images_app_store_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_images_app_store_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_logo_bg_light_png__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_logo_bg_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_logo_bg_light_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_google_play_svg__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_google_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_google_play_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_footer_css__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_MainMenu_MenuMobile__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App_Footer_FooterPlaceholder__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__App_Footer_IuppContactList__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(props){_classCallCheck(this,Footer);var _this=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this.state={isHomeOrGuest:false,isHelpPage:false,isWishlistPage:false,isCartPage:false,profileMenu:false,userMenu:false,stateMenu:true,categoryMenu:false,showIuppMobileMenu:false};_this.openProfileMenu=function(){setTimeout(function(){if(_this.state.userMenu===true){_this.setState({profileMenu:false,userMenu:false});}else{_this.setState({profileMenu:true,userMenu:true,categoryMenu:false,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false});}},300);};_this.openCategoryMenu=function(){setTimeout(function(){if(_this.state.categoryMenu===true){_this.setState({categoryMenu:false});}else{_this.setState({profileMenu:false,userMenu:false,categoryMenu:true,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false});}},300);};_this.callReset=function(e){_this.setState({stateMenu:!_this.state.stateMenu});if(!_this.state.stateMenu||_this.state.categoryMenu||_this.state.userMenu){setTimeout(function(){_this.setState({profileMenu:false,userMenu:false,categoryMenu:false});},300);}};_this.closeMenu=function(){var checkMenu=document.getElementById('menuToggle');if(checkMenu&&checkMenu.checked===true){checkMenu.checked=false;}_this.callReset();};_this.activePage=function(){_this.closeMenu();setTimeout(function(){var activeRoute=window.location.pathname.substring(window.location.pathname.lastIndexOf('/'));if(activeRoute==='/'){_this.setState({isHomeOrGuest:true,isHelpPage:false,isProfile:false,isCartPage:false,showIuppMobileMenu:false});}else if(activeRoute==='/faq'){_this.setState({isHomeOrGuest:false,isHelpPage:true,isProfile:false,isCartPage:false,showIuppMobileMenu:false});}else if(activeRoute==='/profile'||activeRoute==='/wishlist'||activeRoute==='/extract'||activeRoute==='/my-orders'||activeRoute==='/my-address'||activeRoute==='/scheduling'){_this.setState({isHomeOrGuest:false,isHelpPage:false,isProfile:true,isCartPage:false,showIuppMobileMenu:false});}else if(activeRoute==='/cart'){_this.setState({isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:true,showIuppMobileMenu:false});}else{_this.setState({isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false,showIuppMobileMenu:false});}},1);};_this.profileMenuState=_this.profileMenuState.bind(_this);_this.callReset=_this.callReset.bind(_this);_this.activePage=_this.activePage.bind(_this);_this.state={profileMenu:false,userMenu:false,categoryMenu:true,isHomeOrGuest:false,isHelpPage:false,isProfile:false,isCartPage:false,openNPS:false,showIuppMobileMenu:false};return _this;}// Apenas para o modo responsivo
_createClass(Footer,[{key:'profileMenuState',value:function profileMenuState(){this.setState({profileMenu:!this.state.profileMenu});}},{key:'openNPS',value:function openNPS(){this.setState({openNPS:!this.state.openNPS});}},{key:'componentDidMount',value:function componentDidMount(){this.activePage();}},{key:'toggleMenuMobileIupp',value:function toggleMenuMobileIupp(){this.setState({showIuppMobileMenu:!this.state.showIuppMobileMenu,isHomeOrGuest:!this.state.isHomeOrGuest});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__App_Footer_FooterPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('footer',{className:'box-footer d-print-none',role:'contentinfo'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_responsive___default.a,{maxDeviceWidth:1025},__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('section',{className:this.state.showIuppMobileMenu?'open-menu-iupp menu-mobile-iupp':'close-menu-iupp menu-mobile-iupp'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('section',{className:'menu-mobile menu'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('nav',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'flexible-items-container'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{onClick:function onClick(){_this2.toggleMenuMobileIupp();Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','beneficios','meu-negocio');},to:'/meu-negocio/#benefits','data-target':'#benefits',className:'flex-item mn-item mn-benefits',title:'benef\xEDcios que v\xE3o te ajudar a vender mais.',tabIndex:0},'benef\xEDcios'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{onClick:function onClick(){_this2.toggleMenuMobileIupp();Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','ajuda','meu-negocio');},to:'/meu-negocio/#help','data-target':'#help',className:'flex-item mn-item mn-help',title:'est\xE1 com d\xFAvidas? veja nossas perguntas frequentes.',tabIndex:0},'ajuda'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN,className:'flex-item mn-item mn-login',title:'Ir para para area de login',tabIndex:0,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','entrar','meu-negocio');}},'entrar'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP,className:'flex-item mn-item mn-register',title:'Fazer cadastro',tabIndex:0,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','cadastre-se','meu-negocio');}},'cadastre-se'))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'box-footer-mobile'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'container-footer footer-part-mobile bg-brand-2 container-fluid row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isHomeOrGuest?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{to:'/meu-negocio',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.activePage();Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','inicio-meu-negocio','meu-negocio');},onFocus:function onFocus(){return _this2.callReset();},tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_home color-ui-white'}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile'},'In\xEDcio'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.showIuppMobileMenu?'active':'inactive')},this.props.profile?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{className:'not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){return _this2.openCategoryMenu();},'aria-haspop':'true','aria-expanded':this.state.categoryMenu,onFocus:function onFocus(){return _this2.callReset();},role:'button',href:'javascript:void(0)',tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_'+(this.state.categoryMenu?'menu_app_close':'menu_app')+' color-'+(this.state.categoryMenu?'brand-6 txt-body':'brand-5')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},'Menu')),this.state.categoryMenu&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_MainMenu_MenuMobile__["b" /* MenuMobileContainer */],{stateMenu:this.state.stateMenu,callReset:this.callReset,profileMenu:this.state.profileMenu,profileMenuState:this.profileMenuState,categoryMenu:this.state.categoryMenu,userMenu:this.state.userMenu,activePage:this.activePage})):__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){return _this2.toggleMenuMobileIupp();},onFocus:function onFocus(){return _this2.callReset();},tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_'+(this.state.showIuppMobileMenu?'menu_app_close':'menu_app')+' color-'+(this.state.showIuppMobileMenu?'brand-6 txt-body':'brand-5')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},'Menu')):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{to:'/auth/login',className:'color-ui-white txt-body-sm d-flex justify-content-center',tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_'+(this.state.categoryMenu?'menu_app_close':'menu_app')+' color-'+(this.state.categoryMenu?'brand-6 txt-body':'brand-5')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},'Menu'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isCartPage?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)&&!this.props.profile?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{to:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP,className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.activePage();Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','cadastre-se','meu-negocio');},onFocus:function onFocus(){return _this2.callReset();},tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_login color-'+(this.state.isCartPage?'brand-6':'brand-5')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},'Cadastre-se')):''),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isProfile?'active':'inactive')},this.props.profile?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('a',{className:'not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center','aria-haspop':'true','aria-expanded':this.state.userMenu,onClick:function onClick(){return _this2.openProfileMenu();},onFocus:function onFocus(){return _this2.callReset();},role:'button',href:'javascript:void(0)',tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_'+(this.state.userMenu?'menu_app_close':'profile')+' color-'+(this.state.userMenu?'brand-6 txt-body':'brand-5')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},this.props.profile?'Perfil':'Entrar')),this.state.userMenu&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_App_MainMenu_MenuMobile__["b" /* MenuMobileContainer */],{stateMenu:this.state.stateMenu,callReset:this.callReset,profileMenu:this.state.profileMenu,profileMenuState:this.profileMenuState,categoryMenu:this.state.categoryMenu,userMenu:this.state.userMenu,activePage:this.activePage})):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{to:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN,className:'color-ui-white txt-body-sm d-flex justify-content-center',tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_profile color-ui-white'}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},this.props.profile?'Perfil':'Entrar'))),__WEBPACK_IMPORTED_MODULE_12_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col px-0 d-flex justify-content-center '+(this.state.isHelpPage?'active':'inactive')},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{to:'/redirect/faq',className:'color-ui-white txt-body-sm d-flex justify-content-center',onClick:function onClick(){_this2.activePage();Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:menu','ajuda','meu-negocio');},onFocus:function onFocus(){return _this2.callReset();},tabIndex:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_loyal_react__["Icon"],{className:'icon icon_question color-ui-white'}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'},'Ajuda')))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_responsive___default.a,{minDeviceWidth:1026},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'box-footer-desktop'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'container-footer footer-part-1 bg-brand-4 container-fluid py-4 d-none'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'container py-1'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'address col-12 col-md-6 align-self-center'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col-12 col-md-3 pl-0 pr-2 txt-center'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_brand_logo_bg_light_png___default.a,className:'address-logo',alt:'LTM Fidelidade'})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col-12 col-md-8 align-self-center mt-3 mt-md-0'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'txt-body-sm  color-ui-white txt-center txt-md-left'},'Alameda Rio Negro, 585 - 13\xBA andar'),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{className:'txt-body-sm  color-ui-white txt-center txt-md-left'},'Alphaville - Barueri - SP - CEP 06454-000')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'app col-12 col-md-6 d-none'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col-12 col-md-6 txt-right downloadit-app txt-circular-book txt-center txt-md-right mt-3 mt-md-0 align-self-center'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span',{className:'txt-customsize-20x28 d-block'},'Baixe agora o app.')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img',{className:'img-h-100 img-w-auto google-play',src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_google_play_svg___default.a,alt:'Baixe o aplicativo no Google play'})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img',{className:'img-h-100 img-w-auto app-store',src:__WEBPACK_IMPORTED_MODULE_0__loyal_images_app_store_svg___default.a,alt:'Baixe o aplicativo na App Store'}))))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'container-footer footer-part-2 bg-ui-1 container-fluid d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__App_Footer_IuppContactList__["a" /* default */],{profile:this.props.profile}):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('nav',{'aria-label':'Rodap\xE9',className:'links col-12 px-0 py-3'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('ul',{className:'row'},__WEBPACK_IMPORTED_MODULE_12_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li',{className:'col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0','data-href':'/security'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/security',tabIndex:0,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','termos-seguranca','meu-negocio');},target:'_blank'},'Seguran\xE7a')),__WEBPACK_IMPORTED_MODULE_12_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li',{className:'col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0','data-href':'/regulation'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/regulation',tabIndex:0,target:'_blank',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','termos-regulamentos','meu-negocio');}},'Regulamentos')),__WEBPACK_IMPORTED_MODULE_12_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li',{className:'col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0','data-href':'/privacy'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/privacy',tabIndex:0,target:'_blank',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','termos-privacidade','meu-negocio');}},'Politica de Privacidade')),__WEBPACK_IMPORTED_MODULE_12_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li',{className:'col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0','data-href':'/terms'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/terms',tabIndex:0,target:'_blank',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','termos-de-uso','meu-negocio');}},'Termos de uso')),__WEBPACK_IMPORTED_MODULE_12_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('li',{className:'col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0','data-href':'/redirect/faq'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["Link"],{className:'color-ui-white txt-body-sm',to:'/redirect/faq',tabIndex:0,target:'_blank',onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_15_Shared_GTM_getButton__["a" /* getButton */])(false,'home','clique:botao','faq','meu-negocio');}},'Ajuda'))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'row mx-0 px-0'},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'legal col-12 col-md-10 px-0 py-3',role:'contentinfo'}, true?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{tabIndex:0,className:'color-ui-white txt-subtitle txt-center txt-md-left'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MESSAGE_FOOTER_LEGAL||'PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119'):'',__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('p',{tabIndex:0,className:'color-ui-white txt-subtitle txt-center txt-md-left'},'O cat\xE1logo de premia\xE7\xE3o \xE9 atualizado peri\xF3dica e automaticamente pelos parceiros e os produtos e pre\xE7os poder\xE3o sofrer altera\xE7\xF5es durante a navega\xE7\xE3o, sem aviso pr\xE9vio, devendo ser consultados pelo interessado no momento da conclus\xE3o efetiva do resgate.')),!__WEBPACK_IMPORTED_MODULE_12_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_FOOTERIUPP)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:'address col-2 align-self-center txt-center logo-footer',role:'img','aria-label':"Tupperware | Premmiar"||''}))))))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);Footer.propTypes={profile:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_features_ToggleFeature__ = __webpack_require__(639);
var Widgets=function Widgets(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_features_ToggleFeature__["a" /* ToggleFeature */],{feature:__WEBPACK_IMPORTED_MODULE_2_features_ToggleFeature__["b" /* features */].ZendeskWebWidget,src:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ZENDESK_WEBWIDGET_URL})));};/* harmony default export */ __webpack_exports__["a"] = (Widgets);

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_yn__);
var fallback=null;var env=Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}});var features=Object.freeze({RedirectCustomConexxeFeature:__WEBPACK_IMPORTED_MODULE_1_yn___default()(env.REACT_APP_CONEXXE_TOGGLE_REDIRECT)?Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 2285));}):fallback,RedirectCustomZendeskFeature:__WEBPACK_IMPORTED_MODULE_1_yn___default()(env.REACT_APP_ZENDESK_TOGGLE_REDIRECT)?Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 2286));}):fallback,RedirectCustomContactZendeskFeature:__WEBPACK_IMPORTED_MODULE_1_yn___default()(env.REACT_APP_ZENDESK_TOGGLE_REDIRECT)?Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 2287));}):fallback,ZendeskWebWidget:__WEBPACK_IMPORTED_MODULE_1_yn___default()(env.REACT_APP_HAS_ZENDESK_WEBWIDGET)?Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2288));}):fallback});/* harmony default export */ __webpack_exports__["a"] = (features);

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * @prop {Element} feature - Feature component
 * @prop {Element} fallback - Fallback component to render in case feature is not enabled
 * @prop {Element} loader - Loader component to render while feature is not loaded
 * @prop {*} props - All others props passed
 */var ToggleFeature=function ToggleFeature(_ref){var _ref$feature=_ref.feature,Feature=_ref$feature===undefined?null:_ref$feature,_ref$fallback=_ref.fallback,Fallback=_ref$fallback===undefined?null:_ref$fallback,_ref$default=_ref.default,Default=_ref$default===undefined?null:_ref$default,props=_objectWithoutProperties(_ref,['feature','fallback','default']);if(Feature){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:Fallback?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fallback,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Feature,props));}else{return Default&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Default,props);}};ToggleFeature.propTypes={feature:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fallback:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,default:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ToggleFeature);

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_Shell__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HomePage__ = __webpack_require__(1734);
var HomeRouter=function HomeRouter(_ref){var user=_ref.oidc.user;var _ref2=user||{},profile=_ref2.profile;profile=profile||{};return __WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_HOME_ITAU)&&!profile.username?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_App_Shell__["b" /* ShellRoute */],{isGuest:false,path:'/',exact:true,component:__WEBPACK_IMPORTED_MODULE_5__HomePage__["a" /* default */]});};var mapStateToProps=function mapStateToProps(_ref3){var oidc=_ref3.oidc;return{oidc:oidc};};HomeRouter.propTypes={oidc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HomeRouter,props);}));

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HomePageContainer__ = __webpack_require__(1735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HomePageContainer__["a"]; });


/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_HomePage_HomePage__ = __webpack_require__(1736);
var mapStateToProps=function mapStateToProps(_ref){var user=_ref.oidc.user,google=_ref.google;return{profile:user&&user.profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_HomePage_HomePage__["a" /* default */]));

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_modules_carousel_css_owl_theme_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_features_Suggestion__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_features_Services__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_features_Services_BannersVSA__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_features_Services_Mileage__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_App_MainMenu_MenuMobile__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_features_Slider__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_features_AccumulatePoints__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_features_BestOffers__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalCategories__ = __webpack_require__(1827);
// @ts-nocheck
var HomePage=function HomePage(_ref){var profile=_ref.profile;Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){setTimeout(function(){window._etmc.push(['setUserInfo',{'email':profile['custom:participant_id']}]);window._etmc.push(['setOrgId','6422293']);window._etmc.push(['trackPageView']);},3000);},[]);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('title',null,''+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["e" /* SliderContainer */],null),profile&&__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_App_MainMenu_MenuMobile__["a" /* MenuHomeContainer */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_BANNERS_SHOWCASE)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__["a" /* BannersShowcase */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__["e" /* default */],{showcaseType:'5',title:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PRODUCTS_SHOWCASE_TITLE||'Troque seus pontos por produtos dos principais e-commerces.',identifier:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PRODUCTS_SHOWCASE_IDENTIFIER||'home',viewAllPath:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PRODUCTS_SHOWCASE_PATH||'/search'}),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CATEGORIES_SHOWCASE)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__["c" /* CategoriesShowcase */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_FILTERED_SHOWCASE)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__["d" /* FilteredShowcase */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_features_BestOffers__["a" /* BestOffers */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_features_AccumulatePoints__["a" /* AccumulatePoints */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__["b" /* BenefitsShowcase */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_responsive___default.a,{maxWidth:1024},__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CONNEXXE_BANNER_VIVO)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["d" /* ConexxeBannerVivo */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["b" /* ConexxeBanner */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CONNEXXE_BANNER_DFP)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["c" /* ConexxeBannerDFP */],null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_responsive___default.a,{minWidth:1025},__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CONNEXXE_BANNER_VIVO)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["d" /* ConexxeBannerVivo */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()("false")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["b" /* ConexxeBanner */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_CONNEXXE_BANNER_DFP)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_features_Slider__["c" /* ConexxeBannerDFP */],null)),profile&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_features_Services__["a" /* Services */],null),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_MILEAGE)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_features_Services_Mileage__["a" /* Mileage */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ModalCategories__["a" /* ModalCategories */],null)),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Showcase__["e" /* default */],{showcaseType:'5',identifier:'voucher',title:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_VOUCHERS_SHOWCASE_TITLE||'Vouchers.',viewAllPath:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_VOUCHERS_SHOWCASE_PATH||'/stores/vouchers'}),__WEBPACK_IMPORTED_MODULE_4_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_features_Suggestion__["a" /* StoreSuggestion */],{viewAllPath:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_STORES_SHOWCASE_PATH||'/stores'}),__WEBPACK_IMPORTED_MODULE_4_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_BANNERS_VSA)&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_features_Services_BannersVSA__["a" /* BannersVSA */],null));};HomePage.propTypes={profile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (HomePage);

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSuggestion__ = __webpack_require__(538);
/* unused harmony reexport ProductSuggestion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductRecomendation__ = __webpack_require__(1738);
/* unused harmony reexport ProductRecomendationParticipant */
/* unused harmony reexport ProductRecomendationSku */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoreSuggestion__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__StoreSuggestion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VoucherSuggestion__ = __webpack_require__(556);
/* unused harmony reexport VoucherSuggestion */


/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductRecomendationParticipantContainer__ = __webpack_require__(1739);
/* unused harmony reexport ProductRecomendationParticipant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductRecomendationSkuContainer__ = __webpack_require__(1740);
/* unused harmony reexport ProductRecomendationSku */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(321);
/* unused harmony reexport productRecomendationReducer */


/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Availability__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductRecomendationParticipantContainer=function(_Component){_inherits(ProductRecomendationParticipantContainer,_Component);function ProductRecomendationParticipantContainer(){_classCallCheck(this,ProductRecomendationParticipantContainer);return _possibleConstructorReturn(this,(ProductRecomendationParticipantContainer.__proto__||Object.getPrototypeOf(ProductRecomendationParticipantContainer)).apply(this,arguments));}_createClass(ProductRecomendationParticipantContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchRecomendationParticipant(this.props.ParticipantId,'io');}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},this.props.products.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Showcase__["a" /* Showcase */],{title:this.props.title,titleMobile:this.props.titleMobile,searchPage:'/search-Page'},this.props.products.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_placeholder___default.a,{ready:!_this2.props.isloading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loyal_react__["CardPlaceholder"],null),key:p.sku},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Availability__["b" /* RecomendationCardContainer */],Object.assign({},p,{key:p.sku})));})));}}]);return ProductRecomendationParticipantContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductRecomendationParticipantContainer.propTypes={fetchRecomendationParticipant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isloading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,ParticipantId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var productRecomendation=_ref.productRecomendation;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* Products */])(productRecomendation));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchRecomendationParticipant:function fetchRecomendationParticipant(PartcipantId,identifier){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchRecomendationParticipant */])(PartcipantId,identifier));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductRecomendationParticipantContainer));

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Showcase__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Availability__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_loyal_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductRecomendationSkuContainer=function(_Component){_inherits(ProductRecomendationSkuContainer,_Component);function ProductRecomendationSkuContainer(){_classCallCheck(this,ProductRecomendationSkuContainer);return _possibleConstructorReturn(this,(ProductRecomendationSkuContainer.__proto__||Object.getPrototypeOf(ProductRecomendationSkuContainer)).apply(this,arguments));}_createClass(ProductRecomendationSkuContainer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.isloading){this.props.fetchRecomendationSku(this.props.productId,'io');}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},this.props.products.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Showcase__["a" /* Showcase */],{title:this.props.title,titleMobile:this.props.titleMobile,searchPage:'/search-Page'},this.props.products.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_placeholder___default.a,{ready:!_this2.props.isloading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_loyal_react___default.a,null),key:p.sku},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Availability__["b" /* RecomendationCardContainer */],Object.assign({},p,{key:p.sku})));})));}}]);return ProductRecomendationSkuContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductRecomendationSkuContainer.propTypes={fetchRecomendationSku:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isloading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,productId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var productRecomendation=_ref.productRecomendation;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__reducer__["a" /* Products */])(productRecomendation));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchRecomendationSku:function fetchRecomendationSku(productId,identifier){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchRecomendationSku */])(productId,identifier));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductRecomendationSkuContainer));

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Services__ = __webpack_require__(1742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Services__["a"]; });


/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RechargePhone__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BillPayment__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FuelCredit__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServicesPlaceholder__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_showcases_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RechargePhoneId=71;var BillPaymentId=21188;var FuelCreditId=117;var Services=function(_Component){_inherits(Services,_Component);function Services(){_classCallCheck(this,Services);return _possibleConstructorReturn(this,(Services.__proto__||Object.getPrototypeOf(Services)).apply(this,arguments));}_createClass(Services,[{key:'render',value:function render(){var hasRechargePhone=this.props.services.find(function(s){return s.supplierId===RechargePhoneId;});var hasBillPayment=this.props.services.find(function(s){return s.supplierId===BillPaymentId;});var hasFuelCredit=this.props.services.find(function(s){return s.supplierId===FuelCreditId;});if(hasRechargePhone||hasBillPayment||hasFuelCredit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ServicesPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-services container-fluid bg-brand-4 blue-area py-0 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-1 mb-2 px-0 d-lg-block d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-ui-white'},'Aproveite servi\xE7os exclusivos.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-1 mb-2 px-0 d-lg-none d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-ui-white mt-2'},'Servi\xE7os'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},hasRechargePhone?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RechargePhone__["a" /* RechargePhone */],null):'',hasBillPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BillPayment__["a" /* BillPayment */],null):'',hasFuelCredit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FuelCredit__["a" /* FuelCredit */],null):''))));}return'';}}]);return Services;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref){var services=_ref.stores.services;return{services:services};};Services.propTypes={services:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,null)(Services));

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RechargePhone__ = __webpack_require__(1744);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RechargePhone__["a"]; });


/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellphoneRecharge__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormStep__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorStep__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuccessStep_SuccessStep__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OperatorStep__ = __webpack_require__(1752);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RechargePhone=function(_Component){_inherits(RechargePhone,_Component);function RechargePhone(props){_classCallCheck(this,RechargePhone);var _this=_possibleConstructorReturn(this,(RechargePhone.__proto__||Object.getPrototypeOf(RechargePhone)).call(this,props));_this.state={operatorStep:true,formStep:false,orderId:undefined,operatorKey:undefined};_this.onChangeMobileOperator=_this.onChangeMobileOperator.bind(_this);_this.resetSteps=_this.resetSteps.bind(_this);_this.tryAgain=_this.tryAgain.bind(_this);_this.goFormStep=_this.goFormStep.bind(_this);_this.insertedMobileRecharge=_this.insertedMobileRecharge.bind(_this);_this.errorInsertMobileRecharge=_this.errorInsertMobileRecharge.bind(_this);_this.beforeInsertMobileRecharge=_this.beforeInsertMobileRecharge.bind(_this);return _this;}_createClass(RechargePhone,[{key:'beforeInsertMobileRecharge',value:function beforeInsertMobileRecharge(){this.setState({loadingFinalizeOrder:true});}},{key:'insertedMobileRecharge',value:function insertedMobileRecharge(_ref){var orderId=_ref.id;this.setState({loadingFinalizeOrder:undefined,operatorStep:false,formStep:false,orderId:orderId});}},{key:'errorInsertMobileRecharge',value:function errorInsertMobileRecharge(errorMessage){this.setState({loadingFinalizeOrder:undefined,errorMessage:errorMessage,operatorStep:false,formStep:false});}},{key:'onChangeMobileOperator',value:function onChangeMobileOperator(e){this.setState({operatorKey:e.mobileOperator});}},{key:'resetSteps',value:function resetSteps(){this.setState({operatorStep:true,formStep:false,errorMessage:undefined,operatorKey:undefined,orderId:undefined});}},{key:'goFormStep',value:function goFormStep(){this.setState({operatorStep:false,formStep:true,errorMessage:undefined});}},{key:'tryAgain',value:function tryAgain(){this.setState({operatorStep:false,formStep:true});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-service col-12 col-md-8 col-lg-4 px-1 mb-lg-0 mb-3'},this.state.operatorStep?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OperatorStep__["a" /* default */],{operatorKey:this.state.operatorKey,onChangeMobileOperator:this.onChangeMobileOperator,nextStep:this.goFormStep,pointsValue:this.props.pointsValue}):'',this.state.operatorKey?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FormStep__["a" /* default */],{operatorKey:this.state.operatorKey,loadingFinalizeOrder:this.state.loadingFinalizeOrder,insertMobileRecharge:this.props.insertMobileRecharge(this.beforeInsertMobileRecharge,this.insertedMobileRecharge,this.errorInsertMobileRecharge),backStep:this.resetSteps,visible:this.state.formStep}):'',this.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorStep__["a" /* default */],{resetSteps:this.resetSteps,tryAgain:this.goFormStep,errorMessage:this.state.errorMessage,title:'Não foi possível concluir a sua transação'})||'',this.state.orderId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SuccessStep_SuccessStep__["a" /* default */],{resetSteps:this.resetSteps,orderId:this.state.orderId,tryAgain:this.tryAgain}):'');}}]);return RechargePhone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RechargePhone.propTypes={insertMobileRecharge:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref2){var _ref2$cellphoneRechar=_ref2.cellphoneRecharge,errorMessage=_ref2$cellphoneRechar.errorMessage,mobileRechargeInserted=_ref2$cellphoneRechar.mobileRechargeInserted,currencyConfiguration=_ref2.catalog.currencyConfiguration;return{errorMessage:errorMessage,mobileRechargeInserted:mobileRechargeInserted,pointsValue:currencyConfiguration.pointsName};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{insertMobileRecharge:function insertMobileRecharge(beforeInsert,successCallback,errorCallback){return function(serviceId,operatorKey,areaCode,phone){if(beforeInsert)beforeInsert();dispatch(__WEBPACK_IMPORTED_MODULE_2__CellphoneRecharge__["c" /* actions */].insertMobileRecharge(serviceId,operatorKey,areaCode,phone,successCallback,errorCallback));};}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(RechargePhone));

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormStep__ = __webpack_require__(1746);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__FormStep__["a" /* default */]);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValuesRecharge__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellphoneRecharge_PhoneNumber__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CellphoneRecharge_ModalTerms__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CellphoneRecharge_constants__ = __webpack_require__(209);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormStep=function(_Component){_inherits(FormStep,_Component);function FormStep(props){_classCallCheck(this,FormStep);var _this=_possibleConstructorReturn(this,(FormStep.__proto__||Object.getPrototypeOf(FormStep)).call(this,props));_this.onChangeService=_this.onChangeService.bind(_this);_this.onChangeAreaCode=_this.onChangeAreaCode.bind(_this);_this.onChangePhoneNumber=_this.onChangePhoneNumber.bind(_this);_this.btnMobileRechargeClick=_this.btnMobileRechargeClick.bind(_this);_this.onChageAcceptTerms=_this.onChageAcceptTerms.bind(_this);_this.state={};return _this;}_createClass(FormStep,[{key:'onChageAcceptTerms',value:function onChageAcceptTerms(e){this.setState({acceptTerms:e.target.checked});}},{key:'onChangeAreaCode',value:function onChangeAreaCode(e){this.setState({areaCode:e.areaCode,serviceId:'',pointsValue:'',rechargeValue:''});}},{key:'onChangePhoneNumber',value:function onChangePhoneNumber(e){this.setState({areaCode:e.value||e.areaCode,phoneNumber:e.phoneNumber});}},{key:'onChangeService',value:function onChangeService(e){this.setState({serviceId:e.serviceId,pointsValue:e.pointsValue,rechargeValue:e.rechargeValue});}},{key:'btnMobileRechargeClick',value:function btnMobileRechargeClick(){if(this.state.acceptTerms){this.props.insertMobileRecharge(this.state.serviceId,this.props.operatorKey,this.state.areaCode,this.state.phoneNumber);}else{this.setState({showTerms:true});}}},{key:'render',value:function render(){var _this2=this;var style=this.props.visible?{}:{display:'none'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style,className:'bg-white radius row px-1 mx-0 pt-2 pb-1 border-top-lg border-color-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1'},'Fa\xE7a sua recarga ',this.props.operatorKey,'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:this.props.backStep})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CellphoneRecharge_PhoneNumber__["a" /* PhoneNumber */],{operatorKey:this.props.operatorKey,areaCode:this.state.areaCode,phoneNumber:this.state.phoneNumber,divContentClassName:'col-12 col-md-12 mt-12 form-field mt-1',onChangePhoneNumber:this.onChangePhoneNumber,onChangeAreaCode:this.onChangeAreaCode,disabled:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ValuesRecharge__["a" /* default */],{id:'rechargeValue',label:'Valor da Recarga',className:'col-12 mt-2 form-field',operatorKey:this.props.operatorKey,areaCode:this.state.areaCode,onChangeValue:this.onChangeService,serviceId:this.state.serviceId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Checkbox"],{id:'aceito_termos_recharge',className:'col-auto',labelClass:'l-0',checked:this.state.acceptTerms,onChange:this.onChageAcceptTerms}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 col-md-auto pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'txt-body-sm color-brand-2 txt-underline',role:'button',onClick:function onClick(e){return _this2.setState({showTerms:true});}},'termos do regulamento')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'btnMobileRecharge',name:'DoneRecharge',className:'btn-featured btn btn-sm',text:'Finalizar Recarga',loading:this.props.loadingFinalizeOrder,onClick:this.btnMobileRechargeClick,disabled:!(this.props.operatorKey&&this.state.areaCode&&this.state.acceptTerms&&this.state.phoneNumber&&this.state.phoneNumber.indexOf('_')===-1&&this.state.phoneNumber.length===10&&this.state.serviceId)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CellphoneRecharge_ModalTerms__["a" /* ModalTerms */],{show:this.state.showTerms,onClose:function onClose(e){return _this2.setState({showTerms:false});},acceptTerms:function acceptTerms(e){_this2.setState({showTerms:false,acceptTerms:true});},terms:{vendorId:__WEBPACK_IMPORTED_MODULE_6__CellphoneRecharge_constants__["d" /* default */].VENDORID_CELLPHONE_RECHARGE,type:__WEBPACK_IMPORTED_MODULE_6__CellphoneRecharge_constants__["d" /* default */].REGULATION_TYPE_VENDOR}}));}}]);return FormStep;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FormStep.propTypes={operatorKey:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,insertMobileRecharge:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,loadingFinalizeOrder:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,backStep:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,visible:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (FormStep);

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ValueRechargeClient__ = __webpack_require__(1748);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValuesRecharge=function(_Component){_inherits(ValuesRecharge,_Component);function ValuesRecharge(props){_classCallCheck(this,ValuesRecharge);var _this=_possibleConstructorReturn(this,(ValuesRecharge.__proto__||Object.getPrototypeOf(ValuesRecharge)).call(this,props));_this.handleFormatValue=function(value,decimal){if(!isNaN(value)){return parseFloat(value).toLocaleString('pt-br',{minimumFractionDigits:decimal||_this.props.decimalPlaces,maximumFractionDigits:decimal||_this.props.decimalPlaces})+'  '+(decimal?'':_this.props.pointsName)+' ';}return'';};_this.state={valuesRecharge:[]};_this.onChange=_this.onChange.bind(_this);_this.successListValueRecharge=_this.successListValueRecharge.bind(_this);_this.loadValuesRecharge=_this.loadValuesRecharge.bind(_this);_this.successListValueRecharge=_this.successListValueRecharge.bind(_this);return _this;}_createClass(ValuesRecharge,[{key:'loadValuesRecharge',value:function loadValuesRecharge(){if(!this.props.operatorKey||!this.props.areaCode){this.setState({valuesRecharge:[]});}__WEBPACK_IMPORTED_MODULE_4__ValueRechargeClient__["a" /* default */].listValuesRecharge(this.props.operatorKey,this.props.areaCode,this.successListValueRecharge);}},{key:'successListValueRecharge',value:function successListValueRecharge(data){var _this2=this;data.forEach(function(item){return item.descriptionMoneyValue='R$ '+_this2.handleFormatValue(item.rechargeValue,2);});this.setState({valuesRecharge:data});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!prevProps||this.props.operatorKey!==prevProps.operatorKey||this.props.areaCode!==prevProps.areaCode){this.loadValuesRecharge();}}},{key:'onChange',value:function onChange(selectedItem){this.props.onChangeValue(selectedItem);}},{key:'render',value:function render(){var _this3=this;var value=this.state.valuesRecharge.find(function(item){return item.serviceId===_this3.props.serviceId;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Select"],{id:'selectCreditValue',label:'Valor da Recarga',className:'col-12 mt-2 form-field',displayValue:'descriptionMoneyValue',selectedValue:'serviceId',options:this.state.valuesRecharge,value:value||{},onChange:this.onChange,key:value&&value.serviceId||''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'pointsValue',label:'Voc\xEA vai gastar',className:'col-12 mt-2 form-field',value:this.handleFormatValue(''+(value&&value.pointsValue||'0')),readOnly:true}));}}]);return ValuesRecharge;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ValuesRecharge.propTypes={areaCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,operatorKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onChangeValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,serviceId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,decimalPlaces:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};var mapStateToProps=function mapStateToProps(_ref){var _ref$catalog$currency=_ref.catalog.currencyConfiguration,pointsName=_ref$catalog$currency.pointsName,decimalPlaces=_ref$catalog$currency.decimalPlaces;return{pointsName:pointsName,decimalPlaces:decimalPlaces};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(ValuesRecharge));

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listValuesRecharge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var listValuesRecharge=function listValuesRecharge(operatorKey,areaCode,successCallback,errorCallback){client.get('/v1/mobileRecharges/mobileoperator/'+operatorKey+'/areacode/'+areaCode+'/rechargeValue').then(function(response){return successCallback(response.data);}).catch(function(error){if(errorCallback)errorCallback(error.response&&error.response.data);});};/* harmony default export */ __webpack_exports__["a"] = ({listValuesRecharge:listValuesRecharge});

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var ErrorStep=function ErrorStep(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close_circle color-error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:props.resetSteps})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1 color-error'},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1'},props.errorMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 mb-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btnTryAgainRecharge',name:'TryAgainRecharge',className:'btn-featured btn btn-sm btn-cart mb-5',text:'TENTAR NOVAMENTE',onClick:props.tryAgain}))));};ErrorStep.propTypes={errorMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,tryAgain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,resetSteps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ErrorStep);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderClient__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SuccessStep=function(_Component){_inherits(SuccessStep,_Component);function SuccessStep(props){_classCallCheck(this,SuccessStep);var _this=_possibleConstructorReturn(this,(SuccessStep.__proto__||Object.getPrototypeOf(SuccessStep)).call(this,props));_this.successGetOrder=_this.successGetOrder.bind(_this);_this.goOrderDetailsPage=_this.goOrderDetailsPage.bind(_this);_this.loadOrder=_this.loadOrder.bind(_this);_this.state={parentOrderId:null,orderId:null,productId:null,date:null,operator:null,phone:null,creditValue:null,pointsValue:null,loading:true};_this.loadOrder();return _this;}_createClass(SuccessStep,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.orderId!==this.props.orderId)this.loadOrder();}},{key:'loadOrder',value:function loadOrder(){if(this.props.orderId){__WEBPACK_IMPORTED_MODULE_3__OrderClient__["a" /* default */].getOrder(this.props.orderId,this.successGetOrder);}else{this.setState({order:null});}}},{key:'successGetOrder',value:function successGetOrder(order){var vendorOrder=order&&order.vendorOrderModel&&order.vendorOrderModel.length>0&&order.vendorOrderModel[0];var product=vendorOrder&&vendorOrder.items&&vendorOrder.items.length>0&&vendorOrder.items[0];this.setState({parentOrderId:order.parentOrderId,orderId:vendorOrder.orderId,productId:product.id,description:product&&product.name,date:product&&product.deliveryForecast,operator:null,phone:null,creditValue:product&&product.rechargeValue,pointsValue:product&&product.pointsValue,loading:false});}},{key:'goOrderDetailsPage',value:function goOrderDetailsPage(){this.props.goOrderDetailsPage(this.state.parentOrderId,this.state.orderId,this.state.productId);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-2 mx-0 pt-2 pb-3 border-top-lg border-color-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_check_circle color-success'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:this.props.resetSteps})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1 color-success'},'Parab\xE9ns! Seu resgate foi conclu\xEDdo com sucesso.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Resgate realizado em:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.date&&__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.state.date).format('DD/MM/YYYY [às] HH[h]mm')||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Descri\xE7\xE3o: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Valor em cr\xE9ditos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ ',this.state.creditValue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Valor em pontos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.pointsValue,' ',this.props.pointsName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'btnTryAgainRecharge',name:'TryAgainRecharge',className:'btn-featured btn btn-sm btn-cart mb-5',text:'Ver detalhes',onClick:this.goOrderDetailsPage}))));}}]);return SuccessStep;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SuccessStep.propTypes={resetSteps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,orderId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,goOrderDetailsPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref){var pointsName=_ref.catalog.currencyConfiguration.pointsName;return{pointsName:pointsName};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{goOrderDetailsPage:function goOrderDetailsPage(parentOrderId,orderId,productId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__["push"])('/order/'+parentOrderId+'/'+orderId+'/product/'+productId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SuccessStep));

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOrder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_clients__ = __webpack_require__(25);
var client=__WEBPACK_IMPORTED_MODULE_0_redux_clients__["a" /* default */].cloudloyalty.client;var getOrder=function getOrder(orderId,successCallback,errorCallback){client.get('/v1/purchases/'+orderId+'/order').then(function(response){return successCallback(response&&response.data);}).catch(function(error){if(errorCallback){errorCallback(error&&error.response&&error.response.data);}});};/* harmony default export */ __webpack_exports__["a"] = ({getOrder:getOrder});

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectMobileOperator__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
var OperatorStep=function OperatorStep(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'bx-recarga bg-white radius row px-2 mx-0 pt-3 pb-2'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'col-12 my-3 pb-1'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h4',{className:'txt-uppercase color-brand-6 txt-body-sm mb-1'},'Recarga de celular'),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('h2',{className:'color-ui-white txt-title txt-circular-book'},'Troque seus ',props.pointsValue,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('br',null),'por cr\xE9dito no celular.')),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SelectMobileOperator__["a" /* SelectMobileOperator */],{id:'operadora',label:'Operadora',className:'form-field col-12 mt-3 mt-md-5',value:props.operatorKey,onChange:props.onChangeMobileOperator,style:{marginTop:'39px !important'}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Button"],{id:'btnNextStepRecharge',name:'NextStepRecharge',className:'btn-featured btn btn-sm mt-2 mx-1',text:'Continuar',onClick:props.nextStep,disabled:!props.operatorKey}));};OperatorStep.propTypes={operatorKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onChangeMobileOperator:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,nextStep:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (OperatorStep);

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BillPayment__ = __webpack_require__(1754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BillPayment__["a"]; });


/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CellphoneRecharge_ModalTerms__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_clients__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var client=__WEBPACK_IMPORTED_MODULE_7_redux_clients__["a" /* default */].cloudloyalty.client;var objectErrorDefault={message:'',valid:null};var errorsDefault={barCode:objectErrorDefault,dueDate:objectErrorDefault,acceptedTerms:objectErrorDefault};var BillPayment=function(_Component){_inherits(BillPayment,_Component);function BillPayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BillPayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BillPayment.__proto__||Object.getPrototypeOf(BillPayment)).call.apply(_ref,[this].concat(args))),_this),_this.state={vendorId:21188,maskLengthAccountType:51,maskAccountType:[],services:[],barCode:'',serviceId:'',dueDate:'',showTerms:false,isLoading:false,isSendingPurchase:false,errors:Object.assign({},errorsDefault),enableNextStep:true,firstStep:true,secondStep:false,stepError:false,stepFinal:false,acceptedTerms:false},_this.getServiceSelected=function(){var _this$state=_this.state,serviceId=_this$state.serviceId,services=_this$state.services;return services.find(function(service){return service.serviceId===serviceId;});},_this.loadServices=function(){client.get('/v1/billPayments/vendor/'+_this.state.vendorId+'/service').then(function(_ref2){var services=_ref2.data;return _this.setState({services:services});});},_this.handleValidateDueDate=function(){var propName='dueDate';var dueDate=__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.state.dueDate,'DD/MM/YYYY',true);if(dueDate.isValid()){return _this.setPropValidation(propName,{message:'',valid:true});}_this.setPropValidation(propName,{message:'Data de vencimento inválida.',valid:false});},_this.handleValidateBarCode=function(_ref3){var serviceId=_ref3.serviceId,barCode=_ref3.barCode;if(!serviceId||!barCode)return;var handleFail=function handleFail(_ref4){var response=_ref4.response;var message='Não foi possível validar o código de barra.';if(response&&response.status===422){message='Código de barras inválido.';}_this.setState({isLoading:false,errors:Object.assign({},_this.state.errors,{barCode:{message:message,valid:false}})});};var vendorId=_this.state.vendorId;var url='/v1/billPayments/vendor/'+vendorId+'/service/'+serviceId+'/validate/'+barCode;_this.setState({isLoading:true});client.get(url).then(function(_ref5){var data=_ref5.data;_this.setState(Object.assign({},data,{isLoading:false}));_this.setPropValidation('barCode',{valid:true,message:''});}).catch(handleFail);},_this.handleSendPurchase=function(){var payment={serviceId:_this.state.serviceId,barCode:_this.state.barCode,dueDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.state.dueDate,'DD/MM/YYYY').format('MM/DD/YYYY'),documentNumber:_this.props.documentNumber,billValue:_this.state.billValue};_this.setState({isSendingPurchase:true});client.post('/v1/purchases/billPayment',payment).then(function(_ref6){var id=_ref6.data.id;_this.setState({isSendingPurchase:false});_this.props.redirect('/confirmation/'+id);}).catch(function(_ref7){var error=_ref7.response.data;_this.setState({isSendingPurchase:false});_this.props.redirect({pathname:'/billpayment',state:Object.assign({},_this.state,{hasError:true,error:error})});});},_this.btnResetSteps=function(){_this.setState({firstStep:true,secondStep:false,stepError:false,stepFinal:false});},_this.btnBillPaymentNextStep=function(){_this.setState({firstStep:false,secondStep:true,stepError:false,stepFinal:false});},_this.btnTryAgain=function(){_this.setState({firstStep:false,secondStep:true,stepError:false,stepFinal:false});},_this.isFormInvalid=function(){var errors=_this.state.errors;var propNames=Object.keys(errors);for(var index=0;index<propNames.length;index++){var propName=propNames[index];var isInvalid=!errors[propName].valid;if(isInvalid)return true;}return false;},_this.handleOnChangeAcceptTerms=function(){var acceptedTerms=!_this.state.acceptedTerms;_this.setPropValidation('acceptedTerms',{valid:acceptedTerms});_this.setState({acceptedTerms:acceptedTerms});},_this.setPropValidation=function(name,value){var errors=Object.assign({},_this.state.errors,_defineProperty({},name,value));_this.setState({errors:errors});},_this.handleBarCodeChange=function(_ref8){var value=_ref8.target.value;var valueFormated=value.trim().match(/\d+/g);if(valueFormated){var barCode=valueFormated.join([]);_this.setState({barCode:barCode});return;}_this.setState({barCode:value});},_this.handleFormatValue=function(value,decimal){if(!isNaN(value)){return parseFloat(value).toLocaleString('pt-br',{minimumFractionDigits:decimal||_this.props.decimalPlaces,maximumFractionDigits:decimal||_this.props.decimalPlaces})+' ';}return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BillPayment,[{key:'componentWillMount',value:function componentWillMount(){this.loadServices();}},{key:'render',value:function render(){var _this2=this;var serviceSelected=this.getServiceSelected(this.state.serviceId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-service col-12 col-md-8 col-lg-4 px-1 mb-lg-0 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-paguecontas bg-white radius row px-2 mx-0 pt-3 pb-2',style:this.state.firstStep?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-3 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-uppercase color-brand-6 txt-body-sm mb-1'},'Pagamento de contas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title txt-circular-book'},'Pague suas contas',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'com seus ',this.props.pointsValue,'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Select"],{id:'BillType',label:'Tipo de conta',className:'form-field col-12 mt-3 mt-md-5',hasEmpty:true,displayValue:'name',selectedValue:'serviceId',options:this.state.services,required:true,onChange:function onChange(_ref9){var serviceId=_ref9.serviceId;var defaultNotDigit=new RegExp(/[^ -//]/);var arrayRegularExpression=_this2.state.services.find(function(item){return item.serviceId===serviceId;}).mask.split(',');var arrayMask=arrayRegularExpression.map(function(i){return defaultNotDigit.test(i)?new RegExp(i):i;});_this2.setState({serviceId:serviceId,enableNextStep:false,maskAccountType:arrayMask,maskLengthAccountType:_this2.state.services.find(function(item){return item.serviceId===serviceId;}).maskLength});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'btnNextStepBillPayment',name:'NextStepBillPayment',className:'btn-featured btn btn-sm mt-2 mx-1',text:'Continuar',onClick:this.btnBillPaymentNextStep,disabled:this.state.enableNextStep})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-featured',style:this.state.secondStep?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1 nowrap'},serviceSelected?'Pague sua '+serviceSelected.name+'.':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:this.btnResetSteps})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'BarCode',className:'col-12 form-field mt-1',label:'Digite o c\xF3digo de barras',required:true,value:this.state.barCode,onChange:this.handleBarCodeChange,'data-error':this.state.errors.barCode.message,valid:this.state.errors.barCode.valid,onBlur:function onBlur(){return _this2.handleValidateBarCode(_this2.state);},mask:this.state.maskAccountType,type:'number'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'DueDate',name:'DueDate',className:'col-12 form-field mt-2',label:'Vencimento',required:true,mask:[/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[1-2]/,/[0-9]/,/[0-9]/,/[0-9]/],onChange:function onChange(_ref10){var dueDate=_ref10.target.value;_this2.setState({dueDate:dueDate});},'data-error':this.state.errors.dueDate.message,valid:this.state.errors.dueDate.valid,onBlur:function onBlur(){return _this2.handleValidateDueDate();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'BillValue',label:'Valor da conta',className:'col-6 form-field mt-2',required:true,value:this.handleFormatValue(this.state.billValue,'2'),disabled:this.state.isPriceEditable?'true':'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'BillPoints',label:'Valor em '+this.props.pointsValue,className:'col-6 form-field mt-2',required:true,value:this.handleFormatValue(this.state.pointsValue),disabled:this.state.isPriceEditable?'true':'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Checkbox"],{id:'aceito_termos_bill_payment',className:'col-auto',labelClass:'l-0',checked:this.state.acceptedTerms,onChange:this.handleOnChangeAcceptTerms}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 col-md-auto pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'txt-body-sm color-brand-2 txt-underline',role:'button',onClick:function onClick(_){return _this2.setState({showTerms:true});}},'termos do regulamento')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'DoneBill',name:'DoneBill',className:'btn-featured btn btn-sm',text:'Pagar Conta',loading:this.state.isSendingPurchase,disabled:this.isFormInvalid(),onClick:this.handleSendPurchase}))),this.state.showTerms&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CellphoneRecharge_ModalTerms__["a" /* ModalTerms */],{show:this.state.showTerms,terms:{type:'Vendor',vendorId:this.state.vendorId,catalogId:this.props.catalogId},onClose:function onClose(_){return _this2.setState({showTerms:false});},acceptTerms:function acceptTerms(){_this2.setState({acceptedTerms:true,showTerms:false});_this2.setPropValidation('acceptedTerms',{valid:true});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-error',style:this.state.stepError?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close_circle color-error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:function onClick(){return _this2.btnResetSteps();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1 color-error'},'N\xE3o foi poss\xEDvel concluir o sua transa\xE7\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm my-1'},'Seu saldo \xE9 insuficiente.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 mb-5 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'btnTryAgainBillPayment',name:'TryAgainBillPayment',className:'btn-featured btn btn-sm btn-cart mb-5',text:'TENTAR NOVAMENTE',onClick:function onClick(){return _this2.btnTryAgain();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white radius row px-2 mx-0 pt-2 pb-3 border-top-lg border-color-success',style:this.state.stepFinal?{}:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_check_circle color-success'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 pl-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close txt-body-sm cursor',onClick:function onClick(){return _this2.btnResetSteps();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body my-1 color-success'},'Parab\xE9ns! Seu resgate foi conclu\xEDdo com sucesso.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Resgate realizado em: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'04/11/2018 às 14h13')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Tipo de conta: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Conta de luz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Telefone: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'11 96284-4068')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Valor da conta: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ 300,00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Valor em pontos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'300 pontos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'btnTryAgainRecharge',name:'TryAgainRecharge',className:'btn-featured btn btn-sm btn-cart mb-5',text:'Ver detalhes',onClick:function onClick(){return _this2.btnTryAgain();}})))));}}]);return BillPayment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref11){var cpf=_ref11.participant.cpf,profile=_ref11.oidc.user.profile,currencyConfiguration=_ref11.catalog.currencyConfiguration;return{documentNumber:cpf.value,catalogId:profile['custom:catalog_id'],pointsValue:currencyConfiguration.pointsName,decimalPlaces:currencyConfiguration.decimalPlaces};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirect:function redirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_connected_react_router__["push"])(path));}};};BillPayment.propTypes={documentNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,catalogId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,redirect:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,decimalPlaces:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(BillPayment));

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var ServicesPlaceholder=function ServicesPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-white pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2 mx-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-image-gray border-ui-4 bg-white radius row px-2 mx-0 pt-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-2 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 py-half bg-white radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0  mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-white radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-auto ml-auto bg-white mt-2  border-ui-4 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-image-gray border-ui-4 bg-white radius row px-2 mx-0 pt-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-2 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 py-half bg-white radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0  mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-white radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-auto ml-auto bg-white mt-2  border-ui-4 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-image-gray border-ui-4 bg-white radius row px-2 mx-0 pt-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-2 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-2 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 py-half bg-white radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0  mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half bg-white radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mr-auto ml-auto bg-white mt-2  border-ui-4 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 bg-ui-3 radius'})))))))))));};/* harmony default export */ __webpack_exports__["a"] = (ServicesPlaceholder);

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BannersVSA__ = __webpack_require__(1757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BannersVSA__["a"]; });


/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_bannersVSA_css__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_bannersVSA_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_bannersVSA_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BannersVSA=function(_React$Component){_inherits(BannersVSA,_React$Component);function BannersVSA(){_classCallCheck(this,BannersVSA);return _possibleConstructorReturn(this,(BannersVSA.__proto__||Object.getPrototypeOf(BannersVSA)).apply(this,arguments));}_createClass(BannersVSA,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mx-auto mx-md-0 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_BANNER_DR_CONSULTA,title:'Ir para Dr. Consulta'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'drConsulta mx-auto'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mx-auto mx-md-0 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_BANNER_SMILES,title:'Ir para Smiles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'smiles mx-auto'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mx-auto mx-md-0 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_BANNER_VALE_VIAGEM,title:'Ir para Shell Box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'valeViagem mx-auto'})))));}}]);return BannersVSA;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BannersVSA);

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; /* eslint-disable react/sort-comp */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(42);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = __webpack_require__(60);

var _invariant2 = _interopRequireDefault(_invariant);

var _deepEqual = __webpack_require__(1760);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _hoistNonReactStatics = __webpack_require__(1771);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Events = __webpack_require__(323);

var _Events2 = _interopRequireDefault(_Events);

var _filterProps = __webpack_require__(1772);

var _filterProps2 = _interopRequireDefault(_filterProps);

var _createManager = __webpack_require__(1773);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * An Ad Component using Google Publisher Tags.
 * This component should work standalone w/o context.
 * https://developers.google.com/doubleclick-gpt/
 *
 * @module Bling
 * @class Bling
 * @fires Bling#Events.READY
 * @fires Bling#Events.SLOT_RENDER_ENDED
 * @fires Bling#Events.IMPRESSION_VIEWABLE
 * @fires Bling#Events.SLOT_VISIBILITY_CHANGED
 * @fires Bling#Events.SLOT_LOADED
 */
var Bling = (_temp2 = _class = function (_Component) {
    _inherits(Bling, _Component);

    function Bling() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Bling);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bling.__proto__ || Object.getPrototypeOf(Bling)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            scriptLoaded: false,
            inViewport: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * An array of prop names which can reflect to the ad by calling `refresh`.
     *
     * @property refreshableProps
     * @static
     */

    /**
     * An array of prop names which requires to create a new ad slot and render as a new ad.
     *
     * @property reRenderProps
     * @static
     */

    /**
     * An instance of ad manager.
     *
     * @property _adManager
     * @private
     * @static
     */

    /**
     *
     * @property
     * @private
     * @static
     */


    _createClass(Bling, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            Bling._adManager.addInstance(this);
            Bling._adManager.load(Bling._config.seedFileUrl).then(this.onScriptLoaded.bind(this)).catch(this.onScriptError.bind(this));
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var propsEqual = Bling._config.propsEqual;
            var sizeMapping = this.props.sizeMapping;

            if ((nextProps.sizeMapping || sizeMapping) && !propsEqual(nextProps.sizeMapping, sizeMapping)) {
                Bling._adManager.removeMQListener(this, nextProps);
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            // if adUnitPath changes, need to create a new slot, re-render
            // otherwise, just refresh
            var scriptLoaded = nextState.scriptLoaded,
                inViewport = nextState.inViewport;

            var notInViewport = this.notInViewport(nextProps, nextState);
            var inViewportChanged = this.state.inViewport !== inViewport;
            var isScriptLoaded = this.state.scriptLoaded !== scriptLoaded;

            // Exit early for visibility change, before executing deep equality check.
            if (notInViewport) {
                return false;
            } else if (inViewportChanged) {
                return true;
            }

            var _Bling$_config = Bling._config,
                filterProps = _Bling$_config.filterProps,
                propsEqual = _Bling$_config.propsEqual;

            var refreshableProps = filterProps(Bling.refreshableProps, this.props, nextProps);
            var reRenderProps = filterProps(Bling.reRenderProps, this.props, nextProps);
            var shouldRender = !propsEqual(reRenderProps.props, reRenderProps.nextProps);
            var shouldRefresh = !shouldRender && !propsEqual(refreshableProps.props, refreshableProps.nextProps);

            if (shouldRefresh) {
                this.configureSlot(this._adSlot, nextProps);
            }

            if (Bling._adManager._syncCorrelator) {
                if (shouldRefresh) {
                    Bling._adManager.refresh();
                } else if (shouldRender || isScriptLoaded) {
                    Bling._adManager.renderAll();
                }
            } else {
                if (shouldRefresh) {
                    this.refresh();
                    return false;
                }
                if (shouldRender || isScriptLoaded) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.notInViewport(this.props, this.state)) {
                return;
            }
            if (this._divId) {
                // initial render will enable pubads service before any ad renders
                // so taken care of by the manager
                if (Bling._adManager._initialRender) {
                    Bling._adManager.render();
                } else {
                    this.renderAd();
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            Bling._adManager.removeInstance(this);
            if (this._adSlot) {
                Bling._adManager.googletag.destroySlots([this._adSlot]);
                this._adSlot = null;
            }
        }
    }, {
        key: "onScriptLoaded",
        value: function onScriptLoaded() {
            var onScriptLoaded = this.props.onScriptLoaded;


            if (this.getRenderWhenViewable()) {
                this.foldCheck();
            }
            this.setState({ scriptLoaded: true }, onScriptLoaded); // eslint-disable-line react/no-did-mount-set-state
        }
    }, {
        key: "onScriptError",
        value: function onScriptError(err) {
            console.warn("Ad: Failed to load gpt for " + Bling._config.seedFileUrl, err);
        }
    }, {
        key: "getRenderWhenViewable",
        value: function getRenderWhenViewable() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.renderWhenViewable !== undefined ? props.renderWhenViewable : Bling._config.renderWhenViewable;
        }
    }, {
        key: "foldCheck",
        value: function foldCheck() {
            if (this.state.inViewport) {
                return;
            }

            var slotSize = this.getSlotSize();
            if (Array.isArray(slotSize) && Array.isArray(slotSize[0])) {
                slotSize = slotSize[0];
            }
            if (slotSize === "fluid" || Array.isArray(slotSize) && slotSize[0] === "fluid") {
                slotSize = [0, 0];
            }

            var inViewport = Bling._adManager.isInViewport(_reactDom2.default.findDOMNode(this), slotSize, this.viewableThreshold);
            if (inViewport) {
                this.setState({ inViewport: true });
            }
        }
    }, {
        key: "defineSizeMapping",
        value: function defineSizeMapping(adSlot, sizeMapping) {
            if (sizeMapping) {
                Bling._adManager.addMQListener(this, this.props);
                var sizeMappingArray = sizeMapping.reduce(function (mapping, size) {
                    return mapping.addSize(size.viewport, size.slot);
                }, Bling._adManager.googletag.sizeMapping()).build();
                adSlot.defineSizeMapping(sizeMappingArray);
            }
        }
    }, {
        key: "setAttributes",
        value: function setAttributes(adSlot, attributes) {
            // no clear method, attempting to clear existing attributes before setting new ones.
            var attributeKeys = adSlot.getAttributeKeys();
            attributeKeys.forEach(function (key) {
                adSlot.set(key, null);
            });
            if (attributes) {
                Object.keys(attributes).forEach(function (key) {
                    adSlot.set(key, attributes[key]);
                });
            }
        }
    }, {
        key: "setTargeting",
        value: function setTargeting(adSlot, targeting) {
            adSlot.clearTargeting();
            if (targeting) {
                Object.keys(targeting).forEach(function (key) {
                    adSlot.setTargeting(key, targeting[key]);
                });
            }
        }
    }, {
        key: "addCompanionAdService",
        value: function addCompanionAdService(serviceConfig, adSlot) {
            var companionAdsService = Bling._adManager.googletag.companionAds();
            adSlot.addService(companionAdsService);
            if ((typeof serviceConfig === "undefined" ? "undefined" : _typeof(serviceConfig)) === "object") {
                if (serviceConfig.hasOwnProperty("enableSyncLoading")) {
                    companionAdsService.enableSyncLoading();
                }
                if (serviceConfig.hasOwnProperty("refreshUnfilledSlots")) {
                    companionAdsService.setRefreshUnfilledSlots(serviceConfig.refreshUnfilledSlots);
                }
            }
        }
    }, {
        key: "getSlotSize",
        value: function getSlotSize() {
            var _props = this.props,
                origSlotSize = _props.slotSize,
                origSizeMapping = _props.sizeMapping;

            var slotSize = void 0;
            if (origSlotSize) {
                slotSize = origSlotSize;
            } else if (origSizeMapping) {
                var sizeMapping = origSizeMapping;
                slotSize = sizeMapping[0] && sizeMapping[0].slot;
            }

            return slotSize;
        }
    }, {
        key: "renderAd",
        value: function renderAd() {
            this.defineSlot();
            this.display();
        }
    }, {
        key: "notInViewport",
        value: function notInViewport() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
            var inViewport = state.inViewport;

            return this.getRenderWhenViewable(props) && !inViewport;
        }
    }, {
        key: "defineSlot",
        value: function defineSlot() {
            var _props2 = this.props,
                adUnitPath = _props2.adUnitPath,
                outOfPage = _props2.outOfPage;

            var divId = this._divId;
            var slotSize = this.getSlotSize();

            if (!this._adSlot) {
                if (outOfPage) {
                    this._adSlot = Bling._adManager.googletag.defineOutOfPageSlot(adUnitPath, divId);
                } else {
                    this._adSlot = Bling._adManager.googletag.defineSlot(adUnitPath, slotSize || [], divId);
                }
            }

            this.configureSlot(this._adSlot);
        }
    }, {
        key: "configureSlot",
        value: function configureSlot(adSlot) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
            var sizeMapping = props.sizeMapping,
                attributes = props.attributes,
                targeting = props.targeting,
                companionAdService = props.companionAdService,
                categoryExclusion = props.categoryExclusion,
                collapseEmptyDiv = props.collapseEmptyDiv,
                safeFrameConfig = props.safeFrameConfig,
                content = props.content,
                clickUrl = props.clickUrl,
                forceSafeFrame = props.forceSafeFrame;


            this.defineSizeMapping(adSlot, sizeMapping);

            if (collapseEmptyDiv !== undefined) {
                if (Array.isArray(collapseEmptyDiv)) {
                    var _adSlot$setCollapseEm;

                    (_adSlot$setCollapseEm = adSlot.setCollapseEmptyDiv).call.apply(_adSlot$setCollapseEm, [adSlot].concat(_toConsumableArray(collapseEmptyDiv)));
                } else {
                    adSlot.setCollapseEmptyDiv(collapseEmptyDiv);
                }
            }

            // Overrides click url
            if (clickUrl) {
                adSlot.setClickUrl(clickUrl);
            }

            // Sets category exclusion
            if (categoryExclusion) {
                var exclusion = categoryExclusion;
                if (typeof exclusion === "string") {
                    exclusion = [exclusion];
                }
                adSlot.clearCategoryExclusions();
                exclusion.forEach(function (item) {
                    adSlot.setCategoryExclusion(item);
                });
            }

            // Sets AdSense attributes
            this.setAttributes(adSlot, attributes);

            // Sets custom targeting parameters
            this.setTargeting(adSlot, targeting);

            if (safeFrameConfig) {
                adSlot.setSafeFrameConfig(safeFrameConfig);
            }

            if (forceSafeFrame) {
                adSlot.setForceSafeFrame(forceSafeFrame);
            }

            // Enables companion ad service
            if (companionAdService) {
                this.addCompanionAdService(companionAdService, adSlot);
            }

            // GPT checks if the same service is already added.
            if (content) {
                adSlot.addService(Bling._adManager.googletag.content());
            } else {
                adSlot.addService(Bling._adManager.googletag.pubads());
            }
        }
    }, {
        key: "display",
        value: function display() {
            var content = this.props.content;

            var divId = this._divId;
            var adSlot = this._adSlot;

            if (content) {
                Bling._adManager.googletag.content().setContent(adSlot, content);
            } else {
                if (!Bling._adManager._disableInitialLoad && !Bling._adManager._syncCorrelator) {
                    Bling._adManager.updateCorrelator();
                }
                Bling._adManager.googletag.display(divId);
                if (Bling._adManager._disableInitialLoad && !Bling._adManager._initialRender) {
                    this.refresh();
                }
            }
        }
    }, {
        key: "clear",
        value: function clear() {
            var adSlot = this._adSlot;
            if (adSlot && adSlot.hasOwnProperty("getServices")) {
                // googletag.ContentService doesn't clear content
                var services = adSlot.getServices();
                if (this._divId && services.some(function (s) {
                    return !!s.setContent;
                })) {
                    document.getElementById(this._divId).innerHTML = "";
                    return;
                }
                Bling._adManager.clear([adSlot]);
            }
        }
    }, {
        key: "refresh",
        value: function refresh(options) {
            var adSlot = this._adSlot;
            if (adSlot) {
                this.clear();
                Bling._adManager.refresh([adSlot], options);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var scriptLoaded = this.state.scriptLoaded;
            var _props3 = this.props,
                id = _props3.id,
                outOfPage = _props3.outOfPage,
                style = _props3.style;

            var shouldNotRender = this.notInViewport(this.props, this.state);

            if (!scriptLoaded || shouldNotRender) {
                var slotSize = this.getSlotSize();

                if (!outOfPage) {
                    (0, _invariant2.default)(slotSize, "Either 'slotSize' or 'sizeMapping' prop needs to be set.");
                }

                if (Array.isArray(slotSize) && Array.isArray(slotSize[0])) {
                    slotSize = slotSize[0];
                }
                // https://developers.google.com/doubleclick-gpt/reference?hl=en#googletag.NamedSize
                if (slotSize === "fluid" || Array.isArray(slotSize) && slotSize[0] === "fluid") {
                    slotSize = ["auto", "auto"];
                }
                var emptyStyle = slotSize && {
                    width: slotSize[0],
                    height: slotSize[1]
                };
                // render node element instead of script element so that `inViewport` check works.
                return _react2.default.createElement("div", { style: emptyStyle });
            }

            // clear the current ad if exists
            this.clear();
            if (this._adSlot) {
                Bling._adManager.googletag.destroySlots([this._adSlot]);
                this._adSlot = null;
            }
            this._divId = id || Bling._adManager.generateDivId();

            return _react2.default.createElement("div", { id: this._divId, style: style });
        }
    }, {
        key: "adSlot",
        get: function get() {
            return this._adSlot;
        }
    }, {
        key: "viewableThreshold",
        get: function get() {
            return this.props.viewableThreshold >= 0 ? this.props.viewableThreshold : Bling._config.viewableThreshold;
        }
    }], [{
        key: "on",
        value: function on(eventType, cb) {
            Bling._on("on", eventType, cb);
        }
    }, {
        key: "once",
        value: function once(eventType, cb) {
            Bling._on("once", eventType, cb);
        }
    }, {
        key: "removeListener",
        value: function removeListener() {
            var _Bling$_adManager;

            (_Bling$_adManager = Bling._adManager).removeListener.apply(_Bling$_adManager, arguments);
        }
    }, {
        key: "removeAllListeners",
        value: function removeAllListeners() {
            var _Bling$_adManager2;

            (_Bling$_adManager2 = Bling._adManager).removeAllListeners.apply(_Bling$_adManager2, arguments);
        }
    }, {
        key: "_on",
        value: function _on(fn, eventType, cb) {
            if (typeof cb !== "function") {
                return;
            }
            if (eventType === _Events2.default.READY && Bling._adManager.isReady) {
                cb.call(Bling._adManager, Bling._adManager.googletag);
            } else {
                Bling._adManager[fn](eventType, cb);
            }
        }
    }, {
        key: "configure",
        value: function configure() {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            Bling._config = _extends({}, Bling._config, config);
        }
        /**
         * Returns the GPT version.
         *
         * @method getGPTVersion
         * @returns {Number|boolean} a version or false if GPT is not yet ready.
         * @static
         */

    }, {
        key: "getGPTVersion",
        value: function getGPTVersion() {
            return Bling._adManager.getGPTVersion();
        }
        /**
         * Returns the Pubads Service version.
         *
         * @method getPubadsVersion
         * @returns {Number|boolean} a version or false if Pubads Service is not yet ready.
         * @static
         */

    }, {
        key: "getPubadsVersion",
        value: function getPubadsVersion() {
            return Bling._adManager.getPubadsVersion();
        }
        /**
         * Sets a flag to indicate whether the correlator value should always be same across the ads in the page or not.
         *
         * @method syncCorrelator
         * @param {boolean} value
         * @static
         */

    }, {
        key: "syncCorrelator",
        value: function syncCorrelator(value) {
            Bling._adManager.syncCorrelator(value);
        }
        /**
         * Trigger re-rendering of all the ads.
         *
         * @method render
         * @static
         */

    }, {
        key: "render",
        value: function render() {
            Bling._adManager.renderAll();
        }
        /**
         * Refreshes all the ads in the page with a new correlator value.
         *
         * @param {Array} slots An array of ad slots.
         * @param {Object} options You can pass `changeCorrelator` flag.
         * @static
         */

    }, {
        key: "refresh",
        value: function refresh(slots, options) {
            Bling._adManager.refresh(slots, options);
        }
        /**
         * Clears the ads for the specified ad slots, if no slots are provided, all the ads will be cleared.
         *
         * @method clear
         * @param {Array} slots An optional array of slots to clear.
         * @static
         */

    }, {
        key: "clear",
        value: function clear(slots) {
            Bling._adManager.clear(slots);
        }
        /**
         * Updates the correlator value for the next ad request.
         *
         * @method updateCorrelator
         * @static
         */

    }, {
        key: "updateCorrelator",
        value: function updateCorrelator() {
            Bling._adManager.updateCorrelator();
        }
    }, {
        key: "testManager",
        set: function set(testManager) {
            (0, _invariant2.default)(testManager, "Pass in createManagerTest to mock GPT");
            Bling._adManager = testManager;
        }
    }]);

    return Bling;
}(_react.Component), _class.propTypes = {
    /**
     * An optional string to be used as container div id.
     *
     * @property id
     */
    id: _propTypes2.default.string,
    /**
     * An optional string indicating ad unit path which will be used
     * to create an ad slot.
     *
     * @property adUnitPath
     */
    adUnitPath: _propTypes2.default.string.isRequired,
    /**
     * An optional object which includes ad targeting key-value pairs.
     *
     * @property targeting
     */
    targeting: _propTypes2.default.object,
    /**
     * An optional prop to specify the ad slot size which accepts [googletag.GeneralSize](https://developers.google.com/doubleclick-gpt/reference#googletag.GeneralSize) as a type.
     * This will be preceded by the sizeMapping if specified.
     *
     * @property slotSize
     */
    slotSize: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    /**
     * An optional array of object which contains an array of viewport size and slot size.
     * This needs to be set if the ad needs to serve different ad sizes per different viewport sizes (responsive ad).
     * Setting the `slot` to any dimension that's not configured in DFP results in rendering an empty ad.
     * The ad slot size which is provided for the viewport size of [0, 0] will be used as default ad size if none of viewport size matches.
     *
     * https://support.google.com/dfp_premium/answer/3423562?hl=en
     *
     * e.g.
     *
     * sizeMapping={[
     *   {viewport: [0, 0], slot: [320, 50]},
     *   {viewport: [768, 0], slot: [728, 90]}
     * ]}
     *
     * @property sizeMapping
     */
    sizeMapping: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        viewport: _propTypes2.default.array,
        slot: _propTypes2.default.array
    })),
    /**
     * An optional flag to indicate whether an ad slot should be out-of-page slot.
     *
     * @property outOfPage
     */
    outOfPage: _propTypes2.default.bool,
    /**
     * An optional flag to indicate whether companion ad service should be enabled for the ad.
     * If an object is passed, it takes as a configuration expecting `enableSyncLoading` or `refreshUnfilledSlots`.
     *
     * @property companionAdService
     */
    companionAdService: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /**
     * An optional HTML content for the slot. If specified, the ad will render with the HTML content using content service.
     *
     * @property content
     */
    content: _propTypes2.default.string,
    /**
     * An optional click through URL. If specified, any landing page URL associated with the creative that is served is overridden.
     *
     * @property clickUrl
     */
    clickUrl: _propTypes2.default.string,
    /**
     * An optional string or an array of string which specifies a page-level ad category exclusion for the given label name.
     *
     * @property categoryExclusion
     */
    categoryExclusion: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    /**
     * An optional map of key-value pairs for an AdSense attribute on a particular ad slot.
     * see the list of supported key value: https://developers.google.com/doubleclick-gpt/adsense_attributes#adsense_parameters.googletag.Slot
     *
     * @property attributes
     */
    attributes: _propTypes2.default.object,
    /**
     * An optional flag to indicate whether an empty ad should be collapsed or not.
     *
     * @property collapseEmptyDiv
     */
    collapseEmptyDiv: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
    /**
     * An optional flag to indicate whether ads in this slot should be forced to be rendered using a SafeFrame container.
     *
     * @property forceSafeFrame
     */
    forceSafeFrame: _propTypes2.default.bool,
    /**
     * An optional object to set the slot-level preferences for SafeFrame configuration.
     *
     * @property safeFrameConfig
     */
    safeFrameConfig: _propTypes2.default.object,
    /**
     * An optional event handler function for `googletag.events.SlotRenderEndedEvent`.
     *
     * @property onSlotRenderEnded
     */
    onSlotRenderEnded: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.ImpressionViewableEvent`.
     *
     * @property onImpressionViewable
     */
    onImpressionViewable: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.slotVisibilityChangedEvent`.
     *
     * @property onSlotVisibilityChanged
     */
    onSlotVisibilityChanged: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.SlotOnloadEvent`.
     *
     * @property onSlotOnload
     */
    onSlotOnload: _propTypes2.default.func,
    /**
     * An optional flag to indicate whether an ad should only render when it's fully in the viewport area.
     *
     * @property renderWhenViewable
     */
    renderWhenViewable: _propTypes2.default.bool,
    /**
     * An optional number to indicate how much percentage of an ad area needs to be in a viewable area before rendering.
     * Acceptable range is between 0 and 1.
     *
     * @property viewableThreshold
     */
    viewableThreshold: _propTypes2.default.number,
    /**
     * An optional call back function to notify when the script is loaded.
     *
     * @property onScriptLoaded
     */
    onScriptLoaded: _propTypes2.default.func,
    /**
     * An optional call back function to notify when the media queries on the document change.
     *
     * @property onMediaQueryChange
     */
    onMediaQueryChange: _propTypes2.default.func,
    /**
     * An optional object to be applied as `style` props to the container div.
     *
     * @property style
     */
    style: _propTypes2.default.object
}, _class.refreshableProps = ["targeting", "sizeMapping", "clickUrl", "categoryExclusion", "attributes", "collapseEmptyDiv", "companionAdService", "forceSafeFrame", "safeFrameConfig"], _class.reRenderProps = ["adUnitPath", "slotSize", "outOfPage", "content"], _class._adManager = (0, _createManager.createManager)(), _class._config = {
    /**
     * An optional string for GPT seed file url to override.
     */
    seedFileUrl: "//www.googletagservices.com/tag/js/gpt.js",
    /**
     * An optional flag to indicate whether an ad should only render when it's fully in the viewport area. Default is `true`.
     */
    renderWhenViewable: true,
    /**
     * An optional number to indicate how much percentage of an ad area needs to be in a viewable area before rendering. Default value is 0.5.
     * Acceptable range is between 0 and 1.
     */
    viewableThreshold: 0.5,
    /**
     * An optional function to create an object with filtered current props and next props for a given keys to perform equality check.
     */
    filterProps: _filterProps2.default,
    /**
     * An optional function for the filtered props and the next props to perform equality check.
     */
    propsEqual: _deepEqual2.default
}, _temp2);

// proxy pubads API through Bling

exports.default = (0, _hoistNonReactStatics2.default)(Bling, _createManager.pubadsAPI.reduce(function (api, method) {
    api[method] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Bling._adManager.pubadsProxy({ method: method, args: args });
    };
    return api;
}, {}));

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(643);
var isArguments = __webpack_require__(1762);
var is = __webpack_require__(1763);
var isRegex = __webpack_require__(1764);
var flags = __webpack_require__(1768);
var isDate = __webpack_require__(1770);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(644); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr = Object.prototype.toString;

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return toStr.call(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		toStr.call(value) !== '[object Array]' &&
		toStr.call(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.is */

var NumberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	} else if (a === b) {
		return true;
	} else if (NumberIsNaN(a) && NumberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(1765);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(1766);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1767);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(322);

var implementation = __webpack_require__(645);
var getPolyfill = __webpack_require__(646);
var shim = __webpack_require__(1769);

var flagsBound = Function.call.bind(implementation);

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(322).supportsDescriptors;
var getPolyfill = __webpack_require__(646);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 1772 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filterProps;
function filterProps(propKeys, props, nextProps) {
    return propKeys.reduce(function (filtered, key) {
        filtered.props[key] = props[key];
        filtered.nextProps[key] = nextProps[key];
        return filtered;
    }, {
        props: {},
        nextProps: {}
    });
}

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdManager = exports.APIToCallBeforeServiceEnabled = exports.pubadsAPI = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createManager = createManager;

var _eventemitter = __webpack_require__(1774);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _throttleDebounce = __webpack_require__(1775);

var _invariant = __webpack_require__(60);

var _invariant2 = _interopRequireDefault(_invariant);

var _exenv = __webpack_require__(1777);

var _Events = __webpack_require__(323);

var _Events2 = _interopRequireDefault(_Events);

var _isInViewport2 = __webpack_require__(1778);

var _isInViewport3 = _interopRequireDefault(_isInViewport2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// based on https://developers.google.com/doubleclick-gpt/reference?hl=en
var pubadsAPI = exports.pubadsAPI = ["enableAsyncRendering", "enableSingleRequest", "enableSyncRendering", "disableInitialLoad", "collapseEmptyDivs", "enableVideoAds", "set", "get", "getAttributeKeys", "setTargeting", "clearTargeting", "setCategoryExclusion", "clearCategoryExclusions", "setCentering", "setCookieOptions", "setLocation", "setPublisherProvidedId", "setTagForChildDirectedTreatment", "clearTagForChildDirectedTreatment", "setVideoContent", "setForceSafeFrame"];

var APIToCallBeforeServiceEnabled = exports.APIToCallBeforeServiceEnabled = ["enableAsyncRendering", "enableSingleRequest", "enableSyncRendering", "disableInitialLoad", "collapseEmptyDivs", "setCentering"];

var AdManager = exports.AdManager = function (_EventEmitter) {
    _inherits(AdManager, _EventEmitter);

    function AdManager() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, AdManager);

        var _this = _possibleConstructorReturn(this, (AdManager.__proto__ || Object.getPrototypeOf(AdManager)).call(this, config));

        _this._adCnt = 0;
        _this._initialRender = true;
        _this._syncCorrelator = false;
        _this._testMode = false;
        _this._foldCheck = (0, _throttleDebounce.throttle)(20, function (event) {
            var instances = _this.getMountedInstances();
            instances.forEach(function (instance) {
                if (instance.getRenderWhenViewable()) {
                    instance.foldCheck(event);
                }
            });

            if (_this.testMode) {
                _this._getTimer();
            }
        });

        _this._handleMediaQueryChange = function (event) {
            if (_this._syncCorrelator) {
                _this.refresh();
                return;
            }
            // IE returns `event.media` value differently, need to use regex to evaluate.
            // eslint-disable-next-line wrap-regex
            var res = /min-width:\s?(\d+)px/.exec(event.media);
            var viewportWidth = res && res[1];

            if (viewportWidth && _this._mqls[viewportWidth]) {
                _this._mqls[viewportWidth].listeners.forEach(function (instance) {
                    instance.refresh();
                    if (instance.props.onMediaQueryChange) {
                        instance.props.onMediaQueryChange(event);
                    }
                });
            }
        };

        _this.render = (0, _throttleDebounce.debounce)(4, function () {
            if (!_this._initialRender) {
                return;
            }

            var checkPubadsReady = function checkPubadsReady(cb) {
                if (_this.pubadsReady) {
                    cb();
                } else {
                    setTimeout(checkPubadsReady, 50, cb);
                }
            };

            var instances = _this.getMountedInstances();
            var hasPubAdsService = false;
            var dummyAdSlot = void 0;

            // Define all the slots
            instances.forEach(function (instance) {
                if (!instance.notInViewport()) {
                    instance.defineSlot();
                    var adSlot = instance.adSlot;

                    if (adSlot && adSlot.hasOwnProperty("getServices")) {
                        var services = adSlot.getServices();
                        if (!hasPubAdsService) {
                            hasPubAdsService = services.filter(function (service) {
                                return !!service.enableAsyncRendering;
                            }).length > 0;
                        }
                    }
                }
            });
            // if none of the ad slots uses pubads service, create dummy slot to use pubads service.
            if (!hasPubAdsService) {
                dummyAdSlot = _this.googletag.defineSlot("/", []);
                dummyAdSlot.addService(_this.googletag.pubads());
            }

            // Call pubads API which needs to be called before service is enabled.
            _this._processPubadsQueue();

            // Enable service
            _this.googletag.enableServices();

            // After the service is enabled, check periodically until `pubadsReady` flag returns true before proceeding the rest.
            checkPubadsReady(function () {
                // destroy dummy ad slot if exists.
                if (dummyAdSlot) {
                    _this.googletag.destroySlots([dummyAdSlot]);
                }
                // Call the rest of the pubads API that's in the queue.
                _this._processPubadsQueue();
                // listen for GPT events
                _this._listen();
                // client should be able to set any page-level setting within the event handler.
                _this._isReady = true;
                _this.emit(_Events2.default.READY, _this.googletag);

                // Call display
                instances.forEach(function (instance) {
                    if (!instance.notInViewport()) {
                        instance.display();
                    }
                });

                _this.emit(_Events2.default.RENDER, _this.googletag);

                _this._initialRender = false;
            });
        });
        _this.renderAll = (0, _throttleDebounce.debounce)(4, function () {
            if (!_this.apiReady) {
                return false;
            }

            // first instance updates correlator value and re-render each ad
            var instances = _this.getMountedInstances();
            instances.forEach(function (instance, i) {
                if (i === 0) {
                    _this.updateCorrelator();
                }
                instance.forceUpdate();
            });

            return true;
        });


        if (config.test) {
            _this.testMode = config;
        }
        return _this;
    }

    _createClass(AdManager, [{
        key: "_processPubadsQueue",
        value: function _processPubadsQueue() {
            var _this2 = this;

            if (this._pubadsProxyQueue) {
                Object.keys(this._pubadsProxyQueue).forEach(function (method) {
                    if (_this2.googletag && !_this2.googletag.pubadsReady && APIToCallBeforeServiceEnabled.indexOf(method) > -1 || _this2.pubadsReady) {
                        _this2._pubadsProxyQueue[method].forEach(function (params) {
                            return _this2.pubadsProxy(params);
                        });
                        delete _this2._pubadsProxyQueue[method];
                    }
                });
                if (!Object.keys(this._pubadsProxyQueue).length) {
                    this._pubadsProxyQueue = null;
                }
            }
        }
    }, {
        key: "_callPubads",
        value: function _callPubads(_ref) {
            var method = _ref.method,
                args = _ref.args,
                resolve = _ref.resolve,
                reject = _ref.reject;

            if (typeof this.googletag.pubads()[method] !== "function") {
                reject(new Error("googletag.pubads does not support " + method + ", please update pubadsAPI"));
            } else {
                try {
                    var _googletag$pubads;

                    var result = (_googletag$pubads = this.googletag.pubads())[method].apply(_googletag$pubads, _toConsumableArray(args));
                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            }
        }
    }, {
        key: "_toggleListener",
        value: function _toggleListener(add) {
            var _this3 = this;

            ["scroll", "resize"].forEach(function (eventName) {
                window[add ? "addEventListener" : "removeEventListener"](eventName, _this3._foldCheck);
            });
        }
    }, {
        key: "_getTimer",
        value: function _getTimer() {
            return Date.now();
        }
    }, {
        key: "_listen",
        value: function _listen() {
            var _this4 = this;

            if (!this._listening) {
                [_Events2.default.SLOT_RENDER_ENDED, _Events2.default.IMPRESSION_VIEWABLE, _Events2.default.SLOT_VISIBILITY_CHANGED, _Events2.default.SLOT_LOADED].forEach(function (eventType) {
                    ["pubads", "content", "companionAds"].forEach(function (service) {
                        // there is no API to remove listeners.
                        _this4.googletag[service]().addEventListener(eventType, _this4._onEvent.bind(_this4, eventType));
                    });
                });
                this._listening = true;
            }
        }
    }, {
        key: "_onEvent",
        value: function _onEvent(eventType, event) {
            // fire to the global listeners
            if (this.listeners(eventType, true)) {
                this.emit(eventType, event);
            }
            // call event handler props
            var instances = this.getMountedInstances();
            var slot = event.slot;

            var funcName = "on" + eventType.charAt(0).toUpperCase() + eventType.substr(1);
            var instance = instances.filter(function (inst) {
                return slot === inst.adSlot;
            })[0];
            if (instance && instance.props[funcName]) {
                instance.props[funcName](event);
            }
        }
    }, {
        key: "syncCorrelator",
        value: function syncCorrelator() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this._syncCorrelator = value;
        }
    }, {
        key: "generateDivId",
        value: function generateDivId() {
            return "bling-" + ++this._adCnt;
        }
    }, {
        key: "getMountedInstances",
        value: function getMountedInstances() {
            if (!this.mountedInstances) {
                this.mountedInstances = [];
            }
            return this.mountedInstances;
        }
    }, {
        key: "addInstance",
        value: function addInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index === -1) {
                // The first instance starts listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(true);
                }
                this.addMQListener(instance, instance.props);
                instances.push(instance);
            }
        }
    }, {
        key: "removeInstance",
        value: function removeInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index >= 0) {
                instances.splice(index, 1);
                // The last instance removes listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(false);
                }
                this.removeMQListener(instance, instance.props);
            }
        }
    }, {
        key: "addMQListener",
        value: function addMQListener(instance, _ref2) {
            var _this5 = this;

            var sizeMapping = _ref2.sizeMapping;

            if (!sizeMapping || !Array.isArray(sizeMapping)) {
                return;
            }

            sizeMapping.forEach(function (size) {
                var viewportWidth = size.viewport && size.viewport[0];
                if (viewportWidth !== undefined) {
                    if (!_this5._mqls) {
                        _this5._mqls = {};
                    }
                    if (!_this5._mqls[viewportWidth]) {
                        var mql = window.matchMedia("(min-width: " + viewportWidth + "px)");
                        mql.addListener(_this5._handleMediaQueryChange);
                        _this5._mqls[viewportWidth] = {
                            mql: mql,
                            listeners: []
                        };
                    }
                    if (_this5._mqls[viewportWidth].listeners.indexOf(instance) === -1) {
                        _this5._mqls[viewportWidth].listeners.push(instance);
                    }
                }
            });
        }
    }, {
        key: "removeMQListener",
        value: function removeMQListener(instance) {
            var _this6 = this;

            if (!this._mqls) {
                return;
            }

            Object.keys(this._mqls).forEach(function (key) {
                var index = _this6._mqls[key].listeners.indexOf(instance);
                if (index > -1) {
                    _this6._mqls[key].listeners.splice(index, 1);
                }
                if (_this6._mqls[key].listeners.length === 0) {
                    _this6._mqls[key].mql.removeListener(_this6._handleMediaQueryChange);
                    delete _this6._mqls[key];
                }
            });
        }
    }, {
        key: "isInViewport",
        value: function isInViewport() {
            return _isInViewport3.default.apply(undefined, arguments);
        }

        /**
         * Refreshes all the ads in the page with a new correlator value.
         *
         * @param {Array} slots An array of ad slots.
         * @param {Object} options You can pass `changeCorrelator` flag.
         * @static
         */

    }, {
        key: "refresh",
        value: function refresh(slots, options) {
            if (!this.pubadsReady) {
                return false;
            }

            // gpt already debounces refresh
            this.googletag.pubads().refresh(slots, options);

            return true;
        }
    }, {
        key: "clear",
        value: function clear(slots) {
            if (!this.pubadsReady) {
                return false;
            }

            this.googletag.pubads().clear(slots);

            return true;
        }

        /**
         * Re-render(not refresh) all the ads in the page and the first ad will update the correlator value.
         * Updating correlator value ensures competitive exclusion.
         *
         * @method renderAll
         * @static
         */

    }, {
        key: "getGPTVersion",
        value: function getGPTVersion() {
            if (!this.apiReady) {
                return false;
            }
            return this.googletag.getVersion();
        }
    }, {
        key: "getPubadsVersion",
        value: function getPubadsVersion() {
            if (!this.pubadsReady) {
                return false;
            }
            return this.googletag.pubads().getVersion();
        }
    }, {
        key: "updateCorrelator",
        value: function updateCorrelator() {
            if (!this.pubadsReady) {
                return false;
            }
            this.googletag.pubads().updateCorrelator();

            return true;
        }
    }, {
        key: "load",
        value: function load(url) {
            var _this7 = this;

            return this._loadPromise || (this._loadPromise = new Promise(function (resolve, reject) {
                // test mode can't be enabled in production mode
                if (_this7.testMode) {
                    resolve(_this7.googletag);
                    return;
                }
                if (!_exenv.canUseDOM) {
                    reject(new Error("DOM not available"));
                    return;
                }
                if (!url) {
                    reject(new Error("url is missing"));
                    return;
                }
                var onLoad = function onLoad() {
                    if (window.googletag) {
                        _this7._googletag = window.googletag;
                        // make sure API is ready for use.
                        _this7.googletag.cmd.push(function () {
                            _this7._isLoaded = true;
                            resolve(_this7.googletag);
                        });
                    } else {
                        reject(new Error("window.googletag is not available"));
                    }
                };
                if (window.googletag && window.googletag.apiReady) {
                    onLoad();
                } else {
                    var script = document.createElement("script");
                    script.async = true;
                    script.onload = onLoad;
                    script.onerror = function () {
                        reject(new Error("failed to load script"));
                    };
                    script.src = url;
                    document.head.appendChild(script);
                }
            }));
        }
    }, {
        key: "pubadsProxy",
        value: function pubadsProxy(_ref3) {
            var _this8 = this;

            var method = _ref3.method,
                _ref3$args = _ref3.args,
                args = _ref3$args === undefined ? [] : _ref3$args,
                resolve = _ref3.resolve,
                reject = _ref3.reject;

            if (!resolve) {
                // there are couple pubads API which doesn't provide getter methods for later use,
                // so remember them here.
                if (APIToCallBeforeServiceEnabled.indexOf(method) > -1) {
                    this["_" + method] = args && args.length && args[0] || true;
                }
                return new Promise(function (resolve2, reject2) {
                    var params = {
                        method: method,
                        args: args,
                        resolve: resolve2,
                        reject: reject2
                    };
                    if (!_this8.pubadsReady) {
                        if (!_this8._pubadsProxyQueue) {
                            _this8._pubadsProxyQueue = {};
                        }
                        if (!_this8._pubadsProxyQueue[method]) {
                            _this8._pubadsProxyQueue[method] = [];
                        }
                        _this8._pubadsProxyQueue[method].push(params);
                    } else {
                        _this8._callPubads(params);
                    }
                });
            }

            this._callPubads({ method: method, args: args, resolve: resolve, reject: reject });

            return Promise.resolve();
        }
    }, {
        key: "googletag",
        get: function get() {
            return this._googletag;
        }
    }, {
        key: "isLoaded",
        get: function get() {
            return !!this._isLoaded;
        }
    }, {
        key: "isReady",
        get: function get() {
            return !!this._isReady;
        }
    }, {
        key: "apiReady",
        get: function get() {
            return this.googletag && this.googletag.apiReady;
        }
    }, {
        key: "pubadsReady",
        get: function get() {
            return this.googletag && this.googletag.pubadsReady;
        }
    }, {
        key: "testMode",
        get: function get() {
            return this._testMode;
        },
        set: function set(config) {
            if (true) {
                return;
            }
            var test = config.test,
                GPTMock = config.GPTMock;

            this._isLoaded = true;
            this._testMode = !!test;

            if (test) {
                (0, _invariant2.default)(test && GPTMock, "Must provide GPTMock to enable testMode. config{GPTMock}");
                this._googletag = new GPTMock(config);
            }
        }
    }]);

    return AdManager;
}(_eventemitter2.default);

function createManager(config) {
    return new AdManager(config);
}

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var throttle = __webpack_require__(647);
var debounce = __webpack_require__(1776);

module.exports = {
	throttle: throttle,
	debounce: debounce
};

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-undefined */

var throttle = __webpack_require__(647);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1778 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = isInViewport;
function isInViewport(el) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0],
        _ref2 = _slicedToArray(_ref, 2),
        width = _ref2[0],
        height = _ref2[1];

    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (!el || el.nodeType !== 1) {
        return false;
    }
    var clientRect = el.getBoundingClientRect();
    var rect = {
        top: clientRect.top,
        left: clientRect.left,
        bottom: clientRect.bottom,
        right: clientRect.right
    };
    var viewport = {
        top: 0,
        left: 0,
        bottom: window.innerHeight,
        right: window.innerWidth
    };
    var inViewport = rect.bottom >= viewport.top + height * offset && rect.right >= viewport.left + width * offset && rect.top <= viewport.bottom - height * offset && rect.left <= viewport.right - width * offset;
    return inViewport;
}

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gpt__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_gpt__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_2_react_gpt__["Bling"].configure({renderWhenViewable:false,collapseEmptyDiv:true,outOfPage:true});var AdBanner=function(_Component){_inherits(AdBanner,_Component);function AdBanner(){_classCallCheck(this,AdBanner);return _possibleConstructorReturn(this,(AdBanner.__proto__||Object.getPrototypeOf(AdBanner)).apply(this,arguments));}_createClass(AdBanner,[{key:'componentWillMount',value:function componentWillMount(){this.urlSlider='/'+this.props.accountDfp+'/'+this.props.sliderName;this.setState({showBanner:false});}},{key:'render',value:function render(){var _this2=this;setTimeout(function(){_this2.setState({showBanner:true});},5000);return this.state.showBanner?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_gpt__["Bling"],{adUnitPath:this.urlSlider,targeting:this.props.targeting,sizeMapping:this.props.sizeMapping}):'';}}]);return AdBanner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AdBanner.propTypes={accountDfp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,sliderName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,targeting:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,sizeMapping:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* unused harmony default export */ var _unused_webpack_default_export = (AdBanner);

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WrapperSlider__ = __webpack_require__(648);
/* unused harmony reexport WrapperSlider */


/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var WrapperSliderPlaceholder=function WrapperSliderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-slider container-fluid  py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' container pos-relative radius px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'csslider infinity'})));};/* harmony default export */ __webpack_exports__["a"] = (WrapperSliderPlaceholder);

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBanner; });
var getBanner=function getBanner(isLogged,eventCategory,eventAction,items){window.dataLayer=window.dataLayer||[];window.dataLayer.push({'event':'event','eventCategory':("tupperware-inc-cancun"||'webpremios')+':'+eventCategory+'-'+(isLogged?'logada':'aberta'),'eventAction':eventAction,'noInteraction':'1','ecommerce':{'promoView':{'promotions':items}}});};

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DoubleSlider__ = __webpack_require__(1785);
/* unused harmony reexport DoubleSlider */


/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DoubleSliderPlaceholder__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_slider_css__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_molecules_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DoubleSlider=function(_Component){_inherits(DoubleSlider,_Component);function DoubleSlider(){_classCallCheck(this,DoubleSlider);return _possibleConstructorReturn(this,(DoubleSlider.__proto__||Object.getPrototypeOf(DoubleSlider)).apply(this,arguments));}_createClass(DoubleSlider,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DoubleSliderPlaceholder__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-slider pos-relative bg-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 txt-center'},this.props.targeting.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'col-6 slider-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* AdSlider */],{accountDfp:itemSlider.accountDfp,sliderName:itemSlider.sliderName,slotSize:itemSlider.slotSize,targeting:itemSlider.targeting,collapseEmptyDivs:true}));}))))));}}]);return DoubleSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DoubleSlider.propTypes={targeting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array};/* unused harmony default export */ var _unused_webpack_default_export = (DoubleSlider);

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_placeholder_svg__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_products_placeholder_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_placeholder_svg__);
var DoubleSliderPlaceholder=function DoubleSliderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-slider pos-relative bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_products_placeholder_svg___default.a,alt:'Banner carregando',className:'img-w-auto ml-auto mr-auto'})));};/* harmony default export */ __webpack_exports__["a"] = (DoubleSliderPlaceholder);

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wrapperSlider_WrapperSlider__ = __webpack_require__(648);
var configureDfpTargeting=function configureDfpTargeting(dfpAccount,sliders,campaignId,catalogId,clientId,sliderIsOnlyCash){return sliders.map(function(slider){return{accountDfp:dfpAccount,sliderName:slider,sizeMapping:[{viewport:[0,0],slot:[375,310]},{viewport:[475,0],slot:[1366,450]}],targeting:{ltm_campaign:[campaignId,'default'],ltm_catalog:[catalogId,'default'],ltm_costumer:[clientId],only_cash:[sliderIsOnlyCash]}};});};var SliderContainer=function SliderContainer(_ref){var profile=_ref.profile,google=_ref.google,onlyCash=_ref.onlyCash,catalogJustCash=_ref.catalogJustCash;var sliders=['ragnarok_1','ragnarok_2','ragnarok_3','ragnarok_4','ragnarok_5','ragnarok_6','ragnarok_7','ragnarok_8','ragnarok_9','ragnarok_10'];var campaignId=profile?profile['custom:campaign_id']:'0';var catalogId=profile?profile['custom:catalog_id']:"80938";var clientId=profile?profile['custom:client_id']:'0';var sliderIsOnlyCash=catalogJustCash?onlyCash.toString():'false';var sliderList=configureDfpTargeting(google.accountDfp,sliders,campaignId,catalogId,clientId,sliderIsOnlyCash);var options={autoHeight:true,items:1,nav:true,rewind:!profile,autoplay:true,navClass:['pos-absolute slider-nav showcase-nav showcase-next bg-featured d-none d-md-block border-color-brand-1 btn-icon','pos-absolute slider-nav showcase-nav showcase-prev bg-featured d-none d-md-block border-color-brand-1 btn-icon'],navText:['<i className="icon icon_right color-ui-white" aria-hidden="true"></i>','<i className="icon icon_left color-ui-white" aria-hidden="true"></i>']};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__wrapperSlider_WrapperSlider__["a" /* default */],{profile:profile,sliders:sliderList,options:options});};SliderContainer.propTypes={profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({'custom:campaign_id':__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,'custom:catalog_id':__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,'custom:client_id':__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}),google:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({accountDfp:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}),catalogJustCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref2){var user=_ref2.oidc.user,google=_ref2.google,catalog=_ref2.catalog,onlyCash=_ref2.onlyCash;return{profile:user&&user.profile,google:google,catalogJustCash:catalog.onlyCash,onlyCash:onlyCash};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(SliderContainer));

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_responsive__);
// import ganhePontos from '@loyal_images/banners/ganhe_pontos.png'
var ConexxeBanner=function ConexxeBanner(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-bannerConexxe pos-relative pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 px-sm-0 txt-center banner-tablet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{maxDeviceWidth:475},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'',alt:'Tem pontos no Sempre Presente? Transfira seus pontos para o iupp e fa\xE7a suas compras.',className:'w-100'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{minDeviceWidth:476},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'',alt:'Tem pontos no Sempre Presente? Transfira seus pontos para o iupp e fa\xE7a suas compras.',className:'w-100'})))))));};/* harmony default export */ __webpack_exports__["a"] = (ConexxeBanner);

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_gpt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var removeEmpty=function removeEmpty(event){if(event.isEmpty){var list;list=document.querySelectorAll('.bx-banner-travel');for(var i=0;i<list.length;++i){list[i].classList.add('d-none');}}};var configureDfpTargeting=function configureDfpTargeting(dfpAccount,sliders,campaignId,catalogId,clientId){return sliders.map(function(slider){return{accountDfp:dfpAccount,sliderName:slider,urlSlider:'/'+dfpAccount+'/'+slider,sizeMapping:[{viewport:[0,0],slot:[335,160]},{viewport:[475,0],slot:[1180,300]}],targeting:{ltm_campaign:[campaignId,'default'],ltm_catalog:[catalogId,'default'],vertem_template:[Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_BANNER_TEMPLATE||'default'],ltm_costumer:[clientId]}};});};var ConexxeBannerDFP=function ConexxeBannerDFP(_ref){var profile=_ref.profile,google=_ref.google;var sliders=['ragnarok_travel'];var campaignId=profile?profile['custom:campaign_id']:'0';var catalogId=profile?profile['custom:catalog_id']:"80938";var clientId=profile?profile['custom:client_id']:'0';var sliderList=configureDfpTargeting(google.accountDfp,sliders,campaignId,catalogId,clientId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-banner-travel pos-relative pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},sliderList.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'col-12 px-1 px-sm-0 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_gpt__["Bling"],{adUnitPath:itemSlider.urlSlider,targeting:itemSlider.targeting,sizeMapping:itemSlider.sizeMapping,onSlotRenderEnded:removeEmpty}));}))));};ConexxeBannerDFP.propTypes={profile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({'custom:campaign_id':__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,'custom:catalog_id':__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,'custom:client_id':__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}),google:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({accountDfp:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired})};var mapStateToProps=function mapStateToProps(_ref2){var user=_ref2.oidc.user,google=_ref2.google;return{profile:user&&user.profile,google:google};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(ConexxeBannerDFP));

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var ConexxeBannerVivo=function ConexxeBannerVivo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-bannerConexxe pos-relative pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-1 px-sm-0 txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:'/search?category=5',title:'Veja nossos produtos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{maxDeviceWidth:475},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://vertemmodulosprd.blob.core.windows.net/banners/vivo_masters20_MAI_banner_1180x300_cat_premio_B_01.jpg',alt:'Veja nossas viagens',className:'w-100'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive___default.a,{minDeviceWidth:476},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://vertemmodulosprd.blob.core.windows.net/banners/vivo_masters20_MAI_banner_1180x300_cat_premio_B_01.jpg',alt:'Veja nossas viagens',className:'w-100'})))))));};/* harmony default export */ __webpack_exports__["a"] = (ConexxeBannerVivo);

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Showcase_ducks__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Catalog_Product_ProductCard_Tagging__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Showcase__ = __webpack_require__(649);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowcaseContainer=function(_Component){_inherits(ShowcaseContainer,_Component);function ShowcaseContainer(props){_classCallCheck(this,ShowcaseContainer);var _this=_possibleConstructorReturn(this,(ShowcaseContainer.__proto__||Object.getPrototypeOf(ShowcaseContainer)).call(this,props));_this.handleLoadShowcase=_this.handleLoadShowcase.bind(_this);return _this;}_createClass(ShowcaseContainer,[{key:'handleLoadShowcase',value:function handleLoadShowcase(){var _props=this.props,loadShowcase=_props.loadShowcase,showcaseType=_props.showcaseType,identifier=_props.identifier;loadShowcase(showcaseType,identifier);}},{key:'componentDidMount',value:function componentDidMount(){this.handleLoadShowcase();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.onlyCash!==this.props.onlyCash){this.handleLoadShowcase();}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,_=_props2.loadShowcase,products=_props2.products,props=_objectWithoutProperties(_props2,['loadShowcase','products']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Showcase__["a" /* default */],Object.assign({products:products},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Catalog_Product_ProductCard_Tagging__["a" /* default */],{type:'send'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{minWidth:480},products.map(function(sku,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],{position:index,identifier:_this2.props.identifier,titleShowcase:props.title,key:sku,sku:sku});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,{maxWidth:479},products.slice(0,4).map(function(sku,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],{isResponsiveEnabled:true,identifier:_this2.props.identifier,titleShowcase:props.title,position:index,className:'col-12 mb-1 px-half d-block card-mobile',sku:sku,key:sku+'_mobile'});})));}}]);return ShowcaseContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShowcaseContainer.propTypes={loadShowcase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,showcaseType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,identifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,products:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ShowcaseContainer.defaultProps={isLoading:true,products:[]};var mapStateToProps=function mapStateToProps(_ref,_ref2){var showcases=_ref.showcases,onlyCash=_ref.onlyCash;var showcaseType=_ref2.showcaseType,identifier=_ref2.identifier;var showcase=showcases[showcaseType]?showcases[showcaseType][identifier]:{};return Object.assign({},showcase,{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadShowcase:function loadShowcase(showcaseType,identifier){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Catalog_Showcase_ducks__["c" /* fetchShowcase */])(showcaseType,identifier));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ShowcaseContainer));

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder_lib_reactPlaceholder_css__);
var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card container pt-3 pb-1 py-md-3 px-0 px-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx--1 mx-md-0 px-2 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-1 py-half txt-body-sm color-ui-2 bg-ui-3 txt-font-body txt-center w-100 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 px-1 d-none  d-md-flex '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card  col-6 col-sm-4 col-md-3 d-none d-md-flex px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-4 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-center pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 ml-auto mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'mw-100'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mb-1  py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12  mt-2 mb-1 color-brand-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-headline txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 pt-3 txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-currency col-12 txt-body txt-circular-black txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 py-half txt-body-sm color-ui-2 bg-ui-4 txt-font-body txt-center w-100 radius'})))))))))));};var ShowcasePlaceholder=function ShowcasePlaceholder(_ref){var isLoading=_ref.isLoading,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_placeholder___default.a,{ready:!isLoading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder,null)},children));};ShowcasePlaceholder.propTypes={isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};ShowcasePlaceholder.defaultProps={isLoading:true};/* harmony default export */ __webpack_exports__["a"] = (ShowcasePlaceholder);

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_card_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loyal_molecules_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__loyal_molecules_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_showcases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_modules_carousel_css_owl_theme_default_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2__);
var ShowcaseProductListWrapper=function ShowcaseProductListWrapper(_ref){var children=_ref.children,viewAllPath=_ref.viewAllPath;Object(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function(){setTimeout(function(){var nextButton=document.querySelector('.bx-showcase-products .owl-nav');nextButton&&nextButton.setAttribute('aria-hidden',true);},2000);},[]);var options={margin:10,autoplay:false,dots:false,rewind:true,loop:false,mouseDrag:false,pullDrag:false,freeDrag:false,responsive:{0:{items:1,margin:0,rewind:true,loop:false},400:{items:2,margin:0,rewind:true,loop:false},600:{items:4,nav:true,rewind:true,loop:false},1000:{margin:20,nav:true,rewind:true,loop:false,items:4}},navClass:['pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon','pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'],navText:['<i class="icon icon_left icon-sm color-ui-white" aria-hidden="true"></i>','<i class="icon icon_right icon-sm color-ui-white" aria-hidden="true"></i>']};return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_owl_carousel2___default.a,{className:'showcase-carousel bx-slider w-100 mx-0 owl-carousel owl-theme px-1',options:options},children)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive___default.a,{maxDeviceWidth:425},children,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["Link"],{to:viewAllPath,className:'btn btn-sm txt-center txt-button btn-invert border-color-ui-2'},'Ver todos')))));};ShowcaseProductListWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,viewAllPath:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string};ShowcaseProductListWrapper.defaultProps={viewAllPath:'/search'};/* harmony default export */ __webpack_exports__["a"] = (ShowcaseProductListWrapper);

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_owl_carousel2__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_owl_carousel2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_owl_carousel2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_card_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_molecules_card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_molecules_card_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_modules_carousel_css_owl_carousel_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_modules_carousel_css_owl_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_modules_carousel_css_owl_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_modules_carousel_css_owl_theme_default_min_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_modules_carousel_css_owl_theme_default_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_modules_carousel_css_owl_theme_default_min_css__);
var Showcase=function Showcase(_ref){var _ref$title=_ref.title,title=_ref$title===undefined?'':_ref$title,_ref$titleMobile=_ref.titleMobile,titleMobile=_ref$titleMobile===undefined?'':_ref$titleMobile,children=_ref.children,searchPage=_ref.searchPage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'showcard-products container-card container py-1 py-md-3 px-0 px-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-auto mb-2 mx-0 px-0'},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'},title),titleMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-block d-md-none px-md-0 pt-1 px-0'},titleMobile)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:searchPage||'/search',className:'card-see-all d-block btn btn-sm btn-flat btn-icon txt-button txt-font-body btn-invert'},'Ver todos ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon-sm icon_right'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bx-showcase-products pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row row-eq-height w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_owl_carousel2___default.a,{className:'showcase-carousel bx-slider w-100 mx-0 owl-carousel owl-theme px-1',options:options},children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive___default.a,{maxDeviceWidth:425},children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-5 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:searchPage||'/search',className:'btn btn-sm  txt-center txt-button btn-invert'},'Ver todos'))))));};var options={margin:10,autoplay:false,dots:false,rewind:true,loop:false,responsive:{0:{items:2,margin:0,rewind:true,loop:false},420:{items:2,nav:true,rewind:true,loop:false},600:{items:4,nav:true,rewind:true,loop:false},1000:{margin:20,nav:true,rewind:true,loop:false,items:4}},navClass:['pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon','pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'],navText:['<i class="icon icon_left icon-sm color-ui-white"></i>','<i class="icon icon_right icon-sm color-ui-white"></i>']};Showcase.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,searchPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* unused harmony default export */ var _unused_webpack_default_export = (Showcase);

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilteredShowcase_FilteredHeader__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FilteredShowcase_FilteredWrapper__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FilteredShowcase_FilteredItem__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__);
var FilteredShowcase=function FilteredShowcase(_ref){var onlyCash=_ref.onlyCash,showcaseInfos=_ref.showcaseInfos;return showcaseInfos.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'bx-filteredShowcase pos-relative py-3 '+(onlyCash?'scope-onlyCash':'scope-points')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-1 px-sm-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FilteredShowcase_FilteredHeader__["a" /* default */],item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FilteredShowcase_FilteredWrapper__["a" /* default */],null,item.banners.map(function(banner,bannerIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FilteredShowcase_FilteredItem__["a" /* default */],{key:bannerIndex,bannerIndex:bannerIndex,path:banner.path});}))));});};FilteredShowcase.propTypes={onlyCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showcaseInfos:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};FilteredShowcase.defaultProps={showcaseInfos:[{'title':'Veja produtos por faixa de pontos.','titleMobile':'Faixa de pontos','banners':[{'path':'/search?minprice=0&maxprice=5000'},{'path':'/search?minprice=0&maxprice=50000'},{'path':'/search?minprice=0&maxprice=200000'},{'path':'/search?minprice=200000&maxprice=0'}]}]};var mapStateToProps=function mapStateToProps(_ref2){var onlyCash=_ref2.onlyCash;return{onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_1_features_Cart__["c" /* actions */].loadCart());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(FilteredShowcase));

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
var FilteredHeader=function FilteredHeader(_ref){var title=_ref.title,titleMobile=_ref.titleMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-sm--1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},titleMobile))));};FilteredHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (FilteredHeader);

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var FilteredWrapper=function FilteredWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-sm--1'},children);};FilteredWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (FilteredWrapper);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var FilteredItem=function FilteredItem(_ref){var bannerIndex=_ref.bannerIndex,path=_ref.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:bannerIndex,className:'col-6 col-md px-1 py-1 pos-banner pos-'+bannerIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bannerImage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'',to:path,title:'Veja a seleção de produtos'})));};FilteredItem.propTypes={bannerIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (FilteredItem);

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoriesShowcase_CategoriesHeader__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CategoriesShowcase_CategoriesWrapper__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CategoriesShowcase_CategoriesItem__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__);
var CategoriesShowcase=function CategoriesShowcase(_ref){var onlyCash=_ref.onlyCash,showcaseInfos=_ref.showcaseInfos;return showcaseInfos.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'bx-categoriesShowcase pos-relative py-3 '+(onlyCash?'scope-onlyCash':'scope-points')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-1 px-sm-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CategoriesShowcase_CategoriesHeader__["a" /* default */],item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CategoriesShowcase_CategoriesWrapper__["a" /* default */],null,item.categories.map(function(category,categoryIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CategoriesShowcase_CategoriesItem__["a" /* default */],{key:categoryIndex,categoryIndex:categoryIndex,name:category.name,path:category.path});}))));});};CategoriesShowcase.propTypes={onlyCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showcaseInfos:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};CategoriesShowcase.defaultProps={showcaseInfos:[{'title':'As melhores ofertas por categoria.','titleMobile':'Categorias','categories':[{'name':'Smartphones','path':'/search?term=Smartphone'},{'name':'TVs','path':'/search?term=TVs'},{'name':'Notebooks','path':'/search?term=Notebooks'},{'name':'Moda','path':'/search?term=Moda'},{'name':'Esporte e Lazer','path':'/search?term=Esporte e Lazer'},{'name':'Eletrodomésticos','path':'/search?term=Eletrodomésticos'}]}]};var mapStateToProps=function mapStateToProps(_ref2){var onlyCash=_ref2.onlyCash;return{onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_1_features_Cart__["c" /* actions */].loadCart());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CategoriesShowcase));

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
var CategoriesHeader=function CategoriesHeader(_ref){var title=_ref.title,titleMobile=_ref.titleMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-sm--1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},titleMobile))));};CategoriesHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CategoriesHeader);

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var CategoriesWrapper=function CategoriesWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-sm--1'},children);};CategoriesWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (CategoriesWrapper);

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var CategoriesItem=function CategoriesItem(_ref){var categoryIndex=_ref.categoryIndex,name=_ref.name,path=_ref.path;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:categoryIndex,className:'col-6 col-md-4 px-1 py-1 pos-category pos-'+categoryIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:path,title:name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-category row align-items-center mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-1 px-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,name)))));};CategoriesItem.propTypes={categoryIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CategoriesItem);

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_features_Cart__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BenefitsShowcase_BenefitsHeader__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BenefitsShowcase_BenefitsWrapper__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BenefitsShowcase_BenefitsItem__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_template_showcases_css__);
var BenefitsShowcase=function BenefitsShowcase(_ref){var onlyCash=_ref.onlyCash,BenefitsInfo=_ref.BenefitsInfo;return BenefitsInfo.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'bx-benefitsShowcase pos-relative py-3 '+(onlyCash?'scope-onlyCash':'scope-points')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-1 px-sm-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BenefitsShowcase_BenefitsHeader__["a" /* default */],item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BenefitsShowcase_BenefitsWrapper__["a" /* default */],null,item.banners.map(function(banner,bannerIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BenefitsShowcase_BenefitsItem__["a" /* default */],Object.assign({key:bannerIndex,bannerIndex:bannerIndex},banner));}))));});};BenefitsShowcase.propTypes={onlyCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,BenefitsShowcase:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};BenefitsShowcase.defaultProps={BenefitsInfo:[{'title':'Veja uma seleção de benefícios especiais para você.','titleMobile':'Benefícios especiais para você.','banners':[{'name':'Beneficios','className':'col-12 col-lg-6 banner-home-beneficios','path':'/benefits/landing'},{'name':'Links','className':'mt-2 mt-md-0 col-12 col-lg-6 banner-home-links','path':'#','items':[{'name':'Muitas opções','description':'Tudo o que você precisa nos principais varejistas em um único lugar','icon':'iconCompras','className':'pl-0','path':'#'},{'name':'Ganhe + pontos​','description':'Compre no iupp e ganhe ainda mais pontos','icon':'iconCartoes','className':'pr-0','path':'#'},{'name':'Use pontos','description':'Para comprar produtos, experiências e viagens','icon':'iconPontos','className':'mt-2 pl-0','path':'#'},{'name':'Comunidade iupp​','description':'Encontre ofertas perto de você','icon':'iconCumunidade','className':'mt-2 pr-0','path':'#'}]}]}]};var mapStateToProps=function mapStateToProps(_ref2){var onlyCash=_ref2.onlyCash;return{onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadCart:function loadCart(){return dispatch(__WEBPACK_IMPORTED_MODULE_1_features_Cart__["c" /* actions */].loadCart());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(BenefitsShowcase));

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
var BenefitsHeader=function BenefitsHeader(_ref){var title=_ref.title,titleMobile=_ref.titleMobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-sm--1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},titleMobile))));};BenefitsHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,titleMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (BenefitsHeader);

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var BenefitsWrapper=function BenefitsWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-2'},children);};BenefitsWrapper.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (BenefitsWrapper);

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
var BenefitsItem=function BenefitsItem(_ref){var bannerIndex=_ref.bannerIndex,name=_ref.name,path=_ref.path,className=_ref.className,items=_ref.items;var redirectBenefitsPage=function redirectBenefitsPage(){window.location.href='/search';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:bannerIndex,className:'pos-benefits pos-'+bannerIndex+' '+className},items&&items.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mx-sm-auto'},items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'col-6 pos-benefits-sub pos-sub-'+index+' '+item.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'bg-white radius border border-color-ui-2 d-flex align-items-center justify-content-center py-2 px-2 pointer',to:item.path,'aria-label':item.name+', '+item.description},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:item.icon,className:'d-inline-block color-brand-1 icon-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'aria-hidden':true,className:'txt-title fontSize24 fontBenefitsMob lineHeight29 mt-2'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'aria-hidden':true,className:'txt-descr fontSize15 lineHeight19 tt mt-1 mbCardsHome'},item.description))));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-benefits row align-items-center mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-auto radius bannerHomeNew'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'mt-3 mb-1 mb-md-2 ml-1 ml-md-3 color-brand-1 txt-bold'},'iupp, a sua plataforma de compras do Ita\xFA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ml-1 ml-md-3 mb-1 mb-md-0 color-ui-white'},'a cada real gasto na loja online, ganhe pontos iupp'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{onClick:function onClick(){return redirectBenefitsPage();},text:'eu quero','aria-label':'eu quero. ir para a tela de benef\xEDcios.',className:'btn btn-default btn-benefits ml-1 ml-md-3 mt-md-2',tabIndex:0}))));};BenefitsItem.propTypes={bannerIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (BenefitsItem);

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Showcase_ShowcaseHeader__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_gpt__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_gpt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_gpt__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_4_react_gpt__["Bling"].configure({renderWhenViewable:false,collapseEmptyDiv:true,outOfPage:true});var BannersShowcase=function(_Component){_inherits(BannersShowcase,_Component);function BannersShowcase(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BannersShowcase);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BannersShowcase.__proto__||Object.getPrototypeOf(BannersShowcase)).call.apply(_ref,[this].concat(args))),_this),_this.removeEmpty=function(event){if(event.isEmpty){var list;list=document.querySelectorAll('.banner-showcase-ordination');for(var i=0;i<list.length;++i){list[i].classList.add('d-none');}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BannersShowcase,[{key:'configureDfpTargeting',value:function configureDfpTargeting(dfpAccount,sliders,campaignId,catalogId,clientId){return sliders.map(function(slider){return{accountDfp:dfpAccount,sliderName:slider,urlSlider:'/'+dfpAccount+'/'+slider,sizeMapping:[{viewport:[0,0],slot:[304,224]},{viewport:[380,0],slot:[380,280]}],targeting:{ltm_campaign:[campaignId,'default'],ltm_catalog:[catalogId,'default']}};});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,profile=_props.profile,google=_props.google;var sliders=['showcase_banner_1','showcase_banner_2','showcase_banner_3'];var campaignId=profile?profile['custom:campaign_id']:'0';var catalogId=profile?profile['custom:catalog_id']:"80938";var clientId=profile?profile['custom:client_id']:'0';var sliderList=this.configureDfpTargeting(google.accountDfp,sliders,campaignId,catalogId,clientId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'banner-showcase-ordination col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'banners-showcase-container pos-relative py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-1 px-sm-0'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_BANNERS_SHOWCASE_TITLE&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Catalog_Showcase_ShowcaseHeader__["a" /* default */],{title:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_BANNERS_SHOWCASE_TITLE,mobileTitle:Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_HAS_BANNERS_SHOWCASE_TITLE,viewAllPath:'/search'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},sliderList.map(function(itemSlider,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'col-12 col-sm-auto mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_gpt__["Bling"],{adUnitPath:itemSlider.urlSlider,sizeMapping:itemSlider.sizeMapping,targeting:itemSlider.targeting,onSlotRenderEnded:_this2.removeEmpty}));})))));}}]);return BannersShowcase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BannersShowcase.propTypes={profile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({'custom:campaign_id':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,'custom:catalog_id':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,'custom:client_id':__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),google:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({accountDfp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})};var mapStateToProps=function mapStateToProps(_ref2){var user=_ref2.oidc.user,google=_ref2.google;return{profile:user&&user.profile,google:google};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(BannersShowcase));

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccumulatePoints__ = __webpack_require__(1809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AccumulatePoints__["a"]; });


/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_card_oferta_progressiva_png__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_card_oferta_progressiva_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_card_oferta_progressiva_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_card_oferta_progressiva2_png__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_card_oferta_progressiva2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_card_oferta_progressiva2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_card_oferta_progressiva3_png__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_card_oferta_progressiva3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_card_oferta_progressiva3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccumulatePoints=function(_Component){_inherits(AccumulatePoints,_Component);function AccumulatePoints(props){_classCallCheck(this,AccumulatePoints);var _this=_possibleConstructorReturn(this,(AccumulatePoints.__proto__||Object.getPrototypeOf(AccumulatePoints)).call(this,props));_this.state={};return _this;}_createClass(AccumulatePoints,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-relative pt-2 px-1 scope-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title'},'\xC9 muito f\xE1cil acumular pontos! Quer ver como?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_card_oferta_progressiva_png___default.a,className:'w-100',alt:'Usando um itaucard inscrito no programa. Consulte o regulamento do seu cart\xE3o'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/pointsandcash',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_card_oferta_progressiva2_png___default.a,className:'w-100',alt:'Fazendo compras em nosso shopping com dinheiro.'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/checkout/points-purchase',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_card_oferta_progressiva3_png___default.a,className:'w-100',alt:'Comprando pontos direto na nossa loja.'}))))));}}]);return AccumulatePoints;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AccumulatePoints);

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_oferta_progressiva.a5635877.png";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_oferta_progressiva2.83776fbe.png";

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_oferta_progressiva3.19452df3.png";

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BestOffers__ = __webpack_require__(1814);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BestOffers__["a"]; });


/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_ofertas_smartphones_png__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_ofertas_smartphones_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_ofertas_smartphones_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_ofertas_smartphones_mobile_png__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_ofertas_smartphones_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_ofertas_smartphones_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_ofertas_tvs_png__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_ofertas_tvs_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_ofertas_tvs_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_ofertas_tvs_mobile_png__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_ofertas_tvs_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_ofertas_tvs_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_ofertas_eletroportateis_png__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_ofertas_eletroportateis_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_ofertas_eletroportateis_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_ofertas_eletroportateis_mobile_png__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_ofertas_eletroportateis_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_ofertas_eletroportateis_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_ofertas_utilidades_domesticas_png__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_ofertas_utilidades_domesticas_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_images_ofertas_utilidades_domesticas_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_ofertas_utilidades_domesticas_mobile_png__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_ofertas_utilidades_domesticas_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_images_ofertas_utilidades_domesticas_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_ofertas_infantil_e_bebes_png__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_ofertas_infantil_e_bebes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_images_ofertas_infantil_e_bebes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_ofertas_infantil_e_bebes_mobile_png__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_ofertas_infantil_e_bebes_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__loyal_images_ofertas_infantil_e_bebes_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_images_ofertas_eletrodomesticos_png__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_images_ofertas_eletrodomesticos_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__loyal_images_ofertas_eletrodomesticos_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyal_images_ofertas_eletrodomesticos_mobile_png__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyal_images_ofertas_eletrodomesticos_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__loyal_images_ofertas_eletrodomesticos_mobile_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BestOffers=function(_Component){_inherits(BestOffers,_Component);function BestOffers(props){_classCallCheck(this,BestOffers);var _this=_possibleConstructorReturn(this,(BestOffers.__proto__||Object.getPrototypeOf(BestOffers)).call(this,props));_this.state={};return _this;}_createClass(BestOffers,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos-relative pb-1 px-1 scope-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2 mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-none d-md-block'},'As melhores ofertas por categoria.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-title color-title d-block d-md-none'},'Ofertas por categoria.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?term=Smartphone&subcategory=48','aria-label':'Smartphones',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__loyal_images_ofertas_smartphones_png___default.a,className:'d-none d-md-block w-100',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__loyal_images_ofertas_smartphones_mobile_png___default.a,className:'d-block d-md-none w-100',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?subcategory=46','aria-label':'TVs',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__loyal_images_ofertas_tvs_png___default.a,className:'d-none d-md-block w-100',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__loyal_images_ofertas_tvs_mobile_png___default.a,className:'d-block d-md-none w-100',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?subcategory=39','aria-label':'El\xE9troport\xE1teis',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__loyal_images_ofertas_eletroportateis_png___default.a,className:'d-none d-md-block w-100',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__loyal_images_ofertas_eletroportateis_mobile_png___default.a,className:'d-block d-md-none w-100',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?subcategory=42','aria-label':'Utilidades Dom\xE9sticas',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__loyal_images_ofertas_utilidades_domesticas_png___default.a,className:'d-none d-md-block w-100',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__loyal_images_ofertas_utilidades_domesticas_mobile_png___default.a,className:'d-block d-md-none w-100',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?category=3','aria-label':'Infantil e Beb\xEAs',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__loyal_images_ofertas_infantil_e_bebes_png___default.a,className:'d-none d-md-block w-100',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__loyal_images_ofertas_infantil_e_bebes_mobile_png___default.a,className:'d-block d-md-none w-100',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 col-md-4 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?subcategory=38','aria-label':'El\xE9trodom\xE9sticos',className:'d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__loyal_images_ofertas_eletrodomesticos_png___default.a,className:'d-none d-md-block w-100',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__loyal_images_ofertas_eletrodomesticos_mobile_png___default.a,className:'d-block d-md-none w-100',alt:''}))))));}}]);return BestOffers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BestOffers);

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXwAAAC0CAIAAAAYSQDwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABvmSURBVHhe7d0JfBNl/gbwTI4mTe9CaWk5WspVCp5YKbCo3Ih4oLC4giBUAUVBC8uyf1xRWRR2BQUEURQUUe5LVARZLkWQW7nLUcrV0paeSXPn/6QzZmvRtW3SaWif7ycfnffNZJIZOk9+7ztTEOLjExVERHJRSv8nIpIFQ4eIZMXQISJZMXSISFYMHSKSFUOHiGTF0CEiWTF0iEhWDB0ikhVDh4hkxdAhIlkxdIhIVgwdIpIVQ4eIZMXQISJZMXSISFYMHSKSFUOHiGTF0KG6S8AJIDh1Kode7QhQO7CgEpzSc1Rt+HckUx1VT2trFWJKDDXG6K0hWhu+fk125RWjJr1Ye/i6/orRz+pAKJH3MXSobkGQxAWZu0YXdo8uiPK36VR29LjTBXWOQyEUmFUHcwPWZ4Qeyg2w1Fz0qNWqiIiIyMjIuLimMTEN/fy0Vqs1Jyf33LlzV65kZmZmoSmtelNh6FAdolU5bg83PptwrUWISS04Hb8/llIKigKL6vNz9VaeDy+0qqReGcXERHftem+PHl1btGgeHh6uUkkzIU6ns6ioOD39wo4duzZv/vbkyVPOm21EyNChuiJQbR/aIueR2Lxgjb2CJyrO9MO5+lcPxVw0+Eld1a9hw6iePbs/+eRfoqIitVqt1HsDpI/RaFy2bNWCBR9ev35d6r0ZqMLDG0iLRLWXSnA+Gpv3ZPNcRE/FKwNkU5Te2jjQuj8nwOia9ql2YWGhEyemInHq16+vVqul3t8iCIKfn1+7dol33HHbsWPHMeySnvB5DB2q/QSFolejgpfaZfmr/seI6nc1CbQ0CzRvywy2O6t3fqdRo0YzZkzt1u0+pInU9UdUKhUGYh07djhw4FB2do7U69sYOlT7tQg2jWmTFelvrfLsR7TeetmoSSv0l9rVIDw8LCVl2AMP9EGOSF0VFhoaGhsb+8MPe4qLDVKXD+N9OlTLoTjpGVPQItjsyYSrUnAObn49QleNV4v69evbv//DVUgc0d13t58wYVyVXy4nhg7Vcg38rfdEFSE1pHZVNQsydYwslhreFhvbdMCAR0JCgqV25SmVyr59+yQktJbaPoyhQ7Vcu7CS2ECL59eVUTF1iSpSKz3e0A0EQdG7d4/WrVtJ7apSq9XDhg3W66txDOgVDB2qzdSCMzHUqPRGUjicrrmhMD+71Pae8PDwDh2SpIZnkpLax8RESw1fxdCh2sxP5YwNMjscUtNDAWoHBmtSw3siIyMxvJIanmnQIKJVq5ZSw1cxdKg206sdgZqqXCb/TRqlM8zPJjW8Jza2CYodqeEZjLA8H6ZVN4YO1WaCQuHFyzmCIPzy2wjeFBYW5u+vkxoei4qKlJZ8FUOHajOHUmMXvBc7glLpp5eWvUen0yHOpIbH9Hrvf0LvYuhQbSb46VUh0a5fHvcGQaNXBnt/mtbmrc9Xyur00gxWtWHoUG0maPxVTZK8c1I7FUJQpBASIzW9J8fhNEuLXnDJ4f3ra97F0KFaTVBpmt+jUP/u72pXhqCJv0ep986Mb1nnnPZ8LxU7NoXimN37U93exdChWs1pV4bHq6MSPT+pBV2IMqGP604+b8uw2y/YvVOeZCqcx1jpENUsQRek6/qSoAmU2lXjUPgl9FJF3+ashhmTK077OqtJanhmt916jqFDVMMEpV+bvurmnREcVYbk0nYaqQyM9OqcrwSb3Gg1FXrjbwBcbzHlcCKZqMYJ/qEBj85RxdxatcgQtCH6fm9qmt/3379L2dtO2W3vmA0WDyINSbPCYlrtpYqpWjF0qE5Q1W8e8MhMISCisue1oNLqklO0t/9ZalcPq0Ix12T43mqR2pV3wm6bYy72JLZkw9ChukLTomtwyjp1sy4VHWc5FMqQxv73v+7f51UhoJ7UWW2ynY7RxoKf7FX53a4sh2OcsWC37eb4xyEYOlSHqOM6Bj21XNdljDIoxvXDf2NZgB5XpyDoIzWJfQMHfaDrNFrwCxCfrG6nHfbBhvzdNkvFw8OuUByyW58rKdhms9wERU4phg7VLcqgKP1D/w56ZoOuywuq6NsFbQhGUE6HwonT1+G651gIjvG7dWBA/7eCBn+iad1L0Hp22auSjtptgwz5882G3ArMB5uczi+tpueMBastJl+fPS6D/wQN1WYREfXnzp115523S+2yHHanqdB+/bwj54zDmKdwOgWNTlkvThXWVPAPc2WNsvwvbRmNxtTUSVu2bJXaXpI/eMD1cSNd//TEL7SC4l619mGNrpdGW09Q6oX//v4YwgVZc93p2GOzrrKUfG0zG8pexlcpA7buipwwRWr6JFY6VFcpVYI+TN3oDr/bBuo6jtR1GqVNGua65zg8VvAPuTFx5GR2KjZZzS8YC/oW544w5E83FS+xGJdbSpZaSmabDM8aCx4pzhtuzF9hNRVVx41D1YyhQ+SLhNJLWifs9pVW0yslRSmGgmGG/BRD/sSSwiWWkgN2a7E37uupEQwdIp+G9LGXBpC59IGFmzVsfsHQISJZMXSISFYMHSKSFUOHiGTF0CEiWTF0iEhWDB0ikhVDh4hkxdAhIlkxdIhIVgwdIpIVQ4eIZMXQISJZMXSISFYMHSKSFUOHiGTF0CEiWTF0iEhWDB2iShCq7V8WrjsYOkQkK4YOUSXctP8Egw9h6BCRrBg6RJXAOR3PMXSISFYMHaJK4JyO5xg6RCQrhg5RJXBOx3MMHSKSFUOHqBI4p+M5hk6NSUhoPXnyRDzGjx8XFRUp9RLVdgydGtOoUfSwYUPwGDRoQGRkA6mXfBvndDzH0Km0/v0fmj59Kh7Dhw8NDAyQeomoYhg6lXb33Xc9+ujDeHTrdq+fn5/US3UD53Q8x9AhIlkxdIgqgXM6nhPi4xOlxZqjVCrr16/Xq1eP5OSkhg0bqtUqk8l89erVrVu3f/HFVw6HIzn57uefHx0UFJifXzBjxszY2KY9e3Zv0qSRw+E8duzEkiWfnTp1OiQkpHPn5L59ezdsGIWXXLhwcfHiJT/9dFR6D4VCr/ePj2/20EMPNG3aNCKivkqlLC424IUbN246ePAQXiKuhkHTmDGj1Go1nvrXv97GYKp//4fq1QtfvXpdly6d8cKgoKBGjWLElc+ePWexWPbu3Td16nQ0J05MxWfAwqJFS3bs2NW9e1fsVHh4mN1uu3z5yscfLz1w4FDp61x69Og6f/5sLGCnUlP/ptNp8dliYqJxNNLTM9at27Bz53dWq01cWYR379QpGS/EPmo0mpISEz7khg1fHj58pOyaS5cuCg4Owt5NnvxqaGjIAw/0adMmAbuPnu3bd65atTY397q0aikMEnFIBw16rGXL5jiMOBRXrlzF/n777TZpjVLYkdtuu/X++3s1adLY319ns9mwnR9/3P/xx5+azRZpJR+DIzZ37qw777xdanvGaDSOHz9p8+atUttL8gcPuD5upHdGbiplwNZdkROmSE2f5BOh07x5/OTJEzt37ii1f3H9el6/fo9lZWUhdGbOnI4fIIPB8M033/bs2S0wMFBaSaFIT7+AkxbpMG7cGPcki9PpxCkxadI/tm3bIfZ06JA0Z87MsLBQselWVFQ8efKUTZu22O12NHGKvvnm6zqd7vz59G3bdv7lL39GHKB/6dJlCJ3GjRuVvuhXEDpPPPEUFl5//R+PPz4QC2vWrLdarf37P6zRqEtXccGHnzZtxvLlq8WmO3TQv2fPjx07dvD39xefgoKCwtmz312xYk1JSYnYExERMXnyX5G2iBuxR4Qz4ZNPPlu4cBHCS+w5ePAHhA7S8LPPlt933z3ICOGXL2js4759B3C4srKuiT2AsHvxxTGNGv1q18xm87Jlq2bOfMdgMKIZEKD/+9//ijVxZMQV3PBndOLESanhY7weOqmpk7ZsYeh4RBUeXsMXa7Vav7feejM5uQNODBQ4+OrG2Y64QWrgDFmxYjXOSZzqKBnwc49MadGiBU6D06dP4xwLDQ1FXYD//ulPnZApKHzwnY+zFF/v6Nfr9YmJCRs3foXN4o0SElqhZsnLy79wIePs2fNYwNmL8xwfoEuXTigu0tLOYLWWLVugQkGlgy/z1q1b4k0RH/hW37fvIH7m8Krg4GCt1hVD+AAnTpzKyLiIU27nzu/R07XrPe3auUIcxRTeDqf9sWPHc3JyQ0KCsUF8+I4dkzMypDeKj49DwGEB/U2bNsGWz5w5gx0PCnKtjKRLSroLiXntWjbWQZUxd+5M7CaeMplMyNlz59JxfLBl7EX79nfg6CG5cNCw8siRKfiEKpUqMbENDgLWxPoIC8BhiY5GLalGUOLlaPbq1f2VV/4eGRmJ3UQSHT9+Eh8bmY5PhX3BrqM6w2ZHjRoxbNgQdOJV2OW0tLPZ2dkocPA5V65cjX3E+/og/PHdf39v7LLU9gwOEcqcc+fOS20vMd2SWNKhvdTwkFLwO58RuGW71PRJNT+ngxOjTZvWSqWAn+8FCxaOHPk8qgY8nntu3JQp/zQYiqX1foFMQT9WeOaZMV9+uUnsxE+V3e54/fVp6H/qqZEYcYjDJfQjUMR1UNEsXLj4xRcnYAWsNnRoCr7wcTbiqYCAgKeeGiKu5oZTFCOpn38++tpr07Amipdx4ybghe4vOuTjyJFj0COOrcrCWCY7O3f8+L8NGTL8ySdT3nprdl5eHvoRZIMGDUAZIq7mhmT5v/+bgk09/fRz77zzrtiJlcW6CR544P677roTOYIAXbDgQ6w2ZMiIF15IPXToiLgCqqr27ct/nyOPUAQNHz4SK6emTsS+oBNBg1IR4yksY9j49NNPhYeHY/nrrzfjkOIzpKQ8+/nnK5CzeLtHHnmwefNmOA5duvwJTayGYeOzz44bPHg41hwz5qWxY8dfunQF/XUE53Q8V/Oh06BBBL4/seBw2K9ezczMzMIykuXIkZ+//fY/xcWG0rUk+Mpds2bd7t0/4Dv2ypWrM2bMlJ5QKND5xRdfYQFbWL9+IyIGyzjrQkJCSp9XoBCYO3f+99/vyc7OQbOwsGjXru9nzZqD+gjN+PhmKHlKV/wvlDCjR49dtWotBl9nzpyVeisAkbdw4UcYneFzFhUVLVr0yfLlq8SnkpLau6eERKgsPvhg0d69P2Jl1BoffPARaj3xqbi4WPwX6/fu3UPswTHBQO/ixUv41v3552NTp76Zm+uqMlAK9enTq+xoDk6ePD1nzjxsEyvv2rV77doNqFPQj5EaYhELiJ6EhNZYQIU1ffpbJ0+ewjIKmddeewOHF8t467ZtE1FPucezqBNPn07DdvBpcXy2bt2OHRSfIqqImg8djHRw1mEB0TN27HN/+1tqp07J4ilxI5zMON8KCgrFZtmJCYSCezI1N/c6iMvu6Qyw2exRUZEDBvSfMmXynDkz58+fPWjQQKfTVROp1apWrVqKq4kQcKtXr0eElZ2jrSAk2tatO9yT07Bs2SrxhEe9gB0UO0XY/VOnTpWUmKR2aQ0lLog3HyJQWrZsjgXk48GDhxEQpU+6ICb27z+IBezmHXfcFhYWJvaLUNqU3SzGWUgfLCCbxKDv06enuHD+/HkEPUow90MMWZRF7dq1xUjq2jXpUKOkmjbt1X797sfIpVzG1QW8T8dzNR86aWln8A2MExunTcOGUSkpTy1a9P6mTRvGjx9346wtgqDsmVyWxeI6nURWK07k8tdT6tev99JLL3z11do33nht8OBBON969OianJwkjhpwdokzNW7YAk5FqVFJiDx8BqlRKj8/352VKO7EBRGiUJx1civ34fHBxELDZrMic8VOEcoN93wKBkHldsFs/l+bBfdkx5133nHw4A9lH1273is+FRfXFO+CAZc4pY2qZ+DAR2fNmrFjx+YZM/7ZqlULHDpxTaKK8IkflxkzZs2btwBjK3wPI1aUSgEnw6hRKdOnT0VSSCt5BkMnpNiQIY8HBwfbbDaDwYDhw6VLl91XfG6EwgRxIDVqFOJYrXbVFAhco9F1LclbxDLnfxNDGQPMV1+dhsLKaCzBnxF6QkND+/Xr+/77795yS9vSFYkqxCdCB1kzZ878IUNGTJr0j6VLl4vTOpCU1H7ixFRx2UOdO3d6+OF+KARQUq1bt3Hs2AkPPvjYvff2GjFiVHFx+blqz+GNbvz+9/OTLnWXq2v+EI6PWGVgmygGxU43d3AgJX+vDPw94uVwQAE1e/a833ysXLlGXGfVqrWPPvqXSZNenjfv/ePHT4idMTHRL788CUWW2CT6Qz5UGKenX1i37ospU6aOGDH69Ok0sbNJk8bigoduv/1WMQX27v0RVdX27TvFGqfsrTFehAFUvXq/qtG6dOms1+uxgFw4evS42FlBhYVFqC+woFZrWrRwTe64RUY2EGMI1cfx4yfFbKo49/01AQEB7723sFzciI/16zeK6wDGa19+uWnWrDnDh4/atGmz2IncwRBMXCb6QzUfOk2aNGrQ4Ff3CiF9du/eKy4jKcLDfzU5WjXu6WQMCtxnpk6n69//obL3GVaEOB8MERH1sQVxuRyNRjN+/Nh69VyXoiE2tsnQoU+IqZeTk3P4sHSdu4IyMjKQlVjAwBMfuE0b1/UmUffuXZGnWMCY8ejRY2XnmCti587vxEIPB3nMmFE3RnB8fDP8F4VM2TeFnJzcXbt2403FZmiodImQ6A/VfOjccku7jRtXf/rpRyNGDLv77rtwFr399r8GDuwvPovzrbIn0m/KzMwUZyLatm0zb947vXv3eOyxR5Yt+/ihh/qJK1TchQsZ4kKzZnGvvPL3e+7506BBA8pdBQf0v/vu23369Hzwwb7vvPPvdu1cEx8Wi2Xp0hVi2VJxGBKiDDEYXHcPIOk++WTh6NFPd+t27xtvvDZhwjgUKeg/cuTnNWvWl65eCWlpZzZu3CQeGWxzzZrPR49+Jjn57vvuu+fVVyd/880GJBGeioyMmDVrxrp1y1NTx3bp0qlz544TJrz40kvPizNN2dk5J09KlWmtx/t0POcTwyu93r9Dh6RJk8YvXbrovfdm9+jRVRyJFBQUrFy5VlzHQ1u2/Md93Qelwdy5s9588/W2bRPxFpW9m/abb7a4p4G6dbvvww/n41Qsd6GtqKjYarW2b3/HnDkzZ86cnpjYRpx5QTHy+efLq3BjC4ZOc+bMF2s0FGt4xwUL5g4Y0F8s0zIyLr711jtVuC3YbLYsXPjR4cM/YRnFIMZuqakvLFny4QcfvPvEE4NQ5rhLOeQLDheC6aOPFixe/P7IkSPE8aPJZF62bKX7gjrRH6r50Dlx4tQXX3yF8gFnlPiVizPh2rXsDRu+GjhwyJ49rmGF5zIzs1JSnt22bQfyAu/icDhwiqI5adLLFy9elFaqmPT0jKFDnz506IjBYBQ3lZeXV+7idHZ29nPPjduxY5fJ5LpNBgUOPsDixZ+OGvVClQu3hQsXDxky4ocf9ubl5YtDvNKL+umffbZ8xIhR+/YdEFerLOzOk0+mvPzya6dPpxUWFolT0aitcHz27z+4efO3aF65krlq1dqTJ0/j6IlvjdVyc69/993usWPHI3RcG6obSn9CySM+8QufWq0W37Hh4aEoB/B9a7FYi4sNaWmuc0BcoV698ISE1v7+utJZ2BNZWdLlLUBZJC5gpIDzR1wODAzA+qGhrl+YLrt+ZGSD+Pg4lFH40cH5c+rUaYxZML4LDw/DN/axY8eRCKhZmjdvhi92m812/Pipsu9VFqqAqKhIfCRsqrCw8MSJk/jM7l/4PHfu/OOPD9VoNK1atcBOYVMYg5w7l172gndMTLQ4UYK3PnTocNl7rzEWi4pyzXPhCOzdu0/sBKVSiUMRFxcbFBSIZYROVta1Cxculps/dh+TjIxL7vsMAbvp/tVHbNZ9eEUYLeL44OCIv5KCbV6+fOXSpcvisxqNOi4urn79cH9/f7y1w+FEvXb27HnxfmifxV/49EE+ETq1RrnQKfc3SJD8GDo+yCfmdIio7mDoEJGsGDpEJCuGjjetWbN+6tTpeLz//kflJnepduB9Op5j6HjToUNHFi9egseqVWsrewcgUR3B0CEiWTF0iEhWDB2iSuAdyZ5j6BCRrBg6RCQrhg4RyYqhQ1QJvE/HcwwdIpIVQ4eIZMXQISJZMXSIKoH36XiOoUNEsmLoEJGsGDpEJCuGDlEl8D4dzzF0iEhWDB0ikhVDh4hkxdAhqgTep+M5hg4RyYqhQ0SyYugQkawYOkSVwPt0PMfQISJZMXSISFYMHSKSFUOHqBJ4n47nGDpEJCuGDhHJiqFDRLJi6BCRrBg6RCQrhg5RJfCOZM8xdIhIVgwdokrgfTqeY+gQkawYOkQkK4YOEcmKoUNEsmLoEJGsGDpEJCuGDlFFOZ0Kh8MhNaiqGDpUm5lMZovFIjU8ZrfbiouLpYb3CF689web8vlbiRg6VJuZzaaLFy9JDY+VlJiysq5JDe8RzGZpyRuUXt1adWDoUG1mtdqOHPlZanjs6tXMnJxcqeE9qut5gtUqNTymupwpLfkqhg7VZk6nc9++AyUlJVLbAw6H48cf9xsMBqntPerLV5XF3tmsYDL5pV+UGr6KoUO1XGZm5sGDh6WGB7Kzc7Zu3YYUk9reo8685pd23iu/wK7OzfM7c05q+CqGDtVyRmPJJ58szc8vkNpVgqzZunV7WtpZqe1VqoLCgB3fK5Qen4wqlW7/YUSY1PRVDB2q/b77bvc332yRGlVy9Wrmxx9/WlhYKLW9Tb/zB3V2jqe5Y7cHfv2tt0Zq1UcVHt5AWiSqpex2+6FDR9q2bdO4cSOpqzKQONOm/Wvfvv1SuxooS0oEg9HU/nanWiV1VZLgcIas2Ri8coPU9mEMHaoTzGZzWtqZW29tFxFRX+qqAIfDUVBQOG/e+19/vclms0m91cHp1Fy+YmsQYWnTUuGo/LSRIGhPnQmb95Hqer7U48MYOlRXXLuWvXPndwEB+pYtW6hUf1xQOJ3Ow4d/+ve/396w4Usv3mH4ewSzRXfkmDW2ibVZLNJO6q0IQfA7f6HB5Gl+Z9OlHt/G0KE6pKioaN++A/n5+dHRDZE+arVaeuLXUNQgoTZv3vreex/s2bOvemucMpQms/boCXtkhC0mSvE7n60cwanQHT4aPus93fFTUpfPE+LjE6VForpBEBRhYWHdu3dNTk5KSGgdFRWp0+nQj8FUTk7uhQsX9u7dv337zhMnTtntdvElcnJq/Yoe7FPw54etcU1c7d+serAPSiUGU0Hrvw5esU6dlS313wwYOlR3abXaQJeAsLBQlUpdUmLMzy8wGAwlJSYZxlP/i1JpjYkydkwqfrC3LTrK4e/vVEkXtgSbTWmxqLJy9N/v1W/7XnvytGDx2t3M8mDoEPkue1iItXEja+Noe4P6Dp0O+aLKL9BcvKS+dFWTea1yUz8+g6FDdDMQ8CgtdpxO1+NmxpsDiW4GyBnUNXjc5IkDDB0ikhVDh4hkxdAhIlkxdIhIVgwdIpIVQ4eIZMXQISJZMXSISFYMHSKSFUOHiGTF0CEiWTF0iEhWDB0ikhVDh4hkxdAhIlkxdIhIRgrF/wPTI3gw2MB05AAAAABJRU5ErkJggg=="

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalCategories__ = __webpack_require__(1828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalCategories__["a"]; });


/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_css_template_modal_css__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_css_template_modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_design_system_assets_css_template_modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_categoria_interesse_automotivo_jpg__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_categoria_interesse_automotivo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_categoria_interesse_automotivo_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_categoria_interesse_bebes_jpg__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_categoria_interesse_bebes_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_categoria_interesse_bebes_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_banners_categoria_interesse_bem_estar_jpg__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_banners_categoria_interesse_bem_estar_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_banners_categoria_interesse_bem_estar_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_banners_categoria_interesse_casa_jpg__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loyal_images_banners_categoria_interesse_casa_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__loyal_images_banners_categoria_interesse_casa_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_banners_categoria_interesse_eletronicos_jpg__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_images_banners_categoria_interesse_eletronicos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_images_banners_categoria_interesse_eletronicos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_banners_categoria_interesse_gastronomia_jpg__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_images_banners_categoria_interesse_gastronomia_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_images_banners_categoria_interesse_gastronomia_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_banners_categoria_interesse_industria_jpg__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_images_banners_categoria_interesse_industria_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_images_banners_categoria_interesse_industria_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_banners_categoria_interesse_lazer_jpg__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_images_banners_categoria_interesse_lazer_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__loyal_images_banners_categoria_interesse_lazer_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_images_banners_categoria_interesse_moda_jpg__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_images_banners_categoria_interesse_moda_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__loyal_images_banners_categoria_interesse_moda_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyal_images_banners_categoria_interesse_tabacaria_jpg__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyal_images_banners_categoria_interesse_tabacaria_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__loyal_images_banners_categoria_interesse_tabacaria_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loyal_images_banners_categoria_interesse_veiculos_jpg__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loyal_images_banners_categoria_interesse_veiculos_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__loyal_images_banners_categoria_interesse_veiculos_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loyal_images_banners_categoria_interesse_viagem_jpg__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loyal_images_banners_categoria_interesse_viagem_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__loyal_images_banners_categoria_interesse_viagem_jpg__);
var ModalCategories=function ModalCategories(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalCategories pos-relative container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_awesome_modal___default.a,{visible:false,height:'auto',effect:'fadeInUp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-step row px-3 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-initial color-brand-1 mr-auto'},'Selecione ao menos 3 categorias que tenha interesse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured',text:'Continuar'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-list row px-2 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item1',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item1',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Automotivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__loyal_images_banners_categoria_interesse_automotivo_jpg___default.a,alt:'Automotivo',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item2',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item2',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Beb\xEAs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__loyal_images_banners_categoria_interesse_bebes_jpg___default.a,alt:'Beb\xEAs',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item3',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item3',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Bem estar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__loyal_images_banners_categoria_interesse_bem_estar_jpg___default.a,alt:'Bem estar',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item4',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item4',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Casa e cozinha'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__loyal_images_banners_categoria_interesse_casa_jpg___default.a,alt:'Casa e cozinha',className:'img-w-auto'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-list row px-2 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item5',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item5',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Eletr\xF4nicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__loyal_images_banners_categoria_interesse_eletronicos_jpg___default.a,alt:'Eletr\xF4nicos',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item6',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item6',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Gastronimia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__loyal_images_banners_categoria_interesse_gastronomia_jpg___default.a,alt:'Gastronimia',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item7',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item7',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Ind\xFAstria e Com\xE9rcio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__loyal_images_banners_categoria_interesse_industria_jpg___default.a,alt:'Ind\xFAstria e Com\xE9rcio',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item8',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item8',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Lazer e Cultura'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__loyal_images_banners_categoria_interesse_lazer_jpg___default.a,alt:'Lazer e Cultura',className:'img-w-auto'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-list row px-2 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item9',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item9',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Moda'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__loyal_images_banners_categoria_interesse_moda_jpg___default.a,alt:'Moda',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item10',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item10',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Tabacaria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__loyal_images_banners_categoria_interesse_tabacaria_jpg___default.a,alt:'Tabacaria',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item11',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item11',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Ve\xEDculos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__loyal_images_banners_categoria_interesse_veiculos_jpg___default.a,alt:'Ve\xEDculos',className:'img-w-auto'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'categories-item col-2 col-md-3 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'item12',className:'radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'item12',type:'checkbox',name:'categories-choose',className:'d-none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body'},'Viagens'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__loyal_images_banners_categoria_interesse_viagem_jpg___default.a,alt:'Viagens',className:'img-w-auto'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (ModalCategories);

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/automotivo.f2b4b59b.jpg";

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bebes.c37d74ee.jpg";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bem-estar.3b4fb702.jpg";

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/casa.4b8c1290.jpg";

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eletronicos.0fece863.jpg";

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gastronomia.1d51c90f.jpg";

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/industria.c8915a1c.jpg";

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lazer.6ca8716a.jpg";

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/moda.1584c226.jpg";

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tabacaria.b374e2b8.jpg";

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/veiculos.faf31869.jpg";

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/viagem.a1f3ecd2.jpg";

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GoogleMaps__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__newShowCase_StoreShowCase__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__newShowCase_OfferShowCase__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(628);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function HomeIupp(_ref){var _this=this;var participant=_ref.participant,stores=_ref.stores,physicalOffers=_ref.physicalOffers,ecommerceOffers=_ref.ecommerceOffers,zipCode=_ref.zipCode,location=_ref.location,isLoadingStores=_ref.isLoadingStores,isLoadingOffers=_ref.isLoadingOffers,useLocation=_ref.useLocation,setLocation=_ref.setLocation,getStoreShowcase=_ref.getStoreShowcase,getOfferShowCase=_ref.getOfferShowCase,setZipCode=_ref.setZipCode,setUseLocation=_ref.setUseLocation,getLocationFromZipCode=_ref.getLocationFromZipCode;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isModalVisible=_useState2[0],setIsModalVisible=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){verifyToken();},[]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var handleZipCode=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return verifyToken();case 2:setZipCode(participant.address.zipCode.value);_context.next=5;return getLocationFromZipCode();case 5:search();case 6:case'end':return _context.stop();}}},_callee,this);}));return function handleZipCode(){return _ref2.apply(this,arguments);};}();if(participant.address.zipCode.value&&!useLocation){handleZipCode();}},[participant]);var verifyToken=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].tokenVerify();case 2:case'end':return _context2.stop();}}},_callee2,_this);}));return function verifyToken(){return _ref3.apply(this,arguments);};}();var getLocation=function getLocation(){navigator.geolocation.getCurrentPosition(getLocationSuccess,getLocationError);};var getLocationSuccess=function getLocationSuccess(_ref4){var _ref4$coords=_ref4.coords,latitude=_ref4$coords.latitude,longitude=_ref4$coords.longitude;setUseLocation(true);setLocation({latitude:latitude,longitude:longitude});search();closeUseLocationModal();};var getLocationError=function getLocationError(){setUseLocation(false);search();closeUseLocationModal();};var handleDontUseLocation=function handleDontUseLocation(){closeUseLocationModal();setUseLocation(false);search();};var search=function search(){getStoreShowcase();getOfferShowCase('physicalOffers');getOfferShowCase('ecommerceOffers');};var openUseLocationModal=function openUseLocationModal(){return setIsModalVisible(true);};var closeUseLocationModal=function closeUseLocationModal(){return setIsModalVisible(false);};var handleRedirectToSignUp=function handleRedirectToSignUp(){window.location.href='https://'+Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_SIGNUP;};var redirectToSearch=function redirectToSearch(){window.location.href='/comunidade-iupp/search'+(zipCode?'?zipcode='+zipCode:'');};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{visible:isModalVisible,width:'580',height:'250',effect:'fadeInUp'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ModalAlertLocal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'headerLocal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'queremos mostrar ofertas pr\xF3ximas de voc\xEA.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bodyLocal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'para isso precisamos que voc\xEA divida sua localiza\xE7\xE3o com a gente.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btnLocations'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'BtnAgoraNao',onClick:handleDontUseLocation},'agora n\xE3o'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'BtnAtivarLocalizar',onClick:getLocation},'ativar localiza\xE7\xE3o'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'destaque-meu-bairro col-12 col-md-12 bordered radius border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'pl-3'},'o ita\xFA incentiva o com\xE9rcio local.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' cadastre seu neg\xF3cio e venda tamb\xE9m no iupp.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-vender-link',onClick:handleRedirectToSignUp},'quero vender')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__newShowCase_StoreShowCase__["a" /* default */],{loading:isLoadingStores,stores:stores,useLocation:useLocation,zipCode:zipCode,openLocationModal:openUseLocationModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__newShowCase_OfferShowCase__["a" /* default */],{type:'physicalOffers',loading:isLoadingOffers,offers:physicalOffers,useLocation:useLocation,zipCode:zipCode,openLocationModal:openUseLocationModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__newShowCase_OfferShowCase__["a" /* default */],{type:'ecommerceOffers',loading:isLoadingOffers,offers:ecommerceOffers,openLocationModal:openUseLocationModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'overflowHidden pb-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'floatLeft mt-2 titleOfertas'},'aproveite as ofertas por categorias.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'floatRight d-flex color-brand-1 tit-ver-todas-b mt-2',onClick:redirectToSearch,title:'Vai para ofertas por categorias'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:'mr-1'},'ver todas'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-sm icon_right color-brand-1'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex flex-direct-b'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card card-bairro mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cardCate cardCateFeatured radius d-flex-mob'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'postionBairro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'primer1Bairro'},'descontos',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' em farm\xE1cias.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/comunidade-iupp/search/?category='+Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_FARMACIA+'&zipcode='+zipCode,title:'Ver Ofertas de Farmácias'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divOfertas'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:'primer1Bairro'},'ver ofertas',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-sm icon_right_app primer1Bairro'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card card-bairro mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cardCate cardBrand1 radius d-flex-mob'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'postionBairro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'primer2Bairro'},'descontos',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' em padarias.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/comunidade-iupp/search/?category='+Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_PADARIA+'&zipcode='+zipCode,title:'Ver Ofertas de Padarias'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divOfertas'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:'primer2Bairro'},'ver ofertas',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-sm icon_right_app primer2Bairro'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card card-bairro mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cardCate cardUi4 radius d-flex-mob'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'postionBairro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'primer1Bairro'},'descontos',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' em supermercados'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"],{to:'/comunidade-iupp/search/?category='+Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_SUPERMERCADO+'&zipcode='+zipCode,title:'Ver Ofertas de Supermercados'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divOfertas'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:'primer1Bairro'},'ver ofertas',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-sm icon_right_app primer1Bairro'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card card-bairro mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'cardCate cardBrand4 radius d-flex-mob'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'postionBairro'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'primer2Bairro'},'descontos',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' em outras lojas'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'divOfertas',onClick:redirectToSearch},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:'primer2Bairro'},'ver ofertas',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-sm icon_right_app primer2Bairro'})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-cards-mBairro mobile',onClick:redirectToSearch},'Ver todas')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'overflowHidden pb-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'floatLeft mt-2 titleOfertas'},'veja o que tem perto de voc\xEA.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'floatRight d-flex color-brand-1 tit-ver-todas-b mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',{className:'mr-1',onClick:redirectToSearch},'ver todas'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-sm icon_right color-brand-1'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mapa-space'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mapa-meu-bairro mt-2 mb-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__GoogleMaps__["a" /* default */],{stores:stores,offers:physicalOffers,styles:{width:'100%',height:'100%'},google:'https://maps.googleapis.com/maps/api',geolocation:{lat:location.latitude,lng:location.longitude}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'btn-cards-mBairro mobile',onClick:redirectToSearch},'Ver todas')));}var mapStateToProps=function mapStateToProps(state){return{storesFilter:__WEBPACK_IMPORTED_MODULE_10__selectors__["f" /* showCaseStoresFilter */](state),participant:__WEBPACK_IMPORTED_MODULE_10__selectors__["c" /* participant */](state),stores:__WEBPACK_IMPORTED_MODULE_10__selectors__["e" /* showCaseStores */](state),physicalOffers:__WEBPACK_IMPORTED_MODULE_10__selectors__["a" /* getOffers */](state,'physicalOffers'),ecommerceOffers:__WEBPACK_IMPORTED_MODULE_10__selectors__["a" /* getOffers */](state,'ecommerceOffers'),useLocation:__WEBPACK_IMPORTED_MODULE_10__selectors__["g" /* useLocation */](state),zipCode:__WEBPACK_IMPORTED_MODULE_10__selectors__["h" /* zipCode */](state),location:__WEBPACK_IMPORTED_MODULE_10__selectors__["b" /* location */](state),isLoadingStores:__WEBPACK_IMPORTED_MODULE_10__selectors__["d" /* selectRequesting */](state,[__WEBPACK_IMPORTED_MODULE_11__actions__["e" /* REQUEST_GET_SHOWCASE_STORES */]]),isLoadingOffers:__WEBPACK_IMPORTED_MODULE_10__selectors__["d" /* selectRequesting */](state,[__WEBPACK_IMPORTED_MODULE_11__actions__["c" /* REQUEST_GET_SHOWCASE_OFFERS */],__WEBPACK_IMPORTED_MODULE_11__actions__["a" /* REQUEST_GET_LOCATION_FROM_ZIP_CODE */]])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setLocation:function setLocation(location){return dispatch(__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* setLocation */](location));},setZipCode:function setZipCode(zipCode){return dispatch(__WEBPACK_IMPORTED_MODULE_11__actions__["o" /* setZipCode */](zipCode));},setUseLocation:function setUseLocation(value){return dispatch(__WEBPACK_IMPORTED_MODULE_11__actions__["n" /* setUseLocation */](value));},getStoreShowcase:function getStoreShowcase(){return dispatch(__WEBPACK_IMPORTED_MODULE_11__actions__["l" /* getStoreShowcase */]());},getOfferShowCase:function getOfferShowCase(type){return dispatch(__WEBPACK_IMPORTED_MODULE_11__actions__["k" /* getOfferShowCase */](type));},getLocationFromZipCode:function getLocationFromZipCode(){return dispatch(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* getLocationFromZipCode */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(HomeIupp));HomeIupp.propTypes={participant:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,stores:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,physicalOffers:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,ecommerceOffers:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,useLocation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,zipCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isLoadingStores:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingOffers:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,setLocation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,setZipCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,setUseLocation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,getStoreShowcase:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,getOfferShowCase:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,getLocationFromZipCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_maps_react__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_google_maps_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_google_maps_react__);
var APIKEY=''+Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_COMUNIDADE_IUPP_GOOGLE_MAPS_KEY;function MapContainer(_ref){var google=_ref.google,styles=_ref.styles,geolocation=_ref.geolocation,stores=_ref.stores,offers=_ref.offers;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){},[geolocation,stores,offers]);var getMarkers=function getMarkers(stores){return stores.map(function(store,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_google_maps_react__["Marker"],{key:index,id:index,title:store.name,name:store.name,position:{lat:store.place.location.latitude,lng:store.place.location.longitude}});});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_google_maps_react__["Map"],{google:google,zoom:11,style:styles,initialCenter:geolocation,center:geolocation},stores&&stores.length>0&&getMarkers(stores));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_google_maps_react__["GoogleApiWrapper"])({apiKey:APIKEY})(MapContainer));MapContainer.propTypes={google:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,styles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,geolocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,offers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1844), __webpack_require__(1848), __webpack_require__(1849), __webpack_require__(1852), __webpack_require__(1853), __webpack_require__(1854), __webpack_require__(1858), __webpack_require__(1855), __webpack_require__(0), __webpack_require__(1), __webpack_require__(42), __webpack_require__(103), __webpack_require__(1857)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./GoogleApiComponent'), require('./components/Marker'), require('./components/InfoWindow'), require('./components/HeatMap'), require('./components/Polygon'), require('./components/Polyline'), require('./components/Circle'), require('./components/Rectangle'), require('react'), require('prop-types'), require('react-dom'), require('./lib/String'), require('./lib/cancelablePromise'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.GoogleApiComponent, global.Marker, global.InfoWindow, global.HeatMap, global.Polygon, global.Polyline, global.Circle, global.Rectangle, global.react, global.propTypes, global.reactDom, global.String, global.cancelablePromise);
    global.index = mod.exports;
  }
})(this, function (exports, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _Circle, _Rectangle, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Map = exports.Rectangle = exports.Circle = exports.Polyline = exports.Polygon = exports.HeatMap = exports.InfoWindow = exports.Marker = exports.GoogleApiWrapper = undefined;
  Object.defineProperty(exports, 'GoogleApiWrapper', {
    enumerable: true,
    get: function () {
      return _GoogleApiComponent.wrapper;
    }
  });
  Object.defineProperty(exports, 'Marker', {
    enumerable: true,
    get: function () {
      return _Marker.Marker;
    }
  });
  Object.defineProperty(exports, 'InfoWindow', {
    enumerable: true,
    get: function () {
      return _InfoWindow.InfoWindow;
    }
  });
  Object.defineProperty(exports, 'HeatMap', {
    enumerable: true,
    get: function () {
      return _HeatMap.HeatMap;
    }
  });
  Object.defineProperty(exports, 'Polygon', {
    enumerable: true,
    get: function () {
      return _Polygon.Polygon;
    }
  });
  Object.defineProperty(exports, 'Polyline', {
    enumerable: true,
    get: function () {
      return _Polyline.Polyline;
    }
  });
  Object.defineProperty(exports, 'Circle', {
    enumerable: true,
    get: function () {
      return _Circle.Circle;
    }
  });
  Object.defineProperty(exports, 'Rectangle', {
    enumerable: true,
    get: function () {
      return _Rectangle.Rectangle;
    }
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var mapStyles = {
    container: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    map: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    }
  };

  var evtNames = ['ready', 'click', 'dragend', 'recenter', 'bounds_changed', 'center_changed', 'dblclick', 'dragstart', 'heading_change', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];

  var Map = exports.Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
      _classCallCheck(this, Map);

      var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

      if (!props.hasOwnProperty('google')) {
        throw new Error('You must include a `google` prop');
      }

      _this.listeners = {};
      _this.state = {
        currentLocation: {
          lat: _this.props.initialCenter.lat,
          lng: _this.props.initialCenter.lng
        }
      };

      _this.mapRef = _react2.default.createRef();
      return _this;
    }

    _createClass(Map, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.centerAroundCurrentLocation) {
          if (navigator && navigator.geolocation) {
            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            }));

            this.geoPromise.promise.then(function (pos) {
              var coords = pos.coords;
              _this2.setState({
                currentLocation: {
                  lat: coords.latitude,
                  lng: coords.longitude
                }
              });
            }).catch(function (e) {
              return e;
            });
          }
        }
        this.loadMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
          this.loadMap();
        }
        if (this.props.visible !== prevProps.visible) {
          this.restyleMap();
        }
        if (this.props.zoom !== prevProps.zoom) {
          this.map.setZoom(this.props.zoom);
        }
        if (this.props.center !== prevProps.center) {
          this.setState({
            currentLocation: this.props.center
          });
        }
        if (prevState.currentLocation !== this.state.currentLocation) {
          this.recenterMap();
        }
        if (this.props.bounds && this.props.bounds !== prevProps.bounds) {
          this.map.fitBounds(this.props.bounds);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var google = this.props.google;

        if (this.geoPromise) {
          this.geoPromise.cancel();
        }
        Object.keys(this.listeners).forEach(function (e) {
          google.maps.event.removeListener(_this3.listeners[e]);
        });
      }
    }, {
      key: 'loadMap',
      value: function loadMap() {
        var _this4 = this;

        if (this.props && this.props.google) {
          var google = this.props.google;

          var maps = google.maps;

          var mapRef = this.mapRef.current;
          var node = _reactDom2.default.findDOMNode(mapRef);
          var curr = this.state.currentLocation;
          var center = new maps.LatLng(curr.lat, curr.lng);

          var mapTypeIds = this.props.google.maps.MapTypeId || {};
          var mapTypeFromProps = String(this.props.mapType).toUpperCase();

          var mapConfig = Object.assign({}, {
            mapTypeId: mapTypeIds[mapTypeFromProps],
            center: center,
            zoom: this.props.zoom,
            maxZoom: this.props.maxZoom,
            minZoom: this.props.minZoom,
            clickableIcons: !!this.props.clickableIcons,
            disableDefaultUI: this.props.disableDefaultUI,
            zoomControl: this.props.zoomControl,
            zoomControlOptions: this.props.zoomControlOptions,
            mapTypeControl: this.props.mapTypeControl,
            mapTypeControlOptions: this.props.mapTypeControlOptions,
            scaleControl: this.props.scaleControl,
            streetViewControl: this.props.streetViewControl,
            streetViewControlOptions: this.props.streetViewControlOptions,
            panControl: this.props.panControl,
            rotateControl: this.props.rotateControl,
            fullscreenControl: this.props.fullscreenControl,
            scrollwheel: this.props.scrollwheel,
            draggable: this.props.draggable,
            draggableCursor: this.props.draggableCursor,
            keyboardShortcuts: this.props.keyboardShortcuts,
            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
            noClear: this.props.noClear,
            styles: this.props.styles,
            gestureHandling: this.props.gestureHandling
          });

          Object.keys(mapConfig).forEach(function (key) {
            // Allow to configure mapConfig with 'false'
            if (mapConfig[key] === null) {
              delete mapConfig[key];
            }
          });

          this.map = new maps.Map(node, mapConfig);

          evtNames.forEach(function (e) {
            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
          });
          maps.event.trigger(this.map, 'ready');
          this.forceUpdate();
        }
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evtName) {
        var _this5 = this;

        var timeout = void 0;
        var handlerName = 'on' + (0, _String.camelize)(evtName);

        return function (e) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          timeout = setTimeout(function () {
            if (_this5.props[handlerName]) {
              _this5.props[handlerName](_this5.props, _this5.map, e);
            }
          }, 0);
        };
      }
    }, {
      key: 'recenterMap',
      value: function recenterMap() {
        var map = this.map;

        var google = this.props.google;


        if (!google) return;
        var maps = google.maps;

        if (map) {
          var center = this.state.currentLocation;
          if (!(center instanceof google.maps.LatLng)) {
            center = new google.maps.LatLng(center.lat, center.lng);
          }
          // map.panTo(center)
          map.setCenter(center);
          maps.event.trigger(map, 'recenter');
        }
      }
    }, {
      key: 'restyleMap',
      value: function restyleMap() {
        if (this.map) {
          var google = this.props.google;

          google.maps.event.trigger(this.map, 'resize');
        }
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var _this6 = this;

        var children = this.props.children;


        if (!children) return;

        return _react2.default.Children.map(children, function (c) {
          if (!c) return;
          return _react2.default.cloneElement(c, {
            map: _this6.map,
            google: _this6.props.google,
            mapCenter: _this6.state.currentLocation
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var style = Object.assign({}, mapStyles.map, this.props.style, {
          display: this.props.visible ? 'inherit' : 'none'
        });

        var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);

        return _react2.default.createElement(
          'div',
          { style: containerStyles, className: this.props.className },
          _react2.default.createElement(
            'div',
            { style: style, ref: this.mapRef },
            'Loading map...'
          ),
          this.renderChildren()
        );
      }
    }]);

    return Map;
  }(_react2.default.Component);

  Map.propTypes = {
    google: _propTypes2.default.object,
    zoom: _propTypes2.default.number,
    centerAroundCurrentLocation: _propTypes2.default.bool,
    center: _propTypes2.default.object,
    initialCenter: _propTypes2.default.object,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    containerStyle: _propTypes2.default.object,
    visible: _propTypes2.default.bool,
    mapType: _propTypes2.default.string,
    maxZoom: _propTypes2.default.number,
    minZoom: _propTypes2.default.number,
    clickableIcons: _propTypes2.default.bool,
    disableDefaultUI: _propTypes2.default.bool,
    zoomControl: _propTypes2.default.bool,
    zoomControlOptions: _propTypes2.default.object,
    mapTypeControl: _propTypes2.default.bool,
    mapTypeControlOptions: _propTypes2.default.bool,
    scaleControl: _propTypes2.default.bool,
    streetViewControl: _propTypes2.default.bool,
    streetViewControlOptions: _propTypes2.default.object,
    panControl: _propTypes2.default.bool,
    rotateControl: _propTypes2.default.bool,
    fullscreenControl: _propTypes2.default.bool,
    scrollwheel: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    draggableCursor: _propTypes2.default.string,
    keyboardShortcuts: _propTypes2.default.bool,
    disableDoubleClickZoom: _propTypes2.default.bool,
    noClear: _propTypes2.default.bool,
    styles: _propTypes2.default.array,
    gestureHandling: _propTypes2.default.string,
    bounds: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
  });

  Map.defaultProps = {
    zoom: 14,
    initialCenter: {
      lat: 37.774929,
      lng: -122.419416
    },
    center: {},
    centerAroundCurrentLocation: false,
    style: {},
    containerStyle: {},
    visible: true
  };

  exports.default = Map;
});

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(42), __webpack_require__(1845), __webpack_require__(1847)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-dom'), require('./lib/ScriptCache'), require('./lib/GoogleApi'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactDom, global.ScriptCache, global.GoogleApi);
    global.GoogleApiComponent = mod.exports;
  }
})(this, function (exports, _react, _reactDom, _ScriptCache, _GoogleApi) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {};

  var serialize = function serialize(obj) {
    return JSON.stringify(obj);
  };
  var isSame = function isSame(obj1, obj2) {
    return obj1 === obj2 || serialize(obj1) === serialize(obj2);
  };

  var defaultCreateCache = function defaultCreateCache(options) {
    options = options || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || ['places'];
    var version = options.version || '3';
    var language = options.language || 'en';
    var url = options.url;
    var client = options.client;
    var region = options.region;

    return (0, _ScriptCache.ScriptCache)({
      google: (0, _GoogleApi2.default)({
        apiKey: apiKey,
        language: language,
        libraries: libraries,
        version: version,
        url: url,
        client: client,
        region: region
      })
    });
  };

  var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  };

  var wrapper = exports.wrapper = function wrapper(input) {
    return function (WrappedComponent) {
      var Wrapper = function (_React$Component) {
        _inherits(Wrapper, _React$Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          // Build options from input
          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          var options = typeof input === 'function' ? input(props) : input;

          // Initialize required Google scripts and other configured options
          _this.initialize(options);

          _this.state = {
            loaded: false,
            map: null,
            google: null,
            options: options
          };

          _this.mapRef = _react2.default.createRef();
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'UNSAFE_componentWillReceiveProps',
          value: function UNSAFE_componentWillReceiveProps(props) {
            // Do not update input if it's not dynamic
            if (typeof input !== 'function') {
              return;
            }

            // Get options to compare
            var prevOptions = this.state.options;
            var options = typeof input === 'function' ? input(props) : input;

            // Ignore when options are not changed
            if (isSame(options, prevOptions)) {
              return;
            }

            // Initialize with new options
            this.initialize(options);

            // Save new options in component state,
            // and remove information about previous API handlers
            this.setState({
              options: options,
              loaded: false,
              google: null
            });
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
            }
          }
        }, {
          key: 'initialize',
          value: function initialize(options) {
            // Avoid race condition: remove previous 'load' listener
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
              this.unregisterLoadHandler = null;
            }

            // Load cache factory
            var createCache = options.createCache || defaultCreateCache;

            // Build script
            this.scriptCache = createCache(options);
            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));

            // Store information about loading container
            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
          }
        }, {
          key: 'onLoad',
          value: function onLoad(err, tag) {
            this._gapi = window.google;

            this.setState({ loaded: true, google: this._gapi });
          }
        }, {
          key: 'render',
          value: function render() {
            var LoadingContainer = this.LoadingContainer;

            if (!this.state.loaded) {
              return _react2.default.createElement(LoadingContainer, null);
            }

            var props = Object.assign({}, this.props, {
              loaded: this.state.loaded,
              google: window.google
            });

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(WrappedComponent, props),
              _react2.default.createElement('div', { ref: this.mapRef })
            );
          }
        }]);

        return Wrapper;
      }(_react2.default.Component);

      return Wrapper;
    };
  };

  exports.default = wrapper;
});

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1846)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./windowOrGlobal'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.windowOrGlobal);
        global.ScriptCache = mod.exports;
    }
})(this, function (exports, window) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== 'undefined' && window._scriptMap || new Map();
    var ScriptCache = exports.ScriptCache = function (global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};

            Cache._onLoad = function (key) {
                return function (cb) {
                    var registered = true;

                    function unregister() {
                        registered = false;
                    }

                    var stored = scriptMap.get(key);

                    if (stored) {
                        stored.promise.then(function () {
                            if (registered) {
                                stored.error ? cb(stored.error) : cb(null, stored);
                            }

                            return stored;
                        }).catch(function (error) {
                            return cb(error);
                        });
                    } else {
                        // TODO:
                    }

                    return unregister;
                };
            };

            Cache._scriptTag = function (key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === 'undefined') return null;

                    var tag = document.createElement('script');
                    var promise = new Promise(function (resolve, reject) {
                        var body = document.getElementsByTagName('body')[0];

                        tag.type = 'text/javascript';
                        tag.async = false; // Load in order

                        var cbName = 'loaderCB' + counter++ + Date.now();
                        var cb = void 0;

                        var handleResult = function handleResult(state) {
                            return function (evt) {
                                var stored = scriptMap.get(key);
                                if (state === 'loaded') {
                                    stored.resolved = true;
                                    resolve(src);
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = []
                                } else if (state === 'error') {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;

                                cleanup();
                            };
                        };

                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === 'function') {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };

                        tag.onload = handleResult('loaded');
                        tag.onerror = handleResult('error');
                        tag.onreadystatechange = function () {
                            handleResult(tag.readyState);
                        };

                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
                            cb = window[cbName] = tag.onload;
                        } else {
                            tag.addEventListener('load', tag.onload);
                        }
                        tag.addEventListener('error', tag.onerror);

                        tag.src = src;
                        body.appendChild(tag);

                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key).tag;
            };

            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});

            Object.keys(scripts).forEach(function (key) {
                var script = scripts[key];

                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);

                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });

            return Cache;
        };
    }(window);

    exports.default = ScriptCache;
});

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.windowOrGlobal = mod.exports;
  }
})(this, function (module) {
  'use strict';

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  module.exports = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.GoogleApi = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
    opts = opts || {};

    if (!opts.hasOwnProperty('apiKey')) {
      throw new Error('You must pass an apiKey to use GoogleApi');
    }

    var apiKey = opts.apiKey;
    var libraries = opts.libraries || ['places'];
    var client = opts.client;
    var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';

    var googleVersion = opts.version || '3.31';

    var script = null;
    var google = typeof window !== 'undefined' && window.google || null;
    var loading = false;
    var channel = null;
    var language = opts.language;
    var region = opts.region || null;

    var onLoadEvents = [];

    var url = function url() {
      var url = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        v: googleVersion,
        channel: channel,
        language: language,
        region: region,
        onerror: 'ERROR_FUNCTION'
      };

      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');

      return url + '?' + paramStr;
    };

    return url();
  };

  exports.default = GoogleApi;
});

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.Marker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Marker = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Marker = exports.Marker = function (_React$Component) {
    _inherits(Marker, _React$Component);

    function Marker() {
      _classCallCheck(this, Marker);

      return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
    }

    _createClass(Marker, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.markerPromise = wrappedPromise();
        this.renderMarker();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
          if (this.marker) {
            this.marker.setMap(null);
          }
          this.renderMarker();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.marker) {
          this.marker.setMap(null);
        }
      }
    }, {
      key: 'renderMarker',
      value: function renderMarker() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            position = _props.position,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            label = _props.label,
            draggable = _props.draggable,
            title = _props.title,
            props = _objectWithoutProperties(_props, ['map', 'google', 'position', 'mapCenter', 'icon', 'label', 'draggable', 'title']);

        if (!google) {
          return null;
        }

        var pos = position || mapCenter;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = new google.maps.LatLng(pos.lat, pos.lng);
        }

        var pref = _extends({
          map: map,
          position: pos,
          icon: icon,
          label: label,
          title: title,
          draggable: draggable
        }, props);
        this.marker = new google.maps.Marker(pref);

        evtNames.forEach(function (e) {
          _this2.marker.addListener(e, _this2.handleEvent(e));
        });

        this.markerPromise.resolve(this.marker);
      }
    }, {
      key: 'getMarker',
      value: function getMarker() {
        return this.markerPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.marker, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Marker;
  }(_react2.default.Component);

  Marker.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Marker.propTypes[e] = _propTypes2.default.func;
  });

  Marker.defaultProps = {
    name: 'Marker'
  };

  exports.default = Marker;
});

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(42), __webpack_require__(1850)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-dom/server'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.server);
    global.InfoWindow = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _server) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.InfoWindow = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _server2 = _interopRequireDefault(_server);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InfoWindow = exports.InfoWindow = function (_React$Component) {
    _inherits(InfoWindow, _React$Component);

    function InfoWindow() {
      _classCallCheck(this, InfoWindow);

      return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
    }

    _createClass(InfoWindow, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.renderInfoWindow();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            google = _props.google,
            map = _props.map;


        if (!google || !map) {
          return;
        }

        if (map !== prevProps.map) {
          this.renderInfoWindow();
        }

        if (this.props.position !== prevProps.position) {
          this.updatePosition();
        }

        if (this.props.children !== prevProps.children) {
          this.updateContent();
        }

        if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) {
          this.props.visible ? this.openWindow() : this.closeWindow();
        }
      }
    }, {
      key: 'renderInfoWindow',
      value: function renderInfoWindow() {
        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            mapCenter = _props2.mapCenter,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'mapCenter']);

        if (!google || !google.maps) {
          return;
        }

        var iw = this.infowindow = new google.maps.InfoWindow(_extends({
          content: ''
        }, props));

        google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
        google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
      }
    }, {
      key: 'onOpen',
      value: function onOpen() {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
    }, {
      key: 'onClose',
      value: function onClose() {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }, {
      key: 'openWindow',
      value: function openWindow() {
        this.infowindow.open(this.props.map, this.props.marker);
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition() {
        var pos = this.props.position;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
        }
        this.infowindow.setPosition(pos);
      }
    }, {
      key: 'updateContent',
      value: function updateContent() {
        var content = this.renderChildren();
        this.infowindow.setContent(content);
      }
    }, {
      key: 'closeWindow',
      value: function closeWindow() {
        this.infowindow.close();
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var children = this.props.children;

        return _server2.default.renderToString(children);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return InfoWindow;
  }(_react2.default.Component);

  InfoWindow.propTypes = {
    children: _propTypes2.default.element.isRequired,
    map: _propTypes2.default.object,
    marker: _propTypes2.default.object,
    position: _propTypes2.default.object,
    visible: _propTypes2.default.bool,

    // callbacks
    onClose: _propTypes2.default.func,
    onOpen: _propTypes2.default.func
  };

  InfoWindow.defaultProps = {
    visible: false
  };

  exports.default = InfoWindow;
});

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1851);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(118),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,w=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.fundamental"):60117,la=t?Symbol.for("react.scope"):60119,C=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;C.hasOwnProperty("ReactCurrentDispatcher")||(C.ReactCurrentDispatcher={current:null});C.hasOwnProperty("ReactCurrentBatchConfig")||(C.ReactCurrentBatchConfig={suspense:null});
function ma(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function D(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case w:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return D(a.type);case ja:if(a=1===a._status?a._result:null)return D(a)}return null}var na={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function oa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=na;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var pa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,qa=Object.prototype.hasOwnProperty,ra={},sa={};
function ta(a){if(qa.call(sa,a))return!0;if(qa.call(ra,a))return!1;if(pa.test(a))return sa[a]=!0;ra[a]=!0;return!1}function ua(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function va(a,b,c,d){if(null===b||"undefined"===typeof b||ua(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var wa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=wa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function xa(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||va(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+"="+('"'+N(b)+'"')}return ta(a)?a+"="+('"'+N(b)+'"'):""}function ya(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var za="function"===typeof Object.is?Object.is:ya,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Aa(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ba(){null===Q?null===P?(R=!1,P=Q=Aa()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Aa()):(R=!0,Q=Q.next);return Q}function Ca(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Da(a,b){return"function"===typeof b?b(a):b}
function Ea(a,b,c){O=W();Q=Ba();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Da?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Fa.bind(null,O,a);return[Q.memoizedState,a]}
function Fa(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ga(){}
var X=0,Ha={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ba();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!za(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ea,useRef:function(a){O=W();Q=Ba();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Ea(Da,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ga,useEffect:Ga,useDebugValue:Ga,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ia={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Ka={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},La=k({menuitem:!0},Ka),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ma=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Na=/([A-Z])/g,Oa=/^ms-/,Z=l.Children.toArray,Pa=C.ReactCurrentDispatcher,Qa={listing:!0,pre:!0,textarea:!0},Ra=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Sa={},Ta={};function Ua(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Va=Object.prototype.hasOwnProperty,Wa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Xa(a,b){if(void 0===a)throw Error(q(152,D(b)||"Component"));}
function Ya(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=oa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var v=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=v&&(e.state=k({},e.state,v))}}else if(O={},e=g(d.props,
f,m),e=Ca(g,d.props,e,f),null==e||null==e.render){a=e;Xa(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{v=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,v,d.props,f):p;null!=p&&(y?(y=!1,v=k({},v,p)):k(v,p))}e.state=v}}else x=null;a=e.render();Xa(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,D(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var Za=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ia.html,children:a,childIndex:0,context:na,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Pa.current;Pa.current=Ha;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
v="";try{v+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=v}}return g[0]}finally{Pa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Ya(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Ca(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ka:throw Error(q(338));case ja:switch(c=a.type,ma(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case la:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ia.html&&Ja(c);if(!Sa.hasOwnProperty(c)){if(!Ra.test(c))throw Error(q(65,c));Sa[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Ua(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(La[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Va.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var v="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ta.hasOwnProperty(A))A=Ta[A];else{var T=A.replace(Na,"-$1").toLowerCase().replace(Oa,"-ms-");A=Ta[A]=T}v+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";v+=y;r=";"}}m=v||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Wa.hasOwnProperty(z)||(n=z,n=ta(n)&&null!=m?n+"="+('"'+N(m)+'"'):""):n=xa(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";Ka.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Qa[c]&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ja(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),$a={renderToString:function(a){a=new Za(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Za(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.12.0"},ab={default:$a},bb=ab&&$a||ab;module.exports=bb.default||bb;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.HeatMap = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HeatMap = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseover', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var HeatMap = exports.HeatMap = function (_React$Component) {
    _inherits(HeatMap, _React$Component);

    function HeatMap() {
      _classCallCheck(this, HeatMap);

      return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
    }

    _createClass(HeatMap, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.heatMapPromise = wrappedPromise();
        this.renderHeatMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
          if (this.heatMap) {
            this.heatMap.setMap(null);
            this.renderHeatMap();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.heatMap) {
          this.heatMap.setMap(null);
        }
      }
    }, {
      key: 'renderHeatMap',
      value: function renderHeatMap() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            positions = _props.positions,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            gradient = _props.gradient,
            _props$radius = _props.radius,
            radius = _props$radius === undefined ? 20 : _props$radius,
            _props$opacity = _props.opacity,
            opacity = _props$opacity === undefined ? 0.2 : _props$opacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'positions', 'mapCenter', 'icon', 'gradient', 'radius', 'opacity']);

        if (!google) {
          return null;
        }

        var data = positions.map(function (pos) {
          return { location: new google.maps.LatLng(pos.lat, pos.lng), weight: pos.weight };
        });

        var pref = _extends({
          map: map,
          gradient: gradient,
          radius: radius,
          opacity: opacity,
          data: data
        }, props);

        this.heatMap = new google.maps.visualization.HeatmapLayer(pref);

        this.heatMap.set('radius', radius === undefined ? 20 : radius);

        this.heatMap.set('opacity', opacity === undefined ? 0.2 : opacity);

        evtNames.forEach(function (e) {
          _this2.heatMap.addListener(e, _this2.handleEvent(e));
        });

        this.heatMapPromise.resolve(this.heatMap);
      }
    }, {
      key: 'getHeatMap',
      value: function getHeatMap() {
        return this.heatMapPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.heatMap, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return HeatMap;
  }(_react2.default.Component);

  HeatMap.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object,
    icon: _propTypes2.default.string
  };

  evtNames.forEach(function (e) {
    return HeatMap.propTypes[e] = _propTypes2.default.func;
  });

  HeatMap.defaultProps = {
    name: 'HeatMap'
  };

  exports.default = HeatMap;
});

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(325), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polygon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polygon = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polygon = exports.Polygon = function (_React$Component) {
    _inherits(Polygon, _React$Component);

    function Polygon() {
      _classCallCheck(this, Polygon);

      return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
    }

    _createClass(Polygon, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polygonPromise = wrappedPromise();
        this.renderPolygon();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
          this.renderPolygon();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polygon) {
          this.polygon.setMap(null);
        }
      }
    }, {
      key: 'renderPolygon',
      value: function renderPolygon() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            paths = _props.paths,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          paths: paths,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.polygon = new google.maps.Polygon(params);

        evtNames.forEach(function (e) {
          _this2.polygon.addListener(e, _this2.handleEvent(e));
        });

        this.polygonPromise.resolve(this.polygon);
      }
    }, {
      key: 'getPolygon',
      value: function getPolygon() {
        return this.polygonPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polygon, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polygon;
  }(_react2.default.Component);

  Polygon.propTypes = {
    paths: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polygon.propTypes[e] = _propTypes2.default.func;
  });

  Polygon.defaultProps = {
    name: 'Polygon'
  };

  exports.default = Polygon;
});

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(325), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polyline = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polyline = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polyline = exports.Polyline = function (_React$Component) {
    _inherits(Polyline, _React$Component);

    function Polyline() {
      _classCallCheck(this, Polyline);

      return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
    }

    _createClass(Polyline, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polylinePromise = wrappedPromise();
        this.renderPolyline();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
          if (this.polyline) {
            this.polyline.setMap(null);
          }
          this.renderPolyline();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polyline) {
          this.polyline.setMap(null);
        }
      }
    }, {
      key: 'renderPolyline',
      value: function renderPolyline() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            path = _props.path,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            props = _objectWithoutProperties(_props, ['map', 'google', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          path: path,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight
        }, props);

        this.polyline = new google.maps.Polyline(params);

        evtNames.forEach(function (e) {
          _this2.polyline.addListener(e, _this2.handleEvent(e));
        });

        this.polylinePromise.resolve(this.polyline);
      }
    }, {
      key: 'getPolyline',
      value: function getPolyline() {
        return this.polylinePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polyline, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polyline;
  }(_react2.default.Component);

  Polyline.propTypes = {
    path: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polyline.propTypes[e] = _propTypes2.default.func;
  });

  Polyline.defaultProps = {
    name: 'Polyline'
  };

  exports.default = Polyline;
});

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(1856), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/areBoundsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.areBoundsEqual, global.String);
    global.Rectangle = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _areBoundsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Rectangle = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Rectangle = exports.Rectangle = function (_React$Component) {
    _inherits(Rectangle, _React$Component);

    function Rectangle() {
      _classCallCheck(this, Rectangle);

      return _possibleConstructorReturn(this, (Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).apply(this, arguments));
    }

    _createClass(Rectangle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.rectanglePromise = wrappedPromise();
        this.renderRectangle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _areBoundsEqual.areBoundsEqual)(this.props.bounds, prevProps.bounds)) {
          if (this.rectangle) {
            this.rectangle.setMap(null);
          }
          this.renderRectangle();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.rectangle) {
          this.rectangle.setMap(null);
        }
      }
    }, {
      key: 'renderRectangle',
      value: function renderRectangle() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            bounds = _props.bounds,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'bounds', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          bounds: bounds,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.rectangle = new google.maps.Rectangle(params);

        evtNames.forEach(function (e) {
          _this2.rectangle.addListener(e, _this2.handleEvent(e));
        });

        this.rectanglePromise.resolve(this.rectangle);
      }
    }, {
      key: 'getRectangle',
      value: function getRectangle() {
        return this.rectanglePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.rectangle, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        console.log('hii, ', this.props.bounds);
        return null;
      }
    }]);

    return Rectangle;
  }(_react2.default.Component);

  Rectangle.propTypes = {
    bounds: _propTypes2.default.object,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Rectangle.propTypes[e] = _propTypes2.default.func;
  });

  Rectangle.defaultProps = {
    name: 'Rectangle'
  };

  exports.default = Rectangle;
});

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.areBoundsEqual = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two bound objects.
   */

  var areBoundsEqual = exports.areBoundsEqual = function areBoundsEqual(boundA, boundB) {
    if (boundA === boundB) {
      return true;
    }
    if (!(boundA instanceof Object) || !(boundB instanceof Object)) {
      return false;
    }
    if (Object.keys(boundA).length !== Object.keys(boundB).length) {
      return false;
    }
    if (!areValidBounds(boundA) || !areValidBounds(boundB)) {
      return false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(boundA)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (boundA[key] !== boundB[key]) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var areValidBounds = function areValidBounds(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('north') && elem.hasOwnProperty('south') && elem.hasOwnProperty('east') && elem.hasOwnProperty('west');
  };
});

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.cancelablePromise = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html

  var makeCancelable = exports.makeCancelable = function makeCancelable(promise) {
    var hasCanceled_ = false;

    var wrappedPromise = new Promise(function (resolve, reject) {
      promise.then(function (val) {
        return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
      });
      promise.catch(function (error) {
        return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
      });
    });

    return {
      promise: wrappedPromise,
      cancel: function cancel() {
        hasCanceled_ = true;
      }
    };
  };
});

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(325), __webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Circle = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Circle = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Circle = exports.Circle = function (_React$Component) {
    _inherits(Circle, _React$Component);

    function Circle() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Circle);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Circle.__proto__ || Object.getPrototypeOf(Circle)).call.apply(_ref, [this].concat(args))), _this), _this.centerChanged = function (newCenter) {
        var _this$props$center = _this.props.center,
            lat = _this$props$center.lat,
            lng = _this$props$center.lng;

        return lat !== newCenter.lat || lng !== newCenter.lng;
      }, _this.propsChanged = function (newProps) {
        if (_this.centerChanged(newProps.center)) return true;

        return Object.keys(Circle.propTypes).some(function (key) {
          return _this.props[key] !== newProps[key];
        });
      }, _this.destroyCircle = function () {
        if (_this.circle) {
          _this.circle.setMap(null);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Circle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.circlePromise = wrappedPromise();
        this.renderCircle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            path = _props.path,
            map = _props.map;


        if (this.propsChanged(prevProps) || map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(path, prevProps.path)) {
          this.destroyCircle();
          this.renderCircle();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.destroyCircle();
      }
    }, {
      key: 'renderCircle',
      value: function renderCircle() {
        var _this2 = this;

        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            center = _props2.center,
            radius = _props2.radius,
            strokeColor = _props2.strokeColor,
            strokeOpacity = _props2.strokeOpacity,
            strokeWeight = _props2.strokeWeight,
            fillColor = _props2.fillColor,
            fillOpacity = _props2.fillOpacity,
            draggable = _props2.draggable,
            visible = _props2.visible,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'center', 'radius', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity', 'draggable', 'visible']);

        if (!google) {
          return null;
        }

        var params = _extends({}, props, {
          map: map,
          center: center,
          radius: radius,
          draggable: draggable,
          visible: visible,
          options: {
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight,
            fillColor: fillColor,
            fillOpacity: fillOpacity
          }
        });

        this.circle = new google.maps.Circle(params);

        evtNames.forEach(function (e) {
          _this2.circle.addListener(e, _this2.handleEvent(e));
        });

        this.circlePromise.resolve(this.circle);
      }
    }, {
      key: 'getCircle',
      value: function getCircle() {
        return this.circlePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.circle, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Circle;
  }(_react2.default.Component);

  Circle.propTypes = {
    center: _propTypes2.default.object,
    radius: _propTypes2.default.number,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number,
    draggable: _propTypes2.default.bool,
    visible: _propTypes2.default.bool
  };

  evtNames.forEach(function (e) {
    return Circle.propTypes[e] = _propTypes2.default.func;
  });

  Circle.defaultProps = {
    name: 'Circle'
  };

  exports.default = Circle;
});

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_CardStore__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaceHolder__ = __webpack_require__(651);
var StoreShowCase=function StoreShowCase(_ref){var loading=_ref.loading,stores=_ref.stores,useLocation=_ref.useLocation,zipCode=_ref.zipCode,openLocationModal=_ref.openLocationModal;var handleShowAllStores=function handleShowAllStores(){window.location.href='/comunidade-iupp/searchStores?zipcode='+zipCode;};var hasStores=stores&&stores.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PlaceHolder__["a" /* default */],{isLoading:loading},hasStores&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'p0-mob'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overflowHidden mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'floatLeft mt-2 titleOfertas'},'lojas pertinho de voc\xEA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonClickCep floatRight',onClick:openLocationModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_location'}),'ativar localiza\xE7\xE3o'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-direct-b'},stores&&stores.slice(0,4).map(function(unity,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Card_CardStore__["a" /* default */],Object.assign({},unity,{key:index,location:useLocation}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-cards-mBairro mobile',onClick:handleShowAllStores},'Ver todas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex color-brand-1 tit-ver-todas-b mt-2',onClick:handleShowAllStores,title:'Vai para todas unidades'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'mr-1'},'ver todas unidades'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon-sm icon_right color-brand-1'}))));};/* harmony default export */ __webpack_exports__["a"] = (StoreShowCase);StoreShowCase.propTypes={loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,useLocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,zipCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,openLocationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_CardOferta__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaceHolder__ = __webpack_require__(651);
// @ts-nocheck
var OfferShowCase=function OfferShowCase(_ref){var type=_ref.type,loading=_ref.loading,offers=_ref.offers,useLocation=_ref.useLocation,zipCode=_ref.zipCode,openLocationModal=_ref.openLocationModal;var handleShowAllStores=function handleShowAllStores(){window.location.href='/comunidade-iupp/search?zipcode='+zipCode;};var hasStores=offers&&offers.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PlaceHolder__["a" /* default */],{isLoading:loading},hasStores&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'p0-mob'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overflowHidden mt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'floatLeft mt-2 titleOfertas'},type==='ecommerceOffers'?'ofertas em lojas virtuais':'ofertas pertinho de você'),type!=='ecommerceOffers'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonClickCep floatRight',onClick:openLocationModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_location'}),'ativar localiza\xE7\xE3o'):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-direct-b'},offers&&offers.slice(0,4).map(function(product,ix){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Card_CardOferta__["a" /* default */],Object.assign({},product,{offer:product,key:ix,location:useLocation}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-cards-mBairro mobile',onClick:handleShowAllStores},'Ver todas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex color-brand-1 tit-ver-todas-b mt-2',onClick:handleShowAllStores,title:'Vai para ofertas por categorias'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'mr-1'},'ver todas ofertas de lojas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon-sm icon_right color-brand-1'}))));};/* harmony default export */ __webpack_exports__["a"] = (OfferShowCase);OfferShowCase.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,offers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,useLocation:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,zipCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,openLocationModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return participant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showCaseStoresFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showCaseStores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return zipCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return location; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectRequesting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(543);
function _selectRequesting(requestingState,actionTypes){return actionTypes.some(function(actionType){return requestingState[actionType];});}function _getOfferShowCase(offers,type){return offers[type];}var participant=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.participant;},function(participant){return participant;});var showCaseStoresFilter=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.showcase.filters.stores;},function(stores){return stores;});var showCaseStores=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.showcase.stores;},function(stores){return stores;});var useLocation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.showcase.useLocation;},function(useLocation){return useLocation;});var zipCode=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.showcase.zipCode;},function(zipCode){return zipCode;});var location=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.showcase.location;},function(location){return location;});var selectRequesting=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.requesting;},function(state,actionTypes){return actionTypes;},_selectRequesting);var getOffers=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["a" /* createSelector */])(function(state){return state.comunidade.showcase.offers;},function(state,type){return type;},_getOfferShowCase);

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Product__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductContainer=function(_Component){_inherits(ProductContainer,_Component);function ProductContainer(){_classCallCheck(this,ProductContainer);return _possibleConstructorReturn(this,(ProductContainer.__proto__||Object.getPrototypeOf(ProductContainer)).apply(this,arguments));}_createClass(ProductContainer,[{key:'render',value:function render(){var _props$match$params=this.props.match.params,product=_props$match$params.product,company=_props$match$params.company,store=_props$match$params.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Product__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */],{product:product,company:company,store:store}));}}]);return ProductContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductContainer.propTypes={match:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({product:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,company:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,store:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired})})};/* harmony default export */ __webpack_exports__["a"] = (ProductContainer);

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductTabs__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_click_copy_code__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_rater__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_rater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_rater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalEvaluation__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ModalReport__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_rater_lib_react_rater_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_rater_lib_react_rater_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_rater_lib_react_rater_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_tabs_style_react_tabs_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loyal_template_rating_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loyal_template_rating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__loyal_template_rating_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Product=function(_Component){_inherits(Product,_Component);function Product(props){var _this2=this;_classCallCheck(this,Product);var _this=_possibleConstructorReturn(this,(Product.__proto__||Object.getPrototypeOf(Product)).call(this,props));_this.handleVerifyToken=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].tokenVerify();case 2:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleGetUnity=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var resultUnity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getUnity(_this.props.company,_this.props.store);case 2:resultUnity=_context2.sent;if(resultUnity!=null){_this.setState(Object.assign({},_this.state,{isLoaded:true,unity:resultUnity.data.objectReturn}));}case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleGetOffer=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var resultOffer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getOffers(_this.state.filter);case 2:resultOffer=_context3.sent;_this.setState({offer:resultOffer.data.objectReturn.data[0]});case 4:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleGetEvaluate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var items=arguments.length>0&&arguments[0]!==undefined?arguments[0]:5;var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var resultEvaluate,averageRating,numberOfRows,Evaluate,EvaluateItems;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getEvaluate(_this.props.company,items,page);case 2:resultEvaluate=_context4.sent;averageRating=resultEvaluate.data.objectReturn&&resultEvaluate.data.objectReturn.averageRating;numberOfRows=resultEvaluate.data.objectReturn&&resultEvaluate.data.objectReturn.numberOfRows;Evaluate={'averageRating':averageRating,'numberOfRows':numberOfRows};EvaluateItems=_this.state.EvaluateItems.concat(resultEvaluate.data.objectReturn.ratings);_this.setState({currentPage:_this.state.currentPage+1,Evaluate:Evaluate,EvaluateItems:EvaluateItems});return _context4.abrupt('return',resultEvaluate);case 9:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.createEvaluate=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(EvaluateTitle,EvaluateComment,EvaluateRating,EvaluateUserId,EvaluateName){var payload,resultEvaluate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:payload={'comment':EvaluateComment,'title':EvaluateTitle,'rating':EvaluateRating,'userId':_this.props.company,'participantIdentifier':EvaluateUserId,'participantName':EvaluateName};_context5.next=3;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].createEvaluate(payload);case 3:resultEvaluate=_context5.sent;_this.setState({EvaluateItems:[],Evaluate:{}});_this.handleGetEvaluate(5,1);return _context5.abrupt('return',resultEvaluate);case 7:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x3,_x4,_x5,_x6,_x7){return _ref5.apply(this,arguments);};}();_this.toReport=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(email,id,description){var payload,resultComplain;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:payload={'complainTypeId':id,'company':_this.state.unity.description,'description':description,'email':email,'userId':_this.props.company};_context6.next=3;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].createReportComplain(payload);case 3:resultComplain=_context6.sent;if(!(resultComplain&&resultComplain.data&&resultComplain.data.success)){_context6.next=9;break;}_this.ReportToggle();return _context6.abrupt('return',resultComplain);case 9:_this.setState({errorReportComplain:true});return _context6.abrupt('return',resultComplain);case 11:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x8,_x9,_x10){return _ref6.apply(this,arguments);};}();_this.handleGetComplain=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var resultComplain;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return __WEBPACK_IMPORTED_MODULE_8__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getComplain();case 2:resultComplain=_context7.sent;_this.setState({complain:resultComplain&&resultComplain.data.objectReturn});case 4:case'end':return _context7.stop();}}},_callee7,_this2);}));_this.state={copied:false,modalGoLink:false,onClose:false,unity:null,isLoaded:false,currentPage:0,onReportToggle:false,complain:{},errorReportComplain:false,Evaluate:{},EvaluateItems:[],offer:{},filter:{pagination:{pageSize:1,pageNumber:1},filter:{saleId:_this.props.product,storeIds:[_this.props.store],geoNear:{maxDistance:500000,location:{latitude:-23.4945212,longitude:-46.7066441}}}}};_this.onCopy=_this.onCopy.bind(_this);_this.modalGoLink=_this.modalGoLink.bind(_this);_this.onRating=_this.onRating.bind(_this);_this.ReportToggle=_this.ReportToggle.bind(_this);_this.handleGetEvaluate=_this.handleGetEvaluate.bind(_this);_this.handleClickModalRedirect=_this.handleClickModalRedirect.bind(_this);_this.createEvaluate=_this.createEvaluate.bind(_this);return _this;}_createClass(Product,[{key:'componentDidMount',value:function componentDidMount(){this.handleVerifyToken();this.handleGetUnity();this.handleGetComplain();this.handleGetEvaluate(5,1);this.handleGetOffer();}},{key:'onCopy',value:function onCopy(){var _this3=this;this.setState({copied:true});setTimeout(function(){_this3.setState({copied:false});_this3.modalGoLink();},1000);}},{key:'handleClickModalRedirect',value:function handleClickModalRedirect(){this.state.unity.urlECommerce?window.open(this.state.unity.urlECommerce,'_blank'):this.modalGoLink();}},{key:'modalGoLink',value:function modalGoLink(){this.setState({modalGoLink:!this.state.modalGoLink});}},{key:'onRating',value:function onRating(){this.setState({onClose:!this.state.onClose});}},{key:'ReportToggle',value:function ReportToggle(){this.setState({onReportToggle:!this.state.onReportToggle});}},{key:'render',value:function render(){var props=this.props;return this.state.isLoaded===false?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-bairro container pt-5 pb-3 ','data-sku':props.company},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-side col-12 col-md-7 pr-0 pl-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white pt-1 pt-md-3 pos-relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-image overflow voucher txt-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default.a,{src:this.state.offer.urlImage,fallbackImage:__WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png___default.a,alt:'',className:'mx-auto'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minDeviceWidth:768},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductTabs__["a" /* default */],{description:this.state.unity.descriptionChain,evaluate:this.state.Evaluate,evaluateItems:this.state.EvaluateItems,onRating:this.onRating,handleGetEvaluate:this.handleGetEvaluate,currentPage:this.state.currentPage,offer:this.state.offer})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-side col-12 col-lg-5  mt-4 mt-lg-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-infos col-12 py-2 px-3 mx-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body color-featured mb-1 txt-lowercase'},this.state.unity.category),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'color-title'},this.state.offer.fantasyName,' ',!this.state.offer.isVirtualStore?' - '+this.state.unity.description:''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm'},this.state.unity.address.city,'/',this.state.unity.address.state),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center mt-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto product-rating'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,this.state.Evaluate.averageRating))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto product-rating px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_rater___default.a,{total:5,rating:Math.round(this.state.Evaluate.averageRating),interactive:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto product-rating'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm'},this.state.Evaluate.numberOfRows>1?this.state.Evaluate.numberOfRows+' avaliações':this.state.Evaluate.numberOfRows+' avaliação')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-discount-infos col-12 border-color-ui-3 border-bottom border-top py-2 px-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row w-100 mx-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-discount-value col-12 txt-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-title txt-font-body-bold '},this.state.offer.name!==undefined&&this.state.offer.name!==''?this.state.offer.name+' - ':'','  ',this.state.offer.benefitTitle)))),this.state.offer.isCupom?this.state.offer.isVirtualStore?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 mt-2 mb-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},'Copie o cupom e acesso o site para utilizar')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 mt-2 mb-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},'Informe o cupom no momento da compra')):'',this.state.offer.isCupom?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-coupon col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 radius py-1 txt-center '+(this.state.copied&&'copied')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.offer.cupom))):'',this.state.offer.isGift?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 mt-2 mb-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},'Brinde:')):'',this.state.offer.isGift?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-coupon col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 radius py-1 txt-center '+(this.state.copied&&'copied')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.offer.gift))):'',this.state.offer.isCupom&&this.state.offer.isVirtualStore?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_click_copy_code__["a" /* ClickCopy */],{sourceOverwrite:this.state.offer.cupom,onClick:this.onCopy,className:'btn btn-featured btn-copy-coupon col-12 col-md-12 px-3'},'Copiar cupom e utilizar')):'',this.state.offer.isGift&&this.state.offer.isVirtualStore?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 mt-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_click_copy_code__["a" /* ClickCopy */],{sourceOverwrite:this.state.offer.cupom,onClick:this.onCopy,className:'btn btn-featured btn-copy-coupon col-12 col-md-12 px-3'},'Acessar site')):'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-info col-12 border-color-ui-3 border-bottom border-top px-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row py-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-2'},!this.state.offer.isVirtualStore&&this.state.unity.description&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_chat'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'Sobre')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.description))))),this.state.unity.urlECommerce&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_translate'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'site')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:this.state.unity.urlECommerce,target:'_blank'},this.state.unity.urlECommerce)))))),!this.state.offer.isVirtualStore&&this.state.unity.phone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_phone'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'telefone')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.phone.length===12?this.state.unity.phone.replace(/^(\d{2})(\d{4})(\d{4})$/g,'($1) $2-$3'):this.state.unity.whatsApp.replace(/^(\d{2})(\d{5})(\d{4})$/g,'($1) $2-$3')))))),!this.state.offer.isVirtualStore&&this.state.unity.whatsApp&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_whatsapp'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'whatsapp')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://api.whatsapp.com/send?phone=55'+this.state.unity.whatsApp,target:'_blank'},this.state.unity.whatsApp.replace(/^(\d{2})(\d{5})(\d{4})$/g,'($1) $2-$3'))))))),!this.state.offer.isVirtualStore&&this.state.unity.instagram&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_instagram'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'instagram')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.instagram))))),!this.state.offer.isVirtualStore&&this.state.unity.address.zipCode&&this.state.unity.address.street&&this.state.unity.address.city&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_location'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'endere\xE7o')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.address.street,', ',this.state.unity.address.number,' - ',this.state.unity.address.neighborhood),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.address.city,' - ',this.state.unity.address.state,' - ',this.state.unity.address.zipCode.replace(/^(\d{5})(\d{3})$/g,'$1-$2')))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center bg-ui-4 border-top border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-2 py-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm mBairro'},'Caso tenha algum problema com este an\xFAncio e queira denunci\xE1-lo ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'txt-body-sm cursor color-featured',onClick:this.ReportToggle},'clique aqui'),'.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{maxDeviceWidth:767},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductTabs__["a" /* default */],{description:this.state.unity.descriptionChain,onRating:this.onRating,evaluate:this.state.unity.evaluate,evaluateItems:this.state.EvaluateItems,handleGetEvaluate:this.handleGetEvaluate,currentPage:this.state.currentPage,offer:this.state.offer})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' modal-marker'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_awesome_modal___default.a,{width:'100%',height:'100%',effect:'fadeInUp',visible:this.state.modalGoLink},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-copy-and-go col-auto mx-auto bg-white radius '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'py-half'},'voc\xEA ser\xE1 enviado ao site do nosso parceiro')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_card color-brand-1'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'n\xE3o esque\xE7a de realizar a compra com o seu Itaucard para garantir o desconto.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn',onClick:this.modalGoLink},'Cancelar')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-featured',onClick:this.handleClickModalRedirect},'Ir para o site')))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ModalReport__["a" /* ModalReport */],{show:this.state.onReportToggle,ReportToggle:this.ReportToggle,toReport:this.toReport,complain:this.state.complain,errorReportComplain:this.state.errorReportComplain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalEvaluation__["a" /* ModalEvaluation */],{show:this.state.onClose,onClose:this.onRating,createEvaluate:this.createEvaluate}));}}]);return Product;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Product.propTypes={product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,store:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,company:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Product);

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rater__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_rater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_rater_lib_react_rater_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_rater_lib_react_rater_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_rater_lib_react_rater_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tabs_style_react_tabs_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_rating_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loyal_template_rating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__loyal_template_rating_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_storerating_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_storerating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_storerating_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductTabs=function(_Component){_inherits(ProductTabs,_Component);function ProductTabs(){_classCallCheck(this,ProductTabs);return _possibleConstructorReturn(this,(ProductTabs.__proto__||Object.getPrototypeOf(ProductTabs)).apply(this,arguments));}_createClass(ProductTabs,[{key:'render',value:function render(){var _this2=this;var _props$evaluate=this.props.evaluate,averageRating=_props$evaluate.averageRating,numberOfRows=_props$evaluate.numberOfRows;var evaluateItems=this.props.evaluateItems;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["d" /* Tabs */],{defaultIndex:0,className:'product-tabs border-color-ui-3 mt-0 mt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-area draggable border-color-ui-3 border-bottom px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["b" /* TabList */],{className:'tabs-item py-3 px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-lowercase txt-body color-ui-3'},'como utilizar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-lowercase txt-body color-ui-3'},'avalia\xE7\xF5es')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book'},'como utilizar seu cupom:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.offer.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book'},'Condi\xE7\xF5es'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.offer.name)),this.props.offer.typeBenefit&&this.props.offer.typeBenefit.isProducts?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book'},'Benef\xEDcios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.offer.gift)):'',this.props.offer.typeBenefit&&this.props.offer.typeBenefit.isDiscount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book'},'Benef\xEDcios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},this.props.offer.benefitTitle)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book'},'Vig\xEAncia'),this.props.offer&&this.props.offer.duration&&this.props.offer.duration.initialDateUTC&&this.props.offer.duration.finalDateUTC&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'De',' ',__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(this.props.offer.duration.initialDateUTC).format('DD/MM/YYYY HH:mm'),' ','/ At\xE9',' ',__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(this.props.offer.duration.finalDateUTC).format('DD/MM/YYYY HH:mm')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 product-rating-tablets'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'txt-headline'},averageRating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rater___default.a,{total:5,rating:Math.round(averageRating),interactive:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'m\xE9dia de',' ',numberOfRows>1?numberOfRows+' avaliações':numberOfRows+' avaliação')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'openRatingModal',name:'openRatingModal',className:'btn btn-rating-modal col-12 col-md-12 px-3',text:'Avaliar',onClick:this.props.onRating})))),evaluateItems&&evaluateItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'col-12 border-color-ui-3 border-top pt-3 mt-3 mb-3 product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rater___default.a,{total:5,rating:item.rating,interactive:false}),' ',item.participantName||'',' -',' ',__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.createDate).format('DD/MM/YYYY')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 d-none d-md-block px-md-1 px-2 my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book '},item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 py-md-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},item.comment))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-top border-top-dotted border-color-ui-3 pt-3 pb-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cursor txt-left px-0 pt-1 txt-font-body color-brand-1 txt-body',onClick:function onClick(){return _this2.props.handleGetEvaluate(5,_this2.props.currentPage+1);}},'Ver mais avalia\xE7\xF5es'))))));}}]);return ProductTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductTabs.propTypes={offer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,onRating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,evaluate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,evaluateItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,handleGetEvaluate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductTabs);

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Star = function Star(props) {
  var starProps = Object.assign({}, props);
  var nameMap = {
    isDisabled: 'is-disabled',
    isActive: 'is-active',
    isActiveHalf: 'is-active-half',
    willBeActive: 'will-be-active'
  };
  var className = Object.keys(nameMap).filter(function (prop) {
    return delete starProps[prop], props[prop];
  }).map(function (prop) {
    return nameMap[prop];
  }).join(' ');
  return _react["default"].createElement("div", _extends({
    className: "react-rater-star ".concat(className)
  }, starProps), "\u2605");
};

Star.defaultProps = {
  willBeActive: false,
  isActive: false,
  isActiveHalf: false,
  isDisabled: false
};
Star.propTypes = {
  isActive: _propTypes["default"].bool,
  isActiveHalf: _propTypes["default"].bool,
  willBeActive: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool
};
var _default = Star;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Star, "Star", "/Users/simon/Individual/react-rater/src/star.js");
  reactHotLoader.register(_default, "default", "/Users/simon/Individual/react-rater/src/star.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)(module)))

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
'use strict';

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* WEBPACK VAR INJECTION */(function (global) {
  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return ClickCopy;
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

  var toggleSelection = function toggleSelection() {
    var selection = document.getSelection();
    if (!selection.rangeCount) {
      return function () {};
    }
    var active = document.activeElement;

    var ranges = [];
    for (var i = 0; i < selection.rangeCount; i++) {
      ranges.push(selection.getRangeAt(i));
    }

    switch (active.tagName.toUpperCase()) {// .toUpperCase handles XHTML
      case 'INPUT':
      case 'TEXTAREA':
        active.blur();
        break;

      default:
        active = null;
        break;
    }

    selection.removeAllRanges();
    return function () {
      selection.type === 'Caret' && selection.removeAllRanges();

      if (!selection.rangeCount) {
        ranges.forEach(function (range) {
          selection.addRange(range);
        });
      }

      active && active.focus();
    };
  };

  var defaultMessage = 'Copy to clipboard: #{key}, Enter';

  function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
    return message.replace(/#{\s*key\s*}/g, copyKey);
  }

  function copy(text, options) {
    var debug,
        message,
        reselectPrevious,
        range,
        selection,
        mark,
        success = false;
    if (!options) {
      options = {};
    }
    debug = options.debug || false;
    try {
      reselectPrevious = toggleSelection();

      range = document.createRange();
      selection = document.getSelection();

      mark = document.createElement('span');
      mark.textContent = text;
      // reset user styles for span element
      mark.style.all = 'unset';
      // prevents scrolling to the end of the page
      mark.style.position = 'fixed';
      mark.style.top = 0;
      mark.style.clip = 'rect(0, 0, 0, 0)';
      // used to preserve spaces and line breaks
      mark.style.whiteSpace = 'pre';
      // do not inherit user-select (it may be `none`)
      mark.style.webkitUserSelect = 'text';
      mark.style.MozUserSelect = 'text';
      mark.style.msUserSelect = 'text';
      mark.style.userSelect = 'text';

      document.body.appendChild(mark);

      range.selectNode(mark);
      selection.addRange(range);

      var successful = document.execCommand('copy');
      if (!successful) {
        throw new Error('copy command was unsuccessful');
      }
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using execCommand: ', err);
      debug && console.warn('trying IE specific stuff');
      try {
        window.clipboardData.setData('text', text);
        success = true;
      } catch (err) {
        debug && console.error('unable to copy using clipboardData: ', err);
        debug && console.error('falling back to prompt');
        message = format('message' in options ? options.message : defaultMessage);
        window.prompt(message, text);
      }
    } finally {
      if (selection) {
        if (typeof selection.removeRange == 'function') {
          selection.removeRange(range);
        } else {
          selection.removeAllRanges();
        }
      }

      if (mark) {
        document.body.removeChild(mark);
      }
      reselectPrevious();
    }

    return success;
  }

  var copyToClipboard = copy;

  var spacer = function spacer(times, tabStop) {
    if (times === 0) {
      return '';
    }

    return new Array(times * tabStop).fill(' ').join('');
  };

  /*!
   * isobject <https://github.com/jonschlinkert/isobject>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */

  var isobject = function isObject(val) {
    return val != null && (typeof val === 'undefined' ? 'undefined' : _typeof2(val)) === 'object' && Array.isArray(val) === false;
  };

  function isObjectObject(o) {
    return isobject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
  }

  var isPlainObject = function isPlainObject(o) {
    var ctor, prot;

    if (isObjectObject(o) === false) return false;

    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== 'function') return false;

    // If has modified prototype
    prot = ctor.prototype;
    if (isObjectObject(prot) === false) return false;

    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) {
      return false;
    }

    // Most likely a plain Object
    return true;
  };

  var isRegexp = function isRegexp(re) {
    return Object.prototype.toString.call(re) === '[object RegExp]';
  };

  var isObj = function isObj(x) {
    var type = typeof x === 'undefined' ? 'undefined' : _typeof2(x);
    return x !== null && (type === 'object' || type === 'function');
  };

  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var lib = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = function (object) {
      return Object.getOwnPropertySymbols(object).filter(function (keySymbol) {
        return object.propertyIsEnumerable(keySymbol);
      });
    };
  });

  unwrapExports(lib);

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };

  var getOwnEnumPropSymbols = lib.default;

  var stringifyObject = function stringifyObject(val, opts, pad) {
    var seen = [];

    return function stringify(val, opts, pad) {
      opts = opts || {};
      opts.indent = opts.indent || '\t';
      pad = pad || '';

      var tokens = void 0;

      if (opts.inlineCharacterLimit === undefined) {
        tokens = {
          newLine: '\n',
          newLineOrSpace: '\n',
          pad: pad,
          indent: pad + opts.indent
        };
      } else {
        tokens = {
          newLine: '@@__STRINGIFY_OBJECT_NEW_LINE__@@',
          newLineOrSpace: '@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@',
          pad: '@@__STRINGIFY_OBJECT_PAD__@@',
          indent: '@@__STRINGIFY_OBJECT_INDENT__@@'
        };
      }

      var expandWhiteSpace = function expandWhiteSpace(string) {
        if (opts.inlineCharacterLimit === undefined) {
          return string;
        }

        var oneLined = string.replace(new RegExp(tokens.newLine, 'g'), '').replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');

        if (oneLined.length <= opts.inlineCharacterLimit) {
          return oneLined;
        }

        return string.replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').replace(new RegExp(tokens.pad, 'g'), pad).replace(new RegExp(tokens.indent, 'g'), pad + opts.indent);
      };

      if (seen.indexOf(val) !== -1) {
        return '"[Circular]"';
      }

      if (val === null || val === undefined || typeof val === 'number' || typeof val === 'boolean' || typeof val === 'function' || (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'symbol' || isRegexp(val)) {
        return String(val);
      }

      if (val instanceof Date) {
        return 'new Date(\'' + val.toISOString() + '\')';
      }

      if (Array.isArray(val)) {
        if (val.length === 0) {
          return '[]';
        }

        seen.push(val);

        var ret = '[' + tokens.newLine + val.map(function (el, i) {
          var eol = val.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
          var value = stringify(el, opts, pad + opts.indent);
          if (opts.transform) {
            value = opts.transform(val, i, value);
          }
          return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';

        seen.pop(val);

        return expandWhiteSpace(ret);
      }

      if (isObj(val)) {
        var objKeys = Object.keys(val).concat(getOwnEnumPropSymbols(val));

        if (opts.filter) {
          objKeys = objKeys.filter(function (el) {
            return opts.filter(val, el);
          });
        }

        if (objKeys.length === 0) {
          return '{}';
        }

        seen.push(val);

        var _ret = '{' + tokens.newLine + objKeys.map(function (el, i) {
          var eol = objKeys.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
          var isSymbol = (typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'symbol';
          var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el);
          var key = isSymbol || isClassic ? el : stringify(el, opts);
          var value = stringify(val[el], opts, pad + opts.indent);
          if (opts.transform) {
            value = opts.transform(val, el, value);
          }
          return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';

        seen.pop(val);

        return expandWhiteSpace(_ret);
      }

      val = String(val).replace(/[\r\n]/g, function (x) {
        return x === '\n' ? '\\n' : '\\r';
      });

      if (opts.singleQuotes === false) {
        val = val.replace(/"/g, '\\"');
        return '"' + val + '"';
      }

      val = val.replace(/\\?'/g, '\\\'');
      return '\'' + val + '\'';
    }(val, opts, pad);
  };

  var _typeof$1 = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };

  function sortObject(value) {
    // return non-object value as is
    if (value === null || (typeof value === 'undefined' ? 'undefined' : _typeof$1(value)) !== 'object') {
      return value;
    }

    // return date and regexp values as is
    if (value instanceof Date || value instanceof RegExp) {
      return value;
    }

    // make a copy of array with each item passed through sortObject()
    if (Array.isArray(value)) {
      return value.map(sortObject);
    }

    // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function (result, key) {
      // eslint-disable-next-line no-param-reassign
      result[key] = sortObject(value[key]);
      return result;
    }, {});
  }

  /* eslint-disable no-use-before-define */

  var createStringTreeNode = function createStringTreeNode(value) {
    return {
      type: 'string',
      value: value
    };
  };

  var createNumberTreeNode = function createNumberTreeNode(value) {
    return {
      type: 'number',
      value: value
    };
  };

  var createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
      type: 'ReactElement',
      displayName: displayName,
      props: props,
      defaultProps: defaultProps,
      childrens: childrens
    };
  };

  var createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
      type: 'ReactFragment',
      key: key,
      childrens: childrens
    };
  };

  var _typeof$2 = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };

  var supportFragment = Boolean(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"]);

  var getReactElementDisplayName = function getReactElementDisplayName(element) {
    return element.type.displayName || element.type.name || ( // function name
    typeof element.type === 'function' // function without a name, you should provide one
    ? 'No Display Name' : element.type);
  };

  var noChildren = function noChildren(propsValue, propName) {
    return propName !== 'children';
  };

  var onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== '';
  };

  var filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};

    Object.keys(originalProps).filter(function (key) {
      return cb(originalProps[key], key);
    }).forEach(function (key) {
      return filteredProps[key] = originalProps[key];
    });

    return filteredProps;
  };

  var parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName,
        displayNameFn = _options$displayName === undefined ? getReactElementDisplayName : _options$displayName;

    if (typeof element === 'string') {
      return createStringTreeNode(element);
    } else if (typeof element === 'number') {
      return createNumberTreeNode(element);
    } else if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      throw new Error('react-element-to-jsx-string: Expected a React.Element, got `' + (typeof element === 'undefined' ? 'undefined' : _typeof$2(element)) + '`');
    }

    var displayName = displayNameFn(element);

    var props = filterProps(element.props, noChildren);
    if (element.ref !== null) {
      props.ref = element.ref;
    }

    var key = element.key;
    if (typeof key === 'string' && key.search(/^\./)) {
      // React automatically add key=".X" when there are some children
      props.key = key;
    }

    var defaultProps = filterProps(element.type.defaultProps || {}, noChildren);
    var childrens = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(element.props.children).filter(onlyMeaningfulChildren).map(function (child) {
      return parseReactElement(child, options);
    });

    if (supportFragment && element.type === __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"]) {
      return createReactFragmentTreeNode(key, childrens);
    }

    return createReactElementTreeNode(displayName, props, defaultProps, childrens);
  };

  function noRefCheck() {}

  var formatComplexDataStructure = function formatComplexDataStructure(value, inline, lvl, options) {
    var normalizedValue = sortObject(value);

    var stringifiedValue = stringifyObject(normalizedValue, {
      transform: function transform(currentObj, prop, originalResult) {
        var currentValue = currentObj[prop];

        if (currentValue && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(currentValue)) {
          return formatTreeNode(parseReactElement(currentValue, options), true, lvl, options);
        }

        if (typeof currentValue === 'function') {
          return noRefCheck;
        }

        return originalResult;
      }
    });

    if (inline) {
      return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
    }

    // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, spacer(1, options.tabStop)).replace(/\n([^$])/g, '\n' + spacer(lvl + 1, options.tabStop) + '$1');
  };

  var _typeof$3 = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };

  var noRefCheck$1 = function noRefCheck() {};
  var escape = function escape(s) {
    return s.replace(/"/g, '&quot;');
  };

  var defaultFunctionValue = function defaultFunctionValue(fn) {
    return fn;
  };

  var formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === 'number') {
      return '{' + String(propValue) + '}';
    }

    if (typeof propValue === 'string') {
      return '"' + escape(propValue) + '"';
    }

    // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ((typeof propValue === 'undefined' ? 'undefined' : _typeof$3(propValue)) === 'symbol') {
      var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');

      if (!symbolDescription) {
        return '{Symbol()}';
      }

      return '{Symbol(\'' + symbolDescription + '\')}';
    }

    if (typeof propValue === 'function') {
      var _options$functionValu = options.functionValue,
          functionValue = _options$functionValu === undefined ? defaultFunctionValue : _options$functionValu,
          showFunctions = options.showFunctions;

      if (!showFunctions && functionValue === defaultFunctionValue) {
        return '{' + functionValue(noRefCheck$1) + '}';
      }

      return '{' + functionValue(propValue) + '}';
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(propValue)) {
      return '{' + formatTreeNode(parseReactElement(propValue, options), true, lvl, options) + '}';
    }

    if (propValue instanceof Date) {
      return '{new Date("' + propValue.toISOString() + '")}';
    }

    if (isPlainObject(propValue) || Array.isArray(propValue)) {
      return '{' + formatComplexDataStructure(propValue, inline, lvl, options) + '}';
    }

    return '{' + String(propValue) + '}';
  };

  var formatProp = function formatProp(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) {
      throw new Error('The prop "' + name + '" has no value and no default: could not be formatted');
    }

    var usedValue = hasValue ? value : defaultValue;

    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax,
        tabStop = options.tabStop;

    var formattedPropValue = formatPropValue(usedValue, inline, lvl, options);

    var attributeFormattedInline = ' ';
    var attributeFormattedMultiline = '\n' + spacer(lvl + 1, tabStop);
    var isMultilineAttribute = formattedPropValue.includes('\n');

    if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
      // If a boolean is false and not different from it's default, we do not render the attribute
      attributeFormattedInline = '';
      attributeFormattedMultiline = '';
    } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
      attributeFormattedInline += '' + name;
      attributeFormattedMultiline += '' + name;
    } else {
      attributeFormattedInline += name + '=' + formattedPropValue;
      attributeFormattedMultiline += name + '=' + formattedPropValue;
    }

    return {
      attributeFormattedInline: attributeFormattedInline,
      attributeFormattedMultiline: attributeFormattedMultiline,
      isMultilineAttribute: isMultilineAttribute
    };
  };

  var mergeSiblingPlainStringChildrenReducer = function mergeSiblingPlainStringChildrenReducer(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];

    if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) {
      nodes.push(createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    } else {
      if (previousNode) {
        nodes.push(previousNode);
      }

      nodes.push(currentNode);
    }

    return nodes;
  };

  var propNameSorter = function propNameSorter(sortProps) {
    return function (a, b) {
      if (a === b) {
        return 0;
      }

      if (['key', 'ref'].includes(a)) {
        return -1;
      } else if (['key', 'ref'].includes(b)) {
        return 1;
      }

      if (!sortProps) {
        return 0;
      }

      return a < b ? -1 : 1;
    };
  };

  var compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;

    if (element.type === 'string') {
      return formattedElement.split('\n').map(function (line, offset) {
        if (offset === 0) {
          return line;
        }

        return '' + spacer(lvl, tabStop) + line;
      }).join('\n');
    }

    return formattedElement;
  };

  var formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function (element) {
      return compensateMultilineStringElementIndentation(element, formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
  };

  var onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function (propName) {
      var haveDefaultValue = Object.keys(defaultProps).includes(propName);
      return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
  };

  var isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) {
      return attributes.length > 1;
    }

    return spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
  };

  var shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return (isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
  };

  var formatReactElementNode = function formatReactElementNode(node, inline, lvl, options) {
    var type = node.type,
        _node$displayName = node.displayName,
        displayName = _node$displayName === undefined ? '' : _node$displayName,
        childrens = node.childrens,
        _node$props = node.props,
        props = _node$props === undefined ? {} : _node$props,
        _node$defaultProps = node.defaultProps,
        defaultProps = _node$defaultProps === undefined ? {} : _node$defaultProps;

    if (type !== 'ReactElement') {
      throw new Error('The "formatReactElementNode" function could only format node of type "ReactElement". Given:  ' + type);
    }

    var filterProps = options.filterProps,
        maxInlineAttributesLineLength = options.maxInlineAttributesLineLength,
        showDefaultProps = options.showDefaultProps,
        sortProps = options.sortProps,
        tabStop = options.tabStop;

    var out = '<' + displayName;

    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;

    var visibleAttributeNames = [];

    Object.keys(props).filter(function (propName) {
      return filterProps.indexOf(propName) === -1;
    }).filter(onlyPropsWithOriginalValue(defaultProps, props)).forEach(function (propName) {
      return visibleAttributeNames.push(propName);
    });

    Object.keys(defaultProps).filter(function (defaultPropName) {
      return filterProps.indexOf(defaultPropName) === -1;
    }).filter(function () {
      return showDefaultProps;
    }).filter(function (defaultPropName) {
      return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function (defaultPropName) {
      return visibleAttributeNames.push(defaultPropName);
    });

    var attributes = visibleAttributeNames.sort(propNameSorter(sortProps));

    attributes.forEach(function (attributeName) {
      var _formatProp = formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options),
          attributeFormattedInline = _formatProp.attributeFormattedInline,
          attributeFormattedMultiline = _formatProp.attributeFormattedMultiline,
          isMultilineAttribute = _formatProp.isMultilineAttribute;

      if (isMultilineAttribute) {
        containsMultilineAttr = true;
      }

      outInlineAttr += attributeFormattedInline;
      outMultilineAttr += attributeFormattedMultiline;
    });

    outMultilineAttr += '\n' + spacer(lvl, tabStop);

    if (shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) {
      out = outMultilineAttr;
    } else {
      out = outInlineAttr;
    }

    if (childrens && childrens.length > 0) {
      var newLvl = lvl + 1;

      out += '>';

      if (!inline) {
        out += '\n';
        out += spacer(newLvl, tabStop);
      }

      out += childrens.reduce(mergeSiblingPlainStringChildrenReducer, []).map(formatOneChildren(inline, newLvl, options)).join(!inline ? '\n' + spacer(newLvl, tabStop) : '');

      if (!inline) {
        out += '\n';
        out += spacer(newLvl - 1, tabStop);
      }
      out += '</' + displayName + '>';
    } else {
      if (!isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) {
        out += ' ';
      }

      out += '/>';
    }

    return out;
  };

  var REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
  var REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';

  var toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) {
      props = { key: key };
    }

    return {
      type: 'ReactElement',
      displayName: displayName,
      props: props,
      defaultProps: {},
      childrens: childrens
    };
  };

  var isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
  };
  var hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
  };

  var formatReactFragmentNode = function formatReactFragmentNode(node, inline, lvl, options) {
    var type = node.type,
        key = node.key,
        childrens = node.childrens;

    if (type !== 'ReactFragment') {
      throw new Error('The "formatReactFragmentNode" function could only format node of type "ReactFragment". Given: ' + type);
    }

    var useFragmentShortSyntax = options.useFragmentShortSyntax;

    var displayName = void 0;
    if (useFragmentShortSyntax) {
      if (hasNoChildren(node) || isKeyedFragment(node)) {
        displayName = REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
      } else {
        displayName = REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
      }
    } else {
      displayName = REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    }

    return formatReactElementNode(toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
  };

  var jsxStopChars = ['<', '>', '{', '}'];
  var shouldBeEscaped = function shouldBeEscaped(s) {
    return jsxStopChars.some(function (jsxStopChar) {
      return s.includes(jsxStopChar);
    });
  };

  var escape$1 = function escape(s) {
    if (!shouldBeEscaped(s)) {
      return s;
    }

    return '{`' + s + '`}';
  };

  var preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(' ')) {
      result = result.replace(/^(\S*)(\s*)$/, "$1{'$2'}");
    }

    if (result.startsWith(' ')) {
      result = result.replace(/^(\s*)(\S*)$/, "{'$1'}$2");
    }

    return result;
  };

  var formatTreeNode = function formatTreeNode(node, inline, lvl, options) {
    if (node.type === 'number') {
      return String(node.value);
    }

    if (node.type === 'string') {
      return node.value ? '' + preserveTrailingSpace(escape$1(String(node.value))) : '';
    }

    if (node.type === 'ReactElement') {
      return formatReactElementNode(node, inline, lvl, options);
    }

    if (node.type === 'ReactFragment') {
      return formatReactFragmentNode(node, inline, lvl, options);
    }

    throw new TypeError('Unknow format type "' + node.type + '"');
  };

  var formatTree = function formatTree(node, options) {
    return formatTreeNode(node, false, 0, options);
  };

  var reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$filterProps = _ref.filterProps,
        filterProps = _ref$filterProps === undefined ? [] : _ref$filterProps,
        _ref$showDefaultProps = _ref.showDefaultProps,
        showDefaultProps = _ref$showDefaultProps === undefined ? true : _ref$showDefaultProps,
        _ref$showFunctions = _ref.showFunctions,
        showFunctions = _ref$showFunctions === undefined ? false : _ref$showFunctions,
        functionValue = _ref.functionValue,
        _ref$tabStop = _ref.tabStop,
        tabStop = _ref$tabStop === undefined ? 2 : _ref$tabStop,
        _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax,
        useBooleanShorthandSyntax = _ref$useBooleanShorth === undefined ? true : _ref$useBooleanShorth,
        _ref$useFragmentShort = _ref.useFragmentShortSyntax,
        useFragmentShortSyntax = _ref$useFragmentShort === undefined ? true : _ref$useFragmentShort,
        _ref$sortProps = _ref.sortProps,
        sortProps = _ref$sortProps === undefined ? true : _ref$sortProps,
        maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength,
        displayName = _ref.displayName;

    if (!element) {
      throw new Error('react-element-to-jsx-string: Expected a ReactElement');
    }

    var options = {
      filterProps: filterProps,
      showDefaultProps: showDefaultProps,
      showFunctions: showFunctions,
      functionValue: functionValue,
      tabStop: tabStop,
      useBooleanShorthandSyntax: useBooleanShorthandSyntax,
      useFragmentShortSyntax: useFragmentShortSyntax,
      sortProps: sortProps,
      maxInlineAttributesLineLength: maxInlineAttributesLineLength,
      displayName: displayName
    };

    return formatTree(parseReactElement(element, options), options);
  };

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css = "@keyframes styles_click-copy-slide-in__1vKKu {\n  0% {\n    transform: translateY(100%);\n    opacity: 0\n  }\n\n  0% {\n    transform: translateY(95%);\n    opacity: .8\n  }\n\n  100% {\n    transform: translateY(0%);\n    opacity: .8\n  }\n}\n\n.styles_clickCopyNotificationWrapper__2XXYs {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  font-size: 1.4rem;\n  white-space: pre-line;\n}\n\n.styles_clickCopySourceWrapper__D2Jzb {\n  font-size: .8rem;\n  padding: .5rem;\n  text-align: left;\n}\n\n.styles_clickCopyWrapper__20dHa {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  padding: .5rem;\n}\n\n.styles_clickCopyWrapper__20dHa:active .styles_clickCopyNotificationWrapper__2XXYs,\n.styles_clickCopyWrapper__20dHa:focus .styles_clickCopyNotificationWrapper__2XXYs,\n.styles_clickCopyWrapper__20dHa:hover .styles_clickCopyNotificationWrapper__2XXYs {\n  animation: styles_click-copy-slide-in__1vKKu .5s 1 ease-out forwards;\n}\n";
  var styles = { "clickCopyNotificationWrapper": "styles_clickCopyNotificationWrapper__2XXYs", "clickCopySourceWrapper": "styles_clickCopySourceWrapper__D2Jzb", "clickCopyWrapper": "styles_clickCopyWrapper__20dHa", "click-copy-slide-in": "styles_click-copy-slide-in__1vKKu" };
  styleInject(css);

  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports$1(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule$1(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var key = '__global_unique_id__';

  var gud = function gud() {
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   */

  function makeEmptyFunction(arg) {
    return function () {
      return arg;
    };
  }

  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */
  var emptyFunction = function emptyFunction() {};

  emptyFunction.thatReturns = makeEmptyFunction;
  emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
  emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
  emptyFunction.thatReturnsNull = makeEmptyFunction(null);
  emptyFunction.thatReturnsThis = function () {
    return this;
  };
  emptyFunction.thatReturnsArgument = function (arg) {
    return arg;
  };

  var emptyFunction_1 = emptyFunction;

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var warning = emptyFunction_1;

  if (false) {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  }

  var warning_1 = warning;

  var implementation = createCommonjsModule$1(function (module, exports) {

    exports.__esModule = true;

    var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

    var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

    var _gud2 = _interopRequireDefault(gud);

    var _warning2 = _interopRequireDefault(warning_1);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
      }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var MAX_SIGNED_31_BIT_INT = 1073741823;

    // Inlined Object.is polyfill.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    function objectIs(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }

    function createEventEmitter(value) {
      var handlers = [];
      return {
        on: function on(handler) {
          handlers.push(handler);
        },
        off: function off(handler) {
          handlers = handlers.filter(function (h) {
            return h !== handler;
          });
        },
        get: function get() {
          return value;
        },
        set: function set(newValue, changedBits) {
          value = newValue;
          handlers.forEach(function (handler) {
            return handler(value, changedBits);
          });
        }
      };
    }

    function onlyChild(children) {
      return Array.isArray(children) ? children[0] : children;
    }

    function createReactContext(defaultValue, calculateChangedBits) {
      var _Provider$childContex, _Consumer$contextType;

      var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

      var Provider = function (_Component) {
        _inherits(Provider, _Component);

        function Provider() {
          var _temp, _this, _ret;

          _classCallCheck(this, Provider);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
        }

        Provider.prototype.getChildContext = function getChildContext() {
          var _ref;

          return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };

        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          if (this.props.value !== nextProps.value) {
            var oldValue = this.props.value;
            var newValue = nextProps.value;
            var changedBits = void 0;

            if (objectIs(oldValue, newValue)) {
              changedBits = 0; // No change
            } else {
              changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
              if (false) {
                (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
              }

              changedBits |= 0;

              if (changedBits !== 0) {
                this.emitter.set(nextProps.value, changedBits);
              }
            }
          }
        };

        Provider.prototype.render = function render() {
          return this.props.children;
        };

        return Provider;
      }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

      Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

      var Consumer = function (_Component2) {
        _inherits(Consumer, _Component2);

        function Consumer() {
          var _temp2, _this2, _ret2;

          _classCallCheck(this, Consumer);

          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
            value: _this2.getValue()
          }, _this2.onUpdate = function (newValue, changedBits) {
            var observedBits = _this2.observedBits | 0;
            if ((observedBits & changedBits) !== 0) {
              _this2.setState({ value: _this2.getValue() });
            }
          }, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }

        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
          var observedBits = nextProps.observedBits;

          this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
          : observedBits;
        };

        Consumer.prototype.componentDidMount = function componentDidMount() {
          if (this.context[contextProp]) {
            this.context[contextProp].on(this.onUpdate);
          }
          var observedBits = this.props.observedBits;

          this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
          : observedBits;
        };

        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
          if (this.context[contextProp]) {
            this.context[contextProp].off(this.onUpdate);
          }
        };

        Consumer.prototype.getValue = function getValue() {
          if (this.context[contextProp]) {
            return this.context[contextProp].get();
          } else {
            return defaultValue;
          }
        };

        Consumer.prototype.render = function render() {
          return onlyChild(this.props.children)(this.state.value);
        };

        return Consumer;
      }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

      Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);

      return {
        Provider: Provider,
        Consumer: Consumer
      };
    }

    exports.default = createReactContext;
    module.exports = exports['default'];
  });

  unwrapExports$1(implementation);

  var lib$1 = createCommonjsModule$1(function (module, exports) {

    exports.__esModule = true;

    var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

    var _implementation2 = _interopRequireDefault(implementation);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }

    exports.default = _react2.default.createContext || _implementation2.default;
    module.exports = exports['default'];
  });

  var createReactContext = unwrapExports$1(lib$1);

  var copyConsts = {
    COPY: {
      name: 'COPY',
      text: 'Click to copy!'
    },
    SUCCESS: {
      name: 'SUCCESS',
      text: 'Copied!'
    },
    ERROR: {
      name: 'ERROR',
      text: 'Oops. Try again.'
    }
  };

  var callAll = function callAll() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return fns.forEach(function (fn) {
        return fn && fn.apply(undefined, args);
      });
    };
  };

  var ClickContext = createReactContext();

  function ClickContextConsumer(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickContext.Consumer, props, function (context) {
      if (!context) {
        throw new Error('ClickCopy compound components cannot be rendered outside the ClickCopy component');
      }
      return props.children(context);
    });
  }

  function Items(_ref) {
    var children = _ref.children;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickContextConsumer, null, function () {
      return children;
    });
  }

  Items.displayName = 'ClickCopy.Items';

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
  };

  function Notification(_ref) {
    var _ref$background = _ref.background,
        background = _ref$background === undefined ? '#001eff' : _ref$background,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? 'white' : _ref$color,
        _ref$font = _ref.font,
        font = _ref$font === undefined ? 'monospace' : _ref$font,
        className = _ref.className,
        style = _ref.style,
        props = objectWithoutProperties(_ref, ['background', 'color', 'font', 'className', 'style']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickContextConsumer, null, function (_ref2) {
      var copyState = _ref2.copyState,
          notificationMessages = _ref2.notificationMessages;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({
        className: styles.clickCopyNotificationWrapper + ' ' + (className || ''),
        style: _extends({
          background: background,
          color: color,
          fontFamily: font
        }, style)
      }, props, {
        'data-testid': 'click-copy-notification'
      }), notificationMessages[copyState] || copyConsts[copyState].text);
    });
  }

  Notification.displayName = 'ClickCopy.Notification';

  Notification.propTypes = {
    background: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    font: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  function Source(_ref) {
    var _ref$background = _ref.background,
        background = _ref$background === undefined ? '#dadadd' : _ref$background,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? '#53535c' : _ref$color,
        _ref$font = _ref.font,
        font = _ref$font === undefined ? 'monospace' : _ref$font,
        className = _ref.className,
        style = _ref.style,
        props = objectWithoutProperties(_ref, ['background', 'color', 'font', 'className', 'style']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickContextConsumer, null, function (_ref2) {
      var itemSource = _ref2.itemSource;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({
        className: styles.clickCopySourceWrapper + ' ' + (className || ''),
        style: _extends({
          background: background,
          color: color,
          fontFamily: font
        }, style)
      }, props, {
        'data-testid': 'click-copy-source' }), itemSource);
    });
  }

  Source.displayName = 'ClickCopy.Source';

  Source.propTypes = {
    background: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    font: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var ClickCopy = function (_Component) {
    inherits(ClickCopy, _Component);

    function ClickCopy() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, ClickCopy);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ClickCopy.__proto__ || Object.getPrototypeOf(ClickCopy)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        copyState: copyConsts.COPY.name,
        itemSource: '',
        notificationMessages: {}
      }, _this._addNotificationMessages = function (copy, error, success) {
        var _notificationMessages;

        var notificationMessages = (_notificationMessages = {}, defineProperty(_notificationMessages, copyConsts.COPY.name, copy), defineProperty(_notificationMessages, copyConsts.ERROR.name, error), defineProperty(_notificationMessages, copyConsts.SUCCESS.name, success), _notificationMessages);
        _this.setState({ notificationMessages: notificationMessages });
      }, _this._processItems = function (children, formattingOptions) {
        // Finds and processes the item children, so we can copy & display their code
        var itemChildren = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children).find(function (child) {
          return child.type.displayName && child.type.displayName === 'ClickCopy.Items';
        }).props.children;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(itemChildren, function (child) {
          return reactElementToJsxString(child, _extends({
            showDefaultProps: false,
            filterProps: ['key']
          }, formattingOptions));
        }).reduce(function (acc, sourceString) {
          return acc.concat(sourceString);
        });
      }, _this._resetCopyState = function () {
        setTimeout(function () {
          return _this.setState({ copyState: copyConsts.COPY.name });
        }, 1500);
      }, _this._setSource = function (itemSource) {
        _this.setState({ itemSource: itemSource });
      }, _this.componentWillMount = function () {
        var _this$props = _this.props,
            children = _this$props.children,
            copyText = _this$props.copyText,
            formattingOptions = _this$props.formattingOptions,
            errorText = _this$props.errorText,
            sourceOverwrite = _this$props.sourceOverwrite,
            successText = _this$props.successText;

        var textToCopy = sourceOverwrite || _this._processItems(children, formattingOptions);

        _this._setSource(textToCopy);
        _this._addNotificationMessages(copyText, errorText, successText);
      }, _this.copyClick = function () {
        try {
          copyToClipboard(_this.state.itemSource);
          _this.setState({ copyState: copyConsts.SUCCESS.name }, callAll(_this._resetCopyState, _this.props.onSuccess));
        } catch (err) {
          _this.setState({ copyState: copyConsts.ERROR.name }, callAll(_this._resetCopyState, _this.props.onError)(err));
        }
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(ClickCopy, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            onClick = _props.onClick,
            className = _props.className;
        var _state = this.state,
            copyState = _state.copyState,
            itemSource = _state.itemSource,
            notificationMessages = _state.notificationMessages;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickContext.Provider, { value: {
            copyState: copyState,
            itemSource: itemSource,
            notificationMessages: notificationMessages
          } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
          className: styles.clickCopyWrapper + ' ' + (className || ''),
          onClick: callAll(this.copyClick, onClick),
          'data-testid': 'click-copy-wrapper'
        }, children));
      }
    }]);
    return ClickCopy;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ClickCopy.Items = Items;
  ClickCopy.Notification = Notification;
  ClickCopy.Source = Source;
  ClickCopy.propTypes = {
    copyText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    formattingOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    errorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSuccess: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    sourceOverwrite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    successText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  };

  //# sourceMappingURL=index.es.js.map

  /* WEBPACK VAR INJECTION */
}).call(__webpack_exports__, __webpack_require__(8));

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalEvaluation__ = __webpack_require__(1868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalEvaluation__["a"]; });


/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rater__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_rater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalEvaluation=function(_Component){_inherits(ModalEvaluation,_Component);function ModalEvaluation(){_classCallCheck(this,ModalEvaluation);var _this=_possibleConstructorReturn(this,(ModalEvaluation.__proto__||Object.getPrototypeOf(ModalEvaluation)).call(this));_this.goToStepOne=function(){_this.setState({stepOne:true,stepTwo:false,stepDone:false,stepError:false,modalTitle:'quantas estrelas este parceiro merece?',titleError:'Encontramos um problema ao salvar seu comentário.',rating:0,emptyRating:false,evaluateTitle:'',evaluateComment:''});};_this.goRate=function(){_this.setState({stepOne:true,stepTwo:true,modalTitle:'quantas estrelas este parceiro merece?'});};_this.onRating=function(e){_this.setState({rating:e&&e.rating,emptyRating:false});_this.goRate();};_this.onSend=function(){_this.setState({buttonDisabled:true});if(_this.state.rating===0){_this.setState({emptyRating:true,buttonDisabled:false});return false;}if(!_this.state.evaluateTitle){_this.setState({emptyTitle:true,buttonDisabled:false});return false;}if(!_this.state.evaluateComment){_this.setState({emptyComment:true,buttonDisabled:false});return false;}_this.props.createEvaluate(_this.state.evaluateTitle,_this.state.evaluateComment,_this.state.rating,_this.props.userId&&_this.props.userId.value,_this.props.name&&_this.props.name.value).then(function(result){if(result.data.message==='Avaliação salva com sucesso.'){_this.setState({stepOne:false,stepTwo:false,stepDone:true,modalTitle:'Obrigado por avaliar :)',buttonDisabled:false});}else if(result.data.message==='Avaliação já realizada'){_this.setState({stepOne:false,stepTwo:false,stepDone:true,stepError:true,modalTitle:'Avaliação já realizada',buttonDisabled:false,titleError:'Avaliação já registrada pelo participante para essa rede.'});}else{_this.setState({stepOne:false,stepTwo:false,stepDone:true,stepError:true,modalTitle:'OPS :(',buttonDisabled:false,titleError:'Encontramos um problema ao salvar seu comentário.'});}});};_this.onClose=function(){_this.setState({stepOne:true,stepTwo:false,stepDone:false,stepError:false,modalTitle:'quantas estrelas este parceiro merece?',rating:0,emptyRating:false,evaluateTitle:null,evaluateComment:null});_this.props.onClose();};_this.state={stepOne:true,stepTwo:false,stepDone:false,stepError:false,modalTitle:'quantas estrelas este parceiro merece?',titleError:'Encontramos um problema ao salvar seu comentário.',rating:0,emptyRating:false,emptyTitle:false,emptyComment:false,evaluateTitle:null,evaluateComment:null,buttonDisabled:false};return _this;}_createClass(ModalEvaluation,[{key:'stateOpinion',value:function stateOpinion(e){var value=e.target?String(e.target.value):null;if(value){this.setState({emptyTitle:false});}this.setState({evaluateTitle:value});}},{key:'stateComment',value:function stateComment(e){var value=e.target?String(e.target.value):null;if(value){this.setState({emptyComment:false});}this.setState({evaluateComment:value});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' modal-marker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'100%',height:'100%',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-md-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-rating col-auto mx-auto bg-white radius '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'py-half'},this.state.modalTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-scroll col-12 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx--1 mx-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepOne',className:'col-12 color-ui-2 txt-font-body txt-body-sm product-rating '+(!this.state.stepDone?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2'},'Que avalia\xE7\xE3o este produto merece?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 store-rating modal-rating-stars mx-0 '+(this.state.emptyRating&&'rating-empty')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rater___default.a,{id:'rater-modal-products',total:5,rating:this.state.rating,onRate:function onRate(e){return _this2.onRating(e);}})),this.state.emptyRating&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-error txt-subtitle'},'escolha uma avalia\xE7\xE3o para enviar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepTwo',className:'col-12 color-ui-2 txt-font-body txt-body-sm product-rating mt-2   '+(!this.state.stepTwo&&'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Escreva um coment\xE1rio sobre a sua experi\xEAncia com este produto.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-opinion',name:'txt-opinion',label:'T\xEDtulo da sua opini\xE3o',className:'form-field col-12 mb-2',childrenClassName:'has-content',onBlur:function onBlur(e){return _this2.stateOpinion(e);},'data-error':'Por favor, preencher o título.',valid:!this.state.emptyTitle?null:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-comment',name:'txt-comment',label:'Deixe um coment\xE1rio',className:'form-field col-12',childrenClassName:'has-content',onBlur:function onBlur(e){return _this2.stateComment(e);},'data-error':'Por favor, deixe um comentário.',valid:!this.state.emgptyComment?null:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepFinal',className:'col-12 color-ui-2 txt-font-body txt-body-sm product-rating mt-2 '+(!this.state.stepDone?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm pb-1 px-0'},!this.state.stepError?'Sua opinião é muito importante para nós, pois ela ajuda a melhorar sua experiência no Premmiar.':this.state.titleError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-rating-modal col-12',text:'cancelar',onClick:this.onClose,disabled:this.state.buttonDisabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half ml-auto'},!this.state.buttonDisabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-close-modal',name:'btn-close-modal',className:'btn btn-featured btn-rating-modal2 col-12',text:'enviar',onClick:this.onSend,disabled:this.state.buttonDisabled}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepDone',className:'col-12 modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0 mt-2 '+(this.state.stepDone||'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},!this.state.stepError?'Sua opinião é muito importante para nós, pois ela ajuda a melhorar sua experiência no Premmiar.':this.state.titleError),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-rating-modal col-12',text:'deixar outro coment\xE1rio',onClick:this.goToStepOne,disabled:this.state.buttonDisabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-close-modal',name:'btn-close-modal',className:'btn btn-featured btn-rating-modal2 col-12',text:'concluir',onClick:this.onClose,disabled:this.state.buttonDisabled}))))))))))));}}]);return ModalEvaluation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalEvaluation.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,createEvaluate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref,ownProps){var participant=_ref.participant;return{name:participant.name,userId:participant.cpf};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,null)(ModalEvaluation));

/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalReport__ = __webpack_require__(1870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalReport__["a"]; });


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalReport=function(_Component){_inherits(ModalReport,_Component);function ModalReport(){_classCallCheck(this,ModalReport);var _this=_possibleConstructorReturn(this,(ModalReport.__proto__||Object.getPrototypeOf(ModalReport)).call(this));_this.onSubmit=function(){_this.setState({buttonDisabled:true});_this.props.toReport(_this.props.email&&_this.props.email.value,_this.state.complainId,_this.state.complainComment).then(function(result){if(result.data.message==='Reclamação criada com sucesso, foi enviado um email com todas as informações sobre seu chamado.'){_this.setState({buttonDisabled:false});}else{_this.setState({buttonDisabled:false});}});};_this.state={complainId:null,complainComment:null,buttonDisabled:false};return _this;}_createClass(ModalReport,[{key:'selectComplain',value:function selectComplain(e){this.setState({complainId:e.idComplain||null});}},{key:'commentComplain',value:function commentComplain(e){this.setState({complainComment:e.target&&e.target.value||null});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' modal-marker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'100%',height:'100%',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-report col-auto mx-auto bg-white radius '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'py-half'},'algum problema com este an\xFAncio?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_help color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Preencha os campos abaixo para fazer a den\xFAncia.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.props.errorReportComplain?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm color-error'},'Ocorreu um erro! N\xE3o foi poss\xEDvel salvar.')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Select"],{id:'complain',label:'Motivo',className:'col-12 my-1',displayValue:'description',selectedValue:'idComplain',options:this.props.complain||[],placeholder:'Selecione','data-error':'Por favor, selecione o motivo.',onChange:function onChange(e){return _this2.selectComplain(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["TextArea"],{id:'txt-comment',name:'txt-comment',label:'Deixe um coment\xE1rio',className:'form-field col-12 my-1',childrenClassName:'has-content','data-error':'Por favor, deixe um comentário.',onBlur:function onBlur(e){return _this2.commentComplain(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-rating-modal col-12',text:'cancelar',onClick:this.props.ReportToggle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-md-auto ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-featured col-12',text:'enviar',onClick:this.onSubmit,disabled:!(this.props.email&&this.state.complainId&&this.state.complainComment)||this.state.buttonDisabled}))))))))));}}]);return ModalReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalReport.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,complain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,ReportToggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,toReport:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,errorReportComplain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref,ownProps){var participant=_ref.participant;return{email:participant.email};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,null)(ModalReport));

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants={};/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Store__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constantsStore__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// eslint-disable-next-line no-unused-vars
var StoreContainer=function(_Component){_inherits(StoreContainer,_Component);function StoreContainer(){_classCallCheck(this,StoreContainer);return _possibleConstructorReturn(this,(StoreContainer.__proto__||Object.getPrototypeOf(StoreContainer)).apply(this,arguments));}_createClass(StoreContainer,[{key:'render',value:function render(){var _props$match$params=this.props.match.params,company=_props$match$params.company,store=_props$match$params.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Store__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_2__constantsStore__["a" /* default */],{company:company,store:store}));}}]);return StoreContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreContainer.propTypes={match:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({company:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,store:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired})})};/* harmony default export */ __webpack_exports__["a"] = (StoreContainer);

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoreTabs__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_rater__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_rater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_rater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ModalEvaluationStore__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalReportStore__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_rater_lib_react_rater_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_rater_lib_react_rater_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_rater_lib_react_rater_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_tabs_style_react_tabs_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loyal_template_rating_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loyal_template_rating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__loyal_template_rating_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Store=function(_Component){_inherits(Store,_Component);function Store(props){var _this2=this;_classCallCheck(this,Store);var _this=_possibleConstructorReturn(this,(Store.__proto__||Object.getPrototypeOf(Store)).call(this,props));_this.handleVerifyToken=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].tokenVerify();case 2:case'end':return _context.stop();}}},_callee,_this2);}));_this.format=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(mask,number){var s,r,im,is;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:s=''+number;r='';for(im=0,is=0;im<mask.length&&is<s.length;im++){r+=mask.charAt(im)==='X'?s.charAt(is++):mask.charAt(im);}return _context2.abrupt('return',r);case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}();_this.handleGetUnity=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var resultUnity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getUnity(_this.props.company,_this.props.store);case 2:resultUnity=_context3.sent;if(resultUnity!=null){_this.setState(Object.assign({},_this.state,{isLoaded:true,unity:resultUnity.data.objectReturn}));}case 4:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleGetOffers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getOffers(_this.state.filter).then(function(resultOffers){if(resultOffers.data.objectReturn.data.length>0){var offers=resultOffers&&resultOffers.data.objectReturn&&resultOffers.data.objectReturn.data||[];_this.setState({offers:_this.state.offers.concat(offers),isLoading:false,NotFound:false});}else{_this.setState({hasMoreItems:false,isLoading:false});if(_this.state.offers.length>0){_this.setState({NotFound:false});}else{_this.setState({NotFound:true});}}}).catch(function(){return _this.setState({NotFound:false});});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.handleGetEvaluate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var items=arguments.length>0&&arguments[0]!==undefined?arguments[0]:5;var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var resultEvaluate,averageRating,numberOfRows,Evaluate,EvaluateItems;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getEvaluate(_this.props.company,items,page);case 2:resultEvaluate=_context5.sent;averageRating=resultEvaluate.data.objectReturn&&resultEvaluate.data.objectReturn.averageRating;numberOfRows=resultEvaluate.data.objectReturn&&resultEvaluate.data.objectReturn.numberOfRows;Evaluate={'averageRating':averageRating,'numberOfRows':numberOfRows};EvaluateItems=_this.state.EvaluateItems.concat(resultEvaluate.data.objectReturn.ratings);_this.setState({currentPage:_this.state.currentPage+1,Evaluate:Evaluate,EvaluateItems:EvaluateItems});return _context5.abrupt('return',resultEvaluate);case 9:case'end':return _context5.stop();}}},_callee5,_this2);}));_this.createEvaluate=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(EvaluateTitle,EvaluateComment,EvaluateRating,EvaluateName){var payload,resultEvaluate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:payload={'comment':EvaluateComment,'title':EvaluateTitle,'rating':EvaluateRating,'userId':_this.props.company,'participantIdentifier':EvaluateName};_context6.next=3;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].createEvaluate(payload);case 3:resultEvaluate=_context6.sent;_this.setState({EvaluateItems:[],Evaluate:{}});_this.handleGetEvaluate(5,1);return _context6.abrupt('return',resultEvaluate);case 7:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x5,_x6,_x7,_x8){return _ref6.apply(this,arguments);};}();_this.toReport=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(email,id,description){var payload,resultComplain;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:payload={'complainTypeId':id,'company':_this.state.unity.description,'description':description,'email':email,'userId':_this.props.company};_context7.next=3;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].createReportComplain(payload);case 3:resultComplain=_context7.sent;if(!(resultComplain&&resultComplain.data&&resultComplain.data.success)){_context7.next=9;break;}_this.ReportToggle();return _context7.abrupt('return',resultComplain);case 9:_this.setState({errorReportComplain:true});return _context7.abrupt('return',resultComplain);case 11:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x9,_x10,_x11){return _ref7.apply(this,arguments);};}();_this.handleGetComplain=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var resultComplain;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return __WEBPACK_IMPORTED_MODULE_7__Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getComplain();case 2:resultComplain=_context8.sent;_this.setState({complain:resultComplain&&resultComplain.data.objectReturn});case 4:case'end':return _context8.stop();}}},_callee8,_this2);}));_this.state={copied:false,modalGoLink:false,hasMoreItems:true,NotFound:false,onClose:false,unity:null,isLoaded:false,currentPage:0,onReportToggle:false,complain:{},errorReportComplain:false,Evaluate:{},EvaluateItems:[],offers:[],filter:{pagination:{pageSize:8,pageNumber:1},filter:{storeIds:[_this.props.store],geoNear:{maxDistance:500000,location:{latitude:-23.4945212,longitude:-46.7066441}}}}};_this.onCopy=_this.onCopy.bind(_this);_this.modalGoLink=_this.modalGoLink.bind(_this);_this.onRating=_this.onRating.bind(_this);_this.ReportToggle=_this.ReportToggle.bind(_this);_this.handleGetEvaluate=_this.handleGetEvaluate.bind(_this);_this.createEvaluate=_this.createEvaluate.bind(_this);_this.loadItems=_this.loadItems.bind(_this);return _this;}_createClass(Store,[{key:'componentDidMount',value:function componentDidMount(){this.handleVerifyToken();this.handleGetUnity();this.handleGetComplain();this.handleGetEvaluate(5,1);this.handleGetOffers();}},{key:'loadItems',value:function loadItems(){var _this3=this;if(!this.state.isLoading){var pagination={pageSize:8,pageNumber:this.state.filter.pagination.pageNumber+1};var payload={'pagination':pagination,'filter':this.state.filter.filter};this.setState({filter:payload});this.handleGetOffers().catch(function(){return _this3.setState({NotFound:false});});}}},{key:'onCopy',value:function onCopy(){var _this4=this;this.setState({copied:true});setTimeout(function(){_this4.setState({copied:false});_this4.modalGoLink();},1000);}},{key:'modalGoLink',value:function modalGoLink(){this.setState({modalGoLink:!this.state.modalGoLink});}},{key:'onRating',value:function onRating(){this.setState({onClose:!this.state.onClose});}},{key:'ReportToggle',value:function ReportToggle(){this.setState({onReportToggle:!this.state.onReportToggle});}},{key:'render',value:function render(){var props=this.props;return this.state.isLoaded===false?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-bairro container pt-5 pb-3 ','data-sku':props.company},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-side col-12 col-md-7 pr-0 pl-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white pt-1 pt-md-3 pos-relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-image overflow voucher txt-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_image_fallback___default.a,{src:this.state.unity.imageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_4__loyal_images_products_product_placeholder_png___default.a,alt:props.name,className:'mx-auto'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minDeviceWidth:768},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StoreTabs__["a" /* default */],{description:this.state.unity.descriptionChain,evaluate:this.state.Evaluate,evaluateItems:this.state.EvaluateItems,onRating:this.onRating,handleGetEvaluate:this.handleGetEvaluate,currentPage:this.state.currentPage,offers:this.state.offers,loadItems:this.loadItems,hasMoreItems:this.state.hasMoreItems,NotFound:this.state.NotFound})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-side col-12 col-lg-5  mt-4 mt-lg-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-infos col-12 py-2 px-3 mx-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body color-featured mb-1 txt-lowercase'},this.state.unity.category),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'color-title'},this.state.unity.fantasyName,' - ',this.state.unity.description),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm'},this.state.unity.address.city,'/',this.state.unity.address.state),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center mt-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto product-rating'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,this.state.Evaluate.averageRating))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto product-rating px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_rater___default.a,{total:5,rating:Math.round(this.state.Evaluate.averageRating),interactive:false}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto product-rating'},this.state.Evaluate===undefined?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm'},'Nenhuma avalia\xE7\xE3o'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm'},this.state.Evaluate.numberOfRows>1?this.state.Evaluate.numberOfRows+' avaliações':this.state.Evaluate.numberOfRows+' avaliação')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-info col-12 border-color-ui-3 border-bottom border-top px-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row py-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-2'},this.state.unity.urlECommerce&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_translate'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'site')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.urlECommerce))))),this.state.unity.phone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_phone'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'telefone')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.phone.length===12?this.state.unity.phone.replace(/^(\d{2})(\d{4})(\d{4})$/g,'($1) $2-$3'):this.state.unity.whatsApp.replace(/^(\d{2})(\d{5})(\d{4})$/g,'($1) $2-$3')))))),this.state.unity.whatsApp&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_whatsapp'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'whatsapp')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'https://api.whatsapp.com/send?phone=55'+this.state.unity.whatsApp},this.state.unity.whatsApp.replace(/^(\d{2})(\d{5})(\d{4})$/g,'($1) $2-$3'))))))),this.state.unity.instagram&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_instagram'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'instagram')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.instagram))))),this.state.unity.address.zipCode&&this.state.unity.address.street&&this.state.unity.address.city&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bairro-contact-item row mx-0 align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_location'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-subtitle color-ui-2'},'endere\xE7o')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.address.street,', ',this.state.unity.address.number,' - ',this.state.unity.address.neighborhood),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm color-ui-1'},this.state.unity.address.city,' - ',this.state.unity.address.state,' - ',this.state.unity.address.zipCode.replace(/^(\d{5})(\d{3})$/g,'$1-$2')))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center bg-ui-4 border-top border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-2 py-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'txt-body-sm mBairro'},'Caso tenha algum problema com este an\xFAncio e queira denunci\xE1-lo ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'txt-body-sm cursor color-featured',onClick:this.ReportToggle},'clique aqui'),'.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{maxDeviceWidth:767},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StoreTabs__["a" /* default */],{description:this.state.unity.descriptionChain,onRating:this.onRating,evaluate:this.state.unity.evaluate,evaluateItems:this.state.EvaluateItems,handleGetEvaluate:this.handleGetEvaluate,currentPage:this.state.currentPage,offers:this.state.offers,loadItems:this.loadItems,hasMoreItems:this.state.hasMoreItems,NotFound:this.state.NotFound})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:' modal-marker'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_awesome_modal___default.a,{width:'100%',height:'100%',effect:'fadeInUp',visible:this.state.modalGoLink},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-copy-and-go col-auto mx-auto bg-white radius '},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'py-half'},'voc\xEA ser\xE1 enviado ao site do nosso parceiro')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon_card color-brand-1'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'n\xE3o esque\xE7a de realizar a compra com o seu Itaucard para garantir o desconto.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn',onClick:this.modalGoLink},'Cancelar')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-featured'},'Ir para o site')))))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalReportStore__["a" /* ModalReportStore */],{show:this.state.onReportToggle,ReportToggle:this.ReportToggle,toReport:this.toReport,complain:this.state.complain,errorReportComplain:this.state.errorReportComplain}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ModalEvaluationStore__["a" /* ModalEvaluationStore */],{show:this.state.onClose,onClose:this.onRating,createEvaluate:this.createEvaluate}));}}]);return Store;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Store.propTypes={company:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,store:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Store);

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Card_CardOferta__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_rater__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_rater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_rater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_rater_lib_react_rater_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_rater_lib_react_rater_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_rater_lib_react_rater_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tabs_style_react_tabs_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_template_rating_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loyal_template_rating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__loyal_template_rating_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_template_storerating_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loyal_template_storerating_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__loyal_template_storerating_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreTabs=function(_Component){_inherits(StoreTabs,_Component);function StoreTabs(){_classCallCheck(this,StoreTabs);return _possibleConstructorReturn(this,(StoreTabs.__proto__||Object.getPrototypeOf(StoreTabs)).apply(this,arguments));}_createClass(StoreTabs,[{key:'render',value:function render(){var _this2=this;var _props$evaluate=this.props.evaluate,averageRating=_props$evaluate.averageRating,numberOfRows=_props$evaluate.numberOfRows;var evaluateItems=this.props.evaluateItems;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["d" /* Tabs */],{defaultIndex:0,className:'product-tabs border-color-ui-3 mt-0 mt-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs-area draggable border-color-ui-3 border-bottom px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'draggable-item d-inline-block px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["b" /* TabList */],{className:'tabs-item py-3 px-0 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-lowercase txt-body color-ui-3'},'Ofertas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["a" /* Tab */],{className:'item-button pos-relative d-inline-block px-2 txt-circular-black txt-lowercase txt-body color-ui-3'},'Avalia\xE7\xF5es')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},!this.props.NotFound?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:this.props.loadItems,hasMore:this.props.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.props.offers&&this.props.offers.map(function(product,ix){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Card_CardOferta__["a" /* default */],Object.assign({},product,{offer:product,key:ix,location:false}));}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* EmptyOffers */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["c" /* TabPanel */],{className:'tabeffect row px-2 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 product-rating-tablets'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'txt-headline'},averageRating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_rater___default.a,{total:5,rating:Math.round(averageRating),interactive:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'m\xE9dia de ',numberOfRows>1?numberOfRows+' avaliações':numberOfRows+' avaliação')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-auto product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'openRatingModal',name:'openRatingModal',className:'btn btn-rating-modal col-12 col-md-12 px-3',text:'Avaliar',onClick:this.props.onRating})))),evaluateItems&&evaluateItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'col-12 border-color-ui-3 border-top pt-3 mt-3 mb-3 product-rating'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_rater___default.a,{total:5,rating:item.rating,interactive:false}),' ',item.participantName||'',' - ',__WEBPACK_IMPORTED_MODULE_7_moment___default()(item.createDate).format('DD/MM/YYYY')||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 d-none d-md-block px-md-1 px-2 my-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book '},item.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 py-md-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},item.comment))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-top border-top-dotted border-color-ui-3 pt-3 pb-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cursor txt-left px-0 pt-1 txt-font-body color-brand-1 txt-body',onClick:function onClick(){return _this2.props.handleGetEvaluate(5,_this2.props.currentPage+1);}},'Ver mais avalia\xE7\xF5es'))))));}}]);return StoreTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreTabs.propTypes={offers:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onRating:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,evaluate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,evaluateItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,handleGetEvaluate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,loadItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,NotFound:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,hasMoreItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (StoreTabs);

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalEvaluationStore__ = __webpack_require__(1876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalEvaluationStore__["a"]; });


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rater__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_rater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_rater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalEvaluationStore=function(_Component){_inherits(ModalEvaluationStore,_Component);function ModalEvaluationStore(){_classCallCheck(this,ModalEvaluationStore);var _this=_possibleConstructorReturn(this,(ModalEvaluationStore.__proto__||Object.getPrototypeOf(ModalEvaluationStore)).call(this));_this.goToStepOne=function(){_this.setState({stepOne:true,stepTwo:false,stepDone:false,stepError:false,modalTitle:'quantas estrelas este parceiro merece?',titleError:'Encontramos um problema ao salvar seu comentário.',rating:0,emptyRating:false,evaluateTitle:'',evaluateComment:'',buttonDisabled:false});};_this.goRate=function(){_this.setState({stepOne:true,stepTwo:true,modalTitle:'quantas estrelas este parceiro merece?',buttonDisabled:false});};_this.onRating=function(e){_this.setState({rating:e&&e.rating,emptyRating:false,buttonDisabled:false});_this.goRate();};_this.onSend=function(){_this.setState({buttonDisabled:true});if(_this.state.rating===0){_this.setState({emptyRating:true,buttonDisabled:false});return false;}if(!_this.state.evaluateTitle){_this.setState({emptyTitle:true,buttonDisabled:false});return false;}if(!_this.state.evaluateComment){_this.setState({emptyComment:true,buttonDisabled:false});return false;}_this.props.createEvaluate(_this.state.evaluateTitle,_this.state.evaluateComment,_this.state.rating,_this.props.userId&&_this.props.userId.value,_this.props.name&&_this.props.name.value).then(function(result){if(result.data.message==='Avaliação salva com sucesso.'){_this.setState({stepOne:false,stepTwo:false,stepDone:true,modalTitle:'Obrigado por avaliar :)',buttonDisabled:false});}else if(result.data.message==='Avaliação já realizada'){_this.setState({stepOne:false,stepTwo:false,stepDone:true,stepError:true,modalTitle:'Avaliação já realizada',buttonDisabled:false,titleError:'Avaliação já registrada pelo participante para essa rede.'});}else{_this.setState({stepOne:false,stepTwo:false,stepDone:true,stepError:true,modalTitle:'OPS :(',buttonDisabled:false,titleError:'Encontramos um problema ao salvar seu comentário.'});}});};_this.onClose=function(){_this.setState({stepOne:true,stepTwo:false,stepDone:false,stepError:false,modalTitle:'quantas estrelas este parceiro merece?',rating:0,emptyRating:false,evaluateTitle:null,evaluateComment:null,buttonDisabled:false});_this.props.onClose();};_this.state={stepOne:true,stepTwo:false,stepDone:false,stepError:false,modalTitle:'quantas estrelas este parceiro merece?',titleError:'Encontramos um problema ao salvar seu comentário.',rating:0,emptyRating:false,emptyTitle:false,emptyComment:false,evaluateTitle:null,evaluateComment:null,buttonDisabled:false};return _this;}_createClass(ModalEvaluationStore,[{key:'stateOpinion',value:function stateOpinion(e){var value=e.target?String(e.target.value):null;if(value){this.setState({emptyTitle:false});}this.setState({evaluateTitle:value});}},{key:'stateComment',value:function stateComment(e){var value=e.target?String(e.target.value):null;if(value){this.setState({emptyComment:false});}this.setState({evaluateComment:value});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' modal-marker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'100%',height:'100%',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-md-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-rating col-auto mx-auto bg-white radius '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'py-half'},this.state.modalTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-scroll col-12 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx--1 mx-md-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepOne',className:'col-12 color-ui-2 txt-font-body txt-body-sm product-rating '+(!this.state.stepDone?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm pb-2'},'Que avalia\xE7\xE3o este produto merece?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 store-rating modal-rating-stars mx-0 '+(this.state.emptyRating&&'rating-empty')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_rater___default.a,{id:'rater-modal-products',total:5,rating:this.state.rating,onRate:function onRate(e){return _this2.onRating(e);}})),this.state.emptyRating&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-error txt-subtitle'},'escolha uma avalia\xE7\xE3o para enviar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepTwo',className:'col-12 color-ui-2 txt-font-body txt-body-sm product-rating mt-2   '+(!this.state.stepTwo&&'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Escreva um coment\xE1rio sobre a sua experi\xEAncia com este produto.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-opinion',name:'txt-opinion',label:'T\xEDtulo da sua opini\xE3o',className:'form-field col-12 mb-2',childrenClassName:'has-content',onBlur:function onBlur(e){return _this2.stateOpinion(e);},'data-error':'Por favor, preencher o título.',valid:!this.state.emptyTitle?null:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Input"],{id:'txt-comment',name:'txt-comment',label:'Deixe um coment\xE1rio',className:'form-field col-12',childrenClassName:'has-content',onBlur:function onBlur(e){return _this2.stateComment(e);},'data-error':'Por favor, deixe um comentário.',valid:!this.state.emptyComment?null:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepFinal',className:'col-12 color-ui-2 txt-font-body txt-body-sm product-rating mt-2 '+(!this.state.stepDone?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm pb-1 px-0'},!this.state.stepError?'Sua opinião é muito importante para nós, pois ela ajuda a melhorar sua experiência no Premmiar.':this.state.titleError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-rating-modal col-12',text:'cancelar',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-close-modal',name:'btn-close-modal',className:'btn btn-featured btn-rating-modal2 col-12',text:'enviar',onClick:this.onSend,disabled:this.state.buttonDisabled})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'stepDone',className:'col-12 modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0 mt-2 '+(this.state.stepDone||'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},!this.state.stepError?'Sua opinião é muito importante para nós, pois ela ajuda a melhorar sua experiência no Premmiar.':this.state.titleError),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-rating-modal col-12',text:'deixar outro coment\xE1rio',onClick:this.goToStepOne})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-close-modal',name:'btn-close-modal',className:'btn btn-featured btn-rating-modal2 col-12',text:'concluir',onClick:this.onClose}))))))))))));}}]);return ModalEvaluationStore;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalEvaluationStore.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,createEvaluate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,userId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref,ownProps){var participant=_ref.participant;return{name:participant.name,userId:participant.cpf};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,null)(ModalEvaluationStore));

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalReportStore__ = __webpack_require__(1878);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalReportStore__["a"]; });


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalReportStore=function(_Component){_inherits(ModalReportStore,_Component);function ModalReportStore(){_classCallCheck(this,ModalReportStore);var _this=_possibleConstructorReturn(this,(ModalReportStore.__proto__||Object.getPrototypeOf(ModalReportStore)).call(this));_this.onSubmit=function(){_this.setState({buttonDisabled:true});_this.props.toReport(_this.props.email&&_this.props.email.value,_this.state.complainId,_this.state.complainComment).then(function(result){if(result.data.message==='Reclamação criada com sucesso, foi enviado um email com todas as informações sobre seu chamado.'){_this.setState({buttonDisabled:false});}else{_this.setState({buttonDisabled:false});}});};_this.state={complainId:null,complainComment:null,buttonDisabled:false};return _this;}_createClass(ModalReportStore,[{key:'selectComplain',value:function selectComplain(e){this.setState({complainId:e.idComplain||null});}},{key:'commentComplain',value:function commentComplain(e){this.setState({complainComment:e.target&&e.target.value||null});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' modal-marker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'100%',height:'100%',effect:'fadeInUp',visible:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-report col-auto mx-auto bg-white radius '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2 border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'py-half'},'algum problema com este an\xFAncio?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_help color-brand-1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Preencha os campos abaixo para fazer a den\xFAncia.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-11 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.props.errorReportComplain?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm color-error'},'Ocorreu um erro! N\xE3o foi poss\xEDvel salvar.')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Select"],{id:'complain',label:'Motivo',className:'col-12 my-1',displayValue:'description',selectedValue:'idComplain',options:this.props.complain||[],placeholder:'Selecione','data-error':'Por favor, selecione o motivo.',onChange:function onChange(e){return _this2.selectComplain(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["TextArea"],{id:'txt-comment',name:'txt-comment',label:'Deixe um coment\xE1rio',className:'form-field col-12 my-1',childrenClassName:'has-content','data-error':'Por favor, deixe um comentário.',onBlur:function onBlur(e){return _this2.commentComplain(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 my-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-rating-modal col-12',text:'cancelar',onClick:this.props.ReportToggle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-md-auto ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'btn-back-rating',name:'btn-back-rating',className:'btn btn-featured col-12',text:'enviar',onClick:this.onSubmit,disabled:!(this.props.email&&this.state.complainId&&this.state.complainComment)||this.state.buttonDisabled}))))))))));}}]);return ModalReportStore;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModalReportStore.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,complain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,ReportToggle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,toReport:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,errorReportComplain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref,ownProps){var participant=_ref.participant;return{email:participant.email};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps,null)(ModalReportStore));

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constantsStore={};/* harmony default export */ __webpack_exports__["a"] = (constantsStore);

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_CardOferta__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Search=function(_Component){_inherits(Search,_Component);function Search(props){var _this2=this;_classCallCheck(this,Search);var _this=_possibleConstructorReturn(this,(Search.__proto__||Object.getPrototypeOf(Search)).call(this));_this.setFilterByQueryString=function(){var queryStringLocation=_this.props.location&&_this.props.location.search.replace('?','');var _queryString$parse=__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.parse(queryStringLocation),zipcode=_queryString$parse.zipcode,category=_queryString$parse.category,sort=_queryString$parse.sort;category=category&&[category];var mustFetch=true;var mustChangeUrl=false;_this.setFilter(zipcode,category,sort,mustChangeUrl,mustFetch);};_this.handleLocation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filterSelected){var selecteds,resultLocation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:selecteds=filterSelected||_this.state.filterSelected;if(!(selecteds.zipcode&&selecteds.zipcode.length>0)){_context.next=8;break;}_context.next=4;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getLocation(selecteds.zipcode);case 4:resultLocation=_context.sent;_this.setState({locationActive:true,Location:resultLocation});_context.next=9;break;case 8:_this.setState({Location:{}});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleFilterChanged=function(filterType){var mustFetch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(e){var filterValue=void 0;var filterAction='update';var tagType=e.target?String(e.target.type):'';switch(tagType){case'checkbox':{filterValue=e.target.value;filterAction=e.target.checked?'add':'remove';break;}case'text':{filterValue=e.target.value;break;}default:{if(e.target){filterAction=e.target.getAttribute('action');filterValue=e.target.getAttribute('value');}break;}}filterAction=filterAction||'update';filterValue=filterValue||e;var _this$state$filterSel=_this.state.filterSelected,zipcode=_this$state$filterSel.zipcode,category=_this$state$filterSel.category,sort=_this$state$filterSel.sort;switch(filterType){case'category':{category=filterAction==='remove'?'':[filterValue];break;}case'sort':{sort=filterAction==='remove'?'':[filterValue];_this.handleOrdination(sort);break;}case'zipcode':{zipcode=filterAction==='remove'?'':[filterValue.replace('-','')];break;}}var mustChangeUrl=true;_this.setFilter(zipcode,category,sort,mustChangeUrl,mustFetch);};};_this.setFilter=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(zipcode,category,sort,mustChangeUrl,mustFetch){var filterSelected,pagination,geoNear,location,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:filterSelected={zipcode:zipcode,category:category,sort:sort};if(mustChangeUrl){_this.setQueryString(filterSelected);}_this.setState({filterSelected:filterSelected});if(!mustFetch){_context2.next=18;break;}pagination={pageSize:9,pageNumber:1};geoNear={};if(window.sessionStorage.getItem('lat')&&window.sessionStorage.getItem('lng')){_this.setState({locationActive:true});geoNear={maxDistance:500000,location:{latitude:window.sessionStorage.getItem('lat'),longitude:window.sessionStorage.getItem('lng')}};}if(!filterSelected.zipcode){_context2.next=14;break;}_context2.next=10;return _this.handleLocation(filterSelected);case 10:location=_this.state.Location&&_this.state.Location.data&&_this.state.Location.data.objectReturn&&_this.state.Location.data.objectReturn.location;geoNear={maxDistance:500000,location:{latitude:location&&location.lat,longitude:location&&location.lng}};_context2.next=15;break;case 14:if(!window.sessionStorage.getItem('lat')&&!window.sessionStorage.getItem('lng')){_this.setState({locationActive:true});}case 15:payload={pagination:pagination,filter:{advertisementType:[0],chain:{categories:filterSelected.category},geoNear:geoNear}};_this.setState({offers:[],filter:payload,isLoading:true});setTimeout(function(){_this.handleGetOffers();},1000);case 18:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3,_x4,_x5,_x6,_x7){return _ref2.apply(this,arguments);};}();_this.setQueryString=function(filterSelected){var filterQueryString='';Object.keys(filterSelected).map(function(key){var filterQS=filterSelected[key];if(filterQS!==undefined&&filterQS.toString()!==''){filterQueryString+=(filterQueryString?'&':'')+key+'='+filterQS.toString();}});var urlChanged=window.location.protocol+'//'+window.location.host+window.location.pathname+'?'+filterQueryString;window.history.pushState({path:urlChanged},'',urlChanged);};_this.handleFilter=function(){_this.setState({condition:!_this.state.condition});};_this.handleVerifyToken=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].tokenVerify();case 2:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleGetOffers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getOffers(_this.state.filter).then(function(resultOffers){if(resultOffers.data.objectReturn.data.length>0){var offers=resultOffers&&resultOffers.data.objectReturn&&resultOffers.data.objectReturn.data||[];_this.setState({offers:_this.state.offers.concat(offers),isLoading:false,NotFound:false});}else{_this.setState({hasMoreItems:false,isLoading:false});if(_this.state.offers.length>0){_this.setState({NotFound:false});}else{_this.setState({NotFound:true});}}}).catch(function(){return _this.setState({NotFound:false});});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.handleGetCategories=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var resultCategories;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getCategories();case 2:resultCategories=_context5.sent;_this.setState({categories:resultCategories&&resultCategories.data.objectReturn});case 4:case'end':return _context5.stop();}}},_callee5,_this2);}));_this.state={showZipCode:true,locationActive:true,condition:false,NotFound:false,isLoading:false,filterSelected:{},hasMoreItems:true,Location:null,ordination:{DISTANCE:false,HIGHERDISCOUNTS:false},offers:[],filter:{pagination:{pageSize:9,pageNumber:1},filter:{chain:{ids:[]},advertisementType:[0],geoNear:{maxDistance:500000,location:{latitude:0,longitude:0}}}}};_this.loadItems=_this.loadItems.bind(_this);return _this;}_createClass(Search,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;this.handleVerifyToken();this.handleGetCategories();setTimeout(function(){_this3.setFilterByQueryString();},300);}},{key:'handleOrdination',value:function handleOrdination(type){switch(type){case'DISTANCE':this.setState({ordination:{DISTANCE:true,HIGHERDISCOUNTS:false}});break;case'HIGHERDISCOUNTS':this.setState({ordination:{DISTANCE:false,HIGHERDISCOUNTS:true}});break;default:this.setState({ordination:{DISTANCE:false,HIGHERDISCOUNTS:false}});break;}}},{key:'loadItems',value:function loadItems(){var _this4=this;if(!this.state.isLoading){var pagination={pageSize:9,pageNumber:this.state.filter.pagination.pageNumber+1};var payload={pagination:pagination,filter:this.state.filter.filter};this.setState({filter:payload});this.handleGetOffers().catch(function(){return _this4.setState({NotFound:false});});}}},{key:'render',value:function render(){var _this5=this;var productList=this.state.offers;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'showcase-lazy container-fluid showcase'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 pt-4 pt-sm-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-results col-12 pb-2 py-md-2 d-flex d-md-flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row w-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'txt-font-body color-title pb-half'},'comunidade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,productList?productList.length:'xx'),' ','oferta(s) encontrada(s)')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-voltar-mobile',name:'BUTTON',text:'Voltar',iconName:'icon_left icon-sm',className:'col-12 btn-sm',onClick:this.handleFilter})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(!this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-filtrar-mobile',name:'BUTTON',text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm ',onClick:this.handleFilter})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["h" /* Sidebar */],{categories:this.state.categories||[],handleFilterChanged:this.handleFilterChanged,filterSelected:this.state.filterSelected,pageType:'search',isLoading:this.state.isLoading,ordination:this.state.ordination,showZipCode:this.state.showZipCode,term:this.state.term,className:''+(this.state.condition?'d-block d-md-block':'d-none d-md-block')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 '+(!this.state.condition?'d-block d-md-block':'d-none d-md-block')},!this.state.NotFound?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:this.loadItems,hasMore:this.state.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},productList&&productList.map(function(product,ix){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Card_CardOferta__["a" /* default */],Object.assign({},product,{key:ix,offer:product,location:_this5.state.locationActive}));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* NotFound */],null)))));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Search.propTypes={match:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({sku:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired})}),location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref6){var router=_ref6.router;return{location:router&&router.location};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(Search));

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_CardOferta__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchEcommerce=function(_Component){_inherits(SearchEcommerce,_Component);function SearchEcommerce(props){var _this2=this;_classCallCheck(this,SearchEcommerce);var _this=_possibleConstructorReturn(this,(SearchEcommerce.__proto__||Object.getPrototypeOf(SearchEcommerce)).call(this));_this.setFilterByQueryString=function(){var queryStringLocation=_this.props.location&&_this.props.location.search.replace('?','');var _queryString$parse=__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.parse(queryStringLocation),zipcode=_queryString$parse.zipcode,category=_queryString$parse.category,sort=_queryString$parse.sort;category=category&&[category];var mustFetch=true;var mustChangeUrl=false;_this.setFilter(zipcode,category,sort,mustChangeUrl,mustFetch);};_this.handleLocation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filterSelected){var selecteds,resultLocation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:selecteds=filterSelected||_this.state.filterSelected;if(!(selecteds.zipcode&&selecteds.zipcode.length>0)){_context.next=8;break;}_context.next=4;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getLocation(selecteds.zipcode);case 4:resultLocation=_context.sent;_this.setState({locationActive:false,Location:resultLocation});_context.next=9;break;case 8:_this.setState({Location:{}});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleFilterChanged=function(filterType){var mustFetch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(e){var filterValue=void 0;var filterAction='update';var tagType=e.target?String(e.target.type):'';switch(tagType){case'checkbox':{filterValue=e.target.value;filterAction=e.target.checked?'add':'remove';break;}case'text':{filterValue=e.target.value;break;}default:{if(e.target){filterAction=e.target.getAttribute('action');filterValue=e.target.getAttribute('value');}break;}}filterAction=filterAction||'update';filterValue=filterValue||e;var _this$state$filterSel=_this.state.filterSelected,zipcode=_this$state$filterSel.zipcode,category=_this$state$filterSel.category,sort=_this$state$filterSel.sort;switch(filterType){case'category':{category=filterAction==='remove'?'':[filterValue];break;}case'sort':{sort=filterAction==='remove'?'':[filterValue];_this.handleOrdination(sort);break;}case'zipcode':{zipcode=filterAction==='remove'?'':[filterValue.replace('-','')];break;}}var mustChangeUrl=true;_this.setFilter(zipcode,category,sort,mustChangeUrl,mustFetch);};};_this.setFilter=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(zipcode,category,sort,mustChangeUrl,mustFetch){var filterSelected,pagination,geoNear,location,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:filterSelected={zipcode:zipcode,category:category,sort:sort};if(mustChangeUrl){_this.setQueryString(filterSelected);}_this.setState({filterSelected:filterSelected});if(!mustFetch){_context2.next=18;break;}pagination={pageSize:9,pageNumber:1};geoNear={};if(window.sessionStorage.getItem('lat')&&window.sessionStorage.getItem('lng')){_this.setState({locationActive:false});geoNear={maxDistance:500000,location:{latitude:window.sessionStorage.getItem('lat'),longitude:window.sessionStorage.getItem('lng')}};}if(!filterSelected.zipcode){_context2.next=14;break;}_context2.next=10;return _this.handleLocation(filterSelected);case 10:location=_this.state.Location&&_this.state.Location.data&&_this.state.Location.data.objectReturn&&_this.state.Location.data.objectReturn.location;geoNear={maxDistance:500000,location:{latitude:location&&location.lat,longitude:location&&location.lng}};_context2.next=15;break;case 14:if(!window.sessionStorage.getItem('lat')&&!window.sessionStorage.getItem('lng')){_this.setState({locationActive:false});}case 15:payload={pagination:pagination,filter:{advertisementType:[1],chain:{categories:filterSelected.category},geoNear:geoNear}};_this.setState({offers:[],filter:payload,isLoading:true});setTimeout(function(){_this.handleGetOffers();},1000);case 18:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3,_x4,_x5,_x6,_x7){return _ref2.apply(this,arguments);};}();_this.setQueryString=function(filterSelected){var filterQueryString='';Object.keys(filterSelected).map(function(key){var filterQS=filterSelected[key];if(filterQS!==undefined&&filterQS.toString()!==''){filterQueryString+=(filterQueryString?'&':'')+key+'='+filterQS.toString();}});var urlChanged=window.location.protocol+'//'+window.location.host+window.location.pathname+'?'+filterQueryString;window.history.pushState({path:urlChanged},'',urlChanged);};_this.handleFilter=function(){_this.setState({condition:!_this.state.condition});};_this.handleVerifyToken=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].tokenVerify();case 2:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleGetOffers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getOffers(_this.state.filter).then(function(resultOffers){if(resultOffers.data.objectReturn.data.length>0){var offers=resultOffers&&resultOffers.data.objectReturn&&resultOffers.data.objectReturn.data||[];_this.setState({offers:_this.state.offers.concat(offers),isLoading:false,NotFound:false});}else{_this.setState({hasMoreItems:false,isLoading:false});if(_this.state.offers.length>0){_this.setState({NotFound:false});}else{_this.setState({NotFound:true});}}}).catch(function(){return _this.setState({NotFound:false});});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.handleGetCategories=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var resultCategories;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getCategories();case 2:resultCategories=_context5.sent;_this.setState({categories:resultCategories&&resultCategories.data.objectReturn});case 4:case'end':return _context5.stop();}}},_callee5,_this2);}));_this.state={showZipCode:false,locationActive:false,condition:false,NotFound:false,isLoading:false,filterSelected:{},hasMoreItems:true,Location:null,ordination:{DISTANCE:false,HIGHERDISCOUNTS:false},offers:[],filter:{pagination:{pageSize:9,pageNumber:1},filter:{chain:{ids:[]},advertisementType:[1],geoNear:{maxDistance:500000,location:{latitude:0,longitude:0}}}}};_this.loadItems=_this.loadItems.bind(_this);return _this;}_createClass(SearchEcommerce,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;this.handleVerifyToken();this.handleGetCategories();setTimeout(function(){_this3.setFilterByQueryString();},300);}},{key:'handleOrdination',value:function handleOrdination(type){switch(type){case'DISTANCE':this.setState({ordination:{DISTANCE:true,HIGHERDISCOUNTS:false}});break;case'HIGHERDISCOUNTS':this.setState({ordination:{DISTANCE:false,HIGHERDISCOUNTS:true}});break;default:this.setState({ordination:{DISTANCE:false,HIGHERDISCOUNTS:false}});break;}}},{key:'loadItems',value:function loadItems(){var _this4=this;if(!this.state.isLoading){var pagination={pageSize:9,pageNumber:this.state.filter.pagination.pageNumber+1};var payload={pagination:pagination,filter:this.state.filter.filter};this.setState({filter:payload});this.handleGetOffers().catch(function(){return _this4.setState({NotFound:false});});}}},{key:'render',value:function render(){var productList=this.state.offers;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'showcase-lazy container-fluid showcase'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 pt-4 pt-sm-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-results col-12 pb-2 py-md-2 d-flex d-md-flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row w-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'txt-font-body color-title pb-half'},'comunidade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,productList?productList.length:'xx'),' ','oferta(s) eCommerce encontrada(s)')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-voltar-mobile',name:'BUTTON',text:'Voltar',iconName:'icon_left icon-sm',className:'col-12 btn-sm',onClick:this.handleFilter})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(!this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-filtrar-mobile',name:'BUTTON',text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm ',onClick:this.handleFilter})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["h" /* Sidebar */],{categories:this.state.categories||[],handleFilterChanged:this.handleFilterChanged,filterSelected:this.state.filterSelected,pageType:'search',isLoading:this.state.isLoading,ordination:this.state.ordination,showZipCode:this.state.showZipCode,term:this.state.term,className:''+(this.state.condition?'d-block d-md-block':'d-none d-md-block')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 '+(!this.state.condition?'d-block d-md-block':'d-none d-md-block')},!this.state.NotFound?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:this.loadItems,hasMore:this.state.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},productList&&productList.map(function(product,ix){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Card_CardOferta__["a" /* default */],Object.assign({},product,{key:ix,offer:product,location:false}));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* NotFound */],null)))));}}]);return SearchEcommerce;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SearchEcommerce.propTypes={match:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({sku:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired})}),location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref6){var router=_ref6.router;return{location:router&&router.location};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(SearchEcommerce));

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_CardStore__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchStore=function(_Component){_inherits(SearchStore,_Component);function SearchStore(props){var _this2=this;_classCallCheck(this,SearchStore);var _this=_possibleConstructorReturn(this,(SearchStore.__proto__||Object.getPrototypeOf(SearchStore)).call(this));_this.setFilterByQueryString=function(){var queryStringLocation=_this.props.location&&_this.props.location.search.replace('?','');var _queryString$parse=__WEBPACK_IMPORTED_MODULE_8_query_string___default.a.parse(queryStringLocation),zipcode=_queryString$parse.zipcode,category=_queryString$parse.category,sort=_queryString$parse.sort;category=category&&[category];var mustFetch=true;var mustChangeUrl=false;_this.setFilter(zipcode,category,sort,mustChangeUrl,mustFetch);};_this.handleLocation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filterSelected){var selecteds,resultLocation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:selecteds=filterSelected||_this.state.filterSelected;if(!(selecteds.zipcode&&selecteds.zipcode.length>0)){_context.next=8;break;}_context.next=4;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getLocation(selecteds.zipcode);case 4:resultLocation=_context.sent;_this.setState({locationActive:true,Location:resultLocation});_context.next=9;break;case 8:_this.setState({Location:{}});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleFilterChanged=function(filterType){var mustFetch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(e){var filterValue=void 0;var filterAction='update';var tagType=e.target?String(e.target.type):'';switch(tagType){case'checkbox':{filterValue=e.target.value;filterAction=e.target.checked?'add':'remove';break;}case'text':{filterValue=e.target.value;break;}default:{if(e.target){filterAction=e.target.getAttribute('action');filterValue=e.target.getAttribute('value');}break;}}filterAction=filterAction||'update';filterValue=filterValue||e;var _this$state$filterSel=_this.state.filterSelected,zipcode=_this$state$filterSel.zipcode,category=_this$state$filterSel.category,sort=_this$state$filterSel.sort;switch(filterType){case'category':{category=filterAction==='remove'?'':[filterValue];break;}case'sort':{sort=filterAction==='remove'?'':[filterValue];_this.handleOrdination(sort);break;}case'zipcode':{zipcode=filterAction==='remove'?'':[filterValue.replace('-','')];break;}}var mustChangeUrl=true;_this.setFilter(zipcode,category,sort,mustChangeUrl,mustFetch);};};_this.setFilter=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(zipcode,category,sort,mustChangeUrl,mustFetch){var filterSelected,pagination,geoNear,location,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:filterSelected={zipcode:zipcode,category:category,sort:sort};if(mustChangeUrl){_this.setQueryString(filterSelected);}_this.setState({filterSelected:filterSelected});if(!mustFetch){_context2.next=18;break;}pagination={pageSize:9,pageNumber:1};geoNear={};if(window.sessionStorage.getItem('lat')&&window.sessionStorage.getItem('lng')){_this.setState({locationActive:true});geoNear={maxDistance:500000,location:{latitude:window.sessionStorage.getItem('lat'),longitude:window.sessionStorage.getItem('lng')}};}if(!filterSelected.zipcode){_context2.next=14;break;}_context2.next=10;return _this.handleLocation(filterSelected);case 10:location=_this.state.Location&&_this.state.Location.data&&_this.state.Location.data.objectReturn&&_this.state.Location.data.objectReturn.location;geoNear={maxDistance:500000,location:{latitude:location&&location.lat,longitude:location&&location.lng}};_context2.next=15;break;case 14:if(!window.sessionStorage.getItem('lat')&&!window.sessionStorage.getItem('lng')){_this.setState({locationActive:true});}case 15:payload={'pagination':pagination,'filter':{'chain':{'categories':filterSelected.category},'geoNear':geoNear}};_this.setState({unitys:[],filter:payload,isLoading:true});setTimeout(function(){_this.handleGetUnitys();},1000);case 18:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3,_x4,_x5,_x6,_x7){return _ref2.apply(this,arguments);};}();_this.setQueryString=function(filterSelected){var filterQueryString='';Object.keys(filterSelected).map(function(key){var filterQS=filterSelected[key];if(filterQS!==undefined&&filterQS.toString()!==''){filterQueryString+=(filterQueryString?'&':'')+key+'='+filterQS.toString();}});var urlChanged=window.location.protocol+'//'+window.location.host+window.location.pathname+'?'+filterQueryString;window.history.pushState({path:urlChanged},'',urlChanged);};_this.handleFilter=function(){_this.setState({condition:!_this.state.condition});};_this.handleVerifyToken=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].tokenVerify();case 2:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleGetUnitys=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getUnitys(_this.state.filter).then(function(resultUnitys){if(resultUnitys.data.objectReturn.data.length>0){var unitys=resultUnitys&&resultUnitys.data.objectReturn&&resultUnitys.data.objectReturn.data||[];_this.setState({unitys:_this.state.unitys.concat(unitys),isLoading:false,NotFound:false});}else{_this.setState({hasMoreItems:false,isLoading:false});if(_this.state.unitys.length>0){_this.setState({NotFound:false});}else{_this.setState({NotFound:true});}}}).catch(function(){return _this.setState({NotFound:false});});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.handleGetCategories=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var resultCategories;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_10_features_Services_ComunidadeIupp__["a" /* ComunidadeIuppService */].getCategories();case 2:resultCategories=_context5.sent;_this.setState({categories:resultCategories&&resultCategories.data.objectReturn});case 4:case'end':return _context5.stop();}}},_callee5,_this2);}));_this.state={showZipCode:true,locationActive:true,condition:false,NotFound:false,isLoading:false,filterSelected:{},hasMoreItems:true,Location:null,ordination:{DISTANCE:false,HIGHERDISCOUNTS:false},unitys:[],filter:{pagination:{pageSize:9,pageNumber:1},filter:{chain:{ids:[]},geoNear:{maxDistance:500000,location:{latitude:0,longitude:0}}}}};_this.loadItems=_this.loadItems.bind(_this);return _this;}_createClass(SearchStore,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;this.handleVerifyToken();this.handleGetCategories();setTimeout(function(){_this3.setFilterByQueryString();},300);}},{key:'handleOrdination',value:function handleOrdination(type){switch(type){case'DISTANCE':this.setState({ordination:{DISTANCE:true,HIGHERDISCOUNTS:false}});break;case'HIGHERDISCOUNTS':this.setState({ordination:{DISTANCE:false,HIGHERDISCOUNTS:true}});break;default:this.setState({ordination:{DISTANCE:false,HIGHERDISCOUNTS:false}});break;}}},{key:'loadItems',value:function loadItems(){var _this4=this;if(!this.state.isLoading){var pagination={pageSize:9,pageNumber:this.state.filter.pagination.pageNumber+1};var payload={'pagination':pagination,'filter':this.state.filter.filter};this.setState({filter:payload});this.handleGetUnitys().catch(function(){return _this4.setState({NotFound:false});});}}},{key:'render',value:function render(){var _this5=this;var storeList=this.state.unitys;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'showcase-lazy container-fluid showcase'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 pt-4 pt-sm-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-results col-12 pb-2 py-md-2 d-flex d-md-flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row w-100'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'txt-font-body color-title pb-half'},'comunidade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,storeList?storeList.length:'xx'),' unidade(s) encontrada(s)')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-voltar-mobile',name:'BUTTON',text:'Voltar',iconName:'icon_left icon-sm',className:'col-12 btn-sm',onClick:this.handleFilter})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(!this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-filtrar-mobile',name:'BUTTON',text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm ',onClick:this.handleFilter})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["h" /* Sidebar */],{categories:this.state.categories||[],handleFilterChanged:this.handleFilterChanged,filterSelected:this.state.filterSelected,pageType:'search',isLoading:this.state.isLoading,ordination:this.state.ordination,showZipCode:this.state.showZipCode,term:this.state.term,className:''+(this.state.condition?'d-block d-md-block':'d-none d-md-block')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 '+(!this.state.condition?'d-block d-md-block':'d-none d-md-block')},!this.state.NotFound?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:this.loadItems,hasMore:this.state.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},storeList&&storeList.map(function(store,ix){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Card_CardStore__["a" /* default */],Object.assign({},store,{key:ix,location:_this5.state.locationActive}));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* NotFound */],null)))));}}]);return SearchStore;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SearchStore.propTypes={match:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({sku:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired})}),location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref6){var router=_ref6.router;return{location:router&&router.location};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(SearchStore));

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Filters__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__);
var Sidebar=function Sidebar(_ref){var categories=_ref.categories,handleFilterChanged=_ref.handleFilterChanged,filterSelected=_ref.filterSelected,priceLimit=_ref.priceLimit,pageType=_ref.pageType,isLoading=_ref.isLoading,className=_ref.className,ordination=_ref.ordination,showZipCode=_ref.showZipCode;var mustShow=filterSelected&&(filterSelected.zipcode||filterSelected.category&&filterSelected.category.length>0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-siderbar filterSelected col-12 '+(className||'')},mustShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Filters__["c" /* SelectedFilters */],{filterSelected:filterSelected,categories:categories,handleFilterChanged:handleFilterChanged,pageType:pageType}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-sidebar col-12 col-md-4 col-lg-3 pb-5 px-1 px-md-2 mb-5 mt-2 '+(className||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Filters__["b" /* Filters */],{categories:categories,handleFilterChanged:handleFilterChanged,filterSelected:filterSelected||{},priceLimit:priceLimit,ordination:ordination,showZipCode:showZipCode,expanded:true})));};// schema
Sidebar.propTypes={categories:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,priceLimit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,pageType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,ordination:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,showZipCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_accessible_accordion_dist_fancy_example_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Filters=function(_Component){_inherits(Filters,_Component);function Filters(props){_classCallCheck(this,Filters);var _this=_possibleConstructorReturn(this,(Filters.__proto__||Object.getPrototypeOf(Filters)).call(this,props));_this.handleUpdateZipcode=function(e){_this.setState({zipcode:e.target.value});};_this.state={zipcode:null,mask:[/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/]};return _this;}_createClass(Filters,[{key:'render',value:function render(){var _props=this.props,categories=_props.categories,filterSelected=_props.filterSelected,expanded=_props.expanded,ordination=_props.ordination;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["Accordion"],{className:'container-filter row border-color-ui-3 radius',accordion:false},this.props.showZipCode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItem"],{expanded:expanded,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'},'Localiza\xE7\xE3o',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white  px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-price col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Input"],{id:'cep',label:'CEP',className:'col-12 mb-1 has-content',childrenClassName:'has-content',type:'text',mask:this.state.mask,onBlur:this.handleUpdateZipcode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-auto px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button',className:'btn btn-sm btn-featured',onClick:this.props.handleFilterChanged('zipcode'),value:this.state.zipcode,disabled:!this.state.zipcode},'Filtrar')))))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItem"],{expanded:expanded,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 d-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first','aria-label':'Ordenar por'},'Ordenar por',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white  px-2 py-1','data-ordernation':ordination},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-scroll'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'?sort=DISTANCE',className:'txt-body-sm'},'Menor dist\xE2ncia')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'?sort=HIGHERDISCOUNTS',className:'txt-body-sm'},'Maior desconto'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* FilterItems */],{expanded:expanded,items:categories,title:'Categoria',type:'category',handleFilterChanged:this.props.handleFilterChanged,filterSelected:filterSelected})));}}]);return Filters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// schema
Filters.propTypes={categories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,filterSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,expanded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,ordination:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,showZipCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(327);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectedFilters=function(_Component){_inherits(SelectedFilters,_Component);function SelectedFilters(){_classCallCheck(this,SelectedFilters);return _possibleConstructorReturn(this,(SelectedFilters.__proto__||Object.getPrototypeOf(SelectedFilters)).apply(this,arguments));}_createClass(SelectedFilters,[{key:'render',value:function render(){var _props=this.props,filterSelected=_props.filterSelected,categories=_props.categories,handleFilterChanged=_props.handleFilterChanged;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-filter container-selected-filter row radius border-none radius mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-selected pl-1 px-md-2 pt-0 pt-md-2 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["e" /* SelectedFiltersText */],{filterSelected:filterSelected,handleFilterChanged:handleFilterChanged}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["d" /* SelectedFiltersList */],{filterSelected:filterSelected,handleFilterChanged:handleFilterChanged,listObject:categories}))));}}]);return SelectedFilters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectedFilters.propTypes={filterSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,categories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectedFilters);

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectedFiltersList=function(_Component){_inherits(SelectedFiltersList,_Component);function SelectedFiltersList(){_classCallCheck(this,SelectedFiltersList);return _possibleConstructorReturn(this,(SelectedFiltersList.__proto__||Object.getPrototypeOf(SelectedFiltersList)).apply(this,arguments));}_createClass(SelectedFiltersList,[{key:'render',value:function render(){var _props=this.props,filterSelected=_props.filterSelected,listObject=_props.listObject,handleFilterChanged=_props.handleFilterChanged;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,filterSelected&&filterSelected.category&&listObject?filterSelected.category.map(function(item,index){var filteredSubcategory=listObject.filter(function(value){return String(value.id)===String(item);});return filteredSubcategory.length<=0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'subcategory_'+index,className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'button',href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},filteredSubcategory[0].description,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor',action:'remove',value:filteredSubcategory[0].id,onClick:handleFilterChanged('category')}))));}):null);}}]);return SelectedFiltersList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectedFiltersList.propTypes={filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,listObject:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectedFiltersList);

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectedFiltersList=function(_Component){_inherits(SelectedFiltersList,_Component);function SelectedFiltersList(){_classCallCheck(this,SelectedFiltersList);return _possibleConstructorReturn(this,(SelectedFiltersList.__proto__||Object.getPrototypeOf(SelectedFiltersList)).apply(this,arguments));}_createClass(SelectedFiltersList,[{key:'render',value:function render(){var _props=this.props,filterSelected=_props.filterSelected,handleFilterChanged=_props.handleFilterChanged;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,filterSelected&&filterSelected.zipcode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected mb-1 ml-1 px-2 col-auto border-ui-3 h-auto bg-white radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'button',href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2 pr-2'},filterSelected.zipcode,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3',value:filterSelected.zipcode,action:'remove',onClick:handleFilterChanged('zipcode')})))):null);}}]);return SelectedFiltersList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectedFiltersList.propTypes={filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectedFiltersList);

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectedFilters=function(_Component){_inherits(SelectedFilters,_Component);function SelectedFilters(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectedFilters);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectedFilters.__proto__||Object.getPrototypeOf(SelectedFilters)).call.apply(_ref,[this].concat(args))),_this),_this.checkSelected=function(value){var category=_this.props.filterSelected.category;switch(_this.props.type){case'category':{return category?category.includes(String(value)):false;}default:{}}},_this.buildDescription=function(value){return value.trim().length>17?value.trim().substr(0,27)+'...':value.trim();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectedFilters,[{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,filterSelected=_props.filterSelected,expanded=_props.expanded,title=_props.title,items=_props.items,handleFilterChanged=_props.handleFilterChanged;return(items&&items.length)>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:expanded,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 '+(items?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first','aria-label':title},title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white  px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-scroll'},items&&items.map(function(item,index){return(!filterSelected.category||_this2.checkSelected(item.id))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Checkbox"],{key:type+'_'+index,id:type+'_'+item.id,label:_this2.buildDescription(item.description),labelClass:'out',className:'col-12 form-field-custom px-0',value:item.id,onChange:handleFilterChanged(type),checked:_this2.checkSelected(item.id),title:''+item.description});}))));}}]);return SelectedFilters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// schema
SelectedFilters.propTypes={type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,expanded:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectedFilters);

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_notfound_css__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_notfound_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_notfound_css__);
var NotFound=function NotFound(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container not-found py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-notfound row my-4 mt-md-0 py-3 px-3 mx-1 bg-white radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_loupe txt-headline color-brand-1'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-left mb-1'},'Opps! N\xE3o foi encontrado nenhum resultado para sua busca.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-left txt-body-sm'},'\xB7 Verifique se os termos digitados est\xE3o corretos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-left txt-body-sm'},'\xB7 Tente utilizar palavras gen\xE9ricas e refinar a busca nos filtros laterais.'))));};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_notfound_css__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_notfound_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_notfound_css__);
var EmptyOffers=function EmptyOffers(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container not-found py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-notfound row my-4 mt-md-0 py-3 px-3 mx-1 bg-white radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_loupe txt-headline color-brand-1'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-left mb-1'},'Nenhuma oferta cadastrada'))));};/* harmony default export */ __webpack_exports__["a"] = (EmptyOffers);

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductCategory__ = __webpack_require__(1892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductCategory__["a"]; });


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CategoryGroup__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_App_MainMenu__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Shared_HeadMetadata_ducks__ = __webpack_require__(165);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductCategory=function(_Component){_inherits(ProductCategory,_Component);function ProductCategory(props){_classCallCheck(this,ProductCategory);return _possibleConstructorReturn(this,(ProductCategory.__proto__||Object.getPrototypeOf(ProductCategory)).call(this));}_createClass(ProductCategory,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.productCategories.items.length&&!this.props.productCategories.isLoading){this.props.ProductCategoryAction();}this.props.setMeta('Veja todas as categorias de produtos');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Todas as categorias - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-all-categories container-all-with-context container-fluid '+(this.props.onlyCash?'cat-context-cash':'cat-context-points'),'data-context':this.props.onlyCash?'cash':'points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-initial color-brand-1 mr-auto'},'Veja todas as categorias de produtos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.props.productCategories.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CategoryGroup__["a" /* default */],Object.assign({key:index},item));}))))))))));}}]);return ProductCategory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductCategory.propTypes={productCategories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,ProductCategoryAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,setMeta:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onlyCash:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(_ref){var productCategories=_ref.productCategories,onlyCash=_ref.onlyCash;return{productCategories:productCategories,onlyCash:onlyCash};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{ProductCategoryAction:function ProductCategoryAction(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_App_MainMenu__["c" /* ProductCategoryAction */])());},setMeta:function setMeta(title,description,keywords){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Shared_HeadMetadata_ducks__["b" /* setMetadata */])(title,description,keywords));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ProductCategory));

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_slugify__);
var CategoryGroup=function CategoryGroup(_ref){var id=_ref.id,name=_ref.name,subcategories=_ref.subcategories;var removeCategories= true?"servicos,tabacaria,viagens,veiculos,educacao,vale-compras".split(','):[];var removeSubcategories= true?"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas".split(','):[];var getUrl=function getUrl(categoryId,subcategoryId){switch(subcategoryId){case 80:return'/mileage';case 72:return'/fuelcredit';case 73:return'/billpayment';case 90:return'/mobile-recharge';case 93:return'/checkout/points-purchase';default:return'/search?category='+categoryId+'&subcategory='+subcategoryId;}};if(removeCategories.includes(__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(name,{delimiter:'-'}))){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryGroup col-12 pb-3 '+__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(name,{delimiter:'-'}),'data-path':'/search?category='+id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'CategoryParent mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{to:'/search?category='+id,className:'txt-font-body color-ui-2 h4'},name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategoryChilds row'},subcategories.map(function(item,ix){if(!removeSubcategories.includes(__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(item.name,{delimiter:'-'}))){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 pt-half pl-3 pl-md-1 '+__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(item.name,{delimiter:'-'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"],{key:ix,to:getUrl(id,item.id),className:'txt-body-sm'},item.name)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}})));};CategoryGroup.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subcategories:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CategoryGroup);

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Store__ = __webpack_require__(1895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Store__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StoreVoucher__ = __webpack_require__(1896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__StoreVoucher__["a"]; });


/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreGroup__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StorePage__ = __webpack_require__(653);
var capitalize=__webpack_require__(654);var Store=function Store(_ref){var stores=_ref.stores;var storesEcommerce=[];var keepStores=[61719,61721];var removeStores=[61829];stores.ecommerce.map(function(str){if(!removeStores.includes(str.supplierId)){if(keepStores.includes(str.supplierId)){storesEcommerce.push(Object.assign({},str));}else{var name=sanitizeString(str.name);if(name){storesEcommerce.push(Object.assign({},str,{name:name}));}}}});storesEcommerce=storesEcommerce.sort(sortString);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StorePage__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StoreGroup__["a" /* default */],{items:storesEcommerce,title:'Aqui voc\xEA encontra as melhores lojas de produtos.',hasContent:storesEcommerce.length>0})));};Store.propTypes={stores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};var sanitizeString=function sanitizeString(string){var str=string.toLowerCase().replace('(','').replace(')','').replace('ltm','');str=str.replace('ecommerce','').replace('tatix','').replace('-','').replace('satelital','').replace('itlog','').trim();str=capitalize.words(str);str=str==='Jbl'?'JBL':str;str=str==='Mac'?'MAC':str;return str;};var sortString=function sortString(a,b){var aName=__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(a.name,{delimiter:'-'});var bName=__WEBPACK_IMPORTED_MODULE_3_react_slugify___default()(b.name,{delimiter:'-'});if(aName>bName){return 1;}else if(bName>aName){return-1;}return 0;};var mapStateToProps=function mapStateToProps(_ref2){var stores=_ref2.stores;return{stores:stores};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,null)(Store));

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slugify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slugify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slugify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoreGroup__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StorePage__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_yn__);
var capitalize=__webpack_require__(654);var StoreVoucher=function StoreVoucher(_ref){var stores=_ref.stores;var virtualVouchers=[];var physicalVouchers=[];var removeVouchersIds= true?"61719,61718,21217,61751,21136,21121".split(','):[];var addVirtual= true?"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479".split(','):[];var addPhysical= true?"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264".split(','):[];if(stores.vouchers&&stores.vouchers.length){stores.vouchers.map(function(store){var storeNameSlug=__WEBPACK_IMPORTED_MODULE_4_react_slugify___default()(store.description,{delimiter:'-'});if(!removeVouchersIds.includes(store.supplierId)){if(__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&(storeNameSlug.includes('virtual')||addVirtual.includes(''+store.supplierId))){virtualVouchers.push(Object.assign({},store,{name:sanitizeString(store.name,'virtual')}));}else if(__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&(storeNameSlug.includes('fisico')||addPhysical.includes(''+store.supplierId))){physicalVouchers.push(Object.assign({},store,{name:sanitizeString(store.name,'fisico')}));}}});virtualVouchers=virtualVouchers.sort(sortString);physicalVouchers=physicalVouchers.sort(sortString);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Todos os cupons e servi\xE7os - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StorePage__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StoreGroup__["a" /* default */],{items:physicalVouchers,title:"Vouchers Físicos"||'Vouchers Físicos',hasContent:physicalVouchers.length>0}))),__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StorePage__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StoreGroup__["a" /* default */],{items:virtualVouchers,title:"Vouchers Virtuais"||'Vouchers Virtuais',hasContent:virtualVouchers.length>0}))));};StoreVoucher.propTypes={stores:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};var sortString=function sortString(a,b){var aName=__WEBPACK_IMPORTED_MODULE_4_react_slugify___default()(a.name,{delimiter:'-'});var bName=__WEBPACK_IMPORTED_MODULE_4_react_slugify___default()(b.name,{delimiter:'-'});if(aName>bName){return 1;}else if(bName>aName){return-1;}return 0;};var sanitizeString=function sanitizeString(string,type){var str=string.toLowerCase().replace(type,'');if(type==='fisico'){str=str.replace('físico','');}str=str.trim().replace(' -','').replace('-','').replace('.','').replace('dshop','');str=str.trim().replace('-','').trim();str=str.trim().replace('b2w ','').trim();str=str.trim().replace('pg','').trim();str=str.trim().replace('americanascom','americanas.com').trim();return capitalize.words(str);};var mapStateToProps=function mapStateToProps(_ref2){var stores=_ref2.stores;return{stores:stores};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,null)(StoreVoucher));

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_App_Shell_LoggedSidebar__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderItem__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_order_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_template_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_template_order_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var selectOptions=[{text:'Últimos 7 dias',value:1}];var Orders=function Orders(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-orders container-fluid px-0 px-md-1  bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-5 pb-2 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-5 pt-md-0 mt-5 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_App_Shell_LoggedSidebar__["a" /* default */],{selected:props.location.pathname}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-content col-12 col-md-8 border-color-ui-3 bg-white border radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3 py-2 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-1 mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-initial color-brand-1 mr-auto'},'Pedidos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 d-none d-md-block '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Select"],{id:'ordernar',label:'Ordenar por',className:'col-12 px-0',value:selectOptions[0],displayValue:'text',selectedValue:'value',options:selectOptions})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container draggable py-3 border-bottom border-color-ui-3 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row flex-nowrap flex-md-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'7_dias',name:'7_dias',text:'7\xA0dias',className:'btn-sm border-color-ui-2 py-1 px-1 txt-body-sm txt-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'15_dias',name:'15_dias',text:'15\xA0dias',className:'btn-sm py-1 px-1 txt-body-sm txt-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'1_mes',name:'1_mes',text:'1\xA0m\xEAs',className:'btn-sm py-1 px-1 txt-body-sm txt-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'3_meses',name:'3_meses',text:'3\xA0meses',className:'btn-sm py-1 px-1 txt-body-sm txt-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'6_meses',name:'6_meses',text:'6\xA0meses',className:'btn-sm py-1 px-1 txt-body-sm txt-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col px-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'1_ano',name:'1_ano',text:'1\xA0ano',className:'btn-sm py-1 px-1 txt-body-sm txt-left'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OrderItem__["a" /* default */],null)))));};Orders.propTypes={location:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Orders);

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_order_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_order_css__);
var OrderItem=function OrderItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'orders-item row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-auto txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://via.placeholder.com/150',alt:'Imagem do produto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_check_circle color-success h4  d-inline-block'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body py-half color-success txt-body'},'Entregue'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-subtitle color-ui-2 mt-1'},'Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android 6.0, 4G c\xE2mera 12MP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2.200 pontos x 2 unidades')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Previs\xE3o de entrega: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10/11/2018')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Pontofrio.com'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-action pos-relative col-3 d-none d-md-inline-block txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm'},'Ver detalhes'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-auto txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://via.placeholder.com/150',alt:'Imagem do produto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_truck color-warning h4  d-inline-block','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body py-half color-warning txt-body'},'Produto com dificuldade na entrega'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-subtitle color-ui-2 mt-1'},'Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android 6.0, 4G c\xE2mera 12MP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2.200 pontos x 2 unidades')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Previs\xE3o de entrega: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10/11/2018')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Pontofrio.com'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-action pos-relative col-3 d-none d-md-inline-block txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm'},'Ver detalhes'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-auto txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://via.placeholder.com/150',alt:'Imagem do produto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_truck color-success h4  d-inline-block','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body py-half color-success txt-body'},'Enviado para a transportadora'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-subtitle color-ui-2 mt-1'},'Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android 6.0, 4G c\xE2mera 12MP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2.200 pontos x 2 unidades')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Previs\xE3o de entrega: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10/11/2018')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Pontofrio.com'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-action pos-relative col-3 d-none d-md-inline-block txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm'},'Ver detalhes'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 order-item '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-img col-auto txt-center pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://via.placeholder.com/150',alt:'Imagem do produto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info col mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-product-info row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_close_circle color-error h4  d-inline-block'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'txt-font-body py-half color-error txt-body'},'Cancelado'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-font-body txt-subtitle color-ui-2 mt-1'},'Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1, android 6.0, 4G c\xE2mera 12MP'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-1 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-subtitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2.200 pontos x 2 unidades')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Previs\xE3o de entrega: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'10/11/2018')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle'},'Fornecido e entregue por: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Pontofrio.com'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-action pos-relative col-3 d-none d-md-inline-block txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm'},'Ver detalhes'))))));};/* harmony default export */ __webpack_exports__["a"] = (OrderItem);

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderProductItem__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TrackingItem__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_confirmation_css__);
var tracking=true;var mockTracking={items:[{updatedAt:'2019-02-16T16:20:17.058Z',createdAt:'2019-02-16T16:20:17.058Z',sku:'2213156',trackingUrl:'https://status.ondeestameupedido.com/tracking/e43e06fc16ff1f21f6245f595b48aaf42e36ef3a',deliveryForecasts:[{additionalDays:15,deliveryForecast:'2018-11-19T00:00:00.000Z',createdAt:'2019-02-16T16:20:16.588Z'}],statuses:[{vendorStatus:'1',description:'Pedido Realizado - SUCESSO',when:'2018-11-14T04:45:00.000Z',createdAt:'2019-02-16T16:20:16.588Z',origin:'VENDOR'},{vendorStatus:'2',description:'Pagamento - Recebemos a confirmação do pagamento de seu pedido e vamos dar continuidade ao processo de envio.',when:'2018-11-14T04:47:00.000Z',createdAt:'2019-02-16T16:20:16.588Z',origin:'VENDOR'},{vendorStatus:'3',description:'Separação em Estoque - Sucesso',when:'2018-11-14T05:17:00.000Z',createdAt:'2019-02-16T16:20:16.588Z',origin:'VENDOR'},{vendorStatus:'4',description:'Produto em Transporte - Produto em transporte',when:'2018-11-14T10:59:00.000Z',createdAt:'2019-02-16T16:20:16.588Z',origin:'VENDOR'},{vendorStatus:'6',description:'Entrega - Devolução',when:'2018-12-13T17:54:00.000Z',createdAt:'2019-02-16T16:20:16.588Z',origin:'VENDOR'}]}]};var Order=function Order(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 px-md-1 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-5 pb-2 py-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-5 pt-md-0 mt-5 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 px-0 pl-md-1 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-brand-1 txt-uppercase txt-circular-black'},'PEDIDO: #00000001')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OrderProductItem__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-3 bg-ui-5  border-color-ui-3 border-bottom py-2 '+(tracking?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-shipping col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{iconName:'icon_truck',className:'color-brand-1 icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col py-half px-0 txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Transportadora: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Correios')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'C\xF3digo de rastreamento: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'OF992903803BR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Pedido realizado: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'06/11/2018')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-4 pl-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-sm'},'Rastrear Pedido'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-3 border-color-ui-3 border-bottom py-2 '+(!tracking?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-tracking col-12 px-0 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-ui-2 txt-uppercase txt-body txt-circular-black'},'DETALHE DO RASTREAMENTO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TrackingItem__["a" /* default */],{tracking:mockTracking})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-1 px-0 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-back col-12 col-md-5 px-0 txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-flat btn-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{className:'icon icon-sm icon_left'}),'Ver todos os pedidos'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* OrderSide */],null))));};/* harmony default export */ __webpack_exports__["a"] = (Order);

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iphone.67bced32.jpg";

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_payment_icon_mastercard_png__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_payment_icon_mastercard_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_payment_icon_mastercard_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var OrderSide=function OrderSide(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 border-ui-3 radius bg-white px-0 py-0 mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Sobre o pedido')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-0 pb-md-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'w-100',src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_payment_icon_mastercard_png___default.a,alt:'Bandeira selecionada'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Cart\xE3o de cr\xE9dito: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'XXXX-XXXX-XXXX-0278')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3x R$ 1.950,00')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Resgate realizado em: 17/10/2018 \xE0s 14h13'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor total em pontos: 1456 pontos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Complemento em ',Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro',': R$ 5.850,00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor do frete Ponto Frio: 80 pontos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-2  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Adriana Santana')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Alameda Rio Negro, 585 - 7\xBA andar')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Alphaville - Barueri - SP - 06454-000')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:' btn-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon_press'}),'Imprimir Pedido'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-1 px-half d-block d-md-none mt-2 mt-md-0  border-dotted-top border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-back col-12 col-md-5 px-1 txt-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-flat btn-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Icon"],{className:'icon icon-sm icon_left'}),'Ver todos os pedidos')))));};/* harmony default export */ __webpack_exports__["a"] = (OrderSide);

/***/ }),
/* 1902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAAABHNCSVQICAgIfAhkiAAABPVJREFUaIHtml9sU1Ucxz+37f6ytR2sC4S1QBiwsXYIZaIwMOqDYWPRRE1INEbjn2jUFyNoiDzJg7JEI0QTfFESQBiDhTkZBH1iY4Op0XUjEANj7QaMbmvvWLt1/XN92BActPTclk7Ab3If7jnn+/v+vuk5v3vuuZUUj8coE6qRUJ4FycQDCcWtIB0xKNoPJe+Q+1tJ4s3pTikVkBR2SV6Pe0iCvOlOJhVQwKN5WMwCSJCnme4kUo3/DT/o0N2zyLKMtrMLjdNJxGIhvGb1PZMSQVINS04nWVu2onV0Ijmdt/VHbFaCVZUEPtr0746gjFbuQit3opU70fidhA3WyauUiMGWvBxlj1tJRqC0fT+QtWUryPJdx0ZsVvxf7yBis5F+YReZ52ogGJ0XMVjxr9iRFONJMZz90ivojjaJkeygPJOHtMgTNyVQvJlA8aa7D4yBhItWxmfbxc2uAkpB6vXAJQGtc9uZ0fycmNYUJGRY43CQ8XmNGCkPWHLL/SVgLH66dqCF9Au7xDRvgXrDssyMl18V51VOuVeAbrEQmedqkPy3F8V4oNpwtEocE4sB7R3arwFhgThBmayOT8S0J6HasK65RZy0NEp7BBgS1L8qWDcmodqwxukSJ2XH6POryEF2iHPEZSaJotMZID1G37h4OK3cKcxJ7V5aitGnYs+n8YvPMtWGwzarOCmW4QwVORjEc0it4VjP2xkqcvjPG+6P0p4GGMTDKdkWYY5qwxGbjfG33xIjnY2iWCiuHzRvFCdFkY8bYx9vRjGb4ydcAa5PacsFRH8onZ7Rsm2CpAkkVqUNBvzf7BTj/HiLahoTmxHBLPz2nZCmYg2IS92OcMUa/Ht2g14fH2EcaASyJFhO7M3IHRA0byQ0Z+qGPH4k5TkcqqpkuON3QpXr7z5Yr2fsg20Mf/oXoYVxjL8BnZ7RFTsYtQvOqClI2onHDWgcDtJ+akLr6Jx4wXC5iFithG0TV7BqPYrl5qLVXTlK9m/vQ2g4aszwrNX47TtVVeWpSLphtZD8zptnWj4XYaP1n3Mttev1jjqpNHz1aj9Go4HMzEzVMSKRCCebW3hi3VpV/IRPLQ/UHqSnx4l9xXL++LOD9959h1OtbXR0OLCWLsVisXDocD3VG6o4UHuQZWVlVFdX0dDQiKnAROnSEo42HWf1449xpr0dr1fmjddf47vvdwPw4gvPs3fffsrKbIyOjtLT00N//zXVhhMuWvX1R3j6qSdpbjnFPIuFhoZGamvrWLe2gmPHT1B36DAVFWswmfIpKipiZbmdEz//gqOri/37a7l4sRufz8f1kRF6e/uo3lDFF19+xYL5CzjT/iuDg0O4XC5s1lKamo5RUlKSUL4JGy4qWkhx8RJycnLIN+UTGA/gHnDT3X2JYChI+Uo7J082s2fvPnJzcmhtbSMjPR2Xy4XJlI9Wq8VoNKBEIhQUFODz+QgEAgwODZKZMfFGMWf2bHS6NBRF4fz58wnlm/Aa7nE6MRcW0td3mVx9LqFgEFkexuv1MnPWTArnzuX0mXZWPVqOTqfjVGsbjywrw+XqZXRsjCWLFzEyMkJBQQFdXWfx+/2Ul6+kre00WdnZLF5UhHtgAIvZTF/fZdwDAxiNBubPmzc9hu83PHQf0x4+wwrE/63jPocCXg0KddOdSApRpzNIus0yIekB/9vSoIJUb0C36W8lRcMigQD4qwAAAABJRU5ErkJggg=="

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmationDonationContainer__ = __webpack_require__(1904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConfirmationDonationContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(1918);
/* unused harmony reexport reducer */


/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmationDonation__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1917);
// eslint-disable-next-line no-unused-vars
var mapStateToProps=function mapStateToProps(_ref,ownProps){var confirmation=_ref.confirmation;return{order:confirmation,orderId:ownProps.match.params.orderId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectNotFoundPage:function redirectNotFoundPage(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_connected_react_router__["push"])(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].REDIRECT_ROUTE_PAGE_404));},getOrder:function getOrder(orderId){return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].getOrder(orderId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__ConfirmationDonation__["a" /* default */]));

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOrder */
var getOrder=function getOrder(orderId){return{type:'GET_ORDER_CONFIRMATION',payload:{client:'cloudloyalty',request:{method:'get',url:'/v1/purchases/'+orderId+'/order'}}};};/* harmony default export */ __webpack_exports__["a"] = ({getOrder:getOrder});

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductOrderItemDonation__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutOrderDonation__ = __webpack_require__(1913);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmationDonation=function(_Component){_inherits(ConfirmationDonation,_Component);function ConfirmationDonation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConfirmationDonation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConfirmationDonation.__proto__||Object.getPrototypeOf(ConfirmationDonation)).call.apply(_ref,[this].concat(args))),_this),_this.state={showModal:false,hideModal:true,orderId:0},_this.toogleModal=function(){_this.setState({showModal:!_this.state.showModal});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConfirmationDonation,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.orderId){this.props.getOrder(this.props.orderId);}}},{key:'render',value:function render(){var _this2=this;if(this.props.order.notFound){this.props.redirectNotFoundPage();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-cart container pt-5 pt-md-2 pb-5',onLoad:function onLoad(e){return _this2.toogleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block d-md-none pb-5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-5 mt-md-0 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Alert"],{isError:false,title:'Obrigado! Sua doa\xE7\xE3o foi conclu\xEDda com sucesso.',description:'Acompanhe todos os detalhes nos seus pedidos.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-8 pl-0 pr-0 pr-md-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Resumo da doa\xE7\xE3o')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-products col-12 mx-0'},this.props.order.vendorOrderModel?this.props.order.vendorOrderModel.map(function(vendorItem){return vendorItem.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductOrderItemDonation__["a" /* default */],{key:index,productName:item.name,orderParentId:_this2.props.order.parentOrderId,costPrice:item.costPrice,quanttity:item.quantity,vendorName:vendorItem.vendorName,deliveryDate:item.deliveryForecast,orderId:vendorItem.orderId,parentOrderId:_this2.props.order.parentOrderId,productId:item.id,imageUrl:item.imageUrl,vendorId:vendorItem.vendorId,vendorType:vendorItem.vendorType});});}):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AboutOrderDonation__["a" /* AboutOrderDonation */],{parentOrder:this.props.order})));}}]);return ConfirmationDonation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ConfirmationDonation.propTypes={order:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,orderId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,getOrder:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,redirectNotFoundPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ConfirmationDonation);

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProductImageDonation__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_cart_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_confirmation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_products_icon_donation_svg__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_images_products_icon_donation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_icon_donation_svg__);
var ProductOrderItemDonation=function ProductOrderItemDonation(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProductImageDonation__["a" /* ProductImageDonation */],{imageUrl:__WEBPACK_IMPORTED_MODULE_6__loyal_images_products_icon_donation_svg___default.a,alt:props.productName,vendorId:props.vendorId,vendorType:props.vendorType,ready:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-product-info row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order-number col-12 mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-font-body txt-body'},'Pedido: #00000007')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-infos col-12 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'txt-body-sm txt-font-body color-ui-2 '},'Doa\xE7\xE3o de pontos'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row card-price-item  mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5.000 pts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Realizado em:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'17/10/2018')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured btn-cart',text:'Ver detalhes',onClick:function onClick(){window.location.href='/my-orders';}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 d-block d-md-none mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{className:'btn btn-sm btn-featured btn-cart',text:'Ver detalhes',onClick:function onClick(){window.location.href='/my-orders';}})));};ProductOrderItemDonation.propTypes={productName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductOrderItemDonation);

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductImageDonation__ = __webpack_require__(1909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductImageDonation__["a"]; });


/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Placeholder__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png__);
var ProductImageDonation=function ProductImageDonation(props){var img;var src;var alt='';switch(props.vendorId){case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SMILES.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SMILES.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SHELL.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SHELL.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.PAYBILLS.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.SHELL.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.DONATION.ID:src=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.DONATION.IMAGEURL;alt=props.alt;break;case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.CELLPHONERECHARGE.ID:var srcRecharge;var altRecharge;for(var property in __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OPERATORS){var operator=__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OPERATORS[property];if(props.alt.toUpperCase().indexOf(operator.description.toUpperCase())){srcRecharge=operator.IMAGEURL;altRecharge=operator.description;break;}}src=srcRecharge||__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].VENDOR.CELLPHONERECHARGE.IMAGEURL;alt=altRecharge||props.alt;break;default:src=props.imageUrl;alt=props.alt;break;}var imageDonation={width:'70px'};img=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:src||__WEBPACK_IMPORTED_MODULE_5__loyal_images_products_product_placeholder_png___default.a,alt:alt,className:'border border-color-brand-1 radius p-1',style:imageDonation});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_placeholder___default.a,{ready:props.ready,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Placeholder__["a" /* default */],null)},img);};ProductImageDonation.propTypes={imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,vendorId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,ready:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ProductImageDonation);

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VENDOR */
/* unused harmony export OPERATORS */
var VENDOR={SHELL:{ID:117,IMAGEURL:''},SMILES:{ID:21185,IMAGEURL:''},PAYBILLS:{ID:21188,IMAGEURL:''},DONATION:{ID:54,IMAGEURL:''},CELLPHONERECHARGE:{ID:71,IMAGEURL:''}};var OPERATORS={CLARO:{description:'Claro',IMAGEURL:''},NEXTEL:{description:'Nextel',IMAGEURL:''},OI:{description:'Oi',IMAGEURL:''},TIM:{description:'Tim',IMAGEURL:''},VIVO:{description:'Vivo',IMAGEURL:''}};/* harmony default export */ __webpack_exports__["a"] = ({VENDOR:VENDOR,OPERATORS:OPERATORS});

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg__);
var Placeholder=function Placeholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_placeholder_svg___default.a,alt:'Ainda est\xE1 carregando...'});};/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_donation.f3b4bb1e.svg";

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AboutOrderDonation__ = __webpack_require__(1914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AboutOrderDonation__["a"]; });


/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderPointsAndCashDonation__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderInfoDonation__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__About__ = __webpack_require__(208);
var AboutOrderDonation=function AboutOrderDonation(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__About__["a" /* About */],{title:' Sobre o pedido'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__OrderPointsAndCashDonation__["a" /* default */],{paymentDetailMoneyAndPoints:props.parentOrder.OrderPointsAndCashDonation}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__OrderInfoDonation__["a" /* default */],{parentOrder:props.parentOrder}));};AboutOrderDonation.propTypes={parentOrder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (AboutOrderDonation);

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var OrderPointsAndCashDonation=function OrderPointsAndCashDonation(props){return props.paymentDetailMoneyAndPoints&&props.paymentDetailMoneyAndPoints.isDisplay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'w-100',src:props.paymentDetailMoneyAndPoints.imageUrlCardBrand,alt:'Bandeiras da operadora do cart\xE3o de cr\xE9dito'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Cart\xE3o:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'XXXX-XXXX-XXXX-',props.paymentDetailMoneyAndPoints.lastCreditCardDigits)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,props.paymentDetailMoneyAndPoints.numberParcels,'x R$',props.paymentDetailMoneyAndPoints.valueParcel)))):'';};OrderPointsAndCashDonation.propTypes={paymentDetailMoneyAndPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (OrderPointsAndCashDonation);

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var OrderInfoDonation=function OrderInfoDonation(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Resgate realizado em:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'17/10/2018 \xE0s 14h13')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Trasa\xE7\xE3o:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Doa\xE7\xE3o de pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor em pontos:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'5.000,00 pts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Valor em ',Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro',' convertido:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'R$ 5.000,00'))));};/* harmony default export */ __webpack_exports__["a"] = (OrderInfoDonation);

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REDIRECT_ROUTE_PAGE_404 */
var REDIRECT_ROUTE_PAGE_404='/404';/* harmony default export */ __webpack_exports__["a"] = ({REDIRECT_ROUTE_PAGE_404:REDIRECT_ROUTE_PAGE_404});

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var innitialState={};/* unused harmony default export */ var _unused_webpack_default_export = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:innitialState;var action=arguments[1];switch(action.type){case'GET_ORDER_CONFIRMATION':return innitialState;case'GET_ORDER_CONFIRMATION_SUCCESS':return Object.assign({},action.payload.data);case'GET_ORDER_CONFIRMATION_FAIL':var errorMessage='';return Object.assign({},innitialState,{notFound:action.error.request.status===404,errorMessage:action.data&&action.data.errors&&action.data.errors.length>0&&(action.data.errors.map(function(item,index){return errorMessage+=item.message;})||errorMessage)});default:return state||innitialState;}});

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BillPayment__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ByllPaymentContainer=function(_Component){_inherits(ByllPaymentContainer,_Component);function ByllPaymentContainer(props){_classCallCheck(this,ByllPaymentContainer);var _this=_possibleConstructorReturn(this,(ByllPaymentContainer.__proto__||Object.getPrototypeOf(ByllPaymentContainer)).call(this,props));_this.count=0;_this.handleBarCodeChange=function(_ref){var value=_ref.target.value;var valueFormated=value.trim().match(/\d+/g);if(valueFormated){var barCode=valueFormated.join([]);_this.setState({barCode:barCode});return;}_this.setState({barCode:value});};_this.handleBarCodeBlur=function(){var _this$state=_this.state,barCode=_this$state.barCode,serviceId=_this$state.serviceId;_this.calculatePoints({serviceId:serviceId,barCode:barCode});};_this.calculatePoints=function(_ref2){var barCode=_ref2.barCode,serviceId=_ref2.serviceId;if(!barCode||!serviceId)return;_this.setState({isLoadingChangeAccountType:true});_this.client.get('/v1/billPayments/vendor/'+_this.state.vendorId+'/service/'+serviceId+'/validate/'+barCode).then(function(result){_this.setState(Object.assign({},result.data,{errorField:null,serviceId:serviceId,barCode:barCode,isLoadingChangeAccountType:false}));}).catch(function(ex){return _this.ExceptionChangeAccountType(ex);});};_this.state={isloading:true,isLoadingChangeAccountType:false,vendorId:21188,maskLengthAccountType:51,maskAccountType:[],accountType:[],barCode:'',documentNumber:props.cpf?props.cpf.value:'',dueDate:'',billValue:'',pointsValue:'',isPriceEditable:false,name:'',errorPage:null,successPage:null,errorField:null,showTerms:false,acceptTerms:false,serviceId:''};_this.handlerChangeAccountType=_this.handlerChangeAccountType.bind(_this);_this.handlerGetData=_this.handlerGetData.bind(_this);_this.handlerCloseError=_this.handlerCloseError.bind(_this);_this.handlerCloseSuccess=_this.handlerCloseSuccess.bind(_this);_this.handlerFinalizePayment=_this.handlerFinalizePayment.bind(_this);_this.handlerAccountTypes=_this.handlerAccountTypes.bind(_this);_this.closeterms=_this.closeterms.bind(_this);_this.acceptTermsEvent=_this.acceptTermsEvent.bind(_this);_this.showTermsEvent=_this.showTermsEvent.bind(_this);return _this;}_createClass(ByllPaymentContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.count===0){this.count++;var client=__WEBPACK_IMPORTED_MODULE_2_redux_clients__["a" /* default */].cloudloyalty.client;this.client=client;this.handlerAccountTypes();}var location=this.props.location;if(location&&location.state&&location.state.hasError){var _location$state=location.state,barCode=_location$state.barCode,dueDate=_location$state.dueDate,serviceId=_location$state.serviceId,error=_location$state.error;this.ExceptionFinalizePayment(error);this.setState({barCode:barCode,dueDate:dueDate,serviceId:serviceId,acceptTerms:true});this.calculatePoints({barCode:barCode,serviceId:serviceId});}}},{key:'acceptTermsEvent',value:function acceptTermsEvent(checked){this.setState({showTerms:false,acceptTerms:checked});}},{key:'showTermsEvent',value:function showTermsEvent(){this.setState({showTerms:true});}},{key:'closeterms',value:function closeterms(){this.setState({showTerms:false});}},{key:'handlerGetData',value:function handlerGetData(e){this.setState({dueDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()(e).format('DD/MM/YYYY')});}},{key:'handlerChangeAccountType',value:function handlerChangeAccountType(_ref3){var serviceId=_ref3.serviceId;var defaultNotDigit=new RegExp(/[^ -//]/);var arrayRegularExpression=this.state.accountType.find(function(item){return item.serviceId===serviceId;}).mask.split(',');var arrayMask=arrayRegularExpression.map(function(i){return defaultNotDigit.test(i)?new RegExp(i):i;});var barCode=this.state.barCode;this.setState({serviceId:serviceId,maskAccountType:arrayMask,maskLengthAccountType:this.state.accountType.find(function(item){return item.serviceId===serviceId;}).maskLength});this.calculatePoints({serviceId:serviceId,barCode:barCode});}},{key:'ExceptionChangeAccountType',value:function ExceptionChangeAccountType(ex){var data=ex.response.data;if(data.errors[0].code===11){this.setState({errorField:false,billValue:0,pointsValue:0.0,isPriceEditable:true,name:'',isloading:false,isLoadingChangeAccountType:false});}}},{key:'handlerFinalizePayment',value:function handlerFinalizePayment(){var _this2=this;if(!this.state.acceptTerms){return this.handlerShowErrorPage('Regulamento','Favor aceitar o Regulamento!');}var payment={serviceId:this.state.serviceId,barCode:this.state.barCode,dueDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.state.dueDate,'DD/MM/YYYY').format('MM/DD/YYYY'),documentNumber:this.state.documentNumber,billValue:this.state.billValue};this.setState({loadingPayment:true});this.client.post('/v1/purchases/billPayment',payment).then(function(response){_this2.setState({loadingPayment:false,successPage:{title:'Pagamento!',description:'Seu pagamento foi realizado com sucesso!'},serviceId:'',barCode:'',dueDate:'',billValue:'',pointsValue:'',name:''});var id=response.data.id;_this2.props.redirectConfirmation('/confirmation/'+id);}).catch(function(ex){return _this2.ExceptionFinalizePayment(ex.response.data);});}},{key:'ExceptionFinalizePayment',value:function ExceptionFinalizePayment(data){this.setState({loadingPayment:false});var message=data?data.errors[0].message.replace('DueDate inválido','Data de vencimento inválida'):data;this.handlerShowErrorPage('Erro ao tentar efetuar o pagamento!',data?message:'problemas técnicos');}},{key:'handlerCloseError',value:function handlerCloseError(){this.setState({errorPage:null});}},{key:'handlerCloseSuccess',value:function handlerCloseSuccess(){this.setState({successPage:null});}},{key:'handlerShowErrorPage',value:function handlerShowErrorPage(title,description){var _this3=this;this.setState({errorPage:{title:title,description:description,closeError:function closeError(){return _this3.handlerCloseError();}}});}},{key:'handlerAccountTypes',value:function handlerAccountTypes(){var _this4=this;this.client.get('/v1/billPayments/vendor/'+this.state.vendorId+'/service').then(function(result){_this4.setState({isloading:false,accountType:result.data});}).catch(function(){return _this4.handlerShowErrorPage('! tipos de contas','erro ao tentar obter os tipos de contas');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BillPayment__["a" /* default */],Object.assign({},this.state,{handlerChangeAccountType:this.handlerChangeAccountType,handlerFinalizePayment:this.handlerFinalizePayment,handleBarCodeChange:this.handleBarCodeChange,handlerGetData:this.handlerGetData,handlerCloseError:this.handlerCloseError,handlerCloseSuccess:this.handlerCloseSuccess,acceptTermsEvent:this.acceptTermsEvent,closeterms:this.closeterms,showTermsEvent:this.showTermsEvent,handleBarCodeBlur:this.handleBarCodeBlur,currencyConfiguration:this.props.currencyConfiguration}));}}]);return ByllPaymentContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref4){var cpf=_ref4.participant.cpf,profile=_ref4.oidc.user.profile,catalog=_ref4.catalog;return{cpf:cpf,catalogId:profile['custom:catalog_id'],currencyConfiguration:catalog.currencyConfiguration};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectConfirmation:function redirectConfirmation(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["push"])(path));}};};ByllPaymentContainer.propTypes={cpf:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,redirectConfirmation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ByllPaymentContainer));

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CellphoneRecharge_ModalTerms_ModalTerms__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_services_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_services_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_services_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder_lib_reactPlaceholder_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_helmet__);
var showError=function showError(error,handlerCloseError){return error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:error.title,description:error.description,className:'pb-2',onClose:function onClose(){return handlerCloseError();}}):'';};var showSuccess=function showSuccess(success,handlerCloseSuccess){return success?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isSuccess:true,title:success.title,description:success.description,className:'pb-2',onClose:function onClose(){return handlerCloseSuccess();}}):'';};var BillPayment=function BillPayment(_ref){var isloading=_ref.isloading,isLoadingChangeAccountType=_ref.isLoadingChangeAccountType,maskLengthAccountType=_ref.maskLengthAccountType,maskAccountType=_ref.maskAccountType,accountType=_ref.accountType,handlerChangeAccountType=_ref.handlerChangeAccountType,handleBarCodeChange=_ref.handleBarCodeChange,handlerGetData=_ref.handlerGetData,handlerFinalizePayment=_ref.handlerFinalizePayment,handlerCloseError=_ref.handlerCloseError,handlerCloseSuccess=_ref.handlerCloseSuccess,billValue=_ref.billValue,pointsValue=_ref.pointsValue,isPriceEditable=_ref.isPriceEditable,barCode=_ref.barCode,dueDate=_ref.dueDate,errorPage=_ref.errorPage,successPage=_ref.successPage,errorField=_ref.errorField,name=_ref.name,loadingPayment=_ref.loadingPayment,showTerms=_ref.showTerms,closeterms=_ref.closeterms,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,vendorId=_ref.vendorId,catalogId=_ref.catalogId,serviceId=_ref.serviceId,handleBarCodeBlur=_ref.handleBarCodeBlur,currencyConfiguration=_ref.currencyConfiguration;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_placeholder___default.a,{ready:!isloading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* BillPaymentPlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Pagamento de contas - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 px-md-1 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-0 pb-3 py-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-0'},showError(errorPage,handlerCloseError),showSuccess(successPage,handlerCloseSuccess),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-paguecontas radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title-2 txt-circular-book'},'Pagamento de contas'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Voc\xEA sabia que pode utilizar seus',' ',currencyConfiguration.pointsName,' para pagar contas de luz, telefone, \xE1gua, entre outras? Aproveite e leve mais facilidade e economia para a sua vida.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["c" /* FormBillPayment */],{maskLengthAccountType:maskLengthAccountType,maskAccountType:maskAccountType,accountType:accountType,handlerChangeAccountType:handlerChangeAccountType,handleBarCodeChange:handleBarCodeChange,handlerGetData:handlerGetData,billValue:billValue,pointsValue:pointsValue,isPriceEditable:isPriceEditable,barCode:barCode,errorField:errorField,dueDate:dueDate,isloading:isloading,isLoadingChangeAccountType:isLoadingChangeAccountType,serviceId:serviceId,handleBarCodeBlur:handleBarCodeBlur})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CellphoneRecharge_ModalTerms_ModalTerms__["a" /* default */],{show:showTerms,terms:{type:'Vendor',vendorId:vendorId,catalogId:catalogId},onClose:closeterms,acceptTerms:function acceptTerms(){return acceptTermsEvent(true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* Sidebar */],{barCode:barCode,name:name,data:dueDate,billValue:billValue,pointsValue:pointsValue,handlerFinalizePayment:handlerFinalizePayment,loadingPayment:loadingPayment,showTermsEvent:showTermsEvent,acceptTermsEvent:acceptTermsEvent,acceptTerms:acceptTerms,serviceId:serviceId,accountType:accountType})))));};BillPayment.propTypes={isloading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loadingPayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,maskLengthAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,maskAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,accountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handlerChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleBarCodeChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerGetData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerCloseError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerCloseSuccess:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,billValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,isPriceEditable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,barCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,dueDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,errorPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,successPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,errorField:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showTerms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,closeterms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,vendorId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,catalogId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,serviceId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,handleBarCodeBlur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (BillPayment);

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });


/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BarCodeSection__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfoSection__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
var Sidebar=function Sidebar(_ref){var barCode=_ref.barCode,name=_ref.name,data=_ref.data,billValue=_ref.billValue,pointsValue=_ref.pointsValue,handlerFinalizePayment=_ref.handlerFinalizePayment,loadingPayment=_ref.loadingPayment,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,serviceId=_ref.serviceId,accountType=_ref.accountType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Resumo da conta')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BarCodeSection__["a" /* default */],{barCode:barCode,data:data,billValue:billValue,pointsValue:pointsValue,serviceId:serviceId,accountType:accountType})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InfoSection__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Checkbox"],{style:{position:'relative',marginLeft:'20px'},id:'aceito_termos',checked:acceptTerms,className:'col-auto',labelClass:'l-0',outerLabel:true,onChange:function onChange(e){return acceptTermsEvent(e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return showTermsEvent();},className:'txt-body-sm color-brand-2 txt-underline',role:'button'},'termos do regulamento')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},loadingPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button',className:'btn-featured btn-icon',value:'Carregando','aria-label':'Carregando pagamento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{className:'btn-featured btn-icon',disabled:validButton(barCode,data,billValue,pointsValue,acceptTerms),text:'Finalizar pagamento',iconName:'icon_gift',onClick:handlerFinalizePayment})))));};var validButton=function validButton(barCode,data,billValue,pointsValue,acceptTerms){var result=!!(barCode&&data&&billValue&&pointsValue&&acceptTerms);return!result?'disabled':'';};Sidebar.propTypes={barCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,loadingPayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,billValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,serviceId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,accountType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BarCodeSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel_CurrencyLabel__ = __webpack_require__(266);
var BarCodeSection=function BarCodeSection(_ref){var barCode=_ref.barCode,accountType=_ref.accountType,data=_ref.data,billValue=_ref.billValue,pointsValue=_ref.pointsValue,pointsName=_ref.pointsName,decimalPlaces=_ref.decimalPlaces,serviceId=_ref.serviceId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-left justify-content-center align-self-center row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'d-none col-12 mx-0 px-0 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'C\xF3digo de barras: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,barCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'},'Tipo da conta:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,serviceId?accountType.find(function(item){return item.serviceId===serviceId;}).name:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'},'Data de vencimento: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm  txt-font-body color-ui-2'},'Valor da conta:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,billValue?'R$ '+Object(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel_CurrencyLabel__["b" /* numberToStrCurrency */])(billValue,2):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'},'Valor total:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,pointsValue?Object(__WEBPACK_IMPORTED_MODULE_3_Shared_CurrencyLabel_CurrencyLabel__["b" /* numberToStrCurrency */])(pointsValue,decimalPlaces)+' '+pointsName:'')));};BarCodeSection.propTypes={barCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,accountType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,serviceId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,billValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pointsName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,decimalPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};var mapStateToProps=function mapStateToProps(_ref2){var currencyConfiguration=_ref2.catalog.currencyConfiguration;return{pointsName:currencyConfiguration.pointsName,decimalPlaces:currencyConfiguration.decimalPlaces};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,null)(BarCodeSection));

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var InfoSection=function InfoSection(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'\u2022 Pagamentos de segunda \xE0 sexta-feira, das 8h \xE0s 18h;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'\u2022 Permitido apenas 1 (um) pagamento a cada 24 horas;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'\u2022 Pagamentos devem ser realizados at\xE9 2 (dois) dias antes do vencimento;'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'\u2022 Valor limite do boleto: R$ 400,00 para contas de \xE1gua, luz, telefone e g\xE1s;'));};/* harmony default export */ __webpack_exports__["a"] = (InfoSection);

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePicker__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Shared_CurrencyLabel_CurrencyLabel__ = __webpack_require__(266);
var FormBillPayment=function FormBillPayment(_ref){var maskLengthAccountType=_ref.maskLengthAccountType,maskAccountType=_ref.maskAccountType,accountType=_ref.accountType,handlerChangeAccountType=_ref.handlerChangeAccountType,handleBarCodeChange=_ref.handleBarCodeChange,handlerGetData=_ref.handlerGetData,billValue=_ref.billValue,pointsValue=_ref.pointsValue,isPriceEditable=_ref.isPriceEditable,barCode=_ref.barCode,dueDate=_ref.dueDate,errorField=_ref.errorField,isLoadingChangeAccountType=_ref.isLoadingChangeAccountType,serviceId=_ref.serviceId,handleBarCodeBlur=_ref.handleBarCodeBlur,pointsName=_ref.pointsName,decimalPlaces=_ref.decimalPlaces;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'codigo_barra',label:'C\xF3digo de barras',className:'col-12 col-md-12',value:barCode,onChange:handleBarCodeChange,'data-error':'C\xF3digo de barras inv\xE1lido',mask:maskAccountType,valid:errorField,onBlur:handleBarCodeBlur}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'BillType',label:'Selecione o tipo de conta',className:'col-12 col-md-6 mt-2',displayValue:'name',selectedValue:'serviceId',options:accountType,onChange:handlerChangeAccountType,value:accountType.find(function(item){return item.serviceId===serviceId;}),'data-error':'Tipo de conta inv\xE1lido',valid:errorField}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-field col-12 col-md-6 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DatePicker__["a" /* default */],{id:'agendar_para',labelDescription:'Data vencimento',required:true,value:dueDate,minDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).add(1,'days').toDate(),onChange:handlerGetData}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'valor_conta',label:'Valor da conta',className:'col-12 col-md-6 mt-2',value:billValue?Object(__WEBPACK_IMPORTED_MODULE_6_Shared_CurrencyLabel_CurrencyLabel__["b" /* numberToStrCurrency */])(billValue,2):'',disabled:isPriceEditable?'true':'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'valor_em_pontos',label:'Valor em '+pointsName,className:'col-12 col-md-6 mt-2',value:pointsValue?Object(__WEBPACK_IMPORTED_MODULE_6_Shared_CurrencyLabel_CurrencyLabel__["b" /* numberToStrCurrency */])(pointsValue,decimalPlaces):'',disabled:isPriceEditable?'true':'false'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto '+(isLoadingChangeAccountType?'d-block':'d-none'),value:'Carregando','aria-label':'Carregando pagamento'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))));};FormBillPayment.propTypes={maskLengthAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,maskAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,accountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handlerChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleBarCodeChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerGetData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,billValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,isPriceEditable:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,barCode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,dueDate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,errorField:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,serviceId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,handleBarCodeBlur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,pointsName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,decimalPlaces:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};var mapStateToProps=function mapStateToProps(_ref2){var currencyConfiguration=_ref2.catalog.currencyConfiguration;return{pointsName:currencyConfiguration.pointsName,decimalPlaces:currencyConfiguration.decimalPlaces};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,null)(FormBillPayment));

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var BillPaymentPlaceholder=function BillPaymentPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 pr-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 py-5 radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-4 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-4 bg-ui-3 radius'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (BillPaymentPlaceholder);

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mileage__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_Mileage__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_Mileage_actions__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Checkout_actions__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_App_FingerPrint_FingerPrintContainer__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gerador_validador_cpf__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gerador_validador_cpf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_gerador_validador_cpf__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MileageContainer=function(_Component){_inherits(MileageContainer,_Component);function MileageContainer(props){_classCallCheck(this,MileageContainer);var _this=_possibleConstructorReturn(this,(MileageContainer.__proto__||Object.getPrototypeOf(MileageContainer)).call(this,props));_this.handleConfirmationModal=function(){_this.setState({confirmationModal:!_this.state.confirmationModal});};_this.showTermsEvent=function(){_this.setState({showModal:true});};_this.acceptTermsEvent=function(checked){_this.setState({showModal:false,acceptTerms:checked});};_this.acceptTerms=function(accept){_this.setState({acceptTerms:accept});};_this.closeterms=function(){_this.setState({showModal:false});};_this.fidelityLabelConfig=function(vendorId){var filter=_this.props.configuration&&_this.props.configuration[vendorId]&&_this.props.configuration[vendorId].filter(function(x){return x.key==='LoyaltyNumberLabel';});if(filter&&filter.length>0){return filter[0].value;}return null;};_this.selectPartnersOnChange=function(item){if(item===null||item===undefined||item===''){_this.setState({points:'',vendorId:0});_this.props.clearCalculator();return;}setTimeout(function(){_this.setState({vendorId:item.vendorId,formValid:true,partnerName:item.name,disabledFields:false,disableLoyaltyNumber:_this.MapLoyaltNumberType(item.vendorId),acceptTerms:false,convertAllPoints:false,fidelityLabel:_this.fidelityLabelConfig(item.vendorId),loyaltyNumber:_this.MapLoyaltNumberType(item.vendorId)?_this.props.participant.cpf.value:_this.state.loyaltyNumber});_this.props.clearCalculator();_this.props.pointsToMiles(_this.state.vendorId,_this.state.points);_this.props.getMileageConfigurations(_this.props.catalog.id,_this.state.vendorId);},1000);};_this.inputPointsOnChange=function(event){var value=event.target.value;if(value.length>=7)return;var onlyNumbers=value.match(/\d+/g);if(onlyNumbers){_this.inputPointsOnblur(event);return _this.setState({points:onlyNumbers.join([])});}_this.setState({points:''});};_this.inputLoyaltNumberOnChange=function(_ref){var value=_ref.target.value;var onlyNumbers=value.match(/\d+/g);if(onlyNumbers){return _this.setState({loyaltyNumber:onlyNumbers.join([])});}_this.setState({loyaltyNumber:''});};_this.mountNumberValidation=function(event){if(event.key==='0'||event.key==='1'||event.key==='2'||event.key==='3'||event.key==='4'||event.key==='5'||event.key==='6'||event.key==='7'||event.key==='8'||event.key==='9'||event.key==='Enter'||event.key==='Backspace'||event.key==='Delete'){return true;}else{return false;}};_this.pointsConverterOnblur=function(){_this.setState({disabledFields:true});setTimeout(function(){_this.setState({disabledFields:false});},1000);};_this.inputPointsOnblur=function(event){clearTimeout(_this.state.timer);_this.setState({inputPointsValue:event.target.value,timer:setTimeout(function(){_this.setState({formValid:true,formMessage:'',points:_this.state.inputPointsValue,disabledFields:false});_this.props.pointsToMiles(_this.state.vendorId,_this.state.points);},400)});};_this.handleDisableOnFocus=function(){_this.props.disableRedemptionButton(true);};_this.handleDisableOnBlur=function(){_this.props.disableRedemptionButton(false);};_this.handleConvertAllPoints=function(event){if(!event.target.checked){_this.props.clearCalculator();}_this.setState({convertAllPoints:event.target.checked});var balance=Math.floor(_this.props.partBalance,0);if(event.target.checked){_this.setState({points:balance});_this.props.pointsToMiles(_this.state.vendorId,balance);}else{_this.setState({points:0});_this.props.pointsToMiles(_this.state.vendorId,0);}};_this.handleFormatValue=function(value){if(!isNaN(value)){return parseFloat(value).toLocaleString('pt-br',{minimumFractionDigits:_this.props.currencyConfiguration.decimalPlaces,maximumFractionDigits:_this.props.currencyConfiguration.decimalPlaces})+' '+'Milhas';}return'';};_this.handlerFinalizePayment=function(){var MinimumBalance=_this.mapProp('MinimumBalance');var MinimunRedemption=_this.mapProp('MinimumRedemptionLimit');if(_this.props.partBalance<_this.state.points){_this.props.errorBalanceRedemption();}else if(_this.props.partBalance<MinimumBalance){_this.props.errorMinimunBalanceRedemption(MinimumBalance);}else if(_this.state.points<MinimunRedemption){_this.props.errorMinimunRedemption(MinimunRedemption);}else{_this.props.mileageRedemption(_this.getOrderRequest(),_this.state.vendorId);}};_this.handlerCloseError=function(){_this.props.closeErrorMileage();};_this.mapProp=function(KeyName){var filter=_this.props.configuration[_this.state.vendorId].filter(function(x){return x.key===KeyName;});if(filter.length>0){return filter[0].value;}};_this.mapOrderProcessType=function(){var KeyValue=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'OrderProcessType';var NameValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'Queue';var result=false;var filter=_this.props.configuration[_this.state.vendorId].filter(function(x){return x.key===KeyValue;});if(filter.length>0){var item=filter[0];if(item.value===NameValue){result=true;}return result;}};_this.MapLoyaltNumberType=function(vendorId){var filter=_this.props.configuration&&_this.props.configuration[vendorId]&&_this.props.configuration[vendorId].filter(function(x){return x.key.toLowerCase()==='transferkey';});if(filter&&filter.length>0){var item=filter[0];if(item.value.toLowerCase()==='cpf'){return true;}else{_this.setState({loyaltyNumber:''});return false;}}};_this.cpfValidator=function(cpf){var filter=_this.props.configuration&&_this.props.configuration[_this.state.vendorId]&&_this.props.configuration[_this.state.vendorId].filter(function(x){return x.key.toLowerCase()==='transferkey';});if(filter&&filter.length>0){var item=filter[0];if(item.value.toLowerCase()==='cpf'){if(!Object(__WEBPACK_IMPORTED_MODULE_8_gerador_validador_cpf__["validate"])(cpf.target.value)){_this.props.errorCpfMileage();}}}};_this.getOrderRequest=function(){return{totalMiles:_this.state.points,totalPoints:_this.props.calculator.miles,catalogId:_this.props.participant.catalogId,transferKey:'cpf',loyaltyNumber:_this.state.loyaltyNumber,cpf:_this.props.participant.cpf.value,participantName:_this.props.participant.name.value,offline:_this.mapOrderProcessType(),orderItems:[{quantity:1,points:_this.props.calculator.miles,miles:_this.state.points,totalPoints:_this.props.calculator.miles,packageName:_this.handleFormatValue(_this.props.calculator.miles)}],orderTypeId:1};};_this.state={vendorId:0,formValid:false,timer:0,inputPointsValue:0,formMessage:'',points:'',loyaltyNumber:'',convertAllPoints:false,acceptTerms:false,showModal:false,partnerName:'',disabledFields:true,disableLoyaltyNumber:true,confirmationModal:false};_this.handleDisableOnFocus=_this.handleDisableOnFocus.bind(_this);return _this;}_createClass(MileageContainer,[{key:'componentDidMount',value:function componentDidMount(){this.props.partners&&this.props.partners.length===0&&this.props.getPartners();this.props.catalog.id&&!(this.props.partners&&this.props.partners.length>0)&&this.props.getPartnersWithConfigurations(this.props.catalog.id);this.props.clearCalculator();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_App_FingerPrint_FingerPrintContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Mileage__["a" /* default */],Object.assign({},this.state,{partners:this.props.partners,points:this.state.points,miles:this.props.calculator.miles,selectPartnersOnChange:this.selectPartnersOnChange,showModal:this.state.showModal,inputPointsOnblur:this.inputPointsOnblur,pointsConverterOnblur:this.pointsConverterOnblur,inputPointsOnChange:this.inputPointsOnChange,handlerFinalizePayment:this.handlerFinalizePayment,handleConfirmationModal:this.handleConfirmationModal,confirmationModal:this.state.confirmationModal,handlerCloseError:this.handlerCloseError,handlerCloseSuccess:this.handlerCloseSuccess,acceptTermsEvent:this.acceptTermsEvent,closeterms:this.closeterms,showTermsEvent:this.showTermsEvent,vendorId:this.state.vendorId,inputLoyaltNumberOnChange:this.inputLoyaltNumberOnChange,loyaltyNumber:this.state.loyaltyNumber,partnerName:this.state.partnerName,currencyConfiguration:this.props.currencyConfiguration,errorRedemption:this.props.errorRedemption,handleConvertAllPoints:this.handleConvertAllPoints,convertAllPoints:this.state.convertAllPoints,disabledFields:this.state.disabledFields,handleFormatValue:this.handleFormatValue,loadingPayment:this.props.sendRedemptionMileage,validateCPF:this.cpfValidator,disableLoyaltyNumber:this.state.disableLoyaltyNumber,sendTwoFactorAuthorization:this.props.sendTwoFactorAuthorization,authorizeWithTokenMileage:this.props.authorizeWithTokenMileage,authorizeWithTokenResend:this.props.authorizeWithTokenResend,authorizeWithTokenLastTry:this.props.authorizeWithTokenResend,loadingResendToken:this.props.loadingResendToken,closeModalShowError:this.props.closeModalShowError,isLoadingRedemption:this.props.isLoading,disabledSelectPartner:this.props.disabledSelectPartner,oidc:this.props.oidc,disableRedemption:this.props.disableRedemption,disableOnFocus:this.handleDisableOnFocus,disableOnBlur:this.handleDisableOnBlur})));}}]);return MileageContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var partnerMessage=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,vendorId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired});var calculatorMessage=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({points:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,miles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string});MileageContainer.propTypes={cpf:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,redirectConfirmation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,partners:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(partnerMessage).isRequired,calculator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(calculatorMessage),isLoading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,isLoadingCalculator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,getPartners:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,pointsToMiles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,clearCalculator:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,partBalance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,mileageRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,participant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,errorRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,closeErrorMileage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,sendRedemptionMileage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,errorBalanceRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,errorMinimunRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,errorCpfMileage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,getMileageConfigurations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,catalog:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,errorMinimunBalanceRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,getPartnersWithConfigurations:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,configuration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,sendTwoFactorAuthorization:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,authorizeWithTokenMileage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,authorizeWithTokenLastTry:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,loadingResendToken:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,disabledSelectPartner:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,closeModalShowError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,oidc:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,disableRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,disableRedemptionButton:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handleDisableOnFocus:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(_ref2){var mileage=_ref2.mileage,balance=_ref2.balance,participant=_ref2.participant,currencyConfiguration=_ref2.catalog.currencyConfiguration,catalog=_ref2.catalog,oidc=_ref2.oidc;return{partners:Object(__WEBPACK_IMPORTED_MODULE_5__Services_Mileage_actions__["b" /* filterPartnerMileage */])(mileage.partners,true),calculator:mileage.calculator,isLoading:mileage.isLoading,isLoadingCalculator:mileage.isLoadingCalculator,disableRedemption:mileage.disableRedemption||false,getPartners:mileage.getPartners,pointsToMiles:mileage.pointsToMiles,partBalance:balance.pointsValue,participant:participant,catalog:catalog,errorRedemption:mileage.errorRedemption,sendRedemptionMileage:mileage.sendRedemptionMileage,currencyConfiguration:currencyConfiguration,configuration:mileage.configuration,sendTwoFactorAuthorization:mileage.sendTwoFactorAuthorization,loadingResendToken:mileage.loadingResendToken,oidc:oidc,disabledSelectPartner:mileage.disabledSelectPartners};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{disableRedemptionButton:function disableRedemptionButton(value){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].disableRedemptionButton(value));},clearCalculator:function clearCalculator(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].clearCalculator());},getPartners:function getPartners(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].getPartners());},pointsToMiles:function pointsToMiles(supplierId,points){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].convertPointsToMiles(supplierId,points));},mileageRedemption:function mileageRedemption(order,supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].mileageRedemption(order,supplierId));},closeErrorMileage:function closeErrorMileage(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].closeErrorMileage());},errorBalanceRedemption:function errorBalanceRedemption(MinimumBalance){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].errorBalanceRedemption(MinimumBalance));},errorMinimunRedemption:function errorMinimunRedemption(MinimunRedemption){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].errorMinimunRedemption(MinimunRedemption));},errorMinimunBalanceRedemption:function errorMinimunBalanceRedemption(minimunBalanceRedemption){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].errorMinimunBalanceRedemption(minimunBalanceRedemption));},errorCpfMileage:function errorCpfMileage(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].errorCpfMileage());},getMileageConfigurations:function getMileageConfigurations(catalogId,supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].getMileageConfigurations(catalogId,supplierId));},getPartnersWithConfigurations:function getPartnersWithConfigurations(catalogId){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].getPartnersWithConfigurations(catalogId));},authorizeWithTokenMileage:function authorizeWithTokenMileage(orderId,Token,orderIdMileage,vendorId,lastTry){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].authorizeWithTokenMileage(orderId,Token,orderIdMileage,vendorId,lastTry));},authorizeWithTokenResend:function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Checkout_actions__["c" /* default */].authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},authorizeWithTokenLastTry:function authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Checkout_actions__["c" /* default */].authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},closeModalShowError:function closeModalShowError(error){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_Mileage__["b" /* actions */].closeModalShowError(error));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(MileageContainer));

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_ModalServices_ModalServices__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Checkout_SecondFactorAuthenticaton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_services_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_services_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_services_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__);
var _this=this;var showError=function showError(error,handlerCloseError){return error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:'Não foi possível concluir a sua transferência.',description:error,className:'pb-2',onClose:function onClose(){return handlerCloseError();}}):'';};var VENDOR_ID_CONFIRM_MODAL=758;var Mileage=function Mileage(_ref){var isloading=_ref.isloading,isLoadingRedemption=_ref.isLoadingRedemption,partners=_ref.partners,selectPartnersOnChange=_ref.selectPartnersOnChange,inputPointsOnblur=_ref.inputPointsOnblur,pointsConverterOnblur=_ref.pointsConverterOnblur,inputPointsOnChange=_ref.inputPointsOnChange,handlerFinalizePayment=_ref.handlerFinalizePayment,handleConfirmationModal=_ref.handleConfirmationModal,confirmationModal=_ref.confirmationModal,handlerCloseError=_ref.handlerCloseError,points=_ref.points,loadingPayment=_ref.loadingPayment,showModal=_ref.showModal,closeterms=_ref.closeterms,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,vendorId=_ref.vendorId,miles=_ref.miles,loyaltyNumber=_ref.loyaltyNumber,inputLoyaltNumberOnChange=_ref.inputLoyaltNumberOnChange,partnerName=_ref.partnerName,errorRedemption=_ref.errorRedemption,handleConvertAllPoints=_ref.handleConvertAllPoints,convertAllPoints=_ref.convertAllPoints,disabledFields=_ref.disabledFields,handleFormatValue=_ref.handleFormatValue,currencyConfiguration=_ref.currencyConfiguration,fidelityLabel=_ref.fidelityLabel,validateCPF=_ref.validateCPF,disableLoyaltyNumber=_ref.disableLoyaltyNumber,sendTwoFactorAuthorization=_ref.sendTwoFactorAuthorization,authorizeWithTokenMileage=_ref.authorizeWithTokenMileage,authorizeWithTokenResend=_ref.authorizeWithTokenResend,authorizeWithTokenLastTry=_ref.authorizeWithTokenLastTry,loadingResendToken=_ref.loadingResendToken,closeModalShowError=_ref.closeModalShowError,oidc=_ref.oidc,disabledSelectPartner=_ref.disabledSelectPartner,disableRedemption=_ref.disableRedemption,disableOnFocus=_ref.disableOnFocus,disableOnBlur=_ref.disableOnBlur;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_placeholder___default.a,{ready:!isloading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["c" /* MileagePlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Transfer\xEAncia de pontos - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 px-md-1 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-0 pb-3 py-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-0'},showError(errorRedemption,handlerCloseError),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 mt-2 mt-md-0 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body pb-1'},'Para garantir a transfer\xEAncia dos seus pontos com sucesso certifique-se que voc\xEA ativou a verifica\xE7\xE3o em duas etapas.',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://onboarding.webpremios.com.br/Login/RedirectCognito?id=40455',className:'color-featured txt-bold'},'Clique aqui para ativar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-viagens radius-top row align-items-center px-1','data-mileage':vendorId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title-2 txt-circular-book'},'Transfer\xEAncia de pontos'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body pb-1'},'Transfira seus pontos para os programas parceiros. Veja o que voc\xEA precisa saber:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'\u2022 Verifique se possui uma conta no programa parceiro e se os dados est\xE3o atualizados'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'\u2022 A transfer\xEAncia acontecer\xE1 para a mesma titularidade')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* FormMileage */],{disableOnFocus:disableOnFocus,miles:miles,points:points,partners:partners,isloading:isloading,inputPointsOnblur:inputPointsOnblur,pointsConverterOnblur:pointsConverterOnblur,inputPointsOnChange:inputPointsOnChange,selectPartnersOnChange:selectPartnersOnChange,inputLoyaltNumberOnChange:inputLoyaltNumberOnChange,handleConvertAllPoints:handleConvertAllPoints,convertAllPoints:convertAllPoints,disabledFields:disabledFields,handleFormatValue:handleFormatValue,currencyConfiguration:currencyConfiguration,fidelityLabel:fidelityLabel,loyaltyNumber:loyaltyNumber,validateCPF:validateCPF,disableLoyaltyNumber:disableLoyaltyNumber,partnerName:partnerName,disabledSelectPartners:disabledSelectPartner,disableOnBlur:disableOnBlur})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Services_ModalServices_ModalServices__["a" /* default */],{title:'Termos do Regulamento de '+partnerName,show:showModal,terms:{type:'Vendor',vendorId:vendorId},onClose:closeterms,acceptTerms:function acceptTerms(e){return acceptTermsEvent(true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* ModalConfirm */],{show:confirmationModal,onClose:handleConfirmationModal,partner:partnerName,handlerFinalizePayment:handlerFinalizePayment,loadingPayment:loadingPayment})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["e" /* Sidebar */],{miles:miles,pointsValue:points,disableRedemption:disableRedemption,partnerName:partnerName,acceptTerms:acceptTerms,loyaltyNumber:loyaltyNumber,showTermsEvent:showTermsEvent,disabledFields:disabledFields,acceptTermsEvent:acceptTermsEvent,handleConfirmationModal:vendorId&&vendorId===VENDOR_ID_CONFIRM_MODAL?handleConfirmationModal:handlerFinalizePayment,currencyConfiguration:currencyConfiguration,handleFormatValue:handleFormatValue,fidelityLabel:fidelityLabel,isLoadingRedemption:isLoadingRedemption}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},sendTwoFactorAuthorization&&sendTwoFactorAuthorization.enable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Checkout_SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],{show:sendTwoFactorAuthorization.enable,onClose:function onClose(){return _this.toogleModal();},closeModal:function closeModal(){closeModalShowError('Não foi possível concluir o seu pagamento.');},secondFactorAuthConfirmated:sendTwoFactorAuthorization.secondFactorAuthConfirmated,loadingResendToken:loadingResendToken,sendTwoFactorAuthorization:sendTwoFactorAuthorization,authorizeWithTokenMileage:authorizeWithTokenMileage,authorizeWithTokenResend:authorizeWithTokenResend,authorizeWithTokenLastTry:authorizeWithTokenLastTry,vendorId:vendorId,errorToken:sendTwoFactorAuthorization.errorToken,paymentSelected:'POINTS_ONLY',isCreatingPurchase:isLoadingRedemption,oidc:oidc}):'')))));};Mileage.propTypes={partners:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,selectPartnersOnChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,inputPointsOnblur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,pointsConverterOnblur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,inputPointsOnChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isloading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingRedemption:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loadingPayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleConfirmationModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,confirmationModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handlerCloseError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,points:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,closeterms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,vendorId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,miles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,inputLoyaltNumberOnChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,loyaltyNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,partnerName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,errorRedemption:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,handleConvertAllPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,convertAllPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabledFields:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleFormatValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,fidelityLabel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,validateCPF:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,disableLoyaltyNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,sendTwoFactorAuthorization:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,authorizeWithTokenMileage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,authorizeWithTokenLastTry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,loadingResendToken:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,closeModalShowError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,oidc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,disabledSelectPartner:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disableRedemption:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disableOnFocus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,disableOnBlur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Mileage);

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });


/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MileageSection__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfoSection__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOption__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_yn__);
var Sidebar=function Sidebar(_ref){var disableRedemption=_ref.disableRedemption,partnerName=_ref.partnerName,pointsValue=_ref.pointsValue,miles=_ref.miles,loyaltyNumber=_ref.loyaltyNumber,handleConfirmationModal=_ref.handleConfirmationModal,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,currencyConfiguration=_ref.currencyConfiguration,disabledFields=_ref.disabledFields,handleFormatValue=_ref.handleFormatValue,fidelityLabel=_ref.fidelityLabel,isLoadingRedemption=_ref.isLoadingRedemption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Resumo do resgate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MileageSection__["a" /* default */],{mileage:partnerName,pointsValue:pointsValue,mileagePoints:handleFormatValue(miles||0),fidelityNumber:loyaltyNumber,currencyConfiguration:currencyConfiguration,fidelityLabel:fidelityLabel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InfoSection__["a" /* default */],{partnerName:partnerName,disabledFields:disabledFields}),__WEBPACK_IMPORTED_MODULE_6_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TermsOption__["a" /* default */],{acceptTerms:acceptTerms,acceptTermsEvent:acceptTermsEvent,disabledFields:disabledFields,showTermsEvent:showTermsEvent})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{loading:isLoadingRedemption,className:'btn-featured',disabled:validButton(disableRedemption,partnerName,miles,loyaltyNumber,pointsValue,acceptTerms),text:'Transferir Pontos',onClick:handleConfirmationModal})))));};var validButton=function validButton(disableRedemption,partnerName,pointsValue,miles,loyaltyNumber,acceptTerms){var result=!!(!disableRedemption&&partnerName&&pointsValue&&miles&&loyaltyNumber&&(!__WEBPACK_IMPORTED_MODULE_6_yn___default()("true")||acceptTerms));return!result?'disabled':'';};Sidebar.propTypes={disableRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,partnerName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,miles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,loyaltyNumber:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,handleConfirmationModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,disabledFields:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isLoadingRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,handleFormatValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,fidelityLabel:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__ = __webpack_require__(21);
var MileageSection=function MileageSection(_ref){var mileage=_ref.mileage,pointsValue=_ref.pointsValue,mileagePoints=_ref.mileagePoints,fidelityNumber=_ref.fidelityNumber,currencyConfiguration=_ref.currencyConfiguration,fidelityLabel=_ref.fidelityLabel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-left justify-content-center align-self-center row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm txt-subtitle txt-font-body color-ui-2'},'Transfer\xEAncia: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,mileage||'Selecione o parceiro')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'},'Valor em ',currencyConfiguration.pointsName,':',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:pointsValue||0})));};MileageSection.propTypes={mileage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pointsValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mileagePoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,fidelityNumber:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,fidelityLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (MileageSection);

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var InfoSection=function InfoSection(_ref){var partnerName=_ref.partnerName,disabledFields=_ref.disabledFields;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},disabledFields?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'Selecione um parceiro para transferir seus pontos'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'Seus Pontos est\xE3o sendo transferidos para ',partnerName,'.'));};InfoSection.propTypes={partnerName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabledFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (InfoSection);

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var TermsOption=function TermsOption(_ref){var acceptTerms=_ref.acceptTerms,disabledFields=_ref.disabledFields,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Checkbox"],{style:{position:'relative',marginLeft:'20px'},id:'aceito_termos',checked:acceptTerms,className:'col-auto',labelClass:'l-0',outerLabel:true,onChange:function onChange(e){return acceptTermsEvent(e.target.checked);},disabled:disabledFields}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm '+(disabledFields?'color-ui-2':'')},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:disabledFields?void 0:showTermsEvent,className:'txt-body-sm '+(disabledFields?'color-ui-1':'color-brand-2 txt-underline'),disabled:disabledFields,role:'button'},'termos do regulamento')))));};TermsOption.propTypes={acceptTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabledFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showTermsEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TermsOption);

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yn__);
var FormMileage=function FormMileage(_ref){var partners=_ref.partners,points=_ref.points,miles=_ref.miles,selectPartnersOnChange=_ref.selectPartnersOnChange,inputPointsOnblur=_ref.inputPointsOnblur,pointsConverterOnblur=_ref.pointsConverterOnblur,inputPointsOnChange=_ref.inputPointsOnChange,errorField=_ref.errorField,isLoadingChangeAccountType=_ref.isLoadingChangeAccountType,inputLoyaltNumberOnChange=_ref.inputLoyaltNumberOnChange,handleConvertAllPoints=_ref.handleConvertAllPoints,convertAllPoints=_ref.convertAllPoints,disabledFields=_ref.disabledFields,handleFormatValue=_ref.handleFormatValue,currencyConfiguration=_ref.currencyConfiguration,fidelityLabel=_ref.fidelityLabel,loyaltyNumber=_ref.loyaltyNumber,validateCPF=_ref.validateCPF,disableLoyaltyNumber=_ref.disableLoyaltyNumber,disabledSelectPartners=_ref.disabledSelectPartners,partnerName=_ref.partnerName,disableOnFocus=_ref.disableOnFocus,disableOnBlur=_ref.disableOnBlur;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'MileageType',label:'Transferir para',className:'col-12 col-md-6',displayValue:'name',selectedValue:'vendorId',image:'logoUrl',options:partners||[],onChange:selectPartnersOnChange,'data-error':'Tipo de programa de milhagem invalido',valid:errorField,disabled:disabledSelectPartners}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'numero_fidelidade',label:fidelityLabel||'CPF ou Loyalty Number',className:'col-12 col-md-6 mt-2 mt-md-0',onChange:inputLoyaltNumberOnChange,value:loyaltyNumber,disabled:disableLoyaltyNumber,maxLength:'11',onBlur:validateCPF}),__WEBPACK_IMPORTED_MODULE_3_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_MESSAGE_MILEAGE_SMILES)&&partnerName==='Smiles'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm color-brand-1'},'Voc\xEA precisa ter pelo menos 10.000 pontos no iupp para conseguir.')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Quantos ',currencyConfiguration.pointsName,' deseja transferir?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'pontos_converter',label:'Quantidade de '+currencyConfiguration.pointsName,className:'col-12 col-md-6 mt-2',value:points,onChange:inputPointsOnChange,onFocus:disableOnFocus,onBlur:disableOnBlur,disabled:disabledFields||convertAllPoints,maxLength:'7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'milhas_obter',label:'Voc\xEA vai receber no programa parceiro',className:'col-12 col-md-6 mt-2 price-value d-none',value:handleFormatValue(miles||0),disabled:disabledFields}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6 pt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100 pt-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Checkbox"],{style:{position:'relative',marginLeft:'20px'},id:'converter_todos_pontos',className:'col-12 checkbox-field',labelClass:'l-1',label:'Transferir todos os meus '+currencyConfiguration.pointsName+'.',checked:convertAllPoints,onChange:handleConvertAllPoints,disabled:disabledFields})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto '+(isLoadingChangeAccountType?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))));};FormMileage.propTypes={partners:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,partnerName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,points:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,miles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,selectPartnersOnChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,inputPointsOnblur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,pointsConverterOnblur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,inputPointsOnChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,errorField:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,inputLoyaltNumberOnChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleConvertAllPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,convertAllPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabledFields:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleFormatValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,fidelityLabel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,loyaltyNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,validateCPF:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,disableOnFocus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,disableOnBlur:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,disableLoyaltyNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabledSelectPartners:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (FormMileage);

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var MileagePlaceholder=function MileagePlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 pr-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 py-5 radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 mt-2 border-ui-4 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 py-1 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 py-1 bg-ui-4 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 py-1 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-1 bg-ui-4 radius'}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-4 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-white radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-4 bg-ui-3 radius'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (MileagePlaceholder);

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalConfirm__ = __webpack_require__(1938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ModalConfirm__["a"]; });


/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal__);
var ModalConfirm=function ModalConfirm(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_awesome_modal___default.a,{width:'600',height:'90%',effect:'fadeInUp',visible:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-wrapper col-11 mx-auto bg-white radius px-2 py-3 border-bottom-lg border-color-featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm','data-partner':props.partner},'Para realizar o resgate \xE9 preciso ter cadastro no programa parceiro')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6  mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'MileageConfirm',name:'MileageConfirm',className:'cart-done nowrap mr-2 col-2',text:'Cancelar',onClick:function onClick(e){return props.onClose();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-6  mt-2'},props.loadingPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-featured btn-icon','aria-label':'Carregando...'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Button"],{id:'MileageConfirm',name:'MileageConfirm',className:'cart-done btn-featured  col-2',text:'Confirmar',onClick:props.handlerFinalizePayment,loading:props.loadingPayment}))))));};ModalConfirm.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,partner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loadingPayment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ModalConfirm);

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FuelCredit__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_FuelCredit__ = __webpack_require__(213);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var errorTitle='Não foi possível concluir o sua transação.';var errorDescription='Vamos tentar novamente, por favor verifique os campos baixo.';var FuelCreditContainer=function(_Component){_inherits(FuelCreditContainer,_Component);function FuelCreditContainer(props){_classCallCheck(this,FuelCreditContainer);var _this=_possibleConstructorReturn(this,(FuelCreditContainer.__proto__||Object.getPrototypeOf(FuelCreditContainer)).call(this,props));_this.handlerChangePackage=function(packageSelected){_this.setState({packageSelected:packageSelected,isValid:null});};_this.acceptTermsEvent=function(checked){_this.setState({showModal:false,acceptTerms:checked});};_this.showTermsEvent=function(){_this.setState({showModal:true});};_this.closeterms=function(){_this.setState({showModal:false});};_this.handlerFinalizePayment=function(){if(_this.props.participantBalance<_this.state.packageSelected.pointsQuantity){return _this.handlerShowErrorPage('Não foi possível concluir o sua transação.','Seu saldo é insuficiente.',true);}var orderFuelCredit={totalMiles:_this.state.packageSelected.milesQuantity,totalPoints:_this.state.packageSelected.pointsQuantity,transferKey:'cpf',loyaltyNumber:_this.props.participant.cpf.value,cpf:_this.props.participant.cpf.value,participantName:_this.props.participant.name.value,offline:false,orderItems:[{quantity:1,points:_this.state.packageSelected.pointsQuantity,miles:_this.state.packageSelected.milesQuantity,totalPoints:_this.state.packageSelected.pointsQuantity,packageName:_this.state.packageSelected.title,clientProductCode:_this.state.packageSelected.clientProductCode,pointsAdjustment:_this.state.packageSelected.pointsAdjustment,partnerCampaignPackageId:_this.state.packageSelected.partnerCampaignPackageId}],orderTypeId:1};_this.props.redemptionFuelCredit(orderFuelCredit,_this.state);};_this.handleCloseError=function(){_this.setState({errorPage:Object.assign({},_this.state.errorPage,{hasError:false})});_this.props.closeError();};_this.handlerCloseSuccess=function(){_this.setState({successPage:null});};_this.handlerShowErrorPage=function(title,description,hasError){_this.setState({errorPage:{title:title,description:description,hasError:hasError,closeError:function closeError(){return _this.handleCloseError();}}});};_this.handlerFormatValue=function(value,decimalPlaces){return value.toLocaleString('pt-br',{minimumFractionDigits:decimalPlaces,maximumFractionDigits:decimalPlaces});};_this.state={isloading:true,loadingPayment:false,shellSupplierId:117,errorPage:{title:errorTitle,description:props.descriptionErrorFuelCredit||errorDescription,hasError:props.sendRedemptionError},error:null,successPage:null,errorField:null,acceptTerms:false,packageSelected:props.packageSelected||{},isValid:null,regulationType:'Vendor',showModal:false};_this.handlerChangePackage(_this.state.packageSelected);return _this;}_createClass(FuelCreditContainer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.packages||this.props.packages.length<1){this.props.loadPackagesBySupplierId(this.state.shellSupplierId,this.props.clientId);}}},{key:'render',value:function render(){var _this2=this;var errorPage={title:errorTitle,description:this.state.description||this.props.descriptionErrorFuelCredit||errorDescription,hasError:this.props.sendRedemptionError||this.state.hasError,closeError:function closeError(){return _this2.handleCloseError();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FuelCredit__["a" /* default */],Object.assign({},this.state,{errorPage:errorPage,packages:this.props.packages,handlerFinalizePayment:this.handlerFinalizePayment,handleCloseError:this.handleCloseError,acceptTermsEvent:this.acceptTermsEvent,closeterms:this.closeterms,showTermsEvent:this.showTermsEvent,packageSelected:this.state.packageSelected,handlerChangePackage:this.handlerChangePackage,currencyConfiguration:this.props.currencyConfiguration,shellSupplierId:this.state.shellSupplierId,regulationType:this.state.regulationType,acceptTerms:this.state.acceptTerms,showModal:this.state.showModal,handlerFormatValue:this.handlerFormatValue,loadingPayment:this.state.loadingPayment,sendRedemptionError:this.props.sendRedemptionError,sendRedemption:this.props.sendRedemption}));}}]);return FuelCreditContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref){var fuelCredit=_ref.fuelCredit,currencyConfiguration=_ref.catalog.currencyConfiguration,participant=_ref.participant,participantBalance=_ref.balance.pointsValue,oidc=_ref.oidc;var user=oidc.user;var _ref2=user||{},profile=_ref2.profile;return Object.assign({},fuelCredit,{currencyConfiguration:currencyConfiguration,participant:participant,participantBalance:participantBalance,clientId:profile&&profile['custom:client_id']});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadPackagesBySupplierId:function loadPackagesBySupplierId(shellSupplierId,clientId){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_FuelCredit__["b" /* actions */].loadPackagesBySupplierId(shellSupplierId,clientId));},redemptionFuelCredit:function redemptionFuelCredit(order,supplierId){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_FuelCredit__["b" /* actions */].redemptionFuelCredit(order,supplierId));},closeError:function closeError(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Services_FuelCredit__["b" /* actions */].closeError());}};};var packageType=__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({description:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,partnerId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired});FuelCreditContainer.propTypes={packages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(packageType).isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,loadPackagesBySupplierId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,participant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,redemptionFuelCredit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,sendRedemptionError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,sendRedemption:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,packageSelected:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,closeError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,participantBalance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,descriptionErrorFuelCredit:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,clientId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(FuelCreditContainer));

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_ModalServices_ModalServices__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_services_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_template_services_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_template_services_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder_lib_reactPlaceholder_css__);
var showError=function showError(error,handleCloseError){return error.hasError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Alert"],{isError:true,title:error.title,description:error.description,className:'pb-2',onClose:function onClose(){return handleCloseError();}}):'';};var FuelCredit=function FuelCredit(_ref){var isloading=_ref.isloading,handleCloseError=_ref.handleCloseError,errorField=_ref.errorField,closeterms=_ref.closeterms,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,sendRedemptionError=_ref.sendRedemptionError,sendRedemption=_ref.sendRedemption,packages=_ref.packages,handlerChangePackage=_ref.handlerChangePackage,packageSelected=_ref.packageSelected,currencyConfiguration=_ref.currencyConfiguration,shellSupplierId=_ref.shellSupplierId,regulationType=_ref.regulationType,showModal=_ref.showModal,handlerFormatValue=_ref.handlerFormatValue,handlerFinalizePayment=_ref.handlerFinalizePayment,loadingPayment=_ref.loadingPayment,errorPage=_ref.errorPage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_placeholder___default.a,{ready:true,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["c" /* FuelCreditPlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Shell Box - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 px-md-1 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-0 pb-3 py-md-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-0 pt-md-0'},showError(errorPage,handleCloseError),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-servicos-shell radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title-2 txt-circular-book'},'Shell Box'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Abaste\xE7a o seu ve\xEDculo com pontos. Escolha o valor em cr\xE9ditos que deseja utilizar.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* FormFuelCredit */],{errorField:errorField,isloading:isloading,packages:packages,handlerChangePackage:handlerChangePackage,packageSelected:packageSelected,currencyConfiguration:currencyConfiguration,handlerFormatValue:handlerFormatValue})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Services_ModalServices_ModalServices__["a" /* default */],{title:'Termos do Regulamento de Shell Box',show:showModal,onClose:closeterms,acceptTerms:function acceptTerms(e){return acceptTermsEvent(true);},terms:{vendorId:shellSupplierId,type:regulationType},isLoading:sendRedemption}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["d" /* Sidebar */],{showTermsEvent:showTermsEvent,acceptTermsEvent:acceptTermsEvent,acceptTerms:acceptTerms,handlerFinalizePayment:handlerFinalizePayment,packageSelected:packageSelected,handlerFormatValue:handlerFormatValue,currencyConfiguration:currencyConfiguration,pointsValue:packageSelected.pointsQuantity||0,creditValue:packageSelected.description||'0',creditName:'Shell Box',loadingPayment:sendRedemption})))));};FuelCredit.propTypes={isloading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handleCloseError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,errorField:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,closeterms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,sendRedemptionError:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,sendRedemption:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,packages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handlerChangePackage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,packageSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,shellSupplierId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,regulationType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,showModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handlerFormatValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,loadingPayment:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,errorPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (FuelCredit);

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });


/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FuelCreditSection__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfoSection__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
var Sidebar=function Sidebar(_ref){var creditName=_ref.creditName,creditValue=_ref.creditValue,pointsValue=_ref.pointsValue,handlerFinalizePayment=_ref.handlerFinalizePayment,loadingPayment=_ref.loadingPayment,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,handlerFormatValue=_ref.handlerFormatValue,currencyConfiguration=_ref.currencyConfiguration;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'color-title txt-font-body'},'Resumo do resgate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FuelCreditSection__["a" /* default */],{creditName:creditName,creditValue:creditValue.split(' ')[0],pointsValue:handlerFormatValue(pointsValue,currencyConfiguration.decimalPlaces)+' '+currencyConfiguration.pointsName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InfoSection__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Checkbox"],{style:{position:'relative',marginLeft:'20px'},id:'aceito_termos',checked:acceptTerms,className:'col-auto',labelClass:'l-0',outerLabel:true,onChange:function onChange(e){return acceptTermsEvent(e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return showTermsEvent();},className:'txt-body-sm color-brand-2 txt-underline',role:'button'},'termos do regulamento')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},loadingPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-featured btn-icon','aria-label':'Carregando...'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{className:'btn-featured btn-icon',disabled:validButton(creditName,creditValue,pointsValue,acceptTerms),text:'Finalizar compra',iconName:'icon_gift',onClick:handlerFinalizePayment})))));};var validButton=function validButton(creditName,creditValue,pointsValue,acceptTerms){var result=!!(creditName&&creditValue&&pointsValue&&acceptTerms);return!result?'disabled':'';};Sidebar.propTypes={creditName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,loadingPayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,creditValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerFormatValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var BarCodeSection=function BarCodeSection(_ref){var creditName=_ref.creditName,creditValue=_ref.creditValue,pointsValue=_ref.pointsValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Cr\xE9dito: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,creditName||'Shell Box')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm  txt-font-body color-ui-2'},'Valor em cr\xE9ditos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',creditValue,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Valor em pontos: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,pointsValue,' ')));};BarCodeSection.propTypes={creditName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (BarCodeSection);

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var InfoSection=function InfoSection(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-subtitle txt-font-body color-ui-2'},'O valor pode ser creditado em at\xE9 10 dias \xFAteis. Caso o valor n\xE3o seja creditado nesse per\xEDodo, entre em contato com a nossa central de atendimento.'));};/* harmony default export */ __webpack_exports__["a"] = (InfoSection);

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var FormFuelCredit=function FormFuelCredit(_ref){var errorField=_ref.errorField,isLoadingChangeAccountType=_ref.isLoadingChangeAccountType,packages=_ref.packages,handlerChangePackage=_ref.handlerChangePackage,packageSelected=_ref.packageSelected,currencyConfiguration=_ref.currencyConfiguration,handlerFormatValue=_ref.handlerFormatValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'FuelCredit',label:'Quantos cr\xE9ditos voc\xEA deseja?',className:'col-12 col-md-6',displayValue:'description',selectedValue:'id',options:packages||[],onChange:handlerChangePackage,'data-error':'Nenhum crédito selecionado',valid:errorField,value:packageSelected.id?packageSelected:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'voce_vai_obter',label:'Valor em pontos',className:'col-12 col-md-6',value:handlerFormatValue(packageSelected.pointsQuantity||0,currencyConfiguration.decimalPlaces)+' '+currencyConfiguration.pointsName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto '+(isLoadingChangeAccountType?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))));};FormFuelCredit.propTypes={errorField:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isLoadingChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,packages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handlerChangePackage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,packageSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,currencyConfiguration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,handlerFormatValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (FormFuelCredit);

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_template_placeholder_css__);
var FuelCreditPlaceholder=function FuelCreditPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 pr-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 py-5 radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-3 radius'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 py-half bg-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1 py-1 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-5 py-1 bg-ui-4 radius'}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-4 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-4 bg-ui-3 radius'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (FuelCreditPlaceholder);

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Donation__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ducks__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Checkout__ = __webpack_require__(122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DonationContainer=function(_Component){_inherits(DonationContainer,_Component);function DonationContainer(props){_classCallCheck(this,DonationContainer);var _this=_possibleConstructorReturn(this,(DonationContainer.__proto__||Object.getPrototypeOf(DonationContainer)).call(this,props));_this.count=0;_this.state={isloading:true,serviceId:'',isLoadingChangeAccountType:false,vendorId:0,accountType:[],barCode:'',documentNumber:props.cpf?props.cpf.value:'',data:'',billValue:0,pointsValue:0,isPriceEditable:false,name:'',errorPage:null,error:null,successPage:null,errorField:null,showTerms:false,acceptTerms:false,sendRedemptionError:props.sendRedemptionError,institutions:[],donationPointsValue:0,convertedValue:0,imageUrl:'',validateConversion:false,idDonation:0,secondFactorAuthentication:{enable:false,AuthenticationConfirmed:true,confirmedOrderId:0}};_this.handlerChangeAccountType=_this.handlerChangeAccountType.bind(_this);_this.handlerGetBarCode=_this.handlerGetBarCode.bind(_this);_this.handlerGetData=_this.handlerGetData.bind(_this);_this.handlerCloseError=_this.handlerCloseError.bind(_this);_this.handlerCloseSuccess=_this.handlerCloseSuccess.bind(_this);_this.handlerFinalizePayment=_this.handlerFinalizePayment.bind(_this);_this.handlerAccountTypes=_this.handlerAccountTypes.bind(_this);_this.institutions=_this.handlerListInstitutions.bind(_this);_this.closeterms=_this.closeterms.bind(_this);_this.acceptTermsEvent=_this.acceptTermsEvent.bind(_this);_this.showTermsEvent=_this.showTermsEvent.bind(_this);_this.handlerServiceId=_this.handlerServiceId.bind(_this);_this.handlerDonatedPoints=_this.handlerDonatedPoints.bind(_this);_this.handlerConvertionPointsToCash=_this.handlerConvertionPointsToCash.bind(_this);_this.handlerFinalizeDonation=_this.handlerFinalizeDonation.bind(_this);return _this;}_createClass(DonationContainer,[{key:'componentDidMount',value:function componentDidMount(){if(this.count===0){this.count++;var client=__WEBPACK_IMPORTED_MODULE_2_redux_clients__["a" /* default */].cloudloyalty.client;this.client=client;this.handlerListInstitutions();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.secondFactorAuthSuccess!==this.props.SecondFactorAuthSuccess){if(this.props.SecondFactorAuthSuccess&&!this.props.hasError){this.props.closeModal();this.props.redirectConfirmation('/confirmation/'+(this.state.secondFactorAuthentication&&this.state.secondFactorAuthentication.confirmedOrderId));}else if(this.props.hasError&&this.state.secondFactorAuthentication.enable){this.handlerSecondFactorAuthenticationEnable(false);}}}},{key:'handlerSecondFactorAuthenticationEnable',value:function handlerSecondFactorAuthenticationEnable(enable){this.props.closeModal();this.props.clearRedux();var messageError=this.props.messageError;this.handlerShowErrorPage('Não foi possível concluir a sua transferência',messageError);this.setState({secondFactorAuthentication:{enable:enable}});}},{key:'closeError',value:function closeError(){this.setState({errorPage:null});}},{key:'acceptTermsEvent',value:function acceptTermsEvent(){if(this.state.acceptTerms){this.setState({showTerms:false,acceptTerms:false});}else{this.setState({showTerms:false,acceptTerms:true});}}},{key:'showTermsEvent',value:function showTermsEvent(){this.setState({showTerms:true});}},{key:'closeterms',value:function closeterms(){this.setState({showTerms:false});}},{key:'handlerGetBarCode',value:function handlerGetBarCode(e){this.setState({barCode:e.target.value&&e.target.value.trim()});}},{key:'handlerGetData',value:function handlerGetData(e){this.setState({data:e.target.value});}},{key:'handlerDonatedPoints',value:function handlerDonatedPoints(e){this.setState({donationPointsValue:e});}},{key:'handlerServiceId',value:function handlerServiceId(e){this.setState({serviceId:e.serviceId});this.setState({vendorId:e.value});this.setState({imageUrl:e.imageUrl});}},{key:'handlerConvertionPointsToCash',value:function handlerConvertionPointsToCash(e){var _this2=this;e<=0?this.setState({validateConversion:false}):this.setState({validateConversion:true});var modelToConvert={vendorId:this.state.vendorId,serviceId:this.state.serviceId,pointsValue:e};this.setState({donationPointsValue:e});this.client.put('/v1/donation/',modelToConvert).then(function(response){_this2.setState({convertedValue:response.data.cashValue});}).catch(this.setState({convertedValue:0}));}},{key:'handlerChangeAccountType',value:function handlerChangeAccountType(e){var _this3=this;var serviceId=e.value;this.setState({isLoadingChangeAccountType:true});this.client.get('/v1/billPayments/vendor/'+this.state.vendorId+'/service/'+serviceId+'/validate/'+this.state.barCode).then(function(result){_this3.setState(Object.assign({},result.data,{errorField:null,serviceId:e.value,isLoadingChangeAccountType:false}));}).catch(function(ex){return _this3.ExceptionChangeAccountType(ex);});}},{key:'ExceptionChangeAccountType',value:function ExceptionChangeAccountType(ex){var data=ex.response.data;if(data.errors[0].code===11){this.setState({errorField:false,billValue:0,pointsValue:0.0,isPriceEditable:true,name:'',isloading:false,isLoadingChangeAccountType:false});}}},{key:'handlerListInstitutions',value:function handlerListInstitutions(){var _this4=this;this.setState({loadingPayment:false});this.client.get('/v1/donation').then(function(result){_this4.setState({isloading:false,institutions:result.data});}).catch(function(ex){return console.error(ex);});}},{key:'handlerFinalizePayment',value:function handlerFinalizePayment(){var _this5=this;if(!this.state.acceptTerms){return this.handlerShowErrorPage('Regulamento','Favor aceitar o Regulamento!');}var payment={serviceId:this.state.serviceId,barCode:this.state.barCode,dueDate:__WEBPACK_IMPORTED_MODULE_6_moment___default()(this.state.data,'DD/MM/YYYY').format('MM/DD/YYYY'),documentNumber:this.state.documentNumber,billValue:this.state.billValue};this.setState({loadingPayment:true});this.client.post('/v1/purchases/billPayment',payment).then(function(response){_this5.setState({loadingPayment:false,successPage:{title:'Pagamento!',description:'Seu pagamento foi realizado com sucesso!'},serviceId:'',barCode:'',data:'',billValue:'',pointsValue:'',name:''});var id=response.data.id;_this5.setState({idDonation:id});_this5.props.redirectConfirmation('/confirmation/'+id);}).catch(function(ex){return _this5.ExceptionFinalizePayment(ex);});}},{key:'ExceptionFinalizePayment',value:function ExceptionFinalizePayment(ex){var data=ex.response.data;this.setState({loadingPayment:false});var message=data?data.errors[0].message.replace('DueDate inválido','Data de vencimento inválida'):data;this.handlerShowErrorPage('Erro ao tentar efetuar o pagamento!',data?message:'problemas técnicos');}},{key:'handlerCloseError',value:function handlerCloseError(){this.setState({sendRedemptionError:null});}},{key:'handlerCloseSuccess',value:function handlerCloseSuccess(){this.setState({successPage:null});}},{key:'handlerShowErrorPage',value:function handlerShowErrorPage(title,description){var _this6=this;this.setState({errorPage:{title:title,description:description,closeError:function closeError(){return _this6.closeError();}}});}},{key:'handlerAccountTypes',value:function handlerAccountTypes(){var _this7=this;this.client.get('/v1/billPayments/vendor/'+this.state.vendorId+'/service').then(function(result){_this7.setState({isloading:false,accountType:result.data});}).catch(function(){return _this7.handlerShowErrorPage('! tipos de contas','erro ao tentar obter os tipos de contas');});}},{key:'handlerFinalizeDonation',value:function handlerFinalizeDonation(){var _this8=this;this.setState({loadingPayment:true});var model={vendorId:this.state.vendorId,serviceId:this.state.serviceId,costPrice:this.state.convertedValue,type:3,configuration:[]};model.configuration.push({key:'AcceptRegulation',value:!__WEBPACK_IMPORTED_MODULE_7_yn___default()("true")||this.state.acceptTerms?'true':'false'});this.client.post('/v1/purchases/service',model).then(function(_ref){var data=_ref.data;_this8.setState({loadingPayment:false});if(data.status==='RequiresTokenValidation'){_this8.setState({secondFactorAuthentication:{enable:true,AuthenticationConfirmed:true,confirmedOrderId:data.id}});}else{_this8.props.redirectConfirmation({pathname:'/confirmation/'+data.id});}}).catch(function(error){if(error.response.data.status==='MessageOnBoardingRequired'){_this8.setState({secondFactorAuthentication:{enable:true,AuthenticationConfirmed:false}});}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Donation__["a" /* default */],Object.assign({},this.state,{handlerServiceId:this.handlerServiceId,handlerFinalizeDonation:this.handlerFinalizeDonation,handlerDonatedPoints:this.handlerDonatedPoints,handlerConvertionPointsToCash:this.handlerConvertionPointsToCash,handlerChangeAccountType:this.handlerChangeAccountType,handlerFinalizePayment:this.handlerFinalizePayment,handlerGetBarCode:this.handlerGetBarCode,handlerGetData:this.handlerGetData,handlerCloseError:this.handlerCloseError,handlerCloseSuccess:this.handlerCloseSuccess,handlerListInstitutions:this.handlerListInstitutions,acceptTermsEvent:this.acceptTermsEvent,closeterms:this.closeterms,showTermsEvent:this.showTermsEvent,participantPoints:this.props.pointsValue,oidc:this.props.oidc,closeModal:this.props.closeModal,authorizeWithTokenResend:this.props.authorizeWithTokenResend,authorizeWithToken:this.props.authorizeWithToken,authorizeWithTokenLastTry:this.props.authorizeWithTokenLastTry,isCreatingPurchase:this.props.isCreatingPurchase,errorToken:this.props.errorToken,errorPage:this.state.errorPage}));}}]);return DonationContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(_ref2){var cpf=_ref2.participant.cpf,oidc=_ref2.oidc,fuelCredit=_ref2.fuelCredit,balance=_ref2.balance,checkout=_ref2.checkout,pointsPurchase=_ref2.pointsPurchase;var user=oidc.user;var _ref3=user||{},profile=_ref3.profile;pointsPurchase.hasError=pointsPurchase.hasError||checkout.errorToken;return Object.assign({SecondFactorAuthentication:pointsPurchase.SecondFactorAuthentication&&!checkout.secondFactorAuthSuccess,SecondFactorAuthenticationConfirmed:pointsPurchase.SecondFactorAuthenticationConfirmed,SecondFactorAuthSuccess:checkout.secondFactorAuthSuccess,hasError:checkout.hasError,isCreatingPurchase:checkout.isCreatingPurchase,errorToken:checkout.errorToken,cpf:cpf,catalogId:!profile?null:profile['custom:catalog_id'],pointsValue:balance.pointsValue},fuelCredit,{oidc:oidc,messageError:checkout.messageError});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{redirectConfirmation:function redirectConfirmation(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["push"])(path));},loadConfiguration:function loadConfiguration(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__ducks__["c" /* fetchPointPurchaseConfiguration */])());},checkout:function checkout(purchase){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__ducks__["a" /* checkoutPointsPurchase */])(purchase));},closeModal:function closeModal(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__ducks__["b" /* clearSecondFactorAuthentication */])());},clearRedux:function clearRedux(){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Checkout__["c" /* actions */].clearRedux());},authorizeWithToken:function authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){var lastTry=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;return dispatch(__WEBPACK_IMPORTED_MODULE_9__Checkout__["c" /* actions */].authorizeWithToken(OrderId,PaymentMoneyRequest,Token,TokenType,Resend,lastTry));},authorizeWithTokenResend:function authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Checkout__["c" /* actions */].authorizeWithTokenResend(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));},authorizeWithTokenLastTry:function authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Checkout__["c" /* actions */].authorizeWithTokenLastTry(OrderId,PaymentMoneyRequest,Token,TokenType,Resend));}};};DonationContainer.propTypes={cpf:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,redirectConfirmation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,sendRedemptionError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,pointsValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,loggedUser:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,closeModal:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,oidc:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,errorToken:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,SecondFactorAuthentication:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,SecondFactorAuthSuccess:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,SecondFactorAuthenticationConfirmed:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,confirmedOrderId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,authorizeWithToken:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,authorizeWithTokenLastTry:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,isCreatingPurchase:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,hasError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,secondFactorAuthSuccess:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,clearRedux:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,messageError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(DonationContainer));

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CellphoneRecharge_ModalTermsDonation_ModalTermsDonation__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_services_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_services_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_services_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkout_SecondFactorAuthenticaton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_placeholder_lib_reactPlaceholder_css__);
var _this=this;// @ts-nocheck
var showError=function showError(error,handlerCloseError){return error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Alert"],{isError:true,title:'Não foi possível concluir sua transferência',description:'Vamos tentar novamente, por favor verifique os campos baixo.',className:'pb-2',onClose:function onClose(){return handlerCloseError();}}):'';};var customError=function customError(error){return error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Alert"],{isError:true,title:error.title,description:error.description,className:'pb-2',onClose:function onClose(){return error.closeError();}}):'';};var Donation=function Donation(_ref){var isloading=_ref.isloading,isLoadingChangeAccountType=_ref.isLoadingChangeAccountType,accountType=_ref.accountType,handlerChangeAccountType=_ref.handlerChangeAccountType,handlerGetBarCode=_ref.handlerGetBarCode,handlerGetData=_ref.handlerGetData,handlerFinalizePayment=_ref.handlerFinalizePayment,handlerListInstitutions=_ref.handlerListInstitutions,handlerFinalizeDonation=_ref.handlerFinalizeDonation,institutions=_ref.institutions,handlerConvertionPointsToCash=_ref.handlerConvertionPointsToCash,handlerServiceId=_ref.handlerServiceId,handlerDonatedPoints=_ref.handlerDonatedPoints,handlerCloseError=_ref.handlerCloseError,billValue=_ref.billValue,participantPoints=_ref.participantPoints,isPriceEditable=_ref.isPriceEditable,barCode=_ref.barCode,data=_ref.data,errorPage=_ref.errorPage,errorField=_ref.errorField,name=_ref.name,loadingPayment=_ref.loadingPayment,showTerms=_ref.showTerms,closeterms=_ref.closeterms,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,vendorId=_ref.vendorId,catalogId=_ref.catalogId,sendRedemptionError=_ref.sendRedemptionError,donationPointsValue=_ref.donationPointsValue,convertedValue=_ref.convertedValue,imageUrl=_ref.imageUrl,validateConversion=_ref.validateConversion,secondFactorAuthentication=_ref.secondFactorAuthentication,oidc=_ref.oidc,closeModal=_ref.closeModal,authorizeWithTokenResend=_ref.authorizeWithTokenResend,authorizeWithToken=_ref.authorizeWithToken,authorizeWithTokenLastTry=_ref.authorizeWithTokenLastTry,isCreatingPurchase=_ref.isCreatingPurchase,errorToken=_ref.errorToken;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Doa\xE7\xE3o - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_placeholder___default.a,{ready:!isloading,customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["b" /* DonationPlaceholder */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid px-0 px-md-1 pt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container pt-0 pt-md-5 pb-3 py-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-0'},showError(sendRedemptionError,handlerCloseError),customError(errorPage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-servicos-donation radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'h2 color-ui-white txt-title-2 txt-circular-book'},'Ajude-nos a fazer mais',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'por quem precisa'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Selecione a quantidade de pontos, a institui\xE7\xE3o que voc\xEA quer ajudar e faremos um resgate.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm border-dashed-bottom border-color-ui-3 pb-2'},'Sua contribui\xE7\xE3o faz toda a diferen\xE7a!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["c" /* FormDonation */],{accountType:accountType,handlerConvertionPointsToCash:handlerConvertionPointsToCash,handlerServiceId:handlerServiceId,handlerChangeAccountType:handlerChangeAccountType,handlerGetBarCode:handlerGetBarCode,handlerGetData:handlerGetData,handlerDonatedPoints:handlerDonatedPoints,institutions:institutions,handlerListInstitutions:handlerListInstitutions,billValue:billValue,pointsValue:participantPoints,isPriceEditable:isPriceEditable,barCode:barCode,errorField:errorField,isloading:isloading,isLoadingChangeAccountType:isLoadingChangeAccountType,vendorId:vendorId,imageUrl:imageUrl})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CellphoneRecharge_ModalTermsDonation_ModalTermsDonation__["a" /* default */],{show:showTerms,terms:{type:'Vendor',vendorId:vendorId,catalogId:catalogId},onClose:closeterms,acceptTerms:acceptTermsEvent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["d" /* Sidebar */],{barCode:barCode,name:name,data:data,billValue:billValue,donationPointsValue:donationPointsValue,convertedValue:convertedValue,handlerFinalizePayment:handlerFinalizePayment,handlerFinalizeDonation:handlerFinalizeDonation,loadingPayment:loadingPayment,showTermsEvent:showTermsEvent,acceptTermsEvent:acceptTermsEvent,acceptTerms:acceptTerms,validateConversion:validateConversion}))),secondFactorAuthentication&&secondFactorAuthentication.enable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modalConfirmationVoucher'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Checkout_SecondFactorAuthenticaton__["a" /* SecondFactorAuthentication */],Object.assign({show:secondFactorAuthentication&&secondFactorAuthentication.enable,secondFactorAuthConfirmated:secondFactorAuthentication&&secondFactorAuthentication.AuthenticationConfirmed,confirmedOrderId:secondFactorAuthentication&&secondFactorAuthentication.confirmedOrderId,oidc:oidc},_this.props,{paymentSelected:'POINTS_ONLY',closeModal:closeModal,authorizeWithTokenResend:authorizeWithTokenResend,authorizeWithToken:authorizeWithToken,authorizeWithTokenLastTry:authorizeWithTokenLastTry,isCreatingPurchase:isCreatingPurchase,errorToken:errorToken}))))));};Donation.propTypes={isloading:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isLoadingChangeAccountType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,loadingPayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,accountType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,handlerChangeAccountType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerGetBarCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerGetData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerListInstitutions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerConvertionPointsToCash:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,institutions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,handlerCloseError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerCloseSuccess:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,billValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,participantPoints:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,isPriceEditable:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,barCode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,data:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,errorPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,successPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,errorField:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,closeterms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,vendorId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,catalogId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,sendRedemptionError:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,handlerServiceId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,handlerDonatedPoints:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,donationPointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,convertedValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,handlerFinalizeDonation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,imageUrl:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,validateConversion:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,secondFactorAuthentication:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,oidc:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,errorToken:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,secondFactorAuthSuccess:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,secondFactorAuthenticationConfirmed:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,confirmedOrderId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,closeModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,authorizeWithTokenResend:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,authorizeWithToken:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,authorizeWithTokenLastTry:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,isCreatingPurchase:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Donation);

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Regulation__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal__);
var ModalTermsDonation=function ModalTermsDonation(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_awesome_modal___default.a,{width:'1180',height:'345',effect:'fadeInUp',onClickAway:function onClickAway(){return props.onClose();},visible:props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 border-bottom-lg border-color-featured bg-white py-4 mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Termos do regulamento de doa\xE7\xF5es')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'close',name:'Close',className:'btn btn-double btn-flat btn-icon-only btn-icon',iconName:'icon_close icon-sm',text:'','aria-label':'Fechar',onClick:function onClick(e){return props.onClose();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mx-0 mt-4 pl-3 pr-1 py-3 bg-ui-4 border-top border-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pr-3 color-ui-2 txt-font-body txt-body-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Regulation__["a" /* Regulation */],{vendorId:props.terms.vendorId}),'Diante da referida premia\xE7\xE3o, declaro para todos os fins que aceito doar pontos para o Programa Movimento Solid\xE1rio, para desenvolver os objetivos de desenvolvimento sustent\xE1vel, na qual disponho do valor em prol ao programa.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u201CSegundo a legisla\xE7\xE3o fiscal vigente esta doa\xE7\xE3o n\xE3o \xE9 dedut\xEDvel do Imposto de Renda\u201D.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  align-items-center h-100  px-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-2 px-0 txt-left mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'AddMoreProducts',name:'AddMoreProducts',className:'btn btn-sm btn-flat',iconName:'icon_left icon-sm',text:'Voltar',onClick:function onClick(e){return props.onClose();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-back col-4 px-0 txt-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Button"],{id:'Agree-donation',name:'Agree',className:'btn btn-double btn-featured btn-icon mx-0',iconName:'icon_check_circle',text:'LI E ACEITO O REGULAMENTO',onClick:function onClick(e){return props.acceptTerms();}})))))));};ModalTermsDonation.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,terms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ModalTermsDonation);

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_POINT_PURCHASE_CONFIG */
/* unused harmony export CHECKOUT_POINTS_PURCHASE */
/* unused harmony export CLEAR_SECOND_FACTOR_AUTHENTICATION */
/* unused harmony export CHECKOUT_POINTS_PURCHASE_SUCCESS */
/* unused harmony export CHECKOUT_POINTS_PURCHASE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearSecondFactorAuthentication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPointPurchaseConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkoutPointsPurchase; });
var FETCH_POINT_PURCHASE_CONFIG='checkout/points_purchase_config/FETCH';var CHECKOUT_POINTS_PURCHASE='checkout/points_purchase/FETCH';var CLEAR_SECOND_FACTOR_AUTHENTICATION='CLEAR_SECOND_FACTOR_AUTHENTICATION';var CHECKOUT_POINTS_PURCHASE_SUCCESS=CHECKOUT_POINTS_PURCHASE+'_SUCCESS';var CHECKOUT_POINTS_PURCHASE_FAIL=CHECKOUT_POINTS_PURCHASE+'_FAIL';var initialState={isLoading:false,config:{}};var type={REQUIRES_TOKEN_VALIDATION:'RequiresTokenValidation'};/* unused harmony default export */ var _unused_webpack_default_export = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case FETCH_POINT_PURCHASE_CONFIG:return Object.assign({},state,{isLoading:true,hasSuccess:false,hasError:false,errors:[],id:undefined});case CHECKOUT_POINTS_PURCHASE:return Object.assign({},state,{isLoading:true});case CHECKOUT_POINTS_PURCHASE_SUCCESS:return Object.assign({},state,ValidSecondFactorAuthentication(action));case CHECKOUT_POINTS_PURCHASE_FAIL:var errors=[];if(action.error.response.status===422){if(action.error.response.data.errors){errors=action.error.response.data.errors;}else{errors=action.error.response.data.map(function(error){return{message:error.Message};});}}return Object.assign({},state,{isLoading:false,hasError:true,errors:errors},ValidOnBoardingAuthentication(action));case CLEAR_SECOND_FACTOR_AUTHENTICATION:return Object.assign({},state,{SecondFactorAuthentication:false});case'AUTHORIZE_TOKEN_FAIL':return Object.assign({},state,{SecondFactorAuthSuccess:false});case'AUTHORIZE_TOKEN_SUCCESS':return Object.assign({},state,{SecondFactorAuthSuccess:true});default:return state;}});var ValidOnBoardingAuthentication=function ValidOnBoardingAuthentication(action){var status=action.error.response.status;if(status===406){return{SecondFactorAuthentication:true,SecondFactorAuthenticationConfirmed:false};}};var ValidSecondFactorAuthentication=function ValidSecondFactorAuthentication(action){var status=action.payload.data.status;if(type.REQUIRES_TOKEN_VALIDATION===status){return{isLoading:false,hasSuccess:false,SecondFactorAuthentication:true,id:action.payload.data.id,confirmedOrderId:action.payload.data.id,SecondFactorAuthenticationConfirmed:true};}else{return{isLoading:false,hasSuccess:true,SecondFactorAuthentication:false,id:action.payload.data.id,confirmedOrderId:action.payload.data.id,SecondFactorAuthenticationConfirmed:true};}};var clearSecondFactorAuthentication=function clearSecondFactorAuthentication(){return{type:'CLEAR_SECOND_FACTOR_AUTHENTICATION'};};var fetchPointPurchaseConfiguration=function fetchPointPurchaseConfiguration(){var vendorId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"61677";return{type:FETCH_POINT_PURCHASE_CONFIG,payload:{client:'cloudloyalty',request:{url:'/v2/purchase/configuration',params:{vendorId:vendorId}}}};};var checkoutPointsPurchase=function checkoutPointsPurchase(purchase){return{type:CHECKOUT_POINTS_PURCHASE,payload:{client:'cloudloyalty',request:{url:'/v1/purchases/points',method:'post',data:Object.assign({vendorId:"61677"},purchase)}}};};

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });


/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonationSection__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermsOption__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_yn__);
var Sidebar=function Sidebar(_ref){var creditName=_ref.creditName,creditValue=_ref.creditValue,pointsValue=_ref.pointsValue,donationPointsValue=_ref.donationPointsValue,handlerFinalizePayment=_ref.handlerFinalizePayment,handlerFinalizeDonation=_ref.handlerFinalizeDonation,loadingPayment=_ref.loadingPayment,acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent,convertedValue=_ref.convertedValue,validateConversion=_ref.validateConversion;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-12 col-md-4 mt-3 mt-md-0 px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-ui-3 radius bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'h3 color-title txt-font-body'},'Resumo da doa\xE7\xE3o')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DonationSection__["a" /* default */],{creditName:creditName,creditValue:convertedValue.toLocaleString('pt-br',{minimumFractionDigits:2}),donationPointsValue:donationPointsValue})),__WEBPACK_IMPORTED_MODULE_5_yn___default()("true")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TermsOption__["a" /* default */],{acceptTerms:acceptTerms,acceptTermsEvent:acceptTermsEvent,showTermsEvent:showTermsEvent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row px-2 pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},loadingPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-featured btn-icon','aria-label':'Carregando...'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_loyal_react__["Button"],{id:'finalize',className:'btn-featured btn-icon',disabled:!loadingPayment&&validButton(acceptTerms,validateConversion),text:'Finalizar doa\xE7\xE3o',iconName:'icon_donation',onClick:function onClick(){return handlerFinalizeDonation();}}))))));};var validButton=function validButton(acceptTerms,validateConversion){var result=(!__WEBPACK_IMPORTED_MODULE_5_yn___default()("true")||!!acceptTerms)&&!!validateConversion;return!result?'true':'false';};Sidebar.propTypes={creditName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,loadingPayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,creditValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,pointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,handlerFinalizePayment:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTerms:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,donationPointsValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,convertedValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,handlerFinalizeDonation:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,validateConversion:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__ = __webpack_require__(21);
var DonationSection=function DonationSection(_ref){var barCode=_ref.barCode,accountType=_ref.accountType,creditValue=_ref.creditValue,donationPointsValue=_ref.donationPointsValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm txt-font-body color-ui-2'},'Transa\xE7\xE3o: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Doa\xE7\xE3o de pontos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm  txt-font-body color-ui-2'},'Valor:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Shared_CurrencyLabel__["a" /* CatalogCurrencyLabel */],{value:donationPointsValue}),' = R$ ',creditValue)));};DonationSection.propTypes={barCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,accountType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,creditValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,donationPointsValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (DonationSection);

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
var TermsOption=function TermsOption(_ref){var acceptTerms=_ref.acceptTerms,acceptTermsEvent=_ref.acceptTermsEvent,showTermsEvent=_ref.showTermsEvent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Checkbox"],{style:{position:'relative',marginLeft:'20px'},id:'aceito_termos',checked:acceptTerms,className:'col-auto',labelClass:'l-0',outerLabel:true,onChange:function onChange(e){return acceptTermsEvent(e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},' ','Li e aceito os',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return showTermsEvent();},className:'txt-body-sm color-brand-2 txt-underline',role:'button'},'termos do regulamento'))))));};TermsOption.propTypes={acceptTerms:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showTermsEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,acceptTermsEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (TermsOption);

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_donation_css__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loyal_template_donation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loyal_template_donation_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var bgImage={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a+')',backgroundSize:'cover',backgroundPositionY:'-17px'};var bgImageMobile={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a+')',backgroundSize:'contain',backgroundPositionX:'center',backgroundPositionY:'-20px',backgroundRepeat:'no-repeat'};var Donation=function(_Component){_inherits(Donation,_Component);function Donation(props){_classCallCheck(this,Donation);var _this=_possibleConstructorReturn(this,(Donation.__proto__||Object.getPrototypeOf(Donation)).call(this,props));_this.handleValueChange=function(event){return _this.setState({value:_this.state.totalPoints>event.target.value?event.target.value:Math.floor(_this.state.totalPoints)});};_this.state={value:'',totalPoints:_this.props.pointsValue,handlerListInstitutions:_this.props.handlerListInstitutions,handlerConvertionPointsToCash:_this.props.handlerConvertionPointsToCash,handlerServiceId:_this.props.handlerServiceId,handlerDonatedPoints:_this.props.handlerDonatedPoints,vendorId:_this.props.vendorId,imageUrl:_this.props.imageUrl,institutions:_this.props.institutions.map(function(item){return{text:item.name,value:item.id,serviceId:item.services[0].id,imageUrl:item.imageUrl};})};return _this;}_createClass(Donation,[{key:'numberToStrCurrency',value:function numberToStrCurrency(value,decimalPlaces){return value.toLocaleString('pt-br',{minimumFractionDigits:decimalPlaces,maximumFractionDigits:decimalPlaces});}},{key:'render',value:function render(){var _this2=this;this.numberToStrCurrency(this.state.totalPoints-this.state.value,this.props.decimalPlaces);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row border-dashed-bottom border-color-ui-3 mx-0 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm mb-1'},'Escolha a Institui\xE7\xE3o beneficiada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Select"],{id:'institutions',label:'Institui\xE7\xE3o',className:'col-12',hasEmpty:true,displayValue:'text',selectedValue:'value',options:this.state.institutions,onChange:function onChange(e){return _this2.props.handlerServiceId(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-2 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0 d-none d-md-flex align-items-center donation-institution-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default.a,{src:this.props.imageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'img-w-auto',style:bgImage,alt:'','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-1 mt-2 d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 mx-auto py-1  radius txt-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_image_fallback___default.a,{src:this.props.imageUrl,fallbackImage:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,initialImage:__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a,className:'w-75',style:bgImageMobile,alt:'','aria-hidden':'true'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-1 mr-0 my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'col-12 txt-body-sm mb-1'},'Selecione o valor que deseja doar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Input"],{id:'pontosDoados',className:'col-6 col-md-3',childrenClassName:'radius has-content',label:'Doa\xE7\xE3o em '+this.props.label,type:'text',min:'1',placeholder:0,value:this.state.value,onBlur:this.props.handlerConvertionPointsToCash(this.state.value>0?this.state.value:0),onChange:this.handleValueChange,disabled:!(this.state.totalPoints>0)||!this.props.imageUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-loading mr-auto ml-auto '+(this.props.isLoadingChangeAccountType?'d-block':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))));}}]);return Donation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Donation.propTypes={pointsValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,vendorId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,isLoadingChangeAccountType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,handlerListInstitutions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,institutions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handlerConvertionPointsToCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerServiceId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handlerDonatedPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,decimalPlaces:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref){var currencyConfiguration=_ref.catalog.currencyConfiguration;return{label:currencyConfiguration.pointsName,decimalPlaces:currencyConfiguration.decimalPlaces};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,null)(Donation));

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_placeholder_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_placeholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_placeholder_css__);
var bgImage={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_1__loyal_images_products_product_placeholder_png___default.a+')',backgroundSize:'cover',backgroundPositionY:'-25px'};var DonationPlaceholder=function DonationPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container py-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 pr-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 py-5 radius-top row align-items-center px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 py-half bg-ui-3 radius'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row radius-bottom bg-white px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-2 pt-2 pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 mt-1 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 mt-1 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 py-half bg-ui-4 mt-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-half bg-ui-4 my-2 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row ml-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-2 pb-3 border-ui-4 radius'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-3 pb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 py-half bg-ui-4 mb-1 radius'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-2 border-ui-4 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 mr-0 pl-2 pr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mr-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 bg-ui-4 radius',style:bgImage}))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-side col-4 border-ui-3 radius bg-white px-0 py-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 py-half bg-ui-3 radius'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotal col-12 pb-3 mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9  txt-left  justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row product-brand pt-3  px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-7 py-half bg-ui-4 radius'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-done row  px-2 pt-2 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 justify-content-center align-self-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 mt-1 shimmer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pt-3 pb-4 bg-ui-3 radius'})))))))));};/* harmony default export */ __webpack_exports__["a"] = (DonationPlaceholder);

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PointsAndCash__ = __webpack_require__(1959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PointsAndCash__["a"]; });


/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Showcase__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_points_and_cash_css__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_points_and_cash_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_points_and_cash_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PointsAndCash=function(_Component){_inherits(PointsAndCash,_Component);function PointsAndCash(){_classCallCheck(this,PointsAndCash);return _possibleConstructorReturn(this,(PointsAndCash.__proto__||Object.getPrototypeOf(PointsAndCash)).apply(this,arguments));}_createClass(PointsAndCash,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Pontos + '+(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'Dinheiro')+' - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'px-0 bg-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-pointsandcash container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'color-ui-white txt-title-2 txt-circular-black txt-center txt-md-left'},'Conhe\xE7a a melhor forma',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'d-none d-md-inline-block'}),'de resgatar seus pr\xEAmios.',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'d-none d-md-inline-block'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color-brand-6'},'Pontos'),' +',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color-brand-6'},Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_PAYMENT_COMPLEMENT_TEXT||'dinheiro')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container not-found'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h2 txt-center txt-circular-book'},'Veja como \xE9 simples:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md bg-white px-3 py-3 radius mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_cart',className:'color-brand-1  icon-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book mb-1 mt-2'},'Encontre o seu produto e coloque no carrinho'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'O cat\xE1logo de pr\xEAmios conta com milhares de produtos dispon\xEDveis para resgate.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'step-separator ml-auto mr-auto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md bg-white px-3 py-3 radius mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_card',className:'color-brand-1 icon-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book mb-1 mt-2'},'No pagamento escolha pontos + cart\xE3o de cr\xE9dito'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Deslize a barra de pontos at\xE9 o valor desejado e coloque os dados do cart\xE3o.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm pt-1'},'A op\xE7\xE3o do complemento aparece quando voc\xEA tem pelo menos 30% do valor do produto em pontos e n\xE3o h\xE1 saldo suficiente.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto px-2 d-none d-md-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row h-100 align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'step-separator ml-auto mr-auto'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md bg-white px-3 py-3 radius mt-2 mt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_check',className:'color-brand-1  icon-lg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'txt-circular-book mb-1 mt-2'},'Pronto! Agora \xE9 s\xF3 clicar em finalizar compra'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-body-sm'},'Acompanhe o seu pedido at\xE9 a entrega e aproveite as nossas ofertas di\xE1rias.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Catalog_Showcase__["e" /* default */],{showcaseType:'5',identifier:'home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Catalog_Showcase__["e" /* default */],{showcaseType:'7',identifier:'home'}))));}}]);return PointsAndCash;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PointsAndCash);

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseSearch__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ducks__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Shared_HeadMetadata_ducks__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_template_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Catalog_Service_ServiceCard__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductCard__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductCard_Tagging__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Title__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_aria_modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_aria_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_aria_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Main component logic based on search
var MainComponent=function MainComponent(_ref){var services=_ref.services,titleShowcase=_ref.titleShowcase,categoryName=_ref.categoryName,products=_ref.products,isSearch=_ref.isSearch,hasMoreItems=_ref.hasMoreItems,loadItems=_ref.loadItems,activeTagging=_ref.activeTagging,activePagination=_ref.activePagination,notFound=_ref.notFound;if(notFound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* NotFound */],{isSearch:isSearch});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:function loadMore(){activeTagging();activePagination();loadItems();},hasMore:hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},services.map(function(service){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Catalog_Service_ServiceCard__["a" /* ServiceCardContainer */],{className:'col-6 col-lg-4 mb-2 px-1 d-md-flex',path:service.path,key:service.name,name:service.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Catalog_Service_ServiceCard__["a" /* ServiceCardContainer */],{isResponsiveEnabled:true,className:'col-12 mb-1 px-half d-block card-mobile',path:service.path,key:service.name+'_mobile',name:service.name})));}),products.map(function(product,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],{className:'col-6 col-lg-4 mb-2 px-1 d-md-block',sku:product.sku,key:product.sku,identifier:'search-page',titleShowcase:titleShowcase,categoryName:categoryName,position:index})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],{isResponsiveEnabled:true,className:'col-12 mb-1 px-half d-block card-mobile',sku:product.sku,key:product.sku+'_mobile',identifier:'search-page',titleShowcase:titleShowcase,categoryName:categoryName,position:index})));})));}};MainComponent.propTypes={products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,titleShowcase:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,categoryName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,hasMoreItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loadItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,activeTagging:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,activePagination:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,notFound:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,taggingSend:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,sendGTM:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,updateSendGTM:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var SearchPage=function(_BaseSearch){_inherits(SearchPage,_BaseSearch);function SearchPage(props){_classCallCheck(this,SearchPage);var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));_this.getApplicationNode=function(){return document.querySelector('#root');};_this.state={taggingSend:true,sendGTM:false,qtdProducts:0,paginationSearch:true};_this.activeTagging=_this.activeTagging.bind(_this);_this.updateSendGTM=_this.updateSendGTM.bind(_this);_this.activePagination=_this.activePagination.bind(_this);return _this;}_createClass(SearchPage,[{key:'updateSendGTM',value:function updateSendGTM(){this.setState({sendGTM:true,taggingSend:true});}},{key:'activeTagging',value:function activeTagging(){var _this2=this;setTimeout(function(){_this2.setState({taggingSend:false,paginationSearch:false});},1000);}},{key:'activePagination',value:function activePagination(){this.setState({paginationSearch:false});}},{key:'componentWillMount',value:function componentWillMount(){this.props.resetState();if(this.props.filterSelected){this.props.filterSelected.maxprice=0;this.props.filterSelected.minprice=0;}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var propsChanged=JSON.stringify(nextProps)!==JSON.stringify(this.props);var stateChanged=JSON.stringify(nextState)!==JSON.stringify(this.state);return propsChanged||stateChanged;}},{key:'removeTabIndex',value:function removeTabIndex(){setTimeout(function(){var contentModalFilter=document.querySelector('#filter-opened');contentModalFilter&&contentModalFilter.removeAttribute('tabindex');},300);}},{key:'handleApplyFilterModal',value:function handleApplyFilterModal(){this.handleFilter();setTimeout(function(){document.querySelector('.btn-back-page').focus();},300);}},{key:'render',value:function render(){var _this3=this;var _props=this.props,services=_props.services,products=_props.products,categories=_props.categories,subcategories=_props.subcategories,filterSelected=_props.filterSelected,isLoading=_props.isLoading,hasNoProducts=_props.hasNoProducts,hasMoreItems=_props.hasMoreItems;var term=filterSelected.term,category=filterSelected.category,subcategory=filterSelected.subcategory,vendor=filterSelected.vendor;var isSearch=!!term;var notFound=!isLoading&&hasNoProducts;var ariaLabel='Resultado da busca';var title='';var categoryName='';// Title based on search type
if(!term){if(categories&&categories.length&&category.length){title=categories[0].name;}else if(subcategories&&subcategories.length&&subcategory.length){title=subcategories[0].name;}else if(this.props.vendors&&this.props.vendors.length>0&&vendor.length===1){title=Object(__WEBPACK_IMPORTED_MODULE_14__Title__["a" /* default */])(this.props.vendors,vendor[0]);}}else{title=term;}if(subcategories&&subcategories.length&&subcategory.length){categoryName=subcategories[0].name;}else if(categories&&categories.length&&category.length){categoryName=categories[0].name;}if(this.state.qtdProducts!==products.length&&!this.state.paginationSearch){this.setState({qtdProducts:products.length,paginationSearch:true});}this.activeTagging();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Resultado de busca - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchpage-file container-fluid','data-cat':categoryName},!this.state.sendGTM&&!this.state.taggingSend||this.state.paginationSearch&&!this.state.taggingSend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.updateSendGTM(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_Catalog_Product_ProductCard_Tagging__["a" /* default */],{type:'send'})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',style:{width:'1px',height:'1px'},'aria-label':ariaLabel,readOnly:true,'aria-hidden':true,tabIndex:-1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["c" /* SearchTitle */],{title:title,isSearch:isSearch,isLoading:isLoading,quantityFoundProducts:this.props.quantityFoundProducts,className:''+(!this.state.condition?'d-flex d-md-flex':'d-none d-md-flex')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(!this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-filtrar-mobile',name:'BUTTON',text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm ',onClick:this.handleFilter})),this.state.condition&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_aria_modal___default.a,{titleText:'Filtros para busca',onExit:function onExit(){_this3.handleFilter();},getApplicationNode:this.getApplicationNode,underlayStyle:{paddingTop:'0px',zIndex:99999,backgroundColor:'#FFF'},initialFocus:'#filter-opened',focusDialog:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-campaign':"80938"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'filter-opened',className:'h-100 w-100 px-2 py-2',onBlur:this.removeTabIndex,tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pt-md-2 pb-2 d-block d-md-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-voltar-mobile',name:'BUTTON',text:'Voltar',iconName:'icon_left icon-sm',className:'btn-sm',onClick:function onClick(){_this3.handleFilter();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["f" /* Sidebar */],{subcategories:subcategories,brands:this.props.brands,vendors:this.props.vendors,features:this.props.features,handleFilterChanged:this.handleFilterChanged,handleSelectOrdinationFilterChanged:this.handleSelectOrdinationFilterChanged,handleFilterRemove:this.handleFilterRemove,handleFilterClean:this.handleFilterClean,filterSelected:filterSelected,priceLimit:this.props.priceLimit,pageType:'search',isLoading:isLoading,ordination:this.state.ordination,className:'d-block d-md-block',onlyCash:this.props.onlyCash}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white px-2 py-2 row mx-0 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-featured',onClick:function onClick(){_this3.handleApplyFilterModal();}},'Aplicar')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["f" /* Sidebar */],{subcategories:subcategories,brands:this.props.brands,vendors:this.props.vendors,features:this.props.features,handleFilterChanged:this.handleFilterChanged,handleSelectOrdinationFilterChanged:this.handleSelectOrdinationFilterChanged,handleFilterRemove:this.handleFilterRemove,handleFilterClean:this.handleFilterClean,filterSelected:filterSelected,priceLimit:this.props.priceLimit,pageType:'search',isLoading:isLoading,ordination:this.state.ordination,className:'d-none d-md-block',onlyCash:this.props.onlyCash}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 '+(!this.state.condition?'d-block d-md-block':'d-none d-md-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainComponent,{titleShowcase:title,categoryName:categoryName,services:services,products:products,hasMoreItems:hasMoreItems,isSearch:isSearch,loadItems:this.loadItems,activeTagging:this.activeTagging,activePagination:this.activePagination,notFound:notFound,taggingSend:this.state.taggingSend}))))));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_3__BaseSearch__["a" /* default */]);var mapStateToProps=function mapStateToProps(_ref2){var searchResult=_ref2.searchResult,router=_ref2.router,onlyCash=_ref2.onlyCash;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["b" /* SearchFiltered */])(searchResult,router),{onlyCash:onlyCash});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchResultSearch:function fetchResultSearch(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["e" /* fetchResultSearch */])(null)(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex));},clearSearch:function clearSearch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["c" /* clearSearch */])());},resetState:function resetState(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["f" /* resetState */])());},setFilterChanged:function setFilterChanged(filterName,filterSelected){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["g" /* setFilterChanged */])(filterName,filterSelected));},setMeta:function setMeta(title,description,keywords){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Shared_HeadMetadata_ducks__["b" /* setMetadata */])(title,description,keywords));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SearchPage));

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceCardContainer__ = __webpack_require__(1963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ServiceCardContainer__["a"]; });


/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceCard__ = __webpack_require__(1964);
var mapStateToProps=function mapStateToProps(_ref,_ref2){var services=_ref.services;var name=_ref2.name;return services[name]||{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__ServiceCard__["a" /* default */]));

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Service_ServiceCard_CardImage__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Service_ServiceCard_CardTitle__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Service_ServiceCard_CardInternal__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Catalog_Service_ServiceCard_CardButton__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
var ServiceCard=function ServiceCard(_ref){var path=_ref.path,image=_ref.image,name=_ref.name,className=_ref.className,isResponsiveEnabled=_ref.isResponsiveEnabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Shared_IsResponsiveEnabledContext__["a" /* default */].Provider,{value:isResponsiveEnabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item card card-service '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bordered radius border-color-ui-3 bg-white product-image px-1 d-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Catalog_Service_ServiceCard_CardImage__["a" /* default */],{linkTo:path,imageUrl:image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Catalog_Service_ServiceCard_CardInternal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Catalog_Service_ServiceCard_CardTitle__["a" /* default */],{linkTo:path,title:name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Catalog_Service_ServiceCard_CardButton__["a" /* default */],{text:'Trocar pontos'}))))));};ServiceCard.propTypes={path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isResponsiveEnabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ServiceCard);

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
var DefaultCardImage=function DefaultCardImage(_ref){var linkTo=_ref.linkTo,imageUrl=_ref.imageUrl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img col-12 row txt-center py-3 t-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 ml-auto mr-auto t-0 pos-absolute'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 m-0 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:linkTo,tabIndex:-1,'aria-hidden':true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'card-image-fallback',src:imageUrl})))));};DefaultCardImage.propTypes={linkTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var ResponsiveCardImage=function ResponsiveCardImage(_ref2){var linkTo=_ref2.linkTo,imageUrl=_ref2.imageUrl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img col-5 row txt-center py-3 my-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 ml-auto mr-auto t-0 pos-absolute p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 pl-0 pr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{to:linkTo,'aria-hidden':true,tabIndex:-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'aria-hidden':true,alt:'',className:'card-image-fallback pos-absolute l-0',src:imageUrl})))));};ResponsiveCardImage.propTypes=DefaultCardImage.propTypes;var CardImage=function CardImage(props){var isResponsiveEnabled=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4_Shared_IsResponsiveEnabledContext__["a" /* default */]);return isResponsiveEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardImage,props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResponsiveCardImage,props))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardImage,props);};/* harmony default export */ __webpack_exports__["a"] = (CardImage);

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(5);
var CardTitle=function CardTitle(_ref){var linkTo=_ref.linkTo,title=_ref.title,altText=_ref.altText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-name col-12 mt-0 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Link"],{className:'h2 txt-body-sm color-ui-2 txt-font-body txt-left',to:linkTo,'aria-label':altText||title},title));};CardTitle.propTypes={linkTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,altText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CardTitle);

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Shared_IsResponsiveEnabledContext__ = __webpack_require__(88);
var CardInternal=function CardInternal(_ref){var children=_ref.children;var isResponsiveEnabled=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3_Shared_IsResponsiveEnabledContext__["a" /* default */]);var DefaultCardInternal=function DefaultCardInternal(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-internal col-12 pt-md-0 pt-3'},children);};return isResponsiveEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardInternal,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-internal col-7 my-1'},children))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultCardInternal,null);};CardInternal.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (CardInternal);

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var CardButton=function CardButton(_ref){var text=_ref.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12 mt-1 mb-1 p-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price col-12 mt-2 mb-1 px-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-item col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-price-points col-12 txt-title txt-font-body'},text)))))));};CardButton.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CardButton);

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseSearch__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ducks__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Shared_HeadMetadata_ducks__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__loyal_template_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductCard__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Title__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Main component logic based on search
var MainComponent=function MainComponent(_ref){var products=_ref.products,isSearch=_ref.isSearch,hasMoreItems=_ref.hasMoreItems,loadItems=_ref.loadItems,notFound=_ref.notFound;if(notFound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["a" /* NotFound */],{isSearch:isSearch});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:loadItems,hasMore:hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},products.map(function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],{className:'col-6 col-lg-4 mb-2 px-1 d-md-block',sku:product.sku,key:product.sku})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Catalog_Product_ProductCard__["a" /* ProductCardContainer */],{isResponsiveEnabled:true,className:'col-12 mb-1 px-half d-block card-mobile',sku:product.sku,key:product.sku+'_mobile'})));})));}};MainComponent.propTypes={products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,hasMoreItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,loadItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,notFound:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};var SearchVendor=function(_BaseSearch){_inherits(SearchVendor,_BaseSearch);function SearchVendor(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,SearchVendor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=SearchVendor.__proto__||Object.getPrototypeOf(SearchVendor)).call.apply(_ref2,[this].concat(args))),_this),_this.titleConstructor=function(vendors,filterSelected){if(!vendors||vendors.length<=0){return'';}else if(filterSelected.vendor.length===1){return Object(__WEBPACK_IMPORTED_MODULE_12__Title__["a" /* default */])(_this.props.vendors,filterSelected.vendor[0]);}return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchVendor,[{key:'componentWillMount',value:function componentWillMount(){this.props.resetState();if(this.props.filterSelected){this.props.filterSelected.maxprice=0;this.props.filterSelected.minprice=0;}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var propsChanged=JSON.stringify(nextProps)!==JSON.stringify(this.props);var stateChanged=JSON.stringify(nextState)!==JSON.stringify(this.state);return propsChanged||stateChanged;}},{key:'render',value:function render(){var _props=this.props,products=_props.products,subcategories=_props.subcategories,filterSelected=_props.filterSelected,isLoading=_props.isLoading,hasNoProducts=_props.hasNoProducts,hasMoreItems=_props.hasMoreItems;var term=filterSelected.term;var isSearch=!!term;var notFound=!isLoading&&hasNoProducts;var ariaLabel='Resultado da busca';var title='';title=this.titleConstructor(this.props.vendors,filterSelected);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Resultado de busca - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchpage-file container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',autoFocus:true,style:{width:'1px',height:'1px'},'aria-label':ariaLabel,readOnly:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["c" /* SearchTitle */],{title:title,isSearch:isSearch,isLoading:isLoading,quantityFoundProducts:this.props.quantityFoundProducts,className:''+(!this.state.condition?'d-flex d-md-flex':'d-none d-md-flex')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pt-md-2 pb-2 '+(this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-voltar-mobile',name:'BUTTON',text:'Voltar',iconName:'icon_left icon-sm',className:'col-12 btn-sm btn-flat',onClick:this.handleFilter})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-button bg-white px-2 py-2 row mx-0 '+(this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{className:'btn btn-sm btn-featured',text:'Aplicar',onClick:this.handleFilter}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(!this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-filtrar-mobile',name:'BUTTON',text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm ',onClick:this.handleFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["f" /* Sidebar */],{subcategories:subcategories,brands:this.props.brands,vendors:this.props.vendors,features:this.props.features,handleFilterChanged:this.handleFilterChanged,handleSelectOrdinationFilterChanged:this.handleSelectOrdinationFilterChanged,handleFilterRemove:this.handleFilterRemove,handleFilterClean:this.handleFilterClean,filterSelected:filterSelected,priceLimit:this.props.priceLimit,pageType:'vendor',isLoading:isLoading,ordination:this.state.ordination,className:''+(this.state.condition?'d-block d-md-block':'d-none d-md-block')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 '+(!this.state.condition?'d-block d-md-block':'d-none d-md-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainComponent,{products:products,hasMoreItems:hasMoreItems,isSearch:isSearch,loadItems:this.loadItems,notFound:notFound}))))));}}]);return SearchVendor;}(__WEBPACK_IMPORTED_MODULE_3__BaseSearch__["a" /* default */]);var mapStateToProps=function mapStateToProps(_ref3){var searchResult=_ref3.searchResult,router=_ref3.router;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["b" /* SearchFiltered */])(searchResult,router));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchResultSearch:function fetchResultSearch(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["e" /* fetchResultSearch */])(null)(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex));},clearSearch:function clearSearch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["c" /* clearSearch */])());},resetState:function resetState(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["f" /* resetState */])());},setFilterChanged:function setFilterChanged(filterName,filterSelected){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__ducks__["g" /* setFilterChanged */])(filterName,filterSelected));},setMeta:function setMeta(title,description,keywords){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Shared_HeadMetadata_ducks__["b" /* setMetadata */])(title,description,keywords));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SearchVendor));

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Filters__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_molecules_accordion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarPlaceholder__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder_lib_reactPlaceholder_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_placeholder_lib_reactPlaceholder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_placeholder_lib_reactPlaceholder_css__);
var Sidebar=function Sidebar(_ref){var subcategories=_ref.subcategories,brands=_ref.brands,vendors=_ref.vendors,features=_ref.features,handleFilterChanged=_ref.handleFilterChanged,handleSelectOrdinationFilterChanged=_ref.handleSelectOrdinationFilterChanged,handleFilterRemove=_ref.handleFilterRemove,handleFilterClean=_ref.handleFilterClean,filterSelected=_ref.filterSelected,priceLimit=_ref.priceLimit,pageType=_ref.pageType,isLoading=_ref.isLoading,className=_ref.className,ordination=_ref.ordination,onlyCash=_ref.onlyCash;var mustShow=filterSelected&&(filterSelected.term||filterSelected.minprice!==priceLimit.min&&filterSelected.minprice>0||filterSelected.maxprice!==priceLimit.max&&filterSelected.maxprice>0||filterSelected.brand.length>0||filterSelected.subcategory.length>0||filterSelected.vendor.length>0&&vendors);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_placeholder___default.a,{customPlaceholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SidebarPlaceholder__["a" /* default */],null),ready:!isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-siderbar filterSelected col-12 px-0 '+(className||'')},mustShow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Filters__["c" /* SelectedFilters */],{filterSelected:filterSelected,subcategories:subcategories,brands:brands,vendors:vendors,features:features,handleFilterRemove:handleFilterRemove,handleFilterClean:handleFilterClean,pageType:pageType,onlyCash:onlyCash}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-sidebar col-12 col-md-4 col-lg-3 pb-5 px-1 px-md-2 mb-5 '+(className||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Filters__["b" /* Filters */],{subcategories:subcategories,brands:brands,vendors:vendors,features:features,handleFilterChanged:handleFilterChanged,handleSelectOrdinationFilterChanged:handleSelectOrdinationFilterChanged,filterSelected:filterSelected,priceLimit:priceLimit,ordination:ordination,onlyCash:onlyCash}))));};Sidebar.propTypes={subcategories:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,brands:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,vendors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,features:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleSelectOrdinationFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleFilterRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleFilterClean:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,priceLimit:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,pageType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isLoading:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,ordination:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_molecules_accordion_css__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_molecules_accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_molecules_accordion_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_accessible_accordion_dist_fancy_example_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Filters=function(_Component){_inherits(Filters,_Component);function Filters(props){_classCallCheck(this,Filters);var _this=_possibleConstructorReturn(this,(Filters.__proto__||Object.getPrototypeOf(Filters)).call(this,props));_this.state={selectOrdination:'SCORE',minprice:_this.props.filterSelected.minprice>=0?_this.props.filterSelected.minprice:_this.props.priceLimit.min,maxprice:_this.props.filterSelected.maxprice>=0?_this.props.filterSelected.maxprice:_this.props.priceLimit.max};return _this;}_createClass(Filters,[{key:'componentDidMount',value:function componentDidMount(){var urlSearch=window.location.search;var urlParams=new URLSearchParams(urlSearch);var sort=urlParams.get('sort');sort&&this.setState({selectOrdination:sort});}},{key:'handleUpdateMinPrice',value:function handleUpdateMinPrice(e){this.setState({minprice:e.target.value});}},{key:'handleUpdateMaxPrice',value:function handleUpdateMaxPrice(e){this.setState({maxprice:e.target.value});}},{key:'handleSelectOrder',value:function handleSelectOrder(e){var handleSelectOrdinationFilterChanged=this.props.handleSelectOrdinationFilterChanged;return handleSelectOrdinationFilterChanged(e.target.value);}},{key:'maskInput',value:function maskInput(){return[/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/];}},{key:'render',value:function render(){var _this2=this;var _props=this.props,subcategories=_props.subcategories,brands=_props.brands,vendors=_props.vendors,features=_props.features,filterSelected=_props.filterSelected,priceLimit=_props.priceLimit,handleFilterChanged=_props.handleFilterChanged,ordination=_props.ordination;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["Accordion"],{className:'container-filter row radius border-color-ui-3 radius',accordion:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItem"],{className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'py-2 px-2 btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'},'Ordena\xE7\xE3o',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-price col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border custom-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'select-order'},'Ordenar por'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'select-order',name:'select-order',onChange:function onChange(e){return _this2.handleSelectOrder(e);},value:this.state.selectOrdination},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'SCORE'},'Mais Relevantes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'NEWRELEASES'},'Mais Novos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICEHIGHERTOLOWER'},'Maior Pre\xE7o'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICELOWERTOHIGHER'},'Menor Pre\xE7o')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItem"],{expanded:true,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0','data-ordination':ordination},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'py-2 px-2 btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'},'Valor',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white  px-2 py-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-price col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'minimo-mobile',label:'M\xEDnimo',className:'d-block d-md-none col-12 col-md-6 mb-2 has-content',childrenClassName:'has-content',type:'text',value:this.state.minprice,guide:false,mask:this.maskInput,onBlur:function onBlur(e){return _this2.handleUpdateMinPrice(e);},inputMode:'numeric'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'maximo-mobile',label:'M\xE1ximo',className:'d-block d-md-none col-12 col-md-6 mt-0 mb-2 ',childrenClassName:'has-content',type:'text',value:this.state.maxprice,guide:false,mask:this.maskInput,onBlur:function onBlur(e){return _this2.handleUpdateMaxPrice(e);},inputMode:'numeric'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'minimo',label:'M\xEDnimo',className:'d-none d-md-block col-12 col-md-5 mt-1 has-content',childrenClassName:'has-content',type:'text',value:this.state.minprice,guide:false,mask:this.maskInput,onBlur:function onBlur(e){return _this2.handleUpdateMinPrice(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Input"],{id:'maximo',label:'M\xE1ximo',className:'d-none d-md-block col-12 col-md-5 mt-1 has-content ml-auto',childrenClassName:'has-content',type:'text',value:this.state.maxprice,guide:false,mask:this.maskInput,onBlur:function onBlur(e){return _this2.handleUpdateMaxPrice(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mx-auto mt-1 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{role:'button',className:'btn py-2 btn-featured',minprice:this.state.minprice>0?this.state.minprice:priceLimit.min,maxprice:this.state.maxprice>0?this.state.maxprice:priceLimit.max,onClick:handleFilterChanged('price')},'aplicar valor')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* FilterItems */],{items:subcategories,title:'Categoria',type:'subcategory',handleFilterChanged:handleFilterChanged,filterSelected:filterSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* FilterItems */],{items:brands,title:'Marca',type:'brand',handleFilterChanged:handleFilterChanged,filterSelected:filterSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* FilterItems */],{items:vendors,title:'Parceiro',type:'vendor',handleFilterChanged:handleFilterChanged,filterSelected:filterSelected}),features&&[].concat(_toConsumableArray(new Set(features.map(function(item){return item.type;})))).map(function(itemType,ix){var featuresType=features.filter(function(f){return f.type===itemType;}).map(function(elem){return{id:elem.name+'_'+elem.value,name:elem.value,quantity:elem.quantity};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* FilterItems */],{items:featuresType,title:itemType.toLowerCase(),type:'feature',handleFilterChanged:handleFilterChanged,filterSelected:filterSelected,key:ix});}));}}]);return Filters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Filters.propTypes={subcategories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,brands:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,vendors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,features:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,filterSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,priceLimit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleSelectOrdinationFilterChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,ordination:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var SelectedFilters=function SelectedFilters(_ref){var filterSelected=_ref.filterSelected,brands=_ref.brands,subcategories=_ref.subcategories,vendors=_ref.vendors,features=_ref.features,handleFilterRemove=_ref.handleFilterRemove,handleFilterClean=_ref.handleFilterClean,pageType=_ref.pageType,onlyCash=_ref.onlyCash;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-filter container-selected-filter row radius border-none radius mb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filter-accordion filtered-accordion col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-selected pl-1 px-md-2 pt-0 pt-md-2 row'},filterSelected&&filterSelected.minprice>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 py-half h-auto bg-white radius',tabIndex:0,role:'button','aria-label':'Remover filtro de pre\xE7o m\xEDnimo de '+filterValue(filterSelected.minprice,onlyCash),onClick:function onClick(){return handleFilterRemove('minprice',0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-hidden':true,tabIndex:-1,href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},'De: ',filterValue(filterSelected.minprice,onlyCash),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'})))),filterSelected&&filterSelected.maxprice>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 py-half h-auto bg-white radius',role:'button',tabIndex:0,'aria-label':'Remover filtro de pre\xE7o m\xE1ximo at\xE9 '+filterValue(filterSelected.maxprice,onlyCash),onClick:function onClick(){return handleFilterRemove('maxprice',0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-hidden':true,tabIndex:-1,href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},'At\xE9: ',filterValue(filterSelected.maxprice,onlyCash),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'})))),filterSelected&&filterSelected.term?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected mb-1 ml-1 px-2 col-auto border-ui-3 h-auto bg-white radius'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-disabled':'true','aria-label':filterSelected.term,role:'button',href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},filterSelected.term))):null,filterSelected&&filterSelected.brand&&brands?filterSelected.brand.map(function(item,index){var filteredBrand=brands.filter(function(value){return String(value.id)===String(item);});return filteredBrand.length<=0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'brand_'+index,className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius',role:'button',tabIndex:0,onClick:function onClick(){return handleFilterRemove('brand',item);},'aria-label':'Remover filtro da marca '+filteredBrand[0].name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-hidden':true,tabIndex:-1,href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},filteredBrand[0].name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'}))));}):null,filterSelected&&filterSelected.subcategory&&subcategories?filterSelected.subcategory.map(function(item,index){var filteredSubcategory=subcategories.filter(function(value){return String(value.id)===String(item);});return filteredSubcategory.length<=0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'subcategory_'+index,className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius',role:'button',tabIndex:0,'aria-label':'Remover filtro de subcategoria '+filteredSubcategory[0].name,onClick:function onClick(){return handleFilterRemove('subcategory',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-hidden':true,tabIndex:-1,href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},filteredSubcategory[0].name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'}))));}):null,filterSelected&&filterSelected.vendor&&vendors?filterSelected.vendor.map(function(item,index){var filteredVendor=vendors.filter(function(value){return String(value.id)===String(item);});return filteredVendor.length<=0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'vendor_'+index,className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius',tabIndex:0,'aria-label':'Remover filtro do parceiro '+filteredVendor[0].name,onClick:function onClick(){return handleFilterRemove('vendor',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-hidden':true,tabIndex:-1,href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},filteredVendor[0].name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'}))));}):null,filterSelected&&filterSelected.feature&&features?filterSelected.feature.map(function(item,index){var filteredFeature=features.filter(function(value){return String(value.type+'_'+value.value).toUpperCase()===String(item).toUpperCase();});return filteredFeature.length<=0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'feature_'+index,className:'selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius',role:'button','aria-label':'Remover filtro de op\xE7\xE3o',onClick:function onClick(){return handleFilterRemove('feature',item);},tabIndex:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'aria-hidden':true,tabIndex:-1,href:'javascript:void(0)',className:'txt-subtitle txt-font-body color-ui-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_close',className:'color-ui-3 cursor'}))));}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected mb-1 ml-1 pr-1 col-auto h-auto d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Button"],{id:'clearAll',name:'clearAll',text:'Limpar Filtros',className:'col-12 btn-sm btn py-1 txt-subtitle',onClick:handleFilterClean(pageType)})))));};function filterValue(price,onlyCash){if(onlyCash){return'R$ '+parseFloat(price).toFixed(2).replace('.',',');}return price;}SelectedFilters.propTypes={filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,subcategories:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,brands:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,vendors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,features:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handleFilterRemove:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleFilterClean:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,pageType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,onlyCash:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (SelectedFilters);

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion_dist_fancy_example_css__);
var SelectedFilters=function SelectedFilters(_ref){var type=_ref.type,filterSelected=_ref.filterSelected,expanded=_ref.expanded,title=_ref.title,items=_ref.items,handleFilterChanged=_ref.handleFilterChanged;var checkSelected=function checkSelected(value){var brand=filterSelected.brand,subcategory=filterSelected.subcategory,vendor=filterSelected.vendor,feature=filterSelected.feature;switch(type){case'brand':{return brand?brand.includes(String(value)):false;}case'subcategory':{return subcategory?subcategory.includes(String(value)):false;}case'vendor':{return vendor?vendor.includes(String(value)):false;}case'feature':{return feature?feature.includes(String(value)):false;}default:{return false;}}};return(items&&items.length)>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:expanded,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 '+(items?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'py-2 px-2 btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'},title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white  px-2 py-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'panel-scroll'},items&&items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:type+'_'+index,className:'form-field checkbox-field  col-12 px-0',title:(item.name.trim().length>17?item.name.trim().substr(0,17)+'...':item.name.trim())+' ('+item.quantity+')'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'effect check inner l-0  '+(checkSelected(item.id)?'checked':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:type+'_'+index+item.id,type:'checkbox',value:item.id,checked:checkSelected(item.id),onChange:handleFilterChanged(type),tabIndex:0,'aria-label':item.name+' ('+item.quantity+' '+(item.quantity===1?'item':'itens')+' na op\xE7\xE3o)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true',className:!checkSelected(item.id)&&'bg-white'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},(item.name.trim().length>17?item.name.trim().substr(0,17)+'...':item.name.trim())+' ('+item.quantity+')')));}))));};// schema
SelectedFilters.propTypes={type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,filterSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,expanded:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,handleFilterChanged:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SelectedFilters);

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_template_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png__);
var bgBanner={backgroundColor:'#D2DCDE'};var verifyVendor=function verifyVendor(vendor){if(vendor){return vendor.length>0&&vendor[0].imageUrl;}return __WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a;};var StoreInfo=function StoreInfo(_ref){var vendors=_ref.vendors,isLoading=_ref.isLoading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid container-results mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-2 innerShadow',style:bgBanner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 py-5'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-transparent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container  pos-relative py-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumbStore col-auto d-none d-lg-flex py-half px-half border border-color-ui-3 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'radius d-block mx-auto',src:''+(isLoading?__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a:vendors&&vendors.length>0?verifyVendor(vendors):__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a),alt:''+(__WEBPACK_IMPORTED_MODULE_3__loyal_images_products_product_placeholder_png___default.a?'Carregando...':vendors&&vendors.length>0&&vendors[0].name)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-0 offset-lg-2 col-12 col-lg pos-relative'},isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'titleStore col-5 pt-1 bg-ui-5 radius'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'titleStore color-ui-white l-0 w-100 txt-center txt-lg-left'},vendors&&vendors.length>0&&vendors[0].name))))))));};// schema
StoreInfo.propTypes={vendors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* unused harmony default export */ var _unused_webpack_default_export = (StoreInfo);

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Catalog_Showcase__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_notfound_css__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_template_notfound_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_template_notfound_css__);
var NotFound=function NotFound(_ref){var isSearch=_ref.isSearch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container not-found py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box-notfound row my-4 mt-md-0 py-3 px-3 mx-1 bg-white radius border border-color-ui-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-auto mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-ui-4 radius-circle px-3 py-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_loyal_react__["Icon"],{className:'txt-headline color-brand-1',iconName:'icon_loupe'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'txt-left mb-1'},'Opps! N\xE3o foi encontrado nenhum resultado para sua busca.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-left txt-body-sm'},'\xB7 Verifique se os termos digitados est\xE3o corretos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'txt-left txt-body-sm'},'\xB7 Tente utilizar palavras gen\xE9ricas e refinar a busca nos filtros laterais.'))),isSearch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Catalog_Showcase__["e" /* default */],{showcaseType:'5',identifier:'home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Catalog_Showcase__["e" /* default */],{showcaseType:'7',identifier:'home'})));};NotFound.propTypes={isSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};NotFound.defaultProps={isSearch:false};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var ProductCountLabel=function ProductCountLabel(_ref){var productsCount=_ref.productsCount;return productsCount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,productsCount),' produto(s) encontrado(s)'):null;};var searchTitleConstructor=function searchTitleConstructor(isSearch,title){if(isSearch){return'Resultados para "'+title+'"';}else if(title===''||title===false){return'Produtos dos principais e-commerces.';}else{return title;}};var SearchTitle=function SearchTitle(_ref2){var isSearch=_ref2.isSearch,isLoading=_ref2.isLoading,title=_ref2.title,quantityFoundProducts=_ref2.quantityFoundProducts,className=_ref2.className;var searchTitle=searchTitleConstructor(isSearch,title);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-results col-12 pb-2 py-md-2 '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(isLoading?'d-none':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'txt-font-body color-title pb-half'},searchTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCountLabel,{productsCount:quantityFoundProducts})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''+(isLoading?'':'d-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 pb-half pt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'py-half col-3 bg-ui-2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mx-0 pt-half pb-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'py-half col-5 bg-ui-3'}))))));};// schemas
SearchTitle.propTypes={isSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,quantityFoundProducts:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};ProductCountLabel.propTypes={productsCount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};searchTitleConstructor.propTypes={isSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (SearchTitle);

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSearch__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ducks__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_features_Availability__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Shared_HeadMetadata_ducks__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__loyal_template_search_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowCase=function(_BaseSearch){_inherits(ShowCase,_BaseSearch);function ShowCase(){_classCallCheck(this,ShowCase);return _possibleConstructorReturn(this,(ShowCase.__proto__||Object.getPrototypeOf(ShowCase)).apply(this,arguments));}_createClass(ShowCase,[{key:'render',value:function render(){var notFound=!this.props.isLoading&&(!this.props.validShowcasePage||this.props.hasNoProducts);if(notFound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["a" /* NotFound */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'showcase-lazy container-fluid showcase '+(this.props.showcase&&this.props.showcase.id)+' '+(this.props.showcase&&this.props.showcase.type)+'_'+(this.props.showcase&&this.props.showcase.url)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 pt-4 pt-sm-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-voltar-mobile',name:'BUTTON',text:'Voltar',iconName:'icon_left icon-sm',className:'col-12 btn-sm btn-flat',onClick:this.handleFilter})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 pt-0 pb-2 '+(!this.state.condition?'d-block d-md-none':'d-none d-md-none')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{id:'button-filtrar-mobile',name:'BUTTON',text:'Filtrar',iconName:'icon_filter',className:'col-12 btn-sm ',onClick:this.handleFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["f" /* Sidebar */],{subcategories:this.props.subcategories,brands:this.props.brands,vendors:this.props.vendors,features:this.props.features,handleFilterChanged:this.handleFilterChanged,handleFilterClean:this.handleFilterClean,filterSelected:this.props.filterSelected,priceLimit:this.props.priceLimit,pageType:'search',isLoading:this.props.isLoading,ordination:this.state.ordination,className:''+(this.state.condition?'d-block d-md-block':'d-none d-md-block')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-card col-12 col-md-8 col-lg-9 pb-5 px-half px-md-1 '+(!this.state.condition?'d-block d-md-block':'d-none d-md-block')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_infinite_scroller___default.a,{initialLoad:false,pageStart:0,loadMore:this.loadItems,hasMore:this.props.hasMoreItems,loader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_loyal_react__["Button"],{loading:true,text:'Carregando',className:'btn-flat'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},this.props.products.map(function(product,ix){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_features_Availability__["c" /* SearchCardContainer */],Object.assign({},product,{key:ix}));})))))));}}}]);return ShowCase;}(__WEBPACK_IMPORTED_MODULE_2__BaseSearch__["a" /* default */]);var mapStateToProps=function mapStateToProps(_ref){var searchResult=_ref.searchResult,router=_ref.router,oidc=_ref.oidc,clientId=_ref.participant.clientId,google=_ref.google;var user=oidc.user;var _ref2=user||{},profile=_ref2.profile;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__ducks__["b" /* SearchFiltered */])(searchResult,router),{ParticipantId:profile&&profile['custom:participant_id'],clientId:clientId,profile:profile,google:google});};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchResultSearch:function fetchResultSearch(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__ducks__["e" /* fetchResultSearch */])('showcase')(term,identifier,type,brands,categories,subcategories,vendors,vendortype,features,minprice,maxprice,sort,pageIndex));},clearSearch:function clearSearch(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__ducks__["c" /* clearSearch */])());},setFilterChanged:function setFilterChanged(filterName,filterSelected){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__ducks__["g" /* setFilterChanged */])(filterName,filterSelected));},setMeta:function setMeta(title,description,keywords){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Shared_HeadMetadata_ducks__["b" /* setMetadata */])(title,description,keywords));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ShowCase));

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Landing_ItauCardLanding__ = __webpack_require__(666);
/* unused harmony reexport ItauCardLanding */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Listing_ItauCardListing__ = __webpack_require__(673);
/* unused harmony reexport ItauCardListing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_features_Benefits_BenefitsRouter__ = __webpack_require__(2067);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2_features_Benefits_BenefitsRouter__["a"]; });


/***/ }),
/* 1979 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiscountSuggestion__ = __webpack_require__(1984);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DiscountSuggestion__["a"]; });


/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_personalite_png__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_personalite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_personalite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_img_sociedade_mesa_png__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_img_sociedade_mesa_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_img_sociedade_mesa_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_mistral_png__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_mistral_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_mistral_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_nespresso_png__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_nespresso_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_nespresso_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_responsive__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DiscountSuggestion=function(_Component){_inherits(DiscountSuggestion,_Component);function DiscountSuggestion(){_classCallCheck(this,DiscountSuggestion);return _possibleConstructorReturn(this,(DiscountSuggestion.__proto__||Object.getPrototypeOf(DiscountSuggestion)).apply(this,arguments));}_createClass(DiscountSuggestion,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefitsMobile"],{link:'https://www.iupp.com.br/benefits/listing?profile=pra%20quem%20%C3%A9%20Personnalit%C3%A9',name:'Personnalit\xE9',profile:'pra quem \xE9 Personnalit\xE9',image:__WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_personalite_png___default.a,title:'Vai para Personnalit\xE9',alt:'Personnalit\xE9',titleImg:'Imagem Personnalit\xE9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Benef\xEDcios para cliente Personnalit\xE9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefitsMobile"],{link:'https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/',name:'Sociedade da mesa',profile:'pra quem \xE9 Personnalit\xE9',image:__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_img_sociedade_mesa_png___default.a,title:'Vai para Sociedade da mesa',alt:'Sociedade da mesa',titleImg:'Imagem Sociedade da mesa'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fa\xE7a parte do clube de vinhos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefitsMobile"],{link:'http://www.mistral.com.br/itaucard',name:'Mistral',profile:'pra quem tem Itaucard',image:__WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_mistral_png___default.a,title:'Vai para Mistral',alt:'Mistral',titleImg:'Imagem Mistral'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 20% de desconto',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'em at\xE9 7x sem juros')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefitsMobile"],{link:'https://www.nespressobenefits.com.br/',name:'Nespresso',profile:'pra quem tem Itaucard',image:__WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_nespresso_png___default.a,title:'Vai para Nespresso',alt:'Nespresso',titleImg:'Imagem Nespresso'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' o cupom it0615'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefits"],{link:'https://www.iupp.com.br/benefits/listing?profile=pra%20quem%20%C3%A9%20Personnalit%C3%A9',name:'Personalite',profile:'pra quem \xE9 Personnalit\xE9',image:__WEBPACK_IMPORTED_MODULE_2__loyal_images_brand_cards_benefits_cards_new_personalite_png___default.a,title:'Vai para Personnalit\xE9',alt:'Personnalit\xE9',titleImg:'Imagem Personnalit\xE9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Benef\xEDcios para cliente Personnalit\xE9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefits"],{link:'https://www.itau.com.br/personnalite/experiencia/gastronomia/sociedade-da-mesa/',name:'Sociedade da mesa',profile:'pra quem \xE9 Personnalit\xE9',image:__WEBPACK_IMPORTED_MODULE_3__loyal_images_brand_cards_benefits_img_sociedade_mesa_png___default.a,title:'Vai para Sociedade da mesa',alt:'Sociedade da mesa',titleImg:'Imagem Sociedade da mesa'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fa\xE7a parte do clube de vinhos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefits"],{link:'http://www.mistral.com.br/itaucard',name:'Mistral',profile:'pra quem tem Itaucard',image:__WEBPACK_IMPORTED_MODULE_4__loyal_images_brand_cards_benefits_img_mistral_png___default.a,title:'Vai para Mistral',alt:'Mistral',titleImg:'Imagem Mistral'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'At\xE9 20% de desconto',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'em at\xE9 7x sem juros')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefits"],{link:'https://www.nespressobenefits.com.br/',name:'Nespresso',profile:'pra quem tem Itaucard',image:__WEBPACK_IMPORTED_MODULE_5__loyal_images_brand_cards_benefits_img_nespresso_png___default.a,title:'Vai para Nespresso',alt:'Nespresso',titleImg:'Imagem Nespresso'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'20% off com ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' o cupom it0615')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefits"],{link:'',name:'',description:'',image:''})));}}]);return DiscountSuggestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DiscountSuggestion);

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseListing=function(_Component){_inherits(BaseListing,_Component);function BaseListing(parentContext){_classCallCheck(this,BaseListing);var _this=_possibleConstructorReturn(this,(BaseListing.__proto__||Object.getPrototypeOf(BaseListing)).call(this));_initialiseProps.call(_this);_this.props=parentContext;var tags=[];var filter={order:{selected:undefined},profiles:[],categories:[],partners:[]};_this.state={filteredBenefits:[],openFilter:false,profiles:[],categories:[],partners:[],filter:filter,tags:tags};_this.onFilterChange=_this.onFilterChange.bind(_this);_this.onOrderChange=_this.onOrderChange.bind(_this);_this.removeTags=_this.removeTags.bind(_this);_this.removeAllTags=_this.removeAllTags.bind(_this);_this.startFilter();return _this;}_createClass(BaseListing,[{key:'startFilter',value:function startFilter(){var filter=this.state.filter;var query=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(this.props.location.search);if(query.profile){filter.profiles=this.setFilterValue(filter.profiles,query.profile,'add','PROFILE');}if(query.category){filter.categories=this.setFilterValue(filter.categories,query.category,'add','CATEGORY');}if(query.partner){filter.partners=this.setFilterValue(filter.partners,query.partner,'add','PARTNER');}this.setState({filter:filter});}},{key:'getCardsBenefits',value:function getCardsBenefits(benefit){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{minDeviceWidth:426},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 mb-2 d-none d-md-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefits"],{link:benefit.link,name:benefit.name,description:benefit.description,image:benefit.image,title:benefit.title,alt:benefit.alt,titleImg:benefit.titleImg,profile:benefit.profile},benefit.descriptionHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive___default.a,{maxDeviceWidth:425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["CardBenefitsMobile"],{link:benefit.link,name:benefit.name,description:benefit.description,image:benefit.image,title:benefit.title,alt:benefit.alt,titleImg:benefit.titleImg,profile:benefit.profile},benefit.descriptionHtml))];}},{key:'onOrderChange',value:function onOrderChange(_ref){var type=_ref.type;var filter=this.state.filter;this.pageIndex=1;filter.order.selected=type;this.setState({filter:filter});this.filterBenefits();}},{key:'queryParameters',value:function queryParameters(){var filter=this.state.filter;var parameters={};if(filter.profiles.length>0)parameters['profile']=filter.profiles[0];if(filter.categories.length>0)parameters['category']=filter.categories[0];if(filter.partners.length>0)parameters['partner']=filter.partners[0];this.props.history.push({pathname:this.props.location.pathname,search:__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(parameters)});}},{key:'hasMoreItems',get:function get(){return this.totalItens>this.pageIndex*this.pageSize;}}]);return BaseListing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.benefits=[];this.pageIndex=1;this.pageSize=9;this.totalItens=0;this.onFilterChange=function(filterType){return function(e){var filterValue=void 0;var filterAction='update';var tagType=e.target?String(e.target.type):'';_this2.pageIndex=1;switch(tagType){case'checkbox':{filterValue=e.target.value;filterAction=e.target.checked?'add':'remove';break;}case'text':{filterValue=e.target.value;break;}default:{if(e.target){filterAction=e.target.getAttribute('action');filterValue=e.target.getAttribute('value');}break;}}filterAction=filterAction||'update';filterValue=filterValue||e;var filter=_this2.state.filter;switch(filterType){case'PROFILE':{filter.profiles=_this2.setFilterValue(filter.profiles,filterValue,filterAction,filterType);break;}case'CATEGORY':{filter.categories=_this2.setFilterValue(filter.categories,filterValue,filterAction,filterType);break;}case'PARTNER':{filter.partners=_this2.setFilterValue(filter.partners,filterValue,filterAction,filterType);break;}}_this2.setState({filter:filter},function(){return _this2.filterBenefits();});_this2.queryParameters();};};this.checkExist=function(arr,value){return arr.length>0?arr.indexOf(value)>-1:true;};this.filterBenefits=function(){var filter=_this2.state.filter;var currentBenefits=_this2.benefits.filter(function(x){return _this2.checkExist(filter.profiles,x.profile)&&_this2.checkExist(filter.categories,x.category)&&_this2.checkExist(filter.partners,x.partner);});if(currentBenefits.length===0){currentBenefits=_this2.benefits;}_this2.buildFilters(currentBenefits);currentBenefits=_this2.buildSort(currentBenefits,filter);_this2.totalItens=currentBenefits.length;_this2.setState({filteredBenefits:_this2.buildPage(currentBenefits)});};this.buildSort=function(list,filter){return list.sort(function(a,b){var nameA=a.name.toUpperCase();var nameB=b.name.toUpperCase();var priorityA=a.priority&&a.priority===true;var priorityB=b.priority&&b.priority===true;if(priorityA===priorityB){if(filter.order.selected==='ASCENDING'){if(nameA>nameB){return 1;}else if(nameA<nameB){return-1;}}if(filter.order.selected==='DESCENDING'){if(nameA<nameB){return 1;}else if(nameA>nameB){return-1;}}if(filter.order.selected==='HIGHERDISCOUNTS'){if(a.discount>b.discount){return-1;}else if(a.discount<b.discount){return 1;}}}return priorityA?-1:1;});};this.buildPage=function(list){return list.slice(0,_this2.pageIndex*_this2.pageSize);};this.distinctArray=function(array){var flags={};var newArray=array.filter(function(entry){if(flags[entry.link]){return false;}flags[entry.link]=true;return true;});return newArray;};this.buildFilters=function(listBenefits){var profiles=[];var categories=[];var partners=[];if(listBenefits&&listBenefits.length>0){listBenefits.map(function(item){if(profiles&&profiles.find(function(x){return x.name===item.profile;})){var idx=profiles.findIndex(function(x){return x.name===item.profile;});profiles[idx].quantity=profiles[idx].quantity+1;}else{profiles.push({name:item.profile,quantity:1});}if(categories&&categories.find(function(x){return x.name===item.category;})){var _idx=categories.findIndex(function(x){return x.name===item.category;});categories[_idx].quantity=categories[_idx].quantity+1;}else{categories.push({name:item.category,quantity:1});}if(partners&&partners.find(function(x){return x.name===item.partner;})){var _idx2=partners.findIndex(function(x){return x.name===item.partner;});partners[_idx2].quantity=partners[_idx2].quantity+1;}else{partners.push({name:item.partner,quantity:1});}});profiles=_this2.buildSort(profiles,{order:{selected:'ASCENDING'}});categories=_this2.buildSort(categories,{order:{selected:'ASCENDING'}});partners=_this2.buildSort(partners,{order:{selected:'ASCENDING'}});_this2.setState({profiles:profiles,categories:categories,partners:partners});}};this.removeTags=function(tag){var filter=_this2.state.filter;switch(tag.filterType){case'PROFILE':{filter.profiles=_this2.setFilterValue(filter.profiles,tag.valueFilter,'remove',tag.filterType);break;}case'CATEGORY':{filter.categories=_this2.setFilterValue(filter.categories,tag.valueFilter,'remove',tag.filterType);break;}case'PARTNER':{filter.partners=_this2.setFilterValue(filter.partners,tag.valueFilter,'remove',tag.filterType);break;}}_this2.setState({filter:filter});_this2.filterBenefits();_this2.queryParameters();};this.removeAllTags=function(){var filter=_this2.state.filter;filter.profiles=[];filter.categories=[];filter.partners=[];_this2.setState({filter:filter,tags:[]});_this2.filterBenefits();_this2.props.history.push({pathname:_this2.props.location.pathname});};this.setFilterValue=function(sideBarFilter,valueFilter,action,filterType){sideBarFilter=sideBarFilter||[];if(valueFilter===undefined){return sideBarFilter;}if(!Array.isArray(valueFilter)){valueFilter=isNaN(valueFilter)?valueFilter.split(','):[valueFilter];}var tags=_this2.state.tags;valueFilter.map(function(valueItem){if(valueItem!==undefined&&valueItem!==null){switch(action){case'add':{sideBarFilter.push(String(valueItem));tags.push({filterType:filterType,valueFilter:valueFilter});break;}case'remove':{sideBarFilter=sideBarFilter.filter(function(value){return value!==String(valueItem);});tags=tags.filter(function(x){return x.filterType!==String(filterType);});sideBarFilter.forEach(function(e){tags.push({filterType:filterType,valueFilter:e});});break;}default:{sideBarFilter=isNaN(valueItem)?valueItem.length>0?String(valueItem):null:valueItem;}}}});_this2.setState({tags:tags});return sideBarFilter;};this.loadItems=function(){_this2.pageIndex=_this2.pageIndex+1;_this2.filterBenefits();};};BaseListing.propTypes={history:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (BaseListing);

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Filter__ = __webpack_require__(1988);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Filter__["a"]; });


/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__);
var _this=this;var Filter=function Filter(_ref){var profiles=_ref.profiles,categories=_ref.categories,places=_ref.places,partners=_ref.partners,filters=_ref.filters,onOrderChange=_ref.onOrderChange,onFilterChange=_ref.onFilterChange,tags=_ref.tags,removeTags=_ref.removeTags,removeAllTags=_ref.removeAllTags;var orderColor=function orderColor(type){return{fontFamily:filters.order.selected===type?'Itau Display Bold':''};};var checkSelected=function checkSelected(value,type){var profiles=filters.profiles,categories=filters.categories,places=filters.places,partners=filters.partners;switch(type){case'PROFILE':{return profiles?profiles.includes(String(value)):false;}case'CATEGORY':{return categories?categories.includes(String(value)):false;}case'PLACE':{return places?places.includes(String(value)):false;}case'PARTNER':{return partners?partners.includes(String(value)):false;}default:{return false;}}};var orderChangeAscending=function orderChangeAscending(e){onOrderChange({type:'ASCENDING'});};var orderChangeDescending=function orderChangeDescending(e){onOrderChange({type:'DESCENDING'});};var orderChangeHigherdiscounts=function orderChangeHigherdiscounts(e){onOrderChange({type:'HIGHERDISCOUNTS'});};var onRemoveAllTags=function onRemoveAllTags(){removeAllTags(tags);};var onRemoveTags=function onRemoveTags(e){removeTags({valueFilter:e.target.dataset.valuefilter,filterType:e.target.dataset.filtertype});};var inputTags=tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'tag-filtro d-flex align-items-center'},tag.valueFilter,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{'data-valueFilter':tag.valueFilter,'data-filterType':tag.filterType,onClick:onRemoveTags,title:'Limpar o filtro '+tag.valueFilter,className:'icon icon_close ml-1'})));});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'border-left border-top border-right border-color-ui-3 w-100 col-12 px-0 border-button-zero'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',{className:'txt-font-body color-title pb-half txt-beneficios',tabIndex:0},'Benef\xEDcios'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'ml-2 mb-2',tabIndex:0},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('strong',null,_this.totalItens,' '),'benef\xEDcios encontrados'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'tags-filter'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul',{className:'ml-2 d-flex flex-wrap'},inputTags)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'limpar-filtros',onClick:onRemoveAllTags,title:'Limpar todos os filtros',tabIndex:0},'Limpar filtros')))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["Accordion"],{className:'container-filter row radius border-color-ui-3 radius border-top-zero',accordion:false},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:false,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm'},'ORDENAR POR',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'filter-price col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'txt-body-sm',value:'ASCENDING',onClick:orderChangeAscending,role:'button',style:orderColor('ASCENDING'),tabIndex:0},'Alfab\xE9tica (A-Z)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'txt-body-sm',value:'DESCENDING',onClick:orderChangeDescending,role:'button',style:orderColor('DESCENDING'),tabIndex:0},'Alfab\xE9tica (Z-A)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row mx-0 mb-1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{className:'txt-body-sm',value:'HIGHERDISCOUNTS',onClick:orderChangeHigherdiscounts,role:'button',style:orderColor('HIGHERDISCOUNTS'),tabIndex:0},'Maior desconto'))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:true,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm'},'PERFIL',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'panel-scroll'},profiles&&profiles.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Checkbox"],{key:'profile_'+index,id:'profile_'+item.name,value:item.name,className:'col-12 form-field-custom px-0',label:(item.name.trim().length>17?item.name.trim().substr(0,17)+'...':item.name.trim())+' ('+item.quantity+')',title:item.name+' ('+item.quantity+')',checked:checkSelected(item.name,'PROFILE'),onChange:onFilterChange('PROFILE')});})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:true,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm'},'CATEGORIA',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'panel-scroll'},categories&&categories.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Checkbox"],{key:'category_'+index,id:'category_'+item.name,value:item.name,className:'col-12 form-field-custom px-0',label:(item.name.trim().length>17?item.name.trim().substr(0,17)+'...':item.name.trim())+' ('+item.quantity+')',title:item.name+' ('+item.quantity+')',checked:checkSelected(item.name,'CATEGORY'),onChange:onFilterChange('CATEGORY')});})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:true,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 d-none'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm'},'LOCALIDADE',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'panel-scroll'},places&&places.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Checkbox"],{key:'place_'+index,id:'place_'+item.name,value:item.name,className:'col-12 form-field-custom px-0',label:(item.name.trim().length>17?item.name.trim().substr(0,17)+'...':item.name.trim())+' ('+item.quantity+')',title:item.name+' ('+item.quantity+')',checked:checkSelected(item.name,'PLACE'),onChange:onFilterChange('PLACE')});})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:true,className:'filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],{className:'filter-accordion border-color-ui-3 col-12 px-0'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'btn-accordion txt-left border-color-ui-3 txt-body-sm'},'PARCEIRO',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Icon"],{iconName:'icon_down'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],{className:'panel-accordion border-top border-color-ui-3 bg-white px-2 py-2'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'panel-scroll'},partners&&partners.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_loyal_react__["Checkbox"],{key:'vendor_'+index,id:'vendor_'+item.name,value:item.name,className:'col-12 form-field-custom px-0',label:(item.name.trim().length>17?item.name.trim().substr(0,17)+'...':item.name.trim())+' ('+item.quantity+')',title:item.name+' ('+item.quantity+')',checked:checkSelected(item.name,'PARTNER'),onChange:onFilterChange('PARTNER')});}))))));};var filterType=__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({order:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired});Filter.propTypes={profiles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,categories:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,places:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,partners:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,filters:filterType.isRequired,onOrderChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onFilterChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,removeTags:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,removeAllTags:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,tags:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),
/* 1989 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAAXNSR0IArs4c6QAAG1NJREFUeAHtXAmYXFWVPrVX9d7ZAwRCCARIBMJmAFlkGVZZRhDHQR23ARUHcGXEUUdcUAYdtlHJoAzIyCIqCIKg4gIEESGENQtJgJCErL1Vd62v5v9P1etUV6qTSm73PCXnfF93Vb169973/vffc+5ZboVKEDExBAJCIBzQuDasIaAIGAGNCIEiYAQMFH4b3AhoHAgUASNgoPDb4EZA40CgCBgBA4XfBjcCGgcCRcAIGCj8NrgR0DgQKAJGwEDht8GNgMaBQBEwAgYKvw1uBDQOBIqAETBQ+G1wI6BxIFAEjICBwm+DGwGNA4EiYAQMFH4b3AhoHAgUASNgoPDb4EZA40CgCBgBA4XfBjcCGgcCRcAIGCj8NrgR0DgQKAJGwEDht8GNgMaBQBEwAgYKvw1uBDQOBIqAETBQ+G1wI6BxIFAEjICBwm+DGwGNA4EiYAQMFH4b3AhoHAgUASNgoPDb4EZA40CgCBgBA4XfBjcCGgcCRcAIGCj8NrgR0DgQKAJGwEDht8GNgMaBQBEwAgYKvw1uBDQOBIqAETBQ+G1wI6BxIFAEjICBwm+DGwGNA4EiYAQMFH4b3AhoHAgUASNgoPDb4EZA40CgCBgBA4XfBjcCGgcCRcAIGCj8NrgR0DgQKAJGwEDht8GNgMaBQBEwAgYKvw0eHU0IvFJJNmRKsrQ7L+syRcl7Ii2xkExpicpubVFJREKjOfybou/cn58Sb916SZ7wdpHoqD6uIXgVlr0i+WeelfihB0lkp8lDvhvJD6N2R8WSyMINeXlsdVaWbMyDiEUp4sqbomHZuSUiB01IyMET4tKZjIzk/bzp+so9+ZTkX1wkiWPeJqH/LwJCcXgbNkr+hZckts+MUcV01Ai4uCsnty3qk1VpEA9k9CUNNbhooyer+gqyEaQ8ZWpKWuJGQh8fvnobNkju8SelFA5LKZMpfwVSFF9dIRIOSeGV1yTc1iaxt+wrxddXSm7+sxLyPIm/bY6EOzv1fG/tOsk+8RcJJZMS23tPkVxeIlN3lVJ3t+QWPC/eG2skstuuEj9wfylFIuKteF0khL6XvyqRjnaJ7LITSH+khCeMF8HY+ZcWSQF/oVRK4rP3k/DECTpOYfHLGH+BRHBeDH2FW1vL19vg/1Eh4EChJL94OS2v9xWlintDLqk3X5JHV2ZlekdMDpxgBPTBIXF6v/kdKSxZKqGxYyX/9HxJHHGYSLEo6R/fKdmHHlaitHzifAkl4tKDcwXkI1HTP/yRdH7/av3cewX6ePU1CTU1gbCvSuLoI6Tt85+W/p/fJzTrbJu79nvSeuEFkjzzVOm/42eSeeDX6Fuk9V8+KqGBAcnc9yuJjOmUUrpfer5yhUQmTZTiipWSmbKLtH7uYimuekO6LrhI4ocdKiEQL9TcLPGDZ/u30tDrqBBw4YacLOoqk49eDiYyJ9EQTcir64U2fBwmejbMsa0Gy88r98xzUsSar/2Kf5fIjD2l+5JLpVQAlgQQRAhPHC9jbrxe14P9t/9UwiBIy0UfhUZslfVn/aNkHpknkc4O8Xr7pO1rX5TYnnvIhgsullL/gLZpfv97pOk95yihe6/9vmRh4hMnHy8lnB/ZebJ0XvMtCUG7Zh/7k3h9fTp2FNpwzC1zRfJ5yf1lvvT/6Hbx1q6XwtJlUoJmbb3k4xKePElCsVj5Jrbh/6gQcEl3QeiAjE+FZeaYmExti0l/wZPn1+dlcRduAs6ILyuhJakxm6JGQc5Sb/0GmLEWCbe3wSKGJLLXdJi+xT5cEj/kQDWrpWxWpLtHz4u0NItA+5CcxVWrJYQZH2If+BOYV67jaKqlUFACZf7wGAjXK/kFz0kUBA1Vpn/8gLeoiR0crPKG19R/58/FW7lKiqvX6BKBXyWPmCMZtNn4ic9K4rijpemdp4PEO9U23+LnEQ/DkHjdYFhbPCRnTGuWd89olaN2SclJU5vlI7Na5ZCJCakeNIMFYgYENAECIFwomYA5zZb/gGUJDx/2YxM8OEcFr6V4TM/zoIUEhCz1pkHIdpAoCe2VVtNZyuXKa0c0KmLd13fjLTpO83nnShRrwGqpGqX6sAzc+4AMwPwnTztREsceJQLzzcnCdWDnd78jLR/9kOTmPSEDD/4WGjE3pO3WPoy8BiyFoP1EdmuNygHj4xKvCrW0JSJy1M5JeXZdTnqwBqSQsPzbYQTrNYY4CstfUV5FJk2Q2L57l9cpAIEayQOZeq+/QcIIf2T+OE+diFr7QHMXg4nO/f4RSc+9SbUbSagakhqw5EnPFd9WE53DOjJ+MDQnQYYZ9VavlizIwnVmbN8GvFyuMfv7Jff0s1KA1uRSgATM/eVpyT7yuISbUrp2DMPh4STaFhlxAmLOCi3s2GRYknXMansiDK83DAIyKMP7KKmp0Q87wD9qiAE4An3f/W+opIKkzjxNOrDek0RC7z4Gk9t2yYV4sPPUvLZ/4TMSgqaj95k841TVkHoiHjTJJtGI5J99QQnR/u2vS3SP3fV96+cukdxzL0iEGhFkLWGsMJyIlgv/WXL0jsd2Siv7Rntq3dTpp4hgHJpsSmz6NGl+9zm6LkzuhHGpcaGZk7jeUDyuXrLkc5KnkwJz3nzeu+GMHLLN68ARJyCnGUkVQbig3lzA3BxigvVuR+IfZnb61jukiDACPUIPYNE71GtoblJA44ceLFGEJLZnsTwSl6h9ABsPD6yI9RQ92yLibToJ/QEQ64thXRWdtU95YpIQaENPLobwB4ngC0MsiTmHqnbjMf++SvBgaYZTJx4nHtaJOXjKTeecqWvH+EEHSGz/WaqpQuhbnRv0HeX6j31X+mf4JT5u7KBmTsFkh3gdbMOx0IbS/A9nS4k4M0ZZOaZfNPhv5AnY4MAjfRoX5env3QgzsWDYrvmAOEtbP32RJI48TEMUw54c5BcggU8mvYwKKfyHPuTSas/Fl15Pr/R+53rJ/eFRmPOcpE49UVLn/n25Wc35PqHr9l1FqOog+KYpgC5BvCGfh1zc1j9sFwE5A+g45LDY46TgZ1+KOJZn5Bkpt0YEBli6skXGVzcJmhPzCCZZEmvI2JAvN5023DuCGkIwNVTxJBnH8jZ2IaSQlyw8wBxMVttnL9bFM03bm00icA46rvyqaloSh/G5v1bZJgKSV6vTBXkBKbZVeGX4pDrLwZskIV/pLWANCE+pARlAeOaepf1D8sJqcUBAOjCdWDPu0R5DwDoqzbFq/3kLnUPTpbBeSp7yd+gkLqWNGzVbwIV3fuFifO7SYG9sz+mSfMdJW+job/graC96xH/t0jAB6anOX5uTh14dkFdBMGrAccmQHDY5KZOaooIU76AcOjEuE5say26wIGH2uDjIVa0Cy12Bm7IcY923rF9mdEblmCkpELuBfgF+dO+9NIHPTAAl+Y6TJTN7f+m5/JtSeHmZeF3dmlmIH4t001+xhigj8eb93zABl/cU5M5FaVk7UM5wTECQ+cOI6+3aGlPybU6fxkCjUtsPBOyE11wrUKayP0I5TyBbcv8r/TD1IXnHtKYh2rK2zXCfmaNMHH+MxB/8jRSRSy0hKJt/cWE5zuYTEJOsiPRVDkl4D2kmZg+4mGe8LHrQ/sgwlPOsw42hx9FHYelyJPIXguRdEkb7MFJXsX320vztcG3pDHir35A8PNTCSgST6TjBy41hIvnrtHptS3C+CtDqeeSDOamYGYnN2rfsbEH7b03osOQXLdGQDO833NIiUXjAsRnT1Xps1h5ePHGj583xGACPz9xbYvvNVCdns/O3cqBhAt63NC1rQD4KyTZnUkIzHNFtXJ9pBzX/uN6rBzLHaYJmnAWCLkDs8LFVGTkQgexpKOXaHmG6KoKUkZY1gYClgYySjPnX9P/8r/T94BYpQjvWE64VWy7+GNJOH6tr2kjoLBb9vV+7SnKPPa6eYXU/0am7ybh7b0f4Yufqw7rYJYn6r7tBev7jaqxV8VB9gSZvveCD0valS7Gm7fCPll/heWaR0+358jckh5DNkAAwlyCYbG1fRSoO3nRdYW75h7dKz1XXSBFxSV07+Sdi3CY4Lu3XXlnGq3I8c/9D0vO1KzWbwgjDoOD8OMZpvezTkjzphG0iYsNPclF3mXwclOZ2XCoy1HEYvJqRf5NCPLEjEZL0Bk+D2NtLQIY9SvAKfbAZ/+Kfh7BN7smnxUMIR709aJ8Q4nKcAF4aGQVoBmqKvv/8L82xtv/bZyUMJ8cXli6RwL1XXYsc6To9rP2ACDomCBbuaBvSxm8bgtPWfcm/aghJU2gYW5j7hVfPh5y+5TYUUbagkOBTGgtkO4Y9Mr+4X7o/90UNajMux6xEGBkKZkAYehkAWfK4nzFzry3HC/0B8cqKl65LvyjZu39ZnijUAOiDYRkGqml56MSFeS0Qajp61emrcf+YtOohEh+GZHidwJUVNhvOv1hakZduZaFEg1UxDROQuVxfmOnoynia8RgBBeh3W/eVpimL9WYfMidFXMKKXgCEY/U0Zt0Oqg6ynKlAswuQKdFpUyU8doxqRMbHSki+0/xw/RgZzzIkT/LQiAM/+wWqUhYoCbO//b3kzzhFEkcdoX1Q8w389B7p/fZ1ZfIx1IN4XQz9RRBHY1EAS50i03ZXE0zyVAuDwsWVKzWHmjz2aIy/uxRB4gzSXzTlJFTuj49BS50tUWZMILyH7i99XckXHjNGkigmoNMVGj9WisgbD9x1j2TRhueximXszTdICAUKFJr53m9cBQI/oAQP43j8oNkSRWkX18IeHDbmk2OImdJ7ZgaEQfM+TC7iRisSQ1aFZVzMNxdxb7lH/6TlWiUQte/6uZrZYYC9EWmYgNWd0fN9ck1W9h0bk93hoW4PGar729L7PNj+IqprlmENWn501EvbKJV1GfOguafmK/AsRyJIIWgXStO7zpLU2WeU86MwKb6kQBial/Xvv0ArRrw1a1WDxA9/q2pLJujT6JfHGaRNnXyCtKLsKc5gb6UfDzV4Qs3LNZlf31cZgCk5Bn3bv3IZshEn6/VQqzCU0v2Fy1VbF9esw7pwlRKQppYPWWvzoIVSmAytl14iNPEqbz0E2ZBpqKhZp+tCEjH76DzkcU9WTTWAkivmbFmYwHVm0/vfIy3nf1BrBf1YoLd+PbpC5gPXn/3Tk1r9QvKFUPSQOucsrX7RjAu+16UHSsS6v/z18joUlTzpm25VbCu3uMWXhgmYgt3tZ019RVagiuWmF/pkNpyEnZH3ZayOmnxr0p31ZKAqdsOM3PPrc5qeq24LzkgOKu9lVNbQ+94Ajcvud2pG6mhrA9EkQLP0c9aDFFyk80GwwreEIC0vNHXGafrA/YtmcWZdAcixQ1CWPnmiFKDN1ERBK7AAlMK4Yv55pMIgETgbzed/QFhV4vfL41sMh6D/lg+9T8lPU0qh+Y8fjho7vDKrU0LKi+tVShGEzfzyQSUmSZoE4TnuoOB+o3B4YjP3UUeB7Vj9kjj1JClhqZBF7rgEklBi++4jLVhjRnefyo+DEkYdIoXlWKw/LL6OrA0ktvcMafnYhzVfrQfwj0sN1ho2vfNM6UFxKmOurDdsVBomIAtHF6yFva8I4V+BaudV9JwaIJ7fjq9V1lz6YF5veQkPdhghV2nyKa3IIc8aW86Zlo/U/8/Zmrnnl+UHhVM4SznjVfDAqek6rrwca7KahX1Nd2zHmKHHUqaKaOoKs0OXATiWffgP5XUl3qvp3WfGEPL57YZ7je40SbWvTz7/vHATgscgkwpnI/8g+edeQlXLG/rew0ToR5VK5te/08/+P2pJVkn7bTwUkfL+CyBSYfHSQYcljjL/iK85/cZVr94bazG5XtRJwMPxOUxl7lV1RvktHbToAbN02VJIv1L2jjc7q/6Bhgl4ym5JxP/yuvar7ooEqVJo1V81/L5KsQ7bht72W+EBT2mrPJRhz6x8AQ3lr/XUtCAcworelg//kzR95H31tRJMX37JMum/7Scg1h9h5hBKodYbRjSEsXSZfktNQA83zNq8bRCayzBIWCvDafnCsuWDM5KblQZ+dm9t080+ezSfOFpCqT8zQiqwAvG3IHSyBWvCOkCO4ROZ16rOVe0I6INFsMw8qfiTvfa8Op8bJuD0jricM71ZHkQgmvs5qotK6/Q7YoeITzs030Eg3wm7oiIEgeutCUGKYTeXlhrBrEXGj8P+iZlaLq5hmJoOqOkK2PjTd933oFHuUs9OPUsAGmW1By7CQ2xuSKgDfZDgpW6YdL7HOSGUJXF/xdavUJvovxCcoFrtt+nbzd+V4JX7omGl6XuUy6H8g3VeqZm5HvVgrQTaUQWf2X5LQgdEowaVkxgTHVaorZk73UZpmIA0sywmndwclWdgilf3Yy0HW0rzqGapMjCDxa8jTcdKLK7XaoVOBYPa2I+kwrXj7u0gTNVT46wk8fhdO8Ive8H8z4Tp5ZbOhgQEZHlRC9ZjfiZkS+3yz72oGZLsr36jYQnuwUhgDRZFaRQdBK7Buj51mQawN+vHvySaSDxcf2242XnDHYjhEfBmGxRWwPgShbnvuObK4WN9lRPVAoBwQwQWQgk55GDNB04mfxmAr0o9w1sDdbLoaFGq2pQPDP+/YQKyC5rBqQgCT4HTwTxwhgTkF8DeF5rjOxb3SQsYeDqyFrUqntszb3qhVwnMNklcwVl7NGvO1++DryQ8lV0TUiWjuX+YszzzwEPlYC40WuLot0nHVairqyrbKix5eZPmqLpIaq6Qn2+F48MSK82eYE/FaInu0SVhQXhdHkAj1jWLdS6AcT3GPVXQvrhwkSqP2mfkN+XOO3rKvhQWLylbBzhHQwT3XkA4Rs01vqiOkQ45r86HmmlR54w6h0gMaiMGoyfwD3nfTX9lwjB4zO9r/8agKjpaNeN5AdrPkD7K7bhneDTJx1tj6RL3XPCVkjrrNN3u6JdDUbtn6AkyzFIreBBMlangvNxTz2jsrtoi1DZx/UwnQPd6oCMP8ToGgAe3bm6l8zCWIiEsKXyh81Kqd1+VEyITxpU3pVc0GjcwcRtmrRC7HDztom4fgLPCKECDsl0EbLDvv43TGE7hohkEorCgtVry2AXWhzSZRsGrv8B7ao7EicdquIRfscSdZfCltXXICk07EsJ1bXQ/xBghdCj6EXPL//npweuvHcPr6Rk8xL2+uke4Eu7hDrc+ZDi4V3iIAAstakUgPXbAfoNrzALy2zzfz/b4bfp/crc6bhpbxDqx6QPn+V9t9XWbTPBWe/sbPIFeK7cj+jG3vhtvxrpvHNJXB+uusb65N8G0rtZYW/G1FeUHzZRMhbDcGZbAvtgM8sBMnWVQ7LBmznESP+4Y9bqZFstjqyXHGXPr3EGybi9UXNOyZH8DiwG4yXz+Aln/3o9ogDh5BILjSIEVUQShsc/fPYKC1IxMuPdOPc7lQuLE4xETnacVQdScvZhcA79+uLz3GJkNxgjZZwIB7fZvfEmzLP3I9HjY/6FFv7fdJTlkWFLI2gicrhwC1dnfIhTF9S+C+01nnS5J3HujMuIEhPuA9RtsdINCLTKaJmurl4FMSOLtR2qAlkTh/tjuz39lsBm3Rza/91yNbfXfXiZgCWsen4AhpMJaPnORbiTKwwTzIWm87eYfD/bBN5Fdp2DL5UaYtM1DLkNObOBD4qTjpPWTH5e+Gzg5sFUSprjvmu/qX21z7unVcUFMYp1EmX4RG9X7rpuraTR68qxs0X0lfmM4LFxr0rTS0WnDJvQeZjoWLlFrQavAv2phFU7ylBOl5ZMX4tcZthxfrW434gTEk1EPmAqCRq2WijzGP1/4PR0OZ8E6hWCVQth1gpnILIGfCttS3/QQE0ceLq0gEQsKuI5jqIPrrOhee2p1R9N575L093+An544QMuzIswfVyaZtj/qcOn41uVCTZF74kk84BXaB8dnvpTXolUpuC4ei+Lh8mcsaNY1C1FvwsKUMXxCTzWC/b7VC3s6HcxIMIicuf9BBIsRnAYRPe5WA5jM6TL0RNJrCKbKkeB3TL1F8d0AMioFRACKa7DXFxmTMPLYIVYMYW8vtTrXwby/FGopmdfm3mDuhOMvLXCi8l54nDnq5PFv1+LeKLMy9e5nmIeAfSYVWzLMCdtz+A78JkwXvN0PzETiuiY29DoKTK+e341fy1L/GcWsEbns0M66BanbNDbMnxaa4oERNG531Bgb3jci1ASsE2Rynbu/6C1yF1l0tylahcI6wSJKpdg3N4CHATzfVwvXWx6yDayO0U1RmFgMmzDexnAOSUHh/lxvzTrV/NQW0Sko0ap5aDSPmrXAfXFXHJcJ9EqHCDQx12PUgFwPcv8Hr4kTkBOI2pkpxOrQTXV7bcvrxXWX8sgN41kxq8FKGMWPXnDVddHks6CD96epQY6FpQUnFIPp2xLP9K9jVAjIQoW78dsw56NgdRcUrPpCrj/82gB+tCgtiOKozMYvZH18f5T++CfZ6w6FwKg8dwaNm1G8cNfitCzHbwMyXshChnkoKP0piOmTjz/VNmcSNMQOBbndbDUCo6IBOQB//eDWl3oRsBYZg70jA6jnWwuz66//lHyTE/j5jiYtMqi+KHu/4yAwagRkpGLBuqw8sjKDXXJF6cbWS2ZJ+GsJXPfxF7EOx4Ym/oKCyY6LwKgRkJAyT7wO+0jKP9HrgYD8Fayw/jzvrkjnNVJYsOM+mh3jzkeVgDsGhHaXLgiY/XNBz9o6I2AEdIbQOnBBwAjogp61dUbACOgMoXXggoAR0AU9a+uMgBHQGULrwAUBI6ALetbWGQEjoDOE1oELAkZAF/SsrTMCRkBnCK0DFwSMgC7oWVtnBIyAzhBaBy4IGAFd0LO2zggYAZ0htA5cEDACuqBnbZ0RMAI6Q2gduCBgBHRBz9o6I2AEdIbQOnBBwAjogp61dUbACOgMoXXggoAR0AU9a+uMgBHQGULrwAUBI6ALetbWGQEjoDOE1oELAkZAF/SsrTMCRkBnCK0DFwSMgC7oWVtnBIyAzhBaBy4IGAFd0LO2zggYAZ0htA5cEDACuqBnbZ0RMAI6Q2gduCBgBHRBz9o6I2AEdIbQOnBBwAjogp61dUbACOgMoXXggoAR0AU9a+uMgBHQGULrwAUBI6ALetbWGQEjoDOE1oELAkZAF/SsrTMCRkBnCK0DFwSMgC7oWVtnBIyAzhBaBy4IGAFd0LO2zggYAZ0htA5cEDACuqBnbZ0RMAI6Q2gduCBgBHRBz9o6I2AEdIbQOnBBwAjogp61dUbACOgMoXXggoAR0AU9a+uMgBHQGULrwAUBI6ALetbWGQEjoDOE1oELAkZAF/SsrTMCRkBnCK0DFwSMgC7oWVtnBIyAzhBaBy4IGAFd0LO2zgj8H7y/GWFFFnSyAAAAAElFTkSuQmCC"

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_chinainbox.59ae3c95.png";

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_centauro.0a943837.png";

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_shoestock.ddedd66f.png";

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_pets.363d4514.png";

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2014 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_unidas.79fa7612.png";

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img_cafeorfeu.6ba044ab.png";

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAAXNSR0IArs4c6QAAENNJREFUeAHtnHmQHVUVxs8sCQmBsAQIEEIgGPZ9lU12lIChFEEpKCy3YnEp/xCFEqsoUEqqQFFUXEpLgoglguxQ7Bj2TQIIJCwJSYAkBAhLtnkz8/y+7rl59/X0e5l4Mu+a8B3p6e7b99x733d/fdeObVWYyaRAIgXaE+WrbKVApoAAFAhJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmUuAMVAUgUEYFL5lbkAFANJFRCASeVX5gJQDCRVQAAmlV+ZC0AxkFQBAZhUfmXe2SoJFnWZfeVGs9cW5jmuv5bZBYeZHTC2cQm6e81+MsXstlfMenA9BK/LhfA5cny9Ty+e3f+62VXPmj0822zBYsSvmnW0ma03zGzfMWZf28Nsj03NzrrNbMZ7ZnhsY0aaTT4+jxNSrCCtKUhr8lSzR9/I02I52pHWSJR5z83MTtvN7Kitzc69z+yRWXlafPa748wmbBhSMutFJs/MM/vzM2Z3v2b29iIzpo+kbF3E33W02Sm7mH1+e7OLHsLvnJ6nxd/564l5XvT7EfKhH209+F1xrNm2o/L7Rn8v/JfZzdNQhr4I1OzCQ6FhR3+PNz4w+zLqZuHS/Nmo4WY//7TZjhv3j7uqQ1oG4Cz8yLtmQGBUSrCfPZrD0QnBy+zOV81++VgOU3hO0GIAmd6VAI+V9BEgj40QvrvE7A4AfO8Ms89ua8Y0g73yrtmcD+sB/MPTgB6Vt6gSYuVnwsQKYjqE/KsA+q+AtBvhwf7zdj2ANwOos27tnxZdPlhm9uAss8cB+XPzzW54yexNlCXYSwtyAB+dY/YirmNj/BUBeCPg4+8LNgw1vaynHMBX8EI++WaIiRcUb8gc1FcrAGxQ9bXCrKortkqEJTZWJCugzAjOLwrwMR4hiNO5+nmzs+/qD18xzS6I/09UctFCWjz/BSBfcH9/YIo+S7vR2j1VDx/jhLR4/fRbZufcs+K0WK4rnjR76yN61YzA0wqSZWHhWXbT4E8xDssWly926xfOJrpF1jIA56P7KdpitDJnoIVYggot2k1oPZ6I3srwnC1HqJQKKu/iBwFC6GdCJJzXGWq25Xr1rVuxUqLoNg/l+ym6waVIs2hrDzEbi7Q2RHfe1lc5HBI0svfw8px2A6CKWrQQdy20REyL3VxIqxkcwW9NPUOO1hhbwDKb9b7ZdS+Ynbpr7Sm7jh+jGywDhmNJhnNMxpaDXWhsY0eiRTzA7LCt8zHbYsR/eA7GP0hvZt/4M44fru94tb4LZPjGa6MVO8jsM58wGwEICfyz6P7YMk+Z1bhFuWem2dxCi8Yx33f3w3hvB7MNADJbvqnzzC5/vHlaoXxr6rllAL7dAEAK+ycM0jkYZ4vA1oAV3AhYjs0IICuQlRd3H0MxwL70aLOjt6lVFwftJ6DSOQE55EqzD9GCltk16Mpj4Dlm+uMks0+Nq499BMDeHWkdMbkx0A/M7N8qn3sgxoP71Kd11Hiz7UbhZUG53kGr+XG09lb96HeaAPjMXLPLAB2NA/lbX86vy/5yokFQOGAvQj1+A7MDtyzzMuOzz21X/uxDpMl8Y9tnc7O9cZQZu2KC2Mg4SYiNkH19zzikds1hwpd2rt1/3K5aAiDHaAsLLc+otbFM0pc7gbpoitm0d8y+c0c+cw0Vsf8WtXgMYxeM6KUtxl4Ahl1lI9tldPmThWh9mG5sBHZ4g/6BLfXOm8Sx66/nFbrf3ZAvW+dGxi7+42otAZDdZbHrmwjR2QUF4zrXGbeY/RutYbA90dV9a998PS+EceJCYOPuMjzj2KqZcQJQagBq+cymLwKDmllZ/ozPNcnipIiTmGbW7KVp5tfsWZjgNIsTnjX6LeH5YJ5bAiCXLYprdJuuY3Y6uqUhUQkIXxjTcQx2NsZNnAhwwhFsMdLiZGBYSYvCCU0z40Jwma2LGTPzi+0NdPFdgKnMWMbnC91siNeO31MEbsEKxnevvhe8V905kixLlGuijUCb32R4tOpKVJ5SVP3lEVZFKFstHrFtBLD2H2t26FZxaO36kHH5BIAr9/FC9bI+mDddtx5eenIxtTj7DCly2YS7CmXGicoOG9c/efIts6eQXpnNBOh3zyh7kodtvX79M651NppU8fdcNbU+fnxXBInPGqUV+/HFjY3LYBzrFo1Q/h0TsFTWEgC5zsdWMDYKxFaHs1Zul8XGJYsLD8vHc4QvjBUZh93be0vNNhqO2ehmsVcO39XP5Sv+8RPmfdnj2FqbE4fWrtldfWHH2rocn4S1vPsAGocPTIMzcC6dnHK92ewmrS2362Jj5X/vrtpWV3jG33L7K2aPAdBGxi2+ot00Lf+tQVeWLRwc7tC4zRcbF/a5JRie8xlb8rvwUnJ3KZUVOp7BKUZZC7gBAKJxFnjarvmaHt9GAnfmXrWtJt7HLSDjcJC/CyYBPzzY7MRr8y6ZafHZJY/k3SOXYjZDN8/KvxMis9LwuKFxTMptv7gFZUtz2o1m229kxr1rAjhtQfkEKE748K3NfvVEfWXfMj3ffuN2IFvI9wE14b4J4dwia2RlEycCO+lvZpujF+B+d2wcB190BGbp4/PlLQ5Xgl2OMnHH5Rj8Vr78HPJMxu4PdUtlLQFwCSou3u1gi8YKDXbep/IWiGJxtsgKD9YJgXnExn1K2qHjsOwyFm/wzOw2+8O8uOVWtu1Wi9X/ahxehG9gTMrdkLjS2Po9UdJCsZxxaxKn+MktzCZOMON+bBjTsrW7F8DxWBnjKgCXcbhCEIzATMc9j6JxTM19aq578sOIF6LlJXb37CF4/L8Yijv4lnUPACMY39oRQ8Od2VqoTC5VcN2NXUe8ZEFY4xaQXm/iLQ523sFmo9HSFRgNj+vOnPg0MnbD39wn360YNqRRrDycLU+ztTuW99KjzLiWOBBjehx2lBlbqouPxNZdYUxXFjcLw+8goByinLl3f+3K/NZHq9ko/7L4qzKsJQByBsYjGEUd6NIDl06KyyfvYwwYjNBef2K+LlcENcQZDqAO2tLs98fVz3Y5wYlhZ7l+cKDZbybmX6JwmEBf5s8XZvQIs+O3w2dOJ/cfYzGveLZOYC4/Jn+pmG6ZMe/d8cJdi/LzHFv8m7kbcwmA3gYtGtNqtsTCCmW6jHPqLmbfx+8hYGXGl3sH9DbXnIAGAEOaYGwg4nF3CB+Mc1sVNhgJx2ly+YNdIgfCtC3Q3Z2EQX9c+fmT/n/Zdd32cq0rITSTMI6agG4ptvloFR+YnX/WxHEau0cKv8dm+AxrQj7jXhuVx0H/8+iWuF7H7wFP3rm8leBHD3M/xBgS40B+oDASALIFJYQs97dvx9czha6MYB4M0GPjy/IQynX9i/jsCvlyiECYd9o4h/kAdLGElR9ecEzI1ostMLcmizNZ7vw8Nw+fWWHZhpOksprj6sLJ8A0vOIcTnDj9A/k/OCsfh7L822xgdix0PHp8/rs4U+dkhLpsiBePkzKeB9taAuBg/4hi+hxvUnjuZJR9gFmMv7L3szEGnXQNvptbWPNkizX19Lwya6H1VxyKcBzGVnUgL1+9t/+Oi/18AdhTFNcq/an/bylAtjXPCF6jbbQV/dopaCXum5l/pczuqdgVPYvW5Jy78SFCYRnm8K3y1rFZ+uw+G3XHzfxW1TNOUIY0GGuuqjxWNp01sgVcWRFCfHa7/Mrl5XfzFoKzcXaVm6DbZcvBmSgXqOMxKH357eF1J5ntNyakpPNAFVgjW8CB/vhiPO5IcHxF49olv2rmsSI7EeMlLnvIVl4BAdinGQf0/AdTnMnGM/ZmknIs98Wd8PHs4WnGdM3Ktro8Uxcc1RS7Vs5s+Q+TXgeMjZYHCCl3Ys49yIy7HikmFFGxV+tLAVhSfVwu4j+nnIqtKu66ZP8QCvG4fDJm3XyBeV+sP6ZavC0p8mobJABXUHX8igb/ZYaGL9t7bbYQ3BdVpwEqIAAHKJSiDY4CWBmSSYF0CrRoFsx+7AOr9nTl+0cc3WcjfPwJ19k53POmLw6np/ivjUHhWP7pAd4fhmX36CCr7CSjczG8cF/N4jMJ+uXnLLm+a6Zde9b/OsRlnrzuF5dFYcJRkfrd51nXF51pMXwA/rkwzAQaZ2nlJckHDrheHsaBBO9DKWv39F4eH3E62zpsVPt61oH/Dba1BMBq13TrmXc+FtcWWBs3VrlRy/0yfgiH+yys79qWQZi6MMRbirDwvALourFJ2YuN3h4cPPfivocHlvkZll1H5ywun8dhjDscSy5DrVLtsK7s6MyuK9bZd9/R96wvnHFQKZVenvM4lWr+jP5ZOgivMA6WaLoxaakgm+yMrHkOYSxqF+/5PMTBOcRnGK97EKer73mIx3MIYzrWgel7+1Jra19SOPKwdoQbjuyMuO1tuO/APc5tuK/3W2rrgLvfjjjf9u3cbbD5g1qtsF7sW/XMxbEIrSCA40ZtBWDxTBh5EDBulC7BmZCGI4AawrsAYAYYIcTOeze2L9iyZgcBQxrIo+7gDj+CsgW+HjQJPLpxACQ2ClVAVK324qjiY4BeRKviwBkPe+CLEmf/HzD8NyIVXHf14kCL04VmqoJ4PC+rtuO6imvcG66H4BmKkwEFSCpgJECVheFZBhEWvCs8CBklwdGNsmYSIT9+jJHli3LiEfLHGUWv9B3dHEQh3/Z2RGzvwRnOPHcgdhUlwdG2/ABsBugIHs7tgNB6F6O0+MqB9zjQSthH7V32fhVfYrTAWHyZFKhToAUfSC3PrzUAtqE/4iFbLRTobOvEOLA1naOWYVYLJNbcQramBVxz9dMvcyogAJ0Cyt2ngAD06SdvpwIC0Cmg3H0KCECffvJ2KiAAnQLK3aeAAPTpJ2+nAgLQKaDcfQoIQJ9+8nYqIACdAsrdp4AA9Oknb6cCAtApoNx9CghAn37ydiogAJ0Cyt2ngAD06SdvpwIC0Cmg3H0KCECffvJ2KiAAnQLK3aeAAPTpJ2+nAgLQKaDcfQoIQJ9+8nYqIACdAsrdp4AA9Oknb6cCAtApoNx9CghAn37ydiogAJ0Cyt2ngAD06SdvpwIC0Cmg3H0KCECffvJ2KiAAnQLK3aeAAPTpJ2+nAgLQKaDcfQoIQJ9+8nYqIACdAsrdp4AA9Oknb6cCAtApoNx9CghAn37ydiogAJ0Cyt2ngAD06SdvpwIC0Cmg3H0KCECffvJ2KiAAnQLK3aeAAPTpJ2+nAgLQKaDcfQoIQJ9+8nYqIACdAsrdp4AA9Oknb6cCAtApoNx9CghAn37ydiogAJ0Cyt2ngAD06SdvpwIC0Cmg3H0KCECffvJ2KiAAnQLK3aeAAPTpJ2+nAgLQKaDcfQoIQJ9+8nYqIACdAsrdp4AA9Oknb6cCAtApoNx9CghAn37ydiogAJ0Cyt2ngAD06SdvpwL/BQd6SsP5iwSXAAAAAElFTkSuQmCC"

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABAlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ2MCwgMjAyMC8wNS8xMi0xNjowNDoxNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ1dWlkOjVEMjA4OTI0OTNCRkRCMTE5MTRBODU5MEQzMTUwOEM4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQwMjM1NjdFQjdEQjExRUE4NTM2Q0Q2MDREQzUxQjg0IiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQwMjM1NjdEQjdEQjExRUE4NTM2Q0Q2MDREQzUxQjg0IiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIElsbHVzdHJhdG9yIENDIDIzLjEgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpiMDgwM2JjMy1hYWM1LTRlZGQtODg5Ny1hNmFlYjM1MmZmY2MiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpkYTY5YzBkNS1iNDVlLTE0NGUtOGM3My0zMjExMjI0YzlmZTUiLz4gPGRjOnRpdGxlPiA8cmRmOkFsdD4gPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5pbmtfbG9nb3M8L3JkZjpsaT4gPC9yZGY6QWx0PiA8L2RjOnRpdGxlPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pvll4ZgAAAzlSURBVHja7J0PkFVVHcfP4gK7GosCCkvISiC7RIKKuCXrf6mtRGJSq4kEQ0QzCxvRYcxpKvozOhOFMv5hwaC/RFGJli3+QXCJfwHRLCpKtVqwNALCog4IbOc393tmz77Z995999733j13v5+Z3+x7++697/753N855757zylpb29XhBSLHtwFhAISCkgIBSQUkBAKSCggIRSQUEBCKCChgIRQQEIBCaGAhAISQgEJBSSEAhIKSAgFJBSQEApIKCAhFJBQQEIoIKGAhFBAQgEJoYCEAhJCAQkFJBSQEApIuiel6T6o6l/hyjZ8SccYHb10+OnwWqY5quNFHX+2/l+v4+oMyynB/9fqWJmH7bhbx2Adp/jYDlmX93Uc1/GEjletz2brGJLDco5jWbKc13Jc5zt01Og4kWVfb27Zf/h3OQnoCGfrmKdjaIB5e6UI+F0dF/mYb5KO53QcinA7JuL7ywLM+5IlYC32x2kBlrMuRwHH63gIEmdjqY7ECSjybdPRX0erjl/hrM/ESR2n65iuo5/1/7WQb6+O5WmqJnKWn6ljqo6dOj6i42AE23Gljka8Xq9jo4/tkHUZp+MyHb3xvxGQUY7pJh1NPpdzgY4rfExrczHWU0HCE13sM9nX5Tpm6ajIuQiOOVLEbIV85uz9Rg7zT4e0wiodl1oi3pVlXim6F+lo1vFhHW+H2I46Hc9b7+fr+K3Peesh4Ba832Qdz4U6lvlczlUQ8KTP6SXLbsBr2f6Xs0wvAvZMUiNkMOQbYP2vT46ZUzimY46Oa3NcToOOW3VUIhP2DbgdtThxUrctl5NQGIWqxBnWZ4MC7A8/TLDkG+VDPrNvjiclA8oB2o6iMCjtiHtRDwzCImSMhoDFsdSf/hpyX5iK/9MFSiR11gkj8r2S4z53PgNWIvOdGdHyeoWcf7GOmTgpmlG39MP5yCIlIb//ZAGP4eUh5FOZindXBByEBsfAmK1XAySsRHHUL8v0o1FXi2K/lxRoG6V+uAavawLIlxEXBByIzDcwpusnEs7ASdKcQcIayNfToVJHWugv4HW16ny9Mddqj5MCngX5KmO+nkssCXd2IeEItFZPdUi+a6wWusi3K8AyDmXzLM4CDkCxO9iRAyYSfhmZutlqlQ6DfKfFfP3tIl0ujK8OKZ9C4yxjYzeuAkoG+ZtD8hnk56xbkAm3IIs0qeCXaoqB/BzZaFUbgsp3rvIurKtMLf44XoY5HcXuUOUmi5FNFllZxAU2QppnrdbuqyHk24asLyXDD13JgEa+KuU2pnXsAqaBcI+V7apDtHZFvu2Q7wnUjZ1oBfeFfMNUMmjItvNjgvmVYk5Exe52NLYWo06sXBCwT8LkS20dx5lj+Cu3TY0MUeyORLFr5LvFz0xxELACK/4hlUxEwptjvH6mpTpW5X4/oC2fKXYb/MoXBwH7oLU7XCWbn/opjoqEXDKqD5H5apBAylXHz5O+KS2yfFLsjlDdA6mQn4SMcWJFiHmrIV8ZWv235rqAYmVASdVbupF8BrkzeHpCtmVUWPmKJeCpkG+k6p4sjXmd0K98W1HsPhZUvmIIWAb5ahIg0oCQdUJXM+FIyGcy321hFlZIAeX+u004e5KA3Fq1RuX2LEVqJpzh2DZXo9FYpjruDFcuCCi3IG3WcV6CitLdyrtRc1OIZSxJaR0fj/H2yu348uvIB3R8S0X0S0+PAsknB2lMQut0FyrvQaUwrWOTCeN829n7COG5qBaabwFLkfnOT6B49u1L8nTa2pCZ8EEV72d0JImco+N/ynv8c0rcBewB+cZ2k9atPNq5LsT896BoizN7cDzblNc7xJS4CnhKgjNfJuqQHYJyzIFtbEVL+DAk/EzcBCxBur5QdU8mhMyEyhEJayDh78NkwqgFNMVud5UvqkzoAnujyIRRCiiZT553HaeIyYRNDqznTTq+EHDefcq7Nvh20EwYpYBy3/94eteJSxzIhNI1xy+V11VImOL4UJCGSVQCNoXYgO6QCeMsobkNa0OIqtM+q04oEk4qpIDrcKaTzBKujem62V2UyINJFwVcjt0wedKvhGEFXIsKN8nOpQ4Ux6WQMGg9fm+KhNflU8A1qqNfPeI/E8b9Eo04sSlEJtxr1Qn/mC0T9ggh3+X0KRB1jki4MUSj0kh4AJnwk1EK+ALli0TCpoRLKHXCC/B6dlQCyl0QV9CfSJCG2/qYr2MJJLw44Pxv4O+RKAQU+a6iN5HyMUck3BBQwqxd9PoVcDXly6uETQ5IGCYThmqEiHzX0JNuXxwrSFhbKAHlJsu/UD4WxylsUBH+5JpJQOle4eP0gsVxmkw4Pt8C7nfowB3JYdr/RLScN/NYHPv5xeS/GT7bF9H+yNYwySah6aI37ZODmZ5BaHdIQKkcP6C8ri8y9R4vn/fPME1tjsvJF/KLyTZUgUrSfP+4LKVXjY86viwn6F3r5heTHynvTu6uhuoyA/+0pTW5vb1rz6r6V8iC71KEhGdFy/7DNwZtBRMSlp8HKYIJCYvcKV2vOkbWpICkYEi/g3IVZU/QVjAhQZEBFMdkk48CknwgYxVfq3yOP0wBSZTcreOruczAOiCJihuU/9HeKSCJjANo6W4OMjMFJGH4B1q6rUEXwDogCcoq5fWU1RpmIRSQBGGB8h65DH2/AAUkuSL3B3w9qoWxDkhyYbLyHrNUFJAUErm/8BM6/h71glkEk2zIsAyj8yEfBSTZkJ6upIuOvN0dTwFJOubr+Gy+v4R1QNIVd+p4uBBfRAGJjVzXk+t7TxXqC4MWwUd4rBKH/KIxppDyhcmA0iyXB9bfw3vpA+QEzqBPK2/8s8oEHRzpF+dxHferjiHuk4SMYCqXWQ4U+ouDZsDhOj6nYwdCnlF9SMcuHd9U3kDUG1LmkSGedmdYpjTzn1Hpn2ndpTr/7ijL+6fynjs4iMsF/0opTuSO3JMIOUHkOVV5hPAw3rekHISnsFwb6VhHxvf9Db4rach2jS+GfGFbwXbvqDKConRwvRDv31Xes6kG+flmIMSsQjYxSO/6tTjI39MxSHUeNkB6CpDxKKqRVaWO0oaQfgo/qGOIjm/r+BSmuxfSTdUxWHk9wUtshphyRb8cJ89uZHMZfvRnWE+5w8M8sC3STdQxVCWvO+IHkEiKRhgBD1mvzcPTdofXVfgrEvwYIs1TXp9xs5TX0aUgPQHIA85fVF7Poc3IaAoZrM6aRmQyd2EMh3TvIqTVthKZUnbsMh0/QUaV5UivnXJBtTdey8jtk3BSmH4Pl2Ma6ZDpeqzDAFQrklbvnYUTVbkqoE1PFMOP4P1HkU1EpF8gQ4lEpsfMMqR8u0idq+NGHOhn8D8zeN9sFBNnpNRdR1jzi5z2YNhSxJ6nOvfgvwV/j6qOIUfvR7VhD04Q8yzDRtXxRP+fsL6XKLd6jOiK46jvPR6HlYlKwH9DstV4LyM/9rPqgYdQrEod69c4mHKR8yzIKshYtCtQHF8HgUwPmzNQjMs825HlVEqd73bsWOFRqwqwxJrmYRS18tCM6driOyiO5Ud2GYr+Lfy/N0QV6q3qwpUOy/cGTsrGuKxQj4jmvQzFneEO/DWDVLdBvLmoc5RD2lYcVLm/7Fxr/lUosifgvYjxDorcsZDzLSsjmgESG61Wq0HqhDfhtXz+FR0/sDKhLO8+yLvSqueVovhVKI7n4fWLys0uS9ajBf9KnFYqjID9UlqkX1MdA9ZJHWs6Ggh2h+ZDIasUnfPRipV7y+5EVluU0oq92Xovn52Dxk8pPh9lTbsVy1TIpA3WvAuseuqDaDSZInkHXkuVYZryxjxTaC03WlnwPtQtq1GnneuQfMtxMrfFbcWCCtiKIs/wEjKgHLzbkOGWovhrVJ17cloH8eYi2yyAUDOQJYWrUTSfDWEMLfiuOWhE2C24Kagrfh7vZ+p4Da/7IguWq843U8qJUIHXL6Mxc7tVJXjMmvYghJdOm/4AwWc5IN/3rX0SO4L2jrUHRdEQK1tIve4GvJfXO9GgMPWnJ9HCHYIWr5H/dWSsHbgEMrmLetbrqD8exSWTcWjdPm+tQwuKyjJMvwvCDLOy9D7UgVK3ZSVkn4z/LcS6XG9N9x7mH4ITRrb5aRXR0PV5YmZKSVA0WvYfjlRAEm+OoqH1bFxWKJ2AvBkheUhJMNGqfsQa3g+YLGTwyNGuyEcBk8UyXHF4x6WVpoDJQK6PTnNxxTPVAct5XJ1gGrKfSpqAbbjUILTzOMcKGfZALvZPVfEdiT20gE34vIQCxlLAN12XT0h7HZAQNkIIBSSEAhIKSAgFJBSQEApIKCAhFJBQQEIoIKGAhFBAQgEJoYCEAhJCAQkFJIQCEgpICAUkFJAQCkgoICEUkFBAQgEJoYCEAhJCAQkFJIQCEgpICAUkFJAQCkgoICEUkCSL/wswANpYnDg51aeLAAAAAElFTkSuQmCC"

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cobasi.48bab194.jpg";

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAIAAAAErfB6AAABN2lDQ1BBZG9iZSBSR0IgKDE5OTgpAAAokZWPv0rDUBSHvxtFxaFWCOLgcCdRUGzVwYxJW4ogWKtDkq1JQ5ViEm6uf/oQjm4dXNx9AidHwUHxCXwDxamDQ4QMBYvf9J3fORzOAaNi152GUYbzWKt205Gu58vZF2aYAoBOmKV2q3UAECdxxBjf7wiA10277jTG+38yH6ZKAyNguxtlIYgK0L/SqQYxBMygn2oQD4CpTto1EE9AqZf7G1AKcv8ASsr1fBBfgNlzPR+MOcAMcl8BTB1da4Bakg7UWe9Uy6plWdLuJkEkjweZjs4zuR+HiUoT1dFRF8jvA2AxH2w3HblWtay99X/+PRHX82Vun0cIQCw9F1lBeKEuf1UYO5PrYsdwGQ7vYXpUZLs3cLcBC7dFtlqF8hY8Dn8AwMZP/fNTP8gAAAAJcEhZcwAALiMAAC4jAXilP3YAAAXIaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA2LjAtYzAwMiA3OS4xNjQ0NjAsIDIwMjAvMDUvMTItMTY6MDQ6MTcgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMS4yIChXaW5kb3dzKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjAtMDgtMjFUMTM6NTg6MzAtMDM6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjAtMDgtMjFUMTM6NTg6MzAtMDM6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIwLTA4LTIxVDEzOjU4OjMwLTAzOjAwIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOmJkNGQwOGQwLWMxYWItMGY0MS05MTY0LWM1YjNlNDM0ODM1MCIgeG1wTU06RG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjA1Y2Y5NmE1LWYzYzAtZWE0MS05YjMzLTJkZTI1NDMxNGFmMyIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjMzNWQyMWVjLTMwYjUtODk0NC04Njg5LTJmOGU4ZWEwMzE2YiIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjMzNWQyMWVjLTMwYjUtODk0NC04Njg5LTJmOGU4ZWEwMzE2YiIgc3RFdnQ6d2hlbj0iMjAyMC0wOC0yMVQxMzo1ODozMC0wMzowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIxLjIgKFdpbmRvd3MpIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpiZDRkMDhkMC1jMWFiLTBmNDEtOTE2NC1jNWIzZTQzNDgzNTAiIHN0RXZ0OndoZW49IjIwMjAtMDgtMjFUMTM6NTg6MzAtMDM6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4yIChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6e8csaAAAP+UlEQVR4nO2ceVgUR96Aq3tOZmBmgAEGBEERBVRQAaPgQTxW1MUjhxqDaKLu5suXxGjUaGL8VhNdN8R4JRqvxLheiUZB13iu0RDRIAoIGFAxyCGiwABzT1/fH832NDMjzrj6BOqp9/GP7urq7l/3O9VV9etGbGLweICAF/yPDgDxbEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHKFbtSP69cw49vljqx1Yt+/A5/vY5e6+lrmJD108vpnAV5wMciskRPu414JDe4U+ozgQzwg3BUd1c6UaTdJPFAzi6ePeIzo00taC792psZqtjnUsJkvumcvcqpXCaltELh7fQqIxwVPGPcFhkWHc8rIpSxvrGh+7S3WTeOOFAHfDQjwt3BCsUqsUvkp2Wd+sd8UuH1yA9xnct0dMhMJHodPqbl+/VXypmCJJiYdE6asCADCAaaitpynb4x3Dse69w8P7hvtofD3kHvomfYu2pfz67fKi2wzDPOpECl9l/+ED/Lv4y5VynVZ3v/J+YXaBvkn32AiDewRHxkf7h/h7yGX6Jl11efWNX0u0D9y7zI6GG4JDo8K45bu/Vbh1mqETh7/20WyfAB9+Yf29+q9XbqdIaumOZWzJ9YuFy6d9yC4nvzji1YVpfsH+jkerrajd++nuX45l25UHdNW8/n9zBo5+DsMwfjlDM5dP5ny7etf9u7VOw0scnzTlnWlh0fYjDIZh8s9f3b92763CWy5fa8fCHcG85/PdsgqxVDxsUnJMUoxK7W3UG2sr7uUcv3ir4KbjjjOWzHzxf192LFcHqRd/tfS3Kze4kh4xPdiFtPdnvvSWk11YAsMCF25+XxOqOfTFQa4wbkT8os1LpHKpY30MxwaPS+qfHLf2rU+vnMnlb5LKpe+uf29QymCnJ8IwbMDz8f2Hx+36ZGfW9sxHxdORcUNwGK8Fi8SiL89v9evix68w+Y0XL5+89OXijTqt7XmYOmeiU7scUQnR9ieK7sa3a9QbC7MLmuublWpl7+f6KHwUbHns0P6Ht/zAPtIj46OW7lgmFLV3OVKZdMm2D5a/sqzkcjFbIpaIl+9eET2wdzt7AQAwHHtt+RxcIDjy1Q/t1+yAuCG4K28SPPqVMU7rDEoZHBgWuHjCexaTBQDgq/FNXzqLX6Hixu85xy9qH2oDQgKGT052+gTmtyeGYRakzOMerUKRcMq70ybOnbzvsz1Hd2QyNAMAEEvFCzYt5Oxazdaj2zNzfrz4oKpO5aeKG5Hw8ttTPFVeAACBULhg48L/GfYXdvw/fVEa367VYv3l6M8388tIgvLV+MaPTIjo15Pd1HC/4U5Juev3quPgqmAMx7r2tM9y1FXVWUwWTahGLBFzhaGRYa8umvH1yh0AgAlzJ4nEtjnSoS8O7s3YzVoBAHy3fv/ba+cNm5Rsd1h1kO3BwNCMoUXPrZIEuS9jz76MPfz6o6b+yT+4daBuNpiXvLCo4sbv7Kq+WV99u/rSjzl/P/Kpr8YXAOAbqB7zasqxnUf9uvilzp7AHeROcfnq2R/X36vnSr5bvz9xfFL60lllV0u3ffSVocXg0p3qYLg67wwMDRRLbRbLi8rfHvHmXxNnvzPyzfTY6XbPrpT0cV7eXgCA58YM4gqvnsvb849vObsAAMJKbJi/vsJhvEZYbNNrXICvOrgm6c9DZF7yR8WWlDqEW/5uw37OLseD6rqtH2zmVgeNTQQAjJ4+RiBs/X0bdYaP0//Gt8uSc/ziG0Pmrpu3tpPaBa63YLFUfO7gv9lliiR3/30X19GaDeZvV32j8FGOnDKqtbJEnDBqYN65PE1oIHeEw1sOOR6WIsl/7cx667N5/MIrZ3LHpo/nVrv2Cl20ZQlN0eXF5Tfzy4pzrhdmFxj1RnarSCyKjIvkKqfOnjiOty8Hhtt+ypFxkSKxKCYxlis5e+CM9qHWpRvR2XBVcMVvFRsXrGunwuHNhzjBAICIfj1vt51a3LxW5nTHmw4D72vnrx7dnjlh7iR+IS7AI2IjImIjxs/6M0VSuacv7834Z/XtaoWPgmuIAAC7mZhTBEKhyt87MMz24yu7VvrYvTopTy01WFNezQ6sWJS+KomHhFtlGIawEk535O/F8fXKHX+b/lH+hWsUSTpuFQgFg8clfX5iY8yQWA9P2RNE66n0FElsgwOT3vQEB+kUuNqC5YrWLpCwEFaLkxS0HTRN65psgyMMw9RBasdODgAQEOI8kVmQnV+QnS+VSfskxkQnREcP7N1rQCSG2zIYYqn4nbXzF6UusJ2Uor/feMCVy2l6oG2qb+b6daeDeThwVfC3BXu5eUjW9sxvVu6wq9C1Vyi/yTbcb3hY89BisnCFg8clHduR5Xhk/kDMEbPRnHc2N+9sLgBAqVYlT05+ZWGaVNaazVAHqX0CvHVaHTumwwV47ulf7xS7NJ+5U1we1K313fOQ1KGn9pxwZa9Oh6uP6AdVddzyuJnj1UFquwqT/jqZv1p0sZAiyeJLRVzJ1HnTHBtKeN/wP72awi/BMOyz4+vWn9q0/tSmNUcyuvbsym1qrm/K2p65e/Uufn2xVFLw8zVudeYHr+ECJxclloj5rR8AcOlEDrfcNzFm1NTRjnsJhMIhqUODewQ7buosuCq4IDufWxaJRUt3fMSlsXABPm3+9BEv20ZYjXWNhdkFAIDj3xzjCj1VXmuOZMSPGsjeaKFIOPyF5z/+bjV/ogwAYBhGKpOGRXcLi+4WGR81a9nrdpFIZBL+amNd48l/2hpf7NB+S7Z/yE55WWRe8ukL0/aXfr8t5+ux6eO5yd7lEzn37tRw1d76bN7ry+dwYzRcgMcMiV2TmbFw8/vrTm1KnTPRLr/dWcAmBjuZVDgSGBa46dwWfi6QIsmSyyX6Zn3P/r3sGvTGBeu4OdWKfZ/EDu3H36pv1rc0NPsE+DrmjY06w/ToqWmL0196ewpXeOlETta2IzXl1VK5x6CUwWmL07nH/v27tW8MmQsAmL/hveEvPM+LjbpTcqexrkHhrQjv24M/g79bWrFg7Lvs2C0qIfqT71fzB+EAgIb7DVazVR2ktvvlndh9fOuHW1y5Vx0KVwUDAFJmjHtj9ZuPrfbToXMb5tu+21KqVf/IzOBPiNuBFSxXyNed2sglp9phzdxVl09eAgBIPCQr96/qxZsQO8Vqtq6YsZzLRQMAhk1KnrfuXTvHjjTU1n/w4vt1vH6qsyCIVPR0sert67fqqu7HJMWIeIlJPgzDZG49vH35Vv7LWovRfPFfF6Pioxy7bQBAXVXdwQ0H+g8fwK4SVuKHLw8RFiL39K+9n+vj7f/ISa3VYt2y5Iufsy6wqxRJZWdd8Anw7d67+6N2qa2oXTVrRenVNlPeu6UVhb8URMVHc+8wHLn2U94nM1fU1zqZAnR83GjBLN5+3mNmjB06YViXcNvQw6Q35Z278sOXBx3ThCy4AB8+Ofn5l0ZGJUSzj77KsrsXjpw/tjOLoZnpi9LYd/5mo2nbsq9aI8OxxHFJQ1KH9oqL4rpGq9ladavyytncU3tOOn0V3yMmYuTUUf2GDdB01bCdvaHFcKvg5i9Hfz5/+CeScDKrBgAIhIJBKYOHTUqOjItUqlVsYW1F7Y3ckrMHTvNfaHY63BbM4an09AnwkXhIDC2GuqoHTjMSTpF5yixmC0VSrp9L4iERS8U0RRt1xna+5eCDYZjMS0bTtLtJDLFULBKLXJzud3yeXLCLyMV0qI+TXJVTaAYrrXPyxh7xxLj30d0TEOBFzEhocLEy+vD9qYM+U4UcJBhykGDIeeZ98H9PkJJI6tb6cUGTSXimrHXCmtDVEOZjAQBYKTyrSMUWquVklMaUXe6FYyAlqvl0qYKkMQBAYjd9F2XrqLigRnbrYetQbnSvFu6AjqsAgOQeOj9Pwu7UHE5j8JGRMUGm87e9cAyMjW4+XaogKAwAIBIwk/pqSRqrbRHl3vXkvm3hYjNYBT/eUHIHf7lfo5XCK7XiwhoZW5k9AlfhYMHjX353AsF1OuGxEtW0AY0nf1NqjbaAw3wsVyrl93VtEor1BmG42lKplYT6WEwExtoFAORVym+IPaYNaNiVqyYpW1Y5SmPia7NbBQD09Dd/n+9jJjGGcZKLdhpDo1EY4m0NV1s0CsJCYsR/TifAGV85uSdPndRdNyhMn/O7J1serracKVM0mQR2E8AuKmLnJfXoyBYcY65WyQEAJIUdK1ENCjOYCaygxqUX4Z1AMEVj7D8LiVnINnfZz5PEMWClsOomW3It87r3jIR6ksa25dg+3rNSGE5iNIOZCbd7JY2CsJKYicCd/pEVGwNJY5VaWwxZRar0gQ00DfgxAABoBtNbcDOBCwVtZAZ4ETIRbXchNAP0FoHOLOBegzEAmAmcoDCCcvVCOncf7OdJBioJtbxNjqXZJKAZrFIrpuin8/5HoyAClYSv3Hkmh43B36vN9yotZgFBYTXNYrJtDAFeRFp8g6eEvvSf5svi7+xCvD2oD8fcoxhwrfpJvlph6QQtuB3yq2WOrWpgqOFOvSRYZQ1UEK7/YWM7XK6Qt9NcnMYQF2KoaRL5e5HBKiu/UdbpRHvyfIEDeVUyfu/DojUJiu55CAXgv/mldu4WHK0xxYUY+nUxciUqD2pgqP5MmSKzyHtyjFaAu5TX5JCJ6LgQQ7i6TeqtXxdjXIghSuM85ekYg0JKJXXXny5VZl5XTezbJHQhhj6BprgQQ59A+1Ocv6UI8CJigp78kzE33iY9Gd4yKi7E+Ph6AAAASBq7cNvL6SatSdhoFNK8kU6TSUjSGEljBI3XG1p//l5SuuieTG8VGK14nU5EUDg3xmEAqNcLm0xtGspDg4jfdBqNQpLGTATeYhawJQ0GIc1gJI1ZSNyxkTmPQUIX18p0FgHbbZM0ZqXwRwXAXhpFYySNWSmskXcKNrayBx5yMcUvN1rxBoPI7NrfUj/zXDT6Pzr+WDr3IxrxWJBgyEGCIeeZ98GIPxbUgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHKQYMhBgiEHCYYcJBhykGDIQYIhBwmGHCQYcpBgyEGCIQcJhhwkGHL+H2m27ygEXqIzAAAAAElFTkSuQmCC"

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/looccitane.c27b1969.png";

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/under.f0e163c6.jpg";

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkZGRTAzRTA4RTZGNTExRUFBMjg0OUM3NDQxQTZBNzZEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkZGRTAzRTA5RTZGNTExRUFBMjg0OUM3NDQxQTZBNzZEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RkZFMDNFMDZFNkY1MTFFQUEyODQ5Qzc0NDFBNkE3NkQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RkZFMDNFMDdFNkY1MTFFQUEyODQ5Qzc0NDFBNkE3NkQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4p00BaAAALy0lEQVR42uyce5RXVRXHDwzKW0GcMZ7CyKNAoRHLZxJIU0AGPsAXREUuopZLXemylNIeFrHSJUsjtFytrEglK6xMMkDwEWEJigscBJ00FRTijTIK095r9l2z57DPff3ub+SP72etvX739bu/e+/53n323ufMtGlsbHQAfFC0xSMAECCAAAGAAAEECAAECCBAACBAAAECAAECCBAACBBAgABAgAACBAACBBAgABAggAABgAABBAgABAggQAAgQAABAgABAggQAAgQQIAAQIAAAgQAAgQQIIAAAYAAAQQIAAQIIEAAIEAAAQIAAQIIEAAIEECAAECAAAIEAAIEECAAECCAAAGAAAEECAAECCBAACBAAAECAAECCBAACBBAgABAgAACBAACBEcG7dIctLN7j6znHUw2guwEMv7yMWRHke0m20O2nWwL2Rqy19EMRxQTyYaQDSMbQNZR2u05sjqyp8nWpTlRtx3bixFgSrqSjSe7kuy8lN85SLaU7Hdkq8i2kr0FDbQ6FWTTyb5JNjBwzBi1vJBsTlohxtGmsbGxCA84k+xW8XY+/AN7leA7xpznKrK7oIdW5TSy3xrC20G2nuxd2Xei8d05ItrcHrBUAXYnW0z2CW/7G2TzyJaJV9sp248WkfLNTCC7gux42fem3Oh+aKLVuJrsDrXObfV9suVk9WT71D7ujseSfZusj9q+Stryf60twFNFfPpi3ie7jmwB2YEUD6AL2WSyGWQ/JvsjNNFqzCb7nlr/DtltEqPHwT3YN0SIESzWc/x4vpwC5AB1NVkntY3d9WVkz6Ntm56tPKde4vmZBrL/kG2U0OSDYqY4iYhJ4kyyMJXsV2r9NbJqcUJlFWAnUXyl9wYMK7D7vFEFva+SfSnl9z4r3Qo3/r/kTbVYoGIeDg+mkB0yjrtHHmrEF+VBh+ggCdilZOMCMbGTRGuJNDo/u3+TnUX2XXXMl2Wfzw/JTiZ7R36vkwicE4n3yLbJ99aKM/Adwkh5NhG1ZI/lbKdpZPep9WU6AS2XAFeQnesdUik3XhT/Jeut1junFDeXCM6U5feU59G0l8Ba0ydQDtolJaSIETEefobETx9S2/ZLT7FDfrcv2SlGvMz3+qCEIxE3kM01fofjtKoMz3KNvIh/k3X2wP1kea78TincI5WPCH6ZF6UVYNZC9GRDfNMKFl934wGflfK7PdXyUZ6II84xtg0NnG+Lt95gHFMpb/7Plfg4AasRDzia7EIJ1Ie7ptooe/dHVCLAXOSd95OBa3rF2DZLstkxEsttVftqxNteL8f1U0K8oYD2usp7TuwRu6X9chYBsjf5jbdtE9mvC45PLhTx+F1rEieohxsxPnB+n08Hztk+4Tf7k70gImM2S0XgGukC3w10v8tFkJxVcg10lNEWgzM8s2XSjfN5byE7SRIKDXu7+Wr9RwW11wFJIHUYcnE5BDjFEMbNZQiQpwZiuyTGG/czybjfCzKc/1DM73WSEkSVEh97mycz3OtS+bQK91yqOi7leXp56/ukGvHTwPFbY/bl4QFv/avlEOAMb51jpoUFi48Ffrax/SRnF0KTPNtoLw7s73XTEUOkzpWFheJ1mb3ixfbkvO/PGdvaxXjmtLAQXkwhmCJi9hVet39KkQIcoIL7iEfL4P1ONrysFqGL6SrPC9SsBnhCi/vttM+LBTNRbb/J5R/T/ogkNy6n50/iTmPbS2Vouz946xOKFOBIIx56rQw3cVHMvrhEpK8LD/GNVMvjEl6yJA7K57VqGydgPykx5g0xVkpKSVTE7LOK+5vL0HbPG5WFwgTYp5Vu4vMx+ybF7Ds1Zp/2VHHBcZoJFPzSdfEy1DuVMPMwPGZfVSCT94krUb0h5alyt90ub71LkQI8LhDIFskI8WRxXrhvDi8yQWWVPWOOq5UMLqmhJ3vbHizhntumEH6a0GBfwv5n1DLXR3eUQYDvZ6wgZBJggys/NWr5IbKVxjGjAuWhqGudZwTdneVt7KNKRw8Z5+kgXV4c7bzrbBAPk5fPuObRkvVSRrGOKaULZnZ6623K0H5t82gmrQCtALtHwTegM0EukP7eOKba2HaGax6t4AHyfxjHDFVJzMuuqVZm8fGEa+zsWo5/7xKPkpepXhB/fZkSkX1epaGqDALs5K3vLVKALxjbBhZ48cd6AtxsxBSMNYoRFWx5THF3wCNxOeJyWV4r9/N6yljXf17tPM9Typ81aMH/3TUVk63sf0iJz9f3kIPKIMBqI/YsTIDPkm3wtvUr8OInqYe0UT5fNY4bYwS3p8ln5Pnqje9NV4lDVPxdk1LgfrdywHtxjs55z5Uq8+bY8ikjXkuTqKShu7d+YhkE6IcvjxYpQM7y7stT58mRCf5CPp823HiFUUqJRjai6UR/TUgiVqhY0BmeYVBCV7bNu57BOe95snr+T6iufEPgukrhw4GXtsjuV5fQ1ge8eW4BMvd7671chiGXBD6llhfJJ4+jLgl4wYgzVTzzsIpX/xn4nU3Kgy0JHHN+wrUujonjsjBdLa9VyxuNY8eV8Gw5ZPAnkFxseMVS20/3THfnzVziqFfdRMQtBVw8lxmiYZttrmWNamlCrFErn9u97Pcvgd96zou5rPrZuTHXyrNdeHqVnn7O8/a6ZrznY7z4T4t6SSA06JLz+fJwXjejRPKtAgV4tbf+QDkEyEwx4pgFJV78NLW8wttnTT36mIoXqwPd6abAbz3s1a2s7jouPuphvOEdjAZI89LpF1tn7jxZ1Kqxjs/5fK8MbJ9lZK5522+0Wv+ay1AjzipAzmx+4G2bKV4gL6er5V96+9YGAupo5COauPC4d8xq43sHjMD4z4F4KVQni2bHzJWMO+LGjIG9HtWxCtmPGNtqcjxbHlmaGNjXQXqBUqjyXkb+u+H5WU6Qp4TAA+/+FO6fBWpYacoDNaob9bvOLa7l9PGIkapEwfjjnZuN0tFKI6lZF2iYKBv2hRhNH+fCrq7PdZSXoDLlfU8NhAUuJkOv9l4C67p88fkvNItxnhdDz88pPg47VrnmMfhDCeFLYQKMgmLf67BX4ClKwzKcZ7xrLiI/G3i4fzK2jRJXz7wtD8JnkbdeZxzzkrPHcc+PaVinMtcr1Hp/1zQgf0HCPfNL0zMm7IiuyycqI1n10VdUwlErovLFd6uEINe4lhMHZknloVuGdjtbzjFAVUm4DPNWawnwoPT7/gzpy8TzzHHJ88EqXcu/eVgVOO6xQGA9W5VrLPwExioL7DZeJKdimncS7mGhZOV1KknhEZzl4uV4fLu3hA29pdx0reeVrYL4U+7wERbu7oY6u8B7t/QC9ZLEzFL79ki1Yrbn+XSl4AvSbpe4ln8D48MlJ55J/aS8cNEzqnX2MGIiRfxnhMslEekaKHs8Id3MBhHuIMkAL/GC4MGBN7+Hi/+bkwXeA9cZ65tqnSdUWIPwLIjbA99f43mr4S787yg4BLnOZRvm+kpMyeJxd/jY913iQdOUZTjcuFc839uBY273XogovFgsiRG337ESc9dKAqh5UUIRc3ZNa/xnhIjjJRH5umv+TwdZWOnsiQY6OdHTktqoLvJmozwUcb8IfnVApExf11z81uefKVYjcU57qZ/Vx1xnR4lPx0o89FGv3tYg3SWP8jwj4tgfk6jcpMKStvIy73GHzxo/JC9XvYhhnYgjzawX9tL8V3OXZmivlyUZvTfuoNYUoK5vcVx3hjTAQNWgFfJ5UBpgg3S7dVIOKWVQ/0ilQmKrLtLdH3BH7r8eqZHk63TXPPWtwjWPr2+Sl6ZOYslE4RQmQADKBf5BJYAAAQQIAAQIIEAAIEAAAQIAAQIIEAAIEECAAECAAAIEAAIEECAAECCAAAGAAAEECAAECCBAACBAAAECAAECCBAACBBAgABAgAACBAACBBAgABAggAABBAgABAggQAAgQAABAgABAggQAAgQQIAAQIAAAgQAAgQQIAAQIIAAAYAAAQQIAAQIIEAAIEAAAQIAAQIIEAAIEECAAECAAAIEAAIEECAAECCAAAFw7v8CDACcFz1cPCEfrQAAAABJRU5ErkJggg=="

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/olympikus.e6eb6bfb.png";

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAIAAAAErfB6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM1MiwgMjAyMC8wMS8zMC0xNTo1MDozOCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODJFMUM4NDJEQjI4MTFFQTk5N0ZDNkM0MjIxMzYzQkEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODJFMUM4NDNEQjI4MTFFQTk5N0ZDNkM0MjIxMzYzQkEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozMDRFOUZGRkRCMDUxMUVBOTk3RkM2QzQyMjEzNjNCQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozMDRFQTAwMERCMDUxMUVBOTk3RkM2QzQyMjEzNjNCQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgnATf8AABQ6SURBVHja7JwJWI7Z+8dpoTDZlTCJ7GYsv58tIkt2E5mUpWyJNMmSQigVQrY0kkqLVKJQtixlX7LvyZJIhoohhWj8vzldp2ee9/X2Vq/5/cd1f6/36jrPdp7znM8597nv85ynip8/f65A+n6lRFVAgEkEmESASQSYRIBJBJhEgAkwiQCTCDCJAJMIMIkAkwgwASYRYBIBJhFgEgEmEWASASYRYAJMIsAkAkwiwCQCTCLAJAJMgEkEmESASQSYRIBJBJhEgAkwiQCTCDCJAJMIMIkAkwgwiQATYBIBJhFgEgEmEWASASYRYAJMIsAkAkwiwCQCTCLAJAL8P1DIlpAWjVuwH9LYcyHpgoWZhfEgY++13n/99dc/WRgV4vGt9fbtW+uJ1nm5eUgn30lu2Kihya8m1IO/Hz3LeMboMj2494BM9HelxrqNtbW1+WZX/a5kor8rqaqqhkeHbwvdlvM6p2//vga9DP41gHNzc2F8atWupaysXOZMPn/+/OTxk7y8vAYNG/zwww8KeaqszKzMzMzKlSvr6Ogoq8gqW35+ftqjNJT/R50fVVSKagN+0JO0J3nv8rS0tGrWqlni7XD+47TH+R/yGzRqULVqVckT6tev7+DkILUCM55mKCkpaWppVqtWTXT0zes3z549q1SpknYDbTyL1Mth/z99+oRxXfLyMgIGj8SjiXG7406dOPXmzRvsqVixYus2rfsa9TUbY1anbp1S5bYjcsdG740ZGRlIo5YHDh5oYGgwb848dvS3mb/ZzbSDL8o28ZyJpxNZ+sihI7bWtixtOcnSebEzS++J2eO/yf9eyj22iRZjYmoyY/YM9vx/u2qipaam5qbfN+Xk5GATIB0XOBqPMA7wCwgOCH758iU7rY9Rn2Urln0Nc0FBQXBgcFBAUOaLTNZZcTuUU3QaXOik80ksnXAqAU05KyvL08Pz4L6DHz9+ZHXYqUsnFMlogBE2H6U+cl/sfub0GeZyI1v0+ynTpnT8b0eWSUpyytrVa08kngDdwoFWSQknzJo7q1XrVuUCDBKOMx3h9IuQ37p5C7+AzQGoo9FjR8uZ23L35agdYWXti9uXcDShzJbA2dE5eke0cCfgIVBBW9wWtU0EKWZHDPxbvvnq5av5DvOjo6IvJl0UnpZwOMHutV1YVJjUm85zmBe7K5Zvgtb28O1qamqyi4rTLM0tH9x/ICx80rkk/ELCQ/Sa6Y0eOZq3MHZ+wpGE48eOHz15FMYA6Zm2Mz98+CA0IccTj585dcbHz8ewj2EZnSy0GtNfTEV0hYK5dnV2BTZ5cjt18pSQLte7vHdlAxy5LVJIV11dHe26yHG9/8DZyVkyepHMRESXCY987eo1yf2wFkK6XO/fv5ddVDQaTle9irpGdQ2W7tW7F1ywqIgoTheHqlStUmRyJliCLvrYHPs5nC6GFW690Q5m283G8FQWwKBrOcYShqXEM4EtNCi0xNO2bN7C01r1tZatWhYQEjBy1Miy0UXv91nvw9KokcCtgVfvXD125hjGDrbz6OGj9+7eE1019JehmwI3DTMeJtxZvUZ1D1jP1Z5I8J2XLlySvGng5kCe1m2i67Xey2+L34DBA0osrbDvrlyz8vyV877+vsjBfbk79ty/d58fjdoVhaNuy9xatmppP8ee1RsPuqymWeExL9+6bDXVio/KospXkZ8ujJic1b16xWqjgUZobjJcmwvniywB+llgaCDsEtLMw4SdLC3g61ev85bbtVvXSqqVYO6QNuxrePvWbbYfJg4RC7+kWYtmQILBT7+HPrwK3qGdFjixdpaRnuG91pvtZEOsyI+7m3yX98LQiNB6mvUK79jH0HqiNQymjNLWqlOLp2fYzOjdt7epuemeA3tYX6xdt3ZxE+w/dKjxUFMz05i4GOYtHks4xtuxQU+DK5euIN2tezdwRa0iffL4ydmOs0vRg0tLl9mosOAw2V4uKw3Uqk0rRpdpuMnwMvTg9PT0YgN4JMHC3IL94MEJJxyEl3To2AF0kUC16jbVLd7/nw4s0bJ1S77zU8En0R2fPn3K0506d2J0mYxNjGWXtv/A/tw8YPRFgW2sbMCSNYuRpiO55w8fanf07rGjxo4yGXXz+k0YKkQcfEAcP2Y8e8zJlpN5fQqromTAZaDLdOjgIdleRrENUf6bFZERcQlncV//+frvLlbJRUK8IdxUUy92hdTV1HmaBwKyYzZhYVRUVWTcSEoPrlUL4xFiG+FOBFrTJk87f/Y8rPEG3w01atYQHgXdcWbj0h+nl/YxVb4FXVbc7Ozs2rVrSz2K9o7eg8aLNNxvRHvcnh/cf1B0MpCj5SKRnZWNMYYFmlcuXxGeI4xMhgwb4rrUVei14SpgQ0+F+VLUBAL8hmIv7NwFxKzcV4o/EF/i5YhnDiYc3B+3f1f0rnNnzrGqQKPZGbWzS7cuPQ17wmFG38VRoC16kHfv9sbuxZMidMYm6iE+Mb6yWnF8nJaapqOrw13LEnpweeh+bdwSurjtO7TnVsjK0gqj4I1rN1Z5rgoLEdv22nVq837v4eKBgNJvo59onEZuPAo6sO8AQiDg1NDQePyosFvM+m0WHlvqXEGZhRap01iHB2OTLCedPnkazraHq0fc7rgSL3dxdnGa7YSxM3hbcMzeGL4fjRitGbYXg8vwkcOjY6NXe6/mR/98/Sc8be5PLXZenPMmB4+JmvFe420+0hxugWjGQ+Ub0ZVtbKEJkyfwXgi/ERi+dma79u0Oxx8uCl53xuAn5V4qytPtpi9dspT1A4RqK5auAFG0eu7LbA7arNhZwIlTJiIsZGm0zkkWk+S8EI/DGijaol5zvZzXOcKJ6wC/ADjt+MFvaqrX9Pnz58W+uq4u3Eb0bPZcCLfwg7fF/WqbyTaRMZHwaeCLwbscNGSQ0jeiW2iH69WTcXTgkIFooZL7RRYGGj95vBQbUEVdPFs0wUKYITBzupCmpmZ55lOlymy0WV+jvlJmB1VKiE24lUIhUdsYoYrcAjW10WNHbw/fzi1W8p1kDkJTSxMetba29qp1q1RVVYXTDzwNMwbe6MdTJ01dv3o9LIG4NtMepU0YO6H8dJu3bC6MI6Vq2cpljgschaehszrME8/Zwkdd7rWcj3BQv/79XNxdRKdhUPf08ly6Yim3nEXOMHyWTRuQA/OZFSi0RXhDCE+FZcNg4erhKvtC2BJEMkLHG0LIHhwejOANEdFEq4nCPCHEcojEYI2RNhpgFLU7CuO0sDPAKZtmOy32QCxaAI8MMXYUeTqcLnzu5388L//Dz5g1w9beVq45ik8Fd+/efZvztr52/UY/NhJOF7O5aN6cU+6mwGPCOWjLGLnz8vK43yiaHUx/ko6nKJymb6gtdPS+dhU6AQ+E4DyzpoCC5eblfu0WokdISUlBbaJy4RsLL8RVuFaYP8ZIDgYVDk/lc4XPjRo1EnptrHM/fPDwZfZLGJ4mTZtInQyHZ5eamorb4Rkb6TTi2fr6+K7zWsfiMZVvQRetb6zlWHmHahVlPt8kQzBKbdq2EZpB1pylCrUsCkJkX8WnA0UFk3EL0ZnCWX7JC6XmD8HYiOyN0DwUTg80K6GeYfMk9/+R8QdL9O7XW0XhdCH3Ze6iMI70TwpxOQYmJGDGVRROd+78uXCgqJb/h1q0ZFExbMXSneM0h098l01q6mp81kJOC0mSoYqG+oZsZqT8gmc4dfpUec6E03HzRtEETc2aNeE6/lvq682bN5W/SLHZZmRknD119sWLF4UBSIvm+t31JePAMpprRKuKAvzs6TP45PJEI2lphWaDpRFKbvTf+P8fLTxwx1mO++L2wf0ZN36cs4uzQrJ9nPZ4ufvyhCN/W+YAD2ah60LRe8wyxnIBoQGIWRVS1ohtEUsWLvlebV38gXjQZQFMaFDo9WvXy59n6sNUk6EmIrqFU5Kv/nSwdzh6+KgCACPsCwkPUZSRBGOvFV7fJeDct7nCTQTu5c/zR50fZTik61avUwDgCl/eXoVGhCqKsb+vf0RYxPcHuE+/PppamiwNm8fXv5VHysrK7svdrW2sq1WrtmTZkr2H9iLNj6Ykp4jfipbByeIzWS9fvrQcbSm5rqUMUldXj0+M59UhqTu37wwfPPzfNQYzDwuuEKLM7gbdS1xZVyrxV6vv379v17J47uLY2WMyFsbI5WTxFOvHCmH87t270ODQufPmyn9J8p3kK5euYHhrqte0U5dOki8GCgoKcMK9e/fyP+Qjjuqq31X4Qv7m9Zt8DrJz184oQOLRRI3qGj0MehRN7jz748L5C2jE7E2l0O3Iysx6+OAht5la9bVu37p97eq1j/kfUZhu3bvxKcDk28lsyhCl5a87K3xZlYEmizLgvggK2ndsj3xE5f/w4UPSuaQnj5/AWdNprNOlWxdhE+HzqTeu3yhmo6JSt25dhfVgxfZjPMOhY4fk6cHoDTVq1GD+C1OTpk1Wrln5U7uf+B64IR6uHk/Ti1fJIIqwnmY91XYqawrGg4xR6exQ+I5we1v7zBeZI0aO8Fzt+erlK7fFbvv37hcWoHOXzu6e7myJVszOmPkO89l+u5l2qGK+7glq0bJFQEgAezEgdYV20vkkdxd3mFNh/h3+08F5sTN/hMjwyLWr1sJ1EvrJjvMdRYsMYZBNR5impaaxTXjRXuvL69CI3yYpajxOe5QmXNkrQ6dPnhbShdCfxpmN40vaondE21jZCOlW+LJOY/2a9QudFkpmaD3Rmq81QJ2OGjFKRJdRMR9pjkKK9vv6+ArpQijGovmLZLjWE8ZMENGFYGyQ/4ljJyp8WYLossBFSJcVbIHjgk2/bxLODViNt+J0YUjmL56vGCdLKmN0o3JmLWNFR4nCUOTi7MJmAFA7fH/bn9sa9DLgy47Q+RIOi2MM4YJn9C0Emvy5DPsYcuOJni3ZPtiHAiIBudT3p3hAdH22nEhSsK5aWlpoSZt9ixYaVKxYEZYDxplPFXiv8ebGcs7MOTz0gsEI3hb8tQVP5QXM6iIoLEhyICld1hXlXXRt8qvJ6Yunr96+KvyAB50AvSd8azhfobdoyaLo2GgYTBhhPkiHBIVIZqihoaHfQx9eHrcNrVq3OnLyiN8WvwNHD+AQ78fcThSVWUkJVv3KrSuR0ZHCuaT79+9L3iU8LDw3N5cjCQwNxIX7Du8bPHRw6zatd+zZgZE+JLC4eP7B/lu3b0Xn4YYXjWNb6DZWEt5SGzRsELEzQreJrmJmsr52ACZia+RWC3ML3gNKq7r15HIQmjVv5rHCgwGbYjMFQ+ne2L3s0OWLl8+ePsubP3rMhnUbippg7VrMQjDXTJhhT8Oe3hu9gSduTxz3MDDmbfEvWmovXLV0MemiEKTRQCOM3GwQ7WfUDznw0VGy5GzpNZPbMrcePQsdOr1mems2rIFLxXwoXn64hFevXMWPbaqqqrKGe+lS4ZL65FvJPCuvdV5S33UqGHA5GQObnG8M4fQKfWZYMA44MzMT3i/3VIUjltA7FX2E4uTsxJgJ36Cgonldi5zKBlUa8E3hm+matUv4rlC40JpbBdYWGV0Mq7yL5+Tk+KzzkRIgZWbjb9VqVfkrFqF3+W0Bl4dx/0H95TyTfdwndQRFM69atSr7ZAG1BodWag6iLzZ1dYuMW5UqVYQPAl9d8lr0FWEcgSBK/mcUrkBGQ5EMWCtVLj4ByIXfVXDV1y68Cu50mT/bKRfgsjHGEGgx3kLOkw/HH05/ks6MEuLIndt3CmfyEIkyXxcY3Ja78QUM2ISHBXMquUiPfxYg/GACJnedT/HMH8LcypUrs7fiUpdpyqPmLZqnPkxl6YBNAfwtbMbTjOfPn3fo2AGBLIZSdg7GEXgPfNiCfT64/yB/nYDHOXTwECKFXr174ZH/UcBlYOy61FWe76Z5wGNqbGo2xgwdcc/uPfzDLADQ766PeuFz8TaTbWztbX9u93NWVlZoUOiZU2cwYPMvgyXV8b8dUXJm5A/sPYDqNjUzhfU+kXgiwC9Ao7rG9l3byzNPBGeKr3EPCwlDybt174bbxe6KBb9Va1cNGDxgyC9DmGXOz89H7Dfdbrpecz00WX9f/9u3br/NeTt6XOHXtkuXLN0avLVw/tlrXWRMpDxrmBQJmDO2HG0pGTuKNHfe3CHDhpSqELBvCEBFOy0mWKCVIKutQVvZ15vZ2dlui92E54RuCW3btu3XvgUCUYd5Dg72RZ553O444ZJ0WIvpVtOFi85LKwxD6KZ8dbdomLe3tffw9Bg/aXxMVAz7wv1R6iPH2Y7CHPA4GHfQEPfE7OEuRfz+eAUCLsX3wWC8Y/cOGfAQKvy++XeraaVb0SF1yhoB60yHmSxu8fHzES63E6qrflfR984iwQaiwUmacTaO2NjZlGctLbLdGLDxazDQUzt16YS7bA7aLPnNP9NQ46HMpRJWgmh55T/Ug5mq16iOGGDy1MlocbCQ6enpH95/QMTy088/9TXqO2z4MDmn4HEaG/8g83HmsMbBAcGINZWVlBE7jjIf9avZr9y1RruBLd0ZtROm786tO2jjCNNxuam5KWwgIyT8PFAkNDh9A/3gwGAUGP6amroaxns0i4lWE9lMQo3qNXhhkHNxy9PU5PvZvDff5EuacX7U7qiIsIjY3bEwuQWfCmB1gBzdYLjJcOYNNGvRbN+hfcFbgtE1MR5/KvhUp04dOBNjLcfy/7jj7unuNNsJ9dl/YH8TU0X+Fy3xXDTpOxP9nywCTCLAJAJMIsAkAkwiwCQCTIBJBJhEgEkEmESASQSYRIAJMIkAkwgwiQCTCDCJAJMIMIkAE2ASASYRYBIBJhFgEgEmEWACTCLAJAJMIsAkAkwiwCQCTIBJBJhEgEkEmESASQSYRIBJBJgAkwgwiQCTCDCJAJMIMIkAE2ASASYRYBIBJhFgEgEmlaz/E2AApPdJ1DIuBLEAAAAASUVORK5CYII="

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAYAAACLz2ctAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEi1JREFUeNrsXb1u48oVnjXU5DaX+wDJ0rhIlcLcMsXC1BOs/ASWgCRlLF8g1RaWA2wV4ErbJgEkPYHkJxAFFylNF6mCC3OTBzBvc9NlM2OfsY/GM8MZ/klenw8g/MPh/Jz55vyRHDJGIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCASCBa/KXPSbX38X8h9hQbH8n//6MS3bMd5GXFSG15+8xEnjson4j6CgWMblk+36WDolrzvhx7CgzIwfgwrkWxUJmB/7L1RxTPkRFZTpgox2Gnslr4scylxX6JdL/Ql7uXCRT/ocBlKWgHHDBDlsmODP2fy6yF6Y3/yrJCD4H4Wo4v99TSuctF/9GrBR88gJHjgEOC82AHG0DuuvmYCHDa/Aps07acAXoAGvScCN+H9fnXXoNESQnQxAIH/Z48cBTCTWthkcKZiwpClHHojUg7GGIFOZ18uhD+Lnmvdh4mkdMt8cKvQnapF3DznKjqfgXASQV0yA1q4Beb/7/MdxwQSGiJRDuG7Gf5zXldAF+Z0A+UwIUD/Fz4mnbMQYinKogtyv0d+iP9MWCSjyw7MyGjCumxyaCDtwIHjqMeFTF7NlgCBun9cz4W2eVhiXaH9cQDwXS3JYEwFU+R20bHnTsibYpaNVIrBatB+YlDNWfLfGFUMgc9fXLMN1C4eF5eJq1GUm1yUUS23ACmSvAYJU8f8qExzIt6qRfHjsK0/y9eGaoGSbiaJFg5rGkjZEbG+tvuchTKcIrGKEWkkDIvI1JdCItzF2lFcdflXakJZKPP36RsyvrwZ0isAqRo6x7wpqkXzYHIcOPl9l8imyrMtPU+coapmA67JpmEbzczXc4zzzEKaIapfgY2Wg2Q8gSHDR8iKStQUl0xrMZVNmcmcCEF8CNn0LqDTBgbwuPl8OaZWJ4fwpr2sEZLahZyIg9KWMWUtqCBRc/O+LGv123/xhqqa0dkYDVgxApo59GxSlcPj5EScRKyBhKFJGhrrOPMY848enoj45PgAi0lPdEhFp2Wc2A8+gTIzxSf86jo255Oeq3gKKyxAcIs0is5m7kA9h4kCkUO0P+H4u48ghpZPWKJsqsi9LPlftJ/p2pHOfXIOQpv2/Kvc4XTSOD/kYCCopIRPXRPOR5+NqLtbhuiXyiXFfeZBvJjSzyXfv1CgABv5TGbwpqf1iB+KKe7rLlpTDsYs2KGEpduIJcSCfT15zVmTiOzUKIGo4pE9LTrjw11Yl2os8J8fVIf/UZoC2y+TzIWDMto91SZMXsvL3gusmSe6rjR3TU2mTj+CXIJ/zvfO9mgTQBlJNvwK2O2gqUCgVnNVIvr4n+QY+D250alrZjUPjtG97YWTK303lSbcWgAD5fO7oCPLNfNrYq0kATUOnOQ53jIBNBQpb8f/aIJ8rAXfV/9uqZlaeKA6ZW57U90FaJ/+17kfwPcmXlyVfoQn2eAKmVf8PEOxQf5ry/1pPv8DTPkMP8nWrvILbqUEAwhTNK4z5zHfCYWG49CtriIAXJdyUdUMETGskn9B6/bbI50JA1xTAqEJ4X0RA3TsmLhMzL9uvHSJKaztEbIN8Lj5g0wJoynS1jaZSJWFD9VYhX1YX+eoywVUIUjbFkO0K8zyeVMmaIGDFLfCEK7PwCDRTVuK9mFIa0COyq0LAUgR3nMy20kfPUoujJ1q2Rr4iE9zGEzBV2igiYc91IyVN32LXdz9YQ4niosf+PQMyE/mibZKviIBN7wHjRD7LoF3anvpMkHiRCB5cuHurDvJhW0mVeJjsccPkS5oiX5EP6NLBKo/gV3XcRds9B3LccKGLJ1Bm6qSChoxgsfU0LseYl1mahF+DFq8DfdCWc4NVUBfxFfPL7Yp5uoWnxH0h3uHZL0vAuGHBVjVdM8fVL19SPwMhpjABgce1pw1pcRftEzuSxFSuKzWw652VGlHIj70KkV0bm1AmlrZzIGGZdn38JttrmE0v0ouqDFCCxK2+gumjARuN7DzucRZN3qnBdNaNKdO8UMOaf1Jl6evjFcxR2wR8mL8/ff99gFym5V9++CG3BSEHDa/sWhx30IKDFgQZtBmAKIHIeY0msNUniKT25eSTD7QKXok5WxRFwU0HILU57vCEcVMklO8Rv21QixddPyrpaui0b9wi/1IlUk9g3sVL/WvQiJUIWEWwtd7ig0eBukCY2ojHj33L/eTWnlSBdysmVUxw2ZxoVfPPiRaCsgpBZsKvPTCa4JY2oazdxwR1vw/EyUqSTmhT8crka0G8gui11fQLPOb+FvrISsxR2wS8UyCcaBmYXkG8I368x8qlYxBa12GyqqDrIPCsxCSJfgmNNUJbZBwgHy5mj9vfyrF+ZvevSvqSZemwSLI6ZxT6eIRegD80uAFrTd8SF7k3ZIJFHvYY+vuJk3LJCAQCgUAgEAgvFhvfC/7f9Z0Df0ZiIVTE/t6BWwCmpmEOSXaEishdyacjYEzyI1RE4lN4D5nfiGRHqAHXpQjIGBGQsEUNSP4foSakZQlIGpBQFRkPQHIiIOFZmF8B/DBCl+RHqKoBSQQEAoFAIBAIhOeMkNX/0ennADHmEduNnWmLEENfd4IsX9ARVhzUCuqZvkDySRne7Djx5ByNdqVDmIBVsEL1jF4YAUc1yrFJ3KA+9nZNcKuKdd2iuuIX6HbIye3vcD/xIql0A6NTU4fwxwYz9Ltu9yhJKvkaZKZMQKBcH7OnG46HbHNLjpTpX1eMDX8ncKj9y5SJnzF9clVt39YHib7imujqFvUNUH0qekp/TXXYZD5j+rcaI402W7LiLwKku7AirtCKGCoC+2I5bhVhxYZyfYOf9EXRvIFDXXjlFpXRaeGxpazuk1axYrLwMXbU/pEiY5NsbPLBMld99IWl/FSzkOS5q11UybHFp9EdC4fysWN9I8eJuHGcLJ2Qex59cCH40BDIBUij3XoskqlDm9MC39NG8rFh7kphrwbyRRaVrG5yJNT/uWICYospT9AhJuhMqavLNvdNOTbUpZrIc0P/lpr+RZoysu3X7H63AjzmQ0QcdaIn7Ok+L28QARkylTma8EAZt1rHseIeqG2qYwo18zKBMb2Cn5mhPJbH9S5ov56i3k3R0tSgnW4Nplw1LVNDoBMYIseVYaWGhjJTi5ZT/b8R1LlAv6t961u0VF+jLXWBXGjQljZ5mLTx2BIoRmgcU/j9ylDPzgWJtgjYFC2NHIQXW8hsO3SC6nm6Dj1DPq7v0P5I41ctDIGMaYGNNe3dOsjdZMZtMncx2X3DYg+rkqcOE4yfpF47RkvfaqJm1dQlBROmQ2aIplMHAqQGM5Oh8Uw9+hAUmKrM4spca/roEm2azLjqbqwRwfseY4oKxrCVNExo6JBNeHggnwvq0UH4Kz8VEBBPRFbDZB0r45HbwYWKliw7KZFnHe818o0dZS7PnSi+7REi5lSjDGKLgthpAtpWe6L5X8ie7mTFFNJOUNlIycHFDprDd7JCpc+5QZMmiNQ4SJjA/yKYXFHu1FH7yzIR9GekXHNhWTi2+cB1zBW/WiebN7uW/4stzrrpllpo8CNGBT7dQpNKuTLktqaWXJuuvpGD77pQ/LExtHNrSNn0DSkdnW9l8jkjQwrpi8GfMwVxpnm6UcY00viEC8Oc7sSDIkNLvswULcUGxzq25OvkZNw65hOvHATlO1kuAcjC0oYuIdxzCORWBTnKwCGoMiWPXfK0I8cgcSuwJSVN0ZJN2H1lVerSBTeGxGrgKSjfyZJ9v1VIdGvRpIEhylxY0kGudahjjizWaGSZp3GBhu05RNil8Yo9T4RoApMttB8jP8jlNUR8f9b1mibqcKk7YQQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEDTQvpb53ZtwxB734pv8+Dk7Vc6Ld2Hle6H7/HxWR2d4veL92Bj+7PJ6kzaF8e9f/la2nf3qP//IHK9RX5dk8m9eR0IUs8O0OxbeY+RaIUmIyJfVRT5AjH7fxt4jKzj6HtdE6Drx+1D+jQhNMKBjEaqJCMZznJxi4sR2bYKk4sVpsUHOjJM0V8oFMMnvUT1zpZ0hL3dHcjhf9DmApG2NSWiAgKDhQvgz55OqEvBQ1Y5AqBV7usuTIM0xP9+VJOS/S42hbu2g7qH34AKwp9vz6pA+J8Fz7fggZ2mqTS7A737/BynX7O9/+6vfjggfLkUbpn0Nc2UeztnHd0lBXXi/ngkoElzHAMYlebLmdY58NGBUMKkbW6tpyJfDdRF73PJB7D8yAHLryLdmT/drxudOHESdehIghn49TK6hnOx/jMrNOUFGHm0FsIDkZMk9CyPFF5d74Syhf3dl/3y/F6How2mJhdZj5v1xMra5R82RQ10Yfc1cLoGk8v9zXxMcKZNf5KcNFSf8TtsBMWVHerAyTlDHcvifJCzeiAgLOgVB4YEeK37axMcX5ZPb12iF0EDSlabcGT/3hpNw4Eg+1TrovuVhmmih9eSGmGVwbDkXKGQcci2X3ZHo4zudphX7AyYGLiQwV7FS79KXgNjEnnEimUxfCkRTB7gA3003UCzYAb9+iUz/w4Tw/09M2o2XmyrkE/XMPLUR3jNwBotAt5qnGgHLcn1e19yhyaGiZecg46IARZYt79d+uAwUi4TlmSt9wG5OwK99r5xXtWWuUVwhe7od3i2vi7HHHWXxjmOTToGGs5o8IE1o0J4bvgZoxBCRDJPPKfqtSj7UR0m0c2lKOZkusLYD7Sf7O5PaDkh3hbRLEQkP0YS95fXkUM+qwDQ+lC2Ney3W5QQYK3PTBTma2n9fwIPc0Oeiz3ZNlfLnHWWCI6WR1DJ51xoVnln8M922vFq/skHy6cwGk4EAJ4Xpmjkql/Jy0nkPPdpLFUKtLZM8r0w+TZbgYS4EMT9cvrFo10xzDu+1nWnGnjH7lnExnE9QwJN3bETgE3ykkOCKbe4jhwk45+VHFu01sviWB5ZoWCWfGMRpSfLJfp8hDZYgv9C0yk9QOezjZI7tiWsiEdAAgQO2ucl4c/hwGSlmcQ7R7FDTR6YxzQM4f2Mwxxkn0j60tUBulijzCbk78Ub0DNH2nisRwIRiP03VjscQ5d5pUkE4fiwMvmVqcYYPRT1SGwPp+xupAj44Ybbh8PpaI6Q8JLmEH3cF5nCqEC5ABOuhciudZrRgjsa4gjrwQhakXhj8VVH+Cz+qfDf5WBOl9jx8O7W87rz0N3vK/1ODdpVfqnpCwNjHTELiN0NO7A0nhNzaVmiZHv+755DeWSuh/Q0EM7HGrxizxzsP4jj548lpKA6PSTlSxhVrFkQM5XJDuZnLrTZeZoYiQVlvWJDekHnCGMmkLDZJce8XHlsIGHiWvzD0cW4wyQMcYe+ZSKa5q2AKFI4stj8DbRXi9IsmZTLTkDJxcGrZL7755jMQ9sxTC74FYuRoxQ5QVJwLcwnlZqicuPYIpWByRTuof4v2jmDVp0guM2gPb7eboz5mSiqqrPndJMu9+Y0s8xUUlA82xveYuN4k6cd3uj5P1ER3B5nYEKnG3OLEbuR2hCnm1+4raYwcfMhUU/cTvwnukryFW3mh0t65Tcb//fnnmUu+SUPC1JB4lcTARBjg/2nqeaUszommnPCBR4b2ZJnXyjVvhc9Z4aGGYEN+H9/NgJTnCunWaN7UHJ6ufKiZywukDVNT1Kt28EFwX643Nv5+Nnh1sP1NtSHAEp8f+wl+zkEjn8MCHcM5GQCdg595AZpjja7PKgRYujyg/NrmAH6XbUd3QcLHd0uUpjmH4ChCJJoredNPwJN7CyVIrW97pFilru42X0fxrXrPjH8J2/Ku7jKHKR5Zg4ApZ4+fEYvZ07sDa5jkC7ngRfYAArbIMbBxRR+CSanJeuzxa00pkH+J/pbB1xo01hj6uFYyCKE2FfPhcojm42wjcDTcY95zSCLvMnbhAQQxoe/BfbClZqRb862h3IP/iAK3OuRzDGQ4Ae0lF8NPmj7gzEcI5QNNHJDAIjrkpMPBxxm0N97og+PDCPNnSMDltjsAJnaAcmb6yG/z23IZSuzij2jLW2f1uEJC63y4PHrwB0Vg8OFydlf//TmpdE7hnPzmXoAWxIRtfr0df6MvUMbbhQAkZwQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBEIb+L8AAwABloExAK21lwAAAABJRU5ErkJggg=="

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/invisalign.9021467c.png";

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/turbi.590424dc.png";

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2063 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAACgCAIAAAAErfB6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAE6JJREFUeNrsmwlcVFX7x8/sM8wMDAwMu4gLgrinUIqpuGSva29uZS6F299de03TzMpcyl0qxcQyKxUX3CVz38UF0AQFQZFFZB2Yfb3/59xBGrcyQ//9X5/fZz7k58695557vuc8z+88d+IwDENQ/73i4hAgYBQCRiFgFAJGIWAUAkYhYASMQsAoBIxCwCgEjELAKASMgFEIGIWAUQgYhYBRCBiFgFEIGAGjEDAKAaMQMAoBoxAwCgEjYBQCRiFgFAJGIWAUAkYhYASMQsAoBIxCwCgEjELAKASMQsAIGIWAUQgYhYBRCBiFgFEIGAGjEDAKAaMQMAoBoxAwCgEjYBQCRiFgFAJGIWAUAkYhYJST+E93WUGZ5tz1gp1nr6Vdzc/JLiRVRsLlEFdJwwa+YY38+7UNbRPi76+Uv+CDe/TKrXcmx1cVV74zsUdsTFce9/9gOXEYhvlLF5RpDOPjkjbFHSBGC7HZCWGISEAkQgLt6M3EYmPjAodIhV36vvzt+33rqtxeTLowUJ4tpxCNnshdSJF6+c9TJ/WO+KeH6K2nM4I7fbRp7hZitQFC4iYhbi5ELCCOWeLiOCIhMhEx2w7GH+w++qsXdvnuTs6kC8BDToR8WAAJB1Kerp28sqqMzIKCIvXl6wVVepNGb3Ic1+hMepOlNgF/vv10/zcWaPJLSYAHhcrhUK6wZGHhVmhJqYZUGojJSix2erZEQDzlIvuLG587Ng2i/6nUU8wGyyuRIU/XTmZ+2egVu6NHfb33yq21R674RX5QCm0S4tdpVlzSpVoDvPlUxuwhK4iLmEBmtTME0gnlqiN8rmt971b/bhs9oktwp3Chp4zwOJR0pRHwi2XiFxZwXZViRewIIuATnanV4PZzB0Q9XTudmwdPebtDqNL1w37tQpRyrd74y6XszIIyrcGsZknXgsm6mlsyaNAS4ulKcy3QhbVbpCZe8tivR/Vo3UClkElhQbMq0RhK1Lpjl299HLun9EL27euFL7LJmtgzomdkqNlkCQ1Q/p12eHqzTEhJXcwvbdUnIuFC1vZL2Q1D/fVqbe0AfnPOzzQIB3kRu53SrdA16tB4V+yoEP8H++0ll8CncaDn8K4tViaeOZmSY7bahHzeC8u4npfr329Erdbm5ZXQvL7xxNjxPZZsOGqo0IwZ0TVh88lacNHX80tD231IBDz6AbpqnTTQs+LUQsGTYbPbGS6Y6nsymCw5RRW/5ZVmZN2hk8bL9ZXwOg18Per7uj9wYWG5tqpcQ3MB9JDLCQ5QigR0Op5Mzzt4/KoqSDUoKsxDLrHa7Ddyi8HLEw519O5KubdCarMzKTcK95+7bivXNWvdoG3jQB932eN6WFiuuZZXevxKLimuFNZVdQoLCKvjpZD+UXIBswNXUcNBn4zz4NcMUz/IC8bnWnYRm8444FR8ApSKhxIWtJNxu+Rwep7pdgkEyKjwOo2DVH4eD3Y1OavwbEbexN6RKxPP9okKy72rtjNMQz+P749fnfXGK38XcP8lO7Z+voUAADgTultlOHn4s3ZhgX91GhrN1s+2nFq9OqmioIz6DqGACHnEaCVmK6Ttjv3a7ps/RCL8PaIMXLIjYfEuopDQ/ZiLSJ28yE0q7r90x9YvEwmMvtnGFwuO75r5UgM/UdMJ1OvB/Ksynj78WYt6Po36Lcw7n01dPTRYZYB5uSJuzMQebR7u1dT4X5ctSiRaM+0MGEN2p+eiclu1ZPjQTs0ePj+7qGLcyj1H9l80Gx/vYE3W3NML6/i4c1pPJeU6IuKTkqq1P02Nea2l81mr9l+c/ulGTX4F7TnkPrDEMGMkwmmz+n05vPPz2yYdPpBKJKLqjZBa17RPxFPQBUPfaMiyBePXVOQUAxugDU0RtZ7ObthT8XhHY/dHTljjPNlgFTrHAaB7ICVn68yfqdGDnbdMZM0r+/VKrpDGlXtPIRHM253cZMjSvKRUOl4GlgFs2xhm0pDlPxxOc+6SwWyNHBu3bPI6OqxisEJGUlhBtEYYbn2Reti/v5j2w5EHniLhdEaDlz/4ZVWSGXoO8xKmjoZ6SRrYalYygNcZbTb7Q5HsviODlu8aO2gJpQu7TegAeBpwTDwuXL5oUnz0rB+fH+DywnI6tau7yfTt1OQpbgOAb6fddOysvJvWiRgQFT2ya1h0E7qfttrpHA/2vJJwau/5zJpLxE6r2b++z8Wswl4xsQTCF4yUwUz/esgGtw9nQyI7dtC4RLh35b6c/anSiAavju7WuGM4BQATRSElQuGwUd9oYWLdU9+FW5PX/koClXRYLdaooZ1Wb5gyfO7bKjAWsJrdZYvHxq112rzmlVQOHLgELDEBxwRbQYYJbh/q36oe0ZooVJipcCMeVxXiJ/NXCoV84M53Kl05Z7RFO89t/uAHonIjcjHRW5p3b/7lmrHTV8SEtq5H21G5HVm2e8CK3c+rVGmx0hXjWFw8jkr6NDsfPgyi1iSs4/nN0veGvhpe87T/WXdwycwNMJo013I4W89l9ox4aL8Ii9xD/l7sHnNWEVHKxD4KI4wyxHlvBWRuPQxuzcKHf2gN4X3bnF491tVFBAeGfr13w+dbaTUGQr3GeOnGnVebBLGJ/PaBlXupbYRL1LrYdRPGs2Wm0YRoh0cH9p6nTs8nbtKRY1YNvBorl4jgBtGT46Fx4u9BNAaer9uBdROjmwZBLpy7/cwn076nYQksgNmWsPjdl0P9wVeWwsmOut79ulOu+WDKOuKroNPobmWP9/vs+bCf46uFgzu2mvRtys8niJ/Hls82X+4d0SzY+9lXshwFjep/c022pyleFJRruo/onH9sfkx0M+e5vPi9Lhxvd7oi4RZCHvPIxoWCrLSblxOTiY8iKXFGydF5xScX/GfR8JgpvWghAUJrjc2p0Nft0vxC/AQHXdCSdzrRmgwMNDyFSHAs9SadBoS8NXuj445g9MIHthvvVESUiYVn102kTcqEEIQTTqTDwfzSqhvJWTR+WGjI2bdmXDRbx+ByOHPebDtgQk9akoTnqtTFHUwDM8jhcCw2e3Xovl+jvtlPyjRwG5jxsiaBNXSr/dTSGK6fO41PDFmw4+xzWcEQKjUGuohBVtuV/NKn2S2oFPs/efuBg2k5RWfS8+j04VXPMx6f+8hJaGdz9prt019rWd/BYFFM1wdTNQBjmOmju4kFvz+UFsIPwHaU9ER8291KOg00hvzLt2jcttNCuo+H/PTV24aSKkqIoWHWIOBx/NyZMi3h87/efiamW8sqRwvQPcAmF7cNDXDuYGTjgATHUhEJDx+9TKb0Zs/l3B+G7iE8cZXSpeUEogzwOp9VWAW5n8d+zxCJys0t2LsCJqKLeFfiWcO4Hs7G85kA9g32unMuuxqwkL9925nvxvXg/MXbSESCmn/rjJatp9KXJ5xK/SWFFji93aiH/IPAAATV+uDerUd2bfEI+s5TwkWou9/cmgEMLCPHSoKJJOA5ALMbevZKueTQj8cOxR8iChd6kEttDv2ANePTnWFmSg6cFeLjTrMjeGypCDqz7VTGsC7Na+6yLuFUdagzWXx9PGrm2wNx0OFFdHB3thvQVO7Z6xEdPiKu4uqvwY5A9oFbwICYrfq76tySylB/5bMN0a91f4maXsd8dHPRpN4c993Bp6ybl1YNXpzo12X28HeWp353GJKipGWw1Mv1kbnqPsI2ZsXEXo+j72RVGbPN9tj8QkMEfV613sSmfOeJYKFhs0JH/+qNxGYl5Vqi1sJfXXGVxmAS8LjDJveCjTK9SioaHvPVJ1tOqbXGgrKqLjM3XN13ibi7ON6tzR3R9REdo+6F3hpcnsFguRe6OfQkiDFw33J6Lxrn4dZVelohgIOFlQaD+ZmH6Hn9o75ftJNuOUTsyW7SVR9v6t08uHur+n98IexDlu29ENOpqTcEQ0I2HLkyLOYrGvfAOpqtLd+Nnj+qW9O6qiaDFpM7arpnfey20kZUrm1C/GrBU7LxXA5ZmY2QjrT95sQeo7o0N5gtD6w5OqXtjEDAd1Ti1o3pfu1a/rm4X6k/4nM/nRw/94utdp0ZWqCrHxZfQXnYW1E92zT8/XIn2djWXUQCsVigd9xIrY94I+LzmC7gEx++Ndg3yOT1Hqr/1D5gP6U8onfr5G8PVpcqIaVpja+//mn8hikQph75ElutMx5KyZkwZ+Od9Pwhl5fDkaIK7dBBi+ic9XcnlYbxn70VO+5fbE63q0urCOfPqPC5Al5tvC1nbySFbT333srWG71Urt1eqv/nsY7DObti5Ma+kR+u2JObkQfjYC9Q0/UHKR/WulgYNaLzngXDHk66ziEaAEO20jtubbbYOJyuLeuTZ6knSuA7Zg/0232BBg13NlHR0gQ3Zujy2S+HTB4aHdWkTqifUizk3SyuvJhbfOBSzpb1R0xgHODhveQubPb9ZNMJ+shKOaxrrofUQdexfeKJhDZGWzOIv+/O4PKaobIzFpu9tgD7uss86qnKU2/R/iikcV8mLugfpXjMi68yjUEhFdXM4/B6PnRmwHoFZO7SgPCAkHq+keGBvV8JjWz4RzHGwRQesFlkyJG0W9RneUgvbj97fkKPNiH+j7wE/AT4RnCUzxywr4f82M6ZHV6dSSo51H3AkhLTQmNh8o0PzlwnSleeRCgW8HSQMDRscQdsAhgHWg2AYaCD+hs8Eoc4ij6M3Q4Ll8+uyINpN+1qHXH4XqtdKZfQ6ndBWYBSrpBJHkpkfx8wh/VlnIQvhneJ/ojmfhcRc1fdccb3F1aM4t8fJMAQjflmX25KzpHvJzuOrN5/8X8GL6N1PZt9wLQ+m9/v+1eSQ/WzrJvaJximu9bIemljt7Grr2+boXKTPnD+goSTa9YfvrJl+vNYwaBXw+v8uH3GO4OWkOIq4imvrs+5ubChxmrTm3QMa2HA08O3bN2felETrEPqepSBSrY0z4ETGL2517yE0V1aHLtZtHzWT3Q1uDkCgyQxKcVqsixdlaQ786WXUlb7AUtQvQXv3CK4/ahuJ5bvJcFeROWWtu1c6B31xJHdmvkrlVJRWlHF1dyS+PWHS5JvtGgaVPOyJH7DUcilNIyp9fm3S89nFgpEfH+FzEUskDptE/7kPbG3YtYXw+YNiyWBPKKUqdML6kTPnjHjzVfq+wR4yDKKK7MKy3/YmXxt30UYWNm9Df0zBwwa3KFJg+Pz+o6PK0pllyOsMBgvhlS/aHIYRzac0t/gMTbIdX3ejXZlK19zBrbftWw3XdywsiXCpNUHklbupbsOdxm1V1YrnRwyUdaZ60s3HSe+SgjsdGbYbbQ1YG9nyONeijDUwNAT6F8Qc39gZL+693GuBx+aNySiQpf64zHiDoHaJftc1qRzWXQ/ChMOpik4beieTBzWuWnNJXMm9RqWWVgOUcrN5fTO5AjYHYG94vNclfKwMP9O7RpP6tnGRyGt6ZfVYrt3a7tzaf3zQe0zCsu3f7yJ+k2Fi6lU8+mkeDqGcD44WaOV6GArxQ9/veXzqEXft6Nv6Jeze/b6Te+Hvf4SHfFKA43JjtGHzlUZ6BGbvUGH0Nhvx2efXrDjowGOfXqrBr4rvpsAeZWU6di6Ei0E+HUISzs1f+anA0l+BX0qwA+Bq1HAqrXj4JLMG0VEY6L7QjioN9keA5gOHD3H4DhTSwtbTt9C5tazjbAfbaXOaTFzU+LGfpswTezrRrco0A7sPoUC9scqJgjdQd1brP9pyncf9q+5pGdkSMyEHvQ1A3wkAhp44Fl0pqpbJecSzy+ctt6v9fubTqZXewjHre91DPZazh3bNrXP7kOf+LYKpibcZKazXMynlTW4RMhze6ne/Lgxp9dOqIWk9Fd/VVmjq7nFGbdLboBjLixnk5lQ5ePu5y7zVMqjHuMaUnKKwIIZSiolPu6R9bzbNQmCUQZCm4//lnmtgOMiatnQt3VogB/77vZmUUV5pZ5D7S5hOKRpsPcjfzhgstiu3rpbs14DVQqVQur0rfW3W8WcezbHz9PV96G3reVaQ2rWnfQ75aV5pbB8wTrV9VF4esj/1TyY42T6jv2WO23pzsuXsk1gNWA6Wth3YrR6JaAlEbAdsPohf7mI7qYthz6Az7h8864j8DB2po6Pu5cjozlvv622cxn5t+6qs3OLab1WLqnjr1S4Sro2rSuXCGvHdTw14BdKt4srg1pMoa8UYRNssgY18m/WLrRD40Aul3v8Wn5mak76hWwaYyHRFFWOnDd4zZju/5Ce8xHek2jc6v0EYmyAB2ybuo19/ZePB9V8NYX9O3Tlng3zt7CvxTjJl7L/OT3H/3XliZR+9nr1ywmLvWWQ1yOsXvU7fw74KblC+s/pOa7gJ1LHPpE5p36gZTgP2Rfzt1kY0rqRfwOlnM/l5pRU7jxz7cevk9gZQH8IMK5nm39OzzEHP5EqNAYPxw+svN3ohh6MPexnbEx1PQAMs+ONUH65T3STOztnIeD/fwKvO3jupitH0h0/YLJZbY6h43I5XB77ItloiR7YbuP0NyVPXPRAwCg0WSgEjIBRCBiFgFEIGIWAUQgYhYBRCBgBoxAwCgGjEDAKAaMQMAoBI2AUAkYhYBQCRiFgFAJGIWAEjELAKASMQsAoBIxCwCgEjELACBiFgFEIGIWAUQgYhYBRCBgBoxAwCgGjEDAKAaMQMAoBoxAwAkYhYBQCRiFgFAJGIWAUAkbAKASMQsAoBIxCwCgEjELACBj136r/FWAAjYlf0jqbR4IAAAAASUVORK5CYII="

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_App_FourOFour__ = __webpack_require__(320);
var ItauCardLanding=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 666));});var ItauCardListing=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 673));});var BenefitsRouter=function BenefitsRouter(_ref){var url=_ref.match.url;return __WEBPACK_IMPORTED_MODULE_3_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_ALLOW_BENEFITS)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/landing',component:ItauCardLanding}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{path:url+'/listing',component:ItauCardListing}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{component:__WEBPACK_IMPORTED_MODULE_4_App_FourOFour__["a" /* default */]}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],{component:__WEBPACK_IMPORTED_MODULE_4_App_FourOFour__["a" /* default */]});};BenefitsRouter.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(BenefitsRouter));

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_App_Shell__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_App_FourOFour__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_features_Redirect__ = __webpack_require__(2069);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 2283));});var Contact=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2289));});var FaqSelected=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 2284));});var RedirectCash=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 2290));});var RedirectCustom=function(_Component){_inherits(RedirectCustom,_Component);function RedirectCustom(){_classCallCheck(this,RedirectCustom);return _possibleConstructorReturn(this,(RedirectCustom.__proto__||Object.getPrototypeOf(RedirectCustom)).apply(this,arguments));}_createClass(RedirectCustom,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Switch"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell__["b" /* ShellRoute */],{path:'/redirect/vendor/:vendorId',component:__WEBPACK_IMPORTED_MODULE_5_features_Redirect__["a" /* RedirectContainer */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/redirect/conexxe/:conexxePath',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__["a" /* ToggleFeature */],{feature:__WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__["b" /* features */].RedirectCustomConexxeFeature,'default':__WEBPACK_IMPORTED_MODULE_3_App_FourOFour__["a" /* default */]});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell__["b" /* ShellRoute */],{exact:true,path:'/redirect/faq',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__["a" /* ToggleFeature */],{feature:__WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__["b" /* features */].RedirectCustomZendeskFeature,'default':Faq});},isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell__["b" /* ShellRoute */],{exact:true,path:'/redirect/contact',component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__["a" /* ToggleFeature */],{feature:__WEBPACK_IMPORTED_MODULE_4_features_ToggleFeature__["b" /* features */].RedirectCustomZendeskFeature,'default':Contact});},isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell__["b" /* ShellRoute */],{path:'/redirect/faq/:section/:topic',component:FaqSelected,isGuest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],{path:'/redirect/cash',component:RedirectCash}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_App_Shell__["b" /* ShellRoute */],{component:__WEBPACK_IMPORTED_MODULE_3_App_FourOFour__["a" /* default */],isGuest:true})));}}]);return RedirectCustom;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RedirectCustom);

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedirectContainer__ = __webpack_require__(2070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RedirectContainer__["a"]; });


/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redirect__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PostForm__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_connected_react_router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RedirectContainer=function(_Component){_inherits(RedirectContainer,_Component);function RedirectContainer(props){_classCallCheck(this,RedirectContainer);var _this=_possibleConstructorReturn(this,(RedirectContainer.__proto__||Object.getPrototypeOf(RedirectContainer)).call(this,props));var vendorId=_this.props.match.params.vendorId;_this.vendorId=vendorId;var client=__WEBPACK_IMPORTED_MODULE_5_redux_clients__["a" /* default */].cloudloyalty.client;_this.client=client;_this.state={errorAlert:null,postProperties:null};_this.closeError=_this.closeError.bind(_this);return _this;}_createClass(RedirectContainer,[{key:'componentDidMount',value:function componentDidMount(){this.secondFactorValidation();}},{key:'closeError',value:function closeError(){this.setState({errorAlert:null});}},{key:'throwError',value:function throwError(title,description){var _this2=this;this.setState({errorAlert:{title:title,description:description,closeError:function closeError(){return _this2.closeError();}}});}},{key:'secondFactorValidation',value:function secondFactorValidation(){var _this3=this;this.client.get('/v1/secondfactorauth/sendtoken?tokenType=sms&authorizationCode=&supplierId='+this.vendorId+'&supplierValidation=false').then(function(result){_this3.handleTokenResult(result);}).catch(function(){return _this3.throwError('Problema ao redirecionar','Ocorreu um problema ao tentar redirecioná-lo.');});}},{key:'handleTokenResult',value:function handleTokenResult(_ref){var data=_ref.data;if(data.onBoardingRequired||!data.authorized){this.throwError('Problema ao redirecionar','Ocorreu um problema ao tentar redirecioná-lo. ');return;}this.handleRedirect(data);}},{key:'handleRedirect',value:function handleRedirect(_ref2){var _this4=this;var redirectUrl=_ref2.redirectUrl;this.client.get('/v1/configurations/catalog/'+this.props.catalogId+'/vendor/'+this.vendorId+'/client/'+this.props.clientId+'/parameter/isPost/value').then(function(_ref3){var data=_ref3.data;if(data&&data===true){_this4.redirectToForm(redirectUrl);}else{_this4.redirectToStore(redirectUrl);}}).catch(function(){return _this4.throwError('Problema ao redirecionar','Ocorreu um problema ao tentar redirecioná-lo.');});}},{key:'redirectToStore',value:function redirectToStore(urlReturn){var search=this.props.location.search;if(search&&search.includes('?'))urlReturn+='&'+search.split('?')[1];if(!urlReturn.includes('http')||urlReturn.includes('#')){this.props.internalRedirect('/vendor?vendor='+this.vendorId);}else{window.location=urlReturn.replace(/^"(.+(?="$))"$/,'$1');}}},{key:'redirectToForm',value:function redirectToForm(urlReturn){var parameters=urlReturn.split('?');var postData=parameters[1].split('&');this.setState({postProperties:{action:parameters[0],parameters:postData}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Redirect__["a" /* default */],this.state),this.state.postProperties?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PostForm__["a" /* default */],{action:this.state.postProperties.action,token:this.props.token,parameters:this.state.postProperties.parameters}):'');}}]);return RedirectContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RedirectContainer.propTypes={match:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,catalogId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,clientId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,internalRedirect:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,token:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(_ref4){var _ref4$participant=_ref4.participant,catalogId=_ref4$participant.catalogId,clientId=_ref4$participant.clientId,user=_ref4.oidc.user;return{catalogId:catalogId,clientId:clientId,token:user['token_type']+' '+user['access_token']};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{internalRedirect:function internalRedirect(path){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_connected_react_router__["push"])(path));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(RedirectContainer));

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Catalog_Search_SearchPlaceHolder__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Catalog_Search_SidebarPlaceholder__ = __webpack_require__(664);
var bgBanner={backgroundColor:'#D2DCDE'};var showError=function showError(error){return error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_loyal_react__["Alert"],{isError:true,title:error.title,description:error.description,className:'pb-2',onClose:function onClose(){return error.closeError();}}):'';};var Redirect=function Redirect(_ref){var errorAlert=_ref.errorAlert;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,showError(errorAlert),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid container-results mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row py-2 innerShadow',style:bgBanner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0 py-5'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bg-transparent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container  pos-relative py-1 px-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pos-relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumbStore col-auto d-none d-md-flex py-half px-half border border-color-ui-3 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row  align-items-center h-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-0 offset-md-2 col-12 col-md pos-relative'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mt-5 mt-md-0 pt-5 pt-md-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Catalog_Search_SidebarPlaceholder__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Catalog_Search_SearchPlaceHolder__["a" /* default */],null))));};Redirect.propTypes={errorAlert:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PostForm=function(_Component){_inherits(PostForm,_Component);function PostForm(){_classCallCheck(this,PostForm);return _possibleConstructorReturn(this,(PostForm.__proto__||Object.getPrototypeOf(PostForm)).apply(this,arguments));}_createClass(PostForm,[{key:'componentDidMount',value:function componentDidMount(){this._form.submit();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{method:'post',action:this.props.action,id:'formid',ref:function ref(c){return _this2._form=c;}},this.props.parameters.map(function(item,ix){var value=item.split('=');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:ix,type:'hidden',name:value[0],value:value[0]==='token'?_this2.props.token:value[1]});}));}}]);return PostForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PostForm.propTypes={action:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,token:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,parameters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (PostForm);

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loyal_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loyal_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_Shell_TitleAnnouncer__ = __webpack_require__(270);
var AccessibilityIupp=function AccessibilityIupp(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Estatuto de acessibilidade - '+("Tupperware | Premmiar"||''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App_Shell_TitleAnnouncer__["a" /* default */],{orientation:'mobile'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid bg-color-ui-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 px-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_loyal_react__["AccessibilityIuppComponent"],null)))))));};/* harmony default export */ __webpack_exports__["a"] = (AccessibilityIupp);

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Shared_HeadMetadata_HeadMetadataContainer__ = __webpack_require__(2075);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_Shared_HeadMetadata_HeadMetadataContainer__["a"]; });


/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Shared_HeadMetadata_HeadMetadata__ = __webpack_require__(2076);
var mapStateToProps=function mapStateToProps(_ref){var metadata=_ref.metadata;return Object.assign({},metadata);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_Shared_HeadMetadata_HeadMetadata__["a" /* default */]));

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_yn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_yn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_favicon_ico__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loyal_favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__loyal_favicon_ico__);
var HeadMetadata=function HeadMetadata(_ref){var title=_ref.title,description=_ref.description,keywords=_ref.keywords;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet_async___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,title),__WEBPACK_IMPORTED_MODULE_3_yn___default()(Object({"NODE_ENV":"production","PUBLIC_URL":"","SKIN":"tupperware-inc-cancun","REACT_APP_CATALOG_ID":"80938","REACT_APP_TENANT_ID":"70885","REACT_APP_USER_POOL_ID":"us-east-1_XR3aIEQ8B","REACT_APP_CLIENT_ID":"1tbhh14ofdn4d5oof5dm32nmen","REACT_APP_AUTH_ENDPOINT":"https://auth.tupperwarepremios.premmiar.io","REACT_APP_TITLE":"Tupperware | Premmiar","REACT_APP_MENU_SEGMENTS":"80938","REACT_APP_ENVIRONMENT":"prod","REACT_APP_CLOUD_LOYALTY_ENDPOINT":"https://api.ltm.digital","REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION":"4c8e61c3270c44bb8d274d090a2a97c5","REACT_APP_ONBOARDING_ENDPOINT":"https://onboarding.webpremios.com.br/Login/RedirectCognito?id=","REACT_APP_TRACKING_ENDPOINT":"https://ltmtrackingprdapi.azurewebsites.net/","REACT_APP_VENDOR_PURCHASE_POINTS":"61677","REACT_APP_VENDOR_IDS_QUICK_REDEMPTION":"80,81,21039,21185,61659","REACT_APP_HAS_STORES_SHOWCASE":"true","REACT_APP_HAS_SCHEDULING":"false","REACT_APP_HAS_REGULATION_LINK":"true","REACT_APP_HAS_REGULATION_CUSTOM":"false","REACT_APP_HAS_SECURITY_LINK":"false","REACT_APP_HAS_TERMS_LINK":"true","REACT_APP_HAS_TERMS_CUSTOM":"false","REACT_APP_HAS_PRIVACY_LINK":"true","REACT_APP_HAS_PRIVACY_CUSTOM":"false","REACT_APP_HAS_FAQ_LINK":"true","REACT_APP_HAS_CONTACT_LINK":"true","REACT_APP_HAS_OPTIN_REGULATION":"true","REACT_APP_VENDOR_IDS_CASH_ONLY_ENABLED":"61727,61726,61725","REACT_APP_HAS_CASHBACK":"false","REACT_APP_HAS_POINTCASH":"true","REACT_APP_HAS_POINTSANDCASH_LINK":"false","REACT_APP_HAS_TRADEMENU_HOME":"true","REACT_APP_HAS_BENEFITS_SHOWCASE":"false","REACT_APP_HAS_BEST_OFFERS":"false","REACT_APP_HAS_ACCUMULATE_BANNERS":"false","REACT_APP_HAS_CONNEXXE_BANNER":"false","REACT_APP_URL_VIAGEM":"false","REACT_APP_HAS_SERVICES":"true","REACT_APP_HAS_POINSPURCHASE":"false","REACT_APP_HAS_ONBOARDING":"false","REACT_APP_REMOVE_CATEGORIES":"servicos,tabacaria,viagens,veiculos,educacao,vale-compras","REACT_APP_REMOVE_SUBCATEGORIES":"acessorios-para-motos,iluminacao,oleos-e-fluidos,racks-e-suportes,eventos,viagens,carros,passeios,passagens-aereas","REACT_APP_REMOVE_VOUCHERS":"61719,61718,21217,61751,21136,21121","REACT_APP_PHYSICAL_VOUCHERS_ENABLED":"true","REACT_APP_PHYSICAL_VOUCHERS_TITLE":"Vouchers Físicos","REACT_APP_ADD_PHYSICAL_VOUCHERS":"21210,51483,21181,41417,51547,61556,21158,21239,21221,21247,21151,41419,21252,21160,21172,21170,61994,21266,51484,21171,21264","REACT_APP_VIRTUAL_VOUCHERS_ENABLED":"true","REACT_APP_VIRTUAL_VOUCHERS_TITLE":"Vouchers Virtuais","REACT_APP_ADD_VIRTUAL_VOUCHERS":"21098,21110,21114,21119,21128,51473,1482,21099,21112,21116,21120,21131,21136,41420,51474,61912,21109,21113,21122,21132,21281,51472,51481,21255,21133,21134,61555,61619,21126,21127,61620,61786,61793,61664,51453,61739,61743,61740,41414,61741,61742,61621,51482,61999,61955,72032,72040,61998,41416,41418,41422,21118,72037,61997,51479","REACT_APP_HAS_VOUCHER_SHOWCASE":"true","REACT_APP_HAS_CHAT_ID":"47f5e1dab4ce634d2292149592e49e66","REACT_APP_HAS_CHAT_URL":"https://js.huggy.chat/widget.min.js","REACT_APP_UUID_CHAT":"01eefbea-376f-4613-b29d-2bcc2ea929f9","REACT_APP_FULL_MENU":{"80938":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"default":{"categoryMenu":[{"context":["points","cash"],"items":[{"items":[],"label":"Automotivo","path":"/search?category=2","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bebês","path":"/search?category=3","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Bem estar","path":"/search?category=4","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Casa e cozinha","path":"/search?category=5","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Eletrônicos","path":"/search?category=6","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Gastronomia","path":"/search?category=13","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Indústria e Comércio","path":"/search?category=1","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Lazer e Cultura","path":"/search?category=7","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Moda","path":"/search?category=8","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"},{"items":[],"label":"Todos","path":"/categories","enabled":true,"createdAt":"2020-12-23T18:54:02.711Z","updatedAt":"2020-12-23T18:54:02.711Z"}],"label":"Categorias","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"C&C - Virtual","path":"/vendor?vendor=21248","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Físico","path":"/vendor?vendor=21210","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Carrefour - Virtual","path":"/vendor?vendor=21109","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cartão Presente Havan - Físico","path":"/vendor?vendor=61792","enabled":true,"createdAt":"2020-12-23T18:54:02.712Z","updatedAt":"2020-12-23T18:54:02.712Z"},{"items":[],"label":"Cestas Michelli - Virtual","path":"/vendor?vendor=21110","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Deezer - Físico","path":"/vendor?vendor=51483","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Todos","path":"/stores/vouchers","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"}],"label":"Vale Compras","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Americanas","path":"/vendor?vendor=61982","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Extra.Com","path":"/vendor?vendor=59","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Fast Shop","path":"/vendor?vendor=106","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Magazine Luiza","path":"/vendor?vendor=62","enabled":true,"createdAt":"2020-12-23T18:54:02.713Z","updatedAt":"2020-12-23T18:54:02.713Z"},{"items":[],"label":"Ponto Frio","path":"/vendor?vendor=58","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Todos","path":"/stores","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Lojas","enabled":true,"type":"services"},{"context":["points","cash"],"items":[{"items":[],"label":"Pague suas contas","path":"/billpayment","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"},{"items":[],"label":"Recarga de celular","path":"/mobile-recharge","enabled":true,"createdAt":"2020-12-23T18:54:02.714Z","updatedAt":"2020-12-23T18:54:02.714Z"}],"label":"Serviços","enabled":true,"type":"services"}],"createdAt":"2020-12-09T21:01:41.043Z","updatedAt":"2020-12-23T18:54:02.714Z","tradeMenu":{"items":[{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f5","label":"Favoritos","title":"null","icon":"icon_wishlist","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/wishlist"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f4","label":"Extrato","title":"null","icon":"icon_listing","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/extract"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f3","label":"Pedidos","title":"null","icon":"icon_package","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/my-orders"},{"context":["points","cash"],"items":[],"_id":"5fd13b3b33e85a00172698f2","label":"Troque seus pontos","title":"null","icon":"icon_gift","bannerInventory":"null","type":"static","dynamicAction":"null","path":"/search"}],"bottom":[],"label":"trade"},"footerMenu":{"items":[{"items":[],"label":"Regulamentos","path":"/regulation","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Termos de uso","path":"/terms","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Politica de Privacidade","path":"/privacy","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"},{"items":[],"label":"Ajuda","path":"/redirect/faq","createdAt":"2020-12-09T21:01:49.351Z","updatedAt":"2020-12-09T21:01:49.351Z"}],"label":"PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119","disclaimer":"O catálogo de premiação é atualizado periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate."}},"calls":1,"defaultId":"80938"}}).REACT_APP_NO_INDEX)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'robots',content:'noindex, nofollow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'shortcut icon',href:__WEBPACK_IMPORTED_MODULE_4__loyal_favicon_ico___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'author',content:'Grupo LTM'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'keywords',content:keywords}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{httpEquiv:'pragma',content:'no-cache'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{httpEquiv:'expires',content:'-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemProp:'name',content:'WebPr\xEAmios'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemProp:'image',content:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemProp:'url',content:'https://webpremios.com.br'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{itemProp:'description',content:'O WebPr\xEAmios \xE9 um marketplace com design integrado que oferece uma experi\xEAncia interativa ao participante, possibilitando a personaliza\xE7\xE3o do cat\xE1logo sem necessidade de envolvimento de t\xE9cnicos ou intermedi\xE1rios. Entre suas facilidades est\xE3o telas de comparativo de pre\xE7os, carrinho \xFAnico, tracking, navega\xE7\xE3o com menos cliques, atendimento por chat e cross-selling de produtos.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:title',content:'WebPr\xEAmios'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:image',content:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:url',content:'https://webpremios.com.br'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:type',content:'website'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{property:'og:description',content:'O WebPr\xEAmios \xE9 um marketplace com design integrado que oferece uma experi\xEAncia interativa ao participante, possibilitando a personaliza\xE7\xE3o do cat\xE1logo sem necessidade de envolvimento de t\xE9cnicos ou intermedi\xE1rios. Entre suas facilidades est\xE3o telas de comparativo de pre\xE7os, carrinho \xFAnico, tracking, navega\xE7\xE3o com menos cliques, atendimento por chat e cross-selling de produtos.'}));};HeadMetadata.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,keywords:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (HeadMetadata);

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/favicon.9fdec765.ico";

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
/* eslint-disable no-undef */// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(2080);

__webpack_require__(2277);

__webpack_require__(2278);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2081);
__webpack_require__(2084);
__webpack_require__(2085);
__webpack_require__(2086);
__webpack_require__(2087);
__webpack_require__(2088);
__webpack_require__(2089);
__webpack_require__(2090);
__webpack_require__(2091);
__webpack_require__(2092);
__webpack_require__(2093);
__webpack_require__(2094);
__webpack_require__(2095);
__webpack_require__(2096);
__webpack_require__(2097);
__webpack_require__(2098);
__webpack_require__(2099);
__webpack_require__(2100);
__webpack_require__(2101);
__webpack_require__(2102);
__webpack_require__(2103);
__webpack_require__(2104);
__webpack_require__(2105);
__webpack_require__(2106);
__webpack_require__(2107);
__webpack_require__(2108);
__webpack_require__(2109);
__webpack_require__(2110);
__webpack_require__(2111);
__webpack_require__(2112);
__webpack_require__(2113);
__webpack_require__(2114);
__webpack_require__(2115);
__webpack_require__(2116);
__webpack_require__(2117);
__webpack_require__(2118);
__webpack_require__(2119);
__webpack_require__(2120);
__webpack_require__(2121);
__webpack_require__(2122);
__webpack_require__(2123);
__webpack_require__(2124);
__webpack_require__(2125);
__webpack_require__(2126);
__webpack_require__(2127);
__webpack_require__(2128);
__webpack_require__(2129);
__webpack_require__(2130);
__webpack_require__(2131);
__webpack_require__(2132);
__webpack_require__(2133);
__webpack_require__(2134);
__webpack_require__(2135);
__webpack_require__(2136);
__webpack_require__(2137);
__webpack_require__(2138);
__webpack_require__(2139);
__webpack_require__(2140);
__webpack_require__(2141);
__webpack_require__(2142);
__webpack_require__(2143);
__webpack_require__(2144);
__webpack_require__(2145);
__webpack_require__(2146);
__webpack_require__(2147);
__webpack_require__(2148);
__webpack_require__(2149);
__webpack_require__(2150);
__webpack_require__(2151);
__webpack_require__(2152);
__webpack_require__(2153);
__webpack_require__(2154);
__webpack_require__(2155);
__webpack_require__(2156);
__webpack_require__(2157);
__webpack_require__(2158);
__webpack_require__(2159);
__webpack_require__(2161);
__webpack_require__(2162);
__webpack_require__(2164);
__webpack_require__(2165);
__webpack_require__(2166);
__webpack_require__(2167);
__webpack_require__(2168);
__webpack_require__(2169);
__webpack_require__(2170);
__webpack_require__(2172);
__webpack_require__(2173);
__webpack_require__(2174);
__webpack_require__(2175);
__webpack_require__(2176);
__webpack_require__(2177);
__webpack_require__(2178);
__webpack_require__(2179);
__webpack_require__(2180);
__webpack_require__(2181);
__webpack_require__(2182);
__webpack_require__(2183);
__webpack_require__(2184);
__webpack_require__(350);
__webpack_require__(2185);
__webpack_require__(693);
__webpack_require__(2186);
__webpack_require__(694);
__webpack_require__(2187);
__webpack_require__(2188);
__webpack_require__(2189);
__webpack_require__(2190);
__webpack_require__(2191);
__webpack_require__(697);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(2192);
__webpack_require__(2193);
__webpack_require__(2194);
__webpack_require__(2195);
__webpack_require__(2196);
__webpack_require__(2197);
__webpack_require__(2198);
__webpack_require__(2199);
__webpack_require__(2200);
__webpack_require__(2201);
__webpack_require__(2202);
__webpack_require__(2203);
__webpack_require__(2204);
__webpack_require__(2205);
__webpack_require__(2206);
__webpack_require__(2207);
__webpack_require__(2208);
__webpack_require__(2209);
__webpack_require__(2210);
__webpack_require__(2211);
__webpack_require__(2212);
__webpack_require__(2213);
__webpack_require__(2214);
__webpack_require__(2215);
__webpack_require__(2216);
__webpack_require__(2217);
__webpack_require__(2218);
__webpack_require__(2219);
__webpack_require__(2220);
__webpack_require__(2221);
__webpack_require__(2222);
__webpack_require__(2223);
__webpack_require__(2224);
__webpack_require__(2225);
__webpack_require__(2226);
__webpack_require__(2227);
__webpack_require__(2228);
__webpack_require__(2229);
__webpack_require__(2230);
__webpack_require__(2231);
__webpack_require__(2232);
__webpack_require__(2233);
__webpack_require__(2234);
__webpack_require__(2235);
__webpack_require__(2236);
__webpack_require__(2237);
__webpack_require__(2238);
__webpack_require__(2239);
__webpack_require__(2240);
__webpack_require__(2241);
__webpack_require__(2242);
__webpack_require__(2243);
__webpack_require__(2244);
__webpack_require__(2245);
__webpack_require__(2246);
__webpack_require__(2247);
__webpack_require__(2248);
__webpack_require__(2249);
__webpack_require__(2250);
__webpack_require__(2251);
__webpack_require__(2252);
__webpack_require__(2253);
__webpack_require__(2254);
__webpack_require__(2255);
__webpack_require__(2256);
__webpack_require__(2257);
__webpack_require__(2258);
__webpack_require__(2259);
__webpack_require__(2260);
__webpack_require__(2261);
__webpack_require__(2262);
__webpack_require__(2263);
__webpack_require__(2264);
__webpack_require__(2265);
__webpack_require__(2266);
__webpack_require__(2267);
__webpack_require__(2268);
__webpack_require__(2269);
__webpack_require__(2270);
__webpack_require__(2271);
__webpack_require__(2272);
__webpack_require__(2273);
__webpack_require__(2274);
__webpack_require__(2275);
__webpack_require__(2276);
module.exports = __webpack_require__(63);


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(16);
var has = __webpack_require__(56);
var DESCRIPTORS = __webpack_require__(29);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(50);
var META = __webpack_require__(90).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(168);
var setToStringTag = __webpack_require__(133);
var uid = __webpack_require__(106);
var wks = __webpack_require__(26);
var wksExt = __webpack_require__(675);
var wksDefine = __webpack_require__(331);
var enumKeys = __webpack_require__(2083);
var isArray = __webpack_require__(221);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(35);
var toIObject = __webpack_require__(57);
var toPrimitive = __webpack_require__(72);
var createDesc = __webpack_require__(105);
var _create = __webpack_require__(109);
var gOPNExt = __webpack_require__(678);
var $GOPD = __webpack_require__(58);
var $GOPS = __webpack_require__(220);
var $DP = __webpack_require__(32);
var $keys = __webpack_require__(107);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(110).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(170).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(89)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(49)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(168)('native-function-to-string', Function.toString);


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(107);
var gOPS = __webpack_require__(220);
var pIE = __webpack_require__(170);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(109) });


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperties: __webpack_require__(677) });


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(57);
var $getOwnPropertyDescriptor = __webpack_require__(58).f;

__webpack_require__(74)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(35);
var $getPrototypeOf = __webpack_require__(59);

__webpack_require__(74)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(35);
var $keys = __webpack_require__(107);

__webpack_require__(74)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(74)('getOwnPropertyNames', function () {
  return __webpack_require__(678).f;
});


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(90).onFreeze;

__webpack_require__(74)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(90).onFreeze;

__webpack_require__(74)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(90).onFreeze;

__webpack_require__(74)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(74)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(74)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(74)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(679) });


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { is: __webpack_require__(680) });


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(335).set });


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(134);
var test = {};
test[__webpack_require__(26)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(50)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(4);

$export($export.P, 'Function', { bind: __webpack_require__(681) });


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(29) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(59);
var HAS_INSTANCE = __webpack_require__(26)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(32).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(683);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(684);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var has = __webpack_require__(56);
var cof = __webpack_require__(65);
var inheritIfRequired = __webpack_require__(337);
var toPrimitive = __webpack_require__(72);
var fails = __webpack_require__(19);
var gOPN = __webpack_require__(110).f;
var gOPD = __webpack_require__(58).f;
var dP = __webpack_require__(32).f;
var $trim = __webpack_require__(135).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(109)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(29) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(50)(global, NUMBER, $Number);
}


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toInteger = __webpack_require__(66);
var aNumberValue = __webpack_require__(685);
var repeat = __webpack_require__(338);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(19)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $fails = __webpack_require__(19);
var aNumberValue = __webpack_require__(685);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(4);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(4);
var _isFinite = __webpack_require__(16).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', { isInteger: __webpack_require__(686) });


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(4);
var isInteger = __webpack_require__(686);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(684);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(683);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(4);
var log1p = __webpack_require__(687);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(4);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(4);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(4);
var sign = __webpack_require__(339);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(4);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(4);
var $expm1 = __webpack_require__(340);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { fround: __webpack_require__(688) });


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(4);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(4);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(19)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { log1p: __webpack_require__(687) });


/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { sign: __webpack_require__(339) });


/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(340);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(19)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(340);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(108);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(57);
var toLength = __webpack_require__(28);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(135)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(222)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(341)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $at = __webpack_require__(222)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(28);
var context = __webpack_require__(343);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(344)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(4);
var context = __webpack_require__(343);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(344)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(338)
});


/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(28);
var context = __webpack_require__(343);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(344)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(51)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(51)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(51)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(51)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(51)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(51)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(51)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(51)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(51)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(51)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(51)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(51)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(51)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(4);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(72);

$export($export.P + $export.F * __webpack_require__(19)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(4);
var toISOString = __webpack_require__(2160);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(19);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(50)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(26)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(49)(proto, TO_PRIMITIVE, __webpack_require__(2163));


/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(72);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(4);

$export($export.S, 'Array', { isArray: __webpack_require__(221) });


/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(64);
var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var call = __webpack_require__(689);
var isArrayIter = __webpack_require__(345);
var toLength = __webpack_require__(28);
var createProperty = __webpack_require__(346);
var getIterFn = __webpack_require__(347);

$export($export.S + $export.F * !__webpack_require__(224)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var createProperty = __webpack_require__(346);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(19)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(4);
var toIObject = __webpack_require__(57);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(169) != Object || !__webpack_require__(67)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var html = __webpack_require__(334);
var cof = __webpack_require__(65);
var toAbsoluteIndex = __webpack_require__(108);
var toLength = __webpack_require__(28);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(19)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var aFunction = __webpack_require__(40);
var toObject = __webpack_require__(35);
var fails = __webpack_require__(19);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(67)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $forEach = __webpack_require__(75)(0);
var STRICT = __webpack_require__(67)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(221);
var SPECIES = __webpack_require__(26)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $map = __webpack_require__(75)(1);

$export($export.P + $export.F * !__webpack_require__(67)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $filter = __webpack_require__(75)(2);

$export($export.P + $export.F * !__webpack_require__(67)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $some = __webpack_require__(75)(3);

$export($export.P + $export.F * !__webpack_require__(67)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $every = __webpack_require__(75)(4);

$export($export.P + $export.F * !__webpack_require__(67)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(690);

$export($export.P + $export.F * !__webpack_require__(67)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(690);

$export($export.P + $export.F * !__webpack_require__(67)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $indexOf = __webpack_require__(219)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(67)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(57);
var toInteger = __webpack_require__(66);
var toLength = __webpack_require__(28);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(67)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { copyWithin: __webpack_require__(691) });

__webpack_require__(91)('copyWithin');


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { fill: __webpack_require__(349) });

__webpack_require__(91)('fill');


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(75)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(91)(KEY);


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(75)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(91)(KEY);


/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Array');


/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var inheritIfRequired = __webpack_require__(337);
var dP = __webpack_require__(32).f;
var gOPN = __webpack_require__(110).f;
var isRegExp = __webpack_require__(223);
var $flags = __webpack_require__(171);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(29) && (!CORRECT_NEW || __webpack_require__(19)(function () {
  re2[__webpack_require__(26)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(50)(global, 'RegExp', $RegExp);
}

__webpack_require__(111)('RegExp');


/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(694);
var anObject = __webpack_require__(10);
var $flags = __webpack_require__(171);
var DESCRIPTORS = __webpack_require__(29);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(50)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(19)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toLength = __webpack_require__(28);
var advanceStringIndex = __webpack_require__(352);
var regExpExec = __webpack_require__(225);

// @@match logic
__webpack_require__(226)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(28);
var toInteger = __webpack_require__(66);
var advanceStringIndex = __webpack_require__(352);
var regExpExec = __webpack_require__(225);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(226)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var sameValue = __webpack_require__(680);
var regExpExec = __webpack_require__(225);

// @@search logic
__webpack_require__(226)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(223);
var anObject = __webpack_require__(10);
var speciesConstructor = __webpack_require__(172);
var advanceStringIndex = __webpack_require__(352);
var toLength = __webpack_require__(28);
var callRegExpExec = __webpack_require__(225);
var regexpExec = __webpack_require__(351);
var fails = __webpack_require__(19);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(226)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(89);
var global = __webpack_require__(16);
var ctx = __webpack_require__(64);
var classof = __webpack_require__(134);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(40);
var anInstance = __webpack_require__(112);
var forOf = __webpack_require__(113);
var speciesConstructor = __webpack_require__(172);
var task = __webpack_require__(353).set;
var microtask = __webpack_require__(354)();
var newPromiseCapabilityModule = __webpack_require__(355);
var perform = __webpack_require__(695);
var userAgent = __webpack_require__(227);
var promiseResolve = __webpack_require__(696);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(26)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(114)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(133)($Promise, PROMISE);
__webpack_require__(111)(PROMISE);
Wrapper = __webpack_require__(63)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(224)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(701);
var validate = __webpack_require__(115);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(228)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $typed = __webpack_require__(229);
var buffer = __webpack_require__(356);
var anObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(108);
var toLength = __webpack_require__(28);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(16).ArrayBuffer;
var speciesConstructor = __webpack_require__(172);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(19)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(111)(ARRAY_BUFFER);


/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
$export($export.G + $export.W + $export.F * !__webpack_require__(229).ABV, {
  DataView: __webpack_require__(356).DataView
});


/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(40);
var anObject = __webpack_require__(10);
var rApply = (__webpack_require__(16).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(19)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(4);
var create = __webpack_require__(109);
var aFunction = __webpack_require__(40);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(19);
var bind = __webpack_require__(681);
var rConstruct = (__webpack_require__(16).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(32);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(72);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(19)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(4);
var gOPD = __webpack_require__(58).f;
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(342)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(58);
var getPrototypeOf = __webpack_require__(59);
var has = __webpack_require__(56);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(10);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(58);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(4);
var getProto = __webpack_require__(59);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(703) });


/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(32);
var gOPD = __webpack_require__(58);
var getPrototypeOf = __webpack_require__(59);
var has = __webpack_require__(56);
var $export = __webpack_require__(4);
var createDesc = __webpack_require__(105);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(4);
var setProto = __webpack_require__(335);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(4);
var $includes = __webpack_require__(219)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(91)('includes');


/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(704);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(28);
var aFunction = __webpack_require__(40);
var arraySpeciesCreate = __webpack_require__(348);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(91)('flatMap');


/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(704);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(28);
var toInteger = __webpack_require__(66);
var arraySpeciesCreate = __webpack_require__(348);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(91)('flatten');


/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(4);
var $at = __webpack_require__(222)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(705);
var userAgent = __webpack_require__(227);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(705);
var userAgent = __webpack_require__(227);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(135)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(135)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(4);
var defined = __webpack_require__(73);
var toLength = __webpack_require__(28);
var isRegExp = __webpack_require__(223);
var getFlags = __webpack_require__(171);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(342)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(331)('asyncIterator');


/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(331)('observable');


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(4);
var ownKeys = __webpack_require__(703);
var toIObject = __webpack_require__(57);
var gOPD = __webpack_require__(58);
var createProperty = __webpack_require__(346);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $values = __webpack_require__(706)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $entries = __webpack_require__(706)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var aFunction = __webpack_require__(40);
var $defineProperty = __webpack_require__(32);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(29) && $export($export.P + __webpack_require__(230), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var aFunction = __webpack_require__(40);
var $defineProperty = __webpack_require__(32);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(29) && $export($export.P + __webpack_require__(230), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(72);
var getPrototypeOf = __webpack_require__(59);
var getOwnPropertyDescriptor = __webpack_require__(58).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(29) && $export($export.P + __webpack_require__(230), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(72);
var getPrototypeOf = __webpack_require__(59);
var getOwnPropertyDescriptor = __webpack_require__(58).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(29) && $export($export.P + __webpack_require__(230), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(707)('Map') });


/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(707)('Set') });


/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(231)('Map');


/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(231)('Set');


/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(231)('WeakMap');


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(231)('WeakSet');


/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(232)('Map');


/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(232)('Set');


/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(232)('WeakMap');


/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(232)('WeakSet');


/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.G, { global: __webpack_require__(16) });


/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.S, 'System', { global: __webpack_require__(16) });


/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(4);
var cof = __webpack_require__(65);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var scale = __webpack_require__(709);
var fround = __webpack_require__(688);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { scale: __webpack_require__(709) });


/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(4);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(63);
var global = __webpack_require__(16);
var speciesConstructor = __webpack_require__(172);
var promiseResolve = __webpack_require__(696);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(355);
var perform = __webpack_require__(695);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(59);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(699);
var from = __webpack_require__(708);
var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(59);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(59);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(81);
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(40);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(4);
var microtask = __webpack_require__(354)();
var process = __webpack_require__(16).process;
var isNode = __webpack_require__(65)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(4);
var global = __webpack_require__(16);
var core = __webpack_require__(63);
var microtask = __webpack_require__(354)();
var OBSERVABLE = __webpack_require__(26)('observable');
var aFunction = __webpack_require__(40);
var anObject = __webpack_require__(10);
var anInstance = __webpack_require__(112);
var redefineAll = __webpack_require__(114);
var hide = __webpack_require__(49);
var forOf = __webpack_require__(113);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(111)('Observable');


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(16);
var $export = __webpack_require__(4);
var userAgent = __webpack_require__(227);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $task = __webpack_require__(353);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(350);
var getKeys = __webpack_require__(107);
var redefine = __webpack_require__(50);
var global = __webpack_require__(16);
var hide = __webpack_require__(49);
var Iterators = __webpack_require__(136);
var wks = __webpack_require__(26);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2279);
module.exports = __webpack_require__(63).RegExp.escape;


/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(4);
var $re = __webpack_require__(2280)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 2280 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 2281 */
/***/ (function(module, exports) {

"use strict";

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch (e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__(726);

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = _typeof(options.attrs) === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (_typeof(options.insertAt) === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.f3dac0ba.js